/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "bundles/" + "bab0d1f71b846e270316" + "/" + ({"0":"e2e-export"}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	// for ES6 stuff like startsWith() that Safari doesn't handle
	// and babel doesn't do by default
	// Note we use this, as well as the babel transform-runtime plugin
	// since transform-runtime does not cover instance methods
	// such as "foobar".includes("foo") which bits of our library
	// code use, but the babel transform-runtime plugin allows the
	// regenerator runtime to be injected early enough in the process
	// (it can't be here as it's too late: the alternative is to put
	// the babel-polyfill as the first 'entry' in the webpack config).
	// https://babeljs.io/docs/plugins/transform-runtime/
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var loadApp = function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var fragparts, params, preventRedirect, configJson, configError, MatrixChat, CompatibilityPage;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        fragparts = (0, _url_utils.parseQsFromFragment)(window.location);
	                        params = (0, _url_utils.parseQs)(window.location);
	
	                        // set the platform for react sdk (our Platform object automatically picks the right one)
	
	                        PlatformPeg.set(new _platform2.default());
	
	                        // don't try to redirect to the native apps if we're
	                        // verifying a 3pid
	                        preventRedirect = Boolean(fragparts.params.client_secret);
	
	                        if (preventRedirect) {
	                            _context.next = 15;
	                            break;
	                        }
	
	                        if (!(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)) {
	                            _context.next = 11;
	                            break;
	                        }
	
	                        if (!confirm("Riot is not supported on mobile web. Install the app?")) {
	                            _context.next = 9;
	                            break;
	                        }
	
	                        window.location = "https://itunes.apple.com/us/app/vector.im/id1083446067";
	                        return _context.abrupt('return');
	
	                    case 9:
	                        _context.next = 15;
	                        break;
	
	                    case 11:
	                        if (!/Android/.test(navigator.userAgent)) {
	                            _context.next = 15;
	                            break;
	                        }
	
	                        if (!confirm("Riot is not supported on mobile web. Install the app?")) {
	                            _context.next = 15;
	                            break;
	                        }
	
	                        window.location = "https://play.google.com/store/apps/details?id=im.vector.alpha";
	                        return _context.abrupt('return');
	
	                    case 15:
	                        configJson = void 0;
	                        configError = void 0;
	                        _context.prev = 17;
	                        _context.next = 20;
	                        return getConfig();
	
	                    case 20:
	                        configJson = _context.sent;
	
	                        rageshake.setBugReportEndpoint(configJson.bug_report_endpoint_url);
	                        _context.next = 27;
	                        break;
	
	                    case 24:
	                        _context.prev = 24;
	                        _context.t0 = _context['catch'](17);
	
	                        configError = _context.t0;
	
	                    case 27:
	
	                        console.log("Vector starting at " + window.location);
	                        if (configError) {
	                            window.matrixChat = ReactDOM.render(React.createElement(
	                                'div',
	                                { className: 'error' },
	                                'Unable to load config file: please refresh the page to try again.'
	                            ), document.getElementById('matrixchat'));
	                        } else if (validBrowser) {
	                            UpdateChecker.start();
	
	                            MatrixChat = sdk.getComponent('structures.MatrixChat');
	
	                            window.matrixChat = ReactDOM.render(React.createElement(MatrixChat, {
	                                onNewScreen: onNewScreen,
	                                makeRegistrationUrl: makeRegistrationUrl,
	                                ConferenceHandler: VectorConferenceHandler,
	                                config: configJson,
	                                realQueryParams: params,
	                                startingFragmentQueryParams: fragparts.params,
	                                enableGuest: true,
	                                onLoadCompleted: onLoadCompleted,
	                                initialScreenAfterLogin: getScreenFromLocation(window.location),
	                                defaultDeviceDisplayName: PlatformPeg.get().getDefaultDeviceDisplayName()
	                            }), document.getElementById('matrixchat'));
	                        } else {
	                            console.error("Browser is missing required features.");
	                            // take to a different landing page to AWOOOOOGA at the user
	                            CompatibilityPage = sdk.getComponent("structures.CompatibilityPage");
	
	                            window.matrixChat = ReactDOM.render(React.createElement(CompatibilityPage, { onAccept: function onAccept() {
	                                    validBrowser = true;
	                                    console.log("User accepts the compatibility risks.");
	                                    loadApp();
	                                } }), document.getElementById('matrixchat'));
	                        }
	
	                    case 29:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[17, 24]]);
	    }));
	
	    return function loadApp() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _url = __webpack_require__(149);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _url_utils = __webpack_require__(602);
	
	var _platform = __webpack_require__(600);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(611);
	
	// Require common CSS here; this will make webpack process it into bundle.css.
	// Our own CSS (which is themed) is imported via separate webpack entry points
	// in webpack.config.js
	__webpack_require__(604);
	__webpack_require__(605);
	__webpack_require__(606);
	__webpack_require__(603);
	
	var rageshake = __webpack_require__(370);
	rageshake.init().then(function () {
	    console.log("Initialised rageshake: See https://bugs.chromium.org/p/chromium/issues/detail?id=583193 to fix line numbers on Chrome.");
	    rageshake.cleanup();
	}, function (err) {
	    console.error("Failed to initialise rageshake: " + err);
	});
	
	// add React and ReactPerf to the global namespace, to make them easier to
	// access via the console
	global.React = __webpack_require__(1);
	if (false) {
	    global.Perf = require("react-addons-perf");
	}
	
	var RunModernizrTests = __webpack_require__(597); // this side-effects a global
	var ReactDOM = __webpack_require__(18);
	var sdk = __webpack_require__(2);
	var PlatformPeg = __webpack_require__(93);
	sdk.loadSkin(__webpack_require__(563));
	var VectorConferenceHandler = __webpack_require__(366);
	var UpdateChecker = __webpack_require__(601);
	var q = __webpack_require__(6);
	var request = __webpack_require__(97);
	
	var lastLocationHashSet = null;
	
	var CallHandler = __webpack_require__(73);
	CallHandler.setConferenceHandler(VectorConferenceHandler);
	
	_MatrixClientPeg2.default.setIndexedDbWorkerScript(window.vector_indexeddb_worker_script);
	
	function checkBrowserFeatures(featureList) {
	    if (!window.Modernizr) {
	        console.error("Cannot check features - Modernizr global is missing.");
	        return false;
	    }
	    var featureComplete = true;
	    for (var i = 0; i < featureList.length; i++) {
	        if (window.Modernizr[featureList[i]] === undefined) {
	            console.error("Looked for feature '%s' but Modernizr has no results for this. " + "Has it been configured correctly?", featureList[i]);
	            return false;
	        }
	        if (window.Modernizr[featureList[i]] === false) {
	            console.error("Browser missing feature: '%s'", featureList[i]);
	            // toggle flag rather than return early so we log all missing features
	            // rather than just the first.
	            featureComplete = false;
	        }
	    }
	    return featureComplete;
	}
	
	var validBrowser = checkBrowserFeatures(["displaytable", "flexbox", "es5object", "es5function", "localstorage", "objectfit"]);
	
	// Parse the given window.location and return parameters that can be used when calling
	// MatrixChat.showScreen(screen, params)
	function getScreenFromLocation(location) {
	    var fragparts = (0, _url_utils.parseQsFromFragment)(location);
	    return {
	        screen: fragparts.location.substring(1),
	        params: fragparts.params
	    };
	}
	
	// Here, we do some crude URL analysis to allow
	// deep-linking.
	function routeUrl(location) {
	    if (!window.matrixChat) return;
	
	    console.log("Routing URL ", location.href);
	    var s = getScreenFromLocation(location);
	    window.matrixChat.showScreen(s.screen, s.params);
	}
	
	function onHashChange(ev) {
	    if (decodeURIComponent(window.location.hash) == lastLocationHashSet) {
	        // we just set this: no need to route it!
	        return;
	    }
	    routeUrl(window.location);
	}
	
	// This will be called whenever the SDK changes screens,
	// so a web page can update the URL bar appropriately.
	var onNewScreen = function onNewScreen(screen) {
	    console.log("newscreen " + screen);
	    var hash = '#/' + screen;
	    lastLocationHashSet = hash;
	    window.location.hash = hash;
	};
	
	// We use this to work out what URL the SDK should
	// pass through when registering to allow the user to
	// click back to the client having registered.
	// It's up to us to recognise if we're loaded with
	// this URL and tell MatrixClient to resume registration.
	//
	// If we're in electron, we should never pass through a file:// URL otherwise
	// the identity server will try to 302 the browser to it, which breaks horribly.
	// so in that instance, hardcode to use riot.im/app for now instead.
	var makeRegistrationUrl = function makeRegistrationUrl(params) {
	    var url = void 0;
	    if (window.location.protocol === "file:") {
	        url = 'https://riot.im/app/#/register';
	    } else {
	        url = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/register';
	    }
	
	    var keys = (0, _keys2.default)(params);
	    for (var i = 0; i < keys.length; ++i) {
	        if (i == 0) {
	            url += '?';
	        } else {
	            url += '&';
	        }
	        var k = keys[i];
	        url += k + '=' + encodeURIComponent(params[k]);
	    }
	    return url;
	};
	
	window.addEventListener('hashchange', onHashChange);
	
	function getConfig() {
	    var deferred = q.defer();
	
	    request({ method: "GET", url: "config.json" }, function (err, response, body) {
	        if (err || response.status < 200 || response.status >= 300) {
	            // Lack of a config isn't an error, we should
	            // just use the defaults.
	            // Also treat a blank config as no config, assuming
	            // the status code is 0, because we don't get 404s
	            // from file: URIs so this is the only way we can
	            // not fail if the file doesn't exist when loading
	            // from a file:// URI.
	            if (response) {
	                if (response.status == 404 || response.status == 0 && body == '') {
	                    deferred.resolve({});
	                }
	            }
	            deferred.reject({ err: err, response: response });
	            return;
	        }
	
	        // We parse the JSON ourselves rather than use the JSON
	        // parameter, since this throws a parse error on empty
	        // which breaks if there's no config.json and we're
	        // loading from the filesystem (see above).
	        deferred.resolve(JSON.parse(body));
	    });
	
	    return deferred.promise;
	}
	
	function onLoadCompleted() {
	    // if we did a token login, we're now left with the token, hs and is
	    // url as query params in the url; a little nasty but let's redirect to
	    // clear them.
	    if (window.location.search) {
	        var parsedUrl = _url2.default.parse(window.location.href);
	        parsedUrl.search = "";
	        var formatted = _url2.default.format(parsedUrl);
	        console.log("Redirecting to " + formatted + " to drop loginToken " + "from queryparams");
	        window.location.href = formatted;
	    }
	}
	
	loadApp();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(146);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var Skinner = __webpack_require__(1161);
	
	module.exports.loadSkin = function (skinObject) {
	    Skinner.load(skinObject);
	};
	
	module.exports.resetSkin = function () {
	    Skinner.reset();
	};
	
	module.exports.getComponent = function (componentName) {
	    return Skinner.getComponent(componentName);
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(13)
	  , core      = __webpack_require__(80)
	  , hide      = __webpack_require__(48)
	  , redefine  = __webpack_require__(49)
	  , ctx       = __webpack_require__(81)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);
	
	var _utils = __webpack_require__(16);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _eventTimeline = __webpack_require__(115);
	
	var _eventTimeline2 = _interopRequireDefault(_eventTimeline);
	
	var _eventTimelineSet = __webpack_require__(324);
	
	var _eventTimelineSet2 = _interopRequireDefault(_eventTimelineSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localStorage = window.localStorage;
	
	/**
	 * Wrapper object for handling the js-sdk Matrix Client object in the react-sdk
	 * Handles the creation/initialisation of client objects.
	 * This module provides a singleton instance of this class so the 'current'
	 * Matrix Client object is available easily.
	 */
	var MatrixClientPeg = function () {
	    function MatrixClientPeg() {
	        (0, _classCallCheck3.default)(this, MatrixClientPeg);
	
	        this.matrixClient = null;
	
	        // These are the default options used when when the
	        // client is started in 'start'. These can be altered
	        // at any time up to after the 'will_start_client'
	        // event is finished processing.
	        this.opts = {
	            initialSyncLimit: 20
	        };
	        this.indexedDbWorkerScript = null;
	    }
	
	    /**
	     * Sets the script href passed to the IndexedDB web worker
	     * If set, a separate web worker will be started to run the IndexedDB
	     * queries on.
	     *
	     * @param {string} script href to the script to be passed to the web worker
	     */
	
	
	    (0, _createClass3.default)(MatrixClientPeg, [{
	        key: 'setIndexedDbWorkerScript',
	        value: function setIndexedDbWorkerScript(script) {
	            this.indexedDbWorkerScript = script;
	        }
	    }, {
	        key: 'get',
	        value: function get() {
	            return this.matrixClient;
	        }
	    }, {
	        key: 'unset',
	        value: function unset() {
	            this.matrixClient = null;
	        }
	
	        /**
	         * Replace this MatrixClientPeg's client with a client instance that has
	         * Home Server / Identity Server URLs and active credentials
	         */
	
	    }, {
	        key: 'replaceUsingCreds',
	        value: function replaceUsingCreds(creds) {
	            this._createClient(creds);
	        }
	    }, {
	        key: 'start',
	        value: function start() {
	            var _this = this;
	
	            var opts = _utils2.default.deepCopy(this.opts);
	            // the react sdk doesn't work without this, so don't allow
	            opts.pendingEventOrdering = "detached";
	
	            var promise = this.matrixClient.store.startup();
	            // log any errors when starting up the database (if one exists)
	            promise.catch(function (err) {
	                console.error(err);
	            });
	
	            // regardless of errors, start the client. If we did error out, we'll
	            // just end up doing a full initial /sync.
	            promise.finally(function () {
	                _this.get().startClient(opts);
	            });
	        }
	    }, {
	        key: 'getCredentials',
	        value: function getCredentials() {
	            return {
	                homeserverUrl: this.matrixClient.baseUrl,
	                identityServerUrl: this.matrixClient.idBaseUrl,
	                userId: this.matrixClient.credentials.userId,
	                deviceId: this.matrixClient.getDeviceId(),
	                accessToken: this.matrixClient.getAccessToken(),
	                guest: this.matrixClient.isGuest()
	            };
	        }
	
	        /**
	         * Return the server name of the user's home server
	         * Throws an error if unable to deduce the home server name
	         * (eg. if the user is not logged in)
	         */
	
	    }, {
	        key: 'getHomeServerName',
	        value: function getHomeServerName() {
	            var matches = /^@.+:(.+)$/.exec(this.matrixClient.credentials.userId);
	            if (matches === null || matches.length < 1) {
	                throw new Error("Failed to derive home server name from user ID!");
	            }
	            return matches[1];
	        }
	    }, {
	        key: '_createClient',
	        value: function _createClient(creds) {
	            var opts = {
	                baseUrl: creds.homeserverUrl,
	                idBaseUrl: creds.identityServerUrl,
	                accessToken: creds.accessToken,
	                userId: creds.userId,
	                deviceId: creds.deviceId,
	                timelineSupport: true
	            };
	
	            if (localStorage) {
	                opts.sessionStore = new _matrixJsSdk2.default.WebStorageSessionStore(localStorage);
	            }
	            if (window.indexedDB && localStorage) {
	                // FIXME: bodge to remove old database. Remove this after a few weeks.
	                window.indexedDB.deleteDatabase("matrix-js-sdk:default");
	
	                opts.store = new _matrixJsSdk2.default.IndexedDBStore({
	                    indexedDB: window.indexedDB,
	                    dbName: "riot-web-sync",
	                    localStorage: localStorage,
	                    workerScript: this.indexedDbWorkerScript
	                });
	            }
	
	            this.matrixClient = _matrixJsSdk2.default.createClient(opts);
	
	            // we're going to add eventlisteners for each matrix event tile, so the
	            // potential number of event listeners is quite high.
	            this.matrixClient.setMaxListeners(500);
	
	            this.matrixClient.setGuest(Boolean(creds.guest));
	
	            var notifTimelineSet = new _eventTimelineSet2.default(null, {
	                timelineSupport: true
	            });
	            // XXX: what is our initial pagination token?! it somehow needs to be synchronised with /sync.
	            notifTimelineSet.getLiveTimeline().setPaginationToken("", _eventTimeline2.default.BACKWARDS);
	            this.matrixClient.setNotifTimelineSet(notifTimelineSet);
	        }
	    }]);
	    return MatrixClientPeg;
	}();
	
	if (!global.mxMatrixClientPeg) {
	    global.mxMatrixClientPeg = new MatrixClientPeg();
	}
	module.exports = global.mxMatrixClientPeg;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(240);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flux = __webpack_require__(1011);
	
	var MatrixDispatcher = function (_flux$Dispatcher) {
	    (0, _inherits3.default)(MatrixDispatcher, _flux$Dispatcher);
	
	    function MatrixDispatcher() {
	        (0, _classCallCheck3.default)(this, MatrixDispatcher);
	        return (0, _possibleConstructorReturn3.default)(this, (MatrixDispatcher.__proto__ || (0, _getPrototypeOf2.default)(MatrixDispatcher)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MatrixDispatcher, [{
	        key: "dispatch",
	
	        /**
	         * @param {Object} payload Required. The payload to dispatch.
	         *        Must contain at least an 'action' key.
	         * @param {boolean} sync Optional. Pass true to dispatch
	         *        synchronously. This is useful for anything triggering
	         *        an operation that the browser requires user interaction
	         *        for.
	         */
	        value: function dispatch(payload, sync) {
	            if (sync) {
	                (0, _get3.default)(MatrixDispatcher.prototype.__proto__ || (0, _getPrototypeOf2.default)(MatrixDispatcher.prototype), "dispatch", this).call(this, payload);
	            } else {
	                // Unless the caller explicitly asked for us to dispatch synchronously,
	                // we always set a timeout to do this: The flux dispatcher complains
	                // if you dispatch from within a dispatch, so rather than action
	                // handlers having to worry about not calling anything that might
	                // then dispatch, we just do dispatches asynchronously.
	                setTimeout((0, _get3.default)(MatrixDispatcher.prototype.__proto__ || (0, _getPrototypeOf2.default)(MatrixDispatcher.prototype), "dispatch", this).bind(this, payload), 0);
	            }
	        }
	    }]);
	    return MatrixDispatcher;
	}(flux.Dispatcher);
	
	// XXX this is a big anti-pattern, and makes testing hard. Because dispatches
	// happen asynchronously, it is possible for actions dispatched in one thread
	// to arrive in another, with *hilarious* consequences.
	
	
	if (global.mxDispatcher === undefined) {
	    global.mxDispatcher = new MatrixDispatcher();
	}
	module.exports = global.mxDispatcher;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// vim:ts=4:sts=4:sw=4:
	/*!
	 *
	 * Copyright 2009-2017 Kris Kowal under the terms of the MIT
	 * license found at https://github.com/kriskowal/q/blob/v1/LICENSE
	 *
	 * With parts by Tyler Close
	 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
	 * at http://www.opensource.org/licenses/mit-license.html
	 * Forked at ref_send.js version: 2009-05-11
	 *
	 * With parts by Mark Miller
	 * Copyright (C) 2011 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	(function (definition) {
	    "use strict";
	
	    // This file will function properly as a <script> tag, or a module
	    // using CommonJS and NodeJS or RequireJS module formats.  In
	    // Common/Node/RequireJS, the module exports the Q API and when
	    // executed as a simple <script>, it creates a Q global instead.
	
	    // Montage Require
	    if (typeof bootstrap === "function") {
	        bootstrap("promise", definition);
	
	    // CommonJS
	    } else if (true) {
	        module.exports = definition();
	
	    // RequireJS
	    } else if (typeof define === "function" && define.amd) {
	        define(definition);
	
	    // SES (Secure EcmaScript)
	    } else if (typeof ses !== "undefined") {
	        if (!ses.ok()) {
	            return;
	        } else {
	            ses.makeQ = definition;
	        }
	
	    // <script>
	    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
	        // Prefer window over self for add-on scripts. Use self for
	        // non-windowed contexts.
	        var global = typeof window !== "undefined" ? window : self;
	
	        // Get the `window` object, save the previous Q global
	        // and initialize Q as a global.
	        var previousQ = global.Q;
	        global.Q = definition();
	
	        // Add a noConflict function so Q can be removed from the
	        // global namespace.
	        global.Q.noConflict = function () {
	            global.Q = previousQ;
	            return this;
	        };
	
	    } else {
	        throw new Error("This environment was not anticipated by Q. Please file a bug.");
	    }
	
	})(function () {
	"use strict";
	
	var hasStacks = false;
	try {
	    throw new Error();
	} catch (e) {
	    hasStacks = !!e.stack;
	}
	
	// All code after this point will be filtered from stack traces reported
	// by Q.
	var qStartingLine = captureLine();
	var qFileName;
	
	// shims
	
	// used for fallback in "allResolved"
	var noop = function () {};
	
	// Use the fastest possible means to execute a task in a future turn
	// of the event loop.
	var nextTick =(function () {
	    // linked list of tasks (single, with head node)
	    var head = {task: void 0, next: null};
	    var tail = head;
	    var flushing = false;
	    var requestTick = void 0;
	    var isNodeJS = false;
	    // queue for late tasks, used by unhandled rejection tracking
	    var laterQueue = [];
	
	    function flush() {
	        /* jshint loopfunc: true */
	        var task, domain;
	
	        while (head.next) {
	            head = head.next;
	            task = head.task;
	            head.task = void 0;
	            domain = head.domain;
	
	            if (domain) {
	                head.domain = void 0;
	                domain.enter();
	            }
	            runSingle(task, domain);
	
	        }
	        while (laterQueue.length) {
	            task = laterQueue.pop();
	            runSingle(task);
	        }
	        flushing = false;
	    }
	    // runs a single function in the async queue
	    function runSingle(task, domain) {
	        try {
	            task();
	
	        } catch (e) {
	            if (isNodeJS) {
	                // In node, uncaught exceptions are considered fatal errors.
	                // Re-throw them synchronously to interrupt flushing!
	
	                // Ensure continuation if the uncaught exception is suppressed
	                // listening "uncaughtException" events (as domains does).
	                // Continue in next event to avoid tick recursion.
	                if (domain) {
	                    domain.exit();
	                }
	                setTimeout(flush, 0);
	                if (domain) {
	                    domain.enter();
	                }
	
	                throw e;
	
	            } else {
	                // In browsers, uncaught exceptions are not fatal.
	                // Re-throw them asynchronously to avoid slow-downs.
	                setTimeout(function () {
	                    throw e;
	                }, 0);
	            }
	        }
	
	        if (domain) {
	            domain.exit();
	        }
	    }
	
	    nextTick = function (task) {
	        tail = tail.next = {
	            task: task,
	            domain: isNodeJS && process.domain,
	            next: null
	        };
	
	        if (!flushing) {
	            flushing = true;
	            requestTick();
	        }
	    };
	
	    if (typeof process === "object" &&
	        process.toString() === "[object process]" && process.nextTick) {
	        // Ensure Q is in a real Node environment, with a `process.nextTick`.
	        // To see through fake Node environments:
	        // * Mocha test runner - exposes a `process` global without a `nextTick`
	        // * Browserify - exposes a `process.nexTick` function that uses
	        //   `setTimeout`. In this case `setImmediate` is preferred because
	        //    it is faster. Browserify's `process.toString()` yields
	        //   "[object Object]", while in a real Node environment
	        //   `process.toString()` yields "[object process]".
	        isNodeJS = true;
	
	        requestTick = function () {
	            process.nextTick(flush);
	        };
	
	    } else if (typeof setImmediate === "function") {
	        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
	        if (typeof window !== "undefined") {
	            requestTick = setImmediate.bind(window, flush);
	        } else {
	            requestTick = function () {
	                setImmediate(flush);
	            };
	        }
	
	    } else if (typeof MessageChannel !== "undefined") {
	        // modern browsers
	        // http://www.nonblocking.io/2011/06/windownexttick.html
	        var channel = new MessageChannel();
	        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
	        // working message ports the first time a page loads.
	        channel.port1.onmessage = function () {
	            requestTick = requestPortTick;
	            channel.port1.onmessage = flush;
	            flush();
	        };
	        var requestPortTick = function () {
	            // Opera requires us to provide a message payload, regardless of
	            // whether we use it.
	            channel.port2.postMessage(0);
	        };
	        requestTick = function () {
	            setTimeout(flush, 0);
	            requestPortTick();
	        };
	
	    } else {
	        // old browsers
	        requestTick = function () {
	            setTimeout(flush, 0);
	        };
	    }
	    // runs a task after all other tasks have been run
	    // this is useful for unhandled rejection tracking that needs to happen
	    // after all `then`d tasks have been run.
	    nextTick.runAfter = function (task) {
	        laterQueue.push(task);
	        if (!flushing) {
	            flushing = true;
	            requestTick();
	        }
	    };
	    return nextTick;
	})();
	
	// Attempt to make generics safe in the face of downstream
	// modifications.
	// There is no situation where this is necessary.
	// If you need a security guarantee, these primordials need to be
	// deeply frozen anyway, and if you don’t need a security guarantee,
	// this is just plain paranoid.
	// However, this **might** have the nice side-effect of reducing the size of
	// the minified code by reducing x.call() to merely x()
	// See Mark Miller’s explanation of what this does.
	// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
	var call = Function.call;
	function uncurryThis(f) {
	    return function () {
	        return call.apply(f, arguments);
	    };
	}
	// This is equivalent, but slower:
	// uncurryThis = Function_bind.bind(Function_bind.call);
	// http://jsperf.com/uncurrythis
	
	var array_slice = uncurryThis(Array.prototype.slice);
	
	var array_reduce = uncurryThis(
	    Array.prototype.reduce || function (callback, basis) {
	        var index = 0,
	            length = this.length;
	        // concerning the initial value, if one is not provided
	        if (arguments.length === 1) {
	            // seek to the first value in the array, accounting
	            // for the possibility that is is a sparse array
	            do {
	                if (index in this) {
	                    basis = this[index++];
	                    break;
	                }
	                if (++index >= length) {
	                    throw new TypeError();
	                }
	            } while (1);
	        }
	        // reduce
	        for (; index < length; index++) {
	            // account for the possibility that the array is sparse
	            if (index in this) {
	                basis = callback(basis, this[index], index);
	            }
	        }
	        return basis;
	    }
	);
	
	var array_indexOf = uncurryThis(
	    Array.prototype.indexOf || function (value) {
	        // not a very good shim, but good enough for our one use of it
	        for (var i = 0; i < this.length; i++) {
	            if (this[i] === value) {
	                return i;
	            }
	        }
	        return -1;
	    }
	);
	
	var array_map = uncurryThis(
	    Array.prototype.map || function (callback, thisp) {
	        var self = this;
	        var collect = [];
	        array_reduce(self, function (undefined, value, index) {
	            collect.push(callback.call(thisp, value, index, self));
	        }, void 0);
	        return collect;
	    }
	);
	
	var object_create = Object.create || function (prototype) {
	    function Type() { }
	    Type.prototype = prototype;
	    return new Type();
	};
	
	var object_defineProperty = Object.defineProperty || function (obj, prop, descriptor) {
	    obj[prop] = descriptor.value;
	    return obj;
	};
	
	var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
	
	var object_keys = Object.keys || function (object) {
	    var keys = [];
	    for (var key in object) {
	        if (object_hasOwnProperty(object, key)) {
	            keys.push(key);
	        }
	    }
	    return keys;
	};
	
	var object_toString = uncurryThis(Object.prototype.toString);
	
	function isObject(value) {
	    return value === Object(value);
	}
	
	// generator related shims
	
	// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
	function isStopIteration(exception) {
	    return (
	        object_toString(exception) === "[object StopIteration]" ||
	        exception instanceof QReturnValue
	    );
	}
	
	// FIXME: Remove this helper and Q.return once ES6 generators are in
	// SpiderMonkey.
	var QReturnValue;
	if (typeof ReturnValue !== "undefined") {
	    QReturnValue = ReturnValue;
	} else {
	    QReturnValue = function (value) {
	        this.value = value;
	    };
	}
	
	// long stack traces
	
	var STACK_JUMP_SEPARATOR = "From previous event:";
	
	function makeStackTraceLong(error, promise) {
	    // If possible, transform the error stack trace by removing Node and Q
	    // cruft, then concatenating with the stack trace of `promise`. See #57.
	    if (hasStacks &&
	        promise.stack &&
	        typeof error === "object" &&
	        error !== null &&
	        error.stack
	    ) {
	        var stacks = [];
	        for (var p = promise; !!p; p = p.source) {
	            if (p.stack && (!error.__minimumStackCounter__ || error.__minimumStackCounter__ > p.stackCounter)) {
	                object_defineProperty(error, "__minimumStackCounter__", {value: p.stackCounter, configurable: true});
	                stacks.unshift(p.stack);
	            }
	        }
	        stacks.unshift(error.stack);
	
	        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
	        var stack = filterStackString(concatedStacks);
	        object_defineProperty(error, "stack", {value: stack, configurable: true});
	    }
	}
	
	function filterStackString(stackString) {
	    var lines = stackString.split("\n");
	    var desiredLines = [];
	    for (var i = 0; i < lines.length; ++i) {
	        var line = lines[i];
	
	        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
	            desiredLines.push(line);
	        }
	    }
	    return desiredLines.join("\n");
	}
	
	function isNodeFrame(stackLine) {
	    return stackLine.indexOf("(module.js:") !== -1 ||
	           stackLine.indexOf("(node.js:") !== -1;
	}
	
	function getFileNameAndLineNumber(stackLine) {
	    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
	    // In IE10 function name can have spaces ("Anonymous function") O_o
	    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
	    if (attempt1) {
	        return [attempt1[1], Number(attempt1[2])];
	    }
	
	    // Anonymous functions: "at filename:lineNumber:columnNumber"
	    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
	    if (attempt2) {
	        return [attempt2[1], Number(attempt2[2])];
	    }
	
	    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
	    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
	    if (attempt3) {
	        return [attempt3[1], Number(attempt3[2])];
	    }
	}
	
	function isInternalFrame(stackLine) {
	    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
	
	    if (!fileNameAndLineNumber) {
	        return false;
	    }
	
	    var fileName = fileNameAndLineNumber[0];
	    var lineNumber = fileNameAndLineNumber[1];
	
	    return fileName === qFileName &&
	        lineNumber >= qStartingLine &&
	        lineNumber <= qEndingLine;
	}
	
	// discover own file name and line number range for filtering stack
	// traces
	function captureLine() {
	    if (!hasStacks) {
	        return;
	    }
	
	    try {
	        throw new Error();
	    } catch (e) {
	        var lines = e.stack.split("\n");
	        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
	        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
	        if (!fileNameAndLineNumber) {
	            return;
	        }
	
	        qFileName = fileNameAndLineNumber[0];
	        return fileNameAndLineNumber[1];
	    }
	}
	
	function deprecate(callback, name, alternative) {
	    return function () {
	        if (typeof console !== "undefined" &&
	            typeof console.warn === "function") {
	            console.warn(name + " is deprecated, use " + alternative +
	                         " instead.", new Error("").stack);
	        }
	        return callback.apply(callback, arguments);
	    };
	}
	
	// end of shims
	// beginning of real work
	
	/**
	 * Constructs a promise for an immediate reference, passes promises through, or
	 * coerces promises from different systems.
	 * @param value immediate reference or promise
	 */
	function Q(value) {
	    // If the object is already a Promise, return it directly.  This enables
	    // the resolve function to both be used to created references from objects,
	    // but to tolerably coerce non-promises to promises.
	    if (value instanceof Promise) {
	        return value;
	    }
	
	    // assimilate thenables
	    if (isPromiseAlike(value)) {
	        return coerce(value);
	    } else {
	        return fulfill(value);
	    }
	}
	Q.resolve = Q;
	
	/**
	 * Performs a task in a future turn of the event loop.
	 * @param {Function} task
	 */
	Q.nextTick = nextTick;
	
	/**
	 * Controls whether or not long stack traces will be on
	 */
	Q.longStackSupport = false;
	
	/**
	 * The counter is used to determine the stopping point for building
	 * long stack traces. In makeStackTraceLong we walk backwards through
	 * the linked list of promises, only stacks which were created before
	 * the rejection are concatenated.
	 */
	var longStackCounter = 1;
	
	// enable long stacks if Q_DEBUG is set
	if (typeof process === "object" && process && ({"NODE_ENV":"production"}) && ({"NODE_ENV":"production"}).Q_DEBUG) {
	    Q.longStackSupport = true;
	}
	
	/**
	 * Constructs a {promise, resolve, reject} object.
	 *
	 * `resolve` is a callback to invoke with a more resolved value for the
	 * promise. To fulfill the promise, invoke `resolve` with any value that is
	 * not a thenable. To reject the promise, invoke `resolve` with a rejected
	 * thenable, or invoke `reject` with the reason directly. To resolve the
	 * promise to another thenable, thus putting it in the same state, invoke
	 * `resolve` with that other thenable.
	 */
	Q.defer = defer;
	function defer() {
	    // if "messages" is an "Array", that indicates that the promise has not yet
	    // been resolved.  If it is "undefined", it has been resolved.  Each
	    // element of the messages array is itself an array of complete arguments to
	    // forward to the resolved promise.  We coerce the resolution value to a
	    // promise using the `resolve` function because it handles both fully
	    // non-thenable values and other thenables gracefully.
	    var messages = [], progressListeners = [], resolvedPromise;
	
	    var deferred = object_create(defer.prototype);
	    var promise = object_create(Promise.prototype);
	
	    promise.promiseDispatch = function (resolve, op, operands) {
	        var args = array_slice(arguments);
	        if (messages) {
	            messages.push(args);
	            if (op === "when" && operands[1]) { // progress operand
	                progressListeners.push(operands[1]);
	            }
	        } else {
	            Q.nextTick(function () {
	                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
	            });
	        }
	    };
	
	    // XXX deprecated
	    promise.valueOf = function () {
	        if (messages) {
	            return promise;
	        }
	        var nearerValue = nearer(resolvedPromise);
	        if (isPromise(nearerValue)) {
	            resolvedPromise = nearerValue; // shorten chain
	        }
	        return nearerValue;
	    };
	
	    promise.inspect = function () {
	        if (!resolvedPromise) {
	            return { state: "pending" };
	        }
	        return resolvedPromise.inspect();
	    };
	
	    if (Q.longStackSupport && hasStacks) {
	        try {
	            throw new Error();
	        } catch (e) {
	            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
	            // accessor around; that causes memory leaks as per GH-111. Just
	            // reify the stack trace as a string ASAP.
	            //
	            // At the same time, cut off the first line; it's always just
	            // "[object Promise]\n", as per the `toString`.
	            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
	            promise.stackCounter = longStackCounter++;
	        }
	    }
	
	    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
	    // consolidating them into `become`, since otherwise we'd create new
	    // promises with the lines `become(whatever(value))`. See e.g. GH-252.
	
	    function become(newPromise) {
	        resolvedPromise = newPromise;
	
	        if (Q.longStackSupport && hasStacks) {
	            // Only hold a reference to the new promise if long stacks
	            // are enabled to reduce memory usage
	            promise.source = newPromise;
	        }
	
	        array_reduce(messages, function (undefined, message) {
	            Q.nextTick(function () {
	                newPromise.promiseDispatch.apply(newPromise, message);
	            });
	        }, void 0);
	
	        messages = void 0;
	        progressListeners = void 0;
	    }
	
	    deferred.promise = promise;
	    deferred.resolve = function (value) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        become(Q(value));
	    };
	
	    deferred.fulfill = function (value) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        become(fulfill(value));
	    };
	    deferred.reject = function (reason) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        become(reject(reason));
	    };
	    deferred.notify = function (progress) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        array_reduce(progressListeners, function (undefined, progressListener) {
	            Q.nextTick(function () {
	                progressListener(progress);
	            });
	        }, void 0);
	    };
	
	    return deferred;
	}
	
	/**
	 * Creates a Node-style callback that will resolve or reject the deferred
	 * promise.
	 * @returns a nodeback
	 */
	defer.prototype.makeNodeResolver = function () {
	    var self = this;
	    return function (error, value) {
	        if (error) {
	            self.reject(error);
	        } else if (arguments.length > 2) {
	            self.resolve(array_slice(arguments, 1));
	        } else {
	            self.resolve(value);
	        }
	    };
	};
	
	/**
	 * @param resolver {Function} a function that returns nothing and accepts
	 * the resolve, reject, and notify functions for a deferred.
	 * @returns a promise that may be resolved with the given resolve and reject
	 * functions, or rejected by a thrown exception in resolver
	 */
	Q.Promise = promise; // ES6
	Q.promise = promise;
	function promise(resolver) {
	    if (typeof resolver !== "function") {
	        throw new TypeError("resolver must be a function.");
	    }
	    var deferred = defer();
	    try {
	        resolver(deferred.resolve, deferred.reject, deferred.notify);
	    } catch (reason) {
	        deferred.reject(reason);
	    }
	    return deferred.promise;
	}
	
	promise.race = race; // ES6
	promise.all = all; // ES6
	promise.reject = reject; // ES6
	promise.resolve = Q; // ES6
	
	// XXX experimental.  This method is a way to denote that a local value is
	// serializable and should be immediately dispatched to a remote upon request,
	// instead of passing a reference.
	Q.passByCopy = function (object) {
	    //freeze(object);
	    //passByCopies.set(object, true);
	    return object;
	};
	
	Promise.prototype.passByCopy = function () {
	    //freeze(object);
	    //passByCopies.set(object, true);
	    return this;
	};
	
	/**
	 * If two promises eventually fulfill to the same value, promises that value,
	 * but otherwise rejects.
	 * @param x {Any*}
	 * @param y {Any*}
	 * @returns {Any*} a promise for x and y if they are the same, but a rejection
	 * otherwise.
	 *
	 */
	Q.join = function (x, y) {
	    return Q(x).join(y);
	};
	
	Promise.prototype.join = function (that) {
	    return Q([this, that]).spread(function (x, y) {
	        if (x === y) {
	            // TODO: "===" should be Object.is or equiv
	            return x;
	        } else {
	            throw new Error("Q can't join: not the same: " + x + " " + y);
	        }
	    });
	};
	
	/**
	 * Returns a promise for the first of an array of promises to become settled.
	 * @param answers {Array[Any*]} promises to race
	 * @returns {Any*} the first promise to be settled
	 */
	Q.race = race;
	function race(answerPs) {
	    return promise(function (resolve, reject) {
	        // Switch to this once we can assume at least ES5
	        // answerPs.forEach(function (answerP) {
	        //     Q(answerP).then(resolve, reject);
	        // });
	        // Use this in the meantime
	        for (var i = 0, len = answerPs.length; i < len; i++) {
	            Q(answerPs[i]).then(resolve, reject);
	        }
	    });
	}
	
	Promise.prototype.race = function () {
	    return this.then(Q.race);
	};
	
	/**
	 * Constructs a Promise with a promise descriptor object and optional fallback
	 * function.  The descriptor contains methods like when(rejected), get(name),
	 * set(name, value), post(name, args), and delete(name), which all
	 * return either a value, a promise for a value, or a rejection.  The fallback
	 * accepts the operation name, a resolver, and any further arguments that would
	 * have been forwarded to the appropriate method above had a method been
	 * provided with the proper name.  The API makes no guarantees about the nature
	 * of the returned object, apart from that it is usable whereever promises are
	 * bought and sold.
	 */
	Q.makePromise = Promise;
	function Promise(descriptor, fallback, inspect) {
	    if (fallback === void 0) {
	        fallback = function (op) {
	            return reject(new Error(
	                "Promise does not support operation: " + op
	            ));
	        };
	    }
	    if (inspect === void 0) {
	        inspect = function () {
	            return {state: "unknown"};
	        };
	    }
	
	    var promise = object_create(Promise.prototype);
	
	    promise.promiseDispatch = function (resolve, op, args) {
	        var result;
	        try {
	            if (descriptor[op]) {
	                result = descriptor[op].apply(promise, args);
	            } else {
	                result = fallback.call(promise, op, args);
	            }
	        } catch (exception) {
	            result = reject(exception);
	        }
	        if (resolve) {
	            resolve(result);
	        }
	    };
	
	    promise.inspect = inspect;
	
	    // XXX deprecated `valueOf` and `exception` support
	    if (inspect) {
	        var inspected = inspect();
	        if (inspected.state === "rejected") {
	            promise.exception = inspected.reason;
	        }
	
	        promise.valueOf = function () {
	            var inspected = inspect();
	            if (inspected.state === "pending" ||
	                inspected.state === "rejected") {
	                return promise;
	            }
	            return inspected.value;
	        };
	    }
	
	    return promise;
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.then = function (fulfilled, rejected, progressed) {
	    var self = this;
	    var deferred = defer();
	    var done = false;   // ensure the untrusted promise makes at most a
	                        // single call to one of the callbacks
	
	    function _fulfilled(value) {
	        try {
	            return typeof fulfilled === "function" ? fulfilled(value) : value;
	        } catch (exception) {
	            return reject(exception);
	        }
	    }
	
	    function _rejected(exception) {
	        if (typeof rejected === "function") {
	            makeStackTraceLong(exception, self);
	            try {
	                return rejected(exception);
	            } catch (newException) {
	                return reject(newException);
	            }
	        }
	        return reject(exception);
	    }
	
	    function _progressed(value) {
	        return typeof progressed === "function" ? progressed(value) : value;
	    }
	
	    Q.nextTick(function () {
	        self.promiseDispatch(function (value) {
	            if (done) {
	                return;
	            }
	            done = true;
	
	            deferred.resolve(_fulfilled(value));
	        }, "when", [function (exception) {
	            if (done) {
	                return;
	            }
	            done = true;
	
	            deferred.resolve(_rejected(exception));
	        }]);
	    });
	
	    // Progress propagator need to be attached in the current tick.
	    self.promiseDispatch(void 0, "when", [void 0, function (value) {
	        var newValue;
	        var threw = false;
	        try {
	            newValue = _progressed(value);
	        } catch (e) {
	            threw = true;
	            if (Q.onerror) {
	                Q.onerror(e);
	            } else {
	                throw e;
	            }
	        }
	
	        if (!threw) {
	            deferred.notify(newValue);
	        }
	    }]);
	
	    return deferred.promise;
	};
	
	Q.tap = function (promise, callback) {
	    return Q(promise).tap(callback);
	};
	
	/**
	 * Works almost like "finally", but not called for rejections.
	 * Original resolution value is passed through callback unaffected.
	 * Callback may return a promise that will be awaited for.
	 * @param {Function} callback
	 * @returns {Q.Promise}
	 * @example
	 * doSomething()
	 *   .then(...)
	 *   .tap(console.log)
	 *   .then(...);
	 */
	Promise.prototype.tap = function (callback) {
	    callback = Q(callback);
	
	    return this.then(function (value) {
	        return callback.fcall(value).thenResolve(value);
	    });
	};
	
	/**
	 * Registers an observer on a promise.
	 *
	 * Guarantees:
	 *
	 * 1. that fulfilled and rejected will be called only once.
	 * 2. that either the fulfilled callback or the rejected callback will be
	 *    called, but not both.
	 * 3. that fulfilled and rejected will not be called in this turn.
	 *
	 * @param value      promise or immediate reference to observe
	 * @param fulfilled  function to be called with the fulfilled value
	 * @param rejected   function to be called with the rejection exception
	 * @param progressed function to be called on any progress notifications
	 * @return promise for the return value from the invoked callback
	 */
	Q.when = when;
	function when(value, fulfilled, rejected, progressed) {
	    return Q(value).then(fulfilled, rejected, progressed);
	}
	
	Promise.prototype.thenResolve = function (value) {
	    return this.then(function () { return value; });
	};
	
	Q.thenResolve = function (promise, value) {
	    return Q(promise).thenResolve(value);
	};
	
	Promise.prototype.thenReject = function (reason) {
	    return this.then(function () { throw reason; });
	};
	
	Q.thenReject = function (promise, reason) {
	    return Q(promise).thenReject(reason);
	};
	
	/**
	 * If an object is not a promise, it is as "near" as possible.
	 * If a promise is rejected, it is as "near" as possible too.
	 * If it’s a fulfilled promise, the fulfillment value is nearer.
	 * If it’s a deferred promise and the deferred has been resolved, the
	 * resolution is "nearer".
	 * @param object
	 * @returns most resolved (nearest) form of the object
	 */
	
	// XXX should we re-do this?
	Q.nearer = nearer;
	function nearer(value) {
	    if (isPromise(value)) {
	        var inspected = value.inspect();
	        if (inspected.state === "fulfilled") {
	            return inspected.value;
	        }
	    }
	    return value;
	}
	
	/**
	 * @returns whether the given object is a promise.
	 * Otherwise it is a fulfilled value.
	 */
	Q.isPromise = isPromise;
	function isPromise(object) {
	    return object instanceof Promise;
	}
	
	Q.isPromiseAlike = isPromiseAlike;
	function isPromiseAlike(object) {
	    return isObject(object) && typeof object.then === "function";
	}
	
	/**
	 * @returns whether the given object is a pending promise, meaning not
	 * fulfilled or rejected.
	 */
	Q.isPending = isPending;
	function isPending(object) {
	    return isPromise(object) && object.inspect().state === "pending";
	}
	
	Promise.prototype.isPending = function () {
	    return this.inspect().state === "pending";
	};
	
	/**
	 * @returns whether the given object is a value or fulfilled
	 * promise.
	 */
	Q.isFulfilled = isFulfilled;
	function isFulfilled(object) {
	    return !isPromise(object) || object.inspect().state === "fulfilled";
	}
	
	Promise.prototype.isFulfilled = function () {
	    return this.inspect().state === "fulfilled";
	};
	
	/**
	 * @returns whether the given object is a rejected promise.
	 */
	Q.isRejected = isRejected;
	function isRejected(object) {
	    return isPromise(object) && object.inspect().state === "rejected";
	}
	
	Promise.prototype.isRejected = function () {
	    return this.inspect().state === "rejected";
	};
	
	//// BEGIN UNHANDLED REJECTION TRACKING
	
	// This promise library consumes exceptions thrown in handlers so they can be
	// handled by a subsequent promise.  The exceptions get added to this array when
	// they are created, and removed when they are handled.  Note that in ES6 or
	// shimmed environments, this would naturally be a `Set`.
	var unhandledReasons = [];
	var unhandledRejections = [];
	var reportedUnhandledRejections = [];
	var trackUnhandledRejections = true;
	
	function resetUnhandledRejections() {
	    unhandledReasons.length = 0;
	    unhandledRejections.length = 0;
	
	    if (!trackUnhandledRejections) {
	        trackUnhandledRejections = true;
	    }
	}
	
	function trackRejection(promise, reason) {
	    if (!trackUnhandledRejections) {
	        return;
	    }
	    if (typeof process === "object" && typeof process.emit === "function") {
	        Q.nextTick.runAfter(function () {
	            if (array_indexOf(unhandledRejections, promise) !== -1) {
	                process.emit("unhandledRejection", reason, promise);
	                reportedUnhandledRejections.push(promise);
	            }
	        });
	    }
	
	    unhandledRejections.push(promise);
	    if (reason && typeof reason.stack !== "undefined") {
	        unhandledReasons.push(reason.stack);
	    } else {
	        unhandledReasons.push("(no stack) " + reason);
	    }
	}
	
	function untrackRejection(promise) {
	    if (!trackUnhandledRejections) {
	        return;
	    }
	
	    var at = array_indexOf(unhandledRejections, promise);
	    if (at !== -1) {
	        if (typeof process === "object" && typeof process.emit === "function") {
	            Q.nextTick.runAfter(function () {
	                var atReport = array_indexOf(reportedUnhandledRejections, promise);
	                if (atReport !== -1) {
	                    process.emit("rejectionHandled", unhandledReasons[at], promise);
	                    reportedUnhandledRejections.splice(atReport, 1);
	                }
	            });
	        }
	        unhandledRejections.splice(at, 1);
	        unhandledReasons.splice(at, 1);
	    }
	}
	
	Q.resetUnhandledRejections = resetUnhandledRejections;
	
	Q.getUnhandledReasons = function () {
	    // Make a copy so that consumers can't interfere with our internal state.
	    return unhandledReasons.slice();
	};
	
	Q.stopUnhandledRejectionTracking = function () {
	    resetUnhandledRejections();
	    trackUnhandledRejections = false;
	};
	
	resetUnhandledRejections();
	
	//// END UNHANDLED REJECTION TRACKING
	
	/**
	 * Constructs a rejected promise.
	 * @param reason value describing the failure
	 */
	Q.reject = reject;
	function reject(reason) {
	    var rejection = Promise({
	        "when": function (rejected) {
	            // note that the error has been handled
	            if (rejected) {
	                untrackRejection(this);
	            }
	            return rejected ? rejected(reason) : this;
	        }
	    }, function fallback() {
	        return this;
	    }, function inspect() {
	        return { state: "rejected", reason: reason };
	    });
	
	    // Note that the reason has not been handled.
	    trackRejection(rejection, reason);
	
	    return rejection;
	}
	
	/**
	 * Constructs a fulfilled promise for an immediate reference.
	 * @param value immediate reference
	 */
	Q.fulfill = fulfill;
	function fulfill(value) {
	    return Promise({
	        "when": function () {
	            return value;
	        },
	        "get": function (name) {
	            return value[name];
	        },
	        "set": function (name, rhs) {
	            value[name] = rhs;
	        },
	        "delete": function (name) {
	            delete value[name];
	        },
	        "post": function (name, args) {
	            // Mark Miller proposes that post with no name should apply a
	            // promised function.
	            if (name === null || name === void 0) {
	                return value.apply(void 0, args);
	            } else {
	                return value[name].apply(value, args);
	            }
	        },
	        "apply": function (thisp, args) {
	            return value.apply(thisp, args);
	        },
	        "keys": function () {
	            return object_keys(value);
	        }
	    }, void 0, function inspect() {
	        return { state: "fulfilled", value: value };
	    });
	}
	
	/**
	 * Converts thenables to Q promises.
	 * @param promise thenable promise
	 * @returns a Q promise
	 */
	function coerce(promise) {
	    var deferred = defer();
	    Q.nextTick(function () {
	        try {
	            promise.then(deferred.resolve, deferred.reject, deferred.notify);
	        } catch (exception) {
	            deferred.reject(exception);
	        }
	    });
	    return deferred.promise;
	}
	
	/**
	 * Annotates an object such that it will never be
	 * transferred away from this process over any promise
	 * communication channel.
	 * @param object
	 * @returns promise a wrapping of that object that
	 * additionally responds to the "isDef" message
	 * without a rejection.
	 */
	Q.master = master;
	function master(object) {
	    return Promise({
	        "isDef": function () {}
	    }, function fallback(op, args) {
	        return dispatch(object, op, args);
	    }, function () {
	        return Q(object).inspect();
	    });
	}
	
	/**
	 * Spreads the values of a promised array of arguments into the
	 * fulfillment callback.
	 * @param fulfilled callback that receives variadic arguments from the
	 * promised array
	 * @param rejected callback that receives the exception if the promise
	 * is rejected.
	 * @returns a promise for the return value or thrown exception of
	 * either callback.
	 */
	Q.spread = spread;
	function spread(value, fulfilled, rejected) {
	    return Q(value).spread(fulfilled, rejected);
	}
	
	Promise.prototype.spread = function (fulfilled, rejected) {
	    return this.all().then(function (array) {
	        return fulfilled.apply(void 0, array);
	    }, rejected);
	};
	
	/**
	 * The async function is a decorator for generator functions, turning
	 * them into asynchronous generators.  Although generators are only part
	 * of the newest ECMAScript 6 drafts, this code does not cause syntax
	 * errors in older engines.  This code should continue to work and will
	 * in fact improve over time as the language improves.
	 *
	 * ES6 generators are currently part of V8 version 3.19 with the
	 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
	 * for longer, but under an older Python-inspired form.  This function
	 * works on both kinds of generators.
	 *
	 * Decorates a generator function such that:
	 *  - it may yield promises
	 *  - execution will continue when that promise is fulfilled
	 *  - the value of the yield expression will be the fulfilled value
	 *  - it returns a promise for the return value (when the generator
	 *    stops iterating)
	 *  - the decorated function returns a promise for the return value
	 *    of the generator or the first rejected promise among those
	 *    yielded.
	 *  - if an error is thrown in the generator, it propagates through
	 *    every following yield until it is caught, or until it escapes
	 *    the generator function altogether, and is translated into a
	 *    rejection for the promise returned by the decorated generator.
	 */
	Q.async = async;
	function async(makeGenerator) {
	    return function () {
	        // when verb is "send", arg is a value
	        // when verb is "throw", arg is an exception
	        function continuer(verb, arg) {
	            var result;
	
	            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
	            // engine that has a deployed base of browsers that support generators.
	            // However, SM's generators use the Python-inspired semantics of
	            // outdated ES6 drafts.  We would like to support ES6, but we'd also
	            // like to make it possible to use generators in deployed browsers, so
	            // we also support Python-style generators.  At some point we can remove
	            // this block.
	
	            if (typeof StopIteration === "undefined") {
	                // ES6 Generators
	                try {
	                    result = generator[verb](arg);
	                } catch (exception) {
	                    return reject(exception);
	                }
	                if (result.done) {
	                    return Q(result.value);
	                } else {
	                    return when(result.value, callback, errback);
	                }
	            } else {
	                // SpiderMonkey Generators
	                // FIXME: Remove this case when SM does ES6 generators.
	                try {
	                    result = generator[verb](arg);
	                } catch (exception) {
	                    if (isStopIteration(exception)) {
	                        return Q(exception.value);
	                    } else {
	                        return reject(exception);
	                    }
	                }
	                return when(result, callback, errback);
	            }
	        }
	        var generator = makeGenerator.apply(this, arguments);
	        var callback = continuer.bind(continuer, "next");
	        var errback = continuer.bind(continuer, "throw");
	        return callback();
	    };
	}
	
	/**
	 * The spawn function is a small wrapper around async that immediately
	 * calls the generator and also ends the promise chain, so that any
	 * unhandled errors are thrown instead of forwarded to the error
	 * handler. This is useful because it's extremely common to run
	 * generators at the top-level to work with libraries.
	 */
	Q.spawn = spawn;
	function spawn(makeGenerator) {
	    Q.done(Q.async(makeGenerator)());
	}
	
	// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
	/**
	 * Throws a ReturnValue exception to stop an asynchronous generator.
	 *
	 * This interface is a stop-gap measure to support generator return
	 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
	 * generators like Chromium 29, just use "return" in your generator
	 * functions.
	 *
	 * @param value the return value for the surrounding generator
	 * @throws ReturnValue exception with the value.
	 * @example
	 * // ES6 style
	 * Q.async(function* () {
	 *      var foo = yield getFooPromise();
	 *      var bar = yield getBarPromise();
	 *      return foo + bar;
	 * })
	 * // Older SpiderMonkey style
	 * Q.async(function () {
	 *      var foo = yield getFooPromise();
	 *      var bar = yield getBarPromise();
	 *      Q.return(foo + bar);
	 * })
	 */
	Q["return"] = _return;
	function _return(value) {
	    throw new QReturnValue(value);
	}
	
	/**
	 * The promised function decorator ensures that any promise arguments
	 * are settled and passed as values (`this` is also settled and passed
	 * as a value).  It will also ensure that the result of a function is
	 * always a promise.
	 *
	 * @example
	 * var add = Q.promised(function (a, b) {
	 *     return a + b;
	 * });
	 * add(Q(a), Q(B));
	 *
	 * @param {function} callback The function to decorate
	 * @returns {function} a function that has been decorated.
	 */
	Q.promised = promised;
	function promised(callback) {
	    return function () {
	        return spread([this, all(arguments)], function (self, args) {
	            return callback.apply(self, args);
	        });
	    };
	}
	
	/**
	 * sends a message to a value in a future turn
	 * @param object* the recipient
	 * @param op the name of the message operation, e.g., "when",
	 * @param args further arguments to be forwarded to the operation
	 * @returns result {Promise} a promise for the result of the operation
	 */
	Q.dispatch = dispatch;
	function dispatch(object, op, args) {
	    return Q(object).dispatch(op, args);
	}
	
	Promise.prototype.dispatch = function (op, args) {
	    var self = this;
	    var deferred = defer();
	    Q.nextTick(function () {
	        self.promiseDispatch(deferred.resolve, op, args);
	    });
	    return deferred.promise;
	};
	
	/**
	 * Gets the value of a property in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of property to get
	 * @return promise for the property value
	 */
	Q.get = function (object, key) {
	    return Q(object).dispatch("get", [key]);
	};
	
	Promise.prototype.get = function (key) {
	    return this.dispatch("get", [key]);
	};
	
	/**
	 * Sets the value of a property in a future turn.
	 * @param object    promise or immediate reference for object object
	 * @param name      name of property to set
	 * @param value     new value of property
	 * @return promise for the return value
	 */
	Q.set = function (object, key, value) {
	    return Q(object).dispatch("set", [key, value]);
	};
	
	Promise.prototype.set = function (key, value) {
	    return this.dispatch("set", [key, value]);
	};
	
	/**
	 * Deletes a property in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of property to delete
	 * @return promise for the return value
	 */
	Q.del = // XXX legacy
	Q["delete"] = function (object, key) {
	    return Q(object).dispatch("delete", [key]);
	};
	
	Promise.prototype.del = // XXX legacy
	Promise.prototype["delete"] = function (key) {
	    return this.dispatch("delete", [key]);
	};
	
	/**
	 * Invokes a method in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of method to invoke
	 * @param value     a value to post, typically an array of
	 *                  invocation arguments for promises that
	 *                  are ultimately backed with `resolve` values,
	 *                  as opposed to those backed with URLs
	 *                  wherein the posted value can be any
	 *                  JSON serializable object.
	 * @return promise for the return value
	 */
	// bound locally because it is used by other methods
	Q.mapply = // XXX As proposed by "Redsandro"
	Q.post = function (object, name, args) {
	    return Q(object).dispatch("post", [name, args]);
	};
	
	Promise.prototype.mapply = // XXX As proposed by "Redsandro"
	Promise.prototype.post = function (name, args) {
	    return this.dispatch("post", [name, args]);
	};
	
	/**
	 * Invokes a method in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of method to invoke
	 * @param ...args   array of invocation arguments
	 * @return promise for the return value
	 */
	Q.send = // XXX Mark Miller's proposed parlance
	Q.mcall = // XXX As proposed by "Redsandro"
	Q.invoke = function (object, name /*...args*/) {
	    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
	};
	
	Promise.prototype.send = // XXX Mark Miller's proposed parlance
	Promise.prototype.mcall = // XXX As proposed by "Redsandro"
	Promise.prototype.invoke = function (name /*...args*/) {
	    return this.dispatch("post", [name, array_slice(arguments, 1)]);
	};
	
	/**
	 * Applies the promised function in a future turn.
	 * @param object    promise or immediate reference for target function
	 * @param args      array of application arguments
	 */
	Q.fapply = function (object, args) {
	    return Q(object).dispatch("apply", [void 0, args]);
	};
	
	Promise.prototype.fapply = function (args) {
	    return this.dispatch("apply", [void 0, args]);
	};
	
	/**
	 * Calls the promised function in a future turn.
	 * @param object    promise or immediate reference for target function
	 * @param ...args   array of application arguments
	 */
	Q["try"] =
	Q.fcall = function (object /* ...args*/) {
	    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
	};
	
	Promise.prototype.fcall = function (/*...args*/) {
	    return this.dispatch("apply", [void 0, array_slice(arguments)]);
	};
	
	/**
	 * Binds the promised function, transforming return values into a fulfilled
	 * promise and thrown errors into a rejected one.
	 * @param object    promise or immediate reference for target function
	 * @param ...args   array of application arguments
	 */
	Q.fbind = function (object /*...args*/) {
	    var promise = Q(object);
	    var args = array_slice(arguments, 1);
	    return function fbound() {
	        return promise.dispatch("apply", [
	            this,
	            args.concat(array_slice(arguments))
	        ]);
	    };
	};
	Promise.prototype.fbind = function (/*...args*/) {
	    var promise = this;
	    var args = array_slice(arguments);
	    return function fbound() {
	        return promise.dispatch("apply", [
	            this,
	            args.concat(array_slice(arguments))
	        ]);
	    };
	};
	
	/**
	 * Requests the names of the owned properties of a promised
	 * object in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @return promise for the keys of the eventually settled object
	 */
	Q.keys = function (object) {
	    return Q(object).dispatch("keys", []);
	};
	
	Promise.prototype.keys = function () {
	    return this.dispatch("keys", []);
	};
	
	/**
	 * Turns an array of promises into a promise for an array.  If any of
	 * the promises gets rejected, the whole array is rejected immediately.
	 * @param {Array*} an array (or promise for an array) of values (or
	 * promises for values)
	 * @returns a promise for an array of the corresponding values
	 */
	// By Mark Miller
	// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
	Q.all = all;
	function all(promises) {
	    return when(promises, function (promises) {
	        var pendingCount = 0;
	        var deferred = defer();
	        array_reduce(promises, function (undefined, promise, index) {
	            var snapshot;
	            if (
	                isPromise(promise) &&
	                (snapshot = promise.inspect()).state === "fulfilled"
	            ) {
	                promises[index] = snapshot.value;
	            } else {
	                ++pendingCount;
	                when(
	                    promise,
	                    function (value) {
	                        promises[index] = value;
	                        if (--pendingCount === 0) {
	                            deferred.resolve(promises);
	                        }
	                    },
	                    deferred.reject,
	                    function (progress) {
	                        deferred.notify({ index: index, value: progress });
	                    }
	                );
	            }
	        }, void 0);
	        if (pendingCount === 0) {
	            deferred.resolve(promises);
	        }
	        return deferred.promise;
	    });
	}
	
	Promise.prototype.all = function () {
	    return all(this);
	};
	
	/**
	 * Returns the first resolved promise of an array. Prior rejected promises are
	 * ignored.  Rejects only if all promises are rejected.
	 * @param {Array*} an array containing values or promises for values
	 * @returns a promise fulfilled with the value of the first resolved promise,
	 * or a rejected promise if all promises are rejected.
	 */
	Q.any = any;
	
	function any(promises) {
	    if (promises.length === 0) {
	        return Q.resolve();
	    }
	
	    var deferred = Q.defer();
	    var pendingCount = 0;
	    array_reduce(promises, function (prev, current, index) {
	        var promise = promises[index];
	
	        pendingCount++;
	
	        when(promise, onFulfilled, onRejected, onProgress);
	        function onFulfilled(result) {
	            deferred.resolve(result);
	        }
	        function onRejected(err) {
	            pendingCount--;
	            if (pendingCount === 0) {
	                err.message = ("Q can't get fulfillment value from any promise, all " +
	                    "promises were rejected. Last error message: " + err.message);
	                deferred.reject(err);
	            }
	        }
	        function onProgress(progress) {
	            deferred.notify({
	                index: index,
	                value: progress
	            });
	        }
	    }, undefined);
	
	    return deferred.promise;
	}
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	/**
	 * Waits for all promises to be settled, either fulfilled or
	 * rejected.  This is distinct from `all` since that would stop
	 * waiting at the first rejection.  The promise returned by
	 * `allResolved` will never be rejected.
	 * @param promises a promise for an array (or an array) of promises
	 * (or values)
	 * @return a promise for an array of promises
	 */
	Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
	function allResolved(promises) {
	    return when(promises, function (promises) {
	        promises = array_map(promises, Q);
	        return when(all(array_map(promises, function (promise) {
	            return when(promise, noop, noop);
	        })), function () {
	            return promises;
	        });
	    });
	}
	
	Promise.prototype.allResolved = function () {
	    return allResolved(this);
	};
	
	/**
	 * @see Promise#allSettled
	 */
	Q.allSettled = allSettled;
	function allSettled(promises) {
	    return Q(promises).allSettled();
	}
	
	/**
	 * Turns an array of promises into a promise for an array of their states (as
	 * returned by `inspect`) when they have all settled.
	 * @param {Array[Any*]} values an array (or promise for an array) of values (or
	 * promises for values)
	 * @returns {Array[State]} an array of states for the respective values.
	 */
	Promise.prototype.allSettled = function () {
	    return this.then(function (promises) {
	        return all(array_map(promises, function (promise) {
	            promise = Q(promise);
	            function regardless() {
	                return promise.inspect();
	            }
	            return promise.then(regardless, regardless);
	        }));
	    });
	};
	
	/**
	 * Captures the failure of a promise, giving an oportunity to recover
	 * with a callback.  If the given promise is fulfilled, the returned
	 * promise is fulfilled.
	 * @param {Any*} promise for something
	 * @param {Function} callback to fulfill the returned promise if the
	 * given promise is rejected
	 * @returns a promise for the return value of the callback
	 */
	Q.fail = // XXX legacy
	Q["catch"] = function (object, rejected) {
	    return Q(object).then(void 0, rejected);
	};
	
	Promise.prototype.fail = // XXX legacy
	Promise.prototype["catch"] = function (rejected) {
	    return this.then(void 0, rejected);
	};
	
	/**
	 * Attaches a listener that can respond to progress notifications from a
	 * promise's originating deferred. This listener receives the exact arguments
	 * passed to ``deferred.notify``.
	 * @param {Any*} promise for something
	 * @param {Function} callback to receive any progress notifications
	 * @returns the given promise, unchanged
	 */
	Q.progress = progress;
	function progress(object, progressed) {
	    return Q(object).then(void 0, void 0, progressed);
	}
	
	Promise.prototype.progress = function (progressed) {
	    return this.then(void 0, void 0, progressed);
	};
	
	/**
	 * Provides an opportunity to observe the settling of a promise,
	 * regardless of whether the promise is fulfilled or rejected.  Forwards
	 * the resolution to the returned promise when the callback is done.
	 * The callback can return a promise to defer completion.
	 * @param {Any*} promise
	 * @param {Function} callback to observe the resolution of the given
	 * promise, takes no arguments.
	 * @returns a promise for the resolution of the given promise when
	 * ``fin`` is done.
	 */
	Q.fin = // XXX legacy
	Q["finally"] = function (object, callback) {
	    return Q(object)["finally"](callback);
	};
	
	Promise.prototype.fin = // XXX legacy
	Promise.prototype["finally"] = function (callback) {
	    if (!callback || typeof callback.apply !== "function") {
	        throw new Error("Q can't apply finally callback");
	    }
	    callback = Q(callback);
	    return this.then(function (value) {
	        return callback.fcall().then(function () {
	            return value;
	        });
	    }, function (reason) {
	        // TODO attempt to recycle the rejection with "this".
	        return callback.fcall().then(function () {
	            throw reason;
	        });
	    });
	};
	
	/**
	 * Terminates a chain of promises, forcing rejections to be
	 * thrown as exceptions.
	 * @param {Any*} promise at the end of a chain of promises
	 * @returns nothing
	 */
	Q.done = function (object, fulfilled, rejected, progress) {
	    return Q(object).done(fulfilled, rejected, progress);
	};
	
	Promise.prototype.done = function (fulfilled, rejected, progress) {
	    var onUnhandledError = function (error) {
	        // forward to a future turn so that ``when``
	        // does not catch it and turn it into a rejection.
	        Q.nextTick(function () {
	            makeStackTraceLong(error, promise);
	            if (Q.onerror) {
	                Q.onerror(error);
	            } else {
	                throw error;
	            }
	        });
	    };
	
	    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
	    var promise = fulfilled || rejected || progress ?
	        this.then(fulfilled, rejected, progress) :
	        this;
	
	    if (typeof process === "object" && process && process.domain) {
	        onUnhandledError = process.domain.bind(onUnhandledError);
	    }
	
	    promise.then(void 0, onUnhandledError);
	};
	
	/**
	 * Causes a promise to be rejected if it does not get fulfilled before
	 * some milliseconds time out.
	 * @param {Any*} promise
	 * @param {Number} milliseconds timeout
	 * @param {Any*} custom error message or Error object (optional)
	 * @returns a promise for the resolution of the given promise if it is
	 * fulfilled before the timeout, otherwise rejected.
	 */
	Q.timeout = function (object, ms, error) {
	    return Q(object).timeout(ms, error);
	};
	
	Promise.prototype.timeout = function (ms, error) {
	    var deferred = defer();
	    var timeoutId = setTimeout(function () {
	        if (!error || "string" === typeof error) {
	            error = new Error(error || "Timed out after " + ms + " ms");
	            error.code = "ETIMEDOUT";
	        }
	        deferred.reject(error);
	    }, ms);
	
	    this.then(function (value) {
	        clearTimeout(timeoutId);
	        deferred.resolve(value);
	    }, function (exception) {
	        clearTimeout(timeoutId);
	        deferred.reject(exception);
	    }, deferred.notify);
	
	    return deferred.promise;
	};
	
	/**
	 * Returns a promise for the given value (or promised value), some
	 * milliseconds after it resolved. Passes rejections immediately.
	 * @param {Any*} promise
	 * @param {Number} milliseconds
	 * @returns a promise for the resolution of the given promise after milliseconds
	 * time has elapsed since the resolution of the given promise.
	 * If the given promise rejects, that is passed immediately.
	 */
	Q.delay = function (object, timeout) {
	    if (timeout === void 0) {
	        timeout = object;
	        object = void 0;
	    }
	    return Q(object).delay(timeout);
	};
	
	Promise.prototype.delay = function (timeout) {
	    return this.then(function (value) {
	        var deferred = defer();
	        setTimeout(function () {
	            deferred.resolve(value);
	        }, timeout);
	        return deferred.promise;
	    });
	};
	
	/**
	 * Passes a continuation to a Node function, which is called with the given
	 * arguments provided as an array, and returns a promise.
	 *
	 *      Q.nfapply(FS.readFile, [__filename])
	 *      .then(function (content) {
	 *      })
	 *
	 */
	Q.nfapply = function (callback, args) {
	    return Q(callback).nfapply(args);
	};
	
	Promise.prototype.nfapply = function (args) {
	    var deferred = defer();
	    var nodeArgs = array_slice(args);
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.fapply(nodeArgs).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * Passes a continuation to a Node function, which is called with the given
	 * arguments provided individually, and returns a promise.
	 * @example
	 * Q.nfcall(FS.readFile, __filename)
	 * .then(function (content) {
	 * })
	 *
	 */
	Q.nfcall = function (callback /*...args*/) {
	    var args = array_slice(arguments, 1);
	    return Q(callback).nfapply(args);
	};
	
	Promise.prototype.nfcall = function (/*...args*/) {
	    var nodeArgs = array_slice(arguments);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.fapply(nodeArgs).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * Wraps a NodeJS continuation passing function and returns an equivalent
	 * version that returns a promise.
	 * @example
	 * Q.nfbind(FS.readFile, __filename)("utf-8")
	 * .then(console.log)
	 * .done()
	 */
	Q.nfbind =
	Q.denodeify = function (callback /*...args*/) {
	    if (callback === undefined) {
	        throw new Error("Q can't wrap an undefined function");
	    }
	    var baseArgs = array_slice(arguments, 1);
	    return function () {
	        var nodeArgs = baseArgs.concat(array_slice(arguments));
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        Q(callback).fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	};
	
	Promise.prototype.nfbind =
	Promise.prototype.denodeify = function (/*...args*/) {
	    var args = array_slice(arguments);
	    args.unshift(this);
	    return Q.denodeify.apply(void 0, args);
	};
	
	Q.nbind = function (callback, thisp /*...args*/) {
	    var baseArgs = array_slice(arguments, 2);
	    return function () {
	        var nodeArgs = baseArgs.concat(array_slice(arguments));
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        function bound() {
	            return callback.apply(thisp, arguments);
	        }
	        Q(bound).fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	};
	
	Promise.prototype.nbind = function (/*thisp, ...args*/) {
	    var args = array_slice(arguments, 0);
	    args.unshift(this);
	    return Q.nbind.apply(void 0, args);
	};
	
	/**
	 * Calls a method of a Node-style object that accepts a Node-style
	 * callback with a given array of arguments, plus a provided callback.
	 * @param object an object that has the named method
	 * @param {String} name name of the method of object
	 * @param {Array} args arguments to pass to the method; the callback
	 * will be provided by Q and appended to these arguments.
	 * @returns a promise for the value or error
	 */
	Q.nmapply = // XXX As proposed by "Redsandro"
	Q.npost = function (object, name, args) {
	    return Q(object).npost(name, args);
	};
	
	Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
	Promise.prototype.npost = function (name, args) {
	    var nodeArgs = array_slice(args || []);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * Calls a method of a Node-style object that accepts a Node-style
	 * callback, forwarding the given variadic arguments, plus a provided
	 * callback argument.
	 * @param object an object that has the named method
	 * @param {String} name name of the method of object
	 * @param ...args arguments to pass to the method; the callback will
	 * be provided by Q and appended to these arguments.
	 * @returns a promise for the value or error
	 */
	Q.nsend = // XXX Based on Mark Miller's proposed "send"
	Q.nmcall = // XXX Based on "Redsandro's" proposal
	Q.ninvoke = function (object, name /*...args*/) {
	    var nodeArgs = array_slice(arguments, 2);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};
	
	Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
	Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
	Promise.prototype.ninvoke = function (name /*...args*/) {
	    var nodeArgs = array_slice(arguments, 1);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * If a function would like to support both Node continuation-passing-style and
	 * promise-returning-style, it can end its internal promise chain with
	 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
	 * elects to use a nodeback, the result will be sent there.  If they do not
	 * pass a nodeback, they will receive the result promise.
	 * @param object a result (or a promise for a result)
	 * @param {Function} nodeback a Node.js-style callback
	 * @returns either the promise or nothing
	 */
	Q.nodeify = nodeify;
	function nodeify(object, nodeback) {
	    return Q(object).nodeify(nodeback);
	}
	
	Promise.prototype.nodeify = function (nodeback) {
	    if (nodeback) {
	        this.then(function (value) {
	            Q.nextTick(function () {
	                nodeback(null, value);
	            });
	        }, function (error) {
	            Q.nextTick(function () {
	                nodeback(error);
	            });
	        });
	    } else {
	        return this;
	    }
	};
	
	Q.noConflict = function() {
	    throw new Error("Q.noConflict only works when Q is used as a global");
	};
	
	// All code before this point will be filtered from stack traces.
	var qEndingLine = captureLine();
	
	return Q;
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64), __webpack_require__(232).setImmediate))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(239);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _objectWithoutProperties2 = __webpack_require__(96);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	
	
	var DIALOG_CONTAINER_ID = "mx_Dialog_Container";
	
	/**
	 * Wrap an asynchronous loader function with a react component which shows a
	 * spinner until the real component loads.
	 */
	var AsyncWrapper = React.createClass({
	    displayName: 'AsyncWrapper',
	
	    propTypes: {
	        /** A function which takes a 'callback' argument which it will call
	         * with the real component once it loads.
	         */
	        loader: React.PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            component: null
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        this._unmounted = false;
	        // XXX: temporary logging to try to diagnose
	        // https://github.com/vector-im/riot-web/issues/3148
	        console.log('Starting load of AsyncWrapper for modal');
	        this.props.loader(function (e) {
	            // XXX: temporary logging to try to diagnose
	            // https://github.com/vector-im/riot-web/issues/3148
	            console.log('AsyncWrapper load completed with ' + e.displayName);
	            if (_this._unmounted) {
	                return;
	            }
	            _this.setState({ component: e });
	        });
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this._unmounted = true;
	    },
	
	    render: function render() {
	        var _props = this.props,
	            loader = _props.loader,
	            otherProps = (0, _objectWithoutProperties3.default)(_props, ['loader']);
	
	
	        if (this.state.component) {
	            var Component = this.state.component;
	            return React.createElement(Component, otherProps);
	        } else {
	            // show a spinner until the component is loaded.
	            var Spinner = _index2.default.getComponent("elements.Spinner");
	            return React.createElement(Spinner, null);
	        }
	    }
	});
	
	var ModalManager = function () {
	    function ModalManager() {
	        (0, _classCallCheck3.default)(this, ModalManager);
	
	        this._counter = 0;
	
	        /** list of the modals we have stacked up, with the most recent at [0] */
	        this._modals = [
	            /* {
	               elem: React component for this dialog
	               onFinished: caller-supplied onFinished callback
	               className: CSS class for the dialog wrapper div
	               } */
	        ];
	
	        this.closeAll = this.closeAll.bind(this);
	    }
	
	    (0, _createClass3.default)(ModalManager, [{
	        key: 'getOrCreateContainer',
	        value: function getOrCreateContainer() {
	            var container = document.getElementById(DIALOG_CONTAINER_ID);
	
	            if (!container) {
	                container = document.createElement("div");
	                container.id = DIALOG_CONTAINER_ID;
	                document.body.appendChild(container);
	            }
	
	            return container;
	        }
	    }, {
	        key: 'createDialog',
	        value: function createDialog(Element, props, className) {
	            return this.createDialogAsync(function (cb) {
	                cb(Element);
	            }, props, className);
	        }
	
	        /**
	         * Open a modal view.
	         *
	         * This can be used to display a react component which is loaded as an asynchronous
	         * webpack component. To do this, set 'loader' as:
	         *
	         *   (cb) => {
	         *       require(['<module>'], cb);
	         *   }
	         *
	         * @param {Function} loader   a function which takes a 'callback' argument,
	         *   which it should call with a React component which will be displayed as
	         *   the modal view.
	         *
	         * @param {Object} props   properties to pass to the displayed
	         *    component. (We will also pass an 'onFinished' property.)
	         *
	         * @param {String} className   CSS class to apply to the modal wrapper
	         */
	
	    }, {
	        key: 'createDialogAsync',
	        value: function createDialogAsync(loader, props, className) {
	            var self = this;
	            var modal = {};
	
	            // never call this from onFinished() otherwise it will loop
	            //
	            // nb explicit function() rather than arrow function, to get `arguments`
	            var closeDialog = function closeDialog() {
	                if (props && props.onFinished) props.onFinished.apply(null, arguments);
	                var i = self._modals.indexOf(modal);
	                if (i >= 0) {
	                    self._modals.splice(i, 1);
	                }
	                self._reRender();
	            };
	
	            // don't attempt to reuse the same AsyncWrapper for different dialogs,
	            // otherwise we'll get confused.
	            var modalCount = this._counter++;
	
	            // FIXME: If a dialog uses getDefaultProps it clobbers the onFinished
	            // property set here so you can't close the dialog from a button click!
	            modal.elem = React.createElement(AsyncWrapper, (0, _extends3.default)({ key: modalCount, loader: loader }, props, {
	                onFinished: closeDialog }));
	            modal.onFinished = props ? props.onFinished : null;
	            modal.className = className;
	
	            this._modals.unshift(modal);
	
	            this._reRender();
	            return { close: closeDialog };
	        }
	    }, {
	        key: 'closeAll',
	        value: function closeAll() {
	            var modals = this._modals;
	            this._modals = [];
	
	            for (var i = 0; i < modals.length; i++) {
	                var m = modals[i];
	                if (m.onFinished) {
	                    m.onFinished(false);
	                }
	            }
	
	            this._reRender();
	        }
	    }, {
	        key: '_reRender',
	        value: function _reRender() {
	            if (this._modals.length == 0) {
	                ReactDOM.unmountComponentAtNode(this.getOrCreateContainer());
	                return;
	            }
	
	            var modal = this._modals[0];
	            var dialog = React.createElement(
	                'div',
	                { className: "mx_Dialog_wrapper " + (modal.className ? modal.className : '') },
	                React.createElement(
	                    'div',
	                    { className: 'mx_Dialog' },
	                    modal.elem
	                ),
	                React.createElement('div', { className: 'mx_Dialog_background', onClick: this.closeAll })
	            );
	
	            ReactDOM.render(dialog, this.getOrCreateContainer());
	        }
	    }]);
	    return ModalManager;
	}();
	
	exports.default = new ModalManager();
	module.exports = exports['default'];


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(654), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(43);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(650), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module.
	 * @module utils
	 */
	
	/**
	 * Encode a dictionary of query parameters.
	 * @param {Object} params A dict of key/values to encode e.g.
	 * {"foo": "bar", "baz": "taz"}
	 * @return {string} The encoded string e.g. foo=bar&baz=taz
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports.encodeParams = function (params) {
	    var qs = "";
	    for (var key in params) {
	        if (!params.hasOwnProperty(key)) {
	            continue;
	        }
	        qs += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
	    }
	    return qs.substring(1);
	};
	
	/**
	 * Encodes a URI according to a set of template variables. Variables will be
	 * passed through encodeURIComponent.
	 * @param {string} pathTemplate The path with template variables e.g. '/foo/$bar'.
	 * @param {Object} variables The key/value pairs to replace the template
	 * variables with. E.g. { "$bar": "baz" }.
	 * @return {string} The result of replacing all template variables e.g. '/foo/baz'.
	 */
	module.exports.encodeUri = function (pathTemplate, variables) {
	    for (var key in variables) {
	        if (!variables.hasOwnProperty(key)) {
	            continue;
	        }
	        pathTemplate = pathTemplate.replace(key, encodeURIComponent(variables[key]));
	    }
	    return pathTemplate;
	};
	
	/**
	 * Applies a map function to the given array.
	 * @param {Array} array The array to apply the function to.
	 * @param {Function} fn The function that will be invoked for each element in
	 * the array with the signature <code>fn(element){...}</code>
	 * @return {Array} A new array with the results of the function.
	 */
	module.exports.map = function (array, fn) {
	    var results = new Array(array.length);
	    for (var i = 0; i < array.length; i++) {
	        results[i] = fn(array[i]);
	    }
	    return results;
	};
	
	/**
	 * Applies a filter function to the given array.
	 * @param {Array} array The array to apply the function to.
	 * @param {Function} fn The function that will be invoked for each element in
	 * the array. It should return true to keep the element. The function signature
	 * looks like <code>fn(element, index, array){...}</code>.
	 * @return {Array} A new array with the results of the function.
	 */
	module.exports.filter = function (array, fn) {
	    var results = [];
	    for (var i = 0; i < array.length; i++) {
	        if (fn(array[i], i, array)) {
	            results.push(array[i]);
	        }
	    }
	    return results;
	};
	
	/**
	 * Get the keys for an object. Same as <code>Object.keys()</code>.
	 * @param {Object} obj The object to get the keys for.
	 * @return {string[]} The keys of the object.
	 */
	module.exports.keys = function (obj) {
	    var keys = [];
	    for (var key in obj) {
	        if (!obj.hasOwnProperty(key)) {
	            continue;
	        }
	        keys.push(key);
	    }
	    return keys;
	};
	
	/**
	 * Get the values for an object.
	 * @param {Object} obj The object to get the values for.
	 * @return {Array<*>} The values of the object.
	 */
	module.exports.values = function (obj) {
	    var values = [];
	    for (var key in obj) {
	        if (!obj.hasOwnProperty(key)) {
	            continue;
	        }
	        values.push(obj[key]);
	    }
	    return values;
	};
	
	/**
	 * Invoke a function for each item in the array.
	 * @param {Array} array The array.
	 * @param {Function} fn The function to invoke for each element. Has the
	 * function signature <code>fn(element, index)</code>.
	 */
	module.exports.forEach = function (array, fn) {
	    for (var i = 0; i < array.length; i++) {
	        fn(array[i], i);
	    }
	};
	
	/**
	 * The findElement() method returns a value in the array, if an element in the array
	 * satisfies (returns true) the provided testing function. Otherwise undefined
	 * is returned.
	 * @param {Array} array The array.
	 * @param {Function} fn Function to execute on each value in the array, with the
	 * function signature <code>fn(element, index, array)</code>
	 * @param {boolean} reverse True to search in reverse order.
	 * @return {*} The first value in the array which returns <code>true</code> for
	 * the given function.
	 */
	module.exports.findElement = function (array, fn, reverse) {
	    var i = void 0;
	    if (reverse) {
	        for (i = array.length - 1; i >= 0; i--) {
	            if (fn(array[i], i, array)) {
	                return array[i];
	            }
	        }
	    } else {
	        for (i = 0; i < array.length; i++) {
	            if (fn(array[i], i, array)) {
	                return array[i];
	            }
	        }
	    }
	};
	
	/**
	 * The removeElement() method removes the first element in the array that
	 * satisfies (returns true) the provided testing function.
	 * @param {Array} array The array.
	 * @param {Function} fn Function to execute on each value in the array, with the
	 * function signature <code>fn(element, index, array)</code>. Return true to
	 * remove this element and break.
	 * @param {boolean} reverse True to search in reverse order.
	 * @return {boolean} True if an element was removed.
	 */
	module.exports.removeElement = function (array, fn, reverse) {
	    var i = void 0;
	    var removed = void 0;
	    if (reverse) {
	        for (i = array.length - 1; i >= 0; i--) {
	            if (fn(array[i], i, array)) {
	                removed = array[i];
	                array.splice(i, 1);
	                return removed;
	            }
	        }
	    } else {
	        for (i = 0; i < array.length; i++) {
	            if (fn(array[i], i, array)) {
	                removed = array[i];
	                array.splice(i, 1);
	                return removed;
	            }
	        }
	    }
	    return false;
	};
	
	/**
	 * Checks if the given thing is a function.
	 * @param {*} value The thing to check.
	 * @return {boolean} True if it is a function.
	 */
	module.exports.isFunction = function (value) {
	    return Object.prototype.toString.call(value) == "[object Function]";
	};
	
	/**
	 * Checks if the given thing is an array.
	 * @param {*} value The thing to check.
	 * @return {boolean} True if it is an array.
	 */
	module.exports.isArray = function (value) {
	    return Array.isArray ? Array.isArray(value) : Boolean(value && value.constructor === Array);
	};
	
	/**
	 * Checks that the given object has the specified keys.
	 * @param {Object} obj The object to check.
	 * @param {string[]} keys The list of keys that 'obj' must have.
	 * @throws If the object is missing keys.
	 */
	module.exports.checkObjectHasKeys = function (obj, keys) {
	    for (var i = 0; i < keys.length; i++) {
	        if (!obj.hasOwnProperty(keys[i])) {
	            throw new Error("Missing required key: " + keys[i]);
	        }
	    }
	};
	
	/**
	 * Checks that the given object has no extra keys other than the specified ones.
	 * @param {Object} obj The object to check.
	 * @param {string[]} allowedKeys The list of allowed key names.
	 * @throws If there are extra keys.
	 */
	module.exports.checkObjectHasNoAdditionalKeys = function (obj, allowedKeys) {
	    for (var key in obj) {
	        if (!obj.hasOwnProperty(key)) {
	            continue;
	        }
	        if (allowedKeys.indexOf(key) === -1) {
	            throw new Error("Unknown key: " + key);
	        }
	    }
	};
	
	/**
	 * Deep copy the given object. The object MUST NOT have circular references and
	 * MUST NOT have functions.
	 * @param {Object} obj The object to deep copy.
	 * @return {Object} A copy of the object without any references to the original.
	 */
	module.exports.deepCopy = function (obj) {
	    return JSON.parse(JSON.stringify(obj));
	};
	
	/**
	 * Compare two objects for equality. The objects MUST NOT have circular references.
	 *
	 * @param {Object} x The first object to compare.
	 * @param {Object} y The second object to compare.
	 *
	 * @return {boolean} true if the two objects are equal
	 */
	var deepCompare = module.exports.deepCompare = function (x, y) {
	    // Inspired by
	    // http://stackoverflow.com/questions/1068834/object-comparison-in-javascript#1144249
	
	    // Compare primitives and functions.
	    // Also check if both arguments link to the same object.
	    if (x === y) {
	        return true;
	    }
	
	    if ((typeof x === "undefined" ? "undefined" : _typeof(x)) !== (typeof y === "undefined" ? "undefined" : _typeof(y))) {
	        return false;
	    }
	
	    // special-case NaN (since NaN !== NaN)
	    if (typeof x === 'number' && isNaN(x) && isNaN(y)) {
	        return true;
	    }
	
	    // special-case null (since typeof null == 'object', but null.constructor
	    // throws)
	    if (x === null || y === null) {
	        return x === y;
	    }
	
	    // everything else is either an unequal primitive, or an object
	    if (!(x instanceof Object)) {
	        return false;
	    }
	
	    // check they are the same type of object
	    if (x.constructor !== y.constructor || x.prototype !== y.prototype) {
	        return false;
	    }
	
	    // special-casing for some special types of object
	    if (x instanceof RegExp || x instanceof Date) {
	        return x.toString() === y.toString();
	    }
	
	    // the object algorithm works for Array, but it's sub-optimal.
	    if (x instanceof Array) {
	        if (x.length !== y.length) {
	            return false;
	        }
	
	        for (var i = 0; i < x.length; i++) {
	            if (!deepCompare(x[i], y[i])) {
	                return false;
	            }
	        }
	    } else {
	        // disable jshint "The body of a for in should be wrapped in an if
	        // statement"
	        /* jshint -W089 */
	
	        // check that all of y's direct keys are in x
	        var p = void 0;
	        for (p in y) {
	            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
	                return false;
	            }
	        }
	
	        // finally, compare each of x's keys with y
	        for (p in y) {
	            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
	                return false;
	            }
	            if (!deepCompare(x[p], y[p])) {
	                return false;
	            }
	        }
	    }
	    /* jshint +W089 */
	    return true;
	};
	
	/**
	 * Copy properties from one object to another.
	 *
	 * All enumerable properties, included inherited ones, are copied.
	 *
	 * This is approximately equivalent to ES6's Object.assign, except
	 * that the latter doesn't copy inherited properties.
	 *
	 * @param {Object} target  The object that will receive new properties
	 * @param {...Object} source  Objects from which to copy properties
	 *
	 * @return {Object} target
	 */
	module.exports.extend = function () {
	    var target = arguments[0] || {};
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	        for (var propName in source) {
	            // eslint-disable-line guard-for-in
	            target[propName] = source[propName];
	        }
	    }
	    return target;
	};
	
	/**
	 * Run polyfills to add Array.map and Array.filter if they are missing.
	 */
	module.exports.runPolyfills = function () {
	    //                Array.prototype.filter
	    // ========================================================
	    // SOURCE:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
	    if (!Array.prototype.filter) {
	        Array.prototype.filter = function (fun /*, thisArg*/) {
	            if (this === void 0 || this === null) {
	                throw new TypeError();
	            }
	
	            var t = Object(this);
	            var len = t.length >>> 0;
	            if (typeof fun !== 'function') {
	                throw new TypeError();
	            }
	
	            var res = [];
	            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	            for (var i = 0; i < len; i++) {
	                if (i in t) {
	                    var val = t[i];
	
	                    // NOTE: Technically this should Object.defineProperty at
	                    //       the next index, as push can be affected by
	                    //       properties on Object.prototype and Array.prototype.
	                    //       But that method's new, and collisions should be
	                    //       rare, so use the more-compatible alternative.
	                    if (fun.call(thisArg, val, i, t)) {
	                        res.push(val);
	                    }
	                }
	            }
	
	            return res;
	        };
	    }
	
	    //                Array.prototype.map
	    // ========================================================
	    // SOURCE:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
	    // Production steps of ECMA-262, Edition 5, 15.4.4.19
	    // Reference: http://es5.github.io/#x15.4.4.19
	    if (!Array.prototype.map) {
	        Array.prototype.map = function (callback, thisArg) {
	            var T = void 0,
	                k = void 0;
	
	            if (this === null || this === undefined) {
	                throw new TypeError(' this is null or not defined');
	            }
	
	            // 1. Let O be the result of calling ToObject passing the |this|
	            //    value as the argument.
	            var O = Object(this);
	
	            // 2. Let lenValue be the result of calling the Get internal
	            //    method of O with the argument "length".
	            // 3. Let len be ToUint32(lenValue).
	            var len = O.length >>> 0;
	
	            // 4. If IsCallable(callback) is false, throw a TypeError exception.
	            // See: http://es5.github.com/#x9.11
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
	            if (arguments.length > 1) {
	                T = thisArg;
	            }
	
	            // 6. Let A be a new array created as if by the expression new Array(len)
	            //    where Array is the standard built-in constructor with that name and
	            //    len is the value of len.
	            var A = new Array(len);
	
	            // 7. Let k be 0
	            k = 0;
	
	            // 8. Repeat, while k < len
	            while (k < len) {
	                var kValue, mappedValue;
	
	                // a. Let Pk be ToString(k).
	                //   This is implicit for LHS operands of the in operator
	                // b. Let kPresent be the result of calling the HasProperty internal
	                //    method of O with argument Pk.
	                //   This step can be combined with c
	                // c. If kPresent is true, then
	                if (k in O) {
	                    // i. Let kValue be the result of calling the Get internal
	                    //    method of O with argument Pk.
	                    kValue = O[k];
	
	                    // ii. Let mappedValue be the result of calling the Call internal
	                    //     method of callback with T as the this value and argument
	                    //     list containing kValue, k, and O.
	                    mappedValue = callback.call(T, kValue, k, O);
	
	                    // iii. Call the DefineOwnProperty internal method of A with arguments
	                    // Pk, Property Descriptor
	                    // { Value: mappedValue,
	                    //   Writable: true,
	                    //   Enumerable: true,
	                    //   Configurable: true },
	                    // and false.
	
	                    // In browsers that support Object.defineProperty, use the following:
	                    // Object.defineProperty(A, k, {
	                    //   value: mappedValue,
	                    //   writable: true,
	                    //   enumerable: true,
	                    //   configurable: true
	                    // });
	
	                    // For best browser support, use the following:
	                    A[k] = mappedValue;
	                }
	                // d. Increase k by 1.
	                k++;
	            }
	
	            // 9. return A
	            return A;
	        };
	    }
	
	    //                Array.prototype.forEach
	    // ========================================================
	    // SOURCE:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	    // Production steps of ECMA-262, Edition 5, 15.4.4.18
	    // Reference: http://es5.github.io/#x15.4.4.18
	    if (!Array.prototype.forEach) {
	        Array.prototype.forEach = function (callback, thisArg) {
	            var T = void 0,
	                k = void 0;
	
	            if (this === null || this === undefined) {
	                throw new TypeError(' this is null or not defined');
	            }
	
	            // 1. Let O be the result of calling ToObject passing the |this| value as the
	            // argument.
	            var O = Object(this);
	
	            // 2. Let lenValue be the result of calling the Get internal method of O with the
	            // argument "length".
	            // 3. Let len be ToUint32(lenValue).
	            var len = O.length >>> 0;
	
	            // 4. If IsCallable(callback) is false, throw a TypeError exception.
	            // See: http://es5.github.com/#x9.11
	            if (typeof callback !== "function") {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
	            if (arguments.length > 1) {
	                T = thisArg;
	            }
	
	            // 6. Let k be 0
	            k = 0;
	
	            // 7. Repeat, while k < len
	            while (k < len) {
	                var kValue;
	
	                // a. Let Pk be ToString(k).
	                //   This is implicit for LHS operands of the in operator
	                // b. Let kPresent be the result of calling the HasProperty internal
	                //    method of O with
	                //    argument Pk.
	                //   This step can be combined with c
	                // c. If kPresent is true, then
	                if (k in O) {
	                    // i. Let kValue be the result of calling the Get internal method of O with
	                    // argument Pk
	                    kValue = O[k];
	
	                    // ii. Call the Call internal method of callback with T as the this value and
	                    // argument list containing kValue, k, and O.
	                    callback.call(T, kValue, k, O);
	                }
	                // d. Increase k by 1.
	                k++;
	            }
	            // 8. return undefined
	        };
	    }
	};
	
	/**
	 * Inherit the prototype methods from one constructor into another. This is a
	 * port of the Node.js implementation with an Object.create polyfill.
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	module.exports.inherits = function (ctor, superCtor) {
	    // Add Object.create polyfill for IE8
	    // Source:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript
	    // /Reference/Global_Objects/Object/create#Polyfill
	    if (typeof Object.create != 'function') {
	        // Production steps of ECMA-262, Edition 5, 15.2.3.5
	        // Reference: http://es5.github.io/#x15.2.3.5
	        Object.create = function () {
	            // To save on memory, use a shared constructor
	            function Temp() {}
	
	            // make a safe reference to Object.prototype.hasOwnProperty
	            var hasOwn = Object.prototype.hasOwnProperty;
	
	            return function (O) {
	                // 1. If Type(O) is not Object or Null throw a TypeError exception.
	                if ((typeof O === "undefined" ? "undefined" : _typeof(O)) != 'object') {
	                    throw new TypeError('Object prototype may only be an Object or null');
	                }
	
	                // 2. Let obj be the result of creating a new object as if by the
	                //    expression new Object() where Object is the standard built-in
	                //    constructor with that name
	                // 3. Set the [[Prototype]] internal property of obj to O.
	                Temp.prototype = O;
	                var obj = new Temp();
	                Temp.prototype = null; // Let's not keep a stray reference to O...
	
	                // 4. If the argument Properties is present and not undefined, add
	                //    own properties to obj as if by calling the standard built-in
	                //    function Object.defineProperties with arguments obj and
	                //    Properties.
	                if (arguments.length > 1) {
	                    // Object.defineProperties does ToObject on its first argument.
	                    var Properties = Object(arguments[1]);
	                    for (var prop in Properties) {
	                        if (hasOwn.call(Properties, prop)) {
	                            obj[prop] = Properties[prop];
	                        }
	                    }
	                }
	
	                // 5. Return obj
	                return obj;
	            };
	        }();
	    }
	    // END polyfill
	
	    // Add util.inherits from Node.js
	    // Source:
	    // https://github.com/joyent/node/blob/master/lib/util.js
	    // Copyright Joyent, Inc. and other Node contributors.
	    //
	    // Permission is hereby granted, free of charge, to any person obtaining a
	    // copy of this software and associated documentation files (the
	    // "Software"), to deal in the Software without restriction, including
	    // without limitation the rights to use, copy, modify, merge, publish,
	    // distribute, sublicense, and/or sell copies of the Software, and to permit
	    // persons to whom the Software is furnished to do so, subject to the
	    // following conditions:
	    //
	    // The above copyright notice and this permission notice shall be included
	    // in all copies or substantial portions of the Software.
	    //
	    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	    // USE OR OTHER DEALINGS IN THE SOFTWARE.
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	            value: ctor,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1453);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(623);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(178);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(123);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(123);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorState
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlockTree = __webpack_require__(426);
	var ContentState = __webpack_require__(286);
	var EditorBidiService = __webpack_require__(940);
	var Immutable = __webpack_require__(26);
	var SelectionState = __webpack_require__(133);
	
	var OrderedSet = Immutable.OrderedSet;
	var Record = Immutable.Record;
	var Stack = Immutable.Stack;
	
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = function () {
	  EditorState.createEmpty = function createEmpty(decorator) {
	    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
	  };
	
	  EditorState.createWithContent = function createWithContent(contentState, decorator) {
	    var firstKey = contentState.getBlockMap().first().getKey();
	    return EditorState.create({
	      currentContent: contentState,
	      undoStack: Stack(),
	      redoStack: Stack(),
	      decorator: decorator || null,
	      selection: SelectionState.createEmpty(firstKey)
	    });
	  };
	
	  EditorState.create = function create(config) {
	    var currentContent = config.currentContent;
	    var decorator = config.decorator;
	
	    var recordConfig = _extends({}, config, {
	      treeMap: generateNewTreeMap(currentContent, decorator),
	      directionMap: EditorBidiService.getDirectionMap(currentContent)
	    });
	    return new EditorState(new EditorStateRecord(recordConfig));
	  };
	
	  EditorState.set = function set(editorState, put) {
	    var map = editorState.getImmutable().withMutations(function (state) {
	      var existingDecorator = state.get('decorator');
	      var decorator = existingDecorator;
	      if (put.decorator === null) {
	        decorator = null;
	      } else if (put.decorator) {
	        decorator = put.decorator;
	      }
	
	      var newContent = put.currentContent || editorState.getCurrentContent();
	
	      if (decorator !== existingDecorator) {
	        var treeMap = state.get('treeMap');
	        var newTreeMap;
	        if (decorator && existingDecorator) {
	          newTreeMap = regenerateTreeForNewDecorator(newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	        } else {
	          newTreeMap = generateNewTreeMap(newContent, decorator);
	        }
	
	        state.merge({
	          decorator: decorator,
	          treeMap: newTreeMap,
	          nativelyRenderedContent: null
	        });
	        return;
	      }
	
	      var existingContent = editorState.getCurrentContent();
	      if (newContent !== existingContent) {
	        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), decorator));
	      }
	
	      state.merge(put);
	    });
	
	    return new EditorState(map);
	  };
	
	  EditorState.prototype.toJS = function toJS() {
	    return this.getImmutable().toJS();
	  };
	
	  EditorState.prototype.getAllowUndo = function getAllowUndo() {
	    return this.getImmutable().get('allowUndo');
	  };
	
	  EditorState.prototype.getCurrentContent = function getCurrentContent() {
	    return this.getImmutable().get('currentContent');
	  };
	
	  EditorState.prototype.getUndoStack = function getUndoStack() {
	    return this.getImmutable().get('undoStack');
	  };
	
	  EditorState.prototype.getRedoStack = function getRedoStack() {
	    return this.getImmutable().get('redoStack');
	  };
	
	  EditorState.prototype.getSelection = function getSelection() {
	    return this.getImmutable().get('selection');
	  };
	
	  EditorState.prototype.getDecorator = function getDecorator() {
	    return this.getImmutable().get('decorator');
	  };
	
	  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
	    return this.getImmutable().get('inCompositionMode');
	  };
	
	  EditorState.prototype.mustForceSelection = function mustForceSelection() {
	    return this.getImmutable().get('forceSelection');
	  };
	
	  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
	    return this.getImmutable().get('nativelyRenderedContent');
	  };
	
	  EditorState.prototype.getLastChangeType = function getLastChangeType() {
	    return this.getImmutable().get('lastChangeType');
	  };
	
	  /**
	   * While editing, the user may apply inline style commands with a collapsed
	   * cursor, intending to type text that adopts the specified style. In this
	   * case, we track the specified style as an "override" that takes precedence
	   * over the inline style of the text adjacent to the cursor.
	   *
	   * If null, there is no override in place.
	   */
	
	
	  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
	    return this.getImmutable().get('inlineStyleOverride');
	  };
	
	  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
	    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
	  };
	
	  /**
	   * Get the appropriate inline style for the editor state. If an
	   * override is in place, use it. Otherwise, the current style is
	   * based on the location of the selection state.
	   */
	
	
	  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
	    var override = this.getInlineStyleOverride();
	    if (override != null) {
	      return override;
	    }
	
	    var content = this.getCurrentContent();
	    var selection = this.getSelection();
	
	    if (selection.isCollapsed()) {
	      return getInlineStyleForCollapsedSelection(content, selection);
	    }
	
	    return getInlineStyleForNonCollapsedSelection(content, selection);
	  };
	
	  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
	    return this.getImmutable().getIn(['treeMap', blockKey]);
	  };
	
	  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
	    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	  };
	
	  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
	    var content = this.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var last = blockMap.last();
	    var end = last.getLength();
	    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	  };
	
	  EditorState.prototype.getDirectionMap = function getDirectionMap() {
	    return this.getImmutable().get('directionMap');
	  };
	
	  /**
	   * Incorporate native DOM selection changes into the EditorState. This
	   * method can be used when we simply want to accept whatever the DOM
	   * has given us to represent selection, and we do not need to re-render
	   * the editor.
	   *
	   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	   */
	
	
	  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
	    return updateSelection(editorState, selection, false);
	  };
	
	  /**
	   * At times, we need to force the DOM selection to be where we
	   * need it to be. This can occur when the anchor or focus nodes
	   * are non-text nodes, for instance. In this case, we want to trigger
	   * a re-render of the editor, which in turn forces selection into
	   * the correct place in the DOM. The `forceSelection` method
	   * accomplishes this.
	   *
	   * This method should be used in cases where you need to explicitly
	   * move the DOM selection from one place to another without a change
	   * in ContentState.
	   */
	
	
	  EditorState.forceSelection = function forceSelection(editorState, selection) {
	    if (!selection.getHasFocus()) {
	      selection = selection.set('hasFocus', true);
	    }
	    return updateSelection(editorState, selection, true);
	  };
	
	  /**
	   * Move selection to the end of the editor without forcing focus.
	   */
	
	
	  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	    var content = editorState.getCurrentContent();
	    var lastBlock = content.getLastBlock();
	    var lastKey = lastBlock.getKey();
	    var length = lastBlock.getLength();
	
	    return EditorState.acceptSelection(editorState, new SelectionState({
	      anchorKey: lastKey,
	      anchorOffset: length,
	      focusKey: lastKey,
	      focusOffset: length,
	      isBackward: false
	    }));
	  };
	
	  /**
	   * Force focus to the end of the editor. This is useful in scenarios
	   * where we want to programmatically focus the input and it makes sense
	   * to allow the user to continue working seamlessly.
	   */
	
	
	  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
	    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	  };
	
	  /**
	   * Push the current ContentState onto the undo stack if it should be
	   * considered a boundary state, and set the provided ContentState as the
	   * new current content.
	   */
	
	
	  EditorState.push = function push(editorState, contentState, changeType) {
	    if (editorState.getCurrentContent() === contentState) {
	      return editorState;
	    }
	
	    var forceSelection = changeType !== 'insert-characters';
	    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	    if (!editorState.getAllowUndo()) {
	      return EditorState.set(editorState, {
	        currentContent: contentState,
	        directionMap: directionMap,
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: null
	      });
	    }
	
	    var selection = editorState.getSelection();
	    var currentContent = editorState.getCurrentContent();
	    var undoStack = editorState.getUndoStack();
	    var newContent = contentState;
	
	    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	      undoStack = undoStack.push(currentContent);
	      newContent = newContent.set('selectionBefore', selection);
	    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	      // Preserve the previous selection.
	      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	    }
	
	    var inlineStyleOverride = editorState.getInlineStyleOverride();
	
	    // Don't discard inline style overrides on block type or depth changes.
	    if (changeType !== 'adjust-depth' && changeType !== 'change-block-type') {
	      inlineStyleOverride = null;
	    }
	
	    var editorStateChanges = {
	      currentContent: newContent,
	      directionMap: directionMap,
	      undoStack: undoStack,
	      redoStack: Stack(),
	      lastChangeType: changeType,
	      selection: contentState.getSelectionAfter(),
	      forceSelection: forceSelection,
	      inlineStyleOverride: inlineStyleOverride
	    };
	
	    return EditorState.set(editorState, editorStateChanges);
	  };
	
	  /**
	   * Make the top ContentState in the undo stack the new current content and
	   * push the current content onto the redo stack.
	   */
	
	
	  EditorState.undo = function undo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var undoStack = editorState.getUndoStack();
	    var newCurrentContent = undoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: undoStack.shift(),
	      redoStack: editorState.getRedoStack().push(currentContent),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'undo',
	      nativelyRenderedContent: null,
	      selection: currentContent.getSelectionBefore()
	    });
	  };
	
	  /**
	   * Make the top ContentState in the redo stack the new current content and
	   * push the current content onto the undo stack.
	   */
	
	
	  EditorState.redo = function redo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var redoStack = editorState.getRedoStack();
	    var newCurrentContent = redoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: editorState.getUndoStack().push(currentContent),
	      redoStack: redoStack.shift(),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'redo',
	      nativelyRenderedContent: null,
	      selection: newCurrentContent.getSelectionAfter()
	    });
	  };
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  function EditorState(immutable) {
	    _classCallCheck(this, EditorState);
	
	    this._immutable = immutable;
	  }
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  EditorState.prototype.getImmutable = function getImmutable() {
	    return this._immutable;
	  };
	
	  return EditorState;
	}();
	
	/**
	 * Set the supplied SelectionState as the new current selection, and set
	 * the `force` flag to trigger manual selection placement by the view.
	 */
	
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }).toOrderedMap();
	}
	
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	function regenerateTreeForNewBlocks(editorState, newBlockMap, decorator) {
	  var prevBlockMap = editorState.getCurrentContent().getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }));
	}
	
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	function regenerateTreeForNewDecorator(blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block) !== existingDecorator.getDecorations(block);
	  }).map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }));
	}
	
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If there is a character just inside the selection, use its style.
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  }
	
	  // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var previousBlock = content.getBlockBefore(fromKey);
	  var previousLength;
	
	  while (previousBlock) {
	    previousLength = previousBlock.getLength();
	    if (previousLength) {
	      return previousBlock.getInlineStyleAt(previousLength - 1);
	    }
	    previousBlock = content.getBlockBefore(previousBlock.getKey());
	  }
	
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var matrixcs = __webpack_require__(1143);
	matrixcs.request(__webpack_require__(97));
	module.exports = matrixcs; // keep export for browserify package deps
	global.matrixcs = matrixcs;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(196)('wks')
	  , uid        = __webpack_require__(109)
	  , Symbol     = __webpack_require__(13).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(96);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = AccessibleButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AccessibleButton is a generic wrapper for any element that should be treated
	 * as a button.  Identifies the element as a button, setting proper tab
	 * indexing and keyboard activation behavior.
	 *
	 * @param {Object} props  react element properties
	 * @returns {Object} rendered react
	 */
	function AccessibleButton(props) {
	    var element = props.element,
	        onClick = props.onClick,
	        children = props.children,
	        restProps = (0, _objectWithoutProperties3.default)(props, ["element", "onClick", "children"]);
	
	    restProps.onClick = onClick;
	    restProps.onKeyUp = function (e) {
	        if (e.keyCode == 13 || e.keyCode == 32) return onClick(e);
	    };
	    restProps.tabIndex = restProps.tabIndex || "0";
	    restProps.role = "button";
	    return _react2.default.createElement(element, restProps, children);
	}
	
	/**
	 * children: React's magic prop. Represents all children given to the element.
	 * element:  (optional) The base element type. "div" by default.
	 * onClick:  (required) Event handler for button activation. Should be
	 *           implemented exactly like a normal onClick handler.
	 */
	/*
	 Copyright 2016 Jani Mustonen
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */
	
	AccessibleButton.propTypes = {
	    children: _react2.default.PropTypes.node,
	    element: _react2.default.PropTypes.string,
	    onClick: _react2.default.PropTypes.func.isRequired
	};
	
	AccessibleButton.defaultProps = {
	    element: 'div'
	};
	
	AccessibleButton.displayName = "AccessibleButton";
	module.exports = exports["default"];


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(17)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(11)
	  , IE8_DOM_DEFINE = __webpack_require__(401)
	  , toPrimitive    = __webpack_require__(69)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(31) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMProperty = __webpack_require__(144);
	var ReactDOMComponentFlags = __webpack_require__(536);
	
	var invariant = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(638), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(91)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(61);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(640), __esModule: true };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(251)('wks')
	  , uid        = __webpack_require__(185)
	  , Symbol     = __webpack_require__(53).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftModifier
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(63);
	var ContentStateInlineStyle = __webpack_require__(929);
	var Immutable = __webpack_require__(26);
	
	var applyEntityToContentState = __webpack_require__(945);
	var getCharacterRemovalRange = __webpack_require__(966);
	var getContentStateFragment = __webpack_require__(202);
	var insertFragmentIntoContentState = __webpack_require__(971);
	var insertTextIntoContentState = __webpack_require__(972);
	var invariant = __webpack_require__(7);
	var modifyBlockForContentState = __webpack_require__(983);
	var removeEntitiesAtEdges = __webpack_require__(444);
	var removeRangeFromContentState = __webpack_require__(984);
	var splitBlockInContentState = __webpack_require__(986);
	
	var OrderedSet = Immutable.OrderedSet;
	
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
	  },
	
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	    if (rangeToRemove.getAnchorKey() === rangeToRemove.getFocusKey()) {
	      var key = rangeToRemove.getAnchorKey();
	      var startOffset = rangeToRemove.getStartOffset();
	      var endOffset = rangeToRemove.getEndOffset();
	      var block = contentState.getBlockForKey(key);
	
	      var startEntity = block.getEntityAt(startOffset);
	      var endEntity = block.getEntityAt(endOffset - 1);
	      if (startEntity && startEntity === endEntity) {
	        var adjustedRemovalRange = getCharacterRemovalRange(block, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, adjustedRemovalRange);
	      }
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
	    return removeRangeFromContentState(withoutEntities, rangeToRemove);
	  },
	
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ type: blockType, depth: 0 });
	    });
	  },
	
	  setBlockData: function setBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: blockData });
	    });
	  },
	
	  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: block.getData().merge(blockData) });
	    });
	  },
	
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	
	module.exports = DraftModifier;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(177);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(53)
	  , core      = __webpack_require__(21)
	  , ctx       = __webpack_require__(125)
	  , hide      = __webpack_require__(99)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(32)
	  , createDesc = __webpack_require__(90);
	module.exports = __webpack_require__(31) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(13)
	  , hide      = __webpack_require__(48)
	  , has       = __webpack_require__(40)
	  , SRC       = __webpack_require__(109)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(80).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(17)
	  , defined = __webpack_require__(61)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(156)
	  , defined = __webpack_require__(61);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(157)
	  , createDesc     = __webpack_require__(90)
	  , toIObject      = __webpack_require__(51)
	  , toPrimitive    = __webpack_require__(69)
	  , has            = __webpack_require__(40)
	  , IE8_DOM_DEFINE = __webpack_require__(401)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(31) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(40)
	  , toObject    = __webpack_require__(36)
	  , IE_PROTO    = __webpack_require__(273)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1523);


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(17);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CharacterMetadata
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(26);
	
	var Map = _require.Map;
	var OrderedSet = _require.OrderedSet;
	var Record = _require.Record;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = function (_CharacterMetadataRec) {
	  _inherits(CharacterMetadata, _CharacterMetadataRec);
	
	  function CharacterMetadata() {
	    _classCallCheck(this, CharacterMetadata);
	
	    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
	  }
	
	  CharacterMetadata.prototype.getStyle = function getStyle() {
	    return this.get('style');
	  };
	
	  CharacterMetadata.prototype.getEntity = function getEntity() {
	    return this.get('entity');
	  };
	
	  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
	    return this.getStyle().has(style);
	  };
	
	  CharacterMetadata.applyStyle = function applyStyle(record, style) {
	    var withStyle = record.set('style', record.getStyle().add(style));
	    return CharacterMetadata.create(withStyle);
	  };
	
	  CharacterMetadata.removeStyle = function removeStyle(record, style) {
	    var withoutStyle = record.set('style', record.getStyle().remove(style));
	    return CharacterMetadata.create(withoutStyle);
	  };
	
	  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
	    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	    return CharacterMetadata.create(withEntity);
	  };
	
	  /**
	   * Use this function instead of the `CharacterMetadata` constructor.
	   * Since most content generally uses only a very small number of
	   * style/entity permutations, we can reuse these objects as often as
	   * possible.
	   */
	
	
	  CharacterMetadata.create = function create(config) {
	    if (!config) {
	      return EMPTY;
	    }
	
	    // Fill in unspecified properties, if necessary.
	    var configMap = Map({ style: EMPTY_SET, entity: null }).merge(config);
	
	    var existing = pool.get(configMap);
	    if (existing) {
	      return existing;
	    }
	
	    var newCharacter = new CharacterMetadata(configMap);
	    pool = pool.set(configMap, newCharacter);
	    return newCharacter;
	  };
	
	  return CharacterMetadata;
	}(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	
	CharacterMetadata.EMPTY = EMPTY;
	
	module.exports = CharacterMetadata;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(45)
	  , core    = __webpack_require__(21)
	  , fails   = __webpack_require__(126);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(81)
	  , IObject  = __webpack_require__(156)
	  , toObject = __webpack_require__(36)
	  , toLength = __webpack_require__(35)
	  , asc      = __webpack_require__(710);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3)
	  , core    = __webpack_require__(80)
	  , fails   = __webpack_require__(17);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(25);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule generateRandomKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key = void 0;
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var UserAgentData = __webpack_require__(995);
	var VersionRange = __webpack_require__(996);
	
	var mapObject = __webpack_require__(1009);
	var memoizeStringOnly = __webpack_require__(455);
	
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  }
	
	  // check for non-matching names
	  if (!query.startsWith(name)) {
	    return false;
	  }
	
	  // full comparison with version
	  var range = query.slice(name.length);
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/*
	 * Manages a list of all the currently active calls.
	 *
	 * This handler dispatches when voip calls are added/updated/removed from this list:
	 * {
	 *   action: 'call_state'
	 *   room_id: <room ID of the call>
	 * }
	 *
	 * To know the state of the call, this handler exposes a getter to
	 * obtain the call for a room:
	 *   var call = CallHandler.getCall(roomId)
	 *   var state = call.call_state; // ringing|ringback|connected|ended|busy|stop_ringback|stop_ringing
	 *
	 * This handler listens for and handles the following actions:
	 * {
	 *   action: 'place_call',
	 *   type: 'voice|video',
	 *   room_id: <room that the place call button was pressed in>
	 * }
	 *
	 * {
	 *   action: 'incoming_call'
	 *   call: MatrixCall
	 * }
	 *
	 * {
	 *   action: 'hangup'
	 *   room_id: <room that the hangup button was pressed in>
	 * }
	 *
	 * {
	 *   action: 'answer'
	 *   room_id: <room that the answer button was pressed in>
	 * }
	 */
	
	var MatrixClientPeg = __webpack_require__(4);
	var PlatformPeg = __webpack_require__(93);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	var Matrix = __webpack_require__(28);
	var dis = __webpack_require__(5);
	
	global.mxCalls = {
	    //room_id: MatrixCall
	};
	var calls = global.mxCalls;
	var ConferenceHandler = null;
	
	var audioPromises = {};
	
	function play(audioId) {
	    // TODO: Attach an invisible element for this instead
	    // which listens?
	    var audio = document.getElementById(audioId);
	    if (audio) {
	        if (audioPromises[audioId]) {
	            audioPromises[audioId] = audioPromises[audioId].then(function () {
	                audio.load();
	                return audio.play();
	            });
	        } else {
	            audioPromises[audioId] = audio.play();
	        }
	    }
	}
	
	function pause(audioId) {
	    // TODO: Attach an invisible element for this instead
	    // which listens?
	    var audio = document.getElementById(audioId);
	    if (audio) {
	        if (audioPromises[audioId]) {
	            audioPromises[audioId] = audioPromises[audioId].then(function () {
	                return audio.pause();
	            });
	        } else {
	            // pause doesn't actually return a promise, but might as well do this for symmetry with play();
	            audioPromises[audioId] = audio.pause();
	        }
	    }
	}
	
	function _setCallListeners(call) {
	    call.on("error", function (err) {
	        console.error("Call error: %s", err);
	        console.error(err.stack);
	        call.hangup();
	        _setCallState(undefined, call.roomId, "ended");
	    });
	    call.on('send_event_error', function (err) {
	        if (err.name === "UnknownDeviceError") {
	            dis.dispatch({
	                action: 'unknown_device_error',
	                err: err,
	                room: MatrixClientPeg.get().getRoom(call.roomId)
	            });
	        }
	    });
	    call.on("hangup", function () {
	        _setCallState(undefined, call.roomId, "ended");
	    });
	    // map web rtc states to dummy UI state
	    // ringing|ringback|connected|ended|busy|stop_ringback|stop_ringing
	    call.on("state", function (newState, oldState) {
	        if (newState === "ringing") {
	            _setCallState(call, call.roomId, "ringing");
	            pause("ringbackAudio");
	        } else if (newState === "invite_sent") {
	            _setCallState(call, call.roomId, "ringback");
	            play("ringbackAudio");
	        } else if (newState === "ended" && oldState === "connected") {
	            _setCallState(undefined, call.roomId, "ended");
	            pause("ringbackAudio");
	            play("callendAudio");
	        } else if (newState === "ended" && oldState === "invite_sent" && (call.hangupParty === "remote" || call.hangupParty === "local" && call.hangupReason === "invite_timeout")) {
	            _setCallState(call, call.roomId, "busy");
	            pause("ringbackAudio");
	            play("busyAudio");
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Call Timeout",
	                description: "The remote side failed to pick up."
	            });
	        } else if (oldState === "invite_sent") {
	            _setCallState(call, call.roomId, "stop_ringback");
	            pause("ringbackAudio");
	        } else if (oldState === "ringing") {
	            _setCallState(call, call.roomId, "stop_ringing");
	            pause("ringbackAudio");
	        } else if (newState === "connected") {
	            _setCallState(call, call.roomId, "connected");
	            pause("ringbackAudio");
	        }
	    });
	}
	
	function _setCallState(call, roomId, status) {
	    console.log("Call state in %s changed to %s (%s)", roomId, status, call ? call.call_state : "-");
	    calls[roomId] = call;
	
	    if (status === "ringing") {
	        play("ringAudio");
	    } else if (call && call.call_state === "ringing") {
	        pause("ringAudio");
	    }
	
	    if (call) {
	        call.call_state = status;
	    }
	    dis.dispatch({
	        action: 'call_state',
	        room_id: roomId
	    });
	}
	
	function _onAction(payload) {
	    function placeCall(newCall) {
	        _setCallListeners(newCall);
	        _setCallState(newCall, newCall.roomId, "ringback");
	        if (payload.type === 'voice') {
	            newCall.placeVoiceCall();
	        } else if (payload.type === 'video') {
	            newCall.placeVideoCall(payload.remote_element, payload.local_element);
	        } else if (payload.type === 'screensharing') {
	            var screenCapErrorString = PlatformPeg.get().screenCaptureErrorString();
	            if (screenCapErrorString) {
	                _setCallState(undefined, newCall.roomId, "ended");
	                console.log("Can't capture screen: " + screenCapErrorString);
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Unable to capture screen",
	                    description: screenCapErrorString
	                });
	                return;
	            }
	            newCall.placeScreenSharingCall(payload.remote_element, payload.local_element);
	        } else {
	            console.error("Unknown conf call type: %s", payload.type);
	        }
	    }
	
	    switch (payload.action) {
	        case 'place_call':
	            if (module.exports.getAnyActiveCall()) {
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Existing Call",
	                    description: "You are already in a call."
	                });
	                return; // don't allow >1 call to be placed.
	            }
	
	            // if the runtime env doesn't do VoIP, whine.
	            if (!MatrixClientPeg.get().supportsVoip()) {
	                var _ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(_ErrorDialog, {
	                    title: "VoIP is unsupported",
	                    description: "You cannot place VoIP calls in this browser."
	                });
	                return;
	            }
	
	            var room = MatrixClientPeg.get().getRoom(payload.room_id);
	            if (!room) {
	                console.error("Room %s does not exist.", payload.room_id);
	                return;
	            }
	
	            var members = room.getJoinedMembers();
	            if (members.length <= 1) {
	                var _ErrorDialog2 = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(_ErrorDialog2, {
	                    description: "You cannot place a call with yourself."
	                });
	                return;
	            } else if (members.length === 2) {
	                console.log("Place %s call in %s", payload.type, payload.room_id);
	                var call = Matrix.createNewMatrixCall(MatrixClientPeg.get(), payload.room_id);
	                placeCall(call);
	            } else {
	                // > 2
	                dis.dispatch({
	                    action: "place_conference_call",
	                    room_id: payload.room_id,
	                    type: payload.type,
	                    remote_element: payload.remote_element,
	                    local_element: payload.local_element
	                });
	            }
	            break;
	        case 'place_conference_call':
	            console.log("Place conference call in %s", payload.room_id);
	            if (!ConferenceHandler) {
	                var _ErrorDialog3 = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(_ErrorDialog3, {
	                    description: "Conference calls are not supported in this client"
	                });
	            } else if (!MatrixClientPeg.get().supportsVoip()) {
	                var _ErrorDialog4 = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(_ErrorDialog4, {
	                    title: "VoIP is unsupported",
	                    description: "You cannot place VoIP calls in this browser."
	                });
	            } else if (MatrixClientPeg.get().isRoomEncrypted(payload.room_id)) {
	                // Conference calls are implemented by sending the media to central
	                // server which combines the audio from all the participants together
	                // into a single stream. This is incompatible with end-to-end encryption
	                // because a central server would be decrypting the audio for each
	                // participant.
	                // Therefore we disable conference calling in E2E rooms.
	                var _ErrorDialog5 = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(_ErrorDialog5, {
	                    description: "Conference calls are not supported in encrypted rooms"
	                });
	            } else {
	                var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	                Modal.createDialog(QuestionDialog, {
	                    title: "Warning!",
	                    description: "Conference calling is in development and may not be reliable.",
	                    onFinished: function onFinished(confirm) {
	                        if (confirm) {
	                            ConferenceHandler.createNewMatrixCall(MatrixClientPeg.get(), payload.room_id).done(function (call) {
	                                placeCall(call);
	                            }, function (err) {
	                                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                                console.error("Conference call failed: " + err);
	                                Modal.createDialog(ErrorDialog, {
	                                    title: "Failed to set up conference call",
	                                    description: "Conference call failed."
	                                });
	                            });
	                        }
	                    }
	                });
	            }
	            break;
	        case 'incoming_call':
	            if (module.exports.getAnyActiveCall()) {
	                // ignore multiple incoming calls. in future, we may want a line-1/line-2 setup.
	                // we avoid rejecting with "busy" in case the user wants to answer it on a different device.
	                // in future we could signal a "local busy" as a warning to the caller.
	                // see https://github.com/vector-im/vector-web/issues/1964
	                return;
	            }
	
	            // if the runtime env doesn't do VoIP, stop here.
	            if (!MatrixClientPeg.get().supportsVoip()) {
	                return;
	            }
	
	            var call = payload.call;
	            _setCallListeners(call);
	            _setCallState(call, call.roomId, "ringing");
	            break;
	        case 'hangup':
	            if (!calls[payload.room_id]) {
	                return; // no call to hangup
	            }
	            calls[payload.room_id].hangup();
	            _setCallState(null, payload.room_id, "ended");
	            break;
	        case 'answer':
	            if (!calls[payload.room_id]) {
	                return; // no call to answer
	            }
	            calls[payload.room_id].answer();
	            _setCallState(calls[payload.room_id], payload.room_id, "connected");
	            dis.dispatch({
	                action: "view_room",
	                room_id: payload.room_id
	            });
	            break;
	    }
	}
	// FIXME: Nasty way of making sure we only register
	// with the dispatcher once
	if (!global.mxCallHandler) {
	    dis.register(_onAction);
	}
	
	var callHandler = {
	    getCallForRoom: function getCallForRoom(roomId) {
	        var call = module.exports.getCall(roomId);
	        if (call) return call;
	
	        if (ConferenceHandler) {
	            call = ConferenceHandler.getConferenceCallForRoom(roomId);
	        }
	        if (call) return call;
	
	        return null;
	    },
	
	    getCall: function getCall(roomId) {
	        return calls[roomId] || null;
	    },
	
	    getAnyActiveCall: function getAnyActiveCall() {
	        var roomsWithCalls = (0, _keys2.default)(calls);
	        for (var i = 0; i < roomsWithCalls.length; i++) {
	            if (calls[roomsWithCalls[i]] && calls[roomsWithCalls[i]].call_state !== "ended") {
	                return calls[roomsWithCalls[i]];
	            }
	        }
	        return null;
	    },
	
	    setConferenceHandler: function setConferenceHandler(confHandler) {
	        ConferenceHandler = confHandler;
	    },
	
	    getConferenceHandler: function getConferenceHandler() {
	        return ConferenceHandler;
	    }
	};
	// Only things in here which actually need to be global are the
	// calls list (done separately) and making sure we only register
	// with the dispatcher once (which uses this mechanism but checks
	// separately). This could be tidied up.
	if (global.mxCallHandler === undefined) {
	    global.mxCallHandler = callHandler;
	}
	
	module.exports = global.mxCallHandler;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var q = __webpack_require__(6);
	var MatrixClientPeg = __webpack_require__(4);
	var Notifier = __webpack_require__(170);
	
	/*
	 * TODO: Make things use this. This is all WIP - see UserSettings.js for usage.
	 */
	
	module.exports = {
	    LABS_FEATURES: [{
	        name: 'New Composer & Autocomplete',
	        id: 'rich_text_editor',
	        default: false
	    }],
	
	    loadProfileInfo: function loadProfileInfo() {
	        var cli = MatrixClientPeg.get();
	        return cli.getProfileInfo(cli.credentials.userId);
	    },
	
	    saveDisplayName: function saveDisplayName(newDisplayname) {
	        return MatrixClientPeg.get().setDisplayName(newDisplayname);
	    },
	
	    loadThreePids: function loadThreePids() {
	        if (MatrixClientPeg.get().isGuest()) {
	            return q({
	                threepids: []
	            }); // guests can't poke 3pid endpoint
	        }
	        return MatrixClientPeg.get().getThreePids();
	    },
	
	    saveThreePids: function saveThreePids(threePids) {
	        // TODO
	    },
	
	    getEnableNotifications: function getEnableNotifications() {
	        return Notifier.isEnabled();
	    },
	
	    setEnableNotifications: function setEnableNotifications(enable) {
	        if (!Notifier.supportsDesktopNotifications()) {
	            return;
	        }
	        Notifier.setEnabled(enable);
	    },
	
	    getEnableAudioNotifications: function getEnableAudioNotifications() {
	        return Notifier.isAudioEnabled();
	    },
	
	    setEnableAudioNotifications: function setEnableAudioNotifications(enable) {
	        Notifier.setAudioEnabled(enable);
	    },
	
	    changePassword: function changePassword(old_password, new_password) {
	        var cli = MatrixClientPeg.get();
	
	        var authDict = {
	            type: 'm.login.password',
	            user: cli.credentials.userId,
	            password: old_password
	        };
	
	        return cli.setPassword(authDict, new_password);
	    },
	
	    /**
	     * Returns the email pusher (pusher of type 'email') for a given
	     * email address. Email pushers all have the same app ID, so since
	     * pushers are unique over (app ID, pushkey), there will be at most
	     * one such pusher.
	     */
	    getEmailPusher: function getEmailPusher(pushers, address) {
	        if (pushers === undefined) {
	            return undefined;
	        }
	        for (var i = 0; i < pushers.length; ++i) {
	            if (pushers[i].kind == 'email' && pushers[i].pushkey == address) {
	                return pushers[i];
	            }
	        }
	        return undefined;
	    },
	
	    hasEmailPusher: function hasEmailPusher(pushers, address) {
	        return this.getEmailPusher(pushers, address) !== undefined;
	    },
	
	    addEmailPusher: function addEmailPusher(address, data) {
	        return MatrixClientPeg.get().setPusher({
	            kind: 'email',
	            app_id: "m.email",
	            pushkey: address,
	            app_display_name: 'Email Notifications',
	            device_display_name: address,
	            lang: navigator.language,
	            data: data,
	            append: true });
	    },
	
	    getUrlPreviewsDisabled: function getUrlPreviewsDisabled() {
	        var event = MatrixClientPeg.get().getAccountData("org.matrix.preview_urls");
	        return event && event.getContent().disable;
	    },
	
	    setUrlPreviewsDisabled: function setUrlPreviewsDisabled(disabled) {
	        // FIXME: handle errors
	        return MatrixClientPeg.get().setAccountData("org.matrix.preview_urls", {
	            disable: disabled
	        });
	    },
	
	    getSyncedSettings: function getSyncedSettings() {
	        var event = MatrixClientPeg.get().getAccountData("im.vector.web.settings");
	        return event ? event.getContent() : {};
	    },
	
	    getSyncedSetting: function getSyncedSetting(type) {
	        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        var settings = this.getSyncedSettings();
	        return settings.hasOwnProperty(type) ? settings[type] : null;
	    },
	
	    setSyncedSetting: function setSyncedSetting(type, value) {
	        var settings = this.getSyncedSettings();
	        settings[type] = value;
	        // FIXME: handle errors
	        return MatrixClientPeg.get().setAccountData("im.vector.web.settings", settings);
	    },
	
	    getLocalSettings: function getLocalSettings() {
	        var localSettingsString = localStorage.getItem('mx_local_settings') || '{}';
	        return JSON.parse(localSettingsString);
	    },
	
	    getLocalSetting: function getLocalSetting(type) {
	        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        var settings = this.getLocalSettings();
	        return settings.hasOwnProperty(type) ? settings[type] : null;
	    },
	
	    setLocalSetting: function setLocalSetting(type, value) {
	        var settings = this.getLocalSettings();
	        settings[type] = value;
	        // FIXME: handle errors
	        localStorage.setItem('mx_local_settings', (0, _stringify2.default)(settings));
	    },
	
	    isFeatureEnabled: function isFeatureEnabled(feature) {
	        // Disable labs for guests.
	        if (MatrixClientPeg.get().isGuest()) return false;
	
	        if (localStorage.getItem("mx_labs_feature_" + feature) === null) {
	            for (var i = 0; i < this.LABS_FEATURES.length; i++) {
	                var f = this.LABS_FEATURES[i];
	                if (f.id === feature) {
	                    return f.default;
	                }
	            }
	        }
	        return localStorage.getItem("mx_labs_feature_" + feature) === 'true';
	    },
	
	    setFeatureEnabled: function setFeatureEnabled(feature, enabled) {
	        localStorage.setItem("mx_labs_feature_" + feature, enabled);
	    }
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(22);
	
	var CallbackQueue = __webpack_require__(534);
	var PooledClass = __webpack_require__(120);
	var ReactFeatureFlags = __webpack_require__(539);
	var ReactReconciler = __webpack_require__(145);
	var Transaction = __webpack_require__(229);
	
	var invariant = __webpack_require__(7);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(126)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(76)
	  , IE8_DOM_DEFINE = __webpack_require__(379)
	  , toPrimitive    = __webpack_require__(254)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(77) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(380)
	  , defined = __webpack_require__(244);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(47);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(417)
	  , $export = __webpack_require__(3)
	  , shared  = __webpack_require__(196)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(420)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(31)){
	  var LIBRARY             = __webpack_require__(102)
	    , global              = __webpack_require__(13)
	    , fails               = __webpack_require__(17)
	    , $export             = __webpack_require__(3)
	    , $typed              = __webpack_require__(197)
	    , $buffer             = __webpack_require__(280)
	    , ctx                 = __webpack_require__(81)
	    , anInstance          = __webpack_require__(101)
	    , propertyDesc        = __webpack_require__(90)
	    , hide                = __webpack_require__(48)
	    , redefineAll         = __webpack_require__(106)
	    , toInteger           = __webpack_require__(91)
	    , toLength            = __webpack_require__(35)
	    , toIndex             = __webpack_require__(108)
	    , toPrimitive         = __webpack_require__(69)
	    , has                 = __webpack_require__(40)
	    , same                = __webpack_require__(414)
	    , classof             = __webpack_require__(155)
	    , isObject            = __webpack_require__(25)
	    , toObject            = __webpack_require__(36)
	    , isArrayIter         = __webpack_require__(265)
	    , create              = __webpack_require__(103)
	    , getPrototypeOf      = __webpack_require__(55)
	    , gOPN                = __webpack_require__(104).f
	    , getIterFn           = __webpack_require__(282)
	    , uid                 = __webpack_require__(109)
	    , wks                 = __webpack_require__(29)
	    , createArrayMethod   = __webpack_require__(67)
	    , createArrayIncludes = __webpack_require__(187)
	    , speciesConstructor  = __webpack_require__(274)
	    , ArrayIterators      = __webpack_require__(283)
	    , Iterators           = __webpack_require__(130)
	    , $iterDetect         = __webpack_require__(193)
	    , setSpecies          = __webpack_require__(107)
	    , arrayFill           = __webpack_require__(258)
	    , arrayCopyWithin     = __webpack_require__(394)
	    , $DP                 = __webpack_require__(32)
	    , $GOPD               = __webpack_require__(54)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntity
	 * @typechecks
	 * 
	 */
	
	var DraftEntityInstance = __webpack_require__(429);
	var Immutable = __webpack_require__(26);
	
	var invariant = __webpack_require__(7);
	
	var Map = Immutable.Map;
	
	
	var instances = Map();
	var instanceKey = 0;
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    return DraftEntity.add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    var key = '' + ++instanceKey;
	    instances = instances.set(key, instance);
	    return key;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key.') : invariant(false) : void 0;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    var instance = DraftEntity.get(key);
	    var newData = _extends({}, instance.getData(), toMerge);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    var instance = DraftEntity.get(key);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	
	module.exports = DraftEntity;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(475);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var PooledClass = __webpack_require__(120);
	
	var emptyFunction = __webpack_require__(43);
	var warning = __webpack_require__(14);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(626)
	var ieee754 = __webpack_require__(1019)
	var isArray = __webpack_require__(459)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(109)('meta')
	  , isObject = __webpack_require__(25)
	  , has      = __webpack_require__(40)
	  , setDesc  = __webpack_require__(32).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(17)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * This is an internal module. See {@link MatrixEvent} and {@link RoomEvent} for
	 * the public classes.
	 * @module models/event
	 */
	
	var EventEmitter = __webpack_require__(56).EventEmitter;
	
	var utils = __webpack_require__(16);
	
	/**
	 * Enum for event statuses.
	 * @readonly
	 * @enum {string}
	 */
	module.exports.EventStatus = {
	    /** The event was not sent and will no longer be retried. */
	    NOT_SENT: "not_sent",
	
	    /** The message is being encrypted */
	    ENCRYPTING: "encrypting",
	
	    /** The event is in the process of being sent. */
	    SENDING: "sending",
	    /** The event is in a queue waiting to be sent. */
	    QUEUED: "queued",
	    /** The event has been sent to the server, but we have not yet received the
	     * echo. */
	    SENT: "sent",
	
	    /** The event was cancelled before it was successfully sent. */
	    CANCELLED: "cancelled"
	};
	
	var interns = {};
	
	/**
	 * Construct a Matrix Event object
	 * @constructor
	 *
	 * @param {Object} event The raw event to be wrapped in this DAO
	 *
	 * @prop {Object} event The raw (possibly encrypted) event. <b>Do not access
	 * this property</b> directly unless you absolutely have to. Prefer the getter
	 * methods defined on this class. Using the getter methods shields your app
	 * from changes to event JSON between Matrix versions.
	 *
	 * @prop {RoomMember} sender The room member who sent this event, or null e.g.
	 * this is a presence event. This is only guaranteed to be set for events that
	 * appear in a timeline, ie. do not guarantee that it will be set on state
	 * events.
	 * @prop {RoomMember} target The room member who is the target of this event, e.g.
	 * the invitee, the person being banned, etc.
	 * @prop {EventStatus} status The sending status of the event.
	 * @prop {Error} error most recent error associated with sending the event, if any
	 * @prop {boolean} forwardLooking True if this event is 'forward looking', meaning
	 * that getDirectionalContent() will return event.content and not event.prev_content.
	 * Default: true. <strong>This property is experimental and may change.</strong>
	 */
	module.exports.MatrixEvent = function MatrixEvent(event) {
	    // intern the values of matrix events to force share strings and reduce the
	    // amount of needless string duplication. This can save moderate amounts of
	    // memory (~10% on a 350MB heap).
	    ["state_key", "type", "sender", "room_id"].forEach(function (prop) {
	        if (!event[prop]) {
	            return;
	        }
	        if (!interns[event[prop]]) {
	            interns[event[prop]] = event[prop];
	        }
	        event[prop] = interns[event[prop]];
	    });
	
	    ["membership", "avatar_url", "displayname"].forEach(function (prop) {
	        if (!event.content || !event.content[prop]) {
	            return;
	        }
	        if (!interns[event.content[prop]]) {
	            interns[event.content[prop]] = event.content[prop];
	        }
	        event.content[prop] = interns[event.content[prop]];
	    });
	
	    this.event = event || {};
	
	    this.sender = null;
	    this.target = null;
	    this.status = null;
	    this.error = null;
	    this.forwardLooking = true;
	    this._pushActions = null;
	    this._date = this.event.origin_server_ts ? new Date(this.event.origin_server_ts) : null;
	
	    this._clearEvent = {};
	    this._keysProved = {};
	    this._keysClaimed = {};
	};
	utils.inherits(module.exports.MatrixEvent, EventEmitter);
	
	utils.extend(module.exports.MatrixEvent.prototype, {
	
	    /**
	     * Get the event_id for this event.
	     * @return {string} The event ID, e.g. <code>$143350589368169JsLZx:localhost
	     * </code>
	     */
	    getId: function getId() {
	        return this.event.event_id;
	    },
	
	    /**
	     * Get the user_id for this event.
	     * @return {string} The user ID, e.g. <code>@alice:matrix.org</code>
	     */
	    getSender: function getSender() {
	        return this.event.sender || this.event.user_id; // v2 / v1
	    },
	
	    /**
	     * Get the (decrypted, if necessary) type of event.
	     *
	     * @return {string} The event type, e.g. <code>m.room.message</code>
	     */
	    getType: function getType() {
	        return this._clearEvent.type || this.event.type;
	    },
	
	    /**
	     * Get the (possibly encrypted) type of the event that will be sent to the
	     * homeserver.
	     *
	     * @return {string} The event type.
	     */
	    getWireType: function getWireType() {
	        return this.event.type;
	    },
	
	    /**
	     * Get the room_id for this event. This will return <code>undefined</code>
	     * for <code>m.presence</code> events.
	     * @return {string} The room ID, e.g. <code>!cURbafjkfsMDVwdRDQ:matrix.org
	     * </code>
	     */
	    getRoomId: function getRoomId() {
	        return this.event.room_id;
	    },
	
	    /**
	     * Get the timestamp of this event.
	     * @return {Number} The event timestamp, e.g. <code>1433502692297</code>
	     */
	    getTs: function getTs() {
	        return this.event.origin_server_ts;
	    },
	
	    /**
	     * Get the timestamp of this event, as a Date object.
	     * @return {Date} The event date, e.g. <code>new Date(1433502692297)</code>
	     */
	    getDate: function getDate() {
	        return this._date;
	    },
	
	    /**
	     * Get the (decrypted, if necessary) event content JSON.
	     *
	     * @return {Object} The event content JSON, or an empty object.
	     */
	    getContent: function getContent() {
	        return this._clearEvent.content || this.event.content || {};
	    },
	
	    /**
	     * Get the (possibly encrypted) event content JSON that will be sent to the
	     * homeserver.
	     *
	     * @return {Object} The event content JSON, or an empty object.
	     */
	    getWireContent: function getWireContent() {
	        return this.event.content || {};
	    },
	
	    /**
	     * Get the previous event content JSON. This will only return something for
	     * state events which exist in the timeline.
	     * @return {Object} The previous event content JSON, or an empty object.
	     */
	    getPrevContent: function getPrevContent() {
	        // v2 then v1 then default
	        return this.getUnsigned().prev_content || this.event.prev_content || {};
	    },
	
	    /**
	     * Get either 'content' or 'prev_content' depending on if this event is
	     * 'forward-looking' or not. This can be modified via event.forwardLooking.
	     * In practice, this means we get the chronologically earlier content value
	     * for this event (this method should surely be called getEarlierContent)
	     * <strong>This method is experimental and may change.</strong>
	     * @return {Object} event.content if this event is forward-looking, else
	     * event.prev_content.
	     */
	    getDirectionalContent: function getDirectionalContent() {
	        return this.forwardLooking ? this.getContent() : this.getPrevContent();
	    },
	
	    /**
	     * Get the age of this event. This represents the age of the event when the
	     * event arrived at the device, and not the age of the event when this
	     * function was called.
	     * @return {Number} The age of this event in milliseconds.
	     */
	    getAge: function getAge() {
	        return this.getUnsigned().age || this.event.age; // v2 / v1
	    },
	
	    /**
	     * Get the event state_key if it has one. This will return <code>undefined
	     * </code> for message events.
	     * @return {string} The event's <code>state_key</code>.
	     */
	    getStateKey: function getStateKey() {
	        return this.event.state_key;
	    },
	
	    /**
	     * Check if this event is a state event.
	     * @return {boolean} True if this is a state event.
	     */
	    isState: function isState() {
	        return this.event.state_key !== undefined;
	    },
	
	    /**
	     * Replace the content of this event with encrypted versions.
	     * (This is used when sending an event; it should not be used by applications).
	     *
	     * @internal
	     *
	     * @param {string} crypto_type type of the encrypted event - typically
	     * <tt>"m.room.encrypted"</tt>
	     *
	     * @param {object} crypto_content raw 'content' for the encrypted event.
	     * @param {object} keys The local keys claimed and proved by this event.
	     */
	    makeEncrypted: function makeEncrypted(crypto_type, crypto_content, keys) {
	        // keep the plain-text data for 'view source'
	        this._clearEvent = {
	            type: this.event.type,
	            content: this.event.content
	        };
	        this.event.type = crypto_type;
	        this.event.content = crypto_content;
	        this._keysProved = keys;
	        this._keysClaimed = keys;
	    },
	
	    /**
	     * Update the cleartext data on this event.
	     *
	     * (This is used after decrypting an event; it should not be used by applications).
	     *
	     * @internal
	     *
	     * @fires module:models/event.MatrixEvent#"Event.decrypted"
	     *
	     * @param {Object} clearEvent The plaintext payload for the event
	     *     (typically containing <tt>type</tt> and <tt>content</tt> fields).
	     *
	     * @param {Object=} keysProved Keys owned by the sender of this event.
	     *    See {@link module:models/event.MatrixEvent#getKeysProved}.
	     *
	     * @param {Object=} keysClaimed Keys the sender of this event claims.
	     *    See {@link module:models/event.MatrixEvent#getKeysClaimed}.
	     */
	    setClearData: function setClearData(clearEvent, keysProved, keysClaimed) {
	        this._clearEvent = clearEvent;
	        this._keysProved = keysProved || {};
	        this._keysClaimed = keysClaimed || {};
	        this.emit("Event.decrypted", this);
	    },
	
	    /**
	     * Check if the event is encrypted.
	     * @return {boolean} True if this event is encrypted.
	     */
	    isEncrypted: function isEncrypted() {
	        return this.event.type === "m.room.encrypted";
	    },
	
	    /**
	     * The curve25519 key that sent this event
	     * @return {string}
	     */
	    getSenderKey: function getSenderKey() {
	        return this.getKeysProved().curve25519 || null;
	    },
	
	    /**
	     * The keys that must have been owned by the sender of this encrypted event.
	     * <p>
	     * These don't necessarily have to come from this event itself, but may be
	     * implied by the cryptographic session.
	     *
	     * @return {Object<string, string>}
	     */
	    getKeysProved: function getKeysProved() {
	        return this._keysProved;
	    },
	
	    /**
	     * The additional keys the sender of this encrypted event claims to possess.
	     * <p>
	     * These don't necessarily have to come from this event itself, but may be
	     * implied by the cryptographic session.
	     * For example megolm messages don't claim keys directly, but instead
	     * inherit a claim from the olm message that established the session.
	     *
	     * @return {Object<string, string>}
	     */
	    getKeysClaimed: function getKeysClaimed() {
	        return this._keysClaimed;
	    },
	
	    getUnsigned: function getUnsigned() {
	        return this.event.unsigned || {};
	    },
	
	    /**
	     * Update the content of an event in the same way it would be by the server
	     * if it were redacted before it was sent to us
	     *
	     * @param {module:models/event.MatrixEvent} redaction_event
	     *     event causing the redaction
	     */
	    makeRedacted: function makeRedacted(redaction_event) {
	        // quick sanity-check
	        if (!redaction_event.event) {
	            throw new Error("invalid redaction_event in makeRedacted");
	        }
	
	        // we attempt to replicate what we would see from the server if
	        // the event had been redacted before we saw it.
	        //
	        // The server removes (most of) the content of the event, and adds a
	        // "redacted_because" key to the unsigned section containing the
	        // redacted event.
	        if (!this.event.unsigned) {
	            this.event.unsigned = {};
	        }
	        this.event.unsigned.redacted_because = redaction_event.event;
	
	        var key = void 0;
	        for (key in this.event) {
	            if (!this.event.hasOwnProperty(key)) {
	                continue;
	            }
	            if (!_REDACT_KEEP_KEY_MAP[key]) {
	                delete this.event[key];
	            }
	        }
	
	        var keeps = _REDACT_KEEP_CONTENT_MAP[this.getType()] || {};
	        var content = this.getContent();
	        for (key in content) {
	            if (!content.hasOwnProperty(key)) {
	                continue;
	            }
	            if (!keeps[key]) {
	                delete content[key];
	            }
	        }
	    },
	
	    /**
	     * Check if this event has been redacted
	     *
	     * @return {boolean} True if this event has been redacted
	     */
	    isRedacted: function isRedacted() {
	        return Boolean(this.getUnsigned().redacted_because);
	    },
	
	    /**
	     * Get the push actions, if known, for this event
	     *
	     * @return {?Object} push actions
	     */
	    getPushActions: function getPushActions() {
	        return this._pushActions;
	    },
	
	    /**
	     * Set the push actions for this event.
	     *
	     * @param {Object} pushActions push actions
	     */
	    setPushActions: function setPushActions(pushActions) {
	        this._pushActions = pushActions;
	    },
	
	    /**
	     * Replace the `event` property and recalculate any properties based on it.
	     * @param {Object} event the object to assign to the `event` property
	     */
	    handleRemoteEcho: function handleRemoteEcho(event) {
	        this.event = event;
	        // successfully sent.
	        this.status = null;
	        this._date = new Date(this.event.origin_server_ts);
	    }
	});
	
	/* _REDACT_KEEP_KEY_MAP gives the keys we keep when an event is redacted
	 *
	 * This is specified here:
	 *  http://matrix.org/speculator/spec/HEAD/client_server/unstable.html#redactions
	 *
	 * Also:
	 *  - We keep 'unsigned' since that is created by the local server
	 *  - We keep user_id for backwards-compat with v1
	 */
	var _REDACT_KEEP_KEY_MAP = ['event_id', 'type', 'room_id', 'user_id', 'sender', 'state_key', 'prev_state', 'content', 'unsigned', 'origin_server_ts'].reduce(function (ret, val) {
	    ret[val] = 1;return ret;
	}, {});
	
	// a map from event type to the .content keys we keep when an event is redacted
	var _REDACT_KEEP_CONTENT_MAP = {
	    'm.room.member': { 'membership': 1 },
	    'm.room.create': { 'creator': 1 },
	    'm.room.join_rules': { 'join_rule': 1 },
	    'm.room.power_levels': { 'ban': 1, 'events': 1, 'events_default': 1,
	        'kick': 1, 'redact': 1, 'state_default': 1,
	        'users': 1, 'users_default': 1
	    },
	    'm.room.aliases': { 'aliases': 1 }
	};
	
	/**
	 * Fires when an event is decrypted
	 *
	 * @event module:models/event.MatrixEvent#"Event.decrypted"
	 *
	 * @param {module:models/event.MatrixEvent} event
	 *    The matrix event which has been decrypted
	 */


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/*
	 * Holds the current Platform object used by the code to do anything
	 * specific to the platform we're running on (eg. web, electron)
	 * Platforms are provided by the app layer.
	 * This allows the app layer to set a Platform without necessarily
	 * having to have a MatrixChat object
	 */
	var PlatformPeg = function () {
	    function PlatformPeg() {
	        (0, _classCallCheck3.default)(this, PlatformPeg);
	
	        this.platform = null;
	    }
	
	    /**
	     * Returns the current Platform object for the application.
	     * This should be an instance of a class extending BasePlatform.
	     */
	
	
	    (0, _createClass3.default)(PlatformPeg, [{
	        key: "get",
	        value: function get() {
	            return this.platform;
	        }
	
	        /**
	         * Sets the current platform handler object to use for the
	         * application.
	         * This should be an instance of a class extending BasePlatform.
	         */
	
	    }, {
	        key: "set",
	        value: function set(plaf) {
	            this.platform = plaf;
	        }
	    }]);
	    return PlatformPeg;
	}();
	
	if (!global.mxPlatformPeg) {
	    global.mxPlatformPeg = new PlatformPeg();
	}
	module.exports = global.mxPlatformPeg;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Class that takes a Matrix Client and flips the m.direct map
	 * so the operation of mapping a room ID to which user it's a DM
	 * with can be performed efficiently.
	 *
	 * With 'start', this can also keep itself up to date over time.
	 */
	var DMRoomMap = function () {
	    function DMRoomMap(matrixClient) {
	        (0, _classCallCheck3.default)(this, DMRoomMap);
	
	        this.matrixClient = matrixClient;
	        this.roomToUser = null;
	
	        // XXX: Force-bind the event handler method because it
	        // doesn't call it with our object as the 'this'
	        // (use a static property arrow function for this when we can)
	        this._onAccountData = this._onAccountData.bind(this);
	
	        var mDirectEvent = matrixClient.getAccountData('m.direct');
	        if (!mDirectEvent) {
	            this.userToRooms = {};
	        } else {
	            this.userToRooms = mDirectEvent.getContent();
	        }
	    }
	
	    /**
	     * Makes and returns a new shared instance that can then be accessed
	     * with shared(). This returned instance is not automatically started.
	     */
	
	
	    (0, _createClass3.default)(DMRoomMap, [{
	        key: 'start',
	        value: function start() {
	            this._populateRoomToUser();
	            this.matrixClient.on("accountData", this._onAccountData);
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this.matrixClient.removeListener("accountData", this._onAccountData);
	        }
	    }, {
	        key: '_onAccountData',
	        value: function _onAccountData(ev) {
	            if (ev.getType() == 'm.direct') {
	                this.userToRooms = this.matrixClient.getAccountData('m.direct').getContent();
	                this._populateRoomToUser();
	            }
	        }
	    }, {
	        key: 'getDMRoomsForUserId',
	        value: function getDMRoomsForUserId(userId) {
	            // Here, we return the empty list if there are no rooms,
	            // since the number of conversations you have with this user is zero.
	            return this.userToRooms[userId] || [];
	        }
	    }, {
	        key: 'getUserIdForRoomId',
	        value: function getUserIdForRoomId(roomId) {
	            if (this.roomToUser == null) {
	                // we lazily populate roomToUser so you can use
	                // this class just to call getDMRoomsForUserId
	                // which doesn't do very much, but is a fairly
	                // convenient wrapper and there's no point
	                // iterating through the map if getUserIdForRoomId()
	                // is never called.
	                this._populateRoomToUser();
	            }
	            // Here, we return undefined if the room is not in the map:
	            // the room ID you gave is not a DM room for any user.
	            if (this.roomToUser[roomId] === undefined) {
	                // no entry? if the room is an invite, look for the is_direct hint.
	                var room = this.matrixClient.getRoom(roomId);
	                if (room) {
	                    var me = room.getMember(this.matrixClient.credentials.userId);
	                    if (me.membership == 'invite') {
	                        // The 'direct' hihnt is there, so declare that this is a DM room for
	                        // whoever invited us.
	                        if (me.events.member.getContent().is_direct) {
	                            return me.events.member.getSender();
	                        }
	                    }
	                }
	            }
	            return this.roomToUser[roomId];
	        }
	    }, {
	        key: '_populateRoomToUser',
	        value: function _populateRoomToUser() {
	            this.roomToUser = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.userToRooms)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var user = _step.value;
	                    var _iteratorNormalCompletion2 = true;
	                    var _didIteratorError2 = false;
	                    var _iteratorError2 = undefined;
	
	                    try {
	                        for (var _iterator2 = (0, _getIterator3.default)(this.userToRooms[user]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            var roomId = _step2.value;
	
	                            this.roomToUser[roomId] = user;
	                        }
	                    } catch (err) {
	                        _didIteratorError2 = true;
	                        _iteratorError2 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	                        } finally {
	                            if (_didIteratorError2) {
	                                throw _iteratorError2;
	                            }
	                        }
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }], [{
	        key: 'makeShared',
	        value: function makeShared() {
	            DMRoomMap._sharedInstance = new DMRoomMap(_MatrixClientPeg2.default.get());
	            return DMRoomMap._sharedInstance;
	        }
	
	        /**
	         * Returns a shared instance of the class
	         * that uses the singleton matrix client
	         * The shared instance must be started before use.
	         */
	
	    }, {
	        key: 'shared',
	        value: function shared() {
	            return DMRoomMap._sharedInstance;
	        }
	    }]);
	    return DMRoomMap;
	}(); /*
	     Copyright 2016 OpenMarket Ltd
	     
	     Licensed under the Apache License, Version 2.0 (the "License");
	     you may not use this file except in compliance with the License.
	     You may obtain a copy of the License at
	     
	         http://www.apache.org/licenses/LICENSE-2.0
	     
	     Unless required by applicable law or agreed to in writing, software
	     distributed under the License is distributed on an "AS IS" BASIS,
	     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     See the License for the specific language governing permissions and
	     limitations under the License.
	     */
	
	exports.default = DMRoomMap;
	module.exports = exports['default'];


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(659), __esModule: true };

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Browser Request
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//     http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	// UMD HEADER START 
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like enviroments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.returnExports = factory();
	  }
	}(this, function () {
	// UMD HEADER END
	
	var XHR = XMLHttpRequest
	if (!XHR) throw new Error('missing XMLHttpRequest')
	request.log = {
	  'trace': noop, 'debug': noop, 'info': noop, 'warn': noop, 'error': noop
	}
	
	var DEFAULT_TIMEOUT = 3 * 60 * 1000 // 3 minutes
	
	//
	// request
	//
	
	function request(options, callback) {
	  // The entry-point to the API: prep the options object and pass the real work to run_xhr.
	  if(typeof callback !== 'function')
	    throw new Error('Bad callback given: ' + callback)
	
	  if(!options)
	    throw new Error('No options given')
	
	  var options_onResponse = options.onResponse; // Save this for later.
	
	  if(typeof options === 'string')
	    options = {'uri':options};
	  else
	    options = JSON.parse(JSON.stringify(options)); // Use a duplicate for mutating.
	
	  options.onResponse = options_onResponse // And put it back.
	
	  if (options.verbose) request.log = getLogger();
	
	  if(options.url) {
	    options.uri = options.url;
	    delete options.url;
	  }
	
	  if(!options.uri && options.uri !== "")
	    throw new Error("options.uri is a required argument");
	
	  if(typeof options.uri != "string")
	    throw new Error("options.uri must be a string");
	
	  var unsupported_options = ['proxy', '_redirectsFollowed', 'maxRedirects', 'followRedirect']
	  for (var i = 0; i < unsupported_options.length; i++)
	    if(options[ unsupported_options[i] ])
	      throw new Error("options." + unsupported_options[i] + " is not supported")
	
	  options.callback = callback
	  options.method = options.method || 'GET';
	  options.headers = options.headers || {};
	  options.body    = options.body || null
	  options.timeout = options.timeout || request.DEFAULT_TIMEOUT
	
	  if(options.headers.host)
	    throw new Error("Options.headers.host is not supported");
	
	  if(options.json) {
	    options.headers.accept = options.headers.accept || 'application/json'
	    if(options.method !== 'GET')
	      options.headers['content-type'] = 'application/json'
	
	    if(typeof options.json !== 'boolean')
	      options.body = JSON.stringify(options.json)
	    else if(typeof options.body !== 'string')
	      options.body = JSON.stringify(options.body)
	  }
	  
	  //BEGIN QS Hack
	  var serialize = function(obj) {
	    var str = [];
	    for(var p in obj)
	      if (obj.hasOwnProperty(p)) {
	        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	      }
	    return str.join("&");
	  }
	  
	  if(options.qs){
	    var qs = (typeof options.qs == 'string')? options.qs : serialize(options.qs);
	    if(options.uri.indexOf('?') !== -1){ //no get params
	        options.uri = options.uri+'&'+qs;
	    }else{ //existing get params
	        options.uri = options.uri+'?'+qs;
	    }
	  }
	  //END QS Hack
	  
	  //BEGIN FORM Hack
	  var multipart = function(obj) {
	    //todo: support file type (useful?)
	    var result = {};
	    result.boundry = '-------------------------------'+Math.floor(Math.random()*1000000000);
	    var lines = [];
	    for(var p in obj){
	        if (obj.hasOwnProperty(p)) {
	            lines.push(
	                '--'+result.boundry+"\n"+
	                'Content-Disposition: form-data; name="'+p+'"'+"\n"+
	                "\n"+
	                obj[p]+"\n"
	            );
	        }
	    }
	    lines.push( '--'+result.boundry+'--' );
	    result.body = lines.join('');
	    result.length = result.body.length;
	    result.type = 'multipart/form-data; boundary='+result.boundry;
	    return result;
	  }
	  
	  if(options.form){
	    if(typeof options.form == 'string') throw('form name unsupported');
	    if(options.method === 'POST'){
	        var encoding = (options.encoding || 'application/x-www-form-urlencoded').toLowerCase();
	        options.headers['content-type'] = encoding;
	        switch(encoding){
	            case 'application/x-www-form-urlencoded':
	                options.body = serialize(options.form).replace(/%20/g, "+");
	                break;
	            case 'multipart/form-data':
	                var multi = multipart(options.form);
	                //options.headers['content-length'] = multi.length;
	                options.body = multi.body;
	                options.headers['content-type'] = multi.type;
	                break;
	            default : throw new Error('unsupported encoding:'+encoding);
	        }
	    }
	  }
	  //END FORM Hack
	
	  // If onResponse is boolean true, call back immediately when the response is known,
	  // not when the full request is complete.
	  options.onResponse = options.onResponse || noop
	  if(options.onResponse === true) {
	    options.onResponse = callback
	    options.callback = noop
	  }
	
	  // XXX Browsers do not like this.
	  //if(options.body)
	  //  options.headers['content-length'] = options.body.length;
	
	  // HTTP basic authentication
	  if(!options.headers.authorization && options.auth)
	    options.headers.authorization = 'Basic ' + b64_enc(options.auth.username + ':' + options.auth.password);
	
	  return run_xhr(options)
	}
	
	var req_seq = 0
	function run_xhr(options) {
	  var xhr = new XHR
	    , timed_out = false
	    , is_cors = is_crossDomain(options.uri)
	    , supports_cors = ('withCredentials' in xhr)
	
	  req_seq += 1
	  xhr.seq_id = req_seq
	  xhr.id = req_seq + ': ' + options.method + ' ' + options.uri
	  xhr._id = xhr.id // I know I will type "_id" from habit all the time.
	
	  if(is_cors && !supports_cors) {
	    var cors_err = new Error('Browser does not support cross-origin request: ' + options.uri)
	    cors_err.cors = 'unsupported'
	    return options.callback(cors_err, xhr)
	  }
	
	  xhr.timeoutTimer = setTimeout(too_late, options.timeout)
	  function too_late() {
	    timed_out = true
	    var er = new Error('ETIMEDOUT')
	    er.code = 'ETIMEDOUT'
	    er.duration = options.timeout
	
	    request.log.error('Timeout', { 'id':xhr._id, 'milliseconds':options.timeout })
	    return options.callback(er, xhr)
	  }
	
	  // Some states can be skipped over, so remember what is still incomplete.
	  var did = {'response':false, 'loading':false, 'end':false}
	
	  xhr.onreadystatechange = on_state_change
	  xhr.open(options.method, options.uri, true) // asynchronous
	  if(is_cors)
	    xhr.withCredentials = !! options.withCredentials
	  xhr.send(options.body)
	  return xhr
	
	  function on_state_change(event) {
	    if(timed_out)
	      return request.log.debug('Ignoring timed out state change', {'state':xhr.readyState, 'id':xhr.id})
	
	    request.log.debug('State change', {'state':xhr.readyState, 'id':xhr.id, 'timed_out':timed_out})
	
	    if(xhr.readyState === XHR.OPENED) {
	      request.log.debug('Request started', {'id':xhr.id})
	      for (var key in options.headers)
	        xhr.setRequestHeader(key, options.headers[key])
	    }
	
	    else if(xhr.readyState === XHR.HEADERS_RECEIVED)
	      on_response()
	
	    else if(xhr.readyState === XHR.LOADING) {
	      on_response()
	      on_loading()
	    }
	
	    else if(xhr.readyState === XHR.DONE) {
	      on_response()
	      on_loading()
	      on_end()
	    }
	  }
	
	  function on_response() {
	    if(did.response)
	      return
	
	    did.response = true
	    request.log.debug('Got response', {'id':xhr.id, 'status':xhr.status})
	    clearTimeout(xhr.timeoutTimer)
	    xhr.statusCode = xhr.status // Node request compatibility
	
	    // Detect failed CORS requests.
	    if(is_cors && xhr.statusCode == 0) {
	      var cors_err = new Error('CORS request rejected: ' + options.uri)
	      cors_err.cors = 'rejected'
	
	      // Do not process this request further.
	      did.loading = true
	      did.end = true
	
	      return options.callback(cors_err, xhr)
	    }
	
	    options.onResponse(null, xhr)
	  }
	
	  function on_loading() {
	    if(did.loading)
	      return
	
	    did.loading = true
	    request.log.debug('Response body loading', {'id':xhr.id})
	    // TODO: Maybe simulate "data" events by watching xhr.responseText
	  }
	
	  function on_end() {
	    if(did.end)
	      return
	
	    did.end = true
	    request.log.debug('Request done', {'id':xhr.id})
	
	    xhr.body = xhr.responseText
	    if(options.json) {
	      try        { xhr.body = JSON.parse(xhr.responseText) }
	      catch (er) { return options.callback(er, xhr)        }
	    }
	
	    options.callback(null, xhr, xhr.body)
	  }
	
	} // request
	
	request.withCredentials = false;
	request.DEFAULT_TIMEOUT = DEFAULT_TIMEOUT;
	
	//
	// defaults
	//
	
	request.defaults = function(options, requester) {
	  var def = function (method) {
	    var d = function (params, callback) {
	      if(typeof params === 'string')
	        params = {'uri': params};
	      else {
	        params = JSON.parse(JSON.stringify(params));
	      }
	      for (var i in options) {
	        if (params[i] === undefined) params[i] = options[i]
	      }
	      return method(params, callback)
	    }
	    return d
	  }
	  var de = def(request)
	  de.get = def(request.get)
	  de.post = def(request.post)
	  de.put = def(request.put)
	  de.head = def(request.head)
	  return de
	}
	
	//
	// HTTP method shortcuts
	//
	
	var shortcuts = [ 'get', 'put', 'post', 'head' ];
	shortcuts.forEach(function(shortcut) {
	  var method = shortcut.toUpperCase();
	  var func   = shortcut.toLowerCase();
	
	  request[func] = function(opts) {
	    if(typeof opts === 'string')
	      opts = {'method':method, 'uri':opts};
	    else {
	      opts = JSON.parse(JSON.stringify(opts));
	      opts.method = method;
	    }
	
	    var args = [opts].concat(Array.prototype.slice.apply(arguments, [1]));
	    return request.apply(this, args);
	  }
	})
	
	//
	// CouchDB shortcut
	//
	
	request.couch = function(options, callback) {
	  if(typeof options === 'string')
	    options = {'uri':options}
	
	  // Just use the request API to do JSON.
	  options.json = true
	  if(options.body)
	    options.json = options.body
	  delete options.body
	
	  callback = callback || noop
	
	  var xhr = request(options, couch_handler)
	  return xhr
	
	  function couch_handler(er, resp, body) {
	    if(er)
	      return callback(er, resp, body)
	
	    if((resp.statusCode < 200 || resp.statusCode > 299) && body.error) {
	      // The body is a Couch JSON object indicating the error.
	      er = new Error('CouchDB error: ' + (body.error.reason || body.error.error))
	      for (var key in body)
	        er[key] = body[key]
	      return callback(er, resp, body);
	    }
	
	    return callback(er, resp, body);
	  }
	}
	
	//
	// Utility
	//
	
	function noop() {}
	
	function getLogger() {
	  var logger = {}
	    , levels = ['trace', 'debug', 'info', 'warn', 'error']
	    , level, i
	
	  for(i = 0; i < levels.length; i++) {
	    level = levels[i]
	
	    logger[level] = noop
	    if(typeof console !== 'undefined' && console && console[level])
	      logger[level] = formatted(console, level)
	  }
	
	  return logger
	}
	
	function formatted(obj, method) {
	  return formatted_logger
	
	  function formatted_logger(str, context) {
	    if(typeof context === 'object')
	      str += ' ' + JSON.stringify(context)
	
	    return obj[method].call(obj, str)
	  }
	}
	
	// Return whether a URL is a cross-domain request.
	function is_crossDomain(url) {
	  var rurl = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/
	
	  // jQuery #8138, IE may throw an exception when accessing
	  // a field from window.location if document.domain has been set
	  var ajaxLocation
	  try { ajaxLocation = location.href }
	  catch (e) {
	    // Use the href attribute of an A element since IE will modify it given document.location
	    ajaxLocation = document.createElement( "a" );
	    ajaxLocation.href = "";
	    ajaxLocation = ajaxLocation.href;
	  }
	
	  var ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || []
	    , parts = rurl.exec(url.toLowerCase() )
	
	  var result = !!(
	    parts &&
	    (  parts[1] != ajaxLocParts[1]
	    || parts[2] != ajaxLocParts[2]
	    || (parts[3] || (parts[1] === "http:" ? 80 : 443)) != (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? 80 : 443))
	    )
	  )
	
	  //console.debug('is_crossDomain('+url+') -> ' + result)
	  return result
	}
	
	// MIT License from http://phpjs.org/functions/base64_encode:358
	function b64_enc (data) {
	    // Encodes string using MIME base64 algorithm
	    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc="", tmp_arr = [];
	
	    if (!data) {
	        return data;
	    }
	
	    // assume utf8 data
	    // data = this.utf8_encode(data+'');
	
	    do { // pack three octets into four hexets
	        o1 = data.charCodeAt(i++);
	        o2 = data.charCodeAt(i++);
	        o3 = data.charCodeAt(i++);
	
	        bits = o1<<16 | o2<<8 | o3;
	
	        h1 = bits>>18 & 0x3f;
	        h2 = bits>>12 & 0x3f;
	        h3 = bits>>6 & 0x3f;
	        h4 = bits & 0x3f;
	
	        // use hexets to index into b64, and append result to encoded string
	        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	    } while (i < data.length);
	
	    enc = tmp_arr.join('');
	
	    switch (data.length % 3) {
	        case 1:
	            enc = enc.slice(0, -2) + '==';
	        break;
	        case 2:
	            enc = enc.slice(0, -1) + '=';
	        break;
	    }
	
	    return enc;
	}
	    return request;
	//UMD FOOTER START
	}));
	//UMD FOOTER END


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(78)
	  , createDesc = __webpack_require__(152);
	module.exports = __webpack_require__(77) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(389)
	  , enumBugKeys = __webpack_require__(246);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(11)
	  , dPs         = __webpack_require__(407)
	  , enumBugKeys = __webpack_require__(261)
	  , IE_PROTO    = __webpack_require__(273)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(260)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(263).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(409)
	  , hiddenKeys = __webpack_require__(261).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(409)
	  , enumBugKeys = __webpack_require__(261);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(49);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(13)
	  , dP          = __webpack_require__(32)
	  , DESCRIPTORS = __webpack_require__(31)
	  , SPECIES     = __webpack_require__(29)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(91)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlock
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(26);
	
	var findRangesImmutable = __webpack_require__(201);
	
	var List = Immutable.List;
	var Map = Immutable.Map;
	var OrderedSet = Immutable.OrderedSet;
	var Record = Immutable.Record;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0,
	  data: Map()
	};
	
	var ContentBlockRecord = Record(defaultRecord);
	
	var ContentBlock = function (_ContentBlockRecord) {
	  _inherits(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock() {
	    _classCallCheck(this, ContentBlock);
	
	    return _possibleConstructorReturn(this, _ContentBlockRecord.apply(this, arguments));
	  }
	
	  ContentBlock.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlock.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlock.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlock.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlock.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlock.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlock.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  /**
	   * Execute a callback for every contiguous range of styles within the block.
	   */
	
	
	  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  /**
	   * Execute a callback for every contiguous range of entities within the block.
	   */
	
	
	  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlock;
	}(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	  if (index + 1 === str.length) {
	    return false;
	  }
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	  return len;
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0;
	
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  }
	
	  // Obvious cases
	  var size = str.length;
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  }
	
	  // Find the actual starting position
	  var posA = 0;
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	    if (posA < 0) {
	      posA = 0;
	    }
	  }
	
	  // Find the actual ending position
	  var posB = size;
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	function getCodePoints(str) {
	  var codePoints = [];
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	
	module.exports = UnicodeUtils;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1047),
	    getValue = __webpack_require__(1079);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    getPrototype = __webpack_require__(1075),
	    isObjectLike = __webpack_require__(113);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016, 2017 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module models/event-timeline
	 */
	
	var RoomState = __webpack_require__(490);
	var utils = __webpack_require__(16);
	var MatrixEvent = __webpack_require__(92).MatrixEvent;
	
	/**
	 * Construct a new EventTimeline
	 *
	 * <p>An EventTimeline represents a contiguous sequence of events in a room.
	 *
	 * <p>As well as keeping track of the events themselves, it stores the state of
	 * the room at the beginning and end of the timeline, and pagination tokens for
	 * going backwards and forwards in the timeline.
	 *
	 * <p>In order that clients can meaningfully maintain an index into a timeline,
	 * the EventTimeline object tracks a 'baseIndex'. This starts at zero, but is
	 * incremented when events are prepended to the timeline. The index of an event
	 * relative to baseIndex therefore remains constant.
	 *
	 * <p>Once a timeline joins up with its neighbour, they are linked together into a
	 * doubly-linked list.
	 *
	 * @param {EventTimelineSet} eventTimelineSet the set of timelines this is part of
	 * @constructor
	 */
	function EventTimeline(eventTimelineSet) {
	    this._eventTimelineSet = eventTimelineSet;
	    this._roomId = eventTimelineSet.room ? eventTimelineSet.room.roomId : null;
	    this._events = [];
	    this._baseIndex = 0;
	    this._startState = new RoomState(this._roomId);
	    this._startState.paginationToken = null;
	    this._endState = new RoomState(this._roomId);
	    this._endState.paginationToken = null;
	
	    this._prevTimeline = null;
	    this._nextTimeline = null;
	
	    // this is used by client.js
	    this._paginationRequests = { 'b': null, 'f': null };
	
	    this._name = this._roomId + ":" + new Date().toISOString();
	}
	
	/**
	 * Symbolic constant for methods which take a 'direction' argument:
	 * refers to the start of the timeline, or backwards in time.
	 */
	EventTimeline.BACKWARDS = "b";
	
	/**
	 * Symbolic constant for methods which take a 'direction' argument:
	 * refers to the end of the timeline, or forwards in time.
	 */
	EventTimeline.FORWARDS = "f";
	
	/**
	 * Initialise the start and end state with the given events
	 *
	 * <p>This can only be called before any events are added.
	 *
	 * @param {MatrixEvent[]} stateEvents list of state events to initialise the
	 * state with.
	 * @throws {Error} if an attempt is made to call this after addEvent is called.
	 */
	EventTimeline.prototype.initialiseState = function (stateEvents) {
	    if (this._events.length > 0) {
	        throw new Error("Cannot initialise state after events are added");
	    }
	
	    // we deep-copy the events here, in case they get changed later - we don't
	    // want changes to the start state leaking through to the end state.
	    var oldStateEvents = utils.map(utils.deepCopy(stateEvents.map(function (mxEvent) {
	        return mxEvent.event;
	    })), function (ev) {
	        return new MatrixEvent(ev);
	    });
	
	    this._startState.setStateEvents(oldStateEvents);
	    this._endState.setStateEvents(stateEvents);
	};
	
	/**
	 * Get the ID of the room for this timeline
	 * @return {string} room ID
	 */
	EventTimeline.prototype.getRoomId = function () {
	    return this._roomId;
	};
	
	/**
	 * Get the filter for this timeline's timelineSet (if any)
	 * @return {Filter} filter
	 */
	EventTimeline.prototype.getFilter = function () {
	    return this._eventTimelineSet.getFilter();
	};
	
	/**
	 * Get the timelineSet for this timeline
	 * @return {EventTimelineSet} timelineSet
	 */
	EventTimeline.prototype.getTimelineSet = function () {
	    return this._eventTimelineSet;
	};
	
	/**
	 * Get the base index.
	 *
	 * <p>This is an index which is incremented when events are prepended to the
	 * timeline. An individual event therefore stays at the same index in the array
	 * relative to the base index (although note that a given event's index may
	 * well be less than the base index, thus giving that event a negative relative
	 * index).
	 *
	 * @return {number}
	 */
	EventTimeline.prototype.getBaseIndex = function () {
	    return this._baseIndex;
	};
	
	/**
	 * Get the list of events in this context
	 *
	 * @return {MatrixEvent[]} An array of MatrixEvents
	 */
	EventTimeline.prototype.getEvents = function () {
	    return this._events;
	};
	
	/**
	 * Get the room state at the start/end of the timeline
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to get the state at the
	 *   start of the timeline; EventTimeline.FORWARDS to get the state at the end
	 *   of the timeline.
	 *
	 * @return {RoomState} state at the start/end of the timeline
	 */
	EventTimeline.prototype.getState = function (direction) {
	    if (direction == EventTimeline.BACKWARDS) {
	        return this._startState;
	    } else if (direction == EventTimeline.FORWARDS) {
	        return this._endState;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	};
	
	/**
	 * Get a pagination token
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to get the pagination
	 *   token for going backwards in time; EventTimeline.FORWARDS to get the
	 *   pagination token for going forwards in time.
	 *
	 * @return {?string} pagination token
	 */
	EventTimeline.prototype.getPaginationToken = function (direction) {
	    return this.getState(direction).paginationToken;
	};
	
	/**
	 * Set a pagination token
	 *
	 * @param {?string} token       pagination token
	 *
	 * @param {string} direction    EventTimeline.BACKWARDS to set the pagination
	 *   token for going backwards in time; EventTimeline.FORWARDS to set the
	 *   pagination token for going forwards in time.
	 */
	EventTimeline.prototype.setPaginationToken = function (token, direction) {
	    this.getState(direction).paginationToken = token;
	};
	
	/**
	 * Get the next timeline in the series
	 *
	 * @param {string} direction EventTimeline.BACKWARDS to get the previous
	 *   timeline; EventTimeline.FORWARDS to get the next timeline.
	 *
	 * @return {?EventTimeline} previous or following timeline, if they have been
	 * joined up.
	 */
	EventTimeline.prototype.getNeighbouringTimeline = function (direction) {
	    if (direction == EventTimeline.BACKWARDS) {
	        return this._prevTimeline;
	    } else if (direction == EventTimeline.FORWARDS) {
	        return this._nextTimeline;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	};
	
	/**
	 * Set the next timeline in the series
	 *
	 * @param {EventTimeline} neighbour previous/following timeline
	 *
	 * @param {string} direction EventTimeline.BACKWARDS to set the previous
	 *   timeline; EventTimeline.FORWARDS to set the next timeline.
	 *
	 * @throws {Error} if an attempt is made to set the neighbouring timeline when
	 * it is already set.
	 */
	EventTimeline.prototype.setNeighbouringTimeline = function (neighbour, direction) {
	    if (this.getNeighbouringTimeline(direction)) {
	        throw new Error("timeline already has a neighbouring timeline - " + "cannot reset neighbour");
	    }
	
	    if (direction == EventTimeline.BACKWARDS) {
	        this._prevTimeline = neighbour;
	    } else if (direction == EventTimeline.FORWARDS) {
	        this._nextTimeline = neighbour;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	
	    // make sure we don't try to paginate this timeline
	    this.setPaginationToken(null, direction);
	};
	
	/**
	 * Add a new event to the timeline, and update the state
	 *
	 * @param {MatrixEvent} event   new event
	 * @param {boolean}  atStart     true to insert new event at the start
	 */
	EventTimeline.prototype.addEvent = function (event, atStart) {
	    var stateContext = atStart ? this._startState : this._endState;
	
	    // only call setEventMetadata on the unfiltered timelineSets
	    var timelineSet = this.getTimelineSet();
	    if (timelineSet.room && timelineSet.room.getUnfilteredTimelineSet() === timelineSet) {
	        EventTimeline.setEventMetadata(event, stateContext, atStart);
	
	        // modify state
	        if (event.isState()) {
	            stateContext.setStateEvents([event]);
	            // it is possible that the act of setting the state event means we
	            // can set more metadata (specifically sender/target props), so try
	            // it again if the prop wasn't previously set. It may also mean that
	            // the sender/target is updated (if the event set was a room member event)
	            // so we want to use the *updated* member (new avatar/name) instead.
	            //
	            // However, we do NOT want to do this on member events if we're going
	            // back in time, else we'll set the .sender value for BEFORE the given
	            // member event, whereas we want to set the .sender value for the ACTUAL
	            // member event itself.
	            if (!event.sender || event.getType() === "m.room.member" && !atStart) {
	                EventTimeline.setEventMetadata(event, stateContext, atStart);
	            }
	        }
	    }
	
	    var insertIndex = void 0;
	
	    if (atStart) {
	        insertIndex = 0;
	    } else {
	        insertIndex = this._events.length;
	    }
	
	    this._events.splice(insertIndex, 0, event); // insert element
	    if (atStart) {
	        this._baseIndex++;
	    }
	};
	
	/**
	 * Static helper method to set sender and target properties
	 *
	 * @param {MatrixEvent} event   the event whose metadata is to be set
	 * @param {RoomState} stateContext  the room state to be queried
	 * @param {bool} toStartOfTimeline  if true the event's forwardLooking flag is set false
	 */
	EventTimeline.setEventMetadata = function (event, stateContext, toStartOfTimeline) {
	    // set sender and target properties
	    event.sender = stateContext.getSentinelMember(event.getSender());
	    if (event.getType() === "m.room.member") {
	        event.target = stateContext.getSentinelMember(event.getStateKey());
	    }
	    if (event.isState()) {
	        // room state has no concept of 'old' or 'current', but we want the
	        // room state to regress back to previous values if toStartOfTimeline
	        // is set, which means inspecting prev_content if it exists. This
	        // is done by toggling the forwardLooking flag.
	        if (toStartOfTimeline) {
	            event.forwardLooking = false;
	        }
	    }
	};
	
	/**
	 * Remove an event from the timeline
	 *
	 * @param {string} eventId  ID of event to be removed
	 * @return {?MatrixEvent} removed event, or null if not found
	 */
	EventTimeline.prototype.removeEvent = function (eventId) {
	    for (var i = this._events.length - 1; i >= 0; i--) {
	        var ev = this._events[i];
	        if (ev.getId() == eventId) {
	            this._events.splice(i, 1);
	            if (i < this._baseIndex) {
	                this._baseIndex--;
	            }
	            return ev;
	        }
	    }
	    return null;
	};
	
	/**
	 * Return a string to identify this timeline, for debugging
	 *
	 * @return {string} name for this timeline
	 */
	EventTimeline.prototype.toString = function () {
	    return this._name;
	};
	
	/**
	 * The EventTimeline class
	 */
	module.exports = EventTimeline;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/* a selection of key codes, as used in KeyboardEvent.keyCode */
	module.exports = {
	    BACKSPACE: 8,
	    TAB: 9,
	    ENTER: 13,
	    SHIFT: 16,
	    ESCAPE: 27,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    END: 35,
	    HOME: 36,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46,
	    KEY_D: 68,
	    KEY_E: 69
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.getDisplayAliasForRoom = getDisplayAliasForRoom;
	exports.getOnlyOtherMember = getOnlyOtherMember;
	exports.isConfCallRoom = isConfCallRoom;
	exports.looksLikeDirectMessageRoom = looksLikeDirectMessageRoom;
	exports.guessAndSetDMRoom = guessAndSetDMRoom;
	exports.setDMRoom = setDMRoom;
	exports.guessDMRoomTarget = guessDMRoomTarget;
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a room object, return the alias we should use for it,
	 * if any. This could be the canonical alias if one exists, otherwise
	 * an alias selected arbitrarily but deterministically from the list
	 * of aliases. Otherwise return null;
	 */
	function getDisplayAliasForRoom(room) {
	    return room.getCanonicalAlias() || room.getAliases()[0];
	}
	
	/**
	 * If the room contains only two members including the logged-in user,
	 * return the other one. Otherwise, return null.
	 */
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	function getOnlyOtherMember(room, me) {
	    var joinedMembers = room.getJoinedMembers();
	
	    if (joinedMembers.length === 2) {
	        return joinedMembers.filter(function (m) {
	            return m.userId !== me.userId;
	        })[0];
	    }
	
	    return null;
	}
	
	function isConfCallRoom(room, me, conferenceHandler) {
	    if (!conferenceHandler) return false;
	
	    if (me.membership != "join") {
	        return false;
	    }
	
	    var otherMember = getOnlyOtherMember(room, me);
	    if (otherMember === null) {
	        return false;
	    }
	
	    if (conferenceHandler.isConferenceUser(otherMember.userId)) {
	        return true;
	    }
	}
	
	function looksLikeDirectMessageRoom(room, me) {
	    if (me.membership == "join" || me.membership === "ban" || me.membership === "leave" && me.events.member.getSender() !== me.events.member.getStateKey()) {
	        // Used to split rooms via tags
	        var tagNames = (0, _keys2.default)(room.tags);
	        // Used for 1:1 direct chats
	        var members = room.currentState.getMembers();
	
	        // Show 1:1 chats in seperate "Direct Messages" section as long as they haven't
	        // been moved to a different tag section
	        if (members.length === 2 && !tagNames.length) {
	            return true;
	        }
	    }
	    return false;
	}
	
	function guessAndSetDMRoom(room, isDirect) {
	    var newTarget = void 0;
	    if (isDirect) {
	        var guessedTarget = guessDMRoomTarget(room, room.getMember(_MatrixClientPeg2.default.get().credentials.userId));
	        newTarget = guessedTarget.userId;
	    } else {
	        newTarget = null;
	    }
	
	    return setDMRoom(room.roomId, newTarget);
	}
	
	/**
	 * Marks or unmarks the given room as being as a DM room.
	 * @param {string} roomId The ID of the room to modify
	 * @param {string} userId The user ID of the desired DM
	                   room target user or null to un-mark
	                   this room as a DM room
	 * @returns {object} A promise
	 */
	function setDMRoom(roomId, userId) {
	    if (_MatrixClientPeg2.default.get().isGuest()) {
	        return (0, _q2.default)();
	    }
	
	    var mDirectEvent = _MatrixClientPeg2.default.get().getAccountData('m.direct');
	    var dmRoomMap = {};
	
	    if (mDirectEvent !== undefined) dmRoomMap = mDirectEvent.getContent();
	
	    // remove it from the lists of any others users
	    // (it can only be a DM room for one person)
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(dmRoomMap)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var thisUserId = _step.value;
	
	            var _roomList = dmRoomMap[thisUserId];
	
	            if (thisUserId != userId) {
	                var indexOfRoom = _roomList.indexOf(roomId);
	                if (indexOfRoom > -1) {
	                    _roomList.splice(indexOfRoom, 1);
	                }
	            }
	        }
	
	        // now add it, if it's not already there
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    if (userId) {
	        var roomList = dmRoomMap[userId] || [];
	        if (roomList.indexOf(roomId) == -1) {
	            roomList.push(roomId);
	        }
	        dmRoomMap[userId] = roomList;
	    }
	
	    return _MatrixClientPeg2.default.get().setAccountData('m.direct', dmRoomMap);
	}
	
	/**
	 * Given a room, estimate which of its members is likely to
	 * be the target if the room were a DM room and return that user.
	 */
	function guessDMRoomTarget(room, me) {
	    var oldestTs = void 0;
	    var oldestUser = void 0;
	
	    // Pick the user who's been here longest (and isn't us)
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = (0, _getIterator3.default)(room.currentState.getMembers()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var user = _step2.value;
	
	            if (user.userId == me.userId) continue;
	
	            if (oldestTs === undefined || user.events.member.getTs() < oldestTs) {
	                oldestUser = user;
	                oldestTs = user.events.member.getTs();
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    if (oldestUser === undefined) return me;
	    return oldestUser;
	}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var DEFAULTS = {
	    // URL to a page we show in an iframe to configure integrations
	    integrations_ui_url: "https://scalar.vector.im/",
	    // Base URL to the REST interface of the integrations server
	    integrations_rest_url: "https://scalar.vector.im/api",
	    // Where to send bug reports. If not specified, bugs cannot be sent.
	    bug_report_endpoint_url: null
	};
	
	var SdkConfig = function () {
	    function SdkConfig() {
	        (0, _classCallCheck3.default)(this, SdkConfig);
	    }
	
	    (0, _createClass3.default)(SdkConfig, null, [{
	        key: "get",
	        value: function get() {
	            return global.mxReactSdkConfig;
	        }
	    }, {
	        key: "put",
	        value: function put(cfg) {
	            var defaultKeys = (0, _keys2.default)(DEFAULTS);
	            for (var i = 0; i < defaultKeys.length; ++i) {
	                if (cfg[defaultKeys[i]] === undefined) {
	                    cfg[defaultKeys[i]] = DEFAULTS[defaultKeys[i]];
	                }
	            }
	            global.mxReactSdkConfig = cfg;
	        }
	    }, {
	        key: "unset",
	        value: function unset() {
	            global.mxReactSdkConfig = undefined;
	        }
	    }]);
	    return SdkConfig;
	}();
	
	module.exports = SdkConfig;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * 'debounces' a function to only execute every n milliseconds.
	 * Useful when react-sdk gets many, many events but only wants
	 * to update the interface once for all of them.
	 *
	 * Note that the function must not take arguments, since the args
	 * could be different for each invocarion of the function.
	 *
	 * The returned function has a 'cancelPendingCall' property which can be called
	 * on unmount or similar to cancel any pending update.
	 */
	module.exports = function (f, minIntervalMs) {
	    this.lastCall = 0;
	    this.scheduledCall = undefined;
	
	    var self = this;
	    var wrapper = function wrapper() {
	        var _this = this;
	
	        var now = Date.now();
	
	        if (self.lastCall < now - minIntervalMs) {
	            f.apply(this);
	            self.lastCall = now;
	        } else if (self.scheduledCall === undefined) {
	            self.scheduledCall = setTimeout(function () {
	                self.scheduledCall = undefined;
	                f.apply(_this);
	                self.lastCall = now;
	            }, self.lastCall + minIntervalMs - now);
	        }
	    };
	
	    // add the cancelPendingCall property
	    wrapper.cancelPendingCall = function () {
	        if (self.scheduledCall) {
	            clearTimeout(self.scheduledCall);
	            self.scheduledCall = undefined;
	        }
	    };
	
	    // make sure that cancelPendingCall is copied when react rebinds the
	    // wrapper
	    var _bind = wrapper.bind;
	    wrapper.bind = function () {
	        var rebound = _bind.apply(this, arguments);
	        rebound.cancelPendingCall = wrapper.cancelPendingCall;
	        return rebound;
	    };
	
	    return wrapper;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var GeminiScrollbar = __webpack_require__(1014);
	
	module.exports = React.createClass({
	    displayName: 'GeminiScrollbar',
	
	    propTypes: {
	        autoshow: React.PropTypes.bool,
	        forceGemini: React.PropTypes.bool,
	        onResize: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            autoshow: false,
	            forceGemini: false
	        };
	    },
	
	
	    /**
	     * Holds the reference to the GeminiScrollbar instance.
	     * @property scrollbar <public> [Object]
	     */
	    scrollbar: null,
	
	    componentDidMount: function componentDidMount() {
	        this.scrollbar = new GeminiScrollbar({
	            element: ReactDOM.findDOMNode(this),
	            autoshow: this.props.autoshow,
	            forceGemini: this.props.forceGemini,
	            createElements: false,
	            onResize: this.props.onResize
	        }).create();
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        this.scrollbar.update();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        if (this.scrollbar) {
	            this.scrollbar.destroy();
	        }
	        this.scrollbar = null;
	    },
	    render: function render() {
	        var _props = this.props;
	        var className = _props.className;
	        var children = _props.children;
	        var autoshow = _props.autoshow;
	        var forceGemini = _props.forceGemini;
	        var onResize = _props.onResize;
	        var other = _objectWithoutProperties(_props, ['className', 'children', 'autoshow', 'forceGemini', 'onResize']);
	        var classes = '';
	
	        if (className) {
	            classes += ' ' + className;
	        }
	
	        return React.createElement(
	            'div',
	            _extends({}, other, { className: classes }),
	            React.createElement(
	                'div',
	                { className: 'gm-scrollbar -vertical' },
	                React.createElement('div', { className: 'thumb' })
	            ),
	            React.createElement(
	                'div',
	                { className: 'gm-scrollbar -horizontal' },
	                React.createElement('div', { className: 'thumb' })
	            ),
	            React.createElement(
	                'div',
	                { className: 'gm-scroll-view', ref: 'scroll-view' },
	                children
	            )
	        );
	    }
	});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(339);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(158);
	util.inherits = __webpack_require__(72);
	/*</replacement>*/
	
	var Readable = __webpack_require__(556);
	var Writable = __webpack_require__(362);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(625);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(624);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var encode = __webpack_require__(1412);
	var decode = __webpack_require__(1411);
	
	var C_BACKSLASH = 92;
	
	var decodeHTML = __webpack_require__(293).decodeHTML;
	
	var ENTITY = "&(?:#x[a-f0-9]{1,8}|#[0-9]{1,8}|[a-z][a-z0-9]{1,31});";
	
	var TAGNAME = '[A-Za-z][A-Za-z0-9-]*';
	var ATTRIBUTENAME = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var UNQUOTEDVALUE = "[^\"'=<>`\\x00-\\x20]+";
	var SINGLEQUOTEDVALUE = "'[^']*'";
	var DOUBLEQUOTEDVALUE = '"[^"]*"';
	var ATTRIBUTEVALUE = "(?:" + UNQUOTEDVALUE + "|" + SINGLEQUOTEDVALUE + "|" + DOUBLEQUOTEDVALUE + ")";
	var ATTRIBUTEVALUESPEC = "(?:" + "\\s*=" + "\\s*" + ATTRIBUTEVALUE + ")";
	var ATTRIBUTE = "(?:" + "\\s+" + ATTRIBUTENAME + ATTRIBUTEVALUESPEC + "?)";
	var OPENTAG = "<" + TAGNAME + ATTRIBUTE + "*" + "\\s*/?>";
	var CLOSETAG = "</" + TAGNAME + "\\s*[>]";
	var HTMLCOMMENT = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
	var PROCESSINGINSTRUCTION = "[<][?].*?[?][>]";
	var DECLARATION = "<![A-Z]+" + "\\s+[^>]*>";
	var CDATA = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
	var HTMLTAG = "(?:" + OPENTAG + "|" + CLOSETAG + "|" + HTMLCOMMENT + "|" +
	        PROCESSINGINSTRUCTION + "|" + DECLARATION + "|" + CDATA + ")";
	var reHtmlTag = new RegExp('^' + HTMLTAG, 'i');
	
	var reBackslashOrAmp = /[\\&]/;
	
	var ESCAPABLE = '[!"#$%&\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]';
	
	var reEntityOrEscapedChar = new RegExp('\\\\' + ESCAPABLE + '|' + ENTITY, 'gi');
	
	var XMLSPECIAL = '[&<>"]';
	
	var reXmlSpecial = new RegExp(XMLSPECIAL, 'g');
	
	var reXmlSpecialOrEntity = new RegExp(ENTITY + '|' + XMLSPECIAL, 'gi');
	
	var unescapeChar = function(s) {
	    if (s.charCodeAt(0) === C_BACKSLASH) {
	        return s.charAt(1);
	    } else {
	        return decodeHTML(s);
	    }
	};
	
	// Replace entities and backslash escapes with literal characters.
	var unescapeString = function(s) {
	    if (reBackslashOrAmp.test(s)) {
	        return s.replace(reEntityOrEscapedChar, unescapeChar);
	    } else {
	        return s;
	    }
	};
	
	var normalizeURI = function(uri) {
	    try {
	        return encode(decode(uri));
	    }
	    catch(err) {
	        return uri;
	    }
	};
	
	var replaceUnsafeChar = function(s) {
	    switch (s) {
	    case '&':
	        return '&amp;';
	    case '<':
	        return '&lt;';
	    case '>':
	        return '&gt;';
	    case '"':
	        return '&quot;';
	    default:
	        return s;
	    }
	};
	
	var escapeXml = function(s, preserve_entities) {
	    if (reXmlSpecial.test(s)) {
	        if (preserve_entities) {
	            return s.replace(reXmlSpecialOrEntity, replaceUnsafeChar);
	        } else {
	            return s.replace(reXmlSpecial, replaceUnsafeChar);
	        }
	    } else {
	        return s;
	    }
	};
	
	module.exports = { unescapeString: unescapeString,
	                   normalizeURI: normalizeURI,
	                   escapeXml: escapeXml,
	                   reHtmlTag: reHtmlTag,
	                   OPENTAG: OPENTAG,
	                   CLOSETAG: CLOSETAG,
	                   ENTITY: ENTITY,
	                   ESCAPABLE: ESCAPABLE
	                 };


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(242);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(29)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(48)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(81)
	  , call        = __webpack_require__(403)
	  , isArrayIter = __webpack_require__(265)
	  , anObject    = __webpack_require__(11)
	  , toLength    = __webpack_require__(35)
	  , getIterFn   = __webpack_require__(282)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(32).f
	  , has = __webpack_require__(40)
	  , TAG = __webpack_require__(29)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , defined = __webpack_require__(61)
	  , fails   = __webpack_require__(17)
	  , spaces  = __webpack_require__(278)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectionState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(26);
	
	var Record = Immutable.Record;
	
	
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = function (_SelectionStateRecord) {
	  _inherits(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    _classCallCheck(this, SelectionState);
	
	    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
	  }
	
	  SelectionState.prototype.serialize = function serialize() {
	    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	  };
	
	  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
	    return this.get('anchorKey');
	  };
	
	  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
	    return this.get('anchorOffset');
	  };
	
	  SelectionState.prototype.getFocusKey = function getFocusKey() {
	    return this.get('focusKey');
	  };
	
	  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
	    return this.get('focusOffset');
	  };
	
	  SelectionState.prototype.getIsBackward = function getIsBackward() {
	    return this.get('isBackward');
	  };
	
	  SelectionState.prototype.getHasFocus = function getHasFocus() {
	    return this.get('hasFocus');
	  };
	
	  /**
	   * Return whether the specified range overlaps with an edge of the
	   * SelectionState.
	   */
	
	
	  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
	    var anchorKey = this.getAnchorKey();
	    var focusKey = this.getFocusKey();
	
	    if (anchorKey === focusKey && anchorKey === blockKey) {
	      var selectionStart = this.getStartOffset();
	      var selectionEnd = this.getEndOffset();
	      return start <= selectionEnd && selectionStart <= end;
	    }
	
	    if (blockKey !== anchorKey && blockKey !== focusKey) {
	      return false;
	    }
	
	    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	
	    return start <= offsetToCheck && end >= offsetToCheck;
	  };
	
	  SelectionState.prototype.isCollapsed = function isCollapsed() {
	    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	  };
	
	  SelectionState.prototype.getStartKey = function getStartKey() {
	    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	  };
	
	  SelectionState.prototype.getStartOffset = function getStartOffset() {
	    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	  };
	
	  SelectionState.prototype.getEndKey = function getEndKey() {
	    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	  };
	
	  SelectionState.prototype.getEndOffset = function getEndOffset() {
	    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	  };
	
	  SelectionState.createEmpty = function createEmpty(key) {
	    return new SelectionState({
	      anchorKey: key,
	      anchorOffset: 0,
	      focusKey: key,
	      focusOffset: 0,
	      isBackward: false,
	      hasFocus: false
	    });
	  };
	
	  return SelectionState;
	}(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(167),
	    getRawTag = __webpack_require__(1076),
	    objectToString = __webpack_require__(1105);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(316),
	    overRest = __webpack_require__(1106),
	    setToString = __webpack_require__(1109);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(482),
	    isLength = __webpack_require__(318);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var ContentRepo = __webpack_require__(28).ContentRepo;
	var MatrixClientPeg = __webpack_require__(4);
	
	module.exports = {
	    avatarUrlForMember: function avatarUrlForMember(member, width, height, resizeMethod) {
	        var url = member.getAvatarUrl(MatrixClientPeg.get().getHomeserverUrl(), width, height, resizeMethod, false, false);
	        if (!url) {
	            // member can be null here currently since on invites, the JS SDK
	            // does not have enough info to build a RoomMember object for
	            // the inviter.
	            url = this.defaultAvatarUrlForString(member ? member.userId : '');
	        }
	        return url;
	    },
	
	    avatarUrlForUser: function avatarUrlForUser(user, width, height, resizeMethod) {
	        var url = ContentRepo.getHttpUriForMxc(MatrixClientPeg.get().getHomeserverUrl(), user.avatarUrl, width, height, resizeMethod);
	        if (!url || url.length === 0) {
	            return null;
	        }
	        return url;
	    },
	
	    defaultAvatarUrlForString: function defaultAvatarUrlForString(s) {
	        var images = ['76cfa6', '50e2c2', 'f4c371'];
	        var total = 0;
	        for (var i = 0; i < s.length; ++i) {
	            total += s.charCodeAt(i);
	        }
	        return 'img/' + images[total % images.length] + '.png';
	    }
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(123);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * For two objects of the form { key: [val1, val2, val3] }, work out the added/removed
	 * values. Entirely new keys will result in the entire value array being added.
	 * @param {Object} before
	 * @param {Object} after
	 * @return {Object[]} An array of objects with the form:
	 * { key: $KEY, val: $VALUE, place: "add|del" }
	 */
	module.exports.getKeyValueArrayDiffs = function (before, after) {
	    var results = [];
	    var delta = {};
	    (0, _keys2.default)(before).forEach(function (beforeKey) {
	        delta[beforeKey] = delta[beforeKey] || 0; // init to 0 initially
	        delta[beforeKey]--; // keys present in the past have -ve values
	    });
	    (0, _keys2.default)(after).forEach(function (afterKey) {
	        delta[afterKey] = delta[afterKey] || 0; // init to 0 initially
	        delta[afterKey]++; // keys present in the future have +ve values
	    });
	
	    (0, _keys2.default)(delta).forEach(function (muxedKey) {
	        switch (delta[muxedKey]) {
	            case 1:
	                // A new key in after
	                after[muxedKey].forEach(function (afterVal) {
	                    results.push({ place: "add", key: muxedKey, val: afterVal });
	                });
	                break;
	            case -1:
	                // A before key was removed
	                before[muxedKey].forEach(function (beforeVal) {
	                    results.push({ place: "del", key: muxedKey, val: beforeVal });
	                });
	                break;
	            case 0:
	                // A mix of added/removed keys
	                // compare old & new vals
	                var itemDelta = {};
	                before[muxedKey].forEach(function (beforeVal) {
	                    itemDelta[beforeVal] = itemDelta[beforeVal] || 0;
	                    itemDelta[beforeVal]--;
	                });
	                after[muxedKey].forEach(function (afterVal) {
	                    itemDelta[afterVal] = itemDelta[afterVal] || 0;
	                    itemDelta[afterVal]++;
	                });
	
	                (0, _keys2.default)(itemDelta).forEach(function (item) {
	                    if (itemDelta[item] === 1) {
	                        results.push({ place: "add", key: muxedKey, val: item });
	                    } else if (itemDelta[item] === -1) {
	                        results.push({ place: "del", key: muxedKey, val: item });
	                    } else {
	                        // itemDelta of 0 means it was unchanged between before/after
	                    }
	                });
	                break;
	            default:
	                console.error("Calculated key delta of " + delta[muxedKey] + " - this should never happen!");
	                break;
	        }
	    });
	
	    return results;
	};
	
	/**
	 * Shallow-compare two objects for equality: each key and value must be
	 * identical
	 */
	module.exports.shallowEqual = function (objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === "undefined" ? "undefined" : (0, _typeof3.default)(objA)) !== 'object' || objA === null || (typeof objB === "undefined" ? "undefined" : (0, _typeof3.default)(objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = (0, _keys2.default)(objA);
	    var keysB = (0, _keys2.default)(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    for (var i = 0; i < keysA.length; i++) {
	        var key = keysA[i];
	        if (!objB.hasOwnProperty(key) || objA[key] !== objB[key]) {
	            return false;
	        }
	    }
	
	    return true;
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	Copyright 2015 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	// FIXME: these vars should be bundled up and attached to
	// module.exports otherwise this will break when included by both
	// react-sdk and apps layered on top.
	
	var DEBUG = 0;
	
	// The colour keys to be replaced as referred to in CSS
	var keyRgb = ["rgb(118, 207, 166)", // Vector Green
	"rgb(234, 245, 240)", // Vector Light Green
	"rgb(211, 239, 225)"];
	
	// Some algebra workings for calculating the tint % of Vector Green & Light Green
	// x * 118 + (1 - x) * 255 = 234
	// x * 118 + 255 - 255 * x = 234
	// x * 118 - x * 255 = 234 - 255
	// (255 - 118) x = 255 - 234
	// x = (255 - 234) / (255 - 118) = 0.16
	
	// The colour keys to be replaced as referred to in SVGs
	var keyHex = ["#76CFA6", // Vector Green
	"#EAF5F0", // Vector Light Green
	"#D3EFE1", // BottomLeftMenu overlay (20% Vector Green overlaid on Vector Light Green)
	"#FFFFFF"];
	
	// cache of our replacement colours
	// defaults to our keys.
	var colors = [keyHex[0], keyHex[1], keyHex[2], keyHex[3]];
	
	var cssFixups = [
	    // {
	    //     style: a style object that should be fixed up taken from a stylesheet
	    //     attr: name of the attribute to be clobbered, e.g. 'color'
	    //     index: ordinal of primary, secondary or tertiary
	    // }
	];
	
	// CSS attributes to be fixed up
	var cssAttrs = ["color", "backgroundColor", "borderColor", "borderTopColor", "borderBottomColor", "borderLeftColor"];
	
	var svgAttrs = ["fill", "stroke"];
	
	var cached = false;
	
	function calcCssFixups() {
	    if (DEBUG) console.log("calcSvgFixups start");
	    for (var i = 0; i < document.styleSheets.length; i++) {
	        var ss = document.styleSheets[i];
	        if (!ss) continue; // well done safari >:(
	        // Chromium apparently sometimes returns null here; unsure why.
	        // see $14534907369972FRXBx:matrix.org in HQ
	        // ...ah, it's because there's a third party extension like
	        // privacybadger inserting its own stylesheet in there with a
	        // resource:// URI or something which results in a XSS error.
	        // See also #vector:matrix.org/$145357669685386ebCfr:matrix.org
	        // ...except some browsers apparently return stylesheets without
	        // hrefs, which we have no choice but ignore right now
	
	        // XXX seriously? we are hardcoding the name of vector's CSS file in
	        // here?
	        //
	        // Why do we need to limit it to vector's CSS file anyway - if there
	        // are other CSS files affecting the doc don't we want to apply the
	        // same transformations to them?
	        //
	        // Iterating through the CSS looking for matches to hack on feels
	        // pretty horrible anyway. And what if the application skin doesn't use
	        // Vector Green as its primary color?
	
	        if (ss.href && !ss.href.match(/\/bundle.*\.css$/)) continue;
	
	        if (!ss.cssRules) continue;
	        for (var j = 0; j < ss.cssRules.length; j++) {
	            var rule = ss.cssRules[j];
	            if (!rule.style) continue;
	            for (var k = 0; k < cssAttrs.length; k++) {
	                var attr = cssAttrs[k];
	                for (var l = 0; l < keyRgb.length; l++) {
	                    if (rule.style[attr] === keyRgb[l]) {
	                        cssFixups.push({
	                            style: rule.style,
	                            attr: attr,
	                            index: l
	                        });
	                    }
	                }
	            }
	        }
	    }
	    if (DEBUG) console.log("calcSvgFixups end");
	}
	
	function applyCssFixups() {
	    if (DEBUG) console.log("applyCssFixups start");
	    for (var i = 0; i < cssFixups.length; i++) {
	        var cssFixup = cssFixups[i];
	        cssFixup.style[cssFixup.attr] = colors[cssFixup.index];
	    }
	    if (DEBUG) console.log("applyCssFixups end");
	}
	
	function hexToRgb(color) {
	    if (color[0] === '#') color = color.slice(1);
	    if (color.length === 3) {
	        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
	    }
	    var val = parseInt(color, 16);
	    var r = val >> 16 & 255;
	    var g = val >> 8 & 255;
	    var b = val & 255;
	    return [r, g, b];
	}
	
	function rgbToHex(rgb) {
	    var val = rgb[0] << 16 | rgb[1] << 8 | rgb[2];
	    return '#' + (0x1000000 + val).toString(16).slice(1);
	}
	
	// List of functions to call when the tint changes.
	var tintables = [];
	
	module.exports = {
	    /**
	     * Register a callback to fire when the tint changes.
	     * This is used to rewrite the tintable SVGs with the new tint.
	     *
	     * It's not possible to unregister a tintable callback. So this can only be
	     * used to register a static callback. If a set of tintables will change
	     * over time then the best bet is to register a single callback for the
	     * entire set.
	     *
	     * @param {Function} tintable Function to call when the tint changes.
	     */
	    registerTintable: function registerTintable(tintable) {
	        tintables.push(tintable);
	    },
	
	    tint: function tint(primaryColor, secondaryColor, tertiaryColor) {
	
	        if (!cached) {
	            calcCssFixups();
	            cached = true;
	        }
	
	        if (!primaryColor) {
	            primaryColor = "#76CFA6"; // Vector green
	            secondaryColor = "#EAF5F0"; // Vector light green
	        }
	
	        if (!secondaryColor) {
	            var x = 0.16; // average weighting factor calculated from vector green & light green
	            var rgb = hexToRgb(primaryColor);
	            rgb[0] = x * rgb[0] + (1 - x) * 255;
	            rgb[1] = x * rgb[1] + (1 - x) * 255;
	            rgb[2] = x * rgb[2] + (1 - x) * 255;
	            secondaryColor = rgbToHex(rgb);
	        }
	
	        if (!tertiaryColor) {
	            var _x = 0.19;
	            var rgb1 = hexToRgb(primaryColor);
	            var rgb2 = hexToRgb(secondaryColor);
	            rgb1[0] = _x * rgb1[0] + (1 - _x) * rgb2[0];
	            rgb1[1] = _x * rgb1[1] + (1 - _x) * rgb2[1];
	            rgb1[2] = _x * rgb1[2] + (1 - _x) * rgb2[2];
	            tertiaryColor = rgbToHex(rgb1);
	        }
	
	        if (colors[0] === primaryColor && colors[1] === secondaryColor && colors[2] === tertiaryColor) {
	            return;
	        }
	
	        colors[0] = primaryColor;
	        colors[1] = secondaryColor;
	        colors[2] = tertiaryColor;
	
	        if (DEBUG) console.log("Tinter.tint");
	
	        // go through manually fixing up the stylesheets.
	        applyCssFixups();
	
	        // tell all the SVGs to go fix themselves up
	        // we don't do this as a dispatch otherwise it will visually lag
	        tintables.forEach(function (tintable) {
	            tintable();
	        });
	    },
	
	    tintSvgWhite: function tintSvgWhite(whiteColor) {
	        if (!whiteColor) {
	            whiteColor = colors[3];
	        }
	        if (colors[3] === whiteColor) {
	            return;
	        }
	        colors[3] = whiteColor;
	        tintables.forEach(function (tintable) {
	            tintable();
	        });
	    },
	
	    // XXX: we could just move this all into TintableSvg, but as it's so similar
	    // to the CSS fixup stuff in Tinter (just that the fixups are stored in TintableSvg)
	    // keeping it here for now.
	    calcSvgFixups: function calcSvgFixups(svgs) {
	        // go through manually fixing up SVG colours.
	        // we could do this by stylesheets, but keeping the stylesheets
	        // updated would be a PITA, so just brute-force search for the
	        // key colour; cache the element and apply.
	
	        if (DEBUG) console.log("calcSvgFixups start for " + svgs);
	        var fixups = [];
	        for (var i = 0; i < svgs.length; i++) {
	            var svgDoc;
	            try {
	                svgDoc = svgs[i].contentDocument;
	            } catch (e) {
	                var msg = 'Failed to get svg.contentDocument of ' + svgs[i].toString();
	                if (e.message) {
	                    msg += e.message;
	                }
	                if (e.stack) {
	                    msg += ' | stack: ' + e.stack;
	                }
	                console.error(e);
	            }
	            if (!svgDoc) continue;
	            var tags = svgDoc.getElementsByTagName("*");
	            for (var j = 0; j < tags.length; j++) {
	                var tag = tags[j];
	                for (var k = 0; k < svgAttrs.length; k++) {
	                    var attr = svgAttrs[k];
	                    for (var l = 0; l < keyHex.length; l++) {
	                        if (tag.getAttribute(attr) && tag.getAttribute(attr).toUpperCase() === keyHex[l]) {
	                            fixups.push({
	                                node: tag,
	                                attr: attr,
	                                index: l
	                            });
	                        }
	                    }
	                }
	            }
	        }
	        if (DEBUG) console.log("calcSvgFixups end");
	
	        return fixups;
	    },
	
	    applySvgFixups: function applySvgFixups(fixups) {
	        if (DEBUG) console.log("applySvgFixups start for " + fixups);
	        for (var i = 0; i < fixups.length; i++) {
	            var svgFixup = fixups[i];
	            svgFixup.node.setAttribute(svgFixup.attr, colors[svgFixup.index]);
	        }
	        if (DEBUG) console.log("applySvgFixups end");
	    }
	};


/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	function matrixLinkify(linkify) {
	    // Text tokens
	    var TT = linkify.scanner.TOKENS;
	    // Multi tokens
	    var MT = linkify.parser.TOKENS;
	    var MultiToken = MT.Base;
	    var S_START = linkify.parser.start;
	
	    if (TT.UNDERSCORE === undefined) {
	        throw new Error("linkify-matrix requires linkifyjs 2.1.1: this version is too old.");
	    }
	
	    var ROOMALIAS = function ROOMALIAS(value) {
	        MultiToken.call(this, value);
	        this.type = 'roomalias';
	        this.isLink = true;
	    };
	    ROOMALIAS.prototype = new MultiToken();
	
	    var S_HASH = new linkify.parser.State();
	    var S_HASH_NAME = new linkify.parser.State();
	    var S_HASH_NAME_COLON = new linkify.parser.State();
	    var S_HASH_NAME_COLON_DOMAIN = new linkify.parser.State();
	    var S_HASH_NAME_COLON_DOMAIN_DOT = new linkify.parser.State();
	    var S_ROOMALIAS = new linkify.parser.State(ROOMALIAS);
	
	    var roomname_tokens = [TT.DOT, TT.PLUS, TT.NUM, TT.DOMAIN, TT.TLD, TT.UNDERSCORE, TT.POUND,
	
	    // because 'localhost' is tokenised to the localhost token,
	    // usernames @localhost:foo.com are otherwise not matched!
	    TT.LOCALHOST];
	
	    S_START.on(TT.POUND, S_HASH);
	
	    S_HASH.on(roomname_tokens, S_HASH_NAME);
	    S_HASH_NAME.on(roomname_tokens, S_HASH_NAME);
	    S_HASH_NAME.on(TT.DOMAIN, S_HASH_NAME);
	
	    S_HASH_NAME.on(TT.COLON, S_HASH_NAME_COLON);
	
	    S_HASH_NAME_COLON.on(TT.DOMAIN, S_HASH_NAME_COLON_DOMAIN);
	    S_HASH_NAME_COLON.on(TT.LOCALHOST, S_ROOMALIAS); // accept #foo:localhost
	    S_HASH_NAME_COLON_DOMAIN.on(TT.DOT, S_HASH_NAME_COLON_DOMAIN_DOT);
	    S_HASH_NAME_COLON_DOMAIN_DOT.on(TT.DOMAIN, S_HASH_NAME_COLON_DOMAIN);
	    S_HASH_NAME_COLON_DOMAIN_DOT.on(TT.TLD, S_ROOMALIAS);
	
	    var USERID = function USERID(value) {
	        MultiToken.call(this, value);
	        this.type = 'userid';
	        this.isLink = true;
	    };
	    USERID.prototype = new MultiToken();
	
	    var S_AT = new linkify.parser.State();
	    var S_AT_NAME = new linkify.parser.State();
	    var S_AT_NAME_COLON = new linkify.parser.State();
	    var S_AT_NAME_COLON_DOMAIN = new linkify.parser.State();
	    var S_AT_NAME_COLON_DOMAIN_DOT = new linkify.parser.State();
	    var S_USERID = new linkify.parser.State(USERID);
	
	    var username_tokens = [TT.DOT, TT.UNDERSCORE, TT.PLUS, TT.NUM, TT.DOMAIN, TT.TLD,
	
	    // as in roomname_tokens
	    TT.LOCALHOST];
	
	    S_START.on(TT.AT, S_AT);
	
	    S_AT.on(username_tokens, S_AT_NAME);
	    S_AT_NAME.on(username_tokens, S_AT_NAME);
	    S_AT_NAME.on(TT.DOMAIN, S_AT_NAME);
	
	    S_AT_NAME.on(TT.COLON, S_AT_NAME_COLON);
	
	    S_AT_NAME_COLON.on(TT.DOMAIN, S_AT_NAME_COLON_DOMAIN);
	    S_AT_NAME_COLON.on(TT.LOCALHOST, S_USERID); // accept @foo:localhost
	    S_AT_NAME_COLON_DOMAIN.on(TT.DOT, S_AT_NAME_COLON_DOMAIN_DOT);
	    S_AT_NAME_COLON_DOMAIN_DOT.on(TT.DOMAIN, S_AT_NAME_COLON_DOMAIN);
	    S_AT_NAME_COLON_DOMAIN_DOT.on(TT.TLD, S_USERID);
	}
	
	// stubs, overwritten in MatrixChat's componentDidMount
	matrixLinkify.onUserClick = function (e, userId) {
	    e.preventDefault();
	};
	matrixLinkify.onAliasClick = function (e, roomAlias) {
	    e.preventDefault();
	};
	
	var escapeRegExp = function escapeRegExp(string) {
	    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	};
	
	// Recognise URLs from both our local vector and official vector as vector.
	// anyone else really should be using matrix.to.
	matrixLinkify.VECTOR_URL_PATTERN = "^(?:https?:\/\/)?(?:" + escapeRegExp(window.location.host + window.location.pathname) + "|" + "(?:www\\.)?(?:riot|vector)\\.im/(?:app|beta|staging|develop)/" + ")(#.*)";
	
	matrixLinkify.MATRIXTO_URL_PATTERN = "^(?:https?:\/\/)?(?:www\\.)?matrix\\.to/#/((#|@|!).*)";
	matrixLinkify.MATRIXTO_BASE_URL = "https://matrix.to";
	
	matrixLinkify.options = {
	    events: function events(href, type) {
	        switch (type) {
	            case "userid":
	                return {
	                    click: function click(e) {
	                        matrixLinkify.onUserClick(e, href);
	                    }
	                };
	            case "roomalias":
	                return {
	                    click: function click(e) {
	                        matrixLinkify.onAliasClick(e, href);
	                    }
	                };
	        }
	    },
	
	    formatHref: function formatHref(href, type) {
	        switch (type) {
	            case 'roomalias':
	            case 'userid':
	                return matrixLinkify.MATRIXTO_BASE_URL + '/#/' + href;
	            default:
	                var m;
	                // FIXME: horrible duplication with HtmlUtils' transform tags
	                m = href.match(matrixLinkify.VECTOR_URL_PATTERN);
	                if (m) {
	                    return m[1];
	                }
	                m = href.match(matrixLinkify.MATRIXTO_URL_PATTERN);
	                if (m) {
	                    var entity = m[1];
	                    if (entity[0] === '@') {
	                        return '#/user/' + entity;
	                    } else if (entity[0] === '#' || entity[0] === '!') {
	                        return '#/room/' + entity;
	                    }
	                }
	
	                return href;
	        }
	    },
	
	    linkAttributes: {
	        rel: 'noopener'
	    },
	
	    target: function target(href, type) {
	        if (type === 'url') {
	            if (href.match(matrixLinkify.VECTOR_URL_PATTERN) || href.match(matrixLinkify.MATRIXTO_URL_PATTERN)) {
	                return null;
	            } else {
	                return '_blank';
	            }
	        }
	        return null;
	    }
	};
	
	module.exports = matrixLinkify;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(345);
	var setInnerHTML = __webpack_require__(231);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(353);
	var setTextContent = __webpack_require__(551);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1476);
	var ReactInstrumentation = __webpack_require__(65);
	
	var warning = __webpack_require__(14);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var ReactChildren = __webpack_require__(1505);
	var ReactComponent = __webpack_require__(360);
	var ReactPureComponent = __webpack_require__(1510);
	var ReactClass = __webpack_require__(1506);
	var ReactDOMFactories = __webpack_require__(1507);
	var ReactElement = __webpack_require__(147);
	var ReactPropTypes = __webpack_require__(1509);
	var ReactVersion = __webpack_require__(1511);
	
	var onlyChild = __webpack_require__(1514);
	var warning = __webpack_require__(14);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var ReactCurrentOwner = __webpack_require__(87);
	
	var warning = __webpack_require__(14);
	var canDefineProperty = __webpack_require__(555);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(554);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(1531);
	var util = __webpack_require__(1532);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(526);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(244);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(681)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(383)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(60)
	  , TAG = __webpack_require__(29)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(60);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88).Buffer))

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockMapBuilder
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	
	module.exports = BlockMapBuilder;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Draft
	 */
	
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(927);
	var BlockMapBuilder = __webpack_require__(160);
	var CharacterMetadata = __webpack_require__(63);
	var CompositeDraftDecorator = __webpack_require__(928);
	var ContentBlock = __webpack_require__(110);
	var ContentState = __webpack_require__(286);
	var DefaultDraftBlockRenderMap = __webpack_require__(287);
	var DefaultDraftInlineStyle = __webpack_require__(427);
	var DraftEditor = __webpack_require__(930);
	var DraftEditorBlock = __webpack_require__(428);
	var DraftModifier = __webpack_require__(41);
	var DraftEntity = __webpack_require__(84);
	var DraftEntityInstance = __webpack_require__(429);
	var EditorState = __webpack_require__(24);
	var KeyBindingUtil = __webpack_require__(288);
	var RichTextEditorUtil = __webpack_require__(941);
	var SelectionState = __webpack_require__(133);
	
	var convertFromDraftStateToRaw = __webpack_require__(946);
	var convertFromHTMLToContentBlocks = __webpack_require__(432);
	var convertFromRawToDraftState = __webpack_require__(947);
	var generateRandomKey = __webpack_require__(70);
	var getDefaultKeyBinding = __webpack_require__(433);
	var getVisibleSelectionRect = __webpack_require__(970);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  SelectionState: SelectionState,
	
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	
	  convertFromHTML: convertFromHTMLToContentBlocks,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	
	module.exports = DraftPublic;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeTextWithStrategy
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	    if (target === selection) {
	      return content;
	    }
	  }
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Fuse - Lightweight fuzzy-search
	 *
	 * Copyright (c) 2012-2016 Kirollos Risk <kirollos@gmail.com>.
	 * All Rights Reserved. Apache Software License 2.0
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License")
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	;(function (global) {
	  'use strict'
	
	  /** @type {function(...*)} */
	  function log () {
	    console.log.apply(console, arguments)
	  }
	
	  var defaultOptions = {
	    // The name of the identifier property. If specified, the returned result will be a list
	    // of the items' dentifiers, otherwise it will be a list of the items.
	    id: null,
	
	    // Indicates whether comparisons should be case sensitive.
	
	    caseSensitive: false,
	
	    // An array of values that should be included from the searcher's output. When this array
	    // contains elements, each result in the list will be of the form `{ item: ..., include1: ..., include2: ... }`.
	    // Values you can include are `score`, `matchedLocations`
	    include: [],
	
	    // Whether to sort the result list, by score
	    shouldSort: true,
	
	    // The search function to use
	    // Note that the default search function ([[Function]]) must conform to the following API:
	    //
	    //  @param pattern The pattern string to search
	    //  @param options The search option
	    //  [[Function]].constructor = function(pattern, options)
	    //
	    //  @param text: the string to search in for the pattern
	    //  @return Object in the form of:
	    //    - isMatch: boolean
	    //    - score: Int
	    //  [[Function]].prototype.search = function(text)
	    searchFn: BitapSearcher,
	
	    // Default sort function
	    sortFn: function (a, b) {
	      return a.score - b.score
	    },
	
	    // The get function to use when fetching an object's properties.
	    // The default will search nested paths *ie foo.bar.baz*
	    getFn: deepValue,
	
	    // List of properties that will be searched. This also supports nested properties.
	    keys: [],
	
	    // Will print to the console. Useful for debugging.
	    verbose: false,
	
	    // When true, the search algorithm will search individual words **and** the full string,
	    // computing the final score as a function of both. Note that when `tokenize` is `true`,
	    // the `threshold`, `distance`, and `location` are inconsequential for individual tokens.
	    tokenize: false,
	
	    // When true, the result set will only include records that match all tokens. Will only work
	    // if `tokenize` is also true.
	    matchAllTokens: false,
	
	    // Regex used to separate words when searching. Only applicable when `tokenize` is `true`.
	    tokenSeparator: / +/g,
	
	    // Minimum number of characters that must be matched before a result is considered a match
	    minMatchCharLength: 1,
	
	    // When true, the algorithm continues searching to the end of the input even if a perfect
	    // match is found before the end of the same input.
	    findAllMatches: false
	  }
	
	  /**
	   * @constructor
	   * @param {!Array} list
	   * @param {!Object<string, *>} options
	   */
	  function Fuse (list, options) {
	    var key
	
	    this.list = list
	    this.options = options = options || {}
	
	    for (key in defaultOptions) {
	      if (!defaultOptions.hasOwnProperty(key)) {
	        continue;
	      }
	      // Add boolean type options
	      if (typeof defaultOptions[key] === 'boolean') {
	        this.options[key] = key in options ? options[key] : defaultOptions[key];
	      // Add all other options
	      } else {
	        this.options[key] = options[key] || defaultOptions[key]
	      }
	    }
	  }
	
	  Fuse.VERSION = '2.6.2'
	
	  /**
	   * Sets a new list for Fuse to match against.
	   * @param {!Array} list
	   * @return {!Array} The newly set list
	   * @public
	   */
	  Fuse.prototype.set = function (list) {
	    this.list = list
	    return list
	  }
	
	  Fuse.prototype.search = function (pattern) {
	    if (this.options.verbose) log('\nSearch term:', pattern, '\n')
	
	    this.pattern = pattern
	    this.results = []
	    this.resultMap = {}
	    this._keyMap = null
	
	    this._prepareSearchers()
	    this._startSearch()
	    this._computeScore()
	    this._sort()
	
	    var output = this._format()
	    return output
	  }
	
	  Fuse.prototype._prepareSearchers = function () {
	    var options = this.options
	    var pattern = this.pattern
	    var searchFn = options.searchFn
	    var tokens = pattern.split(options.tokenSeparator)
	    var i = 0
	    var len = tokens.length
	
	    if (this.options.tokenize) {
	      this.tokenSearchers = []
	      for (; i < len; i++) {
	        this.tokenSearchers.push(new searchFn(tokens[i], options))
	      }
	    }
	    this.fullSeacher = new searchFn(pattern, options)
	  }
	
	  Fuse.prototype._startSearch = function () {
	    var options = this.options
	    var getFn = options.getFn
	    var list = this.list
	    var listLen = list.length
	    var keys = this.options.keys
	    var keysLen = keys.length
	    var key
	    var weight
	    var item = null
	    var i
	    var j
	
	    // Check the first item in the list, if it's a string, then we assume
	    // that every item in the list is also a string, and thus it's a flattened array.
	    if (typeof list[0] === 'string') {
	      // Iterate over every item
	      for (i = 0; i < listLen; i++) {
	        this._analyze('', list[i], i, i)
	      }
	    } else {
	      this._keyMap = {}
	      // Otherwise, the first item is an Object (hopefully), and thus the searching
	      // is done on the values of the keys of each item.
	      // Iterate over every item
	      for (i = 0; i < listLen; i++) {
	        item = list[i]
	        // Iterate over every key
	        for (j = 0; j < keysLen; j++) {
	          key = keys[j]
	          if (typeof key !== 'string') {
	            weight = (1 - key.weight) || 1
	            this._keyMap[key.name] = {
	              weight: weight
	            }
	            if (key.weight <= 0 || key.weight > 1) {
	              throw new Error('Key weight has to be > 0 and <= 1')
	            }
	            key = key.name
	          } else {
	            this._keyMap[key] = {
	              weight: 1
	            }
	          }
	          this._analyze(key, getFn(item, key, []), item, i)
	        }
	      }
	    }
	  }
	
	  Fuse.prototype._analyze = function (key, text, entity, index) {
	    var options = this.options
	    var words
	    var scores
	    var exists = false
	    var existingResult
	    var averageScore
	    var finalScore
	    var scoresLen
	    var mainSearchResult
	    var tokenSearcher
	    var termScores
	    var word
	    var tokenSearchResult
	    var hasMatchInText
	    var checkTextMatches
	    var i
	    var j
	
	    // Check if the text can be searched
	    if (text === undefined || text === null) {
	      return
	    }
	
	    scores = []
	
	    var numTextMatches = 0
	
	    if (typeof text === 'string') {
	      words = text.split(options.tokenSeparator)
	
	      if (options.verbose) log('---------\nKey:', key)
	
	      if (this.options.tokenize) {
	        for (i = 0; i < this.tokenSearchers.length; i++) {
	          tokenSearcher = this.tokenSearchers[i]
	
	          if (options.verbose) log('Pattern:', tokenSearcher.pattern)
	
	          termScores = []
	          hasMatchInText = false
	
	          for (j = 0; j < words.length; j++) {
	            word = words[j]
	            tokenSearchResult = tokenSearcher.search(word)
	            var obj = {}
	            if (tokenSearchResult.isMatch) {
	              obj[word] = tokenSearchResult.score
	              exists = true
	              hasMatchInText = true
	              scores.push(tokenSearchResult.score)
	            } else {
	              obj[word] = 1
	              if (!this.options.matchAllTokens) {
	                scores.push(1)
	              }
	            }
	            termScores.push(obj)
	          }
	
	          if (hasMatchInText) {
	            numTextMatches++
	          }
	
	          if (options.verbose) log('Token scores:', termScores)
	        }
	
	        averageScore = scores[0]
	        scoresLen = scores.length
	        for (i = 1; i < scoresLen; i++) {
	          averageScore += scores[i]
	        }
	        averageScore = averageScore / scoresLen
	
	        if (options.verbose) log('Token score average:', averageScore)
	      }
	
	      mainSearchResult = this.fullSeacher.search(text)
	      if (options.verbose) log('Full text score:', mainSearchResult.score)
	
	      finalScore = mainSearchResult.score
	      if (averageScore !== undefined) {
	        finalScore = (finalScore + averageScore) / 2
	      }
	
	      if (options.verbose) log('Score average:', finalScore)
	
	      checkTextMatches = (this.options.tokenize && this.options.matchAllTokens) ? numTextMatches >= this.tokenSearchers.length : true
	
	      if (options.verbose) log('Check Matches', checkTextMatches)
	
	      // If a match is found, add the item to <rawResults>, including its score
	      if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
	        // Check if the item already exists in our results
	        existingResult = this.resultMap[index]
	
	        if (existingResult) {
	          // Use the lowest score
	          // existingResult.score, bitapResult.score
	          existingResult.output.push({
	            key: key,
	            score: finalScore,
	            matchedIndices: mainSearchResult.matchedIndices
	          })
	        } else {
	          // Add it to the raw result list
	          this.resultMap[index] = {
	            item: entity,
	            output: [{
	              key: key,
	              score: finalScore,
	              matchedIndices: mainSearchResult.matchedIndices
	            }]
	          }
	
	          this.results.push(this.resultMap[index])
	        }
	      }
	    } else if (isArray(text)) {
	      for (i = 0; i < text.length; i++) {
	        this._analyze(key, text[i], entity, index)
	      }
	    }
	  }
	
	  Fuse.prototype._computeScore = function () {
	    var i
	    var j
	    var keyMap = this._keyMap
	    var totalScore
	    var output
	    var scoreLen
	    var score
	    var weight
	    var results = this.results
	    var bestScore
	    var nScore
	
	    if (this.options.verbose) log('\n\nComputing score:\n')
	
	    for (i = 0; i < results.length; i++) {
	      totalScore = 0
	      output = results[i].output
	      scoreLen = output.length
	
	      bestScore = 1
	
	      for (j = 0; j < scoreLen; j++) {
	        score = output[j].score
	        weight = keyMap ? keyMap[output[j].key].weight : 1
	
	        nScore = score * weight
	
	        if (weight !== 1) {
	          bestScore = Math.min(bestScore, nScore)
	        } else {
	          totalScore += nScore
	          output[j].nScore = nScore
	        }
	      }
	
	      if (bestScore === 1) {
	        results[i].score = totalScore / scoreLen
	      } else {
	        results[i].score = bestScore
	      }
	
	      if (this.options.verbose) log(results[i])
	    }
	  }
	
	  Fuse.prototype._sort = function () {
	    var options = this.options
	    if (options.shouldSort) {
	      if (options.verbose) log('\n\nSorting....')
	      this.results.sort(options.sortFn)
	    }
	  }
	
	  Fuse.prototype._format = function () {
	    var options = this.options
	    var getFn = options.getFn
	    var finalOutput = []
	    var item
	    var i
	    var len
	    var results = this.results
	    var replaceValue
	    var getItemAtIndex
	    var include = options.include
	
	    if (options.verbose) log('\n\nOutput:\n\n', results)
	
	    // Helper function, here for speed-up, which replaces the item with its value,
	    // if the options specifies it,
	    replaceValue = options.id ? function (index) {
	      results[index].item = getFn(results[index].item, options.id, [])[0]
	    } : function () {}
	
	    getItemAtIndex = function (index) {
	      var record = results[index]
	      var data
	      var j
	      var output
	      var _item
	      var _result
	
	      // If `include` has values, put the item in the result
	      if (include.length > 0) {
	        data = {
	          item: record.item
	        }
	        if (include.indexOf('matches') !== -1) {
	          output = record.output
	          data.matches = []
	          for (j = 0; j < output.length; j++) {
	            _item = output[j]
	            _result = {
	              indices: _item.matchedIndices
	            }
	            if (_item.key) {
	              _result.key = _item.key
	            }
	            data.matches.push(_result)
	          }
	        }
	
	        if (include.indexOf('score') !== -1) {
	          data.score = results[index].score
	        }
	
	      } else {
	        data = record.item
	      }
	
	      return data
	    }
	
	    // From the results, push into a new array only the item identifier (if specified)
	    // of the entire item.  This is because we don't want to return the <results>,
	    // since it contains other metadata
	    for (i = 0, len = results.length; i < len; i++) {
	      replaceValue(i)
	      item = getItemAtIndex(i)
	      finalOutput.push(item)
	    }
	
	    return finalOutput
	  }
	
	  // Helpers
	
	  function deepValue (obj, path, list) {
	    var firstSegment
	    var remaining
	    var dotIndex
	    var value
	    var i
	    var len
	
	    if (!path) {
	      // If there's no path left, we've gotten to the object we care about.
	      list.push(obj)
	    } else {
	      dotIndex = path.indexOf('.')
	
	      if (dotIndex !== -1) {
	        firstSegment = path.slice(0, dotIndex)
	        remaining = path.slice(dotIndex + 1)
	      } else {
	        firstSegment = path
	      }
	
	      value = obj[firstSegment]
	      if (value !== null && value !== undefined) {
	        if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
	          list.push(value)
	        } else if (isArray(value)) {
	          // Search each item in the array.
	          for (i = 0, len = value.length; i < len; i++) {
	            deepValue(value[i], remaining, list)
	          }
	        } else if (remaining) {
	          // An object. Recurse further.
	          deepValue(value, remaining, list)
	        }
	      }
	    }
	
	    return list
	  }
	
	  function isArray (obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]'
	  }
	
	  /**
	   * Adapted from "Diff, Match and Patch", by Google
	   *
	   *   http://code.google.com/p/google-diff-match-patch/
	   *
	   * Modified by: Kirollos Risk <kirollos@gmail.com>
	   * -----------------------------------------------
	   * Details: the algorithm and structure was modified to allow the creation of
	   * <Searcher> instances with a <search> method which does the actual
	   * bitap search. The <pattern> (the string that is searched for) is only defined
	   * once per instance and thus it eliminates redundant re-creation when searching
	   * over a list of strings.
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License")
	   * you may not use this file except in compliance with the License.
	   *
	   * @constructor
	   */
	  function BitapSearcher (pattern, options) {
	    options = options || {}
	    this.options = options
	    this.options.location = options.location || BitapSearcher.defaultOptions.location
	    this.options.distance = 'distance' in options ? options.distance : BitapSearcher.defaultOptions.distance
	    this.options.threshold = 'threshold' in options ? options.threshold : BitapSearcher.defaultOptions.threshold
	    this.options.maxPatternLength = options.maxPatternLength || BitapSearcher.defaultOptions.maxPatternLength
	
	    this.pattern = options.caseSensitive ? pattern : pattern.toLowerCase()
	    this.patternLen = pattern.length
	
	    if (this.patternLen <= this.options.maxPatternLength) {
	      this.matchmask = 1 << (this.patternLen - 1)
	      this.patternAlphabet = this._calculatePatternAlphabet()
	    }
	  }
	
	  BitapSearcher.defaultOptions = {
	    // Approximately where in the text is the pattern expected to be found?
	    location: 0,
	
	    // Determines how close the match must be to the fuzzy location (specified above).
	    // An exact letter match which is 'distance' characters away from the fuzzy location
	    // would score as a complete mismatch. A distance of '0' requires the match be at
	    // the exact location specified, a threshold of '1000' would require a perfect match
	    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
	    distance: 100,
	
	    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
	    // (of both letters and location), a threshold of '1.0' would match anything.
	    threshold: 0.6,
	
	    // Machine word size
	    maxPatternLength: 32
	  }
	
	  /**
	   * Initialize the alphabet for the Bitap algorithm.
	   * @return {Object} Hash of character locations.
	   * @private
	   */
	  BitapSearcher.prototype._calculatePatternAlphabet = function () {
	    var mask = {},
	      i = 0
	
	    for (i = 0; i < this.patternLen; i++) {
	      mask[this.pattern.charAt(i)] = 0
	    }
	
	    for (i = 0; i < this.patternLen; i++) {
	      mask[this.pattern.charAt(i)] |= 1 << (this.pattern.length - i - 1)
	    }
	
	    return mask
	  }
	
	  /**
	   * Compute and return the score for a match with `e` errors and `x` location.
	   * @param {number} errors Number of errors in match.
	   * @param {number} location Location of match.
	   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
	   * @private
	   */
	  BitapSearcher.prototype._bitapScore = function (errors, location) {
	    var accuracy = errors / this.patternLen,
	      proximity = Math.abs(this.options.location - location)
	
	    if (!this.options.distance) {
	      // Dodge divide by zero error.
	      return proximity ? 1.0 : accuracy
	    }
	    return accuracy + (proximity / this.options.distance)
	  }
	
	  /**
	   * Compute and return the result of the search
	   * @param {string} text The text to search in
	   * @return {{isMatch: boolean, score: number}} Literal containing:
	   *                          isMatch - Whether the text is a match or not
	   *                          score - Overall score for the match
	   * @public
	   */
	  BitapSearcher.prototype.search = function (text) {
	    var options = this.options
	    var i
	    var j
	    var textLen
	    var findAllMatches
	    var location
	    var threshold
	    var bestLoc
	    var binMin
	    var binMid
	    var binMax
	    var start, finish
	    var bitArr
	    var lastBitArr
	    var charMatch
	    var score
	    var locations
	    var matches
	    var isMatched
	    var matchMask
	    var matchedIndices
	    var matchesLen
	    var match
	
	    text = options.caseSensitive ? text : text.toLowerCase()
	
	    if (this.pattern === text) {
	      // Exact match
	      return {
	        isMatch: true,
	        score: 0,
	        matchedIndices: [[0, text.length - 1]]
	      }
	    }
	
	    // When pattern length is greater than the machine word length, just do a a regex comparison
	    if (this.patternLen > options.maxPatternLength) {
	      matches = text.match(new RegExp(this.pattern.replace(options.tokenSeparator, '|')))
	      isMatched = !!matches
	
	      if (isMatched) {
	        matchedIndices = []
	        for (i = 0, matchesLen = matches.length; i < matchesLen; i++) {
	          match = matches[i]
	          matchedIndices.push([text.indexOf(match), match.length - 1])
	        }
	      }
	
	      return {
	        isMatch: isMatched,
	        // TODO: revisit this score
	        score: isMatched ? 0.5 : 1,
	        matchedIndices: matchedIndices
	      }
	    }
	
	    findAllMatches = options.findAllMatches
	
	    location = options.location
	    // Set starting location at beginning text and initialize the alphabet.
	    textLen = text.length
	    // Highest score beyond which we give up.
	    threshold = options.threshold
	    // Is there a nearby exact match? (speedup)
	    bestLoc = text.indexOf(this.pattern, location)
	
	    // a mask of the matches
	    matchMask = []
	    for (i = 0; i < textLen; i++) {
	      matchMask[i] = 0
	    }
	
	    if (bestLoc != -1) {
	      threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
	      // What about in the other direction? (speed up)
	      bestLoc = text.lastIndexOf(this.pattern, location + this.patternLen)
	
	      if (bestLoc != -1) {
	        threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
	      }
	    }
	
	    bestLoc = -1
	    score = 1
	    locations = []
	    binMax = this.patternLen + textLen
	
	    for (i = 0; i < this.patternLen; i++) {
	      // Scan for the best match; each iteration allows for one more error.
	      // Run a binary search to determine how far from the match location we can stray
	      // at this error level.
	      binMin = 0
	      binMid = binMax
	      while (binMin < binMid) {
	        if (this._bitapScore(i, location + binMid) <= threshold) {
	          binMin = binMid
	        } else {
	          binMax = binMid
	        }
	        binMid = Math.floor((binMax - binMin) / 2 + binMin)
	      }
	
	      // Use the result from this iteration as the maximum for the next.
	      binMax = binMid
	      start = Math.max(1, location - binMid + 1)
	      if (findAllMatches) {
	        finish = textLen;
	      } else {
	        finish = Math.min(location + binMid, textLen) + this.patternLen
	      }
	
	      // Initialize the bit array
	      bitArr = Array(finish + 2)
	
	      bitArr[finish + 1] = (1 << i) - 1
	
	      for (j = finish; j >= start; j--) {
	        charMatch = this.patternAlphabet[text.charAt(j - 1)]
	
	        if (charMatch) {
	          matchMask[j - 1] = 1
	        }
	
	        if (i === 0) {
	          // First pass: exact match.
	          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch
	        } else {
	          // Subsequent passes: fuzzy match.
	          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch | (((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1) | lastBitArr[j + 1]
	        }
	        if (bitArr[j] & this.matchmask) {
	          score = this._bitapScore(i, j - 1)
	
	          // This match will almost certainly be better than any existing match.
	          // But check anyway.
	          if (score <= threshold) {
	            // Indeed it is
	            threshold = score
	            bestLoc = j - 1
	            locations.push(bestLoc)
	
	            if (bestLoc > location) {
	              // When passing loc, don't exceed our current distance from loc.
	              start = Math.max(1, 2 * location - bestLoc)
	            } else {
	              // Already passed loc, downhill from here on in.
	              break
	            }
	          }
	        }
	      }
	
	      // No hope for a (better) match at greater error levels.
	      if (this._bitapScore(i + 1, location) > threshold) {
	        break
	      }
	      lastBitArr = bitArr
	    }
	
	    matchedIndices = this._getMatchedIndices(matchMask)
	
	    // Count exact matches (those with a score of 0) to be "almost" exact
	    return {
	      isMatch: bestLoc >= 0,
	      score: score === 0 ? 0.001 : score,
	      matchedIndices: matchedIndices
	    }
	  }
	
	  BitapSearcher.prototype._getMatchedIndices = function (matchMask) {
	    var matchedIndices = []
	    var start = -1
	    var end = -1
	    var i = 0
	    var match
	    var len = matchMask.length
	    for (; i < len; i++) {
	      match = matchMask[i]
	      if (match && start === -1) {
	        start = i
	      } else if (!match && start !== -1) {
	        end = i - 1
	        if ((end - start) + 1 >= this.options.minMatchCharLength) {
	            matchedIndices.push([start, end])
	        }
	        start = -1
	      }
	    }
	    if (matchMask[i - 1]) {
	      if ((i-1 - start) + 1 >= this.options.minMatchCharLength) {
	        matchedIndices.push([start, i - 1])
	      }
	    }
	    return matchedIndices
	  }
	
	  // Export to Common JS Loader
	  if (true) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = Fuse
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(function () {
	      return Fuse
	    })
	  } else {
	    // Browser globals (root is window)
	    global.Fuse = Fuse
	  }
	
	})(this);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(456),
	    DomHandler = __webpack_require__(907);
	
	function defineProp(name, value){
		delete module.exports[name];
		module.exports[name] = value;
		return value;
	}
	
	module.exports = {
		Parser: Parser,
		Tokenizer: __webpack_require__(457),
		ElementType: __webpack_require__(159),
		DomHandler: DomHandler,
		get FeedHandler(){
			return defineProp("FeedHandler", __webpack_require__(1016));
		},
		get Stream(){
			return defineProp("Stream", __webpack_require__(1018));
		},
		get WritableStream(){
			return defineProp("WritableStream", __webpack_require__(458));
		},
		get ProxyHandler(){
			return defineProp("ProxyHandler", __webpack_require__(1017));
		},
		get DomUtils(){
			return defineProp("DomUtils", __webpack_require__(909));
		},
		get CollectingHandler(){
			return defineProp("CollectingHandler", __webpack_require__(1015));
		},
		// For legacy support
		DefaultHandler: DomHandler,
		get RssHandler(){
			return defineProp("RssHandler", this.FeedHandler);
		},
		//helper methods
		parseDOM: function(data, options){
			var handler = new DomHandler(options);
			new Parser(handler, options).end(data);
			return handler.dom;
		},
		parseFeed: function(feed, options){
			var handler = new module.exports.FeedHandler(options);
			new Parser(handler, options).end(feed);
			return handler.dom;
		},
		createDomStream: function(cb, options, elementCb){
			var handler = new DomHandler(cb, options, elementCb);
			return new Parser(handler, options);
		},
		// List of all events that the parser emits
		EVENTS: { /* Format: eventname: number of arguments */
			attribute: 2,
			cdatastart: 0,
			cdataend: 0,
			text: 1,
			processinginstruction: 2,
			comment: 1,
			commentend: 0,
			closetag: 1,
			opentag: 2,
			opentagname: 1,
			error: 1,
			end: 0
		}
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(85);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	var PlatformPeg = __webpack_require__(93);
	var TextForEvent = __webpack_require__(331);
	var Avatar = __webpack_require__(138);
	var dis = __webpack_require__(5);
	
	/*
	 * Dispatches:
	 * {
	 *   action: "notifier_enabled",
	 *   value: boolean
	 * }
	 */
	
	var Notifier = {
	    notifsByRoom: {},
	
	    notificationMessageForEvent: function notificationMessageForEvent(ev) {
	        return TextForEvent.textForEvent(ev);
	    },
	
	    _displayPopupNotification: function _displayPopupNotification(ev, room) {
	        var plaf = PlatformPeg.get();
	        if (!plaf) {
	            return;
	        }
	        if (!plaf.supportsNotifications() || !plaf.maySendNotifications()) {
	            return;
	        }
	        if (global.document.hasFocus()) {
	            return;
	        }
	
	        var msg = this.notificationMessageForEvent(ev);
	        if (!msg) return;
	
	        var title;
	        if (!ev.sender || room.name == ev.sender.name) {
	            title = room.name;
	            // notificationMessageForEvent includes sender,
	            // but we already have the sender here
	            if (ev.getContent().body) msg = ev.getContent().body;
	        } else if (ev.getType() == 'm.room.member') {
	            // context is all in the message here, we don't need
	            // to display sender info
	            title = room.name;
	        } else if (ev.sender) {
	            title = ev.sender.name + " (" + room.name + ")";
	            // notificationMessageForEvent includes sender,
	            // but we've just out sender in the title
	            if (ev.getContent().body) msg = ev.getContent().body;
	        }
	
	        var avatarUrl = ev.sender ? Avatar.avatarUrlForMember(ev.sender, 40, 40, 'crop') : null;
	
	        var notif = plaf.displayNotification(title, msg, avatarUrl, room);
	
	        // if displayNotification returns non-null,  the platform supports
	        // clearing notifications later, so keep track of this.
	        if (notif) {
	            if (this.notifsByRoom[ev.getRoomId()] === undefined) this.notifsByRoom[ev.getRoomId()] = [];
	            this.notifsByRoom[ev.getRoomId()].push(notif);
	        }
	    },
	
	    _playAudioNotification: function _playAudioNotification(ev, room) {
	        var e = document.getElementById("messageAudio");
	        if (e) {
	            e.load();
	            e.play();
	        }
	    },
	
	    start: function start() {
	        this.boundOnRoomTimeline = this.onRoomTimeline.bind(this);
	        this.boundOnSyncStateChange = this.onSyncStateChange.bind(this);
	        this.boundOnRoomReceipt = this.onRoomReceipt.bind(this);
	        MatrixClientPeg.get().on('Room.timeline', this.boundOnRoomTimeline);
	        MatrixClientPeg.get().on("Room.receipt", this.boundOnRoomReceipt);
	        MatrixClientPeg.get().on("sync", this.boundOnSyncStateChange);
	        this.toolbarHidden = false;
	        this.isSyncing = false;
	    },
	
	    stop: function stop() {
	        if (MatrixClientPeg.get() && this.boundOnRoomTimeline) {
	            MatrixClientPeg.get().removeListener('Room.timeline', this.boundOnRoomTimeline);
	            MatrixClientPeg.get().removeListener("Room.receipt", this.boundOnRoomReceipt);
	            MatrixClientPeg.get().removeListener('sync', this.boundOnSyncStateChange);
	        }
	        this.isSyncing = false;
	    },
	
	    supportsDesktopNotifications: function supportsDesktopNotifications() {
	        var plaf = PlatformPeg.get();
	        return plaf && plaf.supportsNotifications();
	    },
	
	    setEnabled: function setEnabled(enable, callback) {
	        var plaf = PlatformPeg.get();
	        if (!plaf) return;
	        // make sure that we persist the current setting audio_enabled setting
	        // before changing anything
	        if (global.localStorage) {
	            if (global.localStorage.getItem('audio_notifications_enabled') == null) {
	                this.setAudioEnabled(this.isEnabled());
	            }
	        }
	
	        if (enable) {
	            // Attempt to get permission from user
	            plaf.requestNotificationPermission().done(function (result) {
	                if (result !== 'granted') {
	                    // The permission request was dismissed or denied
	                    return;
	                }
	
	                if (global.localStorage) {
	                    global.localStorage.setItem('notifications_enabled', 'true');
	                }
	
	                if (callback) callback();
	                dis.dispatch({
	                    action: "notifier_enabled",
	                    value: true
	                });
	            });
	            // clear the notifications_hidden flag, so that if notifications are
	            // disabled again in the future, we will show the banner again.
	            this.setToolbarHidden(false);
	        } else {
	            if (!global.localStorage) return;
	            global.localStorage.setItem('notifications_enabled', 'false');
	            dis.dispatch({
	                action: "notifier_enabled",
	                value: false
	            });
	        }
	    },
	
	    isEnabled: function isEnabled() {
	        var plaf = PlatformPeg.get();
	        if (!plaf) return false;
	        if (!plaf.supportsNotifications()) return false;
	        if (!plaf.maySendNotifications()) return false;
	
	        if (!global.localStorage) return true;
	
	        var enabled = global.localStorage.getItem('notifications_enabled');
	        if (enabled === null) return true;
	        return enabled === 'true';
	    },
	
	    setAudioEnabled: function setAudioEnabled(enable) {
	        if (!global.localStorage) return;
	        global.localStorage.setItem('audio_notifications_enabled', enable ? 'true' : 'false');
	    },
	
	    isAudioEnabled: function isAudioEnabled(enable) {
	        if (!global.localStorage) return true;
	        var enabled = global.localStorage.getItem('audio_notifications_enabled');
	        // default to true if the popups are enabled
	        if (enabled === null) return this.isEnabled();
	        return enabled === 'true';
	    },
	
	    setToolbarHidden: function setToolbarHidden(hidden) {
	        var persistent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        this.toolbarHidden = hidden;
	
	        // XXX: why are we dispatching this here?
	        // this is nothing to do with notifier_enabled
	        dis.dispatch({
	            action: "notifier_enabled",
	            value: this.isEnabled()
	        });
	
	        // update the info to localStorage for persistent settings
	        if (persistent && global.localStorage) {
	            global.localStorage.setItem('notifications_hidden', hidden);
	        }
	    },
	
	    isToolbarHidden: function isToolbarHidden() {
	        // Check localStorage for any such meta data
	        if (global.localStorage) {
	            if (global.localStorage.getItem('notifications_hidden') === 'true') {
	                return true;
	            }
	        }
	
	        return this.toolbarHidden;
	    },
	
	    onSyncStateChange: function onSyncStateChange(state) {
	        if (state === "SYNCING") {
	            this.isSyncing = true;
	        } else if (state === "STOPPED" || state === "ERROR") {
	            this.isSyncing = false;
	        }
	    },
	
	    onRoomTimeline: function onRoomTimeline(ev, room, toStartOfTimeline, removed, data) {
	        if (toStartOfTimeline) return;
	        if (!room) return;
	        if (!this.isSyncing) return; // don't alert for any messages initially
	        if (ev.sender && ev.sender.userId == MatrixClientPeg.get().credentials.userId) return;
	        if (data.timeline.getTimelineSet() !== room.getUnfilteredTimelineSet()) return;
	
	        var actions = MatrixClientPeg.get().getPushActionsForEvent(ev);
	        if (actions && actions.notify) {
	            if (this.isEnabled()) {
	                this._displayPopupNotification(ev, room);
	            }
	            if (actions.tweaks.sound && this.isAudioEnabled()) {
	                this._playAudioNotification(ev, room);
	            }
	        }
	    },
	
	    onRoomReceipt: function onRoomReceipt(ev, room) {
	        if (room.getUnreadNotificationCount() == 0) {
	            // ideally we would clear each notification when it was read,
	            // but we have no way, given a read receipt, to know whether
	            // the receipt comes before or after an event, so we can't
	            // do this. Instead, clear all notifications for a room once
	            // there are no notifs left in that room., which is not quite
	            // as good but it's something.
	            var plaf = PlatformPeg.get();
	            if (!plaf) return;
	            if (this.notifsByRoom[room.roomId] === undefined) return;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(this.notifsByRoom[room.roomId]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var notif = _step.value;
	
	                    plaf.clearNotification(notif);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            delete this.notifsByRoom[room.roomId];
	        }
	    }
	};
	
	if (!global.mxNotifier) {
	    global.mxNotifier = Notifier;
	}
	
	module.exports = global.mxNotifier;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutocompleteProvider = function () {
	    function AutocompleteProvider(commandRegex, fuseOpts) {
	        (0, _classCallCheck3.default)(this, AutocompleteProvider);
	
	        if (commandRegex) {
	            if (!commandRegex.global) {
	                throw new Error('commandRegex must have global flag set');
	            }
	            this.commandRegex = commandRegex;
	        }
	    }
	
	    /**
	     * Of the matched commands in the query, returns the first that contains or is contained by the selection, or null.
	     */
	
	
	    (0, _createClass3.default)(AutocompleteProvider, [{
	        key: 'getCurrentCommand',
	        value: function getCurrentCommand(query, selection) {
	            var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var commandRegex = this.commandRegex;
	
	            if (force && this.shouldForceComplete()) {
	                commandRegex = /\S+/g;
	            }
	
	            if (commandRegex == null) {
	                return null;
	            }
	
	            commandRegex.lastIndex = 0;
	
	            var match = void 0;
	            while ((match = commandRegex.exec(query)) != null) {
	                var matchStart = match.index,
	                    matchEnd = matchStart + match[0].length;
	                if (selection.start <= matchEnd && selection.end >= matchStart) {
	                    return {
	                        command: match,
	                        range: {
	                            start: matchStart,
	                            end: matchEnd
	                        }
	                    };
	                }
	            }
	            return {
	                command: null,
	                range: {
	                    start: -1,
	                    end: -1
	                }
	            };
	        }
	    }, {
	        key: 'getCompletions',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, selection) {
	                var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                return _context.abrupt('return', []);
	
	                            case 1:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getCompletions(_x2, _x3) {
	                return _ref.apply(this, arguments);
	            }
	
	            return getCompletions;
	        }()
	    }, {
	        key: 'getName',
	        value: function getName() {
	            return 'Default Provider';
	        }
	    }, {
	        key: 'renderCompletions',
	        value: function renderCompletions(completions) {
	            console.error('stub; should be implemented in subclasses');
	            return null;
	        }
	
	        // Whether we should provide completions even if triggered forcefully, without a sigil.
	
	    }, {
	        key: 'shouldForceComplete',
	        value: function shouldForceComplete() {
	            return false;
	        }
	    }]);
	    return AutocompleteProvider;
	}();
	
	exports.default = AutocompleteProvider;
	module.exports = exports['default'];


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PillCompletion = exports.TextualCompletion = undefined;
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(96);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(18);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* These were earlier stateless functional components but had to be converted
	since we need to use refs/findDOMNode to access the underlying DOM node to focus the correct completion,
	something that is not entirely possible with stateless functional components. One could
	presumably wrap them in a <div> before rendering but I think this is the better way to do it.
	 */
	
	var TextualCompletion = exports.TextualCompletion = function (_React$Component) {
	    (0, _inherits3.default)(TextualCompletion, _React$Component);
	
	    function TextualCompletion() {
	        (0, _classCallCheck3.default)(this, TextualCompletion);
	        return (0, _possibleConstructorReturn3.default)(this, (TextualCompletion.__proto__ || (0, _getPrototypeOf2.default)(TextualCompletion)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(TextualCompletion, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                subtitle = _props.subtitle,
	                description = _props.description,
	                className = _props.className,
	                restProps = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'description', 'className']);
	
	            return _react2.default.createElement(
	                'div',
	                (0, _extends3.default)({ className: (0, _classnames2.default)('mx_Autocomplete_Completion_block', className) }, restProps),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mx_Autocomplete_Completion_title' },
	                    title
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mx_Autocomplete_Completion_subtitle' },
	                    subtitle
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mx_Autocomplete_Completion_description' },
	                    description
	                )
	            );
	        }
	    }]);
	    return TextualCompletion;
	}(_react2.default.Component);
	
	TextualCompletion.propTypes = {
	    title: _react2.default.PropTypes.string,
	    subtitle: _react2.default.PropTypes.string,
	    description: _react2.default.PropTypes.string,
	    className: _react2.default.PropTypes.string
	};
	
	var PillCompletion = exports.PillCompletion = function (_React$Component2) {
	    (0, _inherits3.default)(PillCompletion, _React$Component2);
	
	    function PillCompletion() {
	        (0, _classCallCheck3.default)(this, PillCompletion);
	        return (0, _possibleConstructorReturn3.default)(this, (PillCompletion.__proto__ || (0, _getPrototypeOf2.default)(PillCompletion)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(PillCompletion, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                title = _props2.title,
	                subtitle = _props2.subtitle,
	                description = _props2.description,
	                initialComponent = _props2.initialComponent,
	                className = _props2.className,
	                restProps = (0, _objectWithoutProperties3.default)(_props2, ['title', 'subtitle', 'description', 'initialComponent', 'className']);
	
	            return _react2.default.createElement(
	                'div',
	                (0, _extends3.default)({ className: (0, _classnames2.default)('mx_Autocomplete_Completion_pill', className) }, restProps),
	                initialComponent,
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mx_Autocomplete_Completion_title' },
	                    title
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mx_Autocomplete_Completion_subtitle' },
	                    subtitle
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mx_Autocomplete_Completion_description' },
	                    description
	                )
	            );
	        }
	    }]);
	    return PillCompletion;
	}(_react2.default.Component);
	
	PillCompletion.propTypes = {
	    title: _react2.default.PropTypes.string,
	    subtitle: _react2.default.PropTypes.string,
	    description: _react2.default.PropTypes.string,
	    initialComponent: _react2.default.PropTypes.element,
	    className: _react2.default.PropTypes.string
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var EventPluginRegistry = __webpack_require__(346);
	var EventPluginUtils = __webpack_require__(347);
	var ReactErrorUtils = __webpack_require__(351);
	
	var accumulateInto = __webpack_require__(545);
	var forEachAccumulated = __webpack_require__(546);
	var invariant = __webpack_require__(7);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(173);
	var EventPluginUtils = __webpack_require__(347);
	
	var accumulateInto = __webpack_require__(545);
	var forEachAccumulated = __webpack_require__(546);
	var warning = __webpack_require__(14);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	var getEventTarget = __webpack_require__(356);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(643), __esModule: true };

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(644), __esModule: true };

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(239);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(612);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var buffer = __webpack_require__(88);
	var Buffer = buffer.Buffer;
	var SlowBuffer = buffer.SlowBuffer;
	var MAX_LEN = buffer.kMaxLength || 2147483647;
	exports.alloc = function alloc(size, fill, encoding) {
	  if (typeof Buffer.alloc === 'function') {
	    return Buffer.alloc(size, fill, encoding);
	  }
	  if (typeof encoding === 'number') {
	    throw new TypeError('encoding must not be number');
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size > MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  var enc = encoding;
	  var _fill = fill;
	  if (_fill === undefined) {
	    enc = undefined;
	    _fill = 0;
	  }
	  var buf = new Buffer(size);
	  if (typeof _fill === 'string') {
	    var fillBuf = new Buffer(_fill, enc);
	    var flen = fillBuf.length;
	    var i = -1;
	    while (++i < size) {
	      buf[i] = fillBuf[i % flen];
	    }
	  } else {
	    buf.fill(_fill);
	  }
	  return buf;
	}
	exports.allocUnsafe = function allocUnsafe(size) {
	  if (typeof Buffer.allocUnsafe === 'function') {
	    return Buffer.allocUnsafe(size);
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size > MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  return new Buffer(size);
	}
	exports.from = function from(value, encodingOrOffset, length) {
	  if (typeof Buffer.from === 'function' && (!global.Uint8Array || Uint8Array.from !== Buffer.from)) {
	    return Buffer.from(value, encodingOrOffset, length);
	  }
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	  if (typeof value === 'string') {
	    return new Buffer(value, encodingOrOffset);
	  }
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    var offset = encodingOrOffset;
	    if (arguments.length === 1) {
	      return new Buffer(value);
	    }
	    if (typeof offset === 'undefined') {
	      offset = 0;
	    }
	    var len = length;
	    if (typeof len === 'undefined') {
	      len = value.byteLength - offset;
	    }
	    if (offset >= value.byteLength) {
	      throw new RangeError('\'offset\' is out of bounds');
	    }
	    if (len > value.byteLength - offset) {
	      throw new RangeError('\'length\' is out of bounds');
	    }
	    return new Buffer(value.slice(offset, offset + len));
	  }
	  if (Buffer.isBuffer(value)) {
	    var out = new Buffer(value.length);
	    value.copy(out, 0, 0, value.length);
	    return out;
	  }
	  if (value) {
	    if (Array.isArray(value) || (typeof ArrayBuffer !== 'undefined' && value.buffer instanceof ArrayBuffer) || 'length' in value) {
	      return new Buffer(value);
	    }
	    if (value.type === 'Buffer' && Array.isArray(value.data)) {
	      return new Buffer(value.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ' + 'ArrayBuffer, Array, or array-like object.');
	}
	exports.allocUnsafeSlow = function allocUnsafeSlow(size) {
	  if (typeof Buffer.allocUnsafeSlow === 'function') {
	    return Buffer.allocUnsafeSlow(size);
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size >= MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  return new SlowBuffer(size);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	module.exports = true;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(185)('meta')
	  , isObject = __webpack_require__(46)
	  , has      = __webpack_require__(98)
	  , setDesc  = __webpack_require__(78).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(126)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(78).f
	  , has = __webpack_require__(98)
	  , TAG = __webpack_require__(39)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(686);
	var global        = __webpack_require__(53)
	  , hide          = __webpack_require__(99)
	  , Iterators     = __webpack_require__(127)
	  , TO_STRING_TAG = __webpack_require__(39)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(51)
	  , toLength  = __webpack_require__(35)
	  , toIndex   = __webpack_require__(108);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(13)
	  , $export           = __webpack_require__(3)
	  , redefine          = __webpack_require__(49)
	  , redefineAll       = __webpack_require__(106)
	  , meta              = __webpack_require__(89)
	  , forOf             = __webpack_require__(129)
	  , anInstance        = __webpack_require__(101)
	  , isObject          = __webpack_require__(25)
	  , fails             = __webpack_require__(17)
	  , $iterDetect       = __webpack_require__(193)
	  , setToStringTag    = __webpack_require__(131)
	  , inheritIfRequired = __webpack_require__(264);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(48)
	  , redefine = __webpack_require__(49)
	  , fails    = __webpack_require__(17)
	  , defined  = __webpack_require__(61)
	  , wks      = __webpack_require__(29);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(11);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(25)
	  , cof      = __webpack_require__(60)
	  , MATCH    = __webpack_require__(29)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(29)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(102)|| !__webpack_require__(17)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(13)[K];
	});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13)
	  , hide   = __webpack_require__(48)
	  , uid    = __webpack_require__(109)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.beginDrag = beginDrag;
	exports.publishDragSource = publishDragSource;
	exports.hover = hover;
	exports.drop = drop;
	exports.endDrag = endDrag;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(37);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(137);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _matchesType = __webpack_require__(423);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
	var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
	var HOVER = exports.HOVER = 'dnd-core/HOVER';
	var DROP = exports.DROP = 'dnd-core/DROP';
	var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
	
	function beginDrag(sourceIds) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
	  var publishSource = options.publishSource,
	      clientOffset = options.clientOffset,
	      getSourceClientOffset = options.getSourceClientOffset;
	
	  (0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
	  for (var i = 0; i < sourceIds.length; i++) {
	    (0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	  }
	
	  var sourceId = null;
	  for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
	    if (monitor.canDragSource(sourceIds[_i])) {
	      sourceId = sourceIds[_i];
	      break;
	    }
	  }
	  if (sourceId === null) {
	    return;
	  }
	
	  var sourceClientOffset = null;
	  if (clientOffset) {
	    (0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
	    sourceClientOffset = getSourceClientOffset(sourceId);
	  }
	
	  var source = registry.getSource(sourceId);
	  var item = source.beginDrag(monitor, sourceId);
	  (0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
	
	  registry.pinSource(sourceId);
	
	  var itemType = registry.getSourceType(sourceId);
	  return {
	    type: BEGIN_DRAG,
	    itemType: itemType,
	    item: item,
	    sourceId: sourceId,
	    clientOffset: clientOffset,
	    sourceClientOffset: sourceClientOffset,
	    isSourcePublic: publishSource
	  };
	}
	
	function publishDragSource() {
	  var monitor = this.getMonitor();
	  if (!monitor.isDragging()) {
	    return;
	  }
	
	  return { type: PUBLISH_DRAG_SOURCE };
	}
	
	function hover(targetIdsArg) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$clientOffset = _ref.clientOffset,
	      clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	
	  (0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
	  var targetIds = targetIdsArg.slice(0);
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
	  // First check invariants.
	  for (var i = 0; i < targetIds.length; i++) {
	    var targetId = targetIds[i];
	    (0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
	    var target = registry.getTarget(targetId);
	    (0, _invariant2.default)(target, 'Expected targetIds to be registered.');
	  }
	
	  var draggedItemType = monitor.getItemType();
	
	  // Remove those targetIds that don't match the targetType.  This
	  // fixes shallow isOver which would only be non-shallow because of
	  // non-matching targets.
	  for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
	    var _targetId = targetIds[_i2];
	    var targetType = registry.getTargetType(_targetId);
	    if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
	      targetIds.splice(_i2, 1);
	    }
	  }
	
	  // Finally call hover on all matching targets.
	  for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
	    var _targetId2 = targetIds[_i3];
	    var _target = registry.getTarget(_targetId2);
	    _target.hover(monitor, _targetId2);
	  }
	
	  return {
	    type: HOVER,
	    targetIds: targetIds,
	    clientOffset: clientOffset
	  };
	}
	
	function drop() {
	  var _this = this;
	
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
	  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
	  targetIds.reverse();
	  targetIds.forEach(function (targetId, index) {
	    var target = registry.getTarget(targetId);
	
	    var dropResult = target.drop(monitor, targetId);
	    (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
	    if (typeof dropResult === 'undefined') {
	      dropResult = index === 0 ? {} : monitor.getDropResult();
	    }
	
	    _this.store.dispatch({
	      type: DROP,
	      dropResult: _extends({}, options, dropResult)
	    });
	  });
	}
	
	function endDrag() {
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
	  var sourceId = monitor.getSourceId();
	  var source = registry.getSource(sourceId, true);
	  source.endDrag(monitor, sourceId);
	
	  registry.unpinSource();
	
	  return { type: END_DRAG };
	}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addSource = addSource;
	exports.addTarget = addTarget;
	exports.removeSource = removeSource;
	exports.removeTarget = removeTarget;
	var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
	var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
	var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
	var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
	function addSource(sourceId) {
	  return {
	    type: ADD_SOURCE,
	    sourceId: sourceId
	  };
	}
	
	function addTarget(targetId) {
	  return {
	    type: ADD_TARGET,
	    targetId: targetId
	  };
	}
	
	function removeSource(sourceId) {
	  return {
	    type: REMOVE_SOURCE,
	    sourceId: sourceId
	  };
	}
	
	function removeTarget(targetId) {
	  return {
	    type: REMOVE_TARGET,
	    targetId: targetId
	  };
	}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftOffsetKey
	 * 
	 */
	
	'use strict';
	
	var KEY_DELIMITER = '-';
	
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	
	  decode: function decode(offsetKey) {
	    var _offsetKey$split = offsetKey.split(KEY_DELIMITER);
	
	    var blockKey = _offsetKey$split[0];
	    var decoratorKey = _offsetKey$split[1];
	    var leafKey = _offsetKey$split[2];
	
	    return {
	      blockKey: blockKey,
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	
	module.exports = DraftOffsetKey;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findRangesImmutable
	 * 
	 */
	
	'use strict';
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    /* $FlowFixMe(>=0.28.0): `value` could be undefined! */
	    if (!areEqualFn(value, nextValue)) {
	      /* $FlowFixMe(>=0.28.0): `value` could be undefined! */
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	      cursor = nextIndex;
	    }
	    return nextValue;
	  });
	
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getContentStateFragment
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var generateRandomKey = __webpack_require__(70);
	var removeEntitiesAtEdges = __webpack_require__(444);
	
	function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	
	  var slice = blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var newKey = generateRandomKey();
	
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block.set('key', newKey);
	  });
	
	  return slice.toOrderedMap();
	}
	
	module.exports = getContentStateFragment;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(303);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.inherits = inherits;
	function inherits(parent, child) {
		var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		var extended = Object.create(parent.prototype);
		for (var p in props) {
			extended[p] = props[p];
		}
		extended.constructor = child;
		child.prototype = extended;
		return child;
	}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1090),
	    listCacheDelete = __webpack_require__(1091),
	    listCacheGet = __webpack_require__(1092),
	    listCacheHas = __webpack_require__(1093),
	    listCacheSet = __webpack_require__(1094);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(306),
	    setCacheAdd = __webpack_require__(1107),
	    setCacheHas = __webpack_require__(1108);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(169);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1088);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(112);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(319);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(136),
	    isObjectLike = __webpack_require__(113);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	/**
	 * @module content-repo
	 */
	var utils = __webpack_require__(16);
	
	/** Content Repo utility functions */
	module.exports = {
	    /**
	     * Get the HTTP URL for an MXC URI.
	     * @param {string} baseUrl The base homeserver url which has a content repo.
	     * @param {string} mxc The mxc:// URI.
	     * @param {Number} width The desired width of the thumbnail.
	     * @param {Number} height The desired height of the thumbnail.
	     * @param {string} resizeMethod The thumbnail resize method to use, either
	     * "crop" or "scale".
	     * @param {Boolean} allowDirectLinks If true, return any non-mxc URLs
	     * directly. Fetching such URLs will leak information about the user to
	     * anyone they share a room with. If false, will return the emptry string
	     * for such URLs.
	     * @return {string} The complete URL to the content.
	     */
	    getHttpUriForMxc: function getHttpUriForMxc(baseUrl, mxc, width, height, resizeMethod, allowDirectLinks) {
	        if (typeof mxc !== "string" || !mxc) {
	            return '';
	        }
	        if (mxc.indexOf("mxc://") !== 0) {
	            if (allowDirectLinks) {
	                return mxc;
	            } else {
	                return '';
	            }
	        }
	        var serverAndMediaId = mxc.slice(6); // strips mxc://
	        var prefix = "/_matrix/media/v1/download/";
	        var params = {};
	
	        if (width) {
	            params.width = width;
	        }
	        if (height) {
	            params.height = height;
	        }
	        if (resizeMethod) {
	            params.method = resizeMethod;
	        }
	        if (utils.keys(params).length > 0) {
	            // these are thumbnailing params so they probably want the
	            // thumbnailing API...
	            prefix = "/_matrix/media/v1/thumbnail/";
	        }
	
	        var fragmentOffset = serverAndMediaId.indexOf("#");
	        var fragment = "";
	        if (fragmentOffset >= 0) {
	            fragment = serverAndMediaId.substr(fragmentOffset);
	            serverAndMediaId = serverAndMediaId.substr(0, fragmentOffset);
	        }
	        return baseUrl + prefix + serverAndMediaId + (utils.keys(params).length === 0 ? "" : "?" + utils.encodeParams(params)) + fragment;
	    },
	
	    /**
	     * Get an identicon URL from an arbitrary string.
	     * @param {string} baseUrl The base homeserver url which has a content repo.
	     * @param {string} identiconString The string to create an identicon for.
	     * @param {Number} width The desired width of the image in pixels. Default: 96.
	     * @param {Number} height The desired height of the image in pixels. Default: 96.
	     * @return {string} The complete URL to the identicon.
	     */
	    getIdenticonUri: function getIdenticonUri(baseUrl, identiconString, width, height) {
	        if (!identiconString) {
	            return null;
	        }
	        if (!width) {
	            width = 96;
	        }
	        if (!height) {
	            height = 96;
	        }
	        var params = {
	            width: width,
	            height: height
	        };
	
	        var path = utils.encodeUri("/_matrix/media/v1/identicon/$ident", {
	            $ident: identiconString
	        });
	        return baseUrl + path + (utils.keys(params).length === 0 ? "" : "?" + utils.encodeParams(params));
	    }
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * @module olmlib
	 *
	 * Utilities common to olm encryption algorithms
	 */
	
	var q = __webpack_require__(6);
	var anotherjson = __webpack_require__(372);
	
	var utils = __webpack_require__(16);
	
	/**
	 * matrix algorithm tag for olm
	 */
	module.exports.OLM_ALGORITHM = "m.olm.v1.curve25519-aes-sha2";
	
	/**
	 * matrix algorithm tag for megolm
	 */
	module.exports.MEGOLM_ALGORITHM = "m.megolm.v1.aes-sha2";
	
	/**
	 * Encrypt an event payload for an Olm device
	 *
	 * @param {Object<string, string>} resultsObject  The `ciphertext` property
	 *   of the m.room.encrypted event to which to add our result
	 *
	 * @param {string} ourUserId
	 * @param {string} ourDeviceId
	 * @param {module:crypto/OlmDevice} olmDevice olm.js wrapper
	 * @param {string} recipientUserId
	 * @param {module:crypto/deviceinfo} recipientDevice
	 * @param {object} payloadFields fields to include in the encrypted payload
	 */
	module.exports.encryptMessageForDevice = function (resultsObject, ourUserId, ourDeviceId, olmDevice, recipientUserId, recipientDevice, payloadFields) {
	    var deviceKey = recipientDevice.getIdentityKey();
	    var sessionId = olmDevice.getSessionIdForDevice(deviceKey);
	    if (sessionId === null) {
	        // If we don't have a session for a device then
	        // we can't encrypt a message for it.
	        return;
	    }
	
	    console.log("Using sessionid " + sessionId + " for device " + recipientUserId + ":" + recipientDevice.deviceId);
	
	    var payload = {
	        sender: ourUserId,
	        sender_device: ourDeviceId,
	
	        // Include the Ed25519 key so that the recipient knows what
	        // device this message came from.
	        // We don't need to include the curve25519 key since the
	        // recipient will already know this from the olm headers.
	        // When combined with the device keys retrieved from the
	        // homeserver signed by the ed25519 key this proves that
	        // the curve25519 key and the ed25519 key are owned by
	        // the same device.
	        keys: {
	            "ed25519": olmDevice.deviceEd25519Key
	        },
	
	        // include the recipient device details in the payload,
	        // to avoid unknown key attacks, per
	        // https://github.com/vector-im/vector-web/issues/2483
	        recipient: recipientUserId,
	        recipient_keys: {
	            "ed25519": recipientDevice.getFingerprint()
	        }
	    };
	
	    // TODO: technically, a bunch of that stuff only needs to be included for
	    // pre-key messages: after that, both sides know exactly which devices are
	    // involved in the session. If we're looking to reduce data transfer in the
	    // future, we could elide them for subsequent messages.
	
	    utils.extend(payload, payloadFields);
	
	    resultsObject[deviceKey] = olmDevice.encryptMessage(deviceKey, sessionId, JSON.stringify(payload));
	};
	
	/**
	 * Try to make sure we have established olm sessions for the given devices.
	 *
	 * @param {module:crypto/OlmDevice} olmDevice
	 *
	 * @param {module:base-apis~MatrixBaseApis} baseApis
	 *
	 * @param {object<string, module:crypto/deviceinfo[]>} devicesByUser
	 *    map from userid to list of devices
	 *
	 * @return {module:client.Promise} resolves once the sessions are complete, to
	 *    an Object mapping from userId to deviceId to
	 *    {@link module:crypto~OlmSessionResult}
	 */
	module.exports.ensureOlmSessionsForDevices = function (olmDevice, baseApis, devicesByUser) {
	    var devicesWithoutSession = [
	        // [userId, deviceId], ...
	    ];
	    var result = {};
	
	    for (var userId in devicesByUser) {
	        if (!devicesByUser.hasOwnProperty(userId)) {
	            continue;
	        }
	        result[userId] = {};
	        var devices = devicesByUser[userId];
	        for (var j = 0; j < devices.length; j++) {
	            var deviceInfo = devices[j];
	            var deviceId = deviceInfo.deviceId;
	            var key = deviceInfo.getIdentityKey();
	            var sessionId = olmDevice.getSessionIdForDevice(key);
	            if (sessionId === null) {
	                devicesWithoutSession.push([userId, deviceId]);
	            }
	            result[userId][deviceId] = {
	                device: deviceInfo,
	                sessionId: sessionId
	            };
	        }
	    }
	
	    if (devicesWithoutSession.length === 0) {
	        return q(result);
	    }
	
	    // TODO: this has a race condition - if we try to send another message
	    // while we are claiming a key, we will end up claiming two and setting up
	    // two sessions.
	    //
	    // That should eventually resolve itself, but it's poor form.
	
	    var oneTimeKeyAlgorithm = "signed_curve25519";
	    return baseApis.claimOneTimeKeys(devicesWithoutSession, oneTimeKeyAlgorithm).then(function (res) {
	        var otk_res = res.one_time_keys || {};
	        for (var _userId in devicesByUser) {
	            if (!devicesByUser.hasOwnProperty(_userId)) {
	                continue;
	            }
	            var userRes = otk_res[_userId] || {};
	            var _devices = devicesByUser[_userId];
	            for (var _j = 0; _j < _devices.length; _j++) {
	                var _deviceInfo = _devices[_j];
	                var _deviceId = _deviceInfo.deviceId;
	                if (result[_userId][_deviceId].sessionId) {
	                    // we already have a result for this device
	                    continue;
	                }
	
	                var deviceRes = userRes[_deviceId] || {};
	                var oneTimeKey = null;
	                for (var keyId in deviceRes) {
	                    if (keyId.indexOf(oneTimeKeyAlgorithm + ":") === 0) {
	                        oneTimeKey = deviceRes[keyId];
	                    }
	                }
	
	                if (!oneTimeKey) {
	                    console.warn("No one-time keys (alg=" + oneTimeKeyAlgorithm + ") for device " + _userId + ":" + _deviceId);
	                    continue;
	                }
	
	                var sid = _verifyKeyAndStartSession(olmDevice, oneTimeKey, _userId, _deviceInfo);
	                result[_userId][_deviceId].sessionId = sid;
	            }
	        }
	        return result;
	    });
	};
	
	function _verifyKeyAndStartSession(olmDevice, oneTimeKey, userId, deviceInfo) {
	    var deviceId = deviceInfo.deviceId;
	    try {
	        _verifySignature(olmDevice, oneTimeKey, userId, deviceId, deviceInfo.getFingerprint());
	    } catch (e) {
	        console.error("Unable to verify signature on one-time key for device " + userId + ":" + deviceId + ":", e);
	        return null;
	    }
	
	    var sid = void 0;
	    try {
	        sid = olmDevice.createOutboundSession(deviceInfo.getIdentityKey(), oneTimeKey.key);
	    } catch (e) {
	        // possibly a bad key
	        console.error("Error starting session with device " + userId + ":" + deviceId + ": " + e);
	        return null;
	    }
	
	    console.log("Started new sessionid " + sid + " for device " + userId + ":" + deviceId);
	    return sid;
	}
	
	/**
	 * Verify the signature on an object
	 *
	 * @param {module:crypto/OlmDevice} olmDevice olm wrapper to use for verify op
	 *
	 * @param {Object} obj object to check signature on. Note that this will be
	 * stripped of its 'signatures' and 'unsigned' properties.
	 *
	 * @param {string} signingUserId  ID of the user whose signature should be checked
	 *
	 * @param {string} signingDeviceId  ID of the device whose signature should be checked
	 *
	 * @param {string} signingKey   base64-ed ed25519 public key
	 */
	var _verifySignature = module.exports.verifySignature = function (olmDevice, obj, signingUserId, signingDeviceId, signingKey) {
	    var signKeyId = "ed25519:" + signingDeviceId;
	    var signatures = obj.signatures || {};
	    var userSigs = signatures[signingUserId] || {};
	    var signature = userSigs[signKeyId];
	    if (!signature) {
	        throw Error("No signature");
	    }
	
	    // prepare the canonical json: remove unsigned and signatures, and stringify with
	    // anotherjson
	    delete obj.unsigned;
	    delete obj.signatures;
	    var json = anotherjson.stringify(obj);
	
	    olmDevice.verifySignature(signingKey, json, signature);
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module. See {@link MatrixHttpApi} for the public class.
	 * @module http-api
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var q = __webpack_require__(6);
	var utils = __webpack_require__(16);
	
	// we use our own implementation of setTimeout, so that if we get suspended in
	// the middle of a /sync, we cancel the sync as soon as we awake, rather than
	// waiting for the delay to elapse.
	var callbacks = __webpack_require__(1147);
	
	/*
	TODO:
	- CS: complete register function (doing stages)
	- Identity server: linkEmail, authEmail, bindEmail, lookup3pid
	*/
	
	/**
	 * A constant representing the URI path for release 0 of the Client-Server HTTP API.
	 */
	module.exports.PREFIX_R0 = "/_matrix/client/r0";
	
	/**
	 * A constant representing the URI path for as-yet unspecified Client-Server HTTP APIs.
	 */
	module.exports.PREFIX_UNSTABLE = "/_matrix/client/unstable";
	
	/**
	 * URI path for the identity API
	 */
	module.exports.PREFIX_IDENTITY_V1 = "/_matrix/identity/api/v1";
	
	/**
	 * URI path for the media repo API
	 */
	module.exports.PREFIX_MEDIA_R0 = "/_matrix/media/r0";
	
	/**
	 * Construct a MatrixHttpApi.
	 * @constructor
	 * @param {EventEmitter} event_emitter The event emitter to use for emitting events
	 * @param {Object} opts The options to use for this HTTP API.
	 * @param {string} opts.baseUrl Required. The base client-server URL e.g.
	 * 'http://localhost:8008'.
	 * @param {Function} opts.request Required. The function to call for HTTP
	 * requests. This function must look like function(opts, callback){ ... }.
	 * @param {string} opts.prefix Required. The matrix client prefix to use, e.g.
	 * '/_matrix/client/r0'. See PREFIX_R0 and PREFIX_UNSTABLE for constants.
	 *
	 * @param {bool=} opts.onlyData True to return only the 'data' component of the
	 * response (e.g. the parsed HTTP body). If false, requests will return an
	 * object with the properties <tt>code</tt>, <tt>headers</tt> and <tt>data</tt>.
	 *
	 * @param {string} opts.accessToken The access_token to send with requests. Can be
	 * null to not send an access token.
	 * @param {Object=} opts.extraParams Optional. Extra query parameters to send on
	 * requests.
	 * @param {Number=} opts.localTimeoutMs The default maximum amount of time to wait
	 * before timing out the request. If not specified, there is no timeout.
	 */
	module.exports.MatrixHttpApi = function MatrixHttpApi(event_emitter, opts) {
	    utils.checkObjectHasKeys(opts, ["baseUrl", "request", "prefix"]);
	    opts.onlyData = opts.onlyData || false;
	    this.event_emitter = event_emitter;
	    this.opts = opts;
	    this.uploads = [];
	};
	
	module.exports.MatrixHttpApi.prototype = {
	
	    /**
	     * Get the content repository url with query parameters.
	     * @return {Object} An object with a 'base', 'path' and 'params' for base URL,
	     *          path and query parameters respectively.
	     */
	    getContentUri: function getContentUri() {
	        var params = {
	            access_token: this.opts.accessToken
	        };
	        return {
	            base: this.opts.baseUrl,
	            path: "/_matrix/media/v1/upload",
	            params: params
	        };
	    },
	
	    /**
	     * Upload content to the Home Server
	     *
	     * @param {object} file The object to upload. On a browser, something that
	     *   can be sent to XMLHttpRequest.send (typically a File).  Under node.js,
	     *   a Buffer, String or ReadStream.
	     *
	     * @param {object} opts  options object
	     *
	     * @param {string=} opts.name   Name to give the file on the server. Defaults
	     *   to <tt>file.name</tt>.
	     *
	     * @param {string=} opts.type   Content-type for the upload. Defaults to
	     *   <tt>file.type</tt>, or <tt>applicaton/octet-stream</tt>.
	     *
	     * @param {boolean=} opts.rawResponse Return the raw body, rather than
	     *   parsing the JSON. Defaults to false (except on node.js, where it
	     *   defaults to true for backwards compatibility).
	     *
	     * @param {boolean=} opts.onlyContentUri Just return the content URI,
	     *   rather than the whole body. Defaults to false (except on browsers,
	     *   where it defaults to true for backwards compatibility). Ignored if
	     *   opts.rawResponse is true.
	     *
	     * @param {Function=} opts.callback Deprecated. Optional. The callback to
	     *    invoke on success/failure. See the promise return values for more
	     *    information.
	     *
	     * @return {module:client.Promise} Resolves to response object, as
	     *    determined by this.opts.onlyData, opts.rawResponse, and
	     *    opts.onlyContentUri.  Rejects with an error (usually a MatrixError).
	     */
	    uploadContent: function uploadContent(file, opts) {
	        var _this = this;
	
	        if (utils.isFunction(opts)) {
	            // opts used to be callback
	            opts = {
	                callback: opts
	            };
	        } else if (opts === undefined) {
	            opts = {};
	        }
	
	        // if the file doesn't have a mime type, use a default since
	        // the HS errors if we don't supply one.
	        var contentType = opts.type || file.type || 'application/octet-stream';
	        var fileName = opts.name || file.name;
	
	        // we used to recommend setting file.stream to the thing to upload on
	        // nodejs.
	        var body = file.stream ? file.stream : file;
	
	        // backwards-compatibility hacks where we used to do different things
	        // between browser and node.
	        var rawResponse = opts.rawResponse;
	        if (rawResponse === undefined) {
	            if (global.XMLHttpRequest) {
	                rawResponse = false;
	            } else {
	                console.warn("Returning the raw JSON from uploadContent(). Future " + "versions of the js-sdk will change this default, to " + "return the parsed object. Set opts.rawResponse=false " + "to change this behaviour now.");
	                rawResponse = true;
	            }
	        }
	
	        var onlyContentUri = opts.onlyContentUri;
	        if (!rawResponse && onlyContentUri === undefined) {
	            if (global.XMLHttpRequest) {
	                console.warn("Returning only the content-uri from uploadContent(). " + "Future versions of the js-sdk will change this " + "default, to return the whole response object. Set " + "opts.onlyContentUri=false to change this behaviour now.");
	                onlyContentUri = true;
	            } else {
	                onlyContentUri = false;
	            }
	        }
	
	        // browser-request doesn't support File objects because it deep-copies
	        // the options using JSON.parse(JSON.stringify(options)). Instead of
	        // loading the whole file into memory as a string and letting
	        // browser-request base64 encode and then decode it again, we just
	        // use XMLHttpRequest directly.
	        // (browser-request doesn't support progress either, which is also kind
	        // of important here)
	
	        var upload = { loaded: 0, total: 0 };
	        var promise = void 0;
	
	        // XMLHttpRequest doesn't parse JSON for us. request normally does, but
	        // we're setting opts.json=false so that it doesn't JSON-encode the
	        // request, which also means it doesn't JSON-decode the response. Either
	        // way, we have to JSON-parse the response ourselves.
	        var bodyParser = null;
	        if (!rawResponse) {
	            bodyParser = function bodyParser(rawBody) {
	                var body = JSON.parse(rawBody);
	                if (onlyContentUri) {
	                    body = body.content_uri;
	                    if (body === undefined) {
	                        throw Error('Bad response');
	                    }
	                }
	                return body;
	            };
	        }
	
	        if (global.XMLHttpRequest) {
	            (function () {
	                var defer = q.defer();
	                var xhr = new global.XMLHttpRequest();
	                upload.xhr = xhr;
	                var cb = requestCallback(defer, opts.callback, _this.opts.onlyData);
	
	                var timeout_fn = function timeout_fn() {
	                    xhr.abort();
	                    cb(new Error('Timeout'));
	                };
	
	                // set an initial timeout of 30s; we'll advance it each time we get
	                // a progress notification
	                xhr.timeout_timer = callbacks.setTimeout(timeout_fn, 30000);
	
	                xhr.onreadystatechange = function () {
	                    switch (xhr.readyState) {
	                        case global.XMLHttpRequest.DONE:
	                            callbacks.clearTimeout(xhr.timeout_timer);
	                            var resp;
	                            try {
	                                if (!xhr.responseText) {
	                                    throw new Error('No response body.');
	                                }
	                                resp = xhr.responseText;
	                                if (bodyParser) {
	                                    resp = bodyParser(resp);
	                                }
	                            } catch (err) {
	                                err.http_status = xhr.status;
	                                cb(err);
	                                return;
	                            }
	                            cb(undefined, xhr, resp);
	                            break;
	                    }
	                };
	                xhr.upload.addEventListener("progress", function (ev) {
	                    callbacks.clearTimeout(xhr.timeout_timer);
	                    upload.loaded = ev.loaded;
	                    upload.total = ev.total;
	                    xhr.timeout_timer = callbacks.setTimeout(timeout_fn, 30000);
	                    defer.notify(ev);
	                });
	                var url = _this.opts.baseUrl + "/_matrix/media/v1/upload";
	                url += "?access_token=" + encodeURIComponent(_this.opts.accessToken);
	                url += "&filename=" + encodeURIComponent(fileName);
	
	                xhr.open("POST", url);
	                xhr.setRequestHeader("Content-Type", contentType);
	                xhr.send(body);
	                promise = defer.promise;
	
	                // dirty hack (as per _request) to allow the upload to be cancelled.
	                promise.abort = xhr.abort.bind(xhr);
	            })();
	        } else {
	            var queryParams = {
	                filename: fileName
	            };
	
	            promise = this.authedRequest(opts.callback, "POST", "/upload", queryParams, body, {
	                prefix: "/_matrix/media/v1",
	                headers: { "Content-Type": contentType },
	                json: false,
	                bodyParser: bodyParser
	            });
	        }
	
	        var self = this;
	
	        // remove the upload from the list on completion
	        var promise0 = promise.finally(function () {
	            for (var i = 0; i < self.uploads.length; ++i) {
	                if (self.uploads[i] === upload) {
	                    self.uploads.splice(i, 1);
	                    return;
	                }
	            }
	        });
	
	        // copy our dirty abort() method to the new promise
	        promise0.abort = promise.abort;
	
	        upload.promise = promise0;
	        this.uploads.push(upload);
	
	        return promise0;
	    },
	
	    cancelUpload: function cancelUpload(promise) {
	        if (promise.abort) {
	            promise.abort();
	            return true;
	        }
	        return false;
	    },
	
	    getCurrentUploads: function getCurrentUploads() {
	        return this.uploads;
	    },
	
	    idServerRequest: function idServerRequest(callback, method, path, params, prefix) {
	        var fullUri = this.opts.idBaseUrl + prefix + path;
	
	        if (callback !== undefined && !utils.isFunction(callback)) {
	            throw Error("Expected callback to be a function but got " + (typeof callback === "undefined" ? "undefined" : _typeof(callback)));
	        }
	
	        var opts = {
	            uri: fullUri,
	            method: method,
	            withCredentials: false,
	            json: false,
	            _matrix_opts: this.opts
	        };
	        if (method == 'GET') {
	            opts.qs = params;
	        } else {
	            opts.form = params;
	        }
	
	        var defer = q.defer();
	        this.opts.request(opts, requestCallback(defer, callback, this.opts.onlyData));
	        // ID server does not always take JSON, so we can't use requests' 'json'
	        // option as we do with the home server, but it does return JSON, so
	        // parse it manually
	        return defer.promise.then(function (response) {
	            return JSON.parse(response);
	        });
	    },
	
	    /**
	     * Perform an authorised request to the homeserver.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     *
	     * @param {Object=} queryParams A dict of query params (these will NOT be
	     * urlencoded). If unspecified, there will be no query params.
	     *
	     * @param {Object} data The HTTP JSON body.
	     *
	     * @param {Object=} opts additional options
	     *
	     * @param {Number=} opts.localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     *
	     * @param {sting=} opts.prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha". If not specified, uses this.opts.prefix.
	     *
	     * @param {Object=} opts.headers map of additional request headers
	     *
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     */
	    authedRequest: function authedRequest(callback, method, path, queryParams, data, opts) {
	        if (!queryParams) {
	            queryParams = {};
	        }
	        if (!queryParams.access_token) {
	            queryParams.access_token = this.opts.accessToken;
	        }
	
	        var request_promise = this.request(callback, method, path, queryParams, data, opts);
	
	        var self = this;
	        request_promise.catch(function (err) {
	            if (err.errcode == 'M_UNKNOWN_TOKEN') {
	                self.event_emitter.emit("Session.logged_out");
	            }
	        });
	
	        // return the original promise, otherwise tests break due to it having to
	        // go around the event loop one more time to process the result of the request
	        return request_promise;
	    },
	
	    /**
	     * Perform a request to the homeserver without any credentials.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     *
	     * @param {Object=} queryParams A dict of query params (these will NOT be
	     * urlencoded). If unspecified, there will be no query params.
	     *
	     * @param {Object} data The HTTP JSON body.
	     *
	     * @param {Object=} opts additional options
	     *
	     * @param {Number=} opts.localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     *
	     * @param {sting=} opts.prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha". If not specified, uses this.opts.prefix.
	     *
	     * @param {Object=} opts.headers map of additional request headers
	     *
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     */
	    request: function request(callback, method, path, queryParams, data, opts) {
	        opts = opts || {};
	        var prefix = opts.prefix !== undefined ? opts.prefix : this.opts.prefix;
	        var fullUri = this.opts.baseUrl + prefix + path;
	
	        return this.requestOtherUrl(callback, method, fullUri, queryParams, data, opts);
	    },
	
	    /**
	     * Perform an authorised request to the homeserver with a specific path
	     * prefix which overrides the default for this call only. Useful for hitting
	     * different Matrix Client-Server versions.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {Object} data The HTTP JSON body.
	     * @param {string} prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha".
	     * @param {Number=} localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     *
	     * @deprecated prefer authedRequest with opts.prefix
	     */
	    authedRequestWithPrefix: function authedRequestWithPrefix(callback, method, path, queryParams, data, prefix, localTimeoutMs) {
	        return this.authedRequest(callback, method, path, queryParams, data, {
	            localTimeoutMs: localTimeoutMs,
	            prefix: prefix
	        });
	    },
	
	    /**
	     * Perform a request to the homeserver without any credentials but with a
	     * specific path prefix which overrides the default for this call only.
	     * Useful for hitting different Matrix Client-Server versions.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {Object} data The HTTP JSON body.
	     * @param {string} prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha".
	     * @param {Number=} localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     *
	     * @deprecated prefer request with opts.prefix
	     */
	    requestWithPrefix: function requestWithPrefix(callback, method, path, queryParams, data, prefix, localTimeoutMs) {
	        return this.request(callback, method, path, queryParams, data, {
	            localTimeoutMs: localTimeoutMs,
	            prefix: prefix
	        });
	    },
	
	    /**
	     * Perform a request to an arbitrary URL.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} uri The HTTP URI
	     *
	     * @param {Object=} queryParams A dict of query params (these will NOT be
	     * urlencoded). If unspecified, there will be no query params.
	     *
	     * @param {Object} data The HTTP JSON body.
	     *
	     * @param {Object=} opts additional options
	     *
	     * @param {Number=} opts.localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     *
	     * @param {sting=} opts.prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha". If not specified, uses this.opts.prefix.
	     *
	     * @param {Object=} opts.headers map of additional request headers
	     *
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     */
	    requestOtherUrl: function requestOtherUrl(callback, method, uri, queryParams, data, opts) {
	        if (opts === undefined || opts === null) {
	            opts = {};
	        } else if (isFinite(opts)) {
	            // opts used to be localTimeoutMs
	            opts = {
	                localTimeoutMs: opts
	            };
	        }
	
	        return this._request(callback, method, uri, queryParams, data, opts);
	    },
	
	    /**
	     * Form and return a homeserver request URL based on the given path
	     * params and prefix.
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {string} prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha".
	     * @return {string} URL
	     */
	    getUrl: function getUrl(path, queryParams, prefix) {
	        var queryString = "";
	        if (queryParams) {
	            queryString = "?" + utils.encodeParams(queryParams);
	        }
	        return this.opts.baseUrl + prefix + path + queryString;
	    },
	
	    /**
	     * @private
	     *
	     * @param {function} callback
	     * @param {string} method
	     * @param {string} uri
	     * @param {object} queryParams
	     * @param {object|string} data
	     * @param {object=} opts
	     *
	     * @param {boolean} [opts.json =true] Json-encode data before sending, and
	     *   decode response on receipt. (We will still json-decode error
	     *   responses, even if this is false.)
	     *
	     * @param {object=} opts.headers  extra request headers
	     *
	     * @param {number=} opts.localTimeoutMs client-side timeout for the
	     *    request. Default timeout if falsy.
	     *
	     * @param {function=} opts.bodyParser function to parse the body of the
	     *    response before passing it to the promise and callback.
	     *
	     * @return {module:client.Promise} a promise which resolves to either the
	     * response object (if this.opts.onlyData is truthy), or the parsed
	     * body. Rejects
	     */
	    _request: function _request(callback, method, uri, queryParams, data, opts) {
	        if (callback !== undefined && !utils.isFunction(callback)) {
	            throw Error("Expected callback to be a function but got " + (typeof callback === "undefined" ? "undefined" : _typeof(callback)));
	        }
	        opts = opts || {};
	
	        var self = this;
	        if (this.opts.extraParams) {
	            for (var key in this.opts.extraParams) {
	                if (!this.opts.extraParams.hasOwnProperty(key)) {
	                    continue;
	                }
	                queryParams[key] = this.opts.extraParams[key];
	            }
	        }
	
	        var json = opts.json === undefined ? true : opts.json;
	
	        var defer = q.defer();
	
	        var timeoutId = void 0;
	        var timedOut = false;
	        var req = void 0;
	        var localTimeoutMs = opts.localTimeoutMs || this.opts.localTimeoutMs;
	
	        var resetTimeout = function resetTimeout() {
	            if (localTimeoutMs) {
	                if (timeoutId) {
	                    callbacks.clearTimeout(timeoutId);
	                }
	                timeoutId = callbacks.setTimeout(function () {
	                    timedOut = true;
	                    if (req && req.abort) {
	                        req.abort();
	                    }
	                    defer.reject(new module.exports.MatrixError({
	                        error: "Locally timed out waiting for a response",
	                        errcode: "ORG.MATRIX.JSSDK_TIMEOUT",
	                        timeout: localTimeoutMs
	                    }));
	                }, localTimeoutMs);
	            }
	        };
	        resetTimeout();
	
	        var reqPromise = defer.promise;
	
	        try {
	            req = this.opts.request({
	                uri: uri,
	                method: method,
	                withCredentials: false,
	                qs: queryParams,
	                body: data,
	                json: json,
	                timeout: localTimeoutMs,
	                headers: opts.headers || {},
	                _matrix_opts: this.opts
	            }, function (err, response, body) {
	                if (localTimeoutMs) {
	                    callbacks.clearTimeout(timeoutId);
	                    if (timedOut) {
	                        return; // already rejected promise
	                    }
	                }
	
	                // if json is falsy, we won't parse any error response, so need
	                // to do so before turning it into a MatrixError
	                var parseErrorJson = !json;
	                var handlerFn = requestCallback(defer, callback, self.opts.onlyData, parseErrorJson, opts.bodyParser);
	                handlerFn(err, response, body);
	            });
	            if (req) {
	                // This will only work in a browser, where opts.request is the
	                // `browser-request` import. Currently `request` does not support progress
	                // updates - see https://github.com/request/request/pull/2346.
	                // `browser-request` returns an XHRHttpRequest which exposes `onprogress`
	                if ('onprogress' in req) {
	                    req.onprogress = function (e) {
	                        // Prevent the timeout from rejecting the deferred promise if progress is
	                        // seen with the request
	                        resetTimeout();
	                    };
	                }
	
	                // FIXME: This is EVIL, but I can't think of a better way to expose
	                // abort() operations on underlying HTTP requests :(
	                if (req.abort) reqPromise.abort = req.abort.bind(req);
	            }
	        } catch (ex) {
	            defer.reject(ex);
	            if (callback) {
	                callback(ex);
	            }
	        }
	        return reqPromise;
	    }
	};
	
	/*
	 * Returns a callback that can be invoked by an HTTP request on completion,
	 * that will either resolve or reject the given defer as well as invoke the
	 * given userDefinedCallback (if any).
	 *
	 * If onlyData is true, the defer/callback is invoked with the body of the
	 * response, otherwise the result code.
	 *
	 * If parseErrorJson is true, we will JSON.parse the body if we get a 4xx error.
	 *
	 */
	var requestCallback = function requestCallback(defer, userDefinedCallback, onlyData, parseErrorJson, bodyParser) {
	    userDefinedCallback = userDefinedCallback || function () {};
	
	    return function (err, response, body) {
	        if (!err) {
	            try {
	                if (response.statusCode >= 400) {
	                    if (parseErrorJson) {
	                        // we won't have json-decoded the response.
	                        body = JSON.parse(body);
	                    }
	                    err = new module.exports.MatrixError(body);
	                } else if (bodyParser) {
	                    body = bodyParser(body);
	                }
	            } catch (e) {
	                err = e;
	            }
	            if (err) {
	                err.httpStatus = response.statusCode;
	            }
	        }
	
	        if (err) {
	            defer.reject(err);
	            userDefinedCallback(err);
	        } else {
	            var res = {
	                code: response.statusCode,
	                headers: response.headers,
	                data: body
	            };
	            defer.resolve(onlyData ? body : res);
	            userDefinedCallback(null, onlyData ? body : res);
	        }
	    };
	};
	
	/**
	 * Construct a Matrix error. This is a JavaScript Error with additional
	 * information specific to the standard Matrix error response.
	 * @constructor
	 * @param {Object} errorJson The Matrix error JSON returned from the homeserver.
	 * @prop {string} errcode The Matrix 'errcode' value, e.g. "M_FORBIDDEN".
	 * @prop {string} name Same as MatrixError.errcode but with a default unknown string.
	 * @prop {string} message The Matrix 'error' value, e.g. "Missing token."
	 * @prop {Object} data The raw Matrix error JSON used to construct this object.
	 * @prop {integer} httpStatus The numeric HTTP status code given
	 */
	module.exports.MatrixError = function MatrixError(errorJson) {
	    errorJson = errorJson || {};
	    this.errcode = errorJson.errcode;
	    this.name = errorJson.errcode || "Unknown error code";
	    this.message = errorJson.error || "Unknown message";
	    this.data = errorJson;
	};
	module.exports.MatrixError.prototype = Object.create(Error.prototype);
	/** */
	module.exports.MatrixError.prototype.constructor = module.exports.MatrixError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/user
	 */
	
	var EventEmitter = __webpack_require__(56).EventEmitter;
	var utils = __webpack_require__(16);
	
	/**
	 * Construct a new User. A User must have an ID and can optionally have extra
	 * information associated with it.
	 * @constructor
	 * @param {string} userId Required. The ID of this user.
	 * @prop {string} userId The ID of the user.
	 * @prop {Object} info The info object supplied in the constructor.
	 * @prop {string} displayName The 'displayname' of the user if known.
	 * @prop {string} avatarUrl The 'avatar_url' of the user if known.
	 * @prop {string} presence The presence enum if known.
	 * @prop {string} presenceStatusMsg The presence status message if known.
	 * @prop {Number} lastActiveAgo The time elapsed in ms since the user interacted
	 *                proactively with the server, or we saw a message from the user
	 * @prop {Number} lastPresenceTs Timestamp (ms since the epoch) for when we last
	 *                received presence data for this user.  We can subtract
	 *                lastActiveAgo from this to approximate an absolute value for
	 *                when a user was last active.
	 * @prop {Boolean} currentlyActive Whether we should consider lastActiveAgo to be
	 *               an approximation and that the user should be seen as active 'now'
	 * @prop {Object} events The events describing this user.
	 * @prop {MatrixEvent} events.presence The m.presence event for this user.
	 */
	function User(userId) {
	    this.userId = userId;
	    this.presence = "offline";
	    this.presenceStatusMsg = null;
	    this.displayName = userId;
	    this.rawDisplayName = userId;
	    this.avatarUrl = null;
	    this.lastActiveAgo = 0;
	    this.lastPresenceTs = 0;
	    this.currentlyActive = false;
	    this.events = {
	        presence: null,
	        profile: null
	    };
	    this._updateModifiedTime();
	}
	utils.inherits(User, EventEmitter);
	
	/**
	 * Update this User with the given presence event. May fire "User.presence",
	 * "User.avatarUrl" and/or "User.displayName" if this event updates this user's
	 * properties.
	 * @param {MatrixEvent} event The <code>m.presence</code> event.
	 * @fires module:client~MatrixClient#event:"User.presence"
	 * @fires module:client~MatrixClient#event:"User.displayName"
	 * @fires module:client~MatrixClient#event:"User.avatarUrl"
	 */
	User.prototype.setPresenceEvent = function (event) {
	    if (event.getType() !== "m.presence") {
	        return;
	    }
	    var firstFire = this.events.presence === null;
	    this.events.presence = event;
	
	    var eventsToFire = [];
	    if (event.getContent().presence !== this.presence || firstFire) {
	        eventsToFire.push("User.presence");
	    }
	    if (event.getContent().avatar_url && event.getContent().avatar_url !== this.avatarUrl) {
	        eventsToFire.push("User.avatarUrl");
	    }
	    if (event.getContent().displayname && event.getContent().displayname !== this.displayName) {
	        eventsToFire.push("User.displayName");
	    }
	    if (event.getContent().currently_active !== undefined && event.getContent().currently_active !== this.currentlyActive) {
	        eventsToFire.push("User.currentlyActive");
	    }
	
	    this.presence = event.getContent().presence;
	    eventsToFire.push("User.lastPresenceTs");
	
	    if (event.getContent().status_msg) {
	        this.presenceStatusMsg = event.getContent().status_msg;
	    }
	    if (event.getContent().displayname) {
	        this.displayName = event.getContent().displayname;
	    }
	    if (event.getContent().avatar_url) {
	        this.avatarUrl = event.getContent().avatar_url;
	    }
	    this.lastActiveAgo = event.getContent().last_active_ago;
	    this.lastPresenceTs = Date.now();
	    this.currentlyActive = event.getContent().currently_active;
	
	    this._updateModifiedTime();
	
	    for (var i = 0; i < eventsToFire.length; i++) {
	        this.emit(eventsToFire[i], event, this);
	    }
	};
	
	/**
	 * Manually set this user's display name. No event is emitted in response to this
	 * as there is no underlying MatrixEvent to emit with.
	 * @param {string} name The new display name.
	 */
	User.prototype.setDisplayName = function (name) {
	    var oldName = this.displayName;
	    this.displayName = name;
	    if (name !== oldName) {
	        this._updateModifiedTime();
	    }
	};
	
	/**
	 * Manually set this user's non-disambiguated display name. No event is emitted
	 * in response to this as there is no underlying MatrixEvent to emit with.
	 * @param {string} name The new display name.
	 */
	User.prototype.setRawDisplayName = function (name) {
	    this.rawDisplayName = name;
	};
	
	/**
	 * Manually set this user's avatar URL. No event is emitted in response to this
	 * as there is no underlying MatrixEvent to emit with.
	 * @param {string} url The new avatar URL.
	 */
	User.prototype.setAvatarUrl = function (url) {
	    var oldUrl = this.avatarUrl;
	    this.avatarUrl = url;
	    if (url !== oldUrl) {
	        this._updateModifiedTime();
	    }
	};
	
	/**
	 * Update the last modified time to the current time.
	 */
	User.prototype._updateModifiedTime = function () {
	    this._modified = Date.now();
	};
	
	/**
	 * Get the timestamp when this User was last updated. This timestamp is
	 * updated when this User receives a new Presence event which has updated a
	 * property on this object. It is updated <i>before</i> firing events.
	 * @return {number} The timestamp
	 */
	User.prototype.getLastModifiedTime = function () {
	    return this._modified;
	};
	
	/**
	 * Get the absolute timestamp when this User was last known active on the server.
	 * It is *NOT* accurate if this.currentlyActive is true.
	 * @return {number} The timestamp
	 */
	User.prototype.getLastActiveTs = function () {
	    return this.lastPresenceTs - this.lastActiveAgo;
	};
	
	/**
	 * The User class.
	 */
	module.exports = User;
	
	/**
	 * Fires whenever any user's lastPresenceTs changes,
	 * ie. whenever any presence event is received for a user.
	 * @event module:client~MatrixClient#"User.lastPresenceTs"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.lastPresenceTs changed.
	 * @example
	 * matrixClient.on("User.lastPresenceTs", function(event, user){
	 *   var newlastPresenceTs = user.lastPresenceTs;
	 * });
	 */
	
	/**
	 * Fires whenever any user's presence changes.
	 * @event module:client~MatrixClient#"User.presence"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.presence changed.
	 * @example
	 * matrixClient.on("User.presence", function(event, user){
	 *   var newPresence = user.presence;
	 * });
	 */
	
	/**
	 * Fires whenever any user's currentlyActive changes.
	 * @event module:client~MatrixClient#"User.currentlyActive"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.currentlyActive changed.
	 * @example
	 * matrixClient.on("User.currentlyActive", function(event, user){
	 *   var newCurrentlyActive = user.currentlyActive;
	 * });
	 */
	
	/**
	 * Fires whenever any user's display name changes.
	 * @event module:client~MatrixClient#"User.displayName"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.displayName changed.
	 * @example
	 * matrixClient.on("User.displayName", function(event, user){
	 *   var newName = user.displayName;
	 * });
	 */
	
	/**
	 * Fires whenever any user's avatar URL changes.
	 * @event module:client~MatrixClient#"User.avatarUrl"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.avatarUrl changed.
	 * @example
	 * matrixClient.on("User.avatarUrl", function(event, user){
	 *   var newUrl = user.avatarUrl;
	 * });
	 */


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     Copyright 2017 Vector Creations Ltd
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	/**
	 * This is an internal module. See {@link SyncAccumulator} for the public class.
	 * @module sync-accumulator
	 */
	
	var _utils = __webpack_require__(16);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The purpose of this class is to accumulate /sync responses such that a
	 * complete "initial" JSON response can be returned which accurately represents
	 * the sum total of the /sync responses accumulated to date. It only handles
	 * room data: that is, everything under the "rooms" top-level key.
	 *
	 * This class is used when persisting room data so a complete /sync response can
	 * be loaded from disk and incremental syncs can be performed on the server,
	 * rather than asking the server to do an initial sync on startup.
	 */
	var SyncAccumulator = function () {
	
	    /**
	     * @param {Object} opts
	     * @param {Number=} opts.maxTimelineEntries The ideal maximum number of
	     * timeline entries to keep in the sync response. This is best-effort, as
	     * clients do not always have a back-pagination token for each event, so
	     * it's possible there may be slightly *less* than this value. There will
	     * never be more. This cannot be 0 or else it makes it impossible to scroll
	     * back in a room. Default: 50.
	     */
	    function SyncAccumulator(opts) {
	        _classCallCheck(this, SyncAccumulator);
	
	        opts = opts || {};
	        opts.maxTimelineEntries = opts.maxTimelineEntries || 50;
	        this.opts = opts;
	        this.accountData = {
	            //$event_type: Object
	        };
	        this.inviteRooms = {
	            //$roomId: { ... sync 'invite' json data ... }
	        };
	        this.joinRooms = {
	            //$roomId: {
	            //    _currentState: { $event_type: { $state_key: json } },
	            //    _timeline: [
	            //       { event: $event, token: null|token },
	            //       { event: $event, token: null|token },
	            //       { event: $event, token: null|token },
	            //       ...
	            //    ],
	            //    _accountData: { $event_type: json },
	            //    _unreadNotifications: { ... unread_notifications JSON ... },
	            //    _readReceipts: { $user_id: { data: $json, eventId: $event_id }}
	            //}
	        };
	        // the /sync token which corresponds to the last time rooms were
	        // accumulated. We remember this so that any caller can obtain a
	        // coherent /sync response and know at what point they should be
	        // streaming from without losing events.
	        this.nextBatch = null;
	    }
	
	    _createClass(SyncAccumulator, [{
	        key: "accumulate",
	        value: function accumulate(syncResponse) {
	            this._accumulateRooms(syncResponse);
	            this._accumulateAccountData(syncResponse);
	            this.nextBatch = syncResponse.next_batch;
	        }
	    }, {
	        key: "_accumulateAccountData",
	        value: function _accumulateAccountData(syncResponse) {
	            var _this = this;
	
	            if (!syncResponse.account_data || !syncResponse.account_data.events) {
	                return;
	            }
	            // Clobbers based on event type.
	            syncResponse.account_data.events.forEach(function (e) {
	                _this.accountData[e.type] = e;
	            });
	        }
	
	        /**
	         * Accumulate incremental /sync room data.
	         * @param {Object} syncResponse the complete /sync JSON
	         */
	
	    }, {
	        key: "_accumulateRooms",
	        value: function _accumulateRooms(syncResponse) {
	            var _this2 = this;
	
	            if (!syncResponse.rooms) {
	                return;
	            }
	            if (syncResponse.rooms.invite) {
	                Object.keys(syncResponse.rooms.invite).forEach(function (roomId) {
	                    _this2._accumulateRoom(roomId, "invite", syncResponse.rooms.invite[roomId]);
	                });
	            }
	            if (syncResponse.rooms.join) {
	                Object.keys(syncResponse.rooms.join).forEach(function (roomId) {
	                    _this2._accumulateRoom(roomId, "join", syncResponse.rooms.join[roomId]);
	                });
	            }
	            if (syncResponse.rooms.leave) {
	                Object.keys(syncResponse.rooms.leave).forEach(function (roomId) {
	                    _this2._accumulateRoom(roomId, "leave", syncResponse.rooms.leave[roomId]);
	                });
	            }
	        }
	    }, {
	        key: "_accumulateRoom",
	        value: function _accumulateRoom(roomId, category, data) {
	            // Valid /sync state transitions
	            //       +--------+ <======+            1: Accept an invite
	            //   +== | INVITE |        | (5)        2: Leave a room
	            //   |   +--------+ =====+ |            3: Join a public room previously
	            //   |(1)            (4) | |               left (handle as if new room)
	            //   V         (2)       V |            4: Reject an invite
	            // +------+ ========> +--------+         5: Invite to a room previously
	            // | JOIN |    (3)    | LEAVE* |            left (handle as if new room)
	            // +------+ <======== +--------+
	            //
	            // * equivalent to "no state"
	            switch (category) {
	                case "invite":
	                    // (5)
	                    this._accumulateInviteState(roomId, data);
	                    break;
	                case "join":
	                    if (this.inviteRooms[roomId]) {
	                        // (1)
	                        // was previously invite, now join. We expect /sync to give
	                        // the entire state and timeline on 'join', so delete previous
	                        // invite state
	                        delete this.inviteRooms[roomId];
	                    }
	                    // (3)
	                    this._accumulateJoinState(roomId, data);
	                    break;
	                case "leave":
	                    if (this.inviteRooms[roomId]) {
	                        // (4)
	                        delete this.inviteRooms[roomId];
	                    } else {
	                        // (2)
	                        delete this.joinRooms[roomId];
	                    }
	                    break;
	                default:
	                    console.error("Unknown cateogory: ", category);
	            }
	        }
	    }, {
	        key: "_accumulateInviteState",
	        value: function _accumulateInviteState(roomId, data) {
	            if (!data.invite_state || !data.invite_state.events) {
	                // no new data
	                return;
	            }
	            if (!this.inviteRooms[roomId]) {
	                this.inviteRooms[roomId] = {
	                    invite_state: data.invite_state
	                };
	                return;
	            }
	            // accumulate extra keys for invite->invite transitions
	            // clobber based on event type / state key
	            // We expect invite_state to be small, so just loop over the events
	            var currentData = this.inviteRooms[roomId];
	            data.invite_state.events.forEach(function (e) {
	                var hasAdded = false;
	                for (var i = 0; i < currentData.invite_state.events.length; i++) {
	                    var current = currentData.invite_state.events[i];
	                    if (current.type === e.type && current.state_key == e.state_key) {
	                        currentData.invite_state.events[i] = e; // update
	                        hasAdded = true;
	                    }
	                }
	                if (!hasAdded) {
	                    currentData.invite_state.events.push(e);
	                }
	            });
	        }
	
	        // Accumulate timeline and state events in a room.
	
	    }, {
	        key: "_accumulateJoinState",
	        value: function _accumulateJoinState(roomId, data) {
	            // We expect this function to be called a lot (every /sync) so we want
	            // this to be fast. /sync stores events in an array but we often want
	            // to clobber based on type/state_key. Rather than convert arrays to
	            // maps all the time, just keep private maps which contain
	            // the actual current accumulated sync state, and array-ify it when
	            // getJSON() is called.
	
	            // State resolution:
	            // The 'state' key is the delta from the previous sync (or start of time
	            // if no token was supplied), to the START of the timeline. To obtain
	            // the current state, we need to "roll forward" state by reading the
	            // timeline. We want to store the current state so we can drop events
	            // out the end of the timeline based on opts.maxTimelineEntries.
	            //
	            //      'state'     'timeline'     current state
	            // |-------x<======================>x
	            //          T   I   M   E
	            //
	            // When getJSON() is called, we 'roll back' the current state by the
	            // number of entries in the timeline to work out what 'state' should be.
	
	            // Back-pagination:
	            // On an initial /sync, the server provides a back-pagination token for
	            // the start of the timeline. When /sync deltas come down, they also
	            // include back-pagination tokens for the start of the timeline. This
	            // means not all events in the timeline have back-pagination tokens, as
	            // it is only the ones at the START of the timeline which have them.
	            // In order for us to have a valid timeline (and back-pagination token
	            // to match), we need to make sure that when we remove old timeline
	            // events, that we roll forward to an event which has a back-pagination
	            // token. This means we can't keep a strict sliding-window based on
	            // opts.maxTimelineEntries, and we may have a few less. We should never
	            // have more though, provided that the /sync limit is less than or equal
	            // to opts.maxTimelineEntries.
	
	            if (!this.joinRooms[roomId]) {
	                // Create truly empty objects so event types of 'hasOwnProperty' and co
	                // don't cause this code to break.
	                this.joinRooms[roomId] = {
	                    _currentState: Object.create(null),
	                    _timeline: [],
	                    _accountData: Object.create(null),
	                    _unreadNotifications: {},
	                    _readReceipts: {}
	                };
	            }
	            var currentData = this.joinRooms[roomId];
	
	            if (data.account_data && data.account_data.events) {
	                // clobber based on type
	                data.account_data.events.forEach(function (e) {
	                    currentData._accountData[e.type] = e;
	                });
	            }
	
	            // these probably clobber, spec is unclear.
	            if (data.unread_notifications) {
	                currentData._unreadNotifications = data.unread_notifications;
	            }
	
	            if (data.ephemeral && data.ephemeral.events) {
	                data.ephemeral.events.forEach(function (e) {
	                    // We purposefully do not persist m.typing events.
	                    // Technically you could refresh a browser before the timer on a
	                    // typing event is up, so it'll look like you aren't typing when
	                    // you really still are. However, the alternative is worse. If
	                    // we do persist typing events, it will look like people are
	                    // typing forever until someone really does start typing (which
	                    // will prompt Synapse to send down an actual m.typing event to
	                    // clobber the one we persisted).
	                    if (e.type !== "m.receipt" || !e.content) {
	                        // This means we'll drop unknown ephemeral events but that
	                        // seems okay.
	                        return;
	                    }
	                    // Handle m.receipt events. They clobber based on:
	                    //   (user_id, receipt_type)
	                    // but they are keyed in the event as:
	                    //   content:{ $event_id: { $receipt_type: { $user_id: {json} }}}
	                    // so store them in the former so we can accumulate receipt deltas
	                    // quickly and efficiently (we expect a lot of them). Fold the
	                    // receipt type into the key name since we only have 1 at the
	                    // moment (m.read) and nested JSON objects are slower and more
	                    // of a hassle to work with. We'll inflate this back out when
	                    // getJSON() is called.
	                    Object.keys(e.content).forEach(function (eventId) {
	                        if (!e.content[eventId]["m.read"]) {
	                            return;
	                        }
	                        Object.keys(e.content[eventId]["m.read"]).forEach(function (userId) {
	                            // clobber on user ID
	                            currentData._readReceipts[userId] = {
	                                data: e.content[eventId]["m.read"][userId],
	                                eventId: eventId
	                            };
	                        });
	                    });
	                });
	            }
	
	            // if we got a limited sync, we need to remove all timeline entries or else
	            // we will have gaps in the timeline.
	            if (data.timeline && data.timeline.limited) {
	                currentData._timeline = [];
	            }
	
	            // Work out the current state. The deltas need to be applied in the order:
	            // - existing state which didn't come down /sync.
	            // - State events under the 'state' key.
	            // - State events in the 'timeline'.
	            if (data.state && data.state.events) {
	                data.state.events.forEach(function (e) {
	                    setState(currentData._currentState, e);
	                });
	            }
	            if (data.timeline && data.timeline.events) {
	                data.timeline.events.forEach(function (e, index) {
	                    // this nops if 'e' isn't a state event
	                    setState(currentData._currentState, e);
	                    // append the event to the timeline. The back-pagination token
	                    // corresponds to the first event in the timeline
	                    currentData._timeline.push({
	                        event: e,
	                        token: index === 0 ? data.timeline.prev_batch : null
	                    });
	                });
	            }
	
	            // attempt to prune the timeline by jumping between events which have
	            // pagination tokens.
	            if (currentData._timeline.length > this.opts.maxTimelineEntries) {
	                var startIndex = currentData._timeline.length - this.opts.maxTimelineEntries;
	                for (var i = startIndex; i < currentData._timeline.length; i++) {
	                    if (currentData._timeline[i].token) {
	                        // keep all events after this, including this one
	                        currentData._timeline = currentData._timeline.slice(i, currentData._timeline.length);
	                        break;
	                    }
	                }
	            }
	        }
	
	        /**
	         * Return everything under the 'rooms' key from a /sync response which
	         * represents all room data that should be stored. This should be paired
	         * with the sync token which represents the most recent /sync response
	         * provided to accumulate().
	         * @return {Object} An object with a "nextBatch", "roomsData" and "accountData"
	         * keys.
	         * The "nextBatch" key is a string which represents at what point in the
	         * /sync stream the accumulator reached. This token should be used when
	         * restarting a /sync stream at startup. Failure to do so can lead to missing
	         * events. The "roomsData" key is an Object which represents the entire
	         * /sync response from the 'rooms' key onwards. The "accountData" key is
	         * a list of raw events which represent global account data.
	         */
	
	    }, {
	        key: "getJSON",
	        value: function getJSON() {
	            var _this3 = this;
	
	            var data = {
	                join: {},
	                invite: {},
	                // always empty. This is set by /sync when a room was previously
	                // in 'invite' or 'join'. On fresh startup, the client won't know
	                // about any previous room being in 'invite' or 'join' so we can
	                // just omit mentioning it at all, even if it has previously come
	                // down /sync.
	                // The notable exception is when a client is kicked or banned:
	                // we may want to hold onto that room so the client can clearly see
	                // why their room has disappeared. We don't persist it though because
	                // it is unclear *when* we can safely remove the room from the DB.
	                // Instead, we assume that if you're loading from the DB, you've
	                // refreshed the page, which means you've seen the kick/ban already.
	                leave: {}
	            };
	            Object.keys(this.inviteRooms).forEach(function (roomId) {
	                data.invite[roomId] = _this3.inviteRooms[roomId];
	            });
	            Object.keys(this.joinRooms).forEach(function (roomId) {
	                var roomData = _this3.joinRooms[roomId];
	                var roomJson = {
	                    ephemeral: { events: [] },
	                    account_data: { events: [] },
	                    state: { events: [] },
	                    timeline: {
	                        events: [],
	                        prev_batch: null
	                    },
	                    unread_notifications: roomData._unreadNotifications
	                };
	                // Add account data
	                Object.keys(roomData._accountData).forEach(function (evType) {
	                    roomJson.account_data.events.push(roomData._accountData[evType]);
	                });
	
	                // Add receipt data
	                var receiptEvent = {
	                    type: "m.receipt",
	                    room_id: roomId,
	                    content: {
	                        // $event_id: { "m.read": { $user_id: $json } }
	                    }
	                };
	                Object.keys(roomData._readReceipts).forEach(function (userId) {
	                    var receiptData = roomData._readReceipts[userId];
	                    if (!receiptEvent.content[receiptData.eventId]) {
	                        receiptEvent.content[receiptData.eventId] = {
	                            "m.read": {}
	                        };
	                    }
	                    receiptEvent.content[receiptData.eventId]["m.read"][userId] = receiptData.data;
	                });
	                // add only if we have some receipt data
	                if (Object.keys(receiptEvent.content).length > 0) {
	                    roomJson.ephemeral.events.push(receiptEvent);
	                }
	
	                // Add timeline data
	                roomData._timeline.forEach(function (msgData) {
	                    if (!roomJson.timeline.prev_batch) {
	                        // the first event we add to the timeline MUST match up to
	                        // the prev_batch token.
	                        if (!msgData.token) {
	                            return; // this shouldn't happen as we prune constantly.
	                        }
	                        roomJson.timeline.prev_batch = msgData.token;
	                    }
	                    roomJson.timeline.events.push(msgData.event);
	                });
	
	                // Add state data: roll back current state to the start of timeline,
	                // by "reverse clobbering" from the end of the timeline to the start.
	                // Convert maps back into arrays.
	                var rollBackState = Object.create(null);
	                for (var i = roomJson.timeline.events.length - 1; i >= 0; i--) {
	                    var timelineEvent = roomJson.timeline.events[i];
	                    if (timelineEvent.state_key === null || timelineEvent.state_key === undefined) {
	                        continue; // not a state event
	                    }
	                    // since we're going back in time, we need to use the previous
	                    // state value else we'll break causality. We don't have the
	                    // complete previous state event, so we need to create one.
	                    var prevStateEvent = _utils2.default.deepCopy(timelineEvent);
	                    if (prevStateEvent.unsigned) {
	                        if (prevStateEvent.unsigned.prev_content) {
	                            prevStateEvent.content = prevStateEvent.unsigned.prev_content;
	                        }
	                        if (prevStateEvent.unsigned.prev_sender) {
	                            prevStateEvent.sender = prevStateEvent.unsigned.prev_sender;
	                        }
	                    }
	                    setState(rollBackState, prevStateEvent);
	                }
	                Object.keys(roomData._currentState).forEach(function (evType) {
	                    Object.keys(roomData._currentState[evType]).forEach(function (stateKey) {
	                        var ev = roomData._currentState[evType][stateKey];
	                        if (rollBackState[evType] && rollBackState[evType][stateKey]) {
	                            // use the reverse clobbered event instead.
	                            ev = rollBackState[evType][stateKey];
	                        }
	                        roomJson.state.events.push(ev);
	                    });
	                });
	                data.join[roomId] = roomJson;
	            });
	
	            // Add account data
	            var accData = [];
	            Object.keys(this.accountData).forEach(function (evType) {
	                accData.push(_this3.accountData[evType]);
	            });
	
	            return {
	                nextBatch: this.nextBatch,
	                roomsData: data,
	                accountData: accData
	            };
	        }
	    }]);
	
	    return SyncAccumulator;
	}();
	
	function setState(eventMap, event) {
	    if (event.state_key === null || event.state_key === undefined || !event.type) {
	        return;
	    }
	    if (!eventMap[event.type]) {
	        eventMap[event.type] = Object.create(null);
	    }
	    eventMap[event.type][event.state_key] = event;
	}
	
	module.exports = SyncAccumulator;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.unicodeToImage = unicodeToImage;
	exports.charactersToImageNode = charactersToImageNode;
	exports.stripParagraphs = stripParagraphs;
	exports.bodyToHtml = bodyToHtml;
	exports.emojifyText = emojifyText;
	
	var _escape = __webpack_require__(315);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _emojione = __webpack_require__(338);
	
	var _emojione2 = _interopRequireDefault(_emojione);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var sanitizeHtml = __webpack_require__(560);
	var highlight = __webpack_require__(523);
	var linkifyMatrix = __webpack_require__(142);
	
	
	_emojione2.default.imagePathSVG = 'emojione/svg/';
	_emojione2.default.imageType = 'svg';
	
	var EMOJI_REGEX = new RegExp(_emojione2.default.unicodeRegexp + "+", "gi");
	var COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;
	
	/* modified from https://github.com/Ranks/emojione/blob/master/lib/js/emojione.js
	 * because we want to include emoji shortnames in title text
	 */
	function unicodeToImage(str) {
	    var replaceWith = void 0,
	        unicode = void 0,
	        alt = void 0;
	    var mappedUnicode = _emojione2.default.mapUnicodeToShort();
	
	    str = str.replace(_emojione2.default.regUnicode, function (unicodeChar) {
	        if (typeof unicodeChar === 'undefined' || unicodeChar === '' || !(unicodeChar in _emojione2.default.jsEscapeMap)) {
	            // if the unicodeChar doesnt exist just return the entire match
	            return unicodeChar;
	        } else {
	            // get the unicode codepoint from the actual char
	            unicode = _emojione2.default.jsEscapeMap[unicodeChar];
	
	            // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
	            alt = _emojione2.default.unicodeAlt ? _emojione2.default.convert(unicode.toUpperCase()) : mappedUnicode[unicode];
	            var title = mappedUnicode[unicode];
	
	            replaceWith = '<img class="mx_emojione" title="' + title + '" alt="' + alt + '" src="' + _emojione2.default.imagePathSVG + unicode + '.svg' + _emojione2.default.cacheBustParam + '"/>';
	            return replaceWith;
	        }
	    });
	
	    return str;
	}
	
	/**
	 * Given one or more unicode characters (represented by unicode
	 * character number), return an image node with the corresponding
	 * emoji.
	 *
	 * @param alt {string} String to use for the image alt text
	 * @param unicode {integer} One or more integers representing unicode characters
	 * @returns A img node with the corresponding emoji
	 */
	function charactersToImageNode(alt) {
	    for (var _len = arguments.length, unicode = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        unicode[_key - 1] = arguments[_key];
	    }
	
	    var fileName = unicode.map(function (u) {
	        return u.toString(16);
	    }).join('-');
	    return React.createElement('img', { alt: alt, src: '' + _emojione2.default.imagePathSVG + fileName + '.svg' + _emojione2.default.cacheBustParam });
	}
	
	function stripParagraphs(html) {
	    var contentDiv = document.createElement('div');
	    contentDiv.innerHTML = html;
	
	    if (contentDiv.children.length === 0) {
	        return contentDiv.innerHTML;
	    }
	
	    var contentHTML = "";
	    for (var i = 0; i < contentDiv.children.length; i++) {
	        var element = contentDiv.children[i];
	        if (element.tagName.toLowerCase() === 'p') {
	            contentHTML += element.innerHTML + '<br />';
	        } else {
	            var temp = document.createElement('div');
	            temp.appendChild(element.cloneNode(true));
	            contentHTML += temp.innerHTML;
	        }
	    }
	
	    return contentHTML;
	}
	
	var sanitizeHtmlParams = {
	    allowedTags: ['font', // custom to matrix for IRC-style font coloring
	    'del', // for markdown
	    // deliberately no h1/h2 to stop people shouting.
	    'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol', 'nl', 'li', 'b', 'i', 'u', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'span'],
	    allowedAttributes: {
	        // custom ones first:
	        font: ['color', 'data-mx-bg-color', 'data-mx-color', 'style'], // custom to matrix
	        span: ['data-mx-bg-color', 'data-mx-color', 'style'], // custom to matrix
	        a: ['href', 'name', 'target', 'rel'], // remote target: custom to matrix
	        // We don't currently allow img itself by default, but this
	        // would make sense if we did
	        img: ['src'],
	        ol: ['start']
	    },
	    // Lots of these won't come up by default because we don't allow them
	    selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
	    // URL schemes we permit
	    allowedSchemes: ['http', 'https', 'ftp', 'mailto'],
	
	    // DO NOT USE. sanitize-html allows all URL starting with '//'
	    // so this will always allow links to whatever scheme the
	    // host page is served over.
	    allowedSchemesByTag: {},
	
	    transformTags: { // custom to matrix
	        // add blank targets to all hyperlinks except vector URLs
	        'a': function a(tagName, attribs) {
	            if (attribs.href) {
	                attribs.target = '_blank'; // by default
	
	                var m;
	                // FIXME: horrible duplication with linkify-matrix
	                m = attribs.href.match(linkifyMatrix.VECTOR_URL_PATTERN);
	                if (m) {
	                    attribs.href = m[1];
	                    delete attribs.target;
	                }
	
	                m = attribs.href.match(linkifyMatrix.MATRIXTO_URL_PATTERN);
	                if (m) {
	                    var entity = m[1];
	                    if (entity[0] === '@') {
	                        attribs.href = '#/user/' + entity;
	                    } else if (entity[0] === '#' || entity[0] === '!') {
	                        attribs.href = '#/room/' + entity;
	                    }
	                    delete attribs.target;
	                }
	            }
	            attribs.rel = 'noopener'; // https://mathiasbynens.github.io/rel-noopener/
	            return { tagName: tagName, attribs: attribs };
	        },
	        '*': function _(tagName, attribs) {
	            // Delete any style previously assigned, style is an allowedTag for font and span
	            // because attributes are stripped after transforming
	            delete attribs.style;
	
	            // Sanitise and transform data-mx-color and data-mx-bg-color to their CSS
	            // equivalents
	            var customCSSMapper = {
	                'data-mx-color': 'color',
	                'data-mx-bg-color': 'background-color'
	            };
	
	            var style = "";
	            (0, _keys2.default)(customCSSMapper).forEach(function (customAttributeKey) {
	                var cssAttributeKey = customCSSMapper[customAttributeKey];
	                var customAttributeValue = attribs[customAttributeKey];
	                if (customAttributeValue && typeof customAttributeValue === 'string' && COLOR_REGEX.test(customAttributeValue)) {
	                    style += cssAttributeKey + ":" + customAttributeValue + ";";
	                    delete attribs[customAttributeKey];
	                }
	            });
	
	            if (style) {
	                attribs.style = style;
	            }
	
	            return { tagName: tagName, attribs: attribs };
	        }
	    }
	};
	
	var BaseHighlighter = function () {
	    function BaseHighlighter(highlightClass, highlightLink) {
	        (0, _classCallCheck3.default)(this, BaseHighlighter);
	
	        this.highlightClass = highlightClass;
	        this.highlightLink = highlightLink;
	    }
	
	    /**
	     * apply the highlights to a section of text
	     *
	     * @param {string} safeSnippet The snippet of text to apply the highlights
	     *     to.
	     * @param {string[]} safeHighlights A list of substrings to highlight,
	     *     sorted by descending length.
	     *
	     * returns a list of results (strings for HtmlHighligher, react nodes for
	     * TextHighlighter).
	     */
	
	
	    (0, _createClass3.default)(BaseHighlighter, [{
	        key: 'applyHighlights',
	        value: function applyHighlights(safeSnippet, safeHighlights) {
	            var lastOffset = 0;
	            var offset;
	            var nodes = [];
	
	            var safeHighlight = safeHighlights[0];
	            while ((offset = safeSnippet.toLowerCase().indexOf(safeHighlight.toLowerCase(), lastOffset)) >= 0) {
	                // handle preamble
	                if (offset > lastOffset) {
	                    var subSnippet = safeSnippet.substring(lastOffset, offset);
	                    nodes = nodes.concat(this._applySubHighlights(subSnippet, safeHighlights));
	                }
	
	                // do highlight. use the original string rather than safeHighlight
	                // to preserve the original casing.
	                var endOffset = offset + safeHighlight.length;
	                nodes.push(this._processSnippet(safeSnippet.substring(offset, endOffset), true));
	
	                lastOffset = endOffset;
	            }
	
	            // handle postamble
	            if (lastOffset !== safeSnippet.length) {
	                subSnippet = safeSnippet.substring(lastOffset, undefined);
	                nodes = nodes.concat(this._applySubHighlights(subSnippet, safeHighlights));
	            }
	            return nodes;
	        }
	    }, {
	        key: '_applySubHighlights',
	        value: function _applySubHighlights(safeSnippet, safeHighlights) {
	            if (safeHighlights[1]) {
	                // recurse into this range to check for the next set of highlight matches
	                return this.applyHighlights(safeSnippet, safeHighlights.slice(1));
	            } else {
	                // no more highlights to be found, just return the unhighlighted string
	                return [this._processSnippet(safeSnippet, false)];
	            }
	        }
	    }]);
	    return BaseHighlighter;
	}();
	
	var HtmlHighlighter = function (_BaseHighlighter) {
	    (0, _inherits3.default)(HtmlHighlighter, _BaseHighlighter);
	
	    function HtmlHighlighter() {
	        (0, _classCallCheck3.default)(this, HtmlHighlighter);
	        return (0, _possibleConstructorReturn3.default)(this, (HtmlHighlighter.__proto__ || (0, _getPrototypeOf2.default)(HtmlHighlighter)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(HtmlHighlighter, [{
	        key: '_processSnippet',
	
	        /* highlight the given snippet if required
	         *
	         * snippet: content of the span; must have been sanitised
	         * highlight: true to highlight as a search match
	         *
	         * returns an HTML string
	         */
	        value: function _processSnippet(snippet, highlight) {
	            if (!highlight) {
	                // nothing required here
	                return snippet;
	            }
	
	            var span = "<span class=\"" + this.highlightClass + "\">" + snippet + "</span>";
	
	            if (this.highlightLink) {
	                span = "<a href=\"" + encodeURI(this.highlightLink) + "\">" + span + "</a>";
	            }
	            return span;
	        }
	    }]);
	    return HtmlHighlighter;
	}(BaseHighlighter);
	
	var TextHighlighter = function (_BaseHighlighter2) {
	    (0, _inherits3.default)(TextHighlighter, _BaseHighlighter2);
	
	    function TextHighlighter(highlightClass, highlightLink) {
	        (0, _classCallCheck3.default)(this, TextHighlighter);
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (TextHighlighter.__proto__ || (0, _getPrototypeOf2.default)(TextHighlighter)).call(this, highlightClass, highlightLink));
	
	        _this2._key = 0;
	        return _this2;
	    }
	
	    /* create a <span> node to hold the given content
	     *
	     * snippet: content of the span
	     * highlight: true to highlight as a search match
	     *
	     * returns a React node
	     */
	
	
	    (0, _createClass3.default)(TextHighlighter, [{
	        key: '_processSnippet',
	        value: function _processSnippet(snippet, highlight) {
	            var key = this._key++;
	
	            var node = React.createElement(
	                'span',
	                { key: key, className: highlight ? this.highlightClass : null },
	                snippet
	            );
	
	            if (highlight && this.highlightLink) {
	                node = React.createElement(
	                    'a',
	                    { key: key, href: this.highlightLink },
	                    node
	                );
	            }
	
	            return node;
	        }
	    }]);
	    return TextHighlighter;
	}(BaseHighlighter);
	
	/* turn a matrix event body into html
	 *
	 * content: 'content' of the MatrixEvent
	 *
	 * highlights: optional list of words to highlight, ordered by longest word first
	 *
	 * opts.highlightLink: optional href to add to highlighted words
	 */
	
	
	function bodyToHtml(content, highlights, opts) {
	    opts = opts || {};
	
	    var isHtml = content.format === "org.matrix.custom.html";
	    var body = isHtml ? content.formatted_body : (0, _escape2.default)(content.body);
	
	    var safeBody;
	    // XXX: We sanitize the HTML whilst also highlighting its text nodes, to avoid accidentally trying
	    // to highlight HTML tags themselves.  However, this does mean that we don't highlight textnodes which
	    // are interrupted by HTML tags (not that we did before) - e.g. foo<span/>bar won't get highlighted
	    // by an attempt to search for 'foobar'.  Then again, the search query probably wouldn't work either
	    try {
	        if (highlights && highlights.length > 0) {
	            var highlighter = new HtmlHighlighter("mx_EventTile_searchHighlight", opts.highlightLink);
	            var safeHighlights = highlights.map(function (highlight) {
	                return sanitizeHtml(highlight, sanitizeHtmlParams);
	            });
	            // XXX: hacky bodge to temporarily apply a textFilter to the sanitizeHtmlParams structure.
	            sanitizeHtmlParams.textFilter = function (safeText) {
	                return highlighter.applyHighlights(safeText, safeHighlights).join('');
	            };
	        }
	        safeBody = sanitizeHtml(body, sanitizeHtmlParams);
	        safeBody = unicodeToImage(safeBody);
	    } finally {
	        delete sanitizeHtmlParams.textFilter;
	    }
	
	    EMOJI_REGEX.lastIndex = 0;
	    var contentBodyTrimmed = content.body !== undefined ? content.body.trim() : '';
	    var match = EMOJI_REGEX.exec(contentBodyTrimmed);
	    var emojiBody = match && match[0] && match[0].length === contentBodyTrimmed.length;
	
	    var className = (0, _classnames2.default)({
	        'mx_EventTile_body': true,
	        'mx_EventTile_bigEmoji': emojiBody,
	        'markdown-body': isHtml
	    });
	    return React.createElement('span', { className: className, dangerouslySetInnerHTML: { __html: safeBody } });
	}
	
	function emojifyText(text) {
	    return {
	        __html: unicodeToImage((0, _escape2.default)(text))
	    };
	}


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAddressType = getAddressType;
	exports.inviteToRoom = inviteToRoom;
	exports.inviteMultipleToRoom = inviteMultipleToRoom;
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _MultiInviter = __webpack_require__(1272);
	
	var _MultiInviter2 = _interopRequireDefault(_MultiInviter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var emailRegex = /^\S+@\S+\.\S+$/;
	
	var mxidRegex = /^@\S+:\S+$/;
	
	function getAddressType(inputText) {
	    var isEmailAddress = emailRegex.test(inputText);
	    var isMatrixId = mxidRegex.test(inputText);
	
	    // sanity check the input for user IDs
	    if (isEmailAddress) {
	        return 'email';
	    } else if (isMatrixId) {
	        return 'mx';
	    } else {
	        return null;
	    }
	}
	
	function inviteToRoom(roomId, addr) {
	    var addrType = getAddressType(addr);
	
	    if (addrType == 'email') {
	        return _MatrixClientPeg2.default.get().inviteByEmail(roomId, addr);
	    } else if (addrType == 'mx') {
	        return _MatrixClientPeg2.default.get().invite(roomId, addr);
	    } else {
	        throw new Error('Unsupported address');
	    }
	}
	
	/**
	 * Invites multiple addresses to a room
	 * Simpler interface to utils/MultiInviter but with
	 * no option to cancel.
	 *
	 * @param {roomId} The ID of the room to invite to
	 * @param {array} Array of strings of addresses to invite. May be matrix IDs or 3pids.
	 * @returns Promise
	 */
	function inviteMultipleToRoom(roomId, addrs) {
	    var inviter = new _MultiInviter2.default(roomId);
	    return inviter.invite(addrs);
	}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	
	module.exports = {
	    /**
	     * Returns true iff this event arriving in a room should affect the room's
	     * count of unread messages
	     */
	    eventTriggersUnreadCount: function eventTriggersUnreadCount(ev) {
	        if (ev.sender && ev.sender.userId == MatrixClientPeg.get().credentials.userId) {
	            return false;
	        } else if (ev.getType() == "m.room.member") {
	            return false;
	        } else if (ev.getType == 'm.room.message' && ev.getContent().msgtype == 'm.notify') {
	            return false;
	        }
	        var EventTile = sdk.getComponent('rooms.EventTile');
	        return EventTile.haveTileForEvent(ev);
	    },
	
	    doesRoomHaveUnreadMessages: function doesRoomHaveUnreadMessages(room) {
	        var readUpToId = room.getEventReadUpTo(MatrixClientPeg.get().credentials.userId);
	        // this just looks at whatever history we have, which if we've only just started
	        // up probably won't be very much, so if the last couple of events are ones that
	        // don't count, we don't know if there are any events that do count between where
	        // we have and the read receipt. We could fetch more history to try & find out,
	        // but currently we just guess.
	
	        // Loop through messages, starting with the most recent...
	        for (var i = room.timeline.length - 1; i >= 0; --i) {
	            var ev = room.timeline[i];
	
	            if (ev.getId() == readUpToId) {
	                // If we've read up to this event, there's nothing more recents
	                // that counts and we can stop looking because the user's read
	                // this and everything before.
	                return false;
	            } else if (this.eventTriggersUnreadCount(ev)) {
	                // We've found a message that counts before we hit
	                // the read marker, so this room is definitely unread.
	                return true;
	            }
	        }
	        // If we got here, we didn't find a message that counted but didn't
	        // find the read marker either, so we guess and say that the room
	        // is unread on the theory that false positives are better than
	        // false negatives here.
	        return true;
	    }
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var classNames = __webpack_require__(27);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	
	// Shamelessly ripped off Modal.js.  There's probably a better way
	// of doing reusable widgets like dialog boxes & menus where we go and
	// pass in a custom control as the actual body.
	
	module.exports = {
	    ContextualMenuContainerId: "mx_ContextualMenu_Container",
	
	    propTypes: {
	        menuWidth: React.PropTypes.number,
	        menuHeight: React.PropTypes.number,
	        chevronOffset: React.PropTypes.number,
	        menuColour: React.PropTypes.string
	    },
	
	    getOrCreateContainer: function getOrCreateContainer() {
	        var container = document.getElementById(this.ContextualMenuContainerId);
	
	        if (!container) {
	            container = document.createElement("div");
	            container.id = this.ContextualMenuContainerId;
	            document.body.appendChild(container);
	        }
	
	        return container;
	    },
	
	    createMenu: function createMenu(Element, props) {
	        var self = this;
	
	        var closeMenu = function closeMenu() {
	            ReactDOM.unmountComponentAtNode(self.getOrCreateContainer());
	
	            if (props && props.onFinished) {
	                props.onFinished.apply(null, arguments);
	            }
	        };
	
	        var position = {
	            top: props.top
	        };
	
	        var chevronOffset = {};
	        if (props.chevronOffset) {
	            chevronOffset.top = props.chevronOffset;
	        }
	
	        // To override the default chevron colour, if it's been set
	        var chevronCSS = "";
	        if (props.menuColour) {
	            chevronCSS = '\n                .mx_ContextualMenu_chevron_left:after {\n                    border-right-color: ' + props.menuColour + ';\n                }\n\n                .mx_ContextualMenu_chevron_right:after {\n                    border-left-color: ' + props.menuColour + ';\n                }\n            ';
	        }
	
	        var chevron = null;
	        if (props.left) {
	            chevron = React.createElement('div', { style: chevronOffset, className: 'mx_ContextualMenu_chevron_left' });
	            position.left = props.left;
	        } else {
	            chevron = React.createElement('div', { style: chevronOffset, className: 'mx_ContextualMenu_chevron_right' });
	            position.right = props.right;
	        }
	
	        var className = 'mx_ContextualMenu_wrapper';
	
	        var menuClasses = classNames({
	            'mx_ContextualMenu': true,
	            'mx_ContextualMenu_left': props.left,
	            'mx_ContextualMenu_right': !props.left
	        });
	
	        var menuStyle = {};
	        if (props.menuWidth) {
	            menuStyle.width = props.menuWidth;
	        }
	
	        if (props.menuHeight) {
	            menuStyle.height = props.menuHeight;
	        }
	
	        if (props.menuColour) {
	            menuStyle["backgroundColor"] = props.menuColour;
	        }
	
	        // FIXME: If a menu uses getDefaultProps it clobbers the onFinished
	        // property set here so you can't close the menu from a button click!
	        var menu = React.createElement(
	            'div',
	            { className: className, style: position },
	            React.createElement(
	                'div',
	                { className: menuClasses, style: menuStyle },
	                chevron,
	                React.createElement(Element, (0, _extends3.default)({}, props, { onFinished: closeMenu }))
	            ),
	            React.createElement('div', { className: 'mx_ContextualMenu_background', onClick: closeMenu }),
	            React.createElement(
	                'style',
	                null,
	                chevronCSS
	            )
	        );
	
	        ReactDOM.render(menu, this.getOrCreateContainer());
	
	        return { close: closeMenu };
	    }
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filesize = __webpack_require__(300);
	
	var _filesize2 = _interopRequireDefault(_filesize);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _DecryptFile = __webpack_require__(225);
	
	var _Tinter = __webpack_require__(140);
	
	var _Tinter2 = _interopRequireDefault(_Tinter);
	
	var _browserRequest = __webpack_require__(97);
	
	var _browserRequest2 = _interopRequireDefault(_browserRequest);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A cached tinted copy of "img/download.svg"
	var tintedDownloadImageURL;
	// Track a list of mounted MFileBody instances so that we can update
	// the "img/download.svg" when the tint changes.
	var nextMountId = 0;
	var mounts = {};
	
	/**
	 * Updates the tinted copy of "img/download.svg" when the tint changes.
	 */
	function updateTintedDownloadImage() {
	    // Download the svg as an XML document.
	    // We could cache the XML response here, but since the tint rarely changes
	    // it's probably not worth it.
	    // Also note that we can't use fetch here because fetch doesn't support
	    // file URLs, which the download image will be if we're running from
	    // the filesystem (like in an Electron wrapper).
	    (0, _browserRequest2.default)({ uri: "img/download.svg" }, function (err, response, body) {
	        if (err) return;
	
	        var svg = new DOMParser().parseFromString(body, "image/svg+xml");
	        // Apply the fixups to the XML.
	        var fixups = _Tinter2.default.calcSvgFixups([{ contentDocument: svg }]);
	        _Tinter2.default.applySvgFixups(fixups);
	        // Encoded the fixed up SVG as a data URL.
	        var svgString = new XMLSerializer().serializeToString(svg);
	        tintedDownloadImageURL = "data:image/svg+xml;base64," + window.btoa(svgString);
	        // Notify each mounted MFileBody that the URL has changed.
	        (0, _keys2.default)(mounts).forEach(function (id) {
	            mounts[id].tint();
	        });
	    });
	}
	
	_Tinter2.default.registerTintable(updateTintedDownloadImage);
	
	// User supplied content can contain scripts, we have to be careful that
	// we don't accidentally run those script within the same origin as the
	// client. Otherwise those scripts written by remote users can read
	// the access token and end-to-end keys that are in local storage.
	//
	// For attachments downloaded directly from the homeserver we can use
	// Content-Security-Policy headers to disable script execution.
	//
	// But attachments with end-to-end encryption are more difficult to handle.
	// We need to decrypt the attachment on the client and then display it.
	// To display the attachment we need to turn the decrypted bytes into a URL.
	//
	// There are two ways to turn bytes into URLs, data URL and blob URLs.
	// Data URLs aren't suitable for downloading a file because Chrome has a
	// 2MB limit on the size of URLs that can be viewed in the browser or
	// downloaded. This limit does not seem to apply when the url is used as
	// the source attribute of an image tag.
	//
	// Blob URLs are generated using window.URL.createObjectURL and unforuntately
	// for our purposes they inherit the origin of the page that created them.
	// This means that any scripts that run when the URL is viewed will be able
	// to access local storage.
	//
	// The easiest solution is to host the code that generates the blob URL on
	// a different domain to the client.
	// Another possibility is to generate the blob URL within a sandboxed iframe.
	// The downside of using a second domain is that it complicates hosting,
	// the downside of using a sandboxed iframe is that the browers are overly
	// restrictive in what you are allowed to do with the generated URL.
	//
	// For now given how unusable the blobs generated in sandboxed iframes are we
	// default to using a renderer hosted on "usercontent.riot.im". This is
	// overridable so that people running their own version of the client can
	// choose a different renderer.
	//
	// To that end the first version of the blob generation will be the following
	// html:
	//
	//      <html><head><script>
	//      window.onmessage=function(e){eval("("+e.data.code+")")(e)}
	//      </script></head><body></body></html>
	//
	// This waits to receive a message event sent using the window.postMessage API.
	// When it receives the event it evals a javascript function in data.code and
	// runs the function passing the event as an argument.
	//
	// In particular it means that the rendering function can be written as a
	// ordinary javascript function which then is turned into a string using
	// toString().
	//
	var DEFAULT_CROSS_ORIGIN_RENDERER = "https://usercontent.riot.im/v1.html";
	
	/**
	 * Render the attachment inside the iframe.
	 * We can't use imported libraries here so this has to be vanilla JS.
	 */
	function remoteRender(event) {
	    var data = event.data;
	
	    var img = document.createElement("img");
	    img.id = "img";
	    img.src = data.imgSrc;
	
	    var a = document.createElement("a");
	    a.id = "a";
	    a.rel = data.rel;
	    a.target = data.target;
	    a.download = data.download;
	    a.style = data.style;
	    a.href = window.URL.createObjectURL(data.blob);
	    a.appendChild(img);
	    a.appendChild(document.createTextNode(data.textContent));
	
	    var body = document.body;
	    // Don't display scrollbars if the link takes more than one line
	    // to display.
	    body.style = "margin: 0px; overflow: hidden";
	    body.appendChild(a);
	}
	
	/**
	 * Update the tint inside the iframe.
	 * We can't use imported libraries here so this has to be vanilla JS.
	 */
	function remoteSetTint(event) {
	    var data = event.data;
	
	    var img = document.getElementById("img");
	    img.src = data.imgSrc;
	    img.style = data.imgStyle;
	
	    var a = document.getElementById("a");
	    a.style = data.style;
	}
	
	/**
	 * Get the current CSS style for a DOMElement.
	 * @param {HTMLElement} element The element to get the current style of.
	 * @return {string} The CSS style encoded as a string.
	 */
	function computedStyle(element) {
	    if (!element) {
	        return "";
	    }
	    var style = window.getComputedStyle(element, null);
	    var cssText = style.cssText;
	    if (cssText == "") {
	        // Firefox doesn't implement ".cssText" for computed styles.
	        // https://bugzilla.mozilla.org/show_bug.cgi?id=137687
	        for (var i = 0; i < style.length; i++) {
	            cssText += style[i] + ":";
	            cssText += style.getPropertyValue(style[i]) + ";";
	        }
	    }
	    return cssText;
	}
	
	module.exports = _react2.default.createClass({
	    displayName: 'MFileBody',
	
	    getInitialState: function getInitialState() {
	        return {
	            decryptedBlob: this.props.decryptedBlob ? this.props.decryptedBlob : null
	        };
	    },
	
	    contextTypes: {
	        appConfig: _react2.default.PropTypes.object
	    },
	
	    /**
	     * Extracts a human readable label for the file attachment to use as
	     * link text.
	     *
	     * @params {Object} content The "content" key of the matrix event.
	     * @return {string} the human readable link text for the attachment.
	     */
	    presentableTextForFile: function presentableTextForFile(content) {
	        var linkText = 'Attachment';
	        if (content.body && content.body.length > 0) {
	            // The content body should be the name of the file including a
	            // file extension.
	            linkText = content.body;
	        }
	
	        if (content.info && content.info.size) {
	            // If we know the size of the file then add it as human readable
	            // string to the end of the link text so that the user knows how
	            // big a file they are downloading.
	            // The content.info also contains a MIME-type but we don't display
	            // it since it is "ugly", users generally aren't aware what it
	            // means and the type of the attachment can usually be inferrered
	            // from the file extension.
	            linkText += ' (' + (0, _filesize2.default)(content.info.size) + ')';
	        }
	        return linkText;
	    },
	
	    _getContentUrl: function _getContentUrl() {
	        var content = this.props.mxEvent.getContent();
	        return _MatrixClientPeg2.default.get().mxcUrlToHttp(content.url);
	    },
	
	    componentDidMount: function componentDidMount() {
	        // Add this to the list of mounted components to receive notifications
	        // when the tint changes.
	        this.id = nextMountId++;
	        mounts[this.id] = this;
	        this.tint();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // Remove this from the list of mounted components
	        delete mounts[this.id];
	    },
	
	    tint: function tint() {
	        // Update our tinted copy of "img/download.svg"
	        if (this.refs.downloadImage) {
	            this.refs.downloadImage.src = tintedDownloadImageURL;
	        }
	        if (this.refs.iframe) {
	            // If the attachment is encrypted then the download image
	            // will be inside the iframe so we wont be able to update
	            // it directly.
	            this.refs.iframe.contentWindow.postMessage({
	                code: remoteSetTint.toString(),
	                imgSrc: tintedDownloadImageURL,
	                style: computedStyle(this.refs.dummyLink)
	            }, "*");
	        }
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var content = this.props.mxEvent.getContent();
	        var text = this.presentableTextForFile(content);
	        var isEncrypted = content.file !== undefined;
	        var fileName = content.body && content.body.length > 0 ? content.body : "Attachment";
	        var contentUrl = this._getContentUrl();
	        var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	
	        if (isEncrypted) {
	            if (this.state.decryptedBlob === null) {
	                // Need to decrypt the attachment
	                // Wait for the user to click on the link before downloading
	                // and decrypting the attachment.
	                var decrypting = false;
	                var decrypt = function decrypt() {
	                    if (decrypting) {
	                        return false;
	                    }
	                    decrypting = true;
	                    (0, _DecryptFile.decryptFile)(content.file).then(function (blob) {
	                        _this.setState({
	                            decryptedBlob: blob
	                        });
	                    }).catch(function (err) {
	                        console.warn("Unable to decrypt attachment: ", err);
	                        _Modal2.default.createDialog(ErrorDialog, {
	                            description: "Error decrypting attachment"
	                        });
	                    }).finally(function () {
	                        decrypting = false;
	                        return;
	                    });
	                };
	
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'mx_MFileBody', ref: 'body' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_MImageBody_download' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:void(0)', onClick: decrypt },
	                            'Decrypt ',
	                            text
	                        )
	                    )
	                );
	            }
	
	            // When the iframe loads we tell it to render a download link
	            var onIframeLoad = function onIframeLoad(ev) {
	                ev.target.contentWindow.postMessage({
	                    code: remoteRender.toString(),
	                    imgSrc: tintedDownloadImageURL,
	                    style: computedStyle(_this.refs.dummyLink),
	                    blob: _this.state.decryptedBlob,
	                    // Set a download attribute for encrypted files so that the file
	                    // will have the correct name when the user tries to download it.
	                    // We can't provide a Content-Disposition header like we would for HTTP.
	                    download: fileName,
	                    target: "_blank",
	                    textContent: "Download " + text
	                }, "*");
	            };
	
	            // If the attachment is encryped then put the link inside an iframe.
	            var renderer_url = DEFAULT_CROSS_ORIGIN_RENDERER;
	            if (this.context.appConfig && this.context.appConfig.cross_origin_renderer_url) {
	                renderer_url = this.context.appConfig.cross_origin_renderer_url;
	            }
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MFileBody' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MImageBody_download' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: "none" } },
	                        _react2.default.createElement('a', { ref: 'dummyLink' })
	                    ),
	                    _react2.default.createElement('iframe', { src: renderer_url, onLoad: onIframeLoad, ref: 'iframe' })
	                )
	            );
	        } else if (contentUrl) {
	            // If the attachment is not encrypted then we check whether we
	            // are being displayed in the room timeline or in a list of
	            // files in the right hand side of the screen.
	            if (this.props.tileShape === "file_grid") {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'mx_MFileBody' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_MImageBody_download' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'mx_ImageBody_downloadLink', href: contentUrl, target: '_blank' },
	                            fileName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'mx_MImageBody_size' },
	                            content.info && content.info.size ? (0, _filesize2.default)(content.info.size) : ""
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'mx_MFileBody' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_MImageBody_download' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: contentUrl, target: '_blank', rel: 'noopener' },
	                            _react2.default.createElement('img', { src: tintedDownloadImageURL, width: '12', height: '14', ref: 'downloadImage' }),
	                            'Download ',
	                            text
	                        )
	                    )
	                );
	            }
	        } else {
	            var extra = text ? ': ' + text : '';
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MFileBody' },
	                'Invalid file',
	                extra
	            );
	        }
	    }
	});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var Rooms = __webpack_require__(117);
	
	var q = __webpack_require__(6);
	
	/**
	 * Create a new room, and switch to it.
	 *
	 * Returns a promise which resolves to the room id, or null if the
	 * action was aborted or failed.
	 *
	 * @param {object=} opts parameters for creating the room
	 * @param {string=} opts.dmUserId If specified, make this a DM room for this user and invite them
	 * @param {object=} opts.createOpts set of options to pass to createRoom call.
	 */
	function createRoom(opts) {
	    opts = opts || {};
	
	    var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	    var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	    var Loader = sdk.getComponent("elements.Spinner");
	
	    var client = MatrixClientPeg.get();
	    if (client.isGuest()) {
	        setTimeout(function () {
	            Modal.createDialog(NeedToRegisterDialog, {
	                title: "Please Register",
	                description: "Guest users can't create new rooms. Please register to create room and start a chat."
	            });
	        }, 0);
	        return q(null);
	    }
	
	    var defaultPreset = opts.dmUserId ? 'trusted_private_chat' : 'private_chat';
	
	    // set some defaults for the creation
	    var createOpts = opts.createOpts || {};
	    createOpts.preset = createOpts.preset || defaultPreset;
	    createOpts.visibility = createOpts.visibility || 'private';
	    if (opts.dmUserId && createOpts.invite === undefined) {
	        createOpts.invite = [opts.dmUserId];
	    }
	    if (opts.dmUserId && createOpts.is_direct === undefined) {
	        createOpts.is_direct = true;
	    }
	
	    // Allow guests by default since the room is private and they'd
	    // need an invite. This means clicking on a 3pid invite email can
	    // actually drop you right in to a chat.
	    createOpts.initial_state = createOpts.initial_state || [{
	        content: {
	            guest_access: 'can_join'
	        },
	        type: 'm.room.guest_access',
	        state_key: ''
	    }];
	
	    var modal = void 0;
	    setTimeout(function () {
	        modal = Modal.createDialog(Loader, null, 'mx_Dialog_spinner');
	    }, 0);
	
	    var roomId = void 0;
	    return client.createRoom(createOpts).finally(function () {
	        if (modal) modal.close();
	    }).then(function (res) {
	        roomId = res.room_id;
	        if (opts.dmUserId) {
	            return Rooms.setDMRoom(roomId, opts.dmUserId);
	        } else {
	            return q();
	        }
	    }).then(function () {
	        // NB createRoom doesn't block on the client seeing the echo that the
	        // room has been created, so we race here with the client knowing that
	        // the room exists, causing things like
	        // https://github.com/vector-im/vector-web/issues/1813
	        dis.dispatch({
	            action: 'view_room',
	            room_id: roomId
	        });
	        return roomId;
	    }, function (err) {
	        console.error("Failed to create room " + roomId + " " + err);
	        Modal.createDialog(ErrorDialog, {
	            title: "Failure to create room",
	            description: "Server may be unavailable, overloaded, or you hit a bug."
	        });
	        return null;
	    });
	}
	
	module.exports = createRoom;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.readBlobAsDataUri = readBlobAsDataUri;
	exports.decryptFile = decryptFile;
	
	var _browserEncryptAttachment = __webpack_require__(377);
	
	var _browserEncryptAttachment2 = _interopRequireDefault(_browserEncryptAttachment);
	
	__webpack_require__(1020);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Read blob as a data:// URI.
	 * @return {Promise} A promise that resolves with the data:// URI.
	 */
	
	// Grab the client so that we can turn mxc:// URLs into https:// URLS.
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	// Pull in the encryption lib so that we can decrypt attachments.
	function readBlobAsDataUri(file) {
	    var deferred = _q2.default.defer();
	    var reader = new FileReader();
	    reader.onload = function (e) {
	        deferred.resolve(e.target.result);
	    };
	    reader.onerror = function (e) {
	        deferred.reject(e);
	    };
	    reader.readAsDataURL(file);
	    return deferred.promise;
	}
	
	/**
	 * Decrypt a file attached to a matrix event.
	 * @param file {Object} The json taken from the matrix event.
	 *   This passed to [link]{@link https://github.com/matrix-org/browser-encrypt-attachments}
	 *   as the encryption info object, so will also have the those keys in addition to
	 *   the keys below.
	 * @param file.url {string} An mxc:// URL for the encrypted file.
	 * @param file.mimetype {string} The MIME-type of the plaintext file.
	 */
	
	// Pull in a fetch polyfill so we can download encrypted attachments.
	function decryptFile(file) {
	    var url = _MatrixClientPeg2.default.get().mxcUrlToHttp(file.url);
	    // Download the encrypted file as an array buffer.
	    return (0, _q2.default)(fetch(url)).then(function (response) {
	        return response.arrayBuffer();
	    }).then(function (responseData) {
	        // Decrypt the array buffer using the information taken from
	        // the event content.
	        return _browserEncryptAttachment2.default.decryptAttachment(responseData, file);
	    }).then(function (dataArray) {
	        // Turn the array into a Blob and give it the correct MIME-type.
	        var blob = new Blob([dataArray], { type: file.mimetype });
	        return blob;
	    });
	}


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = checkDecoratorArguments;
	function checkDecoratorArguments(functionName, signature) {
	  if (false) {
	    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
	      var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
	      if (arg && arg.prototype && arg.prototype.render) {
	        console.error( // eslint-disable-line no-console
	        'You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
	        return;
	      }
	    }
	  }
	}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var EventPluginRegistry = __webpack_require__(346);
	var ReactEventEmitterMixin = __webpack_require__(1468);
	var ViewportMetrics = __webpack_require__(544);
	
	var getVendorPrefixedEventName = __webpack_require__(1500);
	var isEventSupported = __webpack_require__(357);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(176);
	var ViewportMetrics = __webpack_require__(544);
	
	var getEventModifierState = __webpack_require__(355);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(42);
	var DOMNamespaces = __webpack_require__(345);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(353);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(364);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! VelocityJS.org (1.2.3). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
	
	/*************************
	   Velocity jQuery Shim
	*************************/
	
	/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
	
	/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
	/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
	/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */
	
	;(function (window) {
	    /***************
	         Setup
	    ***************/
	
	    /* If jQuery is already loaded, there's no point in loading this shim. */
	    if (window.jQuery) {
	        return;
	    }
	
	    /* jQuery base. */
	    var $ = function (selector, context) {
	        return new $.fn.init(selector, context);
	    };
	
	    /********************
	       Private Methods
	    ********************/
	
	    /* jQuery */
	    $.isWindow = function (obj) {
	        /* jshint eqeqeq: false */
	        return obj != null && obj == obj.window;
	    };
	
	    /* jQuery */
	    $.type = function (obj) {
	        if (obj == null) {
	            return obj + "";
	        }
	
	        return typeof obj === "object" || typeof obj === "function" ?
	            class2type[toString.call(obj)] || "object" :
	            typeof obj;
	    };
	
	    /* jQuery */
	    $.isArray = Array.isArray || function (obj) {
	        return $.type(obj) === "array";
	    };
	
	    /* jQuery */
	    function isArraylike (obj) {
	        var length = obj.length,
	            type = $.type(obj);
	
	        if (type === "function" || $.isWindow(obj)) {
	            return false;
	        }
	
	        if (obj.nodeType === 1 && length) {
	            return true;
	        }
	
	        return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
	    }
	
	    /***************
	       $ Methods
	    ***************/
	
	    /* jQuery: Support removed for IE<9. */
	    $.isPlainObject = function (obj) {
	        var key;
	
	        if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
	            return false;
	        }
	
	        try {
	            if (obj.constructor &&
	                !hasOwn.call(obj, "constructor") &&
	                !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
	                return false;
	            }
	        } catch (e) {
	            return false;
	        }
	
	        for (key in obj) {}
	
	        return key === undefined || hasOwn.call(obj, key);
	    };
	
	    /* jQuery */
	    $.each = function(obj, callback, args) {
	        var value,
	            i = 0,
	            length = obj.length,
	            isArray = isArraylike(obj);
	
	        if (args) {
	            if (isArray) {
	                for (; i < length; i++) {
	                    value = callback.apply(obj[i], args);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            } else {
	                for (i in obj) {
	                    value = callback.apply(obj[i], args);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            }
	
	        } else {
	            if (isArray) {
	                for (; i < length; i++) {
	                    value = callback.call(obj[i], i, obj[i]);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            } else {
	                for (i in obj) {
	                    value = callback.call(obj[i], i, obj[i]);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            }
	        }
	
	        return obj;
	    };
	
	    /* Custom */
	    $.data = function (node, key, value) {
	        /* $.getData() */
	        if (value === undefined) {
	            var id = node[$.expando],
	                store = id && cache[id];
	
	            if (key === undefined) {
	                return store;
	            } else if (store) {
	                if (key in store) {
	                    return store[key];
	                }
	            }
	        /* $.setData() */
	        } else if (key !== undefined) {
	            var id = node[$.expando] || (node[$.expando] = ++$.uuid);
	
	            cache[id] = cache[id] || {};
	            cache[id][key] = value;
	
	            return value;
	        }
	    };
	
	    /* Custom */
	    $.removeData = function (node, keys) {
	        var id = node[$.expando],
	            store = id && cache[id];
	
	        if (store) {
	            if (!keys) {
	                delete cache[id];
	            } else {
	                $.each(keys, function(_, key) {
	                    delete store[key];
	                });
	            }
	        }
	    };
	
	    /* jQuery */
	    $.extend = function () {
	        var src, copyIsArray, copy, name, options, clone,
	            target = arguments[0] || {},
	            i = 1,
	            length = arguments.length,
	            deep = false;
	
	        if (typeof target === "boolean") {
	            deep = target;
	
	            target = arguments[i] || {};
	            i++;
	        }
	
	        if (typeof target !== "object" && $.type(target) !== "function") {
	            target = {};
	        }
	
	        if (i === length) {
	            target = this;
	            i--;
	        }
	
	        for (; i < length; i++) {
	            if ((options = arguments[i]) != null) {
	                for (name in options) {
	                    src = target[name];
	                    copy = options[name];
	
	                    if (target === copy) {
	                        continue;
	                    }
	
	                    if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
	                        if (copyIsArray) {
	                            copyIsArray = false;
	                            clone = src && $.isArray(src) ? src : [];
	
	                        } else {
	                            clone = src && $.isPlainObject(src) ? src : {};
	                        }
	
	                        target[name] = $.extend(deep, clone, copy);
	
	                    } else if (copy !== undefined) {
	                        target[name] = copy;
	                    }
	                }
	            }
	        }
	
	        return target;
	    };
	
	    /* jQuery 1.4.3 */
	    $.queue = function (elem, type, data) {
	        function $makeArray (arr, results) {
	            var ret = results || [];
	
	            if (arr != null) {
	                if (isArraylike(Object(arr))) {
	                    /* $.merge */
	                    (function(first, second) {
	                        var len = +second.length,
	                            j = 0,
	                            i = first.length;
	
	                        while (j < len) {
	                            first[i++] = second[j++];
	                        }
	
	                        if (len !== len) {
	                            while (second[j] !== undefined) {
	                                first[i++] = second[j++];
	                            }
	                        }
	
	                        first.length = i;
	
	                        return first;
	                    })(ret, typeof arr === "string" ? [arr] : arr);
	                } else {
	                    [].push.call(ret, arr);
	                }
	            }
	
	            return ret;
	        }
	
	        if (!elem) {
	            return;
	        }
	
	        type = (type || "fx") + "queue";
	
	        var q = $.data(elem, type);
	
	        if (!data) {
	            return q || [];
	        }
	
	        if (!q || $.isArray(data)) {
	            q = $.data(elem, type, $makeArray(data));
	        } else {
	            q.push(data);
	        }
	
	        return q;
	    };
	
	    /* jQuery 1.4.3 */
	    $.dequeue = function (elems, type) {
	        /* Custom: Embed element iteration. */
	        $.each(elems.nodeType ? [ elems ] : elems, function(i, elem) {
	            type = type || "fx";
	
	            var queue = $.queue(elem, type),
	                fn = queue.shift();
	
	            if (fn === "inprogress") {
	                fn = queue.shift();
	            }
	
	            if (fn) {
	                if (type === "fx") {
	                    queue.unshift("inprogress");
	                }
	
	                fn.call(elem, function() {
	                    $.dequeue(elem, type);
	                });
	            }
	        });
	    };
	
	    /******************
	       $.fn Methods
	    ******************/
	
	    /* jQuery */
	    $.fn = $.prototype = {
	        init: function (selector) {
	            /* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
	            if (selector.nodeType) {
	                this[0] = selector;
	
	                return this;
	            } else {
	                throw new Error("Not a DOM node.");
	            }
	        },
	
	        offset: function () {
	            /* jQuery altered code: Dropped disconnected DOM node checking. */
	            var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : { top: 0, left: 0 };
	
	            return {
	                top: box.top + (window.pageYOffset || document.scrollTop  || 0)  - (document.clientTop  || 0),
	                left: box.left + (window.pageXOffset || document.scrollLeft  || 0) - (document.clientLeft || 0)
	            };
	        },
	
	        position: function () {
	            /* jQuery */
	            function offsetParent() {
	                var offsetParent = this.offsetParent || document;
	
	                while (offsetParent && (!offsetParent.nodeType.toLowerCase === "html" && offsetParent.style.position === "static")) {
	                    offsetParent = offsetParent.offsetParent;
	                }
	
	                return offsetParent || document;
	            }
	
	            /* Zepto */
	            var elem = this[0],
	                offsetParent = offsetParent.apply(elem),
	                offset = this.offset(),
	                parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? { top: 0, left: 0 } : $(offsetParent).offset()
	
	            offset.top -= parseFloat(elem.style.marginTop) || 0;
	            offset.left -= parseFloat(elem.style.marginLeft) || 0;
	
	            if (offsetParent.style) {
	                parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0
	                parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0
	            }
	
	            return {
	                top: offset.top - parentOffset.top,
	                left: offset.left - parentOffset.left
	            };
	        }
	    };
	
	    /**********************
	       Private Variables
	    **********************/
	
	    /* For $.data() */
	    var cache = {};
	    $.expando = "velocity" + (new Date().getTime());
	    $.uuid = 0;
	
	    /* For $.queue() */
	    var class2type = {},
	        hasOwn = class2type.hasOwnProperty,
	        toString = class2type.toString;
	
	    var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
	    for (var i = 0; i < types.length; i++) {
	        class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
	    }
	
	    /* Makes $(node) possible, without having to call init. */
	    $.fn.init.prototype = $.fn;
	
	    /* Globalize Velocity onto the window, and assign its Utilities property. */
	    window.Velocity = { Utilities: $ };
	})(window);
	
	/******************
	    Velocity.js
	******************/
	
	;(function (factory) {
	    /* CommonJS module. */
	    if (typeof module === "object" && typeof module.exports === "object") {
	        module.exports = factory();
	    /* AMD module. */
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    /* Browser globals. */
	    } else {
	        factory();
	    }
	}(function() {
	return function (global, window, document, undefined) {
	
	    /***************
	        Summary
	    ***************/
	
	    /*
	    - CSS: CSS stack that works independently from the rest of Velocity.
	    - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
	      - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
	      - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
	                  Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
	      - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
	    - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
	    - completeCall(): Handles the cleanup process for each Velocity call.
	    */
	
	    /*********************
	       Helper Functions
	    *********************/
	
	    /* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
	    var IE = (function() {
	        if (document.documentMode) {
	            return document.documentMode;
	        } else {
	            for (var i = 7; i > 4; i--) {
	                var div = document.createElement("div");
	
	                div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";
	
	                if (div.getElementsByTagName("span").length) {
	                    div = null;
	
	                    return i;
	                }
	            }
	        }
	
	        return undefined;
	    })();
	
	    /* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
	    var rAFShim = (function() {
	        var timeLast = 0;
	
	        return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
	            var timeCurrent = (new Date()).getTime(),
	                timeDelta;
	
	            /* Dynamically set delay on a per-tick basis to match 60fps. */
	            /* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
	            timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
	            timeLast = timeCurrent + timeDelta;
	
	            return setTimeout(function() { callback(timeCurrent + timeDelta); }, timeDelta);
	        };
	    })();
	
	    /* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
	    function compactSparseArray (array) {
	        var index = -1,
	            length = array ? array.length : 0,
	            result = [];
	
	        while (++index < length) {
	            var value = array[index];
	
	            if (value) {
	                result.push(value);
	            }
	        }
	
	        return result;
	    }
	
	    function sanitizeElements (elements) {
	        /* Unwrap jQuery/Zepto objects. */
	        if (Type.isWrapped(elements)) {
	            elements = [].slice.call(elements);
	        /* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
	        } else if (Type.isNode(elements)) {
	            elements = [ elements ];
	        }
	
	        return elements;
	    }
	
	    var Type = {
	        isString: function (variable) {
	            return (typeof variable === "string");
	        },
	        isArray: Array.isArray || function (variable) {
	            return Object.prototype.toString.call(variable) === "[object Array]";
	        },
	        isFunction: function (variable) {
	            return Object.prototype.toString.call(variable) === "[object Function]";
	        },
	        isNode: function (variable) {
	            return variable && variable.nodeType;
	        },
	        /* Copyright Martin Bohm. MIT License: https://gist.github.com/Tomalak/818a78a226a0738eaade */
	        isNodeList: function (variable) {
	            return typeof variable === "object" &&
	                /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(variable)) &&
	                variable.length !== undefined &&
	                (variable.length === 0 || (typeof variable[0] === "object" && variable[0].nodeType > 0));
	        },
	        /* Determine if variable is a wrapped jQuery or Zepto element. */
	        isWrapped: function (variable) {
	            return variable && (variable.jquery || (window.Zepto && window.Zepto.zepto.isZ(variable)));
	        },
	        isSVG: function (variable) {
	            return window.SVGElement && (variable instanceof window.SVGElement);
	        },
	        isEmptyObject: function (variable) {
	            for (var name in variable) {
	                return false;
	            }
	
	            return true;
	        }
	    };
	
	    /*****************
	       Dependencies
	    *****************/
	
	    var $,
	        isJQuery = false;
	
	    if (global.fn && global.fn.jquery) {
	        $ = global;
	        isJQuery = true;
	    } else {
	        $ = window.Velocity.Utilities;
	    }
	
	    if (IE <= 8 && !isJQuery) {
	        throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
	    } else if (IE <= 7) {
	        /* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
	        jQuery.fn.velocity = jQuery.fn.animate;
	
	        /* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
	        return;
	    }
	
	    /*****************
	        Constants
	    *****************/
	
	    var DURATION_DEFAULT = 400,
	        EASING_DEFAULT = "swing";
	
	    /*************
	        State
	    *************/
	
	    var Velocity = {
	        /* Container for page-wide Velocity state data. */
	        State: {
	            /* Detect mobile devices to determine if mobileHA should be turned on. */
	            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
	            /* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
	            isAndroid: /Android/i.test(navigator.userAgent),
	            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
	            isChrome: window.chrome,
	            isFirefox: /Firefox/i.test(navigator.userAgent),
	            /* Create a cached element for re-use when checking for CSS property prefixes. */
	            prefixElement: document.createElement("div"),
	            /* Cache every prefix match to avoid repeating lookups. */
	            prefixMatches: {},
	            /* Cache the anchor used for animating window scrolling. */
	            scrollAnchor: null,
	            /* Cache the browser-specific property names associated with the scroll anchor. */
	            scrollPropertyLeft: null,
	            scrollPropertyTop: null,
	            /* Keep track of whether our RAF tick is running. */
	            isTicking: false,
	            /* Container for every in-progress call to Velocity. */
	            calls: []
	        },
	        /* Velocity's custom CSS stack. Made global for unit testing. */
	        CSS: { /* Defined below. */ },
	        /* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
	        Utilities: $,
	        /* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
	        Redirects: { /* Manually registered by the user. */ },
	        Easings: { /* Defined below. */ },
	        /* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
	        Promise: window.Promise,
	        /* Velocity option defaults, which can be overriden by the user. */
	        defaults: {
	            queue: "",
	            duration: DURATION_DEFAULT,
	            easing: EASING_DEFAULT,
	            begin: undefined,
	            complete: undefined,
	            progress: undefined,
	            display: undefined,
	            visibility: undefined,
	            loop: false,
	            delay: false,
	            mobileHA: true,
	            /* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
	            _cacheValues: true
	        },
	        /* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
	        init: function (element) {
	            $.data(element, "velocity", {
	                /* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
	                isSVG: Type.isSVG(element),
	                /* Keep track of whether the element is currently being animated by Velocity.
	                   This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
	                isAnimating: false,
	                /* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
	                computedStyle: null,
	                /* Tween data is cached for each animation on the element so that data can be passed across calls --
	                   in particular, end values are used as subsequent start values in consecutive Velocity calls. */
	                tweensContainer: null,
	                /* The full root property values of each CSS hook being animated on this element are cached so that:
	                   1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
	                   2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
	                rootPropertyValueCache: {},
	                /* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
	                transformCache: {}
	            });
	        },
	        /* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
	        hook: null, /* Defined below. */
	        /* Velocity-wide animation time remapping for testing purposes. */
	        mock: false,
	        version: { major: 1, minor: 2, patch: 2 },
	        /* Set to 1 or 2 (most verbose) to output debug info to console. */
	        debug: false
	    };
	
	    /* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
	    if (window.pageYOffset !== undefined) {
	        Velocity.State.scrollAnchor = window;
	        Velocity.State.scrollPropertyLeft = "pageXOffset";
	        Velocity.State.scrollPropertyTop = "pageYOffset";
	    } else {
	        Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
	        Velocity.State.scrollPropertyLeft = "scrollLeft";
	        Velocity.State.scrollPropertyTop = "scrollTop";
	    }
	
	    /* Shorthand alias for jQuery's $.data() utility. */
	    function Data (element) {
	        /* Hardcode a reference to the plugin name. */
	        var response = $.data(element, "velocity");
	
	        /* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
	        return response === null ? undefined : response;
	    };
	
	    /**************
	        Easing
	    **************/
	
	    /* Step easing generator. */
	    function generateStep (steps) {
	        return function (p) {
	            return Math.round(p * steps) * (1 / steps);
	        };
	    }
	
	    /* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
	    function generateBezier (mX1, mY1, mX2, mY2) {
	        var NEWTON_ITERATIONS = 4,
	            NEWTON_MIN_SLOPE = 0.001,
	            SUBDIVISION_PRECISION = 0.0000001,
	            SUBDIVISION_MAX_ITERATIONS = 10,
	            kSplineTableSize = 11,
	            kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
	            float32ArraySupported = "Float32Array" in window;
	
	        /* Must contain four arguments. */
	        if (arguments.length !== 4) {
	            return false;
	        }
	
	        /* Arguments must be numbers. */
	        for (var i = 0; i < 4; ++i) {
	            if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
	                return false;
	            }
	        }
	
	        /* X values must be in the [0, 1] range. */
	        mX1 = Math.min(mX1, 1);
	        mX2 = Math.min(mX2, 1);
	        mX1 = Math.max(mX1, 0);
	        mX2 = Math.max(mX2, 0);
	
	        var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	
	        function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	        function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	        function C (aA1)      { return 3.0 * aA1; }
	
	        function calcBezier (aT, aA1, aA2) {
	            return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	        }
	
	        function getSlope (aT, aA1, aA2) {
	            return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	        }
	
	        function newtonRaphsonIterate (aX, aGuessT) {
	            for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	                var currentSlope = getSlope(aGuessT, mX1, mX2);
	
	                if (currentSlope === 0.0) return aGuessT;
	
	                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	                aGuessT -= currentX / currentSlope;
	            }
	
	            return aGuessT;
	        }
	
	        function calcSampleValues () {
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        }
	
	        function binarySubdivide (aX, aA, aB) {
	            var currentX, currentT, i = 0;
	
	            do {
	                currentT = aA + (aB - aA) / 2.0;
	                currentX = calcBezier(currentT, mX1, mX2) - aX;
	                if (currentX > 0.0) {
	                  aB = currentT;
	                } else {
	                  aA = currentT;
	                }
	            } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	
	            return currentT;
	        }
	
	        function getTForX (aX) {
	            var intervalStart = 0.0,
	                currentSample = 1,
	                lastSample = kSplineTableSize - 1;
	
	            for (; currentSample != lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	
	            --currentSample;
	
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]),
	                guessForT = intervalStart + dist * kSampleStepSize,
	                initialSlope = getSlope(guessForT, mX1, mX2);
	
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT);
	            } else if (initialSlope == 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
	            }
	        }
	
	        var _precomputed = false;
	
	        function precompute() {
	            _precomputed = true;
	            if (mX1 != mY1 || mX2 != mY2) calcSampleValues();
	        }
	
	        var f = function (aX) {
	            if (!_precomputed) precompute();
	            if (mX1 === mY1 && mX2 === mY2) return aX;
	            if (aX === 0) return 0;
	            if (aX === 1) return 1;
	
	            return calcBezier(getTForX(aX), mY1, mY2);
	        };
	
	        f.getControlPoints = function() { return [{ x: mX1, y: mY1 }, { x: mX2, y: mY2 }]; };
	
	        var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
	        f.toString = function () { return str; };
	
	        return f;
	    }
	
	    /* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
	    /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
	       then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
	    var generateSpringRK4 = (function () {
	        function springAccelerationForState (state) {
	            return (-state.tension * state.x) - (state.friction * state.v);
	        }
	
	        function springEvaluateStateWithDerivative (initialState, dt, derivative) {
	            var state = {
	                x: initialState.x + derivative.dx * dt,
	                v: initialState.v + derivative.dv * dt,
	                tension: initialState.tension,
	                friction: initialState.friction
	            };
	
	            return { dx: state.v, dv: springAccelerationForState(state) };
	        }
	
	        function springIntegrateState (state, dt) {
	            var a = {
	                    dx: state.v,
	                    dv: springAccelerationForState(state)
	                },
	                b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
	                c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
	                d = springEvaluateStateWithDerivative(state, dt, c),
	                dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
	                dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
	
	            state.x = state.x + dxdt * dt;
	            state.v = state.v + dvdt * dt;
	
	            return state;
	        }
	
	        return function springRK4Factory (tension, friction, duration) {
	
	            var initState = {
	                    x: -1,
	                    v: 0,
	                    tension: null,
	                    friction: null
	                },
	                path = [0],
	                time_lapsed = 0,
	                tolerance = 1 / 10000,
	                DT = 16 / 1000,
	                have_duration, dt, last_state;
	
	            tension = parseFloat(tension) || 500;
	            friction = parseFloat(friction) || 20;
	            duration = duration || null;
	
	            initState.tension = tension;
	            initState.friction = friction;
	
	            have_duration = duration !== null;
	
	            /* Calculate the actual time it takes for this animation to complete with the provided conditions. */
	            if (have_duration) {
	                /* Run the simulation without a duration. */
	                time_lapsed = springRK4Factory(tension, friction);
	                /* Compute the adjusted time delta. */
	                dt = time_lapsed / duration * DT;
	            } else {
	                dt = DT;
	            }
	
	            while (true) {
	                /* Next/step function .*/
	                last_state = springIntegrateState(last_state || initState, dt);
	                /* Store the position. */
	                path.push(1 + last_state.x);
	                time_lapsed += 16;
	                /* If the change threshold is reached, break. */
	                if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
	                    break;
	                }
	            }
	
	            /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
	               computed path and returns a snapshot of the position according to a given percentComplete. */
	            return !have_duration ? time_lapsed : function(percentComplete) { return path[ (percentComplete * (path.length - 1)) | 0 ]; };
	        };
	    }());
	
	    /* jQuery easings. */
	    Velocity.Easings = {
	        linear: function(p) { return p; },
	        swing: function(p) { return 0.5 - Math.cos( p * Math.PI ) / 2 },
	        /* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
	        spring: function(p) { return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6)); }
	    };
	
	    /* CSS3 and Robert Penner easings. */
	    $.each(
	        [
	            [ "ease", [ 0.25, 0.1, 0.25, 1.0 ] ],
	            [ "ease-in", [ 0.42, 0.0, 1.00, 1.0 ] ],
	            [ "ease-out", [ 0.00, 0.0, 0.58, 1.0 ] ],
	            [ "ease-in-out", [ 0.42, 0.0, 0.58, 1.0 ] ],
	            [ "easeInSine", [ 0.47, 0, 0.745, 0.715 ] ],
	            [ "easeOutSine", [ 0.39, 0.575, 0.565, 1 ] ],
	            [ "easeInOutSine", [ 0.445, 0.05, 0.55, 0.95 ] ],
	            [ "easeInQuad", [ 0.55, 0.085, 0.68, 0.53 ] ],
	            [ "easeOutQuad", [ 0.25, 0.46, 0.45, 0.94 ] ],
	            [ "easeInOutQuad", [ 0.455, 0.03, 0.515, 0.955 ] ],
	            [ "easeInCubic", [ 0.55, 0.055, 0.675, 0.19 ] ],
	            [ "easeOutCubic", [ 0.215, 0.61, 0.355, 1 ] ],
	            [ "easeInOutCubic", [ 0.645, 0.045, 0.355, 1 ] ],
	            [ "easeInQuart", [ 0.895, 0.03, 0.685, 0.22 ] ],
	            [ "easeOutQuart", [ 0.165, 0.84, 0.44, 1 ] ],
	            [ "easeInOutQuart", [ 0.77, 0, 0.175, 1 ] ],
	            [ "easeInQuint", [ 0.755, 0.05, 0.855, 0.06 ] ],
	            [ "easeOutQuint", [ 0.23, 1, 0.32, 1 ] ],
	            [ "easeInOutQuint", [ 0.86, 0, 0.07, 1 ] ],
	            [ "easeInExpo", [ 0.95, 0.05, 0.795, 0.035 ] ],
	            [ "easeOutExpo", [ 0.19, 1, 0.22, 1 ] ],
	            [ "easeInOutExpo", [ 1, 0, 0, 1 ] ],
	            [ "easeInCirc", [ 0.6, 0.04, 0.98, 0.335 ] ],
	            [ "easeOutCirc", [ 0.075, 0.82, 0.165, 1 ] ],
	            [ "easeInOutCirc", [ 0.785, 0.135, 0.15, 0.86 ] ]
	        ], function(i, easingArray) {
	            Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
	        });
	
	    /* Determine the appropriate easing type given an easing input. */
	    function getEasing(value, duration) {
	        var easing = value;
	
	        /* The easing option can either be a string that references a pre-registered easing,
	           or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
	        if (Type.isString(value)) {
	            /* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
	            if (!Velocity.Easings[value]) {
	                easing = false;
	            }
	        } else if (Type.isArray(value) && value.length === 1) {
	            easing = generateStep.apply(null, value);
	        } else if (Type.isArray(value) && value.length === 2) {
	            /* springRK4 must be passed the animation's duration. */
	            /* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
	               function generated with default tension and friction values. */
	            easing = generateSpringRK4.apply(null, value.concat([ duration ]));
	        } else if (Type.isArray(value) && value.length === 4) {
	            /* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
	            easing = generateBezier.apply(null, value);
	        } else {
	            easing = false;
	        }
	
	        /* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
	           if the Velocity-wide default has been incorrectly modified. */
	        if (easing === false) {
	            if (Velocity.Easings[Velocity.defaults.easing]) {
	                easing = Velocity.defaults.easing;
	            } else {
	                easing = EASING_DEFAULT;
	            }
	        }
	
	        return easing;
	    }
	
	    /*****************
	        CSS Stack
	    *****************/
	
	    /* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
	       It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
	    /* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
	    var CSS = Velocity.CSS = {
	
	        /*************
	            RegEx
	        *************/
	
	        RegEx: {
	            isHex: /^#([A-f\d]{3}){1,2}$/i,
	            /* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
	            valueUnwrap: /^[A-z]+\((.*)\)$/i,
	            wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
	            /* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
	            valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
	        },
	
	        /************
	            Lists
	        ************/
	
	        Lists: {
	            colors: [ "fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor" ],
	            transformsBase: [ "translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ" ],
	            transforms3D: [ "transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY" ]
	        },
	
	        /************
	            Hooks
	        ************/
	
	        /* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
	           (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
	        /* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
	           tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
	        Hooks: {
	            /********************
	                Registration
	            ********************/
	
	            /* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
	            /* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
	            templates: {
	                "textShadow": [ "Color X Y Blur", "black 0px 0px 0px" ],
	                "boxShadow": [ "Color X Y Blur Spread", "black 0px 0px 0px 0px" ],
	                "clip": [ "Top Right Bottom Left", "0px 0px 0px 0px" ],
	                "backgroundPosition": [ "X Y", "0% 0%" ],
	                "transformOrigin": [ "X Y Z", "50% 50% 0px" ],
	                "perspectiveOrigin": [ "X Y", "50% 50%" ]
	            },
	
	            /* A "registered" hook is one that has been converted from its template form into a live,
	               tweenable property. It contains data to associate it with its root property. */
	            registered: {
	                /* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
	                   which consists of the subproperty's name, the associated root property's name,
	                   and the subproperty's position in the root's value. */
	            },
	            /* Convert the templates into individual hooks then append them to the registered object above. */
	            register: function () {
	                /* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
	                   currently set to "transparent" default to their respective template below when color-animated,
	                   and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
	                   which is almost always set closer to black than white. */
	                for (var i = 0; i < CSS.Lists.colors.length; i++) {
	                    var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
	                    CSS.Hooks.templates[CSS.Lists.colors[i]] = [ "Red Green Blue Alpha", rgbComponents ];
	                }
	
	                var rootProperty,
	                    hookTemplate,
	                    hookNames;
	
	                /* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
	                   Thus, we re-arrange the templates accordingly. */
	                if (IE) {
	                    for (rootProperty in CSS.Hooks.templates) {
	                        hookTemplate = CSS.Hooks.templates[rootProperty];
	                        hookNames = hookTemplate[0].split(" ");
	
	                        var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);
	
	                        if (hookNames[0] === "Color") {
	                            /* Reposition both the hook's name and its default value to the end of their respective strings. */
	                            hookNames.push(hookNames.shift());
	                            defaultValues.push(defaultValues.shift());
	
	                            /* Replace the existing template for the hook's root property. */
	                            CSS.Hooks.templates[rootProperty] = [ hookNames.join(" "), defaultValues.join(" ") ];
	                        }
	                    }
	                }
	
	                /* Hook registration. */
	                for (rootProperty in CSS.Hooks.templates) {
	                    hookTemplate = CSS.Hooks.templates[rootProperty];
	                    hookNames = hookTemplate[0].split(" ");
	
	                    for (var i in hookNames) {
	                        var fullHookName = rootProperty + hookNames[i],
	                            hookPosition = i;
	
	                        /* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
	                           and the hook's position in its template's default value string. */
	                        CSS.Hooks.registered[fullHookName] = [ rootProperty, hookPosition ];
	                    }
	                }
	            },
	
	            /*****************************
	               Injection and Extraction
	            *****************************/
	
	            /* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
	            /* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
	            getRoot: function (property) {
	                var hookData = CSS.Hooks.registered[property];
	
	                if (hookData) {
	                    return hookData[0];
	                } else {
	                    /* If there was no hook match, return the property name untouched. */
	                    return property;
	                }
	            },
	            /* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
	               the targeted hook can be injected or extracted at its standard position. */
	            cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
	                /* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
	                if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
	                    rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
	                }
	
	                /* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
	                   default to the root's default value as defined in CSS.Hooks.templates. */
	                /* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
	                   zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
	                if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
	                    rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
	                }
	
	                return rootPropertyValue;
	            },
	            /* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
	            extractValue: function (fullHookName, rootPropertyValue) {
	                var hookData = CSS.Hooks.registered[fullHookName];
	
	                if (hookData) {
	                    var hookRoot = hookData[0],
	                        hookPosition = hookData[1];
	
	                    rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
	                    /* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
	                    return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
	                } else {
	                    /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
	                    return rootPropertyValue;
	                }
	            },
	            /* Inject the hook's value into its root property's value. This is used to piece back together the root property
	               once Velocity has updated one of its individually hooked values through tweening. */
	            injectValue: function (fullHookName, hookValue, rootPropertyValue) {
	                var hookData = CSS.Hooks.registered[fullHookName];
	
	                if (hookData) {
	                    var hookRoot = hookData[0],
	                        hookPosition = hookData[1],
	                        rootPropertyValueParts,
	                        rootPropertyValueUpdated;
	
	                    rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
	                    /* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
	                       then reconstruct the rootPropertyValue string. */
	                    rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
	                    rootPropertyValueParts[hookPosition] = hookValue;
	                    rootPropertyValueUpdated = rootPropertyValueParts.join(" ");
	
	                    return rootPropertyValueUpdated;
	                } else {
	                    /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
	                    return rootPropertyValue;
	                }
	            }
	        },
	
	        /*******************
	           Normalizations
	        *******************/
	
	        /* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
	           and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
	        Normalizations: {
	            /* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
	               the targeted element (which may need to be queried), and the targeted property value. */
	            registered: {
	                clip: function (type, element, propertyValue) {
	                    switch (type) {
	                        case "name":
	                            return "clip";
	                        /* Clip needs to be unwrapped and stripped of its commas during extraction. */
	                        case "extract":
	                            var extracted;
	
	                            /* If Velocity also extracted this value, skip extraction. */
	                            if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
	                                extracted = propertyValue;
	                            } else {
	                                /* Remove the "rect()" wrapper. */
	                                extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);
	
	                                /* Strip off commas. */
	                                extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
	                            }
	
	                            return extracted;
	                        /* Clip needs to be re-wrapped during injection. */
	                        case "inject":
	                            return "rect(" + propertyValue + ")";
	                    }
	                },
	
	                blur: function(type, element, propertyValue) {
	                    switch (type) {
	                        case "name":
	                            return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
	                        case "extract":
	                            var extracted = parseFloat(propertyValue);
	
	                            /* If extracted is NaN, meaning the value isn't already extracted. */
	                            if (!(extracted || extracted === 0)) {
	                                var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
	
	                                /* If the filter string had a blur component, return just the blur value and unit type. */
	                                if (blurComponent) {
	                                    extracted = blurComponent[1];
	                                /* If the component doesn't exist, default blur to 0. */
	                                } else {
	                                    extracted = 0;
	                                }
	                            }
	
	                            return extracted;
	                        /* Blur needs to be re-wrapped during injection. */
	                        case "inject":
	                            /* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
	                            if (!parseFloat(propertyValue)) {
	                                return "none";
	                            } else {
	                                return "blur(" + propertyValue + ")";
	                            }
	                    }
	                },
	
	                /* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
	                opacity: function (type, element, propertyValue) {
	                    if (IE <= 8) {
	                        switch (type) {
	                            case "name":
	                                return "filter";
	                            case "extract":
	                                /* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
	                                   Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
	                                var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);
	
	                                if (extracted) {
	                                    /* Convert to decimal value. */
	                                    propertyValue = extracted[1] / 100;
	                                } else {
	                                    /* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
	                                    propertyValue = 1;
	                                }
	
	                                return propertyValue;
	                            case "inject":
	                                /* Opacified elements are required to have their zoom property set to a non-zero value. */
	                                element.style.zoom = 1;
	
	                                /* Setting the filter property on elements with certain font property combinations can result in a
	                                   highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
	                                   value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
	                                if (parseFloat(propertyValue) >= 1) {
	                                    return "";
	                                } else {
	                                  /* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
	                                  return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
	                                }
	                        }
	                    /* With all other browsers, normalization is not required; return the same values that were passed in. */
	                    } else {
	                        switch (type) {
	                            case "name":
	                                return "opacity";
	                            case "extract":
	                                return propertyValue;
	                            case "inject":
	                                return propertyValue;
	                        }
	                    }
	                }
	            },
	
	            /*****************************
	                Batched Registrations
	            *****************************/
	
	            /* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
	            register: function () {
	
	                /*****************
	                    Transforms
	                *****************/
	
	                /* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
	                   so that they can be referenced in a properties map by their individual names. */
	                /* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
	                   setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
	                   Transform setting is batched in this way to improve performance: the transform style only needs to be updated
	                   once when multiple transform subproperties are being animated simultaneously. */
	                /* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
	                   transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
	                   from being normalized for these browsers so that tweening skips these properties altogether
	                   (since it will ignore them as being unsupported by the browser.) */
	                if (!(IE <= 9) && !Velocity.State.isGingerbread) {
	                    /* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
	                    share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
	                    CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
	                }
	
	                for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
	                    /* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
	                    paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
	                    (function() {
	                        var transformName = CSS.Lists.transformsBase[i];
	
	                        CSS.Normalizations.registered[transformName] = function (type, element, propertyValue) {
	                            switch (type) {
	                                /* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
	                                case "name":
	                                    return "transform";
	                                /* Transform values are cached onto a per-element transformCache object. */
	                                case "extract":
	                                    /* If this transform has yet to be assigned a value, return its null value. */
	                                    if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
	                                        /* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
	                                        return /^scale/i.test(transformName) ? 1 : 0;
	                                    /* When transform values are set, they are wrapped in parentheses as per the CSS spec.
	                                       Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
	                                    } else {
	                                        return Data(element).transformCache[transformName].replace(/[()]/g, "");
	                                    }
	                                case "inject":
	                                    var invalid = false;
	
	                                    /* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
	                                       Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
	                                    /* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
	                                    switch (transformName.substr(0, transformName.length - 1)) {
	                                        /* Whitelist unit types for each transform. */
	                                        case "translate":
	                                            invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
	                                            break;
	                                        /* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
	                                        case "scal":
	                                        case "scale":
	                                            /* Chrome on Android has a bug in which scaled elements blur if their initial scale
	                                               value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
	                                               and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
	                                            if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
	                                                propertyValue = 1;
	                                            }
	
	                                            invalid = !/(\d)$/i.test(propertyValue);
	                                            break;
	                                        case "skew":
	                                            invalid = !/(deg|\d)$/i.test(propertyValue);
	                                            break;
	                                        case "rotate":
	                                            invalid = !/(deg|\d)$/i.test(propertyValue);
	                                            break;
	                                    }
	
	                                    if (!invalid) {
	                                        /* As per the CSS spec, wrap the value in parentheses. */
	                                        Data(element).transformCache[transformName] = "(" + propertyValue + ")";
	                                    }
	
	                                    /* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
	                                    return Data(element).transformCache[transformName];
	                            }
	                        };
	                    })();
	                }
	
	                /*************
	                    Colors
	                *************/
	
	                /* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
	                   Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
	                for (var i = 0; i < CSS.Lists.colors.length; i++) {
	                    /* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
	                       (Otherwise, all functions would take the final for loop's colorName.) */
	                    (function () {
	                        var colorName = CSS.Lists.colors[i];
	
	                        /* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
	                        CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
	                            switch (type) {
	                                case "name":
	                                    return colorName;
	                                /* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
	                                case "extract":
	                                    var extracted;
	
	                                    /* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
	                                    if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
	                                        extracted = propertyValue;
	                                    } else {
	                                        var converted,
	                                            colorNames = {
	                                                black: "rgb(0, 0, 0)",
	                                                blue: "rgb(0, 0, 255)",
	                                                gray: "rgb(128, 128, 128)",
	                                                green: "rgb(0, 128, 0)",
	                                                red: "rgb(255, 0, 0)",
	                                                white: "rgb(255, 255, 255)"
	                                            };
	
	                                        /* Convert color names to rgb. */
	                                        if (/^[A-z]+$/i.test(propertyValue)) {
	                                            if (colorNames[propertyValue] !== undefined) {
	                                                converted = colorNames[propertyValue]
	                                            } else {
	                                                /* If an unmatched color name is provided, default to black. */
	                                                converted = colorNames.black;
	                                            }
	                                        /* Convert hex values to rgb. */
	                                        } else if (CSS.RegEx.isHex.test(propertyValue)) {
	                                            converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
	                                        /* If the provided color doesn't match any of the accepted color formats, default to black. */
	                                        } else if (!(/^rgba?\(/i.test(propertyValue))) {
	                                            converted = colorNames.black;
	                                        }
	
	                                        /* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
	                                           repeated spaces (in case the value included spaces to begin with). */
	                                        extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
	                                    }
	
	                                    /* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
	                                    if (!(IE <= 8) && extracted.split(" ").length === 3) {
	                                        extracted += " 1";
	                                    }
	
	                                    return extracted;
	                                case "inject":
	                                    /* If this is IE<=8 and an alpha component exists, strip it off. */
	                                    if (IE <= 8) {
	                                        if (propertyValue.split(" ").length === 4) {
	                                            propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
	                                        }
	                                    /* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
	                                    } else if (propertyValue.split(" ").length === 3) {
	                                        propertyValue += " 1";
	                                    }
	
	                                    /* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
	                                       on all values but the fourth (R, G, and B only accept whole numbers). */
	                                    return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
	                            }
	                        };
	                    })();
	                }
	            }
	        },
	
	        /************************
	           CSS Property Names
	        ************************/
	
	        Names: {
	            /* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
	               Camelcasing is used to normalize property names between and across calls. */
	            camelCase: function (property) {
	                return property.replace(/-(\w)/g, function (match, subMatch) {
	                    return subMatch.toUpperCase();
	                });
	            },
	
	            /* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
	            SVGAttribute: function (property) {
	                var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
	
	                /* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
	                if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
	                    SVGAttributes += "|transform";
	                }
	
	                return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
	            },
	
	            /* Determine whether a property should be set with a vendor prefix. */
	            /* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
	               If the property is not at all supported by the browser, return a false flag. */
	            prefixCheck: function (property) {
	                /* If this property has already been checked, return the cached value. */
	                if (Velocity.State.prefixMatches[property]) {
	                    return [ Velocity.State.prefixMatches[property], true ];
	                } else {
	                    var vendors = [ "", "Webkit", "Moz", "ms", "O" ];
	
	                    for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
	                        var propertyPrefixed;
	
	                        if (i === 0) {
	                            propertyPrefixed = property;
	                        } else {
	                            /* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
	                            propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) { return match.toUpperCase(); });
	                        }
	
	                        /* Check if the browser supports this property as prefixed. */
	                        if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
	                            /* Cache the match. */
	                            Velocity.State.prefixMatches[property] = propertyPrefixed;
	
	                            return [ propertyPrefixed, true ];
	                        }
	                    }
	
	                    /* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
	                    return [ property, false ];
	                }
	            }
	        },
	
	        /************************
	           CSS Property Values
	        ************************/
	
	        Values: {
	            /* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
	            hexToRgb: function (hex) {
	                var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
	                    longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
	                    rgbParts;
	
	                hex = hex.replace(shortformRegex, function (m, r, g, b) {
	                    return r + r + g + g + b + b;
	                });
	
	                rgbParts = longformRegex.exec(hex);
	
	                return rgbParts ? [ parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16) ] : [ 0, 0, 0 ];
	            },
	
	            isCSSNullValue: function (value) {
	                /* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
	                   Thus, we check for both falsiness and these special strings. */
	                /* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
	                   templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
	                /* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
	                return (value == 0 || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
	            },
	
	            /* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
	            getUnitType: function (property) {
	                if (/^(rotate|skew)/i.test(property)) {
	                    return "deg";
	                } else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
	                    /* The above properties are unitless. */
	                    return "";
	                } else {
	                    /* Default to px for all other properties. */
	                    return "px";
	                }
	            },
	
	            /* HTML elements default to an associated display type when they're not set to display:none. */
	            /* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
	            getDisplayType: function (element) {
	                var tagName = element && element.tagName.toString().toLowerCase();
	
	                if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
	                    return "inline";
	                } else if (/^(li)$/i.test(tagName)) {
	                    return "list-item";
	                } else if (/^(tr)$/i.test(tagName)) {
	                    return "table-row";
	                } else if (/^(table)$/i.test(tagName)) {
	                    return "table";
	                } else if (/^(tbody)$/i.test(tagName)) {
	                    return "table-row-group";
	                /* Default to "block" when no match is found. */
	                } else {
	                    return "block";
	                }
	            },
	
	            /* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
	            addClass: function (element, className) {
	                if (element.classList) {
	                    element.classList.add(className);
	                } else {
	                    element.className += (element.className.length ? " " : "") + className;
	                }
	            },
	
	            removeClass: function (element, className) {
	                if (element.classList) {
	                    element.classList.remove(className);
	                } else {
	                    element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
	                }
	            }
	        },
	
	        /****************************
	           Style Getting & Setting
	        ****************************/
	
	        /* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
	        getPropertyValue: function (element, property, rootPropertyValue, forceStyleLookup) {
	            /* Get an element's computed property value. */
	            /* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
	               style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
	               *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
	            function computePropertyValue (element, property) {
	                /* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
	                   element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
	                   offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
	                   We subtract border and padding to get the sum of interior + scrollbar. */
	                var computedValue = 0;
	
	                /* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
	                   of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
	                   codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
	                   Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
	                if (IE <= 8) {
	                    computedValue = $.css(element, property); /* GET */
	                /* All other browsers support getComputedStyle. The returned live object reference is cached onto its
	                   associated element so that it does not need to be refetched upon every GET. */
	                } else {
	                    /* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
	                       toggle display to the element type's default value. */
	                    var toggleDisplay = false;
	
	                    if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
	                        toggleDisplay = true;
	                        CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
	                    }
	
	                    function revertDisplay () {
	                        if (toggleDisplay) {
	                            CSS.setPropertyValue(element, "display", "none");
	                        }
	                    }
	
	                    if (!forceStyleLookup) {
	                        if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
	                            var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
	                            revertDisplay();
	
	                            return contentBoxHeight;
	                        } else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
	                            var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
	                            revertDisplay();
	
	                            return contentBoxWidth;
	                        }
	                    }
	
	                    var computedStyle;
	
	                    /* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
	                       of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
	                    if (Data(element) === undefined) {
	                        computedStyle = window.getComputedStyle(element, null); /* GET */
	                    /* If the computedStyle object has yet to be cached, do so now. */
	                    } else if (!Data(element).computedStyle) {
	                        computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
	                    /* If computedStyle is cached, use it. */
	                    } else {
	                        computedStyle = Data(element).computedStyle;
	                    }
	
	                    /* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
	                       Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
	                       So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
	                    if (property === "borderColor") {
	                        property = "borderTopColor";
	                    }
	
	                    /* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
	                       instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
	                    if (IE === 9 && property === "filter") {
	                        computedValue = computedStyle.getPropertyValue(property); /* GET */
	                    } else {
	                        computedValue = computedStyle[property];
	                    }
	
	                    /* Fall back to the property's style value (if defined) when computedValue returns nothing,
	                       which can happen when the element hasn't been painted. */
	                    if (computedValue === "" || computedValue === null) {
	                        computedValue = element.style[property];
	                    }
	
	                    revertDisplay();
	                }
	
	                /* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
	                   defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
	                   effect as being set to 0, so no conversion is necessary.) */
	                /* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
	                   property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
	                   to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
	                if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
	                    var position = computePropertyValue(element, "position"); /* GET */
	
	                    /* For absolute positioning, jQuery's $.position() only returns values for top and left;
	                       right and bottom will have their "auto" value reverted to 0. */
	                    /* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
	                       Not a big deal since we're currently in a GET batch anyway. */
	                    if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
	                        /* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
	                        computedValue = $(element).position()[property] + "px"; /* GET */
	                    }
	                }
	
	                return computedValue;
	            }
	
	            var propertyValue;
	
	            /* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
	               extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
	            if (CSS.Hooks.registered[property]) {
	                var hook = property,
	                    hookRoot = CSS.Hooks.getRoot(hook);
	
	                /* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
	                   query the DOM for the root property's value. */
	                if (rootPropertyValue === undefined) {
	                    /* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
	                    rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
	                }
	
	                /* If this root has a normalization registered, peform the associated normalization extraction. */
	                if (CSS.Normalizations.registered[hookRoot]) {
	                    rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
	                }
	
	                /* Extract the hook's value. */
	                propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);
	
	            /* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
	               normalize the property's name and value, and handle the special case of transforms. */
	            /* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
	               numerical and therefore do not require normalization extraction. */
	            } else if (CSS.Normalizations.registered[property]) {
	                var normalizedPropertyName,
	                    normalizedPropertyValue;
	
	                normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);
	
	                /* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
	                   At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
	                   This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
	                   thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
	                if (normalizedPropertyName !== "transform") {
	                    normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */
	
	                    /* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
	                    if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
	                        normalizedPropertyValue = CSS.Hooks.templates[property][1];
	                    }
	                }
	
	                propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
	            }
	
	            /* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
	            if (!/^[\d-]/.test(propertyValue)) {
	                /* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
	                   their HTML attribute values instead of their CSS style values. */
	                if (Data(element) && Data(element).isSVG && CSS.Names.SVGAttribute(property)) {
	                    /* Since the height/width attribute values must be set manually, they don't reflect computed values.
	                       Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
	                    if (/^(height|width)$/i.test(property)) {
	                        /* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
	                        try {
	                            propertyValue = element.getBBox()[property];
	                        } catch (error) {
	                            propertyValue = 0;
	                        }
	                    /* Otherwise, access the attribute value directly. */
	                    } else {
	                        propertyValue = element.getAttribute(property);
	                    }
	                } else {
	                    propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
	                }
	            }
	
	            /* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
	               convert CSS null-values to an integer of value 0. */
	            if (CSS.Values.isCSSNullValue(propertyValue)) {
	                propertyValue = 0;
	            }
	
	            if (Velocity.debug >= 2) console.log("Get " + property + ": " + propertyValue);
	
	            return propertyValue;
	        },
	
	        /* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
	        setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
	            var propertyName = property;
	
	            /* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
	            if (property === "scroll") {
	                /* If a container option is present, scroll the container instead of the browser window. */
	                if (scrollData.container) {
	                    scrollData.container["scroll" + scrollData.direction] = propertyValue;
	                /* Otherwise, Velocity defaults to scrolling the browser window. */
	                } else {
	                    if (scrollData.direction === "Left") {
	                        window.scrollTo(propertyValue, scrollData.alternateValue);
	                    } else {
	                        window.scrollTo(scrollData.alternateValue, propertyValue);
	                    }
	                }
	            } else {
	                /* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
	                   Thus, for now, we merely cache transforms being SET. */
	                if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
	                    /* Perform a normalization injection. */
	                    /* Note: The normalization logic handles the transformCache updating. */
	                    CSS.Normalizations.registered[property]("inject", element, propertyValue);
	
	                    propertyName = "transform";
	                    propertyValue = Data(element).transformCache[property];
	                } else {
	                    /* Inject hooks. */
	                    if (CSS.Hooks.registered[property]) {
	                        var hookName = property,
	                            hookRoot = CSS.Hooks.getRoot(property);
	
	                        /* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
	                        rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */
	
	                        propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
	                        property = hookRoot;
	                    }
	
	                    /* Normalize names and values. */
	                    if (CSS.Normalizations.registered[property]) {
	                        propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
	                        property = CSS.Normalizations.registered[property]("name", element);
	                    }
	
	                    /* Assign the appropriate vendor prefix before performing an official style update. */
	                    propertyName = CSS.Names.prefixCheck(property)[0];
	
	                    /* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
	                       Try/catch is avoided for other browsers since it incurs a performance overhead. */
	                    if (IE <= 8) {
	                        try {
	                            element.style[propertyName] = propertyValue;
	                        } catch (error) { if (Velocity.debug) console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]"); }
	                    /* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
	                    /* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
	                    } else if (Data(element) && Data(element).isSVG && CSS.Names.SVGAttribute(property)) {
	                        /* Note: For SVG attributes, vendor-prefixed property names are never used. */
	                        /* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
	                        element.setAttribute(property, propertyValue);
	                    } else {
	                        element.style[propertyName] = propertyValue;
	                    }
	
	                    if (Velocity.debug >= 2) console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
	                }
	            }
	
	            /* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
	            return [ propertyName, propertyValue ];
	        },
	
	        /* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
	        /* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
	        flushTransformCache: function(element) {
	            var transformString = "";
	
	            /* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
	               (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
	            if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && Data(element).isSVG) {
	                /* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
	                   Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
	                function getTransformFloat (transformProperty) {
	                    return parseFloat(CSS.getPropertyValue(element, transformProperty));
	                }
	
	                /* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
	                   we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
	                var SVGTransforms = {
	                    translate: [ getTransformFloat("translateX"), getTransformFloat("translateY") ],
	                    skewX: [ getTransformFloat("skewX") ], skewY: [ getTransformFloat("skewY") ],
	                    /* If the scale property is set (non-1), use that value for the scaleX and scaleY values
	                       (this behavior mimics the result of animating all these properties at once on HTML elements). */
	                    scale: getTransformFloat("scale") !== 1 ? [ getTransformFloat("scale"), getTransformFloat("scale") ] : [ getTransformFloat("scaleX"), getTransformFloat("scaleY") ],
	                    /* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
	                       defining the rotation's origin point. We ignore the origin values (default them to 0). */
	                    rotate: [ getTransformFloat("rotateZ"), 0, 0 ]
	                };
	
	                /* Iterate through the transform properties in the user-defined property map order.
	                   (This mimics the behavior of non-SVG transform animation.) */
	                $.each(Data(element).transformCache, function(transformName) {
	                    /* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
	                       properties so that they match up with SVG's accepted transform properties. */
	                    if (/^translate/i.test(transformName)) {
	                        transformName = "translate";
	                    } else if (/^scale/i.test(transformName)) {
	                        transformName = "scale";
	                    } else if (/^rotate/i.test(transformName)) {
	                        transformName = "rotate";
	                    }
	
	                    /* Check that we haven't yet deleted the property from the SVGTransforms container. */
	                    if (SVGTransforms[transformName]) {
	                        /* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
	                        transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";
	
	                        /* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
	                           re-insert the same master property if we encounter another one of its axis-specific properties. */
	                        delete SVGTransforms[transformName];
	                    }
	                });
	            } else {
	                var transformValue,
	                    perspective;
	
	                /* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
	                $.each(Data(element).transformCache, function(transformName) {
	                    transformValue = Data(element).transformCache[transformName];
	
	                    /* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
	                    if (transformName === "transformPerspective") {
	                        perspective = transformValue;
	                        return true;
	                    }
	
	                    /* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
	                    if (IE === 9 && transformName === "rotateZ") {
	                        transformName = "rotate";
	                    }
	
	                    transformString += transformName + transformValue + " ";
	                });
	
	                /* If present, set the perspective subproperty first. */
	                if (perspective) {
	                    transformString = "perspective" + perspective + " " + transformString;
	                }
	            }
	
	            CSS.setPropertyValue(element, "transform", transformString);
	        }
	    };
	
	    /* Register hooks and normalizations. */
	    CSS.Hooks.register();
	    CSS.Normalizations.register();
	
	    /* Allow hook setting in the same fashion as jQuery's $.css(). */
	    Velocity.hook = function (elements, arg2, arg3) {
	        var value = undefined;
	
	        elements = sanitizeElements(elements);
	
	        $.each(elements, function(i, element) {
	            /* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
	            if (Data(element) === undefined) {
	                Velocity.init(element);
	            }
	
	            /* Get property value. If an element set was passed in, only return the value for the first element. */
	            if (arg3 === undefined) {
	                if (value === undefined) {
	                    value = Velocity.CSS.getPropertyValue(element, arg2);
	                }
	            /* Set property value. */
	            } else {
	                /* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
	                var adjustedSet = Velocity.CSS.setPropertyValue(element, arg2, arg3);
	
	                /* Transform properties don't automatically set. They have to be flushed to the DOM. */
	                if (adjustedSet[0] === "transform") {
	                    Velocity.CSS.flushTransformCache(element);
	                }
	
	                value = adjustedSet;
	            }
	        });
	
	        return value;
	    };
	
	    /*****************
	        Animation
	    *****************/
	
	    var animate = function() {
	
	        /******************
	            Call Chain
	        ******************/
	
	        /* Logic for determining what to return to the call stack when exiting out of Velocity. */
	        function getChain () {
	            /* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
	               default to null instead of returning the targeted elements so that utility function's return value is standardized. */
	            if (isUtility) {
	                return promiseData.promise || null;
	            /* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
	            } else {
	                return elementsWrapped;
	            }
	        }
	
	        /*************************
	           Arguments Assignment
	        *************************/
	
	        /* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
	           objects are defined on a container object that's passed in as Velocity's sole argument. */
	        /* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
	        var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
	            /* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
	            isUtility,
	            /* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
	               passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
	            elementsWrapped,
	            argumentIndex;
	
	        var elements,
	            propertiesMap,
	            options;
	
	        /* Detect jQuery/Zepto elements being animated via the $.fn method. */
	        if (Type.isWrapped(this)) {
	            isUtility = false;
	
	            argumentIndex = 0;
	            elements = this;
	            elementsWrapped = this;
	        /* Otherwise, raw elements are being animated via the utility function. */
	        } else {
	            isUtility = true;
	
	            argumentIndex = 1;
	            elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
	        }
	
	        elements = sanitizeElements(elements);
	
	        if (!elements) {
	            return;
	        }
	
	        if (syntacticSugar) {
	            propertiesMap = arguments[0].properties || arguments[0].p;
	            options = arguments[0].options || arguments[0].o;
	        } else {
	            propertiesMap = arguments[argumentIndex];
	            options = arguments[argumentIndex + 1];
	        }
	
	        /* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
	           single raw DOM element is passed in (which doesn't contain a length property). */
	        var elementsLength = elements.length,
	            elementsIndex = 0;
	
	        /***************************
	            Argument Overloading
	        ***************************/
	
	        /* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
	           Overloading is detected by checking for the absence of an object being passed into options. */
	        /* Note: The stop and finish actions do not accept animation options, and are therefore excluded from this check. */
	        if (!/^(stop|finish|finishAll)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
	            /* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
	            var startingArgumentPosition = argumentIndex + 1;
	
	            options = {};
	
	            /* Iterate through all options arguments */
	            for (var i = startingArgumentPosition; i < arguments.length; i++) {
	                /* Treat a number as a duration. Parse it out. */
	                /* Note: The following RegEx will return true if passed an array with a number as its first item.
	                   Thus, arrays are skipped from this check. */
	                if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
	                    options.duration = arguments[i];
	                /* Treat strings and arrays as easings. */
	                } else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
	                    options.easing = arguments[i];
	                /* Treat a function as a complete callback. */
	                } else if (Type.isFunction(arguments[i])) {
	                    options.complete = arguments[i];
	                }
	            }
	        }
	
	        /***************
	            Promises
	        ***************/
	
	        var promiseData = {
	                promise: null,
	                resolver: null,
	                rejecter: null
	            };
	
	        /* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
	           promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
	           method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
	           call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
	        /* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
	           triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
	           grouped together for the purposes of resolving and rejecting a promise. */
	        if (isUtility && Velocity.Promise) {
	            promiseData.promise = new Velocity.Promise(function (resolve, reject) {
	                promiseData.resolver = resolve;
	                promiseData.rejecter = reject;
	            });
	        }
	
	        /*********************
	           Action Detection
	        *********************/
	
	        /* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
	           or they can be started, stopped, or reversed. If a literal or referenced properties map is passed in as Velocity's
	           first argument, the associated action is "start". Alternatively, "scroll", "reverse", or "stop" can be passed in instead of a properties map. */
	        var action;
	
	        switch (propertiesMap) {
	            case "scroll":
	                action = "scroll";
	                break;
	
	            case "reverse":
	                action = "reverse";
	                break;
	
	            case "finish":
	            case "finishAll":
	            case "stop":
	                /*******************
	                    Action: Stop
	                *******************/
	
	                /* Clear the currently-active delay on each targeted element. */
	                $.each(elements, function(i, element) {
	                    if (Data(element) && Data(element).delayTimer) {
	                        /* Stop the timer from triggering its cached next() function. */
	                        clearTimeout(Data(element).delayTimer.setTimeout);
	
	                        /* Manually call the next() function so that the subsequent queue items can progress. */
	                        if (Data(element).delayTimer.next) {
	                            Data(element).delayTimer.next();
	                        }
	
	                        delete Data(element).delayTimer;
	                    }
	
	                    /* If we want to finish everything in the queue, we have to iterate through it
	                       and call each function. This will make them active calls below, which will
	                       cause them to be applied via the duration setting. */
	                    if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
	                        /* Iterate through the items in the element's queue. */
	                        $.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
	                            /* The queue array can contain an "inprogress" string, which we skip. */
	                            if (Type.isFunction(item)) {
	                                item();
	                            }
	                        });
	
	                        /* Clearing the $.queue() array is achieved by resetting it to []. */
	                        $.queue(element, Type.isString(options) ? options : "", []);
	                    }
	                });
	
	                var callsToStop = [];
	
	                /* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
	                   been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
	                   is stopped, the next item in its animation queue is immediately triggered. */
	                /* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
	                   or a custom queue string can be passed in. */
	                /* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
	                   regardless of the element's current queue state. */
	
	                /* Iterate through every active call. */
	                $.each(Velocity.State.calls, function(i, activeCall) {
	                    /* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
	                    if (activeCall) {
	                        /* Iterate through the active call's targeted elements. */
	                        $.each(activeCall[1], function(k, activeElement) {
	                            /* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
	                               clear calls associated with the relevant queue. */
	                            /* Call stopping logic works as follows:
	                               - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
	                               - options === undefined --> stop current queue:"" call and all queue:false calls.
	                               - options === false --> stop only queue:false calls.
	                               - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
	                            var queueName = (options === undefined) ? "" : options;
	
	                            if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
	                                return true;
	                            }
	
	                            /* Iterate through the calls targeted by the stop command. */
	                            $.each(elements, function(l, element) {
	                                /* Check that this call was applied to the target element. */
	                                if (element === activeElement) {
	                                    /* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
	                                       due to the queue-clearing above. */
	                                    if (options === true || Type.isString(options)) {
	                                        /* Iterate through the items in the element's queue. */
	                                        $.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
	                                            /* The queue array can contain an "inprogress" string, which we skip. */
	                                            if (Type.isFunction(item)) {
	                                                /* Pass the item's callback a flag indicating that we want to abort from the queue call.
	                                                   (Specifically, the queue will resolve the call's associated promise then abort.)  */
	                                                item(null, true);
	                                            }
	                                        });
	
	                                        /* Clearing the $.queue() array is achieved by resetting it to []. */
	                                        $.queue(element, Type.isString(options) ? options : "", []);
	                                    }
	
	                                    if (propertiesMap === "stop") {
	                                        /* Since "reverse" uses cached start values (the previous call's endValues), these values must be
	                                           changed to reflect the final value that the elements were actually tweened to. */
	                                        /* Note: If only queue:false animations are currently running on an element, it won't have a tweensContainer
	                                           object. Also, queue:false animations can't be reversed. */
	                                        if (Data(element) && Data(element).tweensContainer && queueName !== false) {
	                                            $.each(Data(element).tweensContainer, function(m, activeTween) {
	                                                activeTween.endValue = activeTween.currentValue;
	                                            });
	                                        }
	
	                                        callsToStop.push(i);
	                                    } else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
	                                        /* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
	                                        they finish upon the next rAf tick then proceed with normal call completion logic. */
	                                        activeCall[2].duration = 1;
	                                    }
	                                }
	                            });
	                        });
	                    }
	                });
	
	                /* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
	                   that the complete callback and display:none setting should be skipped since we're completing prematurely. */
	                if (propertiesMap === "stop") {
	                    $.each(callsToStop, function(i, j) {
	                        completeCall(j, true);
	                    });
	
	                    if (promiseData.promise) {
	                        /* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
	                        promiseData.resolver(elements);
	                    }
	                }
	
	                /* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
	                return getChain();
	
	            default:
	                /* Treat a non-empty plain object as a literal properties map. */
	                if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
	                    action = "start";
	
	                /****************
	                    Redirects
	                ****************/
	
	                /* Check if a string matches a registered redirect (see Redirects above). */
	                } else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
	                    var opts = $.extend({}, options),
	                        durationOriginal = opts.duration,
	                        delayOriginal = opts.delay || 0;
	
	                    /* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
	                    if (opts.backwards === true) {
	                        elements = $.extend(true, [], elements).reverse();
	                    }
	
	                    /* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
	                    $.each(elements, function(elementIndex, element) {
	                        /* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
	                        if (parseFloat(opts.stagger)) {
	                            opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
	                        } else if (Type.isFunction(opts.stagger)) {
	                            opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
	                        }
	
	                        /* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
	                           the duration of each element's animation, using floors to prevent producing very short durations. */
	                        if (opts.drag) {
	                            /* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
	                            opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);
	
	                            /* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
	                               B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
	                               The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
	                            opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex/elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
	                        }
	
	                        /* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
	                           reduce the opts checking logic required inside the redirect. */
	                        Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
	                    });
	
	                    /* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
	                       (The performance overhead up to this point is virtually non-existant.) */
	                    /* Note: The jQuery call chain is kept intact by returning the complete element set. */
	                    return getChain();
	                } else {
	                    var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";
	
	                    if (promiseData.promise) {
	                        promiseData.rejecter(new Error(abortError));
	                    } else {
	                        console.log(abortError);
	                    }
	
	                    return getChain();
	                }
	        }
	
	        /**************************
	            Call-Wide Variables
	        **************************/
	
	        /* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
	           being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
	           avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
	           conversion metrics across Velocity animations that are not immediately consecutively chained. */
	        var callUnitConversionData = {
	                lastParent: null,
	                lastPosition: null,
	                lastFontSize: null,
	                lastPercentToPxWidth: null,
	                lastPercentToPxHeight: null,
	                lastEmToPx: null,
	                remToPx: null,
	                vwToPx: null,
	                vhToPx: null
	            };
	
	        /* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
	           Velocity.State.calls array that is processed during animation ticking. */
	        var call = [];
	
	        /************************
	           Element Processing
	        ************************/
	
	        /* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
	           1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
	           2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
	           3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
	        */
	
	        function processElement () {
	
	            /*************************
	               Part I: Pre-Queueing
	            *************************/
	
	            /***************************
	               Element-Wide Variables
	            ***************************/
	
	            var element = this,
	                /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
	                opts = $.extend({}, Velocity.defaults, options),
	                /* A container for the processed data associated with each property in the propertyMap.
	                   (Each property in the map produces its own "tween".) */
	                tweensContainer = {},
	                elementUnitConversionData;
	
	            /******************
	               Element Init
	            ******************/
	
	            if (Data(element) === undefined) {
	                Velocity.init(element);
	            }
	
	            /******************
	               Option: Delay
	            ******************/
	
	            /* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
	            /* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
	               (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
	            if (parseFloat(opts.delay) && opts.queue !== false) {
	                $.queue(element, opts.queue, function(next) {
	                    /* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
	                    Velocity.velocityQueueEntryFlag = true;
	
	                    /* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
	                       The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command. */
	                    Data(element).delayTimer = {
	                        setTimeout: setTimeout(next, parseFloat(opts.delay)),
	                        next: next
	                    };
	                });
	            }
	
	            /*********************
	               Option: Duration
	            *********************/
	
	            /* Support for jQuery's named durations. */
	            switch (opts.duration.toString().toLowerCase()) {
	                case "fast":
	                    opts.duration = 200;
	                    break;
	
	                case "normal":
	                    opts.duration = DURATION_DEFAULT;
	                    break;
	
	                case "slow":
	                    opts.duration = 600;
	                    break;
	
	                default:
	                    /* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
	                    opts.duration = parseFloat(opts.duration) || 1;
	            }
	
	            /************************
	               Global Option: Mock
	            ************************/
	
	            if (Velocity.mock !== false) {
	                /* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
	                   Alternatively, a multiplier can be passed in to time remap all delays and durations. */
	                if (Velocity.mock === true) {
	                    opts.duration = opts.delay = 1;
	                } else {
	                    opts.duration *= parseFloat(Velocity.mock) || 1;
	                    opts.delay *= parseFloat(Velocity.mock) || 1;
	                }
	            }
	
	            /*******************
	               Option: Easing
	            *******************/
	
	            opts.easing = getEasing(opts.easing, opts.duration);
	
	            /**********************
	               Option: Callbacks
	            **********************/
	
	            /* Callbacks must functions. Otherwise, default to null. */
	            if (opts.begin && !Type.isFunction(opts.begin)) {
	                opts.begin = null;
	            }
	
	            if (opts.progress && !Type.isFunction(opts.progress)) {
	                opts.progress = null;
	            }
	
	            if (opts.complete && !Type.isFunction(opts.complete)) {
	                opts.complete = null;
	            }
	
	            /*********************************
	               Option: Display & Visibility
	            *********************************/
	
	            /* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
	            /* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
	            if (opts.display !== undefined && opts.display !== null) {
	                opts.display = opts.display.toString().toLowerCase();
	
	                /* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
	                if (opts.display === "auto") {
	                    opts.display = Velocity.CSS.Values.getDisplayType(element);
	                }
	            }
	
	            if (opts.visibility !== undefined && opts.visibility !== null) {
	                opts.visibility = opts.visibility.toString().toLowerCase();
	            }
	
	            /**********************
	               Option: mobileHA
	            **********************/
	
	            /* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
	               on animating elements. HA is removed from the element at the completion of its animation. */
	            /* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
	            /* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
	            opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);
	
	            /***********************
	               Part II: Queueing
	            ***********************/
	
	            /* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
	               In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
	            /* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
	               the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
	            function buildQueue (next) {
	
	                /*******************
	                   Option: Begin
	                *******************/
	
	                /* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
	                if (opts.begin && elementsIndex === 0) {
	                    /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
	                    try {
	                        opts.begin.call(elements, elements);
	                    } catch (error) {
	                        setTimeout(function() { throw error; }, 1);
	                    }
	                }
	
	                /*****************************************
	                   Tween Data Construction (for Scroll)
	                *****************************************/
	
	                /* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
	                if (action === "scroll") {
	                    /* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
	                    var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
	                        scrollOffset = parseFloat(opts.offset) || 0,
	                        scrollPositionCurrent,
	                        scrollPositionCurrentAlternate,
	                        scrollPositionEnd;
	
	                    /* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
	                       as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
	                    if (opts.container) {
	                        /* Ensure that either a jQuery object or a raw DOM element was passed in. */
	                        if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
	                            /* Extract the raw DOM element from the jQuery wrapper. */
	                            opts.container = opts.container[0] || opts.container;
	                            /* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
	                               (due to the user's natural interaction with the page). */
	                            scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */
	
	                            /* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
	                               -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
	                               the scroll container's current scroll position. */
	                            scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
	                        /* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
	                        } else {
	                            opts.container = null;
	                        }
	                    } else {
	                        /* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
	                           the appropriate cached property names (which differ based on browser type). */
	                        scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
	                        /* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
	                        scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */
	
	                        /* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
	                           and therefore end values do not need to be compounded onto current values. */
	                        scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
	                    }
	
	                    /* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
	                    tweensContainer = {
	                        scroll: {
	                            rootPropertyValue: false,
	                            startValue: scrollPositionCurrent,
	                            currentValue: scrollPositionCurrent,
	                            endValue: scrollPositionEnd,
	                            unitType: "",
	                            easing: opts.easing,
	                            scrollData: {
	                                container: opts.container,
	                                direction: scrollDirection,
	                                alternateValue: scrollPositionCurrentAlternate
	                            }
	                        },
	                        element: element
	                    };
	
	                    if (Velocity.debug) console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
	
	                /******************************************
	                   Tween Data Construction (for Reverse)
	                ******************************************/
	
	                /* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
	                   that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
	                   the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
	                /* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
	                /* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
	                   there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
	                   as reverting to the element's values as they were prior to the previous *Velocity* call. */
	                } else if (action === "reverse") {
	                    /* Abort if there is no prior animation data to reverse to. */
	                    if (!Data(element).tweensContainer) {
	                        /* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
	                        $.dequeue(element, opts.queue);
	
	                        return;
	                    } else {
	                        /*********************
	                           Options Parsing
	                        *********************/
	
	                        /* If the element was hidden via the display option in the previous call,
	                           revert display to "auto" prior to reversal so that the element is visible again. */
	                        if (Data(element).opts.display === "none") {
	                            Data(element).opts.display = "auto";
	                        }
	
	                        if (Data(element).opts.visibility === "hidden") {
	                            Data(element).opts.visibility = "visible";
	                        }
	
	                        /* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
	                           Further, remove the previous call's callback options; typically, users do not want these to be refired. */
	                        Data(element).opts.loop = false;
	                        Data(element).opts.begin = null;
	                        Data(element).opts.complete = null;
	
	                        /* Since we're extending an opts object that has already been extended with the defaults options object,
	                           we remove non-explicitly-defined properties that are auto-assigned values. */
	                        if (!options.easing) {
	                            delete opts.easing;
	                        }
	
	                        if (!options.duration) {
	                            delete opts.duration;
	                        }
	
	                        /* The opts object used for reversal is an extension of the options object optionally passed into this
	                           reverse call plus the options used in the previous Velocity call. */
	                        opts = $.extend({}, Data(element).opts, opts);
	
	                        /*************************************
	                           Tweens Container Reconstruction
	                        *************************************/
	
	                        /* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
	                        var lastTweensContainer = $.extend(true, {}, Data(element).tweensContainer);
	
	                        /* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
	                        for (var lastTween in lastTweensContainer) {
	                            /* In addition to tween data, tweensContainers contain an element property that we ignore here. */
	                            if (lastTween !== "element") {
	                                var lastStartValue = lastTweensContainer[lastTween].startValue;
	
	                                lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
	                                lastTweensContainer[lastTween].endValue = lastStartValue;
	
	                                /* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
	                                   Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
	                                   The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
	                                if (!Type.isEmptyObject(options)) {
	                                    lastTweensContainer[lastTween].easing = opts.easing;
	                                }
	
	                                if (Velocity.debug) console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
	                            }
	                        }
	
	                        tweensContainer = lastTweensContainer;
	                    }
	
	                /*****************************************
	                   Tween Data Construction (for Start)
	                *****************************************/
	
	                } else if (action === "start") {
	
	                    /*************************
	                        Value Transferring
	                    *************************/
	
	                    /* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
	                       while the element was in the process of being animated by Velocity, then this current call is safe to use
	                       the end values from the prior call as its start values. Velocity attempts to perform this value transfer
	                       process whenever possible in order to avoid requerying the DOM. */
	                    /* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
	                       then the DOM is queried for the element's current values as a last resort. */
	                    /* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */
	                    var lastTweensContainer;
	
	                    /* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
	                       to transfer over end values to use as start values. If it's set to true and there is a previous
	                       Velocity call to pull values from, do so. */
	                    if (Data(element).tweensContainer && Data(element).isAnimating === true) {
	                        lastTweensContainer = Data(element).tweensContainer;
	                    }
	
	                    /***************************
	                       Tween Data Calculation
	                    ***************************/
	
	                    /* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
	                    /* Property map values can either take the form of 1) a single value representing the end value,
	                       or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
	                       The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
	                       the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
	                    function parsePropertyValue (valueData, skipResolvingEasing) {
	                        var endValue = undefined,
	                            easing = undefined,
	                            startValue = undefined;
	
	                        /* Handle the array format, which can be structured as one of three potential overloads:
	                           A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
	                        if (Type.isArray(valueData)) {
	                            /* endValue is always the first item in the array. Don't bother validating endValue's value now
	                               since the ensuing property cycling logic does that. */
	                            endValue = valueData[0];
	
	                            /* Two-item array format: If the second item is a number, function, or hex string, treat it as a
	                               start value since easings can only be non-hex strings or arrays. */
	                            if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
	                                startValue = valueData[1];
	                            /* Two or three-item array: If the second item is a non-hex string or an array, treat it as an easing. */
	                            } else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1])) || Type.isArray(valueData[1])) {
	                                easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);
	
	                                /* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
	                                if (valueData[2] !== undefined) {
	                                    startValue = valueData[2];
	                                }
	                            }
	                        /* Handle the single-value format. */
	                        } else {
	                            endValue = valueData;
	                        }
	
	                        /* Default to the call's easing if a per-property easing type was not defined. */
	                        if (!skipResolvingEasing) {
	                            easing = easing || opts.easing;
	                        }
	
	                        /* If functions were passed in as values, pass the function the current element as its context,
	                           plus the element's index and the element set's size as arguments. Then, assign the returned value. */
	                        if (Type.isFunction(endValue)) {
	                            endValue = endValue.call(element, elementsIndex, elementsLength);
	                        }
	
	                        if (Type.isFunction(startValue)) {
	                            startValue = startValue.call(element, elementsIndex, elementsLength);
	                        }
	
	                        /* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
	                        return [ endValue || 0, easing, startValue ];
	                    }
	
	                    /* Cycle through each property in the map, looking for shorthand color properties (e.g. "color" as opposed to "colorRed"). Inject the corresponding
	                       colorRed, colorGreen, and colorBlue RGB component tweens into the propertiesMap (which Velocity understands) and remove the shorthand property. */
	                    $.each(propertiesMap, function(property, value) {
	                        /* Find shorthand color properties that have been passed a hex string. */
	                        if (RegExp("^" + CSS.Lists.colors.join("$|^") + "$").test(property)) {
	                            /* Parse the value data for each shorthand. */
	                            var valueData = parsePropertyValue(value, true),
	                                endValue = valueData[0],
	                                easing = valueData[1],
	                                startValue = valueData[2];
	
	                            if (CSS.RegEx.isHex.test(endValue)) {
	                                /* Convert the hex strings into their RGB component arrays. */
	                                var colorComponents = [ "Red", "Green", "Blue" ],
	                                    endValueRGB = CSS.Values.hexToRgb(endValue),
	                                    startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;
	
	                                /* Inject the RGB component tweens into propertiesMap. */
	                                for (var i = 0; i < colorComponents.length; i++) {
	                                    var dataArray = [ endValueRGB[i] ];
	
	                                    if (easing) {
	                                        dataArray.push(easing);
	                                    }
	
	                                    if (startValueRGB !== undefined) {
	                                        dataArray.push(startValueRGB[i]);
	                                    }
	
	                                    propertiesMap[property + colorComponents[i]] = dataArray;
	                                }
	
	                                /* Remove the intermediary shorthand property entry now that we've processed it. */
	                                delete propertiesMap[property];
	                            }
	                        }
	                    });
	
	                    /* Create a tween out of each property, and append its associated data to tweensContainer. */
	                    for (var property in propertiesMap) {
	
	                        /**************************
	                           Start Value Sourcing
	                        **************************/
	
	                        /* Parse out endValue, easing, and startValue from the property's data. */
	                        var valueData = parsePropertyValue(propertiesMap[property]),
	                            endValue = valueData[0],
	                            easing = valueData[1],
	                            startValue = valueData[2];
	
	                        /* Now that the original property name's format has been used for the parsePropertyValue() lookup above,
	                           we force the property to its camelCase styling to normalize it for manipulation. */
	                        property = CSS.Names.camelCase(property);
	
	                        /* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
	                        var rootProperty = CSS.Hooks.getRoot(property),
	                            rootPropertyValue = false;
	
	                        /* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
	                           inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
	                           Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
	                        /* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
	                           there is no way to check for their explicit browser support, and so we skip skip this check for them. */
	                        if (!Data(element).isSVG && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
	                            if (Velocity.debug) console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
	
	                            continue;
	                        }
	
	                        /* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
	                           animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
	                           a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
	                        if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
	                            startValue = 0;
	                        }
	
	                        /* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
	                           for all of the current call's properties that were *also* animated in the previous call. */
	                        /* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
	                        if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
	                            if (startValue === undefined) {
	                                startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
	                            }
	
	                            /* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
	                               instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
	                               attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
	                            rootPropertyValue = Data(element).rootPropertyValueCache[rootProperty];
	                        /* If values were not transferred from a previous Velocity call, query the DOM as needed. */
	                        } else {
	                            /* Handle hooked properties. */
	                            if (CSS.Hooks.registered[property]) {
	                               if (startValue === undefined) {
	                                    rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
	                                    /* Note: The following getPropertyValue() call does not actually trigger a DOM query;
	                                       getPropertyValue() will extract the hook from rootPropertyValue. */
	                                    startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
	                                /* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
	                                   just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
	                                   root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
	                                   to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
	                                } else {
	                                    /* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
	                                    rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
	                                }
	                            /* Handle non-hooked properties that haven't already been defined via forcefeeding. */
	                            } else if (startValue === undefined) {
	                                startValue = CSS.getPropertyValue(element, property); /* GET */
	                            }
	                        }
	
	                        /**************************
	                           Value Data Extraction
	                        **************************/
	
	                        var separatedValue,
	                            endValueUnitType,
	                            startValueUnitType,
	                            operator = false;
	
	                        /* Separates a property value into its numeric value and its unit type. */
	                        function separateValue (property, value) {
	                            var unitType,
	                                numericValue;
	
	                            numericValue = (value || "0")
	                                .toString()
	                                .toLowerCase()
	                                /* Match the unit type at the end of the value. */
	                                .replace(/[%A-z]+$/, function(match) {
	                                    /* Grab the unit type. */
	                                    unitType = match;
	
	                                    /* Strip the unit type off of value. */
	                                    return "";
	                                });
	
	                            /* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
	                            if (!unitType) {
	                                unitType = CSS.Values.getUnitType(property);
	                            }
	
	                            return [ numericValue, unitType ];
	                        }
	
	                        /* Separate startValue. */
	                        separatedValue = separateValue(property, startValue);
	                        startValue = separatedValue[0];
	                        startValueUnitType = separatedValue[1];
	
	                        /* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
	                        separatedValue = separateValue(property, endValue);
	                        endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
	                            operator = subMatch;
	
	                            /* Strip the operator off of the value. */
	                            return "";
	                        });
	                        endValueUnitType = separatedValue[1];
	
	                        /* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
	                        startValue = parseFloat(startValue) || 0;
	                        endValue = parseFloat(endValue) || 0;
	
	                        /***************************************
	                           Property-Specific Value Conversion
	                        ***************************************/
	
	                        /* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
	                        if (endValueUnitType === "%") {
	                            /* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
	                               which is identical to the em unit's behavior, so we piggyback off of that. */
	                            if (/^(fontSize|lineHeight)$/.test(property)) {
	                                /* Convert % into an em decimal value. */
	                                endValue = endValue / 100;
	                                endValueUnitType = "em";
	                            /* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
	                            } else if (/^scale/.test(property)) {
	                                endValue = endValue / 100;
	                                endValueUnitType = "";
	                            /* For RGB components, take the defined percentage of 255 and strip off the unit type. */
	                            } else if (/(Red|Green|Blue)$/i.test(property)) {
	                                endValue = (endValue / 100) * 255;
	                                endValueUnitType = "";
	                            }
	                        }
	
	                        /***************************
	                           Unit Ratio Calculation
	                        ***************************/
	
	                        /* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
	                           %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
	                           for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
	                           from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
	                           1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
	                           2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
	                        /* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
	                           setting values with the target unit type then comparing the returned pixel value. */
	                        /* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
	                           of batching the SETs and GETs together upfront outweights the potential overhead
	                           of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
	                        /* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
	                        function calculateUnitRatios () {
	
	                            /************************
	                                Same Ratio Checks
	                            ************************/
	
	                            /* The properties below are used to determine whether the element differs sufficiently from this call's
	                               previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
	                               of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
	                               this is done to minimize DOM querying. */
	                            var sameRatioIndicators = {
	                                    myParent: element.parentNode || document.body, /* GET */
	                                    position: CSS.getPropertyValue(element, "position"), /* GET */
	                                    fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
	                                },
	                                /* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
	                                samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
	                                /* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
	                                sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);
	
	                            /* Store these ratio indicators call-wide for the next element to compare against. */
	                            callUnitConversionData.lastParent = sameRatioIndicators.myParent;
	                            callUnitConversionData.lastPosition = sameRatioIndicators.position;
	                            callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;
	
	                            /***************************
	                               Element-Specific Units
	                            ***************************/
	
	                            /* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
	                               of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
	                            var measurement = 100,
	                                unitRatios = {};
	
	                            if (!sameEmRatio || !samePercentRatio) {
	                                var dummy = Data(element).isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");
	
	                                Velocity.init(dummy);
	                                sameRatioIndicators.myParent.appendChild(dummy);
	
	                                /* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
	                                   Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
	                                /* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
	                                $.each([ "overflow", "overflowX", "overflowY" ], function(i, property) {
	                                    Velocity.CSS.setPropertyValue(dummy, property, "hidden");
	                                });
	                                Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
	                                Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
	                                Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");
	
	                                /* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
	                                $.each([ "minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height" ], function(i, property) {
	                                    Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
	                                });
	                                /* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
	                                Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");
	
	                                /* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
	                                unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
	                                unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
	                                unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */
	
	                                sameRatioIndicators.myParent.removeChild(dummy);
	                            } else {
	                                unitRatios.emToPx = callUnitConversionData.lastEmToPx;
	                                unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
	                                unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
	                            }
	
	                            /***************************
	                               Element-Agnostic Units
	                            ***************************/
	
	                            /* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
	                               once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
	                               that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
	                               so we calculate it now. */
	                            if (callUnitConversionData.remToPx === null) {
	                                /* Default to browsers' default fontSize of 16px in the case of 0. */
	                                callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
	                            }
	
	                            /* Similarly, viewport units are %-relative to the window's inner dimensions. */
	                            if (callUnitConversionData.vwToPx === null) {
	                                callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
	                                callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
	                            }
	
	                            unitRatios.remToPx = callUnitConversionData.remToPx;
	                            unitRatios.vwToPx = callUnitConversionData.vwToPx;
	                            unitRatios.vhToPx = callUnitConversionData.vhToPx;
	
	                            if (Velocity.debug >= 1) console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
	
	                            return unitRatios;
	                        }
	
	                        /********************
	                           Unit Conversion
	                        ********************/
	
	                        /* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
	                        if (/[\/*]/.test(operator)) {
	                            endValueUnitType = startValueUnitType;
	                        /* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
	                           is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
	                           on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
	                           would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
	                        /* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
	                        } else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
	                            /* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
	                            /* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
	                               match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
	                               which remains past the point of the animation's completion. */
	                            if (endValue === 0) {
	                                endValueUnitType = startValueUnitType;
	                            } else {
	                                /* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
	                                   If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
	                                elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();
	
	                                /* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
	                                /* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
	                                var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";
	
	                                /* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
	                                   1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
	                                switch (startValueUnitType) {
	                                    case "%":
	                                        /* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
	                                           Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
	                                           to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
	                                        startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
	                                        break;
	
	                                    case "px":
	                                        /* px acts as our midpoint in the unit conversion process; do nothing. */
	                                        break;
	
	                                    default:
	                                        startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
	                                }
	
	                                /* Invert the px ratios to convert into to the target unit. */
	                                switch (endValueUnitType) {
	                                    case "%":
	                                        startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
	                                        break;
	
	                                    case "px":
	                                        /* startValue is already in px, do nothing; we're done. */
	                                        break;
	
	                                    default:
	                                        startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
	                                }
	                            }
	                        }
	
	                        /*********************
	                           Relative Values
	                        *********************/
	
	                        /* Operator logic must be performed last since it requires unit-normalized start and end values. */
	                        /* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
	                           to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
	                           50 points is added on top of the current % value. */
	                        switch (operator) {
	                            case "+":
	                                endValue = startValue + endValue;
	                                break;
	
	                            case "-":
	                                endValue = startValue - endValue;
	                                break;
	
	                            case "*":
	                                endValue = startValue * endValue;
	                                break;
	
	                            case "/":
	                                endValue = startValue / endValue;
	                                break;
	                        }
	
	                        /**************************
	                           tweensContainer Push
	                        **************************/
	
	                        /* Construct the per-property tween object, and push it to the element's tweensContainer. */
	                        tweensContainer[property] = {
	                            rootPropertyValue: rootPropertyValue,
	                            startValue: startValue,
	                            currentValue: startValue,
	                            endValue: endValue,
	                            unitType: endValueUnitType,
	                            easing: easing
	                        };
	
	                        if (Velocity.debug) console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
	                    }
	
	                    /* Along with its property data, store a reference to the element itself onto tweensContainer. */
	                    tweensContainer.element = element;
	                }
	
	                /*****************
	                    Call Push
	                *****************/
	
	                /* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
	                   being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
	                if (tweensContainer.element) {
	                    /* Apply the "velocity-animating" indicator class. */
	                    CSS.Values.addClass(element, "velocity-animating");
	
	                    /* The call array houses the tweensContainers for each element being animated in the current call. */
	                    call.push(tweensContainer);
	
	                    /* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
	                    if (opts.queue === "") {
	                        Data(element).tweensContainer = tweensContainer;
	                        Data(element).opts = opts;
	                    }
	
	                    /* Switch on the element's animating flag. */
	                    Data(element).isAnimating = true;
	
	                    /* Once the final element in this call's element set has been processed, push the call array onto
	                       Velocity.State.calls for the animation tick to immediately begin processing. */
	                    if (elementsIndex === elementsLength - 1) {
	                        /* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
	                           Anything on this call container is subjected to tick() processing. */
	                        Velocity.State.calls.push([ call, elements, opts, null, promiseData.resolver ]);
	
	                        /* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
	                        if (Velocity.State.isTicking === false) {
	                            Velocity.State.isTicking = true;
	
	                            /* Start the tick loop. */
	                            tick();
	                        }
	                    } else {
	                        elementsIndex++;
	                    }
	                }
	            }
	
	            /* When the queue option is set to false, the call skips the element's queue and fires immediately. */
	            if (opts.queue === false) {
	                /* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
	                   we manually inject the delay property here with an explicit setTimeout. */
	                if (opts.delay) {
	                    setTimeout(buildQueue, opts.delay);
	                } else {
	                    buildQueue();
	                }
	            /* Otherwise, the call undergoes element queueing as normal. */
	            /* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
	            } else {
	                $.queue(element, opts.queue, function(next, clearQueue) {
	                    /* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
	                       so it's fine if this is repeatedly triggered for each element in the associated call.) */
	                    if (clearQueue === true) {
	                        if (promiseData.promise) {
	                            promiseData.resolver(elements);
	                        }
	
	                        /* Do not continue with animation queueing. */
	                        return true;
	                    }
	
	                    /* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
	                       See completeCall() for further details. */
	                    Velocity.velocityQueueEntryFlag = true;
	
	                    buildQueue(next);
	                });
	            }
	
	            /*********************
	                Auto-Dequeuing
	            *********************/
	
	            /* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
	               must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
	               for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
	               queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
	               first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
	            /* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
	               each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
	            /* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
	               Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
	            if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
	                $.dequeue(element);
	            }
	        }
	
	        /**************************
	           Element Set Iteration
	        **************************/
	
	        /* If the "nodeType" property exists on the elements variable, we're animating a single element.
	           Place it in an array so that $.each() can iterate over it. */
	        $.each(elements, function(i, element) {
	            /* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
	            if (Type.isNode(element)) {
	                processElement.call(element);
	            }
	        });
	
	        /******************
	           Option: Loop
	        ******************/
	
	        /* The loop option accepts an integer indicating how many times the element should loop between the values in the
	           current call's properties map and the element's property values prior to this call. */
	        /* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
	           to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
	           which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
	        var opts = $.extend({}, Velocity.defaults, options),
	            reverseCallsCount;
	
	        opts.loop = parseInt(opts.loop);
	        reverseCallsCount = (opts.loop * 2) - 1;
	
	        if (opts.loop) {
	            /* Double the loop count to convert it into its appropriate number of "reverse" calls.
	               Subtract 1 from the resulting value since the current call is included in the total alternation count. */
	            for (var x = 0; x < reverseCallsCount; x++) {
	                /* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
	                   isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
	                   call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
	                var reverseOptions = {
	                    delay: opts.delay,
	                    progress: opts.progress
	                };
	
	                /* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
	                   so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
	                if (x === reverseCallsCount - 1) {
	                    reverseOptions.display = opts.display;
	                    reverseOptions.visibility = opts.visibility;
	                    reverseOptions.complete = opts.complete;
	                }
	
	                animate(elements, "reverse", reverseOptions);
	            }
	        }
	
	        /***************
	            Chaining
	        ***************/
	
	        /* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
	        return getChain();
	    };
	
	    /* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
	    Velocity = $.extend(animate, Velocity);
	    /* For legacy support, also expose the literal animate method. */
	    Velocity.animate = animate;
	
	    /**************
	        Timing
	    **************/
	
	    /* Ticker function. */
	    var ticker = window.requestAnimationFrame || rAFShim;
	
	    /* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
	       To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
	       devices to avoid wasting battery power on inactive tabs. */
	    /* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
	    if (!Velocity.State.isMobile && document.hidden !== undefined) {
	        document.addEventListener("visibilitychange", function() {
	            /* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
	            if (document.hidden) {
	                ticker = function(callback) {
	                    /* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
	                    return setTimeout(function() { callback(true) }, 16);
	                };
	
	                /* The rAF loop has been paused by the browser, so we manually restart the tick. */
	                tick();
	            } else {
	                ticker = window.requestAnimationFrame || rAFShim;
	            }
	        });
	    }
	
	    /************
	        Tick
	    ************/
	
	    /* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
	    function tick (timestamp) {
	        /* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
	           We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
	           the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
	           calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
	           the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
	           by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
	        if (timestamp) {
	            /* We ignore RAF's high resolution timestamp since it can be significantly offset when the browser is
	               under high stress; we opt for choppiness over allowing the browser to drop huge chunks of frames. */
	            var timeCurrent = (new Date).getTime();
	
	            /********************
	               Call Iteration
	            ********************/
	
	            var callsLength = Velocity.State.calls.length;
	
	            /* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
	               when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
	               has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
	            if (callsLength > 10000) {
	                Velocity.State.calls = compactSparseArray(Velocity.State.calls);
	            }
	
	            /* Iterate through each active call. */
	            for (var i = 0; i < callsLength; i++) {
	                /* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
	                if (!Velocity.State.calls[i]) {
	                    continue;
	                }
	
	                /************************
	                   Call-Wide Variables
	                ************************/
	
	                var callContainer = Velocity.State.calls[i],
	                    call = callContainer[0],
	                    opts = callContainer[2],
	                    timeStart = callContainer[3],
	                    firstTick = !!timeStart,
	                    tweenDummyValue = null;
	
	                /* If timeStart is undefined, then this is the first time that this call has been processed by tick().
	                   We assign timeStart now so that its value is as close to the real animation start time as possible.
	                   (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
	                   between that time and now would cause the first few frames of the tween to be skipped since
	                   percentComplete is calculated relative to timeStart.) */
	                /* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
	                   first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
	                   same style value as the element's current value. */
	                if (!timeStart) {
	                    timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
	                }
	
	                /* The tween's completion percentage is relative to the tween's start time, not the tween's start value
	                   (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
	                   Accordingly, we ensure that percentComplete does not exceed 1. */
	                var percentComplete = Math.min((timeCurrent - timeStart) / opts.duration, 1);
	
	                /**********************
	                   Element Iteration
	                **********************/
	
	                /* For every call, iterate through each of the elements in its set. */
	                for (var j = 0, callLength = call.length; j < callLength; j++) {
	                    var tweensContainer = call[j],
	                        element = tweensContainer.element;
	
	                    /* Check to see if this element has been deleted midway through the animation by checking for the
	                       continued existence of its data cache. If it's gone, skip animating this element. */
	                    if (!Data(element)) {
	                        continue;
	                    }
	
	                    var transformPropertyExists = false;
	
	                    /**********************************
	                       Display & Visibility Toggling
	                    **********************************/
	
	                    /* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
	                       (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
	                    if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
	                        if (opts.display === "flex") {
	                            var flexValues = [ "-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex" ];
	
	                            $.each(flexValues, function(i, flexValue) {
	                                CSS.setPropertyValue(element, "display", flexValue);
	                            });
	                        }
	
	                        CSS.setPropertyValue(element, "display", opts.display);
	                    }
	
	                    /* Same goes with the visibility option, but its "none" equivalent is "hidden". */
	                    if (opts.visibility !== undefined && opts.visibility !== "hidden") {
	                        CSS.setPropertyValue(element, "visibility", opts.visibility);
	                    }
	
	                    /************************
	                       Property Iteration
	                    ************************/
	
	                    /* For every element, iterate through each property. */
	                    for (var property in tweensContainer) {
	                        /* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
	                        if (property !== "element") {
	                            var tween = tweensContainer[property],
	                                currentValue,
	                                /* Easing can either be a pre-genereated function or a string that references a pre-registered easing
	                                   on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
	                                easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;
	
	                            /******************************
	                               Current Value Calculation
	                            ******************************/
	
	                            /* If this is the last tick pass (if we've reached 100% completion for this tween),
	                               ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
	                            if (percentComplete === 1) {
	                                currentValue = tween.endValue;
	                            /* Otherwise, calculate currentValue based on the current delta from startValue. */
	                            } else {
	                                var tweenDelta = tween.endValue - tween.startValue;
	                                currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
	
	                                /* If no value change is occurring, don't proceed with DOM updating. */
	                                if (!firstTick && (currentValue === tween.currentValue)) {
	                                    continue;
	                                }
	                            }
	
	                            tween.currentValue = currentValue;
	
	                            /* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
	                               it can be passed into the progress callback. */
	                            if (property === "tween") {
	                                tweenDummyValue = currentValue;
	                            } else {
	                                /******************
	                                   Hooks: Part I
	                                ******************/
	
	                                /* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
	                                   for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
	                                   rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
	                                   updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
	                                   subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
	                                if (CSS.Hooks.registered[property]) {
	                                    var hookRoot = CSS.Hooks.getRoot(property),
	                                        rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];
	
	                                    if (rootPropertyValueCache) {
	                                        tween.rootPropertyValue = rootPropertyValueCache;
	                                    }
	                                }
	
	                                /*****************
	                                    DOM Update
	                                *****************/
	
	                                /* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
	                                /* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
	                                var adjustedSetData = CSS.setPropertyValue(element, /* SET */
	                                                                           property,
	                                                                           tween.currentValue + (parseFloat(currentValue) === 0 ? "" : tween.unitType),
	                                                                           tween.rootPropertyValue,
	                                                                           tween.scrollData);
	
	                                /*******************
	                                   Hooks: Part II
	                                *******************/
	
	                                /* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
	                                if (CSS.Hooks.registered[property]) {
	                                    /* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
	                                    if (CSS.Normalizations.registered[hookRoot]) {
	                                        Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
	                                    } else {
	                                        Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
	                                    }
	                                }
	
	                                /***************
	                                   Transforms
	                                ***************/
	
	                                /* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
	                                if (adjustedSetData[0] === "transform") {
	                                    transformPropertyExists = true;
	                                }
	
	                            }
	                        }
	                    }
	
	                    /****************
	                        mobileHA
	                    ****************/
	
	                    /* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
	                       It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
	                    if (opts.mobileHA) {
	                        /* Don't set the null transform hack if we've already done so. */
	                        if (Data(element).transformCache.translate3d === undefined) {
	                            /* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
	                            Data(element).transformCache.translate3d = "(0px, 0px, 0px)";
	
	                            transformPropertyExists = true;
	                        }
	                    }
	
	                    if (transformPropertyExists) {
	                        CSS.flushTransformCache(element);
	                    }
	                }
	
	                /* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
	                   Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
	                if (opts.display !== undefined && opts.display !== "none") {
	                    Velocity.State.calls[i][2].display = false;
	                }
	                if (opts.visibility !== undefined && opts.visibility !== "hidden") {
	                    Velocity.State.calls[i][2].visibility = false;
	                }
	
	                /* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
	                if (opts.progress) {
	                    opts.progress.call(callContainer[1],
	                                       callContainer[1],
	                                       percentComplete,
	                                       Math.max(0, (timeStart + opts.duration) - timeCurrent),
	                                       timeStart,
	                                       tweenDummyValue);
	                }
	
	                /* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
	                if (percentComplete === 1) {
	                    completeCall(i);
	                }
	            }
	        }
	
	        /* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
	        if (Velocity.State.isTicking) {
	            ticker(tick);
	        }
	    }
	
	    /**********************
	        Call Completion
	    **********************/
	
	    /* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
	    function completeCall (callIndex, isStopped) {
	        /* Ensure the call exists. */
	        if (!Velocity.State.calls[callIndex]) {
	            return false;
	        }
	
	        /* Pull the metadata from the call. */
	        var call = Velocity.State.calls[callIndex][0],
	            elements = Velocity.State.calls[callIndex][1],
	            opts = Velocity.State.calls[callIndex][2],
	            resolver = Velocity.State.calls[callIndex][4];
	
	        var remainingCallsExist = false;
	
	        /*************************
	           Element Finalization
	        *************************/
	
	        for (var i = 0, callLength = call.length; i < callLength; i++) {
	            var element = call[i].element;
	
	            /* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
	            /* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
	            /* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
	            if (!isStopped && !opts.loop) {
	                if (opts.display === "none") {
	                    CSS.setPropertyValue(element, "display", opts.display);
	                }
	
	                if (opts.visibility === "hidden") {
	                    CSS.setPropertyValue(element, "visibility", opts.visibility);
	                }
	            }
	
	            /* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
	               a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
	               an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
	               we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
	               is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
	            if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
	                /* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
	                if (Data(element)) {
	                    Data(element).isAnimating = false;
	                    /* Clear the element's rootPropertyValueCache, which will become stale. */
	                    Data(element).rootPropertyValueCache = {};
	
	                    var transformHAPropertyExists = false;
	                    /* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
	                    $.each(CSS.Lists.transforms3D, function(i, transformName) {
	                        var defaultValue = /^scale/.test(transformName) ? 1 : 0,
	                            currentValue = Data(element).transformCache[transformName];
	
	                        if (Data(element).transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
	                            transformHAPropertyExists = true;
	
	                            delete Data(element).transformCache[transformName];
	                        }
	                    });
	
	                    /* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
	                    if (opts.mobileHA) {
	                        transformHAPropertyExists = true;
	                        delete Data(element).transformCache.translate3d;
	                    }
	
	                    /* Flush the subproperty removals to the DOM. */
	                    if (transformHAPropertyExists) {
	                        CSS.flushTransformCache(element);
	                    }
	
	                    /* Remove the "velocity-animating" indicator class. */
	                    CSS.Values.removeClass(element, "velocity-animating");
	                }
	            }
	
	            /*********************
	               Option: Complete
	            *********************/
	
	            /* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
	            /* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
	            if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
	                /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
	                try {
	                    opts.complete.call(elements, elements);
	                } catch (error) {
	                    setTimeout(function() { throw error; }, 1);
	                }
	            }
	
	            /**********************
	               Promise Resolving
	            **********************/
	
	            /* Note: Infinite loops don't return promises. */
	            if (resolver && opts.loop !== true) {
	                resolver(elements);
	            }
	
	            /****************************
	               Option: Loop (Infinite)
	            ****************************/
	
	            if (Data(element) && opts.loop === true && !isStopped) {
	                /* If a rotateX/Y/Z property is being animated to 360 deg with loop:true, swap tween start/end values to enable
	                   continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
	                $.each(Data(element).tweensContainer, function(propertyName, tweenContainer) {
	                    if (/^rotate/.test(propertyName) && parseFloat(tweenContainer.endValue) === 360) {
	                        tweenContainer.endValue = 0;
	                        tweenContainer.startValue = 360;
	                    }
	
	                    if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
	                        tweenContainer.endValue = 0;
	                        tweenContainer.startValue = 100;
	                    }
	                });
	
	                Velocity(element, "reverse", { loop: true, delay: opts.delay });
	            }
	
	            /***************
	               Dequeueing
	            ***************/
	
	            /* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
	               which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
	               $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
	            if (opts.queue !== false) {
	                $.dequeue(element, opts.queue);
	            }
	        }
	
	        /************************
	           Calls Array Cleanup
	        ************************/
	
	        /* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
	          (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
	        Velocity.State.calls[callIndex] = false;
	
	        /* Iterate through the calls array to determine if this was the final in-progress animation.
	           If so, set a flag to end ticking and clear the calls array. */
	        for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
	            if (Velocity.State.calls[j] !== false) {
	                remainingCallsExist = true;
	
	                break;
	            }
	        }
	
	        if (remainingCallsExist === false) {
	            /* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
	            Velocity.State.isTicking = false;
	
	            /* Clear the calls array so that its length is reset. */
	            delete Velocity.State.calls;
	            Velocity.State.calls = [];
	        }
	    }
	
	    /******************
	        Frameworks
	    ******************/
	
	    /* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
	       If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
	       also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
	       accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
	       (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
	    global.Velocity = Velocity;
	
	    if (global !== window) {
	        /* Assign the element function to Velocity's core animate() method. */
	        global.fn.velocity = animate;
	        /* Assign the object function's defaults to Velocity's global defaults object. */
	        global.fn.velocity.defaults = Velocity.defaults;
	    }
	
	    /***********************
	       Packaged Redirects
	    ***********************/
	
	    /* slideUp, slideDown */
	    $.each([ "Down", "Up" ], function(i, direction) {
	        Velocity.Redirects["slide" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
	            var opts = $.extend({}, options),
	                begin = opts.begin,
	                complete = opts.complete,
	                computedValues = { height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: "" },
	                inlineValues = {};
	
	            if (opts.display === undefined) {
	                /* Show the element before slideDown begins and hide the element after slideUp completes. */
	                /* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
	                opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
	            }
	
	            opts.begin = function() {
	                /* If the user passed in a begin callback, fire it now. */
	                begin && begin.call(elements, elements);
	
	                /* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
	                for (var property in computedValues) {
	                    inlineValues[property] = element.style[property];
	
	                    /* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
	                       use forcefeeding to start from computed values and animate down to 0. */
	                    var propertyValue = Velocity.CSS.getPropertyValue(element, property);
	                    computedValues[property] = (direction === "Down") ? [ propertyValue, 0 ] : [ 0, propertyValue ];
	                }
	
	                /* Force vertical overflow content to clip so that sliding works as expected. */
	                inlineValues.overflow = element.style.overflow;
	                element.style.overflow = "hidden";
	            }
	
	            opts.complete = function() {
	                /* Reset element to its pre-slide inline values once its slide animation is complete. */
	                for (var property in inlineValues) {
	                    element.style[property] = inlineValues[property];
	                }
	
	                /* If the user passed in a complete callback, fire it now. */
	                complete && complete.call(elements, elements);
	                promiseData && promiseData.resolver(elements);
	            };
	
	            Velocity(element, computedValues, opts);
	        };
	    });
	
	    /* fadeIn, fadeOut */
	    $.each([ "In", "Out" ], function(i, direction) {
	        Velocity.Redirects["fade" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
	            var opts = $.extend({}, options),
	                propertiesMap = { opacity: (direction === "In") ? 1 : 0 },
	                originalComplete = opts.complete;
	
	            /* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
	               callbacks by firing them only when the final element has been reached. */
	            if (elementsIndex !== elementsSize - 1) {
	                opts.complete = opts.begin = null;
	            } else {
	                opts.complete = function() {
	                    if (originalComplete) {
	                        originalComplete.call(elements, elements);
	                    }
	
	                    promiseData && promiseData.resolver(elements);
	                }
	            }
	
	            /* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
	            /* Note: We allow users to pass in "null" to skip display setting altogether. */
	            if (opts.display === undefined) {
	                opts.display = (direction === "In" ? "auto" : "none");
	            }
	
	            Velocity(this, propertiesMap, opts);
	        };
	    });
	
	    return Velocity;
	}((window.jQuery || window.Zepto || window), window, document);
	}));
	
	/******************
	   Known Issues
	******************/
	
	/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
	Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
	will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _typeof2 = __webpack_require__(123);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    // Encodes a dictionary of {
	    //   "notify": true/false,
	    //   "sound": string or undefined,
	    //   "highlight: true/false,
	    // }
	    // to a list of push actions.
	    encodeActions: function encodeActions(action) {
	        var notify = action.notify;
	        var sound = action.sound;
	        var highlight = action.highlight;
	        if (notify) {
	            var actions = ["notify"];
	            if (sound) {
	                actions.push({ "set_tweak": "sound", "value": sound });
	            }
	            if (highlight) {
	                actions.push({ "set_tweak": "highlight" });
	            } else {
	                actions.push({ "set_tweak": "highlight", "value": false });
	            }
	            return actions;
	        } else {
	            return ["dont_notify"];
	        }
	    },
	
	    // Decode a list of actions to a dictionary of {
	    //   "notify": true/false,
	    //   "sound": string or undefined,
	    //   "highlight: true/false,
	    // }
	    // If the actions couldn't be decoded then returns null.
	    decodeActions: function decodeActions(actions) {
	        var notify = false;
	        var sound = null;
	        var highlight = false;
	
	        for (var i = 0; i < actions.length; ++i) {
	            var action = actions[i];
	            if (action === "notify") {
	                notify = true;
	            } else if (action === "dont_notify") {
	                notify = false;
	            } else if ((typeof action === "undefined" ? "undefined" : (0, _typeof3.default)(action)) === 'object') {
	                if (action.set_tweak === "sound") {
	                    sound = action.value;
	                } else if (action.set_tweak === "highlight") {
	                    highlight = action.value;
	                } else {
	                    // We don't understand this kind of tweak, so give up.
	                    return null;
	                }
	            } else {
	                // We don't understand this kind of action, so give up.
	                return null;
	            }
	        }
	
	        if (highlight === undefined) {
	            // If a highlight tweak is missing a value then it defaults to true.
	            highlight = true;
	        }
	
	        var result = { notify: notify, highlight: highlight };
	        if (sound !== null) {
	            result.sound = sound;
	        }
	        return result;
	    }
	};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var StandardActions = __webpack_require__(367);
	var NotificationUtils = __webpack_require__(235);
	
	var states = {
	    /** The push rule is disabled */
	    OFF: "off",
	
	    /** The user will receive push notification for this rule */
	    ON: "on",
	
	    /** The user will receive push notification for this rule with sound and
	        highlight if this is legitimate */
	    LOUD: "loud"
	};
	
	module.exports = {
	    /**
	     * Enum for state of a push rule as defined by the Vector UI.
	     * @readonly
	     * @enum {string}
	     */
	    states: states,
	
	    /**
	     * Convert a PushRuleVectorState to a list of actions
	     *
	     * @return [object] list of push-rule actions
	     */
	    actionsFor: function actionsFor(pushRuleVectorState) {
	        if (pushRuleVectorState === this.ON) {
	            return StandardActions.ACTION_NOTIFY;
	        } else if (pushRuleVectorState === this.LOUD) {
	            return StandardActions.ACTION_HIGHLIGHT_DEFAULT_SOUND;
	        }
	    },
	
	    /**
	     * Convert a pushrule's actions to a PushRuleVectorState.
	     *
	     * Determines whether a content rule is in the PushRuleVectorState.ON
	     * category or in PushRuleVectorState.LOUD, regardless of its enabled
	     * state. Returns null if it does not match these categories.
	     */
	    contentRuleVectorStateKind: function contentRuleVectorStateKind(rule) {
	        var decoded = NotificationUtils.decodeActions(rule.actions);
	
	        if (!decoded) {
	            return null;
	        }
	
	        // Count tweaks to determine if it is a ON or LOUD rule
	        var tweaks = 0;
	        if (decoded.sound) {
	            tweaks++;
	        }
	        if (decoded.highlight) {
	            tweaks++;
	        }
	        var stateKind = null;
	        switch (tweaks) {
	            case 0:
	                stateKind = this.ON;
	                break;
	            case 2:
	                stateKind = this.LOUD;
	                break;
	        }
	        return stateKind;
	    }
	};
	
	for (var k in states) {
	    module.exports[k] = states[k];
	};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(646), __esModule: true };

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(374);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	"use strict";
	
	function isContainer(node) {
	    switch (node._type) {
	    case 'document':
	    case 'block_quote':
	    case 'list':
	    case 'item':
	    case 'paragraph':
	    case 'heading':
	    case 'emph':
	    case 'strong':
	    case 'link':
	    case 'image':
	    case 'custom_inline':
	    case 'custom_block':
	        return true;
	    default:
	        return false;
	    }
	}
	
	var resumeAt = function(node, entering) {
	    this.current = node;
	    this.entering = (entering === true);
	};
	
	var next = function(){
	    var cur = this.current;
	    var entering = this.entering;
	
	    if (cur === null) {
	        return null;
	    }
	
	    var container = isContainer(cur);
	
	    if (entering && container) {
	        if (cur._firstChild) {
	            this.current = cur._firstChild;
	            this.entering = true;
	        } else {
	            // stay on node but exit
	            this.entering = false;
	        }
	
	    } else if (cur === this.root) {
	        this.current = null;
	
	    } else if (cur._next === null) {
	        this.current = cur._parent;
	        this.entering = false;
	
	    } else {
	        this.current = cur._next;
	        this.entering = true;
	    }
	
	    return {entering: entering, node: cur};
	};
	
	var NodeWalker = function(root) {
	    return { current: root,
	             root: root,
	             entering: true,
	             next: next,
	             resumeAt: resumeAt };
	};
	
	var Node = function(nodeType, sourcepos) {
	    this._type = nodeType;
	    this._parent = null;
	    this._firstChild = null;
	    this._lastChild = null;
	    this._prev = null;
	    this._next = null;
	    this._sourcepos = sourcepos;
	    this._lastLineBlank = false;
	    this._open = true;
	    this._string_content = null;
	    this._literal = null;
	    this._listData = {};
	    this._info = null;
	    this._destination = null;
	    this._title = null;
	    this._isFenced = false;
	    this._fenceChar = null;
	    this._fenceLength = 0;
	    this._fenceOffset = null;
	    this._level = null;
	    this._onEnter = null;
	    this._onExit = null;
	};
	
	var proto = Node.prototype;
	
	Object.defineProperty(proto, 'isContainer', {
	    get: function () { return isContainer(this); }
	});
	
	Object.defineProperty(proto, 'type', {
	    get: function() { return this._type; }
	});
	
	Object.defineProperty(proto, 'firstChild', {
	    get: function() { return this._firstChild; }
	});
	
	Object.defineProperty(proto, 'lastChild', {
	    get: function() { return this._lastChild; }
	});
	
	Object.defineProperty(proto, 'next', {
	    get: function() { return this._next; }
	});
	
	Object.defineProperty(proto, 'prev', {
	    get: function() { return this._prev; }
	});
	
	Object.defineProperty(proto, 'parent', {
	    get: function() { return this._parent; }
	});
	
	Object.defineProperty(proto, 'sourcepos', {
	    get: function() { return this._sourcepos; }
	});
	
	Object.defineProperty(proto, 'literal', {
	    get: function() { return this._literal; },
	    set: function(s) { this._literal = s; }
	});
	
	Object.defineProperty(proto, 'destination', {
	    get: function() { return this._destination; },
	    set: function(s) { this._destination = s; }
	});
	
	Object.defineProperty(proto, 'title', {
	    get: function() { return this._title; },
	    set: function(s) { this._title = s; }
	});
	
	Object.defineProperty(proto, 'info', {
	    get: function() { return this._info; },
	    set: function(s) { this._info = s; }
	});
	
	Object.defineProperty(proto, 'level', {
	    get: function() { return this._level; },
	    set: function(s) { this._level = s; }
	});
	
	Object.defineProperty(proto, 'listType', {
	    get: function() { return this._listData.type; },
	    set: function(t) { this._listData.type = t; }
	});
	
	Object.defineProperty(proto, 'listTight', {
	    get: function() { return this._listData.tight; },
	    set: function(t) { this._listData.tight = t; }
	});
	
	Object.defineProperty(proto, 'listStart', {
	    get: function() { return this._listData.start; },
	    set: function(n) { this._listData.start = n; }
	});
	
	Object.defineProperty(proto, 'listDelimiter', {
	    get: function() { return this._listData.delimiter; },
	    set: function(delim) { this._listData.delimiter = delim; }
	});
	
	Object.defineProperty(proto, 'onEnter', {
	    get: function() { return this._onEnter; },
	    set: function(s) { this._onEnter = s; }
	});
	
	Object.defineProperty(proto, 'onExit', {
	    get: function() { return this._onExit; },
	    set: function(s) { this._onExit = s; }
	});
	
	Node.prototype.appendChild = function(child) {
	    child.unlink();
	    child._parent = this;
	    if (this._lastChild) {
	        this._lastChild._next = child;
	        child._prev = this._lastChild;
	        this._lastChild = child;
	    } else {
	        this._firstChild = child;
	        this._lastChild = child;
	    }
	};
	
	Node.prototype.prependChild = function(child) {
	    child.unlink();
	    child._parent = this;
	    if (this._firstChild) {
	        this._firstChild._prev = child;
	        child._next = this._firstChild;
	        this._firstChild = child;
	    } else {
	        this._firstChild = child;
	        this._lastChild = child;
	    }
	};
	
	Node.prototype.unlink = function() {
	    if (this._prev) {
	        this._prev._next = this._next;
	    } else if (this._parent) {
	        this._parent._firstChild = this._next;
	    }
	    if (this._next) {
	        this._next._prev = this._prev;
	    } else if (this._parent) {
	        this._parent._lastChild = this._prev;
	    }
	    this._parent = null;
	    this._next = null;
	    this._prev = null;
	};
	
	Node.prototype.insertAfter = function(sibling) {
	    sibling.unlink();
	    sibling._next = this._next;
	    if (sibling._next) {
	        sibling._next._prev = sibling;
	    }
	    sibling._prev = this;
	    this._next = sibling;
	    sibling._parent = this._parent;
	    if (!sibling._next) {
	        sibling._parent._lastChild = sibling;
	    }
	};
	
	Node.prototype.insertBefore = function(sibling) {
	    sibling.unlink();
	    sibling._prev = this._prev;
	    if (sibling._prev) {
	        sibling._prev._next = sibling;
	    }
	    sibling._next = this;
	    this._prev = sibling;
	    sibling._parent = this._parent;
	    if (!sibling._prev) {
	        sibling._parent._firstChild = sibling;
	    }
	};
	
	Node.prototype.walker = function() {
	    var walker = new NodeWalker(this);
	    return walker;
	};
	
	module.exports = Node;
	
	
	/* Example of use of walker:
	
	 var walker = w.walker();
	 var event;
	
	 while (event = walker.next()) {
	 console.log(event.entering, event.node.type);
	 }
	
	 */


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(150)
	  , TAG = __webpack_require__(39)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46)
	  , document = __webpack_require__(53).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(76)
	  , dPs         = __webpack_require__(385)
	  , enumBugKeys = __webpack_require__(246)
	  , IE_PROTO    = __webpack_require__(250)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(245)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(378).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(151)
	  , createDesc     = __webpack_require__(152)
	  , toIObject      = __webpack_require__(79)
	  , toPrimitive    = __webpack_require__(254)
	  , has            = __webpack_require__(98)
	  , IE8_DOM_DEFINE = __webpack_require__(379)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(77) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(251)('keys')
	  , uid    = __webpack_require__(185);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(53)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(252)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(46);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(53)
	  , core           = __webpack_require__(21)
	  , LIBRARY        = __webpack_require__(182)
	  , wksExt         = __webpack_require__(256)
	  , defineProperty = __webpack_require__(78).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(39);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(243)
	  , ITERATOR  = __webpack_require__(39)('iterator')
	  , Iterators = __webpack_require__(127);
	module.exports = __webpack_require__(21).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(36)
	  , toIndex  = __webpack_require__(108)
	  , toLength = __webpack_require__(35);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(32)
	  , createDesc      = __webpack_require__(90);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25)
	  , document = __webpack_require__(13).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(29)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(13).document && document.documentElement;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(25)
	  , setPrototypeOf = __webpack_require__(272).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(130)
	  , ITERATOR   = __webpack_require__(29)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(60);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(103)
	  , descriptor     = __webpack_require__(90)
	  , setToStringTag = __webpack_require__(131)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(48)(IteratorPrototype, __webpack_require__(29)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(102)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(49)
	  , hide           = __webpack_require__(48)
	  , has            = __webpack_require__(40)
	  , Iterators      = __webpack_require__(130)
	  , $iterCreate    = __webpack_require__(267)
	  , setToStringTag = __webpack_require__(131)
	  , getPrototypeOf = __webpack_require__(55)
	  , ITERATOR       = __webpack_require__(29)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(13)
	  , macrotask = __webpack_require__(279).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(60)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(25)
	  , anObject = __webpack_require__(11);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(81)(Function.call, __webpack_require__(54).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(196)('keys')
	  , uid    = __webpack_require__(109);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(11)
	  , aFunction = __webpack_require__(47)
	  , SPECIES   = __webpack_require__(29)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(91)
	  , defined   = __webpack_require__(61);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(192)
	  , defined  = __webpack_require__(61);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(91)
	  , defined   = __webpack_require__(61);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(81)
	  , invoke             = __webpack_require__(191)
	  , html               = __webpack_require__(263)
	  , cel                = __webpack_require__(260)
	  , global             = __webpack_require__(13)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(60)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(13)
	  , DESCRIPTORS    = __webpack_require__(31)
	  , LIBRARY        = __webpack_require__(102)
	  , $typed         = __webpack_require__(197)
	  , hide           = __webpack_require__(48)
	  , redefineAll    = __webpack_require__(106)
	  , fails          = __webpack_require__(17)
	  , anInstance     = __webpack_require__(101)
	  , toInteger      = __webpack_require__(91)
	  , toLength       = __webpack_require__(35)
	  , gOPN           = __webpack_require__(104).f
	  , dP             = __webpack_require__(32).f
	  , arrayFill      = __webpack_require__(258)
	  , setToStringTag = __webpack_require__(131)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(13)
	  , core           = __webpack_require__(80)
	  , LIBRARY        = __webpack_require__(102)
	  , wksExt         = __webpack_require__(416)
	  , defineProperty = __webpack_require__(32).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(155)
	  , ITERATOR  = __webpack_require__(29)('iterator')
	  , Iterators = __webpack_require__(130);
	module.exports = __webpack_require__(80).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(128)
	  , step             = __webpack_require__(404)
	  , Iterators        = __webpack_require__(130)
	  , toIObject        = __webpack_require__(51);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(268)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isDisposable;
	
	function isDisposable(obj) {
	  return Boolean(obj && typeof obj.dispose === 'function');
	}
	
	module.exports = exports['default'];

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Returns an array of all `ContentBlock` instances within two block keys
	 *
	 * @param  {object} contentState A draft.js `ContentState` instance
	 * @param  {string} anchorKey    The block key to start searching from
	 * @param  {string} focusKey     The block key until which to search
	 *
	 * @return {array} An array containing the found content blocks
	 */
	exports.default = function (contentState, anchorKey, focusKey) {
	  var isSameBlock = anchorKey === focusKey;
	  var startingBlock = contentState.getBlockForKey(anchorKey);
	
	  if (!startingBlock) {
	    return [];
	  }
	
	  var selectedBlocks = [startingBlock];
	
	  if (!isSameBlock) {
	    var blockKey = anchorKey;
	
	    while (blockKey !== focusKey) {
	      var nextBlock = contentState.getBlockAfter(blockKey);
	
	      if (!nextBlock) {
	        selectedBlocks = [];
	        break;
	      }
	
	      selectedBlocks.push(nextBlock);
	      blockKey = nextBlock.getKey();
	    }
	  }
	
	  return selectedBlocks;
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(160);
	var CharacterMetadata = __webpack_require__(63);
	var ContentBlock = __webpack_require__(110);
	var Immutable = __webpack_require__(26);
	var SelectionState = __webpack_require__(133);
	
	var generateRandomKey = __webpack_require__(70);
	var sanitizeDraftText = __webpack_require__(292);
	
	var List = Immutable.List;
	var Record = Immutable.Record;
	var Repeat = Immutable.Repeat;
	
	
	var defaultRecord = {
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	
	var ContentStateRecord = Record(defaultRecord);
	
	var ContentState = function (_ContentStateRecord) {
	  _inherits(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    _classCallCheck(this, ContentState);
	
	    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
	  }
	
	  ContentState.prototype.getBlockMap = function getBlockMap() {
	    return this.get('blockMap');
	  };
	
	  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
	    return this.get('selectionBefore');
	  };
	
	  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
	    return this.get('selectionAfter');
	  };
	
	  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
	    var block = this.getBlockMap().get(key);
	    return block;
	  };
	
	  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
	    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
	    return this.getBlockMap().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
	    return this.getBlockMap().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
	    return this.getBlockMap().reverse().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
	    return this.getBlockMap().toArray();
	  };
	
	  ContentState.prototype.getFirstBlock = function getFirstBlock() {
	    return this.getBlockMap().first();
	  };
	
	  ContentState.prototype.getLastBlock = function getLastBlock() {
	    return this.getBlockMap().last();
	  };
	
	  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
	    return this.getBlockMap().map(function (block) {
	      return block ? block.getText() : '';
	    }).join(delimiter || '\n');
	  };
	
	  ContentState.prototype.hasText = function hasText() {
	    var blockMap = this.getBlockMap();
	    return blockMap.size > 1 || blockMap.first().getLength() > 0;
	  };
	
	  ContentState.createFromBlockArray = function createFromBlockArray(blocks) {
	    var blockMap = BlockMapBuilder.createFromArray(blocks);
	    var selectionState = SelectionState.createEmpty(blockMap.first().getKey());
	    return new ContentState({
	      blockMap: blockMap,
	      selectionBefore: selectionState,
	      selectionAfter: selectionState
	    });
	  };
	
	  ContentState.createFromText = function createFromText(text) {
	    var delimiter = arguments.length <= 1 || arguments[1] === undefined ? /\r\n?|\n/g : arguments[1];
	
	    var strings = text.split(delimiter);
	    var blocks = strings.map(function (block) {
	      block = sanitizeDraftText(block);
	      return new ContentBlock({
	        key: generateRandomKey(),
	        text: block,
	        type: 'unstyled',
	        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	      });
	    });
	    return ContentState.createFromBlockArray(blocks);
	  };
	
	  return ContentState;
	}(ContentStateRecord);
	
	module.exports = ContentState;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftBlockRenderMap
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(26);
	
	var Map = _require.Map;
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(163);
	
	var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
	var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
	var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });
	
	module.exports = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  'blockquote': {
	    element: 'blockquote'
	  },
	  'atomic': {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  'unstyled': {
	    element: 'div'
	  }
	});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyBindingUtil
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(71);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  }
	};
	
	module.exports = KeyBindingUtil;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findAncestorOffsetKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getSelectionOffsetKeyForNode = __webpack_require__(438);
	
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	function findAncestorOffsetKey(node) {
	  var searchNode = node;
	  while (searchNode && searchNode !== document.documentElement) {
	    var key = getSelectionOffsetKeyForNode(searchNode);
	    if (key != null) {
	      return key;
	    }
	    searchNode = searchNode.parentNode;
	  }
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEntityKeyForSelection
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(84);
	
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	      return filterKey(entityKey);
	    }
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	
	  return filterKey(entityKey);
	}
	
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	function filterKey(entityKey) {
	  if (entityKey) {
	    var entity = DraftEntity.get(entityKey);
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionBackward
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule sanitizeDraftText
	 * 
	 */
	
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var encode = __webpack_require__(989),
	    decode = __webpack_require__(988);
	
	exports.decode = function(data, level){
		return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
	};
	
	exports.decodeStrict = function(data, level){
		return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
	};
	
	exports.encode = function(data, level){
		return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
	};
	
	exports.encodeXML = encode.XML;
	
	exports.encodeHTML4 =
	exports.encodeHTML5 =
	exports.encodeHTML  = encode.HTML;
	
	exports.decodeXML =
	exports.decodeXMLStrict = decode.XML;
	
	exports.decodeHTML4 =
	exports.decodeHTML5 =
	exports.decodeHTML = decode.HTML;
	
	exports.decodeHTML4Strict =
	exports.decodeHTML5Strict =
	exports.decodeHTMLStrict = decode.HTMLStrict;
	
	exports.escape = encode.escape;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var getStyleProperty = __webpack_require__(1003);
	
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	
	/**
	 * Utilities for querying and mutating style properties.
	 */
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	    var ownerDocument = node.ownerDocument;
	    while (node && node !== ownerDocument.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return ownerDocument.defaultView || ownerDocument.parentWindow;
	  }
	
	};
	
	module.exports = Style;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	var LTR = 'LTR'; // Left-to-Right direction
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null;
	
	// == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	}
	
	// == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	
	/**
	 * Initialize the global direction
	 */
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	
	/**
	 * Get the global direction
	 */
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	
	module.exports = UnicodeBidiDirection;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1007);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(999);
	var getUnboundedScrollPosition = __webpack_require__(453);
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    scrollable = documentScrollElement;
	  }
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	
	  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
	
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	/**
	 * filesize
	 *
	 * @copyright 2017 Jason Mulligan <jason.mulligan@avoidwork.com>
	 * @license BSD-3-Clause
	 * @version 3.5.6
	 */
	(function (global) {
		var b = /^(b|B)$/,
		    symbol = {
			iec: {
				bits: ["b", "Kib", "Mib", "Gib", "Tib", "Pib", "Eib", "Zib", "Yib"],
				bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
			},
			jedec: {
				bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"],
				bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
			}
		},
		    fullform = {
			iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
			jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"]
		};
	
		/**
	  * filesize
	  *
	  * @method filesize
	  * @param  {Mixed}   arg        String, Int or Float to transform
	  * @param  {Object}  descriptor [Optional] Flags
	  * @return {String}             Readable file size String
	  */
		function filesize(arg) {
			var descriptor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			var result = [],
			    val = 0,
			    e = void 0,
			    base = void 0,
			    bits = void 0,
			    ceil = void 0,
			    full = void 0,
			    fullforms = void 0,
			    neg = void 0,
			    num = void 0,
			    output = void 0,
			    round = void 0,
			    unix = void 0,
			    spacer = void 0,
			    standard = void 0,
			    symbols = void 0;
	
			if (isNaN(arg)) {
				throw new Error("Invalid arguments");
			}
	
			bits = descriptor.bits === true;
			unix = descriptor.unix === true;
			base = descriptor.base || 2;
			round = descriptor.round !== undefined ? descriptor.round : unix ? 1 : 2;
			spacer = descriptor.spacer !== undefined ? descriptor.spacer : unix ? "" : " ";
			symbols = descriptor.symbols || descriptor.suffixes || {};
			standard = base === 2 ? descriptor.standard || "jedec" : "jedec";
			output = descriptor.output || "string";
			full = descriptor.fullform === true;
			fullforms = descriptor.fullforms instanceof Array ? descriptor.fullforms : [];
			e = descriptor.exponent !== undefined ? descriptor.exponent : -1;
			num = Number(arg);
			neg = num < 0;
			ceil = base > 2 ? 1000 : 1024;
	
			// Flipping a negative number to determine the size
			if (neg) {
				num = -num;
			}
	
			// Determining the exponent
			if (e === -1 || isNaN(e)) {
				e = Math.floor(Math.log(num) / Math.log(ceil));
	
				if (e < 0) {
					e = 0;
				}
			}
	
			// Exceeding supported length, time to reduce & multiply
			if (e > 8) {
				e = 8;
			}
	
			// Zero is now a special case because bytes divide by 1
			if (num === 0) {
				result[0] = 0;
				result[1] = unix ? "" : symbol[standard][bits ? "bits" : "bytes"][e];
			} else {
				val = num / (base === 2 ? Math.pow(2, e * 10) : Math.pow(1000, e));
	
				if (bits) {
					val = val * 8;
	
					if (val >= ceil && e < 8) {
						val = val / ceil;
						e++;
					}
				}
	
				result[0] = Number(val.toFixed(e > 0 ? round : 0));
				result[1] = base === 10 && e === 1 ? bits ? "kb" : "kB" : symbol[standard][bits ? "bits" : "bytes"][e];
	
				if (unix) {
					result[1] = standard === "jedec" ? result[1].charAt(0) : e > 0 ? result[1].replace(/B$/, "") : result[1];
	
					if (b.test(result[1])) {
						result[0] = Math.floor(result[0]);
						result[1] = "";
					}
				}
			}
	
			// Decorating a 'diff'
			if (neg) {
				result[0] = -result[0];
			}
	
			// Applying custom symbol
			result[1] = symbols[result[1]] || result[1];
	
			// Returning Array, Object, or String (default)
			if (output === "array") {
				return result;
			}
	
			if (output === "exponent") {
				return e;
			}
	
			if (output === "object") {
				return { value: result[0], suffix: result[1], symbol: result[1] };
			}
	
			if (full) {
				result[1] = fullforms[e] ? fullforms[e] : fullform[standard][e] + (bits ? "bit" : "byte") + (result[0] === 1 ? "" : "s");
			}
	
			return result.join(spacer);
		}
	
		// Partial application for functional programming
		filesize.partial = function (opt) {
			return function (arg) {
				return filesize(arg, opt);
			};
		};
	
		// CommonJS, AMD, script tag
		if (true) {
			module.exports = filesize;
		} else if (typeof define === "function" && define.amd) {
			define(function () {
				return filesize;
			});
		} else {
			global.filesize = filesize;
		}
	})(typeof window !== "undefined" ? window : global);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1021).default;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tokenize = exports.test = exports.scanner = exports.parser = exports.options = exports.inherits = exports.find = undefined;
	
	var _class = __webpack_require__(205);
	
	var _options = __webpack_require__(1026);
	
	var options = _interopRequireWildcard(_options);
	
	var _scanner = __webpack_require__(1024);
	
	var scanner = _interopRequireWildcard(_scanner);
	
	var _parser = __webpack_require__(1023);
	
	var parser = _interopRequireWildcard(_parser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	if (!Array.isArray) {
		Array.isArray = function (arg) {
			return Object.prototype.toString.call(arg) === '[object Array]';
		};
	}
	
	/**
		Converts a string into tokens that represent linkable and non-linkable bits
		@method tokenize
		@param {String} str
		@return {Array} tokens
	*/
	var tokenize = function tokenize(str) {
		return parser.run(scanner.run(str));
	};
	
	/**
		Returns a list of linkable items in the given string.
	*/
	var find = function find(str) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
		var tokens = tokenize(str);
		var filtered = [];
	
		for (var i = 0; i < tokens.length; i++) {
			var token = tokens[i];
			if (token.isLink && (!type || token.type === type)) {
				filtered.push(token.toObject());
			}
		}
	
		return filtered;
	};
	
	/**
		Is the given string valid linkable text of some sort
		Note that this does not trim the text for you.
	
		Optionally pass in a second `type` param, which is the type of link to test
		for.
	
		For example,
	
			test(str, 'email');
	
		Will return `true` if str is a valid email.
	*/
	var test = function test(str) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
		var tokens = tokenize(str);
		return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].type === type);
	};
	
	// Scanner and parser provide states and tokens for the lexicographic stage
	// (will be used to add additional link types)
	exports.find = find;
	exports.inherits = _class.inherits;
	exports.options = options;
	exports.parser = parser;
	exports.scanner = scanner;
	exports.test = test;
	exports.tokenize = tokenize;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AMPERSAND = exports.CLOSEPAREN = exports.CLOSEANGLEBRACKET = exports.CLOSEBRACKET = exports.CLOSEBRACE = exports.OPENPAREN = exports.OPENANGLEBRACKET = exports.OPENBRACKET = exports.OPENBRACE = exports.WS = exports.TLD = exports.SYM = exports.UNDERSCORE = exports.SLASH = exports.MAILTO = exports.PROTOCOL = exports.QUERY = exports.POUND = exports.PLUS = exports.NUM = exports.NL = exports.LOCALHOST = exports.PUNCTUATION = exports.DOT = exports.COLON = exports.AT = exports.DOMAIN = exports.Base = undefined;
	
	var _createTokenClass = __webpack_require__(461);
	
	var _class = __webpack_require__(205);
	
	/******************************************************************************
		Text Tokens
		Tokens composed of strings
	******************************************************************************/
	
	/**
		Abstract class used for manufacturing text tokens.
		Pass in the value this token represents
	
		@class TextToken
		@abstract
	*/
	var TextToken = (0, _createTokenClass.createTokenClass)();
	TextToken.prototype = {
		toString: function toString() {
			return this.v + '';
		}
	};
	
	function inheritsToken(value) {
		var props = value ? { v: value } : {};
		return (0, _class.inherits)(TextToken, (0, _createTokenClass.createTokenClass)(), props);
	}
	
	/**
		A valid domain token
		@class DOMAIN
		@extends TextToken
	*/
	var DOMAIN = inheritsToken();
	
	/**
		@class AT
		@extends TextToken
	*/
	var AT = inheritsToken('@');
	
	/**
		Represents a single colon `:` character
	
		@class COLON
		@extends TextToken
	*/
	var COLON = inheritsToken(':');
	
	/**
		@class DOT
		@extends TextToken
	*/
	var DOT = inheritsToken('.');
	
	/**
		A character class that can surround the URL, but which the URL cannot begin
		or end with. Does not include certain English punctuation like parentheses.
	
		@class PUNCTUATION
		@extends TextToken
	*/
	var PUNCTUATION = inheritsToken();
	
	/**
		The word localhost (by itself)
		@class LOCALHOST
		@extends TextToken
	*/
	var LOCALHOST = inheritsToken();
	
	/**
		Newline token
		@class NL
		@extends TextToken
	*/
	var NL = inheritsToken('\n');
	
	/**
		@class NUM
		@extends TextToken
	*/
	var NUM = inheritsToken();
	
	/**
		@class PLUS
		@extends TextToken
	*/
	var PLUS = inheritsToken('+');
	
	/**
		@class POUND
		@extends TextToken
	*/
	var POUND = inheritsToken('#');
	
	/**
		Represents a web URL protocol. Supported types include
	
		* `http:`
		* `https:`
		* `ftp:`
		* `ftps:`
	
		@class PROTOCOL
		@extends TextToken
	*/
	var PROTOCOL = inheritsToken();
	
	/**
		Represents the start of the email URI protocol
	
		@class MAILTO
		@extends TextToken
	*/
	var MAILTO = inheritsToken('mailto:');
	
	/**
		@class QUERY
		@extends TextToken
	*/
	var QUERY = inheritsToken('?');
	
	/**
		@class SLASH
		@extends TextToken
	*/
	var SLASH = inheritsToken('/');
	
	/**
		@class UNDERSCORE
		@extends TextToken
	*/
	var UNDERSCORE = inheritsToken('_');
	
	/**
		One ore more non-whitespace symbol.
		@class SYM
		@extends TextToken
	*/
	var SYM = inheritsToken();
	
	/**
		@class TLD
		@extends TextToken
	*/
	var TLD = inheritsToken();
	
	/**
		Represents a string of consecutive whitespace characters
	
		@class WS
		@extends TextToken
	*/
	var WS = inheritsToken();
	
	/**
		Opening/closing bracket classes
	*/
	
	var OPENBRACE = inheritsToken('{');
	var OPENBRACKET = inheritsToken('[');
	var OPENANGLEBRACKET = inheritsToken('<');
	var OPENPAREN = inheritsToken('(');
	var CLOSEBRACE = inheritsToken('}');
	var CLOSEBRACKET = inheritsToken(']');
	var CLOSEANGLEBRACKET = inheritsToken('>');
	var CLOSEPAREN = inheritsToken(')');
	
	var AMPERSAND = inheritsToken('&');
	
	exports.Base = TextToken;
	exports.DOMAIN = DOMAIN;
	exports.AT = AT;
	exports.COLON = COLON;
	exports.DOT = DOT;
	exports.PUNCTUATION = PUNCTUATION;
	exports.LOCALHOST = LOCALHOST;
	exports.NL = NL;
	exports.NUM = NUM;
	exports.PLUS = PLUS;
	exports.POUND = POUND;
	exports.QUERY = QUERY;
	exports.PROTOCOL = PROTOCOL;
	exports.MAILTO = MAILTO;
	exports.SLASH = SLASH;
	exports.UNDERSCORE = UNDERSCORE;
	exports.SYM = SYM;
	exports.TLD = TLD;
	exports.WS = WS;
	exports.OPENBRACE = OPENBRACE;
	exports.OPENBRACKET = OPENBRACKET;
	exports.OPENANGLEBRACKET = OPENANGLEBRACKET;
	exports.OPENPAREN = OPENPAREN;
	exports.CLOSEBRACE = CLOSEBRACE;
	exports.CLOSEBRACKET = CLOSEBRACKET;
	exports.CLOSEANGLEBRACKET = CLOSEANGLEBRACKET;
	exports.CLOSEPAREN = CLOSEPAREN;
	exports.AMPERSAND = AMPERSAND;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(112),
	    root = __webpack_require__(85);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1095),
	    mapCacheDelete = __webpack_require__(1096),
	    mapCacheGet = __webpack_require__(1097),
	    mapCacheHas = __webpack_require__(1098),
	    mapCacheSet = __webpack_require__(1099);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1041);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(467),
	    isFlattenable = __webpack_require__(1086);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1044),
	    isObjectLike = __webpack_require__(113);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(37),
	    isSymbol = __webpack_require__(319);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var escapeHtmlChar = __webpack_require__(1072),
	    toString = __webpack_require__(486);
	
	/** Used to match HTML entities and HTML characters. */
	var reUnescapedHtml = /[&<>"']/g,
	    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	/**
	 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	 * corresponding HTML entities.
	 *
	 * **Note:** No other characters are escaped. To escape additional
	 * characters use a third-party library like [_he_](https://mths.be/he).
	 *
	 * Though the ">" character is escaped for symmetry, characters like
	 * ">" and "/" don't need escaping in HTML and have no special meaning
	 * unless they're part of a tag or unquoted attribute value. See
	 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	 * (under "semi-related fun fact") for more details.
	 *
	 * When working with HTML you should always
	 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	 * XSS vectors.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escape('fred, barney, & pebbles');
	 * // => 'fred, barney, &amp; pebbles'
	 */
	function escape(string) {
	  string = toString(string);
	  return (string && reHasUnescapedHtml.test(string))
	    ? string.replace(reUnescapedHtml, escapeHtmlChar)
	    : string;
	}
	
	module.exports = escape;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1043),
	    isObjectLike = __webpack_require__(113);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObjectLike = __webpack_require__(113);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(466),
	    baseKeys = __webpack_require__(1050),
	    isArrayLike = __webpack_require__(136);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * Internal module. Defines the base classes of the encryption implementations
	 *
	 * @module crypto/algorithms/base
	 */
	
	var utils = __webpack_require__(16);
	
	/**
	 * map of registered encryption algorithm classes. A map from string to {@link
	 * module:crypto/algorithms/base.EncryptionAlgorithm|EncryptionAlgorithm} class
	 *
	 * @type {Object.<string, function(new: module:crypto/algorithms/base.EncryptionAlgorithm)>}
	 */
	module.exports.ENCRYPTION_CLASSES = {};
	
	/**
	 * map of registered encryption algorithm classes. Map from string to {@link
	 * module:crypto/algorithms/base.DecryptionAlgorithm|DecryptionAlgorithm} class
	 *
	 * @type {Object.<string, function(new: module:crypto/algorithms/base.DecryptionAlgorithm)>}
	 */
	module.exports.DECRYPTION_CLASSES = {};
	
	/**
	 * base type for encryption implementations
	 *
	 * @constructor
	 * @alias module:crypto/algorithms/base.EncryptionAlgorithm
	 *
	 * @param {object} params parameters
	 * @param {string} params.userId  The UserID for the local user
	 * @param {string} params.deviceId The identifier for this device.
	 * @param {module:crypto} params.crypto crypto core
	 * @param {module:crypto/OlmDevice} params.olmDevice olm.js wrapper
	 * @param {module:base-apis~MatrixBaseApis} baseApis base matrix api interface
	 * @param {string} params.roomId  The ID of the room we will be sending to
	 * @param {object} params.config  The body of the m.room.encryption event
	 */
	var EncryptionAlgorithm = function EncryptionAlgorithm(params) {
	  this._userId = params.userId;
	  this._deviceId = params.deviceId;
	  this._crypto = params.crypto;
	  this._olmDevice = params.olmDevice;
	  this._baseApis = params.baseApis;
	  this._roomId = params.roomId;
	};
	/** */
	module.exports.EncryptionAlgorithm = EncryptionAlgorithm;
	
	/**
	 * Encrypt a message event
	 *
	 * @method module:crypto/algorithms/base.EncryptionAlgorithm#encryptMessage
	 * @abstract
	 *
	 * @param {module:models/room} room
	 * @param {string} eventType
	 * @param {object} plaintext event content
	 *
	 * @return {module:client.Promise} Promise which resolves to the new event body
	 */
	
	/**
	 * Called when the membership of a member of the room changes.
	 *
	 * @param {module:models/event.MatrixEvent} event  event causing the change
	 * @param {module:models/room-member} member  user whose membership changed
	 * @param {string=} oldMembership  previous membership
	 */
	EncryptionAlgorithm.prototype.onRoomMembership = function (event, member, oldMembership) {};
	
	/**
	 * base type for decryption implementations
	 *
	 * @constructor
	 * @alias module:crypto/algorithms/base.DecryptionAlgorithm
	 *
	 * @param {object} params parameters
	 * @param {string} params.userId  The UserID for the local user
	 * @param {module:crypto} params.crypto crypto core
	 * @param {module:crypto/OlmDevice} params.olmDevice olm.js wrapper
	 * @param {string=} params.roomId The ID of the room we will be receiving
	 *     from. Null for to-device events.
	 */
	var DecryptionAlgorithm = function DecryptionAlgorithm(params) {
	  this._userId = params.userId;
	  this._crypto = params.crypto;
	  this._olmDevice = params.olmDevice;
	  this._roomId = params.roomId;
	};
	/** */
	module.exports.DecryptionAlgorithm = DecryptionAlgorithm;
	
	/**
	 * Decrypt an event
	 *
	 * @method module:crypto/algorithms/base.DecryptionAlgorithm#decryptEvent
	 * @abstract
	 *
	 * @param {object} event raw event
	 *
	 * @return {null} if the event referred to an unknown megolm session
	 * @return {module:crypto.DecryptionResult} decryption result
	 *
	 * @throws {module:crypto/algorithms/base.DecryptionError} if there is a
	 *   problem decrypting the event
	 */
	
	/**
	 * Handle a key event
	 *
	 * @method module:crypto/algorithms/base.DecryptionAlgorithm#onRoomKeyEvent
	 *
	 * @param {module:models/event.MatrixEvent} params event key event
	 */
	DecryptionAlgorithm.prototype.onRoomKeyEvent = function (params) {
	  // ignore by default
	};
	
	/**
	 * Import a room key
	 *
	 * @param {module:crypto/OlmDevice.MegolmSessionData} session
	 */
	DecryptionAlgorithm.prototype.importRoomKey = function (session) {
	  // ignore by default
	};
	
	/**
	 * Exception thrown when decryption fails
	 *
	 * @alias module:crypto/algorithms/base.DecryptionError
	 * @constructor
	 * @param {string} msg user-visible message describing the problem
	 *
	 * @param {Object=} details key/value pairs reported in the logs but not shown
	 *   to the user.
	 *
	 * @extends Error
	 */
	var DecryptionError = function DecryptionError(msg, details) {
	  this.name = 'DecryptionError';
	  this.message = msg;
	  this.details = details;
	};
	utils.inherits(DecryptionError, Error);
	
	/** override the string used when logging
	 *
	 * @returns {String}
	 */
	DecryptionError.prototype.toString = function () {
	  var _this = this;
	
	  var result = this.name + '[msg: ' + this.message;
	
	  if (this.details) {
	    result += ', ' + Object.keys(this.details).map(function (k) {
	      return k + ': ' + _this.details[k];
	    }).join(', ');
	  }
	
	  result += ']';
	
	  return result;
	};
	
	module.exports.DecryptionError = DecryptionError;
	
	/**
	 * Exception thrown specifically when we want to warn the user to consider
	 * the security of their conversation before continuing
	 *
	 * @constructor
	 * @param {string} msg message describing the problem
	 * @param {Object} devices userId -> {deviceId -> object}
	 *      set of unknown devices per user we're warning about
	 * @extends Error
	 */
	module.exports.UnknownDeviceError = function (msg, devices) {
	  this.name = "UnknownDeviceError";
	  this.message = msg;
	  this.devices = devices;
	};
	utils.inherits(module.exports.UnknownDeviceError, Error);
	
	/**
	 * Registers an encryption/decryption class for a particular algorithm
	 *
	 * @param {string} algorithm algorithm tag to register for
	 *
	 * @param {class} encryptor {@link
	 *     module:crypto/algorithms/base.EncryptionAlgorithm|EncryptionAlgorithm}
	 *     implementation
	 *
	 * @param {class} decryptor {@link
	 *     module:crypto/algorithms/base.DecryptionAlgorithm|DecryptionAlgorithm}
	 *     implementation
	 */
	module.exports.registerAlgorithm = function (algorithm, encryptor, decryptor) {
	  module.exports.ENCRYPTION_CLASSES[algorithm] = encryptor;
	  module.exports.DECRYPTION_CLASSES[algorithm] = decryptor;
	};


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module crypto/deviceinfo
	 */
	
	/**
	  * Information about a user's device
	  *
	  * @constructor
	  * @alias module:crypto/deviceinfo
	  *
	  * @property {string} deviceId the ID of this device
	  *
	  * @property {string[]} algorithms list of algorithms supported by this device
	  *
	  * @property {Object.<string,string>} keys a map from
	  *      &lt;key type&gt;:&lt;id&gt; -> &lt;base64-encoded key&gt;>
	  *
	  * @property {module:crypto/deviceinfo.DeviceVerification} verified
	  *     whether the device has been verified/blocked by the user
	  *
	  * @property {boolean} known
	  *     whether the user knows of this device's existence (useful when warning
	  *     the user that a user has added new devices)
	  *
	  * @property {Object} unsigned  additional data from the homeserver
	  *
	  * @param {string} deviceId id of the device
	  */
	
	function DeviceInfo(deviceId) {
	    // you can't change the deviceId
	    Object.defineProperty(this, 'deviceId', {
	        enumerable: true,
	        value: deviceId
	    });
	
	    this.algorithms = [];
	    this.keys = {};
	    this.verified = DeviceVerification.UNVERIFIED;
	    this.known = false;
	    this.unsigned = {};
	}
	
	/**
	 * rehydrate a DeviceInfo from the session store
	 *
	 * @param {object} obj  raw object from session store
	 * @param {string} deviceId id of the device
	 *
	 * @return {module:crypto~DeviceInfo} new DeviceInfo
	 */
	DeviceInfo.fromStorage = function (obj, deviceId) {
	    var res = new DeviceInfo(deviceId);
	    for (var prop in obj) {
	        if (obj.hasOwnProperty(prop)) {
	            res[prop] = obj[prop];
	        }
	    }
	    return res;
	};
	
	/**
	 * Prepare a DeviceInfo for JSON serialisation in the session store
	 *
	 * @return {object} deviceinfo with non-serialised members removed
	 */
	DeviceInfo.prototype.toStorage = function () {
	    return {
	        algorithms: this.algorithms,
	        keys: this.keys,
	        verified: this.verified,
	        known: this.known,
	        unsigned: this.unsigned
	    };
	};
	
	/**
	 * Get the fingerprint for this device (ie, the Ed25519 key)
	 *
	 * @return {string} base64-encoded fingerprint of this device
	 */
	DeviceInfo.prototype.getFingerprint = function () {
	    return this.keys["ed25519:" + this.deviceId];
	};
	
	/**
	 * Get the identity key for this device (ie, the Curve25519 key)
	 *
	 * @return {string} base64-encoded identity key of this device
	 */
	DeviceInfo.prototype.getIdentityKey = function () {
	    return this.keys["curve25519:" + this.deviceId];
	};
	
	/**
	 * Get the configured display name for this device, if any
	 *
	 * @return {string?} displayname
	 */
	DeviceInfo.prototype.getDisplayName = function () {
	    return this.unsigned.device_display_name || null;
	};
	
	/**
	 * Returns true if this device is blocked
	 *
	 * @return {Boolean} true if blocked
	 */
	DeviceInfo.prototype.isBlocked = function () {
	    return this.verified == DeviceVerification.BLOCKED;
	};
	
	/**
	 * Returns true if this device is verified
	 *
	 * @return {Boolean} true if verified
	 */
	DeviceInfo.prototype.isVerified = function () {
	    return this.verified == DeviceVerification.VERIFIED;
	};
	
	/**
	 * Returns true if this device is unverified
	 *
	 * @return {Boolean} true if unverified
	 */
	DeviceInfo.prototype.isUnverified = function () {
	    return this.verified == DeviceVerification.UNVERIFIED;
	};
	
	/**
	 * Returns true if the user knows about this device's existence
	 *
	 * @return {Boolean} true if known
	 */
	DeviceInfo.prototype.isKnown = function () {
	    return this.known == true;
	};
	
	/**
	 * @enum
	 */
	DeviceInfo.DeviceVerification = {
	    VERIFIED: 1,
	    UNVERIFIED: 0,
	    BLOCKED: -1
	};
	
	var DeviceVerification = DeviceInfo.DeviceVerification;
	
	/** */
	module.exports = DeviceInfo;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module filter
	 */
	
	var FilterComponent = __webpack_require__(1140);
	
	/**
	 * @param {Object} obj
	 * @param {string} keyNesting
	 * @param {*} val
	 */
	function setProp(obj, keyNesting, val) {
	    var nestedKeys = keyNesting.split(".");
	    var currentObj = obj;
	    for (var i = 0; i < nestedKeys.length - 1; i++) {
	        if (!currentObj[nestedKeys[i]]) {
	            currentObj[nestedKeys[i]] = {};
	        }
	        currentObj = currentObj[nestedKeys[i]];
	    }
	    currentObj[nestedKeys[nestedKeys.length - 1]] = val;
	}
	
	/**
	 * Construct a new Filter.
	 * @constructor
	 * @param {string} userId The user ID for this filter.
	 * @param {string=} filterId The filter ID if known.
	 * @prop {string} userId The user ID of the filter
	 * @prop {?string} filterId The filter ID
	 */
	function Filter(userId, filterId) {
	    this.userId = userId;
	    this.filterId = filterId;
	    this.definition = {};
	}
	
	/**
	 * Get the ID of this filter on your homeserver (if known)
	 * @return {?Number} The filter ID
	 */
	Filter.prototype.getFilterId = function () {
	    return this.filterId;
	};
	
	/**
	 * Get the JSON body of the filter.
	 * @return {Object} The filter definition
	 */
	Filter.prototype.getDefinition = function () {
	    return this.definition;
	};
	
	/**
	 * Set the JSON body of the filter
	 * @param {Object} definition The filter definition
	 */
	Filter.prototype.setDefinition = function (definition) {
	    this.definition = definition;
	
	    // This is all ported from synapse's FilterCollection()
	
	    // definitions look something like:
	    // {
	    //   "room": {
	    //     "rooms": ["!abcde:example.com"],
	    //     "not_rooms": ["!123456:example.com"],
	    //     "state": {
	    //       "types": ["m.room.*"],
	    //       "not_rooms": ["!726s6s6q:example.com"],
	    //     },
	    //     "timeline": {
	    //       "limit": 10,
	    //       "types": ["m.room.message"],
	    //       "not_rooms": ["!726s6s6q:example.com"],
	    //       "not_senders": ["@spam:example.com"]
	    //       "contains_url": true
	    //     },
	    //     "ephemeral": {
	    //       "types": ["m.receipt", "m.typing"],
	    //       "not_rooms": ["!726s6s6q:example.com"],
	    //       "not_senders": ["@spam:example.com"]
	    //     }
	    //   },
	    //   "presence": {
	    //     "types": ["m.presence"],
	    //     "not_senders": ["@alice:example.com"]
	    //   },
	    //   "event_format": "client",
	    //   "event_fields": ["type", "content", "sender"]
	    // }
	
	    var room_filter_json = definition.room;
	
	    // consider the top level rooms/not_rooms filter
	    var room_filter_fields = {};
	    if (room_filter_json) {
	        if (room_filter_json.rooms) {
	            room_filter_fields.rooms = room_filter_json.rooms;
	        }
	        if (room_filter_json.rooms) {
	            room_filter_fields.not_rooms = room_filter_json.not_rooms;
	        }
	
	        this._include_leave = room_filter_json.include_leave || false;
	    }
	
	    this._room_filter = new FilterComponent(room_filter_fields);
	    this._room_timeline_filter = new FilterComponent(room_filter_json ? room_filter_json.timeline || {} : {});
	
	    // don't bother porting this from synapse yet:
	    // this._room_state_filter =
	    //     new FilterComponent(room_filter_json.state || {});
	    // this._room_ephemeral_filter =
	    //     new FilterComponent(room_filter_json.ephemeral || {});
	    // this._room_account_data_filter =
	    //     new FilterComponent(room_filter_json.account_data || {});
	    // this._presence_filter =
	    //     new FilterComponent(definition.presence || {});
	    // this._account_data_filter =
	    //     new FilterComponent(definition.account_data || {});
	};
	
	/**
	 * Get the room.timeline filter component of the filter
	 * @return {FilterComponent} room timeline filter component
	 */
	Filter.prototype.getRoomTimelineFilterComponent = function () {
	    return this._room_timeline_filter;
	};
	
	/**
	 * Filter the list of events based on whether they are allowed in a timeline
	 * based on this filter
	 * @param {MatrixEvent[]} events  the list of events being filtered
	 * @return {MatrixEvent[]} the list of events which match the filter
	 */
	Filter.prototype.filterRoomTimeline = function (events) {
	    return this._room_timeline_filter.filter(this._room_filter.filter(events));
	};
	
	/**
	 * Set the max number of events to return for each room's timeline.
	 * @param {Number} limit The max number of events to return for each room.
	 */
	Filter.prototype.setTimelineLimit = function (limit) {
	    setProp(this.definition, "room.timeline.limit", limit);
	};
	
	/**
	 * Control whether left rooms should be included in responses.
	 * @param {boolean} includeLeave True to make rooms the user has left appear
	 * in responses.
	 */
	Filter.prototype.setIncludeLeaveRooms = function (includeLeave) {
	    setProp(this.definition, "room.include_leave", includeLeave);
	};
	
	/**
	 * Create a filter from existing data.
	 * @static
	 * @param {string} userId
	 * @param {string} filterId
	 * @param {Object} jsonObj
	 * @return {Filter}
	 */
	Filter.fromJson = function (userId, filterId, jsonObj) {
	    var filter = new Filter(userId, filterId);
	    filter.setDefinition(jsonObj);
	    return filter;
	};
	
	/** The Filter class */
	module.exports = Filter;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/event-timeline-set
	 */
	
	var EventEmitter = __webpack_require__(56).EventEmitter;
	var utils = __webpack_require__(16);
	var EventTimeline = __webpack_require__(115);
	
	// var DEBUG = false;
	var DEBUG = true;
	
	var debuglog = void 0;
	if (DEBUG) {
	    // using bind means that we get to keep useful line numbers in the console
	    debuglog = console.log.bind(console);
	} else {
	    debuglog = function debuglog() {};
	}
	
	/**
	 * Construct a set of EventTimeline objects, typically on behalf of a given
	 * room.  A room may have multiple EventTimelineSets for different levels
	 * of filtering.  The global notification list is also an EventTimelineSet, but
	 * lacks a room.
	 *
	 * <p>This is an ordered sequence of timelines, which may or may not
	 * be continuous. Each timeline lists a series of events, as well as tracking
	 * the room state at the start and the end of the timeline (if appropriate).
	 * It also tracks forward and backward pagination tokens, as well as containing
	 * links to the next timeline in the sequence.
	 *
	 * <p>There is one special timeline - the 'live' timeline, which represents the
	 * timeline to which events are being added in real-time as they are received
	 * from the /sync API. Note that you should not retain references to this
	 * timeline - even if it is the current timeline right now, it may not remain
	 * so if the server gives us a timeline gap in /sync.
	 *
	 * <p>In order that we can find events from their ids later, we also maintain a
	 * map from event_id to timeline and index.
	 *
	 * @constructor
	 * @param {?Room} room      the optional room for this timelineSet
	 * @param {Object} opts     hash of options inherited from Room.
	 *      opts.timelineSupport gives whether timeline support is enabled
	 *      opts.filter is the filter object, if any, for this timelineSet.
	 */
	function EventTimelineSet(room, opts) {
	    this.room = room;
	
	    this._timelineSupport = Boolean(opts.timelineSupport);
	    this._liveTimeline = new EventTimeline(this);
	
	    // just a list - *not* ordered.
	    this._timelines = [this._liveTimeline];
	    this._eventIdToTimeline = {};
	
	    this._filter = opts.filter || null;
	}
	utils.inherits(EventTimelineSet, EventEmitter);
	
	/**
	 * Get the filter object this timeline set is filtered on, if any
	 * @return {?Filter} the optional filter for this timelineSet
	 */
	EventTimelineSet.prototype.getFilter = function () {
	    return this._filter;
	};
	
	/**
	 * Set the filter object this timeline set is filtered on
	 * (passed to the server when paginating via /messages).
	 * @param {Filter} filter the filter for this timelineSet
	 */
	EventTimelineSet.prototype.setFilter = function (filter) {
	    this._filter = filter;
	};
	
	/**
	 * Get the list of pending sent events for this timelineSet's room, filtered
	 * by the timelineSet's filter if appropriate.
	 *
	 * @return {module:models/event.MatrixEvent[]} A list of the sent events
	 * waiting for remote echo.
	 *
	 * @throws If <code>opts.pendingEventOrdering</code> was not 'detached'
	 */
	EventTimelineSet.prototype.getPendingEvents = function () {
	    if (!this.room) {
	        return [];
	    }
	
	    if (this._filter) {
	        return this._filter.filterRoomTimeline(this.room.getPendingEvents());
	    } else {
	        return this.room.getPendingEvents();
	    }
	};
	
	/**
	 * Get the live timeline for this room.
	 *
	 * @return {module:models/event-timeline~EventTimeline} live timeline
	 */
	EventTimelineSet.prototype.getLiveTimeline = function () {
	    return this._liveTimeline;
	};
	
	/**
	 * Return the timeline (if any) this event is in.
	 * @param {String} eventId the eventId being sought
	 * @return {module:models/event-timeline~EventTimeline} timeline
	 */
	EventTimelineSet.prototype.eventIdToTimeline = function (eventId) {
	    return this._eventIdToTimeline[eventId];
	};
	
	/**
	 * Track a new event as if it were in the same timeline as an old event,
	 * replacing it.
	 * @param {String} oldEventId  event ID of the original event
	 * @param {String} newEventId  event ID of the replacement event
	 */
	EventTimelineSet.prototype.replaceEventId = function (oldEventId, newEventId) {
	    var existingTimeline = this._eventIdToTimeline[oldEventId];
	    if (existingTimeline) {
	        delete this._eventIdToTimeline[oldEventId];
	        this._eventIdToTimeline[newEventId] = existingTimeline;
	    }
	};
	
	/**
	 * Reset the live timeline, and start a new one.
	 *
	 * <p>This is used when /sync returns a 'limited' timeline.
	 *
	 * @param {string=} backPaginationToken   token for back-paginating the new timeline
	 * @param {?bool} flush  Whether to flush the non-live timelines too.
	 *
	 * @fires module:client~MatrixClient#event:"Room.timelineReset"
	 */
	EventTimelineSet.prototype.resetLiveTimeline = function (backPaginationToken, flush) {
	    // if timeline support is disabled, forget about the old timelines
	    var resetAllTimelines = !this._timelineSupport || flush;
	
	    var newTimeline = void 0;
	    if (resetAllTimelines) {
	        newTimeline = new EventTimeline(this);
	        this._timelines = [newTimeline];
	        this._eventIdToTimeline = {};
	    } else {
	        newTimeline = this.addTimeline();
	    }
	
	    // initialise the state in the new timeline from our last known state
	    var evMap = this._liveTimeline.getState(EventTimeline.FORWARDS).events;
	    var events = [];
	    for (var evtype in evMap) {
	        if (!evMap.hasOwnProperty(evtype)) {
	            continue;
	        }
	        for (var stateKey in evMap[evtype]) {
	            if (!evMap[evtype].hasOwnProperty(stateKey)) {
	                continue;
	            }
	            events.push(evMap[evtype][stateKey]);
	        }
	    }
	    newTimeline.initialiseState(events);
	
	    // make sure we set the pagination token before firing timelineReset,
	    // otherwise clients which start back-paginating will fail, and then get
	    // stuck without realising that they *can* back-paginate.
	    newTimeline.setPaginationToken(backPaginationToken, EventTimeline.BACKWARDS);
	
	    this._liveTimeline = newTimeline;
	    this.emit("Room.timelineReset", this.room, this, resetAllTimelines);
	};
	
	/**
	 * Get the timeline which contains the given event, if any
	 *
	 * @param {string} eventId  event ID to look for
	 * @return {?module:models/event-timeline~EventTimeline} timeline containing
	 * the given event, or null if unknown
	 */
	EventTimelineSet.prototype.getTimelineForEvent = function (eventId) {
	    var res = this._eventIdToTimeline[eventId];
	    return res === undefined ? null : res;
	};
	
	/**
	 * Get an event which is stored in our timelines
	 *
	 * @param {string} eventId  event ID to look for
	 * @return {?module:models/event~MatrixEvent} the given event, or undefined if unknown
	 */
	EventTimelineSet.prototype.findEventById = function (eventId) {
	    var tl = this.getTimelineForEvent(eventId);
	    if (!tl) {
	        return undefined;
	    }
	    return utils.findElement(tl.getEvents(), function (ev) {
	        return ev.getId() == eventId;
	    });
	};
	
	/**
	 * Add a new timeline to this timeline list
	 *
	 * @return {module:models/event-timeline~EventTimeline} newly-created timeline
	 */
	EventTimelineSet.prototype.addTimeline = function () {
	    if (!this._timelineSupport) {
	        throw new Error("timeline support is disabled. Set the 'timelineSupport'" + " parameter to true when creating MatrixClient to enable" + " it.");
	    }
	
	    var timeline = new EventTimeline(this);
	    this._timelines.push(timeline);
	    return timeline;
	};
	
	/**
	 * Add events to a timeline
	 *
	 * <p>Will fire "Room.timeline" for each event added.
	 *
	 * @param {MatrixEvent[]} events A list of events to add.
	 *
	 * @param {boolean} toStartOfTimeline   True to add these events to the start
	 * (oldest) instead of the end (newest) of the timeline. If true, the oldest
	 * event will be the <b>last</b> element of 'events'.
	 *
	 * @param {module:models/event-timeline~EventTimeline} timeline   timeline to
	 *    add events to.
	 *
	 * @param {string=} paginationToken   token for the next batch of events
	 *
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 *
	 */
	EventTimelineSet.prototype.addEventsToTimeline = function (events, toStartOfTimeline, timeline, paginationToken) {
	    if (!timeline) {
	        throw new Error("'timeline' not specified for EventTimelineSet.addEventsToTimeline");
	    }
	
	    if (!toStartOfTimeline && timeline == this._liveTimeline) {
	        throw new Error("EventTimelineSet.addEventsToTimeline cannot be used for adding events to " + "the live timeline - use Room.addLiveEvents instead");
	    }
	
	    if (this._filter) {
	        events = this._filter.filterRoomTimeline(events);
	        if (!events.length) {
	            return;
	        }
	    }
	
	    var direction = toStartOfTimeline ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS;
	    var inverseDirection = toStartOfTimeline ? EventTimeline.FORWARDS : EventTimeline.BACKWARDS;
	
	    // Adding events to timelines can be quite complicated. The following
	    // illustrates some of the corner-cases.
	    //
	    // Let's say we start by knowing about four timelines. timeline3 and
	    // timeline4 are neighbours:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M]          [P]          [S] <------> [T]
	    //
	    // Now we paginate timeline1, and get the following events from the server:
	    // [M, N, P, R, S, T, U].
	    //
	    // 1. First, we ignore event M, since we already know about it.
	    //
	    // 2. Next, we append N to timeline 1.
	    //
	    // 3. Next, we don't add event P, since we already know about it,
	    //    but we do link together the timelines. We now have:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P]          [S] <------> [T]
	    //
	    // 4. Now we add event R to timeline2:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P, R]       [S] <------> [T]
	    //
	    //    Note that we have switched the timeline we are working on from
	    //    timeline1 to timeline2.
	    //
	    // 5. We ignore event S, but again join the timelines:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P, R] <---> [S] <------> [T]
	    //
	    // 6. We ignore event T, and the timelines are already joined, so there
	    //    is nothing to do.
	    //
	    // 7. Finally, we add event U to timeline4:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P, R] <---> [S] <------> [T, U]
	    //
	    // The important thing to note in the above is what happened when we
	    // already knew about a given event:
	    //
	    //   - if it was appropriate, we joined up the timelines (steps 3, 5).
	    //   - in any case, we started adding further events to the timeline which
	    //       contained the event we knew about (steps 3, 5, 6).
	    //
	    //
	    // So much for adding events to the timeline. But what do we want to do
	    // with the pagination token?
	    //
	    // In the case above, we will be given a pagination token which tells us how to
	    // get events beyond 'U' - in this case, it makes sense to store this
	    // against timeline4. But what if timeline4 already had 'U' and beyond? in
	    // that case, our best bet is to throw away the pagination token we were
	    // given and stick with whatever token timeline4 had previously. In short,
	    // we want to only store the pagination token if the last event we receive
	    // is one we didn't previously know about.
	    //
	    // We make an exception for this if it turns out that we already knew about
	    // *all* of the events, and we weren't able to join up any timelines. When
	    // that happens, it means our existing pagination token is faulty, since it
	    // is only telling us what we already know. Rather than repeatedly
	    // paginating with the same token, we might as well use the new pagination
	    // token in the hope that we eventually work our way out of the mess.
	
	    var didUpdate = false;
	    var lastEventWasNew = false;
	    for (var i = 0; i < events.length; i++) {
	        var event = events[i];
	        var eventId = event.getId();
	
	        var existingTimeline = this._eventIdToTimeline[eventId];
	
	        if (!existingTimeline) {
	            // we don't know about this event yet. Just add it to the timeline.
	            this.addEventToTimeline(event, timeline, toStartOfTimeline);
	            lastEventWasNew = true;
	            didUpdate = true;
	            continue;
	        }
	
	        lastEventWasNew = false;
	
	        if (existingTimeline == timeline) {
	            debuglog("Event " + eventId + " already in timeline " + timeline);
	            continue;
	        }
	
	        var neighbour = timeline.getNeighbouringTimeline(direction);
	        if (neighbour) {
	            // this timeline already has a neighbour in the relevant direction;
	            // let's assume the timelines are already correctly linked up, and
	            // skip over to it.
	            //
	            // there's probably some edge-case here where we end up with an
	            // event which is in a timeline a way down the chain, and there is
	            // a break in the chain somewhere. But I can't really imagine how
	            // that would happen, so I'm going to ignore it for now.
	            //
	            if (existingTimeline == neighbour) {
	                debuglog("Event " + eventId + " in neighbouring timeline - " + "switching to " + existingTimeline);
	            } else {
	                debuglog("Event " + eventId + " already in a different " + "timeline " + existingTimeline);
	            }
	            timeline = existingTimeline;
	            continue;
	        }
	
	        // time to join the timelines.
	        console.info("Already have timeline for " + eventId + " - joining timeline " + timeline + " to " + existingTimeline);
	        timeline.setNeighbouringTimeline(existingTimeline, direction);
	        existingTimeline.setNeighbouringTimeline(timeline, inverseDirection);
	        timeline = existingTimeline;
	        didUpdate = true;
	    }
	
	    // see above - if the last event was new to us, or if we didn't find any
	    // new information, we update the pagination token for whatever
	    // timeline we ended up on.
	    if (lastEventWasNew || !didUpdate) {
	        timeline.setPaginationToken(paginationToken, direction);
	    }
	};
	
	/**
	 * Add an event to the end of this live timeline.
	 *
	 * @param {MatrixEvent} event Event to be added
	 * @param {string?} duplicateStrategy 'ignore' or 'replace'
	 */
	EventTimelineSet.prototype.addLiveEvent = function (event, duplicateStrategy) {
	    if (this._filter) {
	        var events = this._filter.filterRoomTimeline([event]);
	        if (!events.length) {
	            return;
	        }
	    }
	
	    var timeline = this._eventIdToTimeline[event.getId()];
	    if (timeline) {
	        if (duplicateStrategy === "replace") {
	            debuglog("EventTimelineSet.addLiveEvent: replacing duplicate event " + event.getId());
	            var tlEvents = timeline.getEvents();
	            for (var j = 0; j < tlEvents.length; j++) {
	                if (tlEvents[j].getId() === event.getId()) {
	                    // still need to set the right metadata on this event
	                    EventTimeline.setEventMetadata(event, timeline.getState(EventTimeline.FORWARDS), false);
	
	                    if (!tlEvents[j].encryptedType) {
	                        tlEvents[j] = event;
	                    }
	
	                    // XXX: we need to fire an event when this happens.
	                    break;
	                }
	            }
	        } else {
	            debuglog("EventTimelineSet.addLiveEvent: ignoring duplicate event " + event.getId());
	        }
	        return;
	    }
	
	    this.addEventToTimeline(event, this._liveTimeline, false);
	};
	
	/**
	 * Add event to the given timeline, and emit Room.timeline. Assumes
	 * we have already checked we don't know about this event.
	 *
	 * Will fire "Room.timeline" for each event added.
	 *
	 * @param {MatrixEvent} event
	 * @param {EventTimeline} timeline
	 * @param {boolean} toStartOfTimeline
	 *
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 */
	EventTimelineSet.prototype.addEventToTimeline = function (event, timeline, toStartOfTimeline) {
	    var eventId = event.getId();
	    timeline.addEvent(event, toStartOfTimeline);
	    this._eventIdToTimeline[eventId] = timeline;
	
	    var data = {
	        timeline: timeline,
	        liveEvent: !toStartOfTimeline && timeline == this._liveTimeline
	    };
	    this.emit("Room.timeline", event, this.room, Boolean(toStartOfTimeline), false, data);
	};
	
	/**
	 * Replaces event with ID oldEventId with one with newEventId, if oldEventId is
	 * recognised.  Otherwise, add to the live timeline.  Used to handle remote echos.
	 *
	 * @param {MatrixEvent} localEvent     the new event to be added to the timeline
	 * @param {String} oldEventId          the ID of the original event
	 * @param {boolean} newEventId         the ID of the replacement event
	 *
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 */
	EventTimelineSet.prototype.handleRemoteEcho = function (localEvent, oldEventId, newEventId) {
	    // XXX: why don't we infer newEventId from localEvent?
	    var existingTimeline = this._eventIdToTimeline[oldEventId];
	    if (existingTimeline) {
	        delete this._eventIdToTimeline[oldEventId];
	        this._eventIdToTimeline[newEventId] = existingTimeline;
	    } else {
	        if (this._filter) {
	            if (this._filter.filterRoomTimeline([localEvent]).length) {
	                this.addEventToTimeline(localEvent, this._liveTimeline, false);
	            }
	        } else {
	            this.addEventToTimeline(localEvent, this._liveTimeline, false);
	        }
	    }
	};
	
	/**
	 * Removes a single event from this room.
	 *
	 * @param {String} eventId  The id of the event to remove
	 *
	 * @return {?MatrixEvent} the removed event, or null if the event was not found
	 * in this room.
	 */
	EventTimelineSet.prototype.removeEvent = function (eventId) {
	    var timeline = this._eventIdToTimeline[eventId];
	    if (!timeline) {
	        return null;
	    }
	
	    var removed = timeline.removeEvent(eventId);
	    if (removed) {
	        delete this._eventIdToTimeline[eventId];
	        var data = {
	            timeline: timeline
	        };
	        this.emit("Room.timeline", removed, this.room, undefined, true, data);
	    }
	    return removed;
	};
	
	/**
	 * Determine where two events appear in the timeline relative to one another
	 *
	 * @param {string} eventId1   The id of the first event
	 * @param {string} eventId2   The id of the second event
	
	 * @return {?number} a number less than zero if eventId1 precedes eventId2, and
	 *    greater than zero if eventId1 succeeds eventId2. zero if they are the
	 *    same event; null if we can't tell (either because we don't know about one
	 *    of the events, or because they are in separate timelines which don't join
	 *    up).
	 */
	EventTimelineSet.prototype.compareEventOrdering = function (eventId1, eventId2) {
	    if (eventId1 == eventId2) {
	        // optimise this case
	        return 0;
	    }
	
	    var timeline1 = this._eventIdToTimeline[eventId1];
	    var timeline2 = this._eventIdToTimeline[eventId2];
	
	    if (timeline1 === undefined) {
	        return null;
	    }
	    if (timeline2 === undefined) {
	        return null;
	    }
	
	    if (timeline1 === timeline2) {
	        // both events are in the same timeline - figure out their
	        // relative indices
	        var idx1 = void 0,
	            idx2 = void 0;
	        var events = timeline1.getEvents();
	        for (var idx = 0; idx < events.length && (idx1 === undefined || idx2 === undefined); idx++) {
	            var evId = events[idx].getId();
	            if (evId == eventId1) {
	                idx1 = idx;
	            }
	            if (evId == eventId2) {
	                idx2 = idx;
	            }
	        }
	        return idx1 - idx2;
	    }
	
	    // the events are in different timelines. Iterate through the
	    // linkedlist to see which comes first.
	
	    // first work forwards from timeline1
	    var tl = timeline1;
	    while (tl) {
	        if (tl === timeline2) {
	            // timeline1 is before timeline2
	            return -1;
	        }
	        tl = tl.getNeighbouringTimeline(EventTimeline.FORWARDS);
	    }
	
	    // now try backwards from timeline1
	    tl = timeline1;
	    while (tl) {
	        if (tl === timeline2) {
	            // timeline2 is before timeline1
	            return 1;
	        }
	        tl = tl.getNeighbouringTimeline(EventTimeline.BACKWARDS);
	    }
	
	    // the timelines are not contiguous.
	    return null;
	};
	
	/**
	 * The EventTimelineSet class.
	 */
	module.exports = EventTimelineSet;
	
	/**
	 * Fires whenever the timeline in a room is updated.
	 * @event module:client~MatrixClient#"Room.timeline"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {?Room} room The room, if any, whose timeline was updated.
	 * @param {boolean} toStartOfTimeline True if this event was added to the start
	 * @param {boolean} removed True if this event has just been removed from the timeline
	 * (beginning; oldest) of the timeline e.g. due to pagination.
	 *
	 * @param {object} data  more data about the event
	 *
	 * @param {module:event-timeline.EventTimeline} data.timeline the timeline the
	 * event was added to/removed from
	 *
	 * @param {boolean} data.liveEvent true if the event was a real-time event
	 * added to the end of the live timeline
	 *
	 * @example
	 * matrixClient.on("Room.timeline",
	 *                 function(event, room, toStartOfTimeline, removed, data) {
	 *   if (!toStartOfTimeline && data.liveEvent) {
	 *     var messageToAppend = room.timeline.[room.timeline.length - 1];
	 *   }
	 * });
	 */
	
	/**
	 * Fires whenever the live timeline in a room is reset.
	 *
	 * When we get a 'limited' sync (for example, after a network outage), we reset
	 * the live timeline to be empty before adding the recent events to the new
	 * timeline. This event is fired after the timeline is reset, and before the
	 * new events are added.
	 *
	 * @event module:client~MatrixClient#"Room.timelineReset"
	 * @param {Room} room The room whose live timeline was reset, if any
	 * @param {EventTimelineSet} timelineSet timelineSet room whose live timeline was reset
	 * @param {boolean} resetAllTimelines True if all timelines were reset.
	 */


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         Copyright 2017 Vector Creations Ltd
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         */
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _syncAccumulator = __webpack_require__(218);
	
	var _syncAccumulator2 = _interopRequireDefault(_syncAccumulator);
	
	var _utils = __webpack_require__(16);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERSION = 1;
	
	function createDatabase(db) {
	    // Make user store, clobber based on user ID. (userId property of User objects)
	    db.createObjectStore("users", { keyPath: ["userId"] });
	
	    // Make account data store, clobber based on event type.
	    // (event.type property of MatrixEvent objects)
	    db.createObjectStore("accountData", { keyPath: ["type"] });
	
	    // Make /sync store (sync tokens, room data, etc), always clobber (const key).
	    db.createObjectStore("sync", { keyPath: ["clobber"] });
	}
	
	/**
	 * Helper method to collect results from a Cursor and promiseify it.
	 * @param {ObjectStore|Index} store The store to perform openCursor on.
	 * @param {IDBKeyRange=} keyRange Optional key range to apply on the cursor.
	 * @param {Function} resultMapper A function which is repeatedly called with a
	 * Cursor.
	 * Return the data you want to keep.
	 * @return {Promise<T[]>} Resolves to an array of whatever you returned from
	 * resultMapper.
	 */
	function selectQuery(store, keyRange, resultMapper) {
	    var query = store.openCursor(keyRange);
	    return _q2.default.Promise(function (resolve, reject) {
	        /*eslint new-cap: 0*/
	        var results = [];
	        query.onerror = function (event) {
	            reject(new Error("Query failed: " + event.target.errorCode));
	        };
	        // collect results
	        query.onsuccess = function (event) {
	            var cursor = event.target.result;
	            if (!cursor) {
	                resolve(results);
	                return; // end of results
	            }
	            results.push(resultMapper(cursor));
	            cursor.continue();
	        };
	    });
	}
	
	function promiseifyTxn(txn) {
	    return new _q2.default.Promise(function (resolve, reject) {
	        txn.oncomplete = function (event) {
	            resolve(event);
	        };
	        txn.onerror = function (event) {
	            reject(event);
	        };
	    });
	}
	
	function promiseifyRequest(req) {
	    return new _q2.default.Promise(function (resolve, reject) {
	        req.onsuccess = function (event) {
	            resolve(event);
	        };
	        req.onerror = function (event) {
	            reject(event);
	        };
	    });
	}
	
	/**
	 * Does the actual reading from and writing to the indexeddb
	 *
	 * Construct a new Indexed Database store backend. This requires a call to
	 * <code>connect()</code> before this store can be used.
	 * @constructor
	 * @param {Object} indexedDBInterface The Indexed DB interface e.g
	 * <code>window.indexedDB</code>
	 * @param {string=} dbName Optional database name. The same name must be used
	 * to open the same database.
	 */
	var LocalIndexedDBStoreBackend = function LocalIndexedDBStoreBackend(indexedDBInterface, dbName) {
	    this.indexedDB = indexedDBInterface;
	    this._dbName = "matrix-js-sdk:" + (dbName || "default");
	    this.db = null;
	    this._syncAccumulator = new _syncAccumulator2.default();
	};
	
	LocalIndexedDBStoreBackend.prototype = {
	    /**
	     * Attempt to connect to the database. This can fail if the user does not
	     * grant permission.
	     * @return {Promise} Resolves if successfully connected.
	     */
	    connect: function connect() {
	        var _this = this;
	
	        if (this.db) {
	            return (0, _q2.default)();
	        }
	        var req = this.indexedDB.open(this._dbName, VERSION);
	        req.onupgradeneeded = function (ev) {
	            var db = ev.target.result;
	            var oldVersion = ev.oldVersion;
	            if (oldVersion < 1) {
	                // The database did not previously exist.
	                createDatabase(db);
	            }
	            // Expand as needed.
	        };
	
	        return promiseifyRequest(req).then(function (ev) {
	            _this.db = ev.target.result;
	
	            // add a poorly-named listener for when deleteDatabase is called
	            // so we can close our db connections.
	            _this.db.onversionchange = function () {
	                _this.db.close();
	            };
	
	            return _this._init();
	        });
	    },
	
	    /**
	     * Having connected, load initial data from the database and prepare for use
	     * @return {Promise} Resolves on success
	     */
	    _init: function _init() {
	        var _this2 = this;
	
	        return _q2.default.all([this._loadAccountData(), this._loadSyncData()]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                accountData = _ref2[0],
	                syncData = _ref2[1];
	
	            _this2._syncAccumulator.accumulate({
	                next_batch: syncData.nextBatch,
	                rooms: syncData.roomsData,
	                account_data: {
	                    events: accountData
	                }
	            });
	        });
	    },
	
	    /**
	     * Clear the entire database. This should be used when logging out of a client
	     * to prevent mixing data between accounts.
	     * @return {Promise} Resolved when the database is cleared.
	     */
	    clearDatabase: function clearDatabase() {
	        console.log("Removing indexeddb instance: ", this._dbName);
	        return promiseifyRequest(this.indexedDB.deleteDatabase(this._dbName));
	    },
	
	    /**
	     * @param {boolean=} copy If false, the data returned is from internal
	     * buffers and must not be muated. Otherwise, a copy is made before
	     * returning such that the data can be safely mutated. Default: true.
	     *
	     * @return {Promise} Resolves with a sync response to restore the
	     * client state to where it was at the last save, or null if there
	     * is no saved sync data.
	     */
	    getSavedSync: function getSavedSync(copy) {
	        if (copy === undefined) copy = true;
	
	        var data = this._syncAccumulator.getJSON();
	        if (!data.nextBatch) return (0, _q2.default)(null);
	        if (copy) {
	            // We must deep copy the stored data so that the /sync processing code doesn't
	            // corrupt the internal state of the sync accumulator (it adds non-clonable keys)
	            return (0, _q2.default)(_utils2.default.deepCopy(data));
	        } else {
	            return (0, _q2.default)(data);
	        }
	    },
	
	    setSyncData: function setSyncData(syncData) {
	        var _this3 = this;
	
	        return (0, _q2.default)().then(function () {
	            _this3._syncAccumulator.accumulate(syncData);
	        });
	    },
	
	    syncToDatabase: function syncToDatabase(userTuples) {
	        var syncData = this._syncAccumulator.getJSON();
	
	        return _q2.default.all([this._persistUserPresenceEvents(userTuples), this._persistAccountData(syncData.accountData), this._persistSyncData(syncData.nextBatch, syncData.roomsData)]);
	    },
	
	    /**
	     * Persist rooms /sync data along with the next batch token.
	     * @param {string} nextBatch The next_batch /sync value.
	     * @param {Object} roomsData The 'rooms' /sync data from a SyncAccumulator
	     * @return {Promise} Resolves if the data was persisted.
	     */
	    _persistSyncData: function _persistSyncData(nextBatch, roomsData) {
	        var _this4 = this;
	
	        console.log("Persisting sync data up to ", nextBatch);
	        return _q2.default.try(function () {
	            var txn = _this4.db.transaction(["sync"], "readwrite");
	            var store = txn.objectStore("sync");
	            store.put({
	                clobber: "-", // constant key so will always clobber
	                nextBatch: nextBatch,
	                roomsData: roomsData
	            }); // put == UPSERT
	            return promiseifyTxn(txn);
	        });
	    },
	
	    /**
	     * Persist a list of account data events. Events with the same 'type' will
	     * be replaced.
	     * @param {Object[]} accountData An array of raw user-scoped account data events
	     * @return {Promise} Resolves if the events were persisted.
	     */
	    _persistAccountData: function _persistAccountData(accountData) {
	        var _this5 = this;
	
	        return _q2.default.try(function () {
	            var txn = _this5.db.transaction(["accountData"], "readwrite");
	            var store = txn.objectStore("accountData");
	            for (var i = 0; i < accountData.length; i++) {
	                store.put(accountData[i]); // put == UPSERT
	            }
	            return promiseifyTxn(txn);
	        });
	    },
	
	    /**
	     * Persist a list of [user id, presence event] they are for.
	     * Users with the same 'userId' will be replaced.
	     * Presence events should be the event in its raw form (not the Event
	     * object)
	     * @param {Object[]} tuples An array of [userid, event] tuples
	     * @return {Promise} Resolves if the users were persisted.
	     */
	    _persistUserPresenceEvents: function _persistUserPresenceEvents(tuples) {
	        var _this6 = this;
	
	        return _q2.default.try(function () {
	            var txn = _this6.db.transaction(["users"], "readwrite");
	            var store = txn.objectStore("users");
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = tuples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var tuple = _step.value;
	
	                    store.put({
	                        userId: tuple[0],
	                        event: tuple[1]
	                    }); // put == UPSERT
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return promiseifyTxn(txn);
	        });
	    },
	
	    /**
	     * Load all user presence events from the database. This is not cached.
	     * FIXME: It would probably be more sensible to store the events in the
	     * sync.
	     * @return {Promise<Object[]>} A list of presence events in their raw form.
	     */
	    getUserPresenceEvents: function getUserPresenceEvents() {
	        var _this7 = this;
	
	        return _q2.default.try(function () {
	            var txn = _this7.db.transaction(["users"], "readonly");
	            var store = txn.objectStore("users");
	            return selectQuery(store, undefined, function (cursor) {
	                return [cursor.value.userId, cursor.value.event];
	            });
	        });
	    },
	
	    /**
	     * Load all the account data events from the database. This is not cached.
	     * @return {Promise<Object[]>} A list of raw global account events.
	     */
	    _loadAccountData: function _loadAccountData() {
	        var _this8 = this;
	
	        return _q2.default.try(function () {
	            var txn = _this8.db.transaction(["accountData"], "readonly");
	            var store = txn.objectStore("accountData");
	            return selectQuery(store, undefined, function (cursor) {
	                return cursor.value;
	            });
	        });
	    },
	
	    /**
	     * Load the sync data from the database.
	     * @return {Promise<Object>} An object with "roomsData" and "nextBatch" keys.
	     */
	    _loadSyncData: function _loadSyncData() {
	        var _this9 = this;
	
	        return _q2.default.try(function () {
	            var txn = _this9.db.transaction(["sync"], "readonly");
	            var store = txn.objectStore("sync");
	            return selectQuery(store, undefined, function (cursor) {
	                return cursor.value;
	            }).then(function (results) {
	                if (results.length > 1) {
	                    console.warn("loadSyncData: More than 1 sync row found.");
	                }
	                return results.length > 0 ? results[0] : {};
	            });
	        });
	    }
	};
	
	exports.default = LocalIndexedDBStoreBackend;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	module.exports = {
	    formatDate: function formatDate(date) {
	        // date.toLocaleTimeString is completely system dependent.
	        // just go 24h for now
	        function pad(n) {
	            return (n < 10 ? '0' : '') + n;
	        }
	
	        var now = new Date();
	        if (date.toDateString() === now.toDateString()) {
	            return pad(date.getHours()) + ':' + pad(date.getMinutes());
	        } else if (now.getTime() - date.getTime() < 6 * 24 * 60 * 60 * 1000) {
	            return days[date.getDay()] + " " + pad(date.getHours()) + ':' + pad(date.getMinutes());
	        } else /* if (now.getFullYear() === date.getFullYear()) */{
	                return days[date.getDay()] + ", " + months[date.getMonth()] + " " + date.getDate() + " " + pad(date.getHours()) + ':' + pad(date.getMinutes());
	            }
	        /*
	        else {
	            return days[date.getDay()] + ", " + months[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear() + " " + pad(date.getHours()) + ':' + pad(date.getMinutes());
	        }
	        */
	    },
	
	    formatTime: function formatTime(date) {
	        //return pad(date.getHours()) + ':' + pad(date.getMinutes());
	        return ('00' + date.getHours()).slice(-2) + ':' + ('00' + date.getMinutes()).slice(-2);
	    }
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _matrixJsSdk = __webpack_require__(28);
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	var sdk = __webpack_require__(2);
	var Modal = __webpack_require__(10);
	
	
	module.exports = {
	    resendUnsentEvents: function resendUnsentEvents(room) {
	        room.getPendingEvents().filter(function (ev) {
	            return ev.status === _matrixJsSdk.EventStatus.NOT_SENT;
	        }).forEach(function (event) {
	            module.exports.resend(event);
	        });
	    },
	    cancelUnsentEvents: function cancelUnsentEvents(room) {
	        room.getPendingEvents().filter(function (ev) {
	            return ev.status === _matrixJsSdk.EventStatus.NOT_SENT;
	        }).forEach(function (event) {
	            module.exports.removeFromQueue(event);
	        });
	    },
	    resend: function resend(event) {
	        var room = MatrixClientPeg.get().getRoom(event.getRoomId());
	        MatrixClientPeg.get().resendEvent(event, room).done(function (res) {
	            dis.dispatch({
	                action: 'message_sent',
	                event: event
	            });
	        }, function (err) {
	            // XXX: temporary logging to try to diagnose
	            // https://github.com/vector-im/riot-web/issues/3148
	            console.log('Resend got send failure: ' + err.name + '(' + err + ')');
	            if (err.name === "UnknownDeviceError") {
	                dis.dispatch({
	                    action: 'unknown_device_error',
	                    err: err,
	                    room: room
	                });
	            }
	
	            dis.dispatch({
	                action: 'message_send_failed',
	                event: event
	            });
	        });
	    },
	    removeFromQueue: function removeFromQueue(event) {
	        MatrixClientPeg.get().cancelPendingEvent(event);
	        dis.dispatch({
	            action: 'message_send_cancelled',
	            event: event
	        });
	    }
	};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MUTE = exports.MENTIONS_ONLY = exports.ALL_MESSAGES = exports.ALL_MESSAGES_LOUD = undefined;
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.getRoomNotifsState = getRoomNotifsState;
	exports.setRoomNotifsState = setRoomNotifsState;
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _pushprocessor = __webpack_require__(492);
	
	var _pushprocessor2 = _interopRequireDefault(_pushprocessor);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALL_MESSAGES_LOUD = exports.ALL_MESSAGES_LOUD = 'all_messages_loud'; /*
	                                                                         Copyright 2016 OpenMarket Ltd
	                                                                         
	                                                                         Licensed under the Apache License, Version 2.0 (the "License");
	                                                                         you may not use this file except in compliance with the License.
	                                                                         You may obtain a copy of the License at
	                                                                         
	                                                                             http://www.apache.org/licenses/LICENSE-2.0
	                                                                         
	                                                                         Unless required by applicable law or agreed to in writing, software
	                                                                         distributed under the License is distributed on an "AS IS" BASIS,
	                                                                         WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                         See the License for the specific language governing permissions and
	                                                                         limitations under the License.
	                                                                         */
	
	var ALL_MESSAGES = exports.ALL_MESSAGES = 'all_messages';
	var MENTIONS_ONLY = exports.MENTIONS_ONLY = 'mentions_only';
	var MUTE = exports.MUTE = 'mute';
	
	function getRoomNotifsState(roomId) {
	    if (_MatrixClientPeg2.default.get().isGuest()) return ALL_MESSAGES;
	
	    // look through the override rules for a rule affecting this room:
	    // if one exists, it will take precedence.
	    var muteRule = findOverrideMuteRule(roomId);
	    if (muteRule) {
	        return MUTE;
	    }
	
	    // for everything else, look at the room rule.
	    var roomRule = _MatrixClientPeg2.default.get().getRoomPushRule('global', roomId);
	
	    // XXX: We have to assume the default is to notify for all messages
	    // (in particular this will be 'wrong' for one to one rooms because
	    // they will notify loudly for all messages)
	    if (!roomRule || !roomRule.enabled) return ALL_MESSAGES;
	
	    // a mute at the room level will still allow mentions
	    // to notify
	    if (isMuteRule(roomRule)) return MENTIONS_ONLY;
	
	    var actionsObject = _pushprocessor2.default.actionListToActionsObject(roomRule.actions);
	    if (actionsObject.tweaks.sound) return ALL_MESSAGES_LOUD;
	
	    return null;
	}
	
	function setRoomNotifsState(roomId, newState) {
	    if (newState == MUTE) {
	        return setRoomNotifsStateMuted(roomId);
	    } else {
	        return setRoomNotifsStateUnmuted(roomId, newState);
	    }
	}
	
	function setRoomNotifsStateMuted(roomId) {
	    var cli = _MatrixClientPeg2.default.get();
	    var promises = [];
	
	    // delete the room rule
	    var roomRule = cli.getRoomPushRule('global', roomId);
	    if (roomRule) {
	        promises.push(cli.deletePushRule('global', 'room', roomRule.rule_id));
	    }
	
	    // add/replace an override rule to squelch everything in this room
	    // NB. We use the room ID as the name of this rule too, although this
	    // is an override rule, not a room rule: it still pertains to this room
	    // though, so using the room ID as the rule ID is logical and prevents
	    // duplicate copies of the rule.
	    promises.push(cli.addPushRule('global', 'override', roomId, {
	        conditions: [{
	            kind: 'event_match',
	            key: 'room_id',
	            pattern: roomId
	        }],
	        actions: ['dont_notify']
	    }));
	
	    return _q2.default.all(promises);
	}
	
	function setRoomNotifsStateUnmuted(roomId, newState) {
	    var cli = _MatrixClientPeg2.default.get();
	    var promises = [];
	
	    var overrideMuteRule = findOverrideMuteRule(roomId);
	    if (overrideMuteRule) {
	        promises.push(cli.deletePushRule('global', 'override', overrideMuteRule.rule_id));
	    }
	
	    if (newState == 'all_messages') {
	        var roomRule = cli.getRoomPushRule('global', roomId);
	        if (roomRule) {
	            promises.push(cli.deletePushRule('global', 'room', roomRule.rule_id));
	        }
	    } else if (newState == 'mentions_only') {
	        promises.push(cli.addPushRule('global', 'room', roomId, {
	            actions: ['dont_notify']
	        }));
	        // https://matrix.org/jira/browse/SPEC-400
	        promises.push(cli.setPushRuleEnabled('global', 'room', roomId, true));
	    } else if ('all_messages_loud') {
	        promises.push(cli.addPushRule('global', 'room', roomId, {
	            actions: ['notify', {
	                set_tweak: 'sound',
	                value: 'default'
	            }]
	        }));
	        // https://matrix.org/jira/browse/SPEC-400
	        promises.push(cli.setPushRuleEnabled('global', 'room', roomId, true));
	    }
	
	    return _q2.default.all(promises);
	}
	
	function findOverrideMuteRule(roomId) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)(_MatrixClientPeg2.default.get().pushRules['global'].override), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var rule = _step.value;
	
	            if (isRuleForRoom(roomId, rule)) {
	                if (isMuteRule(rule) && rule.enabled) {
	                    return rule;
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return null;
	}
	
	function isRuleForRoom(roomId, rule) {
	    if (rule.conditions.length !== 1) {
	        return false;
	    }
	    var cond = rule.conditions[0];
	    if (cond.kind == 'event_match' && cond.key == 'room_id' && cond.pattern == roomId) {
	        return true;
	    }
	    return false;
	}
	
	function isMuteRule(rule) {
	    return rule.actions.length == 1 && rule.actions[0] == 'dont_notify';
	}


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	var Tinter = __webpack_require__(140);
	
	var Command = function () {
	    function Command(name, paramArgs, runFn) {
	        (0, _classCallCheck3.default)(this, Command);
	
	        this.name = name;
	        this.paramArgs = paramArgs;
	        this.runFn = runFn;
	    }
	
	    (0, _createClass3.default)(Command, [{
	        key: "getCommand",
	        value: function getCommand() {
	            return "/" + this.name;
	        }
	    }, {
	        key: "getCommandWithArgs",
	        value: function getCommandWithArgs() {
	            return this.getCommand() + " " + this.paramArgs;
	        }
	    }, {
	        key: "run",
	        value: function run(roomId, args) {
	            return this.runFn.bind(this)(roomId, args);
	        }
	    }, {
	        key: "getUsage",
	        value: function getUsage() {
	            return "Usage: " + this.getCommandWithArgs();
	        }
	    }]);
	    return Command;
	}();
	
	var reject = function reject(msg) {
	    return {
	        error: msg
	    };
	};
	
	var success = function success(promise) {
	    return {
	        promise: promise
	    };
	};
	
	var commands = {
	    ddg: new Command("ddg", "<query>", function (roomId, args) {
	        var ErrorDialog = _index2.default.getComponent('dialogs.ErrorDialog');
	        // TODO Don't explain this away, actually show a search UI here.
	        _Modal2.default.createDialog(ErrorDialog, {
	            title: "/ddg is not a command",
	            description: "To use it, just wait for autocomplete results to load and tab through them."
	        });
	        return success();
	    }),
	
	    // Change your nickname
	    nick: new Command("nick", "<display_name>", function (room_id, args) {
	        if (args) {
	            return success(MatrixClientPeg.get().setDisplayName(args));
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Changes the colorscheme of your current room
	    tint: new Command("tint", "<color1> [<color2>]", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}))( +(#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})))?$/);
	            if (matches) {
	                Tinter.tint(matches[1], matches[4]);
	                var colorScheme = {};
	                colorScheme.primary_color = matches[1];
	                if (matches[4]) {
	                    colorScheme.secondary_color = matches[4];
	                }
	                return success(MatrixClientPeg.get().setRoomAccountData(room_id, "org.matrix.room.color_scheme", colorScheme));
	            }
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Change the room topic
	    topic: new Command("topic", "<topic>", function (room_id, args) {
	        if (args) {
	            return success(MatrixClientPeg.get().setRoomTopic(room_id, args));
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Invite a user
	    invite: new Command("invite", "<userId>", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(\S+)$/);
	            if (matches) {
	                return success(MatrixClientPeg.get().invite(room_id, matches[1]));
	            }
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Join a room
	    join: new Command("join", "#alias:domain", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(\S+)$/);
	            if (matches) {
	                var room_alias = matches[1];
	                if (room_alias[0] !== '#') {
	                    return reject(this.getUsage());
	                }
	                if (!room_alias.match(/:/)) {
	                    room_alias += ':' + MatrixClientPeg.get().getDomain();
	                }
	
	                dis.dispatch({
	                    action: 'view_room',
	                    room_alias: room_alias,
	                    auto_join: true
	                });
	
	                return success();
	            }
	        }
	        return reject(this.getUsage());
	    }),
	
	    part: new Command("part", "[#alias:domain]", function (room_id, args) {
	        var targetRoomId;
	        if (args) {
	            var matches = args.match(/^(\S+)$/);
	            if (matches) {
	                var room_alias = matches[1];
	                if (room_alias[0] !== '#') {
	                    return reject(this.getUsage());
	                }
	                if (!room_alias.match(/:/)) {
	                    room_alias += ':' + MatrixClientPeg.get().getDomain();
	                }
	
	                // Try to find a room with this alias
	                var rooms = MatrixClientPeg.get().getRooms();
	                for (var i = 0; i < rooms.length; i++) {
	                    var aliasEvents = rooms[i].currentState.getStateEvents("m.room.aliases");
	                    for (var j = 0; j < aliasEvents.length; j++) {
	                        var aliases = aliasEvents[j].getContent().aliases || [];
	                        for (var k = 0; k < aliases.length; k++) {
	                            if (aliases[k] === room_alias) {
	                                targetRoomId = rooms[i].roomId;
	                                break;
	                            }
	                        }
	                        if (targetRoomId) {
	                            break;
	                        }
	                    }
	                    if (targetRoomId) {
	                        break;
	                    }
	                }
	            }
	            if (!targetRoomId) {
	                return reject("Unrecognised room alias: " + room_alias);
	            }
	        }
	        if (!targetRoomId) targetRoomId = room_id;
	        return success(MatrixClientPeg.get().leave(targetRoomId).then(function () {
	            dis.dispatch({ action: 'view_next_room' });
	        }));
	    }),
	
	    // Kick a user from the room with an optional reason
	    kick: new Command("kick", "<userId> [<reason>]", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(\S+?)( +(.*))?$/);
	            if (matches) {
	                return success(MatrixClientPeg.get().kick(room_id, matches[1], matches[3]));
	            }
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Ban a user from the room with an optional reason
	    ban: new Command("ban", "<userId> [<reason>]", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(\S+?)( +(.*))?$/);
	            if (matches) {
	                return success(MatrixClientPeg.get().ban(room_id, matches[1], matches[3]));
	            }
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Unban a user from the room
	    unban: new Command("unban", "<userId>", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(\S+)$/);
	            if (matches) {
	                // Reset the user membership to "leave" to unban him
	                return success(MatrixClientPeg.get().unban(room_id, matches[1]));
	            }
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Define the power level of a user
	    op: new Command("op", "<userId> [<power level>]", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(\S+?)( +(\d+))?$/);
	            var powerLevel = 50; // default power level for op
	            if (matches) {
	                var user_id = matches[1];
	                if (matches.length === 4 && undefined !== matches[3]) {
	                    powerLevel = parseInt(matches[3]);
	                }
	                if (powerLevel !== NaN) {
	                    var room = MatrixClientPeg.get().getRoom(room_id);
	                    if (!room) {
	                        return reject("Bad room ID: " + room_id);
	                    }
	                    var powerLevelEvent = room.currentState.getStateEvents("m.room.power_levels", "");
	                    return success(MatrixClientPeg.get().setPowerLevel(room_id, user_id, powerLevel, powerLevelEvent));
	                }
	            }
	        }
	        return reject(this.getUsage());
	    }),
	
	    // Reset the power level of a user
	    deop: new Command("deop", "<userId>", function (room_id, args) {
	        if (args) {
	            var matches = args.match(/^(\S+)$/);
	            if (matches) {
	                var room = MatrixClientPeg.get().getRoom(room_id);
	                if (!room) {
	                    return reject("Bad room ID: " + room_id);
	                }
	
	                var powerLevelEvent = room.currentState.getStateEvents("m.room.power_levels", "");
	                return success(MatrixClientPeg.get().setPowerLevel(room_id, args, undefined, powerLevelEvent));
	            }
	        }
	        return reject(this.getUsage());
	    })
	};
	
	// helpful aliases
	var aliases = {
	    j: "join"
	};
	
	module.exports = {
	    /**
	     * Process the given text for /commands and perform them.
	     * @param {string} roomId The room in which the command was performed.
	     * @param {string} input The raw text input by the user.
	     * @return {Object|null} An object with the property 'error' if there was an error
	     * processing the command, or 'promise' if a request was sent out.
	     * Returns null if the input didn't match a command.
	     */
	    processInput: function processInput(roomId, input) {
	        // trim any trailing whitespace, as it can confuse the parser for
	        // IRC-style commands
	        input = input.replace(/\s+$/, "");
	        if (input[0] === "/" && input[1] !== "/") {
	            var bits = input.match(/^(\S+?)( +((.|\n)*))?$/);
	            var cmd, args;
	            if (bits) {
	                cmd = bits[1].substring(1).toLowerCase();
	                args = bits[3];
	            } else {
	                cmd = input;
	            }
	            if (cmd === "me") return null;
	            if (aliases[cmd]) {
	                cmd = aliases[cmd];
	            }
	            if (commands[cmd]) {
	                return commands[cmd].run(roomId, args);
	            } else {
	                return reject("Unrecognised command: " + input);
	            }
	        }
	        return null; // not a command
	    },
	
	    getCommandList: function getCommandList() {
	        // Return all the commands plus /me and /markdown which aren't handled like normal commands
	        var cmds = (0, _keys2.default)(commands).sort().map(function (cmdKey) {
	            return commands[cmdKey];
	        });
	        cmds.push(new Command("me", "<action>", function () {}));
	        cmds.push(new Command("markdown", "<on|off>", function () {}));
	
	        return cmds;
	    }
	};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var sdk = __webpack_require__(2);
	
	var Entry = function () {
	    function Entry(text) {
	        (0, _classCallCheck3.default)(this, Entry);
	
	        this.text = text;
	    }
	
	    /**
	     * @return {string} The text to display in this entry.
	     */
	
	
	    (0, _createClass3.default)(Entry, [{
	        key: "getText",
	        value: function getText() {
	            return this.text;
	        }
	
	        /**
	         * @return {string} The text to insert into the input box. Most of the time
	         * this is the same as getText().
	         */
	
	    }, {
	        key: "getFillText",
	        value: function getFillText() {
	            return this.text;
	        }
	
	        /**
	         * @return {ReactClass} Raw JSX
	         */
	
	    }, {
	        key: "getImageJsx",
	        value: function getImageJsx() {
	            return null;
	        }
	
	        /**
	         * @return {?string} The unique key= prop for React dedupe
	         */
	
	    }, {
	        key: "getKey",
	        value: function getKey() {
	            return null;
	        }
	
	        /**
	         * @return {?string} The suffix to append to the tab-complete, or null to
	         * not do this.
	         */
	
	    }, {
	        key: "getSuffix",
	        value: function getSuffix(isFirstWord) {
	            return null;
	        }
	
	        /**
	         * Called when this entry is clicked.
	         */
	
	    }, {
	        key: "onClick",
	        value: function onClick() {
	            // NOP
	        }
	    }]);
	    return Entry;
	}();
	
	var CommandEntry = function (_Entry) {
	    (0, _inherits3.default)(CommandEntry, _Entry);
	
	    function CommandEntry(cmd, cmdWithArgs) {
	        (0, _classCallCheck3.default)(this, CommandEntry);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CommandEntry.__proto__ || (0, _getPrototypeOf2.default)(CommandEntry)).call(this, cmdWithArgs));
	
	        _this.kind = 'command';
	        _this.cmd = cmd;
	        return _this;
	    }
	
	    (0, _createClass3.default)(CommandEntry, [{
	        key: "getFillText",
	        value: function getFillText() {
	            return this.cmd;
	        }
	    }, {
	        key: "getKey",
	        value: function getKey() {
	            return this.getFillText();
	        }
	    }, {
	        key: "getSuffix",
	        value: function getSuffix(isFirstWord) {
	            return " "; // force a space after the command.
	        }
	    }]);
	    return CommandEntry;
	}(Entry);
	
	CommandEntry.fromCommands = function (commandArray) {
	    return commandArray.map(function (cmd) {
	        return new CommandEntry(cmd.getCommand(), cmd.getCommandWithArgs());
	    });
	};
	
	var MemberEntry = function (_Entry2) {
	    (0, _inherits3.default)(MemberEntry, _Entry2);
	
	    function MemberEntry(member) {
	        (0, _classCallCheck3.default)(this, MemberEntry);
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (MemberEntry.__proto__ || (0, _getPrototypeOf2.default)(MemberEntry)).call(this, (member.name || member.userId).replace(' (IRC)', '')));
	
	        _this2.member = member;
	        _this2.kind = 'member';
	        return _this2;
	    }
	
	    (0, _createClass3.default)(MemberEntry, [{
	        key: "getImageJsx",
	        value: function getImageJsx() {
	            var MemberAvatar = sdk.getComponent("views.avatars.MemberAvatar");
	            return React.createElement(MemberAvatar, { member: this.member, width: 24, height: 24 });
	        }
	    }, {
	        key: "getKey",
	        value: function getKey() {
	            return this.member.userId;
	        }
	    }, {
	        key: "getSuffix",
	        value: function getSuffix(isFirstWord) {
	            return isFirstWord ? ": " : " ";
	        }
	    }]);
	    return MemberEntry;
	}(Entry);
	
	MemberEntry.fromMemberList = function (members) {
	    return members.map(function (m) {
	        return new MemberEntry(m);
	    });
	};
	
	module.exports.Entry = Entry;
	module.exports.MemberEntry = MemberEntry;
	module.exports.CommandEntry = CommandEntry;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	var CallHandler = __webpack_require__(73);
	
	function textForMemberEvent(ev) {
	    // XXX: SYJS-16 "sender is sometimes null for join messages"
	    var senderName = ev.sender ? ev.sender.name : ev.getSender();
	    var targetName = ev.target ? ev.target.name : ev.getStateKey();
	    var ConferenceHandler = CallHandler.getConferenceHandler();
	    var reason = ev.getContent().reason ? " Reason: " + ev.getContent().reason : "";
	    switch (ev.getContent().membership) {
	        case 'invite':
	            var threePidContent = ev.getContent().third_party_invite;
	            if (threePidContent) {
	                if (threePidContent.display_name) {
	                    return targetName + " accepted the invitation for " + threePidContent.display_name + ".";
	                } else {
	                    return targetName + " accepted an invitation.";
	                }
	            } else {
	                if (ConferenceHandler && ConferenceHandler.isConferenceUser(ev.getStateKey())) {
	                    return senderName + " requested a VoIP conference";
	                } else {
	                    return senderName + " invited " + targetName + ".";
	                }
	            }
	        case 'ban':
	            return senderName + " banned " + targetName + "." + reason;
	        case 'join':
	            if (ev.getPrevContent() && ev.getPrevContent().membership == 'join') {
	                if (ev.getPrevContent().displayname && ev.getContent().displayname && ev.getPrevContent().displayname != ev.getContent().displayname) {
	                    return ev.getSender() + " changed their display name from " + ev.getPrevContent().displayname + " to " + ev.getContent().displayname;
	                } else if (!ev.getPrevContent().displayname && ev.getContent().displayname) {
	                    return ev.getSender() + " set their display name to " + ev.getContent().displayname;
	                } else if (ev.getPrevContent().displayname && !ev.getContent().displayname) {
	                    return ev.getSender() + " removed their display name (" + ev.getPrevContent().displayname + ")";
	                } else if (ev.getPrevContent().avatar_url && !ev.getContent().avatar_url) {
	                    return senderName + " removed their profile picture";
	                } else if (ev.getPrevContent().avatar_url && ev.getContent().avatar_url && ev.getPrevContent().avatar_url != ev.getContent().avatar_url) {
	                    return senderName + " changed their profile picture";
	                } else if (!ev.getPrevContent().avatar_url && ev.getContent().avatar_url) {
	                    return senderName + " set a profile picture";
	                } else {
	                    // hacky hack for https://github.com/vector-im/vector-web/issues/2020
	                    return senderName + " rejoined the room.";
	                }
	            } else {
	                if (!ev.target) console.warn("Join message has no target! -- " + ev.getContent().state_key);
	                if (ConferenceHandler && ConferenceHandler.isConferenceUser(ev.getStateKey())) {
	                    return "VoIP conference started";
	                } else {
	                    return targetName + " joined the room.";
	                }
	            }
	        case 'leave':
	            if (ev.getSender() === ev.getStateKey()) {
	                if (ConferenceHandler && ConferenceHandler.isConferenceUser(ev.getStateKey())) {
	                    return "VoIP conference finished";
	                } else if (ev.getPrevContent().membership === "invite") {
	                    return targetName + " rejected the invitation.";
	                } else {
	                    return targetName + " left the room.";
	                }
	            } else if (ev.getPrevContent().membership === "ban") {
	                return senderName + " unbanned " + targetName + ".";
	            } else if (ev.getPrevContent().membership === "join") {
	                return senderName + " kicked " + targetName + "." + reason;
	            } else if (ev.getPrevContent().membership === "invite") {
	                return senderName + " withdrew " + targetName + "'s invitation." + reason;
	            } else {
	                return targetName + " left the room.";
	            }
	    }
	}
	
	function textForTopicEvent(ev) {
	    var senderDisplayName = ev.sender && ev.sender.name ? ev.sender.name : ev.getSender();
	
	    return senderDisplayName + ' changed the topic to "' + ev.getContent().topic + '"';
	}
	
	function textForRoomNameEvent(ev) {
	    var senderDisplayName = ev.sender && ev.sender.name ? ev.sender.name : ev.getSender();
	
	    return senderDisplayName + ' changed the room name to "' + ev.getContent().name + '"';
	}
	
	function textForMessageEvent(ev) {
	    var senderDisplayName = ev.sender && ev.sender.name ? ev.sender.name : ev.getSender();
	    var message = senderDisplayName + ': ' + ev.getContent().body;
	    if (ev.getContent().msgtype === "m.emote") {
	        message = "* " + senderDisplayName + " " + message;
	    } else if (ev.getContent().msgtype === "m.image") {
	        message = senderDisplayName + " sent an image.";
	    }
	    return message;
	}
	
	function textForCallAnswerEvent(event) {
	    var senderName = event.sender ? event.sender.name : "Someone";
	    var supported = MatrixClientPeg.get().supportsVoip() ? "" : " (not supported by this browser)";
	    return senderName + " answered the call." + supported;
	}
	
	function textForCallHangupEvent(event) {
	    var senderName = event.sender ? event.sender.name : "Someone";
	    var supported = MatrixClientPeg.get().supportsVoip() ? "" : " (not supported by this browser)";
	    return senderName + " ended the call." + supported;
	}
	
	function textForCallInviteEvent(event) {
	    var senderName = event.sender ? event.sender.name : "Someone";
	    // FIXME: Find a better way to determine this from the event?
	    var type = "voice";
	    if (event.getContent().offer && event.getContent().offer.sdp && event.getContent().offer.sdp.indexOf('m=video') !== -1) {
	        type = "video";
	    }
	    var supported = MatrixClientPeg.get().supportsVoip() ? "" : " (not supported by this browser)";
	    return senderName + " placed a " + type + " call." + supported;
	}
	
	function textForThreePidInviteEvent(event) {
	    var senderName = event.sender ? event.sender.name : event.getSender();
	    return senderName + " sent an invitation to " + event.getContent().display_name + " to join the room.";
	}
	
	function textForHistoryVisibilityEvent(event) {
	    var senderName = event.sender ? event.sender.name : event.getSender();
	    var vis = event.getContent().history_visibility;
	    var text = senderName + " made future room history visible to ";
	    if (vis === "invited") {
	        text += "all room members, from the point they are invited.";
	    } else if (vis === "joined") {
	        text += "all room members, from the point they joined.";
	    } else if (vis === "shared") {
	        text += "all room members.";
	    } else if (vis === "world_readable") {
	        text += "anyone.";
	    } else {
	        text += " unknown (" + vis + ")";
	    }
	    return text;
	}
	
	function textForEncryptionEvent(event) {
	    var senderName = event.sender ? event.sender.name : event.getSender();
	    return senderName + " turned on end-to-end encryption (algorithm " + event.getContent().algorithm + ")";
	}
	
	var handlers = {
	    'm.room.message': textForMessageEvent,
	    'm.room.name': textForRoomNameEvent,
	    'm.room.topic': textForTopicEvent,
	    'm.room.member': textForMemberEvent,
	    'm.call.invite': textForCallInviteEvent,
	    'm.call.answer': textForCallAnswerEvent,
	    'm.call.hangup': textForCallHangupEvent,
	    'm.room.third_party_invite': textForThreePidInviteEvent,
	    'm.room.history_visibility': textForHistoryVisibilityEvent,
	    'm.room.encryption': textForEncryptionEvent
	};
	
	module.exports = {
	    textForEvent: function textForEvent(ev) {
	        var hdlr = handlers[ev.getType()];
	        if (!hdlr) return "";
	        return hdlr(ev);
	    }
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var dis = __webpack_require__(5);
	
	var MIN_DISPATCH_INTERVAL_MS = 500;
	var CURRENTLY_ACTIVE_THRESHOLD_MS = 2000;
	
	/**
	 * This class watches for user activity (moving the mouse or pressing a key)
	 * and dispatches the user_activity action at times when the user is interacting
	 * with the app (but at a much lower frequency than mouse move events)
	 */
	
	var UserActivity = function () {
	    function UserActivity() {
	        (0, _classCallCheck3.default)(this, UserActivity);
	    }
	
	    (0, _createClass3.default)(UserActivity, [{
	        key: 'start',
	
	
	        /**
	         * Start listening to user activity
	         */
	        value: function start() {
	            document.onmousedown = this._onUserActivity.bind(this);
	            document.onmousemove = this._onUserActivity.bind(this);
	            document.onkeypress = this._onUserActivity.bind(this);
	            // can't use document.scroll here because that's only the document
	            // itself being scrolled. Need to use addEventListener's useCapture.
	            // also this needs to be the wheel event, not scroll, as scroll is
	            // fired when the view scrolls down for a new message.
	            window.addEventListener('wheel', this._onUserActivity.bind(this), { passive: true, capture: true });
	            this.lastActivityAtTs = new Date().getTime();
	            this.lastDispatchAtTs = 0;
	            this.activityEndTimer = undefined;
	        }
	
	        /**
	         * Stop tracking user activity
	         */
	
	    }, {
	        key: 'stop',
	        value: function stop() {
	            document.onmousedown = undefined;
	            document.onmousemove = undefined;
	            document.onkeypress = undefined;
	            window.removeEventListener('wheel', this._onUserActivity.bind(this), { passive: true, capture: true });
	        }
	
	        /**
	         * Return true if there has been user activity very recently
	         * (ie. within a few seconds)
	         */
	
	    }, {
	        key: 'userCurrentlyActive',
	        value: function userCurrentlyActive() {
	            return this.lastActivityAtTs > new Date().getTime() - CURRENTLY_ACTIVE_THRESHOLD_MS;
	        }
	    }, {
	        key: '_onUserActivity',
	        value: function _onUserActivity(event) {
	            if (event.screenX && event.type == "mousemove") {
	                if (event.screenX === this.lastScreenX && event.screenY === this.lastScreenY) {
	                    // mouse hasn't actually moved
	                    return;
	                }
	                this.lastScreenX = event.screenX;
	                this.lastScreenY = event.screenY;
	            }
	
	            this.lastActivityAtTs = new Date().getTime();
	            if (this.lastDispatchAtTs < this.lastActivityAtTs - MIN_DISPATCH_INTERVAL_MS) {
	                this.lastDispatchAtTs = this.lastActivityAtTs;
	                dis.dispatch({
	                    action: 'user_activity'
	                });
	                if (!this.activityEndTimer) {
	                    this.activityEndTimer = setTimeout(this._onActivityEndTimer.bind(this), MIN_DISPATCH_INTERVAL_MS);
	                }
	            }
	        }
	    }, {
	        key: '_onActivityEndTimer',
	        value: function _onActivityEndTimer() {
	            var now = new Date().getTime();
	            var targetTime = this.lastActivityAtTs + MIN_DISPATCH_INTERVAL_MS;
	            if (now >= targetTime) {
	                dis.dispatch({
	                    action: 'user_activity_end'
	                });
	                this.activityEndTimer = undefined;
	            } else {
	                this.activityEndTimer = setTimeout(this._onActivityEndTimer.bind(this), targetTime - now);
	            }
	        }
	    }]);
	    return UserActivity;
	}();
	
	module.exports = new UserActivity();


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCompletions = undefined;
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var getCompletions = exports.getCompletions = function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, selection) {
	        var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var completionsList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _q2.default.allSettled(PROVIDERS.map(function (provider) {
	                            return (0, _q2.default)(provider.getCompletions(query, selection, force)).timeout(PROVIDER_COMPLETION_TIMEOUT);
	                        }));
	
	                    case 2:
	                        completionsList = _context.sent;
	                        return _context.abrupt('return', completionsList.filter(function (completion) {
	                            return completion.state === "fulfilled";
	                        }).map(function (completionsState, i) {
	                            return {
	                                completions: completionsState.value,
	                                provider: PROVIDERS[i],
	
	                                /* the currently matched "command" the completer tried to complete
	                                 * we pass this through so that Autocomplete can figure out when to
	                                 * re-show itself once hidden.
	                                 */
	                                command: PROVIDERS[i].getCurrentCommand(query, selection, force)
	                            };
	                        }));
	
	                    case 4:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getCompletions(_x, _x2) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _CommandProvider = __webpack_require__(1168);
	
	var _CommandProvider2 = _interopRequireDefault(_CommandProvider);
	
	var _DuckDuckGoProvider = __webpack_require__(1169);
	
	var _DuckDuckGoProvider2 = _interopRequireDefault(_DuckDuckGoProvider);
	
	var _RoomProvider = __webpack_require__(1171);
	
	var _RoomProvider2 = _interopRequireDefault(_RoomProvider);
	
	var _UserProvider = __webpack_require__(508);
	
	var _UserProvider2 = _interopRequireDefault(_UserProvider);
	
	var _EmojiProvider = __webpack_require__(1170);
	
	var _EmojiProvider2 = _interopRequireDefault(_EmojiProvider);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PROVIDERS = [_UserProvider2.default, _RoomProvider2.default, _EmojiProvider2.default, _CommandProvider2.default, _DuckDuckGoProvider2.default].map(function (completer) {
	    return completer.getInstance();
	});
	
	// Providers will get rejected if they take longer than this.
	
	
	var PROVIDER_COMPLETION_TIMEOUT = 3000;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(96);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var Avatar = __webpack_require__(138);
	var sdk = __webpack_require__(2);
	var dispatcher = __webpack_require__(5);
	
	module.exports = React.createClass({
	    displayName: 'MemberAvatar',
	
	    propTypes: {
	        member: React.PropTypes.object.isRequired,
	        width: React.PropTypes.number,
	        height: React.PropTypes.number,
	        resizeMethod: React.PropTypes.string,
	        // The onClick to give the avatar
	        onClick: React.PropTypes.func,
	        // Whether the onClick of the avatar should be overriden to dispatch 'view_user'
	        viewUserOnClick: React.PropTypes.bool,
	        title: React.PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            width: 40,
	            height: 40,
	            resizeMethod: 'crop',
	            viewUserOnClick: false
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return this._getState(this.props);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setState(this._getState(nextProps));
	    },
	
	    _getState: function _getState(props) {
	        if (!props.member) {
	            console.error("MemberAvatar called somehow with null member");
	        }
	        return {
	            name: props.member.name,
	            title: props.title || props.member.userId,
	            imageUrl: Avatar.avatarUrlForMember(props.member, props.width, props.height, props.resizeMethod)
	        };
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var BaseAvatar = sdk.getComponent("avatars.BaseAvatar");
	
	        var _props = this.props,
	            member = _props.member,
	            onClick = _props.onClick,
	            viewUserOnClick = _props.viewUserOnClick,
	            otherProps = (0, _objectWithoutProperties3.default)(_props, ['member', 'onClick', 'viewUserOnClick']);
	
	
	        if (viewUserOnClick) {
	            onClick = function onClick() {
	                dispatcher.dispatch({
	                    action: 'view_user',
	                    member: _this.props.member
	                });
	            };
	        }
	
	        return React.createElement(BaseAvatar, (0, _extends3.default)({}, otherProps, { name: this.state.name, title: this.state.title,
	            idName: member.userId, url: this.state.imageUrl, onClick: onClick }));
	    }
	});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	
	/**
	 * A pure UI component which displays the HS and IS to use.
	 */
	module.exports = React.createClass({
	    displayName: 'ServerConfig',
	
	    propTypes: {
	        onHsUrlChanged: React.PropTypes.func,
	        onIsUrlChanged: React.PropTypes.func,
	
	        // default URLs are defined in config.json (or the hardcoded defaults)
	        // they are used if the user has not overridden them with a custom URL.
	        // In other words, if the custom URL is blank, the default is used.
	        defaultHsUrl: React.PropTypes.string, // e.g. https://matrix.org
	        defaultIsUrl: React.PropTypes.string, // e.g. https://vector.im
	
	        // custom URLs are explicitly provided by the user and override the
	        // default URLs.  The user enters them via the component's input fields,
	        // which is reflected on these properties whenever on..UrlChanged fires.
	        // They are persisted in localStorage by MatrixClientPeg, and so can
	        // override the default URLs when the component initially loads.
	        customHsUrl: React.PropTypes.string,
	        customIsUrl: React.PropTypes.string,
	
	        withToggleButton: React.PropTypes.bool,
	        delayTimeMs: React.PropTypes.number // time to wait before invoking onChanged
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onHsUrlChanged: function onHsUrlChanged() {},
	            onIsUrlChanged: function onIsUrlChanged() {},
	            customHsUrl: "",
	            customIsUrl: "",
	            withToggleButton: false,
	            delayTimeMs: 0
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            hs_url: this.props.customHsUrl,
	            is_url: this.props.customIsUrl,
	            // if withToggleButton is false, then show the config all the time given we have no way otherwise of making it visible
	            configVisible: !this.props.withToggleButton || this.props.customHsUrl !== this.props.defaultHsUrl || this.props.customIsUrl !== this.props.defaultIsUrl
	        };
	    },
	
	    onHomeserverChanged: function onHomeserverChanged(ev) {
	        this.setState({ hs_url: ev.target.value }, function () {
	            this._hsTimeoutId = this._waitThenInvoke(this._hsTimeoutId, function () {
	                var hsUrl = this.state.hs_url.trim().replace(/\/$/, "");
	                if (hsUrl === "") hsUrl = this.props.defaultHsUrl;
	                this.props.onHsUrlChanged(hsUrl);
	            });
	        });
	    },
	
	    onIdentityServerChanged: function onIdentityServerChanged(ev) {
	        this.setState({ is_url: ev.target.value }, function () {
	            this._isTimeoutId = this._waitThenInvoke(this._isTimeoutId, function () {
	                var isUrl = this.state.is_url.trim().replace(/\/$/, "");
	                if (isUrl === "") isUrl = this.props.defaultIsUrl;
	                this.props.onIsUrlChanged(isUrl);
	            });
	        });
	    },
	
	    _waitThenInvoke: function _waitThenInvoke(existingTimeoutId, fn) {
	        if (existingTimeoutId) {
	            clearTimeout(existingTimeoutId);
	        }
	        return setTimeout(fn.bind(this), this.props.delayTimeMs);
	    },
	
	    onServerConfigVisibleChange: function onServerConfigVisibleChange(visible, ev) {
	        this.setState({
	            configVisible: visible
	        });
	        if (!visible) {
	            this.props.onHsUrlChanged(this.props.defaultHsUrl);
	            this.props.onIsUrlChanged(this.props.defaultIsUrl);
	        } else {
	            this.props.onHsUrlChanged(this.state.hs_url);
	            this.props.onIsUrlChanged(this.state.is_url);
	        }
	    },
	
	    showHelpPopup: function showHelpPopup() {
	        var CustomServerDialog = sdk.getComponent('login.CustomServerDialog');
	        Modal.createDialog(CustomServerDialog);
	    },
	
	    render: function render() {
	        var serverConfigStyle = {};
	        serverConfigStyle.display = this.state.configVisible ? 'block' : 'none';
	
	        var toggleButton;
	        if (this.props.withToggleButton) {
	            toggleButton = React.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                React.createElement('input', { className: 'mx_Login_radio', id: 'basic', name: 'configVisible', type: 'radio',
	                    checked: !this.state.configVisible,
	                    onChange: this.onServerConfigVisibleChange.bind(this, false) }),
	                React.createElement(
	                    'label',
	                    { className: 'mx_Login_label', htmlFor: 'basic' },
	                    'Default server'
	                ),
	                '\xA0\xA0',
	                React.createElement('input', { className: 'mx_Login_radio', id: 'advanced', name: 'configVisible', type: 'radio',
	                    checked: this.state.configVisible,
	                    onChange: this.onServerConfigVisibleChange.bind(this, true) }),
	                React.createElement(
	                    'label',
	                    { className: 'mx_Login_label', htmlFor: 'advanced' },
	                    'Custom server'
	                )
	            );
	        }
	
	        return React.createElement(
	            'div',
	            null,
	            toggleButton,
	            React.createElement(
	                'div',
	                { style: serverConfigStyle },
	                React.createElement(
	                    'div',
	                    { className: 'mx_ServerConfig' },
	                    React.createElement(
	                        'label',
	                        { className: 'mx_Login_label mx_ServerConfig_hslabel', htmlFor: 'hsurl' },
	                        'Home server URL'
	                    ),
	                    React.createElement('input', { className: 'mx_Login_field', id: 'hsurl', type: 'text',
	                        placeholder: this.props.defaultHsUrl,
	                        disabled: !this.props.withToggleButton,
	                        value: this.state.hs_url,
	                        onChange: this.onHomeserverChanged }),
	                    React.createElement(
	                        'label',
	                        { className: 'mx_Login_label mx_ServerConfig_islabel', htmlFor: 'isurl' },
	                        'Identity server URL'
	                    ),
	                    React.createElement('input', { className: 'mx_Login_field', id: 'isurl', type: 'text',
	                        placeholder: this.props.defaultIsUrl,
	                        disabled: !this.props.withToggleButton,
	                        value: this.state.is_url,
	                        onChange: this.onIdentityServerChanged }),
	                    React.createElement(
	                        'a',
	                        { className: 'mx_ServerConfig_help', href: '#', onClick: this.showHelpPopup },
	                        'What does this mean?'
	                    )
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(18);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _flatMap = __webpack_require__(1121);
	
	var _flatMap2 = _interopRequireDefault(_flatMap);
	
	var _isEqual = __webpack_require__(1125);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _Autocompleter = __webpack_require__(333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPOSER_SELECTED = 0;
	
	var Autocomplete = function (_React$Component) {
	    (0, _inherits3.default)(Autocomplete, _React$Component);
	
	    function Autocomplete(props) {
	        (0, _classCallCheck3.default)(this, Autocomplete);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Autocomplete.__proto__ || (0, _getPrototypeOf2.default)(Autocomplete)).call(this, props));
	
	        _this.completionPromise = null;
	        _this.hide = _this.hide.bind(_this);
	        _this.onCompletionClicked = _this.onCompletionClicked.bind(_this);
	
	        _this.state = {
	            // list of completionResults, each containing completions
	            completions: [],
	
	            // array of completions, so we can look up current selection by offset quickly
	            completionList: [],
	
	            // how far down the completion list we are (THIS IS 1-INDEXED!)
	            selectionOffset: COMPOSER_SELECTED,
	
	            // whether we should show completions if they're available
	            shouldShowCompletions: true,
	
	            hide: false,
	
	            forceComplete: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Autocomplete, [{
	        key: 'componentWillReceiveProps',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(props, state) {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!(props.query === this.props.query)) {
	                                    _context.next = 2;
	                                    break;
	                                }
	
	                                return _context.abrupt('return', null);
	
	                            case 2:
	                                _context.next = 4;
	                                return this.complete(props.query, props.selection);
	
	                            case 4:
	                                return _context.abrupt('return', _context.sent);
	
	                            case 5:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillReceiveProps(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillReceiveProps;
	        }()
	    }, {
	        key: 'complete',
	        value: function () {
	            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(query, selection) {
	                var _this2 = this;
	
	                var forceComplete, completionPromise, completions, completionList, selectionOffset, hide, oldMatches, newMatches;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                forceComplete = this.state.forceComplete;
	                                completionPromise = (0, _Autocompleter.getCompletions)(query, selection, forceComplete);
	
	                                this.completionPromise = completionPromise;
	                                _context2.next = 5;
	                                return this.completionPromise;
	
	                            case 5:
	                                completions = _context2.sent;
	
	                                if (!(completionPromise !== this.completionPromise)) {
	                                    _context2.next = 8;
	                                    break;
	                                }
	
	                                return _context2.abrupt('return');
	
	                            case 8:
	                                completionList = (0, _flatMap2.default)(completions, function (provider) {
	                                    return provider.completions;
	                                });
	
	                                // Reset selection when completion list becomes empty.
	
	                                selectionOffset = COMPOSER_SELECTED;
	
	                                if (completionList.length > 0) {
	                                    (function () {
	                                        /* If the currently selected completion is still in the completion list,
	                                         try to find it and jump to it. If not, select composer.
	                                         */
	                                        var currentSelection = _this2.state.selectionOffset === 0 ? null : _this2.state.completionList[_this2.state.selectionOffset - 1].completion;
	                                        selectionOffset = completionList.findIndex(function (completion) {
	                                            return completion.completion === currentSelection;
	                                        });
	                                        if (selectionOffset === -1) {
	                                            selectionOffset = COMPOSER_SELECTED;
	                                        } else {
	                                            selectionOffset++; // selectionOffset is 1-indexed!
	                                        }
	                                    })();
	                                } else {
	                                    // If no completions were returned, we should turn off force completion.
	                                    forceComplete = false;
	                                }
	
	                                hide = this.state.hide;
	                                // These are lists of booleans that indicate whether whether the corresponding provider had a matching pattern
	
	                                oldMatches = this.state.completions.map(function (completion) {
	                                    return !!completion.command.command;
	                                }), newMatches = completions.map(function (completion) {
	                                    return !!completion.command.command;
	                                });
	
	                                // So, essentially, we re-show autocomplete if any provider finds a new pattern or stops finding an old one
	
	                                if (!(0, _isEqual2.default)(oldMatches, newMatches)) {
	                                    hide = false;
	                                }
	
	                                this.setState({
	                                    completions: completions,
	                                    completionList: completionList,
	                                    selectionOffset: selectionOffset,
	                                    hide: hide,
	                                    forceComplete: forceComplete
	                                });
	
	                            case 15:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function complete(_x3, _x4) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return complete;
	        }()
	    }, {
	        key: 'countCompletions',
	        value: function countCompletions() {
	            return this.state.completionList.length;
	        }
	
	        // called from MessageComposerInput
	
	    }, {
	        key: 'onUpArrow',
	        value: function onUpArrow() {
	            var completionCount = this.countCompletions();
	            // completionCount + 1, since 0 means composer is selected
	            var selectionOffset = (completionCount + 1 + this.state.selectionOffset - 1) % (completionCount + 1);
	            if (!completionCount) {
	                return null;
	            }
	            this.setSelection(selectionOffset);
	            return selectionOffset === COMPOSER_SELECTED ? null : this.state.completionList[selectionOffset - 1];
	        }
	
	        // called from MessageComposerInput
	
	    }, {
	        key: 'onDownArrow',
	        value: function onDownArrow() {
	            var completionCount = this.countCompletions();
	            // completionCount + 1, since 0 means composer is selected
	            var selectionOffset = (this.state.selectionOffset + 1) % (completionCount + 1);
	            if (!completionCount) {
	                return null;
	            }
	            this.setSelection(selectionOffset);
	            return selectionOffset === COMPOSER_SELECTED ? null : this.state.completionList[selectionOffset - 1];
	        }
	    }, {
	        key: 'onEscape',
	        value: function onEscape(e) {
	            var completionCount = this.countCompletions();
	            if (completionCount === 0) {
	                // autocomplete is already empty, so don't preventDefault
	                return;
	            }
	
	            e.preventDefault();
	
	            // selectionOffset = 0, so we don't end up completing when autocomplete is hidden
	            this.hide();
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({ hide: true, selectionOffset: 0 });
	        }
	    }, {
	        key: 'forceComplete',
	        value: function forceComplete() {
	            var _this3 = this;
	
	            var done = _q2.default.defer();
	            this.setState({
	                forceComplete: true
	            }, function () {
	                _this3.complete(_this3.props.query, _this3.props.selection).then(function () {
	                    done.resolve();
	                });
	            });
	            return done.promise;
	        }
	    }, {
	        key: 'onCompletionClicked',
	        value: function onCompletionClicked() {
	            if (this.countCompletions() === 0 || this.state.selectionOffset === COMPOSER_SELECTED) {
	                return false;
	            }
	
	            this.props.onConfirm(this.state.completionList[this.state.selectionOffset - 1]);
	            this.hide();
	
	            return true;
	        }
	    }, {
	        key: 'setSelection',
	        value: function setSelection(selectionOffset) {
	            this.setState({ selectionOffset: selectionOffset });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            // this is the selected completion, so scroll it into view if needed
	            var selectedCompletion = this.refs['completion' + this.state.selectionOffset];
	            if (selectedCompletion && this.container) {
	                var domNode = _reactDom2.default.findDOMNode(selectedCompletion);
	                var offsetTop = domNode && domNode.offsetTop;
	                if (offsetTop > this.container.scrollTop + this.container.offsetHeight || offsetTop < this.container.scrollTop) {
	                    this.container.scrollTop = offsetTop - this.container.offsetTop;
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var EmojiText = _index2.default.getComponent('views.elements.EmojiText');
	
	            var position = 1;
	            var renderedCompletions = this.state.completions.map(function (completionResult, i) {
	                var completions = completionResult.completions.map(function (completion, i) {
	
	                    var className = (0, _classnames2.default)('mx_Autocomplete_Completion', {
	                        'selected': position === _this4.state.selectionOffset
	                    });
	                    var componentPosition = position;
	                    position++;
	
	                    var onMouseOver = function onMouseOver() {
	                        return _this4.setSelection(componentPosition);
	                    };
	                    var onClick = function onClick() {
	                        _this4.setSelection(componentPosition);
	                        _this4.onCompletionClicked();
	                    };
	
	                    return _react2.default.cloneElement(completion.component, {
	                        key: i,
	                        ref: 'completion' + (position - 1),
	                        className: className,
	                        onMouseOver: onMouseOver,
	                        onClick: onClick
	                    });
	                });
	
	                return completions.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { key: i, className: 'mx_Autocomplete_ProviderSection' },
	                    _react2.default.createElement(
	                        EmojiText,
	                        { element: 'div', className: 'mx_Autocomplete_provider_name' },
	                        completionResult.provider.getName()
	                    ),
	                    completionResult.provider.renderCompletions(completions)
	                ) : null;
	            }).filter(function (completion) {
	                return !!completion;
	            });
	
	            return !this.state.hide && renderedCompletions.length > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'mx_Autocomplete', ref: function ref(e) {
	                        return _this4.container = e;
	                    } },
	                renderedCompletions
	            ) : null;
	        }
	    }]);
	    return Autocomplete;
	}(_react2.default.Component);
	
	exports.default = Autocomplete;
	
	
	Autocomplete.propTypes = {
	    // the query string for which to show autocomplete suggestions
	    query: _react2.default.PropTypes.string.isRequired,
	
	    // method invoked with range and text content when completion is confirmed
	    onConfirm: _react2.default.PropTypes.func.isRequired
	};
	module.exports = exports['default'];


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function (WrappedComponent) {
	    return _react2.default.createClass({
	        displayName: "WithMatrixClient<" + WrappedComponent.displayName + ">",
	
	        contextTypes: {
	            matrixClient: _react2.default.PropTypes.instanceOf(Matrix.MatrixClient).isRequired
	        },
	
	        render: function render() {
	            return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, { matrixClient: this.context.matrixClient }));
	        }
	    });
	};
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var Matrix = _interopRequireWildcard(_matrixJsSdk);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];
	
	/**
	 * Wraps a react class, pulling the MatrixClient from the context and adding it
	 * as a 'matrixClient' property instead.
	 *
	 * This abstracts the use of the context API, so that we can use a different
	 * mechanism in future.
	 */
	/*
	Copyright 2015, 2016 OpenMarket Ltd

	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at

	    http://www.apache.org/licenses/LICENSE-2.0

	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint maxerr: 10000 */
	/* jslint unused: true */
	/* jshint shadow: true */
	/* jshint -W075 */
	(function(ns){
	    // this list must be ordered from largest length of the value array, index 0, to the shortest
	    ns.emojioneList = {":kiss_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","1f469-2764-1f48b-1f469"],"isCanonical": true},":couplekiss_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","1f469-2764-1f48b-1f469"],"isCanonical": false},":kiss_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","1f468-2764-1f48b-1f468"],"isCanonical": true},":couplekiss_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","1f468-2764-1f48b-1f468"],"isCanonical": false},":family_mmbb:":{"unicode":["1f468-200d-1f468-200d-1f466-200d-1f466","1f468-1f468-1f466-1f466"],"isCanonical": true},":family_mmgb:":{"unicode":["1f468-200d-1f468-200d-1f467-200d-1f466","1f468-1f468-1f467-1f466"],"isCanonical": true},":family_mmgg:":{"unicode":["1f468-200d-1f468-200d-1f467-200d-1f467","1f468-1f468-1f467-1f467"],"isCanonical": true},":family_mwbb:":{"unicode":["1f468-200d-1f469-200d-1f466-200d-1f466","1f468-1f469-1f466-1f466"],"isCanonical": true},":family_mwgb:":{"unicode":["1f468-200d-1f469-200d-1f467-200d-1f466","1f468-1f469-1f467-1f466"],"isCanonical": true},":family_mwgg:":{"unicode":["1f468-200d-1f469-200d-1f467-200d-1f467","1f468-1f469-1f467-1f467"],"isCanonical": true},":family_wwbb:":{"unicode":["1f469-200d-1f469-200d-1f466-200d-1f466","1f469-1f469-1f466-1f466"],"isCanonical": true},":family_wwgb:":{"unicode":["1f469-200d-1f469-200d-1f467-200d-1f466","1f469-1f469-1f467-1f466"],"isCanonical": true},":family_wwgg:":{"unicode":["1f469-200d-1f469-200d-1f467-200d-1f467","1f469-1f469-1f467-1f467"],"isCanonical": true},":couple_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f469","1f469-2764-1f469"],"isCanonical": true},":couple_with_heart_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f469","1f469-2764-1f469"],"isCanonical": false},":couple_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f468","1f468-2764-1f468"],"isCanonical": true},":couple_with_heart_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f468","1f468-2764-1f468"],"isCanonical": false},":family_mmb:":{"unicode":["1f468-200d-1f468-200d-1f466","1f468-1f468-1f466"],"isCanonical": true},":family_mmg:":{"unicode":["1f468-200d-1f468-200d-1f467","1f468-1f468-1f467"],"isCanonical": true},":family_mwg:":{"unicode":["1f468-200d-1f469-200d-1f467","1f468-1f469-1f467"],"isCanonical": true},":family_wwb:":{"unicode":["1f469-200d-1f469-200d-1f466","1f469-1f469-1f466"],"isCanonical": true},":family_wwg:":{"unicode":["1f469-200d-1f469-200d-1f467","1f469-1f469-1f467"],"isCanonical": true},":eye_in_speech_bubble:":{"unicode":["1f441-200d-1f5e8","1f441-1f5e8"],"isCanonical": true},":hash:":{"unicode":["0023-fe0f-20e3","0023-20e3"],"isCanonical": true},":zero:":{"unicode":["0030-fe0f-20e3","0030-20e3"],"isCanonical": true},":one:":{"unicode":["0031-fe0f-20e3","0031-20e3"],"isCanonical": true},":two:":{"unicode":["0032-fe0f-20e3","0032-20e3"],"isCanonical": true},":three:":{"unicode":["0033-fe0f-20e3","0033-20e3"],"isCanonical": true},":four:":{"unicode":["0034-fe0f-20e3","0034-20e3"],"isCanonical": true},":five:":{"unicode":["0035-fe0f-20e3","0035-20e3"],"isCanonical": true},":six:":{"unicode":["0036-fe0f-20e3","0036-20e3"],"isCanonical": true},":seven:":{"unicode":["0037-fe0f-20e3","0037-20e3"],"isCanonical": true},":eight:":{"unicode":["0038-fe0f-20e3","0038-20e3"],"isCanonical": true},":nine:":{"unicode":["0039-fe0f-20e3","0039-20e3"],"isCanonical": true},":asterisk:":{"unicode":["002a-fe0f-20e3","002a-20e3"],"isCanonical": true},":keycap_asterisk:":{"unicode":["002a-fe0f-20e3","002a-20e3"],"isCanonical": false},":metal_tone5:":{"unicode":["1f918-1f3ff"],"isCanonical": true},":sign_of_the_horns_tone5:":{"unicode":["1f918-1f3ff"],"isCanonical": false},":metal_tone4:":{"unicode":["1f918-1f3fe"],"isCanonical": true},":sign_of_the_horns_tone4:":{"unicode":["1f918-1f3fe"],"isCanonical": false},":metal_tone3:":{"unicode":["1f918-1f3fd"],"isCanonical": true},":sign_of_the_horns_tone3:":{"unicode":["1f918-1f3fd"],"isCanonical": false},":metal_tone2:":{"unicode":["1f918-1f3fc"],"isCanonical": true},":sign_of_the_horns_tone2:":{"unicode":["1f918-1f3fc"],"isCanonical": false},":metal_tone1:":{"unicode":["1f918-1f3fb"],"isCanonical": true},":sign_of_the_horns_tone1:":{"unicode":["1f918-1f3fb"],"isCanonical": false},":bath_tone5:":{"unicode":["1f6c0-1f3ff"],"isCanonical": true},":bath_tone4:":{"unicode":["1f6c0-1f3fe"],"isCanonical": true},":bath_tone3:":{"unicode":["1f6c0-1f3fd"],"isCanonical": true},":bath_tone2:":{"unicode":["1f6c0-1f3fc"],"isCanonical": true},":bath_tone1:":{"unicode":["1f6c0-1f3fb"],"isCanonical": true},":walking_tone5:":{"unicode":["1f6b6-1f3ff"],"isCanonical": true},":walking_tone4:":{"unicode":["1f6b6-1f3fe"],"isCanonical": true},":walking_tone3:":{"unicode":["1f6b6-1f3fd"],"isCanonical": true},":walking_tone2:":{"unicode":["1f6b6-1f3fc"],"isCanonical": true},":walking_tone1:":{"unicode":["1f6b6-1f3fb"],"isCanonical": true},":mountain_bicyclist_tone5:":{"unicode":["1f6b5-1f3ff"],"isCanonical": true},":mountain_bicyclist_tone4:":{"unicode":["1f6b5-1f3fe"],"isCanonical": true},":mountain_bicyclist_tone3:":{"unicode":["1f6b5-1f3fd"],"isCanonical": true},":mountain_bicyclist_tone2:":{"unicode":["1f6b5-1f3fc"],"isCanonical": true},":mountain_bicyclist_tone1:":{"unicode":["1f6b5-1f3fb"],"isCanonical": true},":bicyclist_tone5:":{"unicode":["1f6b4-1f3ff"],"isCanonical": true},":bicyclist_tone4:":{"unicode":["1f6b4-1f3fe"],"isCanonical": true},":bicyclist_tone3:":{"unicode":["1f6b4-1f3fd"],"isCanonical": true},":bicyclist_tone2:":{"unicode":["1f6b4-1f3fc"],"isCanonical": true},":bicyclist_tone1:":{"unicode":["1f6b4-1f3fb"],"isCanonical": true},":rowboat_tone5:":{"unicode":["1f6a3-1f3ff"],"isCanonical": true},":rowboat_tone4:":{"unicode":["1f6a3-1f3fe"],"isCanonical": true},":rowboat_tone3:":{"unicode":["1f6a3-1f3fd"],"isCanonical": true},":rowboat_tone2:":{"unicode":["1f6a3-1f3fc"],"isCanonical": true},":rowboat_tone1:":{"unicode":["1f6a3-1f3fb"],"isCanonical": true},":pray_tone5:":{"unicode":["1f64f-1f3ff"],"isCanonical": true},":pray_tone4:":{"unicode":["1f64f-1f3fe"],"isCanonical": true},":pray_tone3:":{"unicode":["1f64f-1f3fd"],"isCanonical": true},":pray_tone2:":{"unicode":["1f64f-1f3fc"],"isCanonical": true},":pray_tone1:":{"unicode":["1f64f-1f3fb"],"isCanonical": true},":person_with_pouting_face_tone5:":{"unicode":["1f64e-1f3ff"],"isCanonical": true},":person_with_pouting_face_tone4:":{"unicode":["1f64e-1f3fe"],"isCanonical": true},":person_with_pouting_face_tone3:":{"unicode":["1f64e-1f3fd"],"isCanonical": true},":person_with_pouting_face_tone2:":{"unicode":["1f64e-1f3fc"],"isCanonical": true},":person_with_pouting_face_tone1:":{"unicode":["1f64e-1f3fb"],"isCanonical": true},":person_frowning_tone5:":{"unicode":["1f64d-1f3ff"],"isCanonical": true},":person_frowning_tone4:":{"unicode":["1f64d-1f3fe"],"isCanonical": true},":person_frowning_tone3:":{"unicode":["1f64d-1f3fd"],"isCanonical": true},":person_frowning_tone2:":{"unicode":["1f64d-1f3fc"],"isCanonical": true},":person_frowning_tone1:":{"unicode":["1f64d-1f3fb"],"isCanonical": true},":raised_hands_tone5:":{"unicode":["1f64c-1f3ff"],"isCanonical": true},":raised_hands_tone4:":{"unicode":["1f64c-1f3fe"],"isCanonical": true},":raised_hands_tone3:":{"unicode":["1f64c-1f3fd"],"isCanonical": true},":raised_hands_tone2:":{"unicode":["1f64c-1f3fc"],"isCanonical": true},":raised_hands_tone1:":{"unicode":["1f64c-1f3fb"],"isCanonical": true},":raising_hand_tone5:":{"unicode":["1f64b-1f3ff"],"isCanonical": true},":raising_hand_tone4:":{"unicode":["1f64b-1f3fe"],"isCanonical": true},":raising_hand_tone3:":{"unicode":["1f64b-1f3fd"],"isCanonical": true},":raising_hand_tone2:":{"unicode":["1f64b-1f3fc"],"isCanonical": true},":raising_hand_tone1:":{"unicode":["1f64b-1f3fb"],"isCanonical": true},":bow_tone5:":{"unicode":["1f647-1f3ff"],"isCanonical": true},":bow_tone4:":{"unicode":["1f647-1f3fe"],"isCanonical": true},":bow_tone3:":{"unicode":["1f647-1f3fd"],"isCanonical": true},":bow_tone2:":{"unicode":["1f647-1f3fc"],"isCanonical": true},":bow_tone1:":{"unicode":["1f647-1f3fb"],"isCanonical": true},":ok_woman_tone5:":{"unicode":["1f646-1f3ff"],"isCanonical": true},":ok_woman_tone4:":{"unicode":["1f646-1f3fe"],"isCanonical": true},":ok_woman_tone3:":{"unicode":["1f646-1f3fd"],"isCanonical": true},":ok_woman_tone2:":{"unicode":["1f646-1f3fc"],"isCanonical": true},":ok_woman_tone1:":{"unicode":["1f646-1f3fb"],"isCanonical": true},":no_good_tone5:":{"unicode":["1f645-1f3ff"],"isCanonical": true},":no_good_tone4:":{"unicode":["1f645-1f3fe"],"isCanonical": true},":no_good_tone3:":{"unicode":["1f645-1f3fd"],"isCanonical": true},":no_good_tone2:":{"unicode":["1f645-1f3fc"],"isCanonical": true},":no_good_tone1:":{"unicode":["1f645-1f3fb"],"isCanonical": true},":vulcan_tone5:":{"unicode":["1f596-1f3ff"],"isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone5:":{"unicode":["1f596-1f3ff"],"isCanonical": false},":vulcan_tone4:":{"unicode":["1f596-1f3fe"],"isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone4:":{"unicode":["1f596-1f3fe"],"isCanonical": false},":vulcan_tone3:":{"unicode":["1f596-1f3fd"],"isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone3:":{"unicode":["1f596-1f3fd"],"isCanonical": false},":vulcan_tone2:":{"unicode":["1f596-1f3fc"],"isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone2:":{"unicode":["1f596-1f3fc"],"isCanonical": false},":vulcan_tone1:":{"unicode":["1f596-1f3fb"],"isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone1:":{"unicode":["1f596-1f3fb"],"isCanonical": false},":middle_finger_tone5:":{"unicode":["1f595-1f3ff"],"isCanonical": true},":reversed_hand_with_middle_finger_extended_tone5:":{"unicode":["1f595-1f3ff"],"isCanonical": false},":middle_finger_tone4:":{"unicode":["1f595-1f3fe"],"isCanonical": true},":reversed_hand_with_middle_finger_extended_tone4:":{"unicode":["1f595-1f3fe"],"isCanonical": false},":middle_finger_tone3:":{"unicode":["1f595-1f3fd"],"isCanonical": true},":reversed_hand_with_middle_finger_extended_tone3:":{"unicode":["1f595-1f3fd"],"isCanonical": false},":middle_finger_tone2:":{"unicode":["1f595-1f3fc"],"isCanonical": true},":reversed_hand_with_middle_finger_extended_tone2:":{"unicode":["1f595-1f3fc"],"isCanonical": false},":middle_finger_tone1:":{"unicode":["1f595-1f3fb"],"isCanonical": true},":reversed_hand_with_middle_finger_extended_tone1:":{"unicode":["1f595-1f3fb"],"isCanonical": false},":hand_splayed_tone5:":{"unicode":["1f590-1f3ff"],"isCanonical": true},":raised_hand_with_fingers_splayed_tone5:":{"unicode":["1f590-1f3ff"],"isCanonical": false},":hand_splayed_tone4:":{"unicode":["1f590-1f3fe"],"isCanonical": true},":raised_hand_with_fingers_splayed_tone4:":{"unicode":["1f590-1f3fe"],"isCanonical": false},":hand_splayed_tone3:":{"unicode":["1f590-1f3fd"],"isCanonical": true},":raised_hand_with_fingers_splayed_tone3:":{"unicode":["1f590-1f3fd"],"isCanonical": false},":hand_splayed_tone2:":{"unicode":["1f590-1f3fc"],"isCanonical": true},":raised_hand_with_fingers_splayed_tone2:":{"unicode":["1f590-1f3fc"],"isCanonical": false},":hand_splayed_tone1:":{"unicode":["1f590-1f3fb"],"isCanonical": true},":raised_hand_with_fingers_splayed_tone1:":{"unicode":["1f590-1f3fb"],"isCanonical": false},":spy_tone5:":{"unicode":["1f575-1f3ff"],"isCanonical": true},":sleuth_or_spy_tone5:":{"unicode":["1f575-1f3ff"],"isCanonical": false},":spy_tone4:":{"unicode":["1f575-1f3fe"],"isCanonical": true},":sleuth_or_spy_tone4:":{"unicode":["1f575-1f3fe"],"isCanonical": false},":spy_tone3:":{"unicode":["1f575-1f3fd"],"isCanonical": true},":sleuth_or_spy_tone3:":{"unicode":["1f575-1f3fd"],"isCanonical": false},":spy_tone2:":{"unicode":["1f575-1f3fc"],"isCanonical": true},":sleuth_or_spy_tone2:":{"unicode":["1f575-1f3fc"],"isCanonical": false},":spy_tone1:":{"unicode":["1f575-1f3fb"],"isCanonical": true},":sleuth_or_spy_tone1:":{"unicode":["1f575-1f3fb"],"isCanonical": false},":muscle_tone5:":{"unicode":["1f4aa-1f3ff"],"isCanonical": true},":muscle_tone4:":{"unicode":["1f4aa-1f3fe"],"isCanonical": true},":muscle_tone3:":{"unicode":["1f4aa-1f3fd"],"isCanonical": true},":muscle_tone2:":{"unicode":["1f4aa-1f3fc"],"isCanonical": true},":muscle_tone1:":{"unicode":["1f4aa-1f3fb"],"isCanonical": true},":haircut_tone5:":{"unicode":["1f487-1f3ff"],"isCanonical": true},":haircut_tone4:":{"unicode":["1f487-1f3fe"],"isCanonical": true},":haircut_tone3:":{"unicode":["1f487-1f3fd"],"isCanonical": true},":haircut_tone2:":{"unicode":["1f487-1f3fc"],"isCanonical": true},":haircut_tone1:":{"unicode":["1f487-1f3fb"],"isCanonical": true},":massage_tone5:":{"unicode":["1f486-1f3ff"],"isCanonical": true},":massage_tone4:":{"unicode":["1f486-1f3fe"],"isCanonical": true},":massage_tone3:":{"unicode":["1f486-1f3fd"],"isCanonical": true},":massage_tone2:":{"unicode":["1f486-1f3fc"],"isCanonical": true},":massage_tone1:":{"unicode":["1f486-1f3fb"],"isCanonical": true},":nail_care_tone5:":{"unicode":["1f485-1f3ff"],"isCanonical": true},":nail_care_tone4:":{"unicode":["1f485-1f3fe"],"isCanonical": true},":nail_care_tone3:":{"unicode":["1f485-1f3fd"],"isCanonical": true},":nail_care_tone2:":{"unicode":["1f485-1f3fc"],"isCanonical": true},":nail_care_tone1:":{"unicode":["1f485-1f3fb"],"isCanonical": true},":dancer_tone5:":{"unicode":["1f483-1f3ff"],"isCanonical": true},":dancer_tone4:":{"unicode":["1f483-1f3fe"],"isCanonical": true},":dancer_tone3:":{"unicode":["1f483-1f3fd"],"isCanonical": true},":dancer_tone2:":{"unicode":["1f483-1f3fc"],"isCanonical": true},":dancer_tone1:":{"unicode":["1f483-1f3fb"],"isCanonical": true},":guardsman_tone5:":{"unicode":["1f482-1f3ff"],"isCanonical": true},":guardsman_tone4:":{"unicode":["1f482-1f3fe"],"isCanonical": true},":guardsman_tone3:":{"unicode":["1f482-1f3fd"],"isCanonical": true},":guardsman_tone2:":{"unicode":["1f482-1f3fc"],"isCanonical": true},":guardsman_tone1:":{"unicode":["1f482-1f3fb"],"isCanonical": true},":information_desk_person_tone5:":{"unicode":["1f481-1f3ff"],"isCanonical": true},":information_desk_person_tone4:":{"unicode":["1f481-1f3fe"],"isCanonical": true},":information_desk_person_tone3:":{"unicode":["1f481-1f3fd"],"isCanonical": true},":information_desk_person_tone2:":{"unicode":["1f481-1f3fc"],"isCanonical": true},":information_desk_person_tone1:":{"unicode":["1f481-1f3fb"],"isCanonical": true},":angel_tone5:":{"unicode":["1f47c-1f3ff"],"isCanonical": true},":angel_tone4:":{"unicode":["1f47c-1f3fe"],"isCanonical": true},":angel_tone3:":{"unicode":["1f47c-1f3fd"],"isCanonical": true},":angel_tone2:":{"unicode":["1f47c-1f3fc"],"isCanonical": true},":angel_tone1:":{"unicode":["1f47c-1f3fb"],"isCanonical": true},":princess_tone5:":{"unicode":["1f478-1f3ff"],"isCanonical": true},":princess_tone4:":{"unicode":["1f478-1f3fe"],"isCanonical": true},":princess_tone3:":{"unicode":["1f478-1f3fd"],"isCanonical": true},":princess_tone2:":{"unicode":["1f478-1f3fc"],"isCanonical": true},":princess_tone1:":{"unicode":["1f478-1f3fb"],"isCanonical": true},":construction_worker_tone5:":{"unicode":["1f477-1f3ff"],"isCanonical": true},":construction_worker_tone4:":{"unicode":["1f477-1f3fe"],"isCanonical": true},":construction_worker_tone3:":{"unicode":["1f477-1f3fd"],"isCanonical": true},":construction_worker_tone2:":{"unicode":["1f477-1f3fc"],"isCanonical": true},":construction_worker_tone1:":{"unicode":["1f477-1f3fb"],"isCanonical": true},":baby_tone5:":{"unicode":["1f476-1f3ff"],"isCanonical": true},":baby_tone4:":{"unicode":["1f476-1f3fe"],"isCanonical": true},":baby_tone3:":{"unicode":["1f476-1f3fd"],"isCanonical": true},":baby_tone2:":{"unicode":["1f476-1f3fc"],"isCanonical": true},":baby_tone1:":{"unicode":["1f476-1f3fb"],"isCanonical": true},":older_woman_tone5:":{"unicode":["1f475-1f3ff"],"isCanonical": true},":grandma_tone5:":{"unicode":["1f475-1f3ff"],"isCanonical": false},":older_woman_tone4:":{"unicode":["1f475-1f3fe"],"isCanonical": true},":grandma_tone4:":{"unicode":["1f475-1f3fe"],"isCanonical": false},":older_woman_tone3:":{"unicode":["1f475-1f3fd"],"isCanonical": true},":grandma_tone3:":{"unicode":["1f475-1f3fd"],"isCanonical": false},":older_woman_tone2:":{"unicode":["1f475-1f3fc"],"isCanonical": true},":grandma_tone2:":{"unicode":["1f475-1f3fc"],"isCanonical": false},":older_woman_tone1:":{"unicode":["1f475-1f3fb"],"isCanonical": true},":grandma_tone1:":{"unicode":["1f475-1f3fb"],"isCanonical": false},":older_man_tone5:":{"unicode":["1f474-1f3ff"],"isCanonical": true},":older_man_tone4:":{"unicode":["1f474-1f3fe"],"isCanonical": true},":older_man_tone3:":{"unicode":["1f474-1f3fd"],"isCanonical": true},":older_man_tone2:":{"unicode":["1f474-1f3fc"],"isCanonical": true},":older_man_tone1:":{"unicode":["1f474-1f3fb"],"isCanonical": true},":man_with_turban_tone5:":{"unicode":["1f473-1f3ff"],"isCanonical": true},":man_with_turban_tone4:":{"unicode":["1f473-1f3fe"],"isCanonical": true},":man_with_turban_tone3:":{"unicode":["1f473-1f3fd"],"isCanonical": true},":man_with_turban_tone2:":{"unicode":["1f473-1f3fc"],"isCanonical": true},":man_with_turban_tone1:":{"unicode":["1f473-1f3fb"],"isCanonical": true},":man_with_gua_pi_mao_tone5:":{"unicode":["1f472-1f3ff"],"isCanonical": true},":man_with_gua_pi_mao_tone4:":{"unicode":["1f472-1f3fe"],"isCanonical": true},":man_with_gua_pi_mao_tone3:":{"unicode":["1f472-1f3fd"],"isCanonical": true},":man_with_gua_pi_mao_tone2:":{"unicode":["1f472-1f3fc"],"isCanonical": true},":man_with_gua_pi_mao_tone1:":{"unicode":["1f472-1f3fb"],"isCanonical": true},":person_with_blond_hair_tone5:":{"unicode":["1f471-1f3ff"],"isCanonical": true},":person_with_blond_hair_tone4:":{"unicode":["1f471-1f3fe"],"isCanonical": true},":person_with_blond_hair_tone3:":{"unicode":["1f471-1f3fd"],"isCanonical": true},":person_with_blond_hair_tone2:":{"unicode":["1f471-1f3fc"],"isCanonical": true},":person_with_blond_hair_tone1:":{"unicode":["1f471-1f3fb"],"isCanonical": true},":bride_with_veil_tone5:":{"unicode":["1f470-1f3ff"],"isCanonical": true},":bride_with_veil_tone4:":{"unicode":["1f470-1f3fe"],"isCanonical": true},":bride_with_veil_tone3:":{"unicode":["1f470-1f3fd"],"isCanonical": true},":bride_with_veil_tone2:":{"unicode":["1f470-1f3fc"],"isCanonical": true},":bride_with_veil_tone1:":{"unicode":["1f470-1f3fb"],"isCanonical": true},":cop_tone5:":{"unicode":["1f46e-1f3ff"],"isCanonical": true},":cop_tone4:":{"unicode":["1f46e-1f3fe"],"isCanonical": true},":cop_tone3:":{"unicode":["1f46e-1f3fd"],"isCanonical": true},":cop_tone2:":{"unicode":["1f46e-1f3fc"],"isCanonical": true},":cop_tone1:":{"unicode":["1f46e-1f3fb"],"isCanonical": true},":woman_tone5:":{"unicode":["1f469-1f3ff"],"isCanonical": true},":woman_tone4:":{"unicode":["1f469-1f3fe"],"isCanonical": true},":woman_tone3:":{"unicode":["1f469-1f3fd"],"isCanonical": true},":woman_tone2:":{"unicode":["1f469-1f3fc"],"isCanonical": true},":woman_tone1:":{"unicode":["1f469-1f3fb"],"isCanonical": true},":man_tone5:":{"unicode":["1f468-1f3ff"],"isCanonical": true},":man_tone4:":{"unicode":["1f468-1f3fe"],"isCanonical": true},":man_tone3:":{"unicode":["1f468-1f3fd"],"isCanonical": true},":man_tone2:":{"unicode":["1f468-1f3fc"],"isCanonical": true},":man_tone1:":{"unicode":["1f468-1f3fb"],"isCanonical": true},":girl_tone5:":{"unicode":["1f467-1f3ff"],"isCanonical": true},":girl_tone4:":{"unicode":["1f467-1f3fe"],"isCanonical": true},":girl_tone3:":{"unicode":["1f467-1f3fd"],"isCanonical": true},":girl_tone2:":{"unicode":["1f467-1f3fc"],"isCanonical": true},":girl_tone1:":{"unicode":["1f467-1f3fb"],"isCanonical": true},":boy_tone5:":{"unicode":["1f466-1f3ff"],"isCanonical": true},":boy_tone4:":{"unicode":["1f466-1f3fe"],"isCanonical": true},":boy_tone3:":{"unicode":["1f466-1f3fd"],"isCanonical": true},":boy_tone2:":{"unicode":["1f466-1f3fc"],"isCanonical": true},":boy_tone1:":{"unicode":["1f466-1f3fb"],"isCanonical": true},":open_hands_tone5:":{"unicode":["1f450-1f3ff"],"isCanonical": true},":open_hands_tone4:":{"unicode":["1f450-1f3fe"],"isCanonical": true},":open_hands_tone3:":{"unicode":["1f450-1f3fd"],"isCanonical": true},":open_hands_tone2:":{"unicode":["1f450-1f3fc"],"isCanonical": true},":open_hands_tone1:":{"unicode":["1f450-1f3fb"],"isCanonical": true},":clap_tone5:":{"unicode":["1f44f-1f3ff"],"isCanonical": true},":clap_tone4:":{"unicode":["1f44f-1f3fe"],"isCanonical": true},":clap_tone3:":{"unicode":["1f44f-1f3fd"],"isCanonical": true},":clap_tone2:":{"unicode":["1f44f-1f3fc"],"isCanonical": true},":clap_tone1:":{"unicode":["1f44f-1f3fb"],"isCanonical": true},":thumbsdown_tone5:":{"unicode":["1f44e-1f3ff"],"isCanonical": true},":-1_tone5:":{"unicode":["1f44e-1f3ff"],"isCanonical": false},":thumbdown_tone5:":{"unicode":["1f44e-1f3ff"],"isCanonical": false},":thumbsdown_tone4:":{"unicode":["1f44e-1f3fe"],"isCanonical": true},":-1_tone4:":{"unicode":["1f44e-1f3fe"],"isCanonical": false},":thumbdown_tone4:":{"unicode":["1f44e-1f3fe"],"isCanonical": false},":thumbsdown_tone3:":{"unicode":["1f44e-1f3fd"],"isCanonical": true},":-1_tone3:":{"unicode":["1f44e-1f3fd"],"isCanonical": false},":thumbdown_tone3:":{"unicode":["1f44e-1f3fd"],"isCanonical": false},":thumbsdown_tone2:":{"unicode":["1f44e-1f3fc"],"isCanonical": true},":-1_tone2:":{"unicode":["1f44e-1f3fc"],"isCanonical": false},":thumbdown_tone2:":{"unicode":["1f44e-1f3fc"],"isCanonical": false},":thumbsdown_tone1:":{"unicode":["1f44e-1f3fb"],"isCanonical": true},":-1_tone1:":{"unicode":["1f44e-1f3fb"],"isCanonical": false},":thumbdown_tone1:":{"unicode":["1f44e-1f3fb"],"isCanonical": false},":thumbsup_tone5:":{"unicode":["1f44d-1f3ff"],"isCanonical": true},":+1_tone5:":{"unicode":["1f44d-1f3ff"],"isCanonical": false},":thumbup_tone5:":{"unicode":["1f44d-1f3ff"],"isCanonical": false},":thumbsup_tone4:":{"unicode":["1f44d-1f3fe"],"isCanonical": true},":+1_tone4:":{"unicode":["1f44d-1f3fe"],"isCanonical": false},":thumbup_tone4:":{"unicode":["1f44d-1f3fe"],"isCanonical": false},":thumbsup_tone3:":{"unicode":["1f44d-1f3fd"],"isCanonical": true},":+1_tone3:":{"unicode":["1f44d-1f3fd"],"isCanonical": false},":thumbup_tone3:":{"unicode":["1f44d-1f3fd"],"isCanonical": false},":thumbsup_tone2:":{"unicode":["1f44d-1f3fc"],"isCanonical": true},":+1_tone2:":{"unicode":["1f44d-1f3fc"],"isCanonical": false},":thumbup_tone2:":{"unicode":["1f44d-1f3fc"],"isCanonical": false},":thumbsup_tone1:":{"unicode":["1f44d-1f3fb"],"isCanonical": true},":+1_tone1:":{"unicode":["1f44d-1f3fb"],"isCanonical": false},":thumbup_tone1:":{"unicode":["1f44d-1f3fb"],"isCanonical": false},":ok_hand_tone5:":{"unicode":["1f44c-1f3ff"],"isCanonical": true},":ok_hand_tone4:":{"unicode":["1f44c-1f3fe"],"isCanonical": true},":ok_hand_tone3:":{"unicode":["1f44c-1f3fd"],"isCanonical": true},":ok_hand_tone2:":{"unicode":["1f44c-1f3fc"],"isCanonical": true},":ok_hand_tone1:":{"unicode":["1f44c-1f3fb"],"isCanonical": true},":wave_tone5:":{"unicode":["1f44b-1f3ff"],"isCanonical": true},":wave_tone4:":{"unicode":["1f44b-1f3fe"],"isCanonical": true},":wave_tone3:":{"unicode":["1f44b-1f3fd"],"isCanonical": true},":wave_tone2:":{"unicode":["1f44b-1f3fc"],"isCanonical": true},":wave_tone1:":{"unicode":["1f44b-1f3fb"],"isCanonical": true},":punch_tone5:":{"unicode":["1f44a-1f3ff"],"isCanonical": true},":punch_tone4:":{"unicode":["1f44a-1f3fe"],"isCanonical": true},":punch_tone3:":{"unicode":["1f44a-1f3fd"],"isCanonical": true},":punch_tone2:":{"unicode":["1f44a-1f3fc"],"isCanonical": true},":punch_tone1:":{"unicode":["1f44a-1f3fb"],"isCanonical": true},":point_right_tone5:":{"unicode":["1f449-1f3ff"],"isCanonical": true},":point_right_tone4:":{"unicode":["1f449-1f3fe"],"isCanonical": true},":point_right_tone3:":{"unicode":["1f449-1f3fd"],"isCanonical": true},":point_right_tone2:":{"unicode":["1f449-1f3fc"],"isCanonical": true},":point_right_tone1:":{"unicode":["1f449-1f3fb"],"isCanonical": true},":point_left_tone5:":{"unicode":["1f448-1f3ff"],"isCanonical": true},":point_left_tone4:":{"unicode":["1f448-1f3fe"],"isCanonical": true},":point_left_tone3:":{"unicode":["1f448-1f3fd"],"isCanonical": true},":point_left_tone2:":{"unicode":["1f448-1f3fc"],"isCanonical": true},":point_left_tone1:":{"unicode":["1f448-1f3fb"],"isCanonical": true},":point_down_tone5:":{"unicode":["1f447-1f3ff"],"isCanonical": true},":point_down_tone4:":{"unicode":["1f447-1f3fe"],"isCanonical": true},":point_down_tone3:":{"unicode":["1f447-1f3fd"],"isCanonical": true},":point_down_tone2:":{"unicode":["1f447-1f3fc"],"isCanonical": true},":point_down_tone1:":{"unicode":["1f447-1f3fb"],"isCanonical": true},":point_up_2_tone5:":{"unicode":["1f446-1f3ff"],"isCanonical": true},":point_up_2_tone4:":{"unicode":["1f446-1f3fe"],"isCanonical": true},":point_up_2_tone3:":{"unicode":["1f446-1f3fd"],"isCanonical": true},":point_up_2_tone2:":{"unicode":["1f446-1f3fc"],"isCanonical": true},":point_up_2_tone1:":{"unicode":["1f446-1f3fb"],"isCanonical": true},":nose_tone5:":{"unicode":["1f443-1f3ff"],"isCanonical": true},":nose_tone4:":{"unicode":["1f443-1f3fe"],"isCanonical": true},":nose_tone3:":{"unicode":["1f443-1f3fd"],"isCanonical": true},":nose_tone2:":{"unicode":["1f443-1f3fc"],"isCanonical": true},":nose_tone1:":{"unicode":["1f443-1f3fb"],"isCanonical": true},":ear_tone5:":{"unicode":["1f442-1f3ff"],"isCanonical": true},":ear_tone4:":{"unicode":["1f442-1f3fe"],"isCanonical": true},":ear_tone3:":{"unicode":["1f442-1f3fd"],"isCanonical": true},":ear_tone2:":{"unicode":["1f442-1f3fc"],"isCanonical": true},":ear_tone1:":{"unicode":["1f442-1f3fb"],"isCanonical": true},":lifter_tone5:":{"unicode":["1f3cb-1f3ff"],"isCanonical": true},":weight_lifter_tone5:":{"unicode":["1f3cb-1f3ff"],"isCanonical": false},":lifter_tone4:":{"unicode":["1f3cb-1f3fe"],"isCanonical": true},":weight_lifter_tone4:":{"unicode":["1f3cb-1f3fe"],"isCanonical": false},":lifter_tone3:":{"unicode":["1f3cb-1f3fd"],"isCanonical": true},":weight_lifter_tone3:":{"unicode":["1f3cb-1f3fd"],"isCanonical": false},":lifter_tone2:":{"unicode":["1f3cb-1f3fc"],"isCanonical": true},":weight_lifter_tone2:":{"unicode":["1f3cb-1f3fc"],"isCanonical": false},":lifter_tone1:":{"unicode":["1f3cb-1f3fb"],"isCanonical": true},":weight_lifter_tone1:":{"unicode":["1f3cb-1f3fb"],"isCanonical": false},":swimmer_tone5:":{"unicode":["1f3ca-1f3ff"],"isCanonical": true},":swimmer_tone4:":{"unicode":["1f3ca-1f3fe"],"isCanonical": true},":swimmer_tone3:":{"unicode":["1f3ca-1f3fd"],"isCanonical": true},":swimmer_tone2:":{"unicode":["1f3ca-1f3fc"],"isCanonical": true},":swimmer_tone1:":{"unicode":["1f3ca-1f3fb"],"isCanonical": true},":horse_racing_tone5:":{"unicode":["1f3c7-1f3ff"],"isCanonical": true},":horse_racing_tone4:":{"unicode":["1f3c7-1f3fe"],"isCanonical": true},":horse_racing_tone3:":{"unicode":["1f3c7-1f3fd"],"isCanonical": true},":horse_racing_tone2:":{"unicode":["1f3c7-1f3fc"],"isCanonical": true},":horse_racing_tone1:":{"unicode":["1f3c7-1f3fb"],"isCanonical": true},":surfer_tone5:":{"unicode":["1f3c4-1f3ff"],"isCanonical": true},":surfer_tone4:":{"unicode":["1f3c4-1f3fe"],"isCanonical": true},":surfer_tone3:":{"unicode":["1f3c4-1f3fd"],"isCanonical": true},":surfer_tone2:":{"unicode":["1f3c4-1f3fc"],"isCanonical": true},":surfer_tone1:":{"unicode":["1f3c4-1f3fb"],"isCanonical": true},":runner_tone5:":{"unicode":["1f3c3-1f3ff"],"isCanonical": true},":runner_tone4:":{"unicode":["1f3c3-1f3fe"],"isCanonical": true},":runner_tone3:":{"unicode":["1f3c3-1f3fd"],"isCanonical": true},":runner_tone2:":{"unicode":["1f3c3-1f3fc"],"isCanonical": true},":runner_tone1:":{"unicode":["1f3c3-1f3fb"],"isCanonical": true},":santa_tone5:":{"unicode":["1f385-1f3ff"],"isCanonical": true},":santa_tone4:":{"unicode":["1f385-1f3fe"],"isCanonical": true},":santa_tone3:":{"unicode":["1f385-1f3fd"],"isCanonical": true},":santa_tone2:":{"unicode":["1f385-1f3fc"],"isCanonical": true},":santa_tone1:":{"unicode":["1f385-1f3fb"],"isCanonical": true},":flag_zw:":{"unicode":["1f1ff-1f1fc"],"isCanonical": true},":zw:":{"unicode":["1f1ff-1f1fc"],"isCanonical": false},":flag_zm:":{"unicode":["1f1ff-1f1f2"],"isCanonical": true},":zm:":{"unicode":["1f1ff-1f1f2"],"isCanonical": false},":flag_za:":{"unicode":["1f1ff-1f1e6"],"isCanonical": true},":za:":{"unicode":["1f1ff-1f1e6"],"isCanonical": false},":flag_yt:":{"unicode":["1f1fe-1f1f9"],"isCanonical": true},":yt:":{"unicode":["1f1fe-1f1f9"],"isCanonical": false},":flag_ye:":{"unicode":["1f1fe-1f1ea"],"isCanonical": true},":ye:":{"unicode":["1f1fe-1f1ea"],"isCanonical": false},":flag_xk:":{"unicode":["1f1fd-1f1f0"],"isCanonical": true},":xk:":{"unicode":["1f1fd-1f1f0"],"isCanonical": false},":flag_ws:":{"unicode":["1f1fc-1f1f8"],"isCanonical": true},":ws:":{"unicode":["1f1fc-1f1f8"],"isCanonical": false},":flag_wf:":{"unicode":["1f1fc-1f1eb"],"isCanonical": true},":wf:":{"unicode":["1f1fc-1f1eb"],"isCanonical": false},":flag_vu:":{"unicode":["1f1fb-1f1fa"],"isCanonical": true},":vu:":{"unicode":["1f1fb-1f1fa"],"isCanonical": false},":flag_vn:":{"unicode":["1f1fb-1f1f3"],"isCanonical": true},":vn:":{"unicode":["1f1fb-1f1f3"],"isCanonical": false},":flag_vi:":{"unicode":["1f1fb-1f1ee"],"isCanonical": true},":vi:":{"unicode":["1f1fb-1f1ee"],"isCanonical": false},":flag_vg:":{"unicode":["1f1fb-1f1ec"],"isCanonical": true},":vg:":{"unicode":["1f1fb-1f1ec"],"isCanonical": false},":flag_ve:":{"unicode":["1f1fb-1f1ea"],"isCanonical": true},":ve:":{"unicode":["1f1fb-1f1ea"],"isCanonical": false},":flag_vc:":{"unicode":["1f1fb-1f1e8"],"isCanonical": true},":vc:":{"unicode":["1f1fb-1f1e8"],"isCanonical": false},":flag_va:":{"unicode":["1f1fb-1f1e6"],"isCanonical": true},":va:":{"unicode":["1f1fb-1f1e6"],"isCanonical": false},":flag_uz:":{"unicode":["1f1fa-1f1ff"],"isCanonical": true},":uz:":{"unicode":["1f1fa-1f1ff"],"isCanonical": false},":flag_uy:":{"unicode":["1f1fa-1f1fe"],"isCanonical": true},":uy:":{"unicode":["1f1fa-1f1fe"],"isCanonical": false},":flag_us:":{"unicode":["1f1fa-1f1f8"],"isCanonical": true},":us:":{"unicode":["1f1fa-1f1f8"],"isCanonical": false},":flag_um:":{"unicode":["1f1fa-1f1f2"],"isCanonical": true},":um:":{"unicode":["1f1fa-1f1f2"],"isCanonical": false},":flag_ug:":{"unicode":["1f1fa-1f1ec"],"isCanonical": true},":ug:":{"unicode":["1f1fa-1f1ec"],"isCanonical": false},":flag_ua:":{"unicode":["1f1fa-1f1e6"],"isCanonical": true},":ua:":{"unicode":["1f1fa-1f1e6"],"isCanonical": false},":flag_tz:":{"unicode":["1f1f9-1f1ff"],"isCanonical": true},":tz:":{"unicode":["1f1f9-1f1ff"],"isCanonical": false},":flag_tw:":{"unicode":["1f1f9-1f1fc"],"isCanonical": true},":tw:":{"unicode":["1f1f9-1f1fc"],"isCanonical": false},":flag_tv:":{"unicode":["1f1f9-1f1fb"],"isCanonical": true},":tuvalu:":{"unicode":["1f1f9-1f1fb"],"isCanonical": false},":flag_tt:":{"unicode":["1f1f9-1f1f9"],"isCanonical": true},":tt:":{"unicode":["1f1f9-1f1f9"],"isCanonical": false},":flag_tr:":{"unicode":["1f1f9-1f1f7"],"isCanonical": true},":tr:":{"unicode":["1f1f9-1f1f7"],"isCanonical": false},":flag_to:":{"unicode":["1f1f9-1f1f4"],"isCanonical": true},":to:":{"unicode":["1f1f9-1f1f4"],"isCanonical": false},":flag_tn:":{"unicode":["1f1f9-1f1f3"],"isCanonical": true},":tn:":{"unicode":["1f1f9-1f1f3"],"isCanonical": false},":flag_tm:":{"unicode":["1f1f9-1f1f2"],"isCanonical": true},":turkmenistan:":{"unicode":["1f1f9-1f1f2"],"isCanonical": false},":flag_tl:":{"unicode":["1f1f9-1f1f1"],"isCanonical": true},":tl:":{"unicode":["1f1f9-1f1f1"],"isCanonical": false},":flag_tk:":{"unicode":["1f1f9-1f1f0"],"isCanonical": true},":tk:":{"unicode":["1f1f9-1f1f0"],"isCanonical": false},":flag_tj:":{"unicode":["1f1f9-1f1ef"],"isCanonical": true},":tj:":{"unicode":["1f1f9-1f1ef"],"isCanonical": false},":flag_th:":{"unicode":["1f1f9-1f1ed"],"isCanonical": true},":th:":{"unicode":["1f1f9-1f1ed"],"isCanonical": false},":flag_tg:":{"unicode":["1f1f9-1f1ec"],"isCanonical": true},":tg:":{"unicode":["1f1f9-1f1ec"],"isCanonical": false},":flag_tf:":{"unicode":["1f1f9-1f1eb"],"isCanonical": true},":tf:":{"unicode":["1f1f9-1f1eb"],"isCanonical": false},":flag_td:":{"unicode":["1f1f9-1f1e9"],"isCanonical": true},":td:":{"unicode":["1f1f9-1f1e9"],"isCanonical": false},":flag_tc:":{"unicode":["1f1f9-1f1e8"],"isCanonical": true},":tc:":{"unicode":["1f1f9-1f1e8"],"isCanonical": false},":flag_ta:":{"unicode":["1f1f9-1f1e6"],"isCanonical": true},":ta:":{"unicode":["1f1f9-1f1e6"],"isCanonical": false},":flag_sz:":{"unicode":["1f1f8-1f1ff"],"isCanonical": true},":sz:":{"unicode":["1f1f8-1f1ff"],"isCanonical": false},":flag_sy:":{"unicode":["1f1f8-1f1fe"],"isCanonical": true},":sy:":{"unicode":["1f1f8-1f1fe"],"isCanonical": false},":flag_sx:":{"unicode":["1f1f8-1f1fd"],"isCanonical": true},":sx:":{"unicode":["1f1f8-1f1fd"],"isCanonical": false},":flag_sv:":{"unicode":["1f1f8-1f1fb"],"isCanonical": true},":sv:":{"unicode":["1f1f8-1f1fb"],"isCanonical": false},":flag_st:":{"unicode":["1f1f8-1f1f9"],"isCanonical": true},":st:":{"unicode":["1f1f8-1f1f9"],"isCanonical": false},":flag_ss:":{"unicode":["1f1f8-1f1f8"],"isCanonical": true},":ss:":{"unicode":["1f1f8-1f1f8"],"isCanonical": false},":flag_sr:":{"unicode":["1f1f8-1f1f7"],"isCanonical": true},":sr:":{"unicode":["1f1f8-1f1f7"],"isCanonical": false},":flag_so:":{"unicode":["1f1f8-1f1f4"],"isCanonical": true},":so:":{"unicode":["1f1f8-1f1f4"],"isCanonical": false},":flag_sn:":{"unicode":["1f1f8-1f1f3"],"isCanonical": true},":sn:":{"unicode":["1f1f8-1f1f3"],"isCanonical": false},":flag_sm:":{"unicode":["1f1f8-1f1f2"],"isCanonical": true},":sm:":{"unicode":["1f1f8-1f1f2"],"isCanonical": false},":flag_sl:":{"unicode":["1f1f8-1f1f1"],"isCanonical": true},":sl:":{"unicode":["1f1f8-1f1f1"],"isCanonical": false},":flag_sk:":{"unicode":["1f1f8-1f1f0"],"isCanonical": true},":sk:":{"unicode":["1f1f8-1f1f0"],"isCanonical": false},":flag_sj:":{"unicode":["1f1f8-1f1ef"],"isCanonical": true},":sj:":{"unicode":["1f1f8-1f1ef"],"isCanonical": false},":flag_si:":{"unicode":["1f1f8-1f1ee"],"isCanonical": true},":si:":{"unicode":["1f1f8-1f1ee"],"isCanonical": false},":flag_sh:":{"unicode":["1f1f8-1f1ed"],"isCanonical": true},":sh:":{"unicode":["1f1f8-1f1ed"],"isCanonical": false},":flag_sg:":{"unicode":["1f1f8-1f1ec"],"isCanonical": true},":sg:":{"unicode":["1f1f8-1f1ec"],"isCanonical": false},":flag_se:":{"unicode":["1f1f8-1f1ea"],"isCanonical": true},":se:":{"unicode":["1f1f8-1f1ea"],"isCanonical": false},":flag_sd:":{"unicode":["1f1f8-1f1e9"],"isCanonical": true},":sd:":{"unicode":["1f1f8-1f1e9"],"isCanonical": false},":flag_sc:":{"unicode":["1f1f8-1f1e8"],"isCanonical": true},":sc:":{"unicode":["1f1f8-1f1e8"],"isCanonical": false},":flag_sb:":{"unicode":["1f1f8-1f1e7"],"isCanonical": true},":sb:":{"unicode":["1f1f8-1f1e7"],"isCanonical": false},":flag_sa:":{"unicode":["1f1f8-1f1e6"],"isCanonical": true},":saudiarabia:":{"unicode":["1f1f8-1f1e6"],"isCanonical": false},":saudi:":{"unicode":["1f1f8-1f1e6"],"isCanonical": false},":flag_rw:":{"unicode":["1f1f7-1f1fc"],"isCanonical": true},":rw:":{"unicode":["1f1f7-1f1fc"],"isCanonical": false},":flag_ru:":{"unicode":["1f1f7-1f1fa"],"isCanonical": true},":ru:":{"unicode":["1f1f7-1f1fa"],"isCanonical": false},":flag_rs:":{"unicode":["1f1f7-1f1f8"],"isCanonical": true},":rs:":{"unicode":["1f1f7-1f1f8"],"isCanonical": false},":flag_ro:":{"unicode":["1f1f7-1f1f4"],"isCanonical": true},":ro:":{"unicode":["1f1f7-1f1f4"],"isCanonical": false},":flag_re:":{"unicode":["1f1f7-1f1ea"],"isCanonical": true},":re:":{"unicode":["1f1f7-1f1ea"],"isCanonical": false},":flag_qa:":{"unicode":["1f1f6-1f1e6"],"isCanonical": true},":qa:":{"unicode":["1f1f6-1f1e6"],"isCanonical": false},":flag_py:":{"unicode":["1f1f5-1f1fe"],"isCanonical": true},":py:":{"unicode":["1f1f5-1f1fe"],"isCanonical": false},":flag_pw:":{"unicode":["1f1f5-1f1fc"],"isCanonical": true},":pw:":{"unicode":["1f1f5-1f1fc"],"isCanonical": false},":flag_pt:":{"unicode":["1f1f5-1f1f9"],"isCanonical": true},":pt:":{"unicode":["1f1f5-1f1f9"],"isCanonical": false},":flag_ps:":{"unicode":["1f1f5-1f1f8"],"isCanonical": true},":ps:":{"unicode":["1f1f5-1f1f8"],"isCanonical": false},":flag_pr:":{"unicode":["1f1f5-1f1f7"],"isCanonical": true},":pr:":{"unicode":["1f1f5-1f1f7"],"isCanonical": false},":flag_pn:":{"unicode":["1f1f5-1f1f3"],"isCanonical": true},":pn:":{"unicode":["1f1f5-1f1f3"],"isCanonical": false},":flag_pm:":{"unicode":["1f1f5-1f1f2"],"isCanonical": true},":pm:":{"unicode":["1f1f5-1f1f2"],"isCanonical": false},":flag_pl:":{"unicode":["1f1f5-1f1f1"],"isCanonical": true},":pl:":{"unicode":["1f1f5-1f1f1"],"isCanonical": false},":flag_pk:":{"unicode":["1f1f5-1f1f0"],"isCanonical": true},":pk:":{"unicode":["1f1f5-1f1f0"],"isCanonical": false},":flag_ph:":{"unicode":["1f1f5-1f1ed"],"isCanonical": true},":ph:":{"unicode":["1f1f5-1f1ed"],"isCanonical": false},":flag_pg:":{"unicode":["1f1f5-1f1ec"],"isCanonical": true},":pg:":{"unicode":["1f1f5-1f1ec"],"isCanonical": false},":flag_pf:":{"unicode":["1f1f5-1f1eb"],"isCanonical": true},":pf:":{"unicode":["1f1f5-1f1eb"],"isCanonical": false},":flag_pe:":{"unicode":["1f1f5-1f1ea"],"isCanonical": true},":pe:":{"unicode":["1f1f5-1f1ea"],"isCanonical": false},":flag_pa:":{"unicode":["1f1f5-1f1e6"],"isCanonical": true},":pa:":{"unicode":["1f1f5-1f1e6"],"isCanonical": false},":flag_om:":{"unicode":["1f1f4-1f1f2"],"isCanonical": true},":om:":{"unicode":["1f1f4-1f1f2"],"isCanonical": false},":flag_nz:":{"unicode":["1f1f3-1f1ff"],"isCanonical": true},":nz:":{"unicode":["1f1f3-1f1ff"],"isCanonical": false},":flag_nu:":{"unicode":["1f1f3-1f1fa"],"isCanonical": true},":nu:":{"unicode":["1f1f3-1f1fa"],"isCanonical": false},":flag_nr:":{"unicode":["1f1f3-1f1f7"],"isCanonical": true},":nr:":{"unicode":["1f1f3-1f1f7"],"isCanonical": false},":flag_np:":{"unicode":["1f1f3-1f1f5"],"isCanonical": true},":np:":{"unicode":["1f1f3-1f1f5"],"isCanonical": false},":flag_no:":{"unicode":["1f1f3-1f1f4"],"isCanonical": true},":no:":{"unicode":["1f1f3-1f1f4"],"isCanonical": false},":flag_nl:":{"unicode":["1f1f3-1f1f1"],"isCanonical": true},":nl:":{"unicode":["1f1f3-1f1f1"],"isCanonical": false},":flag_ni:":{"unicode":["1f1f3-1f1ee"],"isCanonical": true},":ni:":{"unicode":["1f1f3-1f1ee"],"isCanonical": false},":flag_ng:":{"unicode":["1f1f3-1f1ec"],"isCanonical": true},":nigeria:":{"unicode":["1f1f3-1f1ec"],"isCanonical": false},":flag_nf:":{"unicode":["1f1f3-1f1eb"],"isCanonical": true},":nf:":{"unicode":["1f1f3-1f1eb"],"isCanonical": false},":flag_ne:":{"unicode":["1f1f3-1f1ea"],"isCanonical": true},":ne:":{"unicode":["1f1f3-1f1ea"],"isCanonical": false},":flag_nc:":{"unicode":["1f1f3-1f1e8"],"isCanonical": true},":nc:":{"unicode":["1f1f3-1f1e8"],"isCanonical": false},":flag_na:":{"unicode":["1f1f3-1f1e6"],"isCanonical": true},":na:":{"unicode":["1f1f3-1f1e6"],"isCanonical": false},":flag_mz:":{"unicode":["1f1f2-1f1ff"],"isCanonical": true},":mz:":{"unicode":["1f1f2-1f1ff"],"isCanonical": false},":flag_my:":{"unicode":["1f1f2-1f1fe"],"isCanonical": true},":my:":{"unicode":["1f1f2-1f1fe"],"isCanonical": false},":flag_mx:":{"unicode":["1f1f2-1f1fd"],"isCanonical": true},":mx:":{"unicode":["1f1f2-1f1fd"],"isCanonical": false},":flag_mw:":{"unicode":["1f1f2-1f1fc"],"isCanonical": true},":mw:":{"unicode":["1f1f2-1f1fc"],"isCanonical": false},":flag_mv:":{"unicode":["1f1f2-1f1fb"],"isCanonical": true},":mv:":{"unicode":["1f1f2-1f1fb"],"isCanonical": false},":flag_mu:":{"unicode":["1f1f2-1f1fa"],"isCanonical": true},":mu:":{"unicode":["1f1f2-1f1fa"],"isCanonical": false},":flag_mt:":{"unicode":["1f1f2-1f1f9"],"isCanonical": true},":mt:":{"unicode":["1f1f2-1f1f9"],"isCanonical": false},":flag_ms:":{"unicode":["1f1f2-1f1f8"],"isCanonical": true},":ms:":{"unicode":["1f1f2-1f1f8"],"isCanonical": false},":flag_mr:":{"unicode":["1f1f2-1f1f7"],"isCanonical": true},":mr:":{"unicode":["1f1f2-1f1f7"],"isCanonical": false},":flag_mq:":{"unicode":["1f1f2-1f1f6"],"isCanonical": true},":mq:":{"unicode":["1f1f2-1f1f6"],"isCanonical": false},":flag_mp:":{"unicode":["1f1f2-1f1f5"],"isCanonical": true},":mp:":{"unicode":["1f1f2-1f1f5"],"isCanonical": false},":flag_mo:":{"unicode":["1f1f2-1f1f4"],"isCanonical": true},":mo:":{"unicode":["1f1f2-1f1f4"],"isCanonical": false},":flag_mn:":{"unicode":["1f1f2-1f1f3"],"isCanonical": true},":mn:":{"unicode":["1f1f2-1f1f3"],"isCanonical": false},":flag_mm:":{"unicode":["1f1f2-1f1f2"],"isCanonical": true},":mm:":{"unicode":["1f1f2-1f1f2"],"isCanonical": false},":flag_ml:":{"unicode":["1f1f2-1f1f1"],"isCanonical": true},":ml:":{"unicode":["1f1f2-1f1f1"],"isCanonical": false},":flag_mk:":{"unicode":["1f1f2-1f1f0"],"isCanonical": true},":mk:":{"unicode":["1f1f2-1f1f0"],"isCanonical": false},":flag_mh:":{"unicode":["1f1f2-1f1ed"],"isCanonical": true},":mh:":{"unicode":["1f1f2-1f1ed"],"isCanonical": false},":flag_mg:":{"unicode":["1f1f2-1f1ec"],"isCanonical": true},":mg:":{"unicode":["1f1f2-1f1ec"],"isCanonical": false},":flag_mf:":{"unicode":["1f1f2-1f1eb"],"isCanonical": true},":mf:":{"unicode":["1f1f2-1f1eb"],"isCanonical": false},":flag_me:":{"unicode":["1f1f2-1f1ea"],"isCanonical": true},":me:":{"unicode":["1f1f2-1f1ea"],"isCanonical": false},":flag_md:":{"unicode":["1f1f2-1f1e9"],"isCanonical": true},":md:":{"unicode":["1f1f2-1f1e9"],"isCanonical": false},":flag_mc:":{"unicode":["1f1f2-1f1e8"],"isCanonical": true},":mc:":{"unicode":["1f1f2-1f1e8"],"isCanonical": false},":flag_ma:":{"unicode":["1f1f2-1f1e6"],"isCanonical": true},":ma:":{"unicode":["1f1f2-1f1e6"],"isCanonical": false},":flag_ly:":{"unicode":["1f1f1-1f1fe"],"isCanonical": true},":ly:":{"unicode":["1f1f1-1f1fe"],"isCanonical": false},":flag_lv:":{"unicode":["1f1f1-1f1fb"],"isCanonical": true},":lv:":{"unicode":["1f1f1-1f1fb"],"isCanonical": false},":flag_lu:":{"unicode":["1f1f1-1f1fa"],"isCanonical": true},":lu:":{"unicode":["1f1f1-1f1fa"],"isCanonical": false},":flag_lt:":{"unicode":["1f1f1-1f1f9"],"isCanonical": true},":lt:":{"unicode":["1f1f1-1f1f9"],"isCanonical": false},":flag_ls:":{"unicode":["1f1f1-1f1f8"],"isCanonical": true},":ls:":{"unicode":["1f1f1-1f1f8"],"isCanonical": false},":flag_lr:":{"unicode":["1f1f1-1f1f7"],"isCanonical": true},":lr:":{"unicode":["1f1f1-1f1f7"],"isCanonical": false},":flag_lk:":{"unicode":["1f1f1-1f1f0"],"isCanonical": true},":lk:":{"unicode":["1f1f1-1f1f0"],"isCanonical": false},":flag_li:":{"unicode":["1f1f1-1f1ee"],"isCanonical": true},":li:":{"unicode":["1f1f1-1f1ee"],"isCanonical": false},":flag_lc:":{"unicode":["1f1f1-1f1e8"],"isCanonical": true},":lc:":{"unicode":["1f1f1-1f1e8"],"isCanonical": false},":flag_lb:":{"unicode":["1f1f1-1f1e7"],"isCanonical": true},":lb:":{"unicode":["1f1f1-1f1e7"],"isCanonical": false},":flag_la:":{"unicode":["1f1f1-1f1e6"],"isCanonical": true},":la:":{"unicode":["1f1f1-1f1e6"],"isCanonical": false},":flag_kz:":{"unicode":["1f1f0-1f1ff"],"isCanonical": true},":kz:":{"unicode":["1f1f0-1f1ff"],"isCanonical": false},":flag_ky:":{"unicode":["1f1f0-1f1fe"],"isCanonical": true},":ky:":{"unicode":["1f1f0-1f1fe"],"isCanonical": false},":flag_kw:":{"unicode":["1f1f0-1f1fc"],"isCanonical": true},":kw:":{"unicode":["1f1f0-1f1fc"],"isCanonical": false},":flag_kr:":{"unicode":["1f1f0-1f1f7"],"isCanonical": true},":kr:":{"unicode":["1f1f0-1f1f7"],"isCanonical": false},":flag_kp:":{"unicode":["1f1f0-1f1f5"],"isCanonical": true},":kp:":{"unicode":["1f1f0-1f1f5"],"isCanonical": false},":flag_kn:":{"unicode":["1f1f0-1f1f3"],"isCanonical": true},":kn:":{"unicode":["1f1f0-1f1f3"],"isCanonical": false},":flag_km:":{"unicode":["1f1f0-1f1f2"],"isCanonical": true},":km:":{"unicode":["1f1f0-1f1f2"],"isCanonical": false},":flag_ki:":{"unicode":["1f1f0-1f1ee"],"isCanonical": true},":ki:":{"unicode":["1f1f0-1f1ee"],"isCanonical": false},":flag_kh:":{"unicode":["1f1f0-1f1ed"],"isCanonical": true},":kh:":{"unicode":["1f1f0-1f1ed"],"isCanonical": false},":flag_kg:":{"unicode":["1f1f0-1f1ec"],"isCanonical": true},":kg:":{"unicode":["1f1f0-1f1ec"],"isCanonical": false},":flag_ke:":{"unicode":["1f1f0-1f1ea"],"isCanonical": true},":ke:":{"unicode":["1f1f0-1f1ea"],"isCanonical": false},":flag_jp:":{"unicode":["1f1ef-1f1f5"],"isCanonical": true},":jp:":{"unicode":["1f1ef-1f1f5"],"isCanonical": false},":flag_jo:":{"unicode":["1f1ef-1f1f4"],"isCanonical": true},":jo:":{"unicode":["1f1ef-1f1f4"],"isCanonical": false},":flag_jm:":{"unicode":["1f1ef-1f1f2"],"isCanonical": true},":jm:":{"unicode":["1f1ef-1f1f2"],"isCanonical": false},":flag_je:":{"unicode":["1f1ef-1f1ea"],"isCanonical": true},":je:":{"unicode":["1f1ef-1f1ea"],"isCanonical": false},":flag_it:":{"unicode":["1f1ee-1f1f9"],"isCanonical": true},":it:":{"unicode":["1f1ee-1f1f9"],"isCanonical": false},":flag_is:":{"unicode":["1f1ee-1f1f8"],"isCanonical": true},":is:":{"unicode":["1f1ee-1f1f8"],"isCanonical": false},":flag_ir:":{"unicode":["1f1ee-1f1f7"],"isCanonical": true},":ir:":{"unicode":["1f1ee-1f1f7"],"isCanonical": false},":flag_iq:":{"unicode":["1f1ee-1f1f6"],"isCanonical": true},":iq:":{"unicode":["1f1ee-1f1f6"],"isCanonical": false},":flag_io:":{"unicode":["1f1ee-1f1f4"],"isCanonical": true},":io:":{"unicode":["1f1ee-1f1f4"],"isCanonical": false},":flag_in:":{"unicode":["1f1ee-1f1f3"],"isCanonical": true},":in:":{"unicode":["1f1ee-1f1f3"],"isCanonical": false},":flag_im:":{"unicode":["1f1ee-1f1f2"],"isCanonical": true},":im:":{"unicode":["1f1ee-1f1f2"],"isCanonical": false},":flag_il:":{"unicode":["1f1ee-1f1f1"],"isCanonical": true},":il:":{"unicode":["1f1ee-1f1f1"],"isCanonical": false},":flag_ie:":{"unicode":["1f1ee-1f1ea"],"isCanonical": true},":ie:":{"unicode":["1f1ee-1f1ea"],"isCanonical": false},":flag_id:":{"unicode":["1f1ee-1f1e9"],"isCanonical": true},":indonesia:":{"unicode":["1f1ee-1f1e9"],"isCanonical": false},":flag_ic:":{"unicode":["1f1ee-1f1e8"],"isCanonical": true},":ic:":{"unicode":["1f1ee-1f1e8"],"isCanonical": false},":flag_hu:":{"unicode":["1f1ed-1f1fa"],"isCanonical": true},":hu:":{"unicode":["1f1ed-1f1fa"],"isCanonical": false},":flag_ht:":{"unicode":["1f1ed-1f1f9"],"isCanonical": true},":ht:":{"unicode":["1f1ed-1f1f9"],"isCanonical": false},":flag_hr:":{"unicode":["1f1ed-1f1f7"],"isCanonical": true},":hr:":{"unicode":["1f1ed-1f1f7"],"isCanonical": false},":flag_hn:":{"unicode":["1f1ed-1f1f3"],"isCanonical": true},":hn:":{"unicode":["1f1ed-1f1f3"],"isCanonical": false},":flag_hm:":{"unicode":["1f1ed-1f1f2"],"isCanonical": true},":hm:":{"unicode":["1f1ed-1f1f2"],"isCanonical": false},":flag_hk:":{"unicode":["1f1ed-1f1f0"],"isCanonical": true},":hk:":{"unicode":["1f1ed-1f1f0"],"isCanonical": false},":flag_gy:":{"unicode":["1f1ec-1f1fe"],"isCanonical": true},":gy:":{"unicode":["1f1ec-1f1fe"],"isCanonical": false},":flag_gw:":{"unicode":["1f1ec-1f1fc"],"isCanonical": true},":gw:":{"unicode":["1f1ec-1f1fc"],"isCanonical": false},":flag_gu:":{"unicode":["1f1ec-1f1fa"],"isCanonical": true},":gu:":{"unicode":["1f1ec-1f1fa"],"isCanonical": false},":flag_gt:":{"unicode":["1f1ec-1f1f9"],"isCanonical": true},":gt:":{"unicode":["1f1ec-1f1f9"],"isCanonical": false},":flag_gs:":{"unicode":["1f1ec-1f1f8"],"isCanonical": true},":gs:":{"unicode":["1f1ec-1f1f8"],"isCanonical": false},":flag_gr:":{"unicode":["1f1ec-1f1f7"],"isCanonical": true},":gr:":{"unicode":["1f1ec-1f1f7"],"isCanonical": false},":flag_gq:":{"unicode":["1f1ec-1f1f6"],"isCanonical": true},":gq:":{"unicode":["1f1ec-1f1f6"],"isCanonical": false},":flag_gp:":{"unicode":["1f1ec-1f1f5"],"isCanonical": true},":gp:":{"unicode":["1f1ec-1f1f5"],"isCanonical": false},":flag_gn:":{"unicode":["1f1ec-1f1f3"],"isCanonical": true},":gn:":{"unicode":["1f1ec-1f1f3"],"isCanonical": false},":flag_gm:":{"unicode":["1f1ec-1f1f2"],"isCanonical": true},":gm:":{"unicode":["1f1ec-1f1f2"],"isCanonical": false},":flag_gl:":{"unicode":["1f1ec-1f1f1"],"isCanonical": true},":gl:":{"unicode":["1f1ec-1f1f1"],"isCanonical": false},":flag_gi:":{"unicode":["1f1ec-1f1ee"],"isCanonical": true},":gi:":{"unicode":["1f1ec-1f1ee"],"isCanonical": false},":flag_gh:":{"unicode":["1f1ec-1f1ed"],"isCanonical": true},":gh:":{"unicode":["1f1ec-1f1ed"],"isCanonical": false},":flag_gg:":{"unicode":["1f1ec-1f1ec"],"isCanonical": true},":gg:":{"unicode":["1f1ec-1f1ec"],"isCanonical": false},":flag_gf:":{"unicode":["1f1ec-1f1eb"],"isCanonical": true},":gf:":{"unicode":["1f1ec-1f1eb"],"isCanonical": false},":flag_ge:":{"unicode":["1f1ec-1f1ea"],"isCanonical": true},":ge:":{"unicode":["1f1ec-1f1ea"],"isCanonical": false},":flag_gd:":{"unicode":["1f1ec-1f1e9"],"isCanonical": true},":gd:":{"unicode":["1f1ec-1f1e9"],"isCanonical": false},":flag_gb:":{"unicode":["1f1ec-1f1e7"],"isCanonical": true},":gb:":{"unicode":["1f1ec-1f1e7"],"isCanonical": false},":flag_ga:":{"unicode":["1f1ec-1f1e6"],"isCanonical": true},":ga:":{"unicode":["1f1ec-1f1e6"],"isCanonical": false},":flag_fr:":{"unicode":["1f1eb-1f1f7"],"isCanonical": true},":fr:":{"unicode":["1f1eb-1f1f7"],"isCanonical": false},":flag_fo:":{"unicode":["1f1eb-1f1f4"],"isCanonical": true},":fo:":{"unicode":["1f1eb-1f1f4"],"isCanonical": false},":flag_fm:":{"unicode":["1f1eb-1f1f2"],"isCanonical": true},":fm:":{"unicode":["1f1eb-1f1f2"],"isCanonical": false},":flag_fk:":{"unicode":["1f1eb-1f1f0"],"isCanonical": true},":fk:":{"unicode":["1f1eb-1f1f0"],"isCanonical": false},":flag_fj:":{"unicode":["1f1eb-1f1ef"],"isCanonical": true},":fj:":{"unicode":["1f1eb-1f1ef"],"isCanonical": false},":flag_fi:":{"unicode":["1f1eb-1f1ee"],"isCanonical": true},":fi:":{"unicode":["1f1eb-1f1ee"],"isCanonical": false},":flag_eu:":{"unicode":["1f1ea-1f1fa"],"isCanonical": true},":eu:":{"unicode":["1f1ea-1f1fa"],"isCanonical": false},":flag_et:":{"unicode":["1f1ea-1f1f9"],"isCanonical": true},":et:":{"unicode":["1f1ea-1f1f9"],"isCanonical": false},":flag_es:":{"unicode":["1f1ea-1f1f8"],"isCanonical": true},":es:":{"unicode":["1f1ea-1f1f8"],"isCanonical": false},":flag_er:":{"unicode":["1f1ea-1f1f7"],"isCanonical": true},":er:":{"unicode":["1f1ea-1f1f7"],"isCanonical": false},":flag_eh:":{"unicode":["1f1ea-1f1ed"],"isCanonical": true},":eh:":{"unicode":["1f1ea-1f1ed"],"isCanonical": false},":flag_eg:":{"unicode":["1f1ea-1f1ec"],"isCanonical": true},":eg:":{"unicode":["1f1ea-1f1ec"],"isCanonical": false},":flag_ee:":{"unicode":["1f1ea-1f1ea"],"isCanonical": true},":ee:":{"unicode":["1f1ea-1f1ea"],"isCanonical": false},":flag_ec:":{"unicode":["1f1ea-1f1e8"],"isCanonical": true},":ec:":{"unicode":["1f1ea-1f1e8"],"isCanonical": false},":flag_ea:":{"unicode":["1f1ea-1f1e6"],"isCanonical": true},":ea:":{"unicode":["1f1ea-1f1e6"],"isCanonical": false},":flag_dz:":{"unicode":["1f1e9-1f1ff"],"isCanonical": true},":dz:":{"unicode":["1f1e9-1f1ff"],"isCanonical": false},":flag_do:":{"unicode":["1f1e9-1f1f4"],"isCanonical": true},":do:":{"unicode":["1f1e9-1f1f4"],"isCanonical": false},":flag_dm:":{"unicode":["1f1e9-1f1f2"],"isCanonical": true},":dm:":{"unicode":["1f1e9-1f1f2"],"isCanonical": false},":flag_dk:":{"unicode":["1f1e9-1f1f0"],"isCanonical": true},":dk:":{"unicode":["1f1e9-1f1f0"],"isCanonical": false},":flag_dj:":{"unicode":["1f1e9-1f1ef"],"isCanonical": true},":dj:":{"unicode":["1f1e9-1f1ef"],"isCanonical": false},":flag_dg:":{"unicode":["1f1e9-1f1ec"],"isCanonical": true},":dg:":{"unicode":["1f1e9-1f1ec"],"isCanonical": false},":flag_de:":{"unicode":["1f1e9-1f1ea"],"isCanonical": true},":de:":{"unicode":["1f1e9-1f1ea"],"isCanonical": false},":flag_cz:":{"unicode":["1f1e8-1f1ff"],"isCanonical": true},":cz:":{"unicode":["1f1e8-1f1ff"],"isCanonical": false},":flag_cy:":{"unicode":["1f1e8-1f1fe"],"isCanonical": true},":cy:":{"unicode":["1f1e8-1f1fe"],"isCanonical": false},":flag_cx:":{"unicode":["1f1e8-1f1fd"],"isCanonical": true},":cx:":{"unicode":["1f1e8-1f1fd"],"isCanonical": false},":flag_cw:":{"unicode":["1f1e8-1f1fc"],"isCanonical": true},":cw:":{"unicode":["1f1e8-1f1fc"],"isCanonical": false},":flag_cv:":{"unicode":["1f1e8-1f1fb"],"isCanonical": true},":cv:":{"unicode":["1f1e8-1f1fb"],"isCanonical": false},":flag_cu:":{"unicode":["1f1e8-1f1fa"],"isCanonical": true},":cu:":{"unicode":["1f1e8-1f1fa"],"isCanonical": false},":flag_cr:":{"unicode":["1f1e8-1f1f7"],"isCanonical": true},":cr:":{"unicode":["1f1e8-1f1f7"],"isCanonical": false},":flag_cp:":{"unicode":["1f1e8-1f1f5"],"isCanonical": true},":cp:":{"unicode":["1f1e8-1f1f5"],"isCanonical": false},":flag_co:":{"unicode":["1f1e8-1f1f4"],"isCanonical": true},":co:":{"unicode":["1f1e8-1f1f4"],"isCanonical": false},":flag_cn:":{"unicode":["1f1e8-1f1f3"],"isCanonical": true},":cn:":{"unicode":["1f1e8-1f1f3"],"isCanonical": false},":flag_cm:":{"unicode":["1f1e8-1f1f2"],"isCanonical": true},":cm:":{"unicode":["1f1e8-1f1f2"],"isCanonical": false},":flag_cl:":{"unicode":["1f1e8-1f1f1"],"isCanonical": true},":chile:":{"unicode":["1f1e8-1f1f1"],"isCanonical": false},":flag_ck:":{"unicode":["1f1e8-1f1f0"],"isCanonical": true},":ck:":{"unicode":["1f1e8-1f1f0"],"isCanonical": false},":flag_ci:":{"unicode":["1f1e8-1f1ee"],"isCanonical": true},":ci:":{"unicode":["1f1e8-1f1ee"],"isCanonical": false},":flag_ch:":{"unicode":["1f1e8-1f1ed"],"isCanonical": true},":ch:":{"unicode":["1f1e8-1f1ed"],"isCanonical": false},":flag_cg:":{"unicode":["1f1e8-1f1ec"],"isCanonical": true},":cg:":{"unicode":["1f1e8-1f1ec"],"isCanonical": false},":flag_cf:":{"unicode":["1f1e8-1f1eb"],"isCanonical": true},":cf:":{"unicode":["1f1e8-1f1eb"],"isCanonical": false},":flag_cd:":{"unicode":["1f1e8-1f1e9"],"isCanonical": true},":congo:":{"unicode":["1f1e8-1f1e9"],"isCanonical": false},":flag_cc:":{"unicode":["1f1e8-1f1e8"],"isCanonical": true},":cc:":{"unicode":["1f1e8-1f1e8"],"isCanonical": false},":flag_ca:":{"unicode":["1f1e8-1f1e6"],"isCanonical": true},":ca:":{"unicode":["1f1e8-1f1e6"],"isCanonical": false},":flag_bz:":{"unicode":["1f1e7-1f1ff"],"isCanonical": true},":bz:":{"unicode":["1f1e7-1f1ff"],"isCanonical": false},":flag_by:":{"unicode":["1f1e7-1f1fe"],"isCanonical": true},":by:":{"unicode":["1f1e7-1f1fe"],"isCanonical": false},":flag_bw:":{"unicode":["1f1e7-1f1fc"],"isCanonical": true},":bw:":{"unicode":["1f1e7-1f1fc"],"isCanonical": false},":flag_bv:":{"unicode":["1f1e7-1f1fb"],"isCanonical": true},":bv:":{"unicode":["1f1e7-1f1fb"],"isCanonical": false},":flag_bt:":{"unicode":["1f1e7-1f1f9"],"isCanonical": true},":bt:":{"unicode":["1f1e7-1f1f9"],"isCanonical": false},":flag_bs:":{"unicode":["1f1e7-1f1f8"],"isCanonical": true},":bs:":{"unicode":["1f1e7-1f1f8"],"isCanonical": false},":flag_br:":{"unicode":["1f1e7-1f1f7"],"isCanonical": true},":br:":{"unicode":["1f1e7-1f1f7"],"isCanonical": false},":flag_bq:":{"unicode":["1f1e7-1f1f6"],"isCanonical": true},":bq:":{"unicode":["1f1e7-1f1f6"],"isCanonical": false},":flag_bo:":{"unicode":["1f1e7-1f1f4"],"isCanonical": true},":bo:":{"unicode":["1f1e7-1f1f4"],"isCanonical": false},":flag_bn:":{"unicode":["1f1e7-1f1f3"],"isCanonical": true},":bn:":{"unicode":["1f1e7-1f1f3"],"isCanonical": false},":flag_bm:":{"unicode":["1f1e7-1f1f2"],"isCanonical": true},":bm:":{"unicode":["1f1e7-1f1f2"],"isCanonical": false},":flag_bl:":{"unicode":["1f1e7-1f1f1"],"isCanonical": true},":bl:":{"unicode":["1f1e7-1f1f1"],"isCanonical": false},":flag_bj:":{"unicode":["1f1e7-1f1ef"],"isCanonical": true},":bj:":{"unicode":["1f1e7-1f1ef"],"isCanonical": false},":flag_bi:":{"unicode":["1f1e7-1f1ee"],"isCanonical": true},":bi:":{"unicode":["1f1e7-1f1ee"],"isCanonical": false},":flag_bh:":{"unicode":["1f1e7-1f1ed"],"isCanonical": true},":bh:":{"unicode":["1f1e7-1f1ed"],"isCanonical": false},":flag_bg:":{"unicode":["1f1e7-1f1ec"],"isCanonical": true},":bg:":{"unicode":["1f1e7-1f1ec"],"isCanonical": false},":flag_bf:":{"unicode":["1f1e7-1f1eb"],"isCanonical": true},":bf:":{"unicode":["1f1e7-1f1eb"],"isCanonical": false},":flag_be:":{"unicode":["1f1e7-1f1ea"],"isCanonical": true},":be:":{"unicode":["1f1e7-1f1ea"],"isCanonical": false},":flag_bd:":{"unicode":["1f1e7-1f1e9"],"isCanonical": true},":bd:":{"unicode":["1f1e7-1f1e9"],"isCanonical": false},":flag_bb:":{"unicode":["1f1e7-1f1e7"],"isCanonical": true},":bb:":{"unicode":["1f1e7-1f1e7"],"isCanonical": false},":flag_ba:":{"unicode":["1f1e7-1f1e6"],"isCanonical": true},":ba:":{"unicode":["1f1e7-1f1e6"],"isCanonical": false},":flag_az:":{"unicode":["1f1e6-1f1ff"],"isCanonical": true},":az:":{"unicode":["1f1e6-1f1ff"],"isCanonical": false},":flag_ax:":{"unicode":["1f1e6-1f1fd"],"isCanonical": true},":ax:":{"unicode":["1f1e6-1f1fd"],"isCanonical": false},":flag_aw:":{"unicode":["1f1e6-1f1fc"],"isCanonical": true},":aw:":{"unicode":["1f1e6-1f1fc"],"isCanonical": false},":flag_au:":{"unicode":["1f1e6-1f1fa"],"isCanonical": true},":au:":{"unicode":["1f1e6-1f1fa"],"isCanonical": false},":flag_at:":{"unicode":["1f1e6-1f1f9"],"isCanonical": true},":at:":{"unicode":["1f1e6-1f1f9"],"isCanonical": false},":flag_as:":{"unicode":["1f1e6-1f1f8"],"isCanonical": true},":as:":{"unicode":["1f1e6-1f1f8"],"isCanonical": false},":flag_ar:":{"unicode":["1f1e6-1f1f7"],"isCanonical": true},":ar:":{"unicode":["1f1e6-1f1f7"],"isCanonical": false},":flag_aq:":{"unicode":["1f1e6-1f1f6"],"isCanonical": true},":aq:":{"unicode":["1f1e6-1f1f6"],"isCanonical": false},":flag_ao:":{"unicode":["1f1e6-1f1f4"],"isCanonical": true},":ao:":{"unicode":["1f1e6-1f1f4"],"isCanonical": false},":flag_am:":{"unicode":["1f1e6-1f1f2"],"isCanonical": true},":am:":{"unicode":["1f1e6-1f1f2"],"isCanonical": false},":flag_al:":{"unicode":["1f1e6-1f1f1"],"isCanonical": true},":al:":{"unicode":["1f1e6-1f1f1"],"isCanonical": false},":flag_ai:":{"unicode":["1f1e6-1f1ee"],"isCanonical": true},":ai:":{"unicode":["1f1e6-1f1ee"],"isCanonical": false},":flag_ag:":{"unicode":["1f1e6-1f1ec"],"isCanonical": true},":ag:":{"unicode":["1f1e6-1f1ec"],"isCanonical": false},":flag_af:":{"unicode":["1f1e6-1f1eb"],"isCanonical": true},":af:":{"unicode":["1f1e6-1f1eb"],"isCanonical": false},":flag_ae:":{"unicode":["1f1e6-1f1ea"],"isCanonical": true},":ae:":{"unicode":["1f1e6-1f1ea"],"isCanonical": false},":flag_ad:":{"unicode":["1f1e6-1f1e9"],"isCanonical": true},":ad:":{"unicode":["1f1e6-1f1e9"],"isCanonical": false},":flag_ac:":{"unicode":["1f1e6-1f1e8"],"isCanonical": true},":ac:":{"unicode":["1f1e6-1f1e8"],"isCanonical": false},":mahjong:":{"unicode":["1f004-fe0f","1f004"],"isCanonical": true},":parking:":{"unicode":["1f17f-fe0f","1f17f"],"isCanonical": true},":sa:":{"unicode":["1f202-fe0f","1f202"],"isCanonical": true},":u7121:":{"unicode":["1f21a-fe0f","1f21a"],"isCanonical": true},":u6307:":{"unicode":["1f22f-fe0f","1f22f"],"isCanonical": true},":u6708:":{"unicode":["1f237-fe0f","1f237"],"isCanonical": true},":film_frames:":{"unicode":["1f39e-fe0f","1f39e"],"isCanonical": true},":tickets:":{"unicode":["1f39f-fe0f","1f39f"],"isCanonical": true},":admission_tickets:":{"unicode":["1f39f-fe0f","1f39f"],"isCanonical": false},":lifter:":{"unicode":["1f3cb-fe0f","1f3cb"],"isCanonical": true},":weight_lifter:":{"unicode":["1f3cb-fe0f","1f3cb"],"isCanonical": false},":golfer:":{"unicode":["1f3cc-fe0f","1f3cc"],"isCanonical": true},":motorcycle:":{"unicode":["1f3cd-fe0f","1f3cd"],"isCanonical": true},":racing_motorcycle:":{"unicode":["1f3cd-fe0f","1f3cd"],"isCanonical": false},":race_car:":{"unicode":["1f3ce-fe0f","1f3ce"],"isCanonical": true},":racing_car:":{"unicode":["1f3ce-fe0f","1f3ce"],"isCanonical": false},":military_medal:":{"unicode":["1f396-fe0f","1f396"],"isCanonical": true},":reminder_ribbon:":{"unicode":["1f397-fe0f","1f397"],"isCanonical": true},":hot_pepper:":{"unicode":["1f336-fe0f","1f336"],"isCanonical": true},":cloud_rain:":{"unicode":["1f327-fe0f","1f327"],"isCanonical": true},":cloud_with_rain:":{"unicode":["1f327-fe0f","1f327"],"isCanonical": false},":cloud_snow:":{"unicode":["1f328-fe0f","1f328"],"isCanonical": true},":cloud_with_snow:":{"unicode":["1f328-fe0f","1f328"],"isCanonical": false},":cloud_lightning:":{"unicode":["1f329-fe0f","1f329"],"isCanonical": true},":cloud_with_lightning:":{"unicode":["1f329-fe0f","1f329"],"isCanonical": false},":cloud_tornado:":{"unicode":["1f32a-fe0f","1f32a"],"isCanonical": true},":cloud_with_tornado:":{"unicode":["1f32a-fe0f","1f32a"],"isCanonical": false},":fog:":{"unicode":["1f32b-fe0f","1f32b"],"isCanonical": true},":wind_blowing_face:":{"unicode":["1f32c-fe0f","1f32c"],"isCanonical": true},":chipmunk:":{"unicode":["1f43f-fe0f","1f43f"],"isCanonical": true},":spider:":{"unicode":["1f577-fe0f","1f577"],"isCanonical": true},":spider_web:":{"unicode":["1f578-fe0f","1f578"],"isCanonical": true},":thermometer:":{"unicode":["1f321-fe0f","1f321"],"isCanonical": true},":microphone2:":{"unicode":["1f399-fe0f","1f399"],"isCanonical": true},":studio_microphone:":{"unicode":["1f399-fe0f","1f399"],"isCanonical": false},":level_slider:":{"unicode":["1f39a-fe0f","1f39a"],"isCanonical": true},":control_knobs:":{"unicode":["1f39b-fe0f","1f39b"],"isCanonical": true},":flag_white:":{"unicode":["1f3f3-fe0f","1f3f3"],"isCanonical": true},":waving_white_flag:":{"unicode":["1f3f3-fe0f","1f3f3"],"isCanonical": false},":rosette:":{"unicode":["1f3f5-fe0f","1f3f5"],"isCanonical": true},":label:":{"unicode":["1f3f7-fe0f","1f3f7"],"isCanonical": true},":projector:":{"unicode":["1f4fd-fe0f","1f4fd"],"isCanonical": true},":film_projector:":{"unicode":["1f4fd-fe0f","1f4fd"],"isCanonical": false},":om_symbol:":{"unicode":["1f549-fe0f","1f549"],"isCanonical": true},":dove:":{"unicode":["1f54a-fe0f","1f54a"],"isCanonical": true},":dove_of_peace:":{"unicode":["1f54a-fe0f","1f54a"],"isCanonical": false},":candle:":{"unicode":["1f56f-fe0f","1f56f"],"isCanonical": true},":clock:":{"unicode":["1f570-fe0f","1f570"],"isCanonical": true},":mantlepiece_clock:":{"unicode":["1f570-fe0f","1f570"],"isCanonical": false},":hole:":{"unicode":["1f573-fe0f","1f573"],"isCanonical": true},":dark_sunglasses:":{"unicode":["1f576-fe0f","1f576"],"isCanonical": true},":joystick:":{"unicode":["1f579-fe0f","1f579"],"isCanonical": true},":paperclips:":{"unicode":["1f587-fe0f","1f587"],"isCanonical": true},":linked_paperclips:":{"unicode":["1f587-fe0f","1f587"],"isCanonical": false},":pen_ballpoint:":{"unicode":["1f58a-fe0f","1f58a"],"isCanonical": true},":lower_left_ballpoint_pen:":{"unicode":["1f58a-fe0f","1f58a"],"isCanonical": false},":pen_fountain:":{"unicode":["1f58b-fe0f","1f58b"],"isCanonical": true},":lower_left_fountain_pen:":{"unicode":["1f58b-fe0f","1f58b"],"isCanonical": false},":paintbrush:":{"unicode":["1f58c-fe0f","1f58c"],"isCanonical": true},":lower_left_paintbrush:":{"unicode":["1f58c-fe0f","1f58c"],"isCanonical": false},":crayon:":{"unicode":["1f58d-fe0f","1f58d"],"isCanonical": true},":lower_left_crayon:":{"unicode":["1f58d-fe0f","1f58d"],"isCanonical": false},":desktop:":{"unicode":["1f5a5-fe0f","1f5a5"],"isCanonical": true},":desktop_computer:":{"unicode":["1f5a5-fe0f","1f5a5"],"isCanonical": false},":printer:":{"unicode":["1f5a8-fe0f","1f5a8"],"isCanonical": true},":trackball:":{"unicode":["1f5b2-fe0f","1f5b2"],"isCanonical": true},":frame_photo:":{"unicode":["1f5bc-fe0f","1f5bc"],"isCanonical": true},":frame_with_picture:":{"unicode":["1f5bc-fe0f","1f5bc"],"isCanonical": false},":dividers:":{"unicode":["1f5c2-fe0f","1f5c2"],"isCanonical": true},":card_index_dividers:":{"unicode":["1f5c2-fe0f","1f5c2"],"isCanonical": false},":card_box:":{"unicode":["1f5c3-fe0f","1f5c3"],"isCanonical": true},":card_file_box:":{"unicode":["1f5c3-fe0f","1f5c3"],"isCanonical": false},":file_cabinet:":{"unicode":["1f5c4-fe0f","1f5c4"],"isCanonical": true},":wastebasket:":{"unicode":["1f5d1-fe0f","1f5d1"],"isCanonical": true},":notepad_spiral:":{"unicode":["1f5d2-fe0f","1f5d2"],"isCanonical": true},":spiral_note_pad:":{"unicode":["1f5d2-fe0f","1f5d2"],"isCanonical": false},":calendar_spiral:":{"unicode":["1f5d3-fe0f","1f5d3"],"isCanonical": true},":spiral_calendar_pad:":{"unicode":["1f5d3-fe0f","1f5d3"],"isCanonical": false},":compression:":{"unicode":["1f5dc-fe0f","1f5dc"],"isCanonical": true},":key2:":{"unicode":["1f5dd-fe0f","1f5dd"],"isCanonical": true},":old_key:":{"unicode":["1f5dd-fe0f","1f5dd"],"isCanonical": false},":newspaper2:":{"unicode":["1f5de-fe0f","1f5de"],"isCanonical": true},":rolled_up_newspaper:":{"unicode":["1f5de-fe0f","1f5de"],"isCanonical": false},":dagger:":{"unicode":["1f5e1-fe0f","1f5e1"],"isCanonical": true},":dagger_knife:":{"unicode":["1f5e1-fe0f","1f5e1"],"isCanonical": false},":speaking_head:":{"unicode":["1f5e3-fe0f","1f5e3"],"isCanonical": true},":speaking_head_in_silhouette:":{"unicode":["1f5e3-fe0f","1f5e3"],"isCanonical": false},":anger_right:":{"unicode":["1f5ef-fe0f","1f5ef"],"isCanonical": true},":right_anger_bubble:":{"unicode":["1f5ef-fe0f","1f5ef"],"isCanonical": false},":ballot_box:":{"unicode":["1f5f3-fe0f","1f5f3"],"isCanonical": true},":ballot_box_with_ballot:":{"unicode":["1f5f3-fe0f","1f5f3"],"isCanonical": false},":map:":{"unicode":["1f5fa-fe0f","1f5fa"],"isCanonical": true},":world_map:":{"unicode":["1f5fa-fe0f","1f5fa"],"isCanonical": false},":tools:":{"unicode":["1f6e0-fe0f","1f6e0"],"isCanonical": true},":hammer_and_wrench:":{"unicode":["1f6e0-fe0f","1f6e0"],"isCanonical": false},":shield:":{"unicode":["1f6e1-fe0f","1f6e1"],"isCanonical": true},":oil:":{"unicode":["1f6e2-fe0f","1f6e2"],"isCanonical": true},":oil_drum:":{"unicode":["1f6e2-fe0f","1f6e2"],"isCanonical": false},":satellite_orbital:":{"unicode":["1f6f0-fe0f","1f6f0"],"isCanonical": true},":fork_knife_plate:":{"unicode":["1f37d-fe0f","1f37d"],"isCanonical": true},":fork_and_knife_with_plate:":{"unicode":["1f37d-fe0f","1f37d"],"isCanonical": false},":eye:":{"unicode":["1f441-fe0f","1f441"],"isCanonical": true},":levitate:":{"unicode":["1f574-fe0f","1f574"],"isCanonical": true},":man_in_business_suit_levitating:":{"unicode":["1f574-fe0f","1f574"],"isCanonical": false},":spy:":{"unicode":["1f575-fe0f","1f575"],"isCanonical": true},":sleuth_or_spy:":{"unicode":["1f575-fe0f","1f575"],"isCanonical": false},":hand_splayed:":{"unicode":["1f590-fe0f","1f590"],"isCanonical": true},":raised_hand_with_fingers_splayed:":{"unicode":["1f590-fe0f","1f590"],"isCanonical": false},":mountain_snow:":{"unicode":["1f3d4-fe0f","1f3d4"],"isCanonical": true},":snow_capped_mountain:":{"unicode":["1f3d4-fe0f","1f3d4"],"isCanonical": false},":camping:":{"unicode":["1f3d5-fe0f","1f3d5"],"isCanonical": true},":beach:":{"unicode":["1f3d6-fe0f","1f3d6"],"isCanonical": true},":beach_with_umbrella:":{"unicode":["1f3d6-fe0f","1f3d6"],"isCanonical": false},":construction_site:":{"unicode":["1f3d7-fe0f","1f3d7"],"isCanonical": true},":building_construction:":{"unicode":["1f3d7-fe0f","1f3d7"],"isCanonical": false},":homes:":{"unicode":["1f3d8-fe0f","1f3d8"],"isCanonical": true},":house_buildings:":{"unicode":["1f3d8-fe0f","1f3d8"],"isCanonical": false},":cityscape:":{"unicode":["1f3d9-fe0f","1f3d9"],"isCanonical": true},":house_abandoned:":{"unicode":["1f3da-fe0f","1f3da"],"isCanonical": true},":derelict_house_building:":{"unicode":["1f3da-fe0f","1f3da"],"isCanonical": false},":classical_building:":{"unicode":["1f3db-fe0f","1f3db"],"isCanonical": true},":desert:":{"unicode":["1f3dc-fe0f","1f3dc"],"isCanonical": true},":island:":{"unicode":["1f3dd-fe0f","1f3dd"],"isCanonical": true},":desert_island:":{"unicode":["1f3dd-fe0f","1f3dd"],"isCanonical": false},":park:":{"unicode":["1f3de-fe0f","1f3de"],"isCanonical": true},":national_park:":{"unicode":["1f3de-fe0f","1f3de"],"isCanonical": false},":stadium:":{"unicode":["1f3df-fe0f","1f3df"],"isCanonical": true},":couch:":{"unicode":["1f6cb-fe0f","1f6cb"],"isCanonical": true},":couch_and_lamp:":{"unicode":["1f6cb-fe0f","1f6cb"],"isCanonical": false},":shopping_bags:":{"unicode":["1f6cd-fe0f","1f6cd"],"isCanonical": true},":bellhop:":{"unicode":["1f6ce-fe0f","1f6ce"],"isCanonical": true},":bellhop_bell:":{"unicode":["1f6ce-fe0f","1f6ce"],"isCanonical": false},":bed:":{"unicode":["1f6cf-fe0f","1f6cf"],"isCanonical": true},":motorway:":{"unicode":["1f6e3-fe0f","1f6e3"],"isCanonical": true},":railway_track:":{"unicode":["1f6e4-fe0f","1f6e4"],"isCanonical": true},":railroad_track:":{"unicode":["1f6e4-fe0f","1f6e4"],"isCanonical": false},":motorboat:":{"unicode":["1f6e5-fe0f","1f6e5"],"isCanonical": true},":airplane_small:":{"unicode":["1f6e9-fe0f","1f6e9"],"isCanonical": true},":small_airplane:":{"unicode":["1f6e9-fe0f","1f6e9"],"isCanonical": false},":cruise_ship:":{"unicode":["1f6f3-fe0f","1f6f3"],"isCanonical": true},":passenger_ship:":{"unicode":["1f6f3-fe0f","1f6f3"],"isCanonical": false},":white_sun_small_cloud:":{"unicode":["1f324-fe0f","1f324"],"isCanonical": true},":white_sun_with_small_cloud:":{"unicode":["1f324-fe0f","1f324"],"isCanonical": false},":white_sun_cloud:":{"unicode":["1f325-fe0f","1f325"],"isCanonical": true},":white_sun_behind_cloud:":{"unicode":["1f325-fe0f","1f325"],"isCanonical": false},":white_sun_rain_cloud:":{"unicode":["1f326-fe0f","1f326"],"isCanonical": true},":white_sun_behind_cloud_with_rain:":{"unicode":["1f326-fe0f","1f326"],"isCanonical": false},":mouse_three_button:":{"unicode":["1f5b1-fe0f","1f5b1"],"isCanonical": true},":three_button_mouse:":{"unicode":["1f5b1-fe0f","1f5b1"],"isCanonical": false},":point_up_tone1:":{"unicode":["261d-1f3fb"],"isCanonical": true},":point_up_tone2:":{"unicode":["261d-1f3fc"],"isCanonical": true},":point_up_tone3:":{"unicode":["261d-1f3fd"],"isCanonical": true},":point_up_tone4:":{"unicode":["261d-1f3fe"],"isCanonical": true},":point_up_tone5:":{"unicode":["261d-1f3ff"],"isCanonical": true},":v_tone1:":{"unicode":["270c-1f3fb"],"isCanonical": true},":v_tone2:":{"unicode":["270c-1f3fc"],"isCanonical": true},":v_tone3:":{"unicode":["270c-1f3fd"],"isCanonical": true},":v_tone4:":{"unicode":["270c-1f3fe"],"isCanonical": true},":v_tone5:":{"unicode":["270c-1f3ff"],"isCanonical": true},":fist_tone1:":{"unicode":["270a-1f3fb"],"isCanonical": true},":fist_tone2:":{"unicode":["270a-1f3fc"],"isCanonical": true},":fist_tone3:":{"unicode":["270a-1f3fd"],"isCanonical": true},":fist_tone4:":{"unicode":["270a-1f3fe"],"isCanonical": true},":fist_tone5:":{"unicode":["270a-1f3ff"],"isCanonical": true},":raised_hand_tone1:":{"unicode":["270b-1f3fb"],"isCanonical": true},":raised_hand_tone2:":{"unicode":["270b-1f3fc"],"isCanonical": true},":raised_hand_tone3:":{"unicode":["270b-1f3fd"],"isCanonical": true},":raised_hand_tone4:":{"unicode":["270b-1f3fe"],"isCanonical": true},":raised_hand_tone5:":{"unicode":["270b-1f3ff"],"isCanonical": true},":writing_hand_tone1:":{"unicode":["270d-1f3fb"],"isCanonical": true},":writing_hand_tone2:":{"unicode":["270d-1f3fc"],"isCanonical": true},":writing_hand_tone3:":{"unicode":["270d-1f3fd"],"isCanonical": true},":writing_hand_tone4:":{"unicode":["270d-1f3fe"],"isCanonical": true},":writing_hand_tone5:":{"unicode":["270d-1f3ff"],"isCanonical": true},":basketball_player_tone1:":{"unicode":["26f9-1f3fb"],"isCanonical": true},":person_with_ball_tone1:":{"unicode":["26f9-1f3fb"],"isCanonical": false},":basketball_player_tone2:":{"unicode":["26f9-1f3fc"],"isCanonical": true},":person_with_ball_tone2:":{"unicode":["26f9-1f3fc"],"isCanonical": false},":basketball_player_tone3:":{"unicode":["26f9-1f3fd"],"isCanonical": true},":person_with_ball_tone3:":{"unicode":["26f9-1f3fd"],"isCanonical": false},":basketball_player_tone4:":{"unicode":["26f9-1f3fe"],"isCanonical": true},":person_with_ball_tone4:":{"unicode":["26f9-1f3fe"],"isCanonical": false},":basketball_player_tone5:":{"unicode":["26f9-1f3ff"],"isCanonical": true},":person_with_ball_tone5:":{"unicode":["26f9-1f3ff"],"isCanonical": false},":copyright:":{"unicode":["00a9-fe0f","00a9"],"isCanonical": true},":registered:":{"unicode":["00ae-fe0f","00ae"],"isCanonical": true},":bangbang:":{"unicode":["203c-fe0f","203c"],"isCanonical": true},":interrobang:":{"unicode":["2049-fe0f","2049"],"isCanonical": true},":tm:":{"unicode":["2122-fe0f","2122"],"isCanonical": true},":information_source:":{"unicode":["2139-fe0f","2139"],"isCanonical": true},":left_right_arrow:":{"unicode":["2194-fe0f","2194"],"isCanonical": true},":arrow_up_down:":{"unicode":["2195-fe0f","2195"],"isCanonical": true},":arrow_upper_left:":{"unicode":["2196-fe0f","2196"],"isCanonical": true},":arrow_upper_right:":{"unicode":["2197-fe0f","2197"],"isCanonical": true},":arrow_lower_right:":{"unicode":["2198-fe0f","2198"],"isCanonical": true},":arrow_lower_left:":{"unicode":["2199-fe0f","2199"],"isCanonical": true},":leftwards_arrow_with_hook:":{"unicode":["21a9-fe0f","21a9"],"isCanonical": true},":arrow_right_hook:":{"unicode":["21aa-fe0f","21aa"],"isCanonical": true},":watch:":{"unicode":["231a-fe0f","231a"],"isCanonical": true},":hourglass:":{"unicode":["231b-fe0f","231b"],"isCanonical": true},":m:":{"unicode":["24c2-fe0f","24c2"],"isCanonical": true},":black_small_square:":{"unicode":["25aa-fe0f","25aa"],"isCanonical": true},":white_small_square:":{"unicode":["25ab-fe0f","25ab"],"isCanonical": true},":arrow_forward:":{"unicode":["25b6-fe0f","25b6"],"isCanonical": true},":arrow_backward:":{"unicode":["25c0-fe0f","25c0"],"isCanonical": true},":white_medium_square:":{"unicode":["25fb-fe0f","25fb"],"isCanonical": true},":black_medium_square:":{"unicode":["25fc-fe0f","25fc"],"isCanonical": true},":white_medium_small_square:":{"unicode":["25fd-fe0f","25fd"],"isCanonical": true},":black_medium_small_square:":{"unicode":["25fe-fe0f","25fe"],"isCanonical": true},":sunny:":{"unicode":["2600-fe0f","2600"],"isCanonical": true},":cloud:":{"unicode":["2601-fe0f","2601"],"isCanonical": true},":telephone:":{"unicode":["260e-fe0f","260e"],"isCanonical": true},":ballot_box_with_check:":{"unicode":["2611-fe0f","2611"],"isCanonical": true},":umbrella:":{"unicode":["2614-fe0f","2614"],"isCanonical": true},":coffee:":{"unicode":["2615-fe0f","2615"],"isCanonical": true},":point_up:":{"unicode":["261d-fe0f","261d"],"isCanonical": true},":relaxed:":{"unicode":["263a-fe0f","263a"],"isCanonical": true},":aries:":{"unicode":["2648-fe0f","2648"],"isCanonical": true},":taurus:":{"unicode":["2649-fe0f","2649"],"isCanonical": true},":gemini:":{"unicode":["264a-fe0f","264a"],"isCanonical": true},":cancer:":{"unicode":["264b-fe0f","264b"],"isCanonical": true},":leo:":{"unicode":["264c-fe0f","264c"],"isCanonical": true},":virgo:":{"unicode":["264d-fe0f","264d"],"isCanonical": true},":libra:":{"unicode":["264e-fe0f","264e"],"isCanonical": true},":scorpius:":{"unicode":["264f-fe0f","264f"],"isCanonical": true},":sagittarius:":{"unicode":["2650-fe0f","2650"],"isCanonical": true},":capricorn:":{"unicode":["2651-fe0f","2651"],"isCanonical": true},":aquarius:":{"unicode":["2652-fe0f","2652"],"isCanonical": true},":pisces:":{"unicode":["2653-fe0f","2653"],"isCanonical": true},":spades:":{"unicode":["2660-fe0f","2660"],"isCanonical": true},":clubs:":{"unicode":["2663-fe0f","2663"],"isCanonical": true},":hearts:":{"unicode":["2665-fe0f","2665"],"isCanonical": true},":diamonds:":{"unicode":["2666-fe0f","2666"],"isCanonical": true},":hotsprings:":{"unicode":["2668-fe0f","2668"],"isCanonical": true},":recycle:":{"unicode":["267b-fe0f","267b"],"isCanonical": true},":wheelchair:":{"unicode":["267f-fe0f","267f"],"isCanonical": true},":anchor:":{"unicode":["2693-fe0f","2693"],"isCanonical": true},":warning:":{"unicode":["26a0-fe0f","26a0"],"isCanonical": true},":zap:":{"unicode":["26a1-fe0f","26a1"],"isCanonical": true},":white_circle:":{"unicode":["26aa-fe0f","26aa"],"isCanonical": true},":black_circle:":{"unicode":["26ab-fe0f","26ab"],"isCanonical": true},":soccer:":{"unicode":["26bd-fe0f","26bd"],"isCanonical": true},":baseball:":{"unicode":["26be-fe0f","26be"],"isCanonical": true},":snowman:":{"unicode":["26c4-fe0f","26c4"],"isCanonical": true},":partly_sunny:":{"unicode":["26c5-fe0f","26c5"],"isCanonical": true},":no_entry:":{"unicode":["26d4-fe0f","26d4"],"isCanonical": true},":church:":{"unicode":["26ea-fe0f","26ea"],"isCanonical": true},":fountain:":{"unicode":["26f2-fe0f","26f2"],"isCanonical": true},":golf:":{"unicode":["26f3-fe0f","26f3"],"isCanonical": true},":sailboat:":{"unicode":["26f5-fe0f","26f5"],"isCanonical": true},":tent:":{"unicode":["26fa-fe0f","26fa"],"isCanonical": true},":fuelpump:":{"unicode":["26fd-fe0f","26fd"],"isCanonical": true},":scissors:":{"unicode":["2702-fe0f","2702"],"isCanonical": true},":airplane:":{"unicode":["2708-fe0f","2708"],"isCanonical": true},":envelope:":{"unicode":["2709-fe0f","2709"],"isCanonical": true},":v:":{"unicode":["270c-fe0f","270c"],"isCanonical": true},":pencil2:":{"unicode":["270f-fe0f","270f"],"isCanonical": true},":black_nib:":{"unicode":["2712-fe0f","2712"],"isCanonical": true},":heavy_check_mark:":{"unicode":["2714-fe0f","2714"],"isCanonical": true},":heavy_multiplication_x:":{"unicode":["2716-fe0f","2716"],"isCanonical": true},":eight_spoked_asterisk:":{"unicode":["2733-fe0f","2733"],"isCanonical": true},":eight_pointed_black_star:":{"unicode":["2734-fe0f","2734"],"isCanonical": true},":snowflake:":{"unicode":["2744-fe0f","2744"],"isCanonical": true},":sparkle:":{"unicode":["2747-fe0f","2747"],"isCanonical": true},":exclamation:":{"unicode":["2757-fe0f","2757"],"isCanonical": true},":heart:":{"unicode":["2764-fe0f","2764"],"isCanonical": true},":arrow_right:":{"unicode":["27a1-fe0f","27a1"],"isCanonical": true},":arrow_heading_up:":{"unicode":["2934-fe0f","2934"],"isCanonical": true},":arrow_heading_down:":{"unicode":["2935-fe0f","2935"],"isCanonical": true},":arrow_left:":{"unicode":["2b05-fe0f","2b05"],"isCanonical": true},":arrow_up:":{"unicode":["2b06-fe0f","2b06"],"isCanonical": true},":arrow_down:":{"unicode":["2b07-fe0f","2b07"],"isCanonical": true},":black_large_square:":{"unicode":["2b1b-fe0f","2b1b"],"isCanonical": true},":white_large_square:":{"unicode":["2b1c-fe0f","2b1c"],"isCanonical": true},":star:":{"unicode":["2b50-fe0f","2b50"],"isCanonical": true},":o:":{"unicode":["2b55-fe0f","2b55"],"isCanonical": true},":wavy_dash:":{"unicode":["3030-fe0f","3030"],"isCanonical": true},":part_alternation_mark:":{"unicode":["303d-fe0f","303d"],"isCanonical": true},":congratulations:":{"unicode":["3297-fe0f","3297"],"isCanonical": true},":secret:":{"unicode":["3299-fe0f","3299"],"isCanonical": true},":cross:":{"unicode":["271d-fe0f","271d"],"isCanonical": true},":latin_cross:":{"unicode":["271d-fe0f","271d"],"isCanonical": false},":keyboard:":{"unicode":["2328-fe0f","2328"],"isCanonical": true},":writing_hand:":{"unicode":["270d-fe0f","270d"],"isCanonical": true},":track_next:":{"unicode":["23ed-fe0f","23ed"],"isCanonical": true},":next_track:":{"unicode":["23ed-fe0f","23ed"],"isCanonical": false},":track_previous:":{"unicode":["23ee-fe0f","23ee"],"isCanonical": true},":previous_track:":{"unicode":["23ee-fe0f","23ee"],"isCanonical": false},":play_pause:":{"unicode":["23ef-fe0f","23ef"],"isCanonical": true},":stopwatch:":{"unicode":["23f1-fe0f","23f1"],"isCanonical": true},":timer:":{"unicode":["23f2-fe0f","23f2"],"isCanonical": true},":timer_clock:":{"unicode":["23f2-fe0f","23f2"],"isCanonical": false},":pause_button:":{"unicode":["23f8-fe0f","23f8"],"isCanonical": true},":double_vertical_bar:":{"unicode":["23f8-fe0f","23f8"],"isCanonical": false},":stop_button:":{"unicode":["23f9-fe0f","23f9"],"isCanonical": true},":record_button:":{"unicode":["23fa-fe0f","23fa"],"isCanonical": true},":umbrella2:":{"unicode":["2602-fe0f","2602"],"isCanonical": true},":snowman2:":{"unicode":["2603-fe0f","2603"],"isCanonical": true},":comet:":{"unicode":["2604-fe0f","2604"],"isCanonical": true},":shamrock:":{"unicode":["2618-fe0f","2618"],"isCanonical": true},":skull_crossbones:":{"unicode":["2620-fe0f","2620"],"isCanonical": true},":skull_and_crossbones:":{"unicode":["2620-fe0f","2620"],"isCanonical": false},":radioactive:":{"unicode":["2622-fe0f","2622"],"isCanonical": true},":radioactive_sign:":{"unicode":["2622-fe0f","2622"],"isCanonical": false},":biohazard:":{"unicode":["2623-fe0f","2623"],"isCanonical": true},":biohazard_sign:":{"unicode":["2623-fe0f","2623"],"isCanonical": false},":orthodox_cross:":{"unicode":["2626-fe0f","2626"],"isCanonical": true},":star_and_crescent:":{"unicode":["262a-fe0f","262a"],"isCanonical": true},":peace:":{"unicode":["262e-fe0f","262e"],"isCanonical": true},":peace_symbol:":{"unicode":["262e-fe0f","262e"],"isCanonical": false},":yin_yang:":{"unicode":["262f-fe0f","262f"],"isCanonical": true},":wheel_of_dharma:":{"unicode":["2638-fe0f","2638"],"isCanonical": true},":frowning2:":{"unicode":["2639-fe0f","2639"],"isCanonical": true},":white_frowning_face:":{"unicode":["2639-fe0f","2639"],"isCanonical": false},":hammer_pick:":{"unicode":["2692-fe0f","2692"],"isCanonical": true},":hammer_and_pick:":{"unicode":["2692-fe0f","2692"],"isCanonical": false},":crossed_swords:":{"unicode":["2694-fe0f","2694"],"isCanonical": true},":scales:":{"unicode":["2696-fe0f","2696"],"isCanonical": true},":alembic:":{"unicode":["2697-fe0f","2697"],"isCanonical": true},":gear:":{"unicode":["2699-fe0f","2699"],"isCanonical": true},":atom:":{"unicode":["269b-fe0f","269b"],"isCanonical": true},":atom_symbol:":{"unicode":["269b-fe0f","269b"],"isCanonical": false},":fleur-de-lis:":{"unicode":["269c-fe0f","269c"],"isCanonical": true},":coffin:":{"unicode":["26b0-fe0f","26b0"],"isCanonical": true},":urn:":{"unicode":["26b1-fe0f","26b1"],"isCanonical": true},":funeral_urn:":{"unicode":["26b1-fe0f","26b1"],"isCanonical": false},":thunder_cloud_rain:":{"unicode":["26c8-fe0f","26c8"],"isCanonical": true},":thunder_cloud_and_rain:":{"unicode":["26c8-fe0f","26c8"],"isCanonical": false},":pick:":{"unicode":["26cf-fe0f","26cf"],"isCanonical": true},":helmet_with_cross:":{"unicode":["26d1-fe0f","26d1"],"isCanonical": true},":helmet_with_white_cross:":{"unicode":["26d1-fe0f","26d1"],"isCanonical": false},":chains:":{"unicode":["26d3-fe0f","26d3"],"isCanonical": true},":shinto_shrine:":{"unicode":["26e9-fe0f","26e9"],"isCanonical": true},":mountain:":{"unicode":["26f0-fe0f","26f0"],"isCanonical": true},":beach_umbrella:":{"unicode":["26f1-fe0f","26f1"],"isCanonical": true},":umbrella_on_ground:":{"unicode":["26f1-fe0f","26f1"],"isCanonical": false},":ferry:":{"unicode":["26f4-fe0f","26f4"],"isCanonical": true},":skier:":{"unicode":["26f7-fe0f","26f7"],"isCanonical": true},":ice_skate:":{"unicode":["26f8-fe0f","26f8"],"isCanonical": true},":basketball_player:":{"unicode":["26f9-fe0f","26f9"],"isCanonical": true},":person_with_ball:":{"unicode":["26f9-fe0f","26f9"],"isCanonical": false},":star_of_david:":{"unicode":["2721-fe0f","2721"],"isCanonical": true},":heart_exclamation:":{"unicode":["2763-fe0f","2763"],"isCanonical": true},":heavy_heart_exclamation_mark_ornament:":{"unicode":["2763-fe0f","2763"],"isCanonical": false},":black_joker:":{"unicode":["1f0cf"],"isCanonical": true},":a:":{"unicode":["1f170"],"isCanonical": true},":b:":{"unicode":["1f171"],"isCanonical": true},":o2:":{"unicode":["1f17e"],"isCanonical": true},":ab:":{"unicode":["1f18e"],"isCanonical": true},":cl:":{"unicode":["1f191"],"isCanonical": true},":cool:":{"unicode":["1f192"],"isCanonical": true},":free:":{"unicode":["1f193"],"isCanonical": true},":id:":{"unicode":["1f194"],"isCanonical": true},":new:":{"unicode":["1f195"],"isCanonical": true},":ng:":{"unicode":["1f196"],"isCanonical": true},":ok:":{"unicode":["1f197"],"isCanonical": true},":sos:":{"unicode":["1f198"],"isCanonical": true},":up:":{"unicode":["1f199"],"isCanonical": true},":vs:":{"unicode":["1f19a"],"isCanonical": true},":koko:":{"unicode":["1f201"],"isCanonical": true},":u7981:":{"unicode":["1f232"],"isCanonical": true},":u7a7a:":{"unicode":["1f233"],"isCanonical": true},":u5408:":{"unicode":["1f234"],"isCanonical": true},":u6e80:":{"unicode":["1f235"],"isCanonical": true},":u6709:":{"unicode":["1f236"],"isCanonical": true},":u7533:":{"unicode":["1f238"],"isCanonical": true},":u5272:":{"unicode":["1f239"],"isCanonical": true},":u55b6:":{"unicode":["1f23a"],"isCanonical": true},":ideograph_advantage:":{"unicode":["1f250"],"isCanonical": true},":accept:":{"unicode":["1f251"],"isCanonical": true},":cyclone:":{"unicode":["1f300"],"isCanonical": true},":foggy:":{"unicode":["1f301"],"isCanonical": true},":closed_umbrella:":{"unicode":["1f302"],"isCanonical": true},":night_with_stars:":{"unicode":["1f303"],"isCanonical": true},":sunrise_over_mountains:":{"unicode":["1f304"],"isCanonical": true},":sunrise:":{"unicode":["1f305"],"isCanonical": true},":city_dusk:":{"unicode":["1f306"],"isCanonical": true},":city_sunset:":{"unicode":["1f307"],"isCanonical": true},":city_sunrise:":{"unicode":["1f307"],"isCanonical": false},":rainbow:":{"unicode":["1f308"],"isCanonical": true},":bridge_at_night:":{"unicode":["1f309"],"isCanonical": true},":ocean:":{"unicode":["1f30a"],"isCanonical": true},":volcano:":{"unicode":["1f30b"],"isCanonical": true},":milky_way:":{"unicode":["1f30c"],"isCanonical": true},":earth_asia:":{"unicode":["1f30f"],"isCanonical": true},":new_moon:":{"unicode":["1f311"],"isCanonical": true},":first_quarter_moon:":{"unicode":["1f313"],"isCanonical": true},":waxing_gibbous_moon:":{"unicode":["1f314"],"isCanonical": true},":full_moon:":{"unicode":["1f315"],"isCanonical": true},":crescent_moon:":{"unicode":["1f319"],"isCanonical": true},":first_quarter_moon_with_face:":{"unicode":["1f31b"],"isCanonical": true},":star2:":{"unicode":["1f31f"],"isCanonical": true},":stars:":{"unicode":["1f320"],"isCanonical": true},":chestnut:":{"unicode":["1f330"],"isCanonical": true},":seedling:":{"unicode":["1f331"],"isCanonical": true},":palm_tree:":{"unicode":["1f334"],"isCanonical": true},":cactus:":{"unicode":["1f335"],"isCanonical": true},":tulip:":{"unicode":["1f337"],"isCanonical": true},":cherry_blossom:":{"unicode":["1f338"],"isCanonical": true},":rose:":{"unicode":["1f339"],"isCanonical": true},":hibiscus:":{"unicode":["1f33a"],"isCanonical": true},":sunflower:":{"unicode":["1f33b"],"isCanonical": true},":blossom:":{"unicode":["1f33c"],"isCanonical": true},":corn:":{"unicode":["1f33d"],"isCanonical": true},":ear_of_rice:":{"unicode":["1f33e"],"isCanonical": true},":herb:":{"unicode":["1f33f"],"isCanonical": true},":four_leaf_clover:":{"unicode":["1f340"],"isCanonical": true},":maple_leaf:":{"unicode":["1f341"],"isCanonical": true},":fallen_leaf:":{"unicode":["1f342"],"isCanonical": true},":leaves:":{"unicode":["1f343"],"isCanonical": true},":mushroom:":{"unicode":["1f344"],"isCanonical": true},":tomato:":{"unicode":["1f345"],"isCanonical": true},":eggplant:":{"unicode":["1f346"],"isCanonical": true},":grapes:":{"unicode":["1f347"],"isCanonical": true},":melon:":{"unicode":["1f348"],"isCanonical": true},":watermelon:":{"unicode":["1f349"],"isCanonical": true},":tangerine:":{"unicode":["1f34a"],"isCanonical": true},":banana:":{"unicode":["1f34c"],"isCanonical": true},":pineapple:":{"unicode":["1f34d"],"isCanonical": true},":apple:":{"unicode":["1f34e"],"isCanonical": true},":green_apple:":{"unicode":["1f34f"],"isCanonical": true},":peach:":{"unicode":["1f351"],"isCanonical": true},":cherries:":{"unicode":["1f352"],"isCanonical": true},":strawberry:":{"unicode":["1f353"],"isCanonical": true},":hamburger:":{"unicode":["1f354"],"isCanonical": true},":pizza:":{"unicode":["1f355"],"isCanonical": true},":meat_on_bone:":{"unicode":["1f356"],"isCanonical": true},":poultry_leg:":{"unicode":["1f357"],"isCanonical": true},":rice_cracker:":{"unicode":["1f358"],"isCanonical": true},":rice_ball:":{"unicode":["1f359"],"isCanonical": true},":rice:":{"unicode":["1f35a"],"isCanonical": true},":curry:":{"unicode":["1f35b"],"isCanonical": true},":ramen:":{"unicode":["1f35c"],"isCanonical": true},":spaghetti:":{"unicode":["1f35d"],"isCanonical": true},":bread:":{"unicode":["1f35e"],"isCanonical": true},":fries:":{"unicode":["1f35f"],"isCanonical": true},":sweet_potato:":{"unicode":["1f360"],"isCanonical": true},":dango:":{"unicode":["1f361"],"isCanonical": true},":oden:":{"unicode":["1f362"],"isCanonical": true},":sushi:":{"unicode":["1f363"],"isCanonical": true},":fried_shrimp:":{"unicode":["1f364"],"isCanonical": true},":fish_cake:":{"unicode":["1f365"],"isCanonical": true},":icecream:":{"unicode":["1f366"],"isCanonical": true},":shaved_ice:":{"unicode":["1f367"],"isCanonical": true},":ice_cream:":{"unicode":["1f368"],"isCanonical": true},":doughnut:":{"unicode":["1f369"],"isCanonical": true},":cookie:":{"unicode":["1f36a"],"isCanonical": true},":chocolate_bar:":{"unicode":["1f36b"],"isCanonical": true},":candy:":{"unicode":["1f36c"],"isCanonical": true},":lollipop:":{"unicode":["1f36d"],"isCanonical": true},":custard:":{"unicode":["1f36e"],"isCanonical": true},":pudding:":{"unicode":["1f36e"],"isCanonical": false},":flan:":{"unicode":["1f36e"],"isCanonical": false},":honey_pot:":{"unicode":["1f36f"],"isCanonical": true},":cake:":{"unicode":["1f370"],"isCanonical": true},":bento:":{"unicode":["1f371"],"isCanonical": true},":stew:":{"unicode":["1f372"],"isCanonical": true},":egg:":{"unicode":["1f373"],"isCanonical": true},":fork_and_knife:":{"unicode":["1f374"],"isCanonical": true},":tea:":{"unicode":["1f375"],"isCanonical": true},":sake:":{"unicode":["1f376"],"isCanonical": true},":wine_glass:":{"unicode":["1f377"],"isCanonical": true},":cocktail:":{"unicode":["1f378"],"isCanonical": true},":tropical_drink:":{"unicode":["1f379"],"isCanonical": true},":beer:":{"unicode":["1f37a"],"isCanonical": true},":beers:":{"unicode":["1f37b"],"isCanonical": true},":ribbon:":{"unicode":["1f380"],"isCanonical": true},":gift:":{"unicode":["1f381"],"isCanonical": true},":birthday:":{"unicode":["1f382"],"isCanonical": true},":jack_o_lantern:":{"unicode":["1f383"],"isCanonical": true},":christmas_tree:":{"unicode":["1f384"],"isCanonical": true},":santa:":{"unicode":["1f385"],"isCanonical": true},":fireworks:":{"unicode":["1f386"],"isCanonical": true},":sparkler:":{"unicode":["1f387"],"isCanonical": true},":balloon:":{"unicode":["1f388"],"isCanonical": true},":tada:":{"unicode":["1f389"],"isCanonical": true},":confetti_ball:":{"unicode":["1f38a"],"isCanonical": true},":tanabata_tree:":{"unicode":["1f38b"],"isCanonical": true},":crossed_flags:":{"unicode":["1f38c"],"isCanonical": true},":bamboo:":{"unicode":["1f38d"],"isCanonical": true},":dolls:":{"unicode":["1f38e"],"isCanonical": true},":flags:":{"unicode":["1f38f"],"isCanonical": true},":wind_chime:":{"unicode":["1f390"],"isCanonical": true},":rice_scene:":{"unicode":["1f391"],"isCanonical": true},":school_satchel:":{"unicode":["1f392"],"isCanonical": true},":mortar_board:":{"unicode":["1f393"],"isCanonical": true},":carousel_horse:":{"unicode":["1f3a0"],"isCanonical": true},":ferris_wheel:":{"unicode":["1f3a1"],"isCanonical": true},":roller_coaster:":{"unicode":["1f3a2"],"isCanonical": true},":fishing_pole_and_fish:":{"unicode":["1f3a3"],"isCanonical": true},":microphone:":{"unicode":["1f3a4"],"isCanonical": true},":movie_camera:":{"unicode":["1f3a5"],"isCanonical": true},":cinema:":{"unicode":["1f3a6"],"isCanonical": true},":headphones:":{"unicode":["1f3a7"],"isCanonical": true},":art:":{"unicode":["1f3a8"],"isCanonical": true},":tophat:":{"unicode":["1f3a9"],"isCanonical": true},":circus_tent:":{"unicode":["1f3aa"],"isCanonical": true},":ticket:":{"unicode":["1f3ab"],"isCanonical": true},":clapper:":{"unicode":["1f3ac"],"isCanonical": true},":performing_arts:":{"unicode":["1f3ad"],"isCanonical": true},":video_game:":{"unicode":["1f3ae"],"isCanonical": true},":dart:":{"unicode":["1f3af"],"isCanonical": true},":slot_machine:":{"unicode":["1f3b0"],"isCanonical": true},":8ball:":{"unicode":["1f3b1"],"isCanonical": true},":game_die:":{"unicode":["1f3b2"],"isCanonical": true},":bowling:":{"unicode":["1f3b3"],"isCanonical": true},":flower_playing_cards:":{"unicode":["1f3b4"],"isCanonical": true},":musical_note:":{"unicode":["1f3b5"],"isCanonical": true},":notes:":{"unicode":["1f3b6"],"isCanonical": true},":saxophone:":{"unicode":["1f3b7"],"isCanonical": true},":guitar:":{"unicode":["1f3b8"],"isCanonical": true},":musical_keyboard:":{"unicode":["1f3b9"],"isCanonical": true},":trumpet:":{"unicode":["1f3ba"],"isCanonical": true},":violin:":{"unicode":["1f3bb"],"isCanonical": true},":musical_score:":{"unicode":["1f3bc"],"isCanonical": true},":running_shirt_with_sash:":{"unicode":["1f3bd"],"isCanonical": true},":tennis:":{"unicode":["1f3be"],"isCanonical": true},":ski:":{"unicode":["1f3bf"],"isCanonical": true},":basketball:":{"unicode":["1f3c0"],"isCanonical": true},":checkered_flag:":{"unicode":["1f3c1"],"isCanonical": true},":snowboarder:":{"unicode":["1f3c2"],"isCanonical": true},":runner:":{"unicode":["1f3c3"],"isCanonical": true},":surfer:":{"unicode":["1f3c4"],"isCanonical": true},":trophy:":{"unicode":["1f3c6"],"isCanonical": true},":football:":{"unicode":["1f3c8"],"isCanonical": true},":swimmer:":{"unicode":["1f3ca"],"isCanonical": true},":house:":{"unicode":["1f3e0"],"isCanonical": true},":house_with_garden:":{"unicode":["1f3e1"],"isCanonical": true},":office:":{"unicode":["1f3e2"],"isCanonical": true},":post_office:":{"unicode":["1f3e3"],"isCanonical": true},":hospital:":{"unicode":["1f3e5"],"isCanonical": true},":bank:":{"unicode":["1f3e6"],"isCanonical": true},":atm:":{"unicode":["1f3e7"],"isCanonical": true},":hotel:":{"unicode":["1f3e8"],"isCanonical": true},":love_hotel:":{"unicode":["1f3e9"],"isCanonical": true},":convenience_store:":{"unicode":["1f3ea"],"isCanonical": true},":school:":{"unicode":["1f3eb"],"isCanonical": true},":department_store:":{"unicode":["1f3ec"],"isCanonical": true},":factory:":{"unicode":["1f3ed"],"isCanonical": true},":izakaya_lantern:":{"unicode":["1f3ee"],"isCanonical": true},":japanese_castle:":{"unicode":["1f3ef"],"isCanonical": true},":european_castle:":{"unicode":["1f3f0"],"isCanonical": true},":snail:":{"unicode":["1f40c"],"isCanonical": true},":snake:":{"unicode":["1f40d"],"isCanonical": true},":racehorse:":{"unicode":["1f40e"],"isCanonical": true},":sheep:":{"unicode":["1f411"],"isCanonical": true},":monkey:":{"unicode":["1f412"],"isCanonical": true},":chicken:":{"unicode":["1f414"],"isCanonical": true},":boar:":{"unicode":["1f417"],"isCanonical": true},":elephant:":{"unicode":["1f418"],"isCanonical": true},":octopus:":{"unicode":["1f419"],"isCanonical": true},":shell:":{"unicode":["1f41a"],"isCanonical": true},":bug:":{"unicode":["1f41b"],"isCanonical": true},":ant:":{"unicode":["1f41c"],"isCanonical": true},":bee:":{"unicode":["1f41d"],"isCanonical": true},":beetle:":{"unicode":["1f41e"],"isCanonical": true},":fish:":{"unicode":["1f41f"],"isCanonical": true},":tropical_fish:":{"unicode":["1f420"],"isCanonical": true},":blowfish:":{"unicode":["1f421"],"isCanonical": true},":turtle:":{"unicode":["1f422"],"isCanonical": true},":hatching_chick:":{"unicode":["1f423"],"isCanonical": true},":baby_chick:":{"unicode":["1f424"],"isCanonical": true},":hatched_chick:":{"unicode":["1f425"],"isCanonical": true},":bird:":{"unicode":["1f426"],"isCanonical": true},":penguin:":{"unicode":["1f427"],"isCanonical": true},":koala:":{"unicode":["1f428"],"isCanonical": true},":poodle:":{"unicode":["1f429"],"isCanonical": true},":camel:":{"unicode":["1f42b"],"isCanonical": true},":dolphin:":{"unicode":["1f42c"],"isCanonical": true},":mouse:":{"unicode":["1f42d"],"isCanonical": true},":cow:":{"unicode":["1f42e"],"isCanonical": true},":tiger:":{"unicode":["1f42f"],"isCanonical": true},":rabbit:":{"unicode":["1f430"],"isCanonical": true},":cat:":{"unicode":["1f431"],"isCanonical": true},":dragon_face:":{"unicode":["1f432"],"isCanonical": true},":whale:":{"unicode":["1f433"],"isCanonical": true},":horse:":{"unicode":["1f434"],"isCanonical": true},":monkey_face:":{"unicode":["1f435"],"isCanonical": true},":dog:":{"unicode":["1f436"],"isCanonical": true},":pig:":{"unicode":["1f437"],"isCanonical": true},":frog:":{"unicode":["1f438"],"isCanonical": true},":hamster:":{"unicode":["1f439"],"isCanonical": true},":wolf:":{"unicode":["1f43a"],"isCanonical": true},":bear:":{"unicode":["1f43b"],"isCanonical": true},":panda_face:":{"unicode":["1f43c"],"isCanonical": true},":pig_nose:":{"unicode":["1f43d"],"isCanonical": true},":feet:":{"unicode":["1f43e"],"isCanonical": true},":paw_prints:":{"unicode":["1f43e"],"isCanonical": false},":eyes:":{"unicode":["1f440"],"isCanonical": true},":ear:":{"unicode":["1f442"],"isCanonical": true},":nose:":{"unicode":["1f443"],"isCanonical": true},":lips:":{"unicode":["1f444"],"isCanonical": true},":tongue:":{"unicode":["1f445"],"isCanonical": true},":point_up_2:":{"unicode":["1f446"],"isCanonical": true},":point_down:":{"unicode":["1f447"],"isCanonical": true},":point_left:":{"unicode":["1f448"],"isCanonical": true},":point_right:":{"unicode":["1f449"],"isCanonical": true},":punch:":{"unicode":["1f44a"],"isCanonical": true},":wave:":{"unicode":["1f44b"],"isCanonical": true},":ok_hand:":{"unicode":["1f44c"],"isCanonical": true},":thumbsup:":{"unicode":["1f44d"],"isCanonical": true},":+1:":{"unicode":["1f44d"],"isCanonical": false},":thumbup:":{"unicode":["1f44d"],"isCanonical": false},":thumbsdown:":{"unicode":["1f44e"],"isCanonical": true},":-1:":{"unicode":["1f44e"],"isCanonical": false},":thumbdown:":{"unicode":["1f44e"],"isCanonical": false},":clap:":{"unicode":["1f44f"],"isCanonical": true},":open_hands:":{"unicode":["1f450"],"isCanonical": true},":crown:":{"unicode":["1f451"],"isCanonical": true},":womans_hat:":{"unicode":["1f452"],"isCanonical": true},":eyeglasses:":{"unicode":["1f453"],"isCanonical": true},":necktie:":{"unicode":["1f454"],"isCanonical": true},":shirt:":{"unicode":["1f455"],"isCanonical": true},":jeans:":{"unicode":["1f456"],"isCanonical": true},":dress:":{"unicode":["1f457"],"isCanonical": true},":kimono:":{"unicode":["1f458"],"isCanonical": true},":bikini:":{"unicode":["1f459"],"isCanonical": true},":womans_clothes:":{"unicode":["1f45a"],"isCanonical": true},":purse:":{"unicode":["1f45b"],"isCanonical": true},":handbag:":{"unicode":["1f45c"],"isCanonical": true},":pouch:":{"unicode":["1f45d"],"isCanonical": true},":mans_shoe:":{"unicode":["1f45e"],"isCanonical": true},":athletic_shoe:":{"unicode":["1f45f"],"isCanonical": true},":high_heel:":{"unicode":["1f460"],"isCanonical": true},":sandal:":{"unicode":["1f461"],"isCanonical": true},":boot:":{"unicode":["1f462"],"isCanonical": true},":footprints:":{"unicode":["1f463"],"isCanonical": true},":bust_in_silhouette:":{"unicode":["1f464"],"isCanonical": true},":boy:":{"unicode":["1f466"],"isCanonical": true},":girl:":{"unicode":["1f467"],"isCanonical": true},":man:":{"unicode":["1f468"],"isCanonical": true},":woman:":{"unicode":["1f469"],"isCanonical": true},":family:":{"unicode":["1f46a"],"isCanonical": true},":couple:":{"unicode":["1f46b"],"isCanonical": true},":cop:":{"unicode":["1f46e"],"isCanonical": true},":dancers:":{"unicode":["1f46f"],"isCanonical": true},":bride_with_veil:":{"unicode":["1f470"],"isCanonical": true},":person_with_blond_hair:":{"unicode":["1f471"],"isCanonical": true},":man_with_gua_pi_mao:":{"unicode":["1f472"],"isCanonical": true},":man_with_turban:":{"unicode":["1f473"],"isCanonical": true},":older_man:":{"unicode":["1f474"],"isCanonical": true},":older_woman:":{"unicode":["1f475"],"isCanonical": true},":grandma:":{"unicode":["1f475"],"isCanonical": false},":baby:":{"unicode":["1f476"],"isCanonical": true},":construction_worker:":{"unicode":["1f477"],"isCanonical": true},":princess:":{"unicode":["1f478"],"isCanonical": true},":japanese_ogre:":{"unicode":["1f479"],"isCanonical": true},":japanese_goblin:":{"unicode":["1f47a"],"isCanonical": true},":ghost:":{"unicode":["1f47b"],"isCanonical": true},":angel:":{"unicode":["1f47c"],"isCanonical": true},":alien:":{"unicode":["1f47d"],"isCanonical": true},":space_invader:":{"unicode":["1f47e"],"isCanonical": true},":imp:":{"unicode":["1f47f"],"isCanonical": true},":skull:":{"unicode":["1f480"],"isCanonical": true},":skeleton:":{"unicode":["1f480"],"isCanonical": false},":card_index:":{"unicode":["1f4c7"],"isCanonical": true},":information_desk_person:":{"unicode":["1f481"],"isCanonical": true},":guardsman:":{"unicode":["1f482"],"isCanonical": true},":dancer:":{"unicode":["1f483"],"isCanonical": true},":lipstick:":{"unicode":["1f484"],"isCanonical": true},":nail_care:":{"unicode":["1f485"],"isCanonical": true},":ledger:":{"unicode":["1f4d2"],"isCanonical": true},":massage:":{"unicode":["1f486"],"isCanonical": true},":notebook:":{"unicode":["1f4d3"],"isCanonical": true},":haircut:":{"unicode":["1f487"],"isCanonical": true},":notebook_with_decorative_cover:":{"unicode":["1f4d4"],"isCanonical": true},":barber:":{"unicode":["1f488"],"isCanonical": true},":closed_book:":{"unicode":["1f4d5"],"isCanonical": true},":syringe:":{"unicode":["1f489"],"isCanonical": true},":book:":{"unicode":["1f4d6"],"isCanonical": true},":pill:":{"unicode":["1f48a"],"isCanonical": true},":green_book:":{"unicode":["1f4d7"],"isCanonical": true},":kiss:":{"unicode":["1f48b"],"isCanonical": true},":blue_book:":{"unicode":["1f4d8"],"isCanonical": true},":love_letter:":{"unicode":["1f48c"],"isCanonical": true},":orange_book:":{"unicode":["1f4d9"],"isCanonical": true},":ring:":{"unicode":["1f48d"],"isCanonical": true},":books:":{"unicode":["1f4da"],"isCanonical": true},":gem:":{"unicode":["1f48e"],"isCanonical": true},":name_badge:":{"unicode":["1f4db"],"isCanonical": true},":couplekiss:":{"unicode":["1f48f"],"isCanonical": true},":scroll:":{"unicode":["1f4dc"],"isCanonical": true},":bouquet:":{"unicode":["1f490"],"isCanonical": true},":pencil:":{"unicode":["1f4dd"],"isCanonical": true},":couple_with_heart:":{"unicode":["1f491"],"isCanonical": true},":telephone_receiver:":{"unicode":["1f4de"],"isCanonical": true},":wedding:":{"unicode":["1f492"],"isCanonical": true},":pager:":{"unicode":["1f4df"],"isCanonical": true},":fax:":{"unicode":["1f4e0"],"isCanonical": true},":heartbeat:":{"unicode":["1f493"],"isCanonical": true},":satellite:":{"unicode":["1f4e1"],"isCanonical": true},":loudspeaker:":{"unicode":["1f4e2"],"isCanonical": true},":broken_heart:":{"unicode":["1f494"],"isCanonical": true},":mega:":{"unicode":["1f4e3"],"isCanonical": true},":outbox_tray:":{"unicode":["1f4e4"],"isCanonical": true},":two_hearts:":{"unicode":["1f495"],"isCanonical": true},":inbox_tray:":{"unicode":["1f4e5"],"isCanonical": true},":package:":{"unicode":["1f4e6"],"isCanonical": true},":sparkling_heart:":{"unicode":["1f496"],"isCanonical": true},":e-mail:":{"unicode":["1f4e7"],"isCanonical": true},":email:":{"unicode":["1f4e7"],"isCanonical": false},":incoming_envelope:":{"unicode":["1f4e8"],"isCanonical": true},":heartpulse:":{"unicode":["1f497"],"isCanonical": true},":envelope_with_arrow:":{"unicode":["1f4e9"],"isCanonical": true},":mailbox_closed:":{"unicode":["1f4ea"],"isCanonical": true},":cupid:":{"unicode":["1f498"],"isCanonical": true},":mailbox:":{"unicode":["1f4eb"],"isCanonical": true},":postbox:":{"unicode":["1f4ee"],"isCanonical": true},":blue_heart:":{"unicode":["1f499"],"isCanonical": true},":newspaper:":{"unicode":["1f4f0"],"isCanonical": true},":iphone:":{"unicode":["1f4f1"],"isCanonical": true},":green_heart:":{"unicode":["1f49a"],"isCanonical": true},":calling:":{"unicode":["1f4f2"],"isCanonical": true},":vibration_mode:":{"unicode":["1f4f3"],"isCanonical": true},":yellow_heart:":{"unicode":["1f49b"],"isCanonical": true},":mobile_phone_off:":{"unicode":["1f4f4"],"isCanonical": true},":signal_strength:":{"unicode":["1f4f6"],"isCanonical": true},":purple_heart:":{"unicode":["1f49c"],"isCanonical": true},":camera:":{"unicode":["1f4f7"],"isCanonical": true},":video_camera:":{"unicode":["1f4f9"],"isCanonical": true},":gift_heart:":{"unicode":["1f49d"],"isCanonical": true},":tv:":{"unicode":["1f4fa"],"isCanonical": true},":radio:":{"unicode":["1f4fb"],"isCanonical": true},":revolving_hearts:":{"unicode":["1f49e"],"isCanonical": true},":vhs:":{"unicode":["1f4fc"],"isCanonical": true},":arrows_clockwise:":{"unicode":["1f503"],"isCanonical": true},":heart_decoration:":{"unicode":["1f49f"],"isCanonical": true},":loud_sound:":{"unicode":["1f50a"],"isCanonical": true},":battery:":{"unicode":["1f50b"],"isCanonical": true},":diamond_shape_with_a_dot_inside:":{"unicode":["1f4a0"],"isCanonical": true},":electric_plug:":{"unicode":["1f50c"],"isCanonical": true},":mag:":{"unicode":["1f50d"],"isCanonical": true},":bulb:":{"unicode":["1f4a1"],"isCanonical": true},":mag_right:":{"unicode":["1f50e"],"isCanonical": true},":lock_with_ink_pen:":{"unicode":["1f50f"],"isCanonical": true},":anger:":{"unicode":["1f4a2"],"isCanonical": true},":closed_lock_with_key:":{"unicode":["1f510"],"isCanonical": true},":key:":{"unicode":["1f511"],"isCanonical": true},":bomb:":{"unicode":["1f4a3"],"isCanonical": true},":lock:":{"unicode":["1f512"],"isCanonical": true},":unlock:":{"unicode":["1f513"],"isCanonical": true},":zzz:":{"unicode":["1f4a4"],"isCanonical": true},":bell:":{"unicode":["1f514"],"isCanonical": true},":bookmark:":{"unicode":["1f516"],"isCanonical": true},":boom:":{"unicode":["1f4a5"],"isCanonical": true},":link:":{"unicode":["1f517"],"isCanonical": true},":radio_button:":{"unicode":["1f518"],"isCanonical": true},":sweat_drops:":{"unicode":["1f4a6"],"isCanonical": true},":back:":{"unicode":["1f519"],"isCanonical": true},":end:":{"unicode":["1f51a"],"isCanonical": true},":droplet:":{"unicode":["1f4a7"],"isCanonical": true},":on:":{"unicode":["1f51b"],"isCanonical": true},":soon:":{"unicode":["1f51c"],"isCanonical": true},":dash:":{"unicode":["1f4a8"],"isCanonical": true},":top:":{"unicode":["1f51d"],"isCanonical": true},":underage:":{"unicode":["1f51e"],"isCanonical": true},":poop:":{"unicode":["1f4a9"],"isCanonical": true},":shit:":{"unicode":["1f4a9"],"isCanonical": false},":hankey:":{"unicode":["1f4a9"],"isCanonical": false},":poo:":{"unicode":["1f4a9"],"isCanonical": false},":ten:":{"unicode":["1f51f"],"isCanonical": true},":muscle:":{"unicode":["1f4aa"],"isCanonical": true},":capital_abcd:":{"unicode":["1f520"],"isCanonical": true},":abcd:":{"unicode":["1f521"],"isCanonical": true},":dizzy:":{"unicode":["1f4ab"],"isCanonical": true},":1234:":{"unicode":["1f522"],"isCanonical": true},":symbols:":{"unicode":["1f523"],"isCanonical": true},":speech_balloon:":{"unicode":["1f4ac"],"isCanonical": true},":abc:":{"unicode":["1f524"],"isCanonical": true},":fire:":{"unicode":["1f525"],"isCanonical": true},":flame:":{"unicode":["1f525"],"isCanonical": false},":white_flower:":{"unicode":["1f4ae"],"isCanonical": true},":flashlight:":{"unicode":["1f526"],"isCanonical": true},":wrench:":{"unicode":["1f527"],"isCanonical": true},":100:":{"unicode":["1f4af"],"isCanonical": true},":hammer:":{"unicode":["1f528"],"isCanonical": true},":nut_and_bolt:":{"unicode":["1f529"],"isCanonical": true},":moneybag:":{"unicode":["1f4b0"],"isCanonical": true},":knife:":{"unicode":["1f52a"],"isCanonical": true},":gun:":{"unicode":["1f52b"],"isCanonical": true},":currency_exchange:":{"unicode":["1f4b1"],"isCanonical": true},":crystal_ball:":{"unicode":["1f52e"],"isCanonical": true},":heavy_dollar_sign:":{"unicode":["1f4b2"],"isCanonical": true},":six_pointed_star:":{"unicode":["1f52f"],"isCanonical": true},":credit_card:":{"unicode":["1f4b3"],"isCanonical": true},":beginner:":{"unicode":["1f530"],"isCanonical": true},":trident:":{"unicode":["1f531"],"isCanonical": true},":yen:":{"unicode":["1f4b4"],"isCanonical": true},":black_square_button:":{"unicode":["1f532"],"isCanonical": true},":white_square_button:":{"unicode":["1f533"],"isCanonical": true},":dollar:":{"unicode":["1f4b5"],"isCanonical": true},":red_circle:":{"unicode":["1f534"],"isCanonical": true},":large_blue_circle:":{"unicode":["1f535"],"isCanonical": true},":money_with_wings:":{"unicode":["1f4b8"],"isCanonical": true},":large_orange_diamond:":{"unicode":["1f536"],"isCanonical": true},":large_blue_diamond:":{"unicode":["1f537"],"isCanonical": true},":chart:":{"unicode":["1f4b9"],"isCanonical": true},":small_orange_diamond:":{"unicode":["1f538"],"isCanonical": true},":small_blue_diamond:":{"unicode":["1f539"],"isCanonical": true},":seat:":{"unicode":["1f4ba"],"isCanonical": true},":small_red_triangle:":{"unicode":["1f53a"],"isCanonical": true},":small_red_triangle_down:":{"unicode":["1f53b"],"isCanonical": true},":computer:":{"unicode":["1f4bb"],"isCanonical": true},":arrow_up_small:":{"unicode":["1f53c"],"isCanonical": true},":briefcase:":{"unicode":["1f4bc"],"isCanonical": true},":arrow_down_small:":{"unicode":["1f53d"],"isCanonical": true},":clock1:":{"unicode":["1f550"],"isCanonical": true},":minidisc:":{"unicode":["1f4bd"],"isCanonical": true},":clock2:":{"unicode":["1f551"],"isCanonical": true},":floppy_disk:":{"unicode":["1f4be"],"isCanonical": true},":clock3:":{"unicode":["1f552"],"isCanonical": true},":cd:":{"unicode":["1f4bf"],"isCanonical": true},":clock4:":{"unicode":["1f553"],"isCanonical": true},":dvd:":{"unicode":["1f4c0"],"isCanonical": true},":clock5:":{"unicode":["1f554"],"isCanonical": true},":clock6:":{"unicode":["1f555"],"isCanonical": true},":file_folder:":{"unicode":["1f4c1"],"isCanonical": true},":clock7:":{"unicode":["1f556"],"isCanonical": true},":clock8:":{"unicode":["1f557"],"isCanonical": true},":open_file_folder:":{"unicode":["1f4c2"],"isCanonical": true},":clock9:":{"unicode":["1f558"],"isCanonical": true},":clock10:":{"unicode":["1f559"],"isCanonical": true},":page_with_curl:":{"unicode":["1f4c3"],"isCanonical": true},":clock11:":{"unicode":["1f55a"],"isCanonical": true},":clock12:":{"unicode":["1f55b"],"isCanonical": true},":page_facing_up:":{"unicode":["1f4c4"],"isCanonical": true},":mount_fuji:":{"unicode":["1f5fb"],"isCanonical": true},":tokyo_tower:":{"unicode":["1f5fc"],"isCanonical": true},":date:":{"unicode":["1f4c5"],"isCanonical": true},":statue_of_liberty:":{"unicode":["1f5fd"],"isCanonical": true},":japan:":{"unicode":["1f5fe"],"isCanonical": true},":calendar:":{"unicode":["1f4c6"],"isCanonical": true},":moyai:":{"unicode":["1f5ff"],"isCanonical": true},":grin:":{"unicode":["1f601"],"isCanonical": true},":joy:":{"unicode":["1f602"],"isCanonical": true},":smiley:":{"unicode":["1f603"],"isCanonical": true},":chart_with_upwards_trend:":{"unicode":["1f4c8"],"isCanonical": true},":smile:":{"unicode":["1f604"],"isCanonical": true},":sweat_smile:":{"unicode":["1f605"],"isCanonical": true},":chart_with_downwards_trend:":{"unicode":["1f4c9"],"isCanonical": true},":laughing:":{"unicode":["1f606"],"isCanonical": true},":satisfied:":{"unicode":["1f606"],"isCanonical": false},":wink:":{"unicode":["1f609"],"isCanonical": true},":bar_chart:":{"unicode":["1f4ca"],"isCanonical": true},":blush:":{"unicode":["1f60a"],"isCanonical": true},":yum:":{"unicode":["1f60b"],"isCanonical": true},":clipboard:":{"unicode":["1f4cb"],"isCanonical": true},":relieved:":{"unicode":["1f60c"],"isCanonical": true},":heart_eyes:":{"unicode":["1f60d"],"isCanonical": true},":pushpin:":{"unicode":["1f4cc"],"isCanonical": true},":smirk:":{"unicode":["1f60f"],"isCanonical": true},":unamused:":{"unicode":["1f612"],"isCanonical": true},":round_pushpin:":{"unicode":["1f4cd"],"isCanonical": true},":sweat:":{"unicode":["1f613"],"isCanonical": true},":pensive:":{"unicode":["1f614"],"isCanonical": true},":paperclip:":{"unicode":["1f4ce"],"isCanonical": true},":confounded:":{"unicode":["1f616"],"isCanonical": true},":kissing_heart:":{"unicode":["1f618"],"isCanonical": true},":straight_ruler:":{"unicode":["1f4cf"],"isCanonical": true},":kissing_closed_eyes:":{"unicode":["1f61a"],"isCanonical": true},":stuck_out_tongue_winking_eye:":{"unicode":["1f61c"],"isCanonical": true},":triangular_ruler:":{"unicode":["1f4d0"],"isCanonical": true},":stuck_out_tongue_closed_eyes:":{"unicode":["1f61d"],"isCanonical": true},":disappointed:":{"unicode":["1f61e"],"isCanonical": true},":bookmark_tabs:":{"unicode":["1f4d1"],"isCanonical": true},":angry:":{"unicode":["1f620"],"isCanonical": true},":rage:":{"unicode":["1f621"],"isCanonical": true},":cry:":{"unicode":["1f622"],"isCanonical": true},":persevere:":{"unicode":["1f623"],"isCanonical": true},":triumph:":{"unicode":["1f624"],"isCanonical": true},":disappointed_relieved:":{"unicode":["1f625"],"isCanonical": true},":fearful:":{"unicode":["1f628"],"isCanonical": true},":weary:":{"unicode":["1f629"],"isCanonical": true},":sleepy:":{"unicode":["1f62a"],"isCanonical": true},":tired_face:":{"unicode":["1f62b"],"isCanonical": true},":sob:":{"unicode":["1f62d"],"isCanonical": true},":cold_sweat:":{"unicode":["1f630"],"isCanonical": true},":scream:":{"unicode":["1f631"],"isCanonical": true},":astonished:":{"unicode":["1f632"],"isCanonical": true},":flushed:":{"unicode":["1f633"],"isCanonical": true},":dizzy_face:":{"unicode":["1f635"],"isCanonical": true},":mask:":{"unicode":["1f637"],"isCanonical": true},":smile_cat:":{"unicode":["1f638"],"isCanonical": true},":joy_cat:":{"unicode":["1f639"],"isCanonical": true},":smiley_cat:":{"unicode":["1f63a"],"isCanonical": true},":heart_eyes_cat:":{"unicode":["1f63b"],"isCanonical": true},":smirk_cat:":{"unicode":["1f63c"],"isCanonical": true},":kissing_cat:":{"unicode":["1f63d"],"isCanonical": true},":pouting_cat:":{"unicode":["1f63e"],"isCanonical": true},":crying_cat_face:":{"unicode":["1f63f"],"isCanonical": true},":scream_cat:":{"unicode":["1f640"],"isCanonical": true},":no_good:":{"unicode":["1f645"],"isCanonical": true},":ok_woman:":{"unicode":["1f646"],"isCanonical": true},":bow:":{"unicode":["1f647"],"isCanonical": true},":see_no_evil:":{"unicode":["1f648"],"isCanonical": true},":hear_no_evil:":{"unicode":["1f649"],"isCanonical": true},":speak_no_evil:":{"unicode":["1f64a"],"isCanonical": true},":raising_hand:":{"unicode":["1f64b"],"isCanonical": true},":raised_hands:":{"unicode":["1f64c"],"isCanonical": true},":person_frowning:":{"unicode":["1f64d"],"isCanonical": true},":person_with_pouting_face:":{"unicode":["1f64e"],"isCanonical": true},":pray:":{"unicode":["1f64f"],"isCanonical": true},":rocket:":{"unicode":["1f680"],"isCanonical": true},":railway_car:":{"unicode":["1f683"],"isCanonical": true},":bullettrain_side:":{"unicode":["1f684"],"isCanonical": true},":bullettrain_front:":{"unicode":["1f685"],"isCanonical": true},":metro:":{"unicode":["1f687"],"isCanonical": true},":station:":{"unicode":["1f689"],"isCanonical": true},":bus:":{"unicode":["1f68c"],"isCanonical": true},":busstop:":{"unicode":["1f68f"],"isCanonical": true},":ambulance:":{"unicode":["1f691"],"isCanonical": true},":fire_engine:":{"unicode":["1f692"],"isCanonical": true},":police_car:":{"unicode":["1f693"],"isCanonical": true},":taxi:":{"unicode":["1f695"],"isCanonical": true},":red_car:":{"unicode":["1f697"],"isCanonical": true},":blue_car:":{"unicode":["1f699"],"isCanonical": true},":truck:":{"unicode":["1f69a"],"isCanonical": true},":ship:":{"unicode":["1f6a2"],"isCanonical": true},":speedboat:":{"unicode":["1f6a4"],"isCanonical": true},":traffic_light:":{"unicode":["1f6a5"],"isCanonical": true},":construction:":{"unicode":["1f6a7"],"isCanonical": true},":rotating_light:":{"unicode":["1f6a8"],"isCanonical": true},":triangular_flag_on_post:":{"unicode":["1f6a9"],"isCanonical": true},":door:":{"unicode":["1f6aa"],"isCanonical": true},":no_entry_sign:":{"unicode":["1f6ab"],"isCanonical": true},":smoking:":{"unicode":["1f6ac"],"isCanonical": true},":no_smoking:":{"unicode":["1f6ad"],"isCanonical": true},":bike:":{"unicode":["1f6b2"],"isCanonical": true},":walking:":{"unicode":["1f6b6"],"isCanonical": true},":mens:":{"unicode":["1f6b9"],"isCanonical": true},":womens:":{"unicode":["1f6ba"],"isCanonical": true},":restroom:":{"unicode":["1f6bb"],"isCanonical": true},":baby_symbol:":{"unicode":["1f6bc"],"isCanonical": true},":toilet:":{"unicode":["1f6bd"],"isCanonical": true},":wc:":{"unicode":["1f6be"],"isCanonical": true},":bath:":{"unicode":["1f6c0"],"isCanonical": true},":metal:":{"unicode":["1f918"],"isCanonical": true},":sign_of_the_horns:":{"unicode":["1f918"],"isCanonical": false},":grinning:":{"unicode":["1f600"],"isCanonical": true},":innocent:":{"unicode":["1f607"],"isCanonical": true},":smiling_imp:":{"unicode":["1f608"],"isCanonical": true},":sunglasses:":{"unicode":["1f60e"],"isCanonical": true},":neutral_face:":{"unicode":["1f610"],"isCanonical": true},":expressionless:":{"unicode":["1f611"],"isCanonical": true},":confused:":{"unicode":["1f615"],"isCanonical": true},":kissing:":{"unicode":["1f617"],"isCanonical": true},":kissing_smiling_eyes:":{"unicode":["1f619"],"isCanonical": true},":stuck_out_tongue:":{"unicode":["1f61b"],"isCanonical": true},":worried:":{"unicode":["1f61f"],"isCanonical": true},":frowning:":{"unicode":["1f626"],"isCanonical": true},":anguished:":{"unicode":["1f627"],"isCanonical": true},":grimacing:":{"unicode":["1f62c"],"isCanonical": true},":open_mouth:":{"unicode":["1f62e"],"isCanonical": true},":hushed:":{"unicode":["1f62f"],"isCanonical": true},":sleeping:":{"unicode":["1f634"],"isCanonical": true},":no_mouth:":{"unicode":["1f636"],"isCanonical": true},":helicopter:":{"unicode":["1f681"],"isCanonical": true},":steam_locomotive:":{"unicode":["1f682"],"isCanonical": true},":train2:":{"unicode":["1f686"],"isCanonical": true},":light_rail:":{"unicode":["1f688"],"isCanonical": true},":tram:":{"unicode":["1f68a"],"isCanonical": true},":oncoming_bus:":{"unicode":["1f68d"],"isCanonical": true},":trolleybus:":{"unicode":["1f68e"],"isCanonical": true},":minibus:":{"unicode":["1f690"],"isCanonical": true},":oncoming_police_car:":{"unicode":["1f694"],"isCanonical": true},":oncoming_taxi:":{"unicode":["1f696"],"isCanonical": true},":oncoming_automobile:":{"unicode":["1f698"],"isCanonical": true},":articulated_lorry:":{"unicode":["1f69b"],"isCanonical": true},":tractor:":{"unicode":["1f69c"],"isCanonical": true},":monorail:":{"unicode":["1f69d"],"isCanonical": true},":mountain_railway:":{"unicode":["1f69e"],"isCanonical": true},":suspension_railway:":{"unicode":["1f69f"],"isCanonical": true},":mountain_cableway:":{"unicode":["1f6a0"],"isCanonical": true},":aerial_tramway:":{"unicode":["1f6a1"],"isCanonical": true},":rowboat:":{"unicode":["1f6a3"],"isCanonical": true},":vertical_traffic_light:":{"unicode":["1f6a6"],"isCanonical": true},":put_litter_in_its_place:":{"unicode":["1f6ae"],"isCanonical": true},":do_not_litter:":{"unicode":["1f6af"],"isCanonical": true},":potable_water:":{"unicode":["1f6b0"],"isCanonical": true},":non-potable_water:":{"unicode":["1f6b1"],"isCanonical": true},":no_bicycles:":{"unicode":["1f6b3"],"isCanonical": true},":bicyclist:":{"unicode":["1f6b4"],"isCanonical": true},":mountain_bicyclist:":{"unicode":["1f6b5"],"isCanonical": true},":no_pedestrians:":{"unicode":["1f6b7"],"isCanonical": true},":children_crossing:":{"unicode":["1f6b8"],"isCanonical": true},":shower:":{"unicode":["1f6bf"],"isCanonical": true},":bathtub:":{"unicode":["1f6c1"],"isCanonical": true},":passport_control:":{"unicode":["1f6c2"],"isCanonical": true},":customs:":{"unicode":["1f6c3"],"isCanonical": true},":baggage_claim:":{"unicode":["1f6c4"],"isCanonical": true},":left_luggage:":{"unicode":["1f6c5"],"isCanonical": true},":earth_africa:":{"unicode":["1f30d"],"isCanonical": true},":earth_americas:":{"unicode":["1f30e"],"isCanonical": true},":globe_with_meridians:":{"unicode":["1f310"],"isCanonical": true},":waxing_crescent_moon:":{"unicode":["1f312"],"isCanonical": true},":waning_gibbous_moon:":{"unicode":["1f316"],"isCanonical": true},":last_quarter_moon:":{"unicode":["1f317"],"isCanonical": true},":waning_crescent_moon:":{"unicode":["1f318"],"isCanonical": true},":new_moon_with_face:":{"unicode":["1f31a"],"isCanonical": true},":last_quarter_moon_with_face:":{"unicode":["1f31c"],"isCanonical": true},":full_moon_with_face:":{"unicode":["1f31d"],"isCanonical": true},":sun_with_face:":{"unicode":["1f31e"],"isCanonical": true},":evergreen_tree:":{"unicode":["1f332"],"isCanonical": true},":deciduous_tree:":{"unicode":["1f333"],"isCanonical": true},":lemon:":{"unicode":["1f34b"],"isCanonical": true},":pear:":{"unicode":["1f350"],"isCanonical": true},":baby_bottle:":{"unicode":["1f37c"],"isCanonical": true},":horse_racing:":{"unicode":["1f3c7"],"isCanonical": true},":rugby_football:":{"unicode":["1f3c9"],"isCanonical": true},":european_post_office:":{"unicode":["1f3e4"],"isCanonical": true},":rat:":{"unicode":["1f400"],"isCanonical": true},":mouse2:":{"unicode":["1f401"],"isCanonical": true},":ox:":{"unicode":["1f402"],"isCanonical": true},":water_buffalo:":{"unicode":["1f403"],"isCanonical": true},":cow2:":{"unicode":["1f404"],"isCanonical": true},":tiger2:":{"unicode":["1f405"],"isCanonical": true},":leopard:":{"unicode":["1f406"],"isCanonical": true},":rabbit2:":{"unicode":["1f407"],"isCanonical": true},":cat2:":{"unicode":["1f408"],"isCanonical": true},":dragon:":{"unicode":["1f409"],"isCanonical": true},":crocodile:":{"unicode":["1f40a"],"isCanonical": true},":whale2:":{"unicode":["1f40b"],"isCanonical": true},":ram:":{"unicode":["1f40f"],"isCanonical": true},":goat:":{"unicode":["1f410"],"isCanonical": true},":rooster:":{"unicode":["1f413"],"isCanonical": true},":dog2:":{"unicode":["1f415"],"isCanonical": true},":pig2:":{"unicode":["1f416"],"isCanonical": true},":dromedary_camel:":{"unicode":["1f42a"],"isCanonical": true},":busts_in_silhouette:":{"unicode":["1f465"],"isCanonical": true},":two_men_holding_hands:":{"unicode":["1f46c"],"isCanonical": true},":two_women_holding_hands:":{"unicode":["1f46d"],"isCanonical": true},":thought_balloon:":{"unicode":["1f4ad"],"isCanonical": true},":euro:":{"unicode":["1f4b6"],"isCanonical": true},":pound:":{"unicode":["1f4b7"],"isCanonical": true},":mailbox_with_mail:":{"unicode":["1f4ec"],"isCanonical": true},":mailbox_with_no_mail:":{"unicode":["1f4ed"],"isCanonical": true},":postal_horn:":{"unicode":["1f4ef"],"isCanonical": true},":no_mobile_phones:":{"unicode":["1f4f5"],"isCanonical": true},":twisted_rightwards_arrows:":{"unicode":["1f500"],"isCanonical": true},":repeat:":{"unicode":["1f501"],"isCanonical": true},":repeat_one:":{"unicode":["1f502"],"isCanonical": true},":arrows_counterclockwise:":{"unicode":["1f504"],"isCanonical": true},":low_brightness:":{"unicode":["1f505"],"isCanonical": true},":high_brightness:":{"unicode":["1f506"],"isCanonical": true},":mute:":{"unicode":["1f507"],"isCanonical": true},":sound:":{"unicode":["1f509"],"isCanonical": true},":no_bell:":{"unicode":["1f515"],"isCanonical": true},":microscope:":{"unicode":["1f52c"],"isCanonical": true},":telescope:":{"unicode":["1f52d"],"isCanonical": true},":clock130:":{"unicode":["1f55c"],"isCanonical": true},":clock230:":{"unicode":["1f55d"],"isCanonical": true},":clock330:":{"unicode":["1f55e"],"isCanonical": true},":clock430:":{"unicode":["1f55f"],"isCanonical": true},":clock530:":{"unicode":["1f560"],"isCanonical": true},":clock630:":{"unicode":["1f561"],"isCanonical": true},":clock730:":{"unicode":["1f562"],"isCanonical": true},":clock830:":{"unicode":["1f563"],"isCanonical": true},":clock930:":{"unicode":["1f564"],"isCanonical": true},":clock1030:":{"unicode":["1f565"],"isCanonical": true},":clock1130:":{"unicode":["1f566"],"isCanonical": true},":clock1230:":{"unicode":["1f567"],"isCanonical": true},":speaker:":{"unicode":["1f508"],"isCanonical": true},":train:":{"unicode":["1f68b"],"isCanonical": true},":medal:":{"unicode":["1f3c5"],"isCanonical": true},":sports_medal:":{"unicode":["1f3c5"],"isCanonical": false},":flag_black:":{"unicode":["1f3f4"],"isCanonical": true},":waving_black_flag:":{"unicode":["1f3f4"],"isCanonical": false},":camera_with_flash:":{"unicode":["1f4f8"],"isCanonical": true},":sleeping_accommodation:":{"unicode":["1f6cc"],"isCanonical": true},":middle_finger:":{"unicode":["1f595"],"isCanonical": true},":reversed_hand_with_middle_finger_extended:":{"unicode":["1f595"],"isCanonical": false},":vulcan:":{"unicode":["1f596"],"isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers:":{"unicode":["1f596"],"isCanonical": false},":slight_frown:":{"unicode":["1f641"],"isCanonical": true},":slightly_frowning_face:":{"unicode":["1f641"],"isCanonical": false},":slight_smile:":{"unicode":["1f642"],"isCanonical": true},":slightly_smiling_face:":{"unicode":["1f642"],"isCanonical": false},":airplane_departure:":{"unicode":["1f6eb"],"isCanonical": true},":airplane_arriving:":{"unicode":["1f6ec"],"isCanonical": true},":tone1:":{"unicode":["1f3fb"],"isCanonical": true},":tone2:":{"unicode":["1f3fc"],"isCanonical": true},":tone3:":{"unicode":["1f3fd"],"isCanonical": true},":tone4:":{"unicode":["1f3fe"],"isCanonical": true},":tone5:":{"unicode":["1f3ff"],"isCanonical": true},":upside_down:":{"unicode":["1f643"],"isCanonical": true},":upside_down_face:":{"unicode":["1f643"],"isCanonical": false},":money_mouth:":{"unicode":["1f911"],"isCanonical": true},":money_mouth_face:":{"unicode":["1f911"],"isCanonical": false},":nerd:":{"unicode":["1f913"],"isCanonical": true},":nerd_face:":{"unicode":["1f913"],"isCanonical": false},":hugging:":{"unicode":["1f917"],"isCanonical": true},":hugging_face:":{"unicode":["1f917"],"isCanonical": false},":rolling_eyes:":{"unicode":["1f644"],"isCanonical": true},":face_with_rolling_eyes:":{"unicode":["1f644"],"isCanonical": false},":thinking:":{"unicode":["1f914"],"isCanonical": true},":thinking_face:":{"unicode":["1f914"],"isCanonical": false},":zipper_mouth:":{"unicode":["1f910"],"isCanonical": true},":zipper_mouth_face:":{"unicode":["1f910"],"isCanonical": false},":thermometer_face:":{"unicode":["1f912"],"isCanonical": true},":face_with_thermometer:":{"unicode":["1f912"],"isCanonical": false},":head_bandage:":{"unicode":["1f915"],"isCanonical": true},":face_with_head_bandage:":{"unicode":["1f915"],"isCanonical": false},":robot:":{"unicode":["1f916"],"isCanonical": true},":robot_face:":{"unicode":["1f916"],"isCanonical": false},":lion_face:":{"unicode":["1f981"],"isCanonical": true},":lion:":{"unicode":["1f981"],"isCanonical": false},":unicorn:":{"unicode":["1f984"],"isCanonical": true},":unicorn_face:":{"unicode":["1f984"],"isCanonical": false},":scorpion:":{"unicode":["1f982"],"isCanonical": true},":crab:":{"unicode":["1f980"],"isCanonical": true},":turkey:":{"unicode":["1f983"],"isCanonical": true},":cheese:":{"unicode":["1f9c0"],"isCanonical": true},":cheese_wedge:":{"unicode":["1f9c0"],"isCanonical": false},":hotdog:":{"unicode":["1f32d"],"isCanonical": true},":hot_dog:":{"unicode":["1f32d"],"isCanonical": false},":taco:":{"unicode":["1f32e"],"isCanonical": true},":burrito:":{"unicode":["1f32f"],"isCanonical": true},":popcorn:":{"unicode":["1f37f"],"isCanonical": true},":champagne:":{"unicode":["1f37e"],"isCanonical": true},":bottle_with_popping_cork:":{"unicode":["1f37e"],"isCanonical": false},":bow_and_arrow:":{"unicode":["1f3f9"],"isCanonical": true},":archery:":{"unicode":["1f3f9"],"isCanonical": false},":amphora:":{"unicode":["1f3fa"],"isCanonical": true},":place_of_worship:":{"unicode":["1f6d0"],"isCanonical": true},":worship_symbol:":{"unicode":["1f6d0"],"isCanonical": false},":kaaba:":{"unicode":["1f54b"],"isCanonical": true},":mosque:":{"unicode":["1f54c"],"isCanonical": true},":synagogue:":{"unicode":["1f54d"],"isCanonical": true},":menorah:":{"unicode":["1f54e"],"isCanonical": true},":prayer_beads:":{"unicode":["1f4ff"],"isCanonical": true},":cricket:":{"unicode":["1f3cf"],"isCanonical": true},":cricket_bat_ball:":{"unicode":["1f3cf"],"isCanonical": false},":volleyball:":{"unicode":["1f3d0"],"isCanonical": true},":field_hockey:":{"unicode":["1f3d1"],"isCanonical": true},":hockey:":{"unicode":["1f3d2"],"isCanonical": true},":ping_pong:":{"unicode":["1f3d3"],"isCanonical": true},":table_tennis:":{"unicode":["1f3d3"],"isCanonical": false},":badminton:":{"unicode":["1f3f8"],"isCanonical": true},":fast_forward:":{"unicode":["23e9"],"isCanonical": true},":rewind:":{"unicode":["23ea"],"isCanonical": true},":arrow_double_up:":{"unicode":["23eb"],"isCanonical": true},":arrow_double_down:":{"unicode":["23ec"],"isCanonical": true},":alarm_clock:":{"unicode":["23f0"],"isCanonical": true},":hourglass_flowing_sand:":{"unicode":["23f3"],"isCanonical": true},":ophiuchus:":{"unicode":["26ce"],"isCanonical": true},":white_check_mark:":{"unicode":["2705"],"isCanonical": true},":fist:":{"unicode":["270a"],"isCanonical": true},":raised_hand:":{"unicode":["270b"],"isCanonical": true},":sparkles:":{"unicode":["2728"],"isCanonical": true},":x:":{"unicode":["274c"],"isCanonical": true},":negative_squared_cross_mark:":{"unicode":["274e"],"isCanonical": true},":question:":{"unicode":["2753"],"isCanonical": true},":grey_question:":{"unicode":["2754"],"isCanonical": true},":grey_exclamation:":{"unicode":["2755"],"isCanonical": true},":heavy_plus_sign:":{"unicode":["2795"],"isCanonical": true},":heavy_minus_sign:":{"unicode":["2796"],"isCanonical": true},":heavy_division_sign:":{"unicode":["2797"],"isCanonical": true},":curly_loop:":{"unicode":["27b0"],"isCanonical": true},":loop:":{"unicode":["27bf"],"isCanonical": true}};
	    // ns.shortnames = Object.keys(ns.emojioneList).map(function(emoji) {
	    //     return emoji.replace(/[+]/g, "\\$&");
	    // }).join('|');
	    var tmpShortNames = [],
	        emoji;
	    for (emoji in ns.emojioneList) {
	        if (!ns.emojioneList.hasOwnProperty(emoji)) continue;
	        tmpShortNames.push(emoji.replace(/[+]/g, "\\$&"));
	    }
	    ns.shortnames = tmpShortNames.join('|');
	    ns.asciiList = {
	        '<3':'2764',
	        '</3':'1f494',
	        ':\')':'1f602',
	        ':\'-)':'1f602',
	        ':D':'1f603',
	        ':-D':'1f603',
	        '=D':'1f603',
	        ':)':'1f642',
	        ':-)':'1f642',
	        '=]':'1f642',
	        '=)':'1f642',
	        ':]':'1f642',
	        '\':)':'1f605',
	        '\':-)':'1f605',
	        '\'=)':'1f605',
	        '\':D':'1f605',
	        '\':-D':'1f605',
	        '\'=D':'1f605',
	        '>:)':'1f606',
	        '>;)':'1f606',
	        '>:-)':'1f606',
	        '>=)':'1f606',
	        ';)':'1f609',
	        ';-)':'1f609',
	        '*-)':'1f609',
	        '*)':'1f609',
	        ';-]':'1f609',
	        ';]':'1f609',
	        ';D':'1f609',
	        ';^)':'1f609',
	        '\':(':'1f613',
	        '\':-(':'1f613',
	        '\'=(':'1f613',
	        ':*':'1f618',
	        ':-*':'1f618',
	        '=*':'1f618',
	        ':^*':'1f618',
	        '>:P':'1f61c',
	        'X-P':'1f61c',
	        'x-p':'1f61c',
	        '>:[':'1f61e',
	        ':-(':'1f61e',
	        ':(':'1f61e',
	        ':-[':'1f61e',
	        ':[':'1f61e',
	        '=(':'1f61e',
	        '>:(':'1f620',
	        '>:-(':'1f620',
	        ':@':'1f620',
	        ':\'(':'1f622',
	        ':\'-(':'1f622',
	        ';(':'1f622',
	        ';-(':'1f622',
	        '>.<':'1f623',
	        'D:':'1f628',
	        ':$':'1f633',
	        '=$':'1f633',
	        '#-)':'1f635',
	        '#)':'1f635',
	        '%-)':'1f635',
	        '%)':'1f635',
	        'X)':'1f635',
	        'X-)':'1f635',
	        '*\\0/*':'1f646',
	        '\\0/':'1f646',
	        '*\\O/*':'1f646',
	        '\\O/':'1f646',
	        'O:-)':'1f607',
	        '0:-3':'1f607',
	        '0:3':'1f607',
	        '0:-)':'1f607',
	        '0:)':'1f607',
	        '0;^)':'1f607',
	        'O:)':'1f607',
	        'O;-)':'1f607',
	        'O=)':'1f607',
	        '0;-)':'1f607',
	        'O:-3':'1f607',
	        'O:3':'1f607',
	        'B-)':'1f60e',
	        'B)':'1f60e',
	        '8)':'1f60e',
	        '8-)':'1f60e',
	        'B-D':'1f60e',
	        '8-D':'1f60e',
	        '-_-':'1f611',
	        '-__-':'1f611',
	        '-___-':'1f611',
	        '>:\\':'1f615',
	        '>:/':'1f615',
	        ':-/':'1f615',
	        ':-.':'1f615',
	        ':/':'1f615',
	        ':\\':'1f615',
	        '=/':'1f615',
	        '=\\':'1f615',
	        ':L':'1f615',
	        '=L':'1f615',
	        ':P':'1f61b',
	        ':-P':'1f61b',
	        '=P':'1f61b',
	        ':-p':'1f61b',
	        ':p':'1f61b',
	        '=p':'1f61b',
	        ':-Þ':'1f61b',
	        ':Þ':'1f61b',
	        ':þ':'1f61b',
	        ':-þ':'1f61b',
	        ':-b':'1f61b',
	        ':b':'1f61b',
	        'd:':'1f61b',
	        ':-O':'1f62e',
	        ':O':'1f62e',
	        ':-o':'1f62e',
	        ':o':'1f62e',
	        'O_O':'1f62e',
	        '>:O':'1f62e',
	        ':-X':'1f636',
	        ':X':'1f636',
	        ':-#':'1f636',
	        ':#':'1f636',
	        '=X':'1f636',
	        '=x':'1f636',
	        ':x':'1f636',
	        ':-x':'1f636',
	        '=#':'1f636'
	    };
	    ns.asciiRegexp = '(\\<3|&lt;3|\\<\\/3|&lt;\\/3|\\:\'\\)|\\:\'\\-\\)|\\:D|\\:\\-D|\\=D|\\:\\)|\\:\\-\\)|\\=\\]|\\=\\)|\\:\\]|\'\\:\\)|\'\\:\\-\\)|\'\\=\\)|\'\\:D|\'\\:\\-D|\'\\=D|\\>\\:\\)|&gt;\\:\\)|\\>;\\)|&gt;;\\)|\\>\\:\\-\\)|&gt;\\:\\-\\)|\\>\\=\\)|&gt;\\=\\)|;\\)|;\\-\\)|\\*\\-\\)|\\*\\)|;\\-\\]|;\\]|;D|;\\^\\)|\'\\:\\(|\'\\:\\-\\(|\'\\=\\(|\\:\\*|\\:\\-\\*|\\=\\*|\\:\\^\\*|\\>\\:P|&gt;\\:P|X\\-P|x\\-p|\\>\\:\\[|&gt;\\:\\[|\\:\\-\\(|\\:\\(|\\:\\-\\[|\\:\\[|\\=\\(|\\>\\:\\(|&gt;\\:\\(|\\>\\:\\-\\(|&gt;\\:\\-\\(|\\:@|\\:\'\\(|\\:\'\\-\\(|;\\(|;\\-\\(|\\>\\.\\<|&gt;\\.&lt;|D\\:|\\:\\$|\\=\\$|#\\-\\)|#\\)|%\\-\\)|%\\)|X\\)|X\\-\\)|\\*\\\\0\\/\\*|\\\\0\\/|\\*\\\\O\\/\\*|\\\\O\\/|O\\:\\-\\)|0\\:\\-3|0\\:3|0\\:\\-\\)|0\\:\\)|0;\\^\\)|O\\:\\-\\)|O\\:\\)|O;\\-\\)|O\\=\\)|0;\\-\\)|O\\:\\-3|O\\:3|B\\-\\)|B\\)|8\\)|8\\-\\)|B\\-D|8\\-D|\\-_\\-|\\-__\\-|\\-___\\-|\\>\\:\\\\|&gt;\\:\\\\|\\>\\:\\/|&gt;\\:\\/|\\:\\-\\/|\\:\\-\\.|\\:\\/|\\:\\\\|\\=\\/|\\=\\\\|\\:L|\\=L|\\:P|\\:\\-P|\\=P|\\:\\-p|\\:p|\\=p|\\:\\-Þ|\\:\\-&THORN;|\\:Þ|\\:&THORN;|\\:þ|\\:&thorn;|\\:\\-þ|\\:\\-&thorn;|\\:\\-b|\\:b|d\\:|\\:\\-O|\\:O|\\:\\-o|\\:o|O_O|\\>\\:O|&gt;\\:O|\\:\\-X|\\:X|\\:\\-#|\\:#|\\=X|\\=x|\\:x|\\:\\-x|\\=#)';
	    // javascript escapes here must be ordered from largest length to shortest
	    ns.unicodeRegexp = '(\\uD83D\\uDC69\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC8B\\u200D\\uD83D\\uDC69|\\uD83D\\uDC68\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC8B\\u200D\\uD83D\\uDC68|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC68|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC69|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC66|\\uD83D\\uDC41\\u200D\\uD83D\\uDDE8|\\uD83C\\uDDE6\\uD83C\\uDDE9|\\uD83C\\uDDE6\\uD83C\\uDDEA|\\uD83C\\uDDE6\\uD83C\\uDDEB|\\uD83C\\uDDE6\\uD83C\\uDDEC|\\uD83C\\uDDE6\\uD83C\\uDDEE|\\uD83C\\uDDE6\\uD83C\\uDDF1|\\uD83C\\uDDE6\\uD83C\\uDDF2|\\uD83C\\uDDE6\\uD83C\\uDDF4|\\uD83C\\uDDE6\\uD83C\\uDDF6|\\uD83C\\uDDE6\\uD83C\\uDDF7|\\uD83C\\uDDE6\\uD83C\\uDDF8|\\uD83E\\uDD18\\uD83C\\uDFFF|\\uD83E\\uDD18\\uD83C\\uDFFE|\\uD83E\\uDD18\\uD83C\\uDFFD|\\uD83E\\uDD18\\uD83C\\uDFFC|\\uD83E\\uDD18\\uD83C\\uDFFB|\\uD83D\\uDEC0\\uD83C\\uDFFF|\\uD83D\\uDEC0\\uD83C\\uDFFE|\\uD83D\\uDEC0\\uD83C\\uDFFD|\\uD83D\\uDEC0\\uD83C\\uDFFC|\\uD83D\\uDEC0\\uD83C\\uDFFB|\\uD83D\\uDEB6\\uD83C\\uDFFF|\\uD83D\\uDEB6\\uD83C\\uDFFE|\\uD83D\\uDEB6\\uD83C\\uDFFD|\\uD83D\\uDEB6\\uD83C\\uDFFC|\\uD83D\\uDEB6\\uD83C\\uDFFB|\\uD83D\\uDEB5\\uD83C\\uDFFF|\\uD83D\\uDEB5\\uD83C\\uDFFE|\\uD83D\\uDEB5\\uD83C\\uDFFD|\\uD83D\\uDEB5\\uD83C\\uDFFC|\\uD83D\\uDEB5\\uD83C\\uDFFB|\\uD83D\\uDEB4\\uD83C\\uDFFF|\\uD83D\\uDEB4\\uD83C\\uDFFE|\\uD83D\\uDEB4\\uD83C\\uDFFD|\\uD83D\\uDEB4\\uD83C\\uDFFC|\\uD83D\\uDEB4\\uD83C\\uDFFB|\\uD83D\\uDEA3\\uD83C\\uDFFF|\\uD83D\\uDEA3\\uD83C\\uDFFE|\\uD83D\\uDEA3\\uD83C\\uDFFD|\\uD83D\\uDEA3\\uD83C\\uDFFC|\\uD83D\\uDEA3\\uD83C\\uDFFB|\\uD83D\\uDE4F\\uD83C\\uDFFF|\\uD83D\\uDE4F\\uD83C\\uDFFE|\\uD83D\\uDE4F\\uD83C\\uDFFD|\\uD83D\\uDE4F\\uD83C\\uDFFC|\\uD83D\\uDE4F\\uD83C\\uDFFB|\\uD83D\\uDE4E\\uD83C\\uDFFF|\\uD83D\\uDE4E\\uD83C\\uDFFE|\\uD83D\\uDE4E\\uD83C\\uDFFD|\\uD83D\\uDE4E\\uD83C\\uDFFC|\\uD83D\\uDE4E\\uD83C\\uDFFB|\\uD83D\\uDE4D\\uD83C\\uDFFF|\\uD83D\\uDE4D\\uD83C\\uDFFE|\\uD83D\\uDE4D\\uD83C\\uDFFD|\\uD83D\\uDE4D\\uD83C\\uDFFC|\\uD83D\\uDE4D\\uD83C\\uDFFB|\\uD83D\\uDE4C\\uD83C\\uDFFF|\\uD83D\\uDE4C\\uD83C\\uDFFE|\\uD83D\\uDE4C\\uD83C\\uDFFD|\\uD83D\\uDE4C\\uD83C\\uDFFC|\\uD83D\\uDE4C\\uD83C\\uDFFB|\\uD83D\\uDE4B\\uD83C\\uDFFF|\\uD83D\\uDE4B\\uD83C\\uDFFE|\\uD83D\\uDE4B\\uD83C\\uDFFD|\\uD83D\\uDE4B\\uD83C\\uDFFC|\\uD83D\\uDE4B\\uD83C\\uDFFB|\\uD83D\\uDE47\\uD83C\\uDFFF|\\uD83D\\uDE47\\uD83C\\uDFFE|\\uD83D\\uDE47\\uD83C\\uDFFD|\\uD83D\\uDE47\\uD83C\\uDFFC|\\uD83D\\uDE47\\uD83C\\uDFFB|\\uD83D\\uDE46\\uD83C\\uDFFF|\\uD83D\\uDE46\\uD83C\\uDFFE|\\uD83D\\uDE46\\uD83C\\uDFFD|\\uD83D\\uDE46\\uD83C\\uDFFC|\\uD83D\\uDE46\\uD83C\\uDFFB|\\uD83D\\uDE45\\uD83C\\uDFFF|\\uD83D\\uDE45\\uD83C\\uDFFE|\\uD83D\\uDE45\\uD83C\\uDFFD|\\uD83D\\uDE45\\uD83C\\uDFFC|\\uD83D\\uDE45\\uD83C\\uDFFB|\\uD83D\\uDD96\\uD83C\\uDFFF|\\uD83D\\uDD96\\uD83C\\uDFFE|\\uD83D\\uDD96\\uD83C\\uDFFD|\\uD83D\\uDD96\\uD83C\\uDFFC|\\uD83D\\uDD96\\uD83C\\uDFFB|\\uD83D\\uDD95\\uD83C\\uDFFF|\\uD83D\\uDD95\\uD83C\\uDFFE|\\uD83D\\uDD95\\uD83C\\uDFFD|\\uD83D\\uDD95\\uD83C\\uDFFC|\\uD83D\\uDD95\\uD83C\\uDFFB|\\uD83D\\uDD90\\uD83C\\uDFFF|\\uD83D\\uDD90\\uD83C\\uDFFE|\\uD83D\\uDD90\\uD83C\\uDFFD|\\uD83D\\uDD90\\uD83C\\uDFFC|\\uD83D\\uDD90\\uD83C\\uDFFB|\\uD83D\\uDD75\\uD83C\\uDFFF|\\uD83D\\uDD75\\uD83C\\uDFFE|\\uD83D\\uDD75\\uD83C\\uDFFD|\\uD83D\\uDD75\\uD83C\\uDFFC|\\uD83D\\uDD75\\uD83C\\uDFFB|\\uD83D\\uDCAA\\uD83C\\uDFFF|\\uD83D\\uDCAA\\uD83C\\uDFFE|\\uD83D\\uDCAA\\uD83C\\uDFFD|\\uD83D\\uDCAA\\uD83C\\uDFFC|\\uD83D\\uDCAA\\uD83C\\uDFFB|\\uD83D\\uDC87\\uD83C\\uDFFF|\\uD83D\\uDC87\\uD83C\\uDFFE|\\uD83D\\uDC87\\uD83C\\uDFFD|\\uD83D\\uDC87\\uD83C\\uDFFC|\\uD83D\\uDC87\\uD83C\\uDFFB|\\uD83D\\uDC86\\uD83C\\uDFFF|\\uD83D\\uDC86\\uD83C\\uDFFE|\\uD83D\\uDC86\\uD83C\\uDFFD|\\uD83D\\uDC86\\uD83C\\uDFFC|\\uD83D\\uDC86\\uD83C\\uDFFB|\\uD83D\\uDC85\\uD83C\\uDFFF|\\uD83D\\uDC85\\uD83C\\uDFFE|\\uD83D\\uDC85\\uD83C\\uDFFD|\\uD83D\\uDC85\\uD83C\\uDFFC|\\uD83D\\uDC85\\uD83C\\uDFFB|\\uD83D\\uDC83\\uD83C\\uDFFF|\\uD83D\\uDC83\\uD83C\\uDFFE|\\uD83D\\uDC83\\uD83C\\uDFFD|\\uD83D\\uDC83\\uD83C\\uDFFC|\\uD83D\\uDC83\\uD83C\\uDFFB|\\uD83D\\uDC82\\uD83C\\uDFFF|\\uD83D\\uDC82\\uD83C\\uDFFE|\\uD83D\\uDC82\\uD83C\\uDFFD|\\uD83D\\uDC82\\uD83C\\uDFFC|\\uD83D\\uDC82\\uD83C\\uDFFB|\\uD83D\\uDC81\\uD83C\\uDFFF|\\uD83D\\uDC81\\uD83C\\uDFFE|\\uD83D\\uDC81\\uD83C\\uDFFD|\\uD83D\\uDC81\\uD83C\\uDFFC|\\uD83D\\uDC81\\uD83C\\uDFFB|\\uD83D\\uDC7C\\uD83C\\uDFFF|\\uD83D\\uDC7C\\uD83C\\uDFFE|\\uD83D\\uDC7C\\uD83C\\uDFFD|\\uD83D\\uDC7C\\uD83C\\uDFFC|\\uD83D\\uDC7C\\uD83C\\uDFFB|\\uD83D\\uDC78\\uD83C\\uDFFF|\\uD83D\\uDC78\\uD83C\\uDFFE|\\uD83D\\uDC78\\uD83C\\uDFFD|\\uD83D\\uDC78\\uD83C\\uDFFC|\\uD83D\\uDC78\\uD83C\\uDFFB|\\uD83D\\uDC77\\uD83C\\uDFFF|\\uD83D\\uDC77\\uD83C\\uDFFE|\\uD83D\\uDC77\\uD83C\\uDFFD|\\uD83D\\uDC77\\uD83C\\uDFFC|\\uD83D\\uDC77\\uD83C\\uDFFB|\\uD83D\\uDC76\\uD83C\\uDFFF|\\uD83D\\uDC76\\uD83C\\uDFFE|\\uD83D\\uDC76\\uD83C\\uDFFD|\\uD83D\\uDC76\\uD83C\\uDFFC|\\uD83D\\uDC76\\uD83C\\uDFFB|\\uD83D\\uDC75\\uD83C\\uDFFF|\\uD83D\\uDC75\\uD83C\\uDFFE|\\uD83D\\uDC75\\uD83C\\uDFFD|\\uD83D\\uDC75\\uD83C\\uDFFC|\\uD83D\\uDC75\\uD83C\\uDFFB|\\uD83D\\uDC74\\uD83C\\uDFFF|\\uD83D\\uDC74\\uD83C\\uDFFE|\\uD83D\\uDC74\\uD83C\\uDFFD|\\uD83D\\uDC74\\uD83C\\uDFFC|\\uD83D\\uDC74\\uD83C\\uDFFB|\\uD83D\\uDC73\\uD83C\\uDFFF|\\uD83D\\uDC73\\uD83C\\uDFFE|\\uD83D\\uDC73\\uD83C\\uDFFD|\\uD83D\\uDC73\\uD83C\\uDFFC|\\uD83D\\uDC73\\uD83C\\uDFFB|\\uD83D\\uDC72\\uD83C\\uDFFF|\\uD83D\\uDC72\\uD83C\\uDFFE|\\uD83D\\uDC72\\uD83C\\uDFFD|\\uD83D\\uDC72\\uD83C\\uDFFC|\\uD83D\\uDC72\\uD83C\\uDFFB|\\uD83D\\uDC71\\uD83C\\uDFFF|\\uD83D\\uDC71\\uD83C\\uDFFE|\\uD83D\\uDC71\\uD83C\\uDFFD|\\uD83D\\uDC71\\uD83C\\uDFFC|\\uD83D\\uDC71\\uD83C\\uDFFB|\\uD83D\\uDC70\\uD83C\\uDFFF|\\uD83D\\uDC70\\uD83C\\uDFFE|\\uD83D\\uDC70\\uD83C\\uDFFD|\\uD83D\\uDC70\\uD83C\\uDFFC|\\uD83D\\uDC70\\uD83C\\uDFFB|\\uD83D\\uDC6E\\uD83C\\uDFFF|\\uD83D\\uDC6E\\uD83C\\uDFFE|\\uD83D\\uDC6E\\uD83C\\uDFFD|\\uD83D\\uDC6E\\uD83C\\uDFFC|\\uD83D\\uDC6E\\uD83C\\uDFFB|\\uD83D\\uDC69\\uD83C\\uDFFF|\\uD83D\\uDC69\\uD83C\\uDFFE|\\uD83D\\uDC69\\uD83C\\uDFFD|\\uD83D\\uDC69\\uD83C\\uDFFC|\\uD83D\\uDC69\\uD83C\\uDFFB|\\uD83D\\uDC68\\uD83C\\uDFFF|\\uD83D\\uDC68\\uD83C\\uDFFE|\\uD83D\\uDC68\\uD83C\\uDFFD|\\uD83D\\uDC68\\uD83C\\uDFFC|\\uD83D\\uDC68\\uD83C\\uDFFB|\\uD83D\\uDC67\\uD83C\\uDFFF|\\uD83D\\uDC67\\uD83C\\uDFFE|\\uD83D\\uDC67\\uD83C\\uDFFD|\\uD83D\\uDC67\\uD83C\\uDFFC|\\uD83D\\uDC67\\uD83C\\uDFFB|\\uD83D\\uDC66\\uD83C\\uDFFF|\\uD83D\\uDC66\\uD83C\\uDFFE|\\uD83D\\uDC66\\uD83C\\uDFFD|\\uD83D\\uDC66\\uD83C\\uDFFC|\\uD83D\\uDC66\\uD83C\\uDFFB|\\uD83D\\uDC50\\uD83C\\uDFFF|\\uD83D\\uDC50\\uD83C\\uDFFE|\\uD83D\\uDC50\\uD83C\\uDFFD|\\uD83D\\uDC50\\uD83C\\uDFFC|\\uD83D\\uDC50\\uD83C\\uDFFB|\\uD83D\\uDC4F\\uD83C\\uDFFF|\\uD83D\\uDC4F\\uD83C\\uDFFE|\\uD83D\\uDC4F\\uD83C\\uDFFD|\\uD83D\\uDC4F\\uD83C\\uDFFC|\\uD83D\\uDC4F\\uD83C\\uDFFB|\\uD83D\\uDC4E\\uD83C\\uDFFF|\\uD83D\\uDC4E\\uD83C\\uDFFE|\\uD83D\\uDC4E\\uD83C\\uDFFD|\\uD83D\\uDC4E\\uD83C\\uDFFC|\\uD83D\\uDC4E\\uD83C\\uDFFB|\\uD83D\\uDC4D\\uD83C\\uDFFF|\\uD83D\\uDC4D\\uD83C\\uDFFE|\\uD83D\\uDC4D\\uD83C\\uDFFD|\\uD83D\\uDC4D\\uD83C\\uDFFC|\\uD83D\\uDC4D\\uD83C\\uDFFB|\\uD83D\\uDC4C\\uD83C\\uDFFF|\\uD83D\\uDC4C\\uD83C\\uDFFE|\\uD83D\\uDC4C\\uD83C\\uDFFD|\\uD83D\\uDC4C\\uD83C\\uDFFC|\\uD83D\\uDC4C\\uD83C\\uDFFB|\\uD83D\\uDC4B\\uD83C\\uDFFF|\\uD83D\\uDC4B\\uD83C\\uDFFE|\\uD83D\\uDC4B\\uD83C\\uDFFD|\\uD83D\\uDC4B\\uD83C\\uDFFC|\\uD83D\\uDC4B\\uD83C\\uDFFB|\\uD83D\\uDC4A\\uD83C\\uDFFF|\\uD83D\\uDC4A\\uD83C\\uDFFE|\\uD83D\\uDC4A\\uD83C\\uDFFD|\\uD83D\\uDC4A\\uD83C\\uDFFC|\\uD83D\\uDC4A\\uD83C\\uDFFB|\\uD83D\\uDC49\\uD83C\\uDFFF|\\uD83D\\uDC49\\uD83C\\uDFFE|\\uD83D\\uDC49\\uD83C\\uDFFD|\\uD83D\\uDC49\\uD83C\\uDFFC|\\uD83D\\uDC49\\uD83C\\uDFFB|\\uD83D\\uDC48\\uD83C\\uDFFF|\\uD83D\\uDC48\\uD83C\\uDFFE|\\uD83D\\uDC48\\uD83C\\uDFFD|\\uD83D\\uDC48\\uD83C\\uDFFC|\\uD83D\\uDC48\\uD83C\\uDFFB|\\uD83D\\uDC47\\uD83C\\uDFFF|\\uD83D\\uDC47\\uD83C\\uDFFE|\\uD83D\\uDC47\\uD83C\\uDFFD|\\uD83D\\uDC47\\uD83C\\uDFFC|\\uD83D\\uDC47\\uD83C\\uDFFB|\\uD83D\\uDC46\\uD83C\\uDFFF|\\uD83D\\uDC46\\uD83C\\uDFFE|\\uD83D\\uDC46\\uD83C\\uDFFD|\\uD83D\\uDC46\\uD83C\\uDFFC|\\uD83D\\uDC46\\uD83C\\uDFFB|\\uD83D\\uDC43\\uD83C\\uDFFF|\\uD83D\\uDC43\\uD83C\\uDFFE|\\uD83D\\uDC43\\uD83C\\uDFFD|\\uD83D\\uDC43\\uD83C\\uDFFC|\\uD83D\\uDC43\\uD83C\\uDFFB|\\uD83D\\uDC42\\uD83C\\uDFFF|\\uD83D\\uDC42\\uD83C\\uDFFE|\\uD83D\\uDC42\\uD83C\\uDFFD|\\uD83D\\uDC42\\uD83C\\uDFFC|\\uD83D\\uDC42\\uD83C\\uDFFB|\\uD83C\\uDFCB\\uD83C\\uDFFF|\\uD83C\\uDFCB\\uD83C\\uDFFE|\\uD83C\\uDFCB\\uD83C\\uDFFD|\\uD83C\\uDFCB\\uD83C\\uDFFC|\\uD83C\\uDFCB\\uD83C\\uDFFB|\\uD83C\\uDFCA\\uD83C\\uDFFF|\\uD83C\\uDFCA\\uD83C\\uDFFE|\\uD83C\\uDFCA\\uD83C\\uDFFD|\\uD83C\\uDFCA\\uD83C\\uDFFC|\\uD83C\\uDFCA\\uD83C\\uDFFB|\\uD83C\\uDFC7\\uD83C\\uDFFF|\\uD83C\\uDFC7\\uD83C\\uDFFE|\\uD83C\\uDFC7\\uD83C\\uDFFD|\\uD83C\\uDFC7\\uD83C\\uDFFC|\\uD83C\\uDFC7\\uD83C\\uDFFB|\\uD83C\\uDFC4\\uD83C\\uDFFF|\\uD83C\\uDFC4\\uD83C\\uDFFE|\\uD83C\\uDFC4\\uD83C\\uDFFD|\\uD83C\\uDFC4\\uD83C\\uDFFC|\\uD83C\\uDFC4\\uD83C\\uDFFB|\\uD83C\\uDFC3\\uD83C\\uDFFF|\\uD83C\\uDFC3\\uD83C\\uDFFE|\\uD83C\\uDFC3\\uD83C\\uDFFD|\\uD83C\\uDFC3\\uD83C\\uDFFC|\\uD83C\\uDFC3\\uD83C\\uDFFB|\\uD83C\\uDF85\\uD83C\\uDFFF|\\uD83C\\uDF85\\uD83C\\uDFFE|\\uD83C\\uDF85\\uD83C\\uDFFD|\\uD83C\\uDF85\\uD83C\\uDFFC|\\uD83C\\uDF85\\uD83C\\uDFFB|\\uD83C\\uDDFF\\uD83C\\uDDFC|\\uD83C\\uDDFF\\uD83C\\uDDF2|\\uD83C\\uDDFF\\uD83C\\uDDE6|\\uD83C\\uDDFE\\uD83C\\uDDF9|\\uD83C\\uDDFE\\uD83C\\uDDEA|\\uD83C\\uDDFD\\uD83C\\uDDF0|\\uD83C\\uDDFC\\uD83C\\uDDF8|\\uD83C\\uDDFC\\uD83C\\uDDEB|\\uD83C\\uDDFB\\uD83C\\uDDFA|\\uD83C\\uDDFB\\uD83C\\uDDF3|\\uD83C\\uDDFB\\uD83C\\uDDEE|\\uD83C\\uDDFB\\uD83C\\uDDEC|\\uD83C\\uDDFB\\uD83C\\uDDEA|\\uD83C\\uDDFB\\uD83C\\uDDE8|\\uD83C\\uDDFB\\uD83C\\uDDE6|\\uD83C\\uDDFA\\uD83C\\uDDFF|\\uD83C\\uDDFA\\uD83C\\uDDFE|\\uD83C\\uDDFA\\uD83C\\uDDF8|\\uD83C\\uDDFA\\uD83C\\uDDF2|\\uD83C\\uDDFA\\uD83C\\uDDEC|\\uD83C\\uDDFA\\uD83C\\uDDE6|\\uD83C\\uDDF9\\uD83C\\uDDFF|\\uD83C\\uDDF9\\uD83C\\uDDFC|\\uD83C\\uDDF9\\uD83C\\uDDFB|\\uD83C\\uDDF9\\uD83C\\uDDF9|\\uD83C\\uDDF9\\uD83C\\uDDF7|\\uD83C\\uDDF9\\uD83C\\uDDF4|\\uD83C\\uDDF9\\uD83C\\uDDF3|\\uD83C\\uDDF9\\uD83C\\uDDF2|\\uD83C\\uDDF9\\uD83C\\uDDF1|\\uD83C\\uDDF9\\uD83C\\uDDF0|\\uD83C\\uDDF9\\uD83C\\uDDEF|\\uD83C\\uDDF9\\uD83C\\uDDED|\\uD83C\\uDDF9\\uD83C\\uDDEC|\\uD83C\\uDDF9\\uD83C\\uDDEB|\\uD83C\\uDDE6\\uD83C\\uDDE8|\\uD83C\\uDDF9\\uD83C\\uDDE8|\\uD83C\\uDDF9\\uD83C\\uDDE6|\\uD83C\\uDDF8\\uD83C\\uDDFF|\\uD83C\\uDDF8\\uD83C\\uDDFE|\\uD83C\\uDDF8\\uD83C\\uDDFD|\\uD83C\\uDDF8\\uD83C\\uDDFB|\\uD83C\\uDDF8\\uD83C\\uDDF9|\\uD83C\\uDDF8\\uD83C\\uDDF8|\\uD83C\\uDDF8\\uD83C\\uDDF7|\\uD83C\\uDDF8\\uD83C\\uDDF4|\\uD83C\\uDDF8\\uD83C\\uDDF3|\\uD83C\\uDDF8\\uD83C\\uDDF2|\\uD83C\\uDDF8\\uD83C\\uDDF1|\\uD83C\\uDDF8\\uD83C\\uDDF0|\\uD83C\\uDDF8\\uD83C\\uDDEF|\\uD83C\\uDDF8\\uD83C\\uDDEE|\\uD83C\\uDDF8\\uD83C\\uDDED|\\uD83C\\uDDF8\\uD83C\\uDDEC|\\uD83C\\uDDF8\\uD83C\\uDDEA|\\uD83C\\uDDF8\\uD83C\\uDDE9|\\uD83C\\uDDF8\\uD83C\\uDDE8|\\uD83C\\uDDF8\\uD83C\\uDDE7|\\uD83C\\uDDF8\\uD83C\\uDDE6|\\uD83C\\uDDF7\\uD83C\\uDDFC|\\uD83C\\uDDF7\\uD83C\\uDDFA|\\uD83C\\uDDF7\\uD83C\\uDDF8|\\uD83C\\uDDF7\\uD83C\\uDDF4|\\uD83C\\uDDF7\\uD83C\\uDDEA|\\uD83C\\uDDF6\\uD83C\\uDDE6|\\uD83C\\uDDF5\\uD83C\\uDDFE|\\uD83C\\uDDF5\\uD83C\\uDDFC|\\uD83C\\uDDF5\\uD83C\\uDDF9|\\uD83C\\uDDF5\\uD83C\\uDDF8|\\uD83C\\uDDF5\\uD83C\\uDDF7|\\uD83C\\uDDF5\\uD83C\\uDDF3|\\uD83C\\uDDF5\\uD83C\\uDDF2|\\uD83C\\uDDF5\\uD83C\\uDDF1|\\uD83C\\uDDF5\\uD83C\\uDDF0|\\uD83C\\uDDF5\\uD83C\\uDDED|\\uD83C\\uDDF5\\uD83C\\uDDEC|\\uD83C\\uDDF5\\uD83C\\uDDEB|\\uD83C\\uDDF5\\uD83C\\uDDEA|\\uD83C\\uDDF5\\uD83C\\uDDE6|\\uD83C\\uDDF4\\uD83C\\uDDF2|\\uD83C\\uDDF3\\uD83C\\uDDFF|\\uD83C\\uDDF3\\uD83C\\uDDFA|\\uD83C\\uDDF3\\uD83C\\uDDF7|\\uD83C\\uDDF3\\uD83C\\uDDF5|\\uD83C\\uDDF3\\uD83C\\uDDF4|\\uD83C\\uDDF3\\uD83C\\uDDF1|\\uD83C\\uDDF3\\uD83C\\uDDEE|\\uD83C\\uDDF3\\uD83C\\uDDEC|\\uD83C\\uDDF3\\uD83C\\uDDEB|\\uD83C\\uDDF3\\uD83C\\uDDEA|\\uD83C\\uDDF3\\uD83C\\uDDE8|\\uD83C\\uDDF3\\uD83C\\uDDE6|\\uD83C\\uDDF2\\uD83C\\uDDFF|\\uD83C\\uDDF2\\uD83C\\uDDFE|\\uD83C\\uDDF2\\uD83C\\uDDFD|\\uD83C\\uDDF2\\uD83C\\uDDFC|\\uD83C\\uDDF2\\uD83C\\uDDFB|\\uD83C\\uDDF2\\uD83C\\uDDFA|\\uD83C\\uDDF2\\uD83C\\uDDF9|\\uD83C\\uDDF2\\uD83C\\uDDF8|\\uD83C\\uDDF2\\uD83C\\uDDF7|\\uD83C\\uDDF2\\uD83C\\uDDF6|\\uD83C\\uDDF2\\uD83C\\uDDF5|\\uD83C\\uDDF2\\uD83C\\uDDF4|\\uD83C\\uDDF2\\uD83C\\uDDF3|\\uD83C\\uDDF2\\uD83C\\uDDF2|\\uD83C\\uDDF2\\uD83C\\uDDF1|\\uD83C\\uDDF2\\uD83C\\uDDF0|\\uD83C\\uDDF2\\uD83C\\uDDED|\\uD83C\\uDDF2\\uD83C\\uDDEC|\\uD83C\\uDDF2\\uD83C\\uDDEB|\\uD83C\\uDDF2\\uD83C\\uDDEA|\\uD83C\\uDDF2\\uD83C\\uDDE9|\\uD83C\\uDDF2\\uD83C\\uDDE8|\\uD83C\\uDDF2\\uD83C\\uDDE6|\\uD83C\\uDDF1\\uD83C\\uDDFE|\\uD83C\\uDDF1\\uD83C\\uDDFB|\\uD83C\\uDDF1\\uD83C\\uDDFA|\\uD83C\\uDDF1\\uD83C\\uDDF9|\\uD83C\\uDDF1\\uD83C\\uDDF8|\\uD83C\\uDDF1\\uD83C\\uDDF7|\\uD83C\\uDDF1\\uD83C\\uDDF0|\\uD83C\\uDDF1\\uD83C\\uDDEE|\\uD83C\\uDDF1\\uD83C\\uDDE8|\\uD83C\\uDDF1\\uD83C\\uDDE7|\\uD83C\\uDDF1\\uD83C\\uDDE6|\\uD83C\\uDDF0\\uD83C\\uDDFF|\\uD83C\\uDDF0\\uD83C\\uDDFE|\\uD83C\\uDDF0\\uD83C\\uDDFC|\\uD83C\\uDDF0\\uD83C\\uDDF7|\\uD83C\\uDDF0\\uD83C\\uDDF5|\\uD83C\\uDDF0\\uD83C\\uDDF3|\\uD83C\\uDDF0\\uD83C\\uDDF2|\\uD83C\\uDDF0\\uD83C\\uDDEE|\\uD83C\\uDDF0\\uD83C\\uDDED|\\uD83C\\uDDF0\\uD83C\\uDDEC|\\uD83C\\uDDF0\\uD83C\\uDDEA|\\uD83C\\uDDEF\\uD83C\\uDDF5|\\uD83C\\uDDEF\\uD83C\\uDDF4|\\uD83C\\uDDEF\\uD83C\\uDDF2|\\uD83C\\uDDEF\\uD83C\\uDDEA|\\uD83C\\uDDEE\\uD83C\\uDDF9|\\uD83C\\uDDEE\\uD83C\\uDDF8|\\uD83C\\uDDEE\\uD83C\\uDDF7|\\uD83C\\uDDEE\\uD83C\\uDDF6|\\uD83C\\uDDEE\\uD83C\\uDDF4|\\uD83C\\uDDEE\\uD83C\\uDDF3|\\uD83C\\uDDEE\\uD83C\\uDDF2|\\uD83C\\uDDEE\\uD83C\\uDDF1|\\uD83C\\uDDEE\\uD83C\\uDDEA|\\uD83C\\uDDEE\\uD83C\\uDDE9|\\uD83C\\uDDEE\\uD83C\\uDDE8|\\uD83C\\uDDED\\uD83C\\uDDFA|\\uD83C\\uDDED\\uD83C\\uDDF9|\\uD83C\\uDDED\\uD83C\\uDDF7|\\uD83C\\uDDED\\uD83C\\uDDF3|\\uD83C\\uDDED\\uD83C\\uDDF2|\\uD83C\\uDDED\\uD83C\\uDDF0|\\uD83C\\uDDEC\\uD83C\\uDDFE|\\uD83C\\uDDEC\\uD83C\\uDDFC|\\uD83C\\uDDEC\\uD83C\\uDDFA|\\uD83C\\uDDEC\\uD83C\\uDDF9|\\uD83C\\uDDEC\\uD83C\\uDDF8|\\uD83C\\uDDEC\\uD83C\\uDDF7|\\uD83C\\uDDEC\\uD83C\\uDDF6|\\uD83C\\uDDEC\\uD83C\\uDDF5|\\uD83C\\uDDEC\\uD83C\\uDDF3|\\uD83C\\uDDEC\\uD83C\\uDDF2|\\uD83C\\uDDEC\\uD83C\\uDDF1|\\uD83C\\uDDEC\\uD83C\\uDDEE|\\uD83C\\uDDEC\\uD83C\\uDDED|\\uD83C\\uDDEC\\uD83C\\uDDEC|\\uD83C\\uDDEC\\uD83C\\uDDEB|\\uD83C\\uDDEC\\uD83C\\uDDEA|\\uD83C\\uDDEC\\uD83C\\uDDE9|\\uD83C\\uDDEC\\uD83C\\uDDE7|\\uD83C\\uDDEC\\uD83C\\uDDE6|\\uD83C\\uDDEB\\uD83C\\uDDF7|\\uD83C\\uDDEB\\uD83C\\uDDF4|\\uD83C\\uDDEB\\uD83C\\uDDF2|\\uD83C\\uDDEB\\uD83C\\uDDF0|\\uD83C\\uDDEB\\uD83C\\uDDEF|\\uD83C\\uDDEB\\uD83C\\uDDEE|\\uD83C\\uDDEA\\uD83C\\uDDFA|\\uD83C\\uDDEA\\uD83C\\uDDF9|\\uD83C\\uDDEA\\uD83C\\uDDF8|\\uD83C\\uDDEA\\uD83C\\uDDF7|\\uD83C\\uDDEA\\uD83C\\uDDED|\\uD83C\\uDDEA\\uD83C\\uDDEC|\\uD83C\\uDDEA\\uD83C\\uDDEA|\\uD83C\\uDDEA\\uD83C\\uDDE8|\\uD83C\\uDDEA\\uD83C\\uDDE6|\\uD83C\\uDDE9\\uD83C\\uDDFF|\\uD83C\\uDDE9\\uD83C\\uDDF4|\\uD83C\\uDDE9\\uD83C\\uDDF2|\\uD83C\\uDDE9\\uD83C\\uDDF0|\\uD83C\\uDDE9\\uD83C\\uDDEF|\\uD83C\\uDDE9\\uD83C\\uDDEC|\\uD83C\\uDDE9\\uD83C\\uDDEA|\\uD83C\\uDDE8\\uD83C\\uDDFF|\\uD83C\\uDDE8\\uD83C\\uDDFE|\\uD83C\\uDDE8\\uD83C\\uDDFD|\\uD83C\\uDDE8\\uD83C\\uDDFC|\\uD83C\\uDDE8\\uD83C\\uDDFB|\\uD83C\\uDDE8\\uD83C\\uDDFA|\\uD83C\\uDDE8\\uD83C\\uDDF7|\\uD83C\\uDDE8\\uD83C\\uDDF5|\\uD83C\\uDDE8\\uD83C\\uDDF4|\\uD83C\\uDDE8\\uD83C\\uDDF3|\\uD83C\\uDDE8\\uD83C\\uDDF2|\\uD83C\\uDDE8\\uD83C\\uDDF1|\\uD83C\\uDDE8\\uD83C\\uDDF0|\\uD83C\\uDDE8\\uD83C\\uDDEE|\\uD83C\\uDDE8\\uD83C\\uDDED|\\uD83C\\uDDE8\\uD83C\\uDDEC|\\uD83C\\uDDE8\\uD83C\\uDDEB|\\uD83C\\uDDE8\\uD83C\\uDDE9|\\uD83C\\uDDE8\\uD83C\\uDDE8|\\uD83C\\uDDE8\\uD83C\\uDDE6|\\uD83C\\uDDE7\\uD83C\\uDDFF|\\uD83C\\uDDE7\\uD83C\\uDDFE|\\uD83C\\uDDE7\\uD83C\\uDDFC|\\uD83C\\uDDE7\\uD83C\\uDDFB|\\uD83C\\uDDE7\\uD83C\\uDDF9|\\uD83C\\uDDE7\\uD83C\\uDDF8|\\uD83C\\uDDE7\\uD83C\\uDDF7|\\uD83C\\uDDE7\\uD83C\\uDDF6|\\uD83C\\uDDE7\\uD83C\\uDDF4|\\uD83C\\uDDE7\\uD83C\\uDDF3|\\uD83C\\uDDE7\\uD83C\\uDDF2|\\uD83C\\uDDE7\\uD83C\\uDDF1|\\uD83C\\uDDE7\\uD83C\\uDDEF|\\uD83C\\uDDE7\\uD83C\\uDDEE|\\uD83C\\uDDE7\\uD83C\\uDDED|\\uD83C\\uDDE7\\uD83C\\uDDEC|\\uD83C\\uDDE7\\uD83C\\uDDEB|\\uD83C\\uDDE7\\uD83C\\uDDEA|\\uD83C\\uDDE7\\uD83C\\uDDE9|\\uD83C\\uDDE7\\uD83C\\uDDE7|\\uD83C\\uDDE7\\uD83C\\uDDE6|\\uD83C\\uDDE6\\uD83C\\uDDFF|\\uD83C\\uDDE6\\uD83C\\uDDFD|\\uD83C\\uDDE6\\uD83C\\uDDFC|\\uD83C\\uDDE6\\uD83C\\uDDFA|\\uD83C\\uDDE6\\uD83C\\uDDF9|\\uD83C\\uDDF9\\uD83C\\uDDE9|\\uD83D\\uDDE1\\uFE0F|\\u26F9\\uD83C\\uDFFF|\\u26F9\\uD83C\\uDFFE|\\u26F9\\uD83C\\uDFFD|\\u26F9\\uD83C\\uDFFC|\\u26F9\\uD83C\\uDFFB|\\u270D\\uD83C\\uDFFF|\\u270D\\uD83C\\uDFFE|\\u270D\\uD83C\\uDFFD|\\u270D\\uD83C\\uDFFC|\\u270D\\uD83C\\uDFFB|\\uD83C\\uDC04\\uFE0F|\\uD83C\\uDD7F\\uFE0F|\\uD83C\\uDE02\\uFE0F|\\uD83C\\uDE1A\\uFE0F|\\uD83C\\uDE2F\\uFE0F|\\uD83C\\uDE37\\uFE0F|\\uD83C\\uDF9E\\uFE0F|\\uD83C\\uDF9F\\uFE0F|\\uD83C\\uDFCB\\uFE0F|\\uD83C\\uDFCC\\uFE0F|\\uD83C\\uDFCD\\uFE0F|\\uD83C\\uDFCE\\uFE0F|\\uD83C\\uDF96\\uFE0F|\\uD83C\\uDF97\\uFE0F|\\uD83C\\uDF36\\uFE0F|\\uD83C\\uDF27\\uFE0F|\\uD83C\\uDF28\\uFE0F|\\uD83C\\uDF29\\uFE0F|\\uD83C\\uDF2A\\uFE0F|\\uD83C\\uDF2B\\uFE0F|\\uD83C\\uDF2C\\uFE0F|\\uD83D\\uDC3F\\uFE0F|\\uD83D\\uDD77\\uFE0F|\\uD83D\\uDD78\\uFE0F|\\uD83C\\uDF21\\uFE0F|\\uD83C\\uDF99\\uFE0F|\\uD83C\\uDF9A\\uFE0F|\\uD83C\\uDF9B\\uFE0F|\\uD83C\\uDFF3\\uFE0F|\\uD83C\\uDFF5\\uFE0F|\\uD83C\\uDFF7\\uFE0F|\\uD83D\\uDCFD\\uFE0F|\\uD83D\\uDD49\\uFE0F|\\uD83D\\uDD4A\\uFE0F|\\uD83D\\uDD6F\\uFE0F|\\uD83D\\uDD70\\uFE0F|\\uD83D\\uDD73\\uFE0F|\\uD83D\\uDD76\\uFE0F|\\uD83D\\uDD79\\uFE0F|\\uD83D\\uDD87\\uFE0F|\\uD83D\\uDD8A\\uFE0F|\\uD83D\\uDD8B\\uFE0F|\\uD83D\\uDD8C\\uFE0F|\\uD83D\\uDD8D\\uFE0F|\\uD83D\\uDDA5\\uFE0F|\\uD83D\\uDDA8\\uFE0F|\\uD83D\\uDDB2\\uFE0F|\\uD83D\\uDDBC\\uFE0F|\\uD83D\\uDDC2\\uFE0F|\\uD83D\\uDDC3\\uFE0F|\\uD83D\\uDDC4\\uFE0F|\\uD83D\\uDDD1\\uFE0F|\\uD83D\\uDDD2\\uFE0F|\\uD83D\\uDDD3\\uFE0F|\\uD83D\\uDDDC\\uFE0F|\\uD83D\\uDDDD\\uFE0F|\\uD83D\\uDDDE\\uFE0F|\\u270B\\uD83C\\uDFFF|\\uD83D\\uDDE3\\uFE0F|\\uD83D\\uDDEF\\uFE0F|\\uD83D\\uDDF3\\uFE0F|\\uD83D\\uDDFA\\uFE0F|\\uD83D\\uDEE0\\uFE0F|\\uD83D\\uDEE1\\uFE0F|\\uD83D\\uDEE2\\uFE0F|\\uD83D\\uDEF0\\uFE0F|\\uD83C\\uDF7D\\uFE0F|\\uD83D\\uDC41\\uFE0F|\\uD83D\\uDD74\\uFE0F|\\uD83D\\uDD75\\uFE0F|\\uD83D\\uDD90\\uFE0F|\\uD83C\\uDFD4\\uFE0F|\\uD83C\\uDFD5\\uFE0F|\\uD83C\\uDFD6\\uFE0F|\\uD83C\\uDFD7\\uFE0F|\\uD83C\\uDFD8\\uFE0F|\\uD83C\\uDFD9\\uFE0F|\\uD83C\\uDFDA\\uFE0F|\\uD83C\\uDFDB\\uFE0F|\\uD83C\\uDFDC\\uFE0F|\\uD83C\\uDFDD\\uFE0F|\\uD83C\\uDFDE\\uFE0F|\\uD83C\\uDFDF\\uFE0F|\\uD83D\\uDECB\\uFE0F|\\uD83D\\uDECD\\uFE0F|\\uD83D\\uDECE\\uFE0F|\\uD83D\\uDECF\\uFE0F|\\uD83D\\uDEE3\\uFE0F|\\uD83D\\uDEE4\\uFE0F|\\uD83D\\uDEE5\\uFE0F|\\uD83D\\uDEE9\\uFE0F|\\uD83D\\uDEF3\\uFE0F|\\uD83C\\uDF24\\uFE0F|\\uD83C\\uDF25\\uFE0F|\\uD83C\\uDF26\\uFE0F|\\uD83D\\uDDB1\\uFE0F|\\u261D\\uD83C\\uDFFB|\\u261D\\uD83C\\uDFFC|\\u261D\\uD83C\\uDFFD|\\u261D\\uD83C\\uDFFE|\\u261D\\uD83C\\uDFFF|\\u270C\\uD83C\\uDFFB|\\u270C\\uD83C\\uDFFC|\\u270C\\uD83C\\uDFFD|\\u270C\\uD83C\\uDFFE|\\u270C\\uD83C\\uDFFF|\\u270A\\uD83C\\uDFFB|\\u270A\\uD83C\\uDFFC|\\u270A\\uD83C\\uDFFD|\\u270A\\uD83C\\uDFFE|\\u270A\\uD83C\\uDFFF|\\u270B\\uD83C\\uDFFB|\\u270B\\uD83C\\uDFFC|\\u270B\\uD83C\\uDFFD|\\u270B\\uD83C\\uDFFE|4\\uFE0F\\u20E3|9\\uFE0F\\u20E3|0\\uFE0F\\u20E3|1\\uFE0F\\u20E3|2\\uFE0F\\u20E3|3\\uFE0F\\u20E3|#\\uFE0F\\u20E3|5\\uFE0F\\u20E3|6\\uFE0F\\u20E3|7\\uFE0F\\u20E3|8\\uFE0F\\u20E3|\\*\\uFE0F\\u20E3|\\u00A9\\uFE0F|\\u00AE\\uFE0F|\\u203C\\uFE0F|\\u2049\\uFE0F|\\u2122\\uFE0F|\\u2139\\uFE0F|\\u2194\\uFE0F|\\u2195\\uFE0F|\\u2196\\uFE0F|\\u2197\\uFE0F|\\u2198\\uFE0F|\\u2199\\uFE0F|\\u21A9\\uFE0F|\\u21AA\\uFE0F|\\u231A\\uFE0F|\\u231B\\uFE0F|\\u24C2\\uFE0F|\\u25AA\\uFE0F|\\u25AB\\uFE0F|\\u25B6\\uFE0F|\\u25C0\\uFE0F|\\u25FB\\uFE0F|\\u25FC\\uFE0F|\\u25FD\\uFE0F|\\u25FE\\uFE0F|\\u2600\\uFE0F|\\u2601\\uFE0F|\\u260E\\uFE0F|\\u2611\\uFE0F|\\u2614\\uFE0F|\\u2615\\uFE0F|\\u261D\\uFE0F|\\u263A\\uFE0F|\\u2648\\uFE0F|\\u2649\\uFE0F|\\u264A\\uFE0F|\\u264B\\uFE0F|\\u264C\\uFE0F|\\u264D\\uFE0F|\\u264E\\uFE0F|\\u264F\\uFE0F|\\u2650\\uFE0F|\\u2651\\uFE0F|\\u2652\\uFE0F|\\u2653\\uFE0F|\\u2660\\uFE0F|\\u2663\\uFE0F|\\u2665\\uFE0F|\\u2666\\uFE0F|\\u2668\\uFE0F|\\u267B\\uFE0F|\\u267F\\uFE0F|\\u2693\\uFE0F|\\u26A0\\uFE0F|\\u26A1\\uFE0F|\\u26AA\\uFE0F|\\u26AB\\uFE0F|\\u26BD\\uFE0F|\\u26BE\\uFE0F|\\u26C4\\uFE0F|\\u26C5\\uFE0F|\\u26D4\\uFE0F|\\u26EA\\uFE0F|\\u26F2\\uFE0F|\\u26F3\\uFE0F|\\u26F5\\uFE0F|\\u26FA\\uFE0F|\\u26FD\\uFE0F|\\u2702\\uFE0F|\\u2708\\uFE0F|\\u2709\\uFE0F|\\u270C\\uFE0F|\\u270F\\uFE0F|\\u2712\\uFE0F|\\u2714\\uFE0F|\\u2716\\uFE0F|\\u2733\\uFE0F|\\u2734\\uFE0F|\\u2744\\uFE0F|\\u2747\\uFE0F|\\u2757\\uFE0F|\\u2764\\uFE0F|\\u27A1\\uFE0F|\\u2934\\uFE0F|\\u2935\\uFE0F|\\u2B05\\uFE0F|\\u2B06\\uFE0F|\\u2B07\\uFE0F|\\u2B1B\\uFE0F|\\u2B1C\\uFE0F|\\u2B50\\uFE0F|\\u2B55\\uFE0F|\\u3030\\uFE0F|\\u303D\\uFE0F|\\u3297\\uFE0F|\\u3299\\uFE0F|\\u271D\\uFE0F|\\u2328\\uFE0F|\\u270D\\uFE0F|\\u23ED\\uFE0F|\\u23EE\\uFE0F|\\u23EF\\uFE0F|\\u23F1\\uFE0F|\\u23F2\\uFE0F|\\u23F8\\uFE0F|\\u23F9\\uFE0F|\\u23FA\\uFE0F|\\u2602\\uFE0F|\\u2603\\uFE0F|\\u2604\\uFE0F|\\u2618\\uFE0F|\\u2620\\uFE0F|\\u2622\\uFE0F|\\u2623\\uFE0F|\\u2626\\uFE0F|\\u262A\\uFE0F|\\u262E\\uFE0F|\\u262F\\uFE0F|\\u2638\\uFE0F|\\u2639\\uFE0F|\\u2692\\uFE0F|\\u2694\\uFE0F|\\u2696\\uFE0F|\\u2697\\uFE0F|\\u2699\\uFE0F|\\u269B\\uFE0F|\\u269C\\uFE0F|\\u26B0\\uFE0F|\\u26B1\\uFE0F|\\u26C8\\uFE0F|\\u26CF\\uFE0F|\\u26D1\\uFE0F|\\u26D3\\uFE0F|\\u26E9\\uFE0F|\\u26F0\\uFE0F|\\u26F1\\uFE0F|\\u26F4\\uFE0F|\\u26F7\\uFE0F|\\u26F8\\uFE0F|\\u26F9\\uFE0F|\\u2721\\uFE0F|\\u2763\\uFE0F|\\uD83C\\uDCCF|\\uD83C\\uDD70|\\uD83C\\uDD71|\\uD83C\\uDD7E|\\uD83C\\uDD8E|\\uD83C\\uDD91|\\uD83C\\uDD92|\\uD83C\\uDD93|\\uD83C\\uDD94|\\uD83C\\uDD95|\\uD83C\\uDD96|\\uD83C\\uDD97|\\uD83C\\uDD98|\\uD83C\\uDD99|\\uD83C\\uDD9A|\\uD83C\\uDE01|\\uD83C\\uDE32|\\uD83C\\uDE33|\\uD83C\\uDE34|\\uD83C\\uDE35|\\uD83C\\uDE36|\\uD83C\\uDE38|\\uD83C\\uDE39|\\uD83C\\uDE3A|\\uD83C\\uDE50|\\uD83C\\uDE51|\\uD83C\\uDF00|\\uD83C\\uDF01|\\uD83C\\uDF02|\\uD83C\\uDF03|\\uD83C\\uDF04|\\uD83C\\uDF05|\\uD83C\\uDF06|\\uD83C\\uDF07|\\uD83C\\uDF08|\\uD83C\\uDF09|\\uD83C\\uDF0A|\\uD83C\\uDF0B|\\uD83C\\uDF0C|\\uD83C\\uDF0F|\\uD83C\\uDF11|\\uD83C\\uDF13|\\uD83C\\uDF14|\\uD83C\\uDF15|\\uD83C\\uDF19|\\uD83C\\uDF1B|\\uD83C\\uDF1F|\\uD83C\\uDF20|\\uD83C\\uDF30|\\uD83C\\uDF31|\\uD83C\\uDF34|\\uD83C\\uDF35|\\uD83C\\uDF37|\\uD83C\\uDF38|\\uD83C\\uDF39|\\uD83C\\uDF3A|\\uD83C\\uDF3B|\\uD83C\\uDF3C|\\uD83C\\uDF3D|\\uD83C\\uDF3E|\\uD83C\\uDF3F|\\uD83C\\uDF40|\\uD83C\\uDF41|\\uD83C\\uDF42|\\uD83C\\uDF43|\\uD83C\\uDF44|\\uD83C\\uDF45|\\uD83C\\uDF46|\\uD83C\\uDF47|\\uD83C\\uDF48|\\uD83C\\uDF49|\\uD83C\\uDF4A|\\uD83C\\uDF4C|\\uD83C\\uDF4D|\\uD83C\\uDF4E|\\uD83C\\uDF4F|\\uD83C\\uDF51|\\uD83C\\uDF52|\\uD83C\\uDF53|\\uD83C\\uDF54|\\uD83C\\uDF55|\\uD83C\\uDF56|\\uD83C\\uDF57|\\uD83C\\uDF58|\\uD83C\\uDF59|\\uD83C\\uDF5A|\\uD83C\\uDF5B|\\uD83C\\uDF5C|\\uD83C\\uDF5D|\\uD83C\\uDF5E|\\uD83C\\uDF5F|\\uD83C\\uDF60|\\uD83C\\uDF61|\\uD83C\\uDF62|\\uD83C\\uDF63|\\uD83C\\uDF64|\\uD83C\\uDF65|\\uD83C\\uDF66|\\uD83C\\uDF67|\\uD83C\\uDF68|\\uD83C\\uDF69|\\uD83C\\uDF6A|\\uD83C\\uDF6B|\\uD83C\\uDF6C|\\uD83C\\uDF6D|\\uD83C\\uDF6E|\\uD83C\\uDF6F|\\uD83C\\uDF70|\\uD83C\\uDF71|\\uD83C\\uDF72|\\uD83C\\uDF73|\\uD83C\\uDF74|\\uD83C\\uDF75|\\uD83C\\uDF76|\\uD83C\\uDF77|\\uD83C\\uDF78|\\uD83C\\uDF79|\\uD83C\\uDF7A|\\uD83C\\uDF7B|\\uD83C\\uDF80|\\uD83C\\uDF81|\\uD83C\\uDF82|\\uD83C\\uDF83|\\uD83C\\uDF84|\\uD83C\\uDF85|\\uD83C\\uDF86|\\uD83C\\uDF87|\\uD83C\\uDF88|\\uD83C\\uDF89|\\uD83C\\uDF8A|\\uD83C\\uDF8B|\\uD83C\\uDF8C|\\uD83C\\uDF8D|\\uD83C\\uDF8E|\\uD83C\\uDF8F|\\uD83C\\uDF90|\\uD83C\\uDF91|\\uD83C\\uDF92|\\uD83C\\uDF93|\\uD83C\\uDFA0|\\uD83C\\uDFA1|\\uD83C\\uDFA2|\\uD83C\\uDFA3|\\uD83C\\uDFA4|\\uD83C\\uDFA5|\\uD83C\\uDFA6|\\uD83C\\uDFA7|\\uD83C\\uDFA8|\\uD83C\\uDFA9|\\uD83C\\uDFAA|\\uD83C\\uDFAB|\\uD83C\\uDFAC|\\uD83C\\uDFAD|\\uD83C\\uDFAE|\\uD83C\\uDFAF|\\uD83C\\uDFB0|\\uD83C\\uDFB1|\\uD83C\\uDFB2|\\uD83C\\uDFB3|\\uD83C\\uDFB4|\\uD83C\\uDFB5|\\uD83C\\uDFB6|\\uD83C\\uDFB7|\\uD83C\\uDFB8|\\uD83C\\uDFB9|\\uD83C\\uDFBA|\\uD83C\\uDFBB|\\uD83C\\uDFBC|\\uD83C\\uDFBD|\\uD83C\\uDFBE|\\uD83C\\uDFBF|\\uD83C\\uDFC0|\\uD83C\\uDFC1|\\uD83C\\uDFC2|\\uD83C\\uDFC3|\\uD83C\\uDFC4|\\uD83C\\uDFC6|\\uD83C\\uDFC8|\\uD83C\\uDFCA|\\uD83C\\uDFE0|\\uD83D\\uDDB1|\\uD83C\\uDFE2|\\uD83C\\uDFE3|\\uD83C\\uDFE5|\\uD83C\\uDFE6|\\uD83C\\uDFE7|\\uD83C\\uDFE8|\\uD83C\\uDFE9|\\uD83C\\uDFEA|\\uD83C\\uDFEB|\\uD83C\\uDFEC|\\uD83C\\uDFED|\\uD83C\\uDFEE|\\uD83C\\uDFEF|\\uD83C\\uDFF0|\\uD83D\\uDC0C|\\uD83D\\uDC0D|\\uD83D\\uDC0E|\\uD83D\\uDC11|\\uD83D\\uDC12|\\uD83D\\uDC14|\\uD83D\\uDC17|\\uD83D\\uDC18|\\uD83D\\uDC19|\\uD83D\\uDC1A|\\uD83D\\uDC1B|\\uD83D\\uDC1C|\\uD83D\\uDC1D|\\uD83D\\uDC1E|\\uD83D\\uDC1F|\\uD83D\\uDC20|\\uD83D\\uDC21|\\uD83D\\uDC22|\\uD83D\\uDC23|\\uD83D\\uDC24|\\uD83D\\uDC25|\\uD83D\\uDC26|\\uD83D\\uDC27|\\uD83D\\uDC28|\\uD83D\\uDC29|\\uD83D\\uDC2B|\\uD83D\\uDC2C|\\uD83D\\uDC2D|\\uD83D\\uDC2E|\\uD83D\\uDC2F|\\uD83D\\uDC30|\\uD83D\\uDC31|\\uD83D\\uDC32|\\uD83D\\uDC33|\\uD83D\\uDC34|\\uD83D\\uDC35|\\uD83D\\uDC36|\\uD83D\\uDC37|\\uD83D\\uDC38|\\uD83D\\uDC39|\\uD83D\\uDC3A|\\uD83D\\uDC3B|\\uD83D\\uDC3C|\\uD83D\\uDC3D|\\uD83D\\uDC3E|\\uD83D\\uDC40|\\uD83D\\uDC42|\\uD83D\\uDC43|\\uD83D\\uDC44|\\uD83D\\uDC45|\\uD83D\\uDC46|\\uD83D\\uDC47|\\uD83D\\uDC48|\\uD83D\\uDC49|\\uD83D\\uDC4A|\\uD83D\\uDC4B|\\uD83D\\uDC4C|\\uD83D\\uDC4D|\\uD83D\\uDC4E|\\uD83D\\uDC4F|\\uD83D\\uDC50|\\uD83D\\uDC51|\\uD83D\\uDC52|\\uD83D\\uDC53|\\uD83D\\uDC54|\\uD83D\\uDC55|\\uD83D\\uDC56|\\uD83D\\uDC57|\\uD83D\\uDC58|\\uD83D\\uDC59|\\uD83D\\uDC5A|\\uD83D\\uDC5B|\\uD83D\\uDC5C|\\uD83D\\uDC5D|\\uD83D\\uDC5E|\\uD83D\\uDC5F|\\uD83D\\uDC60|\\uD83D\\uDC61|\\uD83D\\uDC62|\\uD83D\\uDC63|\\uD83D\\uDC64|\\uD83D\\uDC66|\\uD83D\\uDC67|\\uD83D\\uDC68|\\uD83D\\uDC69|\\uD83D\\uDC6A|\\uD83D\\uDC6B|\\uD83D\\uDC6E|\\uD83D\\uDC6F|\\uD83D\\uDC70|\\uD83D\\uDC71|\\uD83D\\uDC72|\\uD83D\\uDC73|\\uD83D\\uDC74|\\uD83D\\uDC75|\\uD83D\\uDC76|\\uD83D\\uDC77|\\uD83D\\uDC78|\\uD83D\\uDC79|\\uD83D\\uDC7A|\\uD83D\\uDC7B|\\uD83D\\uDC7C|\\uD83D\\uDC7D|\\uD83D\\uDC7E|\\uD83D\\uDC7F|\\uD83D\\uDC80|\\uD83D\\uDCC7|\\uD83D\\uDC81|\\uD83D\\uDC82|\\uD83D\\uDC83|\\uD83D\\uDC84|\\uD83D\\uDC85|\\uD83D\\uDCD2|\\uD83D\\uDC86|\\uD83D\\uDCD3|\\uD83D\\uDC87|\\uD83D\\uDCD4|\\uD83D\\uDC88|\\uD83D\\uDCD5|\\uD83D\\uDC89|\\uD83D\\uDCD6|\\uD83D\\uDC8A|\\uD83D\\uDCD7|\\uD83D\\uDC8B|\\uD83D\\uDCD8|\\uD83D\\uDC8C|\\uD83D\\uDCD9|\\uD83D\\uDC8D|\\uD83D\\uDCDA|\\uD83D\\uDC8E|\\uD83D\\uDCDB|\\uD83D\\uDC8F|\\uD83D\\uDCDC|\\uD83D\\uDC90|\\uD83D\\uDCDD|\\uD83D\\uDC91|\\uD83D\\uDCDE|\\uD83D\\uDC92|\\uD83D\\uDCDF|\\uD83D\\uDCE0|\\uD83D\\uDC93|\\uD83D\\uDCE1|\\uD83D\\uDCE2|\\uD83D\\uDC94|\\uD83D\\uDCE3|\\uD83D\\uDCE4|\\uD83D\\uDC95|\\uD83D\\uDCE5|\\uD83D\\uDCE6|\\uD83D\\uDC96|\\uD83D\\uDCE7|\\uD83D\\uDCE8|\\uD83D\\uDC97|\\uD83D\\uDCE9|\\uD83D\\uDCEA|\\uD83D\\uDC98|\\uD83D\\uDCEB|\\uD83D\\uDCEE|\\uD83D\\uDC99|\\uD83D\\uDCF0|\\uD83D\\uDCF1|\\uD83D\\uDC9A|\\uD83D\\uDCF2|\\uD83D\\uDCF3|\\uD83D\\uDC9B|\\uD83D\\uDCF4|\\uD83D\\uDCF6|\\uD83D\\uDC9C|\\uD83D\\uDCF7|\\uD83D\\uDCF9|\\uD83D\\uDC9D|\\uD83D\\uDCFA|\\uD83D\\uDCFB|\\uD83D\\uDC9E|\\uD83D\\uDCFC|\\uD83D\\uDD03|\\uD83D\\uDC9F|\\uD83D\\uDD0A|\\uD83D\\uDD0B|\\uD83D\\uDCA0|\\uD83D\\uDD0C|\\uD83D\\uDD0D|\\uD83D\\uDCA1|\\uD83D\\uDD0E|\\uD83D\\uDD0F|\\uD83D\\uDCA2|\\uD83D\\uDD10|\\uD83D\\uDD11|\\uD83D\\uDCA3|\\uD83D\\uDD12|\\uD83D\\uDD13|\\uD83D\\uDCA4|\\uD83D\\uDD14|\\uD83D\\uDD16|\\uD83D\\uDCA5|\\uD83D\\uDD17|\\uD83D\\uDD18|\\uD83D\\uDCA6|\\uD83D\\uDD19|\\uD83D\\uDD1A|\\uD83D\\uDCA7|\\uD83D\\uDD1B|\\uD83D\\uDD1C|\\uD83D\\uDCA8|\\uD83D\\uDD1D|\\uD83D\\uDD1E|\\uD83D\\uDCA9|\\uD83D\\uDD1F|\\uD83D\\uDCAA|\\uD83D\\uDD20|\\uD83D\\uDD21|\\uD83D\\uDCAB|\\uD83D\\uDD22|\\uD83D\\uDD23|\\uD83D\\uDCAC|\\uD83D\\uDD24|\\uD83D\\uDD25|\\uD83D\\uDCAE|\\uD83D\\uDD26|\\uD83D\\uDD27|\\uD83D\\uDCAF|\\uD83D\\uDD28|\\uD83D\\uDD29|\\uD83D\\uDCB0|\\uD83D\\uDD2A|\\uD83D\\uDD2B|\\uD83D\\uDCB1|\\uD83D\\uDD2E|\\uD83D\\uDCB2|\\uD83D\\uDD2F|\\uD83D\\uDCB3|\\uD83D\\uDD30|\\uD83D\\uDD31|\\uD83D\\uDCB4|\\uD83D\\uDD32|\\uD83D\\uDD33|\\uD83D\\uDCB5|\\uD83D\\uDD34|\\uD83D\\uDD35|\\uD83D\\uDCB8|\\uD83D\\uDD36|\\uD83D\\uDD37|\\uD83D\\uDCB9|\\uD83D\\uDD38|\\uD83D\\uDD39|\\uD83D\\uDCBA|\\uD83D\\uDD3A|\\uD83D\\uDD3B|\\uD83D\\uDCBB|\\uD83D\\uDD3C|\\uD83D\\uDCBC|\\uD83D\\uDD3D|\\uD83D\\uDD50|\\uD83D\\uDCBD|\\uD83D\\uDD51|\\uD83D\\uDCBE|\\uD83D\\uDD52|\\uD83D\\uDCBF|\\uD83D\\uDD53|\\uD83D\\uDCC0|\\uD83D\\uDD54|\\uD83D\\uDD55|\\uD83D\\uDCC1|\\uD83D\\uDD56|\\uD83D\\uDD57|\\uD83D\\uDCC2|\\uD83D\\uDD58|\\uD83D\\uDD59|\\uD83D\\uDCC3|\\uD83D\\uDD5A|\\uD83D\\uDD5B|\\uD83D\\uDCC4|\\uD83D\\uDDFB|\\uD83D\\uDDFC|\\uD83D\\uDCC5|\\uD83D\\uDDFD|\\uD83D\\uDDFE|\\uD83D\\uDCC6|\\uD83D\\uDDFF|\\uD83D\\uDE01|\\uD83D\\uDE02|\\uD83D\\uDE03|\\uD83D\\uDCC8|\\uD83D\\uDE04|\\uD83D\\uDE05|\\uD83D\\uDCC9|\\uD83D\\uDE06|\\uD83D\\uDE09|\\uD83D\\uDCCA|\\uD83D\\uDE0A|\\uD83D\\uDE0B|\\uD83D\\uDCCB|\\uD83D\\uDE0C|\\uD83D\\uDE0D|\\uD83D\\uDCCC|\\uD83D\\uDE0F|\\uD83D\\uDE12|\\uD83D\\uDCCD|\\uD83D\\uDE13|\\uD83D\\uDE14|\\uD83D\\uDCCE|\\uD83D\\uDE16|\\uD83D\\uDE18|\\uD83D\\uDCCF|\\uD83D\\uDE1A|\\uD83D\\uDE1C|\\uD83D\\uDCD0|\\uD83D\\uDE1D|\\uD83D\\uDE1E|\\uD83D\\uDCD1|\\uD83D\\uDE20|\\uD83D\\uDE21|\\uD83D\\uDE22|\\uD83D\\uDE23|\\uD83D\\uDE24|\\uD83D\\uDE25|\\uD83D\\uDE28|\\uD83D\\uDE29|\\uD83D\\uDE2A|\\uD83D\\uDE2B|\\uD83D\\uDE2D|\\uD83D\\uDE30|\\uD83D\\uDE31|\\uD83D\\uDE32|\\uD83D\\uDE33|\\uD83D\\uDE35|\\uD83D\\uDE37|\\uD83D\\uDE38|\\uD83D\\uDE39|\\uD83D\\uDE3A|\\uD83D\\uDE3B|\\uD83D\\uDE3C|\\uD83D\\uDE3D|\\uD83D\\uDE3E|\\uD83D\\uDE3F|\\uD83D\\uDE40|\\uD83D\\uDE45|\\uD83D\\uDE46|\\uD83D\\uDE47|\\uD83D\\uDE48|\\uD83D\\uDE49|\\uD83D\\uDE4A|\\uD83D\\uDE4B|\\uD83D\\uDE4C|\\uD83D\\uDE4D|\\uD83D\\uDE4E|\\uD83D\\uDE4F|\\uD83D\\uDE80|\\uD83D\\uDE83|\\uD83D\\uDE84|\\uD83D\\uDE85|\\uD83D\\uDE87|\\uD83D\\uDE89|\\uD83D\\uDE8C|\\uD83D\\uDE8F|\\uD83D\\uDE91|\\uD83D\\uDE92|\\uD83D\\uDE93|\\uD83D\\uDE95|\\uD83D\\uDE97|\\uD83D\\uDE99|\\uD83D\\uDE9A|\\uD83D\\uDEA2|\\uD83D\\uDEA4|\\uD83D\\uDEA5|\\uD83D\\uDEA7|\\uD83D\\uDEA8|\\uD83D\\uDEA9|\\uD83D\\uDEAA|\\uD83D\\uDEAB|\\uD83D\\uDEAC|\\uD83D\\uDEAD|\\uD83D\\uDEB2|\\uD83D\\uDEB6|\\uD83D\\uDEB9|\\uD83D\\uDEBA|\\uD83D\\uDEBB|\\uD83D\\uDEBC|\\uD83D\\uDEBD|\\uD83D\\uDEBE|\\uD83D\\uDEC0|\\uD83E\\uDD18|\\uD83D\\uDE00|\\uD83D\\uDE07|\\uD83D\\uDE08|\\uD83D\\uDE0E|\\uD83D\\uDE10|\\uD83D\\uDE11|\\uD83D\\uDE15|\\uD83D\\uDE17|\\uD83D\\uDE19|\\uD83D\\uDE1B|\\uD83D\\uDE1F|\\uD83D\\uDE26|\\uD83D\\uDE27|\\uD83D\\uDE2C|\\uD83D\\uDE2E|\\uD83D\\uDE2F|\\uD83D\\uDE34|\\uD83D\\uDE36|\\uD83D\\uDE81|\\uD83D\\uDE82|\\uD83D\\uDE86|\\uD83D\\uDE88|\\uD83D\\uDE8A|\\uD83D\\uDE8D|\\uD83D\\uDE8E|\\uD83D\\uDE90|\\uD83D\\uDE94|\\uD83D\\uDE96|\\uD83D\\uDE98|\\uD83D\\uDE9B|\\uD83D\\uDE9C|\\uD83D\\uDE9D|\\uD83D\\uDE9E|\\uD83D\\uDE9F|\\uD83D\\uDEA0|\\uD83D\\uDEA1|\\uD83D\\uDEA3|\\uD83D\\uDEA6|\\uD83D\\uDEAE|\\uD83D\\uDEAF|\\uD83D\\uDEB0|\\uD83D\\uDEB1|\\uD83D\\uDEB3|\\uD83D\\uDEB4|\\uD83D\\uDEB5|\\uD83D\\uDEB7|\\uD83D\\uDEB8|\\uD83D\\uDEBF|\\uD83D\\uDEC1|\\uD83D\\uDEC2|\\uD83D\\uDEC3|\\uD83D\\uDEC4|\\uD83D\\uDEC5|\\uD83C\\uDF0D|\\uD83C\\uDF0E|\\uD83C\\uDF10|\\uD83C\\uDF12|\\uD83C\\uDF16|\\uD83C\\uDF17|\\uD83C\\uDF18|\\uD83C\\uDF1A|\\uD83C\\uDF1C|\\uD83C\\uDF1D|\\uD83C\\uDF1E|\\uD83C\\uDF32|\\uD83C\\uDF33|\\uD83C\\uDF4B|\\uD83C\\uDF50|\\uD83C\\uDF7C|\\uD83C\\uDFC7|\\uD83C\\uDFC9|\\uD83C\\uDFE4|\\uD83D\\uDC00|\\uD83D\\uDC01|\\uD83D\\uDC02|\\uD83D\\uDC03|\\uD83D\\uDC04|\\uD83D\\uDC05|\\uD83D\\uDC06|\\uD83D\\uDC07|\\uD83D\\uDC08|\\uD83D\\uDC09|\\uD83D\\uDC0A|\\uD83D\\uDC0B|\\uD83D\\uDC0F|\\uD83D\\uDC10|\\uD83D\\uDC13|\\uD83D\\uDC15|\\uD83D\\uDC16|\\uD83D\\uDC2A|\\uD83D\\uDC65|\\uD83D\\uDC6C|\\uD83D\\uDC6D|\\uD83D\\uDCAD|\\uD83D\\uDCB6|\\uD83D\\uDCB7|\\uD83D\\uDCEC|\\uD83D\\uDCED|\\uD83D\\uDCEF|\\uD83D\\uDCF5|\\uD83D\\uDD00|\\uD83D\\uDD01|\\uD83D\\uDD02|\\uD83D\\uDD04|\\uD83D\\uDD05|\\uD83D\\uDD06|\\uD83D\\uDD07|\\uD83D\\uDD09|\\uD83D\\uDD15|\\uD83D\\uDD2C|\\uD83D\\uDD2D|\\uD83D\\uDD5C|\\uD83D\\uDD5D|\\uD83D\\uDD5E|\\uD83D\\uDD5F|\\uD83D\\uDD60|\\uD83D\\uDD61|\\uD83D\\uDD62|\\uD83D\\uDD63|\\uD83D\\uDD64|\\uD83D\\uDD65|\\uD83D\\uDD66|\\uD83D\\uDD67|\\uD83D\\uDD08|\\uD83D\\uDE8B|\\uD83C\\uDFC5|\\uD83C\\uDFF4|\\uD83D\\uDCF8|\\uD83D\\uDECC|\\uD83D\\uDD95|\\uD83D\\uDD96|\\uD83D\\uDE41|\\uD83D\\uDE42|\\uD83D\\uDEEB|\\uD83D\\uDEEC|\\uD83C\\uDFFB|\\uD83C\\uDFFC|\\uD83C\\uDFFD|\\uD83C\\uDFFE|\\uD83C\\uDFFF|\\uD83D\\uDE43|\\uD83E\\uDD11|\\uD83E\\uDD13|\\uD83E\\uDD17|\\uD83D\\uDE44|\\uD83E\\uDD14|\\uD83E\\uDD10|\\uD83E\\uDD12|\\uD83E\\uDD15|\\uD83E\\uDD16|\\uD83E\\uDD81|\\uD83E\\uDD84|\\uD83E\\uDD82|\\uD83E\\uDD80|\\uD83E\\uDD83|\\uD83E\\uDDC0|\\uD83C\\uDF2D|\\uD83C\\uDF2E|\\uD83C\\uDF2F|\\uD83C\\uDF7F|\\uD83C\\uDF7E|\\uD83C\\uDFF9|\\uD83C\\uDFFA|\\uD83D\\uDED0|\\uD83D\\uDD4B|\\uD83D\\uDD4C|\\uD83D\\uDD4D|\\uD83D\\uDD4E|\\uD83D\\uDCFF|\\uD83C\\uDFCF|\\uD83C\\uDFD0|\\uD83C\\uDFD1|\\uD83C\\uDFD2|\\uD83C\\uDFD3|\\uD83C\\uDFF8|\\uD83C\\uDF26|\\uD83C\\uDF25|\\uD83C\\uDF24|\\uD83D\\uDEF3|\\uD83D\\uDEE9|\\uD83D\\uDEE5|\\uD83D\\uDEE4|\\uD83D\\uDEE3|\\uD83D\\uDECF|\\uD83D\\uDECE|\\uD83D\\uDECD|\\uD83D\\uDECB|\\uD83C\\uDFDF|\\uD83C\\uDFDE|\\uD83C\\uDFDD|\\uD83C\\uDFDC|\\uD83C\\uDFDB|\\uD83C\\uDFDA|\\uD83C\\uDFD9|\\uD83C\\uDFD8|\\uD83C\\uDFD7|\\uD83C\\uDFD6|\\uD83C\\uDFD5|\\uD83C\\uDFD4|\\uD83D\\uDD90|\\uD83D\\uDD75|\\uD83D\\uDD74|\\uD83D\\uDC41|\\uD83C\\uDF7D|\\uD83D\\uDEF0|\\uD83D\\uDEE2|\\uD83D\\uDEE1|\\uD83D\\uDEE0|\\uD83D\\uDDFA|\\uD83D\\uDDF3|\\uD83D\\uDDEF|\\uD83D\\uDDE3|\\uD83D\\uDDE1|\\uD83D\\uDDDE|\\uD83D\\uDDDD|\\uD83D\\uDDDC|\\uD83D\\uDDD3|\\uD83D\\uDDD2|\\uD83D\\uDDD1|\\uD83D\\uDDC4|\\uD83D\\uDDC3|\\uD83D\\uDDC2|\\uD83D\\uDDBC|\\uD83D\\uDDB2|\\uD83D\\uDDA8|\\uD83D\\uDDA5|\\uD83D\\uDD8D|\\uD83D\\uDD8C|\\uD83D\\uDD8B|\\uD83D\\uDD8A|\\uD83D\\uDD87|\\uD83D\\uDD79|\\uD83D\\uDD76|\\uD83D\\uDD73|\\uD83D\\uDD70|\\uD83D\\uDD6F|\\uD83D\\uDD4A|\\uD83D\\uDD49|\\uD83D\\uDCFD|\\uD83C\\uDFF7|\\uD83C\\uDFF5|\\uD83C\\uDFF3|\\uD83C\\uDF9B|\\uD83C\\uDF9A|\\uD83C\\uDF99|\\uD83C\\uDF21|\\uD83D\\uDD78|\\uD83D\\uDD77|\\uD83D\\uDC3F|\\uD83C\\uDF2C|\\uD83C\\uDF2B|\\uD83C\\uDF2A|\\uD83C\\uDF29|\\uD83C\\uDF28|\\uD83C\\uDF27|\\uD83C\\uDF36|\\uD83C\\uDF97|\\uD83C\\uDF96|\\uD83C\\uDFCE|\\uD83C\\uDFCD|\\uD83C\\uDFCC|\\uD83C\\uDFCB|\\uD83C\\uDF9F|\\uD83C\\uDF9E|\\uD83C\\uDE37|\\uD83C\\uDE2F|\\uD83C\\uDE1A|\\uD83C\\uDE02|\\uD83C\\uDD7F|\\uD83C\\uDC04|\\uD83C\\uDFE1|\\u2714|\\u2733|\\u2734|\\u2744|\\u2747|\\u2757|\\u2764|\\u27A1|\\u2934|\\u2935|\\u2B05|\\u2B06|\\u2B07|\\u2B1B|\\u2B1C|\\u2B50|\\u2B55|\\u3030|\\u303D|\\u3297|\\u3299|\\u2712|\\u270F|\\u270C|\\u2709|\\u2708|\\u2702|\\u26FD|\\u26FA|\\u26F5|\\u26F3|\\u26F2|\\u26EA|\\u26D4|\\u26C5|\\u26C4|\\u26BE|\\u26BD|\\u26AB|\\u26AA|\\u26A1|\\u26A0|\\u2693|\\u267F|\\u267B|\\u2668|\\u2666|\\u2665|\\u2663|\\u2660|\\u2653|\\u2652|\\u2651|\\u271D|\\u2650|\\u264F|\\u264E|\\u264D|\\u264C|\\u264B|\\u264A|\\u2649|\\u2648|\\u263A|\\u261D|\\u2615|\\u2614|\\u2611|\\u2328|\\u260E|\\u2601|\\u2600|\\u25FE|\\u25FD|\\u25FC|\\u25FB|\\u25C0|\\u25B6|\\u25AB|\\u25AA|\\u24C2|\\u2716|\\u231A|\\u21AA|\\u21A9|\\u2199|\\u2198|\\u2197|\\u2196|\\u2195|\\u2194|\\u2139|\\u2122|\\u270D|\\u2049|\\u203C|\\u00AE|\\u00A9|\\u27BF|\\u27B0|\\u2797|\\u2796|\\u2795|\\u2755|\\u2754|\\u2753|\\u274E|\\u274C|\\u2728|\\u270B|\\u270A|\\u2705|\\u26CE|\\u23F3|\\u23F0|\\u23EC|\\u23ED|\\u23EE|\\u23EF|\\u23F1|\\u23F2|\\u23F8|\\u23F9|\\u23FA|\\u2602|\\u2603|\\u2604|\\u2618|\\u2620|\\u2622|\\u2623|\\u2626|\\u262A|\\u262E|\\u262F|\\u2638|\\u2639|\\u2692|\\u2694|\\u2696|\\u2697|\\u2699|\\u269B|\\u269C|\\u26B0|\\u26B1|\\u26C8|\\u26CF|\\u26D1|\\u26D3|\\u26E9|\\u26F0|\\u26F1|\\u26F4|\\u26F7|\\u26F8|\\u26F9|\\u2721|\\u2763|\\u23EB|\\u23EA|\\u23E9|\\u231B)';
	    ns.jsEscapeMap = {"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69":"1f469-2764-1f48b-1f469","\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68":"1f468-2764-1f48b-1f468","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f468-1f468-1f466-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f468-1f468-1f467-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f468-1f468-1f467-1f467","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f468-1f469-1f466-1f466","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f468-1f469-1f467-1f466","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f468-1f469-1f467-1f467","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f469-1f469-1f466-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f469-1f469-1f467-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f469-1f469-1f467-1f467","\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69":"1f469-2764-1f469","\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68":"1f468-2764-1f468","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66":"1f468-1f468-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67":"1f468-1f468-1f467","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67":"1f468-1f469-1f467","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66":"1f469-1f469-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67":"1f469-1f469-1f467","\uD83D\uDC41\u200D\uD83D\uDDE8":"1f441-1f5e8","#\uFE0F\u20E3":"0023-20e3","0\uFE0F\u20E3":"0030-20e3","1\uFE0F\u20E3":"0031-20e3","2\uFE0F\u20E3":"0032-20e3","3\uFE0F\u20E3":"0033-20e3","4\uFE0F\u20E3":"0034-20e3","5\uFE0F\u20E3":"0035-20e3","6\uFE0F\u20E3":"0036-20e3","7\uFE0F\u20E3":"0037-20e3","8\uFE0F\u20E3":"0038-20e3","9\uFE0F\u20E3":"0039-20e3","*\uFE0F\u20E3":"002a-20e3","\uD83E\uDD18\uD83C\uDFFF":"1f918-1f3ff","\uD83E\uDD18\uD83C\uDFFE":"1f918-1f3fe","\uD83E\uDD18\uD83C\uDFFD":"1f918-1f3fd","\uD83E\uDD18\uD83C\uDFFC":"1f918-1f3fc","\uD83E\uDD18\uD83C\uDFFB":"1f918-1f3fb","\uD83D\uDEC0\uD83C\uDFFF":"1f6c0-1f3ff","\uD83D\uDEC0\uD83C\uDFFE":"1f6c0-1f3fe","\uD83D\uDEC0\uD83C\uDFFD":"1f6c0-1f3fd","\uD83D\uDEC0\uD83C\uDFFC":"1f6c0-1f3fc","\uD83D\uDEC0\uD83C\uDFFB":"1f6c0-1f3fb","\uD83D\uDEB6\uD83C\uDFFF":"1f6b6-1f3ff","\uD83D\uDEB6\uD83C\uDFFE":"1f6b6-1f3fe","\uD83D\uDEB6\uD83C\uDFFD":"1f6b6-1f3fd","\uD83D\uDEB6\uD83C\uDFFC":"1f6b6-1f3fc","\uD83D\uDEB6\uD83C\uDFFB":"1f6b6-1f3fb","\uD83D\uDEB5\uD83C\uDFFF":"1f6b5-1f3ff","\uD83D\uDEB5\uD83C\uDFFE":"1f6b5-1f3fe","\uD83D\uDEB5\uD83C\uDFFD":"1f6b5-1f3fd","\uD83D\uDEB5\uD83C\uDFFC":"1f6b5-1f3fc","\uD83D\uDEB5\uD83C\uDFFB":"1f6b5-1f3fb","\uD83D\uDEB4\uD83C\uDFFF":"1f6b4-1f3ff","\uD83D\uDEB4\uD83C\uDFFE":"1f6b4-1f3fe","\uD83D\uDEB4\uD83C\uDFFD":"1f6b4-1f3fd","\uD83D\uDEB4\uD83C\uDFFC":"1f6b4-1f3fc","\uD83D\uDEB4\uD83C\uDFFB":"1f6b4-1f3fb","\uD83D\uDEA3\uD83C\uDFFF":"1f6a3-1f3ff","\uD83D\uDEA3\uD83C\uDFFE":"1f6a3-1f3fe","\uD83D\uDEA3\uD83C\uDFFD":"1f6a3-1f3fd","\uD83D\uDEA3\uD83C\uDFFC":"1f6a3-1f3fc","\uD83D\uDEA3\uD83C\uDFFB":"1f6a3-1f3fb","\uD83D\uDE4F\uD83C\uDFFF":"1f64f-1f3ff","\uD83D\uDE4F\uD83C\uDFFE":"1f64f-1f3fe","\uD83D\uDE4F\uD83C\uDFFD":"1f64f-1f3fd","\uD83D\uDE4F\uD83C\uDFFC":"1f64f-1f3fc","\uD83D\uDE4F\uD83C\uDFFB":"1f64f-1f3fb","\uD83D\uDE4E\uD83C\uDFFF":"1f64e-1f3ff","\uD83D\uDE4E\uD83C\uDFFE":"1f64e-1f3fe","\uD83D\uDE4E\uD83C\uDFFD":"1f64e-1f3fd","\uD83D\uDE4E\uD83C\uDFFC":"1f64e-1f3fc","\uD83D\uDE4E\uD83C\uDFFB":"1f64e-1f3fb","\uD83D\uDE4D\uD83C\uDFFF":"1f64d-1f3ff","\uD83D\uDE4D\uD83C\uDFFE":"1f64d-1f3fe","\uD83D\uDE4D\uD83C\uDFFD":"1f64d-1f3fd","\uD83D\uDE4D\uD83C\uDFFC":"1f64d-1f3fc","\uD83D\uDE4D\uD83C\uDFFB":"1f64d-1f3fb","\uD83D\uDE4C\uD83C\uDFFF":"1f64c-1f3ff","\uD83D\uDE4C\uD83C\uDFFE":"1f64c-1f3fe","\uD83D\uDE4C\uD83C\uDFFD":"1f64c-1f3fd","\uD83D\uDE4C\uD83C\uDFFC":"1f64c-1f3fc","\uD83D\uDE4C\uD83C\uDFFB":"1f64c-1f3fb","\uD83D\uDE4B\uD83C\uDFFF":"1f64b-1f3ff","\uD83D\uDE4B\uD83C\uDFFE":"1f64b-1f3fe","\uD83D\uDE4B\uD83C\uDFFD":"1f64b-1f3fd","\uD83D\uDE4B\uD83C\uDFFC":"1f64b-1f3fc","\uD83D\uDE4B\uD83C\uDFFB":"1f64b-1f3fb","\uD83D\uDE47\uD83C\uDFFF":"1f647-1f3ff","\uD83D\uDE47\uD83C\uDFFE":"1f647-1f3fe","\uD83D\uDE47\uD83C\uDFFD":"1f647-1f3fd","\uD83D\uDE47\uD83C\uDFFC":"1f647-1f3fc","\uD83D\uDE47\uD83C\uDFFB":"1f647-1f3fb","\uD83D\uDE46\uD83C\uDFFF":"1f646-1f3ff","\uD83D\uDE46\uD83C\uDFFE":"1f646-1f3fe","\uD83D\uDE46\uD83C\uDFFD":"1f646-1f3fd","\uD83D\uDE46\uD83C\uDFFC":"1f646-1f3fc","\uD83D\uDE46\uD83C\uDFFB":"1f646-1f3fb","\uD83D\uDE45\uD83C\uDFFF":"1f645-1f3ff","\uD83D\uDE45\uD83C\uDFFE":"1f645-1f3fe","\uD83D\uDE45\uD83C\uDFFD":"1f645-1f3fd","\uD83D\uDE45\uD83C\uDFFC":"1f645-1f3fc","\uD83D\uDE45\uD83C\uDFFB":"1f645-1f3fb","\uD83D\uDD96\uD83C\uDFFF":"1f596-1f3ff","\uD83D\uDD96\uD83C\uDFFE":"1f596-1f3fe","\uD83D\uDD96\uD83C\uDFFD":"1f596-1f3fd","\uD83D\uDD96\uD83C\uDFFC":"1f596-1f3fc","\uD83D\uDD96\uD83C\uDFFB":"1f596-1f3fb","\uD83D\uDD95\uD83C\uDFFF":"1f595-1f3ff","\uD83D\uDD95\uD83C\uDFFE":"1f595-1f3fe","\uD83D\uDD95\uD83C\uDFFD":"1f595-1f3fd","\uD83D\uDD95\uD83C\uDFFC":"1f595-1f3fc","\uD83D\uDD95\uD83C\uDFFB":"1f595-1f3fb","\uD83D\uDD90\uD83C\uDFFF":"1f590-1f3ff","\uD83D\uDD90\uD83C\uDFFE":"1f590-1f3fe","\uD83D\uDD90\uD83C\uDFFD":"1f590-1f3fd","\uD83D\uDD90\uD83C\uDFFC":"1f590-1f3fc","\uD83D\uDD90\uD83C\uDFFB":"1f590-1f3fb","\uD83D\uDD75\uD83C\uDFFF":"1f575-1f3ff","\uD83D\uDD75\uD83C\uDFFE":"1f575-1f3fe","\uD83D\uDD75\uD83C\uDFFD":"1f575-1f3fd","\uD83D\uDD75\uD83C\uDFFC":"1f575-1f3fc","\uD83D\uDD75\uD83C\uDFFB":"1f575-1f3fb","\uD83D\uDCAA\uD83C\uDFFF":"1f4aa-1f3ff","\uD83D\uDCAA\uD83C\uDFFE":"1f4aa-1f3fe","\uD83D\uDCAA\uD83C\uDFFD":"1f4aa-1f3fd","\uD83D\uDCAA\uD83C\uDFFC":"1f4aa-1f3fc","\uD83D\uDCAA\uD83C\uDFFB":"1f4aa-1f3fb","\uD83D\uDC87\uD83C\uDFFF":"1f487-1f3ff","\uD83D\uDC87\uD83C\uDFFE":"1f487-1f3fe","\uD83D\uDC87\uD83C\uDFFD":"1f487-1f3fd","\uD83D\uDC87\uD83C\uDFFC":"1f487-1f3fc","\uD83D\uDC87\uD83C\uDFFB":"1f487-1f3fb","\uD83D\uDC86\uD83C\uDFFF":"1f486-1f3ff","\uD83D\uDC86\uD83C\uDFFE":"1f486-1f3fe","\uD83D\uDC86\uD83C\uDFFD":"1f486-1f3fd","\uD83D\uDC86\uD83C\uDFFC":"1f486-1f3fc","\uD83D\uDC86\uD83C\uDFFB":"1f486-1f3fb","\uD83D\uDC85\uD83C\uDFFF":"1f485-1f3ff","\uD83D\uDC85\uD83C\uDFFE":"1f485-1f3fe","\uD83D\uDC85\uD83C\uDFFD":"1f485-1f3fd","\uD83D\uDC85\uD83C\uDFFC":"1f485-1f3fc","\uD83D\uDC85\uD83C\uDFFB":"1f485-1f3fb","\uD83D\uDC83\uD83C\uDFFF":"1f483-1f3ff","\uD83D\uDC83\uD83C\uDFFE":"1f483-1f3fe","\uD83D\uDC83\uD83C\uDFFD":"1f483-1f3fd","\uD83D\uDC83\uD83C\uDFFC":"1f483-1f3fc","\uD83D\uDC83\uD83C\uDFFB":"1f483-1f3fb","\uD83D\uDC82\uD83C\uDFFF":"1f482-1f3ff","\uD83D\uDC82\uD83C\uDFFE":"1f482-1f3fe","\uD83D\uDC82\uD83C\uDFFD":"1f482-1f3fd","\uD83D\uDC82\uD83C\uDFFC":"1f482-1f3fc","\uD83D\uDC82\uD83C\uDFFB":"1f482-1f3fb","\uD83D\uDC81\uD83C\uDFFF":"1f481-1f3ff","\uD83D\uDC81\uD83C\uDFFE":"1f481-1f3fe","\uD83D\uDC81\uD83C\uDFFD":"1f481-1f3fd","\uD83D\uDC81\uD83C\uDFFC":"1f481-1f3fc","\uD83D\uDC81\uD83C\uDFFB":"1f481-1f3fb","\uD83D\uDC7C\uD83C\uDFFF":"1f47c-1f3ff","\uD83D\uDC7C\uD83C\uDFFE":"1f47c-1f3fe","\uD83D\uDC7C\uD83C\uDFFD":"1f47c-1f3fd","\uD83D\uDC7C\uD83C\uDFFC":"1f47c-1f3fc","\uD83D\uDC7C\uD83C\uDFFB":"1f47c-1f3fb","\uD83D\uDC78\uD83C\uDFFF":"1f478-1f3ff","\uD83D\uDC78\uD83C\uDFFE":"1f478-1f3fe","\uD83D\uDC78\uD83C\uDFFD":"1f478-1f3fd","\uD83D\uDC78\uD83C\uDFFC":"1f478-1f3fc","\uD83D\uDC78\uD83C\uDFFB":"1f478-1f3fb","\uD83D\uDC77\uD83C\uDFFF":"1f477-1f3ff","\uD83D\uDC77\uD83C\uDFFE":"1f477-1f3fe","\uD83D\uDC77\uD83C\uDFFD":"1f477-1f3fd","\uD83D\uDC77\uD83C\uDFFC":"1f477-1f3fc","\uD83D\uDC77\uD83C\uDFFB":"1f477-1f3fb","\uD83D\uDC76\uD83C\uDFFF":"1f476-1f3ff","\uD83D\uDC76\uD83C\uDFFE":"1f476-1f3fe","\uD83D\uDC76\uD83C\uDFFD":"1f476-1f3fd","\uD83D\uDC76\uD83C\uDFFC":"1f476-1f3fc","\uD83D\uDC76\uD83C\uDFFB":"1f476-1f3fb","\uD83D\uDC75\uD83C\uDFFF":"1f475-1f3ff","\uD83D\uDC75\uD83C\uDFFE":"1f475-1f3fe","\uD83D\uDC75\uD83C\uDFFD":"1f475-1f3fd","\uD83D\uDC75\uD83C\uDFFC":"1f475-1f3fc","\uD83D\uDC75\uD83C\uDFFB":"1f475-1f3fb","\uD83D\uDC74\uD83C\uDFFF":"1f474-1f3ff","\uD83D\uDC74\uD83C\uDFFE":"1f474-1f3fe","\uD83D\uDC74\uD83C\uDFFD":"1f474-1f3fd","\uD83D\uDC74\uD83C\uDFFC":"1f474-1f3fc","\uD83D\uDC74\uD83C\uDFFB":"1f474-1f3fb","\uD83D\uDC73\uD83C\uDFFF":"1f473-1f3ff","\uD83D\uDC73\uD83C\uDFFE":"1f473-1f3fe","\uD83D\uDC73\uD83C\uDFFD":"1f473-1f3fd","\uD83D\uDC73\uD83C\uDFFC":"1f473-1f3fc","\uD83D\uDC73\uD83C\uDFFB":"1f473-1f3fb","\uD83D\uDC72\uD83C\uDFFF":"1f472-1f3ff","\uD83D\uDC72\uD83C\uDFFE":"1f472-1f3fe","\uD83D\uDC72\uD83C\uDFFD":"1f472-1f3fd","\uD83D\uDC72\uD83C\uDFFC":"1f472-1f3fc","\uD83D\uDC72\uD83C\uDFFB":"1f472-1f3fb","\uD83D\uDC71\uD83C\uDFFF":"1f471-1f3ff","\uD83D\uDC71\uD83C\uDFFE":"1f471-1f3fe","\uD83D\uDC71\uD83C\uDFFD":"1f471-1f3fd","\uD83D\uDC71\uD83C\uDFFC":"1f471-1f3fc","\uD83D\uDC71\uD83C\uDFFB":"1f471-1f3fb","\uD83D\uDC70\uD83C\uDFFF":"1f470-1f3ff","\uD83D\uDC70\uD83C\uDFFE":"1f470-1f3fe","\uD83D\uDC70\uD83C\uDFFD":"1f470-1f3fd","\uD83D\uDC70\uD83C\uDFFC":"1f470-1f3fc","\uD83D\uDC70\uD83C\uDFFB":"1f470-1f3fb","\uD83D\uDC6E\uD83C\uDFFF":"1f46e-1f3ff","\uD83D\uDC6E\uD83C\uDFFE":"1f46e-1f3fe","\uD83D\uDC6E\uD83C\uDFFD":"1f46e-1f3fd","\uD83D\uDC6E\uD83C\uDFFC":"1f46e-1f3fc","\uD83D\uDC6E\uD83C\uDFFB":"1f46e-1f3fb","\uD83D\uDC69\uD83C\uDFFF":"1f469-1f3ff","\uD83D\uDC69\uD83C\uDFFE":"1f469-1f3fe","\uD83D\uDC69\uD83C\uDFFD":"1f469-1f3fd","\uD83D\uDC69\uD83C\uDFFC":"1f469-1f3fc","\uD83D\uDC69\uD83C\uDFFB":"1f469-1f3fb","\uD83D\uDC68\uD83C\uDFFF":"1f468-1f3ff","\uD83D\uDC68\uD83C\uDFFE":"1f468-1f3fe","\uD83D\uDC68\uD83C\uDFFD":"1f468-1f3fd","\uD83D\uDC68\uD83C\uDFFC":"1f468-1f3fc","\uD83D\uDC68\uD83C\uDFFB":"1f468-1f3fb","\uD83D\uDC67\uD83C\uDFFF":"1f467-1f3ff","\uD83D\uDC67\uD83C\uDFFE":"1f467-1f3fe","\uD83D\uDC67\uD83C\uDFFD":"1f467-1f3fd","\uD83D\uDC67\uD83C\uDFFC":"1f467-1f3fc","\uD83D\uDC67\uD83C\uDFFB":"1f467-1f3fb","\uD83D\uDC66\uD83C\uDFFF":"1f466-1f3ff","\uD83D\uDC66\uD83C\uDFFE":"1f466-1f3fe","\uD83D\uDC66\uD83C\uDFFD":"1f466-1f3fd","\uD83D\uDC66\uD83C\uDFFC":"1f466-1f3fc","\uD83D\uDC66\uD83C\uDFFB":"1f466-1f3fb","\uD83D\uDC50\uD83C\uDFFF":"1f450-1f3ff","\uD83D\uDC50\uD83C\uDFFE":"1f450-1f3fe","\uD83D\uDC50\uD83C\uDFFD":"1f450-1f3fd","\uD83D\uDC50\uD83C\uDFFC":"1f450-1f3fc","\uD83D\uDC50\uD83C\uDFFB":"1f450-1f3fb","\uD83D\uDC4F\uD83C\uDFFF":"1f44f-1f3ff","\uD83D\uDC4F\uD83C\uDFFE":"1f44f-1f3fe","\uD83D\uDC4F\uD83C\uDFFD":"1f44f-1f3fd","\uD83D\uDC4F\uD83C\uDFFC":"1f44f-1f3fc","\uD83D\uDC4F\uD83C\uDFFB":"1f44f-1f3fb","\uD83D\uDC4E\uD83C\uDFFF":"1f44e-1f3ff","\uD83D\uDC4E\uD83C\uDFFE":"1f44e-1f3fe","\uD83D\uDC4E\uD83C\uDFFD":"1f44e-1f3fd","\uD83D\uDC4E\uD83C\uDFFC":"1f44e-1f3fc","\uD83D\uDC4E\uD83C\uDFFB":"1f44e-1f3fb","\uD83D\uDC4D\uD83C\uDFFF":"1f44d-1f3ff","\uD83D\uDC4D\uD83C\uDFFE":"1f44d-1f3fe","\uD83D\uDC4D\uD83C\uDFFD":"1f44d-1f3fd","\uD83D\uDC4D\uD83C\uDFFC":"1f44d-1f3fc","\uD83D\uDC4D\uD83C\uDFFB":"1f44d-1f3fb","\uD83D\uDC4C\uD83C\uDFFF":"1f44c-1f3ff","\uD83D\uDC4C\uD83C\uDFFE":"1f44c-1f3fe","\uD83D\uDC4C\uD83C\uDFFD":"1f44c-1f3fd","\uD83D\uDC4C\uD83C\uDFFC":"1f44c-1f3fc","\uD83D\uDC4C\uD83C\uDFFB":"1f44c-1f3fb","\uD83D\uDC4B\uD83C\uDFFF":"1f44b-1f3ff","\uD83D\uDC4B\uD83C\uDFFE":"1f44b-1f3fe","\uD83D\uDC4B\uD83C\uDFFD":"1f44b-1f3fd","\uD83D\uDC4B\uD83C\uDFFC":"1f44b-1f3fc","\uD83D\uDC4B\uD83C\uDFFB":"1f44b-1f3fb","\uD83D\uDC4A\uD83C\uDFFF":"1f44a-1f3ff","\uD83D\uDC4A\uD83C\uDFFE":"1f44a-1f3fe","\uD83D\uDC4A\uD83C\uDFFD":"1f44a-1f3fd","\uD83D\uDC4A\uD83C\uDFFC":"1f44a-1f3fc","\uD83D\uDC4A\uD83C\uDFFB":"1f44a-1f3fb","\uD83D\uDC49\uD83C\uDFFF":"1f449-1f3ff","\uD83D\uDC49\uD83C\uDFFE":"1f449-1f3fe","\uD83D\uDC49\uD83C\uDFFD":"1f449-1f3fd","\uD83D\uDC49\uD83C\uDFFC":"1f449-1f3fc","\uD83D\uDC49\uD83C\uDFFB":"1f449-1f3fb","\uD83D\uDC48\uD83C\uDFFF":"1f448-1f3ff","\uD83D\uDC48\uD83C\uDFFE":"1f448-1f3fe","\uD83D\uDC48\uD83C\uDFFD":"1f448-1f3fd","\uD83D\uDC48\uD83C\uDFFC":"1f448-1f3fc","\uD83D\uDC48\uD83C\uDFFB":"1f448-1f3fb","\uD83D\uDC47\uD83C\uDFFF":"1f447-1f3ff","\uD83D\uDC47\uD83C\uDFFE":"1f447-1f3fe","\uD83D\uDC47\uD83C\uDFFD":"1f447-1f3fd","\uD83D\uDC47\uD83C\uDFFC":"1f447-1f3fc","\uD83D\uDC47\uD83C\uDFFB":"1f447-1f3fb","\uD83D\uDC46\uD83C\uDFFF":"1f446-1f3ff","\uD83D\uDC46\uD83C\uDFFE":"1f446-1f3fe","\uD83D\uDC46\uD83C\uDFFD":"1f446-1f3fd","\uD83D\uDC46\uD83C\uDFFC":"1f446-1f3fc","\uD83D\uDC46\uD83C\uDFFB":"1f446-1f3fb","\uD83D\uDC43\uD83C\uDFFF":"1f443-1f3ff","\uD83D\uDC43\uD83C\uDFFE":"1f443-1f3fe","\uD83D\uDC43\uD83C\uDFFD":"1f443-1f3fd","\uD83D\uDC43\uD83C\uDFFC":"1f443-1f3fc","\uD83D\uDC43\uD83C\uDFFB":"1f443-1f3fb","\uD83D\uDC42\uD83C\uDFFF":"1f442-1f3ff","\uD83D\uDC42\uD83C\uDFFE":"1f442-1f3fe","\uD83D\uDC42\uD83C\uDFFD":"1f442-1f3fd","\uD83D\uDC42\uD83C\uDFFC":"1f442-1f3fc","\uD83D\uDC42\uD83C\uDFFB":"1f442-1f3fb","\uD83C\uDFCB\uD83C\uDFFF":"1f3cb-1f3ff","\uD83C\uDFCB\uD83C\uDFFE":"1f3cb-1f3fe","\uD83C\uDFCB\uD83C\uDFFD":"1f3cb-1f3fd","\uD83C\uDFCB\uD83C\uDFFC":"1f3cb-1f3fc","\uD83C\uDFCB\uD83C\uDFFB":"1f3cb-1f3fb","\uD83C\uDFCA\uD83C\uDFFF":"1f3ca-1f3ff","\uD83C\uDFCA\uD83C\uDFFE":"1f3ca-1f3fe","\uD83C\uDFCA\uD83C\uDFFD":"1f3ca-1f3fd","\uD83C\uDFCA\uD83C\uDFFC":"1f3ca-1f3fc","\uD83C\uDFCA\uD83C\uDFFB":"1f3ca-1f3fb","\uD83C\uDFC7\uD83C\uDFFF":"1f3c7-1f3ff","\uD83C\uDFC7\uD83C\uDFFE":"1f3c7-1f3fe","\uD83C\uDFC7\uD83C\uDFFD":"1f3c7-1f3fd","\uD83C\uDFC7\uD83C\uDFFC":"1f3c7-1f3fc","\uD83C\uDFC7\uD83C\uDFFB":"1f3c7-1f3fb","\uD83C\uDFC4\uD83C\uDFFF":"1f3c4-1f3ff","\uD83C\uDFC4\uD83C\uDFFE":"1f3c4-1f3fe","\uD83C\uDFC4\uD83C\uDFFD":"1f3c4-1f3fd","\uD83C\uDFC4\uD83C\uDFFC":"1f3c4-1f3fc","\uD83C\uDFC4\uD83C\uDFFB":"1f3c4-1f3fb","\uD83C\uDFC3\uD83C\uDFFF":"1f3c3-1f3ff","\uD83C\uDFC3\uD83C\uDFFE":"1f3c3-1f3fe","\uD83C\uDFC3\uD83C\uDFFD":"1f3c3-1f3fd","\uD83C\uDFC3\uD83C\uDFFC":"1f3c3-1f3fc","\uD83C\uDFC3\uD83C\uDFFB":"1f3c3-1f3fb","\uD83C\uDF85\uD83C\uDFFF":"1f385-1f3ff","\uD83C\uDF85\uD83C\uDFFE":"1f385-1f3fe","\uD83C\uDF85\uD83C\uDFFD":"1f385-1f3fd","\uD83C\uDF85\uD83C\uDFFC":"1f385-1f3fc","\uD83C\uDF85\uD83C\uDFFB":"1f385-1f3fb","\uD83C\uDDFF\uD83C\uDDFC":"1f1ff-1f1fc","\uD83C\uDDFF\uD83C\uDDF2":"1f1ff-1f1f2","\uD83C\uDDFF\uD83C\uDDE6":"1f1ff-1f1e6","\uD83C\uDDFE\uD83C\uDDF9":"1f1fe-1f1f9","\uD83C\uDDFE\uD83C\uDDEA":"1f1fe-1f1ea","\uD83C\uDDFD\uD83C\uDDF0":"1f1fd-1f1f0","\uD83C\uDDFC\uD83C\uDDF8":"1f1fc-1f1f8","\uD83C\uDDFC\uD83C\uDDEB":"1f1fc-1f1eb","\uD83C\uDDFB\uD83C\uDDFA":"1f1fb-1f1fa","\uD83C\uDDFB\uD83C\uDDF3":"1f1fb-1f1f3","\uD83C\uDDFB\uD83C\uDDEE":"1f1fb-1f1ee","\uD83C\uDDFB\uD83C\uDDEC":"1f1fb-1f1ec","\uD83C\uDDFB\uD83C\uDDEA":"1f1fb-1f1ea","\uD83C\uDDFB\uD83C\uDDE8":"1f1fb-1f1e8","\uD83C\uDDFB\uD83C\uDDE6":"1f1fb-1f1e6","\uD83C\uDDFA\uD83C\uDDFF":"1f1fa-1f1ff","\uD83C\uDDFA\uD83C\uDDFE":"1f1fa-1f1fe","\uD83C\uDDFA\uD83C\uDDF8":"1f1fa-1f1f8","\uD83C\uDDFA\uD83C\uDDF2":"1f1fa-1f1f2","\uD83C\uDDFA\uD83C\uDDEC":"1f1fa-1f1ec","\uD83C\uDDFA\uD83C\uDDE6":"1f1fa-1f1e6","\uD83C\uDDF9\uD83C\uDDFF":"1f1f9-1f1ff","\uD83C\uDDF9\uD83C\uDDFC":"1f1f9-1f1fc","\uD83C\uDDF9\uD83C\uDDFB":"1f1f9-1f1fb","\uD83C\uDDF9\uD83C\uDDF9":"1f1f9-1f1f9","\uD83C\uDDF9\uD83C\uDDF7":"1f1f9-1f1f7","\uD83C\uDDF9\uD83C\uDDF4":"1f1f9-1f1f4","\uD83C\uDDF9\uD83C\uDDF3":"1f1f9-1f1f3","\uD83C\uDDF9\uD83C\uDDF2":"1f1f9-1f1f2","\uD83C\uDDF9\uD83C\uDDF1":"1f1f9-1f1f1","\uD83C\uDDF9\uD83C\uDDF0":"1f1f9-1f1f0","\uD83C\uDDF9\uD83C\uDDEF":"1f1f9-1f1ef","\uD83C\uDDF9\uD83C\uDDED":"1f1f9-1f1ed","\uD83C\uDDF9\uD83C\uDDEC":"1f1f9-1f1ec","\uD83C\uDDF9\uD83C\uDDEB":"1f1f9-1f1eb","\uD83C\uDDF9\uD83C\uDDE9":"1f1f9-1f1e9","\uD83C\uDDF9\uD83C\uDDE8":"1f1f9-1f1e8","\uD83C\uDDF9\uD83C\uDDE6":"1f1f9-1f1e6","\uD83C\uDDF8\uD83C\uDDFF":"1f1f8-1f1ff","\uD83C\uDDF8\uD83C\uDDFE":"1f1f8-1f1fe","\uD83C\uDDF8\uD83C\uDDFD":"1f1f8-1f1fd","\uD83C\uDDF8\uD83C\uDDFB":"1f1f8-1f1fb","\uD83C\uDDF8\uD83C\uDDF9":"1f1f8-1f1f9","\uD83C\uDDF8\uD83C\uDDF8":"1f1f8-1f1f8","\uD83C\uDDF8\uD83C\uDDF7":"1f1f8-1f1f7","\uD83C\uDDF8\uD83C\uDDF4":"1f1f8-1f1f4","\uD83C\uDDF8\uD83C\uDDF3":"1f1f8-1f1f3","\uD83C\uDDF8\uD83C\uDDF2":"1f1f8-1f1f2","\uD83C\uDDF8\uD83C\uDDF1":"1f1f8-1f1f1","\uD83C\uDDF8\uD83C\uDDF0":"1f1f8-1f1f0","\uD83C\uDDF8\uD83C\uDDEF":"1f1f8-1f1ef","\uD83C\uDDF8\uD83C\uDDEE":"1f1f8-1f1ee","\uD83C\uDDF8\uD83C\uDDED":"1f1f8-1f1ed","\uD83C\uDDF8\uD83C\uDDEC":"1f1f8-1f1ec","\uD83C\uDDF8\uD83C\uDDEA":"1f1f8-1f1ea","\uD83C\uDDF8\uD83C\uDDE9":"1f1f8-1f1e9","\uD83C\uDDF8\uD83C\uDDE8":"1f1f8-1f1e8","\uD83C\uDDF8\uD83C\uDDE7":"1f1f8-1f1e7","\uD83C\uDDF8\uD83C\uDDE6":"1f1f8-1f1e6","\uD83C\uDDF7\uD83C\uDDFC":"1f1f7-1f1fc","\uD83C\uDDF7\uD83C\uDDFA":"1f1f7-1f1fa","\uD83C\uDDF7\uD83C\uDDF8":"1f1f7-1f1f8","\uD83C\uDDF7\uD83C\uDDF4":"1f1f7-1f1f4","\uD83C\uDDF7\uD83C\uDDEA":"1f1f7-1f1ea","\uD83C\uDDF6\uD83C\uDDE6":"1f1f6-1f1e6","\uD83C\uDDF5\uD83C\uDDFE":"1f1f5-1f1fe","\uD83C\uDDF5\uD83C\uDDFC":"1f1f5-1f1fc","\uD83C\uDDF5\uD83C\uDDF9":"1f1f5-1f1f9","\uD83C\uDDF5\uD83C\uDDF8":"1f1f5-1f1f8","\uD83C\uDDF5\uD83C\uDDF7":"1f1f5-1f1f7","\uD83C\uDDF5\uD83C\uDDF3":"1f1f5-1f1f3","\uD83C\uDDF5\uD83C\uDDF2":"1f1f5-1f1f2","\uD83C\uDDF5\uD83C\uDDF1":"1f1f5-1f1f1","\uD83C\uDDF5\uD83C\uDDF0":"1f1f5-1f1f0","\uD83C\uDDF5\uD83C\uDDED":"1f1f5-1f1ed","\uD83C\uDDF5\uD83C\uDDEC":"1f1f5-1f1ec","\uD83C\uDDF5\uD83C\uDDEB":"1f1f5-1f1eb","\uD83C\uDDF5\uD83C\uDDEA":"1f1f5-1f1ea","\uD83C\uDDF5\uD83C\uDDE6":"1f1f5-1f1e6","\uD83C\uDDF4\uD83C\uDDF2":"1f1f4-1f1f2","\uD83C\uDDF3\uD83C\uDDFF":"1f1f3-1f1ff","\uD83C\uDDF3\uD83C\uDDFA":"1f1f3-1f1fa","\uD83C\uDDF3\uD83C\uDDF7":"1f1f3-1f1f7","\uD83C\uDDF3\uD83C\uDDF5":"1f1f3-1f1f5","\uD83C\uDDF3\uD83C\uDDF4":"1f1f3-1f1f4","\uD83C\uDDF3\uD83C\uDDF1":"1f1f3-1f1f1","\uD83C\uDDF3\uD83C\uDDEE":"1f1f3-1f1ee","\uD83C\uDDF3\uD83C\uDDEC":"1f1f3-1f1ec","\uD83C\uDDF3\uD83C\uDDEB":"1f1f3-1f1eb","\uD83C\uDDF3\uD83C\uDDEA":"1f1f3-1f1ea","\uD83C\uDDF3\uD83C\uDDE8":"1f1f3-1f1e8","\uD83C\uDDF3\uD83C\uDDE6":"1f1f3-1f1e6","\uD83C\uDDF2\uD83C\uDDFF":"1f1f2-1f1ff","\uD83C\uDDF2\uD83C\uDDFE":"1f1f2-1f1fe","\uD83C\uDDF2\uD83C\uDDFD":"1f1f2-1f1fd","\uD83C\uDDF2\uD83C\uDDFC":"1f1f2-1f1fc","\uD83C\uDDF2\uD83C\uDDFB":"1f1f2-1f1fb","\uD83C\uDDF2\uD83C\uDDFA":"1f1f2-1f1fa","\uD83C\uDDF2\uD83C\uDDF9":"1f1f2-1f1f9","\uD83C\uDDF2\uD83C\uDDF8":"1f1f2-1f1f8","\uD83C\uDDF2\uD83C\uDDF7":"1f1f2-1f1f7","\uD83C\uDDF2\uD83C\uDDF6":"1f1f2-1f1f6","\uD83C\uDDF2\uD83C\uDDF5":"1f1f2-1f1f5","\uD83C\uDDF2\uD83C\uDDF4":"1f1f2-1f1f4","\uD83C\uDDF2\uD83C\uDDF3":"1f1f2-1f1f3","\uD83C\uDDF2\uD83C\uDDF2":"1f1f2-1f1f2","\uD83C\uDDF2\uD83C\uDDF1":"1f1f2-1f1f1","\uD83C\uDDF2\uD83C\uDDF0":"1f1f2-1f1f0","\uD83C\uDDF2\uD83C\uDDED":"1f1f2-1f1ed","\uD83C\uDDF2\uD83C\uDDEC":"1f1f2-1f1ec","\uD83C\uDDF2\uD83C\uDDEB":"1f1f2-1f1eb","\uD83C\uDDF2\uD83C\uDDEA":"1f1f2-1f1ea","\uD83C\uDDF2\uD83C\uDDE9":"1f1f2-1f1e9","\uD83C\uDDF2\uD83C\uDDE8":"1f1f2-1f1e8","\uD83C\uDDF2\uD83C\uDDE6":"1f1f2-1f1e6","\uD83C\uDDF1\uD83C\uDDFE":"1f1f1-1f1fe","\uD83C\uDDF1\uD83C\uDDFB":"1f1f1-1f1fb","\uD83C\uDDF1\uD83C\uDDFA":"1f1f1-1f1fa","\uD83C\uDDF1\uD83C\uDDF9":"1f1f1-1f1f9","\uD83C\uDDF1\uD83C\uDDF8":"1f1f1-1f1f8","\uD83C\uDDF1\uD83C\uDDF7":"1f1f1-1f1f7","\uD83C\uDDF1\uD83C\uDDF0":"1f1f1-1f1f0","\uD83C\uDDF1\uD83C\uDDEE":"1f1f1-1f1ee","\uD83C\uDDF1\uD83C\uDDE8":"1f1f1-1f1e8","\uD83C\uDDF1\uD83C\uDDE7":"1f1f1-1f1e7","\uD83C\uDDF1\uD83C\uDDE6":"1f1f1-1f1e6","\uD83C\uDDF0\uD83C\uDDFF":"1f1f0-1f1ff","\uD83C\uDDF0\uD83C\uDDFE":"1f1f0-1f1fe","\uD83C\uDDF0\uD83C\uDDFC":"1f1f0-1f1fc","\uD83C\uDDF0\uD83C\uDDF7":"1f1f0-1f1f7","\uD83C\uDDF0\uD83C\uDDF5":"1f1f0-1f1f5","\uD83C\uDDF0\uD83C\uDDF3":"1f1f0-1f1f3","\uD83C\uDDF0\uD83C\uDDF2":"1f1f0-1f1f2","\uD83C\uDDF0\uD83C\uDDEE":"1f1f0-1f1ee","\uD83C\uDDF0\uD83C\uDDED":"1f1f0-1f1ed","\uD83C\uDDF0\uD83C\uDDEC":"1f1f0-1f1ec","\uD83C\uDDF0\uD83C\uDDEA":"1f1f0-1f1ea","\uD83C\uDDEF\uD83C\uDDF5":"1f1ef-1f1f5","\uD83C\uDDEF\uD83C\uDDF4":"1f1ef-1f1f4","\uD83C\uDDEF\uD83C\uDDF2":"1f1ef-1f1f2","\uD83C\uDDEF\uD83C\uDDEA":"1f1ef-1f1ea","\uD83C\uDDEE\uD83C\uDDF9":"1f1ee-1f1f9","\uD83C\uDDEE\uD83C\uDDF8":"1f1ee-1f1f8","\uD83C\uDDEE\uD83C\uDDF7":"1f1ee-1f1f7","\uD83C\uDDEE\uD83C\uDDF6":"1f1ee-1f1f6","\uD83C\uDDEE\uD83C\uDDF4":"1f1ee-1f1f4","\uD83C\uDDEE\uD83C\uDDF3":"1f1ee-1f1f3","\uD83C\uDDEE\uD83C\uDDF2":"1f1ee-1f1f2","\uD83C\uDDEE\uD83C\uDDF1":"1f1ee-1f1f1","\uD83C\uDDEE\uD83C\uDDEA":"1f1ee-1f1ea","\uD83C\uDDEE\uD83C\uDDE9":"1f1ee-1f1e9","\uD83C\uDDEE\uD83C\uDDE8":"1f1ee-1f1e8","\uD83C\uDDED\uD83C\uDDFA":"1f1ed-1f1fa","\uD83C\uDDED\uD83C\uDDF9":"1f1ed-1f1f9","\uD83C\uDDED\uD83C\uDDF7":"1f1ed-1f1f7","\uD83C\uDDED\uD83C\uDDF3":"1f1ed-1f1f3","\uD83C\uDDED\uD83C\uDDF2":"1f1ed-1f1f2","\uD83C\uDDED\uD83C\uDDF0":"1f1ed-1f1f0","\uD83C\uDDEC\uD83C\uDDFE":"1f1ec-1f1fe","\uD83C\uDDEC\uD83C\uDDFC":"1f1ec-1f1fc","\uD83C\uDDEC\uD83C\uDDFA":"1f1ec-1f1fa","\uD83C\uDDEC\uD83C\uDDF9":"1f1ec-1f1f9","\uD83C\uDDEC\uD83C\uDDF8":"1f1ec-1f1f8","\uD83C\uDDEC\uD83C\uDDF7":"1f1ec-1f1f7","\uD83C\uDDEC\uD83C\uDDF6":"1f1ec-1f1f6","\uD83C\uDDEC\uD83C\uDDF5":"1f1ec-1f1f5","\uD83C\uDDEC\uD83C\uDDF3":"1f1ec-1f1f3","\uD83C\uDDEC\uD83C\uDDF2":"1f1ec-1f1f2","\uD83C\uDDEC\uD83C\uDDF1":"1f1ec-1f1f1","\uD83C\uDDEC\uD83C\uDDEE":"1f1ec-1f1ee","\uD83C\uDDEC\uD83C\uDDED":"1f1ec-1f1ed","\uD83C\uDDEC\uD83C\uDDEC":"1f1ec-1f1ec","\uD83C\uDDEC\uD83C\uDDEB":"1f1ec-1f1eb","\uD83C\uDDEC\uD83C\uDDEA":"1f1ec-1f1ea","\uD83C\uDDEC\uD83C\uDDE9":"1f1ec-1f1e9","\uD83C\uDDEC\uD83C\uDDE7":"1f1ec-1f1e7","\uD83C\uDDEC\uD83C\uDDE6":"1f1ec-1f1e6","\uD83C\uDDEB\uD83C\uDDF7":"1f1eb-1f1f7","\uD83C\uDDEB\uD83C\uDDF4":"1f1eb-1f1f4","\uD83C\uDDEB\uD83C\uDDF2":"1f1eb-1f1f2","\uD83C\uDDEB\uD83C\uDDF0":"1f1eb-1f1f0","\uD83C\uDDEB\uD83C\uDDEF":"1f1eb-1f1ef","\uD83C\uDDEB\uD83C\uDDEE":"1f1eb-1f1ee","\uD83C\uDDEA\uD83C\uDDFA":"1f1ea-1f1fa","\uD83C\uDDEA\uD83C\uDDF9":"1f1ea-1f1f9","\uD83C\uDDEA\uD83C\uDDF8":"1f1ea-1f1f8","\uD83C\uDDEA\uD83C\uDDF7":"1f1ea-1f1f7","\uD83C\uDDEA\uD83C\uDDED":"1f1ea-1f1ed","\uD83C\uDDEA\uD83C\uDDEC":"1f1ea-1f1ec","\uD83C\uDDEA\uD83C\uDDEA":"1f1ea-1f1ea","\uD83C\uDDEA\uD83C\uDDE8":"1f1ea-1f1e8","\uD83C\uDDEA\uD83C\uDDE6":"1f1ea-1f1e6","\uD83C\uDDE9\uD83C\uDDFF":"1f1e9-1f1ff","\uD83C\uDDE9\uD83C\uDDF4":"1f1e9-1f1f4","\uD83C\uDDE9\uD83C\uDDF2":"1f1e9-1f1f2","\uD83C\uDDE9\uD83C\uDDF0":"1f1e9-1f1f0","\uD83C\uDDE9\uD83C\uDDEF":"1f1e9-1f1ef","\uD83C\uDDE9\uD83C\uDDEC":"1f1e9-1f1ec","\uD83C\uDDE9\uD83C\uDDEA":"1f1e9-1f1ea","\uD83C\uDDE8\uD83C\uDDFF":"1f1e8-1f1ff","\uD83C\uDDE8\uD83C\uDDFE":"1f1e8-1f1fe","\uD83C\uDDE8\uD83C\uDDFD":"1f1e8-1f1fd","\uD83C\uDDE8\uD83C\uDDFC":"1f1e8-1f1fc","\uD83C\uDDE8\uD83C\uDDFB":"1f1e8-1f1fb","\uD83C\uDDE8\uD83C\uDDFA":"1f1e8-1f1fa","\uD83C\uDDE8\uD83C\uDDF7":"1f1e8-1f1f7","\uD83C\uDDE8\uD83C\uDDF5":"1f1e8-1f1f5","\uD83C\uDDE8\uD83C\uDDF4":"1f1e8-1f1f4","\uD83C\uDDE8\uD83C\uDDF3":"1f1e8-1f1f3","\uD83C\uDDE8\uD83C\uDDF2":"1f1e8-1f1f2","\uD83C\uDDE8\uD83C\uDDF1":"1f1e8-1f1f1","\uD83C\uDDE8\uD83C\uDDF0":"1f1e8-1f1f0","\uD83C\uDDE8\uD83C\uDDEE":"1f1e8-1f1ee","\uD83C\uDDE8\uD83C\uDDED":"1f1e8-1f1ed","\uD83C\uDDE8\uD83C\uDDEC":"1f1e8-1f1ec","\uD83C\uDDE8\uD83C\uDDEB":"1f1e8-1f1eb","\uD83C\uDDE8\uD83C\uDDE9":"1f1e8-1f1e9","\uD83C\uDDE8\uD83C\uDDE8":"1f1e8-1f1e8","\uD83C\uDDE8\uD83C\uDDE6":"1f1e8-1f1e6","\uD83C\uDDE7\uD83C\uDDFF":"1f1e7-1f1ff","\uD83C\uDDE7\uD83C\uDDFE":"1f1e7-1f1fe","\uD83C\uDDE7\uD83C\uDDFC":"1f1e7-1f1fc","\uD83C\uDDE7\uD83C\uDDFB":"1f1e7-1f1fb","\uD83C\uDDE7\uD83C\uDDF9":"1f1e7-1f1f9","\uD83C\uDDE7\uD83C\uDDF8":"1f1e7-1f1f8","\uD83C\uDDE7\uD83C\uDDF7":"1f1e7-1f1f7","\uD83C\uDDE7\uD83C\uDDF6":"1f1e7-1f1f6","\uD83C\uDDE7\uD83C\uDDF4":"1f1e7-1f1f4","\uD83C\uDDE7\uD83C\uDDF3":"1f1e7-1f1f3","\uD83C\uDDE7\uD83C\uDDF2":"1f1e7-1f1f2","\uD83C\uDDE7\uD83C\uDDF1":"1f1e7-1f1f1","\uD83C\uDDE7\uD83C\uDDEF":"1f1e7-1f1ef","\uD83C\uDDE7\uD83C\uDDEE":"1f1e7-1f1ee","\uD83C\uDDE7\uD83C\uDDED":"1f1e7-1f1ed","\uD83C\uDDE7\uD83C\uDDEC":"1f1e7-1f1ec","\uD83C\uDDE7\uD83C\uDDEB":"1f1e7-1f1eb","\uD83C\uDDE7\uD83C\uDDEA":"1f1e7-1f1ea","\uD83C\uDDE7\uD83C\uDDE9":"1f1e7-1f1e9","\uD83C\uDDE7\uD83C\uDDE7":"1f1e7-1f1e7","\uD83C\uDDE7\uD83C\uDDE6":"1f1e7-1f1e6","\uD83C\uDDE6\uD83C\uDDFF":"1f1e6-1f1ff","\uD83C\uDDE6\uD83C\uDDFD":"1f1e6-1f1fd","\uD83C\uDDE6\uD83C\uDDFC":"1f1e6-1f1fc","\uD83C\uDDE6\uD83C\uDDFA":"1f1e6-1f1fa","\uD83C\uDDE6\uD83C\uDDF9":"1f1e6-1f1f9","\uD83C\uDDE6\uD83C\uDDF8":"1f1e6-1f1f8","\uD83C\uDDE6\uD83C\uDDF7":"1f1e6-1f1f7","\uD83C\uDDE6\uD83C\uDDF6":"1f1e6-1f1f6","\uD83C\uDDE6\uD83C\uDDF4":"1f1e6-1f1f4","\uD83C\uDDE6\uD83C\uDDF2":"1f1e6-1f1f2","\uD83C\uDDE6\uD83C\uDDF1":"1f1e6-1f1f1","\uD83C\uDDE6\uD83C\uDDEE":"1f1e6-1f1ee","\uD83C\uDDE6\uD83C\uDDEC":"1f1e6-1f1ec","\uD83C\uDDE6\uD83C\uDDEB":"1f1e6-1f1eb","\uD83C\uDDE6\uD83C\uDDEA":"1f1e6-1f1ea","\uD83C\uDDE6\uD83C\uDDE9":"1f1e6-1f1e9","\uD83C\uDDE6\uD83C\uDDE8":"1f1e6-1f1e8","\uD83C\uDC04\uFE0F":"1f004","\uD83C\uDD7F\uFE0F":"1f17f","\uD83C\uDE02\uFE0F":"1f202","\uD83C\uDE1A\uFE0F":"1f21a","\uD83C\uDE2F\uFE0F":"1f22f","\uD83C\uDE37\uFE0F":"1f237","\uD83C\uDF9E\uFE0F":"1f39e","\uD83C\uDF9F\uFE0F":"1f39f","\uD83C\uDFCB\uFE0F":"1f3cb","\uD83C\uDFCC\uFE0F":"1f3cc","\uD83C\uDFCD\uFE0F":"1f3cd","\uD83C\uDFCE\uFE0F":"1f3ce","\uD83C\uDF96\uFE0F":"1f396","\uD83C\uDF97\uFE0F":"1f397","\uD83C\uDF36\uFE0F":"1f336","\uD83C\uDF27\uFE0F":"1f327","\uD83C\uDF28\uFE0F":"1f328","\uD83C\uDF29\uFE0F":"1f329","\uD83C\uDF2A\uFE0F":"1f32a","\uD83C\uDF2B\uFE0F":"1f32b","\uD83C\uDF2C\uFE0F":"1f32c","\uD83D\uDC3F\uFE0F":"1f43f","\uD83D\uDD77\uFE0F":"1f577","\uD83D\uDD78\uFE0F":"1f578","\uD83C\uDF21\uFE0F":"1f321","\uD83C\uDF99\uFE0F":"1f399","\uD83C\uDF9A\uFE0F":"1f39a","\uD83C\uDF9B\uFE0F":"1f39b","\uD83C\uDFF3\uFE0F":"1f3f3","\uD83C\uDFF5\uFE0F":"1f3f5","\uD83C\uDFF7\uFE0F":"1f3f7","\uD83D\uDCFD\uFE0F":"1f4fd","\uD83D\uDD49\uFE0F":"1f549","\uD83D\uDD4A\uFE0F":"1f54a","\uD83D\uDD6F\uFE0F":"1f56f","\uD83D\uDD70\uFE0F":"1f570","\uD83D\uDD73\uFE0F":"1f573","\uD83D\uDD76\uFE0F":"1f576","\uD83D\uDD79\uFE0F":"1f579","\uD83D\uDD87\uFE0F":"1f587","\uD83D\uDD8A\uFE0F":"1f58a","\uD83D\uDD8B\uFE0F":"1f58b","\uD83D\uDD8C\uFE0F":"1f58c","\uD83D\uDD8D\uFE0F":"1f58d","\uD83D\uDDA5\uFE0F":"1f5a5","\uD83D\uDDA8\uFE0F":"1f5a8","\uD83D\uDDB2\uFE0F":"1f5b2","\uD83D\uDDBC\uFE0F":"1f5bc","\uD83D\uDDC2\uFE0F":"1f5c2","\uD83D\uDDC3\uFE0F":"1f5c3","\uD83D\uDDC4\uFE0F":"1f5c4","\uD83D\uDDD1\uFE0F":"1f5d1","\uD83D\uDDD2\uFE0F":"1f5d2","\uD83D\uDDD3\uFE0F":"1f5d3","\uD83D\uDDDC\uFE0F":"1f5dc","\uD83D\uDDDD\uFE0F":"1f5dd","\uD83D\uDDDE\uFE0F":"1f5de","\uD83D\uDDE1\uFE0F":"1f5e1","\uD83D\uDDE3\uFE0F":"1f5e3","\uD83D\uDDEF\uFE0F":"1f5ef","\uD83D\uDDF3\uFE0F":"1f5f3","\uD83D\uDDFA\uFE0F":"1f5fa","\uD83D\uDEE0\uFE0F":"1f6e0","\uD83D\uDEE1\uFE0F":"1f6e1","\uD83D\uDEE2\uFE0F":"1f6e2","\uD83D\uDEF0\uFE0F":"1f6f0","\uD83C\uDF7D\uFE0F":"1f37d","\uD83D\uDC41\uFE0F":"1f441","\uD83D\uDD74\uFE0F":"1f574","\uD83D\uDD75\uFE0F":"1f575","\uD83D\uDD90\uFE0F":"1f590","\uD83C\uDFD4\uFE0F":"1f3d4","\uD83C\uDFD5\uFE0F":"1f3d5","\uD83C\uDFD6\uFE0F":"1f3d6","\uD83C\uDFD7\uFE0F":"1f3d7","\uD83C\uDFD8\uFE0F":"1f3d8","\uD83C\uDFD9\uFE0F":"1f3d9","\uD83C\uDFDA\uFE0F":"1f3da","\uD83C\uDFDB\uFE0F":"1f3db","\uD83C\uDFDC\uFE0F":"1f3dc","\uD83C\uDFDD\uFE0F":"1f3dd","\uD83C\uDFDE\uFE0F":"1f3de","\uD83C\uDFDF\uFE0F":"1f3df","\uD83D\uDECB\uFE0F":"1f6cb","\uD83D\uDECD\uFE0F":"1f6cd","\uD83D\uDECE\uFE0F":"1f6ce","\uD83D\uDECF\uFE0F":"1f6cf","\uD83D\uDEE3\uFE0F":"1f6e3","\uD83D\uDEE4\uFE0F":"1f6e4","\uD83D\uDEE5\uFE0F":"1f6e5","\uD83D\uDEE9\uFE0F":"1f6e9","\uD83D\uDEF3\uFE0F":"1f6f3","\uD83C\uDF24\uFE0F":"1f324","\uD83C\uDF25\uFE0F":"1f325","\uD83C\uDF26\uFE0F":"1f326","\uD83D\uDDB1\uFE0F":"1f5b1","\u261D\uD83C\uDFFB":"261d-1f3fb","\u261D\uD83C\uDFFC":"261d-1f3fc","\u261D\uD83C\uDFFD":"261d-1f3fd","\u261D\uD83C\uDFFE":"261d-1f3fe","\u261D\uD83C\uDFFF":"261d-1f3ff","\u270C\uD83C\uDFFB":"270c-1f3fb","\u270C\uD83C\uDFFC":"270c-1f3fc","\u270C\uD83C\uDFFD":"270c-1f3fd","\u270C\uD83C\uDFFE":"270c-1f3fe","\u270C\uD83C\uDFFF":"270c-1f3ff","\u270A\uD83C\uDFFB":"270a-1f3fb","\u270A\uD83C\uDFFC":"270a-1f3fc","\u270A\uD83C\uDFFD":"270a-1f3fd","\u270A\uD83C\uDFFE":"270a-1f3fe","\u270A\uD83C\uDFFF":"270a-1f3ff","\u270B\uD83C\uDFFB":"270b-1f3fb","\u270B\uD83C\uDFFC":"270b-1f3fc","\u270B\uD83C\uDFFD":"270b-1f3fd","\u270B\uD83C\uDFFE":"270b-1f3fe","\u270B\uD83C\uDFFF":"270b-1f3ff","\u270D\uD83C\uDFFB":"270d-1f3fb","\u270D\uD83C\uDFFC":"270d-1f3fc","\u270D\uD83C\uDFFD":"270d-1f3fd","\u270D\uD83C\uDFFE":"270d-1f3fe","\u270D\uD83C\uDFFF":"270d-1f3ff","\u26F9\uD83C\uDFFB":"26f9-1f3fb","\u26F9\uD83C\uDFFC":"26f9-1f3fc","\u26F9\uD83C\uDFFD":"26f9-1f3fd","\u26F9\uD83C\uDFFE":"26f9-1f3fe","\u26F9\uD83C\uDFFF":"26f9-1f3ff","\u00A9\uFE0F":"00a9","\u00AE\uFE0F":"00ae","\u203C\uFE0F":"203c","\u2049\uFE0F":"2049","\u2122\uFE0F":"2122","\u2139\uFE0F":"2139","\u2194\uFE0F":"2194","\u2195\uFE0F":"2195","\u2196\uFE0F":"2196","\u2197\uFE0F":"2197","\u2198\uFE0F":"2198","\u2199\uFE0F":"2199","\u21A9\uFE0F":"21a9","\u21AA\uFE0F":"21aa","\u231A\uFE0F":"231a","\u231B\uFE0F":"231b","\u24C2\uFE0F":"24c2","\u25AA\uFE0F":"25aa","\u25AB\uFE0F":"25ab","\u25B6\uFE0F":"25b6","\u25C0\uFE0F":"25c0","\u25FB\uFE0F":"25fb","\u25FC\uFE0F":"25fc","\u25FD\uFE0F":"25fd","\u25FE\uFE0F":"25fe","\u2600\uFE0F":"2600","\u2601\uFE0F":"2601","\u260E\uFE0F":"260e","\u2611\uFE0F":"2611","\u2614\uFE0F":"2614","\u2615\uFE0F":"2615","\u261D\uFE0F":"261d","\u263A\uFE0F":"263a","\u2648\uFE0F":"2648","\u2649\uFE0F":"2649","\u264A\uFE0F":"264a","\u264B\uFE0F":"264b","\u264C\uFE0F":"264c","\u264D\uFE0F":"264d","\u264E\uFE0F":"264e","\u264F\uFE0F":"264f","\u2650\uFE0F":"2650","\u2651\uFE0F":"2651","\u2652\uFE0F":"2652","\u2653\uFE0F":"2653","\u2660\uFE0F":"2660","\u2663\uFE0F":"2663","\u2665\uFE0F":"2665","\u2666\uFE0F":"2666","\u2668\uFE0F":"2668","\u267B\uFE0F":"267b","\u267F\uFE0F":"267f","\u2693\uFE0F":"2693","\u26A0\uFE0F":"26a0","\u26A1\uFE0F":"26a1","\u26AA\uFE0F":"26aa","\u26AB\uFE0F":"26ab","\u26BD\uFE0F":"26bd","\u26BE\uFE0F":"26be","\u26C4\uFE0F":"26c4","\u26C5\uFE0F":"26c5","\u26D4\uFE0F":"26d4","\u26EA\uFE0F":"26ea","\u26F2\uFE0F":"26f2","\u26F3\uFE0F":"26f3","\u26F5\uFE0F":"26f5","\u26FA\uFE0F":"26fa","\u26FD\uFE0F":"26fd","\u2702\uFE0F":"2702","\u2708\uFE0F":"2708","\u2709\uFE0F":"2709","\u270C\uFE0F":"270c","\u270F\uFE0F":"270f","\u2712\uFE0F":"2712","\u2714\uFE0F":"2714","\u2716\uFE0F":"2716","\u2733\uFE0F":"2733","\u2734\uFE0F":"2734","\u2744\uFE0F":"2744","\u2747\uFE0F":"2747","\u2757\uFE0F":"2757","\u2764\uFE0F":"2764","\u27A1\uFE0F":"27a1","\u2934\uFE0F":"2934","\u2935\uFE0F":"2935","\u2B05\uFE0F":"2b05","\u2B06\uFE0F":"2b06","\u2B07\uFE0F":"2b07","\u2B1B\uFE0F":"2b1b","\u2B1C\uFE0F":"2b1c","\u2B50\uFE0F":"2b50","\u2B55\uFE0F":"2b55","\u3030\uFE0F":"3030","\u303D\uFE0F":"303d","\u3297\uFE0F":"3297","\u3299\uFE0F":"3299","\u271D\uFE0F":"271d","\u2328\uFE0F":"2328","\u270D\uFE0F":"270d","\u23ED\uFE0F":"23ed","\u23EE\uFE0F":"23ee","\u23EF\uFE0F":"23ef","\u23F1\uFE0F":"23f1","\u23F2\uFE0F":"23f2","\u23F8\uFE0F":"23f8","\u23F9\uFE0F":"23f9","\u23FA\uFE0F":"23fa","\u2602\uFE0F":"2602","\u2603\uFE0F":"2603","\u2604\uFE0F":"2604","\u2618\uFE0F":"2618","\u2620\uFE0F":"2620","\u2622\uFE0F":"2622","\u2623\uFE0F":"2623","\u2626\uFE0F":"2626","\u262A\uFE0F":"262a","\u262E\uFE0F":"262e","\u262F\uFE0F":"262f","\u2638\uFE0F":"2638","\u2639\uFE0F":"2639","\u2692\uFE0F":"2692","\u2694\uFE0F":"2694","\u2696\uFE0F":"2696","\u2697\uFE0F":"2697","\u2699\uFE0F":"2699","\u269B\uFE0F":"269b","\u269C\uFE0F":"269c","\u26B0\uFE0F":"26b0","\u26B1\uFE0F":"26b1","\u26C8\uFE0F":"26c8","\u26CF\uFE0F":"26cf","\u26D1\uFE0F":"26d1","\u26D3\uFE0F":"26d3","\u26E9\uFE0F":"26e9","\u26F0\uFE0F":"26f0","\u26F1\uFE0F":"26f1","\u26F4\uFE0F":"26f4","\u26F7\uFE0F":"26f7","\u26F8\uFE0F":"26f8","\u26F9\uFE0F":"26f9","\u2721\uFE0F":"2721","\u2763\uFE0F":"2763","\uD83C\uDCCF":"1f0cf","\uD83C\uDD70":"1f170","\uD83C\uDD71":"1f171","\uD83C\uDD7E":"1f17e","\uD83C\uDD8E":"1f18e","\uD83C\uDD91":"1f191","\uD83C\uDD92":"1f192","\uD83C\uDD93":"1f193","\uD83C\uDD94":"1f194","\uD83C\uDD95":"1f195","\uD83C\uDD96":"1f196","\uD83C\uDD97":"1f197","\uD83C\uDD98":"1f198","\uD83C\uDD99":"1f199","\uD83C\uDD9A":"1f19a","\uD83C\uDE01":"1f201","\uD83C\uDE32":"1f232","\uD83C\uDE33":"1f233","\uD83C\uDE34":"1f234","\uD83C\uDE35":"1f235","\uD83C\uDE36":"1f236","\uD83C\uDE38":"1f238","\uD83C\uDE39":"1f239","\uD83C\uDE3A":"1f23a","\uD83C\uDE50":"1f250","\uD83C\uDE51":"1f251","\uD83C\uDF00":"1f300","\uD83C\uDF01":"1f301","\uD83C\uDF02":"1f302","\uD83C\uDF03":"1f303","\uD83C\uDF04":"1f304","\uD83C\uDF05":"1f305","\uD83C\uDF06":"1f306","\uD83C\uDF07":"1f307","\uD83C\uDF08":"1f308","\uD83C\uDF09":"1f309","\uD83C\uDF0A":"1f30a","\uD83C\uDF0B":"1f30b","\uD83C\uDF0C":"1f30c","\uD83C\uDF0F":"1f30f","\uD83C\uDF11":"1f311","\uD83C\uDF13":"1f313","\uD83C\uDF14":"1f314","\uD83C\uDF15":"1f315","\uD83C\uDF19":"1f319","\uD83C\uDF1B":"1f31b","\uD83C\uDF1F":"1f31f","\uD83C\uDF20":"1f320","\uD83C\uDF30":"1f330","\uD83C\uDF31":"1f331","\uD83C\uDF34":"1f334","\uD83C\uDF35":"1f335","\uD83C\uDF37":"1f337","\uD83C\uDF38":"1f338","\uD83C\uDF39":"1f339","\uD83C\uDF3A":"1f33a","\uD83C\uDF3B":"1f33b","\uD83C\uDF3C":"1f33c","\uD83C\uDF3D":"1f33d","\uD83C\uDF3E":"1f33e","\uD83C\uDF3F":"1f33f","\uD83C\uDF40":"1f340","\uD83C\uDF41":"1f341","\uD83C\uDF42":"1f342","\uD83C\uDF43":"1f343","\uD83C\uDF44":"1f344","\uD83C\uDF45":"1f345","\uD83C\uDF46":"1f346","\uD83C\uDF47":"1f347","\uD83C\uDF48":"1f348","\uD83C\uDF49":"1f349","\uD83C\uDF4A":"1f34a","\uD83C\uDF4C":"1f34c","\uD83C\uDF4D":"1f34d","\uD83C\uDF4E":"1f34e","\uD83C\uDF4F":"1f34f","\uD83C\uDF51":"1f351","\uD83C\uDF52":"1f352","\uD83C\uDF53":"1f353","\uD83C\uDF54":"1f354","\uD83C\uDF55":"1f355","\uD83C\uDF56":"1f356","\uD83C\uDF57":"1f357","\uD83C\uDF58":"1f358","\uD83C\uDF59":"1f359","\uD83C\uDF5A":"1f35a","\uD83C\uDF5B":"1f35b","\uD83C\uDF5C":"1f35c","\uD83C\uDF5D":"1f35d","\uD83C\uDF5E":"1f35e","\uD83C\uDF5F":"1f35f","\uD83C\uDF60":"1f360","\uD83C\uDF61":"1f361","\uD83C\uDF62":"1f362","\uD83C\uDF63":"1f363","\uD83C\uDF64":"1f364","\uD83C\uDF65":"1f365","\uD83C\uDF66":"1f366","\uD83C\uDF67":"1f367","\uD83C\uDF68":"1f368","\uD83C\uDF69":"1f369","\uD83C\uDF6A":"1f36a","\uD83C\uDF6B":"1f36b","\uD83C\uDF6C":"1f36c","\uD83C\uDF6D":"1f36d","\uD83C\uDF6E":"1f36e","\uD83C\uDF6F":"1f36f","\uD83C\uDF70":"1f370","\uD83C\uDF71":"1f371","\uD83C\uDF72":"1f372","\uD83C\uDF73":"1f373","\uD83C\uDF74":"1f374","\uD83C\uDF75":"1f375","\uD83C\uDF76":"1f376","\uD83C\uDF77":"1f377","\uD83C\uDF78":"1f378","\uD83C\uDF79":"1f379","\uD83C\uDF7A":"1f37a","\uD83C\uDF7B":"1f37b","\uD83C\uDF80":"1f380","\uD83C\uDF81":"1f381","\uD83C\uDF82":"1f382","\uD83C\uDF83":"1f383","\uD83C\uDF84":"1f384","\uD83C\uDF85":"1f385","\uD83C\uDF86":"1f386","\uD83C\uDF87":"1f387","\uD83C\uDF88":"1f388","\uD83C\uDF89":"1f389","\uD83C\uDF8A":"1f38a","\uD83C\uDF8B":"1f38b","\uD83C\uDF8C":"1f38c","\uD83C\uDF8D":"1f38d","\uD83C\uDF8E":"1f38e","\uD83C\uDF8F":"1f38f","\uD83C\uDF90":"1f390","\uD83C\uDF91":"1f391","\uD83C\uDF92":"1f392","\uD83C\uDF93":"1f393","\uD83C\uDFA0":"1f3a0","\uD83C\uDFA1":"1f3a1","\uD83C\uDFA2":"1f3a2","\uD83C\uDFA3":"1f3a3","\uD83C\uDFA4":"1f3a4","\uD83C\uDFA5":"1f3a5","\uD83C\uDFA6":"1f3a6","\uD83C\uDFA7":"1f3a7","\uD83C\uDFA8":"1f3a8","\uD83C\uDFA9":"1f3a9","\uD83C\uDFAA":"1f3aa","\uD83C\uDFAB":"1f3ab","\uD83C\uDFAC":"1f3ac","\uD83C\uDFAD":"1f3ad","\uD83C\uDFAE":"1f3ae","\uD83C\uDFAF":"1f3af","\uD83C\uDFB0":"1f3b0","\uD83C\uDFB1":"1f3b1","\uD83C\uDFB2":"1f3b2","\uD83C\uDFB3":"1f3b3","\uD83C\uDFB4":"1f3b4","\uD83C\uDFB5":"1f3b5","\uD83C\uDFB6":"1f3b6","\uD83C\uDFB7":"1f3b7","\uD83C\uDFB8":"1f3b8","\uD83C\uDFB9":"1f3b9","\uD83C\uDFBA":"1f3ba","\uD83C\uDFBB":"1f3bb","\uD83C\uDFBC":"1f3bc","\uD83C\uDFBD":"1f3bd","\uD83C\uDFBE":"1f3be","\uD83C\uDFBF":"1f3bf","\uD83C\uDFC0":"1f3c0","\uD83C\uDFC1":"1f3c1","\uD83C\uDFC2":"1f3c2","\uD83C\uDFC3":"1f3c3","\uD83C\uDFC4":"1f3c4","\uD83C\uDFC6":"1f3c6","\uD83C\uDFC8":"1f3c8","\uD83C\uDFCA":"1f3ca","\uD83C\uDFE0":"1f3e0","\uD83C\uDFE1":"1f3e1","\uD83C\uDFE2":"1f3e2","\uD83C\uDFE3":"1f3e3","\uD83C\uDFE5":"1f3e5","\uD83C\uDFE6":"1f3e6","\uD83C\uDFE7":"1f3e7","\uD83C\uDFE8":"1f3e8","\uD83C\uDFE9":"1f3e9","\uD83C\uDFEA":"1f3ea","\uD83C\uDFEB":"1f3eb","\uD83C\uDFEC":"1f3ec","\uD83C\uDFED":"1f3ed","\uD83C\uDFEE":"1f3ee","\uD83C\uDFEF":"1f3ef","\uD83C\uDFF0":"1f3f0","\uD83D\uDC0C":"1f40c","\uD83D\uDC0D":"1f40d","\uD83D\uDC0E":"1f40e","\uD83D\uDC11":"1f411","\uD83D\uDC12":"1f412","\uD83D\uDC14":"1f414","\uD83D\uDC17":"1f417","\uD83D\uDC18":"1f418","\uD83D\uDC19":"1f419","\uD83D\uDC1A":"1f41a","\uD83D\uDC1B":"1f41b","\uD83D\uDC1C":"1f41c","\uD83D\uDC1D":"1f41d","\uD83D\uDC1E":"1f41e","\uD83D\uDC1F":"1f41f","\uD83D\uDC20":"1f420","\uD83D\uDC21":"1f421","\uD83D\uDC22":"1f422","\uD83D\uDC23":"1f423","\uD83D\uDC24":"1f424","\uD83D\uDC25":"1f425","\uD83D\uDC26":"1f426","\uD83D\uDC27":"1f427","\uD83D\uDC28":"1f428","\uD83D\uDC29":"1f429","\uD83D\uDC2B":"1f42b","\uD83D\uDC2C":"1f42c","\uD83D\uDC2D":"1f42d","\uD83D\uDC2E":"1f42e","\uD83D\uDC2F":"1f42f","\uD83D\uDC30":"1f430","\uD83D\uDC31":"1f431","\uD83D\uDC32":"1f432","\uD83D\uDC33":"1f433","\uD83D\uDC34":"1f434","\uD83D\uDC35":"1f435","\uD83D\uDC36":"1f436","\uD83D\uDC37":"1f437","\uD83D\uDC38":"1f438","\uD83D\uDC39":"1f439","\uD83D\uDC3A":"1f43a","\uD83D\uDC3B":"1f43b","\uD83D\uDC3C":"1f43c","\uD83D\uDC3D":"1f43d","\uD83D\uDC3E":"1f43e","\uD83D\uDC40":"1f440","\uD83D\uDC42":"1f442","\uD83D\uDC43":"1f443","\uD83D\uDC44":"1f444","\uD83D\uDC45":"1f445","\uD83D\uDC46":"1f446","\uD83D\uDC47":"1f447","\uD83D\uDC48":"1f448","\uD83D\uDC49":"1f449","\uD83D\uDC4A":"1f44a","\uD83D\uDC4B":"1f44b","\uD83D\uDC4C":"1f44c","\uD83D\uDC4D":"1f44d","\uD83D\uDC4E":"1f44e","\uD83D\uDC4F":"1f44f","\uD83D\uDC50":"1f450","\uD83D\uDC51":"1f451","\uD83D\uDC52":"1f452","\uD83D\uDC53":"1f453","\uD83D\uDC54":"1f454","\uD83D\uDC55":"1f455","\uD83D\uDC56":"1f456","\uD83D\uDC57":"1f457","\uD83D\uDC58":"1f458","\uD83D\uDC59":"1f459","\uD83D\uDC5A":"1f45a","\uD83D\uDC5B":"1f45b","\uD83D\uDC5C":"1f45c","\uD83D\uDC5D":"1f45d","\uD83D\uDC5E":"1f45e","\uD83D\uDC5F":"1f45f","\uD83D\uDC60":"1f460","\uD83D\uDC61":"1f461","\uD83D\uDC62":"1f462","\uD83D\uDC63":"1f463","\uD83D\uDC64":"1f464","\uD83D\uDC66":"1f466","\uD83D\uDC67":"1f467","\uD83D\uDC68":"1f468","\uD83D\uDC69":"1f469","\uD83D\uDC6A":"1f46a","\uD83D\uDC6B":"1f46b","\uD83D\uDC6E":"1f46e","\uD83D\uDC6F":"1f46f","\uD83D\uDC70":"1f470","\uD83D\uDC71":"1f471","\uD83D\uDC72":"1f472","\uD83D\uDC73":"1f473","\uD83D\uDC74":"1f474","\uD83D\uDC75":"1f475","\uD83D\uDC76":"1f476","\uD83D\uDC77":"1f477","\uD83D\uDC78":"1f478","\uD83D\uDC79":"1f479","\uD83D\uDC7A":"1f47a","\uD83D\uDC7B":"1f47b","\uD83D\uDC7C":"1f47c","\uD83D\uDC7D":"1f47d","\uD83D\uDC7E":"1f47e","\uD83D\uDC7F":"1f47f","\uD83D\uDC80":"1f480","\uD83D\uDCC7":"1f4c7","\uD83D\uDC81":"1f481","\uD83D\uDC82":"1f482","\uD83D\uDC83":"1f483","\uD83D\uDC84":"1f484","\uD83D\uDC85":"1f485","\uD83D\uDCD2":"1f4d2","\uD83D\uDC86":"1f486","\uD83D\uDCD3":"1f4d3","\uD83D\uDC87":"1f487","\uD83D\uDCD4":"1f4d4","\uD83D\uDC88":"1f488","\uD83D\uDCD5":"1f4d5","\uD83D\uDC89":"1f489","\uD83D\uDCD6":"1f4d6","\uD83D\uDC8A":"1f48a","\uD83D\uDCD7":"1f4d7","\uD83D\uDC8B":"1f48b","\uD83D\uDCD8":"1f4d8","\uD83D\uDC8C":"1f48c","\uD83D\uDCD9":"1f4d9","\uD83D\uDC8D":"1f48d","\uD83D\uDCDA":"1f4da","\uD83D\uDC8E":"1f48e","\uD83D\uDCDB":"1f4db","\uD83D\uDC8F":"1f48f","\uD83D\uDCDC":"1f4dc","\uD83D\uDC90":"1f490","\uD83D\uDCDD":"1f4dd","\uD83D\uDC91":"1f491","\uD83D\uDCDE":"1f4de","\uD83D\uDC92":"1f492","\uD83D\uDCDF":"1f4df","\uD83D\uDCE0":"1f4e0","\uD83D\uDC93":"1f493","\uD83D\uDCE1":"1f4e1","\uD83D\uDCE2":"1f4e2","\uD83D\uDC94":"1f494","\uD83D\uDCE3":"1f4e3","\uD83D\uDCE4":"1f4e4","\uD83D\uDC95":"1f495","\uD83D\uDCE5":"1f4e5","\uD83D\uDCE6":"1f4e6","\uD83D\uDC96":"1f496","\uD83D\uDCE7":"1f4e7","\uD83D\uDCE8":"1f4e8","\uD83D\uDC97":"1f497","\uD83D\uDCE9":"1f4e9","\uD83D\uDCEA":"1f4ea","\uD83D\uDC98":"1f498","\uD83D\uDCEB":"1f4eb","\uD83D\uDCEE":"1f4ee","\uD83D\uDC99":"1f499","\uD83D\uDCF0":"1f4f0","\uD83D\uDCF1":"1f4f1","\uD83D\uDC9A":"1f49a","\uD83D\uDCF2":"1f4f2","\uD83D\uDCF3":"1f4f3","\uD83D\uDC9B":"1f49b","\uD83D\uDCF4":"1f4f4","\uD83D\uDCF6":"1f4f6","\uD83D\uDC9C":"1f49c","\uD83D\uDCF7":"1f4f7","\uD83D\uDCF9":"1f4f9","\uD83D\uDC9D":"1f49d","\uD83D\uDCFA":"1f4fa","\uD83D\uDCFB":"1f4fb","\uD83D\uDC9E":"1f49e","\uD83D\uDCFC":"1f4fc","\uD83D\uDD03":"1f503","\uD83D\uDC9F":"1f49f","\uD83D\uDD0A":"1f50a","\uD83D\uDD0B":"1f50b","\uD83D\uDCA0":"1f4a0","\uD83D\uDD0C":"1f50c","\uD83D\uDD0D":"1f50d","\uD83D\uDCA1":"1f4a1","\uD83D\uDD0E":"1f50e","\uD83D\uDD0F":"1f50f","\uD83D\uDCA2":"1f4a2","\uD83D\uDD10":"1f510","\uD83D\uDD11":"1f511","\uD83D\uDCA3":"1f4a3","\uD83D\uDD12":"1f512","\uD83D\uDD13":"1f513","\uD83D\uDCA4":"1f4a4","\uD83D\uDD14":"1f514","\uD83D\uDD16":"1f516","\uD83D\uDCA5":"1f4a5","\uD83D\uDD17":"1f517","\uD83D\uDD18":"1f518","\uD83D\uDCA6":"1f4a6","\uD83D\uDD19":"1f519","\uD83D\uDD1A":"1f51a","\uD83D\uDCA7":"1f4a7","\uD83D\uDD1B":"1f51b","\uD83D\uDD1C":"1f51c","\uD83D\uDCA8":"1f4a8","\uD83D\uDD1D":"1f51d","\uD83D\uDD1E":"1f51e","\uD83D\uDCA9":"1f4a9","\uD83D\uDD1F":"1f51f","\uD83D\uDCAA":"1f4aa","\uD83D\uDD20":"1f520","\uD83D\uDD21":"1f521","\uD83D\uDCAB":"1f4ab","\uD83D\uDD22":"1f522","\uD83D\uDD23":"1f523","\uD83D\uDCAC":"1f4ac","\uD83D\uDD24":"1f524","\uD83D\uDD25":"1f525","\uD83D\uDCAE":"1f4ae","\uD83D\uDD26":"1f526","\uD83D\uDD27":"1f527","\uD83D\uDCAF":"1f4af","\uD83D\uDD28":"1f528","\uD83D\uDD29":"1f529","\uD83D\uDCB0":"1f4b0","\uD83D\uDD2A":"1f52a","\uD83D\uDD2B":"1f52b","\uD83D\uDCB1":"1f4b1","\uD83D\uDD2E":"1f52e","\uD83D\uDCB2":"1f4b2","\uD83D\uDD2F":"1f52f","\uD83D\uDCB3":"1f4b3","\uD83D\uDD30":"1f530","\uD83D\uDD31":"1f531","\uD83D\uDCB4":"1f4b4","\uD83D\uDD32":"1f532","\uD83D\uDD33":"1f533","\uD83D\uDCB5":"1f4b5","\uD83D\uDD34":"1f534","\uD83D\uDD35":"1f535","\uD83D\uDCB8":"1f4b8","\uD83D\uDD36":"1f536","\uD83D\uDD37":"1f537","\uD83D\uDCB9":"1f4b9","\uD83D\uDD38":"1f538","\uD83D\uDD39":"1f539","\uD83D\uDCBA":"1f4ba","\uD83D\uDD3A":"1f53a","\uD83D\uDD3B":"1f53b","\uD83D\uDCBB":"1f4bb","\uD83D\uDD3C":"1f53c","\uD83D\uDCBC":"1f4bc","\uD83D\uDD3D":"1f53d","\uD83D\uDD50":"1f550","\uD83D\uDCBD":"1f4bd","\uD83D\uDD51":"1f551","\uD83D\uDCBE":"1f4be","\uD83D\uDD52":"1f552","\uD83D\uDCBF":"1f4bf","\uD83D\uDD53":"1f553","\uD83D\uDCC0":"1f4c0","\uD83D\uDD54":"1f554","\uD83D\uDD55":"1f555","\uD83D\uDCC1":"1f4c1","\uD83D\uDD56":"1f556","\uD83D\uDD57":"1f557","\uD83D\uDCC2":"1f4c2","\uD83D\uDD58":"1f558","\uD83D\uDD59":"1f559","\uD83D\uDCC3":"1f4c3","\uD83D\uDD5A":"1f55a","\uD83D\uDD5B":"1f55b","\uD83D\uDCC4":"1f4c4","\uD83D\uDDFB":"1f5fb","\uD83D\uDDFC":"1f5fc","\uD83D\uDCC5":"1f4c5","\uD83D\uDDFD":"1f5fd","\uD83D\uDDFE":"1f5fe","\uD83D\uDCC6":"1f4c6","\uD83D\uDDFF":"1f5ff","\uD83D\uDE01":"1f601","\uD83D\uDE02":"1f602","\uD83D\uDE03":"1f603","\uD83D\uDCC8":"1f4c8","\uD83D\uDE04":"1f604","\uD83D\uDE05":"1f605","\uD83D\uDCC9":"1f4c9","\uD83D\uDE06":"1f606","\uD83D\uDE09":"1f609","\uD83D\uDCCA":"1f4ca","\uD83D\uDE0A":"1f60a","\uD83D\uDE0B":"1f60b","\uD83D\uDCCB":"1f4cb","\uD83D\uDE0C":"1f60c","\uD83D\uDE0D":"1f60d","\uD83D\uDCCC":"1f4cc","\uD83D\uDE0F":"1f60f","\uD83D\uDE12":"1f612","\uD83D\uDCCD":"1f4cd","\uD83D\uDE13":"1f613","\uD83D\uDE14":"1f614","\uD83D\uDCCE":"1f4ce","\uD83D\uDE16":"1f616","\uD83D\uDE18":"1f618","\uD83D\uDCCF":"1f4cf","\uD83D\uDE1A":"1f61a","\uD83D\uDE1C":"1f61c","\uD83D\uDCD0":"1f4d0","\uD83D\uDE1D":"1f61d","\uD83D\uDE1E":"1f61e","\uD83D\uDCD1":"1f4d1","\uD83D\uDE20":"1f620","\uD83D\uDE21":"1f621","\uD83D\uDE22":"1f622","\uD83D\uDE23":"1f623","\uD83D\uDE24":"1f624","\uD83D\uDE25":"1f625","\uD83D\uDE28":"1f628","\uD83D\uDE29":"1f629","\uD83D\uDE2A":"1f62a","\uD83D\uDE2B":"1f62b","\uD83D\uDE2D":"1f62d","\uD83D\uDE30":"1f630","\uD83D\uDE31":"1f631","\uD83D\uDE32":"1f632","\uD83D\uDE33":"1f633","\uD83D\uDE35":"1f635","\uD83D\uDE37":"1f637","\uD83D\uDE38":"1f638","\uD83D\uDE39":"1f639","\uD83D\uDE3A":"1f63a","\uD83D\uDE3B":"1f63b","\uD83D\uDE3C":"1f63c","\uD83D\uDE3D":"1f63d","\uD83D\uDE3E":"1f63e","\uD83D\uDE3F":"1f63f","\uD83D\uDE40":"1f640","\uD83D\uDE45":"1f645","\uD83D\uDE46":"1f646","\uD83D\uDE47":"1f647","\uD83D\uDE48":"1f648","\uD83D\uDE49":"1f649","\uD83D\uDE4A":"1f64a","\uD83D\uDE4B":"1f64b","\uD83D\uDE4C":"1f64c","\uD83D\uDE4D":"1f64d","\uD83D\uDE4E":"1f64e","\uD83D\uDE4F":"1f64f","\uD83D\uDE80":"1f680","\uD83D\uDE83":"1f683","\uD83D\uDE84":"1f684","\uD83D\uDE85":"1f685","\uD83D\uDE87":"1f687","\uD83D\uDE89":"1f689","\uD83D\uDE8C":"1f68c","\uD83D\uDE8F":"1f68f","\uD83D\uDE91":"1f691","\uD83D\uDE92":"1f692","\uD83D\uDE93":"1f693","\uD83D\uDE95":"1f695","\uD83D\uDE97":"1f697","\uD83D\uDE99":"1f699","\uD83D\uDE9A":"1f69a","\uD83D\uDEA2":"1f6a2","\uD83D\uDEA4":"1f6a4","\uD83D\uDEA5":"1f6a5","\uD83D\uDEA7":"1f6a7","\uD83D\uDEA8":"1f6a8","\uD83D\uDEA9":"1f6a9","\uD83D\uDEAA":"1f6aa","\uD83D\uDEAB":"1f6ab","\uD83D\uDEAC":"1f6ac","\uD83D\uDEAD":"1f6ad","\uD83D\uDEB2":"1f6b2","\uD83D\uDEB6":"1f6b6","\uD83D\uDEB9":"1f6b9","\uD83D\uDEBA":"1f6ba","\uD83D\uDEBB":"1f6bb","\uD83D\uDEBC":"1f6bc","\uD83D\uDEBD":"1f6bd","\uD83D\uDEBE":"1f6be","\uD83D\uDEC0":"1f6c0","\uD83E\uDD18":"1f918","\uD83D\uDE00":"1f600","\uD83D\uDE07":"1f607","\uD83D\uDE08":"1f608","\uD83D\uDE0E":"1f60e","\uD83D\uDE10":"1f610","\uD83D\uDE11":"1f611","\uD83D\uDE15":"1f615","\uD83D\uDE17":"1f617","\uD83D\uDE19":"1f619","\uD83D\uDE1B":"1f61b","\uD83D\uDE1F":"1f61f","\uD83D\uDE26":"1f626","\uD83D\uDE27":"1f627","\uD83D\uDE2C":"1f62c","\uD83D\uDE2E":"1f62e","\uD83D\uDE2F":"1f62f","\uD83D\uDE34":"1f634","\uD83D\uDE36":"1f636","\uD83D\uDE81":"1f681","\uD83D\uDE82":"1f682","\uD83D\uDE86":"1f686","\uD83D\uDE88":"1f688","\uD83D\uDE8A":"1f68a","\uD83D\uDE8D":"1f68d","\uD83D\uDE8E":"1f68e","\uD83D\uDE90":"1f690","\uD83D\uDE94":"1f694","\uD83D\uDE96":"1f696","\uD83D\uDE98":"1f698","\uD83D\uDE9B":"1f69b","\uD83D\uDE9C":"1f69c","\uD83D\uDE9D":"1f69d","\uD83D\uDE9E":"1f69e","\uD83D\uDE9F":"1f69f","\uD83D\uDEA0":"1f6a0","\uD83D\uDEA1":"1f6a1","\uD83D\uDEA3":"1f6a3","\uD83D\uDEA6":"1f6a6","\uD83D\uDEAE":"1f6ae","\uD83D\uDEAF":"1f6af","\uD83D\uDEB0":"1f6b0","\uD83D\uDEB1":"1f6b1","\uD83D\uDEB3":"1f6b3","\uD83D\uDEB4":"1f6b4","\uD83D\uDEB5":"1f6b5","\uD83D\uDEB7":"1f6b7","\uD83D\uDEB8":"1f6b8","\uD83D\uDEBF":"1f6bf","\uD83D\uDEC1":"1f6c1","\uD83D\uDEC2":"1f6c2","\uD83D\uDEC3":"1f6c3","\uD83D\uDEC4":"1f6c4","\uD83D\uDEC5":"1f6c5","\uD83C\uDF0D":"1f30d","\uD83C\uDF0E":"1f30e","\uD83C\uDF10":"1f310","\uD83C\uDF12":"1f312","\uD83C\uDF16":"1f316","\uD83C\uDF17":"1f317","\uD83C\uDF18":"1f318","\uD83C\uDF1A":"1f31a","\uD83C\uDF1C":"1f31c","\uD83C\uDF1D":"1f31d","\uD83C\uDF1E":"1f31e","\uD83C\uDF32":"1f332","\uD83C\uDF33":"1f333","\uD83C\uDF4B":"1f34b","\uD83C\uDF50":"1f350","\uD83C\uDF7C":"1f37c","\uD83C\uDFC7":"1f3c7","\uD83C\uDFC9":"1f3c9","\uD83C\uDFE4":"1f3e4","\uD83D\uDC00":"1f400","\uD83D\uDC01":"1f401","\uD83D\uDC02":"1f402","\uD83D\uDC03":"1f403","\uD83D\uDC04":"1f404","\uD83D\uDC05":"1f405","\uD83D\uDC06":"1f406","\uD83D\uDC07":"1f407","\uD83D\uDC08":"1f408","\uD83D\uDC09":"1f409","\uD83D\uDC0A":"1f40a","\uD83D\uDC0B":"1f40b","\uD83D\uDC0F":"1f40f","\uD83D\uDC10":"1f410","\uD83D\uDC13":"1f413","\uD83D\uDC15":"1f415","\uD83D\uDC16":"1f416","\uD83D\uDC2A":"1f42a","\uD83D\uDC65":"1f465","\uD83D\uDC6C":"1f46c","\uD83D\uDC6D":"1f46d","\uD83D\uDCAD":"1f4ad","\uD83D\uDCB6":"1f4b6","\uD83D\uDCB7":"1f4b7","\uD83D\uDCEC":"1f4ec","\uD83D\uDCED":"1f4ed","\uD83D\uDCEF":"1f4ef","\uD83D\uDCF5":"1f4f5","\uD83D\uDD00":"1f500","\uD83D\uDD01":"1f501","\uD83D\uDD02":"1f502","\uD83D\uDD04":"1f504","\uD83D\uDD05":"1f505","\uD83D\uDD06":"1f506","\uD83D\uDD07":"1f507","\uD83D\uDD09":"1f509","\uD83D\uDD15":"1f515","\uD83D\uDD2C":"1f52c","\uD83D\uDD2D":"1f52d","\uD83D\uDD5C":"1f55c","\uD83D\uDD5D":"1f55d","\uD83D\uDD5E":"1f55e","\uD83D\uDD5F":"1f55f","\uD83D\uDD60":"1f560","\uD83D\uDD61":"1f561","\uD83D\uDD62":"1f562","\uD83D\uDD63":"1f563","\uD83D\uDD64":"1f564","\uD83D\uDD65":"1f565","\uD83D\uDD66":"1f566","\uD83D\uDD67":"1f567","\uD83D\uDD08":"1f508","\uD83D\uDE8B":"1f68b","\uD83C\uDFC5":"1f3c5","\uD83C\uDFF4":"1f3f4","\uD83D\uDCF8":"1f4f8","\uD83D\uDECC":"1f6cc","\uD83D\uDD95":"1f595","\uD83D\uDD96":"1f596","\uD83D\uDE41":"1f641","\uD83D\uDE42":"1f642","\uD83D\uDEEB":"1f6eb","\uD83D\uDEEC":"1f6ec","\uD83C\uDFFB":"1f3fb","\uD83C\uDFFC":"1f3fc","\uD83C\uDFFD":"1f3fd","\uD83C\uDFFE":"1f3fe","\uD83C\uDFFF":"1f3ff","\uD83D\uDE43":"1f643","\uD83E\uDD11":"1f911","\uD83E\uDD13":"1f913","\uD83E\uDD17":"1f917","\uD83D\uDE44":"1f644","\uD83E\uDD14":"1f914","\uD83E\uDD10":"1f910","\uD83E\uDD12":"1f912","\uD83E\uDD15":"1f915","\uD83E\uDD16":"1f916","\uD83E\uDD81":"1f981","\uD83E\uDD84":"1f984","\uD83E\uDD82":"1f982","\uD83E\uDD80":"1f980","\uD83E\uDD83":"1f983","\uD83E\uDDC0":"1f9c0","\uD83C\uDF2D":"1f32d","\uD83C\uDF2E":"1f32e","\uD83C\uDF2F":"1f32f","\uD83C\uDF7F":"1f37f","\uD83C\uDF7E":"1f37e","\uD83C\uDFF9":"1f3f9","\uD83C\uDFFA":"1f3fa","\uD83D\uDED0":"1f6d0","\uD83D\uDD4B":"1f54b","\uD83D\uDD4C":"1f54c","\uD83D\uDD4D":"1f54d","\uD83D\uDD4E":"1f54e","\uD83D\uDCFF":"1f4ff","\uD83C\uDFCF":"1f3cf","\uD83C\uDFD0":"1f3d0","\uD83C\uDFD1":"1f3d1","\uD83C\uDFD2":"1f3d2","\uD83C\uDFD3":"1f3d3","\uD83C\uDFF8":"1f3f8","\u23E9":"23e9","\u23EA":"23ea","\u23EB":"23eb","\u23EC":"23ec","\u23F0":"23f0","\u23F3":"23f3","\u26CE":"26ce","\u2705":"2705","\u270A":"270a","\u270B":"270b","\u2728":"2728","\u274C":"274c","\u274E":"274e","\u2753":"2753","\u2754":"2754","\u2755":"2755","\u2795":"2795","\u2796":"2796","\u2797":"2797","\u27B0":"27b0","\u27BF":"27bf","\u00A9":"00a9","\u00AE":"00ae","\u203C":"203c","\u2049":"2049","\u2122":"2122","\u2139":"2139","\u2194":"2194","\u2195":"2195","\u2196":"2196","\u2197":"2197","\u2198":"2198","\u2199":"2199","\u21A9":"21a9","\u21AA":"21aa","\u231A":"231a","\u231B":"231b","\u24C2":"24c2","\u25AA":"25aa","\u25AB":"25ab","\u25B6":"25b6","\u25C0":"25c0","\u25FB":"25fb","\u25FC":"25fc","\u25FD":"25fd","\u25FE":"25fe","\u2600":"2600","\u2601":"2601","\u260E":"260e","\u2611":"2611","\u2614":"2614","\u2615":"2615","\u261D":"261d","\u263A":"263a","\u2648":"2648","\u2649":"2649","\u264A":"264a","\u264B":"264b","\u264C":"264c","\u264D":"264d","\u264E":"264e","\u264F":"264f","\u2650":"2650","\u2651":"2651","\u2652":"2652","\u2653":"2653","\u2660":"2660","\u2663":"2663","\u2665":"2665","\u2666":"2666","\u2668":"2668","\u267B":"267b","\u267F":"267f","\u2693":"2693","\u26A0":"26a0","\u26A1":"26a1","\u26AA":"26aa","\u26AB":"26ab","\u26BD":"26bd","\u26BE":"26be","\u26C4":"26c4","\u26C5":"26c5","\u26D4":"26d4","\u26EA":"26ea","\u26F2":"26f2","\u26F3":"26f3","\u26F5":"26f5","\u26FA":"26fa","\u26FD":"26fd","\u2702":"2702","\u2708":"2708","\u2709":"2709","\u270C":"270c","\u270F":"270f","\u2712":"2712","\u2714":"2714","\u2716":"2716","\u2733":"2733","\u2734":"2734","\u2744":"2744","\u2747":"2747","\u2757":"2757","\u2764":"2764","\u27A1":"27a1","\u2934":"2934","\u2935":"2935","\u2B05":"2b05","\u2B06":"2b06","\u2B07":"2b07","\u2B1B":"2b1b","\u2B1C":"2b1c","\u2B50":"2b50","\u2B55":"2b55","\u3030":"3030","\u303D":"303d","\u3297":"3297","\u3299":"3299","\uD83C\uDC04":"1f004","\uD83C\uDD7F":"1f17f","\uD83C\uDE02":"1f202","\uD83C\uDE1A":"1f21a","\uD83C\uDE2F":"1f22f","\uD83C\uDE37":"1f237","\uD83C\uDF9E":"1f39e","\uD83C\uDF9F":"1f39f","\uD83C\uDFCB":"1f3cb","\uD83C\uDFCC":"1f3cc","\uD83C\uDFCD":"1f3cd","\uD83C\uDFCE":"1f3ce","\uD83C\uDF96":"1f396","\uD83C\uDF97":"1f397","\uD83C\uDF36":"1f336","\uD83C\uDF27":"1f327","\uD83C\uDF28":"1f328","\uD83C\uDF29":"1f329","\uD83C\uDF2A":"1f32a","\uD83C\uDF2B":"1f32b","\uD83C\uDF2C":"1f32c","\uD83D\uDC3F":"1f43f","\uD83D\uDD77":"1f577","\uD83D\uDD78":"1f578","\uD83C\uDF21":"1f321","\uD83C\uDF99":"1f399","\uD83C\uDF9A":"1f39a","\uD83C\uDF9B":"1f39b","\uD83C\uDFF3":"1f3f3","\uD83C\uDFF5":"1f3f5","\uD83C\uDFF7":"1f3f7","\uD83D\uDCFD":"1f4fd","\u271D":"271d","\uD83D\uDD49":"1f549","\uD83D\uDD4A":"1f54a","\uD83D\uDD6F":"1f56f","\uD83D\uDD70":"1f570","\uD83D\uDD73":"1f573","\uD83D\uDD76":"1f576","\uD83D\uDD79":"1f579","\uD83D\uDD87":"1f587","\uD83D\uDD8A":"1f58a","\uD83D\uDD8B":"1f58b","\uD83D\uDD8C":"1f58c","\uD83D\uDD8D":"1f58d","\uD83D\uDDA5":"1f5a5","\uD83D\uDDA8":"1f5a8","\u2328":"2328","\uD83D\uDDB2":"1f5b2","\uD83D\uDDBC":"1f5bc","\uD83D\uDDC2":"1f5c2","\uD83D\uDDC3":"1f5c3","\uD83D\uDDC4":"1f5c4","\uD83D\uDDD1":"1f5d1","\uD83D\uDDD2":"1f5d2","\uD83D\uDDD3":"1f5d3","\uD83D\uDDDC":"1f5dc","\uD83D\uDDDD":"1f5dd","\uD83D\uDDDE":"1f5de","\uD83D\uDDE1":"1f5e1","\uD83D\uDDE3":"1f5e3","\uD83D\uDDEF":"1f5ef","\uD83D\uDDF3":"1f5f3","\uD83D\uDDFA":"1f5fa","\uD83D\uDEE0":"1f6e0","\uD83D\uDEE1":"1f6e1","\uD83D\uDEE2":"1f6e2","\uD83D\uDEF0":"1f6f0","\uD83C\uDF7D":"1f37d","\uD83D\uDC41":"1f441","\uD83D\uDD74":"1f574","\uD83D\uDD75":"1f575","\u270D":"270d","\uD83D\uDD90":"1f590","\uD83C\uDFD4":"1f3d4","\uD83C\uDFD5":"1f3d5","\uD83C\uDFD6":"1f3d6","\uD83C\uDFD7":"1f3d7","\uD83C\uDFD8":"1f3d8","\uD83C\uDFD9":"1f3d9","\uD83C\uDFDA":"1f3da","\uD83C\uDFDB":"1f3db","\uD83C\uDFDC":"1f3dc","\uD83C\uDFDD":"1f3dd","\uD83C\uDFDE":"1f3de","\uD83C\uDFDF":"1f3df","\uD83D\uDECB":"1f6cb","\uD83D\uDECD":"1f6cd","\uD83D\uDECE":"1f6ce","\uD83D\uDECF":"1f6cf","\uD83D\uDEE3":"1f6e3","\uD83D\uDEE4":"1f6e4","\uD83D\uDEE5":"1f6e5","\uD83D\uDEE9":"1f6e9","\uD83D\uDEF3":"1f6f3","\u23ED":"23ed","\u23EE":"23ee","\u23EF":"23ef","\u23F1":"23f1","\u23F2":"23f2","\u23F8":"23f8","\u23F9":"23f9","\u23FA":"23fa","\u2602":"2602","\u2603":"2603","\u2604":"2604","\u2618":"2618","\u2620":"2620","\u2622":"2622","\u2623":"2623","\u2626":"2626","\u262A":"262a","\u262E":"262e","\u262F":"262f","\u2638":"2638","\u2639":"2639","\u2692":"2692","\u2694":"2694","\u2696":"2696","\u2697":"2697","\u2699":"2699","\u269B":"269b","\u269C":"269c","\u26B0":"26b0","\u26B1":"26b1","\u26C8":"26c8","\u26CF":"26cf","\u26D1":"26d1","\u26D3":"26d3","\u26E9":"26e9","\u26F0":"26f0","\u26F1":"26f1","\u26F4":"26f4","\u26F7":"26f7","\u26F8":"26f8","\u26F9":"26f9","\u2721":"2721","\u2763":"2763","\uD83C\uDF24":"1f324","\uD83C\uDF25":"1f325","\uD83C\uDF26":"1f326","\uD83D\uDDB1":"1f5b1"};
	    ns.imagePathPNG = '//cdn.jsdelivr.net/emojione/assets/png/';
	    ns.imagePathSVG = '//cdn.jsdelivr.net/emojione/assets/svg/';
	    ns.imagePathSVGSprites = './../assets/sprites/emojione.sprites.svg';
	    ns.imageType = 'png'; // or svg
	    ns.sprites = false; // if this is true then sprite markup will be used (if SVG image type is set then you must include the SVG sprite file locally)
	    ns.unicodeAlt = true; // use the unicode char as the alt attribute (makes copy and pasting the resulting text better)
	    ns.ascii = false; // change to true to convert ascii smileys
	    ns.cacheBustParam = '?v=2.2.3'; // you can [optionally] modify this to force browsers to refresh their cache. it will be appended to the send of the filenames
	
	    ns.regShortNames = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+ns.shortnames+")", "gi");
	    ns.regAscii = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|((\\s|^)"+ns.asciiRegexp+"(?=\\s|$|[!,.?]))", "g");
	    ns.regUnicode = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+ns.unicodeRegexp+")", "gi");
	
	    ns.toImage = function(str) {
	        str = ns.unicodeToImage(str);
	        str = ns.shortnameToImage(str);
	        return str;
	    };
	
	    // Uses toShort to transform all unicode into a standard shortname
	    // then transforms the shortname into unicode
	    // This is done for standardization when converting several unicode types
	    ns.unifyUnicode = function(str) {
	        str = ns.toShort(str);
	        str = ns.shortnameToUnicode(str);
	        return str;
	    };
	
	    // Replace shortnames (:wink:) with Ascii equivalents ( ;^) )
	    // Useful for systems that dont support unicode nor images
	    ns.shortnameToAscii = function(str) {
	        var unicode,
	            // something to keep in mind here is that array flip will destroy
	            // half of the ascii text "emojis" because the unicode numbers are duplicated
	            // this is ok for what it's being used for
	            unicodeToAscii = ns.objectFlip(ns.asciiList);
	
	        str = str.replace(ns.regShortNames, function(shortname) {
	            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
	                // if the shortname doesnt exist just return the entire match
	                return shortname;
	            }
	            else {
	                unicode = ns.emojioneList[shortname].unicode[ns.emojioneList[shortname].unicode.length-1];
	                if(typeof unicodeToAscii[unicode] !== 'undefined') {
	                    return unicodeToAscii[unicode];
	                } else {
	                    return shortname;
	                }
	            }
	        });
	        return str;
	    };
	
	    // will output unicode from shortname
	    // useful for sending emojis back to mobile devices
	    ns.shortnameToUnicode = function(str) {
	        // replace regular shortnames first
	        var unicode;
	        str = str.replace(ns.regShortNames, function(shortname) {
	            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
	                // if the shortname doesnt exist just return the entire match
	                return shortname;
	            }
	            unicode = ns.emojioneList[shortname].unicode[0].toUpperCase();
	            return ns.convert(unicode);
	        });
	
	        // if ascii smileys are turned on, then we'll replace them!
	        if (ns.ascii) {
	
	            str = str.replace(ns.regAscii, function(entire, m1, m2, m3) {
	                if( (typeof m3 === 'undefined') || (m3 === '') || (!(ns.unescapeHTML(m3) in ns.asciiList)) ) {
	                    // if the shortname doesnt exist just return the entire match
	                    return entire;
	                }
	
	                m3 = ns.unescapeHTML(m3);
	                unicode = ns.asciiList[m3].toUpperCase();
	                return m2+ns.convert(unicode);
	            });
	        }
	
			return str;
	    };
	
	    ns.shortnameToImage = function(str) {
	        // replace regular shortnames first
	        var replaceWith,unicode,alt;
	        str = str.replace(ns.regShortNames, function(shortname) {
	            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
	                // if the shortname doesnt exist just return the entire match
	                return shortname;
	            }
	            else {
	                unicode = ns.emojioneList[shortname].unicode[ns.emojioneList[shortname].unicode.length-1];
	
	                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
	                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : shortname;
	
	                if(ns.imageType === 'png') {
	                    if(ns.sprites) {
	                        replaceWith = '<span class="emojione emojione-'+unicode+'" title="'+shortname+'">'+alt+'</span>';
	                    }
	                    else {
	                        replaceWith = '<img class="emojione" alt="'+alt+'" src="'+ns.imagePathPNG+unicode+'.png'+ns.cacheBustParam+'"/>';
	                    }
	                }
	                else {
	                    // svg
	                    if(ns.sprites) {
	                        replaceWith = '<svg class="emojione"><description>'+alt+'</description><use xlink:href="'+ns.imagePathSVGSprites+'#emoji-'+unicode+'"></use></svg>';
	                    }
	                    else {
	                        replaceWith = '<object class="emojione" data="'+ns.imagePathSVG+unicode+'.svg'+ns.cacheBustParam+'" type="image/svg+xml" standby="'+alt+'">'+alt+'</object>';
	                    }
	                }
	
	                return replaceWith;
	            }
	        });
	
	        // if ascii smileys are turned on, then we'll replace them!
	        if (ns.ascii) {
	
	            str = str.replace(ns.regAscii, function(entire, m1, m2, m3) {
	                if( (typeof m3 === 'undefined') || (m3 === '') || (!(ns.unescapeHTML(m3) in ns.asciiList)) ) {
	                    // if the shortname doesnt exist just return the entire match
	                    return entire;
	                }
	
	                m3 = ns.unescapeHTML(m3);
	                unicode = ns.asciiList[m3];
	
	                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
	                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : ns.escapeHTML(m3);
	
	                if(ns.imageType === 'png') {
	                    if(ns.sprites) {
	                        replaceWith = m2+'<span class="emojione emojione-'+unicode+'" title="'+ns.escapeHTML(m3)+'">'+alt+'</span>';
	                    }
	                    else {
	                        replaceWith = m2+'<img class="emojione" alt="'+alt+'" src="'+ns.imagePathPNG+unicode+'.png'+ns.cacheBustParam+'"/>';
	                    }
	                }
	                else {
	                    // svg
	                    if(ns.sprites) {
	                        replaceWith = '<svg class="emojione"><description>'+alt+'</description><use xlink:href="'+ns.imagePathSVGSprites+'#emoji-'+unicode+'"></use></svg>';
	                    }
	                    else {
	                        replaceWith = m2+'<object class="emojione" data="'+ns.imagePathSVG+unicode+'.svg'+ns.cacheBustParam+'" type="image/svg+xml" standby="'+alt+'">'+alt+'</object>';
	                    }
	                }
	
	                return replaceWith;
	            });
	        }
	
	        return str;
	    };
	
	    ns.unicodeToImage = function(str) {
	
	        var replaceWith,unicode,alt;
	
	        if((!ns.unicodeAlt) || (ns.sprites)) {
	            // if we are using the shortname as the alt tag then we need a reversed array to map unicode code point to shortnames
	            var mappedUnicode = ns.mapUnicodeToShort();
	        }
	
	        str = str.replace(ns.regUnicode, function(unicodeChar) {
	            if( (typeof unicodeChar === 'undefined') || (unicodeChar === '') || (!(unicodeChar in ns.jsEscapeMap)) ) {
	                // if the unicodeChar doesnt exist just return the entire match
	                return unicodeChar;
	            }
	            else {
	                // get the unicode codepoint from the actual char
	                unicode = ns.jsEscapeMap[unicodeChar];
	
	                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
	                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : mappedUnicode[unicode];
	
	                if(ns.imageType === 'png') {
	                    if(ns.sprites) {
	                        replaceWith = '<span class="emojione emojione-'+unicode+'" title="'+mappedUnicode[unicode]+'">'+alt+'</span>';
	                    }
	                    else {
	                        replaceWith = '<img class="emojione" alt="'+alt+'" src="'+ns.imagePathPNG+unicode+'.png'+ns.cacheBustParam+'"/>';
	                    }
	                }
	                else {
	                    // svg
	                    if(ns.sprites) {
	                        replaceWith = '<svg class="emojione"><description>'+alt+'</description><use xlink:href="'+ns.imagePathSVGSprites+'#emoji-'+unicode+'"></use></svg>';
	                    }
	                    else {
	                        replaceWith = '<img class="emojione" alt="'+alt+'" src="'+ns.imagePathSVG+unicode+'.svg'+ns.cacheBustParam+'"/>';
	                    }
	                }
	
	                return replaceWith;
	            }
	        });
	
	        return str;
	    };
	
	    // this is really just unicodeToShortname() but I opted for the shorthand name to match toImage()
	    ns.toShort = function(str) {
	        var find = ns.getUnicodeReplacementRegEx(),
	            replacementList = ns.mapUnicodeCharactersToShort();
	        return  ns.replaceAll(str, find,replacementList);
	    };
	
	    // for converting unicode code points and code pairs to their respective characters
	    ns.convert = function(unicode) {
	        if(unicode.indexOf("-") > -1) {
	            var parts = [];
	            var s = unicode.split('-');
	            for(var i = 0; i < s.length; i++) {
	                var part = parseInt(s[i], 16);
	                if (part >= 0x10000 && part <= 0x10FFFF) {
	                    var hi = Math.floor((part - 0x10000) / 0x400) + 0xD800;
	                    var lo = ((part - 0x10000) % 0x400) + 0xDC00;
	                    part = (String.fromCharCode(hi) + String.fromCharCode(lo));
	                }
	                else {
	                    part = String.fromCharCode(part);
	                }
	                parts.push(part);
	            }
	            return parts.join('');
	        }
	        else {
	            var s = parseInt(unicode, 16);
	            if (s >= 0x10000 && s <= 0x10FFFF) {
	                var hi = Math.floor((s - 0x10000) / 0x400) + 0xD800;
	                var lo = ((s - 0x10000) % 0x400) + 0xDC00;
	                return (String.fromCharCode(hi) + String.fromCharCode(lo));
	            }
	            else {
	                return String.fromCharCode(s);
	            }
	        }
	    };
	
	    ns.escapeHTML = function (string) {
	        var escaped = {
	            '&' : '&amp;',
	            '<' : '&lt;',
	            '>' : '&gt;',
	            '"' : '&quot;',
	            '\'': '&#039;'
	        };
	
	        return string.replace(/[&<>"']/g, function (match) {
	            return escaped[match];
	        });
	    };
	    ns.unescapeHTML = function (string) {
	        var unescaped = {
	            '&amp;'  : '&',
	            '&#38;'  : '&',
	            '&#x26;' : '&',
	            '&lt;'   : '<',
	            '&#60;'  : '<',
	            '&#x3C;' : '<',
	            '&gt;'   : '>',
	            '&#62;'  : '>',
	            '&#x3E;' : '>',
	            '&quot;' : '"',
	            '&#34;'  : '"',
	            '&#x22;' : '"',
	            '&apos;' : '\'',
	            '&#39;'  : '\'',
	            '&#x27;' : '\''
	        };
	
	        return string.replace(/&(?:amp|#38|#x26|lt|#60|#x3C|gt|#62|#x3E|apos|#39|#x27|quot|#34|#x22);/ig, function (match) {
	            return unescaped[match];
	        });
	    };
	
	    ns.mapEmojioneList = function (addToMapStorage) {
	        for (var shortname in ns.emojioneList) {
	            if (!ns.emojioneList.hasOwnProperty(shortname)) { continue; }
	            for (var i = 0, len = ns.emojioneList[shortname].unicode.length; i < len; i++) {
	                var unicode = ns.emojioneList[shortname].unicode[i];
	                addToMapStorage(unicode, shortname);
	            }
	        }
	    };
	
	    ns.mapUnicodeToShort = function() {
	        if (!ns.memMapShortToUnicode) {
	            ns.memMapShortToUnicode = {};
	            ns.mapEmojioneList(function (unicode, shortname) {
	                ns.memMapShortToUnicode[unicode] = shortname;
	            });
	        }
	        return ns.memMapShortToUnicode;
	    };
	
	    ns.memoizeReplacement = function() {
	        if (!ns.unicodeReplacementRegEx || !ns.memMapShortToUnicodeCharacters) {
	            var unicodeList = [];
	            ns.memMapShortToUnicodeCharacters = {};
	            ns.mapEmojioneList(function (unicode, shortname) {
	                var emojiCharacter = ns.convert(unicode);
	                if(ns.emojioneList[shortname].isCanonical) {
	                    ns.memMapShortToUnicodeCharacters[emojiCharacter] = shortname;
	                }
	                unicodeList.push(emojiCharacter);
	            });
	            ns.unicodeReplacementRegEx = unicodeList.join('|');
	        }
	    };
	
	    ns.mapUnicodeCharactersToShort = function() {
	        ns.memoizeReplacement();
	        return ns.memMapShortToUnicodeCharacters;
	    };
	
	    ns.getUnicodeReplacementRegEx = function() {
	        ns.memoizeReplacement();
	        return ns.unicodeReplacementRegEx;
	    };
	
	    //reverse an object
	    ns.objectFlip = function (obj) {
	        var key, tmp_obj = {};
	
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                tmp_obj[obj[key]] = key;
	            }
	        }
	
	        return tmp_obj;
	    };
	
	    ns.escapeRegExp = function(string) {
	        return string.replace(/[-[\]{}()*+?.,;:&\\^$#\s]/g, "\\$&");
	    };
	
	    ns.replaceAll = function(string, find, replacementList) {
	        var escapedFind = ns.escapeRegExp(find);
	        var search = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+escapedFind+")", "gi");
	
	        // callback prevents replacing anything inside of these common html tags as well as between an <object></object> tag
	        var replace = function(entire, m1) {
	            return m1 ? replacementList[m1] : entire;
	        };
	
	        return string.replace(search,replace);
	    };
	
	}(this.emojione = this.emojione || {}));
	if(true) module.exports = this.emojione;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILE = exports.FILE = '__NATIVE_FILE__';
	var URL = exports.URL = '__NATIVE_URL__';
	var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropContext = __webpack_require__(528);
	
	Object.defineProperty(exports, 'DragDropContext', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContext).default;
	  }
	});
	
	var _DragDropContextProvider = __webpack_require__(1427);
	
	Object.defineProperty(exports, 'DragDropContextProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContextProvider).default;
	  }
	});
	
	var _DragLayer = __webpack_require__(1428);
	
	Object.defineProperty(exports, 'DragLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragLayer).default;
	  }
	});
	
	var _DragSource = __webpack_require__(1429);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(1430);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i += 1) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(143);
	var Danger = __webpack_require__(1445);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstrumentation = __webpack_require__(65);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(353);
	var setInnerHTML = __webpack_require__(231);
	var setTextContent = __webpack_require__(551);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactErrorUtils = __webpack_require__(351);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactPropTypesSecret = __webpack_require__(1474);
	var propTypesFactory = __webpack_require__(525);
	
	var React = __webpack_require__(146);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactInstanceMap = __webpack_require__(175);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactUpdates = __webpack_require__(75);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(42);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var emptyFunction = __webpack_require__(43);
	var warning = __webpack_require__(14);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(148);
	
	var ReactNoopUpdateQueue = __webpack_require__(361);
	
	var canDefineProperty = __webpack_require__(555);
	var emptyObject = __webpack_require__(164);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(14);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	module.exports = Writable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(339);
	/*</replacement>*/
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(158);
	util.inherits = __webpack_require__(72);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1533)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(558);
	/*</replacement>*/
	
	var Buffer = __webpack_require__(88).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(181);
	/*</replacement>*/
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(122);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(122);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = Buffer.isBuffer(chunk);
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = bufferShim.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    chunk = decodeChunk(state, chunk, encoding);
	    if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) processNextTick(cb, er);else cb(er);
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    while (entry) {
	      buffer[count] = entry;
	      entry = entry.next;
	      count += 1;
	    }
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else {
	      prefinish(stream, state);
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function (err) {
	    var entry = _this.entry;
	    _this.entry = null;
	    while (entry) {
	      var cb = entry.callback;
	      state.pendingcb--;
	      cb(err);
	      entry = entry.next;
	    }
	    if (state.corkedRequestsFree) {
	      state.corkedRequestsFree.next = _this;
	    } else {
	      state.corkedRequestsFree = _this;
	    }
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64), __webpack_require__(232).setImmediate))

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(556);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(362);
	exports.Duplex = __webpack_require__(122);
	exports.Transform = __webpack_require__(557);
	exports.PassThrough = __webpack_require__(1517);


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(64)))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(88).Buffer;
	var bufferShim = __webpack_require__(181);
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = bufferShim.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	"use strict";
	
	var q = __webpack_require__(6);
	var Matrix = __webpack_require__(28);
	var Room = Matrix.Room;
	var CallHandler = __webpack_require__(73);
	
	// FIXME: This currently forces Vector to try to hit the matrix.org AS for conferencing.
	// This is bad because it prevents people running their own ASes from being used.
	// This isn't permanent and will be customisable in the future: see the proposal
	// at docs/conferencing.md for more info.
	var USER_PREFIX = "fs_";
	var DOMAIN = "matrix.org";
	
	function ConferenceCall(matrixClient, groupChatRoomId) {
	    this.client = matrixClient;
	    this.groupRoomId = groupChatRoomId;
	    this.confUserId = module.exports.getConferenceUserIdForRoom(this.groupRoomId);
	}
	
	ConferenceCall.prototype.setup = function () {
	    var self = this;
	    return this._joinConferenceUser().then(function () {
	        return self._getConferenceUserRoom();
	    }).then(function (room) {
	        // return a call for *this* room to be placed. We also tack on
	        // confUserId to speed up lookups (else we'd need to loop every room
	        // looking for a 1:1 room with this conf user ID!)
	        var call = Matrix.createNewMatrixCall(self.client, room.roomId);
	        call.confUserId = self.confUserId;
	        call.groupRoomId = self.groupRoomId;
	        return call;
	    });
	};
	
	ConferenceCall.prototype._joinConferenceUser = function () {
	    // Make sure the conference user is in the group chat room
	    var groupRoom = this.client.getRoom(this.groupRoomId);
	    if (!groupRoom) {
	        return q.reject("Bad group room ID");
	    }
	    var member = groupRoom.getMember(this.confUserId);
	    if (member && member.membership === "join") {
	        return q();
	    }
	    return this.client.invite(this.groupRoomId, this.confUserId);
	};
	
	ConferenceCall.prototype._getConferenceUserRoom = function () {
	    // Use an existing 1:1 with the conference user; else make one
	    var rooms = this.client.getRooms();
	    var confRoom = null;
	    for (var i = 0; i < rooms.length; i++) {
	        var confUser = rooms[i].getMember(this.confUserId);
	        if (confUser && confUser.membership === "join" && rooms[i].getJoinedMembers().length === 2) {
	            confRoom = rooms[i];
	            break;
	        }
	    }
	    if (confRoom) {
	        return q(confRoom);
	    }
	    return this.client.createRoom({
	        preset: "private_chat",
	        invite: [this.confUserId]
	    }).then(function (res) {
	        return new Room(res.room_id);
	    });
	};
	
	/**
	 * Check if this user ID is in fact a conference bot.
	 * @param {string} userId The user ID to check.
	 * @return {boolean} True if it is a conference bot.
	 */
	module.exports.isConferenceUser = function (userId) {
	    if (userId.indexOf("@" + USER_PREFIX) !== 0) {
	        return false;
	    }
	    var base64part = userId.split(":")[0].substring(1 + USER_PREFIX.length);
	    if (base64part) {
	        var decoded = new Buffer(base64part, "base64").toString();
	        // ! $STUFF : $STUFF
	        return (/^!.+:.+/.test(decoded)
	        );
	    }
	    return false;
	};
	
	module.exports.getConferenceUserIdForRoom = function (roomId) {
	    // abuse browserify's core node Buffer support (strip padding ='s)
	    var base64RoomId = new Buffer(roomId).toString("base64").replace(/=/g, "");
	    return "@" + USER_PREFIX + base64RoomId + ":" + DOMAIN;
	};
	
	module.exports.createNewMatrixCall = function (client, roomId) {
	    var confCall = new ConferenceCall(client, roomId);
	    return confCall.setup();
	};
	
	module.exports.getConferenceCallForRoom = function (roomId) {
	    // search for a conference 1:1 call for this group chat room ID
	    var activeCall = CallHandler.getAnyActiveCall();
	    if (activeCall && activeCall.confUserId) {
	        var thisRoomConfUserId = module.exports.getConferenceUserIdForRoom(roomId);
	        if (thisRoomConfUserId === activeCall.confUserId) {
	            return activeCall;
	        }
	    }
	    return null;
	};
	
	module.exports.ConferenceCall = ConferenceCall;
	
	module.exports.slot = 'conference';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88).Buffer))

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var NotificationUtils = __webpack_require__(235);
	
	var encodeActions = NotificationUtils.encodeActions;
	
	module.exports = {
	    ACTION_NOTIFY: encodeActions({ notify: true }),
	    ACTION_NOTIFY_DEFAULT_SOUND: encodeActions({ notify: true, sound: "default" }),
	    ACTION_NOTIFY_RING_SOUND: encodeActions({ notify: true, sound: "ring" }),
	    ACTION_HIGHLIGHT_DEFAULT_SOUND: encodeActions({ notify: true, sound: "default", highlight: true }),
	    ACTION_DONT_NOTIFY: encodeActions({ notify: false }),
	    ACTION_DISABLED: null
	};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.instanceForInstanceId = instanceForInstanceId;
	exports.protocolNameForInstanceId = protocolNameForInstanceId;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Find a protocol 'instance' with a given instance_id
	// in the supplied protocols dict
	function instanceForInstanceId(protocols, instance_id) {
	    if (!instance_id) return null;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(protocols)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var proto = _step.value;
	
	            if (!protocols[proto].instances && protocols[proto].instances instanceof Array) continue;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = (0, _getIterator3.default)(protocols[proto].instances), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var instance = _step2.value;
	
	                    if (instance.instance_id == instance_id) return instance;
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	// given an instance_id, return the name of the protocol for
	// that instance ID in the supplied protocols dict
	function protocolNameForInstanceId(protocols, instance_id) {
	    if (!instance_id) return null;
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(protocols)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var proto = _step3.value;
	
	            if (!protocols[proto].instances && protocols[proto].instances instanceof Array) continue;
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = (0, _getIterator3.default)(protocols[proto].instances), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var instance = _step4.value;
	
	                    if (instance.instance_id == instance_id) return proto;
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _BasePlatform2 = __webpack_require__(1155);
	
	var _BasePlatform3 = _interopRequireDefault(_BasePlatform2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Vector-specific extensions to the BasePlatform template
	 */
	var VectorBasePlatform = function (_BasePlatform) {
	  (0, _inherits3.default)(VectorBasePlatform, _BasePlatform);
	
	  function VectorBasePlatform() {
	    (0, _classCallCheck3.default)(this, VectorBasePlatform);
	    return (0, _possibleConstructorReturn3.default)(this, (VectorBasePlatform.__proto__ || (0, _getPrototypeOf2.default)(VectorBasePlatform)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VectorBasePlatform, [{
	    key: "pollForUpdate",
	
	    /**
	     * Check for the availability of an update to the version of the
	     * app that's currently running.
	     * If an update is available, this function should dispatch the
	     * 'new_version' action.
	     */
	    value: function pollForUpdate() {}
	
	    /**
	     * Update the currently running app to the latest available
	     * version and replace this instance of the app with the
	     * new version.
	     */
	
	  }, {
	    key: "installUpdate",
	    value: function installUpdate() {}
	
	    /**
	     * Get a sensible default display name for the
	     * device Vector is running on
	     */
	
	  }, {
	    key: "getDefaultDeviceDisplayName",
	    value: function getDefaultDeviceDisplayName() {
	      return "Unknown device";
	    }
	  }]);
	  return VectorBasePlatform;
	}(_BasePlatform3.default);
	
	/*
	Copyright 2016 Aviral Dasgupta
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = VectorBasePlatform;
	module.exports = exports["default"];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _PlatformPeg = __webpack_require__(93);
	
	var _PlatformPeg2 = _interopRequireDefault(_PlatformPeg);
	
	var _browserRequest = __webpack_require__(97);
	
	var _browserRequest2 = _interopRequireDefault(_browserRequest);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This module contains all the code needed to log the console, persist it to
	// disk and submit bug reports. Rationale is as follows:
	//  - Monkey-patching the console is preferable to having a log library because
	//    we can catch logs by other libraries more easily, without having to all
	//    depend on the same log framework / pass the logger around.
	//  - We use IndexedDB to persists logs because it has generous disk space
	//    limits compared to local storage. IndexedDB does not work in incognito
	//    mode, in which case this module will not be able to write logs to disk.
	//    However, the logs will still be stored in-memory, so can still be
	//    submitted in a bug report should the user wish to: we can also store more
	//    logs in-memory than in local storage, which does work in incognito mode.
	//    We also need to handle the case where there are 2+ tabs. Each JS runtime
	//    generates a random string which serves as the "ID" for that tab/session.
	//    These IDs are stored along with the log lines.
	//  - Bug reports are sent as a POST over HTTPS: it purposefully does not use
	//    Matrix as bug reports may be made when Matrix is not responsive (which may
	//    be the cause of the bug). We send the most recent N MB of UTF-8 log data,
	//    starting with the most recent, which we know because the "ID"s are
	//    actually timestamps. We then purge the remaining logs. We also do this
	//    purge on startup to prevent logs from accumulating.
	
	var FLUSH_RATE_MS = 30 * 1000;
	
	// A class which monkey-patches the global console and stores log lines.
	/*
	Copyright 2017 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var ConsoleLogger = function () {
	    function ConsoleLogger() {
	        (0, _classCallCheck3.default)(this, ConsoleLogger);
	
	        this.logs = "";
	    }
	
	    (0, _createClass3.default)(ConsoleLogger, [{
	        key: "monkeyPatch",
	        value: function monkeyPatch(consoleObj) {
	            var _this = this;
	
	            // Monkey-patch console logging
	            var consoleFunctionsToLevels = {
	                log: "I",
	                info: "I",
	                warn: "W",
	                error: "E"
	            };
	            (0, _keys2.default)(consoleFunctionsToLevels).forEach(function (fnName) {
	                var level = consoleFunctionsToLevels[fnName];
	                var originalFn = consoleObj[fnName].bind(consoleObj);
	                consoleObj[fnName] = function () {
	                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                        args[_key] = arguments[_key];
	                    }
	
	                    _this.log.apply(_this, [level].concat(args));
	                    originalFn.apply(undefined, args);
	                };
	            });
	        }
	    }, {
	        key: "log",
	        value: function log(level) {
	            // We don't know what locale the user may be running so use ISO strings
	            var ts = new Date().toISOString();
	            // Some browsers support string formatting which we're not doing here
	            // so the lines are a little more ugly but easy to implement / quick to
	            // run.
	            // Example line:
	            // 2017-01-18T11:23:53.214Z W Failed to set badge count
	
	            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	                args[_key2 - 1] = arguments[_key2];
	            }
	
	            var line = ts + " " + level + " " + args.join(' ') + "\n";
	            // Using + really is the quickest way in JS
	            // http://jsperf.com/concat-vs-plus-vs-join
	            this.logs += line;
	        }
	
	        /**
	         * Retrieve log lines to flush to disk.
	         * @param {boolean} keepLogs True to not delete logs after flushing.
	         * @return {string} \n delimited log lines to flush.
	         */
	
	    }, {
	        key: "flush",
	        value: function flush(keepLogs) {
	            // The ConsoleLogger doesn't care how these end up on disk, it just
	            // flushes them to the caller.
	            if (keepLogs) {
	                return this.logs;
	            }
	            var logsToFlush = this.logs;
	            this.logs = "";
	            return logsToFlush;
	        }
	    }]);
	    return ConsoleLogger;
	}();
	
	// A class which stores log lines in an IndexedDB instance.
	
	
	var IndexedDBLogStore = function () {
	    function IndexedDBLogStore(indexedDB, logger) {
	        (0, _classCallCheck3.default)(this, IndexedDBLogStore);
	
	        this.indexedDB = indexedDB;
	        this.logger = logger;
	        this.id = "instance-" + Math.random() + Date.now();
	        this.index = 0;
	        this.db = null;
	        this.flushPromise = null;
	        // set if flush() is called whilst one is ongoing
	        this.flushAgainPromise = null;
	    }
	
	    /**
	     * @return {Promise} Resolves when the store is ready.
	     */
	
	
	    (0, _createClass3.default)(IndexedDBLogStore, [{
	        key: "connect",
	        value: function connect() {
	            var _this2 = this;
	
	            var req = this.indexedDB.open("logs");
	            return _q2.default.Promise(function (resolve, reject) {
	                req.onsuccess = function (event) {
	                    _this2.db = event.target.result;
	                    // Periodically flush logs to local storage / indexeddb
	                    setInterval(_this2.flush.bind(_this2), FLUSH_RATE_MS);
	                    resolve();
	                };
	
	                req.onerror = function (event) {
	                    var err = "Failed to open log database: " + event.target.errorCode;
	                    console.error(err);
	                    reject(new Error(err));
	                };
	
	                // First time: Setup the object store
	                req.onupgradeneeded = function (event) {
	                    var db = event.target.result;
	                    var logObjStore = db.createObjectStore("logs", {
	                        keyPath: ["id", "index"]
	                    });
	                    // Keys in the database look like: [ "instance-148938490", 0 ]
	                    // Later on we need to query everything based on an instance id.
	                    // In order to do this, we need to set up indexes "id".
	                    logObjStore.createIndex("id", "id", { unique: false });
	
	                    logObjStore.add(_this2._generateLogEntry(new Date() + " ::: Log database was created."));
	
	                    var lastModifiedStore = db.createObjectStore("logslastmod", {
	                        keyPath: "id"
	                    });
	                    lastModifiedStore.add(_this2._generateLastModifiedTime());
	                };
	            });
	        }
	
	        /**
	         * Flush logs to disk.
	         *
	         * There are guards to protect against race conditions in order to ensure
	         * that all previous flushes have completed before the most recent flush.
	         * Consider without guards:
	         *  - A calls flush() periodically.
	         *  - B calls flush() and wants to send logs immediately afterwards.
	         *  - If B doesn't wait for A's flush to complete, B will be missing the
	         *    contents of A's flush.
	         * To protect against this, we set 'flushPromise' when a flush is ongoing.
	         * Subsequent calls to flush() during this period will chain another flush,
	         * then keep returning that same chained flush.
	         *
	         * This guarantees that we will always eventually do a flush when flush() is
	         * called.
	         *
	         * @return {Promise} Resolved when the logs have been flushed.
	         */
	
	    }, {
	        key: "flush",
	        value: function flush() {
	            var _this3 = this;
	
	            // check if a flush() operation is ongoing
	            if (this.flushPromise && this.flushPromise.isPending()) {
	                if (this.flushAgainPromise && this.flushAgainPromise.isPending()) {
	                    // this is the 3rd+ time we've called flush() : return the same
	                    // promise.
	                    return this.flushAgainPromise;
	                }
	                // queue up a flush to occur immediately after the pending one
	                // completes.
	                this.flushAgainPromise = this.flushPromise.then(function () {
	                    return _this3.flush();
	                });
	                return this.flushAgainPromise;
	            }
	            // there is no flush promise or there was but it has finished, so do
	            // a brand new one, destroying the chain which may have been built up.
	            this.flushPromise = _q2.default.Promise(function (resolve, reject) {
	                if (!_this3.db) {
	                    // not connected yet or user rejected access for us to r/w to
	                    // the db.
	                    reject(new Error("No connected database"));
	                    return;
	                }
	                var lines = _this3.logger.flush();
	                if (lines.length === 0) {
	                    resolve();
	                    return;
	                }
	                var txn = _this3.db.transaction(["logs", "logslastmod"], "readwrite");
	                var objStore = txn.objectStore("logs");
	                objStore.add(_this3._generateLogEntry(lines));
	                var lastModStore = txn.objectStore("logslastmod");
	                lastModStore.put(_this3._generateLastModifiedTime());
	                txn.oncomplete = function (event) {
	                    resolve();
	                };
	                txn.onerror = function (event) {
	                    console.error("Failed to flush logs : ", event);
	                    reject(new Error("Failed to write logs: " + event.target.errorCode));
	                };
	            });
	            return this.flushPromise;
	        }
	
	        /**
	         * Consume the most recent logs and return them. Older logs which are not
	         * returned are deleted at the same time, so this can be called at startup
	         * to do house-keeping to keep the logs from growing too large.
	         *
	         * @return {Promise<Object[]>} Resolves to an array of objects. The array is
	         * sorted in time (oldest first) based on when the log file was created (the
	         * log ID). The objects have said log ID in an "id" field and "lines" which
	         * is a big string with all the new-line delimited logs.
	         */
	
	    }, {
	        key: "consume",
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                var MAX_LOG_SIZE, db, fetchLogs, fetchLogIds, deleteLogs, allLogIds, removeLogIds, logs, size, i, lines;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                deleteLogs = function deleteLogs(id) {
	                                    return _q2.default.Promise(function (resolve, reject) {
	                                        var txn = db.transaction(["logs", "logslastmod"], "readwrite");
	                                        var o = txn.objectStore("logs");
	                                        // only load the key path, not the data which may be huge
	                                        var query = o.index("id").openKeyCursor(IDBKeyRange.only(id));
	                                        query.onsuccess = function (event) {
	                                            var cursor = event.target.result;
	                                            if (!cursor) {
	                                                return;
	                                            }
	                                            o.delete(cursor.primaryKey);
	                                            cursor.continue();
	                                        };
	                                        txn.oncomplete = function () {
	                                            resolve();
	                                        };
	                                        txn.onerror = function (event) {
	                                            reject(new Error("Failed to delete logs for " + ("'" + id + "' : " + event.target.errorCode)));
	                                        };
	                                        // delete last modified entries
	                                        var lastModStore = txn.objectStore("logslastmod");
	                                        lastModStore.delete(id);
	                                    });
	                                };
	
	                                fetchLogIds = function fetchLogIds() {
	                                    // To gather all the log IDs, query for all records in logslastmod.
	                                    var o = db.transaction("logslastmod", "readonly").objectStore("logslastmod");
	                                    return selectQuery(o, undefined, function (cursor) {
	                                        return {
	                                            id: cursor.value.id,
	                                            ts: cursor.value.ts
	                                        };
	                                    }).then(function (res) {
	                                        // Sort IDs by timestamp (newest first)
	                                        return res.sort(function (a, b) {
	                                            return b.ts - a.ts;
	                                        }).map(function (a) {
	                                            return a.id;
	                                        });
	                                    });
	                                };
	
	                                fetchLogs = function fetchLogs(id) {
	                                    var o = db.transaction("logs", "readonly").objectStore("logs");
	                                    return selectQuery(o.index("id"), IDBKeyRange.only(id), function (cursor) {
	                                        return {
	                                            lines: cursor.value.lines,
	                                            index: cursor.value.index
	                                        };
	                                    }).then(function (linesArray) {
	                                        // We have been storing logs periodically, so string them all
	                                        // together *in order of index* now
	                                        linesArray.sort(function (a, b) {
	                                            return a.index - b.index;
	                                        });
	                                        return linesArray.map(function (l) {
	                                            return l.lines;
	                                        }).join("");
	                                    });
	                                };
	
	                                MAX_LOG_SIZE = 1024 * 1024 * 50; // 50 MB
	
	                                db = this.db;
	
	                                // Returns: a string representing the concatenated logs for this ID.
	
	
	                                // Returns: A sorted array of log IDs. (newest first)
	
	                                _context.next = 7;
	                                return fetchLogIds();
	
	                            case 7:
	                                allLogIds = _context.sent;
	                                removeLogIds = [];
	                                logs = [];
	                                size = 0;
	                                i = 0;
	
	                            case 12:
	                                if (!(i < allLogIds.length)) {
	                                    _context.next = 24;
	                                    break;
	                                }
	
	                                _context.next = 15;
	                                return fetchLogs(allLogIds[i]);
	
	                            case 15:
	                                lines = _context.sent;
	
	                                if (!(i > 0 && size + lines.length > MAX_LOG_SIZE)) {
	                                    _context.next = 19;
	                                    break;
	                                }
	
	                                // the remaining log IDs should be removed. If we go out of
	                                // bounds this is just []
	                                //
	                                // XXX: there's nothing stopping the current session exceeding
	                                // MAX_LOG_SIZE. We ought to think about culling it.
	                                removeLogIds = allLogIds.slice(i + 1);
	                                return _context.abrupt("break", 24);
	
	                            case 19:
	
	                                logs.push({
	                                    lines: lines,
	                                    id: allLogIds[i]
	                                });
	                                size += lines.length;
	
	                            case 21:
	                                i++;
	                                _context.next = 12;
	                                break;
	
	                            case 24:
	                                if (removeLogIds.length > 0) {
	                                    console.log("Removing logs: ", removeLogIds);
	                                    // Don't await this because it's non-fatal if we can't clean up
	                                    // logs.
	                                    _promise2.default.all(removeLogIds.map(function (id) {
	                                        return deleteLogs(id);
	                                    })).then(function () {
	                                        console.log("Removed " + removeLogIds.length + " old logs.");
	                                    }, function (err) {
	                                        console.error(err);
	                                    });
	                                }
	                                return _context.abrupt("return", logs);
	
	                            case 26:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function consume() {
	                return _ref.apply(this, arguments);
	            }
	
	            return consume;
	        }()
	    }, {
	        key: "_generateLogEntry",
	        value: function _generateLogEntry(lines) {
	            return {
	                id: this.id,
	                lines: lines,
	                index: this.index++
	            };
	        }
	    }, {
	        key: "_generateLastModifiedTime",
	        value: function _generateLastModifiedTime() {
	            return {
	                id: this.id,
	                ts: Date.now()
	            };
	        }
	    }]);
	    return IndexedDBLogStore;
	}();
	
	/**
	 * Helper method to collect results from a Cursor and promiseify it.
	 * @param {ObjectStore|Index} store The store to perform openCursor on.
	 * @param {IDBKeyRange=} keyRange Optional key range to apply on the cursor.
	 * @param {Function} resultMapper A function which is repeatedly called with a
	 * Cursor.
	 * Return the data you want to keep.
	 * @return {Promise<T[]>} Resolves to an array of whatever you returned from
	 * resultMapper.
	 */
	
	
	function selectQuery(store, keyRange, resultMapper) {
	    var query = store.openCursor(keyRange);
	    return _q2.default.Promise(function (resolve, reject) {
	        var results = [];
	        query.onerror = function (event) {
	            reject(new Error("Query failed: " + event.target.errorCode));
	        };
	        // collect results
	        query.onsuccess = function (event) {
	            var cursor = event.target.result;
	            if (!cursor) {
	                resolve(results);
	                return; // end of results
	            }
	            results.push(resultMapper(cursor));
	            cursor.continue();
	        };
	    });
	}
	
	var store = null;
	var logger = null;
	var initPromise = null;
	var bugReportEndpoint = null;
	module.exports = {
	
	    /**
	     * Configure rage shaking support for sending bug reports.
	     * Modifies globals.
	     * @return {Promise} Resolves when set up.
	     */
	    init: function init() {
	        if (initPromise) {
	            return initPromise;
	        }
	        logger = new ConsoleLogger();
	        logger.monkeyPatch(window.console);
	        if (window.indexedDB) {
	            store = new IndexedDBLogStore(window.indexedDB, logger);
	            initPromise = store.connect();
	            return initPromise;
	        }
	        initPromise = _promise2.default.resolve();
	        return initPromise;
	    },
	
	    /**
	     * Clean up old logs.
	     * @return Promise Resolves if cleaned logs.
	     */
	    cleanup: function () {
	        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (store) {
	                                _context2.next = 2;
	                                break;
	                            }
	
	                            return _context2.abrupt("return");
	
	                        case 2:
	                            _context2.next = 4;
	                            return store.consume();
	
	                        case 4:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function cleanup() {
	            return _ref2.apply(this, arguments);
	        }
	
	        return cleanup;
	    }(),
	
	    setBugReportEndpoint: function setBugReportEndpoint(url) {
	        bugReportEndpoint = url;
	    },
	
	    /**
	     * Send a bug report.
	     * @param {string} userText Any additional user input.
	     * @param {boolean} sendLogs True to send logs
	     * @return {Promise} Resolved when the bug report is sent.
	     */
	    sendBugReport: function () {
	        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(userText, sendLogs) {
	            var version, userAgent, logs;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (logger) {
	                                _context3.next = 2;
	                                break;
	                            }
	
	                            throw new Error("No console logger, did you forget to call init()?");
	
	                        case 2:
	                            if (bugReportEndpoint) {
	                                _context3.next = 4;
	                                break;
	                            }
	
	                            throw new Error("No bug report endpoint has been set.");
	
	                        case 4:
	                            version = "UNKNOWN";
	                            _context3.prev = 5;
	                            _context3.next = 8;
	                            return _PlatformPeg2.default.get().getAppVersion();
	
	                        case 8:
	                            version = _context3.sent;
	                            _context3.next = 13;
	                            break;
	
	                        case 11:
	                            _context3.prev = 11;
	                            _context3.t0 = _context3["catch"](5);
	
	                        case 13:
	                            // PlatformPeg already logs this.
	
	                            userAgent = "UNKNOWN";
	
	                            if (window.navigator && window.navigator.userAgent) {
	                                userAgent = window.navigator.userAgent;
	                            }
	
	                            // If in incognito mode, store is null, but we still want bug report
	                            // sending to work going off the in-memory console logs.
	                            console.log("Sending bug report.");
	                            logs = [];
	
	                            if (!sendLogs) {
	                                _context3.next = 27;
	                                break;
	                            }
	
	                            if (!store) {
	                                _context3.next = 26;
	                                break;
	                            }
	
	                            _context3.next = 21;
	                            return store.flush();
	
	                        case 21:
	                            _context3.next = 23;
	                            return store.consume();
	
	                        case 23:
	                            logs = _context3.sent;
	                            _context3.next = 27;
	                            break;
	
	                        case 26:
	                            logs.push({
	                                lines: logger.flush(true),
	                                id: "-"
	                            });
	
	                        case 27:
	                            _context3.next = 29;
	                            return _q2.default.Promise(function (resolve, reject) {
	                                (0, _browserRequest2.default)({
	                                    method: "POST",
	                                    url: bugReportEndpoint,
	                                    body: {
	                                        logs: logs,
	                                        text: userText || "User did not supply any additional text.",
	                                        app: 'riot-web',
	                                        version: version,
	                                        user_agent: userAgent
	                                    },
	                                    json: true,
	                                    timeout: 5 * 60 * 1000
	                                }, function (err, res) {
	                                    if (err) {
	                                        reject(err);
	                                        return;
	                                    }
	                                    if (res.status < 200 || res.status >= 400) {
	                                        reject(new Error("HTTP " + res.status));
	                                        return;
	                                    }
	                                    resolve();
	                                });
	                            });
	
	                        case 29:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[5, 11]]);
	        }));
	
	        function sendBugReport(_x, _x2) {
	            return _ref3.apply(this, arguments);
	        }
	
	        return sendBugReport;
	    }()
	};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	/* Copyright 2015 Mark Haines
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	'use strict';
	
	var escaped = /[\\\"\x00-\x1F]/g;
	var escapes = {};
	for (var i = 0; i < 0x20; ++i) {
	    escapes[String.fromCharCode(i)] = (
	        '\\U' + ('0000' + i.toString(16)).slice(-4).toUpperCase()
	    );
	}
	escapes['\b'] = '\\b';
	escapes['\t'] = '\\t';
	escapes['\n'] = '\\n';
	escapes['\f'] = '\\f';
	escapes['\r'] = '\\r';
	escapes['\"'] = '\\\"';
	escapes['\\'] = '\\\\';
	
	function escapeString(value) {
	    escaped.lastIndex = 0;
	    return value.replace(escaped, function(c) { return escapes[c]; });
	}
	
	function stringify(value) {
	    switch (typeof value) {
	        case 'string':
	            return '"' + escapeString(value) + '"';
	        case 'number':
	            return isFinite(value) ? value : 'null';
	        case 'boolean':
	            return value;
	        case 'object':
	            if (value === null) {
	                return 'null';
	            }
	            if (Array.isArray(value)) {
	                return stringifyArray(value);
	            }
	            return stringifyObject(value);
	        default:
	            throw new Error('Cannot stringify: ' + typeof value);
	    }
	}
	
	function stringifyArray(array) {
	    var sep = '[';
	    var result = '';
	    for (var i = 0; i < array.length; ++i) {
	        result += sep;
	        sep = ',';
	        result += stringify(array[i]);
	    }
	    if (sep != ',') {
	        return '[]';
	    } else {
	        return result + ']';
	    }
	}
	
	function stringifyObject(object) {
	    var sep = '{';
	    var result = '';
	    var keys = Object.keys(object);
	    keys.sort();
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        result += sep + '"' + escapeString(key) + '":';
	        sep = ',';
	        result += stringify(object[key]);
	    }
	    if (sep != ',') {
	        return '{}';
	    } else {
	        return result + '}';
	    }
	}
	
	/** */
	module.exports = {stringify: stringify};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(642), __esModule: true };

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(648), __esModule: true };

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(658), __esModule: true };

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(613);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * Encrypt an attachment.
	 * @param {ArrayBuffer} plaintextBuffer The attachment data buffer.
	 * @return {Promise} A promise that resolves with an object when the attachment is encrypted.
	 *      The object has a "data" key with an ArrayBuffer of encrypted data and an "info" key
	 *      with an object containing the info needed to decrypt the data.
	 */
	function encryptAttachment(plaintextBuffer) {
	    var cryptoKey; // The AES key object.
	    var exportedKey; // The AES key exported as JWK.
	    var ciphertextBuffer; // ArrayBuffer of encrypted data.
	    var sha256Buffer; // ArrayBuffer of digest.
	    var ivArray; // Uint8Array of AES IV
	    // Generate an IV where the first 8 bytes are random and the high 8 bytes
	    // are zero. We set the counter low bits to 0 since it makes it unlikely
	    // that the 64 bit counter will overflow.
	    ivArray = new Uint8Array(16);
	    window.crypto.getRandomValues(ivArray.subarray(0,8));
	    // Load the encryption key.
	    return window.crypto.subtle.generateKey(
	        {"name": "AES-CTR", length: 256}, true, ["encrypt", "decrypt"]
	    ).then(function(generateKeyResult) {
	        cryptoKey = generateKeyResult;
	        // Export the Key as JWK.
	        return window.crypto.subtle.exportKey("jwk", cryptoKey);
	    }).then(function(exportKeyResult) {
	        exportedKey = exportKeyResult;
	        // Encrypt the input ArrayBuffer.
	        // Use half of the iv as the counter by setting the "length" to 64.
	        return window.crypto.subtle.encrypt(
	            {name: "AES-CTR", counter: ivArray, length: 64}, cryptoKey, plaintextBuffer
	        );
	    }).then(function(encryptResult) {
	        ciphertextBuffer = encryptResult;
	        // SHA-256 the encrypted data.
	        return window.crypto.subtle.digest("SHA-256", ciphertextBuffer);
	    }).then(function (digestResult) {
	        sha256Buffer = digestResult;
	
	        return {
	            data: ciphertextBuffer,
	            info: {
	                v: "v2",
	                key: exportedKey,
	                iv: encodeBase64(ivArray),
	                hashes: {
	                    sha256: encodeBase64(new Uint8Array(sha256Buffer)),
	                },
	            },
	        };
	    });
	}
	
	/**
	 * Decrypt an attachment.
	 * @param {ArrayBuffer} ciphertextBuffer The encrypted attachment data buffer.
	 * @param {Object} info The information needed to decrypt the attachment.
	 * @param {Object} info.key AES-CTR JWK key object.
	 * @param {string} info.iv Base64 encoded 16 byte AES-CTR IV.
	 * @param {string} info.hashes.sha256 Base64 encoded SHA-256 hash of the ciphertext.
	 * @return {Promise} A promise that resolves with an ArrayBuffer when the attachment is decrypted.
	 */
	function decryptAttachment(ciphertextBuffer, info) {
	
	    if (info === undefined || info.key === undefined || info.iv === undefined
	        || info.hashes === undefined || info.hashes.sha256 === undefined) {
	       throw new Error("Invalid info. Missing info.key, info.iv or info.hashes.sha256 key");
	    }
	
	    var cryptoKey; // The AES key object.
	    var ivArray = decodeBase64(info.iv);
	    var expectedSha256base64 = info.hashes.sha256;
	    // Load the AES from the "key" key of the info object.
	    return window.crypto.subtle.importKey(
	        "jwk", info.key, {"name": "AES-CTR"}, false, ["encrypt", "decrypt"]
	    ).then(function (importKeyResult) {
	        cryptoKey = importKeyResult;
	        // Check the sha256 hash
	        return window.crypto.subtle.digest("SHA-256", ciphertextBuffer);
	    }).then(function (digestResult) {
	        if (encodeBase64(new Uint8Array(digestResult)) != expectedSha256base64) {
	            throw new Error("Mismatched SHA-256 digest");
	        }
	        var counterLength;
	        if (info.v == "v1" || info.v == "v2") {
	            // Version 1 and 2 use a 64 bit counter.
	            counterLength = 64;
	        } else {
	            // Version 0 uses a 128 bit counter.
	            counterLength = 128;
	        }
	        return window.crypto.subtle.decrypt(
	            {name: "AES-CTR", counter: ivArray, length: counterLength}, cryptoKey, ciphertextBuffer
	        );
	    });
	}
	
	/**
	 * Encode a typed array of uint8 as base64.
	 * @param {Uint8Array} uint8Array The data to encode.
	 * @return {string} The base64 without padding.
	 */
	function encodeBase64(uint8Array) {
	    // Misinterpt the Uint8Array as Latin-1.
	    // window.btoa expects a unicode string with codepoints in the range 0-255.
	    var latin1String = String.fromCharCode.apply(null, uint8Array);
	    // Use the builtin base64 encoder.
	    var paddedBase64 = window.btoa(latin1String);
	    // Calculate the unpadded length.
	    var inputLength = uint8Array.length;
	    var outputLength = 4 * Math.floor((inputLength + 2) / 3) + (inputLength + 2) % 3 - 2;
	    // Return the unpadded base64.
	    return paddedBase64.slice(0, outputLength);
	}
	
	/**
	 * Decode a base64 string to a typed array of uint8.
	 * This will decode unpadded base64, but will also accept base64 with padding.
	 * @param {string} base64 The unpadded base64 to decode.
	 * @return {Uint8Array} The decoded data.
	 */
	function decodeBase64(base64) {
	    // Pad the base64 up to the next multiple of 4.
	    var paddedBase64 = base64 + "===".slice(0, (4 - base64.length % 4) % 4);
	    // Decode the base64 as a misinterpreted Latin-1 string.
	    // window.atob returns a unicode string with codepoints in the range 0-255.
	    var latin1String = window.atob(paddedBase64);
	    // Encode the string as a Uint8Array as Latin-1.
	    var uint8Array = new Uint8Array(latin1String.length);
	    for (var i = 0; i < latin1String.length; i++) {
	        uint8Array[i] = latin1String.charCodeAt(i);
	    }
	    return uint8Array;
	}
	
	try {
	    exports.encryptAttachment = encryptAttachment;
	    exports.decryptAttachment = decryptAttachment;
	}
	catch (e) {
	    // Ignore unknown variable "exports" errors when this is loaded directly into a browser
	    // This means that we can test it without having to use browserify.
	    // The intention is that the library is used using browserify.
	}


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(53).document && document.documentElement;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(77) && !__webpack_require__(126)(function(){
	  return Object.defineProperty(__webpack_require__(245)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(150);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(127)
	  , ITERATOR   = __webpack_require__(39)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(76);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(182)
	  , $export        = __webpack_require__(45)
	  , redefine       = __webpack_require__(390)
	  , hide           = __webpack_require__(99)
	  , has            = __webpack_require__(98)
	  , Iterators      = __webpack_require__(127)
	  , $iterCreate    = __webpack_require__(671)
	  , setToStringTag = __webpack_require__(184)
	  , getPrototypeOf = __webpack_require__(388)
	  , ITERATOR       = __webpack_require__(39)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(39)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(78)
	  , anObject = __webpack_require__(76)
	  , getKeys  = __webpack_require__(100);
	
	module.exports = __webpack_require__(77) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(79)
	  , gOPN      = __webpack_require__(387).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(389)
	  , hiddenKeys = __webpack_require__(246).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(98)
	  , toObject    = __webpack_require__(153)
	  , IE_PROTO    = __webpack_require__(250)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(98)
	  , toIObject    = __webpack_require__(79)
	  , arrayIndexOf = __webpack_require__(664)(false)
	  , IE_PROTO     = __webpack_require__(250)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(99);

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(125)
	  , invoke             = __webpack_require__(668)
	  , html               = __webpack_require__(378)
	  , cel                = __webpack_require__(245)
	  , global             = __webpack_require__(53)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(150)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 392 */
/***/ (function(module, exports) {



/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(60);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(36)
	  , toIndex  = __webpack_require__(108)
	  , toLength = __webpack_require__(35);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(129);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(47)
	  , toObject  = __webpack_require__(36)
	  , IObject   = __webpack_require__(156)
	  , toLength  = __webpack_require__(35);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(47)
	  , isObject   = __webpack_require__(25)
	  , invoke     = __webpack_require__(191)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(32).f
	  , create      = __webpack_require__(103)
	  , redefineAll = __webpack_require__(106)
	  , ctx         = __webpack_require__(81)
	  , anInstance  = __webpack_require__(101)
	  , defined     = __webpack_require__(61)
	  , forOf       = __webpack_require__(129)
	  , $iterDefine = __webpack_require__(268)
	  , step        = __webpack_require__(404)
	  , setSpecies  = __webpack_require__(107)
	  , DESCRIPTORS = __webpack_require__(31)
	  , fastKey     = __webpack_require__(89).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(155)
	  , from    = __webpack_require__(395);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(106)
	  , getWeak           = __webpack_require__(89).getWeak
	  , anObject          = __webpack_require__(11)
	  , isObject          = __webpack_require__(25)
	  , anInstance        = __webpack_require__(101)
	  , forOf             = __webpack_require__(129)
	  , createArrayMethod = __webpack_require__(67)
	  , $has              = __webpack_require__(40)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(31) && !__webpack_require__(17)(function(){
	  return Object.defineProperty(__webpack_require__(260)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(25)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(11);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(105)
	  , gOPS     = __webpack_require__(195)
	  , pIE      = __webpack_require__(157)
	  , toObject = __webpack_require__(36)
	  , IObject  = __webpack_require__(156)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(17)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(32)
	  , anObject = __webpack_require__(11)
	  , getKeys  = __webpack_require__(105);
	
	module.exports = __webpack_require__(31) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(51)
	  , gOPN      = __webpack_require__(104).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(40)
	  , toIObject    = __webpack_require__(51)
	  , arrayIndexOf = __webpack_require__(187)(false)
	  , IE_PROTO     = __webpack_require__(273)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(105)
	  , toIObject = __webpack_require__(51)
	  , isEnum    = __webpack_require__(157).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(104)
	  , gOPS     = __webpack_require__(195)
	  , anObject = __webpack_require__(11)
	  , Reflect  = __webpack_require__(13).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(13).parseFloat
	  , $trim       = __webpack_require__(132).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(278) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(13).parseInt
	  , $trim     = __webpack_require__(132).trim
	  , ws        = __webpack_require__(278)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(35)
	  , repeat   = __webpack_require__(277)
	  , defined  = __webpack_require__(61);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(29);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(398);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(188)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(31) && /./g.flags != 'g')__webpack_require__(32).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(190)
	});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(398);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(188)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(67)(0)
	  , redefine     = __webpack_require__(49)
	  , meta         = __webpack_require__(89)
	  , assign       = __webpack_require__(406)
	  , weak         = __webpack_require__(400)
	  , isObject     = __webpack_require__(25)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(188)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dirtyHandlerIds;
	exports.areDirty = areDirty;
	
	var _xor = __webpack_require__(1132);
	
	var _xor2 = _interopRequireDefault(_xor);
	
	var _intersection = __webpack_require__(1124);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _dragDrop = __webpack_require__(198);
	
	var _registry = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NONE = [];
	var ALL = [];
	
	function dirtyHandlerIds() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
	  var action = arguments[1];
	  var dragOperation = arguments[2];
	
	  switch (action.type) {
	    case _dragDrop.HOVER:
	      break;
	    case _registry.ADD_SOURCE:
	    case _registry.ADD_TARGET:
	    case _registry.REMOVE_TARGET:
	    case _registry.REMOVE_SOURCE:
	      return NONE;
	    case _dragDrop.BEGIN_DRAG:
	    case _dragDrop.PUBLISH_DRAG_SOURCE:
	    case _dragDrop.END_DRAG:
	    case _dragDrop.DROP:
	    default:
	      return ALL;
	  }
	
	  var targetIds = action.targetIds;
	  var prevTargetIds = dragOperation.targetIds;
	
	  var result = (0, _xor2.default)(targetIds, prevTargetIds);
	
	  var didChange = false;
	  if (result.length === 0) {
	    for (var i = 0; i < targetIds.length; i++) {
	      if (targetIds[i] !== prevTargetIds[i]) {
	        didChange = true;
	        break;
	      }
	    }
	  } else {
	    didChange = true;
	  }
	
	  if (!didChange) {
	    return NONE;
	  }
	
	  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	  var innermostTargetId = targetIds[targetIds.length - 1];
	
	  if (prevInnermostTargetId !== innermostTargetId) {
	    if (prevInnermostTargetId) {
	      result.push(prevInnermostTargetId);
	    }
	    if (innermostTargetId) {
	      result.push(innermostTargetId);
	    }
	  }
	
	  return result;
	}
	
	function areDirty(state, handlerIds) {
	  if (state === NONE) {
	    return false;
	  }
	
	  if (state === ALL || typeof handlerIds === 'undefined') {
	    return true;
	  }
	
	  return (0, _intersection2.default)(handlerIds, state).length > 0;
	}

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOffset;
	exports.getSourceClientOffset = getSourceClientOffset;
	exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
	var _dragDrop = __webpack_require__(198);
	
	var initialState = {
	  initialSourceClientOffset: null,
	  initialClientOffset: null,
	  clientOffset: null
	};
	
	function areOffsetsEqual(offsetA, offsetB) {
	  if (offsetA === offsetB) {
	    return true;
	  }
	  return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	}
	
	function dragOffset() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _dragDrop.BEGIN_DRAG:
	      return {
	        initialSourceClientOffset: action.sourceClientOffset,
	        initialClientOffset: action.clientOffset,
	        clientOffset: action.clientOffset
	      };
	    case _dragDrop.HOVER:
	      if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
	        return state;
	      }
	      return _extends({}, state, {
	        clientOffset: action.clientOffset
	      });
	    case _dragDrop.END_DRAG:
	    case _dragDrop.DROP:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	function getSourceClientOffset(state) {
	  var clientOffset = state.clientOffset,
	      initialClientOffset = state.initialClientOffset,
	      initialSourceClientOffset = state.initialSourceClientOffset;
	
	  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
	    return null;
	  }
	  return {
	    x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
	    y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	  };
	}
	
	function getDifferenceFromInitialOffset(state) {
	  var clientOffset = state.clientOffset,
	      initialClientOffset = state.initialClientOffset;
	
	  if (!clientOffset || !initialClientOffset) {
	    return null;
	  }
	  return {
	    x: clientOffset.x - initialClientOffset.x,
	    y: clientOffset.y - initialClientOffset.y
	  };
	}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matchesType;
	
	var _isArray = __webpack_require__(37);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchesType(targetType, draggedItemType) {
	  if ((0, _isArray2.default)(targetType)) {
	    return targetType.some(function (t) {
	      return t === draggedItemType;
	    });
	  } else {
	    return targetType === draggedItemType;
	  }
	}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Constants = __webpack_require__(923);
	
	Object.keys(_Constants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Constants[key];
	    }
	  });
	});
	Object.defineProperty(exports, 'Constants', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Constants).default;
	  }
	});
	
	var _getEntityRanges = __webpack_require__(925);
	
	Object.defineProperty(exports, 'getEntityRanges', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getEntityRanges).default;
	  }
	});
	
	var _getSelectedBlocks = __webpack_require__(285);
	
	Object.defineProperty(exports, 'getSelectedBlocks', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getSelectedBlocks).default;
	  }
	});
	
	var _selectionContainsEntity = __webpack_require__(926);
	
	Object.defineProperty(exports, 'selectionContainsEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_selectionContainsEntity).default;
	  }
	});
	
	var _callModifierForSelectedBlocks = __webpack_require__(924);
	
	Object.defineProperty(exports, 'callModifierForSelectedBlocks', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_callModifierForSelectedBlocks).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockTree
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var emptyFunction = __webpack_require__(43);
	var findRangesImmutable = __webpack_require__(201);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	var Record = Immutable.Record;
	
	
	var returnTrue = emptyFunction.thatReturnsTrue;
	
	var FINGERPRINT_DELIMITER = '-';
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	
	var LeafRange = Record(defaultLeafRange);
	
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	
	var DecoratorRange = Record(defaultDecoratorRange);
	
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(block, decorator) {
	    var textLength = block.getLength();
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block) : List(Repeat(null, textLength));
	
	    var chars = block.getCharacterList();
	
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	
	    return List(leafSets);
	  },
	
	  /**
	   * Create a string representation of the given tree map. This allows us
	   * to rapidly determine whether a tree has undergone a significant
	   * structural change.
	   */
	  getFingerprint: function getFingerprint(tree) {
	    return tree.map(function (leafSet) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
	      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
	    }).join(FINGERPRINT_DELIMITER);
	  }
	};
	
	/**
	 * Generate LeafRange records for a given character list.
	 */
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftInlineStyle
	 * 
	 */
	
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorBlock.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentBlock = __webpack_require__(110);
	var DraftEditorLeaf = __webpack_require__(935);
	var DraftOffsetKey = __webpack_require__(200);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var Scroll = __webpack_require__(448);
	var SelectionState = __webpack_require__(133);
	var Style = __webpack_require__(295);
	var UnicodeBidi = __webpack_require__(449);
	var UnicodeBidiDirection = __webpack_require__(296);
	
	var cx = __webpack_require__(163);
	var getElementPosition = __webpack_require__(1000);
	var getScrollPosition = __webpack_require__(298);
	var getViewportDimensions = __webpack_require__(1004);
	var nullthrows = __webpack_require__(57);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	var DraftEditorBlock = function (_React$Component) {
	  _inherits(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    _classCallCheck(this, DraftEditorBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	  };
	
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	
	
	  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = ReactDOM.findDOMNode(this);
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = this.props.tree.size - 1;
	    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	
	    return this.props.tree.map(function (leafSet, ii) {
	      var leavesForLeafSet = leafSet.get('leaves');
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          blockKey: blockKey,
	          start: start,
	          selection: hasSelection ? _this2.props.selection : undefined,
	          forceSelection: _this2.props.forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: _this2.props.customStyleMap,
	          customStyleFn: _this2.props.customStyleFn,
	          isLast: ii === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	
	      var decoratorKey = leafSet.get('decoratorKey');
	      if (decoratorKey == null) {
	        return leaves;
	      }
	
	      if (!_this2.props.decorator) {
	        return leaves;
	      }
	
	      var decorator = nullthrows(_this2.props.decorator);
	
	      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	      if (!DecoratorComponent) {
	        return leaves;
	      }
	
	      var decoratorProps = decorator.getPropsForKey(decoratorKey);
	      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));
	
	      // Resetting dir to the same value on a child node makes Chrome/Firefox
	      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
	
	      return React.createElement(
	        DecoratorComponent,
	        _extends({}, decoratorProps, {
	          decoratedText: decoratedText,
	          dir: dir,
	          key: decoratorOffsetKey,
	          entityKey: block.getEntityAt(leafSet.get('start')),
	          offsetKey: decoratorOffsetKey }),
	        leaves
	      );
	    }).toArray();
	  };
	
	  DraftEditorBlock.prototype.render = function render() {
	    var _props = this.props;
	    var direction = _props.direction;
	    var offsetKey = _props.offsetKey;
	
	    var className = cx({
	      'public/DraftStyleDefault/block': true,
	      'public/DraftStyleDefault/ltr': direction === 'LTR',
	      'public/DraftStyleDefault/rtl': direction === 'RTL'
	    });
	
	    return React.createElement(
	      'div',
	      { 'data-offset-key': offsetKey, className: className },
	      this._renderChildren()
	    );
	  };
	
	  return DraftEditorBlock;
	}(React.Component);
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	
	
	function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	}
	
	module.exports = DraftEditorBlock;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntityInstance
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(26);
	
	var Record = Immutable.Record;
	
	
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = function (_DraftEntityInstanceR) {
	  _inherits(DraftEntityInstance, _DraftEntityInstanceR);
	
	  function DraftEntityInstance() {
	    _classCallCheck(this, DraftEntityInstance);
	
	    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
	  }
	
	  DraftEntityInstance.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  DraftEntityInstance.prototype.getMutability = function getMutability() {
	    return this.get('mutability');
	  };
	
	  DraftEntityInstance.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  return DraftEntityInstance;
	}(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftRemovableWord
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var TokenizeUtil = __webpack_require__(992);
	
	var punctuation = TokenizeUtil.getPunctuation();
	
	// The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	var CHAMELEON_CHARS = '[\'‘’]';
	
	// Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	
	module.exports = DraftRemovableWord;

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftStringKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	
	module.exports = DraftStringKey;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromHTMLToContentBlocks
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(63);
	var ContentBlock = __webpack_require__(110);
	var DefaultDraftBlockRenderMap = __webpack_require__(287);
	var DraftEntity = __webpack_require__(84);
	var Immutable = __webpack_require__(26);
	var URI = __webpack_require__(993);
	
	var generateRandomKey = __webpack_require__(70);
	var getSafeBodyFromHTML = __webpack_require__(437);
	var invariant = __webpack_require__(7);
	var nullthrows = __webpack_require__(57);
	var sanitizeDraftText = __webpack_require__(292);
	
	var List = Immutable.List;
	var OrderedSet = Immutable.OrderedSet;
	
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
	var REGEX_ZWS = new RegExp('&#8203;?', 'g');
	
	// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
	var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
	var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
	
	var lastBlock;
	
	function getEmptyChunk() {
	  return {
	    text: '',
	    inlines: [],
	    entities: [],
	    blocks: []
	  };
	}
	
	function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return {
	    text: SPACE,
	    inlines: [OrderedSet()],
	    entities: entities,
	    blocks: []
	  };
	}
	
	function getSoftNewlineChunk() {
	  return {
	    text: '\n',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: []
	  };
	}
	
	function getBlockDividerChunk(block, depth) {
	  return {
	    text: '\r',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: [{
	      type: block,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    }]
	  };
	}
	
	function getListBlockType(tag, lastList) {
	  if (tag === 'li') {
	    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	  }
	  return null;
	}
	
	function getBlockMapSupportedTags(blockRenderMap) {
	  var unstyledElement = blockRenderMap.get('unstyled').element;
	  return blockRenderMap.map(function (config) {
	    return config.element;
	  }).valueSeq().toSet().filter(function (tag) {
	    return tag && tag !== unstyledElement;
	  }).toArray().sort();
	}
	
	// custom element conversions
	function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
	  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
	    var matchType = multiMatchExtractor[ii](tag, lastList);
	    if (matchType) {
	      return matchType;
	    }
	  }
	  return null;
	}
	
	function getBlockTypeForTag(tag, lastList, blockRenderMap) {
	  var matchedTypes = blockRenderMap.filter(function (config) {
	    return config.element === tag || config.wrapper === tag;
	  }).keySeq().toSet().toArray().sort();
	
	  // if we dont have any matched type, return unstyled
	  // if we have one matched type return it
	  // if we have multi matched types use the multi-match function to gather type
	  switch (matchedTypes.length) {
	    case 0:
	      return 'unstyled';
	    case 1:
	      return matchedTypes[0];
	    default:
	      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
	  }
	}
	
	function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    (function () {
	      var htmlElement = node;
	      currentStyle = currentStyle.withMutations(function (style) {
	        var fontWeight = htmlElement.style.fontWeight;
	        var fontStyle = htmlElement.style.fontStyle;
	        var textDecoration = htmlElement.style.textDecoration;
	
	        if (boldValues.indexOf(fontWeight) >= 0) {
	          style.add('BOLD');
	        } else if (notBoldValues.indexOf(fontWeight) >= 0) {
	          style.remove('BOLD');
	        }
	
	        if (fontStyle === 'italic') {
	          style.add('ITALIC');
	        } else if (fontStyle === 'normal') {
	          style.remove('ITALIC');
	        }
	
	        if (textDecoration === 'underline') {
	          style.add('UNDERLINE');
	        }
	        if (textDecoration === 'line-through') {
	          style.add('STRIKETHROUGH');
	        }
	        if (textDecoration === 'none') {
	          style.remove('UNDERLINE');
	          style.remove('STRIKETHROUGH');
	        }
	      }).toOrderedSet();
	    })();
	  }
	  return currentStyle;
	}
	
	function joinChunks(A, B) {
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var lastInA = A.text.slice(-1);
	  var firstInB = B.text.slice(0, 1);
	
	  if (lastInA === '\r' && firstInB === '\r') {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks
	  if (lastInA === '\r') {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (firstInB === SPACE || firstInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks)
	  };
	}
	
	/**
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	function containsSemanticBlockMarkup(html, blockTags) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	}
	
	function hasValidLinkText(link) {
	  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
	  var protocol = link.protocol;
	  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
	}
	
	function genFragment(node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity) {
	  var nodeName = node.nodeName.toLowerCase();
	  var newBlock = false;
	  var nextBlockType = 'unstyled';
	  var lastLastBlock = lastBlock;
	
	  // Base Case
	  if (nodeName === '#text') {
	    var text = node.textContent;
	    if (text.trim() === '' && inBlock !== 'pre') {
	      return getWhitespaceChunk(inEntity);
	    }
	    if (inBlock !== 'pre') {
	      // Can't use empty string because MSWord
	      text = text.replace(REGEX_LF, SPACE);
	    }
	
	    // save the last block so we can use it later
	    lastBlock = nodeName;
	
	    return {
	      text: text,
	      inlines: Array(text.length).fill(inlineStyle),
	      entities: Array(text.length).fill(inEntity),
	      blocks: []
	    };
	  }
	
	  // save the last block so we can use it later
	  lastBlock = nodeName;
	
	  // BR tags
	  if (nodeName === 'br') {
	    if (lastLastBlock === 'br' && (!inBlock || getBlockTypeForTag(inBlock, lastList, blockRenderMap) === 'unstyled')) {
	      return getBlockDividerChunk('unstyled', depth);
	    }
	    return getSoftNewlineChunk();
	  }
	
	  var chunk = getEmptyChunk();
	  var newChunk = null;
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	  }
	
	  // Block Tags
	  if (!inBlock && blockTags.indexOf(nodeName) !== -1) {
	    chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth);
	    inBlock = nodeName;
	    newBlock = true;
	  } else if (lastList && inBlock === 'li' && nodeName === 'li') {
	    chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth);
	    inBlock = nodeName;
	    newBlock = true;
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	
	  while (child) {
	    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
	      (function () {
	        var anchor = child;
	        var entityConfig = {};
	
	        anchorAttr.forEach(function (attr) {
	          var anchorAttribute = anchor.getAttribute(attr);
	          if (anchorAttribute) {
	            entityConfig[attr] = anchorAttribute;
	          }
	        });
	
	        entityConfig.url = new URI(anchor.href).toString();
	
	        entityId = DraftEntity.create('LINK', 'MUTABLE', entityConfig);
	      })();
	    } else {
	      entityId = undefined;
	    }
	
	    newChunk = genFragment(child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity);
	
	    chunk = joinChunks(chunk, newChunk);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
	      chunk = joinChunks(chunk, getSoftNewlineChunk());
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth));
	  }
	
	  return chunk;
	}
	
	function getChunkForHTML(html, DOMBuilder, blockRenderMap) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
	
	  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	  lastBlock = null;
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to start with.
	  var chunk = genFragment(safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push({ type: 'unstyled', depth: 0 });
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
	  }
	
	  return chunk;
	}
	
	function convertFromHTMLtoContentBlocks(html) {
	  var DOMBuilder = arguments.length <= 1 || arguments[1] === undefined ? getSafeBodyFromHTML : arguments[1];
	  var blockRenderMap = arguments.length <= 2 || arguments[2] === undefined ? DefaultDraftBlockRenderMap : arguments[2];
	
	  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  var chunk = getChunkForHTML(html, DOMBuilder, blockRenderMap);
	
	  if (chunk == null) {
	    return null;
	  }
	  var start = 0;
	  return chunk.text.split('\r').map(function (textBlock, ii) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	    var end = start + textBlock.length;
	    var inlines = nullthrows(chunk).inlines.slice(start, end);
	    var entities = nullthrows(chunk).entities.slice(start, end);
	    var characterList = List(inlines.map(function (style, ii) {
	      var data = { style: style, entity: null };
	      if (entities[ii]) {
	        data.entity = entities[ii];
	      }
	      return CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    return new ContentBlock({
	      key: generateRandomKey(),
	      type: nullthrows(chunk).blocks[ii].type,
	      depth: nullthrows(chunk).blocks[ii].depth,
	      text: textBlock,
	      characterList: characterList
	    });
	  });
	}
	
	module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDefaultKeyBinding
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(288);
	var Keys = __webpack_require__(294);
	var UserAgent = __webpack_require__(71);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var isWindows = UserAgent.isPlatform('Windows');
	
	// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier;
	var isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	function getZCommand(e) {
	  if (!hasCommandModifier(e)) {
	    return null;
	  }
	  return e.shiftKey ? 'redo' : 'undo';
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for Windows on Shift + Delete.
	  if (isWindows && e.shiftKey) {
	    return null;
	  }
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	
	/**
	 * Retrieve a bound key command for the given event.
	 */
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	    case 75:
	      // K
	      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isWindows ? 'redo' : 'secondary-paste';
	      }
	      return null;
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	    case Keys.RETURN:
	      return 'split-block';
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelectionWithNodes
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(289);
	var getSelectionOffsetKeyForNode = __webpack_require__(438);
	var getUpdatedSelectionState = __webpack_require__(440);
	var invariant = __webpack_require__(7);
	var nullthrows = __webpack_require__(57);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
	
	  // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true;
	
	  // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	
	    // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	function getFirstLeaf(node) {
	  while (node.firstChild && getSelectionOffsetKeyForNode(node.firstChild)) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	function getLastLeaf(node) {
	  while (node.lastChild && getSelectionOffsetKeyForNode(node.lastChild)) {
	    node = node.lastChild;
	  }
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, startNode, childOffset) {
	  var node = startNode;
	  var offsetKey = findAncestorOffsetKey(node);
	
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;
	
	  // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  }
	
	  // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	  if (childOffset === 0) {
	    var key = null;
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	    return { key: key, offset: 0 };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getFragmentFromSelection
	 * 
	 */
	
	'use strict';
	
	var getContentStateFragment = __webpack_require__(202);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	
	  if (selectionState.isCollapsed()) {
	    return null;
	  }
	
	  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	}
	
	module.exports = getFragmentFromSelection;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeClientRects
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(71);
	
	var invariant = __webpack_require__(7);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	// In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	/* eslint-disable consistent-return */
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
	}
	/* eslint-enable consistent-return */
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	
	module.exports = getRangeClientRects;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSafeBodyFromHTML
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(71);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9');
	
	// Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null;
	  // Provides a safe context
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSelectionOffsetKeyForNode
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	/**
	 * Get offset key from a node or it's child nodes. Return the first offset key
	 * found on the DOM tree of given node.
	 */
	
	function getSelectionOffsetKeyForNode(node) {
	  if (node instanceof Element) {
	    var offsetKey = node.getAttribute('data-offset-key');
	    if (offsetKey) {
	      return offsetKey;
	    }
	    for (var ii = 0; ii < node.childNodes.length; ii++) {
	      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
	      if (childOffsetKey) {
	        return childOffsetKey;
	      }
	    }
	  }
	  return null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentFromFiles
	 * 
	 */
	
	'use strict';
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	};
	
	// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	var TEXT_SIZE_UPPER_BOUND = 5000;
	
	/**
	 * Extract the text content from a file list.
	 */
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function ( /*blob*/file) {
	    readFile(file, function ( /*string*/text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var contents = '';
	    // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	    callback(contents);
	    return;
	  }
	
	  var reader = new FileReader();
	  reader.onload = function () {
	    callback(reader.result);
	  };
	  reader.onerror = function () {
	    callback('');
	  };
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUpdatedSelectionState
	 * 
	 */
	
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(200);
	
	var nullthrows = __webpack_require__(57);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	  if (false) {
	    if (!anchorKey || !focusKey) {
	      /*eslint-disable no-console */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	      /*eslint-enable no-console */
	      return selection;
	    }
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertIntoList
	 * 
	 */
	
	'use strict';
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	function insertIntoList(targetList, toInsert, offset) {
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isSelectionAtLeafStart
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	
	  var isAtStart = false;
	
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return false;
	  });
	
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionForward
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	
	  var focusKey = key;
	  var focusOffset;
	
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
	}
	
	module.exports = moveSelectionForward;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeEntitiesAtEdges
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(63);
	var DraftEntity = __webpack_require__(84);
	
	var findRangesImmutable = __webpack_require__(201);
	var invariant = __webpack_require__(7);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	
	  var updatedBlocks = {};
	
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	
	function getRemovalRange(characters, key, offset) {
	  var removalRange;
	  findRangesImmutable(characters, function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, function (element) {
	    return element.getEntity() === key;
	  }, function (start, end) {
	    if (start <= offset && end >= offset) {
	      removalRange = { start: start, end: end };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
	  return removalRange;
	}
	
	function removeForBlock(block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = DraftEntity.get(entityAfterCursor);
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset);
	
	      var start = _getRemovalRange.start;
	      var end = _getRemovalRange.end;
	
	      var current;
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(607);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint){
	
		if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
			return "\uFFFD";
		}
	
		if(codePoint in decodeMap){
			codePoint = decodeMap[codePoint];
		}
	
		var output = "";
	
		if(codePoint > 0xFFFF){
			codePoint -= 0x10000;
			output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
	
		output += String.fromCharCode(codePoint);
		return output;
	}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var PhotosMimeType = __webpack_require__(991);
	
	var createArrayFromMixed = __webpack_require__(451);
	var emptyFunction = __webpack_require__(43);
	
	var CR_LF_REGEX = new RegExp('\r\n', 'g');
	var LF_ONLY = '\n';
	
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer = function () {
	  /**
	   * @param {object} data
	   */
	  function DataTransfer(data) {
	    _classCallCheck(this, DataTransfer);
	
	    this.data = data;
	
	    // Types could be DOMStringList or array
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    }
	
	    // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getText = function getText() {
	    var text;
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  DataTransfer.prototype.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	    return null;
	  };
	
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  DataTransfer.prototype.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(43);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ?
	    // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	
	module.exports = Scroll;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(296);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	
	  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',
	
	  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',
	
	  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'
	
	};
	
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	  if (!str.length) {
	    return fallback;
	  }
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	
	module.exports = UnicodeBidi;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(457);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
		input: true,
		option: true,
		optgroup: true,
		select: true,
		button: true,
		datalist: true,
		textarea: true
	};
	
	var openImpliesClose = {
		tr      : { tr:true, th:true, td:true },
		th      : { th:true },
		td      : { thead:true, th:true, td:true },
		body    : { head:true, link:true, script:true },
		li      : { li:true },
		p       : { p:true },
		h1      : { p:true },
		h2      : { p:true },
		h3      : { p:true },
		h4      : { p:true },
		h5      : { p:true },
		h6      : { p:true },
		select  : formTags,
		input   : formTags,
		output  : formTags,
		button  : formTags,
		datalist: formTags,
		textarea: formTags,
		option  : { option:true },
		optgroup: { optgroup:true }
	};
	
	var voidElements = {
		__proto__: null,
		area: true,
		base: true,
		basefont: true,
		br: true,
		col: true,
		command: true,
		embed: true,
		frame: true,
		hr: true,
		img: true,
		input: true,
		isindex: true,
		keygen: true,
		link: true,
		meta: true,
		param: true,
		source: true,
		track: true,
		wbr: true,
	
		//common self closing svg elements
		path: true,
		circle: true,
		ellipse: true,
		line: true,
		rect: true,
		use: true,
		stop: true,
		polyline: true,
		polygon: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options){
		this._options = options || {};
		this._cbs = cbs || {};
	
		this._tagname = "";
		this._attribname = "";
		this._attribvalue = "";
		this._attribs = null;
		this._stack = [];
	
		this.startIndex = 0;
		this.endIndex = null;
	
		this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
										!!this._options.lowerCaseTags :
										!this._options.xmlMode;
		this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
										!!this._options.lowerCaseAttributeNames :
										!this._options.xmlMode;
	
		if(this._options.Tokenizer) {
			Tokenizer = this._options.Tokenizer;
		}
		this._tokenizer = new Tokenizer(this._options, this);
	
		if(this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(72)(Parser, __webpack_require__(56).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset){
		if(this.endIndex === null){
			if(this._tokenizer._sectionStart <= initialOffset){
				this.startIndex = 0;
			} else {
				this.startIndex = this._tokenizer._sectionStart - initialOffset;
			}
		}
		else this.startIndex = this.endIndex + 1;
		this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data){
		this._updatePosition(1);
		this.endIndex--;
	
		if(this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name){
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		this._tagname = name;
	
		if(!this._options.xmlMode && name in openImpliesClose) {
			for(
				var el;
				(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
				this.onclosetag(el)
			);
		}
	
		if(this._options.xmlMode || !(name in voidElements)){
			this._stack.push(name);
		}
	
		if(this._cbs.onopentagname) this._cbs.onopentagname(name);
		if(this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function(){
		this._updatePosition(1);
	
		if(this._attribs){
			if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
			this._attribs = null;
		}
	
		if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
			this._cbs.onclosetag(this._tagname);
		}
	
		this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name){
		this._updatePosition(1);
	
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
			var pos = this._stack.lastIndexOf(name);
			if(pos !== -1){
				if(this._cbs.onclosetag){
					pos = this._stack.length - pos;
					while(pos--) this._cbs.onclosetag(this._stack.pop());
				}
				else this._stack.length = pos;
			} else if(name === "p" && !this._options.xmlMode){
				this.onopentagname(name);
				this._closeCurrentTag();
			}
		} else if(!this._options.xmlMode && (name === "br" || name === "p")){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	};
	
	Parser.prototype.onselfclosingtag = function(){
		if(this._options.xmlMode || this._options.recognizeSelfClosing){
			this._closeCurrentTag();
		} else {
			this.onopentagend();
		}
	};
	
	Parser.prototype._closeCurrentTag = function(){
		var name = this._tagname;
	
		this.onopentagend();
	
		//self-closing tags will be on the top of the stack
		//(cheaper check than in onclosetag)
		if(this._stack[this._stack.length - 1] === name){
			if(this._cbs.onclosetag){
				this._cbs.onclosetag(name);
			}
			this._stack.pop();
		}
	};
	
	Parser.prototype.onattribname = function(name){
		if(this._lowerCaseAttributeNames){
			name = name.toLowerCase();
		}
		this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value){
		this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function(){
		if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
		if(
			this._attribs &&
			!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
		){
			this._attribs[this._attribname] = this._attribvalue;
		}
		this._attribname = "";
		this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value){
		var idx = value.search(re_nameEnd),
		    name = idx < 0 ? value : value.substr(0, idx);
	
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		return name;
	};
	
	Parser.prototype.ondeclaration = function(value){
		if(this._cbs.onprocessinginstruction){
			var name = this._getInstructionName(value);
			this._cbs.onprocessinginstruction("!" + name, "!" + value);
		}
	};
	
	Parser.prototype.onprocessinginstruction = function(value){
		if(this._cbs.onprocessinginstruction){
			var name = this._getInstructionName(value);
			this._cbs.onprocessinginstruction("?" + name, "?" + value);
		}
	};
	
	Parser.prototype.oncomment = function(value){
		this._updatePosition(4);
	
		if(this._cbs.oncomment) this._cbs.oncomment(value);
		if(this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value){
		this._updatePosition(1);
	
		if(this._options.xmlMode || this._options.recognizeCDATA){
			if(this._cbs.oncdatastart) this._cbs.oncdatastart();
			if(this._cbs.ontext) this._cbs.ontext(value);
			if(this._cbs.oncdataend) this._cbs.oncdataend();
		} else {
			this.oncomment("[CDATA[" + value + "]]");
		}
	};
	
	Parser.prototype.onerror = function(err){
		if(this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function(){
		if(this._cbs.onclosetag){
			for(
				var i = this._stack.length;
				i > 0;
				this._cbs.onclosetag(this._stack[--i])
			);
		}
		if(this._cbs.onend) this._cbs.onend();
	};
	
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function(){
		if(this._cbs.onreset) this._cbs.onreset();
		this._tokenizer.reset();
	
		this._tagname = "";
		this._attribname = "";
		this._attribs = null;
		this._stack = [];
	
		if(this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data){
		this.reset();
		this.end(data);
	};
	
	Parser.prototype.write = function(chunk){
		this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk){
		this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function(){
		this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function(){
		this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(445),
	    entityMap = __webpack_require__(237),
	    legacyMap = __webpack_require__(371),
	    xmlMap    = __webpack_require__(238),
	
	    i = 0,
	
	    TEXT                      = i++,
	    BEFORE_TAG_NAME           = i++, //after <
	    IN_TAG_NAME               = i++,
	    IN_SELF_CLOSING_TAG       = i++,
	    BEFORE_CLOSING_TAG_NAME   = i++,
	    IN_CLOSING_TAG_NAME       = i++,
	    AFTER_CLOSING_TAG_NAME    = i++,
	
	    //attributes
	    BEFORE_ATTRIBUTE_NAME     = i++,
	    IN_ATTRIBUTE_NAME         = i++,
	    AFTER_ATTRIBUTE_NAME      = i++,
	    BEFORE_ATTRIBUTE_VALUE    = i++,
	    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
	    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
	    IN_ATTRIBUTE_VALUE_NQ     = i++,
	
	    //declarations
	    BEFORE_DECLARATION        = i++, // !
	    IN_DECLARATION            = i++,
	
	    //processing instructions
	    IN_PROCESSING_INSTRUCTION = i++, // ?
	
	    //comments
	    BEFORE_COMMENT            = i++,
	    IN_COMMENT                = i++,
	    AFTER_COMMENT_1           = i++,
	    AFTER_COMMENT_2           = i++,
	
	    //cdata
	    BEFORE_CDATA_1            = i++, // [
	    BEFORE_CDATA_2            = i++, // C
	    BEFORE_CDATA_3            = i++, // D
	    BEFORE_CDATA_4            = i++, // A
	    BEFORE_CDATA_5            = i++, // T
	    BEFORE_CDATA_6            = i++, // A
	    IN_CDATA                  = i++, // [
	    AFTER_CDATA_1             = i++, // ]
	    AFTER_CDATA_2             = i++, // ]
	
	    //special tags
	    BEFORE_SPECIAL            = i++, //S
	    BEFORE_SPECIAL_END        = i++,   //S
	
	    BEFORE_SCRIPT_1           = i++, //C
	    BEFORE_SCRIPT_2           = i++, //R
	    BEFORE_SCRIPT_3           = i++, //I
	    BEFORE_SCRIPT_4           = i++, //P
	    BEFORE_SCRIPT_5           = i++, //T
	    AFTER_SCRIPT_1            = i++, //C
	    AFTER_SCRIPT_2            = i++, //R
	    AFTER_SCRIPT_3            = i++, //I
	    AFTER_SCRIPT_4            = i++, //P
	    AFTER_SCRIPT_5            = i++, //T
	
	    BEFORE_STYLE_1            = i++, //T
	    BEFORE_STYLE_2            = i++, //Y
	    BEFORE_STYLE_3            = i++, //L
	    BEFORE_STYLE_4            = i++, //E
	    AFTER_STYLE_1             = i++, //T
	    AFTER_STYLE_2             = i++, //Y
	    AFTER_STYLE_3             = i++, //L
	    AFTER_STYLE_4             = i++, //E
	
	    BEFORE_ENTITY             = i++, //&
	    BEFORE_NUMERIC_ENTITY     = i++, //#
	    IN_NAMED_ENTITY           = i++,
	    IN_NUMERIC_ENTITY         = i++,
	    IN_HEX_ENTITY             = i++, //X
	
	    j = 0,
	
	    SPECIAL_NONE              = j++,
	    SPECIAL_SCRIPT            = j++,
	    SPECIAL_STYLE             = j++;
	
	function whitespace(c){
		return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function characterState(char, SUCCESS){
		return function(c){
			if(c === char) this._state = SUCCESS;
		};
	}
	
	function ifElseState(upper, SUCCESS, FAILURE){
		var lower = upper.toLowerCase();
	
		if(upper === lower){
			return function(c){
				if(c === lower){
					this._state = SUCCESS;
				} else {
					this._state = FAILURE;
					this._index--;
				}
			};
		} else {
			return function(c){
				if(c === lower || c === upper){
					this._state = SUCCESS;
				} else {
					this._state = FAILURE;
					this._index--;
				}
			};
		}
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE){
		var lower = upper.toLowerCase();
	
		return function(c){
			if(c === lower || c === upper){
				this._state = NEXT_STATE;
			} else {
				this._state = IN_TAG_NAME;
				this._index--; //consume the token again
			}
		};
	}
	
	function Tokenizer(options, cbs){
		this._state = TEXT;
		this._buffer = "";
		this._sectionStart = 0;
		this._index = 0;
		this._bufferOffset = 0; //chars removed from _buffer
		this._baseState = TEXT;
		this._special = SPECIAL_NONE;
		this._cbs = cbs;
		this._running = true;
		this._ended = false;
		this._xmlMode = !!(options && options.xmlMode);
		this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c){
		if(c === "<"){
			if(this._index > this._sectionStart){
				this._cbs.ontext(this._getSection());
			}
			this._state = BEFORE_TAG_NAME;
			this._sectionStart = this._index;
		} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
			if(this._index > this._sectionStart){
				this._cbs.ontext(this._getSection());
			}
			this._baseState = TEXT;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c){
		if(c === "/"){
			this._state = BEFORE_CLOSING_TAG_NAME;
		} else if(c === "<"){
			this._cbs.ontext(this._getSection());
			this._sectionStart = this._index;
		} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
			this._state = TEXT;
		} else if(c === "!"){
			this._state = BEFORE_DECLARATION;
			this._sectionStart = this._index + 1;
		} else if(c === "?"){
			this._state = IN_PROCESSING_INSTRUCTION;
			this._sectionStart = this._index + 1;
		} else {
			this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
							BEFORE_SPECIAL : IN_TAG_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInTagName = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._emitToken("onopentagname");
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
		if(whitespace(c));
		else if(c === ">"){
			this._state = TEXT;
		} else if(this._special !== SPECIAL_NONE){
			if(c === "s" || c === "S"){
				this._state = BEFORE_SPECIAL_END;
			} else {
				this._state = TEXT;
				this._index--;
			}
		} else {
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c){
		if(c === ">" || whitespace(c)){
			this._emitToken("onclosetag");
			this._state = AFTER_CLOSING_TAG_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c){
		//skip everything until ">"
		if(c === ">"){
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c){
		if(c === ">"){
			this._cbs.onopentagend();
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c === "/"){
			this._state = IN_SELF_CLOSING_TAG;
		} else if(!whitespace(c)){
			this._state = IN_ATTRIBUTE_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c){
		if(c === ">"){
			this._cbs.onselfclosingtag();
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(!whitespace(c)){
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c){
		if(c === "=" || c === "/" || c === ">" || whitespace(c)){
			this._cbs.onattribname(this._getSection());
			this._sectionStart = -1;
			this._state = AFTER_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c){
		if(c === "="){
			this._state = BEFORE_ATTRIBUTE_VALUE;
		} else if(c === "/" || c === ">"){
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		} else if(!whitespace(c)){
			this._cbs.onattribend();
			this._state = IN_ATTRIBUTE_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c){
		if(c === "\""){
			this._state = IN_ATTRIBUTE_VALUE_DQ;
			this._sectionStart = this._index + 1;
		} else if(c === "'"){
			this._state = IN_ATTRIBUTE_VALUE_SQ;
			this._sectionStart = this._index + 1;
		} else if(!whitespace(c)){
			this._state = IN_ATTRIBUTE_VALUE_NQ;
			this._sectionStart = this._index;
			this._index--; //reconsume token
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
		if(c === "\""){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
		if(c === "'"){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
		if(whitespace(c) || c === ">"){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c){
		this._state = c === "[" ? BEFORE_CDATA_1 :
						c === "-" ? BEFORE_COMMENT :
							IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c){
		if(c === ">"){
			this._cbs.ondeclaration(this._getSection());
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c){
		if(c === ">"){
			this._cbs.onprocessinginstruction(this._getSection());
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c){
		if(c === "-"){
			this._state = IN_COMMENT;
			this._sectionStart = this._index + 1;
		} else {
			this._state = IN_DECLARATION;
		}
	};
	
	Tokenizer.prototype._stateInComment = function(c){
		if(c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c){
		if(c === "-"){
			this._state = AFTER_COMMENT_2;
		} else {
			this._state = IN_COMMENT;
		}
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c){
		if(c === ">"){
			//remove 2 trailing chars
			this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c !== "-"){
			this._state = IN_COMMENT;
		}
		// else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c){
		if(c === "["){
			this._state = IN_CDATA;
			this._sectionStart = this._index + 1;
		} else {
			this._state = IN_DECLARATION;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInCdata = function(c){
		if(c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);
	
	Tokenizer.prototype._stateAfterCdata2 = function(c){
		if(c === ">"){
			//remove 2 trailing chars
			this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c !== "]") {
			this._state = IN_CDATA;
		}
		//else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c){
		if(c === "c" || c === "C"){
			this._state = BEFORE_SCRIPT_1;
		} else if(c === "t" || c === "T"){
			this._state = BEFORE_STYLE_1;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
		if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
			this._state = AFTER_SCRIPT_1;
		} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
			this._state = AFTER_STYLE_1;
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._special = SPECIAL_SCRIPT;
		}
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c){
		if(c === ">" || whitespace(c)){
			this._special = SPECIAL_NONE;
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index - 6;
			this._index--; //reconsume the token
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._special = SPECIAL_STYLE;
		}
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c){
		if(c === ">" || whitespace(c)){
			this._special = SPECIAL_NONE;
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index - 5;
			this._index--; //reconsume the token
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function(){
		//offset = 1
		if(this._sectionStart + 1 < this._index){
			var entity = this._buffer.substring(this._sectionStart + 1, this._index),
			    map = this._xmlMode ? xmlMap : entityMap;
	
			if(map.hasOwnProperty(entity)){
				this._emitPartial(map[entity]);
				this._sectionStart = this._index + 1;
			}
		}
	};
	
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function(){
		var start = this._sectionStart + 1,
		    limit = this._index - start;
	
		if(limit > 6) limit = 6; //the max length of legacy entities is 6
	
		while(limit >= 2){ //the min length of legacy entities is 2
			var entity = this._buffer.substr(start, limit);
	
			if(legacyMap.hasOwnProperty(entity)){
				this._emitPartial(legacyMap[entity]);
				this._sectionStart += limit + 1;
				return;
			} else {
				limit--;
			}
		}
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c){
		if(c === ";"){
			this._parseNamedEntityStrict();
			if(this._sectionStart + 1 < this._index && !this._xmlMode){
				this._parseLegacyEntity();
			}
			this._state = this._baseState;
		} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
			if(this._xmlMode);
			else if(this._sectionStart + 1 === this._index);
			else if(this._baseState !== TEXT){
				if(c !== "="){
					this._parseNamedEntityStrict();
				}
			} else {
				this._parseLegacyEntity();
			}
	
			this._state = this._baseState;
			this._index--;
		}
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base){
		var sectionStart = this._sectionStart + offset;
	
		if(sectionStart !== this._index){
			//parse entity
			var entity = this._buffer.substring(sectionStart, this._index);
			var parsed = parseInt(entity, base);
	
			this._emitPartial(decodeCodePoint(parsed));
			this._sectionStart = this._index;
		} else {
			this._sectionStart--;
		}
	
		this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c){
		if(c === ";"){
			this._decodeNumericEntity(2, 10);
			this._sectionStart++;
		} else if(c < "0" || c > "9"){
			if(!this._xmlMode){
				this._decodeNumericEntity(2, 10);
			} else {
				this._state = this._baseState;
			}
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c){
		if(c === ";"){
			this._decodeNumericEntity(3, 16);
			this._sectionStart++;
		} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
			if(!this._xmlMode){
				this._decodeNumericEntity(3, 16);
			} else {
				this._state = this._baseState;
			}
			this._index--;
		}
	};
	
	Tokenizer.prototype._cleanup = function (){
		if(this._sectionStart < 0){
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._running){
			if(this._state === TEXT){
				if(this._sectionStart !== this._index){
					this._cbs.ontext(this._buffer.substr(this._sectionStart));
				}
				this._buffer = "";
				this._bufferOffset += this._index;
				this._index = 0;
			} else if(this._sectionStart === this._index){
				//the section just started
				this._buffer = "";
				this._bufferOffset += this._index;
				this._index = 0;
			} else {
				//remove everything unnecessary
				this._buffer = this._buffer.substr(this._sectionStart);
				this._index -= this._sectionStart;
				this._bufferOffset += this._sectionStart;
			}
	
			this._sectionStart = 0;
		}
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk){
		if(this._ended) this._cbs.onerror(Error(".write() after done!"));
	
		this._buffer += chunk;
		this._parse();
	};
	
	Tokenizer.prototype._parse = function(){
		while(this._index < this._buffer.length && this._running){
			var c = this._buffer.charAt(this._index);
			if(this._state === TEXT) {
				this._stateText(c);
			} else if(this._state === BEFORE_TAG_NAME){
				this._stateBeforeTagName(c);
			} else if(this._state === IN_TAG_NAME) {
				this._stateInTagName(c);
			} else if(this._state === BEFORE_CLOSING_TAG_NAME){
				this._stateBeforeCloseingTagName(c);
			} else if(this._state === IN_CLOSING_TAG_NAME){
				this._stateInCloseingTagName(c);
			} else if(this._state === AFTER_CLOSING_TAG_NAME){
				this._stateAfterCloseingTagName(c);
			} else if(this._state === IN_SELF_CLOSING_TAG){
				this._stateInSelfClosingTag(c);
			}
	
			/*
			*	attributes
			*/
			else if(this._state === BEFORE_ATTRIBUTE_NAME){
				this._stateBeforeAttributeName(c);
			} else if(this._state === IN_ATTRIBUTE_NAME){
				this._stateInAttributeName(c);
			} else if(this._state === AFTER_ATTRIBUTE_NAME){
				this._stateAfterAttributeName(c);
			} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
				this._stateBeforeAttributeValue(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
				this._stateInAttributeValueDoubleQuotes(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
				this._stateInAttributeValueSingleQuotes(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
				this._stateInAttributeValueNoQuotes(c);
			}
	
			/*
			*	declarations
			*/
			else if(this._state === BEFORE_DECLARATION){
				this._stateBeforeDeclaration(c);
			} else if(this._state === IN_DECLARATION){
				this._stateInDeclaration(c);
			}
	
			/*
			*	processing instructions
			*/
			else if(this._state === IN_PROCESSING_INSTRUCTION){
				this._stateInProcessingInstruction(c);
			}
	
			/*
			*	comments
			*/
			else if(this._state === BEFORE_COMMENT){
				this._stateBeforeComment(c);
			} else if(this._state === IN_COMMENT){
				this._stateInComment(c);
			} else if(this._state === AFTER_COMMENT_1){
				this._stateAfterComment1(c);
			} else if(this._state === AFTER_COMMENT_2){
				this._stateAfterComment2(c);
			}
	
			/*
			*	cdata
			*/
			else if(this._state === BEFORE_CDATA_1){
				this._stateBeforeCdata1(c);
			} else if(this._state === BEFORE_CDATA_2){
				this._stateBeforeCdata2(c);
			} else if(this._state === BEFORE_CDATA_3){
				this._stateBeforeCdata3(c);
			} else if(this._state === BEFORE_CDATA_4){
				this._stateBeforeCdata4(c);
			} else if(this._state === BEFORE_CDATA_5){
				this._stateBeforeCdata5(c);
			} else if(this._state === BEFORE_CDATA_6){
				this._stateBeforeCdata6(c);
			} else if(this._state === IN_CDATA){
				this._stateInCdata(c);
			} else if(this._state === AFTER_CDATA_1){
				this._stateAfterCdata1(c);
			} else if(this._state === AFTER_CDATA_2){
				this._stateAfterCdata2(c);
			}
	
			/*
			* special tags
			*/
			else if(this._state === BEFORE_SPECIAL){
				this._stateBeforeSpecial(c);
			} else if(this._state === BEFORE_SPECIAL_END){
				this._stateBeforeSpecialEnd(c);
			}
	
			/*
			* script
			*/
			else if(this._state === BEFORE_SCRIPT_1){
				this._stateBeforeScript1(c);
			} else if(this._state === BEFORE_SCRIPT_2){
				this._stateBeforeScript2(c);
			} else if(this._state === BEFORE_SCRIPT_3){
				this._stateBeforeScript3(c);
			} else if(this._state === BEFORE_SCRIPT_4){
				this._stateBeforeScript4(c);
			} else if(this._state === BEFORE_SCRIPT_5){
				this._stateBeforeScript5(c);
			}
	
			else if(this._state === AFTER_SCRIPT_1){
				this._stateAfterScript1(c);
			} else if(this._state === AFTER_SCRIPT_2){
				this._stateAfterScript2(c);
			} else if(this._state === AFTER_SCRIPT_3){
				this._stateAfterScript3(c);
			} else if(this._state === AFTER_SCRIPT_4){
				this._stateAfterScript4(c);
			} else if(this._state === AFTER_SCRIPT_5){
				this._stateAfterScript5(c);
			}
	
			/*
			* style
			*/
			else if(this._state === BEFORE_STYLE_1){
				this._stateBeforeStyle1(c);
			} else if(this._state === BEFORE_STYLE_2){
				this._stateBeforeStyle2(c);
			} else if(this._state === BEFORE_STYLE_3){
				this._stateBeforeStyle3(c);
			} else if(this._state === BEFORE_STYLE_4){
				this._stateBeforeStyle4(c);
			}
	
			else if(this._state === AFTER_STYLE_1){
				this._stateAfterStyle1(c);
			} else if(this._state === AFTER_STYLE_2){
				this._stateAfterStyle2(c);
			} else if(this._state === AFTER_STYLE_3){
				this._stateAfterStyle3(c);
			} else if(this._state === AFTER_STYLE_4){
				this._stateAfterStyle4(c);
			}
	
			/*
			* entities
			*/
			else if(this._state === BEFORE_ENTITY){
				this._stateBeforeEntity(c);
			} else if(this._state === BEFORE_NUMERIC_ENTITY){
				this._stateBeforeNumericEntity(c);
			} else if(this._state === IN_NAMED_ENTITY){
				this._stateInNamedEntity(c);
			} else if(this._state === IN_NUMERIC_ENTITY){
				this._stateInNumericEntity(c);
			} else if(this._state === IN_HEX_ENTITY){
				this._stateInHexEntity(c);
			}
	
			else {
				this._cbs.onerror(Error("unknown _state"), this._state);
			}
	
			this._index++;
		}
	
		this._cleanup();
	};
	
	Tokenizer.prototype.pause = function(){
		this._running = false;
	};
	Tokenizer.prototype.resume = function(){
		this._running = true;
	
		if(this._index < this._buffer.length){
			this._parse();
		}
		if(this._ended){
			this._finish();
		}
	};
	
	Tokenizer.prototype.end = function(chunk){
		if(this._ended) this._cbs.onerror(Error(".end() after done!"));
		if(chunk) this.write(chunk);
	
		this._ended = true;
	
		if(this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function(){
		//if there is remaining data, emit it in a reasonable way
		if(this._sectionStart < this._index){
			this._handleTrailingData();
		}
	
		this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function(){
		var data = this._buffer.substr(this._sectionStart);
	
		if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
			this._cbs.oncdata(data);
		} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
			this._cbs.oncomment(data);
		} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
			this._parseLegacyEntity();
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
			this._decodeNumericEntity(2, 10);
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
			this._decodeNumericEntity(3, 16);
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(
			this._state !== IN_TAG_NAME &&
			this._state !== BEFORE_ATTRIBUTE_NAME &&
			this._state !== BEFORE_ATTRIBUTE_VALUE &&
			this._state !== AFTER_ATTRIBUTE_NAME &&
			this._state !== IN_ATTRIBUTE_NAME &&
			this._state !== IN_ATTRIBUTE_VALUE_SQ &&
			this._state !== IN_ATTRIBUTE_VALUE_DQ &&
			this._state !== IN_ATTRIBUTE_VALUE_NQ &&
			this._state !== IN_CLOSING_TAG_NAME
		){
			this._cbs.ontext(data);
		}
		//else, ignore remaining data
		//TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function(){
		Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function(){
		return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function(){
		return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name){
		this._cbs[name](this._getSection());
		this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value){
		if(this._baseState !== TEXT){
			this._cbs.onattribdata(value); //TODO implement the new event
		} else {
			this._cbs.ontext(value);
		}
	};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(456),
	    WritableStream = __webpack_require__(1525).Writable || __webpack_require__(1540).Writable,
	    StringDecoder = __webpack_require__(365).StringDecoder,
	    Buffer = __webpack_require__(88).Buffer;
	
	function Stream(cbs, options){
		var parser = this._parser = new Parser(cbs, options);
		var decoder = this._decoder = new StringDecoder();
	
		WritableStream.call(this, {decodeStrings: false});
	
		this.once("finish", function(){
			parser.end(decoder.end());
		});
	}
	
	__webpack_require__(72)(Stream, WritableStream);
	
	WritableStream.prototype._write = function(chunk, encoding, cb){
		if(chunk instanceof Buffer) chunk = this._decoder.write(chunk);
		this._parser.write(chunk);
		cb();
	};

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.stateify = exports.TokenState = exports.CharacterState = undefined;
	
	var _class = __webpack_require__(205);
	
	function createStateClass() {
		return function (tClass) {
			this.j = [];
			this.T = tClass || null;
		};
	}
	
	/**
		A simple state machine that can emit token classes
	
		The `j` property in this class refers to state jumps. It's a
		multidimensional array where for each element:
	
		* index [0] is a symbol or class of symbols to transition to.
		* index [1] is a State instance which matches
	
		The type of symbol will depend on the target implementation for this class.
		In Linkify, we have a two-stage scanner. Each stage uses this state machine
		but with a slighly different (polymorphic) implementation.
	
		The `T` property refers to the token class.
	
		TODO: Can the `on` and `next` methods be combined?
	
		@class BaseState
	*/
	var BaseState = createStateClass();
	BaseState.prototype = {
		defaultTransition: false,
	
		/**
	 	@method constructor
	 	@param {Class} tClass Pass in the kind of token to emit if there are
	 		no jumps after this state and the state is accepting.
	 */
	
		/**
	 	On the given symbol(s), this machine should go to the given state
	 		@method on
	 	@param {Array|Mixed} symbol
	 	@param {BaseState} state Note that the type of this state should be the
	 		same as the current instance (i.e., don't pass in a different
	 		subclass)
	 */
		on: function on(symbol, state) {
			if (symbol instanceof Array) {
				for (var i = 0; i < symbol.length; i++) {
					this.j.push([symbol[i], state]);
				}
				return this;
			}
			this.j.push([symbol, state]);
			return this;
		},
	
	
		/**
	 	Given the next item, returns next state for that item
	 	@method next
	 	@param {Mixed} item Should be an instance of the symbols handled by
	 		this particular machine.
	 	@return {State} state Returns false if no jumps are available
	 */
		next: function next(item) {
			for (var i = 0; i < this.j.length; i++) {
				var jump = this.j[i];
				var symbol = jump[0]; // Next item to check for
				var state = jump[1]; // State to jump to if items match
	
				// compare item with symbol
				if (this.test(item, symbol)) {
					return state;
				}
			}
	
			// Nowhere left to jump!
			return this.defaultTransition;
		},
	
	
		/**
	 	Does this state accept?
	 	`true` only of `this.T` exists
	 		@method accepts
	 	@return {Boolean}
	 */
		accepts: function accepts() {
			return !!this.T;
		},
	
	
		/**
	 	Determine whether a given item "symbolizes" the symbol, where symbol is
	 	a class of items handled by this state machine.
	 		This method should be overriden in extended classes.
	 		@method test
	 	@param {Mixed} item Does this item match the given symbol?
	 	@param {Mixed} symbol
	 	@return {Boolean}
	 */
		test: function test(item, symbol) {
			return item === symbol;
		},
	
	
		/**
	 	Emit the token for this State (just return it in this case)
	 	If this emits a token, this instance is an accepting state
	 	@method emit
	 	@return {Class} T
	 */
		emit: function emit() {
			return this.T;
		}
	};
	
	/**
		State machine for string-based input
	
		@class CharacterState
		@extends BaseState
	*/
	var CharacterState = (0, _class.inherits)(BaseState, createStateClass(), {
		/**
	 	Does the given character match the given character or regular
	 	expression?
	 		@method test
	 	@param {String} char
	 	@param {String|RegExp} charOrRegExp
	 	@return {Boolean}
	 */
		test: function test(character, charOrRegExp) {
			return character === charOrRegExp || charOrRegExp instanceof RegExp && charOrRegExp.test(character);
		}
	});
	
	/**
		State machine for input in the form of TextTokens
	
		@class TokenState
		@extends BaseState
	*/
	var TokenState = (0, _class.inherits)(BaseState, createStateClass(), {
	
		/**
	  * Similar to `on`, but returns the state the results in the transition from
	  * the given item
	  * @method jump
	  * @param {Mixed} item
	  * @param {Token} [token]
	  * @return state
	  */
		jump: function jump(token) {
			var tClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
			var state = this.next(new token('')); // dummy temp token
			if (state === this.defaultTransition) {
				// Make a new state!
				state = new this.constructor(tClass);
				this.on(token, state);
			} else if (tClass) {
				state.T = tClass;
			}
			return state;
		},
	
	
		/**
	 	Is the given token an instance of the given token class?
	 		@method test
	 	@param {TextToken} token
	 	@param {Class} tokenClass
	 	@return {Boolean}
	 */
		test: function test(token, tokenClass) {
			return token instanceof tokenClass;
		}
	});
	
	/**
		Given a non-empty target string, generates states (if required) for each
		consecutive substring of characters in str starting from the beginning of
		the string. The final state will have a special value, as specified in
		options. All other "in between" substrings will have a default end state.
	
		This turns the state machine into a Trie-like data structure (rather than a
		intelligently-designed DFA).
	
		Note that I haven't really tried these with any strings other than
		DOMAIN.
	
		@param {String} str
		@param {CharacterState} start State to jump from the first character
		@param {Class} endToken Token class to emit when the given string has been
			matched and no more jumps exist.
		@param {Class} defaultToken "Filler token", or which token type to emit when
			we don't have a full match
		@return {Array} list of newly-created states
	*/
	function stateify(str, start, endToken, defaultToken) {
		var i = 0,
		    len = str.length,
		    state = start,
		    newStates = [],
		    nextState = void 0;
	
		// Find the next state without a jump to the next character
		while (i < len && (nextState = state.next(str[i]))) {
			state = nextState;
			i++;
		}
	
		if (i >= len) {
			return [];
		} // no new tokens were added
	
		while (i < len - 1) {
			nextState = new CharacterState(defaultToken);
			newStates.push(nextState);
			state.on(str[i], nextState);
			state = nextState;
			i++;
		}
	
		nextState = new CharacterState(endToken);
		newStates.push(nextState);
		state.on(str[len - 1], nextState);
	
		return newStates;
	}
	
	exports.CharacterState = CharacterState;
	exports.TokenState = TokenState;
	exports.stateify = stateify;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function createTokenClass() {
		return function (value) {
			if (value) {
				this.v = value;
			}
		};
	}
	
	exports.createTokenClass = createTokenClass;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(112),
	    root = __webpack_require__(85);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(206),
	    stackClear = __webpack_require__(1111),
	    stackDelete = __webpack_require__(1112),
	    stackGet = __webpack_require__(1113),
	    stackHas = __webpack_require__(1114),
	    stackSet = __webpack_require__(1115);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1059),
	    isArguments = __webpack_require__(317),
	    isArray = __webpack_require__(37),
	    isBuffer = __webpack_require__(481),
	    isIndex = __webpack_require__(312),
	    isTypedArray = __webpack_require__(483);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(473);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(207),
	    arrayIncludes = __webpack_require__(307),
	    arrayIncludesWith = __webpack_require__(308),
	    arrayMap = __webpack_require__(168),
	    baseUnary = __webpack_require__(311),
	    cacheHas = __webpack_require__(209);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(472),
	    toKey = __webpack_require__(212);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(207),
	    arrayIncludes = __webpack_require__(307),
	    arrayIncludesWith = __webpack_require__(308),
	    cacheHas = __webpack_require__(209),
	    createSet = __webpack_require__(1068),
	    setToArray = __webpack_require__(314);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(37),
	    isKey = __webpack_require__(313),
	    stringToPath = __webpack_require__(1117),
	    toString = __webpack_require__(486);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(112);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(207),
	    arraySome = __webpack_require__(1033),
	    cacheHas = __webpack_require__(209);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(137);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(85),
	    stubFalse = __webpack_require__(1130);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234)(module)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObject = __webpack_require__(137);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1048),
	    baseUnary = __webpack_require__(311),
	    nodeUtil = __webpack_require__(1104);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(306);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1060);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(469),
	    baseRest = __webpack_require__(135),
	    isArrayLikeObject = __webpack_require__(213);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var PushProcessor = __webpack_require__(492);
	
	/**
	 * This is an internal module. See {@link MatrixClient} for the public class.
	 * @module client
	 */
	var EventEmitter = __webpack_require__(56).EventEmitter;
	var q = __webpack_require__(6);
	var url = __webpack_require__(149);
	
	var httpApi = __webpack_require__(216);
	var MatrixEvent = __webpack_require__(92).MatrixEvent;
	var EventStatus = __webpack_require__(92).EventStatus;
	var EventTimeline = __webpack_require__(115);
	var SearchResult = __webpack_require__(1146);
	var StubStore = __webpack_require__(1152);
	var webRtcCall = __webpack_require__(495);
	var utils = __webpack_require__(16);
	var contentRepo = __webpack_require__(214);
	var Filter = __webpack_require__(323);
	var SyncApi = __webpack_require__(1153);
	var MatrixBaseApis = __webpack_require__(1133);
	var MatrixError = httpApi.MatrixError;
	
	var SCROLLBACK_DELAY_MS = 3000;
	var CRYPTO_ENABLED = false;
	
	try {
	    var Crypto = __webpack_require__(1139);
	    CRYPTO_ENABLED = true;
	} catch (e) {
	    console.error("olm load error", e);
	    // Olm not installed.
	}
	
	/**
	 * Construct a Matrix Client. Only directly construct this if you want to use
	 * custom modules. Normally, {@link createClient} should be used
	 * as it specifies 'sensible' defaults for these modules.
	 * @constructor
	 * @extends {external:EventEmitter}
	 * @extends {module:base-apis~MatrixBaseApis}
	 *
	 * @param {Object} opts The configuration options for this client.
	 * @param {string} opts.baseUrl Required. The base URL to the client-server
	 * HTTP API.
	 * @param {string} opts.idBaseUrl Optional. The base identity server URL for
	 * identity server requests.
	 * @param {Function} opts.request Required. The function to invoke for HTTP
	 * requests. The value of this property is typically <code>require("request")
	 * </code> as it returns a function which meets the required interface. See
	 * {@link requestFunction} for more information.
	 *
	 * @param {string} opts.accessToken The access_token for this user.
	 *
	 * @param {string} opts.userId The user ID for this user.
	 *
	 * @param {Object=} opts.store The data store to use. If not specified,
	 * this client will not store any HTTP responses.
	 *
	 * @param {string=} opts.deviceId A unique identifier for this device; used for
	 *    tracking things like crypto keys and access tokens.  If not specified,
	 *    end-to-end crypto will be disabled.
	 *
	 * @param {Object=} opts.sessionStore A store to be used for end-to-end crypto
	 *    session data. This should be a {@link
	 *    module:store/session/webstorage~WebStorageSessionStore|WebStorageSessionStore},
	 *    or an object implementing the same interface. If not specified,
	 *    end-to-end crypto will be disabled.
	 *
	 * @param {Object} opts.scheduler Optional. The scheduler to use. If not
	 * specified, this client will not retry requests on failure. This client
	 * will supply its own processing function to
	 * {@link module:scheduler~MatrixScheduler#setProcessFunction}.
	 *
	 * @param {Object} opts.queryParams Optional. Extra query parameters to append
	 * to all requests with this client. Useful for application services which require
	 * <code>?user_id=</code>.
	 *
	 * @param {Number=} opts.localTimeoutMs Optional. The default maximum amount of
	 * time to wait before timing out HTTP requests. If not specified, there is no timeout.
	 *
	 * @param {boolean} [opts.timelineSupport = false] Set to true to enable
	 * improved timeline support ({@link
	 * module:client~MatrixClient#getEventTimeline getEventTimeline}). It is
	 * disabled by default for compatibility with older clients - in particular to
	 * maintain support for back-paginating the live timeline after a '/sync'
	 * result with a gap.
	 */
	function MatrixClient(opts) {
	    var _this = this;
	
	    MatrixBaseApis.call(this, opts);
	
	    this.store = opts.store || new StubStore();
	
	    this.deviceId = opts.deviceId || null;
	
	    var userId = opts.userId || null;
	    this.credentials = {
	        userId: userId
	    };
	
	    this.scheduler = opts.scheduler;
	    if (this.scheduler) {
	        (function () {
	            var self = _this;
	            _this.scheduler.setProcessFunction(function (eventToSend) {
	                var room = self.getRoom(eventToSend.getRoomId());
	                if (eventToSend.status !== EventStatus.SENDING) {
	                    _updatePendingEventStatus(room, eventToSend, EventStatus.SENDING);
	                }
	                return _sendEventHttpRequest(self, eventToSend);
	            });
	        })();
	    }
	    this.clientRunning = false;
	
	    this.callList = {
	        // callId: MatrixCall
	    };
	
	    // try constructing a MatrixCall to see if we are running in an environment
	    // which has WebRTC. If we are, listen for and handle m.call.* events.
	    var call = webRtcCall.createNewMatrixCall(this);
	    this._supportsVoip = false;
	    if (call) {
	        setupCallEventHandler(this);
	        this._supportsVoip = true;
	    }
	    this._syncingRetry = null;
	    this._syncApi = null;
	    this._peekSync = null;
	    this._isGuest = false;
	    this._ongoingScrollbacks = {};
	    this.timelineSupport = Boolean(opts.timelineSupport);
	    this.urlPreviewCache = {};
	    this._notifTimelineSet = null;
	
	    this._crypto = null;
	    if (CRYPTO_ENABLED && Boolean(opts.sessionStore) && userId !== null && this.deviceId !== null) {
	        this._crypto = new Crypto(this, this, opts.sessionStore, userId, this.deviceId, this.store);
	
	        this.olmVersion = Crypto.getOlmVersion();
	    }
	}
	utils.inherits(MatrixClient, EventEmitter);
	utils.extend(MatrixClient.prototype, MatrixBaseApis.prototype);
	
	/**
	 * Get the domain for this client's MXID
	 * @return {?string} Domain of this MXID
	 */
	MatrixClient.prototype.getDomain = function () {
	    if (this.credentials && this.credentials.userId) {
	        return this.credentials.userId.replace(/^.*?:/, '');
	    }
	    return null;
	};
	
	/**
	 * Get the local part of the current user ID e.g. "foo" in "@foo:bar".
	 * @return {?string} The user ID localpart or null.
	 */
	MatrixClient.prototype.getUserIdLocalpart = function () {
	    if (this.credentials && this.credentials.userId) {
	        return this.credentials.userId.split(":")[0].substring(1);
	    }
	    return null;
	};
	
	/**
	 * Get the device ID of this client
	 * @return {?string} device ID
	 */
	MatrixClient.prototype.getDeviceId = function () {
	    return this.deviceId;
	};
	
	/**
	 * Check if the runtime environment supports VoIP calling.
	 * @return {boolean} True if VoIP is supported.
	 */
	MatrixClient.prototype.supportsVoip = function () {
	    return this._supportsVoip;
	};
	
	/**
	 * Get the current sync state.
	 * @return {?string} the sync state, which may be null.
	 * @see module:client~MatrixClient#event:"sync"
	 */
	MatrixClient.prototype.getSyncState = function () {
	    if (!this._syncApi) {
	        return null;
	    }
	    return this._syncApi.getSyncState();
	};
	
	/**
	 * Return whether the client is configured for a guest account.
	 * @return {boolean} True if this is a guest access_token (or no token is supplied).
	 */
	MatrixClient.prototype.isGuest = function () {
	    return this._isGuest;
	};
	
	/**
	 * Return the provided scheduler, if any.
	 * @return {?module:scheduler~MatrixScheduler} The scheduler or null
	 */
	MatrixClient.prototype.getScheduler = function () {
	    return this.scheduler;
	};
	
	/**
	 * Set whether this client is a guest account. <b>This method is experimental
	 * and may change without warning.</b>
	 * @param {boolean} isGuest True if this is a guest account.
	 */
	MatrixClient.prototype.setGuest = function (isGuest) {
	    // EXPERIMENTAL:
	    // If the token is a macaroon, it should be encoded in it that it is a 'guest'
	    // access token, which means that the SDK can determine this entirely without
	    // the dev manually flipping this flag.
	    this._isGuest = isGuest;
	};
	
	/**
	 * Retry a backed off syncing request immediately. This should only be used when
	 * the user <b>explicitly</b> attempts to retry their lost connection.
	 * @return {boolean} True if this resulted in a request being retried.
	 */
	MatrixClient.prototype.retryImmediately = function () {
	    return this._syncApi.retryImmediately();
	};
	
	/**
	 * Return the global notification EventTimelineSet, if any
	 *
	 * @return {EventTimelineSet} the globl notification EventTimelineSet
	 */
	MatrixClient.prototype.getNotifTimelineSet = function () {
	    return this._notifTimelineSet;
	};
	
	/**
	 * Set the global notification EventTimelineSet
	 *
	 * @param {EventTimelineSet} notifTimelineSet
	 */
	MatrixClient.prototype.setNotifTimelineSet = function (notifTimelineSet) {
	    this._notifTimelineSet = notifTimelineSet;
	};
	
	// Crypto bits
	// ===========
	
	/**
	 * Is end-to-end crypto enabled for this client.
	 * @return {boolean} True if end-to-end is enabled.
	 */
	MatrixClient.prototype.isCryptoEnabled = function () {
	    return this._crypto !== null;
	};
	
	/**
	 * Get the Ed25519 key for this device
	 *
	 * @return {?string} base64-encoded ed25519 key. Null if crypto is
	 *    disabled.
	 */
	MatrixClient.prototype.getDeviceEd25519Key = function () {
	    if (!this._crypto) {
	        return null;
	    }
	    return this._crypto.getDeviceEd25519Key();
	};
	
	/**
	 * Upload the device keys to the homeserver.
	 * @return {object} A promise that will resolve when the keys are uploaded.
	 */
	MatrixClient.prototype.uploadKeys = function () {
	    if (this._crypto === null) {
	        throw new Error("End-to-end encryption disabled");
	    }
	
	    return this._crypto.uploadDeviceKeys();
	};
	
	/**
	 * Download the keys for a list of users and stores the keys in the session
	 * store.
	 * @param {Array} userIds The users to fetch.
	 * @param {bool} forceDownload Always download the keys even if cached.
	 *
	 * @return {Promise} A promise which resolves to a map userId->deviceId->{@link
	 * module:crypto~DeviceInfo|DeviceInfo}.
	 */
	MatrixClient.prototype.downloadKeys = function (userIds, forceDownload) {
	    if (this._crypto === null) {
	        return q.reject(new Error("End-to-end encryption disabled"));
	    }
	    return this._crypto.downloadKeys(userIds, forceDownload);
	};
	
	/**
	 * List the stored device keys for a user id
	 *
	 * @deprecated prefer {@link module:client#getStoredDevicesForUser}
	 *
	 * @param {string} userId the user to list keys for.
	 *
	 * @return {object[]} list of devices with "id", "verified", "blocked",
	 *    "key", and "display_name" parameters.
	 */
	MatrixClient.prototype.listDeviceKeys = function (userId) {
	    if (this._crypto === null) {
	        throw new Error("End-to-end encryption disabled");
	    }
	    return this._crypto.listDeviceKeys(userId);
	};
	
	/**
	 * Get the stored device keys for a user id
	 *
	 * @param {string} userId the user to list keys for.
	 *
	 * @return {module:crypto-deviceinfo[]} list of devices
	 */
	MatrixClient.prototype.getStoredDevicesForUser = function (userId) {
	    if (this._crypto === null) {
	        throw new Error("End-to-end encryption disabled");
	    }
	    return this._crypto.getStoredDevicesForUser(userId) || [];
	};
	
	/**
	 * Mark the given device as verified
	 *
	 * @param {string} userId owner of the device
	 * @param {string} deviceId unique identifier for the device
	 *
	 * @param {boolean=} verified whether to mark the device as verified. defaults
	 *   to 'true'.
	 *
	 * @fires module:client~event:MatrixClient"deviceVerificationChanged"
	 */
	MatrixClient.prototype.setDeviceVerified = function (userId, deviceId, verified) {
	    if (verified === undefined) {
	        verified = true;
	    }
	    _setDeviceVerification(this, userId, deviceId, verified, null);
	};
	
	/**
	 * Mark the given device as blocked/unblocked
	 *
	 * @param {string} userId owner of the device
	 * @param {string} deviceId unique identifier for the device
	 *
	 * @param {boolean=} blocked whether to mark the device as blocked. defaults
	 *   to 'true'.
	 *
	 * @fires module:client~event:MatrixClient"deviceVerificationChanged"
	 */
	MatrixClient.prototype.setDeviceBlocked = function (userId, deviceId, blocked) {
	    if (blocked === undefined) {
	        blocked = true;
	    }
	    _setDeviceVerification(this, userId, deviceId, null, blocked);
	};
	
	/**
	 * Mark the given device as known/unknown
	 *
	 * @param {string} userId owner of the device
	 * @param {string} deviceId unique identifier for the device
	 *
	 * @param {boolean=} known whether to mark the device as known. defaults
	 *   to 'true'.
	 *
	 * @fires module:client~event:MatrixClient"deviceVerificationChanged"
	 */
	MatrixClient.prototype.setDeviceKnown = function (userId, deviceId, known) {
	    if (known === undefined) {
	        known = true;
	    }
	    _setDeviceVerification(this, userId, deviceId, null, null, known);
	};
	
	function _setDeviceVerification(client, userId, deviceId, verified, blocked, known) {
	    if (!client._crypto) {
	        throw new Error("End-to-End encryption disabled");
	    }
	    var dev = client._crypto.setDeviceVerification(userId, deviceId, verified, blocked, known);
	    client.emit("deviceVerificationChanged", userId, deviceId, dev);
	}
	
	/**
	 * Set the global override for whether the client should ever send encrypted
	 * messages to unverified devices.  If false, it can still be overridden
	 * per-room.  If true, it overrides the per-room settings.
	 *
	 * @param {boolean} value whether to unilaterally blacklist all
	 * unverified devices
	 */
	MatrixClient.prototype.setGlobalBlacklistUnverifiedDevices = function (value) {
	    if (this._crypto === null) {
	        throw new Error("End-to-end encryption disabled");
	    }
	    this._crypto.setGlobalBlacklistUnverifiedDevices(value);
	};
	
	/**
	 * @return {boolean} whether to unilaterally blacklist all
	 * unverified devices
	 */
	MatrixClient.prototype.getGlobalBlacklistUnverifiedDevices = function () {
	    if (this._crypto === null) {
	        throw new Error("End-to-end encryption disabled");
	    }
	    return this._crypto.getGlobalBlacklistUnverifiedDevices();
	};
	
	/**
	 * Get e2e information on the device that sent an event
	 *
	 * @param {MatrixEvent} event event to be checked
	 *
	 * @return {module:crypto/deviceinfo?}
	 */
	MatrixClient.prototype.getEventSenderDeviceInfo = function (event) {
	    if (!this._crypto) {
	        return null;
	    }
	
	    return this._crypto.getEventSenderDeviceInfo(event);
	};
	
	/**
	 * Check if the sender of an event is verified
	 *
	 * @param {MatrixEvent} event event to be checked
	 *
	 * @return {boolean} true if the sender of this event has been verified using
	 * {@link module:client~MatrixClient#setDeviceVerified|setDeviceVerified}.
	 */
	MatrixClient.prototype.isEventSenderVerified = function (event) {
	    var device = this.getEventSenderDeviceInfo(event);
	    if (!device) {
	        return false;
	    }
	    return device.isVerified();
	};
	
	/**
	 * Enable end-to-end encryption for a room.
	 * @param {string} roomId The room ID to enable encryption in.
	 * @param {object} config The encryption config for the room.
	 * @return {Object} A promise that will resolve when encryption is setup.
	 */
	MatrixClient.prototype.setRoomEncryption = function (roomId, config) {
	    if (!this._crypto) {
	        throw new Error("End-to-End encryption disabled");
	    }
	    this._crypto.setRoomEncryption(roomId, config);
	    return q();
	};
	
	/**
	 * Whether encryption is enabled for a room.
	 * @param {string} roomId the room id to query.
	 * @return {bool} whether encryption is enabled.
	 */
	MatrixClient.prototype.isRoomEncrypted = function (roomId) {
	    if (!this._crypto) {
	        return false;
	    }
	
	    return this._crypto.isRoomEncrypted(roomId);
	};
	
	/**
	 * Get a list containing all of the room keys
	 *
	 * This should be encrypted before returning it to the user.
	 *
	 * @return {module:client.Promise} a promise which resolves to a list of
	 *    session export objects
	 */
	MatrixClient.prototype.exportRoomKeys = function () {
	    if (!this._crypto) {
	        return q.reject(new Error("End-to-end encryption disabled"));
	    }
	    return this._crypto.exportRoomKeys();
	};
	
	/**
	 * Import a list of room keys previously exported by exportRoomKeys
	 *
	 * @param {Object[]} keys a list of session export objects
	 */
	MatrixClient.prototype.importRoomKeys = function (keys) {
	    if (!this._crypto) {
	        throw new Error("End-to-end encryption disabled");
	    }
	    this._crypto.importRoomKeys(keys);
	};
	
	/**
	 * Decrypt a received event according to the algorithm specified in the event.
	 *
	 * @param {MatrixClient} client
	 * @param {MatrixEvent} event
	 */
	function _decryptEvent(client, event) {
	    if (!client._crypto) {
	        _badEncryptedMessage(event, "Encryption not enabled");
	        return;
	    }
	
	    try {
	        client._crypto.decryptEvent(event);
	    } catch (e) {
	        console.warn("Error decrypting event (id=" + event.getId() + "): " + e);
	        if (!(e instanceof Crypto.DecryptionError)) {
	            throw e;
	        }
	        _badEncryptedMessage(event, e.message);
	        return;
	    }
	}
	
	function _badEncryptedMessage(event, reason) {
	    event.setClearData({
	        type: "m.room.message",
	        content: {
	            msgtype: "m.bad.encrypted",
	            body: "** Unable to decrypt: " + reason + " **"
	        }
	    });
	}
	
	// Room ops
	// ========
	
	/**
	 * Get the room for the given room ID.
	 * This function will return a valid room for any room for which a Room event
	 * has been emitted. Note in particular that other events, eg. RoomState.members
	 * will be emitted for a room before this function will return the given room.
	 * @param {string} roomId The room ID
	 * @return {Room} The Room or null if it doesn't exist or there is no data store.
	 */
	MatrixClient.prototype.getRoom = function (roomId) {
	    return this.store.getRoom(roomId);
	};
	
	/**
	 * Retrieve all known rooms.
	 * @return {Room[]} A list of rooms, or an empty list if there is no data store.
	 */
	MatrixClient.prototype.getRooms = function () {
	    return this.store.getRooms();
	};
	
	/**
	 * Retrieve a user.
	 * @param {string} userId The user ID to retrieve.
	 * @return {?User} A user or null if there is no data store or the user does
	 * not exist.
	 */
	MatrixClient.prototype.getUser = function (userId) {
	    return this.store.getUser(userId);
	};
	
	/**
	 * Retrieve all known users.
	 * @return {User[]} A list of users, or an empty list if there is no data store.
	 */
	MatrixClient.prototype.getUsers = function () {
	    return this.store.getUsers();
	};
	
	// User Account Data operations
	// ============================
	
	/**
	 * Set account data event for the current user.
	 * @param {string} eventType The event type
	 * @param {Object} contents the contents object for the event
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setAccountData = function (eventType, contents, callback) {
	    var path = utils.encodeUri("/user/$userId/account_data/$type", {
	        $userId: this.credentials.userId,
	        $type: eventType
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, contents);
	};
	
	/**
	 * Get account data event of given type for the current user.
	 * @param {string} eventType The event type
	 * @param {module:client.callback} callback Optional.
	 * @return {?object} The contents of the given account data event
	 */
	MatrixClient.prototype.getAccountData = function (eventType) {
	    return this.store.getAccountData(eventType);
	};
	
	// Room operations
	// ===============
	
	/**
	 * Join a room. If you have already joined the room, this will no-op.
	 * @param {string} roomIdOrAlias The room ID or room alias to join.
	 * @param {Object} opts Options when joining the room.
	 * @param {boolean} opts.syncRoom True to do a room initial sync on the resulting
	 * room. If false, the <strong>returned Room object will have no current state.
	 * </strong> Default: true.
	 * @param {boolean} opts.inviteSignUrl If the caller has a keypair 3pid invite,
	 *                                     the signing URL is passed in this parameter.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Room object.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.joinRoom = function (roomIdOrAlias, opts, callback) {
	    // to help people when upgrading..
	    if (utils.isFunction(opts)) {
	        throw new Error("Expected 'opts' object, got function.");
	    }
	    opts = opts || {};
	    if (opts.syncRoom === undefined) {
	        opts.syncRoom = true;
	    }
	
	    var room = this.getRoom(roomIdOrAlias);
	    if (room && room.hasMembershipState(this.credentials.userId, "join")) {
	        return q(room);
	    }
	
	    var sign_promise = q();
	
	    if (opts.inviteSignUrl) {
	        sign_promise = this._http.requestOtherUrl(undefined, 'POST', opts.inviteSignUrl, { mxid: this.credentials.userId });
	    }
	
	    var defer = q.defer();
	
	    var self = this;
	    sign_promise.then(function (signed_invite_object) {
	        var data = {};
	        if (signed_invite_object) {
	            data.third_party_signed = signed_invite_object;
	        }
	
	        var path = utils.encodeUri("/join/$roomid", { $roomid: roomIdOrAlias });
	        return self._http.authedRequest(undefined, "POST", path, undefined, data);
	    }).then(function (res) {
	        var roomId = res.room_id;
	        var syncApi = new SyncApi(self, self._clientOpts);
	        var room = syncApi.createRoom(roomId);
	        if (opts.syncRoom) {
	            // v2 will do this for us
	            // return syncApi.syncRoom(room);
	        }
	        return q(room);
	    }).done(function (room) {
	        _resolve(callback, defer, room);
	    }, function (err) {
	        _reject(callback, defer, err);
	    });
	    return defer.promise;
	};
	
	/**
	 * Resend an event.
	 * @param {MatrixEvent} event The event to resend.
	 * @param {Room} room Optional. The room the event is in. Will update the
	 * timeline entry if provided.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.resendEvent = function (event, room) {
	    _updatePendingEventStatus(room, event, EventStatus.SENDING);
	    return _sendEvent(this, room, event);
	};
	
	/**
	 * Cancel a queued or unsent event.
	 *
	 * @param {MatrixEvent} event   Event to cancel
	 * @throws Error if the event is not in QUEUED or NOT_SENT state
	 */
	MatrixClient.prototype.cancelPendingEvent = function (event) {
	    if ([EventStatus.QUEUED, EventStatus.NOT_SENT].indexOf(event.status) < 0) {
	        throw new Error("cannot cancel an event with status " + event.status);
	    }
	
	    // first tell the scheduler to forget about it, if it's queued
	    if (this.scheduler) {
	        this.scheduler.removeEventFromQueue(event);
	    }
	
	    // then tell the room about the change of state, which will remove it
	    // from the room's list of pending events.
	    var room = this.getRoom(event.getRoomId());
	    _updatePendingEventStatus(room, event, EventStatus.CANCELLED);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} name
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomName = function (roomId, name, callback) {
	    return this.sendStateEvent(roomId, "m.room.name", { name: name }, undefined, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} topic
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomTopic = function (roomId, topic, callback) {
	    return this.sendStateEvent(roomId, "m.room.topic", { topic: topic }, undefined, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getRoomTags = function (roomId, callback) {
	    var path = utils.encodeUri("/user/$userId/rooms/$roomId/tags/", {
	        $userId: this.credentials.userId,
	        $roomId: roomId
	    });
	    return this._http.authedRequest(callback, "GET", path, undefined);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} tagName name of room tag to be set
	 * @param {object} metadata associated with that tag to be stored
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomTag = function (roomId, tagName, metadata, callback) {
	    var path = utils.encodeUri("/user/$userId/rooms/$roomId/tags/$tag", {
	        $userId: this.credentials.userId,
	        $roomId: roomId,
	        $tag: tagName
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, metadata);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} tagName name of room tag to be removed
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.deleteRoomTag = function (roomId, tagName, callback) {
	    var path = utils.encodeUri("/user/$userId/rooms/$roomId/tags/$tag", {
	        $userId: this.credentials.userId,
	        $roomId: roomId,
	        $tag: tagName
	    });
	    return this._http.authedRequest(callback, "DELETE", path, undefined, undefined);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventType event type to be set
	 * @param {object} content event content
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomAccountData = function (roomId, eventType, content, callback) {
	    var path = utils.encodeUri("/user/$userId/rooms/$roomId/account_data/$type", {
	        $userId: this.credentials.userId,
	        $roomId: roomId,
	        $type: eventType
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, content);
	};
	
	/**
	 * Set a user's power level.
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {Number} powerLevel
	 * @param {MatrixEvent} event
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setPowerLevel = function (roomId, userId, powerLevel, event, callback) {
	    var content = {
	        users: {}
	    };
	    if (event && event.getType() === "m.room.power_levels") {
	        // take a copy of the content to ensure we don't corrupt
	        // existing client state with a failed power level change
	        content = utils.deepCopy(event.getContent());
	    }
	    content.users[userId] = powerLevel;
	    var path = utils.encodeUri("/rooms/$roomId/state/m.room.power_levels", {
	        $roomId: roomId
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, content);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventType
	 * @param {Object} content
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendEvent = function (roomId, eventType, content, txnId, callback) {
	    if (utils.isFunction(txnId)) {
	        callback = txnId;txnId = undefined;
	    }
	
	    if (!txnId) {
	        txnId = this.makeTxnId();
	    }
	
	    // we always construct a MatrixEvent when sending because the store and
	    // scheduler use them. We'll extract the params back out if it turns out
	    // the client has no scheduler or store.
	    var room = this.getRoom(roomId);
	    var localEvent = new MatrixEvent({
	        event_id: "~" + roomId + ":" + txnId,
	        user_id: this.credentials.userId,
	        room_id: roomId,
	        type: eventType,
	        origin_server_ts: new Date().getTime(),
	        content: content
	    });
	    localEvent._txnId = txnId;
	    localEvent.status = EventStatus.SENDING;
	
	    // add this event immediately to the local store as 'sending'.
	    if (room) {
	        room.addPendingEvent(localEvent, txnId);
	    }
	
	    return _sendEvent(this, room, localEvent, callback);
	};
	
	// encrypts the event if necessary
	// adds the event to the queue, or sends it
	// marks the event as sent/unsent
	// returns a promise which resolves with the result of the send request
	function _sendEvent(client, room, event, callback) {
	    // Add an extra q() to turn synchronous exceptions into promise rejections,
	    // so that we can handle synchronous and asynchronous exceptions with the
	    // same code path.
	    return q().then(function () {
	        var encryptionPromise = null;
	        if (client._crypto) {
	            encryptionPromise = client._crypto.encryptEventIfNeeded(event, room);
	        }
	        if (encryptionPromise) {
	            _updatePendingEventStatus(room, event, EventStatus.ENCRYPTING);
	            encryptionPromise = encryptionPromise.then(function () {
	                _updatePendingEventStatus(room, event, EventStatus.SENDING);
	            });
	        }
	        return encryptionPromise;
	    }).then(function () {
	        var promise = void 0;
	        // this event may be queued
	        if (client.scheduler) {
	            // if this returns a promsie then the scheduler has control now and will
	            // resolve/reject when it is done. Internally, the scheduler will invoke
	            // processFn which is set to this._sendEventHttpRequest so the same code
	            // path is executed regardless.
	            promise = client.scheduler.queueEvent(event);
	            if (promise && client.scheduler.getQueueForEvent(event).length > 1) {
	                // event is processed FIFO so if the length is 2 or more we know
	                // this event is stuck behind an earlier event.
	                _updatePendingEventStatus(room, event, EventStatus.QUEUED);
	            }
	        }
	
	        if (!promise) {
	            promise = _sendEventHttpRequest(client, event);
	        }
	        return promise;
	    }).then(function (res) {
	        // the request was sent OK
	        if (room) {
	            room.updatePendingEvent(event, EventStatus.SENT, res.event_id);
	        }
	        if (callback) {
	            callback(null, res);
	        }
	        return res;
	    }, function (err) {
	        // the request failed to send.
	        console.error("Error sending event", err.stack || err);
	
	        try {
	            _updatePendingEventStatus(room, event, EventStatus.NOT_SENT);
	            event.error = err;
	
	            if (callback) {
	                callback(err);
	            }
	        } catch (err2) {
	            console.error("Exception in error handler!", err2.stack || err);
	        }
	        throw err;
	    });
	}
	
	function _updatePendingEventStatus(room, event, newStatus) {
	    if (room) {
	        room.updatePendingEvent(event, newStatus);
	    } else {
	        event.status = newStatus;
	    }
	}
	
	function _sendEventHttpRequest(client, event) {
	    var txnId = event._txnId ? event._txnId : client.makeTxnId();
	
	    var pathParams = {
	        $roomId: event.getRoomId(),
	        $eventType: event.getWireType(),
	        $stateKey: event.getStateKey(),
	        $txnId: txnId
	    };
	
	    var path = void 0;
	
	    if (event.isState()) {
	        var pathTemplate = "/rooms/$roomId/state/$eventType";
	        if (event.getStateKey() && event.getStateKey().length > 0) {
	            pathTemplate = "/rooms/$roomId/state/$eventType/$stateKey";
	        }
	        path = utils.encodeUri(pathTemplate, pathParams);
	    } else {
	        path = utils.encodeUri("/rooms/$roomId/send/$eventType/$txnId", pathParams);
	    }
	
	    return client._http.authedRequest(undefined, "PUT", path, undefined, event.getWireContent());
	}
	
	/**
	 * @param {string} roomId
	 * @param {Object} content
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendMessage = function (roomId, content, txnId, callback) {
	    if (utils.isFunction(txnId)) {
	        callback = txnId;txnId = undefined;
	    }
	    return this.sendEvent(roomId, "m.room.message", content, txnId, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendTextMessage = function (roomId, body, txnId, callback) {
	    var content = {
	        msgtype: "m.text",
	        body: body
	    };
	    return this.sendMessage(roomId, content, txnId, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendNotice = function (roomId, body, txnId, callback) {
	    var content = {
	        msgtype: "m.notice",
	        body: body
	    };
	    return this.sendMessage(roomId, content, txnId, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendEmoteMessage = function (roomId, body, txnId, callback) {
	    var content = {
	        msgtype: "m.emote",
	        body: body
	    };
	    return this.sendMessage(roomId, content, txnId, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} url
	 * @param {Object} info
	 * @param {string} text
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendImageMessage = function (roomId, url, info, text, callback) {
	    if (utils.isFunction(text)) {
	        callback = text;text = undefined;
	    }
	    if (!text) {
	        text = "Image";
	    }
	    var content = {
	        msgtype: "m.image",
	        url: url,
	        info: info,
	        body: text
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} htmlBody
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendHtmlMessage = function (roomId, body, htmlBody, callback) {
	    var content = {
	        msgtype: "m.text",
	        format: "org.matrix.custom.html",
	        body: body,
	        formatted_body: htmlBody
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} htmlBody
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendHtmlNotice = function (roomId, body, htmlBody, callback) {
	    var content = {
	        msgtype: "m.notice",
	        format: "org.matrix.custom.html",
	        body: body,
	        formatted_body: htmlBody
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} htmlBody
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendHtmlEmote = function (roomId, body, htmlBody, callback) {
	    var content = {
	        msgtype: "m.emote",
	        format: "org.matrix.custom.html",
	        body: body,
	        formatted_body: htmlBody
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * Send a receipt.
	 * @param {Event} event The event being acknowledged
	 * @param {string} receiptType The kind of receipt e.g. "m.read"
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendReceipt = function (event, receiptType, callback) {
	    if (this.isGuest()) {
	        return q({}); // guests cannot send receipts so don't bother.
	    }
	
	    var path = utils.encodeUri("/rooms/$roomId/receipt/$receiptType/$eventId", {
	        $roomId: event.getRoomId(),
	        $receiptType: receiptType,
	        $eventId: event.getId()
	    });
	    var promise = this._http.authedRequest(callback, "POST", path, undefined, {});
	
	    var room = this.getRoom(event.getRoomId());
	    if (room) {
	        room._addLocalEchoReceipt(this.credentials.userId, event, receiptType);
	    }
	    return promise;
	};
	
	/**
	 * Send a read receipt.
	 * @param {Event} event The event that has been read.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendReadReceipt = function (event, callback) {
	    return this.sendReceipt(event, "m.read", callback);
	};
	
	/**
	 * Get a preview of the given URL as of (roughly) the given point in time,
	 * described as an object with OpenGraph keys and associated values.
	 * Attributes may be synthesized where actual OG metadata is lacking.
	 * Caches results to prevent hammering the server.
	 * @param {string} url The URL to get preview data for
	 * @param {Number} ts The preferred point in time that the preview should
	 * describe (ms since epoch).  The preview returned will either be the most
	 * recent one preceding this timestamp if available, or failing that the next
	 * most recent available preview.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Object of OG metadata.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 * May return synthesized attributes if the URL lacked OG meta.
	 */
	MatrixClient.prototype.getUrlPreview = function (url, ts, callback) {
	    var key = ts + "_" + url;
	    var og = this.urlPreviewCache[key];
	    if (og) {
	        return q(og);
	    }
	
	    var self = this;
	    return this._http.authedRequestWithPrefix(callback, "GET", "/preview_url", {
	        url: url,
	        ts: ts
	    }, undefined, httpApi.PREFIX_MEDIA_R0).then(function (response) {
	        // TODO: expire cache occasionally
	        self.urlPreviewCache[key] = response;
	        return response;
	    });
	};
	
	/**
	 * @param {string} roomId
	 * @param {boolean} isTyping
	 * @param {Number} timeoutMs
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendTyping = function (roomId, isTyping, timeoutMs, callback) {
	    if (this.isGuest()) {
	        return q({}); // guests cannot send typing notifications so don't bother.
	    }
	
	    var path = utils.encodeUri("/rooms/$roomId/typing/$userId", {
	        $roomId: roomId,
	        $userId: this.credentials.userId
	    });
	    var data = {
	        typing: isTyping
	    };
	    if (isTyping) {
	        data.timeout = timeoutMs ? timeoutMs : 20000;
	    }
	    return this._http.authedRequest(callback, "PUT", path, undefined, data);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.invite = function (roomId, userId, callback) {
	    return _membershipChange(this, roomId, userId, "invite", undefined, callback);
	};
	
	/**
	 * Invite a user to a room based on their email address.
	 * @param {string} roomId The room to invite the user to.
	 * @param {string} email The email address to invite.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.inviteByEmail = function (roomId, email, callback) {
	    return this.inviteByThreePid(roomId, "email", email, callback);
	};
	
	/**
	 * Invite a user to a room based on a third-party identifier.
	 * @param {string} roomId The room to invite the user to.
	 * @param {string} medium The medium to invite the user e.g. "email".
	 * @param {string} address The address for the specified medium.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.inviteByThreePid = function (roomId, medium, address, callback) {
	    var path = utils.encodeUri("/rooms/$roomId/invite", { $roomId: roomId });
	
	    var identityServerUrl = this.getIdentityServerUrl();
	    if (!identityServerUrl) {
	        return q.reject(new MatrixError({
	            error: "No supplied identity server URL",
	            errcode: "ORG.MATRIX.JSSDK_MISSING_PARAM"
	        }));
	    }
	    if (identityServerUrl.indexOf("http://") === 0 || identityServerUrl.indexOf("https://") === 0) {
	        // this request must not have the protocol part because reasons
	        identityServerUrl = identityServerUrl.split("://")[1];
	    }
	
	    return this._http.authedRequest(callback, "POST", path, undefined, {
	        id_server: identityServerUrl,
	        medium: medium,
	        address: address
	    });
	};
	
	/**
	 * @param {string} roomId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.leave = function (roomId, callback) {
	    return _membershipChange(this, roomId, undefined, "leave", undefined, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} reason Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.ban = function (roomId, userId, reason, callback) {
	    return _membershipChange(this, roomId, userId, "ban", reason, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {boolean} deleteRoom True to delete the room from the store on success.
	 * Default: true.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.forget = function (roomId, deleteRoom, callback) {
	    if (deleteRoom === undefined) {
	        deleteRoom = true;
	    }
	    var promise = _membershipChange(this, roomId, undefined, "forget", undefined, callback);
	    if (!deleteRoom) {
	        return promise;
	    }
	    var self = this;
	    return promise.then(function (response) {
	        self.store.removeRoom(roomId);
	        self.emit("deleteRoom", roomId);
	        return response;
	    });
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Object (currently empty)
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.unban = function (roomId, userId, callback) {
	    // unbanning != set their state to leave: this used to be
	    // the case, but was then changed so that leaving was always
	    // a revoking of priviledge, otherwise two people racing to
	    // kick / ban someone could end up banning and then un-banning
	    // them.
	    var path = utils.encodeUri("/rooms/$roomId/unban", {
	        $roomId: roomId
	    });
	    var data = {
	        user_id: userId
	    };
	    return this._http.authedRequest(callback, "POST", path, undefined, data);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} reason Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.kick = function (roomId, userId, reason, callback) {
	    return _setMembershipState(this, roomId, userId, "leave", reason, callback);
	};
	
	/**
	 * This is an internal method.
	 * @param {MatrixClient} client
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} membershipValue
	 * @param {string} reason
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	function _setMembershipState(client, roomId, userId, membershipValue, reason, callback) {
	    if (utils.isFunction(reason)) {
	        callback = reason;reason = undefined;
	    }
	
	    var path = utils.encodeUri("/rooms/$roomId/state/m.room.member/$userId", { $roomId: roomId, $userId: userId });
	
	    return client._http.authedRequest(callback, "PUT", path, undefined, {
	        membership: membershipValue,
	        reason: reason
	    });
	}
	
	/**
	 * This is an internal method.
	 * @param {MatrixClient} client
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} membership
	 * @param {string} reason
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	function _membershipChange(client, roomId, userId, membership, reason, callback) {
	    if (utils.isFunction(reason)) {
	        callback = reason;reason = undefined;
	    }
	
	    var path = utils.encodeUri("/rooms/$room_id/$membership", {
	        $room_id: roomId,
	        $membership: membership
	    });
	    return client._http.authedRequest(callback, "POST", path, undefined, {
	        user_id: userId, // may be undefined e.g. on leave
	        reason: reason
	    });
	}
	
	/**
	 * Obtain a dict of actions which should be performed for this event according
	 * to the push rules for this user.  Caches the dict on the event.
	 * @param {MatrixEvent} event The event to get push actions for.
	 * @return {module:pushprocessor~PushAction} A dict of actions to perform.
	 */
	MatrixClient.prototype.getPushActionsForEvent = function (event) {
	    if (!event.getPushActions()) {
	        var pushProcessor = new PushProcessor(this);
	        event.setPushActions(pushProcessor.actionsForEvent(event));
	    }
	    return event.getPushActions();
	};
	
	// Profile operations
	// ==================
	
	/**
	 * @param {string} info The kind of info to set (e.g. 'avatar_url')
	 * @param {Object} data The JSON object to set.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setProfileInfo = function (info, data, callback) {
	    var path = utils.encodeUri("/profile/$userId/$info", {
	        $userId: this.credentials.userId,
	        $info: info
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, data);
	};
	
	/**
	 * @param {string} name
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setDisplayName = function (name, callback) {
	    return this.setProfileInfo("displayname", { displayname: name }, callback);
	};
	
	/**
	 * @param {string} url
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setAvatarUrl = function (url, callback) {
	    return this.setProfileInfo("avatar_url", { avatar_url: url }, callback);
	};
	
	/**
	 * Turn an MXC URL into an HTTP one. <strong>This method is experimental and
	 * may change.</strong>
	 * @param {string} mxcUrl The MXC URL
	 * @param {Number} width The desired width of the thumbnail.
	 * @param {Number} height The desired height of the thumbnail.
	 * @param {string} resizeMethod The thumbnail resize method to use, either
	 * "crop" or "scale".
	 * @param {Boolean} allowDirectLinks If true, return any non-mxc URLs
	 * directly. Fetching such URLs will leak information about the user to
	 * anyone they share a room with. If false, will return null for such URLs.
	 * @return {?string} the avatar URL or null.
	 */
	MatrixClient.prototype.mxcUrlToHttp = function (mxcUrl, width, height, resizeMethod, allowDirectLinks) {
	    return contentRepo.getHttpUriForMxc(this.baseUrl, mxcUrl, width, height, resizeMethod, allowDirectLinks);
	};
	
	/**
	 * @param {Object} opts Options to apply
	 * @param {string} opts.presence One of "online", "offline" or "unavailable"
	 * @param {string} opts.status_msg The status message to attach.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 * @throws If 'presence' isn't a valid presence enum value.
	 */
	MatrixClient.prototype.setPresence = function (opts, callback) {
	    var path = utils.encodeUri("/presence/$userId/status", {
	        $userId: this.credentials.userId
	    });
	
	    if (typeof opts === "string") {
	        opts = { presence: opts };
	    }
	
	    var validStates = ["offline", "online", "unavailable"];
	    if (validStates.indexOf(opts.presence) == -1) {
	        throw new Error("Bad presence value: " + opts.presence);
	    }
	    return this._http.authedRequest(callback, "PUT", path, undefined, opts);
	};
	
	function _presenceList(callback, client, opts, method) {
	    var path = utils.encodeUri("/presence/list/$userId", {
	        $userId: client.credentials.userId
	    });
	    return client._http.authedRequest(callback, method, path, undefined, opts);
	}
	
	/**
	* Retrieve current user presence list.
	* @param {module:client.callback} callback Optional.
	* @return {module:client.Promise} Resolves: TODO
	* @return {module:http-api.MatrixError} Rejects: with an error response.
	*/
	MatrixClient.prototype.getPresenceList = function (callback) {
	    return _presenceList(callback, this, undefined, "GET");
	};
	
	/**
	* Add users to the current user presence list.
	* @param {module:client.callback} callback Optional.
	* @param {string[]} userIds
	* @return {module:client.Promise} Resolves: TODO
	* @return {module:http-api.MatrixError} Rejects: with an error response.
	*/
	MatrixClient.prototype.inviteToPresenceList = function (callback, userIds) {
	    var opts = { "invite": userIds };
	    return _presenceList(callback, this, opts, "POST");
	};
	
	/**
	* Drop users from the current user presence list.
	* @param {module:client.callback} callback Optional.
	* @param {string[]} userIds
	* @return {module:client.Promise} Resolves: TODO
	* @return {module:http-api.MatrixError} Rejects: with an error response.
	**/
	MatrixClient.prototype.dropFromPresenceList = function (callback, userIds) {
	    var opts = { "drop": userIds };
	    return _presenceList(callback, this, opts, "POST");
	};
	
	/**
	 * Retrieve older messages from the given room and put them in the timeline.
	 *
	 * If this is called multiple times whilst a request is ongoing, the <i>same</i>
	 * Promise will be returned. If there was a problem requesting scrollback, there
	 * will be a small delay before another request can be made (to prevent tight-looping
	 * when there is no connection).
	 *
	 * @param {Room} room The room to get older messages in.
	 * @param {Integer} limit Optional. The maximum number of previous events to
	 * pull in. Default: 30.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Room. If you are at the beginning
	 * of the timeline, <code>Room.oldState.paginationToken</code> will be
	 * <code>null</code>.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.scrollback = function (room, limit, callback) {
	    if (utils.isFunction(limit)) {
	        callback = limit;limit = undefined;
	    }
	    limit = limit || 30;
	    var timeToWaitMs = 0;
	
	    var info = this._ongoingScrollbacks[room.roomId] || {};
	    if (info.promise) {
	        return info.promise;
	    } else if (info.errorTs) {
	        var timeWaitedMs = Date.now() - info.errorTs;
	        timeToWaitMs = Math.max(SCROLLBACK_DELAY_MS - timeWaitedMs, 0);
	    }
	
	    if (room.oldState.paginationToken === null) {
	        return q(room); // already at the start.
	    }
	    // attempt to grab more events from the store first
	    var numAdded = this.store.scrollback(room, limit).length;
	    if (numAdded === limit) {
	        // store contained everything we needed.
	        return q(room);
	    }
	    // reduce the required number of events appropriately
	    limit = limit - numAdded;
	
	    var path = utils.encodeUri("/rooms/$roomId/messages", { $roomId: room.roomId });
	    var params = {
	        from: room.oldState.paginationToken,
	        limit: limit,
	        dir: 'b'
	    };
	    var defer = q.defer();
	    info = {
	        promise: defer.promise,
	        errorTs: null
	    };
	    var self = this;
	    // wait for a time before doing this request
	    // (which may be 0 in order not to special case the code paths)
	    q.delay(timeToWaitMs).then(function () {
	        return self._http.authedRequest(callback, "GET", path, params);
	    }).done(function (res) {
	        var matrixEvents = utils.map(res.chunk, _PojoToMatrixEventMapper(self));
	        room.addEventsToTimeline(matrixEvents, true, room.getLiveTimeline());
	        room.oldState.paginationToken = res.end;
	        if (res.chunk.length === 0) {
	            room.oldState.paginationToken = null;
	        }
	        self.store.storeEvents(room, matrixEvents, res.end, true);
	        self._ongoingScrollbacks[room.roomId] = null;
	        _resolve(callback, defer, room);
	    }, function (err) {
	        self._ongoingScrollbacks[room.roomId] = {
	            errorTs: Date.now()
	        };
	        _reject(callback, defer, err);
	    });
	    this._ongoingScrollbacks[room.roomId] = info;
	    return defer.promise;
	};
	
	/**
	 * Take an EventContext, and back/forward-fill results.
	 *
	 * @param {module:models/event-context.EventContext} eventContext  context
	 *    object to be updated
	 * @param {Object}  opts
	 * @param {boolean} opts.backwards  true to fill backwards, false to go forwards
	 * @param {boolean} opts.limit      number of events to request
	 *
	 * @return {module:client.Promise} Resolves: updated EventContext object
	 * @return {Error} Rejects: with an error response.
	 */
	MatrixClient.prototype.paginateEventContext = function (eventContext, opts) {
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	    opts = opts || {};
	    var backwards = opts.backwards || false;
	
	    var token = eventContext.getPaginateToken(backwards);
	    if (!token) {
	        // no more results.
	        return q.reject(new Error("No paginate token"));
	    }
	
	    var dir = backwards ? 'b' : 'f';
	    var pendingRequest = eventContext._paginateRequests[dir];
	
	    if (pendingRequest) {
	        // already a request in progress - return the existing promise
	        return pendingRequest;
	    }
	
	    var path = utils.encodeUri("/rooms/$roomId/messages", { $roomId: eventContext.getEvent().getRoomId() });
	    var params = {
	        from: token,
	        limit: 'limit' in opts ? opts.limit : 30,
	        dir: dir
	    };
	
	    var self = this;
	    var promise = self._http.authedRequest(undefined, "GET", path, params).then(function (res) {
	        var token = res.end;
	        if (res.chunk.length === 0) {
	            token = null;
	        } else {
	            var matrixEvents = utils.map(res.chunk, self.getEventMapper());
	            if (backwards) {
	                // eventContext expects the events in timeline order, but
	                // back-pagination returns them in reverse order.
	                matrixEvents.reverse();
	            }
	            eventContext.addEvents(matrixEvents, backwards);
	        }
	        eventContext.setPaginateToken(token, backwards);
	        return eventContext;
	    }).finally(function () {
	        eventContext._paginateRequests[dir] = null;
	    });
	    eventContext._paginateRequests[dir] = promise;
	
	    return promise;
	};
	
	/**
	 * Get an EventTimeline for the given event
	 *
	 * <p>If the EventTimelineSet object already has the given event in its store, the
	 * corresponding timeline will be returned. Otherwise, a /context request is
	 * made, and used to construct an EventTimeline.
	 *
	 * @param {EventTimelineSet} timelineSet  The timelineSet to look for the event in
	 * @param {string} eventId  The ID of the event to look for
	 *
	 * @return {module:client.Promise} Resolves:
	 *    {@link module:models/event-timeline~EventTimeline} including the given
	 *    event
	 */
	MatrixClient.prototype.getEventTimeline = function (timelineSet, eventId) {
	    // don't allow any timeline support unless it's been enabled.
	    if (!this.timelineSupport) {
	        throw new Error("timeline support is disabled. Set the 'timelineSupport'" + " parameter to true when creating MatrixClient to enable" + " it.");
	    }
	
	    if (timelineSet.getTimelineForEvent(eventId)) {
	        return q(timelineSet.getTimelineForEvent(eventId));
	    }
	
	    var path = utils.encodeUri("/rooms/$roomId/context/$eventId", {
	        $roomId: timelineSet.room.roomId,
	        $eventId: eventId
	    });
	
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	    var self = this;
	    var promise = self._http.authedRequest(undefined, "GET", path).then(function (res) {
	        if (!res.event) {
	            throw new Error("'event' not in '/context' result - homeserver too old?");
	        }
	
	        // by the time the request completes, the event might have ended up in
	        // the timeline.
	        if (timelineSet.getTimelineForEvent(eventId)) {
	            return timelineSet.getTimelineForEvent(eventId);
	        }
	
	        // we start with the last event, since that's the point at which we
	        // have known state.
	        // events_after is already backwards; events_before is forwards.
	        res.events_after.reverse();
	        var events = res.events_after.concat([res.event]).concat(res.events_before);
	        var matrixEvents = utils.map(events, self.getEventMapper());
	
	        var timeline = timelineSet.getTimelineForEvent(matrixEvents[0].getId());
	        if (!timeline) {
	            timeline = timelineSet.addTimeline();
	            timeline.initialiseState(utils.map(res.state, self.getEventMapper()));
	            timeline.getState(EventTimeline.FORWARDS).paginationToken = res.end;
	        }
	        timelineSet.addEventsToTimeline(matrixEvents, true, timeline, res.start);
	
	        // there is no guarantee that the event ended up in "timeline" (we
	        // might have switched to a neighbouring timeline) - so check the
	        // room's index again. On the other hand, there's no guarantee the
	        // event ended up anywhere, if it was later redacted, so we just
	        // return the timeline we first thought of.
	        var tl = timelineSet.getTimelineForEvent(eventId) || timeline;
	        return tl;
	    });
	    return promise;
	};
	
	/**
	 * Take an EventTimeline, and back/forward-fill results.
	 *
	 * @param {module:models/event-timeline~EventTimeline} eventTimeline timeline
	 *    object to be updated
	 * @param {Object}   [opts]
	 * @param {bool}     [opts.backwards = false]  true to fill backwards,
	 *    false to go forwards
	 * @param {number}   [opts.limit = 30]         number of events to request
	 *
	 * @return {module:client.Promise} Resolves to a boolean: false if there are no
	 *    events and we reached either end of the timeline; else true.
	 */
	MatrixClient.prototype.paginateEventTimeline = function (eventTimeline, opts) {
	    var isNotifTimeline = eventTimeline.getTimelineSet() === this._notifTimelineSet;
	
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	    opts = opts || {};
	    var backwards = opts.backwards || false;
	
	    if (isNotifTimeline) {
	        if (!backwards) {
	            throw new Error("paginateNotifTimeline can only paginate backwards");
	        }
	    }
	
	    var dir = backwards ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS;
	
	    var token = eventTimeline.getPaginationToken(dir);
	    if (!token) {
	        // no token - no results.
	        return q(false);
	    }
	
	    var pendingRequest = eventTimeline._paginationRequests[dir];
	
	    if (pendingRequest) {
	        // already a request in progress - return the existing promise
	        return pendingRequest;
	    }
	
	    var path = void 0,
	        params = void 0,
	        promise = void 0;
	    var self = this;
	
	    if (isNotifTimeline) {
	        path = "/notifications";
	        params = {
	            limit: 'limit' in opts ? opts.limit : 30,
	            only: 'highlight'
	        };
	
	        if (token && token !== "end") {
	            params.from = token;
	        }
	
	        promise = this._http.authedRequestWithPrefix(undefined, "GET", path, params, undefined, httpApi.PREFIX_UNSTABLE).then(function (res) {
	            var token = res.next_token;
	            var matrixEvents = [];
	
	            for (var i = 0; i < res.notifications.length; i++) {
	                var notification = res.notifications[i];
	                var event = self.getEventMapper()(notification.event);
	                event.setPushActions(PushProcessor.actionListToActionsObject(notification.actions));
	                event.event.room_id = notification.room_id; // XXX: gutwrenching
	                matrixEvents[i] = event;
	            }
	
	            eventTimeline.getTimelineSet().addEventsToTimeline(matrixEvents, backwards, eventTimeline, token);
	
	            // if we've hit the end of the timeline, we need to stop trying to
	            // paginate. We need to keep the 'forwards' token though, to make sure
	            // we can recover from gappy syncs.
	            if (backwards && !res.next_token) {
	                eventTimeline.setPaginationToken(null, dir);
	            }
	            return res.next_token ? true : false;
	        }).finally(function () {
	            eventTimeline._paginationRequests[dir] = null;
	        });
	        eventTimeline._paginationRequests[dir] = promise;
	    } else {
	        var room = this.getRoom(eventTimeline.getRoomId());
	        if (!room) {
	            throw new Error("Unknown room " + eventTimeline.getRoomId());
	        }
	
	        path = utils.encodeUri("/rooms/$roomId/messages", { $roomId: eventTimeline.getRoomId() });
	        params = {
	            from: token,
	            limit: 'limit' in opts ? opts.limit : 30,
	            dir: dir
	        };
	
	        var filter = eventTimeline.getFilter();
	        if (filter) {
	            // XXX: it's horrific that /messages' filter parameter doesn't match
	            // /sync's one - see https://matrix.org/jira/browse/SPEC-451
	            params.filter = JSON.stringify(filter.getRoomTimelineFilterComponent());
	        }
	
	        promise = this._http.authedRequest(undefined, "GET", path, params).then(function (res) {
	            var token = res.end;
	            var matrixEvents = utils.map(res.chunk, self.getEventMapper());
	            eventTimeline.getTimelineSet().addEventsToTimeline(matrixEvents, backwards, eventTimeline, token);
	
	            // if we've hit the end of the timeline, we need to stop trying to
	            // paginate. We need to keep the 'forwards' token though, to make sure
	            // we can recover from gappy syncs.
	            if (backwards && res.end == res.start) {
	                eventTimeline.setPaginationToken(null, dir);
	            }
	            return res.end != res.start;
	        }).finally(function () {
	            eventTimeline._paginationRequests[dir] = null;
	        });
	        eventTimeline._paginationRequests[dir] = promise;
	    }
	
	    return promise;
	};
	
	/**
	 * Reset the notifTimelineSet entirely, paginating in some historical notifs as
	 * a starting point for subsequent pagination.
	 */
	MatrixClient.prototype.resetNotifTimelineSet = function () {
	    if (!this._notifTimelineSet) {
	        return;
	    }
	
	    // FIXME: This thing is a total hack, and results in duplicate events being
	    // added to the timeline both from /sync and /notifications, and lots of
	    // slow and wasteful processing and pagination.  The correct solution is to
	    // extend /messages or /search or something to filter on notifications.
	
	    // use the fictitious token 'end'. in practice we would ideally give it
	    // the oldest backwards pagination token from /sync, but /sync doesn't
	    // know about /notifications, so we have no choice but to start paginating
	    // from the current point in time.  This may well overlap with historical
	    // notifs which are then inserted into the timeline by /sync responses.
	    this._notifTimelineSet.resetLiveTimeline('end', true);
	
	    // we could try to paginate a single event at this point in order to get
	    // a more valid pagination token, but it just ends up with an out of order
	    // timeline. given what a mess this is and given we're going to have duplicate
	    // events anyway, just leave it with the dummy token for now.
	    /*
	    this.paginateNotifTimeline(this._notifTimelineSet.getLiveTimeline(), {
	        backwards: true,
	        limit: 1
	    });
	    */
	};
	
	/**
	 * Peek into a room and receive updates about the room. This only works if the
	 * history visibility for the room is world_readable.
	 * @param {String} roomId The room to attempt to peek into.
	 * @return {module:client.Promise} Resolves: Room object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.peekInRoom = function (roomId) {
	    if (this._peekSync) {
	        this._peekSync.stopPeeking();
	    }
	    this._peekSync = new SyncApi(this, this._clientOpts);
	    return this._peekSync.peek(roomId);
	};
	
	/**
	 * Stop any ongoing room peeking.
	 */
	MatrixClient.prototype.stopPeeking = function () {
	    if (this._peekSync) {
	        this._peekSync.stopPeeking();
	        this._peekSync = null;
	    }
	};
	
	/**
	 * Set r/w flags for guest access in a room.
	 * @param {string} roomId The room to configure guest access in.
	 * @param {Object} opts Options
	 * @param {boolean} opts.allowJoin True to allow guests to join this room. This
	 * implicitly gives guests write access. If false or not given, guests are
	 * explicitly forbidden from joining the room.
	 * @param {boolean} opts.allowRead True to set history visibility to
	 * be world_readable. This gives guests read access *from this point forward*.
	 * If false or not given, history visibility is not modified.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setGuestAccess = function (roomId, opts) {
	    var writePromise = this.sendStateEvent(roomId, "m.room.guest_access", {
	        guest_access: opts.allowJoin ? "can_join" : "forbidden"
	    });
	
	    var readPromise = q();
	    if (opts.allowRead) {
	        readPromise = this.sendStateEvent(roomId, "m.room.history_visibility", {
	            history_visibility: "world_readable"
	        });
	    }
	
	    return q.all(readPromise, writePromise);
	};
	
	// Registration/Login operations
	// =============================
	
	/**
	 * Requests an email verification token for the purposes of registration.
	 * This API proxies the Identity Server /validate/email/requestToken API,
	 * adding registration-specific behaviour. Specifically, if an account with
	 * the given email address already exists, it will either send an email
	 * to the address informing them of this or return M_THREEPID_IN_USE
	 * (which one is up to the Home Server).
	 *
	 * requestEmailToken calls the equivalent API directly on the ID server,
	 * therefore bypassing the registration-specific logic.
	 *
	 * Parameters and return value are as for requestEmailToken
	
	 * @param {string} email As requestEmailToken
	 * @param {string} clientSecret As requestEmailToken
	 * @param {number} sendAttempt As requestEmailToken
	 * @param {string} nextLink As requestEmailToken
	 * @return {module:client.Promise} Resolves: As requestEmailToken
	 */
	MatrixClient.prototype.requestRegisterEmailToken = function (email, clientSecret, sendAttempt, nextLink) {
	    return this._requestTokenFromEndpoint("/register/email/requestToken", {
	        email: email,
	        client_secret: clientSecret,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    });
	};
	
	/**
	 * Requests a text message verification token for the purposes of registration.
	 * This API proxies the Identity Server /validate/msisdn/requestToken API,
	 * adding registration-specific behaviour, as with requestRegisterEmailToken.
	 *
	 * @param {string} phoneCountry The ISO 3166-1 alpha-2 code for the country in which
	 *    phoneNumber should be parsed relative to.
	 * @param {string} phoneNumber The phone number, in national or international format
	 * @param {string} clientSecret As requestEmailToken
	 * @param {number} sendAttempt As requestEmailToken
	 * @param {string} nextLink As requestEmailToken
	 * @return {module:client.Promise} Resolves: As requestEmailToken
	 */
	MatrixClient.prototype.requestRegisterMsisdnToken = function (phoneCountry, phoneNumber, clientSecret, sendAttempt, nextLink) {
	    return this._requestTokenFromEndpoint("/register/msisdn/requestToken", {
	        country: phoneCountry,
	        phone_number: phoneNumber,
	        client_secret: clientSecret,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    });
	};
	
	/**
	 * Requests an email verification token for the purposes of adding a
	 * third party identifier to an account.
	 * This API proxies the Identity Server /validate/email/requestToken API,
	 * adding specific behaviour for the addition of email addresses to an
	 * account. Specifically, if an account with
	 * the given email address already exists, it will either send an email
	 * to the address informing them of this or return M_THREEPID_IN_USE
	 * (which one is up to the Home Server).
	 *
	 * requestEmailToken calls the equivalent API directly on the ID server,
	 * therefore bypassing the email addition specific logic.
	 *
	 * @param {string} email As requestEmailToken
	 * @param {string} clientSecret As requestEmailToken
	 * @param {number} sendAttempt As requestEmailToken
	 * @param {string} nextLink As requestEmailToken
	 * @return {module:client.Promise} Resolves: As requestEmailToken
	 */
	MatrixClient.prototype.requestAdd3pidEmailToken = function (email, clientSecret, sendAttempt, nextLink) {
	    return this._requestTokenFromEndpoint("/account/3pid/email/requestToken", {
	        email: email,
	        client_secret: clientSecret,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    });
	};
	
	/**
	 * Requests a text message verification token for the purposes of adding a
	 * third party identifier to an account.
	 * This API proxies the Identity Server /validate/email/requestToken API,
	 * adding specific behaviour for the addition of phone numbers to an
	 * account, as requestAdd3pidEmailToken.
	 *
	 * @param {string} phoneCountry As requestRegisterMsisdnToken
	 * @param {string} phoneNumber As requestRegisterMsisdnToken
	 * @param {string} clientSecret As requestEmailToken
	 * @param {number} sendAttempt As requestEmailToken
	 * @param {string} nextLink As requestEmailToken
	 * @return {module:client.Promise} Resolves: As requestEmailToken
	 */
	MatrixClient.prototype.requestAdd3pidMsisdnToken = function (phoneCountry, phoneNumber, clientSecret, sendAttempt, nextLink) {
	    return this._requestTokenFromEndpoint("/account/3pid/msisdn/requestToken", {
	        country: phoneCountry,
	        phone_number: phoneNumber,
	        client_secret: clientSecret,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    });
	};
	
	/**
	 * Requests an email verification token for the purposes of resetting
	 * the password on an account.
	 * This API proxies the Identity Server /validate/email/requestToken API,
	 * adding specific behaviour for the password resetting. Specifically,
	 * if no account with the given email address exists, it may either
	 * return M_THREEPID_NOT_FOUND or send an email
	 * to the address informing them of this (which one is up to the Home Server).
	 *
	 * requestEmailToken calls the equivalent API directly on the ID server,
	 * therefore bypassing the password reset specific logic.
	 *
	 * @param {string} email As requestEmailToken
	 * @param {string} clientSecret As requestEmailToken
	 * @param {number} sendAttempt As requestEmailToken
	 * @param {string} nextLink As requestEmailToken
	 * @param {module:client.callback} callback Optional. As requestEmailToken
	 * @return {module:client.Promise} Resolves: As requestEmailToken
	 */
	MatrixClient.prototype.requestPasswordEmailToken = function (email, clientSecret, sendAttempt, nextLink) {
	    return this._requestTokenFromEndpoint("/account/password/email/requestToken", {
	        email: email,
	        client_secret: clientSecret,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    });
	};
	
	/**
	 * Requests a text message verification token for the purposes of resetting
	 * the password on an account.
	 * This API proxies the Identity Server /validate/email/requestToken API,
	 * adding specific behaviour for the password resetting, as requestPasswordEmailToken.
	 *
	 * @param {string} phoneCountry As requestRegisterMsisdnToken
	 * @param {string} phoneNumber As requestRegisterMsisdnToken
	 * @param {string} clientSecret As requestEmailToken
	 * @param {number} sendAttempt As requestEmailToken
	 * @param {string} nextLink As requestEmailToken
	 * @return {module:client.Promise} Resolves: As requestEmailToken
	 */
	MatrixClient.prototype.requestPasswordMsisdnToken = function (phoneCountry, phoneNumber, clientSecret, sendAttempt, nextLink) {
	    return this._requestTokenFromEndpoint("/account/password/msisdn/requestToken", {
	        country: phoneCountry,
	        phone_number: phoneNumber,
	        client_secret: clientSecret,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    });
	};
	
	/**
	 * Internal utility function for requesting validation tokens from usage-specific
	 * requestToken endpoints.
	 *
	 * @param {string} endpoint The endpoint to send the request to
	 * @param {object} params Parameters for the POST request
	 * @return {module:client.Promise} Resolves: As requestEmailToken
	 */
	MatrixClient.prototype._requestTokenFromEndpoint = function (endpoint, params) {
	    var id_server_url = url.parse(this.idBaseUrl);
	    if (id_server_url.host === null) {
	        throw new Error("Invalid ID server URL: " + this.idBaseUrl);
	    }
	
	    var postParams = Object.assign({}, params, {
	        id_server: id_server_url.host
	    });
	    return this._http.request(undefined, "POST", endpoint, undefined, postParams);
	};
	
	// Push operations
	// ===============
	
	/**
	 * Get the room-kind push rule associated with a room.
	 * @param {string} scope "global" or device-specific.
	 * @param {string} roomId the id of the room.
	 * @return {object} the rule or undefined.
	 */
	MatrixClient.prototype.getRoomPushRule = function (scope, roomId) {
	    // There can be only room-kind push rule per room
	    // and its id is the room id.
	    if (this.pushRules) {
	        for (var i = 0; i < this.pushRules[scope].room.length; i++) {
	            var rule = this.pushRules[scope].room[i];
	            if (rule.rule_id === roomId) {
	                return rule;
	            }
	        }
	    } else {
	        throw new Error("SyncApi.sync() must be done before accessing to push rules.");
	    }
	};
	
	/**
	 * Set a room-kind muting push rule in a room.
	 * The operation also updates MatrixClient.pushRules at the end.
	 * @param {string} scope "global" or device-specific.
	 * @param {string} roomId the id of the room.
	 * @param {string} mute the mute state.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomMutePushRule = function (scope, roomId, mute) {
	    var self = this;
	    var deferred = void 0,
	        hasDontNotifyRule = void 0;
	
	    // Get the existing room-kind push rule if any
	    var roomPushRule = this.getRoomPushRule(scope, roomId);
	    if (roomPushRule) {
	        if (0 <= roomPushRule.actions.indexOf("dont_notify")) {
	            hasDontNotifyRule = true;
	        }
	    }
	
	    if (!mute) {
	        // Remove the rule only if it is a muting rule
	        if (hasDontNotifyRule) {
	            deferred = this.deletePushRule(scope, "room", roomPushRule.rule_id);
	        }
	    } else {
	        if (!roomPushRule) {
	            deferred = this.addPushRule(scope, "room", roomId, {
	                actions: ["dont_notify"]
	            });
	        } else if (!hasDontNotifyRule) {
	            // Remove the existing one before setting the mute push rule
	            // This is a workaround to SYN-590 (Push rule update fails)
	            deferred = q.defer();
	            this.deletePushRule(scope, "room", roomPushRule.rule_id).done(function () {
	                self.addPushRule(scope, "room", roomId, {
	                    actions: ["dont_notify"]
	                }).done(function () {
	                    deferred.resolve();
	                }, function (err) {
	                    deferred.reject(err);
	                });
	            }, function (err) {
	                deferred.reject(err);
	            });
	
	            deferred = deferred.promise;
	        }
	    }
	
	    if (deferred) {
	        var _ret2 = function () {
	            // Update this.pushRules when the operation completes
	            var ruleRefreshDeferred = q.defer();
	            deferred.done(function () {
	                self.getPushRules().done(function (result) {
	                    self.pushRules = result;
	                    ruleRefreshDeferred.resolve();
	                }, function (err) {
	                    ruleRefreshDeferred.reject(err);
	                });
	            }, function (err) {
	                // Update it even if the previous operation fails. This can help the
	                // app to recover when push settings has been modifed from another client
	                self.getPushRules().done(function (result) {
	                    self.pushRules = result;
	                    ruleRefreshDeferred.reject(err);
	                }, function (err2) {
	                    ruleRefreshDeferred.reject(err);
	                });
	            });
	            return {
	                v: ruleRefreshDeferred.promise
	            };
	        }();
	
	        if ((typeof _ret2 === "undefined" ? "undefined" : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	};
	
	// Search
	// ======
	
	/**
	 * Perform a server-side search for messages containing the given text.
	 * @param {Object} opts Options for the search.
	 * @param {string} opts.query The text to query.
	 * @param {string=} opts.keys The keys to search on. Defaults to all keys. One
	 * of "content.body", "content.name", "content.topic".
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.searchMessageText = function (opts, callback) {
	    var roomEvents = {
	        search_term: opts.query
	    };
	
	    if ('keys' in opts) {
	        roomEvents.keys = opts.keys;
	    }
	
	    return this.search({
	        body: {
	            search_categories: {
	                room_events: roomEvents
	            }
	        }
	    }, callback);
	};
	
	/**
	 * Perform a server-side search for room events.
	 *
	 * The returned promise resolves to an object containing the fields:
	 *
	 *  * {number}  count:       estimate of the number of results
	 *  * {string}  next_batch:  token for back-pagination; if undefined, there are
	 *                           no more results
	 *  * {Array}   highlights:  a list of words to highlight from the stemming
	 *                           algorithm
	 *  * {Array}   results:     a list of results
	 *
	 * Each entry in the results list is a {module:models/search-result.SearchResult}.
	 *
	 * @param {Object} opts
	 * @param {string} opts.term     the term to search for
	 * @param {Object} opts.filter   a JSON filter object to pass in the request
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.searchRoomEvents = function (opts) {
	    // TODO: support groups
	
	    var body = {
	        search_categories: {
	            room_events: {
	                search_term: opts.term,
	                filter: opts.filter,
	                order_by: "recent",
	                event_context: {
	                    before_limit: 1,
	                    after_limit: 1,
	                    include_profile: true
	                }
	            }
	        }
	    };
	
	    var searchResults = {
	        _query: body,
	        results: [],
	        highlights: []
	    };
	
	    return this.search({ body: body }).then(this._processRoomEventsSearch.bind(this, searchResults));
	};
	
	/**
	 * Take a result from an earlier searchRoomEvents call, and backfill results.
	 *
	 * @param  {object} searchResults  the results object to be updated
	 * @return {module:client.Promise} Resolves: updated result object
	 * @return {Error} Rejects: with an error response.
	 */
	MatrixClient.prototype.backPaginateRoomEventsSearch = function (searchResults) {
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	
	    if (!searchResults.next_batch) {
	        return q.reject(new Error("Cannot backpaginate event search any further"));
	    }
	
	    if (searchResults.pendingRequest) {
	        // already a request in progress - return the existing promise
	        return searchResults.pendingRequest;
	    }
	
	    var searchOpts = {
	        body: searchResults._query,
	        next_batch: searchResults.next_batch
	    };
	
	    var promise = this.search(searchOpts).then(this._processRoomEventsSearch.bind(this, searchResults)).finally(function () {
	        searchResults.pendingRequest = null;
	    });
	    searchResults.pendingRequest = promise;
	
	    return promise;
	};
	
	/**
	 * helper for searchRoomEvents and backPaginateRoomEventsSearch. Processes the
	 * response from the API call and updates the searchResults
	 *
	 * @param {Object} searchResults
	 * @param {Object} response
	 * @return {Object} searchResults
	 * @private
	 */
	MatrixClient.prototype._processRoomEventsSearch = function (searchResults, response) {
	    var room_events = response.search_categories.room_events;
	
	    searchResults.count = room_events.count;
	    searchResults.next_batch = room_events.next_batch;
	
	    // combine the highlight list with our existing list; build an object
	    // to avoid O(N^2) fail
	    var highlights = {};
	    room_events.highlights.forEach(function (hl) {
	        highlights[hl] = 1;
	    });
	    searchResults.highlights.forEach(function (hl) {
	        highlights[hl] = 1;
	    });
	
	    // turn it back into a list.
	    searchResults.highlights = Object.keys(highlights);
	
	    // append the new results to our existing results
	    for (var i = 0; i < room_events.results.length; i++) {
	        var sr = SearchResult.fromJson(room_events.results[i], this.getEventMapper());
	        searchResults.results.push(sr);
	    }
	    return searchResults;
	};
	
	/**
	 * Populate the store with rooms the user has left.
	 * @return {module:client.Promise} Resolves: TODO - Resolved when the rooms have
	 * been added to the data store.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.syncLeftRooms = function () {
	    // Guard against multiple calls whilst ongoing and multiple calls post success
	    if (this._syncedLeftRooms) {
	        return q([]); // don't call syncRooms again if it succeeded.
	    }
	    if (this._syncLeftRoomsPromise) {
	        return this._syncLeftRoomsPromise; // return the ongoing request
	    }
	    var self = this;
	    var syncApi = new SyncApi(this, this._clientOpts);
	    this._syncLeftRoomsPromise = syncApi.syncLeftRooms();
	
	    // cleanup locks
	    this._syncLeftRoomsPromise.then(function (res) {
	        console.log("Marking success of sync left room request");
	        self._syncedLeftRooms = true; // flip the bit on success
	    }).finally(function () {
	        self._syncLeftRoomsPromise = null; // cleanup ongoing request state
	    });
	
	    return this._syncLeftRoomsPromise;
	};
	
	// Filters
	// =======
	
	/**
	 * Create a new filter.
	 * @param {Object} content The HTTP body for the request
	 * @return {Filter} Resolves to a Filter object.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.createFilter = function (content) {
	    var self = this;
	    var path = utils.encodeUri("/user/$userId/filter", {
	        $userId: this.credentials.userId
	    });
	    return this._http.authedRequest(undefined, "POST", path, undefined, content).then(function (response) {
	        // persist the filter
	        var filter = Filter.fromJson(self.credentials.userId, response.filter_id, content);
	        self.store.storeFilter(filter);
	        return filter;
	    });
	};
	
	/**
	 * Retrieve a filter.
	 * @param {string} userId The user ID of the filter owner
	 * @param {string} filterId The filter ID to retrieve
	 * @param {boolean} allowCached True to allow cached filters to be returned.
	 * Default: True.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getFilter = function (userId, filterId, allowCached) {
	    if (allowCached) {
	        var filter = this.store.getFilter(userId, filterId);
	        if (filter) {
	            return q(filter);
	        }
	    }
	
	    var self = this;
	    var path = utils.encodeUri("/user/$userId/filter/$filterId", {
	        $userId: userId,
	        $filterId: filterId
	    });
	
	    return this._http.authedRequest(undefined, "GET", path, undefined, undefined).then(function (response) {
	        // persist the filter
	        var filter = Filter.fromJson(userId, filterId, response);
	        self.store.storeFilter(filter);
	        return filter;
	    });
	};
	
	/**
	 * @param {string} filterName
	 * @param {Filter} filter
	 * @return {Promise<String>} Filter ID
	 */
	MatrixClient.prototype.getOrCreateFilter = function (filterName, filter) {
	    var filterId = this.store.getFilterIdByName(filterName);
	    var promise = q();
	    var self = this;
	
	    if (filterId) {
	        // check that the existing filter matches our expectations
	        promise = self.getFilter(self.credentials.userId, filterId, true).then(function (existingFilter) {
	            var oldDef = existingFilter.getDefinition();
	            var newDef = filter.getDefinition();
	
	            if (utils.deepCompare(oldDef, newDef)) {
	                // super, just use that.
	                // debuglog("Using existing filter ID %s: %s", filterId,
	                //          JSON.stringify(oldDef));
	                return q(filterId);
	            }
	            // debuglog("Existing filter ID %s: %s; new filter: %s",
	            //          filterId, JSON.stringify(oldDef), JSON.stringify(newDef));
	            self.store.setFilterIdByName(filterName, undefined);
	            return undefined;
	        }, function (error) {
	            // Synapse currently returns the following when the filter cannot be found:
	            // {
	            //     errcode: "M_UNKNOWN",
	            //     name: "M_UNKNOWN",
	            //     message: "No row found",
	            //     data: Object, httpStatus: 404
	            // }
	            if (error.httpStatus === 404 && (error.errcode === "M_UNKNOWN" || error.errcode === "M_NOT_FOUND")) {
	                // Clear existing filterId from localStorage
	                // if it no longer exists on the server
	                self.store.setFilterIdByName(filterName, undefined);
	                // Return a undefined value for existingId further down the promise chain
	                return undefined;
	            } else {
	                throw error;
	            }
	        });
	    }
	
	    return promise.then(function (existingId) {
	        if (existingId) {
	            return existingId;
	        }
	
	        // create a new filter
	        return self.createFilter(filter.getDefinition()).then(function (createdFilter) {
	            // debuglog("Created new filter ID %s: %s", createdFilter.filterId,
	            //          JSON.stringify(createdFilter.getDefinition()));
	            self.store.setFilterIdByName(filterName, createdFilter.filterId);
	            return createdFilter.filterId;
	        });
	    });
	};
	
	/**
	 * Gets a bearer token from the Home Server that the user can
	 * present to a third party in order to prove their ownership
	 * of the Matrix account they are logged into.
	 * @return {module:client.Promise} Resolves: Token object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getOpenIdToken = function () {
	    var path = utils.encodeUri("/user/$userId/openid/request_token", {
	        $userId: this.credentials.userId
	    });
	
	    return this._http.authedRequest(undefined, "POST", path, undefined, {});
	};
	
	// VoIP operations
	// ===============
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.turnServer = function (callback) {
	    return this._http.authedRequest(callback, "GET", "/voip/turnServer");
	};
	
	/**
	 * Get the TURN servers for this home server.
	 * @return {Array<Object>} The servers or an empty list.
	 */
	MatrixClient.prototype.getTurnServers = function () {
	    return this._turnServers || [];
	};
	
	// Higher level APIs
	// =================
	
	// TODO: stuff to handle:
	//   local echo
	//   event dup suppression? - apparently we should still be doing this
	//   tracking current display name / avatar per-message
	//   pagination
	//   re-sending (including persisting pending messages to be sent)
	//   - Need a nice way to callback the app for arbitrary events like
	//     displayname changes
	//   due to ambiguity (or should this be on a chat-specific layer)?
	//   reconnect after connectivity outages
	
	
	/**
	 * High level helper method to begin syncing and poll for new events. To listen for these
	 * events, add a listener for {@link module:client~MatrixClient#event:"event"}
	 * via {@link module:client~MatrixClient#on}. Alternatively, listen for specific
	 * state change events.
	 * @param {Object=} opts Options to apply when syncing.
	 * @param {Number=} opts.initialSyncLimit The event <code>limit=</code> to apply
	 * to initial sync. Default: 8.
	 * @param {Boolean=} opts.includeArchivedRooms True to put <code>archived=true</code>
	 * on the <code>/initialSync</code> request. Default: false.
	 * @param {Boolean=} opts.resolveInvitesToProfiles True to do /profile requests
	 * on every invite event if the displayname/avatar_url is not known for this user ID.
	 * Default: false.
	 *
	 * @param {String=} opts.pendingEventOrdering Controls where pending messages
	 * appear in a room's timeline. If "<b>chronological</b>", messages will appear
	 * in the timeline when the call to <code>sendEvent</code> was made. If
	 * "<b>detached</b>", pending messages will appear in a separate list,
	 * accessbile via {@link module:models/room#getPendingEvents}. Default:
	 * "chronological".
	 *
	 * @param {Number=} opts.pollTimeout The number of milliseconds to wait on /sync.
	 * Default: 30000 (30 seconds).
	 *
	 * @param {Filter=} opts.filter The filter to apply to /sync calls. This will override
	 * the opts.initialSyncLimit, which would normally result in a timeline limit filter.
	 */
	MatrixClient.prototype.startClient = function (opts) {
	    var _this2 = this;
	
	    if (this.clientRunning) {
	        // client is already running.
	        return;
	    }
	    this.clientRunning = true;
	    // backwards compat for when 'opts' was 'historyLen'.
	    if (typeof opts === "number") {
	        opts = {
	            initialSyncLimit: opts
	        };
	    }
	
	    if (this._crypto) {
	        this._crypto.uploadDeviceKeys().done();
	    }
	
	    // periodically poll for turn servers if we support voip
	    checkTurnServers(this);
	
	    if (this._syncApi) {
	        // This shouldn't happen since we thought the client was not running
	        console.error("Still have sync object whilst not running: stopping old one");
	        this._syncApi.stop();
	    }
	
	    // shallow-copy the opts dict before modifying and storing it
	    opts = Object.assign({}, opts);
	
	    opts.crypto = this._crypto;
	    opts.canResetEntireTimeline = function (roomId) {
	        if (!_this2._canResetTimelineCallback) {
	            return false;
	        }
	        return _this2._canResetTimelineCallback(roomId);
	    };
	    this._clientOpts = opts;
	
	    this._syncApi = new SyncApi(this, opts);
	    this._syncApi.sync();
	};
	
	/**
	 * High level helper method to stop the client from polling and allow a
	 * clean shutdown.
	 */
	MatrixClient.prototype.stopClient = function () {
	    this.clientRunning = false;
	    // TODO: f.e. Room => self.store.storeRoom(room) ?
	    if (this._syncApi) {
	        this._syncApi.stop();
	        this._syncApi = null;
	    }
	    global.clearTimeout(this._checkTurnServersTimeoutID);
	};
	
	/*
	 * Set a function which is called when /sync returns a 'limited' response.
	 * It is called with a room ID and returns a boolean. It should return 'true' if the SDK
	 * can SAFELY remove events from this room. It may not be safe to remove events if there
	 * are other references to the timelines for this room, e.g because the client is
	 * actively viewing events in this room.
	 * Default: returns false.
	 * @param {Function} cb The callback which will be invoked.
	 */
	MatrixClient.prototype.setCanResetTimelineCallback = function (cb) {
	    this._canResetTimelineCallback = cb;
	};
	
	/**
	 * Get the callback set via `setCanResetTimelineCallback`.
	 * @return {?Function} The callback or null
	 */
	MatrixClient.prototype.getCanResetTimelineCallback = function () {
	    return this._canResetTimelineCallback;
	};
	
	function setupCallEventHandler(client) {
	    var candidatesByCall = {
	        // callId: [Candidate]
	    };
	
	    // Maintain a buffer of events before the client has synced for the first time.
	    // This buffer will be inspected to see if we should send incoming call
	    // notifications. It needs to be buffered to correctly determine if an
	    // incoming call has had a matching answer/hangup.
	    var callEventBuffer = [];
	    var isClientPrepared = false;
	    client.on("sync", function (state) {
	        if (state === "PREPARED") {
	            (function () {
	                isClientPrepared = true;
	                var ignoreCallIds = {}; // Set<String>
	                // inspect the buffer and mark all calls which have been answered
	                // or hung up before passing them to the call event handler.
	                for (var i = callEventBuffer.length - 1; i >= 0; i--) {
	                    var ev = callEventBuffer[i];
	                    if (ev.getType() === "m.call.answer" || ev.getType() === "m.call.hangup") {
	                        ignoreCallIds[ev.getContent().call_id] = "yep";
	                    }
	                }
	                // now loop through the buffer chronologically and inject them
	                callEventBuffer.forEach(function (e) {
	                    if (ignoreCallIds[e.getContent().call_id]) {
	                        return;
	                    }
	                    callEventHandler(e);
	                });
	                callEventBuffer = [];
	            })();
	        }
	    });
	
	    client.on("event", function (event) {
	        if (!isClientPrepared) {
	            if (event.getType().indexOf("m.call.") === 0) {
	                callEventBuffer.push(event);
	            }
	            return;
	        }
	        callEventHandler(event);
	    });
	
	    function callEventHandler(event) {
	        if (event.getType().indexOf("m.call.") !== 0) {
	            return; // not a call event
	        }
	        var content = event.getContent();
	        var call = content.call_id ? client.callList[content.call_id] : undefined;
	        var i = void 0;
	        //console.log("RECV %s content=%s", event.getType(), JSON.stringify(content));
	
	        if (event.getType() === "m.call.invite") {
	            if (event.getSender() === client.credentials.userId) {
	                return; // ignore invites you send
	            }
	
	            if (event.getAge() > content.lifetime) {
	                return; // expired call
	            }
	
	            if (call && call.state === "ended") {
	                return; // stale/old invite event
	            }
	            if (call) {
	                console.log("WARN: Already have a MatrixCall with id %s but got an " + "invite. Clobbering.", content.call_id);
	            }
	
	            call = webRtcCall.createNewMatrixCall(client, event.getRoomId());
	            if (!call) {
	                console.log("Incoming call ID " + content.call_id + " but this client " + "doesn't support WebRTC");
	                // don't hang up the call: there could be other clients
	                // connected that do support WebRTC and declining the
	                // the call on their behalf would be really annoying.
	                return;
	            }
	
	            call.callId = content.call_id;
	            call._initWithInvite(event);
	            client.callList[call.callId] = call;
	
	            // if we stashed candidate events for that call ID, play them back now
	            if (candidatesByCall[call.callId]) {
	                for (i = 0; i < candidatesByCall[call.callId].length; i++) {
	                    call._gotRemoteIceCandidate(candidatesByCall[call.callId][i]);
	                }
	            }
	
	            // Were we trying to call that user (room)?
	            var existingCall = void 0;
	            var existingCalls = utils.values(client.callList);
	            for (i = 0; i < existingCalls.length; ++i) {
	                var thisCall = existingCalls[i];
	                if (call.roomId === thisCall.roomId && thisCall.direction === 'outbound' && ["wait_local_media", "create_offer", "invite_sent"].indexOf(thisCall.state) !== -1) {
	                    existingCall = thisCall;
	                    break;
	                }
	            }
	
	            if (existingCall) {
	                // If we've only got to wait_local_media or create_offer and
	                // we've got an invite, pick the incoming call because we know
	                // we haven't sent our invite yet otherwise, pick whichever
	                // call has the lowest call ID (by string comparison)
	                if (existingCall.state === 'wait_local_media' || existingCall.state === 'create_offer' || existingCall.callId > call.callId) {
	                    console.log("Glare detected: answering incoming call " + call.callId + " and canceling outgoing call " + existingCall.callId);
	                    existingCall._replacedBy(call);
	                    call.answer();
	                } else {
	                    console.log("Glare detected: rejecting incoming call " + call.callId + " and keeping outgoing call " + existingCall.callId);
	                    call.hangup();
	                }
	            } else {
	                client.emit("Call.incoming", call);
	            }
	        } else if (event.getType() === 'm.call.answer') {
	            if (!call) {
	                return;
	            }
	            if (event.getSender() === client.credentials.userId) {
	                if (call.state === 'ringing') {
	                    call._onAnsweredElsewhere(content);
	                }
	            } else {
	                call._receivedAnswer(content);
	            }
	        } else if (event.getType() === 'm.call.candidates') {
	            if (event.getSender() === client.credentials.userId) {
	                return;
	            }
	            if (!call) {
	                // store the candidates; we may get a call eventually.
	                if (!candidatesByCall[content.call_id]) {
	                    candidatesByCall[content.call_id] = [];
	                }
	                candidatesByCall[content.call_id] = candidatesByCall[content.call_id].concat(content.candidates);
	            } else {
	                for (i = 0; i < content.candidates.length; i++) {
	                    call._gotRemoteIceCandidate(content.candidates[i]);
	                }
	            }
	        } else if (event.getType() === 'm.call.hangup') {
	            // Note that we also observe our own hangups here so we can see
	            // if we've already rejected a call that would otherwise be valid
	            if (!call) {
	                // if not live, store the fact that the call has ended because
	                // we're probably getting events backwards so
	                // the hangup will come before the invite
	                call = webRtcCall.createNewMatrixCall(client, event.getRoomId());
	                if (call) {
	                    call.callId = content.call_id;
	                    call._initWithHangup(event);
	                    client.callList[content.call_id] = call;
	                }
	            } else {
	                if (call.state !== 'ended') {
	                    call._onHangupReceived(content);
	                    delete client.callList[content.call_id];
	                }
	            }
	        }
	    }
	}
	
	function checkTurnServers(client) {
	    if (!client._supportsVoip) {
	        return;
	    }
	    if (client.isGuest()) {
	        return; // guests can't access TURN servers
	    }
	
	    client.turnServer().done(function (res) {
	        if (res.uris) {
	            console.log("Got TURN URIs: " + res.uris + " refresh in " + res.ttl + " secs");
	            // map the response to a format that can be fed to
	            // RTCPeerConnection
	            var servers = {
	                urls: res.uris,
	                username: res.username,
	                credential: res.password
	            };
	            client._turnServers = [servers];
	            // re-fetch when we're about to reach the TTL
	            client._checkTurnServersTimeoutID = setTimeout(function () {
	                checkTurnServers(client);
	            }, (res.ttl || 60 * 60) * 1000 * 0.9);
	        }
	    }, function (err) {
	        console.error("Failed to get TURN URIs");
	        client._checkTurnServersTimeoutID = setTimeout(function () {
	            checkTurnServers(client);
	        }, 60000);
	    });
	}
	
	function _reject(callback, defer, err) {
	    if (callback) {
	        callback(err);
	    }
	    defer.reject(err);
	}
	
	function _resolve(callback, defer, res) {
	    if (callback) {
	        callback(null, res);
	    }
	    defer.resolve(res);
	}
	
	function _PojoToMatrixEventMapper(client) {
	    function mapper(plainOldJsObject) {
	        var event = new MatrixEvent(plainOldJsObject);
	        if (event.isEncrypted()) {
	            _decryptEvent(client, event);
	        }
	        return event;
	    }
	    return mapper;
	}
	
	/**
	 * @return {Function}
	 */
	MatrixClient.prototype.getEventMapper = function () {
	    return _PojoToMatrixEventMapper(this);
	};
	
	// Identity Server Operations
	// ==========================
	
	/**
	 * Generates a random string suitable for use as a client secret. <strong>This
	 * method is experimental and may change.</strong>
	 * @return {string} A new client secret
	 */
	MatrixClient.prototype.generateClientSecret = function () {
	    var ret = "";
	    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	
	    for (var i = 0; i < 32; i++) {
	        ret += chars.charAt(Math.floor(Math.random() * chars.length));
	    }
	
	    return ret;
	};
	
	/** */
	module.exports.MatrixClient = MatrixClient;
	/** */
	module.exports.CRYPTO_ENABLED = CRYPTO_ENABLED;
	
	// MatrixClient Event JSDocs
	
	/**
	 * Fires whenever the SDK receives a new event.
	 * <p>
	 * This is only fired for live events received via /sync - it is not fired for
	 * events received over context, search, or pagination APIs.
	 *
	 * @event module:client~MatrixClient#"event"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @example
	 * matrixClient.on("event", function(event){
	 *   var sender = event.getSender();
	 * });
	 */
	
	/**
	 * Fires whenever the SDK receives a new to-device event.
	 * @event module:client~MatrixClient#"toDeviceEvent"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @example
	 * matrixClient.on("toDeviceEvent", function(event){
	 *   var sender = event.getSender();
	 * });
	 */
	
	/**
	 * Fires whenever the SDK's syncing state is updated. The state can be one of:
	 * <ul>
	 *
	 * <li>PREPARED: The client has synced with the server at least once and is
	 * ready for methods to be called on it. This will be immediately followed by
	 * a state of SYNCING. <i>This is the equivalent of "syncComplete" in the
	 * previous API.</i></li>
	 *
	 * <li>SYNCING : The client is currently polling for new events from the server.
	 * This will be called <i>after</i> processing latest events from a sync.</li>
	 *
	 * <li>ERROR : The client has had a problem syncing with the server. If this is
	 * called <i>before</i> PREPARED then there was a problem performing the initial
	 * sync. If this is called <i>after</i> PREPARED then there was a problem polling
	 * the server for updates. This may be called multiple times even if the state is
	 * already ERROR. <i>This is the equivalent of "syncError" in the previous
	 * API.</i></li>
	 *
	 * <li>RECONNECTING: The sync connection has dropped, but not (yet) in a way that
	 * should be considered erroneous.
	 * </li>
	 *
	 * <li>STOPPED: The client has stopped syncing with server due to stopClient
	 * being called.
	 * </li>
	 * </ul>
	 * State transition diagram:
	 * <pre>
	 *                                          +---->STOPPED
	 *                                          |
	 *              +----->PREPARED -------> SYNCING <--+
	 *              |        ^                |  ^      |
	 *              |        |                |  |      |
	 *              |        |                V  |      |
	 *   null ------+        |  +--------RECONNECTING   |
	 *              |        |  V                       |
	 *              +------->ERROR ---------------------+
	 *
	 * NB: 'null' will never be emitted by this event.
	 *
	 * </pre>
	 * Transitions:
	 * <ul>
	 *
	 * <li><code>null -> PREPARED</code> : Occurs when the initial sync is completed
	 * first time. This involves setting up filters and obtaining push rules.
	 *
	 * <li><code>null -> ERROR</code> : Occurs when the initial sync failed first time.
	 *
	 * <li><code>ERROR -> PREPARED</code> : Occurs when the initial sync succeeds
	 * after previously failing.
	 *
	 * <li><code>PREPARED -> SYNCING</code> : Occurs immediately after transitioning
	 * to PREPARED. Starts listening for live updates rather than catching up.
	 *
	 * <li><code>SYNCING -> RECONNECTING</code> : Occurs when the live update fails.
	 *
	 * <li><code>RECONNECTING -> RECONNECTING</code> : Can occur if the update calls
	 * continue to fail, but the keepalive calls (to /versions) succeed.
	 *
	 * <li><code>RECONNECTING -> ERROR</code> : Occurs when the keepalive call also fails
	 *
	 * <li><code>ERROR -> SYNCING</code> : Occurs when the client has performed a
	 * live update after having previously failed.
	 *
	 * <li><code>ERROR -> ERROR</code> : Occurs when the client has failed to keepalive
	 * for a second time or more.</li>
	 *
	 * <li><code>SYNCING -> SYNCING</code> : Occurs when the client has performed a live
	 * update. This is called <i>after</i> processing.</li>
	 *
	 * <li><code>* -> STOPPED</code> : Occurs once the client has stopped syncing or
	 * trying to sync after stopClient has been called.</li>
	 * </ul>
	 *
	 * @event module:client~MatrixClient#"sync"
	 *
	 * @param {string} state An enum representing the syncing state. One of "PREPARED",
	 * "SYNCING", "ERROR", "STOPPED".
	 *
	 * @param {?string} prevState An enum representing the previous syncing state.
	 * One of "PREPARED", "SYNCING", "ERROR", "STOPPED" <b>or null</b>.
	 *
	 * @param {?Object} data Data about this transition.
	 *
	 * @param {MatrixError} data.err The matrix error if <code>state=ERROR</code>.
	 *
	 * @param {String} data.oldSyncToken The 'since' token passed to /sync.
	 *    <code>null</code> for the first successful sync since this client was
	 *    started. Only present if <code>state=PREPARED</code> or
	 *    <code>state=SYNCING</code>.
	 *
	 * @param {String} data.nextSyncToken The 'next_batch' result from /sync, which
	 *    will become the 'since' token for the next call to /sync. Only present if
	 *    <code>state=PREPARED</code> or <code>state=SYNCING</code>.
	 *
	 * @param {boolean} data.catchingUp True if we are working our way through a
	 *    backlog of events after connecting. Only present if <code>state=SYNCING</code>.
	 *
	 * @example
	 * matrixClient.on("sync", function(state, prevState, data) {
	 *   switch (state) {
	 *     case "ERROR":
	 *       // update UI to say "Connection Lost"
	 *       break;
	 *     case "SYNCING":
	 *       // update UI to remove any "Connection Lost" message
	 *       break;
	 *     case "PREPARED":
	 *       // the client instance is ready to be queried.
	 *       var rooms = matrixClient.getRooms();
	 *       break;
	 *   }
	 * });
	 */
	
	/**
	* Fires whenever a new Room is added. This will fire when you are invited to a
	* room, as well as when you join a room. <strong>This event is experimental and
	* may change.</strong>
	* @event module:client~MatrixClient#"Room"
	* @param {Room} room The newly created, fully populated room.
	* @example
	* matrixClient.on("Room", function(room){
	*   var roomId = room.roomId;
	* });
	*/
	
	/**
	* Fires whenever a Room is removed. This will fire when you forget a room.
	* <strong>This event is experimental and may change.</strong>
	* @event module:client~MatrixClient#"deleteRoom"
	* @param {string} roomId The deleted room ID.
	* @example
	* matrixClient.on("deleteRoom", function(roomId){
	*   // update UI from getRooms()
	* });
	*/
	
	/**
	 * Fires whenever an incoming call arrives.
	 * @event module:client~MatrixClient#"Call.incoming"
	 * @param {module:webrtc/call~MatrixCall} call The incoming call.
	 * @example
	 * matrixClient.on("Call.incoming", function(call){
	 *   call.answer(); // auto-answer
	 * });
	 */
	
	/**
	 * Fires whenever the login session the JS SDK is using is no
	 * longer valid and the user must log in again.
	 * NB. This only fires when action is required from the user, not
	 * when then login session can be renewed by using a refresh token.
	 * @event module:client~MatrixClient#"Session.logged_out"
	 * @example
	 * matrixClient.on("Session.logged_out", function(call){
	 *   // show the login screen
	 * });
	 */
	
	/**
	 * Fires when a device is marked as verified/unverified/blocked/unblocked by
	 * {@link module:client~MatrixClient#setDeviceVerified|MatrixClient.setDeviceVerified} or
	 * {@link module:client~MatrixClient#setDeviceBlocked|MatrixClient.setDeviceBlocked}.
	 *
	 * @event module:client~MatrixClient#"deviceVerificationChanged"
	 * @param {string} userId the owner of the verified device
	 * @param {string} deviceId the id of the verified device
	 * @param {module:crypto/deviceinfo} deviceInfo updated device information
	 */
	
	/**
	 * Fires whenever new user-scoped account_data is added.
	 * @event module:client~MatrixClient#"accountData"
	 * @param {MatrixEvent} event The event describing the account_data just added
	 * @example
	 * matrixClient.on("accountData", function(event){
	 *   myAccountData[event.type] = event.content;
	 * });
	 */
	
	// EventEmitter JSDocs
	
	/**
	 * The {@link https://nodejs.org/api/events.html|EventEmitter} class.
	 * @external EventEmitter
	 * @see {@link https://nodejs.org/api/events.html}
	 */
	
	/**
	 * Adds a listener to the end of the listeners array for the specified event.
	 * No checks are made to see if the listener has already been added. Multiple
	 * calls passing the same combination of event and listener will result in the
	 * listener being added multiple times.
	 * @function external:EventEmitter#on
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Alias for {@link external:EventEmitter#on}.
	 * @function external:EventEmitter#addListener
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Adds a <b>one time</b> listener for the event. This listener is invoked only
	 * the next time the event is fired, after which it is removed.
	 * @function external:EventEmitter#once
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Remove a listener from the listener array for the specified event.
	 * <b>Caution:</b> changes array indices in the listener array behind the
	 * listener.
	 * @function external:EventEmitter#removeListener
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Removes all listeners, or those of the specified event. It's not a good idea
	 * to remove listeners that were added elsewhere in the code, especially when
	 * it's on an emitter that you didn't create (e.g. sockets or file streams).
	 * @function external:EventEmitter#removeAllListeners
	 * @param {string} event Optional. The event to remove listeners for.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Execute each of the listeners in order with the supplied arguments.
	 * @function external:EventEmitter#emit
	 * @param {string} event The event to emit.
	 * @param {Function} listener The function to invoke.
	 * @return {boolean} true if event had listeners, false otherwise.
	 */
	
	/**
	 * By default EventEmitters will print a warning if more than 10 listeners are
	 * added for a particular event. This is a useful default which helps finding
	 * memory leaks. Obviously not all Emitters should be limited to 10. This
	 * function allows that to be increased. Set to zero for unlimited.
	 * @function external:EventEmitter#setMaxListeners
	 * @param {Number} n The max number of listeners.
	 * @return {EventEmitter} for call chaining.
	 */
	
	// MatrixClient Callback JSDocs
	
	/**
	 * The standard MatrixClient callback interface. Functions which accept this
	 * will specify 2 return arguments. These arguments map to the 2 parameters
	 * specified in this callback.
	 * @callback module:client.callback
	 * @param {Object} err The error value, the "rejected" value or null.
	 * @param {Object} data The data returned, the "resolved" value.
	 */
	
	/**
	 * {@link https://github.com/kriskowal/q|A promise implementation (Q)}. Functions
	 * which return this will specify 2 return arguments. These arguments map to the
	 * "onFulfilled" and "onRejected" values of the Promise.
	 * @typedef {Object} Promise
	 * @static
	 * @property {Function} then promise.then(onFulfilled, onRejected, onProgress)
	 * @property {Function} catch promise.catch(onRejected)
	 * @property {Function} finally promise.finally(callback)
	 * @property {Function} done promise.done(onFulfilled, onRejected, onProgress)
	 */
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room-member
	 */
	
	var EventEmitter = __webpack_require__(56).EventEmitter;
	var ContentRepo = __webpack_require__(214);
	
	var utils = __webpack_require__(16);
	
	/**
	 * Construct a new room member.
	 *
	 * @constructor
	 * @alias module:models/room-member
	 *
	 * @param {string} roomId The room ID of the member.
	 * @param {string} userId The user ID of the member.
	 * @prop {string} roomId The room ID for this member.
	 * @prop {string} userId The user ID of this member.
	 * @prop {boolean} typing True if the room member is currently typing.
	 * @prop {string} name The human-readable name for this room member.
	 * @prop {Number} powerLevel The power level for this room member.
	 * @prop {Number} powerLevelNorm The normalised power level (0-100) for this
	 * room member.
	 * @prop {User} user The User object for this room member, if one exists.
	 * @prop {string} membership The membership state for this room member e.g. 'join'.
	 * @prop {Object} events The events describing this RoomMember.
	 * @prop {MatrixEvent} events.member The m.room.member event for this RoomMember.
	 */
	function RoomMember(roomId, userId) {
	    this.roomId = roomId;
	    this.userId = userId;
	    this.typing = false;
	    this.name = userId;
	    this.powerLevel = 0;
	    this.powerLevelNorm = 0;
	    this.user = null;
	    this.membership = null;
	    this.events = {
	        member: null
	    };
	    this._updateModifiedTime();
	}
	utils.inherits(RoomMember, EventEmitter);
	
	/**
	 * Update this room member's membership event. May fire "RoomMember.name" if
	 * this event updates this member's name.
	 * @param {MatrixEvent} event The <code>m.room.member</code> event
	 * @param {RoomState} roomState Optional. The room state to take into account
	 * when calculating (e.g. for disambiguating users with the same name).
	 * @fires module:client~MatrixClient#event:"RoomMember.name"
	 * @fires module:client~MatrixClient#event:"RoomMember.membership"
	 */
	RoomMember.prototype.setMembershipEvent = function (event, roomState) {
	    if (event.getType() !== "m.room.member") {
	        return;
	    }
	    this.events.member = event;
	
	    var oldMembership = this.membership;
	    this.membership = event.getDirectionalContent().membership;
	
	    var oldName = this.name;
	    this.name = calculateDisplayName(this, event, roomState);
	    if (oldMembership !== this.membership) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.membership", event, this, oldMembership);
	    }
	    if (oldName !== this.name) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.name", event, this, oldName);
	    }
	};
	
	/**
	 * Update this room member's power level event. May fire
	 * "RoomMember.powerLevel" if this event updates this member's power levels.
	 * @param {MatrixEvent} powerLevelEvent The <code>m.room.power_levels</code>
	 * event
	 * @fires module:client~MatrixClient#event:"RoomMember.powerLevel"
	 */
	RoomMember.prototype.setPowerLevelEvent = function (powerLevelEvent) {
	    if (powerLevelEvent.getType() !== "m.room.power_levels") {
	        return;
	    }
	    var maxLevel = powerLevelEvent.getContent().users_default || 0;
	    utils.forEach(utils.values(powerLevelEvent.getContent().users), function (lvl) {
	        maxLevel = Math.max(maxLevel, lvl);
	    });
	    var oldPowerLevel = this.powerLevel;
	    var oldPowerLevelNorm = this.powerLevelNorm;
	
	    if (powerLevelEvent.getContent().users[this.userId] !== undefined) {
	        this.powerLevel = powerLevelEvent.getContent().users[this.userId];
	    } else if (powerLevelEvent.getContent().users_default !== undefined) {
	        this.powerLevel = powerLevelEvent.getContent().users_default;
	    } else {
	        this.powerLevel = 0;
	    }
	    this.powerLevelNorm = 0;
	    if (maxLevel > 0) {
	        this.powerLevelNorm = this.powerLevel * 100 / maxLevel;
	    }
	
	    // emit for changes in powerLevelNorm as well (since the app will need to
	    // redraw everyone's level if the max has changed)
	    if (oldPowerLevel !== this.powerLevel || oldPowerLevelNorm !== this.powerLevelNorm) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.powerLevel", powerLevelEvent, this);
	    }
	};
	
	/**
	 * Update this room member's typing event. May fire "RoomMember.typing" if
	 * this event changes this member's typing state.
	 * @param {MatrixEvent} event The typing event
	 * @fires module:client~MatrixClient#event:"RoomMember.typing"
	 */
	RoomMember.prototype.setTypingEvent = function (event) {
	    if (event.getType() !== "m.typing") {
	        return;
	    }
	    var oldTyping = this.typing;
	    this.typing = false;
	    var typingList = event.getContent().user_ids;
	    if (!utils.isArray(typingList)) {
	        // malformed event :/ bail early. TODO: whine?
	        return;
	    }
	    if (typingList.indexOf(this.userId) !== -1) {
	        this.typing = true;
	    }
	    if (oldTyping !== this.typing) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.typing", event, this);
	    }
	};
	
	/**
	 * Update the last modified time to the current time.
	 */
	RoomMember.prototype._updateModifiedTime = function () {
	    this._modified = Date.now();
	};
	
	/**
	 * Get the timestamp when this RoomMember was last updated. This timestamp is
	 * updated when properties on this RoomMember are updated.
	 * It is updated <i>before</i> firing events.
	 * @return {number} The timestamp
	 */
	RoomMember.prototype.getLastModifiedTime = function () {
	    return this._modified;
	};
	
	/**
	 * Get the avatar URL for a room member.
	 * @param {string} baseUrl The base homeserver URL See
	 * {@link module:client~MatrixClient#getHomeserverUrl}.
	 * @param {Number} width The desired width of the thumbnail.
	 * @param {Number} height The desired height of the thumbnail.
	 * @param {string} resizeMethod The thumbnail resize method to use, either
	 * "crop" or "scale".
	 * @param {Boolean} allowDefault (optional) Passing false causes this method to
	 * return null if the user has no avatar image. Otherwise, a default image URL
	 * will be returned. Default: true.
	 * @param {Boolean} allowDirectLinks (optional) If true, the avatar URL will be
	 * returned even if it is a direct hyperlink rather than a matrix content URL.
	 * If false, any non-matrix content URLs will be ignored. Setting this option to
	 * true will expose URLs that, if fetched, will leak information about the user
	 * to anyone who they share a room with.
	 * @return {?string} the avatar URL or null.
	 */
	RoomMember.prototype.getAvatarUrl = function (baseUrl, width, height, resizeMethod, allowDefault, allowDirectLinks) {
	    if (allowDefault === undefined) {
	        allowDefault = true;
	    }
	    if (!this.events.member && !allowDefault) {
	        return null;
	    }
	    var rawUrl = this.events.member ? this.events.member.getContent().avatar_url : null;
	    var httpUrl = ContentRepo.getHttpUriForMxc(baseUrl, rawUrl, width, height, resizeMethod, allowDirectLinks);
	    if (httpUrl) {
	        return httpUrl;
	    } else if (allowDefault) {
	        return ContentRepo.getIdenticonUri(baseUrl, this.userId, width, height);
	    }
	    return null;
	};
	
	function calculateDisplayName(member, event, roomState) {
	    var displayName = event.getDirectionalContent().displayname;
	    var selfUserId = member.userId;
	
	    if (!displayName) {
	        return selfUserId;
	    }
	
	    if (!roomState) {
	        return displayName;
	    }
	
	    var userIds = roomState.getUserIdsWithDisplayName(displayName);
	    var otherUsers = userIds.filter(function (u) {
	        return u !== selfUserId;
	    });
	    if (otherUsers.length > 0) {
	        return displayName + " (" + selfUserId + ")";
	    }
	    return displayName;
	}
	
	/**
	 * The RoomMember class.
	 */
	module.exports = RoomMember;
	
	/**
	 * Fires whenever any room member's name changes.
	 * @event module:client~MatrixClient#"RoomMember.name"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.name changed.
	 * @param {string?} oldName The previous name. Null if the member didn't have a
	 *    name previously.
	 * @example
	 * matrixClient.on("RoomMember.name", function(event, member){
	 *   var newName = member.name;
	 * });
	 */
	
	/**
	 * Fires whenever any room member's membership state changes.
	 * @event module:client~MatrixClient#"RoomMember.membership"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.membership changed.
	 * @param {string?} oldMembership The previous membership state. Null if it's a
	 *    new member.
	 * @example
	 * matrixClient.on("RoomMember.membership", function(event, member, oldMembership){
	 *   var newState = member.membership;
	 * });
	 */
	
	/**
	 * Fires whenever any room member's typing state changes.
	 * @event module:client~MatrixClient#"RoomMember.typing"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.typing changed.
	 * @example
	 * matrixClient.on("RoomMember.typing", function(event, member){
	 *   var isTyping = member.typing;
	 * });
	 */
	
	/**
	 * Fires whenever any room member's power level changes.
	 * @event module:client~MatrixClient#"RoomMember.powerLevel"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.powerLevel changed.
	 * @example
	 * matrixClient.on("RoomMember.powerLevel", function(event, member){
	 *   var newPowerLevel = member.powerLevel;
	 *   var newNormPowerLevel = member.powerLevelNorm;
	 * });
	 */


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room-state
	 */
	
	var EventEmitter = __webpack_require__(56).EventEmitter;
	
	var utils = __webpack_require__(16);
	var RoomMember = __webpack_require__(489);
	
	/**
	 * Construct room state.
	 * @constructor
	 * @param {?string} roomId Optional. The ID of the room which has this state.
	 * If none is specified it just tracks paginationTokens, useful for notifTimelineSet
	 * @prop {Object.<string, RoomMember>} members The room member dictionary, keyed
	 * on the user's ID.
	 * @prop {Object.<string, Object.<string, MatrixEvent>>} events The state
	 * events dictionary, keyed on the event type and then the state_key value.
	 * @prop {string} paginationToken The pagination token for this state.
	 */
	function RoomState(roomId) {
	    this.roomId = roomId;
	    this.members = {
	        // userId: RoomMember
	    };
	    this.events = {
	        // eventType: { stateKey: MatrixEvent }
	    };
	    this.paginationToken = null;
	
	    this._sentinels = {
	        // userId: RoomMember
	    };
	    this._updateModifiedTime();
	    this._displayNameToUserIds = {};
	    this._userIdsToDisplayNames = {};
	    this._tokenToInvite = {}; // 3pid invite state_key to m.room.member invite
	}
	utils.inherits(RoomState, EventEmitter);
	
	/**
	 * Get all RoomMembers in this room.
	 * @return {Array<RoomMember>} A list of RoomMembers.
	 */
	RoomState.prototype.getMembers = function () {
	    return utils.values(this.members);
	};
	
	/**
	 * Get a room member by their user ID.
	 * @param {string} userId The room member's user ID.
	 * @return {RoomMember} The member or null if they do not exist.
	 */
	RoomState.prototype.getMember = function (userId) {
	    return this.members[userId] || null;
	};
	
	/**
	 * Get a room member whose properties will not change with this room state. You
	 * typically want this if you want to attach a RoomMember to a MatrixEvent which
	 * may no longer be represented correctly by Room.currentState or Room.oldState.
	 * The term 'sentinel' refers to the fact that this RoomMember is an unchanging
	 * guardian for state at this particular point in time.
	 * @param {string} userId The room member's user ID.
	 * @return {RoomMember} The member or null if they do not exist.
	 */
	RoomState.prototype.getSentinelMember = function (userId) {
	    return this._sentinels[userId] || null;
	};
	
	/**
	 * Get state events from the state of the room.
	 * @param {string} eventType The event type of the state event.
	 * @param {string} stateKey Optional. The state_key of the state event. If
	 * this is <code>undefined</code> then all matching state events will be
	 * returned.
	 * @return {MatrixEvent[]|MatrixEvent} A list of events if state_key was
	 * <code>undefined</code>, else a single event (or null if no match found).
	 */
	RoomState.prototype.getStateEvents = function (eventType, stateKey) {
	    if (!this.events[eventType]) {
	        // no match
	        return stateKey === undefined ? [] : null;
	    }
	    if (stateKey === undefined) {
	        // return all values
	        return utils.values(this.events[eventType]);
	    }
	    var event = this.events[eventType][stateKey];
	    return event ? event : null;
	};
	
	/**
	 * Add an array of one or more state MatrixEvents, overwriting
	 * any existing state with the same {type, stateKey} tuple. Will fire
	 * "RoomState.events" for every event added. May fire "RoomState.members"
	 * if there are <code>m.room.member</code> events.
	 * @param {MatrixEvent[]} stateEvents a list of state events for this room.
	 * @fires module:client~MatrixClient#event:"RoomState.members"
	 * @fires module:client~MatrixClient#event:"RoomState.newMember"
	 * @fires module:client~MatrixClient#event:"RoomState.events"
	 */
	RoomState.prototype.setStateEvents = function (stateEvents) {
	    var self = this;
	    this._updateModifiedTime();
	
	    // update the core event dict
	    utils.forEach(stateEvents, function (event) {
	        if (event.getRoomId() !== self.roomId) {
	            return;
	        }
	        if (!event.isState()) {
	            return;
	        }
	
	        if (self.events[event.getType()] === undefined) {
	            self.events[event.getType()] = {};
	        }
	        self.events[event.getType()][event.getStateKey()] = event;
	        if (event.getType() === "m.room.member") {
	            _updateDisplayNameCache(self, event.getStateKey(), event.getContent().displayname);
	            _updateThirdPartyTokenCache(self, event);
	        }
	        self.emit("RoomState.events", event, self);
	    });
	
	    // update higher level data structures. This needs to be done AFTER the
	    // core event dict as these structures may depend on other state events in
	    // the given array (e.g. disambiguating display names in one go to do both
	    // clashing names rather than progressively which only catches 1 of them).
	    utils.forEach(stateEvents, function (event) {
	        if (event.getRoomId() !== self.roomId) {
	            return;
	        }
	        if (!event.isState()) {
	            return;
	        }
	
	        if (event.getType() === "m.room.member") {
	            var userId = event.getStateKey();
	
	            // leave events apparently elide the displayname or avatar_url,
	            // so let's fake one up so that we don't leak user ids
	            // into the timeline
	            if (event.getContent().membership === "leave" || event.getContent().membership === "ban") {
	                event.getContent().avatar_url = event.getContent().avatar_url || event.getPrevContent().avatar_url;
	                event.getContent().displayname = event.getContent().displayname || event.getPrevContent().displayname;
	            }
	
	            var member = self.members[userId];
	            if (!member) {
	                member = new RoomMember(event.getRoomId(), userId);
	                self.emit("RoomState.newMember", event, self, member);
	            }
	            // Add a new sentinel for this change. We apply the same
	            // operations to both sentinel and member rather than deep copying
	            // so we don't make assumptions about the properties of RoomMember
	            // (e.g. and manage to break it because deep copying doesn't do
	            // everything).
	            var sentinel = new RoomMember(event.getRoomId(), userId);
	            utils.forEach([member, sentinel], function (roomMember) {
	                roomMember.setMembershipEvent(event, self);
	                // this member may have a power level already, so set it.
	                var pwrLvlEvent = self.getStateEvents("m.room.power_levels", "");
	                if (pwrLvlEvent) {
	                    roomMember.setPowerLevelEvent(pwrLvlEvent);
	                }
	            });
	
	            self._sentinels[userId] = sentinel;
	            self.members[userId] = member;
	            self.emit("RoomState.members", event, self, member);
	        } else if (event.getType() === "m.room.power_levels") {
	            var members = utils.values(self.members);
	            utils.forEach(members, function (member) {
	                member.setPowerLevelEvent(event);
	                self.emit("RoomState.members", event, self, member);
	            });
	        }
	    });
	};
	
	/**
	 * Set the current typing event for this room.
	 * @param {MatrixEvent} event The typing event
	 */
	RoomState.prototype.setTypingEvent = function (event) {
	    utils.forEach(utils.values(this.members), function (member) {
	        member.setTypingEvent(event);
	    });
	};
	
	/**
	 * Get the m.room.member event which has the given third party invite token.
	 *
	 * @param {string} token The token
	 * @return {?MatrixEvent} The m.room.member event or null
	 */
	RoomState.prototype.getInviteForThreePidToken = function (token) {
	    return this._tokenToInvite[token] || null;
	};
	
	/**
	 * Update the last modified time to the current time.
	 */
	RoomState.prototype._updateModifiedTime = function () {
	    this._modified = Date.now();
	};
	
	/**
	 * Get the timestamp when this room state was last updated. This timestamp is
	 * updated when this object has received new state events.
	 * @return {number} The timestamp
	 */
	RoomState.prototype.getLastModifiedTime = function () {
	    return this._modified;
	};
	
	/**
	 * Get user IDs with the specified display name.
	 * @param {string} displayName The display name to get user IDs from.
	 * @return {string[]} An array of user IDs or an empty array.
	 */
	RoomState.prototype.getUserIdsWithDisplayName = function (displayName) {
	    return this._displayNameToUserIds[displayName] || [];
	};
	
	/**
	 * Short-form for maySendEvent('m.room.message', userId)
	 * @param {string} userId The user ID of the user to test permission for
	 * @return {boolean} true if the given user ID should be permitted to send
	 *                   message events into the given room.
	 */
	RoomState.prototype.maySendMessage = function (userId) {
	    return this._maySendEventOfType('m.room.message', userId, false);
	};
	
	/**
	 * Returns true if the given user ID has permission to send a normal
	 * event of type `eventType` into this room.
	 * @param {string} eventType The type of event to test
	 * @param {string} userId The user ID of the user to test permission for
	 * @return {boolean} true if the given user ID should be permitted to send
	 *                        the given type of event into this room,
	 *                        according to the room's state.
	 */
	RoomState.prototype.maySendEvent = function (eventType, userId) {
	    return this._maySendEventOfType(eventType, userId, false);
	};
	
	/**
	 * Returns true if the given MatrixClient has permission to send a state
	 * event of type `stateEventType` into this room.
	 * @param {string} stateEventType The type of state events to test
	 * @param {MatrixClient} cli The client to test permission for
	 * @return {boolean} true if the given client should be permitted to send
	 *                        the given type of state event into this room,
	 *                        according to the room's state.
	 */
	RoomState.prototype.mayClientSendStateEvent = function (stateEventType, cli) {
	    if (cli.isGuest()) {
	        return false;
	    }
	    return this.maySendStateEvent(stateEventType, cli.credentials.userId);
	};
	
	/**
	 * Returns true if the given user ID has permission to send a state
	 * event of type `stateEventType` into this room.
	 * @param {string} stateEventType The type of state events to test
	 * @param {string} userId The user ID of the user to test permission for
	 * @return {boolean} true if the given user ID should be permitted to send
	 *                        the given type of state event into this room,
	 *                        according to the room's state.
	 */
	RoomState.prototype.maySendStateEvent = function (stateEventType, userId) {
	    return this._maySendEventOfType(stateEventType, userId, true);
	};
	
	/**
	 * Returns true if the given user ID has permission to send a normal or state
	 * event of type `eventType` into this room.
	 * @param {string} eventType The type of event to test
	 * @param {string} userId The user ID of the user to test permission for
	 * @param {boolean} state If true, tests if the user may send a state
	                          event of this type. Otherwise tests whether
	                          they may send a regular event.
	 * @return {boolean} true if the given user ID should be permitted to send
	 *                        the given type of event into this room,
	 *                        according to the room's state.
	 */
	RoomState.prototype._maySendEventOfType = function (eventType, userId, state) {
	    var member = this.getMember(userId);
	    if (!member || member.membership == 'leave') {
	        return false;
	    }
	
	    var power_levels_event = this.getStateEvents('m.room.power_levels', '');
	
	    var power_levels = void 0;
	    var events_levels = {};
	
	    var state_default = 0;
	    var events_default = 0;
	    if (power_levels_event) {
	        power_levels = power_levels_event.getContent();
	        events_levels = power_levels.events || {};
	
	        if (power_levels.state_default !== undefined) {
	            state_default = power_levels.state_default;
	        } else {
	            state_default = 50;
	        }
	        if (power_levels.events_default !== undefined) {
	            events_default = power_levels.events_default;
	        }
	    }
	
	    var required_level = state ? state_default : events_default;
	    if (events_levels[eventType] !== undefined) {
	        required_level = events_levels[eventType];
	    }
	    return member.powerLevel >= required_level;
	};
	
	/**
	 * The RoomState class.
	 */
	module.exports = RoomState;
	
	function _updateThirdPartyTokenCache(roomState, memberEvent) {
	    if (!memberEvent.getContent().third_party_invite) {
	        return;
	    }
	    var token = (memberEvent.getContent().third_party_invite.signed || {}).token;
	    if (!token) {
	        return;
	    }
	    var threePidInvite = roomState.getStateEvents("m.room.third_party_invite", token);
	    if (!threePidInvite) {
	        return;
	    }
	    roomState._tokenToInvite[token] = memberEvent;
	}
	
	function _updateDisplayNameCache(roomState, userId, displayName) {
	    var oldName = roomState._userIdsToDisplayNames[userId];
	    delete roomState._userIdsToDisplayNames[userId];
	    if (oldName) {
	        // Remove the old name from the cache.
	        // We clobber the user_id > name lookup but the name -> [user_id] lookup
	        // means we need to remove that user ID from that array rather than nuking
	        // the lot.
	        var existingUserIds = roomState._displayNameToUserIds[oldName] || [];
	        for (var i = 0; i < existingUserIds.length; i++) {
	            if (existingUserIds[i] === userId) {
	                // remove this user ID from this array
	                existingUserIds.splice(i, 1);
	                i--;
	            }
	        }
	        roomState._displayNameToUserIds[oldName] = existingUserIds;
	    }
	
	    roomState._userIdsToDisplayNames[userId] = displayName;
	    if (!roomState._displayNameToUserIds[displayName]) {
	        roomState._displayNameToUserIds[displayName] = [];
	    }
	    roomState._displayNameToUserIds[displayName].push(userId);
	}
	
	/**
	 * Fires whenever the event dictionary in room state is updated.
	 * @event module:client~MatrixClient#"RoomState.events"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomState} state The room state whose RoomState.events dictionary
	 * was updated.
	 * @example
	 * matrixClient.on("RoomState.events", function(event, state){
	 *   var newStateEvent = event;
	 * });
	 */
	
	/**
	 * Fires whenever a member in the members dictionary is updated in any way.
	 * @event module:client~MatrixClient#"RoomState.members"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomState} state The room state whose RoomState.members dictionary
	 * was updated.
	 * @param {RoomMember} member The room member that was updated.
	 * @example
	 * matrixClient.on("RoomState.members", function(event, state, member){
	 *   var newMembershipState = member.membership;
	 * });
	 */
	
	/**
	* Fires whenever a member is added to the members dictionary. The RoomMember
	* will not be fully populated yet (e.g. no membership state).
	* @event module:client~MatrixClient#"RoomState.newMember"
	* @param {MatrixEvent} event The matrix event which caused this event to fire.
	* @param {RoomState} state The room state whose RoomState.members dictionary
	* was updated with a new entry.
	* @param {RoomMember} member The room member that was added.
	* @example
	* matrixClient.on("RoomState.newMember", function(event, state, member){
	*   // add event listeners on 'member'
	* });
	*/


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room
	 */
	
	var EventEmitter = __webpack_require__(56).EventEmitter;
	
	var EventStatus = __webpack_require__(92).EventStatus;
	var RoomSummary = __webpack_require__(1145);
	var MatrixEvent = __webpack_require__(92).MatrixEvent;
	var utils = __webpack_require__(16);
	var ContentRepo = __webpack_require__(214);
	var EventTimeline = __webpack_require__(115);
	var EventTimelineSet = __webpack_require__(324);
	
	function synthesizeReceipt(userId, event, receiptType) {
	    // console.log("synthesizing receipt for "+event.getId());
	    // This is really ugly because JS has no way to express an object literal
	    // where the name of a key comes from an expression
	    var fakeReceipt = {
	        content: {},
	        type: "m.receipt",
	        room_id: event.getRoomId()
	    };
	    fakeReceipt.content[event.getId()] = {};
	    fakeReceipt.content[event.getId()][receiptType] = {};
	    fakeReceipt.content[event.getId()][receiptType][userId] = {
	        ts: event.getTs()
	    };
	    return new MatrixEvent(fakeReceipt);
	}
	
	/**
	 * Construct a new Room.
	 *
	 * <p>For a room, we store an ordered sequence of timelines, which may or may not
	 * be continuous. Each timeline lists a series of events, as well as tracking
	 * the room state at the start and the end of the timeline. It also tracks
	 * forward and backward pagination tokens, as well as containing links to the
	 * next timeline in the sequence.
	 *
	 * <p>There is one special timeline - the 'live' timeline, which represents the
	 * timeline to which events are being added in real-time as they are received
	 * from the /sync API. Note that you should not retain references to this
	 * timeline - even if it is the current timeline right now, it may not remain
	 * so if the server gives us a timeline gap in /sync.
	 *
	 * <p>In order that we can find events from their ids later, we also maintain a
	 * map from event_id to timeline and index.
	 *
	 * @constructor
	 * @alias module:models/room
	 * @param {string} roomId Required. The ID of this room.
	 * @param {Object=} opts Configuration options
	 * @param {*} opts.storageToken Optional. The token which a data store can use
	 * to remember the state of the room. What this means is dependent on the store
	 * implementation.
	 *
	 * @param {String=} opts.pendingEventOrdering Controls where pending messages
	 * appear in a room's timeline. If "<b>chronological</b>", messages will appear
	 * in the timeline when the call to <code>sendEvent</code> was made. If
	 * "<b>detached</b>", pending messages will appear in a separate list,
	 * accessbile via {@link module:models/room#getPendingEvents}. Default:
	 * "chronological".
	 *
	 * @param {boolean} [opts.timelineSupport = false] Set to true to enable improved
	 * timeline support.
	 *
	 * @prop {string} roomId The ID of this room.
	 * @prop {string} name The human-readable display name for this room.
	 * @prop {Array<MatrixEvent>} timeline The live event timeline for this room,
	 * with the oldest event at index 0. Present for backwards compatibility -
	 * prefer getLiveTimeline().getEvents().
	 * @prop {object} tags Dict of room tags; the keys are the tag name and the values
	 * are any metadata associated with the tag - e.g. { "fav" : { order: 1 } }
	 * @prop {object} accountData Dict of per-room account_data events; the keys are the
	 * event type and the values are the events.
	 * @prop {RoomState} oldState The state of the room at the time of the oldest
	 * event in the live timeline. Present for backwards compatibility -
	 * prefer getLiveTimeline().getState(true).
	 * @prop {RoomState} currentState The state of the room at the time of the
	 * newest event in the timeline. Present for backwards compatibility -
	 * prefer getLiveTimeline().getState(false).
	 * @prop {RoomSummary} summary The room summary.
	 * @prop {*} storageToken A token which a data store can use to remember
	 * the state of the room.
	 */
	function Room(roomId, opts) {
	    opts = opts || {};
	    opts.pendingEventOrdering = opts.pendingEventOrdering || "chronological";
	
	    if (["chronological", "detached"].indexOf(opts.pendingEventOrdering) === -1) {
	        throw new Error("opts.pendingEventOrdering MUST be either 'chronological' or " + "'detached'. Got: '" + opts.pendingEventOrdering + "'");
	    }
	
	    this.roomId = roomId;
	    this.name = roomId;
	    this.tags = {
	        // $tagName: { $metadata: $value },
	        // $tagName: { $metadata: $value },
	    };
	    this.accountData = {
	        // $eventType: $event
	    };
	    this.summary = null;
	    this.storageToken = opts.storageToken;
	    this._opts = opts;
	    this._txnToEvent = {}; // Pending in-flight requests { string: MatrixEvent }
	    // receipts should clobber based on receipt_type and user_id pairs hence
	    // the form of this structure. This is sub-optimal for the exposed APIs
	    // which pass in an event ID and get back some receipts, so we also store
	    // a pre-cached list for this purpose.
	    this._receipts = {
	        // receipt_type: {
	        //   user_id: {
	        //     eventId: <event_id>,
	        //     data: <receipt_data>
	        //   }
	        // }
	    };
	    this._receiptCacheByEventId = {
	        // $event_id: [{
	        //   type: $type,
	        //   userId: $user_id,
	        //   data: <receipt data>
	        // }]
	    };
	    // only receipts that came from the server, not synthesized ones
	    this._realReceipts = {};
	
	    this._notificationCounts = {};
	
	    // all our per-room timeline sets. the first one is the unfiltered ones;
	    // the subsequent ones are the filtered ones in no particular order.
	    this._timelineSets = [new EventTimelineSet(this, opts)];
	    reEmit(this, this.getUnfilteredTimelineSet(), ["Room.timeline", "Room.timelineReset"]);
	
	    this._fixUpLegacyTimelineFields();
	
	    // any filtered timeline sets we're maintaining for this room
	    this._filteredTimelineSets = {
	        // filter_id: timelineSet
	    };
	
	    if (this._opts.pendingEventOrdering == "detached") {
	        this._pendingEventList = [];
	    }
	
	    this._blacklistUnverifiedDevices = false; // read by megolm
	}
	utils.inherits(Room, EventEmitter);
	
	/**
	 * Get the list of pending sent events for this room
	 *
	 * @return {module:models/event.MatrixEvent[]} A list of the sent events
	 * waiting for remote echo.
	 *
	 * @throws If <code>opts.pendingEventOrdering</code> was not 'detached'
	 */
	Room.prototype.getPendingEvents = function () {
	    if (this._opts.pendingEventOrdering !== "detached") {
	        throw new Error("Cannot call getPendingEventList with pendingEventOrdering == " + this._opts.pendingEventOrdering);
	    }
	
	    return this._pendingEventList;
	};
	
	/**
	 * Get the live unfiltered timeline for this room.
	 *
	 * @return {module:models/event-timeline~EventTimeline} live timeline
	 */
	Room.prototype.getLiveTimeline = function () {
	    return this.getUnfilteredTimelineSet().getLiveTimeline();
	};
	
	/**
	 * Reset the live timeline of all timelineSets, and start new ones.
	 *
	 * <p>This is used when /sync returns a 'limited' timeline.
	 *
	 * @param {string=} backPaginationToken   token for back-paginating the new timeline
	 * @param {boolean=} flush True to remove all events in all timelines. If false, only
	 * the live timeline is reset.
	 */
	Room.prototype.resetLiveTimeline = function (backPaginationToken, flush) {
	    for (var i = 0; i < this._timelineSets.length; i++) {
	        this._timelineSets[i].resetLiveTimeline(backPaginationToken, flush);
	    }
	
	    this._fixUpLegacyTimelineFields();
	};
	
	/**
	 * Fix up this.timeline, this.oldState and this.currentState
	 *
	 * @private
	 */
	Room.prototype._fixUpLegacyTimelineFields = function () {
	    // maintain this.timeline as a reference to the live timeline,
	    // and this.oldState and this.currentState as references to the
	    // state at the start and end of that timeline. These are more
	    // for backwards-compatibility than anything else.
	    this.timeline = this.getLiveTimeline().getEvents();
	    this.oldState = this.getLiveTimeline().getState(EventTimeline.BACKWARDS);
	    this.currentState = this.getLiveTimeline().getState(EventTimeline.FORWARDS);
	};
	
	/**
	 * Return the timeline sets for this room.
	 * @return {EventTimelineSet[]} array of timeline sets for this room
	 */
	Room.prototype.getTimelineSets = function () {
	    return this._timelineSets;
	};
	
	/**
	 * Helper to return the main unfiltered timeline set for this room
	 * @return {EventTimelineSet} room's unfiltered timeline set
	 */
	Room.prototype.getUnfilteredTimelineSet = function () {
	    return this._timelineSets[0];
	};
	
	/**
	 * Get the timeline which contains the given event from the unfiltered set, if any
	 *
	 * @param {string} eventId  event ID to look for
	 * @return {?module:models/event-timeline~EventTimeline} timeline containing
	 * the given event, or null if unknown
	 */
	Room.prototype.getTimelineForEvent = function (eventId) {
	    return this.getUnfilteredTimelineSet().getTimelineForEvent(eventId);
	};
	
	/**
	 * Add a new timeline to this room's unfiltered timeline set
	 *
	 * @return {module:models/event-timeline~EventTimeline} newly-created timeline
	 */
	Room.prototype.addTimeline = function () {
	    return this.getUnfilteredTimelineSet().addTimeline();
	};
	
	/**
	 * Get an event which is stored in our unfiltered timeline set
	 *
	 * @param {string} eventId  event ID to look for
	 * @return {?module:models/event.MatrixEvent} the given event, or undefined if unknown
	 */
	Room.prototype.findEventById = function (eventId) {
	    return this.getUnfilteredTimelineSet().findEventById(eventId);
	};
	
	/**
	 * Get one of the notification counts for this room
	 * @param {String} type The type of notification count to get. default: 'total'
	 * @return {Number} The notification count, or undefined if there is no count
	 *                  for this type.
	 */
	Room.prototype.getUnreadNotificationCount = function (type) {
	    type = type || 'total';
	    return this._notificationCounts[type];
	};
	
	/**
	 * Set one of the notification counts for this room
	 * @param {String} type The type of notification count to set.
	 * @param {Number} count The new count
	 */
	Room.prototype.setUnreadNotificationCount = function (type, count) {
	    this._notificationCounts[type] = count;
	};
	
	/**
	 * Whether to send encrypted messages to devices within this room.
	 * Will be ignored if MatrixClient's blacklistUnverifiedDevices setting is true.
	 * @param {boolean} value if true, blacklist unverified devices.
	 */
	Room.prototype.setBlacklistUnverifiedDevices = function (value) {
	    this._blacklistUnverifiedDevices = value;
	};
	
	/**
	 * Whether to send encrypted messages to devices within this room.
	 * Will be ignored if MatrixClient's blacklistUnverifiedDevices setting is true.
	 * @return {boolean} true if blacklisting unverified devices.
	 */
	Room.prototype.getBlacklistUnverifiedDevices = function () {
	    return this._blacklistUnverifiedDevices;
	};
	
	/**
	 * Get the avatar URL for a room if one was set.
	 * @param {String} baseUrl The homeserver base URL. See
	 * {@link module:client~MatrixClient#getHomeserverUrl}.
	 * @param {Number} width The desired width of the thumbnail.
	 * @param {Number} height The desired height of the thumbnail.
	 * @param {string} resizeMethod The thumbnail resize method to use, either
	 * "crop" or "scale".
	 * @param {boolean} allowDefault True to allow an identicon for this room if an
	 * avatar URL wasn't explicitly set. Default: true.
	 * @return {?string} the avatar URL or null.
	 */
	Room.prototype.getAvatarUrl = function (baseUrl, width, height, resizeMethod, allowDefault) {
	    var roomAvatarEvent = this.currentState.getStateEvents("m.room.avatar", "");
	    if (allowDefault === undefined) {
	        allowDefault = true;
	    }
	    if (!roomAvatarEvent && !allowDefault) {
	        return null;
	    }
	
	    var mainUrl = roomAvatarEvent ? roomAvatarEvent.getContent().url : null;
	    if (mainUrl) {
	        return ContentRepo.getHttpUriForMxc(baseUrl, mainUrl, width, height, resizeMethod);
	    } else if (allowDefault) {
	        return ContentRepo.getIdenticonUri(baseUrl, this.roomId, width, height);
	    }
	
	    return null;
	};
	
	/**
	 * Get the aliases this room has according to the room's state
	 * The aliases returned by this function may not necessarily
	 * still point to this room.
	 * @return {array} The room's alias as an array of strings
	 */
	Room.prototype.getAliases = function () {
	    var alias_strings = [];
	
	    var alias_events = this.currentState.getStateEvents("m.room.aliases");
	    if (alias_events) {
	        for (var i = 0; i < alias_events.length; ++i) {
	            var alias_event = alias_events[i];
	            if (utils.isArray(alias_event.getContent().aliases)) {
	                Array.prototype.push.apply(alias_strings, alias_event.getContent().aliases);
	            }
	        }
	    }
	    return alias_strings;
	};
	
	/**
	 * Get this room's canonical alias
	 * The alias returned by this function may not necessarily
	 * still point to this room.
	 * @return {?string} The room's canonical alias, or null if there is none
	 */
	Room.prototype.getCanonicalAlias = function () {
	    var canonicalAlias = this.currentState.getStateEvents("m.room.canonical_alias", "");
	    if (canonicalAlias) {
	        return canonicalAlias.getContent().alias;
	    }
	    return null;
	};
	
	/**
	 * Add events to a timeline
	 *
	 * <p>Will fire "Room.timeline" for each event added.
	 *
	 * @param {MatrixEvent[]} events A list of events to add.
	 *
	 * @param {boolean} toStartOfTimeline   True to add these events to the start
	 * (oldest) instead of the end (newest) of the timeline. If true, the oldest
	 * event will be the <b>last</b> element of 'events'.
	 *
	 * @param {module:models/event-timeline~EventTimeline} timeline   timeline to
	 *    add events to.
	 *
	 * @param {string=} paginationToken   token for the next batch of events
	 *
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 *
	 */
	Room.prototype.addEventsToTimeline = function (events, toStartOfTimeline, timeline, paginationToken) {
	    timeline.getTimelineSet().addEventsToTimeline(events, toStartOfTimeline, timeline, paginationToken);
	};
	
	/**
	 * Get a member from the current room state.
	 * @param {string} userId The user ID of the member.
	 * @return {RoomMember} The member or <code>null</code>.
	 */
	Room.prototype.getMember = function (userId) {
	    var member = this.currentState.members[userId];
	    if (!member) {
	        return null;
	    }
	    return member;
	};
	
	/**
	 * Get a list of members whose membership state is "join".
	 * @return {RoomMember[]} A list of currently joined members.
	 */
	Room.prototype.getJoinedMembers = function () {
	    return this.getMembersWithMembership("join");
	};
	
	/**
	 * Get a list of members with given membership state.
	 * @param {string} membership The membership state.
	 * @return {RoomMember[]} A list of members with the given membership state.
	 */
	Room.prototype.getMembersWithMembership = function (membership) {
	    return utils.filter(this.currentState.getMembers(), function (m) {
	        return m.membership === membership;
	    });
	};
	
	/**
	 * Get the default room name (i.e. what a given user would see if the
	 * room had no m.room.name)
	 * @param {string} userId The userId from whose perspective we want
	 * to calculate the default name
	 * @return {string} The default room name
	 */
	Room.prototype.getDefaultRoomName = function (userId) {
	    return calculateRoomName(this, userId, true);
	};
	
	/**
	* Check if the given user_id has the given membership state.
	* @param {string} userId The user ID to check.
	* @param {string} membership The membership e.g. <code>'join'</code>
	* @return {boolean} True if this user_id has the given membership state.
	*/
	Room.prototype.hasMembershipState = function (userId, membership) {
	    var member = this.getMember(userId);
	    if (!member) {
	        return false;
	    }
	    return member.membership === membership;
	};
	
	/**
	 * Add a timelineSet for this room with the given filter
	 * @param {Filter} filter  The filter to be applied to this timelineSet
	 * @return {EventTimelineSet}  The timelineSet
	 */
	Room.prototype.getOrCreateFilteredTimelineSet = function (filter) {
	    if (this._filteredTimelineSets[filter.filterId]) {
	        return this._filteredTimelineSets[filter.filterId];
	    }
	    var opts = Object.assign({ filter: filter }, this._opts);
	    var timelineSet = new EventTimelineSet(this, opts);
	    reEmit(this, timelineSet, ["Room.timeline", "Room.timelineReset"]);
	    this._filteredTimelineSets[filter.filterId] = timelineSet;
	    this._timelineSets.push(timelineSet);
	
	    // populate up the new timelineSet with filtered events from our live
	    // unfiltered timeline.
	    //
	    // XXX: This is risky as our timeline
	    // may have grown huge and so take a long time to filter.
	    // see https://github.com/vector-im/vector-web/issues/2109
	
	    var unfilteredLiveTimeline = this.getLiveTimeline();
	
	    unfilteredLiveTimeline.getEvents().forEach(function (event) {
	        timelineSet.addLiveEvent(event);
	    });
	
	    // find the earliest unfiltered timeline
	    var timeline = unfilteredLiveTimeline;
	    while (timeline.getNeighbouringTimeline(EventTimeline.BACKWARDS)) {
	        timeline = timeline.getNeighbouringTimeline(EventTimeline.BACKWARDS);
	    }
	
	    timelineSet.getLiveTimeline().setPaginationToken(timeline.getPaginationToken(EventTimeline.BACKWARDS), EventTimeline.BACKWARDS);
	
	    // alternatively, we could try to do something like this to try and re-paginate
	    // in the filtered events from nothing, but Mark says it's an abuse of the API
	    // to do so:
	    //
	    // timelineSet.resetLiveTimeline(
	    //      unfilteredLiveTimeline.getPaginationToken(EventTimeline.FORWARDS)
	    // );
	
	    return timelineSet;
	};
	
	/**
	 * Forget the timelineSet for this room with the given filter
	 *
	 * @param {Filter} filter  the filter whose timelineSet is to be forgotten
	 */
	Room.prototype.removeFilteredTimelineSet = function (filter) {
	    var timelineSet = this._filteredTimelineSets[filter.filterId];
	    delete this._filteredTimelineSets[filter.filterId];
	    var i = this._timelineSets.indexOf(timelineSet);
	    if (i > -1) {
	        this._timelineSets.splice(i, 1);
	    }
	};
	
	/**
	 * Add an event to the end of this room's live timelines. Will fire
	 * "Room.timeline".
	 *
	 * @param {MatrixEvent} event Event to be added
	 * @param {string?} duplicateStrategy 'ignore' or 'replace'
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 * @private
	 */
	Room.prototype._addLiveEvent = function (event, duplicateStrategy) {
	    var i = void 0;
	    if (event.getType() === "m.room.redaction") {
	        var redactId = event.event.redacts;
	
	        // if we know about this event, redact its contents now.
	        var redactedEvent = this.getUnfilteredTimelineSet().findEventById(redactId);
	        if (redactedEvent) {
	            redactedEvent.makeRedacted(event);
	            this.emit("Room.redaction", event, this);
	
	            // TODO: we stash user displaynames (among other things) in
	            // RoomMember objects which are then attached to other events
	            // (in the sender and target fields). We should get those
	            // RoomMember objects to update themselves when the events that
	            // they are based on are changed.
	        }
	
	        // FIXME: apply redactions to notification list
	
	        // NB: We continue to add the redaction event to the timeline so
	        // clients can say "so and so redacted an event" if they wish to. Also
	        // this may be needed to trigger an update.
	    }
	
	    if (event.getUnsigned().transaction_id) {
	        var existingEvent = this._txnToEvent[event.getUnsigned().transaction_id];
	        if (existingEvent) {
	            // remote echo of an event we sent earlier
	            this._handleRemoteEcho(event, existingEvent);
	            return;
	        }
	    }
	
	    // add to our timeline sets
	    for (i = 0; i < this._timelineSets.length; i++) {
	        this._timelineSets[i].addLiveEvent(event, duplicateStrategy);
	    }
	
	    // synthesize and inject implicit read receipts
	    // Done after adding the event because otherwise the app would get a read receipt
	    // pointing to an event that wasn't yet in the timeline
	    if (event.sender) {
	        this.addReceipt(synthesizeReceipt(event.sender.userId, event, "m.read"), true);
	
	        // Any live events from a user could be taken as implicit
	        // presence information: evidence that they are currently active.
	        // ...except in a world where we use 'user.currentlyActive' to reduce
	        // presence spam, this isn't very useful - we'll get a transition when
	        // they are no longer currently active anyway. So don't bother to
	        // reset the lastActiveAgo and lastPresenceTs from the RoomState's user.
	    }
	};
	
	/**
	 * Add a pending outgoing event to this room.
	 *
	 * <p>The event is added to either the pendingEventList, or the live timeline,
	 * depending on the setting of opts.pendingEventOrdering.
	 *
	 * <p>This is an internal method, intended for use by MatrixClient.
	 *
	 * @param {module:models/event.MatrixEvent} event The event to add.
	 *
	 * @param {string} txnId   Transaction id for this outgoing event
	 *
	 * @fires module:client~MatrixClient#event:"Room.localEchoUpdated"
	 *
	 * @throws if the event doesn't have status SENDING, or we aren't given a
	 * unique transaction id.
	 */
	Room.prototype.addPendingEvent = function (event, txnId) {
	    if (event.status !== EventStatus.SENDING) {
	        throw new Error("addPendingEvent called on an event with status " + event.status);
	    }
	
	    if (this._txnToEvent[txnId]) {
	        throw new Error("addPendingEvent called on an event with known txnId " + txnId);
	    }
	
	    // call setEventMetadata to set up event.sender etc
	    // as event is shared over all timelineSets, we set up its metadata based
	    // on the unfiltered timelineSet.
	    EventTimeline.setEventMetadata(event, this.getLiveTimeline().getState(EventTimeline.FORWARDS), false);
	
	    this._txnToEvent[txnId] = event;
	
	    if (this._opts.pendingEventOrdering == "detached") {
	        this._pendingEventList.push(event);
	    } else {
	        for (var i = 0; i < this._timelineSets.length; i++) {
	            var timelineSet = this._timelineSets[i];
	            if (timelineSet.getFilter()) {
	                if (this._filter.filterRoomTimeline([event]).length) {
	                    timelineSet.addEventToTimeline(event, timelineSet.getLiveTimeline(), false);
	                }
	            } else {
	                timelineSet.addEventToTimeline(event, timelineSet.getLiveTimeline(), false);
	            }
	        }
	    }
	
	    this.emit("Room.localEchoUpdated", event, this, null, null);
	};
	
	/**
	 * Deal with the echo of a message we sent.
	 *
	 * <p>We move the event to the live timeline if it isn't there already, and
	 * update it.
	 *
	 * @param {module:models/event.MatrixEvent} remoteEvent   The event received from
	 *    /sync
	 * @param {module:models/event.MatrixEvent} localEvent    The local echo, which
	 *    should be either in the _pendingEventList or the timeline.
	 *
	 * @fires module:client~MatrixClient#event:"Room.localEchoUpdated"
	 * @private
	 */
	Room.prototype._handleRemoteEcho = function (remoteEvent, localEvent) {
	    var oldEventId = localEvent.getId();
	    var newEventId = remoteEvent.getId();
	    var oldStatus = localEvent.status;
	
	    // no longer pending
	    delete this._txnToEvent[remoteEvent.transaction_id];
	
	    // if it's in the pending list, remove it
	    if (this._pendingEventList) {
	        utils.removeElement(this._pendingEventList, function (ev) {
	            return ev.getId() == oldEventId;
	        }, false);
	    }
	
	    // replace the event source (this will preserve the plaintext payload if
	    // any, which is good, because we don't want to try decoding it again).
	    localEvent.handleRemoteEcho(remoteEvent.event);
	
	    for (var i = 0; i < this._timelineSets.length; i++) {
	        var timelineSet = this._timelineSets[i];
	
	        // if it's already in the timeline, update the timeline map. If it's not, add it.
	        timelineSet.handleRemoteEcho(localEvent, oldEventId, newEventId);
	    }
	
	    this.emit("Room.localEchoUpdated", localEvent, this, oldEventId, oldStatus);
	};
	
	/* a map from current event status to a list of allowed next statuses
	 */
	var ALLOWED_TRANSITIONS = {};
	
	ALLOWED_TRANSITIONS[EventStatus.ENCRYPTING] = [EventStatus.SENDING, EventStatus.NOT_SENT];
	
	ALLOWED_TRANSITIONS[EventStatus.SENDING] = [EventStatus.ENCRYPTING, EventStatus.QUEUED, EventStatus.NOT_SENT, EventStatus.SENT];
	
	ALLOWED_TRANSITIONS[EventStatus.QUEUED] = [EventStatus.SENDING, EventStatus.CANCELLED];
	
	ALLOWED_TRANSITIONS[EventStatus.SENT] = [];
	
	ALLOWED_TRANSITIONS[EventStatus.NOT_SENT] = [EventStatus.SENDING, EventStatus.QUEUED, EventStatus.CANCELLED];
	
	ALLOWED_TRANSITIONS[EventStatus.CANCELLED] = [];
	
	/**
	 * Update the status / event id on a pending event, to reflect its transmission
	 * progress.
	 *
	 * <p>This is an internal method.
	 *
	 * @param {MatrixEvent} event      local echo event
	 * @param {EventStatus} newStatus  status to assign
	 * @param {string} newEventId      new event id to assign. Ignored unless
	 *    newStatus == EventStatus.SENT.
	 * @fires module:client~MatrixClient#event:"Room.localEchoUpdated"
	 */
	Room.prototype.updatePendingEvent = function (event, newStatus, newEventId) {
	    // if the message was sent, we expect an event id
	    if (newStatus == EventStatus.SENT && !newEventId) {
	        throw new Error("updatePendingEvent called with status=SENT, " + "but no new event id");
	    }
	
	    // SENT races against /sync, so we have to special-case it.
	    if (newStatus == EventStatus.SENT) {
	        var timeline = this.getUnfilteredTimelineSet().eventIdToTimeline(newEventId);
	        if (timeline) {
	            // we've already received the event via the event stream.
	            // nothing more to do here.
	            return;
	        }
	    }
	
	    var oldStatus = event.status;
	    var oldEventId = event.getId();
	
	    if (!oldStatus) {
	        throw new Error("updatePendingEventStatus called on an event which is " + "not a local echo.");
	    }
	
	    var allowed = ALLOWED_TRANSITIONS[oldStatus];
	    if (!allowed || allowed.indexOf(newStatus) < 0) {
	        throw new Error("Invalid EventStatus transition " + oldStatus + "->" + newStatus);
	    }
	
	    event.status = newStatus;
	
	    if (newStatus == EventStatus.SENT) {
	        // update the event id
	        event.event.event_id = newEventId;
	
	        // if the event was already in the timeline (which will be the case if
	        // opts.pendingEventOrdering==chronological), we need to update the
	        // timeline map.
	        for (var i = 0; i < this._timelineSets.length; i++) {
	            this._timelineSets[i].replaceEventId(oldEventId, newEventId);
	        }
	    } else if (newStatus == EventStatus.CANCELLED) {
	        // remove it from the pending event list, or the timeline.
	        if (this._pendingEventList) {
	            utils.removeElement(this._pendingEventList, function (ev) {
	                return ev.getId() == oldEventId;
	            }, false);
	        }
	        this.removeEvent(oldEventId);
	    }
	
	    this.emit("Room.localEchoUpdated", event, this, event.getId(), oldStatus);
	};
	
	/**
	 * Add some events to this room. This can include state events, message
	 * events and typing notifications. These events are treated as "live" so
	 * they will go to the end of the timeline.
	 *
	 * @param {MatrixEvent[]} events A list of events to add.
	 *
	 * @param {string} duplicateStrategy Optional. Applies to events in the
	 * timeline only. If this is 'replace' then if a duplicate is encountered, the
	 * event passed to this function will replace the existing event in the
	 * timeline. If this is not specified, or is 'ignore', then the event passed to
	 * this function will be ignored entirely, preserving the existing event in the
	 * timeline. Events are identical based on their event ID <b>only</b>.
	 *
	 * @throws If <code>duplicateStrategy</code> is not falsey, 'replace' or 'ignore'.
	 */
	Room.prototype.addLiveEvents = function (events, duplicateStrategy) {
	    var i = void 0;
	    if (duplicateStrategy && ["replace", "ignore"].indexOf(duplicateStrategy) === -1) {
	        throw new Error("duplicateStrategy MUST be either 'replace' or 'ignore'");
	    }
	
	    // sanity check that the live timeline is still live
	    for (i = 0; i < this._timelineSets.length; i++) {
	        var liveTimeline = this._timelineSets[i].getLiveTimeline();
	        if (liveTimeline.getPaginationToken(EventTimeline.FORWARDS)) {
	            throw new Error("live timeline " + i + " is no longer live - it has a pagination token " + "(" + liveTimeline.getPaginationToken(EventTimeline.FORWARDS) + ")");
	        }
	        if (liveTimeline.getNeighbouringTimeline(EventTimeline.FORWARDS)) {
	            throw new Error("live timeline " + i + " is no longer live - " + "it has a neighbouring timeline");
	        }
	    }
	
	    for (i = 0; i < events.length; i++) {
	        if (events[i].getType() === "m.typing") {
	            this.currentState.setTypingEvent(events[i]);
	        } else if (events[i].getType() === "m.receipt") {
	            this.addReceipt(events[i]);
	        }
	        // N.B. account_data is added directly by /sync to avoid
	        // having to maintain an event.isAccountData() here
	        else {
	                // TODO: We should have a filter to say "only add state event
	                // types X Y Z to the timeline".
	                this._addLiveEvent(events[i], duplicateStrategy);
	            }
	    }
	};
	
	/**
	 * Removes events from this room.
	 * @param {String[]} event_ids A list of event_ids to remove.
	 */
	Room.prototype.removeEvents = function (event_ids) {
	    for (var i = 0; i < event_ids.length; ++i) {
	        this.removeEvent(event_ids[i]);
	    }
	};
	
	/**
	 * Removes a single event from this room.
	 *
	 * @param {String} eventId  The id of the event to remove
	 *
	 * @return {bool} true if the event was removed from any of the room's timeline sets
	 */
	Room.prototype.removeEvent = function (eventId) {
	    var removedAny = false;
	    for (var i = 0; i < this._timelineSets.length; i++) {
	        var removed = this._timelineSets[i].removeEvent(eventId);
	        if (removed) {
	            removedAny = true;
	        }
	    }
	    return removedAny;
	};
	
	/**
	 * Recalculate various aspects of the room, including the room name and
	 * room summary. Call this any time the room's current state is modified.
	 * May fire "Room.name" if the room name is updated.
	 * @param {string} userId The client's user ID.
	 * @fires module:client~MatrixClient#event:"Room.name"
	 */
	Room.prototype.recalculate = function (userId) {
	    // set fake stripped state events if this is an invite room so logic remains
	    // consistent elsewhere.
	    var self = this;
	    var membershipEvent = this.currentState.getStateEvents("m.room.member", userId);
	    if (membershipEvent && membershipEvent.getContent().membership === "invite") {
	        var strippedStateEvents = membershipEvent.event.invite_room_state || [];
	        utils.forEach(strippedStateEvents, function (strippedEvent) {
	            var existingEvent = self.currentState.getStateEvents(strippedEvent.type, strippedEvent.state_key);
	            if (!existingEvent) {
	                // set the fake stripped event instead
	                self.currentState.setStateEvents([new MatrixEvent({
	                    type: strippedEvent.type,
	                    state_key: strippedEvent.state_key,
	                    content: strippedEvent.content,
	                    event_id: "$fake" + Date.now(),
	                    room_id: self.roomId,
	                    user_id: userId })]);
	            }
	        });
	    }
	
	    var oldName = this.name;
	    this.name = calculateRoomName(this, userId);
	    this.summary = new RoomSummary(this.roomId, {
	        title: this.name
	    });
	
	    if (oldName !== this.name) {
	        this.emit("Room.name", this);
	    }
	};
	
	/**
	 * Get a list of user IDs who have <b>read up to</b> the given event.
	 * @param {MatrixEvent} event the event to get read receipts for.
	 * @return {String[]} A list of user IDs.
	 */
	Room.prototype.getUsersReadUpTo = function (event) {
	    return this.getReceiptsForEvent(event).filter(function (receipt) {
	        return receipt.type === "m.read";
	    }).map(function (receipt) {
	        return receipt.userId;
	    });
	};
	
	/**
	 * Get the ID of the event that a given user has read up to, or null if we
	 * have received no read receipts from them.
	 * @param {String} userId The user ID to get read receipt event ID for
	 * @param {Boolean} ignoreSynthesized If true, return only receipts that have been
	 *                                    sent by the server, not implicit ones generated
	 *                                    by the JS SDK.
	 * @return {String} ID of the latest event that the given user has read, or null.
	 */
	Room.prototype.getEventReadUpTo = function (userId, ignoreSynthesized) {
	    var receipts = this._receipts;
	    if (ignoreSynthesized) {
	        receipts = this._realReceipts;
	    }
	
	    if (receipts["m.read"] === undefined || receipts["m.read"][userId] === undefined) {
	        return null;
	    }
	
	    return receipts["m.read"][userId].eventId;
	};
	
	/**
	 * Get a list of receipts for the given event.
	 * @param {MatrixEvent} event the event to get receipts for
	 * @return {Object[]} A list of receipts with a userId, type and data keys or
	 * an empty list.
	 */
	Room.prototype.getReceiptsForEvent = function (event) {
	    return this._receiptCacheByEventId[event.getId()] || [];
	};
	
	/**
	 * Add a receipt event to the room.
	 * @param {MatrixEvent} event The m.receipt event.
	 * @param {Boolean} fake True if this event is implicit
	 */
	Room.prototype.addReceipt = function (event, fake) {
	    // event content looks like:
	    // content: {
	    //   $event_id: {
	    //     $receipt_type: {
	    //       $user_id: {
	    //         ts: $timestamp
	    //       }
	    //     }
	    //   }
	    // }
	    if (fake === undefined) {
	        fake = false;
	    }
	    if (!fake) {
	        this._addReceiptsToStructure(event, this._realReceipts);
	        // we don't bother caching real receipts by event ID
	        // as there's nothing that would read it.
	    }
	    this._addReceiptsToStructure(event, this._receipts);
	    this._receiptCacheByEventId = this._buildReceiptCache(this._receipts);
	
	    // send events after we've regenerated the cache, otherwise things that
	    // listened for the event would read from a stale cache
	    this.emit("Room.receipt", event, this);
	};
	
	/**
	 * Add a receipt event to the room.
	 * @param {MatrixEvent} event The m.receipt event.
	 * @param {Object} receipts The object to add receipts to
	 */
	Room.prototype._addReceiptsToStructure = function (event, receipts) {
	    var self = this;
	    utils.keys(event.getContent()).forEach(function (eventId) {
	        utils.keys(event.getContent()[eventId]).forEach(function (receiptType) {
	            utils.keys(event.getContent()[eventId][receiptType]).forEach(function (userId) {
	                var receipt = event.getContent()[eventId][receiptType][userId];
	
	                if (!receipts[receiptType]) {
	                    receipts[receiptType] = {};
	                }
	
	                var existingReceipt = receipts[receiptType][userId];
	
	                if (!existingReceipt) {
	                    receipts[receiptType][userId] = {};
	                } else {
	                    // we only want to add this receipt if we think it is later
	                    // than the one we already have. (This is managed
	                    // server-side, but because we synthesize RRs locally we
	                    // have to do it here too.)
	                    var ordering = self.getUnfilteredTimelineSet().compareEventOrdering(existingReceipt.eventId, eventId);
	                    if (ordering !== null && ordering >= 0) {
	                        return;
	                    }
	                }
	
	                receipts[receiptType][userId] = {
	                    eventId: eventId,
	                    data: receipt
	                };
	            });
	        });
	    });
	};
	
	/**
	 * Build and return a map of receipts by event ID
	 * @param {Object} receipts A map of receipts
	 * @return {Object} Map of receipts by event ID
	 */
	Room.prototype._buildReceiptCache = function (receipts) {
	    var receiptCacheByEventId = {};
	    utils.keys(receipts).forEach(function (receiptType) {
	        utils.keys(receipts[receiptType]).forEach(function (userId) {
	            var receipt = receipts[receiptType][userId];
	            if (!receiptCacheByEventId[receipt.eventId]) {
	                receiptCacheByEventId[receipt.eventId] = [];
	            }
	            receiptCacheByEventId[receipt.eventId].push({
	                userId: userId,
	                type: receiptType,
	                data: receipt.data
	            });
	        });
	    });
	    return receiptCacheByEventId;
	};
	
	/**
	 * Add a temporary local-echo receipt to the room to reflect in the
	 * client the fact that we've sent one.
	 * @param {string} userId The user ID if the receipt sender
	 * @param {MatrixEvent} e The event that is to be acknowledged
	 * @param {string} receiptType The type of receipt
	 */
	Room.prototype._addLocalEchoReceipt = function (userId, e, receiptType) {
	    this.addReceipt(synthesizeReceipt(userId, e, receiptType), true);
	};
	
	/**
	 * Update the room-tag event for the room.  The previous one is overwritten.
	 * @param {MatrixEvent} event the m.tag event
	 */
	Room.prototype.addTags = function (event) {
	    // event content looks like:
	    // content: {
	    //    tags: {
	    //       $tagName: { $metadata: $value },
	    //       $tagName: { $metadata: $value },
	    //    }
	    // }
	
	    // XXX: do we need to deep copy here?
	    this.tags = event.getContent().tags;
	
	    // XXX: we could do a deep-comparison to see if the tags have really
	    // changed - but do we want to bother?
	    this.emit("Room.tags", event, this);
	};
	
	/**
	 * Update the account_data events for this room, overwriting events of the same type.
	 * @param {Array<MatrixEvent>} events an array of account_data events to add
	 */
	Room.prototype.addAccountData = function (events) {
	    for (var i = 0; i < events.length; i++) {
	        var event = events[i];
	        if (event.getType() === "m.tag") {
	            this.addTags(event);
	        }
	        this.accountData[event.getType()] = event;
	        this.emit("Room.accountData", event, this);
	    }
	};
	
	/**
	 * Access account_data event of given event type for this room
	 * @param {string} type the type of account_data event to be accessed
	 * @return {?MatrixEvent} the account_data event in question
	 */
	Room.prototype.getAccountData = function (type) {
	    return this.accountData[type];
	};
	
	/**
	 * This is an internal method. Calculates the name of the room from the current
	 * room state.
	 * @param {Room} room The matrix room.
	 * @param {string} userId The client's user ID. Used to filter room members
	 * correctly.
	 * @param {bool} ignoreRoomNameEvent Return the implicit room name that we'd see if there
	 * was no m.room.name event.
	 * @return {string} The calculated room name.
	 */
	function calculateRoomName(room, userId, ignoreRoomNameEvent) {
	    if (!ignoreRoomNameEvent) {
	        // check for an alias, if any. for now, assume first alias is the
	        // official one.
	        var mRoomName = room.currentState.getStateEvents("m.room.name", "");
	        if (mRoomName && mRoomName.getContent() && mRoomName.getContent().name) {
	            return mRoomName.getContent().name;
	        }
	    }
	
	    var alias = room.getCanonicalAlias();
	
	    if (!alias) {
	        var aliases = room.getAliases();
	
	        if (aliases.length) {
	            alias = aliases[0];
	        }
	    }
	    if (alias) {
	        return alias;
	    }
	
	    // get members that are NOT ourselves and are actually in the room.
	    var otherMembers = utils.filter(room.currentState.getMembers(), function (m) {
	        return m.userId !== userId && m.membership !== "leave" && m.membership !== "ban";
	    });
	    var allMembers = utils.filter(room.currentState.getMembers(), function (m) {
	        return m.membership !== "leave";
	    });
	    var myMemberEventArray = utils.filter(room.currentState.getMembers(), function (m) {
	        return m.userId == userId;
	    });
	    var myMemberEvent = myMemberEventArray.length && myMemberEventArray[0].events ? myMemberEventArray[0].events.member.event : undefined;
	
	    // TODO: Localisation
	    if (myMemberEvent && myMemberEvent.content.membership == "invite") {
	        if (room.currentState.getMember(myMemberEvent.sender)) {
	            // extract who invited us to the room
	            return "Invite from " + room.currentState.getMember(myMemberEvent.sender).name;
	        } else if (allMembers[0].events.member) {
	            // use the sender field from the invite event, although this only
	            // gets us the mxid
	            return "Invite from " + myMemberEvent.sender;
	        } else {
	            return "Room Invite";
	        }
	    }
	
	    if (otherMembers.length === 0) {
	        if (allMembers.length === 1) {
	            // self-chat, peeked room with 1 participant,
	            // or inbound invite, or outbound 3PID invite.
	            if (allMembers[0].userId === userId) {
	                var thirdPartyInvites = room.currentState.getStateEvents("m.room.third_party_invite");
	                if (thirdPartyInvites && thirdPartyInvites.length > 0) {
	                    var name = "Inviting " + thirdPartyInvites[0].getContent().display_name;
	                    if (thirdPartyInvites.length > 1) {
	                        if (thirdPartyInvites.length == 2) {
	                            name += " and " + thirdPartyInvites[1].getContent().display_name;
	                        } else {
	                            name += " and " + thirdPartyInvites.length + " others";
	                        }
	                    }
	                    return name;
	                } else {
	                    return "Empty room";
	                }
	            } else {
	                return allMembers[0].name;
	            }
	        } else {
	            // there really isn't anyone in this room...
	            return "Empty room";
	        }
	    } else if (otherMembers.length === 1) {
	        return otherMembers[0].name;
	    } else if (otherMembers.length === 2) {
	        return otherMembers[0].name + " and " + otherMembers[1].name;
	    } else {
	        return otherMembers[0].name + " and " + (otherMembers.length - 1) + " others";
	    }
	}
	
	// FIXME: copypasted from sync.js
	function reEmit(reEmitEntity, emittableEntity, eventNames) {
	    utils.forEach(eventNames, function (eventName) {
	        // setup a listener on the entity (the Room, User, etc) for this event
	        emittableEntity.on(eventName, function () {
	            // take the args from the listener and reuse them, adding the
	            // event name to the arg list so it works with .emit()
	            // Transformation Example:
	            // listener on "foo" => function(a,b) { ... }
	            // Re-emit on "thing" => thing.emit("foo", a, b)
	            var newArgs = [eventName];
	            for (var i = 0; i < arguments.length; i++) {
	                newArgs.push(arguments[i]);
	            }
	            reEmitEntity.emit.apply(reEmitEntity, newArgs);
	        });
	    });
	}
	
	/**
	 * The Room class.
	 */
	module.exports = Room;
	
	/**
	 * Fires when an event we had previously received is redacted.
	 *
	 * (Note this is *not* fired when the redaction happens before we receive the
	 * event).
	 *
	 * @event module:client~MatrixClient#"Room.redaction"
	 * @param {MatrixEvent} event The matrix event which was redacted
	 * @param {Room} room The room containing the redacted event
	 */
	
	/**
	 * Fires whenever the name of a room is updated.
	 * @event module:client~MatrixClient#"Room.name"
	 * @param {Room} room The room whose Room.name was updated.
	 * @example
	 * matrixClient.on("Room.name", function(room){
	 *   var newName = room.name;
	 * });
	 */
	
	/**
	 * Fires whenever a receipt is received for a room
	 * @event module:client~MatrixClient#"Room.receipt"
	 * @param {event} event The receipt event
	 * @param {Room} room The room whose receipts was updated.
	 * @example
	 * matrixClient.on("Room.receipt", function(event, room){
	 *   var receiptContent = event.getContent();
	 * });
	 */
	
	/**
	 * Fires whenever a room's tags are updated.
	 * @event module:client~MatrixClient#"Room.tags"
	 * @param {event} event The tags event
	 * @param {Room} room The room whose Room.tags was updated.
	 * @example
	 * matrixClient.on("Room.tags", function(event, room){
	 *   var newTags = event.getContent().tags;
	 *   if (newTags["favourite"]) showStar(room);
	 * });
	 */
	
	/**
	 * Fires whenever a room's account_data is updated.
	 * @event module:client~MatrixClient#"Room.accountData"
	 * @param {event} event The account_data event
	 * @param {Room} room The room whose account_data was updated.
	 * @example
	 * matrixClient.on("Room.accountData", function(event, room){
	 *   if (event.getType() === "m.room.colorscheme") {
	 *       applyColorScheme(event.getContents());
	 *   }
	 * });
	 */
	
	/**
	 * Fires when the status of a transmitted event is updated.
	 *
	 * <p>When an event is first transmitted, a temporary copy of the event is
	 * inserted into the timeline, with a temporary event id, and a status of
	 * 'SENDING'.
	 *
	 * <p>Once the echo comes back from the server, the content of the event
	 * (MatrixEvent.event) is replaced by the complete event from the homeserver,
	 * thus updating its event id, as well as server-generated fields such as the
	 * timestamp. Its status is set to null.
	 *
	 * <p>Once the /send request completes, if the remote echo has not already
	 * arrived, the event is updated with a new event id and the status is set to
	 * 'SENT'. The server-generated fields are of course not updated yet.
	 *
	 * <p>If the /send fails, In this case, the event's status is set to
	 * 'NOT_SENT'. If it is later resent, the process starts again, setting the
	 * status to 'SENDING'. Alternatively, the message may be cancelled, which
	 * removes the event from the room, and sets the status to 'CANCELLED'.
	 *
	 * <p>This event is raised to reflect each of the transitions above.
	 *
	 * @event module:client~MatrixClient#"Room.localEchoUpdated"
	 *
	 * @param {MatrixEvent} event The matrix event which has been updated
	 *
	 * @param {Room} room The room containing the redacted event
	 *
	 * @param {string} oldEventId The previous event id (the temporary event id,
	 *    except when updating a successfully-sent event when its echo arrives)
	 *
	 * @param {EventStatus} oldStatus The previous event status.
	 */


/***/ }),
/* 492 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	/**
	 * @module pushprocessor
	 */
	
	/**
	 * Construct a Push Processor.
	 * @constructor
	 * @param {Object} client The Matrix client object to use
	 */
	function PushProcessor(client) {
	    var escapeRegExp = function escapeRegExp(string) {
	        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	    };
	
	    var matchingRuleFromKindSet = function matchingRuleFromKindSet(ev, kindset, device) {
	        var rulekinds_in_order = ['override', 'content', 'room', 'sender', 'underride'];
	        for (var ruleKindIndex = 0; ruleKindIndex < rulekinds_in_order.length; ++ruleKindIndex) {
	            var kind = rulekinds_in_order[ruleKindIndex];
	            var ruleset = kindset[kind];
	
	            for (var ruleIndex = 0; ruleIndex < ruleset.length; ++ruleIndex) {
	                var rule = ruleset[ruleIndex];
	                if (!rule.enabled) {
	                    continue;
	                }
	
	                var rawrule = templateRuleToRaw(kind, rule, device);
	                if (!rawrule) {
	                    continue;
	                }
	
	                if (ruleMatchesEvent(rawrule, ev)) {
	                    rule.kind = kind;
	                    return rule;
	                }
	            }
	        }
	        return null;
	    };
	
	    var templateRuleToRaw = function templateRuleToRaw(kind, tprule, device) {
	        var rawrule = {
	            'rule_id': tprule.rule_id,
	            'actions': tprule.actions,
	            'conditions': []
	        };
	        switch (kind) {
	            case 'underride':
	            case 'override':
	                rawrule.conditions = tprule.conditions;
	                break;
	            case 'room':
	                if (!tprule.rule_id) {
	                    return null;
	                }
	                rawrule.conditions.push({
	                    'kind': 'event_match',
	                    'key': 'room_id',
	                    'pattern': tprule.rule_id
	                });
	                break;
	            case 'sender':
	                if (!tprule.rule_id) {
	                    return null;
	                }
	                rawrule.conditions.push({
	                    'kind': 'event_match',
	                    'key': 'user_id',
	                    'pattern': tprule.rule_id
	                });
	                break;
	            case 'content':
	                if (!tprule.pattern) {
	                    return null;
	                }
	                rawrule.conditions.push({
	                    'kind': 'event_match',
	                    'key': 'content.body',
	                    'pattern': tprule.pattern
	                });
	                break;
	        }
	        if (device) {
	            rawrule.conditions.push({
	                'kind': 'device',
	                'profile_tag': device
	            });
	        }
	        return rawrule;
	    };
	
	    var ruleMatchesEvent = function ruleMatchesEvent(rule, ev) {
	        var ret = true;
	        for (var i = 0; i < rule.conditions.length; ++i) {
	            var cond = rule.conditions[i];
	            ret &= eventFulfillsCondition(cond, ev);
	        }
	        //console.log("Rule "+rule.rule_id+(ret ? " matches" : " doesn't match"));
	        return ret;
	    };
	
	    var eventFulfillsCondition = function eventFulfillsCondition(cond, ev) {
	        var condition_functions = {
	            "event_match": eventFulfillsEventMatchCondition,
	            "device": eventFulfillsDeviceCondition,
	            "contains_display_name": eventFulfillsDisplayNameCondition,
	            "room_member_count": eventFulfillsRoomMemberCountCondition
	        };
	        if (condition_functions[cond.kind]) {
	            return condition_functions[cond.kind](cond, ev);
	        }
	        return true;
	    };
	
	    var eventFulfillsRoomMemberCountCondition = function eventFulfillsRoomMemberCountCondition(cond, ev) {
	        if (!cond.is) {
	            return false;
	        }
	
	        var room = client.getRoom(ev.getRoomId());
	        if (!room || !room.currentState || !room.currentState.members) {
	            return false;
	        }
	
	        var memberCount = Object.keys(room.currentState.members).filter(function (m) {
	            return room.currentState.members[m].membership == 'join';
	        }).length;
	
	        var m = cond.is.match(/^([=<>]*)([0-9]*)$/);
	        if (!m) {
	            return false;
	        }
	        var ineq = m[1];
	        var rhs = parseInt(m[2]);
	        if (isNaN(rhs)) {
	            return false;
	        }
	        switch (ineq) {
	            case '':
	            case '==':
	                return memberCount == rhs;
	            case '<':
	                return memberCount < rhs;
	            case '>':
	                return memberCount > rhs;
	            case '<=':
	                return memberCount <= rhs;
	            case '>=':
	                return memberCount >= rhs;
	            default:
	                return false;
	        }
	    };
	
	    var eventFulfillsDisplayNameCondition = function eventFulfillsDisplayNameCondition(cond, ev) {
	        var content = ev.getContent();
	        if (!content || !content.body || typeof content.body != 'string') {
	            return false;
	        }
	
	        var room = client.getRoom(ev.getRoomId());
	        if (!room || !room.currentState || !room.currentState.members || !room.currentState.getMember(client.credentials.userId)) {
	            return false;
	        }
	
	        var displayName = room.currentState.getMember(client.credentials.userId).name;
	
	        // N.B. we can't use \b as it chokes on unicode. however \W seems to be okay
	        // as shorthand for [^0-9A-Za-z_].
	        var pat = new RegExp("(^|\\W)" + escapeRegExp(displayName) + "(\\W|$)", 'i');
	        return content.body.search(pat) > -1;
	    };
	
	    var eventFulfillsDeviceCondition = function eventFulfillsDeviceCondition(cond, ev) {
	        return false; // XXX: Allow a profile tag to be set for the web client instance
	    };
	
	    var eventFulfillsEventMatchCondition = function eventFulfillsEventMatchCondition(cond, ev) {
	        var val = valueForDottedKey(cond.key, ev);
	        if (!val || typeof val != 'string') {
	            return false;
	        }
	
	        var pat = void 0;
	        if (cond.key == 'content.body') {
	            pat = '(^|\\W)' + globToRegexp(cond.pattern) + '(\\W|$)';
	        } else {
	            pat = '^' + globToRegexp(cond.pattern) + '$';
	        }
	        var regex = new RegExp(pat, 'i');
	        return !!val.match(regex);
	    };
	
	    var globToRegexp = function globToRegexp(glob) {
	        // From
	        // https://github.com/matrix-org/synapse/blob/abbee6b29be80a77e05730707602f3bbfc3f38cb/synapse/push/__init__.py#L132
	        // Because micromatch is about 130KB with dependencies,
	        // and minimatch is not much better.
	        var pat = escapeRegExp(glob);
	        pat = pat.replace(/\\\*/, '.*');
	        pat = pat.replace(/\?/, '.');
	        pat = pat.replace(/\\\[(!|)(.*)\\]/, function (match, p1, p2, offset, string) {
	            var first = p1 && '^' || '';
	            var second = p2.replace(/\\\-/, '-');
	            return '[' + first + second + ']';
	        });
	        return pat;
	    };
	
	    var valueForDottedKey = function valueForDottedKey(key, ev) {
	        var parts = key.split('.');
	        var val = void 0;
	
	        // special-case the first component to deal with encrypted messages
	        var firstPart = parts[0];
	        if (firstPart == 'content') {
	            val = ev.getContent();
	            parts.shift();
	        } else if (firstPart == 'type') {
	            val = ev.getType();
	            parts.shift();
	        } else {
	            // use the raw event for any other fields
	            val = ev.event;
	        }
	
	        while (parts.length > 0) {
	            var thispart = parts.shift();
	            if (!val[thispart]) {
	                return null;
	            }
	            val = val[thispart];
	        }
	        return val;
	    };
	
	    var matchingRuleForEventWithRulesets = function matchingRuleForEventWithRulesets(ev, rulesets) {
	        if (!rulesets || !rulesets.device) {
	            return null;
	        }
	        if (ev.getSender() == client.credentials.userId) {
	            return null;
	        }
	
	        var allDevNames = Object.keys(rulesets.device);
	        for (var i = 0; i < allDevNames.length; ++i) {
	            var devname = allDevNames[i];
	            var devrules = rulesets.device[devname];
	
	            var matchingRule = matchingRuleFromKindSet(devrules, devname);
	            if (matchingRule) {
	                return matchingRule;
	            }
	        }
	        return matchingRuleFromKindSet(ev, rulesets.global);
	    };
	
	    var pushActionsForEventAndRulesets = function pushActionsForEventAndRulesets(ev, rulesets) {
	        var rule = matchingRuleForEventWithRulesets(ev, rulesets);
	        if (!rule) {
	            return {};
	        }
	
	        var actionObj = PushProcessor.actionListToActionsObject(rule.actions);
	
	        // Some actions are implicit in some situations: we add those here
	        if (actionObj.tweaks.highlight === undefined) {
	            // if it isn't specified, highlight if it's a content
	            // rule but otherwise not
	            actionObj.tweaks.highlight = rule.kind == 'content';
	        }
	
	        return actionObj;
	    };
	
	    /**
	     * Get the user's push actions for the given event
	     *
	     * @param {module:models/event.MatrixEvent} ev
	     *
	     * @return {PushAction}
	     */
	    this.actionsForEvent = function (ev) {
	        return pushActionsForEventAndRulesets(ev, client.pushRules);
	    };
	}
	
	/**
	 * Convert a list of actions into a object with the actions as keys and their values
	 * eg. [ 'notify', { set_tweak: 'sound', value: 'default' } ]
	 *     becomes { notify: true, tweaks: { sound: 'default' } }
	 * @param {array} actionlist The actions list
	 *
	 * @return {object} A object with key 'notify' (true or false) and an object of actions
	 */
	PushProcessor.actionListToActionsObject = function (actionlist) {
	    var actionobj = { 'notify': false, 'tweaks': {} };
	    for (var i = 0; i < actionlist.length; ++i) {
	        var action = actionlist[i];
	        if (action === 'notify') {
	            actionobj.notify = true;
	        } else if ((typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object') {
	            if (action.value === undefined) {
	                action.value = true;
	            }
	            actionobj.tweaks[action.set_tweak] = action.value;
	        }
	    }
	    return actionobj;
	};
	
	/**
	 * @typedef {Object} PushAction
	 * @type {Object}
	 * @property {boolean} notify Whether this event should notify the user or not.
	 * @property {Object} tweaks How this event should be notified.
	 * @property {boolean} tweaks.highlight Whether this event should be highlighted
	 * on the UI.
	 * @property {boolean} tweaks.sound Whether this notification should produce a
	 * noise.
	 */
	
	/** The PushProcessor class. */
	module.exports = PushProcessor;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         Copyright 2017 Vector Creations Ltd
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         */
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _memory = __webpack_require__(494);
	
	var _utils = __webpack_require__(16);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _indexeddbLocalBackend = __webpack_require__(325);
	
	var _indexeddbLocalBackend2 = _interopRequireDefault(_indexeddbLocalBackend);
	
	var _indexeddbRemoteBackend = __webpack_require__(1149);
	
	var _indexeddbRemoteBackend2 = _interopRequireDefault(_indexeddbRemoteBackend);
	
	var _user = __webpack_require__(217);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _event = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is an internal module. See {@link IndexedDBStore} for the public class.
	 * @module store/indexeddb
	 */
	
	// If this value is too small we'll be writing very often which will cause
	// noticable stop-the-world pauses. If this value is too big we'll be writing
	// so infrequently that the /sync size gets bigger on reload. Writing more
	// often does not affect the length of the pause since the entire /sync
	// response is persisted each time.
	var WRITE_DELAY_MS = 1000 * 60 * 5; // once every 5 minutes
	
	
	/**
	 * Construct a new Indexed Database store, which extends MatrixInMemoryStore.
	 *
	 * This store functions like a MatrixInMemoryStore except it periodically persists
	 * the contents of the store to an IndexedDB backend.
	 *
	 * All data is still kept in-memory but can be loaded from disk by calling
	 * <code>startup()</code>. This can make startup times quicker as a complete
	 * sync from the server is not required. This does not reduce memory usage as all
	 * the data is eagerly fetched when <code>startup()</code> is called.
	 * <pre>
	 * let opts = { localStorage: window.localStorage };
	 * let store = new IndexedDBStore();
	 * await store.startup(); // load from indexed db
	 * let client = sdk.createClient({
	 *     store: store,
	 * });
	 * client.startClient();
	 * client.on("sync", function(state, prevState, data) {
	 *     if (state === "PREPARED") {
	 *         console.log("Started up, now with go faster stripes!");
	 *     }
	 * });
	 * </pre>
	 *
	 * @constructor
	 * @extends MatrixInMemoryStore
	 * @param {Object} opts Options object.
	 * @param {Object} opts.indexedDB The Indexed DB interface e.g.
	 * <code>window.indexedDB</code>
	 * @param {string=} opts.dbName Optional database name. The same name must be used
	 * to open the same database.
	 * @param {string=} opts.workerScript Optional URL to a script to invoke a web
	 * worker with to run IndexedDB queries on the web worker. The IndexedDbStoreWorker
	 * class is provided for this purpose and requires the application to provide a
	 * trivial wrapper script around it.
	 * @param {Object=} opts.workerApi The webWorker API object. If omitted, the global Worker
	 * object will be used if it exists.
	 * @prop {IndexedDBStoreBackend} backend The backend instance. Call through to
	 * this API if you need to perform specific indexeddb actions like deleting the
	 * database.
	 */
	var IndexedDBStore = function IndexedDBStore(opts) {
	    _memory.MatrixInMemoryStore.call(this, opts);
	
	    if (!opts.indexedDB) {
	        throw new Error('Missing required option: indexedDB');
	    }
	
	    if (opts.workerScript) {
	        // try & find a webworker-compatible API
	        var workerApi = opts.workerApi;
	        if (!workerApi) {
	            // default to the global Worker object (which is where it in a browser)
	            workerApi = global.Worker;
	        }
	        this.backend = new _indexeddbRemoteBackend2.default(opts.workerScript, opts.dbName, workerApi);
	    } else {
	        this.backend = new _indexeddbLocalBackend2.default(opts.indexedDB, opts.dbName);
	    }
	
	    this.startedUp = false;
	    this._syncTs = 0;
	
	    // Records the last-modified-time of each user at the last point we saved
	    // the database, such that we can derive the set if users that have been
	    // modified since we last saved.
	    this._userModifiedMap = {
	        // user_id : timestamp
	    };
	};
	_utils2.default.inherits(IndexedDBStore, _memory.MatrixInMemoryStore);
	
	/**
	 * @return {Promise} Resolved when loaded from indexed db.
	  */
	IndexedDBStore.prototype.startup = function () {
	    var _this = this;
	
	    if (this.startedUp) {
	        return (0, _q2.default)();
	    }
	
	    return this.backend.connect().then(function () {
	        return _this.backend.getUserPresenceEvents();
	    }).then(function (userPresenceEvents) {
	        userPresenceEvents.forEach(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                userId = _ref2[0],
	                rawEvent = _ref2[1];
	
	            var u = new _user2.default(userId);
	            if (rawEvent) {
	                u.setPresenceEvent(new _event.MatrixEvent(rawEvent));
	            }
	            _this._userModifiedMap[u.userId] = u.getLastModifiedTime();
	            _this.storeUser(u);
	        });
	    });
	};
	
	/**
	 * @return {Promise} Resolves with a sync response to restore the
	 * client state to where it was at the last save, or null if there
	 * is no saved sync data.
	 */
	IndexedDBStore.prototype.getSavedSync = function () {
	    return this.backend.getSavedSync();
	};
	
	/**
	 * Delete all data from this store.
	 * @return {Promise} Resolves if the data was deleted from the database.
	 */
	IndexedDBStore.prototype.deleteAllData = function () {
	    _memory.MatrixInMemoryStore.prototype.deleteAllData.call(this);
	    return this.backend.clearDatabase().then(function () {
	        console.log("Deleted indexeddb data.");
	    }, function (err) {
	        console.error("Failed to delete indexeddb data: ", err);
	        throw err;
	    });
	};
	
	/**
	 * Possibly write data to the database.
	 * @return {Promise} Promise resolves after the write completes.
	 */
	IndexedDBStore.prototype.save = function () {
	    var now = Date.now();
	    if (now - this._syncTs > WRITE_DELAY_MS) {
	        return this._reallySave();
	    }
	    return (0, _q2.default)();
	};
	
	IndexedDBStore.prototype._reallySave = function () {
	    this._syncTs = Date.now(); // set now to guard against multi-writes
	
	    // work out changed users (this doesn't handle deletions but you
	    // can't 'delete' users as they are just presence events).
	    var userTuples = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = this.getUsers()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var u = _step.value;
	
	            if (this._userModifiedMap[u.userId] === u.getLastModifiedTime()) continue;
	            if (!u.events.presence) continue;
	
	            userTuples.push([u.userId, u.events.presence.event]);
	
	            // note that we've saved this version of the user
	            this._userModifiedMap[u.userId] = u.getLastModifiedTime();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return this.backend.syncToDatabase(userTuples).catch(function (err) {
	        console.error("sync fail:", err);
	    });
	};
	
	IndexedDBStore.prototype.setSyncData = function (syncData) {
	    return this.backend.setSyncData(syncData);
	};
	
	module.exports.IndexedDBStore = IndexedDBStore;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module. See {@link MatrixInMemoryStore} for the public class.
	 * @module store/memory
	 */
	
	var utils = __webpack_require__(16);
	var User = __webpack_require__(217);
	var q = __webpack_require__(6);
	
	/**
	 * Construct a new in-memory data store for the Matrix Client.
	 * @constructor
	 * @param {Object=} opts Config options
	 * @param {LocalStorage} opts.localStorage The local storage instance to persist
	 * some forms of data such as tokens. Rooms will NOT be stored.
	 */
	module.exports.MatrixInMemoryStore = function MatrixInMemoryStore(opts) {
	    opts = opts || {};
	    this.rooms = {
	        // roomId: Room
	    };
	    this.users = {
	        // userId: User
	    };
	    this.syncToken = null;
	    this.filters = {
	        // userId: {
	        //    filterId: Filter
	        // }
	    };
	    this.accountData = {
	        // type : content
	    };
	    this.localStorage = opts.localStorage;
	};
	
	module.exports.MatrixInMemoryStore.prototype = {
	
	    /**
	     * Retrieve the token to stream from.
	     * @return {string} The token or null.
	     */
	    getSyncToken: function getSyncToken() {
	        return this.syncToken;
	    },
	
	    /**
	     * Set the token to stream from.
	     * @param {string} token The token to stream from.
	     */
	    setSyncToken: function setSyncToken(token) {
	        this.syncToken = token;
	    },
	
	    /**
	     * Store the given room.
	     * @param {Room} room The room to be stored. All properties must be stored.
	     */
	    storeRoom: function storeRoom(room) {
	        this.rooms[room.roomId] = room;
	        // add listeners for room member changes so we can keep the room member
	        // map up-to-date.
	        room.currentState.on("RoomState.members", this._onRoomMember.bind(this));
	        // add existing members
	        var self = this;
	        room.currentState.getMembers().forEach(function (m) {
	            self._onRoomMember(null, room.currentState, m);
	        });
	    },
	
	    /**
	     * Called when a room member in a room being tracked by this store has been
	     * updated.
	     * @param {MatrixEvent} event
	     * @param {RoomState} state
	     * @param {RoomMember} member
	     */
	    _onRoomMember: function _onRoomMember(event, state, member) {
	        if (member.membership === "invite") {
	            // We do NOT add invited members because people love to typo user IDs
	            // which would then show up in these lists (!)
	            return;
	        }
	
	        var user = this.users[member.userId] || new User(member.userId);
	        if (member.name) {
	            user.setDisplayName(member.name);
	            if (member.events.member) {
	                user.setRawDisplayName(member.events.member.getDirectionalContent().displayname);
	            }
	        }
	        if (member.events.member && member.events.member.getContent().avatar_url) {
	            user.setAvatarUrl(member.events.member.getContent().avatar_url);
	        }
	        this.users[user.userId] = user;
	    },
	
	    /**
	     * Retrieve a room by its' room ID.
	     * @param {string} roomId The room ID.
	     * @return {Room} The room or null.
	     */
	    getRoom: function getRoom(roomId) {
	        return this.rooms[roomId] || null;
	    },
	
	    /**
	     * Retrieve all known rooms.
	     * @return {Room[]} A list of rooms, which may be empty.
	     */
	    getRooms: function getRooms() {
	        return utils.values(this.rooms);
	    },
	
	    /**
	     * Permanently delete a room.
	     * @param {string} roomId
	     */
	    removeRoom: function removeRoom(roomId) {
	        if (this.rooms[roomId]) {
	            this.rooms[roomId].removeListener("RoomState.members", this._onRoomMember);
	        }
	        delete this.rooms[roomId];
	    },
	
	    /**
	     * Retrieve a summary of all the rooms.
	     * @return {RoomSummary[]} A summary of each room.
	     */
	    getRoomSummaries: function getRoomSummaries() {
	        return utils.map(utils.values(this.rooms), function (room) {
	            return room.summary;
	        });
	    },
	
	    /**
	     * Store a User.
	     * @param {User} user The user to store.
	     */
	    storeUser: function storeUser(user) {
	        this.users[user.userId] = user;
	    },
	
	    /**
	     * Retrieve a User by its' user ID.
	     * @param {string} userId The user ID.
	     * @return {User} The user or null.
	     */
	    getUser: function getUser(userId) {
	        return this.users[userId] || null;
	    },
	
	    /**
	     * Retrieve all known users.
	     * @return {User[]} A list of users, which may be empty.
	     */
	    getUsers: function getUsers() {
	        return utils.values(this.users);
	    },
	
	    /**
	     * Retrieve scrollback for this room.
	     * @param {Room} room The matrix room
	     * @param {integer} limit The max number of old events to retrieve.
	     * @return {Array<Object>} An array of objects which will be at most 'limit'
	     * length and at least 0. The objects are the raw event JSON.
	     */
	    scrollback: function scrollback(room, limit) {
	        return [];
	    },
	
	    /**
	     * Store events for a room. The events have already been added to the timeline
	     * @param {Room} room The room to store events for.
	     * @param {Array<MatrixEvent>} events The events to store.
	     * @param {string} token The token associated with these events.
	     * @param {boolean} toStart True if these are paginated results.
	     */
	    storeEvents: function storeEvents(room, events, token, toStart) {
	        // no-op because they've already been added to the room instance.
	    },
	
	    /**
	     * Store a filter.
	     * @param {Filter} filter
	     */
	    storeFilter: function storeFilter(filter) {
	        if (!filter) {
	            return;
	        }
	        if (!this.filters[filter.userId]) {
	            this.filters[filter.userId] = {};
	        }
	        this.filters[filter.userId][filter.filterId] = filter;
	    },
	
	    /**
	     * Retrieve a filter.
	     * @param {string} userId
	     * @param {string} filterId
	     * @return {?Filter} A filter or null.
	     */
	    getFilter: function getFilter(userId, filterId) {
	        if (!this.filters[userId] || !this.filters[userId][filterId]) {
	            return null;
	        }
	        return this.filters[userId][filterId];
	    },
	
	    /**
	     * Retrieve a filter ID with the given name.
	     * @param {string} filterName The filter name.
	     * @return {?string} The filter ID or null.
	     */
	    getFilterIdByName: function getFilterIdByName(filterName) {
	        if (!this.localStorage) {
	            return null;
	        }
	        try {
	            return this.localStorage.getItem("mxjssdk_memory_filter_" + filterName);
	        } catch (e) {}
	        return null;
	    },
	
	    /**
	     * Set a filter name to ID mapping.
	     * @param {string} filterName
	     * @param {string} filterId
	     */
	    setFilterIdByName: function setFilterIdByName(filterName, filterId) {
	        if (!this.localStorage) {
	            return;
	        }
	        try {
	            this.localStorage.setItem("mxjssdk_memory_filter_" + filterName, filterId);
	        } catch (e) {}
	    },
	
	    /**
	     * Store user-scoped account data events.
	     * N.B. that account data only allows a single event per type, so multiple
	     * events with the same type will replace each other.
	     * @param {Array<MatrixEvent>} events The events to store.
	     */
	    storeAccountDataEvents: function storeAccountDataEvents(events) {
	        var self = this;
	        events.forEach(function (event) {
	            self.accountData[event.getType()] = event;
	        });
	    },
	
	    /**
	     * Get account data event by event type
	     * @param {string} eventType The event type being queried
	     * @return {?MatrixEvent} the user account_data event of given type, if any
	     */
	    getAccountData: function getAccountData(eventType) {
	        return this.accountData[eventType];
	    },
	
	    /**
	     * setSyncData does nothing as there is no backing data store.
	     *
	     * @param {Object} syncData The sync data
	     * @return {Promise} An immediately resolved promise.
	     */
	    setSyncData: function setSyncData(syncData) {
	        return q();
	    },
	
	    /**
	     * Save does nothing as there is no backing data store.
	     */
	    save: function save() {},
	
	    /**
	     * Startup does nothing as this store doesn't require starting up.
	     * @return {Promise} An immediately resolved promise.
	     */
	    startup: function startup() {
	        return q();
	    },
	
	    /**
	     * @return {Promise} Resolves with a sync response to restore the
	     * client state to where it was at the last save, or null if there
	     * is no saved sync data.
	     */
	    getSavedSync: function getSavedSync() {
	        return q(null);
	    },
	
	    /**
	     * Delete all data from this store.
	     * @return {Promise} An immediately resolved promise.
	     */
	    deleteAllData: function deleteAllData() {
	        this.rooms = {
	            // roomId: Room
	        };
	        this.users = {
	            // userId: User
	        };
	        this.syncToken = null;
	        this.filters = {
	            // userId: {
	            //    filterId: Filter
	            // }
	        };
	        this.accountData = {
	            // type : content
	        };
	        return q();
	    }
	};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module. See {@link createNewMatrixCall} for the public API.
	 * @module webrtc/call
	 */
	
	var utils = __webpack_require__(16);
	var EventEmitter = __webpack_require__(56).EventEmitter;
	var DEBUG = true; // set true to enable console logging.
	
	// events: hangup, error(err), replaced(call), state(state, oldState)
	
	/**
	 * Fires when the MatrixCall encounters an error when sending a Matrix event.
	 * <p>
	 * This is required to allow errors, which occur during sending of events, to bubble up.
	 * (This is because call.js does a hangup when it encounters a normal `error`, which in
	 * turn could lead to an UnknownDeviceError.)
	 * <p>
	 * To deal with an UnknownDeviceError when trying to send events, the application should let
	 * users know that there are new devices in the encrypted room (into which the event was
	 * sent) and give the user the options to resend unsent events or cancel them. Resending
	 * is done using {@link module:client~MatrixClient#resendEvent} and cancelling can be done by using
	 * {@link module:client~MatrixClient#cancelPendingEvent}.
	 * <p>
	 * MatrixCall will not do anything in response to an error that causes `send_event_error`
	 * to be emitted with the exception of sending `m.call.candidates`, which is retried upon
	 * failure when ICE candidates are being sent. This happens during call setup.
	 *
	 * @event module:webrtc/call~MatrixCall#"send_event_error"
	 * @param {Error} err The error caught from calling client.sendEvent in call.js.
	 * @example
	 * matrixCall.on("send_event_error", function(err){
	 *   console.error(err);
	 * });
	 */
	
	/**
	 * Fires whenever an error occurs when call.js encounters an issue with setting up the call.
	 * <p>
	 * The error given will have a code equal to either `MatrixCall.ERR_LOCAL_OFFER_FAILED` or
	 * `MatrixCall.ERR_NO_USER_MEDIA`. `ERR_LOCAL_OFFER_FAILED` is emitted when the local client
	 * fails to create an offer. `ERR_NO_USER_MEDIA` is emitted when the user has denied access
	 * to their audio/video hardware.
	 *
	 * @event module:webrtc/call~MatrixCall#"error"
	 * @param {Error} err The error raised by MatrixCall.
	 * @example
	 * matrixCall.on("error", function(err){
	 *   console.error(err.code, err);
	 * });
	 */
	
	/**
	 * Construct a new Matrix Call.
	 * @constructor
	 * @param {Object} opts Config options.
	 * @param {string} opts.roomId The room ID for this call.
	 * @param {Object} opts.webRtc The WebRTC globals from the browser.
	 * @param {Object} opts.URL The URL global.
	 * @param {Array<Object>} opts.turnServers Optional. A list of TURN servers.
	 * @param {MatrixClient} opts.client The Matrix Client instance to send events to.
	 */
	function MatrixCall(opts) {
	    this.roomId = opts.roomId;
	    this.client = opts.client;
	    this.webRtc = opts.webRtc;
	    this.URL = opts.URL;
	    // Array of Objects with urls, username, credential keys
	    this.turnServers = opts.turnServers || [];
	    if (this.turnServers.length === 0) {
	        this.turnServers.push({
	            urls: [MatrixCall.FALLBACK_STUN_SERVER]
	        });
	    }
	    utils.forEach(this.turnServers, function (server) {
	        utils.checkObjectHasKeys(server, ["urls"]);
	    });
	
	    this.callId = "c" + new Date().getTime();
	    this.state = 'fledgling';
	    this.didConnect = false;
	
	    // A queue for candidates waiting to go out.
	    // We try to amalgamate candidates into a single candidate message where
	    // possible
	    this.candidateSendQueue = [];
	    this.candidateSendTries = 0;
	
	    // Lookup from opaque queue ID to a promise for media element operations that
	    // need to be serialised into a given queue.  Store this per-MatrixCall on the
	    // assumption that multiple matrix calls will never compete for control of the
	    // same DOM elements.
	    this.mediaPromises = Object.create(null);
	
	    this.screenSharingStream = null;
	}
	/** The length of time a call can be ringing for. */
	MatrixCall.CALL_TIMEOUT_MS = 60000;
	/** The fallback server to use for STUN. */
	MatrixCall.FALLBACK_STUN_SERVER = 'stun:stun.l.google.com:19302';
	/** An error code when the local client failed to create an offer. */
	MatrixCall.ERR_LOCAL_OFFER_FAILED = "local_offer_failed";
	/**
	 * An error code when there is no local mic/camera to use. This may be because
	 * the hardware isn't plugged in, or the user has explicitly denied access.
	 */
	MatrixCall.ERR_NO_USER_MEDIA = "no_user_media";
	
	utils.inherits(MatrixCall, EventEmitter);
	
	/**
	 * Place a voice call to this room.
	 * @throws If you have not specified a listener for 'error' events.
	 */
	MatrixCall.prototype.placeVoiceCall = function () {
	    debuglog("placeVoiceCall");
	    checkForErrorListener(this);
	    _placeCallWithConstraints(this, _getUserMediaVideoContraints('voice'));
	    this.type = 'voice';
	};
	
	/**
	 * Place a video call to this room.
	 * @param {Element} remoteVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render video to.
	 * @param {Element} localVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render the local camera preview.
	 * @throws If you have not specified a listener for 'error' events.
	 */
	MatrixCall.prototype.placeVideoCall = function (remoteVideoElement, localVideoElement) {
	    debuglog("placeVideoCall");
	    checkForErrorListener(this);
	    this.localVideoElement = localVideoElement;
	    this.remoteVideoElement = remoteVideoElement;
	    _placeCallWithConstraints(this, _getUserMediaVideoContraints('video'));
	    this.type = 'video';
	    _tryPlayRemoteStream(this);
	};
	
	/**
	 * Place a screen-sharing call to this room. This includes audio.
	 * <b>This method is EXPERIMENTAL and subject to change without warning. It
	 * only works in Google Chrome.</b>
	 * @param {Element} remoteVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render video to.
	 * @param {Element} localVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render the local camera preview.
	 * @throws If you have not specified a listener for 'error' events.
	 */
	MatrixCall.prototype.placeScreenSharingCall = function (remoteVideoElement, localVideoElement) {
	    debuglog("placeScreenSharingCall");
	    checkForErrorListener(this);
	    var screenConstraints = _getChromeScreenSharingConstraints(this);
	    if (!screenConstraints) {
	        return;
	    }
	    this.localVideoElement = localVideoElement;
	    this.remoteVideoElement = remoteVideoElement;
	    var self = this;
	    this.webRtc.getUserMedia(screenConstraints, function (stream) {
	        self.screenSharingStream = stream;
	        debuglog("Got screen stream, requesting audio stream...");
	        var audioConstraints = _getUserMediaVideoContraints('voice');
	        _placeCallWithConstraints(self, audioConstraints);
	    }, function (err) {
	        self.emit("error", callError(MatrixCall.ERR_NO_USER_MEDIA, "Failed to get screen-sharing stream: " + err));
	    });
	    this.type = 'video';
	    _tryPlayRemoteStream(this);
	};
	
	/**
	 * Play the given HTMLMediaElement, serialising the operation into a chain
	 * of promises to avoid racing access to the element
	 * @param {Element} element HTMLMediaElement element to play
	 * @param {string} queueId Arbitrary ID to track the chain of promises to be used
	 */
	MatrixCall.prototype.playElement = function (element, queueId) {
	    console.log("queuing play on " + queueId + " and element " + element);
	    // XXX: FIXME: Does this leak elements, given the old promises
	    // may hang around and retain a reference to them?
	    if (this.mediaPromises[queueId]) {
	        // XXX: these promises can fail (e.g. by <video/> being unmounted whilst
	        // pending receiving media to play - e.g. whilst switching between
	        // rooms before answering an inbound call), and throw unhandled exceptions.
	        // However, we should soldier on as best we can even if they fail, given
	        // these failures may be non-fatal (as in the case of unmounts)
	        this.mediaPromises[queueId] = this.mediaPromises[queueId].then(function () {
	            console.log("previous promise completed for " + queueId);
	            return element.play();
	        }, function () {
	            console.log("previous promise failed for " + queueId);
	            return element.play();
	        });
	    } else {
	        this.mediaPromises[queueId] = element.play();
	    }
	};
	
	/**
	 * Pause the given HTMLMediaElement, serialising the operation into a chain
	 * of promises to avoid racing access to the element
	 * @param {Element} element HTMLMediaElement element to pause
	 * @param {string} queueId Arbitrary ID to track the chain of promises to be used
	 */
	MatrixCall.prototype.pauseElement = function (element, queueId) {
	    console.log("queuing pause on " + queueId + " and element " + element);
	    if (this.mediaPromises[queueId]) {
	        this.mediaPromises[queueId] = this.mediaPromises[queueId].then(function () {
	            console.log("previous promise completed for " + queueId);
	            return element.pause();
	        }, function () {
	            console.log("previous promise failed for " + queueId);
	            return element.pause();
	        });
	    } else {
	        // pause doesn't actually return a promise, but do this for symmetry
	        // and just in case it does in future.
	        this.mediaPromises[queueId] = element.pause();
	    }
	};
	
	/**
	 * Assign the given HTMLMediaElement by setting the .src attribute on it,
	 * serialising the operation into a chain of promises to avoid racing access
	 * to the element
	 * @param {Element} element HTMLMediaElement element to pause
	 * @param {MediaStream} srcObject the srcObject attribute value to assign to the element
	 * @param {string} queueId Arbitrary ID to track the chain of promises to be used
	 */
	MatrixCall.prototype.assignElement = function (element, srcObject, queueId) {
	    console.log("queuing assign on " + queueId + " element " + element + " for " + srcObject);
	    if (this.mediaPromises[queueId]) {
	        this.mediaPromises[queueId] = this.mediaPromises[queueId].then(function () {
	            console.log("previous promise completed for " + queueId);
	            element.srcObject = srcObject;
	        }, function () {
	            console.log("previous promise failed for " + queueId);
	            element.srcObject = srcObject;
	        });
	    } else {
	        element.srcObject = srcObject;
	    }
	};
	
	/**
	 * Retrieve the local <code>&lt;video&gt;</code> DOM element.
	 * @return {Element} The dom element
	 */
	MatrixCall.prototype.getLocalVideoElement = function () {
	    return this.localVideoElement;
	};
	
	/**
	 * Retrieve the remote <code>&lt;video&gt;</code> DOM element
	 * used for playing back video capable streams.
	 * @return {Element} The dom element
	 */
	MatrixCall.prototype.getRemoteVideoElement = function () {
	    return this.remoteVideoElement;
	};
	
	/**
	 * Retrieve the remote <code>&lt;audio&gt;</code> DOM element
	 * used for playing back audio only streams.
	 * @return {Element} The dom element
	 */
	MatrixCall.prototype.getRemoteAudioElement = function () {
	    return this.remoteAudioElement;
	};
	
	/**
	 * Set the local <code>&lt;video&gt;</code> DOM element. If this call is active,
	 * video will be rendered to it immediately.
	 * @param {Element} element The <code>&lt;video&gt;</code> DOM element.
	 */
	MatrixCall.prototype.setLocalVideoElement = function (element) {
	    var _this = this;
	
	    this.localVideoElement = element;
	
	    if (element && this.localAVStream && this.type === 'video') {
	        (function () {
	            element.autoplay = true;
	            _this.assignElement(element, _this.localAVStream, "localVideo");
	            element.muted = true;
	            var self = _this;
	            setTimeout(function () {
	                var vel = self.getLocalVideoElement();
	                if (vel.play) {
	                    self.playElement(vel, "localVideo");
	                }
	            }, 0);
	        })();
	    }
	};
	
	/**
	 * Set the remote <code>&lt;video&gt;</code> DOM element. If this call is active,
	 * the first received video-capable stream will be rendered to it immediately.
	 * @param {Element} element The <code>&lt;video&gt;</code> DOM element.
	 */
	MatrixCall.prototype.setRemoteVideoElement = function (element) {
	    this.remoteVideoElement = element;
	    _tryPlayRemoteStream(this);
	};
	
	/**
	 * Set the remote <code>&lt;audio&gt;</code> DOM element. If this call is active,
	 * the first received audio-only stream will be rendered to it immediately.
	 * The audio will *not* be rendered from the remoteVideoElement.
	 * @param {Element} element The <code>&lt;video&gt;</code> DOM element.
	 */
	MatrixCall.prototype.setRemoteAudioElement = function (element) {
	    this.remoteVideoElement.muted = true;
	    this.remoteAudioElement = element;
	    _tryPlayRemoteAudioStream(this);
	};
	
	/**
	 * Configure this call from an invite event. Used by MatrixClient.
	 * @protected
	 * @param {MatrixEvent} event The m.call.invite event
	 */
	MatrixCall.prototype._initWithInvite = function (event) {
	    this.msg = event.getContent();
	    this.peerConn = _createPeerConnection(this);
	    var self = this;
	    if (this.peerConn) {
	        this.peerConn.setRemoteDescription(new this.webRtc.RtcSessionDescription(this.msg.offer), hookCallback(self, self._onSetRemoteDescriptionSuccess), hookCallback(self, self._onSetRemoteDescriptionError));
	    }
	    setState(this, 'ringing');
	    this.direction = 'inbound';
	
	    // firefox and OpenWebRTC's RTCPeerConnection doesn't add streams until it
	    // starts getting media on them so we need to figure out whether a video
	    // channel has been offered by ourselves.
	    if (this.msg.offer && this.msg.offer.sdp && this.msg.offer.sdp.indexOf('m=video') > -1) {
	        this.type = 'video';
	    } else {
	        this.type = 'voice';
	    }
	
	    if (event.getAge()) {
	        setTimeout(function () {
	            if (self.state == 'ringing') {
	                debuglog("Call invite has expired. Hanging up.");
	                self.hangupParty = 'remote'; // effectively
	                setState(self, 'ended');
	                stopAllMedia(self);
	                if (self.peerConn.signalingState != 'closed') {
	                    self.peerConn.close();
	                }
	                self.emit("hangup", self);
	            }
	        }, this.msg.lifetime - event.getAge());
	    }
	};
	
	/**
	 * Configure this call from a hangup event. Used by MatrixClient.
	 * @protected
	 * @param {MatrixEvent} event The m.call.hangup event
	 */
	MatrixCall.prototype._initWithHangup = function (event) {
	    // perverse as it may seem, sometimes we want to instantiate a call with a
	    // hangup message (because when getting the state of the room on load, events
	    // come in reverse order and we want to remember that a call has been hung up)
	    this.msg = event.getContent();
	    setState(this, 'ended');
	};
	
	/**
	 * Answer a call.
	 */
	MatrixCall.prototype.answer = function () {
	    debuglog("Answering call %s of type %s", this.callId, this.type);
	    var self = this;
	
	    if (!this.localAVStream && !this.waitForLocalAVStream) {
	        this.webRtc.getUserMedia(_getUserMediaVideoContraints(this.type), hookCallback(self, self._gotUserMediaForAnswer), hookCallback(self, self._getUserMediaFailed));
	        setState(this, 'wait_local_media');
	    } else if (this.localAVStream) {
	        this._gotUserMediaForAnswer(this.localAVStream);
	    } else if (this.waitForLocalAVStream) {
	        setState(this, 'wait_local_media');
	    }
	};
	
	/**
	 * Replace this call with a new call, e.g. for glare resolution. Used by
	 * MatrixClient.
	 * @protected
	 * @param {MatrixCall} newCall The new call.
	 */
	MatrixCall.prototype._replacedBy = function (newCall) {
	    debuglog(this.callId + " being replaced by " + newCall.callId);
	    if (this.state == 'wait_local_media') {
	        debuglog("Telling new call to wait for local media");
	        newCall.waitForLocalAVStream = true;
	    } else if (this.state == 'create_offer') {
	        debuglog("Handing local stream to new call");
	        newCall._gotUserMediaForAnswer(this.localAVStream);
	        delete this.localAVStream;
	    } else if (this.state == 'invite_sent') {
	        debuglog("Handing local stream to new call");
	        newCall._gotUserMediaForAnswer(this.localAVStream);
	        delete this.localAVStream;
	    }
	    newCall.localVideoElement = this.localVideoElement;
	    newCall.remoteVideoElement = this.remoteVideoElement;
	    newCall.remoteAudioElement = this.remoteAudioElement;
	    this.successor = newCall;
	    this.emit("replaced", newCall);
	    this.hangup(true);
	};
	
	/**
	 * Hangup a call.
	 * @param {string} reason The reason why the call is being hung up.
	 * @param {boolean} suppressEvent True to suppress emitting an event.
	 */
	MatrixCall.prototype.hangup = function (reason, suppressEvent) {
	    debuglog("Ending call " + this.callId);
	    terminate(this, "local", reason, !suppressEvent);
	    var content = {
	        version: 0,
	        call_id: this.callId,
	        reason: reason
	    };
	    sendEvent(this, 'm.call.hangup', content);
	};
	
	/**
	 * Set whether the local video preview should be muted or not.
	 * @param {boolean} muted True to mute the local video.
	 */
	MatrixCall.prototype.setLocalVideoMuted = function (muted) {
	    if (!this.localAVStream) {
	        return;
	    }
	    setTracksEnabled(this.localAVStream.getVideoTracks(), !muted);
	};
	
	/**
	 * Check if local video is muted.
	 *
	 * If there are multiple video tracks, <i>all</i> of the tracks need to be muted
	 * for this to return true. This means if there are no video tracks, this will
	 * return true.
	 * @return {Boolean} True if the local preview video is muted, else false
	 * (including if the call is not set up yet).
	 */
	MatrixCall.prototype.isLocalVideoMuted = function () {
	    if (!this.localAVStream) {
	        return false;
	    }
	    return !isTracksEnabled(this.localAVStream.getVideoTracks());
	};
	
	/**
	 * Set whether the microphone should be muted or not.
	 * @param {boolean} muted True to mute the mic.
	 */
	MatrixCall.prototype.setMicrophoneMuted = function (muted) {
	    if (!this.localAVStream) {
	        return;
	    }
	    setTracksEnabled(this.localAVStream.getAudioTracks(), !muted);
	};
	
	/**
	 * Check if the microphone is muted.
	 *
	 * If there are multiple audio tracks, <i>all</i> of the tracks need to be muted
	 * for this to return true. This means if there are no audio tracks, this will
	 * return true.
	 * @return {Boolean} True if the mic is muted, else false (including if the call
	 * is not set up yet).
	 */
	MatrixCall.prototype.isMicrophoneMuted = function () {
	    if (!this.localAVStream) {
	        return false;
	    }
	    return !isTracksEnabled(this.localAVStream.getAudioTracks());
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} stream
	 */
	MatrixCall.prototype._gotUserMediaForInvite = function (stream) {
	    if (this.successor) {
	        this.successor._gotUserMediaForAnswer(stream);
	        return;
	    }
	    if (this.state == 'ended') {
	        return;
	    }
	    debuglog("_gotUserMediaForInvite -> " + this.type);
	    var self = this;
	    var videoEl = this.getLocalVideoElement();
	
	    if (videoEl && this.type == 'video') {
	        videoEl.autoplay = true;
	        if (this.screenSharingStream) {
	            debuglog("Setting screen sharing stream to the local video element");
	            this.assignElement(videoEl, this.screenSharingStream, "localVideo");
	        } else {
	            this.assignElement(videoEl, stream, "localVideo");
	        }
	        videoEl.muted = true;
	        setTimeout(function () {
	            var vel = self.getLocalVideoElement();
	            if (vel.play) {
	                self.playElement(vel, "localVideo");
	            }
	        }, 0);
	    }
	
	    if (this.screenSharingStream) {
	        this.screenSharingStream.addTrack(stream.getAudioTracks()[0]);
	        stream = this.screenSharingStream;
	    }
	
	    this.localAVStream = stream;
	    // why do we enable audio (and only audio) tracks here? -- matthew
	    setTracksEnabled(stream.getAudioTracks(), true);
	    this.peerConn = _createPeerConnection(this);
	    this.peerConn.addStream(stream);
	    this.peerConn.createOffer(hookCallback(self, self._gotLocalOffer), hookCallback(self, self._getLocalOfferFailed));
	    setState(self, 'create_offer');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} stream
	 */
	MatrixCall.prototype._gotUserMediaForAnswer = function (stream) {
	    var self = this;
	    if (self.state == 'ended') {
	        return;
	    }
	    var localVidEl = self.getLocalVideoElement();
	
	    if (localVidEl && self.type == 'video') {
	        localVidEl.autoplay = true;
	        this.assignElement(localVidEl, stream, "localVideo");
	        localVidEl.muted = true;
	        setTimeout(function () {
	            var vel = self.getLocalVideoElement();
	            if (vel.play) {
	                self.playElement(vel, "localVideo");
	            }
	        }, 0);
	    }
	
	    self.localAVStream = stream;
	    setTracksEnabled(stream.getAudioTracks(), true);
	    self.peerConn.addStream(stream);
	
	    var constraints = {
	        'mandatory': {
	            'OfferToReceiveAudio': true,
	            'OfferToReceiveVideo': self.type == 'video'
	        }
	    };
	    self.peerConn.createAnswer(function (description) {
	        debuglog("Created answer: " + description);
	        self.peerConn.setLocalDescription(description, function () {
	            var content = {
	                version: 0,
	                call_id: self.callId,
	                answer: {
	                    sdp: self.peerConn.localDescription.sdp,
	                    type: self.peerConn.localDescription.type
	                }
	            };
	            sendEvent(self, 'm.call.answer', content);
	            setState(self, 'connecting');
	        }, function () {
	            debuglog("Error setting local description!");
	        }, constraints);
	    }, function (err) {
	        debuglog("Failed to create answer: " + err);
	    });
	    setState(self, 'create_answer');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._gotLocalIceCandidate = function (event) {
	    if (event.candidate) {
	        debuglog("Got local ICE " + event.candidate.sdpMid + " candidate: " + event.candidate.candidate);
	        // As with the offer, note we need to make a copy of this object, not
	        // pass the original: that broke in Chrome ~m43.
	        var c = {
	            candidate: event.candidate.candidate,
	            sdpMid: event.candidate.sdpMid,
	            sdpMLineIndex: event.candidate.sdpMLineIndex
	        };
	        sendCandidate(this, c);
	    }
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} cand
	 */
	MatrixCall.prototype._gotRemoteIceCandidate = function (cand) {
	    if (this.state == 'ended') {
	        //debuglog("Ignoring remote ICE candidate because call has ended");
	        return;
	    }
	    debuglog("Got remote ICE " + cand.sdpMid + " candidate: " + cand.candidate);
	    this.peerConn.addIceCandidate(new this.webRtc.RtcIceCandidate(cand), function () {}, function (e) {});
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} msg
	 */
	MatrixCall.prototype._receivedAnswer = function (msg) {
	    if (this.state == 'ended') {
	        return;
	    }
	
	    var self = this;
	    this.peerConn.setRemoteDescription(new this.webRtc.RtcSessionDescription(msg.answer), hookCallback(self, self._onSetRemoteDescriptionSuccess), hookCallback(self, self._onSetRemoteDescriptionError));
	    setState(self, 'connecting');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} description
	 */
	MatrixCall.prototype._gotLocalOffer = function (description) {
	    var self = this;
	    debuglog("Created offer: " + description);
	
	    if (self.state == 'ended') {
	        debuglog("Ignoring newly created offer on call ID " + self.callId + " because the call has ended");
	        return;
	    }
	
	    self.peerConn.setLocalDescription(description, function () {
	        var content = {
	            version: 0,
	            call_id: self.callId,
	            // OpenWebRTC appears to add extra stuff (like the DTLS fingerprint)
	            // to the description when setting it on the peerconnection.
	            // According to the spec it should only add ICE
	            // candidates. Any ICE candidates that have already been generated
	            // at this point will probably be sent both in the offer and separately.
	            // Also, note that we have to make a new object here, copying the
	            // type and sdp properties.
	            // Passing the RTCSessionDescription object as-is doesn't work in
	            // Chrome (as of about m43).
	            offer: {
	                sdp: self.peerConn.localDescription.sdp,
	                type: self.peerConn.localDescription.type
	            },
	            lifetime: MatrixCall.CALL_TIMEOUT_MS
	        };
	        sendEvent(self, 'm.call.invite', content);
	
	        setTimeout(function () {
	            if (self.state == 'invite_sent') {
	                self.hangup('invite_timeout');
	            }
	        }, MatrixCall.CALL_TIMEOUT_MS);
	        setState(self, 'invite_sent');
	    }, function () {
	        debuglog("Error setting local description!");
	    });
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} error
	 */
	MatrixCall.prototype._getLocalOfferFailed = function (error) {
	    this.emit("error", callError(MatrixCall.ERR_LOCAL_OFFER_FAILED, "Failed to start audio for call!"));
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} error
	 */
	MatrixCall.prototype._getUserMediaFailed = function (error) {
	    this.emit("error", callError(MatrixCall.ERR_NO_USER_MEDIA, "Couldn't start capturing media! Is your microphone set up and " + "does this app have permission?"));
	    this.hangup("user_media_failed");
	};
	
	/**
	 * Internal
	 * @private
	 */
	MatrixCall.prototype._onIceConnectionStateChanged = function () {
	    if (this.state == 'ended') {
	        return; // because ICE can still complete as we're ending the call
	    }
	    debuglog("Ice connection state changed to: " + this.peerConn.iceConnectionState);
	    // ideally we'd consider the call to be connected when we get media but
	    // chrome doesn't implement any of the 'onstarted' events yet
	    if (this.peerConn.iceConnectionState == 'completed' || this.peerConn.iceConnectionState == 'connected') {
	        setState(this, 'connected');
	        this.didConnect = true;
	    } else if (this.peerConn.iceConnectionState == 'failed') {
	        this.hangup('ice_failed');
	    }
	};
	
	/**
	 * Internal
	 * @private
	 */
	MatrixCall.prototype._onSignallingStateChanged = function () {
	    debuglog("call " + this.callId + ": Signalling state changed to: " + this.peerConn.signalingState);
	};
	
	/**
	 * Internal
	 * @private
	 */
	MatrixCall.prototype._onSetRemoteDescriptionSuccess = function () {
	    debuglog("Set remote description");
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} e
	 */
	MatrixCall.prototype._onSetRemoteDescriptionError = function (e) {
	    debuglog("Failed to set remote description" + e);
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onAddStream = function (event) {
	    debuglog("Stream id " + event.stream.id + " added");
	
	    var s = event.stream;
	
	    if (s.getVideoTracks().length > 0) {
	        this.type = 'video';
	        this.remoteAVStream = s;
	        this.remoteAStream = s;
	    } else {
	        this.type = 'voice';
	        this.remoteAStream = s;
	    }
	
	    var self = this;
	    forAllTracksOnStream(s, function (t) {
	        debuglog("Track id " + t.id + " added");
	        // not currently implemented in chrome
	        t.onstarted = hookCallback(self, self._onRemoteStreamTrackStarted);
	    });
	
	    if (event.stream.oninactive !== undefined) {
	        event.stream.oninactive = hookCallback(self, self._onRemoteStreamEnded);
	    } else {
	        // onended is deprecated from Chrome 54
	        event.stream.onended = hookCallback(self, self._onRemoteStreamEnded);
	    }
	
	    // not currently implemented in chrome
	    event.stream.onstarted = hookCallback(self, self._onRemoteStreamStarted);
	
	    if (this.type === 'video') {
	        _tryPlayRemoteStream(this);
	        _tryPlayRemoteAudioStream(this);
	    } else {
	        _tryPlayRemoteAudioStream(this);
	    }
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onRemoteStreamStarted = function (event) {
	    setState(this, 'connected');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onRemoteStreamEnded = function (event) {
	    debuglog("Remote stream ended");
	    this.hangupParty = 'remote';
	    setState(this, 'ended');
	    stopAllMedia(this);
	    if (this.peerConn.signalingState != 'closed') {
	        this.peerConn.close();
	    }
	    this.emit("hangup", this);
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onRemoteStreamTrackStarted = function (event) {
	    setState(this, 'connected');
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} msg
	 */
	MatrixCall.prototype._onHangupReceived = function (msg) {
	    debuglog("Hangup received");
	    terminate(this, "remote", msg.reason, true);
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} msg
	 */
	MatrixCall.prototype._onAnsweredElsewhere = function (msg) {
	    debuglog("Answered elsewhere");
	    terminate(this, "remote", "answered_elsewhere", true);
	};
	
	var setTracksEnabled = function setTracksEnabled(tracks, enabled) {
	    for (var i = 0; i < tracks.length; i++) {
	        tracks[i].enabled = enabled;
	    }
	};
	
	var isTracksEnabled = function isTracksEnabled(tracks) {
	    for (var i = 0; i < tracks.length; i++) {
	        if (tracks[i].enabled) {
	            return true; // at least one track is enabled
	        }
	    }
	    return false;
	};
	
	var setState = function setState(self, state) {
	    var oldState = self.state;
	    self.state = state;
	    self.emit("state", state, oldState);
	};
	
	/**
	 * Internal
	 * @param {MatrixCall} self
	 * @param {string} eventType
	 * @param {Object} content
	 * @return {Promise}
	 */
	var sendEvent = function sendEvent(self, eventType, content) {
	    return self.client.sendEvent(self.roomId, eventType, content).catch(function (err) {
	        self.emit('send_event_error', err);
	    });
	};
	
	var sendCandidate = function sendCandidate(self, content) {
	    // Sends candidates with are sent in a special way because we try to amalgamate
	    // them into one message
	    self.candidateSendQueue.push(content);
	    if (self.candidateSendTries === 0) {
	        setTimeout(function () {
	            _sendCandidateQueue(self);
	        }, 100);
	    }
	};
	
	var terminate = function terminate(self, hangupParty, hangupReason, shouldEmit) {
	    if (self.getRemoteVideoElement()) {
	        if (self.getRemoteVideoElement().pause) {
	            self.pauseElement(self.getRemoteVideoElement(), "remoteVideo");
	        }
	        self.assignElement(self.getRemoteVideoElement(), null, "remoteVideo");
	    }
	    if (self.getRemoteAudioElement()) {
	        if (self.getRemoteAudioElement().pause) {
	            self.pauseElement(self.getRemoteAudioElement(), "remoteAudio");
	        }
	        self.assignElement(self.getRemoteAudioElement(), null, "remoteAudio");
	    }
	    if (self.getLocalVideoElement()) {
	        if (self.getLocalVideoElement().pause) {
	            self.pauseElement(self.getLocalVideoElement(), "localVideo");
	        }
	        self.assignElement(self.getLocalVideoElement(), null, "localVideo");
	    }
	    self.hangupParty = hangupParty;
	    self.hangupReason = hangupReason;
	    setState(self, 'ended');
	    stopAllMedia(self);
	    if (self.peerConn && self.peerConn.signalingState !== 'closed') {
	        self.peerConn.close();
	    }
	    if (shouldEmit) {
	        self.emit("hangup", self);
	    }
	};
	
	var stopAllMedia = function stopAllMedia(self) {
	    debuglog("stopAllMedia (stream=%s)", self.localAVStream);
	    if (self.localAVStream) {
	        forAllTracksOnStream(self.localAVStream, function (t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	        // also call stop on the main stream so firefox will stop sharing
	        // the mic
	        if (self.localAVStream.stop) {
	            self.localAVStream.stop();
	        }
	    }
	    if (self.screenSharingStream) {
	        forAllTracksOnStream(self.screenSharingStream, function (t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	        if (self.screenSharingStream.stop) {
	            self.screenSharingStream.stop();
	        }
	    }
	    if (self.remoteAVStream) {
	        forAllTracksOnStream(self.remoteAVStream, function (t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	    }
	    if (self.remoteAStream) {
	        forAllTracksOnStream(self.remoteAStream, function (t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	    }
	};
	
	var _tryPlayRemoteStream = function _tryPlayRemoteStream(self) {
	    if (self.getRemoteVideoElement() && self.remoteAVStream) {
	        var player = self.getRemoteVideoElement();
	        player.autoplay = true;
	        self.assignElement(player, self.remoteAVStream, "remoteVideo");
	        setTimeout(function () {
	            var vel = self.getRemoteVideoElement();
	            if (vel.play) {
	                self.playElement(vel, "remoteVideo");
	            }
	            // OpenWebRTC does not support oniceconnectionstatechange yet
	            if (self.webRtc.isOpenWebRTC()) {
	                setState(self, 'connected');
	            }
	        }, 0);
	    }
	};
	
	var _tryPlayRemoteAudioStream = function _tryPlayRemoteAudioStream(self) {
	    if (self.getRemoteAudioElement() && self.remoteAStream) {
	        var player = self.getRemoteAudioElement();
	        player.autoplay = true;
	        self.assignElement(player, self.remoteAStream, "remoteAudio");
	        setTimeout(function () {
	            var ael = self.getRemoteAudioElement();
	            if (ael.play) {
	                self.playElement(ael, "remoteAudio");
	            }
	            // OpenWebRTC does not support oniceconnectionstatechange yet
	            if (self.webRtc.isOpenWebRTC()) {
	                setState(self, 'connected');
	            }
	        }, 0);
	    }
	};
	
	var checkForErrorListener = function checkForErrorListener(self) {
	    if (self.listeners("error").length === 0) {
	        throw new Error("You MUST attach an error listener using call.on('error', function() {})");
	    }
	};
	
	var callError = function callError(code, msg) {
	    var e = new Error(msg);
	    e.code = code;
	    return e;
	};
	
	var debuglog = function debuglog() {
	    if (DEBUG) {
	        var _console;
	
	        (_console = console).log.apply(_console, arguments);
	    }
	};
	
	var _sendCandidateQueue = function _sendCandidateQueue(self) {
	    if (self.candidateSendQueue.length === 0) {
	        return;
	    }
	
	    var cands = self.candidateSendQueue;
	    self.candidateSendQueue = [];
	    ++self.candidateSendTries;
	    var content = {
	        version: 0,
	        call_id: self.callId,
	        candidates: cands
	    };
	    debuglog("Attempting to send " + cands.length + " candidates");
	    sendEvent(self, 'm.call.candidates', content).then(function () {
	        self.candidateSendTries = 0;
	        _sendCandidateQueue(self);
	    }, function (error) {
	        for (var i = 0; i < cands.length; i++) {
	            self.candidateSendQueue.push(cands[i]);
	        }
	
	        if (self.candidateSendTries > 5) {
	            debuglog("Failed to send candidates on attempt %s. Giving up for now.", self.candidateSendTries);
	            self.candidateSendTries = 0;
	            return;
	        }
	
	        var delayMs = 500 * Math.pow(2, self.candidateSendTries);
	        ++self.candidateSendTries;
	        debuglog("Failed to send candidates. Retrying in " + delayMs + "ms");
	        setTimeout(function () {
	            _sendCandidateQueue(self);
	        }, delayMs);
	    });
	};
	
	var _placeCallWithConstraints = function _placeCallWithConstraints(self, constraints) {
	    self.client.callList[self.callId] = self;
	    self.webRtc.getUserMedia(constraints, hookCallback(self, self._gotUserMediaForInvite), hookCallback(self, self._getUserMediaFailed));
	    setState(self, 'wait_local_media');
	    self.direction = 'outbound';
	    self.config = constraints;
	};
	
	var _createPeerConnection = function _createPeerConnection(self) {
	    var servers = self.turnServers;
	    if (self.webRtc.vendor === "mozilla") {
	        // modify turnServers struct to match what mozilla expects.
	        servers = [];
	        for (var i = 0; i < self.turnServers.length; i++) {
	            for (var j = 0; j < self.turnServers[i].urls.length; j++) {
	                servers.push({
	                    url: self.turnServers[i].urls[j],
	                    username: self.turnServers[i].username,
	                    credential: self.turnServers[i].credential
	                });
	            }
	        }
	    }
	
	    var pc = new self.webRtc.RtcPeerConnection({
	        iceServers: servers
	    });
	    pc.oniceconnectionstatechange = hookCallback(self, self._onIceConnectionStateChanged);
	    pc.onsignalingstatechange = hookCallback(self, self._onSignallingStateChanged);
	    pc.onicecandidate = hookCallback(self, self._gotLocalIceCandidate);
	    pc.onaddstream = hookCallback(self, self._onAddStream);
	    return pc;
	};
	
	var _getChromeScreenSharingConstraints = function _getChromeScreenSharingConstraints(call) {
	    var screen = global.screen;
	    if (!screen) {
	        call.emit("error", callError(MatrixCall.ERR_NO_USER_MEDIA, "Couldn't determine screen sharing constaints."));
	        return;
	    }
	
	    return {
	        video: {
	            mandatory: {
	                chromeMediaSource: "screen",
	                chromeMediaSourceId: "" + Date.now(),
	                maxWidth: screen.width,
	                maxHeight: screen.height,
	                minFrameRate: 1,
	                maxFrameRate: 10
	            }
	        }
	    };
	};
	
	var _getUserMediaVideoContraints = function _getUserMediaVideoContraints(callType) {
	    switch (callType) {
	        case 'voice':
	            return { audio: true, video: false };
	        case 'video':
	            return { audio: true, video: {
	                    mandatory: {
	                        minWidth: 640,
	                        maxWidth: 640,
	                        minHeight: 360,
	                        maxHeight: 360
	                    }
	                } };
	    }
	};
	
	var hookCallback = function hookCallback(call, fn) {
	    return function () {
	        return fn.apply(call, arguments);
	    };
	};
	
	var forAllVideoTracksOnStream = function forAllVideoTracksOnStream(s, f) {
	    var tracks = s.getVideoTracks();
	    for (var i = 0; i < tracks.length; i++) {
	        f(tracks[i]);
	    }
	};
	
	var forAllAudioTracksOnStream = function forAllAudioTracksOnStream(s, f) {
	    var tracks = s.getAudioTracks();
	    for (var i = 0; i < tracks.length; i++) {
	        f(tracks[i]);
	    }
	};
	
	var forAllTracksOnStream = function forAllTracksOnStream(s, f) {
	    forAllVideoTracksOnStream(s, f);
	    forAllAudioTracksOnStream(s, f);
	};
	
	/** The MatrixCall class. */
	module.exports.MatrixCall = MatrixCall;
	
	/**
	 * Create a new Matrix call for the browser.
	 * @param {MatrixClient} client The client instance to use.
	 * @param {string} roomId The room the call is in.
	 * @return {MatrixCall} the call or null if the browser doesn't support calling.
	 */
	module.exports.createNewMatrixCall = function (client, roomId) {
	    var w = global.window;
	    var doc = global.document;
	    if (!w || !doc) {
	        return null;
	    }
	    var webRtc = {};
	    webRtc.isOpenWebRTC = function () {
	        var scripts = doc.getElementById("script");
	        if (!scripts || !scripts.length) {
	            return false;
	        }
	        for (var i = 0; i < scripts.length; i++) {
	            if (scripts[i].src.indexOf("owr.js") > -1) {
	                return true;
	            }
	        }
	        return false;
	    };
	    var getUserMedia = w.navigator.getUserMedia || w.navigator.webkitGetUserMedia || w.navigator.mozGetUserMedia;
	    if (getUserMedia) {
	        webRtc.getUserMedia = function () {
	            return getUserMedia.apply(w.navigator, arguments);
	        };
	    }
	    webRtc.RtcPeerConnection = w.RTCPeerConnection || w.webkitRTCPeerConnection || w.mozRTCPeerConnection;
	    webRtc.RtcSessionDescription = w.RTCSessionDescription || w.webkitRTCSessionDescription || w.mozRTCSessionDescription;
	    webRtc.RtcIceCandidate = w.RTCIceCandidate || w.webkitRTCIceCandidate || w.mozRTCIceCandidate;
	    webRtc.vendor = null;
	    if (w.mozRTCPeerConnection) {
	        webRtc.vendor = "mozilla";
	    } else if (w.webkitRTCPeerConnection) {
	        webRtc.vendor = "webkit";
	    } else if (w.RTCPeerConnection) {
	        webRtc.vendor = "generic";
	    }
	    if (!webRtc.RtcIceCandidate || !webRtc.RtcSessionDescription || !webRtc.RtcPeerConnection || !webRtc.getUserMedia) {
	        return null; // WebRTC is not supported.
	    }
	    var opts = {
	        webRtc: webRtc,
	        client: client,
	        URL: w.URL,
	        roomId: roomId,
	        turnServers: client.getTurnServers()
	    };
	    return new MatrixCall(opts);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	
	/**
	 * Allows a user to add a third party identifier to their Home Server and,
	 * optionally, the identity servers.
	 *
	 * This involves getting an email token from the identity server to "prove" that
	 * the client owns the given email address, which is then passed to the
	 * add threepid API on the homeserver.
	 */
	
	var AddThreepid = function () {
	    function AddThreepid() {
	        (0, _classCallCheck3.default)(this, AddThreepid);
	
	        this.clientSecret = MatrixClientPeg.get().generateClientSecret();
	    }
	
	    /**
	     * Attempt to add an email threepid. This will trigger a side-effect of
	     * sending an email to the provided email address.
	     * @param {string} emailAddress The email address to add
	     * @param {boolean} bind If True, bind this email to this mxid on the Identity Server
	     * @return {Promise} Resolves when the email has been sent. Then call checkEmailLinkClicked().
	     */
	
	
	    (0, _createClass3.default)(AddThreepid, [{
	        key: "addEmailAddress",
	        value: function addEmailAddress(emailAddress, bind) {
	            var _this = this;
	
	            this.bind = bind;
	            return MatrixClientPeg.get().requestAdd3pidEmailToken(emailAddress, this.clientSecret, 1).then(function (res) {
	                _this.sessionId = res.sid;
	                return res;
	            }, function (err) {
	                if (err.errcode == 'M_THREEPID_IN_USE') {
	                    err.message = "This email address is already in use";
	                } else if (err.httpStatus) {
	                    err.message = err.message + (" (Status " + err.httpStatus + ")");
	                }
	                throw err;
	            });
	        }
	
	        /**
	         * Attempt to add a msisdn threepid. This will trigger a side-effect of
	         * sending a test message to the provided phone number.
	         * @param {string} phoneCountry The ISO 2 letter code of the country to resolve phoneNumber in
	         * @param {string} phoneNumber The national or international formatted phone number to add
	         * @param {boolean} bind If True, bind this phone number to this mxid on the Identity Server
	         * @return {Promise} Resolves when the text message has been sent. Then call haveMsisdnToken().
	         */
	
	    }, {
	        key: "addMsisdn",
	        value: function addMsisdn(phoneCountry, phoneNumber, bind) {
	            var _this2 = this;
	
	            this.bind = bind;
	            return MatrixClientPeg.get().requestAdd3pidMsisdnToken(phoneCountry, phoneNumber, this.clientSecret, 1).then(function (res) {
	                _this2.sessionId = res.sid;
	                return res;
	            }, function (err) {
	                if (err.errcode == 'M_THREEPID_IN_USE') {
	                    err.message = "This phone number is already in use";
	                } else if (err.httpStatus) {
	                    err.message = err.message + (" (Status " + err.httpStatus + ")");
	                }
	                throw err;
	            });
	        }
	
	        /**
	         * Checks if the email link has been clicked by attempting to add the threepid
	         * @return {Promise} Resolves if the email address was added. Rejects with an object
	         * with a "message" property which contains a human-readable message detailing why
	         * the request failed.
	         */
	
	    }, {
	        key: "checkEmailLinkClicked",
	        value: function checkEmailLinkClicked() {
	            var identityServerDomain = MatrixClientPeg.get().idBaseUrl.split("://")[1];
	            return MatrixClientPeg.get().addThreePid({
	                sid: this.sessionId,
	                client_secret: this.clientSecret,
	                id_server: identityServerDomain
	            }, this.bind).catch(function (err) {
	                if (err.httpStatus === 401) {
	                    err.message = "Failed to verify email address: make sure you clicked the link in the email";
	                } else if (err.httpStatus) {
	                    err.message += " (Status " + err.httpStatus + ")";
	                }
	                throw err;
	            });
	        }
	
	        /**
	         * Takes a phone number verification code as entered by the user and validates
	         * it with the ID server, then if successful, adds the phone number.
	         * @return {Promise} Resolves if the phone number was added. Rejects with an object
	         * with a "message" property which contains a human-readable message detailing why
	         * the request failed.
	         */
	
	    }, {
	        key: "haveMsisdnToken",
	        value: function haveMsisdnToken(token) {
	            var _this3 = this;
	
	            return MatrixClientPeg.get().submitMsisdnToken(this.sessionId, this.clientSecret, token).then(function (result) {
	                if (result.errcode) {
	                    throw result;
	                }
	                var identityServerDomain = MatrixClientPeg.get().idBaseUrl.split("://")[1];
	                return MatrixClientPeg.get().addThreePid({
	                    sid: _this3.sessionId,
	                    client_secret: _this3.clientSecret,
	                    id_server: identityServerDomain
	                }, _this3.bind);
	            });
	        }
	    }]);
	    return AddThreepid;
	}();
	
	module.exports = AddThreepid;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var q = __webpack_require__(6);
	var extend = __webpack_require__(1271);
	var dis = __webpack_require__(5);
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	var Modal = __webpack_require__(10);
	
	var encrypt = __webpack_require__(377);
	
	// Polyfill for Canvas.toBlob API using Canvas.toDataURL
	__webpack_require__(627);
	
	var MAX_WIDTH = 800;
	var MAX_HEIGHT = 600;
	
	/**
	 * Create a thumbnail for a image DOM element.
	 * The image will be smaller than MAX_WIDTH and MAX_HEIGHT.
	 * The thumbnail will have the same aspect ratio as the original.
	 * Draws the element into a canvas using CanvasRenderingContext2D.drawImage
	 * Then calls Canvas.toBlob to get a blob object for the image data.
	 *
	 * Since it needs to calculate the dimensions of the source image and the
	 * thumbnailed image it returns an info object filled out with information
	 * about the original image and the thumbnail.
	 *
	 * @param {HTMLElement} element The element to thumbnail.
	 * @param {integer} inputWidth The width of the image in the input element.
	 * @param {integer} inputHeight the width of the image in the input element.
	 * @param {String} mimeType The mimeType to save the blob as.
	 * @return {Promise} A promise that resolves with an object with an info key
	 *  and a thumbnail key.
	 */
	function createThumbnail(element, inputWidth, inputHeight, mimeType) {
	    var deferred = q.defer();
	
	    var targetWidth = inputWidth;
	    var targetHeight = inputHeight;
	    if (targetHeight > MAX_HEIGHT) {
	        targetWidth = Math.floor(targetWidth * (MAX_HEIGHT / targetHeight));
	        targetHeight = MAX_HEIGHT;
	    }
	    if (targetWidth > MAX_WIDTH) {
	        targetHeight = Math.floor(targetHeight * (MAX_WIDTH / targetWidth));
	        targetWidth = MAX_WIDTH;
	    }
	
	    var canvas = document.createElement("canvas");
	    canvas.width = targetWidth;
	    canvas.height = targetHeight;
	    canvas.getContext("2d").drawImage(element, 0, 0, targetWidth, targetHeight);
	    canvas.toBlob(function (thumbnail) {
	        deferred.resolve({
	            info: {
	                thumbnail_info: {
	                    w: targetWidth,
	                    h: targetHeight,
	                    mimetype: thumbnail.type,
	                    size: thumbnail.size
	                },
	                w: inputWidth,
	                h: inputHeight
	            },
	            thumbnail: thumbnail
	        });
	    }, mimeType);
	
	    return deferred.promise;
	}
	
	/**
	 * Load a file into a newly created image element.
	 *
	 * @param {File} file The file to load in an image element.
	 * @return {Promise} A promise that resolves with the html image element.
	 */
	function loadImageElement(imageFile) {
	    var deferred = q.defer();
	
	    // Load the file into an html element
	    var img = document.createElement("img");
	
	    var reader = new FileReader();
	    reader.onload = function (e) {
	        img.src = e.target.result;
	
	        // Once ready, create a thumbnail
	        img.onload = function () {
	            deferred.resolve(img);
	        };
	        img.onerror = function (e) {
	            deferred.reject(e);
	        };
	    };
	    reader.onerror = function (e) {
	        deferred.reject(e);
	    };
	    reader.readAsDataURL(imageFile);
	
	    return deferred.promise;
	}
	
	/**
	 * Read the metadata for an image file and create and upload a thumbnail of the image.
	 *
	 * @param {MatrixClient} matrixClient A matrixClient to upload the thumbnail with.
	 * @param {String} roomId The ID of the room the image will be uploaded in.
	 * @param {File} The image to read and thumbnail.
	 * @return {Promise} A promise that resolves with the attachment info.
	 */
	function infoForImageFile(matrixClient, roomId, imageFile) {
	    var thumbnailType = "image/png";
	    if (imageFile.type == "image/jpeg") {
	        thumbnailType = "image/jpeg";
	    }
	
	    var imageInfo;
	    return loadImageElement(imageFile).then(function (img) {
	        return createThumbnail(img, img.width, img.height, thumbnailType);
	    }).then(function (result) {
	        imageInfo = result.info;
	        return uploadFile(matrixClient, roomId, result.thumbnail);
	    }).then(function (result) {
	        imageInfo.thumbnail_url = result.url;
	        imageInfo.thumbnail_file = result.file;
	        return imageInfo;
	    });
	}
	
	/**
	 * Load a file into a newly created video element.
	 *
	 * @param {File} file The file to load in an video element.
	 * @return {Promise} A promise that resolves with the video image element.
	 */
	function loadVideoElement(videoFile) {
	    var deferred = q.defer();
	
	    // Load the file into an html element
	    var video = document.createElement("video");
	
	    var reader = new FileReader();
	    reader.onload = function (e) {
	        video.src = e.target.result;
	
	        // Once ready, returns its size
	        // Wait until we have enough data to thumbnail the first frame.
	        video.onloadeddata = function () {
	            deferred.resolve(video);
	        };
	        video.onerror = function (e) {
	            deferred.reject(e);
	        };
	    };
	    reader.onerror = function (e) {
	        deferred.reject(e);
	    };
	    reader.readAsDataURL(videoFile);
	
	    return deferred.promise;
	}
	
	/**
	 * Read the metadata for a video file and create and upload a thumbnail of the video.
	 *
	 * @param {MatrixClient} matrixClient A matrixClient to upload the thumbnail with.
	 * @param {String} roomId The ID of the room the video will be uploaded to.
	 * @param {File} The video to read and thumbnail.
	 * @return {Promise} A promise that resolves with the attachment info.
	 */
	function infoForVideoFile(matrixClient, roomId, videoFile) {
	    var thumbnailType = "image/jpeg";
	
	    var videoInfo;
	    return loadVideoElement(videoFile).then(function (video) {
	        return createThumbnail(video, video.videoWidth, video.videoHeight, thumbnailType);
	    }).then(function (result) {
	        videoInfo = result.info;
	        return uploadFile(matrixClient, roomId, result.thumbnail);
	    }).then(function (result) {
	        videoInfo.thumbnail_url = result.url;
	        videoInfo.thumbnail_file = result.file;
	        return videoInfo;
	    });
	}
	
	/**
	 * Read the file as an ArrayBuffer.
	 * @return {Promise} A promise that resolves with an ArrayBuffer when the file
	 *   is read.
	 */
	function readFileAsArrayBuffer(file) {
	    var deferred = q.defer();
	    var reader = new FileReader();
	    reader.onload = function (e) {
	        deferred.resolve(e.target.result);
	    };
	    reader.onerror = function (e) {
	        deferred.reject(e);
	    };
	    reader.readAsArrayBuffer(file);
	    return deferred.promise;
	}
	
	/**
	 * Upload the file to the content repository.
	 * If the room is encrypted then encrypt the file before uploading.
	 *
	 * @param {MatrixClient} matrixClient The matrix client to upload the file with.
	 * @param {String} roomId The ID of the room being uploaded to.
	 * @param {File} file The file to upload.
	 * @return {Promise} A promise that resolves with an object.
	 *  If the file is unencrypted then the object will have a "url" key.
	 *  If the file is encrypted then the object will have a "file" key.
	 */
	function uploadFile(matrixClient, roomId, file) {
	    if (matrixClient.isRoomEncrypted(roomId)) {
	        // If the room is encrypted then encrypt the file before uploading it.
	        // First read the file into memory.
	        return readFileAsArrayBuffer(file).then(function (data) {
	            // Then encrypt the file.
	            return encrypt.encryptAttachment(data);
	        }).then(function (encryptResult) {
	            // Record the information needed to decrypt the attachment.
	            var encryptInfo = encryptResult.info;
	            // Pass the encrypted data as a Blob to the uploader.
	            var blob = new Blob([encryptResult.data]);
	            return matrixClient.uploadContent(blob).then(function (url) {
	                // If the attachment is encrypted then bundle the URL along
	                // with the information needed to decrypt the attachment and
	                // add it under a file key.
	                encryptInfo.url = url;
	                if (file.type) {
	                    encryptInfo.mimetype = file.type;
	                }
	                return { "file": encryptInfo };
	            });
	        });
	    } else {
	        var basePromise = matrixClient.uploadContent(file);
	        var promise1 = basePromise.then(function (url) {
	            // If the attachment isn't encrypted then include the URL directly.
	            return { "url": url };
	        });
	        // XXX: copy over the abort method to the new promise
	        promise1.abort = basePromise.abort;
	        return promise1;
	    }
	}
	
	var ContentMessages = function () {
	    function ContentMessages() {
	        (0, _classCallCheck3.default)(this, ContentMessages);
	
	        this.inprogress = [];
	        this.nextId = 0;
	    }
	
	    (0, _createClass3.default)(ContentMessages, [{
	        key: 'sendContentToRoom',
	        value: function sendContentToRoom(file, roomId, matrixClient) {
	            var _this = this;
	
	            var content = {
	                body: file.name || 'Attachment',
	                info: {
	                    size: file.size
	                }
	            };
	
	            // if we have a mime type for the file, add it to the message metadata
	            if (file.type) {
	                content.info.mimetype = file.type;
	            }
	
	            var def = q.defer();
	            if (file.type.indexOf('image/') == 0) {
	                content.msgtype = 'm.image';
	                infoForImageFile(matrixClient, roomId, file).then(function (imageInfo) {
	                    extend(content.info, imageInfo);
	                    def.resolve();
	                }, function (error) {
	                    console.error(error);
	                    content.msgtype = 'm.file';
	                    def.resolve();
	                });
	            } else if (file.type.indexOf('audio/') == 0) {
	                content.msgtype = 'm.audio';
	                def.resolve();
	            } else if (file.type.indexOf('video/') == 0) {
	                content.msgtype = 'm.video';
	                infoForVideoFile(matrixClient, roomId, file).then(function (videoInfo) {
	                    extend(content.info, videoInfo);
	                    def.resolve();
	                }, function (error) {
	                    content.msgtype = 'm.file';
	                    def.resolve();
	                });
	            } else {
	                content.msgtype = 'm.file';
	                def.resolve();
	            }
	
	            var upload = {
	                fileName: file.name || 'Attachment',
	                roomId: roomId,
	                total: 0,
	                loaded: 0
	            };
	            this.inprogress.push(upload);
	            dis.dispatch({ action: 'upload_started' });
	
	            var error;
	            return def.promise.then(function () {
	                // XXX: upload.promise must be the promise that
	                // is returned by uploadFile as it has an abort()
	                // method hacked onto it.
	                upload.promise = uploadFile(matrixClient, roomId, file);
	                return upload.promise.then(function (result) {
	                    content.file = result.file;
	                    content.url = result.url;
	                });
	            }).progress(function (ev) {
	                if (ev) {
	                    upload.total = ev.total;
	                    upload.loaded = ev.loaded;
	                    dis.dispatch({ action: 'upload_progress', upload: upload });
	                }
	            }).then(function (url) {
	                return matrixClient.sendMessage(roomId, content);
	            }, function (err) {
	                error = err;
	                if (!upload.canceled) {
	                    var desc = "The file '" + upload.fileName + "' failed to upload.";
	                    if (err.http_status == 413) {
	                        desc = "The file '" + upload.fileName + "' exceeds this home server's size limit for uploads";
	                    }
	                    var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                    Modal.createDialog(ErrorDialog, {
	                        title: "Upload Failed",
	                        description: desc
	                    });
	                }
	            }).finally(function () {
	                var inprogressKeys = (0, _keys2.default)(_this.inprogress);
	                for (var i = 0; i < _this.inprogress.length; ++i) {
	                    var k = inprogressKeys[i];
	                    if (_this.inprogress[k].promise === upload.promise) {
	                        _this.inprogress.splice(k, 1);
	                        break;
	                    }
	                }
	                if (error) {
	                    dis.dispatch({ action: 'upload_failed', upload: upload });
	                } else {
	                    dis.dispatch({ action: 'upload_finished', upload: upload });
	                }
	            });
	        }
	    }, {
	        key: 'getCurrentUploads',
	        value: function getCurrentUploads() {
	            return this.inprogress;
	        }
	    }, {
	        key: 'cancelUpload',
	        value: function cancelUpload(promise) {
	            var inprogressKeys = (0, _keys2.default)(this.inprogress);
	            var upload;
	            for (var i = 0; i < this.inprogress.length; ++i) {
	                var k = inprogressKeys[i];
	                if (this.inprogress[k].promise === promise) {
	                    upload = this.inprogress[k];
	                    break;
	                }
	            }
	            if (upload) {
	                upload.canceled = true;
	                MatrixClientPeg.get().cancelUpload(upload.promise);
	            }
	        }
	    }]);
	    return ContentMessages;
	}();
	
	if (global.mx_ContentMessage === undefined) {
	    global.mx_ContentMessage = new ContentMessages();
	}
	
	module.exports = global.mx_ContentMessage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	module.exports = {
	
	    /**
	     * Returns the actual height that an image of dimensions (fullWidth, fullHeight)
	     * will occupy if resized to fit inside a thumbnail bounding box of size
	     * (thumbWidth, thumbHeight).
	     *
	     * If the aspect ratio of the source image is taller than the aspect ratio of
	     * the thumbnail bounding box, then we return the thumbHeight parameter unchanged.
	     * Otherwise we return the thumbHeight parameter scaled down appropriately to
	     * reflect the actual height the scaled thumbnail occupies.
	     *
	     * This is very useful for calculating how much height a thumbnail will actually
	     * consume in the timeline, when performing scroll offset calcuations
	     * (e.g. scroll locking)
	     */
	    thumbHeight: function thumbHeight(fullWidth, fullHeight, thumbWidth, _thumbHeight) {
	        if (!fullWidth || !fullHeight) {
	            // Cannot calculate thumbnail height for image: missing w/h in metadata. We can't even
	            // log this because it's spammy
	            return undefined;
	        }
	        if (fullWidth < thumbWidth && fullHeight < _thumbHeight) {
	            // no scaling needs to be applied
	            return fullHeight;
	        }
	        var widthMulti = thumbWidth / fullWidth;
	        var heightMulti = _thumbHeight / fullHeight;
	        if (widthMulti < heightMulti) {
	            // width is the dominant dimension so scaling will be fixed on that
	            return Math.floor(widthMulti * fullHeight);
	        } else {
	            // height is the dominant dimension so scaling will be fixed on that
	            return Math.floor(heightMulti * fullHeight);
	        }
	    }
	};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.loadSession = loadSession;
	exports.initRtsClient = initRtsClient;
	exports.setLoggedIn = setLoggedIn;
	exports.logout = logout;
	exports.startMatrixClient = startMatrixClient;
	exports.onLoggedOut = onLoggedOut;
	exports.stopMatrixClient = stopMatrixClient;
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _Notifier = __webpack_require__(170);
	
	var _Notifier2 = _interopRequireDefault(_Notifier);
	
	var _UserActivity = __webpack_require__(332);
	
	var _UserActivity2 = _interopRequireDefault(_UserActivity);
	
	var _Presence = __webpack_require__(502);
	
	var _Presence2 = _interopRequireDefault(_Presence);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	var _RtsClient = __webpack_require__(504);
	
	var _RtsClient2 = _interopRequireDefault(_RtsClient);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Called at startup, to attempt to build a logged-in Matrix session. It tries
	 * a number of things:
	 *
	 * 0. if it looks like we are in the middle of a registration process, it does
	 *    nothing.
	 *
	 * 1. if we have a loginToken in the (real) query params, it uses that to log
	 *    in.
	 *
	 * 2. if we have a guest access token in the fragment query params, it uses
	 *    that.
	 *
	 * 3. if an access token is stored in local storage (from a previous session),
	 *    it uses that.
	 *
	 * 4. it attempts to auto-register as a guest user.
	 *
	 * If any of steps 1-4 are successful, it will call {setLoggedIn}, which in
	 * turn will raise on_logged_in and will_start_client events.
	 *
	 * It returns a promise which resolves when the above process completes.
	 *
	 * @param {object} opts.realQueryParams: string->string map of the
	 *     query-parameters extracted from the real query-string of the starting
	 *     URI.
	 *
	 * @param {object} opts.fragmentQueryParams: string->string map of the
	 *     query-parameters extracted from the #-fragment of the starting URI.
	 *
	 * @param {boolean} opts.enableGuest: set to true to enable guest access tokens
	 *     and auto-guest registrations.
	 *
	 * @params {string} opts.guestHsUrl: homeserver URL. Only used if enableGuest is
	 *     true; defines the HS to register against.
	 *
	 * @params {string} opts.guestIsUrl: homeserver URL. Only used if enableGuest is
	 *     true; defines the IS to use.
	 *
	 */
	function loadSession(opts) {
	    var realQueryParams = opts.realQueryParams || {};
	    var fragmentQueryParams = opts.fragmentQueryParams || {};
	    var enableGuest = opts.enableGuest || false;
	    var guestHsUrl = opts.guestHsUrl;
	    var guestIsUrl = opts.guestIsUrl;
	    var defaultDeviceDisplayName = opts.defaultDeviceDisplayName;
	
	    if (fragmentQueryParams.client_secret && fragmentQueryParams.sid) {
	        // this happens during email validation: the email contains a link to the
	        // IS, which in turn redirects back to vector. We let MatrixChat create a
	        // Registration component which completes the next stage of registration.
	        console.log("Not registering as guest: registration already in progress.");
	        return (0, _q2.default)();
	    }
	
	    if (!guestHsUrl) {
	        console.warn("Cannot enable guest access: can't determine HS URL to use");
	        enableGuest = false;
	    }
	
	    if (realQueryParams.loginToken) {
	        if (!realQueryParams.homeserver) {
	            console.warn("Cannot log in with token: can't determine HS URL to use");
	        } else {
	            return _loginWithToken(realQueryParams, defaultDeviceDisplayName);
	        }
	    }
	
	    if (enableGuest && fragmentQueryParams.guest_user_id && fragmentQueryParams.guest_access_token) {
	        console.log("Using guest access credentials");
	        setLoggedIn({
	            userId: fragmentQueryParams.guest_user_id,
	            accessToken: fragmentQueryParams.guest_access_token,
	            homeserverUrl: guestHsUrl,
	            identityServerUrl: guestIsUrl,
	            guest: true
	        });
	        return (0, _q2.default)();
	    }
	
	    return _restoreFromLocalStorage().then(function (success) {
	        if (success) {
	            return;
	        }
	
	        if (enableGuest) {
	            return _registerAsGuest(guestHsUrl, guestIsUrl, defaultDeviceDisplayName);
	        }
	
	        // fall back to login screen
	    });
	} /*
	  Copyright 2015, 2016 OpenMarket Ltd
	  Copyright 2017 Vector Creations Ltd
	  
	  Licensed under the Apache License, Version 2.0 (the "License");
	  you may not use this file except in compliance with the License.
	  You may obtain a copy of the License at
	  
	      http://www.apache.org/licenses/LICENSE-2.0
	  
	  Unless required by applicable law or agreed to in writing, software
	  distributed under the License is distributed on an "AS IS" BASIS,
	  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	  See the License for the specific language governing permissions and
	  limitations under the License.
	  */
	
	function _loginWithToken(queryParams, defaultDeviceDisplayName) {
	    // create a temporary MatrixClient to do the login
	    var client = _matrixJsSdk2.default.createClient({
	        baseUrl: queryParams.homeserver
	    });
	
	    return client.login("m.login.token", {
	        token: queryParams.loginToken,
	        initial_device_display_name: defaultDeviceDisplayName
	    }).then(function (data) {
	        console.log("Logged in with token");
	        setLoggedIn({
	            userId: data.user_id,
	            deviceId: data.device_id,
	            accessToken: data.access_token,
	            homeserverUrl: queryParams.homeserver,
	            identityServerUrl: queryParams.identityServer,
	            guest: false
	        });
	    }, function (err) {
	        console.error("Failed to log in with login token: " + err + " " + err.data);
	    });
	}
	
	function _registerAsGuest(hsUrl, isUrl, defaultDeviceDisplayName) {
	    console.log("Doing guest login on %s", hsUrl);
	
	    // TODO: we should probably de-duplicate this and Login.loginAsGuest.
	    // Not really sure where the right home for it is.
	
	    // create a temporary MatrixClient to do the login
	    var client = _matrixJsSdk2.default.createClient({
	        baseUrl: hsUrl
	    });
	
	    return client.registerGuest({
	        body: {
	            initial_device_display_name: defaultDeviceDisplayName
	        }
	    }).then(function (creds) {
	        console.log("Registered as guest: %s", creds.user_id);
	        setLoggedIn({
	            userId: creds.user_id,
	            deviceId: creds.device_id,
	            accessToken: creds.access_token,
	            homeserverUrl: hsUrl,
	            identityServerUrl: isUrl,
	            guest: true
	        });
	    }, function (err) {
	        console.error("Failed to register as guest: " + err + " " + err.data);
	    });
	}
	
	// returns a promise which resolves to true if a session is found in
	// localstorage
	function _restoreFromLocalStorage() {
	    if (!localStorage) {
	        return (0, _q2.default)(false);
	    }
	    var hs_url = localStorage.getItem("mx_hs_url");
	    var is_url = localStorage.getItem("mx_is_url") || 'https://matrix.org';
	    var access_token = localStorage.getItem("mx_access_token");
	    var user_id = localStorage.getItem("mx_user_id");
	    var device_id = localStorage.getItem("mx_device_id");
	
	    var is_guest = void 0;
	    if (localStorage.getItem("mx_is_guest") !== null) {
	        is_guest = localStorage.getItem("mx_is_guest") === "true";
	    } else {
	        // legacy key name
	        is_guest = localStorage.getItem("matrix-is-guest") === "true";
	    }
	
	    if (access_token && user_id && hs_url) {
	        console.log("Restoring session for %s", user_id);
	        try {
	            setLoggedIn({
	                userId: user_id,
	                deviceId: device_id,
	                accessToken: access_token,
	                homeserverUrl: hs_url,
	                identityServerUrl: is_url,
	                guest: is_guest
	            });
	            return (0, _q2.default)(true);
	        } catch (e) {
	            return _handleRestoreFailure(e);
	        }
	    } else {
	        console.log("No previous session found.");
	        return (0, _q2.default)(false);
	    }
	}
	
	function _handleRestoreFailure(e) {
	    console.log("Unable to restore session", e);
	
	    var msg = e.message;
	    if (msg == "OLM.BAD_LEGACY_ACCOUNT_PICKLE") {
	        msg = "You need to log back in to generate end-to-end encryption keys " + "for this device and submit the public key to your homeserver. " + "This is a once off; sorry for the inconvenience.";
	
	        _clearLocalStorage();
	
	        return _q2.default.reject(new Error("Unable to restore previous session: " + msg));
	    }
	
	    var def = _q2.default.defer();
	    var SessionRestoreErrorDialog = _index2.default.getComponent('views.dialogs.SessionRestoreErrorDialog');
	
	    _Modal2.default.createDialog(SessionRestoreErrorDialog, {
	        error: msg,
	        onFinished: function onFinished(success) {
	            def.resolve(success);
	        }
	    });
	
	    return def.promise.then(function (success) {
	        if (success) {
	            // user clicked continue.
	            _clearLocalStorage();
	            return false;
	        }
	
	        // try, try again
	        return _restoreFromLocalStorage();
	    });
	}
	
	var rtsClient = null;
	function initRtsClient(url) {
	    rtsClient = new _RtsClient2.default(url);
	}
	
	/**
	 * Transitions to a logged-in state using the given credentials
	 * @param {MatrixClientCreds} credentials The credentials to use
	 */
	function setLoggedIn(credentials) {
	    credentials.guest = Boolean(credentials.guest);
	    console.log("setLoggedIn => %s (guest=%s) hs=%s", credentials.userId, credentials.guest, credentials.homeserverUrl);
	    // This is dispatched to indicate that the user is still in the process of logging in
	    // because `teamPromise` may take some time to resolve, breaking the assumption that
	    // `setLoggedIn` takes an "instant" to complete, and dispatch `on_logged_in` a few ms
	    // later than MatrixChat might assume.
	    _dispatcher2.default.dispatch({ action: 'on_logging_in' });
	
	    // Resolves by default
	    var teamPromise = _promise2.default.resolve(null);
	
	    // persist the session
	    if (localStorage) {
	        try {
	            localStorage.setItem("mx_hs_url", credentials.homeserverUrl);
	            localStorage.setItem("mx_is_url", credentials.identityServerUrl);
	            localStorage.setItem("mx_user_id", credentials.userId);
	            localStorage.setItem("mx_access_token", credentials.accessToken);
	            localStorage.setItem("mx_is_guest", (0, _stringify2.default)(credentials.guest));
	
	            // if we didn't get a deviceId from the login, leave mx_device_id unset,
	            // rather than setting it to "undefined".
	            //
	            // (in this case MatrixClient doesn't bother with the crypto stuff
	            // - that's fine for us).
	            if (credentials.deviceId) {
	                localStorage.setItem("mx_device_id", credentials.deviceId);
	            }
	
	            console.log("Session persisted for %s", credentials.userId);
	        } catch (e) {
	            console.warn("Error using local storage: can't persist session!", e);
	        }
	
	        if (rtsClient && !credentials.guest) {
	            teamPromise = rtsClient.login(credentials.userId).then(function (body) {
	                if (body.team_token) {
	                    localStorage.setItem("mx_team_token", body.team_token);
	                }
	                return body.team_token;
	            });
	        }
	    } else {
	        console.warn("No local storage available: can't persist session!");
	    }
	
	    // stop any running clients before we create a new one with these new credentials
	    stopMatrixClient();
	
	    _MatrixClientPeg2.default.replaceUsingCreds(credentials);
	
	    teamPromise.then(function (teamToken) {
	        _dispatcher2.default.dispatch({ action: 'on_logged_in', teamToken: teamToken });
	    }, function (err) {
	        console.warn("Failed to get team token on login", err);
	        _dispatcher2.default.dispatch({ action: 'on_logged_in', teamToken: null });
	    });
	
	    startMatrixClient();
	}
	
	/**
	 * Logs the current session out and transitions to the logged-out state
	 */
	function logout() {
	    if (_MatrixClientPeg2.default.get().isGuest()) {
	        // logout doesn't work for guest sessions
	        // Also we sometimes want to re-log in a guest session
	        // if we abort the login
	
	        // use settimeout to avoid racing with react unmounting components
	        // which need a valid matrixclientpeg
	        setTimeout(function () {
	            onLoggedOut();
	        }, 0);
	        return;
	    }
	
	    return _MatrixClientPeg2.default.get().logout().then(onLoggedOut, function (err) {
	        // Just throwing an error here is going to be very unhelpful
	        // if you're trying to log out because your server's down and
	        // you want to log into a different server, so just forget the
	        // access token. It's annoying that this will leave the access
	        // token still valid, but we should fix this by having access
	        // tokens expire (and if you really think you've been compromised,
	        // change your password).
	        console.log("Failed to call logout API: token will not be invalidated");
	        onLoggedOut();
	    });
	}
	
	/**
	 * Starts the matrix client and all other react-sdk services that
	 * listen for events while a session is logged in.
	 */
	function startMatrixClient() {
	    // dispatch this before starting the matrix client: it's used
	    // to add listeners for the 'sync' event so otherwise we'd have
	    // a race condition (and we need to dispatch synchronously for this
	    // to work).
	    _dispatcher2.default.dispatch({ action: 'will_start_client' }, true);
	
	    _Notifier2.default.start();
	    _UserActivity2.default.start();
	    _Presence2.default.start();
	    _DMRoomMap2.default.makeShared().start();
	
	    _MatrixClientPeg2.default.start();
	}
	
	/*
	 * Stops a running client and all related services, used after
	 * a session has been logged out / ended.
	 */
	function onLoggedOut() {
	    _clearLocalStorage();
	    stopMatrixClient();
	    _dispatcher2.default.dispatch({ action: 'on_logged_out' });
	}
	
	function _clearLocalStorage() {
	    if (!window.localStorage) {
	        return;
	    }
	    var hsUrl = window.localStorage.getItem("mx_hs_url");
	    var isUrl = window.localStorage.getItem("mx_is_url");
	    window.localStorage.clear();
	
	    // preserve our HS & IS URLs for convenience
	    // N.B. we cache them in hsUrl/isUrl and can't really inline them
	    // as getCurrentHsUrl() may call through to localStorage.
	    // NB. We do clear the device ID (as well as all the settings)
	    if (hsUrl) window.localStorage.setItem("mx_hs_url", hsUrl);
	    if (isUrl) window.localStorage.setItem("mx_is_url", isUrl);
	}
	
	/**
	 * Stop all the background processes related to the current client
	 */
	function stopMatrixClient() {
	    _Notifier2.default.stop();
	    _UserActivity2.default.stop();
	    _Presence2.default.stop();
	    if (_DMRoomMap2.default.shared()) _DMRoomMap2.default.shared().stop();
	    var cli = _MatrixClientPeg2.default.get();
	    if (cli) {
	        cli.stopClient();
	        cli.removeAllListeners();
	        cli.store.deleteAllData();
	        _MatrixClientPeg2.default.unset();
	    }
	}


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _commonmark = __webpack_require__(630);
	
	var _commonmark2 = _interopRequireDefault(_commonmark);
	
	var _escape = __webpack_require__(315);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var ALLOWED_HTML_TAGS = ['del'];
	
	// These types of node are definitely text
	var TEXT_NODES = ['text', 'softbreak', 'linebreak', 'paragraph', 'document'];
	
	function is_allowed_html_tag(node) {
	    // Regex won't work for tags with attrs, but we only
	    // allow <del> anyway.
	    var matches = /^<\/?(.*)>$/.exec(node.literal);
	    if (matches && matches.length == 2) {
	        var tag = matches[1];
	        return ALLOWED_HTML_TAGS.indexOf(tag) > -1;
	    }
	    return false;
	}
	
	function html_if_tag_allowed(node) {
	    if (is_allowed_html_tag(node)) {
	        this.lit(node.literal);
	        return;
	    } else {
	        this.lit((0, _escape2.default)(node.literal));
	    }
	}
	
	/*
	 * Returns true if the parse output containing the node
	 * comprises multiple block level elements (ie. lines),
	 * or false if it is only a single line.
	 */
	function is_multi_line(node) {
	    var par = node;
	    while (par.parent) {
	        par = par.parent;
	    }
	    return par.firstChild != par.lastChild;
	}
	
	/**
	 * Class that wraps commonmark, adding the ability to see whether
	 * a given message actually uses any markdown syntax or whether
	 * it's plain text.
	 */
	
	var Markdown = function () {
	    function Markdown(input) {
	        (0, _classCallCheck3.default)(this, Markdown);
	
	        this.input = input;
	
	        var parser = new _commonmark2.default.Parser();
	        this.parsed = parser.parse(this.input);
	    }
	
	    (0, _createClass3.default)(Markdown, [{
	        key: 'isPlainText',
	        value: function isPlainText() {
	            var walker = this.parsed.walker();
	
	            var ev = void 0;
	            while (ev = walker.next()) {
	                var node = ev.node;
	                if (TEXT_NODES.indexOf(node.type) > -1) {
	                    // definitely text
	                    continue;
	                } else if (node.type == 'html_inline' || node.type == 'html_block') {
	                    // if it's an allowed html tag, we need to render it and therefore
	                    // we will need to use HTML. If it's not allowed, it's not HTML since
	                    // we'll just be treating it as text.
	                    if (is_allowed_html_tag(node)) {
	                        return false;
	                    }
	                } else {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }, {
	        key: 'toHTML',
	        value: function toHTML() {
	            var renderer = new _commonmark2.default.HtmlRenderer({
	                safe: false,
	
	                // Set soft breaks to hard HTML breaks: commonmark
	                // puts softbreaks in for multiple lines in a blockquote,
	                // so if these are just newline characters then the
	                // block quote ends up all on one line
	                // (https://github.com/vector-im/riot-web/issues/3154)
	                softbreak: '<br />'
	            });
	            var real_paragraph = renderer.paragraph;
	
	            renderer.paragraph = function (node, entering) {
	                // If there is only one top level node, just return the
	                // bare text: it's a single line of text and so should be
	                // 'inline', rather than unnecessarily wrapped in its own
	                // p tag. If, however, we have multiple nodes, each gets
	                // its own p tag to keep them as separate paragraphs.
	                if (is_multi_line(node)) {
	                    real_paragraph.call(this, node, entering);
	                }
	            };
	
	            renderer.html_inline = html_if_tag_allowed;
	            renderer.html_block = function (node) {
	                // as with `paragraph`, we only insert line breaks
	                // if there are multiple lines in the markdown.
	                var isMultiLine = is_multi_line(node);
	
	                if (isMultiLine) this.cr();
	                html_if_tag_allowed.call(this, node);
	                if (isMultiLine) this.cr();
	            };
	
	            return renderer.render(this.parsed);
	        }
	
	        /*
	         * Render the markdown message to plain text. That is, essentially
	         * just remove any backslashes escaping what would otherwise be
	         * markdown syntax
	         * (to fix https://github.com/vector-im/riot-web/issues/2870)
	         */
	
	    }, {
	        key: 'toPlaintext',
	        value: function toPlaintext() {
	            var renderer = new _commonmark2.default.HtmlRenderer({ safe: false });
	            var real_paragraph = renderer.paragraph;
	
	            // The default `out` function only sends the input through an XML
	            // escaping function, which causes messages to be entity encoded,
	            // which we don't want in this case.
	            renderer.out = function (s) {
	                // The `lit` function adds a string literal to the output buffer.
	                this.lit(s);
	            };
	
	            renderer.paragraph = function (node, entering) {
	                // as with toHTML, only append lines to paragraphs if there are
	                // multiple paragraphs
	                if (is_multi_line(node)) {
	                    if (!entering && node.next) {
	                        this.lit('\n\n');
	                    }
	                }
	            };
	            renderer.html_block = function (node) {
	                this.lit(node.literal);
	                if (is_multi_line(node) && node.next) this.lit('\n\n');
	            };
	
	            return renderer.render(this.parsed);
	        }
	    }]);
	    return Markdown;
	}();
	
	exports.default = Markdown;
	module.exports = exports['default'];


/***/ }),
/* 501 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/** The types of page which can be shown by the LoggedInView */
	exports.default = {
	    HomePage: "home_page",
	    RoomView: "room_view",
	    UserSettings: "user_settings",
	    CreateRoom: "create_room",
	    RoomDirectory: "room_directory",
	    UserView: "user_view"
	};
	module.exports = exports["default"];


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	
	// Time in ms after that a user is considered as unavailable/away
	var UNAVAILABLE_TIME_MS = 3 * 60 * 1000; // 3 mins
	var PRESENCE_STATES = ["online", "offline", "unavailable"];
	
	var Presence = function () {
	    function Presence() {
	        (0, _classCallCheck3.default)(this, Presence);
	    }
	
	    (0, _createClass3.default)(Presence, [{
	        key: "start",
	
	
	        /**
	         * Start listening the user activity to evaluate his presence state.
	         * Any state change will be sent to the Home Server.
	         */
	        value: function start() {
	            this.running = true;
	            if (undefined === this.state) {
	                this._resetTimer();
	                this.dispatcherRef = dis.register(this._onUserActivity.bind(this));
	            }
	        }
	
	        /**
	         * Stop tracking user activity
	         */
	
	    }, {
	        key: "stop",
	        value: function stop() {
	            this.running = false;
	            if (this.timer) {
	                clearInterval(this.timer);
	                this.timer = undefined;
	                dis.unregister(this.dispatcherRef);
	            }
	            this.state = undefined;
	        }
	
	        /**
	         * Get the current presence state.
	         * @returns {string} the presence state (see PRESENCE enum)
	         */
	
	    }, {
	        key: "getState",
	        value: function getState() {
	            return this.state;
	        }
	
	        /**
	         * Set the presence state.
	         * If the state has changed, the Home Server will be notified.
	         * @param {string} newState the new presence state (see PRESENCE enum)
	         */
	
	    }, {
	        key: "setState",
	        value: function setState(newState) {
	            if (newState === this.state) {
	                return;
	            }
	            if (PRESENCE_STATES.indexOf(newState) === -1) {
	                throw new Error("Bad presence state: " + newState);
	            }
	            if (!this.running) {
	                return;
	            }
	            var old_state = this.state;
	            this.state = newState;
	
	            if (MatrixClientPeg.get().isGuest()) {
	                return; // don't try to set presence when a guest; it won't work.
	            }
	
	            var self = this;
	            MatrixClientPeg.get().setPresence(this.state).done(function () {
	                console.log("Presence: %s", newState);
	            }, function (err) {
	                console.error("Failed to set presence: %s", err);
	                self.state = old_state;
	            });
	        }
	
	        /**
	         * Callback called when the user made no action on the page for UNAVAILABLE_TIME ms.
	         * @private
	         */
	
	    }, {
	        key: "_onUnavailableTimerFire",
	        value: function _onUnavailableTimerFire() {
	            this.setState("unavailable");
	        }
	    }, {
	        key: "_onUserActivity",
	        value: function _onUserActivity() {
	            this._resetTimer();
	        }
	
	        /**
	         * Callback called when the user made an action on the page
	         * @private
	         */
	
	    }, {
	        key: "_resetTimer",
	        value: function _resetTimer() {
	            var self = this;
	            this.setState("online");
	            // Re-arm the timer
	            clearTimeout(this.timer);
	            this.timer = setTimeout(function () {
	                self._onUnavailableTimerFire();
	            }, UNAVAILABLE_TIME_MS);
	        }
	    }]);
	    return Presence;
	}();
	
	module.exports = new Presence();


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _maxSafeInteger = __webpack_require__(373);
	
	var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tsOfNewestEvent(room) {
	    if (room.timeline.length) {
	        return room.timeline[room.timeline.length - 1].getTs();
	    } else {
	        return _maxSafeInteger2.default;
	    }
	}
	
	function mostRecentActivityFirst(roomList) {
	    return roomList.sort(function (a, b) {
	        return tsOfNewestEvent(b) - tsOfNewestEvent(a);
	    });
	}
	
	module.exports = {
	    mostRecentActivityFirst: mostRecentActivityFirst
	};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	__webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkStatus(response) {
	    if (!response.ok) {
	        return response.text().then(function (text) {
	            throw new Error(text);
	        });
	    }
	    return response;
	}
	
	function parseJson(response) {
	    return response.json();
	}
	
	function encodeQueryParams(params) {
	    return '?' + (0, _keys2.default)(params).map(function (k) {
	        return k + '=' + encodeURIComponent(params[k]);
	    }).join('&');
	}
	
	var request = function request(url, opts) {
	    if (opts && opts.qs) {
	        url += encodeQueryParams(opts.qs);
	        delete opts.qs;
	    }
	    if (opts && opts.body) {
	        if (!opts.headers) {
	            opts.headers = {};
	        }
	        opts.body = (0, _stringify2.default)(opts.body);
	        opts.headers['Content-Type'] = 'application/json';
	    }
	    return fetch(url, opts).then(checkStatus).then(parseJson);
	};
	
	var RtsClient = function () {
	    function RtsClient(url) {
	        (0, _classCallCheck3.default)(this, RtsClient);
	
	        this._url = url;
	    }
	
	    (0, _createClass3.default)(RtsClient, [{
	        key: 'getTeamsConfig',
	        value: function getTeamsConfig() {
	            return request(this._url + '/teams');
	        }
	
	        /**
	         * Track a referral with the Riot Team Server. This should be called once a referred
	         * user has been successfully registered.
	         * @param {string} referrer the user ID of one who referred the user to Riot.
	         * @param {string} sid the sign-up identity server session ID .
	         * @param {string} clientSecret the sign-up client secret.
	         * @returns {Promise} a promise that resolves to { team_token: 'sometoken' } upon
	         * success.
	         */
	
	    }, {
	        key: 'trackReferral',
	        value: function trackReferral(referrer, sid, clientSecret) {
	            return request(this._url + '/register', {
	                body: {
	                    referrer: referrer,
	                    session_id: sid,
	                    client_secret: clientSecret
	                },
	                method: 'POST'
	            });
	        }
	    }, {
	        key: 'getTeam',
	        value: function getTeam(teamToken) {
	            return request(this._url + '/teamConfiguration', {
	                qs: {
	                    team_token: teamToken
	                }
	            });
	        }
	
	        /**
	         * Signal to the RTS that a login has occurred and that a user requires their team's
	         * token.
	         * @param {string} userId the user ID of the user who is a member of a team.
	         * @returns {Promise} a promise that resolves to { team_token: 'sometoken' } upon
	         * success.
	         */
	
	    }, {
	        key: 'login',
	        value: function login(userId) {
	            return request(this._url + '/login', {
	                qs: {
	                    user_id: userId
	                }
	            });
	        }
	    }]);
	    return RtsClient;
	}();
	
	exports.default = RtsClient;
	module.exports = exports['default'];


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var q = __webpack_require__(6);
	var request = __webpack_require__(97);
	
	var SdkConfig = __webpack_require__(118);
	var MatrixClientPeg = __webpack_require__(4);
	
	var ScalarAuthClient = function () {
	    function ScalarAuthClient() {
	        (0, _classCallCheck3.default)(this, ScalarAuthClient);
	
	        this.scalarToken = null;
	    }
	
	    (0, _createClass3.default)(ScalarAuthClient, [{
	        key: 'connect',
	        value: function connect() {
	            var _this = this;
	
	            return this.getScalarToken().then(function (tok) {
	                _this.scalarToken = tok;
	            });
	        }
	    }, {
	        key: 'hasCredentials',
	        value: function hasCredentials() {
	            return this.scalarToken != null; // undef or null
	        }
	
	        // Returns a scalar_token string
	
	    }, {
	        key: 'getScalarToken',
	        value: function getScalarToken() {
	            var _this2 = this;
	
	            var tok = window.localStorage.getItem("mx_scalar_token");
	            if (tok) return q(tok);
	
	            // No saved token, so do the dance to get one. First, we
	            // need an openid bearer token from the HS.
	            return MatrixClientPeg.get().getOpenIdToken().then(function (token_object) {
	                // Now we can send that to scalar and exchange it for a scalar token
	                return _this2.exchangeForScalarToken(token_object);
	            }).then(function (token_object) {
	                window.localStorage.setItem("mx_scalar_token", token_object);
	                return token_object;
	            });
	        }
	    }, {
	        key: 'exchangeForScalarToken',
	        value: function exchangeForScalarToken(openid_token_object) {
	            var defer = q.defer();
	
	            var scalar_rest_url = SdkConfig.get().integrations_rest_url;
	            request({
	                method: 'POST',
	                uri: scalar_rest_url + '/register',
	                body: openid_token_object,
	                json: true
	            }, function (err, response, body) {
	                if (err) {
	                    defer.reject(err);
	                } else if (response.statusCode / 100 !== 2) {
	                    defer.reject({ statusCode: response.statusCode });
	                } else if (!body || !body.scalar_token) {
	                    defer.reject(new Error("Missing scalar_token in response"));
	                } else {
	                    defer.resolve(body.scalar_token);
	                }
	            });
	
	            return defer.promise;
	        }
	    }, {
	        key: 'getScalarInterfaceUrlForRoom',
	        value: function getScalarInterfaceUrlForRoom(roomId) {
	            var url = SdkConfig.get().integrations_ui_url;
	            url += "?scalar_token=" + encodeURIComponent(this.scalarToken);
	            url += "&room_id=" + encodeURIComponent(roomId);
	            return url;
	        }
	    }, {
	        key: 'getStarterLink',
	        value: function getStarterLink(starterLinkUrl) {
	            return starterLinkUrl + "?scalar_token=" + encodeURIComponent(this.scalarToken);
	        }
	    }]);
	    return ScalarAuthClient;
	}();
	
	module.exports = ScalarAuthClient;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.field_input_incorrect = field_input_incorrect;
	
	var _velocityVector = __webpack_require__(233);
	
	var _velocityVector2 = _interopRequireDefault(_velocityVector);
	
	__webpack_require__(1534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * Functions for applying common thematic effects to  UI elements.
	 * Ideally this would be themeable.
	 */
	
	function field_input_incorrect(element) {
	    (0, _velocityVector2.default)(element, "callout.shake", 300);
	}


/***/ }),
/* 507 */,
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AutocompleteProvider2 = __webpack_require__(171);
	
	var _AutocompleteProvider3 = _interopRequireDefault(_AutocompleteProvider2);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _fuse = __webpack_require__(165);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	var _Components = __webpack_require__(172);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USER_REGEX = /@\S*/g;
	
	var instance = null;
	
	var UserProvider = function (_AutocompleteProvider) {
	    (0, _inherits3.default)(UserProvider, _AutocompleteProvider);
	
	    function UserProvider() {
	        (0, _classCallCheck3.default)(this, UserProvider);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UserProvider.__proto__ || (0, _getPrototypeOf2.default)(UserProvider)).call(this, USER_REGEX, {
	            keys: ['name', 'userId']
	        }));
	
	        _this.users = [];
	        _this.fuse = new _fuse2.default([], {
	            keys: ['name', 'userId']
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(UserProvider, [{
	        key: 'getCompletions',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, selection) {
	                var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	                var MemberAvatar, completions, _getCurrentCommand, command, range;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                MemberAvatar = _index2.default.getComponent('views.avatars.MemberAvatar');
	                                completions = [];
	                                _getCurrentCommand = this.getCurrentCommand(query, selection, force), command = _getCurrentCommand.command, range = _getCurrentCommand.range;
	
	                                if (command) {
	                                    this.fuse.set(this.users);
	                                    completions = this.fuse.search(command[0]).map(function (user) {
	                                        var displayName = (user.name || user.userId || '').replace(' (IRC)', ''); // FIXME when groups are done
	                                        var completion = displayName;
	                                        if (range.start === 0) {
	                                            completion += ': ';
	                                        } else {
	                                            completion += ' ';
	                                        }
	                                        return {
	                                            completion: completion,
	                                            component: _react2.default.createElement(_Components.PillCompletion, {
	                                                initialComponent: _react2.default.createElement(MemberAvatar, { member: user, width: 24, height: 24 }),
	                                                title: displayName,
	                                                description: user.userId }),
	                                            range: range
	                                        };
	                                    }).slice(0, 4);
	                                }
	                                return _context.abrupt('return', completions);
	
	                            case 5:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getCompletions(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return getCompletions;
	        }()
	    }, {
	        key: 'getName',
	        value: function getName() {
	            return '👥 Users';
	        }
	    }, {
	        key: 'setUserList',
	        value: function setUserList(users) {
	            this.users = users;
	        }
	    }, {
	        key: 'renderCompletions',
	        value: function renderCompletions(completions) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_Autocomplete_Completion_container_pill' },
	                completions
	            );
	        }
	    }, {
	        key: 'shouldForceComplete',
	        value: function shouldForceComplete() {
	            return true;
	        }
	    }], [{
	        key: 'getInstance',
	        value: function getInstance() {
	            if (instance == null) {
	                instance = new UserProvider();
	            }
	            return instance;
	        }
	    }]);
	    return UserProvider;
	}(_AutocompleteProvider3.default);
	
	exports.default = UserProvider;
	module.exports = exports['default'];


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var React = __webpack_require__(1);
	var classNames = __webpack_require__(27);
	var sdk = __webpack_require__(2);
	var Invite = __webpack_require__(220);
	var MatrixClientPeg = __webpack_require__(4);
	var Avatar = __webpack_require__(138);
	
	// React PropType definition for an object describing
	// an address that can be invited to a room (which
	// could be a third party identifier or a matrix ID)
	// along with some additional information about the
	// address / target.
	var InviteAddressType = exports.InviteAddressType = React.PropTypes.shape({
	    addressType: React.PropTypes.oneOf(['mx', 'email']).isRequired,
	    address: React.PropTypes.string.isRequired,
	    displayName: React.PropTypes.string,
	    avatarMxc: React.PropTypes.string,
	    // true if the address is known to be a valid address (eg. is a real
	    // user we've seen) or false otherwise (eg. is just an address the
	    // user has entered)
	    isKnown: React.PropTypes.bool
	});
	
	exports.default = React.createClass({
	    displayName: 'AddressTile',
	
	    propTypes: {
	        address: InviteAddressType.isRequired,
	        canDismiss: React.PropTypes.bool,
	        onDismissed: React.PropTypes.func,
	        justified: React.PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            canDismiss: false,
	            onDismissed: function onDismissed() {}, // NOP
	            justified: false
	        };
	    },
	
	    render: function render() {
	        var address = this.props.address;
	        var name = address.displayName || address.address;
	
	        var imgUrls = [];
	
	        if (address.addressType === "mx" && address.avatarMxc) {
	            imgUrls.push(MatrixClientPeg.get().mxcUrlToHttp(address.avatarMxc, 25, 25, 'crop'));
	        } else if (address.addressType === 'email') {
	            imgUrls.push('img/icon-email-user.svg');
	        }
	
	        // Removing networks for now as they're not really supported
	        /*
	        var network;
	        if (this.props.networkUrl !== "") {
	            network = (
	                <div className="mx_AddressTile_network">
	                    <BaseAvatar width={25} height={25} name={this.props.networkName} title="Riot" url={this.props.networkUrl} />
	                </div>
	            );
	        }
	        */
	
	        var BaseAvatar = sdk.getComponent('avatars.BaseAvatar');
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	
	        var nameClasses = classNames({
	            "mx_AddressTile_name": true,
	            "mx_AddressTile_justified": this.props.justified
	        });
	
	        var info = void 0;
	        var error = false;
	        if (address.addressType === "mx" && address.isKnown) {
	            var idClasses = classNames({
	                "mx_AddressTile_id": true,
	                "mx_AddressTile_justified": this.props.justified
	            });
	
	            info = React.createElement(
	                'div',
	                { className: 'mx_AddressTile_mx' },
	                React.createElement(
	                    'div',
	                    { className: nameClasses },
	                    name
	                ),
	                React.createElement(
	                    'div',
	                    { className: idClasses },
	                    address.address
	                )
	            );
	        } else if (address.addressType === "mx") {
	            var unknownMxClasses = classNames({
	                "mx_AddressTile_unknownMx": true,
	                "mx_AddressTile_justified": this.props.justified
	            });
	
	            info = React.createElement(
	                'div',
	                { className: unknownMxClasses },
	                this.props.address.address
	            );
	        } else if (address.addressType === "email") {
	            var emailClasses = classNames({
	                "mx_AddressTile_email": true,
	                "mx_AddressTile_justified": this.props.justified
	            });
	
	            var nameNode = null;
	            if (address.displayName) {
	                nameNode = React.createElement(
	                    'div',
	                    { className: nameClasses },
	                    address.displayName
	                );
	            }
	
	            info = React.createElement(
	                'div',
	                { className: 'mx_AddressTile_mx' },
	                React.createElement(
	                    'div',
	                    { className: emailClasses },
	                    address.address
	                ),
	                nameNode
	            );
	        } else {
	            error = true;
	            var unknownClasses = classNames({
	                "mx_AddressTile_unknown": true,
	                "mx_AddressTile_justified": this.props.justified
	            });
	
	            info = React.createElement(
	                'div',
	                { className: unknownClasses },
	                'Unknown Address'
	            );
	        }
	
	        var classes = classNames({
	            "mx_AddressTile": true,
	            "mx_AddressTile_error": error
	        });
	
	        var dismiss = void 0;
	        if (this.props.canDismiss) {
	            dismiss = React.createElement(
	                'div',
	                { className: 'mx_AddressTile_dismiss', onClick: this.props.onDismissed },
	                React.createElement(TintableSvg, { src: 'img/icon-address-delete.svg', width: '9', height: '9' })
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: classes },
	            React.createElement(
	                'div',
	                { className: 'mx_AddressTile_avatar' },
	                React.createElement(BaseAvatar, { defaultToInitialLetter: true, width: 25, height: 25, name: name, title: name, urls: imgUrls })
	            ),
	            info,
	            dismiss
	        );
	    }
	});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var DIV_ID = 'mx_recaptcha';
	
	/**
	 * A pure UI component which displays a captcha form.
	 */
	module.exports = React.createClass({
	    displayName: 'CaptchaForm',
	
	    propTypes: {
	        sitePublicKey: React.PropTypes.string,
	
	        // called with the captcha response
	        onCaptchaResponse: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onCaptchaResponse: function onCaptchaResponse() {}
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            errorText: null
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        // Just putting a script tag into the returned jsx doesn't work, annoyingly,
	        // so we do this instead.
	        if (global.grecaptcha) {
	            // already loaded
	            this._onCaptchaLoaded();
	        } else {
	            console.log("Loading recaptcha script...");
	            window.mx_on_recaptcha_loaded = function () {
	                _this._onCaptchaLoaded();
	            };
	            var protocol = global.location.protocol;
	            if (protocol === "file:") {
	                var warning = document.createElement('div');
	                // XXX: fix hardcoded app URL.  Better solutions include:
	                // * jumping straight to a hosted captcha page (but we don't support that yet)
	                // * embedding the captcha in an iframe (if that works)
	                // * using a better captcha lib
	                warning.innerHTML = "Robot check is currently unavailable on desktop - please use a <a href='https://riot.im/app'>web browser</a>.";
	                this.refs.recaptchaContainer.appendChild(warning);
	            } else {
	                var scriptTag = document.createElement('script');
	                scriptTag.setAttribute('src', protocol + "//www.google.com/recaptcha/api.js?onload=mx_on_recaptcha_loaded&render=explicit");
	                this.refs.recaptchaContainer.appendChild(scriptTag);
	            }
	        }
	    },
	
	    _renderRecaptcha: function _renderRecaptcha(divId) {
	        if (!global.grecaptcha) {
	            console.error("grecaptcha not loaded!");
	            throw new Error("Recaptcha did not load successfully");
	        }
	
	        var publicKey = this.props.sitePublicKey;
	        if (!publicKey) {
	            console.error("No public key for recaptcha!");
	            throw new Error("This server has not supplied enough information for Recaptcha " + "authentication");
	        }
	
	        console.log("Rendering to %s", divId);
	        global.grecaptcha.render(divId, {
	            sitekey: publicKey,
	            callback: this.props.onCaptchaResponse
	        });
	    },
	
	    _onCaptchaLoaded: function _onCaptchaLoaded() {
	        console.log("Loaded recaptcha script.");
	        try {
	            this._renderRecaptcha(DIV_ID);
	        } catch (e) {
	            this.setState({
	                errorText: e.toString()
	            });
	        }
	    },
	
	    render: function render() {
	        var error = null;
	        if (this.state.errorText) {
	            error = React.createElement(
	                'div',
	                { className: 'error' },
	                this.state.errorText
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { ref: 'recaptchaContainer' },
	            'This Home Server would like to make sure you are not a robot',
	            React.createElement('br', null),
	            React.createElement('div', { id: DIV_ID }),
	            error
	        );
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'CasLogin',
	
	    propTypes: {
	        onSubmit: React.PropTypes.func },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'button',
	                { onClick: this.props.onSubmit },
	                'Sign in with CAS'
	            )
	        );
	    }
	
	});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FallbackAuthEntry = exports.MsisdnAuthEntry = exports.EmailIdentityAuthEntry = exports.RecaptchaAuthEntry = exports.PasswordAuthEntry = undefined;
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _defineProperty2 = __webpack_require__(179);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getEntryComponentForLoginType = getEntryComponentForLoginType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _url = __webpack_require__(149);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* This file contains a collection of components which are used by the
	 * InteractiveAuth to prompt the user to enter the information needed
	 * for an auth stage. (The intention is that they could also be used for other
	 * components, such as the registration flow).
	 *
	 * Call getEntryComponentForLoginType() to get a component suitable for a
	 * particular login type. Each component requires the same properties:
	 *
	 * matrixClient:           A matrix client. May be a different one to the one
	 *                         currently being used generally (eg. to register with
	 *                         one HS whilst beign a guest on another).
	 * loginType:              the login type of the auth stage being attempted
	 * authSessionId:          session id from the server
	 * clientSecret:           The client secret in use for ID server auth sessions
	 * stageParams:            params from the server for the stage being attempted
	 * errorText:              error message from a previous attempt to authenticate
	 * submitAuthDict:         a function which will be called with the new auth dict
	 * busy:                   a boolean indicating whether the auth logic is doing something
	 *                         the user needs to wait for.
	 * inputs:                 Object of inputs provided by the user, as in js-sdk
	 *                         interactive-auth
	 * stageState:             Stage-specific object used for communicating state information
	 *                         to the UI from the state-specific auth logic.
	 *                         Defined keys for stages are:
	 *                             m.login.email.identity:
	 *                              * emailSid: string representing the sid of the active
	 *                                          verification session from the ID server, or
	 *                                          null if no session is active.
	 * fail:                   a function which should be called with an error object if an
	 *                         error occurred during the auth stage. This will cause the auth
	 *                         session to be failed and the process to go back to the start.
	 * setEmailSid:            m.login.email.identity only: a function to be called with the
	 *                         email sid after a token is requested.
	 * makeRegistrationUrl     A function that makes a registration URL
	 *
	 * Each component may also provide the following functions (beyond the standard React ones):
	 *    focus: set the input focus appropriately in the form.
	 */
	
	/*
	Copyright 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var PasswordAuthEntry = exports.PasswordAuthEntry = _react2.default.createClass({
	    displayName: 'PasswordAuthEntry',
	
	    statics: {
	        LOGIN_TYPE: "m.login.password"
	    },
	
	    propTypes: {
	        matrixClient: _react2.default.PropTypes.object.isRequired,
	        submitAuthDict: _react2.default.PropTypes.func.isRequired,
	        errorText: _react2.default.PropTypes.string,
	        // is the auth logic currently waiting for something to
	        // happen?
	        busy: _react2.default.PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            passwordValid: false
	        };
	    },
	
	    focus: function focus() {
	        if (this.refs.passwordField) {
	            this.refs.passwordField.focus();
	        }
	    },
	
	    _onSubmit: function _onSubmit(e) {
	        e.preventDefault();
	        if (this.props.busy) return;
	
	        this.props.submitAuthDict({
	            type: PasswordAuthEntry.LOGIN_TYPE,
	            user: this.props.matrixClient.credentials.userId,
	            password: this.refs.passwordField.value
	        });
	    },
	
	    _onPasswordFieldChange: function _onPasswordFieldChange(ev) {
	        // enable the submit button iff the password is non-empty
	        this.setState({
	            passwordValid: Boolean(this.refs.passwordField.value)
	        });
	    },
	
	    render: function render() {
	        var passwordBoxClass = null;
	
	        if (this.props.errorText) {
	            passwordBoxClass = 'error';
	        }
	
	        var submitButtonOrSpinner = void 0;
	        if (this.props.busy) {
	            var Loader = _index2.default.getComponent("elements.Spinner");
	            submitButtonOrSpinner = _react2.default.createElement(Loader, null);
	        } else {
	            submitButtonOrSpinner = _react2.default.createElement('input', { type: 'submit',
	                className: 'mx_Dialog_primary',
	                disabled: !this.state.passwordValid
	            });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'To continue, please enter your password.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Password:'
	            ),
	            _react2.default.createElement(
	                'form',
	                { onSubmit: this._onSubmit },
	                _react2.default.createElement('input', {
	                    ref: 'passwordField',
	                    className: passwordBoxClass,
	                    onChange: this._onPasswordFieldChange,
	                    type: 'password'
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_button_row' },
	                    submitButtonOrSpinner
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'error' },
	                this.props.errorText
	            )
	        );
	    }
	});
	
	var RecaptchaAuthEntry = exports.RecaptchaAuthEntry = _react2.default.createClass({
	    displayName: 'RecaptchaAuthEntry',
	
	    statics: {
	        LOGIN_TYPE: "m.login.recaptcha"
	    },
	
	    propTypes: {
	        submitAuthDict: _react2.default.PropTypes.func.isRequired,
	        stageParams: _react2.default.PropTypes.object.isRequired,
	        errorText: _react2.default.PropTypes.string,
	        busy: _react2.default.PropTypes.bool
	    },
	
	    _onCaptchaResponse: function _onCaptchaResponse(response) {
	        this.props.submitAuthDict({
	            type: RecaptchaAuthEntry.LOGIN_TYPE,
	            response: response
	        });
	    },
	
	    render: function render() {
	        if (this.props.busy) {
	            var Loader = _index2.default.getComponent("elements.Spinner");
	            return _react2.default.createElement(Loader, null);
	        }
	
	        var CaptchaForm = _index2.default.getComponent("views.login.CaptchaForm");
	        var sitePublicKey = this.props.stageParams.public_key;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(CaptchaForm, { sitePublicKey: sitePublicKey,
	                onCaptchaResponse: this._onCaptchaResponse
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: 'error' },
	                this.props.errorText
	            )
	        );
	    }
	});
	
	var EmailIdentityAuthEntry = exports.EmailIdentityAuthEntry = _react2.default.createClass({
	    displayName: 'EmailIdentityAuthEntry',
	
	    statics: {
	        LOGIN_TYPE: "m.login.email.identity"
	    },
	
	    propTypes: {
	        matrixClient: _react2.default.PropTypes.object.isRequired,
	        submitAuthDict: _react2.default.PropTypes.func.isRequired,
	        authSessionId: _react2.default.PropTypes.string.isRequired,
	        clientSecret: _react2.default.PropTypes.string.isRequired,
	        inputs: _react2.default.PropTypes.object.isRequired,
	        stageState: _react2.default.PropTypes.object.isRequired,
	        fail: _react2.default.PropTypes.func.isRequired,
	        setEmailSid: _react2.default.PropTypes.func.isRequired,
	        makeRegistrationUrl: _react2.default.PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            requestingToken: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        if (this.props.stageState.emailSid === null) {
	            this.setState({ requestingToken: true });
	            this._requestEmailToken().catch(function (e) {
	                _this.props.fail(e);
	            }).finally(function () {
	                _this.setState({ requestingToken: false });
	            }).done();
	        }
	    },
	
	    /*
	     * Requests a verification token by email.
	     */
	    _requestEmailToken: function _requestEmailToken() {
	        var _this2 = this;
	
	        var nextLink = this.props.makeRegistrationUrl({
	            client_secret: this.props.clientSecret,
	            hs_url: this.props.matrixClient.getHomeserverUrl(),
	            is_url: this.props.matrixClient.getIdentityServerUrl(),
	            session_id: this.props.authSessionId
	        });
	
	        return this.props.matrixClient.requestRegisterEmailToken(this.props.inputs.emailAddress, this.props.clientSecret, 1, // TODO: Multiple send attempts?
	        nextLink).then(function (result) {
	            _this2.props.setEmailSid(result.sid);
	        });
	    },
	
	    render: function render() {
	        if (this.state.requestingToken) {
	            var Loader = _index2.default.getComponent("elements.Spinner");
	            return _react2.default.createElement(Loader, null);
	        } else {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'An email has been sent to ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        this.props.inputs.emailAddress
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Please check your email to continue registration.'
	                )
	            );
	        }
	    }
	});
	
	var MsisdnAuthEntry = exports.MsisdnAuthEntry = _react2.default.createClass({
	    displayName: 'MsisdnAuthEntry',
	
	    statics: {
	        LOGIN_TYPE: "m.login.msisdn"
	    },
	
	    propTypes: (0, _defineProperty3.default)({
	        inputs: _react2.default.PropTypes.shape({
	            phoneCountry: _react2.default.PropTypes.string,
	            phoneNumber: _react2.default.PropTypes.string
	        }),
	        fail: _react2.default.PropTypes.func,
	        clientSecret: _react2.default.PropTypes.func,
	        submitAuthDict: _react2.default.PropTypes.func.isRequired,
	        matrixClient: _react2.default.PropTypes.object
	    }, 'submitAuthDict', _react2.default.PropTypes.func),
	
	    getInitialState: function getInitialState() {
	        return {
	            token: '',
	            requestingToken: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this3 = this;
	
	        this._sid = null;
	        this._msisdn = null;
	        this._tokenBox = null;
	
	        this.setState({ requestingToken: true });
	        this._requestMsisdnToken().catch(function (e) {
	            _this3.props.fail(e);
	        }).finally(function () {
	            _this3.setState({ requestingToken: false });
	        }).done();
	    },
	
	    /*
	     * Requests a verification token by SMS.
	     */
	    _requestMsisdnToken: function _requestMsisdnToken() {
	        var _this4 = this;
	
	        return this.props.matrixClient.requestRegisterMsisdnToken(this.props.inputs.phoneCountry, this.props.inputs.phoneNumber, this.props.clientSecret, 1).then(function (result) {
	            _this4._sid = result.sid;
	            _this4._msisdn = result.msisdn;
	        });
	    },
	
	    _onTokenChange: function _onTokenChange(e) {
	        this.setState({
	            token: e.target.value
	        });
	    },
	
	    _onFormSubmit: function _onFormSubmit(e) {
	        var _this5 = this;
	
	        e.preventDefault();
	        if (this.state.token == '') return;
	
	        this.setState({
	            errorText: null
	        });
	
	        this.props.matrixClient.submitMsisdnToken(this._sid, this.props.clientSecret, this.state.token).then(function (result) {
	            if (result.success) {
	                var idServerParsedUrl = _url2.default.parse(_this5.props.matrixClient.getIdentityServerUrl());
	                _this5.props.submitAuthDict({
	                    type: MsisdnAuthEntry.LOGIN_TYPE,
	                    threepid_creds: {
	                        sid: _this5._sid,
	                        client_secret: _this5.props.clientSecret,
	                        id_server: idServerParsedUrl.host
	                    }
	                });
	            } else {
	                _this5.setState({
	                    errorText: "Token incorrect"
	                });
	            }
	        }).catch(function (e) {
	            _this5.props.fail(e);
	            console.log("Failed to submit msisdn token");
	        }).done();
	    },
	
	    render: function render() {
	        if (this.state.requestingToken) {
	            var Loader = _index2.default.getComponent("elements.Spinner");
	            return _react2.default.createElement(Loader, null);
	        } else {
	            var enableSubmit = Boolean(this.state.token);
	            var submitClasses = (0, _classnames2.default)({
	                mx_InteractiveAuthEntryComponents_msisdnSubmit: true,
	                mx_UserSettings_button: true });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'A text message has been sent to +',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        this._msisdn
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Please enter the code it contains:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_InteractiveAuthEntryComponents_msisdnWrapper' },
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: this._onFormSubmit },
	                        _react2.default.createElement('input', { type: 'text',
	                            className: 'mx_InteractiveAuthEntryComponents_msisdnEntry',
	                            value: this.state.token,
	                            onChange: this._onTokenChange
	                        }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('input', { type: 'submit', value: 'Submit',
	                            className: submitClasses,
	                            disabled: !enableSubmit
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'error' },
	                        this.state.errorText
	                    )
	                )
	            );
	        }
	    }
	});
	
	var FallbackAuthEntry = exports.FallbackAuthEntry = _react2.default.createClass({
	    displayName: 'FallbackAuthEntry',
	
	    propTypes: {
	        matrixClient: _react2.default.PropTypes.object.isRequired,
	        authSessionId: _react2.default.PropTypes.string.isRequired,
	        loginType: _react2.default.PropTypes.string.isRequired,
	        submitAuthDict: _react2.default.PropTypes.func.isRequired,
	        errorText: _react2.default.PropTypes.string
	    },
	
	    componentWillMount: function componentWillMount() {
	        // we have to make the user click a button, as browsers will block
	        // the popup if we open it immediately.
	        this._popupWindow = null;
	        window.addEventListener("message", this._onReceiveMessage);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        window.removeEventListener("message", this._onReceiveMessage);
	        if (this._popupWindow) {
	            this._popupWindow.close();
	        }
	    },
	
	    _onShowFallbackClick: function _onShowFallbackClick() {
	        var url = this.props.matrixClient.getFallbackAuthUrl(this.props.loginType, this.props.authSessionId);
	        this._popupWindow = window.open(url);
	    },
	
	    _onReceiveMessage: function _onReceiveMessage(event) {
	        if (event.data === "authDone" && event.origin === this.props.matrixClient.getHomeserverUrl()) {
	            this.props.submitAuthDict({});
	        }
	    },
	
	    render: function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'a',
	                { onClick: this._onShowFallbackClick },
	                'Start authentication'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'error' },
	                this.props.errorText
	            )
	        );
	    }
	});
	
	var AuthEntryComponents = [PasswordAuthEntry, RecaptchaAuthEntry, EmailIdentityAuthEntry, MsisdnAuthEntry];
	
	function getEntryComponentForLoginType(loginType) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)(AuthEntryComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var c = _step.value;
	
	            if (c.LOGIN_TYPE == loginType) {
	                return c;
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return FallbackAuthEntry;
	}


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(18);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _UiEffects = __webpack_require__(506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A pure UI component which displays a username/password form.
	 */
	module.exports = _react2.default.createClass({ displayName: 'PasswordLogin',
	    propTypes: {
	        onSubmit: _react2.default.PropTypes.func.isRequired, // fn(username, password)
	        onForgotPasswordClick: _react2.default.PropTypes.func, // fn()
	        initialUsername: _react2.default.PropTypes.string,
	        initialPhoneCountry: _react2.default.PropTypes.string,
	        initialPhoneNumber: _react2.default.PropTypes.string,
	        initialPassword: _react2.default.PropTypes.string,
	        onUsernameChanged: _react2.default.PropTypes.func,
	        onPhoneCountryChanged: _react2.default.PropTypes.func,
	        onPhoneNumberChanged: _react2.default.PropTypes.func,
	        onPasswordChanged: _react2.default.PropTypes.func,
	        loginIncorrect: _react2.default.PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onUsernameChanged: function onUsernameChanged() {},
	            onPasswordChanged: function onPasswordChanged() {},
	            onPhoneCountryChanged: function onPhoneCountryChanged() {},
	            onPhoneNumberChanged: function onPhoneNumberChanged() {},
	            initialUsername: "",
	            initialPhoneCountry: "",
	            initialPhoneNumber: "",
	            initialPassword: "",
	            loginIncorrect: false
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            username: this.props.initialUsername,
	            password: this.props.initialPassword,
	            phoneCountry: this.props.initialPhoneCountry,
	            phoneNumber: this.props.initialPhoneNumber
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this._passwordField = null;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (!this.props.loginIncorrect && nextProps.loginIncorrect) {
	            (0, _UiEffects.field_input_incorrect)(this._passwordField);
	        }
	    },
	
	    onSubmitForm: function onSubmitForm(ev) {
	        ev.preventDefault();
	        this.props.onSubmit(this.state.username, this.state.phoneCountry, this.state.phoneNumber, this.state.password);
	    },
	
	    onUsernameChanged: function onUsernameChanged(ev) {
	        this.setState({ username: ev.target.value });
	        this.props.onUsernameChanged(ev.target.value);
	    },
	
	    onPhoneCountryChanged: function onPhoneCountryChanged(country) {
	        this.setState({ phoneCountry: country });
	        this.props.onPhoneCountryChanged(country);
	    },
	
	    onPhoneNumberChanged: function onPhoneNumberChanged(ev) {
	        this.setState({ phoneNumber: ev.target.value });
	        this.props.onPhoneNumberChanged(ev.target.value);
	    },
	
	    onPasswordChanged: function onPasswordChanged(ev) {
	        this.setState({ password: ev.target.value });
	        this.props.onPasswordChanged(ev.target.value);
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var forgotPasswordJsx;
	
	        if (this.props.onForgotPasswordClick) {
	            forgotPasswordJsx = _react2.default.createElement(
	                'a',
	                { className: 'mx_Login_forgot', onClick: this.props.onForgotPasswordClick, href: '#' },
	                'Forgot your password?'
	            );
	        }
	
	        var pwFieldClass = (0, _classnames2.default)({
	            mx_Login_field: true,
	            error: this.props.loginIncorrect
	        });
	
	        var CountryDropdown = _index2.default.getComponent('views.login.CountryDropdown');
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'form',
	                { onSubmit: this.onSubmitForm },
	                _react2.default.createElement('input', { className: 'mx_Login_field mx_Login_username', type: 'text',
	                    name: 'username' // make it a little easier for browser's remember-password
	                    , value: this.state.username, onChange: this.onUsernameChanged,
	                    placeholder: 'Email or user name', autoFocus: true }),
	                'or',
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Login_phoneSection' },
	                    _react2.default.createElement(CountryDropdown, { ref: 'phone_country', onOptionChange: this.onPhoneCountryChanged,
	                        className: 'mx_Login_phoneCountry',
	                        value: this.state.phoneCountry
	                    }),
	                    _react2.default.createElement('input', { type: 'text', ref: 'phoneNumber',
	                        onChange: this.onPhoneNumberChanged,
	                        placeholder: 'Mobile phone number',
	                        className: 'mx_Login_phoneNumberField mx_Login_field',
	                        value: this.state.phoneNumber,
	                        name: 'phoneNumber'
	                    })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { className: pwFieldClass, ref: function ref(e) {
	                        _this._passwordField = e;
	                    }, type: 'password',
	                    name: 'password',
	                    value: this.state.password, onChange: this.onPasswordChanged,
	                    placeholder: 'Password' }),
	                _react2.default.createElement('br', null),
	                forgotPasswordJsx,
	                _react2.default.createElement('input', { className: 'mx_Login_submit', type: 'submit', value: 'Sign in' })
	            )
	        );
	    }
	}); /*
	    Copyright 2015, 2016 OpenMarket Ltd
	    Copyright 2017 Vector Creations Ltd
	    
	    Licensed under the Apache License, Version 2.0 (the "License");
	    you may not use this file except in compliance with the License.
	    You may obtain a copy of the License at
	    
	        http://www.apache.org/licenses/LICENSE-2.0
	    
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    See the License for the specific language governing permissions and
	    limitations under the License.
	    */


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UiEffects = __webpack_require__(506);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _email = __webpack_require__(518);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _phonenumber = __webpack_require__(519);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var FIELD_EMAIL = 'field_email';
	var FIELD_PHONE_COUNTRY = 'field_phone_country';
	var FIELD_PHONE_NUMBER = 'field_phone_number';
	var FIELD_USERNAME = 'field_username';
	var FIELD_PASSWORD = 'field_password';
	var FIELD_PASSWORD_CONFIRM = 'field_password_confirm';
	
	/**
	 * A pure UI component which displays a registration form.
	 */
	module.exports = _react2.default.createClass({
	    displayName: 'RegistrationForm',
	
	    propTypes: {
	        // Values pre-filled in the input boxes when the component loads
	        defaultEmail: _react2.default.PropTypes.string,
	        defaultPhoneCountry: _react2.default.PropTypes.string,
	        defaultPhoneNumber: _react2.default.PropTypes.string,
	        defaultUsername: _react2.default.PropTypes.string,
	        defaultPassword: _react2.default.PropTypes.string,
	        teamsConfig: _react2.default.PropTypes.shape({
	            // Email address to request new teams
	            supportEmail: _react2.default.PropTypes.string,
	            teams: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	                // The displayed name of the team
	                "name": _react2.default.PropTypes.string,
	                // The domain of team email addresses
	                "domain": _react2.default.PropTypes.string
	            })).required
	        }),
	
	        // A username that will be used if no username is entered.
	        // Specifying this param will also warn the user that entering
	        // a different username will cause a fresh account to be generated.
	        guestUsername: _react2.default.PropTypes.string,
	
	        minPasswordLength: _react2.default.PropTypes.number,
	        onError: _react2.default.PropTypes.func,
	        onRegisterClick: _react2.default.PropTypes.func.isRequired },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            minPasswordLength: 6,
	            onError: function onError(e) {
	                console.error(e);
	            }
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            fieldValid: {},
	            selectedTeam: null,
	            // The ISO2 country code selected in the phone number entry
	            phoneCountry: this.props.defaultPhoneCountry
	        };
	    },
	
	    onSubmit: function onSubmit(ev) {
	        ev.preventDefault();
	
	        // validate everything, in reverse order so
	        // the error that ends up being displayed
	        // is the one from the first invalid field.
	        // It's not super ideal that this just calls
	        // onError once for each invalid field.
	        this.validateField(FIELD_PASSWORD_CONFIRM);
	        this.validateField(FIELD_PASSWORD);
	        this.validateField(FIELD_USERNAME);
	        this.validateField(FIELD_PHONE_NUMBER);
	        this.validateField(FIELD_EMAIL);
	
	        var self = this;
	        if (this.allFieldsValid()) {
	            if (this.refs.email.value == '') {
	                var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
	                _Modal2.default.createDialog(QuestionDialog, {
	                    title: "Warning",
	                    description: _react2.default.createElement(
	                        'div',
	                        null,
	                        'If you don\'t specify an email address, you won\'t be able to reset your password.',
	                        _react2.default.createElement('br', null),
	                        'Are you sure?'
	                    ),
	                    button: "Continue",
	                    onFinished: function onFinished(confirmed) {
	                        if (confirmed) {
	                            self._doSubmit();
	                        }
	                    }
	                });
	            } else {
	                self._doSubmit();
	            }
	        }
	    },
	
	    _doSubmit: function _doSubmit() {
	        var email = this.refs.email.value.trim();
	        var promise = this.props.onRegisterClick({
	            username: this.refs.username.value.trim() || this.props.guestUsername,
	            password: this.refs.password.value.trim(),
	            email: email,
	            phoneCountry: this.state.phoneCountry,
	            phoneNumber: this.refs.phoneNumber.value.trim()
	        });
	
	        if (promise) {
	            ev.target.disabled = true;
	            promise.finally(function () {
	                ev.target.disabled = false;
	            });
	        }
	    },
	
	    /**
	     * Returns true if all fields were valid last time
	     * they were validated.
	     */
	    allFieldsValid: function allFieldsValid() {
	        var keys = (0, _keys2.default)(this.state.fieldValid);
	        for (var i = 0; i < keys.length; ++i) {
	            if (this.state.fieldValid[keys[i]] == false) {
	                return false;
	            }
	        }
	        return true;
	    },
	
	    _isUniEmail: function _isUniEmail(email) {
	        return email.endsWith('.ac.uk') || email.endsWith('.edu') || email.endsWith('matrix.org');
	    },
	
	    validateField: function validateField(field_id) {
	        var _this = this;
	
	        var pwd1 = this.refs.password.value.trim();
	        var pwd2 = this.refs.passwordConfirm.value.trim();
	
	        var username;
	
	        (function () {
	            switch (field_id) {
	                case FIELD_EMAIL:
	                    var email = _this.refs.email.value;
	                    if (_this.props.teamsConfig && _this._isUniEmail(email)) {
	                        var matchingTeam = _this.props.teamsConfig.teams.find(function (team) {
	                            return email.split('@').pop() === team.domain;
	                        }) || null;
	                        _this.setState({
	                            selectedTeam: matchingTeam,
	                            showSupportEmail: !matchingTeam
	                        });
	                        _this.props.onTeamSelected(matchingTeam);
	                    } else {
	                        _this.props.onTeamSelected(null);
	                        _this.setState({
	                            selectedTeam: null,
	                            showSupportEmail: false
	                        });
	                    }
	                    var emailValid = email === '' || _email2.default.looksValid(email);
	                    _this.markFieldValid(field_id, emailValid, "RegistrationForm.ERR_EMAIL_INVALID");
	                    break;
	                case FIELD_PHONE_NUMBER:
	                    var phoneNumber = _this.refs.phoneNumber.value;
	                    var phoneNumberValid = phoneNumber === '' || (0, _phonenumber.looksValid)(phoneNumber);
	                    _this.markFieldValid(field_id, phoneNumberValid, "RegistrationForm.ERR_PHONE_NUMBER_INVALID");
	                    break;
	                case FIELD_USERNAME:
	                    // XXX: SPEC-1
	                    username = _this.refs.username.value.trim() || _this.props.guestUsername;
	
	                    if (encodeURIComponent(username) != username) {
	                        _this.markFieldValid(field_id, false, "RegistrationForm.ERR_USERNAME_INVALID");
	                    } else if (username == '') {
	                        _this.markFieldValid(field_id, false, "RegistrationForm.ERR_USERNAME_BLANK");
	                    } else {
	                        _this.markFieldValid(field_id, true);
	                    }
	                    break;
	                case FIELD_PASSWORD:
	                    if (pwd1 == '') {
	                        _this.markFieldValid(field_id, false, "RegistrationForm.ERR_PASSWORD_MISSING");
	                    } else if (pwd1.length < _this.props.minPasswordLength) {
	                        _this.markFieldValid(field_id, false, "RegistrationForm.ERR_PASSWORD_LENGTH");
	                    } else {
	                        _this.markFieldValid(field_id, true);
	                    }
	                    break;
	                case FIELD_PASSWORD_CONFIRM:
	                    _this.markFieldValid(field_id, pwd1 == pwd2, "RegistrationForm.ERR_PASSWORD_MISMATCH");
	                    break;
	            }
	        })();
	    },
	
	    markFieldValid: function markFieldValid(field_id, val, error_code) {
	        var fieldValid = this.state.fieldValid;
	        fieldValid[field_id] = val;
	        this.setState({ fieldValid: fieldValid });
	        if (!val) {
	            (0, _UiEffects.field_input_incorrect)(this.fieldElementById(field_id));
	            this.props.onError(error_code);
	        }
	    },
	
	    fieldElementById: function fieldElementById(field_id) {
	        switch (field_id) {
	            case FIELD_EMAIL:
	                return this.refs.email;
	            case FIELD_PHONE_NUMBER:
	                return this.refs.phoneNumber;
	            case FIELD_USERNAME:
	                return this.refs.username;
	            case FIELD_PASSWORD:
	                return this.refs.password;
	            case FIELD_PASSWORD_CONFIRM:
	                return this.refs.passwordConfirm;
	        }
	    },
	
	
	    _classForField: function _classForField(field_id) {
	        for (var _len = arguments.length, baseClasses = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            baseClasses[_key - 1] = arguments[_key];
	        }
	
	        var cls = baseClasses.join(' ');
	        if (this.state.fieldValid[field_id] === false) {
	            if (cls) cls += ' ';
	            cls += 'error';
	        }
	        return cls;
	    },
	
	    _onPhoneCountryChange: function _onPhoneCountryChange(newVal) {
	        this.setState({
	            phoneCountry: newVal
	        });
	    },
	
	
	    render: function render() {
	        var self = this;
	
	        var emailSection = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('input', { type: 'text', ref: 'email',
	                autoFocus: true, placeholder: 'Email address (optional)',
	                defaultValue: this.props.defaultEmail,
	                className: this._classForField(FIELD_EMAIL, 'mx_Login_field'),
	                onBlur: function onBlur() {
	                    self.validateField(FIELD_EMAIL);
	                },
	                value: self.state.email })
	        );
	        var belowEmailSection = void 0;
	        if (this.props.teamsConfig) {
	            if (this.props.teamsConfig.supportEmail && this.state.showSupportEmail) {
	                belowEmailSection = _react2.default.createElement(
	                    'p',
	                    { className: 'mx_Login_support' },
	                    'Sorry, but your university is not registered with us just yet.\xA0 Email us on\xA0',
	                    _react2.default.createElement(
	                        'a',
	                        { href: "mailto:" + this.props.teamsConfig.supportEmail },
	                        this.props.teamsConfig.supportEmail
	                    ),
	                    '\xA0 to get your university signed up. Or continue to register with Riot to enjoy our open source platform.'
	                );
	            } else if (this.state.selectedTeam) {
	                belowEmailSection = _react2.default.createElement(
	                    'p',
	                    { className: 'mx_Login_support' },
	                    'You are registering with ',
	                    this.state.selectedTeam.name
	                );
	            }
	        }
	
	        var CountryDropdown = _index2.default.getComponent('views.login.CountryDropdown');
	        var phoneSection = _react2.default.createElement(
	            'div',
	            { className: 'mx_Login_phoneSection' },
	            _react2.default.createElement(CountryDropdown, { ref: 'phone_country', onOptionChange: this._onPhoneCountryChange,
	                className: 'mx_Login_phoneCountry',
	                value: this.state.phoneCountry
	            }),
	            _react2.default.createElement('input', { type: 'text', ref: 'phoneNumber',
	                placeholder: 'Mobile phone number (optional)',
	                defaultValue: this.props.defaultPhoneNumber,
	                className: this._classForField(FIELD_PHONE_NUMBER, 'mx_Login_phoneNumberField', 'mx_Login_field'),
	                onBlur: function onBlur() {
	                    self.validateField(FIELD_PHONE_NUMBER);
	                },
	                value: self.state.phoneNumber
	            })
	        );
	
	        var registerButton = _react2.default.createElement('input', { className: 'mx_Login_submit', type: 'submit', value: 'Register' });
	
	        var placeholderUserName = "User name";
	        if (this.props.guestUsername) {
	            placeholderUserName += " (default: " + this.props.guestUsername + ")";
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                emailSection,
	                belowEmailSection,
	                phoneSection,
	                _react2.default.createElement('input', { type: 'text', ref: 'username',
	                    placeholder: placeholderUserName, defaultValue: this.props.defaultUsername,
	                    className: this._classForField(FIELD_USERNAME, 'mx_Login_field'),
	                    onBlur: function onBlur() {
	                        self.validateField(FIELD_USERNAME);
	                    } }),
	                _react2.default.createElement('br', null),
	                this.props.guestUsername ? _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Login_fieldLabel' },
	                    'Setting a user name will create a fresh account'
	                ) : null,
	                _react2.default.createElement('input', { type: 'password', ref: 'password',
	                    className: this._classForField(FIELD_PASSWORD, 'mx_Login_field'),
	                    onBlur: function onBlur() {
	                        self.validateField(FIELD_PASSWORD);
	                    },
	                    placeholder: 'Password', defaultValue: this.props.defaultPassword }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { type: 'password', ref: 'passwordConfirm',
	                    placeholder: 'Confirm password',
	                    className: this._classForField(FIELD_PASSWORD_CONFIRM, 'mx_Login_field'),
	                    onBlur: function onBlur() {
	                        self.validateField(FIELD_PASSWORD_CONFIRM);
	                    },
	                    defaultValue: this.props.defaultPassword }),
	                _react2.default.createElement('br', null),
	                registerButton
	            )
	        );
	    }
	});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.onSendMessageFailed = onSendMessageFailed;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 Copyright 2015, 2016 OpenMarket Ltd
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */
	var React = __webpack_require__(1);
	
	var MatrixClientPeg = __webpack_require__(4);
	var SlashCommands = __webpack_require__(329);
	var Modal = __webpack_require__(10);
	var MemberEntry = __webpack_require__(330).MemberEntry;
	var sdk = __webpack_require__(2);
	
	var dis = __webpack_require__(5);
	var KeyCode = __webpack_require__(116);
	var Markdown = __webpack_require__(500);
	
	var TYPING_USER_TIMEOUT = 10000;
	var TYPING_SERVER_TIMEOUT = 30000;
	var MARKDOWN_ENABLED = true;
	
	function onSendMessageFailed(err, room) {
	    // XXX: temporary logging to try to diagnose
	    // https://github.com/vector-im/riot-web/issues/3148
	    console.log('MessageComposer got send failure: ' + err.name + '(' + err + ')');
	    if (err.name === "UnknownDeviceError") {
	        dis.dispatch({
	            action: 'unknown_device_error',
	            err: err,
	            room: room
	        });
	    }
	    dis.dispatch({
	        action: 'message_send_failed'
	    });
	}
	
	/*
	 * The textInput part of the MessageComposer
	 */
	exports.default = React.createClass({
	    displayName: 'MessageComposerInput',
	
	    statics: {
	        // the height we limit the composer to
	        MAX_HEIGHT: 100
	    },
	
	    propTypes: {
	        tabComplete: React.PropTypes.any,
	
	        // a callback which is called when the height of the composer is
	        // changed due to a change in content.
	        onResize: React.PropTypes.func,
	
	        // js-sdk Room object
	        room: React.PropTypes.object.isRequired,
	
	        // The text to use a placeholder in the input box
	        placeholder: React.PropTypes.string.isRequired
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.oldScrollHeight = 0;
	        this.markdownEnabled = MARKDOWN_ENABLED;
	        var self = this;
	        this.sentHistory = {
	            // The list of typed messages. Index 0 is more recent
	            data: [],
	            // The position in data currently displayed
	            position: -1,
	            // The room the history is for.
	            roomId: null,
	            // The original text before they hit UP
	            originalText: null,
	            // The textarea element to set text to.
	            element: null,
	
	            init: function init(element, roomId) {
	                this.roomId = roomId;
	                this.element = element;
	                this.position = -1;
	                var storedData = window.sessionStorage.getItem("history_" + roomId);
	                if (storedData) {
	                    this.data = JSON.parse(storedData);
	                }
	                if (this.roomId) {
	                    this.setLastTextEntry();
	                }
	            },
	
	            push: function push(text) {
	                // store a message in the sent history
	                this.data.unshift(text);
	                window.sessionStorage.setItem("history_" + this.roomId, (0, _stringify2.default)(this.data));
	                // reset history position
	                this.position = -1;
	                this.originalText = null;
	            },
	
	            // move in the history. Returns true if we managed to move.
	            next: function next(offset) {
	                if (this.position === -1) {
	                    // user is going into the history, save the current line.
	                    this.originalText = this.element.value;
	                } else {
	                    // user may have modified this line in the history; remember it.
	                    this.data[this.position] = this.element.value;
	                }
	
	                if (offset > 0 && this.position === this.data.length - 1) {
	                    // we've run out of history
	                    return false;
	                }
	
	                // retrieve the next item (bounded).
	                var newPosition = this.position + offset;
	                newPosition = Math.max(-1, newPosition);
	                newPosition = Math.min(newPosition, this.data.length - 1);
	                this.position = newPosition;
	
	                if (this.position !== -1) {
	                    // show the message
	                    this.element.value = this.data[this.position];
	                } else if (this.originalText !== undefined) {
	                    // restore the original text the user was typing.
	                    this.element.value = this.originalText;
	                }
	
	                self.resizeInput();
	                return true;
	            },
	
	            saveLastTextEntry: function saveLastTextEntry() {
	                // save the currently entered text in order to restore it later.
	                // NB: This isn't 'originalText' because we want to restore
	                // sent history items too!
	                var text = this.element.value;
	                window.sessionStorage.setItem("input_" + this.roomId, text);
	            },
	
	            setLastTextEntry: function setLastTextEntry() {
	                var text = window.sessionStorage.getItem("input_" + this.roomId);
	                if (text) {
	                    this.element.value = text;
	                    self.resizeInput();
	                }
	            }
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        this.sentHistory.init(this.refs.textarea, this.props.room.roomId);
	        this.resizeInput();
	        if (this.props.tabComplete) {
	            this.props.tabComplete.setTextArea(this.refs.textarea);
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	        this.sentHistory.saveLastTextEntry();
	    },
	
	    onAction: function onAction(payload) {
	        var textarea = this.refs.textarea;
	        switch (payload.action) {
	            case 'focus_composer':
	                textarea.focus();
	                break;
	            case 'insert_displayname':
	                if (textarea.value.length) {
	                    var left = textarea.value.substring(0, textarea.selectionStart);
	                    var right = textarea.value.substring(textarea.selectionEnd);
	                    if (right.length) {
	                        left += payload.displayname;
	                    } else {
	                        left = left.replace(/( ?)$/, " " + payload.displayname);
	                    }
	                    textarea.value = left + right;
	                    textarea.focus();
	                    textarea.setSelectionRange(left.length, left.length);
	                } else {
	                    textarea.value = payload.displayname + ": ";
	                    textarea.focus();
	                }
	                break;
	        }
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        var _this = this;
	
	        if (ev.keyCode === KeyCode.ENTER && !ev.shiftKey) {
	            var input = this.refs.textarea.value;
	            if (input.length === 0) {
	                ev.preventDefault();
	                return;
	            }
	            this.sentHistory.push(input);
	            this.onEnter(ev);
	        } else if (ev.keyCode === KeyCode.UP || ev.keyCode === KeyCode.DOWN) {
	            var oldSelectionStart = this.refs.textarea.selectionStart;
	            // Remember the keyCode because React will recycle the synthetic event
	            var keyCode = ev.keyCode;
	            // set a callback so we can see if the cursor position changes as
	            // a result of this event. If it doesn't, we cycle history.
	            setTimeout(function () {
	                if (_this.refs.textarea.selectionStart == oldSelectionStart) {
	                    _this.sentHistory.next(keyCode === KeyCode.UP ? 1 : -1);
	                    _this.resizeInput();
	                }
	            }, 0);
	        }
	
	        if (this.props.tabComplete) {
	            this.props.tabComplete.onKeyDown(ev);
	        }
	
	        var self = this;
	        setTimeout(function () {
	            if (self.refs.textarea && self.refs.textarea.value != '') {
	                self.onTypingActivity();
	            } else {
	                self.onFinishedTyping();
	            }
	        }, 10); // XXX: what is this 10ms setTimeout doing?  Looks hacky :(
	    },
	
	    resizeInput: function resizeInput() {
	        // scrollHeight is at least equal to clientHeight, so we have to
	        // temporarily crimp clientHeight to 0 to get an accurate scrollHeight value
	        this.refs.textarea.style.height = "20px"; // 20 hardcoded from CSS
	        var newHeight = Math.min(this.refs.textarea.scrollHeight, this.constructor.MAX_HEIGHT);
	        this.refs.textarea.style.height = Math.ceil(newHeight) + "px";
	        this.oldScrollHeight = this.refs.textarea.scrollHeight;
	
	        if (this.props.onResize) {
	            // kick gemini-scrollbar to re-layout
	            this.props.onResize();
	        }
	    },
	
	    onKeyUp: function onKeyUp(ev) {
	        if (this.refs.textarea.scrollHeight !== this.oldScrollHeight || ev.keyCode === KeyCode.DELETE || ev.keyCode === KeyCode.BACKSPACE) {
	            this.resizeInput();
	        }
	    },
	
	    onEnter: function onEnter(ev) {
	        var _this2 = this;
	
	        var contentText = this.refs.textarea.value;
	
	        // bodge for now to set markdown state on/off. We probably want a separate
	        // area for "local" commands which don't hit out to the server.
	        if (contentText.indexOf("/markdown") === 0) {
	            ev.preventDefault();
	            this.refs.textarea.value = '';
	            if (contentText.indexOf("/markdown on") === 0) {
	                this.markdownEnabled = true;
	            } else if (contentText.indexOf("/markdown off") === 0) {
	                this.markdownEnabled = false;
	            } else {
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Unknown command",
	                    description: "Usage: /markdown on|off"
	                });
	            }
	            return;
	        }
	
	        var cmd = SlashCommands.processInput(this.props.room.roomId, contentText);
	        if (cmd) {
	            ev.preventDefault();
	            if (!cmd.error) {
	                this.refs.textarea.value = '';
	            }
	            if (cmd.promise) {
	                cmd.promise.done(function () {
	                    console.log("Command success.");
	                }, function (err) {
	                    console.error("Command failure: %s", err);
	                    var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                    Modal.createDialog(ErrorDialog, {
	                        title: "Server error",
	                        description: "Server unavailable, overloaded, or something else went wrong."
	                    });
	                });
	            } else if (cmd.error) {
	                console.error(cmd.error);
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Command error",
	                    description: cmd.error
	                });
	            }
	            return;
	        }
	
	        var isEmote = /^\/me( |$)/i.test(contentText);
	        var sendMessagePromise;
	
	        if (isEmote) {
	            contentText = contentText.substring(4);
	        } else if (contentText[0] === '/') {
	            contentText = contentText.substring(1);
	        }
	
	        var send_markdown = false;
	        var mdown = void 0;
	        if (this.markdownEnabled) {
	            mdown = new Markdown(contentText);
	            send_markdown = !mdown.isPlainText();
	        }
	
	        if (send_markdown) {
	            var htmlText = mdown.toHTML();
	            sendMessagePromise = isEmote ? MatrixClientPeg.get().sendHtmlEmote(this.props.room.roomId, contentText, htmlText) : MatrixClientPeg.get().sendHtmlMessage(this.props.room.roomId, contentText, htmlText);
	        } else {
	            if (mdown) contentText = mdown.toPlaintext();
	            sendMessagePromise = isEmote ? MatrixClientPeg.get().sendEmoteMessage(this.props.room.roomId, contentText) : MatrixClientPeg.get().sendTextMessage(this.props.room.roomId, contentText);
	        }
	
	        sendMessagePromise.done(function (res) {
	            dis.dispatch({
	                action: 'message_sent'
	            });
	        }, function (e) {
	            return onSendMessageFailed(e, _this2.props.room);
	        });
	
	        this.refs.textarea.value = '';
	        this.resizeInput();
	        ev.preventDefault();
	    },
	
	    onTypingActivity: function onTypingActivity() {
	        this.isTyping = true;
	        if (!this.userTypingTimer) {
	            this.sendTyping(true);
	        }
	        this.startUserTypingTimer();
	        this.startServerTypingTimer();
	    },
	
	    onFinishedTyping: function onFinishedTyping() {
	        this.isTyping = false;
	        this.sendTyping(false);
	        this.stopUserTypingTimer();
	        this.stopServerTypingTimer();
	    },
	
	    startUserTypingTimer: function startUserTypingTimer() {
	        this.stopUserTypingTimer();
	        var self = this;
	        this.userTypingTimer = setTimeout(function () {
	            self.isTyping = false;
	            self.sendTyping(self.isTyping);
	            self.userTypingTimer = null;
	        }, TYPING_USER_TIMEOUT);
	    },
	
	    stopUserTypingTimer: function stopUserTypingTimer() {
	        if (this.userTypingTimer) {
	            clearTimeout(this.userTypingTimer);
	            this.userTypingTimer = null;
	        }
	    },
	
	    startServerTypingTimer: function startServerTypingTimer() {
	        if (!this.serverTypingTimer) {
	            var self = this;
	            this.serverTypingTimer = setTimeout(function () {
	                if (self.isTyping) {
	                    self.sendTyping(self.isTyping);
	                    self.startServerTypingTimer();
	                }
	            }, TYPING_SERVER_TIMEOUT / 2);
	        }
	    },
	
	    stopServerTypingTimer: function stopServerTypingTimer() {
	        if (this.serverTypingTimer) {
	            clearTimeout(this.servrTypingTimer);
	            this.serverTypingTimer = null;
	        }
	    },
	
	    sendTyping: function sendTyping(isTyping) {
	        MatrixClientPeg.get().sendTyping(this.props.room.roomId, this.isTyping, TYPING_SERVER_TIMEOUT).done();
	    },
	
	    refreshTyping: function refreshTyping() {
	        if (this.typingTimeout) {
	            clearTimeout(this.typingTimeout);
	            this.typingTimeout = null;
	        }
	    },
	
	    onInputClick: function onInputClick(ev) {
	        this.refs.textarea.focus();
	    },
	
	    render: function render() {
	        return React.createElement(
	            "div",
	            { className: "mx_MessageComposer_input", onClick: this.onInputClick },
	            React.createElement("textarea", { autoFocus: true, ref: "textarea", rows: "1", onKeyDown: this.onKeyDown, onKeyUp: this.onKeyUp, placeholder: this.props.placeholder })
	        );
	    }
	});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var classNames = __webpack_require__(27);
	var MatrixClientPeg = __webpack_require__(4);
	
	var sdk = __webpack_require__(2);
	var ContextualMenu = __webpack_require__(222);
	var RoomNotifs = __webpack_require__(328);
	var FormattingUtils = __webpack_require__(520);
	
	var UserSettingsStore = __webpack_require__(74);
	
	module.exports = React.createClass({
	    displayName: 'RoomTile',
	
	    propTypes: {
	        connectDragSource: React.PropTypes.func,
	        connectDropTarget: React.PropTypes.func,
	        onClick: React.PropTypes.func,
	        isDragging: React.PropTypes.bool,
	
	        room: React.PropTypes.object.isRequired,
	        collapsed: React.PropTypes.bool.isRequired,
	        selected: React.PropTypes.bool.isRequired,
	        unread: React.PropTypes.bool.isRequired,
	        highlight: React.PropTypes.bool.isRequired,
	        isInvite: React.PropTypes.bool.isRequired,
	        incomingCall: React.PropTypes.object
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            isDragging: false
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            hover: false,
	            badgeHover: false,
	            menuDisplayed: false,
	            notifState: RoomNotifs.getRoomNotifsState(this.props.room.roomId)
	        };
	    },
	
	    _shouldShowNotifBadge: function _shouldShowNotifBadge() {
	        var showBadgeInStates = [RoomNotifs.ALL_MESSAGES, RoomNotifs.ALL_MESSAGES_LOUD];
	        return showBadgeInStates.indexOf(this.state.notifState) > -1;
	    },
	
	    _shouldShowMentionBadge: function _shouldShowMentionBadge() {
	        return this.state.notifState != RoomNotifs.MUTE;
	    },
	
	    _isDirectMessageRoom: function _isDirectMessageRoom(roomId) {
	        var dmRooms = _DMRoomMap2.default.shared().getUserIdForRoomId(roomId);
	        if (dmRooms) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	
	    onAccountData: function onAccountData(accountDataEvent) {
	        if (accountDataEvent.getType() == 'm.push_rules') {
	            this.setState({
	                notifState: RoomNotifs.getRoomNotifsState(this.props.room.roomId)
	            });
	        }
	    },
	
	    componentWillMount: function componentWillMount() {
	        MatrixClientPeg.get().on("accountData", this.onAccountData);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        var cli = MatrixClientPeg.get();
	        if (cli) {
	            MatrixClientPeg.get().removeListener("accountData", this.onAccountData);
	        }
	    },
	
	    onClick: function onClick() {
	        if (this.props.onClick) {
	            this.props.onClick(this.props.room.roomId);
	        }
	    },
	
	    onMouseEnter: function onMouseEnter() {
	        this.setState({ hover: true });
	        this.badgeOnMouseEnter();
	    },
	
	    onMouseLeave: function onMouseLeave() {
	        this.setState({ hover: false });
	        this.badgeOnMouseLeave();
	    },
	
	    badgeOnMouseEnter: function badgeOnMouseEnter() {
	        // Only allow non-guests to access the context menu
	        // and only change it if it needs to change
	        if (!MatrixClientPeg.get().isGuest() && !this.state.badgeHover) {
	            this.setState({ badgeHover: true });
	        }
	    },
	
	    badgeOnMouseLeave: function badgeOnMouseLeave() {
	        this.setState({ badgeHover: false });
	    },
	
	    onBadgeClicked: function onBadgeClicked(e) {
	        // Only allow none guests to access the context menu
	        if (!MatrixClientPeg.get().isGuest()) {
	
	            // If the badge is clicked, then no longer show tooltip
	            if (this.props.collapsed) {
	                this.setState({ hover: false });
	            }
	
	            var RoomTileContextMenu = sdk.getComponent('context_menus.RoomTileContextMenu');
	            var elementRect = e.target.getBoundingClientRect();
	
	            // The window X and Y offsets are to adjust position when zoomed in to page
	            var x = elementRect.right + window.pageXOffset + 3;
	            var chevronOffset = 12;
	            var y = elementRect.top + elementRect.height / 2 + window.pageYOffset;
	            y = y - (chevronOffset + 8); // where 8 is half the height of the chevron
	
	            var self = this;
	            ContextualMenu.createMenu(RoomTileContextMenu, {
	                chevronOffset: chevronOffset,
	                left: x,
	                top: y,
	                room: this.props.room,
	                onFinished: function onFinished() {
	                    self.setState({ menuDisplayed: false });
	                    self.props.refreshSubList();
	                }
	            });
	            this.setState({ menuDisplayed: true });
	        }
	        // Prevent the RoomTile onClick event firing as well
	        e.stopPropagation();
	    },
	
	    render: function render() {
	        var myUserId = MatrixClientPeg.get().credentials.userId;
	        var me = this.props.room.currentState.members[myUserId];
	
	        var notificationCount = this.props.room.getUnreadNotificationCount();
	        // var highlightCount = this.props.room.getUnreadNotificationCount("highlight");
	
	        var notifBadges = notificationCount > 0 && this._shouldShowNotifBadge();
	        var mentionBadges = this.props.highlight && this._shouldShowMentionBadge();
	        var badges = notifBadges || mentionBadges;
	
	        var classes = classNames({
	            'mx_RoomTile': true,
	            'mx_RoomTile_selected': this.props.selected,
	            'mx_RoomTile_unread': this.props.unread,
	            'mx_RoomTile_unreadNotify': notifBadges,
	            'mx_RoomTile_highlight': mentionBadges,
	            'mx_RoomTile_invited': me && me.membership == 'invite',
	            'mx_RoomTile_menuDisplayed': this.state.menuDisplayed,
	            'mx_RoomTile_noBadges': !badges
	        });
	
	        var avatarClasses = classNames({
	            'mx_RoomTile_avatar': true
	        });
	
	        var badgeClasses = classNames({
	            'mx_RoomTile_badge': true,
	            'mx_RoomTile_badgeButton': this.state.badgeHover || this.state.menuDisplayed
	        });
	
	        // XXX: We should never display raw room IDs, but sometimes the
	        // room name js sdk gives is undefined (cannot repro this -- k)
	        var name = this.props.room.name || this.props.room.roomId;
	        name = name.replace(":", ':\u200B'); // add a zero-width space to allow linewrapping after the colon
	
	        var badge;
	        var badgeContent;
	
	        if (this.state.badgeHover || this.state.menuDisplayed) {
	            badgeContent = '\xB7\xB7\xB7';
	        } else if (badges) {
	            var limitedCount = FormattingUtils.formatCount(notificationCount);
	            badgeContent = notificationCount ? limitedCount : '!';
	        } else {
	            badgeContent = '\u200B';
	        }
	
	        badge = React.createElement(
	            'div',
	            { className: badgeClasses, onClick: this.onBadgeClicked },
	            badgeContent
	        );
	
	        var EmojiText = sdk.getComponent('elements.EmojiText');
	        var label;
	        var tooltip;
	        if (!this.props.collapsed) {
	            var nameClasses = classNames({
	                'mx_RoomTile_name': true,
	                'mx_RoomTile_invite': this.props.isInvite,
	                'mx_RoomTile_badgeShown': badges || this.state.badgeHover || this.state.menuDisplayed
	            });
	
	            if (this.props.selected) {
	                var nameSelected = React.createElement(
	                    EmojiText,
	                    null,
	                    name
	                );
	
	                label = React.createElement(
	                    'div',
	                    { title: name, className: nameClasses },
	                    nameSelected
	                );
	            } else {
	                label = React.createElement(
	                    EmojiText,
	                    { element: 'div', title: name, className: nameClasses },
	                    name
	                );
	            }
	        } else if (this.state.hover) {
	            var RoomTooltip = sdk.getComponent("rooms.RoomTooltip");
	            tooltip = React.createElement(RoomTooltip, { className: 'mx_RoomTile_tooltip', room: this.props.room });
	        }
	
	        //var incomingCallBox;
	        //if (this.props.incomingCall) {
	        //    var IncomingCallBox = sdk.getComponent("voip.IncomingCallBox");
	        //    incomingCallBox = <IncomingCallBox incomingCall={ this.props.incomingCall }/>;
	        //}
	
	        var RoomAvatar = sdk.getComponent('avatars.RoomAvatar');
	
	        var directMessageIndicator;
	        if (this._isDirectMessageRoom(this.props.room.roomId)) {
	            directMessageIndicator = React.createElement('img', { src: 'img/icon_person.svg', className: 'mx_RoomTile_dm', width: '11', height: '13', alt: 'dm' });
	        }
	
	        // These props are injected by React DnD,
	        // as defined by your `collect` function above:
	        var isDragging = this.props.isDragging;
	        var connectDragSource = this.props.connectDragSource;
	        var connectDropTarget = this.props.connectDropTarget;
	
	        var ret = React.createElement(
	            'div',
	            null,
	            ' ',
	            React.createElement(
	                _AccessibleButton2.default,
	                { className: classes, tabIndex: '0', onClick: this.onClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave },
	                React.createElement(
	                    'div',
	                    { className: avatarClasses },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RoomTile_avatar_container' },
	                        React.createElement(RoomAvatar, { room: this.props.room, width: 24, height: 24 }),
	                        directMessageIndicator
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomTile_nameContainer' },
	                    label,
	                    badge
	                ),
	                tooltip
	            )
	        );
	
	        if (connectDropTarget) ret = connectDropTarget(ret);
	        if (connectDragSource) ret = connectDragSource(ret);
	
	        return ret;
	    }
	});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CancelButton = CancelButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// cancel button which is shared between room header and simple room header
	function CancelButton(props) {
	    var onClick = props.onClick;
	
	
	    return _react2.default.createElement(
	        _AccessibleButton2.default,
	        { className: 'mx_RoomHeader_cancelButton', onClick: onClick },
	        _react2.default.createElement('img', { src: 'img/cancel.svg', className: 'mx_filterFlipColor',
	            width: '18', height: '18', alt: 'Cancel' })
	    );
	}
	
	/*
	 * A stripped-down room header used for things like the user settings
	 * and room directory.
	 */
	exports.default = _react2.default.createClass({
	    displayName: 'SimpleRoomHeader',
	
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        onCancelClick: _react2.default.PropTypes.func,
	
	        // is the RightPanel collapsed?
	        collapsedRhs: _react2.default.PropTypes.bool
	    },
	
	    onShowRhsClick: function onShowRhsClick(ev) {
	        _dispatcher2.default.dispatch({ action: 'show_right_panel' });
	    },
	
	    render: function render() {
	        var cancelButton = void 0;
	        if (this.props.onCancelClick) {
	            cancelButton = _react2.default.createElement(CancelButton, { onClick: this.props.onCancelClick });
	        }
	
	        var showRhsButton = void 0;
	        /* // don't bother cluttering things up with this for now.
	        const TintableSvg = sdk.getComponent("elements.TintableSvg");
	         if (this.props.collapsedRhs) {
	            showRhsButton =
	                <div className="mx_RoomHeader_button" style={{ float: 'right' }} onClick={this.onShowRhsClick} title=">">
	                    <TintableSvg src="img/minimise.svg" width="10" height="16"/>
	                </div>
	        }
	        */
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_RoomHeader' },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomHeader_wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomHeader_simpleHeader' },
	                    this.props.title,
	                    showRhsButton,
	                    cancelButton
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 518 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var EMAIL_ADDRESS_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
	
	module.exports = {
	    looksValid: function looksValid(email) {
	        return EMAIL_ADDRESS_REGEX.test(email);
	    }
	};


/***/ }),
/* 519 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.looksValid = looksValid;
	/*
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var PHONE_NUMBER_REGEXP = /^[0-9 -\.]+$/;
	
	/*
	 * Do basic validation to determine if the given input could be
	 * a valid phone number.
	 *
	 * @param {String} phoneNumber The string to validate. This could be
	 *     either an international format number (MSISDN or e.164) or
	 *     a national-format number.
	 * @return True if the number could be a valid phone number, otherwise false.
	 */
	function looksValid(phoneNumber) {
	    return PHONE_NUMBER_REGEXP.test(phoneNumber);
	}
	
	var COUNTRIES = exports.COUNTRIES = [{
	    "iso2": "GB",
	    "name": "United Kingdom",
	    "prefix": "44"
	}, {
	    "iso2": "US",
	    "name": "United States",
	    "prefix": "1"
	}, {
	    "iso2": "AF",
	    "name": "Afghanistan",
	    "prefix": "93"
	}, {
	    "iso2": "AX",
	    "name": "\xC5land Islands",
	    "prefix": "358"
	}, {
	    "iso2": "AL",
	    "name": "Albania",
	    "prefix": "355"
	}, {
	    "iso2": "DZ",
	    "name": "Algeria",
	    "prefix": "213"
	}, {
	    "iso2": "AS",
	    "name": "American Samoa",
	    "prefix": "1"
	}, {
	    "iso2": "AD",
	    "name": "Andorra",
	    "prefix": "376"
	}, {
	    "iso2": "AO",
	    "name": "Angola",
	    "prefix": "244"
	}, {
	    "iso2": "AI",
	    "name": "Anguilla",
	    "prefix": "1"
	}, {
	    "iso2": "AQ",
	    "name": "Antarctica",
	    "prefix": "672"
	}, {
	    "iso2": "AG",
	    "name": "Antigua & Barbuda",
	    "prefix": "1"
	}, {
	    "iso2": "AR",
	    "name": "Argentina",
	    "prefix": "54"
	}, {
	    "iso2": "AM",
	    "name": "Armenia",
	    "prefix": "374"
	}, {
	    "iso2": "AW",
	    "name": "Aruba",
	    "prefix": "297"
	}, {
	    "iso2": "AU",
	    "name": "Australia",
	    "prefix": "61"
	}, {
	    "iso2": "AT",
	    "name": "Austria",
	    "prefix": "43"
	}, {
	    "iso2": "AZ",
	    "name": "Azerbaijan",
	    "prefix": "994"
	}, {
	    "iso2": "BS",
	    "name": "Bahamas",
	    "prefix": "1"
	}, {
	    "iso2": "BH",
	    "name": "Bahrain",
	    "prefix": "973"
	}, {
	    "iso2": "BD",
	    "name": "Bangladesh",
	    "prefix": "880"
	}, {
	    "iso2": "BB",
	    "name": "Barbados",
	    "prefix": "1"
	}, {
	    "iso2": "BY",
	    "name": "Belarus",
	    "prefix": "375"
	}, {
	    "iso2": "BE",
	    "name": "Belgium",
	    "prefix": "32"
	}, {
	    "iso2": "BZ",
	    "name": "Belize",
	    "prefix": "501"
	}, {
	    "iso2": "BJ",
	    "name": "Benin",
	    "prefix": "229"
	}, {
	    "iso2": "BM",
	    "name": "Bermuda",
	    "prefix": "1"
	}, {
	    "iso2": "BT",
	    "name": "Bhutan",
	    "prefix": "975"
	}, {
	    "iso2": "BO",
	    "name": "Bolivia",
	    "prefix": "591"
	}, {
	    "iso2": "BA",
	    "name": "Bosnia",
	    "prefix": "387"
	}, {
	    "iso2": "BW",
	    "name": "Botswana",
	    "prefix": "267"
	}, {
	    "iso2": "BV",
	    "name": "Bouvet Island",
	    "prefix": "47"
	}, {
	    "iso2": "BR",
	    "name": "Brazil",
	    "prefix": "55"
	}, {
	    "iso2": "IO",
	    "name": "British Indian Ocean Territory",
	    "prefix": "246"
	}, {
	    "iso2": "VG",
	    "name": "British Virgin Islands",
	    "prefix": "1"
	}, {
	    "iso2": "BN",
	    "name": "Brunei",
	    "prefix": "673"
	}, {
	    "iso2": "BG",
	    "name": "Bulgaria",
	    "prefix": "359"
	}, {
	    "iso2": "BF",
	    "name": "Burkina Faso",
	    "prefix": "226"
	}, {
	    "iso2": "BI",
	    "name": "Burundi",
	    "prefix": "257"
	}, {
	    "iso2": "KH",
	    "name": "Cambodia",
	    "prefix": "855"
	}, {
	    "iso2": "CM",
	    "name": "Cameroon",
	    "prefix": "237"
	}, {
	    "iso2": "CA",
	    "name": "Canada",
	    "prefix": "1"
	}, {
	    "iso2": "CV",
	    "name": "Cape Verde",
	    "prefix": "238"
	}, {
	    "iso2": "BQ",
	    "name": "Caribbean Netherlands",
	    "prefix": "599"
	}, {
	    "iso2": "KY",
	    "name": "Cayman Islands",
	    "prefix": "1"
	}, {
	    "iso2": "CF",
	    "name": "Central African Republic",
	    "prefix": "236"
	}, {
	    "iso2": "TD",
	    "name": "Chad",
	    "prefix": "235"
	}, {
	    "iso2": "CL",
	    "name": "Chile",
	    "prefix": "56"
	}, {
	    "iso2": "CN",
	    "name": "China",
	    "prefix": "86"
	}, {
	    "iso2": "CX",
	    "name": "Christmas Island",
	    "prefix": "61"
	}, {
	    "iso2": "CC",
	    "name": "Cocos (Keeling) Islands",
	    "prefix": "61"
	}, {
	    "iso2": "CO",
	    "name": "Colombia",
	    "prefix": "57"
	}, {
	    "iso2": "KM",
	    "name": "Comoros",
	    "prefix": "269"
	}, {
	    "iso2": "CG",
	    "name": "Congo - Brazzaville",
	    "prefix": "242"
	}, {
	    "iso2": "CD",
	    "name": "Congo - Kinshasa",
	    "prefix": "243"
	}, {
	    "iso2": "CK",
	    "name": "Cook Islands",
	    "prefix": "682"
	}, {
	    "iso2": "CR",
	    "name": "Costa Rica",
	    "prefix": "506"
	}, {
	    "iso2": "HR",
	    "name": "Croatia",
	    "prefix": "385"
	}, {
	    "iso2": "CU",
	    "name": "Cuba",
	    "prefix": "53"
	}, {
	    "iso2": "CW",
	    "name": "Cura\xE7ao",
	    "prefix": "599"
	}, {
	    "iso2": "CY",
	    "name": "Cyprus",
	    "prefix": "357"
	}, {
	    "iso2": "CZ",
	    "name": "Czech Republic",
	    "prefix": "420"
	}, {
	    "iso2": "CI",
	    "name": "C\xF4te d\u2019Ivoire",
	    "prefix": "225"
	}, {
	    "iso2": "DK",
	    "name": "Denmark",
	    "prefix": "45"
	}, {
	    "iso2": "DJ",
	    "name": "Djibouti",
	    "prefix": "253"
	}, {
	    "iso2": "DM",
	    "name": "Dominica",
	    "prefix": "1"
	}, {
	    "iso2": "DO",
	    "name": "Dominican Republic",
	    "prefix": "1"
	}, {
	    "iso2": "EC",
	    "name": "Ecuador",
	    "prefix": "593"
	}, {
	    "iso2": "EG",
	    "name": "Egypt",
	    "prefix": "20"
	}, {
	    "iso2": "SV",
	    "name": "El Salvador",
	    "prefix": "503"
	}, {
	    "iso2": "GQ",
	    "name": "Equatorial Guinea",
	    "prefix": "240"
	}, {
	    "iso2": "ER",
	    "name": "Eritrea",
	    "prefix": "291"
	}, {
	    "iso2": "EE",
	    "name": "Estonia",
	    "prefix": "372"
	}, {
	    "iso2": "ET",
	    "name": "Ethiopia",
	    "prefix": "251"
	}, {
	    "iso2": "FK",
	    "name": "Falkland Islands",
	    "prefix": "500"
	}, {
	    "iso2": "FO",
	    "name": "Faroe Islands",
	    "prefix": "298"
	}, {
	    "iso2": "FJ",
	    "name": "Fiji",
	    "prefix": "679"
	}, {
	    "iso2": "FI",
	    "name": "Finland",
	    "prefix": "358"
	}, {
	    "iso2": "FR",
	    "name": "France",
	    "prefix": "33"
	}, {
	    "iso2": "GF",
	    "name": "French Guiana",
	    "prefix": "594"
	}, {
	    "iso2": "PF",
	    "name": "French Polynesia",
	    "prefix": "689"
	}, {
	    "iso2": "TF",
	    "name": "French Southern Territories",
	    "prefix": "262"
	}, {
	    "iso2": "GA",
	    "name": "Gabon",
	    "prefix": "241"
	}, {
	    "iso2": "GM",
	    "name": "Gambia",
	    "prefix": "220"
	}, {
	    "iso2": "GE",
	    "name": "Georgia",
	    "prefix": "995"
	}, {
	    "iso2": "DE",
	    "name": "Germany",
	    "prefix": "49"
	}, {
	    "iso2": "GH",
	    "name": "Ghana",
	    "prefix": "233"
	}, {
	    "iso2": "GI",
	    "name": "Gibraltar",
	    "prefix": "350"
	}, {
	    "iso2": "GR",
	    "name": "Greece",
	    "prefix": "30"
	}, {
	    "iso2": "GL",
	    "name": "Greenland",
	    "prefix": "299"
	}, {
	    "iso2": "GD",
	    "name": "Grenada",
	    "prefix": "1"
	}, {
	    "iso2": "GP",
	    "name": "Guadeloupe",
	    "prefix": "590"
	}, {
	    "iso2": "GU",
	    "name": "Guam",
	    "prefix": "1"
	}, {
	    "iso2": "GT",
	    "name": "Guatemala",
	    "prefix": "502"
	}, {
	    "iso2": "GG",
	    "name": "Guernsey",
	    "prefix": "44"
	}, {
	    "iso2": "GN",
	    "name": "Guinea",
	    "prefix": "224"
	}, {
	    "iso2": "GW",
	    "name": "Guinea-Bissau",
	    "prefix": "245"
	}, {
	    "iso2": "GY",
	    "name": "Guyana",
	    "prefix": "592"
	}, {
	    "iso2": "HT",
	    "name": "Haiti",
	    "prefix": "509"
	}, {
	    "iso2": "HM",
	    "name": "Heard & McDonald Islands",
	    "prefix": "672"
	}, {
	    "iso2": "HN",
	    "name": "Honduras",
	    "prefix": "504"
	}, {
	    "iso2": "HK",
	    "name": "Hong Kong",
	    "prefix": "852"
	}, {
	    "iso2": "HU",
	    "name": "Hungary",
	    "prefix": "36"
	}, {
	    "iso2": "IS",
	    "name": "Iceland",
	    "prefix": "354"
	}, {
	    "iso2": "IN",
	    "name": "India",
	    "prefix": "91"
	}, {
	    "iso2": "ID",
	    "name": "Indonesia",
	    "prefix": "62"
	}, {
	    "iso2": "IR",
	    "name": "Iran",
	    "prefix": "98"
	}, {
	    "iso2": "IQ",
	    "name": "Iraq",
	    "prefix": "964"
	}, {
	    "iso2": "IE",
	    "name": "Ireland",
	    "prefix": "353"
	}, {
	    "iso2": "IM",
	    "name": "Isle of Man",
	    "prefix": "44"
	}, {
	    "iso2": "IL",
	    "name": "Israel",
	    "prefix": "972"
	}, {
	    "iso2": "IT",
	    "name": "Italy",
	    "prefix": "39"
	}, {
	    "iso2": "JM",
	    "name": "Jamaica",
	    "prefix": "1"
	}, {
	    "iso2": "JP",
	    "name": "Japan",
	    "prefix": "81"
	}, {
	    "iso2": "JE",
	    "name": "Jersey",
	    "prefix": "44"
	}, {
	    "iso2": "JO",
	    "name": "Jordan",
	    "prefix": "962"
	}, {
	    "iso2": "KZ",
	    "name": "Kazakhstan",
	    "prefix": "7"
	}, {
	    "iso2": "KE",
	    "name": "Kenya",
	    "prefix": "254"
	}, {
	    "iso2": "KI",
	    "name": "Kiribati",
	    "prefix": "686"
	}, {
	    "iso2": "KW",
	    "name": "Kuwait",
	    "prefix": "965"
	}, {
	    "iso2": "KG",
	    "name": "Kyrgyzstan",
	    "prefix": "996"
	}, {
	    "iso2": "LA",
	    "name": "Laos",
	    "prefix": "856"
	}, {
	    "iso2": "LV",
	    "name": "Latvia",
	    "prefix": "371"
	}, {
	    "iso2": "LB",
	    "name": "Lebanon",
	    "prefix": "961"
	}, {
	    "iso2": "LS",
	    "name": "Lesotho",
	    "prefix": "266"
	}, {
	    "iso2": "LR",
	    "name": "Liberia",
	    "prefix": "231"
	}, {
	    "iso2": "LY",
	    "name": "Libya",
	    "prefix": "218"
	}, {
	    "iso2": "LI",
	    "name": "Liechtenstein",
	    "prefix": "423"
	}, {
	    "iso2": "LT",
	    "name": "Lithuania",
	    "prefix": "370"
	}, {
	    "iso2": "LU",
	    "name": "Luxembourg",
	    "prefix": "352"
	}, {
	    "iso2": "MO",
	    "name": "Macau",
	    "prefix": "853"
	}, {
	    "iso2": "MK",
	    "name": "Macedonia",
	    "prefix": "389"
	}, {
	    "iso2": "MG",
	    "name": "Madagascar",
	    "prefix": "261"
	}, {
	    "iso2": "MW",
	    "name": "Malawi",
	    "prefix": "265"
	}, {
	    "iso2": "MY",
	    "name": "Malaysia",
	    "prefix": "60"
	}, {
	    "iso2": "MV",
	    "name": "Maldives",
	    "prefix": "960"
	}, {
	    "iso2": "ML",
	    "name": "Mali",
	    "prefix": "223"
	}, {
	    "iso2": "MT",
	    "name": "Malta",
	    "prefix": "356"
	}, {
	    "iso2": "MH",
	    "name": "Marshall Islands",
	    "prefix": "692"
	}, {
	    "iso2": "MQ",
	    "name": "Martinique",
	    "prefix": "596"
	}, {
	    "iso2": "MR",
	    "name": "Mauritania",
	    "prefix": "222"
	}, {
	    "iso2": "MU",
	    "name": "Mauritius",
	    "prefix": "230"
	}, {
	    "iso2": "YT",
	    "name": "Mayotte",
	    "prefix": "262"
	}, {
	    "iso2": "MX",
	    "name": "Mexico",
	    "prefix": "52"
	}, {
	    "iso2": "FM",
	    "name": "Micronesia",
	    "prefix": "691"
	}, {
	    "iso2": "MD",
	    "name": "Moldova",
	    "prefix": "373"
	}, {
	    "iso2": "MC",
	    "name": "Monaco",
	    "prefix": "377"
	}, {
	    "iso2": "MN",
	    "name": "Mongolia",
	    "prefix": "976"
	}, {
	    "iso2": "ME",
	    "name": "Montenegro",
	    "prefix": "382"
	}, {
	    "iso2": "MS",
	    "name": "Montserrat",
	    "prefix": "1"
	}, {
	    "iso2": "MA",
	    "name": "Morocco",
	    "prefix": "212"
	}, {
	    "iso2": "MZ",
	    "name": "Mozambique",
	    "prefix": "258"
	}, {
	    "iso2": "MM",
	    "name": "Myanmar",
	    "prefix": "95"
	}, {
	    "iso2": "NA",
	    "name": "Namibia",
	    "prefix": "264"
	}, {
	    "iso2": "NR",
	    "name": "Nauru",
	    "prefix": "674"
	}, {
	    "iso2": "NP",
	    "name": "Nepal",
	    "prefix": "977"
	}, {
	    "iso2": "NL",
	    "name": "Netherlands",
	    "prefix": "31"
	}, {
	    "iso2": "NC",
	    "name": "New Caledonia",
	    "prefix": "687"
	}, {
	    "iso2": "NZ",
	    "name": "New Zealand",
	    "prefix": "64"
	}, {
	    "iso2": "NI",
	    "name": "Nicaragua",
	    "prefix": "505"
	}, {
	    "iso2": "NE",
	    "name": "Niger",
	    "prefix": "227"
	}, {
	    "iso2": "NG",
	    "name": "Nigeria",
	    "prefix": "234"
	}, {
	    "iso2": "NU",
	    "name": "Niue",
	    "prefix": "683"
	}, {
	    "iso2": "NF",
	    "name": "Norfolk Island",
	    "prefix": "672"
	}, {
	    "iso2": "KP",
	    "name": "North Korea",
	    "prefix": "850"
	}, {
	    "iso2": "MP",
	    "name": "Northern Mariana Islands",
	    "prefix": "1"
	}, {
	    "iso2": "NO",
	    "name": "Norway",
	    "prefix": "47"
	}, {
	    "iso2": "OM",
	    "name": "Oman",
	    "prefix": "968"
	}, {
	    "iso2": "PK",
	    "name": "Pakistan",
	    "prefix": "92"
	}, {
	    "iso2": "PW",
	    "name": "Palau",
	    "prefix": "680"
	}, {
	    "iso2": "PS",
	    "name": "Palestine",
	    "prefix": "970"
	}, {
	    "iso2": "PA",
	    "name": "Panama",
	    "prefix": "507"
	}, {
	    "iso2": "PG",
	    "name": "Papua New Guinea",
	    "prefix": "675"
	}, {
	    "iso2": "PY",
	    "name": "Paraguay",
	    "prefix": "595"
	}, {
	    "iso2": "PE",
	    "name": "Peru",
	    "prefix": "51"
	}, {
	    "iso2": "PH",
	    "name": "Philippines",
	    "prefix": "63"
	}, {
	    "iso2": "PN",
	    "name": "Pitcairn Islands",
	    "prefix": "870"
	}, {
	    "iso2": "PL",
	    "name": "Poland",
	    "prefix": "48"
	}, {
	    "iso2": "PT",
	    "name": "Portugal",
	    "prefix": "351"
	}, {
	    "iso2": "PR",
	    "name": "Puerto Rico",
	    "prefix": "1"
	}, {
	    "iso2": "QA",
	    "name": "Qatar",
	    "prefix": "974"
	}, {
	    "iso2": "RO",
	    "name": "Romania",
	    "prefix": "40"
	}, {
	    "iso2": "RU",
	    "name": "Russia",
	    "prefix": "7"
	}, {
	    "iso2": "RW",
	    "name": "Rwanda",
	    "prefix": "250"
	}, {
	    "iso2": "RE",
	    "name": "R\xE9union",
	    "prefix": "262"
	}, {
	    "iso2": "WS",
	    "name": "Samoa",
	    "prefix": "685"
	}, {
	    "iso2": "SM",
	    "name": "San Marino",
	    "prefix": "378"
	}, {
	    "iso2": "SA",
	    "name": "Saudi Arabia",
	    "prefix": "966"
	}, {
	    "iso2": "SN",
	    "name": "Senegal",
	    "prefix": "221"
	}, {
	    "iso2": "RS",
	    "name": "Serbia",
	    "prefix": "381 p"
	}, {
	    "iso2": "SC",
	    "name": "Seychelles",
	    "prefix": "248"
	}, {
	    "iso2": "SL",
	    "name": "Sierra Leone",
	    "prefix": "232"
	}, {
	    "iso2": "SG",
	    "name": "Singapore",
	    "prefix": "65"
	}, {
	    "iso2": "SX",
	    "name": "Sint Maarten",
	    "prefix": "1"
	}, {
	    "iso2": "SK",
	    "name": "Slovakia",
	    "prefix": "421"
	}, {
	    "iso2": "SI",
	    "name": "Slovenia",
	    "prefix": "386"
	}, {
	    "iso2": "SB",
	    "name": "Solomon Islands",
	    "prefix": "677"
	}, {
	    "iso2": "SO",
	    "name": "Somalia",
	    "prefix": "252"
	}, {
	    "iso2": "ZA",
	    "name": "South Africa",
	    "prefix": "27"
	}, {
	    "iso2": "GS",
	    "name": "South Georgia & South Sandwich Islands",
	    "prefix": "500"
	}, {
	    "iso2": "KR",
	    "name": "South Korea",
	    "prefix": "82"
	}, {
	    "iso2": "SS",
	    "name": "South Sudan",
	    "prefix": "211"
	}, {
	    "iso2": "ES",
	    "name": "Spain",
	    "prefix": "34"
	}, {
	    "iso2": "LK",
	    "name": "Sri Lanka",
	    "prefix": "94"
	}, {
	    "iso2": "BL",
	    "name": "St. Barth\xE9lemy",
	    "prefix": "590"
	}, {
	    "iso2": "SH",
	    "name": "St. Helena",
	    "prefix": "290 n"
	}, {
	    "iso2": "KN",
	    "name": "St. Kitts & Nevis",
	    "prefix": "1"
	}, {
	    "iso2": "LC",
	    "name": "St. Lucia",
	    "prefix": "1"
	}, {
	    "iso2": "MF",
	    "name": "St. Martin",
	    "prefix": "590"
	}, {
	    "iso2": "PM",
	    "name": "St. Pierre & Miquelon",
	    "prefix": "508"
	}, {
	    "iso2": "VC",
	    "name": "St. Vincent & Grenadines",
	    "prefix": "1"
	}, {
	    "iso2": "SD",
	    "name": "Sudan",
	    "prefix": "249"
	}, {
	    "iso2": "SR",
	    "name": "Suriname",
	    "prefix": "597"
	}, {
	    "iso2": "SJ",
	    "name": "Svalbard & Jan Mayen",
	    "prefix": "47"
	}, {
	    "iso2": "SZ",
	    "name": "Swaziland",
	    "prefix": "268"
	}, {
	    "iso2": "SE",
	    "name": "Sweden",
	    "prefix": "46"
	}, {
	    "iso2": "CH",
	    "name": "Switzerland",
	    "prefix": "41"
	}, {
	    "iso2": "SY",
	    "name": "Syria",
	    "prefix": "963"
	}, {
	    "iso2": "ST",
	    "name": "S\xE3o Tom\xE9 & Pr\xEDncipe",
	    "prefix": "239"
	}, {
	    "iso2": "TW",
	    "name": "Taiwan",
	    "prefix": "886"
	}, {
	    "iso2": "TJ",
	    "name": "Tajikistan",
	    "prefix": "992"
	}, {
	    "iso2": "TZ",
	    "name": "Tanzania",
	    "prefix": "255"
	}, {
	    "iso2": "TH",
	    "name": "Thailand",
	    "prefix": "66"
	}, {
	    "iso2": "TL",
	    "name": "Timor-Leste",
	    "prefix": "670"
	}, {
	    "iso2": "TG",
	    "name": "Togo",
	    "prefix": "228"
	}, {
	    "iso2": "TK",
	    "name": "Tokelau",
	    "prefix": "690"
	}, {
	    "iso2": "TO",
	    "name": "Tonga",
	    "prefix": "676"
	}, {
	    "iso2": "TT",
	    "name": "Trinidad & Tobago",
	    "prefix": "1"
	}, {
	    "iso2": "TN",
	    "name": "Tunisia",
	    "prefix": "216"
	}, {
	    "iso2": "TR",
	    "name": "Turkey",
	    "prefix": "90"
	}, {
	    "iso2": "TM",
	    "name": "Turkmenistan",
	    "prefix": "993"
	}, {
	    "iso2": "TC",
	    "name": "Turks & Caicos Islands",
	    "prefix": "1"
	}, {
	    "iso2": "TV",
	    "name": "Tuvalu",
	    "prefix": "688"
	}, {
	    "iso2": "VI",
	    "name": "U.S. Virgin Islands",
	    "prefix": "1"
	}, {
	    "iso2": "UG",
	    "name": "Uganda",
	    "prefix": "256"
	}, {
	    "iso2": "UA",
	    "name": "Ukraine",
	    "prefix": "380"
	}, {
	    "iso2": "AE",
	    "name": "United Arab Emirates",
	    "prefix": "971"
	}, {
	    "iso2": "UY",
	    "name": "Uruguay",
	    "prefix": "598"
	}, {
	    "iso2": "UZ",
	    "name": "Uzbekistan",
	    "prefix": "998"
	}, {
	    "iso2": "VU",
	    "name": "Vanuatu",
	    "prefix": "678"
	}, {
	    "iso2": "VA",
	    "name": "Vatican City",
	    "prefix": "39"
	}, {
	    "iso2": "VE",
	    "name": "Venezuela",
	    "prefix": "58"
	}, {
	    "iso2": "VN",
	    "name": "Vietnam",
	    "prefix": "84"
	}, {
	    "iso2": "WF",
	    "name": "Wallis & Futuna",
	    "prefix": "681"
	}, {
	    "iso2": "EH",
	    "name": "Western Sahara",
	    "prefix": "212"
	}, {
	    "iso2": "YE",
	    "name": "Yemen",
	    "prefix": "967"
	}, {
	    "iso2": "ZM",
	    "name": "Zambia",
	    "prefix": "260"
	}, {
	    "iso2": "ZW",
	    "name": "Zimbabwe",
	    "prefix": "263"
	}];


/***/ }),
/* 520 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.formatCount = formatCount;
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * formats numbers to fit into ~3 characters, suitable for badge counts
	 * e.g: 999, 9.9K, 99K, 0.9M, 9.9M, 99M, 0.9B, 9.9B
	 */
	function formatCount(count) {
	   if (count < 1000) return count;
	   if (count < 10000) return (count / 1000).toFixed(1) + "K";
	   if (count < 100000) return (count / 1000).toFixed(0) + "K";
	   if (count < 10000000) return (count / 1000000).toFixed(1) + "M";
	   if (count < 100000000) return (count / 1000000).toFixed(0) + "M";
	   return (count / 1000000000).toFixed(1) + "B"; // 10B is enough for anyone, right? :S
	}


/***/ }),
/* 521 */,
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.findReadReceiptFromUserId = findReadReceiptFromUserId;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * Given MatrixEvent containing receipts, return the first
	 * read receipt from the given user ID, or null if no such
	 * receipt exists.
	 */
	function findReadReceiptFromUserId(receiptEvent, userId) {
	    var receiptKeys = (0, _keys2.default)(receiptEvent.getContent());
	    for (var i = 0; i < receiptKeys.length; ++i) {
	        var rcpt = receiptEvent.getContent()[receiptKeys[i]];
	        if (rcpt['m.read'] && rcpt['m.read'][userId]) {
	            return rcpt;
	        }
	    }
	
	    return null;
	}


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var hljs = __webpack_require__(1273);
	
	hljs.registerLanguage('1c', __webpack_require__(1274));
	hljs.registerLanguage('accesslog', __webpack_require__(1275));
	hljs.registerLanguage('actionscript', __webpack_require__(1276));
	hljs.registerLanguage('apache', __webpack_require__(1277));
	hljs.registerLanguage('applescript', __webpack_require__(1278));
	hljs.registerLanguage('armasm', __webpack_require__(1279));
	hljs.registerLanguage('xml', __webpack_require__(1408));
	hljs.registerLanguage('asciidoc', __webpack_require__(1280));
	hljs.registerLanguage('aspectj', __webpack_require__(1281));
	hljs.registerLanguage('autohotkey', __webpack_require__(1282));
	hljs.registerLanguage('autoit', __webpack_require__(1283));
	hljs.registerLanguage('avrasm', __webpack_require__(1284));
	hljs.registerLanguage('axapta', __webpack_require__(1285));
	hljs.registerLanguage('bash', __webpack_require__(1286));
	hljs.registerLanguage('brainfuck', __webpack_require__(1287));
	hljs.registerLanguage('cal', __webpack_require__(1288));
	hljs.registerLanguage('capnproto', __webpack_require__(1289));
	hljs.registerLanguage('ceylon', __webpack_require__(1290));
	hljs.registerLanguage('clojure', __webpack_require__(1292));
	hljs.registerLanguage('clojure-repl', __webpack_require__(1291));
	hljs.registerLanguage('cmake', __webpack_require__(1293));
	hljs.registerLanguage('coffeescript', __webpack_require__(1294));
	hljs.registerLanguage('cpp', __webpack_require__(1295));
	hljs.registerLanguage('crmsh', __webpack_require__(1296));
	hljs.registerLanguage('crystal', __webpack_require__(1297));
	hljs.registerLanguage('cs', __webpack_require__(1298));
	hljs.registerLanguage('css', __webpack_require__(1299));
	hljs.registerLanguage('d', __webpack_require__(1300));
	hljs.registerLanguage('markdown', __webpack_require__(1345));
	hljs.registerLanguage('dart', __webpack_require__(1301));
	hljs.registerLanguage('delphi', __webpack_require__(1302));
	hljs.registerLanguage('diff', __webpack_require__(1303));
	hljs.registerLanguage('django', __webpack_require__(1304));
	hljs.registerLanguage('dns', __webpack_require__(1305));
	hljs.registerLanguage('dockerfile', __webpack_require__(1306));
	hljs.registerLanguage('dos', __webpack_require__(1307));
	hljs.registerLanguage('dust', __webpack_require__(1308));
	hljs.registerLanguage('elixir', __webpack_require__(1309));
	hljs.registerLanguage('elm', __webpack_require__(1310));
	hljs.registerLanguage('ruby', __webpack_require__(1377));
	hljs.registerLanguage('erb', __webpack_require__(1311));
	hljs.registerLanguage('erlang-repl', __webpack_require__(1312));
	hljs.registerLanguage('erlang', __webpack_require__(1313));
	hljs.registerLanguage('fix', __webpack_require__(1314));
	hljs.registerLanguage('fortran', __webpack_require__(1315));
	hljs.registerLanguage('fsharp', __webpack_require__(1316));
	hljs.registerLanguage('gams', __webpack_require__(1317));
	hljs.registerLanguage('gcode', __webpack_require__(1318));
	hljs.registerLanguage('gherkin', __webpack_require__(1319));
	hljs.registerLanguage('glsl', __webpack_require__(1320));
	hljs.registerLanguage('go', __webpack_require__(1321));
	hljs.registerLanguage('golo', __webpack_require__(1322));
	hljs.registerLanguage('gradle', __webpack_require__(1323));
	hljs.registerLanguage('groovy', __webpack_require__(1324));
	hljs.registerLanguage('haml', __webpack_require__(1325));
	hljs.registerLanguage('handlebars', __webpack_require__(1326));
	hljs.registerLanguage('haskell', __webpack_require__(1327));
	hljs.registerLanguage('haxe', __webpack_require__(1328));
	hljs.registerLanguage('http', __webpack_require__(1329));
	hljs.registerLanguage('inform7', __webpack_require__(1330));
	hljs.registerLanguage('ini', __webpack_require__(1331));
	hljs.registerLanguage('irpf90', __webpack_require__(1332));
	hljs.registerLanguage('java', __webpack_require__(1333));
	hljs.registerLanguage('javascript', __webpack_require__(1334));
	hljs.registerLanguage('json', __webpack_require__(1335));
	hljs.registerLanguage('julia', __webpack_require__(1336));
	hljs.registerLanguage('kotlin', __webpack_require__(1337));
	hljs.registerLanguage('lasso', __webpack_require__(1338));
	hljs.registerLanguage('less', __webpack_require__(1339));
	hljs.registerLanguage('lisp', __webpack_require__(1340));
	hljs.registerLanguage('livecodeserver', __webpack_require__(1341));
	hljs.registerLanguage('livescript', __webpack_require__(1342));
	hljs.registerLanguage('lua', __webpack_require__(1343));
	hljs.registerLanguage('makefile', __webpack_require__(1344));
	hljs.registerLanguage('mathematica', __webpack_require__(1346));
	hljs.registerLanguage('matlab', __webpack_require__(1347));
	hljs.registerLanguage('mel', __webpack_require__(1348));
	hljs.registerLanguage('mercury', __webpack_require__(1349));
	hljs.registerLanguage('mizar', __webpack_require__(1350));
	hljs.registerLanguage('perl', __webpack_require__(1362));
	hljs.registerLanguage('mojolicious', __webpack_require__(1351));
	hljs.registerLanguage('monkey', __webpack_require__(1352));
	hljs.registerLanguage('nginx', __webpack_require__(1353));
	hljs.registerLanguage('nimrod', __webpack_require__(1354));
	hljs.registerLanguage('nix', __webpack_require__(1355));
	hljs.registerLanguage('nsis', __webpack_require__(1356));
	hljs.registerLanguage('objectivec', __webpack_require__(1357));
	hljs.registerLanguage('ocaml', __webpack_require__(1358));
	hljs.registerLanguage('openscad', __webpack_require__(1359));
	hljs.registerLanguage('oxygene', __webpack_require__(1360));
	hljs.registerLanguage('parser3', __webpack_require__(1361));
	hljs.registerLanguage('pf', __webpack_require__(1363));
	hljs.registerLanguage('php', __webpack_require__(1364));
	hljs.registerLanguage('powershell', __webpack_require__(1365));
	hljs.registerLanguage('processing', __webpack_require__(1366));
	hljs.registerLanguage('profile', __webpack_require__(1367));
	hljs.registerLanguage('prolog', __webpack_require__(1368));
	hljs.registerLanguage('protobuf', __webpack_require__(1369));
	hljs.registerLanguage('puppet', __webpack_require__(1370));
	hljs.registerLanguage('python', __webpack_require__(1371));
	hljs.registerLanguage('q', __webpack_require__(1372));
	hljs.registerLanguage('r', __webpack_require__(1373));
	hljs.registerLanguage('rib', __webpack_require__(1374));
	hljs.registerLanguage('roboconf', __webpack_require__(1375));
	hljs.registerLanguage('rsl', __webpack_require__(1376));
	hljs.registerLanguage('ruleslanguage', __webpack_require__(1378));
	hljs.registerLanguage('rust', __webpack_require__(1379));
	hljs.registerLanguage('scala', __webpack_require__(1380));
	hljs.registerLanguage('scheme', __webpack_require__(1381));
	hljs.registerLanguage('scilab', __webpack_require__(1382));
	hljs.registerLanguage('scss', __webpack_require__(1383));
	hljs.registerLanguage('smali', __webpack_require__(1384));
	hljs.registerLanguage('smalltalk', __webpack_require__(1385));
	hljs.registerLanguage('sml', __webpack_require__(1386));
	hljs.registerLanguage('sqf', __webpack_require__(1387));
	hljs.registerLanguage('sql', __webpack_require__(1388));
	hljs.registerLanguage('stata', __webpack_require__(1389));
	hljs.registerLanguage('step21', __webpack_require__(1390));
	hljs.registerLanguage('stylus', __webpack_require__(1391));
	hljs.registerLanguage('swift', __webpack_require__(1392));
	hljs.registerLanguage('tcl', __webpack_require__(1393));
	hljs.registerLanguage('tex', __webpack_require__(1394));
	hljs.registerLanguage('thrift', __webpack_require__(1395));
	hljs.registerLanguage('tp', __webpack_require__(1396));
	hljs.registerLanguage('twig', __webpack_require__(1397));
	hljs.registerLanguage('typescript', __webpack_require__(1398));
	hljs.registerLanguage('vala', __webpack_require__(1399));
	hljs.registerLanguage('vbnet', __webpack_require__(1400));
	hljs.registerLanguage('vbscript', __webpack_require__(1402));
	hljs.registerLanguage('vbscript-html', __webpack_require__(1401));
	hljs.registerLanguage('verilog', __webpack_require__(1403));
	hljs.registerLanguage('vhdl', __webpack_require__(1404));
	hljs.registerLanguage('vim', __webpack_require__(1405));
	hljs.registerLanguage('x86asm', __webpack_require__(1406));
	hljs.registerLanguage('xl', __webpack_require__(1407));
	hljs.registerLanguage('xquery', __webpack_require__(1409));
	hljs.registerLanguage('zephir', __webpack_require__(1410));
	
	module.exports = hljs;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1415);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1417);
	exports.encode = exports.stringify = __webpack_require__(1418);


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSafari = exports.isFirefox = undefined;
	
	var _memoize = __webpack_require__(484);
	
	var _memoize2 = _interopRequireDefault(_memoize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
	  return (/firefox/i.test(navigator.userAgent)
	  );
	});
	var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
	  return Boolean(window.safari);
	});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = DragDropContext;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dndCore = __webpack_require__(899);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(301);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _checkDecoratorArguments = __webpack_require__(226);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
	  dragDropManager: _react.PropTypes.object.isRequired
	};
	
	var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
	  return {
	    dragDropManager: new _dndCore.DragDropManager(backend, context)
	  };
	};
	
	var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
	  // Auto-detect ES6 default export for people still using ES5
	  var backend = backendOrModule;
	  if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
	    backend = backend.default;
	  }
	  (0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
	  return backend;
	};
	
	function DragDropContext(backendOrModule) {
	  _checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	
	  var backend = unpackBackendForEs5Users(backendOrModule);
	  var childContext = createChildContext(backend);
	
	  return function decorateContext(DecoratedComponent) {
	    var _class, _temp;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    var DragDropContextContainer = (_temp = _class = function (_Component) {
	      _inherits(DragDropContextContainer, _Component);
	
	      function DragDropContextContainer() {
	        _classCallCheck(this, DragDropContextContainer);
	
	        return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
	      }
	
	      _createClass(DragDropContextContainer, [{
	        key: 'getDecoratedComponentInstance',
	        value: function getDecoratedComponentInstance() {
	          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
	          return this.child;
	        }
	      }, {
	        key: 'getManager',
	        value: function getManager() {
	          return childContext.dragDropManager;
	        }
	      }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	          return childContext;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this2 = this;
	
	          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
	            ref: function ref(child) {
	              return _this2.child = child;
	            }
	          }));
	        }
	      }]);
	
	      return DragDropContextContainer;
	    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
	
	
	    return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
	  };
	}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areOptionsEqual;
	
	var _shallowEqual = __webpack_require__(342);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function areOptionsEqual(nextOptions, currentOptions) {
	  if (currentOptions === nextOptions) {
	    return true;
	  }
	
	  return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = decorateHandler;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _disposables = __webpack_require__(892);
	
	var _isPlainObject = __webpack_require__(114);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(301);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _shallowEqual = __webpack_require__(342);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(532);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function decorateHandler(_ref) {
	  var _class, _temp;
	
	  var DecoratedComponent = _ref.DecoratedComponent,
	      createHandler = _ref.createHandler,
	      createMonitor = _ref.createMonitor,
	      createConnector = _ref.createConnector,
	      registerHandler = _ref.registerHandler,
	      containerDisplayName = _ref.containerDisplayName,
	      getType = _ref.getType,
	      collect = _ref.collect,
	      options = _ref.options;
	  var _options$arePropsEqua = options.arePropsEqual,
	      arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
	  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	  var DragDropContainer = (_temp = _class = function (_Component) {
	    _inherits(DragDropContainer, _Component);
	
	    _createClass(DragDropContainer, [{
	      key: 'getHandlerId',
	      value: function getHandlerId() {
	        return this.handlerId;
	      }
	    }, {
	      key: 'getDecoratedComponentInstance',
	      value: function getDecoratedComponentInstance() {
	        return this.decoratedComponentInstance;
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
	      }
	    }]);
	
	    function DragDropContainer(props, context) {
	      _classCallCheck(this, DragDropContainer);
	
	      var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleChildRef = _this.handleChildRef.bind(_this);
	
	      (0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	      _this.manager = _this.context.dragDropManager;
	      _this.handlerMonitor = createMonitor(_this.manager);
	      _this.handlerConnector = createConnector(_this.manager.getBackend());
	      _this.handler = createHandler(_this.handlerMonitor);
	
	      _this.disposable = new _disposables.SerialDisposable();
	      _this.receiveProps(props);
	      _this.state = _this.getCurrentState();
	      _this.dispose();
	      return _this;
	    }
	
	    _createClass(DragDropContainer, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.isCurrentlyMounted = true;
	        this.disposable = new _disposables.SerialDisposable();
	        this.currentType = null;
	        this.receiveProps(this.props);
	        this.handleChange();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!arePropsEqual(nextProps, this.props)) {
	          this.receiveProps(nextProps);
	          this.handleChange();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.dispose();
	        this.isCurrentlyMounted = false;
	      }
	    }, {
	      key: 'receiveProps',
	      value: function receiveProps(props) {
	        this.handler.receiveProps(props);
	        this.receiveType(getType(props));
	      }
	    }, {
	      key: 'receiveType',
	      value: function receiveType(type) {
	        if (type === this.currentType) {
	          return;
	        }
	
	        this.currentType = type;
	
	        var _registerHandler = registerHandler(type, this.handler, this.manager),
	            handlerId = _registerHandler.handlerId,
	            unregister = _registerHandler.unregister;
	
	        this.handlerId = handlerId;
	        this.handlerMonitor.receiveHandlerId(handlerId);
	        this.handlerConnector.receiveHandlerId(handlerId);
	
	        var globalMonitor = this.manager.getMonitor();
	        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
	        this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange() {
	        if (!this.isCurrentlyMounted) {
	          return;
	        }
	
	        var nextState = this.getCurrentState();
	        if (!(0, _shallowEqual2.default)(nextState, this.state)) {
	          this.setState(nextState);
	        }
	      }
	    }, {
	      key: 'dispose',
	      value: function dispose() {
	        this.disposable.dispose();
	        this.handlerConnector.receiveHandlerId(null);
	      }
	    }, {
	      key: 'handleChildRef',
	      value: function handleChildRef(component) {
	        this.decoratedComponentInstance = component;
	        this.handler.receiveComponent(component);
	      }
	    }, {
	      key: 'getCurrentState',
	      value: function getCurrentState() {
	        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
	
	        if (false) {
	          (0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
	        }
	
	        return nextState;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	          ref: this.handleChildRef
	        }));
	      }
	    }]);
	
	    return DragDropContainer;
	  }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
	    dragDropManager: _react.PropTypes.object.isRequired
	  }, _temp);
	
	
	  return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
	}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	       value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isValidType;
	
	var _isArray = __webpack_require__(37);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidType(type, allowArray) {
	       return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
	              return isValidType(t, false);
	       });
	}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = shallowEqualScalar;
	function shallowEqualScalar(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i += 1) {
	    if (!hasOwn.call(objB, keysA[i])) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = wrapConnectorHooks;
	
	var _react = __webpack_require__(1);
	
	var _cloneWithRef = __webpack_require__(1439);
	
	var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throwIfCompositeComponentElement(element) {
	  // Custom components can no longer be wrapped directly in React DnD 2.0
	  // so that we don't need to depend on findDOMNode() from react-dom.
	  if (typeof element.type === 'string') {
	    return;
	  }
	
	  var displayName = element.type.displayName || element.type.name || 'the component';
	
	  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
	}
	
	function wrapHookToRecognizeElement(hook) {
	  return function () {
	    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    // When passed a node, call the hook straight away.
	    if (!(0, _react.isValidElement)(elementOrNode)) {
	      var node = elementOrNode;
	      hook(node, options);
	      return undefined;
	    }
	
	    // If passed a ReactElement, clone it and attach this function as a ref.
	    // This helps us achieve a neat API where user doesn't even know that refs
	    // are being used under the hood.
	    var element = elementOrNode;
	    throwIfCompositeComponentElement(element);
	
	    // When no options are passed, use the hook directly
	    var ref = options ? function (node) {
	      return hook(node, options);
	    } : hook;
	
	    return (0, _cloneWithRef2.default)(element, ref);
	  };
	}
	
	function wrapConnectorHooks(hooks) {
	  var wrappedHooks = {};
	
	  Object.keys(hooks).forEach(function (key) {
	    var hook = hooks[key];
	    var wrappedHook = wrapHookToRecognizeElement(hook);
	    wrappedHooks[key] = function () {
	      return wrappedHook;
	    };
	  });
	
	  return wrappedHooks;
	}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(120);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(144);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstrumentation = __webpack_require__(65);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1501);
	var warning = __webpack_require__(14);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var LinkedValueUtils = __webpack_require__(349);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(75);
	
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1461);
	
	var containsNode = __webpack_require__(297);
	var focusNode = __webpack_require__(452);
	var getActiveElement = __webpack_require__(203);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMLazyTree = __webpack_require__(143);
	var DOMProperty = __webpack_require__(144);
	var React = __webpack_require__(146);
	var ReactBrowserEventEmitter = __webpack_require__(227);
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMContainerInfo = __webpack_require__(1455);
	var ReactDOMFeatureFlags = __webpack_require__(1457);
	var ReactFeatureFlags = __webpack_require__(539);
	var ReactInstanceMap = __webpack_require__(175);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactMarkupChecksum = __webpack_require__(1471);
	var ReactReconciler = __webpack_require__(145);
	var ReactUpdateQueue = __webpack_require__(352);
	var ReactUpdates = __webpack_require__(75);
	
	var emptyObject = __webpack_require__(164);
	var instantiateReactComponent = __webpack_require__(549);
	var invariant = __webpack_require__(7);
	var setInnerHTML = __webpack_require__(231);
	var shouldUpdateReactComponent = __webpack_require__(358);
	var warning = __webpack_require__(14);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var React = __webpack_require__(146);
	
	var invariant = __webpack_require__(7);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(543);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(42);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(22);
	
	var ReactCompositeComponent = __webpack_require__(1452);
	var ReactEmptyComponent = __webpack_require__(538);
	var ReactHostComponent = __webpack_require__(540);
	
	var getNextDebugID = __webpack_require__(1513);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(42);
	var escapeTextContentForBrowser = __webpack_require__(230);
	var setInnerHTML = __webpack_require__(231);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var REACT_ELEMENT_TYPE = __webpack_require__(1467);
	
	var getIteratorFn = __webpack_require__(1498);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(348);
	var warning = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(148);
	
	var ReactCurrentOwner = __webpack_require__(87);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	module.exports = Readable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(339);
	/*</replacement>*/
	
	/*<replacement>*/
	var isArray = __webpack_require__(459);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(56).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(558);
	/*</replacement>*/
	
	var Buffer = __webpack_require__(88).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(181);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(158);
	util.inherits = __webpack_require__(72);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1541);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1518);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(122);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(365).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(122);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options && typeof options.read === 'function') this._read = options.read;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	
	  if (!state.objectMode && typeof chunk === 'string') {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = bufferShim.from(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var _e = new Error('stream.unshift() after end event');
	      stream.emit('error', _e);
	    } else {
	      var skipAdd;
	      if (state.decoder && !addToFront && !encoding) {
	        chunk = state.decoder.write(chunk);
	        skipAdd = !state.objectMode && chunk.length === 0;
	      }
	
	      if (!addToFront) state.reading = false;
	
	      // Don't add to the buffer if we've decoded to an empty string chunk and
	      // we're not in object mode
	      if (!skipAdd) {
	        // if we want the data now, just emit it.
	        if (state.flowing && state.length === 0 && !state.sync) {
	          stream.emit('data', chunk);
	          stream.read(0);
	        } else {
	          // update the buffer info.
	          state.length += state.objectMode ? 1 : chunk.length;
	          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	          if (state.needReadable) emitReadable(stream);
	        }
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(365).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = bufferShim.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(122);
	
	/*<replacement>*/
	var util = __webpack_require__(158);
	util.inherits = __webpack_require__(72);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(56).EventEmitter;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(64)))

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var htmlparser = __webpack_require__(166);
	var extend = __webpack_require__(1536);
	var quoteRegexp = __webpack_require__(1524);
	
	function each(obj, cb) {
	  if (obj) Object.keys(obj).forEach(function (key) {
	    cb(obj[key], key);
	  });
	}
	
	// Avoid false positives with .__proto__, .hasOwnProperty, etc.
	function has(obj, key) {
	  return ({}).hasOwnProperty.call(obj, key);
	}
	
	module.exports = sanitizeHtml;
	
	// Ignore the _recursing flag; it's there for recursive
	// invocation as a guard against this exploit:
	// https://github.com/fb55/htmlparser2/issues/105
	
	function sanitizeHtml(html, options, _recursing) {
	  var result = '';
	
	  function Frame(tag, attribs) {
	    var that = this;
	    this.tag = tag;
	    this.attribs = attribs || {};
	    this.tagPosition = result.length;
	    this.text = ''; // Node inner text
	
	    this.updateParentNodeText = function() {
	      if (stack.length) {
	          var parentFrame = stack[stack.length - 1];
	          parentFrame.text += that.text;
	      }
	    };
	  }
	
	  if (!options) {
	    options = sanitizeHtml.defaults;
	    options.parser = htmlParserDefaults;
	  } else {
	    options = extend(sanitizeHtml.defaults, options);
	    if (options.parser) {
	      options.parser = extend(htmlParserDefaults, options.parser);
	    } else {
	      options.parser = htmlParserDefaults;
	    }
	  }
	
	  // Tags that contain something other than HTML, or where discarding
	  // the text when the tag is disallowed makes sense for other reasons.
	  // If we are not allowing these tags, we should drop their content too.
	  // For other tags you would drop the tag but keep its content.
	  var nonTextTagsArray = options.nonTextTags || [ 'script', 'style', 'textarea' ];
	  var allowedAttributesMap;
	  var allowedAttributesGlobMap;
	  if(options.allowedAttributes) {
	    allowedAttributesMap = {};
	    allowedAttributesGlobMap = {};
	    each(options.allowedAttributes, function(attributes, tag) {
	      allowedAttributesMap[tag] = [];
	      var globRegex = [];
	      attributes.forEach(function(name) {
	        if(name.indexOf('*') >= 0) {
	          globRegex.push(quoteRegexp(name).replace(/\\\*/g, '.*'));
	        } else {
	          allowedAttributesMap[tag].push(name);
	        }
	      });
	      allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
	    });
	  }
	  var allowedClassesMap = {};
	  each(options.allowedClasses, function(classes, tag) {
	    // Implicitly allows the class attribute
	    if(allowedAttributesMap) {
	      if (!has(allowedAttributesMap, tag)) {
	        allowedAttributesMap[tag] = [];
	      }
	      allowedAttributesMap[tag].push('class');
	    }
	
	    allowedClassesMap[tag] = classes;
	  });
	
	  var transformTagsMap = {};
	  var transformTagsAll;
	  each(options.transformTags, function(transform, tag) {
	    var transFun;
	    if (typeof transform === 'function') {
	      transFun = transform;
	    } else if (typeof transform === "string") {
	      transFun = sanitizeHtml.simpleTransform(transform);
	    }
	    if (tag === '*') {
	      transformTagsAll = transFun;
	    } else {
	      transformTagsMap[tag] = transFun;
	    }
	  });
	
	  var depth = 0;
	  var stack = [];
	  var skipMap = {};
	  var transformMap = {};
	  var skipText = false;
	  var skipTextDepth = 0;
	
	  var parser = new htmlparser.Parser({
	    onopentag: function(name, attribs) {
	      if (skipText) {
	        skipTextDepth++;
	        return;
	      }
	      var frame = new Frame(name, attribs);
	      stack.push(frame);
	
	      var skip = false;
	      var hasText = frame.text ? true : false;
	      var transformedTag;
	      if (has(transformTagsMap, name)) {
	        transformedTag = transformTagsMap[name](name, attribs);
	
	        frame.attribs = attribs = transformedTag.attribs;
	
	        if (transformedTag.text !== undefined) {
	          frame.innerText = transformedTag.text;
	        }
	
	        if (name !== transformedTag.tagName) {
	          frame.name = name = transformedTag.tagName;
	          transformMap[depth] = transformedTag.tagName;
	        }
	      }
	      if (transformTagsAll) {
	        transformedTag = transformTagsAll(name, attribs);
	
	        frame.attribs = attribs = transformedTag.attribs;
	        if (name !== transformedTag.tagName) {
	          frame.name = name = transformedTag.tagName;
	          transformMap[depth] = transformedTag.tagName;
	        }
	      }
	
	      if (options.allowedTags && options.allowedTags.indexOf(name) === -1) {
	        skip = true;
	        if (nonTextTagsArray.indexOf(name) !== -1) {
	          skipText = true;
	          skipTextDepth = 1;
	        }
	        skipMap[depth] = true;
	      }
	      depth++;
	      if (skip) {
	        // We want the contents but not this tag
	        return;
	      }
	      result += '<' + name;
	      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
	        each(attribs, function(value, a) {
	          if (!allowedAttributesMap ||
	              (has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 ) ||
	              (allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 ) ||
	              (has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a)) ||
	              (allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a))) {
	            if ((a === 'href') || (a === 'src')) {
	              if (naughtyHref(name, value)) {
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            if (a === 'class') {
	              value = filterClasses(value, allowedClassesMap[name]);
	              if (!value.length) {
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            result += ' ' + a;
	            if (value.length) {
	              result += '="' + escapeHtml(value) + '"';
	            }
	          } else {
	            delete frame.attribs[a];
	          }
	        });
	      }
	      if (options.selfClosing.indexOf(name) !== -1) {
	        result += " />";
	      } else {
	        result += ">";
	        if (frame.innerText && !hasText && !options.textFilter) {
	          result += frame.innerText;
	        }
	      }
	    },
	    ontext: function(text) {
	      if (skipText) {
	        return;
	      }
	      var lastFrame = stack[stack.length-1];
	      var tag;
	
	      if (lastFrame) {
	        tag = lastFrame.tag;
	        // If inner text was set by transform function then let's use it
	        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
	      }
	
	      if ((tag === 'script') || (tag === 'style')) {
	        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
	        // script tags is, by definition, game over for XSS protection, so if that's
	        // your concern, don't allow them. The same is essentially true for style tags
	        // which have their own collection of XSS vectors.
	        result += text;
	      } else {
	        var escaped = escapeHtml(text);
	        if (options.textFilter) {
	          result += options.textFilter(escaped);
	        } else {
	          result += escaped;
	        }
	      }
	      if (stack.length) {
	           var frame = stack[stack.length - 1];
	           frame.text += text;
	      }
	    },
	    onclosetag: function(name) {
	
	      if (skipText) {
	        skipTextDepth--;
	        if (!skipTextDepth) {
	          skipText = false;
	        } else {
	          return;
	        }
	      }
	
	      var frame = stack.pop();
	      if (!frame) {
	        // Do not crash on bad markup
	        return;
	      }
	      skipText = false;
	      depth--;
	      if (skipMap[depth]) {
	        delete skipMap[depth];
	        frame.updateParentNodeText();
	        return;
	      }
	
	      if (transformMap[depth]) {
	        name = transformMap[depth];
	        delete transformMap[depth];
	      }
	
	      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
	         result = result.substr(0, frame.tagPosition);
	         return;
	      }
	
	      frame.updateParentNodeText();
	
	      if (options.selfClosing.indexOf(name) !== -1) {
	         // Already output />
	         return;
	      }
	
	      result += "</" + name + ">";
	    }
	  }, options.parser);
	  parser.write(html);
	  parser.end();
	
	  return result;
	
	  function escapeHtml(s) {
	    if (typeof(s) !== 'string') {
	      s = s + '';
	    }
	    return s.replace(/\&/g, '&amp;').replace(/</g, '&lt;').replace(/\>/g, '&gt;').replace(/\"/g, '&quot;');
	  }
	
	  function naughtyHref(name, href) {
	    // Browsers ignore character codes of 32 (space) and below in a surprising
	    // number of situations. Start reading here:
	    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
	    href = href.replace(/[\x00-\x20]+/g, '');
	    // Clobber any comments in URLs, which the browser might
	    // interpret inside an XML data island, allowing
	    // a javascript: URL to be snuck through
	    href = href.replace(/<\!\-\-.*?\-\-\>/g, '');
	    // Case insensitive so we don't get faked out by JAVASCRIPT #1
	    var matches = href.match(/^([a-zA-Z]+)\:/);
	    if (!matches) {
	      // Protocol-relative URL: "//some.evil.com/nasty"
	      if (href.match(/^\/\//)) {
	        return !options.allowProtocolRelative;
	      }
	
	      // No scheme
	      return false;
	    }
	    var scheme = matches[1].toLowerCase();
	
	    if (has(options.allowedSchemesByTag, name)) {
	      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
	    }
	
	    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
	  }
	
	  function filterClasses(classes, allowed) {
	    if (!allowed) {
	      // The class attribute is allowed without filtering on this tag
	      return classes;
	    }
	    classes = classes.split(/\s+/);
	    return classes.filter(function(clss) {
	      return allowed.indexOf(clss) !== -1;
	    }).join(' ');
	  }
	}
	
	// Defaults are accessible to you so that you can use them as a starting point
	// programmatically if you wish
	
	var htmlParserDefaults = {
	  decodeEntities: true
	};
	sanitizeHtml.defaults = {
	  allowedTags: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
	    'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
	    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre' ],
	  allowedAttributes: {
	    a: [ 'href', 'name', 'target' ],
	    // We don't currently allow img itself by default, but this
	    // would make sense if we did
	    img: [ 'src' ]
	  },
	  // Lots of these won't come up by default because we don't allow them
	  selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
	  // URL schemes we permit
	  allowedSchemes: [ 'http', 'https', 'ftp', 'mailto' ],
	  allowedSchemesByTag: {},
	  allowProtocolRelative: true
	};
	
	sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
	  merge = (merge === undefined) ? true : merge;
	  newAttribs = newAttribs || {};
	
	  return function(tagName, attribs) {
	    var attrib;
	    if (merge) {
	      for (attrib in newAttribs) {
	        attribs[attrib] = newAttribs[attrib];
	      }
	    } else {
	      attribs = newAttribs;
	    }
	
	    return {
	      tagName: newTagName,
	      attribs: attribs
	    };
	  };
	};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.12
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.12',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            var margedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    margedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    margedRegexes[i] = regexes[i];
	                }
	            }
	            return margedRegexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
	        },
	        trim : function (str) {
	          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function () {
	
	            var result, i = 0, j, k, p, q, matches, match, args = arguments;
	
	            // loop through all regexes maps
	            while (i < args.length && !matches) {
	
	                var regex = args[i],       // even sequence (0,2,4,..)
	                    props = args[i + 1];   // odd sequence (1,3,5,..)
	
	                // construct object barebones
	                if (typeof result === UNDEF_TYPE) {
	                    result = {};
	                    for (p in props) {
	                        if (props.hasOwnProperty(p)){
	                            q = props[p];
	                            if (typeof q === OBJ_TYPE) {
	                                result[q[0]] = undefined;
	                            } else {
	                                result[q] = undefined;
	                            }
	                        }
	                    }
	                }
	
	                // try matching uastring with regexes
	                j = k = 0;
	                while (j < regex.length && !matches) {
	                    matches = regex[j++].exec(this.getUA());
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        result[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        result[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                result[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            return result;
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	            ], [NAME, VERSION], [
	
	            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
	            ], [[NAME, 'Opera Mini'], VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
	            ], [NAME, VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
	            ], [[NAME, 'WeChat'], VERSION], [
	
	            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
	            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [
	
	            /android.+samsungbrowser\/([\w\.]+)/i,
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            /(qqbrowser)[\/\s]?([\w\.]+)/i
	                                                                                // QQBrowser
	            ], [NAME, VERSION], [
	
	            /(uc\s?browser)[\/\s]?([\w\.]+)/i,
	            /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
	            /juc.+(ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	
	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////
	
	            , [
	
	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [
	
	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [
	
	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [
	
	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [
	
	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [
	
	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [
	
	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [
	
	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [
	
	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [
	
	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [
	
	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [
	
	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [
	
	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [
	
	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [
	
	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [
	
	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [
	
	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [
	
	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [
	
	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [
	
	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [
	
	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [
	
	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [
	
	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]
	
	            //////////////////////
	            // Media players END
	            ////////////////////*/
	
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(hp).+(tablet)/i,                                                  // HP Tablet
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /(nexus\s6p)/i                                                      // Huawei Nexus 6P
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
	
	            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s6)/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
	            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
	
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /smart-tv.+(samsung)/i
	            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	
	            /android.+a000(1)\s+build/i                                         // OnePlus
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            /\s(tablet)[;\/]/i,                                                 // Unidentifiable Tablet
	            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL]
	
	            /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	
	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	
	            /(R1001)/i                                                          // Oppo R1001
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /(X9006)/i                                                          // Oppo Find 7a
	            ], [[MODEL, 'Find 7a'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R2001)/i                                                          // Oppo YOYO R2001
	            ], [[MODEL, 'Yoyo R2001'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R815)/i                                                           // Oppo Clover R815
	            ], [[MODEL, 'Clover R815'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	             /(U707)/i                                                          // Oppo Find Way S
	            ], [[MODEL, 'Find Way S'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	
	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	
	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	
	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	
	            /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
	            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(haiku)\s(\w+)/i                                                  // Haiku
	            ], [NAME, VERSION],[
	
	            /(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i              // iOS
	            ], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	
	    var UAParser = function (uastring, extensions) {
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	
	        this.getBrowser = function () {
	            var browser = mapper.rgx.apply(this, rgxmap.browser);
	            browser.major = util.major(browser.version);
	            return browser;
	        };
	        this.getCPU = function () {
	            return mapper.rgx.apply(this, rgxmap.cpu);
	        };
	        this.getDevice = function () {
	            return mapper.rgx.apply(this, rgxmap.device);
	        };
	        this.getEngine = function () {
	            return mapper.rgx.apply(this, rgxmap.engine);
	        };
	        this.getOS = function () {
	            return mapper.rgx.apply(this, rgxmap.os);
	        };
	        this.getResult = function() {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            return this;
	        };
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(562)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window.jQuery || window.Zepto;
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function() {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ }),
/* 562 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _BottomLeftMenu = __webpack_require__(564);
	
	var _BottomLeftMenu2 = _interopRequireDefault(_BottomLeftMenu);
	
	var _CompatibilityPage = __webpack_require__(565);
	
	var _CompatibilityPage2 = _interopRequireDefault(_CompatibilityPage);
	
	var _HomePage = __webpack_require__(566);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _LeftPanel = __webpack_require__(567);
	
	var _LeftPanel2 = _interopRequireDefault(_LeftPanel);
	
	var _RightPanel = __webpack_require__(568);
	
	var _RightPanel2 = _interopRequireDefault(_RightPanel);
	
	var _RoomDirectory = __webpack_require__(569);
	
	var _RoomDirectory2 = _interopRequireDefault(_RoomDirectory);
	
	var _RoomSubList = __webpack_require__(570);
	
	var _RoomSubList2 = _interopRequireDefault(_RoomSubList);
	
	var _SearchBox = __webpack_require__(571);
	
	var _SearchBox2 = _interopRequireDefault(_SearchBox);
	
	var _ViewSource = __webpack_require__(572);
	
	var _ViewSource2 = _interopRequireDefault(_ViewSource);
	
	var _MessageContextMenu = __webpack_require__(573);
	
	var _MessageContextMenu2 = _interopRequireDefault(_MessageContextMenu);
	
	var _RoomTileContextMenu = __webpack_require__(574);
	
	var _RoomTileContextMenu2 = _interopRequireDefault(_RoomTileContextMenu);
	
	var _BugReportDialog = __webpack_require__(575);
	
	var _BugReportDialog2 = _interopRequireDefault(_BugReportDialog);
	
	var _ChangelogDialog = __webpack_require__(576);
	
	var _ChangelogDialog2 = _interopRequireDefault(_ChangelogDialog);
	
	var _NetworkDropdown = __webpack_require__(577);
	
	var _NetworkDropdown2 = _interopRequireDefault(_NetworkDropdown);
	
	var _ImageView = __webpack_require__(578);
	
	var _ImageView2 = _interopRequireDefault(_ImageView);
	
	var _Spinner = __webpack_require__(579);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _GuestWarningBar = __webpack_require__(580);
	
	var _GuestWarningBar2 = _interopRequireDefault(_GuestWarningBar);
	
	var _MatrixToolbar = __webpack_require__(581);
	
	var _MatrixToolbar2 = _interopRequireDefault(_MatrixToolbar);
	
	var _NewVersionBar = __webpack_require__(582);
	
	var _NewVersionBar2 = _interopRequireDefault(_NewVersionBar);
	
	var _VectorCustomServerDialog = __webpack_require__(583);
	
	var _VectorCustomServerDialog2 = _interopRequireDefault(_VectorCustomServerDialog);
	
	var _VectorLoginFooter = __webpack_require__(584);
	
	var _VectorLoginFooter2 = _interopRequireDefault(_VectorLoginFooter);
	
	var _VectorLoginHeader = __webpack_require__(585);
	
	var _VectorLoginHeader2 = _interopRequireDefault(_VectorLoginHeader);
	
	var _DateSeparator = __webpack_require__(586);
	
	var _DateSeparator2 = _interopRequireDefault(_DateSeparator);
	
	var _MessageTimestamp = __webpack_require__(587);
	
	var _MessageTimestamp2 = _interopRequireDefault(_MessageTimestamp);
	
	var _DNDRoomTile = __webpack_require__(588);
	
	var _DNDRoomTile2 = _interopRequireDefault(_DNDRoomTile);
	
	var _RoomDropTarget = __webpack_require__(589);
	
	var _RoomDropTarget2 = _interopRequireDefault(_RoomDropTarget);
	
	var _RoomTooltip = __webpack_require__(590);
	
	var _RoomTooltip2 = _interopRequireDefault(_RoomTooltip);
	
	var _SearchBar = __webpack_require__(591);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _IntegrationsManager = __webpack_require__(592);
	
	var _IntegrationsManager2 = _interopRequireDefault(_IntegrationsManager);
	
	var _Notifications = __webpack_require__(593);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/*
	 * THIS FILE IS AUTO-GENERATED
	 * You can edit it you like, but your changes will be overwritten,
	 * so you'd just be trying to swim upstream like a salmon.
	 * You are not a salmon.
	 *
	 * To update it, run:
	 *    ./reskindex.js -h header
	 */
	
	module.exports.components = __webpack_require__(1172).components;
	
	_BottomLeftMenu2.default && (module.exports.components['structures.BottomLeftMenu'] = _BottomLeftMenu2.default);
	
	_CompatibilityPage2.default && (module.exports.components['structures.CompatibilityPage'] = _CompatibilityPage2.default);
	
	_HomePage2.default && (module.exports.components['structures.HomePage'] = _HomePage2.default);
	
	_LeftPanel2.default && (module.exports.components['structures.LeftPanel'] = _LeftPanel2.default);
	
	_RightPanel2.default && (module.exports.components['structures.RightPanel'] = _RightPanel2.default);
	
	_RoomDirectory2.default && (module.exports.components['structures.RoomDirectory'] = _RoomDirectory2.default);
	
	_RoomSubList2.default && (module.exports.components['structures.RoomSubList'] = _RoomSubList2.default);
	
	_SearchBox2.default && (module.exports.components['structures.SearchBox'] = _SearchBox2.default);
	
	_ViewSource2.default && (module.exports.components['structures.ViewSource'] = _ViewSource2.default);
	
	_MessageContextMenu2.default && (module.exports.components['views.context_menus.MessageContextMenu'] = _MessageContextMenu2.default);
	
	_RoomTileContextMenu2.default && (module.exports.components['views.context_menus.RoomTileContextMenu'] = _RoomTileContextMenu2.default);
	
	_BugReportDialog2.default && (module.exports.components['views.dialogs.BugReportDialog'] = _BugReportDialog2.default);
	
	_ChangelogDialog2.default && (module.exports.components['views.dialogs.ChangelogDialog'] = _ChangelogDialog2.default);
	
	_NetworkDropdown2.default && (module.exports.components['views.directory.NetworkDropdown'] = _NetworkDropdown2.default);
	
	_ImageView2.default && (module.exports.components['views.elements.ImageView'] = _ImageView2.default);
	
	_Spinner2.default && (module.exports.components['views.elements.Spinner'] = _Spinner2.default);
	
	_GuestWarningBar2.default && (module.exports.components['views.globals.GuestWarningBar'] = _GuestWarningBar2.default);
	
	_MatrixToolbar2.default && (module.exports.components['views.globals.MatrixToolbar'] = _MatrixToolbar2.default);
	
	_NewVersionBar2.default && (module.exports.components['views.globals.NewVersionBar'] = _NewVersionBar2.default);
	
	_VectorCustomServerDialog2.default && (module.exports.components['views.login.VectorCustomServerDialog'] = _VectorCustomServerDialog2.default);
	
	_VectorLoginFooter2.default && (module.exports.components['views.login.VectorLoginFooter'] = _VectorLoginFooter2.default);
	
	_VectorLoginHeader2.default && (module.exports.components['views.login.VectorLoginHeader'] = _VectorLoginHeader2.default);
	
	_DateSeparator2.default && (module.exports.components['views.messages.DateSeparator'] = _DateSeparator2.default);
	
	_MessageTimestamp2.default && (module.exports.components['views.messages.MessageTimestamp'] = _MessageTimestamp2.default);
	
	_DNDRoomTile2.default && (module.exports.components['views.rooms.DNDRoomTile'] = _DNDRoomTile2.default);
	
	_RoomDropTarget2.default && (module.exports.components['views.rooms.RoomDropTarget'] = _RoomDropTarget2.default);
	
	_RoomTooltip2.default && (module.exports.components['views.rooms.RoomTooltip'] = _RoomTooltip2.default);
	
	_SearchBar2.default && (module.exports.components['views.rooms.SearchBar'] = _SearchBar2.default);
	
	_IntegrationsManager2.default && (module.exports.components['views.settings.IntegrationsManager'] = _IntegrationsManager2.default);
	
	_Notifications2.default && (module.exports.components['views.settings.Notifications'] = _Notifications2.default);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var AccessibleButton = __webpack_require__(30);
	
	module.exports = React.createClass({
	    displayName: 'BottomLeftMenu',
	
	    propTypes: {
	        collapsed: React.PropTypes.bool.isRequired,
	        teamToken: React.PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            directoryHover: false,
	            roomsHover: false,
	            homeHover: false,
	            peopleHover: false,
	            settingsHover: false
	        };
	    },
	
	    // Room events
	    onDirectoryClick: function onDirectoryClick() {
	        dis.dispatch({ action: 'view_room_directory' });
	    },
	
	    onDirectoryMouseEnter: function onDirectoryMouseEnter() {
	        this.setState({ directoryHover: true });
	    },
	
	    onDirectoryMouseLeave: function onDirectoryMouseLeave() {
	        this.setState({ directoryHover: false });
	    },
	
	    onRoomsClick: function onRoomsClick() {
	        dis.dispatch({ action: 'view_create_room' });
	    },
	
	    onRoomsMouseEnter: function onRoomsMouseEnter() {
	        this.setState({ roomsHover: true });
	    },
	
	    onRoomsMouseLeave: function onRoomsMouseLeave() {
	        this.setState({ roomsHover: false });
	    },
	
	    // Home button events
	    onHomeClick: function onHomeClick() {
	        dis.dispatch({ action: 'view_home_page' });
	    },
	
	    onHomeMouseEnter: function onHomeMouseEnter() {
	        this.setState({ homeHover: true });
	    },
	
	    onHomeMouseLeave: function onHomeMouseLeave() {
	        this.setState({ homeHover: false });
	    },
	
	    // People events
	    onPeopleClick: function onPeopleClick() {
	        dis.dispatch({ action: 'view_create_chat' });
	    },
	
	    onPeopleMouseEnter: function onPeopleMouseEnter() {
	        this.setState({ peopleHover: true });
	    },
	
	    onPeopleMouseLeave: function onPeopleMouseLeave() {
	        this.setState({ peopleHover: false });
	    },
	
	    // Settings events
	    onSettingsClick: function onSettingsClick() {
	        dis.dispatch({ action: 'view_user_settings' });
	    },
	
	    onSettingsMouseEnter: function onSettingsMouseEnter() {
	        this.setState({ settingsHover: true });
	    },
	
	    onSettingsMouseLeave: function onSettingsMouseLeave() {
	        this.setState({ settingsHover: false });
	    },
	
	    // Get the label/tooltip to show
	    getLabel: function getLabel(label, show) {
	        if (show) {
	            var RoomTooltip = sdk.getComponent("rooms.RoomTooltip");
	            return React.createElement(RoomTooltip, { className: 'mx_BottomLeftMenu_tooltip', label: label });
	        }
	    },
	
	    render: function render() {
	        var TintableSvg = sdk.getComponent('elements.TintableSvg');
	
	        var homeButton;
	        if (this.props.teamToken) {
	            homeButton = React.createElement(
	                AccessibleButton,
	                { className: 'mx_BottomLeftMenu_homePage', onClick: this.onHomeClick, onMouseEnter: this.onHomeMouseEnter, onMouseLeave: this.onHomeMouseLeave },
	                React.createElement(TintableSvg, { src: 'img/icons-home.svg', width: '25', height: '25' }),
	                this.getLabel("Welcome page", this.state.homeHover)
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_BottomLeftMenu' },
	            React.createElement(
	                'div',
	                { className: 'mx_BottomLeftMenu_options' },
	                homeButton,
	                React.createElement(
	                    AccessibleButton,
	                    { className: 'mx_BottomLeftMenu_people', onClick: this.onPeopleClick, onMouseEnter: this.onPeopleMouseEnter, onMouseLeave: this.onPeopleMouseLeave },
	                    React.createElement(TintableSvg, { src: 'img/icons-people.svg', width: '25', height: '25' }),
	                    this.getLabel("Start chat", this.state.peopleHover)
	                ),
	                React.createElement(
	                    AccessibleButton,
	                    { className: 'mx_BottomLeftMenu_directory', onClick: this.onDirectoryClick, onMouseEnter: this.onDirectoryMouseEnter, onMouseLeave: this.onDirectoryMouseLeave },
	                    React.createElement(TintableSvg, { src: 'img/icons-directory.svg', width: '25', height: '25' }),
	                    this.getLabel("Room directory", this.state.directoryHover)
	                ),
	                React.createElement(
	                    AccessibleButton,
	                    { className: 'mx_BottomLeftMenu_createRoom', onClick: this.onRoomsClick, onMouseEnter: this.onRoomsMouseEnter, onMouseLeave: this.onRoomsMouseLeave },
	                    React.createElement(TintableSvg, { src: 'img/icons-create-room.svg', width: '25', height: '25' }),
	                    this.getLabel("Create new room", this.state.roomsHover)
	                ),
	                React.createElement(
	                    AccessibleButton,
	                    { className: 'mx_BottomLeftMenu_settings', onClick: this.onSettingsClick, onMouseEnter: this.onSettingsMouseEnter, onMouseLeave: this.onSettingsMouseLeave },
	                    React.createElement(TintableSvg, { src: 'img/icons-settings.svg', width: '25', height: '25' }),
	                    this.getLabel("Settings", this.state.settingsHover)
	                )
	            )
	        );
	    }
	});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'CompatibilityPage',
	    propTypes: {
	        onAccept: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onAccept: function onAccept() {} // NOP
	        };
	    },
	
	    onAccept: function onAccept() {
	        this.props.onAccept();
	    },
	
	    render: function render() {
	
	        return React.createElement(
	            'div',
	            { className: 'mx_CompatibilityPage' },
	            React.createElement(
	                'div',
	                { className: 'mx_CompatibilityPage_box' },
	                React.createElement(
	                    'p',
	                    null,
	                    'Sorry, your browser is ',
	                    React.createElement(
	                        'b',
	                        null,
	                        'not'
	                    ),
	                    ' able to run Riot.'
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    'Riot uses many advanced browser features, some of which are not available or experimental in your current browser.'
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    'Please install ',
	                    React.createElement(
	                        'a',
	                        { href: 'https://www.google.com/chrome' },
	                        'Chrome'
	                    ),
	                    ' or ',
	                    React.createElement(
	                        'a',
	                        { href: 'https://getfirefox.com' },
	                        'Firefox'
	                    ),
	                    ' for the best experience. ',
	                    React.createElement(
	                        'a',
	                        { href: 'http://apple.com/safari' },
	                        'Safari'
	                    ),
	                    ' and ',
	                    React.createElement(
	                        'a',
	                        { href: 'http://opera.com' },
	                        'Opera'
	                    ),
	                    ' work too.'
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    'With your current browser, the look and feel of the application may be completely incorrect, and some or all features may not function. If you want to try it anyway you can continue, but you are on your own in terms of any issues you may encounter!'
	                ),
	                React.createElement(
	                    'button',
	                    { onClick: this.onAccept },
	                    'I understand the risks and wish to continue'
	                )
	            )
	        );
	    }
	});

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _matrixReactSdk = __webpack_require__(2);
	
	var _matrixReactSdk2 = _interopRequireDefault(_matrixReactSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _react2.default.createClass({
	    displayName: 'HomePage',
	
	    propTypes: {
	        teamServerUrl: _react2.default.PropTypes.string.isRequired,
	        teamToken: _react2.default.PropTypes.string.isRequired,
	        collapsedRhs: _react2.default.PropTypes.bool
	    },
	
	    render: function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_HomePage' },
	            _react2.default.createElement('iframe', { src: this.props.teamServerUrl + '/static/' + this.props.teamToken + '/home.html' })
	        );
	    }
	});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var DragDropContext = __webpack_require__(341).DragDropContext;
	var HTML5Backend = __webpack_require__(1425);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	
	var VectorConferenceHandler = __webpack_require__(366);
	var CallHandler = __webpack_require__(73);
	
	var LeftPanel = React.createClass({
	    displayName: 'LeftPanel',
	
	    propTypes: {
	        collapsed: React.PropTypes.bool.isRequired,
	        teamToken: React.PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            showCallElement: null,
	            searchFilter: ''
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        this._recheckCallElement(newProps.selectedRoom);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	    },
	
	    onAction: function onAction(payload) {
	        switch (payload.action) {
	            // listen for call state changes to prod the render method, which
	            // may hide the global CallView if the call it is tracking is dead
	            case 'call_state':
	                this._recheckCallElement(this.props.selectedRoom);
	                break;
	        }
	    },
	
	    _recheckCallElement: function _recheckCallElement(selectedRoomId) {
	        // if we aren't viewing a room with an ongoing call, but there is an
	        // active call, show the call element - we need to do this to make
	        // audio/video not crap out
	        var activeCall = CallHandler.getAnyActiveCall();
	        var callForRoom = CallHandler.getCallForRoom(selectedRoomId);
	        var showCall = activeCall && activeCall.call_state === 'connected' && !callForRoom;
	        this.setState({
	            showCallElement: showCall
	        });
	    },
	
	    onHideClick: function onHideClick() {
	        dis.dispatch({
	            action: 'hide_left_panel'
	        });
	    },
	
	    onCallViewClick: function onCallViewClick() {
	        var call = CallHandler.getAnyActiveCall();
	        if (call) {
	            dis.dispatch({
	                action: 'view_room',
	                room_id: call.groupRoomId || call.roomId
	            });
	        }
	    },
	
	    onSearch: function onSearch(term) {
	        this.setState({ searchFilter: term });
	    },
	
	    render: function render() {
	        var RoomList = sdk.getComponent('rooms.RoomList');
	        var BottomLeftMenu = sdk.getComponent('structures.BottomLeftMenu');
	        var SearchBox = sdk.getComponent('structures.SearchBox');
	
	        var collapseButton;
	        var classes = "mx_LeftPanel mx_fadable";
	        if (this.props.collapsed) {
	            classes += " collapsed";
	        } else {
	            // Hide the collapse button until we work out how to display it in the new skin
	            // collapseButton = <img className="mx_LeftPanel_hideButton" onClick={ this.onHideClick } src="img/hide.png" width="12" height="20" alt="<"/>
	        }
	
	        var callPreview;
	        if (this.state.showCallElement && !this.props.collapsed) {
	            var CallView = sdk.getComponent('voip.CallView');
	            callPreview = React.createElement(CallView, {
	                className: 'mx_LeftPanel_callView', showVoice: true, onClick: this.onCallViewClick,
	                ConferenceHandler: VectorConferenceHandler });
	        }
	
	        return React.createElement(
	            'aside',
	            { className: classes, style: { opacity: this.props.opacity } },
	            React.createElement(SearchBox, { collapsed: this.props.collapsed, onSearch: this.onSearch }),
	            collapseButton,
	            callPreview,
	            React.createElement(RoomList, {
	                selectedRoom: this.props.selectedRoom,
	                collapsed: this.props.collapsed,
	                searchFilter: this.state.searchFilter,
	                ConferenceHandler: VectorConferenceHandler }),
	            React.createElement(BottomLeftMenu, { collapsed: this.props.collapsed, teamToken: this.props.teamToken })
	        );
	    }
	});
	
	module.exports = DragDropContext(HTML5Backend)(LeftPanel);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var Matrix = __webpack_require__(28);
	var dis = __webpack_require__(5);
	var MatrixClientPeg = __webpack_require__(4);
	var rate_limited_func = __webpack_require__(119);
	var Modal = __webpack_require__(10);
	var AccessibleButton = __webpack_require__(30);
	
	module.exports = React.createClass({
	    displayName: 'RightPanel',
	
	    propTypes: {
	        userId: React.PropTypes.string, // if showing an orphaned MemberInfo page, this is set
	        roomId: React.PropTypes.string, // if showing panels for a given room, this is set
	        collapsed: React.PropTypes.bool },
	
	    Phase: {
	        MemberList: 'MemberList',
	        FilePanel: 'FilePanel',
	        NotificationPanel: 'NotificationPanel',
	        MemberInfo: 'MemberInfo'
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        var cli = MatrixClientPeg.get();
	        cli.on("RoomState.members", this.onRoomStateMember);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	        if (MatrixClientPeg.get()) {
	            MatrixClientPeg.get().removeListener("RoomState.members", this.onRoomStateMember);
	        }
	    },
	
	    getInitialState: function getInitialState() {
	        if (this.props.userId) {
	            var member = new Matrix.RoomMember(null, this.props.userId);
	            return {
	                phase: this.Phase.MemberInfo,
	                member: member
	            };
	        } else {
	            return {
	                phase: this.Phase.MemberList
	            };
	        }
	    },
	
	    onMemberListButtonClick: function onMemberListButtonClick() {
	        this.setState({ phase: this.Phase.MemberList });
	    },
	
	    onFileListButtonClick: function onFileListButtonClick() {
	        this.setState({ phase: this.Phase.FilePanel });
	    },
	
	    onNotificationListButtonClick: function onNotificationListButtonClick() {
	        this.setState({ phase: this.Phase.NotificationPanel });
	    },
	
	    onCollapseClick: function onCollapseClick() {
	        dis.dispatch({
	            action: 'hide_right_panel'
	        });
	    },
	
	    onInviteButtonClick: function onInviteButtonClick() {
	        if (MatrixClientPeg.get().isGuest()) {
	            var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	            Modal.createDialog(NeedToRegisterDialog, {
	                title: "Please Register",
	                description: "Guest users can't invite users. Please register to invite."
	            });
	            return;
	        }
	
	        // call ChatInviteDialog
	        dis.dispatch({
	            action: 'view_invite',
	            roomId: this.props.roomId
	        });
	    },
	
	    onRoomStateMember: function onRoomStateMember(ev, state, member) {
	        // redraw the badge on the membership list
	        if (this.state.phase == this.Phase.MemberList && member.roomId === this.props.roomId) {
	            this._delayedUpdate();
	        } else if (this.state.phase === this.Phase.MemberInfo && member.roomId === this.props.roomId && member.userId === this.state.member.userId) {
	            // refresh the member info (e.g. new power level)
	            this._delayedUpdate();
	        }
	    },
	
	    _delayedUpdate: new rate_limited_func(function () {
	        this.forceUpdate();
	    }, 500),
	
	    onAction: function onAction(payload) {
	        if (payload.action === "view_user") {
	            dis.dispatch({
	                action: 'show_right_panel'
	            });
	            if (payload.member) {
	                this.setState({
	                    phase: this.Phase.MemberInfo,
	                    member: payload.member
	                });
	            } else {
	                this.setState({
	                    phase: this.Phase.MemberList
	                });
	            }
	        } else if (payload.action === "view_room") {
	            if (this.state.phase === this.Phase.MemberInfo) {
	                this.setState({
	                    phase: this.Phase.MemberList
	                });
	            }
	        }
	    },
	
	    render: function render() {
	        var MemberList = sdk.getComponent('rooms.MemberList');
	        var NotificationPanel = sdk.getComponent('structures.NotificationPanel');
	        var FilePanel = sdk.getComponent('structures.FilePanel');
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	        var buttonGroup;
	        var inviteGroup;
	        var panel;
	
	        var filesHighlight;
	        var membersHighlight;
	        var notificationsHighlight;
	        if (!this.props.collapsed) {
	            if (this.state.phase == this.Phase.MemberList || this.state.phase === this.Phase.MemberInfo) {
	                membersHighlight = React.createElement('div', { className: 'mx_RightPanel_headerButton_highlight' });
	            } else if (this.state.phase == this.Phase.FilePanel) {
	                filesHighlight = React.createElement('div', { className: 'mx_RightPanel_headerButton_highlight' });
	            } else if (this.state.phase == this.Phase.NotificationPanel) {
	                notificationsHighlight = React.createElement('div', { className: 'mx_RightPanel_headerButton_highlight' });
	            }
	        }
	
	        var membersBadge;
	        if ((this.state.phase == this.Phase.MemberList || this.state.phase === this.Phase.MemberInfo) && this.props.roomId) {
	            var cli = MatrixClientPeg.get();
	            var room = cli.getRoom(this.props.roomId);
	            var user_is_in_room;
	            if (room) {
	                membersBadge = room.getJoinedMembers().length;
	                user_is_in_room = room.hasMembershipState(MatrixClientPeg.get().credentials.userId, 'join');
	            }
	
	            if (user_is_in_room) {
	                inviteGroup = React.createElement(
	                    AccessibleButton,
	                    { className: 'mx_RightPanel_invite', onClick: this.onInviteButtonClick },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RightPanel_icon' },
	                        React.createElement(TintableSvg, { src: 'img/icon-invite-people.svg', width: '35', height: '35' })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RightPanel_message' },
	                        'Invite to this room'
	                    )
	                );
	            }
	        }
	
	        if (this.props.roomId) {
	            buttonGroup = React.createElement(
	                'div',
	                { className: 'mx_RightPanel_headerButtonGroup' },
	                React.createElement(
	                    AccessibleButton,
	                    { className: 'mx_RightPanel_headerButton',
	                        title: 'Members', onClick: this.onMemberListButtonClick },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RightPanel_headerButton_badge' },
	                        membersBadge ? membersBadge : React.createElement(
	                            'span',
	                            null,
	                            '\xA0'
	                        )
	                    ),
	                    React.createElement(TintableSvg, { src: 'img/icons-people.svg', width: '25', height: '25' }),
	                    membersHighlight
	                ),
	                React.createElement(
	                    AccessibleButton,
	                    {
	                        className: 'mx_RightPanel_headerButton mx_RightPanel_filebutton',
	                        title: 'Files', onClick: this.onFileListButtonClick },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RightPanel_headerButton_badge' },
	                        '\xA0'
	                    ),
	                    React.createElement(TintableSvg, { src: 'img/icons-files.svg', width: '25', height: '25' }),
	                    filesHighlight
	                ),
	                React.createElement(
	                    AccessibleButton,
	                    {
	                        className: 'mx_RightPanel_headerButton mx_RightPanel_notificationbutton',
	                        title: 'Notifications', onClick: this.onNotificationListButtonClick },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RightPanel_headerButton_badge' },
	                        '\xA0'
	                    ),
	                    React.createElement(TintableSvg, { src: 'img/icons-notifications.svg', width: '25', height: '25' }),
	                    notificationsHighlight
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RightPanel_headerButton mx_RightPanel_collapsebutton', title: 'Hide panel', onClick: this.onCollapseClick },
	                    React.createElement(TintableSvg, { src: 'img/minimise.svg', width: '10', height: '16' })
	                )
	            );
	        }
	
	        if (!this.props.collapsed) {
	            if (this.props.roomId && this.state.phase == this.Phase.MemberList) {
	                panel = React.createElement(MemberList, { roomId: this.props.roomId, key: this.props.roomId });
	            } else if (this.state.phase == this.Phase.MemberInfo) {
	                var MemberInfo = sdk.getComponent('rooms.MemberInfo');
	                panel = React.createElement(MemberInfo, { member: this.state.member, key: this.props.roomId || this.props.userId });
	            } else if (this.state.phase == this.Phase.NotificationPanel) {
	                panel = React.createElement(NotificationPanel, null);
	            } else if (this.state.phase == this.Phase.FilePanel) {
	                panel = React.createElement(FilePanel, { roomId: this.props.roomId });
	            }
	        }
	
	        if (!panel) {
	            panel = React.createElement('div', { className: 'mx_RightPanel_blank' });
	        }
	
	        var classes = "mx_RightPanel mx_fadable";
	        if (this.props.collapsed) {
	            classes += " collapsed";
	        }
	
	        return React.createElement(
	            'aside',
	            { className: classes, style: { opacity: this.props.opacity } },
	            React.createElement(
	                'div',
	                { className: 'mx_RightPanel_header' },
	                buttonGroup
	            ),
	            panel,
	            React.createElement(
	                'div',
	                { className: 'mx_RightPanel_footer' },
	                inviteGroup
	            )
	        );
	    }
	});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(180);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _DirectoryUtils = __webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var MatrixClientPeg = __webpack_require__(4);
	var ContentRepo = __webpack_require__(28).ContentRepo;
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var GeminiScrollbar = __webpack_require__(121);
	
	var linkify = __webpack_require__(204);
	var linkifyString = __webpack_require__(1027);
	var linkifyMatrix = __webpack_require__(142);
	var sanitizeHtml = __webpack_require__(560);
	var q = __webpack_require__(6);
	
	linkifyMatrix(linkify);
	
	module.exports = React.createClass({
	    displayName: 'RoomDirectory',
	
	    propTypes: {
	        config: React.PropTypes.object
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            config: {}
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            publicRooms: [],
	            loading: true,
	            protocolsLoading: true,
	            instanceId: null,
	            includeAll: false,
	            roomServer: null,
	            filterString: null
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        this.nextBatch = null;
	        this.filterTimeout = null;
	        this.scrollPanel = null;
	        this.protocols = null;
	
	        this.setState({ protocolsLoading: true });
	        MatrixClientPeg.get().getThirdpartyProtocols().done(function (response) {
	            _this.protocols = response;
	            _this.setState({ protocolsLoading: false });
	        }, function (err) {
	            _this.setState({ protocolsLoading: false });
	            if (MatrixClientPeg.get().isGuest()) {
	                // Guests currently aren't allowed to use this API, so
	                // ignore this as otherwise this error is literally the
	                // thing you see when loading the client!
	                return;
	            }
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Failed to get protocol list from Home Server",
	                description: "The Home Server may be too old to support third party networks"
	            });
	        });
	
	        // dis.dispatch({
	        //     action: 'ui_opacity',
	        //     sideOpacity: 0.3,
	        //     middleOpacity: 0.3,
	        // });
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // dis.dispatch({
	        //     action: 'ui_opacity',
	        //     sideOpacity: 1.0,
	        //     middleOpacity: 1.0,
	        // });
	    },
	
	    refreshRoomList: function refreshRoomList() {
	        this.nextBatch = null;
	        this.setState({
	            publicRooms: [],
	            loading: true
	        });
	        this.getMoreRooms().done();
	    },
	
	    getMoreRooms: function getMoreRooms() {
	        var _this2 = this;
	
	        if (!MatrixClientPeg.get()) return q();
	
	        var my_filter_string = this.state.filterString;
	        var my_server = this.state.roomServer;
	        // remember the next batch token when we sent the request
	        // too. If it's changed, appending to the list will corrupt it.
	        var my_next_batch = this.nextBatch;
	        var opts = { limit: 20 };
	        if (my_server != MatrixClientPeg.getHomeServerName()) {
	            opts.server = my_server;
	        }
	        if (this.state.instanceId) {
	            opts.third_party_instance_id = this.state.instanceId;
	        } else if (this.state.includeAll) {
	            opts.include_all_networks = true;
	        }
	        if (this.nextBatch) opts.since = this.nextBatch;
	        if (my_filter_string) opts.filter = { generic_search_term: my_filter_string };
	        return MatrixClientPeg.get().publicRooms(opts).then(function (data) {
	            if (my_filter_string != _this2.state.filterString || my_server != _this2.state.roomServer || my_next_batch != _this2.nextBatch) {
	                // if the filter or server has changed since this request was sent,
	                // throw away the result (don't even clear the busy flag
	                // since we must still have a request in flight)
	                return;
	            }
	
	            _this2.nextBatch = data.next_batch;
	            _this2.setState(function (s) {
	                var _s$publicRooms;
	
	                (_s$publicRooms = s.publicRooms).push.apply(_s$publicRooms, (0, _toConsumableArray3.default)(data.chunk));
	                s.loading = false;
	                return s;
	            });
	            return Boolean(data.next_batch);
	        }, function (err) {
	            if (my_filter_string != _this2.state.filterString || my_server != _this2.state.roomServer || my_next_batch != _this2.nextBatch) {
	                // as above: we don't care about errors for old
	                // requests either
	                return;
	            }
	            _this2.setState({ loading: false });
	            console.error("Failed to get publicRooms: %s", (0, _stringify2.default)(err));
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Failed to get public room list",
	                description: "The server may be unavailable or overloaded"
	            });
	        });
	    },
	
	    /**
	     * A limited interface for removing rooms from the directory.
	     * Will set the room to not be publicly visible and delete the
	     * default alias. In the long term, it would be better to allow
	     * HS admins to do this through the RoomSettings interface, but
	     * this needs SPEC-417.
	     */
	    removeFromDirectory: function removeFromDirectory(room) {
	        var _this3 = this;
	
	        var alias = get_display_alias_for_room(room);
	        var name = room.name || alias || "Unnamed room";
	
	        var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	
	        var desc;
	        if (alias) {
	            desc = 'Delete the room alias \'' + alias + '\' and remove \'' + name + '\' from the directory?';
	        } else {
	            desc = 'Remove \'' + name + '\' from the directory?';
	        }
	
	        Modal.createDialog(QuestionDialog, {
	            title: "Remove from Directory",
	            description: desc,
	            onFinished: function onFinished(should_delete) {
	                if (!should_delete) return;
	
	                var Loader = sdk.getComponent("elements.Spinner");
	                var modal = Modal.createDialog(Loader);
	                var step = 'remove \'' + name + '\' from the directory.';
	
	                MatrixClientPeg.get().setRoomDirectoryVisibility(room.room_id, 'private').then(function () {
	                    if (!alias) return;
	                    step = 'delete the alias.';
	                    return MatrixClientPeg.get().deleteAlias(alias);
	                }).done(function () {
	                    modal.close();
	                    _this3.refreshRoomList();
	                }, function (err) {
	                    modal.close();
	                    this.refreshRoomList();
	                    console.error("Failed to " + step + ": " + err);
	                    Modal.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "Failed to " + step
	                    });
	                });
	            }
	        });
	    },
	
	    onRoomClicked: function onRoomClicked(room, ev) {
	        if (ev.shiftKey) {
	            ev.preventDefault();
	            this.removeFromDirectory(room);
	        } else {
	            this.showRoom(room);
	        }
	    },
	
	    onOptionChange: function onOptionChange(server, instanceId, includeAll) {
	        // clear next batch so we don't try to load more rooms
	        this.nextBatch = null;
	        this.setState({
	            // Clear the public rooms out here otherwise we needlessly
	            // spend time filtering lots of rooms when we're about to
	            // to clear the list anyway.
	            publicRooms: [],
	            roomServer: server,
	            instanceId: instanceId,
	            includeAll: includeAll
	        }, this.refreshRoomList);
	        // We also refresh the room list each time even though this
	        // filtering is client-side. It hopefully won't be client side
	        // for very long, and we may have fetched a thousand rooms to
	        // find the five gitter ones, at which point we do not want
	        // to render all those rooms when switching back to 'all networks'.
	        // Easiest to just blow away the state & re-fetch.
	    },
	
	    onFillRequest: function onFillRequest(backwards) {
	        if (backwards || !this.nextBatch) return q(false);
	
	        return this.getMoreRooms();
	    },
	
	    onFilterChange: function onFilterChange(alias) {
	        var _this4 = this;
	
	        this.setState({
	            filterString: alias || null
	        });
	
	        // don't send the request for a little bit,
	        // no point hammering the server with a
	        // request for every keystroke, let the
	        // user finish typing.
	        if (this.filterTimeout) {
	            clearTimeout(this.filterTimeout);
	        }
	        this.filterTimeout = setTimeout(function () {
	            _this4.filterTimeout = null;
	            _this4.refreshRoomList();
	        }, 700);
	    },
	
	    onFilterClear: function onFilterClear() {
	        // update immediately
	        this.setState({
	            filterString: null
	        }, this.refreshRoomList);
	
	        if (this.filterTimeout) {
	            clearTimeout(this.filterTimeout);
	        }
	    },
	
	    onJoinClick: function onJoinClick(alias) {
	        var _this5 = this;
	
	        // If we don't have a particular instance id selected, just show that rooms alias
	        if (!this.state.instanceId) {
	            // If the user specified an alias without a domain, add on whichever server is selected
	            // in the dropdown
	            if (alias.indexOf(':') == -1) {
	                alias = alias + ':' + this.state.roomServer;
	            }
	            this.showRoomAlias(alias);
	        } else {
	            // This is a 3rd party protocol. Let's see if we can join it
	            var protocolName = (0, _DirectoryUtils.protocolNameForInstanceId)(this.protocols, this.state.instanceId);
	            var instance = (0, _DirectoryUtils.instanceForInstanceId)(this.protocols, this.state.instanceId);
	            var fields = protocolName ? this._getFieldsForThirdPartyLocation(alias, this.protocols[protocolName], instance) : null;
	            if (!fields) {
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Unable to join network",
	                    description: "Riot does not know how to join a room on this network"
	                });
	                return;
	            }
	            MatrixClientPeg.get().getThirdpartyLocation(protocolName, fields).done(function (resp) {
	                if (resp.length > 0 && resp[0].alias) {
	                    _this5.showRoomAlias(resp[0].alias);
	                } else {
	                    var _ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                    Modal.createDialog(_ErrorDialog, {
	                        title: "Room not found",
	                        description: "Couldn't find a matching Matrix room"
	                    });
	                }
	            }, function (e) {
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Fetching third party location failed",
	                    description: "Unable to look up room ID from server"
	                });
	            });
	        }
	    },
	
	    showRoomAlias: function showRoomAlias(alias) {
	        this.showRoom(null, alias);
	    },
	
	    showRoom: function showRoom(room, room_alias) {
	        var payload = { action: 'view_room' };
	        if (room) {
	            // Don't let the user view a room they won't be able to either
	            // peek or join: fail earlier so they don't have to click back
	            // to the directory.
	            if (MatrixClientPeg.get().isGuest()) {
	                if (!room.world_readable && !room.guest_can_join) {
	                    var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	                    Modal.createDialog(NeedToRegisterDialog, {
	                        title: "Failed to join the room",
	                        description: "This room is inaccessible to guests. You may be able to join if you register."
	                    });
	                    return;
	                }
	            }
	
	            if (!room_alias) {
	                room_alias = get_display_alias_for_room(room);
	            }
	
	            payload.oob_data = {
	                avatarUrl: room.avatar_url,
	                // XXX: This logic is duplicated from the JS SDK which
	                // would normally decide what the name is.
	                name: room.name || room_alias || "Unnamed room"
	            };
	        }
	        // It's not really possible to join Matrix rooms by ID because the HS has no way to know
	        // which servers to start querying. However, there's no other way to join rooms in
	        // this list without aliases at present, so if roomAlias isn't set here we have no
	        // choice but to supply the ID.
	        if (room_alias) {
	            payload.room_alias = room_alias;
	        } else {
	            payload.room_id = room.room_id;
	        }
	        dis.dispatch(payload);
	    },
	
	    getRows: function getRows() {
	        var BaseAvatar = sdk.getComponent('avatars.BaseAvatar');
	
	        if (!this.state.publicRooms) return [];
	
	        var rooms = this.state.publicRooms;
	        var rows = [];
	        var self = this;
	        var guestRead, guestJoin, perms;
	        for (var i = 0; i < rooms.length; i++) {
	            var name = rooms[i].name || get_display_alias_for_room(rooms[i]) || "Unnamed room";
	            guestRead = null;
	            guestJoin = null;
	
	            if (rooms[i].world_readable) {
	                guestRead = React.createElement(
	                    'div',
	                    { className: 'mx_RoomDirectory_perm' },
	                    'World readable'
	                );
	            }
	            if (rooms[i].guest_can_join) {
	                guestJoin = React.createElement(
	                    'div',
	                    { className: 'mx_RoomDirectory_perm' },
	                    'Guests can join'
	                );
	            }
	
	            perms = null;
	            if (guestRead || guestJoin) {
	                perms = React.createElement(
	                    'div',
	                    { className: 'mx_RoomDirectory_perms' },
	                    guestRead,
	                    ' ',
	                    guestJoin
	                );
	            }
	
	            var topic = rooms[i].topic || '';
	            topic = linkifyString(sanitizeHtml(topic));
	
	            rows.push(React.createElement(
	                'tr',
	                { key: rooms[i].room_id,
	                    onClick: self.onRoomClicked.bind(self, rooms[i])
	                    // cancel onMouseDown otherwise shift-clicking highlights text
	                    , onMouseDown: function onMouseDown(ev) {
	                        ev.preventDefault();
	                    }
	                },
	                React.createElement(
	                    'td',
	                    { className: 'mx_RoomDirectory_roomAvatar' },
	                    React.createElement(BaseAvatar, { width: 24, height: 24, resizeMethod: 'crop',
	                        name: name, idName: name,
	                        url: ContentRepo.getHttpUriForMxc(MatrixClientPeg.get().getHomeserverUrl(), rooms[i].avatar_url, 24, 24, "crop") })
	                ),
	                React.createElement(
	                    'td',
	                    { className: 'mx_RoomDirectory_roomDescription' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RoomDirectory_name' },
	                        name
	                    ),
	                    '\xA0',
	                    perms,
	                    React.createElement('div', { className: 'mx_RoomDirectory_topic',
	                        onClick: function onClick(e) {
	                            e.stopPropagation();
	                        },
	                        dangerouslySetInnerHTML: { __html: topic } }),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RoomDirectory_alias' },
	                        get_display_alias_for_room(rooms[i])
	                    )
	                ),
	                React.createElement(
	                    'td',
	                    { className: 'mx_RoomDirectory_roomMemberCount' },
	                    rooms[i].num_joined_members
	                )
	            ));
	        }
	        return rows;
	    },
	
	    collectScrollPanel: function collectScrollPanel(element) {
	        this.scrollPanel = element;
	    },
	
	    _stringLooksLikeId: function _stringLooksLikeId(s, field_type) {
	        var pat = /^#[^\s]+:[^\s]/;
	        if (field_type && field_type.regexp) {
	            pat = new RegExp(field_type.regexp);
	        }
	
	        return pat.test(s);
	    },
	
	    _getFieldsForThirdPartyLocation: function _getFieldsForThirdPartyLocation(userInput, protocol, instance) {
	        // make an object with the fields specified by that protocol. We
	        // require that the values of all but the last field come from the
	        // instance. The last is the user input.
	        var requiredFields = protocol.location_fields;
	        if (!requiredFields) return null;
	        var fields = {};
	        for (var i = 0; i < requiredFields.length - 1; ++i) {
	            var thisField = requiredFields[i];
	            if (instance.fields[thisField] === undefined) return null;
	            fields[thisField] = instance.fields[thisField];
	        }
	        fields[requiredFields[requiredFields.length - 1]] = userInput;
	        return fields;
	    },
	
	    render: function render() {
	        var SimpleRoomHeader = sdk.getComponent('rooms.SimpleRoomHeader');
	        var Loader = sdk.getComponent("elements.Spinner");
	
	        if (this.state.protocolsLoading) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomDirectory' },
	                React.createElement(SimpleRoomHeader, { title: 'Directory' }),
	                React.createElement(Loader, null)
	            );
	        }
	
	        var content = void 0;
	        if (this.state.loading) {
	            content = React.createElement(
	                'div',
	                { className: 'mx_RoomDirectory' },
	                React.createElement(Loader, null)
	            );
	        } else {
	            var rows = this.getRows();
	            // we still show the scrollpanel, at least for now, because
	            // otherwise we don't fetch more because we don't get a fill
	            // request from the scrollpanel because there isn't one
	            var scrollpanel_content = void 0;
	            if (rows.length == 0) {
	                scrollpanel_content = React.createElement(
	                    'i',
	                    null,
	                    'No rooms to show'
	                );
	            } else {
	                scrollpanel_content = React.createElement(
	                    'table',
	                    { ref: 'directory_table', className: 'mx_RoomDirectory_table' },
	                    React.createElement(
	                        'tbody',
	                        null,
	                        this.getRows()
	                    )
	                );
	            }
	            var ScrollPanel = sdk.getComponent("structures.ScrollPanel");
	            content = React.createElement(
	                ScrollPanel,
	                { ref: this.collectScrollPanel,
	                    className: 'mx_RoomDirectory_tableWrapper',
	                    onFillRequest: this.onFillRequest,
	                    stickyBottom: false,
	                    startAtBottom: false,
	                    onResize: function onResize() {}
	                },
	                scrollpanel_content
	            );
	        }
	
	        var protocolName = (0, _DirectoryUtils.protocolNameForInstanceId)(this.protocols, this.state.instanceId);
	        var instance_expected_field_type = void 0;
	        if (protocolName && this.protocols && this.protocols[protocolName] && this.protocols[protocolName].location_fields.length > 0 && this.protocols[protocolName].field_types) {
	            var last_field = this.protocols[protocolName].location_fields.slice(-1)[0];
	            instance_expected_field_type = this.protocols[protocolName].field_types[last_field];
	        }
	
	        var placeholder = 'Search for a room';
	        if (!this.state.instanceId) {
	            placeholder = '#example:' + this.state.roomServer;
	        } else if (instance_expected_field_type) {
	            placeholder = instance_expected_field_type.placeholder;
	        }
	
	        var showJoinButton = this._stringLooksLikeId(this.state.filterString, instance_expected_field_type);
	        if (protocolName) {
	            var instance = (0, _DirectoryUtils.instanceForInstanceId)(this.protocols, this.state.instanceId);
	            if (this._getFieldsForThirdPartyLocation(this.state.filterString, this.protocols[protocolName], instance) === null) {
	                showJoinButton = false;
	            }
	        }
	
	        var NetworkDropdown = sdk.getComponent('directory.NetworkDropdown');
	        var DirectorySearchBox = sdk.getComponent('elements.DirectorySearchBox');
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomDirectory' },
	            React.createElement(SimpleRoomHeader, { title: 'Directory' }),
	            React.createElement(
	                'div',
	                { className: 'mx_RoomDirectory_list' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomDirectory_listheader' },
	                    React.createElement(DirectorySearchBox, {
	                        className: 'mx_RoomDirectory_searchbox',
	                        onChange: this.onFilterChange, onClear: this.onFilterClear, onJoinClick: this.onJoinClick,
	                        placeholder: placeholder, showJoinButton: showJoinButton
	                    }),
	                    React.createElement(NetworkDropdown, { config: this.props.config, protocols: this.protocols, onOptionChange: this.onOptionChange })
	                ),
	                content
	            )
	        );
	    }
	});
	
	// Similar to matrix-react-sdk's MatrixTools.getDisplayAliasForRoom
	// but works with the objects we get from the public room list
	function get_display_alias_for_room(room) {
	    return room.canonical_alias || (room.aliases ? room.aliases[0] : "");
	}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _maxSafeInteger = __webpack_require__(373);
	
	var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var classNames = __webpack_require__(27);
	var DropTarget = __webpack_require__(341).DropTarget;
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var Unread = __webpack_require__(221);
	var MatrixClientPeg = __webpack_require__(4);
	var RoomNotifs = __webpack_require__(328);
	var FormattingUtils = __webpack_require__(520);
	var AccessibleButton = __webpack_require__(30);
	
	// turn this on for drop & drag console debugging galore
	var debug = false;
	
	var TRUNCATE_AT = 10;
	
	var roomListTarget = {
	    canDrop: function canDrop() {
	        return true;
	    },
	
	    drop: function drop(props, monitor, component) {
	        if (debug) console.log("dropped on sublist");
	    },
	
	    hover: function hover(props, monitor, component) {
	        var item = monitor.getItem();
	
	        if (component.state.sortedList.length == 0 && props.editable) {
	            if (debug) console.log("hovering on sublist " + props.label + ", isOver=" + monitor.isOver());
	
	            if (item.targetList !== component) {
	                item.targetList.removeRoomTile(item.room);
	                item.targetList = component;
	            }
	
	            component.moveRoomTile(item.room, 0);
	        }
	    }
	};
	
	var RoomSubList = React.createClass({
	    displayName: 'RoomSubList',
	
	    debug: debug,
	
	    propTypes: {
	        list: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
	        label: React.PropTypes.string.isRequired,
	        tagName: React.PropTypes.string,
	        editable: React.PropTypes.bool,
	
	        order: React.PropTypes.string.isRequired,
	
	        // undefined if no room is selected (eg we are showing settings)
	        selectedRoom: React.PropTypes.string,
	
	        startAsHidden: React.PropTypes.bool,
	        showSpinner: React.PropTypes.bool, // true to show a spinner if 0 elements when expanded
	        collapsed: React.PropTypes.bool.isRequired, // is LeftPanel collapsed?
	        onHeaderClick: React.PropTypes.func,
	        alwaysShowHeader: React.PropTypes.bool,
	        incomingCall: React.PropTypes.object,
	        onShowMoreRooms: React.PropTypes.func,
	        searchFilter: React.PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            hidden: this.props.startAsHidden || false,
	            truncateAt: TRUNCATE_AT,
	            sortedList: []
	        };
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onHeaderClick: function onHeaderClick() {}, // NOP
	            onShowMoreRooms: function onShowMoreRooms() {} // NOP
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.sortList(this.applySearchFilter(this.props.list, this.props.searchFilter), this.props.order);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        // order the room list appropriately before we re-render
	        //if (debug) console.log("received new props, list = " + newProps.list);
	        this.sortList(this.applySearchFilter(newProps.list, newProps.searchFilter), newProps.order);
	    },
	
	    applySearchFilter: function applySearchFilter(list, filter) {
	        if (filter === "") return list;
	        return list.filter(function (room) {
	            return room.name && room.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
	        });
	    },
	
	    // The header is collapsable if it is hidden or not stuck
	    // The dataset elements are added in the RoomList _initAndPositionStickyHeaders method
	    isCollapsableOnClick: function isCollapsableOnClick() {
	        var stuck = this.refs.header.dataset.stuck;
	        if (this.state.hidden || stuck === undefined || stuck === "none") {
	            return true;
	        } else {
	            return false;
	        }
	    },
	
	    onClick: function onClick(ev) {
	        if (this.isCollapsableOnClick()) {
	            // The header isCollapsable, so the click is to be interpreted as collapse and truncation logic
	            var isHidden = !this.state.hidden;
	            this.setState({ hidden: isHidden });
	
	            if (isHidden) {
	                // as good a way as any to reset the truncate state
	                this.setState({ truncateAt: TRUNCATE_AT });
	            }
	
	            this.props.onShowMoreRooms();
	            this.props.onHeaderClick(isHidden);
	        } else {
	            // The header is stuck, so the click is to be interpreted as a scroll to the header
	            this.props.onHeaderClick(this.state.hidden, this.refs.header.dataset.originalPosition);
	        }
	    },
	
	    onRoomTileClick: function onRoomTileClick(roomId) {
	        dis.dispatch({
	            action: 'view_room',
	            room_id: roomId
	        });
	    },
	
	
	    tsOfNewestEvent: function tsOfNewestEvent(room) {
	        for (var i = room.timeline.length - 1; i >= 0; --i) {
	            var ev = room.timeline[i];
	            if (ev.getTs() && (Unread.eventTriggersUnreadCount(ev) || ev.getSender() === MatrixClientPeg.get().credentials.userId)) {
	                return ev.getTs();
	            }
	        }
	
	        // we might only have events that don't trigger the unread indicator,
	        // in which case use the oldest event even if normally it wouldn't count.
	        // This is better than just assuming the last event was forever ago.
	        if (room.timeline.length && room.timeline[0].getTs()) {
	            return room.timeline[0].getTs();
	        } else {
	            return _maxSafeInteger2.default;
	        }
	    },
	
	    // TODO: factor the comparators back out into a generic comparator
	    // so that view_prev_room and view_next_room can do the right thing
	
	    recentsComparator: function recentsComparator(roomA, roomB) {
	        return this.tsOfNewestEvent(roomB) - this.tsOfNewestEvent(roomA);
	    },
	
	    lexicographicalComparator: function lexicographicalComparator(roomA, roomB) {
	        return roomA.name > roomB.name ? 1 : -1;
	    },
	
	    // Generates the manual comparator using the given list
	    manualComparator: function manualComparator(roomA, roomB) {
	        if (!roomA.tags[this.props.tagName] || !roomB.tags[this.props.tagName]) return 0;
	
	        // Make sure the room tag has an order element, if not set it to be the bottom
	        var a = roomA.tags[this.props.tagName].order;
	        var b = roomB.tags[this.props.tagName].order;
	
	        // Order undefined room tag orders to the bottom
	        if (a === undefined && b !== undefined) {
	            return 1;
	        } else if (a !== undefined && b === undefined) {
	            return -1;
	        }
	
	        return a == b ? this.lexicographicalComparator(roomA, roomB) : a > b ? 1 : -1;
	    },
	
	    sortList: function sortList(list, order) {
	        if (list === undefined) list = this.state.sortedList;
	        if (order === undefined) order = this.props.order;
	        var comparator;
	        list = list || [];
	        if (order === "manual") comparator = this.manualComparator;
	        if (order === "recent") comparator = this.recentsComparator;
	
	        // Fix undefined orders here, and make sure the backend gets updated as well
	        this._fixUndefinedOrder(list);
	
	        //if (debug) console.log("sorting list for sublist " + this.props.label + " with length " + list.length + ", this.props.list = " + this.props.list);
	        this.setState({ sortedList: list.sort(comparator) });
	    },
	
	    _shouldShowNotifBadge: function _shouldShowNotifBadge(roomNotifState) {
	        var showBadgeInStates = [RoomNotifs.ALL_MESSAGES, RoomNotifs.ALL_MESSAGES_LOUD];
	        return showBadgeInStates.indexOf(roomNotifState) > -1;
	    },
	
	    _shouldShowMentionBadge: function _shouldShowMentionBadge(roomNotifState) {
	        return roomNotifState != RoomNotifs.MUTE;
	    },
	
	    /**
	     * Total up all the notification counts from the rooms
	     *
	     * @param {Number} If supplied will only total notifications for rooms outside the truncation number
	     * @returns {Array} The array takes the form [total, highlight] where highlight is a bool
	     */
	    roomNotificationCount: function roomNotificationCount(truncateAt) {
	        var self = this;
	
	        return this.props.list.reduce(function (result, room, index) {
	            if (truncateAt === undefined || index >= truncateAt) {
	                var roomNotifState = RoomNotifs.getRoomNotifsState(room.roomId);
	                var highlight = room.getUnreadNotificationCount('highlight') > 0 || self.props.label === 'Invites';
	                var notificationCount = room.getUnreadNotificationCount();
	
	                var notifBadges = notificationCount > 0 && self._shouldShowNotifBadge(roomNotifState);
	                var mentionBadges = highlight && self._shouldShowMentionBadge(roomNotifState);
	                var badges = notifBadges || mentionBadges;
	
	                if (badges) {
	                    result[0] += notificationCount;
	                    if (highlight) {
	                        result[1] = true;
	                    }
	                }
	            }
	            return result;
	        }, [0, false]);
	    },
	
	    _updateSubListCount: function _updateSubListCount() {
	        // Force an update by setting the state to the current state
	        // Doing it this way rather than using forceUpdate(), so that the shouldComponentUpdate()
	        // method is honoured
	        this.setState(this.state);
	    },
	
	    moveRoomTile: function moveRoomTile(room, atIndex) {
	        if (debug) console.log("moveRoomTile: id " + room.roomId + ", atIndex " + atIndex);
	        //console.log("moveRoomTile before: " + JSON.stringify(this.state.rooms));
	        var found = this.findRoomTile(room);
	        var rooms = this.state.sortedList;
	        if (found.room) {
	            if (debug) console.log("removing at index " + found.index + " and adding at index " + atIndex);
	            rooms.splice(found.index, 1);
	            rooms.splice(atIndex, 0, found.room);
	        } else {
	            if (debug) console.log("Adding at index " + atIndex);
	            rooms.splice(atIndex, 0, room);
	        }
	        this.setState({ sortedList: rooms });
	        // console.log("moveRoomTile after: " + JSON.stringify(this.state.rooms));
	    },
	
	    // XXX: this isn't invoked via a property method but indirectly via
	    // the roomList property method.  Unsure how evil this is.
	    removeRoomTile: function removeRoomTile(room) {
	        if (debug) console.log("remove room " + room.roomId);
	        var found = this.findRoomTile(room);
	        var rooms = this.state.sortedList;
	        if (found.room) {
	            rooms.splice(found.index, 1);
	        } else {
	            console.warn("Can't remove room " + room.roomId + " - can't find it");
	        }
	        this.setState({ sortedList: rooms });
	    },
	
	    findRoomTile: function findRoomTile(room) {
	        var index = this.state.sortedList.indexOf(room);
	        if (index >= 0) {
	            // console.log("found: room: " + room.roomId + " with index " + index);
	        } else {
	            if (debug) console.log("didn't find room");
	            room = null;
	        }
	        return {
	            room: room,
	            index: index
	        };
	    },
	
	    calcManualOrderTagData: function calcManualOrderTagData(room) {
	        var index = this.state.sortedList.indexOf(room);
	
	        // we sort rooms by the lexicographic ordering of the 'order' metadata on their tags.
	        // for convenience, we calculate this for now a floating point number between 0.0 and 1.0.
	
	        var orderA = 0.0; // by default we're next to the beginning of the list
	        if (index > 0) {
	            var prevTag = this.state.sortedList[index - 1].tags[this.props.tagName];
	            if (!prevTag) {
	                console.error("Previous room in sublist is not tagged to be in this list. This should never happen.");
	            } else if (prevTag.order === undefined) {
	                console.error("Previous room in sublist has no ordering metadata. This should never happen.");
	            } else {
	                orderA = prevTag.order;
	            }
	        }
	
	        var orderB = 1.0; // by default we're next to the end of the list too
	        if (index < this.state.sortedList.length - 1) {
	            var nextTag = this.state.sortedList[index + 1].tags[this.props.tagName];
	            if (!nextTag) {
	                console.error("Next room in sublist is not tagged to be in this list. This should never happen.");
	            } else if (nextTag.order === undefined) {
	                console.error("Next room in sublist has no ordering metadata. This should never happen.");
	            } else {
	                orderB = nextTag.order;
	            }
	        }
	
	        var order = (orderA + orderB) / 2.0;
	        if (order === orderA || order === orderB) {
	            console.error("Cannot describe new list position.  This should be incredibly unlikely.");
	            // TODO: renumber the list
	        }
	
	        return order;
	    },
	
	    makeRoomTiles: function makeRoomTiles() {
	        var self = this;
	        var DNDRoomTile = sdk.getComponent("rooms.DNDRoomTile");
	        return this.state.sortedList.map(function (room) {
	            var selected = room.roomId == self.props.selectedRoom;
	            // XXX: is it evil to pass in self as a prop to RoomTile?
	            return React.createElement(DNDRoomTile, {
	                room: room,
	                roomSubList: self,
	                key: room.roomId,
	                collapsed: self.props.collapsed || false,
	                selected: selected,
	                unread: Unread.doesRoomHaveUnreadMessages(room),
	                highlight: room.getUnreadNotificationCount('highlight') > 0 || self.props.label === 'Invites',
	                isInvite: self.props.label === 'Invites',
	                refreshSubList: self._updateSubListCount,
	                incomingCall: null,
	                onClick: self.onRoomTileClick
	            });
	        });
	    },
	
	    _getHeaderJsx: function _getHeaderJsx() {
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	
	        var subListNotifications = this.roomNotificationCount();
	        var subListNotifCount = subListNotifications[0];
	        var subListNotifHighlight = subListNotifications[1];
	
	        var roomCount = this.props.list.length > 0 ? this.props.list.length : '';
	
	        var chevronClasses = classNames({
	            'mx_RoomSubList_chevron': true,
	            'mx_RoomSubList_chevronRight': this.state.hidden,
	            'mx_RoomSubList_chevronDown': !this.state.hidden
	        });
	
	        var badgeClasses = classNames({
	            'mx_RoomSubList_badge': true,
	            'mx_RoomSubList_badgeHighlight': subListNotifHighlight
	        });
	
	        var badge;
	        if (subListNotifCount > 0) {
	            badge = React.createElement(
	                'div',
	                { className: badgeClasses },
	                FormattingUtils.formatCount(subListNotifCount)
	            );
	        }
	
	        // When collapsed, allow a long hover on the header to show user
	        // the full tag name and room count
	        var title;
	        if (this.props.collapsed) {
	            title = this.props.label;
	            if (roomCount !== '') {
	                title += " [" + roomCount + "]";
	            }
	        }
	
	        var incomingCall;
	        if (this.props.incomingCall) {
	            var self = this;
	            // Check if the incoming call is for this section
	            var incomingCallRoom = this.props.list.filter(function (room) {
	                return self.props.incomingCall.roomId === room.roomId;
	            });
	
	            if (incomingCallRoom.length === 1) {
	                var IncomingCallBox = sdk.getComponent("voip.IncomingCallBox");
	                incomingCall = React.createElement(IncomingCallBox, { className: 'mx_RoomSubList_incomingCall', incomingCall: this.props.incomingCall });
	            }
	        }
	
	        var tabindex = this.props.searchFilter === "" ? "0" : "-1";
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomSubList_labelContainer', title: title, ref: 'header' },
	            React.createElement(
	                AccessibleButton,
	                { onClick: this.onClick, className: 'mx_RoomSubList_label', tabIndex: tabindex },
	                this.props.collapsed ? '' : this.props.label,
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomSubList_roomCount' },
	                    roomCount
	                ),
	                React.createElement('div', { className: chevronClasses }),
	                badge,
	                incomingCall
	            )
	        );
	    },
	
	    _createOverflowTile: function _createOverflowTile(overflowCount, totalCount) {
	        var content = React.createElement('div', { className: 'mx_RoomSubList_chevronDown' });
	
	        var overflowNotifications = this.roomNotificationCount(TRUNCATE_AT);
	        var overflowNotifCount = overflowNotifications[0];
	        var overflowNotifHighlight = overflowNotifications[1];
	        if (overflowNotifCount && !this.props.collapsed) {
	            content = FormattingUtils.formatCount(overflowNotifCount);
	        }
	
	        var badgeClasses = classNames({
	            'mx_RoomSubList_moreBadge': true,
	            'mx_RoomSubList_moreBadgeNotify': overflowNotifCount && !this.props.collapsed,
	            'mx_RoomSubList_moreBadgeHighlight': overflowNotifHighlight && !this.props.collapsed
	        });
	
	        return React.createElement(
	            AccessibleButton,
	            { className: 'mx_RoomSubList_ellipsis', onClick: this._showFullMemberList },
	            React.createElement('div', { className: 'mx_RoomSubList_line' }),
	            React.createElement(
	                'div',
	                { className: 'mx_RoomSubList_more' },
	                'more'
	            ),
	            React.createElement(
	                'div',
	                { className: badgeClasses },
	                content
	            )
	        );
	    },
	
	    _showFullMemberList: function _showFullMemberList() {
	        this.setState({
	            truncateAt: -1
	        });
	
	        this.props.onShowMoreRooms();
	        this.props.onHeaderClick(false);
	    },
	
	    // Fix any undefined order elements of a room in a manual ordered list
	    //     room.tag[tagname].order
	    _fixUndefinedOrder: function _fixUndefinedOrder(list) {
	        if (this.props.order === "manual") {
	            var order = 0.0;
	            var self = this;
	
	            // Find the highest (lowest position) order of a room in a manual ordered list
	            list.forEach(function (room) {
	                if (room.tags.hasOwnProperty(self.props.tagName)) {
	                    if (order < room.tags[self.props.tagName].order) {
	                        order = room.tags[self.props.tagName].order;
	                    }
	                }
	            });
	
	            // Fix any undefined order elements of a room in a manual ordered list
	            // Do this one at a time, as each time a rooms tag data is updated the RoomList
	            // gets triggered and another list is passed in. Doing it one at a time means that
	            // we always correctly calculate the highest order for the list - stops multiple
	            // rooms getting the same order. This is only really relevant for the first time this
	            // is run with historical room tag data, after that there should only be undefined
	            // in the list at a time anyway.
	            for (var i = 0; i < list.length; i++) {
	                if (list[i].tags[self.props.tagName] && list[i].tags[self.props.tagName].order === undefined) {
	                    MatrixClientPeg.get().setRoomTag(list[i].roomId, self.props.tagName, { order: (order + 1.0) / 2.0 }).finally(function () {
	                        // Do any final stuff here
	                    }).fail(function (err) {
	                        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                        console.error("Failed to add tag " + self.props.tagName + " to room" + err);
	                        Modal.createDialog(ErrorDialog, {
	                            title: "Error",
	                            description: "Failed to add tag " + self.props.tagName + " to room"
	                        });
	                    });
	                    break;
	                };
	            };
	        }
	    },
	
	    render: function render() {
	        var connectDropTarget = this.props.connectDropTarget;
	        var RoomDropTarget = sdk.getComponent('rooms.RoomDropTarget');
	        var TruncatedList = sdk.getComponent('elements.TruncatedList');
	
	        var label = this.props.collapsed ? null : this.props.label;
	
	        //console.log("render: " + JSON.stringify(this.state.sortedList));
	
	        var target;
	        if (this.state.sortedList.length == 0 && this.props.editable) {
	            target = React.createElement(RoomDropTarget, { label: 'Drop here to ' + this.props.verb });
	        }
	
	        if (this.state.sortedList.length > 0 || this.props.editable) {
	            var subList;
	            var classes = "mx_RoomSubList";
	
	            if (!this.state.hidden) {
	                subList = React.createElement(
	                    TruncatedList,
	                    { className: classes, truncateAt: this.state.truncateAt,
	                        createOverflowElement: this._createOverflowTile },
	                    target,
	                    this.makeRoomTiles()
	                );
	            } else {
	                subList = React.createElement(TruncatedList, { className: classes });
	            }
	
	            return connectDropTarget(React.createElement(
	                'div',
	                null,
	                this._getHeaderJsx(),
	                subList
	            ));
	        } else {
	            var Loader = sdk.getComponent("elements.Spinner");
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomSubList' },
	                this.props.alwaysShowHeader ? this._getHeaderJsx() : undefined,
	                this.props.showSpinner && !this.state.hidden ? React.createElement(Loader, null) : undefined
	            );
	        }
	    }
	});
	
	// Export the wrapped version, inlining the 'collect' functions
	// to more closely resemble the ES7
	module.exports = DropTarget('RoomTile', roomListTarget, function (connect) {
	    return {
	        connectDropTarget: connect.dropTarget()
	    };
	})(RoomSubList);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var rate_limited_func = __webpack_require__(119);
	var AccessibleButton = __webpack_require__(30);
	
	module.exports = React.createClass({
	    displayName: 'SearchBox',
	
	    propTypes: {
	        collapsed: React.PropTypes.bool,
	        onSearch: React.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            searchTerm: ""
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	    },
	
	    onAction: function onAction(payload) {
	        // Disabling this as I find it really really annoying, and was used to the
	        // previous behaviour - see https://github.com/vector-im/riot-web/issues/3348
	        /*        
	                switch (payload.action) {
	                    // Clear up the text field when a room is selected.
	                    case 'view_room':
	                        if (this.refs.search) {
	                            this._clearSearch();
	                        }
	                        break;
	                }
	        */
	    },
	
	    onChange: function onChange() {
	        if (!this.refs.search) return;
	        this.setState({ searchTerm: this.refs.search.value });
	        this.onSearch();
	    },
	
	    onSearch: new rate_limited_func(function () {
	        this.props.onSearch(this.refs.search.value);
	    }, 100),
	
	    onToggleCollapse: function onToggleCollapse(show) {
	        if (show) {
	            dis.dispatch({
	                action: 'show_left_panel'
	            });
	        } else {
	            dis.dispatch({
	                action: 'hide_left_panel'
	            });
	        }
	    },
	
	    _clearSearch: function _clearSearch() {
	        this.refs.search.value = "";
	        this.onChange();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var TintableSvg = sdk.getComponent('elements.TintableSvg');
	
	        var collapseTabIndex = this.refs.search && this.refs.search.value !== "" ? "-1" : "0";
	
	        var toggleCollapse;
	        if (this.props.collapsed) {
	            toggleCollapse = React.createElement(
	                AccessibleButton,
	                { className: 'mx_SearchBox_maximise', tabIndex: collapseTabIndex, onClick: this.onToggleCollapse.bind(this, true) },
	                React.createElement(TintableSvg, { src: 'img/maximise.svg', width: '10', height: '16', alt: 'Expand panel' })
	            );
	        } else {
	            toggleCollapse = React.createElement(
	                AccessibleButton,
	                { className: 'mx_SearchBox_minimise', tabIndex: collapseTabIndex, onClick: this.onToggleCollapse.bind(this, false) },
	                React.createElement(TintableSvg, { src: 'img/minimise.svg', width: '10', height: '16', alt: 'Collapse panel' })
	            );
	        }
	
	        var searchControls;
	        if (!this.props.collapsed) {
	            searchControls = [this.state.searchTerm.length > 0 ? React.createElement(
	                AccessibleButton,
	                { key: 'button',
	                    className: 'mx_SearchBox_closeButton',
	                    onClick: function onClick() {
	                        _this._clearSearch();
	                    } },
	                React.createElement(TintableSvg, {
	                    className: 'mx_SearchBox_searchButton',
	                    src: 'img/icons-close.svg', width: '24', height: '24'
	                })
	            ) : React.createElement(TintableSvg, {
	                key: 'button',
	                className: 'mx_SearchBox_searchButton',
	                src: 'img/icons-search-copy.svg', width: '13', height: '13'
	            }), React.createElement('input', {
	                key: 'searchfield',
	                type: 'text',
	                ref: 'search',
	                className: 'mx_SearchBox_search',
	                value: this.state.searchTerm,
	                onChange: this.onChange,
	                placeholder: 'Filter room names'
	            })];
	        }
	
	        var self = this;
	        return React.createElement(
	            'div',
	            { className: 'mx_SearchBox' },
	            searchControls,
	            toggleCollapse
	        );
	    }
	});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'ViewSource',
	
	    propTypes: {
	        content: React.PropTypes.object.isRequired,
	        onFinished: React.PropTypes.func.isRequired
	    },
	
	    componentDidMount: function componentDidMount() {
	        document.addEventListener("keydown", this.onKeyDown);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener("keydown", this.onKeyDown);
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        if (ev.keyCode == 27) {
	            // escape
	            ev.stopPropagation();
	            ev.preventDefault();
	            this.props.onFinished();
	        }
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_ViewSource' },
	            React.createElement(
	                'pre',
	                null,
	                (0, _stringify2.default)(this.props.content, null, 2)
	            )
	        );
	    }
	});

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _UserSettingsStore = __webpack_require__(74);
	
	var UserSettingsStore = _interopRequireWildcard(_UserSettingsStore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var React = __webpack_require__(1);
	
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	var sdk = __webpack_require__(2);
	var Modal = __webpack_require__(10);
	var Resend = __webpack_require__(327);
	
	
	module.exports = React.createClass({
	    displayName: 'MessageContextMenu',
	
	    propTypes: {
	        /* the MatrixEvent associated with the context menu */
	        mxEvent: React.PropTypes.object.isRequired,
	
	        /* an optional EventTileOps implementation that can be used to unhide preview widgets */
	        eventTileOps: React.PropTypes.object,
	
	        /* callback called when the menu is dismissed */
	        onFinished: React.PropTypes.func
	    },
	
	    onResendClick: function onResendClick() {
	        Resend.resend(this.props.mxEvent);
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onViewSourceClick: function onViewSourceClick() {
	        var ViewSource = sdk.getComponent('structures.ViewSource');
	        Modal.createDialog(ViewSource, {
	            content: this.props.mxEvent.event
	        }, 'mx_Dialog_viewsource');
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onViewClearSourceClick: function onViewClearSourceClick() {
	        var ViewSource = sdk.getComponent('structures.ViewSource');
	        Modal.createDialog(ViewSource, {
	            // FIXME: _clearEvent is private
	            content: this.props.mxEvent._clearEvent
	        }, 'mx_Dialog_viewsource');
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onRedactClick: function onRedactClick() {
	        var _this = this;
	
	        var ConfirmRedactDialog = sdk.getComponent("dialogs.ConfirmRedactDialog");
	        Modal.createDialog(ConfirmRedactDialog, {
	            onFinished: function onFinished(proceed) {
	                if (!proceed) return;
	
	                MatrixClientPeg.get().redactEvent(_this.props.mxEvent.getRoomId(), _this.props.mxEvent.getId()).catch(function (e) {
	                    var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                    // display error message stating you couldn't delete this.
	                    var code = e.errcode || e.statusCode;
	                    Modal.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "You cannot delete this message. (" + code + ")"
	                    });
	                }).done();
	            }
	        }, 'mx_Dialog_confirmredact');
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onCancelSendClick: function onCancelSendClick() {
	        Resend.removeFromQueue(this.props.mxEvent);
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    closeMenu: function closeMenu() {
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onUnhidePreviewClick: function onUnhidePreviewClick() {
	        if (this.props.eventTileOps) {
	            this.props.eventTileOps.unhideWidget();
	        }
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onQuoteClick: function onQuoteClick() {
	        console.log(this.props.mxEvent);
	        dis.dispatch({
	            action: 'quote',
	            event: this.props.mxEvent
	        });
	    },
	
	    render: function render() {
	        var eventStatus = this.props.mxEvent.status;
	        var resendButton;
	        var viewSourceButton;
	        var viewClearSourceButton;
	        var redactButton;
	        var cancelButton;
	        var permalinkButton;
	        var unhidePreviewButton;
	        var externalURLButton;
	
	        if (eventStatus === 'not_sent') {
	            resendButton = React.createElement(
	                'div',
	                { className: 'mx_MessageContextMenu_field', onClick: this.onResendClick },
	                'Resend'
	            );
	        }
	
	        if (!eventStatus && !this.props.mxEvent.isRedacted()) {
	            // sent and not redacted
	            redactButton = React.createElement(
	                'div',
	                { className: 'mx_MessageContextMenu_field', onClick: this.onRedactClick },
	                'Redact'
	            );
	        }
	
	        if (eventStatus === "queued" || eventStatus === "not_sent") {
	            cancelButton = React.createElement(
	                'div',
	                { className: 'mx_MessageContextMenu_field', onClick: this.onCancelSendClick },
	                'Cancel Sending'
	            );
	        }
	
	        viewSourceButton = React.createElement(
	            'div',
	            { className: 'mx_MessageContextMenu_field', onClick: this.onViewSourceClick },
	            'View Source'
	        );
	
	        if (this.props.mxEvent.getType() !== this.props.mxEvent.getWireType()) {
	            viewClearSourceButton = React.createElement(
	                'div',
	                { className: 'mx_MessageContextMenu_field', onClick: this.onViewClearSourceClick },
	                'View Decrypted Source'
	            );
	        }
	
	        if (this.props.eventTileOps) {
	            if (this.props.eventTileOps.isWidgetHidden()) {
	                unhidePreviewButton = React.createElement(
	                    'div',
	                    { className: 'mx_MessageContextMenu_field', onClick: this.onUnhidePreviewClick },
	                    'Unhide Preview'
	                );
	            }
	        }
	
	        // XXX: if we use room ID, we should also include a server where the event can be found (other than in the domain of the event ID)
	        permalinkButton = React.createElement(
	            'div',
	            { className: 'mx_MessageContextMenu_field' },
	            React.createElement(
	                'a',
	                { href: "https://matrix.to/#/" + this.props.mxEvent.getRoomId() + "/" + this.props.mxEvent.getId(),
	                    target: '_blank', rel: 'noopener', onClick: this.closeMenu },
	                'Permalink'
	            )
	        );
	
	        var quoteButton = React.createElement(
	            'div',
	            { className: 'mx_MessageContextMenu_field', onClick: this.onQuoteClick },
	            'Quote'
	        );
	
	        // Bridges can provide a 'external_url' to link back to the source.
	        if (typeof this.props.mxEvent.event.content.external_url === "string") {
	            externalURLButton = React.createElement(
	                'div',
	                { className: 'mx_MessageContextMenu_field' },
	                React.createElement(
	                    'a',
	                    { href: this.props.mxEvent.event.content.external_url,
	                        rel: 'noopener', target: '_blank', onClick: this.closeMenu },
	                    'Source URL'
	                )
	            );
	        }
	
	        return React.createElement(
	            'div',
	            null,
	            resendButton,
	            redactButton,
	            cancelButton,
	            viewSourceButton,
	            viewClearSourceButton,
	            unhidePreviewButton,
	            permalinkButton,
	            UserSettingsStore.isFeatureEnabled('rich_text_editor') ? quoteButton : null,
	            externalURLButton
	        );
	    }
	});

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _matrixReactSdk = __webpack_require__(2);
	
	var _matrixReactSdk2 = _interopRequireDefault(_matrixReactSdk);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	var _Rooms = __webpack_require__(117);
	
	var Rooms = _interopRequireWildcard(_Rooms);
	
	var _RoomNotifs = __webpack_require__(328);
	
	var RoomNotifs = _interopRequireWildcard(_RoomNotifs);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _react2.default.createClass({
	    displayName: 'RoomTileContextMenu',
	
	    propTypes: {
	        room: _react2.default.PropTypes.object.isRequired,
	        /* callback called when the menu is dismissed */
	        onFinished: _react2.default.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        var dmRoomMap = new _DMRoomMap2.default(_MatrixClientPeg2.default.get());
	        return {
	            roomNotifState: RoomNotifs.getRoomNotifsState(this.props.room.roomId),
	            isFavourite: this.props.room.tags.hasOwnProperty("m.favourite"),
	            isLowPriority: this.props.room.tags.hasOwnProperty("m.lowpriority"),
	            isDirectMessage: Boolean(dmRoomMap.getUserIdForRoomId(this.props.room.roomId))
	        };
	    },
	
	
	    componentWillMount: function componentWillMount() {
	        this._unmounted = false;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this._unmounted = true;
	    },
	
	    _toggleTag: function _toggleTag(tagNameOn, tagNameOff) {
	        var self = this;
	        var roomId = this.props.room.roomId;
	        var cli = _MatrixClientPeg2.default.get();
	        if (!cli.isGuest()) {
	            _q2.default.delay(500).then(function () {
	                if (tagNameOff !== null && tagNameOff !== undefined) {
	                    cli.deleteRoomTag(roomId, tagNameOff).finally(function () {
	                        // Close the context menu
	                        if (self.props.onFinished) {
	                            self.props.onFinished();
	                        };
	                    }).fail(function (err) {
	                        var ErrorDialog = _matrixReactSdk2.default.getComponent("dialogs.ErrorDialog");
	                        _Modal2.default.createDialog(ErrorDialog, {
	                            title: "Failed to remove tag " + tagNameOff + " from room",
	                            description: err.toString()
	                        });
	                    });
	                }
	
	                if (tagNameOn !== null && tagNameOn !== undefined) {
	                    // If the tag ordering meta data is required, it is added by
	                    // the RoomSubList when it sorts its rooms
	                    cli.setRoomTag(roomId, tagNameOn, {}).finally(function () {
	                        // Close the context menu
	                        if (self.props.onFinished) {
	                            self.props.onFinished();
	                        };
	                    }).fail(function (err) {
	                        var ErrorDialog = _matrixReactSdk2.default.getComponent("dialogs.ErrorDialog");
	                        _Modal2.default.createDialog(ErrorDialog, {
	                            title: "Failed to add tag " + tagNameOn + " to room",
	                            description: err.toString()
	                        });
	                    });
	                }
	            });
	        }
	    },
	
	    _onClickFavourite: function _onClickFavourite() {
	        // Tag room as 'Favourite'
	        if (!this.state.isFavourite && this.state.isLowPriority) {
	            this.setState({
	                isFavourite: true,
	                isLowPriority: false
	            });
	            this._toggleTag("m.favourite", "m.lowpriority");
	        } else if (this.state.isFavourite) {
	            this.setState({ isFavourite: false });
	            this._toggleTag(null, "m.favourite");
	        } else if (!this.state.isFavourite) {
	            this.setState({ isFavourite: true });
	            this._toggleTag("m.favourite");
	        }
	    },
	
	    _onClickLowPriority: function _onClickLowPriority() {
	        // Tag room as 'Low Priority'
	        if (!this.state.isLowPriority && this.state.isFavourite) {
	            this.setState({
	                isFavourite: false,
	                isLowPriority: true
	            });
	            this._toggleTag("m.lowpriority", "m.favourite");
	        } else if (this.state.isLowPriority) {
	            this.setState({ isLowPriority: false });
	            this._toggleTag(null, "m.lowpriority");
	        } else if (!this.state.isLowPriority) {
	            this.setState({ isLowPriority: true });
	            this._toggleTag("m.lowpriority");
	        }
	    },
	
	    _onClickDM: function _onClickDM() {
	        var _this = this;
	
	        var newIsDirectMessage = !this.state.isDirectMessage;
	        this.setState({
	            isDirectMessage: newIsDirectMessage
	        });
	
	        if (_MatrixClientPeg2.default.get().isGuest()) return;
	
	        Rooms.guessAndSetDMRoom(this.props.room, newIsDirectMessage).delay(500).finally(function () {
	            // Close the context menu
	            if (_this.props.onFinished) {
	                _this.props.onFinished();
	            };
	        }, function (err) {
	            var ErrorDialog = _matrixReactSdk2.default.getComponent("dialogs.ErrorDialog");
	            _Modal2.default.createDialog(ErrorDialog, {
	                title: "Failed to set Direct Message status of room",
	                description: err.toString()
	            });
	        });
	    },
	
	    _onClickLeave: function _onClickLeave() {
	        // Leave room
	        _dispatcher2.default.dispatch({
	            action: 'leave_room',
	            room_id: this.props.room.roomId
	        });
	
	        // Close the context menu
	        if (this.props.onFinished) {
	            this.props.onFinished();
	        };
	    },
	
	    _onClickReject: function _onClickReject() {
	        _dispatcher2.default.dispatch({
	            action: 'reject_invite',
	            room_id: this.props.room.roomId
	        });
	
	        // Close the context menu
	        if (this.props.onFinished) {
	            this.props.onFinished();
	        };
	    },
	
	    _onClickForget: function _onClickForget() {
	        // FIXME: duplicated with RoomSettings (and dead code in RoomView)
	        _MatrixClientPeg2.default.get().forget(this.props.room.roomId).done(function () {
	            _dispatcher2.default.dispatch({ action: 'view_next_room' });
	        }, function (err) {
	            var errCode = err.errcode || "unknown error code";
	            var ErrorDialog = _matrixReactSdk2.default.getComponent("dialogs.ErrorDialog");
	            _Modal2.default.createDialog(ErrorDialog, {
	                title: "Error",
	                description: 'Failed to forget room (' + errCode + ')'
	            });
	        });
	
	        // Close the context menu
	        if (this.props.onFinished) {
	            this.props.onFinished();
	        };
	    },
	
	    _saveNotifState: function _saveNotifState(newState) {
	        var _this2 = this;
	
	        var oldState = this.state.roomNotifState;
	        var roomId = this.props.room.roomId;
	        var cli = _MatrixClientPeg2.default.get();
	
	        if (cli.isGuest()) return;
	
	        this.setState({
	            roomNotifState: newState
	        });
	        RoomNotifs.setRoomNotifsState(this.props.room.roomId, newState).done(function () {
	            // delay slightly so that the user can see their state change
	            // before closing the menu
	            return _q2.default.delay(500).then(function () {
	                if (_this2._unmounted) return;
	                // Close the context menu
	                if (_this2.props.onFinished) {
	                    _this2.props.onFinished();
	                };
	            });
	        }, function (error) {
	            // TODO: some form of error notification to the user
	            // to inform them that their state change failed.
	            // For now we at least set the state back
	            if (_this2._unmounted) return;
	            _this2.setState({
	                roomNotifState: oldState
	            });
	        });
	    },
	
	    _onClickAlertMe: function _onClickAlertMe() {
	        this._saveNotifState(RoomNotifs.ALL_MESSAGES_LOUD);
	    },
	
	    _onClickAllNotifs: function _onClickAllNotifs() {
	        this._saveNotifState(RoomNotifs.ALL_MESSAGES);
	    },
	
	    _onClickMentions: function _onClickMentions() {
	        this._saveNotifState(RoomNotifs.MENTIONS_ONLY);
	    },
	
	    _onClickMute: function _onClickMute() {
	        this._saveNotifState(RoomNotifs.MUTE);
	    },
	
	    _renderNotifMenu: function _renderNotifMenu() {
	        var alertMeClasses = (0, _classnames2.default)({
	            'mx_RoomTileContextMenu_notif_field': true,
	            'mx_RoomTileContextMenu_notif_fieldSet': this.state.roomNotifState == RoomNotifs.ALL_MESSAGES_LOUD
	        });
	
	        var allNotifsClasses = (0, _classnames2.default)({
	            'mx_RoomTileContextMenu_notif_field': true,
	            'mx_RoomTileContextMenu_notif_fieldSet': this.state.roomNotifState == RoomNotifs.ALL_MESSAGES
	        });
	
	        var mentionsClasses = (0, _classnames2.default)({
	            'mx_RoomTileContextMenu_notif_field': true,
	            'mx_RoomTileContextMenu_notif_fieldSet': this.state.roomNotifState == RoomNotifs.MENTIONS_ONLY
	        });
	
	        var muteNotifsClasses = (0, _classnames2.default)({
	            'mx_RoomTileContextMenu_notif_field': true,
	            'mx_RoomTileContextMenu_notif_fieldSet': this.state.roomNotifState == RoomNotifs.MUTE
	        });
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomTileContextMenu_notif_picker' },
	                _react2.default.createElement('img', { src: 'img/notif-slider.svg', width: '20', height: '107' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: alertMeClasses, onClick: this._onClickAlertMe },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_activeIcon', src: 'img/notif-active.svg', width: '12', height: '12' }),
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_icon mx_filterFlipColor', src: 'img/icon-context-mute-off-copy.svg', width: '16', height: '12' }),
	                'All messages (loud)'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: allNotifsClasses, onClick: this._onClickAllNotifs },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_activeIcon', src: 'img/notif-active.svg', width: '12', height: '12' }),
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_icon mx_filterFlipColor', src: 'img/icon-context-mute-off.svg', width: '16', height: '12' }),
	                'All messages'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: mentionsClasses, onClick: this._onClickMentions },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_activeIcon', src: 'img/notif-active.svg', width: '12', height: '12' }),
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_icon mx_filterFlipColor', src: 'img/icon-context-mute-mentions.svg', width: '16', height: '12' }),
	                'Mentions only'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: muteNotifsClasses, onClick: this._onClickMute },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_activeIcon', src: 'img/notif-active.svg', width: '12', height: '12' }),
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_notif_icon mx_filterFlipColor', src: 'img/icon-context-mute.svg', width: '16', height: '12' }),
	                'Mute'
	            )
	        );
	    },
	
	    _renderLeaveMenu: function _renderLeaveMenu(membership) {
	        if (!membership) {
	            return null;
	        }
	
	        var leaveClickHandler = null;
	        var leaveText = null;
	
	        switch (membership) {
	            case "join":
	                leaveClickHandler = this._onClickLeave;
	                leaveText = "Leave";
	                break;
	            case "leave":
	            case "ban":
	                leaveClickHandler = this._onClickForget;
	                leaveText = "Forget";
	                break;
	            case "invite":
	                leaveClickHandler = this._onClickReject;
	                leaveText = "Reject";
	                break;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomTileContextMenu_leave', onClick: leaveClickHandler },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon', src: 'img/icon_context_delete.svg', width: '15', height: '15' }),
	                leaveText
	            )
	        );
	    },
	
	    _renderRoomTagMenu: function _renderRoomTagMenu() {
	        var favouriteClasses = (0, _classnames2.default)({
	            'mx_RoomTileContextMenu_tag_field': true,
	            'mx_RoomTileContextMenu_tag_fieldSet': this.state.isFavourite,
	            'mx_RoomTileContextMenu_tag_fieldDisabled': false
	        });
	
	        var lowPriorityClasses = (0, _classnames2.default)({
	            'mx_RoomTileContextMenu_tag_field': true,
	            'mx_RoomTileContextMenu_tag_fieldSet': this.state.isLowPriority,
	            'mx_RoomTileContextMenu_tag_fieldDisabled': false
	        });
	
	        var dmClasses = (0, _classnames2.default)({
	            'mx_RoomTileContextMenu_tag_field': true,
	            'mx_RoomTileContextMenu_tag_fieldSet': this.state.isDirectMessage,
	            'mx_RoomTileContextMenu_tag_fieldDisabled': false
	        });
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: favouriteClasses, onClick: this._onClickFavourite },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon', src: 'img/icon_context_fave.svg', width: '15', height: '15' }),
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon_set', src: 'img/icon_context_fave_on.svg', width: '15', height: '15' }),
	                'Favourite'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: lowPriorityClasses, onClick: this._onClickLowPriority },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon', src: 'img/icon_context_low.svg', width: '15', height: '15' }),
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon_set', src: 'img/icon_context_low_on.svg', width: '15', height: '15' }),
	                'Low Priority'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: dmClasses, onClick: this._onClickDM },
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon', src: 'img/icon_context_person.svg', width: '15', height: '15' }),
	                _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon_set', src: 'img/icon_context_person_on.svg', width: '15', height: '15' }),
	                'Direct Chat'
	            )
	        );
	    },
	
	    render: function render() {
	        var myMember = this.props.room.getMember(_MatrixClientPeg2.default.get().credentials.userId);
	
	        // Can't set notif level or tags on non-join rooms
	        if (myMember.membership !== 'join') {
	            return this._renderLeaveMenu(myMember.membership);
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            this._renderNotifMenu(),
	            _react2.default.createElement('hr', { className: 'mx_RoomTileContextMenu_separator' }),
	            this._renderLeaveMenu(myMember.membership),
	            _react2.default.createElement('hr', { className: 'mx_RoomTileContextMenu_separator' }),
	            this._renderRoomTagMenu()
	        );
	    }
	});

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _matrixReactSdk = __webpack_require__(2);
	
	var _matrixReactSdk2 = _interopRequireDefault(_matrixReactSdk);
	
	var _rageshake = __webpack_require__(370);
	
	var _rageshake2 = _interopRequireDefault(_rageshake);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BugReportDialog = function (_React$Component) {
	    (0, _inherits3.default)(BugReportDialog, _React$Component);
	
	    function BugReportDialog(props, context) {
	        (0, _classCallCheck3.default)(this, BugReportDialog);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BugReportDialog.__proto__ || (0, _getPrototypeOf2.default)(BugReportDialog)).call(this, props, context));
	
	        _this.state = {
	            sendLogs: true,
	            busy: false,
	            err: null,
	            text: ""
	        };
	        _this._onSubmit = _this._onSubmit.bind(_this);
	        _this._onCancel = _this._onCancel.bind(_this);
	        _this._onTextChange = _this._onTextChange.bind(_this);
	        _this._onSendLogsChange = _this._onSendLogsChange.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BugReportDialog, [{
	        key: '_onCancel',
	        value: function _onCancel(ev) {
	            this.props.onFinished(false);
	        }
	    }, {
	        key: '_onSubmit',
	        value: function _onSubmit(ev) {
	            var _this2 = this;
	
	            var sendLogs = this.state.sendLogs;
	            var userText = this.state.text;
	            if (!sendLogs && userText.trim().length === 0) {
	                this.setState({
	                    err: "Please describe the bug and/or send logs."
	                });
	                return;
	            }
	            this.setState({ busy: true, err: null });
	            _rageshake2.default.sendBugReport(userText, sendLogs).then(function () {
	                _this2.setState({ busy: false });
	                _this2.props.onFinished(false);
	            }, function (err) {
	                _this2.setState({ busy: false, err: 'Failed: ' + err.message });
	            });
	        }
	    }, {
	        key: '_onTextChange',
	        value: function _onTextChange(ev) {
	            this.setState({ text: ev.target.value });
	        }
	    }, {
	        key: '_onSendLogsChange',
	        value: function _onSendLogsChange(ev) {
	            this.setState({ sendLogs: ev.target.checked });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Loader = _matrixReactSdk2.default.getComponent("elements.Spinner");
	
	            var error = null;
	            if (this.state.err) {
	                error = _react2.default.createElement(
	                    'div',
	                    { className: 'error' },
	                    this.state.err
	                );
	            }
	
	            var okLabel = this.state.busy ? _react2.default.createElement(Loader, null) : 'Send';
	
	            var cancelButton = null;
	            if (!this.state.busy) {
	                cancelButton = _react2.default.createElement(
	                    'button',
	                    { onClick: this._onCancel },
	                    'Cancel'
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_BugReportDialog' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_title' },
	                    'Report a bug'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Please describe the bug. What did you do? What did you expect to happen? What actually happened?'
	                    ),
	                    _react2.default.createElement('textarea', {
	                        className: 'mx_BugReportDialog_input',
	                        rows: 5,
	                        onChange: this._onTextChange,
	                        value: this.state.text,
	                        placeholder: 'Describe your problem here.'
	                    }),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'In order to diagnose problems, logs from this client will be sent with this bug report. If you would prefer to only send the text above, please untick:'
	                    ),
	                    _react2.default.createElement('input', { type: 'checkbox', checked: this.state.sendLogs,
	                        onChange: this._onSendLogsChange, id: 'mx_BugReportDialog_logs' }),
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'mx_BugReportDialog_logs' },
	                        'Send logs'
	                    ),
	                    error
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_buttons' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'mx_Dialog_primary danger',
	                            onClick: this._onSubmit,
	                            autoFocus: true
	                        },
	                        okLabel
	                    ),
	                    cancelButton
	                )
	            );
	        }
	    }]);
	    return BugReportDialog;
	}(_react2.default.Component); /*
	                              Copyright 2017 OpenMarket Ltd
	                              
	                              Licensed under the Apache License, Version 2.0 (the "License");
	                              you may not use this file except in compliance with the License.
	                              You may obtain a copy of the License at
	                              
	                                  http://www.apache.org/licenses/LICENSE-2.0
	                              
	                              Unless required by applicable law or agreed to in writing, software
	                              distributed under the License is distributed on an "AS IS" BASIS,
	                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                              See the License for the specific language governing permissions and
	                              limitations under the License.
	                              */
	
	exports.default = BugReportDialog;
	
	
	BugReportDialog.propTypes = {
	    onFinished: _react2.default.PropTypes.func.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(179);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _matrixReactSdk = __webpack_require__(2);
	
	var _matrixReactSdk2 = _interopRequireDefault(_matrixReactSdk);
	
	var _browserRequest = __webpack_require__(97);
	
	var _browserRequest2 = _interopRequireDefault(_browserRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REPOS = ['vector-im/vector-web', 'matrix-org/matrix-react-sdk', 'matrix-org/matrix-js-sdk']; /*
	                                                                                                  Copyright 2016 Aviral Dasgupta
	                                                                                                 
	                                                                                                  Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                  you may not use this file except in compliance with the License.
	                                                                                                  You may obtain a copy of the License at
	                                                                                                 
	                                                                                                  http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                 
	                                                                                                  Unless required by applicable law or agreed to in writing, software
	                                                                                                  distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                  See the License for the specific language governing permissions and
	                                                                                                  limitations under the License.
	                                                                                                  */
	
	var ChangelogDialog = function (_React$Component) {
	    (0, _inherits3.default)(ChangelogDialog, _React$Component);
	
	    function ChangelogDialog(props) {
	        (0, _classCallCheck3.default)(this, ChangelogDialog);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ChangelogDialog.__proto__ || (0, _getPrototypeOf2.default)(ChangelogDialog)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    (0, _createClass3.default)(ChangelogDialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var version = this.props.newVersion.split('-');
	            var version2 = this.props.version.split('-');
	            if (version == null || version2 == null) return;
	            // parse versions of form: [vectorversion]-react-[react-sdk-version]-js-[js-sdk-version]
	
	            var _loop = function _loop(i) {
	                var oldVersion = version2[2 * i];
	                var newVersion = version[2 * i];
	                (0, _browserRequest2.default)('https://api.github.com/repos/' + REPOS[i] + '/compare/' + oldVersion + '...' + newVersion, function (a, b, body) {
	                    if (body == null) return;
	                    _this2.setState((0, _defineProperty3.default)({}, REPOS[i], JSON.parse(body).commits));
	                });
	            };
	
	            for (var i = 0; i < REPOS.length; i++) {
	                _loop(i);
	            }
	        }
	    }, {
	        key: '_elementsForCommit',
	        value: function _elementsForCommit(commit) {
	            return _react2.default.createElement(
	                'li',
	                { key: commit.sha, className: 'mx_ChangelogDialog_li' },
	                _react2.default.createElement(
	                    'a',
	                    { href: commit.html_url, target: '_blank', rel: 'noopener' },
	                    commit.commit.message
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var Spinner = _matrixReactSdk2.default.getComponent('views.elements.Spinner');
	            var QuestionDialog = _matrixReactSdk2.default.getComponent('dialogs.QuestionDialog');
	
	            var logs = REPOS.map(function (repo) {
	                if (_this3.state[repo] == null) return _react2.default.createElement(Spinner, { key: repo });
	                return _react2.default.createElement(
	                    'div',
	                    { key: repo },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        repo
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _this3.state[repo].map(_this3._elementsForCommit)
	                    )
	                );
	            });
	
	            var content = _react2.default.createElement(
	                'div',
	                { className: 'mx_ChangelogDialog_content' },
	                this.props.version == null || this.props.newVersion == null ? _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Unavailable'
	                ) : logs
	            );
	
	            return _react2.default.createElement(QuestionDialog, {
	                title: 'Changelog',
	                description: content,
	                button: 'Update',
	                onFinished: this.props.onFinished
	            });
	        }
	    }]);
	    return ChangelogDialog;
	}(_react2.default.Component);
	
	exports.default = ChangelogDialog;
	
	
	ChangelogDialog.propTypes = {
	    version: _react2.default.PropTypes.string.isRequired,
	    newVersion: _react2.default.PropTypes.string.isRequired,
	    onFinished: _react2.default.PropTypes.func.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _DirectoryUtils = __webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_ICON_URL = "img/network-matrix.svg"; /*
	                                                 Copyright 2016 OpenMarket Ltd
	                                                 
	                                                 Licensed under the Apache License, Version 2.0 (the "License");
	                                                 you may not use this file except in compliance with the License.
	                                                 You may obtain a copy of the License at
	                                                 
	                                                     http://www.apache.org/licenses/LICENSE-2.0
	                                                 
	                                                 Unless required by applicable law or agreed to in writing, software
	                                                 distributed under the License is distributed on an "AS IS" BASIS,
	                                                 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                 See the License for the specific language governing permissions and
	                                                 limitations under the License.
	                                                 */
	
	var NetworkDropdown = function (_React$Component) {
	    (0, _inherits3.default)(NetworkDropdown, _React$Component);
	
	    function NetworkDropdown(props) {
	        (0, _classCallCheck3.default)(this, NetworkDropdown);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (NetworkDropdown.__proto__ || (0, _getPrototypeOf2.default)(NetworkDropdown)).call(this, props));
	
	        _this.dropdownRootElement = null;
	        _this.ignoreEvent = null;
	
	        _this.onInputClick = _this.onInputClick.bind(_this);
	        _this.onRootClick = _this.onRootClick.bind(_this);
	        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
	        _this.onMenuOptionClick = _this.onMenuOptionClick.bind(_this);
	        _this.onInputKeyUp = _this.onInputKeyUp.bind(_this);
	        _this.collectRoot = _this.collectRoot.bind(_this);
	        _this.collectInputTextBox = _this.collectInputTextBox.bind(_this);
	
	        _this.inputTextBox = null;
	
	        var server = _MatrixClientPeg2.default.getHomeServerName();
	        _this.state = {
	            expanded: false,
	            selectedServer: server,
	            selectedInstance: null,
	            includeAllNetworks: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(NetworkDropdown, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Listen for all clicks on the document so we can close the
	            // menu when the user clicks somewhere else
	            document.addEventListener('click', this.onDocumentClick, false);
	
	            // fire this now so the defaults can be set up
	            this.props.onOptionChange(this.state.selectedServer, this.state.selectedInstance, this.state.includeAllNetworks);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.onDocumentClick, false);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.expanded && this.inputTextBox) {
	                this.inputTextBox.focus();
	            }
	        }
	    }, {
	        key: 'onDocumentClick',
	        value: function onDocumentClick(ev) {
	            // Close the dropdown if the user clicks anywhere that isn't
	            // within our root element
	            if (ev !== this.ignoreEvent) {
	                this.setState({
	                    expanded: false
	                });
	            }
	        }
	    }, {
	        key: 'onRootClick',
	        value: function onRootClick(ev) {
	            // This captures any clicks that happen within our elements,
	            // such that we can then ignore them when they're seen by the
	            // click listener on the document handler, ie. not close the
	            // dropdown immediately after opening it.
	            // NB. We can't just stopPropagation() because then the event
	            // doesn't reach the React onClick().
	            this.ignoreEvent = ev;
	        }
	    }, {
	        key: 'onInputClick',
	        value: function onInputClick(ev) {
	            this.setState({
	                expanded: !this.state.expanded
	            });
	            ev.preventDefault();
	        }
	    }, {
	        key: 'onMenuOptionClick',
	        value: function onMenuOptionClick(server, instance, includeAll) {
	            this.setState({
	                expanded: false,
	                selectedServer: server,
	                selectedInstanceId: instance ? instance.instance_id : null,
	                includeAll: includeAll
	            });
	            this.props.onOptionChange(server, instance ? instance.instance_id : null, includeAll);
	        }
	    }, {
	        key: 'onInputKeyUp',
	        value: function onInputKeyUp(e) {
	            if (e.key == 'Enter') {
	                this.setState({
	                    expanded: false,
	                    selectedServer: e.target.value,
	                    selectedNetwork: null
	                });
	                this.props.onOptionChange(e.target.value, null);
	            }
	        }
	    }, {
	        key: 'collectRoot',
	        value: function collectRoot(e) {
	            if (this.dropdownRootElement) {
	                this.dropdownRootElement.removeEventListener('click', this.onRootClick, false);
	            }
	            if (e) {
	                e.addEventListener('click', this.onRootClick, false);
	            }
	            this.dropdownRootElement = e;
	        }
	    }, {
	        key: 'collectInputTextBox',
	        value: function collectInputTextBox(e) {
	            this.inputTextBox = e;
	        }
	    }, {
	        key: '_getMenuOptions',
	        value: function _getMenuOptions() {
	            var options = [];
	
	            var servers = [];
	            if (this.props.config.servers) {
	                servers = servers.concat(this.props.config.servers);
	            }
	
	            if (servers.indexOf(_MatrixClientPeg2.default.getHomeServerName()) == -1) {
	                servers.unshift(_MatrixClientPeg2.default.getHomeServerName());
	            }
	
	            // For our own HS, we can use the instance_ids given in the third party protocols
	            // response to get the server to filter the room list by network for us.
	            // We can't get thirdparty protocols for remote server yet though, so for those
	            // we can only show the default room list.
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(servers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var server = _step.value;
	
	                    options.push(this._makeMenuOption(server, null, true));
	                    if (server == _MatrixClientPeg2.default.getHomeServerName()) {
	                        options.push(this._makeMenuOption(server, null, false));
	                        if (this.props.protocols) {
	                            var _iteratorNormalCompletion2 = true;
	                            var _didIteratorError2 = false;
	                            var _iteratorError2 = undefined;
	
	                            try {
	                                for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(this.props.protocols)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                    var proto = _step2.value;
	
	                                    if (!this.props.protocols[proto].instances) continue;
	                                    var _iteratorNormalCompletion3 = true;
	                                    var _didIteratorError3 = false;
	                                    var _iteratorError3 = undefined;
	
	                                    try {
	                                        for (var _iterator3 = (0, _getIterator3.default)(this.props.protocols[proto].instances), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                                            var instance = _step3.value;
	
	                                            if (!instance.instance_id) continue;
	                                            options.push(this._makeMenuOption(server, instance, false));
	                                        }
	                                    } catch (err) {
	                                        _didIteratorError3 = true;
	                                        _iteratorError3 = err;
	                                    } finally {
	                                        try {
	                                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                                _iterator3.return();
	                                            }
	                                        } finally {
	                                            if (_didIteratorError3) {
	                                                throw _iteratorError3;
	                                            }
	                                        }
	                                    }
	                                }
	                            } catch (err) {
	                                _didIteratorError2 = true;
	                                _iteratorError2 = err;
	                            } finally {
	                                try {
	                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                        _iterator2.return();
	                                    }
	                                } finally {
	                                    if (_didIteratorError2) {
	                                        throw _iteratorError2;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return options;
	        }
	    }, {
	        key: '_makeMenuOption',
	        value: function _makeMenuOption(server, instance, includeAll, handleClicks) {
	            if (handleClicks === undefined) handleClicks = true;
	
	            var icon = void 0;
	            var name = void 0;
	            var span_class = void 0;
	            var key = void 0;
	
	            if (!instance && includeAll) {
	                key = server;
	                name = server;
	                span_class = 'mx_NetworkDropdown_menu_all';
	            } else if (!instance) {
	                key = server + '_all';
	                name = 'Matrix';
	                icon = _react2.default.createElement('img', { src: 'img/network-matrix.svg' });
	                span_class = 'mx_NetworkDropdown_menu_network';
	            } else {
	                key = server + '_inst_' + instance.instance_id;
	                var imgUrl = instance.icon ? _MatrixClientPeg2.default.get().mxcUrlToHttp(instance.icon, 25, 25, 'crop', true) : DEFAULT_ICON_URL;
	                icon = _react2.default.createElement('img', { src: imgUrl });
	                name = instance.desc;
	                span_class = 'mx_NetworkDropdown_menu_network';
	            }
	
	            var click_handler = handleClicks ? this.onMenuOptionClick.bind(this, server, instance, includeAll) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { key: key, className: 'mx_NetworkDropdown_networkoption', onClick: click_handler },
	                icon,
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mx_NetworkDropdown_menu_network' },
	                    name
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var current_value = void 0;
	
	            var menu = void 0;
	            if (this.state.expanded) {
	                var menu_options = this._getMenuOptions();
	                menu = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_NetworkDropdown_menu' },
	                    menu_options
	                );
	                current_value = _react2.default.createElement('input', { type: 'text', className: 'mx_NetworkDropdown_networkoption',
	                    ref: this.collectInputTextBox, onKeyUp: this.onInputKeyUp,
	                    placeholder: 'matrix.org' // 'matrix.org' as an example of an HS name
	                });
	            } else {
	                var instance = (0, _DirectoryUtils.instanceForInstanceId)(this.props.protocols, this.state.selectedInstanceId);
	                current_value = this._makeMenuOption(this.state.selectedServer, instance, this.state.includeAll, false);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_NetworkDropdown', ref: this.collectRoot },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_NetworkDropdown_input', onClick: this.onInputClick },
	                    current_value,
	                    _react2.default.createElement('span', { className: 'mx_NetworkDropdown_arrow' }),
	                    menu
	                )
	            );
	        }
	    }]);
	    return NetworkDropdown;
	}(_react2.default.Component);
	
	exports.default = NetworkDropdown;
	
	
	NetworkDropdown.propTypes = {
	    onOptionChange: _react2.default.PropTypes.func.isRequired,
	    protocols: _react2.default.PropTypes.object,
	    // The room directory config. May have a 'servers' key that is a list of server names to include in the dropdown
	    config: _react2.default.PropTypes.object
	};
	
	NetworkDropdown.defaultProps = {
	    protocols: {},
	    config: {}
	};
	module.exports = exports['default'];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var MatrixClientPeg = __webpack_require__(4);
	
	var DateUtils = __webpack_require__(326);
	var filesize = __webpack_require__(300);
	var AccessibleButton = __webpack_require__(30);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'ImageView',
	
	    propTypes: {
	        src: React.PropTypes.string.isRequired, // the source of the image being displayed
	        name: React.PropTypes.string, // the main title ('name') for the image
	        link: React.PropTypes.string, // the link (if any) applied to the name of the image
	        width: React.PropTypes.number, // width of the image src in pixels
	        height: React.PropTypes.number, // height of the image src in pixels
	        fileSize: React.PropTypes.number, // size of the image src in bytes
	        onFinished: React.PropTypes.func.isRequired, // callback when the lightbox is dismissed
	
	        // the event (if any) that the Image is displaying. Used for event-specific stuff like
	        // redactions, senders, timestamps etc.  Other descriptors are taken from the explicit
	        // properties above, which let us use lightboxes to display images which aren't associated
	        // with events.
	        mxEvent: React.PropTypes.object
	    },
	
	    // XXX: keyboard shortcuts for managing dialogs should be done by the modal
	    // dialog base class somehow, surely...
	    componentDidMount: function componentDidMount() {
	        document.addEventListener("keydown", this.onKeyDown);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener("keydown", this.onKeyDown);
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        if (ev.keyCode == 27) {
	            // escape
	            ev.stopPropagation();
	            ev.preventDefault();
	            this.props.onFinished();
	        }
	    },
	
	    onRedactClick: function onRedactClick() {
	        var _this = this;
	
	        var ConfirmRedactDialog = sdk.getComponent("dialogs.ConfirmRedactDialog");
	        Modal.createDialog(ConfirmRedactDialog, {
	            onFinished: function onFinished(proceed) {
	                if (!proceed) return;
	                var self = _this;
	                MatrixClientPeg.get().redactEvent(_this.props.mxEvent.getRoomId(), _this.props.mxEvent.getId()).catch(function (e) {
	                    var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                    // display error message stating you couldn't delete this.
	                    var code = e.errcode || e.statusCode;
	                    Modal.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "You cannot delete this image. (" + code + ")"
	                    });
	                }).done();
	            }
	        });
	    },
	
	    getName: function getName() {
	        var name = this.props.name;
	        if (name && this.props.link) {
	            name = React.createElement(
	                'a',
	                { href: this.props.link, target: '_blank', rel: 'noopener' },
	                name
	            );
	        }
	        return name;
	    },
	
	    render: function render() {
	
	        /*
	                // In theory max-width: 80%, max-height: 80% on the CSS should work
	                // but in practice, it doesn't, so do it manually:
	        
	                var width = this.props.width || 500;
	                var height = this.props.height || 500;
	        
	                var maxWidth = document.documentElement.clientWidth * 0.8;
	                var maxHeight = document.documentElement.clientHeight * 0.8;
	        
	                var widthFrac = width / maxWidth;
	                var heightFrac = height / maxHeight;
	        
	                var displayWidth;
	                var displayHeight;
	                if (widthFrac > heightFrac) {
	                    displayWidth = Math.min(width, maxWidth);
	                    displayHeight = (displayWidth / width) * height;
	                } else {
	                    displayHeight = Math.min(height, maxHeight);
	                    displayWidth = (displayHeight / height) * width;
	                }
	        
	                var style = {
	                    width: displayWidth,
	                    height: displayHeight
	                };
	        */
	        var style, res;
	
	        if (this.props.width && this.props.height) {
	            style = {
	                width: this.props.width,
	                height: this.props.height
	            };
	            res = style.width + "x" + style.height + "px";
	        }
	
	        var size;
	        if (this.props.fileSize) {
	            size = filesize(this.props.fileSize);
	        }
	
	        var size_res;
	        if (size && res) {
	            size_res = size + ", " + res;
	        } else {
	            size_res = size || res;
	        }
	
	        var showEventMeta = !!this.props.mxEvent;
	
	        var eventMeta;
	        if (showEventMeta) {
	            eventMeta = React.createElement(
	                'div',
	                { className: 'mx_ImageView_metadata' },
	                'Uploaded on ',
	                DateUtils.formatDate(new Date(this.props.mxEvent.getTs())),
	                ' by ',
	                this.props.mxEvent.getSender()
	            );
	        }
	
	        var eventRedact;
	        if (showEventMeta) {
	            eventRedact = React.createElement(
	                'div',
	                { className: 'mx_ImageView_button', onClick: this.onRedactClick },
	                'Redact'
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_ImageView' },
	            React.createElement('div', { className: 'mx_ImageView_lhs' }),
	            React.createElement(
	                'div',
	                { className: 'mx_ImageView_content' },
	                React.createElement('img', { src: this.props.src, style: style }),
	                React.createElement(
	                    'div',
	                    { className: 'mx_ImageView_labelWrapper' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_ImageView_label' },
	                        React.createElement(
	                            AccessibleButton,
	                            { className: 'mx_ImageView_cancel', onClick: this.props.onFinished },
	                            React.createElement('img', { src: 'img/cancel-white.svg', width: '18', height: '18', alt: 'Close' })
	                        ),
	                        React.createElement('div', { className: 'mx_ImageView_shim' }),
	                        React.createElement(
	                            'div',
	                            { className: 'mx_ImageView_name' },
	                            this.getName()
	                        ),
	                        eventMeta,
	                        React.createElement(
	                            'a',
	                            { className: 'mx_ImageView_link', href: this.props.src, target: '_blank', rel: 'noopener' },
	                            React.createElement(
	                                'div',
	                                { className: 'mx_ImageView_download' },
	                                'Download this file',
	                                React.createElement('br', null),
	                                React.createElement(
	                                    'span',
	                                    { className: 'mx_ImageView_size' },
	                                    size_res
	                                )
	                            )
	                        ),
	                        eventRedact,
	                        React.createElement('div', { className: 'mx_ImageView_shim' })
	                    )
	                )
	            ),
	            React.createElement('div', { className: 'mx_ImageView_rhs' })
	        );
	    }
	});

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'Spinner',
	
	    render: function render() {
	        var w = this.props.w || 32;
	        var h = this.props.h || 32;
	        var imgClass = this.props.imgClassName || "";
	        return React.createElement(
	            'div',
	            { className: 'mx_Spinner' },
	            React.createElement('img', { src: 'img/spinner.gif', width: w, height: h, className: imgClass })
	        );
	    }
	});

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var dis = __webpack_require__(5);
	
	module.exports = React.createClass({
	    displayName: 'GuestWarningBar',
	
	    onRegisterClicked: function onRegisterClicked() {
	        dis.dispatch({ 'action': 'start_upgrade_registration' });
	    },
	
	    onLoginClicked: function onLoginClicked() {
	        dis.dispatch({ 'action': 'logout' });
	        dis.dispatch({ 'action': 'start_login' });
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_GuestWarningBar' },
	            React.createElement('img', { className: 'mx_GuestWarningBar_warning', src: 'img/warning.svg', width: '24', height: '23', alt: '/!\\' }),
	            React.createElement(
	                'div',
	                null,
	                'You are Rioting as a guest. ',
	                React.createElement(
	                    'a',
	                    { onClick: this.onRegisterClicked },
	                    'Register'
	                ),
	                ' or ',
	                React.createElement(
	                    'a',
	                    { onClick: this.onLoginClicked },
	                    'sign in'
	                ),
	                ' to access more rooms and features.'
	            )
	        );
	    }
	});

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var Notifier = __webpack_require__(170);
	var sdk = __webpack_require__(2);
	var AccessibleButton = __webpack_require__(30);
	
	module.exports = React.createClass({
	    displayName: 'MatrixToolbar',
	
	    hideToolbar: function hideToolbar() {
	        Notifier.setToolbarHidden(true);
	    },
	
	    onClick: function onClick() {
	        Notifier.setEnabled(true);
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_MatrixToolbar' },
	            React.createElement('img', { className: 'mx_MatrixToolbar_warning', src: 'img/warning.svg', width: '24', height: '23', alt: '/!\\' }),
	            React.createElement(
	                'div',
	                { className: 'mx_MatrixToolbar_content' },
	                'You are not receiving desktop notifications. ',
	                React.createElement(
	                    'a',
	                    { className: 'mx_MatrixToolbar_link', onClick: this.onClick },
	                    'Enable them now'
	                )
	            ),
	            React.createElement(
	                AccessibleButton,
	                { className: 'mx_MatrixToolbar_close', onClick: this.hideToolbar },
	                React.createElement('img', { src: 'img/cancel.svg', width: '18', height: '18' })
	            )
	        );
	    }
	});

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _matrixReactSdk = __webpack_require__(2);
	
	var _matrixReactSdk2 = _interopRequireDefault(_matrixReactSdk);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PlatformPeg = __webpack_require__(93);
	
	var _PlatformPeg2 = _interopRequireDefault(_PlatformPeg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check a version string is compatible with the Changelog
	 * dialog ([vectorversion]-react-[react-sdk-version]-js-[js-sdk-version])
	 */
	function checkVersion(ver) {
	    var parts = ver.split('-');
	    return parts.length == 5 && parts[1] == 'react' && parts[3] == 'js';
	}
	
	exports.default = _react2.default.createClass({
	    displayName: 'NewVersionBar',
	
	    propTypes: {
	        version: _react2.default.PropTypes.string.isRequired,
	        newVersion: _react2.default.PropTypes.string.isRequired,
	        releaseNotes: _react2.default.PropTypes.string
	    },
	
	    displayReleaseNotes: function displayReleaseNotes(releaseNotes) {
	        var QuestionDialog = _matrixReactSdk2.default.getComponent('dialogs.QuestionDialog');
	        _Modal2.default.createDialog(QuestionDialog, {
	            title: "What's New",
	            description: _react2.default.createElement(
	                'pre',
	                { className: 'changelog_text' },
	                releaseNotes
	            ),
	            button: "Update",
	            onFinished: function onFinished(update) {
	                if (update && _PlatformPeg2.default.get()) {
	                    _PlatformPeg2.default.get().installUpdate();
	                }
	            }
	        });
	    },
	
	    displayChangelog: function displayChangelog() {
	        var ChangelogDialog = _matrixReactSdk2.default.getComponent('dialogs.ChangelogDialog');
	        _Modal2.default.createDialog(ChangelogDialog, {
	            version: this.props.version,
	            newVersion: this.props.newVersion,
	            onFinished: function onFinished(update) {
	                if (update && _PlatformPeg2.default.get()) {
	                    _PlatformPeg2.default.get().installUpdate();
	                }
	            }
	        });
	    },
	
	    onUpdateClicked: function onUpdateClicked() {
	        _PlatformPeg2.default.get().installUpdate();
	    },
	
	    render: function render() {
	        var action_button = void 0;
	        // If we have release notes to display, we display them. Otherwise,
	        // we display the Changelog Dialog which takes two versions and
	        // automatically tells you what's changed (provided the versions
	        // are in the right format)
	        if (this.props.releaseNotes) {
	            action_button = _react2.default.createElement(
	                'button',
	                { className: 'mx_MatrixToolbar_action', onClick: this.displayReleaseNotes },
	                'What\'s new?'
	            );
	        } else if (checkVersion(this.props.version) && checkVersion(this.props.newVersion)) {
	            action_button = _react2.default.createElement(
	                'button',
	                { className: 'mx_MatrixToolbar_action', onClick: this.displayChangelog },
	                'What\'s new?'
	            );
	        } else if (_PlatformPeg2.default.get()) {
	            action_button = _react2.default.createElement(
	                'button',
	                { className: 'mx_MatrixToolbar_action', onClick: this.onUpdateClicked },
	                'Update'
	            );
	        }
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_MatrixToolbar' },
	            _react2.default.createElement('img', { className: 'mx_MatrixToolbar_warning', src: 'img/warning.svg', width: '24', height: '23', alt: '/!\\' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_MatrixToolbar_content' },
	                'A new version of Riot is available.'
	            ),
	            action_button
	        );
	    }
	});
	module.exports = exports['default'];

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'VectorCustomServerDialog',
	    statics: {
	        replaces: 'CustomServerDialog'
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_ErrorDialog' },
	            React.createElement(
	                'div',
	                { className: 'mx_Dialog_title' },
	                'Custom Server Options'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                React.createElement(
	                    'span',
	                    null,
	                    'You can use the custom server options to sign into other Matrix servers by specifying a different Home server URL.',
	                    React.createElement('br', null),
	                    'This allows you to use Riot with an existing Matrix account on a different home server.',
	                    React.createElement('br', null),
	                    React.createElement('br', null),
	                    'You can also set a custom identity server but you won\'t be able to invite users by email address, or be invited by email address yourself.'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                React.createElement(
	                    'button',
	                    { onClick: this.props.onFinished, autoFocus: true },
	                    'Dismiss'
	                )
	            )
	        );
	    }
	});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'VectorLoginFooter',
	    statics: {
	        replaces: 'LoginFooter'
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_Login_links' },
	            React.createElement(
	                'a',
	                { href: 'https://medium.com/@RiotChat' },
	                'blog'
	            ),
	            '\xA0\xA0\xB7\xA0\xA0',
	            React.createElement(
	                'a',
	                { href: 'https://twitter.com/@RiotChat' },
	                'twitter'
	            ),
	            '\xA0\xA0\xB7\xA0\xA0',
	            React.createElement(
	                'a',
	                { href: 'https://github.com/vector-im/vector-web' },
	                'github'
	            ),
	            '\xA0\xA0\xB7\xA0\xA0',
	            React.createElement(
	                'a',
	                { href: 'https://matrix.org' },
	                'powered by Matrix'
	            )
	        );
	    }
	});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'VectorLoginHeader',
	    statics: {
	        replaces: 'LoginHeader'
	    },
	    propTypes: {
	        icon: React.PropTypes.string
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_Login_logo' },
	            React.createElement('img', { src: this.props.icon || "img/logo.png", alt: 'Riot' })
	        );
	    }
	});

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	
	module.exports = React.createClass({
	    displayName: 'DateSeparator',
	    render: function render() {
	        var date = new Date(this.props.ts);
	        var today = new Date();
	        var yesterday = new Date();
	        yesterday.setDate(today.getDate() - 1);
	        var label;
	        if (date.toDateString() === today.toDateString()) {
	            label = "Today";
	        } else if (date.toDateString() === yesterday.toDateString()) {
	            label = "Yesterday";
	        } else if (today.getTime() - date.getTime() < 6 * 24 * 60 * 60 * 1000) {
	            label = days[date.getDay()];
	        } else {
	            label = date.toDateString();
	        }
	
	        return React.createElement(
	            'h2',
	            null,
	            label
	        );
	    }
	});

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var DateUtils = __webpack_require__(326);
	
	module.exports = React.createClass({
	    displayName: 'MessageTimestamp',
	
	    render: function render() {
	        var date = new Date(this.props.ts);
	        return React.createElement(
	            'span',
	            { className: 'mx_MessageTimestamp' },
	            DateUtils.formatTime(date)
	        );
	    }
	});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(341);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _matrixReactSdk = __webpack_require__(2);
	
	var _matrixReactSdk2 = _interopRequireDefault(_matrixReactSdk);
	
	var _RoomTile = __webpack_require__(516);
	
	var _RoomTile2 = _interopRequireDefault(_RoomTile);
	
	var _Rooms = __webpack_require__(117);
	
	var Rooms = _interopRequireWildcard(_Rooms);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Defines a new Component, DNDRoomTile that wraps RoomTile, making it draggable.
	 * Requires extra props:
	 *   roomSubList: React.PropTypes.object.isRequired,
	 *   refreshSubList: React.PropTypes.func.isRequired,
	 */
	
	/**
	 * Specifies the drag source contract.
	 * Only `beginDrag` function is required.
	 */
	var roomTileSource = {
	    canDrag: function canDrag(props, monitor) {
	        return props.roomSubList.props.editable;
	    },
	
	    beginDrag: function beginDrag(props) {
	        // Return the data describing the dragged item
	        var item = {
	            room: props.room,
	            originalList: props.roomSubList,
	            originalIndex: props.roomSubList.findRoomTile(props.room).index,
	            targetList: props.roomSubList };
	
	        if (props.roomSubList.debug) console.log("roomTile beginDrag for " + item.room.roomId);
	
	        // doing this 'correctly' with state causes react-dnd to break seemingly due to the state transitions
	        props.room._dragging = true;
	
	        return item;
	    },
	
	    endDrag: function endDrag(props, monitor, component) {
	        var item = monitor.getItem();
	
	        if (props.roomSubList.debug) console.log("roomTile endDrag for " + item.room.roomId + " with didDrop=" + monitor.didDrop());
	
	        props.room._dragging = false;
	        if (monitor.didDrop()) {
	            if (props.roomSubList.debug) console.log("force updating component " + item.targetList.props.label);
	            item.targetList.forceUpdate(); // as we're not using state
	        }
	
	        var prevTag = item.originalList.props.tagName;
	        var newTag = item.targetList.props.tagName;
	
	        if (monitor.didDrop() && item.targetList.props.editable) {
	            // Evil hack to get DMs behaving
	            if (prevTag === undefined && newTag === 'im.vector.fake.direct' || prevTag === 'im.vector.fake.direct' && newTag === undefined) {
	                Rooms.guessAndSetDMRoom(item.room, newTag === 'im.vector.fake.direct').done(function () {
	                    item.originalList.removeRoomTile(item.room);
	                }, function (err) {
	                    var ErrorDialog = _matrixReactSdk2.default.getComponent("dialogs.ErrorDialog");
	                    console.error("Failed to set direct chat tag " + err);
	                    _Modal2.default.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "Failed to set direct chat tag"
	                    });
	                });
	                return;
	            }
	
	            // More evilness: We will still be dealing with moving to favourites/low prio,
	            // but we avoid ever doing a request with 'im.vector.fake.direct`.
	
	            // if we moved lists, remove the old tag
	            if (prevTag && prevTag !== 'im.vector.fake.direct' && item.targetList !== item.originalList) {
	                // commented out attempts to set a spinner on our target component as component is actually
	                // the original source component being dragged, not our target.  To fix we just need to
	                // move all of this to endDrop in the target instead.  FIXME later.
	
	                //component.state.set({ spinner: component.state.spinner ? component.state.spinner++ : 1 });
	                _MatrixClientPeg2.default.get().deleteRoomTag(item.room.roomId, prevTag).finally(function () {
	                    //component.state.set({ spinner: component.state.spinner-- });
	                }).fail(function (err) {
	                    var ErrorDialog = _matrixReactSdk2.default.getComponent("dialogs.ErrorDialog");
	                    console.error("Failed to remove tag " + prevTag + " from room: " + err);
	                    _Modal2.default.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "Failed to remove tag " + prevTag + " from room"
	                    });
	                });
	            }
	
	            var newOrder = {};
	            if (item.targetList.props.order === 'manual') {
	                newOrder['order'] = item.targetList.calcManualOrderTagData(item.room);
	            }
	
	            // if we moved lists or the ordering changed, add the new tag
	            if (newTag && newTag !== 'im.vector.fake.direct' && (item.targetList !== item.originalList || newOrder)) {
	                //component.state.set({ spinner: component.state.spinner ? component.state.spinner++ : 1 });
	                _MatrixClientPeg2.default.get().setRoomTag(item.room.roomId, newTag, newOrder).finally(function () {
	                    //component.state.set({ spinner: component.state.spinner-- });
	                }).fail(function (err) {
	                    var ErrorDialog = _matrixReactSdk2.default.getComponent("dialogs.ErrorDialog");
	                    console.error("Failed to add tag " + newTag + " to room: " + err);
	                    _Modal2.default.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "Failed to add tag " + newTag + " to room"
	                    });
	                });
	            }
	        } else {
	            // cancel the drop and reset our original position
	            if (props.roomSubList.debug) console.log("cancelling drop & drag");
	            props.roomSubList.moveRoomTile(item.room, item.originalIndex);
	            if (item.targetList && item.targetList !== item.originalList) {
	                item.targetList.removeRoomTile(item.room);
	            }
	        }
	    }
	};
	
	var roomTileTarget = {
	    canDrop: function canDrop() {
	        return false;
	    },
	
	    hover: function hover(props, monitor) {
	        var item = monitor.getItem();
	        //var off = monitor.getClientOffset();
	        // console.log("hovering on room " + props.room.roomId + ", isOver=" + monitor.isOver());
	
	        //console.log("item.targetList=" + item.targetList + ", roomSubList=" + props.roomSubList);
	
	        var switchedTarget = false;
	        if (item.targetList !== props.roomSubList) {
	            // we've switched target, so remove the tile from the previous target.
	            // n.b. the previous target might actually be the source list.
	            if (props.roomSubList.debug) console.log("switched target sublist");
	            switchedTarget = true;
	            item.targetList.removeRoomTile(item.room);
	            item.targetList = props.roomSubList;
	        }
	
	        if (!item.targetList.props.editable) return;
	
	        if (item.targetList.props.order === 'manual') {
	            if (item.room.roomId !== props.room.roomId && props.room !== item.lastTargetRoom) {
	                // find the offset of the target tile in the list.
	                var roomTile = props.roomSubList.findRoomTile(props.room);
	                // shuffle the list to add our tile to that position.
	                props.roomSubList.moveRoomTile(item.room, roomTile.index);
	            }
	
	            // stop us from flickering between our droptarget and the previous room.
	            // whenever the cursor changes direction we have to reset the flicker-damping.
	            /*
	                        var yDelta = off.y - item.lastYOffset;
	            
	                        if ((yDelta > 0 && item.lastYDelta < 0) ||
	                            (yDelta < 0 && item.lastYDelta > 0))
	                        {
	                            // the cursor changed direction - forget our previous room
	                            item.lastTargetRoom = null;
	                        }
	                        else {
	                            // track the last room we were hovering over so we can stop
	                            // bouncing back and forth if the droptarget is narrower than
	                            // the other list items.  The other way to do this would be
	                            // to reduce the size of the hittarget on the list items, but
	                            // can't see an easy way to do that.
	                            item.lastTargetRoom = props.room;
	                        }
	            
	                        if (yDelta) item.lastYDelta = yDelta;
	                        item.lastYOffset = off.y;
	            */
	        } else if (switchedTarget) {
	            if (!props.roomSubList.findRoomTile(item.room).room) {
	                // add to the list in the right place
	                props.roomSubList.moveRoomTile(item.room, 0);
	            }
	            // we have to sort the list whatever to recalculate it
	            props.roomSubList.sortList();
	        }
	    }
	};
	
	// Export the wrapped version, inlining the 'collect' functions
	// to more closely resemble the ES7
	module.exports = (0, _reactDnd.DropTarget)('RoomTile', roomTileTarget, function (connect, monitor) {
	    return {
	        // Call this function inside render()
	        // to let React DnD handle the drag events:
	        connectDropTarget: connect.dropTarget(),
	        isOver: monitor.isOver()
	    };
	})((0, _reactDnd.DragSource)('RoomTile', roomTileSource, function (connect, monitor) {
	    return {
	        // Call this function inside render()
	        // to let React DnD handle the drag events:
	        connectDragSource: connect.dragSource(),
	        // You can ask the monitor about the current drag state:
	        isDragging: monitor.isDragging()
	    };
	})(_RoomTile2.default));

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'RoomDropTarget',
	
	    render: function render() {
	        if (this.props.placeholder) {
	            return React.createElement('div', { className: 'mx_RoomDropTarget mx_RoomDropTarget_placeholder' });
	        } else {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomDropTarget' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomDropTarget_label' },
	                    this.props.label
	                )
	            );
	        }
	    }
	});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var dis = __webpack_require__(5);
	
	module.exports = React.createClass({
	    displayName: 'RoomTooltip',
	
	    propTypes: {
	        // Alllow the tooltip to be styled by the parent element
	        className: React.PropTypes.string.isRequired,
	        // The tooltip is derived from either the room name or a label
	        room: React.PropTypes.object,
	        label: React.PropTypes.string
	    },
	
	    // Create a wrapper for the tooltip outside the parent and attach it to the body element
	    componentDidMount: function componentDidMount() {
	        this.tooltipContainer = document.createElement("div");
	        this.tooltipContainer.className = "mx_RoomTileTooltip_wrapper";
	        document.body.appendChild(this.tooltipContainer);
	
	        this._renderTooltip();
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        this._renderTooltip();
	    },
	
	    // Remove the wrapper element, as the tooltip has finished using it
	    componentWillUnmount: function componentWillUnmount() {
	        dis.dispatch({
	            action: 'view_tooltip',
	            tooltip: null,
	            parent: null
	        });
	
	        ReactDOM.unmountComponentAtNode(this.tooltipContainer);
	        document.body.removeChild(this.tooltipContainer);
	    },
	
	    _renderTooltip: function _renderTooltip() {
	        var label = this.props.room ? this.props.room.name : this.props.label;
	
	        // Add the parent's position to the tooltips, so it's correctly
	        // positioned, also taking into account any window zoom
	        // NOTE: The additional 6 pixels for the left position, is to take account of the
	        // tooltips chevron
	        var parent = ReactDOM.findDOMNode(this);
	        var style = {};
	        style.top = parent.getBoundingClientRect().top + window.pageYOffset;
	        style.left = 6 + parent.getBoundingClientRect().right + window.pageXOffset;
	        style.display = "block";
	
	        var tooltip = React.createElement(
	            'div',
	            { className: 'mx_RoomTooltip', style: style },
	            React.createElement('div', { className: 'mx_RoomTooltip_chevron' }),
	            label
	        );
	
	        // Render the tooltip manually, as we wish it not to be rendered within the parent
	        this.tooltip = ReactDOM.render(tooltip, this.tooltipContainer);
	
	        // Tell the roomlist about us so it can manipulate us if it wishes
	        dis.dispatch({
	            action: 'view_tooltip',
	            tooltip: this.tooltip,
	            parent: parent
	        });
	    },
	
	    render: function render() {
	        // Render a placeholder
	        return React.createElement('div', { className: this.props.className });
	    }
	});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	var classNames = __webpack_require__(27);
	var AccessibleButton = __webpack_require__(30);
	
	module.exports = React.createClass({
	    displayName: 'SearchBar',
	
	    getInitialState: function getInitialState() {
	        return {
	            scope: 'Room'
	        };
	    },
	
	    onThisRoomClick: function onThisRoomClick() {
	        this.setState({ scope: 'Room' });
	    },
	
	    onAllRoomsClick: function onAllRoomsClick() {
	        this.setState({ scope: 'All' });
	    },
	
	    onSearchChange: function onSearchChange(e) {
	        if (e.keyCode === 13) {
	            // on enter...
	            this.onSearch();
	        }
	        if (e.keyCode === 27) {
	            // escape...
	            this.props.onCancelClick();
	        }
	    },
	
	    onSearch: function onSearch() {
	        this.props.onSearch(this.refs.search_term.value, this.state.scope);
	    },
	
	    render: function render() {
	        var searchButtonClasses = classNames({ mx_SearchBar_searchButton: true, mx_SearchBar_searching: this.props.searchInProgress });
	        var thisRoomClasses = classNames({ mx_SearchBar_button: true, mx_SearchBar_unselected: this.state.scope !== 'Room' });
	        var allRoomsClasses = classNames({ mx_SearchBar_button: true, mx_SearchBar_unselected: this.state.scope !== 'All' });
	
	        return React.createElement(
	            'div',
	            { className: 'mx_SearchBar' },
	            React.createElement('input', { ref: 'search_term', className: 'mx_SearchBar_input', type: 'text', autoFocus: true, placeholder: 'Search...', onKeyDown: this.onSearchChange }),
	            React.createElement(
	                AccessibleButton,
	                { className: searchButtonClasses, onClick: this.onSearch },
	                React.createElement('img', { src: 'img/search-button.svg', width: '37', height: '37', alt: 'Search' })
	            ),
	            React.createElement(
	                AccessibleButton,
	                { className: thisRoomClasses, onClick: this.onThisRoomClick },
	                'This Room'
	            ),
	            React.createElement(
	                AccessibleButton,
	                { className: allRoomsClasses, onClick: this.onAllRoomsClick },
	                'All Rooms'
	            ),
	            React.createElement(
	                AccessibleButton,
	                { className: 'mx_SearchBar_cancel', onClick: this.props.onCancelClick },
	                React.createElement('img', { src: 'img/cancel.svg', width: '18', height: '18' })
	            )
	        );
	    }
	});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	
	module.exports = React.createClass({
	    displayName: 'IntegrationsManager',
	
	    propTypes: {
	        src: React.PropTypes.string.isRequired, // the source of the integration manager being embedded
	        onFinished: React.PropTypes.func.isRequired },
	
	    // XXX: keyboard shortcuts for managing dialogs should be done by the modal
	    // dialog base class somehow, surely...
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        document.addEventListener("keydown", this.onKeyDown);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	        document.removeEventListener("keydown", this.onKeyDown);
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        if (ev.keyCode == 27) {
	            // escape
	            ev.stopPropagation();
	            ev.preventDefault();
	            this.props.onFinished();
	        }
	    },
	
	    onAction: function onAction(payload) {
	        if (payload.action === 'close_scalar') {
	            this.props.onFinished();
	        }
	    },
	
	    render: function render() {
	        return React.createElement('iframe', { src: this.props.src });
	    }
	});

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var q = __webpack_require__(6);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var UserSettingsStore = __webpack_require__(74);
	var Modal = __webpack_require__(10);
	
	var notifications = __webpack_require__(596);
	
	// TODO: this "view" component still has far too much application logic in it,
	// which should be factored out to other files.
	
	// TODO: this component also does a lot of direct poking into this.state, which
	// is VERY NAUGHTY.
	
	var NotificationUtils = notifications.NotificationUtils;
	var VectorPushRulesDefinitions = notifications.VectorPushRulesDefinitions;
	var PushRuleVectorState = notifications.PushRuleVectorState;
	var ContentRules = notifications.ContentRules;
	
	/**
	 * Rules that Vector used to set in order to override the actions of default rules.
	 * These are used to port peoples existing overrides to match the current API.
	 * These can be removed and forgotten once everyone has moved to the new client.
	 */
	var LEGACY_RULES = {
	    "im.vector.rule.contains_display_name": ".m.rule.contains_display_name",
	    "im.vector.rule.room_one_to_one": ".m.rule.room_one_to_one",
	    "im.vector.rule.room_message": ".m.rule.message",
	    "im.vector.rule.invite_for_me": ".m.rule.invite_for_me",
	    "im.vector.rule.call": ".m.rule.call",
	    "im.vector.rule.notices": ".m.rule.suppress_notices"
	};
	
	function portLegacyActions(actions) {
	    var decoded = NotificationUtils.decodeActions(actions);
	    if (decoded !== null) {
	        return NotificationUtils.encodeActions(decoded);
	    } else {
	        // We don't recognise one of the actions here, so we don't try to
	        // canonicalise them.
	        return actions;
	    }
	}
	
	module.exports = React.createClass({
	    displayName: 'Notififications',
	
	    phases: {
	        LOADING: "LOADING", // The component is loading or sending data to the hs
	        DISPLAY: "DISPLAY", // The component is ready and display data
	        ERROR: "ERROR" // There was an error
	    },
	
	    propTypes: {
	        // The array of threepids from the JS SDK (required for email notifications)
	        threepids: React.PropTypes.array.isRequired,
	        // The brand string set when creating an email pusher
	        brand: React.PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            threepids: []
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            phase: this.phases.LOADING,
	            masterPushRule: undefined, // The master rule ('.m.rule.master')
	            vectorPushRules: [], // HS default push rules displayed in Vector UI
	            vectorContentRules: { // Keyword push rules displayed in Vector UI
	                vectorState: PushRuleVectorState.ON,
	                rules: []
	            },
	            externalPushRules: [], // Push rules (except content rule) that have been defined outside Vector UI
	            externalContentRules: [] // Keyword push rules that have been defined outside Vector UI
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this._refreshFromServer();
	    },
	
	    onEnableNotificationsChange: function onEnableNotificationsChange(event) {
	        var self = this;
	        this.setState({
	            phase: this.phases.LOADING
	        });
	
	        MatrixClientPeg.get().setPushRuleEnabled('global', self.state.masterPushRule.kind, self.state.masterPushRule.rule_id, !event.target.checked).done(function () {
	            self._refreshFromServer();
	        });
	    },
	
	    onEnableDesktopNotificationsChange: function onEnableDesktopNotificationsChange(event) {
	        UserSettingsStore.setEnableNotifications(event.target.checked);
	    },
	
	    onEnableEmailNotificationsChange: function onEnableEmailNotificationsChange(address, event) {
	        var _this = this;
	
	        var emailPusherPromise;
	        if (event.target.checked) {
	            var data = {};
	            data['brand'] = this.props.brand || 'Riot';
	            emailPusherPromise = UserSettingsStore.addEmailPusher(address, data);
	        } else {
	            var emailPusher = UserSettingsStore.getEmailPusher(this.state.pushers, address);
	            emailPusher.kind = null;
	            emailPusherPromise = MatrixClientPeg.get().setPusher(emailPusher);
	        }
	        emailPusherPromise.done(function () {
	            _this._refreshFromServer();
	        }, function (error) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Error saving email notification preferences",
	                description: "An error occurred whilst saving your email notification preferences."
	            });
	        });
	    },
	
	    onNotifStateButtonClicked: function onNotifStateButtonClicked(event) {
	        // FIXME: use .bind() rather than className metadata here surely
	        var vectorRuleId = event.target.className.split("-")[0];
	        var newPushRuleVectorState = event.target.className.split("-")[1];
	
	        if ("_keywords" === vectorRuleId) {
	            this._setKeywordsPushRuleVectorState(newPushRuleVectorState);
	        } else {
	            var rule = this.getRule(vectorRuleId);
	            if (rule) {
	                this._setPushRuleVectorState(rule, newPushRuleVectorState);
	            }
	        }
	    },
	
	    onKeywordsClicked: function onKeywordsClicked(event) {
	        var self = this;
	
	        // Compute the keywords list to display
	        var keywords = [];
	        for (var i in this.state.vectorContentRules.rules) {
	            var rule = this.state.vectorContentRules.rules[i];
	            keywords.push(rule.pattern);
	        }
	        if (keywords.length) {
	            // As keeping the order of per-word push rules hs side is a bit tricky to code,
	            // display the keywords in alphabetical order to the user
	            keywords.sort();
	
	            keywords = keywords.join(", ");
	        } else {
	            keywords = "";
	        }
	
	        var TextInputDialog = sdk.getComponent("dialogs.TextInputDialog");
	        Modal.createDialog(TextInputDialog, {
	            title: "Keywords",
	            description: "Enter keywords separated by a comma:",
	            value: keywords,
	            onFinished: function onFinished(should_leave, newValue) {
	
	                if (should_leave && newValue !== keywords) {
	                    var newKeywords = newValue.split(',');
	                    for (var i in newKeywords) {
	                        newKeywords[i] = newKeywords[i].trim();
	                    }
	
	                    // Remove duplicates and empty
	                    newKeywords = newKeywords.reduce(function (array, keyword) {
	                        if (keyword !== "" && array.indexOf(keyword) < 0) {
	                            array.push(keyword);
	                        }
	                        return array;
	                    }, []);
	
	                    self._setKeywords(newKeywords);
	                }
	            }
	        });
	    },
	
	    getRule: function getRule(vectorRuleId) {
	        for (var i in this.state.vectorPushRules) {
	            var rule = this.state.vectorPushRules[i];
	            if (rule.vectorRuleId === vectorRuleId) {
	                return rule;
	            }
	        }
	    },
	
	    _setPushRuleVectorState: function _setPushRuleVectorState(rule, newPushRuleVectorState) {
	        if (rule && rule.vectorState !== newPushRuleVectorState) {
	
	            this.setState({
	                phase: this.phases.LOADING
	            });
	
	            var self = this;
	            var cli = MatrixClientPeg.get();
	            var deferreds = [];
	            var ruleDefinition = VectorPushRulesDefinitions[rule.vectorRuleId];
	
	            if (rule.rule) {
	                var actions = ruleDefinition.vectorStateToActions[newPushRuleVectorState];
	
	                if (!actions) {
	                    // The new state corresponds to disabling the rule.
	                    deferreds.push(cli.setPushRuleEnabled('global', rule.rule.kind, rule.rule.rule_id, false));
	                } else {
	                    // The new state corresponds to enabling the rule and setting specific actions
	                    deferreds.push(this._updatePushRuleActions(rule.rule, actions, true));
	                }
	            }
	
	            q.all(deferreds).done(function () {
	                self._refreshFromServer();
	            }, function (error) {
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                console.error("Failed to change settings: " + error);
	                Modal.createDialog(ErrorDialog, {
	                    title: "Error",
	                    description: "Failed to change settings",
	                    onFinished: self._refreshFromServer
	                });
	            });
	        }
	    },
	
	    _setKeywordsPushRuleVectorState: function _setKeywordsPushRuleVectorState(newPushRuleVectorState) {
	        // Is there really a change?
	        if (this.state.vectorContentRules.vectorState === newPushRuleVectorState || this.state.vectorContentRules.rules.length === 0) {
	            return;
	        }
	
	        var self = this;
	        var cli = MatrixClientPeg.get();
	
	        this.setState({
	            phase: this.phases.LOADING
	        });
	
	        // Update all rules in self.state.vectorContentRules
	        var deferreds = [];
	        for (var i in this.state.vectorContentRules.rules) {
	            var rule = this.state.vectorContentRules.rules[i];
	
	            var enabled, actions;
	            switch (newPushRuleVectorState) {
	                case PushRuleVectorState.ON:
	                    if (rule.actions.length !== 1) {
	                        actions = PushRuleVectorState.actionsFor(PushRuleVectorState.ON);
	                    }
	
	                    if (this.state.vectorContentRules.vectorState === PushRuleVectorState.OFF) {
	                        enabled = true;
	                    }
	                    break;
	
	                case PushRuleVectorState.LOUD:
	                    if (rule.actions.length !== 3) {
	                        actions = PushRuleVectorState.actionsFor(PushRuleVectorState.LOUD);
	                    }
	
	                    if (this.state.vectorContentRules.vectorState === PushRuleVectorState.OFF) {
	                        enabled = true;
	                    }
	                    break;
	
	                case PushRuleVectorState.OFF:
	                    enabled = false;
	                    break;
	            }
	
	            if (actions) {
	                // Note that the workaround in _updatePushRuleActions will automatically
	                // enable the rule
	                deferreds.push(this._updatePushRuleActions(rule, actions, enabled));
	            } else if (enabled != undefined) {
	                deferreds.push(cli.setPushRuleEnabled('global', rule.kind, rule.rule_id, enabled));
	            }
	        }
	
	        q.all(deferreds).done(function (resps) {
	            self._refreshFromServer();
	        }, function (error) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            console.error("Can't update user notification settings: " + error);
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "Can't update user notification settings",
	                onFinished: self._refreshFromServer
	            });
	        });
	    },
	
	    _setKeywords: function _setKeywords(newKeywords) {
	        this.setState({
	            phase: this.phases.LOADING
	        });
	
	        var self = this;
	        var cli = MatrixClientPeg.get();
	        var removeDeferreds = [];
	
	        // Remove per-word push rules of keywords that are no more in the list
	        var vectorContentRulesPatterns = [];
	        for (var i in self.state.vectorContentRules.rules) {
	            var rule = self.state.vectorContentRules.rules[i];
	
	            vectorContentRulesPatterns.push(rule.pattern);
	
	            if (newKeywords.indexOf(rule.pattern) < 0) {
	                removeDeferreds.push(cli.deletePushRule('global', rule.kind, rule.rule_id));
	            }
	        }
	
	        // If the keyword is part of `externalContentRules`, remove the rule
	        // before recreating it in the right Vector path
	        for (var i in self.state.externalContentRules) {
	            var rule = self.state.externalContentRules[i];
	
	            if (newKeywords.indexOf(rule.pattern) >= 0) {
	                removeDeferreds.push(cli.deletePushRule('global', rule.kind, rule.rule_id));
	            }
	        }
	
	        var onError = function onError(error) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            console.error("Failed to update keywords: " + error);
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "Failed to update keywords",
	                onFinished: self._refreshFromServer
	            });
	        };
	
	        // Then, add the new ones
	        q.all(removeDeferreds).done(function (resps) {
	            var deferreds = [];
	
	            var pushRuleVectorStateKind = self.state.vectorContentRules.vectorState;
	            if (pushRuleVectorStateKind === PushRuleVectorState.OFF) {
	                // When the current global keywords rule is OFF, we need to look at
	                // the flavor of rules in 'vectorContentRules' to apply the same actions
	                // when creating the new rule.
	                // Thus, this new rule will join the 'vectorContentRules' set.
	                if (self.state.vectorContentRules.rules.length) {
	                    pushRuleVectorStateKind = PushRuleVectorState.contentRuleVectorStateKind(self.state.vectorContentRules.rules[0]);
	                } else {
	                    // ON is default
	                    pushRuleVectorStateKind = PushRuleVectorState.ON;
	                }
	            }
	
	            for (var i in newKeywords) {
	                var keyword = newKeywords[i];
	
	                if (vectorContentRulesPatterns.indexOf(keyword) < 0) {
	                    if (self.state.vectorContentRules.vectorState !== PushRuleVectorState.OFF) {
	                        deferreds.push(cli.addPushRule('global', 'content', keyword, {
	                            actions: PushRuleVectorState.actionsFor(pushRuleVectorStateKind),
	                            pattern: keyword
	                        }));
	                    } else {
	                        deferreds.push(self._addDisabledPushRule('global', 'content', keyword, {
	                            actions: PushRuleVectorState.actionsFor(pushRuleVectorStateKind),
	                            pattern: keyword
	                        }));
	                    }
	                }
	            }
	
	            q.all(deferreds).done(function (resps) {
	                self._refreshFromServer();
	            }, onError);
	        }, onError);
	    },
	
	    // Create a push rule but disabled
	    _addDisabledPushRule: function _addDisabledPushRule(scope, kind, ruleId, body) {
	        var cli = MatrixClientPeg.get();
	        return cli.addPushRule(scope, kind, ruleId, body).then(function () {
	            return cli.setPushRuleEnabled(scope, kind, ruleId, false);
	        });
	    },
	
	    // Check if any legacy im.vector rules need to be ported to the new API
	    // for overriding the actions of default rules.
	    _portRulesToNewAPI: function _portRulesToNewAPI(rulesets) {
	        var self = this;
	        var needsUpdate = [];
	        var cli = MatrixClientPeg.get();
	
	        for (var kind in rulesets.global) {
	            var ruleset = rulesets.global[kind];
	            for (var i = 0; i < ruleset.length; ++i) {
	                var rule = ruleset[i];
	                if (rule.rule_id in LEGACY_RULES) {
	                    console.log("Porting legacy rule", rule);
	                    needsUpdate.push(function (kind, rule) {
	                        return cli.setPushRuleActions('global', kind, LEGACY_RULES[rule.rule_id], portLegacyActions(rule.actions)).then(function () {
	                            return cli.deletePushRule('global', kind, rule.rule_id);
	                        });
	                    }(kind, rule));
	                }
	            }
	        }
	
	        if (needsUpdate.length > 0) {
	            // If some of the rules need to be ported then wait for the porting
	            // to happen and then fetch the rules again.
	            return q.allSettled(needsUpdate).then(function () {
	                return cli.getPushRules();
	            });
	        } else {
	            // Otherwise return the rules that we already have.
	            return rulesets;
	        }
	    },
	
	    _refreshFromServer: function _refreshFromServer() {
	        var self = this;
	        var pushRulesPromise = MatrixClientPeg.get().getPushRules().then(self._portRulesToNewAPI).then(function (rulesets) {
	            //console.log("resolving pushRulesPromise");
	
	            /// XXX seriously? wtf is this?
	            MatrixClientPeg.get().pushRules = rulesets;
	
	            // Get homeserver default rules and triage them by categories
	            var rule_categories = {
	                // The master rule (all notifications disabling)
	                '.m.rule.master': 'master',
	
	                // The default push rules displayed by Vector UI
	                '.m.rule.contains_display_name': 'vector',
	                '.m.rule.contains_user_name': 'vector',
	                '.m.rule.room_one_to_one': 'vector',
	                '.m.rule.message': 'vector',
	                '.m.rule.invite_for_me': 'vector',
	                //'.m.rule.member_event': 'vector',
	                '.m.rule.call': 'vector',
	                '.m.rule.suppress_notices': 'vector'
	
	                // Others go to others
	            };
	
	            // HS default rules
	            var defaultRules = { master: [], vector: {}, others: [] };
	
	            for (var kind in rulesets.global) {
	                for (var i = 0; i < (0, _keys2.default)(rulesets.global[kind]).length; ++i) {
	                    var r = rulesets.global[kind][i];
	                    var cat = rule_categories[r.rule_id];
	                    r.kind = kind;
	
	                    if (r.rule_id[0] === '.') {
	                        if (cat === 'vector') {
	                            defaultRules.vector[r.rule_id] = r;
	                        } else if (cat === 'master') {
	                            defaultRules.master.push(r);
	                        } else {
	                            defaultRules['others'].push(r);
	                        }
	                    }
	                }
	            }
	
	            // Get the master rule if any defined by the hs
	            if (defaultRules.master.length > 0) {
	                self.state.masterPushRule = defaultRules.master[0];
	            }
	
	            // parse the keyword rules into our state
	            var contentRules = ContentRules.parseContentRules(rulesets);
	            self.state.vectorContentRules = {
	                vectorState: contentRules.vectorState,
	                rules: contentRules.rules
	            };
	            self.state.externalContentRules = contentRules.externalRules;
	
	            // Build the rules displayed in the Vector UI matrix table
	            self.state.vectorPushRules = [];
	            self.state.externalPushRules = [];
	
	            var vectorRuleIds = ['.m.rule.contains_display_name', '.m.rule.contains_user_name', '_keywords', '.m.rule.room_one_to_one', '.m.rule.message', '.m.rule.invite_for_me',
	            //'im.vector.rule.member_event',
	            '.m.rule.call', '.m.rule.suppress_notices'];
	            for (var i in vectorRuleIds) {
	                var vectorRuleId = vectorRuleIds[i];
	
	                if (vectorRuleId === '_keywords') {
	                    // keywords needs a special handling
	                    // For Vector UI, this is a single global push rule but translated in Matrix,
	                    // it corresponds to all content push rules (stored in self.state.vectorContentRule)
	                    self.state.vectorPushRules.push({
	                        "vectorRuleId": "_keywords",
	                        "description": React.createElement(
	                            'span',
	                            null,
	                            'Messages containing ',
	                            React.createElement(
	                                'span',
	                                { className: 'mx_UserNotifSettings_keywords', onClick: self.onKeywordsClicked },
	                                'keywords'
	                            )
	                        ),
	                        "vectorState": self.state.vectorContentRules.vectorState
	                    });
	                } else {
	                    var ruleDefinition = VectorPushRulesDefinitions[vectorRuleId];
	                    var rule = defaultRules.vector[vectorRuleId];
	
	                    var vectorState = ruleDefinition.ruleToVectorState(rule);
	
	                    //console.log("Refreshing vectorPushRules for " + vectorRuleId +", "+ ruleDefinition.description +", " + rule +", " + vectorState);
	
	                    self.state.vectorPushRules.push({
	                        "vectorRuleId": vectorRuleId,
	                        "description": ruleDefinition.description,
	                        "rule": rule,
	                        "vectorState": vectorState
	                    });
	
	                    // if there was a rule which we couldn't parse, add it to the external list
	                    if (rule && !vectorState) {
	                        rule.description = ruleDefinition.description;
	                        self.state.externalPushRules.push(rule);
	                    }
	                }
	            }
	
	            // Build the rules not managed by Vector UI
	            var otherRulesDescriptions = {
	                '.m.rule.message': "Notify for all other messages/rooms",
	                '.m.rule.fallback': "Notify me for anything else"
	            };
	
	            for (var i in defaultRules.others) {
	                var rule = defaultRules.others[i];
	                var ruleDescription = otherRulesDescriptions[rule.rule_id];
	
	                // Show enabled default rules that was modified by the user
	                if (ruleDescription && rule.enabled && !rule.default) {
	                    rule.description = ruleDescription;
	                    self.state.externalPushRules.push(rule);
	                }
	            }
	        });
	
	        var pushersPromise = MatrixClientPeg.get().getPushers().then(function (resp) {
	            //console.log("resolving pushersPromise");
	            self.setState({ pushers: resp.pushers });
	        });
	
	        q.all([pushRulesPromise, pushersPromise]).then(function () {
	            self.setState({
	                phase: self.phases.DISPLAY
	            });
	        }, function (error) {
	            self.setState({
	                phase: self.phases.ERROR
	            });
	        }).finally(function () {
	            // actually explicitly update our state  having been deep-manipulating it
	            self.setState({
	                masterPushRule: self.state.masterPushRule,
	                vectorContentRules: self.state.vectorContentRules,
	                vectorPushRules: self.state.vectorPushRules,
	                externalContentRules: self.state.externalContentRules,
	                externalPushRules: self.state.externalPushRules
	            });
	        }).done();
	    },
	
	    _updatePushRuleActions: function _updatePushRuleActions(rule, actions, enabled) {
	        var cli = MatrixClientPeg.get();
	
	        return cli.setPushRuleActions('global', rule.kind, rule.rule_id, actions).then(function () {
	            // Then, if requested, enabled or disabled the rule
	            if (undefined != enabled) {
	                return cli.setPushRuleEnabled('global', rule.kind, rule.rule_id, enabled);
	            }
	        });
	    },
	
	    renderNotifRulesTableRow: function renderNotifRulesTableRow(title, className, pushRuleVectorState) {
	        return React.createElement(
	            'tr',
	            { key: className },
	            React.createElement(
	                'th',
	                null,
	                title
	            ),
	            React.createElement(
	                'th',
	                null,
	                React.createElement('input', { className: className + "-" + PushRuleVectorState.OFF,
	                    type: 'radio',
	                    checked: pushRuleVectorState === PushRuleVectorState.OFF,
	                    onChange: this.onNotifStateButtonClicked })
	            ),
	            React.createElement(
	                'th',
	                null,
	                React.createElement('input', { className: className + "-" + PushRuleVectorState.ON,
	                    type: 'radio',
	                    checked: pushRuleVectorState === PushRuleVectorState.ON,
	                    onChange: this.onNotifStateButtonClicked })
	            ),
	            React.createElement(
	                'th',
	                null,
	                React.createElement('input', { className: className + "-" + PushRuleVectorState.LOUD,
	                    type: 'radio',
	                    checked: pushRuleVectorState === PushRuleVectorState.LOUD,
	                    onChange: this.onNotifStateButtonClicked })
	            )
	        );
	    },
	
	    renderNotifRulesTableRows: function renderNotifRulesTableRows() {
	        var rows = [];
	        for (var i in this.state.vectorPushRules) {
	            var rule = this.state.vectorPushRules[i];
	            //console.log("rendering: " + rule.description + ", " + rule.vectorRuleId + ", " + rule.vectorState);
	            rows.push(this.renderNotifRulesTableRow(rule.description, rule.vectorRuleId, rule.vectorState));
	        }
	        return rows;
	    },
	
	    emailNotificationsRow: function emailNotificationsRow(address, label) {
	        return React.createElement(
	            'div',
	            { className: 'mx_UserNotifSettings_tableRow' },
	            React.createElement(
	                'div',
	                { className: 'mx_UserNotifSettings_inputCell' },
	                React.createElement('input', { id: 'enableEmailNotifications_{address}',
	                    ref: 'enableEmailNotifications_{address}',
	                    type: 'checkbox',
	                    checked: UserSettingsStore.hasEmailPusher(this.state.pushers, address),
	                    onChange: this.onEnableEmailNotificationsChange.bind(this, address)
	                })
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserNotifSettings_labelCell' },
	                React.createElement(
	                    'label',
	                    { htmlFor: 'enableEmailNotifications_{address}' },
	                    label
	                )
	            )
	        );
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var self = this;
	
	        var spinner;
	        if (this.state.phase === this.phases.LOADING) {
	            var Loader = sdk.getComponent("elements.Spinner");
	            spinner = React.createElement(Loader, null);
	        }
	
	        if (this.state.masterPushRule) {
	            var masterPushRuleDiv = React.createElement(
	                'div',
	                { className: 'mx_UserNotifSettings_tableRow' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_inputCell' },
	                    React.createElement('input', { id: 'enableNotifications',
	                        ref: 'enableNotifications',
	                        type: 'checkbox',
	                        checked: !this.state.masterPushRule.enabled,
	                        onChange: this.onEnableNotificationsChange })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_labelCell' },
	                    React.createElement(
	                        'label',
	                        { htmlFor: 'enableNotifications' },
	                        'Enable notifications for this account'
	                    )
	                )
	            );
	        }
	
	        // When enabled, the master rule inhibits all existing rules
	        // So do not show all notification settings
	        if (this.state.masterPushRule && this.state.masterPushRule.enabled) {
	            return React.createElement(
	                'div',
	                null,
	                masterPushRuleDiv,
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_notifTable' },
	                    'All notifications are currently disabled for all targets.'
	                )
	            );
	        }
	
	        var emailThreepids = this.props.threepids.filter(function (tp) {
	            return tp.medium === "email";
	        });
	        var emailNotificationsRow = void 0;
	        if (emailThreepids.length === 0) {
	            emailNotificationsRow = React.createElement(
	                'div',
	                null,
	                'Add an email address above to configure email notifications'
	            );
	        } else {
	            // This only supports the first email address in your profile for now
	            emailNotificationsRow = this.emailNotificationsRow(emailThreepids[0].address, "Enable email notifications (" + emailThreepids[0].address + ")");
	        }
	
	        // Build external push rules
	        var externalRules = [];
	        for (var i in this.state.externalPushRules) {
	            var rule = this.state.externalPushRules[i];
	            externalRules.push(React.createElement(
	                'li',
	                null,
	                rule.description
	            ));
	        }
	
	        // Show keywords not displayed by the vector UI as a single external push rule
	        var externalKeyWords = [];
	        for (var i in this.state.externalContentRules) {
	            var rule = this.state.externalContentRules[i];
	            externalKeyWords.push(rule.pattern);
	        }
	        if (externalKeyWords.length) {
	            externalKeyWords = externalKeyWords.join(", ");
	            externalRules.push(React.createElement(
	                'li',
	                null,
	                'Notifications on the following keywords follow rules which can\u2019t be displayed here: ',
	                externalKeyWords
	            ));
	        }
	
	        var devicesSection;
	        if (this.state.pushers === undefined) {
	            devicesSection = React.createElement(
	                'div',
	                { className: 'error' },
	                'Unable to fetch notification target list'
	            );
	        } else if (this.state.pushers.length == 0) {
	            devicesSection = null;
	        } else {
	            // TODO: It would be great to be able to delete pushers from here too,
	            // and this wouldn't be hard to add.
	            var rows = [];
	            for (var i = 0; i < this.state.pushers.length; ++i) {
	                rows.push(React.createElement(
	                    'tr',
	                    { key: i },
	                    React.createElement(
	                        'td',
	                        null,
	                        this.state.pushers[i].app_display_name
	                    ),
	                    React.createElement(
	                        'td',
	                        null,
	                        this.state.pushers[i].device_display_name
	                    )
	                ));
	            }
	            devicesSection = React.createElement(
	                'table',
	                { className: 'mx_UserSettings_devicesTable' },
	                React.createElement(
	                    'tbody',
	                    null,
	                    rows
	                )
	            );
	        }
	        if (devicesSection) {
	            devicesSection = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'h3',
	                    null,
	                    'Notification targets'
	                ),
	                devicesSection
	            );
	        }
	
	        var advancedSettings;
	        if (externalRules.length) {
	            advancedSettings = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'h3',
	                    null,
	                    'Advanced notifications settings'
	                ),
	                'There are advanced notifications which are not shown here.',
	                React.createElement('br', null),
	                'You might have configured them in a client other than Riot. You cannot tune them in Riot but they still apply.',
	                React.createElement(
	                    'ul',
	                    null,
	                    externalRules
	                )
	            );
	        }
	
	        return React.createElement(
	            'div',
	            null,
	            masterPushRuleDiv,
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_notifTable' },
	                spinner,
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_tableRow' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserNotifSettings_inputCell' },
	                        React.createElement('input', { id: 'enableDesktopNotifications',
	                            ref: 'enableDesktopNotifications',
	                            type: 'checkbox',
	                            checked: UserSettingsStore.getEnableNotifications(),
	                            onChange: this.onEnableDesktopNotificationsChange })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserNotifSettings_labelCell' },
	                        React.createElement(
	                            'label',
	                            { htmlFor: 'enableDesktopNotifications' },
	                            'Enable desktop notifications'
	                        )
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_tableRow' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserNotifSettings_inputCell' },
	                        React.createElement('input', { id: 'enableDesktopAudioNotifications',
	                            ref: 'enableDesktopAudioNotifications',
	                            type: 'checkbox',
	                            checked: UserSettingsStore.getEnableAudioNotifications(),
	                            onChange: function onChange(e) {
	                                UserSettingsStore.setEnableAudioNotifications(e.target.checked);
	                                _this2.forceUpdate();
	                            } })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserNotifSettings_labelCell' },
	                        React.createElement(
	                            'label',
	                            { htmlFor: 'enableDesktopAudioNotifications' },
	                            'Enable audible notifications in web client'
	                        )
	                    )
	                ),
	                emailNotificationsRow,
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_pushRulesTableWrapper' },
	                    React.createElement(
	                        'table',
	                        { className: 'mx_UserNotifSettings_pushRulesTable' },
	                        React.createElement(
	                            'thead',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement('th', { width: '55%' }),
	                                React.createElement(
	                                    'th',
	                                    { width: '15%' },
	                                    'Off'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { width: '15%' },
	                                    'On'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { width: '15%' },
	                                    'Noisy'
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            'tbody',
	                            null,
	                            this.renderNotifRulesTableRows()
	                        )
	                    )
	                ),
	                advancedSettings,
	                devicesSection
	            )
	        );
	    }
	});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PushRuleVectorState = __webpack_require__(236);
	
	module.exports = {
	    /**
	     * Extract the keyword rules from a list of rules, and parse them
	     * into a form which is useful for Vector's UI.
	     *
	     * Returns an object containing:
	     *   rules: the primary list of keyword rules
	     *   vectorState: a PushRuleVectorState indicating whether those rules are
	     *      OFF/ON/LOUD
	     *   externalRules: a list of other keyword rules, with states other than
	     *      vectorState
	     */
	    parseContentRules: function parseContentRules(rulesets) {
	        // first categorise the keyword rules in terms of their actions
	        var contentRules = this._categoriseContentRules(rulesets);
	
	        // Decide which content rules to display in Vector UI.
	        // Vector displays a single global rule for a list of keywords
	        // whereas Matrix has a push rule per keyword.
	        // Vector can set the unique rule in ON, LOUD or OFF state.
	        // Matrix has enabled/disabled plus a combination of (highlight, sound) tweaks.
	
	        // The code below determines which set of user's content push rules can be
	        // displayed by the vector UI.
	        // Push rules that does not fit, ie defined by another Matrix client, ends
	        // in externalRules.
	        // There is priority in the determination of which set will be the displayed one.
	        // The set with rules that have LOUD tweaks is the first choice. Then, the ones
	        // with ON tweaks (no tweaks).
	
	        if (contentRules.loud.length) {
	            return {
	                vectorState: PushRuleVectorState.LOUD,
	                rules: contentRules.loud,
	                externalRules: [].concat(contentRules.loud_but_disabled, contentRules.on, contentRules.on_but_disabled, contentRules.other)
	            };
	        } else if (contentRules.loud_but_disabled.length) {
	            return {
	                vectorState: PushRuleVectorState.OFF,
	                rules: contentRules.loud_but_disabled,
	                externalRules: [].concat(contentRules.on, contentRules.on_but_disabled, contentRules.other)
	            };
	        } else if (contentRules.on.length) {
	            return {
	                vectorState: PushRuleVectorState.ON,
	                rules: contentRules.on,
	                externalRules: [].concat(contentRules.on_but_disabled, contentRules.other)
	            };
	        } else if (contentRules.on_but_disabled.length) {
	            return {
	                vectorState: PushRuleVectorState.OFF,
	                rules: contentRules.on_but_disabled,
	                externalRules: contentRules.other
	            };
	        } else {
	            return {
	                vectorState: PushRuleVectorState.ON,
	                rules: [],
	                externalRules: contentRules.other
	            };
	        }
	    },
	
	    _categoriseContentRules: function _categoriseContentRules(rulesets) {
	        var contentRules = { on: [], on_but_disabled: [], loud: [], loud_but_disabled: [], other: [] };
	        for (var kind in rulesets.global) {
	            for (var i = 0; i < (0, _keys2.default)(rulesets.global[kind]).length; ++i) {
	                var r = rulesets.global[kind][i];
	
	                // check it's not a default rule
	                if (r.rule_id[0] === '.' || kind !== 'content') {
	                    continue;
	                }
	
	                r.kind = kind; // is this needed? not sure
	
	                switch (PushRuleVectorState.contentRuleVectorStateKind(r)) {
	                    case PushRuleVectorState.ON:
	                        if (r.enabled) {
	                            contentRules.on.push(r);
	                        } else {
	                            contentRules.on_but_disabled.push(r);
	                        }
	                        break;
	                    case PushRuleVectorState.LOUD:
	                        if (r.enabled) {
	                            contentRules.loud.push(r);
	                        } else {
	                            contentRules.loud_but_disabled.push(r);
	                        }
	                        break;
	                    default:
	                        contentRules.other.push(r);
	                        break;
	                }
	            }
	        }
	        return contentRules;
	    }
	};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StandardActions = __webpack_require__(367);
	var PushRuleVectorState = __webpack_require__(236);
	
	var VectorPushRuleDefinition = function () {
	    function VectorPushRuleDefinition(opts) {
	        (0, _classCallCheck3.default)(this, VectorPushRuleDefinition);
	
	        this.kind = opts.kind;
	        this.description = opts.description;
	        this.vectorStateToActions = opts.vectorStateToActions;
	    }
	
	    // Translate the rule actions and its enabled value into vector state
	
	
	    (0, _createClass3.default)(VectorPushRuleDefinition, [{
	        key: 'ruleToVectorState',
	        value: function ruleToVectorState(rule) {
	            var enabled = false;
	            var actions = null;
	            if (rule) {
	                enabled = rule.enabled;
	                actions = rule.actions;
	            }
	
	            for (var stateKey in PushRuleVectorState.states) {
	                var state = PushRuleVectorState.states[stateKey];
	                var vectorStateToActions = this.vectorStateToActions[state];
	
	                if (!vectorStateToActions) {
	                    // No defined actions means that this vector state expects a disabled (or absent) rule
	                    if (!enabled) {
	                        return state;
	                    }
	                } else {
	                    // The actions must match to the ones expected by vector state
	                    if (enabled && (0, _stringify2.default)(rule.actions) === (0, _stringify2.default)(vectorStateToActions)) {
	                        return state;
	                    }
	                }
	            }
	
	            console.error("Cannot translate rule actions into Vector rule state. Rule: " + (0, _stringify2.default)(rule));
	            return undefined;
	        }
	    }]);
	    return VectorPushRuleDefinition;
	}();
	
	;
	
	/**
	 * The descriptions of rules managed by the Vector UI.
	 */
	module.exports = {
	    // Messages containing user's display name
	    ".m.rule.contains_display_name": new VectorPushRuleDefinition({
	        kind: "override",
	        description: "Messages containing my display name",
	        vectorStateToActions: { // The actions for each vector state, or null to disable the rule.
	            on: StandardActions.ACTION_NOTIFY,
	            loud: StandardActions.ACTION_HIGHLIGHT_DEFAULT_SOUND,
	            off: StandardActions.ACTION_DISABLED
	        }
	    }),
	
	    // Messages containing user's username (localpart/MXID)
	    ".m.rule.contains_user_name": new VectorPushRuleDefinition({
	        kind: "override",
	        description: "Messages containing my user name",
	        vectorStateToActions: { // The actions for each vector state, or null to disable the rule.
	            on: StandardActions.ACTION_NOTIFY,
	            loud: StandardActions.ACTION_HIGHLIGHT_DEFAULT_SOUND,
	            off: StandardActions.ACTION_DISABLED
	        }
	    }),
	
	    // Messages just sent to the user in a 1:1 room
	    ".m.rule.room_one_to_one": new VectorPushRuleDefinition({
	        kind: "underride",
	        description: "Messages in one-to-one chats",
	        vectorStateToActions: {
	            on: StandardActions.ACTION_NOTIFY,
	            loud: StandardActions.ACTION_NOTIFY_DEFAULT_SOUND,
	            off: StandardActions.ACTION_DONT_NOTIFY
	        }
	    }),
	
	    // Messages just sent to a group chat room
	    // 1:1 room messages are catched by the .m.rule.room_one_to_one rule if any defined
	    // By opposition, all other room messages are from group chat rooms.
	    ".m.rule.message": new VectorPushRuleDefinition({
	        kind: "underride",
	        description: "Messages in group chats",
	        vectorStateToActions: {
	            on: StandardActions.ACTION_NOTIFY,
	            loud: StandardActions.ACTION_NOTIFY_DEFAULT_SOUND,
	            off: StandardActions.ACTION_DONT_NOTIFY
	        }
	    }),
	
	    // Invitation for the user
	    ".m.rule.invite_for_me": new VectorPushRuleDefinition({
	        kind: "underride",
	        description: "When I'm invited to a room",
	        vectorStateToActions: {
	            on: StandardActions.ACTION_NOTIFY,
	            loud: StandardActions.ACTION_NOTIFY_DEFAULT_SOUND,
	            off: StandardActions.ACTION_DISABLED
	        }
	    }),
	
	    // Incoming call
	    ".m.rule.call": new VectorPushRuleDefinition({
	        kind: "underride",
	        description: "Call invitation",
	        vectorStateToActions: {
	            on: StandardActions.ACTION_NOTIFY,
	            loud: StandardActions.ACTION_NOTIFY_RING_SOUND,
	            off: StandardActions.ACTION_DISABLED
	        }
	    }),
	
	    // Notifications from bots
	    ".m.rule.suppress_notices": new VectorPushRuleDefinition({
	        kind: "override",
	        description: "Messages sent by bot",
	        vectorStateToActions: {
	            // .m.rule.suppress_notices is a "negative" rule, we have to invert its enabled value for vector UI
	            on: StandardActions.ACTION_DISABLED,
	            loud: StandardActions.ACTION_NOTIFY_DEFAULT_SOUND,
	            off: StandardActions.ACTION_DONT_NOTIFY
	        }
	    })
	};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	module.exports = {
	    NotificationUtils: __webpack_require__(235),
	    PushRuleVectorState: __webpack_require__(236),
	    VectorPushRulesDefinitions: __webpack_require__(595),
	    ContentRules: __webpack_require__(594)
	};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _preventExtensions = __webpack_require__(621);
	
	var _preventExtensions2 = _interopRequireDefault(_preventExtensions);
	
	var _freeze = __webpack_require__(616);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _seal = __webpack_require__(622);
	
	var _seal2 = _interopRequireDefault(_seal);
	
	var _defineProperties = __webpack_require__(615);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _defineProperty = __webpack_require__(239);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__(374);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _isExtensible = __webpack_require__(618);
	
	var _isExtensible2 = _interopRequireDefault(_isExtensible);
	
	var _isFrozen = __webpack_require__(619);
	
	var _isFrozen2 = _interopRequireDefault(_isFrozen);
	
	var _isSealed = __webpack_require__(620);
	
	var _isSealed2 = _interopRequireDefault(_isSealed);
	
	var _getOwnPropertyNames = __webpack_require__(617);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _create = __webpack_require__(178);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(123);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*! modernizr 3.1.0 (Custom Build) | MIT *
	 * http://modernizr.com/download/?-displaytable-es5-flexbox-localstorage-objectfit-cssclassprefix:modernizr_ !*/
	!function (window, document, undefined) {
	  function is(e, t) {
	    return (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) === t;
	  }function testRunner() {
	    var e, t, r, n, o, s, i;for (var d in tests) {
	      if (e = [], t = tests[d], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (r = 0; r < t.options.aliases.length; r++) {
	        e.push(t.options.aliases[r].toLowerCase());
	      }for (n = is(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) {
	        s = e[o], i = s.split("."), 1 === i.length ? Modernizr[i[0]] = n : (!Modernizr[i[0]] || Modernizr[i[0]] instanceof Boolean || (Modernizr[i[0]] = new Boolean(Modernizr[i[0]])), Modernizr[i[0]][i[1]] = n), classes.push((n ? "" : "no-") + i.join("-"));
	      }
	    }
	  }function setClasses(e) {
	    var t = docElement.className,
	        r = Modernizr._config.classPrefix || "";if (isSVG && (t = t.baseVal), Modernizr._config.enableJSClass) {
	      var n = new RegExp("(^|\\s)" + r + "no-js(\\s|$)");t = t.replace(n, "$1" + r + "js$2");
	    }Modernizr._config.enableClasses && (t += " " + r + e.join(" " + r), isSVG ? docElement.className.baseVal = t : docElement.className = t);
	  }function createElement() {
	    return "function" != typeof document.createElement ? document.createElement(arguments[0]) : isSVG ? document.createElementNS.call(document, "http://www.w3.org/2000/svg", arguments[0]) : document.createElement.apply(document, arguments);
	  }function getBody() {
	    var e = document.body;return e || (e = createElement(isSVG ? "svg" : "body"), e.fake = !0), e;
	  }function injectElementWithStyles(e, t, r, n) {
	    var o,
	        s,
	        i,
	        d,
	        a = "modernizr",
	        l = createElement("div"),
	        c = getBody();if (parseInt(r, 10)) for (; r--;) {
	      i = createElement("div"), i.id = n ? n[r] : a + (r + 1), l.appendChild(i);
	    }return o = createElement("style"), o.type = "text/css", o.id = "s" + a, (c.fake ? c : l).appendChild(o), c.appendChild(l), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e)), l.id = a, c.fake && (c.style.background = "", c.style.overflow = "hidden", d = docElement.style.overflow, docElement.style.overflow = "hidden", docElement.appendChild(c)), s = t(l, e), c.fake ? (c.parentNode.removeChild(c), docElement.style.overflow = d, docElement.offsetHeight) : l.parentNode.removeChild(l), !!s;
	  }function contains(e, t) {
	    return !!~("" + e).indexOf(t);
	  }function domToCSS(e) {
	    return e.replace(/([A-Z])/g, function (e, t) {
	      return "-" + t.toLowerCase();
	    }).replace(/^ms-/, "-ms-");
	  }function nativeTestProps(e, t) {
	    var r = e.length;if ("CSS" in window && "supports" in window.CSS) {
	      for (; r--;) {
	        if (window.CSS.supports(domToCSS(e[r]), t)) return !0;
	      }return !1;
	    }if ("CSSSupportsRule" in window) {
	      for (var n = []; r--;) {
	        n.push("(" + domToCSS(e[r]) + ":" + t + ")");
	      }return n = n.join(" or "), injectElementWithStyles("@supports (" + n + ") { #modernizr { position: absolute; } }", function (e) {
	        return "absolute" == getComputedStyle(e, null).position;
	      });
	    }return undefined;
	  }function cssToDOM(e) {
	    return e.replace(/([a-z])-([a-z])/g, function (e, t, r) {
	      return t + r.toUpperCase();
	    }).replace(/^-/, "");
	  }function testProps(e, t, r, n) {
	    function o() {
	      i && (delete mStyle.style, delete mStyle.modElem);
	    }if (n = is(n, "undefined") ? !1 : n, !is(r, "undefined")) {
	      var s = nativeTestProps(e, r);if (!is(s, "undefined")) return s;
	    }for (var i, d, a, l, c, f = ["modernizr", "tspan"]; !mStyle.style;) {
	      i = !0, mStyle.modElem = createElement(f.shift()), mStyle.style = mStyle.modElem.style;
	    }for (a = e.length, d = 0; a > d; d++) {
	      if (l = e[d], c = mStyle.style[l], contains(l, "-") && (l = cssToDOM(l)), mStyle.style[l] !== undefined) {
	        if (n || is(r, "undefined")) return o(), "pfx" == t ? l : !0;try {
	          mStyle.style[l] = r;
	        } catch (u) {}if (mStyle.style[l] != c) return o(), "pfx" == t ? l : !0;
	      }
	    }return o(), !1;
	  }function fnBind(e, t) {
	    return function () {
	      return e.apply(t, arguments);
	    };
	  }function testDOMProps(e, t, r) {
	    var n;for (var o in e) {
	      if (e[o] in t) return r === !1 ? e[o] : (n = t[e[o]], is(n, "function") ? fnBind(n, r || t) : n);
	    }return !1;
	  }function testPropsAll(e, t, r, n, o) {
	    var s = e.charAt(0).toUpperCase() + e.slice(1),
	        i = (e + " " + cssomPrefixes.join(s + " ") + s).split(" ");return is(t, "string") || is(t, "undefined") ? testProps(i, t, n, o) : (i = (e + " " + domPrefixes.join(s + " ") + s).split(" "), testDOMProps(i, t, r));
	  }function testAllProps(e, t, r) {
	    return testPropsAll(e, undefined, undefined, t, r);
	  }var tests = [],
	      ModernizrProto = { _version: "3.1.0", _config: { classPrefix: "modernizr_", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {
	      var r = this;setTimeout(function () {
	        t(r[e]);
	      }, 0);
	    }, addTest: function addTest(e, t, r) {
	      tests.push({ name: e, fn: t, options: r });
	    }, addAsyncTest: function addAsyncTest(e) {
	      tests.push({ name: null, fn: e });
	    } },
	      Modernizr = function Modernizr() {};Modernizr.prototype = ModernizrProto, Modernizr = new Modernizr();var classes = [],
	      docElement = document.documentElement,
	      isSVG = "svg" === docElement.nodeName.toLowerCase(),
	      testStyles = ModernizrProto.testStyles = injectElementWithStyles;testStyles("#modernizr{display: table; direction: ltr}#modernizr div{display: table-cell; padding: 10px}", function (e) {
	    var t,
	        r = e.childNodes;t = r[0].offsetLeft < r[1].offsetLeft, Modernizr.addTest("displaytable", t, { aliases: ["display-table"] });
	  }, 2);var omPrefixes = "Moz O ms Webkit",
	      cssomPrefixes = ModernizrProto._config.usePrefixes ? omPrefixes.split(" ") : [];ModernizrProto._cssomPrefixes = cssomPrefixes;var modElem = { elem: createElement("modernizr") };Modernizr._q.push(function () {
	    delete modElem.elem;
	  });var mStyle = { style: modElem.elem.style };Modernizr._q.unshift(function () {
	    delete mStyle.style;
	  });var domPrefixes = ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(" ") : [];ModernizrProto._domPrefixes = domPrefixes, ModernizrProto.testAllProps = testPropsAll, ModernizrProto.testAllProps = testAllProps, Modernizr.addTest("flexbox", testAllProps("flexBasis", "1px", !0)), Modernizr.addTest("es5array", function () {
	    return !!(Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray);
	  }), Modernizr.addTest("es5date", function () {
	    var e = "2013-04-12T06:06:37.307Z",
	        t = !1;try {
	      t = !!Date.parse(e);
	    } catch (r) {}return !!(Date.now && Date.prototype && Date.prototype.toISOString && Date.prototype.toJSON && t);
	  }), Modernizr.addTest("es5function", function () {
	    return !(!Function.prototype || !Function.prototype.bind);
	  }), Modernizr.addTest("es5object", function () {
	    return !!(_keys2.default && _create2.default && _getPrototypeOf2.default && _getOwnPropertyNames2.default && _isSealed2.default && _isFrozen2.default && _isExtensible2.default && _getOwnPropertyDescriptor2.default && _defineProperty2.default && _defineProperties2.default && _seal2.default && _freeze2.default && _preventExtensions2.default);
	  }), Modernizr.addTest("strictmode", function () {
	    "use strict";
	    return !this;
	  }()), Modernizr.addTest("es5string", function () {
	    return !(!String.prototype || !String.prototype.trim);
	  }), Modernizr.addTest("json", "JSON" in window && "parse" in JSON && "stringify" in JSON), Modernizr.addTest("es5syntax", function () {
	    var value, obj, stringAccess, getter, setter, reservedWords, zeroWidthChars;try {
	      return stringAccess = eval('"foobar"[3] === "b"'), getter = eval("({ get x(){ return 1 } }).x === 1"), eval("({ set x(v){ value = v; } }).x = 1"), setter = 1 === value, eval("obj = ({ if: 1 })"), reservedWords = 1 === obj["if"], zeroWidthChars = eval("_‌‍ = true"), stringAccess && getter && setter && reservedWords && zeroWidthChars;
	    } catch (ignore) {
	      return !1;
	    }
	  }), Modernizr.addTest("es5undefined", function () {
	    var e, t;try {
	      t = window.undefined, window.undefined = 12345, e = "undefined" == typeof window.undefined, window.undefined = t;
	    } catch (r) {
	      return !1;
	    }return e;
	  }), Modernizr.addTest("es5", function () {
	    return !!(Modernizr.es5array && Modernizr.es5date && Modernizr.es5function && Modernizr.es5object && Modernizr.strictmode && Modernizr.es5string && Modernizr.json && Modernizr.es5syntax && Modernizr.es5undefined);
	  });var atRule = function atRule(e) {
	    var t,
	        r = prefixes.length,
	        n = window.CSSRule;if ("undefined" == typeof n) return undefined;if (!e) return !1;if (e = e.replace(/^@/, ""), t = e.replace(/-/g, "_").toUpperCase() + "_RULE", t in n) return "@" + e;for (var o = 0; r > o; o++) {
	      var s = prefixes[o],
	          i = s.toUpperCase() + "_" + t;if (i in n) return "@-" + s.toLowerCase() + "-" + e;
	    }return !1;
	  };ModernizrProto.atRule = atRule;var prefixed = ModernizrProto.prefixed = function (e, t, r) {
	    return 0 === e.indexOf("@") ? atRule(e) : (-1 != e.indexOf("-") && (e = cssToDOM(e)), t ? testPropsAll(e, t, r) : testPropsAll(e, "pfx"));
	  };Modernizr.addTest("objectfit", !!prefixed("objectFit"), { aliases: ["object-fit"] }), Modernizr.addTest("localstorage", function () {
	    var e = "modernizr";try {
	      return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
	    } catch (t) {
	      return !1;
	    }
	  }), testRunner(), setClasses(classes), delete ModernizrProto.addTest, delete ModernizrProto.addAsyncTest;for (var i = 0; i < Modernizr._q.length; i++) {
	    Modernizr._q[i]();
	  }window.Modernizr = Modernizr;
	}(window, document);

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(240);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _VectorBasePlatform2 = __webpack_require__(369);
	
	var _VectorBasePlatform3 = _interopRequireDefault(_VectorBasePlatform2);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var electron = __webpack_require__(1539);
	
	/*
	Copyright 2016 Aviral Dasgupta
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var remote = electron.remote;
	
	electron.remote.autoUpdater.on('update-downloaded', onUpdateDownloaded);
	
	function onUpdateDownloaded(ev, releaseNotes, ver, date, updateURL) {
	    _dispatcher2.default.dispatch({
	        action: 'new_version',
	        currentVersion: electron.remote.app.getVersion(),
	        newVersion: ver,
	        releaseNotes: releaseNotes
	    });
	}
	
	function platformFriendlyName() {
	    console.log(window.process);
	    switch (window.process.platform) {
	        case 'darwin':
	            return 'macOS';
	        case 'freebsd':
	            return 'FreeBSD';
	        case 'openbsd':
	            return 'OpenBSD';
	        case 'sunos':
	            return 'SunOS';
	        case 'win32':
	            return 'Windows';
	        default:
	            // Sorry, Linux users: you get lumped into here,
	            // but only because Linux's capitalisation is
	            // normal. We do care about you.
	            return window.process.platform[0].toUpperCase() + window.process.platform.slice(1);
	    }
	}
	
	var ElectronPlatform = function (_VectorBasePlatform) {
	    (0, _inherits3.default)(ElectronPlatform, _VectorBasePlatform);
	
	    function ElectronPlatform() {
	        (0, _classCallCheck3.default)(this, ElectronPlatform);
	        return (0, _possibleConstructorReturn3.default)(this, (ElectronPlatform.__proto__ || (0, _getPrototypeOf2.default)(ElectronPlatform)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ElectronPlatform, [{
	        key: 'setNotificationCount',
	        value: function setNotificationCount(count) {
	            if (this.notificationCount === count) return;
	            (0, _get3.default)(ElectronPlatform.prototype.__proto__ || (0, _getPrototypeOf2.default)(ElectronPlatform.prototype), 'setNotificationCount', this).call(this, count);
	            // this sometimes throws because electron is made of fail:
	            // https://github.com/electron/electron/issues/7351
	            // For now, let's catch the error, but I suspect it may
	            // continue to fail and we might just have to accept that
	            // electron's remote RPC is a non-starter for now and use IPC
	            try {
	                remote.app.setBadgeCount(count);
	            } catch (e) {
	                console.error("Failed to set notification count", e);
	            }
	        }
	    }, {
	        key: 'supportsNotifications',
	        value: function supportsNotifications() {
	            return true;
	        }
	    }, {
	        key: 'maySendNotifications',
	        value: function maySendNotifications() {
	            return true;
	        }
	    }, {
	        key: 'displayNotification',
	        value: function displayNotification(title, msg, avatarUrl, room) {
	            // Notifications in Electron use the HTML5 notification API
	            var notification = new global.Notification(title, {
	                body: msg,
	                icon: avatarUrl,
	                tag: "vector",
	                silent: true });
	
	            notification.onclick = function () {
	                _dispatcher2.default.dispatch({
	                    action: 'view_room',
	                    room_id: room.roomId
	                });
	                global.focus();
	                var currentWin = electron.remote.getCurrentWindow();
	                currentWin.show();
	                currentWin.restore();
	                currentWin.focus();
	            };
	
	            return notification;
	        }
	    }, {
	        key: 'clearNotification',
	        value: function clearNotification(notif) {
	            notif.close();
	        }
	    }, {
	        key: 'getAppVersion',
	        value: function getAppVersion() {
	            return (0, _q2.default)(electron.remote.app.getVersion());
	        }
	    }, {
	        key: 'pollForUpdate',
	        value: function pollForUpdate() {
	            // In electron we control the update process ourselves, since
	            // it needs to run in the main process, so we just run the timer
	            // loop in the main electron process instead.
	        }
	    }, {
	        key: 'installUpdate',
	        value: function installUpdate() {
	            // IPC to the main process to install the update, since quitAndInstall
	            // doesn't fire the before-quit event so the main process needs to know
	            // it should exit.
	            electron.ipcRenderer.send('install_update');
	        }
	    }, {
	        key: 'getDefaultDeviceDisplayName',
	        value: function getDefaultDeviceDisplayName() {
	            return "Riot Desktop on " + platformFriendlyName();
	        }
	    }, {
	        key: 'screenCaptureErrorString',
	        value: function screenCaptureErrorString() {
	            return null;
	        }
	    }, {
	        key: 'requestNotificationPermission',
	        value: function requestNotificationPermission() {
	            return (0, _q2.default)('granted');
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            electron.remote.getCurrentWebContents().reload();
	        }
	    }]);
	    return ElectronPlatform;
	}(_VectorBasePlatform3.default);
	
	exports.default = ElectronPlatform;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(240);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _VectorBasePlatform2 = __webpack_require__(369);
	
	var _VectorBasePlatform3 = _interopRequireDefault(_VectorBasePlatform2);
	
	var _favico = __webpack_require__(990);
	
	var _favico2 = _interopRequireDefault(_favico);
	
	var _browserRequest = __webpack_require__(97);
	
	var _browserRequest2 = _interopRequireDefault(_browserRequest);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _url = __webpack_require__(149);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _uaParserJs = __webpack_require__(561);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebPlatform = function (_VectorBasePlatform) {
	    (0, _inherits3.default)(WebPlatform, _VectorBasePlatform);
	
	    function WebPlatform() {
	        (0, _classCallCheck3.default)(this, WebPlatform);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (WebPlatform.__proto__ || (0, _getPrototypeOf2.default)(WebPlatform)).call(this));
	
	        _this.runningVersion = null;
	        // The 'animations' are really low framerate and look terrible.
	        // Also it re-starts the animationb every time you set the badge,
	        // and we set the state each time, even if the value hasn't changed,
	        // so we'd need to fix that if enabling the animation.
	        _this.favicon = new _favico2.default({ animation: 'none' });
	        _this._updateFavicon();
	        return _this;
	    }
	
	    (0, _createClass3.default)(WebPlatform, [{
	        key: '_updateFavicon',
	        value: function _updateFavicon() {
	            try {
	                // This needs to be in in a try block as it will throw
	                // if there are more than 100 badge count changes in
	                // its internal queue
	                var bgColor = "#d00",
	                    notif = this.notificationCount;
	
	                if (this.errorDidOccur) {
	                    notif = notif || "×";
	                    bgColor = "#f00";
	                }
	
	                this.favicon.badge(notif, {
	                    bgColor: bgColor
	                });
	            } catch (e) {
	                console.warn('Failed to set badge count: ' + e.message);
	            }
	        }
	    }, {
	        key: 'setNotificationCount',
	        value: function setNotificationCount(count) {
	            if (this.notificationCount === count) return;
	            (0, _get3.default)(WebPlatform.prototype.__proto__ || (0, _getPrototypeOf2.default)(WebPlatform.prototype), 'setNotificationCount', this).call(this, count);
	            this._updateFavicon();
	        }
	    }, {
	        key: 'setErrorStatus',
	        value: function setErrorStatus(errorDidOccur) {
	            if (this.errorDidOccur === errorDidOccur) return;
	            (0, _get3.default)(WebPlatform.prototype.__proto__ || (0, _getPrototypeOf2.default)(WebPlatform.prototype), 'setErrorStatus', this).call(this, errorDidOccur);
	            this._updateFavicon();
	        }
	
	        /**
	         * Returns true if the platform supports displaying
	         * notifications, otherwise false.
	         */
	
	    }, {
	        key: 'supportsNotifications',
	        value: function supportsNotifications() {
	            return Boolean(global.Notification);
	        }
	
	        /**
	         * Returns true if the application currently has permission
	         * to display notifications. Otherwise false.
	         */
	
	    }, {
	        key: 'maySendNotifications',
	        value: function maySendNotifications() {
	            return global.Notification.permission == 'granted';
	        }
	
	        /**
	         * Requests permission to send notifications. Returns
	         * a promise that is resolved when the user has responded
	         * to the request. The promise has a single string argument
	         * that is 'granted' if the user allowed the request or
	         * 'denied' otherwise.
	         */
	
	    }, {
	        key: 'requestNotificationPermission',
	        value: function requestNotificationPermission() {
	            // annoyingly, the latest spec says this returns a
	            // promise, but this is only supported in Chrome 46
	            // and Firefox 47, so adapt the callback API.
	            var defer = _q2.default.defer();
	            global.Notification.requestPermission(function (result) {
	                defer.resolve(result);
	            });
	            return defer.promise;
	        }
	    }, {
	        key: 'displayNotification',
	        value: function displayNotification(title, msg, avatarUrl, room) {
	            var notification = new global.Notification(title, {
	                body: msg,
	                icon: avatarUrl,
	                tag: "vector",
	                silent: true });
	
	            notification.onclick = function () {
	                _dispatcher2.default.dispatch({
	                    action: 'view_room',
	                    room_id: room.roomId
	                });
	                global.focus();
	                notification.close();
	            };
	
	            // Chrome only dismisses notifications after 20s, which
	            // is waaaaay too long
	            global.setTimeout(function () {
	                notification.close();
	            }, 5 * 1000);
	        }
	    }, {
	        key: '_getVersion',
	        value: function _getVersion() {
	            var deferred = _q2.default.defer();
	
	            // We add a cachebuster to the request to make sure that we know about
	            // the most recent version on the origin server. That might not
	            // actually be the version we'd get on a reload (particularly in the
	            // presence of intermediate caching proxies), but still: we're trying
	            // to tell the user that there is a new version.
	            (0, _browserRequest2.default)({
	                method: "GET",
	                url: "version",
	                qs: { cachebuster: Date.now() }
	            }, function (err, response, body) {
	                if (err || response.status < 200 || response.status >= 300) {
	                    if (err == null) err = { status: response.status };
	                    deferred.reject(err);
	                    return;
	                }
	
	                var ver = body.trim();
	                deferred.resolve(ver);
	            });
	            return deferred.promise;
	        }
	    }, {
	        key: 'getAppVersion',
	        value: function getAppVersion() {
	            if (this.runningVersion !== null) {
	                return (0, _q2.default)(this.runningVersion);
	            }
	            return this._getVersion();
	        }
	    }, {
	        key: 'pollForUpdate',
	        value: function pollForUpdate() {
	            var _this2 = this;
	
	            this._getVersion().done(function (ver) {
	                if (_this2.runningVersion == null) {
	                    _this2.runningVersion = ver;
	                } else if (_this2.runningVersion != ver) {
	                    _dispatcher2.default.dispatch({
	                        action: 'new_version',
	                        currentVersion: _this2.runningVersion,
	                        newVersion: ver
	                    });
	                }
	            }, function (err) {
	                console.error("Failed to poll for update", err);
	            });
	        }
	    }, {
	        key: 'installUpdate',
	        value: function installUpdate() {
	            window.location.reload();
	        }
	    }, {
	        key: 'getDefaultDeviceDisplayName',
	        value: function getDefaultDeviceDisplayName() {
	            // strip query-string and fragment from uri
	            var u = _url2.default.parse(window.location.href);
	            u.search = "";
	            u.hash = "";
	            var app_name = u.format();
	
	            var ua = new _uaParserJs2.default();
	            return app_name + " via " + ua.getBrowser().name + " on " + ua.getOS().name;
	        }
	    }, {
	        key: 'screenCaptureErrorString',
	        value: function screenCaptureErrorString() {
	            // it won't work at all if you're not on HTTPS so whine whine whine
	            if (!global.window || global.window.location.protocol !== "https:") {
	                return "You need to be using HTTPS to place a screen-sharing call.";
	            }
	            return null;
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            // forceReload=false since we don't really need new HTML/JS files
	            // we just need to restart the JS runtime.
	            window.location.reload(false);
	        }
	    }]);
	    return WebPlatform;
	}(_VectorBasePlatform3.default);
	
	/*
	Copyright 2016 Aviral Dasgupta
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = WebPlatform;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	/*
	Copyright 2016 Aviral Dasgupta
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var Platform = null;
	
	if (window && window.process && window.process && window.process.type === 'renderer') {
	    // we're running inside electron
	    Platform = __webpack_require__(598);
	} else {
	    Platform = __webpack_require__(599);
	}
	
	exports.default = Platform;
	module.exports = exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _PlatformPeg = __webpack_require__(93);
	
	var _PlatformPeg2 = _interopRequireDefault(_PlatformPeg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POKE_RATE_MS = 10 * 60 * 1000; // 10 min
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	module.exports = {
	    start: function start() {
	        module.exports.poll();
	        setInterval(module.exports.poll, POKE_RATE_MS);
	    },
	
	    poll: function poll() {
	        _PlatformPeg2.default.get().pollForUpdate();
	    }
	};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseQsFromFragment = parseQsFromFragment;
	exports.parseQs = parseQs;
	
	var _querystring = __webpack_require__(526);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// We want to support some name / value pairs in the fragment
	// so we're re-using query string like format
	//
	// returns {location, params}
	function parseQsFromFragment(location) {
	    // if we have a fragment, it will start with '#', which we need to drop.
	    // (if we don't, this will return '').
	    var fragment = location.hash.substring(1);
	
	    // our fragment may contain a query-param-like section. we need to fish
	    // this out *before* URI-decoding because the params may contain ? and &
	    // characters which are only URI-encoded once.
	    var hashparts = fragment.split('?');
	
	    var result = {
	        location: decodeURIComponent(hashparts[0]),
	        params: {}
	    };
	
	    if (hashparts.length > 1) {
	        result.params = _querystring2.default.parse(hashparts[1]);
	    }
	    return result;
	}
	
	function parseQs(location) {
	    return _querystring2.default.parse(location.search.substring(1));
	}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = {
		"_args": [
			[
				{
					"raw": "matrix-react-sdk@0.8.8",
					"scope": null,
					"escapedName": "matrix-react-sdk",
					"name": "matrix-react-sdk",
					"rawSpec": "0.8.8",
					"spec": "0.8.8",
					"type": "version"
				},
				"/private/var/folders/w1/zlp00m5x3fnc1y7qdzlwlk3m0000gn/T/tmp.iKJoKqx9"
			]
		],
		"_from": "matrix-react-sdk@0.8.8",
		"_id": "matrix-react-sdk@0.8.8",
		"_inCache": true,
		"_location": "/matrix-react-sdk",
		"_nodeVersion": "7.4.0",
		"_npmOperationalInternal": {
			"host": "packages-18-east.internal.npmjs.com",
			"tmp": "tmp/matrix-react-sdk-0.8.8.tgz_1493114088059_0.5916441886220127"
		},
		"_npmUser": {
			"name": "matrixdotorg",
			"email": "matrix@matrix.org"
		},
		"_npmVersion": "4.0.5",
		"_phantomChildren": {},
		"_requested": {
			"raw": "matrix-react-sdk@0.8.8",
			"scope": null,
			"escapedName": "matrix-react-sdk",
			"name": "matrix-react-sdk",
			"rawSpec": "0.8.8",
			"spec": "0.8.8",
			"type": "version"
		},
		"_requiredBy": [
			"/"
		],
		"_resolved": "https://registry.npmjs.org/matrix-react-sdk/-/matrix-react-sdk-0.8.8.tgz",
		"_shasum": "40ebc736eb60795452a33d61d4a88423f9227ece",
		"_shrinkwrap": null,
		"_spec": "matrix-react-sdk@0.8.8",
		"_where": "/private/var/folders/w1/zlp00m5x3fnc1y7qdzlwlk3m0000gn/T/tmp.iKJoKqx9",
		"author": {
			"name": "matrix.org"
		},
		"bin": {
			"reskindex": "scripts/reskindex.js"
		},
		"bugs": {
			"url": "https://github.com/matrix-org/matrix-react-sdk/issues"
		},
		"dependencies": {
			"babel-runtime": "^6.11.6",
			"blueimp-canvas-to-blob": "^3.5.0",
			"browser-encrypt-attachment": "^0.3.0",
			"browser-request": "^0.3.3",
			"classnames": "^2.1.2",
			"commonmark": "^0.27.0",
			"draft-js": "^0.8.1",
			"draft-js-export-html": "^0.5.0",
			"draft-js-export-markdown": "^0.2.0",
			"emojione": "2.2.3",
			"file-saver": "^1.3.3",
			"filesize": "^3.1.2",
			"flux": "^2.0.3",
			"fuse.js": "^2.2.0",
			"glob": "^5.0.14",
			"highlight.js": "^8.9.1",
			"isomorphic-fetch": "^2.2.1",
			"linkifyjs": "^2.1.3",
			"lodash": "^4.13.1",
			"matrix-js-sdk": "0.7.7",
			"optimist": "^0.6.1",
			"q": "^1.4.1",
			"react": "^15.4.0",
			"react-addons-css-transition-group": "15.3.2",
			"react-dom": "^15.4.0",
			"react-gemini-scrollbar": "github:matrix-org/react-gemini-scrollbar#5e97aef",
			"sanitize-html": "^1.11.1",
			"text-encoding-utf-8": "^1.0.1",
			"velocity-vector": "github:vector-im/velocity#059e3b2",
			"whatwg-fetch": "^1.0.0"
		},
		"description": "SDK for matrix.org using React",
		"devDependencies": {
			"babel-cli": "^6.5.2",
			"babel-core": "^6.14.0",
			"babel-eslint": "^6.1.2",
			"babel-loader": "^6.2.5",
			"babel-plugin-add-module-exports": "^0.2.1",
			"babel-plugin-transform-async-to-generator": "^6.16.0",
			"babel-plugin-transform-class-properties": "^6.16.0",
			"babel-plugin-transform-object-rest-spread": "^6.16.0",
			"babel-plugin-transform-runtime": "^6.15.0",
			"babel-polyfill": "^6.5.0",
			"babel-preset-es2015": "^6.14.0",
			"babel-preset-es2016": "^6.11.3",
			"babel-preset-es2017": "^6.14.0",
			"babel-preset-react": "^6.11.1",
			"eslint": "^3.13.1",
			"eslint-config-google": "^0.7.1",
			"eslint-plugin-babel": "^4.0.1",
			"eslint-plugin-flowtype": "^2.30.0",
			"eslint-plugin-react": "^6.9.0",
			"expect": "^1.16.0",
			"json-loader": "^0.5.3",
			"karma": "^0.13.22",
			"karma-chrome-launcher": "^0.2.3",
			"karma-cli": "^0.1.2",
			"karma-junit-reporter": "^0.4.1",
			"karma-mocha": "^0.2.2",
			"karma-phantomjs-launcher": "^1.0.0",
			"karma-sourcemap-loader": "^0.3.7",
			"karma-webpack": "^1.7.0",
			"mocha": "^2.4.5",
			"phantomjs-prebuilt": "^2.1.7",
			"react-addons-test-utils": "^15.4.0",
			"require-json": "0.0.1",
			"rimraf": "^2.4.3",
			"sinon": "^1.17.3",
			"source-map-loader": "^0.1.5",
			"webpack": "^1.12.14"
		},
		"directories": {},
		"dist": {
			"shasum": "40ebc736eb60795452a33d61d4a88423f9227ece",
			"tarball": "https://registry.npmjs.org/matrix-react-sdk/-/matrix-react-sdk-0.8.8.tgz"
		},
		"files": [
			".eslintrc.js",
			"CHANGELOG.md",
			"CONTRIBUTING.rst",
			"LICENSE",
			"README.md",
			"code_style.md",
			"git-revision.txt",
			"header",
			"jenkins.sh",
			"karma.conf.js",
			"lib",
			"package.json",
			"release.sh",
			"scripts",
			"src",
			"test"
		],
		"gitHead": "d81adb234a7581169a2ddbf2f0ee6375e5c340ce",
		"homepage": "https://github.com/matrix-org/matrix-react-sdk#readme",
		"license": "Apache-2.0",
		"main": "lib/index.js",
		"maintainers": [
			{
				"name": "matrixdotorg",
				"email": "matrix@matrix.org"
			}
		],
		"name": "matrix-react-sdk",
		"optionalDependencies": {},
		"readme": "ERROR: No README data found!",
		"repository": {
			"type": "git",
			"url": "git+https://github.com/matrix-org/matrix-react-sdk.git"
		},
		"scripts": {
			"build": "node scripts/babelcheck.js && babel src -d lib --source-maps",
			"clean": "rimraf lib",
			"lint": "eslint src/",
			"lintall": "eslint src/ test/",
			"prepublish": "npm run build && git rev-parse HEAD > git-revision.txt",
			"reskindex": "scripts/reskindex.js -h header",
			"start": "node scripts/babelcheck.js && babel src -w -d lib --source-maps",
			"test": "karma start $KARMAFLAGS --browsers PhantomJS",
			"test-multi": "karma start $KARMAFLAGS --single-run=false"
		},
		"version": "0.8.8"
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(610);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 610 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(888);
	
	__webpack_require__(559);
	
	__webpack_require__(636);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(637), __esModule: true };

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(639), __esModule: true };

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(641), __esModule: true };

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(645), __esModule: true };

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(647), __esModule: true };

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(649), __esModule: true };

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(651), __esModule: true };

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(652), __esModule: true };

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(653), __esModule: true };

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(655), __esModule: true };

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(656), __esModule: true };

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(657), __esModule: true };

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(660), __esModule: true };

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(661), __esModule: true };

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	function init () {
	  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	  for (var i = 0, len = code.length; i < len; ++i) {
	    lookup[i] = code[i]
	    revLookup[code.charCodeAt(i)] = i
	  }
	
	  revLookup['-'.charCodeAt(0)] = 62
	  revLookup['_'.charCodeAt(0)] = 63
	}
	
	init()
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	
	  // base64 is 4/3 + up to two characters of the original data
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * JavaScript Canvas to Blob
	 * https://github.com/blueimp/JavaScript-Canvas-to-Blob
	 *
	 * Copyright 2012, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on stackoverflow user Stoive's code snippet:
	 * http://stackoverflow.com/q/4998908
	 */
	
	/* global atob, Blob, define */
	
	;(function (window) {
	  'use strict'
	
	  var CanvasPrototype = window.HTMLCanvasElement &&
	                          window.HTMLCanvasElement.prototype
	  var hasBlobConstructor = window.Blob && (function () {
	    try {
	      return Boolean(new Blob())
	    } catch (e) {
	      return false
	    }
	  }())
	  var hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array &&
	    (function () {
	      try {
	        return new Blob([new Uint8Array(100)]).size === 100
	      } catch (e) {
	        return false
	      }
	    }())
	  var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder ||
	                      window.MozBlobBuilder || window.MSBlobBuilder
	  var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/
	  var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob &&
	    window.ArrayBuffer && window.Uint8Array &&
	    function (dataURI) {
	      var matches,
	        mediaType,
	        isBase64,
	        dataString,
	        byteString,
	        arrayBuffer,
	        intArray,
	        i,
	        bb
	      // Parse the dataURI components as per RFC 2397
	      matches = dataURI.match(dataURIPattern)
	      if (!matches) {
	        throw new Error('invalid data URI')
	      }
	      // Default to text/plain;charset=US-ASCII
	      mediaType = matches[2]
	        ? matches[1]
	        : 'text/plain' + (matches[3] || ';charset=US-ASCII')
	      isBase64 = !!matches[4]
	      dataString = dataURI.slice(matches[0].length)
	      if (isBase64) {
	        // Convert base64 to raw binary data held in a string:
	        byteString = atob(dataString)
	      } else {
	        // Convert base64/URLEncoded data component to raw binary:
	        byteString = decodeURIComponent(dataString)
	      }
	      // Write the bytes of the string to an ArrayBuffer:
	      arrayBuffer = new ArrayBuffer(byteString.length)
	      intArray = new Uint8Array(arrayBuffer)
	      for (i = 0; i < byteString.length; i += 1) {
	        intArray[i] = byteString.charCodeAt(i)
	      }
	      // Write the ArrayBuffer (or ArrayBufferView) to a blob:
	      if (hasBlobConstructor) {
	        return new Blob(
	          [hasArrayBufferViewSupport ? intArray : arrayBuffer],
	          {type: mediaType}
	        )
	      }
	      bb = new BlobBuilder()
	      bb.append(arrayBuffer)
	      return bb.getBlob(mediaType)
	    }
	  if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
	    if (CanvasPrototype.mozGetAsFile) {
	      CanvasPrototype.toBlob = function (callback, type, quality) {
	        if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
	          callback(dataURLtoBlob(this.toDataURL(type, quality)))
	        } else {
	          callback(this.mozGetAsFile('blob', type))
	        }
	      }
	    } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
	      CanvasPrototype.toBlob = function (callback, type, quality) {
	        callback(dataURLtoBlob(this.toDataURL(type, quality)))
	      }
	    }
	  }
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dataURLtoBlob
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else if (typeof module === 'object' && module.exports) {
	    module.exports = dataURLtoBlob
	  } else {
	    window.dataURLtoBlob = dataURLtoBlob
	  }
	}(window))


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Node = __webpack_require__(241);
	var unescapeString = __webpack_require__(124).unescapeString;
	var OPENTAG = __webpack_require__(124).OPENTAG;
	var CLOSETAG = __webpack_require__(124).CLOSETAG;
	
	var CODE_INDENT = 4;
	
	var C_TAB = 9;
	var C_NEWLINE = 10;
	var C_GREATERTHAN = 62;
	var C_LESSTHAN = 60;
	var C_SPACE = 32;
	var C_OPEN_BRACKET = 91;
	
	var InlineParser = __webpack_require__(631);
	
	var reHtmlBlockOpen = [
	   /./, // dummy for 0
	   /^<(?:script|pre|style)(?:\s|>|$)/i,
	   /^<!--/,
	   /^<[?]/,
	   /^<![A-Z]/,
	   /^<!\[CDATA\[/,
	   /^<[/]?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[123456]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|title|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|[/]?[>]|$)/i,
	    new RegExp('^(?:' + OPENTAG + '|' + CLOSETAG + ')\\s*$', 'i')
	];
	
	var reHtmlBlockClose = [
	   /./, // dummy for 0
	   /<\/(?:script|pre|style)>/i,
	   /-->/,
	   /\?>/,
	   />/,
	   /\]\]>/
	];
	
	var reThematicBreak = /^(?:(?:\*[ \t]*){3,}|(?:_[ \t]*){3,}|(?:-[ \t]*){3,})[ \t]*$/;
	
	var reMaybeSpecial = /^[#`~*+_=<>0-9-]/;
	
	var reNonSpace = /[^ \t\f\v\r\n]/;
	
	var reBulletListMarker = /^[*+-]/;
	
	var reOrderedListMarker = /^(\d{1,9})([.)])/;
	
	var reATXHeadingMarker = /^#{1,6}(?:[ \t]+|$)/;
	
	var reCodeFence = /^`{3,}(?!.*`)|^~{3,}(?!.*~)/;
	
	var reClosingCodeFence = /^(?:`{3,}|~{3,})(?= *$)/;
	
	var reSetextHeadingLine = /^(?:=+|-+)[ \t]*$/;
	
	var reLineEnding = /\r\n|\n|\r/;
	
	// Returns true if string contains only space characters.
	var isBlank = function(s) {
	    return !(reNonSpace.test(s));
	};
	
	var isSpaceOrTab = function(c) {
	    return c === C_SPACE || c === C_TAB;
	};
	
	var peek = function(ln, pos) {
	    if (pos < ln.length) {
	        return ln.charCodeAt(pos);
	    } else {
	        return -1;
	    }
	};
	
	// DOC PARSER
	
	// These are methods of a Parser object, defined below.
	
	// Returns true if block ends with a blank line, descending if needed
	// into lists and sublists.
	var endsWithBlankLine = function(block) {
	    while (block) {
	        if (block._lastLineBlank) {
	            return true;
	        }
	        var t = block.type;
	        if (t === 'list' || t === 'item') {
	            block = block._lastChild;
	        } else {
	            break;
	        }
	    }
	    return false;
	};
	
	// Add a line to the block at the tip.  We assume the tip
	// can accept lines -- that check should be done before calling this.
	var addLine = function() {
	    if (this.partiallyConsumedTab) {
	      this.offset += 1; // skip over tab
	      // add space characters:
	      var charsToTab = 4 - (this.column % 4);
	      this.tip._string_content += (' '.repeat(charsToTab));
	    }
	    this.tip._string_content += this.currentLine.slice(this.offset) + '\n';
	};
	
	// Add block of type tag as a child of the tip.  If the tip can't
	// accept children, close and finalize it and try its parent,
	// and so on til we find a block that can accept children.
	var addChild = function(tag, offset) {
	    while (!this.blocks[this.tip.type].canContain(tag)) {
	        this.finalize(this.tip, this.lineNumber - 1);
	    }
	
	    var column_number = offset + 1; // offset 0 = column 1
	    var newBlock = new Node(tag, [[this.lineNumber, column_number], [0, 0]]);
	    newBlock._string_content = '';
	    this.tip.appendChild(newBlock);
	    this.tip = newBlock;
	    return newBlock;
	};
	
	// Parse a list marker and return data on the marker (type,
	// start, delimiter, bullet character, padding) or null.
	var parseListMarker = function(parser, container) {
	    var rest = parser.currentLine.slice(parser.nextNonspace);
	    var match;
	    var nextc;
	    var spacesStartCol;
	    var spacesStartOffset;
	    var data = { type: null,
	                 tight: true,  // lists are tight by default
	                 bulletChar: null,
	                 start: null,
	                 delimiter: null,
	                 padding: null,
	                 markerOffset: parser.indent };
	    if ((match = rest.match(reBulletListMarker))) {
	        data.type = 'bullet';
	        data.bulletChar = match[0][0];
	
	    } else if ((match = rest.match(reOrderedListMarker)) &&
	                (container.type !== 'paragraph' ||
	                 match[1] === '1')) {
	        data.type = 'ordered';
	        data.start = parseInt(match[1]);
	        data.delimiter = match[2];
	    } else {
	        return null;
	    }
	    // make sure we have spaces after
	    nextc = peek(parser.currentLine, parser.nextNonspace + match[0].length);
	    if (!(nextc === -1 || nextc === C_TAB || nextc === C_SPACE)) {
	        return null;
	    }
	
	    // if it interrupts paragraph, make sure first line isn't blank
	    if (container.type === 'paragraph' && !parser.currentLine.slice(parser.nextNonspace + match[0].length).match(reNonSpace)) {
	        return null;
	    }
	
	    // we've got a match! advance offset and calculate padding
	    parser.advanceNextNonspace(); // to start of marker
	    parser.advanceOffset(match[0].length, true); // to end of marker
	    spacesStartCol = parser.column;
	    spacesStartOffset = parser.offset;
	    do {
	        parser.advanceOffset(1, true);
	        nextc = peek(parser.currentLine, parser.offset);
	    } while (parser.column - spacesStartCol < 5 &&
	           isSpaceOrTab(nextc));
	    var blank_item = peek(parser.currentLine, parser.offset) === -1;
	    var spaces_after_marker = parser.column - spacesStartCol;
	    if (spaces_after_marker >= 5 ||
	        spaces_after_marker < 1 ||
	        blank_item) {
	        data.padding = match[0].length + 1;
	        parser.column = spacesStartCol;
	        parser.offset = spacesStartOffset;
	        if (isSpaceOrTab(peek(parser.currentLine, parser.offset))) {
	            parser.advanceOffset(1, true);
	        }
	    } else {
	        data.padding = match[0].length + spaces_after_marker;
	    }
	    return data;
	};
	
	// Returns true if the two list items are of the same type,
	// with the same delimiter and bullet character.  This is used
	// in agglomerating list items into lists.
	var listsMatch = function(list_data, item_data) {
	    return (list_data.type === item_data.type &&
	            list_data.delimiter === item_data.delimiter &&
	            list_data.bulletChar === item_data.bulletChar);
	};
	
	// Finalize and close any unmatched blocks.
	var closeUnmatchedBlocks = function() {
	    if (!this.allClosed) {
	        // finalize any blocks not matched
	        while (this.oldtip !== this.lastMatchedContainer) {
	            var parent = this.oldtip._parent;
	            this.finalize(this.oldtip, this.lineNumber - 1);
	            this.oldtip = parent;
	        }
	        this.allClosed = true;
	    }
	};
	
	// 'finalize' is run when the block is closed.
	// 'continue' is run to check whether the block is continuing
	// at a certain line and offset (e.g. whether a block quote
	// contains a `>`.  It returns 0 for matched, 1 for not matched,
	// and 2 for "we've dealt with this line completely, go to next."
	var blocks = {
	    document: {
	        continue: function() { return 0; },
	        finalize: function() { return; },
	        canContain: function(t) { return (t !== 'item'); },
	        acceptsLines: false
	    },
	    list: {
	        continue: function() { return 0; },
	        finalize: function(parser, block) {
	            var item = block._firstChild;
	            while (item) {
	                // check for non-final list item ending with blank line:
	                if (endsWithBlankLine(item) && item._next) {
	                    block._listData.tight = false;
	                    break;
	                }
	                // recurse into children of list item, to see if there are
	                // spaces between any of them:
	                var subitem = item._firstChild;
	                while (subitem) {
	                    if (endsWithBlankLine(subitem) &&
	                        (item._next || subitem._next)) {
	                        block._listData.tight = false;
	                        break;
	                    }
	                    subitem = subitem._next;
	                }
	                item = item._next;
	            }
	        },
	        canContain: function(t) { return (t === 'item'); },
	        acceptsLines: false
	    },
	    block_quote: {
	        continue: function(parser) {
	            var ln = parser.currentLine;
	            if (!parser.indented &&
	                peek(ln, parser.nextNonspace) === C_GREATERTHAN) {
	                parser.advanceNextNonspace();
	                parser.advanceOffset(1, false);
	                if (isSpaceOrTab(peek(ln, parser.offset))) {
	                    parser.advanceOffset(1, true);
	                }
	            } else {
	                return 1;
	            }
	            return 0;
	        },
	        finalize: function() { return; },
	        canContain: function(t) { return (t !== 'item'); },
	        acceptsLines: false
	    },
	    item: {
	        continue: function(parser, container) {
	            if (parser.blank) {
	                if (container._firstChild == null) {
	                    // Blank line after empty list item
	                    return 1;
	                } else {
	                    parser.advanceNextNonspace();
	                }
	            } else if (parser.indent >=
	                       container._listData.markerOffset +
	                       container._listData.padding) {
	                parser.advanceOffset(container._listData.markerOffset +
	                    container._listData.padding, true);
	            } else {
	                return 1;
	            }
	            return 0;
	        },
	        finalize: function() { return; },
	        canContain: function(t) { return (t !== 'item'); },
	        acceptsLines: false
	    },
	    heading: {
	        continue: function() {
	            // a heading can never container > 1 line, so fail to match:
	            return 1;
	        },
	        finalize: function() { return; },
	        canContain: function() { return false; },
	        acceptsLines: false
	    },
	    thematic_break: {
	        continue: function() {
	            // a thematic break can never container > 1 line, so fail to match:
	            return 1;
	        },
	        finalize: function() { return; },
	        canContain: function() { return false; },
	        acceptsLines: false
	    },
	    code_block: {
	        continue: function(parser, container) {
	            var ln = parser.currentLine;
	            var indent = parser.indent;
	            if (container._isFenced) { // fenced
	                var match = (indent <= 3 &&
	                    ln.charAt(parser.nextNonspace) === container._fenceChar &&
	                    ln.slice(parser.nextNonspace).match(reClosingCodeFence));
	                if (match && match[0].length >= container._fenceLength) {
	                    // closing fence - we're at end of line, so we can return
	                    parser.finalize(container, parser.lineNumber);
	                    return 2;
	                } else {
	                    // skip optional spaces of fence offset
	                    var i = container._fenceOffset;
	                    while (i > 0 && isSpaceOrTab(peek(ln, parser.offset))) {
	                        parser.advanceOffset(1, true);
	                        i--;
	                    }
	                }
	            } else { // indented
	                if (indent >= CODE_INDENT) {
	                    parser.advanceOffset(CODE_INDENT, true);
	                } else if (parser.blank) {
	                    parser.advanceNextNonspace();
	                } else {
	                    return 1;
	                }
	            }
	            return 0;
	        },
	        finalize: function(parser, block) {
	            if (block._isFenced) { // fenced
	                // first line becomes info string
	                var content = block._string_content;
	                var newlinePos = content.indexOf('\n');
	                var firstLine = content.slice(0, newlinePos);
	                var rest = content.slice(newlinePos + 1);
	                block.info = unescapeString(firstLine.trim());
	                block._literal = rest;
	            } else { // indented
	                block._literal = block._string_content.replace(/(\n *)+$/, '\n');
	            }
	            block._string_content = null; // allow GC
	        },
	        canContain: function() { return false; },
	        acceptsLines: true
	    },
	    html_block: {
	        continue: function(parser, container) {
	            return ((parser.blank &&
	                     (container._htmlBlockType === 6 ||
	                      container._htmlBlockType === 7)) ? 1 : 0);
	        },
	        finalize: function(parser, block) {
	            block._literal = block._string_content.replace(/(\n *)+$/, '');
	            block._string_content = null; // allow GC
	        },
	        canContain: function() { return false; },
	        acceptsLines: true
	    },
	    paragraph: {
	        continue: function(parser) {
	            return (parser.blank ? 1 : 0);
	        },
	        finalize: function(parser, block) {
	            var pos;
	            var hasReferenceDefs = false;
	
	            // try parsing the beginning as link reference definitions:
	            while (peek(block._string_content, 0) === C_OPEN_BRACKET &&
	                   (pos =
	                    parser.inlineParser.parseReference(block._string_content,
	                                                       parser.refmap))) {
	                block._string_content = block._string_content.slice(pos);
	                hasReferenceDefs = true;
	            }
	            if (hasReferenceDefs && isBlank(block._string_content)) {
	                block.unlink();
	            }
	        },
	        canContain: function() { return false; },
	        acceptsLines: true
	    }
	};
	
	// block start functions.  Return values:
	// 0 = no match
	// 1 = matched container, keep going
	// 2 = matched leaf, no more block starts
	var blockStarts = [
	    // block quote
	    function(parser) {
	        if (!parser.indented &&
	            peek(parser.currentLine, parser.nextNonspace) === C_GREATERTHAN) {
	            parser.advanceNextNonspace();
	            parser.advanceOffset(1, false);
	            // optional following space
	            if (isSpaceOrTab(peek(parser.currentLine, parser.offset))) {
	                parser.advanceOffset(1, true);
	            }
	            parser.closeUnmatchedBlocks();
	            parser.addChild('block_quote', parser.nextNonspace);
	            return 1;
	        } else {
	            return 0;
	        }
	    },
	
	    // ATX heading
	    function(parser) {
	        var match;
	        if (!parser.indented &&
	            (match = parser.currentLine.slice(parser.nextNonspace).match(reATXHeadingMarker))) {
	            parser.advanceNextNonspace();
	            parser.advanceOffset(match[0].length, false);
	            parser.closeUnmatchedBlocks();
	            var container = parser.addChild('heading', parser.nextNonspace);
	            container.level = match[0].trim().length; // number of #s
	            // remove trailing ###s:
	            container._string_content =
	                parser.currentLine.slice(parser.offset).replace(/^ *#+ *$/, '').replace(/ +#+ *$/, '');
	            parser.advanceOffset(parser.currentLine.length - parser.offset);
	            return 2;
	        } else {
	            return 0;
	        }
	    },
	
	    // Fenced code block
	    function(parser) {
	        var match;
	        if (!parser.indented &&
	            (match = parser.currentLine.slice(parser.nextNonspace).match(reCodeFence))) {
	            var fenceLength = match[0].length;
	            parser.closeUnmatchedBlocks();
	            var container = parser.addChild('code_block', parser.nextNonspace);
	            container._isFenced = true;
	            container._fenceLength = fenceLength;
	            container._fenceChar = match[0][0];
	            container._fenceOffset = parser.indent;
	            parser.advanceNextNonspace();
	            parser.advanceOffset(fenceLength, false);
	            return 2;
	        } else {
	            return 0;
	        }
	    },
	
	    // HTML block
	    function(parser, container) {
	        if (!parser.indented &&
	            peek(parser.currentLine, parser.nextNonspace) === C_LESSTHAN) {
	            var s = parser.currentLine.slice(parser.nextNonspace);
	            var blockType;
	
	            for (blockType = 1; blockType <= 7; blockType++) {
	                if (reHtmlBlockOpen[blockType].test(s) &&
	                    (blockType < 7 ||
	                     container.type !== 'paragraph')) {
	                    parser.closeUnmatchedBlocks();
	                    // We don't adjust parser.offset;
	                    // spaces are part of the HTML block:
	                    var b = parser.addChild('html_block',
	                                            parser.offset);
	                    b._htmlBlockType = blockType;
	                    return 2;
	                }
	            }
	        }
	
	        return 0;
	
	    },
	
	    // Setext heading
	    function(parser, container) {
	        var match;
	        if (!parser.indented &&
	            container.type === 'paragraph' &&
	                   ((match = parser.currentLine.slice(parser.nextNonspace).match(reSetextHeadingLine)))) {
	            parser.closeUnmatchedBlocks();
	            var heading = new Node('heading', container.sourcepos);
	            heading.level = match[0][0] === '=' ? 1 : 2;
	            heading._string_content = container._string_content;
	            container.insertAfter(heading);
	            container.unlink();
	            parser.tip = heading;
	            parser.advanceOffset(parser.currentLine.length - parser.offset, false);
	            return 2;
	        } else {
	            return 0;
	        }
	    },
	
	    // thematic break
	    function(parser) {
	        if (!parser.indented &&
	            reThematicBreak.test(parser.currentLine.slice(parser.nextNonspace))) {
	            parser.closeUnmatchedBlocks();
	            parser.addChild('thematic_break', parser.nextNonspace);
	            parser.advanceOffset(parser.currentLine.length - parser.offset, false);
	            return 2;
	        } else {
	            return 0;
	        }
	    },
	
	    // list item
	    function(parser, container) {
	        var data;
	
	        if ((!parser.indented || container.type === 'list')
	                && (data = parseListMarker(parser, container))) {
	            parser.closeUnmatchedBlocks();
	
	            // add the list if needed
	            if (parser.tip.type !== 'list' ||
	                !(listsMatch(container._listData, data))) {
	                container = parser.addChild('list', parser.nextNonspace);
	                container._listData = data;
	            }
	
	            // add the list item
	            container = parser.addChild('item', parser.nextNonspace);
	            container._listData = data;
	            return 1;
	        } else {
	            return 0;
	        }
	    },
	
	    // indented code block
	    function(parser) {
	        if (parser.indented &&
	            parser.tip.type !== 'paragraph' &&
	            !parser.blank) {
	            // indented code
	            parser.advanceOffset(CODE_INDENT, true);
	            parser.closeUnmatchedBlocks();
	            parser.addChild('code_block', parser.offset);
	            return 2;
	        } else {
	            return 0;
	        }
	     }
	
	];
	
	var advanceOffset = function(count, columns) {
	    var currentLine = this.currentLine;
	    var charsToTab, charsToAdvance;
	    var c;
	    while (count > 0 && (c = currentLine[this.offset])) {
	        if (c === '\t') {
	            charsToTab = 4 - (this.column % 4);
	            if (columns) {
	                this.partiallyConsumedTab = charsToTab > count;
	                charsToAdvance = charsToTab > count ? count : charsToTab;
	                this.column += charsToAdvance;
	                this.offset += this.partiallyConsumedTab ? 0 : 1;
	                count -= charsToAdvance;
	            } else {
	                this.partiallyConsumedTab = false;
	                this.column += charsToTab;
	                this.offset += 1;
	                count -= 1;
	            }
	        } else {
	            this.partiallyConsumedTab = false;
	            this.offset += 1;
	            this.column += 1; // assume ascii; block starts are ascii
	            count -= 1;
	        }
	    }
	};
	
	var advanceNextNonspace = function() {
	    this.offset = this.nextNonspace;
	    this.column = this.nextNonspaceColumn;
	    this.partiallyConsumedTab = false;
	};
	
	var findNextNonspace = function() {
	    var currentLine = this.currentLine;
	    var i = this.offset;
	    var cols = this.column;
	    var c;
	
	    while ((c = currentLine.charAt(i)) !== '') {
	        if (c === ' ') {
	            i++;
	            cols++;
	        } else if (c === '\t') {
	            i++;
	            cols += (4 - (cols % 4));
	        } else {
	            break;
	        }
	    }
	    this.blank = (c === '\n' || c === '\r' || c === '');
	    this.nextNonspace = i;
	    this.nextNonspaceColumn = cols;
	    this.indent = this.nextNonspaceColumn - this.column;
	    this.indented = this.indent >= CODE_INDENT;
	};
	
	// Analyze a line of text and update the document appropriately.
	// We parse markdown text by calling this on each line of input,
	// then finalizing the document.
	var incorporateLine = function(ln) {
	    var all_matched = true;
	    var t;
	
	    var container = this.doc;
	    this.oldtip = this.tip;
	    this.offset = 0;
	    this.column = 0;
	    this.blank = false;
	    this.partiallyConsumedTab = false;
	    this.lineNumber += 1;
	
	    // replace NUL characters for security
	    if (ln.indexOf('\u0000') !== -1) {
	        ln = ln.replace(/\0/g, '\uFFFD');
	    }
	
	    this.currentLine = ln;
	
	    // For each containing block, try to parse the associated line start.
	    // Bail out on failure: container will point to the last matching block.
	    // Set all_matched to false if not all containers match.
	    var lastChild;
	    while ((lastChild = container._lastChild) && lastChild._open) {
	        container = lastChild;
	
	        this.findNextNonspace();
	
	        switch (this.blocks[container.type].continue(this, container)) {
	        case 0: // we've matched, keep going
	            break;
	        case 1: // we've failed to match a block
	            all_matched = false;
	            break;
	        case 2: // we've hit end of line for fenced code close and can return
	            this.lastLineLength = ln.length;
	            return;
	        default:
	            throw 'continue returned illegal value, must be 0, 1, or 2';
	        }
	        if (!all_matched) {
	            container = container._parent; // back up to last matching block
	            break;
	        }
	    }
	
	    this.allClosed = (container === this.oldtip);
	    this.lastMatchedContainer = container;
	
	    var matchedLeaf = container.type !== 'paragraph' &&
	            blocks[container.type].acceptsLines;
	    var starts = this.blockStarts;
	    var startsLen = starts.length;
	    // Unless last matched container is a code block, try new container starts,
	    // adding children to the last matched container:
	    while (!matchedLeaf) {
	
	        this.findNextNonspace();
	
	        // this is a little performance optimization:
	        if (!this.indented &&
	            !reMaybeSpecial.test(ln.slice(this.nextNonspace))) {
	            this.advanceNextNonspace();
	            break;
	        }
	
	        var i = 0;
	        while (i < startsLen) {
	            var res = starts[i](this, container);
	            if (res === 1) {
	                container = this.tip;
	                break;
	            } else if (res === 2) {
	                container = this.tip;
	                matchedLeaf = true;
	                break;
	            } else {
	                i++;
	            }
	        }
	
	        if (i === startsLen) { // nothing matched
	            this.advanceNextNonspace();
	            break;
	        }
	    }
	
	    // What remains at the offset is a text line.  Add the text to the
	    // appropriate container.
	
	   // First check for a lazy paragraph continuation:
	    if (!this.allClosed && !this.blank &&
	        this.tip.type === 'paragraph') {
	        // lazy paragraph continuation
	        this.addLine();
	
	    } else { // not a lazy continuation
	
	        // finalize any blocks not matched
	        this.closeUnmatchedBlocks();
	        if (this.blank && container.lastChild) {
	            container.lastChild._lastLineBlank = true;
	        }
	
	        t = container.type;
	
	        // Block quote lines are never blank as they start with >
	        // and we don't count blanks in fenced code for purposes of tight/loose
	        // lists or breaking out of lists.  We also don't set _lastLineBlank
	        // on an empty list item, or if we just closed a fenced block.
	        var lastLineBlank = this.blank &&
	            !(t === 'block_quote' ||
	              (t === 'code_block' && container._isFenced) ||
	              (t === 'item' &&
	               !container._firstChild &&
	               container.sourcepos[0][0] === this.lineNumber));
	
	        // propagate lastLineBlank up through parents:
	        var cont = container;
	        while (cont) {
	            cont._lastLineBlank = lastLineBlank;
	            cont = cont._parent;
	        }
	
	        if (this.blocks[t].acceptsLines) {
	            this.addLine();
	            // if HtmlBlock, check for end condition
	            if (t === 'html_block' &&
	                container._htmlBlockType >= 1 &&
	                container._htmlBlockType <= 5 &&
	                reHtmlBlockClose[container._htmlBlockType].test(this.currentLine.slice(this.offset))) {
	                this.finalize(container, this.lineNumber);
	            }
	
	        } else if (this.offset < ln.length && !this.blank) {
	            // create paragraph container for line
	            container = this.addChild('paragraph', this.offset);
	            this.advanceNextNonspace();
	            this.addLine();
	        }
	    }
	    this.lastLineLength = ln.length;
	};
	
	// Finalize a block.  Close it and do any necessary postprocessing,
	// e.g. creating string_content from strings, setting the 'tight'
	// or 'loose' status of a list, and parsing the beginnings
	// of paragraphs for reference definitions.  Reset the tip to the
	// parent of the closed block.
	var finalize = function(block, lineNumber) {
	    var above = block._parent;
	    block._open = false;
	    block.sourcepos[1] = [lineNumber, this.lastLineLength];
	
	    this.blocks[block.type].finalize(this, block);
	
	    this.tip = above;
	};
	
	// Walk through a block & children recursively, parsing string content
	// into inline content where appropriate.
	var processInlines = function(block) {
	    var node, event, t;
	    var walker = block.walker();
	    this.inlineParser.refmap = this.refmap;
	    this.inlineParser.options = this.options;
	    while ((event = walker.next())) {
	        node = event.node;
	        t = node.type;
	        if (!event.entering && (t === 'paragraph' || t === 'heading')) {
	            this.inlineParser.parse(node);
	        }
	    }
	};
	
	var Document = function() {
	    var doc = new Node('document', [[1, 1], [0, 0]]);
	    return doc;
	};
	
	// The main parsing function.  Returns a parsed document AST.
	var parse = function(input) {
	    this.doc = new Document();
	    this.tip = this.doc;
	    this.refmap = {};
	    this.lineNumber = 0;
	    this.lastLineLength = 0;
	    this.offset = 0;
	    this.column = 0;
	    this.lastMatchedContainer = this.doc;
	    this.currentLine = "";
	    if (this.options.time) { console.time("preparing input"); }
	    var lines = input.split(reLineEnding);
	    var len = lines.length;
	    if (input.charCodeAt(input.length - 1) === C_NEWLINE) {
	        // ignore last blank line created by final newline
	        len -= 1;
	    }
	    if (this.options.time) { console.timeEnd("preparing input"); }
	    if (this.options.time) { console.time("block parsing"); }
	    for (var i = 0; i < len; i++) {
	        this.incorporateLine(lines[i]);
	    }
	    while (this.tip) {
	        this.finalize(this.tip, len);
	    }
	    if (this.options.time) { console.timeEnd("block parsing"); }
	    if (this.options.time) { console.time("inline parsing"); }
	    this.processInlines(this.doc);
	    if (this.options.time) { console.timeEnd("inline parsing"); }
	    return this.doc;
	};
	
	
	// The Parser object.
	function Parser(options){
	    return {
	        doc: new Document(),
	        blocks: blocks,
	        blockStarts: blockStarts,
	        tip: this.doc,
	        oldtip: this.doc,
	        currentLine: "",
	        lineNumber: 0,
	        offset: 0,
	        column: 0,
	        nextNonspace: 0,
	        nextNonspaceColumn: 0,
	        indent: 0,
	        indented: false,
	        blank: false,
	        partiallyConsumedTab: false,
	        allClosed: true,
	        lastMatchedContainer: this.doc,
	        refmap: {},
	        lastLineLength: 0,
	        inlineParser: new InlineParser(options),
	        findNextNonspace: findNextNonspace,
	        advanceOffset: advanceOffset,
	        advanceNextNonspace: advanceNextNonspace,
	        addLine: addLine,
	        addChild: addChild,
	        incorporateLine: incorporateLine,
	        finalize: finalize,
	        processInlines: processInlines,
	        closeUnmatchedBlocks: closeUnmatchedBlocks,
	        parse: parse,
	        options: options || {}
	    };
	}
	
	module.exports = Parser;


/***/ }),
/* 629 */
/***/ (function(module, exports) {

	"use strict";
	
	// derived from https://github.com/mathiasbynens/String.fromCodePoint
	/*! http://mths.be/fromcodepoint v0.2.1 by @mathias */
	if (String.fromCodePoint) {
	    module.exports = function (_) {
	        try {
	            return String.fromCodePoint(_);
	        } catch (e) {
	            if (e instanceof RangeError) {
	                return String.fromCharCode(0xFFFD);
	            }
	            throw e;
	        }
	    };
	
	} else {
	
	  var stringFromCharCode = String.fromCharCode;
	  var floor = Math.floor;
	  var fromCodePoint = function() {
	      var MAX_SIZE = 0x4000;
	      var codeUnits = [];
	      var highSurrogate;
	      var lowSurrogate;
	      var index = -1;
	      var length = arguments.length;
	      if (!length) {
	          return '';
	      }
	      var result = '';
	      while (++index < length) {
	          var codePoint = Number(arguments[index]);
	          if (
	              !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
	                  codePoint < 0 || // not a valid Unicode code point
	                  codePoint > 0x10FFFF || // not a valid Unicode code point
	                  floor(codePoint) !== codePoint // not an integer
	          ) {
	              return String.fromCharCode(0xFFFD);
	          }
	          if (codePoint <= 0xFFFF) { // BMP code point
	              codeUnits.push(codePoint);
	          } else { // Astral code point; split in surrogate halves
	              // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	              codePoint -= 0x10000;
	              highSurrogate = (codePoint >> 10) + 0xD800;
	              lowSurrogate = (codePoint % 0x400) + 0xDC00;
	              codeUnits.push(highSurrogate, lowSurrogate);
	          }
	          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
	              result += stringFromCharCode.apply(null, codeUnits);
	              codeUnits.length = 0;
	          }
	      }
	      return result;
	  };
	  module.exports = fromCodePoint;
	}


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// commonmark.js - CommomMark in JavaScript
	// Copyright (C) 2014 John MacFarlane
	// License: BSD3.
	
	// Basic usage:
	//
	// var commonmark = require('commonmark');
	// var parser = new commonmark.Parser();
	// var renderer = new commonmark.HtmlRenderer();
	// console.log(renderer.render(parser.parse('Hello *world*')));
	
	module.exports.version = '0.27.0';
	module.exports.Node = __webpack_require__(241);
	module.exports.Parser = __webpack_require__(628);
	// module.exports.HtmlRenderer = require('./html');
	module.exports.HtmlRenderer = __webpack_require__(633);
	module.exports.XmlRenderer = __webpack_require__(635);


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Node = __webpack_require__(241);
	var common = __webpack_require__(124);
	var normalizeReference = __webpack_require__(632);
	
	var normalizeURI = common.normalizeURI;
	var unescapeString = common.unescapeString;
	var fromCodePoint = __webpack_require__(629);
	var decodeHTML = __webpack_require__(293).decodeHTML;
	__webpack_require__(1526); // Polyfill for String.prototype.repeat
	
	// Constants for character codes:
	
	var C_NEWLINE = 10;
	var C_ASTERISK = 42;
	var C_UNDERSCORE = 95;
	var C_BACKTICK = 96;
	var C_OPEN_BRACKET = 91;
	var C_CLOSE_BRACKET = 93;
	var C_LESSTHAN = 60;
	var C_BANG = 33;
	var C_BACKSLASH = 92;
	var C_AMPERSAND = 38;
	var C_OPEN_PAREN = 40;
	var C_CLOSE_PAREN = 41;
	var C_COLON = 58;
	var C_SINGLEQUOTE = 39;
	var C_DOUBLEQUOTE = 34;
	
	// Some regexps used in inline parser:
	
	var ESCAPABLE = common.ESCAPABLE;
	var ESCAPED_CHAR = '\\\\' + ESCAPABLE;
	var REG_CHAR = '[^\\\\()\\x00-\\x20]';
	var IN_PARENS_NOSP = '\\((' + REG_CHAR + '|' + ESCAPED_CHAR + '|\\\\)*\\)';
	
	var ENTITY = common.ENTITY;
	var reHtmlTag = common.reHtmlTag;
	
	var rePunctuation = new RegExp(/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/);
	
	var reLinkTitle = new RegExp(
	    '^(?:"(' + ESCAPED_CHAR + '|[^"\\x00])*"' +
	        '|' +
	        '\'(' + ESCAPED_CHAR + '|[^\'\\x00])*\'' +
	        '|' +
	        '\\((' + ESCAPED_CHAR + '|[^)\\x00])*\\))');
	
	var reLinkDestinationBraces = new RegExp(
	    '^(?:[<](?:[^ <>\\t\\n\\\\\\x00]' + '|' + ESCAPED_CHAR + '|' + '\\\\)*[>])');
	
	var reLinkDestination = new RegExp(
	    '^(?:' + REG_CHAR + '+|' + ESCAPED_CHAR + '|\\\\|' + IN_PARENS_NOSP + ')*');
	
	var reEscapable = new RegExp('^' + ESCAPABLE);
	
	var reEntityHere = new RegExp('^' + ENTITY, 'i');
	
	var reTicks = /`+/;
	
	var reTicksHere = /^`+/;
	
	var reEllipses = /\.\.\./g;
	
	var reDash = /--+/g;
	
	var reEmailAutolink = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
	
	var reAutolink = /^<[A-Za-z][A-Za-z0-9.+-]{1,31}:[^<>\x00-\x20]*>/i;
	
	var reSpnl = /^ *(?:\n *)?/;
	
	var reWhitespaceChar = /^[ \t\n\x0b\x0c\x0d]/;
	
	var reWhitespace = /[ \t\n\x0b\x0c\x0d]+/g;
	
	var reUnicodeWhitespaceChar = /^\s/;
	
	var reUnicodeWhitespace = /\s+/g;
	
	var reFinalSpace = / *$/;
	
	var reInitialSpace = /^ */;
	
	var reSpaceAtEndOfLine = /^ *(?:\n|$)/;
	
	var reLinkLabel = new RegExp('^\\[(?:[^\\\\\\[\\]]|' + ESCAPED_CHAR +
	  '|\\\\){0,1000}\\]');
	
	// Matches a string of non-special characters.
	var reMain = /^[^\n`\[\]\\!<&*_'"]+/m;
	
	var text = function(s) {
	    var node = new Node('text');
	    node._literal = s;
	    return node;
	};
	
	// INLINE PARSER
	
	// These are methods of an InlineParser object, defined below.
	// An InlineParser keeps track of a subject (a string to be
	// parsed) and a position in that subject.
	
	// If re matches at current position in the subject, advance
	// position in subject and return the match; otherwise return null.
	var match = function(re) {
	    var m = re.exec(this.subject.slice(this.pos));
	    if (m === null) {
	        return null;
	    } else {
	        this.pos += m.index + m[0].length;
	        return m[0];
	    }
	};
	
	// Returns the code for the character at the current subject position, or -1
	// there are no more characters.
	var peek = function() {
	    if (this.pos < this.subject.length) {
	        return this.subject.charCodeAt(this.pos);
	    } else {
	        return -1;
	    }
	};
	
	// Parse zero or more space characters, including at most one newline
	var spnl = function() {
	    this.match(reSpnl);
	    return true;
	};
	
	// All of the parsers below try to match something at the current position
	// in the subject.  If they succeed in matching anything, they
	// return the inline matched, advancing the subject.
	
	// Attempt to parse backticks, adding either a backtick code span or a
	// literal sequence of backticks.
	var parseBackticks = function(block) {
	    var ticks = this.match(reTicksHere);
	    if (ticks === null) {
	        return false;
	    }
	    var afterOpenTicks = this.pos;
	    var matched;
	    var node;
	    while ((matched = this.match(reTicks)) !== null) {
	        if (matched === ticks) {
	            node = new Node('code');
	            node._literal = this.subject.slice(afterOpenTicks,
	                                        this.pos - ticks.length)
	                          .trim().replace(reWhitespace, ' ');
	            block.appendChild(node);
	            return true;
	        }
	    }
	    // If we got here, we didn't match a closing backtick sequence.
	    this.pos = afterOpenTicks;
	    block.appendChild(text(ticks));
	    return true;
	};
	
	// Parse a backslash-escaped special character, adding either the escaped
	// character, a hard line break (if the backslash is followed by a newline),
	// or a literal backslash to the block's children.  Assumes current character
	// is a backslash.
	var parseBackslash = function(block) {
	    var subj = this.subject;
	    var node;
	    this.pos += 1;
	    if (this.peek() === C_NEWLINE) {
	        this.pos += 1;
	        node = new Node('linebreak');
	        block.appendChild(node);
	    } else if (reEscapable.test(subj.charAt(this.pos))) {
	        block.appendChild(text(subj.charAt(this.pos)));
	        this.pos += 1;
	    } else {
	        block.appendChild(text('\\'));
	    }
	    return true;
	};
	
	// Attempt to parse an autolink (URL or email in pointy brackets).
	var parseAutolink = function(block) {
	    var m;
	    var dest;
	    var node;
	    if ((m = this.match(reEmailAutolink))) {
	        dest = m.slice(1, m.length - 1);
	        node = new Node('link');
	        node._destination = normalizeURI('mailto:' + dest);
	        node._title = '';
	        node.appendChild(text(dest));
	        block.appendChild(node);
	        return true;
	    } else if ((m = this.match(reAutolink))) {
	        dest = m.slice(1, m.length - 1);
	        node = new Node('link');
	        node._destination = normalizeURI(dest);
	        node._title = '';
	        node.appendChild(text(dest));
	        block.appendChild(node);
	        return true;
	    } else {
	        return false;
	    }
	};
	
	// Attempt to parse a raw HTML tag.
	var parseHtmlTag = function(block) {
	    var m = this.match(reHtmlTag);
	    if (m === null) {
	        return false;
	    } else {
	        var node = new Node('html_inline');
	        node._literal = m;
	        block.appendChild(node);
	        return true;
	    }
	};
	
	// Scan a sequence of characters with code cc, and return information about
	// the number of delimiters and whether they are positioned such that
	// they can open and/or close emphasis or strong emphasis.  A utility
	// function for strong/emph parsing.
	var scanDelims = function(cc) {
	    var numdelims = 0;
	    var char_before, char_after, cc_after;
	    var startpos = this.pos;
	    var left_flanking, right_flanking, can_open, can_close;
	    var after_is_whitespace, after_is_punctuation, before_is_whitespace, before_is_punctuation;
	
	    if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
	        numdelims++;
	        this.pos++;
	    } else {
	        while (this.peek() === cc) {
	            numdelims++;
	            this.pos++;
	        }
	    }
	
	    if (numdelims === 0) {
	        return null;
	    }
	
	    char_before = startpos === 0 ? '\n' : this.subject.charAt(startpos - 1);
	
	    cc_after = this.peek();
	    if (cc_after === -1) {
	        char_after = '\n';
	    } else {
	        char_after = fromCodePoint(cc_after);
	    }
	
	    after_is_whitespace = reUnicodeWhitespaceChar.test(char_after);
	    after_is_punctuation = rePunctuation.test(char_after);
	    before_is_whitespace = reUnicodeWhitespaceChar.test(char_before);
	    before_is_punctuation = rePunctuation.test(char_before);
	
	    left_flanking = !after_is_whitespace &&
	            !(after_is_punctuation && !before_is_whitespace && !before_is_punctuation);
	    right_flanking = !before_is_whitespace &&
	            !(before_is_punctuation && !after_is_whitespace && !after_is_punctuation);
	    if (cc === C_UNDERSCORE) {
	        can_open = left_flanking &&
	            (!right_flanking || before_is_punctuation);
	        can_close = right_flanking &&
	            (!left_flanking || after_is_punctuation);
	    } else if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
	        can_open = left_flanking && !right_flanking;
	        can_close = right_flanking;
	    } else {
	        can_open = left_flanking;
	        can_close = right_flanking;
	    }
	    this.pos = startpos;
	    return { numdelims: numdelims,
	             can_open: can_open,
	             can_close: can_close };
	};
	
	// Handle a delimiter marker for emphasis or a quote.
	var handleDelim = function(cc, block) {
	    var res = this.scanDelims(cc);
	    if (!res) {
	        return false;
	    }
	    var numdelims = res.numdelims;
	    var startpos = this.pos;
	    var contents;
	
	    this.pos += numdelims;
	    if (cc === C_SINGLEQUOTE) {
	        contents = "\u2019";
	    } else if (cc === C_DOUBLEQUOTE) {
	        contents = "\u201C";
	    } else {
	        contents = this.subject.slice(startpos, this.pos);
	    }
	    var node = text(contents);
	    block.appendChild(node);
	
	    // Add entry to stack for this opener
	    this.delimiters = { cc: cc,
	                        numdelims: numdelims,
	                        node: node,
	                        previous: this.delimiters,
	                        next: null,
	                        can_open: res.can_open,
	                        can_close: res.can_close };
	    if (this.delimiters.previous !== null) {
	        this.delimiters.previous.next = this.delimiters;
	    }
	
	    return true;
	
	};
	
	var removeDelimiter = function(delim) {
	    if (delim.previous !== null) {
	        delim.previous.next = delim.next;
	    }
	    if (delim.next === null) {
	        // top of stack
	        this.delimiters = delim.previous;
	    } else {
	        delim.next.previous = delim.previous;
	    }
	};
	
	var removeDelimitersBetween = function(bottom, top) {
	    if (bottom.next !== top) {
	        bottom.next = top;
	        top.previous = bottom;
	    }
	};
	
	var processEmphasis = function(stack_bottom) {
	    var opener, closer, old_closer;
	    var opener_inl, closer_inl;
	    var tempstack;
	    var use_delims;
	    var tmp, next;
	    var opener_found;
	    var openers_bottom = [];
	    var odd_match = false;
	
	    openers_bottom[C_UNDERSCORE] = stack_bottom;
	    openers_bottom[C_ASTERISK] = stack_bottom;
	    openers_bottom[C_SINGLEQUOTE] = stack_bottom;
	    openers_bottom[C_DOUBLEQUOTE] = stack_bottom;
	
	    // find first closer above stack_bottom:
	    closer = this.delimiters;
	    while (closer !== null && closer.previous !== stack_bottom) {
	        closer = closer.previous;
	    }
	    // move forward, looking for closers, and handling each
	    while (closer !== null) {
	        var closercc = closer.cc;
	        if (!closer.can_close) {
	            closer = closer.next;
	        } else {
	            // found emphasis closer. now look back for first matching opener:
	            opener = closer.previous;
	            opener_found = false;
	            while (opener !== null && opener !== stack_bottom &&
	                   opener !== openers_bottom[closercc]) {
	                odd_match = (closer.can_open || opener.can_close) &&
	                    (opener.numdelims + closer.numdelims) % 3 === 0;
	                if (opener.cc === closer.cc && opener.can_open && !odd_match) {
	                    opener_found = true;
	                    break;
	                }
	                opener = opener.previous;
	            }
	            old_closer = closer;
	
	            if (closercc === C_ASTERISK || closercc === C_UNDERSCORE) {
	                if (!opener_found) {
	                    closer = closer.next;
	                } else {
	                    // calculate actual number of delimiters used from closer
	                    if (closer.numdelims < 3 || opener.numdelims < 3) {
	                        use_delims = closer.numdelims <= opener.numdelims ?
	                            closer.numdelims : opener.numdelims;
	                    } else {
	                        use_delims = closer.numdelims % 2 === 0 ? 2 : 1;
	                    }
	
	                    opener_inl = opener.node;
	                    closer_inl = closer.node;
	
	                    // remove used delimiters from stack elts and inlines
	                    opener.numdelims -= use_delims;
	                    closer.numdelims -= use_delims;
	                    opener_inl._literal =
	                        opener_inl._literal.slice(0,
	                                                  opener_inl._literal.length - use_delims);
	                    closer_inl._literal =
	                        closer_inl._literal.slice(0,
	                                                  closer_inl._literal.length - use_delims);
	
	                    // build contents for new emph element
	                    var emph = new Node(use_delims === 1 ? 'emph' : 'strong');
	
	                    tmp = opener_inl._next;
	                    while (tmp && tmp !== closer_inl) {
	                        next = tmp._next;
	                        tmp.unlink();
	                        emph.appendChild(tmp);
	                        tmp = next;
	                    }
	
	                    opener_inl.insertAfter(emph);
	
	                    // remove elts between opener and closer in delimiters stack
	                    removeDelimitersBetween(opener, closer);
	
	                    // if opener has 0 delims, remove it and the inline
	                    if (opener.numdelims === 0) {
	                        opener_inl.unlink();
	                        this.removeDelimiter(opener);
	                    }
	
	                    if (closer.numdelims === 0) {
	                        closer_inl.unlink();
	                        tempstack = closer.next;
	                        this.removeDelimiter(closer);
	                        closer = tempstack;
	                    }
	
	                }
	
	            } else if (closercc === C_SINGLEQUOTE) {
	                closer.node._literal = "\u2019";
	                if (opener_found) {
	                    opener.node._literal = "\u2018";
	                }
	                closer = closer.next;
	
	            } else if (closercc === C_DOUBLEQUOTE) {
	                closer.node._literal = "\u201D";
	                if (opener_found) {
	                    opener.node.literal = "\u201C";
	                }
	                closer = closer.next;
	
	            }
	            if (!opener_found && !odd_match) {
	                // Set lower bound for future searches for openers:
	                // We don't do this with odd_match because a **
	                // that doesn't match an earlier * might turn into
	                // an opener, and the * might be matched by something
	                // else.
	                openers_bottom[closercc] = old_closer.previous;
	                if (!old_closer.can_open) {
	                    // We can remove a closer that can't be an opener,
	                    // once we've seen there's no matching opener:
	                    this.removeDelimiter(old_closer);
	                }
	            }
	        }
	
	    }
	
	    // remove all delimiters
	    while (this.delimiters !== null && this.delimiters !== stack_bottom) {
	        this.removeDelimiter(this.delimiters);
	    }
	};
	
	// Attempt to parse link title (sans quotes), returning the string
	// or null if no match.
	var parseLinkTitle = function() {
	    var title = this.match(reLinkTitle);
	    if (title === null) {
	        return null;
	    } else {
	        // chop off quotes from title and unescape:
	        return unescapeString(title.substr(1, title.length - 2));
	    }
	};
	
	// Attempt to parse link destination, returning the string or
	// null if no match.
	var parseLinkDestination = function() {
	    var res = this.match(reLinkDestinationBraces);
	    if (res === null) {
	        res = this.match(reLinkDestination);
	        if (res === null) {
	            return null;
	        } else {
	            return normalizeURI(unescapeString(res));
	        }
	    } else {  // chop off surrounding <..>:
	        return normalizeURI(unescapeString(res.substr(1, res.length - 2)));
	    }
	};
	
	// Attempt to parse a link label, returning number of characters parsed.
	var parseLinkLabel = function() {
	    var m = this.match(reLinkLabel);
	    if (m === null || m.length > 1001) {
	        return 0;
	    } else {
	        return m.length;
	    }
	};
	
	// Add open bracket to delimiter stack and add a text node to block's children.
	var parseOpenBracket = function(block) {
	    var startpos = this.pos;
	    this.pos += 1;
	
	    var node = text('[');
	    block.appendChild(node);
	
	    // Add entry to stack for this opener
	    this.addBracket(node, startpos, false);
	    return true;
	};
	
	// IF next character is [, and ! delimiter to delimiter stack and
	// add a text node to block's children.  Otherwise just add a text node.
	var parseBang = function(block) {
	    var startpos = this.pos;
	    this.pos += 1;
	    if (this.peek() === C_OPEN_BRACKET) {
	        this.pos += 1;
	
	        var node = text('![');
	        block.appendChild(node);
	
	        // Add entry to stack for this opener
	        this.addBracket(node, startpos + 1, true);
	    } else {
	        block.appendChild(text('!'));
	    }
	    return true;
	};
	
	// Try to match close bracket against an opening in the delimiter
	// stack.  Add either a link or image, or a plain [ character,
	// to block's children.  If there is a matching delimiter,
	// remove it from the delimiter stack.
	var parseCloseBracket = function(block) {
	    var startpos;
	    var is_image;
	    var dest;
	    var title;
	    var matched = false;
	    var reflabel;
	    var opener;
	
	    this.pos += 1;
	    startpos = this.pos;
	
	    // get last [ or ![
	    opener = this.brackets;
	
	    if (opener === null) {
	        // no matched opener, just return a literal
	        block.appendChild(text(']'));
	        return true;
	    }
	
	    if (!opener.active) {
	        // no matched opener, just return a literal
	        block.appendChild(text(']'));
	        // take opener off brackets stack
	        this.removeBracket();
	        return true;
	    }
	
	    // If we got here, open is a potential opener
	    is_image = opener.image;
	
	    // Check to see if we have a link/image
	
	    var savepos = this.pos;
	
	    // Inline link?
	    if (this.peek() === C_OPEN_PAREN) {
	        this.pos++;
	        if (this.spnl() &&
	            ((dest = this.parseLinkDestination()) !== null) &&
	            this.spnl() &&
	            // make sure there's a space before the title:
	            (reWhitespaceChar.test(this.subject.charAt(this.pos - 1)) &&
	             (title = this.parseLinkTitle()) || true) &&
	            this.spnl() &&
	            this.peek() === C_CLOSE_PAREN) {
	            this.pos += 1;
	            matched = true;
	        } else {
	            this.pos = savepos;
	        }
	    }
	
	    if (!matched) {
	
	        // Next, see if there's a link label
	        var beforelabel = this.pos;
	        var n = this.parseLinkLabel();
	        if (n > 2) {
	            reflabel = this.subject.slice(beforelabel, beforelabel + n);
	        } else if (!opener.bracketAfter) {
	            // Empty or missing second label means to use the first label as the reference.
	            // The reference must not contain a bracket. If we know there's a bracket, we don't even bother checking it.
	            reflabel = this.subject.slice(opener.index, startpos);
	        }
	        if (n === 0) {
	            // If shortcut reference link, rewind before spaces we skipped.
	            this.pos = savepos;
	        }
	
	        if (reflabel) {
	            // lookup rawlabel in refmap
	            var link = this.refmap[normalizeReference(reflabel)];
	            if (link) {
	                dest = link.destination;
	                title = link.title;
	                matched = true;
	            }
	        }
	    }
	
	    if (matched) {
	        var node = new Node(is_image ? 'image' : 'link');
	        node._destination = dest;
	        node._title = title || '';
	
	        var tmp, next;
	        tmp = opener.node._next;
	        while (tmp) {
	            next = tmp._next;
	            tmp.unlink();
	            node.appendChild(tmp);
	            tmp = next;
	        }
	        block.appendChild(node);
	        this.processEmphasis(opener.previousDelimiter);
	        this.removeBracket();
	        opener.node.unlink();
	
	        // We remove this bracket and processEmphasis will remove later delimiters.
	        // Now, for a link, we also deactivate earlier link openers.
	        // (no links in links)
	        if (!is_image) {
	          opener = this.brackets;
	          while (opener !== null) {
	            if (!opener.image) {
	                opener.active = false; // deactivate this opener
	            }
	            opener = opener.previous;
	          }
	        }
	
	        return true;
	
	    } else { // no match
	
	        this.removeBracket();  // remove this opener from stack
	        this.pos = startpos;
	        block.appendChild(text(']'));
	        return true;
	    }
	
	};
	
	var addBracket = function(node, index, image) {
	    if (this.brackets !== null) {
	        this.brackets.bracketAfter = true;
	    }
	    this.brackets = { node: node,
	                      previous: this.brackets,
	                      previousDelimiter: this.delimiters,
	                      index: index,
	                      image: image,
	                      active: true };
	};
	
	var removeBracket = function() {
	    this.brackets = this.brackets.previous;
	};
	
	// Attempt to parse an entity.
	var parseEntity = function(block) {
	    var m;
	    if ((m = this.match(reEntityHere))) {
	        block.appendChild(text(decodeHTML(m)));
	        return true;
	    } else {
	        return false;
	    }
	};
	
	// Parse a run of ordinary characters, or a single character with
	// a special meaning in markdown, as a plain string.
	var parseString = function(block) {
	    var m;
	    if ((m = this.match(reMain))) {
	        if (this.options.smart) {
	            block.appendChild(text(
	                m.replace(reEllipses, "\u2026")
	                    .replace(reDash, function(chars) {
	                        var enCount = 0;
	                        var emCount = 0;
	                        if (chars.length % 3 === 0) { // If divisible by 3, use all em dashes
	                            emCount = chars.length / 3;
	                        } else if (chars.length % 2 === 0) { // If divisible by 2, use all en dashes
	                            enCount = chars.length / 2;
	                        } else if (chars.length % 3 === 2) { // If 2 extra dashes, use en dash for last 2; em dashes for rest
	                            enCount = 1;
	                            emCount = (chars.length - 2) / 3;
	                        } else { // Use en dashes for last 4 hyphens; em dashes for rest
	                            enCount = 2;
	                            emCount = (chars.length - 4) / 3;
	                        }
	                        return "\u2014".repeat(emCount) + "\u2013".repeat(enCount);
	                    })));
	        } else {
	            block.appendChild(text(m));
	        }
	        return true;
	    } else {
	        return false;
	    }
	};
	
	// Parse a newline.  If it was preceded by two spaces, return a hard
	// line break; otherwise a soft line break.
	var parseNewline = function(block) {
	    this.pos += 1; // assume we're at a \n
	    // check previous node for trailing spaces
	    var lastc = block._lastChild;
	    if (lastc && lastc.type === 'text' && lastc._literal[lastc._literal.length - 1] === ' ') {
	        var hardbreak = lastc._literal[lastc._literal.length - 2] === ' ';
	        lastc._literal = lastc._literal.replace(reFinalSpace, '');
	        block.appendChild(new Node(hardbreak ? 'linebreak' : 'softbreak'));
	    } else {
	        block.appendChild(new Node('softbreak'));
	    }
	    this.match(reInitialSpace); // gobble leading spaces in next line
	    return true;
	};
	
	// Attempt to parse a link reference, modifying refmap.
	var parseReference = function(s, refmap) {
	    this.subject = s;
	    this.pos = 0;
	    var rawlabel;
	    var dest;
	    var title;
	    var matchChars;
	    var startpos = this.pos;
	
	    // label:
	    matchChars = this.parseLinkLabel();
	    if (matchChars === 0) {
	        return 0;
	    } else {
	        rawlabel = this.subject.substr(0, matchChars);
	    }
	
	    // colon:
	    if (this.peek() === C_COLON) {
	        this.pos++;
	    } else {
	        this.pos = startpos;
	        return 0;
	    }
	
	    //  link url
	    this.spnl();
	
	    dest = this.parseLinkDestination();
	    if (dest === null || dest.length === 0) {
	        this.pos = startpos;
	        return 0;
	    }
	
	    var beforetitle = this.pos;
	    this.spnl();
	    title = this.parseLinkTitle();
	    if (title === null) {
	        title = '';
	        // rewind before spaces
	        this.pos = beforetitle;
	    }
	
	    // make sure we're at line end:
	    var atLineEnd = true;
	    if (this.match(reSpaceAtEndOfLine) === null) {
	        if (title === '') {
	            atLineEnd = false;
	        } else {
	            // the potential title we found is not at the line end,
	            // but it could still be a legal link reference if we
	            // discard the title
	            title = '';
	            // rewind before spaces
	            this.pos = beforetitle;
	            // and instead check if the link URL is at the line end
	            atLineEnd = this.match(reSpaceAtEndOfLine) !== null;
	        }
	    }
	
	    if (!atLineEnd) {
	        this.pos = startpos;
	        return 0;
	    }
	
	    var normlabel = normalizeReference(rawlabel);
	    if (normlabel === '') {
	        // label must contain non-whitespace characters
	        this.pos = startpos;
	        return 0;
	    }
	
	    if (!refmap[normlabel]) {
	        refmap[normlabel] = { destination: dest, title: title };
	    }
	    return this.pos - startpos;
	};
	
	// Parse the next inline element in subject, advancing subject position.
	// On success, add the result to block's children and return true.
	// On failure, return false.
	var parseInline = function(block) {
	    var res = false;
	    var c = this.peek();
	    if (c === -1) {
	        return false;
	    }
	    switch(c) {
	    case C_NEWLINE:
	        res = this.parseNewline(block);
	        break;
	    case C_BACKSLASH:
	        res = this.parseBackslash(block);
	        break;
	    case C_BACKTICK:
	        res = this.parseBackticks(block);
	        break;
	    case C_ASTERISK:
	    case C_UNDERSCORE:
	        res = this.handleDelim(c, block);
	        break;
	    case C_SINGLEQUOTE:
	    case C_DOUBLEQUOTE:
	        res = this.options.smart && this.handleDelim(c, block);
	        break;
	    case C_OPEN_BRACKET:
	        res = this.parseOpenBracket(block);
	        break;
	    case C_BANG:
	        res = this.parseBang(block);
	        break;
	    case C_CLOSE_BRACKET:
	        res = this.parseCloseBracket(block);
	        break;
	    case C_LESSTHAN:
	        res = this.parseAutolink(block) || this.parseHtmlTag(block);
	        break;
	    case C_AMPERSAND:
	        res = this.parseEntity(block);
	        break;
	    default:
	        res = this.parseString(block);
	        break;
	    }
	    if (!res) {
	        this.pos += 1;
	        block.appendChild(text(fromCodePoint(c)));
	    }
	
	    return true;
	};
	
	// Parse string content in block into inline children,
	// using refmap to resolve references.
	var parseInlines = function(block) {
	    this.subject = block._string_content.trim();
	    this.pos = 0;
	    this.delimiters = null;
	    this.brackets = null;
	    while (this.parseInline(block)) {
	    }
	    block._string_content = null; // allow raw string to be garbage collected
	    this.processEmphasis(null);
	};
	
	// The InlineParser object.
	function InlineParser(options){
	    return {
	        subject: '',
	        delimiters: null,  // used by handleDelim method
	        brackets: null,
	        pos: 0,
	        refmap: {},
	        match: match,
	        peek: peek,
	        spnl: spnl,
	        parseBackticks: parseBackticks,
	        parseBackslash: parseBackslash,
	        parseAutolink: parseAutolink,
	        parseHtmlTag: parseHtmlTag,
	        scanDelims: scanDelims,
	        handleDelim: handleDelim,
	        parseLinkTitle: parseLinkTitle,
	        parseLinkDestination: parseLinkDestination,
	        parseLinkLabel: parseLinkLabel,
	        parseOpenBracket: parseOpenBracket,
	        parseBang: parseBang,
	        parseCloseBracket: parseCloseBracket,
	        addBracket: addBracket,
	        removeBracket: removeBracket,
	        parseEntity: parseEntity,
	        parseString: parseString,
	        parseNewline: parseNewline,
	        parseReference: parseReference,
	        parseInline: parseInline,
	        processEmphasis: processEmphasis,
	        removeDelimiter: removeDelimiter,
	        options: options || {},
	        parse: parseInlines
	    };
	}
	
	module.exports = InlineParser;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

	"use strict";
	
	/* The bulk of this code derives from https://github.com/dmoscrop/fold-case
	But in addition to case-folding, we also normalize whitespace.
	
	fold-case is Copyright Mathias Bynens <https://mathiasbynens.be/>
	
	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	*/
	
	/*eslint-disable  key-spacing, comma-spacing */
	
	var regex = /[ \t\r\n]+|[A-Z\xB5\xC0-\xD6\xD8-\xDF\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u0149\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u017F\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C5\u01C7\u01C8\u01CA\u01CB\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F0-\u01F2\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0345\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03AB\u03B0\u03C2\u03CF-\u03D1\u03D5\u03D6\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F0\u03F1\u03F4\u03F5\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u0587\u10A0-\u10C5\u10C7\u10CD\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E96-\u1E9B\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F50\u1F52\u1F54\u1F56\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1F80-\u1FAF\u1FB2-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD2\u1FD3\u1FD6-\u1FDB\u1FE2-\u1FE4\u1FE6-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A\u212B\u2132\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0\uA7B1\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A]|\uD801[\uDC00-\uDC27]|\uD806[\uDCA0-\uDCBF]/g;
	
	var map = {'A':'a','B':'b','C':'c','D':'d','E':'e','F':'f','G':'g','H':'h','I':'i','J':'j','K':'k','L':'l','M':'m','N':'n','O':'o','P':'p','Q':'q','R':'r','S':'s','T':'t','U':'u','V':'v','W':'w','X':'x','Y':'y','Z':'z','\xB5':'\u03BC','\xC0':'\xE0','\xC1':'\xE1','\xC2':'\xE2','\xC3':'\xE3','\xC4':'\xE4','\xC5':'\xE5','\xC6':'\xE6','\xC7':'\xE7','\xC8':'\xE8','\xC9':'\xE9','\xCA':'\xEA','\xCB':'\xEB','\xCC':'\xEC','\xCD':'\xED','\xCE':'\xEE','\xCF':'\xEF','\xD0':'\xF0','\xD1':'\xF1','\xD2':'\xF2','\xD3':'\xF3','\xD4':'\xF4','\xD5':'\xF5','\xD6':'\xF6','\xD8':'\xF8','\xD9':'\xF9','\xDA':'\xFA','\xDB':'\xFB','\xDC':'\xFC','\xDD':'\xFD','\xDE':'\xFE','\u0100':'\u0101','\u0102':'\u0103','\u0104':'\u0105','\u0106':'\u0107','\u0108':'\u0109','\u010A':'\u010B','\u010C':'\u010D','\u010E':'\u010F','\u0110':'\u0111','\u0112':'\u0113','\u0114':'\u0115','\u0116':'\u0117','\u0118':'\u0119','\u011A':'\u011B','\u011C':'\u011D','\u011E':'\u011F','\u0120':'\u0121','\u0122':'\u0123','\u0124':'\u0125','\u0126':'\u0127','\u0128':'\u0129','\u012A':'\u012B','\u012C':'\u012D','\u012E':'\u012F','\u0132':'\u0133','\u0134':'\u0135','\u0136':'\u0137','\u0139':'\u013A','\u013B':'\u013C','\u013D':'\u013E','\u013F':'\u0140','\u0141':'\u0142','\u0143':'\u0144','\u0145':'\u0146','\u0147':'\u0148','\u014A':'\u014B','\u014C':'\u014D','\u014E':'\u014F','\u0150':'\u0151','\u0152':'\u0153','\u0154':'\u0155','\u0156':'\u0157','\u0158':'\u0159','\u015A':'\u015B','\u015C':'\u015D','\u015E':'\u015F','\u0160':'\u0161','\u0162':'\u0163','\u0164':'\u0165','\u0166':'\u0167','\u0168':'\u0169','\u016A':'\u016B','\u016C':'\u016D','\u016E':'\u016F','\u0170':'\u0171','\u0172':'\u0173','\u0174':'\u0175','\u0176':'\u0177','\u0178':'\xFF','\u0179':'\u017A','\u017B':'\u017C','\u017D':'\u017E','\u017F':'s','\u0181':'\u0253','\u0182':'\u0183','\u0184':'\u0185','\u0186':'\u0254','\u0187':'\u0188','\u0189':'\u0256','\u018A':'\u0257','\u018B':'\u018C','\u018E':'\u01DD','\u018F':'\u0259','\u0190':'\u025B','\u0191':'\u0192','\u0193':'\u0260','\u0194':'\u0263','\u0196':'\u0269','\u0197':'\u0268','\u0198':'\u0199','\u019C':'\u026F','\u019D':'\u0272','\u019F':'\u0275','\u01A0':'\u01A1','\u01A2':'\u01A3','\u01A4':'\u01A5','\u01A6':'\u0280','\u01A7':'\u01A8','\u01A9':'\u0283','\u01AC':'\u01AD','\u01AE':'\u0288','\u01AF':'\u01B0','\u01B1':'\u028A','\u01B2':'\u028B','\u01B3':'\u01B4','\u01B5':'\u01B6','\u01B7':'\u0292','\u01B8':'\u01B9','\u01BC':'\u01BD','\u01C4':'\u01C6','\u01C5':'\u01C6','\u01C7':'\u01C9','\u01C8':'\u01C9','\u01CA':'\u01CC','\u01CB':'\u01CC','\u01CD':'\u01CE','\u01CF':'\u01D0','\u01D1':'\u01D2','\u01D3':'\u01D4','\u01D5':'\u01D6','\u01D7':'\u01D8','\u01D9':'\u01DA','\u01DB':'\u01DC','\u01DE':'\u01DF','\u01E0':'\u01E1','\u01E2':'\u01E3','\u01E4':'\u01E5','\u01E6':'\u01E7','\u01E8':'\u01E9','\u01EA':'\u01EB','\u01EC':'\u01ED','\u01EE':'\u01EF','\u01F1':'\u01F3','\u01F2':'\u01F3','\u01F4':'\u01F5','\u01F6':'\u0195','\u01F7':'\u01BF','\u01F8':'\u01F9','\u01FA':'\u01FB','\u01FC':'\u01FD','\u01FE':'\u01FF','\u0200':'\u0201','\u0202':'\u0203','\u0204':'\u0205','\u0206':'\u0207','\u0208':'\u0209','\u020A':'\u020B','\u020C':'\u020D','\u020E':'\u020F','\u0210':'\u0211','\u0212':'\u0213','\u0214':'\u0215','\u0216':'\u0217','\u0218':'\u0219','\u021A':'\u021B','\u021C':'\u021D','\u021E':'\u021F','\u0220':'\u019E','\u0222':'\u0223','\u0224':'\u0225','\u0226':'\u0227','\u0228':'\u0229','\u022A':'\u022B','\u022C':'\u022D','\u022E':'\u022F','\u0230':'\u0231','\u0232':'\u0233','\u023A':'\u2C65','\u023B':'\u023C','\u023D':'\u019A','\u023E':'\u2C66','\u0241':'\u0242','\u0243':'\u0180','\u0244':'\u0289','\u0245':'\u028C','\u0246':'\u0247','\u0248':'\u0249','\u024A':'\u024B','\u024C':'\u024D','\u024E':'\u024F','\u0345':'\u03B9','\u0370':'\u0371','\u0372':'\u0373','\u0376':'\u0377','\u037F':'\u03F3','\u0386':'\u03AC','\u0388':'\u03AD','\u0389':'\u03AE','\u038A':'\u03AF','\u038C':'\u03CC','\u038E':'\u03CD','\u038F':'\u03CE','\u0391':'\u03B1','\u0392':'\u03B2','\u0393':'\u03B3','\u0394':'\u03B4','\u0395':'\u03B5','\u0396':'\u03B6','\u0397':'\u03B7','\u0398':'\u03B8','\u0399':'\u03B9','\u039A':'\u03BA','\u039B':'\u03BB','\u039C':'\u03BC','\u039D':'\u03BD','\u039E':'\u03BE','\u039F':'\u03BF','\u03A0':'\u03C0','\u03A1':'\u03C1','\u03A3':'\u03C3','\u03A4':'\u03C4','\u03A5':'\u03C5','\u03A6':'\u03C6','\u03A7':'\u03C7','\u03A8':'\u03C8','\u03A9':'\u03C9','\u03AA':'\u03CA','\u03AB':'\u03CB','\u03C2':'\u03C3','\u03CF':'\u03D7','\u03D0':'\u03B2','\u03D1':'\u03B8','\u03D5':'\u03C6','\u03D6':'\u03C0','\u03D8':'\u03D9','\u03DA':'\u03DB','\u03DC':'\u03DD','\u03DE':'\u03DF','\u03E0':'\u03E1','\u03E2':'\u03E3','\u03E4':'\u03E5','\u03E6':'\u03E7','\u03E8':'\u03E9','\u03EA':'\u03EB','\u03EC':'\u03ED','\u03EE':'\u03EF','\u03F0':'\u03BA','\u03F1':'\u03C1','\u03F4':'\u03B8','\u03F5':'\u03B5','\u03F7':'\u03F8','\u03F9':'\u03F2','\u03FA':'\u03FB','\u03FD':'\u037B','\u03FE':'\u037C','\u03FF':'\u037D','\u0400':'\u0450','\u0401':'\u0451','\u0402':'\u0452','\u0403':'\u0453','\u0404':'\u0454','\u0405':'\u0455','\u0406':'\u0456','\u0407':'\u0457','\u0408':'\u0458','\u0409':'\u0459','\u040A':'\u045A','\u040B':'\u045B','\u040C':'\u045C','\u040D':'\u045D','\u040E':'\u045E','\u040F':'\u045F','\u0410':'\u0430','\u0411':'\u0431','\u0412':'\u0432','\u0413':'\u0433','\u0414':'\u0434','\u0415':'\u0435','\u0416':'\u0436','\u0417':'\u0437','\u0418':'\u0438','\u0419':'\u0439','\u041A':'\u043A','\u041B':'\u043B','\u041C':'\u043C','\u041D':'\u043D','\u041E':'\u043E','\u041F':'\u043F','\u0420':'\u0440','\u0421':'\u0441','\u0422':'\u0442','\u0423':'\u0443','\u0424':'\u0444','\u0425':'\u0445','\u0426':'\u0446','\u0427':'\u0447','\u0428':'\u0448','\u0429':'\u0449','\u042A':'\u044A','\u042B':'\u044B','\u042C':'\u044C','\u042D':'\u044D','\u042E':'\u044E','\u042F':'\u044F','\u0460':'\u0461','\u0462':'\u0463','\u0464':'\u0465','\u0466':'\u0467','\u0468':'\u0469','\u046A':'\u046B','\u046C':'\u046D','\u046E':'\u046F','\u0470':'\u0471','\u0472':'\u0473','\u0474':'\u0475','\u0476':'\u0477','\u0478':'\u0479','\u047A':'\u047B','\u047C':'\u047D','\u047E':'\u047F','\u0480':'\u0481','\u048A':'\u048B','\u048C':'\u048D','\u048E':'\u048F','\u0490':'\u0491','\u0492':'\u0493','\u0494':'\u0495','\u0496':'\u0497','\u0498':'\u0499','\u049A':'\u049B','\u049C':'\u049D','\u049E':'\u049F','\u04A0':'\u04A1','\u04A2':'\u04A3','\u04A4':'\u04A5','\u04A6':'\u04A7','\u04A8':'\u04A9','\u04AA':'\u04AB','\u04AC':'\u04AD','\u04AE':'\u04AF','\u04B0':'\u04B1','\u04B2':'\u04B3','\u04B4':'\u04B5','\u04B6':'\u04B7','\u04B8':'\u04B9','\u04BA':'\u04BB','\u04BC':'\u04BD','\u04BE':'\u04BF','\u04C0':'\u04CF','\u04C1':'\u04C2','\u04C3':'\u04C4','\u04C5':'\u04C6','\u04C7':'\u04C8','\u04C9':'\u04CA','\u04CB':'\u04CC','\u04CD':'\u04CE','\u04D0':'\u04D1','\u04D2':'\u04D3','\u04D4':'\u04D5','\u04D6':'\u04D7','\u04D8':'\u04D9','\u04DA':'\u04DB','\u04DC':'\u04DD','\u04DE':'\u04DF','\u04E0':'\u04E1','\u04E2':'\u04E3','\u04E4':'\u04E5','\u04E6':'\u04E7','\u04E8':'\u04E9','\u04EA':'\u04EB','\u04EC':'\u04ED','\u04EE':'\u04EF','\u04F0':'\u04F1','\u04F2':'\u04F3','\u04F4':'\u04F5','\u04F6':'\u04F7','\u04F8':'\u04F9','\u04FA':'\u04FB','\u04FC':'\u04FD','\u04FE':'\u04FF','\u0500':'\u0501','\u0502':'\u0503','\u0504':'\u0505','\u0506':'\u0507','\u0508':'\u0509','\u050A':'\u050B','\u050C':'\u050D','\u050E':'\u050F','\u0510':'\u0511','\u0512':'\u0513','\u0514':'\u0515','\u0516':'\u0517','\u0518':'\u0519','\u051A':'\u051B','\u051C':'\u051D','\u051E':'\u051F','\u0520':'\u0521','\u0522':'\u0523','\u0524':'\u0525','\u0526':'\u0527','\u0528':'\u0529','\u052A':'\u052B','\u052C':'\u052D','\u052E':'\u052F','\u0531':'\u0561','\u0532':'\u0562','\u0533':'\u0563','\u0534':'\u0564','\u0535':'\u0565','\u0536':'\u0566','\u0537':'\u0567','\u0538':'\u0568','\u0539':'\u0569','\u053A':'\u056A','\u053B':'\u056B','\u053C':'\u056C','\u053D':'\u056D','\u053E':'\u056E','\u053F':'\u056F','\u0540':'\u0570','\u0541':'\u0571','\u0542':'\u0572','\u0543':'\u0573','\u0544':'\u0574','\u0545':'\u0575','\u0546':'\u0576','\u0547':'\u0577','\u0548':'\u0578','\u0549':'\u0579','\u054A':'\u057A','\u054B':'\u057B','\u054C':'\u057C','\u054D':'\u057D','\u054E':'\u057E','\u054F':'\u057F','\u0550':'\u0580','\u0551':'\u0581','\u0552':'\u0582','\u0553':'\u0583','\u0554':'\u0584','\u0555':'\u0585','\u0556':'\u0586','\u10A0':'\u2D00','\u10A1':'\u2D01','\u10A2':'\u2D02','\u10A3':'\u2D03','\u10A4':'\u2D04','\u10A5':'\u2D05','\u10A6':'\u2D06','\u10A7':'\u2D07','\u10A8':'\u2D08','\u10A9':'\u2D09','\u10AA':'\u2D0A','\u10AB':'\u2D0B','\u10AC':'\u2D0C','\u10AD':'\u2D0D','\u10AE':'\u2D0E','\u10AF':'\u2D0F','\u10B0':'\u2D10','\u10B1':'\u2D11','\u10B2':'\u2D12','\u10B3':'\u2D13','\u10B4':'\u2D14','\u10B5':'\u2D15','\u10B6':'\u2D16','\u10B7':'\u2D17','\u10B8':'\u2D18','\u10B9':'\u2D19','\u10BA':'\u2D1A','\u10BB':'\u2D1B','\u10BC':'\u2D1C','\u10BD':'\u2D1D','\u10BE':'\u2D1E','\u10BF':'\u2D1F','\u10C0':'\u2D20','\u10C1':'\u2D21','\u10C2':'\u2D22','\u10C3':'\u2D23','\u10C4':'\u2D24','\u10C5':'\u2D25','\u10C7':'\u2D27','\u10CD':'\u2D2D','\u1E00':'\u1E01','\u1E02':'\u1E03','\u1E04':'\u1E05','\u1E06':'\u1E07','\u1E08':'\u1E09','\u1E0A':'\u1E0B','\u1E0C':'\u1E0D','\u1E0E':'\u1E0F','\u1E10':'\u1E11','\u1E12':'\u1E13','\u1E14':'\u1E15','\u1E16':'\u1E17','\u1E18':'\u1E19','\u1E1A':'\u1E1B','\u1E1C':'\u1E1D','\u1E1E':'\u1E1F','\u1E20':'\u1E21','\u1E22':'\u1E23','\u1E24':'\u1E25','\u1E26':'\u1E27','\u1E28':'\u1E29','\u1E2A':'\u1E2B','\u1E2C':'\u1E2D','\u1E2E':'\u1E2F','\u1E30':'\u1E31','\u1E32':'\u1E33','\u1E34':'\u1E35','\u1E36':'\u1E37','\u1E38':'\u1E39','\u1E3A':'\u1E3B','\u1E3C':'\u1E3D','\u1E3E':'\u1E3F','\u1E40':'\u1E41','\u1E42':'\u1E43','\u1E44':'\u1E45','\u1E46':'\u1E47','\u1E48':'\u1E49','\u1E4A':'\u1E4B','\u1E4C':'\u1E4D','\u1E4E':'\u1E4F','\u1E50':'\u1E51','\u1E52':'\u1E53','\u1E54':'\u1E55','\u1E56':'\u1E57','\u1E58':'\u1E59','\u1E5A':'\u1E5B','\u1E5C':'\u1E5D','\u1E5E':'\u1E5F','\u1E60':'\u1E61','\u1E62':'\u1E63','\u1E64':'\u1E65','\u1E66':'\u1E67','\u1E68':'\u1E69','\u1E6A':'\u1E6B','\u1E6C':'\u1E6D','\u1E6E':'\u1E6F','\u1E70':'\u1E71','\u1E72':'\u1E73','\u1E74':'\u1E75','\u1E76':'\u1E77','\u1E78':'\u1E79','\u1E7A':'\u1E7B','\u1E7C':'\u1E7D','\u1E7E':'\u1E7F','\u1E80':'\u1E81','\u1E82':'\u1E83','\u1E84':'\u1E85','\u1E86':'\u1E87','\u1E88':'\u1E89','\u1E8A':'\u1E8B','\u1E8C':'\u1E8D','\u1E8E':'\u1E8F','\u1E90':'\u1E91','\u1E92':'\u1E93','\u1E94':'\u1E95','\u1E9B':'\u1E61','\u1EA0':'\u1EA1','\u1EA2':'\u1EA3','\u1EA4':'\u1EA5','\u1EA6':'\u1EA7','\u1EA8':'\u1EA9','\u1EAA':'\u1EAB','\u1EAC':'\u1EAD','\u1EAE':'\u1EAF','\u1EB0':'\u1EB1','\u1EB2':'\u1EB3','\u1EB4':'\u1EB5','\u1EB6':'\u1EB7','\u1EB8':'\u1EB9','\u1EBA':'\u1EBB','\u1EBC':'\u1EBD','\u1EBE':'\u1EBF','\u1EC0':'\u1EC1','\u1EC2':'\u1EC3','\u1EC4':'\u1EC5','\u1EC6':'\u1EC7','\u1EC8':'\u1EC9','\u1ECA':'\u1ECB','\u1ECC':'\u1ECD','\u1ECE':'\u1ECF','\u1ED0':'\u1ED1','\u1ED2':'\u1ED3','\u1ED4':'\u1ED5','\u1ED6':'\u1ED7','\u1ED8':'\u1ED9','\u1EDA':'\u1EDB','\u1EDC':'\u1EDD','\u1EDE':'\u1EDF','\u1EE0':'\u1EE1','\u1EE2':'\u1EE3','\u1EE4':'\u1EE5','\u1EE6':'\u1EE7','\u1EE8':'\u1EE9','\u1EEA':'\u1EEB','\u1EEC':'\u1EED','\u1EEE':'\u1EEF','\u1EF0':'\u1EF1','\u1EF2':'\u1EF3','\u1EF4':'\u1EF5','\u1EF6':'\u1EF7','\u1EF8':'\u1EF9','\u1EFA':'\u1EFB','\u1EFC':'\u1EFD','\u1EFE':'\u1EFF','\u1F08':'\u1F00','\u1F09':'\u1F01','\u1F0A':'\u1F02','\u1F0B':'\u1F03','\u1F0C':'\u1F04','\u1F0D':'\u1F05','\u1F0E':'\u1F06','\u1F0F':'\u1F07','\u1F18':'\u1F10','\u1F19':'\u1F11','\u1F1A':'\u1F12','\u1F1B':'\u1F13','\u1F1C':'\u1F14','\u1F1D':'\u1F15','\u1F28':'\u1F20','\u1F29':'\u1F21','\u1F2A':'\u1F22','\u1F2B':'\u1F23','\u1F2C':'\u1F24','\u1F2D':'\u1F25','\u1F2E':'\u1F26','\u1F2F':'\u1F27','\u1F38':'\u1F30','\u1F39':'\u1F31','\u1F3A':'\u1F32','\u1F3B':'\u1F33','\u1F3C':'\u1F34','\u1F3D':'\u1F35','\u1F3E':'\u1F36','\u1F3F':'\u1F37','\u1F48':'\u1F40','\u1F49':'\u1F41','\u1F4A':'\u1F42','\u1F4B':'\u1F43','\u1F4C':'\u1F44','\u1F4D':'\u1F45','\u1F59':'\u1F51','\u1F5B':'\u1F53','\u1F5D':'\u1F55','\u1F5F':'\u1F57','\u1F68':'\u1F60','\u1F69':'\u1F61','\u1F6A':'\u1F62','\u1F6B':'\u1F63','\u1F6C':'\u1F64','\u1F6D':'\u1F65','\u1F6E':'\u1F66','\u1F6F':'\u1F67','\u1FB8':'\u1FB0','\u1FB9':'\u1FB1','\u1FBA':'\u1F70','\u1FBB':'\u1F71','\u1FBE':'\u03B9','\u1FC8':'\u1F72','\u1FC9':'\u1F73','\u1FCA':'\u1F74','\u1FCB':'\u1F75','\u1FD8':'\u1FD0','\u1FD9':'\u1FD1','\u1FDA':'\u1F76','\u1FDB':'\u1F77','\u1FE8':'\u1FE0','\u1FE9':'\u1FE1','\u1FEA':'\u1F7A','\u1FEB':'\u1F7B','\u1FEC':'\u1FE5','\u1FF8':'\u1F78','\u1FF9':'\u1F79','\u1FFA':'\u1F7C','\u1FFB':'\u1F7D','\u2126':'\u03C9','\u212A':'k','\u212B':'\xE5','\u2132':'\u214E','\u2160':'\u2170','\u2161':'\u2171','\u2162':'\u2172','\u2163':'\u2173','\u2164':'\u2174','\u2165':'\u2175','\u2166':'\u2176','\u2167':'\u2177','\u2168':'\u2178','\u2169':'\u2179','\u216A':'\u217A','\u216B':'\u217B','\u216C':'\u217C','\u216D':'\u217D','\u216E':'\u217E','\u216F':'\u217F','\u2183':'\u2184','\u24B6':'\u24D0','\u24B7':'\u24D1','\u24B8':'\u24D2','\u24B9':'\u24D3','\u24BA':'\u24D4','\u24BB':'\u24D5','\u24BC':'\u24D6','\u24BD':'\u24D7','\u24BE':'\u24D8','\u24BF':'\u24D9','\u24C0':'\u24DA','\u24C1':'\u24DB','\u24C2':'\u24DC','\u24C3':'\u24DD','\u24C4':'\u24DE','\u24C5':'\u24DF','\u24C6':'\u24E0','\u24C7':'\u24E1','\u24C8':'\u24E2','\u24C9':'\u24E3','\u24CA':'\u24E4','\u24CB':'\u24E5','\u24CC':'\u24E6','\u24CD':'\u24E7','\u24CE':'\u24E8','\u24CF':'\u24E9','\u2C00':'\u2C30','\u2C01':'\u2C31','\u2C02':'\u2C32','\u2C03':'\u2C33','\u2C04':'\u2C34','\u2C05':'\u2C35','\u2C06':'\u2C36','\u2C07':'\u2C37','\u2C08':'\u2C38','\u2C09':'\u2C39','\u2C0A':'\u2C3A','\u2C0B':'\u2C3B','\u2C0C':'\u2C3C','\u2C0D':'\u2C3D','\u2C0E':'\u2C3E','\u2C0F':'\u2C3F','\u2C10':'\u2C40','\u2C11':'\u2C41','\u2C12':'\u2C42','\u2C13':'\u2C43','\u2C14':'\u2C44','\u2C15':'\u2C45','\u2C16':'\u2C46','\u2C17':'\u2C47','\u2C18':'\u2C48','\u2C19':'\u2C49','\u2C1A':'\u2C4A','\u2C1B':'\u2C4B','\u2C1C':'\u2C4C','\u2C1D':'\u2C4D','\u2C1E':'\u2C4E','\u2C1F':'\u2C4F','\u2C20':'\u2C50','\u2C21':'\u2C51','\u2C22':'\u2C52','\u2C23':'\u2C53','\u2C24':'\u2C54','\u2C25':'\u2C55','\u2C26':'\u2C56','\u2C27':'\u2C57','\u2C28':'\u2C58','\u2C29':'\u2C59','\u2C2A':'\u2C5A','\u2C2B':'\u2C5B','\u2C2C':'\u2C5C','\u2C2D':'\u2C5D','\u2C2E':'\u2C5E','\u2C60':'\u2C61','\u2C62':'\u026B','\u2C63':'\u1D7D','\u2C64':'\u027D','\u2C67':'\u2C68','\u2C69':'\u2C6A','\u2C6B':'\u2C6C','\u2C6D':'\u0251','\u2C6E':'\u0271','\u2C6F':'\u0250','\u2C70':'\u0252','\u2C72':'\u2C73','\u2C75':'\u2C76','\u2C7E':'\u023F','\u2C7F':'\u0240','\u2C80':'\u2C81','\u2C82':'\u2C83','\u2C84':'\u2C85','\u2C86':'\u2C87','\u2C88':'\u2C89','\u2C8A':'\u2C8B','\u2C8C':'\u2C8D','\u2C8E':'\u2C8F','\u2C90':'\u2C91','\u2C92':'\u2C93','\u2C94':'\u2C95','\u2C96':'\u2C97','\u2C98':'\u2C99','\u2C9A':'\u2C9B','\u2C9C':'\u2C9D','\u2C9E':'\u2C9F','\u2CA0':'\u2CA1','\u2CA2':'\u2CA3','\u2CA4':'\u2CA5','\u2CA6':'\u2CA7','\u2CA8':'\u2CA9','\u2CAA':'\u2CAB','\u2CAC':'\u2CAD','\u2CAE':'\u2CAF','\u2CB0':'\u2CB1','\u2CB2':'\u2CB3','\u2CB4':'\u2CB5','\u2CB6':'\u2CB7','\u2CB8':'\u2CB9','\u2CBA':'\u2CBB','\u2CBC':'\u2CBD','\u2CBE':'\u2CBF','\u2CC0':'\u2CC1','\u2CC2':'\u2CC3','\u2CC4':'\u2CC5','\u2CC6':'\u2CC7','\u2CC8':'\u2CC9','\u2CCA':'\u2CCB','\u2CCC':'\u2CCD','\u2CCE':'\u2CCF','\u2CD0':'\u2CD1','\u2CD2':'\u2CD3','\u2CD4':'\u2CD5','\u2CD6':'\u2CD7','\u2CD8':'\u2CD9','\u2CDA':'\u2CDB','\u2CDC':'\u2CDD','\u2CDE':'\u2CDF','\u2CE0':'\u2CE1','\u2CE2':'\u2CE3','\u2CEB':'\u2CEC','\u2CED':'\u2CEE','\u2CF2':'\u2CF3','\uA640':'\uA641','\uA642':'\uA643','\uA644':'\uA645','\uA646':'\uA647','\uA648':'\uA649','\uA64A':'\uA64B','\uA64C':'\uA64D','\uA64E':'\uA64F','\uA650':'\uA651','\uA652':'\uA653','\uA654':'\uA655','\uA656':'\uA657','\uA658':'\uA659','\uA65A':'\uA65B','\uA65C':'\uA65D','\uA65E':'\uA65F','\uA660':'\uA661','\uA662':'\uA663','\uA664':'\uA665','\uA666':'\uA667','\uA668':'\uA669','\uA66A':'\uA66B','\uA66C':'\uA66D','\uA680':'\uA681','\uA682':'\uA683','\uA684':'\uA685','\uA686':'\uA687','\uA688':'\uA689','\uA68A':'\uA68B','\uA68C':'\uA68D','\uA68E':'\uA68F','\uA690':'\uA691','\uA692':'\uA693','\uA694':'\uA695','\uA696':'\uA697','\uA698':'\uA699','\uA69A':'\uA69B','\uA722':'\uA723','\uA724':'\uA725','\uA726':'\uA727','\uA728':'\uA729','\uA72A':'\uA72B','\uA72C':'\uA72D','\uA72E':'\uA72F','\uA732':'\uA733','\uA734':'\uA735','\uA736':'\uA737','\uA738':'\uA739','\uA73A':'\uA73B','\uA73C':'\uA73D','\uA73E':'\uA73F','\uA740':'\uA741','\uA742':'\uA743','\uA744':'\uA745','\uA746':'\uA747','\uA748':'\uA749','\uA74A':'\uA74B','\uA74C':'\uA74D','\uA74E':'\uA74F','\uA750':'\uA751','\uA752':'\uA753','\uA754':'\uA755','\uA756':'\uA757','\uA758':'\uA759','\uA75A':'\uA75B','\uA75C':'\uA75D','\uA75E':'\uA75F','\uA760':'\uA761','\uA762':'\uA763','\uA764':'\uA765','\uA766':'\uA767','\uA768':'\uA769','\uA76A':'\uA76B','\uA76C':'\uA76D','\uA76E':'\uA76F','\uA779':'\uA77A','\uA77B':'\uA77C','\uA77D':'\u1D79','\uA77E':'\uA77F','\uA780':'\uA781','\uA782':'\uA783','\uA784':'\uA785','\uA786':'\uA787','\uA78B':'\uA78C','\uA78D':'\u0265','\uA790':'\uA791','\uA792':'\uA793','\uA796':'\uA797','\uA798':'\uA799','\uA79A':'\uA79B','\uA79C':'\uA79D','\uA79E':'\uA79F','\uA7A0':'\uA7A1','\uA7A2':'\uA7A3','\uA7A4':'\uA7A5','\uA7A6':'\uA7A7','\uA7A8':'\uA7A9','\uA7AA':'\u0266','\uA7AB':'\u025C','\uA7AC':'\u0261','\uA7AD':'\u026C','\uA7B0':'\u029E','\uA7B1':'\u0287','\uFF21':'\uFF41','\uFF22':'\uFF42','\uFF23':'\uFF43','\uFF24':'\uFF44','\uFF25':'\uFF45','\uFF26':'\uFF46','\uFF27':'\uFF47','\uFF28':'\uFF48','\uFF29':'\uFF49','\uFF2A':'\uFF4A','\uFF2B':'\uFF4B','\uFF2C':'\uFF4C','\uFF2D':'\uFF4D','\uFF2E':'\uFF4E','\uFF2F':'\uFF4F','\uFF30':'\uFF50','\uFF31':'\uFF51','\uFF32':'\uFF52','\uFF33':'\uFF53','\uFF34':'\uFF54','\uFF35':'\uFF55','\uFF36':'\uFF56','\uFF37':'\uFF57','\uFF38':'\uFF58','\uFF39':'\uFF59','\uFF3A':'\uFF5A','\uD801\uDC00':'\uD801\uDC28','\uD801\uDC01':'\uD801\uDC29','\uD801\uDC02':'\uD801\uDC2A','\uD801\uDC03':'\uD801\uDC2B','\uD801\uDC04':'\uD801\uDC2C','\uD801\uDC05':'\uD801\uDC2D','\uD801\uDC06':'\uD801\uDC2E','\uD801\uDC07':'\uD801\uDC2F','\uD801\uDC08':'\uD801\uDC30','\uD801\uDC09':'\uD801\uDC31','\uD801\uDC0A':'\uD801\uDC32','\uD801\uDC0B':'\uD801\uDC33','\uD801\uDC0C':'\uD801\uDC34','\uD801\uDC0D':'\uD801\uDC35','\uD801\uDC0E':'\uD801\uDC36','\uD801\uDC0F':'\uD801\uDC37','\uD801\uDC10':'\uD801\uDC38','\uD801\uDC11':'\uD801\uDC39','\uD801\uDC12':'\uD801\uDC3A','\uD801\uDC13':'\uD801\uDC3B','\uD801\uDC14':'\uD801\uDC3C','\uD801\uDC15':'\uD801\uDC3D','\uD801\uDC16':'\uD801\uDC3E','\uD801\uDC17':'\uD801\uDC3F','\uD801\uDC18':'\uD801\uDC40','\uD801\uDC19':'\uD801\uDC41','\uD801\uDC1A':'\uD801\uDC42','\uD801\uDC1B':'\uD801\uDC43','\uD801\uDC1C':'\uD801\uDC44','\uD801\uDC1D':'\uD801\uDC45','\uD801\uDC1E':'\uD801\uDC46','\uD801\uDC1F':'\uD801\uDC47','\uD801\uDC20':'\uD801\uDC48','\uD801\uDC21':'\uD801\uDC49','\uD801\uDC22':'\uD801\uDC4A','\uD801\uDC23':'\uD801\uDC4B','\uD801\uDC24':'\uD801\uDC4C','\uD801\uDC25':'\uD801\uDC4D','\uD801\uDC26':'\uD801\uDC4E','\uD801\uDC27':'\uD801\uDC4F','\uD806\uDCA0':'\uD806\uDCC0','\uD806\uDCA1':'\uD806\uDCC1','\uD806\uDCA2':'\uD806\uDCC2','\uD806\uDCA3':'\uD806\uDCC3','\uD806\uDCA4':'\uD806\uDCC4','\uD806\uDCA5':'\uD806\uDCC5','\uD806\uDCA6':'\uD806\uDCC6','\uD806\uDCA7':'\uD806\uDCC7','\uD806\uDCA8':'\uD806\uDCC8','\uD806\uDCA9':'\uD806\uDCC9','\uD806\uDCAA':'\uD806\uDCCA','\uD806\uDCAB':'\uD806\uDCCB','\uD806\uDCAC':'\uD806\uDCCC','\uD806\uDCAD':'\uD806\uDCCD','\uD806\uDCAE':'\uD806\uDCCE','\uD806\uDCAF':'\uD806\uDCCF','\uD806\uDCB0':'\uD806\uDCD0','\uD806\uDCB1':'\uD806\uDCD1','\uD806\uDCB2':'\uD806\uDCD2','\uD806\uDCB3':'\uD806\uDCD3','\uD806\uDCB4':'\uD806\uDCD4','\uD806\uDCB5':'\uD806\uDCD5','\uD806\uDCB6':'\uD806\uDCD6','\uD806\uDCB7':'\uD806\uDCD7','\uD806\uDCB8':'\uD806\uDCD8','\uD806\uDCB9':'\uD806\uDCD9','\uD806\uDCBA':'\uD806\uDCDA','\uD806\uDCBB':'\uD806\uDCDB','\uD806\uDCBC':'\uD806\uDCDC','\uD806\uDCBD':'\uD806\uDCDD','\uD806\uDCBE':'\uD806\uDCDE','\uD806\uDCBF':'\uD806\uDCDF','\xDF':'ss','\u0130':'i\u0307','\u0149':'\u02BCn','\u01F0':'j\u030C','\u0390':'\u03B9\u0308\u0301','\u03B0':'\u03C5\u0308\u0301','\u0587':'\u0565\u0582','\u1E96':'h\u0331','\u1E97':'t\u0308','\u1E98':'w\u030A','\u1E99':'y\u030A','\u1E9A':'a\u02BE','\u1E9E':'ss','\u1F50':'\u03C5\u0313','\u1F52':'\u03C5\u0313\u0300','\u1F54':'\u03C5\u0313\u0301','\u1F56':'\u03C5\u0313\u0342','\u1F80':'\u1F00\u03B9','\u1F81':'\u1F01\u03B9','\u1F82':'\u1F02\u03B9','\u1F83':'\u1F03\u03B9','\u1F84':'\u1F04\u03B9','\u1F85':'\u1F05\u03B9','\u1F86':'\u1F06\u03B9','\u1F87':'\u1F07\u03B9','\u1F88':'\u1F00\u03B9','\u1F89':'\u1F01\u03B9','\u1F8A':'\u1F02\u03B9','\u1F8B':'\u1F03\u03B9','\u1F8C':'\u1F04\u03B9','\u1F8D':'\u1F05\u03B9','\u1F8E':'\u1F06\u03B9','\u1F8F':'\u1F07\u03B9','\u1F90':'\u1F20\u03B9','\u1F91':'\u1F21\u03B9','\u1F92':'\u1F22\u03B9','\u1F93':'\u1F23\u03B9','\u1F94':'\u1F24\u03B9','\u1F95':'\u1F25\u03B9','\u1F96':'\u1F26\u03B9','\u1F97':'\u1F27\u03B9','\u1F98':'\u1F20\u03B9','\u1F99':'\u1F21\u03B9','\u1F9A':'\u1F22\u03B9','\u1F9B':'\u1F23\u03B9','\u1F9C':'\u1F24\u03B9','\u1F9D':'\u1F25\u03B9','\u1F9E':'\u1F26\u03B9','\u1F9F':'\u1F27\u03B9','\u1FA0':'\u1F60\u03B9','\u1FA1':'\u1F61\u03B9','\u1FA2':'\u1F62\u03B9','\u1FA3':'\u1F63\u03B9','\u1FA4':'\u1F64\u03B9','\u1FA5':'\u1F65\u03B9','\u1FA6':'\u1F66\u03B9','\u1FA7':'\u1F67\u03B9','\u1FA8':'\u1F60\u03B9','\u1FA9':'\u1F61\u03B9','\u1FAA':'\u1F62\u03B9','\u1FAB':'\u1F63\u03B9','\u1FAC':'\u1F64\u03B9','\u1FAD':'\u1F65\u03B9','\u1FAE':'\u1F66\u03B9','\u1FAF':'\u1F67\u03B9','\u1FB2':'\u1F70\u03B9','\u1FB3':'\u03B1\u03B9','\u1FB4':'\u03AC\u03B9','\u1FB6':'\u03B1\u0342','\u1FB7':'\u03B1\u0342\u03B9','\u1FBC':'\u03B1\u03B9','\u1FC2':'\u1F74\u03B9','\u1FC3':'\u03B7\u03B9','\u1FC4':'\u03AE\u03B9','\u1FC6':'\u03B7\u0342','\u1FC7':'\u03B7\u0342\u03B9','\u1FCC':'\u03B7\u03B9','\u1FD2':'\u03B9\u0308\u0300','\u1FD3':'\u03B9\u0308\u0301','\u1FD6':'\u03B9\u0342','\u1FD7':'\u03B9\u0308\u0342','\u1FE2':'\u03C5\u0308\u0300','\u1FE3':'\u03C5\u0308\u0301','\u1FE4':'\u03C1\u0313','\u1FE6':'\u03C5\u0342','\u1FE7':'\u03C5\u0308\u0342','\u1FF2':'\u1F7C\u03B9','\u1FF3':'\u03C9\u03B9','\u1FF4':'\u03CE\u03B9','\u1FF6':'\u03C9\u0342','\u1FF7':'\u03C9\u0342\u03B9','\u1FFC':'\u03C9\u03B9','\uFB00':'ff','\uFB01':'fi','\uFB02':'fl','\uFB03':'ffi','\uFB04':'ffl','\uFB05':'st','\uFB06':'st','\uFB13':'\u0574\u0576','\uFB14':'\u0574\u0565','\uFB15':'\u0574\u056B','\uFB16':'\u057E\u0576','\uFB17':'\u0574\u056D'};
	
	// Normalize reference label: collapse internal whitespace
	// to single space, remove leading/trailing whitespace, case fold.
	module.exports = function(string) {
	    return string.slice(1, string.length - 1).trim().replace(regex, function($0) {
	        // Note: there is no need to check `hasOwnProperty($0)` here.
	        // If character not found in lookup table, it must be whitespace.
	        return map[$0] || ' ';
	    });
	};


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Renderer = __webpack_require__(634);
	
	var esc = __webpack_require__(124).escapeXml;
	
	var reUnsafeProtocol = /^javascript:|vbscript:|file:|data:/i;
	var reSafeDataProtocol = /^data:image\/(?:png|gif|jpeg|webp)/i;
	
	var potentiallyUnsafe = function(url) {
	    return reUnsafeProtocol.test(url) &&
	        !reSafeDataProtocol.test(url);
	};
	
	// Helper function to produce an HTML tag.
	function tag(name, attrs, selfclosing) {
	    if (this.disableTags > 0) {
	        return;
	    }
	    this.buffer += ('<' + name);
	    if (attrs && attrs.length > 0) {
	        var i = 0;
	        var attrib;
	        while ((attrib = attrs[i]) !== undefined) {
	            this.buffer += (' ' + attrib[0] + '="' + attrib[1] + '"');
	            i++;
	        }
	    }
	    if (selfclosing) {
	        this.buffer += ' /';
	    }
	    this.buffer += '>';
	    this.lastOut = '>';
	}
	
	
	function HtmlRenderer(options) {
	  options = options || {};
	  // by default, soft breaks are rendered as newlines in HTML
	  options.softbreak = options.softbreak || '\n';
	  // set to "<br />" to make them hard breaks
	  // set to " " if you want to ignore line wrapping in source
	
	  this.disableTags = 0;
	  this.lastOut = "\n";
	  this.options = options;
	}
	
	/* Node methods */
	
	function text(node) {
	  this.out(node.literal);
	}
	
	function softbreak() {
	  this.lit(this.options.softbreak);
	}
	
	function linebreak() {
	  this.tag('br', [], true);
	  this.cr();
	}
	
	function link(node, entering) {
	  var attrs = this.attrs(node);
	  if (entering) {
	      if (!(this.options.safe && potentiallyUnsafe(node.destination))) {
	          attrs.push(['href', esc(node.destination, true)]);
	      }
	      if (node.title) {
	          attrs.push(['title', esc(node.title, true)]);
	      }
	      this.tag('a', attrs);
	  } else {
	      this.tag('/a');
	  }
	}
	
	function image(node, entering) {
	  if (entering) {
	      if (this.disableTags === 0) {
	          if (this.options.safe &&
	               potentiallyUnsafe(node.destination)) {
	              this.lit('<img src="" alt="');
	          } else {
	              this.lit('<img src="' + esc(node.destination, true) +
	                  '" alt="');
	          }
	      }
	      this.disableTags += 1;
	  } else {
	      this.disableTags -= 1;
	      if (this.disableTags === 0) {
	          if (node.title) {
	              this.lit('" title="' + esc(node.title, true));
	          }
	          this.lit('" />');
	      }
	  }
	}
	
	function emph(node, entering) {
	  this.tag(entering ? 'em' : '/em');
	}
	
	function strong(node, entering) {
	  this.tag(entering ? 'strong' : '/strong');
	}
	
	function paragraph(node, entering) {
	  var grandparent = node.parent.parent
	    , attrs = this.attrs(node);
	  if (grandparent !== null &&
	      grandparent.type === 'list') {
	      if (grandparent.listTight) {
	          return;
	      }
	  }
	  if (entering) {
	      this.cr();
	      this.tag('p', attrs);
	  } else {
	      this.tag('/p');
	      this.cr();
	  }
	}
	
	function heading(node, entering) {
	  var tagname = 'h' + node.level
	    , attrs = this.attrs(node);
	  if (entering) {
	      this.cr();
	      this.tag(tagname, attrs);
	  } else {
	      this.tag('/' + tagname);
	      this.cr();
	  }
	}
	
	function code(node) {
	  this.tag('code');
	  this.out(node.literal);
	  this.tag('/code');
	}
	
	function code_block(node) {
	  var info_words = node.info ? node.info.split(/\s+/) : []
	    , attrs = this.attrs(node);
	  if (info_words.length > 0 && info_words[0].length > 0) {
	      attrs.push(['class', 'language-' + esc(info_words[0], true)]);
	  }
	  this.cr();
	  this.tag('pre');
	  this.tag('code', attrs);
	  this.out(node.literal);
	  this.tag('/code');
	  this.tag('/pre');
	  this.cr();
	}
	
	function thematic_break(node) {
	  var attrs = this.attrs(node);
	  this.cr();
	  this.tag('hr', attrs, true);
	  this.cr();
	}
	
	function block_quote(node, entering) {
	  var attrs = this.attrs(node);
	  if (entering) {
	      this.cr();
	      this.tag('blockquote', attrs);
	      this.cr();
	  } else {
	      this.cr();
	      this.tag('/blockquote');
	      this.cr();
	  }
	}
	
	function list(node, entering) {
	  var tagname = node.listType === 'bullet' ? 'ul' : 'ol'
	    , attrs = this.attrs(node);
	
	  if (entering) {
	      var start = node.listStart;
	      if (start !== null && start !== 1) {
	          attrs.push(['start', start.toString()]);
	      }
	      this.cr();
	      this.tag(tagname, attrs);
	      this.cr();
	  } else {
	      this.cr();
	      this.tag('/' + tagname);
	      this.cr();
	  }
	}
	
	function item(node, entering) {
	  var attrs = this.attrs(node);
	  if (entering) {
	      this.tag('li', attrs);
	  } else {
	      this.tag('/li');
	      this.cr();
	  }
	}
	
	function html_inline(node) {
	  if (this.options.safe) {
	      this.lit('<!-- raw HTML omitted -->');
	  } else {
	      this.lit(node.literal);
	  }
	}
	
	function html_block(node) {
	  this.cr();
	  if (this.options.safe) {
	      this.lit('<!-- raw HTML omitted -->');
	  } else {
	      this.lit(node.literal);
	  }
	  this.cr();
	}
	
	function custom_inline(node, entering) {
	  if (entering && node.onEnter) {
	      this.lit(node.onEnter);
	  } else if (!entering && node.onExit) {
	      this.lit(node.onExit);
	  }
	}
	
	function custom_block(node, entering) {
	  this.cr();
	  if (entering && node.onEnter) {
	      this.lit(node.onEnter);
	  } else if (!entering && node.onExit) {
	      this.lit(node.onExit);
	  }
	  this.cr();
	}
	
	/* Helper methods */
	
	function out(s) {
	  this.lit(esc(s, false));
	}
	
	function attrs (node) {
	  var att = [];
	  if (this.options.sourcepos) {
	      var pos = node.sourcepos;
	      if (pos) {
	          att.push(['data-sourcepos', String(pos[0][0]) + ':' +
	                      String(pos[0][1]) + '-' + String(pos[1][0]) + ':' +
	                      String(pos[1][1])]);
	      }
	  }
	  return att;
	}
	
	// quick browser-compatible inheritance
	HtmlRenderer.prototype = Object.create(Renderer.prototype);
	
	HtmlRenderer.prototype.text = text;
	HtmlRenderer.prototype.html_inline = html_inline;
	HtmlRenderer.prototype.html_block = html_block;
	HtmlRenderer.prototype.softbreak = softbreak;
	HtmlRenderer.prototype.linebreak = linebreak;
	HtmlRenderer.prototype.link = link;
	HtmlRenderer.prototype.image = image;
	HtmlRenderer.prototype.emph = emph;
	HtmlRenderer.prototype.strong = strong;
	HtmlRenderer.prototype.paragraph = paragraph;
	HtmlRenderer.prototype.heading = heading;
	HtmlRenderer.prototype.code = code;
	HtmlRenderer.prototype.code_block = code_block;
	HtmlRenderer.prototype.thematic_break = thematic_break;
	HtmlRenderer.prototype.block_quote = block_quote;
	HtmlRenderer.prototype.list = list;
	HtmlRenderer.prototype.item = item;
	HtmlRenderer.prototype.custom_inline = custom_inline;
	HtmlRenderer.prototype.custom_block = custom_block;
	
	HtmlRenderer.prototype.out = out;
	HtmlRenderer.prototype.tag = tag;
	HtmlRenderer.prototype.attrs = attrs;
	
	module.exports = HtmlRenderer;


/***/ }),
/* 634 */
/***/ (function(module, exports) {

	"use strict";
	
	function Renderer() {}
	
	/**
	 *  Walks the AST and calls member methods for each Node type.
	 *
	 *  @param ast {Node} The root of the abstract syntax tree.
	 */
	function render(ast) {
	  var walker = ast.walker()
	    , event
	    , type;
	
	  this.buffer = '';
	  this.lastOut = '\n';
	
	  while((event = walker.next())) {
	    type = event.node.type;
	    if (this[type]) {
	      this[type](event.node, event.entering);
	    }
	  }
	  return this.buffer;
	}
	
	/**
	 *  Concatenate a literal string to the buffer.
	 *
	 *  @param str {String} The string to concatenate.
	 */
	function lit(str) {
	  this.buffer += str;
	  this.lastOut = str;
	}
	
	function cr() {
	    if (this.lastOut !== '\n') {
	        this.lit('\n');
	    }
	}
	
	/**
	 *  Concatenate a string to the buffer possibly escaping the content.
	 *
	 *  Concrete renderer implementations should override this method.
	 *
	 *  @param str {String} The string to concatenate.
	 */
	function out(str) {
	  this.lit(str);
	}
	
	Renderer.prototype.render = render;
	Renderer.prototype.out = out;
	Renderer.prototype.lit = lit;
	Renderer.prototype.cr  = cr;
	
	module.exports = Renderer;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var escapeXml = __webpack_require__(124).escapeXml;
	
	// Helper function to produce an XML tag.
	var tag = function(name, attrs, selfclosing) {
	    var result = '<' + name;
	    if (attrs && attrs.length > 0) {
	        var i = 0;
	        var attrib;
	        while ((attrib = attrs[i]) !== undefined) {
	            result += ' ' + attrib[0] + '="' + escapeXml(attrib[1]) + '"';
	            i++;
	        }
	    }
	    if (selfclosing) {
	        result += ' /';
	    }
	
	    result += '>';
	    return result;
	};
	
	var reXMLTag = /\<[^>]*\>/;
	
	var toTagName = function(s) {
	    return s.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
	};
	
	var renderNodes = function(block) {
	
	    var attrs;
	    var tagname;
	    var walker = block.walker();
	    var event, node, entering;
	    var buffer = "";
	    var lastOut = "\n";
	    var disableTags = 0;
	    var indentLevel = 0;
	    var indent = '  ';
	    var container;
	    var selfClosing;
	    var nodetype;
	
	    var out = function(s) {
	        if (disableTags > 0) {
	            buffer += s.replace(reXMLTag, '');
	        } else {
	            buffer += s;
	        }
	        lastOut = s;
	    };
	    var esc = this.escape;
	    var cr = function() {
	        if (lastOut !== '\n') {
	            buffer += '\n';
	            lastOut = '\n';
	            for (var i = indentLevel; i > 0; i--) {
	                buffer += indent;
	            }
	        }
	    };
	
	    var options = this.options;
	
	    if (options.time) { console.time("rendering"); }
	
	    buffer += '<?xml version="1.0" encoding="UTF-8"?>\n';
	    buffer += '<!DOCTYPE document SYSTEM "CommonMark.dtd">\n';
	
	    while ((event = walker.next())) {
	        entering = event.entering;
	        node = event.node;
	        nodetype = node.type;
	
	        container = node.isContainer;
	        selfClosing = nodetype === 'thematic_break' || nodetype === 'linebreak' ||
	            nodetype === 'softbreak';
	        tagname = toTagName(nodetype);
	
	        if (entering) {
	
	            attrs = [];
	
	            switch (nodetype) {
	            case 'document':
	                attrs.push(['xmlns', 'http://commonmark.org/xml/1.0']);
	                break;
	            case 'list':
	                if (node.listType !== null) {
	                    attrs.push(['type', node.listType.toLowerCase()]);
	                }
	                if (node.listStart !== null) {
	                    attrs.push(['start', String(node.listStart)]);
	                }
	                if (node.listTight !== null) {
	                    attrs.push(['tight', (node.listTight ? 'true' : 'false')]);
	                }
	                var delim = node.listDelimiter;
	                if (delim !== null) {
	                    var delimword = '';
	                    if (delim === '.') {
	                        delimword = 'period';
	                    } else {
	                        delimword = 'paren';
	                    }
	                    attrs.push(['delimiter', delimword]);
	                }
	                break;
	            case 'code_block':
	                if (node.info) {
	                    attrs.push(['info', node.info]);
	                }
	                break;
	            case 'heading':
	                attrs.push(['level', String(node.level)]);
	                break;
	            case 'link':
	            case 'image':
	                attrs.push(['destination', node.destination]);
	                attrs.push(['title', node.title]);
	                break;
	            case 'custom_inline':
	            case 'custom_block':
	                attrs.push(['on_enter', node.onEnter]);
	                attrs.push(['on_exit', node.onExit]);
	                break;
	            default:
	                break;
	            }
	            if (options.sourcepos) {
	                var pos = node.sourcepos;
	                if (pos) {
	                    attrs.push(['sourcepos', String(pos[0][0]) + ':' +
	                                String(pos[0][1]) + '-' + String(pos[1][0]) + ':' +
	                                String(pos[1][1])]);
	                }
	            }
	
	            cr();
	            out(tag(tagname, attrs, selfClosing));
	            if (container) {
	                indentLevel += 1;
	            } else if (!container && !selfClosing) {
	                var lit = node.literal;
	                if (lit) {
	                    out(esc(lit));
	                }
	                out(tag('/' + tagname));
	            }
	        } else {
	            indentLevel -= 1;
	            cr();
	            out(tag('/' + tagname));
	        }
	
	
	    }
	    if (options.time) { console.timeEnd("rendering"); }
	    buffer += '\n';
	    return buffer;
	};
	
	// The XmlRenderer object.
	function XmlRenderer(options){
	    return {
	        // default options:
	        softbreak: '\n', // by default, soft breaks are rendered as newlines in HTML
	        // set to "<br />" to make them hard breaks
	        // set to " " if you want to ignore line wrapping in source
	        escape: escapeXml,
	        options: options || {},
	        render: renderNodes
	    };
	}
	
	module.exports = XmlRenderer;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(717);
	module.exports = __webpack_require__(80).RegExp.escape;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154);
	__webpack_require__(685);
	module.exports = __webpack_require__(21).Array.from;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(186);
	__webpack_require__(154);
	module.exports = __webpack_require__(683);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(186);
	__webpack_require__(154);
	module.exports = __webpack_require__(684);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(21)
	  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(687);
	module.exports = __webpack_require__(21).Number.isInteger;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(688);
	module.exports = 0x1fffffffffffff;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(689);
	module.exports = __webpack_require__(21).Object.assign;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(690);
	var $Object = __webpack_require__(21).Object;
	module.exports = function create(P, D){
	  return $Object.create(P, D);
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(691);
	var $Object = __webpack_require__(21).Object;
	module.exports = function defineProperties(T, D){
	  return $Object.defineProperties(T, D);
	};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(692);
	var $Object = __webpack_require__(21).Object;
	module.exports = function defineProperty(it, key, desc){
	  return $Object.defineProperty(it, key, desc);
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(693);
	module.exports = __webpack_require__(21).Object.freeze;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(694);
	var $Object = __webpack_require__(21).Object;
	module.exports = function getOwnPropertyDescriptor(it, key){
	  return $Object.getOwnPropertyDescriptor(it, key);
	};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(695);
	var $Object = __webpack_require__(21).Object;
	module.exports = function getOwnPropertyNames(it){
	  return $Object.getOwnPropertyNames(it);
	};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(696);
	module.exports = __webpack_require__(21).Object.getPrototypeOf;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(697);
	module.exports = __webpack_require__(21).Object.isExtensible;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(698);
	module.exports = __webpack_require__(21).Object.isFrozen;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(699);
	module.exports = __webpack_require__(21).Object.isSealed;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(700);
	module.exports = __webpack_require__(21).Object.keys;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(701);
	module.exports = __webpack_require__(21).Object.preventExtensions;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(702);
	module.exports = __webpack_require__(21).Object.seal;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(703);
	module.exports = __webpack_require__(21).Object.setPrototypeOf;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(706);
	module.exports = __webpack_require__(21).Object.values;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(392);
	__webpack_require__(154);
	__webpack_require__(186);
	__webpack_require__(704);
	module.exports = __webpack_require__(21).Promise;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(705);
	__webpack_require__(392);
	__webpack_require__(707);
	__webpack_require__(708);
	module.exports = __webpack_require__(21).Symbol;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154);
	__webpack_require__(186);
	module.exports = __webpack_require__(256).f('iterator');

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(79)
	  , toLength  = __webpack_require__(253)
	  , toIndex   = __webpack_require__(682);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(78)
	  , createDesc      = __webpack_require__(152);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(100)
	  , gOPS    = __webpack_require__(249)
	  , pIE     = __webpack_require__(151);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(125)
	  , call        = __webpack_require__(382)
	  , isArrayIter = __webpack_require__(381)
	  , anObject    = __webpack_require__(76)
	  , toLength    = __webpack_require__(253)
	  , getIterFn   = __webpack_require__(257)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(150);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(46)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(247)
	  , descriptor     = __webpack_require__(152)
	  , setToStringTag = __webpack_require__(184)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(99)(IteratorPrototype, __webpack_require__(39)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(100)
	  , toIObject = __webpack_require__(79);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(53)
	  , macrotask = __webpack_require__(391).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(150)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(100)
	  , gOPS     = __webpack_require__(249)
	  , pIE      = __webpack_require__(151)
	  , toObject = __webpack_require__(153)
	  , IObject  = __webpack_require__(380)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(126)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(100)
	  , toIObject = __webpack_require__(79)
	  , isEnum    = __webpack_require__(151).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(99);
	module.exports = function(target, src, safe){
	  for(var key in src){
	    if(safe && target[key])target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(46)
	  , anObject = __webpack_require__(76);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(125)(Function.call, __webpack_require__(248).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(53)
	  , core        = __webpack_require__(21)
	  , dP          = __webpack_require__(78)
	  , DESCRIPTORS = __webpack_require__(77)
	  , SPECIES     = __webpack_require__(39)('species');
	
	module.exports = function(KEY){
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(76)
	  , aFunction = __webpack_require__(242)
	  , SPECIES   = __webpack_require__(39)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(252)
	  , defined   = __webpack_require__(244);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(252)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(76)
	  , get      = __webpack_require__(257);
	module.exports = __webpack_require__(21).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(243)
	  , ITERATOR  = __webpack_require__(39)('iterator')
	  , Iterators = __webpack_require__(127);
	module.exports = __webpack_require__(21).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(125)
	  , $export        = __webpack_require__(45)
	  , toObject       = __webpack_require__(153)
	  , call           = __webpack_require__(382)
	  , isArrayIter    = __webpack_require__(381)
	  , toLength       = __webpack_require__(253)
	  , createProperty = __webpack_require__(665)
	  , getIterFn      = __webpack_require__(257);
	
	$export($export.S + $export.F * !__webpack_require__(384)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(662)
	  , step             = __webpack_require__(672)
	  , Iterators        = __webpack_require__(127)
	  , toIObject        = __webpack_require__(79);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(383)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(45);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(670)});

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(45);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(45);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(675)});

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(45)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(247)});

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(45);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(77), 'Object', {defineProperties: __webpack_require__(385)});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(45);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(77), 'Object', {defineProperty: __webpack_require__(78).f});

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(46)
	  , meta     = __webpack_require__(183).onFreeze;
	
	__webpack_require__(66)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(79)
	  , $getOwnPropertyDescriptor = __webpack_require__(248).f;
	
	__webpack_require__(66)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(66)('getOwnPropertyNames', function(){
	  return __webpack_require__(386).f;
	});

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(153)
	  , $getPrototypeOf = __webpack_require__(388);
	
	__webpack_require__(66)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(46);
	
	__webpack_require__(66)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(46);
	
	__webpack_require__(66)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(46);
	
	__webpack_require__(66)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(153)
	  , $keys    = __webpack_require__(100);
	
	__webpack_require__(66)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(46)
	  , meta     = __webpack_require__(183).onFreeze;
	
	__webpack_require__(66)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(46)
	  , meta     = __webpack_require__(183).onFreeze;
	
	__webpack_require__(66)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(45);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(678).set});

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(182)
	  , global             = __webpack_require__(53)
	  , ctx                = __webpack_require__(125)
	  , classof            = __webpack_require__(243)
	  , $export            = __webpack_require__(45)
	  , isObject           = __webpack_require__(46)
	  , aFunction          = __webpack_require__(242)
	  , anInstance         = __webpack_require__(663)
	  , forOf              = __webpack_require__(667)
	  , speciesConstructor = __webpack_require__(680)
	  , task               = __webpack_require__(391).set
	  , microtask          = __webpack_require__(674)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(39)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(677)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(184)($Promise, PROMISE);
	__webpack_require__(679)(PROMISE);
	Wrapper = __webpack_require__(21)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(384)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(53)
	  , has            = __webpack_require__(98)
	  , DESCRIPTORS    = __webpack_require__(77)
	  , $export        = __webpack_require__(45)
	  , redefine       = __webpack_require__(390)
	  , META           = __webpack_require__(183).KEY
	  , $fails         = __webpack_require__(126)
	  , shared         = __webpack_require__(251)
	  , setToStringTag = __webpack_require__(184)
	  , uid            = __webpack_require__(185)
	  , wks            = __webpack_require__(39)
	  , wksExt         = __webpack_require__(256)
	  , wksDefine      = __webpack_require__(255)
	  , keyOf          = __webpack_require__(673)
	  , enumKeys       = __webpack_require__(666)
	  , isArray        = __webpack_require__(669)
	  , anObject       = __webpack_require__(76)
	  , toIObject      = __webpack_require__(79)
	  , toPrimitive    = __webpack_require__(254)
	  , createDesc     = __webpack_require__(152)
	  , _create        = __webpack_require__(247)
	  , gOPNExt        = __webpack_require__(386)
	  , $GOPD          = __webpack_require__(248)
	  , $DP            = __webpack_require__(78)
	  , $keys          = __webpack_require__(100)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(387).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(151).f  = $propertyIsEnumerable;
	  __webpack_require__(249).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(182)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(99)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(45)
	  , $values = __webpack_require__(676)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(255)('asyncIterator');

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(255)('observable');

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25)
	  , isArray  = __webpack_require__(266)
	  , SPECIES  = __webpack_require__(29)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(709);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(11)
	  , toPrimitive = __webpack_require__(69)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(105)
	  , gOPS    = __webpack_require__(195)
	  , pIE     = __webpack_require__(157);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(105)
	  , toIObject = __webpack_require__(51);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(715)
	  , invoke    = __webpack_require__(191)
	  , aFunction = __webpack_require__(47);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(13);

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3)
	  , $re     = __webpack_require__(716)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(394)});
	
	__webpack_require__(128)('copyWithin');

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $every  = __webpack_require__(67)(4);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {fill: __webpack_require__(258)});
	
	__webpack_require__(128)('fill');

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $filter = __webpack_require__(67)(2);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(67)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(128)(KEY);

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(67)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(128)(KEY);

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(3)
	  , $forEach = __webpack_require__(67)(0)
	  , STRICT   = __webpack_require__(62)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(81)
	  , $export        = __webpack_require__(3)
	  , toObject       = __webpack_require__(36)
	  , call           = __webpack_require__(403)
	  , isArrayIter    = __webpack_require__(265)
	  , toLength       = __webpack_require__(35)
	  , createProperty = __webpack_require__(259)
	  , getIterFn      = __webpack_require__(282);
	
	$export($export.S + $export.F * !__webpack_require__(193)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , $indexOf      = __webpack_require__(187)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(62)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(266)});

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(51)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(156) != Object || !__webpack_require__(62)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , toIObject     = __webpack_require__(51)
	  , toInteger     = __webpack_require__(91)
	  , toLength      = __webpack_require__(35)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(62)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $map    = __webpack_require__(67)(1);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(3)
	  , createProperty = __webpack_require__(259);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(17)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(396);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(396);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(3)
	  , html       = __webpack_require__(263)
	  , cof        = __webpack_require__(60)
	  , toIndex    = __webpack_require__(108)
	  , toLength   = __webpack_require__(35)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(17)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $some   = __webpack_require__(67)(3);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(47)
	  , toObject  = __webpack_require__(36)
	  , fails     = __webpack_require__(17)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(62)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Array');

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(17)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(3)
	  , toObject    = __webpack_require__(36)
	  , toPrimitive = __webpack_require__(69);
	
	$export($export.P + $export.F * __webpack_require__(17)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(29)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(48)(proto, TO_PRIMITIVE, __webpack_require__(711));

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(49)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', {bind: __webpack_require__(397)});

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(25)
	  , getPrototypeOf = __webpack_require__(55)
	  , HAS_INSTANCE   = __webpack_require__(29)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(32).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(32).f
	  , createDesc = __webpack_require__(90)
	  , has        = __webpack_require__(40)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(31) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3)
	  , log1p   = __webpack_require__(405)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3)
	  , sign    = __webpack_require__(270);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3)
	  , $expm1  = __webpack_require__(269);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(3)
	  , sign      = __webpack_require__(270)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(17)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(405)});

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {sign: __webpack_require__(270)});

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(269)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(17)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(269)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(13)
	  , has               = __webpack_require__(40)
	  , cof               = __webpack_require__(60)
	  , inheritIfRequired = __webpack_require__(264)
	  , toPrimitive       = __webpack_require__(69)
	  , fails             = __webpack_require__(17)
	  , gOPN              = __webpack_require__(104).f
	  , gOPD              = __webpack_require__(54).f
	  , dP                = __webpack_require__(32).f
	  , $trim             = __webpack_require__(132).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(103)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(31) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(49)(global, NUMBER, $Number);
	}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(3)
	  , _isFinite = __webpack_require__(13).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(402)});

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(3)
	  , isInteger = __webpack_require__(402)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(412);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(413);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , toInteger    = __webpack_require__(91)
	  , aNumberValue = __webpack_require__(393)
	  , repeat       = __webpack_require__(277)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(17)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $fails       = __webpack_require__(17)
	  , aNumberValue = __webpack_require__(393)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(406)});

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(103)});

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(31), 'Object', {defineProperties: __webpack_require__(407)});

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(31), 'Object', {defineProperty: __webpack_require__(32).f});

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(25)
	  , meta     = __webpack_require__(89).onFreeze;
	
	__webpack_require__(68)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(51)
	  , $getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	__webpack_require__(68)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(68)('getOwnPropertyNames', function(){
	  return __webpack_require__(408).f;
	});

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(36)
	  , $getPrototypeOf = __webpack_require__(55);
	
	__webpack_require__(68)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(68)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(68)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(68)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {is: __webpack_require__(414)});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(36)
	  , $keys    = __webpack_require__(105);
	
	__webpack_require__(68)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(25)
	  , meta     = __webpack_require__(89).onFreeze;
	
	__webpack_require__(68)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(25)
	  , meta     = __webpack_require__(89).onFreeze;
	
	__webpack_require__(68)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(272).set});

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(155)
	  , test    = {};
	test[__webpack_require__(29)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(49)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(412);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(413);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(102)
	  , global             = __webpack_require__(13)
	  , ctx                = __webpack_require__(81)
	  , classof            = __webpack_require__(155)
	  , $export            = __webpack_require__(3)
	  , isObject           = __webpack_require__(25)
	  , aFunction          = __webpack_require__(47)
	  , anInstance         = __webpack_require__(101)
	  , forOf              = __webpack_require__(129)
	  , speciesConstructor = __webpack_require__(274)
	  , task               = __webpack_require__(279).set
	  , microtask          = __webpack_require__(271)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(29)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(106)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(131)($Promise, PROMISE);
	__webpack_require__(107)(PROMISE);
	Wrapper = __webpack_require__(80)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(193)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(47)
	  , anObject  = __webpack_require__(11)
	  , rApply    = (__webpack_require__(13).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(17)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(3)
	  , create     = __webpack_require__(103)
	  , aFunction  = __webpack_require__(47)
	  , anObject   = __webpack_require__(11)
	  , isObject   = __webpack_require__(25)
	  , fails      = __webpack_require__(17)
	  , bind       = __webpack_require__(397)
	  , rConstruct = (__webpack_require__(13).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(32)
	  , $export     = __webpack_require__(3)
	  , anObject    = __webpack_require__(11)
	  , toPrimitive = __webpack_require__(69);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(17)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(3)
	  , gOPD     = __webpack_require__(54).f
	  , anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(11);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(267)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(54)
	  , $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(3)
	  , getProto = __webpack_require__(55)
	  , anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(54)
	  , getPrototypeOf = __webpack_require__(55)
	  , has            = __webpack_require__(40)
	  , $export        = __webpack_require__(3)
	  , isObject       = __webpack_require__(25)
	  , anObject       = __webpack_require__(11);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(3)
	  , anObject      = __webpack_require__(11)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(411)});

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(3)
	  , anObject           = __webpack_require__(11)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(3)
	  , setProto = __webpack_require__(272);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(32)
	  , gOPD           = __webpack_require__(54)
	  , getPrototypeOf = __webpack_require__(55)
	  , has            = __webpack_require__(40)
	  , $export        = __webpack_require__(3)
	  , createDesc     = __webpack_require__(90)
	  , anObject       = __webpack_require__(11)
	  , isObject       = __webpack_require__(25);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(13)
	  , inheritIfRequired = __webpack_require__(264)
	  , dP                = __webpack_require__(32).f
	  , gOPN              = __webpack_require__(104).f
	  , isRegExp          = __webpack_require__(192)
	  , $flags            = __webpack_require__(190)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(31) && (!CORRECT_NEW || __webpack_require__(17)(function(){
	  re2[__webpack_require__(29)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(49)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(107)('RegExp');

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(189)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(189)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(189)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(189)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(192)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(418);
	var anObject    = __webpack_require__(11)
	  , $flags      = __webpack_require__(190)
	  , DESCRIPTORS = __webpack_require__(31)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(49)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(17)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(50)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(50)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(50)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(50)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(275)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(3)
	  , toLength  = __webpack_require__(35)
	  , context   = __webpack_require__(276)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(262)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(50)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(50)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(50)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(3)
	  , toIndex        = __webpack_require__(108)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(3)
	  , context  = __webpack_require__(276)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(262)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(50)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(275)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(268)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(50)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(51)
	  , toLength  = __webpack_require__(35);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(277)
	});

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(50)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(3)
	  , toLength    = __webpack_require__(35)
	  , context     = __webpack_require__(276)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(262)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(50)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(50)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(50)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(132)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(13)
	  , has            = __webpack_require__(40)
	  , DESCRIPTORS    = __webpack_require__(31)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(49)
	  , META           = __webpack_require__(89).KEY
	  , $fails         = __webpack_require__(17)
	  , shared         = __webpack_require__(196)
	  , setToStringTag = __webpack_require__(131)
	  , uid            = __webpack_require__(109)
	  , wks            = __webpack_require__(29)
	  , wksExt         = __webpack_require__(416)
	  , wksDefine      = __webpack_require__(281)
	  , keyOf          = __webpack_require__(713)
	  , enumKeys       = __webpack_require__(712)
	  , isArray        = __webpack_require__(266)
	  , anObject       = __webpack_require__(11)
	  , toIObject      = __webpack_require__(51)
	  , toPrimitive    = __webpack_require__(69)
	  , createDesc     = __webpack_require__(90)
	  , _create        = __webpack_require__(103)
	  , gOPNExt        = __webpack_require__(408)
	  , $GOPD          = __webpack_require__(54)
	  , $DP            = __webpack_require__(32)
	  , $keys          = __webpack_require__(105)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(104).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(157).f  = $propertyIsEnumerable;
	  __webpack_require__(195).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(102)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(48)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $typed       = __webpack_require__(197)
	  , buffer       = __webpack_require__(280)
	  , anObject     = __webpack_require__(11)
	  , toIndex      = __webpack_require__(108)
	  , toLength     = __webpack_require__(35)
	  , isObject     = __webpack_require__(25)
	  , ArrayBuffer  = __webpack_require__(13).ArrayBuffer
	  , speciesConstructor = __webpack_require__(274)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(17)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(107)(ARRAY_BUFFER);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(197).ABV, {
	  DataView: __webpack_require__(280).DataView
	});

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(400);
	
	// 23.4 WeakSet Objects
	__webpack_require__(188)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(3)
	  , $includes = __webpack_require__(187)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(128)('includes');

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(3)
	  , microtask = __webpack_require__(271)()
	  , process   = __webpack_require__(13).process
	  , isNode    = __webpack_require__(60)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3)
	  , cof     = __webpack_require__(60);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(399)('Map')});

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(36)
	  , aFunction       = __webpack_require__(47)
	  , $defineProperty = __webpack_require__(32);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(31) && $export($export.P + __webpack_require__(194), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(36)
	  , aFunction       = __webpack_require__(47)
	  , $defineProperty = __webpack_require__(32);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(31) && $export($export.P + __webpack_require__(194), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(3)
	  , $entries = __webpack_require__(410)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(3)
	  , ownKeys        = __webpack_require__(411)
	  , toIObject      = __webpack_require__(51)
	  , gOPD           = __webpack_require__(54)
	  , createProperty = __webpack_require__(259);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(36)
	  , toPrimitive              = __webpack_require__(69)
	  , getPrototypeOf           = __webpack_require__(55)
	  , getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(31) && $export($export.P + __webpack_require__(194), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(36)
	  , toPrimitive              = __webpack_require__(69)
	  , getPrototypeOf           = __webpack_require__(55)
	  , getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(31) && $export($export.P + __webpack_require__(194), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3)
	  , $values = __webpack_require__(410)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(3)
	  , global      = __webpack_require__(13)
	  , core        = __webpack_require__(80)
	  , microtask   = __webpack_require__(271)()
	  , OBSERVABLE  = __webpack_require__(29)('observable')
	  , aFunction   = __webpack_require__(47)
	  , anObject    = __webpack_require__(11)
	  , anInstance  = __webpack_require__(101)
	  , redefineAll = __webpack_require__(106)
	  , hide        = __webpack_require__(48)
	  , forOf       = __webpack_require__(129)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(107)('Observable');

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(82)
	  , anObject                  = __webpack_require__(11)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(82)
	  , anObject               = __webpack_require__(11)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(419)
	  , from                    = __webpack_require__(395)
	  , metadata                = __webpack_require__(82)
	  , anObject                = __webpack_require__(11)
	  , getPrototypeOf          = __webpack_require__(55)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(82)
	  , anObject               = __webpack_require__(11)
	  , getPrototypeOf         = __webpack_require__(55)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(82)
	  , anObject                = __webpack_require__(11)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(82)
	  , anObject               = __webpack_require__(11)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(82)
	  , anObject               = __webpack_require__(11)
	  , getPrototypeOf         = __webpack_require__(55)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(82)
	  , anObject               = __webpack_require__(11)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(82)
	  , anObject                  = __webpack_require__(11)
	  , aFunction                 = __webpack_require__(47)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(399)('Set')});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(275)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(3)
	  , defined     = __webpack_require__(61)
	  , toLength    = __webpack_require__(35)
	  , isRegExp    = __webpack_require__(192)
	  , getFlags    = __webpack_require__(190)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(267)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(415);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(415);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(132)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(132)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(281)('asyncIterator');

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(281)('observable');

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', {global: __webpack_require__(13)});

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(283)
	  , redefine      = __webpack_require__(49)
	  , global        = __webpack_require__(13)
	  , hide          = __webpack_require__(48)
	  , Iterators     = __webpack_require__(130)
	  , wks           = __webpack_require__(29)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , $task   = __webpack_require__(279);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(13)
	  , $export    = __webpack_require__(3)
	  , invoke     = __webpack_require__(191)
	  , partial    = __webpack_require__(714)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(837);
	__webpack_require__(776);
	__webpack_require__(778);
	__webpack_require__(777);
	__webpack_require__(780);
	__webpack_require__(782);
	__webpack_require__(787);
	__webpack_require__(781);
	__webpack_require__(779);
	__webpack_require__(789);
	__webpack_require__(788);
	__webpack_require__(784);
	__webpack_require__(785);
	__webpack_require__(783);
	__webpack_require__(775);
	__webpack_require__(786);
	__webpack_require__(790);
	__webpack_require__(791);
	__webpack_require__(743);
	__webpack_require__(745);
	__webpack_require__(744);
	__webpack_require__(793);
	__webpack_require__(792);
	__webpack_require__(763);
	__webpack_require__(773);
	__webpack_require__(774);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(769);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(824);
	__webpack_require__(829);
	__webpack_require__(836);
	__webpack_require__(827);
	__webpack_require__(819);
	__webpack_require__(820);
	__webpack_require__(825);
	__webpack_require__(830);
	__webpack_require__(832);
	__webpack_require__(815);
	__webpack_require__(816);
	__webpack_require__(817);
	__webpack_require__(818);
	__webpack_require__(821);
	__webpack_require__(822);
	__webpack_require__(823);
	__webpack_require__(826);
	__webpack_require__(828);
	__webpack_require__(831);
	__webpack_require__(833);
	__webpack_require__(834);
	__webpack_require__(835);
	__webpack_require__(738);
	__webpack_require__(740);
	__webpack_require__(739);
	__webpack_require__(742);
	__webpack_require__(741);
	__webpack_require__(727);
	__webpack_require__(725);
	__webpack_require__(731);
	__webpack_require__(728);
	__webpack_require__(734);
	__webpack_require__(736);
	__webpack_require__(724);
	__webpack_require__(730);
	__webpack_require__(721);
	__webpack_require__(735);
	__webpack_require__(719);
	__webpack_require__(733);
	__webpack_require__(732);
	__webpack_require__(726);
	__webpack_require__(729);
	__webpack_require__(718);
	__webpack_require__(720);
	__webpack_require__(723);
	__webpack_require__(722);
	__webpack_require__(737);
	__webpack_require__(283);
	__webpack_require__(809);
	__webpack_require__(814);
	__webpack_require__(418);
	__webpack_require__(810);
	__webpack_require__(811);
	__webpack_require__(812);
	__webpack_require__(813);
	__webpack_require__(794);
	__webpack_require__(417);
	__webpack_require__(419);
	__webpack_require__(420);
	__webpack_require__(849);
	__webpack_require__(838);
	__webpack_require__(839);
	__webpack_require__(844);
	__webpack_require__(847);
	__webpack_require__(848);
	__webpack_require__(842);
	__webpack_require__(845);
	__webpack_require__(843);
	__webpack_require__(846);
	__webpack_require__(840);
	__webpack_require__(841);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(798);
	__webpack_require__(799);
	__webpack_require__(802);
	__webpack_require__(800);
	__webpack_require__(801);
	__webpack_require__(803);
	__webpack_require__(804);
	__webpack_require__(805);
	__webpack_require__(806);
	__webpack_require__(808);
	__webpack_require__(807);
	__webpack_require__(850);
	__webpack_require__(876);
	__webpack_require__(879);
	__webpack_require__(878);
	__webpack_require__(880);
	__webpack_require__(881);
	__webpack_require__(877);
	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(861);
	__webpack_require__(864);
	__webpack_require__(860);
	__webpack_require__(858);
	__webpack_require__(859);
	__webpack_require__(862);
	__webpack_require__(863);
	__webpack_require__(853);
	__webpack_require__(875);
	__webpack_require__(884);
	__webpack_require__(852);
	__webpack_require__(854);
	__webpack_require__(856);
	__webpack_require__(855);
	__webpack_require__(857);
	__webpack_require__(866);
	__webpack_require__(867);
	__webpack_require__(869);
	__webpack_require__(868);
	__webpack_require__(871);
	__webpack_require__(870);
	__webpack_require__(872);
	__webpack_require__(873);
	__webpack_require__(874);
	__webpack_require__(851);
	__webpack_require__(865);
	__webpack_require__(887);
	__webpack_require__(886);
	__webpack_require__(885);
	module.exports = __webpack_require__(80);

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(284);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	/**
	 * Represents a group of disposable resources that are disposed together.
	 */
	
	var CompositeDisposable = (function () {
	  function CompositeDisposable() {
	    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompositeDisposable);
	
	    if (Array.isArray(disposables[0]) && disposables.length === 1) {
	      disposables = disposables[0];
	    }
	
	    for (var i = 0; i < disposables.length; i++) {
	      if (!_isDisposable2['default'](disposables[i])) {
	        throw new Error('Expected a disposable');
	      }
	    }
	
	    this.disposables = disposables;
	    this.isDisposed = false;
	  }
	
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Disposable} item Disposable to add.
	   */
	
	  CompositeDisposable.prototype.add = function add(item) {
	    if (this.isDisposed) {
	      item.dispose();
	    } else {
	      this.disposables.push(item);
	    }
	  };
	
	  /**
	   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	   * @param {Disposable} item Disposable to remove.
	   * @returns {Boolean} true if found; false otherwise.
	   */
	
	  CompositeDisposable.prototype.remove = function remove(item) {
	    if (this.isDisposed) {
	      return false;
	    }
	
	    var index = this.disposables.indexOf(item);
	    if (index === -1) {
	      return false;
	    }
	
	    this.disposables.splice(index, 1);
	    item.dispose();
	    return true;
	  };
	
	  /**
	   * Disposes all disposables in the group and removes them from the group.
	   */
	
	  CompositeDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    var len = this.disposables.length;
	    var currentDisposables = new Array(len);
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i] = this.disposables[i];
	    }
	
	    this.isDisposed = true;
	    this.disposables = [];
	    this.length = 0;
	
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i].dispose();
	    }
	  };
	
	  return CompositeDisposable;
	})();
	
	exports['default'] = CompositeDisposable;
	module.exports = exports['default'];

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	"use strict";
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.__esModule = true;
	var noop = function noop() {};
	
	/**
	 * The basic disposable.
	 */
	
	var Disposable = (function () {
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = action || noop;
	  }
	
	  Disposable.prototype.dispose = function dispose() {
	    if (!this.isDisposed) {
	      this.action.call(null);
	      this.isDisposed = true;
	    }
	  };
	
	  _createClass(Disposable, null, [{
	    key: "empty",
	    enumerable: true,
	    value: { dispose: noop }
	  }]);
	
	  return Disposable;
	})();
	
	exports["default"] = Disposable;
	module.exports = exports["default"];

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(284);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	var SerialDisposable = (function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	    this.current = null;
	  }
	
	  /**
	   * Gets the underlying disposable.
	   * @return The underlying disposable.
	   */
	
	  SerialDisposable.prototype.getDisposable = function getDisposable() {
	    return this.current;
	  };
	
	  /**
	   * Sets the underlying disposable.
	   * @param {Disposable} value The new underlying disposable.
	   */
	
	  SerialDisposable.prototype.setDisposable = function setDisposable() {
	    var value = arguments[0] === undefined ? null : arguments[0];
	
	    if (value != null && !_isDisposable2['default'](value)) {
	      throw new Error('Expected either an empty value or a valid disposable');
	    }
	
	    var isDisposed = this.isDisposed;
	    var previous = undefined;
	
	    if (!isDisposed) {
	      previous = this.current;
	      this.current = value;
	    }
	
	    if (previous) {
	      previous.dispose();
	    }
	
	    if (isDisposed && value) {
	      value.dispose();
	    }
	  };
	
	  /**
	   * Disposes the underlying disposable as well as all future replacements.
	   */
	
	  SerialDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    this.isDisposed = true;
	    var previous = this.current;
	    this.current = null;
	
	    if (previous) {
	      previous.dispose();
	    }
	  };
	
	  return SerialDisposable;
	})();
	
	exports['default'] = SerialDisposable;
	module.exports = exports['default'];

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	exports.__esModule = true;
	
	var _isDisposable2 = __webpack_require__(284);
	
	var _isDisposable3 = _interopRequireWildcard(_isDisposable2);
	
	exports.isDisposable = _isDisposable3['default'];
	
	var _Disposable2 = __webpack_require__(890);
	
	var _Disposable3 = _interopRequireWildcard(_Disposable2);
	
	exports.Disposable = _Disposable3['default'];
	
	var _CompositeDisposable2 = __webpack_require__(889);
	
	var _CompositeDisposable3 = _interopRequireWildcard(_CompositeDisposable2);
	
	exports.CompositeDisposable = _CompositeDisposable3['default'];
	
	var _SerialDisposable2 = __webpack_require__(891);
	
	var _SerialDisposable3 = _interopRequireWildcard(_SerialDisposable2);
	
	exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createStore = __webpack_require__(1522);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _reducers = __webpack_require__(901);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _dragDrop = __webpack_require__(198);
	
	var dragDropActions = _interopRequireWildcard(_dragDrop);
	
	var _DragDropMonitor = __webpack_require__(894);
	
	var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropManager = function () {
	  function DragDropManager(createBackend) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, DragDropManager);
	
	    var store = (0, _createStore2.default)(_reducers2.default);
	    this.context = context;
	    this.store = store;
	    this.monitor = new _DragDropMonitor2.default(store);
	    this.registry = this.monitor.registry;
	    this.backend = createBackend(this);
	
	    store.subscribe(this.handleRefCountChange.bind(this));
	  }
	
	  _createClass(DragDropManager, [{
	    key: 'handleRefCountChange',
	    value: function handleRefCountChange() {
	      var shouldSetUp = this.store.getState().refCount > 0;
	      if (shouldSetUp && !this.isSetUp) {
	        this.backend.setup();
	        this.isSetUp = true;
	      } else if (!shouldSetUp && this.isSetUp) {
	        this.backend.teardown();
	        this.isSetUp = false;
	      }
	    }
	  }, {
	    key: 'getContext',
	    value: function getContext() {
	      return this.context;
	    }
	  }, {
	    key: 'getMonitor',
	    value: function getMonitor() {
	      return this.monitor;
	    }
	  }, {
	    key: 'getBackend',
	    value: function getBackend() {
	      return this.backend;
	    }
	  }, {
	    key: 'getRegistry',
	    value: function getRegistry() {
	      return this.registry;
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions() {
	      var manager = this;
	      var dispatch = this.store.dispatch;
	
	
	      function bindActionCreator(actionCreator) {
	        return function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var action = actionCreator.apply(manager, args);
	          if (typeof action !== 'undefined') {
	            dispatch(action);
	          }
	        };
	      }
	
	      return Object.keys(dragDropActions).filter(function (key) {
	        return typeof dragDropActions[key] === 'function';
	      }).reduce(function (boundActions, key) {
	        var action = dragDropActions[key];
	        boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
	        return boundActions;
	      }, {});
	    }
	  }]);
	
	  return DragDropManager;
	}();
	
	exports.default = DragDropManager;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(37);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _matchesType = __webpack_require__(423);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	var _HandlerRegistry = __webpack_require__(897);
	
	var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
	var _dragOffset = __webpack_require__(422);
	
	var _dirtyHandlerIds = __webpack_require__(421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropMonitor = function () {
	  function DragDropMonitor(store) {
	    _classCallCheck(this, DragDropMonitor);
	
	    this.store = store;
	    this.registry = new _HandlerRegistry2.default(store);
	  }
	
	  _createClass(DragDropMonitor, [{
	    key: 'subscribeToStateChange',
	    value: function subscribeToStateChange(listener) {
	      var _this = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handlerIds = options.handlerIds;
	
	      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	      (0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
	      var prevStateId = this.store.getState().stateId;
	      var handleChange = function handleChange() {
	        var state = _this.store.getState();
	        var currentStateId = state.stateId;
	        try {
	          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
	
	          if (!canSkipListener) {
	            listener();
	          }
	        } finally {
	          prevStateId = currentStateId;
	        }
	      };
	
	      return this.store.subscribe(handleChange);
	    }
	  }, {
	    key: 'subscribeToOffsetChange',
	    value: function subscribeToOffsetChange(listener) {
	      var _this2 = this;
	
	      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	
	      var previousState = this.store.getState().dragOffset;
	      var handleChange = function handleChange() {
	        var nextState = _this2.store.getState().dragOffset;
	        if (nextState === previousState) {
	          return;
	        }
	
	        previousState = nextState;
	        listener();
	      };
	
	      return this.store.subscribe(handleChange);
	    }
	  }, {
	    key: 'canDragSource',
	    value: function canDragSource(sourceId) {
	      var source = this.registry.getSource(sourceId);
	      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
	      if (this.isDragging()) {
	        return false;
	      }
	
	      return source.canDrag(this, sourceId);
	    }
	  }, {
	    key: 'canDropOnTarget',
	    value: function canDropOnTarget(targetId) {
	      var target = this.registry.getTarget(targetId);
	      (0, _invariant2.default)(target, 'Expected to find a valid target.');
	
	      if (!this.isDragging() || this.didDrop()) {
	        return false;
	      }
	
	      var targetType = this.registry.getTargetType(targetId);
	      var draggedItemType = this.getItemType();
	      return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
	    }
	  }, {
	    key: 'isDragging',
	    value: function isDragging() {
	      return Boolean(this.getItemType());
	    }
	  }, {
	    key: 'isDraggingSource',
	    value: function isDraggingSource(sourceId) {
	      var source = this.registry.getSource(sourceId, true);
	      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
	      if (!this.isDragging() || !this.isSourcePublic()) {
	        return false;
	      }
	
	      var sourceType = this.registry.getSourceType(sourceId);
	      var draggedItemType = this.getItemType();
	      if (sourceType !== draggedItemType) {
	        return false;
	      }
	
	      return source.isDragging(this, sourceId);
	    }
	  }, {
	    key: 'isOverTarget',
	    value: function isOverTarget(targetId) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
	      var shallow = options.shallow;
	
	      if (!this.isDragging()) {
	        return false;
	      }
	
	      var targetType = this.registry.getTargetType(targetId);
	      var draggedItemType = this.getItemType();
	      if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
	        return false;
	      }
	
	      var targetIds = this.getTargetIds();
	      if (!targetIds.length) {
	        return false;
	      }
	
	      var index = targetIds.indexOf(targetId);
	      if (shallow) {
	        return index === targetIds.length - 1;
	      } else {
	        return index > -1;
	      }
	    }
	  }, {
	    key: 'getItemType',
	    value: function getItemType() {
	      return this.store.getState().dragOperation.itemType;
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      return this.store.getState().dragOperation.item;
	    }
	  }, {
	    key: 'getSourceId',
	    value: function getSourceId() {
	      return this.store.getState().dragOperation.sourceId;
	    }
	  }, {
	    key: 'getTargetIds',
	    value: function getTargetIds() {
	      return this.store.getState().dragOperation.targetIds;
	    }
	  }, {
	    key: 'getDropResult',
	    value: function getDropResult() {
	      return this.store.getState().dragOperation.dropResult;
	    }
	  }, {
	    key: 'didDrop',
	    value: function didDrop() {
	      return this.store.getState().dragOperation.didDrop;
	    }
	  }, {
	    key: 'isSourcePublic',
	    value: function isSourcePublic() {
	      return this.store.getState().dragOperation.isSourcePublic;
	    }
	  }, {
	    key: 'getInitialClientOffset',
	    value: function getInitialClientOffset() {
	      return this.store.getState().dragOffset.initialClientOffset;
	    }
	  }, {
	    key: 'getInitialSourceClientOffset',
	    value: function getInitialSourceClientOffset() {
	      return this.store.getState().dragOffset.initialSourceClientOffset;
	    }
	  }, {
	    key: 'getClientOffset',
	    value: function getClientOffset() {
	      return this.store.getState().dragOffset.clientOffset;
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset() {
	      return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
	    }
	  }, {
	    key: 'getDifferenceFromInitialOffset',
	    value: function getDifferenceFromInitialOffset() {
	      return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
	    }
	  }]);
	
	  return DragDropMonitor;
	}();
	
	exports.default = DragDropMonitor;

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragSource = function () {
	  function DragSource() {
	    _classCallCheck(this, DragSource);
	  }
	
	  _createClass(DragSource, [{
	    key: "canDrag",
	    value: function canDrag() {
	      return true;
	    }
	  }, {
	    key: "isDragging",
	    value: function isDragging(monitor, handle) {
	      return handle === monitor.getSourceId();
	    }
	  }, {
	    key: "endDrag",
	    value: function endDrag() {}
	  }]);
	
	  return DragSource;
	}();
	
	exports.default = DragSource;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DropTarget = function () {
	  function DropTarget() {
	    _classCallCheck(this, DropTarget);
	  }
	
	  _createClass(DropTarget, [{
	    key: "canDrop",
	    value: function canDrop() {
	      return true;
	    }
	  }, {
	    key: "hover",
	    value: function hover() {}
	  }, {
	    key: "drop",
	    value: function drop() {}
	  }]);
	
	  return DropTarget;
	}();
	
	exports.default = DropTarget;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(37);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _asap = __webpack_require__(609);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _registry = __webpack_require__(199);
	
	var _getNextUniqueId = __webpack_require__(904);
	
	var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HandlerRoles = {
	  SOURCE: 'SOURCE',
	  TARGET: 'TARGET'
	};
	
	function validateSourceContract(source) {
	  (0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	  (0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	  (0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
	  (0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	  (0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
	  (0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
	  if (allowArray && (0, _isArray2.default)(type)) {
	    type.forEach(function (t) {
	      return validateType(t, false);
	    });
	    return;
	  }
	
	  (0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}
	
	function getNextHandlerId(role) {
	  var id = (0, _getNextUniqueId2.default)().toString();
	  switch (role) {
	    case HandlerRoles.SOURCE:
	      return 'S' + id;
	    case HandlerRoles.TARGET:
	      return 'T' + id;
	    default:
	      (0, _invariant2.default)(false, 'Unknown role: ' + role);
	  }
	}
	
	function parseRoleFromHandlerId(handlerId) {
	  switch (handlerId[0]) {
	    case 'S':
	      return HandlerRoles.SOURCE;
	    case 'T':
	      return HandlerRoles.TARGET;
	    default:
	      (0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
	  }
	}
	
	var HandlerRegistry = function () {
	  function HandlerRegistry(store) {
	    _classCallCheck(this, HandlerRegistry);
	
	    this.store = store;
	
	    this.types = {};
	    this.handlers = {};
	
	    this.pinnedSourceId = null;
	    this.pinnedSource = null;
	  }
	
	  _createClass(HandlerRegistry, [{
	    key: 'addSource',
	    value: function addSource(type, source) {
	      validateType(type);
	      validateSourceContract(source);
	
	      var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
	      this.store.dispatch((0, _registry.addSource)(sourceId));
	      return sourceId;
	    }
	  }, {
	    key: 'addTarget',
	    value: function addTarget(type, target) {
	      validateType(type, true);
	      validateTargetContract(target);
	
	      var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
	      this.store.dispatch((0, _registry.addTarget)(targetId));
	      return targetId;
	    }
	  }, {
	    key: 'addHandler',
	    value: function addHandler(role, type, handler) {
	      var id = getNextHandlerId(role);
	      this.types[id] = type;
	      this.handlers[id] = handler;
	
	      return id;
	    }
	  }, {
	    key: 'containsHandler',
	    value: function containsHandler(handler) {
	      var _this = this;
	
	      return Object.keys(this.handlers).some(function (key) {
	        return _this.handlers[key] === handler;
	      });
	    }
	  }, {
	    key: 'getSource',
	    value: function getSource(sourceId, includePinned) {
	      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	
	      var isPinned = includePinned && sourceId === this.pinnedSourceId;
	      var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
	      return source;
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget(targetId) {
	      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
	      return this.handlers[targetId];
	    }
	  }, {
	    key: 'getSourceType',
	    value: function getSourceType(sourceId) {
	      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	      return this.types[sourceId];
	    }
	  }, {
	    key: 'getTargetType',
	    value: function getTargetType(targetId) {
	      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
	      return this.types[targetId];
	    }
	  }, {
	    key: 'isSourceId',
	    value: function isSourceId(handlerId) {
	      var role = parseRoleFromHandlerId(handlerId);
	      return role === HandlerRoles.SOURCE;
	    }
	  }, {
	    key: 'isTargetId',
	    value: function isTargetId(handlerId) {
	      var role = parseRoleFromHandlerId(handlerId);
	      return role === HandlerRoles.TARGET;
	    }
	  }, {
	    key: 'removeSource',
	    value: function removeSource(sourceId) {
	      var _this2 = this;
	
	      (0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
	      this.store.dispatch((0, _registry.removeSource)(sourceId));
	
	      (0, _asap2.default)(function () {
	        delete _this2.handlers[sourceId];
	        delete _this2.types[sourceId];
	      });
	    }
	  }, {
	    key: 'removeTarget',
	    value: function removeTarget(targetId) {
	      var _this3 = this;
	
	      (0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
	      this.store.dispatch((0, _registry.removeTarget)(targetId));
	
	      (0, _asap2.default)(function () {
	        delete _this3.handlers[targetId];
	        delete _this3.types[targetId];
	      });
	    }
	  }, {
	    key: 'pinSource',
	    value: function pinSource(sourceId) {
	      var source = this.getSource(sourceId);
	      (0, _invariant2.default)(source, 'Expected an existing source.');
	
	      this.pinnedSourceId = sourceId;
	      this.pinnedSource = source;
	    }
	  }, {
	    key: 'unpinSource',
	    value: function unpinSource() {
	      (0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
	
	      this.pinnedSourceId = null;
	      this.pinnedSource = null;
	    }
	  }]);
	
	  return HandlerRegistry;
	}();
	
	exports.default = HandlerRegistry;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createBackend;
	
	var _noop = __webpack_require__(485);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TestBackend = function () {
	  function TestBackend(manager) {
	    _classCallCheck(this, TestBackend);
	
	    this.actions = manager.getActions();
	  }
	
	  _createClass(TestBackend, [{
	    key: 'setup',
	    value: function setup() {
	      this.didCallSetup = true;
	    }
	  }, {
	    key: 'teardown',
	    value: function teardown() {
	      this.didCallTeardown = true;
	    }
	  }, {
	    key: 'connectDragSource',
	    value: function connectDragSource() {
	      return _noop2.default;
	    }
	  }, {
	    key: 'connectDragPreview',
	    value: function connectDragPreview() {
	      return _noop2.default;
	    }
	  }, {
	    key: 'connectDropTarget',
	    value: function connectDropTarget() {
	      return _noop2.default;
	    }
	  }, {
	    key: 'simulateBeginDrag',
	    value: function simulateBeginDrag(sourceIds, options) {
	      this.actions.beginDrag(sourceIds, options);
	    }
	  }, {
	    key: 'simulatePublishDragSource',
	    value: function simulatePublishDragSource() {
	      this.actions.publishDragSource();
	    }
	  }, {
	    key: 'simulateHover',
	    value: function simulateHover(targetIds, options) {
	      this.actions.hover(targetIds, options);
	    }
	  }, {
	    key: 'simulateDrop',
	    value: function simulateDrop() {
	      this.actions.drop();
	    }
	  }, {
	    key: 'simulateEndDrag',
	    value: function simulateEndDrag() {
	      this.actions.endDrag();
	    }
	  }]);
	
	  return TestBackend;
	}();
	
	function createBackend(manager) {
	  return new TestBackend(manager);
	}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropManager = __webpack_require__(893);
	
	Object.defineProperty(exports, 'DragDropManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropManager).default;
	  }
	});
	
	var _DragSource = __webpack_require__(895);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(896);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	var _createTestBackend = __webpack_require__(898);
	
	Object.defineProperty(exports, 'createTestBackend', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createTestBackend).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOperation;
	
	var _without = __webpack_require__(487);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _dragDrop = __webpack_require__(198);
	
	var _registry = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  itemType: null,
	  item: null,
	  sourceId: null,
	  targetIds: [],
	  dropResult: null,
	  didDrop: false,
	  isSourcePublic: null
	};
	
	function dragOperation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _dragDrop.BEGIN_DRAG:
	      return _extends({}, state, {
	        itemType: action.itemType,
	        item: action.item,
	        sourceId: action.sourceId,
	        isSourcePublic: action.isSourcePublic,
	        dropResult: null,
	        didDrop: false
	      });
	    case _dragDrop.PUBLISH_DRAG_SOURCE:
	      return _extends({}, state, {
	        isSourcePublic: true
	      });
	    case _dragDrop.HOVER:
	      return _extends({}, state, {
	        targetIds: action.targetIds
	      });
	    case _registry.REMOVE_TARGET:
	      if (state.targetIds.indexOf(action.targetId) === -1) {
	        return state;
	      }
	      return _extends({}, state, {
	        targetIds: (0, _without2.default)(state.targetIds, action.targetId)
	      });
	    case _dragDrop.DROP:
	      return _extends({}, state, {
	        dropResult: action.dropResult,
	        didDrop: true,
	        targetIds: []
	      });
	    case _dragDrop.END_DRAG:
	      return _extends({}, state, {
	        itemType: null,
	        item: null,
	        sourceId: null,
	        dropResult: null,
	        didDrop: false,
	        isSourcePublic: null,
	        targetIds: []
	      });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reduce;
	
	var _dragOffset = __webpack_require__(422);
	
	var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
	var _dragOperation = __webpack_require__(900);
	
	var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
	var _refCount = __webpack_require__(902);
	
	var _refCount2 = _interopRequireDefault(_refCount);
	
	var _dirtyHandlerIds = __webpack_require__(421);
	
	var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
	var _stateId = __webpack_require__(903);
	
	var _stateId2 = _interopRequireDefault(_stateId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reduce() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  return {
	    dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
	    dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
	    refCount: (0, _refCount2.default)(state.refCount, action),
	    dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
	    stateId: (0, _stateId2.default)(state.stateId)
	  };
	}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = refCount;
	
	var _registry = __webpack_require__(199);
	
	function refCount() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _registry.ADD_SOURCE:
	    case _registry.ADD_TARGET:
	      return state + 1;
	    case _registry.REMOVE_SOURCE:
	    case _registry.REMOVE_TARGET:
	      return state - 1;
	    default:
	      return state;
	  }
	}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stateId;
	function stateId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return state + 1;
	}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
	  return nextUniqueId++;
	}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(906);
	var entities = __webpack_require__(293);
	
	/*
	  Boolean Attributes
	*/
	var booleanAttributes = {
	  __proto__: null,
	  allowfullscreen: true,
	  async: true,
	  autofocus: true,
	  autoplay: true,
	  checked: true,
	  controls: true,
	  default: true,
	  defer: true,
	  disabled: true,
	  hidden: true,
	  ismap: true,
	  loop: true,
	  multiple: true,
	  muted: true,
	  open: true,
	  readonly: true,
	  required: true,
	  reversed: true,
	  scoped: true,
	  seamless: true,
	  selected: true,
	  typemustmatch: true
	};
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '',
	      value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (!value && booleanAttributes[key]) {
	      output += key;
	    } else {
	      output += key + '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true,
	};
	
	
	var render = module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for(var i = 0; i < dom.length; i++){
	    var elem = dom[i];
	
	    if (elem.type === 'root')
	      output += render(elem.children, opts);
	    else if (ElementType.isTag(elem))
	      output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment)
	      output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA)
	      output += renderCdata(elem);
	    else
	      output += renderText(elem, opts);
	  }
	
	  return output;
	};
	
	function renderTag(elem, opts) {
	  // Handle SVG
	  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};
	
	  var tag = '<' + elem.name,
	      attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (
	    opts.xmlMode
	    && (!elem.children || elem.children.length === 0)
	  ) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ }),
/* 906 */
/***/ (function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(159);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(424);
	var ElementPrototype = __webpack_require__(908);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		var elem = this._tagStack.pop();
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
	
		if (this._options.withDomLvl1) {
			element.__proto__ = element.type === "tag" ? ElementPrototype : NodePrototype;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var element = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				this._addDomElement({
					data: data,
					type: ElementType.Text
				});
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var element = {
			data: data,
			type: ElementType.Comment
		};
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var element = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		this._addDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	};
	
	module.exports = DomHandler;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(424);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(914),
		__webpack_require__(915),
		__webpack_require__(912),
		__webpack_require__(913),
		__webpack_require__(911),
		__webpack_require__(910)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ }),
/* 910 */
/***/ (function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(159);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ }),
/* 912 */
/***/ (function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(159).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, elems){
		var result = [];
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
	
			if(elems[i].children.length > 0){
				result = result.concat(findAll(test, elems[i].children));
			}
		}
		return result;
	}


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(159),
	    getOuterHTML = __webpack_require__(905),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem) || elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ }),
/* 915 */
/***/ (function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ }),
/* 916 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function combineOrderedStyles(customMap, defaults) {
	  if (customMap == null) {
	    return defaults;
	  }
	
	  var _defaults = _slicedToArray(defaults, 2);
	
	  var defaultStyleMap = _defaults[0];
	  var defaultStyleOrder = _defaults[1];
	
	  var styleMap = _extends({}, defaultStyleMap);
	  var styleOrder = [].concat(_toConsumableArray(defaultStyleOrder));
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(customMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _styleName = _step.value;
	
	      if (defaultStyleMap.hasOwnProperty(_styleName)) {
	        var defaultStyles = defaultStyleMap[_styleName];
	        styleMap[_styleName] = _extends({}, defaultStyles, customMap[_styleName]);
	      } else {
	        styleMap[_styleName] = customMap[_styleName];
	        styleOrder.push(_styleName);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return [styleMap, styleOrder];
	}
	
	exports.default = combineOrderedStyles;

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	var ATTR_NAME_MAP = {
	  acceptCharset: 'accept-charset',
	  className: 'class',
	  htmlFor: 'for',
	  httpEquiv: 'http-equiv'
	};
	
	function normalizeAttributes(attributes) {
	  if (attributes == null) {
	    return attributes;
	  }
	  var normalized = {};
	  var didNormalize = false;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var name = _step.value;
	
	      var newName = name;
	      if (ATTR_NAME_MAP.hasOwnProperty(name)) {
	        newName = ATTR_NAME_MAP[name];
	        didNormalize = true;
	      }
	      normalized[newName] = attributes[name];
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return didNormalize ? normalized : attributes;
	}
	
	exports.default = normalizeAttributes;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CSSProperty = __webpack_require__(343);
	
	var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;
	
	var NUMERIC_STRING = /^\d+$/;
	var UPPERCASE_PATTERN = /([A-Z])/g;
	
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
	function processStyleName(name) {
	  return name.replace(UPPERCASE_PATTERN, '-$1').toLowerCase().replace(VENDOR_PREFIX, '-$1-');
	}
	
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
	function processStyleValue(name, value) {
	  var isNumeric = void 0;
	  if (typeof value === 'string') {
	    isNumeric = NUMERIC_STRING.test(value);
	  } else {
	    isNumeric = true;
	    value = String(value);
	  }
	  if (!isNumeric || value === '0' || _CSSProperty.isUnitlessNumber[name] === true) {
	    return value;
	  } else {
	    return value + 'px';
	  }
	}
	
	function styleToCSS(styleDescr) {
	  return Object.keys(styleDescr).map(function (name) {
	    var styleValue = processStyleValue(name, styleDescr[name]);
	    var styleName = processStyleName(name);
	    return styleName + ': ' + styleValue;
	  }).join('; ');
	}
	
	exports.default = styleToCSS;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stateToHTML = __webpack_require__(920);
	
	Object.defineProperty(exports, 'stateToHTML', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stateToHTML).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DEFAULT_STYLE_MAP, _ENTITY_ATTR_MAP, _DATA_TO_ATTR;
	
	exports.default = stateToHTML;
	
	var _combineOrderedStyles3 = __webpack_require__(916);
	
	var _combineOrderedStyles4 = _interopRequireDefault(_combineOrderedStyles3);
	
	var _normalizeAttributes = __webpack_require__(917);
	
	var _normalizeAttributes2 = _interopRequireDefault(_normalizeAttributes);
	
	var _styleToCSS = __webpack_require__(918);
	
	var _styleToCSS2 = _interopRequireDefault(_styleToCSS);
	
	var _draftJs = __webpack_require__(161);
	
	var _draftJsUtils = __webpack_require__(425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BOLD = _draftJsUtils.INLINE_STYLE.BOLD;
	var CODE = _draftJsUtils.INLINE_STYLE.CODE;
	var ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC;
	var STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH;
	var UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE;
	
	
	var INDENT = '  ';
	var BREAK = '<br>';
	var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/;
	
	var DEFAULT_STYLE_MAP = (_DEFAULT_STYLE_MAP = {}, _defineProperty(_DEFAULT_STYLE_MAP, BOLD, { element: 'strong' }), _defineProperty(_DEFAULT_STYLE_MAP, CODE, { element: 'code' }), _defineProperty(_DEFAULT_STYLE_MAP, ITALIC, { element: 'em' }), _defineProperty(_DEFAULT_STYLE_MAP, STRIKETHROUGH, { element: 'del' }), _defineProperty(_DEFAULT_STYLE_MAP, UNDERLINE, { element: 'ins' }), _DEFAULT_STYLE_MAP);
	
	// Order: inner-most style to outer-most.
	// Examle: <em><strong>foo</strong></em>
	var DEFAULT_STYLE_ORDER = [BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE];
	
	// Map entity data to element attributes.
	var ENTITY_ATTR_MAP = (_ENTITY_ATTR_MAP = {}, _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.LINK, { url: 'href', rel: 'rel', target: 'target', title: 'title', className: 'class' }), _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.IMAGE, { src: 'src', height: 'height', width: 'width', alt: 'alt', className: 'class' }), _ENTITY_ATTR_MAP);
	
	// Map entity data to element attributes.
	var DATA_TO_ATTR = (_DATA_TO_ATTR = {}, _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.LINK, function (entityType, entity) {
	  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
	  var data = entity.getData();
	  var attrs = {};
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var dataKey = _step.value;
	
	      var dataValue = data[dataKey];
	      if (attrMap.hasOwnProperty(dataKey)) {
	        var attrKey = attrMap[dataKey];
	        attrs[attrKey] = dataValue;
	      } else if (DATA_ATTRIBUTE.test(dataKey)) {
	        attrs[dataKey] = dataValue;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return attrs;
	}), _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.IMAGE, function (entityType, entity) {
	  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
	  var data = entity.getData();
	  var attrs = {};
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = Object.keys(data)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var dataKey = _step2.value;
	
	      var dataValue = data[dataKey];
	      if (attrMap.hasOwnProperty(dataKey)) {
	        var attrKey = attrMap[dataKey];
	        attrs[attrKey] = dataValue;
	      } else if (DATA_ATTRIBUTE.test(dataKey)) {
	        attrs[dataKey] = dataValue;
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return attrs;
	}), _DATA_TO_ATTR);
	
	// The reason this returns an array is because a single block might get wrapped
	// in two tags.
	function getTags(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
	      return ['h1'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
	      return ['h2'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
	      return ['h3'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
	      return ['h4'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
	      return ['h5'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
	      return ['h6'];
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return ['li'];
	    case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
	      return ['blockquote'];
	    case _draftJsUtils.BLOCK_TYPE.CODE:
	      return ['pre', 'code'];
	    case _draftJsUtils.BLOCK_TYPE.ATOMIC:
	      return ['figure'];
	    default:
	      return ['p'];
	  }
	}
	
	function getWrapperTag(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	      return 'ul';
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return 'ol';
	    default:
	      return null;
	  }
	}
	
	var MarkupGenerator = function () {
	  // These are related to state.
	  function MarkupGenerator(contentState, options) {
	    _classCallCheck(this, MarkupGenerator);
	
	    if (options == null) {
	      options = {};
	    }
	    this.contentState = contentState;
	    this.options = options;
	
	    var _combineOrderedStyles = (0, _combineOrderedStyles4.default)(options.inlineStyles, [DEFAULT_STYLE_MAP, DEFAULT_STYLE_ORDER]);
	
	    var _combineOrderedStyles2 = _slicedToArray(_combineOrderedStyles, 2);
	
	    var inlineStyles = _combineOrderedStyles2[0];
	    var styleOrder = _combineOrderedStyles2[1];
	
	    this.inlineStyles = inlineStyles;
	    this.styleOrder = styleOrder;
	  }
	  // These are related to user-defined options.
	
	
	  _createClass(MarkupGenerator, [{
	    key: 'generate',
	    value: function generate() {
	      this.output = [];
	      this.blocks = this.contentState.getBlocksAsArray();
	      this.totalBlocks = this.blocks.length;
	      this.currentBlock = 0;
	      this.indentLevel = 0;
	      this.wrapperTag = null;
	      while (this.currentBlock < this.totalBlocks) {
	        this.processBlock();
	      }
	      this.closeWrapperTag();
	      return this.output.join('').trim();
	    }
	  }, {
	    key: 'processBlock',
	    value: function processBlock() {
	      var blockRenderers = this.options.blockRenderers;
	
	      var block = this.blocks[this.currentBlock];
	      var blockType = block.getType();
	      var newWrapperTag = getWrapperTag(blockType);
	      if (this.wrapperTag !== newWrapperTag) {
	        if (this.wrapperTag) {
	          this.closeWrapperTag();
	        }
	        if (newWrapperTag) {
	          this.openWrapperTag(newWrapperTag);
	        }
	      }
	      this.indent();
	      // Allow blocks to be rendered using a custom renderer.
	      var customRenderer = blockRenderers != null && blockRenderers.hasOwnProperty(blockType) ? blockRenderers[blockType] : null;
	      var customRendererOutput = customRenderer ? customRenderer(block) : null;
	      // Renderer can return null, which will cause processing to continue as normal.
	      if (customRendererOutput != null) {
	        this.output.push(customRendererOutput);
	        this.output.push('\n');
	        this.currentBlock += 1;
	        return;
	      }
	      this.writeStartTag(block);
	      this.output.push(this.renderBlockContent(block));
	      // Look ahead and see if we will nest list.
	      var nextBlock = this.getNextBlock();
	      if (canHaveDepth(blockType) && nextBlock && nextBlock.getDepth() === block.getDepth() + 1) {
	        this.output.push('\n');
	        // This is a litle hacky: temporarily stash our current wrapperTag and
	        // render child list(s).
	        var thisWrapperTag = this.wrapperTag;
	        this.wrapperTag = null;
	        this.indentLevel += 1;
	        this.currentBlock += 1;
	        this.processBlocksAtDepth(nextBlock.getDepth());
	        this.wrapperTag = thisWrapperTag;
	        this.indentLevel -= 1;
	        this.indent();
	      } else {
	        this.currentBlock += 1;
	      }
	      this.writeEndTag(block);
	    }
	  }, {
	    key: 'processBlocksAtDepth',
	    value: function processBlocksAtDepth(depth) {
	      var block = this.blocks[this.currentBlock];
	      while (block && block.getDepth() === depth) {
	        this.processBlock();
	        block = this.blocks[this.currentBlock];
	      }
	      this.closeWrapperTag();
	    }
	  }, {
	    key: 'getNextBlock',
	    value: function getNextBlock() {
	      return this.blocks[this.currentBlock + 1];
	    }
	  }, {
	    key: 'writeStartTag',
	    value: function writeStartTag(block) {
	      var tags = getTags(block.getType());
	
	      var attrString = void 0;
	      if (this.options.blockStyleFn) {
	        var _ref = this.options.blockStyleFn(block) || {};
	
	        var _attributes = _ref.attributes;
	        var _style = _ref.style;
	        // Normalize `className` -> `class`, etc.
	
	        _attributes = (0, _normalizeAttributes2.default)(_attributes);
	        if (_style != null) {
	          var styleAttr = (0, _styleToCSS2.default)(_style);
	          _attributes = _attributes == null ? { style: styleAttr } : _extends({}, _attributes, { style: styleAttr });
	        }
	        attrString = stringifyAttrs(_attributes);
	      } else {
	        attrString = '';
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = tags[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var tag = _step3.value;
	
	          this.output.push('<' + tag + attrString + '>');
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'writeEndTag',
	    value: function writeEndTag(block) {
	      var tags = getTags(block.getType());
	      if (tags.length === 1) {
	        this.output.push('</' + tags[0] + '>\n');
	      } else {
	        var output = [];
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = tags[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var tag = _step4.value;
	
	            output.unshift('</' + tag + '>');
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	
	        this.output.push(output.join('') + '\n');
	      }
	    }
	  }, {
	    key: 'openWrapperTag',
	    value: function openWrapperTag(wrapperTag) {
	      this.wrapperTag = wrapperTag;
	      this.indent();
	      this.output.push('<' + wrapperTag + '>\n');
	      this.indentLevel += 1;
	    }
	  }, {
	    key: 'closeWrapperTag',
	    value: function closeWrapperTag() {
	      var wrapperTag = this.wrapperTag;
	
	      if (wrapperTag) {
	        this.indentLevel -= 1;
	        this.indent();
	        this.output.push('</' + wrapperTag + '>\n');
	        this.wrapperTag = null;
	      }
	    }
	  }, {
	    key: 'indent',
	    value: function indent() {
	      this.output.push(INDENT.repeat(this.indentLevel));
	    }
	  }, {
	    key: 'renderBlockContent',
	    value: function renderBlockContent(block) {
	      var _this = this;
	
	      var blockType = block.getType();
	      var text = block.getText();
	      if (text === '') {
	        // Prevent element collapse if completely empty.
	        return BREAK;
	      }
	      text = this.preserveWhitespace(text);
	      var charMetaList = block.getCharacterList();
	      var entityPieces = (0, _draftJsUtils.getEntityRanges)(text, charMetaList);
	      return entityPieces.map(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 2);
	
	        var entityKey = _ref3[0];
	        var stylePieces = _ref3[1];
	
	        var content = stylePieces.map(function (_ref4) {
	          var _ref5 = _slicedToArray(_ref4, 2);
	
	          var text = _ref5[0];
	          var styleSet = _ref5[1];
	
	          var content = encodeContent(text);
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = _this.styleOrder[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var _styleName = _step5.value;
	
	              // If our block type is CODE then don't wrap inline code elements.
	              if (_styleName === CODE && blockType === _draftJsUtils.BLOCK_TYPE.CODE) {
	                continue;
	              }
	              if (styleSet.has(_styleName)) {
	                var _inlineStyles$_styleN = _this.inlineStyles[_styleName];
	                var _element = _inlineStyles$_styleN.element;
	                var _attributes2 = _inlineStyles$_styleN.attributes;
	                var _style2 = _inlineStyles$_styleN.style;
	
	                if (_element == null) {
	                  _element = 'span';
	                }
	                // Normalize `className` -> `class`, etc.
	                _attributes2 = (0, _normalizeAttributes2.default)(_attributes2);
	                if (_style2 != null) {
	                  var styleAttr = (0, _styleToCSS2.default)(_style2);
	                  _attributes2 = _attributes2 == null ? { style: styleAttr } : _extends({}, _attributes2, { style: styleAttr });
	                }
	                var attrString = stringifyAttrs(_attributes2);
	                content = '<' + _element + attrString + '>' + content + '</' + _element + '>';
	              }
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	
	          return content;
	        }).join('');
	        var entity = entityKey ? _draftJs.Entity.get(entityKey) : null;
	        // Note: The `toUpperCase` below is for compatability with some libraries that use lower-case for image blocks.
	        var entityType = entity == null ? null : entity.getType().toUpperCase();
	        if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.LINK) {
	          var attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
	          var attrString = stringifyAttrs(attrs);
	          return '<a' + attrString + '>' + content + '</a>';
	        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.IMAGE) {
	          var _attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
	          var _attrString = stringifyAttrs(_attrs);
	          return '<img' + _attrString + '/>';
	        } else {
	          return content;
	        }
	      }).join('');
	    }
	  }, {
	    key: 'preserveWhitespace',
	    value: function preserveWhitespace(text) {
	      var length = text.length;
	      // Prevent leading/trailing/consecutive whitespace collapse.
	      var newText = new Array(length);
	      for (var i = 0; i < length; i++) {
	        if (text[i] === ' ' && (i === 0 || i === length - 1 || text[i - 1] === ' ')) {
	          newText[i] = '\xA0';
	        } else {
	          newText[i] = text[i];
	        }
	      }
	      return newText.join('');
	    }
	  }]);
	
	  return MarkupGenerator;
	}();
	
	function stringifyAttrs(attrs) {
	  if (attrs == null) {
	    return '';
	  }
	  var parts = [];
	  var _iteratorNormalCompletion6 = true;
	  var _didIteratorError6 = false;
	  var _iteratorError6 = undefined;
	
	  try {
	    for (var _iterator6 = Object.keys(attrs)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	      var name = _step6.value;
	
	      var value = attrs[name];
	      if (value != null) {
	        parts.push(' ' + name + '="' + encodeAttr(value + '') + '"');
	      }
	    }
	  } catch (err) {
	    _didIteratorError6 = true;
	    _iteratorError6 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion6 && _iterator6.return) {
	        _iterator6.return();
	      }
	    } finally {
	      if (_didIteratorError6) {
	        throw _iteratorError6;
	      }
	    }
	  }
	
	  return parts.join('');
	}
	
	function canHaveDepth(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return true;
	    default:
	      return false;
	  }
	}
	
	function encodeContent(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join(BREAK + '\n');
	}
	
	function encodeAttr(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
	}
	
	function stateToHTML(content, options) {
	  return new MarkupGenerator(content, options).generate();
	}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stateToMarkdown = __webpack_require__(922);
	
	Object.defineProperty(exports, 'stateToMarkdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stateToMarkdown).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = stateToMarkdown;
	
	var _draftJsUtils = __webpack_require__(425);
	
	var _draftJs = __webpack_require__(161);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BOLD = _draftJsUtils.INLINE_STYLE.BOLD;
	var CODE = _draftJsUtils.INLINE_STYLE.CODE;
	var ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC;
	var STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH;
	var UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE;
	
	
	var CODE_INDENT = '    ';
	
	var MarkupGenerator = function () {
	  function MarkupGenerator(contentState) {
	    _classCallCheck(this, MarkupGenerator);
	
	    this.contentState = contentState;
	  }
	
	  _createClass(MarkupGenerator, [{
	    key: 'generate',
	    value: function generate() {
	      this.output = [];
	      this.blocks = this.contentState.getBlockMap().toArray();
	      this.totalBlocks = this.blocks.length;
	      this.currentBlock = 0;
	      this.listItemCounts = {};
	      while (this.currentBlock < this.totalBlocks) {
	        this.processBlock();
	      }
	      return this.output.join('');
	    }
	  }, {
	    key: 'processBlock',
	    value: function processBlock() {
	      var block = this.blocks[this.currentBlock];
	      var blockType = block.getType();
	      switch (blockType) {
	        case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
	          {
	            this.insertLineBreaks(1);
	            this.output.push('# ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
	          {
	            this.insertLineBreaks(1);
	            this.output.push('## ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
	          {
	            this.insertLineBreaks(1);
	            this.output.push('### ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
	          {
	            this.insertLineBreaks(1);
	            this.output.push('#### ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
	          {
	            this.insertLineBreaks(1);
	            this.output.push('##### ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
	          {
	            this.insertLineBreaks(1);
	            this.output.push('###### ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	          {
	            var blockDepth = block.getDepth();
	            var lastBlock = this.getLastBlock();
	            var lastBlockType = lastBlock ? lastBlock.getType() : null;
	            var lastBlockDepth = lastBlock && canHaveDepth(lastBlockType) ? lastBlock.getDepth() : null;
	            if (lastBlockType !== blockType && lastBlockDepth !== blockDepth - 1) {
	              this.insertLineBreaks(1);
	              // Insert an additional line break if following opposite list type.
	              if (lastBlockType === _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM) {
	                this.insertLineBreaks(1);
	              }
	            }
	            var indent = ' '.repeat(block.depth * 4);
	            this.output.push(indent + '- ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	          {
	            var _blockDepth = block.getDepth();
	            var _lastBlock = this.getLastBlock();
	            var _lastBlockType = _lastBlock ? _lastBlock.getType() : null;
	            var _lastBlockDepth = _lastBlock && canHaveDepth(_lastBlockType) ? _lastBlock.getDepth() : null;
	            if (_lastBlockType !== blockType && _lastBlockDepth !== _blockDepth - 1) {
	              this.insertLineBreaks(1);
	              // Insert an additional line break if following opposite list type.
	              if (_lastBlockType === _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM) {
	                this.insertLineBreaks(1);
	              }
	            }
	            var _indent = ' '.repeat(_blockDepth * 4);
	            // TODO: figure out what to do with two-digit numbers
	            var count = this.getListItemCount(block) % 10;
	            this.output.push(_indent + (count + '. ') + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
	          {
	            this.insertLineBreaks(1);
	            this.output.push(' > ' + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        case _draftJsUtils.BLOCK_TYPE.CODE:
	          {
	            this.insertLineBreaks(1);
	            this.output.push(CODE_INDENT + this.renderBlockContent(block) + '\n');
	            break;
	          }
	        default:
	          {
	            this.insertLineBreaks(1);
	            this.output.push(this.renderBlockContent(block) + '\n');
	            break;
	          }
	      }
	      this.currentBlock += 1;
	    }
	  }, {
	    key: 'getLastBlock',
	    value: function getLastBlock() {
	      return this.blocks[this.currentBlock - 1];
	    }
	  }, {
	    key: 'getNextBlock',
	    value: function getNextBlock() {
	      return this.blocks[this.currentBlock + 1];
	    }
	  }, {
	    key: 'getListItemCount',
	    value: function getListItemCount(block) {
	      var blockType = block.getType();
	      var blockDepth = block.getDepth();
	      // To decide if we need to start over we need to backtrack (skipping list
	      // items that are of greater depth)
	      var index = this.currentBlock - 1;
	      var prevBlock = this.blocks[index];
	      while (prevBlock && canHaveDepth(prevBlock.getType()) && prevBlock.getDepth() > blockDepth) {
	        index -= 1;
	        prevBlock = this.blocks[index];
	      }
	      if (!prevBlock || prevBlock.getType() !== blockType || prevBlock.getDepth() !== blockDepth) {
	        this.listItemCounts[blockDepth] = 0;
	      }
	      return this.listItemCounts[blockDepth] = this.listItemCounts[blockDepth] + 1;
	    }
	  }, {
	    key: 'insertLineBreaks',
	    value: function insertLineBreaks() {
	      if (this.currentBlock > 0) {
	        this.output.push('\n');
	      }
	    }
	  }, {
	    key: 'renderBlockContent',
	    value: function renderBlockContent(block) {
	      var blockType = block.getType();
	      var text = block.getText();
	      if (text === '') {
	        // Prevent element collapse if completely empty.
	        // TODO: Replace with constant.
	        return '\u200B';
	      }
	      var charMetaList = block.getCharacterList();
	      var entityPieces = (0, _draftJsUtils.getEntityRanges)(text, charMetaList);
	      return entityPieces.map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var entityKey = _ref2[0];
	        var stylePieces = _ref2[1];
	
	        var content = stylePieces.map(function (_ref3) {
	          var _ref4 = _slicedToArray(_ref3, 2);
	
	          var text = _ref4[0];
	          var style = _ref4[1];
	
	          // Don't allow empty inline elements.
	          if (!text) {
	            return '';
	          }
	          var content = encodeContent(text);
	          if (style.has(BOLD)) {
	            content = '**' + content + '**';
	          }
	          if (style.has(UNDERLINE)) {
	            // TODO: encode `+`?
	            content = '++' + content + '++';
	          }
	          if (style.has(ITALIC)) {
	            content = '_' + content + '_';
	          }
	          if (style.has(STRIKETHROUGH)) {
	            // TODO: encode `~`?
	            content = '~~' + content + '~~';
	          }
	          if (style.has(CODE)) {
	            content = blockType === _draftJsUtils.BLOCK_TYPE.CODE ? content : '`' + content + '`';
	          }
	          return content;
	        }).join('');
	        var entity = entityKey ? _draftJs.Entity.get(entityKey) : null;
	        if (entity != null && entity.getType() === _draftJsUtils.ENTITY_TYPE.LINK) {
	          var data = entity.getData();
	          var url = data.url || '';
	          var title = data.title ? ' "' + escapeTitle(data.title) + '"' : '';
	          return '[' + content + '](' + encodeURL(url) + title + ')';
	        } else if (entity != null && entity.getType() === _draftJsUtils.ENTITY_TYPE.IMAGE) {
	          var _data = entity.getData();
	          var src = _data.src || '';
	          var alt = _data.alt ? ' "' + escapeTitle(_data.alt) + '"' : '';
	          return '![' + alt + '](' + encodeURL(src) + ')';
	        } else {
	          return content;
	        }
	      }).join('');
	    }
	  }]);
	
	  return MarkupGenerator;
	}();
	
	function canHaveDepth(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return true;
	    default:
	      return false;
	  }
	}
	
	function encodeContent(text) {
	  return text.replace(/[*_`]/g, '\\$&');
	}
	
	// Encode chars that would normally be allowed in a URL but would conflict with
	// our markdown syntax: `[foo](http://foo/)`
	function encodeURL(url) {
	  return url.replace(/\)/g, '%29');
	}
	
	// Escape quotes using backslash.
	function escapeTitle(text) {
	  return text.replace(/"/g, '\\"');
	}
	
	function stateToMarkdown(content) {
	  return new MarkupGenerator(content).generate();
	}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BLOCK_TYPE = exports.BLOCK_TYPE = {
	  // This is used to represent a normal text block (paragraph).
	  UNSTYLED: 'unstyled',
	  HEADER_ONE: 'header-one',
	  HEADER_TWO: 'header-two',
	  HEADER_THREE: 'header-three',
	  HEADER_FOUR: 'header-four',
	  HEADER_FIVE: 'header-five',
	  HEADER_SIX: 'header-six',
	  UNORDERED_LIST_ITEM: 'unordered-list-item',
	  ORDERED_LIST_ITEM: 'ordered-list-item',
	  BLOCKQUOTE: 'blockquote',
	  PULLQUOTE: 'pullquote',
	  CODE: 'code-block',
	  ATOMIC: 'atomic'
	};
	
	var ENTITY_TYPE = exports.ENTITY_TYPE = {
	  LINK: 'LINK',
	  IMAGE: 'IMAGE'
	};
	
	var INLINE_STYLE = exports.INLINE_STYLE = {
	  BOLD: 'BOLD',
	  CODE: 'CODE',
	  ITALIC: 'ITALIC',
	  STRIKETHROUGH: 'STRIKETHROUGH',
	  UNDERLINE: 'UNDERLINE'
	};
	
	exports.default = {
	  BLOCK_TYPE: BLOCK_TYPE,
	  ENTITY_TYPE: ENTITY_TYPE,
	  INLINE_STYLE: INLINE_STYLE
	};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _draftJs = __webpack_require__(161);
	
	var _getSelectedBlocks = __webpack_require__(285);
	
	var _getSelectedBlocks2 = _interopRequireDefault(_getSelectedBlocks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calls a provided `modifier` function with a selection for each
	 * selected block in the current editor selection. Passes through additional
	 * arguments to the modifier.
	 *
	 * Note: At the moment it will retain the original selection and override
	 * possible selection changes from modifiers
	 *
	 * @param  {object} editorState The current draft.js editor state object
	 *
	 * @param  {function} modifier  A modifier function to be executed.
	 *                              Must have the signature (editorState, selection, ...)
	 *
	 * @param  {mixed} ...args      Additional arguments to be passed through to the modifier
	 *
	 * @return {object} The new editor state
	 */
	exports.default = function (editorState, modifier) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var contentState = editorState.getCurrentContent();
	  var currentSelection = editorState.getSelection();
	
	  var startKey = currentSelection.getStartKey();
	  var endKey = currentSelection.getEndKey();
	  var startOffset = currentSelection.getStartOffset();
	  var endOffset = currentSelection.getEndOffset();
	
	  var isSameBlock = startKey === endKey;
	  var selectedBlocks = (0, _getSelectedBlocks2.default)(contentState, startKey, endKey);
	
	  var finalEditorState = editorState;
	  selectedBlocks.forEach(function (block) {
	    var currentBlockKey = block.getKey();
	    var selectionStart = startOffset;
	    var selectionEnd = endOffset;
	
	    if (currentBlockKey === startKey) {
	      selectionStart = startOffset;
	      selectionEnd = isSameBlock ? endOffset : block.getText().length;
	    } else if (currentBlockKey === endKey) {
	      selectionStart = isSameBlock ? startOffset : 0;
	      selectionEnd = endOffset;
	    } else {
	      selectionStart = 0;
	      selectionEnd = block.getText().length;
	    }
	
	    var selection = new _draftJs.SelectionState({
	      anchorKey: currentBlockKey,
	      anchorOffset: selectionStart,
	      focusKey: currentBlockKey,
	      focusOffset: selectionEnd
	    });
	
	    finalEditorState = modifier.apply(undefined, [finalEditorState, selection].concat(args));
	  });
	
	  return _draftJs.EditorState.forceSelection(finalEditorState, currentSelection);
	};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EMPTY_SET = undefined;
	exports.default = getEntityRanges;
	
	var _immutable = __webpack_require__(26);
	
	var EMPTY_SET = exports.EMPTY_SET = new _immutable.OrderedSet();
	function getEntityRanges(text, charMetaList) {
	  var charEntity = null;
	  var prevCharEntity = null;
	  var ranges = [];
	  var rangeStart = 0;
	  for (var i = 0, len = text.length; i < len; i++) {
	    prevCharEntity = charEntity;
	    var meta = charMetaList.get(i);
	    charEntity = meta ? meta.getEntity() : null;
	    if (i > 0 && charEntity !== prevCharEntity) {
	      ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
	      rangeStart = i;
	    }
	  }
	  ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
	  return ranges;
	}
	
	function getStyleRanges(text, charMetaList) {
	  var charStyle = EMPTY_SET;
	  var prevCharStyle = EMPTY_SET;
	  var ranges = [];
	  var rangeStart = 0;
	  for (var i = 0, len = text.length; i < len; i++) {
	    prevCharStyle = charStyle;
	    var meta = charMetaList.get(i);
	    charStyle = meta ? meta.getStyle() : EMPTY_SET;
	    if (i > 0 && !(0, _immutable.is)(charStyle, prevCharStyle)) {
	      ranges.push([text.slice(rangeStart, i), prevCharStyle]);
	      rangeStart = i;
	    }
	  }
	  ranges.push([text.slice(rangeStart), charStyle]);
	  return ranges;
	}

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getSelectedBlocks = __webpack_require__(285);
	
	var _getSelectedBlocks2 = _interopRequireDefault(_getSelectedBlocks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (strategy) {
	  return function (editorState, selection) {
	    var contentState = editorState.getCurrentContent();
	    var currentSelection = selection || editorState.getSelection();
	    var startKey = currentSelection.getStartKey();
	    var endKey = currentSelection.getEndKey();
	    var startOffset = currentSelection.getStartOffset();
	    var endOffset = currentSelection.getEndOffset();
	
	    var isSameBlock = startKey === endKey;
	    var selectedBlocks = (0, _getSelectedBlocks2.default)(contentState, startKey, endKey);
	    var entityFound = false;
	
	    // We have to shift the offset to not get false positives when selecting
	    // a character just before or after an entity
	    var finalStartOffset = startOffset + 1;
	    var finalEndOffset = endOffset - 1;
	
	    selectedBlocks.forEach(function (block) {
	      strategy(block, function (start, end) {
	        if (entityFound) {
	          return;
	        }
	
	        var blockKey = block.getKey();
	
	        if (isSameBlock && (end < finalStartOffset || start > finalEndOffset)) {
	          return;
	        } else if (blockKey === startKey && end < finalStartOffset) {
	          return;
	        } else if (blockKey === endKey && start > finalEndOffset) {
	          return;
	        }
	
	        entityFound = true;
	      });
	    });
	
	    return entityFound;
	  };
	};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AtomicBlockUtils
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(160);
	var CharacterMetadata = __webpack_require__(63);
	var ContentBlock = __webpack_require__(110);
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	var Immutable = __webpack_require__(26);
	
	var generateRandomKey = __webpack_require__(70);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	
	
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	
	    var charData = CharacterMetadata.create({ entity: entityKey });
	
	    var fragmentArray = [new ContentBlock({
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    }), new ContentBlock({
	      key: generateRandomKey(),
	      type: 'unstyled',
	      text: '',
	      characterList: List()
	    })];
	
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = AtomicBlockUtils;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CompositeDraftDecorator
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Immutable = __webpack_require__(26);
	
	var List = Immutable.List;
	
	
	var DELIMITER = '.';
	
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block) {
	    var decorations = Array(block.getText().length).fill(null);
	
	    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
	      var counter = 0;
	      var strategy = decorator.strategy;
	      strategy(block, function ( /*number*/start, /*number*/end) {
	        // Find out if any of our matching range is already occupied
	        // by another decorator. If so, discard the match. Otherwise, store
	        // the component key for rendering.
	        if (canOccupySlice(decorations, start, end)) {
	          occupySlice(decorations, start, end, ii + DELIMITER + counter);
	          counter++;
	        }
	      });
	    });
	
	    return List(decorations);
	  };
	
	  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].component;
	  };
	
	  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].props;
	  };
	
	  return CompositeDraftDecorator;
	}();
	
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */
	
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentStateInlineStyle
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(63);
	
	var _require = __webpack_require__(26);
	
	var Map = _require.Map;
	
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditor.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(287);
	var DefaultDraftInlineStyle = __webpack_require__(427);
	var DraftEditorCompositionHandler = __webpack_require__(931);
	var DraftEditorContents = __webpack_require__(932);
	var DraftEditorDragHandler = __webpack_require__(933);
	var DraftEditorEditHandler = __webpack_require__(934);
	var DraftEditorPlaceholder = __webpack_require__(936);
	var EditorState = __webpack_require__(24);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var Scroll = __webpack_require__(448);
	var Style = __webpack_require__(295);
	var UserAgent = __webpack_require__(71);
	
	var cx = __webpack_require__(163);
	var emptyFunction = __webpack_require__(43);
	var generateRandomKey = __webpack_require__(70);
	var getDefaultKeyBinding = __webpack_require__(433);
	var nullthrows = __webpack_require__(57);
	var getScrollPosition = __webpack_require__(298);
	
	var isIE = UserAgent.isBrowser('IE');
	
	// IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	var allowSpellCheck = !isIE;
	
	// Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	var handlerMap = {
	  'edit': DraftEditorEditHandler,
	  'composite': DraftEditorCompositionHandler,
	  'drag': DraftEditorDragHandler,
	  'cut': null,
	  'render': null
	};
	
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	var DraftEditor = function (_React$Component) {
	  _inherits(DraftEditor, _React$Component);
	
	  function DraftEditor(props) {
	    _classCallCheck(this, DraftEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._blockSelectEvents = false;
	    _this._clipboard = null;
	    _this._guardAgainstRender = false;
	    _this._handler = null;
	    _this._dragCount = 0;
	    _this._editorKey = generateRandomKey();
	    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
	
	    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
	    _this._onBlur = _this._buildHandler('onBlur');
	    _this._onCharacterData = _this._buildHandler('onCharacterData');
	    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
	    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
	    _this._onCopy = _this._buildHandler('onCopy');
	    _this._onCut = _this._buildHandler('onCut');
	    _this._onDragEnd = _this._buildHandler('onDragEnd');
	    _this._onDragOver = _this._buildHandler('onDragOver');
	    _this._onDragStart = _this._buildHandler('onDragStart');
	    _this._onDrop = _this._buildHandler('onDrop');
	    _this._onInput = _this._buildHandler('onInput');
	    _this._onFocus = _this._buildHandler('onFocus');
	    _this._onKeyDown = _this._buildHandler('onKeyDown');
	    _this._onKeyPress = _this._buildHandler('onKeyPress');
	    _this._onKeyUp = _this._buildHandler('onKeyUp');
	    _this._onMouseDown = _this._buildHandler('onMouseDown');
	    _this._onMouseUp = _this._buildHandler('onMouseUp');
	    _this._onPaste = _this._buildHandler('onPaste');
	    _this._onSelect = _this._buildHandler('onSelect');
	
	    // Manual binding for public and internal methods.
	    _this.focus = _this._focus.bind(_this);
	    _this.blur = _this._blur.bind(_this);
	    _this.setMode = _this._setMode.bind(_this);
	    _this.exitCurrentMode = _this._exitCurrentMode.bind(_this);
	    _this.restoreEditorDOM = _this._restoreEditorDOM.bind(_this);
	    _this.setRenderGuard = _this._setRenderGuard.bind(_this);
	    _this.removeRenderGuard = _this._removeRenderGuard.bind(_this);
	    _this.setClipboard = _this._setClipboard.bind(_this);
	    _this.getClipboard = _this._getClipboard.bind(_this);
	    _this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	    _this.update = _this._update.bind(_this);
	    _this.onDragEnter = _this._onDragEnter.bind(_this);
	    _this.onDragLeave = _this._onDragLeave.bind(_this);
	
	    // See `_restoreEditorDOM()`.
	    _this.state = { containerKey: 0 };
	    return _this;
	  }
	
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	
	  /**
	   * Define proxies that can route events to the current handler.
	   */
	
	
	  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
	    var _this2 = this;
	
	    return function (e) {
	      if (!_this2.props.readOnly) {
	        var method = _this2._handler && _this2._handler[eventName];
	        method && method.call(_this2, e);
	      }
	    };
	  };
	
	  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
	    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	  };
	
	  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
	    if (this._showPlaceholder()) {
	      return React.createElement(DraftEditorPlaceholder, {
	        text: nullthrows(this.props.placeholder),
	        editorState: this.props.editorState,
	        textAlignment: this.props.textAlignment,
	        accessibilityID: this._placeholderAccessibilityID
	      });
	    }
	    return null;
	  };
	
	  DraftEditor.prototype.render = function render() {
	    var _props = this.props;
	    var readOnly = _props.readOnly;
	    var textAlignment = _props.textAlignment;
	
	    var rootClass = cx({
	      'DraftEditor/root': true,
	      'DraftEditor/alignLeft': textAlignment === 'left',
	      'DraftEditor/alignRight': textAlignment === 'right',
	      'DraftEditor/alignCenter': textAlignment === 'center'
	    });
	
	    var contentStyle = {
	      outline: 'none',
	      whiteSpace: 'pre-wrap',
	      wordWrap: 'break-word'
	    };
	
	    return React.createElement(
	      'div',
	      { className: rootClass },
	      this._renderPlaceholder(),
	      React.createElement(
	        'div',
	        {
	          className: cx('DraftEditor/editorContainer'),
	          key: 'editor' + this.state.containerKey,
	          ref: 'editorContainer' },
	        React.createElement(
	          'div',
	          {
	            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
	            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
	            'aria-describedby': this._showPlaceholder() ? this._placeholderAccessibilityID : null,
	            'aria-expanded': readOnly ? null : this.props.ariaExpanded,
	            'aria-haspopup': readOnly ? null : this.props.ariaHasPopup,
	            'aria-label': this.props.ariaLabel,
	            'aria-owns': readOnly ? null : this.props.ariaOwneeID,
	            className: cx('public/DraftEditor/content'),
	            contentEditable: !readOnly,
	            'data-testid': this.props.webDriverTestID,
	            onBeforeInput: this._onBeforeInput,
	            onBlur: this._onBlur,
	            onCompositionEnd: this._onCompositionEnd,
	            onCompositionStart: this._onCompositionStart,
	            onCopy: this._onCopy,
	            onCut: this._onCut,
	            onDragEnd: this._onDragEnd,
	            onDragEnter: this.onDragEnter,
	            onDragLeave: this.onDragLeave,
	            onDragOver: this._onDragOver,
	            onDragStart: this._onDragStart,
	            onDrop: this._onDrop,
	            onFocus: this._onFocus,
	            onInput: this._onInput,
	            onKeyDown: this._onKeyDown,
	            onKeyPress: this._onKeyPress,
	            onKeyUp: this._onKeyUp,
	            onMouseUp: this._onMouseUp,
	            onPaste: this._onPaste,
	            onSelect: this._onSelect,
	            ref: 'editor',
	            role: readOnly ? null : this.props.role || 'textbox',
	            spellCheck: allowSpellCheck && this.props.spellCheck,
	            style: contentStyle,
	            suppressContentEditableWarning: true,
	            tabIndex: this.props.tabIndex },
	          React.createElement(DraftEditorContents, {
	            blockRenderMap: this.props.blockRenderMap,
	            blockRendererFn: this.props.blockRendererFn,
	            blockStyleFn: this.props.blockStyleFn,
	            customStyleMap: _extends({}, DefaultDraftInlineStyle, this.props.customStyleMap),
	            customStyleFn: this.props.customStyleFn,
	            editorKey: this._editorKey,
	            editorState: this.props.editorState
	          })
	        )
	      )
	    );
	  };
	
	  DraftEditor.prototype.componentDidMount = function componentDidMount() {
	    this.setMode('edit');
	
	    /**
	     * IE has a hardcoded "feature" that attempts to convert link text into
	     * anchors in contentEditable DOM. This breaks the editor's expectations of
	     * the DOM, and control is lost. Disable it to make IE behave.
	     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	     * ie9-beta-minor-change-list.aspx
	     */
	    if (isIE) {
	      document.execCommand('AutoUrlDetect', false, false);
	    }
	  };
	
	  /**
	   * Prevent selection events from affecting the current editor state. This
	   * is mostly intended to defend against IE, which fires off `selectionchange`
	   * events regardless of whether the selection is set via the browser or
	   * programmatically. We only care about selection events that occur because
	   * of browser interaction, not re-renders and forced selections.
	   */
	
	
	  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate() {
	    this._blockSelectEvents = true;
	  };
	
	  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._blockSelectEvents = false;
	  };
	
	  /**
	   * Used via `this.focus()`.
	   *
	   * Force focus back onto the editor node.
	   *
	   * Forcing focus causes the browser to scroll to the top of the editor, which
	   * may be undesirable when the editor is taller than the viewport. To solve
	   * this, either use a specified scroll position (in cases like `cut` behavior
	   * where it should be restored to a known position) or store the current
	   * scroll state and put it back in place after focus has been forced.
	   */
	
	
	  DraftEditor.prototype._focus = function _focus(scrollPosition) {
	    var editorState = this.props.editorState;
	
	    var alreadyHasFocus = editorState.getSelection().getHasFocus();
	    var editorNode = ReactDOM.findDOMNode(this.refs.editor);
	
	    var scrollParent = Style.getScrollParent(editorNode);
	
	    var _ref = scrollPosition || getScrollPosition(scrollParent);
	
	    var x = _ref.x;
	    var y = _ref.y;
	
	
	    editorNode.focus();
	    if (scrollParent === window) {
	      window.scrollTo(x, y);
	    } else {
	      Scroll.setTop(scrollParent, y);
	    }
	
	    // On Chrome and Safari, calling focus on contenteditable focuses the
	    // cursor at the first character. This is something you don't expect when
	    // you're clicking on an input element but not directly on a character.
	    // Put the cursor back where it was before the blur.
	    if (!alreadyHasFocus) {
	      this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	    }
	  };
	
	  DraftEditor.prototype._blur = function _blur() {
	    ReactDOM.findDOMNode(this.refs.editor).blur();
	  };
	
	  /**
	   * Used via `this.setMode(...)`.
	   *
	   * Set the behavior mode for the editor component. This switches the current
	   * handler module to ensure that DOM events are managed appropriately for
	   * the active mode.
	   */
	
	
	  DraftEditor.prototype._setMode = function _setMode(mode) {
	    this._handler = handlerMap[mode];
	  };
	
	  DraftEditor.prototype._exitCurrentMode = function _exitCurrentMode() {
	    this.setMode('edit');
	  };
	
	  /**
	   * Used via `this.restoreEditorDOM()`.
	   *
	   * Force a complete re-render of the editor based on the current EditorState.
	   * This is useful when we know we are going to lose control of the DOM
	   * state (cut command, IME) and we want to make sure that reconciliation
	   * occurs on a version of the DOM that is synchronized with our EditorState.
	   */
	
	
	  DraftEditor.prototype._restoreEditorDOM = function _restoreEditorDOM(scrollPosition) {
	    var _this3 = this;
	
	    this.setState({ containerKey: this.state.containerKey + 1 }, function () {
	      _this3._focus(scrollPosition);
	    });
	  };
	
	  /**
	   * Guard against rendering. Intended for use when we need to manually
	   * reset editor contents, to ensure that no outside influences lead to
	   * React reconciliation when we are in an uncertain state.
	   */
	
	
	  DraftEditor.prototype._setRenderGuard = function _setRenderGuard() {
	    this._guardAgainstRender = true;
	  };
	
	  DraftEditor.prototype._removeRenderGuard = function _removeRenderGuard() {
	    this._guardAgainstRender = false;
	  };
	
	  /**
	   * Used via `this.setClipboard(...)`.
	   *
	   * Set the clipboard state for a cut/copy event.
	   */
	
	
	  DraftEditor.prototype._setClipboard = function _setClipboard(clipboard) {
	    this._clipboard = clipboard;
	  };
	
	  /**
	   * Used via `this.getClipboard()`.
	   *
	   * Retrieve the clipboard state for a cut/copy event.
	   */
	
	
	  DraftEditor.prototype._getClipboard = function _getClipboard() {
	    return this._clipboard;
	  };
	
	  /**
	   * Used via `this.update(...)`.
	   *
	   * Propagate a new `EditorState` object to higher-level components. This is
	   * the method by which event handlers inform the `DraftEditor` component of
	   * state changes. A component that composes a `DraftEditor` **must** provide
	   * an `onChange` prop to receive state updates passed along from this
	   * function.
	   */
	
	
	  DraftEditor.prototype._update = function _update(editorState) {
	    this.props.onChange(editorState);
	  };
	
	  /**
	   * Used in conjunction with `_onDragLeave()`, by counting the number of times
	   * a dragged element enters and leaves the editor (or any of its children),
	   * to determine when the dragged element absolutely leaves the editor.
	   */
	
	
	  DraftEditor.prototype._onDragEnter = function _onDragEnter() {
	    this._dragCount++;
	  };
	
	  /**
	   * See `_onDragEnter()`.
	   */
	
	
	  DraftEditor.prototype._onDragLeave = function _onDragLeave() {
	    this._dragCount--;
	    if (this._dragCount === 0) {
	      this.exitCurrentMode();
	    }
	  };
	
	  return DraftEditor;
	}(React.Component);
	
	DraftEditor.defaultProps = {
	  blockRenderMap: DefaultDraftBlockRenderMap,
	  blockRendererFn: emptyFunction.thatReturnsNull,
	  blockStyleFn: emptyFunction.thatReturns(''),
	  keyBindingFn: getDefaultKeyBinding,
	  readOnly: false,
	  spellCheck: false,
	  stripPastedStyles: false
	};
	
	
	module.exports = DraftEditor;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorCompositionHandler
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	var Keys = __webpack_require__(294);
	
	var getEntityKeyForSelection = __webpack_require__(290);
	var isSelectionAtLeafStart = __webpack_require__(442);
	
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	var RESOLVE_DELAY = 20;
	
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	var resolved = false;
	var stillComposing = false;
	var textInputData = '';
	
	var DraftEditorCompositionHandler = {
	  onBeforeInput: function onBeforeInput(e) {
	    textInputData = (textInputData || '') + e.data;
	  },
	
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart() {
	    stillComposing = true;
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd() {
	    var _this = this;
	
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition.call(_this);
	      }
	    }, RESOLVE_DELAY);
	  },
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(e) {
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition() {
	    if (stillComposing) {
	      return;
	    }
	
	    resolved = true;
	    var composedChars = textInputData;
	    textInputData = '';
	
	    var editorState = EditorState.set(this.props.editorState, {
	      inCompositionMode: false
	    });
	
	    var currentStyle = editorState.getCurrentInlineStyle();
	    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
	
	    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;
	
	    if (mustReset) {
	      this.restoreEditorDOM();
	    }
	
	    this.exitCurrentMode();
	    this.removeRenderGuard();
	
	    if (composedChars) {
	      // If characters have been composed, re-rendering with the update
	      // is sufficient to reset the editor.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
	      this.update(EditorState.push(editorState, contentState, 'insert-characters'));
	      return;
	    }
	
	    if (mustReset) {
	      this.update(EditorState.set(editorState, {
	        nativelyRenderedContent: null,
	        forceSelection: true
	      }));
	    }
	  }
	};
	
	module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(428);
	var DraftOffsetKey = __webpack_require__(200);
	var EditorState = __webpack_require__(24);
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(163);
	var joinClasses = __webpack_require__(1008);
	var nullthrows = __webpack_require__(57);
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	var DraftEditorContents = function (_React$Component) {
	  _inherits(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    _classCallCheck(this, DraftEditorContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap();
	
	    // Text direction has changed for one or more blocks. We must re-render.
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode();
	
	    // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  DraftEditorContents.prototype.render = function render() {
	    var _props = this.props;
	    var blockRenderMap = _props.blockRenderMap;
	    var blockRendererFn = _props.blockRendererFn;
	    var customStyleMap = _props.customStyleMap;
	    var customStyleFn = _props.customStyleFn;
	    var editorState = _props.editorState;
	
	
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	
	    var blocksAsArray = content.getBlocksAsArray();
	    var blocks = [];
	    var currentWrapperElement = null;
	    var currentWrapperTemplate = null;
	    var currentDepth = null;
	    var currentWrappedBlocks = void 0;
	    var block = void 0,
	        key = void 0,
	        blockType = void 0,
	        child = void 0,
	        childProps = void 0,
	        wrapperTemplate = void 0;
	
	    for (var ii = 0; ii < blocksAsArray.length; ii++) {
	      block = blocksAsArray[ii];
	      key = block.getKey();
	      blockType = block.getType();
	
	      var customRenderer = blockRendererFn(block);
	      var CustomComponent = void 0,
	          customProps = void 0,
	          customEditable = void 0;
	      if (customRenderer) {
	        CustomComponent = customRenderer.component;
	        customProps = customRenderer.props;
	        customEditable = customRenderer.editable;
	      }
	
	      var direction = directionMap.get(key);
	      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	      var componentProps = {
	        block: block,
	        blockProps: customProps,
	        customStyleMap: customStyleMap,
	        customStyleFn: customStyleFn,
	        decorator: decorator,
	        direction: direction,
	        forceSelection: forceSelection,
	        key: key,
	        offsetKey: offsetKey,
	        selection: selection,
	        tree: editorState.getBlockTree(key)
	      };
	
	      var configForType = blockRenderMap.get(blockType);
	
	      wrapperTemplate = configForType.wrapper;
	
	      var useNewWrapper = wrapperTemplate !== currentWrapperTemplate;
	
	      var _Element = configForType.element || blockRenderMap.get('unstyled').element;
	
	      var depth = block.getDepth();
	      var className = this.props.blockStyleFn(block);
	
	      // List items are special snowflakes, since we handle nesting and
	      // counters manually.
	      if (_Element === 'li') {
	        var shouldResetCount = useNewWrapper || currentDepth === null || depth > currentDepth;
	        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	      }
	
	      var Component = CustomComponent || DraftEditorBlock;
	      childProps = {
	        className: className,
	        'data-block': true,
	        'data-editor': this.props.editorKey,
	        'data-offset-key': offsetKey,
	        key: key
	      };
	      if (customEditable !== undefined) {
	        childProps = _extends({}, childProps, {
	          contentEditable: customEditable,
	          suppressContentEditableWarning: true
	        });
	      }
	
	      child = React.createElement(_Element, childProps, React.createElement(Component, componentProps));
	
	      if (wrapperTemplate) {
	        if (useNewWrapper) {
	          currentWrappedBlocks = [];
	          currentWrapperElement = React.cloneElement(wrapperTemplate, {
	            key: key + '-wrap',
	            'data-offset-key': offsetKey
	          }, currentWrappedBlocks);
	          currentWrapperTemplate = wrapperTemplate;
	          blocks.push(currentWrapperElement);
	        }
	        currentDepth = block.getDepth();
	        nullthrows(currentWrappedBlocks).push(child);
	      } else {
	        currentWrappedBlocks = null;
	        currentWrapperElement = null;
	        currentWrapperTemplate = null;
	        currentDepth = null;
	        blocks.push(child);
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { 'data-contents': 'true' },
	      blocks
	    );
	  };
	
	  return DraftEditorContents;
	}(React.Component);
	
	/**
	 * Provide default styling for list items. This way, lists will be styled with
	 * proper counters and indentation even if the caller does not specify
	 * their own styling at all. If more than five levels of nesting are needed,
	 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	 */
	
	
	function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth === 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	}
	
	module.exports = DraftEditorContents;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorDragHandler
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DataTransfer = __webpack_require__(446);
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	
	var findAncestorOffsetKey = __webpack_require__(289);
	var getTextContentFromFiles = __webpack_require__(439);
	var getUpdatedSelectionState = __webpack_require__(440);
	var nullthrows = __webpack_require__(57);
	
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	
	  if (document.caretRangeFromPoint) {
	    var dropRange = document.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd() {
	    this.exitCurrentMode();
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(e) {
	    var _this = this;
	
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	
	    var editorState = this.props.editorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	
	    e.preventDefault();
	    this.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	    if (files.length > 0) {
	      if (this.props.handleDroppedFiles && this.props.handleDroppedFiles(dropSelection, files)) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && _this.update(insertTextAtSelection(editorState, nullthrows(dropSelection), // flow wtf
	        fileText));
	      });
	      return;
	    }
	
	    var dragType = this._internalDrag ? 'internal' : 'external';
	    if (this.props.handleDrop && this.props.handleDrop(dropSelection, data, dragType)) {
	      return;
	    }
	
	    if (this._internalDrag) {
	      this.update(moveText(editorState, dropSelection));
	      return;
	    }
	
	    this.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	  }
	
	};
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	/**
	 * Insert text at a specified selection.
	 */
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorEditHandler
	 * 
	 */
	
	'use strict';
	
	var onBeforeInput = __webpack_require__(951);
	var onBlur = __webpack_require__(952);
	var onCompositionStart = __webpack_require__(953);
	var onCopy = __webpack_require__(954);
	var onCut = __webpack_require__(955);
	var onDragOver = __webpack_require__(956);
	var onDragStart = __webpack_require__(957);
	var onFocus = __webpack_require__(958);
	var onInput = __webpack_require__(959);
	var onKeyDown = __webpack_require__(960);
	var onPaste = __webpack_require__(961);
	var onSelect = __webpack_require__(962);
	
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect
	};
	
	module.exports = DraftEditorEditHandler;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorLeaf.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorTextNode = __webpack_require__(937);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var SelectionState = __webpack_require__(133);
	
	var setDraftEditorSelection = __webpack_require__(985);
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	var DraftEditorLeaf = function (_React$Component) {
	  _inherits(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    _classCallCheck(this, DraftEditorLeaf);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  /**
	   * By making individual leaf instances aware of their context within
	   * the text of the editor, we can set our selection range more
	   * easily than we could in the non-React world.
	   *
	   * Note that this depends on our maintaining tight control over the
	   * DOM structure of the TextEditor component. If leaves had multiple
	   * text nodes, this would be harder.
	   */
	  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
	    var selection = this.props.selection;
	
	    // If selection state is irrelevant to the parent block, no-op.
	
	    if (selection == null || !selection.getHasFocus()) {
	      return;
	    }
	
	    var _props = this.props;
	    var blockKey = _props.blockKey;
	    var start = _props.start;
	    var text = _props.text;
	
	    var end = start + text.length;
	    if (!selection.hasEdgeWithin(blockKey, start, end)) {
	      return;
	    }
	
	    // Determine the appropriate target node for selection. If the child
	    // is not a text node, it is a <br /> spacer. In this case, use the
	    // <span> itself as the selection target.
	    var node = ReactDOM.findDOMNode(this);
	    var child = node.firstChild;
	    var targetNode = void 0;
	
	    if (child.nodeType === Node.TEXT_NODE) {
	      targetNode = child;
	    } else if (child.tagName === 'BR') {
	      targetNode = node;
	    } else {
	      targetNode = child.firstChild;
	    }
	
	    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	  };
	
	  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return ReactDOM.findDOMNode(this.refs.leaf).textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	  };
	
	  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.render = function render() {
	    var text = this.props.text;
	
	    // If the leaf is at the end of its block and ends in a soft newline, append
	    // an extra line feed character. Browsers collapse trailing newline
	    // characters, which leaves the cursor in the wrong place after a
	    // shift+enter. The extra character repairs this.
	
	    if (text.endsWith('\n') && this.props.isLast) {
	      text += '\n';
	    }
	
	    var _props2 = this.props;
	    var customStyleMap = _props2.customStyleMap;
	    var customStyleFn = _props2.customStyleFn;
	    var offsetKey = _props2.offsetKey;
	    var styleSet = _props2.styleSet;
	
	    var styleObj = styleSet.reduce(function (map, styleName) {
	      var mergedStyles = {};
	      var style = customStyleMap[styleName];
	
	      if (style !== undefined && map.textDecoration !== style.textDecoration) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
	      }
	
	      return _assign(map, style, mergedStyles);
	    }, {});
	
	    if (customStyleFn) {
	      var newStyles = customStyleFn(styleSet);
	      styleObj = _assign(styleObj, newStyles);
	    }
	
	    return React.createElement(
	      'span',
	      {
	        'data-offset-key': offsetKey,
	        ref: 'leaf',
	        style: styleObj },
	      React.createElement(
	        DraftEditorTextNode,
	        null,
	        text
	      )
	    );
	  };
	
	  return DraftEditorLeaf;
	}(React.Component);
	
	module.exports = DraftEditorLeaf;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorPlaceholder.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(163);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	var DraftEditorPlaceholder = function (_React$Component) {
	  _inherits(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    _classCallCheck(this, DraftEditorPlaceholder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	  };
	
	  DraftEditorPlaceholder.prototype.render = function render() {
	    var hasFocus = this.props.editorState.getSelection().getHasFocus();
	
	    var className = cx({
	      'public/DraftEditorPlaceholder/root': true,
	      'public/DraftEditorPlaceholder/hasFocus': hasFocus
	    });
	
	    return React.createElement(
	      'div',
	      { className: className },
	      React.createElement(
	        'div',
	        {
	          className: cx('public/DraftEditorPlaceholder/inner'),
	          id: this.props.accessibilityID },
	        this.props.text
	      )
	    );
	  };
	
	  return DraftEditorPlaceholder;
	}(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorTextNode.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var UserAgent = __webpack_require__(71);
	
	// In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	
	/**
	 * Check whether the node should be considered a newline.
	 */
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	var NEWLINE_A = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'A', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'A', 'data-text': 'true' });
	
	var NEWLINE_B = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'B', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'B', 'data-text': 'true' });
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	var DraftEditorTextNode = function (_React$Component) {
	  _inherits(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    _classCallCheck(this, DraftEditorTextNode);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._forceFlag = false;
	    return _this;
	  }
	
	  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var node = ReactDOM.findDOMNode(this);
	    var shouldBeNewline = nextProps.children === '';
	    if (shouldBeNewline) {
	      return !isNewline(node);
	    }
	    return node.textContent !== nextProps.children;
	  };
	
	  DraftEditorTextNode.prototype.componentWillUpdate = function componentWillUpdate() {
	    // By flipping this flag, we also keep flipping keys which forces
	    // React to remount this node every time it rerenders.
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.render = function render() {
	    if (this.props.children === '') {
	      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
	    }
	    return React.createElement(
	      'span',
	      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
	      this.props.children
	    );
	  };
	
	  return DraftEditorTextNode;
	}(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntitySegments
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	      return segment;
	    });
	
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length;
	
	      // Our selection overlaps this segment.
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	
	module.exports = DraftEntitySegments;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftPasteProcessor
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(63);
	var ContentBlock = __webpack_require__(110);
	var Immutable = __webpack_require__(26);
	
	var convertFromHTMLtoContentBlocks = __webpack_require__(432);
	var generateRandomKey = __webpack_require__(70);
	var getSafeBodyFromHTML = __webpack_require__(437);
	var sanitizeDraftText = __webpack_require__(292);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	
	
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	  processText: function processText(textBlocks, character) {
	    return textBlocks.map(function (textLine) {
	      textLine = sanitizeDraftText(textLine);
	      return new ContentBlock({
	        key: generateRandomKey(),
	        type: 'unstyled',
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      });
	    });
	  }
	};
	
	module.exports = DraftPasteProcessor;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorBidiService
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	var UnicodeBidiService = __webpack_require__(994);
	
	var nullthrows = __webpack_require__(57);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var bidiService;
	
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	
	module.exports = EditorBidiService;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule RichTextEditorUtil
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(84);
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	var SelectionState = __webpack_require__(133);
	
	var adjustBlockDepthForContentState = __webpack_require__(943);
	var nullthrows = __webpack_require__(57);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && DraftEntity.get(entity).getType() === 'LINK';
	    });
	  },
	
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return { url: uri.toString() };
	  },
	
	  handleKeyCommand: function handleKeyCommand(editorState, command) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	      default:
	        return null;
	    }
	  },
	
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    }
	
	    // First, try to remove a preceding atomic block.
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var atomicBlockTarget = selection.merge({
	        anchorKey: blockBefore.getKey(),
	        anchorOffset: 0
	      });
	      var asCurrentStyle = DraftModifier.setBlockType(content, atomicBlockTarget, content.getBlockForKey(startKey).getType());
	      var withoutAtomicBlock = DraftModifier.removeRange(asCurrentStyle, atomicBlockTarget, 'backward');
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    }
	
	    // If that doesn't succeed, try to remove the current block style.
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength();
	
	    // The cursor is somewhere within the text. Behave normally.
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	
	    // Only allow indenting one level beyond the block above, and only if
	    // the block above is a list item as well.
	    var blockAbove = content.getBlockBefore(key);
	    if (!blockAbove) {
	      return editorState;
	    }
	
	    var typeAbove = blockAbove.getType();
	    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    var depth = block.getDepth();
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection;
	
	    // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).takeWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle();
	
	    // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    }
	
	    // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	    var content = editorState.getCurrentContent();
	    var newContent;
	
	    // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of an empty styled block, allow
	   * certain key commands (newline, backspace) to simply change the
	   * style of the block instead of the default behavior.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	      if (block.getLength() > 0) {
	        return null;
	      }
	
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block') {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	    return null;
	  }
	};
	
	module.exports = RichTextEditorUtil;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SecondaryClipboard
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	
	var getContentStateFragment = __webpack_require__(202);
	var nullthrows = __webpack_require__(57);
	
	var clipboard = null;
	
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        return editorState;
	      }
	
	      targetRange = selection.set('focusOffset', blockEnd);
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange);
	    clipboard = getContentStateFragment(content, targetRange);
	
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = SecondaryClipboard;

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adjustBlockDepthForContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	
	  blockMap = blockMap.merge(blocks);
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentBlock
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(63);
	
	function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
	  var characterList = contentBlock.getCharacterList();
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var applyEntityToContentBlock = __webpack_require__(944);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromDraftStateToRaw
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(84);
	var DraftStringKey = __webpack_require__(431);
	
	var encodeEntityRanges = __webpack_require__(963);
	var encodeInlineStyleRanges = __webpack_require__(964);
	
	function convertFromDraftStateToRaw(contentState) {
	  var entityStorageKey = 0;
	  var entityStorageMap = {};
	  var rawBlocks = [];
	
	  contentState.getBlockMap().forEach(function (block, blockKey) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      // Stringify to maintain order of otherwise numeric keys.
	      var stringifiedEntityKey = DraftStringKey.stringify(block.getEntityAt(start));
	      if (!entityStorageMap.hasOwnProperty(stringifiedEntityKey)) {
	        entityStorageMap[stringifiedEntityKey] = '' + entityStorageKey++;
	      }
	    });
	
	    rawBlocks.push({
	      key: blockKey,
	      text: block.getText(),
	      type: block.getType(),
	      depth: canHaveDepth(block) ? block.getDepth() : 0,
	      inlineStyleRanges: encodeInlineStyleRanges(block),
	      entityRanges: encodeEntityRanges(block, entityStorageMap),
	      data: block.getData().toObject()
	    });
	  });
	
	  // Flip storage map so that our storage keys map to global
	  // DraftEntity keys.
	  var entityKeys = Object.keys(entityStorageMap);
	  var flippedStorageMap = {};
	  entityKeys.forEach(function (key, jj) {
	    var entity = DraftEntity.get(DraftStringKey.unstringify(key));
	    flippedStorageMap[jj] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	
	  return {
	    entityMap: flippedStorageMap,
	    blocks: rawBlocks
	  };
	}
	
	function canHaveDepth(block) {
	  var type = block.getType();
	  return type === 'ordered-list-item' || type === 'unordered-list-item';
	}
	
	module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromRawToDraftState
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(110);
	var ContentState = __webpack_require__(286);
	var DraftEntity = __webpack_require__(84);
	var Immutable = __webpack_require__(26);
	
	var createCharacterList = __webpack_require__(948);
	var decodeEntityRanges = __webpack_require__(949);
	var decodeInlineStyleRanges = __webpack_require__(950);
	var generateRandomKey = __webpack_require__(70);
	
	var Map = Immutable.Map;
	
	
	function convertFromRawToDraftState(rawState) {
	  var blocks = rawState.blocks;
	  var entityMap = rawState.entityMap;
	
	
	  var fromStorageToLocal = {};
	  Object.keys(entityMap).forEach(function (storageKey) {
	    var encodedEntity = entityMap[storageKey];
	    var type = encodedEntity.type;
	    var mutability = encodedEntity.mutability;
	    var data = encodedEntity.data;
	
	    var newKey = DraftEntity.create(type, mutability, data || {});
	    fromStorageToLocal[storageKey] = newKey;
	  });
	
	  var contentBlocks = blocks.map(function (block) {
	    var key = block.key;
	    var type = block.type;
	    var text = block.text;
	    var depth = block.depth;
	    var inlineStyleRanges = block.inlineStyleRanges;
	    var entityRanges = block.entityRanges;
	    var data = block.data;
	
	    key = key || generateRandomKey();
	    depth = depth || 0;
	    inlineStyleRanges = inlineStyleRanges || [];
	    entityRanges = entityRanges || [];
	    data = Map(data);
	
	    var inlineStyles = decodeInlineStyleRanges(text, inlineStyleRanges);
	
	    // Translate entity range keys to the DraftEntity map.
	    var filteredEntityRanges = entityRanges.filter(function (range) {
	      return fromStorageToLocal.hasOwnProperty(range.key);
	    }).map(function (range) {
	      return _extends({}, range, { key: fromStorageToLocal[range.key] });
	    });
	
	    var entities = decodeEntityRanges(text, filteredEntityRanges);
	    var characterList = createCharacterList(inlineStyles, entities);
	
	    return new ContentBlock({ key: key, type: type, text: text, depth: depth, characterList: characterList, data: data });
	  });
	
	  return ContentState.createFromBlockArray(contentBlocks);
	}
	
	module.exports = convertFromRawToDraftState;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createCharacterList
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(63);
	var Immutable = __webpack_require__(26);
	
	var List = Immutable.List;
	
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({ style: style, entity: entity });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeEntityRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(111);
	
	var substr = UnicodeUtils.substr;
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeInlineStyleRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(111);
	
	var _require = __webpack_require__(26);
	
	var OrderedSet = _require.OrderedSet;
	var substr = UnicodeUtils.substr;
	
	
	var EMPTY_SET = OrderedSet();
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	  if (ranges) {
	    ranges.forEach(function ( /*object*/range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBeforeInput
	 * 
	 */
	
	'use strict';
	
	var BlockTree = __webpack_require__(426);
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	var UserAgent = __webpack_require__(71);
	
	var getEntityKeyForSelection = __webpack_require__(290);
	var isSelectionAtLeafStart = __webpack_require__(442);
	var nullthrows = __webpack_require__(57);
	
	// When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	var FF_QUICKFIND_CHAR = '\'';
	var FF_QUICKFIND_LINK_CHAR = '\/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	function replaceText(editorState, text, inlineStyle, entityKey) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters');
	}
	
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	function editOnBeforeInput(e) {
	  var chars = e.data;
	
	  // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	  if (!chars) {
	    return;
	  }
	
	  // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	  if (this.props.handleBeforeInput && this.props.handleBeforeInput(chars)) {
	    e.preventDefault();
	    return;
	  }
	
	  // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	    this.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
	    return;
	  }
	
	  var mayAllowNative = !isSelectionAtLeafStart(editorState);
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
	
	  if (!mayAllowNative) {
	    e.preventDefault();
	    this.update(newEditorState);
	    return;
	  }
	
	  var anchorKey = selection.getAnchorKey();
	  var anchorTree = editorState.getBlockTree(anchorKey);
	
	  // Check the old and new "fingerprints" of the current block to determine
	  // whether this insertion requires any addition or removal of text nodes,
	  // in which case we would prevent the native character insertion.
	  var originalFingerprint = BlockTree.getFingerprint(anchorTree);
	  var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
	
	  if (mustPreventDefaultForCharacter(chars) || originalFingerprint !== newFingerprint || nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey)) {
	    e.preventDefault();
	  } else {
	    // The native event is allowed to occur.
	    newEditorState = EditorState.set(newEditorState, {
	      nativelyRenderedContent: newEditorState.getCurrentContent()
	    });
	  }
	
	  this.update(newEditorState);
	}
	
	module.exports = editOnBeforeInput;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBlur
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var UserAgent = __webpack_require__(71);
	
	var getActiveElement = __webpack_require__(203);
	
	var isWebKit = UserAgent.isEngine('WebKit');
	
	function editOnBlur(e) {
	  // Webkit has a bug in which blurring a contenteditable by clicking on
	  // other active elements will trigger the `blur` event but will not remove
	  // the DOM selection from the contenteditable. We therefore force the
	  // issue to be certain, checking whether the active element is `body`
	  // to force it when blurring occurs within the window (as opposed to
	  // clicking to another tab or window).
	  if (isWebKit && getActiveElement() === document.body) {
	    global.getSelection().removeAllRanges();
	  }
	
	  var editorState = this.props.editorState;
	  var currentSelection = editorState.getSelection();
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  this.props.onBlur && this.props.onBlur(e);
	  this.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCompositionStart
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	function editOnCompositionStart() {
	  this.setRenderGuard();
	  this.setMode('composite');
	  this.update(EditorState.set(this.props.editorState, { inCompositionMode: true }));
	}
	
	module.exports = editOnCompositionStart;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCopy
	 * 
	 */
	
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(435);
	
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	function editOnCopy(e) {
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to copy.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  this.setClipboard(getFragmentFromSelection(this.props.editorState));
	}
	
	module.exports = editOnCopy;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCut
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	var Style = __webpack_require__(295);
	
	var getFragmentFromSelection = __webpack_require__(435);
	var getScrollPosition = __webpack_require__(298);
	
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	function editOnCut(e) {
	  var _this = this;
	
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to cut.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	  var scrollParent = Style.getScrollParent(e.target);
	
	  var _getScrollPosition = getScrollPosition(scrollParent);
	
	  var x = _getScrollPosition.x;
	  var y = _getScrollPosition.y;
	
	
	  var fragment = getFragmentFromSelection(editorState);
	  this.setClipboard(fragment);
	
	  // Set `cut` mode to disable all event handling temporarily.
	  this.setRenderGuard();
	  this.setMode('cut');
	
	  // Let native `cut` behavior occur, then recover control.
	  setTimeout(function () {
	    _this.restoreEditorDOM({ x: x, y: y });
	    _this.removeRenderGuard();
	    _this.exitCurrentMode();
	    _this.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragOver
	 * 
	 */
	
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	
	function editOnDragOver(e) {
	  this._internalDrag = false;
	  this.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragStart
	 * 
	 */
	
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	
	function editOnDragStart() {
	  this._internalDrag = true;
	  this.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnFocus
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	function editOnFocus(e) {
	  var editorState = this.props.editorState;
	  var currentSelection = editorState.getSelection();
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  this.props.onFocus && this.props.onFocus(e);
	
	  // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  this.update(EditorState.forceSelection(editorState, selection));
	}
	
	module.exports = editOnFocus;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnInput
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	var DraftOffsetKey = __webpack_require__(200);
	var EditorState = __webpack_require__(24);
	var Entity = __webpack_require__(84);
	var UserAgent = __webpack_require__(71);
	
	var findAncestorOffsetKey = __webpack_require__(289);
	var nullthrows = __webpack_require__(57);
	
	var isGecko = UserAgent.isEngine('Gecko');
	
	var DOUBLE_NEWLINE = '\n\n';
	
	/**
	 * This function is intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	function editOnInput() {
	  var domSelection = global.getSelection();
	
	  var anchorNode = domSelection.anchorNode;
	  var isCollapsed = domSelection.isCollapsed;
	
	  if (anchorNode.nodeType !== Node.TEXT_NODE) {
	    return;
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = this.props.editorState;
	
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey);
	
	  var blockKey = _DraftOffsetKey$decod.blockKey;
	  var decoratorKey = _DraftOffsetKey$decod.decoratorKey;
	  var leafKey = _DraftOffsetKey$decod.leafKey;
	
	  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]);
	
	  var start = _editorState$getBlock.start;
	  var end = _editorState$getBlock.end;
	
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end);
	
	  // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  }
	
	  // No change -- the DOM is up to date. Nothing to do here.
	  if (domText === modelText) {
	    return;
	  }
	
	  var selection = editorState.getSelection();
	
	  // We'll replace the entire leaf with the text content of the target.
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	
	  var entityKey = block.getEntityAt(start);
	  var entity = entityKey && Entity.get(entityKey);
	  var entityType = entity && entity.getMutability();
	  var preserveEntity = entityType === 'MUTABLE';
	
	  // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  }
	
	  // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
	  });
	
	  this.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnKeyDown
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	var KeyBindingUtil = __webpack_require__(288);
	var Keys = __webpack_require__(294);
	var SecondaryClipboard = __webpack_require__(942);
	var UserAgent = __webpack_require__(71);
	
	var keyCommandBackspaceToStartOfLine = __webpack_require__(973);
	var keyCommandBackspaceWord = __webpack_require__(974);
	var keyCommandDeleteWord = __webpack_require__(975);
	var keyCommandInsertNewline = __webpack_require__(976);
	var keyCommandPlainBackspace = __webpack_require__(979);
	var keyCommandPlainDelete = __webpack_require__(980);
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(977);
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(978);
	var keyCommandTransposeCharacters = __webpack_require__(981);
	var keyCommandUndo = __webpack_require__(982);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	function onKeyCommand(command, editorState) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState);
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	    default:
	      return editorState;
	  }
	}
	
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	function editOnKeyDown(e) {
	  var keyCode = e.which;
	  var editorState = this.props.editorState;
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault();
	      // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	      if (this.props.handleReturn && this.props.handleReturn(e)) {
	        return;
	      }
	      break;
	    case Keys.ESC:
	      e.preventDefault();
	      this.props.onEscape && this.props.onEscape(e);
	      return;
	    case Keys.TAB:
	      this.props.onTab && this.props.onTab(e);
	      return;
	    case Keys.UP:
	      this.props.onUpArrow && this.props.onUpArrow(e);
	      return;
	    case Keys.DOWN:
	      this.props.onDownArrow && this.props.onDownArrow(e);
	      return;
	    case Keys.SPACE:
	      // Handling for OSX where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	        // Insert a nbsp into the editor.
	        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), ' ');
	        this.update(EditorState.push(editorState, contentState, 'insert-characters'));
	        return;
	      }
	  }
	
	  var command = this.props.keyBindingFn(e);
	
	  // If no command is specified, allow keydown event to continue.
	  if (!command) {
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, this.update);
	    return;
	  }
	
	  // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	  e.preventDefault();
	
	  // Allow components higher up the tree to handle the command first.
	  if (this.props.handleKeyCommand && this.props.handleKeyCommand(command)) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState);
	  if (newState !== editorState) {
	    this.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnPaste
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(160);
	var CharacterMetadata = __webpack_require__(63);
	var DataTransfer = __webpack_require__(446);
	var DraftModifier = __webpack_require__(41);
	var DraftPasteProcessor = __webpack_require__(939);
	var EditorState = __webpack_require__(24);
	
	var getEntityKeyForSelection = __webpack_require__(290);
	var getTextContentFromFiles = __webpack_require__(439);
	var splitTextIntoTextBlocks = __webpack_require__(987);
	
	/**
	 * Paste content.
	 */
	function editOnPaste(e) {
	  var _this = this;
	
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData);
	
	  // Get files, unless this is likely to be a string the user wants inline.
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (this.props.handlePastedFiles && this.props.handlePastedFiles(files)) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function ( /*string*/fileText) {
	        fileText = fileText || defaultFileText;
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = _this.props.editorState;
	
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	
	        var text = DraftPasteProcessor.processText(blocks, character);
	        var fragment = BlockMapBuilder.createFromArray(text);
	
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	
	        _this.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	
	  if (this.props.handlePastedText && this.props.handlePastedText(text, html)) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!this.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = this.getClipboard();
	    if (data.isRichText() && internalClipboard) {
	      if (
	      // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      html.indexOf(this.getEditorKey()) !== -1 ||
	      // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        this.update(insertFragment(this.props.editorState, internalClipboard));
	        return;
	      }
	    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
	      // Safari does not properly store text/html in some cases.
	      // Use the internalClipboard if present and equal to what is on
	      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
	      this.update(insertFragment(this.props.editorState, internalClipboard));
	      return;
	    }
	
	    // If there is html paste data, try to parse that.
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, this.props.blockRenderMap);
	      if (htmlFragment) {
	        var htmlMap = BlockMapBuilder.createFromArray(htmlFragment);
	        this.update(insertFragment(this.props.editorState, htmlMap));
	        return;
	      }
	    }
	
	    // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	    this.setClipboard(null);
	  }
	
	  if (textBlocks) {
	    var editorState = this.props.editorState;
	
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character);
	
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    this.update(insertFragment(this.props.editorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	  return EditorState.push(editorState, newContent, 'insert-fragment');
	}
	
	function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
	  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
	    return block.getText() === textBlocks[ii];
	  });
	}
	
	module.exports = editOnPaste;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnSelect
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var ReactDOM = __webpack_require__(18);
	
	var getDraftEditorSelection = __webpack_require__(967);
	
	function editOnSelect() {
	  if (this._blockSelectEvents) {
	    return;
	  }
	
	  var editorState = this.props.editorState;
	  var documentSelection = getDraftEditorSelection(editorState, ReactDOM.findDOMNode(this.refs.editorContainer).firstChild);
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	    this.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeEntityRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = __webpack_require__(431);
	var UnicodeUtils = __webpack_require__(111);
	
	var strlen = UnicodeUtils.strlen;
	
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function ( /*number*/start, /*number*/end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeInlineStyleRanges
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(111);
	
	var findRangesImmutable = __webpack_require__(201);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	var EMPTY_ARRAY = [];
	
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = [];
	
	  // Obtain an array with ranges for only the specified style.
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	
	  findRangesImmutable(filteredInlines, areEqual,
	  // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	
	  return ranges;
	}
	
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule expandRangeToStartOfLine
	 * @typechecks
	 * 
	 */
	
	var UnicodeUtils = __webpack_require__(111);
	
	var getRangeClientRects = __webpack_require__(436);
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var div = document.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	
	  // forced layout here
	  document.body.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  document.body.removeChild(div);
	
	  return rect.height;
	}
	
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	    default:
	      return node.childNodes.length;
	  }
	}
	
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
	  range = range.cloneRange();
	
	  var containingElement = range.startContainer;
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	  var lineHeight = getLineHeightPx(containingElement);
	
	  // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
	    range.setStartBefore(bestContainer);
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  }
	
	  // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	
	    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getCharacterRemovalRange
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(84);
	var DraftEntitySegments = __webpack_require__(938);
	
	var getRangesForDraftEntity = __webpack_require__(969);
	var invariant = __webpack_require__(7);
	
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	function getCharacterRemovalRange(block, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var entityKey = block.getEntityAt(start);
	  if (!entityKey) {
	    return selectionState;
	  }
	
	  var entity = DraftEntity.get(entityKey);
	  var mutability = entity.getMutability();
	
	  // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  }
	
	  // Find the entity range that overlaps with our removal range.
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return start < range.end && end > range.start;
	  });
	
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
	
	  var entityRange = entityRanges[0];
	
	  // For `IMMUTABLE` entity types, we will remove the entire entity range.
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  }
	
	  // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelection
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(434);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelection(editorState, root) {
	  var selection = global.getSelection();
	
	  // No active selection.
	  if (selection.rangeCount === 0) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	}
	
	module.exports = getDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeBoundingClientRect
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getRangeClientRects = __webpack_require__(436);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    var _rects$ = rects[0];
	    top = _rects$.top;
	    right = _rects$.right;
	    bottom = _rects$.bottom;
	    left = _rects$.left;
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	      if (rect.height !== 0 || rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangesForDraftEntity
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({ start: start, end: end });
	  });
	
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
	
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVisibleSelectionRect
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(968);
	
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 */
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top;
	  var right = boundingRect.right;
	  var bottom = boundingRect.bottom;
	  var left = boundingRect.left;
	
	  // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertFragmentIntoContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(160);
	
	var generateRandomKey = __webpack_require__(70);
	var insertIntoList = __webpack_require__(441);
	var invariant = __webpack_require__(7);
	
	function insertFragmentIntoContentState(contentState, selectionState, fragment) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
	
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	
	  var blockMap = contentState.getBlockMap();
	
	  var fragmentSize = fragment.size;
	  var finalKey;
	  var finalOffset;
	
	  if (fragmentSize === 1) {
	    var targetBlock = blockMap.get(targetKey);
	    var pastedBlock = fragment.first();
	    var text = targetBlock.getText();
	    var chars = targetBlock.getCharacterList();
	
	    var newBlock = targetBlock.merge({
	      text: text.slice(0, targetOffset) + pastedBlock.getText() + text.slice(targetOffset),
	      characterList: insertIntoList(chars, pastedBlock.getCharacterList(), targetOffset),
	      data: pastedBlock.getData()
	    });
	
	    blockMap = blockMap.set(targetKey, newBlock);
	
	    finalKey = targetKey;
	    finalOffset = targetOffset + pastedBlock.getText().length;
	
	    return contentState.merge({
	      blockMap: blockMap.set(targetKey, newBlock),
	      selectionBefore: selectionState,
	      selectionAfter: selectionState.merge({
	        anchorKey: finalKey,
	        anchorOffset: finalOffset,
	        focusKey: finalKey,
	        focusOffset: finalOffset,
	        isBackward: false
	      })
	    });
	  }
	
	  var newBlockArr = [];
	
	  contentState.getBlockMap().forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    // Modify head portion of block.
	    var blockSize = text.length;
	    var headText = text.slice(0, targetOffset);
	    var headCharacters = chars.slice(0, targetOffset);
	    var appendToHead = fragment.first();
	
	    var modifiedHead = block.merge({
	      text: headText + appendToHead.getText(),
	      characterList: headCharacters.concat(appendToHead.getCharacterList()),
	      type: headText ? block.getType() : appendToHead.getType(),
	      data: appendToHead.getData()
	    });
	
	    newBlockArr.push(modifiedHead);
	
	    // Insert fragment blocks after the head and before the tail.
	    fragment.slice(1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      newBlockArr.push(fragmentBlock.set('key', generateRandomKey()));
	    });
	
	    // Modify tail portion of block.
	    var tailText = text.slice(targetOffset, blockSize);
	    var tailCharacters = chars.slice(targetOffset, blockSize);
	    var prependToTail = fragment.last();
	    finalKey = generateRandomKey();
	
	    var modifiedTail = prependToTail.merge({
	      key: finalKey,
	      text: prependToTail.getText() + tailText,
	      characterList: prependToTail.getCharacterList().concat(tailCharacters),
	      data: prependToTail.getData()
	    });
	
	    newBlockArr.push(modifiedTail);
	  });
	
	  finalOffset = fragment.last().getLength();
	
	  return contentState.merge({
	    blockMap: BlockMapBuilder.createFromArray(newBlockArr),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	}
	
	module.exports = insertFragmentIntoContentState;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertTextIntoContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var insertIntoList = __webpack_require__(441);
	var invariant = __webpack_require__(7);
	
	var Repeat = Immutable.Repeat;
	
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
	
	  var len = text.length;
	  if (!len) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	
	  var newOffset = offset + len;
	
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceToStartOfLine
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	var expandRangeToStartOfLine = __webpack_require__(965);
	var getDraftEditorSelectionWithNodes = __webpack_require__(434);
	var moveSelectionBackward = __webpack_require__(291);
	var removeTextWithStrategy = __webpack_require__(162);
	
	function keyCommandBackspaceToStartOfLine(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var domSelection = global.getSelection();
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceWord
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(430);
	var EditorState = __webpack_require__(24);
	
	var moveSelectionBackward = __webpack_require__(291);
	var removeTextWithStrategy = __webpack_require__(162);
	
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    // If there are no words before the cursor, remove the preceding newline.
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandDeleteWord
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(430);
	var EditorState = __webpack_require__(24);
	
	var moveSelectionForward = __webpack_require__(443);
	var removeTextWithStrategy = __webpack_require__(162);
	
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text);
	
	    // If there are no words in front of the cursor, remove the newline.
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandInsertNewline
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToEndOfBlock
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToStartOfBlock
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainBackspace
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var UnicodeUtils = __webpack_require__(111);
	
	var moveSelectionBackward = __webpack_require__(291);
	var removeTextWithStrategy = __webpack_require__(162);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainDelete
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	var UnicodeUtils = __webpack_require__(111);
	
	var moveSelectionForward = __webpack_require__(443);
	var removeTextWithStrategy = __webpack_require__(162);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandTransposeCharacters
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(41);
	var EditorState = __webpack_require__(24);
	
	var getContentStateFragment = __webpack_require__(202);
	
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength();
	
	  // Nothing to transpose if there aren't two characters.
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  }
	
	  // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');
	
	  // After the removal, the insertion target is one character back.
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandUndo
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(24);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState);
	
	  // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
	    return;
	  }
	
	  // Otheriwse, manage the undo behavior manually.
	  e.preventDefault();
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  }
	
	  // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));
	
	  // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule modifyBlockForContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var Map = Immutable.Map;
	
	
	function modifyBlockForContentState(contentState, selectionState, operation) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = modifyBlockForContentState;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeRangeFromContentState
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey);
	  var characterList;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  });
	
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Immutable.Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	
	  blockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  });
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	}
	
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = removeRangeFromContentState;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setDraftEditorSelection
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var containsNode = __webpack_require__(297);
	var getActiveElement = __webpack_require__(203);
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  if (!containsNode(document.documentElement, node)) {
	    return;
	  }
	
	  var selection = global.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward();
	
	  // IE doesn't support backward selection. Swap key/offset pairs.
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
	
	  // If the selection is entirely bound within this node, set the selection
	  // and be done.
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart);
	    addFocusToSelection(selection, node, focusOffset - nodeStart);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart);
	    }
	
	    // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart);
	    }
	
	    // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset);
	    }
	  }
	}
	
	/**
	 * Extend selection towards focus point.
	 */
	function addFocusToSelection(selection, node, offset) {
	  if (selection.extend && containsNode(getActiveElement(), node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	    selection.extend(node, offset);
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    var range = selection.getRangeAt(0);
	    range.setEnd(node, offset);
	    selection.addRange(range.cloneRange());
	  }
	}
	
	function addPointToSelection(selection, node, offset) {
	  var range = document.createRange();
	  range.setStart(node, offset);
	  selection.addRange(range);
	}
	
	module.exports = setDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitBlockInContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var generateRandomKey = __webpack_require__(70);
	var invariant = __webpack_require__(7);
	
	var Map = Immutable.Map;
	
	
	function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
	
	  var key = selectionState.getAnchorKey();
	  var offset = selectionState.getAnchorOffset();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	
	  var text = blockToSplit.getText();
	  var chars = blockToSplit.getCharacterList();
	
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	
	  var keyBelow = generateRandomKey();
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset),
	    data: Map()
	  });
	
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[blockAbove.getKey(), blockAbove], [blockBelow.getKey(), blockBelow]], blocksAfter).toOrderedMap();
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	}
	
	module.exports = splitBlockInContentState;

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitTextIntoTextBlocks
	 * 
	 */
	
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var entityMap = __webpack_require__(237),
	    legacyMap = __webpack_require__(371),
	    xmlMap    = __webpack_require__(238),
	    decodeCodePoint = __webpack_require__(445);
	
	var decodeXMLStrict  = getStrictDecoder(xmlMap),
	    decodeHTMLStrict = getStrictDecoder(entityMap);
	
	function getStrictDecoder(map){
		var keys = Object.keys(map).join("|"),
		    replace = getReplacer(map);
	
		keys += "|#[xX][\\da-fA-F]+|#\\d+";
	
		var re = new RegExp("&(?:" + keys + ");", "g");
	
		return function(str){
			return String(str).replace(re, replace);
		};
	}
	
	var decodeHTML = (function(){
		var legacy = Object.keys(legacyMap)
			.sort(sorter);
	
		var keys = Object.keys(entityMap)
			.sort(sorter);
	
		for(var i = 0, j = 0; i < keys.length; i++){
			if(legacy[j] === keys[i]){
				keys[i] += ";?";
				j++;
			} else {
				keys[i] += ";";
			}
		}
	
		var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
		    replace = getReplacer(entityMap);
	
		function replacer(str){
			if(str.substr(-1) !== ";") str += ";";
			return replace(str);
		}
	
		//TODO consider creating a merged map
		return function(str){
			return String(str).replace(re, replacer);
		};
	}());
	
	function sorter(a, b){
		return a < b ? 1 : -1;
	}
	
	function getReplacer(map){
		return function replace(str){
			if(str.charAt(1) === "#"){
				if(str.charAt(2) === "X" || str.charAt(2) === "x"){
					return decodeCodePoint(parseInt(str.substr(3), 16));
				}
				return decodeCodePoint(parseInt(str.substr(2), 10));
			}
			return map[str.slice(1, -1)];
		};
	}
	
	module.exports = {
		XML: decodeXMLStrict,
		HTML: decodeHTML,
		HTMLStrict: decodeHTMLStrict
	};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var inverseXML = getInverseObj(__webpack_require__(238)),
	    xmlReplacer = getInverseReplacer(inverseXML);
	
	exports.XML = getInverse(inverseXML, xmlReplacer);
	
	var inverseHTML = getInverseObj(__webpack_require__(237)),
	    htmlReplacer = getInverseReplacer(inverseHTML);
	
	exports.HTML = getInverse(inverseHTML, htmlReplacer);
	
	function getInverseObj(obj){
		return Object.keys(obj).sort().reduce(function(inverse, name){
			inverse[obj[name]] = "&" + name + ";";
			return inverse;
		}, {});
	}
	
	function getInverseReplacer(inverse){
		var single = [],
		    multiple = [];
	
		Object.keys(inverse).forEach(function(k){
			if(k.length === 1){
				single.push("\\" + k);
			} else {
				multiple.push(k);
			}
		});
	
		//TODO add ranges
		multiple.unshift("[" + single.join("") + "]");
	
		return new RegExp(multiple.join("|"), "g");
	}
	
	var re_nonASCII = /[^\0-\x7F]/g,
	    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	
	function singleCharReplacer(c){
		return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
	}
	
	function astralReplacer(c){
		// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		var high = c.charCodeAt(0);
		var low  = c.charCodeAt(1);
		var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
		return "&#x" + codePoint.toString(16).toUpperCase() + ";";
	}
	
	function getInverse(inverse, re){
		function func(name){
			return inverse[name];
		}
	
		return function(data){
			return data
					.replace(re, func)
					.replace(re_astralSymbols, astralReplacer)
					.replace(re_nonASCII, singleCharReplacer);
		};
	}
	
	var re_xmlChars = getInverseReplacer(inverseXML);
	
	function escapeXML(data){
		return data
				.replace(re_xmlChars, singleCharReplacer)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	}
	
	exports.escape = escapeXML;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @license MIT
	 * @fileOverview Favico animations
	 * @author Miroslav Magda, http://blog.ejci.net
	 * @version 0.3.10
	 */
	
	/**
	 * Create new favico instance
	 * @param {Object} Options
	 * @return {Object} Favico object
	 * @example
	 * var favico = new Favico({
	 *    bgColor : '#d00',
	 *    textColor : '#fff',
	 *    fontFamily : 'sans-serif',
	 *    fontStyle : 'bold',
	 *    position : 'down',
	 *    type : 'circle',
	 *    animation : 'slide',
	 *    dataUrl: function(url){},
	 *    win: top
	 * });
	 */
	(function () {
	
		var Favico = (function (opt) {
			'use strict';
			opt = (opt) ? opt : {};
			var _def = {
				bgColor: '#d00',
				textColor: '#fff',
				fontFamily: 'sans-serif', //Arial,Verdana,Times New Roman,serif,sans-serif,...
				fontStyle: 'bold', //normal,italic,oblique,bold,bolder,lighter,100,200,300,400,500,600,700,800,900
				type: 'circle',
				position: 'down', // down, up, left, leftup (upleft)
				animation: 'slide',
				elementId: false,
				dataUrl: false,
				win: window
			};
			var _opt, _orig, _h, _w, _canvas, _context, _img, _ready, _lastBadge, _running, _readyCb, _stop, _browser, _animTimeout, _drawTimeout, _doc;
	
			_browser = {};
			_browser.ff = typeof InstallTrigger != 'undefined';
			_browser.chrome = !!window.chrome;
			_browser.opera = !!window.opera || navigator.userAgent.indexOf('Opera') >= 0;
			_browser.ie = /*@cc_on!@*/false;
			_browser.safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
			_browser.supported = (_browser.chrome || _browser.ff || _browser.opera);
	
			var _queue = [];
			_readyCb = function () {
			};
			_ready = _stop = false;
			/**
			 * Initialize favico
			 */
			var init = function () {
				//merge initial options
				_opt = merge(_def, opt);
				_opt.bgColor = hexToRgb(_opt.bgColor);
				_opt.textColor = hexToRgb(_opt.textColor);
				_opt.position = _opt.position.toLowerCase();
				_opt.animation = (animation.types['' + _opt.animation]) ? _opt.animation : _def.animation;
	
				_doc = _opt.win.document;
	
				var isUp = _opt.position.indexOf('up') > -1;
				var isLeft = _opt.position.indexOf('left') > -1;
	
				//transform animation
				if (isUp || isLeft) {
					for (var i = 0; i < animation.types['' + _opt.animation].length; i++) {
						var step = animation.types['' + _opt.animation][i];
	
						if (isUp) {
							if (step.y < 0.6) {
								step.y = step.y - 0.4;
							} else {
								step.y = step.y - 2 * step.y + (1 - step.w);
							}
						}
	
						if (isLeft) {
							if (step.x < 0.6) {
								step.x = step.x - 0.4;
							} else {
								step.x = step.x - 2 * step.x + (1 - step.h);
							}
						}
	
						animation.types['' + _opt.animation][i] = step;
					}
				}
				_opt.type = (type['' + _opt.type]) ? _opt.type : _def.type;
	
				_orig = link.getIcon();
				//create temp canvas
				_canvas = document.createElement('canvas');
				//create temp image
				_img = document.createElement('img');
				if (_orig.hasAttribute('href')) {
					_img.setAttribute('crossOrigin', 'anonymous');
					//get width/height
					_img.onload = function () {
						_h = (_img.height > 0) ? _img.height : 32;
						_w = (_img.width > 0) ? _img.width : 32;
						_canvas.height = _h;
						_canvas.width = _w;
						_context = _canvas.getContext('2d');
						icon.ready();
					};
					_img.setAttribute('src', _orig.getAttribute('href'));
				} else {
					_img.onload = function () {
						_h = 32;
						_w = 32;
						_img.height = _h;
						_img.width = _w;
						_canvas.height = _h;
						_canvas.width = _w;
						_context = _canvas.getContext('2d');
						icon.ready();
					};
					_img.setAttribute('src', '');
				}
	
			};
			/**
			 * Icon namespace
			 */
			var icon = {};
			/**
			 * Icon is ready (reset icon) and start animation (if ther is any)
			 */
			icon.ready = function () {
				_ready = true;
				icon.reset();
				_readyCb();
			};
			/**
			 * Reset icon to default state
			 */
			icon.reset = function () {
				//reset
				if (!_ready) {
					return;
				}
				_queue = [];
				_lastBadge = false;
				_running = false;
				_context.clearRect(0, 0, _w, _h);
				_context.drawImage(_img, 0, 0, _w, _h);
				//_stop=true;
				link.setIcon(_canvas);
				//webcam('stop');
				//video('stop');
				window.clearTimeout(_animTimeout);
				window.clearTimeout(_drawTimeout);
			};
			/**
			 * Start animation
			 */
			icon.start = function () {
				if (!_ready || _running) {
					return;
				}
				var finished = function () {
					_lastBadge = _queue[0];
					_running = false;
					if (_queue.length > 0) {
						_queue.shift();
						icon.start();
					} else {
	
					}
				};
				if (_queue.length > 0) {
					_running = true;
					var run = function () {
						// apply options for this animation
						['type', 'animation', 'bgColor', 'textColor', 'fontFamily', 'fontStyle'].forEach(function (a) {
							if (a in _queue[0].options) {
								_opt[a] = _queue[0].options[a];
							}
						});
						animation.run(_queue[0].options, function () {
							finished();
						}, false);
					};
					if (_lastBadge) {
						animation.run(_lastBadge.options, function () {
							run();
						}, true);
					} else {
						run();
					}
				}
			};
	
			/**
			 * Badge types
			 */
			var type = {};
			var options = function (opt) {
				opt.n = ((typeof opt.n) === 'number') ? Math.abs(opt.n | 0) : opt.n;
				opt.x = _w * opt.x;
				opt.y = _h * opt.y;
				opt.w = _w * opt.w;
				opt.h = _h * opt.h;
				opt.len = ("" + opt.n).length;
				return opt;
			};
			/**
			 * Generate circle
			 * @param {Object} opt Badge options
			 */
			type.circle = function (opt) {
				opt = options(opt);
				var more = false;
				if (opt.len === 2) {
					opt.x = opt.x - opt.w * 0.4;
					opt.w = opt.w * 1.4;
					more = true;
				} else if (opt.len >= 3) {
					opt.x = opt.x - opt.w * 0.65;
					opt.w = opt.w * 1.65;
					more = true;
				}
				_context.clearRect(0, 0, _w, _h);
				_context.drawImage(_img, 0, 0, _w, _h);
				_context.beginPath();
				_context.font = _opt.fontStyle + " " + Math.floor(opt.h * (opt.n > 99 ? 0.85 : 1)) + "px " + _opt.fontFamily;
				_context.textAlign = 'center';
				if (more) {
					_context.moveTo(opt.x + opt.w / 2, opt.y);
					_context.lineTo(opt.x + opt.w - opt.h / 2, opt.y);
					_context.quadraticCurveTo(opt.x + opt.w, opt.y, opt.x + opt.w, opt.y + opt.h / 2);
					_context.lineTo(opt.x + opt.w, opt.y + opt.h - opt.h / 2);
					_context.quadraticCurveTo(opt.x + opt.w, opt.y + opt.h, opt.x + opt.w - opt.h / 2, opt.y + opt.h);
					_context.lineTo(opt.x + opt.h / 2, opt.y + opt.h);
					_context.quadraticCurveTo(opt.x, opt.y + opt.h, opt.x, opt.y + opt.h - opt.h / 2);
					_context.lineTo(opt.x, opt.y + opt.h / 2);
					_context.quadraticCurveTo(opt.x, opt.y, opt.x + opt.h / 2, opt.y);
				} else {
					_context.arc(opt.x + opt.w / 2, opt.y + opt.h / 2, opt.h / 2, 0, 2 * Math.PI);
				}
				_context.fillStyle = 'rgba(' + _opt.bgColor.r + ',' + _opt.bgColor.g + ',' + _opt.bgColor.b + ',' + opt.o + ')';
				_context.fill();
				_context.closePath();
				_context.beginPath();
				_context.stroke();
				_context.fillStyle = 'rgba(' + _opt.textColor.r + ',' + _opt.textColor.g + ',' + _opt.textColor.b + ',' + opt.o + ')';
				//_context.fillText((more) ? '9+' : opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				if ((typeof opt.n) === 'number' && opt.n > 999) {
					_context.fillText(((opt.n > 9999) ? 9 : Math.floor(opt.n / 1000)) + 'k+', Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.2));
				} else {
					_context.fillText(opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				}
				_context.closePath();
			};
			/**
			 * Generate rectangle
			 * @param {Object} opt Badge options
			 */
			type.rectangle = function (opt) {
				opt = options(opt);
				var more = false;
				if (opt.len === 2) {
					opt.x = opt.x - opt.w * 0.4;
					opt.w = opt.w * 1.4;
					more = true;
				} else if (opt.len >= 3) {
					opt.x = opt.x - opt.w * 0.65;
					opt.w = opt.w * 1.65;
					more = true;
				}
				_context.clearRect(0, 0, _w, _h);
				_context.drawImage(_img, 0, 0, _w, _h);
				_context.beginPath();
				_context.font = _opt.fontStyle + " " + Math.floor(opt.h * (opt.n > 99 ? 0.9 : 1)) + "px " + _opt.fontFamily;
				_context.textAlign = 'center';
				_context.fillStyle = 'rgba(' + _opt.bgColor.r + ',' + _opt.bgColor.g + ',' + _opt.bgColor.b + ',' + opt.o + ')';
				_context.fillRect(opt.x, opt.y, opt.w, opt.h);
				_context.fillStyle = 'rgba(' + _opt.textColor.r + ',' + _opt.textColor.g + ',' + _opt.textColor.b + ',' + opt.o + ')';
				//_context.fillText((more) ? '9+' : opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				if ((typeof opt.n) === 'number' && opt.n > 999) {
					_context.fillText(((opt.n > 9999) ? 9 : Math.floor(opt.n / 1000)) + 'k+', Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.2));
				} else {
					_context.fillText(opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				}
				_context.closePath();
			};
	
			/**
			 * Set badge
			 */
			var badge = function (number, opts) {
				opts = ((typeof opts) === 'string' ? {
					animation: opts
				} : opts) || {};
				_readyCb = function () {
					try {
						if (typeof (number) === 'number' ? (number > 0) : (number !== '')) {
							var q = {
								type: 'badge',
								options: {
									n: number
								}
							};
							if ('animation' in opts && animation.types['' + opts.animation]) {
								q.options.animation = '' + opts.animation;
							}
							if ('type' in opts && type['' + opts.type]) {
								q.options.type = '' + opts.type;
							}
							['bgColor', 'textColor'].forEach(function (o) {
								if (o in opts) {
									q.options[o] = hexToRgb(opts[o]);
								}
							});
							['fontStyle', 'fontFamily'].forEach(function (o) {
								if (o in opts) {
									q.options[o] = opts[o];
								}
							});
							_queue.push(q);
							if (_queue.length > 100) {
								throw new Error('Too many badges requests in queue.');
							}
							icon.start();
						} else {
							icon.reset();
						}
					} catch (e) {
						throw new Error('Error setting badge. Message: ' + e.message);
					}
				};
				if (_ready) {
					_readyCb();
				}
			};
	
			/**
			 * Set image as icon
			 */
			var image = function (imageElement) {
				_readyCb = function () {
					try {
						var w = imageElement.width;
						var h = imageElement.height;
						var newImg = document.createElement('img');
						var ratio = (w / _w < h / _h) ? (w / _w) : (h / _h);
						newImg.setAttribute('crossOrigin', 'anonymous');
						newImg.onload=function(){
							_context.clearRect(0, 0, _w, _h);
							_context.drawImage(newImg, 0, 0, _w, _h);
							link.setIcon(_canvas);
						};
						newImg.setAttribute('src', imageElement.getAttribute('src'));
						newImg.height = (h / ratio);
						newImg.width = (w / ratio);
					} catch (e) {
						throw new Error('Error setting image. Message: ' + e.message);
					}
				};
				if (_ready) {
					_readyCb();
				}
			};
			/**
			 * Set video as icon
			 */
			var video = function (videoElement) {
				_readyCb = function () {
					try {
						if (videoElement === 'stop') {
							_stop = true;
							icon.reset();
							_stop = false;
							return;
						}
						//var w = videoElement.width;
						//var h = videoElement.height;
						//var ratio = (w / _w < h / _h) ? (w / _w) : (h / _h);
						videoElement.addEventListener('play', function () {
							drawVideo(this);
						}, false);
	
					} catch (e) {
						throw new Error('Error setting video. Message: ' + e.message);
					}
				};
				if (_ready) {
					_readyCb();
				}
			};
			/**
			 * Set video as icon
			 */
			var webcam = function (action) {
				//UR
				if (!window.URL || !window.URL.createObjectURL) {
					window.URL = window.URL || {};
					window.URL.createObjectURL = function (obj) {
						return obj;
					};
				}
				if (_browser.supported) {
					var newVideo = false;
					navigator.getUserMedia = navigator.getUserMedia || navigator.oGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
					_readyCb = function () {
						try {
							if (action === 'stop') {
								_stop = true;
								icon.reset();
								_stop = false;
								return;
							}
							newVideo = document.createElement('video');
							newVideo.width = _w;
							newVideo.height = _h;
							navigator.getUserMedia({
								video: true,
								audio: false
							}, function (stream) {
								newVideo.src = URL.createObjectURL(stream);
								newVideo.play();
								drawVideo(newVideo);
							}, function () {
							});
						} catch (e) {
							throw new Error('Error setting webcam. Message: ' + e.message);
						}
					};
					if (_ready) {
						_readyCb();
					}
				}
	
			};
	
			/**
			 * Draw video to context and repeat :)
			 */
			function drawVideo(video) {
				if (video.paused || video.ended || _stop) {
					return false;
				}
				//nasty hack for FF webcam (Thanks to Julian Ćwirko, kontakt@redsunmedia.pl)
				try {
					_context.clearRect(0, 0, _w, _h);
					_context.drawImage(video, 0, 0, _w, _h);
				} catch (e) {
	
				}
				_drawTimeout = setTimeout(function () {
					drawVideo(video);
				}, animation.duration);
				link.setIcon(_canvas);
			}
	
			var link = {};
			/**
			 * Get icon from HEAD tag or create a new <link> element
			 */
			link.getIcon = function () {
				var elm = false;
				//get link element
				var getLink = function () {
					var link = _doc.getElementsByTagName('head')[0].getElementsByTagName('link');
					for (var l = link.length, i = (l - 1); i >= 0; i--) {
						if ((/(^|\s)icon(\s|$)/i).test(link[i].getAttribute('rel'))) {
							return link[i];
						}
					}
					return false;
				};
				if (_opt.element) {
					elm = _opt.element;
				} else if (_opt.elementId) {
					//if img element identified by elementId
					elm = _doc.getElementById(_opt.elementId);
					elm.setAttribute('href', elm.getAttribute('src'));
				} else {
					//if link element
					elm = getLink();
					if (elm === false) {
						elm = _doc.createElement('link');
						elm.setAttribute('rel', 'icon');
						_doc.getElementsByTagName('head')[0].appendChild(elm);
					}
				}
				elm.setAttribute('type', 'image/png');
				return elm;
			};
			link.setIcon = function (canvas) {
				var url = canvas.toDataURL('image/png');
				if (_opt.dataUrl) {
					//if using custom exporter
					_opt.dataUrl(url);
				}
				if (_opt.element) {
					_opt.element.setAttribute('href', url);
					_opt.element.setAttribute('src', url);
				} else if (_opt.elementId) {
					//if is attached to element (image)
					var elm = _doc.getElementById(_opt.elementId);
					elm.setAttribute('href', url);
					elm.setAttribute('src', url);
				} else {
					//if is attached to fav icon
					if (_browser.ff || _browser.opera) {
						//for FF we need to "recreate" element, atach to dom and remove old <link>
						//var originalType = _orig.getAttribute('rel');
						var old = _orig;
						_orig = _doc.createElement('link');
						//_orig.setAttribute('rel', originalType);
						if (_browser.opera) {
							_orig.setAttribute('rel', 'icon');
						}
						_orig.setAttribute('rel', 'icon');
						_orig.setAttribute('type', 'image/png');
						_doc.getElementsByTagName('head')[0].appendChild(_orig);
						_orig.setAttribute('href', url);
						if (old.parentNode) {
							old.parentNode.removeChild(old);
						}
					} else {
						_orig.setAttribute('href', url);
					}
				}
			};
	
			//http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb#answer-5624139
			//HEX to RGB convertor
			function hexToRgb(hex) {
				var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
				hex = hex.replace(shorthandRegex, function (m, r, g, b) {
					return r + r + g + g + b + b;
				});
				var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				} : false;
			}
	
			/**
			 * Merge options
			 */
			function merge(def, opt) {
				var mergedOpt = {};
				var attrname;
				for (attrname in def) {
					mergedOpt[attrname] = def[attrname];
				}
				for (attrname in opt) {
					mergedOpt[attrname] = opt[attrname];
				}
				return mergedOpt;
			}
	
			/**
			 * Cross-browser page visibility shim
			 * http://stackoverflow.com/questions/12536562/detect-whether-a-window-is-visible
			 */
			function isPageHidden() {
				return _doc.hidden || _doc.msHidden || _doc.webkitHidden || _doc.mozHidden;
			}
	
			/**
			 * @namespace animation
			 */
			var animation = {};
			/**
			 * Animation "frame" duration
			 */
			animation.duration = 40;
			/**
			 * Animation types (none,fade,pop,slide)
			 */
			animation.types = {};
			animation.types.fade = [{
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.0
			}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.1
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.2
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.3
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.4
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.5
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.6
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.7
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.8
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.9
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1.0
				}];
			animation.types.none = [{
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 1
			}];
			animation.types.pop = [{
				x: 1,
				y: 1,
				w: 0,
				h: 0,
				o: 1
			}, {
					x: 0.9,
					y: 0.9,
					w: 0.1,
					h: 0.1,
					o: 1
				}, {
					x: 0.8,
					y: 0.8,
					w: 0.2,
					h: 0.2,
					o: 1
				}, {
					x: 0.7,
					y: 0.7,
					w: 0.3,
					h: 0.3,
					o: 1
				}, {
					x: 0.6,
					y: 0.6,
					w: 0.4,
					h: 0.4,
					o: 1
				}, {
					x: 0.5,
					y: 0.5,
					w: 0.5,
					h: 0.5,
					o: 1
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1
				}];
			animation.types.popFade = [{
				x: 0.75,
				y: 0.75,
				w: 0,
				h: 0,
				o: 0
			}, {
					x: 0.65,
					y: 0.65,
					w: 0.1,
					h: 0.1,
					o: 0.2
				}, {
					x: 0.6,
					y: 0.6,
					w: 0.2,
					h: 0.2,
					o: 0.4
				}, {
					x: 0.55,
					y: 0.55,
					w: 0.3,
					h: 0.3,
					o: 0.6
				}, {
					x: 0.50,
					y: 0.50,
					w: 0.4,
					h: 0.4,
					o: 0.8
				}, {
					x: 0.45,
					y: 0.45,
					w: 0.5,
					h: 0.5,
					o: 0.9
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1
				}];
			animation.types.slide = [{
				x: 0.4,
				y: 1,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
					x: 0.4,
					y: 0.9,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.9,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.8,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.7,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.6,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.5,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1
				}];
			/**
			 * Run animation
			 * @param {Object} opt Animation options
			 * @param {Object} cb Callabak after all steps are done
			 * @param {Object} revert Reverse order? true|false
			 * @param {Object} step Optional step number (frame bumber)
			 */
			animation.run = function (opt, cb, revert, step) {
				var animationType = animation.types[isPageHidden() ? 'none' : _opt.animation];
				if (revert === true) {
					step = (typeof step !== 'undefined') ? step : animationType.length - 1;
				} else {
					step = (typeof step !== 'undefined') ? step : 0;
				}
				cb = (cb) ? cb : function () {
				};
				if ((step < animationType.length) && (step >= 0)) {
					type[_opt.type](merge(opt, animationType[step]));
					_animTimeout = setTimeout(function () {
						if (revert) {
							step = step - 1;
						} else {
							step = step + 1;
						}
						animation.run(opt, cb, revert, step);
					}, animation.duration);
	
					link.setIcon(_canvas);
				} else {
					cb();
					return;
				}
			};
			//auto init
			init();
			return {
				badge: badge,
				video: video,
				image: image,
				webcam: webcam,
				reset: icon.reset,
				browser: {
					supported: _browser.supported
				}
			};
		});
	
		// AMD / RequireJS
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return Favico;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		// CommonJS
		else if (typeof module !== 'undefined' && module.exports) {
			module.exports = Favico;
		}
		// included directly via <script> tag
		else {
			this.Favico = Favico;
		}
	
	})();


/***/ }),
/* 991 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && (
	    // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	
	'use strict';
	
	// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
	
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = function () {
	  function URI(uri) {
	    _classCallCheck(this, URI);
	
	    this._uri = uri;
	  }
	
	  URI.prototype.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnicodeBidi = __webpack_require__(449);
	var UnicodeBidiDirection = __webpack_require__(296);
	
	var invariant = __webpack_require__(7);
	
	var UnicodeBidiService = function () {
	
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	  function UnicodeBidiService(defaultDir) {
	    _classCallCheck(this, UnicodeBidiService);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  UnicodeBidiService.prototype.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	
	'use strict';
	
	var UAParser = __webpack_require__(561);
	
	var UNKNOWN = 'Unknown';
	
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	var parser = new UAParser();
	var results = parser.getResult();
	
	// Do some conversion first.
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	
	module.exports = uaData;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0],
	        endVersion = expressions[1];
	
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range),
	      modifier = _getModifierAndCompon.modifier,
	      rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	
	  zeroPad(a, b.length);
	
	  // mark "x" and "*" components as equal
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	    if (matches) {
	      b[i] = a[i] = '0';
	
	      // final "*" greedily zeros all remaining components
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	
	  return [a, b];
	}
	
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b),
	      aNormalized = _normalizeVersions[0],
	      bNormalized = _normalizeVersions[1];
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	
	module.exports = VersionRange;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(450);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(42);
	
	var createArrayFromMixed = __webpack_require__(451);
	var getMarkupWrap = __webpack_require__(1002);
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var getElementRect = __webpack_require__(1001);
	
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var containsNode = __webpack_require__(297);
	
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	function getElementRect(elem) {
	  var docElem = elem.ownerDocument.documentElement;
	
	  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  }
	
	  // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	  var rect = elem.getBoundingClientRect();
	
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(42);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var camelize = __webpack_require__(450);
	var hyphenate = __webpack_require__(454);
	
	function asString(value) /*?string*/{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
	  var computedStyle = void 0;
	
	  // W3C Standard
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  }
	  // Safari
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null);
	    // A Safari bug causes this to return null for `display: none` elements.
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	    if (name === 'display') {
	      return 'none';
	    }
	  }
	  // Internet Explorer
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	    return asString(node.currentStyle[camelize(name)]);
	  }
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	"use strict";
	
	function getViewportWidth() {
	  var width = void 0;
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	} /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   * All rights reserved.
	   *
	   * This source code is licensed under the BSD-style license found in the
	   * LICENSE file in the root directory of this source tree. An additional grant
	   * of patent rights can be found in the PATENTS file in the same directory.
	   *
	   * 
	   * @typechecks
	   */
	
	function getViewportHeight() {
	  var height = void 0;
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(454);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1006);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} className
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass = void 0;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 1010 */,
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(1012)


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * @typechecks
	 */
	
	"use strict";
	
	var invariant = __webpack_require__(1013);
	
	var _lastID = 1;
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *    CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *
	 *         case 'city-update':
	 *           FlightPriceStore.price =
	 *             FlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	  function Dispatcher() {
	    this.$Dispatcher_callbacks = {};
	    this.$Dispatcher_isPending = {};
	    this.$Dispatcher_isHandled = {};
	    this.$Dispatcher_isDispatching = false;
	    this.$Dispatcher_pendingPayload = null;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   *
	   * @param {function} callback
	   * @return {string}
	   */
	  Dispatcher.prototype.register=function(callback) {
	    var id = _prefix + _lastID++;
	    this.$Dispatcher_callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   *
	   * @param {string} id
	   */
	  Dispatcher.prototype.unregister=function(id) {
	    invariant(
	      this.$Dispatcher_callbacks[id],
	      'Dispatcher.unregister(...): `%s` does not map to a registered callback.',
	      id
	    );
	    delete this.$Dispatcher_callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   *
	   * @param {array<string>} ids
	   */
	  Dispatcher.prototype.waitFor=function(ids) {
	    invariant(
	      this.$Dispatcher_isDispatching,
	      'Dispatcher.waitFor(...): Must be invoked while dispatching.'
	    );
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this.$Dispatcher_isPending[id]) {
	        invariant(
	          this.$Dispatcher_isHandled[id],
	          'Dispatcher.waitFor(...): Circular dependency detected while ' +
	          'waiting for `%s`.',
	          id
	        );
	        continue;
	      }
	      invariant(
	        this.$Dispatcher_callbacks[id],
	        'Dispatcher.waitFor(...): `%s` does not map to a registered callback.',
	        id
	      );
	      this.$Dispatcher_invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   *
	   * @param {object} payload
	   */
	  Dispatcher.prototype.dispatch=function(payload) {
	    invariant(
	      !this.$Dispatcher_isDispatching,
	      'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.'
	    );
	    this.$Dispatcher_startDispatching(payload);
	    try {
	      for (var id in this.$Dispatcher_callbacks) {
	        if (this.$Dispatcher_isPending[id]) {
	          continue;
	        }
	        this.$Dispatcher_invokeCallback(id);
	      }
	    } finally {
	      this.$Dispatcher_stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   *
	   * @return {boolean}
	   */
	  Dispatcher.prototype.isDispatching=function() {
	    return this.$Dispatcher_isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @param {string} id
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_invokeCallback=function(id) {
	    this.$Dispatcher_isPending[id] = true;
	    this.$Dispatcher_callbacks[id](this.$Dispatcher_pendingPayload);
	    this.$Dispatcher_isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @param {object} payload
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_startDispatching=function(payload) {
	    for (var id in this.$Dispatcher_callbacks) {
	      this.$Dispatcher_isPending[id] = false;
	      this.$Dispatcher_isHandled[id] = false;
	    }
	    this.$Dispatcher_pendingPayload = payload;
	    this.$Dispatcher_isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_stopDispatching=function() {
	    this.$Dispatcher_pendingPayload = null;
	    this.$Dispatcher_isDispatching = false;
	  };
	
	
	module.exports = Dispatcher;


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * gemini-scrollbar
	 * @version 1.4.3
	 * @link http://noeldelgado.github.io/gemini-scrollbar/
	 * @license MIT
	 */
	(function() {
	  var SCROLLBAR_WIDTH, DONT_CREATE_GEMINI, CLASSNAMES;
	
	  CLASSNAMES = {
	    element: 'gm-scrollbar-container',
	    verticalScrollbar: 'gm-scrollbar -vertical',
	    horizontalScrollbar: 'gm-scrollbar -horizontal',
	    thumb: 'thumb',
	    view: 'gm-scroll-view',
	    autoshow: 'gm-autoshow',
	    disable: 'gm-scrollbar-disable-selection',
	    prevented: 'gm-prevented',
	    resizeTrigger: 'gm-resize-trigger',
	  };
	
	  function getScrollbarWidth() {
	    var e = document.createElement('div'), sw;
	    e.style.position = 'absolute';
	    e.style.top = '-9999px';
	    e.style.width = '100px';
	    e.style.height = '100px';
	    e.style.overflow = 'scroll';
	    e.style.msOverflowStyle = 'scrollbar';
	    document.body.appendChild(e);
	    sw = (e.offsetWidth - e.clientWidth);
	    document.body.removeChild(e);
	    return sw;
	  }
	
	  function addClass(el, classNames) {
	    if (el.classList) {
	      return classNames.forEach(function(cl) {
	        el.classList.add(cl);
	      });
	    }
	    el.className += ' ' + classNames.join(' ');
	  }
	
	  function removeClass(el, classNames) {
	    if (el.classList) {
	      return classNames.forEach(function(cl) {
	        el.classList.remove(cl);
	      });
	    }
	    el.className = el.className.replace(new RegExp('(^|\\b)' + classNames.join('|') + '(\\b|$)', 'gi'), ' ');
	  }
	
	  /* Copyright (c) 2015 Lucas Wiener
	   * https://github.com/wnr/element-resize-detector
	   */
	  function isIE() {
	    var agent = navigator.userAgent.toLowerCase();
	    return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
	  }
	
	  function GeminiScrollbar(config) {
	    this.element = null;
	    this.autoshow = false;
	    this.createElements = true;
	    this.forceGemini = false;
	    this.onResize = null;
	
	    Object.keys(config || {}).forEach(function (propertyName) {
	      this[propertyName] = config[propertyName];
	    }, this);
	
	    SCROLLBAR_WIDTH = getScrollbarWidth();
	    DONT_CREATE_GEMINI = ((SCROLLBAR_WIDTH === 0) && (this.forceGemini === false));
	
	    this._cache = {events: {}};
	    this._created = false;
	    this._cursorDown = false;
	    this._prevPageX = 0;
	    this._prevPageY = 0;
	
	    this._document = null;
	    this._viewElement = this.element;
	    this._scrollbarVerticalElement = null;
	    this._thumbVerticalElement = null;
	    this._scrollbarHorizontalElement = null;
	    this._scrollbarHorizontalElement = null;
	  }
	
	  GeminiScrollbar.prototype.create = function create() {
	    if (DONT_CREATE_GEMINI) {
	      addClass(this.element, [CLASSNAMES.prevented]);
	
	      if (this.onResize) {
	        // still need a resize trigger if we have an onResize callback, which
	        // also means we need a separate _viewElement to do the scrolling.
	        if (this.createElements === true) {
	          this._viewElement = document.createElement('div');
	          while(this.element.childNodes.length > 0) {
	            this._viewElement.appendChild(this.element.childNodes[0]);
	          }
	          this.element.appendChild(this._viewElement);
	        } else {
	          this._viewElement = this.element.querySelector('.' + CLASSNAMES.view);
	        }
	        addClass(this.element, [CLASSNAMES.element]);
	        addClass(this._viewElement, [CLASSNAMES.view]);
	        this._createResizeTrigger();
	      }
	
	      return this;
	    }
	
	    if (this._created === true) {
	      console.warn('calling on a already-created object');
	      return this;
	    }
	
	    if (this.autoshow) {
	      addClass(this.element, [CLASSNAMES.autoshow]);
	    }
	
	    this._document = document;
	
	    if (this.createElements === true) {
	      this._viewElement = document.createElement('div');
	      this._scrollbarVerticalElement = document.createElement('div');
	      this._thumbVerticalElement = document.createElement('div');
	      this._scrollbarHorizontalElement = document.createElement('div');
	      this._thumbHorizontalElement = document.createElement('div');
	      while(this.element.childNodes.length > 0) {
	        this._viewElement.appendChild(this.element.childNodes[0]);
	      }
	
	      this._scrollbarVerticalElement.appendChild(this._thumbVerticalElement);
	      this._scrollbarHorizontalElement.appendChild(this._thumbHorizontalElement);
	      this.element.appendChild(this._scrollbarVerticalElement);
	      this.element.appendChild(this._scrollbarHorizontalElement);
	      this.element.appendChild(this._viewElement);
	    } else {
	      this._viewElement = this.element.querySelector('.' + CLASSNAMES.view);
	      this._scrollbarVerticalElement = this.element.querySelector('.' + CLASSNAMES.verticalScrollbar.split(' ').join('.'));
	      this._thumbVerticalElement = this._scrollbarVerticalElement.querySelector('.' + CLASSNAMES.thumb);
	      this._scrollbarHorizontalElement = this.element.querySelector('.' + CLASSNAMES.horizontalScrollbar.split(' ').join('.'));
	      this._thumbHorizontalElement = this._scrollbarHorizontalElement.querySelector('.' + CLASSNAMES.thumb);
	    }
	
	    addClass(this.element, [CLASSNAMES.element]);
	    addClass(this._viewElement, [CLASSNAMES.view]);
	    addClass(this._scrollbarVerticalElement, CLASSNAMES.verticalScrollbar.split(/\s/));
	    addClass(this._scrollbarHorizontalElement, CLASSNAMES.horizontalScrollbar.split(/\s/));
	    addClass(this._thumbVerticalElement, [CLASSNAMES.thumb]);
	    addClass(this._thumbHorizontalElement, [CLASSNAMES.thumb]);
	
	    this._scrollbarVerticalElement.style.display = '';
	    this._scrollbarHorizontalElement.style.display = '';
	
	    this._createResizeTrigger();
	
	    this._created = true;
	
	    return this._bindEvents().update();
	  };
	
	  GeminiScrollbar.prototype._createResizeTrigger = function createResizeTrigger() {
	    // We need to arrange for self.scrollbar.update to be called whenever
	    // the DOM is changed resulting in a size-change for our div. To make
	    // this happen, we use a technique described here:
	    // http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/.
	    //
	    // The idea is that we create an <object> element in our div, which we
	    // arrange to have the same size as that div. The <object> element
	    // contains a Window object, to which we can attach an onresize
	    // handler.
	    //
	    // (React appears to get very confused by the object (we end up with
	    // Chrome windows which only show half of the text they are supposed
	    // to), so we always do this manually.)
	
	    var obj = document.createElement('object');
	    addClass(obj, [CLASSNAMES.resizeTrigger]);
	    obj.type = 'text/html';
	    var resizeHandler = this._resizeHandler.bind(this);
	    obj.onload = function () {
	      var win = obj.contentDocument.defaultView;
	      win.addEventListener('resize', resizeHandler);
	    };
	
	    //IE: Does not like that this happens before, even if it is also added after.
	    if (!isIE()) {
	      obj.data = 'about:blank';
	    }
	
	    this.element.appendChild(obj);
	
	    //IE: This must occur after adding the object to the DOM.
	    if (isIE()) {
	      obj.data = 'about:blank';
	    }
	
	    this._resizeTriggerElement = obj;
	  };
	
	  GeminiScrollbar.prototype.update = function update() {
	    if (DONT_CREATE_GEMINI) {
	      return this;
	    }
	
	    if (this._created === false) {
	      console.warn('calling on a not-yet-created object');
	      return this;
	    }
	
	    var heightPercentage, widthPercentage;
	
	    this._viewElement.style.width = ((this.element.offsetWidth + SCROLLBAR_WIDTH).toString() + 'px');
	    this._viewElement.style.height = ((this.element.offsetHeight + SCROLLBAR_WIDTH).toString() + 'px');
	
	    heightPercentage = (this._viewElement.clientHeight * 100 / this._viewElement.scrollHeight);
	    widthPercentage = (this._viewElement.clientWidth * 100 / this._viewElement.scrollWidth);
	
	    this._thumbVerticalElement.style.height = (heightPercentage < 100) ? (heightPercentage + '%') : '';
	    this._thumbHorizontalElement.style.width = (widthPercentage < 100) ? (widthPercentage + '%') : '';
	
	    this._scrollHandler();
	
	    return this;
	  };
	
	  GeminiScrollbar.prototype.destroy = function destroy() {
	    if (this._resizeTriggerElement) {
	      this.element.removeChild(this._resizeTriggerElement);
	      this._resizeTriggerElement = null;
	    }
	
	    if (DONT_CREATE_GEMINI) {
	      return this;
	    }
	
	    if (this._created === false) {
	      console.warn('calling on a not-yet-created object');
	      return this;
	    }
	
	    this._unbinEvents();
	
	    removeClass(this.element, [CLASSNAMES.element, CLASSNAMES.autoshow]);
	
	    if (this.createElements === true) {
	      this.element.removeChild(this._scrollbarVerticalElement);
	      this.element.removeChild(this._scrollbarHorizontalElement);
	      while(this._viewElement.childNodes.length > 0) {
	        this.element.appendChild(this._viewElement.childNodes[0]);
	      }
	      this.element.removeChild(this._viewElement);
	    } else {
	      this._viewElement.style.width = '';
	      this._viewElement.style.height = '';
	      this._scrollbarVerticalElement.style.display = 'none';
	      this._scrollbarHorizontalElement.style.display = 'none';
	    }
	
	    this._created = false;
	    this._document = null;
	
	    return null;
	  };
	
	  GeminiScrollbar.prototype.getViewElement = function getViewElement() {
	    return this._viewElement;
	  };
	
	  GeminiScrollbar.prototype._bindEvents = function _bindEvents() {
	    this._cache.events.scrollHandler = this._scrollHandler.bind(this);
	    this._cache.events.clickVerticalTrackHandler = this._clickVerticalTrackHandler.bind(this);
	    this._cache.events.clickHorizontalTrackHandler = this._clickHorizontalTrackHandler.bind(this);
	    this._cache.events.clickVerticalThumbHandler = this._clickVerticalThumbHandler.bind(this);
	    this._cache.events.clickHorizontalThumbHandler = this._clickHorizontalThumbHandler.bind(this);
	    this._cache.events.mouseUpDocumentHandler = this._mouseUpDocumentHandler.bind(this);
	    this._cache.events.mouseMoveDocumentHandler = this._mouseMoveDocumentHandler.bind(this);
	
	    this._viewElement.addEventListener('scroll', this._cache.events.scrollHandler);
	    this._scrollbarVerticalElement.addEventListener('mousedown', this._cache.events.clickVerticalTrackHandler);
	    this._scrollbarHorizontalElement.addEventListener('mousedown', this._cache.events.clickHorizontalTrackHandler);
	    this._thumbVerticalElement.addEventListener('mousedown', this._cache.events.clickVerticalThumbHandler);
	    this._thumbHorizontalElement.addEventListener('mousedown', this._cache.events.clickHorizontalThumbHandler);
	    this._document.addEventListener('mouseup', this._cache.events.mouseUpDocumentHandler);
	
	    return this;
	  };
	
	  GeminiScrollbar.prototype._unbinEvents = function _unbinEvents() {
	    this._viewElement.removeEventListener('scroll', this._cache.events.scrollHandler);
	    this._scrollbarVerticalElement.removeEventListener('mousedown', this._cache.events.clickVerticalTrackHandler);
	    this._scrollbarHorizontalElement.removeEventListener('mousedown', this._cache.events.clickHorizontalTrackHandler);
	    this._thumbVerticalElement.removeEventListener('mousedown', this._cache.events.clickVerticalThumbHandler);
	    this._thumbHorizontalElement.removeEventListener('mousedown', this._cache.events.clickHorizontalThumbHandler);
	    this._document.removeEventListener('mouseup', this._cache.events.mouseUpDocumentHandler);
	    this._document.removeEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);
	
	    return this;
	  };
	
	  GeminiScrollbar.prototype._scrollHandler = function _scrollHandler() {
	    var viewElement, x, y;
	
	    viewElement = this._viewElement;
	    y = ((viewElement.scrollTop * 100) / viewElement.clientHeight);
	    x = ((viewElement.scrollLeft * 100) / viewElement.clientWidth);
	
	    this._thumbVerticalElement.style.msTransform = 'translateY(' + y + '%)';
	    this._thumbVerticalElement.style.webkitTransform = 'translateY(' + y + '%)';
	    this._thumbVerticalElement.style.transform = 'translateY(' + y + '%)';
	
	    this._thumbHorizontalElement.style.msTransform = 'translateX(' + x + '%)';
	    this._thumbHorizontalElement.style.webkitTransform = 'translateX(' + x + '%)';
	    this._thumbHorizontalElement.style.transform = 'translateX(' + x + '%)';
	  };
	
	  GeminiScrollbar.prototype._resizeHandler = function _resizeHandler() {
	    this.update();
	    if (this.onResize) {
	      this.onResize();
	    }
	  };
	
	  GeminiScrollbar.prototype._clickVerticalTrackHandler = function _clickVerticalTrackHandler(e) {
	    var offset = Math.abs(e.target.getBoundingClientRect().top - e.clientY)
	      , thumbHalf = (this._thumbVerticalElement.offsetHeight / 2)
	      , thumbPositionPercentage = ((offset - thumbHalf) * 100 / this._scrollbarVerticalElement.offsetHeight);
	    this._viewElement.scrollTop = (thumbPositionPercentage * this._viewElement.scrollHeight / 100);
	  };
	
	  GeminiScrollbar.prototype._clickHorizontalTrackHandler = function _clickHorizontalTrackHandler(e) {
	    var offset = Math.abs(e.target.getBoundingClientRect().left - e.clientX)
	      , thumbHalf = (this._thumbHorizontalElement.offsetWidth / 2)
	      , thumbPositionPercentage = ((offset - thumbHalf) * 100 / this._scrollbarHorizontalElement.offsetWidth);
	    this._viewElement.scrollLeft = (thumbPositionPercentage * this._viewElement.scrollWidth / 100);
	  };
	
	  GeminiScrollbar.prototype._clickVerticalThumbHandler = function _clickVerticalThumbHandler(e) {
	    this._startDrag(e);
	    this._prevPageY = (e.currentTarget.offsetHeight - (e.clientY - e.currentTarget.getBoundingClientRect().top));
	  };
	
	  GeminiScrollbar.prototype._clickHorizontalThumbHandler = function _clickHorizontalThumbHandler(e) {
	    this._startDrag(e);
	    this._prevPageX = (e.currentTarget.offsetWidth - (e.clientX - e.currentTarget.getBoundingClientRect().left));
	  };
	
	  GeminiScrollbar.prototype._startDrag = function _startDrag(e) {
	    e.stopImmediatePropagation();
	    this._cursorDown = true;
	    addClass(document.body, [CLASSNAMES.disable]);
	    this._document.addEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);
	    this._document.onselectstart = function() {return false;};
	  };
	
	  GeminiScrollbar.prototype._mouseUpDocumentHandler = function _mouseUpDocumentHandler() {
	    this._cursorDown = false;
	    this._prevPageX = this._prevPageY = 0;
	    removeClass(document.body, [CLASSNAMES.disable]);
	    this._document.removeEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);
	    this._document.onselectstart = null;
	  };
	
	  GeminiScrollbar.prototype._mouseMoveDocumentHandler = function _mouseMoveDocumentHandler(e) {
	    if (this._cursorDown === false) {return;}
	
	    var offset, thumbClickPosition, thumbPositionPercentage;
	
	    if (this._prevPageY) {
	      offset = ((this._scrollbarVerticalElement.getBoundingClientRect().top - e.clientY) * -1);
	      thumbClickPosition = (this._thumbVerticalElement.offsetHeight - this._prevPageY);
	      thumbPositionPercentage = ((offset - thumbClickPosition) * 100 / this._scrollbarVerticalElement.offsetHeight);
	      this._viewElement.scrollTop = (thumbPositionPercentage * this._viewElement.scrollHeight / 100);
	      return void 0;
	    }
	
	    if (this._prevPageX) {
	      offset = ((this._scrollbarHorizontalElement.getBoundingClientRect().left - e.clientX) * -1);
	      thumbClickPosition = (this._thumbHorizontalElement.offsetWidth - this._prevPageX);
	      thumbPositionPercentage = ((offset - thumbClickPosition) * 100 / this._scrollbarHorizontalElement.offsetWidth);
	      this._viewElement.scrollLeft = (thumbPositionPercentage * this._viewElement.scrollWidth / 100);
	    }
	  };
	
	  if (true) {
	    module.exports = GeminiScrollbar;
	  } else {
	    window.GeminiScrollbar = GeminiScrollbar;
	  }
	})();


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs){
		this._cbs = cbs || {};
		this.events = [];
	}
	
	var EVENTS = __webpack_require__(166).EVENTS;
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(){
				this.events.push([name]);
				if(this._cbs[name]) this._cbs[name]();
			};
		} else if(EVENTS[name] === 1){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(a){
				this.events.push([name, a]);
				if(this._cbs[name]) this._cbs[name](a);
			};
		} else if(EVENTS[name] === 2){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(a, b){
				this.events.push([name, a, b]);
				if(this._cbs[name]) this._cbs[name](a, b);
			};
		} else {
			throw Error("wrong number of arguments");
		}
	});
	
	CollectingHandler.prototype.onreset = function(){
		this.events = [];
		if(this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function(){
		if(this._cbs.onreset) this._cbs.onreset();
	
		for(var i = 0, len = this.events.length; i < len; i++){
			if(this._cbs[this.events[i][0]]){
	
				var num = this.events[i].length;
	
				if(num === 1){
					this._cbs[this.events[i][0]]();
				} else if(num === 2){
					this._cbs[this.events[i][0]](this.events[i][1]);
				} else {
					this._cbs[this.events[i][0]](this.events[i][1], this.events[i][2]);
				}
			}
		}
	};


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	var index = __webpack_require__(166),
	    DomHandler = index.DomHandler,
	    DomUtils = index.DomUtils;
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options){
		this.init(callback, options);
	}
	
	__webpack_require__(72)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where){
		return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where){
		return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse){
		return DomUtils.getText(
			DomUtils.getElementsByTagName(what, where, recurse, 1)
		).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse){
		var tmp = fetch(what, where, recurse);
		if(tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value){
		return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function(){
		var feed = {},
		    feedRoot = getOneElement(isValidFeed, this.dom),
		    tmp, childs;
	
		if(feedRoot){
			if(feedRoot.name === "feed"){
				childs = feedRoot.children;
	
				feed.type = "atom";
				addConditionally(feed, "id", "id", childs);
				addConditionally(feed, "title", "title", childs);
				if((tmp = getOneElement("link", childs)) && (tmp = tmp.attribs) && (tmp = tmp.href)) feed.link = tmp;
				addConditionally(feed, "description", "subtitle", childs);
				if((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
				addConditionally(feed, "author", "email", childs, true);
	
				feed.items = getElements("entry", childs).map(function(item){
					var entry = {}, tmp;
	
					item = item.children;
	
					addConditionally(entry, "id", "id", item);
					addConditionally(entry, "title", "title", item);
					if((tmp = getOneElement("link", item)) && (tmp = tmp.attribs) && (tmp = tmp.href)) entry.link = tmp;
					if((tmp = fetch("summary", item) || fetch("content", item))) entry.description = tmp;
					if((tmp = fetch("updated", item))) entry.pubDate = new Date(tmp);
					return entry;
				});
			} else {
				childs = getOneElement("channel", feedRoot.children).children;
	
				feed.type = feedRoot.name.substr(0, 3);
				feed.id = "";
				addConditionally(feed, "title", "title", childs);
				addConditionally(feed, "link", "link", childs);
				addConditionally(feed, "description", "description", childs);
				if((tmp = fetch("lastBuildDate", childs))) feed.updated = new Date(tmp);
				addConditionally(feed, "author", "managingEditor", childs, true);
	
				feed.items = getElements("item", feedRoot.children).map(function(item){
					var entry = {}, tmp;
	
					item = item.children;
	
					addConditionally(entry, "id", "guid", item);
					addConditionally(entry, "title", "title", item);
					addConditionally(entry, "link", "link", item);
					addConditionally(entry, "description", "description", item);
					if((tmp = fetch("pubDate", item))) entry.pubDate = new Date(tmp);
					return entry;
				});
			}
		}
		this.dom = feed;
		DomHandler.prototype._handleCallback.call(
			this, feedRoot ? null : Error("couldn't find root of feed")
		);
	};
	
	module.exports = FeedHandler;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs){
		this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(166).EVENTS;
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(){
				if(this._cbs[name]) this._cbs[name]();
			};
		} else if(EVENTS[name] === 1){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(a){
				if(this._cbs[name]) this._cbs[name](a);
			};
		} else if(EVENTS[name] === 2){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(a, b){
				if(this._cbs[name]) this._cbs[name](a, b);
			};
		} else {
			throw Error("wrong number of arguments");
		}
	});

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(458);
	
	function Stream(options){
		Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(72)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope){
		this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(166).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			Cbs.prototype["on" + name] = function(){
				this.scope.emit(name);
			};
		} else if(EVENTS[name] === 1){
			Cbs.prototype["on" + name] = function(a){
				this.scope.emit(name, a);
			};
		} else if(EVENTS[name] === 2){
			Cbs.prototype["on" + name] = function(a, b){
				this.scope.emit(name, a, b);
			};
		} else {
			throw Error("wrong number of arguments!");
		}
	});

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1535);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _linkify = __webpack_require__(303);
	
	var linkify = _interopRequireWildcard(_linkify);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var tokenize = linkify.tokenize,
	    options = linkify.options; /**
	                               	Linkify a HTML DOM node
	                               */
	
	var Options = options.Options;
	
	
	var TEXT_TOKEN = linkify.parser.TOKENS.TEXT;
	
	var HTML_NODE = 1,
	    TXT_NODE = 3;
	
	/**
		Given a parent element and child node that the parent contains, replaces
		that child with the given array of new children
	*/
	function replaceChildWithChildren(parent, oldChild, newChildren) {
		var lastNewChild = newChildren[newChildren.length - 1];
		parent.replaceChild(lastNewChild, oldChild);
		for (var i = newChildren.length - 2; i >= 0; i--) {
			parent.insertBefore(newChildren[i], lastNewChild);
			lastNewChild = newChildren[i];
		}
	}
	
	/**
		Given an array of MultiTokens, return an array of Nodes that are either
		(a) Plain Text nodes (node type 3)
		(b) Anchor tag nodes (usually, unless tag name is overridden in the options)
	
		Takes the same options as linkifyElement and an optional doc element
		(this should be passed in by linkifyElement)
	*/
	function tokensToNodes(tokens, opts, doc) {
		var result = [];
	
		for (var _iterator = tokens, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var token = _ref;
	
			if (token.type === 'nl' && opts.nl2br) {
				result.push(doc.createElement('br'));
				continue;
			} else if (!token.isLink || !opts.check(token)) {
				result.push(doc.createTextNode(token.toString()));
				continue;
			}
	
			var _opts$resolve = opts.resolve(token),
			    formatted = _opts$resolve.formatted,
			    formattedHref = _opts$resolve.formattedHref,
			    tagName = _opts$resolve.tagName,
			    className = _opts$resolve.className,
			    target = _opts$resolve.target,
			    events = _opts$resolve.events,
			    attributes = _opts$resolve.attributes;
	
			// Build the link
	
	
			var link = doc.createElement(tagName);
			link.setAttribute('href', formattedHref);
	
			if (className) {
				link.setAttribute('class', className);
			}
	
			if (target) {
				link.setAttribute('target', target);
			}
	
			// Build up additional attributes
			if (attributes) {
				for (var attr in attributes) {
					link.setAttribute(attr, attributes[attr]);
				}
			}
	
			if (events) {
				for (var event in events) {
					if (link.addEventListener) {
						link.addEventListener(event, events[event]);
					} else if (link.attachEvent) {
						link.attachEvent('on' + event, events[event]);
					}
				}
			}
	
			link.appendChild(doc.createTextNode(formatted));
			result.push(link);
		}
	
		return result;
	}
	
	// Requires document.createElement
	function linkifyElementHelper(element, opts, doc) {
	
		// Can the element be linkified?
		if (!element || element.nodeType !== HTML_NODE) {
			throw new Error('Cannot linkify ' + element + ' - Invalid DOM Node type');
		}
	
		var ignoreTags = opts.ignoreTags;
	
		// Is this element already a link?
		if (element.tagName === 'A' || options.contains(ignoreTags, element.tagName)) {
			// No need to linkify
			return element;
		}
	
		var childElement = element.firstChild;
	
		while (childElement) {
	
			switch (childElement.nodeType) {
				case HTML_NODE:
					linkifyElementHelper(childElement, opts, doc);
					break;
				case TXT_NODE:
	
					var str = childElement.nodeValue;
					var tokens = tokenize(str);
	
					if (tokens.length === 0 || tokens.length === 1 && tokens[0] instanceof TEXT_TOKEN) {
						// No node replacement required
						break;
					}
	
					var nodes = tokensToNodes(tokens, opts, doc);
	
					// Swap out the current child for the set of nodes
					replaceChildWithChildren(element, childElement, nodes);
	
					// so that the correct sibling is selected next
					childElement = nodes[nodes.length - 1];
	
					break;
			}
	
			childElement = childElement.nextSibling;
		}
	
		return element;
	}
	
	function linkifyElement(element, opts) {
		var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	
		try {
			doc = doc || document || window && window.document || global && global.document;
		} catch (e) {/* do nothing for now */}
	
		if (!doc) {
			throw new Error('Cannot find document implementation. ' + 'If you are in a non-browser environment like Node.js, ' + 'pass the document implementation as the third argument to linkifyElement.');
		}
	
		opts = new Options(opts);
		return linkifyElementHelper(element, opts, doc);
	}
	
	// Maintain reference to the recursive helper to cache option-normalization
	linkifyElement.helper = linkifyElementHelper;
	linkifyElement.normalize = function (opts) {
		return new Options(opts);
	};
	
	exports.default = linkifyElement;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _linkify = __webpack_require__(303);
	
	var linkify = _interopRequireWildcard(_linkify);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var tokenize = linkify.tokenize,
	    options = linkify.options; /**
	                               	Convert strings of text into linkable HTML text
	                               */
	
	var Options = options.Options;
	
	
	function escapeText(text) {
		return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
	
	function escapeAttr(href) {
		return href.replace(/"/g, '&quot;');
	}
	
	function attributesToString(attributes) {
		if (!attributes) {
			return '';
		}
		var result = [];
	
		for (var attr in attributes) {
			var val = attributes[attr] + '';
			result.push(attr + '="' + escapeAttr(val) + '"');
		}
		return result.join(' ');
	}
	
	function linkifyStr(str) {
		var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		opts = new Options(opts);
	
		var tokens = tokenize(str);
		var result = [];
	
		for (var i = 0; i < tokens.length; i++) {
			var token = tokens[i];
	
			if (token.type === 'nl' && opts.nl2br) {
				result.push('<br>\n');
				continue;
			} else if (!token.isLink || !opts.check(token)) {
				result.push(escapeText(token.toString()));
				continue;
			}
	
			var _opts$resolve = opts.resolve(token),
			    formatted = _opts$resolve.formatted,
			    formattedHref = _opts$resolve.formattedHref,
			    tagName = _opts$resolve.tagName,
			    className = _opts$resolve.className,
			    target = _opts$resolve.target,
			    attributes = _opts$resolve.attributes;
	
			var link = '<' + tagName + ' href="' + escapeAttr(formattedHref) + '"';
	
			if (className) {
				link += ' class="' + escapeAttr(className) + '"';
			}
	
			if (target) {
				link += ' target="' + escapeAttr(target) + '"';
			}
	
			if (attributes) {
				link += ' ' + attributesToString(attributes);
			}
	
			link += '>' + escapeText(formatted) + '</' + tagName + '>';
			result.push(link);
		}
	
		return result.join('');
	}
	
	if (!String.prototype.linkify) {
		String.prototype.linkify = function (opts) {
			return linkifyStr(this, opts);
		};
	}
	
	exports.default = linkifyStr;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.start = exports.run = exports.TOKENS = exports.State = undefined;
	
	var _state = __webpack_require__(460);
	
	var _text = __webpack_require__(304);
	
	var TEXT_TOKENS = _interopRequireWildcard(_text);
	
	var _multi = __webpack_require__(1025);
	
	var MULTI_TOKENS = _interopRequireWildcard(_multi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var makeState = function makeState(tokenClass) {
		return new _state.TokenState(tokenClass);
	};
	
	// The universal starting state.
	/**
		Not exactly parser, more like the second-stage scanner (although we can
		theoretically hotswap the code here with a real parser in the future... but
		for a little URL-finding utility abstract syntax trees may be a little
		overkill).
	
		URL format: http://en.wikipedia.org/wiki/URI_scheme
		Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
		reference)
	
		@module linkify
		@submodule parser
		@main parser
	*/
	
	var S_START = makeState();
	
	// Intermediate states for URLs. Note that domains that begin with a protocol
	// are treated slighly differently from those that don't.
	var S_PROTOCOL = makeState(); // e.g., 'http:'
	var S_MAILTO = makeState(); // 'mailto:'
	var S_PROTOCOL_SLASH = makeState(); // e.g., '/', 'http:/''
	var S_PROTOCOL_SLASH_SLASH = makeState(); // e.g., '//', 'http://'
	var S_DOMAIN = makeState(); // parsed string ends with a potential domain name (A)
	var S_DOMAIN_DOT = makeState(); // (A) domain followed by DOT
	var S_TLD = makeState(_multi.URL); // (A) Simplest possible URL with no query string
	var S_TLD_COLON = makeState(); // (A) URL followed by colon (potential port number here)
	var S_TLD_PORT = makeState(_multi.URL); // TLD followed by a port number
	var S_URL = makeState(_multi.URL); // Long URL with optional port and maybe query string
	var S_URL_NON_ACCEPTING = makeState(); // URL followed by some symbols (will not be part of the final URL)
	var S_URL_OPENBRACE = makeState(); // URL followed by {
	var S_URL_OPENBRACKET = makeState(); // URL followed by [
	var S_URL_OPENANGLEBRACKET = makeState(); // URL followed by <
	var S_URL_OPENPAREN = makeState(); // URL followed by (
	var S_URL_OPENBRACE_Q = makeState(_multi.URL); // URL followed by { and some symbols that the URL can end it
	var S_URL_OPENBRACKET_Q = makeState(_multi.URL); // URL followed by [ and some symbols that the URL can end it
	var S_URL_OPENANGLEBRACKET_Q = makeState(_multi.URL); // URL followed by < and some symbols that the URL can end it
	var S_URL_OPENPAREN_Q = makeState(_multi.URL); // URL followed by ( and some symbols that the URL can end it
	var S_URL_OPENBRACE_SYMS = makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it
	var S_URL_OPENBRACKET_SYMS = makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it
	var S_URL_OPENANGLEBRACKET_SYMS = makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it
	var S_URL_OPENPAREN_SYMS = makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it
	var S_EMAIL_DOMAIN = makeState(); // parsed string starts with local email info + @ with a potential domain name (C)
	var S_EMAIL_DOMAIN_DOT = makeState(); // (C) domain followed by DOT
	var S_EMAIL = makeState(_multi.EMAIL); // (C) Possible email address (could have more tlds)
	var S_EMAIL_COLON = makeState(); // (C) URL followed by colon (potential port number here)
	var S_EMAIL_PORT = makeState(_multi.EMAIL); // (C) Email address with a port
	var S_MAILTO_EMAIL = makeState(_multi.MAILTOEMAIL); // Email that begins with the mailto prefix (D)
	var S_MAILTO_EMAIL_NON_ACCEPTING = makeState(); // (D) Followed by some non-query string chars
	var S_LOCALPART = makeState(); // Local part of the email address
	var S_LOCALPART_AT = makeState(); // Local part of the email address plus @
	var S_LOCALPART_DOT = makeState(); // Local part of the email address plus '.' (localpart cannot end in .)
	var S_NL = makeState(_multi.NL); // single new line
	
	// Make path from start to protocol (with '//')
	S_START.on(_text.NL, S_NL).on(_text.PROTOCOL, S_PROTOCOL).on(_text.MAILTO, S_MAILTO).on(_text.SLASH, S_PROTOCOL_SLASH);
	
	S_PROTOCOL.on(_text.SLASH, S_PROTOCOL_SLASH);
	S_PROTOCOL_SLASH.on(_text.SLASH, S_PROTOCOL_SLASH_SLASH);
	
	// The very first potential domain name
	S_START.on(_text.TLD, S_DOMAIN).on(_text.DOMAIN, S_DOMAIN).on(_text.LOCALHOST, S_TLD).on(_text.NUM, S_DOMAIN);
	
	// Force URL for protocol followed by anything sane
	S_PROTOCOL_SLASH_SLASH.on(_text.TLD, S_URL).on(_text.DOMAIN, S_URL).on(_text.NUM, S_URL).on(_text.LOCALHOST, S_URL);
	
	// Account for dots and hyphens
	// hyphens are usually parts of domain names
	S_DOMAIN.on(_text.DOT, S_DOMAIN_DOT);
	S_EMAIL_DOMAIN.on(_text.DOT, S_EMAIL_DOMAIN_DOT);
	
	// Hyphen can jump back to a domain name
	
	// After the first domain and a dot, we can find either a URL or another domain
	S_DOMAIN_DOT.on(_text.TLD, S_TLD).on(_text.DOMAIN, S_DOMAIN).on(_text.NUM, S_DOMAIN).on(_text.LOCALHOST, S_DOMAIN);
	
	S_EMAIL_DOMAIN_DOT.on(_text.TLD, S_EMAIL).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.NUM, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL_DOMAIN);
	
	// S_TLD accepts! But the URL could be longer, try to find a match greedily
	// The `run` function should be able to "rollback" to the accepting state
	S_TLD.on(_text.DOT, S_DOMAIN_DOT);
	S_EMAIL.on(_text.DOT, S_EMAIL_DOMAIN_DOT);
	
	// Become real URLs after `SLASH` or `COLON NUM SLASH`
	// Here PSS and non-PSS converge
	S_TLD.on(_text.COLON, S_TLD_COLON).on(_text.SLASH, S_URL);
	S_TLD_COLON.on(_text.NUM, S_TLD_PORT);
	S_TLD_PORT.on(_text.SLASH, S_URL);
	S_EMAIL.on(_text.COLON, S_EMAIL_COLON);
	S_EMAIL_COLON.on(_text.NUM, S_EMAIL_PORT);
	
	// Types of characters the URL can definitely end in
	var qsAccepting = [_text.DOMAIN, _text.AT, _text.LOCALHOST, _text.NUM, _text.PLUS, _text.POUND, _text.PROTOCOL, _text.SLASH, _text.TLD, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND];
	
	// Types of tokens that can follow a URL and be part of the query string
	// but cannot be the very last characters
	// Characters that cannot appear in the URL at all should be excluded
	var qsNonAccepting = [_text.COLON, _text.DOT, _text.QUERY, _text.PUNCTUATION, _text.CLOSEBRACE, _text.CLOSEBRACKET, _text.CLOSEANGLEBRACKET, _text.CLOSEPAREN, _text.OPENBRACE, _text.OPENBRACKET, _text.OPENANGLEBRACKET, _text.OPENPAREN];
	
	// These states are responsible primarily for determining whether or not to
	// include the final round bracket.
	
	// URL, followed by an opening bracket
	S_URL.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);
	
	// URL with extra symbols at the end, followed by an opening bracket
	S_URL_NON_ACCEPTING.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);
	
	// Closing bracket component. This character WILL be included in the URL
	S_URL_OPENBRACE.on(_text.CLOSEBRACE, S_URL);
	S_URL_OPENBRACKET.on(_text.CLOSEBRACKET, S_URL);
	S_URL_OPENANGLEBRACKET.on(_text.CLOSEANGLEBRACKET, S_URL);
	S_URL_OPENPAREN.on(_text.CLOSEPAREN, S_URL);
	S_URL_OPENBRACE_Q.on(_text.CLOSEBRACE, S_URL);
	S_URL_OPENBRACKET_Q.on(_text.CLOSEBRACKET, S_URL);
	S_URL_OPENANGLEBRACKET_Q.on(_text.CLOSEANGLEBRACKET, S_URL);
	S_URL_OPENPAREN_Q.on(_text.CLOSEPAREN, S_URL);
	S_URL_OPENBRACE_SYMS.on(_text.CLOSEBRACE, S_URL);
	S_URL_OPENBRACKET_SYMS.on(_text.CLOSEBRACKET, S_URL);
	S_URL_OPENANGLEBRACKET_SYMS.on(_text.CLOSEANGLEBRACKET, S_URL);
	S_URL_OPENPAREN_SYMS.on(_text.CLOSEPAREN, S_URL);
	
	// URL that beings with an opening bracket, followed by a symbols.
	// Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
	// has a single opening bracket for some reason).
	S_URL_OPENBRACE.on(qsAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET.on(qsAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN.on(qsAccepting, S_URL_OPENPAREN_Q);
	S_URL_OPENBRACE.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
	S_URL_OPENBRACKET.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
	S_URL_OPENANGLEBRACKET.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
	S_URL_OPENPAREN.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);
	
	// URL that begins with an opening bracket, followed by some symbols
	S_URL_OPENBRACE_Q.on(qsAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET_Q.on(qsAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET_Q.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN_Q.on(qsAccepting, S_URL_OPENPAREN_Q);
	S_URL_OPENBRACE_Q.on(qsNonAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET_Q.on(qsNonAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET_Q.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN_Q.on(qsNonAccepting, S_URL_OPENPAREN_Q);
	
	S_URL_OPENBRACE_SYMS.on(qsAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET_SYMS.on(qsAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET_SYMS.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN_SYMS.on(qsAccepting, S_URL_OPENPAREN_Q);
	S_URL_OPENBRACE_SYMS.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
	S_URL_OPENBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
	S_URL_OPENANGLEBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
	S_URL_OPENPAREN_SYMS.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);
	
	// Account for the query string
	S_URL.on(qsAccepting, S_URL);
	S_URL_NON_ACCEPTING.on(qsAccepting, S_URL);
	
	S_URL.on(qsNonAccepting, S_URL_NON_ACCEPTING);
	S_URL_NON_ACCEPTING.on(qsNonAccepting, S_URL_NON_ACCEPTING);
	
	// Email address-specific state definitions
	// Note: We are not allowing '/' in email addresses since this would interfere
	// with real URLs
	
	// For addresses with the mailto prefix
	// 'mailto:' followed by anything sane is a valid email
	S_MAILTO.on(_text.TLD, S_MAILTO_EMAIL).on(_text.DOMAIN, S_MAILTO_EMAIL).on(_text.NUM, S_MAILTO_EMAIL).on(_text.LOCALHOST, S_MAILTO_EMAIL);
	
	// Greedily get more potential valid email values
	S_MAILTO_EMAIL.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
	S_MAILTO_EMAIL_NON_ACCEPTING.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
	
	// For addresses without the mailto prefix
	// Tokens allowed in the localpart of the email
	var localpartAccepting = [_text.DOMAIN, _text.NUM, _text.PLUS, _text.POUND, _text.QUERY, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND, _text.TLD];
	
	// Some of the tokens in `localpartAccepting` are already accounted for here and
	// will not be overwritten (don't worry)
	S_DOMAIN.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
	S_TLD.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
	S_DOMAIN_DOT.on(localpartAccepting, S_LOCALPART);
	
	// Okay we're on a localpart. Now what?
	// TODO: IP addresses and what if the email starts with numbers?
	S_LOCALPART.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT) // close to an email address now
	.on(_text.DOT, S_LOCALPART_DOT);
	S_LOCALPART_DOT.on(localpartAccepting, S_LOCALPART);
	S_LOCALPART_AT.on(_text.TLD, S_EMAIL_DOMAIN).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL);
	// States following `@` defined above
	
	var run = function run(tokens) {
		var len = tokens.length;
		var cursor = 0;
		var multis = [];
		var textTokens = [];
	
		while (cursor < len) {
			var state = S_START;
			var secondState = null;
			var nextState = null;
			var multiLength = 0;
			var latestAccepting = null;
			var sinceAccepts = -1;
	
			while (cursor < len && !(secondState = state.next(tokens[cursor]))) {
				// Starting tokens with nowhere to jump to.
				// Consider these to be just plain text
				textTokens.push(tokens[cursor++]);
			}
	
			while (cursor < len && (nextState = secondState || state.next(tokens[cursor]))) {
	
				// Get the next state
				secondState = null;
				state = nextState;
	
				// Keep track of the latest accepting state
				if (state.accepts()) {
					sinceAccepts = 0;
					latestAccepting = state;
				} else if (sinceAccepts >= 0) {
					sinceAccepts++;
				}
	
				cursor++;
				multiLength++;
			}
	
			if (sinceAccepts < 0) {
	
				// No accepting state was found, part of a regular text token
				// Add all the tokens we looked at to the text tokens array
				for (var i = cursor - multiLength; i < cursor; i++) {
					textTokens.push(tokens[i]);
				}
			} else {
	
				// Accepting state!
	
				// First close off the textTokens (if available)
				if (textTokens.length > 0) {
					multis.push(new _multi.TEXT(textTokens));
					textTokens = [];
				}
	
				// Roll back to the latest accepting state
				cursor -= sinceAccepts;
				multiLength -= sinceAccepts;
	
				// Create a new multitoken
				var MULTI = latestAccepting.emit();
				multis.push(new MULTI(tokens.slice(cursor - multiLength, cursor)));
			}
		}
	
		// Finally close off the textTokens (if available)
		if (textTokens.length > 0) {
			multis.push(new _multi.TEXT(textTokens));
		}
	
		return multis;
	};
	
	exports.State = _state.TokenState;
	exports.TOKENS = MULTI_TOKENS;
	exports.run = run;
	exports.start = S_START;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.start = exports.run = exports.TOKENS = exports.State = undefined;
	
	var _state = __webpack_require__(460);
	
	var _text = __webpack_require__(304);
	
	var TOKENS = _interopRequireWildcard(_text);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var tlds = 'aaa|aarp|abb|abbott|abogado|ac|academy|accenture|accountant|accountants|aco|active|actor|ad|adac|ads|adult|ae|aeg|aero|af|afl|ag|agency|ai|aig|airforce|airtel|al|alibaba|alipay|allfinanz|alsace|am|amica|amsterdam|an|analytics|android|ao|apartments|app|apple|aq|aquarelle|ar|aramco|archi|army|arpa|arte|as|asia|associates|at|attorney|au|auction|audi|audio|author|auto|autos|avianca|aw|ax|axa|az|azure|ba|baidu|band|bank|bar|barcelona|barclaycard|barclays|bargains|bauhaus|bayern|bb|bbc|bbva|bcg|bcn|bd|be|beats|beer|bentley|berlin|best|bet|bf|bg|bh|bharti|bi|bible|bid|bike|bing|bingo|bio|biz|bj|black|blackfriday|bloomberg|blue|bm|bms|bmw|bn|bnl|bnpparibas|bo|boats|boehringer|bom|bond|boo|book|boots|bosch|bostik|bot|boutique|br|bradesco|bridgestone|broadway|broker|brother|brussels|bs|bt|budapest|bugatti|build|builders|business|buy|buzz|bv|bw|by|bz|bzh|ca|cab|cafe|cal|call|camera|camp|cancerresearch|canon|capetown|capital|car|caravan|cards|care|career|careers|cars|cartier|casa|cash|casino|cat|catering|cba|cbn|cc|cd|ceb|center|ceo|cern|cf|cfa|cfd|cg|ch|chanel|channel|chase|chat|cheap|chloe|christmas|chrome|church|ci|cipriani|circle|cisco|citic|city|cityeats|ck|cl|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|cm|cn|co|coach|codes|coffee|college|cologne|com|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cool|coop|corsica|country|coupon|coupons|courses|cr|credit|creditcard|creditunion|cricket|crown|crs|cruises|csc|cu|cuisinella|cv|cw|cx|cy|cymru|cyou|cz|dabur|dad|dance|date|dating|datsun|day|dclk|de|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|diamonds|diet|digital|direct|directory|discount|dj|dk|dm|dnp|do|docs|dog|doha|domains|download|drive|dubai|durban|dvag|dz|earth|eat|ec|edeka|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|epson|equipment|er|erni|es|esq|estate|et|eu|eurovision|eus|events|everbank|exchange|expert|exposed|express|fage|fail|fairwinds|faith|family|fan|fans|farm|fashion|fast|feedback|ferrero|fi|film|final|finance|financial|firestone|firmdale|fish|fishing|fit|fitness|fj|fk|flickr|flights|florist|flowers|flsmidth|fly|fm|fo|foo|football|ford|forex|forsale|forum|foundation|fox|fr|fresenius|frl|frogans|frontier|fund|furniture|futbol|fyi|ga|gal|gallery|gallup|game|garden|gb|gbiz|gd|gdn|ge|gea|gent|genting|gf|gg|ggee|gh|gi|gift|gifts|gives|giving|gl|glass|gle|global|globo|gm|gmail|gmbh|gmo|gmx|gn|gold|goldpoint|golf|goo|goog|google|gop|got|gov|gp|gq|gr|grainger|graphics|gratis|green|gripe|group|gs|gt|gu|gucci|guge|guide|guitars|guru|gw|gy|hamburg|hangout|haus|hdfcbank|health|healthcare|help|helsinki|here|hermes|hiphop|hitachi|hiv|hk|hm|hn|hockey|holdings|holiday|homedepot|homes|honda|horse|host|hosting|hoteles|hotmail|house|how|hr|hsbc|ht|hu|hyundai|ibm|icbc|ice|icu|id|ie|ifm|iinet|il|im|immo|immobilien|in|industries|infiniti|info|ing|ink|institute|insurance|insure|int|international|investments|io|ipiranga|iq|ir|irish|is|iselect|ist|istanbul|it|itau|iwc|jaguar|java|jcb|je|jetzt|jewelry|jlc|jll|jm|jmp|jo|jobs|joburg|jot|joy|jp|jpmorgan|jprs|juegos|kaufen|kddi|ke|kerryhotels|kerrylogistics|kerryproperties|kfh|kg|kh|ki|kia|kim|kinder|kitchen|kiwi|km|kn|koeln|komatsu|kp|kpn|kr|krd|kred|kuokgroup|kw|ky|kyoto|kz|la|lacaixa|lamborghini|lamer|lancaster|land|landrover|lanxess|lasalle|lat|latrobe|law|lawyer|lb|lc|lds|lease|leclerc|legal|lexus|lgbt|li|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|limited|limo|lincoln|linde|link|live|living|lixil|lk|loan|loans|local|locus|lol|london|lotte|lotto|love|lr|ls|lt|ltd|ltda|lu|lupin|luxe|luxury|lv|ly|ma|madrid|maif|maison|makeup|man|management|mango|market|marketing|markets|marriott|mba|mc|md|me|med|media|meet|melbourne|meme|memorial|men|menu|meo|mg|mh|miami|microsoft|mil|mini|mk|ml|mm|mma|mn|mo|mobi|mobily|moda|moe|moi|mom|monash|money|montblanc|mormon|mortgage|moscow|motorcycles|mov|movie|movistar|mp|mq|mr|ms|mt|mtn|mtpc|mtr|mu|museum|mutuelle|mv|mw|mx|my|mz|na|nadex|nagoya|name|natura|navy|nc|ne|nec|net|netbank|network|neustar|new|news|nexus|nf|ng|ngo|nhk|ni|nico|nikon|ninja|nissan|nl|no|nokia|norton|nowruz|np|nr|nra|nrw|ntt|nu|nyc|nz|obi|office|okinawa|om|omega|one|ong|onl|online|ooo|oracle|orange|org|organic|origins|osaka|otsuka|ovh|pa|page|pamperedchef|panerai|paris|pars|partners|parts|party|passagens|pe|pet|pf|pg|ph|pharmacy|philips|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pizza|pk|pl|place|play|playstation|plumbing|plus|pm|pn|pohl|poker|porn|post|pr|praxi|press|pro|prod|productions|prof|promo|properties|property|protection|ps|pt|pub|pw|pwc|py|qa|qpon|quebec|quest|racing|re|read|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|ricoh|rio|rip|ro|rocher|rocks|rodeo|room|rs|rsvp|ru|ruhr|run|rw|rwe|ryukyu|sa|saarland|safe|safety|sakura|sale|salon|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|saxo|sb|sbs|sc|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scor|scot|sd|se|seat|security|seek|select|sener|services|seven|sew|sex|sexy|sfr|sg|sh|sharp|shell|shia|shiksha|shoes|show|shriram|si|singles|site|sj|sk|ski|skin|sky|skype|sl|sm|smile|sn|sncf|so|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|sr|srl|st|stada|star|starhub|statefarm|statoil|stc|stcgroup|stockholm|storage|store|studio|study|style|su|sucks|supplies|supply|support|surf|surgery|suzuki|sv|swatch|swiss|sx|sy|sydney|symantec|systems|sz|tab|taipei|taobao|tatamotors|tatar|tattoo|tax|taxi|tc|tci|td|team|tech|technology|tel|telecity|telefonica|temasek|tennis|tf|tg|th|thd|theater|theatre|tickets|tienda|tiffany|tips|tires|tirol|tj|tk|tl|tm|tmall|tn|to|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|tp|tr|trade|trading|training|travel|travelers|travelersinsurance|trust|trv|tt|tube|tui|tunes|tushu|tv|tvs|tw|tz|ua|ubs|ug|uk|unicom|university|uno|uol|us|uy|uz|va|vacations|vana|vc|ve|vegas|ventures|verisign|versicherung|vet|vg|vi|viajes|video|viking|villas|vin|vip|virgin|vision|vista|vistaprint|viva|vlaanderen|vn|vodka|volkswagen|vote|voting|voto|voyage|vu|vuelos|wales|walter|wang|wanggou|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weir|wf|whoswho|wien|wiki|williamhill|win|windows|wine|wme|wolterskluwer|work|works|world|ws|wtc|wtf|xbox|xerox|xin|xperia|xxx|xyz|yachts|yahoo|yamaxun|yandex|ye|yodobashi|yoga|yokohama|youtube|yt|za|zara|zero|zip|zm|zone|zuerich|zw'.split('|'); // macro, see gulpfile.js
	
	/**
		The scanner provides an interface that takes a string of text as input, and
		outputs an array of tokens instances that can be used for easy URL parsing.
	
		@module linkify
		@submodule scanner
		@main scanner
	*/
	
	var NUMBERS = '0123456789'.split('');
	var ALPHANUM = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
	var WHITESPACE = [' ', '\f', '\r', '\t', '\v', '\xA0', '\u1680', '\u180E']; // excluding line breaks
	
	var domainStates = []; // states that jump to DOMAIN on /[a-z0-9]/
	var makeState = function makeState(tokenClass) {
		return new _state.CharacterState(tokenClass);
	};
	
	// Frequently used states
	var S_START = makeState();
	var S_NUM = makeState(_text.NUM);
	var S_DOMAIN = makeState(_text.DOMAIN);
	var S_DOMAIN_HYPHEN = makeState(); // domain followed by 1 or more hyphen characters
	var S_WS = makeState(_text.WS);
	
	// States for special URL symbols
	S_START.on('@', makeState(_text.AT)).on('.', makeState(_text.DOT)).on('+', makeState(_text.PLUS)).on('#', makeState(_text.POUND)).on('?', makeState(_text.QUERY)).on('/', makeState(_text.SLASH)).on('_', makeState(_text.UNDERSCORE)).on(':', makeState(_text.COLON)).on('{', makeState(_text.OPENBRACE)).on('[', makeState(_text.OPENBRACKET)).on('<', makeState(_text.OPENANGLEBRACKET)).on('(', makeState(_text.OPENPAREN)).on('}', makeState(_text.CLOSEBRACE)).on(']', makeState(_text.CLOSEBRACKET)).on('>', makeState(_text.CLOSEANGLEBRACKET)).on(')', makeState(_text.CLOSEPAREN)).on('&', makeState(_text.AMPERSAND)).on([',', ';', '!', '"', '\''], makeState(_text.PUNCTUATION));
	
	// Whitespace jumps
	// Tokens of only non-newline whitespace are arbitrarily long
	S_START.on('\n', makeState(_text.NL)).on(WHITESPACE, S_WS);
	
	// If any whitespace except newline, more whitespace!
	S_WS.on(WHITESPACE, S_WS);
	
	// Generates states for top-level domains
	// Note that this is most accurate when tlds are in alphabetical order
	for (var i = 0; i < tlds.length; i++) {
		var newStates = (0, _state.stateify)(tlds[i], S_START, _text.TLD, _text.DOMAIN);
		domainStates.push.apply(domainStates, newStates);
	}
	
	// Collect the states generated by different protocls
	var partialProtocolFileStates = (0, _state.stateify)('file', S_START, _text.DOMAIN, _text.DOMAIN);
	var partialProtocolFtpStates = (0, _state.stateify)('ftp', S_START, _text.DOMAIN, _text.DOMAIN);
	var partialProtocolHttpStates = (0, _state.stateify)('http', S_START, _text.DOMAIN, _text.DOMAIN);
	var partialProtocolMailtoStates = (0, _state.stateify)('mailto', S_START, _text.DOMAIN, _text.DOMAIN);
	
	// Add the states to the array of DOMAINeric states
	domainStates.push.apply(domainStates, partialProtocolFileStates);
	domainStates.push.apply(domainStates, partialProtocolFtpStates);
	domainStates.push.apply(domainStates, partialProtocolHttpStates);
	
	// Protocol states
	var S_PROTOCOL_FILE = partialProtocolFileStates.pop();
	var S_PROTOCOL_FTP = partialProtocolFtpStates.pop();
	var S_PROTOCOL_HTTP = partialProtocolHttpStates.pop();
	var S_MAILTO = partialProtocolMailtoStates.pop();
	var S_PROTOCOL_SECURE = makeState(_text.DOMAIN);
	var S_FULL_PROTOCOL = makeState(_text.PROTOCOL); // Full protocol ends with COLON
	var S_FULL_MAILTO = makeState(_text.MAILTO); // Mailto ends with COLON
	
	// Secure protocols (end with 's')
	S_PROTOCOL_FTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);
	
	S_PROTOCOL_HTTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);
	
	domainStates.push(S_PROTOCOL_SECURE);
	
	// Become protocol tokens after a COLON
	S_PROTOCOL_FILE.on(':', S_FULL_PROTOCOL);
	S_PROTOCOL_SECURE.on(':', S_FULL_PROTOCOL);
	S_MAILTO.on(':', S_FULL_MAILTO);
	
	// Localhost
	var partialLocalhostStates = (0, _state.stateify)('localhost', S_START, _text.LOCALHOST, _text.DOMAIN);
	domainStates.push.apply(domainStates, partialLocalhostStates);
	
	// Everything else
	// DOMAINs make more DOMAINs
	// Number and character transitions
	S_START.on(NUMBERS, S_NUM);
	S_NUM.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_NUM).on(ALPHANUM, S_DOMAIN); // number becomes DOMAIN
	
	S_DOMAIN.on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);
	
	// All the generated states should have a jump to DOMAIN
	for (var _i = 0; _i < domainStates.length; _i++) {
		domainStates[_i].on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);
	}
	
	S_DOMAIN_HYPHEN.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_DOMAIN).on(ALPHANUM, S_DOMAIN);
	
	// Set default transition
	S_START.defaultTransition = makeState(_text.SYM);
	
	/**
		Given a string, returns an array of TOKEN instances representing the
		composition of that string.
	
		@method run
		@param {String} str Input string to scan
		@return {Array} Array of TOKEN instances
	*/
	var run = function run(str) {
	
		// The state machine only looks at lowercase strings.
		// This selective `toLowerCase` is used because lowercasing the entire
		// string causes the length and character position to vary in some in some
		// non-English strings. This happens only on V8-based runtimes.
		var lowerStr = str.replace(/[A-Z]/g, function (c) {
			return c.toLowerCase();
		});
		var len = str.length;
		var tokens = []; // return value
	
		var cursor = 0;
	
		// Tokenize the string
		while (cursor < len) {
			var state = S_START;
			var secondState = null;
			var nextState = null;
			var tokenLength = 0;
			var latestAccepting = null;
			var sinceAccepts = -1;
	
			while (cursor < len && (nextState = state.next(lowerStr[cursor]))) {
				secondState = null;
				state = nextState;
	
				// Keep track of the latest accepting state
				if (state.accepts()) {
					sinceAccepts = 0;
					latestAccepting = state;
				} else if (sinceAccepts >= 0) {
					sinceAccepts++;
				}
	
				tokenLength++;
				cursor++;
			}
	
			if (sinceAccepts < 0) {
				continue;
			} // Should never happen
	
			// Roll back to the latest accepting state
			cursor -= sinceAccepts;
			tokenLength -= sinceAccepts;
	
			// Get the class for the new token
			var TOKEN = latestAccepting.emit(); // Current token class
	
			// No more jumps, just make a new token
			tokens.push(new TOKEN(str.substr(cursor - tokenLength, tokenLength)));
		}
	
		return tokens;
	};
	
	var start = S_START;
	exports.State = _state.CharacterState;
	exports.TOKENS = TOKENS;
	exports.run = run;
	exports.start = start;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.URL = exports.TEXT = exports.NL = exports.EMAIL = exports.MAILTOEMAIL = exports.Base = undefined;
	
	var _createTokenClass = __webpack_require__(461);
	
	var _class = __webpack_require__(205);
	
	var _text = __webpack_require__(304);
	
	/******************************************************************************
		Multi-Tokens
		Tokens composed of arrays of TextTokens
	******************************************************************************/
	
	// Is the given token a valid domain token?
	// Should nums be included here?
	function isDomainToken(token) {
		return token instanceof _text.DOMAIN || token instanceof _text.TLD;
	}
	
	/**
		Abstract class used for manufacturing tokens of text tokens. That is rather
		than the value for a token being a small string of text, it's value an array
		of text tokens.
	
		Used for grouping together URLs, emails, hashtags, and other potential
		creations.
	
		@class MultiToken
		@abstract
	*/
	var MultiToken = (0, _createTokenClass.createTokenClass)();
	
	MultiToken.prototype = {
		/**
	 	String representing the type for this token
	 	@property type
	 	@default 'TOKEN'
	 */
		type: 'token',
	
		/**
	 	Is this multitoken a link?
	 	@property isLink
	 	@default false
	 */
		isLink: false,
	
		/**
	 	Return the string this token represents.
	 	@method toString
	 	@return {String}
	 */
		toString: function toString() {
			var result = [];
			for (var i = 0; i < this.v.length; i++) {
				result.push(this.v[i].toString());
			}
			return result.join('');
		},
	
	
		/**
	 	What should the value for this token be in the `href` HTML attribute?
	 	Returns the `.toString` value by default.
	 		@method toHref
	 	@return {String}
	 */
		toHref: function toHref() {
			return this.toString();
		},
	
	
		/**
	 	Returns a hash of relevant values for this token, which includes keys
	 	* type - Kind of token ('url', 'email', etc.)
	 	* value - Original text
	 	* href - The value that should be added to the anchor tag's href
	 		attribute
	 		@method toObject
	 	@param {String} [protocol] `'http'` by default
	 	@return {Object}
	 */
		toObject: function toObject() {
			var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';
	
			return {
				type: this.type,
				value: this.toString(),
				href: this.toHref(protocol)
			};
		}
	};
	
	/**
		Represents an arbitrarily mailto email address with the prefix included
		@class MAILTO
		@extends MultiToken
	*/
	var MAILTOEMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
		type: 'email',
		isLink: true
	});
	
	/**
		Represents a list of tokens making up a valid email address
		@class EMAIL
		@extends MultiToken
	*/
	var EMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
		type: 'email',
		isLink: true,
		toHref: function toHref() {
			var tokens = this.v;
			return 'mailto:' + this.toString();
		}
	});
	
	/**
		Represents some plain text
		@class TEXT
		@extends MultiToken
	*/
	var TEXT = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'text' });
	
	/**
		Multi-linebreak token - represents a line break
		@class NL
		@extends MultiToken
	*/
	var NL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'nl' });
	
	/**
		Represents a list of tokens making up a valid URL
		@class URL
		@extends MultiToken
	*/
	var URL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
		type: 'url',
		isLink: true,
	
		/**
	 	Lowercases relevant parts of the domain and adds the protocol if
	 	required. Note that this will not escape unsafe HTML characters in the
	 	URL.
	 		@method href
	 	@param {String} protocol
	 	@return {String}
	 */
		toHref: function toHref() {
			var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';
	
			var hasProtocol = false;
			var hasSlashSlash = false;
			var tokens = this.v;
			var result = [];
			var i = 0;
	
			// Make the first part of the domain lowercase
			// Lowercase protocol
			while (tokens[i] instanceof _text.PROTOCOL) {
				hasProtocol = true;
				result.push(tokens[i].toString().toLowerCase());
				i++;
			}
	
			// Skip slash-slash
			while (tokens[i] instanceof _text.SLASH) {
				hasSlashSlash = true;
				result.push(tokens[i].toString());
				i++;
			}
	
			// Lowercase all other characters in the domain
			while (isDomainToken(tokens[i])) {
				result.push(tokens[i].toString().toLowerCase());
				i++;
			}
	
			// Leave all other characters as they were written
			for (; i < tokens.length; i++) {
				result.push(tokens[i].toString());
			}
	
			result = result.join('');
	
			if (!(hasProtocol || hasSlashSlash)) {
				result = protocol + '://' + result;
			}
	
			return result;
		},
		hasProtocol: function hasProtocol() {
			return this.v[0] instanceof _text.PROTOCOL;
		}
	});
	
	exports.Base = MultiToken;
	exports.MAILTOEMAIL = MAILTOEMAIL;
	exports.EMAIL = EMAIL;
	exports.NL = NL;
	exports.TEXT = TEXT;
	exports.URL = URL;

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var defaults = {
		defaultProtocol: 'http',
		events: null,
		format: noop,
		formatHref: noop,
		nl2br: false,
		tagName: 'a',
		target: typeToTarget,
		validate: true,
		ignoreTags: [],
		attributes: null,
		className: 'linkified' };
	
	exports.defaults = defaults;
	exports.Options = Options;
	exports.contains = contains;
	
	
	function Options(opts) {
		opts = opts || {};
	
		this.defaultProtocol = opts.defaultProtocol || defaults.defaultProtocol;
		this.events = opts.events || defaults.events;
		this.format = opts.format || defaults.format;
		this.formatHref = opts.formatHref || defaults.formatHref;
		this.nl2br = opts.nl2br || defaults.nl2br;
		this.tagName = opts.tagName || defaults.tagName;
		this.target = opts.target || defaults.target;
		this.validate = opts.validate || defaults.validate;
		this.ignoreTags = [];
	
		// linkAttributes and linkClass is deprecated
		this.attributes = opts.attributes || opts.linkAttributes || defaults.attributes;
		this.className = opts.className || opts.linkClass || defaults.className;
	
		// Make all tags names upper case
	
		var ignoredTags = opts.ignoreTags || defaults.ignoreTags;
		for (var i = 0; i < ignoredTags.length; i++) {
			this.ignoreTags.push(ignoredTags[i].toUpperCase());
		}
	}
	
	Options.prototype = {
		/**
	  * Given the token, return all options for how it should be displayed
	  */
		resolve: function resolve(token) {
			var href = token.toHref(this.defaultProtocol);
			return {
				formatted: this.get('format', token.toString(), token),
				formattedHref: this.get('formatHref', href, token),
				tagName: this.get('tagName', href, token),
				className: this.get('className', href, token),
				target: this.get('target', href, token),
				events: this.getObject('events', href, token),
				attributes: this.getObject('attributes', href, token)
			};
		},
	
	
		/**
	  * Returns true or false based on whether a token should be displayed as a
	  * link based on the user options. By default,
	  */
		check: function check(token) {
			return this.get('validate', token.toString(), token);
		},
	
	
		// Private methods
	
		/**
	  * Resolve an option's value based on the value of the option and the given
	  * params.
	  * @param [String] key Name of option to use
	  * @param operator will be passed to the target option if it's method
	  * @param [MultiToken] token The token from linkify.tokenize
	  */
		get: function get(key, operator, token) {
			var option = this[key];
	
			if (!option) {
				return option;
			}
	
			switch (typeof option === 'undefined' ? 'undefined' : _typeof(option)) {
				case 'function':
					return option(operator, token.type);
				case 'object':
					var optionValue = option[token.type] || defaults[key];
					return typeof optionValue === 'function' ? optionValue(operator, token.type) : optionValue;
			}
	
			return option;
		},
		getObject: function getObject(key, operator, token) {
			var option = this[key];
			return typeof option === 'function' ? option(operator, token.type) : option;
		}
	};
	
	/**
	 * Quick indexOf replacement for checking the ignoreTags option
	 */
	function contains(arr, value) {
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] === value) {
				return true;
			}
		}
		return false;
	}
	
	function noop(val) {
		return val;
	}
	
	function typeToTarget(href, type) {
		return type === 'url' ? '_blank' : null;
	}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1022).default;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(112),
	    root = __webpack_require__(85);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1081),
	    hashDelete = __webpack_require__(1082),
	    hashGet = __webpack_require__(1083),
	    hashHas = __webpack_require__(1084),
	    hashSet = __webpack_require__(1085);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(112),
	    root = __webpack_require__(85);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(85);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(112),
	    root = __webpack_require__(85);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(468),
	    eq = __webpack_require__(169);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1038),
	    createBaseEach = __webpack_require__(1066);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1067);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1037),
	    keys = __webpack_require__(320);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(467),
	    isArray = __webpack_require__(37);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1036),
	    baseIsNaN = __webpack_require__(1046),
	    strictIndexOf = __webpack_require__(1116);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(207),
	    arrayIncludes = __webpack_require__(307),
	    arrayIncludesWith = __webpack_require__(308),
	    arrayMap = __webpack_require__(168),
	    baseUnary = __webpack_require__(311),
	    cacheHas = __webpack_require__(209);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObjectLike = __webpack_require__(113);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(463),
	    equalArrays = __webpack_require__(474),
	    equalByTag = __webpack_require__(1070),
	    equalObjects = __webpack_require__(1071),
	    getTag = __webpack_require__(1078),
	    isArray = __webpack_require__(37),
	    isBuffer = __webpack_require__(481),
	    isTypedArray = __webpack_require__(483);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(463),
	    baseIsEqual = __webpack_require__(310);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(482),
	    isMasked = __webpack_require__(1089),
	    isObject = __webpack_require__(137),
	    toSource = __webpack_require__(480);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isLength = __webpack_require__(318),
	    isObjectLike = __webpack_require__(113);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1053),
	    baseMatchesProperty = __webpack_require__(1054),
	    identity = __webpack_require__(316),
	    isArray = __webpack_require__(37),
	    property = __webpack_require__(1128);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(476),
	    nativeKeys = __webpack_require__(1102);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(137),
	    isPrototype = __webpack_require__(476),
	    nativeKeysIn = __webpack_require__(1103);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1035),
	    isArrayLike = __webpack_require__(136);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1045),
	    getMatchData = __webpack_require__(1074),
	    matchesStrictComparable = __webpack_require__(478);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(310),
	    get = __webpack_require__(1122),
	    hasIn = __webpack_require__(1123),
	    isKey = __webpack_require__(313),
	    isStrictComparable = __webpack_require__(477),
	    matchesStrictComparable = __webpack_require__(478),
	    toKey = __webpack_require__(212);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(470);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1119),
	    defineProperty = __webpack_require__(473),
	    identity = __webpack_require__(316);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(167),
	    arrayMap = __webpack_require__(168),
	    isArray = __webpack_require__(37),
	    isSymbol = __webpack_require__(319);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(469),
	    baseFlatten = __webpack_require__(309),
	    baseUniq = __webpack_require__(471);
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var length = arrays.length;
	  if (length < 2) {
	    return length ? baseUniq(arrays[0]) : [];
	  }
	  var index = -1,
	      result = Array(length);
	
	  while (++index < length) {
	    var array = arrays[index],
	        othIndex = -1;
	
	    while (++othIndex < length) {
	      if (othIndex != index) {
	        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	      }
	    }
	  }
	  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	}
	
	module.exports = baseXor;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(213);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1034),
	    baseAssignValue = __webpack_require__(468);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(85);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(135),
	    isIterateeCall = __webpack_require__(1087);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(136);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(462),
	    noop = __webpack_require__(485),
	    setToArray = __webpack_require__(314);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(169);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(167),
	    Uint8Array = __webpack_require__(1031),
	    eq = __webpack_require__(169),
	    equalArrays = __webpack_require__(474),
	    mapToArray = __webpack_require__(1100),
	    setToArray = __webpack_require__(314);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1073);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(1057);
	
	/** Used to map characters to HTML entities. */
	var htmlEscapes = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;'
	};
	
	/**
	 * Used by `_.escape` to convert characters to HTML entities.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	module.exports = escapeHtmlChar;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1039),
	    getSymbols = __webpack_require__(1077),
	    keys = __webpack_require__(320);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(477),
	    keys = __webpack_require__(320);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(479);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(167);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(465),
	    stubArray = __webpack_require__(1129);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1028),
	    Map = __webpack_require__(305),
	    Promise = __webpack_require__(1030),
	    Set = __webpack_require__(462),
	    WeakMap = __webpack_require__(1032),
	    baseGetTag = __webpack_require__(134),
	    toSource = __webpack_require__(480);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(472),
	    isArguments = __webpack_require__(317),
	    isArray = __webpack_require__(37),
	    isIndex = __webpack_require__(312),
	    isLength = __webpack_require__(318),
	    toKey = __webpack_require__(212);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(211);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(211);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(211);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(211);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(167),
	    isArguments = __webpack_require__(317),
	    isArray = __webpack_require__(37);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(169),
	    isArrayLike = __webpack_require__(136),
	    isIndex = __webpack_require__(312),
	    isObject = __webpack_require__(137);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1064);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(208);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(208);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(208);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(208);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1029),
	    ListCache = __webpack_require__(206),
	    Map = __webpack_require__(305);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(210);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(210);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(210);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(210);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(484);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(479);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(475);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234)(module)))

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(464);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1058),
	    shortOut = __webpack_require__(1110);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 1110 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(206);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1113 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(206),
	    Map = __webpack_require__(305),
	    MapCache = __webpack_require__(306);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1101);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1063),
	    createAssigner = __webpack_require__(1065),
	    keysIn = __webpack_require__(1126);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(464),
	    assignInWith = __webpack_require__(1118),
	    baseRest = __webpack_require__(135),
	    customDefaultsAssignIn = __webpack_require__(1069);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, customDefaultsAssignIn);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(309),
	    map = __webpack_require__(1127);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(470);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1040),
	    hasPath = __webpack_require__(1080);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(168),
	    baseIntersection = __webpack_require__(1042),
	    baseRest = __webpack_require__(135),
	    castArrayLikeObject = __webpack_require__(1062);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(310);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(466),
	    baseKeysIn = __webpack_require__(1051),
	    isArrayLike = __webpack_require__(136);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(168),
	    baseIteratee = __webpack_require__(1049),
	    baseMap = __webpack_require__(1052),
	    isArray = __webpack_require__(37);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1055),
	    basePropertyDeep = __webpack_require__(1056),
	    isKey = __webpack_require__(313),
	    toKey = __webpack_require__(212);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(309),
	    baseRest = __webpack_require__(135),
	    baseUniq = __webpack_require__(471),
	    isArrayLikeObject = __webpack_require__(213);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(465),
	    baseRest = __webpack_require__(135),
	    baseXor = __webpack_require__(1061),
	    isArrayLikeObject = __webpack_require__(213);
	
	/**
	 * Creates an array of unique values that is the
	 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the given arrays. The order of result values is determined by the order
	 * they occur in the arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.without
	 * @example
	 *
	 * _.xor([2, 1], [2, 3]);
	 * // => [1, 3]
	 */
	var xor = baseRest(function(arrays) {
	  return baseXor(arrayFilter(arrays, isArrayLikeObject));
	});
	
	module.exports = xor;


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * This is an internal module. MatrixBaseApis is currently only meant to be used
	 * by {@link client~MatrixClient}.
	 *
	 * @module base-apis
	 */
	
	var httpApi = __webpack_require__(216);
	var utils = __webpack_require__(16);
	
	/**
	 * Low-level wrappers for the Matrix APIs
	 *
	 * @constructor
	 *
	 * @param {Object} opts Configuration options
	 *
	 * @param {string} opts.baseUrl Required. The base URL to the client-server
	 * HTTP API.
	 *
	 * @param {string} opts.idBaseUrl Optional. The base identity server URL for
	 * identity server requests.
	 *
	 * @param {Function} opts.request Required. The function to invoke for HTTP
	 * requests. The value of this property is typically <code>require("request")
	 * </code> as it returns a function which meets the required interface. See
	 * {@link requestFunction} for more information.
	 *
	 * @param {string} opts.accessToken The access_token for this user.
	 *
	 * @param {Number=} opts.localTimeoutMs Optional. The default maximum amount of
	 * time to wait before timing out HTTP requests. If not specified, there is no
	 * timeout.
	 *
	 * @param {Object} opts.queryParams Optional. Extra query parameters to append
	 * to all requests with this client. Useful for application services which require
	 * <code>?user_id=</code>.
	 *
	 */
	function MatrixBaseApis(opts) {
	    utils.checkObjectHasKeys(opts, ["baseUrl", "request"]);
	
	    this.baseUrl = opts.baseUrl;
	    this.idBaseUrl = opts.idBaseUrl;
	
	    var httpOpts = {
	        baseUrl: opts.baseUrl,
	        idBaseUrl: opts.idBaseUrl,
	        accessToken: opts.accessToken,
	        request: opts.request,
	        prefix: httpApi.PREFIX_R0,
	        onlyData: true,
	        extraParams: opts.queryParams,
	        localTimeoutMs: opts.localTimeoutMs
	    };
	    this._http = new httpApi.MatrixHttpApi(this, httpOpts);
	
	    this._txnCtr = 0;
	}
	
	/**
	 * Get the Homeserver URL of this client
	 * @return {string} Homeserver URL of this client
	 */
	MatrixBaseApis.prototype.getHomeserverUrl = function () {
	    return this.baseUrl;
	};
	
	/**
	 * Get the Identity Server URL of this client
	 * @return {string} Identity Server URL of this client
	 */
	MatrixBaseApis.prototype.getIdentityServerUrl = function () {
	    return this.idBaseUrl;
	};
	
	/**
	 * Get the access token associated with this account.
	 * @return {?String} The access_token or null
	 */
	MatrixBaseApis.prototype.getAccessToken = function () {
	    return this._http.opts.accessToken || null;
	};
	
	/**
	 * @return {boolean} true if there is a valid access_token for this client.
	 */
	MatrixBaseApis.prototype.isLoggedIn = function () {
	    return this._http.opts.accessToken !== undefined;
	};
	
	/**
	 * Make up a new transaction id
	 *
	 * @return {string} a new, unique, transaction id
	 */
	MatrixBaseApis.prototype.makeTxnId = function () {
	    return "m" + new Date().getTime() + "." + this._txnCtr++;
	};
	
	// Registration/Login operations
	// =============================
	
	/**
	 * @param {string} username
	 * @param {string} password
	 * @param {string} sessionId
	 * @param {Object} auth
	 * @param {Object} bindThreepids Set key 'email' to true to bind any email
	 *     threepid uses during registration in the ID server. Set 'msisdn' to
	 *     true to bind msisdn.
	 * @param {string} guestAccessToken
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.register = function (username, password, sessionId, auth, bindThreepids, guestAccessToken, callback) {
	    // backwards compat
	    if (bindThreepids === true) {
	        bindThreepids = { email: true };
	    } else if (bindThreepids === null || bindThreepids === undefined) {
	        bindThreepids = {};
	    }
	
	    if (auth === undefined || auth === null) {
	        auth = {};
	    }
	    if (sessionId) {
	        auth.session = sessionId;
	    }
	
	    var params = {
	        auth: auth
	    };
	    if (username !== undefined && username !== null) {
	        params.username = username;
	    }
	    if (password !== undefined && password !== null) {
	        params.password = password;
	    }
	    if (bindThreepids.email) {
	        params.bind_email = true;
	    }
	    if (bindThreepids.msisdn) {
	        params.bind_msisdn = true;
	    }
	    if (guestAccessToken !== undefined && guestAccessToken !== null) {
	        params.guest_access_token = guestAccessToken;
	    }
	    // Temporary parameter added to make the register endpoint advertise
	    // msisdn flows. This exists because there are clients that break
	    // when given stages they don't recognise. This parameter will cease
	    // to be necessary once these old clients are gone.
	    // Only send it if we send any params at all (the password param is
	    // mandatory, so if we send any params, we'll send the password param)
	    if (password !== undefined && password !== null) {
	        params.x_show_msisdn = true;
	    }
	
	    return this.registerRequest(params, undefined, callback);
	};
	
	/**
	 * Register a guest account.
	 * @param {Object=} opts Registration options
	 * @param {Object} opts.body JSON HTTP body to provide.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.registerGuest = function (opts, callback) {
	    opts = opts || {};
	    opts.body = opts.body || {};
	    return this.registerRequest(opts.body, "guest", callback);
	};
	
	/**
	 * @param {Object} data   parameters for registration request
	 * @param {string=} kind  type of user to register. may be "guest"
	 * @param {module:client.callback=} callback
	 * @return {module:client.Promise} Resolves: to the /register response
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.registerRequest = function (data, kind, callback) {
	    var params = {};
	    if (kind) {
	        params.kind = kind;
	    }
	
	    return this._http.request(callback, "POST", "/register", params, data);
	};
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.loginFlows = function (callback) {
	    return this._http.request(callback, "GET", "/login");
	};
	
	/**
	 * @param {string} loginType
	 * @param {Object} data
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.login = function (loginType, data, callback) {
	    var login_data = {
	        type: loginType
	    };
	
	    // merge data into login_data
	    utils.extend(login_data, data);
	
	    return this._http.authedRequest(callback, "POST", "/login", undefined, login_data);
	};
	
	/**
	 * @param {string} user
	 * @param {string} password
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.loginWithPassword = function (user, password, callback) {
	    return this.login("m.login.password", {
	        user: user,
	        password: password
	    }, callback);
	};
	
	/**
	 * @param {string} relayState URL Callback after SAML2 Authentication
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.loginWithSAML2 = function (relayState, callback) {
	    return this.login("m.login.saml2", {
	        relay_state: relayState
	    }, callback);
	};
	
	/**
	 * @param {string} redirectUrl The URL to redirect to after the HS
	 * authenticates with CAS.
	 * @return {string} The HS URL to hit to begin the CAS login process.
	 */
	MatrixBaseApis.prototype.getCasLoginUrl = function (redirectUrl) {
	    return this._http.getUrl("/login/cas/redirect", {
	        "redirectUrl": redirectUrl
	    }, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * @param {string} token Login token previously received from homeserver
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.loginWithToken = function (token, callback) {
	    return this.login("m.login.token", {
	        token: token
	    }, callback);
	};
	
	/**
	 * Logs out the current session.
	 * Obviously, further calls that require authorisation should fail after this
	 * method is called. The state of the MatrixClient object is not affected:
	 * it is up to the caller to either reset or destroy the MatrixClient after
	 * this method succeeds.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: On success, the empty object
	 */
	MatrixBaseApis.prototype.logout = function (callback) {
	    return this._http.authedRequest(callback, "POST", '/logout');
	};
	
	/**
	 * Deactivates the logged-in account.
	 * Obviously, further calls that require authorisation should fail after this
	 * method is called. The state of the MatrixClient object is not affected:
	 * it is up to the caller to either reset or destroy the MatrixClient after
	 * this method succeeds.
	 * @param {object} auth Optional. Auth data to supply for User-Interactive auth.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: On success, the empty object
	 */
	MatrixBaseApis.prototype.deactivateAccount = function (auth, callback) {
	    var body = {};
	    if (auth) {
	        body = {
	            auth: auth
	        };
	    }
	    return this._http.authedRequestWithPrefix(callback, "POST", '/account/deactivate', undefined, body, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Get the fallback URL to use for unknown interactive-auth stages.
	 *
	 * @param {string} loginType     the type of stage being attempted
	 * @param {string} authSessionId the auth session ID provided by the homeserver
	 *
	 * @return {string} HS URL to hit to for the fallback interface
	 */
	MatrixBaseApis.prototype.getFallbackAuthUrl = function (loginType, authSessionId) {
	    var path = utils.encodeUri("/auth/$loginType/fallback/web", {
	        $loginType: loginType
	    });
	
	    return this._http.getUrl(path, {
	        session: authSessionId
	    }, httpApi.PREFIX_R0);
	};
	
	// Room operations
	// ===============
	
	/**
	 * Create a new room.
	 * @param {Object} options a list of options to pass to the /createRoom API.
	 * @param {string} options.room_alias_name The alias localpart to assign to
	 * this room.
	 * @param {string} options.visibility Either 'public' or 'private'.
	 * @param {string[]} options.invite A list of user IDs to invite to this room.
	 * @param {string} options.name The name to give this room.
	 * @param {string} options.topic The topic to give this room.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: <code>{room_id: {string},
	 * room_alias: {string(opt)}}</code>
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.createRoom = function (options, callback) {
	    // valid options include: room_alias_name, visibility, invite
	    return this._http.authedRequest(callback, "POST", "/createRoom", undefined, options);
	};
	
	/**
	 * @param {string} roomId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.roomState = function (roomId, callback) {
	    var path = utils.encodeUri("/rooms/$roomId/state", { $roomId: roomId });
	    return this._http.authedRequest(callback, "GET", path);
	};
	
	/**
	 * Retrieve a state event.
	 * @param {string} roomId
	 * @param {string} eventType
	 * @param {string} stateKey
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getStateEvent = function (roomId, eventType, stateKey, callback) {
	    var pathParams = {
	        $roomId: roomId,
	        $eventType: eventType,
	        $stateKey: stateKey
	    };
	    var path = utils.encodeUri("/rooms/$roomId/state/$eventType", pathParams);
	    if (stateKey !== undefined) {
	        path = utils.encodeUri(path + "/$stateKey", pathParams);
	    }
	    return this._http.authedRequest(callback, "GET", path);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventType
	 * @param {Object} content
	 * @param {string} stateKey
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.sendStateEvent = function (roomId, eventType, content, stateKey, callback) {
	    var pathParams = {
	        $roomId: roomId,
	        $eventType: eventType,
	        $stateKey: stateKey
	    };
	    var path = utils.encodeUri("/rooms/$roomId/state/$eventType", pathParams);
	    if (stateKey !== undefined) {
	        path = utils.encodeUri(path + "/$stateKey", pathParams);
	    }
	    return this._http.authedRequest(callback, "PUT", path, undefined, content);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.redactEvent = function (roomId, eventId, callback) {
	    var path = utils.encodeUri("/rooms/$roomId/redact/$eventId", {
	        $roomId: roomId,
	        $eventId: eventId
	    });
	    return this._http.authedRequest(callback, "POST", path, undefined, {});
	};
	
	/**
	 * @param {string} roomId
	 * @param {Number} limit
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.roomInitialSync = function (roomId, limit, callback) {
	    if (utils.isFunction(limit)) {
	        callback = limit;limit = undefined;
	    }
	    var path = utils.encodeUri("/rooms/$roomId/initialSync", { $roomId: roomId });
	    if (!limit) {
	        limit = 30;
	    }
	    return this._http.authedRequest(callback, "GET", path, { limit: limit });
	};
	
	// Room Directory operations
	// =========================
	
	/**
	 * @param {Object} options Options for this request
	 * @param {string} options.server The remote server to query for the room list.
	 *                                Optional. If unspecified, get the local home
	 *                                server's public room list.
	 * @param {number} options.limit Maximum number of entries to return
	 * @param {string} options.since Token to paginate from
	 * @param {object} options.filter Filter parameters
	 * @param {string} options.filter.generic_search_term String to search for
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.publicRooms = function (options, callback) {
	    if (typeof options == 'function') {
	        callback = options;
	        options = {};
	    }
	    if (options === undefined) {
	        options = {};
	    }
	
	    var query_params = {};
	    if (options.server) {
	        query_params.server = options.server;
	        delete options.server;
	    }
	
	    if (Object.keys(options).length === 0 && Object.keys(query_params).length === 0) {
	        return this._http.authedRequest(callback, "GET", "/publicRooms");
	    } else {
	        return this._http.authedRequest(callback, "POST", "/publicRooms", query_params, options);
	    }
	};
	
	/**
	 * Create an alias to room ID mapping.
	 * @param {string} alias The room alias to create.
	 * @param {string} roomId The room ID to link the alias to.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.createAlias = function (alias, roomId, callback) {
	    var path = utils.encodeUri("/directory/room/$alias", {
	        $alias: alias
	    });
	    var data = {
	        room_id: roomId
	    };
	    return this._http.authedRequest(callback, "PUT", path, undefined, data);
	};
	
	/**
	 * Delete an alias to room ID mapping.  This alias must be on your local server
	 * and you must have sufficient access to do this operation.
	 * @param {string} alias The room alias to delete.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.deleteAlias = function (alias, callback) {
	    var path = utils.encodeUri("/directory/room/$alias", {
	        $alias: alias
	    });
	    return this._http.authedRequest(callback, "DELETE", path, undefined, undefined);
	};
	
	/**
	 * Get room info for the given alias.
	 * @param {string} alias The room alias to resolve.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Object with room_id and servers.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getRoomIdForAlias = function (alias, callback) {
	    // TODO: deprecate this or resolveRoomAlias
	    var path = utils.encodeUri("/directory/room/$alias", {
	        $alias: alias
	    });
	    return this._http.authedRequest(callback, "GET", path);
	};
	
	/**
	 * @param {string} roomAlias
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.resolveRoomAlias = function (roomAlias, callback) {
	    // TODO: deprecate this or getRoomIdForAlias
	    var path = utils.encodeUri("/directory/room/$alias", { $alias: roomAlias });
	    return this._http.request(callback, "GET", path);
	};
	
	/**
	 * Get the visibility of a room in the current HS's room directory
	 * @param {string} roomId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getRoomDirectoryVisibility = function (roomId, callback) {
	    var path = utils.encodeUri("/directory/list/room/$roomId", {
	        $roomId: roomId
	    });
	    return this._http.authedRequest(callback, "GET", path);
	};
	
	/**
	 * Set the visbility of a room in the current HS's room directory
	 * @param {string} roomId
	 * @param {string} visibility "public" to make the room visible
	 *                 in the public directory, or "private" to make
	 *                 it invisible.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.setRoomDirectoryVisibility = function (roomId, visibility, callback) {
	    var path = utils.encodeUri("/directory/list/room/$roomId", {
	        $roomId: roomId
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, { "visibility": visibility });
	};
	
	/**
	 * Set the visbility of a room bridged to a 3rd party network in
	 * the current HS's room directory.
	 * @param {string} networkId the network ID of the 3rd party
	 *                 instance under which this room is published under.
	 * @param {string} roomId
	 * @param {string} visibility "public" to make the room visible
	 *                 in the public directory, or "private" to make
	 *                 it invisible.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.setRoomDirectoryVisibilityAppService = function (networkId, roomId, visibility, callback) {
	    var path = utils.encodeUri("/directory/list/appservice/$networkId/$roomId", {
	        $networkId: networkId,
	        $roomId: roomId
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, { "visibility": visibility });
	};
	
	// Media operations
	// ================
	
	/**
	 * Upload a file to the media repository on the home server.
	 *
	 * @param {object} file The object to upload. On a browser, something that
	 *   can be sent to XMLHttpRequest.send (typically a File).  Under node.js,
	 *   a a Buffer, String or ReadStream.
	 *
	 * @param {object} opts  options object
	 *
	 * @param {string=} opts.name   Name to give the file on the server. Defaults
	 *   to <tt>file.name</tt>.
	 *
	 * @param {string=} opts.type   Content-type for the upload. Defaults to
	 *   <tt>file.type</tt>, or <tt>applicaton/octet-stream</tt>.
	 *
	 * @param {boolean=} opts.rawResponse Return the raw body, rather than
	 *   parsing the JSON. Defaults to false (except on node.js, where it
	 *   defaults to true for backwards compatibility).
	 *
	 * @param {boolean=} opts.onlyContentUri Just return the content URI,
	 *   rather than the whole body. Defaults to false (except on browsers,
	 *   where it defaults to true for backwards compatibility). Ignored if
	 *   opts.rawResponse is true.
	 *
	 * @param {Function=} opts.callback Deprecated. Optional. The callback to
	 *    invoke on success/failure. See the promise return values for more
	 *    information.
	 *
	 * @return {module:client.Promise} Resolves to response object, as
	 *    determined by this.opts.onlyData, opts.rawResponse, and
	 *    opts.onlyContentUri.  Rejects with an error (usually a MatrixError).
	 */
	MatrixBaseApis.prototype.uploadContent = function (file, opts) {
	    return this._http.uploadContent(file, opts);
	};
	
	/**
	 * Cancel a file upload in progress
	 * @param {module:client.Promise} promise The promise returned from uploadContent
	 * @return {boolean} true if canceled, otherwise false
	 */
	MatrixBaseApis.prototype.cancelUpload = function (promise) {
	    return this._http.cancelUpload(promise);
	};
	
	/**
	 * Get a list of all file uploads in progress
	 * @return {array} Array of objects representing current uploads.
	 * Currently in progress is element 0. Keys:
	 *  - promise: The promise associated with the upload
	 *  - loaded: Number of bytes uploaded
	 *  - total: Total number of bytes to upload
	 */
	MatrixBaseApis.prototype.getCurrentUploads = function () {
	    return this._http.getCurrentUploads();
	};
	
	// Profile operations
	// ==================
	
	/**
	 * @param {string} userId
	 * @param {string} info The kind of info to retrieve (e.g. 'displayname',
	 * 'avatar_url').
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getProfileInfo = function (userId, info, callback) {
	    if (utils.isFunction(info)) {
	        callback = info;info = undefined;
	    }
	
	    var path = info ? utils.encodeUri("/profile/$userId/$info", { $userId: userId, $info: info }) : utils.encodeUri("/profile/$userId", { $userId: userId });
	    return this._http.authedRequest(callback, "GET", path);
	};
	
	// Account operations
	// ==================
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getThreePids = function (callback) {
	    var path = "/account/3pid";
	    return this._http.authedRequest(callback, "GET", path, undefined, undefined);
	};
	
	/**
	 * @param {Object} creds
	 * @param {boolean} bind
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.addThreePid = function (creds, bind, callback) {
	    var path = "/account/3pid";
	    var data = {
	        'threePidCreds': creds,
	        'bind': bind
	    };
	    return this._http.authedRequest(callback, "POST", path, null, data);
	};
	
	/**
	 * @param {string} medium The threepid medium (eg. 'email')
	 * @param {string} address The threepid address (eg. 'bob@example.com')
	 *        this must be as returned by getThreePids.
	 * @return {module:client.Promise} Resolves: The server response on success
	 *     (generally the empty JSON object)
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.deleteThreePid = function (medium, address) {
	    var path = "/account/3pid/delete";
	    var data = {
	        'medium': medium,
	        'address': address
	    };
	    return this._http.authedRequestWithPrefix(undefined, "POST", path, null, data, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Make a request to change your password.
	 * @param {Object} authDict
	 * @param {string} newPassword The new desired password.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.setPassword = function (authDict, newPassword, callback) {
	    var path = "/account/password";
	    var data = {
	        'auth': authDict,
	        'new_password': newPassword
	    };
	
	    return this._http.authedRequest(callback, "POST", path, null, data);
	};
	
	// Device operations
	// =================
	
	/**
	 * Gets all devices recorded for the logged-in user
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getDevices = function () {
	    var path = "/devices";
	    return this._http.authedRequestWithPrefix(undefined, "GET", path, undefined, undefined, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Update the given device
	 *
	 * @param {string} device_id  device to update
	 * @param {Object} body       body of request
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.setDeviceDetails = function (device_id, body) {
	    var path = utils.encodeUri("/devices/$device_id", {
	        $device_id: device_id
	    });
	
	    return this._http.authedRequestWithPrefix(undefined, "PUT", path, undefined, body, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Delete the given device
	 *
	 * @param {string} device_id  device to delete
	 * @param {object} auth Optional. Auth data to supply for User-Interactive auth.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.deleteDevice = function (device_id, auth) {
	    var path = utils.encodeUri("/devices/$device_id", {
	        $device_id: device_id
	    });
	
	    var body = {};
	
	    if (auth) {
	        body.auth = auth;
	    }
	
	    return this._http.authedRequestWithPrefix(undefined, "DELETE", path, undefined, body, httpApi.PREFIX_UNSTABLE);
	};
	
	// Push operations
	// ===============
	
	/**
	 * Gets all pushers registered for the logged-in user
	 *
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Array of objects representing pushers
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getPushers = function (callback) {
	    var path = "/pushers";
	    return this._http.authedRequest(callback, "GET", path, undefined, undefined);
	};
	
	/**
	 * Adds a new pusher or updates an existing pusher
	 *
	 * @param {Object} pusher Object representing a pusher
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Empty json object on success
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.setPusher = function (pusher, callback) {
	    var path = "/pushers/set";
	    return this._http.authedRequest(callback, "POST", path, null, pusher);
	};
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.getPushRules = function (callback) {
	    return this._http.authedRequest(callback, "GET", "/pushrules/");
	};
	
	/**
	 * @param {string} scope
	 * @param {string} kind
	 * @param {string} ruleId
	 * @param {Object} body
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.addPushRule = function (scope, kind, ruleId, body, callback) {
	    // NB. Scope not uri encoded because devices need the '/'
	    var path = utils.encodeUri("/pushrules/" + scope + "/$kind/$ruleId", {
	        $kind: kind,
	        $ruleId: ruleId
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, body);
	};
	
	/**
	 * @param {string} scope
	 * @param {string} kind
	 * @param {string} ruleId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.deletePushRule = function (scope, kind, ruleId, callback) {
	    // NB. Scope not uri encoded because devices need the '/'
	    var path = utils.encodeUri("/pushrules/" + scope + "/$kind/$ruleId", {
	        $kind: kind,
	        $ruleId: ruleId
	    });
	    return this._http.authedRequest(callback, "DELETE", path);
	};
	
	/**
	 * Enable or disable a push notification rule.
	 * @param {string} scope
	 * @param {string} kind
	 * @param {string} ruleId
	 * @param {boolean} enabled
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.setPushRuleEnabled = function (scope, kind, ruleId, enabled, callback) {
	    var path = utils.encodeUri("/pushrules/" + scope + "/$kind/$ruleId/enabled", {
	        $kind: kind,
	        $ruleId: ruleId
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, { "enabled": enabled });
	};
	
	/**
	 * Set the actions for a push notification rule.
	 * @param {string} scope
	 * @param {string} kind
	 * @param {string} ruleId
	 * @param {array} actions
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.setPushRuleActions = function (scope, kind, ruleId, actions, callback) {
	    var path = utils.encodeUri("/pushrules/" + scope + "/$kind/$ruleId/actions", {
	        $kind: kind,
	        $ruleId: ruleId
	    });
	    return this._http.authedRequest(callback, "PUT", path, undefined, { "actions": actions });
	};
	
	// Search
	// ======
	
	/**
	 * Perform a server-side search.
	 * @param {Object} opts
	 * @param {string} opts.next_batch the batch token to pass in the query string
	 * @param {Object} opts.body the JSON object to pass to the request body.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.search = function (opts, callback) {
	    var queryparams = {};
	    if (opts.next_batch) {
	        queryparams.next_batch = opts.next_batch;
	    }
	    return this._http.authedRequest(callback, "POST", "/search", queryparams, opts.body);
	};
	
	// Crypto
	// ======
	
	/**
	 * Upload keys
	 *
	 * @param {Object} content  body of upload request
	 *
	 * @param {Object=} opts
	 *
	 * @param {string=} opts.device_id  explicit device_id to use for upload
	 *    (default is to use the same as that used during auth).
	 *
	 * @param {module:client.callback=} callback
	 *
	 * @return {module:client.Promise} Resolves: result object. Rejects: with
	 *     an error response ({@link module:http-api.MatrixError}).
	 */
	MatrixBaseApis.prototype.uploadKeysRequest = function (content, opts, callback) {
	    opts = opts || {};
	    var deviceId = opts.device_id;
	    var path = void 0;
	    if (deviceId) {
	        path = utils.encodeUri("/keys/upload/$deviceId", {
	            $deviceId: deviceId
	        });
	    } else {
	        path = "/keys/upload";
	    }
	    return this._http.authedRequestWithPrefix(callback, "POST", path, undefined, content, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Download device keys
	 *
	 * @param {string[]} userIds  list of users to get keys for
	 *
	 * @param {Object=} opts
	 *
	 * @param {string=} opts.token   sync token to pass in the query request, to help
	 *   the HS give the most recent results
	 *
	 * @return {module:client.Promise} Resolves: result object. Rejects: with
	 *     an error response ({@link module:http-api.MatrixError}).
	 */
	MatrixBaseApis.prototype.downloadKeysForUsers = function (userIds, opts) {
	    if (utils.isFunction(opts)) {
	        // opts used to be 'callback'.
	        throw new Error('downloadKeysForUsers no longer accepts a callback parameter');
	    }
	    opts = opts || {};
	
	    var content = {
	        device_keys: {}
	    };
	    if ('token' in opts) {
	        content.token = opts.token;
	    }
	    userIds.forEach(function (u) {
	        content.device_keys[u] = {};
	    });
	
	    return this._http.authedRequestWithPrefix(undefined, "POST", "/keys/query", undefined, content, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Claim one-time keys
	 *
	 * @param {string[]} devices  a list of [userId, deviceId] pairs
	 *
	 * @param {string} [key_algorithm = signed_curve25519]  desired key type
	 *
	 * @return {module:client.Promise} Resolves: result object. Rejects: with
	 *     an error response ({@link module:http-api.MatrixError}).
	 */
	MatrixBaseApis.prototype.claimOneTimeKeys = function (devices, key_algorithm) {
	    var queries = {};
	
	    if (key_algorithm === undefined) {
	        key_algorithm = "signed_curve25519";
	    }
	
	    for (var i = 0; i < devices.length; ++i) {
	        var userId = devices[i][0];
	        var deviceId = devices[i][1];
	        var query = queries[userId] || {};
	        queries[userId] = query;
	        query[deviceId] = key_algorithm;
	    }
	    var content = { one_time_keys: queries };
	    return this._http.authedRequestWithPrefix(undefined, "POST", "/keys/claim", undefined, content, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Ask the server for a list of users who have changed their device lists
	 * between a pair of sync tokens
	 *
	 * @param {string} oldToken
	 * @param {string} newToken
	 *
	 * @return {module:client.Promise} Resolves: result object. Rejects: with
	 *     an error response ({@link module:http-api.MatrixError}).
	 */
	MatrixBaseApis.prototype.getKeyChanges = function (oldToken, newToken) {
	    var qps = {
	        from: oldToken,
	        to: newToken
	    };
	
	    return this._http.authedRequestWithPrefix(undefined, "GET", "/keys/changes", qps, undefined, httpApi.PREFIX_UNSTABLE);
	};
	
	// Identity Server Operations
	// ==========================
	
	/**
	 * Requests an email verification token directly from an Identity Server.
	 *
	 * Note that the Home Server offers APIs to proxy this API for specific
	 * situations, allowing for better feedback to the user.
	 *
	 * @param {string} email The email address to request a token for
	 * @param {string} clientSecret A secret binary string generated by the client.
	 *                 It is recommended this be around 16 ASCII characters.
	 * @param {number} sendAttempt If an identity server sees a duplicate request
	 *                 with the same sendAttempt, it will not send another email.
	 *                 To request another email to be sent, use a larger value for
	 *                 the sendAttempt param as was used in the previous request.
	 * @param {string} nextLink Optional If specified, the client will be redirected
	 *                 to this link after validation.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 * @throws Error if No ID server is set
	 */
	MatrixBaseApis.prototype.requestEmailToken = function (email, clientSecret, sendAttempt, nextLink, callback) {
	    var params = {
	        client_secret: clientSecret,
	        email: email,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    };
	    return this._http.idServerRequest(callback, "POST", "/validate/email/requestToken", params, httpApi.PREFIX_IDENTITY_V1);
	};
	
	/**
	 * Submits an MSISDN token to the identity server
	 *
	 * This is used when submitting the code sent by SMS to a phone number.
	 * The ID server has an equivalent API for email but the js-sdk does
	 * not expose this, since email is normally validated by the user clicking
	 * a link rather than entering a code.
	 *
	 * @param {string} sid The sid given in the response to requestToken
	 * @param {string} clientSecret A secret binary string generated by the client.
	 *                 This must be the same value submitted in the requestToken call.
	 * @param {string} token The token, as enetered by the user.
	 *
	 * @return {module:client.Promise} Resolves: Object, currently with no parameters.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 * @throws Error if No ID server is set
	 */
	MatrixBaseApis.prototype.submitMsisdnToken = function (sid, clientSecret, token) {
	    var params = {
	        sid: sid,
	        client_secret: clientSecret,
	        token: token
	    };
	    return this._http.idServerRequest(undefined, "POST", "/validate/msisdn/submitToken", params, httpApi.PREFIX_IDENTITY_V1);
	};
	
	/**
	 * Looks up the public Matrix ID mapping for a given 3rd party
	 * identifier from the Identity Server
	 * @param {string} medium The medium of the threepid, eg. 'email'
	 * @param {string} address The textual address of the threepid
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: A threepid mapping
	 *                                 object or the empty object if no mapping
	 *                                 exists
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixBaseApis.prototype.lookupThreePid = function (medium, address, callback) {
	    var params = {
	        medium: medium,
	        address: address
	    };
	    return this._http.idServerRequest(callback, "GET", "/lookup", params, httpApi.PREFIX_IDENTITY_V1);
	};
	
	// Direct-to-device messaging
	// ==========================
	
	/**
	 * Send an event to a specific list of devices
	 *
	 * @param {string} eventType  type of event to send
	 * @param {Object.<string, Object<string, Object>>} contentMap
	 *    content to send. Map from user_id to device_id to content object.
	 * @param {string=} txnId     transaction id. One will be made up if not
	 *    supplied.
	 * @return {module:client.Promise} Resolves to the result object
	 */
	MatrixBaseApis.prototype.sendToDevice = function (eventType, contentMap, txnId) {
	    var path = utils.encodeUri("/sendToDevice/$eventType/$txnId", {
	        $eventType: eventType,
	        $txnId: txnId ? txnId : this.makeTxnId()
	    });
	
	    var body = {
	        messages: contentMap
	    };
	
	    return this._http.authedRequestWithPrefix(undefined, "PUT", path, undefined, body, httpApi.PREFIX_UNSTABLE);
	};
	
	// Third party Lookup API
	// ======================
	
	/**
	 * Get the third party protocols that can be reached using
	 * this HS
	 * @return {module:client.Promise} Resolves to the result object
	 */
	MatrixBaseApis.prototype.getThirdpartyProtocols = function () {
	    return this._http.authedRequestWithPrefix(undefined, "GET", "/thirdparty/protocols", undefined, undefined, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * Get information on how a specific place on a third party protocol
	 * may be reached.
	 * @param {string} protocol The protocol given in getThirdpartyProtocols()
	 * @param {object} params Protocol-specific parameters, as given in th
	 *                        response to getThirdpartyProtocols()
	 * @return {module:client.Promise} Resolves to the result object
	 */
	MatrixBaseApis.prototype.getThirdpartyLocation = function (protocol, params) {
	    var path = utils.encodeUri("/thirdparty/location/$protocol", {
	        $protocol: protocol
	    });
	
	    return this._http.authedRequestWithPrefix(undefined, "GET", path, params, undefined, httpApi.PREFIX_UNSTABLE);
	};
	
	/**
	 * MatrixBaseApis object
	 */
	module.exports = MatrixBaseApis;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module crypto/DeviceList
	 *
	 * Manages the list of other users' devices
	 */
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _deviceinfo = __webpack_require__(322);
	
	var _deviceinfo2 = _interopRequireDefault(_deviceinfo);
	
	var _olmlib = __webpack_require__(215);
	
	var _olmlib2 = _interopRequireDefault(_olmlib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @alias module:crypto/DeviceList
	 */
	var DeviceList = function () {
	    function DeviceList(baseApis, sessionStore, olmDevice) {
	        _classCallCheck(this, DeviceList);
	
	        this._baseApis = baseApis;
	        this._sessionStore = sessionStore;
	        this._olmDevice = olmDevice;
	
	        // users with outdated device lists
	        // userId -> true
	        this._pendingUsersWithNewDevices = {};
	
	        // userId -> true
	        this._keyDownloadsInProgressByUser = {};
	
	        // deferred which is resolved when the current device query resolves.
	        // (null if there is no current request).
	        this._currentQueryDeferred = null;
	
	        // deferred which is resolved when the *next* device query resolves.
	        //
	        // Normally it is meaningless for this to be non-null when
	        // _currentQueryDeferred is null, but it can happen if the previous
	        // query has finished but the next one has not yet started (because the
	        // previous query failed, in which case we deliberately delay starting
	        // the next query to avoid tight-looping).
	        this._queuedQueryDeferred = null;
	
	        this.lastKnownSyncToken = null;
	    }
	
	    /**
	     * Download the keys for a list of users and stores the keys in the session
	     * store.
	     * @param {Array} userIds The users to fetch.
	     * @param {bool} forceDownload Always download the keys even if cached.
	     *
	     * @return {Promise} A promise which resolves to a map userId->deviceId->{@link
	     * module:crypto/deviceinfo|DeviceInfo}.
	     */
	
	
	    _createClass(DeviceList, [{
	        key: 'downloadKeys',
	        value: function downloadKeys(userIds, forceDownload) {
	            var _this = this;
	
	            var needsRefresh = false;
	            var waitForCurrentQuery = false;
	
	            userIds.forEach(function (u) {
	                if (_this._pendingUsersWithNewDevices[u]) {
	                    // we already know this user's devices are outdated
	                    needsRefresh = true;
	                } else if (_this._keyDownloadsInProgressByUser[u]) {
	                    // already a download in progress - just wait for it.
	                    // (even if forceDownload is true)
	                    waitForCurrentQuery = true;
	                } else if (forceDownload) {
	                    console.log("Invalidating device list for " + u + " for forceDownload");
	                    _this.invalidateUserDeviceList(u);
	                    needsRefresh = true;
	                } else if (!_this.getStoredDevicesForUser(u)) {
	                    console.log("Invalidating device list for " + u + " due to empty cache");
	                    _this.invalidateUserDeviceList(u);
	                    needsRefresh = true;
	                }
	            });
	
	            var promise = void 0;
	            if (needsRefresh) {
	                console.log("downloadKeys: waiting for next key query");
	                promise = this._startOrQueueDeviceQuery();
	            } else if (waitForCurrentQuery) {
	                console.log("downloadKeys: waiting for in-flight query to complete");
	                promise = this._currentQueryDeferred.promise;
	            } else {
	                // we're all up-to-date.
	                promise = (0, _q2.default)();
	            }
	
	            return promise.then(function () {
	                return _this._getDevicesFromStore(userIds);
	            });
	        }
	
	        /**
	         * Get the stored device keys for a list of user ids
	         *
	         * @param {string[]} userIds the list of users to list keys for.
	         *
	         * @return {Object} userId->deviceId->{@link module:crypto/deviceinfo|DeviceInfo}.
	         */
	
	    }, {
	        key: '_getDevicesFromStore',
	        value: function _getDevicesFromStore(userIds) {
	            var stored = {};
	            var self = this;
	            userIds.map(function (u) {
	                stored[u] = {};
	                var devices = self.getStoredDevicesForUser(u) || [];
	                devices.map(function (dev) {
	                    stored[u][dev.deviceId] = dev;
	                });
	            });
	            return stored;
	        }
	
	        /**
	         * Get the stored device keys for a user id
	         *
	         * @param {string} userId the user to list keys for.
	         *
	         * @return {module:crypto/deviceinfo[]|null} list of devices, or null if we haven't
	         * managed to get a list of devices for this user yet.
	         */
	
	    }, {
	        key: 'getStoredDevicesForUser',
	        value: function getStoredDevicesForUser(userId) {
	            var devs = this._sessionStore.getEndToEndDevicesForUser(userId);
	            if (!devs) {
	                return null;
	            }
	            var res = [];
	            for (var deviceId in devs) {
	                if (devs.hasOwnProperty(deviceId)) {
	                    res.push(_deviceinfo2.default.fromStorage(devs[deviceId], deviceId));
	                }
	            }
	            return res;
	        }
	
	        /**
	         * Get the stored keys for a single device
	         *
	         * @param {string} userId
	         * @param {string} deviceId
	         *
	         * @return {module:crypto/deviceinfo?} device, or undefined
	         * if we don't know about this device
	         */
	
	    }, {
	        key: 'getStoredDevice',
	        value: function getStoredDevice(userId, deviceId) {
	            var devs = this._sessionStore.getEndToEndDevicesForUser(userId);
	            if (!devs || !devs[deviceId]) {
	                return undefined;
	            }
	            return _deviceinfo2.default.fromStorage(devs[deviceId], deviceId);
	        }
	
	        /**
	         * Find a device by curve25519 identity key
	         *
	         * @param {string} userId     owner of the device
	         * @param {string} algorithm  encryption algorithm
	         * @param {string} senderKey  curve25519 key to match
	         *
	         * @return {module:crypto/deviceinfo?}
	         */
	
	    }, {
	        key: 'getDeviceByIdentityKey',
	        value: function getDeviceByIdentityKey(userId, algorithm, senderKey) {
	            if (algorithm !== _olmlib2.default.OLM_ALGORITHM && algorithm !== _olmlib2.default.MEGOLM_ALGORITHM) {
	                // we only deal in olm keys
	                return null;
	            }
	
	            var devices = this._sessionStore.getEndToEndDevicesForUser(userId);
	            if (!devices) {
	                return null;
	            }
	
	            for (var deviceId in devices) {
	                if (!devices.hasOwnProperty(deviceId)) {
	                    continue;
	                }
	
	                var device = devices[deviceId];
	                for (var keyId in device.keys) {
	                    if (!device.keys.hasOwnProperty(keyId)) {
	                        continue;
	                    }
	                    if (keyId.indexOf("curve25519:") !== 0) {
	                        continue;
	                    }
	                    var deviceKey = device.keys[keyId];
	                    if (deviceKey == senderKey) {
	                        return _deviceinfo2.default.fromStorage(device, deviceId);
	                    }
	                }
	            }
	
	            // doesn't match a known device
	            return null;
	        }
	
	        /**
	         * Mark the cached device list for the given user outdated.
	         *
	         * This doesn't set off an update, so that several users can be batched
	         * together. Call refreshOutdatedDeviceLists() for that.
	         *
	         * @param {String} userId
	         */
	
	    }, {
	        key: 'invalidateUserDeviceList',
	        value: function invalidateUserDeviceList(userId) {
	            // sanity-check the userId. This is mostly paranoia, but if synapse
	            // can't parse the userId we give it as an mxid, it 500s the whole
	            // request and we can never update the device lists again (because
	            // the broken userId is always 'invalid' and always included in any
	            // refresh request).
	            // By checking it is at least a string, we can eliminate a class of
	            // silly errors.
	            if (typeof userId !== 'string') {
	                throw new Error('userId must be a string; was ' + userId);
	            }
	            this._pendingUsersWithNewDevices[userId] = true;
	        }
	
	        /**
	         * If there is not already a device list query in progress, and we have
	         * users who have outdated device lists, start a query now.
	         */
	
	    }, {
	        key: 'refreshOutdatedDeviceLists',
	        value: function refreshOutdatedDeviceLists() {
	            if (this._currentQueryDeferred) {
	                // request already in progress - do nothing. (We will automatically
	                // make another request if there are more users with outdated
	                // device lists when the current request completes).
	                return;
	            }
	
	            this._startDeviceQuery();
	        }
	
	        /**
	         * If there is currently a device list query in progress, returns a promise
	         * which will resolve when the *next* query completes. Otherwise, starts
	         * a new query, and returns a promise which resolves when it completes.
	         *
	         * @return {Promise}
	         */
	
	    }, {
	        key: '_startOrQueueDeviceQuery',
	        value: function _startOrQueueDeviceQuery() {
	            if (!this._currentQueryDeferred) {
	                this._startDeviceQuery();
	                if (!this._currentQueryDeferred) {
	                    return (0, _q2.default)();
	                }
	
	                return this._currentQueryDeferred.promise;
	            }
	
	            if (!this._queuedQueryDeferred) {
	                this._queuedQueryDeferred = _q2.default.defer();
	            }
	
	            return this._queuedQueryDeferred.promise;
	        }
	
	        /**
	         * kick off a new device query
	         *
	         * Throws if there is already a query in progress.
	         */
	
	    }, {
	        key: '_startDeviceQuery',
	        value: function _startDeviceQuery() {
	            var _this2 = this;
	
	            if (this._currentQueryDeferred) {
	                throw new Error("DeviceList._startDeviceQuery called with request active");
	            }
	
	            this._currentQueryDeferred = this._queuedQueryDeferred || _q2.default.defer();
	            this._queuedQueryDeferred = null;
	
	            var users = Object.keys(this._pendingUsersWithNewDevices);
	            if (users.length === 0) {
	                // nothing to do
	                this._currentQueryDeferred.resolve();
	                this._currentQueryDeferred = null;
	
	                // that means we're up-to-date with the lastKnownSyncToken.
	                var token = this.lastKnownSyncToken;
	                if (token !== null) {
	                    this._sessionStore.storeEndToEndDeviceSyncToken(token);
	                }
	
	                return;
	            }
	
	            this._doKeyDownloadForUsers(users).done(function () {
	                users.forEach(function (u) {
	                    delete _this2._keyDownloadsInProgressByUser[u];
	                });
	
	                _this2._currentQueryDeferred.resolve();
	                _this2._currentQueryDeferred = null;
	
	                // flush out any more requests that were blocked up while that
	                // was going on.
	                _this2._startDeviceQuery();
	            }, function (e) {
	                console.error('Error updating device key cache for ' + users + ":", e);
	
	                // reinstate the pending flags on any users which failed; this will
	                // mean that we will do another download in the future (actually on
	                // the next /sync).
	                users.forEach(function (u) {
	                    delete _this2._keyDownloadsInProgressByUser[u];
	                    _this2._pendingUsersWithNewDevices[u] = true;
	                });
	
	                _this2._currentQueryDeferred.reject(e);
	                _this2._currentQueryDeferred = null;
	            });
	
	            users.forEach(function (u) {
	                delete _this2._pendingUsersWithNewDevices[u];
	                _this2._keyDownloadsInProgressByUser[u] = true;
	            });
	        }
	
	        /**
	         * @param {string[]} downloadUsers list of userIds
	         *
	         * @return {Promise}
	         */
	
	    }, {
	        key: '_doKeyDownloadForUsers',
	        value: function _doKeyDownloadForUsers(downloadUsers) {
	            var _this3 = this;
	
	            console.log('Starting key download for ' + downloadUsers);
	
	            var token = this.lastKnownSyncToken;
	            var opts = {};
	            if (token) {
	                opts.token = token;
	            }
	            return this._baseApis.downloadKeysForUsers(downloadUsers, opts).then(function (res) {
	                var dk = res.device_keys || {};
	
	                // do each user in a separate promise, to avoid wedging the CPU
	                // (https://github.com/vector-im/riot-web/issues/3158)
	                //
	                // of course we ought to do this in a web worker or similar, but
	                // this serves as an easy solution for now.
	                var prom = (0, _q2.default)();
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    var _loop = function _loop() {
	                        var userId = _step.value;
	
	                        prom = prom.delay(5).then(function () {
	                            _this3._processQueryResponseForUser(userId, dk[userId]);
	                        });
	                    };
	
	                    for (var _iterator = downloadUsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        _loop();
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                return prom;
	            }).then(function () {
	                if (token !== null) {
	                    _this3._sessionStore.storeEndToEndDeviceSyncToken(token);
	                }
	                console.log('Completed key download for ' + downloadUsers);
	            });
	        }
	    }, {
	        key: '_processQueryResponseForUser',
	        value: function _processQueryResponseForUser(userId, response) {
	            console.log('got keys for ' + userId + ':', response);
	
	            // map from deviceid -> deviceinfo for this user
	            var userStore = {};
	            var devs = this._sessionStore.getEndToEndDevicesForUser(userId);
	            if (devs) {
	                Object.keys(devs).forEach(function (deviceId) {
	                    var d = _deviceinfo2.default.fromStorage(devs[deviceId], deviceId);
	                    userStore[deviceId] = d;
	                });
	            }
	
	            _updateStoredDeviceKeysForUser(this._olmDevice, userId, userStore, response || {});
	
	            // update the session store
	            var storage = {};
	            Object.keys(userStore).forEach(function (deviceId) {
	                storage[deviceId] = userStore[deviceId].toStorage();
	            });
	
	            this._sessionStore.storeEndToEndDevicesForUser(userId, storage);
	        }
	    }]);
	
	    return DeviceList;
	}();
	
	exports.default = DeviceList;
	
	
	function _updateStoredDeviceKeysForUser(_olmDevice, userId, userStore, userResult) {
	    var updated = false;
	
	    // remove any devices in the store which aren't in the response
	    for (var deviceId in userStore) {
	        if (!userStore.hasOwnProperty(deviceId)) {
	            continue;
	        }
	
	        if (!(deviceId in userResult)) {
	            console.log("Device " + userId + ":" + deviceId + " has been removed");
	            delete userStore[deviceId];
	            updated = true;
	        }
	    }
	
	    for (var _deviceId in userResult) {
	        if (!userResult.hasOwnProperty(_deviceId)) {
	            continue;
	        }
	
	        var deviceResult = userResult[_deviceId];
	
	        // check that the user_id and device_id in the response object are
	        // correct
	        if (deviceResult.user_id !== userId) {
	            console.warn("Mismatched user_id " + deviceResult.user_id + " in keys from " + userId + ":" + _deviceId);
	            continue;
	        }
	        if (deviceResult.device_id !== _deviceId) {
	            console.warn("Mismatched device_id " + deviceResult.device_id + " in keys from " + userId + ":" + _deviceId);
	            continue;
	        }
	
	        if (_storeDeviceKeys(_olmDevice, userStore, deviceResult)) {
	            updated = true;
	        }
	    }
	
	    return updated;
	}
	
	/*
	 * Process a device in a /query response, and add it to the userStore
	 *
	 * returns true if a change was made, else false
	 */
	function _storeDeviceKeys(_olmDevice, userStore, deviceResult) {
	    if (!deviceResult.keys) {
	        // no keys?
	        return false;
	    }
	
	    var deviceId = deviceResult.device_id;
	    var userId = deviceResult.user_id;
	
	    var signKeyId = "ed25519:" + deviceId;
	    var signKey = deviceResult.keys[signKeyId];
	    if (!signKey) {
	        console.warn("Device " + userId + ":" + deviceId + " has no ed25519 key");
	        return false;
	    }
	
	    var unsigned = deviceResult.unsigned || {};
	
	    try {
	        _olmlib2.default.verifySignature(_olmDevice, deviceResult, userId, deviceId, signKey);
	    } catch (e) {
	        console.warn("Unable to verify signature on device " + userId + ":" + deviceId + ":" + e);
	        return false;
	    }
	
	    // DeviceInfo
	    var deviceStore = void 0;
	
	    if (deviceId in userStore) {
	        // already have this device.
	        deviceStore = userStore[deviceId];
	
	        if (deviceStore.getFingerprint() != signKey) {
	            // this should only happen if the list has been MITMed; we are
	            // best off sticking with the original keys.
	            //
	            // Should we warn the user about it somehow?
	            console.warn("Ed25519 key for device " + userId + ":" + deviceId + " has changed");
	            return false;
	        }
	    } else {
	        userStore[deviceId] = deviceStore = new _deviceinfo2.default(deviceId);
	    }
	
	    deviceStore.keys = deviceResult.keys || {};
	    deviceStore.algorithms = deviceResult.algorithms || [];
	    deviceStore.unsigned = unsigned;
	    return true;
	}


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * olm.js wrapper
	 *
	 * @module crypto/OlmDevice
	 */
	
	var Olm = __webpack_require__(1538);
	if (!Olm) {
	    // this happens if we were loaded via browserify and the Olm module was not
	    // loaded.
	    throw new Error("Olm is not defined");
	}
	var utils = __webpack_require__(16);
	
	// The maximum size of an event is 65K, and we base64 the content, so this is a
	// reasonable approximation to the biggest plaintext we can encrypt.
	var MAX_PLAINTEXT_LENGTH = 65536 * 3 / 4;
	
	function checkPayloadLength(payloadString) {
	    if (payloadString === undefined) {
	        throw new Error("payloadString undefined");
	    }
	
	    if (payloadString.length > MAX_PLAINTEXT_LENGTH) {
	        // might as well fail early here rather than letting the olm library throw
	        // a cryptic memory allocation error.
	        //
	        // Note that even if we manage to do the encryption, the message send may fail,
	        // because by the time we've wrapped the ciphertext in the event object, it may
	        // exceed 65K. But at least we won't just fail with "abort()" in that case.
	        throw new Error("Message too long (" + payloadString.length + " bytes). " + "The maximum for an encrypted message is " + MAX_PLAINTEXT_LENGTH + " bytes.");
	    }
	}
	
	/**
	 * The type of object we use for importing and exporting megolm session data.
	 *
	 * @typedef {Object} module:crypto/OlmDevice.MegolmSessionData
	 * @property {String} sender_key  Sender's Curve25519 device key
	 * @property {Object<string, string>} sender_claimed_keys Other keys the sender claims.
	 * @property {String} room_id     Room this session is used in
	 * @property {String} session_id  Unique id for the session
	 * @property {String} session_key Base64'ed key data
	 */
	
	/**
	 * Manages the olm cryptography functions. Each OlmDevice has a single
	 * OlmAccount and a number of OlmSessions.
	 *
	 * Accounts and sessions are kept pickled in a sessionStore.
	 *
	 * @constructor
	 * @alias module:crypto/OlmDevice
	 *
	 * @param {Object} sessionStore A store to be used for data in end-to-end
	 *    crypto
	 *
	 * @property {string} deviceCurve25519Key   Curve25519 key for the account
	 * @property {string} deviceEd25519Key      Ed25519 key for the account
	 */
	function OlmDevice(sessionStore) {
	    this._sessionStore = sessionStore;
	    this._pickleKey = "DEFAULT_KEY";
	
	    var e2eKeys = void 0;
	    var account = new Olm.Account();
	    try {
	        _initialise_account(this._sessionStore, this._pickleKey, account);
	        e2eKeys = JSON.parse(account.identity_keys());
	    } finally {
	        account.free();
	    }
	
	    this.deviceCurve25519Key = e2eKeys.curve25519;
	    this.deviceEd25519Key = e2eKeys.ed25519;
	
	    // we don't bother stashing outboundgroupsessions in the sessionstore -
	    // instead we keep them here.
	    this._outboundGroupSessionStore = {};
	
	    // Store a set of decrypted message indexes for each group session.
	    // This partially mitigates a replay attack where a MITM resends a group
	    // message into the room.
	    //
	    // TODO: If we ever remove an event from memory we will also need to remove
	    // it from this map. Otherwise if we download the event from the server we
	    // will think that it is a duplicate.
	    //
	    // Keys are strings of form "<senderKey>|<session_id>|<message_index>"
	    // Values are true.
	    this._inboundGroupSessionMessageIndexes = {};
	}
	
	function _initialise_account(sessionStore, pickleKey, account) {
	    var e2eAccount = sessionStore.getEndToEndAccount();
	    if (e2eAccount !== null) {
	        account.unpickle(pickleKey, e2eAccount);
	        return;
	    }
	
	    account.create();
	    var pickled = account.pickle(pickleKey);
	    sessionStore.storeEndToEndAccount(pickled);
	}
	
	/**
	 * @return {array} The version of Olm.
	 */
	OlmDevice.getOlmVersion = function () {
	    return Olm.get_library_version();
	};
	
	/**
	 * extract our OlmAccount from the session store and call the given function
	 *
	 * @param {function} func
	 * @return {object} result of func
	 * @private
	 */
	OlmDevice.prototype._getAccount = function (func) {
	    var account = new Olm.Account();
	    try {
	        var pickledAccount = this._sessionStore.getEndToEndAccount();
	        account.unpickle(this._pickleKey, pickledAccount);
	        return func(account);
	    } finally {
	        account.free();
	    }
	};
	
	/**
	 * store our OlmAccount in the session store
	 *
	 * @param {OlmAccount} account
	 * @private
	 */
	OlmDevice.prototype._saveAccount = function (account) {
	    var pickledAccount = account.pickle(this._pickleKey);
	    this._sessionStore.storeEndToEndAccount(pickledAccount);
	};
	
	/**
	 * extract an OlmSession from the session store and call the given function
	 *
	 * @param {string} deviceKey
	 * @param {string} sessionId
	 * @param {function} func
	 * @return {object} result of func
	 * @private
	 */
	OlmDevice.prototype._getSession = function (deviceKey, sessionId, func) {
	    var sessions = this._sessionStore.getEndToEndSessions(deviceKey);
	    var pickledSession = sessions[sessionId];
	
	    var session = new Olm.Session();
	    try {
	        session.unpickle(this._pickleKey, pickledSession);
	        return func(session);
	    } finally {
	        session.free();
	    }
	};
	
	/**
	 * store our OlmSession in the session store
	 *
	 * @param {string} deviceKey
	 * @param {OlmSession} session
	 * @private
	 */
	OlmDevice.prototype._saveSession = function (deviceKey, session) {
	    var pickledSession = session.pickle(this._pickleKey);
	    this._sessionStore.storeEndToEndSession(deviceKey, session.session_id(), pickledSession);
	};
	
	/**
	 * get an OlmUtility and call the given function
	 *
	 * @param {function} func
	 * @return {object} result of func
	 * @private
	 */
	OlmDevice.prototype._getUtility = function (func) {
	    var utility = new Olm.Utility();
	    try {
	        return func(utility);
	    } finally {
	        utility.free();
	    }
	};
	
	/**
	 * Signs a message with the ed25519 key for this account.
	 *
	 * @param {string} message  message to be signed
	 * @return {string} base64-encoded signature
	 */
	OlmDevice.prototype.sign = function (message) {
	    return this._getAccount(function (account) {
	        return account.sign(message);
	    });
	};
	
	/**
	 * Get the current (unused, unpublished) one-time keys for this account.
	 *
	 * @return {object} one time keys; an object with the single property
	 * <tt>curve25519</tt>, which is itself an object mapping key id to Curve25519
	 * key.
	 */
	OlmDevice.prototype.getOneTimeKeys = function () {
	    return this._getAccount(function (account) {
	        return JSON.parse(account.one_time_keys());
	    });
	};
	
	/**
	 * Get the maximum number of one-time keys we can store.
	 *
	 * @return {number} number of keys
	 */
	OlmDevice.prototype.maxNumberOfOneTimeKeys = function () {
	    return this._getAccount(function (account) {
	        return account.max_number_of_one_time_keys();
	    });
	};
	
	/**
	 * Marks all of the one-time keys as published.
	 */
	OlmDevice.prototype.markKeysAsPublished = function () {
	    var self = this;
	    this._getAccount(function (account) {
	        account.mark_keys_as_published();
	        self._saveAccount(account);
	    });
	};
	
	/**
	 * Generate some new one-time keys
	 *
	 * @param {number} numKeys number of keys to generate
	 */
	OlmDevice.prototype.generateOneTimeKeys = function (numKeys) {
	    var self = this;
	    this._getAccount(function (account) {
	        account.generate_one_time_keys(numKeys);
	        self._saveAccount(account);
	    });
	};
	
	/**
	 * Generate a new outbound session
	 *
	 * The new session will be stored in the sessionStore.
	 *
	 * @param {string} theirIdentityKey remote user's Curve25519 identity key
	 * @param {string} theirOneTimeKey  remote user's one-time Curve25519 key
	 * @return {string} sessionId for the outbound session.
	 */
	OlmDevice.prototype.createOutboundSession = function (theirIdentityKey, theirOneTimeKey) {
	    var self = this;
	    return this._getAccount(function (account) {
	        var session = new Olm.Session();
	        try {
	            session.create_outbound(account, theirIdentityKey, theirOneTimeKey);
	            self._saveSession(theirIdentityKey, session);
	            return session.session_id();
	        } finally {
	            session.free();
	        }
	    });
	};
	
	/**
	 * Generate a new inbound session, given an incoming message
	 *
	 * @param {string} theirDeviceIdentityKey remote user's Curve25519 identity key
	 * @param {number} message_type  message_type field from the received message (must be 0)
	 * @param {string} ciphertext base64-encoded body from the received message
	 *
	 * @return {{payload: string, session_id: string}} decrypted payload, and
	 *     session id of new session
	 *
	 * @raises {Error} if the received message was not valid (for instance, it
	 *     didn't use a valid one-time key).
	 */
	OlmDevice.prototype.createInboundSession = function (theirDeviceIdentityKey, message_type, ciphertext) {
	    if (message_type !== 0) {
	        throw new Error("Need message_type == 0 to create inbound session");
	    }
	
	    var self = this;
	    return this._getAccount(function (account) {
	        var session = new Olm.Session();
	        try {
	            session.create_inbound_from(account, theirDeviceIdentityKey, ciphertext);
	            account.remove_one_time_keys(session);
	            self._saveAccount(account);
	
	            var payloadString = session.decrypt(message_type, ciphertext);
	
	            self._saveSession(theirDeviceIdentityKey, session);
	
	            return {
	                payload: payloadString,
	                session_id: session.session_id()
	            };
	        } finally {
	            session.free();
	        }
	    });
	};
	
	/**
	 * Get a list of known session IDs for the given device
	 *
	 * @param {string} theirDeviceIdentityKey Curve25519 identity key for the
	 *     remote device
	 * @return {string[]}  a list of known session ids for the device
	 */
	OlmDevice.prototype.getSessionIdsForDevice = function (theirDeviceIdentityKey) {
	    var sessions = this._sessionStore.getEndToEndSessions(theirDeviceIdentityKey);
	    return utils.keys(sessions);
	};
	
	/**
	 * Get the right olm session id for encrypting messages to the given identity key
	 *
	 * @param {string} theirDeviceIdentityKey Curve25519 identity key for the
	 *     remote device
	 * @return {string?}  session id, or null if no established session
	 */
	OlmDevice.prototype.getSessionIdForDevice = function (theirDeviceIdentityKey) {
	    var sessionIds = this.getSessionIdsForDevice(theirDeviceIdentityKey);
	    if (sessionIds.length === 0) {
	        return null;
	    }
	    // Use the session with the lowest ID.
	    sessionIds.sort();
	    return sessionIds[0];
	};
	
	/**
	 * Get information on the active Olm sessions for a device.
	 * <p>
	 * Returns an array, with an entry for each active session. The first entry in
	 * the result will be the one used for outgoing messages. Each entry contains
	 * the keys 'hasReceivedMessage' (true if the session has received an incoming
	 * message and is therefore past the pre-key stage), and 'sessionId'.
	 *
	 * @param {string} deviceIdentityKey Curve25519 identity key for the device
	 * @return {Array.<{sessionId: string, hasReceivedMessage: Boolean}>}
	 */
	OlmDevice.prototype.getSessionInfoForDevice = function (deviceIdentityKey) {
	    var sessionIds = this.getSessionIdsForDevice(deviceIdentityKey);
	    sessionIds.sort();
	
	    var info = [];
	
	    function getSessionInfo(session) {
	        return {
	            hasReceivedMessage: session.has_received_message()
	        };
	    }
	
	    for (var i = 0; i < sessionIds.length; i++) {
	        var sessionId = sessionIds[i];
	        var res = this._getSession(deviceIdentityKey, sessionId, getSessionInfo);
	        res.sessionId = sessionId;
	        info.push(res);
	    }
	    return info;
	};
	
	/**
	 * Encrypt an outgoing message using an existing session
	 *
	 * @param {string} theirDeviceIdentityKey Curve25519 identity key for the
	 *     remote device
	 * @param {string} sessionId  the id of the active session
	 * @param {string} payloadString  payload to be encrypted and sent
	 *
	 * @return {string} ciphertext
	 */
	OlmDevice.prototype.encryptMessage = function (theirDeviceIdentityKey, sessionId, payloadString) {
	    var self = this;
	
	    checkPayloadLength(payloadString);
	
	    return this._getSession(theirDeviceIdentityKey, sessionId, function (session) {
	        var res = session.encrypt(payloadString);
	        self._saveSession(theirDeviceIdentityKey, session);
	        return res;
	    });
	};
	
	/**
	 * Decrypt an incoming message using an existing session
	 *
	 * @param {string} theirDeviceIdentityKey Curve25519 identity key for the
	 *     remote device
	 * @param {string} sessionId  the id of the active session
	 * @param {number} message_type  message_type field from the received message
	 * @param {string} ciphertext base64-encoded body from the received message
	 *
	 * @return {string} decrypted payload.
	 */
	OlmDevice.prototype.decryptMessage = function (theirDeviceIdentityKey, sessionId, message_type, ciphertext) {
	    var self = this;
	
	    return this._getSession(theirDeviceIdentityKey, sessionId, function (session) {
	        var payloadString = session.decrypt(message_type, ciphertext);
	        self._saveSession(theirDeviceIdentityKey, session);
	
	        return payloadString;
	    });
	};
	
	/**
	 * Determine if an incoming messages is a prekey message matching an existing session
	 *
	 * @param {string} theirDeviceIdentityKey Curve25519 identity key for the
	 *     remote device
	 * @param {string} sessionId  the id of the active session
	 * @param {number} message_type  message_type field from the received message
	 * @param {string} ciphertext base64-encoded body from the received message
	 *
	 * @return {boolean} true if the received message is a prekey message which matches
	 *    the given session.
	 */
	OlmDevice.prototype.matchesSession = function (theirDeviceIdentityKey, sessionId, message_type, ciphertext) {
	    if (message_type !== 0) {
	        return false;
	    }
	
	    return this._getSession(theirDeviceIdentityKey, sessionId, function (session) {
	        return session.matches_inbound(ciphertext);
	    });
	};
	
	// Outbound group session
	// ======================
	
	/**
	 * store an OutboundGroupSession in _outboundGroupSessionStore
	 *
	 * @param {Olm.OutboundGroupSession} session
	 * @private
	 */
	OlmDevice.prototype._saveOutboundGroupSession = function (session) {
	    var pickledSession = session.pickle(this._pickleKey);
	    this._outboundGroupSessionStore[session.session_id()] = pickledSession;
	};
	
	/**
	 * extract an OutboundGroupSession from _outboundGroupSessionStore and call the
	 * given function
	 *
	 * @param {string} sessionId
	 * @param {function} func
	 * @return {object} result of func
	 * @private
	 */
	OlmDevice.prototype._getOutboundGroupSession = function (sessionId, func) {
	    var pickled = this._outboundGroupSessionStore[sessionId];
	    if (pickled === null) {
	        throw new Error("Unknown outbound group session " + sessionId);
	    }
	
	    var session = new Olm.OutboundGroupSession();
	    try {
	        session.unpickle(this._pickleKey, pickled);
	        return func(session);
	    } finally {
	        session.free();
	    }
	};
	
	/**
	 * Generate a new outbound group session
	 *
	 * @return {string} sessionId for the outbound session.
	 */
	OlmDevice.prototype.createOutboundGroupSession = function () {
	    var session = new Olm.OutboundGroupSession();
	    try {
	        session.create();
	        this._saveOutboundGroupSession(session);
	        return session.session_id();
	    } finally {
	        session.free();
	    }
	};
	
	/**
	 * Encrypt an outgoing message with an outbound group session
	 *
	 * @param {string} sessionId  the id of the outboundgroupsession
	 * @param {string} payloadString  payload to be encrypted and sent
	 *
	 * @return {string} ciphertext
	 */
	OlmDevice.prototype.encryptGroupMessage = function (sessionId, payloadString) {
	    var self = this;
	
	    checkPayloadLength(payloadString);
	
	    return this._getOutboundGroupSession(sessionId, function (session) {
	        var res = session.encrypt(payloadString);
	        self._saveOutboundGroupSession(session);
	        return res;
	    });
	};
	
	/**
	 * Get the session keys for an outbound group session
	 *
	 * @param {string} sessionId  the id of the outbound group session
	 *
	 * @return {{chain_index: number, key: string}} current chain index, and
	 *     base64-encoded secret key.
	 */
	OlmDevice.prototype.getOutboundGroupSessionKey = function (sessionId) {
	    return this._getOutboundGroupSession(sessionId, function (session) {
	        return {
	            chain_index: session.message_index(),
	            key: session.session_key()
	        };
	    });
	};
	
	// Inbound group session
	// =====================
	
	/**
	 * store an InboundGroupSession in the session store
	 *
	 * @param {string} roomId
	 * @param {string} senderCurve25519Key
	 * @param {string} sessionId
	 * @param {Olm.InboundGroupSession} session
	 * @param {object} keysClaimed Other keys the sender claims.
	 * @private
	 */
	OlmDevice.prototype._saveInboundGroupSession = function (roomId, senderCurve25519Key, sessionId, session, keysClaimed) {
	    var r = {
	        room_id: roomId,
	        session: session.pickle(this._pickleKey),
	        keysClaimed: keysClaimed
	    };
	
	    this._sessionStore.storeEndToEndInboundGroupSession(senderCurve25519Key, sessionId, JSON.stringify(r));
	};
	
	/**
	 * extract an InboundGroupSession from the session store and call the given function
	 *
	 * @param {string} roomId
	 * @param {string} senderKey
	 * @param {string} sessionId
	 * @param {function(Olm.InboundGroupSession, Object<string, string>): T} func
	 *   function to call. Second argument is the map of keys claimed by the session.
	 *
	 * @return {null} the sessionId is unknown
	 *
	 * @return {T} result of func
	 *
	 * @private
	 * @template {T}
	 */
	OlmDevice.prototype._getInboundGroupSession = function (roomId, senderKey, sessionId, func) {
	    var r = this._sessionStore.getEndToEndInboundGroupSession(senderKey, sessionId);
	
	    if (r === null) {
	        return null;
	    }
	
	    r = JSON.parse(r);
	
	    // check that the room id matches the original one for the session. This stops
	    // the HS pretending a message was targeting a different room.
	    if (roomId !== r.room_id) {
	        throw new Error("Mismatched room_id for inbound group session (expected " + r.room_id + ", was " + roomId + ")");
	    }
	
	    var session = new Olm.InboundGroupSession();
	    try {
	        session.unpickle(this._pickleKey, r.session);
	        return func(session, r.keysClaimed || {});
	    } finally {
	        session.free();
	    }
	};
	
	/**
	 * Add an inbound group session to the session store
	 *
	 * @param {string} roomId     room in which this session will be used
	 * @param {string} senderKey  base64-encoded curve25519 key of the sender
	 * @param {string} sessionId  session identifier
	 * @param {string} sessionKey base64-encoded secret key
	 * @param {Object<string, string>} keysClaimed Other keys the sender claims.
	 */
	OlmDevice.prototype.addInboundGroupSession = function (roomId, senderKey, sessionId, sessionKey, keysClaimed) {
	    var self = this;
	
	    /* if we already have this session, consider updating it */
	    function updateSession(session) {
	        console.log("Update for megolm session " + senderKey + "/" + sessionId);
	        // for now we just ignore updates. TODO: implement something here
	
	        return true;
	    }
	
	    var r = this._getInboundGroupSession(roomId, senderKey, sessionId, updateSession);
	
	    if (r !== null) {
	        return;
	    }
	
	    // new session.
	    var session = new Olm.InboundGroupSession();
	    try {
	        session.create(sessionKey);
	        if (sessionId != session.session_id()) {
	            throw new Error("Mismatched group session ID from senderKey: " + senderKey);
	        }
	        self._saveInboundGroupSession(roomId, senderKey, sessionId, session, keysClaimed);
	    } finally {
	        session.free();
	    }
	};
	
	/**
	 * Add a previously-exported inbound group session to the session store
	 *
	 * @param {module:crypto/OlmDevice.MegolmSessionData} data  session data
	 */
	OlmDevice.prototype.importInboundGroupSession = function (data) {
	    /* if we already have this session, consider updating it */
	    function updateSession(session) {
	        console.log("Update for megolm session " + data.sender_key + "|" + data.session_id);
	        // for now we just ignore updates. TODO: implement something here
	
	        return true;
	    }
	
	    var r = this._getInboundGroupSession(data.room_id, data.sender_key, data.session_id, updateSession);
	
	    if (r !== null) {
	        return;
	    }
	
	    // new session.
	    var session = new Olm.InboundGroupSession();
	    try {
	        session.import_session(data.session_key);
	        if (data.session_id != session.session_id()) {
	            throw new Error("Mismatched group session ID from senderKey: " + data.sender_key);
	        }
	        this._saveInboundGroupSession(data.room_id, data.sender_key, data.session_id, session, data.sender_claimed_keys);
	    } finally {
	        session.free();
	    }
	};
	
	/**
	 * Decrypt a received message with an inbound group session
	 *
	 * @param {string} roomId    room in which the message was received
	 * @param {string} senderKey base64-encoded curve25519 key of the sender
	 * @param {string} sessionId session identifier
	 * @param {string} body      base64-encoded body of the encrypted message
	 *
	 * @return {null} the sessionId is unknown
	 *
	 * @return {{result: string, keysProved: Object<string, string>, keysClaimed:
	 *    Object<string, string>}} result
	 */
	OlmDevice.prototype.decryptGroupMessage = function (roomId, senderKey, sessionId, body) {
	    var self = this;
	
	    function decrypt(session, keysClaimed) {
	        var res = session.decrypt(body);
	
	        var plaintext = res.plaintext;
	        if (plaintext === undefined) {
	            // Compatibility for older olm versions.
	            plaintext = res;
	        } else {
	            // Check if we have seen this message index before to detect replay attacks.
	            var messageIndexKey = senderKey + "|" + sessionId + "|" + res.message_index;
	            if (messageIndexKey in self._inboundGroupSessionMessageIndexes) {
	                throw new Error("Duplicate message index, possible replay attack: " + messageIndexKey);
	            }
	            self._inboundGroupSessionMessageIndexes[messageIndexKey] = true;
	        }
	
	        // the sender must have had the senderKey to persuade us to save the
	        // session.
	        var keysProved = { curve25519: senderKey };
	
	        self._saveInboundGroupSession(roomId, senderKey, sessionId, session, keysClaimed);
	        return {
	            result: plaintext,
	            keysClaimed: keysClaimed,
	            keysProved: keysProved
	        };
	    }
	
	    return this._getInboundGroupSession(roomId, senderKey, sessionId, decrypt);
	};
	
	/**
	 * Export an inbound group session
	 *
	 * @param {string} senderKey base64-encoded curve25519 key of the sender
	 * @param {string} sessionId session identifier
	 * @return {module:crypto/OlmDevice.MegolmSessionData} exported session data
	 */
	OlmDevice.prototype.exportInboundGroupSession = function (senderKey, sessionId) {
	    var s = this._sessionStore.getEndToEndInboundGroupSession(senderKey, sessionId);
	
	    if (s === null) {
	        throw new Error("Unknown inbound group session [" + senderKey + "," + sessionId + "]");
	    }
	    var r = JSON.parse(s);
	
	    var session = new Olm.InboundGroupSession();
	    try {
	        session.unpickle(this._pickleKey, r.session);
	
	        var messageIndex = session.first_known_index();
	
	        return {
	            "sender_key": senderKey,
	            "sender_claimed_keys": r.keysClaimed,
	            "room_id": r.room_id,
	            "session_id": sessionId,
	            "session_key": session.export_session(messageIndex)
	        };
	    } finally {
	        session.free();
	    }
	};
	
	// Utilities
	// =========
	
	/**
	 * Verify an ed25519 signature.
	 *
	 * @param {string} key ed25519 key
	 * @param {string} message message which was signed
	 * @param {string} signature base64-encoded signature to be checked
	 *
	 * @raises {Error} if there is a problem with the verification. If the key was
	 * too small then the message will be "OLM.INVALID_BASE64". If the signature
	 * was invalid then the message will be "OLM.BAD_MESSAGE_MAC".
	 */
	OlmDevice.prototype.verifySignature = function (key, message, signature) {
	    this._getUtility(function (util) {
	        util.ed25519_verify(key, message, signature);
	    });
	};
	
	/** */
	module.exports = OlmDevice;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module crypto/algorithms
	 */
	
	var base = __webpack_require__(321);
	
	__webpack_require__(1138);
	__webpack_require__(1137);
	
	/**
	 * @see module:crypto/algorithms/base.ENCRYPTION_CLASSES
	 */
	module.exports.ENCRYPTION_CLASSES = base.ENCRYPTION_CLASSES;
	
	/**
	 * @see module:crypto/algorithms/base.DECRYPTION_CLASSES
	 */
	module.exports.DECRYPTION_CLASSES = base.DECRYPTION_CLASSES;
	
	/**
	 * @see module:crypto/algorithms/base.DecryptionError
	 */
	module.exports.DecryptionError = base.DecryptionError;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * Defines m.olm encryption/decryption
	 *
	 * @module crypto/algorithms/megolm
	 */
	
	var q = __webpack_require__(6);
	
	var utils = __webpack_require__(16);
	var olmlib = __webpack_require__(215);
	var base = __webpack_require__(321);
	
	/**
	 * @private
	 * @constructor
	 *
	 * @param {string} sessionId
	 *
	 * @property {string} sessionId
	 * @property {Number} useCount     number of times this session has been used
	 * @property {Number} creationTime when the session was created (ms since the epoch)
	 *
	 * @property {object} sharedWithDevices
	 *    devices with which we have shared the session key
	 *        userId -> {deviceId -> msgindex}
	 */
	function OutboundSessionInfo(sessionId) {
	    this.sessionId = sessionId;
	    this.useCount = 0;
	    this.creationTime = new Date().getTime();
	    this.sharedWithDevices = {};
	}
	
	/**
	 * Check if it's time to rotate the session
	 *
	 * @param {Number} rotationPeriodMsgs
	 * @param {Number} rotationPeriodMs
	 * @return {Boolean}
	 */
	OutboundSessionInfo.prototype.needsRotation = function (rotationPeriodMsgs, rotationPeriodMs) {
	    var sessionLifetime = new Date().getTime() - this.creationTime;
	
	    if (this.useCount >= rotationPeriodMsgs || sessionLifetime >= rotationPeriodMs) {
	        console.log("Rotating megolm session after " + this.useCount + " messages, " + sessionLifetime + "ms");
	        return true;
	    }
	
	    return false;
	};
	
	/**
	 * Determine if this session has been shared with devices which it shouldn't
	 * have been.
	 *
	 * @param {Object} devicesInRoom userId -> {deviceId -> object}
	 *   devices we should shared the session with.
	 *
	 * @return {Boolean} true if we have shared the session with devices which aren't
	 * in devicesInRoom.
	 */
	OutboundSessionInfo.prototype.sharedWithTooManyDevices = function (devicesInRoom) {
	    for (var userId in this.sharedWithDevices) {
	        if (!this.sharedWithDevices.hasOwnProperty(userId)) {
	            continue;
	        }
	
	        if (!devicesInRoom.hasOwnProperty(userId)) {
	            console.log("Starting new session because we shared with " + userId);
	            return true;
	        }
	
	        for (var deviceId in this.sharedWithDevices[userId]) {
	            if (!this.sharedWithDevices[userId].hasOwnProperty(deviceId)) {
	                continue;
	            }
	
	            if (!devicesInRoom[userId].hasOwnProperty(deviceId)) {
	                console.log("Starting new session because we shared with " + userId + ":" + deviceId);
	                return true;
	            }
	        }
	    }
	};
	
	/**
	 * Megolm encryption implementation
	 *
	 * @constructor
	 * @extends {module:crypto/algorithms/base.EncryptionAlgorithm}
	 *
	 * @param {object} params parameters, as per
	 *     {@link module:crypto/algorithms/base.EncryptionAlgorithm}
	 */
	function MegolmEncryption(params) {
	    base.EncryptionAlgorithm.call(this, params);
	
	    // the most recent attempt to set up a session. This is used to serialise
	    // the session setups, so that we have a race-free view of which session we
	    // are using, and which devices we have shared the keys with. It resolves
	    // with an OutboundSessionInfo (or undefined, for the first message in the
	    // room).
	    this._setupPromise = q();
	
	    // default rotation periods
	    this._sessionRotationPeriodMsgs = 100;
	    this._sessionRotationPeriodMs = 7 * 24 * 3600 * 1000;
	
	    if (params.config.rotation_period_ms !== undefined) {
	        this._sessionRotationPeriodMs = params.config.rotation_period_ms;
	    }
	
	    if (params.config.rotation_period_msgs !== undefined) {
	        this._sessionRotationPeriodMsgs = params.config.rotation_period_msgs;
	    }
	}
	utils.inherits(MegolmEncryption, base.EncryptionAlgorithm);
	
	/**
	 * @private
	 *
	 * @param {Object} devicesInRoom The devices in this room, indexed by user ID
	 *
	 * @return {module:client.Promise} Promise which resolves to the
	 *    OutboundSessionInfo when setup is complete.
	 */
	MegolmEncryption.prototype._ensureOutboundSession = function (devicesInRoom) {
	    var self = this;
	
	    var session = void 0;
	
	    // takes the previous OutboundSessionInfo, and considers whether to create
	    // a new one. Also shares the key with any (new) devices in the room.
	    // Updates `session` to hold the final OutboundSessionInfo.
	    //
	    // returns a promise which resolves once the keyshare is successful.
	    function prepareSession(oldSession) {
	        session = oldSession;
	
	        // need to make a brand new session?
	        if (session && session.needsRotation(self._sessionRotationPeriodMsgs, self._sessionRotationPeriodMs)) {
	            console.log("Starting new megolm session because we need to rotate.");
	            session = null;
	        }
	
	        // determine if we have shared with anyone we shouldn't have
	        if (session && session.sharedWithTooManyDevices(devicesInRoom)) {
	            session = null;
	        }
	
	        if (!session) {
	            session = self._prepareNewSession();
	        }
	
	        // now check if we need to share with any devices
	        var shareMap = {};
	
	        for (var userId in devicesInRoom) {
	            if (!devicesInRoom.hasOwnProperty(userId)) {
	                continue;
	            }
	
	            var userDevices = devicesInRoom[userId];
	
	            for (var deviceId in userDevices) {
	                if (!userDevices.hasOwnProperty(deviceId)) {
	                    continue;
	                }
	
	                var deviceInfo = userDevices[deviceId];
	
	                var key = deviceInfo.getIdentityKey();
	                if (key == self._olmDevice.deviceCurve25519Key) {
	                    // don't bother sending to ourself
	                    continue;
	                }
	
	                if (!session.sharedWithDevices[userId] || session.sharedWithDevices[userId][deviceId] === undefined) {
	                    shareMap[userId] = shareMap[userId] || [];
	                    shareMap[userId].push(deviceInfo);
	                }
	            }
	        }
	
	        return self._shareKeyWithDevices(session, shareMap);
	    }
	
	    // helper which returns the session prepared by prepareSession
	    function returnSession() {
	        return session;
	    }
	
	    // first wait for the previous share to complete
	    var prom = this._setupPromise.then(prepareSession);
	
	    // _setupPromise resolves to `session` whether or not the share succeeds
	    this._setupPromise = prom.then(returnSession, returnSession);
	
	    // but we return a promise which only resolves if the share was successful.
	    return prom.then(returnSession);
	};
	
	/**
	 * @private
	 *
	 * @return {module:crypto/algorithms/megolm.OutboundSessionInfo} session
	 */
	MegolmEncryption.prototype._prepareNewSession = function () {
	    var session_id = this._olmDevice.createOutboundGroupSession();
	    var key = this._olmDevice.getOutboundGroupSessionKey(session_id);
	
	    this._olmDevice.addInboundGroupSession(this._roomId, this._olmDevice.deviceCurve25519Key, session_id, key.key, { ed25519: this._olmDevice.deviceEd25519Key });
	
	    return new OutboundSessionInfo(session_id);
	};
	
	/**
	 * @private
	 *
	 * @param {module:crypto/algorithms/megolm.OutboundSessionInfo} session
	 *
	 * @param {object<string, module:crypto/deviceinfo[]>} devicesByUser
	 *    map from userid to list of devices
	 *
	 * @return {module:client.Promise} Promise which resolves once the key sharing
	 *     message has been sent.
	 */
	MegolmEncryption.prototype._shareKeyWithDevices = function (session, devicesByUser) {
	    var self = this;
	
	    var key = this._olmDevice.getOutboundGroupSessionKey(session.sessionId);
	    var payload = {
	        type: "m.room_key",
	        content: {
	            algorithm: olmlib.MEGOLM_ALGORITHM,
	            room_id: this._roomId,
	            session_id: session.sessionId,
	            session_key: key.key,
	            chain_index: key.chain_index
	        }
	    };
	
	    var contentMap = {};
	
	    return olmlib.ensureOlmSessionsForDevices(this._olmDevice, this._baseApis, devicesByUser).then(function (devicemap) {
	        var haveTargets = false;
	
	        for (var userId in devicesByUser) {
	            if (!devicesByUser.hasOwnProperty(userId)) {
	                continue;
	            }
	
	            var devicesToShareWith = devicesByUser[userId];
	            var sessionResults = devicemap[userId];
	
	            for (var i = 0; i < devicesToShareWith.length; i++) {
	                var deviceInfo = devicesToShareWith[i];
	                var deviceId = deviceInfo.deviceId;
	
	                var sessionResult = sessionResults[deviceId];
	                if (!sessionResult.sessionId) {
	                    // no session with this device, probably because there
	                    // were no one-time keys.
	                    //
	                    // we could send them a to_device message anyway, as a
	                    // signal that they have missed out on the key sharing
	                    // message because of the lack of keys, but there's not
	                    // much point in that really; it will mostly serve to clog
	                    // up to_device inboxes.
	                    //
	                    // ensureOlmSessionsForUsers has already done the logging,
	                    // so just skip it.
	                    continue;
	                }
	
	                console.log("sharing keys with device " + userId + ":" + deviceId);
	
	                var encryptedContent = {
	                    algorithm: olmlib.OLM_ALGORITHM,
	                    sender_key: self._olmDevice.deviceCurve25519Key,
	                    ciphertext: {}
	                };
	
	                olmlib.encryptMessageForDevice(encryptedContent.ciphertext, self._userId, self._deviceId, self._olmDevice, userId, deviceInfo, payload);
	
	                if (!contentMap[userId]) {
	                    contentMap[userId] = {};
	                }
	
	                contentMap[userId][deviceId] = encryptedContent;
	                haveTargets = true;
	            }
	        }
	
	        if (!haveTargets) {
	            return q();
	        }
	
	        // TODO: retries
	        return self._baseApis.sendToDevice("m.room.encrypted", contentMap);
	    }).then(function () {
	        // Add the devices we have shared with to session.sharedWithDevices.
	        //
	        // we deliberately iterate over devicesByUser (ie, the devices we
	        // attempted to share with) rather than the contentMap (those we did
	        // share with), because we don't want to try to claim a one-time-key
	        // for dead devices on every message.
	        for (var userId in devicesByUser) {
	            if (!devicesByUser.hasOwnProperty(userId)) {
	                continue;
	            }
	            if (!session.sharedWithDevices[userId]) {
	                session.sharedWithDevices[userId] = {};
	            }
	            var devicesToShareWith = devicesByUser[userId];
	            for (var i = 0; i < devicesToShareWith.length; i++) {
	                var deviceInfo = devicesToShareWith[i];
	                session.sharedWithDevices[userId][deviceInfo.deviceId] = key.chain_index;
	            }
	        }
	    });
	};
	
	/**
	 * @inheritdoc
	 *
	 * @param {module:models/room} room
	 * @param {string} eventType
	 * @param {object} content plaintext event content
	 *
	 * @return {module:client.Promise} Promise which resolves to the new event body
	 */
	MegolmEncryption.prototype.encryptMessage = function (room, eventType, content) {
	    var self = this;
	    return this._getDevicesInRoom(room).then(function (devicesInRoom) {
	        // check if any of these devices are not yet known to the user.
	        // if so, warn the user so they can verify or ignore.
	        self._checkForUnknownDevices(devicesInRoom);
	
	        return self._ensureOutboundSession(devicesInRoom);
	    }).then(function (session) {
	        var payloadJson = {
	            room_id: self._roomId,
	            type: eventType,
	            content: content
	        };
	
	        var ciphertext = self._olmDevice.encryptGroupMessage(session.sessionId, JSON.stringify(payloadJson));
	
	        var encryptedContent = {
	            algorithm: olmlib.MEGOLM_ALGORITHM,
	            sender_key: self._olmDevice.deviceCurve25519Key,
	            ciphertext: ciphertext,
	            session_id: session.sessionId,
	            // Include our device ID so that recipients can send us a
	            // m.new_device message if they don't have our session key.
	            device_id: self._deviceId
	        };
	
	        session.useCount++;
	        return encryptedContent;
	    });
	};
	
	/**
	 * Checks the devices we're about to send to and see if any are entirely
	 * unknown to the user.  If so, warn the user, and mark them as known to
	 * give the user a chance to go verify them before re-sending this message.
	 *
	 * @param {Object} devicesInRoom userId -> {deviceId -> object}
	 *   devices we should shared the session with.
	 */
	MegolmEncryption.prototype._checkForUnknownDevices = function (devicesInRoom) {
	    var unknownDevices = {};
	
	    Object.keys(devicesInRoom).forEach(function (userId) {
	        Object.keys(devicesInRoom[userId]).forEach(function (deviceId) {
	            var device = devicesInRoom[userId][deviceId];
	            if (device.isUnverified() && !device.isKnown()) {
	                if (!unknownDevices[userId]) {
	                    unknownDevices[userId] = {};
	                }
	                unknownDevices[userId][deviceId] = device;
	            }
	        });
	    });
	
	    if (Object.keys(unknownDevices).length) {
	        // it'd be kind to pass unknownDevices up to the user in this error
	        throw new base.UnknownDeviceError("This room contains unknown devices which have not been verified. " + "We strongly recommend you verify them before continuing.", unknownDevices);
	    }
	};
	
	/**
	 * Get the list of unblocked devices for all users in the room
	 *
	 * @param {module:models/room} room
	 *
	 * @return {module:client.Promise} Promise which resolves to a map
	 *     from userId to deviceId to deviceInfo
	 */
	MegolmEncryption.prototype._getDevicesInRoom = function (room) {
	    var _this = this;
	
	    // XXX what about rooms where invitees can see the content?
	    var roomMembers = utils.map(room.getJoinedMembers(), function (u) {
	        return u.userId;
	    });
	
	    // We are happy to use a cached version here: we assume that if we already
	    // have a list of the user's devices, then we already share an e2e room
	    // with them, which means that they will have announced any new devices via
	    // an m.new_device.
	    //
	    // XXX: what if the cache is stale, and the user left the room we had in
	    // common and then added new devices before joining this one? --Matthew
	    //
	    // yup, see https://github.com/vector-im/riot-web/issues/2305 --richvdh
	    return this._crypto.downloadKeys(roomMembers, false).then(function (devices) {
	        // remove any blocked devices
	        for (var userId in devices) {
	            if (!devices.hasOwnProperty(userId)) {
	                continue;
	            }
	
	            var userDevices = devices[userId];
	            for (var deviceId in userDevices) {
	                if (!userDevices.hasOwnProperty(deviceId)) {
	                    continue;
	                }
	
	                if (userDevices[deviceId].isBlocked() || userDevices[deviceId].isUnverified() && (room.getBlacklistUnverifiedDevices() || _this._crypto.getGlobalBlacklistUnverifiedDevices())) {
	                    delete userDevices[deviceId];
	                }
	            }
	        }
	
	        return devices;
	    });
	};
	
	/**
	 * Megolm decryption implementation
	 *
	 * @constructor
	 * @extends {module:crypto/algorithms/base.DecryptionAlgorithm}
	 *
	 * @param {object} params parameters, as per
	 *     {@link module:crypto/algorithms/base.DecryptionAlgorithm}
	 */
	function MegolmDecryption(params) {
	    base.DecryptionAlgorithm.call(this, params);
	
	    // events which we couldn't decrypt due to unknown sessions / indexes: map from
	    // senderKey|sessionId to list of MatrixEvents
	    this._pendingEvents = {};
	}
	utils.inherits(MegolmDecryption, base.DecryptionAlgorithm);
	
	/**
	 * @inheritdoc
	 *
	 * @param {MatrixEvent} event
	 *
	 * @throws {module:crypto/algorithms/base.DecryptionError} if there is a
	 *   problem decrypting the event
	 */
	MegolmDecryption.prototype.decryptEvent = function (event) {
	    var content = event.getWireContent();
	
	    if (!content.sender_key || !content.session_id || !content.ciphertext) {
	        throw new base.DecryptionError("Missing fields in input");
	    }
	
	    var res = void 0;
	    try {
	        res = this._olmDevice.decryptGroupMessage(event.getRoomId(), content.sender_key, content.session_id, content.ciphertext);
	    } catch (e) {
	        if (e.message === 'OLM.UNKNOWN_MESSAGE_INDEX') {
	            this._addEventToPendingList(event);
	        }
	        throw new base.DecryptionError(e.toString(), {
	            session: content.sender_key + '|' + content.session_id
	        });
	    }
	
	    if (res === null) {
	        // We've got a message for a session we don't have.
	        this._addEventToPendingList(event);
	        throw new base.DecryptionError("The sender's device has not sent us the keys for this message.", {
	            session: content.sender_key + '|' + content.session_id
	        });
	    }
	
	    var payload = JSON.parse(res.result);
	
	    // belt-and-braces check that the room id matches that indicated by the HS
	    // (this is somewhat redundant, since the megolm session is scoped to the
	    // room, so neither the sender nor a MITM can lie about the room_id).
	    if (payload.room_id !== event.getRoomId()) {
	        throw new base.DecryptionError("Message intended for room " + payload.room_id);
	    }
	
	    event.setClearData(payload, res.keysProved, res.keysClaimed);
	};
	
	/**
	 * Add an event to the list of those we couldn't decrypt the first time we
	 * saw them.
	 *
	 * @private
	 *
	 * @param {module:models/event.MatrixEvent} event
	 */
	MegolmDecryption.prototype._addEventToPendingList = function (event) {
	    var content = event.getWireContent();
	    var k = content.sender_key + "|" + content.session_id;
	    if (!this._pendingEvents[k]) {
	        this._pendingEvents[k] = [];
	    }
	    this._pendingEvents[k].push(event);
	};
	
	/**
	 * @inheritdoc
	 *
	 * @param {module:models/event.MatrixEvent} event key event
	 */
	MegolmDecryption.prototype.onRoomKeyEvent = function (event) {
	    var content = event.getContent();
	    var senderKey = event.getSenderKey();
	    var sessionId = content.session_id;
	
	    if (!content.room_id || !sessionId || !content.session_key) {
	        console.error("key event is missing fields");
	        return;
	    }
	    if (!senderKey) {
	        console.error("key event has no sender key (not encrypted?)");
	        return;
	    }
	
	    console.log("Adding key for megolm session " + senderKey + "|" + sessionId);
	    this._olmDevice.addInboundGroupSession(content.room_id, senderKey, sessionId, content.session_key, event.getKeysClaimed());
	
	    // have another go at decrypting events sent with this session.
	    this._retryDecryption(senderKey, sessionId);
	};
	
	/**
	 * @inheritdoc
	 *
	 * @param {module:crypto/OlmDevice.MegolmSessionData} session
	 */
	MegolmDecryption.prototype.importRoomKey = function (session) {
	    this._olmDevice.importInboundGroupSession(session);
	
	    // have another go at decrypting events sent with this session.
	    this._retryDecryption(session.sender_key, session.session_id);
	};
	
	/**
	 * Have another go at decrypting events after we receive a key
	 *
	 * @private
	 * @param {String} senderKey
	 * @param {String} sessionId
	 */
	MegolmDecryption.prototype._retryDecryption = function (senderKey, sessionId) {
	    var k = senderKey + "|" + sessionId;
	    var pending = this._pendingEvents[k];
	    if (!pending) {
	        return;
	    }
	
	    delete this._pendingEvents[k];
	
	    for (var i = 0; i < pending.length; i++) {
	        try {
	            this.decryptEvent(pending[i]);
	            console.log("successful re-decryption of", pending[i]);
	        } catch (e) {
	            console.log("Still can't decrypt", pending[i], e.stack || e);
	        }
	    }
	};
	
	base.registerAlgorithm(olmlib.MEGOLM_ALGORITHM, MegolmEncryption, MegolmDecryption);


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * Defines m.olm encryption/decryption
	 *
	 * @module crypto/algorithms/olm
	 */
	
	var q = __webpack_require__(6);
	
	var utils = __webpack_require__(16);
	var olmlib = __webpack_require__(215);
	var DeviceInfo = __webpack_require__(322);
	var DeviceVerification = DeviceInfo.DeviceVerification;
	
	var base = __webpack_require__(321);
	
	/**
	 * Olm encryption implementation
	 *
	 * @constructor
	 * @extends {module:crypto/algorithms/base.EncryptionAlgorithm}
	 *
	 * @param {object} params parameters, as per
	 *     {@link module:crypto/algorithms/base.EncryptionAlgorithm}
	 */
	function OlmEncryption(params) {
	    base.EncryptionAlgorithm.call(this, params);
	    this._sessionPrepared = false;
	    this._prepPromise = null;
	}
	utils.inherits(OlmEncryption, base.EncryptionAlgorithm);
	
	/**
	 * @private
	
	 * @param {string[]} roomMembers list of currently-joined users in the room
	 * @return {module:client.Promise} Promise which resolves when setup is complete
	 */
	OlmEncryption.prototype._ensureSession = function (roomMembers) {
	    if (this._prepPromise) {
	        // prep already in progress
	        return this._prepPromise;
	    }
	
	    if (this._sessionPrepared) {
	        // prep already done
	        return q();
	    }
	
	    var self = this;
	    this._prepPromise = self._crypto.downloadKeys(roomMembers).then(function (res) {
	        return self._crypto.ensureOlmSessionsForUsers(roomMembers);
	    }).then(function () {
	        self._sessionPrepared = true;
	    }).finally(function () {
	        self._prepPromise = null;
	    });
	    return this._prepPromise;
	};
	
	/**
	 * @inheritdoc
	 *
	 * @param {module:models/room} room
	 * @param {string} eventType
	 * @param {object} content plaintext event content
	 *
	 * @return {module:client.Promise} Promise which resolves to the new event body
	 */
	OlmEncryption.prototype.encryptMessage = function (room, eventType, content) {
	    // pick the list of recipients based on the membership list.
	    //
	    // TODO: there is a race condition here! What if a new user turns up
	    // just as you are sending a secret message?
	
	    var users = utils.map(room.getJoinedMembers(), function (u) {
	        return u.userId;
	    });
	
	    var self = this;
	    return this._ensureSession(users).then(function () {
	        var payloadFields = {
	            room_id: room.roomId,
	            type: eventType,
	            content: content
	        };
	
	        var encryptedContent = {
	            algorithm: olmlib.OLM_ALGORITHM,
	            sender_key: self._olmDevice.deviceCurve25519Key,
	            ciphertext: {}
	        };
	
	        for (var i = 0; i < users.length; ++i) {
	            var userId = users[i];
	            var devices = self._crypto.getStoredDevicesForUser(userId);
	
	            for (var j = 0; j < devices.length; ++j) {
	                var deviceInfo = devices[j];
	                var key = deviceInfo.getIdentityKey();
	                if (key == self._olmDevice.deviceCurve25519Key) {
	                    // don't bother sending to ourself
	                    continue;
	                }
	                if (deviceInfo.verified == DeviceVerification.BLOCKED) {
	                    // don't bother setting up sessions with blocked users
	                    continue;
	                }
	
	                olmlib.encryptMessageForDevice(encryptedContent.ciphertext, self._userId, self._deviceId, self._olmDevice, userId, deviceInfo, payloadFields);
	            }
	        }
	
	        return encryptedContent;
	    });
	};
	
	/**
	 * Olm decryption implementation
	 *
	 * @constructor
	 * @extends {module:crypto/algorithms/base.DecryptionAlgorithm}
	 * @param {object} params parameters, as per
	 *     {@link module:crypto/algorithms/base.DecryptionAlgorithm}
	 */
	function OlmDecryption(params) {
	    base.DecryptionAlgorithm.call(this, params);
	}
	utils.inherits(OlmDecryption, base.DecryptionAlgorithm);
	
	/**
	 * @inheritdoc
	 *
	 * @param {MatrixEvent} event
	 *
	 * @throws {module:crypto/algorithms/base.DecryptionError} if there is a
	 *   problem decrypting the event
	 */
	OlmDecryption.prototype.decryptEvent = function (event) {
	    var content = event.getWireContent();
	    var deviceKey = content.sender_key;
	    var ciphertext = content.ciphertext;
	
	    if (!ciphertext) {
	        throw new base.DecryptionError("Missing ciphertext");
	    }
	
	    if (!(this._olmDevice.deviceCurve25519Key in ciphertext)) {
	        throw new base.DecryptionError("Not included in recipients");
	    }
	    var message = ciphertext[this._olmDevice.deviceCurve25519Key];
	    var payloadString = void 0;
	
	    try {
	        payloadString = this._decryptMessage(deviceKey, message);
	    } catch (e) {
	        throw new base.DecryptionError("Bad Encrypted Message", {
	            sender: deviceKey,
	            err: e
	        });
	    }
	
	    var payload = JSON.parse(payloadString);
	
	    // check that we were the intended recipient, to avoid unknown-key attack
	    // https://github.com/vector-im/vector-web/issues/2483
	    if (payload.recipient != this._userId) {
	        throw new base.DecryptionError("Message was intented for " + payload.recipient);
	    }
	
	    if (payload.recipient_keys.ed25519 != this._olmDevice.deviceEd25519Key) {
	        throw new base.DecryptionError("Message not intended for this device", {
	            intended: payload.recipient_keys.ed25519,
	            our_key: this._olmDevice.deviceEd25519Key
	        });
	    }
	
	    // check that the original sender matches what the homeserver told us, to
	    // avoid people masquerading as others.
	    // (this check is also provided via the sender's embedded ed25519 key,
	    // which is checked elsewhere).
	    if (payload.sender != event.getSender()) {
	        throw new base.DecryptionError("Message forwarded from " + payload.sender, {
	            reported_sender: event.getSender()
	        });
	    }
	
	    // Olm events intended for a room have a room_id.
	    if (payload.room_id !== event.getRoomId()) {
	        throw new base.DecryptionError("Message intended for room " + payload.room_id, {
	            reported_room: event.room_id
	        });
	    }
	
	    event.setClearData(payload, { curve25519: deviceKey }, payload.keys || {});
	};
	
	/**
	 * Attempt to decrypt an Olm message
	 *
	 * @param {string} theirDeviceIdentityKey  Curve25519 identity key of the sender
	 * @param {object} message  message object, with 'type' and 'body' fields
	 *
	 * @return {string} payload, if decrypted successfully.
	 */
	OlmDecryption.prototype._decryptMessage = function (theirDeviceIdentityKey, message) {
	    var sessionIds = this._olmDevice.getSessionIdsForDevice(theirDeviceIdentityKey);
	
	    // try each session in turn.
	    var decryptionErrors = {};
	    for (var i = 0; i < sessionIds.length; i++) {
	        var sessionId = sessionIds[i];
	        try {
	            var payload = this._olmDevice.decryptMessage(theirDeviceIdentityKey, sessionId, message.type, message.body);
	            console.log("Decrypted Olm message from " + theirDeviceIdentityKey + " with session " + sessionId);
	            return payload;
	        } catch (e) {
	            var foundSession = this._olmDevice.matchesSession(theirDeviceIdentityKey, sessionId, message.type, message.body);
	
	            if (foundSession) {
	                // decryption failed, but it was a prekey message matching this
	                // session, so it should have worked.
	                throw new Error("Error decrypting prekey message with existing session id " + sessionId + ": " + e.message);
	            }
	
	            // otherwise it's probably a message for another session; carry on, but
	            // keep a record of the error
	            decryptionErrors[sessionId] = e.message;
	        }
	    }
	
	    if (message.type !== 0) {
	        // not a prekey message, so it should have matched an existing session, but it
	        // didn't work.
	
	        if (sessionIds.length === 0) {
	            throw new Error("No existing sessions");
	        }
	
	        throw new Error("Error decrypting non-prekey message with existing sessions: " + JSON.stringify(decryptionErrors));
	    }
	
	    // prekey message which doesn't match any existing sessions: make a new
	    // session.
	
	    var res = void 0;
	    try {
	        res = this._olmDevice.createInboundSession(theirDeviceIdentityKey, message.type, message.body);
	    } catch (e) {
	        decryptionErrors["(new)"] = e.message;
	        throw new Error("Error decrypting prekey message: " + JSON.stringify(decryptionErrors));
	    }
	
	    console.log("created new inbound Olm session ID " + res.session_id + " with " + theirDeviceIdentityKey);
	    return res.payload;
	};
	
	base.registerAlgorithm(olmlib.OLM_ALGORITHM, OlmEncryption, OlmDecryption);


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module crypto
	 */
	
	var anotherjson = __webpack_require__(372);
	var q = __webpack_require__(6);
	
	var utils = __webpack_require__(16);
	var OlmDevice = __webpack_require__(1135);
	var olmlib = __webpack_require__(215);
	var algorithms = __webpack_require__(1136);
	var DeviceInfo = __webpack_require__(322);
	var DeviceVerification = DeviceInfo.DeviceVerification;
	var DeviceList = __webpack_require__(1134).default;
	
	/**
	 * Cryptography bits
	 *
	 * @constructor
	 * @alias module:crypto
	 *
	 * @param {module:base-apis~MatrixBaseApis} baseApis base matrix api interface
	 *
	 * @param {external:EventEmitter} eventEmitter event source where we can register
	 *    for event notifications
	 *
	 * @param {module:store/session/webstorage~WebStorageSessionStore} sessionStore
	 *    Store to be used for end-to-end crypto session data
	 *
	 * @param {string} userId The user ID for the local user
	 *
	 * @param {string} deviceId The identifier for this device.
	 *
	 * @param {Object} clientStore the MatrixClient data store.
	 */
	function Crypto(baseApis, eventEmitter, sessionStore, userId, deviceId, clientStore) {
	    this._baseApis = baseApis;
	    this._sessionStore = sessionStore;
	    this._userId = userId;
	    this._deviceId = deviceId;
	    this._clientStore = clientStore;
	
	    this._olmDevice = new OlmDevice(sessionStore);
	    this._deviceList = new DeviceList(baseApis, sessionStore, this._olmDevice);
	    this._initialDeviceListInvalidationDone = false;
	
	    this._clientRunning = false;
	
	    // the last time we did a check for the number of one-time-keys on the
	    // server.
	    this._lastOneTimeKeyCheck = null;
	    this._oneTimeKeyCheckInProgress = false;
	
	    // EncryptionAlgorithm instance for each room
	    this._roomEncryptors = {};
	
	    // map from algorithm to DecryptionAlgorithm instance, for each room
	    this._roomDecryptors = {};
	
	    this._supportedAlgorithms = utils.keys(algorithms.DECRYPTION_CLASSES);
	
	    // build our device keys: these will later be uploaded
	    this._deviceKeys = {};
	    this._deviceKeys["ed25519:" + this._deviceId] = this._olmDevice.deviceEd25519Key;
	    this._deviceKeys["curve25519:" + this._deviceId] = this._olmDevice.deviceCurve25519Key;
	
	    this._globalBlacklistUnverifiedDevices = false;
	
	    var myDevices = this._sessionStore.getEndToEndDevicesForUser(this._userId);
	
	    if (!myDevices) {
	        myDevices = {};
	    }
	
	    if (!myDevices[this._deviceId]) {
	        // add our own deviceinfo to the sessionstore
	        var deviceInfo = {
	            keys: this._deviceKeys,
	            algorithms: this._supportedAlgorithms,
	            verified: DeviceVerification.VERIFIED,
	            known: true
	        };
	
	        myDevices[this._deviceId] = deviceInfo;
	        this._sessionStore.storeEndToEndDevicesForUser(this._userId, myDevices);
	    }
	
	    _registerEventHandlers(this, eventEmitter);
	}
	
	function _registerEventHandlers(crypto, eventEmitter) {
	    eventEmitter.on("sync", function (syncState, oldState, data) {
	        try {
	            if (syncState === "STOPPED") {
	                crypto._clientRunning = false;
	            } else if (syncState === "PREPARED") {
	                crypto._clientRunning = true;
	            }
	            if (syncState === "SYNCING") {
	                crypto._onSyncCompleted(data);
	            }
	        } catch (e) {
	            console.error("Error handling sync", e);
	        }
	    });
	
	    eventEmitter.on("RoomMember.membership", function (event, member, oldMembership) {
	        try {
	            crypto._onRoomMembership(event, member, oldMembership);
	        } catch (e) {
	            console.error("Error handling membership change:", e);
	        }
	    });
	
	    eventEmitter.on("toDeviceEvent", function (event) {
	        try {
	            if (event.getType() == "m.room_key") {
	                crypto._onRoomKeyEvent(event);
	            } else if (event.getType() == "m.new_device") {
	                crypto._onNewDeviceEvent(event);
	            }
	        } catch (e) {
	            console.error("Error handling toDeviceEvent:", e);
	        }
	    });
	
	    eventEmitter.on("event", function (event) {
	        try {
	            if (!event.isState() || event.getType() != "m.room.encryption") {
	                return;
	            }
	            crypto._onCryptoEvent(event);
	        } catch (e) {
	            console.error("Error handling crypto event:", e);
	        }
	    });
	}
	
	/**
	 * @return {string} The version of Olm.
	 */
	Crypto.getOlmVersion = function () {
	    return OlmDevice.getOlmVersion();
	};
	
	/**
	 * Get the Ed25519 key for this device
	 *
	 * @return {string} base64-encoded ed25519 key.
	 */
	Crypto.prototype.getDeviceEd25519Key = function () {
	    return this._olmDevice.deviceEd25519Key;
	};
	
	/**
	 * Set the global override for whether the client should ever send encrypted
	 * messages to unverified devices.  If false, it can still be overridden
	 * per-room.  If true, it overrides the per-room settings.
	 *
	 * @param {boolean} value whether to unilaterally blacklist all
	 * unverified devices
	 */
	Crypto.prototype.setGlobalBlacklistUnverifiedDevices = function (value) {
	    this._globalBlacklistUnverifiedDevices = value;
	};
	
	/**
	 * @return {boolean} whether to unilaterally blacklist all unverified devices
	 */
	Crypto.prototype.getGlobalBlacklistUnverifiedDevices = function () {
	    return this._globalBlacklistUnverifiedDevices;
	};
	
	/**
	 * Upload the device keys to the homeserver.
	 * @return {object} A promise that will resolve when the keys are uploaded.
	 */
	Crypto.prototype.uploadDeviceKeys = function () {
	    var crypto = this;
	    var userId = crypto._userId;
	    var deviceId = crypto._deviceId;
	
	    var deviceKeys = {
	        algorithms: crypto._supportedAlgorithms,
	        device_id: deviceId,
	        keys: crypto._deviceKeys,
	        user_id: userId
	    };
	    crypto._signObject(deviceKeys);
	
	    return crypto._baseApis.uploadKeysRequest({
	        device_keys: deviceKeys
	    }, {
	        // for now, we set the device id explicitly, as we may not be using the
	        // same one as used in login.
	        device_id: deviceId
	    });
	};
	
	// check if it's time to upload one-time keys, and do so if so.
	function _maybeUploadOneTimeKeys(crypto) {
	    // frequency with which to check & upload one-time keys
	    var uploadPeriod = 1000 * 60; // one minute
	
	    // max number of keys to upload at once
	    // Creating keys can be an expensive operation so we limit the
	    // number we generate in one go to avoid blocking the application
	    // for too long.
	    var maxKeysPerCycle = 5;
	
	    if (crypto._oneTimeKeyCheckInProgress) {
	        return;
	    }
	
	    var now = Date.now();
	    if (crypto._lastOneTimeKeyCheck !== null && now - crypto._lastOneTimeKeyCheck < uploadPeriod) {
	        // we've done a key upload recently.
	        return;
	    }
	
	    crypto._lastOneTimeKeyCheck = now;
	
	    function uploadLoop(numberToGenerate) {
	        if (numberToGenerate <= 0) {
	            // If we don't need to generate any more keys then we are done.
	            return;
	        }
	
	        var keysThisLoop = Math.min(numberToGenerate, maxKeysPerCycle);
	
	        // Ask olm to generate new one time keys, then upload them to synapse.
	        crypto._olmDevice.generateOneTimeKeys(keysThisLoop);
	        return _uploadOneTimeKeys(crypto).then(function () {
	            return uploadLoop(numberToGenerate - keysThisLoop);
	        });
	    }
	
	    crypto._oneTimeKeyCheckInProgress = true;
	    q().then(function () {
	        // ask the server how many keys we have
	        return crypto._baseApis.uploadKeysRequest({}, {
	            device_id: crypto._deviceId
	        });
	    }).then(function (res) {
	        // We need to keep a pool of one time public keys on the server so that
	        // other devices can start conversations with us. But we can only store
	        // a finite number of private keys in the olm Account object.
	        // To complicate things further then can be a delay between a device
	        // claiming a public one time key from the server and it sending us a
	        // message. We need to keep the corresponding private key locally until
	        // we receive the message.
	        // But that message might never arrive leaving us stuck with duff
	        // private keys clogging up our local storage.
	        // So we need some kind of enginering compromise to balance all of
	        // these factors.
	
	        // We first find how many keys the server has for us.
	        var keyCount = res.one_time_key_counts.signed_curve25519 || 0;
	        // We then check how many keys we can store in the Account object.
	        var maxOneTimeKeys = crypto._olmDevice.maxNumberOfOneTimeKeys();
	        // Try to keep at most half that number on the server. This leaves the
	        // rest of the slots free to hold keys that have been claimed from the
	        // server but we haven't recevied a message for.
	        // If we run out of slots when generating new keys then olm will
	        // discard the oldest private keys first. This will eventually clean
	        // out stale private keys that won't receive a message.
	        var keyLimit = Math.floor(maxOneTimeKeys / 2);
	
	        // We work out how many new keys we need to create to top up the server
	        // If there are too many keys on the server then we don't need to
	        // create any more keys.
	        var numberToGenerate = Math.max(keyLimit - keyCount, 0);
	
	        return uploadLoop(numberToGenerate);
	    }).catch(function (e) {
	        console.error("Error uploading one-time keys", e.stack || e);
	    }).finally(function () {
	        crypto._oneTimeKeyCheckInProgress = false;
	    }).done();
	}
	
	// returns a promise which resolves to the response
	function _uploadOneTimeKeys(crypto) {
	    var oneTimeKeys = crypto._olmDevice.getOneTimeKeys();
	    var oneTimeJson = {};
	
	    for (var keyId in oneTimeKeys.curve25519) {
	        if (oneTimeKeys.curve25519.hasOwnProperty(keyId)) {
	            var k = {
	                key: oneTimeKeys.curve25519[keyId]
	            };
	            crypto._signObject(k);
	            oneTimeJson["signed_curve25519:" + keyId] = k;
	        }
	    }
	
	    return crypto._baseApis.uploadKeysRequest({
	        one_time_keys: oneTimeJson
	    }, {
	        // for now, we set the device id explicitly, as we may not be using the
	        // same one as used in login.
	        device_id: crypto._deviceId
	    }).then(function (res) {
	        crypto._olmDevice.markKeysAsPublished();
	        return res;
	    });
	}
	
	/**
	 * Download the keys for a list of users and stores the keys in the session
	 * store.
	 * @param {Array} userIds The users to fetch.
	 * @param {bool} forceDownload Always download the keys even if cached.
	 *
	 * @return {Promise} A promise which resolves to a map userId->deviceId->{@link
	 * module:crypto/deviceinfo|DeviceInfo}.
	 */
	Crypto.prototype.downloadKeys = function (userIds, forceDownload) {
	    return this._deviceList.downloadKeys(userIds, forceDownload);
	};
	
	/**
	 * Get the stored device keys for a user id
	 *
	 * @param {string} userId the user to list keys for.
	 *
	 * @return {module:crypto/deviceinfo[]|null} list of devices, or null if we haven't
	 * managed to get a list of devices for this user yet.
	 */
	Crypto.prototype.getStoredDevicesForUser = function (userId) {
	    return this._deviceList.getStoredDevicesForUser(userId);
	};
	
	/**
	 * Get the stored keys for a single device
	 *
	 * @param {string} userId
	 * @param {string} deviceId
	 *
	 * @return {module:crypto/deviceinfo?} device, or undefined
	 * if we don't know about this device
	 */
	Crypto.prototype.getStoredDevice = function (userId, deviceId) {
	    return this._deviceList.getStoredDevice(userId, deviceId);
	};
	
	/**
	 * List the stored device keys for a user id
	 *
	 * @deprecated prefer {@link module:crypto#getStoredDevicesForUser}
	 *
	 * @param {string} userId the user to list keys for.
	 *
	 * @return {object[]} list of devices with "id", "verified", "blocked",
	 *    "key", and "display_name" parameters.
	 */
	Crypto.prototype.listDeviceKeys = function (userId) {
	    var devices = this.getStoredDevicesForUser(userId) || [];
	
	    var result = [];
	
	    for (var i = 0; i < devices.length; ++i) {
	        var device = devices[i];
	        var ed25519Key = device.getFingerprint();
	        if (ed25519Key) {
	            result.push({
	                id: device.deviceId,
	                key: ed25519Key,
	                verified: Boolean(device.isVerified()),
	                blocked: Boolean(device.isBlocked()),
	                display_name: device.getDisplayName()
	            });
	        }
	    }
	
	    // sort by deviceid
	    result.sort(function (a, b) {
	        if (a.deviceId < b.deviceId) {
	            return -1;
	        }
	        if (a.deviceId > b.deviceId) {
	            return 1;
	        }
	        return 0;
	    });
	
	    return result;
	};
	
	/**
	 * Update the blocked/verified state of the given device
	 *
	 * @param {string} userId owner of the device
	 * @param {string} deviceId unique identifier for the device
	 *
	 * @param {?boolean} verified whether to mark the device as verified. Null to
	 *     leave unchanged.
	 *
	 * @param {?boolean} blocked whether to mark the device as blocked. Null to
	 *      leave unchanged.
	 *
	 * @param {?boolean} known whether to mark that the user has been made aware of
	 *      the existence of this device. Null to leave unchanged
	 *
	 * @return {module:crypto/deviceinfo} updated DeviceInfo
	 */
	Crypto.prototype.setDeviceVerification = function (userId, deviceId, verified, blocked, known) {
	    var devices = this._sessionStore.getEndToEndDevicesForUser(userId);
	    if (!devices || !devices[deviceId]) {
	        throw new Error("Unknown device " + userId + ":" + deviceId);
	    }
	
	    var dev = devices[deviceId];
	    var verificationStatus = dev.verified;
	
	    if (verified) {
	        verificationStatus = DeviceVerification.VERIFIED;
	    } else if (verified !== null && verificationStatus == DeviceVerification.VERIFIED) {
	        verificationStatus = DeviceVerification.UNVERIFIED;
	    }
	
	    if (blocked) {
	        verificationStatus = DeviceVerification.BLOCKED;
	    } else if (blocked !== null && verificationStatus == DeviceVerification.BLOCKED) {
	        verificationStatus = DeviceVerification.UNVERIFIED;
	    }
	
	    var knownStatus = dev.known;
	    if (known !== null && known !== undefined) {
	        knownStatus = known;
	    }
	
	    if (dev.verified !== verificationStatus || dev.known !== knownStatus) {
	        dev.verified = verificationStatus;
	        dev.known = knownStatus;
	        this._sessionStore.storeEndToEndDevicesForUser(userId, devices);
	    }
	    return DeviceInfo.fromStorage(dev, deviceId);
	};
	
	/**
	 * Get information on the active olm sessions with a user
	 * <p>
	 * Returns a map from device id to an object with keys 'deviceIdKey' (the
	 * device's curve25519 identity key) and 'sessions' (an array of objects in the
	 * same format as that returned by
	 * {@link module:crypto/OlmDevice#getSessionInfoForDevice}).
	 * <p>
	 * This method is provided for debugging purposes.
	 *
	 * @param {string} userId id of user to inspect
	 *
	 * @return {Object.<string, {deviceIdKey: string, sessions: object[]}>}
	 */
	Crypto.prototype.getOlmSessionsForUser = function (userId) {
	    var devices = this.getStoredDevicesForUser(userId) || [];
	    var result = {};
	    for (var j = 0; j < devices.length; ++j) {
	        var device = devices[j];
	        var deviceKey = device.getIdentityKey();
	        var sessions = this._olmDevice.getSessionInfoForDevice(deviceKey);
	
	        result[device.deviceId] = {
	            deviceIdKey: deviceKey,
	            sessions: sessions
	        };
	    }
	    return result;
	};
	
	/**
	 * Get the device which sent an event
	 *
	 * @param {module:models/event.MatrixEvent} event event to be checked
	 *
	 * @return {module:crypto/deviceinfo?}
	 */
	Crypto.prototype.getEventSenderDeviceInfo = function (event) {
	    var senderKey = event.getSenderKey();
	    var algorithm = event.getWireContent().algorithm;
	
	    if (!senderKey || !algorithm) {
	        return null;
	    }
	
	    // senderKey is the Curve25519 identity key of the device which the event
	    // was sent from. In the case of Megolm, it's actually the Curve25519
	    // identity key of the device which set up the Megolm session.
	
	    var device = this._deviceList.getDeviceByIdentityKey(event.getSender(), algorithm, senderKey);
	
	    if (device === null) {
	        // we haven't downloaded the details of this device yet.
	        return null;
	    }
	
	    // so far so good, but now we need to check that the sender of this event
	    // hadn't advertised someone else's Curve25519 key as their own. We do that
	    // by checking the Ed25519 claimed by the event (or, in the case of megolm,
	    // the event which set up the megolm session), to check that it matches the
	    // fingerprint of the purported sending device.
	    //
	    // (see https://github.com/vector-im/vector-web/issues/2215)
	
	    var claimedKey = event.getKeysClaimed().ed25519;
	    if (!claimedKey) {
	        console.warn("Event " + event.getId() + " claims no ed25519 key: " + "cannot verify sending device");
	        return null;
	    }
	
	    if (claimedKey !== device.getFingerprint()) {
	        console.warn("Event " + event.getId() + " claims ed25519 key " + claimedKey + "but sender device has key " + device.getFingerprint());
	        return null;
	    }
	
	    return device;
	};
	
	/**
	 * Configure a room to use encryption (ie, save a flag in the sessionstore).
	 *
	 * @param {string} roomId The room ID to enable encryption in.
	 * @param {object} config The encryption config for the room.
	 */
	Crypto.prototype.setRoomEncryption = function (roomId, config) {
	    var _this = this;
	
	    // if we already have encryption in this room, we should ignore this event
	    // (for now at least. maybe we should alert the user somehow?)
	    var existingConfig = this._sessionStore.getEndToEndRoom(roomId);
	    if (existingConfig) {
	        if (JSON.stringify(existingConfig) != JSON.stringify(config)) {
	            console.error("Ignoring m.room.encryption event which requests " + "a change of config in " + roomId);
	            return;
	        }
	    }
	
	    var AlgClass = algorithms.ENCRYPTION_CLASSES[config.algorithm];
	    if (!AlgClass) {
	        throw new Error("Unable to encrypt with " + config.algorithm);
	    }
	
	    this._sessionStore.storeEndToEndRoom(roomId, config);
	
	    var alg = new AlgClass({
	        userId: this._userId,
	        deviceId: this._deviceId,
	        crypto: this,
	        olmDevice: this._olmDevice,
	        baseApis: this._baseApis,
	        roomId: roomId,
	        config: config
	    });
	    this._roomEncryptors[roomId] = alg;
	
	    // if encryption was not previously enabled in this room, we will have been
	    // ignoring new device events for these users so far. We may well have
	    // up-to-date lists for some users, for instance if we were sharing other
	    // e2e rooms with them, so there is room for optimisation here, but for now
	    // we just invalidate everyone in the room.
	    if (!existingConfig) {
	        console.log("Enabling encryption in " + roomId + " for the first time; " + "invalidating device lists for all users therein");
	        var room = this._clientStore.getRoom(roomId);
	        var members = room.getJoinedMembers();
	        members.forEach(function (m) {
	            _this._deviceList.invalidateUserDeviceList(m.userId);
	        });
	        // the actual refresh happens once we've finished processing the sync,
	        // in _onSyncCompleted.
	    }
	};
	
	/**
	 * @typedef {Object} module:crypto~OlmSessionResult
	 * @property {module:crypto/deviceinfo} device  device info
	 * @property {string?} sessionId base64 olm session id; null if no session
	 *    could be established
	 */
	
	/**
	 * Try to make sure we have established olm sessions for all known devices for
	 * the given users.
	 *
	 * @param {string[]} users list of user ids
	 *
	 * @return {module:client.Promise} resolves once the sessions are complete, to
	 *    an Object mapping from userId to deviceId to
	 *    {@link module:crypto~OlmSessionResult}
	 */
	Crypto.prototype.ensureOlmSessionsForUsers = function (users) {
	    var devicesByUser = {};
	
	    for (var i = 0; i < users.length; ++i) {
	        var userId = users[i];
	        devicesByUser[userId] = [];
	
	        var devices = this.getStoredDevicesForUser(userId) || [];
	        for (var j = 0; j < devices.length; ++j) {
	            var deviceInfo = devices[j];
	
	            var key = deviceInfo.getIdentityKey();
	            if (key == this._olmDevice.deviceCurve25519Key) {
	                // don't bother setting up session to ourself
	                continue;
	            }
	            if (deviceInfo.verified == DeviceVerification.BLOCKED) {
	                // don't bother setting up sessions with blocked users
	                continue;
	            }
	
	            devicesByUser[userId].push(deviceInfo);
	        }
	    }
	
	    return olmlib.ensureOlmSessionsForDevices(this._olmDevice, this._baseApis, devicesByUser);
	};
	
	/**
	 * Whether encryption is enabled for a room.
	 * @param {string} roomId the room id to query.
	 * @return {bool} whether encryption is enabled.
	 */
	Crypto.prototype.isRoomEncrypted = function (roomId) {
	    return Boolean(this._roomEncryptors[roomId]);
	};
	
	/**
	 * Get a list containing all of the room keys
	 *
	 * @return {module:client.Promise} a promise which resolves to a list of
	 *    session export objects
	 */
	Crypto.prototype.exportRoomKeys = function () {
	    var _this2 = this;
	
	    return q(this._sessionStore.getAllEndToEndInboundGroupSessionKeys().map(function (s) {
	        var sess = _this2._olmDevice.exportInboundGroupSession(s.senderKey, s.sessionId);
	
	        sess.algorithm = olmlib.MEGOLM_ALGORITHM;
	        return sess;
	    }));
	};
	
	/**
	 * Import a list of room keys previously exported by exportRoomKeys
	 *
	 * @param {Object[]} keys a list of session export objects
	 */
	Crypto.prototype.importRoomKeys = function (keys) {
	    var _this3 = this;
	
	    keys.map(function (session) {
	        if (!session.room_id || !session.algorithm) {
	            console.warn("ignoring session entry with missing fields", session);
	            return;
	        }
	
	        var alg = _this3._getRoomDecryptor(session.room_id, session.algorithm);
	        alg.importRoomKey(session);
	    });
	};
	
	/**
	 * Encrypt an event according to the configuration of the room, if necessary.
	 *
	 * @param {module:models/event.MatrixEvent} event  event to be sent
	 *
	 * @param {module:models/room?} room destination room. Null if the destination
	 *     is not a room we have seen over the sync pipe.
	 *
	 * @return {module:client.Promise?} Promise which resolves when the event has been
	 *     encrypted, or null if nothing was needed
	 */
	Crypto.prototype.encryptEventIfNeeded = function (event, room) {
	    if (event.isEncrypted()) {
	        // this event has already been encrypted; this happens if the
	        // encryption step succeeded, but the send step failed on the first
	        // attempt.
	        return null;
	    }
	
	    if (!room) {
	        throw new Error("Cannot send encrypted messages in unknown rooms");
	    }
	
	    var roomId = event.getRoomId();
	
	    var alg = this._roomEncryptors[roomId];
	    if (!alg) {
	        // not encrypting messages in this room
	
	        // check that the HS hasn't hidden the crypto event
	        if (this._sessionStore.getEndToEndRoom(roomId)) {
	            throw new Error("Room was previously configured to use encryption, but is " + "no longer. Perhaps the homeserver is hiding the " + "configuration event.");
	        }
	        return null;
	    }
	
	    // We can claim and prove ownership of all our device keys in the local
	    // echo of the event since we know that all the local echos come from
	    // this device.
	    var myKeys = {
	        curve25519: this._olmDevice.deviceCurve25519Key,
	        ed25519: this._olmDevice.deviceEd25519Key
	    };
	
	    return alg.encryptMessage(room, event.getType(), event.getContent()).then(function (encryptedContent) {
	        event.makeEncrypted("m.room.encrypted", encryptedContent, myKeys);
	    });
	};
	
	/**
	 * Decrypt a received event
	 *
	 * @param {MatrixEvent} event
	 *
	 * @raises {algorithms.DecryptionError} if there is a problem decrypting the event
	 */
	Crypto.prototype.decryptEvent = function (event) {
	    var content = event.getWireContent();
	    var alg = this._getRoomDecryptor(event.getRoomId(), content.algorithm);
	    alg.decryptEvent(event);
	};
	
	/**
	 * Handle the notification from /sync that a user has updated their device list.
	 *
	 * @param {String} userId
	 */
	Crypto.prototype.userDeviceListChanged = function (userId) {
	    this._deviceList.invalidateUserDeviceList(userId);
	
	    // don't flush the outdated device list yet - we do it once we finish
	    // processing the sync.
	};
	
	/**
	 * handle an m.room.encryption event
	 *
	 * @private
	 * @param {module:models/event.MatrixEvent} event encryption event
	 */
	Crypto.prototype._onCryptoEvent = function (event) {
	    var roomId = event.getRoomId();
	    var content = event.getContent();
	
	    try {
	        this.setRoomEncryption(roomId, content);
	    } catch (e) {
	        console.error("Error configuring encryption in room " + roomId + ":", e);
	    }
	};
	
	/**
	 * handle the completion of a /sync
	 *
	 * This is called after the processing of each successful /sync response.
	 * It is an opportunity to do a batch process on the information received.
	 *
	 * @param {Object} syncData  the data from the 'MatrixClient.sync' event
	 */
	Crypto.prototype._onSyncCompleted = function (syncData) {
	    var _this4 = this;
	
	    var nextSyncToken = syncData.nextSyncToken;
	
	    if (!syncData.oldSyncToken) {
	        // an initialsync.
	        this._sendNewDeviceEvents();
	
	        // if we have a deviceSyncToken, we can tell the deviceList to
	        // invalidate devices which have changed since then.
	        var oldSyncToken = this._sessionStore.getEndToEndDeviceSyncToken();
	        if (oldSyncToken !== null) {
	            this._invalidateDeviceListsSince(oldSyncToken, nextSyncToken).catch(function (e) {
	                // if that failed, we fall back to invalidating everyone.
	                console.warn("Error fetching changed device list", e);
	                _this4._invalidateDeviceListForAllActiveUsers();
	            }).done(function () {
	                _this4._initialDeviceListInvalidationDone = true;
	                _this4._deviceList.lastKnownSyncToken = nextSyncToken;
	                _this4._deviceList.refreshOutdatedDeviceLists();
	            });
	        } else {
	            // otherwise, we have to invalidate all devices for all users we
	            // share a room with.
	            console.log("Completed first initialsync; invalidating all " + "device list caches");
	            this._invalidateDeviceListForAllActiveUsers();
	            this._initialDeviceListInvalidationDone = true;
	        }
	    }
	
	    if (this._initialDeviceListInvalidationDone) {
	        // if we've got an up-to-date list of users with outdated device lists,
	        // tell the device list about the new sync token (but not otherwise, because
	        // otherwise we'll start thinking we're more in sync than we are.)
	        this._deviceList.lastKnownSyncToken = nextSyncToken;
	
	        // catch up on any new devices we got told about during the sync.
	        this._deviceList.refreshOutdatedDeviceLists();
	    }
	
	    // we don't start uploading one-time keys until we've caught up with
	    // to-device messages, to help us avoid throwing away one-time-keys that we
	    // are about to receive messages for
	    // (https://github.com/vector-im/riot-web/issues/2782).
	    if (!syncData.catchingUp) {
	        _maybeUploadOneTimeKeys(this);
	    }
	};
	
	/**
	 * Send m.new_device messages to any devices we share a room with.
	 *
	 * (TODO: we can get rid of this once a suitable number of homeservers and
	 * clients support the more reliable device list update stream mechanism)
	 *
	 * @private
	 */
	Crypto.prototype._sendNewDeviceEvents = function () {
	    if (this._sessionStore.getDeviceAnnounced()) {
	        return;
	    }
	
	    // we need to tell all the devices in all the rooms we are members of that
	    // we have arrived.
	    // build a list of rooms for each user.
	    var roomsByUser = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = this._getE2eRooms()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var room = _step.value;
	
	            var members = room.getJoinedMembers();
	            for (var j = 0; j < members.length; j++) {
	                var m = members[j];
	                if (!roomsByUser[m.userId]) {
	                    roomsByUser[m.userId] = [];
	                }
	                roomsByUser[m.userId].push(room.roomId);
	            }
	        }
	
	        // build a per-device message for each user
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var content = {};
	    for (var userId in roomsByUser) {
	        if (!roomsByUser.hasOwnProperty(userId)) {
	            continue;
	        }
	        content[userId] = {
	            "*": {
	                device_id: this._deviceId,
	                rooms: roomsByUser[userId]
	            }
	        };
	    }
	
	    var self = this;
	    this._baseApis.sendToDevice("m.new_device", // OH HAI!
	    content).done(function () {
	        self._sessionStore.setDeviceAnnounced();
	    });
	};
	
	/**
	 * Ask the server which users have new devices since a given token,
	 * and invalidate them
	 *
	 * @param {String} oldSyncToken
	 * @param {String} lastKnownSyncToken
	 *
	 * @returns {Promise} resolves once the query is complete. Rejects if the
	 *   keyChange query fails.
	 */
	Crypto.prototype._invalidateDeviceListsSince = function (oldSyncToken, lastKnownSyncToken) {
	    var _this5 = this;
	
	    return this._baseApis.getKeyChanges(oldSyncToken, lastKnownSyncToken).then(function (r) {
	        if (!r.changed || !Array.isArray(r.changed)) {
	            return;
	        }
	
	        // only invalidate users we share an e2e room with - we don't
	        // care about users in non-e2e rooms.
	        var filteredUserIds = _this5._getE2eRoomMembers();
	        r.changed.forEach(function (u) {
	            if (u in filteredUserIds) {
	                _this5._deviceList.invalidateUserDeviceList(u);
	            }
	        });
	    });
	};
	
	/**
	 * Invalidate any stored device list for any users we share an e2e room with
	 *
	 * @private
	 */
	Crypto.prototype._invalidateDeviceListForAllActiveUsers = function () {
	    var _this6 = this;
	
	    Object.keys(this._getE2eRoomMembers()).forEach(function (m) {
	        _this6._deviceList.invalidateUserDeviceList(m);
	    });
	};
	
	/**
	 * get the users we share an e2e-enabled room with
	 *
	 * @returns {Object<string>} userid->userid map (should be a Set but argh ES6)
	 */
	Crypto.prototype._getE2eRoomMembers = function () {
	    var userIds = Object.create(null);
	
	    var rooms = this._getE2eRooms();
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = rooms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var r = _step2.value;
	
	            var members = r.getJoinedMembers();
	            members.forEach(function (m) {
	                userIds[m.userId] = m.userId;
	            });
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return userIds;
	};
	
	/**
	 * Get a list of the e2e-enabled rooms we are members of
	 *
	 * @returns {module:models.Room[]}
	 */
	Crypto.prototype._getE2eRooms = function () {
	    var _this7 = this;
	
	    return this._clientStore.getRooms().filter(function (room) {
	        // check for rooms with encryption enabled
	        var alg = _this7._roomEncryptors[room.roomId];
	        if (!alg) {
	            return false;
	        }
	
	        // ignore any rooms which we have left
	        var me = room.getMember(_this7._userId);
	        if (!me || me.membership !== "join" && me.membership !== "invite") {
	            return false;
	        }
	
	        return true;
	    });
	};
	
	/**
	 * Handle a key event
	 *
	 * @private
	 * @param {module:models/event.MatrixEvent} event key event
	 */
	Crypto.prototype._onRoomKeyEvent = function (event) {
	    var content = event.getContent();
	
	    if (!content.room_id || !content.algorithm) {
	        console.error("key event is missing fields");
	        return;
	    }
	
	    var alg = this._getRoomDecryptor(content.room_id, content.algorithm);
	    alg.onRoomKeyEvent(event);
	};
	
	/**
	 * Handle a change in the membership state of a member of a room
	 *
	 * @private
	 * @param {module:models/event.MatrixEvent} event  event causing the change
	 * @param {module:models/room-member} member  user whose membership changed
	 * @param {string=} oldMembership  previous membership
	 */
	Crypto.prototype._onRoomMembership = function (event, member, oldMembership) {
	    // this event handler is registered on the *client* (as opposed to the room
	    // member itself), which means it is only called on changes to the *live*
	    // membership state (ie, it is not called when we back-paginate, nor when
	    // we load the state in the initialsync).
	    //
	    // Further, it is automatically registered and called when new members
	    // arrive in the room.
	
	    var roomId = member.roomId;
	
	    var alg = this._roomEncryptors[roomId];
	    if (!alg) {
	        // not encrypting in this room
	        return;
	    }
	
	    alg.onRoomMembership(event, member, oldMembership);
	};
	
	/**
	 * Called when a new device announces itself
	 *
	 * @private
	 * @param {module:models/event.MatrixEvent} event announcement event
	 */
	Crypto.prototype._onNewDeviceEvent = function (event) {
	    var content = event.getContent();
	    var userId = event.getSender();
	    var deviceId = content.device_id;
	    var rooms = content.rooms;
	
	    if (!rooms || !deviceId) {
	        console.warn("new_device event missing keys");
	        return;
	    }
	
	    console.log("m.new_device event from " + userId + ":" + deviceId + " for rooms " + rooms);
	
	    if (this.getStoredDevice(userId, deviceId)) {
	        console.log("Known device; ignoring");
	        return;
	    }
	
	    this._deviceList.invalidateUserDeviceList(userId);
	};
	
	/**
	 * Get a decryptor for a given room and algorithm.
	 *
	 * If we already have a decryptor for the given room and algorithm, return
	 * it. Otherwise try to instantiate it.
	 *
	 * @private
	 *
	 * @param {string?} roomId   room id for decryptor. If undefined, a temporary
	 * decryptor is instantiated.
	 *
	 * @param {string} algorithm  crypto algorithm
	 *
	 * @return {module:crypto.algorithms.base.DecryptionAlgorithm}
	 *
	 * @raises {module:crypto.algorithms.DecryptionError} if the algorithm is
	 * unknown
	 */
	Crypto.prototype._getRoomDecryptor = function (roomId, algorithm) {
	    var decryptors = void 0;
	    var alg = void 0;
	
	    roomId = roomId || null;
	    if (roomId) {
	        decryptors = this._roomDecryptors[roomId];
	        if (!decryptors) {
	            this._roomDecryptors[roomId] = decryptors = {};
	        }
	
	        alg = decryptors[algorithm];
	        if (alg) {
	            return alg;
	        }
	    }
	
	    var AlgClass = algorithms.DECRYPTION_CLASSES[algorithm];
	    if (!AlgClass) {
	        throw new algorithms.DecryptionError('Unknown encryption algorithm "' + algorithm + '".');
	    }
	    alg = new AlgClass({
	        userId: this._userId,
	        crypto: this,
	        olmDevice: this._olmDevice,
	        roomId: roomId
	    });
	
	    if (decryptors) {
	        decryptors[algorithm] = alg;
	    }
	    return alg;
	};
	
	/**
	 * sign the given object with our ed25519 key
	 *
	 * @param {Object} obj  Object to which we will add a 'signatures' property
	 */
	Crypto.prototype._signObject = function (obj) {
	    var sigs = {};
	    sigs[this._userId] = {};
	    sigs[this._userId]["ed25519:" + this._deviceId] = this._olmDevice.sign(anotherjson.stringify(obj));
	    obj.signatures = sigs;
	};
	
	/**
	 * @see module:crypto/algorithms/base.DecryptionError
	 */
	Crypto.DecryptionError = algorithms.DecryptionError;
	
	/** */
	module.exports = Crypto;


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module filter-component
	 */
	
	/**
	 * Checks if a value matches a given field value, which may be a * terminated
	 * wildcard pattern.
	 * @param {String} actual_value  The value to be compared
	 * @param {String} filter_value  The filter pattern to be compared
	 * @return {bool} true if the actual_value matches the filter_value
	 */
	
	function _matches_wildcard(actual_value, filter_value) {
	    if (filter_value.endsWith("*")) {
	        var type_prefix = filter_value.slice(0, -1);
	        return actual_value.substr(0, type_prefix.length) === type_prefix;
	    } else {
	        return actual_value === filter_value;
	    }
	}
	
	/**
	 * FilterComponent is a section of a Filter definition which defines the
	 * types, rooms, senders filters etc to be applied to a particular type of resource.
	 * This is all ported over from synapse's Filter object.
	 *
	 * N.B. that synapse refers to these as 'Filters', and what js-sdk refers to as
	 * 'Filters' are referred to as 'FilterCollections'.
	 *
	 * @constructor
	 * @param {Object} filter_json the definition of this filter JSON, e.g. { 'contains_url': true }
	 */
	function FilterComponent(filter_json) {
	    this.filter_json = filter_json;
	
	    this.types = filter_json.types || null;
	    this.not_types = filter_json.not_types || [];
	
	    this.rooms = filter_json.rooms || null;
	    this.not_rooms = filter_json.not_rooms || [];
	
	    this.senders = filter_json.senders || null;
	    this.not_senders = filter_json.not_senders || [];
	
	    this.contains_url = filter_json.contains_url || null;
	}
	
	/**
	 * Checks with the filter component matches the given event
	 * @param {MatrixEvent} event event to be checked against the filter
	 * @return {bool} true if the event matches the filter
	 */
	FilterComponent.prototype.check = function (event) {
	    return this._checkFields(event.getRoomId(), event.getSender(), event.getType(), event.getContent() ? event.getContent().url !== undefined : false);
	};
	
	/**
	 * Checks whether the filter component matches the given event fields.
	 * @param {String} room_id       the room_id for the event being checked
	 * @param {String} sender        the sender of the event being checked
	 * @param {String} event_type    the type of the event being checked
	 * @param {String} contains_url  whether the event contains a content.url field
	 * @return {bool} true if the event fields match the filter
	 */
	FilterComponent.prototype._checkFields = function (room_id, sender, event_type, contains_url) {
	    var literal_keys = {
	        "rooms": function rooms(v) {
	            return room_id === v;
	        },
	        "senders": function senders(v) {
	            return sender === v;
	        },
	        "types": function types(v) {
	            return _matches_wildcard(event_type, v);
	        }
	    };
	
	    var self = this;
	    Object.keys(literal_keys).forEach(function (name) {
	        var match_func = literal_keys[name];
	        var not_name = "not_" + name;
	        var disallowed_values = self[not_name];
	        if (disallowed_values.map(match_func)) {
	            return false;
	        }
	
	        var allowed_values = self[name];
	        if (allowed_values) {
	            if (!allowed_values.map(match_func)) {
	                return false;
	            }
	        }
	    });
	
	    var contains_url_filter = this.filter_json.contains_url;
	    if (contains_url_filter !== undefined) {
	        if (contains_url_filter !== contains_url) {
	            return false;
	        }
	    }
	
	    return true;
	};
	
	/**
	 * Filters a list of events down to those which match this filter component
	 * @param {MatrixEvent[]} events  Events to be checked againt the filter component
	 * @return {MatrixEvent[]} events which matched the filter component
	 */
	FilterComponent.prototype.filter = function (events) {
	    return events.filter(this.check, this);
	};
	
	/**
	 * Returns the limit field for a given filter component, providing a default of
	 * 10 if none is otherwise specified.  Cargo-culted from Synapse.
	 * @return {Number} the limit for this filter component.
	 */
	FilterComponent.prototype.limit = function () {
	    return this.filter_json.limit !== undefined ? this.filter_json.limit : 10;
	};
	
	/** The FilterComponent class */
	module.exports = FilterComponent;


/***/ }),
/* 1141 */,
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/** @module interactive-auth */
	
	var q = __webpack_require__(6);
	var url = __webpack_require__(149);
	
	var utils = __webpack_require__(16);
	
	var EMAIL_STAGE_TYPE = "m.login.email.identity";
	var MSISDN_STAGE_TYPE = "m.login.msisdn";
	
	/**
	 * Abstracts the logic used to drive the interactive auth process.
	 *
	 * <p>Components implementing an interactive auth flow should instantiate one of
	 * these, passing in the necessary callbacks to the constructor. They should
	 * then call attemptAuth, which will return a promise which will resolve or
	 * reject when the interactive-auth process completes.
	 *
	 * <p>Meanwhile, calls will be made to the startAuthStage and doRequest
	 * callbacks, and information gathered from the user can be submitted with
	 * submitAuthDict.
	 *
	 * @constructor
	 * @alias module:interactive-auth
	 *
	 * @param {object} opts  options object
	 *
	 * @param {object} opts.matrixClient A matrix client to use for the auth process
	 *
	 * @param {object?} opts.authData error response from the last request. If
	 *    null, a request will be made with no auth before starting.
	 *
	 * @param {function(object?, bool?): module:client.Promise} opts.doRequest
	 *     called with the new auth dict to submit the request and a flag set
	 *     to true if this request is a background request. Should return a
	 *     promise which resolves to the successful response or rejects with a
	 *     MatrixError.
	 *
	 * @param {function(string, object?)} opts.stateUpdated
	 *     called when the status of the UI auth changes, ie. when the state of
	 *     an auth stage changes of when the auth flow moves to a new stage.
	 *     The arguments are: the login type (eg m.login.password); and an object
	 *     which is either an error or an informational object specific to the
	 *     login type. If the 'errcode' key is defined, the object is an error,
	 *     and has keys:
	 *         errcode: string, the textual error code, eg. M_UNKNOWN
	 *         error: string, human readable string describing the error
	 *
	 *     The login type specific objects are as follows:
	 *         m.login.email.identity:
	 *          * emailSid: string, the sid of the active email auth session
	 *
	 * @param {object?} opts.inputs Inputs provided by the user and used by different
	 *     stages of the auto process. The inputs provided will affect what flow is chosen.
	 *
	 * @param {string?} opts.inputs.emailAddress An email address. If supplied, a flow
	 *     using email verification will be chosen.
	 *
	 * @param {string?} opts.inputs.phoneCountry An ISO two letter country code. Gives
	 *     the country that opts.phoneNumber should be resolved relative to.
	 *
	 * @param {string?} opts.inputs.phoneNumber A phone number. If supplied, a flow
	 *     using phone number validation will be chosen.
	 *
	 * @param {string?} opts.sessionId If resuming an existing interactive auth session,
	 *     the sessionId of that session.
	 *
	 * @param {string?} opts.clientSecret If resuming an existing interactive auth session,
	 *     the client secret for that session
	 *
	 * @param {string?} opts.emailSid If returning from having completed m.login.email.identity
	 *     auth, the sid for the email verification session.
	 *
	 */
	function InteractiveAuth(opts) {
	    this._matrixClient = opts.matrixClient;
	    this._data = opts.authData || {};
	    this._requestCallback = opts.doRequest;
	    // startAuthStage included for backwards compat
	    this._stateUpdatedCallback = opts.stateUpdated || opts.startAuthStage;
	    this._completionDeferred = null;
	    this._inputs = opts.inputs || {};
	
	    if (opts.sessionId) this._data.session = opts.sessionId;
	    this._clientSecret = opts.clientSecret || this._matrixClient.generateClientSecret();
	    this._emailSid = opts.emailSid;
	    if (this._emailSid === undefined) this._emailSid = null;
	
	    this._currentStage = null;
	}
	
	InteractiveAuth.prototype = {
	    /**
	     * begin the authentication process.
	     *
	     * @return {module:client.Promise} which resolves to the response on success,
	     * or rejects with the error on failure. Rejects with NoAuthFlowFoundError if
	     *     no suitable authentication flow can be found
	     */
	    attemptAuth: function attemptAuth() {
	        var _this = this;
	
	        this._completionDeferred = q.defer();
	
	        // wrap in a promise so that if _startNextAuthStage
	        // throws, it rejects the promise in a consistent way
	        return q().then(function () {
	            // if we have no flows, try a request (we'll have
	            // just a session ID in _data if resuming)
	            if (!_this._data.flows) {
	                _this._doRequest(_this._data);
	            } else {
	                _this._startNextAuthStage();
	            }
	            return _this._completionDeferred.promise;
	        });
	    },
	
	    /**
	     * Poll to check if the auth session or current stage has been
	     * completed out-of-band. If so, the attemptAuth promise will
	     * be resolved.
	     */
	    poll: function poll() {
	        if (!this._data.session) return;
	
	        var authDict = {};
	        if (this._currentStage == EMAIL_STAGE_TYPE) {
	            // The email can be validated out-of-band, but we need to provide the
	            // creds so the HS can go & check it.
	            if (this._emailSid) {
	                var idServerParsedUrl = url.parse(this._matrixClient.getIdentityServerUrl());
	                authDict = {
	                    type: EMAIL_STAGE_TYPE,
	                    threepid_creds: {
	                        sid: this._emailSid,
	                        client_secret: this._clientSecret,
	                        id_server: idServerParsedUrl.host
	                    }
	                };
	            }
	        }
	
	        this.submitAuthDict(authDict, true);
	    },
	
	    /**
	     * get the auth session ID
	     *
	     * @return {string} session id
	     */
	    getSessionId: function getSessionId() {
	        return this._data ? this._data.session : undefined;
	    },
	
	    /**
	     * get the client secret used for validation sessions
	     * with the ID server.
	     *
	     * @return {string} client secret
	     */
	    getClientSecret: function getClientSecret() {
	        return this._clientSecret;
	    },
	
	    /**
	     * get the server params for a given stage
	     *
	     * @param {string} loginType login type for the stage
	     * @return {object?} any parameters from the server for this stage
	     */
	    getStageParams: function getStageParams(loginType) {
	        var params = {};
	        if (this._data && this._data.params) {
	            params = this._data.params;
	        }
	        return params[loginType];
	    },
	
	    /**
	     * submit a new auth dict and fire off the request. This will either
	     * make attemptAuth resolve/reject, or cause the startAuthStage callback
	     * to be called for a new stage.
	     *
	     * @param {object} authData new auth dict to send to the server. Should
	     *    include a `type` propterty denoting the login type, as well as any
	     *    other params for that stage.
	     * @param {bool} background If true, this request failing will not result
	     *    in the attemptAuth promise being rejected. This can be set to true
	     *    for requests that just poll to see if auth has been completed elsewhere.
	     */
	    submitAuthDict: function submitAuthDict(authData, background) {
	        if (!this._completionDeferred) {
	            throw new Error("submitAuthDict() called before attemptAuth()");
	        }
	
	        // use the sessionid from the last request.
	        var auth = {
	            session: this._data.session
	        };
	        utils.extend(auth, authData);
	
	        this._doRequest(auth, background);
	    },
	
	    /**
	     * Gets the sid for the email validation session
	     * Specific to m.login.email.identity
	     *
	     * @returns {string} The sid of the email auth session
	     */
	    getEmailSid: function getEmailSid() {
	        return this._emailSid;
	    },
	
	    /**
	     * Sets the sid for the email validation session
	     * This must be set in order to successfully poll for completion
	     * of the email validation.
	     * Specific to m.login.email.identity
	     *
	     * @param {string} sid The sid for the email validation session
	     */
	    setEmailSid: function setEmailSid(sid) {
	        this._emailSid = sid;
	    },
	
	    /**
	     * Fire off a request, and either resolve the promise, or call
	     * startAuthStage.
	     *
	     * @private
	     * @param {object?} auth new auth dict, including session id
	     * @param {bool?} background If true, this request is a background poll, so it
	     *    failing will not result in the attemptAuth promise being rejected.
	     *    This can be set to true for requests that just poll to see if auth has
	     *    been completed elsewhere.
	     */
	    _doRequest: function _doRequest(auth, background) {
	        var self = this;
	
	        // hackery to make sure that synchronous exceptions end up in the catch
	        // handler (without the additional event loop entailed by q.fcall or an
	        // extra q().then)
	        var prom = void 0;
	        try {
	            prom = this._requestCallback(auth, background);
	        } catch (e) {
	            prom = q.reject(e);
	        }
	
	        prom = prom.then(function (result) {
	            console.log("result from request: ", result);
	            self._completionDeferred.resolve(result);
	        }, function (error) {
	            // sometimes UI auth errors don't come with flows
	            var errorFlows = error.data ? error.data.flows : null;
	            var haveFlows = Boolean(self._data.flows) || Boolean(errorFlows);
	            if (error.httpStatus !== 401 || !error.data || !haveFlows) {
	                // doesn't look like an interactive-auth failure. fail the whole lot.
	                throw error;
	            }
	            // if the error didn't come with flows, completed flows or session ID,
	            // copy over the ones we have. Synapse sometimes sends responses without
	            // any UI auth data (eg. when polling for email validation, if the email
	            // has not yet been validated). This appears to be a Synapse bug, which
	            // we workaround here.
	            if (!error.data.flows && !error.data.completed && !error.data.session) {
	                error.data.flows = self._data.flows;
	                error.data.completed = self._data.completed;
	                error.data.session = self._data.session;
	            }
	            self._data = error.data;
	            self._startNextAuthStage();
	        });
	        if (!background) {
	            prom = prom.catch(this._completionDeferred.reject);
	        } else {
	            // We ignore all failures here (even non-UI auth related ones)
	            // since we don't want to suddenly fail if the internet connection
	            // had a blip whilst we were polling
	            prom = prom.catch(function (error) {
	                console.log("Ignoring error from UI auth: " + error);
	            });
	        }
	        prom.done();
	    },
	
	    /**
	     * Pick the next stage and call the callback
	     *
	     * @private
	     * @throws {NoAuthFlowFoundError} If no suitable authentication flow can be found
	     */
	    _startNextAuthStage: function _startNextAuthStage() {
	        var nextStage = this._chooseStage();
	        if (!nextStage) {
	            throw new Error("No incomplete flows from the server");
	        }
	        this._currentStage = nextStage;
	
	        if (nextStage == 'm.login.dummy') {
	            this.submitAuthDict({
	                type: 'm.login.dummy'
	            });
	            return;
	        }
	
	        if (this._data.errcode || this._data.error) {
	            this._stateUpdatedCallback(nextStage, {
	                errcode: this._data.errcode || "",
	                error: this._data.error || ""
	            });
	            return;
	        }
	
	        var stageStatus = {};
	        if (nextStage == EMAIL_STAGE_TYPE) {
	            stageStatus.emailSid = this._emailSid;
	        }
	        this._stateUpdatedCallback(nextStage, stageStatus);
	    },
	
	    /**
	     * Pick the next auth stage
	     *
	     * @private
	     * @return {string?} login type
	     * @throws {NoAuthFlowFoundError} If no suitable authentication flow can be found
	     */
	    _chooseStage: function _chooseStage() {
	        var flow = this._chooseFlow();
	        console.log("Active flow => %s", JSON.stringify(flow));
	        var nextStage = this._firstUncompletedStage(flow);
	        console.log("Next stage: %s", nextStage);
	        return nextStage;
	    },
	
	    /**
	     * Pick one of the flows from the returned list
	     * If a flow using all of the inputs is found, it will
	     * be returned, otherwise, null will be returned.
	     *
	     * Only flows using all given inputs are chosen because it
	     * is likley to be surprising if the user provides a
	     * credential and it is not used. For example, for registration,
	     * this could result in the email not being used which would leave
	     * the account with no means to reset a password.
	     *
	     * @private
	     * @return {object} flow
	     * @throws {NoAuthFlowFoundError} If no suitable authentication flow can be found
	     */
	    _chooseFlow: function _chooseFlow() {
	        var flows = this._data.flows || [];
	
	        // we've been given an email or we've already done an email part
	        var haveEmail = Boolean(this._inputs.emailAddress) || Boolean(this._emailSid);
	        var haveMsisdn = Boolean(this._inputs.phoneCountry) && Boolean(this._inputs.phoneNumber);
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = flows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var flow = _step.value;
	
	                var flowHasEmail = false;
	                var flowHasMsisdn = false;
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = flow.stages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var stage = _step2.value;
	
	                        if (stage === EMAIL_STAGE_TYPE) {
	                            flowHasEmail = true;
	                        } else if (stage == MSISDN_STAGE_TYPE) {
	                            flowHasMsisdn = true;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	
	                if (flowHasEmail == haveEmail && flowHasMsisdn == haveMsisdn) {
	                    return flow;
	                }
	            }
	            // Throw an error with a fairly generic description, but with more
	            // information such that the app can give a better one if so desired.
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        var err = new Error("No appropriate authentication flow found");
	        err.name = 'NoAuthFlowFoundError';
	        err.required_stages = [];
	        if (haveEmail) err.required_stages.push(EMAIL_STAGE_TYPE);
	        if (haveMsisdn) err.required_stages.push(MSISDN_STAGE_TYPE);
	        err.available_flows = flows;
	        throw err;
	    },
	
	    /**
	     * Get the first uncompleted stage in the given flow
	     *
	     * @private
	     * @param {object} flow
	     * @return {string} login type
	     */
	    _firstUncompletedStage: function _firstUncompletedStage(flow) {
	        var completed = (this._data || {}).completed || [];
	        for (var i = 0; i < flow.stages.length; ++i) {
	            var stageType = flow.stages[i];
	            if (completed.indexOf(stageType) === -1) {
	                return stageType;
	            }
	        }
	    }
	};
	
	/** */
	module.exports = InteractiveAuth;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/** The {@link module:models/event.MatrixEvent|MatrixEvent} class. */
	
	module.exports.MatrixEvent = __webpack_require__(92).MatrixEvent;
	/** The {@link module:models/event.EventStatus|EventStatus} enum. */
	module.exports.EventStatus = __webpack_require__(92).EventStatus;
	/** The {@link module:store/memory.MatrixInMemoryStore|MatrixInMemoryStore} class. */
	module.exports.MatrixInMemoryStore = __webpack_require__(494).MatrixInMemoryStore;
	/** The {@link module:store/indexeddb.IndexedDBStore|IndexedDBStore} class. */
	module.exports.IndexedDBStore = __webpack_require__(493).IndexedDBStore;
	/** The {@link module:store/indexeddb.IndexedDBStoreBackend|IndexedDBStoreBackend} class. */
	module.exports.IndexedDBStoreBackend = __webpack_require__(493).IndexedDBStoreBackend;
	/** The {@link module:sync-accumulator.SyncAccumulator|SyncAccumulator} class. */
	module.exports.SyncAccumulator = __webpack_require__(218);
	/** The {@link module:http-api.MatrixHttpApi|MatrixHttpApi} class. */
	module.exports.MatrixHttpApi = __webpack_require__(216).MatrixHttpApi;
	/** The {@link module:http-api.MatrixError|MatrixError} class. */
	module.exports.MatrixError = __webpack_require__(216).MatrixError;
	/** The {@link module:client.MatrixClient|MatrixClient} class. */
	module.exports.MatrixClient = __webpack_require__(488).MatrixClient;
	/** The {@link module:models/room|Room} class. */
	module.exports.Room = __webpack_require__(491);
	/** The {@link module:models/event-timeline~EventTimeline} class. */
	module.exports.EventTimeline = __webpack_require__(115);
	/** The {@link module:models/event-timeline-set~EventTimelineSet} class. */
	module.exports.EventTimelineSet = __webpack_require__(324);
	/** The {@link module:models/room-member|RoomMember} class. */
	module.exports.RoomMember = __webpack_require__(489);
	/** The {@link module:models/room-state~RoomState|RoomState} class. */
	module.exports.RoomState = __webpack_require__(490);
	/** The {@link module:models/user~User|User} class. */
	module.exports.User = __webpack_require__(217);
	/** The {@link module:scheduler~MatrixScheduler|MatrixScheduler} class. */
	module.exports.MatrixScheduler = __webpack_require__(1148);
	/** The {@link module:store/session/webstorage~WebStorageSessionStore|
	 * WebStorageSessionStore} class. <strong>Work in progress; unstable.</strong> */
	module.exports.WebStorageSessionStore = __webpack_require__(1151);
	/** True if crypto libraries are being used on this client. */
	module.exports.CRYPTO_ENABLED = __webpack_require__(488).CRYPTO_ENABLED;
	/** {@link module:content-repo|ContentRepo} utility functions. */
	module.exports.ContentRepo = __webpack_require__(214);
	/** The {@link module:filter~Filter|Filter} class. */
	module.exports.Filter = __webpack_require__(323);
	/** The {@link module:timeline-window~TimelineWindow} class. */
	module.exports.TimelineWindow = __webpack_require__(1154).TimelineWindow;
	/** The {@link module:interactive-auth} class. */
	module.exports.InteractiveAuth = __webpack_require__(1142);
	
	/**
	 * Create a new Matrix Call.
	 * @function
	 * @param {module:client.MatrixClient} client The MatrixClient instance to use.
	 * @param {string} roomId The room the call is in.
	 * @return {module:webrtc/call~MatrixCall} The Matrix call or null if the browser
	 * does not support WebRTC.
	 */
	module.exports.createNewMatrixCall = __webpack_require__(495).createNewMatrixCall;
	
	// expose the underlying request object so different environments can use
	// different request libs (e.g. request or browser-request)
	var request = void 0;
	/**
	 * The function used to perform HTTP requests. Only use this if you want to
	 * use a different HTTP library, e.g. Angular's <code>$http</code>. This should
	 * be set prior to calling {@link createClient}.
	 * @param {requestFunction} r The request function to use.
	 */
	module.exports.request = function (r) {
	  request = r;
	};
	
	/**
	 * Return the currently-set request function.
	 * @return {requestFunction} The current request function.
	 */
	module.exports.getRequest = function () {
	  return request;
	};
	
	/**
	 * Apply wrapping code around the request function. The wrapper function is
	 * installed as the new request handler, and when invoked it is passed the
	 * previous value, along with the options and callback arguments.
	 * @param {requestWrapperFunction} wrapper The wrapping function.
	 */
	module.exports.wrapRequest = function (wrapper) {
	  var origRequest = request;
	  request = function request(options, callback) {
	    return wrapper(origRequest, options, callback);
	  };
	};
	
	/**
	 * Construct a Matrix Client. Similar to {@link module:client~MatrixClient}
	 * except that the 'request', 'store' and 'scheduler' dependencies are satisfied.
	 * @param {(Object|string)} opts The configuration options for this client. If
	 * this is a string, it is assumed to be the base URL. These configuration
	 * options will be passed directly to {@link module:client~MatrixClient}.
	 * @param {Object} opts.store If not set, defaults to
	 * {@link module:store/memory.MatrixInMemoryStore}.
	 * @param {Object} opts.scheduler If not set, defaults to
	 * {@link module:scheduler~MatrixScheduler}.
	 * @param {requestFunction} opts.request If not set, defaults to the function
	 * supplied to {@link request} which defaults to the request module from NPM.
	 * @return {MatrixClient} A new matrix client.
	 * @see {@link module:client~MatrixClient} for the full list of options for
	 * <code>opts</code>.
	 */
	module.exports.createClient = function (opts) {
	  if (typeof opts === "string") {
	    opts = {
	      "baseUrl": opts
	    };
	  }
	  opts.request = opts.request || request;
	  opts.store = opts.store || new module.exports.MatrixInMemoryStore({
	    localStorage: global.localStorage
	  });
	  opts.scheduler = opts.scheduler || new module.exports.MatrixScheduler();
	  return new module.exports.MatrixClient(opts);
	};
	
	/**
	 * The request function interface for performing HTTP requests. This matches the
	 * API for the {@link https://github.com/request/request#requestoptions-callback|
	 * request NPM module}. The SDK will attempt to call this function in order to
	 * perform an HTTP request.
	 * @callback requestFunction
	 * @param {Object} opts The options for this HTTP request.
	 * @param {string} opts.uri The complete URI.
	 * @param {string} opts.method The HTTP method.
	 * @param {Object} opts.qs The query parameters to append to the URI.
	 * @param {Object} opts.body The JSON-serializable object.
	 * @param {boolean} opts.json True if this is a JSON request.
	 * @param {Object} opts._matrix_opts The underlying options set for
	 * {@link MatrixHttpApi}.
	 * @param {requestCallback} callback The request callback.
	 */
	
	/**
	 * A wrapper for the request function interface.
	 * @callback requestWrapperFunction
	 * @param {requestFunction} origRequest The underlying request function being
	 * wrapped
	 * @param {Object} opts The options for this HTTP request, given in the same
	 * form as {@link requestFunction}.
	 * @param {requestCallback} callback The request callback.
	 */
	
	/**
	 * The request callback interface for performing HTTP requests. This matches the
	 * API for the {@link https://github.com/request/request#requestoptions-callback|
	 * request NPM module}. The SDK will implement a callback which meets this
	 * interface in order to handle the HTTP response.
	 * @callback requestCallback
	 * @param {Error} err The error if one occurred, else falsey.
	 * @param {Object} response The HTTP response which consists of
	 * <code>{statusCode: {Number}, headers: {Object}}</code>
	 * @param {Object} body The parsed HTTP response body.
	 */
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module models/event-context
	 */
	
	/**
	 * Construct a new EventContext
	 *
	 * An eventcontext is used for circumstances such as search results, when we
	 * have a particular event of interest, and a bunch of events before and after
	 * it.
	 *
	 * It also stores pagination tokens for going backwards and forwards in the
	 * timeline.
	 *
	 * @param {MatrixEvent} ourEvent  the event at the centre of this context
	 *
	 * @constructor
	 */
	
	function EventContext(ourEvent) {
	    this._timeline = [ourEvent];
	    this._ourEventIndex = 0;
	    this._paginateTokens = { b: null, f: null };
	
	    // this is used by MatrixClient to keep track of active requests
	    this._paginateRequests = { b: null, f: null };
	}
	
	/**
	 * Get the main event of interest
	 *
	 * This is a convenience function for getTimeline()[getOurEventIndex()].
	 *
	 * @return {MatrixEvent} The event at the centre of this context.
	 */
	EventContext.prototype.getEvent = function () {
	    return this._timeline[this._ourEventIndex];
	};
	
	/**
	 * Get the list of events in this context
	 *
	 * @return {Array} An array of MatrixEvents
	 */
	EventContext.prototype.getTimeline = function () {
	    return this._timeline;
	};
	
	/**
	 * Get the index in the timeline of our event
	 *
	 * @return {Number}
	 */
	EventContext.prototype.getOurEventIndex = function () {
	    return this._ourEventIndex;
	};
	
	/**
	 * Get a pagination token.
	 *
	 * @param {boolean} backwards   true to get the pagination token for going
	 *                                  backwards in time
	 * @return {string}
	 */
	EventContext.prototype.getPaginateToken = function (backwards) {
	    return this._paginateTokens[backwards ? 'b' : 'f'];
	};
	
	/**
	 * Set a pagination token.
	 *
	 * Generally this will be used only by the matrix js sdk.
	 *
	 * @param {string} token        pagination token
	 * @param {boolean} backwards   true to set the pagination token for going
	 *                                   backwards in time
	 */
	EventContext.prototype.setPaginateToken = function (token, backwards) {
	    this._paginateTokens[backwards ? 'b' : 'f'] = token;
	};
	
	/**
	 * Add more events to the timeline
	 *
	 * @param {Array} events      new events, in timeline order
	 * @param {boolean} atStart   true to insert new events at the start
	 */
	EventContext.prototype.addEvents = function (events, atStart) {
	    // TODO: should we share logic with Room.addEventsToTimeline?
	    // Should Room even use EventContext?
	
	    if (atStart) {
	        this._timeline = events.concat(this._timeline);
	        this._ourEventIndex += events.length;
	    } else {
	        this._timeline = this._timeline.concat(events);
	    }
	};
	
	/**
	 * The EventContext class
	 */
	module.exports = EventContext;


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room-summary
	 */
	
	/**
	 * Construct a new Room Summary. A summary can be used for display on a recent
	 * list, without having to load the entire room list into memory.
	 * @constructor
	 * @param {string} roomId Required. The ID of this room.
	 * @param {Object} info Optional. The summary info. Additional keys are supported.
	 * @param {string} info.title The title of the room (e.g. <code>m.room.name</code>)
	 * @param {string} info.desc The description of the room (e.g.
	 * <code>m.room.topic</code>)
	 * @param {Number} info.numMembers The number of joined users.
	 * @param {string[]} info.aliases The list of aliases for this room.
	 * @param {Number} info.timestamp The timestamp for this room.
	 */
	
	function RoomSummary(roomId, info) {
	  this.roomId = roomId;
	  this.info = info;
	}
	
	/**
	 * The RoomSummary class.
	 */
	module.exports = RoomSummary;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module models/search-result
	 */
	
	var EventContext = __webpack_require__(1144);
	var utils = __webpack_require__(16);
	
	/**
	 * Construct a new SearchResult
	 *
	 * @param {number} rank   where this SearchResult ranks in the results
	 * @param {event-context.EventContext} eventContext  the matching event and its
	 *    context
	 *
	 * @constructor
	 */
	function SearchResult(rank, eventContext) {
	  this.rank = rank;
	  this.context = eventContext;
	}
	
	/**
	 * Create a SearchResponse from the response to /search
	 * @static
	 * @param {Object} jsonObj
	 * @param {function} eventMapper
	 * @return {SearchResult}
	 */
	
	SearchResult.fromJson = function (jsonObj, eventMapper) {
	  var jsonContext = jsonObj.context || {};
	  var events_before = jsonContext.events_before || [];
	  var events_after = jsonContext.events_after || [];
	
	  var context = new EventContext(eventMapper(jsonObj.result));
	
	  context.setPaginateToken(jsonContext.start, true);
	  context.addEvents(utils.map(events_before, eventMapper), true);
	  context.addEvents(utils.map(events_after, eventMapper), false);
	  context.setPaginateToken(jsonContext.end, false);
	
	  return new SearchResult(jsonObj.rank, context);
	};
	
	/**
	 * The SearchResult class
	 */
	module.exports = SearchResult;


/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/* A re-implementation of the javascript callback functions (setTimeout,
	 * clearTimeout; setInterval and clearInterval are not yet implemented) which
	 * try to improve handling of large clock jumps (as seen when
	 * suspending/resuming the system).
	 *
	 * In particular, if a timeout would have fired while the system was suspended,
	 * it will instead fire as soon as possible after resume.
	 */
	
	"use strict";
	
	// we schedule a callback at least this often, to check if we've missed out on
	// some wall-clock time due to being suspended.
	
	var TIMER_CHECK_PERIOD_MS = 1000;
	
	// counter, for making up ids to return from setTimeout
	var _count = 0;
	
	// the key for our callback with the real global.setTimeout
	var _realCallbackKey = void 0;
	
	// a sorted list of the callbacks to be run.
	// each is an object with keys [runAt, func, params, key].
	var _callbackList = [];
	
	// var debuglog = console.log.bind(console);
	var debuglog = function debuglog() {};
	
	/**
	 * Replace the function used by this module to get the current time.
	 *
	 * Intended for use by the unit tests.
	 *
	 * @param {function} f function which should return a millisecond counter
	 *
	 * @internal
	 */
	module.exports.setNow = function (f) {
	    _now = f || Date.now;
	};
	var _now = Date.now;
	
	/**
	 * reimplementation of window.setTimeout, which will call the callback if
	 * the wallclock time goes past the deadline.
	 *
	 * @param {function} func   callback to be called after a delay
	 * @param {Number} delayMs  number of milliseconds to delay by
	 *
	 * @return {Number} an identifier for this callback, which may be passed into
	 *                   clearTimeout later.
	 */
	module.exports.setTimeout = function (func, delayMs) {
	    delayMs = delayMs || 0;
	    if (delayMs < 0) {
	        delayMs = 0;
	    }
	
	    var params = Array.prototype.slice.call(arguments, 2);
	    var runAt = _now() + delayMs;
	    var key = _count++;
	    debuglog("setTimeout: scheduling cb", key, "at", runAt, "(delay", delayMs, ")");
	    var data = {
	        runAt: runAt,
	        func: func,
	        params: params,
	        key: key
	    };
	
	    // figure out where it goes in the list
	    var idx = binarySearch(_callbackList, function (el) {
	        return el.runAt - runAt;
	    });
	
	    _callbackList.splice(idx, 0, data);
	    _scheduleRealCallback();
	
	    return key;
	};
	
	/**
	 * reimplementation of window.clearTimeout, which mirrors setTimeout
	 *
	 * @param {Number} key   result from an earlier setTimeout call
	 */
	module.exports.clearTimeout = function (key) {
	    if (_callbackList.length === 0) {
	        return;
	    }
	
	    // remove the element from the list
	    var i = void 0;
	    for (i = 0; i < _callbackList.length; i++) {
	        var cb = _callbackList[i];
	        if (cb.key == key) {
	            _callbackList.splice(i, 1);
	            break;
	        }
	    }
	
	    // iff it was the first one in the list, reschedule our callback.
	    if (i === 0) {
	        _scheduleRealCallback();
	    }
	};
	
	// use the real global.setTimeout to schedule a callback to _runCallbacks.
	function _scheduleRealCallback() {
	    if (_realCallbackKey) {
	        global.clearTimeout(_realCallbackKey);
	    }
	
	    var first = _callbackList[0];
	
	    if (!first) {
	        debuglog("_scheduleRealCallback: no more callbacks, not rescheduling");
	        return;
	    }
	
	    var now = _now();
	    var delayMs = Math.min(first.runAt - now, TIMER_CHECK_PERIOD_MS);
	
	    debuglog("_scheduleRealCallback: now:", now, "delay:", delayMs);
	    _realCallbackKey = global.setTimeout(_runCallbacks, delayMs);
	}
	
	function _runCallbacks() {
	    var cb = void 0;
	    var now = _now();
	    debuglog("_runCallbacks: now:", now);
	
	    // get the list of things to call
	    var callbacksToRun = [];
	    while (true) {
	        var first = _callbackList[0];
	        if (!first || first.runAt > now) {
	            break;
	        }
	        cb = _callbackList.shift();
	        debuglog("_runCallbacks: popping", cb.key);
	        callbacksToRun.push(cb);
	    }
	
	    // reschedule the real callback before running our functions, to
	    // keep the codepaths the same whether or not our functions
	    // register their own setTimeouts.
	    _scheduleRealCallback();
	
	    for (var i = 0; i < callbacksToRun.length; i++) {
	        cb = callbacksToRun[i];
	        try {
	            cb.func.apply(global, cb.params);
	        } catch (e) {
	            console.error("Uncaught exception in callback function", e.stack || e);
	        }
	    }
	}
	
	/* search in a sorted array.
	 *
	 * returns the index of the last element for which func returns
	 * greater than zero, or array.length if no such element exists.
	 */
	function binarySearch(array, func) {
	    // min is inclusive, max exclusive.
	    var min = 0,
	        max = array.length;
	
	    while (min < max) {
	        var mid = min + max >> 1;
	        var res = func(array[mid]);
	        if (res > 0) {
	            // the element at 'mid' is too big; set it as the new max.
	            max = mid;
	        } else {
	            // the element at 'mid' is too small. 'min' is inclusive, so +1.
	            min = mid + 1;
	        }
	    }
	    // presumably, min==max now.
	    return min;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module which manages queuing, scheduling and retrying
	 * of requests.
	 * @module scheduler
	 */
	
	var utils = __webpack_require__(16);
	var q = __webpack_require__(6);
	
	var DEBUG = false; // set true to enable console logging.
	
	/**
	 * Construct a scheduler for Matrix. Requires
	 * {@link module:scheduler~MatrixScheduler#setProcessFunction} to be provided
	 * with a way of processing events.
	 * @constructor
	 * @param {module:scheduler~retryAlgorithm} retryAlgorithm Optional. The retry
	 * algorithm to apply when determining when to try to send an event again.
	 * Defaults to {@link module:scheduler~MatrixScheduler.RETRY_BACKOFF_RATELIMIT}.
	 * @param {module:scheduler~queueAlgorithm} queueAlgorithm Optional. The queuing
	 * algorithm to apply when determining which events should be sent before the
	 * given event. Defaults to {@link module:scheduler~MatrixScheduler.QUEUE_MESSAGES}.
	 */
	function MatrixScheduler(retryAlgorithm, queueAlgorithm) {
	    this.retryAlgorithm = retryAlgorithm || MatrixScheduler.RETRY_BACKOFF_RATELIMIT;
	    this.queueAlgorithm = queueAlgorithm || MatrixScheduler.QUEUE_MESSAGES;
	    this._queues = {
	        // queueName: [{
	        //  event: MatrixEvent,  // event to send
	        //  defer: Deferred,  // defer to resolve/reject at the END of the retries
	        //  attempts: Number  // number of times we've called processFn
	        // }, ...]
	    };
	    this._activeQueues = [];
	    this._procFn = null;
	}
	
	/**
	 * Retrieve a queue based on an event. The event provided does not need to be in
	 * the queue.
	 * @param {MatrixEvent} event An event to get the queue for.
	 * @return {?Array<MatrixEvent>} A shallow copy of events in the queue or null.
	 * Modifying this array will not modify the list itself. Modifying events in
	 * this array <i>will</i> modify the underlying event in the queue.
	 * @see MatrixScheduler.removeEventFromQueue To remove an event from the queue.
	 */
	MatrixScheduler.prototype.getQueueForEvent = function (event) {
	    var name = this.queueAlgorithm(event);
	    if (!name || !this._queues[name]) {
	        return null;
	    }
	    return utils.map(this._queues[name], function (obj) {
	        return obj.event;
	    });
	};
	
	/**
	 * Remove this event from the queue. The event is equal to another event if they
	 * have the same ID returned from event.getId().
	 * @param {MatrixEvent} event The event to remove.
	 * @return {boolean} True if this event was removed.
	 */
	MatrixScheduler.prototype.removeEventFromQueue = function (event) {
	    var name = this.queueAlgorithm(event);
	    if (!name || !this._queues[name]) {
	        return false;
	    }
	    var removed = false;
	    utils.removeElement(this._queues[name], function (element) {
	        if (element.event.getId() === event.getId()) {
	            removed = true;
	            return true;
	        }
	    });
	    return removed;
	};
	
	/**
	 * Set the process function. Required for events in the queue to be processed.
	 * If set after events have been added to the queue, this will immediately start
	 * processing them.
	 * @param {module:scheduler~processFn} fn The function that can process events
	 * in the queue.
	 */
	MatrixScheduler.prototype.setProcessFunction = function (fn) {
	    this._procFn = fn;
	    _startProcessingQueues(this);
	};
	
	/**
	 * Queue an event if it is required and start processing queues.
	 * @param {MatrixEvent} event The event that may be queued.
	 * @return {?Promise} A promise if the event was queued, which will be
	 * resolved or rejected in due time, else null.
	 */
	MatrixScheduler.prototype.queueEvent = function (event) {
	    var queueName = this.queueAlgorithm(event);
	    if (!queueName) {
	        return null;
	    }
	    // add the event to the queue and make a deferred for it.
	    if (!this._queues[queueName]) {
	        this._queues[queueName] = [];
	    }
	    var defer = q.defer();
	    this._queues[queueName].push({
	        event: event,
	        defer: defer,
	        attempts: 0
	    });
	    debuglog("Queue algorithm dumped event %s into queue '%s'", event.getId(), queueName);
	    _startProcessingQueues(this);
	    return defer.promise;
	};
	
	/**
	 * Retries events up to 4 times using exponential backoff. This produces wait
	 * times of 2, 4, 8, and 16 seconds (30s total) after which we give up. If the
	 * failure was due to a rate limited request, the time specified in the error is
	 * waited before being retried.
	 * @param {MatrixEvent} event
	 * @param {Number} attempts
	 * @param {MatrixError} err
	 * @return {Number}
	 * @see module:scheduler~retryAlgorithm
	 */
	MatrixScheduler.RETRY_BACKOFF_RATELIMIT = function (event, attempts, err) {
	    if (err.httpStatus === 400 || err.httpStatus === 403 || err.httpStatus === 401) {
	        // client error; no amount of retrying with save you now.
	        return -1;
	    }
	    // we ship with browser-request which returns { cors: rejected } when trying
	    // with no connection, so if we match that, give up since they have no conn.
	    if (err.cors === "rejected") {
	        return -1;
	    }
	
	    if (err.name === "M_LIMIT_EXCEEDED") {
	        var waitTime = err.data.retry_after_ms;
	        if (waitTime) {
	            return waitTime;
	        }
	    }
	    if (attempts > 4) {
	        return -1; // give up
	    }
	    return 1000 * Math.pow(2, attempts);
	};
	
	/**
	 * Queues <code>m.room.message</code> events and lets other events continue
	 * concurrently.
	 * @param {MatrixEvent} event
	 * @return {string}
	 * @see module:scheduler~queueAlgorithm
	 */
	MatrixScheduler.QUEUE_MESSAGES = function (event) {
	    if (event.getType() === "m.room.message") {
	        // put these events in the 'message' queue.
	        return "message";
	    }
	    // allow all other events continue concurrently.
	    return null;
	};
	
	function _startProcessingQueues(scheduler) {
	    if (!scheduler._procFn) {
	        return;
	    }
	    // for each inactive queue with events in them
	    utils.forEach(utils.filter(utils.keys(scheduler._queues), function (queueName) {
	        return scheduler._activeQueues.indexOf(queueName) === -1 && scheduler._queues[queueName].length > 0;
	    }), function (queueName) {
	        // mark the queue as active
	        scheduler._activeQueues.push(queueName);
	        // begin processing the head of the queue
	        debuglog("Spinning up queue: '%s'", queueName);
	        _processQueue(scheduler, queueName);
	    });
	}
	
	function _processQueue(scheduler, queueName) {
	    // get head of queue
	    var obj = _peekNextEvent(scheduler, queueName);
	    if (!obj) {
	        // queue is empty. Mark as inactive and stop recursing.
	        var index = scheduler._activeQueues.indexOf(queueName);
	        if (index >= 0) {
	            scheduler._activeQueues.splice(index, 1);
	        }
	        debuglog("Stopping queue '%s' as it is now empty", queueName);
	        return;
	    }
	    debuglog("Queue '%s' has %s pending events", queueName, scheduler._queues[queueName].length);
	    // fire the process function and if it resolves, resolve the deferred. Else
	    // invoke the retry algorithm.
	    scheduler._procFn(obj.event).done(function (res) {
	        // remove this from the queue
	        _removeNextEvent(scheduler, queueName);
	        debuglog("Queue '%s' sent event %s", queueName, obj.event.getId());
	        obj.defer.resolve(res);
	        // keep processing
	        _processQueue(scheduler, queueName);
	    }, function (err) {
	        obj.attempts += 1;
	        // ask the retry algorithm when/if we should try again
	        var waitTimeMs = scheduler.retryAlgorithm(obj.event, obj.attempts, err);
	        debuglog("retry(%s) err=%s event_id=%s waitTime=%s", obj.attempts, err, obj.event.getId(), waitTimeMs);
	        if (waitTimeMs === -1) {
	            // give up (you quitter!)
	            debuglog("Queue '%s' giving up on event %s", queueName, obj.event.getId());
	            // remove this from the queue
	            _removeNextEvent(scheduler, queueName);
	            obj.defer.reject(err);
	            // process next event
	            _processQueue(scheduler, queueName);
	        } else {
	            setTimeout(function () {
	                _processQueue(scheduler, queueName);
	            }, waitTimeMs);
	        }
	    });
	}
	
	function _peekNextEvent(scheduler, queueName) {
	    var queue = scheduler._queues[queueName];
	    if (!utils.isArray(queue)) {
	        return null;
	    }
	    return queue[0];
	}
	
	function _removeNextEvent(scheduler, queueName) {
	    var queue = scheduler._queues[queueName];
	    if (!utils.isArray(queue)) {
	        return null;
	    }
	    return queue.shift();
	}
	
	function debuglog() {
	    if (DEBUG) {
	        var _console;
	
	        (_console = console).log.apply(_console, arguments);
	    }
	}
	
	/**
	 * The retry algorithm to apply when retrying events. To stop retrying, return
	 * <code>-1</code>. If this event was part of a queue, it will be removed from
	 * the queue.
	 * @callback retryAlgorithm
	 * @param {MatrixEvent} event The event being retried.
	 * @param {Number} attempts The number of failed attempts. This will always be
	 * >= 1.
	 * @param {MatrixError} err The most recent error message received when trying
	 * to send this event.
	 * @return {Number} The number of milliseconds to wait before trying again. If
	 * this is 0, the request will be immediately retried. If this is
	 * <code>-1</code>, the event will be marked as
	 * {@link module:models/event.EventStatus.NOT_SENT} and will not be retried.
	 */
	
	/**
	 * The queuing algorithm to apply to events. This function must be idempotent as
	 * it may be called multiple times with the same event. All queues created are
	 * serviced in a FIFO manner. To send the event ASAP, return <code>null</code>
	 * which will not put this event in a queue. Events that fail to send that form
	 * part of a queue will be removed from the queue and the next event in the
	 * queue will be sent.
	 * @callback queueAlgorithm
	 * @param {MatrixEvent} event The event to be sent.
	 * @return {string} The name of the queue to put the event into. If a queue with
	 * this name does not exist, it will be created. If this is <code>null</code>,
	 * the event is not put into a queue and will be sent concurrently.
	 */
	
	/**
	* The function to invoke to process (send) events in the queue.
	* @callback processFn
	* @param {MatrixEvent} event The event to send.
	* @return {Promise} Resolved/rejected depending on the outcome of the request.
	*/
	
	/**
	 * The MatrixScheduler class.
	 */
	module.exports = MatrixScheduler;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An IndexedDB store backend where the actual backend sits in a web
	 * worker.
	 *
	 * Construct a new Indexed Database store backend. This requires a call to
	 * <code>connect()</code> before this store can be used.
	 * @constructor
	 * @param {string} workerScript URL to the worker script
	 * @param {string=} dbName Optional database name. The same name must be used
	 * to open the same database.
	 * @param {Object} WorkerApi The web worker compatible interface object
	 */
	var RemoteIndexedDBStoreBackend = function RemoteIndexedDBStoreBackend(workerScript, dbName, WorkerApi) {
	    this._dbName = dbName;
	    this._worker = new WorkerApi(workerScript);
	    this._nextSeq = 0;
	    // The currently in-flight requests to the actual backend
	    this._inFlight = {
	        // seq: promise,
	    };
	
	    this._worker.onmessage = this._onWorkerMessage.bind(this);
	}; /*
	   Copyright 2017 Vector Creations Ltd
	   
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	   
	       http://www.apache.org/licenses/LICENSE-2.0
	   
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	   */
	
	RemoteIndexedDBStoreBackend.prototype = {
	    /**
	     * Attempt to connect to the database. This can fail if the user does not
	     * grant permission.
	     * @return {Promise} Resolves if successfully connected.
	     */
	    connect: function connect() {
	        var _this = this;
	
	        return this._doCmd('_setupWorker', [this._dbName]).then(function () {
	            console.log("IndexedDB worker is ready");
	            return _this._doCmd('connect');
	        });
	    },
	
	    /**
	     * Clear the entire database. This should be used when logging out of a client
	     * to prevent mixing data between accounts.
	     * @return {Promise} Resolved when the database is cleared.
	     */
	    clearDatabase: function clearDatabase() {
	        return this._doCmd('clearDatabase');
	    },
	
	    /**
	     * @return {Promise} Resolves with a sync response to restore the
	     * client state to where it was at the last save, or null if there
	     * is no saved sync data.
	     */
	    getSavedSync: function getSavedSync() {
	        return this._doCmd('getSavedSync');
	    },
	
	    setSyncData: function setSyncData(syncData) {
	        return this._doCmd('setSyncData', [syncData]);
	    },
	
	    syncToDatabase: function syncToDatabase(users) {
	        return this._doCmd('syncToDatabase', [users]);
	    },
	
	    /**
	     * Load all user presence events from the database. This is not cached.
	     * @return {Promise<Object[]>} A list of presence events in their raw form.
	     */
	    getUserPresenceEvents: function getUserPresenceEvents() {
	        return this._doCmd('getUserPresenceEvents');
	    },
	
	    _doCmd: function _doCmd(cmd, args) {
	        var _this2 = this;
	
	        // wrap in a q so if the postMessage throws,
	        // the promise automatically gets rejected
	        return (0, _q2.default)().then(function () {
	            var seq = _this2._nextSeq++;
	            var def = _q2.default.defer();
	
	            _this2._inFlight[seq] = def;
	
	            _this2._worker.postMessage({
	                command: cmd,
	                seq: seq,
	                args: args
	            });
	
	            return def.promise;
	        });
	    },
	
	    _onWorkerMessage: function _onWorkerMessage(ev) {
	        var msg = ev.data;
	
	        if (msg.command == 'cmd_success' || msg.command == 'cmd_fail') {
	            if (msg.seq === undefined) {
	                console.error("Got reply from worker with no seq");
	                return;
	            }
	
	            var def = this._inFlight[msg.seq];
	            if (def === undefined) {
	                console.error("Got reply for unknown seq " + msg.seq);
	                return;
	            }
	            delete this._inFlight[msg.seq];
	
	            if (msg.command == 'cmd_success') {
	                def.resolve(msg.result);
	            } else {
	                def.reject(msg.error);
	            }
	        } else {
	            console.warn("Unrecognised message from worker: " + msg);
	        }
	    }
	};
	
	exports.default = RemoteIndexedDBStoreBackend;


/***/ }),
/* 1150 */,
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module store/session/webstorage
	 */
	
	var utils = __webpack_require__(16);
	
	var DEBUG = false; // set true to enable console logging.
	var E2E_PREFIX = "session.e2e.";
	
	/**
	 * Construct a web storage session store, capable of storing account keys,
	 * session keys and access tokens.
	 * @constructor
	 * @param {WebStorage} webStore A web storage implementation, e.g.
	 * 'window.localStorage' or 'window.sessionStorage' or a custom implementation.
	 * @throws if the supplied 'store' does not meet the Storage interface of the
	 * WebStorage API.
	 */
	function WebStorageSessionStore(webStore) {
	    this.store = webStore;
	    if (!utils.isFunction(webStore.getItem) || !utils.isFunction(webStore.setItem) || !utils.isFunction(webStore.removeItem) || !utils.isFunction(webStore.key) || typeof webStore.length !== 'number') {
	        throw new Error("Supplied webStore does not meet the WebStorage API interface");
	    }
	}
	
	WebStorageSessionStore.prototype = {
	
	    /**
	     * Store the end to end account for the logged-in user.
	     * @param {string} account Base64 encoded account.
	     */
	    storeEndToEndAccount: function storeEndToEndAccount(account) {
	        this.store.setItem(KEY_END_TO_END_ACCOUNT, account);
	    },
	
	    /**
	     * Load the end to end account for the logged-in user.
	     * @return {?string} Base64 encoded account.
	     */
	    getEndToEndAccount: function getEndToEndAccount() {
	        return this.store.getItem(KEY_END_TO_END_ACCOUNT);
	    },
	
	    /**
	     * Store a flag indicating that we have announced the new device.
	     */
	    setDeviceAnnounced: function setDeviceAnnounced() {
	        this.store.setItem(KEY_END_TO_END_ANNOUNCED, "true");
	    },
	
	    /**
	     * Check if the "device announced" flag is set
	     *
	     * @return {boolean} true if the "device announced" flag has been set.
	     */
	    getDeviceAnnounced: function getDeviceAnnounced() {
	        return this.store.getItem(KEY_END_TO_END_ANNOUNCED) == "true";
	    },
	
	    /**
	     * Stores the known devices for a user.
	     * @param {string} userId The user's ID.
	     * @param {object} devices A map from device ID to keys for the device.
	     */
	    storeEndToEndDevicesForUser: function storeEndToEndDevicesForUser(userId, devices) {
	        setJsonItem(this.store, keyEndToEndDevicesForUser(userId), devices);
	    },
	
	    /**
	     * Retrieves the known devices for a user.
	     * @param {string} userId The user's ID.
	     * @return {object} A map from device ID to keys for the device.
	     */
	    getEndToEndDevicesForUser: function getEndToEndDevicesForUser(userId) {
	        return getJsonItem(this.store, keyEndToEndDevicesForUser(userId));
	    },
	
	    /**
	     * Store the sync token corresponding to the device list.
	     *
	     * This is used when starting the client, to get a list of the users who
	     * have changed their device list since the list time we were running.
	     *
	     * @param {String?} token
	     */
	    storeEndToEndDeviceSyncToken: function storeEndToEndDeviceSyncToken(token) {
	        setJsonItem(this.store, KEY_END_TO_END_DEVICE_SYNC_TOKEN, token);
	    },
	
	    /**
	     * Get the sync token corresponding to the device list.
	     *
	     * @return {String?} token
	     */
	    getEndToEndDeviceSyncToken: function getEndToEndDeviceSyncToken() {
	        return getJsonItem(this.store, KEY_END_TO_END_DEVICE_SYNC_TOKEN);
	    },
	
	    /**
	     * Store a session between the logged-in user and another device
	     * @param {string} deviceKey The public key of the other device.
	     * @param {string} sessionId The ID for this end-to-end session.
	     * @param {string} session Base64 encoded end-to-end session.
	     */
	    storeEndToEndSession: function storeEndToEndSession(deviceKey, sessionId, session) {
	        var sessions = this.getEndToEndSessions(deviceKey) || {};
	        sessions[sessionId] = session;
	        setJsonItem(this.store, keyEndToEndSessions(deviceKey), sessions);
	    },
	
	    /**
	     * Retrieve the end-to-end sessions between the logged-in user and another
	     * device.
	     * @param {string} deviceKey The public key of the other device.
	     * @return {object} A map from sessionId to Base64 end-to-end session.
	     */
	    getEndToEndSessions: function getEndToEndSessions(deviceKey) {
	        return getJsonItem(this.store, keyEndToEndSessions(deviceKey));
	    },
	
	    /**
	     * Retrieve a list of all known inbound group sessions
	     *
	     * @return {{senderKey: string, sessionId: string}}
	     */
	    getAllEndToEndInboundGroupSessionKeys: function getAllEndToEndInboundGroupSessionKeys() {
	        var prefix = E2E_PREFIX + 'inboundgroupsessions/';
	        var result = [];
	        for (var i = 0; i < this.store.length; i++) {
	            var key = this.store.key(i);
	            if (!key.startsWith(prefix)) {
	                continue;
	            }
	            // we can't use split, as the components we are trying to split out
	            // might themselves contain '/' characters. We rely on the
	            // senderKey being a (32-byte) curve25519 key, base64-encoded
	            // (hence 43 characters long).
	
	            result.push({
	                senderKey: key.substr(prefix.length, 43),
	                sessionId: key.substr(prefix.length + 44)
	            });
	        }
	        return result;
	    },
	
	    getEndToEndInboundGroupSession: function getEndToEndInboundGroupSession(senderKey, sessionId) {
	        var key = keyEndToEndInboundGroupSession(senderKey, sessionId);
	        return this.store.getItem(key);
	    },
	
	    storeEndToEndInboundGroupSession: function storeEndToEndInboundGroupSession(senderKey, sessionId, pickledSession) {
	        var key = keyEndToEndInboundGroupSession(senderKey, sessionId);
	        return this.store.setItem(key, pickledSession);
	    },
	
	    /**
	     * Store the end-to-end state for a room.
	     * @param {string} roomId The room's ID.
	     * @param {object} roomInfo The end-to-end info for the room.
	     */
	    storeEndToEndRoom: function storeEndToEndRoom(roomId, roomInfo) {
	        setJsonItem(this.store, keyEndToEndRoom(roomId), roomInfo);
	    },
	
	    /**
	     * Get the end-to-end state for a room
	     * @param {string} roomId The room's ID.
	     * @return {object} The end-to-end info for the room.
	     */
	    getEndToEndRoom: function getEndToEndRoom(roomId) {
	        return getJsonItem(this.store, keyEndToEndRoom(roomId));
	    }
	};
	
	var KEY_END_TO_END_ACCOUNT = E2E_PREFIX + "account";
	var KEY_END_TO_END_ANNOUNCED = E2E_PREFIX + "announced";
	var KEY_END_TO_END_DEVICE_SYNC_TOKEN = E2E_PREFIX + "device_sync_token";
	
	function keyEndToEndDevicesForUser(userId) {
	    return E2E_PREFIX + "devices/" + userId;
	}
	
	function keyEndToEndSessions(deviceKey) {
	    return E2E_PREFIX + "sessions/" + deviceKey;
	}
	
	function keyEndToEndInboundGroupSession(senderKey, sessionId) {
	    return E2E_PREFIX + "inboundgroupsessions/" + senderKey + "/" + sessionId;
	}
	
	function keyEndToEndRoom(roomId) {
	    return E2E_PREFIX + "rooms/" + roomId;
	}
	
	function getJsonItem(store, key) {
	    try {
	        // if the key is absent, store.getItem() returns null, and
	        // JSON.parse(null) === null, so this returns null.
	        return JSON.parse(store.getItem(key));
	    } catch (e) {
	        debuglog("Failed to get key %s: %s", key, e);
	        debuglog(e.stack);
	    }
	    return null;
	}
	
	function setJsonItem(store, key, val) {
	    store.setItem(key, JSON.stringify(val));
	}
	
	function debuglog() {
	    if (DEBUG) {
	        var _console;
	
	        (_console = console).log.apply(_console, arguments);
	    }
	}
	
	/** */
	module.exports = WebStorageSessionStore;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is an internal module.
	 * @module store/stub
	 */
	
	/**
	 * Construct a stub store. This does no-ops on most store methods.
	 * @constructor
	 */
	function StubStore() {
	  this.fromToken = null;
	}
	
	StubStore.prototype = {
	
	  /**
	   * Get the sync token.
	   * @return {string}
	   */
	  getSyncToken: function getSyncToken() {
	    return this.fromToken;
	  },
	
	  /**
	   * Set the sync token.
	   * @param {string} token
	   */
	  setSyncToken: function setSyncToken(token) {
	    this.fromToken = token;
	  },
	
	  /**
	   * No-op.
	   * @param {Room} room
	   */
	  storeRoom: function storeRoom(room) {},
	
	  /**
	   * No-op.
	   * @param {string} roomId
	   * @return {null}
	   */
	  getRoom: function getRoom(roomId) {
	    return null;
	  },
	
	  /**
	   * No-op.
	   * @return {Array} An empty array.
	   */
	  getRooms: function getRooms() {
	    return [];
	  },
	
	  /**
	   * Permanently delete a room.
	   * @param {string} roomId
	   */
	  removeRoom: function removeRoom(roomId) {
	    return;
	  },
	
	  /**
	   * No-op.
	   * @return {Array} An empty array.
	   */
	  getRoomSummaries: function getRoomSummaries() {
	    return [];
	  },
	
	  /**
	   * No-op.
	   * @param {User} user
	   */
	  storeUser: function storeUser(user) {},
	
	  /**
	   * No-op.
	   * @param {string} userId
	   * @return {null}
	   */
	  getUser: function getUser(userId) {
	    return null;
	  },
	
	  /**
	   * No-op.
	   * @return {User[]}
	   */
	  getUsers: function getUsers() {
	    return [];
	  },
	
	  /**
	   * No-op.
	   * @param {Room} room
	   * @param {integer} limit
	   * @return {Array}
	   */
	  scrollback: function scrollback(room, limit) {
	    return [];
	  },
	
	  /**
	   * Store events for a room.
	   * @param {Room} room The room to store events for.
	   * @param {Array<MatrixEvent>} events The events to store.
	   * @param {string} token The token associated with these events.
	   * @param {boolean} toStart True if these are paginated results.
	   */
	  storeEvents: function storeEvents(room, events, token, toStart) {},
	
	  /**
	   * Store a filter.
	   * @param {Filter} filter
	   */
	  storeFilter: function storeFilter(filter) {},
	
	  /**
	   * Retrieve a filter.
	   * @param {string} userId
	   * @param {string} filterId
	   * @return {?Filter} A filter or null.
	   */
	  getFilter: function getFilter(userId, filterId) {
	    return null;
	  },
	
	  /**
	   * Retrieve a filter ID with the given name.
	   * @param {string} filterName The filter name.
	   * @return {?string} The filter ID or null.
	   */
	  getFilterIdByName: function getFilterIdByName(filterName) {
	    return null;
	  },
	
	  /**
	   * Set a filter name to ID mapping.
	   * @param {string} filterName
	   * @param {string} filterId
	   */
	  setFilterIdByName: function setFilterIdByName(filterName, filterId) {},
	
	  /**
	   * Store user-scoped account data events
	   * @param {Array<MatrixEvent>} events The events to store.
	   */
	  storeAccountDataEvents: function storeAccountDataEvents(events) {},
	
	  /**
	   * Get account data event by event type
	   * @param {string} eventType The event type being queried
	   */
	  getAccountData: function getAccountData(eventType) {},
	
	  /**
	   * setSyncData does nothing as there is no backing data store.
	   *
	   * @param {Object} syncData The sync data
	   * @return {Promise} An immediately resolved promise.
	   */
	  setSyncData: function setSyncData(syncData) {
	    return (0, _q2.default)();
	  },
	
	  /**
	   * Save does nothing as there is no backing data store.
	   */
	  save: function save() {},
	
	  /**
	   * Startup does nothing.
	   * @return {Promise} An immediately resolved promise.
	   */
	  startup: function startup() {
	    return (0, _q2.default)();
	  },
	
	  /**
	   * @return {Promise} Resolves with a sync response to restore the
	   * client state to where it was at the last save, or null if there
	   * is no saved sync data.
	   */
	  getSavedSync: function getSavedSync() {
	    return (0, _q2.default)(null);
	  },
	
	  /**
	   * Delete all data from this store. Does nothing since this store
	   * doesn't store anything.
	   * @return {Promise} An immediately resolved promise.
	   */
	  deleteAllData: function deleteAllData() {
	    return (0, _q2.default)();
	  }
	};
	
	/** Stub Store class. */
	module.exports = StubStore;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/*
	 * TODO:
	 * This class mainly serves to take all the syncing logic out of client.js and
	 * into a separate file. It's all very fluid, and this class gut wrenches a lot
	 * of MatrixClient props (e.g. _http). Given we want to support WebSockets as
	 * an alternative syncing API, we may want to have a proper syncing interface
	 * for HTTP and WS at some point.
	 */
	
	var q = __webpack_require__(6);
	var User = __webpack_require__(217);
	var Room = __webpack_require__(491);
	var utils = __webpack_require__(16);
	var Filter = __webpack_require__(323);
	var EventTimeline = __webpack_require__(115);
	
	var DEBUG = true;
	
	// /sync requests allow you to set a timeout= but the request may continue
	// beyond that and wedge forever, so we need to track how long we are willing
	// to keep open the connection. This constant is *ADDED* to the timeout= value
	// to determine the max time we're willing to wait.
	var BUFFER_PERIOD_MS = 80 * 1000;
	
	// Number of consecutive failed syncs that will lead to a syncState of ERROR as opposed
	// to RECONNECTING. This is needed to inform the client of server issues when the
	// keepAlive is successful but the server /sync fails.
	var FAILED_SYNC_ERROR_THRESHOLD = 3;
	
	function getFilterName(userId, suffix) {
	    // scope this on the user ID because people may login on many accounts
	    // and they all need to be stored!
	    return "FILTER_SYNC_" + userId + (suffix ? "_" + suffix : "");
	}
	
	function debuglog() {
	    var _console;
	
	    if (!DEBUG) {
	        return;
	    }
	    (_console = console).log.apply(_console, arguments);
	}
	
	/**
	 * <b>Internal class - unstable.</b>
	 * Construct an entity which is able to sync with a homeserver.
	 * @constructor
	 * @param {MatrixClient} client The matrix client instance to use.
	 * @param {Object} opts Config options
	 * @param {module:crypto=} opts.crypto Crypto manager
	 * @param {Function=} opts.canResetEntireTimeline A function which is called
	 * with a room ID and returns a boolean. It should return 'true' if the SDK can
	 * SAFELY remove events from this room. It may not be safe to remove events if
	 * there are other references to the timelines for this room.
	 * Default: returns false.
	 */
	function SyncApi(client, opts) {
	    this.client = client;
	    opts = opts || {};
	    opts.initialSyncLimit = opts.initialSyncLimit === undefined ? 8 : opts.initialSyncLimit;
	    opts.resolveInvitesToProfiles = opts.resolveInvitesToProfiles || false;
	    opts.pollTimeout = opts.pollTimeout || 30 * 1000;
	    opts.pendingEventOrdering = opts.pendingEventOrdering || "chronological";
	    if (!opts.canResetEntireTimeline) {
	        opts.canResetEntireTimeline = function (roomId) {
	            return false;
	        };
	    }
	    this.opts = opts;
	    this._peekRoomId = null;
	    this._currentSyncRequest = null;
	    this._syncState = null;
	    this._catchingUp = false;
	    this._running = false;
	    this._keepAliveTimer = null;
	    this._connectionReturnedDefer = null;
	    this._notifEvents = []; // accumulator of sync events in the current sync response
	    this._failedSyncCount = 0; // Number of consecutive failed /sync requests
	
	    if (client.getNotifTimelineSet()) {
	        reEmit(client, client.getNotifTimelineSet(), ["Room.timeline", "Room.timelineReset"]);
	    }
	}
	
	/**
	 * @param {string} roomId
	 * @return {Room}
	 */
	SyncApi.prototype.createRoom = function (roomId) {
	    var client = this.client;
	    var room = new Room(roomId, {
	        pendingEventOrdering: this.opts.pendingEventOrdering,
	        timelineSupport: client.timelineSupport
	    });
	    reEmit(client, room, ["Room.name", "Room.timeline", "Room.redaction", "Room.receipt", "Room.tags", "Room.timelineReset", "Room.localEchoUpdated", "Room.accountData"]);
	    this._registerStateListeners(room);
	    return room;
	};
	
	/**
	 * @param {Room} room
	 * @private
	 */
	SyncApi.prototype._registerStateListeners = function (room) {
	    var client = this.client;
	    // we need to also re-emit room state and room member events, so hook it up
	    // to the client now. We need to add a listener for RoomState.members in
	    // order to hook them correctly. (TODO: find a better way?)
	    reEmit(client, room.currentState, ["RoomState.events", "RoomState.members", "RoomState.newMember"]);
	    room.currentState.on("RoomState.newMember", function (event, state, member) {
	        member.user = client.getUser(member.userId);
	        reEmit(client, member, ["RoomMember.name", "RoomMember.typing", "RoomMember.powerLevel", "RoomMember.membership"]);
	    });
	};
	
	/**
	 * @param {Room} room
	 * @private
	 */
	SyncApi.prototype._deregisterStateListeners = function (room) {
	    // could do with a better way of achieving this.
	    room.currentState.removeAllListeners("RoomState.events");
	    room.currentState.removeAllListeners("RoomState.members");
	    room.currentState.removeAllListeners("RoomState.newMember");
	};
	
	/**
	 * Sync rooms the user has left.
	 * @return {Promise} Resolved when they've been added to the store.
	 */
	SyncApi.prototype.syncLeftRooms = function () {
	    var client = this.client;
	    var self = this;
	
	    // grab a filter with limit=1 and include_leave=true
	    var filter = new Filter(this.client.credentials.userId);
	    filter.setTimelineLimit(1);
	    filter.setIncludeLeaveRooms(true);
	
	    var localTimeoutMs = this.opts.pollTimeout + BUFFER_PERIOD_MS;
	    var qps = {
	        timeout: 0 };
	
	    return client.getOrCreateFilter(getFilterName(client.credentials.userId, "LEFT_ROOMS"), filter).then(function (filterId) {
	        qps.filter = filterId;
	        return client._http.authedRequest(undefined, "GET", "/sync", qps, undefined, localTimeoutMs);
	    }).then(function (data) {
	        var leaveRooms = [];
	        if (data.rooms && data.rooms.leave) {
	            leaveRooms = self._mapSyncResponseToRoomArray(data.rooms.leave);
	        }
	        var rooms = [];
	        leaveRooms.forEach(function (leaveObj) {
	            var room = leaveObj.room;
	            rooms.push(room);
	            if (!leaveObj.isBrandNewRoom) {
	                // the intention behind syncLeftRooms is to add in rooms which were
	                // *omitted* from the initial /sync. Rooms the user were joined to
	                // but then left whilst the app is running will appear in this list
	                // and we do not want to bother with them since they will have the
	                // current state already (and may get dupe messages if we add
	                // yet more timeline events!), so skip them.
	                // NB: When we persist rooms to localStorage this will be more
	                //     complicated...
	                return;
	            }
	            leaveObj.timeline = leaveObj.timeline || {};
	            var timelineEvents = self._mapSyncEventsFormat(leaveObj.timeline, room);
	            var stateEvents = self._mapSyncEventsFormat(leaveObj.state, room);
	
	            // set the back-pagination token. Do this *before* adding any
	            // events so that clients can start back-paginating.
	            room.getLiveTimeline().setPaginationToken(leaveObj.timeline.prev_batch, EventTimeline.BACKWARDS);
	
	            self._processRoomEvents(room, stateEvents, timelineEvents);
	
	            room.recalculate(client.credentials.userId);
	            client.store.storeRoom(room);
	            client.emit("Room", room);
	        });
	        return rooms;
	    });
	};
	
	/**
	 * Peek into a room. This will result in the room in question being synced so it
	 * is accessible via getRooms(). Live updates for the room will be provided.
	 * @param {string} roomId The room ID to peek into.
	 * @return {Promise} A promise which resolves once the room has been added to the
	 * store.
	 */
	SyncApi.prototype.peek = function (roomId) {
	    var self = this;
	    var client = this.client;
	    this._peekRoomId = roomId;
	    return this.client.roomInitialSync(roomId, 20).then(function (response) {
	        // make sure things are init'd
	        response.messages = response.messages || {};
	        response.messages.chunk = response.messages.chunk || [];
	        response.state = response.state || [];
	
	        var peekRoom = self.createRoom(roomId);
	
	        // FIXME: Mostly duplicated from _processRoomEvents but not entirely
	        // because "state" in this API is at the BEGINNING of the chunk
	        var oldStateEvents = utils.map(utils.deepCopy(response.state), client.getEventMapper());
	        var stateEvents = utils.map(response.state, client.getEventMapper());
	        var messages = utils.map(response.messages.chunk, client.getEventMapper());
	
	        // XXX: copypasted from /sync until we kill off this
	        // minging v1 API stuff)
	        // handle presence events (User objects)
	        if (response.presence && utils.isArray(response.presence)) {
	            response.presence.map(client.getEventMapper()).forEach(function (presenceEvent) {
	                var user = client.store.getUser(presenceEvent.getContent().user_id);
	                if (user) {
	                    user.setPresenceEvent(presenceEvent);
	                } else {
	                    user = createNewUser(client, presenceEvent.getContent().user_id);
	                    user.setPresenceEvent(presenceEvent);
	                    client.store.storeUser(user);
	                }
	                client.emit("event", presenceEvent);
	            });
	        }
	
	        // set the pagination token before adding the events in case people
	        // fire off pagination requests in response to the Room.timeline
	        // events.
	        if (response.messages.start) {
	            peekRoom.oldState.paginationToken = response.messages.start;
	        }
	
	        // set the state of the room to as it was after the timeline executes
	        peekRoom.oldState.setStateEvents(oldStateEvents);
	        peekRoom.currentState.setStateEvents(stateEvents);
	
	        self._resolveInvites(peekRoom);
	        peekRoom.recalculate(self.client.credentials.userId);
	
	        // roll backwards to diverge old state. addEventsToTimeline
	        // will overwrite the pagination token, so make sure it overwrites
	        // it with the right thing.
	        peekRoom.addEventsToTimeline(messages.reverse(), true, peekRoom.getLiveTimeline(), response.messages.start);
	
	        client.store.storeRoom(peekRoom);
	        client.emit("Room", peekRoom);
	
	        self._peekPoll(roomId);
	        return peekRoom;
	    });
	};
	
	/**
	 * Stop polling for updates in the peeked room. NOPs if there is no room being
	 * peeked.
	 */
	SyncApi.prototype.stopPeeking = function () {
	    this._peekRoomId = null;
	};
	
	/**
	 * Do a peek room poll.
	 * @param {string} roomId
	 * @param {string} token from= token
	 */
	SyncApi.prototype._peekPoll = function (roomId, token) {
	    if (this._peekRoomId !== roomId) {
	        debuglog("Stopped peeking in room %s", roomId);
	        return;
	    }
	
	    var self = this;
	    // FIXME: gut wrenching; hard-coded timeout values
	    this.client._http.authedRequest(undefined, "GET", "/events", {
	        room_id: roomId,
	        timeout: 30 * 1000,
	        from: token
	    }, undefined, 50 * 1000).done(function (res) {
	        // We have a problem that we get presence both from /events and /sync
	        // however, /sync only returns presence for users in rooms
	        // you're actually joined to.
	        // in order to be sure to get presence for all of the users in the
	        // peeked room, we handle presence explicitly here. This may result
	        // in duplicate presence events firing for some users, which is a
	        // performance drain, but such is life.
	        // XXX: copypasted from /sync until we can kill this minging v1 stuff.
	
	        res.chunk.filter(function (e) {
	            return e.type === "m.presence";
	        }).map(self.client.getEventMapper()).forEach(function (presenceEvent) {
	            var user = self.client.store.getUser(presenceEvent.getContent().user_id);
	            if (user) {
	                user.setPresenceEvent(presenceEvent);
	            } else {
	                user = createNewUser(self.client, presenceEvent.getContent().user_id);
	                user.setPresenceEvent(presenceEvent);
	                self.client.store.storeUser(user);
	            }
	            self.client.emit("event", presenceEvent);
	        });
	
	        // strip out events which aren't for the given room_id (e.g presence)
	        var events = res.chunk.filter(function (e) {
	            return e.room_id === roomId;
	        }).map(self.client.getEventMapper());
	        var room = self.client.getRoom(roomId);
	        room.addLiveEvents(events);
	        self._peekPoll(roomId, res.end);
	    }, function (err) {
	        console.error("[%s] Peek poll failed: %s", roomId, err);
	        setTimeout(function () {
	            self._peekPoll(roomId, token);
	        }, 30 * 1000);
	    });
	};
	
	/**
	 * Returns the current state of this sync object
	 * @see module:client~MatrixClient#event:"sync"
	 * @return {?String}
	 */
	SyncApi.prototype.getSyncState = function () {
	    return this._syncState;
	};
	
	/**
	 * Main entry point
	 */
	SyncApi.prototype.sync = function () {
	    var client = this.client;
	    var self = this;
	
	    this._running = true;
	
	    if (global.document) {
	        this._onOnlineBound = this._onOnline.bind(this);
	        global.document.addEventListener("online", this._onOnlineBound, false);
	    }
	
	    // We need to do one-off checks before we can begin the /sync loop.
	    // These are:
	    //   1) We need to get push rules so we can check if events should bing as we get
	    //      them from /sync.
	    //   2) We need to get/create a filter which we can use for /sync.
	
	    function getPushRules() {
	        client.getPushRules().done(function (result) {
	            debuglog("Got push rules");
	            client.pushRules = result;
	            getFilter(); // Now get the filter
	        }, function (err) {
	            self._startKeepAlives().done(function () {
	                getPushRules();
	            });
	            self._updateSyncState("ERROR", { error: err });
	        });
	    }
	
	    function getFilter() {
	        var filter = void 0;
	        if (self.opts.filter) {
	            filter = self.opts.filter;
	        } else {
	            filter = new Filter(client.credentials.userId);
	            filter.setTimelineLimit(self.opts.initialSyncLimit);
	        }
	
	        client.getOrCreateFilter(getFilterName(client.credentials.userId), filter).done(function (filterId) {
	            // reset the notifications timeline to prepare it to paginate from
	            // the current point in time.
	            // The right solution would be to tie /sync pagination tokens into
	            // /notifications API somehow.
	            client.resetNotifTimelineSet();
	
	            self._sync({ filterId: filterId });
	        }, function (err) {
	            self._startKeepAlives().done(function () {
	                getFilter();
	            });
	            self._updateSyncState("ERROR", { error: err });
	        });
	    }
	
	    if (client.isGuest()) {
	        // no push rules for guests, no access to POST filter for guests.
	        self._sync({});
	    } else {
	        getPushRules();
	    }
	};
	
	/**
	 * Stops the sync object from syncing.
	 */
	SyncApi.prototype.stop = function () {
	    debuglog("SyncApi.stop");
	    if (global.document) {
	        global.document.removeEventListener("online", this._onOnlineBound, false);
	        this._onOnlineBound = undefined;
	    }
	    this._running = false;
	    if (this._currentSyncRequest) {
	        this._currentSyncRequest.abort();
	    }
	    if (this._keepAliveTimer) {
	        clearTimeout(this._keepAliveTimer);
	        this._keepAliveTimer = null;
	    }
	};
	
	/**
	 * Retry a backed off syncing request immediately. This should only be used when
	 * the user <b>explicitly</b> attempts to retry their lost connection.
	 * @return {boolean} True if this resulted in a request being retried.
	 */
	SyncApi.prototype.retryImmediately = function () {
	    if (!this._connectionReturnedDefer) {
	        return false;
	    }
	    this._startKeepAlives(0);
	    return true;
	};
	
	/**
	 * Invoke me to do /sync calls
	 * @param {Object} syncOptions
	 * @param {string} syncOptions.filterId
	 * @param {boolean} syncOptions.hasSyncedBefore
	 */
	SyncApi.prototype._sync = function (syncOptions) {
	    var _this = this;
	
	    var client = this.client;
	    var self = this;
	
	    if (!this._running) {
	        debuglog("Sync no longer running: exiting.");
	        if (self._connectionReturnedDefer) {
	            self._connectionReturnedDefer.reject();
	            self._connectionReturnedDefer = null;
	        }
	        this._updateSyncState("STOPPED");
	        return;
	    }
	
	    var filterId = syncOptions.filterId;
	    if (client.isGuest() && !filterId) {
	        filterId = this._getGuestFilter();
	    }
	
	    var syncToken = client.store.getSyncToken();
	
	    var pollTimeout = this.opts.pollTimeout;
	
	    if (this.getSyncState() !== 'SYNCING' || this._catchingUp) {
	        // unless we are happily syncing already, we want the server to return
	        // as quickly as possible, even if there are no events queued. This
	        // serves two purposes:
	        //
	        // * When the connection dies, we want to know asap when it comes back,
	        //   so that we can hide the error from the user. (We don't want to
	        //   have to wait for an event or a timeout).
	        //
	        // * We want to know if the server has any to_device messages queued up
	        //   for us. We do that by calling it with a zero timeout until it
	        //   doesn't give us any more to_device messages.
	        this._catchingUp = true;
	        pollTimeout = 0;
	    }
	
	    // normal timeout= plus buffer time
	    var clientSideTimeoutMs = pollTimeout + BUFFER_PERIOD_MS;
	
	    var qps = {
	        filter: filterId,
	        timeout: pollTimeout
	    };
	
	    if (syncToken) {
	        qps.since = syncToken;
	    } else {
	        // use a cachebuster for initialsyncs, to make sure that
	        // we don't get a stale sync
	        // (https://github.com/vector-im/vector-web/issues/1354)
	        qps._cacheBuster = Date.now();
	    }
	
	    if (this.getSyncState() == 'ERROR' || this.getSyncState() == 'RECONNECTING') {
	        // we think the connection is dead. If it comes back up, we won't know
	        // about it till /sync returns. If the timeout= is high, this could
	        // be a long time. Set it to 0 when doing retries so we don't have to wait
	        // for an event or a timeout before emiting the SYNCING event.
	        qps.timeout = 0;
	    }
	
	    var isCachedResponse = false;
	
	    var syncPromise = void 0;
	    if (!syncOptions.hasSyncedBefore) {
	        // Don't do an HTTP hit to /sync. Instead, load up the persisted /sync data,
	        // if there is data there.
	        syncPromise = client.store.getSavedSync();
	    } else {
	        syncPromise = q(null);
	    }
	
	    syncPromise.then(function (savedSync) {
	        if (savedSync) {
	            debuglog("sync(): not doing HTTP hit, instead returning stored /sync data");
	            isCachedResponse = true;
	            return {
	                next_batch: savedSync.nextBatch,
	                rooms: savedSync.roomsData,
	                account_data: {
	                    events: savedSync.accountData
	                }
	            };
	        } else {
	            //debuglog('Starting sync since=' + syncToken);
	            _this._currentSyncRequest = client._http.authedRequest(undefined, "GET", "/sync", qps, undefined, clientSideTimeoutMs);
	            return _this._currentSyncRequest;
	        }
	    }).then(function (data) {
	        //debuglog('Completed sync, next_batch=' + data.next_batch);
	
	        // set the sync token NOW *before* processing the events. We do this so
	        // if something barfs on an event we can skip it rather than constantly
	        // polling with the same token.
	        client.store.setSyncToken(data.next_batch);
	
	        // Reset after a successful sync
	        self._failedSyncCount = 0;
	
	        // We need to wait until the sync data has been sent to the backend
	        // because it appears that the sync data gets modified somewhere in
	        // processing it in such a way as to make it no longer cloneable.
	        // XXX: Find out what is modifying it!
	        if (!isCachedResponse) {
	            // Don't give the store back its own cached data
	            return client.store.setSyncData(data).then(function () {
	                return data;
	            });
	        } else {
	            return q(data);
	        }
	    }).done(function (data) {
	        try {
	            self._processSyncResponse(syncToken, data);
	        } catch (e) {
	            // log the exception with stack if we have it, else fall back
	            // to the plain description
	            console.error("Caught /sync error", e.stack || e);
	        }
	
	        // emit synced events
	        var syncEventData = {
	            oldSyncToken: syncToken,
	            nextSyncToken: data.next_batch,
	            catchingUp: self._catchingUp
	        };
	
	        if (!syncOptions.hasSyncedBefore) {
	            self._updateSyncState("PREPARED", syncEventData);
	            syncOptions.hasSyncedBefore = true;
	        }
	
	        // keep emitting SYNCING -> SYNCING for clients who want to do bulk updates
	        if (!isCachedResponse) {
	            self._updateSyncState("SYNCING", syncEventData);
	
	            // tell databases that everything is now in a consistent state and can be
	            // saved (no point doing so if we only have the data we just got out of the
	            // store).
	            client.store.save();
	        }
	
	        // Begin next sync
	        self._sync(syncOptions);
	    }, function (err) {
	        if (!self._running) {
	            debuglog("Sync no longer running: exiting");
	            if (self._connectionReturnedDefer) {
	                self._connectionReturnedDefer.reject();
	                self._connectionReturnedDefer = null;
	            }
	            self._updateSyncState("STOPPED");
	            return;
	        }
	        console.error("/sync error %s", err);
	        console.error(err);
	
	        self._failedSyncCount++;
	        console.log('Number of consecutive failed sync requests:', self._failedSyncCount);
	
	        debuglog("Starting keep-alive");
	        // Note that we do *not* mark the sync connection as
	        // lost yet: we only do this if a keepalive poke
	        // fails, since long lived HTTP connections will
	        // go away sometimes and we shouldn't treat this as
	        // erroneous. We set the state to 'reconnecting'
	        // instead, so that clients can onserve this state
	        // if they wish.
	        self._startKeepAlives().done(function () {
	            self._sync(syncOptions);
	        });
	        self._currentSyncRequest = null;
	        // Transition from RECONNECTING to ERROR after a given number of failed syncs
	        self._updateSyncState(self._failedSyncCount >= FAILED_SYNC_ERROR_THRESHOLD ? "ERROR" : "RECONNECTING");
	    });
	};
	
	/**
	 * Process data returned from a sync response and propagate it
	 * into the model objects
	 *
	 * @param {string} syncToken the old next_batch token sent to this
	 *    sync request.
	 * @param {Object} data The response from /sync
	 */
	SyncApi.prototype._processSyncResponse = function (syncToken, data) {
	    var _this2 = this;
	
	    var client = this.client;
	    var self = this;
	
	    // data looks like:
	    // {
	    //    next_batch: $token,
	    //    presence: { events: [] },
	    //    account_data: { events: [] },
	    //    device_lists: { changed: ["@user:server", ... ]},
	    //    to_device: { events: [] },
	    //    rooms: {
	    //      invite: {
	    //        $roomid: {
	    //          invite_state: { events: [] }
	    //        }
	    //      },
	    //      join: {
	    //        $roomid: {
	    //          state: { events: [] },
	    //          timeline: { events: [], prev_batch: $token, limited: true },
	    //          ephemeral: { events: [] },
	    //          account_data: { events: [] },
	    //          unread_notifications: {
	    //              highlight_count: 0,
	    //              notification_count: 0,
	    //          }
	    //        }
	    //      },
	    //      leave: {
	    //        $roomid: {
	    //          state: { events: [] },
	    //          timeline: { events: [], prev_batch: $token }
	    //        }
	    //      }
	    //    },
	    // }
	
	    // TODO-arch:
	    // - Each event we pass through needs to be emitted via 'event', can we
	    //   do this in one place?
	    // - The isBrandNewRoom boilerplate is boilerplatey.
	
	    // handle presence events (User objects)
	    if (data.presence && utils.isArray(data.presence.events)) {
	        data.presence.events.map(client.getEventMapper()).forEach(function (presenceEvent) {
	            var user = client.store.getUser(presenceEvent.getSender());
	            if (user) {
	                user.setPresenceEvent(presenceEvent);
	            } else {
	                user = createNewUser(client, presenceEvent.getSender());
	                user.setPresenceEvent(presenceEvent);
	                client.store.storeUser(user);
	            }
	            client.emit("event", presenceEvent);
	        });
	    }
	
	    // handle non-room account_data
	    if (data.account_data && utils.isArray(data.account_data.events)) {
	        var events = data.account_data.events.map(client.getEventMapper());
	        client.store.storeAccountDataEvents(events);
	        events.forEach(function (accountDataEvent) {
	            if (accountDataEvent.getType() == 'm.push_rules') {
	                client.pushRules = accountDataEvent.getContent();
	            }
	            client.emit("accountData", accountDataEvent);
	            return accountDataEvent;
	        });
	    }
	
	    // handle to-device events
	    if (data.to_device && utils.isArray(data.to_device.events) && data.to_device.events.length > 0) {
	        data.to_device.events.map(client.getEventMapper()).forEach(function (toDeviceEvent) {
	            var content = toDeviceEvent.getContent();
	            if (toDeviceEvent.getType() == "m.room.message" && content.msgtype == "m.bad.encrypted") {
	                // the mapper already logged a warning.
	                console.log('Ignoring undecryptable to-device event from ' + toDeviceEvent.getSender());
	                return;
	            }
	
	            client.emit("toDeviceEvent", toDeviceEvent);
	        });
	    } else {
	        // no more to-device events: we can stop polling with a short timeout.
	        this._catchingUp = false;
	    }
	
	    // the returned json structure is a bit crap, so make it into a
	    // nicer form (array) after applying sanity to make sure we don't fail
	    // on missing keys (on the off chance)
	    var inviteRooms = [];
	    var joinRooms = [];
	    var leaveRooms = [];
	
	    if (data.rooms) {
	        if (data.rooms.invite) {
	            inviteRooms = this._mapSyncResponseToRoomArray(data.rooms.invite);
	        }
	        if (data.rooms.join) {
	            joinRooms = this._mapSyncResponseToRoomArray(data.rooms.join);
	        }
	        if (data.rooms.leave) {
	            leaveRooms = this._mapSyncResponseToRoomArray(data.rooms.leave);
	        }
	    }
	
	    this._notifEvents = [];
	
	    // Handle invites
	    inviteRooms.forEach(function (inviteObj) {
	        var room = inviteObj.room;
	        var stateEvents = self._mapSyncEventsFormat(inviteObj.invite_state, room);
	        self._processRoomEvents(room, stateEvents);
	        if (inviteObj.isBrandNewRoom) {
	            room.recalculate(client.credentials.userId);
	            client.store.storeRoom(room);
	            client.emit("Room", room);
	        }
	        stateEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	    });
	
	    // Handle joins
	    joinRooms.forEach(function (joinObj) {
	        var room = joinObj.room;
	        var stateEvents = self._mapSyncEventsFormat(joinObj.state, room);
	        var timelineEvents = self._mapSyncEventsFormat(joinObj.timeline, room);
	        var ephemeralEvents = self._mapSyncEventsFormat(joinObj.ephemeral);
	        var accountDataEvents = self._mapSyncEventsFormat(joinObj.account_data);
	
	        // we do this first so it's correct when any of the events fire
	        if (joinObj.unread_notifications) {
	            room.setUnreadNotificationCount('total', joinObj.unread_notifications.notification_count);
	            room.setUnreadNotificationCount('highlight', joinObj.unread_notifications.highlight_count);
	        }
	
	        joinObj.timeline = joinObj.timeline || {};
	
	        if (joinObj.isBrandNewRoom) {
	            // set the back-pagination token. Do this *before* adding any
	            // events so that clients can start back-paginating.
	            room.getLiveTimeline().setPaginationToken(joinObj.timeline.prev_batch, EventTimeline.BACKWARDS);
	        } else if (joinObj.timeline.limited) {
	            var limited = true;
	
	            // we've got a limited sync, so we *probably* have a gap in the
	            // timeline, so should reset. But we might have been peeking or
	            // paginating and already have some of the events, in which
	            // case we just want to append any subsequent events to the end
	            // of the existing timeline.
	            //
	            // This is particularly important in the case that we already have
	            // *all* of the events in the timeline - in that case, if we reset
	            // the timeline, we'll end up with an entirely empty timeline,
	            // which we'll try to paginate but not get any new events (which
	            // will stop us linking the empty timeline into the chain).
	            //
	            for (var i = timelineEvents.length - 1; i >= 0; i--) {
	                var eventId = timelineEvents[i].getId();
	                if (room.getTimelineForEvent(eventId)) {
	                    debuglog("Already have event " + eventId + " in limited " + "sync - not resetting");
	                    limited = false;
	
	                    // we might still be missing some of the events before i;
	                    // we don't want to be adding them to the end of the
	                    // timeline because that would put them out of order.
	                    timelineEvents.splice(0, i);
	
	                    // XXX: there's a problem here if the skipped part of the
	                    // timeline modifies the state set in stateEvents, because
	                    // we'll end up using the state from stateEvents rather
	                    // than the later state from timelineEvents. We probably
	                    // need to wind stateEvents forward over the events we're
	                    // skipping.
	
	                    break;
	                }
	            }
	
	            if (limited) {
	                // save the old 'next_batch' token as the
	                // forward-pagination token for the previously-active
	                // timeline.
	                room.currentState.paginationToken = syncToken;
	                self._deregisterStateListeners(room);
	                room.resetLiveTimeline(joinObj.timeline.prev_batch, self.opts.canResetEntireTimeline(room.roomId));
	
	                // We have to assume any gap in any timeline is
	                // reason to stop incrementally tracking notifications and
	                // reset the timeline.
	                client.resetNotifTimelineSet();
	
	                self._registerStateListeners(room);
	            }
	        }
	
	        self._processRoomEvents(room, stateEvents, timelineEvents);
	
	        // XXX: should we be adding ephemeralEvents to the timeline?
	        // It feels like that for symmetry with room.addAccountData()
	        // there should be a room.addEphemeralEvents() or similar.
	        room.addLiveEvents(ephemeralEvents);
	
	        // we deliberately don't add accountData to the timeline
	        room.addAccountData(accountDataEvents);
	
	        room.recalculate(client.credentials.userId);
	        if (joinObj.isBrandNewRoom) {
	            client.store.storeRoom(room);
	            client.emit("Room", room);
	        }
	        stateEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	        timelineEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	        ephemeralEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	        accountDataEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	    });
	
	    // Handle leaves (e.g. kicked rooms)
	    leaveRooms.forEach(function (leaveObj) {
	        var room = leaveObj.room;
	        var stateEvents = self._mapSyncEventsFormat(leaveObj.state, room);
	        var timelineEvents = self._mapSyncEventsFormat(leaveObj.timeline, room);
	        var accountDataEvents = self._mapSyncEventsFormat(leaveObj.account_data);
	
	        self._processRoomEvents(room, stateEvents, timelineEvents);
	        room.addAccountData(accountDataEvents);
	
	        room.recalculate(client.credentials.userId);
	        if (leaveObj.isBrandNewRoom) {
	            client.store.storeRoom(room);
	            client.emit("Room", room);
	        }
	
	        stateEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	        timelineEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	        accountDataEvents.forEach(function (e) {
	            client.emit("event", e);
	        });
	    });
	
	    // update the notification timeline, if appropriate.
	    // we only do this for live events, as otherwise we can't order them sanely
	    // in the timeline relative to ones paginated in by /notifications.
	    // XXX: we could fix this by making EventTimeline support chronological
	    // ordering... but it doesn't, right now.
	    if (syncToken && this._notifEvents.length) {
	        this._notifEvents.sort(function (a, b) {
	            return a.getTs() - b.getTs();
	        });
	        this._notifEvents.forEach(function (event) {
	            client.getNotifTimelineSet().addLiveEvent(event);
	        });
	    }
	
	    // Handle device list updates
	    if (this.opts.crypto && data.device_lists && data.device_lists.changed) {
	        data.device_lists.changed.forEach(function (u) {
	            _this2.opts.crypto.userDeviceListChanged(u);
	        });
	    }
	};
	
	/**
	 * Starts polling the connectivity check endpoint
	 * @param {number} delay How long to delay until the first poll.
	 *        defaults to a short, randomised interval (to prevent
	 *        tightlooping if /versions succeeds but /sync etc. fail).
	 * @return {promise} which resolves once the connection returns
	 */
	SyncApi.prototype._startKeepAlives = function (delay) {
	    if (delay === undefined) {
	        delay = 2000 + Math.floor(Math.random() * 5000);
	    }
	
	    if (this._keepAliveTimer !== null) {
	        clearTimeout(this._keepAliveTimer);
	    }
	    var self = this;
	    if (delay > 0) {
	        self._keepAliveTimer = setTimeout(self._pokeKeepAlive.bind(self), delay);
	    } else {
	        self._pokeKeepAlive();
	    }
	    if (!this._connectionReturnedDefer) {
	        this._connectionReturnedDefer = q.defer();
	    }
	    return this._connectionReturnedDefer.promise;
	};
	
	/**
	 * Make a dummy call to /_matrix/client/versions, to see if the HS is
	 * reachable.
	 *
	 * On failure, schedules a call back to itself. On success, resolves
	 * this._connectionReturnedDefer.
	 */
	SyncApi.prototype._pokeKeepAlive = function () {
	    var self = this;
	    function success() {
	        clearTimeout(self._keepAliveTimer);
	        if (self._connectionReturnedDefer) {
	            self._connectionReturnedDefer.resolve();
	            self._connectionReturnedDefer = null;
	        }
	    }
	
	    this.client._http.request(undefined, // callback
	    "GET", "/_matrix/client/versions", undefined, // queryParams
	    undefined, // data
	    {
	        prefix: '',
	        localTimeoutMs: 15 * 1000
	    }).done(function () {
	        success();
	    }, function (err) {
	        if (err.httpStatus == 400) {
	            // treat this as a success because the server probably just doesn't
	            // support /versions: point is, we're getting a response.
	            // We wait a short time though, just in case somehow the server
	            // is in a mode where it 400s /versions responses and sync etc.
	            // responses fail, this will mean we don't hammer in a loop.
	            self._keepAliveTimer = setTimeout(success, 2000);
	        } else {
	            self._keepAliveTimer = setTimeout(self._pokeKeepAlive.bind(self), 5000 + Math.floor(Math.random() * 5000));
	            // A keepalive has failed, so we emit the
	            // error state (whether or not this is the
	            // first failure).
	            // Note we do this after setting the timer:
	            // this lets the unit tests advance the mock
	            // clock when the get the error.
	            self._updateSyncState("ERROR", { error: err });
	        }
	    });
	};
	
	/**
	 * @param {Object} obj
	 * @return {Object[]}
	 */
	SyncApi.prototype._mapSyncResponseToRoomArray = function (obj) {
	    // Maps { roomid: {stuff}, roomid: {stuff} }
	    // to
	    // [{stuff+Room+isBrandNewRoom}, {stuff+Room+isBrandNewRoom}]
	    var client = this.client;
	    var self = this;
	    return utils.keys(obj).map(function (roomId) {
	        var arrObj = obj[roomId];
	        var room = client.store.getRoom(roomId);
	        var isBrandNewRoom = false;
	        if (!room) {
	            room = self.createRoom(roomId);
	            isBrandNewRoom = true;
	        }
	        arrObj.room = room;
	        arrObj.isBrandNewRoom = isBrandNewRoom;
	        return arrObj;
	    });
	};
	
	/**
	 * @param {Object} obj
	 * @param {Room} room
	 * @return {MatrixEvent[]}
	 */
	SyncApi.prototype._mapSyncEventsFormat = function (obj, room) {
	    if (!obj || !utils.isArray(obj.events)) {
	        return [];
	    }
	    var mapper = this.client.getEventMapper();
	    return obj.events.map(function (e) {
	        if (room) {
	            e.room_id = room.roomId;
	        }
	        return mapper(e);
	    });
	};
	
	/**
	 * @param {Room} room
	 */
	SyncApi.prototype._resolveInvites = function (room) {
	    if (!room || !this.opts.resolveInvitesToProfiles) {
	        return;
	    }
	    var client = this.client;
	    // For each invited room member we want to give them a displayname/avatar url
	    // if they have one (the m.room.member invites don't contain this).
	    room.getMembersWithMembership("invite").forEach(function (member) {
	        if (member._requestedProfileInfo) {
	            return;
	        }
	        member._requestedProfileInfo = true;
	        // try to get a cached copy first.
	        var user = client.getUser(member.userId);
	        var promise = void 0;
	        if (user) {
	            promise = q({
	                avatar_url: user.avatarUrl,
	                displayname: user.displayName
	            });
	        } else {
	            promise = client.getProfileInfo(member.userId);
	        }
	        promise.done(function (info) {
	            // slightly naughty by doctoring the invite event but this means all
	            // the code paths remain the same between invite/join display name stuff
	            // which is a worthy trade-off for some minor pollution.
	            var inviteEvent = member.events.member;
	            if (inviteEvent.getContent().membership !== "invite") {
	                // between resolving and now they have since joined, so don't clobber
	                return;
	            }
	            inviteEvent.getContent().avatar_url = info.avatar_url;
	            inviteEvent.getContent().displayname = info.displayname;
	            // fire listeners
	            member.setMembershipEvent(inviteEvent, room.currentState);
	        }, function (err) {
	            // OH WELL.
	        });
	    });
	};
	
	/**
	 * @param {Room} room
	 * @param {MatrixEvent[]} stateEventList A list of state events. This is the state
	 * at the *START* of the timeline list if it is supplied.
	 * @param {MatrixEvent[]} [timelineEventList] A list of timeline events. Lower index
	 * is earlier in time. Higher index is later.
	 */
	SyncApi.prototype._processRoomEvents = function (room, stateEventList, timelineEventList) {
	    timelineEventList = timelineEventList || [];
	    var client = this.client;
	    // "old" and "current" state are the same initially; they
	    // start diverging if the user paginates.
	    // We must deep copy otherwise membership changes in old state
	    // will leak through to current state!
	    var oldStateEvents = utils.map(utils.deepCopy(stateEventList.map(function (mxEvent) {
	        return mxEvent.event;
	    })), client.getEventMapper());
	    var stateEvents = stateEventList;
	
	    // set the state of the room to as it was before the timeline executes
	    //
	    // XXX: what if we've already seen (some of) the events in the timeline,
	    // and they modify some of the state set in stateEvents? In that case we'll
	    // end up with the state from stateEvents, instead of the more recent state
	    // from the timeline.
	    room.oldState.setStateEvents(oldStateEvents);
	    room.currentState.setStateEvents(stateEvents);
	
	    this._resolveInvites(room);
	
	    // recalculate the room name at this point as adding events to the timeline
	    // may make notifications appear which should have the right name.
	    room.recalculate(this.client.credentials.userId);
	
	    // gather our notifications into this._notifEvents
	    if (client.getNotifTimelineSet()) {
	        for (var i = 0; i < timelineEventList.length; i++) {
	            var pushActions = client.getPushActionsForEvent(timelineEventList[i]);
	            if (pushActions && pushActions.notify && pushActions.tweaks && pushActions.tweaks.highlight) {
	                this._notifEvents.push(timelineEventList[i]);
	            }
	        }
	    }
	
	    // execute the timeline events, this will begin to diverge the current state
	    // if the timeline has any state events in it.
	    room.addLiveEvents(timelineEventList);
	};
	
	/**
	 * @return {string}
	 */
	SyncApi.prototype._getGuestFilter = function () {
	    var guestRooms = this.client._guestRooms; // FIXME: horrible gut-wrenching
	    if (!guestRooms) {
	        return "{}";
	    }
	    // we just need to specify the filter inline if we're a guest because guests
	    // can't create filters.
	    return JSON.stringify({
	        room: {
	            timeline: {
	                limit: 20
	            }
	        }
	    });
	};
	
	/**
	 * Sets the sync state and emits an event to say so
	 * @param {String} newState The new state string
	 * @param {Object} data Object of additional data to emit in the event
	 */
	SyncApi.prototype._updateSyncState = function (newState, data) {
	    var old = this._syncState;
	    this._syncState = newState;
	    this.client.emit("sync", this._syncState, old, data);
	};
	
	/**
	 * Event handler for the 'online' event
	 * This event is generally unreliable and precise behaviour
	 * varies between browsers, so we poll for connectivity too,
	 * but this might help us reconnect a little faster.
	 */
	SyncApi.prototype._onOnline = function () {
	    debuglog("Browser thinks we are back online");
	    this._startKeepAlives(0);
	};
	
	function createNewUser(client, userId) {
	    var user = new User(userId);
	    reEmit(client, user, ["User.avatarUrl", "User.displayName", "User.presence", "User.currentlyActive", "User.lastPresenceTs"]);
	    return user;
	}
	
	function reEmit(reEmitEntity, emittableEntity, eventNames) {
	    utils.forEach(eventNames, function (eventName) {
	        // setup a listener on the entity (the Room, User, etc) for this event
	        emittableEntity.on(eventName, function () {
	            // take the args from the listener and reuse them, adding the
	            // event name to the arg list so it works with .emit()
	            // Transformation Example:
	            // listener on "foo" => function(a,b) { ... }
	            // Re-emit on "thing" => thing.emit("foo", a, b)
	            var newArgs = [eventName];
	            for (var i = 0; i < arguments.length; i++) {
	                newArgs.push(arguments[i]);
	            }
	            reEmitEntity.emit.apply(reEmitEntity, newArgs);
	        });
	    });
	}
	
	/** */
	module.exports = SyncApi;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/** @module timeline-window */
	
	var q = __webpack_require__(6);
	var EventTimeline = __webpack_require__(115);
	
	/**
	 * @private
	 */
	var DEBUG = false;
	
	/**
	 * @private
	 */
	var debuglog = DEBUG ? console.log.bind(console) : function () {};
	
	/**
	 * the number of times we ask the server for more events before giving up
	 *
	 * @private
	 */
	var DEFAULT_PAGINATE_LOOP_LIMIT = 5;
	
	/**
	 * Construct a TimelineWindow.
	 *
	 * <p>This abstracts the separate timelines in a Matrix {@link
	 * module:models/room|Room} into a single iterable thing. It keeps track of
	 * the start and endpoints of the window, which can be advanced with the help
	 * of pagination requests.
	 *
	 * <p>Before the window is useful, it must be initialised by calling {@link
	 * module:timeline-window~TimelineWindow#load|load}.
	 *
	 * <p>Note that the window will not automatically extend itself when new events
	 * are received from /sync; you should arrange to call {@link
	 * module:timeline-window~TimelineWindow#paginate|paginate} on {@link
	 * module:client~MatrixClient.event:"Room.timeline"|Room.timeline} events.
	 *
	 * @param {MatrixClient} client   MatrixClient to be used for context/pagination
	 *   requests.
	 *
	 * @param {EventTimelineSet} timelineSet  The timelineSet to track
	 *
	 * @param {Object} [opts] Configuration options for this window
	 *
	 * @param {number} [opts.windowLimit = 1000] maximum number of events to keep
	 *    in the window. If more events are retrieved via pagination requests,
	 *    excess events will be dropped from the other end of the window.
	 *
	 * @constructor
	 */
	function TimelineWindow(client, timelineSet, opts) {
	    opts = opts || {};
	    this._client = client;
	    this._timelineSet = timelineSet;
	
	    // these will be TimelineIndex objects; they delineate the 'start' and
	    // 'end' of the window.
	    //
	    // _start.index is inclusive; _end.index is exclusive.
	    this._start = null;
	    this._end = null;
	
	    this._eventCount = 0;
	    this._windowLimit = opts.windowLimit || 1000;
	}
	
	/**
	 * Initialise the window to point at a given event, or the live timeline
	 *
	 * @param {string} [initialEventId]   If given, the window will contain the
	 *    given event
	 * @param {number} [initialWindowSize = 20]   Size of the initial window
	 *
	 * @return {module:client.Promise}
	 */
	TimelineWindow.prototype.load = function (initialEventId, initialWindowSize) {
	    var self = this;
	    initialWindowSize = initialWindowSize || 20;
	
	    // given an EventTimeline, and an event index within it, initialise our
	    // fields so that the event in question is in the middle of the window.
	    var initFields = function initFields(timeline, eventIndex) {
	        var endIndex = Math.min(timeline.getEvents().length, eventIndex + Math.ceil(initialWindowSize / 2));
	        var startIndex = Math.max(0, endIndex - initialWindowSize);
	        self._start = new TimelineIndex(timeline, startIndex - timeline.getBaseIndex());
	        self._end = new TimelineIndex(timeline, endIndex - timeline.getBaseIndex());
	        self._eventCount = endIndex - startIndex;
	    };
	
	    // We avoid delaying the resolution of the promise by a reactor tick if
	    // we already have the data we need, which is important to keep room-switching
	    // feeling snappy.
	    //
	    // TODO: ideally we'd spot getEventTimeline returning a resolved promise and
	    // skip straight to the find-event loop.
	    if (initialEventId) {
	        return this._client.getEventTimeline(this._timelineSet, initialEventId).then(function (tl) {
	            // make sure that our window includes the event
	            for (var i = 0; i < tl.getEvents().length; i++) {
	                if (tl.getEvents()[i].getId() == initialEventId) {
	                    initFields(tl, i);
	                    return;
	                }
	            }
	            throw new Error("getEventTimeline result didn't include requested event");
	        });
	    } else {
	        // start with the most recent events
	        var tl = this._timelineSet.getLiveTimeline();
	        initFields(tl, tl.getEvents().length);
	        return q();
	    }
	};
	
	/**
	 * Check if this window can be extended
	 *
	 * <p>This returns true if we either have more events, or if we have a
	 * pagination token which means we can paginate in that direction. It does not
	 * necessarily mean that there are more events available in that direction at
	 * this time.
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to check if we can
	 *   paginate backwards; EventTimeline.FORWARDS to check if we can go forwards
	 *
	 * @return {boolean} true if we can paginate in the given direction
	 */
	TimelineWindow.prototype.canPaginate = function (direction) {
	    var tl = void 0;
	    if (direction == EventTimeline.BACKWARDS) {
	        tl = this._start;
	    } else if (direction == EventTimeline.FORWARDS) {
	        tl = this._end;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	
	    if (!tl) {
	        debuglog("TimelineWindow: no timeline yet");
	        return false;
	    }
	
	    if (direction == EventTimeline.BACKWARDS) {
	        if (tl.index > tl.minIndex()) {
	            return true;
	        }
	    } else {
	        if (tl.index < tl.maxIndex()) {
	            return true;
	        }
	    }
	
	    return Boolean(tl.timeline.getNeighbouringTimeline(direction) || tl.timeline.getPaginationToken(direction));
	};
	
	/**
	 * Attempt to extend the window
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to extend the window
	 *    backwards (towards older events); EventTimeline.FORWARDS to go forwards.
	 *
	 * @param {number} size   number of events to try to extend by. If fewer than this
	 *    number are immediately available, then we return immediately rather than
	 *    making an API call.
	 *
	 * @param {boolean} [makeRequest = true] whether we should make API calls to
	 *    fetch further events if we don't have any at all. (This has no effect if
	 *    the room already knows about additional events in the relevant direction,
	 *    even if there are fewer than 'size' of them, as we will just return those
	 *    we already know about.)
	 *
	 * @param {number} [requestLimit = 5] limit for the number of API requests we
	 *    should make.
	 *
	 * @return {module:client.Promise} Resolves to a boolean which is true if more events
	 *    were successfully retrieved.
	 */
	TimelineWindow.prototype.paginate = function (direction, size, makeRequest, requestLimit) {
	    // Either wind back the message cap (if there are enough events in the
	    // timeline to do so), or fire off a pagination request.
	
	    if (makeRequest === undefined) {
	        makeRequest = true;
	    }
	
	    if (requestLimit === undefined) {
	        requestLimit = DEFAULT_PAGINATE_LOOP_LIMIT;
	    }
	
	    var tl = void 0;
	    if (direction == EventTimeline.BACKWARDS) {
	        tl = this._start;
	    } else if (direction == EventTimeline.FORWARDS) {
	        tl = this._end;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	
	    if (!tl) {
	        debuglog("TimelineWindow: no timeline yet");
	        return q(false);
	    }
	
	    if (tl.pendingPaginate) {
	        return tl.pendingPaginate;
	    }
	
	    // try moving the cap
	    var count = direction == EventTimeline.BACKWARDS ? tl.retreat(size) : tl.advance(size);
	
	    if (count) {
	        this._eventCount += count;
	        debuglog("TimelineWindow: increased cap by " + count + " (now " + this._eventCount + ")");
	        // remove some events from the other end, if necessary
	        var excess = this._eventCount - this._windowLimit;
	        if (excess > 0) {
	            this.unpaginate(excess, direction != EventTimeline.BACKWARDS);
	        }
	        return q(true);
	    }
	
	    if (!makeRequest || requestLimit === 0) {
	        // todo: should we return something different to indicate that there
	        // might be more events out there, but we haven't found them yet?
	        return q(false);
	    }
	
	    // try making a pagination request
	    var token = tl.timeline.getPaginationToken(direction);
	    if (!token) {
	        debuglog("TimelineWindow: no token");
	        return q(false);
	    }
	
	    debuglog("TimelineWindow: starting request");
	    var self = this;
	
	    var prom = this._client.paginateEventTimeline(tl.timeline, {
	        backwards: direction == EventTimeline.BACKWARDS,
	        limit: size
	    }).finally(function () {
	        tl.pendingPaginate = null;
	    }).then(function (r) {
	        debuglog("TimelineWindow: request completed with result " + r);
	        if (!r) {
	            // end of timeline
	            return false;
	        }
	
	        // recurse to advance the index into the results.
	        //
	        // If we don't get any new events, we want to make sure we keep asking
	        // the server for events for as long as we have a valid pagination
	        // token. In particular, we want to know if we've actually hit the
	        // start of the timeline, or if we just happened to know about all of
	        // the events thanks to https://matrix.org/jira/browse/SYN-645.
	        //
	        // On the other hand, we necessarily want to wait forever for the
	        // server to make its mind up about whether there are other events,
	        // because it gives a bad user experience
	        // (https://github.com/vector-im/vector-web/issues/1204).
	        return self.paginate(direction, size, true, requestLimit - 1);
	    });
	    tl.pendingPaginate = prom;
	    return prom;
	};
	
	/**
	 * Remove `delta` events from the start or end of the timeline.
	 *
	 * @param {number}  delta           number of events to remove from the timeline
	 * @param {boolean} startOfTimeline if events should be removed from the start
	 *     of the timeline.
	 */
	TimelineWindow.prototype.unpaginate = function (delta, startOfTimeline) {
	    var tl = startOfTimeline ? this._start : this._end;
	
	    // sanity-check the delta
	    if (delta > this._eventCount || delta < 0) {
	        throw new Error("Attemting to unpaginate " + delta + " events, but " + "only have " + this._eventCount + " in the timeline");
	    }
	
	    while (delta > 0) {
	        var count = startOfTimeline ? tl.advance(delta) : tl.retreat(delta);
	        if (count <= 0) {
	            // sadness. This shouldn't be possible.
	            throw new Error("Unable to unpaginate any further, but still have " + this._eventCount + " events");
	        }
	
	        delta -= count;
	        this._eventCount -= count;
	        debuglog("TimelineWindow.unpaginate: dropped " + count + " (now " + this._eventCount + ")");
	    }
	};
	
	/**
	 * Get a list of the events currently in the window
	 *
	 * @return {MatrixEvent[]} the events in the window
	 */
	TimelineWindow.prototype.getEvents = function () {
	    if (!this._start) {
	        // not yet loaded
	        return [];
	    }
	
	    var result = [];
	
	    // iterate through each timeline between this._start and this._end
	    // (inclusive).
	    var timeline = this._start.timeline;
	    while (true) {
	        var events = timeline.getEvents();
	
	        // For the first timeline in the chain, we want to start at
	        // this._start.index. For the last timeline in the chain, we want to
	        // stop before this._end.index. Otherwise, we want to copy all of the
	        // events in the timeline.
	        //
	        // (Note that both this._start.index and this._end.index are relative
	        // to their respective timelines' BaseIndex).
	        //
	        var startIndex = 0,
	            endIndex = events.length;
	        if (timeline === this._start.timeline) {
	            startIndex = this._start.index + timeline.getBaseIndex();
	        }
	        if (timeline === this._end.timeline) {
	            endIndex = this._end.index + timeline.getBaseIndex();
	        }
	
	        for (var i = startIndex; i < endIndex; i++) {
	            result.push(events[i]);
	        }
	
	        // if we're not done, iterate to the next timeline.
	        if (timeline === this._end.timeline) {
	            break;
	        } else {
	            timeline = timeline.getNeighbouringTimeline(EventTimeline.FORWARDS);
	        }
	    }
	
	    return result;
	};
	
	/**
	 * a thing which contains a timeline reference, and an index into it.
	 *
	 * @constructor
	 * @param {EventTimeline} timeline
	 * @param {number} index
	 * @private
	 */
	function TimelineIndex(timeline, index) {
	    this.timeline = timeline;
	
	    // the indexes are relative to BaseIndex, so could well be negative.
	    this.index = index;
	}
	
	/**
	 * @return {number} the minimum possible value for the index in the current
	 *    timeline
	 */
	TimelineIndex.prototype.minIndex = function () {
	    return this.timeline.getBaseIndex() * -1;
	};
	
	/**
	 * @return {number} the maximum possible value for the index in the current
	 *    timeline (exclusive - ie, it actually returns one more than the index
	 *    of the last element).
	 */
	TimelineIndex.prototype.maxIndex = function () {
	    return this.timeline.getEvents().length - this.timeline.getBaseIndex();
	};
	
	/**
	 * Try move the index forward, or into the neighbouring timeline
	 *
	 * @param {number} delta  number of events to advance by
	 * @return {number} number of events successfully advanced by
	 */
	TimelineIndex.prototype.advance = function (delta) {
	    if (!delta) {
	        return 0;
	    }
	
	    // first try moving the index in the current timeline. See if there is room
	    // to do so.
	    var cappedDelta = void 0;
	    if (delta < 0) {
	        // we want to wind the index backwards.
	        //
	        // (this.minIndex() - this.index) is a negative number whose magnitude
	        // is the amount of room we have to wind back the index in the current
	        // timeline. We cap delta to this quantity.
	        cappedDelta = Math.max(delta, this.minIndex() - this.index);
	        if (cappedDelta < 0) {
	            this.index += cappedDelta;
	            return cappedDelta;
	        }
	    } else {
	        // we want to wind the index forwards.
	        //
	        // (this.maxIndex() - this.index) is a (positive) number whose magnitude
	        // is the amount of room we have to wind forward the index in the current
	        // timeline. We cap delta to this quantity.
	        cappedDelta = Math.min(delta, this.maxIndex() - this.index);
	        if (cappedDelta > 0) {
	            this.index += cappedDelta;
	            return cappedDelta;
	        }
	    }
	
	    // the index is already at the start/end of the current timeline.
	    //
	    // next see if there is a neighbouring timeline to switch to.
	    var neighbour = this.timeline.getNeighbouringTimeline(delta < 0 ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS);
	    if (neighbour) {
	        this.timeline = neighbour;
	        if (delta < 0) {
	            this.index = this.maxIndex();
	        } else {
	            this.index = this.minIndex();
	        }
	
	        debuglog("paginate: switched to new neighbour");
	
	        // recurse, using the next timeline
	        return this.advance(delta);
	    }
	
	    return 0;
	};
	
	/**
	 * Try move the index backwards, or into the neighbouring timeline
	 *
	 * @param {number} delta  number of events to retreat by
	 * @return {number} number of events successfully retreated by
	 */
	TimelineIndex.prototype.retreat = function (delta) {
	    return this.advance(delta * -1) * -1;
	};
	
	/**
	 * The TimelineWindow class.
	 */
	module.exports.TimelineWindow = TimelineWindow;
	
	/**
	 * The TimelineIndex class. exported here for unit testing.
	 */
	module.exports.TimelineIndex = TimelineIndex;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 Aviral Dasgupta
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/**
	 * Base class for classes that provide platform-specific functionality
	 * eg. Setting an application badge or displaying notifications
	 *
	 * Instances of this class are provided by the application.
	 */
	var BasePlatform = function () {
	    function BasePlatform() {
	        (0, _classCallCheck3.default)(this, BasePlatform);
	
	        this.notificationCount = 0;
	        this.errorDidOccur = false;
	    }
	
	    (0, _createClass3.default)(BasePlatform, [{
	        key: "setNotificationCount",
	        value: function setNotificationCount(count) {
	            this.notificationCount = count;
	        }
	    }, {
	        key: "setErrorStatus",
	        value: function setErrorStatus(errorDidOccur) {
	            this.errorDidOccur = errorDidOccur;
	        }
	
	        /**
	         * Returns true if the platform supports displaying
	         * notifications, otherwise false.
	         */
	
	    }, {
	        key: "supportsNotifications",
	        value: function supportsNotifications() {
	            return false;
	        }
	
	        /**
	         * Returns true if the application currently has permission
	         * to display notifications. Otherwise false.
	         */
	
	    }, {
	        key: "maySendNotifications",
	        value: function maySendNotifications() {
	            return false;
	        }
	
	        /**
	         * Requests permission to send notifications. Returns
	         * a promise that is resolved when the user has responded
	         * to the request. The promise has a single string argument
	         * that is 'granted' if the user allowed the request or
	         * 'denied' otherwise.
	         */
	
	    }, {
	        key: "requestNotificationPermission",
	        value: function requestNotificationPermission() {}
	    }, {
	        key: "displayNotification",
	        value: function displayNotification(title, msg, avatarUrl, room) {}
	
	        /**
	         * Returns a promise that resolves to a string representing
	         * the current version of the application.
	         */
	
	    }, {
	        key: "getAppVersion",
	        value: function getAppVersion() {
	            throw new Error("getAppVersion not implemented!");
	        }
	
	        /*
	         * If it's not expected that capturing the screen will work
	         * with getUserMedia, return a string explaining why not.
	         * Otherwise, return null.
	         */
	
	    }, {
	        key: "screenCaptureErrorString",
	        value: function screenCaptureErrorString() {
	            return "Not implemented";
	        }
	
	        /**
	         * Restarts the application, without neccessarily reloading
	         * any application code
	         */
	
	    }, {
	        key: "reload",
	        value: function reload() {
	            throw new Error("reload not implemented!");
	        }
	    }]);
	    return BasePlatform;
	}();
	
	exports.default = BasePlatform;
	module.exports = exports["default"];


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	
	function isMatch(query, name, uid) {
	    query = query.toLowerCase();
	    name = name.toLowerCase();
	    uid = uid.toLowerCase();
	
	    // direct prefix matches
	    if (name.indexOf(query) === 0 || uid.indexOf(query) === 0) {
	        return true;
	    }
	
	    // strip @ on uid and try matching again
	    if (uid.length > 1 && uid[0] === "@" && uid.substring(1).indexOf(query) === 0) {
	        return true;
	    }
	
	    // split spaces in name and try matching constituent parts
	    var parts = name.split(" ");
	    for (var i = 0; i < parts.length; i++) {
	        if (parts[i].indexOf(query) === 0) {
	            return true;
	        }
	    }
	    return false;
	}
	
	/*
	 * Converts various data models to Entity objects.
	 *
	 * Entity objects provide an interface for UI components to use to display
	 * members in a data-agnostic way. This means they don't need to care if the
	 * underlying data model is a RoomMember, User or 3PID data structure, it just
	 * cares about rendering.
	 */
	
	var Entity = function () {
	    function Entity(model) {
	        (0, _classCallCheck3.default)(this, Entity);
	
	        this.model = model;
	    }
	
	    (0, _createClass3.default)(Entity, [{
	        key: 'getJsx',
	        value: function getJsx() {
	            return null;
	        }
	    }, {
	        key: 'matches',
	        value: function matches(queryString) {
	            return false;
	        }
	    }]);
	    return Entity;
	}();
	
	var MemberEntity = function (_Entity) {
	    (0, _inherits3.default)(MemberEntity, _Entity);
	
	    function MemberEntity() {
	        (0, _classCallCheck3.default)(this, MemberEntity);
	        return (0, _possibleConstructorReturn3.default)(this, (MemberEntity.__proto__ || (0, _getPrototypeOf2.default)(MemberEntity)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MemberEntity, [{
	        key: 'getJsx',
	        value: function getJsx() {
	            var MemberTile = sdk.getComponent("rooms.MemberTile");
	            return React.createElement(MemberTile, { key: this.model.userId, member: this.model });
	        }
	    }, {
	        key: 'matches',
	        value: function matches(queryString) {
	            return isMatch(queryString, this.model.name, this.model.userId);
	        }
	    }]);
	    return MemberEntity;
	}(Entity);
	
	var UserEntity = function (_Entity2) {
	    (0, _inherits3.default)(UserEntity, _Entity2);
	
	    function UserEntity(model, showInviteButton, inviteFn) {
	        (0, _classCallCheck3.default)(this, UserEntity);
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (UserEntity.__proto__ || (0, _getPrototypeOf2.default)(UserEntity)).call(this, model));
	
	        _this2.showInviteButton = Boolean(showInviteButton);
	        _this2.inviteFn = inviteFn;
	        return _this2;
	    }
	
	    (0, _createClass3.default)(UserEntity, [{
	        key: 'onClick',
	        value: function onClick() {
	            if (this.inviteFn) {
	                this.inviteFn(this.model.userId);
	            }
	        }
	    }, {
	        key: 'getJsx',
	        value: function getJsx() {
	            var UserTile = sdk.getComponent("rooms.UserTile");
	            return React.createElement(UserTile, { key: this.model.userId, user: this.model,
	                showInviteButton: this.showInviteButton, onClick: this.onClick.bind(this) });
	        }
	    }, {
	        key: 'matches',
	        value: function matches(queryString) {
	            var name = this.model.displayName || this.model.userId;
	            return isMatch(queryString, name, this.model.userId);
	        }
	    }]);
	    return UserEntity;
	}(Entity);
	
	module.exports = {
	    newEntity: function newEntity(jsx, matchFn) {
	        var entity = new Entity();
	        entity.getJsx = function () {
	            return jsx;
	        };
	        entity.matches = matchFn;
	        return entity;
	    },
	
	    /**
	     * @param {RoomMember[]} members
	     * @return {Entity[]}
	     */
	    fromRoomMembers: function fromRoomMembers(members) {
	        return members.map(function (m) {
	            return new MemberEntity(m);
	        });
	    },
	
	    /**
	     * @param {User[]} users
	     * @param {boolean} showInviteButton
	     * @param {Function} inviteFn Called with the user ID.
	     * @return {Entity[]}
	     */
	    fromUsers: function fromUsers(users, showInviteButton, inviteFn) {
	        return users.map(function (u) {
	            return new UserEntity(u, showInviteButton, inviteFn);
	        });
	    }
	};


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(177);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _url = __webpack_require__(149);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Login = function () {
	    function Login(hsUrl, isUrl, fallbackHsUrl, opts) {
	        (0, _classCallCheck3.default)(this, Login);
	
	        this._hsUrl = hsUrl;
	        this._isUrl = isUrl;
	        this._fallbackHsUrl = fallbackHsUrl;
	        this._currentFlowIndex = 0;
	        this._flows = [];
	        this._defaultDeviceDisplayName = opts.defaultDeviceDisplayName;
	    }
	
	    (0, _createClass3.default)(Login, [{
	        key: 'getHomeserverUrl',
	        value: function getHomeserverUrl() {
	            return this._hsUrl;
	        }
	    }, {
	        key: 'getIdentityServerUrl',
	        value: function getIdentityServerUrl() {
	            return this._isUrl;
	        }
	    }, {
	        key: 'setHomeserverUrl',
	        value: function setHomeserverUrl(hsUrl) {
	            this._hsUrl = hsUrl;
	        }
	    }, {
	        key: 'setIdentityServerUrl',
	        value: function setIdentityServerUrl(isUrl) {
	            this._isUrl = isUrl;
	        }
	
	        /**
	         * Get a temporary MatrixClient, which can be used for login or register
	         * requests.
	         */
	
	    }, {
	        key: '_createTemporaryClient',
	        value: function _createTemporaryClient() {
	            return _matrixJsSdk2.default.createClient({
	                baseUrl: this._hsUrl,
	                idBaseUrl: this._isUrl
	            });
	        }
	    }, {
	        key: 'getFlows',
	        value: function getFlows() {
	            var self = this;
	            var client = this._createTemporaryClient();
	            return client.loginFlows().then(function (result) {
	                self._flows = result.flows;
	                self._currentFlowIndex = 0;
	                // technically the UI should display options for all flows for the
	                // user to then choose one, so return all the flows here.
	                return self._flows;
	            });
	        }
	    }, {
	        key: 'chooseFlow',
	        value: function chooseFlow(flowIndex) {
	            this._currentFlowIndex = flowIndex;
	        }
	    }, {
	        key: 'getCurrentFlowStep',
	        value: function getCurrentFlowStep() {
	            // technically the flow can have multiple steps, but no one does this
	            // for login so we can ignore it.
	            var flowStep = this._flows[this._currentFlowIndex];
	            return flowStep ? flowStep.type : null;
	        }
	    }, {
	        key: 'loginAsGuest',
	        value: function loginAsGuest() {
	            var _this = this;
	
	            var client = this._createTemporaryClient();
	            return client.registerGuest({
	                body: {
	                    initial_device_display_name: this._defaultDeviceDisplayName
	                }
	            }).then(function (creds) {
	                return {
	                    userId: creds.user_id,
	                    deviceId: creds.device_id,
	                    accessToken: creds.access_token,
	                    homeserverUrl: _this._hsUrl,
	                    identityServerUrl: _this._isUrl,
	                    guest: true
	                };
	            }, function (error) {
	                if (error.httpStatus === 403) {
	                    error.friendlyText = "Guest access is disabled on this Home Server.";
	                } else {
	                    error.friendlyText = "Failed to register as guest: " + error.data;
	                }
	                throw error;
	            });
	        }
	    }, {
	        key: 'loginViaPassword',
	        value: function loginViaPassword(username, phoneCountry, phoneNumber, pass) {
	            var self = this;
	
	            var isEmail = username.indexOf("@") > 0;
	
	            var identifier = void 0;
	            var legacyParams = void 0; // parameters added to support old HSes
	            if (phoneCountry && phoneNumber) {
	                identifier = {
	                    type: 'm.id.phone',
	                    country: phoneCountry,
	                    number: phoneNumber
	                };
	                // No legacy support for phone number login
	            } else if (isEmail) {
	                identifier = {
	                    type: 'm.id.thirdparty',
	                    medium: 'email',
	                    address: username
	                };
	                legacyParams = {
	                    medium: 'email',
	                    address: username
	                };
	            } else {
	                identifier = {
	                    type: 'm.id.user',
	                    user: username
	                };
	                legacyParams = {
	                    user: username
	                };
	            }
	
	            var loginParams = {
	                password: pass,
	                identifier: identifier,
	                initial_device_display_name: this._defaultDeviceDisplayName
	            };
	            (0, _assign2.default)(loginParams, legacyParams);
	
	            var client = this._createTemporaryClient();
	            return client.login('m.login.password', loginParams).then(function (data) {
	                return (0, _q2.default)({
	                    homeserverUrl: self._hsUrl,
	                    identityServerUrl: self._isUrl,
	                    userId: data.user_id,
	                    deviceId: data.device_id,
	                    accessToken: data.access_token
	                });
	            }, function (error) {
	                if (error.httpStatus == 400 && loginParams.medium) {
	                    error.friendlyText = 'This Home Server does not support login using email address.';
	                } else if (error.httpStatus === 403) {
	                    error.friendlyText = 'Incorrect username and/or password.';
	                    if (self._fallbackHsUrl) {
	                        var fbClient = _matrixJsSdk2.default.createClient({
	                            baseUrl: self._fallbackHsUrl,
	                            idBaseUrl: this._isUrl
	                        });
	
	                        return fbClient.login('m.login.password', loginParams).then(function (data) {
	                            return (0, _q2.default)({
	                                homeserverUrl: self._fallbackHsUrl,
	                                identityServerUrl: self._isUrl,
	                                userId: data.user_id,
	                                deviceId: data.device_id,
	                                accessToken: data.access_token
	                            });
	                        }, function (fallback_error) {
	                            // throw the original error
	                            throw error;
	                        });
	                    }
	                } else {
	                    error.friendlyText = 'There was a problem logging in. (HTTP ' + error.httpStatus + ")";
	                }
	                throw error;
	            });
	        }
	    }, {
	        key: 'redirectToCas',
	        value: function redirectToCas() {
	            var client = this._createTemporaryClient();
	            var parsedUrl = _url2.default.parse(window.location.href, true);
	            parsedUrl.query["homeserver"] = client.getHomeserverUrl();
	            parsedUrl.query["identityServer"] = client.getIdentityServerUrl();
	            var casUrl = client.getCasLoginUrl(_url2.default.format(parsedUrl));
	            window.location.href = casUrl;
	        }
	    }]);
	    return Login;
	}(); /*
	     Copyright 2015, 2016 OpenMarket Ltd
	     Copyright 2017 Vector Creations Ltd
	     
	     Licensed under the Apache License, Version 2.0 (the "License");
	     you may not use this file except in compliance with the License.
	     You may obtain a copy of the License at
	     
	         http://www.apache.org/licenses/LICENSE-2.0
	     
	     Unless required by applicable law or agreed to in writing, software
	     distributed under the License is distributed on an "AS IS" BASIS,
	     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     See the License for the specific language governing permissions and
	     limitations under the License.
	     */
	
	exports.default = Login;
	module.exports = exports['default'];


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var Matrix = __webpack_require__(28);
	
	/**
	 * Allows a user to reset their password on a homeserver.
	 *
	 * This involves getting an email token from the identity server to "prove" that
	 * the client owns the given email address, which is then passed to the password
	 * API on the homeserver in question with the new password.
	 */
	
	var PasswordReset = function () {
	
	    /**
	     * Configure the endpoints for password resetting.
	     * @param {string} homeserverUrl The URL to the HS which has the account to reset.
	     * @param {string} identityUrl The URL to the IS which has linked the email -> mxid mapping.
	     */
	    function PasswordReset(homeserverUrl, identityUrl) {
	        (0, _classCallCheck3.default)(this, PasswordReset);
	
	        this.client = Matrix.createClient({
	            baseUrl: homeserverUrl,
	            idBaseUrl: identityUrl
	        });
	        this.clientSecret = this.client.generateClientSecret();
	        this.identityServerDomain = identityUrl.split("://")[1];
	    }
	
	    /**
	     * Attempt to reset the user's password. This will trigger a side-effect of
	     * sending an email to the provided email address.
	     * @param {string} emailAddress The email address
	     * @param {string} newPassword The new password for the account.
	     * @return {Promise} Resolves when the email has been sent. Then call checkEmailLinkClicked().
	     */
	
	
	    (0, _createClass3.default)(PasswordReset, [{
	        key: "resetPassword",
	        value: function resetPassword(emailAddress, newPassword) {
	            var _this = this;
	
	            this.password = newPassword;
	            return this.client.requestPasswordEmailToken(emailAddress, this.clientSecret, 1).then(function (res) {
	                _this.sessionId = res.sid;
	                return res;
	            }, function (err) {
	                if (err.errcode == 'M_THREEPID_NOT_FOUND') {
	                    err.message = "This email address was not found";
	                } else if (err.httpStatus) {
	                    err.message = err.message + (" (Status " + err.httpStatus + ")");
	                }
	                throw err;
	            });
	        }
	
	        /**
	         * Checks if the email link has been clicked by attempting to change the password
	         * for the mxid linked to the email.
	         * @return {Promise} Resolves if the password was reset. Rejects with an object
	         * with a "message" property which contains a human-readable message detailing why
	         * the reset failed, e.g. "There is no mapped matrix user ID for the given email address".
	         */
	
	    }, {
	        key: "checkEmailLinkClicked",
	        value: function checkEmailLinkClicked() {
	            return this.client.setPassword({
	                type: "m.login.email.identity",
	                threepid_creds: {
	                    sid: this.sessionId,
	                    client_secret: this.clientSecret,
	                    id_server: this.identityServerDomain
	                }
	            }, this.password).catch(function (err) {
	                if (err.httpStatus === 401) {
	                    err.message = "Failed to verify email address: make sure you clicked the link in the email";
	                } else if (err.httpStatus === 404) {
	                    err.message = "Your email address does not appear to be associated with a Matrix ID on this Homeserver.";
	                } else if (err.httpStatus) {
	                    err.message += " (Status " + err.httpStatus + ")";
	                }
	                throw err;
	            });
	        }
	    }]);
	    return PasswordReset;
	}();
	
	module.exports = PasswordReset;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.contentStateToHTML = undefined;
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.HTMLtoContentState = HTMLtoContentState;
	exports.getScopedRTDecorators = getScopedRTDecorators;
	exports.getScopedMDDecorators = getScopedMDDecorators;
	exports.modifyText = modifyText;
	exports.selectionStateToTextOffsets = selectionStateToTextOffsets;
	exports.textOffsetsToSelectionState = textOffsetsToSelectionState;
	exports.attachImmutableEntitiesToEmoji = attachImmutableEntitiesToEmoji;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _draftJs = __webpack_require__(161);
	
	var _index = __webpack_require__(2);
	
	var sdk = _interopRequireWildcard(_index);
	
	var _emojione = __webpack_require__(338);
	
	var emojione = _interopRequireWildcard(_emojione);
	
	var _draftJsExportHtml = __webpack_require__(919);
	
	var _Autocompleter = __webpack_require__(333);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARKDOWN_REGEX = {
	    LINK: /(?:\[([^\]]+)\]\(([^\)]+)\))|\<(\w+:\/\/[^\>]+)\>/g,
	    ITALIC: /([\*_])([\w\s]+?)\1/g,
	    BOLD: /([\*_])\1([\w\s]+?)\1\1/g,
	    HR: /(\n|^)((-|\*|_) *){3,}(\n|$)/g,
	    CODE: /`[^`]*`/g,
	    STRIKETHROUGH: /~{2}[^~]*~{2}/g
	};
	
	var USERNAME_REGEX = /@\S+:\S+/g;
	var ROOM_REGEX = /#\S+:\S+/g;
	var EMOJI_REGEX = new RegExp(emojione.unicodeRegexp, 'g');
	
	var contentStateToHTML = exports.contentStateToHTML = _draftJsExportHtml.stateToHTML;
	
	function HTMLtoContentState(html) {
	    return _draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(html));
	}
	
	function unicodeToEmojiUri(str) {
	    var replaceWith = void 0,
	        unicode = void 0,
	        alt = void 0;
	    if (!emojione.unicodeAlt || emojione.sprites) {
	        // if we are using the shortname as the alt tag then we need a reversed array to map unicode code point to shortnames
	        var mappedUnicode = emojione.mapUnicodeToShort();
	    }
	
	    str = str.replace(emojione.regUnicode, function (unicodeChar) {
	        if (typeof unicodeChar === 'undefined' || unicodeChar === '' || !(unicodeChar in emojione.jsEscapeMap)) {
	            // if the unicodeChar doesnt exist just return the entire match
	            return unicodeChar;
	        } else {
	            // get the unicode codepoint from the actual char
	            unicode = emojione.jsEscapeMap[unicodeChar];
	            return emojione.imagePathSVG + unicode + '.svg' + emojione.cacheBustParam;
	        }
	    });
	
	    return str;
	}
	
	/**
	 * Utility function that looks for regex matches within a ContentBlock and invokes {callback} with (start, end)
	 * From https://facebook.github.io/draft-js/docs/advanced-topics-decorators.html
	 */
	function findWithRegex(regex, contentBlock, callback) {
	    var text = contentBlock.getText();
	    var matchArr = void 0,
	        start = void 0;
	    while ((matchArr = regex.exec(text)) !== null) {
	        start = matchArr.index;
	        callback(start, start + matchArr[0].length);
	    }
	}
	
	// Workaround for https://github.com/facebook/draft-js/issues/414
	var emojiDecorator = {
	    strategy: function strategy(contentBlock, callback) {
	        findWithRegex(EMOJI_REGEX, contentBlock, callback);
	    },
	    component: function component(props) {
	        var uri = unicodeToEmojiUri(props.children[0].props.text);
	        var shortname = emojione.toShort(props.children[0].props.text);
	        var style = {
	            display: 'inline-block',
	            width: '1em',
	            maxHeight: '1em',
	            background: 'url(' + uri + ')',
	            backgroundSize: 'contain',
	            backgroundPosition: 'center center',
	            overflow: 'hidden'
	        };
	        return _react2.default.createElement(
	            'span',
	            { title: shortname, style: style },
	            _react2.default.createElement(
	                'span',
	                { style: { opacity: 0 } },
	                props.children
	            )
	        );
	    }
	};
	
	/**
	 * Returns a composite decorator which has access to provided scope.
	 */
	function getScopedRTDecorators(scope) {
	    var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');
	
	    var usernameDecorator = {
	        strategy: function strategy(contentBlock, callback) {
	            findWithRegex(USERNAME_REGEX, contentBlock, callback);
	        },
	        component: function component(props) {
	            var member = scope.room.getMember(props.children[0].props.text);
	            // unused until we make these decorators immutable (autocomplete needed)
	            var name = member ? member.name : null;
	            var avatar = member ? _react2.default.createElement(MemberAvatar, { member: member, width: 16, height: 16 }) : null;
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_UserPill' },
	                avatar,
	                props.children
	            );
	        }
	    };
	
	    var roomDecorator = {
	        strategy: function strategy(contentBlock, callback) {
	            findWithRegex(ROOM_REGEX, contentBlock, callback);
	        },
	        component: function component(props) {
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_RoomPill' },
	                props.children
	            );
	        }
	    };
	
	    // TODO Re-enable usernameDecorator and roomDecorator
	    return [emojiDecorator];
	}
	
	function getScopedMDDecorators(scope) {
	    var markdownDecorators = ['HR', 'BOLD', 'ITALIC', 'CODE', 'STRIKETHROUGH'].map(function (style) {
	        return {
	            strategy: function strategy(contentBlock, callback) {
	                return findWithRegex(MARKDOWN_REGEX[style], contentBlock, callback);
	            },
	            component: function component(props) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: "mx_MarkdownElement mx_Markdown_" + style },
	                    props.children
	                );
	            }
	        };
	    });
	
	    markdownDecorators.push({
	        strategy: function strategy(contentBlock, callback) {
	            return findWithRegex(MARKDOWN_REGEX.LINK, contentBlock, callback);
	        },
	        component: function component(props) {
	            return _react2.default.createElement(
	                'a',
	                { href: '#', className: 'mx_MarkdownElement mx_Markdown_LINK' },
	                props.children
	            );
	        }
	    });
	    markdownDecorators.push(emojiDecorator);
	
	    return markdownDecorators;
	}
	
	/**
	 * Passes rangeToReplace to modifyFn and replaces it in contentState with the result.
	 */
	function modifyText(contentState, rangeToReplace, modifyFn, inlineStyle, entityKey) {
	    var getText = function getText(key) {
	        return contentState.getBlockForKey(key).getText();
	    },
	        startKey = rangeToReplace.getStartKey(),
	        startOffset = rangeToReplace.getStartOffset(),
	        endKey = rangeToReplace.getEndKey(),
	        endOffset = rangeToReplace.getEndOffset(),
	        text = "";
	
	    for (var currentKey = startKey; currentKey && currentKey !== endKey; currentKey = contentState.getKeyAfter(currentKey)) {
	        var blockText = getText(currentKey);
	        text += blockText.substring(startOffset, blockText.length);
	
	        // from now on, we'll take whole blocks
	        startOffset = 0;
	    }
	
	    // add remaining part of last block
	    text += getText(endKey).substring(startOffset, endOffset);
	
	    return _draftJs.Modifier.replaceText(contentState, rangeToReplace, modifyFn(text), inlineStyle, entityKey);
	}
	
	/**
	 * Computes the plaintext offsets of the given SelectionState.
	 * Note that this inherently means we make assumptions about what that means (no separator between ContentBlocks, etc)
	 * Used by autocomplete to show completions when the current selection lies within, or at the edges of a command.
	 */
	function selectionStateToTextOffsets(selectionState, contentBlocks) {
	    var offset = 0,
	        start = 0,
	        end = 0;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)(contentBlocks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var block = _step.value;
	
	            if (selectionState.getStartKey() === block.getKey()) {
	                start = offset + selectionState.getStartOffset();
	            }
	            if (selectionState.getEndKey() === block.getKey()) {
	                end = offset + selectionState.getEndOffset();
	                break;
	            }
	            offset += block.getLength();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return {
	        start: start,
	        end: end
	    };
	}
	
	function textOffsetsToSelectionState(_ref, contentBlocks) {
	    var start = _ref.start,
	        end = _ref.end;
	
	    var selectionState = _draftJs.SelectionState.createEmpty();
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = (0, _getIterator3.default)(contentBlocks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var block = _step2.value;
	
	            var blockLength = block.getLength();
	
	            if (start !== -1 && start < blockLength) {
	                selectionState = selectionState.merge({
	                    anchorKey: block.getKey(),
	                    anchorOffset: start
	                });
	                start = -1;
	            } else {
	                start -= blockLength;
	            }
	
	            if (end !== -1 && end <= blockLength) {
	                selectionState = selectionState.merge({
	                    focusKey: block.getKey(),
	                    focusOffset: end
	                });
	                end = -1;
	            } else {
	                end -= blockLength;
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return selectionState;
	}
	
	// modified version of https://github.com/draft-js-plugins/draft-js-plugins/blob/master/draft-js-emoji-plugin/src/modifiers/attachImmutableEntitiesToEmojis.js
	function attachImmutableEntitiesToEmoji(editorState) {
	    var contentState = editorState.getCurrentContent();
	    var blocks = contentState.getBlockMap();
	    var newContentState = contentState;
	
	    blocks.forEach(function (block) {
	        var plainText = block.getText();
	
	        var addEntityToEmoji = function addEntityToEmoji(start, end) {
	            var existingEntityKey = block.getEntityAt(start);
	            if (existingEntityKey) {
	                // avoid manipulation in case the emoji already has an entity
	                var entity = _draftJs.Entity.get(existingEntityKey);
	                if (entity && entity.get('type') === 'emoji') {
	                    return;
	                }
	            }
	
	            var selection = _draftJs.SelectionState.createEmpty(block.getKey()).set('anchorOffset', start).set('focusOffset', end);
	            var emojiText = plainText.substring(start, end);
	            var entityKey = _draftJs.Entity.create('emoji', 'IMMUTABLE', { emojiUnicode: emojiText });
	            newContentState = _draftJs.Modifier.replaceText(newContentState, selection, emojiText, null, entityKey);
	        };
	
	        findWithRegex(EMOJI_REGEX, block, addEntityToEmoji);
	    });
	
	    if (!newContentState.equals(contentState)) {
	        var oldSelection = editorState.getSelection();
	        editorState = _draftJs.EditorState.push(editorState, newContentState, 'convert-to-immutable-emojis');
	        // this is somewhat of a hack, we're undoing selection changes caused above
	        // it would be better not to make those changes in the first place
	        editorState = _draftJs.EditorState.forceSelection(editorState, oldSelection);
	    }
	
	    return editorState;
	}


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _isInteger = __webpack_require__(614);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/*
	Listens for incoming postMessage requests from the integrations UI URL. The following API is exposed:
	{
	    action: "invite" | "membership_state" | "bot_options" | "set_bot_options",
	    room_id: $ROOM_ID,
	    user_id: $USER_ID
	    // additional request fields
	}
	
	The complete request object is returned to the caller with an additional "response" key like so:
	{
	    action: "invite" | "membership_state" | "bot_options" | "set_bot_options",
	    room_id: $ROOM_ID,
	    user_id: $USER_ID,
	    // additional request fields
	    response: { ... }
	}
	
	The "action" determines the format of the request and response. All actions can return an error response.
	An error response is a "response" object which consists of a sole "error" key to indicate an error.
	They look like:
	{
	    error: {
	        message: "Unable to invite user into room.",
	        _error: <Original Error Object>
	    }
	}
	The "message" key should be a human-friendly string.
	
	ACTIONS
	=======
	All actions can return an error response instead of the response outlined below.
	
	invite
	------
	Invites a user into a room.
	
	Request:
	 - room_id is the room to invite the user into.
	 - user_id is the user ID to invite.
	 - No additional fields.
	Response:
	{
	    success: true
	}
	Example:
	{
	    action: "invite",
	    room_id: "!foo:bar",
	    user_id: "@invitee:bar",
	    response: {
	        success: true
	    }
	}
	
	set_bot_options
	---------------
	Set the m.room.bot.options state event for a bot user.
	
	Request:
	 - room_id is the room to send the state event into.
	 - user_id is the user ID of the bot who you're setting options for.
	 - "content" is an object consisting of the content you wish to set.
	Response:
	{
	    success: true
	}
	Example:
	{
	    action: "set_bot_options",
	    room_id: "!foo:bar",
	    user_id: "@bot:bar",
	    content: {
	        default_option: "alpha"
	    },
	    response: {
	        success: true
	    }
	}
	
	membership_state AND bot_options
	--------------------------------
	Get the content of the "m.room.member" or "m.room.bot.options" state event respectively.
	
	NB: Whilst this API is basically equivalent to getStateEvent, we specifically do not
	    want external entities to be able to query any state event for any room, hence the
	    restrictive API outlined here.
	
	Request:
	 - room_id is the room which has the state event.
	 - user_id is the state_key parameter which in both cases is a user ID (the member or the bot).
	 - No additional fields.
	Response:
	 - The event content. If there is no state event, the "response" key should be null.
	Example:
	{
	    action: "membership_state",
	    room_id: "!foo:bar",
	    user_id: "@somemember:bar",
	    response: {
	        membership: "join",
	        displayname: "Bob",
	        avatar_url: null
	    }
	}
	*/
	
	var SdkConfig = __webpack_require__(118);
	var MatrixClientPeg = __webpack_require__(4);
	var MatrixEvent = __webpack_require__(28).MatrixEvent;
	var dis = __webpack_require__(5);
	
	function sendResponse(event, res) {
	    var data = JSON.parse((0, _stringify2.default)(event.data));
	    data.response = res;
	    event.source.postMessage(data, event.origin);
	}
	
	function sendError(event, msg, nestedError) {
	    console.error("Action:" + event.data.action + " failed with message: " + msg);
	    var data = JSON.parse((0, _stringify2.default)(event.data));
	    data.response = {
	        error: {
	            message: msg
	        }
	    };
	    if (nestedError) {
	        data.response.error._error = nestedError;
	    }
	    event.source.postMessage(data, event.origin);
	}
	
	function inviteUser(event, roomId, userId) {
	    console.log("Received request to invite " + userId + " into room " + roomId);
	    var client = MatrixClientPeg.get();
	    if (!client) {
	        sendError(event, "You need to be logged in.");
	        return;
	    }
	    var room = client.getRoom(roomId);
	    if (room) {
	        // if they are already invited we can resolve immediately.
	        var member = room.getMember(userId);
	        if (member && member.membership === "invite") {
	            sendResponse(event, {
	                success: true
	            });
	            return;
	        }
	    }
	
	    client.invite(roomId, userId).done(function () {
	        sendResponse(event, {
	            success: true
	        });
	    }, function (err) {
	        sendError(event, "You need to be able to invite users to do that.", err);
	    });
	}
	
	function setPlumbingState(event, roomId, status) {
	    if (typeof status !== 'string') {
	        throw new Error('Plumbing state status should be a string');
	    }
	    console.log("Received request to set plumbing state to status \"" + status + "\" in room " + roomId);
	    var client = MatrixClientPeg.get();
	    if (!client) {
	        sendError(event, "You need to be logged in.");
	        return;
	    }
	    client.sendStateEvent(roomId, "m.room.plumbing", { status: status }).done(function () {
	        sendResponse(event, {
	            success: true
	        });
	    }, function (err) {
	        sendError(event, err.message ? err.message : "Failed to send request.", err);
	    });
	}
	
	function setBotOptions(event, roomId, userId) {
	    console.log("Received request to set options for bot " + userId + " in room " + roomId);
	    var client = MatrixClientPeg.get();
	    if (!client) {
	        sendError(event, "You need to be logged in.");
	        return;
	    }
	    client.sendStateEvent(roomId, "m.room.bot.options", event.data.content, "_" + userId).done(function () {
	        sendResponse(event, {
	            success: true
	        });
	    }, function (err) {
	        sendError(event, err.message ? err.message : "Failed to send request.", err);
	    });
	}
	
	function setBotPower(event, roomId, userId, level) {
	    if (!((0, _isInteger2.default)(level) && level >= 0)) {
	        sendError(event, "Power level must be positive integer.");
	        return;
	    }
	
	    console.log("Received request to set power level to " + level + " for bot " + userId + " in room " + roomId + ".");
	    var client = MatrixClientPeg.get();
	    if (!client) {
	        sendError(event, "You need to be logged in.");
	        return;
	    }
	
	    client.getStateEvent(roomId, "m.room.power_levels", "").then(function (powerLevels) {
	        var powerEvent = new MatrixEvent({
	            type: "m.room.power_levels",
	            content: powerLevels
	        });
	
	        client.setPowerLevel(roomId, userId, level, powerEvent).done(function () {
	            sendResponse(event, {
	                success: true
	            });
	        }, function (err) {
	            sendError(event, err.message ? err.message : "Failed to send request.", err);
	        });
	    });
	}
	
	function getMembershipState(event, roomId, userId) {
	    console.log("membership_state of " + userId + " in room " + roomId + " requested.");
	    returnStateEvent(event, roomId, "m.room.member", userId);
	}
	
	function getJoinRules(event, roomId) {
	    console.log("join_rules of " + roomId + " requested.");
	    returnStateEvent(event, roomId, "m.room.join_rules", "");
	}
	
	function botOptions(event, roomId, userId) {
	    console.log("bot_options of " + userId + " in room " + roomId + " requested.");
	    returnStateEvent(event, roomId, "m.room.bot.options", "_" + userId);
	}
	
	function returnStateEvent(event, roomId, eventType, stateKey) {
	    var client = MatrixClientPeg.get();
	    if (!client) {
	        sendError(event, "You need to be logged in.");
	        return;
	    }
	    var room = client.getRoom(roomId);
	    if (!room) {
	        sendError(event, "This room is not recognised.");
	        return;
	    }
	    var stateEvent = room.currentState.getStateEvents(eventType, stateKey);
	    if (!stateEvent) {
	        sendResponse(event, null);
	        return;
	    }
	    sendResponse(event, stateEvent.getContent());
	}
	
	var currentRoomId = null;
	var currentRoomAlias = null;
	
	// Listen for when a room is viewed
	dis.register(onAction);
	function onAction(payload) {
	    if (payload.action !== "view_room") {
	        return;
	    }
	    currentRoomId = payload.room_id;
	    currentRoomAlias = payload.room_alias;
	}
	
	var onMessage = function onMessage(event) {
	    if (!event.origin) {
	        // stupid chrome
	        event.origin = event.originalEvent.origin;
	    }
	
	    // Check that the integrations UI URL starts with the origin of the event
	    // This means the URL could contain a path (like /develop) and still be used
	    // to validate event origins, which do not specify paths.
	    // (See https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage)
	    //
	    // All strings start with the empty string, so for sanity return if the length
	    // of the event origin is 0.
	    var url = SdkConfig.get().integrations_ui_url;
	    if (event.origin.length === 0 || !url.startsWith(event.origin)) {
	        return; // don't log this - debugging APIs like to spam postMessage which floods the log otherwise
	    }
	
	    if (event.data.action === "close_scalar") {
	        dis.dispatch({ action: "close_scalar" });
	        sendResponse(event, null);
	        return;
	    }
	
	    var roomId = event.data.room_id;
	    var userId = event.data.user_id;
	    if (!roomId) {
	        sendError(event, "Missing room_id in request");
	        return;
	    }
	    var promise = _promise2.default.resolve(currentRoomId);
	    if (!currentRoomId) {
	        if (!currentRoomAlias) {
	            sendError(event, "Must be viewing a room");
	            return;
	        }
	        // no room ID but there is an alias, look it up.
	        console.log("Looking up alias " + currentRoomAlias);
	        promise = MatrixClientPeg.get().getRoomIdForAlias(currentRoomAlias).then(function (res) {
	            return res.room_id;
	        });
	    }
	
	    promise.then(function (viewingRoomId) {
	        if (roomId !== viewingRoomId) {
	            sendError(event, "Room " + roomId + " not visible");
	            return;
	        }
	
	        // Getting join rules does not require userId
	        if (event.data.action === "join_rules_state") {
	            getJoinRules(event, roomId);
	            return;
	        } else if (event.data.action === "set_plumbing_state") {
	            setPlumbingState(event, roomId, event.data.status);
	            return;
	        }
	
	        if (!userId) {
	            sendError(event, "Missing user_id in request");
	            return;
	        }
	        switch (event.data.action) {
	            case "membership_state":
	                getMembershipState(event, roomId, userId);
	                break;
	            case "invite":
	                inviteUser(event, roomId, userId);
	                break;
	            case "bot_options":
	                botOptions(event, roomId, userId);
	                break;
	            case "set_bot_options":
	                setBotOptions(event, roomId, userId);
	                break;
	            case "set_bot_power":
	                setBotPower(event, roomId, userId, event.data.level);
	                break;
	            default:
	                console.warn("Unhandled postMessage event with action '" + event.data.action + "'");
	                break;
	        }
	    }, function (err) {
	        console.error(err);
	        sendError(event, "Failed to lookup current room.");
	    });
	};
	
	module.exports = {
	    startListening: function startListening() {
	        window.addEventListener("message", onMessage, false);
	    },
	
	    stopListening: function stopListening() {
	        window.removeEventListener("message", onMessage);
	    }
	};


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var Skinner = function () {
	    function Skinner() {
	        (0, _classCallCheck3.default)(this, Skinner);
	
	        this.components = null;
	    }
	
	    (0, _createClass3.default)(Skinner, [{
	        key: "getComponent",
	        value: function getComponent(name) {
	            if (this.components === null) {
	                throw new Error("Attempted to get a component before a skin has been loaded." + "This is probably because either:" + " a) Your app has not called sdk.loadSkin(), or" + " b) A component has called getComponent at the root level");
	            }
	            var comp = this.components[name];
	            if (comp) {
	                return comp;
	            }
	            // XXX: Temporarily also try 'views.' as we're currently
	            // leaving the 'views.' off views.
	            var comp = this.components['views.' + name];
	            if (comp) {
	                return comp;
	            }
	            throw new Error("No such component: " + name);
	        }
	    }, {
	        key: "load",
	        value: function load(skinObject) {
	            if (this.components !== null) {
	                throw new Error("Attempted to load a skin while a skin is already loaded" + "If you want to change the active skin, call resetSkin first");
	            }
	            this.components = {};
	            var compKeys = (0, _keys2.default)(skinObject.components);
	            for (var i = 0; i < compKeys.length; ++i) {
	                var comp = skinObject.components[compKeys[i]];
	                this.addComponent(compKeys[i], comp);
	            }
	        }
	    }, {
	        key: "addComponent",
	        value: function addComponent(name, comp) {
	            var slot = name;
	            if (comp.replaces !== undefined) {
	                if (comp.replaces.indexOf('.') > -1) {
	                    slot = comp.replaces;
	                } else {
	                    slot = name.substr(0, name.lastIndexOf('.') + 1) + comp.replaces.split('.').pop();
	                }
	            }
	            this.components[slot] = comp;
	        }
	    }, {
	        key: "reset",
	        value: function reset() {
	            this.components = null;
	        }
	    }]);
	    return Skinner;
	}();
	
	// We define one Skinner globally, because the intention is
	// very much that it is a singleton. Relying on there only being one
	// copy of the module can be dicey and not work as browserify's
	// behaviour with multiple copies of files etc. is erratic at best.
	// XXX: We can still end up with the same file twice in the resulting
	// JS bundle which is nonideal.
	
	
	if (global.mxSkinner === undefined) {
	    global.mxSkinner = new Skinner();
	}
	module.exports = global.mxSkinner;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _slicedToArray2 = __webpack_require__(376);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _TabCompleteEntries = __webpack_require__(330);
	
	var _SlashCommands = __webpack_require__(329);
	
	var _SlashCommands2 = _interopRequireDefault(_SlashCommands);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DELAY_TIME_MS = 1000; /*
	                          Copyright 2015, 2016 OpenMarket Ltd
	                          
	                          Licensed under the Apache License, Version 2.0 (the "License");
	                          you may not use this file except in compliance with the License.
	                          You may obtain a copy of the License at
	                          
	                              http://www.apache.org/licenses/LICENSE-2.0
	                          
	                          Unless required by applicable law or agreed to in writing, software
	                          distributed under the License is distributed on an "AS IS" BASIS,
	                          WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                          See the License for the specific language governing permissions and
	                          limitations under the License.
	                          */
	
	var KEY_TAB = 9;
	var KEY_SHIFT = 16;
	var KEY_WINDOWS = 91;
	
	// NB: DO NOT USE \b its "words" are roman alphabet only!
	//
	// Capturing group containing the start
	// of line or a whitespace char
	//     \_______________       __________Capturing group of 0 or more non-whitespace chars
	//                    _|__  _|_         followed by the end of line
	//                   /    \/   \
	var MATCH_REGEX = /(^|\s)(\S*)$/;
	
	var TabComplete = function () {
	    function TabComplete(opts) {
	        (0, _classCallCheck3.default)(this, TabComplete);
	
	        opts.allowLooping = opts.allowLooping || false;
	        opts.autoEnterTabComplete = opts.autoEnterTabComplete || false;
	        opts.onClickCompletes = opts.onClickCompletes || false;
	        this.opts = opts;
	        this.completing = false;
	        this.list = []; // full set of tab-completable things
	        this.matchedList = []; // subset of completable things to loop over
	        this.currentIndex = 0; // index in matchedList currently
	        this.originalText = null; // original input text when tab was first hit
	        this.textArea = opts.textArea; // DOMElement
	        this.isFirstWord = false; // true if you tab-complete on the first word
	        this.enterTabCompleteTimerId = null;
	        this.inPassiveMode = false;
	
	        // Map tracking ordering of the room members.
	        // userId: integer, highest comes first.
	        this.memberTabOrder = {};
	
	        // monotonically increasing counter used for tracking ordering of members
	        this.memberOrderSeq = 0;
	    }
	
	    /**
	     * Call this when a a UI element representing a tab complete entry has been clicked
	     * @param {entry} The entry that was clicked
	     */
	
	
	    (0, _createClass3.default)(TabComplete, [{
	        key: 'onEntryClick',
	        value: function onEntryClick(entry) {
	            if (this.opts.onClickCompletes) {
	                this.completeTo(entry);
	            }
	        }
	    }, {
	        key: 'loadEntries',
	        value: function loadEntries(room) {
	            this._makeEntries(room);
	            this._initSorting(room);
	            this._sortEntries();
	        }
	    }, {
	        key: 'onMemberSpoke',
	        value: function onMemberSpoke(member) {
	            if (this.memberTabOrder[member.userId] === undefined) {
	                this.list.push(new _TabCompleteEntries.MemberEntry(member));
	            }
	            this.memberTabOrder[member.userId] = this.memberOrderSeq++;
	            this._sortEntries();
	        }
	
	        /**
	         * @param {DOMElement}
	         */
	
	    }, {
	        key: 'setTextArea',
	        value: function setTextArea(textArea) {
	            this.textArea = textArea;
	        }
	
	        /**
	         * @return {Boolean}
	         */
	
	    }, {
	        key: 'isTabCompleting',
	        value: function isTabCompleting() {
	            // actually have things to tab over
	            return this.completing && this.matchedList.length > 1;
	        }
	    }, {
	        key: 'stopTabCompleting',
	        value: function stopTabCompleting() {
	            this.completing = false;
	            this.currentIndex = 0;
	            this._notifyStateChange();
	        }
	    }, {
	        key: 'startTabCompleting',
	        value: function startTabCompleting(passive) {
	            var _this = this;
	
	            this.originalText = this.textArea.value; // cache starting text
	
	            // grab the partial word from the text which we'll be tab-completing
	            var res = MATCH_REGEX.exec(this.originalText);
	            if (!res) {
	                this.matchedList = [];
	                return;
	            }
	            // ES6 destructuring; ignore first element (the complete match)
	
	            var _res = (0, _slicedToArray3.default)(res, 3),
	                boundaryGroup = _res[1],
	                partialGroup = _res[2];
	
	            if (partialGroup.length === 0 && passive) {
	                return;
	            }
	
	            this.isFirstWord = partialGroup.length === this.originalText.length;
	
	            this.completing = true;
	            this.currentIndex = 0;
	
	            this.matchedList = [new _TabCompleteEntries.Entry(partialGroup) // first entry is always the original partial
	            ];
	
	            // find matching entries in the set of entries given to us
	            this.list.forEach(function (entry) {
	                if (entry.text.toLowerCase().indexOf(partialGroup.toLowerCase()) === 0) {
	                    _this.matchedList.push(entry);
	                }
	            });
	
	            // console.log("calculated completions => %s", JSON.stringify(this.matchedList));
	        }
	
	        /**
	         * Do an auto-complete with the given word. This terminates the tab-complete.
	         * @param {Entry} entry The tab-complete entry to complete to.
	         */
	
	    }, {
	        key: 'completeTo',
	        value: function completeTo(entry) {
	            this.textArea.value = this._replaceWith(entry.getFillText(), true, entry.getSuffix(this.isFirstWord));
	            this.stopTabCompleting();
	            // keep focus on the text area
	            this.textArea.focus();
	        }
	
	        /**
	         * @param {Number} numAheadToPeek Return *up to* this many elements.
	         * @return {Entry[]}
	         */
	
	    }, {
	        key: 'peek',
	        value: function peek(numAheadToPeek) {
	            if (this.matchedList.length === 0) {
	                return [];
	            }
	            var peekList = [];
	
	            // return the current match item and then one with an index higher, and
	            // so on until we've reached the requested limit. If we hit the end of
	            // the list of options we're done.
	            for (var i = 0; i < numAheadToPeek; i++) {
	                var nextIndex;
	                if (this.opts.allowLooping) {
	                    nextIndex = (this.currentIndex + i) % this.matchedList.length;
	                } else {
	                    nextIndex = this.currentIndex + i;
	                    if (nextIndex === this.matchedList.length) {
	                        break;
	                    }
	                }
	                peekList.push(this.matchedList[nextIndex]);
	            }
	            // console.log("Peek list(%s): %s", numAheadToPeek, JSON.stringify(peekList));
	            return peekList;
	        }
	    }, {
	        key: 'handleTabPress',
	        value: function handleTabPress(passive, shiftKey) {
	            var wasInPassiveMode = this.inPassiveMode && !passive;
	            this.inPassiveMode = passive;
	
	            if (!this.completing) {
	                this.startTabCompleting(passive);
	            }
	
	            if (shiftKey) {
	                this.nextMatchedEntry(-1);
	            } else {
	                // if we were in passive mode we got out of sync by incrementing the
	                // index to show the peek view but not set the text area. Therefore,
	                // we want to set the *current* index rather than the *next* index.
	                this.nextMatchedEntry(wasInPassiveMode ? 0 : 1);
	            }
	            this._notifyStateChange();
	        }
	
	        /**
	         * @param {DOMEvent} e
	         */
	
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(ev) {
	            var _this2 = this;
	
	            if (!this.textArea) {
	                console.error("onKeyDown called before a <textarea> was set!");
	                return;
	            }
	
	            if (ev.keyCode !== KEY_TAB) {
	                // pressing any key (except shift, windows, cmd (OSX) and ctrl/alt combinations)
	                // aborts the current tab completion
	                if (this.completing && ev.keyCode !== KEY_SHIFT && !ev.metaKey && !ev.ctrlKey && !ev.altKey && ev.keyCode !== KEY_WINDOWS) {
	                    // they're resuming typing; reset tab complete state vars.
	                    this.stopTabCompleting();
	                }
	
	                // explicitly pressing any key except tab removes passive mode. Tab doesn't remove
	                // passive mode because handleTabPress needs to know when passive mode is toggling
	                // off so it can resync the textarea/peek list. If tab did remove passive mode then
	                // handleTabPress would never be able to tell when passive mode toggled off.
	                this.inPassiveMode = false;
	
	                // pressing any key at all (except tab) restarts the automatic tab-complete timer
	                if (this.opts.autoEnterTabComplete) {
	                    (function () {
	                        var cachedText = ev.target.value;
	                        clearTimeout(_this2.enterTabCompleteTimerId);
	                        _this2.enterTabCompleteTimerId = setTimeout(function () {
	                            if (_this2.completing) {
	                                // If you highlight text and CTRL+X it, tab-completing will not be reset.
	                                // This check makes sure that if something like a cut operation has been
	                                // done, that we correctly refresh the tab-complete list. Normal backspace
	                                // operations get caught by the stopTabCompleting() section above, but
	                                // because the CTRL key is held, this does not execute for CTRL+X.
	                                if (cachedText !== _this2.textArea.value) {
	                                    _this2.stopTabCompleting();
	                                }
	                            }
	
	                            if (!_this2.completing) {
	                                _this2.handleTabPress(true, false);
	                            }
	                        }, DELAY_TIME_MS);
	                    })();
	                }
	
	                return;
	            }
	
	            // ctrl-tab/alt-tab etc shouldn't trigger a complete
	            if (ev.ctrlKey || ev.metaKey || ev.altKey) return;
	
	            // tab key has been pressed at this point
	            this.handleTabPress(false, ev.shiftKey);
	
	            // prevent the default TAB operation (typically focus shifting)
	            ev.preventDefault();
	        }
	
	        /**
	         * Set the textarea to the next value in the matched list.
	         * @param {Number} offset Offset to apply *before* setting the next value.
	         */
	
	    }, {
	        key: 'nextMatchedEntry',
	        value: function nextMatchedEntry(offset) {
	            var _this3 = this;
	
	            if (this.matchedList.length === 0) {
	                return;
	            }
	
	            // work out the new index, wrapping if necessary.
	            this.currentIndex += offset;
	            if (this.currentIndex >= this.matchedList.length) {
	                this.currentIndex = 0;
	            } else if (this.currentIndex < 0) {
	                this.currentIndex = this.matchedList.length - 1;
	            }
	            var isTransitioningToOriginalText =
	            // impossible to transition if they've never hit tab
	            !this.inPassiveMode && this.currentIndex === 0;
	
	            if (!this.inPassiveMode) {
	                // set textarea to this new value
	                this.textArea.value = this._replaceWith(this.matchedList[this.currentIndex].getFillText(), this.currentIndex !== 0, // don't suffix the original text!
	                this.matchedList[this.currentIndex].getSuffix(this.isFirstWord));
	            }
	
	            // visual display to the user that we looped - TODO: This should be configurable
	            if (isTransitioningToOriginalText) {
	                this.textArea.style["background-color"] = "#faa";
	                setTimeout(function () {
	                    // yay for lexical 'this'!
	                    _this3.textArea.style["background-color"] = "";
	                }, 150);
	
	                if (!this.opts.allowLooping) {
	                    this.stopTabCompleting();
	                }
	            } else {
	                this.textArea.style["background-color"] = ""; // cancel blinks TODO: required?
	            }
	        }
	    }, {
	        key: '_replaceWith',
	        value: function _replaceWith(newVal, includeSuffix, suffix) {
	            // The regex to replace the input matches a character of whitespace AND
	            // the partial word. If we just use string.replace() with the regex it will
	            // replace the partial word AND the character of whitespace. We want to
	            // preserve whatever that character is (\n, \t, etc) so find out what it is now.
	            var boundaryChar;
	            var res = MATCH_REGEX.exec(this.originalText);
	            if (res) {
	                boundaryChar = res[1]; // the first captured group
	            }
	            if (boundaryChar === undefined) {
	                console.warn("Failed to find boundary char on text: '%s'", this.originalText);
	                boundaryChar = "";
	            }
	
	            suffix = suffix || "";
	            if (!includeSuffix) {
	                suffix = "";
	            }
	
	            var replacementText = boundaryChar + newVal + suffix;
	            return this.originalText.replace(MATCH_REGEX, function () {
	                return replacementText; // function form to avoid `$` special-casing
	            });
	        }
	    }, {
	        key: '_notifyStateChange',
	        value: function _notifyStateChange() {
	            if (this.opts.onStateChange) {
	                this.opts.onStateChange(this.completing);
	            }
	        }
	    }, {
	        key: '_sortEntries',
	        value: function _sortEntries() {
	            var _this4 = this;
	
	            // largest comes first
	            var KIND_ORDER = {
	                command: 1,
	                member: 2
	            };
	
	            this.list.sort(function (a, b) {
	                var kindOrderDifference = KIND_ORDER[b.kind] - KIND_ORDER[a.kind];
	                if (kindOrderDifference != 0) {
	                    return kindOrderDifference;
	                }
	
	                if (a.kind == 'member') {
	                    var orderA = _this4.memberTabOrder[a.member.userId];
	                    var orderB = _this4.memberTabOrder[b.member.userId];
	                    if (orderA === undefined) orderA = -1;
	                    if (orderB === undefined) orderB = -1;
	
	                    return orderB - orderA;
	                }
	
	                // anything else we have no ordering for
	                return 0;
	            });
	        }
	    }, {
	        key: '_makeEntries',
	        value: function _makeEntries(room) {
	            var myUserId = _MatrixClientPeg2.default.get().credentials.userId;
	
	            var members = room.getJoinedMembers().filter(function (member) {
	                if (member.userId !== myUserId) return true;
	            });
	
	            this.list = _TabCompleteEntries.MemberEntry.fromMemberList(members).concat(_TabCompleteEntries.CommandEntry.fromCommands(_SlashCommands2.default.getCommandList()));
	        }
	    }, {
	        key: '_initSorting',
	        value: function _initSorting(room) {
	            this.memberTabOrder = {};
	            this.memberOrderSeq = 0;
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(room.getLiveTimeline().getEvents()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var ev = _step.value;
	
	                    this.memberTabOrder[ev.getSender()] = this.memberOrderSeq++;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }]);
	    return TabComplete;
	}();
	
	module.exports = TabComplete;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.startListening = startListening;
	exports.stopListening = stopListening;
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDialogOpen = false; /*
	                          Copyright 2017 Vector Creations Ltd
	                          
	                          Licensed under the Apache License, Version 2.0 (the "License");
	                          you may not use this file except in compliance with the License.
	                          You may obtain a copy of the License at
	                          
	                              http://www.apache.org/licenses/LICENSE-2.0
	                          
	                          Unless required by applicable law or agreed to in writing, software
	                          distributed under the License is distributed on an "AS IS" BASIS,
	                          WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                          See the License for the specific language governing permissions and
	                          limitations under the License.
	                          */
	
	var onAction = function onAction(payload) {
	    if (payload.action === 'unknown_device_error' && !isDialogOpen) {
	        var UnknownDeviceDialog = _index2.default.getComponent("dialogs.UnknownDeviceDialog");
	        isDialogOpen = true;
	        _Modal2.default.createDialog(UnknownDeviceDialog, {
	            devices: payload.err.devices,
	            room: payload.room,
	            onFinished: function onFinished(r) {
	                isDialogOpen = false;
	                // XXX: temporary logging to try to diagnose
	                // https://github.com/vector-im/riot-web/issues/3148
	                console.log('UnknownDeviceDialog closed with ' + r);
	            }
	        }, "mx_Dialog_unknownDevice");
	    }
	};
	
	var ref = null;
	
	function startListening() {
	    ref = _dispatcher2.default.register(onAction);
	}
	
	function stopListening() {
	    if (ref) {
	        _dispatcher2.default.unregister(ref);
	        ref = null;
	    }
	}


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _values = __webpack_require__(375);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactDom = __webpack_require__(18);
	var Velocity = __webpack_require__(233);
	
	/**
	 * The Velociraptor contains components and animates transitions with velocity.
	 * It will only pick up direct changes to properties ('left', currently), and so
	 * will not work for animating positional changes where the position is implicit
	 * from DOM order. This makes it a lot simpler and lighter: if you need fully
	 * automatic positional animation, look at react-shuffle or similar libraries.
	 */
	module.exports = React.createClass({
	    displayName: 'Velociraptor',
	
	    propTypes: {
	        // either a list of child nodes, or a single child.
	        children: React.PropTypes.any,
	
	        // optional transition information for changing existing children
	        transition: React.PropTypes.object,
	
	        // a list of state objects to apply to each child node in turn
	        startStyles: React.PropTypes.array,
	
	        // a list of transition options from the corresponding startStyle
	        enterTransitionOpts: React.PropTypes.array
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            startStyles: [],
	            enterTransitionOpts: []
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.nodes = {};
	        this._updateChildren(this.props.children);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this._updateChildren(nextProps.children);
	    },
	
	    /**
	     * update `this.children` according to the new list of children given
	     */
	    _updateChildren: function _updateChildren(newChildren) {
	        var self = this;
	        var oldChildren = this.children || {};
	        this.children = {};
	        React.Children.toArray(newChildren).forEach(function (c) {
	            if (oldChildren[c.key]) {
	                var old = oldChildren[c.key];
	                var oldNode = ReactDom.findDOMNode(self.nodes[old.key]);
	
	                if (oldNode && oldNode.style.left != c.props.style.left) {
	                    Velocity(oldNode, { left: c.props.style.left }, self.props.transition).then(function () {
	                        // special case visibility because it's nonsensical to animate an invisible element
	                        // so we always hidden->visible pre-transition and visible->hidden after
	                        if (oldNode.style.visibility == 'visible' && c.props.style.visibility == 'hidden') {
	                            oldNode.style.visibility = c.props.style.visibility;
	                        }
	                    });
	                    //console.log("translation: "+oldNode.style.left+" -> "+c.props.style.left);
	                }
	                if (oldNode.style.visibility == 'hidden' && c.props.style.visibility == 'visible') {
	                    oldNode.style.visibility = c.props.style.visibility;
	                }
	                self.children[c.key] = old;
	            } else {
	                // new element. If we have a startStyle, use that as the style and go through
	                // the enter animations
	                var newProps = {};
	                var restingStyle = c.props.style;
	
	                var startStyles = self.props.startStyles;
	                if (startStyles.length > 0) {
	                    var startStyle = startStyles[0];
	                    newProps.style = startStyle;
	                    // console.log("mounted@startstyle0: "+JSON.stringify(startStyle));
	                }
	
	                newProps.ref = function (n) {
	                    return self._collectNode(c.key, n, restingStyle);
	                };
	
	                self.children[c.key] = React.cloneElement(c, newProps);
	            }
	        });
	    },
	
	    /**
	     * called when a child element is mounted/unmounted
	     *
	     * @param {string}     k              key of the child
	     * @param {null|Object} node          On mount: React node. On unmount: null
	     * @param {Object}     restingStyle   final style
	     */
	    _collectNode: function _collectNode(k, node, restingStyle) {
	        var _this = this;
	
	        if (node && this.nodes[k] === undefined && this.props.startStyles.length > 0) {
	            var startStyles;
	            var transitionOpts;
	            var i;
	
	            (function () {
	                startStyles = _this.props.startStyles;
	                transitionOpts = _this.props.enterTransitionOpts;
	
	                var domNode = ReactDom.findDOMNode(node);
	                // start from startStyle 1: 0 is the one we gave it
	                // to start with, so now we animate 1 etc.
	                for (i = 1; i < startStyles.length; ++i) {
	                    Velocity(domNode, startStyles[i], transitionOpts[i - 1]);
	                    /*
	                    console.log("start:",
	                                JSON.stringify(transitionOpts[i-1]),
	                                "->",
	                                JSON.stringify(startStyles[i]),
	                                );
	                    */
	                }
	
	                // and then we animate to the resting state
	                Velocity(domNode, restingStyle, transitionOpts[i - 1]).then(function () {
	                    // once we've reached the resting state, hide the element if
	                    // appropriate
	                    domNode.style.visibility = restingStyle.visibility;
	                });
	
	                /*
	                console.log("enter:",
	                            JSON.stringify(transitionOpts[i-1]),
	                            "->",
	                            JSON.stringify(restingStyle));
	                */
	            })();
	        } else if (node === null) {
	            // Velocity stores data on elements using the jQuery .data()
	            // method, and assumes you'll be using jQuery's .remove() to
	            // remove the element, but we don't use jQuery, so we need to
	            // blow away the element's data explicitly otherwise it will leak.
	            // This uses Velocity's internal jQuery compatible wrapper.
	            // See the bug at
	            // https://github.com/julianshapiro/velocity/issues/300
	            // and the FAQ entry, "Preventing memory leaks when
	            // creating/destroying large numbers of elements"
	            // (https://github.com/julianshapiro/velocity/issues/47)
	            var domNode = ReactDom.findDOMNode(this.nodes[k]);
	            Velocity.Utilities.removeData(domNode);
	        }
	        this.nodes[k] = node;
	    },
	
	    render: function render() {
	        return React.createElement(
	            'span',
	            null,
	            (0, _values2.default)(this.children)
	        );
	    }
	});


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Velocity = __webpack_require__(233);
	
	// courtesy of https://github.com/julianshapiro/velocity/issues/283
	// We only use easeOutBounce (easeInBounce is just sort of nonsensical)
	function bounce(p) {
	    var pow2,
	        bounce = 4;
	
	    while (p < ((pow2 = Math.pow(2, --bounce)) - 1) / 11) {
	        // just sets pow2
	    }
	    return 1 / Math.pow(4, 3 - bounce) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - p, 2);
	}
	
	Velocity.Easings.easeOutBounce = function (p) {
	    return 1 - bounce(1 - p);
	};


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MatrixClientPeg = __webpack_require__(4);
	
	module.exports = {
	    usersTypingApartFromMe: function usersTypingApartFromMe(room) {
	        return this.usersTyping(room, [MatrixClientPeg.get().credentials.userId]);
	    },
	
	    /**
	     * Given a Room object and, optionally, a list of userID strings
	     * to exclude, return a list of user objects who are typing.
	     */
	    usersTyping: function usersTyping(room, exclude) {
	        var whoIsTyping = [];
	
	        if (exclude === undefined) {
	            exclude = [];
	        }
	
	        var memberKeys = (0, _keys2.default)(room.currentState.members);
	        for (var i = 0; i < memberKeys.length; ++i) {
	            var userId = memberKeys[i];
	
	            if (room.currentState.members[userId].typing) {
	                if (exclude.indexOf(userId) == -1) {
	                    whoIsTyping.push(room.currentState.members[userId]);
	                }
	            }
	        }
	
	        return whoIsTyping;
	    },
	
	    whoIsTypingString: function whoIsTypingString(whoIsTyping, limit) {
	        var othersCount = 0;
	        if (whoIsTyping.length > limit) {
	            othersCount = whoIsTyping.length - limit + 1;
	        }
	        if (whoIsTyping.length == 0) {
	            return '';
	        } else if (whoIsTyping.length == 1) {
	            return whoIsTyping[0].name + ' is typing';
	        }
	        var names = whoIsTyping.map(function (m) {
	            return m.name;
	        });
	        if (othersCount) {
	            var other = ' other' + (othersCount > 1 ? 's' : '');
	            return names.slice(0, limit - 1).join(', ') + ' and ' + othersCount + other + ' are typing';
	        } else {
	            var lastPerson = names.pop();
	            return names.join(', ') + ' and ' + lastPerson + ' are typing';
	        }
	    }
	};


/***/ }),
/* 1167 */,
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AutocompleteProvider2 = __webpack_require__(171);
	
	var _AutocompleteProvider3 = _interopRequireDefault(_AutocompleteProvider2);
	
	var _fuse = __webpack_require__(165);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	var _Components = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMMANDS = [{
	    command: '/me',
	    args: '<message>',
	    description: 'Displays action'
	}, {
	    command: '/ban',
	    args: '<user-id> [reason]',
	    description: 'Bans user with given id'
	}, {
	    command: '/deop',
	    args: '<user-id>',
	    description: 'Deops user with given id'
	}, {
	    command: '/invite',
	    args: '<user-id>',
	    description: 'Invites user with given id to current room'
	}, {
	    command: '/join',
	    args: '<room-alias>',
	    description: 'Joins room with given alias'
	}, {
	    command: '/kick',
	    args: '<user-id> [reason]',
	    description: 'Kicks user with given id'
	}, {
	    command: '/nick',
	    args: '<display-name>',
	    description: 'Changes your display nickname'
	}, {
	    command: '/ddg',
	    args: '<query>',
	    description: 'Searches DuckDuckGo for results'
	}];
	
	var COMMAND_RE = /(^\/\w*)/g;
	
	var instance = null;
	
	var CommandProvider = function (_AutocompleteProvider) {
	    (0, _inherits3.default)(CommandProvider, _AutocompleteProvider);
	
	    function CommandProvider() {
	        (0, _classCallCheck3.default)(this, CommandProvider);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CommandProvider.__proto__ || (0, _getPrototypeOf2.default)(CommandProvider)).call(this, COMMAND_RE));
	
	        _this.fuse = new _fuse2.default(COMMANDS, {
	            keys: ['command', 'args', 'description']
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(CommandProvider, [{
	        key: 'getCompletions',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, selection) {
	                var completions, _getCurrentCommand, command, range;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                completions = [];
	                                _getCurrentCommand = this.getCurrentCommand(query, selection), command = _getCurrentCommand.command, range = _getCurrentCommand.range;
	
	                                if (command) {
	                                    completions = this.fuse.search(command[0]).map(function (result) {
	                                        return {
	                                            completion: result.command + ' ',
	                                            component: _react2.default.createElement(_Components.TextualCompletion, {
	                                                title: result.command,
	                                                subtitle: result.args,
	                                                description: result.description
	                                            }),
	                                            range: range
	                                        };
	                                    });
	                                }
	                                return _context.abrupt('return', completions);
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getCompletions(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return getCompletions;
	        }()
	    }, {
	        key: 'getName',
	        value: function getName() {
	            return '*️⃣ Commands';
	        }
	    }, {
	        key: 'renderCompletions',
	        value: function renderCompletions(completions) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_Autocomplete_Completion_container_block' },
	                completions
	            );
	        }
	    }], [{
	        key: 'getInstance',
	        value: function getInstance() {
	            if (instance == null) {
	                instance = new CommandProvider();
	            }
	
	            return instance;
	        }
	    }]);
	    return CommandProvider;
	}(_AutocompleteProvider3.default);
	
	exports.default = CommandProvider;
	module.exports = exports['default'];


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AutocompleteProvider2 = __webpack_require__(171);
	
	var _AutocompleteProvider3 = _interopRequireDefault(_AutocompleteProvider2);
	
	__webpack_require__(524);
	
	var _Components = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DDG_REGEX = /\/ddg\s+(.+)$/g;
	var REFERRER = 'vector';
	
	var instance = null;
	
	var DuckDuckGoProvider = function (_AutocompleteProvider) {
	    (0, _inherits3.default)(DuckDuckGoProvider, _AutocompleteProvider);
	
	    function DuckDuckGoProvider() {
	        (0, _classCallCheck3.default)(this, DuckDuckGoProvider);
	        return (0, _possibleConstructorReturn3.default)(this, (DuckDuckGoProvider.__proto__ || (0, _getPrototypeOf2.default)(DuckDuckGoProvider)).call(this, DDG_REGEX));
	    }
	
	    (0, _createClass3.default)(DuckDuckGoProvider, [{
	        key: 'getCompletions',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, selection) {
	                var _getCurrentCommand, command, range, response, json, results;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _getCurrentCommand = this.getCurrentCommand(query, selection), command = _getCurrentCommand.command, range = _getCurrentCommand.range;
	
	                                if (!(!query || !command)) {
	                                    _context.next = 3;
	                                    break;
	                                }
	
	                                return _context.abrupt('return', []);
	
	                            case 3:
	                                _context.next = 5;
	                                return fetch(DuckDuckGoProvider.getQueryUri(command[1]), {
	                                    method: 'GET'
	                                });
	
	                            case 5:
	                                response = _context.sent;
	                                _context.next = 8;
	                                return response.json();
	
	                            case 8:
	                                json = _context.sent;
	                                results = json.Results.map(function (result) {
	                                    return {
	                                        completion: result.Text,
	                                        component: _react2.default.createElement(_Components.TextualCompletion, {
	                                            title: result.Text,
	                                            description: result.Result }),
	                                        range: range
	                                    };
	                                });
	
	                                if (json.Answer) {
	                                    results.unshift({
	                                        completion: json.Answer,
	                                        component: _react2.default.createElement(_Components.TextualCompletion, {
	                                            title: json.Answer,
	                                            description: json.AnswerType }),
	                                        range: range
	                                    });
	                                }
	                                if (json.RelatedTopics && json.RelatedTopics.length > 0) {
	                                    results.unshift({
	                                        completion: json.RelatedTopics[0].Text,
	                                        component: _react2.default.createElement(_Components.TextualCompletion, {
	                                            title: json.RelatedTopics[0].Text }),
	                                        range: range
	                                    });
	                                }
	                                if (json.AbstractText) {
	                                    results.unshift({
	                                        completion: json.AbstractText,
	                                        component: _react2.default.createElement(_Components.TextualCompletion, {
	                                            title: json.AbstractText }),
	                                        range: range
	                                    });
	                                }
	                                return _context.abrupt('return', results);
	
	                            case 14:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getCompletions(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return getCompletions;
	        }()
	    }, {
	        key: 'getName',
	        value: function getName() {
	            return '🔍 Results from DuckDuckGo';
	        }
	    }, {
	        key: 'renderCompletions',
	        value: function renderCompletions(completions) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_Autocomplete_Completion_container_block' },
	                completions
	            );
	        }
	    }], [{
	        key: 'getQueryUri',
	        value: function getQueryUri(query) {
	            return 'https://api.duckduckgo.com/?q=' + encodeURIComponent(query) + ('&format=json&no_redirect=1&no_html=1&t=' + encodeURIComponent(REFERRER));
	        }
	    }, {
	        key: 'getInstance',
	        value: function getInstance() {
	            if (instance == null) {
	                instance = new DuckDuckGoProvider();
	            }
	            return instance;
	        }
	    }]);
	    return DuckDuckGoProvider;
	}(_AutocompleteProvider3.default);
	
	exports.default = DuckDuckGoProvider;
	module.exports = exports['default'];


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AutocompleteProvider2 = __webpack_require__(171);
	
	var _AutocompleteProvider3 = _interopRequireDefault(_AutocompleteProvider2);
	
	var _emojione = __webpack_require__(338);
	
	var _fuse = __webpack_require__(165);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Components = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMOJI_REGEX = /:\w*:?/g;
	var EMOJI_SHORTNAMES = (0, _keys2.default)(_emojione.emojioneList);
	
	var instance = null;
	
	var EmojiProvider = function (_AutocompleteProvider) {
	    (0, _inherits3.default)(EmojiProvider, _AutocompleteProvider);
	
	    function EmojiProvider() {
	        (0, _classCallCheck3.default)(this, EmojiProvider);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiProvider.__proto__ || (0, _getPrototypeOf2.default)(EmojiProvider)).call(this, EMOJI_REGEX));
	
	        _this.fuse = new _fuse2.default(EMOJI_SHORTNAMES);
	        return _this;
	    }
	
	    (0, _createClass3.default)(EmojiProvider, [{
	        key: 'getCompletions',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, selection) {
	                var EmojiText, completions, _getCurrentCommand, command, range;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                EmojiText = _index2.default.getComponent('views.elements.EmojiText');
	                                completions = [];
	                                _getCurrentCommand = this.getCurrentCommand(query, selection), command = _getCurrentCommand.command, range = _getCurrentCommand.range;
	
	                                if (command) {
	                                    completions = this.fuse.search(command[0]).map(function (result) {
	                                        var shortname = EMOJI_SHORTNAMES[result];
	                                        var unicode = (0, _emojione.shortnameToUnicode)(shortname);
	                                        return {
	                                            completion: unicode,
	                                            component: _react2.default.createElement(_Components.PillCompletion, { title: shortname, initialComponent: _react2.default.createElement(
	                                                    EmojiText,
	                                                    { style: { maxWidth: '1em' } },
	                                                    unicode
	                                                ) }),
	                                            range: range
	                                        };
	                                    }).slice(0, 8);
	                                }
	                                return _context.abrupt('return', completions);
	
	                            case 5:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getCompletions(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return getCompletions;
	        }()
	    }, {
	        key: 'getName',
	        value: function getName() {
	            return '😃 Emoji';
	        }
	    }, {
	        key: 'renderCompletions',
	        value: function renderCompletions(completions) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_Autocomplete_Completion_container_pill' },
	                completions
	            );
	        }
	    }], [{
	        key: 'getInstance',
	        value: function getInstance() {
	            if (instance == null) {
	                instance = new EmojiProvider();
	            }
	            return instance;
	        }
	    }]);
	    return EmojiProvider;
	}(_AutocompleteProvider3.default);
	
	exports.default = EmojiProvider;
	module.exports = exports['default'];


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AutocompleteProvider2 = __webpack_require__(171);
	
	var _AutocompleteProvider3 = _interopRequireDefault(_AutocompleteProvider2);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _fuse = __webpack_require__(165);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	var _Components = __webpack_require__(172);
	
	var _Rooms = __webpack_require__(117);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROOM_REGEX = /(?=#)(\S*)/g;
	
	var instance = null;
	
	var RoomProvider = function (_AutocompleteProvider) {
	    (0, _inherits3.default)(RoomProvider, _AutocompleteProvider);
	
	    function RoomProvider() {
	        (0, _classCallCheck3.default)(this, RoomProvider);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (RoomProvider.__proto__ || (0, _getPrototypeOf2.default)(RoomProvider)).call(this, ROOM_REGEX, {
	            keys: ['displayName', 'userId']
	        }));
	
	        _this.fuse = new _fuse2.default([], {
	            keys: ['name', 'roomId', 'aliases']
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(RoomProvider, [{
	        key: 'getCompletions',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, selection) {
	                var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	                var RoomAvatar, client, completions, _getCurrentCommand, command, range;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                RoomAvatar = _index2.default.getComponent('views.avatars.RoomAvatar');
	                                client = _MatrixClientPeg2.default.get();
	                                completions = [];
	                                _getCurrentCommand = this.getCurrentCommand(query, selection, force), command = _getCurrentCommand.command, range = _getCurrentCommand.range;
	
	                                if (command) {
	                                    // the only reason we need to do this is because Fuse only matches on properties
	                                    this.fuse.set(client.getRooms().filter(function (room) {
	                                        return !!room;
	                                    }).map(function (room) {
	                                        return {
	                                            room: room,
	                                            name: room.name,
	                                            aliases: room.getAliases()
	                                        };
	                                    }));
	                                    completions = this.fuse.search(command[0]).map(function (room) {
	                                        var displayAlias = (0, _Rooms.getDisplayAliasForRoom)(room.room) || room.roomId;
	                                        return {
	                                            completion: displayAlias,
	                                            component: _react2.default.createElement(_Components.PillCompletion, { initialComponent: _react2.default.createElement(RoomAvatar, { width: 24, height: 24, room: room.room }), title: room.name, description: displayAlias }),
	                                            range: range
	                                        };
	                                    }).filter(function (completion) {
	                                        return !!completion.completion && completion.completion.length > 0;
	                                    }).slice(0, 4);
	                                }
	                                return _context.abrupt('return', completions);
	
	                            case 6:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getCompletions(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return getCompletions;
	        }()
	    }, {
	        key: 'getName',
	        value: function getName() {
	            return '💬 Rooms';
	        }
	    }, {
	        key: 'renderCompletions',
	        value: function renderCompletions(completions) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_Autocomplete_Completion_container_pill' },
	                completions
	            );
	        }
	    }, {
	        key: 'shouldForceComplete',
	        value: function shouldForceComplete() {
	            return true;
	        }
	    }], [{
	        key: 'getInstance',
	        value: function getInstance() {
	            if (instance == null) {
	                instance = new RoomProvider();
	            }
	
	            return instance;
	        }
	    }]);
	    return RoomProvider;
	}(_AutocompleteProvider3.default);
	
	exports.default = RoomProvider;
	module.exports = exports['default'];


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ContextualMenu = __webpack_require__(222);
	
	var _ContextualMenu2 = _interopRequireDefault(_ContextualMenu);
	
	var _CreateRoom = __webpack_require__(1173);
	
	var _CreateRoom2 = _interopRequireDefault(_CreateRoom);
	
	var _FilePanel = __webpack_require__(1174);
	
	var _FilePanel2 = _interopRequireDefault(_FilePanel);
	
	var _InteractiveAuth = __webpack_require__(1175);
	
	var _InteractiveAuth2 = _interopRequireDefault(_InteractiveAuth);
	
	var _LoggedInView = __webpack_require__(1176);
	
	var _LoggedInView2 = _interopRequireDefault(_LoggedInView);
	
	var _MatrixChat = __webpack_require__(1177);
	
	var _MatrixChat2 = _interopRequireDefault(_MatrixChat);
	
	var _MessagePanel = __webpack_require__(1178);
	
	var _MessagePanel2 = _interopRequireDefault(_MessagePanel);
	
	var _NotificationPanel = __webpack_require__(1179);
	
	var _NotificationPanel2 = _interopRequireDefault(_NotificationPanel);
	
	var _RoomStatusBar = __webpack_require__(1180);
	
	var _RoomStatusBar2 = _interopRequireDefault(_RoomStatusBar);
	
	var _RoomView = __webpack_require__(1181);
	
	var _RoomView2 = _interopRequireDefault(_RoomView);
	
	var _ScrollPanel = __webpack_require__(1182);
	
	var _ScrollPanel2 = _interopRequireDefault(_ScrollPanel);
	
	var _TimelinePanel = __webpack_require__(1183);
	
	var _TimelinePanel2 = _interopRequireDefault(_TimelinePanel);
	
	var _UploadBar = __webpack_require__(1184);
	
	var _UploadBar2 = _interopRequireDefault(_UploadBar);
	
	var _UserSettings = __webpack_require__(1185);
	
	var _UserSettings2 = _interopRequireDefault(_UserSettings);
	
	var _ForgotPassword = __webpack_require__(1186);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _Login = __webpack_require__(1187);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _PostRegistration = __webpack_require__(1188);
	
	var _PostRegistration2 = _interopRequireDefault(_PostRegistration);
	
	var _Registration = __webpack_require__(1189);
	
	var _Registration2 = _interopRequireDefault(_Registration);
	
	var _BaseAvatar = __webpack_require__(1190);
	
	var _BaseAvatar2 = _interopRequireDefault(_BaseAvatar);
	
	var _MemberAvatar = __webpack_require__(334);
	
	var _MemberAvatar2 = _interopRequireDefault(_MemberAvatar);
	
	var _RoomAvatar = __webpack_require__(1191);
	
	var _RoomAvatar2 = _interopRequireDefault(_RoomAvatar);
	
	var _CreateRoomButton = __webpack_require__(1192);
	
	var _CreateRoomButton2 = _interopRequireDefault(_CreateRoomButton);
	
	var _Presets = __webpack_require__(1193);
	
	var _Presets2 = _interopRequireDefault(_Presets);
	
	var _RoomAlias = __webpack_require__(1194);
	
	var _RoomAlias2 = _interopRequireDefault(_RoomAlias);
	
	var _BaseDialog = __webpack_require__(1195);
	
	var _BaseDialog2 = _interopRequireDefault(_BaseDialog);
	
	var _ChatCreateOrReuseDialog = __webpack_require__(1196);
	
	var _ChatCreateOrReuseDialog2 = _interopRequireDefault(_ChatCreateOrReuseDialog);
	
	var _ChatInviteDialog = __webpack_require__(1197);
	
	var _ChatInviteDialog2 = _interopRequireDefault(_ChatInviteDialog);
	
	var _ConfirmRedactDialog = __webpack_require__(1198);
	
	var _ConfirmRedactDialog2 = _interopRequireDefault(_ConfirmRedactDialog);
	
	var _ConfirmUserActionDialog = __webpack_require__(1199);
	
	var _ConfirmUserActionDialog2 = _interopRequireDefault(_ConfirmUserActionDialog);
	
	var _DeactivateAccountDialog = __webpack_require__(1200);
	
	var _DeactivateAccountDialog2 = _interopRequireDefault(_DeactivateAccountDialog);
	
	var _ErrorDialog = __webpack_require__(1201);
	
	var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);
	
	var _InteractiveAuthDialog = __webpack_require__(1202);
	
	var _InteractiveAuthDialog2 = _interopRequireDefault(_InteractiveAuthDialog);
	
	var _NeedToRegisterDialog = __webpack_require__(1203);
	
	var _NeedToRegisterDialog2 = _interopRequireDefault(_NeedToRegisterDialog);
	
	var _QuestionDialog = __webpack_require__(1204);
	
	var _QuestionDialog2 = _interopRequireDefault(_QuestionDialog);
	
	var _SessionRestoreErrorDialog = __webpack_require__(1205);
	
	var _SessionRestoreErrorDialog2 = _interopRequireDefault(_SessionRestoreErrorDialog);
	
	var _SetDisplayNameDialog = __webpack_require__(1206);
	
	var _SetDisplayNameDialog2 = _interopRequireDefault(_SetDisplayNameDialog);
	
	var _TextInputDialog = __webpack_require__(1207);
	
	var _TextInputDialog2 = _interopRequireDefault(_TextInputDialog);
	
	var _UnknownDeviceDialog = __webpack_require__(1208);
	
	var _UnknownDeviceDialog2 = _interopRequireDefault(_UnknownDeviceDialog);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	var _AddressSelector = __webpack_require__(1209);
	
	var _AddressSelector2 = _interopRequireDefault(_AddressSelector);
	
	var _AddressTile = __webpack_require__(509);
	
	var _AddressTile2 = _interopRequireDefault(_AddressTile);
	
	var _DeviceVerifyButtons = __webpack_require__(1210);
	
	var _DeviceVerifyButtons2 = _interopRequireDefault(_DeviceVerifyButtons);
	
	var _DirectorySearchBox = __webpack_require__(1211);
	
	var _DirectorySearchBox2 = _interopRequireDefault(_DirectorySearchBox);
	
	var _Dropdown = __webpack_require__(1212);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _EditableText = __webpack_require__(1213);
	
	var _EditableText2 = _interopRequireDefault(_EditableText);
	
	var _EditableTextContainer = __webpack_require__(1214);
	
	var _EditableTextContainer2 = _interopRequireDefault(_EditableTextContainer);
	
	var _EmojiText = __webpack_require__(1215);
	
	var _EmojiText2 = _interopRequireDefault(_EmojiText);
	
	var _MemberEventListSummary = __webpack_require__(1216);
	
	var _MemberEventListSummary2 = _interopRequireDefault(_MemberEventListSummary);
	
	var _PowerSelector = __webpack_require__(1217);
	
	var _PowerSelector2 = _interopRequireDefault(_PowerSelector);
	
	var _ProgressBar = __webpack_require__(1218);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _TintableSvg = __webpack_require__(1219);
	
	var _TintableSvg2 = _interopRequireDefault(_TintableSvg);
	
	var _TruncatedList = __webpack_require__(1220);
	
	var _TruncatedList2 = _interopRequireDefault(_TruncatedList);
	
	var _UserSelector = __webpack_require__(1221);
	
	var _UserSelector2 = _interopRequireDefault(_UserSelector);
	
	var _CaptchaForm = __webpack_require__(510);
	
	var _CaptchaForm2 = _interopRequireDefault(_CaptchaForm);
	
	var _CasLogin = __webpack_require__(511);
	
	var _CasLogin2 = _interopRequireDefault(_CasLogin);
	
	var _CountryDropdown = __webpack_require__(1222);
	
	var _CountryDropdown2 = _interopRequireDefault(_CountryDropdown);
	
	var _CustomServerDialog = __webpack_require__(1223);
	
	var _CustomServerDialog2 = _interopRequireDefault(_CustomServerDialog);
	
	var _InteractiveAuthEntryComponents = __webpack_require__(512);
	
	var _InteractiveAuthEntryComponents2 = _interopRequireDefault(_InteractiveAuthEntryComponents);
	
	var _LoginFooter = __webpack_require__(1224);
	
	var _LoginFooter2 = _interopRequireDefault(_LoginFooter);
	
	var _LoginHeader = __webpack_require__(1225);
	
	var _LoginHeader2 = _interopRequireDefault(_LoginHeader);
	
	var _PasswordLogin = __webpack_require__(513);
	
	var _PasswordLogin2 = _interopRequireDefault(_PasswordLogin);
	
	var _RegistrationForm = __webpack_require__(514);
	
	var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);
	
	var _ServerConfig = __webpack_require__(335);
	
	var _ServerConfig2 = _interopRequireDefault(_ServerConfig);
	
	var _MAudioBody = __webpack_require__(1226);
	
	var _MAudioBody2 = _interopRequireDefault(_MAudioBody);
	
	var _MFileBody = __webpack_require__(223);
	
	var _MFileBody2 = _interopRequireDefault(_MFileBody);
	
	var _MImageBody = __webpack_require__(1227);
	
	var _MImageBody2 = _interopRequireDefault(_MImageBody);
	
	var _MVideoBody = __webpack_require__(1228);
	
	var _MVideoBody2 = _interopRequireDefault(_MVideoBody);
	
	var _MessageEvent = __webpack_require__(1229);
	
	var _MessageEvent2 = _interopRequireDefault(_MessageEvent);
	
	var _SenderProfile = __webpack_require__(1230);
	
	var _SenderProfile2 = _interopRequireDefault(_SenderProfile);
	
	var _TextualBody = __webpack_require__(1231);
	
	var _TextualBody2 = _interopRequireDefault(_TextualBody);
	
	var _TextualEvent = __webpack_require__(1232);
	
	var _TextualEvent2 = _interopRequireDefault(_TextualEvent);
	
	var _UnknownBody = __webpack_require__(1233);
	
	var _UnknownBody2 = _interopRequireDefault(_UnknownBody);
	
	var _AliasSettings = __webpack_require__(1234);
	
	var _AliasSettings2 = _interopRequireDefault(_AliasSettings);
	
	var _ColorSettings = __webpack_require__(1235);
	
	var _ColorSettings2 = _interopRequireDefault(_ColorSettings);
	
	var _UrlPreviewSettings = __webpack_require__(1236);
	
	var _UrlPreviewSettings2 = _interopRequireDefault(_UrlPreviewSettings);
	
	var _Autocomplete = __webpack_require__(336);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _AuxPanel = __webpack_require__(1237);
	
	var _AuxPanel2 = _interopRequireDefault(_AuxPanel);
	
	var _EntityTile = __webpack_require__(1238);
	
	var _EntityTile2 = _interopRequireDefault(_EntityTile);
	
	var _EventTile = __webpack_require__(1239);
	
	var _EventTile2 = _interopRequireDefault(_EventTile);
	
	var _LinkPreviewWidget = __webpack_require__(1240);
	
	var _LinkPreviewWidget2 = _interopRequireDefault(_LinkPreviewWidget);
	
	var _MemberDeviceInfo = __webpack_require__(1241);
	
	var _MemberDeviceInfo2 = _interopRequireDefault(_MemberDeviceInfo);
	
	var _MemberInfo = __webpack_require__(1242);
	
	var _MemberInfo2 = _interopRequireDefault(_MemberInfo);
	
	var _MemberList = __webpack_require__(1243);
	
	var _MemberList2 = _interopRequireDefault(_MemberList);
	
	var _MemberTile = __webpack_require__(1244);
	
	var _MemberTile2 = _interopRequireDefault(_MemberTile);
	
	var _MessageComposer = __webpack_require__(1245);
	
	var _MessageComposer2 = _interopRequireDefault(_MessageComposer);
	
	var _MessageComposerInput = __webpack_require__(1246);
	
	var _MessageComposerInput2 = _interopRequireDefault(_MessageComposerInput);
	
	var _MessageComposerInputOld = __webpack_require__(515);
	
	var _MessageComposerInputOld2 = _interopRequireDefault(_MessageComposerInputOld);
	
	var _PresenceLabel = __webpack_require__(1247);
	
	var _PresenceLabel2 = _interopRequireDefault(_PresenceLabel);
	
	var _ReadReceiptMarker = __webpack_require__(1248);
	
	var _ReadReceiptMarker2 = _interopRequireDefault(_ReadReceiptMarker);
	
	var _RoomHeader = __webpack_require__(1249);
	
	var _RoomHeader2 = _interopRequireDefault(_RoomHeader);
	
	var _RoomList = __webpack_require__(1250);
	
	var _RoomList2 = _interopRequireDefault(_RoomList);
	
	var _RoomNameEditor = __webpack_require__(1251);
	
	var _RoomNameEditor2 = _interopRequireDefault(_RoomNameEditor);
	
	var _RoomPreviewBar = __webpack_require__(1252);
	
	var _RoomPreviewBar2 = _interopRequireDefault(_RoomPreviewBar);
	
	var _RoomSettings = __webpack_require__(1253);
	
	var _RoomSettings2 = _interopRequireDefault(_RoomSettings);
	
	var _RoomTile = __webpack_require__(516);
	
	var _RoomTile2 = _interopRequireDefault(_RoomTile);
	
	var _RoomTopicEditor = __webpack_require__(1254);
	
	var _RoomTopicEditor2 = _interopRequireDefault(_RoomTopicEditor);
	
	var _SearchResultTile = __webpack_require__(1255);
	
	var _SearchResultTile2 = _interopRequireDefault(_SearchResultTile);
	
	var _SearchableEntityList = __webpack_require__(1256);
	
	var _SearchableEntityList2 = _interopRequireDefault(_SearchableEntityList);
	
	var _SimpleRoomHeader = __webpack_require__(517);
	
	var _SimpleRoomHeader2 = _interopRequireDefault(_SimpleRoomHeader);
	
	var _TabCompleteBar = __webpack_require__(1257);
	
	var _TabCompleteBar2 = _interopRequireDefault(_TabCompleteBar);
	
	var _TopUnreadMessagesBar = __webpack_require__(1258);
	
	var _TopUnreadMessagesBar2 = _interopRequireDefault(_TopUnreadMessagesBar);
	
	var _UserTile = __webpack_require__(1259);
	
	var _UserTile2 = _interopRequireDefault(_UserTile);
	
	var _AddPhoneNumber = __webpack_require__(1260);
	
	var _AddPhoneNumber2 = _interopRequireDefault(_AddPhoneNumber);
	
	var _ChangeAvatar = __webpack_require__(1261);
	
	var _ChangeAvatar2 = _interopRequireDefault(_ChangeAvatar);
	
	var _ChangeDisplayName = __webpack_require__(1262);
	
	var _ChangeDisplayName2 = _interopRequireDefault(_ChangeDisplayName);
	
	var _ChangePassword = __webpack_require__(1263);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _DevicesPanel = __webpack_require__(1264);
	
	var _DevicesPanel2 = _interopRequireDefault(_DevicesPanel);
	
	var _DevicesPanelEntry = __webpack_require__(1265);
	
	var _DevicesPanelEntry2 = _interopRequireDefault(_DevicesPanelEntry);
	
	var _EnableNotificationsButton = __webpack_require__(1266);
	
	var _EnableNotificationsButton2 = _interopRequireDefault(_EnableNotificationsButton);
	
	var _CallView = __webpack_require__(1267);
	
	var _CallView2 = _interopRequireDefault(_CallView);
	
	var _IncomingCallBox = __webpack_require__(1268);
	
	var _IncomingCallBox2 = _interopRequireDefault(_IncomingCallBox);
	
	var _VideoFeed = __webpack_require__(1269);
	
	var _VideoFeed2 = _interopRequireDefault(_VideoFeed);
	
	var _VideoView = __webpack_require__(1270);
	
	var _VideoView2 = _interopRequireDefault(_VideoView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/*
	 * THIS FILE IS AUTO-GENERATED
	 * You can edit it you like, but your changes will be overwritten,
	 * so you'd just be trying to swim upstream like a salmon.
	 * You are not a salmon.
	 *
	 * To update it, run:
	 *    ./reskindex.js -h header
	 */
	
	module.exports.components = {};
	
	_ContextualMenu2.default && (module.exports.components['structures.ContextualMenu'] = _ContextualMenu2.default);
	
	_CreateRoom2.default && (module.exports.components['structures.CreateRoom'] = _CreateRoom2.default);
	
	_FilePanel2.default && (module.exports.components['structures.FilePanel'] = _FilePanel2.default);
	
	_InteractiveAuth2.default && (module.exports.components['structures.InteractiveAuth'] = _InteractiveAuth2.default);
	
	_LoggedInView2.default && (module.exports.components['structures.LoggedInView'] = _LoggedInView2.default);
	
	_MatrixChat2.default && (module.exports.components['structures.MatrixChat'] = _MatrixChat2.default);
	
	_MessagePanel2.default && (module.exports.components['structures.MessagePanel'] = _MessagePanel2.default);
	
	_NotificationPanel2.default && (module.exports.components['structures.NotificationPanel'] = _NotificationPanel2.default);
	
	_RoomStatusBar2.default && (module.exports.components['structures.RoomStatusBar'] = _RoomStatusBar2.default);
	
	_RoomView2.default && (module.exports.components['structures.RoomView'] = _RoomView2.default);
	
	_ScrollPanel2.default && (module.exports.components['structures.ScrollPanel'] = _ScrollPanel2.default);
	
	_TimelinePanel2.default && (module.exports.components['structures.TimelinePanel'] = _TimelinePanel2.default);
	
	_UploadBar2.default && (module.exports.components['structures.UploadBar'] = _UploadBar2.default);
	
	_UserSettings2.default && (module.exports.components['structures.UserSettings'] = _UserSettings2.default);
	
	_ForgotPassword2.default && (module.exports.components['structures.login.ForgotPassword'] = _ForgotPassword2.default);
	
	_Login2.default && (module.exports.components['structures.login.Login'] = _Login2.default);
	
	_PostRegistration2.default && (module.exports.components['structures.login.PostRegistration'] = _PostRegistration2.default);
	
	_Registration2.default && (module.exports.components['structures.login.Registration'] = _Registration2.default);
	
	_BaseAvatar2.default && (module.exports.components['views.avatars.BaseAvatar'] = _BaseAvatar2.default);
	
	_MemberAvatar2.default && (module.exports.components['views.avatars.MemberAvatar'] = _MemberAvatar2.default);
	
	_RoomAvatar2.default && (module.exports.components['views.avatars.RoomAvatar'] = _RoomAvatar2.default);
	
	_CreateRoomButton2.default && (module.exports.components['views.create_room.CreateRoomButton'] = _CreateRoomButton2.default);
	
	_Presets2.default && (module.exports.components['views.create_room.Presets'] = _Presets2.default);
	
	_RoomAlias2.default && (module.exports.components['views.create_room.RoomAlias'] = _RoomAlias2.default);
	
	_BaseDialog2.default && (module.exports.components['views.dialogs.BaseDialog'] = _BaseDialog2.default);
	
	_ChatCreateOrReuseDialog2.default && (module.exports.components['views.dialogs.ChatCreateOrReuseDialog'] = _ChatCreateOrReuseDialog2.default);
	
	_ChatInviteDialog2.default && (module.exports.components['views.dialogs.ChatInviteDialog'] = _ChatInviteDialog2.default);
	
	_ConfirmRedactDialog2.default && (module.exports.components['views.dialogs.ConfirmRedactDialog'] = _ConfirmRedactDialog2.default);
	
	_ConfirmUserActionDialog2.default && (module.exports.components['views.dialogs.ConfirmUserActionDialog'] = _ConfirmUserActionDialog2.default);
	
	_DeactivateAccountDialog2.default && (module.exports.components['views.dialogs.DeactivateAccountDialog'] = _DeactivateAccountDialog2.default);
	
	_ErrorDialog2.default && (module.exports.components['views.dialogs.ErrorDialog'] = _ErrorDialog2.default);
	
	_InteractiveAuthDialog2.default && (module.exports.components['views.dialogs.InteractiveAuthDialog'] = _InteractiveAuthDialog2.default);
	
	_NeedToRegisterDialog2.default && (module.exports.components['views.dialogs.NeedToRegisterDialog'] = _NeedToRegisterDialog2.default);
	
	_QuestionDialog2.default && (module.exports.components['views.dialogs.QuestionDialog'] = _QuestionDialog2.default);
	
	_SessionRestoreErrorDialog2.default && (module.exports.components['views.dialogs.SessionRestoreErrorDialog'] = _SessionRestoreErrorDialog2.default);
	
	_SetDisplayNameDialog2.default && (module.exports.components['views.dialogs.SetDisplayNameDialog'] = _SetDisplayNameDialog2.default);
	
	_TextInputDialog2.default && (module.exports.components['views.dialogs.TextInputDialog'] = _TextInputDialog2.default);
	
	_UnknownDeviceDialog2.default && (module.exports.components['views.dialogs.UnknownDeviceDialog'] = _UnknownDeviceDialog2.default);
	
	_AccessibleButton2.default && (module.exports.components['views.elements.AccessibleButton'] = _AccessibleButton2.default);
	
	_AddressSelector2.default && (module.exports.components['views.elements.AddressSelector'] = _AddressSelector2.default);
	
	_AddressTile2.default && (module.exports.components['views.elements.AddressTile'] = _AddressTile2.default);
	
	_DeviceVerifyButtons2.default && (module.exports.components['views.elements.DeviceVerifyButtons'] = _DeviceVerifyButtons2.default);
	
	_DirectorySearchBox2.default && (module.exports.components['views.elements.DirectorySearchBox'] = _DirectorySearchBox2.default);
	
	_Dropdown2.default && (module.exports.components['views.elements.Dropdown'] = _Dropdown2.default);
	
	_EditableText2.default && (module.exports.components['views.elements.EditableText'] = _EditableText2.default);
	
	_EditableTextContainer2.default && (module.exports.components['views.elements.EditableTextContainer'] = _EditableTextContainer2.default);
	
	_EmojiText2.default && (module.exports.components['views.elements.EmojiText'] = _EmojiText2.default);
	
	_MemberEventListSummary2.default && (module.exports.components['views.elements.MemberEventListSummary'] = _MemberEventListSummary2.default);
	
	_PowerSelector2.default && (module.exports.components['views.elements.PowerSelector'] = _PowerSelector2.default);
	
	_ProgressBar2.default && (module.exports.components['views.elements.ProgressBar'] = _ProgressBar2.default);
	
	_TintableSvg2.default && (module.exports.components['views.elements.TintableSvg'] = _TintableSvg2.default);
	
	_TruncatedList2.default && (module.exports.components['views.elements.TruncatedList'] = _TruncatedList2.default);
	
	_UserSelector2.default && (module.exports.components['views.elements.UserSelector'] = _UserSelector2.default);
	
	_CaptchaForm2.default && (module.exports.components['views.login.CaptchaForm'] = _CaptchaForm2.default);
	
	_CasLogin2.default && (module.exports.components['views.login.CasLogin'] = _CasLogin2.default);
	
	_CountryDropdown2.default && (module.exports.components['views.login.CountryDropdown'] = _CountryDropdown2.default);
	
	_CustomServerDialog2.default && (module.exports.components['views.login.CustomServerDialog'] = _CustomServerDialog2.default);
	
	_InteractiveAuthEntryComponents2.default && (module.exports.components['views.login.InteractiveAuthEntryComponents'] = _InteractiveAuthEntryComponents2.default);
	
	_LoginFooter2.default && (module.exports.components['views.login.LoginFooter'] = _LoginFooter2.default);
	
	_LoginHeader2.default && (module.exports.components['views.login.LoginHeader'] = _LoginHeader2.default);
	
	_PasswordLogin2.default && (module.exports.components['views.login.PasswordLogin'] = _PasswordLogin2.default);
	
	_RegistrationForm2.default && (module.exports.components['views.login.RegistrationForm'] = _RegistrationForm2.default);
	
	_ServerConfig2.default && (module.exports.components['views.login.ServerConfig'] = _ServerConfig2.default);
	
	_MAudioBody2.default && (module.exports.components['views.messages.MAudioBody'] = _MAudioBody2.default);
	
	_MFileBody2.default && (module.exports.components['views.messages.MFileBody'] = _MFileBody2.default);
	
	_MImageBody2.default && (module.exports.components['views.messages.MImageBody'] = _MImageBody2.default);
	
	_MVideoBody2.default && (module.exports.components['views.messages.MVideoBody'] = _MVideoBody2.default);
	
	_MessageEvent2.default && (module.exports.components['views.messages.MessageEvent'] = _MessageEvent2.default);
	
	_SenderProfile2.default && (module.exports.components['views.messages.SenderProfile'] = _SenderProfile2.default);
	
	_TextualBody2.default && (module.exports.components['views.messages.TextualBody'] = _TextualBody2.default);
	
	_TextualEvent2.default && (module.exports.components['views.messages.TextualEvent'] = _TextualEvent2.default);
	
	_UnknownBody2.default && (module.exports.components['views.messages.UnknownBody'] = _UnknownBody2.default);
	
	_AliasSettings2.default && (module.exports.components['views.room_settings.AliasSettings'] = _AliasSettings2.default);
	
	_ColorSettings2.default && (module.exports.components['views.room_settings.ColorSettings'] = _ColorSettings2.default);
	
	_UrlPreviewSettings2.default && (module.exports.components['views.room_settings.UrlPreviewSettings'] = _UrlPreviewSettings2.default);
	
	_Autocomplete2.default && (module.exports.components['views.rooms.Autocomplete'] = _Autocomplete2.default);
	
	_AuxPanel2.default && (module.exports.components['views.rooms.AuxPanel'] = _AuxPanel2.default);
	
	_EntityTile2.default && (module.exports.components['views.rooms.EntityTile'] = _EntityTile2.default);
	
	_EventTile2.default && (module.exports.components['views.rooms.EventTile'] = _EventTile2.default);
	
	_LinkPreviewWidget2.default && (module.exports.components['views.rooms.LinkPreviewWidget'] = _LinkPreviewWidget2.default);
	
	_MemberDeviceInfo2.default && (module.exports.components['views.rooms.MemberDeviceInfo'] = _MemberDeviceInfo2.default);
	
	_MemberInfo2.default && (module.exports.components['views.rooms.MemberInfo'] = _MemberInfo2.default);
	
	_MemberList2.default && (module.exports.components['views.rooms.MemberList'] = _MemberList2.default);
	
	_MemberTile2.default && (module.exports.components['views.rooms.MemberTile'] = _MemberTile2.default);
	
	_MessageComposer2.default && (module.exports.components['views.rooms.MessageComposer'] = _MessageComposer2.default);
	
	_MessageComposerInput2.default && (module.exports.components['views.rooms.MessageComposerInput'] = _MessageComposerInput2.default);
	
	_MessageComposerInputOld2.default && (module.exports.components['views.rooms.MessageComposerInputOld'] = _MessageComposerInputOld2.default);
	
	_PresenceLabel2.default && (module.exports.components['views.rooms.PresenceLabel'] = _PresenceLabel2.default);
	
	_ReadReceiptMarker2.default && (module.exports.components['views.rooms.ReadReceiptMarker'] = _ReadReceiptMarker2.default);
	
	_RoomHeader2.default && (module.exports.components['views.rooms.RoomHeader'] = _RoomHeader2.default);
	
	_RoomList2.default && (module.exports.components['views.rooms.RoomList'] = _RoomList2.default);
	
	_RoomNameEditor2.default && (module.exports.components['views.rooms.RoomNameEditor'] = _RoomNameEditor2.default);
	
	_RoomPreviewBar2.default && (module.exports.components['views.rooms.RoomPreviewBar'] = _RoomPreviewBar2.default);
	
	_RoomSettings2.default && (module.exports.components['views.rooms.RoomSettings'] = _RoomSettings2.default);
	
	_RoomTile2.default && (module.exports.components['views.rooms.RoomTile'] = _RoomTile2.default);
	
	_RoomTopicEditor2.default && (module.exports.components['views.rooms.RoomTopicEditor'] = _RoomTopicEditor2.default);
	
	_SearchResultTile2.default && (module.exports.components['views.rooms.SearchResultTile'] = _SearchResultTile2.default);
	
	_SearchableEntityList2.default && (module.exports.components['views.rooms.SearchableEntityList'] = _SearchableEntityList2.default);
	
	_SimpleRoomHeader2.default && (module.exports.components['views.rooms.SimpleRoomHeader'] = _SimpleRoomHeader2.default);
	
	_TabCompleteBar2.default && (module.exports.components['views.rooms.TabCompleteBar'] = _TabCompleteBar2.default);
	
	_TopUnreadMessagesBar2.default && (module.exports.components['views.rooms.TopUnreadMessagesBar'] = _TopUnreadMessagesBar2.default);
	
	_UserTile2.default && (module.exports.components['views.rooms.UserTile'] = _UserTile2.default);
	
	_AddPhoneNumber2.default && (module.exports.components['views.settings.AddPhoneNumber'] = _AddPhoneNumber2.default);
	
	_ChangeAvatar2.default && (module.exports.components['views.settings.ChangeAvatar'] = _ChangeAvatar2.default);
	
	_ChangeDisplayName2.default && (module.exports.components['views.settings.ChangeDisplayName'] = _ChangeDisplayName2.default);
	
	_ChangePassword2.default && (module.exports.components['views.settings.ChangePassword'] = _ChangePassword2.default);
	
	_DevicesPanel2.default && (module.exports.components['views.settings.DevicesPanel'] = _DevicesPanel2.default);
	
	_DevicesPanelEntry2.default && (module.exports.components['views.settings.DevicesPanelEntry'] = _DevicesPanelEntry2.default);
	
	_EnableNotificationsButton2.default && (module.exports.components['views.settings.EnableNotificationsButton'] = _EnableNotificationsButton2.default);
	
	_CallView2.default && (module.exports.components['views.voip.CallView'] = _CallView2.default);
	
	_IncomingCallBox2.default && (module.exports.components['views.voip.IncomingCallBox'] = _IncomingCallBox2.default);
	
	_VideoFeed2.default && (module.exports.components['views.voip.VideoFeed'] = _VideoFeed2.default);
	
	_VideoView2.default && (module.exports.components['views.voip.VideoView'] = _VideoView2.default);


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var PresetValues = {
	    PrivateChat: "private_chat",
	    PublicChat: "public_chat",
	    Custom: "custom"
	};
	var q = __webpack_require__(6);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'CreateRoom',
	
	    propTypes: {
	        onRoomCreated: React.PropTypes.func,
	        collapsedRhs: React.PropTypes.bool
	    },
	
	    phases: {
	        CONFIG: "CONFIG", // We're waiting for user to configure and hit create.
	        CREATING: "CREATING", // We're sending the request.
	        CREATED: "CREATED", // We successfully created the room.
	        ERROR: "ERROR" },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onRoomCreated: function onRoomCreated() {}
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            phase: this.phases.CONFIG,
	            error_string: "",
	            is_private: true,
	            share_history: false,
	            default_preset: PresetValues.PrivateChat,
	            topic: '',
	            room_name: '',
	            invited_users: []
	        };
	    },
	
	    onCreateRoom: function onCreateRoom() {
	        var options = {};
	
	        if (this.state.room_name) {
	            options.name = this.state.room_name;
	        }
	
	        if (this.state.topic) {
	            options.topic = this.state.topic;
	        }
	
	        if (this.state.preset) {
	            if (this.state.preset != PresetValues.Custom) {
	                options.preset = this.state.preset;
	            } else {
	                options.initial_state = [{
	                    type: "m.room.join_rules",
	                    content: {
	                        "join_rule": this.state.is_private ? "invite" : "public"
	                    }
	                }, {
	                    type: "m.room.history_visibility",
	                    content: {
	                        "history_visibility": this.state.share_history ? "shared" : "invited"
	                    }
	                }];
	            }
	        }
	
	        options.invite = this.state.invited_users;
	
	        var alias = this.getAliasLocalpart();
	        if (alias) {
	            options.room_alias_name = alias;
	        }
	
	        var cli = MatrixClientPeg.get();
	        if (!cli) {
	            // TODO: Error.
	            console.error("Cannot create room: No matrix client.");
	            return;
	        }
	
	        var deferred = cli.createRoom(options);
	
	        if (this.state.encrypt) {
	            // TODO
	        }
	
	        this.setState({
	            phase: this.phases.CREATING
	        });
	
	        var self = this;
	
	        deferred.then(function (resp) {
	            self.setState({
	                phase: self.phases.CREATED
	            });
	            self.props.onRoomCreated(resp.room_id);
	        }, function (err) {
	            self.setState({
	                phase: self.phases.ERROR,
	                error_string: err.toString()
	            });
	        });
	    },
	
	    getPreset: function getPreset() {
	        return this.refs.presets.getPreset();
	    },
	
	    getName: function getName() {
	        return this.refs.name_textbox.getName();
	    },
	
	    getTopic: function getTopic() {
	        return this.refs.topic.getTopic();
	    },
	
	    getAliasLocalpart: function getAliasLocalpart() {
	        return this.refs.alias.getAliasLocalpart();
	    },
	
	    getInvitedUsers: function getInvitedUsers() {
	        return this.refs.user_selector.getUserIds();
	    },
	
	    onPresetChanged: function onPresetChanged(preset) {
	        switch (preset) {
	            case PresetValues.PrivateChat:
	                this.setState({
	                    preset: preset,
	                    is_private: true,
	                    share_history: false
	                });
	                break;
	            case PresetValues.PublicChat:
	                this.setState({
	                    preset: preset,
	                    is_private: false,
	                    share_history: true
	                });
	                break;
	            case PresetValues.Custom:
	                this.setState({
	                    preset: preset
	                });
	                break;
	        }
	    },
	
	    onPrivateChanged: function onPrivateChanged(ev) {
	        this.setState({
	            preset: PresetValues.Custom,
	            is_private: ev.target.checked
	        });
	    },
	
	    onShareHistoryChanged: function onShareHistoryChanged(ev) {
	        this.setState({
	            preset: PresetValues.Custom,
	            share_history: ev.target.checked
	        });
	    },
	
	    onTopicChange: function onTopicChange(ev) {
	        this.setState({
	            topic: ev.target.value
	        });
	    },
	
	    onNameChange: function onNameChange(ev) {
	        this.setState({
	            room_name: ev.target.value
	        });
	    },
	
	    onInviteChanged: function onInviteChanged(invited_users) {
	        this.setState({
	            invited_users: invited_users
	        });
	    },
	
	    onAliasChanged: function onAliasChanged(alias) {
	        this.setState({
	            alias: alias
	        });
	    },
	
	    onEncryptChanged: function onEncryptChanged(ev) {
	        this.setState({
	            encrypt: ev.target.checked
	        });
	    },
	
	    render: function render() {
	        var curr_phase = this.state.phase;
	        if (curr_phase == this.phases.CREATING) {
	            var Loader = sdk.getComponent("elements.Spinner");
	            return React.createElement(Loader, null);
	        } else {
	            var error_box = "";
	            if (curr_phase == this.phases.ERROR) {
	                error_box = React.createElement(
	                    "div",
	                    { className: "mx_Error" },
	                    "An error occured: ",
	                    this.state.error_string
	                );
	            }
	
	            var CreateRoomButton = sdk.getComponent("create_room.CreateRoomButton");
	            var RoomAlias = sdk.getComponent("create_room.RoomAlias");
	            var Presets = sdk.getComponent("create_room.Presets");
	            var UserSelector = sdk.getComponent("elements.UserSelector");
	            var SimpleRoomHeader = sdk.getComponent("rooms.SimpleRoomHeader");
	
	            var domain = MatrixClientPeg.get().getDomain();
	
	            return React.createElement(
	                "div",
	                { className: "mx_CreateRoom" },
	                React.createElement(SimpleRoomHeader, { title: "CreateRoom", collapsedRhs: this.props.collapsedRhs }),
	                React.createElement(
	                    "div",
	                    { className: "mx_CreateRoom_body" },
	                    React.createElement("input", { type: "text", ref: "room_name", value: this.state.room_name, onChange: this.onNameChange, placeholder: "Name" }),
	                    " ",
	                    React.createElement("br", null),
	                    React.createElement("textarea", { className: "mx_CreateRoom_description", ref: "topic", value: this.state.topic, onChange: this.onTopicChange, placeholder: "Topic" }),
	                    " ",
	                    React.createElement("br", null),
	                    React.createElement(RoomAlias, { ref: "alias", alias: this.state.alias, homeserver: domain, onChange: this.onAliasChanged }),
	                    " ",
	                    React.createElement("br", null),
	                    React.createElement(UserSelector, { ref: "user_selector", selected_users: this.state.invited_users, onChange: this.onInviteChanged }),
	                    " ",
	                    React.createElement("br", null),
	                    React.createElement(Presets, { ref: "presets", onChange: this.onPresetChanged, preset: this.state.preset }),
	                    " ",
	                    React.createElement("br", null),
	                    React.createElement(
	                        "div",
	                        null,
	                        React.createElement(
	                            "label",
	                            null,
	                            React.createElement("input", { type: "checkbox", ref: "is_private", checked: this.state.is_private, onChange: this.onPrivateChanged }),
	                            "Make this room private"
	                        )
	                    ),
	                    React.createElement(
	                        "div",
	                        null,
	                        React.createElement(
	                            "label",
	                            null,
	                            React.createElement("input", { type: "checkbox", ref: "share_history", checked: this.state.share_history, onChange: this.onShareHistoryChanged }),
	                            "Share message history with new users"
	                        )
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "mx_CreateRoom_encrypt" },
	                        React.createElement(
	                            "label",
	                            null,
	                            React.createElement("input", { type: "checkbox", ref: "encrypt", checked: this.state.encrypt, onChange: this.onEncryptChanged }),
	                            "Encrypt room"
	                        )
	                    ),
	                    React.createElement(
	                        "div",
	                        null,
	                        React.createElement(CreateRoomButton, { onCreateRoom: this.onCreateRoom }),
	                        " ",
	                        React.createElement("br", null)
	                    ),
	                    error_box
	                )
	            );
	        }
	    }
	});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	
	var Matrix = __webpack_require__(28);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	
	/*
	 * Component which shows the filtered file using a TimelinePanel
	 */
	var FilePanel = React.createClass({
	    displayName: 'FilePanel',
	
	    propTypes: {
	        roomId: React.PropTypes.string.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            timelineSet: null
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.updateTimelineSet(this.props.roomId);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.roomId !== this.props.roomId) {
	            // otherwise we race between re-rendering the TimelinePanel and setting the new timelineSet.
	            //
	            // FIXME: this race only happens because of the promise returned by getOrCreateFilter().
	            // We should only need to create the containsUrl filter once per login session, so in practice
	            // it shouldn't be being done here at all.  Then we could just update the timelineSet directly
	            // without resetting it first, and speed up room-change.
	            this.setState({ timelineSet: null });
	            this.updateTimelineSet(nextProps.roomId);
	        }
	    },
	
	    updateTimelineSet: function updateTimelineSet(roomId) {
	        var _this = this;
	
	        var client = MatrixClientPeg.get();
	        var room = client.getRoom(roomId);
	
	        if (room) {
	            var filter = new Matrix.Filter(client.credentials.userId);
	            filter.setDefinition({
	                "room": {
	                    "timeline": {
	                        "contains_url": true
	                    }
	                }
	            });
	
	            // FIXME: we shouldn't be doing this every time we change room - see comment above.
	            client.getOrCreateFilter("FILTER_FILES_" + client.credentials.userId, filter).then(function (filterId) {
	                filter.filterId = filterId;
	                var timelineSet = room.getOrCreateFilteredTimelineSet(filter);
	                _this.setState({ timelineSet: timelineSet });
	            }, function (error) {
	                console.error("Failed to get or create file panel filter", error);
	            });
	        } else {
	            console.error("Failed to add filtered timelineSet for FilePanel as no room!");
	        }
	    },
	
	    render: function render() {
	        // wrap a TimelinePanel with the jump-to-event bits turned off.
	        var TimelinePanel = sdk.getComponent("structures.TimelinePanel");
	        var Loader = sdk.getComponent("elements.Spinner");
	
	        if (this.state.timelineSet) {
	            // console.log("rendering TimelinePanel for timelineSet " + this.state.timelineSet.room.roomId + " " +
	            //             "(" + this.state.timelineSet._timelines.join(", ") + ")" + " with key " + this.props.roomId);
	            return React.createElement(TimelinePanel, { key: "filepanel_" + this.props.roomId,
	                className: "mx_FilePanel",
	                manageReadReceipts: false,
	                manageReadMarkers: false,
	                timelineSet: this.state.timelineSet,
	                showUrlPreview: false,
	                tileShape: "file_grid",
	                opacity: this.props.opacity,
	                empty: "There are no visible files in this room"
	            });
	        } else {
	            return React.createElement(
	                "div",
	                { className: "mx_FilePanel" },
	                React.createElement(Loader, null)
	            );
	        }
	    }
	});
	
	module.exports = FilePanel;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _InteractiveAuthEntryComponents = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InteractiveAuth = _matrixJsSdk2.default.InteractiveAuth; /*
	                                                             Copyright 2017 Vector Creations Ltd.
	                                                             
	                                                             Licensed under the Apache License, Version 2.0 (the "License");
	                                                             you may not use this file except in compliance with the License.
	                                                             You may obtain a copy of the License at
	                                                             
	                                                                 http://www.apache.org/licenses/LICENSE-2.0
	                                                             
	                                                             Unless required by applicable law or agreed to in writing, software
	                                                             distributed under the License is distributed on an "AS IS" BASIS,
	                                                             WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                             See the License for the specific language governing permissions and
	                                                             limitations under the License.
	                                                             */
	
	exports.default = _react2.default.createClass({
	    displayName: 'InteractiveAuth',
	
	    propTypes: {
	        // matrix client to use for UI auth requests
	        matrixClient: _react2.default.PropTypes.object.isRequired,
	
	        // response from initial request. If not supplied, will do a request on
	        // mount.
	        authData: _react2.default.PropTypes.shape({
	            flows: _react2.default.PropTypes.array,
	            params: _react2.default.PropTypes.object,
	            session: _react2.default.PropTypes.string
	        }),
	
	        // callback
	        makeRequest: _react2.default.PropTypes.func.isRequired,
	
	        // callback called when the auth process has finished,
	        // successfully or unsuccessfully.
	        // @param {bool} status True if the operation requiring
	        //     auth was completed sucessfully, false if canceled.
	        // @param {object} result The result of the authenticated call
	        //     if successful, otherwise the error object
	        // @param {object} extra Additional information about the UI Auth
	        //     process:
	        //      * emailSid {string} If email auth was performed, the sid of
	        //            the auth session.
	        //      * clientSecret {string} The client secret used in auth
	        //            sessions with the ID server.
	        onAuthFinished: _react2.default.PropTypes.func.isRequired,
	
	        // Inputs provided by the user to the auth process
	        // and used by various stages. As passed to js-sdk
	        // interactive-auth
	        inputs: _react2.default.PropTypes.object,
	
	        // As js-sdk interactive-auth
	        makeRegistrationUrl: _react2.default.PropTypes.func,
	        sessionId: _react2.default.PropTypes.string,
	        clientSecret: _react2.default.PropTypes.string,
	        emailSid: _react2.default.PropTypes.string,
	
	        // If true, poll to see if the auth flow has been completed
	        // out-of-band
	        poll: _react2.default.PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            authStage: null,
	            busy: false,
	            errorText: null,
	            stageErrorText: null,
	            submitButtonEnabled: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        this._unmounted = false;
	        this._authLogic = new InteractiveAuth({
	            authData: this.props.authData,
	            doRequest: this._requestCallback,
	            inputs: this.props.inputs,
	            stateUpdated: this._authStateUpdated,
	            matrixClient: this.props.matrixClient,
	            sessionId: this.props.sessionId,
	            clientSecret: this.props.clientSecret,
	            emailSid: this.props.emailSid
	        });
	
	        this._authLogic.attemptAuth().then(function (result) {
	            var extra = {
	                emailSid: _this._authLogic.getEmailSid(),
	                clientSecret: _this._authLogic.getClientSecret()
	            };
	            _this.props.onAuthFinished(true, result, extra);
	        }).catch(function (error) {
	            _this.props.onAuthFinished(false, error);
	            console.error("Error during user-interactive auth:", error);
	            if (_this._unmounted) {
	                return;
	            }
	
	            var msg = error.message || error.toString();
	            _this.setState({
	                errorText: msg
	            });
	        }).done();
	
	        this._intervalId = null;
	        if (this.props.poll) {
	            this._intervalId = setInterval(function () {
	                _this._authLogic.poll();
	            }, 2000);
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this._unmounted = true;
	
	        if (this._intervalId !== null) {
	            clearInterval(this._intervalId);
	        }
	    },
	
	    _authStateUpdated: function _authStateUpdated(stageType, stageState) {
	        var _this2 = this;
	
	        var oldStage = this.state.authStage;
	        this.setState({
	            authStage: stageType,
	            stageState: stageState,
	            errorText: stageState.error
	        }, function () {
	            if (oldStage != stageType) _this2._setFocus();
	        });
	    },
	
	    _requestCallback: function _requestCallback(auth, background) {
	        var _this3 = this;
	
	        var makeRequestPromise = this.props.makeRequest(auth);
	
	        // if it's a background request, just do it: we don't want
	        // it to affect the state of our UI.
	        if (background) return makeRequestPromise;
	
	        // otherwise, manage the state of the spinner and error messages
	        this.setState({
	            busy: true,
	            errorText: null,
	            stageErrorText: null
	        });
	        return makeRequestPromise.finally(function () {
	            if (_this3._unmounted) {
	                return;
	            }
	            _this3.setState({
	                busy: false
	            });
	        });
	    },
	
	    _setFocus: function _setFocus() {
	        if (this.refs.stageComponent && this.refs.stageComponent.focus) {
	            this.refs.stageComponent.focus();
	        }
	    },
	
	    _submitAuthDict: function _submitAuthDict(authData) {
	        this._authLogic.submitAuthDict(authData);
	    },
	
	    _renderCurrentStage: function _renderCurrentStage() {
	        var stage = this.state.authStage;
	        if (!stage) return null;
	
	        var StageComponent = (0, _InteractiveAuthEntryComponents.getEntryComponentForLoginType)(stage);
	        return _react2.default.createElement(StageComponent, { ref: 'stageComponent',
	            loginType: stage,
	            matrixClient: this.props.matrixClient,
	            authSessionId: this._authLogic.getSessionId(),
	            clientSecret: this._authLogic.getClientSecret(),
	            stageParams: this._authLogic.getStageParams(stage),
	            submitAuthDict: this._submitAuthDict,
	            errorText: this.state.stageErrorText,
	            busy: this.state.busy,
	            inputs: this.props.inputs,
	            stageState: this.state.stageState,
	            fail: this._onAuthStageFailed,
	            setEmailSid: this._setEmailSid,
	            makeRegistrationUrl: this.props.makeRegistrationUrl
	        });
	    },
	
	    _onAuthStageFailed: function _onAuthStageFailed(e) {
	        this.props.onAuthFinished(false, e);
	    },
	    _setEmailSid: function _setEmailSid(sid) {
	        this._authLogic.setEmailSid(sid);
	    },
	
	    render: function render() {
	        var error = null;
	        if (this.state.errorText) {
	            error = _react2.default.createElement(
	                'div',
	                { className: 'error' },
	                this.state.errorText
	            );
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                this._renderCurrentStage(),
	                error
	            )
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var Matrix = _interopRequireWildcard(_matrixJsSdk);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KeyCode = __webpack_require__(116);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _Notifier = __webpack_require__(170);
	
	var _Notifier2 = _interopRequireDefault(_Notifier);
	
	var _PageTypes = __webpack_require__(501);
	
	var _PageTypes2 = _interopRequireDefault(_PageTypes);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * This is what our MatrixChat shows when we are logged in. The precise view is
	 * determined by the page_type property.
	 *
	 * Currently it's very tightly coupled with MatrixChat. We should try to do
	 * something about that.
	 *
	 * Components mounted below us can access the matrix client via the react context.
	 */
	exports.default = _react2.default.createClass({
	    displayName: 'LoggedInView',
	
	    propTypes: {
	        matrixClient: _react2.default.PropTypes.instanceOf(Matrix.MatrixClient).isRequired,
	        page_type: _react2.default.PropTypes.string.isRequired,
	        onRoomIdResolved: _react2.default.PropTypes.func,
	        onRoomCreated: _react2.default.PropTypes.func,
	        onUserSettingsClose: _react2.default.PropTypes.func,
	
	        teamToken: _react2.default.PropTypes.string
	
	    },
	
	    childContextTypes: {
	        matrixClient: _react2.default.PropTypes.instanceOf(Matrix.MatrixClient),
	        authCache: _react2.default.PropTypes.object
	    },
	
	    getChildContext: function getChildContext() {
	        return {
	            matrixClient: this._matrixClient,
	            authCache: {
	                auth: {},
	                lastUpdate: 0
	            }
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        // stash the MatrixClient in case we log out before we are unmounted
	        this._matrixClient = this.props.matrixClient;
	
	        // _scrollStateMap is a map from room id to the scroll state returned by
	        // RoomView.getScrollState()
	        this._scrollStateMap = {};
	
	        document.addEventListener('keydown', this._onKeyDown);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('keydown', this._onKeyDown);
	    },
	
	    getScrollStateForRoom: function getScrollStateForRoom(roomId) {
	        return this._scrollStateMap[roomId];
	    },
	
	    canResetTimelineInRoom: function canResetTimelineInRoom(roomId) {
	        if (!this.refs.roomView) {
	            return true;
	        }
	        return this.refs.roomView.canResetTimeline();
	    },
	
	    _onKeyDown: function _onKeyDown(ev) {
	        /*
	        // Remove this for now as ctrl+alt = alt-gr so this breaks keyboards which rely on alt-gr for numbers
	        // Will need to find a better meta key if anyone actually cares about using this.
	        if (ev.altKey && ev.ctrlKey && ev.keyCode > 48 && ev.keyCode < 58) {
	            dis.dispatch({
	                action: 'view_indexed_room',
	                roomIndex: ev.keyCode - 49,
	            });
	            ev.stopPropagation();
	            ev.preventDefault();
	            return;
	        }
	        */
	
	        var handled = false;
	
	        switch (ev.keyCode) {
	            case _KeyCode2.default.UP:
	            case _KeyCode2.default.DOWN:
	                if (ev.altKey) {
	                    var action = ev.keyCode == _KeyCode2.default.UP ? 'view_prev_room' : 'view_next_room';
	                    _dispatcher2.default.dispatch({ action: action });
	                    handled = true;
	                }
	                break;
	
	            case _KeyCode2.default.PAGE_UP:
	            case _KeyCode2.default.PAGE_DOWN:
	                this._onScrollKeyPressed(ev);
	                handled = true;
	                break;
	
	            case _KeyCode2.default.HOME:
	            case _KeyCode2.default.END:
	                if (ev.ctrlKey) {
	                    this._onScrollKeyPressed(ev);
	                    handled = true;
	                }
	                break;
	        }
	
	        if (handled) {
	            ev.stopPropagation();
	            ev.preventDefault();
	        }
	    },
	
	    /** dispatch a page-up/page-down/etc to the appropriate component */
	    _onScrollKeyPressed: function _onScrollKeyPressed(ev) {
	        if (this.refs.roomView) {
	            this.refs.roomView.handleScrollKey(ev);
	        }
	    },
	
	    render: function render() {
	        var LeftPanel = _index2.default.getComponent('structures.LeftPanel');
	        var RightPanel = _index2.default.getComponent('structures.RightPanel');
	        var RoomView = _index2.default.getComponent('structures.RoomView');
	        var UserSettings = _index2.default.getComponent('structures.UserSettings');
	        var CreateRoom = _index2.default.getComponent('structures.CreateRoom');
	        var RoomDirectory = _index2.default.getComponent('structures.RoomDirectory');
	        var HomePage = _index2.default.getComponent('structures.HomePage');
	        var MatrixToolbar = _index2.default.getComponent('globals.MatrixToolbar');
	        var GuestWarningBar = _index2.default.getComponent('globals.GuestWarningBar');
	        var NewVersionBar = _index2.default.getComponent('globals.NewVersionBar');
	
	        var page_element;
	        var right_panel = '';
	
	        switch (this.props.page_type) {
	            case _PageTypes2.default.RoomView:
	                page_element = _react2.default.createElement(RoomView, {
	                    ref: 'roomView',
	                    roomAddress: this.props.currentRoomAlias || this.props.currentRoomId,
	                    autoJoin: this.props.autoJoin,
	                    onRoomIdResolved: this.props.onRoomIdResolved,
	                    eventId: this.props.initialEventId,
	                    thirdPartyInvite: this.props.thirdPartyInvite,
	                    oobData: this.props.roomOobData,
	                    highlightedEventId: this.props.highlightedEventId,
	                    eventPixelOffset: this.props.initialEventPixelOffset,
	                    key: this.props.currentRoomAlias || this.props.currentRoomId,
	                    opacity: this.props.middleOpacity,
	                    collapsedRhs: this.props.collapse_rhs,
	                    ConferenceHandler: this.props.ConferenceHandler,
	                    scrollStateMap: this._scrollStateMap
	                });
	                if (!this.props.collapse_rhs) right_panel = _react2.default.createElement(RightPanel, { roomId: this.props.currentRoomId, opacity: this.props.sideOpacity });
	                break;
	
	            case _PageTypes2.default.UserSettings:
	                page_element = _react2.default.createElement(UserSettings, {
	                    onClose: this.props.onUserSettingsClose,
	                    brand: this.props.config.brand,
	                    collapsedRhs: this.props.collapse_rhs,
	                    enableLabs: this.props.config.enableLabs,
	                    referralBaseUrl: this.props.config.referralBaseUrl,
	                    teamToken: this.props.teamToken
	                });
	                if (!this.props.collapse_rhs) right_panel = _react2.default.createElement(RightPanel, { opacity: this.props.sideOpacity });
	                break;
	
	            case _PageTypes2.default.CreateRoom:
	                page_element = _react2.default.createElement(CreateRoom, {
	                    onRoomCreated: this.props.onRoomCreated,
	                    collapsedRhs: this.props.collapse_rhs
	                });
	                if (!this.props.collapse_rhs) right_panel = _react2.default.createElement(RightPanel, { opacity: this.props.sideOpacity });
	                break;
	
	            case _PageTypes2.default.RoomDirectory:
	                page_element = _react2.default.createElement(RoomDirectory, {
	                    collapsedRhs: this.props.collapse_rhs,
	                    config: this.props.config.roomDirectory
	                });
	                if (!this.props.collapse_rhs) right_panel = _react2.default.createElement(RightPanel, { opacity: this.props.sideOpacity });
	                break;
	
	            case _PageTypes2.default.HomePage:
	                page_element = _react2.default.createElement(HomePage, {
	                    collapsedRhs: this.props.collapse_rhs,
	                    teamServerUrl: this.props.config.teamServerConfig.teamServerURL,
	                    teamToken: this.props.teamToken
	                });
	                if (!this.props.collapse_rhs) right_panel = _react2.default.createElement(RightPanel, { opacity: this.props.sideOpacity });
	                break;
	
	            case _PageTypes2.default.UserView:
	                page_element = null; // deliberately null for now
	                right_panel = _react2.default.createElement(RightPanel, { userId: this.props.viewUserId, opacity: this.props.sideOpacity });
	                break;
	        }
	
	        var topBar;
	        if (this.props.hasNewVersion) {
	            topBar = _react2.default.createElement(NewVersionBar, { version: this.props.version, newVersion: this.props.newVersion,
	                releaseNotes: this.props.newVersionReleaseNotes
	            });
	        } else if (this.props.matrixClient.isGuest()) {
	            topBar = _react2.default.createElement(GuestWarningBar, null);
	        } else if (_Notifier2.default.supportsDesktopNotifications() && !_Notifier2.default.isEnabled() && !_Notifier2.default.isToolbarHidden()) {
	            topBar = _react2.default.createElement(MatrixToolbar, null);
	        }
	
	        var bodyClasses = 'mx_MatrixChat';
	        if (topBar) {
	            bodyClasses += ' mx_MatrixChat_toolbarShowing';
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_MatrixChat_wrapper' },
	            topBar,
	            _react2.default.createElement(
	                'div',
	                { className: bodyClasses },
	                _react2.default.createElement(LeftPanel, {
	                    selectedRoom: this.props.currentRoomId,
	                    collapsed: this.props.collapse_lhs || false,
	                    opacity: this.props.sideOpacity,
	                    teamToken: this.props.teamToken
	                }),
	                _react2.default.createElement(
	                    'main',
	                    { className: 'mx_MatrixChat_middlePanel' },
	                    page_element
	                ),
	                right_panel
	            )
	        );
	    }
	}); /*
	    Copyright 2015, 2016 OpenMarket Ltd
	    
	    Licensed under the Apache License, Version 2.0 (the "License");
	    you may not use this file except in compliance with the License.
	    You may obtain a copy of the License at
	    
	        http://www.apache.org/licenses/LICENSE-2.0
	    
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    See the License for the specific language governing permissions and
	    limitations under the License.
	    */

	module.exports = exports['default'];


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _values = __webpack_require__(375);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _create = __webpack_require__(178);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _assign = __webpack_require__(177);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _UnknownDeviceErrorHandler = __webpack_require__(1163);
	
	var UDEHandler = _interopRequireWildcard(_UnknownDeviceErrorHandler);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1); /*
	                              Copyright 2015, 2016 OpenMarket Ltd
	                              Copyright 2017 Vector Creations Ltd
	                              
	                              Licensed under the Apache License, Version 2.0 (the "License");
	                              you may not use this file except in compliance with the License.
	                              You may obtain a copy of the License at
	                              
	                                  http://www.apache.org/licenses/LICENSE-2.0
	                              
	                              Unless required by applicable law or agreed to in writing, software
	                              distributed under the License is distributed on an "AS IS" BASIS,
	                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                              See the License for the specific language governing permissions and
	                              limitations under the License.
	                              */
	
	var Matrix = __webpack_require__(28);
	
	var MatrixClientPeg = __webpack_require__(4);
	var PlatformPeg = __webpack_require__(93);
	var SdkConfig = __webpack_require__(118);
	var ContextualMenu = __webpack_require__(222);
	var RoomListSorter = __webpack_require__(503);
	var UserActivity = __webpack_require__(332);
	var Presence = __webpack_require__(502);
	var dis = __webpack_require__(5);
	
	var Modal = __webpack_require__(10);
	var Tinter = __webpack_require__(140);
	var sdk = __webpack_require__(2);
	var Rooms = __webpack_require__(117);
	var linkifyMatrix = __webpack_require__(142);
	var Lifecycle = __webpack_require__(499);
	var PageTypes = __webpack_require__(501);
	
	var createRoom = __webpack_require__(224);
	
	
	module.exports = React.createClass({
	    displayName: 'MatrixChat',
	
	    propTypes: {
	        config: React.PropTypes.object,
	        ConferenceHandler: React.PropTypes.any,
	        onNewScreen: React.PropTypes.func,
	        registrationUrl: React.PropTypes.string,
	        enableGuest: React.PropTypes.bool,
	
	        // the queryParams extracted from the [real] query-string of the URI
	        realQueryParams: React.PropTypes.object,
	
	        // the initial queryParams extracted from the hash-fragment of the URI
	        startingFragmentQueryParams: React.PropTypes.object,
	
	        // called when the session load completes
	        onLoadCompleted: React.PropTypes.func,
	
	        // Represents the screen to display as a result of parsing the initial
	        // window.location
	        initialScreenAfterLogin: React.PropTypes.shape({
	            screen: React.PropTypes.string.isRequired,
	            params: React.PropTypes.object
	        }),
	
	        // displayname, if any, to set on the device when logging
	        // in/registering.
	        defaultDeviceDisplayName: React.PropTypes.string,
	
	        // A function that makes a registration URL
	        makeRegistrationUrl: React.PropTypes.func.isRequired
	    },
	
	    childContextTypes: {
	        appConfig: React.PropTypes.object
	    },
	
	    AuxPanel: {
	        RoomSettings: "room_settings"
	    },
	
	    getChildContext: function getChildContext() {
	        return {
	            appConfig: this.props.config
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        var s = {
	            loading: true,
	            screen: undefined,
	            screenAfterLogin: this.props.initialScreenAfterLogin,
	
	            // Stashed guest credentials if the user logs out
	            // whilst logged in as a guest user (so they can change
	            // their mind & log back in)
	            guestCreds: null,
	
	            // What the LoggedInView would be showing if visible
	            page_type: null,
	
	            // If we are viewing a room by alias, this contains the alias
	            currentRoomAlias: null,
	
	            // The ID of the room we're viewing. This is either populated directly
	            // in the case where we view a room by ID or by RoomView when it resolves
	            // what ID an alias points at.
	            currentRoomId: null,
	
	            // If we're trying to just view a user ID (i.e. /user URL), this is it
	            viewUserId: null,
	
	            loggedIn: false,
	            loggingIn: false,
	            collapse_lhs: false,
	            collapse_rhs: false,
	            ready: false,
	            width: 10000,
	            sideOpacity: 1.0,
	            middleOpacity: 1.0,
	
	            version: null,
	            newVersion: null,
	            hasNewVersion: false,
	            newVersionReleaseNotes: null,
	
	            // The username to default to when upgrading an account from a guest
	            upgradeUsername: null,
	            // The access token we had for our guest account, used when upgrading to a normal account
	            guestAccessToken: null,
	
	            // Parameters used in the registration dance with the IS
	            register_client_secret: null,
	            register_session_id: null,
	            register_hs_url: null,
	            register_is_url: null,
	            register_id_sid: null
	        };
	        return s;
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            realQueryParams: {},
	            startingFragmentQueryParams: {},
	            config: {},
	            onLoadCompleted: function onLoadCompleted() {}
	        };
	    },
	
	    getCurrentHsUrl: function getCurrentHsUrl() {
	        if (this.state.register_hs_url) {
	            return this.state.register_hs_url;
	        } else if (MatrixClientPeg.get()) {
	            return MatrixClientPeg.get().getHomeserverUrl();
	        } else if (window.localStorage && window.localStorage.getItem("mx_hs_url")) {
	            return window.localStorage.getItem("mx_hs_url");
	        } else {
	            return this.getDefaultHsUrl();
	        }
	    },
	
	    getDefaultHsUrl: function getDefaultHsUrl() {
	        return this.props.config.default_hs_url || "https://matrix.org";
	    },
	
	
	    getFallbackHsUrl: function getFallbackHsUrl() {
	        return this.props.config.fallback_hs_url;
	    },
	
	    getCurrentIsUrl: function getCurrentIsUrl() {
	        if (this.state.register_is_url) {
	            return this.state.register_is_url;
	        } else if (MatrixClientPeg.get()) {
	            return MatrixClientPeg.get().getIdentityServerUrl();
	        } else if (window.localStorage && window.localStorage.getItem("mx_is_url")) {
	            return window.localStorage.getItem("mx_is_url");
	        } else {
	            return this.getDefaultIsUrl();
	        }
	    },
	
	    getDefaultIsUrl: function getDefaultIsUrl() {
	        return this.props.config.default_is_url || "https://vector.im";
	    },
	
	
	    componentWillMount: function componentWillMount() {
	        SdkConfig.put(this.props.config);
	
	        // Used by _viewRoom before getting state from sync
	        this.firstSyncComplete = false;
	        this.firstSyncPromise = _q2.default.defer();
	
	        if (this.props.config.sync_timeline_limit) {
	            MatrixClientPeg.opts.initialSyncLimit = this.props.config.sync_timeline_limit;
	        }
	
	        // To enable things like riot.im/geektime in a nicer way than rewriting the URL
	        // and appending a team token query parameter, use the first path segment to
	        // indicate a team, with "public" team tokens stored in the config teamTokenMap.
	        var routedTeamToken = null;
	        if (this.props.config.teamTokenMap) {
	            var teamName = window.location.pathname.split('/')[1];
	            if (teamName && this.props.config.teamTokenMap.hasOwnProperty(teamName)) {
	                routedTeamToken = this.props.config.teamTokenMap[teamName];
	            }
	        }
	
	        // Persist the team token across refreshes using sessionStorage. A new window or
	        // tab will not persist sessionStorage, but refreshes will.
	        if (this.props.startingFragmentQueryParams.team_token) {
	            window.sessionStorage.setItem('mx_team_token', this.props.startingFragmentQueryParams.team_token);
	        }
	
	        // Use the locally-stored team token first, then as a fall-back, check to see if
	        // a referral link was used, which will contain a query parameter `team_token`.
	        this._teamToken = routedTeamToken || window.localStorage.getItem('mx_team_token') || window.sessionStorage.getItem('mx_team_token');
	
	        // Some users have ended up with "undefined" as their local storage team token,
	        // treat that as undefined.
	        if (this._teamToken === "undefined") {
	            this._teamToken = undefined;
	        }
	
	        if (this._teamToken) {
	            console.info('Team token set to ' + this._teamToken);
	        }
	
	        // Set a default HS with query param `hs_url`
	        var paramHs = this.props.startingFragmentQueryParams.hs_url;
	        if (paramHs) {
	            console.log('Setting register_hs_url ', paramHs);
	            this.setState({
	                register_hs_url: paramHs
	            });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        this.dispatcherRef = dis.register(this.onAction);
	        UDEHandler.startListening();
	
	        this.focusComposer = false;
	        window.addEventListener("focus", this.onFocus);
	
	        // this can technically be done anywhere but doing this here keeps all
	        // the routing url path logic together.
	        if (this.onAliasClick) {
	            linkifyMatrix.onAliasClick = this.onAliasClick;
	        }
	        if (this.onUserClick) {
	            linkifyMatrix.onUserClick = this.onUserClick;
	        }
	
	        window.addEventListener('resize', this.handleResize);
	        this.handleResize();
	
	        if (this.props.config.teamServerConfig && this.props.config.teamServerConfig.teamServerURL) {
	            Lifecycle.initRtsClient(this.props.config.teamServerConfig.teamServerURL);
	        }
	
	        // the extra q() ensures that synchronous exceptions hit the same codepath as
	        // asynchronous ones.
	        (0, _q2.default)().then(function () {
	            return Lifecycle.loadSession({
	                realQueryParams: _this.props.realQueryParams,
	                fragmentQueryParams: _this.props.startingFragmentQueryParams,
	                enableGuest: _this.props.enableGuest,
	                guestHsUrl: _this.getCurrentHsUrl(),
	                guestIsUrl: _this.getCurrentIsUrl(),
	                defaultDeviceDisplayName: _this.props.defaultDeviceDisplayName
	            });
	        }).catch(function (e) {
	            console.error("Unable to load session", e);
	        }).done(function () {
	            // stuff this through the dispatcher so that it happens
	            // after the on_logged_in action.
	            dis.dispatch({ action: 'load_completed' });
	        });
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        Lifecycle.stopMatrixClient();
	        dis.unregister(this.dispatcherRef);
	        UDEHandler.stopListening();
	        window.removeEventListener("focus", this.onFocus);
	        window.removeEventListener('resize', this.handleResize);
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (this.focusComposer) {
	            dis.dispatch({ action: 'focus_composer' });
	            this.focusComposer = false;
	        }
	    },
	
	    setStateForNewScreen: function setStateForNewScreen(state) {
	        var newState = {
	            screen: undefined,
	            viewUserId: null,
	            loggedIn: false,
	            ready: false,
	            upgradeUsername: null,
	            guestAccessToken: null
	        };
	        (0, _assign2.default)(newState, state);
	        this.setState(newState);
	    },
	
	    onAction: function onAction(payload) {
	        var _this2 = this;
	
	        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	        var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	        var roomIndexDelta = 1;
	
	        var self = this;
	        switch (payload.action) {
	            case 'logout':
	                Lifecycle.logout();
	                break;
	            case 'start_registration':
	                var params = payload.params || {};
	                this.setStateForNewScreen({
	                    screen: 'register',
	                    // these params may be undefined, but if they are,
	                    // unset them from our state: we don't want to
	                    // resume a previous registration session if the
	                    // user just clicked 'register'
	                    register_client_secret: params.client_secret,
	                    register_session_id: params.session_id,
	                    register_hs_url: params.hs_url,
	                    register_is_url: params.is_url,
	                    register_id_sid: params.sid
	                });
	                this.notifyNewScreen('register');
	                break;
	            case 'start_login':
	                if (MatrixClientPeg.get() && MatrixClientPeg.get().isGuest()) {
	                    this.setState({
	                        guestCreds: MatrixClientPeg.getCredentials()
	                    });
	                }
	                this.setStateForNewScreen({
	                    screen: 'login'
	                });
	                this.notifyNewScreen('login');
	                break;
	            case 'start_post_registration':
	                this.setState({ // don't clobber loggedIn status
	                    screen: 'post_registration'
	                });
	                break;
	            case 'start_upgrade_registration':
	                // also stash our credentials, then if we restore the session,
	                // we can just do it the same way whether we started upgrade
	                // registration or explicitly logged out
	                this.setStateForNewScreen({
	                    guestCreds: MatrixClientPeg.getCredentials(),
	                    screen: "register",
	                    upgradeUsername: MatrixClientPeg.get().getUserIdLocalpart(),
	                    guestAccessToken: MatrixClientPeg.get().getAccessToken()
	                });
	
	                // stop the client: if we are syncing whilst the registration
	                // is completed in another browser, we'll be 401ed for using
	                // a guest access token for a non-guest account.
	                // It will be restarted in onReturnToGuestClick
	                Lifecycle.stopMatrixClient();
	
	                this.notifyNewScreen('register');
	                break;
	            case 'start_password_recovery':
	                if (this.state.loggedIn) return;
	                this.setStateForNewScreen({
	                    screen: 'forgot_password'
	                });
	                this.notifyNewScreen('forgot_password');
	                break;
	            case 'leave_room':
	                Modal.createDialog(QuestionDialog, {
	                    title: "Leave room",
	                    description: "Are you sure you want to leave the room?",
	                    onFinished: function onFinished(should_leave) {
	                        if (should_leave) {
	                            (function () {
	                                var d = MatrixClientPeg.get().leave(payload.room_id);
	
	                                // FIXME: controller shouldn't be loading a view :(
	                                var Loader = sdk.getComponent("elements.Spinner");
	                                var modal = Modal.createDialog(Loader, null, 'mx_Dialog_spinner');
	
	                                d.then(function () {
	                                    modal.close();
	                                    if (_this2.currentRoomId === payload.room_id) {
	                                        dis.dispatch({ action: 'view_next_room' });
	                                    }
	                                }, function (err) {
	                                    modal.close();
	                                    console.error("Failed to leave room " + payload.room_id + " " + err);
	                                    Modal.createDialog(ErrorDialog, {
	                                        title: "Failed to leave room",
	                                        description: "Server may be unavailable, overloaded, or you hit a bug."
	                                    });
	                                });
	                            })();
	                        }
	                    }
	                });
	                break;
	            case 'reject_invite':
	                Modal.createDialog(QuestionDialog, {
	                    title: "Reject invitation",
	                    description: "Are you sure you want to reject the invitation?",
	                    onFinished: function onFinished(confirm) {
	                        if (confirm) {
	                            (function () {
	                                // FIXME: controller shouldn't be loading a view :(
	                                var Loader = sdk.getComponent("elements.Spinner");
	                                var modal = Modal.createDialog(Loader, null, 'mx_Dialog_spinner');
	
	                                MatrixClientPeg.get().leave(payload.room_id).done(function () {
	                                    modal.close();
	                                    if (_this2.currentRoomId === payload.room_id) {
	                                        dis.dispatch({ action: 'view_next_room' });
	                                    }
	                                }, function (err) {
	                                    modal.close();
	                                    Modal.createDialog(ErrorDialog, {
	                                        title: "Failed to reject invitation",
	                                        description: err.toString()
	                                    });
	                                });
	                            })();
	                        }
	                    }
	                });
	                break;
	            case 'view_user':
	                // FIXME: ugly hack to expand the RightPanel and then re-dispatch.
	                if (this.state.collapse_rhs) {
	                    setTimeout(function () {
	                        dis.dispatch({
	                            action: 'show_right_panel'
	                        });
	                        dis.dispatch({
	                            action: 'view_user',
	                            member: payload.member
	                        });
	                    }, 0);
	                }
	                break;
	            case 'view_room':
	                // Takes either a room ID or room alias: if switching to a room the client is already
	                // known to be in (eg. user clicks on a room in the recents panel), supply the ID
	                // If the user is clicking on a room in the context of the alias being presented
	                // to them, supply the room alias. If both are supplied, the room ID will be ignored.
	                this._viewRoom(payload);
	                break;
	            case 'view_prev_room':
	                roomIndexDelta = -1;
	            case 'view_next_room':
	                var allRooms = RoomListSorter.mostRecentActivityFirst(MatrixClientPeg.get().getRooms());
	                var roomIndex = -1;
	                for (var i = 0; i < allRooms.length; ++i) {
	                    if (allRooms[i].roomId == this.state.currentRoomId) {
	                        roomIndex = i;
	                        break;
	                    }
	                }
	                roomIndex = (roomIndex + roomIndexDelta) % allRooms.length;
	                if (roomIndex < 0) roomIndex = allRooms.length - 1;
	                this._viewRoom({ room_id: allRooms[roomIndex].roomId });
	                break;
	            case 'view_indexed_room':
	                var allRooms = RoomListSorter.mostRecentActivityFirst(MatrixClientPeg.get().getRooms());
	                var roomIndex = payload.roomIndex;
	                if (allRooms[roomIndex]) {
	                    this._viewRoom({ room_id: allRooms[roomIndex].roomId });
	                }
	                break;
	            case 'view_user_settings':
	                this._setPage(PageTypes.UserSettings);
	                this.notifyNewScreen('settings');
	                break;
	            case 'view_create_room':
	                //this._setPage(PageTypes.CreateRoom);
	                //this.notifyNewScreen('new');
	
	                var TextInputDialog = sdk.getComponent("dialogs.TextInputDialog");
	                Modal.createDialog(TextInputDialog, {
	                    title: "Create Room",
	                    description: "Room name (optional)",
	                    button: "Create Room",
	                    onFinished: function onFinished(should_create, name) {
	                        if (should_create) {
	                            var createOpts = {};
	                            if (name) createOpts.name = name;
	                            createRoom({ createOpts: createOpts }).done();
	                        }
	                    }
	                });
	                break;
	            case 'view_room_directory':
	                this._setPage(PageTypes.RoomDirectory);
	                this.notifyNewScreen('directory');
	                break;
	            case 'view_home_page':
	                if (!this._teamToken) {
	                    dis.dispatch({ action: 'view_room_directory' });
	                    return;
	                }
	                this._setPage(PageTypes.HomePage);
	                this.notifyNewScreen('home');
	                break;
	            case 'view_create_chat':
	                this._createChat();
	                break;
	            case 'view_invite':
	                this._invite(payload.roomId);
	                break;
	            case 'notifier_enabled':
	                this.forceUpdate();
	                break;
	            case 'hide_left_panel':
	                this.setState({
	                    collapse_lhs: true
	                });
	                break;
	            case 'show_left_panel':
	                this.setState({
	                    collapse_lhs: false
	                });
	                break;
	            case 'hide_right_panel':
	                this.setState({
	                    collapse_rhs: true
	                });
	                break;
	            case 'show_right_panel':
	                this.setState({
	                    collapse_rhs: false
	                });
	                break;
	            case 'ui_opacity':
	                this.setState({
	                    sideOpacity: payload.sideOpacity,
	                    middleOpacity: payload.middleOpacity
	                });
	                break;
	            case 'set_theme':
	                this._onSetTheme(payload.value);
	                break;
	            case 'on_logging_in':
	                this.setState({ loggingIn: true });
	                break;
	            case 'on_logged_in':
	                this._onLoggedIn(payload.teamToken);
	                break;
	            case 'on_logged_out':
	                this._onLoggedOut();
	                break;
	            case 'will_start_client':
	                this._onWillStartClient();
	                break;
	            case 'load_completed':
	                this._onLoadCompleted();
	                break;
	            case 'new_version':
	                this.onVersion(payload.currentVersion, payload.newVersion, payload.releaseNotes);
	                break;
	        }
	    },
	
	    _setPage: function _setPage(pageType) {
	        this.setState({
	            page_type: pageType
	        });
	    },
	
	    // switch view to the given room
	    //
	    // @param {Object} room_info Object containing data about the room to be joined
	    // @param {string=} room_info.room_id ID of the room to join. One of room_id or room_alias must be given.
	    // @param {string=} room_info.room_alias Alias of the room to join. One of room_id or room_alias must be given.
	    // @param {boolean=} room_info.auto_join If true, automatically attempt to join the room if not already a member.
	    // @param {boolean=} room_info.show_settings Makes RoomView show the room settings dialog.
	    // @param {string=} room_info.event_id ID of the event in this room to show: this will cause a switch to the
	    //                                    context of that particular event.
	    // @param {Object=} room_info.third_party_invite Object containing data about the third party
	    //                                    we received to join the room, if any.
	    // @param {string=} room_info.third_party_invite.inviteSignUrl 3pid invite sign URL
	    // @param {string=} room_info.third_party_invite.invitedEmail The email address the invite was sent to
	    // @param {Object=} room_info.oob_data Object of additional data about the room
	    //                               that has been passed out-of-band (eg.
	    //                               room name and avatar from an invite email)
	    _viewRoom: function _viewRoom(room_info) {
	        var _this3 = this;
	
	        this.focusComposer = true;
	
	        var newState = {
	            initialEventId: room_info.event_id,
	            highlightedEventId: room_info.event_id,
	            initialEventPixelOffset: undefined,
	            page_type: PageTypes.RoomView,
	            thirdPartyInvite: room_info.third_party_invite,
	            roomOobData: room_info.oob_data,
	            currentRoomAlias: room_info.room_alias,
	            autoJoin: room_info.auto_join
	        };
	
	        if (!room_info.room_alias) {
	            newState.currentRoomId = room_info.room_id;
	        }
	
	        // if we aren't given an explicit event id, look for one in the
	        // scrollStateMap.
	        //
	        // TODO: do this in RoomView rather than here
	        if (!room_info.event_id && this.refs.loggedInView) {
	            var scrollState = this.refs.loggedInView.getScrollStateForRoom(room_info.room_id);
	            if (scrollState) {
	                newState.initialEventId = scrollState.focussedEvent;
	                newState.initialEventPixelOffset = scrollState.pixelOffset;
	            }
	        }
	
	        // Wait for the first sync to complete so that if a room does have an alias,
	        // it would have been retrieved.
	        var waitFor = (0, _q2.default)(null);
	        if (!this.firstSyncComplete) {
	            if (!this.firstSyncPromise) {
	                console.warn('Cannot view a room before first sync. room_id:', room_info.room_id);
	                return;
	            }
	            waitFor = this.firstSyncPromise.promise;
	        }
	
	        waitFor.done(function () {
	            var presentedId = room_info.room_alias || room_info.room_id;
	            var room = MatrixClientPeg.get().getRoom(room_info.room_id);
	            if (room) {
	                var theAlias = Rooms.getDisplayAliasForRoom(room);
	                if (theAlias) presentedId = theAlias;
	
	                // Store this as the ID of the last room accessed. This is so that we can
	                // persist which room is being stored across refreshes and browser quits.
	                if (localStorage) {
	                    localStorage.setItem('mx_last_room_id', room.roomId);
	                }
	            }
	
	            if (room_info.event_id) {
	                presentedId += "/" + room_info.event_id;
	            }
	            _this3.notifyNewScreen('room/' + presentedId);
	            newState.ready = true;
	            _this3.setState(newState);
	        });
	    },
	
	    _createChat: function _createChat() {
	        var ChatInviteDialog = sdk.getComponent("dialogs.ChatInviteDialog");
	        Modal.createDialog(ChatInviteDialog, {
	            title: "Start a new chat"
	        });
	    },
	
	    _invite: function _invite(roomId) {
	        var ChatInviteDialog = sdk.getComponent("dialogs.ChatInviteDialog");
	        Modal.createDialog(ChatInviteDialog, {
	            title: "Invite new room members",
	            button: "Send Invites",
	            description: "Who would you like to add to this room?",
	            roomId: roomId
	        });
	    },
	
	    /**
	     * Called when the sessionloader has finished
	     */
	    _onLoadCompleted: function _onLoadCompleted() {
	        this.props.onLoadCompleted();
	        this.setState({ loading: false });
	
	        // Show screens (like 'register') that need to be shown without _onLoggedIn
	        // being called. 'register' needs to be routed here when the email confirmation
	        // link is clicked on.
	        if (this.state.screenAfterLogin && ['register'].indexOf(this.state.screenAfterLogin.screen) !== -1) {
	            this._showScreenAfterLogin();
	        }
	    },
	
	    /**
	     * Called whenever someone changes the theme
	     */
	    _onSetTheme: function _onSetTheme(theme) {
	        if (!theme) {
	            theme = 'light';
	        }
	
	        // look for the stylesheet elements.
	        // styleElements is a map from style name to HTMLLinkElement.
	        var styleElements = (0, _create2.default)(null);
	        var i, a;
	        for (i = 0; a = document.getElementsByTagName("link")[i]; i++) {
	            var href = a.getAttribute("href");
	            // shouldn't we be using the 'title' tag rather than the href?
	            var match = href.match(/^bundles\/.*\/theme-(.*)\.css$/);
	            if (match) {
	                styleElements[match[1]] = a;
	            }
	        }
	
	        if (!(theme in styleElements)) {
	            throw new Error("Unknown theme " + theme);
	        }
	
	        // disable all of them first, then enable the one we want. Chrome only
	        // bothers to do an update on a true->false transition, so this ensures
	        // that we get exactly one update, at the right time.
	
	        (0, _values2.default)(styleElements).forEach(function (a) {
	            a.disabled = true;
	        });
	        styleElements[theme].disabled = false;
	
	        if (theme === 'dark') {
	            // abuse the tinter to change all the SVG's #fff to #2d2d2d
	            // XXX: obviously this shouldn't be hardcoded here.
	            Tinter.tintSvgWhite('#2d2d2d');
	        } else {
	            Tinter.tintSvgWhite('#ffffff');
	        }
	    },
	
	    /**
	     * Called when a new logged in session has started
	     */
	    _onLoggedIn: function _onLoggedIn(teamToken) {
	        this.setState({
	            guestCreds: null,
	            loggedIn: true,
	            loggingIn: false
	        });
	
	        if (teamToken) {
	            // A team member has logged in, not a guest
	            this._teamToken = teamToken;
	            dis.dispatch({ action: 'view_home_page' });
	        } else if (this._is_registered) {
	            // The user has just logged in after registering
	            dis.dispatch({ action: 'view_user_settings' });
	        } else {
	            this._showScreenAfterLogin();
	        }
	    },
	
	    _showScreenAfterLogin: function _showScreenAfterLogin() {
	        // If screenAfterLogin is set, use that, then null it so that a second login will
	        // result in view_home_page, _user_settings or _room_directory
	        if (this.state.screenAfterLogin && this.state.screenAfterLogin.screen) {
	            this.showScreen(this.state.screenAfterLogin.screen, this.state.screenAfterLogin.params);
	            this.notifyNewScreen(this.state.screenAfterLogin.screen);
	            this.setState({ screenAfterLogin: null });
	        } else if (localStorage && localStorage.getItem('mx_last_room_id')) {
	            // Before defaulting to directory, show the last viewed room
	            dis.dispatch({
	                action: 'view_room',
	                room_id: localStorage.getItem('mx_last_room_id')
	            });
	        } else if (this._teamToken) {
	            // Team token might be set if we're a guest.
	            // Guests do not call _onLoggedIn with a teamToken
	            dis.dispatch({ action: 'view_home_page' });
	        } else {
	            dis.dispatch({ action: 'view_room_directory' });
	        }
	    },
	
	    /**
	     * Called when the session is logged out
	     */
	    _onLoggedOut: function _onLoggedOut() {
	        this.notifyNewScreen('login');
	        this.setStateForNewScreen({
	            loggedIn: false,
	            ready: false,
	            collapse_lhs: false,
	            collapse_rhs: false,
	            currentRoomAlias: null,
	            currentRoomId: null,
	            page_type: PageTypes.RoomDirectory
	        });
	        this._teamToken = null;
	    },
	
	    /**
	     * Called just before the matrix client is started
	     * (useful for setting listeners)
	     */
	    _onWillStartClient: function _onWillStartClient() {
	        var self = this;
	        var cli = MatrixClientPeg.get();
	
	        // Allow the JS SDK to reap timeline events. This reduces the amount of
	        // memory consumed as the JS SDK stores multiple distinct copies of room
	        // state (each of which can be 10s of MBs) for each DISJOINT timeline. This is
	        // particularly noticeable when there are lots of 'limited' /sync responses
	        // such as when laptops unsleep.
	        // https://github.com/vector-im/riot-web/issues/3307#issuecomment-282895568
	        cli.setCanResetTimelineCallback(function (roomId) {
	            console.log("Request to reset timeline in room ", roomId, " viewing:", self.state.currentRoomId);
	            if (roomId !== self.state.currentRoomId) {
	                // It is safe to remove events from rooms we are not viewing.
	                return true;
	            }
	            // We are viewing the room which we want to reset. It is only safe to do
	            // this if we are not scrolled up in the view. To find out, delegate to
	            // the timeline panel. If the timeline panel doesn't exist, then we assume
	            // it is safe to reset the timeline.
	            if (!self.refs.loggedInView) {
	                return true;
	            }
	            return self.refs.loggedInView.canResetTimelineInRoom(roomId);
	        });
	
	        cli.on('sync', function (state, prevState) {
	            self.updateStatusIndicator(state, prevState);
	            if (state === "SYNCING" && prevState === "SYNCING") {
	                return;
	            }
	            console.log("MatrixClient sync state => %s", state);
	            if (state !== "PREPARED") {
	                return;
	            }
	
	            self.firstSyncComplete = true;
	            self.firstSyncPromise.resolve();
	
	            dis.dispatch({ action: 'focus_composer' });
	            self.setState({ ready: true });
	        });
	        cli.on('Call.incoming', function (call) {
	            dis.dispatch({
	                action: 'incoming_call',
	                call: call
	            });
	        });
	        cli.on('Session.logged_out', function (call) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Signed Out",
	                description: "For security, this session has been signed out. Please sign in again."
	            });
	            dis.dispatch({
	                action: 'logout'
	            });
	        });
	        cli.on("accountData", function (ev) {
	            if (ev.getType() === 'im.vector.web.settings') {
	                if (ev.getContent() && ev.getContent().theme) {
	                    dis.dispatch({
	                        action: 'set_theme',
	                        value: ev.getContent().theme
	                    });
	                }
	            }
	        });
	    },
	
	
	    onFocus: function onFocus(ev) {
	        dis.dispatch({ action: 'focus_composer' });
	    },
	
	    showScreen: function showScreen(screen, params) {
	        if (screen == 'register') {
	            dis.dispatch({
	                action: 'start_registration',
	                params: params
	            });
	        } else if (screen == 'login') {
	            dis.dispatch({
	                action: 'start_login',
	                params: params
	            });
	        } else if (screen == 'forgot_password') {
	            dis.dispatch({
	                action: 'start_password_recovery',
	                params: params
	            });
	        } else if (screen == 'new') {
	            dis.dispatch({
	                action: 'view_create_room'
	            });
	        } else if (screen == 'settings') {
	            dis.dispatch({
	                action: 'view_user_settings'
	            });
	        } else if (screen == 'home') {
	            dis.dispatch({
	                action: 'view_home_page'
	            });
	        } else if (screen == 'directory') {
	            dis.dispatch({
	                action: 'view_room_directory'
	            });
	        } else if (screen == 'post_registration') {
	            dis.dispatch({
	                action: 'start_post_registration'
	            });
	        } else if (screen.indexOf('room/') == 0) {
	            var segments = screen.substring(5).split('/');
	            var roomString = segments[0];
	            var eventId = segments[1]; // undefined if no event id given
	
	            // FIXME: sort_out caseConsistency
	            var third_party_invite = {
	                inviteSignUrl: params.signurl,
	                invitedEmail: params.email
	            };
	            var oob_data = {
	                name: params.room_name,
	                avatarUrl: params.room_avatar_url,
	                inviterName: params.inviter_name
	            };
	
	            var payload = {
	                action: 'view_room',
	                event_id: eventId,
	                third_party_invite: third_party_invite,
	                oob_data: oob_data
	            };
	            if (roomString[0] == '#') {
	                payload.room_alias = roomString;
	            } else {
	                payload.room_id = roomString;
	            }
	
	            // we can't view a room unless we're logged in
	            // (a guest account is fine)
	            if (this.state.loggedIn) {
	                dis.dispatch(payload);
	            }
	        } else if (screen.indexOf('user/') == 0) {
	            var userId = screen.substring(5);
	            this.setState({ viewUserId: userId });
	            this._setPage(PageTypes.UserView);
	            this.notifyNewScreen('user/' + userId);
	            var member = new Matrix.RoomMember(null, userId);
	            if (member) {
	                dis.dispatch({
	                    action: 'view_user',
	                    member: member
	                });
	            }
	        } else {
	            console.info("Ignoring showScreen for '%s'", screen);
	        }
	    },
	
	    notifyNewScreen: function notifyNewScreen(screen) {
	        if (this.props.onNewScreen) {
	            this.props.onNewScreen(screen);
	        }
	    },
	
	    onAliasClick: function onAliasClick(event, alias) {
	        event.preventDefault();
	        dis.dispatch({ action: 'view_room', room_alias: alias });
	    },
	
	    onUserClick: function onUserClick(event, userId) {
	        event.preventDefault();
	
	        var member = new Matrix.RoomMember(null, userId);
	        if (!member) {
	            return;
	        }
	        dis.dispatch({
	            action: 'view_user',
	            member: member
	        });
	    },
	
	    onLogoutClick: function onLogoutClick(event) {
	        dis.dispatch({
	            action: 'logout'
	        });
	        event.stopPropagation();
	        event.preventDefault();
	    },
	
	    handleResize: function handleResize(e) {
	        var hideLhsThreshold = 1000;
	        var showLhsThreshold = 1000;
	        var hideRhsThreshold = 820;
	        var showRhsThreshold = 820;
	
	        if (this.state.width > hideLhsThreshold && window.innerWidth <= hideLhsThreshold) {
	            dis.dispatch({ action: 'hide_left_panel' });
	        }
	        if (this.state.width <= showLhsThreshold && window.innerWidth > showLhsThreshold) {
	            dis.dispatch({ action: 'show_left_panel' });
	        }
	        if (this.state.width > hideRhsThreshold && window.innerWidth <= hideRhsThreshold) {
	            dis.dispatch({ action: 'hide_right_panel' });
	        }
	        if (this.state.width <= showRhsThreshold && window.innerWidth > showRhsThreshold) {
	            dis.dispatch({ action: 'show_right_panel' });
	        }
	
	        this.setState({ width: window.innerWidth });
	    },
	
	    onRoomCreated: function onRoomCreated(room_id) {
	        dis.dispatch({
	            action: "view_room",
	            room_id: room_id
	        });
	    },
	
	    onRegisterClick: function onRegisterClick() {
	        this.showScreen("register");
	    },
	
	    onLoginClick: function onLoginClick() {
	        this.showScreen("login");
	    },
	
	    onForgotPasswordClick: function onForgotPasswordClick() {
	        this.showScreen("forgot_password");
	    },
	
	    onReturnToGuestClick: function onReturnToGuestClick() {
	        // reanimate our guest login
	        if (this.state.guestCreds) {
	            Lifecycle.setLoggedIn(this.state.guestCreds);
	            this.setState({ guestCreds: null });
	        }
	    },
	
	    onRegistered: function onRegistered(credentials, teamToken) {
	        // teamToken may not be truthy
	        this._teamToken = teamToken;
	        this._is_registered = true;
	        Lifecycle.setLoggedIn(credentials);
	    },
	
	    onFinishPostRegistration: function onFinishPostRegistration() {
	        // Don't confuse this with "PageType" which is the middle window to show
	        this.setState({
	            screen: undefined
	        });
	        this.showScreen("settings");
	    },
	
	    onVersion: function onVersion(current, latest, releaseNotes) {
	        this.setState({
	            version: current,
	            newVersion: latest,
	            hasNewVersion: current !== latest,
	            newVersionReleaseNotes: releaseNotes
	        });
	    },
	
	    updateStatusIndicator: function updateStatusIndicator(state, prevState) {
	        var notifCount = 0;
	
	        var rooms = MatrixClientPeg.get().getRooms();
	        for (var i = 0; i < rooms.length; ++i) {
	            if (rooms[i].hasMembershipState(MatrixClientPeg.get().credentials.userId, 'invite')) {
	                notifCount++;
	            } else if (rooms[i].getUnreadNotificationCount()) {
	                // if we were summing unread notifs:
	                // notifCount += rooms[i].getUnreadNotificationCount();
	                // instead, we just count the number of rooms with notifs.
	                notifCount++;
	            }
	        }
	
	        if (PlatformPeg.get()) {
	            PlatformPeg.get().setErrorStatus(state === 'ERROR');
	            PlatformPeg.get().setNotificationCount(notifCount);
	        }
	
	        document.title = 'Riot ' + (state === "ERROR" ? " [offline]" : "") + (notifCount > 0 ? ' [' + notifCount + ']' : "");
	    },
	
	    onUserSettingsClose: function onUserSettingsClose() {
	        // XXX: use browser history instead to find the previous room?
	        // or maintain a this.state.pageHistory in _setPage()?
	        if (this.state.currentRoomId) {
	            dis.dispatch({
	                action: 'view_room',
	                room_id: this.state.currentRoomId
	            });
	        } else {
	            dis.dispatch({
	                action: 'view_room_directory'
	            });
	        }
	    },
	
	    onRoomIdResolved: function onRoomIdResolved(room_id) {
	        // It's the RoomView's resposibility to look up room aliases, but we need the
	        // ID to pass into things like the Member List, so the Room View tells us when
	        // its done that resolution so we can display things that take a room ID.
	        this.setState({ currentRoomId: room_id });
	    },
	
	    _makeRegistrationUrl: function _makeRegistrationUrl(params) {
	        if (this.props.startingFragmentQueryParams.referrer) {
	            params.referrer = this.props.startingFragmentQueryParams.referrer;
	        }
	        return this.props.makeRegistrationUrl(params);
	    },
	
	    render: function render() {
	        // `loading` might be set to false before `loggedIn = true`, causing the default
	        // (`<Login>`) to be visible for a few MS (say, whilst a request is in-flight to
	        // the RTS). So in the meantime, use `loggingIn`, which is true between
	        // actions `on_logging_in` and `on_logged_in`.
	        if (this.state.loading || this.state.loggingIn) {
	            var Spinner = sdk.getComponent('elements.Spinner');
	            return React.createElement(
	                'div',
	                { className: 'mx_MatrixChat_splash' },
	                React.createElement(Spinner, null)
	            );
	        }
	        // needs to be before normal PageTypes as you are logged in technically
	        else if (this.state.screen == 'post_registration') {
	                var PostRegistration = sdk.getComponent('structures.login.PostRegistration');
	                return React.createElement(PostRegistration, {
	                    onComplete: this.onFinishPostRegistration });
	            } else if (this.state.loggedIn && this.state.ready) {
	                /* for now, we stuff the entirety of our props and state into the LoggedInView.
	                 * we should go through and figure out what we actually need to pass down, as well
	                 * as using something like redux to avoid having a billion bits of state kicking around.
	                 */
	                var LoggedInView = sdk.getComponent('structures.LoggedInView');
	                return React.createElement(LoggedInView, (0, _extends3.default)({ ref: 'loggedInView', matrixClient: MatrixClientPeg.get(),
	                    onRoomIdResolved: this.onRoomIdResolved,
	                    onRoomCreated: this.onRoomCreated,
	                    onUserSettingsClose: this.onUserSettingsClose,
	                    teamToken: this._teamToken
	                }, this.props, this.state));
	            } else if (this.state.loggedIn) {
	                // we think we are logged in, but are still waiting for the /sync to complete
	                var _Spinner = sdk.getComponent('elements.Spinner');
	                return React.createElement(
	                    'div',
	                    { className: 'mx_MatrixChat_splash' },
	                    React.createElement(_Spinner, null),
	                    React.createElement(
	                        'a',
	                        { href: '#', className: 'mx_MatrixChat_splashButtons', onClick: this.onLogoutClick },
	                        'Logout'
	                    )
	                );
	            } else if (this.state.screen == 'register') {
	                var Registration = sdk.getComponent('structures.login.Registration');
	                return React.createElement(Registration, {
	                    clientSecret: this.state.register_client_secret,
	                    sessionId: this.state.register_session_id,
	                    idSid: this.state.register_id_sid,
	                    email: this.props.startingFragmentQueryParams.email,
	                    referrer: this.props.startingFragmentQueryParams.referrer,
	                    username: this.state.upgradeUsername,
	                    guestAccessToken: this.state.guestAccessToken,
	                    defaultHsUrl: this.getDefaultHsUrl(),
	                    defaultIsUrl: this.getDefaultIsUrl(),
	                    brand: this.props.config.brand,
	                    teamServerConfig: this.props.config.teamServerConfig,
	                    customHsUrl: this.getCurrentHsUrl(),
	                    customIsUrl: this.getCurrentIsUrl(),
	                    makeRegistrationUrl: this._makeRegistrationUrl,
	                    defaultDeviceDisplayName: this.props.defaultDeviceDisplayName,
	                    onLoggedIn: this.onRegistered,
	                    onLoginClick: this.onLoginClick,
	                    onRegisterClick: this.onRegisterClick,
	                    onCancelClick: this.state.guestCreds ? this.onReturnToGuestClick : null
	                });
	            } else if (this.state.screen == 'forgot_password') {
	                var ForgotPassword = sdk.getComponent('structures.login.ForgotPassword');
	                return React.createElement(ForgotPassword, {
	                    defaultHsUrl: this.getDefaultHsUrl(),
	                    defaultIsUrl: this.getDefaultIsUrl(),
	                    customHsUrl: this.getCurrentHsUrl(),
	                    customIsUrl: this.getCurrentIsUrl(),
	                    onComplete: this.onLoginClick,
	                    onRegisterClick: this.onRegisterClick,
	                    onLoginClick: this.onLoginClick });
	            } else {
	                var Login = sdk.getComponent('structures.login.Login');
	                return React.createElement(Login, {
	                    onLoggedIn: Lifecycle.setLoggedIn,
	                    onRegisterClick: this.onRegisterClick,
	                    defaultHsUrl: this.getDefaultHsUrl(),
	                    defaultIsUrl: this.getDefaultIsUrl(),
	                    customHsUrl: this.getCurrentHsUrl(),
	                    customIsUrl: this.getCurrentIsUrl(),
	                    fallbackHsUrl: this.getFallbackHsUrl(),
	                    defaultDeviceDisplayName: this.props.defaultDeviceDisplayName,
	                    onForgotPasswordClick: this.onForgotPasswordClick,
	                    enableGuest: this.props.enableGuest,
	                    onCancelClick: this.state.guestCreds ? this.onReturnToGuestClick : null
	                });
	            }
	    }
	});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(180);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var dis = __webpack_require__(5);
	var sdk = __webpack_require__(2);
	
	var MatrixClientPeg = __webpack_require__(4);
	
	var MILLIS_IN_DAY = 86400000;
	
	/* (almost) stateless UI component which builds the event tiles in the room timeline.
	 */
	module.exports = React.createClass({
	    displayName: 'MessagePanel',
	
	    propTypes: {
	        // true to give the component a 'display: none' style.
	        hidden: React.PropTypes.bool,
	
	        // true to show a spinner at the top of the timeline to indicate
	        // back-pagination in progress
	        backPaginating: React.PropTypes.bool,
	
	        // true to show a spinner at the end of the timeline to indicate
	        // forward-pagination in progress
	        forwardPaginating: React.PropTypes.bool,
	
	        // the list of MatrixEvents to display
	        events: React.PropTypes.array.isRequired,
	
	        // ID of an event to highlight. If undefined, no event will be highlighted.
	        highlightedEventId: React.PropTypes.string,
	
	        // Should we show URL Previews
	        showUrlPreview: React.PropTypes.bool,
	
	        // event after which we should show a read marker
	        readMarkerEventId: React.PropTypes.string,
	
	        // whether the read marker should be visible
	        readMarkerVisible: React.PropTypes.bool,
	
	        // the userid of our user. This is used to suppress the read marker
	        // for pending messages.
	        ourUserId: React.PropTypes.string,
	
	        // true to suppress the date at the start of the timeline
	        suppressFirstDateSeparator: React.PropTypes.bool,
	
	        // whether to show read receipts
	        manageReadReceipts: React.PropTypes.bool,
	
	        // true if updates to the event list should cause the scroll panel to
	        // scroll down when we are at the bottom of the window. See ScrollPanel
	        // for more details.
	        stickyBottom: React.PropTypes.bool,
	
	        // callback which is called when the panel is scrolled.
	        onScroll: React.PropTypes.func,
	
	        // callback which is called when more content is needed.
	        onFillRequest: React.PropTypes.func,
	
	        // opacity for dynamic UI fading effects
	        opacity: React.PropTypes.number,
	
	        // className for the panel
	        className: React.PropTypes.string.isRequired,
	
	        // shape parameter to be passed to EventTiles
	        tileShape: React.PropTypes.string
	    },
	
	    componentWillMount: function componentWillMount() {
	        // the event after which we put a visible unread marker on the last
	        // render cycle; null if readMarkerVisible was false or the RM was
	        // suppressed (eg because it was at the end of the timeline)
	        this.currentReadMarkerEventId = null;
	
	        // the event after which we are showing a disappearing read marker
	        // animation
	        this.currentGhostEventId = null;
	
	        // opaque readreceipt info for each userId; used by ReadReceiptMarker
	        // to manage its animations
	        this._readReceiptMap = {};
	
	        // Remember the read marker ghost node so we can do the cleanup that
	        // Velocity requires
	        this._readMarkerGhostNode = null;
	
	        this._isMounted = true;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this._isMounted = false;
	    },
	
	    /* get the DOM node representing the given event */
	    getNodeForEventId: function getNodeForEventId(eventId) {
	        if (!this.eventNodes) {
	            return undefined;
	        }
	
	        return this.eventNodes[eventId];
	    },
	
	    /* return true if the content is fully scrolled down right now; else false.
	     */
	    isAtBottom: function isAtBottom() {
	        return this.refs.scrollPanel && this.refs.scrollPanel.isAtBottom();
	    },
	
	    /* get the current scroll state. See ScrollPanel.getScrollState for
	     * details.
	     *
	     * returns null if we are not mounted.
	     */
	    getScrollState: function getScrollState() {
	        if (!this.refs.scrollPanel) {
	            return null;
	        }
	        return this.refs.scrollPanel.getScrollState();
	    },
	
	    // returns one of:
	    //
	    //  null: there is no read marker
	    //  -1: read marker is above the window
	    //   0: read marker is within the window
	    //  +1: read marker is below the window
	    getReadMarkerPosition: function getReadMarkerPosition() {
	        var readMarker = this.refs.readMarkerNode;
	        var messageWrapper = this.refs.scrollPanel;
	
	        if (!readMarker || !messageWrapper) {
	            return null;
	        }
	
	        var wrapperRect = ReactDOM.findDOMNode(messageWrapper).getBoundingClientRect();
	        var readMarkerRect = readMarker.getBoundingClientRect();
	
	        // the read-marker pretends to have zero height when it is actually
	        // two pixels high; +2 here to account for that.
	        if (readMarkerRect.bottom + 2 < wrapperRect.top) {
	            return -1;
	        } else if (readMarkerRect.top < wrapperRect.bottom) {
	            return 0;
	        } else {
	            return 1;
	        }
	    },
	
	    /* jump to the top of the content.
	     */
	    scrollToTop: function scrollToTop() {
	        if (this.refs.scrollPanel) {
	            this.refs.scrollPanel.scrollToTop();
	        }
	    },
	
	    /* jump to the bottom of the content.
	     */
	    scrollToBottom: function scrollToBottom() {
	        if (this.refs.scrollPanel) {
	            this.refs.scrollPanel.scrollToBottom();
	        }
	    },
	
	    /**
	     * Page up/down.
	     *
	     * mult: -1 to page up, +1 to page down
	     */
	    scrollRelative: function scrollRelative(mult) {
	        if (this.refs.scrollPanel) {
	            this.refs.scrollPanel.scrollRelative(mult);
	        }
	    },
	
	    /**
	     * Scroll up/down in response to a scroll key
	     */
	    handleScrollKey: function handleScrollKey(ev) {
	        if (this.refs.scrollPanel) {
	            this.refs.scrollPanel.handleScrollKey(ev);
	        }
	    },
	
	    /* jump to the given event id.
	     *
	     * offsetBase gives the reference point for the pixelOffset. 0 means the
	     * top of the container, 1 means the bottom, and fractional values mean
	     * somewhere in the middle. If omitted, it defaults to 0.
	     *
	     * pixelOffset gives the number of pixels *above* the offsetBase that the
	     * node (specifically, the bottom of it) will be positioned. If omitted, it
	     * defaults to 0.
	     */
	    scrollToEvent: function scrollToEvent(eventId, pixelOffset, offsetBase) {
	        if (this.refs.scrollPanel) {
	            this.refs.scrollPanel.scrollToToken(eventId, pixelOffset, offsetBase);
	        }
	    },
	
	    /* check the scroll state and send out pagination requests if necessary.
	     */
	    checkFillState: function checkFillState() {
	        if (this.refs.scrollPanel) {
	            this.refs.scrollPanel.checkFillState();
	        }
	    },
	
	    _isUnmounting: function _isUnmounting() {
	        return !this._isMounted;
	    },
	
	    _getEventTiles: function _getEventTiles() {
	        var _this = this;
	
	        var EventTile = sdk.getComponent('rooms.EventTile');
	        var DateSeparator = sdk.getComponent('messages.DateSeparator');
	        var MemberEventListSummary = sdk.getComponent('views.elements.MemberEventListSummary');
	
	        this.eventNodes = {};
	
	        var i;
	
	        // first figure out which is the last event in the list which we're
	        // actually going to show; this allows us to behave slightly
	        // differently for the last event in the list.
	        //
	        // we also need to figure out which is the last event we show which isn't
	        // a local echo, to manage the read-marker.
	        var lastShownEventIndex = -1;
	        var lastShownNonLocalEchoIndex = -1;
	        for (i = this.props.events.length - 1; i >= 0; i--) {
	            var mxEv = this.props.events[i];
	            if (!EventTile.haveTileForEvent(mxEv)) {
	                continue;
	            }
	
	            if (lastShownEventIndex < 0) {
	                lastShownEventIndex = i;
	            }
	
	            if (mxEv.status) {
	                // this is a local echo
	                continue;
	            }
	
	            lastShownNonLocalEchoIndex = i;
	            break;
	        }
	
	        var ret = [];
	
	        var prevEvent = null; // the last event we showed
	
	        // assume there is no read marker until proven otherwise
	        var readMarkerVisible = false;
	
	        // if the readmarker has moved, cancel any active ghost.
	        if (this.currentReadMarkerEventId && this.props.readMarkerEventId && this.props.readMarkerVisible && this.currentReadMarkerEventId != this.props.readMarkerEventId) {
	            this.currentGhostEventId = null;
	        }
	
	        var isMembershipChange = function isMembershipChange(e) {
	            return e.getType() === 'm.room.member' && (!e.getPrevContent() || e.getContent().membership !== e.getPrevContent().membership);
	        };
	
	        for (i = 0; i < this.props.events.length; i++) {
	            var mxEv = this.props.events[i];
	            var wantTile = true;
	            var eventId = mxEv.getId();
	
	            if (!EventTile.haveTileForEvent(mxEv)) {
	                wantTile = false;
	            }
	
	            var last = i == lastShownEventIndex;
	
	            // Wrap consecutive member events in a ListSummary, ignore if redacted
	            if (isMembershipChange(mxEv) && EventTile.haveTileForEvent(mxEv) && !mxEv.isRedacted()) {
	                var ts1 = mxEv.getTs();
	                // Ensure that the key of the MemberEventListSummary does not change with new
	                // member events. This will prevent it from being re-created unnecessarily, and
	                // instead will allow new props to be provided. In turn, the shouldComponentUpdate
	                // method on MELS can be used to prevent unnecessary renderings.
	                //
	                // Whilst back-paginating with a MELS at the top of the panel, prevEvent will be null,
	                // so use the key "membereventlistsummary-initial". Otherwise, use the ID of the first
	                // membership event, which will not change during forward pagination.
	                var key = "membereventlistsummary-" + (prevEvent ? mxEv.getId() : "initial");
	
	                if (this._wantsDateSeparator(prevEvent, mxEv.getDate())) {
	                    var dateSeparator = React.createElement(
	                        "li",
	                        { key: ts1 + '~' },
	                        React.createElement(DateSeparator, { key: ts1 + '~', ts: ts1 })
	                    );
	                    ret.push(dateSeparator);
	                }
	
	                var summarisedEvents = [mxEv];
	                for (; i + 1 < this.props.events.length; i++) {
	                    var collapsedMxEv = this.props.events[i + 1];
	
	                    // Ignore redacted member events
	                    if (!EventTile.haveTileForEvent(collapsedMxEv)) {
	                        continue;
	                    }
	
	                    if (!isMembershipChange(collapsedMxEv) || this._wantsDateSeparator(this.props.events[i], collapsedMxEv.getDate())) {
	                        break;
	                    }
	                    summarisedEvents.push(collapsedMxEv);
	                }
	                // At this point, i = the index of the last event in the summary sequence
	
	                var eventTiles = summarisedEvents.map(function (e) {
	                    // In order to prevent DateSeparators from appearing in the expanded form
	                    // of MemberEventListSummary, render each member event as if the previous
	                    // one was itself. This way, the timestamp of the previous event === the
	                    // timestamp of the current event, and no DateSeperator is inserted.
	                    var ret = _this._getTilesForEvent(e, e);
	                    prevEvent = e;
	                    return ret;
	                }).reduce(function (a, b) {
	                    return a.concat(b);
	                });
	
	                if (eventTiles.length === 0) {
	                    eventTiles = null;
	                }
	
	                ret.push(React.createElement(
	                    MemberEventListSummary,
	                    {
	                        key: key,
	                        events: summarisedEvents,
	                        "data-scroll-token": eventId,
	                        onToggle: this._onWidgetLoad // Update scroll state
	                    },
	                    eventTiles
	                ));
	                continue;
	            }
	
	            if (wantTile) {
	                // make sure we unpack the array returned by _getTilesForEvent,
	                // otherwise react will auto-generate keys and we will end up
	                // replacing all of the DOM elements every time we paginate.
	                ret.push.apply(ret, (0, _toConsumableArray3.default)(this._getTilesForEvent(prevEvent, mxEv, last)));
	                prevEvent = mxEv;
	            }
	
	            var isVisibleReadMarker = false;
	
	            if (eventId == this.props.readMarkerEventId) {
	                var visible = this.props.readMarkerVisible;
	
	                // if the read marker comes at the end of the timeline (except
	                // for local echoes, which are excluded from RMs, because they
	                // don't have useful event ids), we don't want to show it, but
	                // we still want to create the <li/> for it so that the
	                // algorithms which depend on its position on the screen aren't
	                // confused.
	                if (i >= lastShownNonLocalEchoIndex) {
	                    visible = false;
	                }
	                ret.push(this._getReadMarkerTile(visible));
	                readMarkerVisible = visible;
	                isVisibleReadMarker = visible;
	            }
	
	            if (eventId == this.currentGhostEventId) {
	                // if we're showing an animation, continue to show it.
	                ret.push(this._getReadMarkerGhostTile());
	            } else if (!isVisibleReadMarker && eventId == this.currentReadMarkerEventId) {
	                // there is currently a read-up-to marker at this point, but no
	                // more. Show an animation of it disappearing.
	                ret.push(this._getReadMarkerGhostTile());
	                this.currentGhostEventId = eventId;
	            }
	        }
	
	        this.currentReadMarkerEventId = readMarkerVisible ? this.props.readMarkerEventId : null;
	        return ret;
	    },
	
	    _getTilesForEvent: function _getTilesForEvent(prevEvent, mxEv, last) {
	        var EventTile = sdk.getComponent('rooms.EventTile');
	        var DateSeparator = sdk.getComponent('messages.DateSeparator');
	        var ret = [];
	
	        // is this a continuation of the previous message?
	        var continuation = false;
	
	        if (prevEvent !== null && prevEvent.sender && mxEv.sender && mxEv.sender.userId === prevEvent.sender.userId && mxEv.getType() == prevEvent.getType()) {
	            continuation = true;
	        }
	
	        /*
	                // Work out if this is still a continuation, as we are now showing commands
	                // and /me messages with their own little avatar. The case of a change of
	                // event type (commands) is handled above, but we need to handle the /me
	                // messages seperately as they have a msgtype of 'm.emote' but are classed
	                // as normal messages
	                if (prevEvent !== null && prevEvent.sender && mxEv.sender
	                        && mxEv.sender.userId === prevEvent.sender.userId
	                        && mxEv.getType() == prevEvent.getType()
	                        && prevEvent.getContent().msgtype === 'm.emote') {
	                    continuation = false;
	                }
	        */
	
	        // local echoes have a fake date, which could even be yesterday. Treat them
	        // as 'today' for the date separators.
	        var ts1 = mxEv.getTs();
	        var eventDate = mxEv.getDate();
	        if (mxEv.status) {
	            eventDate = new Date();
	            ts1 = eventDate.getTime();
	        }
	
	        // do we need a date separator since the last event?
	        if (this._wantsDateSeparator(prevEvent, eventDate)) {
	            var dateSeparator = React.createElement(
	                "li",
	                { key: ts1 },
	                React.createElement(DateSeparator, { key: ts1, ts: ts1 })
	            );
	            ret.push(dateSeparator);
	            continuation = false;
	        }
	
	        var eventId = mxEv.getId();
	        var highlight = eventId == this.props.highlightedEventId;
	
	        // we can't use local echoes as scroll tokens, because their event IDs change.
	        // Local echos have a send "status".
	        var scrollToken = mxEv.status ? undefined : eventId;
	
	        var readReceipts;
	        if (this.props.manageReadReceipts) {
	            readReceipts = this._getReadReceiptsForEvent(mxEv);
	        }
	
	        ret.push(React.createElement(
	            "li",
	            { key: eventId,
	                ref: this._collectEventNode.bind(this, eventId),
	                "data-scroll-token": scrollToken },
	            React.createElement(EventTile, { mxEvent: mxEv, continuation: continuation,
	                isRedacted: mxEv.isRedacted(),
	                onWidgetLoad: this._onWidgetLoad,
	                readReceipts: readReceipts,
	                readReceiptMap: this._readReceiptMap,
	                showUrlPreview: this.props.showUrlPreview,
	                checkUnmounting: this._isUnmounting,
	                eventSendStatus: mxEv.status,
	                tileShape: this.props.tileShape,
	                last: last, isSelectedEvent: highlight })
	        ));
	
	        return ret;
	    },
	
	    _wantsDateSeparator: function _wantsDateSeparator(prevEvent, nextEventDate) {
	        if (prevEvent == null) {
	            // first event in the panel: depends if we could back-paginate from
	            // here.
	            return !this.props.suppressFirstDateSeparator;
	        }
	        var prevEventDate = prevEvent.getDate();
	        if (!nextEventDate || !prevEventDate) {
	            return false;
	        }
	        // Return early for events that are > 24h apart
	        if (Math.abs(prevEvent.getTs() - nextEventDate.getTime()) > MILLIS_IN_DAY) {
	            return true;
	        }
	
	        // Compare weekdays
	        return prevEventDate.getDay() !== nextEventDate.getDay();
	    },
	
	    // get a list of read receipts that should be shown next to this event
	    // Receipts are objects which have a 'roomMember' and 'ts'.
	    _getReadReceiptsForEvent: function _getReadReceiptsForEvent(event) {
	        var myUserId = MatrixClientPeg.get().credentials.userId;
	
	        // get list of read receipts, sorted most recent first
	        var room = MatrixClientPeg.get().getRoom(event.getRoomId());
	        if (!room) {
	            return null;
	        }
	        var receipts = [];
	        room.getReceiptsForEvent(event).forEach(function (r) {
	            if (!r.userId || r.type !== "m.read" || r.userId === myUserId) {
	                return; // ignore non-read receipts and receipts from self.
	            }
	            var member = room.getMember(r.userId);
	            if (!member) {
	                return; // ignore unknown user IDs
	            }
	            receipts.push({
	                roomMember: member,
	                ts: r.data ? r.data.ts : 0
	            });
	        });
	
	        return receipts.sort(function (r1, r2) {
	            return r2.ts - r1.ts;
	        });
	    },
	
	    _getReadMarkerTile: function _getReadMarkerTile(visible) {
	        var hr;
	        if (visible) {
	            hr = React.createElement("hr", { className: "mx_RoomView_myReadMarker",
	                style: { opacity: 1, width: '99%' }
	            });
	        }
	
	        return React.createElement(
	            "li",
	            { key: "_readupto", ref: "readMarkerNode",
	                className: "mx_RoomView_myReadMarker_container" },
	            hr
	        );
	    },
	
	    _startAnimation: function _startAnimation(ghostNode) {
	        if (this._readMarkerGhostNode) {
	            Velocity.Utilities.removeData(this._readMarkerGhostNode);
	        }
	        this._readMarkerGhostNode = ghostNode;
	
	        if (ghostNode) {
	            Velocity(ghostNode, { opacity: '0', width: '10%' }, { duration: 400, easing: 'easeInSine',
	                delay: 1000 });
	        }
	    },
	
	    _getReadMarkerGhostTile: function _getReadMarkerGhostTile() {
	        var hr = React.createElement("hr", { className: "mx_RoomView_myReadMarker",
	            style: { opacity: 1, width: '99%' },
	            ref: this._startAnimation
	        });
	
	        // give it a key which depends on the event id. That will ensure that
	        // we get a new DOM node (restarting the animation) when the ghost
	        // moves to a different event.
	        return React.createElement(
	            "li",
	            { key: "_readuptoghost_" + this.currentGhostEventId,
	                className: "mx_RoomView_myReadMarker_container" },
	            hr
	        );
	    },
	
	    _collectEventNode: function _collectEventNode(eventId, node) {
	        this.eventNodes[eventId] = node;
	    },
	
	    // once dynamic content in the events load, make the scrollPanel check the
	    // scroll offsets.
	    _onWidgetLoad: function _onWidgetLoad() {
	        var scrollPanel = this.refs.scrollPanel;
	        if (scrollPanel) {
	            scrollPanel.forceUpdate();
	        }
	    },
	
	    onResize: function onResize() {
	        dis.dispatch({ action: 'timeline_resize' }, true);
	    },
	
	    render: function render() {
	        var ScrollPanel = sdk.getComponent("structures.ScrollPanel");
	        var Spinner = sdk.getComponent("elements.Spinner");
	        var topSpinner, bottomSpinner;
	        if (this.props.backPaginating) {
	            topSpinner = React.createElement(
	                "li",
	                { key: "_topSpinner" },
	                React.createElement(Spinner, null)
	            );
	        }
	        if (this.props.forwardPaginating) {
	            bottomSpinner = React.createElement(
	                "li",
	                { key: "_bottomSpinner" },
	                React.createElement(Spinner, null)
	            );
	        }
	
	        var style = this.props.hidden ? { display: 'none' } : {};
	        style.opacity = this.props.opacity;
	
	        return React.createElement(
	            ScrollPanel,
	            { ref: "scrollPanel", className: this.props.className + " mx_fadable",
	                onScroll: this.props.onScroll,
	                onResize: this.onResize,
	                onFillRequest: this.props.onFillRequest,
	                onUnfillRequest: this.props.onUnfillRequest,
	                style: style,
	                stickyBottom: this.props.stickyBottom },
	            topSpinner,
	            this._getEventTiles(),
	            bottomSpinner
	        );
	    }
	});


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	
	var Matrix = __webpack_require__(28);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	
	/*
	 * Component which shows the global notification list using a TimelinePanel
	 */
	var NotificationPanel = React.createClass({
	    displayName: 'NotificationPanel',
	
	    propTypes: {},
	
	    render: function render() {
	        // wrap a TimelinePanel with the jump-to-event bits turned off.
	        var TimelinePanel = sdk.getComponent("structures.TimelinePanel");
	        var Loader = sdk.getComponent("elements.Spinner");
	
	        var timelineSet = MatrixClientPeg.get().getNotifTimelineSet();
	
	        if (timelineSet) {
	            return React.createElement(TimelinePanel, { key: "NotificationPanel_" + this.props.roomId,
	                className: "mx_NotificationPanel",
	                manageReadReceipts: false,
	                manageReadMarkers: false,
	                timelineSet: timelineSet,
	                showUrlPreview: false,
	                opacity: this.props.opacity,
	                tileShape: "notif",
	                empty: "You have no visible notifications"
	            });
	        } else {
	            console.error("No notifTimelineSet available!");
	            return React.createElement(
	                "div",
	                { className: "mx_NotificationPanel" },
	                React.createElement(Loader, null)
	            );
	        }
	    }
	});
	
	module.exports = NotificationPanel;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var WhoIsTyping = __webpack_require__(1166);
	var MatrixClientPeg = __webpack_require__(4);
	var MemberAvatar = __webpack_require__(334);
	
	var HIDE_DEBOUNCE_MS = 10000;
	var STATUS_BAR_HIDDEN = 0;
	var STATUS_BAR_EXPANDED = 1;
	var STATUS_BAR_EXPANDED_LARGE = 2;
	
	module.exports = React.createClass({
	    displayName: 'RoomStatusBar',
	
	    propTypes: {
	        // the room this statusbar is representing.
	        room: React.PropTypes.object.isRequired,
	
	        // a TabComplete object
	        tabComplete: React.PropTypes.object.isRequired,
	
	        // the number of messages which have arrived since we've been scrolled up
	        numUnreadMessages: React.PropTypes.number,
	
	        // string to display when there are messages in the room which had errors on send
	        unsentMessageError: React.PropTypes.string,
	
	        // this is true if we are fully scrolled-down, and are looking at
	        // the end of the live timeline.
	        atEndOfLiveTimeline: React.PropTypes.bool,
	
	        // true if there is an active call in this room (means we show
	        // the 'Active Call' text in the status bar if there is nothing
	        // more interesting)
	        hasActiveCall: React.PropTypes.bool,
	
	        // Number of names to display in typing indication. E.g. set to 3, will
	        // result in "X, Y, Z and 100 others are typing."
	        whoIsTypingLimit: React.PropTypes.number,
	
	        // callback for when the user clicks on the 'resend all' button in the
	        // 'unsent messages' bar
	        onResendAllClick: React.PropTypes.func,
	
	        // callback for when the user clicks on the 'cancel all' button in the
	        // 'unsent messages' bar
	        onCancelAllClick: React.PropTypes.func,
	
	        // callback for when the user clicks on the 'scroll to bottom' button
	        onScrollToBottomClick: React.PropTypes.func,
	
	        // callback for when we do something that changes the size of the
	        // status bar. This is used to trigger a re-layout in the parent
	        // component.
	        onResize: React.PropTypes.func,
	
	        // callback for when the status bar can be hidden from view, as it is
	        // not displaying anything
	        onHidden: React.PropTypes.func,
	
	        // callback for when the status bar is displaying something and should
	        // be visible
	        onVisible: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            whoIsTypingLimit: 3
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            syncState: MatrixClientPeg.get().getSyncState(),
	            usersTyping: WhoIsTyping.usersTypingApartFromMe(this.props.room)
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        MatrixClientPeg.get().on("sync", this.onSyncStateChange);
	        MatrixClientPeg.get().on("RoomMember.typing", this.onRoomMemberTyping);
	
	        this._checkSize();
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        this._checkSize();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // we may have entirely lost our client as we're logging out before clicking login on the guest bar...
	        var client = MatrixClientPeg.get();
	        if (client) {
	            client.removeListener("sync", this.onSyncStateChange);
	            client.removeListener("RoomMember.typing", this.onRoomMemberTyping);
	        }
	    },
	
	    onSyncStateChange: function onSyncStateChange(state, prevState) {
	        if (state === "SYNCING" && prevState === "SYNCING") {
	            return;
	        }
	        this.setState({
	            syncState: state
	        });
	    },
	
	    onRoomMemberTyping: function onRoomMemberTyping(ev, member) {
	        this.setState({
	            usersTyping: WhoIsTyping.usersTypingApartFromMe(this.props.room)
	        });
	    },
	
	    // Check whether current size is greater than 0, if yes call props.onVisible
	    _checkSize: function _checkSize() {
	        if (this.props.onVisible && this._getSize()) {
	            this.props.onVisible();
	        }
	    },
	
	    // We don't need the actual height - just whether it is likely to have
	    // changed - so we use '0' to indicate normal size, and other values to
	    // indicate other sizes.
	    _getSize: function _getSize() {
	        if (this.state.syncState === "ERROR" || this.state.usersTyping.length > 0 || this.props.numUnreadMessages || !this.props.atEndOfLiveTimeline || this.props.hasActiveCall || this.props.tabComplete.isTabCompleting()) {
	            return STATUS_BAR_EXPANDED;
	        } else if (this.props.tabCompleteEntries) {
	            return STATUS_BAR_HIDDEN;
	        } else if (this.props.unsentMessageError) {
	            return STATUS_BAR_EXPANDED_LARGE;
	        }
	        return STATUS_BAR_HIDDEN;
	    },
	
	    // return suitable content for the image on the left of the status bar.
	    //
	    // if wantPlaceholder is true, we include a "..." placeholder if
	    // there is nothing better to put in.
	    _getIndicator: function _getIndicator(wantPlaceholder) {
	        if (this.props.numUnreadMessages) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_scrollDownIndicator',
	                    onClick: this.props.onScrollToBottomClick },
	                React.createElement('img', { src: 'img/newmessages.svg', width: '24', height: '24',
	                    alt: '' })
	            );
	        }
	
	        if (!this.props.atEndOfLiveTimeline) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_scrollDownIndicator',
	                    onClick: this.props.onScrollToBottomClick },
	                React.createElement('img', { src: 'img/scrolldown.svg', width: '24', height: '24',
	                    alt: 'Scroll to bottom of page',
	                    title: 'Scroll to bottom of page' })
	            );
	        }
	
	        if (this.props.hasActiveCall) {
	            var TintableSvg = sdk.getComponent("elements.TintableSvg");
	            return React.createElement(TintableSvg, { src: 'img/sound-indicator.svg', width: '23', height: '20' });
	        }
	
	        if (this.state.syncState === "ERROR") {
	            return null;
	        }
	
	        if (wantPlaceholder) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_typingIndicatorAvatars' },
	                this._renderTypingIndicatorAvatars(this.props.whoIsTypingLimit)
	            );
	        }
	
	        return null;
	    },
	
	    _renderTypingIndicatorAvatars: function _renderTypingIndicatorAvatars(limit) {
	        var users = this.state.usersTyping;
	
	        var othersCount = 0;
	        if (users.length > limit) {
	            othersCount = users.length - limit + 1;
	            users = users.slice(0, limit - 1);
	        }
	
	        var avatars = users.map(function (u) {
	            return React.createElement(MemberAvatar, {
	                key: u.userId,
	                member: u,
	                width: 24,
	                height: 24,
	                resizeMethod: 'crop'
	            });
	        });
	
	        if (othersCount > 0) {
	            avatars.push(React.createElement(
	                'span',
	                { className: 'mx_RoomStatusBar_typingIndicatorRemaining', key: 'others' },
	                '+',
	                othersCount
	            ));
	        }
	
	        return avatars;
	    },
	
	    // return suitable content for the main (text) part of the status bar.
	    _getContent: function _getContent() {
	        var TabCompleteBar = sdk.getComponent('rooms.TabCompleteBar');
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	        var EmojiText = sdk.getComponent('elements.EmojiText');
	
	        // no conn bar trumps unread count since you can't get unread messages
	        // without a connection! (technically may already have some but meh)
	        // It also trumps the "some not sent" msg since you can't resend without
	        // a connection!
	        if (this.state.syncState === "ERROR") {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_connectionLostBar' },
	                React.createElement('img', { src: 'img/warning.svg', width: '24', height: '23', title: '/!\\ ', alt: '/!\\ ' }),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomStatusBar_connectionLostBar_title' },
	                    'Connectivity to the server has been lost.'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomStatusBar_connectionLostBar_desc' },
	                    'Sent messages will be stored until your connection has returned.'
	                )
	            );
	        }
	
	        if (this.props.tabComplete.isTabCompleting()) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_tabCompleteBar' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomStatusBar_tabCompleteWrapper' },
	                    React.createElement(TabCompleteBar, { tabComplete: this.props.tabComplete }),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_RoomStatusBar_tabCompleteEol', title: '->|' },
	                        React.createElement(TintableSvg, { src: 'img/eol.svg', width: '22', height: '16' }),
	                        'Auto-complete'
	                    )
	                )
	            );
	        }
	
	        if (this.props.unsentMessageError) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_connectionLostBar' },
	                React.createElement('img', { src: 'img/warning.svg', width: '24', height: '23', title: '/!\\ ', alt: '/!\\ ' }),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomStatusBar_connectionLostBar_title' },
	                    this.props.unsentMessageError
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomStatusBar_connectionLostBar_desc' },
	                    React.createElement(
	                        'a',
	                        { className: 'mx_RoomStatusBar_resend_link',
	                            onClick: this.props.onResendAllClick },
	                        'Resend all'
	                    ),
	                    ' or ',
	                    React.createElement(
	                        'a',
	                        {
	                            className: 'mx_RoomStatusBar_resend_link',
	                            onClick: this.props.onCancelAllClick },
	                        'cancel all'
	                    ),
	                    ' now. You can also select individual messages to resend or cancel.'
	                )
	            );
	        }
	
	        // unread count trumps who is typing since the unread count is only
	        // set when you've scrolled up
	        if (this.props.numUnreadMessages) {
	            var unreadMsgs = this.props.numUnreadMessages + " new message" + (this.props.numUnreadMessages > 1 ? "s" : "");
	
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_unreadMessagesBar',
	                    onClick: this.props.onScrollToBottomClick },
	                unreadMsgs
	            );
	        }
	
	        var typingString = WhoIsTyping.whoIsTypingString(this.state.usersTyping, this.props.whoIsTypingLimit);
	        if (typingString) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_typingBar' },
	                React.createElement(
	                    EmojiText,
	                    null,
	                    typingString
	                )
	            );
	        }
	
	        if (this.props.hasActiveCall) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_callBar' },
	                React.createElement(
	                    'b',
	                    null,
	                    'Active call'
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        var content = this._getContent();
	        var indicator = this._getIndicator(this.state.usersTyping.length > 0);
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomStatusBar' },
	            React.createElement(
	                'div',
	                { className: 'mx_RoomStatusBar_indicator' },
	                indicator
	            ),
	            content
	        );
	    }
	});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _KeyCode = __webpack_require__(116);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _UserProvider = __webpack_require__(508);
	
	var _UserProvider2 = _interopRequireDefault(_UserProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	// TODO: This component is enormous! There's several things which could stand-alone:
	//  - Search results component
	//  - Drag and drop
	//  - File uploading - uploadFile()
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var q = __webpack_require__(6);
	var classNames = __webpack_require__(27);
	var Matrix = __webpack_require__(28);
	
	var MatrixClientPeg = __webpack_require__(4);
	var ContentMessages = __webpack_require__(497);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	var CallHandler = __webpack_require__(73);
	var TabComplete = __webpack_require__(1162);
	var Resend = __webpack_require__(327);
	var dis = __webpack_require__(5);
	var Tinter = __webpack_require__(140);
	var rate_limited_func = __webpack_require__(119);
	var ObjectUtils = __webpack_require__(139);
	var Rooms = __webpack_require__(117);
	
	var DEBUG = false;
	
	if (DEBUG) {
	    // using bind means that we get to keep useful line numbers in the console
	    var debuglog = console.log.bind(console);
	} else {
	    var debuglog = function debuglog() {};
	}
	
	module.exports = React.createClass({
	    displayName: 'RoomView',
	    propTypes: {
	        ConferenceHandler: React.PropTypes.any,
	
	        // Either a room ID or room alias for the room to display.
	        // If the room is being displayed as a result of the user clicking
	        // on a room alias, the alias should be supplied. Otherwise, a room
	        // ID should be supplied.
	        roomAddress: React.PropTypes.string.isRequired,
	
	        // If a room alias is passed to roomAddress, a function can be
	        // provided here that will be called with the ID of the room
	        // once it has been resolved.
	        onRoomIdResolved: React.PropTypes.func,
	
	        // An object representing a third party invite to join this room
	        // Fields:
	        // * inviteSignUrl (string) The URL used to join this room from an email invite
	        //                          (given as part of the link in the invite email)
	        // * invitedEmail (string) The email address that was invited to this room
	        thirdPartyInvite: React.PropTypes.object,
	
	        // Any data about the room that would normally come from the Home Server
	        // but has been passed out-of-band, eg. the room name and avatar URL
	        // from an email invite (a workaround for the fact that we can't
	        // get this information from the HS using an email invite).
	        // Fields:
	        //  * name (string) The room's name
	        //  * avatarUrl (string) The mxc:// avatar URL for the room
	        //  * inviterName (string) The display name of the person who
	        //  *                      invited us tovthe room
	        oobData: React.PropTypes.object,
	
	        // id of an event to jump to. If not given, will go to the end of the
	        // live timeline.
	        eventId: React.PropTypes.string,
	
	        // where to position the event given by eventId, in pixels from the
	        // bottom of the viewport. If not given, will try to put the event
	        // 1/3 of the way down the viewport.
	        eventPixelOffset: React.PropTypes.number,
	
	        // ID of an event to highlight. If undefined, no event will be highlighted.
	        // Typically this will either be the same as 'eventId', or undefined.
	        highlightedEventId: React.PropTypes.string,
	
	        // is the RightPanel collapsed?
	        collapsedRhs: React.PropTypes.bool,
	
	        // a map from room id to scroll state, which will be updated on unmount.
	        //
	        // If there is no special scroll state (ie, we are following the live
	        // timeline), the scroll state is null. Otherwise, it is an object with
	        // the following properties:
	        //
	        //    focussedEvent: the ID of the 'focussed' event. Typically this is
	        //        the last event fully visible in the viewport, though if we
	        //        have done an explicit scroll to an explicit event, it will be
	        //        that event.
	        //
	        //    pixelOffset: the number of pixels the window is scrolled down
	        //        from the focussedEvent.
	        scrollStateMap: React.PropTypes.object
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            room: null,
	            roomId: null,
	            roomLoading: true,
	            editingRoomSettings: false,
	            uploadingRoomSettings: false,
	            numUnreadMessages: 0,
	            draggingFile: false,
	            searching: false,
	            searchResults: null,
	            unsentMessageError: '',
	            callState: null,
	            guestsCanJoin: false,
	            canPeek: false,
	
	            // error object, as from the matrix client/server API
	            // If we failed to load information about the room,
	            // store the error here.
	            roomLoadError: null,
	
	            // this is true if we are fully scrolled-down, and are looking at
	            // the end of the live timeline. It has the effect of hiding the
	            // 'scroll to bottom' knob, among a couple of other things.
	            atEndOfLiveTimeline: true,
	
	            showTopUnreadMessagesBar: false,
	
	            auxPanelMaxHeight: undefined,
	
	            statusBarVisible: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        this.dispatcherRef = dis.register(this.onAction);
	        MatrixClientPeg.get().on("Room", this.onRoom);
	        MatrixClientPeg.get().on("Room.timeline", this.onRoomTimeline);
	        MatrixClientPeg.get().on("Room.name", this.onRoomName);
	        MatrixClientPeg.get().on("Room.accountData", this.onRoomAccountData);
	        MatrixClientPeg.get().on("RoomState.members", this.onRoomStateMember);
	        MatrixClientPeg.get().on("RoomMember.membership", this.onRoomMemberMembership);
	        MatrixClientPeg.get().on("accountData", this.onAccountData);
	
	        this.tabComplete = new TabComplete({
	            allowLooping: false,
	            autoEnterTabComplete: true,
	            onClickCompletes: true,
	            onStateChange: function onStateChange(isCompleting) {
	                _this.forceUpdate();
	            }
	        });
	
	        if (this.props.roomAddress[0] == '#') {
	            // we always look up the alias from the directory server:
	            // we want the room that the given alias is pointing to
	            // right now. We may have joined that alias before but there's
	            // no guarantee the alias hasn't subsequently been remapped.
	            MatrixClientPeg.get().getRoomIdForAlias(this.props.roomAddress).done(function (result) {
	                if (_this.props.onRoomIdResolved) {
	                    _this.props.onRoomIdResolved(result.room_id);
	                }
	                var room = MatrixClientPeg.get().getRoom(result.room_id);
	                _this.setState({
	                    room: room,
	                    roomId: result.room_id,
	                    roomLoading: !room,
	                    unsentMessageError: _this._getUnsentMessageError(room)
	                }, _this._onHaveRoom);
	            }, function (err) {
	                _this.setState({
	                    roomLoading: false,
	                    roomLoadError: err
	                });
	            });
	        } else {
	            var room = MatrixClientPeg.get().getRoom(this.props.roomAddress);
	            this.setState({
	                roomId: this.props.roomAddress,
	                room: room,
	                roomLoading: !room,
	                unsentMessageError: this._getUnsentMessageError(room)
	            }, this._onHaveRoom);
	        }
	    },
	
	    _onHaveRoom: function _onHaveRoom() {
	        var _this2 = this;
	
	        // if this is an unknown room then we're in one of three states:
	        // - This is a room we can peek into (search engine) (we can /peek)
	        // - This is a room we can publicly join or were invited to. (we can /join)
	        // - This is a room we cannot join at all. (no action can help us)
	        // We can't try to /join because this may implicitly accept invites (!)
	        // We can /peek though. If it fails then we present the join UI. If it
	        // succeeds then great, show the preview (but we still may be able to /join!).
	        // Note that peeking works by room ID and room ID only, as opposed to joining
	        // which must be by alias or invite wherever possible (peeking currently does
	        // not work over federation).
	
	        // NB. We peek if we are not in the room, although if we try to peek into
	        // a room in which we have a member event (ie. we've left) synapse will just
	        // send us the same data as we get in the sync (ie. the last events we saw).
	        var user_is_in_room = null;
	        if (this.state.room) {
	            user_is_in_room = this.state.room.hasMembershipState(MatrixClientPeg.get().credentials.userId, 'join');
	
	            this._updateAutoComplete();
	            this.tabComplete.loadEntries(this.state.room);
	        }
	
	        if (!user_is_in_room && this.state.roomId) {
	            if (this.props.autoJoin) {
	                this.onJoinButtonClicked();
	            } else if (this.state.roomId) {
	                console.log("Attempting to peek into room %s", this.state.roomId);
	
	                MatrixClientPeg.get().peekInRoom(this.state.roomId).then(function (room) {
	                    _this2.setState({
	                        room: room,
	                        roomLoading: false
	                    });
	                    _this2._onRoomLoaded(room);
	                }, function (err) {
	                    // This won't necessarily be a MatrixError, but we duck-type
	                    // here and say if it's got an 'errcode' key with the right value,
	                    // it means we can't peek.
	                    if (err.errcode == "M_GUEST_ACCESS_FORBIDDEN") {
	                        // This is fine: the room just isn't peekable (we assume).
	                        _this2.setState({
	                            roomLoading: false
	                        });
	                    } else {
	                        throw err;
	                    }
	                }).done();
	            }
	        } else if (user_is_in_room) {
	            MatrixClientPeg.get().stopPeeking();
	            this._onRoomLoaded(this.state.room);
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        var call = this._getCallForRoom();
	        var callState = call ? call.call_state : "ended";
	        this.setState({
	            callState: callState
	        });
	
	        this._updateConfCallNotification();
	
	        window.addEventListener('resize', this.onResize);
	        this.onResize();
	
	        document.addEventListener("keydown", this.onKeyDown);
	
	        // XXX: EVIL HACK to autofocus inviting on empty rooms.
	        // We use the setTimeout to avoid racing with focus_composer.
	        if (this.state.room && this.state.room.getJoinedMembers().length == 1 && this.state.room.getLiveTimeline() && this.state.room.getLiveTimeline().getEvents() && this.state.room.getLiveTimeline().getEvents().length <= 6) {
	            var inviteBox = document.getElementById("mx_SearchableEntityList_query");
	            setTimeout(function () {
	                if (inviteBox) {
	                    inviteBox.focus();
	                }
	            }, 50);
	        }
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        if (newProps.roomAddress != this.props.roomAddress) {
	            throw new Error("changing room on a RoomView is not supported");
	        }
	
	        if (newProps.eventId != this.props.eventId) {
	            // when we change focussed event id, hide the search results.
	            this.setState({ searchResults: null });
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return !ObjectUtils.shallowEqual(this.props, nextProps) || !ObjectUtils.shallowEqual(this.state, nextState);
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (this.refs.roomView) {
	            var roomView = ReactDOM.findDOMNode(this.refs.roomView);
	            if (!roomView.ondrop) {
	                roomView.addEventListener('drop', this.onDrop);
	                roomView.addEventListener('dragover', this.onDragOver);
	                roomView.addEventListener('dragleave', this.onDragLeaveOrEnd);
	                roomView.addEventListener('dragend', this.onDragLeaveOrEnd);
	            }
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // set a boolean to say we've been unmounted, which any pending
	        // promises can use to throw away their results.
	        //
	        // (We could use isMounted, but facebook have deprecated that.)
	        this.unmounted = true;
	
	        // update the scroll map before we get unmounted
	        this._updateScrollMap();
	
	        if (this.refs.roomView) {
	            // disconnect the D&D event listeners from the room view. This
	            // is really just for hygiene - we're going to be
	            // deleted anyway, so it doesn't matter if the event listeners
	            // don't get cleaned up.
	            var roomView = ReactDOM.findDOMNode(this.refs.roomView);
	            roomView.removeEventListener('drop', this.onDrop);
	            roomView.removeEventListener('dragover', this.onDragOver);
	            roomView.removeEventListener('dragleave', this.onDragLeaveOrEnd);
	            roomView.removeEventListener('dragend', this.onDragLeaveOrEnd);
	        }
	        dis.unregister(this.dispatcherRef);
	        if (MatrixClientPeg.get()) {
	            MatrixClientPeg.get().removeListener("Room", this.onRoom);
	            MatrixClientPeg.get().removeListener("Room.timeline", this.onRoomTimeline);
	            MatrixClientPeg.get().removeListener("Room.name", this.onRoomName);
	            MatrixClientPeg.get().removeListener("Room.accountData", this.onRoomAccountData);
	            MatrixClientPeg.get().removeListener("RoomState.members", this.onRoomStateMember);
	            MatrixClientPeg.get().removeListener("RoomMember.membership", this.onRoomMemberMembership);
	            MatrixClientPeg.get().removeListener("accountData", this.onAccountData);
	        }
	
	        window.removeEventListener('resize', this.onResize);
	
	        document.removeEventListener("keydown", this.onKeyDown);
	
	        // cancel any pending calls to the rate_limited_funcs
	        this._updateRoomMembers.cancelPendingCall();
	
	        // no need to do this as Dir & Settings are now overlays. It just burnt CPU.
	        // console.log("Tinter.tint from RoomView.unmount");
	        // Tinter.tint(); // reset colourscheme
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        var handled = false;
	        var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	        var ctrlCmdOnly = void 0;
	        if (isMac) {
	            ctrlCmdOnly = ev.metaKey && !ev.altKey && !ev.ctrlKey && !ev.shiftKey;
	        } else {
	            ctrlCmdOnly = ev.ctrlKey && !ev.altKey && !ev.metaKey && !ev.shiftKey;
	        }
	
	        switch (ev.keyCode) {
	            case _KeyCode2.default.KEY_D:
	                if (ctrlCmdOnly) {
	                    this.onMuteAudioClick();
	                    handled = true;
	                }
	                break;
	
	            case _KeyCode2.default.KEY_E:
	                if (ctrlCmdOnly) {
	                    this.onMuteVideoClick();
	                    handled = true;
	                }
	                break;
	        }
	
	        if (handled) {
	            ev.stopPropagation();
	            ev.preventDefault();
	        }
	    },
	
	    onAction: function onAction(payload) {
	        switch (payload.action) {
	            case 'message_send_failed':
	            case 'message_sent':
	            case 'message_send_cancelled':
	                this.setState({
	                    unsentMessageError: this._getUnsentMessageError(this.state.room)
	                });
	                break;
	            case 'notifier_enabled':
	            case 'upload_failed':
	            case 'upload_started':
	            case 'upload_finished':
	                this.forceUpdate();
	                break;
	            case 'call_state':
	                // don't filter out payloads for room IDs other than props.room because
	                // we may be interested in the conf 1:1 room
	
	                if (!payload.room_id) {
	                    return;
	                }
	
	                var call = this._getCallForRoom();
	                var callState;
	
	                if (call) {
	                    callState = call.call_state;
	                } else {
	                    callState = "ended";
	                }
	
	                // possibly remove the conf call notification if we're now in
	                // the conf
	                this._updateConfCallNotification();
	
	                this.setState({
	                    callState: callState
	                });
	
	                break;
	        }
	    },
	
	    onRoomTimeline: function onRoomTimeline(ev, room, toStartOfTimeline, removed, data) {
	        if (this.unmounted) return;
	
	        // ignore events for other rooms
	        if (!room) return;
	        if (!this.state.room || room.roomId != this.state.room.roomId) return;
	
	        // ignore events from filtered timelines
	        if (data.timeline.getTimelineSet() !== room.getUnfilteredTimelineSet()) return;
	
	        if (ev.getType() === "org.matrix.room.preview_urls") {
	            this._updatePreviewUrlVisibility(room);
	        }
	
	        // ignore anything but real-time updates at the end of the room:
	        // updates from pagination will happen when the paginate completes.
	        if (toStartOfTimeline || !data || !data.liveEvent) return;
	
	        // no point handling anything while we're waiting for the join to finish:
	        // we'll only be showing a spinner.
	        if (this.state.joining) return;
	
	        if (ev.getSender() !== MatrixClientPeg.get().credentials.userId) {
	            // update unread count when scrolled up
	            if (!this.state.searchResults && this.state.atEndOfLiveTimeline) {
	                // no change
	            } else {
	                this.setState(function (state, props) {
	                    return { numUnreadMessages: state.numUnreadMessages + 1 };
	                });
	            }
	        }
	
	        // update the tab complete list as it depends on who most recently spoke,
	        // and that has probably just changed
	        if (ev.sender) {
	            this.tabComplete.onMemberSpoke(ev.sender);
	            // nb. we don't need to update the new autocomplete here since
	            // its results are currently ordered purely by search score.
	        }
	    },
	
	    onRoomName: function onRoomName(room) {
	        if (this.state.room && room.roomId == this.state.room.roomId) {
	            this.forceUpdate();
	        }
	    },
	
	    canResetTimeline: function canResetTimeline() {
	        if (!this.refs.messagePanel) {
	            return true;
	        }
	        return this.refs.messagePanel.canResetTimeline();
	    },
	
	    // called when state.room is first initialised (either at initial load,
	    // after a successful peek, or after we join the room).
	    _onRoomLoaded: function _onRoomLoaded(room) {
	        this._warnAboutEncryption(room);
	        this._calculatePeekRules(room);
	        this._updatePreviewUrlVisibility(room);
	    },
	
	    _warnAboutEncryption: function _warnAboutEncryption(room) {
	        if (!MatrixClientPeg.get().isRoomEncrypted(room.roomId)) {
	            return;
	        }
	        var userHasUsedEncryption = false;
	        if (localStorage) {
	            userHasUsedEncryption = localStorage.getItem('mx_user_has_used_encryption');
	        }
	        if (!userHasUsedEncryption) {
	            var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	            Modal.createDialog(QuestionDialog, {
	                title: "Warning!",
	                hasCancelButton: false,
	                description: React.createElement(
	                    "div",
	                    null,
	                    React.createElement(
	                        "p",
	                        null,
	                        "End-to-end encryption is in beta and may not be reliable."
	                    ),
	                    React.createElement(
	                        "p",
	                        null,
	                        "You should ",
	                        React.createElement(
	                            "b",
	                            null,
	                            "not"
	                        ),
	                        " yet trust it to secure data."
	                    ),
	                    React.createElement(
	                        "p",
	                        null,
	                        "Devices will ",
	                        React.createElement(
	                            "b",
	                            null,
	                            "not"
	                        ),
	                        " yet be able to decrypt history from before they joined the room."
	                    ),
	                    React.createElement(
	                        "p",
	                        null,
	                        "Encrypted messages will not be visible on clients that do not yet implement encryption."
	                    )
	                )
	            });
	        }
	        if (localStorage) {
	            localStorage.setItem('mx_user_has_used_encryption', true);
	        }
	    },
	
	    _calculatePeekRules: function _calculatePeekRules(room) {
	        var guestAccessEvent = room.currentState.getStateEvents("m.room.guest_access", "");
	        if (guestAccessEvent && guestAccessEvent.getContent().guest_access === "can_join") {
	            this.setState({
	                guestsCanJoin: true
	            });
	        }
	
	        var historyVisibility = room.currentState.getStateEvents("m.room.history_visibility", "");
	        if (historyVisibility && historyVisibility.getContent().history_visibility === "world_readable") {
	            this.setState({
	                canPeek: true
	            });
	        }
	    },
	
	    _updatePreviewUrlVisibility: function _updatePreviewUrlVisibility(room) {
	        // console.log("_updatePreviewUrlVisibility");
	
	        // check our per-room overrides
	        var roomPreviewUrls = room.getAccountData("org.matrix.room.preview_urls");
	        if (roomPreviewUrls && roomPreviewUrls.getContent().disable !== undefined) {
	            this.setState({
	                showUrlPreview: !roomPreviewUrls.getContent().disable
	            });
	            return;
	        }
	
	        // check our global disable override
	        var userRoomPreviewUrls = MatrixClientPeg.get().getAccountData("org.matrix.preview_urls");
	        if (userRoomPreviewUrls && userRoomPreviewUrls.getContent().disable) {
	            this.setState({
	                showUrlPreview: false
	            });
	            return;
	        }
	
	        // check the room state event
	        var roomStatePreviewUrls = room.currentState.getStateEvents('org.matrix.room.preview_urls', '');
	        if (roomStatePreviewUrls && roomStatePreviewUrls.getContent().disable) {
	            this.setState({
	                showUrlPreview: false
	            });
	            return;
	        }
	
	        // otherwise, we assume they're on.
	        this.setState({
	            showUrlPreview: true
	        });
	    },
	
	    onRoom: function onRoom(room) {
	        // This event is fired when the room is 'stored' by the JS SDK, which
	        // means it's now a fully-fledged room object ready to be used, so
	        // set it in our state and start using it (ie. init the timeline)
	        // This will happen if we start off viewing a room we're not joined,
	        // then join it whilst RoomView is looking at that room.
	        if (!this.state.room && room.roomId == this._joiningRoomId) {
	            this._joiningRoomId = undefined;
	            this.setState({
	                room: room,
	                joining: false
	            });
	
	            this._onRoomLoaded(room);
	        }
	    },
	
	    updateTint: function updateTint() {
	        var room = this.state.room;
	        if (!room) return;
	
	        var color_scheme_event = room.getAccountData("org.matrix.room.color_scheme");
	        var color_scheme = {};
	        if (color_scheme_event) {
	            color_scheme = color_scheme_event.getContent();
	            // XXX: we should validate the event
	        }
	        console.log("Tinter.tint from updateTint");
	        Tinter.tint(color_scheme.primary_color, color_scheme.secondary_color);
	    },
	
	    onAccountData: function onAccountData(event) {
	        if (event.getType() === "org.matrix.preview_urls" && this.state.room) {
	            this._updatePreviewUrlVisibility(this.state.room);
	        }
	    },
	
	    onRoomAccountData: function onRoomAccountData(event, room) {
	        if (room.roomId == this.state.roomId) {
	            if (event.getType() === "org.matrix.room.color_scheme") {
	                var color_scheme = event.getContent();
	                // XXX: we should validate the event
	                console.log("Tinter.tint from onRoomAccountData");
	                Tinter.tint(color_scheme.primary_color, color_scheme.secondary_color);
	            } else if (event.getType() === "org.matrix.room.preview_urls") {
	                this._updatePreviewUrlVisibility(room);
	            }
	        }
	    },
	
	    onRoomStateMember: function onRoomStateMember(ev, state, member) {
	        // ignore if we don't have a room yet
	        if (!this.state.room) {
	            return;
	        }
	
	        // ignore members in other rooms
	        if (member.roomId !== this.state.room.roomId) {
	            return;
	        }
	
	        this._updateRoomMembers();
	    },
	
	    onRoomMemberMembership: function onRoomMemberMembership(ev, member, oldMembership) {
	        if (member.userId == MatrixClientPeg.get().credentials.userId) {
	            this.forceUpdate();
	        }
	    },
	
	    // rate limited because a power level change will emit an event for every
	    // member in the room.
	    _updateRoomMembers: new rate_limited_func(function () {
	        // a member state changed in this room
	        // refresh the conf call notification state
	        this._updateConfCallNotification();
	
	        // refresh the tab complete list
	        this.tabComplete.loadEntries(this.state.room);
	        this._updateAutoComplete();
	
	        // if we are now a member of the room, where we were not before, that
	        // means we have finished joining a room we were previously peeking
	        // into.
	        var me = MatrixClientPeg.get().credentials.userId;
	        if (this.state.joining && this.state.room.hasMembershipState(me, "join")) {
	            // Having just joined a room, check to see if it looks like a DM room, and if so,
	            // mark it as one. This is to work around the fact that some clients don't support
	            // is_direct. We should remove this once they do.
	            var _me = this.state.room.getMember(MatrixClientPeg.get().credentials.userId);
	            if (Rooms.looksLikeDirectMessageRoom(this.state.room, _me)) {
	                // XXX: There's not a whole lot we can really do if this fails: at best
	                // perhaps we could try a couple more times, but since it's a temporary
	                // compatability workaround, let's not bother.
	                Rooms.setDMRoom(this.state.room.roomId, _me.events.member.getSender()).done();
	            }
	
	            this.setState({
	                joining: false
	            });
	        }
	    }, 500),
	
	    _getUnsentMessageError: function _getUnsentMessageError(room) {
	        var unsentMessages = this._getUnsentMessages(room);
	        if (!unsentMessages.length) return "";
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = (0, _getIterator3.default)(unsentMessages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var event = _step.value;
	
	                if (!event.error || event.error.name !== "UnknownDeviceError") {
	                    return "Some of your messages have not been sent.";
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return "Message not sent due to unknown devices being present";
	    },
	
	    _getUnsentMessages: function _getUnsentMessages(room) {
	        if (!room) {
	            return [];
	        }
	        return room.getPendingEvents().filter(function (ev) {
	            return ev.status === Matrix.EventStatus.NOT_SENT;
	        });
	    },
	
	    _updateConfCallNotification: function _updateConfCallNotification() {
	        var room = this.state.room;
	        if (!room || !this.props.ConferenceHandler) {
	            return;
	        }
	        var confMember = room.getMember(this.props.ConferenceHandler.getConferenceUserIdForRoom(room.roomId));
	
	        if (!confMember) {
	            return;
	        }
	        var confCall = this.props.ConferenceHandler.getConferenceCallForRoom(confMember.roomId);
	
	        // A conf call notification should be displayed if there is an ongoing
	        // conf call but this cilent isn't a part of it.
	        this.setState({
	            displayConfCallNotification: (!confCall || confCall.call_state === "ended") && confMember.membership === "join"
	        });
	    },
	
	    onSearchResultsResize: function onSearchResultsResize() {
	        dis.dispatch({ action: 'timeline_resize' }, true);
	    },
	
	    onSearchResultsFillRequest: function onSearchResultsFillRequest(backwards) {
	        if (!backwards) {
	            return q(false);
	        }
	
	        if (this.state.searchResults.next_batch) {
	            debuglog("requesting more search results");
	            var searchPromise = MatrixClientPeg.get().backPaginateRoomEventsSearch(this.state.searchResults);
	            return this._handleSearchResult(searchPromise);
	        } else {
	            debuglog("no more search results");
	            return q(false);
	        }
	    },
	
	    onResendAllClick: function onResendAllClick() {
	        Resend.resendUnsentEvents(this.state.room);
	    },
	
	    onCancelAllClick: function onCancelAllClick() {
	        Resend.cancelUnsentEvents(this.state.room);
	    },
	
	    onJoinButtonClicked: function onJoinButtonClicked(ev) {
	        var _this3 = this;
	
	        var self = this;
	
	        var cli = MatrixClientPeg.get();
	        var display_name_promise = q();
	        // if this is the first room we're joining, check the user has a display name
	        // and if they don't, prompt them to set one.
	        // NB. This unfortunately does not re-use the ChangeDisplayName component because
	        // it doesn't behave quite as desired here (we want an input field here rather than
	        // content-editable, and we want a default).
	        if (cli.getRooms().filter(function (r) {
	            return r.hasMembershipState(cli.credentials.userId, "join");
	        })) {
	            display_name_promise = cli.getProfileInfo(cli.credentials.userId).then(function (result) {
	                if (!result.displayname) {
	                    var SetDisplayNameDialog = sdk.getComponent('views.dialogs.SetDisplayNameDialog');
	                    var dialog_defer = q.defer();
	                    Modal.createDialog(SetDisplayNameDialog, {
	                        currentDisplayName: result.displayname,
	                        onFinished: function onFinished(submitted, newDisplayName) {
	                            if (submitted) {
	                                cli.setDisplayName(newDisplayName).done(function () {
	                                    dialog_defer.resolve();
	                                });
	                            } else {
	                                dialog_defer.reject();
	                            }
	                        }
	                    });
	                    return dialog_defer.promise;
	                }
	            });
	        }
	
	        display_name_promise.then(function () {
	            // if this is an invite and has the 'direct' hint set, mark it as a DM room now.
	            if (_this3.state.room) {
	                var me = _this3.state.room.getMember(MatrixClientPeg.get().credentials.userId);
	                if (me && me.membership == 'invite') {
	                    if (me.events.member.getContent().is_direct) {
	                        // The 'direct' hint is there, so declare that this is a DM room for
	                        // whoever invited us.
	                        return Rooms.setDMRoom(_this3.state.room.roomId, me.events.member.getSender());
	                    }
	                }
	            }
	
	            return q();
	        }).then(function () {
	            var sign_url = _this3.props.thirdPartyInvite ? _this3.props.thirdPartyInvite.inviteSignUrl : undefined;
	            return MatrixClientPeg.get().joinRoom(_this3.props.roomAddress, { inviteSignUrl: sign_url });
	        }).then(function (resp) {
	            var roomId = resp.roomId;
	
	            // It is possible that there is no Room yet if state hasn't come down
	            // from /sync - joinRoom will resolve when the HTTP request to join succeeds,
	            // NOT when it comes down /sync. If there is no room, we'll keep the
	            // joining flag set until we see it.
	
	            // We'll need to initialise the timeline when joining, but due to
	            // the above, we can't do it here: we do it in onRoom instead,
	            // once we have a useable room object.
	            var room = MatrixClientPeg.get().getRoom(roomId);
	            if (!room) {
	                // wait for the room to turn up in onRoom.
	                self._joiningRoomId = roomId;
	            } else {
	                // we've got a valid room, but that might also just mean that
	                // it was peekable (so we had one before anyway).  If we are
	                // not yet a member of the room, we will need to wait for that
	                // to happen, in onRoomStateMember.
	                var me = MatrixClientPeg.get().credentials.userId;
	                self.setState({
	                    joining: !room.hasMembershipState(me, "join"),
	                    room: room
	                });
	            }
	        }).catch(function (error) {
	            self.setState({
	                joining: false,
	                joinError: error
	            });
	
	            if (!error) return;
	
	            // https://matrix.org/jira/browse/SYN-659
	            // Need specific error message if joining a room is refused because the user is a guest and guest access is not allowed
	            if (error.errcode == 'M_GUEST_ACCESS_FORBIDDEN' || error.errcode == 'M_FORBIDDEN' && MatrixClientPeg.get().isGuest()) {
	                var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	                Modal.createDialog(NeedToRegisterDialog, {
	                    title: "Failed to join the room",
	                    description: "This room is private or inaccessible to guests. You may be able to join if you register."
	                });
	            } else {
	                var msg = error.message ? error.message : (0, _stringify2.default)(error);
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Failed to join room",
	                    description: msg
	                });
	            }
	        }).done();
	
	        this.setState({
	            joining: true
	        });
	    },
	
	    onMessageListScroll: function onMessageListScroll(ev) {
	        if (this.refs.messagePanel.isAtEndOfLiveTimeline()) {
	            this.setState({
	                numUnreadMessages: 0,
	                atEndOfLiveTimeline: true
	            });
	        } else {
	            this.setState({
	                atEndOfLiveTimeline: false
	            });
	        }
	        this._updateTopUnreadMessagesBar();
	    },
	
	    onDragOver: function onDragOver(ev) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        ev.dataTransfer.dropEffect = 'none';
	
	        var items = ev.dataTransfer.items;
	        if (items.length == 1) {
	            if (items[0].kind == 'file') {
	                this.setState({ draggingFile: true });
	                ev.dataTransfer.dropEffect = 'copy';
	            }
	        }
	    },
	
	    onDrop: function onDrop(ev) {
	        ev.stopPropagation();
	        ev.preventDefault();
	        this.setState({ draggingFile: false });
	        var files = ev.dataTransfer.files;
	        if (files.length == 1) {
	            this.uploadFile(files[0]);
	        }
	    },
	
	    onDragLeaveOrEnd: function onDragLeaveOrEnd(ev) {
	        ev.stopPropagation();
	        ev.preventDefault();
	        this.setState({ draggingFile: false });
	    },
	
	    uploadFile: function uploadFile(file) {
	        var _this4 = this;
	
	        if (MatrixClientPeg.get().isGuest()) {
	            var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	            Modal.createDialog(NeedToRegisterDialog, {
	                title: "Please Register",
	                description: "Guest users can't upload files. Please register to upload."
	            });
	            return;
	        }
	
	        ContentMessages.sendContentToRoom(file, this.state.room.roomId, MatrixClientPeg.get()).done(undefined, function (error) {
	            if (error.name === "UnknownDeviceError") {
	                dis.dispatch({
	                    action: 'unknown_device_error',
	                    err: error,
	                    room: _this4.state.room
	                });
	                return;
	            }
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            console.error("Failed to upload file " + file + " " + error);
	            Modal.createDialog(ErrorDialog, {
	                title: "Failed to upload file",
	                description: "Server may be unavailable, overloaded, or the file too big"
	            });
	        });
	    },
	
	    onSearch: function onSearch(term, scope) {
	        this.setState({
	            searchTerm: term,
	            searchScope: scope,
	            searchResults: {},
	            searchHighlights: []
	        });
	
	        // if we already have a search panel, we need to tell it to forget
	        // about its scroll state.
	        if (this.refs.searchResultsPanel) {
	            this.refs.searchResultsPanel.resetScrollState();
	        }
	
	        // make sure that we don't end up showing results from
	        // an aborted search by keeping a unique id.
	        //
	        // todo: should cancel any previous search requests.
	        this.searchId = new Date().getTime();
	
	        var filter;
	        if (scope === "Room") {
	            filter = {
	                // XXX: it's unintuitive that the filter for searching doesn't have the same shape as the v2 filter API :(
	                rooms: [this.state.room.roomId]
	            };
	        }
	
	        debuglog("sending search request");
	
	        var searchPromise = MatrixClientPeg.get().searchRoomEvents({
	            filter: filter,
	            term: term
	        });
	        this._handleSearchResult(searchPromise).done();
	    },
	
	    _handleSearchResult: function _handleSearchResult(searchPromise) {
	        var self = this;
	
	        // keep a record of the current search id, so that if the search terms
	        // change before we get a response, we can ignore the results.
	        var localSearchId = this.searchId;
	
	        this.setState({
	            searchInProgress: true
	        });
	
	        return searchPromise.then(function (results) {
	            debuglog("search complete");
	            if (self.unmounted || !self.state.searching || self.searchId != localSearchId) {
	                console.error("Discarding stale search results");
	                return;
	            }
	
	            // postgres on synapse returns us precise details of the strings
	            // which actually got matched for highlighting.
	            //
	            // In either case, we want to highlight the literal search term
	            // whether it was used by the search engine or not.
	
	            var highlights = results.highlights;
	            if (highlights.indexOf(self.state.searchTerm) < 0) {
	                highlights = highlights.concat(self.state.searchTerm);
	            }
	
	            // For overlapping highlights,
	            // favour longer (more specific) terms first
	            highlights = highlights.sort(function (a, b) {
	                return b.length - a.length;
	            });
	
	            self.setState({
	                searchHighlights: highlights,
	                searchResults: results
	            });
	        }, function (error) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            console.error("Search failed: " + error);
	            Modal.createDialog(ErrorDialog, {
	                title: "Search failed",
	                description: "Server may be unavailable, overloaded, or search timed out :("
	            });
	        }).finally(function () {
	            self.setState({
	                searchInProgress: false
	            });
	        });
	    },
	
	    getSearchResultTiles: function getSearchResultTiles() {
	        var _this5 = this;
	
	        var EventTile = sdk.getComponent('rooms.EventTile');
	        var SearchResultTile = sdk.getComponent('rooms.SearchResultTile');
	        var Spinner = sdk.getComponent("elements.Spinner");
	
	        var cli = MatrixClientPeg.get();
	
	        // XXX: todo: merge overlapping results somehow?
	        // XXX: why doesn't searching on name work?
	
	        if (this.state.searchResults.results === undefined) {
	            // awaiting results
	            return [];
	        }
	
	        var ret = [];
	
	        if (this.state.searchInProgress) {
	            ret.push(React.createElement(
	                "li",
	                { key: "search-spinner" },
	                React.createElement(Spinner, null)
	            ));
	        }
	
	        if (!this.state.searchResults.next_batch) {
	            if (this.state.searchResults.results.length == 0) {
	                ret.push(React.createElement(
	                    "li",
	                    { key: "search-top-marker" },
	                    React.createElement(
	                        "h2",
	                        { className: "mx_RoomView_topMarker" },
	                        "No results"
	                    )
	                ));
	            } else {
	                ret.push(React.createElement(
	                    "li",
	                    { key: "search-top-marker" },
	                    React.createElement(
	                        "h2",
	                        { className: "mx_RoomView_topMarker" },
	                        "No more results"
	                    )
	                ));
	            }
	        }
	
	        // once dynamic content in the search results load, make the scrollPanel check
	        // the scroll offsets.
	        var onWidgetLoad = function onWidgetLoad() {
	            var scrollPanel = _this5.refs.searchResultsPanel;
	            if (scrollPanel) {
	                scrollPanel.checkScroll();
	            }
	        };
	
	        var lastRoomId;
	
	        for (var i = this.state.searchResults.results.length - 1; i >= 0; i--) {
	            var result = this.state.searchResults.results[i];
	
	            var mxEv = result.context.getEvent();
	            var roomId = mxEv.getRoomId();
	
	            if (!EventTile.haveTileForEvent(mxEv)) {
	                // XXX: can this ever happen? It will make the result count
	                // not match the displayed count.
	                continue;
	            }
	
	            if (this.state.searchScope === 'All') {
	                if (roomId != lastRoomId) {
	                    var room = cli.getRoom(roomId);
	
	                    // XXX: if we've left the room, we might not know about
	                    // it. We should tell the js sdk to go and find out about
	                    // it. But that's not an issue currently, as synapse only
	                    // returns results for rooms we're joined to.
	                    var roomName = room ? room.name : "Unknown room " + roomId;
	
	                    ret.push(React.createElement(
	                        "li",
	                        { key: mxEv.getId() + "-room" },
	                        React.createElement(
	                            "h1",
	                            null,
	                            "Room: ",
	                            roomName
	                        )
	                    ));
	                    lastRoomId = roomId;
	                }
	            }
	
	            var resultLink = "#/room/" + roomId + "/" + mxEv.getId();
	
	            ret.push(React.createElement(SearchResultTile, { key: mxEv.getId(),
	                searchResult: result,
	                searchHighlights: this.state.searchHighlights,
	                resultLink: resultLink,
	                onWidgetLoad: onWidgetLoad }));
	        }
	        return ret;
	    },
	
	    onSettingsClick: function onSettingsClick() {
	        this.showSettings(true);
	    },
	
	    onSettingsSaveClick: function onSettingsSaveClick() {
	        var _this6 = this;
	
	        if (!this.refs.room_settings) return;
	
	        this.setState({
	            uploadingRoomSettings: true
	        });
	
	        var newName = this.refs.header.getEditedName();
	        if (newName !== undefined) {
	            this.refs.room_settings.setName(newName);
	        }
	        var newTopic = this.refs.header.getEditedTopic();
	        if (newTopic !== undefined) {
	            this.refs.room_settings.setTopic(newTopic);
	        }
	
	        this.refs.room_settings.save().then(function (results) {
	            var fails = results.filter(function (result) {
	                return result.state !== "fulfilled";
	            });
	            console.log("Settings saved with %s errors", fails.length);
	            if (fails.length) {
	                fails.forEach(function (result) {
	                    console.error(result.reason);
	                });
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Failed to save settings",
	                    description: fails.map(function (result) {
	                        return result.reason;
	                    }).join("\n")
	                });
	                // still editing room settings
	            } else {
	                _this6.setState({
	                    editingRoomSettings: false
	                });
	            }
	        }).finally(function () {
	            _this6.setState({
	                uploadingRoomSettings: false,
	                editingRoomSettings: false
	            });
	        }).done();
	    },
	
	    onCancelClick: function onCancelClick() {
	        console.log("updateTint from onCancelClick");
	        this.updateTint();
	        this.setState({ editingRoomSettings: false });
	    },
	
	    onLeaveClick: function onLeaveClick() {
	        dis.dispatch({
	            action: 'leave_room',
	            room_id: this.state.room.roomId
	        });
	    },
	
	    onForgetClick: function onForgetClick() {
	        MatrixClientPeg.get().forget(this.state.room.roomId).done(function () {
	            dis.dispatch({ action: 'view_next_room' });
	        }, function (err) {
	            var errCode = err.errcode || "unknown error code";
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "Failed to forget room (" + errCode + ")"
	            });
	        });
	    },
	
	    onRejectButtonClicked: function onRejectButtonClicked(ev) {
	        var self = this;
	        this.setState({
	            rejecting: true
	        });
	        MatrixClientPeg.get().leave(this.state.roomId).done(function () {
	            dis.dispatch({ action: 'view_next_room' });
	            self.setState({
	                rejecting: false
	            });
	        }, function (error) {
	            console.error("Failed to reject invite: %s", error);
	
	            var msg = error.message ? error.message : (0, _stringify2.default)(error);
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Failed to reject invite",
	                description: msg
	            });
	
	            self.setState({
	                rejecting: false,
	                rejectError: error
	            });
	        });
	    },
	
	    onRejectThreepidInviteButtonClicked: function onRejectThreepidInviteButtonClicked(ev) {
	        // We can reject 3pid invites in the same way that we accept them,
	        // using /leave rather than /join. In the short term though, we
	        // just ignore them.
	        // https://github.com/vector-im/vector-web/issues/1134
	        dis.dispatch({
	            action: 'view_room_directory'
	        });
	    },
	
	    onSearchClick: function onSearchClick() {
	        this.setState({ searching: true });
	    },
	
	    onCancelSearchClick: function onCancelSearchClick() {
	        this.setState({
	            searching: false,
	            searchResults: null
	        });
	    },
	
	    // jump down to the bottom of this room, where new events are arriving
	    jumpToLiveTimeline: function jumpToLiveTimeline() {
	        this.refs.messagePanel.jumpToLiveTimeline();
	    },
	
	    // jump up to wherever our read marker is
	    jumpToReadMarker: function jumpToReadMarker() {
	        this.refs.messagePanel.jumpToReadMarker();
	    },
	
	    // update the read marker to match the read-receipt
	    forgetReadMarker: function forgetReadMarker(ev) {
	        ev.stopPropagation();
	        this.refs.messagePanel.forgetReadMarker();
	    },
	
	    // decide whether or not the top 'unread messages' bar should be shown
	    _updateTopUnreadMessagesBar: function _updateTopUnreadMessagesBar() {
	        if (!this.refs.messagePanel) {
	            return;
	        }
	
	        var pos = this.refs.messagePanel.getReadMarkerPosition();
	
	        // we want to show the bar if the read-marker is off the top of the
	        // screen.
	        var showBar = pos < 0;
	
	        if (this.state.showTopUnreadMessagesBar != showBar) {
	            this.setState({ showTopUnreadMessagesBar: showBar }, this.onChildResize);
	        }
	    },
	
	    // update scrollStateMap on unmount
	    _updateScrollMap: function _updateScrollMap() {
	        if (!this.state.room) {
	            // we were instantiated on a room alias and haven't yet joined the room.
	            return;
	        }
	        if (!this.props.scrollStateMap) return;
	
	        var roomId = this.state.room.roomId;
	
	        var state = this._getScrollState();
	        this.props.scrollStateMap[roomId] = state;
	    },
	
	    // get the current scroll position of the room, so that it can be
	    // restored when we switch back to it.
	    //
	    _getScrollState: function _getScrollState() {
	        var messagePanel = this.refs.messagePanel;
	        if (!messagePanel) return null;
	
	        // if we're following the live timeline, we want to return null; that
	        // means that, if we switch back, we will jump to the read-up-to mark.
	        //
	        // That should be more intuitive than slavishly preserving the current
	        // scroll state, in the case where the room advances in the meantime
	        // (particularly in the case that the user reads some stuff on another
	        // device).
	        //
	        if (this.state.atEndOfLiveTimeline) {
	            return null;
	        }
	
	        var scrollState = messagePanel.getScrollState();
	
	        if (scrollState.stuckAtBottom) {
	            // we don't really expect to be in this state, but it will
	            // occasionally happen when no scroll state has been set on the
	            // messagePanel (ie, we didn't have an initial event (so it's
	            // probably a new room), there has been no user-initiated scroll, and
	            // no read-receipts have arrived to update the scroll position).
	            //
	            // Return null, which will cause us to scroll to last unread on
	            // reload.
	            return null;
	        }
	
	        return {
	            focussedEvent: scrollState.trackedScrollToken,
	            pixelOffset: scrollState.pixelOffset
	        };
	    },
	
	    onResize: function onResize(e) {
	        // It seems flexbox doesn't give us a way to constrain the auxPanel height to have
	        // a minimum of the height of the video element, whilst also capping it from pushing out the page
	        // so we have to do it via JS instead.  In this implementation we cap the height by putting
	        // a maxHeight on the underlying remote video tag.
	
	        // header + footer + status + give us at least 120px of scrollback at all times.
	        var auxPanelMaxHeight = window.innerHeight - (83 + // height of RoomHeader
	        36 + // height of the status area
	        72 + ( // minimum height of the message compmoser
	        this.state.editingRoomSettings ? window.innerHeight * 0.3 : 120)); // amount of desired scrollback
	
	        // XXX: this is a bit of a hack and might possibly cause the video to push out the page anyway
	        // but it's better than the video going missing entirely
	        if (auxPanelMaxHeight < 50) auxPanelMaxHeight = 50;
	
	        this.setState({ auxPanelMaxHeight: auxPanelMaxHeight });
	
	        // changing the maxHeight on the auxpanel will trigger a callback go
	        // onChildResize, so no need to worry about that here.
	    },
	
	    onFullscreenClick: function onFullscreenClick() {
	        dis.dispatch({
	            action: 'video_fullscreen',
	            fullscreen: true
	        }, true);
	    },
	
	    onMuteAudioClick: function onMuteAudioClick() {
	        var call = this._getCallForRoom();
	        if (!call) {
	            return;
	        }
	        var newState = !call.isMicrophoneMuted();
	        call.setMicrophoneMuted(newState);
	        this.forceUpdate(); // TODO: just update the voip buttons
	    },
	
	    onMuteVideoClick: function onMuteVideoClick() {
	        var call = this._getCallForRoom();
	        if (!call) {
	            return;
	        }
	        var newState = !call.isLocalVideoMuted();
	        call.setLocalVideoMuted(newState);
	        this.forceUpdate(); // TODO: just update the voip buttons
	    },
	
	    onChildResize: function onChildResize() {
	        // no longer anything to do here
	    },
	
	    onStatusBarVisible: function onStatusBarVisible() {
	        if (this.unmounted) return;
	        this.setState({
	            statusBarVisible: true
	        });
	    },
	
	    onStatusBarHidden: function onStatusBarHidden() {
	        if (this.unmounted) return;
	        this.setState({
	            statusBarVisible: false
	        });
	    },
	
	    showSettings: function showSettings(show) {
	        // XXX: this is a bit naughty; we should be doing this via props
	        if (show) {
	            this.setState({ editingRoomSettings: true });
	        }
	    },
	
	    /**
	     * called by the parent component when PageUp/Down/etc is pressed.
	     *
	     * We pass it down to the scroll panel.
	     */
	    handleScrollKey: function handleScrollKey(ev) {
	        var panel;
	        if (this.refs.searchResultsPanel) {
	            panel = this.refs.searchResultsPanel;
	        } else if (this.refs.messagePanel) {
	            panel = this.refs.messagePanel;
	        }
	
	        if (panel) {
	            panel.handleScrollKey(ev);
	        }
	    },
	
	    /**
	     * get any current call for this room
	     */
	    _getCallForRoom: function _getCallForRoom() {
	        if (!this.state.room) {
	            return null;
	        }
	        return CallHandler.getCallForRoom(this.state.room.roomId);
	    },
	
	    // this has to be a proper method rather than an unnamed function,
	    // otherwise react calls it with null on each update.
	    _gatherTimelinePanelRef: function _gatherTimelinePanelRef(r) {
	        this.refs.messagePanel = r;
	        if (r) {
	            console.log("updateTint from RoomView._gatherTimelinePanelRef");
	            this.updateTint();
	        }
	    },
	
	    _updateAutoComplete: function _updateAutoComplete() {
	        var myUserId = MatrixClientPeg.get().credentials.userId;
	        var members = this.state.room.getJoinedMembers().filter(function (member) {
	            if (member.userId !== myUserId) return true;
	        });
	        _UserProvider2.default.getInstance().setUserList(members);
	    },
	
	    render: function render() {
	        var RoomHeader = sdk.getComponent('rooms.RoomHeader');
	        var MessageComposer = sdk.getComponent('rooms.MessageComposer');
	        var RoomSettings = sdk.getComponent("rooms.RoomSettings");
	        var AuxPanel = sdk.getComponent("rooms.AuxPanel");
	        var SearchBar = sdk.getComponent("rooms.SearchBar");
	        var ScrollPanel = sdk.getComponent("structures.ScrollPanel");
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	        var RoomPreviewBar = sdk.getComponent("rooms.RoomPreviewBar");
	        var Loader = sdk.getComponent("elements.Spinner");
	        var TimelinePanel = sdk.getComponent("structures.TimelinePanel");
	
	        if (!this.state.room) {
	            if (this.state.roomLoading) {
	                return React.createElement(
	                    "div",
	                    { className: "mx_RoomView" },
	                    React.createElement(Loader, null)
	                );
	            } else {
	                var inviterName = undefined;
	                if (this.props.oobData) {
	                    inviterName = this.props.oobData.inviterName;
	                }
	                var invitedEmail = undefined;
	                if (this.props.thirdPartyInvite) {
	                    invitedEmail = this.props.thirdPartyInvite.invitedEmail;
	                }
	
	                // We have no room object for this room, only the ID.
	                // We've got to this room by following a link, possibly a third party invite.
	                var room_alias = this.props.roomAddress[0] == '#' ? this.props.roomAddress : null;
	                return React.createElement(
	                    "div",
	                    { className: "mx_RoomView" },
	                    React.createElement(RoomHeader, { ref: "header",
	                        room: this.state.room,
	                        oobData: this.props.oobData,
	                        collapsedRhs: this.props.collapsedRhs
	                    }),
	                    React.createElement(
	                        "div",
	                        { className: "mx_RoomView_auxPanel" },
	                        React.createElement(RoomPreviewBar, { onJoinClick: this.onJoinButtonClicked,
	                            onForgetClick: this.onForgetClick,
	                            onRejectClick: this.onRejectThreepidInviteButtonClicked,
	                            canPreview: false, error: this.state.roomLoadError,
	                            roomAlias: room_alias,
	                            spinner: this.state.joining,
	                            inviterName: inviterName,
	                            invitedEmail: invitedEmail,
	                            room: this.state.room
	                        })
	                    ),
	                    React.createElement("div", { className: "mx_RoomView_messagePanel" })
	                );
	            }
	        }
	
	        var myUserId = MatrixClientPeg.get().credentials.userId;
	        var myMember = this.state.room.getMember(myUserId);
	        if (myMember && myMember.membership == 'invite') {
	            if (this.state.joining || this.state.rejecting) {
	                return React.createElement(
	                    "div",
	                    { className: "mx_RoomView" },
	                    React.createElement(Loader, null)
	                );
	            } else {
	                var inviteEvent = myMember.events.member;
	                var inviterName = inviteEvent.sender ? inviteEvent.sender.name : inviteEvent.getSender();
	
	                // We deliberately don't try to peek into invites, even if we have permission to peek
	                // as they could be a spam vector.
	                // XXX: in future we could give the option of a 'Preview' button which lets them view anyway.
	
	                // We have a regular invite for this room.
	                return React.createElement(
	                    "div",
	                    { className: "mx_RoomView" },
	                    React.createElement(RoomHeader, {
	                        ref: "header",
	                        room: this.state.room,
	                        collapsedRhs: this.props.collapsedRhs
	                    }),
	                    React.createElement(
	                        "div",
	                        { className: "mx_RoomView_auxPanel" },
	                        React.createElement(RoomPreviewBar, { onJoinClick: this.onJoinButtonClicked,
	                            onForgetClick: this.onForgetClick,
	                            onRejectClick: this.onRejectButtonClicked,
	                            inviterName: inviterName,
	                            canPreview: false,
	                            spinner: this.state.joining,
	                            room: this.state.room
	                        })
	                    ),
	                    React.createElement("div", { className: "mx_RoomView_messagePanel" })
	                );
	            }
	        }
	
	        // We have successfully loaded this room, and are not previewing.
	        // Display the "normal" room view.
	
	        var call = this._getCallForRoom();
	        var inCall = false;
	        if (call && this.state.callState !== 'ended' && this.state.callState !== 'ringing') {
	            inCall = true;
	        }
	
	        var scrollheader_classes = classNames({
	            mx_RoomView_scrollheader: true
	        });
	
	        var statusBar;
	        var isStatusAreaExpanded = true;
	
	        if (ContentMessages.getCurrentUploads().length > 0) {
	            var UploadBar = sdk.getComponent('structures.UploadBar');
	            statusBar = React.createElement(UploadBar, { room: this.state.room });
	        } else if (!this.state.searchResults) {
	            var RoomStatusBar = sdk.getComponent('structures.RoomStatusBar');
	            isStatusAreaExpanded = this.state.statusBarVisible;
	            statusBar = React.createElement(RoomStatusBar, {
	                room: this.state.room,
	                tabComplete: this.tabComplete,
	                numUnreadMessages: this.state.numUnreadMessages,
	                unsentMessageError: this.state.unsentMessageError,
	                atEndOfLiveTimeline: this.state.atEndOfLiveTimeline,
	                hasActiveCall: inCall,
	                onResendAllClick: this.onResendAllClick,
	                onCancelAllClick: this.onCancelAllClick,
	                onScrollToBottomClick: this.jumpToLiveTimeline,
	                onResize: this.onChildResize,
	                onVisible: this.onStatusBarVisible,
	                onHidden: this.onStatusBarHidden,
	                whoIsTypingLimit: 3
	            });
	        }
	
	        var aux = null;
	        if (this.state.editingRoomSettings) {
	            aux = React.createElement(RoomSettings, { ref: "room_settings", onSaveClick: this.onSettingsSaveClick, onCancelClick: this.onCancelClick, room: this.state.room });
	        } else if (this.state.uploadingRoomSettings) {
	            aux = React.createElement(Loader, null);
	        } else if (this.state.searching) {
	            aux = React.createElement(SearchBar, { ref: "search_bar", searchInProgress: this.state.searchInProgress, onCancelClick: this.onCancelSearchClick, onSearch: this.onSearch });
	        } else if (!myMember || myMember.membership !== "join") {
	            // We do have a room object for this room, but we're not currently in it.
	            // We may have a 3rd party invite to it.
	            var inviterName = undefined;
	            if (this.props.oobData) {
	                inviterName = this.props.oobData.inviterName;
	            }
	            var invitedEmail = undefined;
	            if (this.props.thirdPartyInvite) {
	                invitedEmail = this.props.thirdPartyInvite.invitedEmail;
	            }
	            aux = React.createElement(RoomPreviewBar, { onJoinClick: this.onJoinButtonClicked,
	                onForgetClick: this.onForgetClick,
	                onRejectClick: this.onRejectThreepidInviteButtonClicked,
	                spinner: this.state.joining,
	                inviterName: inviterName,
	                invitedEmail: invitedEmail,
	                canPreview: this.state.canPeek,
	                room: this.state.room
	            });
	        }
	
	        var auxPanel = React.createElement(
	            AuxPanel,
	            { ref: "auxPanel", room: this.state.room,
	                conferenceHandler: this.props.ConferenceHandler,
	                draggingFile: this.state.draggingFile,
	                displayConfCallNotification: this.state.displayConfCallNotification,
	                maxHeight: this.state.auxPanelMaxHeight,
	                onResize: this.onChildResize },
	            aux
	        );
	
	        var messageComposer, searchInfo;
	        var canSpeak =
	        // joined and not showing search results
	        myMember && myMember.membership == 'join' && !this.state.searchResults;
	        if (canSpeak) {
	            messageComposer = React.createElement(MessageComposer, {
	                room: this.state.room, onResize: this.onChildResize, uploadFile: this.uploadFile,
	                callState: this.state.callState, tabComplete: this.tabComplete, opacity: this.props.opacity });
	        }
	
	        // TODO: Why aren't we storing the term/scope/count in this format
	        // in this.state if this is what RoomHeader desires?
	        if (this.state.searchResults) {
	            searchInfo = {
	                searchTerm: this.state.searchTerm,
	                searchScope: this.state.searchScope,
	                searchCount: this.state.searchResults.count
	            };
	        }
	
	        if (inCall) {
	            var zoomButton, voiceMuteButton, videoMuteButton;
	
	            if (call.type === "video") {
	                zoomButton = React.createElement(
	                    "div",
	                    { className: "mx_RoomView_voipButton", onClick: this.onFullscreenClick, title: "Fill screen" },
	                    React.createElement(TintableSvg, { src: "img/fullscreen.svg", width: "29", height: "22", style: { marginTop: 1, marginRight: 4 } })
	                );
	
	                videoMuteButton = React.createElement(
	                    "div",
	                    { className: "mx_RoomView_voipButton", onClick: this.onMuteVideoClick },
	                    React.createElement(TintableSvg, { src: call.isLocalVideoMuted() ? "img/video-unmute.svg" : "img/video-mute.svg",
	                        alt: call.isLocalVideoMuted() ? "Click to unmute video" : "Click to mute video",
	                        width: "31", height: "27" })
	                );
	            }
	            voiceMuteButton = React.createElement(
	                "div",
	                { className: "mx_RoomView_voipButton", onClick: this.onMuteAudioClick },
	                React.createElement(TintableSvg, { src: call.isMicrophoneMuted() ? "img/voice-unmute.svg" : "img/voice-mute.svg",
	                    alt: call.isMicrophoneMuted() ? "Click to unmute audio" : "Click to mute audio",
	                    width: "21", height: "26" })
	            );
	
	            // wrap the existing status bar into a 'callStatusBar' which adds more knobs.
	            statusBar = React.createElement(
	                "div",
	                { className: "mx_RoomView_callStatusBar" },
	                voiceMuteButton,
	                videoMuteButton,
	                zoomButton,
	                statusBar,
	                React.createElement(TintableSvg, { className: "mx_RoomView_voipChevron", src: "img/voip-chevron.svg", width: "22", height: "17" })
	            );
	        }
	
	        // if we have search results, we keep the messagepanel (so that it preserves its
	        // scroll state), but hide it.
	        var searchResultsPanel;
	        var hideMessagePanel = false;
	
	        if (this.state.searchResults) {
	            searchResultsPanel = React.createElement(
	                ScrollPanel,
	                { ref: "searchResultsPanel",
	                    className: "mx_RoomView_messagePanel mx_RoomView_searchResultsPanel",
	                    onFillRequest: this.onSearchResultsFillRequest,
	                    onResize: this.onSearchResultsResize,
	                    style: { opacity: this.props.opacity }
	                },
	                React.createElement("li", { className: scrollheader_classes }),
	                this.getSearchResultTiles()
	            );
	            hideMessagePanel = true;
	        }
	
	        // console.log("ShowUrlPreview for %s is %s", this.state.room.roomId, this.state.showUrlPreview);
	
	        var messagePanel = React.createElement(TimelinePanel, { ref: this._gatherTimelinePanelRef,
	            timelineSet: this.state.room.getUnfilteredTimelineSet(),
	            manageReadReceipts: true,
	            manageReadMarkers: true,
	            hidden: hideMessagePanel,
	            highlightedEventId: this.props.highlightedEventId,
	            eventId: this.props.eventId,
	            eventPixelOffset: this.props.eventPixelOffset,
	            onScroll: this.onMessageListScroll,
	            onReadMarkerUpdated: this._updateTopUnreadMessagesBar,
	            showUrlPreview: this.state.showUrlPreview,
	            opacity: this.props.opacity,
	            className: "mx_RoomView_messagePanel"
	        });
	
	        var topUnreadMessagesBar = null;
	        if (this.state.showTopUnreadMessagesBar) {
	            var TopUnreadMessagesBar = sdk.getComponent('rooms.TopUnreadMessagesBar');
	            topUnreadMessagesBar = React.createElement(
	                "div",
	                { className: "mx_RoomView_topUnreadMessagesBar mx_fadable", style: { opacity: this.props.opacity } },
	                React.createElement(TopUnreadMessagesBar, {
	                    onScrollUpClick: this.jumpToReadMarker,
	                    onCloseClick: this.forgetReadMarker
	                })
	            );
	        }
	        var statusBarAreaClass = "mx_RoomView_statusArea mx_fadable";
	        if (isStatusAreaExpanded) {
	            statusBarAreaClass += " mx_RoomView_statusArea_expanded";
	        }
	
	        return React.createElement(
	            "div",
	            { className: "mx_RoomView" + (inCall ? " mx_RoomView_inCall" : ""), ref: "roomView" },
	            React.createElement(RoomHeader, { ref: "header", room: this.state.room, searchInfo: searchInfo,
	                oobData: this.props.oobData,
	                editing: this.state.editingRoomSettings,
	                saving: this.state.uploadingRoomSettings,
	                collapsedRhs: this.props.collapsedRhs,
	                onSearchClick: this.onSearchClick,
	                onSettingsClick: this.onSettingsClick,
	                onSaveClick: this.onSettingsSaveClick,
	                onCancelClick: this.onCancelClick,
	                onForgetClick: myMember && myMember.membership === "leave" ? this.onForgetClick : null,
	                onLeaveClick: myMember && myMember.membership === "join" ? this.onLeaveClick : null }),
	            auxPanel,
	            topUnreadMessagesBar,
	            messagePanel,
	            searchResultsPanel,
	            React.createElement(
	                "div",
	                { className: statusBarAreaClass, style: { opacity: this.props.opacity } },
	                React.createElement(
	                    "div",
	                    { className: "mx_RoomView_statusAreaBox" },
	                    React.createElement("div", { className: "mx_RoomView_statusAreaBox_line" }),
	                    statusBar
	                )
	            ),
	            messageComposer
	        );
	    }
	});


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var GeminiScrollbar = __webpack_require__(121);
	var q = __webpack_require__(6);
	var KeyCode = __webpack_require__(116);
	
	var DEBUG_SCROLL = false;
	// var DEBUG_SCROLL = true;
	
	// The amount of extra scroll distance to allow prior to unfilling.
	// See _getExcessHeight.
	var UNPAGINATION_PADDING = 6000;
	// The number of milliseconds to debounce calls to onUnfillRequest, to prevent
	// many scroll events causing many unfilling requests.
	var UNFILL_REQUEST_DEBOUNCE_MS = 200;
	
	if (DEBUG_SCROLL) {
	    // using bind means that we get to keep useful line numbers in the console
	    var debuglog = console.log.bind(console);
	} else {
	    var debuglog = function debuglog() {};
	}
	
	/* This component implements an intelligent scrolling list.
	 *
	 * It wraps a list of <li> children; when items are added to the start or end
	 * of the list, the scroll position is updated so that the user still sees the
	 * same position in the list.
	 *
	 * It also provides a hook which allows parents to provide more list elements
	 * when we get close to the start or end of the list.
	 *
	 * Each child element should have a 'data-scroll-token'. This token is used to
	 * serialise the scroll state, and returned as the 'trackedScrollToken'
	 * attribute by getScrollState().
	 *
	 * Some notes about the implementation:
	 *
	 * The saved 'scrollState' can exist in one of two states:
	 *
	 *   - stuckAtBottom: (the default, and restored by resetScrollState): the
	 *     viewport is scrolled down as far as it can be. When the children are
	 *     updated, the scroll position will be updated to ensure it is still at
	 *     the bottom.
	 *
	 *   - fixed, in which the viewport is conceptually tied at a specific scroll
	 *     offset.  We don't save the absolute scroll offset, because that would be
	 *     affected by window width, zoom level, amount of scrollback, etc. Instead
	 *     we save an identifier for the last fully-visible message, and the number
	 *     of pixels the window was scrolled below it - which is hopefully near
	 *     enough.
	 *
	 * The 'stickyBottom' property controls the behaviour when we reach the bottom
	 * of the window (either through a user-initiated scroll, or by calling
	 * scrollToBottom). If stickyBottom is enabled, the scrollState will enter
	 * 'stuckAtBottom' state - ensuring that new additions cause the window to
	 * scroll down further. If stickyBottom is disabled, we just save the scroll
	 * offset as normal.
	 */
	module.exports = React.createClass({
	    displayName: 'ScrollPanel',
	
	    propTypes: {
	        /* stickyBottom: if set to true, then once the user hits the bottom of
	         * the list, any new children added to the list will cause the list to
	         * scroll down to show the new element, rather than preserving the
	         * existing view.
	         */
	        stickyBottom: React.PropTypes.bool,
	
	        /* startAtBottom: if set to true, the view is assumed to start
	         * scrolled to the bottom.
	         * XXX: It's likley this is unecessary and can be derived from
	         * stickyBottom, but I'm adding an extra parameter to ensure
	         * behaviour stays the same for other uses of ScrollPanel.
	         * If so, let's remove this parameter down the line.
	         */
	        startAtBottom: React.PropTypes.bool,
	
	        /* onFillRequest(backwards): a callback which is called on scroll when
	         * the user nears the start (backwards = true) or end (backwards =
	         * false) of the list.
	         *
	         * This should return a promise; no more calls will be made until the
	         * promise completes.
	         *
	         * The promise should resolve to true if there is more data to be
	         * retrieved in this direction (in which case onFillRequest may be
	         * called again immediately), or false if there is no more data in this
	         * directon (at this time) - which will stop the pagination cycle until
	         * the user scrolls again.
	         */
	        onFillRequest: React.PropTypes.func,
	
	        /* onUnfillRequest(backwards): a callback which is called on scroll when
	         * there are children elements that are far out of view and could be removed
	         * without causing pagination to occur.
	         *
	         * This function should accept a boolean, which is true to indicate the back/top
	         * of the panel and false otherwise, and a scroll token, which refers to the
	         * first element to remove if removing from the front/bottom, and last element
	         * to remove if removing from the back/top.
	         */
	        onUnfillRequest: React.PropTypes.func,
	
	        /* onScroll: a callback which is called whenever any scroll happens.
	         */
	        onScroll: React.PropTypes.func,
	
	        /* onResize: a callback which is called whenever the Gemini scroll
	         * panel is resized
	         */
	        onResize: React.PropTypes.func,
	
	        /* className: classnames to add to the top-level div
	         */
	        className: React.PropTypes.string,
	
	        /* style: styles to add to the top-level div
	         */
	        style: React.PropTypes.object
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            stickyBottom: true,
	            startAtBottom: true,
	            onFillRequest: function onFillRequest(backwards) {
	                return q(false);
	            },
	            onUnfillRequest: function onUnfillRequest(backwards, scrollToken) {},
	            onScroll: function onScroll() {}
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this._pendingFillRequests = { b: null, f: null };
	        this.resetScrollState();
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.checkFillState();
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        // after adding event tiles, we may need to tweak the scroll (either to
	        // keep at the bottom of the timeline, or to maintain the view after
	        // adding events to the top).
	        //
	        // This will also re-check the fill state, in case the paginate was inadequate
	        this.checkScroll();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // set a boolean to say we've been unmounted, which any pending
	        // promises can use to throw away their results.
	        //
	        // (We could use isMounted(), but facebook have deprecated that.)
	        this.unmounted = true;
	    },
	
	    onScroll: function onScroll(ev) {
	        var sn = this._getScrollNode();
	        debuglog("Scroll event: offset now:", sn.scrollTop, "_lastSetScroll:", this._lastSetScroll);
	
	        // Sometimes we see attempts to write to scrollTop essentially being
	        // ignored. (Or rather, it is successfully written, but on the next
	        // scroll event, it's been reset again).
	        //
	        // This was observed on Chrome 47, when scrolling using the trackpad in OS
	        // X Yosemite.  Can't reproduce on El Capitan. Our theory is that this is
	        // due to Chrome not being able to cope with the scroll offset being reset
	        // while a two-finger drag is in progress.
	        //
	        // By way of a workaround, we detect this situation and just keep
	        // resetting scrollTop until we see the scroll node have the right
	        // value.
	        if (this._lastSetScroll !== undefined && sn.scrollTop < this._lastSetScroll - 200) {
	            console.log("Working around vector-im/vector-web#528");
	            this._restoreSavedScrollState();
	            return;
	        }
	
	        // If there weren't enough children to fill the viewport, the scroll we
	        // got might be different to the scroll we wanted; we don't want to
	        // forget what we wanted, so don't overwrite the saved state unless
	        // this appears to be a user-initiated scroll.
	        if (sn.scrollTop != this._lastSetScroll) {
	            this._saveScrollState();
	        } else {
	            debuglog("Ignoring scroll echo");
	
	            // only ignore the echo once, otherwise we'll get confused when the
	            // user scrolls away from, and back to, the autoscroll point.
	            this._lastSetScroll = undefined;
	        }
	
	        this.props.onScroll(ev);
	
	        this.checkFillState();
	    },
	
	    onResize: function onResize() {
	        this.props.onResize();
	        this.checkScroll();
	        this.refs.geminiPanel.forceUpdate();
	    },
	
	    // after an update to the contents of the panel, check that the scroll is
	    // where it ought to be, and set off pagination requests if necessary.
	    checkScroll: function checkScroll() {
	        this._restoreSavedScrollState();
	        this.checkFillState();
	    },
	
	    // return true if the content is fully scrolled down right now; else false.
	    //
	    // note that this is independent of the 'stuckAtBottom' state - it is simply
	    // about whether the the content is scrolled down right now, irrespective of
	    // whether it will stay that way when the children update.
	    isAtBottom: function isAtBottom() {
	        var sn = this._getScrollNode();
	
	        // there seems to be some bug with flexbox/gemini/chrome/richvdh's
	        // understanding of the box model, wherein the scrollNode ends up 2
	        // pixels higher than the available space, even when there are less
	        // than a screenful of messages. + 3 is a fudge factor to pretend
	        // that we're at the bottom when we're still a few pixels off.
	
	        return sn.scrollHeight - Math.ceil(sn.scrollTop) <= sn.clientHeight + 3;
	    },
	
	    // returns the vertical height in the given direction that can be removed from
	    // the content box (which has a height of scrollHeight, see checkFillState) without
	    // pagination occuring.
	    //
	    // padding* = UNPAGINATION_PADDING
	    //
	    // ### Region determined as excess.
	    //
	    //   .---------.                        -              -
	    //   |#########|                        |              |
	    //   |#########|   -                    |  scrollTop   |
	    //   |         |   | padding*           |              |
	    //   |         |   |                    |              |
	    // .-+---------+-. -  -                 |              |
	    // : |         | :    |                 |              |
	    // : |         | :    |  clientHeight   |              |
	    // : |         | :    |                 |              |
	    // .-+---------+-.    -                 -              |
	    // | |         | |    |                                |
	    // | |         | |    |  clientHeight                  | scrollHeight
	    // | |         | |    |                                |
	    // `-+---------+-'    -                                |
	    // : |         | :    |                                |
	    // : |         | :    |  clientHeight                  |
	    // : |         | :    |                                |
	    // `-+---------+-' -  -                                |
	    //   |         |   | padding*                          |
	    //   |         |   |                                   |
	    //   |#########|   -                                   |
	    //   |#########|                                       |
	    //   `---------'                                       -
	    _getExcessHeight: function _getExcessHeight(backwards) {
	        var sn = this._getScrollNode();
	        if (backwards) {
	            return sn.scrollTop - sn.clientHeight - UNPAGINATION_PADDING;
	        } else {
	            return sn.scrollHeight - (sn.scrollTop + 2 * sn.clientHeight) - UNPAGINATION_PADDING;
	        }
	    },
	
	    // check the scroll state and send out backfill requests if necessary.
	    checkFillState: function checkFillState() {
	        if (this.unmounted) {
	            return;
	        }
	
	        var sn = this._getScrollNode();
	
	        // if there is less than a screenful of messages above or below the
	        // viewport, try to get some more messages.
	        //
	        // scrollTop is the number of pixels between the top of the content and
	        //     the top of the viewport.
	        //
	        // scrollHeight is the total height of the content.
	        //
	        // clientHeight is the height of the viewport (excluding borders,
	        // margins, and scrollbars).
	        //
	        //
	        //   .---------.          -                 -
	        //   |         |          |  scrollTop      |
	        // .-+---------+-.    -   -                 |
	        // | |         | |    |                     |
	        // | |         | |    |  clientHeight       | scrollHeight
	        // | |         | |    |                     |
	        // `-+---------+-'    -                     |
	        //   |         |                            |
	        //   |         |                            |
	        //   `---------'                            -
	        //
	
	        if (sn.scrollTop < sn.clientHeight) {
	            // need to back-fill
	            this._maybeFill(true);
	        }
	        if (sn.scrollTop > sn.scrollHeight - sn.clientHeight * 2) {
	            // need to forward-fill
	            this._maybeFill(false);
	        }
	    },
	
	    // check if unfilling is possible and send an unfill request if necessary
	    _checkUnfillState: function _checkUnfillState(backwards) {
	        var _this = this;
	
	        var excessHeight = this._getExcessHeight(backwards);
	        if (excessHeight <= 0) {
	            return;
	        }
	        var tiles = this.refs.itemlist.children;
	
	        // The scroll token of the first/last tile to be unpaginated
	        var markerScrollToken = null;
	
	        // Subtract heights of tiles to simulate the tiles being unpaginated until the
	        // excess height is less than the height of the next tile to subtract. This
	        // prevents excessHeight becoming negative, which could lead to future
	        // pagination.
	        //
	        // If backwards is true, we unpaginate (remove) tiles from the back (top).
	        for (var i = 0; i < tiles.length; i++) {
	            var tile = tiles[backwards ? i : tiles.length - 1 - i];
	            // Subtract height of tile as if it were unpaginated
	            excessHeight -= tile.clientHeight;
	            // The tile may not have a scroll token, so guard it
	            if (tile.dataset.scrollToken) {
	                markerScrollToken = tile.dataset.scrollToken;
	            }
	            if (tile.clientHeight > excessHeight) {
	                break;
	            }
	        }
	
	        if (markerScrollToken) {
	            // Use a debouncer to prevent multiple unfill calls in quick succession
	            // This is to make the unfilling process less aggressive
	            if (this._unfillDebouncer) {
	                clearTimeout(this._unfillDebouncer);
	            }
	            this._unfillDebouncer = setTimeout(function () {
	                _this._unfillDebouncer = null;
	                _this.props.onUnfillRequest(backwards, markerScrollToken);
	            }, UNFILL_REQUEST_DEBOUNCE_MS);
	        }
	    },
	
	    // check if there is already a pending fill request. If not, set one off.
	    _maybeFill: function _maybeFill(backwards) {
	        var _this2 = this;
	
	        var dir = backwards ? 'b' : 'f';
	        if (this._pendingFillRequests[dir]) {
	            debuglog("ScrollPanel: Already a " + dir + " fill in progress - not starting another");
	            return;
	        }
	
	        debuglog("ScrollPanel: starting " + dir + " fill");
	
	        // onFillRequest can end up calling us recursively (via onScroll
	        // events) so make sure we set this before firing off the call. That
	        // does present the risk that we might not ever actually fire off the
	        // fill request, so wrap it in a try/catch.
	        this._pendingFillRequests[dir] = true;
	        var fillPromise;
	        try {
	            fillPromise = this.props.onFillRequest(backwards);
	        } catch (e) {
	            this._pendingFillRequests[dir] = false;
	            throw e;
	        }
	
	        q.finally(fillPromise, function () {
	            _this2._pendingFillRequests[dir] = false;
	        }).then(function (hasMoreResults) {
	            if (_this2.unmounted) {
	                return;
	            }
	            // Unpaginate once filling is complete
	            _this2._checkUnfillState(!backwards);
	
	            debuglog("ScrollPanel: " + dir + " fill complete; hasMoreResults:" + hasMoreResults);
	            if (hasMoreResults) {
	                // further pagination requests have been disabled until now, so
	                // it's time to check the fill state again in case the pagination
	                // was insufficient.
	                _this2.checkFillState();
	            }
	        }).done();
	    },
	
	    /* get the current scroll state. This returns an object with the following
	     * properties:
	     *
	     * boolean stuckAtBottom: true if we are tracking the bottom of the
	     *   scroll. false if we are tracking a particular child.
	     *
	     * string trackedScrollToken: undefined if stuckAtBottom is true; if it is
	     *   false, the data-scroll-token of the child which we are tracking.
	     *
	     * number pixelOffset: undefined if stuckAtBottom is true; if it is false,
	     *   the number of pixels the bottom of the tracked child is above the
	     *   bottom of the scroll panel.
	     */
	    getScrollState: function getScrollState() {
	        return this.scrollState;
	    },
	
	    /* reset the saved scroll state.
	     *
	     * This is useful if the list is being replaced, and you don't want to
	     * preserve scroll even if new children happen to have the same scroll
	     * tokens as old ones.
	     *
	     * This will cause the viewport to be scrolled down to the bottom on the
	     * next update of the child list. This is different to scrollToBottom(),
	     * which would save the current bottom-most child as the active one (so is
	     * no use if no children exist yet, or if you are about to replace the
	     * child list.)
	     */
	    resetScrollState: function resetScrollState() {
	        this.scrollState = { stuckAtBottom: this.props.startAtBottom };
	    },
	
	    /**
	     * jump to the top of the content.
	     */
	    scrollToTop: function scrollToTop() {
	        this._setScrollTop(0);
	        this._saveScrollState();
	    },
	
	    /**
	     * jump to the bottom of the content.
	     */
	    scrollToBottom: function scrollToBottom() {
	        // the easiest way to make sure that the scroll state is correctly
	        // saved is to do the scroll, then save the updated state. (Calculating
	        // it ourselves is hard, and we can't rely on an onScroll callback
	        // happening, since there may be no user-visible change here).
	        this._setScrollTop(Number.MAX_VALUE);
	        this._saveScrollState();
	    },
	
	    /**
	     * Page up/down.
	     *
	     * mult: -1 to page up, +1 to page down
	     */
	    scrollRelative: function scrollRelative(mult) {
	        var scrollNode = this._getScrollNode();
	        var delta = mult * scrollNode.clientHeight * 0.5;
	        this._setScrollTop(scrollNode.scrollTop + delta);
	        this._saveScrollState();
	    },
	
	    /**
	     * Scroll up/down in response to a scroll key
	     */
	    handleScrollKey: function handleScrollKey(ev) {
	        switch (ev.keyCode) {
	            case KeyCode.PAGE_UP:
	                this.scrollRelative(-1);
	                break;
	
	            case KeyCode.PAGE_DOWN:
	                this.scrollRelative(1);
	                break;
	
	            case KeyCode.HOME:
	                if (ev.ctrlKey) {
	                    this.scrollToTop();
	                }
	                break;
	
	            case KeyCode.END:
	                if (ev.ctrlKey) {
	                    this.scrollToBottom();
	                }
	                break;
	        }
	    },
	
	    /* Scroll the panel to bring the DOM node with the scroll token
	     * `scrollToken` into view.
	     *
	     * offsetBase gives the reference point for the pixelOffset. 0 means the
	     * top of the container, 1 means the bottom, and fractional values mean
	     * somewhere in the middle. If omitted, it defaults to 0.
	     *
	     * pixelOffset gives the number of pixels *above* the offsetBase that the
	     * node (specifically, the bottom of it) will be positioned. If omitted, it
	     * defaults to 0.
	     */
	    scrollToToken: function scrollToToken(scrollToken, pixelOffset, offsetBase) {
	        pixelOffset = pixelOffset || 0;
	        offsetBase = offsetBase || 0;
	
	        // convert pixelOffset so that it is based on the bottom of the
	        // container.
	        pixelOffset += this._getScrollNode().clientHeight * (1 - offsetBase);
	
	        // save the desired scroll state. It's important we do this here rather
	        // than as a result of the scroll event, because (a) we might not *get*
	        // a scroll event, and (b) it might not currently be possible to set
	        // the requested scroll state (eg, because we hit the end of the
	        // timeline and need to do more pagination); we want to save the
	        // *desired* scroll state rather than what we end up achieving.
	        this.scrollState = {
	            stuckAtBottom: false,
	            trackedScrollToken: scrollToken,
	            pixelOffset: pixelOffset
	        };
	
	        // ... then make it so.
	        this._restoreSavedScrollState();
	    },
	
	    // set the scrollTop attribute appropriately to position the given child at the
	    // given offset in the window. A helper for _restoreSavedScrollState.
	    _scrollToToken: function _scrollToToken(scrollToken, pixelOffset) {
	        /* find the dom node with the right scrolltoken */
	        var node;
	        var messages = this.refs.itemlist.children;
	        for (var i = messages.length - 1; i >= 0; --i) {
	            var m = messages[i];
	            if (!m.dataset.scrollToken) continue;
	            if (m.dataset.scrollToken == scrollToken) {
	                node = m;
	                break;
	            }
	        }
	
	        if (!node) {
	            debuglog("ScrollPanel: No node with scrollToken '" + scrollToken + "'");
	            return;
	        }
	
	        var scrollNode = this._getScrollNode();
	        var wrapperRect = ReactDOM.findDOMNode(this).getBoundingClientRect();
	        var boundingRect = node.getBoundingClientRect();
	        var scrollDelta = boundingRect.bottom + pixelOffset - wrapperRect.bottom;
	
	        debuglog("ScrollPanel: scrolling to token '" + node.dataset.scrollToken + "'+" + pixelOffset + " (delta: " + scrollDelta + ")");
	
	        if (scrollDelta != 0) {
	            this._setScrollTop(scrollNode.scrollTop + scrollDelta);
	        }
	    },
	
	    _saveScrollState: function _saveScrollState() {
	        if (this.props.stickyBottom && this.isAtBottom()) {
	            this.scrollState = { stuckAtBottom: true };
	            debuglog("ScrollPanel: Saved scroll state", this.scrollState);
	            return;
	        }
	
	        var itemlist = this.refs.itemlist;
	        var wrapperRect = ReactDOM.findDOMNode(this).getBoundingClientRect();
	        var messages = itemlist.children;
	        var newScrollState = null;
	
	        for (var i = messages.length - 1; i >= 0; --i) {
	            var node = messages[i];
	            if (!node.dataset.scrollToken) continue;
	
	            var boundingRect = node.getBoundingClientRect();
	            newScrollState = {
	                stuckAtBottom: false,
	                trackedScrollToken: node.dataset.scrollToken,
	                pixelOffset: wrapperRect.bottom - boundingRect.bottom
	            };
	            // If the bottom of the panel intersects the ClientRect of node, use this node
	            // as the scrollToken.
	            // If this is false for the entire for-loop, we default to the last node
	            // (which is why newScrollState is set on every iteration).
	            if (boundingRect.top < wrapperRect.bottom) {
	                // Use this node as the scrollToken
	                break;
	            }
	        }
	        // This is only false if there were no nodes with `node.dataset.scrollToken` set.
	        if (newScrollState) {
	            this.scrollState = newScrollState;
	            debuglog("ScrollPanel: saved scroll state", this.scrollState);
	        } else {
	            debuglog("ScrollPanel: unable to save scroll state: found no children in the viewport");
	        }
	    },
	
	    _restoreSavedScrollState: function _restoreSavedScrollState() {
	        var scrollState = this.scrollState;
	        var scrollNode = this._getScrollNode();
	
	        if (scrollState.stuckAtBottom) {
	            this._setScrollTop(Number.MAX_VALUE);
	        } else if (scrollState.trackedScrollToken) {
	            this._scrollToToken(scrollState.trackedScrollToken, scrollState.pixelOffset);
	        }
	    },
	
	    _setScrollTop: function _setScrollTop(scrollTop) {
	        var scrollNode = this._getScrollNode();
	
	        var prevScroll = scrollNode.scrollTop;
	
	        // FF ignores attempts to set scrollTop to very large numbers
	        scrollNode.scrollTop = Math.min(scrollTop, scrollNode.scrollHeight);
	
	        // If this change generates a scroll event, we should not update the
	        // saved scroll state on it. See the comments in onScroll.
	        //
	        // If we *don't* expect a scroll event, we need to leave _lastSetScroll
	        // alone, otherwise we'll end up ignoring a future scroll event which is
	        // nothing to do with this change.
	
	        if (scrollNode.scrollTop != prevScroll) {
	            this._lastSetScroll = scrollNode.scrollTop;
	        }
	
	        debuglog("ScrollPanel: set scrollTop:", scrollNode.scrollTop, "requested:", scrollTop, "_lastSetScroll:", this._lastSetScroll);
	    },
	
	    /* get the DOM node which has the scrollTop property we care about for our
	     * message panel.
	     */
	    _getScrollNode: function _getScrollNode() {
	        if (this.unmounted) {
	            // this shouldn't happen, but when it does, turn the NPE into
	            // something more meaningful.
	            throw new Error("ScrollPanel._getScrollNode called when unmounted");
	        }
	
	        return this.refs.geminiPanel.scrollbar.getViewElement();
	    },
	
	    render: function render() {
	        // TODO: the classnames on the div and ol could do with being updated to
	        // reflect the fact that we don't necessarily contain a list of messages.
	        // it's not obvious why we have a separate div and ol anyway.
	        return React.createElement(
	            GeminiScrollbar,
	            { autoshow: true, ref: "geminiPanel",
	                onScroll: this.onScroll, onResize: this.onResize,
	                className: this.props.className, style: this.props.style },
	            React.createElement(
	                "div",
	                { className: "mx_RoomView_messageListWrapper" },
	                React.createElement(
	                    "ol",
	                    { ref: "itemlist", className: "mx_RoomView_MessageList", "aria-live": "polite" },
	                    this.props.children
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(180);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(179);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var q = __webpack_require__(6);
	
	var Matrix = __webpack_require__(28);
	var EventTimeline = Matrix.EventTimeline;
	
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	var ObjectUtils = __webpack_require__(139);
	var Modal = __webpack_require__(10);
	var UserActivity = __webpack_require__(332);
	var KeyCode = __webpack_require__(116);
	
	var PAGINATE_SIZE = 20;
	var INITIAL_SIZE = 20;
	
	var DEBUG = false;
	
	if (DEBUG) {
	    // using bind means that we get to keep useful line numbers in the console
	    var debuglog = console.log.bind(console);
	} else {
	    var debuglog = function debuglog() {};
	}
	
	/*
	 * Component which shows the event timeline in a room view.
	 *
	 * Also responsible for handling and sending read receipts.
	 */
	var TimelinePanel = React.createClass({
	    displayName: 'TimelinePanel',
	
	    propTypes: {
	        // The js-sdk EventTimelineSet object for the timeline sequence we are
	        // representing.  This may or may not have a room, depending on what it's
	        // a timeline representing.  If it has a room, we maintain RRs etc for
	        // that room.
	        timelineSet: React.PropTypes.object.isRequired,
	
	        // Enable managing RRs and RMs. These require the timelineSet to have a room.
	        manageReadReceipts: React.PropTypes.bool,
	        manageReadMarkers: React.PropTypes.bool,
	
	        // true to give the component a 'display: none' style.
	        hidden: React.PropTypes.bool,
	
	        // ID of an event to highlight. If undefined, no event will be highlighted.
	        // typically this will be either 'eventId' or undefined.
	        highlightedEventId: React.PropTypes.string,
	
	        // id of an event to jump to. If not given, will go to the end of the
	        // live timeline.
	        eventId: React.PropTypes.string,
	
	        // where to position the event given by eventId, in pixels from the
	        // bottom of the viewport. If not given, will try to put the event
	        // half way down the viewport.
	        eventPixelOffset: React.PropTypes.number,
	
	        // Should we show URL Previews
	        showUrlPreview: React.PropTypes.bool,
	
	        // callback which is called when the panel is scrolled.
	        onScroll: React.PropTypes.func,
	
	        // callback which is called when the read-up-to mark is updated.
	        onReadMarkerUpdated: React.PropTypes.func,
	
	        // opacity for dynamic UI fading effects
	        opacity: React.PropTypes.number,
	
	        // maximum number of events to show in a timeline
	        timelineCap: React.PropTypes.number,
	
	        // classname to use for the messagepanel
	        className: React.PropTypes.string,
	
	        // shape property to be passed to EventTiles
	        tileShape: React.PropTypes.string,
	
	        // placeholder text to use if the timeline is empty
	        empty: React.PropTypes.string
	    },
	
	    statics: {
	        // a map from room id to read marker event ID
	        roomReadMarkerMap: {},
	
	        // a map from room id to read marker event timestamp
	        roomReadMarkerTsMap: {}
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            // By default, disable the timelineCap in favour of unpaginating based on
	            // event tile heights. (See _unpaginateEvents)
	            timelineCap: Number.MAX_VALUE,
	            className: 'mx_RoomView_messagePanel'
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        // XXX: we could track RM per TimelineSet rather than per Room.
	        // but for now we just do it per room for simplicity.
	        if (this.props.manageReadMarkers) {
	            var initialReadMarker = TimelinePanel.roomReadMarkerMap[this.props.timelineSet.room.roomId] || this._getCurrentReadReceipt();
	        }
	
	        return {
	            events: [],
	            timelineLoading: true, // track whether our room timeline is loading
	
	            // canBackPaginate == false may mean:
	            //
	            // * we haven't (successfully) loaded the timeline yet, or:
	            //
	            // * we have got to the point where the room was created, or:
	            //
	            // * the server indicated that there were no more visible events
	            //  (normally implying we got to the start of the room), or:
	            //
	            // * we gave up asking the server for more events
	            canBackPaginate: false,
	
	            // canForwardPaginate == false may mean:
	            //
	            // * we haven't (successfully) loaded the timeline yet
	            //
	            // * we have got to the end of time and are now tracking the live
	            //   timeline, or:
	            //
	            // * the server indicated that there were no more visible events
	            //   (not sure if this ever happens when we're not at the live
	            //   timeline), or:
	            //
	            // * we are looking at some historical point, but gave up asking
	            //   the server for more events
	            canForwardPaginate: false,
	
	            // start with the read-marker visible, so that we see its animated
	            // disappearance when switching into the room.
	            readMarkerVisible: true,
	
	            readMarkerEventId: initialReadMarker,
	
	            backPaginating: false,
	            forwardPaginating: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        debuglog("TimelinePanel: mounting");
	
	        this.last_rr_sent_event_id = undefined;
	
	        this.dispatcherRef = dis.register(this.onAction);
	        MatrixClientPeg.get().on("Room.timeline", this.onRoomTimeline);
	        MatrixClientPeg.get().on("Room.timelineReset", this.onRoomTimelineReset);
	        MatrixClientPeg.get().on("Room.redaction", this.onRoomRedaction);
	        MatrixClientPeg.get().on("Room.receipt", this.onRoomReceipt);
	        MatrixClientPeg.get().on("Room.localEchoUpdated", this.onLocalEchoUpdated);
	
	        this._initTimeline(this.props);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        if (newProps.timelineSet !== this.props.timelineSet) {
	            // throw new Error("changing timelineSet on a TimelinePanel is not supported");
	
	            // regrettably, this does happen; in particular, when joining a
	            // room with /join. In that case, there are two Rooms in
	            // circulation - one which is created by the MatrixClient.joinRoom
	            // call and used to create the RoomView, and a second which is
	            // created by the sync loop once the room comes back down the /sync
	            // pipe. Once the latter happens, our room is replaced with the new one.
	            //
	            // for now, just warn about this. But we're going to end up paginating
	            // both rooms separately, and it's all bad.
	            console.warn("Replacing timelineSet on a TimelinePanel - confusion may ensue");
	        }
	
	        if (newProps.eventId != this.props.eventId) {
	            console.log("TimelinePanel switching to eventId " + newProps.eventId + " (was " + this.props.eventId + ")");
	            return this._initTimeline(newProps);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (!ObjectUtils.shallowEqual(this.props, nextProps)) {
	            if (DEBUG) {
	                console.group("Timeline.shouldComponentUpdate: props change");
	                console.log("props before:", this.props);
	                console.log("props after:", nextProps);
	                console.groupEnd();
	            }
	            return true;
	        }
	
	        if (!ObjectUtils.shallowEqual(this.state, nextState)) {
	            if (DEBUG) {
	                console.group("Timeline.shouldComponentUpdate: state change");
	                console.log("state before:", this.state);
	                console.log("state after:", nextState);
	                console.groupEnd();
	            }
	            return true;
	        }
	
	        return false;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // set a boolean to say we've been unmounted, which any pending
	        // promises can use to throw away their results.
	        //
	        // (We could use isMounted, but facebook have deprecated that.)
	        this.unmounted = true;
	
	        dis.unregister(this.dispatcherRef);
	
	        var client = MatrixClientPeg.get();
	        if (client) {
	            client.removeListener("Room.timeline", this.onRoomTimeline);
	            client.removeListener("Room.timelineReset", this.onRoomTimelineReset);
	            client.removeListener("Room.redaction", this.onRoomRedaction);
	            client.removeListener("Room.receipt", this.onRoomReceipt);
	            client.removeListener("Room.localEchoUpdated", this.onLocalEchoUpdated);
	        }
	    },
	
	    onMessageListUnfillRequest: function onMessageListUnfillRequest(backwards, scrollToken) {
	        // If backwards, unpaginate from the back (i.e. the start of the timeline)
	        var dir = backwards ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS;
	        debuglog("TimelinePanel: unpaginating events in direction", dir);
	
	        // All tiles are inserted by MessagePanel to have a scrollToken === eventId, and
	        // this particular event should be the first or last to be unpaginated.
	        var eventId = scrollToken;
	
	        var marker = this.state.events.findIndex(function (ev) {
	            return ev.getId() === eventId;
	        });
	
	        var count = backwards ? marker + 1 : this.state.events.length - marker;
	
	        if (count > 0) {
	            var _setState;
	
	            debuglog("TimelinePanel: Unpaginating", count, "in direction", dir);
	            this._timelineWindow.unpaginate(count, backwards);
	
	            // We can now paginate in the unpaginated direction
	            var canPaginateKey = backwards ? 'canBackPaginate' : 'canForwardPaginate';
	            this.setState((_setState = {}, (0, _defineProperty3.default)(_setState, canPaginateKey, true), (0, _defineProperty3.default)(_setState, "events", this._getEvents()), _setState));
	        }
	    },
	
	    // set off a pagination request.
	    onMessageListFillRequest: function onMessageListFillRequest(backwards) {
	        var _this = this;
	
	        var dir = backwards ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS;
	        var canPaginateKey = backwards ? 'canBackPaginate' : 'canForwardPaginate';
	        var paginatingKey = backwards ? 'backPaginating' : 'forwardPaginating';
	
	        if (!this.state[canPaginateKey]) {
	            debuglog("TimelinePanel: have given up", dir, "paginating this timeline");
	            return q(false);
	        }
	
	        if (!this._timelineWindow.canPaginate(dir)) {
	            debuglog("TimelinePanel: can't", dir, "paginate any further");
	            this.setState((0, _defineProperty3.default)({}, canPaginateKey, false));
	            return q(false);
	        }
	
	        debuglog("TimelinePanel: Initiating paginate; backwards:" + backwards);
	        this.setState((0, _defineProperty3.default)({}, paginatingKey, true));
	
	        return this._timelineWindow.paginate(dir, PAGINATE_SIZE).then(function (r) {
	            var _newState;
	
	            if (_this.unmounted) {
	                return;
	            }
	
	            debuglog("TimelinePanel: paginate complete backwards:" + backwards + "; success:" + r);
	
	            var newState = (_newState = {}, (0, _defineProperty3.default)(_newState, paginatingKey, false), (0, _defineProperty3.default)(_newState, canPaginateKey, r), (0, _defineProperty3.default)(_newState, "events", _this._getEvents()), _newState);
	
	            // moving the window in this direction may mean that we can now
	            // paginate in the other where we previously could not.
	            var otherDirection = backwards ? EventTimeline.FORWARDS : EventTimeline.BACKWARDS;
	            var canPaginateOtherWayKey = backwards ? 'canForwardPaginate' : 'canBackPaginate';
	            if (!_this.state[canPaginateOtherWayKey] && _this._timelineWindow.canPaginate(otherDirection)) {
	                debuglog('TimelinePanel: can now', otherDirection, 'paginate again');
	                newState[canPaginateOtherWayKey] = true;
	            }
	
	            _this.setState(newState);
	
	            return r;
	        });
	    },
	
	    onMessageListScroll: function onMessageListScroll() {
	        if (this.props.onScroll) {
	            this.props.onScroll();
	        }
	
	        if (this.props.manageReadMarkers) {
	            // we hide the read marker when it first comes onto the screen, but if
	            // it goes back off the top of the screen (presumably because the user
	            // clicks on the 'jump to bottom' button), we need to re-enable it.
	            if (this.getReadMarkerPosition() < 0) {
	                this.setState({ readMarkerVisible: true });
	            }
	        }
	    },
	
	    onAction: function onAction(payload) {
	        switch (payload.action) {
	            case 'user_activity':
	            case 'user_activity_end':
	                // we could treat user_activity_end differently and not
	                // send receipts for messages that have arrived between
	                // the actual user activity and the time they stopped
	                // being active, but let's see if this is actually
	                // necessary.
	                this.sendReadReceipt();
	                this.updateReadMarker();
	                break;
	        }
	    },
	
	    onRoomTimeline: function onRoomTimeline(ev, room, toStartOfTimeline, removed, data) {
	        var _this2 = this;
	
	        // ignore events for other timeline sets
	        if (data.timeline.getTimelineSet() !== this.props.timelineSet) return;
	
	        // ignore anything but real-time updates at the end of the room:
	        // updates from pagination will happen when the paginate completes.
	        if (toStartOfTimeline || !data || !data.liveEvent) return;
	
	        if (!this.refs.messagePanel) return;
	
	        if (!this.refs.messagePanel.getScrollState().stuckAtBottom) {
	            // we won't load this event now, because we don't want to push any
	            // events off the other end of the timeline. But we need to note
	            // that we can now paginate.
	            this.setState({ canForwardPaginate: true });
	            return;
	        }
	
	        // tell the timeline window to try to advance itself, but not to make
	        // an http request to do so.
	        //
	        // we deliberately avoid going via the ScrollPanel for this call - the
	        // ScrollPanel might already have an active pagination promise, which
	        // will fail, but would stop us passing the pagination request to the
	        // timeline window.
	        //
	        // see https://github.com/vector-im/vector-web/issues/1035
	        this._timelineWindow.paginate(EventTimeline.FORWARDS, 1, false).done(function () {
	            if (_this2.unmounted) {
	                return;
	            }
	
	            var events = _this2._timelineWindow.getEvents();
	            var lastEv = events[events.length - 1];
	
	            // if we're at the end of the live timeline, append the pending events
	            if (_this2.props.timelineSet.room && !_this2._timelineWindow.canPaginate(EventTimeline.FORWARDS)) {
	                events.push.apply(events, (0, _toConsumableArray3.default)(_this2.props.timelineSet.room.getPendingEvents()));
	            }
	
	            var updatedState = { events: events };
	
	            if (_this2.props.manageReadMarkers) {
	                // when a new event arrives when the user is not watching the
	                // window, but the window is in its auto-scroll mode, make sure the
	                // read marker is visible.
	                //
	                // We ignore events we have sent ourselves; we don't want to see the
	                // read-marker when a remote echo of an event we have just sent takes
	                // more than the timeout on userCurrentlyActive.
	                //
	                var myUserId = MatrixClientPeg.get().credentials.userId;
	                var sender = ev.sender ? ev.sender.userId : null;
	                var callback = null;
	                if (sender != myUserId && !UserActivity.userCurrentlyActive()) {
	                    updatedState.readMarkerVisible = true;
	                } else if (lastEv && _this2.getReadMarkerPosition() === 0) {
	                    // we know we're stuckAtBottom, so we can advance the RM
	                    // immediately, to save a later render cycle
	                    _this2._setReadMarker(lastEv.getId(), lastEv.getTs(), true);
	                    updatedState.readMarkerVisible = false;
	                    updatedState.readMarkerEventId = lastEv.getId();
	                    callback = _this2.props.onReadMarkerUpdated;
	                }
	            }
	
	            _this2.setState(updatedState, callback);
	        });
	    },
	
	    onRoomTimelineReset: function onRoomTimelineReset(room, timelineSet) {
	        if (timelineSet !== this.props.timelineSet) return;
	
	        if (this.refs.messagePanel && this.refs.messagePanel.isAtBottom()) {
	            this._loadTimeline();
	        }
	    },
	
	    canResetTimeline: function canResetTimeline() {
	        return this.refs.messagePanel && this.refs.messagePanel.isAtBottom();
	    },
	
	    onRoomRedaction: function onRoomRedaction(ev, room) {
	        if (this.unmounted) return;
	
	        // ignore events for other rooms
	        if (room !== this.props.timelineSet.room) return;
	
	        // we could skip an update if the event isn't in our timeline,
	        // but that's probably an early optimisation.
	        this.forceUpdate();
	    },
	
	    onRoomReceipt: function onRoomReceipt(ev, room) {
	        if (this.unmounted) return;
	
	        // ignore events for other rooms
	        if (room !== this.props.timelineSet.room) return;
	
	        this.forceUpdate();
	    },
	
	    onLocalEchoUpdated: function onLocalEchoUpdated(ev, room, oldEventId) {
	        if (this.unmounted) return;
	
	        // ignore events for other rooms
	        if (room !== this.props.timelineSet.room) return;
	
	        this._reloadEvents();
	    },
	
	    sendReadReceipt: function sendReadReceipt() {
	        var _this3 = this;
	
	        if (!this.refs.messagePanel) return;
	        if (!this.props.manageReadReceipts) return;
	        // This happens on user_activity_end which is delayed, and it's
	        // very possible have logged out within that timeframe, so check
	        // we still have a client.
	        if (!MatrixClientPeg.get()) return;
	
	        var currentReadUpToEventId = this._getCurrentReadReceipt(true);
	        var currentReadUpToEventIndex = this._indexForEventId(currentReadUpToEventId);
	
	        // We want to avoid sending out read receipts when we are looking at
	        // events in the past which are before the latest RR.
	        //
	        // For now, let's apply a heuristic: if (a) the event corresponding to
	        // the latest RR (either from the server, or sent by ourselves) doesn't
	        // appear in our timeline, and (b) we could forward-paginate the event
	        // timeline, then don't send any more RRs.
	        //
	        // This isn't watertight, as we could be looking at a section of
	        // timeline which is *after* the latest RR (so we should actually send
	        // RRs) - but that is a bit of a niche case. It will sort itself out when
	        // the user eventually hits the live timeline.
	        //
	        if (currentReadUpToEventId && currentReadUpToEventIndex === null && this._timelineWindow.canPaginate(EventTimeline.FORWARDS)) {
	            return;
	        }
	
	        var lastReadEventIndex = this._getLastDisplayedEventIndex({
	            ignoreOwn: true
	        });
	        if (lastReadEventIndex === null) return;
	
	        var lastReadEvent = this.state.events[lastReadEventIndex];
	
	        // we also remember the last read receipt we sent to avoid spamming the
	        // same one at the server repeatedly
	        if (lastReadEventIndex > currentReadUpToEventIndex && this.last_rr_sent_event_id != lastReadEvent.getId()) {
	            this.last_rr_sent_event_id = lastReadEvent.getId();
	            MatrixClientPeg.get().sendReadReceipt(lastReadEvent).catch(function () {
	                // it failed, so allow retries next time the user is active
	                _this3.last_rr_sent_event_id = undefined;
	            });
	
	            // do a quick-reset of our unreadNotificationCount to avoid having
	            // to wait from the remote echo from the homeserver.
	            // we only do this if we're right at the end, because we're just assuming
	            // that sending an RR for the latest message will set our notif counter
	            // to zero: it may not do this if we send an RR for somewhere before the end.
	            if (this.isAtEndOfLiveTimeline()) {
	                this.props.timelineSet.room.setUnreadNotificationCount('total', 0);
	                this.props.timelineSet.room.setUnreadNotificationCount('highlight', 0);
	                dis.dispatch({
	                    action: 'on_room_read'
	                });
	            }
	        }
	    },
	
	    // if the read marker is on the screen, we can now assume we've caught up to the end
	    // of the screen, so move the marker down to the bottom of the screen.
	    updateReadMarker: function updateReadMarker() {
	        if (!this.props.manageReadMarkers) return;
	        if (this.getReadMarkerPosition() !== 0) {
	            return;
	        }
	
	        // move the RM to *after* the message at the bottom of the screen. This
	        // avoids a problem whereby we never advance the RM if there is a huge
	        // message which doesn't fit on the screen.
	        //
	        // But ignore local echoes for this - they have a temporary event ID
	        // and we'll get confused when their ID changes and we can't figure out
	        // where the RM is pointing to. The read marker will be invisible for
	        // now anyway, so this doesn't really matter.
	        var lastDisplayedIndex = this._getLastDisplayedEventIndex({
	            allowPartial: true,
	            ignoreEchoes: true
	        });
	
	        if (lastDisplayedIndex === null) {
	            return;
	        }
	
	        var lastDisplayedEvent = this.state.events[lastDisplayedIndex];
	        this._setReadMarker(lastDisplayedEvent.getId(), lastDisplayedEvent.getTs());
	
	        // the read-marker should become invisible, so that if the user scrolls
	        // down, they don't see it.
	        if (this.state.readMarkerVisible) {
	            this.setState({
	                readMarkerVisible: false
	            });
	        }
	    },
	
	    // advance the read marker past any events we sent ourselves.
	    _advanceReadMarkerPastMyEvents: function _advanceReadMarkerPastMyEvents() {
	        if (!this.props.manageReadMarkers) return;
	
	        // we call _timelineWindow.getEvents() rather than using
	        // this.state.events, because react batches the update to the latter, so it
	        // may not have been updated yet.
	        var events = this._timelineWindow.getEvents();
	
	        // first find where the current RM is
	        for (var i = 0; i < events.length; i++) {
	            if (events[i].getId() == this.state.readMarkerEventId) {
	                break;
	            }
	        }
	        if (i >= events.length) {
	            return;
	        }
	
	        // now think about advancing it
	        var myUserId = MatrixClientPeg.get().credentials.userId;
	        for (i++; i < events.length; i++) {
	            var ev = events[i];
	            if (!ev.sender || ev.sender.userId != myUserId) {
	                break;
	            }
	        }
	        // i is now the first unread message which we didn't send ourselves.
	        i--;
	
	        var ev = events[i];
	        this._setReadMarker(ev.getId(), ev.getTs());
	    },
	
	    /* jump down to the bottom of this room, where new events are arriving
	     */
	    jumpToLiveTimeline: function jumpToLiveTimeline() {
	        // if we can't forward-paginate the existing timeline, then there
	        // is no point reloading it - just jump straight to the bottom.
	        //
	        // Otherwise, reload the timeline rather than trying to paginate
	        // through all of space-time.
	        if (this._timelineWindow.canPaginate(EventTimeline.FORWARDS)) {
	            this._loadTimeline();
	        } else {
	            if (this.refs.messagePanel) {
	                this.refs.messagePanel.scrollToBottom();
	            }
	        }
	    },
	
	    /* scroll to show the read-up-to marker. We put it 1/3 of the way down
	     * the container.
	     */
	    jumpToReadMarker: function jumpToReadMarker() {
	        if (!this.props.manageReadMarkers) return;
	        if (!this.refs.messagePanel) return;
	        if (!this.state.readMarkerEventId) return;
	
	        // we may not have loaded the event corresponding to the read-marker
	        // into the _timelineWindow. In that case, attempts to scroll to it
	        // will fail.
	        //
	        // a quick way to figure out if we've loaded the relevant event is
	        // simply to check if the messagepanel knows where the read-marker is.
	        var ret = this.refs.messagePanel.getReadMarkerPosition();
	        if (ret !== null) {
	            // The messagepanel knows where the RM is, so we must have loaded
	            // the relevant event.
	            this.refs.messagePanel.scrollToEvent(this.state.readMarkerEventId, 0, 1 / 3);
	            return;
	        }
	
	        // Looks like we haven't loaded the event corresponding to the read-marker.
	        // As with jumpToLiveTimeline, we want to reload the timeline around the
	        // read-marker.
	        this._loadTimeline(this.state.readMarkerEventId, 0, 1 / 3);
	    },
	
	    /* update the read-up-to marker to match the read receipt
	     */
	    forgetReadMarker: function forgetReadMarker() {
	        if (!this.props.manageReadMarkers) return;
	
	        var rmId = this._getCurrentReadReceipt();
	
	        // see if we know the timestamp for the rr event
	        var tl = this.props.timelineSet.getTimelineForEvent(rmId);
	        var rmTs;
	        if (tl) {
	            var event = tl.getEvents().find(function (e) {
	                return e.getId() == rmId;
	            });
	            if (event) {
	                rmTs = event.getTs();
	            }
	        }
	
	        this._setReadMarker(rmId, rmTs);
	    },
	
	    /* return true if the content is fully scrolled down and we are
	     * at the end of the live timeline.
	     */
	    isAtEndOfLiveTimeline: function isAtEndOfLiveTimeline() {
	        return this.refs.messagePanel && this.refs.messagePanel.isAtBottom() && this._timelineWindow && !this._timelineWindow.canPaginate(EventTimeline.FORWARDS);
	    },
	
	    /* get the current scroll state. See ScrollPanel.getScrollState for
	     * details.
	     *
	     * returns null if we are not mounted.
	     */
	    getScrollState: function getScrollState() {
	        if (!this.refs.messagePanel) {
	            return null;
	        }
	        return this.refs.messagePanel.getScrollState();
	    },
	
	    // returns one of:
	    //
	    //  null: there is no read marker
	    //  -1: read marker is above the window
	    //   0: read marker is visible
	    //  +1: read marker is below the window
	    getReadMarkerPosition: function getReadMarkerPosition() {
	        if (!this.props.manageReadMarkers) return null;
	        if (!this.refs.messagePanel) return null;
	
	        var ret = this.refs.messagePanel.getReadMarkerPosition();
	        if (ret !== null) {
	            return ret;
	        }
	
	        // the messagePanel doesn't know where the read marker is.
	        // if we know the timestamp of the read marker, make a guess based on that.
	        var rmTs = TimelinePanel.roomReadMarkerTsMap[this.props.timelineSet.roomId];
	        if (rmTs && this.state.events.length > 0) {
	            if (rmTs < this.state.events[0].getTs()) {
	                return -1;
	            } else {
	                return 1;
	            }
	        }
	
	        return null;
	    },
	
	    /**
	     * called by the parent component when PageUp/Down/etc is pressed.
	     *
	     * We pass it down to the scroll panel.
	     */
	    handleScrollKey: function handleScrollKey(ev) {
	        if (!this.refs.messagePanel) {
	            return;
	        }
	
	        // jump to the live timeline on ctrl-end, rather than the end of the
	        // timeline window.
	        if (ev.ctrlKey && ev.keyCode == KeyCode.END) {
	            this.jumpToLiveTimeline();
	        } else {
	            this.refs.messagePanel.handleScrollKey(ev);
	        }
	    },
	
	    _initTimeline: function _initTimeline(props) {
	        var initialEvent = props.eventId;
	        var pixelOffset = props.eventPixelOffset;
	
	        // if a pixelOffset is given, it is relative to the bottom of the
	        // container. If not, put the event in the middle of the container.
	        var offsetBase = 1;
	        if (pixelOffset == null) {
	            offsetBase = 0.5;
	        }
	
	        return this._loadTimeline(initialEvent, pixelOffset, offsetBase);
	    },
	
	    /**
	     * (re)-load the event timeline, and initialise the scroll state, centered
	     * around the given event.
	     *
	     * @param {string?}  eventId the event to focus on. If undefined, will
	     *    scroll to the bottom of the room.
	     *
	     * @param {number?} pixelOffset   offset to position the given event at
	     *    (pixels from the offsetBase). If omitted, defaults to 0.
	     *
	     * @param {number?} offsetBase the reference point for the pixelOffset. 0
	     *     means the top of the container, 1 means the bottom, and fractional
	     *     values mean somewhere in the middle. If omitted, it defaults to 0.
	     *
	     * returns a promise which will resolve when the load completes.
	     */
	    _loadTimeline: function _loadTimeline(eventId, pixelOffset, offsetBase) {
	        var _this4 = this;
	
	        this._timelineWindow = new Matrix.TimelineWindow(MatrixClientPeg.get(), this.props.timelineSet, { windowLimit: this.props.timelineCap });
	
	        var onLoaded = function onLoaded() {
	            _this4._reloadEvents();
	
	            // If we switched away from the room while there were pending
	            // outgoing events, the read-marker will be before those events.
	            // We need to skip over any which have subsequently been sent.
	            _this4._advanceReadMarkerPastMyEvents();
	
	            _this4.setState({
	                canBackPaginate: _this4._timelineWindow.canPaginate(EventTimeline.BACKWARDS),
	                canForwardPaginate: _this4._timelineWindow.canPaginate(EventTimeline.FORWARDS),
	                timelineLoading: false
	            }, function () {
	                // initialise the scroll state of the message panel
	                if (!_this4.refs.messagePanel) {
	                    // this shouldn't happen - we know we're mounted because
	                    // we're in a setState callback, and we know
	                    // timelineLoading is now false, so render() should have
	                    // mounted the message panel.
	                    console.log("can't initialise scroll state because " + "messagePanel didn't load");
	                    return;
	                }
	                if (eventId) {
	                    _this4.refs.messagePanel.scrollToEvent(eventId, pixelOffset, offsetBase);
	                } else {
	                    _this4.refs.messagePanel.scrollToBottom();
	                }
	
	                _this4.sendReadReceipt();
	                _this4.updateReadMarker();
	            });
	        };
	
	        var onError = function onError(error) {
	            _this4.setState({ timelineLoading: false });
	            var msg = error.message ? error.message : (0, _stringify2.default)(error);
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	
	            var onFinished;
	
	            // if we were given an event ID, then when the user closes the
	            // dialog, let's jump to the end of the timeline. If we weren't,
	            // something has gone badly wrong and rather than causing a loop of
	            // undismissable dialogs, let's just give up.
	            if (eventId) {
	                onFinished = function onFinished() {
	                    // go via the dispatcher so that the URL is updated
	                    dis.dispatch({
	                        action: 'view_room',
	                        room_id: _this4.props.timelineSet.room.roomId
	                    });
	                };
	            }
	            var message = "Tried to load a specific point in this room's timeline, but ";
	            if (error.errcode == 'M_FORBIDDEN') {
	                message += "you do not have permission to view the message in question.";
	            } else {
	                message += "was unable to find it.";
	            }
	            Modal.createDialog(ErrorDialog, {
	                title: "Failed to load timeline position",
	                description: message,
	                onFinished: onFinished
	            });
	        };
	
	        var prom = this._timelineWindow.load(eventId, INITIAL_SIZE);
	
	        // if we already have the event in question, TimelineWindow.load
	        // returns a resolved promise.
	        //
	        // In this situation, we don't really want to defer the update of the
	        // state to the next event loop, because it makes room-switching feel
	        // quite slow. So we detect that situation and shortcut straight to
	        // calling _reloadEvents and updating the state.
	
	        if (prom.isFulfilled()) {
	            onLoaded();
	        } else {
	            this.setState({
	                events: [],
	                canBackPaginate: false,
	                canForwardPaginate: false,
	                timelineLoading: true
	            });
	
	            prom = prom.then(onLoaded, onError);
	        }
	
	        prom.done();
	    },
	
	    // handle the completion of a timeline load or localEchoUpdate, by
	    // reloading the events from the timelinewindow and pending event list into
	    // the state.
	    _reloadEvents: function _reloadEvents() {
	        // we might have switched rooms since the load started - just bin
	        // the results if so.
	        if (this.unmounted) return;
	
	        this.setState({
	            events: this._getEvents()
	        });
	    },
	
	    // get the list of events from the timeline window and the pending event list
	    _getEvents: function _getEvents() {
	        var events = this._timelineWindow.getEvents();
	
	        // if we're at the end of the live timeline, append the pending events
	        if (!this._timelineWindow.canPaginate(EventTimeline.FORWARDS)) {
	            events.push.apply(events, (0, _toConsumableArray3.default)(this.props.timelineSet.getPendingEvents()));
	        }
	
	        return events;
	    },
	
	    _indexForEventId: function _indexForEventId(evId) {
	        for (var i = 0; i < this.state.events.length; ++i) {
	            if (evId == this.state.events[i].getId()) {
	                return i;
	            }
	        }
	        return null;
	    },
	
	    _getLastDisplayedEventIndex: function _getLastDisplayedEventIndex(opts) {
	        opts = opts || {};
	        var ignoreOwn = opts.ignoreOwn || false;
	        var ignoreEchoes = opts.ignoreEchoes || false;
	        var allowPartial = opts.allowPartial || false;
	
	        var messagePanel = this.refs.messagePanel;
	        if (messagePanel === undefined) return null;
	
	        var wrapperRect = ReactDOM.findDOMNode(messagePanel).getBoundingClientRect();
	        var myUserId = MatrixClientPeg.get().credentials.userId;
	
	        for (var i = this.state.events.length - 1; i >= 0; --i) {
	            var ev = this.state.events[i];
	
	            if (ignoreOwn && ev.sender && ev.sender.userId == myUserId) {
	                continue;
	            }
	
	            // local echoes have a fake event ID
	            if (ignoreEchoes && ev.status) {
	                continue;
	            }
	
	            var node = messagePanel.getNodeForEventId(ev.getId());
	            if (!node) continue;
	
	            var boundingRect = node.getBoundingClientRect();
	            if (allowPartial && boundingRect.top < wrapperRect.bottom || !allowPartial && boundingRect.bottom < wrapperRect.bottom) {
	                return i;
	            }
	        }
	        return null;
	    },
	
	    /**
	     * get the id of the event corresponding to our user's latest read-receipt.
	     *
	     * @param {Boolean} ignoreSynthesized If true, return only receipts that
	     *                                    have been sent by the server, not
	     *                                    implicit ones generated by the JS
	     *                                    SDK.
	     */
	    _getCurrentReadReceipt: function _getCurrentReadReceipt(ignoreSynthesized) {
	        var client = MatrixClientPeg.get();
	        // the client can be null on logout
	        if (client == null) {
	            return null;
	        }
	
	        var myUserId = client.credentials.userId;
	        return this.props.timelineSet.room.getEventReadUpTo(myUserId, ignoreSynthesized);
	    },
	
	    _setReadMarker: function _setReadMarker(eventId, eventTs, inhibitSetState) {
	        var roomId = this.props.timelineSet.room.roomId;
	
	        if (TimelinePanel.roomReadMarkerMap[roomId] == eventId) {
	            // don't update the state (and cause a re-render) if there is
	            // no change to the RM.
	            return;
	        }
	
	        // ideally we'd sync these via the server, but for now just stash them
	        // in a map.
	        TimelinePanel.roomReadMarkerMap[roomId] = eventId;
	
	        // in order to later figure out if the read marker is
	        // above or below the visible timeline, we stash the timestamp.
	        TimelinePanel.roomReadMarkerTsMap[roomId] = eventTs;
	
	        if (inhibitSetState) {
	            return;
	        }
	
	        // run the render cycle before calling the callback, so that
	        // getReadMarkerPosition() returns the right thing.
	        this.setState({
	            readMarkerEventId: eventId
	        }, this.props.onReadMarkerUpdated);
	    },
	
	    render: function render() {
	        var MessagePanel = sdk.getComponent("structures.MessagePanel");
	        var Loader = sdk.getComponent("elements.Spinner");
	
	        // just show a spinner while the timeline loads.
	        //
	        // put it in a div of the right class (mx_RoomView_messagePanel) so
	        // that the order in the roomview flexbox is correct, and
	        // mx_RoomView_messageListWrapper to position the inner div in the
	        // right place.
	        //
	        // Note that the click-on-search-result functionality relies on the
	        // fact that the messagePanel is hidden while the timeline reloads,
	        // but that the RoomHeader (complete with search term) continues to
	        // exist.
	        if (this.state.timelineLoading) {
	            return React.createElement(
	                "div",
	                { className: this.props.className + " mx_RoomView_messageListWrapper" },
	                React.createElement(Loader, null)
	            );
	        }
	
	        if (this.state.events.length == 0 && !this.state.canBackPaginate && this.props.empty) {
	            return React.createElement(
	                "div",
	                { className: this.props.className + " mx_RoomView_messageListWrapper" },
	                React.createElement(
	                    "div",
	                    { className: "mx_RoomView_empty" },
	                    this.props.empty
	                )
	            );
	        }
	
	        // give the messagepanel a stickybottom if we're at the end of the
	        // live timeline, so that the arrival of new events triggers a
	        // scroll.
	        //
	        // Make sure that stickyBottom is *false* if we can paginate
	        // forwards, otherwise if somebody hits the bottom of the loaded
	        // events when viewing historical messages, we get stuck in a loop
	        // of paginating our way through the entire history of the room.
	        var stickyBottom = !this._timelineWindow.canPaginate(EventTimeline.FORWARDS);
	
	        return React.createElement(MessagePanel, { ref: "messagePanel",
	            hidden: this.props.hidden,
	            backPaginating: this.state.backPaginating,
	            forwardPaginating: this.state.forwardPaginating,
	            events: this.state.events,
	            highlightedEventId: this.props.highlightedEventId,
	            readMarkerEventId: this.state.readMarkerEventId,
	            readMarkerVisible: this.state.readMarkerVisible,
	            suppressFirstDateSeparator: this.state.canBackPaginate,
	            showUrlPreview: this.props.showUrlPreview,
	            manageReadReceipts: this.props.manageReadReceipts,
	            ourUserId: MatrixClientPeg.get().credentials.userId,
	            stickyBottom: stickyBottom,
	            onScroll: this.onMessageListScroll,
	            onFillRequest: this.onMessageListFillRequest,
	            onUnfillRequest: this.onMessageListUnfillRequest,
	            opacity: this.props.opacity,
	            className: this.props.className,
	            tileShape: this.props.tileShape
	        });
	    }
	});
	
	module.exports = TimelinePanel;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var ContentMessages = __webpack_require__(497);
	var dis = __webpack_require__(5);
	var filesize = __webpack_require__(300);
	
	module.exports = React.createClass({ displayName: 'UploadBar',
	    propTypes: {
	        room: React.PropTypes.object
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        this.mounted = true;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this.mounted = false;
	        dis.unregister(this.dispatcherRef);
	    },
	
	    onAction: function onAction(payload) {
	        switch (payload.action) {
	            case 'upload_progress':
	            case 'upload_finished':
	            case 'upload_failed':
	                if (this.mounted) this.forceUpdate();
	                break;
	        }
	    },
	
	    render: function render() {
	        var uploads = ContentMessages.getCurrentUploads();
	
	        // for testing UI... - also fix up the ContentMessages.getCurrentUploads().length
	        // check in RoomView
	        //
	        // uploads = [{
	        //     roomId: this.props.room.roomId,
	        //     loaded: 123493,
	        //     total: 347534,
	        //     fileName: "testing_fooble.jpg",
	        // }];
	
	        if (uploads.length == 0) {
	            return React.createElement('div', null);
	        }
	
	        var upload;
	        for (var i = 0; i < uploads.length; ++i) {
	            if (uploads[i].roomId == this.props.room.roomId) {
	                upload = uploads[i];
	                break;
	            }
	        }
	        if (!upload) {
	            return React.createElement('div', null);
	        }
	
	        var innerProgressStyle = {
	            width: upload.loaded / (upload.total || 1) * 100 + '%'
	        };
	        var uploadedSize = filesize(upload.loaded);
	        var totalSize = filesize(upload.total);
	        if (uploadedSize.replace(/^.* /, '') === totalSize.replace(/^.* /, '')) {
	            uploadedSize = uploadedSize.replace(/ .*/, '');
	        }
	
	        var others;
	        if (uploads.length > 1) {
	            others = ' and ' + (uploads.length - 1) + ' other' + (uploads.length > 2 ? 's' : '');
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_UploadBar' },
	            React.createElement(
	                'div',
	                { className: 'mx_UploadBar_uploadProgressOuter' },
	                React.createElement('div', { className: 'mx_UploadBar_uploadProgressInner', style: innerProgressStyle })
	            ),
	            React.createElement('img', { className: 'mx_UploadBar_uploadIcon mx_filterFlipColor', src: 'img/fileicon.png', width: '17', height: '22' }),
	            React.createElement('img', { className: 'mx_UploadBar_uploadCancel mx_filterFlipColor', src: 'img/cancel.svg', width: '18', height: '18',
	                onClick: function onClick() {
	                    ContentMessages.cancelUpload(upload.promise);
	                }
	            }),
	            React.createElement(
	                'div',
	                { className: 'mx_UploadBar_uploadBytes' },
	                uploadedSize,
	                ' / ',
	                totalSize
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UploadBar_uploadFilename' },
	                'Uploading ',
	                upload.fileName,
	                others
	            )
	        );
	    }
	});


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var PlatformPeg = __webpack_require__(93);
	var Modal = __webpack_require__(10);
	var dis = __webpack_require__(5);
	var q = __webpack_require__(6);
	var package_json = __webpack_require__(608);
	var UserSettingsStore = __webpack_require__(74);
	var GeminiScrollbar = __webpack_require__(121);
	var Email = __webpack_require__(518);
	var AddThreepid = __webpack_require__(496);
	var SdkConfig = __webpack_require__(118);
	
	
	// if this looks like a release, use the 'version' from package.json; else use
	// the git sha.
	var REACT_SDK_VERSION = 'dist' in package_json ? package_json.version : package_json.gitHead || "<local>";
	
	// Enumerate some simple 'flip a bit' UI settings (if any).
	// 'id' gives the key name in the im.vector.web.settings account data event
	// 'label' is how we describe it in the UI.
	var SETTINGS_LABELS = [{
	    id: 'autoplayGifsAndVideos',
	    label: 'Autoplay GIFs and videos'
	}];
	
	var CRYPTO_SETTINGS_LABELS = [{
	    id: 'blacklistUnverifiedDevices',
	    label: 'Never send encrypted messages to unverified devices from this device'
	}];
	
	// Enumerate the available themes, with a nice human text label.
	// 'id' gives the key name in the im.vector.web.settings account data event
	// 'value' is the value for that key in the event
	// 'label' is how we describe it in the UI.
	//
	// XXX: Ideally we would have a theme manifest or something and they'd be nicely
	// packaged up in a single directory, and/or located at the application layer.
	// But for now for expedience we just hardcode them here.
	var THEMES = [{
	    id: 'theme',
	    label: 'Light theme',
	    value: 'light'
	}, {
	    id: 'theme',
	    label: 'Dark theme',
	    value: 'dark'
	}];
	
	module.exports = React.createClass({
	    displayName: 'UserSettings',
	
	    propTypes: {
	        onClose: React.PropTypes.func,
	        // The brand string given when creating email pushers
	        brand: React.PropTypes.string,
	
	        // True to show the 'labs' section of experimental features
	        enableLabs: React.PropTypes.bool,
	
	        // The base URL to use in the referral link. Defaults to window.location.origin.
	        referralBaseUrl: React.PropTypes.string,
	
	        // true if RightPanel is collapsed
	        collapsedRhs: React.PropTypes.bool,
	
	        // Team token for the referral link. If falsy, the referral section will
	        // not appear
	        teamToken: React.PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onClose: function onClose() {},
	            enableLabs: true
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            avatarUrl: null,
	            threePids: [],
	            phase: "UserSettings.LOADING", // LOADING, DISPLAY
	            email_add_pending: false,
	            vectorVersion: null,
	            rejectingInvites: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        this._unmounted = false;
	        this._addThreepid = null;
	
	        if (PlatformPeg.get()) {
	            q().then(function () {
	                return PlatformPeg.get().getAppVersion();
	            }).done(function (appVersion) {
	                if (_this._unmounted) return;
	                _this.setState({
	                    vectorVersion: appVersion
	                });
	            }, function (e) {
	                console.log("Failed to fetch app version", e);
	            });
	        }
	
	        // Bulk rejecting invites:
	        // /sync won't have had time to return when UserSettings re-renders from state changes, so getRooms()
	        // will still return rooms with invites. To get around this, add a listener for
	        // membership updates and kick the UI.
	        MatrixClientPeg.get().on("RoomMember.membership", this._onInviteStateChange);
	
	        dis.dispatch({
	            action: 'ui_opacity',
	            sideOpacity: 0.3,
	            middleOpacity: 0.3
	        });
	        this._refreshFromServer();
	
	        var syncedSettings = UserSettingsStore.getSyncedSettings();
	        if (!syncedSettings.theme) {
	            syncedSettings.theme = 'light';
	        }
	        this._syncedSettings = syncedSettings;
	
	        this._localSettings = UserSettingsStore.getLocalSettings();
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        this._me = MatrixClientPeg.get().credentials.userId;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this._unmounted = true;
	        dis.dispatch({
	            action: 'ui_opacity',
	            sideOpacity: 1.0,
	            middleOpacity: 1.0
	        });
	        dis.unregister(this.dispatcherRef);
	        var cli = MatrixClientPeg.get();
	        if (cli) {
	            cli.removeListener("RoomMember.membership", this._onInviteStateChange);
	        }
	    },
	
	    _refreshFromServer: function _refreshFromServer() {
	        var self = this;
	        q.all([UserSettingsStore.loadProfileInfo(), UserSettingsStore.loadThreePids()]).done(function (resps) {
	            self.setState({
	                avatarUrl: resps[0].avatar_url,
	                threepids: resps[1].threepids,
	                phase: "UserSettings.DISPLAY"
	            });
	        }, function (error) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            console.error("Failed to load user settings: " + error);
	            Modal.createDialog(ErrorDialog, {
	                title: "Can't load user settings",
	                description: "Server may be unavailable or overloaded"
	            });
	        });
	    },
	
	    onAction: function onAction(payload) {
	        if (payload.action === "notifier_enabled") {
	            this.forceUpdate();
	        }
	    },
	
	    onAvatarPickerClick: function onAvatarPickerClick(ev) {
	        if (MatrixClientPeg.get().isGuest()) {
	            var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	            Modal.createDialog(NeedToRegisterDialog, {
	                title: "Please Register",
	                description: "Guests can't set avatars. Please register."
	            });
	            return;
	        }
	
	        if (this.refs.file_label) {
	            this.refs.file_label.click();
	        }
	    },
	
	    onAvatarSelected: function onAvatarSelected(ev) {
	        var self = this;
	        var changeAvatar = this.refs.changeAvatar;
	        if (!changeAvatar) {
	            console.error("No ChangeAvatar found to upload image to!");
	            return;
	        }
	        changeAvatar.onFileSelected(ev).done(function () {
	            // dunno if the avatar changed, re-check it.
	            self._refreshFromServer();
	        }, function (err) {
	            var errMsg = typeof err === "string" ? err : err.error || "";
	            console.error("Failed to set avatar: " + err);
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "Failed to set avatar."
	            });
	        });
	    },
	
	    onLogoutClicked: function onLogoutClicked(ev) {
	        var _this2 = this;
	
	        var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	        Modal.createDialog(QuestionDialog, {
	            title: "Sign out?",
	            description: React.createElement(
	                'div',
	                null,
	                'For security, logging out will delete any end-to-end encryption keys from this browser. If you want to be able to decrypt your conversation history from future Riot sessions, please export your room keys for safe-keeping.'
	            ),
	            button: "Sign out",
	            extraButtons: [React.createElement(
	                'button',
	                { className: 'mx_Dialog_primary',
	                    onClick: this._onExportE2eKeysClicked },
	                'Export E2E room keys'
	            )],
	            onFinished: function onFinished(confirmed) {
	                if (confirmed) {
	                    dis.dispatch({ action: 'logout' });
	                    if (_this2.props.onFinished) {
	                        _this2.props.onFinished();
	                    }
	                }
	            }
	        });
	    },
	
	    onPasswordChangeError: function onPasswordChangeError(err) {
	        var errMsg = err.error || "";
	        if (err.httpStatus === 403) {
	            errMsg = "Failed to change password. Is your password correct?";
	        } else if (err.httpStatus) {
	            errMsg += ' (HTTP status ' + err.httpStatus + ')';
	        }
	        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	        console.error("Failed to change password: " + errMsg);
	        Modal.createDialog(ErrorDialog, {
	            title: "Error",
	            description: errMsg
	        });
	    },
	
	    onPasswordChanged: function onPasswordChanged() {
	        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	        Modal.createDialog(ErrorDialog, {
	            title: "Success",
	            description: 'Your password was successfully changed. You will not\n                          receive push notifications on other devices until you\n                          log back in to them.'
	        });
	    },
	
	    onUpgradeClicked: function onUpgradeClicked() {
	        dis.dispatch({
	            action: "start_upgrade_registration"
	        });
	    },
	
	    onEnableNotificationsChange: function onEnableNotificationsChange(event) {
	        UserSettingsStore.setEnableNotifications(event.target.checked);
	    },
	
	    _onAddEmailEditFinished: function _onAddEmailEditFinished(value, shouldSubmit) {
	        if (!shouldSubmit) return;
	        this._addEmail();
	    },
	
	    _addEmail: function _addEmail() {
	        var _this3 = this;
	
	        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	        var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	
	        var email_address = this.refs.add_email_input.value;
	        if (!Email.looksValid(email_address)) {
	            Modal.createDialog(ErrorDialog, {
	                title: "Invalid Email Address",
	                description: "This doesn't appear to be a valid email address"
	            });
	            return;
	        }
	        this._addThreepid = new AddThreepid();
	        // we always bind emails when registering, so let's do the
	        // same here.
	        this._addThreepid.addEmailAddress(email_address, true).done(function () {
	            Modal.createDialog(QuestionDialog, {
	                title: "Verification Pending",
	                description: "Please check your email and click on the link it contains. Once this is done, click continue.",
	                button: 'Continue',
	                onFinished: _this3.onEmailDialogFinished
	            });
	        }, function (err) {
	            _this3.setState({ email_add_pending: false });
	            console.error("Unable to add email address " + email_address + " " + err);
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "Unable to add email address"
	            });
	        });
	        ReactDOM.findDOMNode(this.refs.add_email_input).blur();
	        this.setState({ email_add_pending: true });
	    },
	
	    onRemoveThreepidClicked: function onRemoveThreepidClicked(threepid) {
	        var _this4 = this;
	
	        var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	        Modal.createDialog(QuestionDialog, {
	            title: "Remove Contact Information?",
	            description: "Remove " + threepid.address + "?",
	            button: 'Remove',
	            onFinished: function onFinished(submit) {
	                if (submit) {
	                    _this4.setState({
	                        phase: "UserSettings.LOADING"
	                    });
	                    MatrixClientPeg.get().deleteThreePid(threepid.medium, threepid.address).then(function () {
	                        return _this4._refreshFromServer();
	                    }).catch(function (err) {
	                        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                        console.error("Unable to remove contact information: " + err);
	                        Modal.createDialog(ErrorDialog, {
	                            title: "Error",
	                            description: "Unable to remove contact information"
	                        });
	                    }).done();
	                }
	            }
	        });
	    },
	
	    onEmailDialogFinished: function onEmailDialogFinished(ok) {
	        if (ok) {
	            this.verifyEmailAddress();
	        } else {
	            this.setState({ email_add_pending: false });
	        }
	    },
	
	    verifyEmailAddress: function verifyEmailAddress() {
	        var _this5 = this;
	
	        this._addThreepid.checkEmailLinkClicked().done(function () {
	            _this5._addThreepid = null;
	            _this5.setState({
	                phase: "UserSettings.LOADING"
	            });
	            _this5._refreshFromServer();
	            _this5.setState({ email_add_pending: false });
	        }, function (err) {
	            _this5.setState({ email_add_pending: false });
	            if (err.errcode == 'M_THREEPID_AUTH_FAILED') {
	                var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	                var message = "Unable to verify email address. ";
	                message += "Please check your email and click on the link it contains. Once this is done, click continue.";
	                Modal.createDialog(QuestionDialog, {
	                    title: "Verification Pending",
	                    description: message,
	                    button: 'Continue',
	                    onFinished: _this5.onEmailDialogFinished
	                });
	            } else {
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                console.error("Unable to verify email address: " + err);
	                Modal.createDialog(ErrorDialog, {
	                    title: "Error",
	                    description: "Unable to verify email address"
	                });
	            }
	        });
	    },
	
	    _onDeactivateAccountClicked: function _onDeactivateAccountClicked() {
	        var DeactivateAccountDialog = sdk.getComponent("dialogs.DeactivateAccountDialog");
	        Modal.createDialog(DeactivateAccountDialog, {});
	    },
	
	    _onBugReportClicked: function _onBugReportClicked() {
	        var BugReportDialog = sdk.getComponent("dialogs.BugReportDialog");
	        if (!BugReportDialog) {
	            return;
	        }
	        Modal.createDialog(BugReportDialog, {});
	    },
	
	    _onClearCacheClicked: function _onClearCacheClicked() {
	        if (!PlatformPeg.get()) return;
	
	        MatrixClientPeg.get().stopClient();
	        MatrixClientPeg.get().store.deleteAllData().done(function () {
	            PlatformPeg.get().reload();
	        });
	    },
	
	    _onInviteStateChange: function _onInviteStateChange(event, member, oldMembership) {
	        if (member.userId === this._me && oldMembership === "invite") {
	            this.forceUpdate();
	        }
	    },
	
	    _onRejectAllInvitesClicked: function _onRejectAllInvitesClicked(rooms, ev) {
	        var _this6 = this;
	
	        this.setState({
	            rejectingInvites: true
	        });
	        // reject the invites
	        var promises = rooms.map(function (room) {
	            return MatrixClientPeg.get().leave(room.roomId);
	        });
	        // purposefully drop errors to the floor: we'll just have a non-zero number on the UI
	        // after trying to reject all the invites.
	        q.allSettled(promises).then(function () {
	            _this6.setState({
	                rejectingInvites: false
	            });
	        }).done();
	    },
	
	    _onExportE2eKeysClicked: function _onExportE2eKeysClicked() {
	        Modal.createDialogAsync(function (cb) {
	            __webpack_require__.e/* nsure */(0, function () {
	                cb(__webpack_require__(141));
	            });
	        }, {
	            matrixClient: MatrixClientPeg.get()
	        });
	    },
	
	    _onImportE2eKeysClicked: function _onImportE2eKeysClicked() {
	        Modal.createDialogAsync(function (cb) {
	            __webpack_require__.e/* nsure */(0, function () {
	                cb(__webpack_require__(507));
	            });
	        }, {
	            matrixClient: MatrixClientPeg.get()
	        });
	    },
	
	    _renderReferral: function _renderReferral() {
	        var teamToken = this.props.teamToken;
	        if (!teamToken) {
	            return null;
	        }
	        if (typeof teamToken !== 'string') {
	            console.warn('Team token not a string');
	            return null;
	        }
	        var href = (this.props.referralBaseUrl || window.location.origin) + ('/#/register?referrer=' + this._me + '&team_token=' + teamToken);
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Referral'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                'Refer a friend to Riot: ',
	                React.createElement(
	                    'a',
	                    { href: href },
	                    href
	                )
	            )
	        );
	    },
	
	    _renderUserInterfaceSettings: function _renderUserInterfaceSettings() {
	        var client = MatrixClientPeg.get();
	
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'User Interface'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                this._renderUrlPreviewSelector(),
	                SETTINGS_LABELS.map(this._renderSyncedSetting),
	                THEMES.map(this._renderThemeSelector)
	            )
	        );
	    },
	
	    _renderUrlPreviewSelector: function _renderUrlPreviewSelector() {
	        return React.createElement(
	            'div',
	            { className: 'mx_UserSettings_toggle' },
	            React.createElement('input', { id: 'urlPreviewsDisabled',
	                type: 'checkbox',
	                defaultChecked: UserSettingsStore.getUrlPreviewsDisabled(),
	                onChange: function onChange(e) {
	                    return UserSettingsStore.setUrlPreviewsDisabled(e.target.checked);
	                }
	            }),
	            React.createElement(
	                'label',
	                { htmlFor: 'urlPreviewsDisabled' },
	                'Disable inline URL previews by default'
	            )
	        );
	    },
	
	    _renderSyncedSetting: function _renderSyncedSetting(setting) {
	        return React.createElement(
	            'div',
	            { className: 'mx_UserSettings_toggle', key: setting.id },
	            React.createElement('input', { id: setting.id,
	                type: 'checkbox',
	                defaultChecked: this._syncedSettings[setting.id],
	                onChange: function onChange(e) {
	                    return UserSettingsStore.setSyncedSetting(setting.id, e.target.checked);
	                }
	            }),
	            React.createElement(
	                'label',
	                { htmlFor: setting.id },
	                setting.label
	            )
	        );
	    },
	
	    _renderThemeSelector: function _renderThemeSelector(setting) {
	        return React.createElement(
	            'div',
	            { className: 'mx_UserSettings_toggle', key: setting.id + "_" + setting.value },
	            React.createElement('input', { id: setting.id + "_" + setting.value,
	                type: 'radio',
	                name: setting.id,
	                value: setting.value,
	                defaultChecked: this._syncedSettings[setting.id] === setting.value,
	                onChange: function onChange(e) {
	                    if (e.target.checked) {
	                        UserSettingsStore.setSyncedSetting(setting.id, setting.value);
	                    }
	                    dis.dispatch({
	                        action: 'set_theme',
	                        value: setting.value
	                    });
	                }
	            }),
	            React.createElement(
	                'label',
	                { htmlFor: setting.id + "_" + setting.value },
	                setting.label
	            )
	        );
	    },
	
	    _renderCryptoInfo: function _renderCryptoInfo() {
	        var client = MatrixClientPeg.get();
	        var deviceId = client.deviceId;
	        var identityKey = client.getDeviceEd25519Key() || "<not supported>";
	
	        var importExportButtons = null;
	
	        if (client.isCryptoEnabled) {
	            importExportButtons = React.createElement(
	                'div',
	                { className: 'mx_UserSettings_importExportButtons' },
	                React.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_UserSettings_button',
	                        onClick: this._onExportE2eKeysClicked },
	                    'Export E2E room keys'
	                ),
	                React.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_UserSettings_button',
	                        onClick: this._onImportE2eKeysClicked },
	                    'Import E2E room keys'
	                )
	            );
	        }
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Cryptography'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section mx_UserSettings_cryptoSection' },
	                React.createElement(
	                    'ul',
	                    null,
	                    React.createElement(
	                        'li',
	                        null,
	                        React.createElement(
	                            'label',
	                            null,
	                            'Device ID:'
	                        ),
	                        '             ',
	                        React.createElement(
	                            'span',
	                            null,
	                            React.createElement(
	                                'code',
	                                null,
	                                deviceId
	                            )
	                        )
	                    ),
	                    React.createElement(
	                        'li',
	                        null,
	                        React.createElement(
	                            'label',
	                            null,
	                            'Device key:'
	                        ),
	                        '            ',
	                        React.createElement(
	                            'span',
	                            null,
	                            React.createElement(
	                                'code',
	                                null,
	                                React.createElement(
	                                    'b',
	                                    null,
	                                    identityKey
	                                )
	                            )
	                        )
	                    )
	                ),
	                importExportButtons
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                CRYPTO_SETTINGS_LABELS.map(this._renderLocalSetting)
	            )
	        );
	    },
	
	    _renderLocalSetting: function _renderLocalSetting(setting) {
	        var client = MatrixClientPeg.get();
	        return React.createElement(
	            'div',
	            { className: 'mx_UserSettings_toggle', key: setting.id },
	            React.createElement('input', { id: setting.id,
	                type: 'checkbox',
	                defaultChecked: this._localSettings[setting.id],
	                onChange: function onChange(e) {
	                    UserSettingsStore.setLocalSetting(setting.id, e.target.checked);
	                    if (setting.id === 'blacklistUnverifiedDevices') {
	                        // XXX: this is a bit ugly
	                        client.setGlobalBlacklistUnverifiedDevices(e.target.checked);
	                    }
	                }
	            }),
	            React.createElement(
	                'label',
	                { htmlFor: setting.id },
	                setting.label
	            )
	        );
	    },
	
	    _renderDevicesPanel: function _renderDevicesPanel() {
	        var DevicesPanel = sdk.getComponent('settings.DevicesPanel');
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Devices'
	            ),
	            React.createElement(DevicesPanel, { className: 'mx_UserSettings_section' })
	        );
	    },
	
	    _renderBugReport: function _renderBugReport() {
	        if (!SdkConfig.get().bug_report_endpoint_url) {
	            return React.createElement('div', null);
	        }
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Bug Report'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                React.createElement(
	                    'p',
	                    null,
	                    'Found a bug?'
	                ),
	                React.createElement(
	                    'button',
	                    { className: 'mx_UserSettings_button danger',
	                        onClick: this._onBugReportClicked },
	                    'Report it'
	                )
	            )
	        );
	    },
	
	    _renderLabs: function _renderLabs() {
	        var _this7 = this;
	
	        // default to enabled if undefined
	        if (this.props.enableLabs === false) return null;
	
	        var features = UserSettingsStore.LABS_FEATURES.map(function (feature) {
	            return React.createElement(
	                'div',
	                { key: feature.id, className: 'mx_UserSettings_toggle' },
	                React.createElement('input', {
	                    type: 'checkbox',
	                    id: feature.id,
	                    name: feature.id,
	                    defaultChecked: UserSettingsStore.isFeatureEnabled(feature.id),
	                    onChange: function onChange(e) {
	                        if (MatrixClientPeg.get().isGuest()) {
	                            e.target.checked = false;
	                            var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	                            Modal.createDialog(NeedToRegisterDialog, {
	                                title: "Please Register",
	                                description: "Guests can't use labs features. Please register."
	                            });
	                            return;
	                        }
	
	                        UserSettingsStore.setFeatureEnabled(feature.id, e.target.checked);
	                        _this7.forceUpdate();
	                    } }),
	                React.createElement(
	                    'label',
	                    { htmlFor: feature.id },
	                    feature.name
	                )
	            );
	        });
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Labs'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                React.createElement(
	                    'p',
	                    null,
	                    'These are experimental features that may break in unexpected ways. Use with caution.'
	                ),
	                features
	            )
	        );
	    },
	
	    _renderDeactivateAccount: function _renderDeactivateAccount() {
	        // We can't deactivate a guest account.
	        if (MatrixClientPeg.get().isGuest()) return null;
	
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Deactivate Account'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                React.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_UserSettings_button danger',
	                        onClick: this._onDeactivateAccountClicked },
	                    'Deactivate my account'
	                )
	            )
	        );
	    },
	
	    _renderClearCache: function _renderClearCache() {
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Clear Cache'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                React.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_UserSettings_button danger',
	                        onClick: this._onClearCacheClicked },
	                    'Clear Cache and Reload'
	                )
	            )
	        );
	    },
	
	    _renderBulkOptions: function _renderBulkOptions() {
	        var _this8 = this;
	
	        var invitedRooms = MatrixClientPeg.get().getRooms().filter(function (r) {
	            return r.hasMembershipState(_this8._me, "invite");
	        });
	        if (invitedRooms.length === 0) {
	            return null;
	        }
	
	        var Spinner = sdk.getComponent("elements.Spinner");
	
	        var reject = React.createElement(Spinner, null);
	        if (!this.state.rejectingInvites) {
	            // bind() the invited rooms so any new invites that may come in as this button is clicked
	            // don't inadvertently get rejected as well.
	            reject = React.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_UserSettings_button danger',
	                    onClick: this._onRejectAllInvitesClicked.bind(this, invitedRooms) },
	                'Reject all ',
	                invitedRooms.length,
	                ' invites'
	            );
	        }
	
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'h3',
	                null,
	                'Bulk Options'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_section' },
	                reject
	            )
	        );
	    },
	
	    nameForMedium: function nameForMedium(medium) {
	        if (medium == 'msisdn') return 'Phone';
	        return medium[0].toUpperCase() + medium.slice(1);
	    },
	
	    presentableTextForThreepid: function presentableTextForThreepid(threepid) {
	        if (threepid.medium == 'msisdn') {
	            return '+' + threepid.address;
	        } else {
	            return threepid.address;
	        }
	    },
	
	    render: function render() {
	        var _this9 = this;
	
	        var Loader = sdk.getComponent("elements.Spinner");
	        switch (this.state.phase) {
	            case "UserSettings.LOADING":
	                return React.createElement(Loader, null);
	            case "UserSettings.DISPLAY":
	                break; // quit the switch to return the common state
	            default:
	                throw new Error("Unknown state.phase => " + this.state.phase);
	        }
	        // can only get here if phase is UserSettings.DISPLAY
	        var SimpleRoomHeader = sdk.getComponent('rooms.SimpleRoomHeader');
	        var ChangeDisplayName = sdk.getComponent("views.settings.ChangeDisplayName");
	        var ChangePassword = sdk.getComponent("views.settings.ChangePassword");
	        var ChangeAvatar = sdk.getComponent('settings.ChangeAvatar');
	        var Notifications = sdk.getComponent("settings.Notifications");
	        var EditableText = sdk.getComponent('elements.EditableText');
	
	        var avatarUrl = this.state.avatarUrl ? MatrixClientPeg.get().mxcUrlToHttp(this.state.avatarUrl) : null;
	
	        var threepidsSection = this.state.threepids.map(function (val, pidIndex) {
	            var id = "3pid-" + val.address;
	            return React.createElement(
	                'div',
	                { className: 'mx_UserSettings_profileTableRow', key: pidIndex },
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_profileLabelCell' },
	                    React.createElement(
	                        'label',
	                        { htmlFor: id },
	                        _this9.nameForMedium(val.medium)
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_profileInputCell' },
	                    React.createElement('input', { type: 'text', key: val.address, id: id,
	                        value: _this9.presentableTextForThreepid(val), disabled: true
	                    })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_threepidButton mx_filterFlipColor' },
	                    React.createElement('img', { src: 'img/cancel-small.svg', width: '14', height: '14', alt: 'Remove', onClick: _this9.onRemoveThreepidClicked.bind(_this9, val) })
	                )
	            );
	        });
	        var addEmailSection = void 0;
	        if (this.state.email_add_pending) {
	            addEmailSection = React.createElement(Loader, { key: '_email_add_spinner' });
	        } else if (!MatrixClientPeg.get().isGuest()) {
	            addEmailSection = React.createElement(
	                'div',
	                { className: 'mx_UserSettings_profileTableRow', key: '_newEmail' },
	                React.createElement('div', { className: 'mx_UserSettings_profileLabelCell' }),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_profileInputCell' },
	                    React.createElement(EditableText, {
	                        ref: 'add_email_input',
	                        className: 'mx_UserSettings_editable',
	                        placeholderClassName: 'mx_UserSettings_threepidPlaceholder',
	                        placeholder: "Add email address",
	                        blurToCancel: false,
	                        onValueChanged: this._onAddEmailEditFinished })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_threepidButton mx_filterFlipColor' },
	                    React.createElement('img', { src: 'img/plus.svg', width: '14', height: '14', alt: 'Add', onClick: this._addEmail })
	                )
	            );
	        }
	        var AddPhoneNumber = sdk.getComponent('views.settings.AddPhoneNumber');
	        var addMsisdnSection = React.createElement(AddPhoneNumber, { key: '_addMsisdn', onThreepidAdded: this._refreshFromServer });
	        threepidsSection.push(addEmailSection);
	        threepidsSection.push(addMsisdnSection);
	
	        var accountJsx;
	
	        if (MatrixClientPeg.get().isGuest()) {
	            accountJsx = React.createElement(
	                'div',
	                { className: 'mx_UserSettings_button', onClick: this.onUpgradeClicked },
	                'Create an account'
	            );
	        } else {
	            accountJsx = React.createElement(ChangePassword, {
	                className: 'mx_UserSettings_accountTable',
	                rowClassName: 'mx_UserSettings_profileTableRow',
	                rowLabelClassName: 'mx_UserSettings_profileLabelCell',
	                rowInputClassName: 'mx_UserSettings_profileInputCell',
	                buttonClassName: 'mx_UserSettings_button mx_UserSettings_changePasswordButton',
	                onError: this.onPasswordChangeError,
	                onFinished: this.onPasswordChanged });
	        }
	        var notification_area;
	        if (!MatrixClientPeg.get().isGuest() && this.state.threepids !== undefined) {
	            notification_area = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'h3',
	                    null,
	                    'Notifications'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_section' },
	                    React.createElement(Notifications, { threepids: this.state.threepids, brand: this.props.brand })
	                )
	            );
	        }
	
	        var olmVersion = MatrixClientPeg.get().olmVersion;
	        // If the olmVersion is not defined then either crypto is disabled, or
	        // we are using a version old version of olm. We assume the former.
	        var olmVersionString = "<not-enabled>";
	        if (olmVersion !== undefined) {
	            olmVersionString = olmVersion[0] + "." + olmVersion[1] + "." + olmVersion[2];
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_UserSettings' },
	            React.createElement(SimpleRoomHeader, {
	                title: 'Settings',
	                collapsedRhs: this.props.collapsedRhs,
	                onCancelClick: this.props.onClose
	            }),
	            React.createElement(
	                GeminiScrollbar,
	                { className: 'mx_UserSettings_body',
	                    autoshow: true },
	                React.createElement(
	                    'h3',
	                    null,
	                    'Profile'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_section' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserSettings_profileTable' },
	                        React.createElement(
	                            'div',
	                            { className: 'mx_UserSettings_profileTableRow' },
	                            React.createElement(
	                                'div',
	                                { className: 'mx_UserSettings_profileLabelCell' },
	                                React.createElement(
	                                    'label',
	                                    { htmlFor: 'displayName' },
	                                    'Display name'
	                                )
	                            ),
	                            React.createElement(
	                                'div',
	                                { className: 'mx_UserSettings_profileInputCell' },
	                                React.createElement(ChangeDisplayName, null)
	                            )
	                        ),
	                        threepidsSection
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserSettings_avatarPicker' },
	                        React.createElement(
	                            'div',
	                            { onClick: this.onAvatarPickerClick },
	                            React.createElement(ChangeAvatar, { ref: 'changeAvatar', initialAvatarUrl: avatarUrl,
	                                showUploadSection: false, className: 'mx_UserSettings_avatarPicker_img' })
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'mx_UserSettings_avatarPicker_edit' },
	                            React.createElement(
	                                'label',
	                                { htmlFor: 'avatarInput', ref: 'file_label' },
	                                React.createElement('img', { src: 'img/camera.svg', className: 'mx_filterFlipColor',
	                                    alt: 'Upload avatar', title: 'Upload avatar',
	                                    width: '17', height: '15' })
	                            ),
	                            React.createElement('input', { id: 'avatarInput', type: 'file', onChange: this.onAvatarSelected })
	                        )
	                    )
	                ),
	                React.createElement(
	                    'h3',
	                    null,
	                    'Account'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_section' },
	                    React.createElement(
	                        _AccessibleButton2.default,
	                        { className: 'mx_UserSettings_logout mx_UserSettings_button', onClick: this.onLogoutClicked },
	                        'Sign out'
	                    ),
	                    accountJsx
	                ),
	                this._renderReferral(),
	                notification_area,
	                this._renderUserInterfaceSettings(),
	                this._renderLabs(),
	                this._renderDevicesPanel(),
	                this._renderCryptoInfo(),
	                this._renderBulkOptions(),
	                this._renderBugReport(),
	                React.createElement(
	                    'h3',
	                    null,
	                    'Advanced'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_section' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserSettings_advanced' },
	                        'Logged in as ',
	                        this._me
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserSettings_advanced' },
	                        'Homeserver is ',
	                        MatrixClientPeg.get().getHomeserverUrl()
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserSettings_advanced' },
	                        'Identity Server is ',
	                        MatrixClientPeg.get().getIdentityServerUrl()
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserSettings_advanced' },
	                        'matrix-react-sdk version: ',
	                        REACT_SDK_VERSION,
	                        React.createElement('br', null),
	                        'riot-web version: ',
	                        this.state.vectorVersion !== null ? this.state.vectorVersion : 'unknown',
	                        React.createElement('br', null),
	                        'olm version: ',
	                        olmVersionString,
	                        React.createElement('br', null)
	                    )
	                ),
	                this._renderClearCache(),
	                this._renderDeactivateAccount()
	            )
	        );
	    }
	});


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _defineProperty2 = __webpack_require__(179);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var Modal = __webpack_require__(10);
	var MatrixClientPeg = __webpack_require__(4);
	
	var PasswordReset = __webpack_require__(1158);
	
	module.exports = React.createClass({
	    displayName: 'ForgotPassword',
	
	    propTypes: {
	        defaultHsUrl: React.PropTypes.string,
	        defaultIsUrl: React.PropTypes.string,
	        customHsUrl: React.PropTypes.string,
	        customIsUrl: React.PropTypes.string,
	        onLoginClick: React.PropTypes.func,
	        onRegisterClick: React.PropTypes.func,
	        onComplete: React.PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            enteredHomeserverUrl: this.props.customHsUrl || this.props.defaultHsUrl,
	            enteredIdentityServerUrl: this.props.customIsUrl || this.props.defaultIsUrl,
	            progress: null
	        };
	    },
	
	    submitPasswordReset: function submitPasswordReset(hsUrl, identityUrl, email, password) {
	        var _this = this;
	
	        this.setState({
	            progress: "sending_email"
	        });
	        this.reset = new PasswordReset(hsUrl, identityUrl);
	        this.reset.resetPassword(email, password).done(function () {
	            _this.setState({
	                progress: "sent_email"
	            });
	        }, function (err) {
	            _this.showErrorDialog("Failed to send email: " + err.message);
	            _this.setState({
	                progress: null
	            });
	        });
	    },
	
	    onVerify: function onVerify(ev) {
	        var _this2 = this;
	
	        ev.preventDefault();
	        if (!this.reset) {
	            console.error("onVerify called before submitPasswordReset!");
	            return;
	        }
	        this.reset.checkEmailLinkClicked().done(function (res) {
	            _this2.setState({ progress: "complete" });
	        }, function (err) {
	            _this2.showErrorDialog(err.message);
	        });
	    },
	
	    onSubmitForm: function onSubmitForm(ev) {
	        var _this3 = this;
	
	        ev.preventDefault();
	
	        if (!this.state.email) {
	            this.showErrorDialog("The email address linked to your account must be entered.");
	        } else if (!this.state.password || !this.state.password2) {
	            this.showErrorDialog("A new password must be entered.");
	        } else if (this.state.password !== this.state.password2) {
	            this.showErrorDialog("New passwords must match each other.");
	        } else {
	            var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	            Modal.createDialog(QuestionDialog, {
	                title: "Warning",
	                description: React.createElement(
	                    'div',
	                    null,
	                    'Resetting password will currently reset any end-to-end encryption keys on all devices, making encrypted chat history unreadable, unless you first export your room keys and re-import them afterwards. In future this ',
	                    React.createElement(
	                        'a',
	                        { href: 'https://github.com/vector-im/riot-web/issues/2671' },
	                        'will be improved'
	                    ),
	                    '.'
	                ),
	                button: "Continue",
	                extraButtons: [React.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary',
	                        onClick: this._onExportE2eKeysClicked },
	                    'Export E2E room keys'
	                )],
	                onFinished: function onFinished(confirmed) {
	                    if (confirmed) {
	                        _this3.submitPasswordReset(_this3.state.enteredHomeserverUrl, _this3.state.enteredIdentityServerUrl, _this3.state.email, _this3.state.password);
	                    }
	                }
	            });
	        }
	    },
	
	    _onExportE2eKeysClicked: function _onExportE2eKeysClicked() {
	        Modal.createDialogAsync(function (cb) {
	            __webpack_require__.e/* nsure */(0, function () {
	                cb(__webpack_require__(141));
	            });
	        }, {
	            matrixClient: MatrixClientPeg.get()
	        });
	    },
	
	    onInputChanged: function onInputChanged(stateKey, ev) {
	        this.setState((0, _defineProperty3.default)({}, stateKey, ev.target.value));
	    },
	
	    onHsUrlChanged: function onHsUrlChanged(newHsUrl) {
	        this.setState({
	            enteredHomeserverUrl: newHsUrl
	        });
	    },
	
	    onIsUrlChanged: function onIsUrlChanged(newIsUrl) {
	        this.setState({
	            enteredIdentityServerUrl: newIsUrl
	        });
	    },
	
	    showErrorDialog: function showErrorDialog(body, title) {
	        var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	        Modal.createDialog(ErrorDialog, {
	            title: title,
	            description: body
	        });
	    },
	
	    render: function render() {
	        var LoginHeader = sdk.getComponent("login.LoginHeader");
	        var LoginFooter = sdk.getComponent("login.LoginFooter");
	        var ServerConfig = sdk.getComponent("login.ServerConfig");
	        var Spinner = sdk.getComponent("elements.Spinner");
	
	        var resetPasswordJsx;
	
	        if (this.state.progress === "sending_email") {
	            resetPasswordJsx = React.createElement(Spinner, null);
	        } else if (this.state.progress === "sent_email") {
	            resetPasswordJsx = React.createElement(
	                'div',
	                null,
	                'An email has been sent to ',
	                this.state.email,
	                '. Once you\'ve followed the link it contains, click below.',
	                React.createElement('br', null),
	                React.createElement('input', { className: 'mx_Login_submit', type: 'button', onClick: this.onVerify,
	                    value: 'I have verified my email address' })
	            );
	        } else if (this.state.progress === "complete") {
	            resetPasswordJsx = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'p',
	                    null,
	                    'Your password has been reset.'
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    'You have been logged out of all devices and will no longer receive push notifications. To re-enable notifications, sign in again on each device.'
	                ),
	                React.createElement('input', { className: 'mx_Login_submit', type: 'button', onClick: this.props.onComplete,
	                    value: 'Return to login screen' })
	            );
	        } else {
	            resetPasswordJsx = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'div',
	                    { className: 'mx_Login_prompt' },
	                    'To reset your password, enter the email address linked to your account:'
	                ),
	                React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'form',
	                        { onSubmit: this.onSubmitForm },
	                        React.createElement('input', { className: 'mx_Login_field', ref: 'user', type: 'text',
	                            name: 'reset_email' // define a name so browser's password autofill gets less confused
	                            , value: this.state.email,
	                            onChange: this.onInputChanged.bind(this, "email"),
	                            placeholder: 'Email address', autoFocus: true }),
	                        React.createElement('br', null),
	                        React.createElement('input', { className: 'mx_Login_field', ref: 'pass', type: 'password',
	                            name: 'reset_password',
	                            value: this.state.password,
	                            onChange: this.onInputChanged.bind(this, "password"),
	                            placeholder: 'New password' }),
	                        React.createElement('br', null),
	                        React.createElement('input', { className: 'mx_Login_field', ref: 'pass', type: 'password',
	                            name: 'reset_password_confirm',
	                            value: this.state.password2,
	                            onChange: this.onInputChanged.bind(this, "password2"),
	                            placeholder: 'Confirm your new password' }),
	                        React.createElement('br', null),
	                        React.createElement('input', { className: 'mx_Login_submit', type: 'submit', value: 'Send Reset Email' })
	                    ),
	                    React.createElement(ServerConfig, { ref: 'serverConfig',
	                        withToggleButton: true,
	                        defaultHsUrl: this.props.defaultHsUrl,
	                        defaultIsUrl: this.props.defaultIsUrl,
	                        customHsUrl: this.props.customHsUrl,
	                        customIsUrl: this.props.customIsUrl,
	                        onHsUrlChanged: this.onHsUrlChanged,
	                        onIsUrlChanged: this.onIsUrlChanged,
	                        delayTimeMs: 0 }),
	                    React.createElement('div', { className: 'mx_Login_error' }),
	                    React.createElement(
	                        'a',
	                        { className: 'mx_Login_create', onClick: this.props.onLoginClick, href: '#' },
	                        'Return to login'
	                    ),
	                    React.createElement(
	                        'a',
	                        { className: 'mx_Login_create', onClick: this.props.onRegisterClick, href: '#' },
	                        'Create a new account'
	                    ),
	                    React.createElement(LoginFooter, null)
	                )
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_Login' },
	            React.createElement(
	                'div',
	                { className: 'mx_Login_box' },
	                React.createElement(LoginHeader, null),
	                resetPasswordJsx
	            )
	        );
	    }
	});


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var sdk = __webpack_require__(2);
	var Login = __webpack_require__(1157);
	var PasswordLogin = __webpack_require__(513);
	var CasLogin = __webpack_require__(511);
	var ServerConfig = __webpack_require__(335);
	
	/**
	 * A wire component which glues together login UI components and Login logic
	 */
	module.exports = React.createClass({
	    displayName: 'Login',
	
	    propTypes: {
	        onLoggedIn: React.PropTypes.func.isRequired,
	
	        enableGuest: React.PropTypes.bool,
	
	        customHsUrl: React.PropTypes.string,
	        customIsUrl: React.PropTypes.string,
	        defaultHsUrl: React.PropTypes.string,
	        defaultIsUrl: React.PropTypes.string,
	        // Secondary HS which we try to log into if the user is using
	        // the default HS but login fails. Useful for migrating to a
	        // different home server without confusing users.
	        fallbackHsUrl: React.PropTypes.string,
	
	        defaultDeviceDisplayName: React.PropTypes.string,
	
	        // login shouldn't know or care how registration is done.
	        onRegisterClick: React.PropTypes.func.isRequired,
	
	        // login shouldn't care how password recovery is done.
	        onForgotPasswordClick: React.PropTypes.func,
	        onCancelClick: React.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            busy: false,
	            errorText: null,
	            loginIncorrect: false,
	            enteredHomeserverUrl: this.props.customHsUrl || this.props.defaultHsUrl,
	            enteredIdentityServerUrl: this.props.customIsUrl || this.props.defaultIsUrl,
	
	            // used for preserving form values when changing homeserver
	            username: "",
	            phoneCountry: null,
	            phoneNumber: ""
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this._initLoginLogic();
	    },
	
	    onPasswordLogin: function onPasswordLogin(username, phoneCountry, phoneNumber, password) {
	        var _this = this;
	
	        this.setState({
	            busy: true,
	            errorText: null,
	            loginIncorrect: false
	        });
	
	        this._loginLogic.loginViaPassword(username, phoneCountry, phoneNumber, password).then(function (data) {
	            _this.props.onLoggedIn(data);
	        }, function (error) {
	            _this._setStateFromError(error, true);
	        }).finally(function () {
	            _this.setState({
	                busy: false
	            });
	        }).done();
	    },
	
	    onCasLogin: function onCasLogin() {
	        this._loginLogic.redirectToCas();
	    },
	
	    _onLoginAsGuestClick: function _onLoginAsGuestClick() {
	        var self = this;
	        self.setState({
	            busy: true,
	            errorText: null,
	            loginIncorrect: false
	        });
	
	        this._loginLogic.loginAsGuest().then(function (data) {
	            self.props.onLoggedIn(data);
	        }, function (error) {
	            self._setStateFromError(error, true);
	        }).finally(function () {
	            self.setState({
	                busy: false
	            });
	        }).done();
	    },
	
	    onUsernameChanged: function onUsernameChanged(username) {
	        this.setState({ username: username });
	    },
	
	    onPhoneCountryChanged: function onPhoneCountryChanged(phoneCountry) {
	        this.setState({ phoneCountry: phoneCountry });
	    },
	
	    onPhoneNumberChanged: function onPhoneNumberChanged(phoneNumber) {
	        this.setState({ phoneNumber: phoneNumber });
	    },
	
	    onHsUrlChanged: function onHsUrlChanged(newHsUrl) {
	        var self = this;
	        this.setState({
	            enteredHomeserverUrl: newHsUrl,
	            errorText: null }, function () {
	            self._initLoginLogic(newHsUrl);
	        });
	    },
	
	    onIsUrlChanged: function onIsUrlChanged(newIsUrl) {
	        var self = this;
	        this.setState({
	            enteredIdentityServerUrl: newIsUrl,
	            errorText: null }, function () {
	            self._initLoginLogic(null, newIsUrl);
	        });
	    },
	
	    _initLoginLogic: function _initLoginLogic(hsUrl, isUrl) {
	        var self = this;
	        hsUrl = hsUrl || this.state.enteredHomeserverUrl;
	        isUrl = isUrl || this.state.enteredIdentityServerUrl;
	
	        var fallbackHsUrl = hsUrl == this.props.defaultHsUrl ? this.props.fallbackHsUrl : null;
	
	        var loginLogic = new Login(hsUrl, isUrl, fallbackHsUrl, {
	            defaultDeviceDisplayName: this.props.defaultDeviceDisplayName
	        });
	        this._loginLogic = loginLogic;
	
	        loginLogic.getFlows().then(function (flows) {
	            // old behaviour was to always use the first flow without presenting
	            // options. This works in most cases (we don't have a UI for multiple
	            // logins so let's skip that for now).
	            loginLogic.chooseFlow(0);
	        }, function (err) {
	            self._setStateFromError(err, false);
	        }).finally(function () {
	            self.setState({
	                busy: false
	            });
	        });
	
	        this.setState({
	            enteredHomeserverUrl: hsUrl,
	            enteredIdentityServerUrl: isUrl,
	            busy: true,
	            loginIncorrect: false
	        });
	    },
	
	    _getCurrentFlowStep: function _getCurrentFlowStep() {
	        return this._loginLogic ? this._loginLogic.getCurrentFlowStep() : null;
	    },
	
	    _setStateFromError: function _setStateFromError(err, isLoginAttempt) {
	        this.setState({
	            errorText: this._errorTextFromError(err),
	            // https://matrix.org/jira/browse/SYN-744
	            loginIncorrect: isLoginAttempt && (err.httpStatus == 401 || err.httpStatus == 403)
	        });
	    },
	
	    _errorTextFromError: function _errorTextFromError(err) {
	        if (err.friendlyText) {
	            return err.friendlyText;
	        }
	
	        var errCode = err.errcode;
	        if (!errCode && err.httpStatus) {
	            errCode = "HTTP " + err.httpStatus;
	        }
	
	        var errorText = "Error: Problem communicating with the given homeserver " + (errCode ? "(" + errCode + ")" : "");
	
	        if (err.cors === 'rejected') {
	            if (window.location.protocol === 'https:' && (this.state.enteredHomeserverUrl.startsWith("http:") || !this.state.enteredHomeserverUrl.startsWith("http"))) {
	                errorText = React.createElement(
	                    'span',
	                    null,
	                    'Can\'t connect to homeserver via HTTP when an HTTPS URL is in your browser bar. Either use HTTPS or ',
	                    React.createElement(
	                        'a',
	                        { href: 'https://www.google.com/search?&q=enable%20unsafe%20scripts' },
	                        'enable unsafe scripts'
	                    )
	                );
	            } else {
	                errorText = React.createElement(
	                    'span',
	                    null,
	                    'Can\'t connect to homeserver - please check your connectivity and ensure your ',
	                    React.createElement(
	                        'a',
	                        { href: this.state.enteredHomeserverUrl },
	                        'homeserver\'s SSL certificate'
	                    ),
	                    ' is trusted.'
	                );
	            }
	        }
	
	        return errorText;
	    },
	
	
	    componentForStep: function componentForStep(step) {
	        switch (step) {
	            case 'm.login.password':
	                return React.createElement(PasswordLogin, {
	                    onSubmit: this.onPasswordLogin,
	                    initialUsername: this.state.username,
	                    initialPhoneCountry: this.state.phoneCountry,
	                    initialPhoneNumber: this.state.phoneNumber,
	                    onUsernameChanged: this.onUsernameChanged,
	                    onPhoneCountryChanged: this.onPhoneCountryChanged,
	                    onPhoneNumberChanged: this.onPhoneNumberChanged,
	                    onForgotPasswordClick: this.props.onForgotPasswordClick,
	                    loginIncorrect: this.state.loginIncorrect
	                });
	            case 'm.login.cas':
	                return React.createElement(CasLogin, { onSubmit: this.onCasLogin });
	            default:
	                if (!step) {
	                    return;
	                }
	                return React.createElement(
	                    'div',
	                    null,
	                    'Sorry, this homeserver is using a login which is not recognised (',
	                    step,
	                    ')'
	                );
	        }
	    },
	
	    render: function render() {
	        var Loader = sdk.getComponent("elements.Spinner");
	        var LoginHeader = sdk.getComponent("login.LoginHeader");
	        var LoginFooter = sdk.getComponent("login.LoginFooter");
	        var loader = this.state.busy ? React.createElement(
	            'div',
	            { className: 'mx_Login_loader' },
	            React.createElement(Loader, null)
	        ) : null;
	
	        var loginAsGuestJsx;
	        if (this.props.enableGuest) {
	            loginAsGuestJsx = React.createElement(
	                'a',
	                { className: 'mx_Login_create', onClick: this._onLoginAsGuestClick, href: '#' },
	                'Login as guest'
	            );
	        }
	
	        var returnToAppJsx;
	        if (this.props.onCancelClick) {
	            returnToAppJsx = React.createElement(
	                'a',
	                { className: 'mx_Login_create', onClick: this.props.onCancelClick, href: '#' },
	                'Return to app'
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_Login' },
	            React.createElement(
	                'div',
	                { className: 'mx_Login_box' },
	                React.createElement(LoginHeader, null),
	                React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'h2',
	                        null,
	                        'Sign in',
	                        loader
	                    ),
	                    this.componentForStep(this._getCurrentFlowStep()),
	                    React.createElement(ServerConfig, { ref: 'serverConfig',
	                        withToggleButton: true,
	                        customHsUrl: this.props.customHsUrl,
	                        customIsUrl: this.props.customIsUrl,
	                        defaultHsUrl: this.props.defaultHsUrl,
	                        defaultIsUrl: this.props.defaultIsUrl,
	                        onHsUrlChanged: this.onHsUrlChanged,
	                        onIsUrlChanged: this.onIsUrlChanged,
	                        delayTimeMs: 1000 }),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_Login_error' },
	                        this.state.errorText
	                    ),
	                    React.createElement(
	                        'a',
	                        { className: 'mx_Login_create', onClick: this.props.onRegisterClick, href: '#' },
	                        'Create a new account'
	                    ),
	                    loginAsGuestJsx,
	                    returnToAppJsx,
	                    React.createElement(LoginFooter, null)
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	
	module.exports = React.createClass({
	    displayName: 'PostRegistration',
	
	    propTypes: {
	        onComplete: React.PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            avatarUrl: null,
	            errorString: null,
	            busy: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        // There is some assymetry between ChangeDisplayName and ChangeAvatar,
	        // as ChangeDisplayName will auto-get the name but ChangeAvatar expects
	        // the URL to be passed to you (because it's also used for room avatars).
	        var cli = MatrixClientPeg.get();
	        this.setState({ busy: true });
	        var self = this;
	        cli.getProfileInfo(cli.credentials.userId).done(function (result) {
	            self.setState({
	                avatarUrl: MatrixClientPeg.get().mxcUrlToHttp(result.avatar_url),
	                busy: false
	            });
	        }, function (error) {
	            self.setState({
	                errorString: "Failed to fetch avatar URL",
	                busy: false
	            });
	        });
	    },
	
	    render: function render() {
	        var ChangeDisplayName = sdk.getComponent('settings.ChangeDisplayName');
	        var ChangeAvatar = sdk.getComponent('settings.ChangeAvatar');
	        var LoginHeader = sdk.getComponent('login.LoginHeader');
	        return React.createElement(
	            'div',
	            { className: 'mx_Login' },
	            React.createElement(
	                'div',
	                { className: 'mx_Login_box' },
	                React.createElement(LoginHeader, null),
	                React.createElement(
	                    'div',
	                    { className: 'mx_Login_profile' },
	                    'Set a display name:',
	                    React.createElement(ChangeDisplayName, null),
	                    'Upload an avatar:',
	                    React.createElement(ChangeAvatar, {
	                        initialAvatarUrl: this.state.avatarUrl }),
	                    React.createElement(
	                        'button',
	                        { onClick: this.props.onComplete },
	                        'Continue'
	                    ),
	                    this.state.errorString
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _ServerConfig = __webpack_require__(335);
	
	var _ServerConfig2 = _interopRequireDefault(_ServerConfig);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _RegistrationForm = __webpack_require__(514);
	
	var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);
	
	var _CaptchaForm = __webpack_require__(510);
	
	var _CaptchaForm2 = _interopRequireDefault(_CaptchaForm);
	
	var _RtsClient = __webpack_require__(504);
	
	var _RtsClient2 = _interopRequireDefault(_RtsClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MIN_PASSWORD_LENGTH = 6;
	
	module.exports = _react2.default.createClass({
	    displayName: 'Registration',
	
	    propTypes: {
	        onLoggedIn: _react2.default.PropTypes.func.isRequired,
	        clientSecret: _react2.default.PropTypes.string,
	        sessionId: _react2.default.PropTypes.string,
	        makeRegistrationUrl: _react2.default.PropTypes.func.isRequired,
	        idSid: _react2.default.PropTypes.string,
	        customHsUrl: _react2.default.PropTypes.string,
	        customIsUrl: _react2.default.PropTypes.string,
	        defaultHsUrl: _react2.default.PropTypes.string,
	        defaultIsUrl: _react2.default.PropTypes.string,
	        brand: _react2.default.PropTypes.string,
	        email: _react2.default.PropTypes.string,
	        referrer: _react2.default.PropTypes.string,
	        username: _react2.default.PropTypes.string,
	        guestAccessToken: _react2.default.PropTypes.string,
	        teamServerConfig: _react2.default.PropTypes.shape({
	            // Email address to request new teams
	            supportEmail: _react2.default.PropTypes.string.isRequired,
	            // URL of the riot-team-server to get team configurations and track referrals
	            teamServerURL: _react2.default.PropTypes.string.isRequired
	        }),
	        teamSelected: _react2.default.PropTypes.object,
	
	        defaultDeviceDisplayName: _react2.default.PropTypes.string,
	
	        // registration shouldn't know or care how login is done.
	        onLoginClick: _react2.default.PropTypes.func.isRequired,
	        onCancelClick: _react2.default.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            busy: false,
	            teamServerBusy: false,
	            errorText: null,
	            // We remember the values entered by the user because
	            // the registration form will be unmounted during the
	            // course of registration, but if there's an error we
	            // want to bring back the registration form with the
	            // values the user entered still in it. We can keep
	            // them in this component's state since this component
	            // persist for the duration of the registration process.
	            formVals: {
	                email: this.props.email
	            },
	            // true if we're waiting for the user to complete
	            // user-interactive auth
	            // If we've been given a session ID, we're resuming
	            // straight back into UI auth
	            doingUIAuth: Boolean(this.props.sessionId),
	            hsUrl: this.props.customHsUrl,
	            isUrl: this.props.customIsUrl
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        this._unmounted = false;
	
	        this._replaceClient();
	
	        if (this.props.teamServerConfig && this.props.teamServerConfig.teamServerURL && !this._rtsClient) {
	            this._rtsClient = new _RtsClient2.default(this.props.teamServerConfig.teamServerURL);
	
	            this.setState({
	                teamServerBusy: true
	            });
	            // GET team configurations including domains, names and icons
	            this._rtsClient.getTeamsConfig().then(function (data) {
	                var teamsConfig = {
	                    teams: data,
	                    supportEmail: _this.props.teamServerConfig.supportEmail
	                };
	                console.log('Setting teams config to ', teamsConfig);
	                _this.setState({
	                    teamsConfig: teamsConfig,
	                    teamServerBusy: false
	                });
	            }, function (err) {
	                console.error('Error retrieving config for teams', err);
	                _this.setState({
	                    teamServerBusy: false
	                });
	            });
	        }
	    },
	
	    onHsUrlChanged: function onHsUrlChanged(newHsUrl) {
	        this.setState({
	            hsUrl: newHsUrl
	        });
	        this._replaceClient();
	    },
	
	    onIsUrlChanged: function onIsUrlChanged(newIsUrl) {
	        this.setState({
	            isUrl: newIsUrl
	        });
	        this._replaceClient();
	    },
	
	    _replaceClient: function _replaceClient() {
	        this._matrixClient = _matrixJsSdk2.default.createClient({
	            baseUrl: this.state.hsUrl,
	            idBaseUrl: this.state.isUrl
	        });
	    },
	
	    onFormSubmit: function onFormSubmit(formVals) {
	        this.setState({
	            errorText: "",
	            busy: true,
	            formVals: formVals,
	            doingUIAuth: true
	        });
	    },
	
	    _onUIAuthFinished: function _onUIAuthFinished(success, response, extra) {
	        var _this2 = this;
	
	        if (!success) {
	            var msg = response.message || response.toString();
	            // can we give a better error message?
	            if (response.required_stages && response.required_stages.indexOf('m.login.msisdn') > -1) {
	                var msisdn_available = false;
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = (0, _getIterator3.default)(response.available_flows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var flow = _step.value;
	
	                        msisdn_available |= flow.stages.indexOf('m.login.msisdn') > -1;
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                if (!msisdn_available) {
	                    msg = "This server does not support authentication with a phone number";
	                }
	            }
	            this.setState({
	                busy: false,
	                doingUIAuth: false,
	                errorText: msg
	            });
	            return;
	        }
	
	        this.setState({
	            // we're still busy until we get unmounted: don't show the registration form again
	            busy: true,
	            doingUIAuth: false
	        });
	
	        // Done regardless of `teamSelected`. People registering with non-team emails
	        // will just nop. The point of this being we might not have the email address
	        // that the user registered with at this stage (depending on whether this
	        // is the client they initiated registration).
	        var trackPromise = (0, _q2.default)(null);
	        if (this._rtsClient && extra.emailSid) {
	            // Track referral if this.props.referrer set, get team_token in order to
	            // retrieve team config and see welcome page etc.
	            trackPromise = this._rtsClient.trackReferral(this.props.referrer || '', // Default to empty string = not referred
	            extra.emailSid, extra.clientSecret).then(function (data) {
	                var teamToken = data.team_token;
	                // Store for use /w welcome pages
	                window.localStorage.setItem('mx_team_token', teamToken);
	
	                _this2._rtsClient.getTeam(teamToken).then(function (team) {
	                    console.log('User successfully registered with team ' + team.name);
	                    if (!team.rooms) {
	                        return;
	                    }
	                    // Auto-join rooms
	                    team.rooms.forEach(function (room) {
	                        if (room.auto_join && room.room_id) {
	                            console.log('Auto-joining ' + room.room_id);
	                            _MatrixClientPeg2.default.get().joinRoom(room.room_id);
	                        }
	                    });
	                }, function (err) {
	                    console.error('Error getting team config', err);
	                });
	
	                return teamToken;
	            }, function (err) {
	                console.error('Error tracking referral', err);
	            });
	        }
	
	        trackPromise.then(function (teamToken) {
	            console.info('Team token promise', teamToken);
	            _this2.props.onLoggedIn({
	                userId: response.user_id,
	                deviceId: response.device_id,
	                homeserverUrl: _this2._matrixClient.getHomeserverUrl(),
	                identityServerUrl: _this2._matrixClient.getIdentityServerUrl(),
	                accessToken: response.access_token
	            }, teamToken);
	        }).then(function () {
	            return _this2._setupPushers();
	        });
	    },
	
	    _setupPushers: function _setupPushers() {
	        var _this3 = this;
	
	        if (!this.props.brand) {
	            return (0, _q2.default)();
	        }
	        return _MatrixClientPeg2.default.get().getPushers().then(function (resp) {
	            var pushers = resp.pushers;
	            for (var i = 0; i < pushers.length; ++i) {
	                if (pushers[i].kind == 'email') {
	                    var emailPusher = pushers[i];
	                    emailPusher.data = { brand: _this3.props.brand };
	                    _MatrixClientPeg2.default.get().setPusher(emailPusher).done(function () {
	                        console.log("Set email branding to " + _this3.props.brand);
	                    }, function (error) {
	                        console.error("Couldn't set email branding: " + error);
	                    });
	                }
	            }
	        }, function (error) {
	            console.error("Couldn't get pushers: " + error);
	        });
	    },
	
	    onFormValidationFailed: function onFormValidationFailed(errCode) {
	        var errMsg;
	        switch (errCode) {
	            case "RegistrationForm.ERR_PASSWORD_MISSING":
	                errMsg = "Missing password.";
	                break;
	            case "RegistrationForm.ERR_PASSWORD_MISMATCH":
	                errMsg = "Passwords don't match.";
	                break;
	            case "RegistrationForm.ERR_PASSWORD_LENGTH":
	                errMsg = 'Password too short (min ' + MIN_PASSWORD_LENGTH + ').';
	                break;
	            case "RegistrationForm.ERR_EMAIL_INVALID":
	                errMsg = "This doesn't look like a valid email address";
	                break;
	            case "RegistrationForm.ERR_PHONE_NUMBER_INVALID":
	                errMsg = "This doesn't look like a valid phone number";
	                break;
	            case "RegistrationForm.ERR_USERNAME_INVALID":
	                errMsg = "User names may only contain letters, numbers, dots, hyphens and underscores.";
	                break;
	            case "RegistrationForm.ERR_USERNAME_BLANK":
	                errMsg = "You need to enter a user name";
	                break;
	            default:
	                console.error("Unknown error code: %s", errCode);
	                errMsg = "An unknown error occurred.";
	                break;
	        }
	        this.setState({
	            errorText: errMsg
	        });
	    },
	
	    onTeamSelected: function onTeamSelected(teamSelected) {
	        if (!this._unmounted) {
	            this.setState({ teamSelected: teamSelected });
	        }
	    },
	
	    _makeRegisterRequest: function _makeRegisterRequest(auth) {
	        var guestAccessToken = this.props.guestAccessToken;
	
	        if (this.state.formVals.username !== this.props.username || this.state.hsUrl != this.props.defaultHsUrl) {
	            // don't try to upgrade if we changed our username
	            // or are registering on a different HS
	            guestAccessToken = null;
	        }
	
	        // Only send the bind params if we're sending username / pw params
	        // (Since we need to send no params at all to use the ones saved in the
	        // session).
	        var bindThreepids = this.state.formVals.password ? {
	            email: true,
	            msisdn: true
	        } : {};
	
	        return this._matrixClient.register(this.state.formVals.username, this.state.formVals.password, undefined, // session id: included in the auth dict already
	        auth, bindThreepids, guestAccessToken);
	    },
	
	    _getUIAuthInputs: function _getUIAuthInputs() {
	        return {
	            emailAddress: this.state.formVals.email,
	            phoneCountry: this.state.formVals.phoneCountry,
	            phoneNumber: this.state.formVals.phoneNumber
	        };
	    },
	
	    render: function render() {
	        var LoginHeader = _index2.default.getComponent('login.LoginHeader');
	        var LoginFooter = _index2.default.getComponent('login.LoginFooter');
	        var InteractiveAuth = _index2.default.getComponent('structures.InteractiveAuth');
	        var Spinner = _index2.default.getComponent("elements.Spinner");
	        var ServerConfig = _index2.default.getComponent('views.login.ServerConfig');
	
	        var registerBody = void 0;
	        if (this.state.doingUIAuth) {
	            registerBody = _react2.default.createElement(InteractiveAuth, {
	                matrixClient: this._matrixClient,
	                makeRequest: this._makeRegisterRequest,
	                onAuthFinished: this._onUIAuthFinished,
	                inputs: this._getUIAuthInputs(),
	                makeRegistrationUrl: this.props.makeRegistrationUrl,
	                sessionId: this.props.sessionId,
	                clientSecret: this.props.clientSecret,
	                emailSid: this.props.idSid,
	                poll: true
	            });
	        } else if (this.state.busy || this.state.teamServerBusy) {
	            registerBody = _react2.default.createElement(Spinner, null);
	        } else {
	            var guestUsername = this.props.username;
	            if (this.state.hsUrl != this.props.defaultHsUrl) {
	                guestUsername = null;
	            }
	            var errorSection = void 0;
	            if (this.state.errorText) {
	                errorSection = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Login_error' },
	                    this.state.errorText
	                );
	            }
	            registerBody = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_RegistrationForm2.default, {
	                    defaultUsername: this.state.formVals.username,
	                    defaultEmail: this.state.formVals.email,
	                    defaultPhoneCountry: this.state.formVals.phoneCountry,
	                    defaultPhoneNumber: this.state.formVals.phoneNumber,
	                    defaultPassword: this.state.formVals.password,
	                    teamsConfig: this.state.teamsConfig,
	                    guestUsername: guestUsername,
	                    minPasswordLength: MIN_PASSWORD_LENGTH,
	                    onError: this.onFormValidationFailed,
	                    onRegisterClick: this.onFormSubmit,
	                    onTeamSelected: this.onTeamSelected
	                }),
	                errorSection,
	                _react2.default.createElement(ServerConfig, { ref: 'serverConfig',
	                    withToggleButton: true,
	                    customHsUrl: this.props.customHsUrl,
	                    customIsUrl: this.props.customIsUrl,
	                    defaultHsUrl: this.props.defaultHsUrl,
	                    defaultIsUrl: this.props.defaultIsUrl,
	                    onHsUrlChanged: this.onHsUrlChanged,
	                    onIsUrlChanged: this.onIsUrlChanged,
	                    delayTimeMs: 1000
	                })
	            );
	        }
	
	        var returnToAppJsx = void 0;
	        if (this.props.onCancelClick) {
	            returnToAppJsx = _react2.default.createElement(
	                'a',
	                { className: 'mx_Login_create', onClick: this.props.onCancelClick, href: '#' },
	                'Return to app'
	            );
	        }
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_Login' },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Login_box' },
	                _react2.default.createElement(LoginHeader, {
	                    icon: this.state.teamSelected ? this.props.teamServerConfig.teamServerURL + "/static/common/" + this.state.teamSelected.domain + "/icon.png" : null
	                }),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Create an account'
	                ),
	                registerBody,
	                _react2.default.createElement(
	                    'a',
	                    { className: 'mx_Login_create', onClick: this.props.onLoginClick, href: '#' },
	                    'I already have an account'
	                ),
	                returnToAppJsx,
	                _react2.default.createElement(LoginFooter, null)
	            )
	        );
	    }
	});


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(96);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var AvatarLogic = __webpack_require__(138);
	
	
	module.exports = React.createClass({
	    displayName: 'BaseAvatar',
	
	    propTypes: {
	        name: React.PropTypes.string.isRequired, // The name (first initial used as default)
	        idName: React.PropTypes.string, // ID for generating hash colours
	        title: React.PropTypes.string, // onHover title text
	        url: React.PropTypes.string, // highest priority of them all, shortcut to set in urls[0]
	        urls: React.PropTypes.array, // [highest_priority, ... , lowest_priority]
	        width: React.PropTypes.number,
	        height: React.PropTypes.number,
	        resizeMethod: React.PropTypes.string,
	        defaultToInitialLetter: React.PropTypes.bool // true to add default url
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            width: 40,
	            height: 40,
	            resizeMethod: 'crop',
	            defaultToInitialLetter: true
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return this._getState(this.props);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        // work out if we need to call setState (if the image URLs array has changed)
	        var newState = this._getState(nextProps);
	        var newImageUrls = newState.imageUrls;
	        var oldImageUrls = this.state.imageUrls;
	        if (newImageUrls.length !== oldImageUrls.length) {
	            this.setState(newState); // detected a new entry
	        } else {
	            // check each one to see if they are the same
	            for (var i = 0; i < newImageUrls.length; i++) {
	                if (oldImageUrls[i] !== newImageUrls[i]) {
	                    this.setState(newState); // detected a diff
	                    break;
	                }
	            }
	        }
	    },
	
	    _getState: function _getState(props) {
	        // work out the full set of urls to try to load. This is formed like so:
	        // imageUrls: [ props.url, props.urls, default image ]
	
	        var urls = props.urls || [];
	        if (props.url) {
	            urls.unshift(props.url); // put in urls[0]
	        }
	
	        var defaultImageUrl = null;
	        if (props.defaultToInitialLetter) {
	            defaultImageUrl = AvatarLogic.defaultAvatarUrlForString(props.idName || props.name);
	            urls.push(defaultImageUrl); // lowest priority
	        }
	        return {
	            imageUrls: urls,
	            defaultImageUrl: defaultImageUrl,
	            urlsIndex: 0
	        };
	    },
	
	    onError: function onError(ev) {
	        var nextIndex = this.state.urlsIndex + 1;
	        if (nextIndex < this.state.imageUrls.length) {
	            // try the next one
	            this.setState({
	                urlsIndex: nextIndex
	            });
	        }
	    },
	
	    /**
	     * returns the first (non-sigil) character of 'name',
	     * converted to uppercase
	     */
	    _getInitialLetter: function _getInitialLetter(name) {
	        if (name.length < 1) {
	            return undefined;
	        }
	
	        var idx = 0;
	        var initial = name[0];
	        if ((initial === '@' || initial === '#') && name[1]) {
	            idx++;
	        }
	
	        // string.codePointAt(0) would do this, but that isn't supported by
	        // some browsers (notably PhantomJS).
	        var chars = 1;
	        var first = name.charCodeAt(idx);
	
	        // check if it’s the start of a surrogate pair
	        if (first >= 0xD800 && first <= 0xDBFF && name[idx + 1]) {
	            var second = name.charCodeAt(idx + 1);
	            if (second >= 0xDC00 && second <= 0xDFFF) {
	                chars++;
	            }
	        }
	
	        var firstChar = name.substring(idx, idx + chars);
	        return firstChar.toUpperCase();
	    },
	
	    render: function render() {
	        var EmojiText = _index2.default.getComponent('elements.EmojiText');
	        var imageUrl = this.state.imageUrls[this.state.urlsIndex];
	
	        var _props = this.props,
	            name = _props.name,
	            idName = _props.idName,
	            title = _props.title,
	            url = _props.url,
	            urls = _props.urls,
	            width = _props.width,
	            height = _props.height,
	            resizeMethod = _props.resizeMethod,
	            defaultToInitialLetter = _props.defaultToInitialLetter,
	            onClick = _props.onClick,
	            otherProps = (0, _objectWithoutProperties3.default)(_props, ['name', 'idName', 'title', 'url', 'urls', 'width', 'height', 'resizeMethod', 'defaultToInitialLetter', 'onClick']);
	
	
	        if (imageUrl === this.state.defaultImageUrl) {
	            var initialLetter = this._getInitialLetter(name);
	            var textNode = React.createElement(
	                EmojiText,
	                { className: 'mx_BaseAvatar_initial', 'aria-hidden': 'true',
	                    style: { fontSize: width * 0.65 + "px",
	                        width: width + "px",
	                        lineHeight: height + "px" }
	                },
	                initialLetter
	            );
	            var imgNode = React.createElement('img', { className: 'mx_BaseAvatar_image', src: imageUrl,
	                alt: '', title: title, onError: this.onError,
	                width: width, height: height });
	            if (onClick != null) {
	                return React.createElement(
	                    _AccessibleButton2.default,
	                    (0, _extends3.default)({ element: 'span', className: 'mx_BaseAvatar',
	                        onClick: onClick }, otherProps),
	                    textNode,
	                    imgNode
	                );
	            } else {
	                return React.createElement(
	                    'span',
	                    (0, _extends3.default)({ className: 'mx_BaseAvatar' }, otherProps),
	                    textNode,
	                    imgNode
	                );
	            }
	        }
	        if (onClick != null) {
	            return React.createElement(_AccessibleButton2.default, (0, _extends3.default)({ className: 'mx_BaseAvatar mx_BaseAvatar_image',
	                element: 'img',
	                src: imageUrl,
	                onClick: onClick,
	                onError: this.onError,
	                width: width, height: height,
	                title: title, alt: ''
	            }, otherProps));
	        } else {
	            return React.createElement('img', (0, _extends3.default)({ className: 'mx_BaseAvatar mx_BaseAvatar_image', src: imageUrl,
	                onError: this.onError,
	                width: width, height: height,
	                title: title, alt: ''
	            }, otherProps));
	        }
	    }
	});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(96);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	var ContentRepo = __webpack_require__(28).ContentRepo;
	var MatrixClientPeg = __webpack_require__(4);
	var Avatar = __webpack_require__(138);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'RoomAvatar',
	
	    // Room may be left unset here, but if it is,
	    // oobData.avatarUrl should be set (else there
	    // would be nowhere to get the avatar from)
	    propTypes: {
	        room: React.PropTypes.object,
	        oobData: React.PropTypes.object,
	        width: React.PropTypes.number,
	        height: React.PropTypes.number,
	        resizeMethod: React.PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            width: 36,
	            height: 36,
	            resizeMethod: 'crop',
	            oobData: {}
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            urls: this.getImageUrls(this.props)
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        this.setState({
	            urls: this.getImageUrls(newProps)
	        });
	    },
	
	    getImageUrls: function getImageUrls(props) {
	        return [ContentRepo.getHttpUriForMxc(MatrixClientPeg.get().getHomeserverUrl(), props.oobData.avatarUrl, props.width, props.height, props.resizeMethod), // highest priority
	        this.getRoomAvatarUrl(props), this.getOneToOneAvatar(props), this.getFallbackAvatar(props) // lowest priority
	        ].filter(function (url) {
	            return url != null && url != "";
	        });
	    },
	
	    getRoomAvatarUrl: function getRoomAvatarUrl(props) {
	        if (!this.props.room) return null;
	
	        return props.room.getAvatarUrl(MatrixClientPeg.get().getHomeserverUrl(), props.width, props.height, props.resizeMethod, false);
	    },
	
	    getOneToOneAvatar: function getOneToOneAvatar(props) {
	        if (!this.props.room) return null;
	
	        var mlist = props.room.currentState.members;
	        var userIds = [];
	        // for .. in optimisation to return early if there are >2 keys
	        for (var uid in mlist) {
	            if (mlist.hasOwnProperty(uid)) {
	                userIds.push(uid);
	            }
	            if (userIds.length > 2) {
	                return null;
	            }
	        }
	
	        if (userIds.length == 2) {
	            var theOtherGuy = null;
	            if (mlist[userIds[0]].userId == MatrixClientPeg.get().credentials.userId) {
	                theOtherGuy = mlist[userIds[1]];
	            } else {
	                theOtherGuy = mlist[userIds[0]];
	            }
	            return theOtherGuy.getAvatarUrl(MatrixClientPeg.get().getHomeserverUrl(), props.width, props.height, props.resizeMethod, false);
	        } else if (userIds.length == 1) {
	            return mlist[userIds[0]].getAvatarUrl(MatrixClientPeg.get().getHomeserverUrl(), props.width, props.height, props.resizeMethod, false);
	        } else {
	            return null;
	        }
	    },
	
	    getFallbackAvatar: function getFallbackAvatar(props) {
	        if (!this.props.room) return null;
	
	        return Avatar.defaultAvatarUrlForString(props.room.roomId);
	    },
	
	    render: function render() {
	        var BaseAvatar = sdk.getComponent("avatars.BaseAvatar");
	
	        var _props = this.props,
	            room = _props.room,
	            oobData = _props.oobData,
	            otherProps = (0, _objectWithoutProperties3.default)(_props, ['room', 'oobData']);
	
	
	        var roomName = room ? room.name : oobData.name;
	
	        return React.createElement(BaseAvatar, (0, _extends3.default)({}, otherProps, { name: roomName,
	            idName: room ? room.roomId : null,
	            urls: this.state.urls }));
	    }
	});


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'CreateRoomButton',
	    propTypes: {
	        onCreateRoom: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onCreateRoom: function onCreateRoom() {}
	        };
	    },
	
	    onClick: function onClick() {
	        this.props.onCreateRoom();
	    },
	
	    render: function render() {
	        return React.createElement(
	            'button',
	            { className: 'mx_CreateRoomButton', onClick: this.onClick },
	            'Create Room'
	        );
	    }
	});


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var Presets = {
	    PrivateChat: "private_chat",
	    PublicChat: "public_chat",
	    Custom: "custom"
	};
	
	module.exports = React.createClass({
	    displayName: 'CreateRoomPresets',
	    propTypes: {
	        onChange: React.PropTypes.func,
	        preset: React.PropTypes.string
	    },
	
	    Presets: Presets,
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onChange: function onChange() {}
	        };
	    },
	
	    onValueChanged: function onValueChanged(ev) {
	        this.props.onChange(ev.target.value);
	    },
	
	    render: function render() {
	        return React.createElement(
	            'select',
	            { className: 'mx_Presets', onChange: this.onValueChanged, value: this.props.preset },
	            React.createElement(
	                'option',
	                { value: this.Presets.PrivateChat },
	                'Private Chat'
	            ),
	            React.createElement(
	                'option',
	                { value: this.Presets.PublicChat },
	                'Public Chat'
	            ),
	            React.createElement(
	                'option',
	                { value: this.Presets.Custom },
	                'Custom'
	            )
	        );
	    }
	});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'RoomAlias',
	    propTypes: {
	        // Specifying a homeserver will make magical things happen when you,
	        // e.g. start typing in the room alias box.
	        homeserver: React.PropTypes.string,
	        alias: React.PropTypes.string,
	        onChange: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onChange: function onChange() {},
	            alias: ''
	        };
	    },
	
	    getAliasLocalpart: function getAliasLocalpart() {
	        var room_alias = this.props.alias;
	
	        if (room_alias && this.props.homeserver) {
	            var suffix = ":" + this.props.homeserver;
	            if (room_alias.startsWith("#") && room_alias.endsWith(suffix)) {
	                room_alias = room_alias.slice(1, -suffix.length);
	            }
	        }
	
	        return room_alias;
	    },
	
	    onValueChanged: function onValueChanged(ev) {
	        this.props.onChange(ev.target.value);
	    },
	
	    onFocus: function onFocus(ev) {
	        var target = ev.target;
	        var curr_val = ev.target.value;
	
	        if (this.props.homeserver) {
	            if (curr_val == "") {
	                var self = this;
	                setTimeout(function () {
	                    target.value = "#:" + self.props.homeserver;
	                    target.setSelectionRange(1, 1);
	                }, 0);
	            } else {
	                var suffix = ":" + this.props.homeserver;
	                setTimeout(function () {
	                    target.setSelectionRange(curr_val.startsWith("#") ? 1 : 0, curr_val.endsWith(suffix) ? target.value.length - suffix.length : target.value.length);
	                }, 0);
	            }
	        }
	    },
	
	    onBlur: function onBlur(ev) {
	        var curr_val = ev.target.value;
	
	        if (this.props.homeserver) {
	            if (curr_val == "#:" + this.props.homeserver) {
	                ev.target.value = "";
	                return;
	            }
	
	            if (curr_val != "") {
	                var new_val = ev.target.value;
	                var suffix = ":" + this.props.homeserver;
	                if (!curr_val.startsWith("#")) new_val = "#" + new_val;
	                if (!curr_val.endsWith(suffix)) new_val = new_val + suffix;
	                ev.target.value = new_val;
	            }
	        }
	    },
	
	    render: function render() {
	        return React.createElement('input', { type: 'text', className: 'mx_RoomAlias', placeholder: 'Alias (optional)',
	            onChange: this.onValueChanged, onFocus: this.onFocus, onBlur: this.onBlur,
	            value: this.props.alias });
	    }
	});


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KeyCode = __webpack_require__(116);
	
	var KeyCode = _interopRequireWildcard(_KeyCode);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Basic container for modal dialogs.
	 *
	 * Includes a div for the title, and a keypress handler which cancels the
	 * dialog on escape.
	 */
	/*
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = _react2.default.createClass({
	    displayName: 'BaseDialog',
	
	    propTypes: {
	        // onFinished callback to call when Escape is pressed
	        onFinished: _react2.default.PropTypes.func.isRequired,
	
	        // callback to call when Enter is pressed
	        onEnterPressed: _react2.default.PropTypes.func,
	
	        // CSS class to apply to dialog div
	        className: _react2.default.PropTypes.string,
	
	        // Title for the dialog.
	        // (could probably actually be something more complicated than a string if desired)
	        title: _react2.default.PropTypes.string.isRequired,
	
	        // children should be the content of the dialog
	        children: _react2.default.PropTypes.node
	    },
	
	    _onKeyDown: function _onKeyDown(e) {
	        if (e.keyCode === KeyCode.ESCAPE) {
	            e.stopPropagation();
	            e.preventDefault();
	            this.props.onFinished();
	        } else if (e.keyCode === KeyCode.ENTER) {
	            if (this.props.onEnterPressed) {
	                e.stopPropagation();
	                e.preventDefault();
	                this.props.onEnterPressed(e);
	            }
	        }
	    },
	
	    _onCancelClick: function _onCancelClick(e) {
	        this.props.onFinished();
	    },
	
	    render: function render() {
	        var TintableSvg = _index2.default.getComponent("elements.TintableSvg");
	
	        return _react2.default.createElement(
	            'div',
	            { onKeyDown: this._onKeyDown, className: this.props.className },
	            _react2.default.createElement(
	                _AccessibleButton2.default,
	                { onClick: this._onCancelClick,
	                    className: 'mx_Dialog_cancelButton'
	                },
	                _react2.default.createElement(TintableSvg, { src: 'img/icons-close-button.svg', width: '35', height: '35' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_title' },
	                this.props.title
	            ),
	            this.props.children
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	var _Unread = __webpack_require__(221);
	
	var _Unread2 = _interopRequireDefault(_Unread);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createRoom = __webpack_require__(224);
	
	var _createRoom2 = _interopRequireDefault(_createRoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatCreateOrReuseDialog = function (_React$Component) {
	    (0, _inherits3.default)(ChatCreateOrReuseDialog, _React$Component);
	
	    function ChatCreateOrReuseDialog(props) {
	        (0, _classCallCheck3.default)(this, ChatCreateOrReuseDialog);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ChatCreateOrReuseDialog.__proto__ || (0, _getPrototypeOf2.default)(ChatCreateOrReuseDialog)).call(this, props));
	
	        _this.onNewDMClick = _this.onNewDMClick.bind(_this);
	        _this.onRoomTileClick = _this.onRoomTileClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(ChatCreateOrReuseDialog, [{
	        key: 'onNewDMClick',
	        value: function onNewDMClick() {
	            (0, _createRoom2.default)({ dmUserId: this.props.userId });
	            this.props.onFinished(true);
	        }
	    }, {
	        key: 'onRoomTileClick',
	        value: function onRoomTileClick(roomId) {
	            _dispatcher2.default.dispatch({
	                action: 'view_room',
	                room_id: roomId
	            });
	            this.props.onFinished(true);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var client = _MatrixClientPeg2.default.get();
	
	            var dmRoomMap = new _DMRoomMap2.default(client);
	            var dmRooms = dmRoomMap.getDMRoomsForUserId(this.props.userId);
	
	            var RoomTile = _index2.default.getComponent("rooms.RoomTile");
	
	            var tiles = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(dmRooms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var roomId = _step.value;
	
	                    var room = client.getRoom(roomId);
	                    if (room) {
	                        var me = room.getMember(client.credentials.userId);
	                        var highlight = room.getUnreadNotificationCount('highlight') > 0 || me.membership == "invite";
	                        tiles.push(_react2.default.createElement(RoomTile, { key: room.roomId, room: room,
	                            collapsed: false,
	                            selected: false,
	                            unread: _Unread2.default.doesRoomHaveUnreadMessages(room),
	                            highlight: highlight,
	                            isInvite: me.membership == "invite",
	                            onClick: this.onRoomTileClick
	                        }));
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var labelClasses = (0, _classnames2.default)({
	                mx_MemberInfo_createRoom_label: true,
	                mx_RoomTile_name: true
	            });
	            var startNewChat = _react2.default.createElement(
	                _AccessibleButton2.default,
	                {
	                    className: 'mx_MemberInfo_createRoom',
	                    onClick: this.onNewDMClick
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomTile_avatar' },
	                    _react2.default.createElement('img', { src: 'img/create-big.svg', width: '26', height: '26' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: labelClasses },
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        'Start new chat'
	                    )
	                )
	            );
	
	            var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	            return _react2.default.createElement(
	                BaseDialog,
	                { className: 'mx_ChatCreateOrReuseDialog',
	                    onFinished: function onFinished() {
	                        _this2.props.onFinished(false);
	                    },
	                    title: 'Create a new chat or reuse an existing one'
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_content' },
	                    'You already have existing direct chats with this user:',
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_ChatCreateOrReuseDialog_tiles' },
	                        tiles,
	                        startNewChat
	                    )
	                )
	            );
	        }
	    }]);
	    return ChatCreateOrReuseDialog;
	}(_react2.default.Component); /*
	                              Copyright 2017 Vector Creations Ltd
	                              
	                              Licensed under the Apache License, Version 2.0 (the "License");
	                              you may not use this file except in compliance with the License.
	                              You may obtain a copy of the License at
	                              
	                                  http://www.apache.org/licenses/LICENSE-2.0
	                              
	                              Unless required by applicable law or agreed to in writing, software
	                              distributed under the License is distributed on an "AS IS" BASIS,
	                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                              See the License for the specific language governing permissions and
	                              limitations under the License.
	                              */
	
	exports.default = ChatCreateOrReuseDialog;
	
	
	ChatCreateOrReuseDialog.propTyps = {
	    userId: _react2.default.PropTypes.string.isRequired,
	    onFinished: _react2.default.PropTypes.func.isRequired
	};
	module.exports = exports['default'];


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Invite = __webpack_require__(220);
	
	var _createRoom = __webpack_require__(224);
	
	var _createRoom2 = _interopRequireDefault(_createRoom);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	var _ratelimitedfunc = __webpack_require__(119);
	
	var _ratelimitedfunc2 = _interopRequireDefault(_ratelimitedfunc);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _fuse = __webpack_require__(165);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRUNCATE_QUERY_LIST = 40; /*
	                              Copyright 2015, 2016 OpenMarket Ltd
	                              
	                              Licensed under the Apache License, Version 2.0 (the "License");
	                              you may not use this file except in compliance with the License.
	                              You may obtain a copy of the License at
	                              
	                                  http://www.apache.org/licenses/LICENSE-2.0
	                              
	                              Unless required by applicable law or agreed to in writing, software
	                              distributed under the License is distributed on an "AS IS" BASIS,
	                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                              See the License for the specific language governing permissions and
	                              limitations under the License.
	                              */
	
	module.exports = _react2.default.createClass({
	    displayName: "ChatInviteDialog",
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        description: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string]),
	        value: _react2.default.PropTypes.string,
	        placeholder: _react2.default.PropTypes.string,
	        roomId: _react2.default.PropTypes.string,
	        button: _react2.default.PropTypes.string,
	        focus: _react2.default.PropTypes.bool,
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            title: "Start a chat",
	            description: "Who would you like to communicate with?",
	            value: "",
	            placeholder: "Email, name or matrix ID",
	            button: "Start Chat",
	            focus: true
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            error: false,
	
	            // List of AddressTile.InviteAddressType objects represeting
	            // the list of addresses we're going to invite
	            inviteList: [],
	
	            // List of AddressTile.InviteAddressType objects represeting
	            // the set of autocompletion results for the current search
	            // query.
	            queryList: []
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.props.focus) {
	            // Set the cursor at the end of the text input
	            this.refs.textinput.value = this.props.value;
	        }
	        // Create a Fuse instance for fuzzy searching this._userList
	        this._fuse = new _fuse2.default(
	        // Use an empty list at first that will later be populated
	        // (see this._updateUserList)
	        [], {
	            shouldSort: true,
	            location: 0, // The index of the query in the test string
	            distance: 5, // The distance away from location the query can be
	            // 0.0 = exact match, 1.0 = match anything
	            threshold: 0.3
	        });
	        this._updateUserList();
	    },
	
	    onButtonClick: function onButtonClick() {
	        var _this = this;
	
	        var inviteList = this.state.inviteList.slice();
	        // Check the text input field to see if user has an unconverted address
	        // If there is and it's valid add it to the local inviteList
	        if (this.refs.textinput.value !== '') {
	            inviteList = this._addInputToList();
	            if (inviteList === null) return;
	        }
	
	        var addrTexts = inviteList.map(function (addr) {
	            return addr.address;
	        });
	        if (inviteList.length > 0) {
	            if (this._isDmChat(addrTexts)) {
	                var userId = inviteList[0].address;
	                // Direct Message chat
	                var rooms = this._getDirectMessageRooms(userId);
	                if (rooms.length > 0) {
	                    // A Direct Message room already exists for this user, so select a
	                    // room from a list that is similar to the one in MemberInfo panel
	                    var ChatCreateOrReuseDialog = _index2.default.getComponent("views.dialogs.ChatCreateOrReuseDialog");
	                    _Modal2.default.createDialog(ChatCreateOrReuseDialog, {
	                        userId: userId,
	                        onFinished: function onFinished(success) {
	                            if (success) {
	                                _this.props.onFinished(true, inviteList[0]);
	                            }
	                            // else show this ChatInviteDialog again
	                        }
	                    });
	                } else {
	                    this._startChat(inviteList);
	                }
	            } else {
	                // Multi invite chat
	                this._startChat(inviteList);
	            }
	        } else {
	            // No addresses supplied
	            this.setState({ error: true });
	        }
	    },
	
	    onCancel: function onCancel() {
	        this.props.onFinished(false);
	    },
	
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode === 27) {
	            // escape
	            e.stopPropagation();
	            e.preventDefault();
	            this.props.onFinished(false);
	        } else if (e.keyCode === 38) {
	            // up arrow
	            e.stopPropagation();
	            e.preventDefault();
	            this.addressSelector.moveSelectionUp();
	        } else if (e.keyCode === 40) {
	            // down arrow
	            e.stopPropagation();
	            e.preventDefault();
	            this.addressSelector.moveSelectionDown();
	        } else if (this.state.queryList.length > 0 && (e.keyCode === 188 || e.keyCode === 13 || e.keyCode === 9)) {
	            // comma or enter or tab
	            e.stopPropagation();
	            e.preventDefault();
	            this.addressSelector.chooseSelection();
	        } else if (this.refs.textinput.value.length === 0 && this.state.inviteList.length && e.keyCode === 8) {
	            // backspace
	            e.stopPropagation();
	            e.preventDefault();
	            this.onDismissed(this.state.inviteList.length - 1)();
	        } else if (e.keyCode === 13) {
	            // enter
	            e.stopPropagation();
	            e.preventDefault();
	            if (this.refs.textinput.value == '') {
	                // if there's nothing in the input box, submit the form
	                this.onButtonClick();
	            } else {
	                this._addInputToList();
	            }
	        } else if (e.keyCode === 188 || e.keyCode === 9) {
	            // comma or tab
	            e.stopPropagation();
	            e.preventDefault();
	            this._addInputToList();
	        }
	    },
	
	    onQueryChanged: function onQueryChanged(ev) {
	        var _this2 = this;
	
	        var query = ev.target.value;
	        var queryList = [];
	
	        if (query.length < 2) {
	            return;
	        }
	
	        if (this.queryChangedDebouncer) {
	            clearTimeout(this.queryChangedDebouncer);
	        }
	        this.queryChangedDebouncer = setTimeout(function () {
	            // Only do search if there is something to search
	            if (query.length > 0 && query != '@') {
	                // Weighted keys prefer to match userIds when first char is @
	                _this2._fuse.options.keys = [{
	                    name: 'displayName',
	                    weight: query[0] === '@' ? 0.1 : 0.9
	                }, {
	                    name: 'userId',
	                    weight: query[0] === '@' ? 0.9 : 0.1
	                }];
	                queryList = _this2._fuse.search(query).map(function (user) {
	                    // Return objects, structure of which is defined
	                    // by InviteAddressType
	                    return {
	                        addressType: 'mx',
	                        address: user.userId,
	                        displayName: user.displayName,
	                        avatarMxc: user.avatarUrl,
	                        isKnown: true
	                    };
	                });
	
	                // If the query is a valid address, add an entry for that
	                // This is important, otherwise there's no way to invite
	                // a perfectly valid address if there are close matches.
	                var addrType = (0, _Invite.getAddressType)(query);
	                if (addrType !== null) {
	                    queryList.unshift({
	                        addressType: addrType,
	                        address: query,
	                        isKnown: false
	                    });
	                    if (_this2._cancelThreepidLookup) _this2._cancelThreepidLookup();
	                    if (addrType == 'email') {
	                        _this2._lookupThreepid(addrType, query).done();
	                    }
	                }
	            }
	            _this2.setState({
	                queryList: queryList,
	                error: false
	            }, function () {
	                _this2.addressSelector.moveSelectionTop();
	            });
	        }, 200);
	    },
	
	    onDismissed: function onDismissed(index) {
	        var self = this;
	        return function () {
	            var inviteList = self.state.inviteList.slice();
	            inviteList.splice(index, 1);
	            self.setState({
	                inviteList: inviteList,
	                queryList: []
	            });
	            if (this._cancelThreepidLookup) this._cancelThreepidLookup();
	        };
	    },
	
	    onClick: function onClick(index) {
	        var self = this;
	        return function () {
	            self.onSelected(index);
	        };
	    },
	
	    onSelected: function onSelected(index) {
	        var inviteList = this.state.inviteList.slice();
	        inviteList.push(this.state.queryList[index]);
	        this.setState({
	            inviteList: inviteList,
	            queryList: []
	        });
	        if (this._cancelThreepidLookup) this._cancelThreepidLookup();
	    },
	
	    _getDirectMessageRooms: function _getDirectMessageRooms(addr) {
	        var dmRoomMap = new _DMRoomMap2.default(_MatrixClientPeg2.default.get());
	        var dmRooms = dmRoomMap.getDMRoomsForUserId(addr);
	        var rooms = [];
	        dmRooms.forEach(function (dmRoom) {
	            var room = _MatrixClientPeg2.default.get().getRoom(dmRoom);
	            if (room) {
	                var me = room.getMember(_MatrixClientPeg2.default.get().credentials.userId);
	                if (me.membership == 'join') {
	                    rooms.push(room);
	                }
	            }
	        });
	        return rooms;
	    },
	
	    _startChat: function _startChat(addrs) {
	        if (_MatrixClientPeg2.default.get().isGuest()) {
	            var NeedToRegisterDialog = _index2.default.getComponent("dialogs.NeedToRegisterDialog");
	            _Modal2.default.createDialog(NeedToRegisterDialog, {
	                title: "Please Register",
	                description: "Guest users can't invite users. Please register."
	            });
	            return;
	        }
	
	        var addrTexts = addrs.map(function (addr) {
	            return addr.address;
	        });
	
	        if (this.props.roomId) {
	            // Invite new user to a room
	            var self = this;
	            (0, _Invite.inviteMultipleToRoom)(this.props.roomId, addrTexts).then(function (addrs) {
	                var room = _MatrixClientPeg2.default.get().getRoom(self.props.roomId);
	                return self._showAnyInviteErrors(addrs, room);
	            }).catch(function (err) {
	                console.error(err.stack);
	                var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                _Modal2.default.createDialog(ErrorDialog, {
	                    title: "Error",
	                    description: "Failed to invite"
	                });
	                return null;
	            }).done();
	        } else if (this._isDmChat(addrTexts)) {
	            // Start the DM chat
	            (0, _createRoom2.default)({ dmUserId: addrTexts[0] }).catch(function (err) {
	                console.error(err.stack);
	                var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                _Modal2.default.createDialog(ErrorDialog, {
	                    title: "Error",
	                    description: "Failed to invite user"
	                });
	                return null;
	            }).done();
	        } else {
	            // Start multi user chat
	            var self = this;
	            var room;
	            (0, _createRoom2.default)().then(function (roomId) {
	                room = _MatrixClientPeg2.default.get().getRoom(roomId);
	                return (0, _Invite.inviteMultipleToRoom)(roomId, addrTexts);
	            }).then(function (addrs) {
	                return self._showAnyInviteErrors(addrs, room);
	            }).catch(function (err) {
	                console.error(err.stack);
	                var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                _Modal2.default.createDialog(ErrorDialog, {
	                    title: "Error",
	                    description: "Failed to invite"
	                });
	                return null;
	            }).done();
	        }
	
	        // Close - this will happen before the above, as that is async
	        this.props.onFinished(true, addrTexts);
	    },
	
	    _updateUserList: new _ratelimitedfunc2.default(function () {
	        // Get all the users
	        this._userList = _MatrixClientPeg2.default.get().getUsers();
	        // Remove current user
	        var meIx = this._userList.findIndex(function (u) {
	            return u.userId === _MatrixClientPeg2.default.get().credentials.userId;
	        });
	        this._userList.splice(meIx, 1);
	
	        this._fuse.set(this._userList);
	    }, 500),
	
	    _isOnInviteList: function _isOnInviteList(uid) {
	        for (var i = 0; i < this.state.inviteList.length; i++) {
	            if (this.state.inviteList[i].addressType == 'mx' && this.state.inviteList[i].address.toLowerCase() === uid) {
	                return true;
	            }
	        }
	        return false;
	    },
	
	    _isDmChat: function _isDmChat(addrTexts) {
	        if (addrTexts.length === 1 && (0, _Invite.getAddressType)(addrTexts[0]) === "mx" && !this.props.roomId) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	
	    _showAnyInviteErrors: function _showAnyInviteErrors(addrs, room) {
	        // Show user any errors
	        var errorList = [];
	        for (var addr in addrs) {
	            if (addrs.hasOwnProperty(addr) && addrs[addr] === "error") {
	                errorList.push(addr);
	            }
	        }
	
	        if (errorList.length > 0) {
	            var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	            _Modal2.default.createDialog(ErrorDialog, {
	                title: "Failed to invite the following users to the " + room.name + " room:",
	                description: errorList.join(", ")
	            });
	        }
	        return addrs;
	    },
	
	    _addInputToList: function _addInputToList() {
	        var addressText = this.refs.textinput.value.trim();
	        var addrType = (0, _Invite.getAddressType)(addressText);
	        var addrObj = {
	            addressType: addrType,
	            address: addressText,
	            isKnown: false
	        };
	        if (addrType == null) {
	            this.setState({ error: true });
	            return null;
	        } else if (addrType == 'mx') {
	            var user = _MatrixClientPeg2.default.get().getUser(addrObj.address);
	            if (user) {
	                addrObj.displayName = user.displayName;
	                addrObj.avatarMxc = user.avatarUrl;
	                addrObj.isKnown = true;
	            }
	        }
	
	        var inviteList = this.state.inviteList.slice();
	        inviteList.push(addrObj);
	        this.setState({
	            inviteList: inviteList,
	            queryList: []
	        });
	        if (this._cancelThreepidLookup) this._cancelThreepidLookup();
	        return inviteList;
	    },
	
	    _lookupThreepid: function _lookupThreepid(medium, address) {
	        var _this3 = this;
	
	        var cancelled = false;
	        // Note that we can't safely remove this after we're done
	        // because we don't know that it's the same one, so we just
	        // leave it: it's replacing the old one each time so it's
	        // not like they leak.
	        this._cancelThreepidLookup = function () {
	            cancelled = true;
	        };
	
	        // wait a bit to let the user finish typing
	        return _q2.default.delay(500).then(function () {
	            if (cancelled) return null;
	            return _MatrixClientPeg2.default.get().lookupThreePid(medium, address);
	        }).then(function (res) {
	            if (res === null || !res.mxid) return null;
	            if (cancelled) return null;
	
	            return _MatrixClientPeg2.default.get().getProfileInfo(res.mxid);
	        }).then(function (res) {
	            if (res === null) return null;
	            if (cancelled) return null;
	            _this3.setState({
	                queryList: [{
	                    // an InviteAddressType
	                    addressType: medium,
	                    address: address,
	                    displayName: res.displayname,
	                    avatarMxc: res.avatar_url,
	                    isKnown: true
	                }]
	            });
	        });
	    },
	
	    render: function render() {
	        var _this4 = this;
	
	        var TintableSvg = _index2.default.getComponent("elements.TintableSvg");
	        var AddressSelector = _index2.default.getComponent("elements.AddressSelector");
	        this.scrollElement = null;
	
	        var query = [];
	        // create the invite list
	        if (this.state.inviteList.length > 0) {
	            var AddressTile = _index2.default.getComponent("elements.AddressTile");
	            for (var i = 0; i < this.state.inviteList.length; i++) {
	                query.push(_react2.default.createElement(AddressTile, { key: i, address: this.state.inviteList[i], canDismiss: true, onDismissed: this.onDismissed(i) }));
	            }
	        }
	
	        // Add the query at the end
	        query.push(_react2.default.createElement('textarea', { key: this.state.inviteList.length,
	            rows: '1',
	            id: 'textinput',
	            ref: 'textinput',
	            className: 'mx_ChatInviteDialog_input',
	            onChange: this.onQueryChanged,
	            placeholder: this.props.placeholder,
	            defaultValue: this.props.value,
	            autoFocus: this.props.focus }));
	
	        var error;
	        var addressSelector;
	        if (this.state.error) {
	            error = _react2.default.createElement(
	                'div',
	                { className: 'mx_ChatInviteDialog_error' },
	                'You have entered an invalid contact. Try using their Matrix ID or email address.'
	            );
	        } else {
	            var addressSelectorHeader = _react2.default.createElement(
	                'div',
	                { className: 'mx_ChatInviteDialog_addressSelectHeader' },
	                'Searching known users'
	            );
	            addressSelector = _react2.default.createElement(AddressSelector, { ref: function ref(_ref) {
	                    _this4.addressSelector = _ref;
	                },
	                addressList: this.state.queryList,
	                onSelected: this.onSelected,
	                truncateAt: TRUNCATE_QUERY_LIST,
	                header: addressSelectorHeader
	            });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_ChatInviteDialog', onKeyDown: this.onKeyDown },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_title' },
	                this.props.title
	            ),
	            _react2.default.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_ChatInviteDialog_cancel',
	                    onClick: this.onCancel },
	                _react2.default.createElement(TintableSvg, { src: 'img/icons-close-button.svg', width: '35', height: '35' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_ChatInviteDialog_label' },
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'textinput' },
	                    this.props.description
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_ChatInviteDialog_inputContainer' },
	                    query
	                ),
	                error,
	                addressSelector
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', onClick: this.onButtonClick },
	                    this.props.button
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * A dialog for confirming a redaction.
	 */
	exports.default = _react2.default.createClass({
	    displayName: 'ConfirmRedactDialog',
	    propTypes: {
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    defaultProps: {
	        danger: false
	    },
	
	    onOk: function onOk() {
	        this.props.onFinished(true);
	    },
	
	    onCancel: function onCancel() {
	        this.props.onFinished(false);
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	
	        var title = "Confirm Redaction";
	
	        var confirmButtonClass = (0, _classnames2.default)({
	            'mx_Dialog_primary': true,
	            'danger': false
	        });
	
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_ConfirmUserActionDialog', onFinished: this.props.onFinished,
	                onEnterPressed: this.onOk,
	                title: title
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                'Are you sure you wish to redact (delete) this event? Note that if you redact a room name or topic change, it could undo the change.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: confirmButtonClass, onClick: this.onOk },
	                    'Redact'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { onClick: this.onCancel },
	                    'Cancel'
	                )
	            )
	        );
	    }
	}); /*
	    Copyright 2017 Vector Creations Ltd
	    
	    Licensed under the Apache License, Version 2.0 (the "License");
	    you may not use this file except in compliance with the License.
	    You may obtain a copy of the License at
	    
	        http://www.apache.org/licenses/LICENSE-2.0
	    
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    See the License for the specific language governing permissions and
	    limitations under the License.
	    */

	module.exports = exports['default'];


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * A dialog for confirming an operation on another user.
	 * Takes a user ID and a verb, displays the target user prominently
	 * such that it should be easy to confirm that the operation is being
	 * performed on the right person, and displays the operation prominently
	 * to make it obvious what is going to happen.
	 * Also tweaks the style for 'dangerous' actions (albeit only with colour)
	 */
	exports.default = _react2.default.createClass({
	    displayName: 'ConfirmUserActionDialog',
	    propTypes: {
	        member: _react2.default.PropTypes.object.isRequired, // matrix-js-sdk member object
	        action: _react2.default.PropTypes.string.isRequired, // eg. 'Ban'
	
	        // Whether to display a text field for a reason
	        // If true, the second argument to onFinished will
	        // be the string entered.
	        askReason: _react2.default.PropTypes.bool,
	        danger: _react2.default.PropTypes.bool,
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    defaultProps: {
	        danger: false,
	        askReason: false
	    },
	
	    componentWillMount: function componentWillMount() {
	        this._reasonField = null;
	    },
	
	    onOk: function onOk() {
	        var reason = void 0;
	        if (this._reasonField) {
	            reason = this._reasonField.value;
	        }
	        this.props.onFinished(true, reason);
	    },
	
	    onCancel: function onCancel() {
	        this.props.onFinished(false);
	    },
	
	    _collectReasonField: function _collectReasonField(e) {
	        this._reasonField = e;
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        var MemberAvatar = _index2.default.getComponent("views.avatars.MemberAvatar");
	
	        var title = this.props.action + " this person?";
	        var confirmButtonClass = (0, _classnames2.default)({
	            'mx_Dialog_primary': true,
	            'danger': this.props.danger
	        });
	
	        var reasonBox = void 0;
	        if (this.props.askReason) {
	            reasonBox = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: this.onOk },
	                    _react2.default.createElement('input', { className: 'mx_ConfirmUserActionDialog_reasonField',
	                        ref: this._collectReasonField,
	                        placeholder: 'Reason',
	                        autoFocus: true
	                    })
	                )
	            );
	        }
	
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_ConfirmUserActionDialog', onFinished: this.props.onFinished,
	                onEnterPressed: this.onOk,
	                title: title
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_ConfirmUserActionDialog_avatar' },
	                    _react2.default.createElement(MemberAvatar, { member: this.props.member, width: 48, height: 48 })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_ConfirmUserActionDialog_name' },
	                    this.props.member.name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_ConfirmUserActionDialog_userId' },
	                    this.props.member.userId
	                )
	            ),
	            reasonBox,
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: confirmButtonClass,
	                        onClick: this.onOk, autoFocus: !this.props.askReason
	                    },
	                    this.props.action
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { onClick: this.onCancel },
	                    'Cancel'
	                )
	            )
	        );
	    }
	}); /*
	    Copyright 2017 Vector Creations Ltd
	    
	    Licensed under the Apache License, Version 2.0 (the "License");
	    you may not use this file except in compliance with the License.
	    You may obtain a copy of the License at
	    
	        http://www.apache.org/licenses/LICENSE-2.0
	    
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    See the License for the specific language governing permissions and
	    limitations under the License.
	    */

	module.exports = exports['default'];


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _Lifecycle = __webpack_require__(499);
	
	var Lifecycle = _interopRequireWildcard(_Lifecycle);
	
	var _velocityVector = __webpack_require__(233);
	
	var _velocityVector2 = _interopRequireDefault(_velocityVector);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeactivateAccountDialog = function (_React$Component) {
	    (0, _inherits3.default)(DeactivateAccountDialog, _React$Component);
	
	    function DeactivateAccountDialog(props, context) {
	        (0, _classCallCheck3.default)(this, DeactivateAccountDialog);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DeactivateAccountDialog.__proto__ || (0, _getPrototypeOf2.default)(DeactivateAccountDialog)).call(this, props, context));
	
	        _this._passwordField = null;
	
	        _this._onOk = _this._onOk.bind(_this);
	        _this._onCancel = _this._onCancel.bind(_this);
	        _this._onPasswordFieldChange = _this._onPasswordFieldChange.bind(_this);
	
	        _this.state = {
	            confirmButtonEnabled: false,
	            busy: false,
	            errStr: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(DeactivateAccountDialog, [{
	        key: '_onPasswordFieldChange',
	        value: function _onPasswordFieldChange(ev) {
	            this.setState({
	                confirmButtonEnabled: Boolean(ev.target.value)
	            });
	        }
	    }, {
	        key: '_onOk',
	        value: function _onOk() {
	            var _this2 = this;
	
	            // This assumes that the HS requires password UI auth
	            // for this endpoint. In reality it could be any UI auth.
	            this.setState({ busy: true });
	            _MatrixClientPeg2.default.get().deactivateAccount({
	                type: 'm.login.password',
	                user: _MatrixClientPeg2.default.get().credentials.userId,
	                password: this._passwordField.value
	            }).done(function () {
	                Lifecycle.onLoggedOut();
	                _this2.props.onFinished(false);
	            }, function (err) {
	                var errStr = 'Unknown error';
	                // https://matrix.org/jira/browse/SYN-744
	                if (err.httpStatus == 401 || err.httpStatus == 403) {
	                    errStr = 'Incorrect password';
	                    (0, _velocityVector2.default)(_this2._passwordField, "callout.shake", 300);
	                }
	                _this2.setState({
	                    busy: false,
	                    errStr: errStr
	                });
	            });
	        }
	    }, {
	        key: '_onCancel',
	        value: function _onCancel() {
	            this.props.onFinished(false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var Loader = _index2.default.getComponent("elements.Spinner");
	            var passwordBoxClass = '';
	
	            var error = null;
	            if (this.state.errStr) {
	                error = _react2.default.createElement(
	                    'div',
	                    { className: 'error' },
	                    this.state.errStr
	                );
	                passwordBoxClass = 'error';
	            }
	
	            var okLabel = this.state.busy ? _react2.default.createElement(Loader, null) : 'Deactivate Account';
	            var okEnabled = this.state.confirmButtonEnabled && !this.state.busy;
	
	            var cancelButton = null;
	            if (!this.state.busy) {
	                cancelButton = _react2.default.createElement(
	                    'button',
	                    { onClick: this._onCancel, autoFocus: true },
	                    'Cancel'
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_DeactivateAccountDialog' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_title danger' },
	                    'Deactivate Account'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'This will make your account permanently unusable. You will not be able to re-register the same user ID.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'This action is irreversible.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'To continue, please enter your password.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Password:'
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'password',
	                        onChange: this._onPasswordFieldChange,
	                        ref: function ref(e) {
	                            _this3._passwordField = e;
	                        },
	                        className: passwordBoxClass
	                    }),
	                    error
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_buttons' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'mx_Dialog_primary danger',
	                            onClick: this._onOk,
	                            disabled: !okEnabled
	                        },
	                        okLabel
	                    ),
	                    cancelButton
	                )
	            );
	        }
	    }]);
	    return DeactivateAccountDialog;
	}(_react2.default.Component); /*
	                              Copyright 2016 OpenMarket Ltd
	                              
	                              Licensed under the Apache License, Version 2.0 (the "License");
	                              you may not use this file except in compliance with the License.
	                              You may obtain a copy of the License at
	                              
	                                  http://www.apache.org/licenses/LICENSE-2.0
	                              
	                              Unless required by applicable law or agreed to in writing, software
	                              distributed under the License is distributed on an "AS IS" BASIS,
	                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                              See the License for the specific language governing permissions and
	                              limitations under the License.
	                              */
	
	exports.default = DeactivateAccountDialog;
	
	
	DeactivateAccountDialog.propTypes = {
	    onFinished: _react2.default.PropTypes.func.isRequired
	};
	module.exports = exports['default'];


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/*
	 * Usage:
	 * Modal.createDialog(ErrorDialog, {
	 *   title: "some text", (default: "Error")
	 *   description: "some more text",
	 *   button: "Button Text",
	 *   onFinished: someFunction,
	 *   focus: true|false (default: true)
	 * });
	 */
	
	exports.default = _react2.default.createClass({
	    displayName: 'ErrorDialog',
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        description: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string]),
	        button: _react2.default.PropTypes.string,
	        focus: _react2.default.PropTypes.bool,
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            title: "Error",
	            description: "An error has occurred.",
	            button: "OK",
	            focus: true
	        };
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_ErrorDialog', onFinished: this.props.onFinished,
	                title: this.props.title },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                this.props.description
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', onClick: this.props.onFinished, autoFocus: this.props.focus },
	                    this.props.button
	                )
	            )
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matrixJsSdk = __webpack_require__(28);
	
	var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = _react2.default.createClass({
	    displayName: 'InteractiveAuthDialog',
	
	    propTypes: {
	        // matrix client to use for UI auth requests
	        matrixClient: _react2.default.PropTypes.object.isRequired,
	
	        // response from initial request. If not supplied, will do a request on
	        // mount.
	        authData: _react2.default.PropTypes.shape({
	            flows: _react2.default.PropTypes.array,
	            params: _react2.default.PropTypes.object,
	            session: _react2.default.PropTypes.string
	        }),
	
	        // callback
	        makeRequest: _react2.default.PropTypes.func.isRequired,
	
	        onFinished: _react2.default.PropTypes.func.isRequired,
	
	        title: _react2.default.PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            title: "Authentication"
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            authError: null
	        };
	    },
	
	    _onAuthFinished: function _onAuthFinished(success, result) {
	        if (success) {
	            this.props.onFinished(true, result);
	        } else {
	            this.setState({
	                authError: result
	            });
	        }
	    },
	
	    _onDismissClick: function _onDismissClick() {
	        this.props.onFinished(false);
	    },
	
	    render: function render() {
	        var InteractiveAuth = _index2.default.getComponent("structures.InteractiveAuth");
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	
	        var content = void 0;
	        if (this.state.authError) {
	            content = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    this.state.authError.message || this.state.authError.toString()
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _AccessibleButton2.default,
	                    { onClick: this._onDismissClick,
	                        className: 'mx_UserSettings_button'
	                    },
	                    'Dismiss'
	                )
	            );
	        } else {
	            content = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(InteractiveAuth, { ref: this._collectInteractiveAuth,
	                    matrixClient: this.props.matrixClient,
	                    authData: this.props.authData,
	                    makeRequest: this.props.makeRequest,
	                    onAuthFinished: this._onAuthFinished
	                })
	            );
	        }
	
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_InteractiveAuthDialog',
	                onFinished: this.props.onFinished,
	                title: this.state.authError ? 'Error' : this.props.title
	            },
	            content
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _react2.default.createClass({
	    displayName: 'NeedToRegisterDialog',
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        description: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string]),
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            title: "Registration required",
	            description: "A registered account is required for this action"
	        };
	    },
	
	    onRegisterClicked: function onRegisterClicked() {
	        _dispatcher2.default.dispatch({
	            action: "start_upgrade_registration"
	        });
	        if (this.props.onFinished) {
	            this.props.onFinished();
	        }
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_NeedToRegisterDialog',
	                onFinished: this.props.onFinished,
	                title: this.props.title
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                this.props.description
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', onClick: this.props.onFinished, autoFocus: true },
	                    'Cancel'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { onClick: this.onRegisterClicked },
	                    'Register'
	                )
	            )
	        );
	    }
	}); /*
	    Copyright 2016 OpenMarket Ltd
	    
	    Licensed under the Apache License, Version 2.0 (the "License");
	    you may not use this file except in compliance with the License.
	    You may obtain a copy of the License at
	    
	        http://www.apache.org/licenses/LICENSE-2.0
	    
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    See the License for the specific language governing permissions and
	    limitations under the License.
	    */
	
	/*
	 * Usage:
	 * Modal.createDialog(NeedToRegisterDialog, {
	 *   title: "some text", (default: "Registration required")
	 *   description: "some more text",
	 *   onFinished: someFunction,
	 * });
	 */


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = _react2.default.createClass({
	    displayName: 'QuestionDialog',
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        description: _react2.default.PropTypes.node,
	        extraButtons: _react2.default.PropTypes.node,
	        button: _react2.default.PropTypes.string,
	        focus: _react2.default.PropTypes.bool,
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            title: "",
	            description: "",
	            extraButtons: null,
	            button: "OK",
	            focus: true,
	            hasCancelButton: true
	        };
	    },
	
	    onOk: function onOk() {
	        this.props.onFinished(true);
	    },
	
	    onCancel: function onCancel() {
	        this.props.onFinished(false);
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        var cancelButton = this.props.hasCancelButton ? _react2.default.createElement(
	            'button',
	            { onClick: this.onCancel },
	            'Cancel'
	        ) : null;
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_QuestionDialog', onFinished: this.props.onFinished,
	                onEnterPressed: this.onOk,
	                title: this.props.title
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                this.props.description
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', onClick: this.onOk, autoFocus: this.props.focus },
	                    this.props.button
	                ),
	                this.props.extraButtons,
	                cancelButton
	            )
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _SdkConfig = __webpack_require__(118);
	
	var _SdkConfig2 = _interopRequireDefault(_SdkConfig);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = _react2.default.createClass({
	    displayName: 'SessionRestoreErrorDialog',
	
	    propTypes: {
	        error: _react2.default.PropTypes.string.isRequired,
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    _sendBugReport: function _sendBugReport() {
	        var BugReportDialog = _index2.default.getComponent("dialogs.BugReportDialog");
	        _Modal2.default.createDialog(BugReportDialog, {});
	    },
	
	    _continueClicked: function _continueClicked() {
	        this.props.onFinished(true);
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        var bugreport = void 0;
	
	        if (_SdkConfig2.default.get().bug_report_endpoint_url) {
	            bugreport = _react2.default.createElement(
	                'p',
	                null,
	                'Otherwise, ',
	                _react2.default.createElement(
	                    'a',
	                    { onClick: this._sendBugReport, href: '#' },
	                    'click here'
	                ),
	                ' to send a bug report.'
	            );
	        }
	
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_ErrorDialog', onFinished: this.props.onFinished,
	                title: 'Unable to restore session' },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'We encountered an error trying to restore your previous session. If you continue, you will need to log in again, and encrypted chat history will be unreadable.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'If you have previously used a more recent version of Riot, your session may be incompatible with this version. Close this window and return to the more recent version.'
	                ),
	                bugreport
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', onClick: this._continueClicked },
	                    'Continue anyway'
	                )
	            )
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Prompt the user to set a display name.
	 *
	 * On success, `onFinished(true, newDisplayName)` is called.
	 */
	exports.default = _react2.default.createClass({
	    displayName: 'SetDisplayNameDialog',
	    propTypes: {
	        onFinished: _react2.default.PropTypes.func.isRequired,
	        currentDisplayName: _react2.default.PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        if (this.props.currentDisplayName) {
	            return { value: this.props.currentDisplayName };
	        }
	
	        if (_MatrixClientPeg2.default.get().isGuest()) {
	            return { value: "Guest " + _MatrixClientPeg2.default.get().getUserIdLocalpart() };
	        } else {
	            return { value: _MatrixClientPeg2.default.get().getUserIdLocalpart() };
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.refs.input_value.select();
	    },
	
	    onValueChange: function onValueChange(ev) {
	        this.setState({
	            value: ev.target.value
	        });
	    },
	
	    onFormSubmit: function onFormSubmit(ev) {
	        ev.preventDefault();
	        this.props.onFinished(true, this.state.value);
	        return false;
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_SetDisplayNameDialog',
	                onFinished: this.props.onFinished,
	                title: 'Set a Display Name'
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                'Your display name is how you\'ll appear to others when you speak in rooms.',
	                _react2.default.createElement('br', null),
	                'What would you like it to be?'
	            ),
	            _react2.default.createElement(
	                'form',
	                { onSubmit: this.onFormSubmit },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_content' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'input_value', value: this.state.value,
	                        autoFocus: true, onChange: this.onValueChange, size: '30',
	                        className: 'mx_SetDisplayNameDialog_input'
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dialog_buttons' },
	                    _react2.default.createElement('input', { className: 'mx_Dialog_primary', type: 'submit', value: 'Set' })
	                )
	            )
	        );
	    }
	}); /*
	    Copyright 2016 OpenMarket Ltd
	    
	    Licensed under the Apache License, Version 2.0 (the "License");
	    you may not use this file except in compliance with the License.
	    You may obtain a copy of the License at
	    
	        http://www.apache.org/licenses/LICENSE-2.0
	    
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    See the License for the specific language governing permissions and
	    limitations under the License.
	    */

	module.exports = exports['default'];


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = _react2.default.createClass({
	    displayName: 'TextInputDialog',
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        description: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string]),
	        value: _react2.default.PropTypes.string,
	        button: _react2.default.PropTypes.string,
	        focus: _react2.default.PropTypes.bool,
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            title: "",
	            value: "",
	            description: "",
	            button: "OK",
	            focus: true
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.props.focus) {
	            // Set the cursor at the end of the text input
	            this.refs.textinput.value = this.props.value;
	        }
	    },
	
	    onOk: function onOk() {
	        this.props.onFinished(true, this.refs.textinput.value);
	    },
	
	    onCancel: function onCancel() {
	        this.props.onFinished(false);
	    },
	
	    render: function render() {
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_TextInputDialog', onFinished: this.props.onFinished,
	                onEnterPressed: this.onOk,
	                title: this.props.title
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_TextInputDialog_label' },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'textinput' },
	                        ' ',
	                        this.props.description,
	                        ' '
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', { id: 'textinput', ref: 'textinput', className: 'mx_TextInputDialog_input', defaultValue: this.props.value, autoFocus: this.props.focus, size: '64', onKeyDown: this.onKeyDown })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { onClick: this.onCancel },
	                    'Cancel'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', onClick: this.onOk },
	                    this.props.button
	                )
	            )
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _reactGeminiScrollbar = __webpack_require__(121);
	
	var _reactGeminiScrollbar2 = _interopRequireDefault(_reactGeminiScrollbar);
	
	var _Resend = __webpack_require__(327);
	
	var _Resend2 = _interopRequireDefault(_Resend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	function DeviceListEntry(props) {
	    var userId = props.userId,
	        device = props.device;
	
	
	    var DeviceVerifyButtons = _index2.default.getComponent('elements.DeviceVerifyButtons');
	
	    return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(DeviceVerifyButtons, { device: device, userId: userId }),
	        device.deviceId,
	        _react2.default.createElement('br', null),
	        device.getDisplayName()
	    );
	}
	
	DeviceListEntry.propTypes = {
	    userId: _react2.default.PropTypes.string.isRequired,
	
	    // deviceinfo
	    device: _react2.default.PropTypes.object.isRequired
	};
	
	function UserUnknownDeviceList(props) {
	    var userId = props.userId,
	        userDevices = props.userDevices;
	
	
	    var deviceListEntries = (0, _keys2.default)(userDevices).map(function (deviceId) {
	        return _react2.default.createElement(DeviceListEntry, { key: deviceId, userId: userId,
	            device: userDevices[deviceId] });
	    });
	
	    return _react2.default.createElement(
	        'ul',
	        { className: 'mx_UnknownDeviceDialog_deviceList' },
	        deviceListEntries
	    );
	}
	
	UserUnknownDeviceList.propTypes = {
	    userId: _react2.default.PropTypes.string.isRequired,
	
	    // map from deviceid -> deviceinfo
	    userDevices: _react2.default.PropTypes.object.isRequired
	};
	
	function UnknownDeviceList(props) {
	    var devices = props.devices;
	
	
	    var userListEntries = (0, _keys2.default)(devices).map(function (userId) {
	        return _react2.default.createElement(
	            'li',
	            { key: userId },
	            _react2.default.createElement(
	                'p',
	                null,
	                userId,
	                ':'
	            ),
	            _react2.default.createElement(UserUnknownDeviceList, { userId: userId, userDevices: devices[userId] })
	        );
	    });
	
	    return _react2.default.createElement(
	        'ul',
	        null,
	        userListEntries
	    );
	}
	
	UnknownDeviceList.propTypes = {
	    // map from userid -> deviceid -> deviceinfo
	    devices: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = _react2.default.createClass({
	    displayName: 'UnknownDeviceDialog',
	
	    propTypes: {
	        room: _react2.default.PropTypes.object.isRequired,
	
	        // map from userid -> deviceid -> deviceinfo
	        devices: _react2.default.PropTypes.object.isRequired,
	        onFinished: _react2.default.PropTypes.func.isRequired
	    },
	
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        // Given we've now shown the user the unknown device, it is no longer
	        // unknown to them. Therefore mark it as 'known'.
	        (0, _keys2.default)(this.props.devices).forEach(function (userId) {
	            (0, _keys2.default)(_this.props.devices[userId]).map(function (deviceId) {
	                _MatrixClientPeg2.default.get().setDeviceKnown(userId, deviceId, true);
	            });
	        });
	
	        // XXX: temporary logging to try to diagnose
	        // https://github.com/vector-im/riot-web/issues/3148
	        console.log('Opening UnknownDeviceDialog');
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var client = _MatrixClientPeg2.default.get();
	        var blacklistUnverified = client.getGlobalBlacklistUnverifiedDevices() || this.props.room.getBlacklistUnverifiedDevices();
	
	        var warning = void 0;
	        if (blacklistUnverified) {
	            warning = _react2.default.createElement(
	                'h4',
	                null,
	                'You are currently blacklisting unverified devices; to send messages to these devices you must verify them.'
	            );
	        } else {
	            warning = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'We recommend you go through the verification process for each device to confirm they belong to their legitimate owner, but you can resend the message without verifying if you prefer.'
	                )
	            );
	        }
	
	        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
	        return _react2.default.createElement(
	            BaseDialog,
	            { className: 'mx_UnknownDeviceDialog',
	                onFinished: function onFinished() {
	                    // XXX: temporary logging to try to diagnose
	                    // https://github.com/vector-im/riot-web/issues/3148
	                    console.log("UnknownDeviceDialog closed by escape");
	                    _this2.props.onFinished();
	                },
	                title: 'Room contains unknown devices'
	            },
	            _react2.default.createElement(
	                _reactGeminiScrollbar2.default,
	                { autoshow: false, className: 'mx_Dialog_content' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'This room contains devices that you haven\'t seen before.'
	                ),
	                warning,
	                'Unknown devices:',
	                _react2.default.createElement(UnknownDeviceList, { devices: this.props.devices })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', autoFocus: true,
	                        onClick: function onClick() {
	                            _this2.props.onFinished();
	                            _Resend2.default.resendUnsentEvents(_this2.props.room);
	                        } },
	                    'Send anyway'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: 'mx_Dialog_primary', autoFocus: true,
	                        onClick: function onClick() {
	                            // XXX: temporary logging to try to diagnose
	                            // https://github.com/vector-im/riot-web/issues/3148
	                            console.log("UnknownDeviceDialog closed by OK");
	                            _this2.props.onFinished();
	                        } },
	                    'OK'
	                )
	            )
	        );
	        // XXX: do we want to give the user the option to enable blacklistUnverifiedDevices for this room (or globally) at this point?
	        // It feels like confused users will likely turn it on and then disappear in a cloud of UISIs...
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AddressTile = __webpack_require__(509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	    displayName: 'AddressSelector',
	
	    propTypes: {
	        onSelected: _react2.default.PropTypes.func.isRequired,
	
	        // List of the addresses to display
	        addressList: _react2.default.PropTypes.arrayOf(_AddressTile.InviteAddressType).isRequired,
	        truncateAt: _react2.default.PropTypes.number.isRequired,
	        selected: _react2.default.PropTypes.number,
	
	        // Element to put as a header on top of the list
	        header: _react2.default.PropTypes.node
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            selected: this.props.selected === undefined ? 0 : this.props.selected,
	            hover: false
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        // Make sure the selected item isn't outside the list bounds
	        var selected = this.state.selected;
	        var maxSelected = this._maxSelected(props.addressList);
	        if (selected > maxSelected) {
	            this.setState({ selected: maxSelected });
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        // As the user scrolls with the arrow keys keep the selected item
	        // at the top of the window.
	        if (this.scrollElement && this.props.addressList.length > 0 && !this.state.hover) {
	            var elementHeight = this.addressListElement.getBoundingClientRect().height;
	            this.scrollElement.scrollTop = this.state.selected * elementHeight - elementHeight;
	        }
	    },
	
	    moveSelectionTop: function moveSelectionTop() {
	        if (this.state.selected > 0) {
	            this.setState({
	                selected: 0,
	                hover: false
	            });
	        }
	    },
	
	    moveSelectionUp: function moveSelectionUp() {
	        if (this.state.selected > 0) {
	            this.setState({
	                selected: this.state.selected - 1,
	                hover: false
	            });
	        }
	    },
	
	    moveSelectionDown: function moveSelectionDown() {
	        if (this.state.selected < this._maxSelected(this.props.addressList)) {
	            this.setState({
	                selected: this.state.selected + 1,
	                hover: false
	            });
	        }
	    },
	
	    chooseSelection: function chooseSelection() {
	        this.selectAddress(this.state.selected);
	    },
	
	    onClick: function onClick(index) {
	        this.selectAddress(index);
	    },
	
	    onMouseEnter: function onMouseEnter(index) {
	        this.setState({
	            selected: index,
	            hover: true
	        });
	    },
	
	    onMouseLeave: function onMouseLeave() {
	        this.setState({ hover: false });
	    },
	
	    selectAddress: function selectAddress(index) {
	        // Only try to select an address if one exists
	        if (this.props.addressList.length !== 0) {
	            this.props.onSelected(index);
	            this.setState({ hover: false });
	        }
	    },
	
	    createAddressListTiles: function createAddressListTiles() {
	        var _this = this;
	
	        var self = this;
	        var AddressTile = _index2.default.getComponent("elements.AddressTile");
	        var maxSelected = this._maxSelected(this.props.addressList);
	        var addressList = [];
	
	        // Only create the address elements if there are address
	        if (this.props.addressList.length > 0) {
	            for (var i = 0; i <= maxSelected; i++) {
	                var classes = (0, _classnames2.default)({
	                    "mx_AddressSelector_addressListElement": true,
	                    "mx_AddressSelector_selected": this.state.selected === i
	                });
	
	                // NOTE: Defaulting to "vector" as the network, until the network backend stuff is done.
	                // Saving the addressListElement so we can use it to work out, in the componentDidUpdate
	                // method, how far to scroll when using the arrow keys
	                addressList.push(_react2.default.createElement(
	                    'div',
	                    {
	                        className: classes,
	                        onClick: this.onClick.bind(this, i),
	                        onMouseEnter: this.onMouseEnter.bind(this, i),
	                        onMouseLeave: this.onMouseLeave,
	                        key: this.props.addressList[i].userId,
	                        ref: function ref(_ref) {
	                            _this.addressListElement = _ref;
	                        }
	                    },
	                    _react2.default.createElement(AddressTile, { address: this.props.addressList[i], justified: true, networkName: 'vector', networkUrl: 'img/search-icon-vector.svg' })
	                ));
	            }
	        }
	        return addressList;
	    },
	
	    _maxSelected: function _maxSelected(list) {
	        var listSize = list.length === 0 ? 0 : list.length - 1;
	        var maxSelected = listSize > this.props.truncateAt - 1 ? this.props.truncateAt - 1 : listSize;
	        return maxSelected;
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var classes = (0, _classnames2.default)({
	            "mx_AddressSelector": true,
	            "mx_AddressSelector_empty": this.props.addressList.length === 0
	        });
	
	        return _react2.default.createElement(
	            'div',
	            { className: classes, ref: function ref(_ref2) {
	                    _this2.scrollElement = _ref2;
	                } },
	            this.props.header,
	            this.createAddressListTiles()
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	exports.default = _react2.default.createClass({
	    displayName: 'DeviceVerifyButtons',
	
	    propTypes: {
	        userId: _react2.default.PropTypes.string.isRequired,
	        device: _react2.default.PropTypes.object.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            device: this.props.device
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var cli = _MatrixClientPeg2.default.get();
	        cli.on("deviceVerificationChanged", this.onDeviceVerificationChanged);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        var cli = _MatrixClientPeg2.default.get();
	        cli.removeListener("deviceVerificationChanged", this.onDeviceVerificationChanged);
	    },
	
	    onDeviceVerificationChanged: function onDeviceVerificationChanged(userId, deviceId, deviceInfo) {
	        if (userId === this.props.userId && deviceId === this.props.device.deviceId) {
	            this.setState({ device: deviceInfo });
	        }
	    },
	
	    onVerifyClick: function onVerifyClick() {
	        var _this = this;
	
	        var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
	        _Modal2.default.createDialog(QuestionDialog, {
	            title: "Verify device",
	            description: _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'To verify that this device can be trusted, please contact its owner using some other means (e.g. in person or a phone call) and ask them whether the key they see in their User Settings for this device matches the key below:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_cryptoSection' },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Device name:'
	                            ),
	                            ' ',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                this.state.device.getDisplayName()
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Device ID:'
	                            ),
	                            '   ',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'code',
	                                    null,
	                                    this.state.device.deviceId
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Device key:'
	                            ),
	                            '  ',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'code',
	                                    null,
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        this.state.device.getFingerprint()
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'If it matches, press the verify button below. If it doesnt, then someone else is intercepting this device and you probably want to press the blacklist button instead.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'In future this verification process will be more sophisticated.'
	                )
	            ),
	            button: "I verify that the keys match",
	            onFinished: function onFinished(confirm) {
	                if (confirm) {
	                    _MatrixClientPeg2.default.get().setDeviceVerified(_this.props.userId, _this.state.device.deviceId, true);
	                }
	            }
	        });
	    },
	
	    onUnverifyClick: function onUnverifyClick() {
	        _MatrixClientPeg2.default.get().setDeviceVerified(this.props.userId, this.state.device.deviceId, false);
	    },
	
	    onBlacklistClick: function onBlacklistClick() {
	        _MatrixClientPeg2.default.get().setDeviceBlocked(this.props.userId, this.state.device.deviceId, true);
	    },
	
	    onUnblacklistClick: function onUnblacklistClick() {
	        _MatrixClientPeg2.default.get().setDeviceBlocked(this.props.userId, this.state.device.deviceId, false);
	    },
	
	    render: function render() {
	        var blacklistButton = null,
	            verifyButton = null;
	
	        if (this.state.device.isBlocked()) {
	            blacklistButton = _react2.default.createElement(
	                'button',
	                { className: 'mx_MemberDeviceInfo_textButton mx_MemberDeviceInfo_unblacklist',
	                    onClick: this.onUnblacklistClick },
	                'Unblacklist'
	            );
	        } else {
	            blacklistButton = _react2.default.createElement(
	                'button',
	                { className: 'mx_MemberDeviceInfo_textButton mx_MemberDeviceInfo_blacklist',
	                    onClick: this.onBlacklistClick },
	                'Blacklist'
	            );
	        }
	
	        if (this.state.device.isVerified()) {
	            verifyButton = _react2.default.createElement(
	                'button',
	                { className: 'mx_MemberDeviceInfo_textButton mx_MemberDeviceInfo_unverify',
	                    onClick: this.onUnverifyClick },
	                'Unverify'
	            );
	        } else {
	            verifyButton = _react2.default.createElement(
	                'button',
	                { className: 'mx_MemberDeviceInfo_textButton mx_MemberDeviceInfo_verify',
	                    onClick: this.onVerifyClick },
	                'Verify...'
	            );
	        }
	
	        // mx_MemberDeviceInfo because the vector's CSS on EncryptedEventDialog is awful
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_MemberDeviceInfo mx_DeviceVerifyButtons' },
	            verifyButton,
	            blacklistButton
	        );
	    }
	});
	module.exports = exports['default'];


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var DirectorySearchBox = function (_React$Component) {
	    (0, _inherits3.default)(DirectorySearchBox, _React$Component);
	
	    function DirectorySearchBox() {
	        (0, _classCallCheck3.default)(this, DirectorySearchBox);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DirectorySearchBox.__proto__ || (0, _getPrototypeOf2.default)(DirectorySearchBox)).call(this));
	
	        _this._collectInput = _this._collectInput.bind(_this);
	        _this._onClearClick = _this._onClearClick.bind(_this);
	        _this._onChange = _this._onChange.bind(_this);
	        _this._onKeyUp = _this._onKeyUp.bind(_this);
	        _this._onJoinButtonClick = _this._onJoinButtonClick.bind(_this);
	
	        _this.input = null;
	
	        _this.state = {
	            value: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(DirectorySearchBox, [{
	        key: '_collectInput',
	        value: function _collectInput(e) {
	            this.input = e;
	        }
	    }, {
	        key: '_onClearClick',
	        value: function _onClearClick() {
	            this.setState({ value: '' });
	
	            if (this.input) {
	                this.input.focus();
	
	                if (this.props.onClear) {
	                    this.props.onClear();
	                }
	            }
	        }
	    }, {
	        key: '_onChange',
	        value: function _onChange(ev) {
	            if (!this.input) return;
	            this.setState({ value: ev.target.value });
	
	            if (this.props.onChange) {
	                this.props.onChange(ev.target.value);
	            }
	        }
	    }, {
	        key: '_onKeyUp',
	        value: function _onKeyUp(ev) {
	            if (ev.key == 'Enter' && this.props.showJoinButton) {
	                if (this.props.onJoinClick) {
	                    this.props.onJoinClick(this.state.value);
	                }
	            }
	        }
	    }, {
	        key: '_onJoinButtonClick',
	        value: function _onJoinButtonClick() {
	            if (this.props.onJoinClick) {
	                this.props.onJoinClick(this.state.value);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var searchbox_classes = {
	                mx_DirectorySearchBox: true
	            };
	            searchbox_classes[this.props.className] = true;
	
	            var join_button = void 0;
	            if (this.props.showJoinButton) {
	                join_button = _react2.default.createElement(
	                    'span',
	                    { className: 'mx_DirectorySearchBox_joinButton',
	                        onClick: this._onJoinButtonClick
	                    },
	                    'Join'
	                );
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { className: (0, _classnames2.default)(searchbox_classes) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_DirectorySearchBox_container' },
	                    _react2.default.createElement('input', { type: 'text', name: 'dirsearch', value: this.state.value,
	                        className: 'mx_DirectorySearchBox_input',
	                        ref: this._collectInput,
	                        onChange: this._onChange, onKeyUp: this._onKeyUp,
	                        placeholder: this.props.placeholder
	                    }),
	                    join_button,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_DirectorySearchBox_clear_wrapper' },
	                        _react2.default.createElement('span', { className: 'mx_DirectorySearchBox_clear', onClick: this._onClearClick })
	                    )
	                )
	            );
	        }
	    }]);
	    return DirectorySearchBox;
	}(_react2.default.Component);
	
	exports.default = DirectorySearchBox;
	
	
	DirectorySearchBox.propTypes = {
	    className: _react2.default.PropTypes.string,
	    onChange: _react2.default.PropTypes.func,
	    onClear: _react2.default.PropTypes.func,
	    onJoinClick: _react2.default.PropTypes.func,
	    placeholder: _react2.default.PropTypes.string,
	    showJoinButton: _react2.default.PropTypes.bool
	};
	module.exports = exports['default'];


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuOption = function (_React$Component) {
	    (0, _inherits3.default)(MenuOption, _React$Component);
	
	    function MenuOption(props) {
	        (0, _classCallCheck3.default)(this, MenuOption);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MenuOption.__proto__ || (0, _getPrototypeOf2.default)(MenuOption)).call(this, props));
	
	        _this._onMouseEnter = _this._onMouseEnter.bind(_this);
	        _this._onClick = _this._onClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(MenuOption, [{
	        key: '_onMouseEnter',
	        value: function _onMouseEnter() {
	            this.props.onMouseEnter(this.props.dropdownKey);
	        }
	    }, {
	        key: '_onClick',
	        value: function _onClick(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            this.props.onClick(this.props.dropdownKey);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var optClasses = (0, _classnames2.default)({
	                mx_Dropdown_option: true,
	                mx_Dropdown_option_highlight: this.props.highlighted
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: optClasses,
	                    onClick: this._onClick, onKeyPress: this._onKeyPress,
	                    onMouseEnter: this._onMouseEnter
	                },
	                this.props.children
	            );
	        }
	    }]);
	    return MenuOption;
	}(_react2.default.Component); /*
	                              Copyright 2017 Vector Creations Ltd
	                              
	                              Licensed under the Apache License, Version 2.0 (the "License");
	                              you may not use this file except in compliance with the License.
	                              You may obtain a copy of the License at
	                              
	                                  http://www.apache.org/licenses/LICENSE-2.0
	                              
	                              Unless required by applicable law or agreed to in writing, software
	                              distributed under the License is distributed on an "AS IS" BASIS,
	                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                              See the License for the specific language governing permissions and
	                              limitations under the License.
	                              */
	
	;
	
	MenuOption.propTypes = {
	    children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]),
	    highlighted: _react2.default.PropTypes.bool,
	    dropdownKey: _react2.default.PropTypes.string,
	    onClick: _react2.default.PropTypes.func.isRequired,
	    onMouseEnter: _react2.default.PropTypes.func.isRequired
	};
	
	/*
	 * Reusable dropdown select control, akin to react-select,
	 * but somewhat simpler as react-select is 79KB of minified
	 * javascript.
	 *
	 * TODO: Port NetworkDropdown to use this.
	 */
	
	var Dropdown = function (_React$Component2) {
	    (0, _inherits3.default)(Dropdown, _React$Component2);
	
	    function Dropdown(props) {
	        (0, _classCallCheck3.default)(this, Dropdown);
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call(this, props));
	
	        _this2.dropdownRootElement = null;
	        _this2.ignoreEvent = null;
	
	        _this2._onInputClick = _this2._onInputClick.bind(_this2);
	        _this2._onRootClick = _this2._onRootClick.bind(_this2);
	        _this2._onDocumentClick = _this2._onDocumentClick.bind(_this2);
	        _this2._onMenuOptionClick = _this2._onMenuOptionClick.bind(_this2);
	        _this2._onInputKeyPress = _this2._onInputKeyPress.bind(_this2);
	        _this2._onInputKeyUp = _this2._onInputKeyUp.bind(_this2);
	        _this2._onInputChange = _this2._onInputChange.bind(_this2);
	        _this2._collectRoot = _this2._collectRoot.bind(_this2);
	        _this2._collectInputTextBox = _this2._collectInputTextBox.bind(_this2);
	        _this2._setHighlightedOption = _this2._setHighlightedOption.bind(_this2);
	
	        _this2.inputTextBox = null;
	
	        _this2._reindexChildren(_this2.props.children);
	
	        var firstChild = _react2.default.Children.toArray(props.children)[0];
	
	        _this2.state = {
	            // True if the menu is dropped-down
	            expanded: false,
	            // The key of the highlighted option
	            // (the option that would become selected if you pressed enter)
	            highlightedOption: firstChild ? firstChild.key : null,
	            // the current search query
	            searchQuery: ''
	        };
	        return _this2;
	    }
	
	    (0, _createClass3.default)(Dropdown, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Listen for all clicks on the document so we can close the
	            // menu when the user clicks somewhere else
	            document.addEventListener('click', this._onDocumentClick, false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this._onDocumentClick, false);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this._reindexChildren(nextProps.children);
	            var firstChild = _react2.default.Children.toArray(nextProps.children)[0];
	            this.setState({
	                highlightedOption: firstChild ? firstChild.key : null
	            });
	        }
	    }, {
	        key: '_reindexChildren',
	        value: function _reindexChildren(children) {
	            var _this3 = this;
	
	            this.childrenByKey = {};
	            _react2.default.Children.forEach(children, function (child) {
	                _this3.childrenByKey[child.key] = child;
	            });
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick(ev) {
	            // Close the dropdown if the user clicks anywhere that isn't
	            // within our root element
	            if (ev !== this.ignoreEvent) {
	                this.setState({
	                    expanded: false
	                });
	            }
	        }
	    }, {
	        key: '_onRootClick',
	        value: function _onRootClick(ev) {
	            // This captures any clicks that happen within our elements,
	            // such that we can then ignore them when they're seen by the
	            // click listener on the document handler, ie. not close the
	            // dropdown immediately after opening it.
	            // NB. We can't just stopPropagation() because then the event
	            // doesn't reach the React onClick().
	            this.ignoreEvent = ev;
	        }
	    }, {
	        key: '_onInputClick',
	        value: function _onInputClick(ev) {
	            this.setState({
	                expanded: !this.state.expanded
	            });
	            ev.preventDefault();
	        }
	    }, {
	        key: '_onMenuOptionClick',
	        value: function _onMenuOptionClick(dropdownKey) {
	            this.setState({
	                expanded: false
	            });
	            this.props.onOptionChange(dropdownKey);
	        }
	    }, {
	        key: '_onInputKeyPress',
	        value: function _onInputKeyPress(e) {
	            // This needs to be on the keypress event because otherwise
	            // it can't cancel the form submission
	            if (e.key == 'Enter') {
	                this.setState({
	                    expanded: false
	                });
	                this.props.onOptionChange(this.state.highlightedOption);
	                e.preventDefault();
	            }
	        }
	    }, {
	        key: '_onInputKeyUp',
	        value: function _onInputKeyUp(e) {
	            // These keys don't generate keypress events and so needs to
	            // be on keyup
	            if (e.key == 'Escape') {
	                this.setState({
	                    expanded: false
	                });
	            } else if (e.key == 'ArrowDown') {
	                this.setState({
	                    highlightedOption: this._nextOption(this.state.highlightedOption)
	                });
	            } else if (e.key == 'ArrowUp') {
	                this.setState({
	                    highlightedOption: this._prevOption(this.state.highlightedOption)
	                });
	            }
	        }
	    }, {
	        key: '_onInputChange',
	        value: function _onInputChange(e) {
	            this.setState({
	                searchQuery: e.target.value
	            });
	            if (this.props.onSearchChange) {
	                this.props.onSearchChange(e.target.value);
	            }
	        }
	    }, {
	        key: '_collectRoot',
	        value: function _collectRoot(e) {
	            if (this.dropdownRootElement) {
	                this.dropdownRootElement.removeEventListener('click', this._onRootClick, false);
	            }
	            if (e) {
	                e.addEventListener('click', this._onRootClick, false);
	            }
	            this.dropdownRootElement = e;
	        }
	    }, {
	        key: '_collectInputTextBox',
	        value: function _collectInputTextBox(e) {
	            this.inputTextBox = e;
	            if (e) e.focus();
	        }
	    }, {
	        key: '_setHighlightedOption',
	        value: function _setHighlightedOption(optionKey) {
	            this.setState({
	                highlightedOption: optionKey
	            });
	        }
	    }, {
	        key: '_nextOption',
	        value: function _nextOption(optionKey) {
	            var keys = (0, _keys2.default)(this.childrenByKey);
	            var index = keys.indexOf(optionKey);
	            return keys[(index + 1) % keys.length];
	        }
	    }, {
	        key: '_prevOption',
	        value: function _prevOption(optionKey) {
	            var keys = (0, _keys2.default)(this.childrenByKey);
	            var index = keys.indexOf(optionKey);
	            return keys[(index - 1) % keys.length];
	        }
	    }, {
	        key: '_getMenuOptions',
	        value: function _getMenuOptions() {
	            var _this4 = this;
	
	            var options = _react2.default.Children.map(this.props.children, function (child) {
	                return _react2.default.createElement(
	                    MenuOption,
	                    { key: child.key, dropdownKey: child.key,
	                        highlighted: _this4.state.highlightedOption == child.key,
	                        onMouseEnter: _this4._setHighlightedOption,
	                        onClick: _this4._onMenuOptionClick
	                    },
	                    child
	                );
	            });
	
	            if (!this.state.searchQuery) {
	                options.push(_react2.default.createElement(
	                    'div',
	                    { key: '_searchprompt', className: 'mx_Dropdown_searchPrompt' },
	                    'Type to search...'
	                ));
	            }
	            return options;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var currentValue = void 0;
	
	            var menuStyle = {};
	            if (this.props.menuWidth) menuStyle.width = this.props.menuWidth;
	
	            var menu = void 0;
	            if (this.state.expanded) {
	                currentValue = _react2.default.createElement('input', { type: 'text', className: 'mx_Dropdown_option',
	                    ref: this._collectInputTextBox, onKeyPress: this._onInputKeyPress,
	                    onKeyUp: this._onInputKeyUp,
	                    onChange: this._onInputChange,
	                    value: this.state.searchQuery
	                });
	                menu = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dropdown_menu', style: menuStyle },
	                    this._getMenuOptions()
	                );
	            } else {
	                var selectedChild = this.props.getShortOption ? this.props.getShortOption(this.props.value) : this.childrenByKey[this.props.value];
	                currentValue = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Dropdown_option' },
	                    selectedChild
	                );
	            }
	
	            var dropdownClasses = {
	                mx_Dropdown: true
	            };
	            if (this.props.className) {
	                dropdownClasses[this.props.className] = true;
	            }
	
	            // Note the menu sits inside the AccessibleButton div so it's anchored
	            // to the input, but overflows below it. The root contains both.
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(dropdownClasses), ref: this._collectRoot },
	                _react2.default.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_Dropdown_input', onClick: this._onInputClick },
	                    currentValue,
	                    _react2.default.createElement('span', { className: 'mx_Dropdown_arrow' }),
	                    menu
	                )
	            );
	        }
	    }]);
	    return Dropdown;
	}(_react2.default.Component);
	
	exports.default = Dropdown;
	
	
	Dropdown.propTypes = {
	    // The width that the dropdown should be. If specified,
	    // the dropped-down part of the menu will be set to this
	    // width.
	    menuWidth: _react2.default.PropTypes.number,
	    // Called when the selected option changes
	    onOptionChange: _react2.default.PropTypes.func.isRequired,
	    // Called when the value of the search field changes
	    onSearchChange: _react2.default.PropTypes.func,
	    // Function that, given the key of an option, returns
	    // a node representing that option to be displayed in the
	    // box itself as the currently-selected option (ie. as
	    // opposed to in the actual dropped-down part). If
	    // unspecified, the appropriate child element is used as
	    // in the dropped-down menu.
	    getShortOption: _react2.default.PropTypes.func,
	    value: _react2.default.PropTypes.string
	};
	module.exports = exports['default'];


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var KEY_TAB = 9;
	var KEY_SHIFT = 16;
	var KEY_WINDOWS = 91;
	
	module.exports = React.createClass({
	    displayName: 'EditableText',
	
	    propTypes: {
	        onValueChanged: React.PropTypes.func,
	        initialValue: React.PropTypes.string,
	        label: React.PropTypes.string,
	        placeholder: React.PropTypes.string,
	        className: React.PropTypes.string,
	        labelClassName: React.PropTypes.string,
	        placeholderClassName: React.PropTypes.string,
	        // Overrides blurToSubmit if true
	        blurToCancel: React.PropTypes.bool,
	        // Will cause onValueChanged(value, true) to fire on blur
	        blurToSubmit: React.PropTypes.bool,
	        editable: React.PropTypes.bool
	    },
	
	    Phases: {
	        Display: "display",
	        Edit: "edit"
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onValueChanged: function onValueChanged() {},
	            initialValue: '',
	            label: '',
	            placeholder: '',
	            editable: true,
	            className: "mx_EditableText",
	            placeholderClassName: "mx_EditableText_placeholder",
	            blurToSubmit: false
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            phase: this.Phases.Display
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.initialValue !== this.props.initialValue) {
	            this.value = nextProps.initialValue;
	            if (this.refs.editable_div) {
	                this.showPlaceholder(!this.value);
	            }
	        }
	    },
	
	    componentWillMount: function componentWillMount() {
	        // we track value as an JS object field rather than in React state
	        // as React doesn't play nice with contentEditable.
	        this.value = '';
	        this.placeholder = false;
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.value = this.props.initialValue;
	        if (this.refs.editable_div) {
	            this.showPlaceholder(!this.value);
	        }
	    },
	
	    showPlaceholder: function showPlaceholder(show) {
	        if (show) {
	            this.refs.editable_div.textContent = this.props.placeholder;
	            this.refs.editable_div.setAttribute("class", this.props.className + " " + this.props.placeholderClassName);
	            this.placeholder = true;
	            this.value = '';
	        } else {
	            this.refs.editable_div.textContent = this.value;
	            this.refs.editable_div.setAttribute("class", this.props.className);
	            this.placeholder = false;
	        }
	    },
	
	    getValue: function getValue() {
	        return this.value;
	    },
	
	    setValue: function setValue(value) {
	        this.value = value;
	        this.showPlaceholder(!this.value);
	    },
	
	    edit: function edit() {
	        this.setState({
	            phase: this.Phases.Edit
	        });
	    },
	
	    cancelEdit: function cancelEdit() {
	        this.setState({
	            phase: this.Phases.Display
	        });
	        this.value = this.props.initialValue;
	        this.showPlaceholder(!this.value);
	        this.onValueChanged(false);
	        this.refs.editable_div.blur();
	    },
	
	    onValueChanged: function onValueChanged(shouldSubmit) {
	        this.props.onValueChanged(this.value, shouldSubmit);
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        // console.log("keyDown: textContent=" + ev.target.textContent + ", value=" + this.value + ", placeholder=" + this.placeholder);
	
	        if (this.placeholder) {
	            this.showPlaceholder(false);
	        }
	
	        if (ev.key == "Enter") {
	            ev.stopPropagation();
	            ev.preventDefault();
	        }
	
	        // console.log("keyDown: textContent=" + ev.target.textContent + ", value=" + this.value + ", placeholder=" + this.placeholder);
	    },
	
	    onKeyUp: function onKeyUp(ev) {
	        // console.log("keyUp: textContent=" + ev.target.textContent + ", value=" + this.value + ", placeholder=" + this.placeholder);
	
	        if (!ev.target.textContent) {
	            this.showPlaceholder(true);
	        } else if (!this.placeholder) {
	            this.value = ev.target.textContent;
	        }
	
	        if (ev.key == "Enter") {
	            this.onFinish(ev);
	        } else if (ev.key == "Escape") {
	            this.cancelEdit();
	        }
	
	        // console.log("keyUp: textContent=" + ev.target.textContent + ", value=" + this.value + ", placeholder=" + this.placeholder);
	    },
	
	    onClickDiv: function onClickDiv(ev) {
	        if (!this.props.editable) return;
	
	        this.setState({
	            phase: this.Phases.Edit
	        });
	    },
	
	    onFocus: function onFocus(ev) {
	        //ev.target.setSelectionRange(0, ev.target.textContent.length);
	
	        var node = ev.target.childNodes[0];
	        if (node) {
	            var range = document.createRange();
	            range.setStart(node, 0);
	            range.setEnd(node, node.length);
	
	            var sel = window.getSelection();
	            sel.removeAllRanges();
	            sel.addRange(range);
	        }
	    },
	
	    onFinish: function onFinish(ev, shouldSubmit) {
	        var self = this;
	        var submit = ev.key === "Enter" || shouldSubmit;
	        this.setState({
	            phase: this.Phases.Display
	        }, function () {
	            if (this.value !== this.props.initialValue) {
	                self.onValueChanged(submit);
	            }
	        });
	    },
	
	    onBlur: function onBlur(ev) {
	        var sel = window.getSelection();
	        sel.removeAllRanges();
	
	        if (this.props.blurToCancel) {
	            this.cancelEdit();
	        } else {
	            this.onFinish(ev, this.props.blurToSubmit);
	        }
	
	        this.showPlaceholder(!this.value);
	    },
	
	    render: function render() {
	        var editable_el;
	
	        if (!this.props.editable || this.state.phase == this.Phases.Display && (this.props.label || this.props.labelClassName) && !this.value) {
	            // show the label
	            editable_el = React.createElement(
	                'div',
	                { className: this.props.className + " " + this.props.labelClassName, onClick: this.onClickDiv },
	                this.props.label || this.props.initialValue
	            );
	        } else {
	            // show the content editable div, but manually manage its contents as react and contentEditable don't play nice together
	            editable_el = React.createElement('div', { ref: 'editable_div', contentEditable: 'true', className: this.props.className,
	                onKeyDown: this.onKeyDown, onKeyUp: this.onKeyUp, onFocus: this.onFocus, onBlur: this.onBlur });
	        }
	
	        return editable_el;
	    }
	});


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A component which wraps an EditableText, with a spinner while updates take
	 * place.
	 *
	 * Parent components should supply an 'onSubmit' callback which returns a
	 * promise; a spinner is shown until the promise resolves.
	 *
	 * The parent can also supply a 'getIntialValue' callback, which works in a
	 * similarly asynchronous way. If this is not provided, the initial value is
	 * taken from the 'initialValue' property.
	 */
	var EditableTextContainer = function (_React$Component) {
	    (0, _inherits3.default)(EditableTextContainer, _React$Component);
	
	    function EditableTextContainer(props, context) {
	        (0, _classCallCheck3.default)(this, EditableTextContainer);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (EditableTextContainer.__proto__ || (0, _getPrototypeOf2.default)(EditableTextContainer)).call(this, props, context));
	
	        _this._unmounted = false;
	        _this.state = {
	            busy: false,
	            errorString: null,
	            value: props.initialValue
	        };
	        _this._onValueChanged = _this._onValueChanged.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(EditableTextContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            if (this.props.getInitialValue === undefined) {
	                // use whatever was given in the initialValue property.
	                return;
	            }
	
	            this.setState({ busy: true });
	
	            this.props.getInitialValue().done(function (result) {
	                if (_this2._unmounted) {
	                    return;
	                }
	                _this2.setState({
	                    busy: false,
	                    value: result
	                });
	            }, function (error) {
	                if (_this2._unmounted) {
	                    return;
	                }
	                _this2.setState({
	                    errorString: error.toString(),
	                    busy: false
	                });
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this._unmounted = true;
	        }
	    }, {
	        key: '_onValueChanged',
	        value: function _onValueChanged(value, shouldSubmit) {
	            var _this3 = this;
	
	            if (!shouldSubmit) {
	                return;
	            }
	
	            this.setState({
	                busy: true,
	                errorString: null
	            });
	
	            this.props.onSubmit(value).done(function () {
	                if (_this3._unmounted) {
	                    return;
	                }
	                _this3.setState({
	                    busy: false,
	                    value: value
	                });
	            }, function (error) {
	                if (_this3._unmounted) {
	                    return;
	                }
	                _this3.setState({
	                    errorString: error.toString(),
	                    busy: false
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.busy) {
	                var Loader = _index2.default.getComponent("elements.Spinner");
	                return _react2.default.createElement(Loader, null);
	            } else if (this.state.errorString) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'error' },
	                    this.state.errorString
	                );
	            } else {
	                var EditableText = _index2.default.getComponent('elements.EditableText');
	                return _react2.default.createElement(EditableText, { initialValue: this.state.value,
	                    placeholder: this.props.placeholder,
	                    onValueChanged: this._onValueChanged,
	                    blurToSubmit: this.props.blurToSubmit
	                });
	            }
	        }
	    }]);
	    return EditableTextContainer;
	}(_react2.default.Component); /*
	                              Copyright 2015, 2016 OpenMarket Ltd
	                              
	                              Licensed under the Apache License, Version 2.0 (the "License");
	                              you may not use this file except in compliance with the License.
	                              You may obtain a copy of the License at
	                              
	                                  http://www.apache.org/licenses/LICENSE-2.0
	                              
	                              Unless required by applicable law or agreed to in writing, software
	                              distributed under the License is distributed on an "AS IS" BASIS,
	                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                              See the License for the specific language governing permissions and
	                              limitations under the License.
	                              */
	
	exports.default = EditableTextContainer;
	
	
	EditableTextContainer.propTypes = {
	    /* callback to retrieve the initial value. */
	    getInitialValue: _react2.default.PropTypes.func,
	
	    /* initial value; used if getInitialValue is not given */
	    initialValue: _react2.default.PropTypes.string,
	
	    /* placeholder text to use when the value is empty (and not being
	     * edited) */
	    placeholder: _react2.default.PropTypes.string,
	
	    /* callback to update the value. Called with a single argument: the new
	     * value. */
	    onSubmit: _react2.default.PropTypes.func,
	
	    /* should the input submit when focus is lost? */
	    blurToSubmit: _react2.default.PropTypes.bool
	};
	
	EditableTextContainer.defaultProps = {
	    initialValue: "",
	    placeholder: "",
	    blurToSubmit: false,
	    onSubmit: function onSubmit(v) {
	        return (0, _q2.default)();
	    }
	};
	module.exports = exports['default'];


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(96);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = EmojiText;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HtmlUtils = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 Copyright 2016 Aviral Dasgupta
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */
	
	function EmojiText(props) {
	    var element = props.element,
	        children = props.children,
	        restProps = (0, _objectWithoutProperties3.default)(props, ['element', 'children']);
	
	    restProps.dangerouslySetInnerHTML = (0, _HtmlUtils.emojifyText)(children);
	    return _react2.default.createElement(element, restProps);
	}
	
	EmojiText.propTypes = {
	    element: _react2.default.PropTypes.string,
	    children: _react2.default.PropTypes.string.isRequired
	};
	
	EmojiText.defaultProps = {
	    element: 'span'
	};
	module.exports = exports['default'];


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MemberAvatar = __webpack_require__(334); /*
	                                                          Copyright 2016 OpenMarket Ltd
	                                                          
	                                                          Licensed under the Apache License, Version 2.0 (the "License");
	                                                          you may not use this file except in compliance with the License.
	                                                          You may obtain a copy of the License at
	                                                          
	                                                              http://www.apache.org/licenses/LICENSE-2.0
	                                                          
	                                                          Unless required by applicable law or agreed to in writing, software
	                                                          distributed under the License is distributed on an "AS IS" BASIS,
	                                                          WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                          See the License for the specific language governing permissions and
	                                                          limitations under the License.
	                                                          */
	
	
	module.exports = _react2.default.createClass({
	    displayName: 'MemberEventListSummary',
	
	    propTypes: {
	        // An array of member events to summarise
	        events: _react2.default.PropTypes.array.isRequired,
	        // An array of EventTiles to render when expanded
	        children: _react2.default.PropTypes.array.isRequired,
	        // The maximum number of names to show in either each summary e.g. 2 would result "A, B and 234 others left"
	        summaryLength: _react2.default.PropTypes.number,
	        // The maximum number of avatars to display in the summary
	        avatarsMaxLength: _react2.default.PropTypes.number,
	        // The minimum number of events needed to trigger summarisation
	        threshold: _react2.default.PropTypes.number,
	        // Called when the MELS expansion is toggled
	        onToggle: _react2.default.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            expanded: false
	        };
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            summaryLength: 1,
	            threshold: 3,
	            avatarsMaxLength: 5
	        };
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        // Update if
	        //  - The number of summarised events has changed
	        //  - or if the summary is currently expanded
	        //  - or if the summary is about to toggle to become collapsed
	        //  - or if there are fewEvents, meaning the child eventTiles are shown as-is
	        return nextProps.events.length !== this.props.events.length || this.state.expanded || nextState.expanded || nextProps.events.length < this.props.threshold;
	    },
	
	    _toggleSummary: function _toggleSummary() {
	        this.setState({
	            expanded: !this.state.expanded
	        });
	        this.props.onToggle();
	    },
	
	    /**
	     * Render the JSX for users aggregated by their transition sequences (`eventAggregates`) where
	     * the sequences are ordered by `orderedTransitionSequences`.
	     * @param {object[]} eventAggregates a map of transition sequence to array of user display names
	     * or user IDs.
	     * @param {string[]} orderedTransitionSequences an array which is some ordering of
	     * `Object.keys(eventAggregates)`.
	     * @returns {ReactElement} a single <span> containing the textual summary of the aggregated
	     * events that occurred.
	     */
	    _renderSummary: function _renderSummary(eventAggregates, orderedTransitionSequences) {
	        var _this = this;
	
	        var summaries = orderedTransitionSequences.map(function (transitions) {
	            var userNames = eventAggregates[transitions];
	            var nameList = _this._renderNameList(userNames);
	            var plural = userNames.length > 1;
	
	            var splitTransitions = transitions.split(',');
	
	            // Some neighbouring transitions are common, so canonicalise some into "pair"
	            // transitions
	            var canonicalTransitions = _this._getCanonicalTransitions(splitTransitions);
	            // Transform into consecutive repetitions of the same transition (like 5
	            // consecutive 'joined_and_left's)
	            var coalescedTransitions = _this._coalesceRepeatedTransitions(canonicalTransitions);
	
	            var descs = coalescedTransitions.map(function (t) {
	                return _this._getDescriptionForTransition(t.transitionType, plural, t.repeats);
	            });
	
	            var desc = _this._renderCommaSeparatedList(descs);
	
	            return nameList + " " + desc;
	        });
	
	        if (!summaries) {
	            return null;
	        }
	
	        return _react2.default.createElement(
	            'span',
	            { className: 'mx_TextualEvent mx_MemberEventListSummary_summary' },
	            summaries.join(", ")
	        );
	    },
	
	    /**
	     * @param {string[]} users an array of user display names or user IDs.
	     * @returns {string} a comma-separated list that ends with "and [n] others" if there are
	     * more items in `users` than `this.props.summaryLength`, which is the number of names
	     * included before "and [n] others".
	     */
	    _renderNameList: function _renderNameList(users) {
	        return this._renderCommaSeparatedList(users, this.props.summaryLength);
	    },
	
	    /**
	     * Canonicalise an array of transitions such that some pairs of transitions become
	     * single transitions. For example an input ['joined','left'] would result in an output
	     * ['joined_and_left'].
	     * @param {string[]} transitions an array of transitions.
	     * @returns {string[]} an array of transitions.
	     */
	    _getCanonicalTransitions: function _getCanonicalTransitions(transitions) {
	        var modMap = {
	            'joined': {
	                'after': 'left',
	                'newTransition': 'joined_and_left'
	            },
	            'left': {
	                'after': 'joined',
	                'newTransition': 'left_and_joined'
	            }
	        };
	        var res = [];
	
	        for (var i = 0; i < transitions.length; i++) {
	            var t = transitions[i];
	            var t2 = transitions[i + 1];
	
	            var transition = t;
	
	            if (i < transitions.length - 1 && modMap[t] && modMap[t].after === t2) {
	                transition = modMap[t].newTransition;
	                i++;
	            }
	
	            res.push(transition);
	        }
	        return res;
	    },
	
	    /**
	     * Transform an array of transitions into an array of transitions and how many times
	     * they are repeated consecutively.
	     *
	     * An array of 123 "joined_and_left" transitions, would result in:
	     * ```
	     * [{
	     *   transitionType: "joined_and_left"
	     *   repeats: 123
	     * }]
	     * ```
	     * @param {string[]} transitions the array of transitions to transform.
	     * @returns {object[]} an array of coalesced transitions.
	     */
	    _coalesceRepeatedTransitions: function _coalesceRepeatedTransitions(transitions) {
	        var res = [];
	        for (var i = 0; i < transitions.length; i++) {
	            if (res.length > 0 && res[res.length - 1].transitionType === transitions[i]) {
	                res[res.length - 1].repeats += 1;
	            } else {
	                res.push({
	                    transitionType: transitions[i],
	                    repeats: 1
	                });
	            }
	        }
	        return res;
	    },
	
	    /**
	     * For a certain transition, t, describe what happened to the users that
	     * underwent the transition.
	     * @param {string} t the transition type.
	     * @param {boolean} plural whether there were multiple users undergoing the same
	     * transition.
	     * @param {number} repeats the number of times the transition was repeated in a row.
	     * @returns {string} the written English equivalent of the transition.
	     */
	    _getDescriptionForTransition: function _getDescriptionForTransition(t, plural, repeats) {
	        var beConjugated = plural ? "were" : "was";
	        var invitation = "their invitation" + (plural || repeats > 1 ? "s" : "");
	
	        var res = null;
	        var map = {
	            "joined": "joined",
	            "left": "left",
	            "joined_and_left": "joined and left",
	            "left_and_joined": "left and rejoined",
	            "invite_reject": "rejected " + invitation,
	            "invite_withdrawal": "had " + invitation + " withdrawn",
	            "invited": beConjugated + " invited",
	            "banned": beConjugated + " banned",
	            "unbanned": beConjugated + " unbanned",
	            "kicked": beConjugated + " kicked"
	        };
	
	        if ((0, _keys2.default)(map).includes(t)) {
	            res = map[t] + (repeats > 1 ? " " + repeats + " times" : "");
	        }
	
	        return res;
	    },
	
	
	    /**
	     * Constructs a written English string representing `items`, with an optional limit on
	     * the number of items included in the result. If specified and if the length of
	     *`items` is greater than the limit, the string "and n others" will be appended onto
	     * the result.
	     * If `items` is empty, returns the empty string. If there is only one item, return
	     * it.
	     * @param {string[]} items the items to construct a string from.
	     * @param {number?} itemLimit the number by which to limit the list.
	     * @returns {string} a string constructed by joining `items` with a comma between each
	     * item, but with the last item appended as " and [lastItem]".
	     */
	    _renderCommaSeparatedList: function _renderCommaSeparatedList(items, itemLimit) {
	        var remaining = itemLimit === undefined ? 0 : Math.max(items.length - itemLimit, 0);
	        if (items.length === 0) {
	            return "";
	        } else if (items.length === 1) {
	            return items[0];
	        } else if (remaining) {
	            items = items.slice(0, itemLimit);
	            var other = " other" + (remaining > 1 ? "s" : "");
	            return items.join(', ') + ' and ' + remaining + other;
	        } else {
	            var lastItem = items.pop();
	            return items.join(', ') + ' and ' + lastItem;
	        }
	    },
	
	
	    _renderAvatars: function _renderAvatars(roomMembers) {
	        var avatars = roomMembers.slice(0, this.props.avatarsMaxLength).map(function (m) {
	            return _react2.default.createElement(MemberAvatar, { key: m.userId, member: m, width: 14, height: 14 });
	        });
	        return _react2.default.createElement(
	            'span',
	            { className: 'mx_MemberEventListSummary_avatars' },
	            avatars
	        );
	    },
	
	    _getTransitionSequence: function _getTransitionSequence(events) {
	        return events.map(this._getTransition);
	    },
	
	    /**
	     * Label a given membership event, `e`, where `getContent().membership` has
	     * changed for each transition allowed by the Matrix protocol. This attempts to
	     * label the membership changes that occur in `../../../TextForEvent.js`.
	     * @param {MatrixEvent} e the membership change event to label.
	     * @returns {string?} the transition type given to this event. This defaults to `null`
	     * if a transition is not recognised.
	     */
	    _getTransition: function _getTransition(e) {
	        switch (e.mxEvent.getContent().membership) {
	            case 'invite':
	                return 'invited';
	            case 'ban':
	                return 'banned';
	            case 'join':
	                return 'joined';
	            case 'leave':
	                if (e.mxEvent.getSender() === e.mxEvent.getStateKey()) {
	                    switch (e.mxEvent.getPrevContent().membership) {
	                        case 'invite':
	                            return 'invite_reject';
	                        default:
	                            return 'left';
	                    }
	                }
	                switch (e.mxEvent.getPrevContent().membership) {
	                    case 'invite':
	                        return 'invite_withdrawal';
	                    case 'ban':
	                        return 'unbanned';
	                    case 'join':
	                        return 'kicked';
	                    default:
	                        return 'left';
	                }
	            default:
	                return null;
	        }
	    },
	
	    _getAggregate: function _getAggregate(userEvents) {
	        var _this2 = this;
	
	        // A map of aggregate type to arrays of display names. Each aggregate type
	        // is a comma-delimited string of transitions, e.g. "joined,left,kicked".
	        // The array of display names is the array of users who went through that
	        // sequence during eventsToRender.
	        var aggregate = {
	            // $aggregateType : []:string
	        };
	        // A map of aggregate types to the indices that order them (the index of
	        // the first event for a given transition sequence)
	        var aggregateIndices = {
	            // $aggregateType : int
	        };
	
	        var users = (0, _keys2.default)(userEvents);
	        users.forEach(function (userId) {
	            var firstEvent = userEvents[userId][0];
	            var displayName = firstEvent.displayName;
	
	            var seq = _this2._getTransitionSequence(userEvents[userId]);
	            if (!aggregate[seq]) {
	                aggregate[seq] = [];
	                aggregateIndices[seq] = -1;
	            }
	
	            aggregate[seq].push(displayName);
	
	            if (aggregateIndices[seq] === -1 || firstEvent.index < aggregateIndices[seq]) {
	                aggregateIndices[seq] = firstEvent.index;
	            }
	        });
	
	        return {
	            names: aggregate,
	            indices: aggregateIndices
	        };
	    },
	
	    render: function render() {
	        var eventsToRender = this.props.events;
	        var fewEvents = eventsToRender.length < this.props.threshold;
	        var expanded = this.state.expanded || fewEvents;
	
	        var expandedEvents = null;
	        if (expanded) {
	            expandedEvents = this.props.children;
	        }
	
	        if (fewEvents) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_MemberEventListSummary' },
	                expandedEvents
	            );
	        }
	
	        // Map user IDs to an array of objects:
	        var userEvents = {
	            // $userId : [{
	            //     // The original event
	            //     mxEvent: e,
	            //     // The display name of the user (if not, then user ID)
	            //     displayName: e.target.name || userId,
	            //     // The original index of the event in this.props.events
	            //     index: index,
	            // }]
	        };
	
	        var avatarMembers = [];
	        eventsToRender.forEach(function (e, index) {
	            var userId = e.getStateKey();
	            // Initialise a user's events
	            if (!userEvents[userId]) {
	                userEvents[userId] = [];
	                if (e.target) avatarMembers.push(e.target);
	            }
	            userEvents[userId].push({
	                mxEvent: e,
	                displayName: (e.target ? e.target.name : null) || userId,
	                index: index
	            });
	        });
	
	        var aggregate = this._getAggregate(userEvents);
	
	        // Sort types by order of lowest event index within sequence
	        var orderedTransitionSequences = (0, _keys2.default)(aggregate.names).sort(function (seq1, seq2) {
	            return aggregate.indices[seq1] > aggregate.indices[seq2];
	        });
	
	        var summaryContainer = null;
	        if (!expanded) {
	            summaryContainer = _react2.default.createElement(
	                'div',
	                { className: 'mx_EventTile_line' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_EventTile_info' },
	                    this._renderAvatars(avatarMembers),
	                    this._renderSummary(aggregate.names, orderedTransitionSequences)
	                )
	            );
	        }
	        var toggleButton = _react2.default.createElement(
	            'div',
	            { className: "mx_MemberEventListSummary_toggle", onClick: this._toggleSummary },
	            expanded ? 'collapse' : 'expand'
	        );
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_MemberEventListSummary' },
	            toggleButton,
	            summaryContainer,
	            expanded ? _react2.default.createElement(
	                'div',
	                { className: 'mx_MemberEventListSummary_line' },
	                '\xA0'
	            ) : null,
	            expandedEvents
	        );
	    }
	});


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var roles = {
	    0: 'User',
	    50: 'Moderator',
	    100: 'Admin'
	};
	
	var reverseRoles = {};
	(0, _keys2.default)(roles).forEach(function (key) {
	    reverseRoles[roles[key]] = key;
	});
	
	module.exports = React.createClass({
	    displayName: 'PowerSelector',
	
	    propTypes: {
	        value: React.PropTypes.number.isRequired,
	
	        // if true, the <select/> should be a 'controlled' form element and updated by React
	        // to reflect the current value, rather than left freeform.
	        // MemberInfo uses controlled; RoomSettings uses non-controlled.
	        //
	        // ignored if disabled is truthy. false by default.
	        controlled: React.PropTypes.bool,
	
	        // should the user be able to change the value? false by default.
	        disabled: React.PropTypes.bool,
	        onChange: React.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            custom: roles[this.props.value] === undefined
	        };
	    },
	
	    onSelectChange: function onSelectChange(event) {
	        this.setState({ custom: event.target.value === "Custom" });
	        if (event.target.value !== "Custom") {
	            this.props.onChange(this.getValue());
	        }
	    },
	
	    onCustomBlur: function onCustomBlur(event) {
	        this.props.onChange(this.getValue());
	    },
	
	    onCustomKeyDown: function onCustomKeyDown(event) {
	        if (event.key == "Enter") {
	            this.props.onChange(this.getValue());
	        }
	    },
	
	    getValue: function getValue() {
	        var value;
	        if (this.refs.select) {
	            value = reverseRoles[this.refs.select.value];
	            if (this.refs.custom) {
	                if (value === undefined) value = parseInt(this.refs.custom.value);
	            }
	        }
	        return value;
	    },
	
	    render: function render() {
	        var customPicker;
	        if (this.state.custom) {
	            var input;
	            if (this.props.disabled) {
	                input = React.createElement(
	                    'span',
	                    null,
	                    this.props.value
	                );
	            } else {
	                input = React.createElement('input', { ref: 'custom', type: 'text', size: '3', defaultValue: this.props.value, onBlur: this.onCustomBlur, onKeyDown: this.onCustomKeyDown });
	            }
	            customPicker = React.createElement(
	                'span',
	                null,
	                ' of ',
	                input
	            );
	        }
	
	        var selectValue;
	        if (this.state.custom) {
	            selectValue = "Custom";
	        } else {
	            selectValue = roles[this.props.value] || "Custom";
	        }
	        var select;
	        if (this.props.disabled) {
	            select = React.createElement(
	                'span',
	                null,
	                selectValue
	            );
	        } else {
	            select = React.createElement(
	                'select',
	                { ref: 'select',
	                    value: this.props.controlled ? selectValue : undefined,
	                    defaultValue: !this.props.controlled ? selectValue : undefined,
	                    onChange: this.onSelectChange },
	                React.createElement(
	                    'option',
	                    { value: 'User' },
	                    'User (0)'
	                ),
	                React.createElement(
	                    'option',
	                    { value: 'Moderator' },
	                    'Moderator (50)'
	                ),
	                React.createElement(
	                    'option',
	                    { value: 'Admin' },
	                    'Admin (100)'
	                ),
	                React.createElement(
	                    'option',
	                    { value: 'Custom' },
	                    'Custom level'
	                )
	            );
	        }
	
	        return React.createElement(
	            'span',
	            { className: 'mx_PowerSelector' },
	            select,
	            customPicker
	        );
	    }
	});


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'ProgressBar',
	    propTypes: {
	        value: React.PropTypes.number,
	        max: React.PropTypes.number
	    },
	
	    render: function render() {
	        // Would use an HTML5 progress tag but if that doesn't animate if you
	        // use the HTML attributes rather than styles
	        var progressStyle = {
	            width: this.props.value / this.props.max * 100 + "%"
	        };
	        return React.createElement(
	            'div',
	            { className: 'mx_ProgressBar' },
	            React.createElement('div', { className: 'mx_ProgressBar_fill', style: progressStyle })
	        );
	    }
	});


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var Tinter = __webpack_require__(140);
	
	var TintableSvg = React.createClass({
	    displayName: 'TintableSvg',
	
	    propTypes: {
	        src: React.PropTypes.string.isRequired,
	        width: React.PropTypes.string.isRequired,
	        height: React.PropTypes.string.isRequired,
	        className: React.PropTypes.string
	    },
	
	    statics: {
	        // list of currently mounted TintableSvgs
	        mounts: {},
	        idSequence: 0
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.fixups = [];
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.id = TintableSvg.idSequence++;
	        TintableSvg.mounts[this.id] = this;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        delete TintableSvg.mounts[this.id];
	    },
	
	    tint: function tint() {
	        // TODO: only bother running this if the global tint settings have changed
	        // since we loaded!
	        Tinter.applySvgFixups(this.fixups);
	    },
	
	    onLoad: function onLoad(event) {
	        // console.log("TintableSvg.onLoad for " + this.props.src);
	        this.fixups = Tinter.calcSvgFixups([event.target]);
	        Tinter.applySvgFixups(this.fixups);
	    },
	
	    render: function render() {
	        return React.createElement('object', { className: "mx_TintableSvg " + (this.props.className ? this.props.className : ""),
	            type: 'image/svg+xml',
	            data: this.props.src,
	            width: this.props.width,
	            height: this.props.height,
	            onLoad: this.onLoad,
	            tabIndex: '-1'
	        });
	    }
	});
	
	// Register with the Tinter so that we will be told if the tint changes
	Tinter.registerTintable(function () {
	    if (TintableSvg.mounts) {
	        (0, _keys2.default)(TintableSvg.mounts).forEach(function (id) {
	            TintableSvg.mounts[id].tint();
	        });
	    }
	});
	
	module.exports = TintableSvg;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'TruncatedList',
	
	    propTypes: {
	        // The number of elements to show before truncating. If negative, no truncation is done.
	        truncateAt: React.PropTypes.number,
	        // The className to apply to the wrapping div
	        className: React.PropTypes.string,
	        // A function which will be invoked when an overflow element is required.
	        // This will be inserted after the children.
	        createOverflowElement: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            truncateAt: 2,
	            createOverflowElement: function createOverflowElement(overflowCount, totalCount) {
	                return React.createElement(
	                    'div',
	                    null,
	                    'And ',
	                    overflowCount,
	                    ' more...'
	                );
	            }
	        };
	    },
	
	    render: function render() {
	        var childsJsx = this.props.children;
	        var overflowJsx;
	        var childArray = React.Children.toArray(this.props.children).filter(function (c) {
	            return c != null;
	        });
	
	        var childCount = childArray.length;
	
	        if (this.props.truncateAt >= 0) {
	            var overflowCount = childCount - this.props.truncateAt;
	
	            if (overflowCount > 1) {
	                overflowJsx = this.props.createOverflowElement(overflowCount, childCount);
	
	                // cut out the overflow elements
	                childArray.splice(childCount - overflowCount, overflowCount);
	                childsJsx = childArray; // use what is left
	            }
	        }
	
	        return React.createElement(
	            'div',
	            { className: this.props.className },
	            childsJsx,
	            overflowJsx
	        );
	    }
	});


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'UserSelector',
	
	    propTypes: {
	        onChange: React.PropTypes.func,
	        selected_users: React.PropTypes.arrayOf(React.PropTypes.string)
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onChange: function onChange() {},
	            selected: []
	        };
	    },
	
	    addUser: function addUser(user_id) {
	        if (this.props.selected_users.indexOf(user_id == -1)) {
	            this.props.onChange(this.props.selected_users.concat([user_id]));
	        }
	    },
	
	    removeUser: function removeUser(user_id) {
	        this.props.onChange(this.props.selected_users.filter(function (e) {
	            return e != user_id;
	        }));
	    },
	
	    onAddUserId: function onAddUserId() {
	        this.addUser(this.refs.user_id_input.value);
	        this.refs.user_id_input.value = "";
	    },
	
	    render: function render() {
	        var self = this;
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'ul',
	                { className: 'mx_UserSelector_UserIdList', ref: 'list' },
	                this.props.selected_users.map(function (user_id, i) {
	                    return React.createElement(
	                        'li',
	                        { key: user_id },
	                        user_id,
	                        ' - ',
	                        React.createElement(
	                            'span',
	                            { onClick: function onClick() {
	                                    self.removeUser(user_id);
	                                } },
	                            'X'
	                        )
	                    );
	                })
	            ),
	            React.createElement('input', { type: 'text', ref: 'user_id_input', defaultValue: '', className: 'mx_UserSelector_userIdInput', placeholder: 'ex. @bob:example.com' }),
	            React.createElement(
	                'button',
	                { onClick: this.onAddUserId, className: 'mx_UserSelector_AddUserId' },
	                'Add User'
	            )
	        );
	    }
	});


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _phonenumber = __webpack_require__(519);
	
	var _HtmlUtils = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var COUNTRIES_BY_ISO2 = new Object(null);
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;
	
	try {
	    for (var _iterator = (0, _getIterator3.default)(_phonenumber.COUNTRIES), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var c = _step.value;
	
	        COUNTRIES_BY_ISO2[c.iso2] = c;
	    }
	} catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	} finally {
	    try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	        }
	    } finally {
	        if (_didIteratorError) {
	            throw _iteratorError;
	        }
	    }
	}
	
	function countryMatchesSearchQuery(query, country) {
	    if (country.name.toUpperCase().indexOf(query.toUpperCase()) == 0) return true;
	    if (country.iso2 == query.toUpperCase()) return true;
	    if (country.prefix == query) return true;
	    return false;
	}
	
	var MAX_DISPLAYED_ROWS = 2;
	
	var CountryDropdown = function (_React$Component) {
	    (0, _inherits3.default)(CountryDropdown, _React$Component);
	
	    function CountryDropdown(props) {
	        (0, _classCallCheck3.default)(this, CountryDropdown);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CountryDropdown.__proto__ || (0, _getPrototypeOf2.default)(CountryDropdown)).call(this, props));
	
	        _this._onSearchChange = _this._onSearchChange.bind(_this);
	
	        _this.state = {
	            searchQuery: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(CountryDropdown, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (!this.props.value) {
	                // If no value is given, we start with the first
	                // country selected, but our parent component
	                // doesn't know this, therefore we do this.
	                this.props.onOptionChange(_phonenumber.COUNTRIES[0].iso2);
	            }
	        }
	    }, {
	        key: '_onSearchChange',
	        value: function _onSearchChange(search) {
	            this.setState({
	                searchQuery: search
	            });
	        }
	    }, {
	        key: '_flagImgForIso2',
	        value: function _flagImgForIso2(iso2) {
	            // Unicode Regional Indicator Symbol letter 'A'
	            var RIS_A = 0x1F1E6;
	            var ASCII_A = 65;
	            return (0, _HtmlUtils.charactersToImageNode)(iso2, RIS_A + (iso2.charCodeAt(0) - ASCII_A), RIS_A + (iso2.charCodeAt(1) - ASCII_A));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var Dropdown = _index2.default.getComponent('elements.Dropdown');
	
	            var displayedCountries = void 0;
	            if (this.state.searchQuery) {
	                displayedCountries = _phonenumber.COUNTRIES.filter(countryMatchesSearchQuery.bind(this, this.state.searchQuery));
	                if (this.state.searchQuery.length == 2 && COUNTRIES_BY_ISO2[this.state.searchQuery.toUpperCase()]) {
	                    (function () {
	                        // exact ISO2 country name match: make the first result the matches ISO2
	                        var matched = COUNTRIES_BY_ISO2[_this2.state.searchQuery.toUpperCase()];
	                        displayedCountries = displayedCountries.filter(function (c) {
	                            return c.iso2 != matched.iso2;
	                        });
	                        displayedCountries.unshift(matched);
	                    })();
	                }
	            } else {
	                displayedCountries = _phonenumber.COUNTRIES;
	            }
	
	            if (displayedCountries.length > MAX_DISPLAYED_ROWS) {
	                displayedCountries = displayedCountries.slice(0, MAX_DISPLAYED_ROWS);
	            }
	
	            var options = displayedCountries.map(function (country) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: country.iso2 },
	                    _this2._flagImgForIso2(country.iso2),
	                    country.name
	                );
	            });
	
	            // default value here too, otherwise we need to handle null / undefined
	            // values between mounting and the initial value propgating
	            var value = this.props.value || _phonenumber.COUNTRIES[0].iso2;
	
	            return _react2.default.createElement(
	                Dropdown,
	                { className: this.props.className,
	                    onOptionChange: this.props.onOptionChange, onSearchChange: this._onSearchChange,
	                    menuWidth: 298, getShortOption: this._flagImgForIso2,
	                    value: value
	                },
	                options
	            );
	        }
	    }]);
	    return CountryDropdown;
	}(_react2.default.Component);
	
	exports.default = CountryDropdown;
	
	
	CountryDropdown.propTypes = {
	    className: _react2.default.PropTypes.string,
	    onOptionChange: _react2.default.PropTypes.func.isRequired,
	    value: _react2.default.PropTypes.string
	};
	module.exports = exports['default'];


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'CustomServerDialog',
	
	    render: function render() {
	        return React.createElement(
	            "div",
	            { className: "mx_ErrorDialog" },
	            React.createElement(
	                "div",
	                { className: "mx_Dialog_title" },
	                "Custom Server Options"
	            ),
	            React.createElement(
	                "div",
	                { className: "mx_Dialog_content" },
	                React.createElement(
	                    "span",
	                    null,
	                    "You can use the custom server options to sign into other Matrix servers by specifying a different Home server URL.",
	                    React.createElement("br", null),
	                    "This allows you to use this app with an existing Matrix account on a different home server.",
	                    React.createElement("br", null),
	                    React.createElement("br", null),
	                    "You can also set a custom identity server but this will typically prevent interaction with users based on email address."
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "mx_Dialog_buttons" },
	                React.createElement(
	                    "button",
	                    { onClick: this.props.onFinished, autoFocus: true },
	                    "Dismiss"
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'LoginFooter',
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_Login_links' },
	            React.createElement(
	                'a',
	                { href: 'https://matrix.org' },
	                'powered by Matrix'
	            )
	        );
	    }
	});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'LoginHeader',
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_Login_logo' },
	            'Matrix'
	        );
	    }
	});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 Copyright 2016 OpenMarket Ltd
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MFileBody = __webpack_require__(223);
	
	var _MFileBody2 = _interopRequireDefault(_MFileBody);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _DecryptFile = __webpack_require__(225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAudioBody = function (_React$Component) {
	    (0, _inherits3.default)(MAudioBody, _React$Component);
	
	    function MAudioBody(props) {
	        (0, _classCallCheck3.default)(this, MAudioBody);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MAudioBody.__proto__ || (0, _getPrototypeOf2.default)(MAudioBody)).call(this, props));
	
	        _this.state = {
	            playing: false,
	            decryptedUrl: null,
	            decryptedBlob: null,
	            error: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(MAudioBody, [{
	        key: 'onPlayToggle',
	        value: function onPlayToggle() {
	            this.setState({
	                playing: !this.state.playing
	            });
	        }
	    }, {
	        key: '_getContentUrl',
	        value: function _getContentUrl() {
	            var content = this.props.mxEvent.getContent();
	            if (content.file !== undefined) {
	                return this.state.decryptedUrl;
	            } else {
	                return _MatrixClientPeg2.default.get().mxcUrlToHttp(content.url);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var content = this.props.mxEvent.getContent();
	            if (content.file !== undefined && this.state.decryptedUrl === null) {
	                var decryptedBlob;
	                (0, _DecryptFile.decryptFile)(content.file).then(function (blob) {
	                    decryptedBlob = blob;
	                    return (0, _DecryptFile.readBlobAsDataUri)(decryptedBlob);
	                }).done(function (url) {
	                    _this2.setState({
	                        decryptedUrl: url,
	                        decryptedBlob: decryptedBlob
	                    });
	                }, function (err) {
	                    console.warn("Unable to decrypt attachment: ", err);
	                    _this2.setState({
	                        error: err
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var content = this.props.mxEvent.getContent();
	
	            if (this.state.error !== null) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'mx_MAudioBody', ref: 'body' },
	                    _react2.default.createElement('img', { src: 'img/warning.svg', width: '16', height: '16' }),
	                    'Error decrypting audio'
	                );
	            }
	
	            if (content.file !== undefined && this.state.decryptedUrl === null) {
	                // Need to decrypt the attachment
	                // The attachment is decrypted in componentDidMount.
	                // For now add an img tag with a 16x16 spinner.
	                // Not sure how tall the audio player is so not sure how tall it should actually be.
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'mx_MAudioBody' },
	                    _react2.default.createElement('img', { src: 'img/spinner.gif', alt: content.body, width: '16', height: '16' })
	                );
	            }
	
	            var contentUrl = this._getContentUrl();
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MAudioBody' },
	                _react2.default.createElement('audio', { src: contentUrl, controls: true }),
	                _react2.default.createElement(_MFileBody2.default, (0, _extends3.default)({}, this.props, { decryptedBlob: this.state.decryptedBlob }))
	            );
	        }
	    }]);
	    return MAudioBody;
	}(_react2.default.Component);
	
	exports.default = MAudioBody;
	module.exports = exports['default'];


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MFileBody = __webpack_require__(223);
	
	var _MFileBody2 = _interopRequireDefault(_MFileBody);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _ImageUtils = __webpack_require__(498);
	
	var _ImageUtils2 = _interopRequireDefault(_ImageUtils);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _DecryptFile = __webpack_require__(225);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _UserSettingsStore = __webpack_require__(74);
	
	var _UserSettingsStore2 = _interopRequireDefault(_UserSettingsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _react2.default.createClass({
	    displayName: 'MImageBody',
	
	    propTypes: {
	        /* the MatrixEvent to show */
	        mxEvent: _react2.default.PropTypes.object.isRequired,
	
	        /* called when the image has loaded */
	        onWidgetLoad: _react2.default.PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            decryptedUrl: null,
	            decryptedThumbnailUrl: null,
	            decryptedBlob: null,
	            error: null
	        };
	    },
	
	    onClick: function onClick(ev) {
	        if (ev.button == 0 && !ev.metaKey) {
	            ev.preventDefault();
	            var content = this.props.mxEvent.getContent();
	            var httpUrl = this._getContentUrl();
	            var ImageView = _index2.default.getComponent("elements.ImageView");
	            var params = {
	                src: httpUrl,
	                mxEvent: this.props.mxEvent
	            };
	
	            if (content.info) {
	                params.width = content.info.w;
	                params.height = content.info.h;
	                params.fileSize = content.info.size;
	            }
	
	            _Modal2.default.createDialog(ImageView, params, "mx_Dialog_lightbox");
	        }
	    },
	
	    _isGif: function _isGif() {
	        var content = this.props.mxEvent.getContent();
	        return content && content.info && content.info.mimetype === "image/gif";
	    },
	
	    onImageEnter: function onImageEnter(e) {
	        if (!this._isGif() || _UserSettingsStore2.default.getSyncedSetting("autoplayGifsAndVideos", false)) {
	            return;
	        }
	        var imgElement = e.target;
	        imgElement.src = this._getContentUrl();
	    },
	
	    onImageLeave: function onImageLeave(e) {
	        if (!this._isGif() || _UserSettingsStore2.default.getSyncedSetting("autoplayGifsAndVideos", false)) {
	            return;
	        }
	        var imgElement = e.target;
	        imgElement.src = this._getThumbUrl();
	    },
	
	    _getContentUrl: function _getContentUrl() {
	        var content = this.props.mxEvent.getContent();
	        if (content.file !== undefined) {
	            return this.state.decryptedUrl;
	        } else {
	            return _MatrixClientPeg2.default.get().mxcUrlToHttp(content.url);
	        }
	    },
	
	    _getThumbUrl: function _getThumbUrl() {
	        var content = this.props.mxEvent.getContent();
	        if (content.file !== undefined) {
	            // Don't use the thumbnail for clients wishing to autoplay gifs.
	            if (this.state.decryptedThumbnailUrl) {
	                return this.state.decryptedThumbnailUrl;
	            }
	            return this.state.decryptedUrl;
	        } else {
	            return _MatrixClientPeg2.default.get().mxcUrlToHttp(content.url, 800, 600);
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        this.dispatcherRef = _dispatcher2.default.register(this.onAction);
	        this.fixupHeight();
	        var content = this.props.mxEvent.getContent();
	        if (content.file !== undefined && this.state.decryptedUrl === null) {
	            (function () {
	                var thumbnailPromise = (0, _q2.default)(null);
	                if (content.info.thumbnail_file) {
	                    thumbnailPromise = (0, _DecryptFile.decryptFile)(content.info.thumbnail_file).then(function (blob) {
	                        return (0, _DecryptFile.readBlobAsDataUri)(blob);
	                    });
	                }
	                var decryptedBlob = void 0;
	                thumbnailPromise.then(function (thumbnailUrl) {
	                    return (0, _DecryptFile.decryptFile)(content.file).then(function (blob) {
	                        decryptedBlob = blob;
	                        return (0, _DecryptFile.readBlobAsDataUri)(blob);
	                    }).then(function (contentUrl) {
	                        _this.setState({
	                            decryptedUrl: contentUrl,
	                            decryptedThumbnailUrl: thumbnailUrl,
	                            decryptedBlob: decryptedBlob
	                        });
	                        _this.props.onWidgetLoad();
	                    });
	                }).catch(function (err) {
	                    console.warn("Unable to decrypt attachment: ", err);
	                    // Set a placeholder image when we can't decrypt the image.
	                    _this.setState({
	                        error: err
	                    });
	                }).done();
	            })();
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        _dispatcher2.default.unregister(this.dispatcherRef);
	    },
	
	    onAction: function onAction(payload) {
	        if (payload.action === "timeline_resize") {
	            this.fixupHeight();
	        }
	    },
	
	    fixupHeight: function fixupHeight() {
	        if (!this.refs.image) {
	            console.warn("Refusing to fix up height on MImageBody with no image element");
	            return;
	        }
	
	        var content = this.props.mxEvent.getContent();
	        var timelineWidth = this.refs.body.offsetWidth;
	        var maxHeight = 600; // let images take up as much width as they can so long as the height doesn't exceed 600px.
	        // the alternative here would be 600*timelineWidth/800; to scale them down to fit inside a 4:3 bounding box
	
	        //console.log("trying to fit image into timelineWidth of " + this.refs.body.offsetWidth + " or " + this.refs.body.clientWidth);
	        var thumbHeight = null;
	        if (content.info) {
	            thumbHeight = _ImageUtils2.default.thumbHeight(content.info.w, content.info.h, timelineWidth, maxHeight);
	        }
	        this.refs.image.style.height = thumbHeight + "px";
	        // console.log("Image height now", thumbHeight);
	    },
	
	    render: function render() {
	        var TintableSvg = _index2.default.getComponent("elements.TintableSvg");
	        var content = this.props.mxEvent.getContent();
	
	        if (this.state.error !== null) {
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MImageBody', ref: 'body' },
	                _react2.default.createElement('img', { src: 'img/warning.svg', width: '16', height: '16' }),
	                'Error decrypting image'
	            );
	        }
	
	        if (content.file !== undefined && this.state.decryptedUrl === null) {
	            // Need to decrypt the attachment
	            // The attachment is decrypted in componentDidMount.
	            // For now add an img tag with a spinner.
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MImageBody', ref: 'body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MImageBody_thumbnail', ref: 'image', style: {
	                            "display": "flex",
	                            "alignItems": "center",
	                            "width": "100%"
	                        } },
	                    _react2.default.createElement('img', { src: 'img/spinner.gif', alt: content.body, width: '32', height: '32', style: {
	                            "margin": "auto"
	                        } })
	                )
	            );
	        }
	
	        var contentUrl = this._getContentUrl();
	        var thumbUrl = void 0;
	        if (this._isGif() && _UserSettingsStore2.default.getSyncedSetting("autoplayGifsAndVideos", false)) {
	            thumbUrl = contentUrl;
	        } else {
	            thumbUrl = this._getThumbUrl();
	        }
	
	        if (thumbUrl) {
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MImageBody', ref: 'body' },
	                _react2.default.createElement(
	                    'a',
	                    { href: contentUrl, onClick: this.onClick },
	                    _react2.default.createElement('img', { className: 'mx_MImageBody_thumbnail', src: thumbUrl, ref: 'image',
	                        alt: content.body,
	                        onMouseEnter: this.onImageEnter,
	                        onMouseLeave: this.onImageLeave })
	                ),
	                _react2.default.createElement(_MFileBody2.default, (0, _extends3.default)({}, this.props, { decryptedBlob: this.state.decryptedBlob }))
	            );
	        } else if (content.body) {
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MImageBody' },
	                'Image \'',
	                content.body,
	                '\' cannot be displayed.'
	            );
	        } else {
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MImageBody' },
	                'This image cannot be displayed.'
	            );
	        }
	    }
	});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MFileBody = __webpack_require__(223);
	
	var _MFileBody2 = _interopRequireDefault(_MFileBody);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _DecryptFile = __webpack_require__(225);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _UserSettingsStore = __webpack_require__(74);
	
	var _UserSettingsStore2 = _interopRequireDefault(_UserSettingsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _react2.default.createClass({
	    displayName: 'MVideoBody',
	
	    propTypes: {
	        /* the MatrixEvent to show */
	        mxEvent: _react2.default.PropTypes.object.isRequired,
	
	        /* called when the video has loaded */
	        onWidgetLoad: _react2.default.PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            decryptedUrl: null,
	            decryptedThumbnailUrl: null,
	            decryptedBlob: null,
	            error: null
	        };
	    },
	
	    thumbScale: function thumbScale(fullWidth, fullHeight, thumbWidth, thumbHeight) {
	        if (!fullWidth || !fullHeight) {
	            // Cannot calculate thumbnail height for image: missing w/h in metadata. We can't even
	            // log this because it's spammy
	            return undefined;
	        }
	        if (fullWidth < thumbWidth && fullHeight < thumbHeight) {
	            // no scaling needs to be applied
	            return 1;
	        }
	        var widthMulti = thumbWidth / fullWidth;
	        var heightMulti = thumbHeight / fullHeight;
	        if (widthMulti < heightMulti) {
	            // width is the dominant dimension so scaling will be fixed on that
	            return widthMulti;
	        } else {
	            // height is the dominant dimension so scaling will be fixed on that
	            return heightMulti;
	        }
	    },
	
	    _getContentUrl: function _getContentUrl() {
	        var content = this.props.mxEvent.getContent();
	        if (content.file !== undefined) {
	            return this.state.decryptedUrl;
	        } else {
	            return _MatrixClientPeg2.default.get().mxcUrlToHttp(content.url);
	        }
	    },
	
	    _getThumbUrl: function _getThumbUrl() {
	        var content = this.props.mxEvent.getContent();
	        if (content.file !== undefined) {
	            return this.state.decryptedThumbnailUrl;
	        } else if (content.info.thumbnail_url) {
	            return _MatrixClientPeg2.default.get().mxcUrlToHttp(content.info.thumbnail_url);
	        } else {
	            return null;
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        var content = this.props.mxEvent.getContent();
	        if (content.file !== undefined && this.state.decryptedUrl === null) {
	            var thumbnailPromise = (0, _q2.default)(null);
	            if (content.info.thumbnail_file) {
	                thumbnailPromise = (0, _DecryptFile.decryptFile)(content.info.thumbnail_file).then(function (blob) {
	                    return (0, _DecryptFile.readBlobAsDataUri)(blob);
	                });
	            }
	            var decryptedBlob;
	            thumbnailPromise.then(function (thumbnailUrl) {
	                return (0, _DecryptFile.decryptFile)(content.file).then(function (blob) {
	                    decryptedBlob = blob;
	                    return (0, _DecryptFile.readBlobAsDataUri)(blob);
	                }).then(function (contentUrl) {
	                    _this.setState({
	                        decryptedUrl: contentUrl,
	                        decryptedThumbnailUrl: thumbnailUrl,
	                        decryptedBlob: decryptedBlob
	                    });
	                    _this.props.onWidgetLoad();
	                });
	            }).catch(function (err) {
	                console.warn("Unable to decrypt attachment: ", err);
	                // Set a placeholder image when we can't decrypt the image.
	                _this.setState({
	                    error: err
	                });
	            }).done();
	        }
	    },
	
	    render: function render() {
	        var content = this.props.mxEvent.getContent();
	
	        if (this.state.error !== null) {
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MVideoBody', ref: 'body' },
	                _react2.default.createElement('img', { src: 'img/warning.svg', width: '16', height: '16' }),
	                'Error decrypting video'
	            );
	        }
	
	        if (content.file !== undefined && this.state.decryptedUrl === null) {
	            // Need to decrypt the attachment
	            // The attachment is decrypted in componentDidMount.
	            // For now add an img tag with a spinner.
	            return _react2.default.createElement(
	                'span',
	                { className: 'mx_MVideoBody', ref: 'body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MImageBody_thumbnail', ref: 'image', style: {
	                            "display": "flex",
	                            "align-items": "center",
	                            "justify-items": "center",
	                            "width": "100%"
	                        } },
	                    _react2.default.createElement('img', { src: 'img/spinner.gif', alt: content.body, width: '16', height: '16' })
	                )
	            );
	        }
	
	        var contentUrl = this._getContentUrl();
	        var thumbUrl = this._getThumbUrl();
	        var autoplay = _UserSettingsStore2.default.getSyncedSetting("autoplayGifsAndVideos", false);
	        var height = null;
	        var width = null;
	        var poster = null;
	        var preload = "metadata";
	        if (content.info) {
	            var scale = this.thumbScale(content.info.w, content.info.h, 480, 360);
	            if (scale) {
	                width = Math.floor(content.info.w * scale);
	                height = Math.floor(content.info.h * scale);
	            }
	
	            if (thumbUrl) {
	                poster = thumbUrl;
	                preload = "none";
	            }
	        }
	        return _react2.default.createElement(
	            'span',
	            { className: 'mx_MVideoBody' },
	            _react2.default.createElement('video', { className: 'mx_MVideoBody', src: contentUrl, alt: content.body,
	                controls: true, preload: preload, muted: autoplay, autoPlay: autoplay,
	                height: height, width: width, poster: poster }),
	            _react2.default.createElement(_MFileBody2.default, (0, _extends3.default)({}, this.props, { decryptedBlob: this.state.decryptedBlob }))
	        );
	    }
	});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'MessageEvent',
	
	    propTypes: {
	        /* the MatrixEvent to show */
	        mxEvent: React.PropTypes.object.isRequired,
	
	        /* a list of words to highlight */
	        highlights: React.PropTypes.array,
	
	        /* link URL for the highlights */
	        highlightLink: React.PropTypes.string,
	
	        /* should show URL previews for this event */
	        showUrlPreview: React.PropTypes.bool,
	
	        /* callback called when dynamic content in events are loaded */
	        onWidgetLoad: React.PropTypes.func,
	
	        /* the shsape of the tile, used */
	        tileShape: React.PropTypes.string
	    },
	
	    getEventTileOps: function getEventTileOps() {
	        return this.refs.body && this.refs.body.getEventTileOps ? this.refs.body.getEventTileOps() : null;
	    },
	
	    render: function render() {
	        var UnknownBody = sdk.getComponent('messages.UnknownBody');
	
	        var bodyTypes = {
	            'm.text': sdk.getComponent('messages.TextualBody'),
	            'm.notice': sdk.getComponent('messages.TextualBody'),
	            'm.emote': sdk.getComponent('messages.TextualBody'),
	            'm.image': sdk.getComponent('messages.MImageBody'),
	            'm.file': sdk.getComponent('messages.MFileBody'),
	            'm.audio': sdk.getComponent('messages.MAudioBody'),
	            'm.video': sdk.getComponent('messages.MVideoBody')
	        };
	
	        var content = this.props.mxEvent.getContent();
	        var msgtype = content.msgtype;
	        var BodyType = UnknownBody;
	        if (msgtype && bodyTypes[msgtype]) {
	            BodyType = bodyTypes[msgtype];
	        } else if (content.url) {
	            // Fallback to MFileBody if there's a content URL
	            BodyType = bodyTypes['m.file'];
	        }
	
	        return React.createElement(BodyType, { ref: 'body', mxEvent: this.props.mxEvent, highlights: this.props.highlights,
	            highlightLink: this.props.highlightLink,
	            showUrlPreview: this.props.showUrlPreview,
	            tileShape: this.props.tileShape,
	            onWidgetLoad: this.props.onWidgetLoad });
	    }
	});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 Copyright 2015, 2016 OpenMarket Ltd
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SenderProfile;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SenderProfile(props) {
	    var EmojiText = _index2.default.getComponent('elements.EmojiText');
	    var mxEvent = props.mxEvent;
	
	    var name = mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender();
	
	    var _mxEvent$getContent = mxEvent.getContent(),
	        msgtype = _mxEvent$getContent.msgtype;
	
	    if (msgtype === 'm.emote') {
	        return _react2.default.createElement('span', null); // emote message must include the name so don't duplicate it
	    }
	
	    return _react2.default.createElement(
	        EmojiText,
	        { className: 'mx_SenderProfile',
	            onClick: props.onClick },
	        (name || '') + ' ' + (props.aux || '')
	    );
	}
	
	SenderProfile.propTypes = {
	    mxEvent: _react2.default.PropTypes.object.isRequired, // event whose sender we're showing
	    aux: _react2.default.PropTypes.string, // stuff to go after the sender name, if anything
	    onClick: _react2.default.PropTypes.func
	};
	module.exports = exports['default'];


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(18);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _highlight = __webpack_require__(523);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _HtmlUtils = __webpack_require__(219);
	
	var HtmlUtils = _interopRequireWildcard(_HtmlUtils);
	
	var _linkifyjs = __webpack_require__(204);
	
	var linkify = _interopRequireWildcard(_linkifyjs);
	
	var _element = __webpack_require__(302);
	
	var _element2 = _interopRequireDefault(_element);
	
	var _linkifyMatrix = __webpack_require__(142);
	
	var _linkifyMatrix2 = _interopRequireDefault(_linkifyMatrix);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ScalarAuthClient = __webpack_require__(505);
	
	var _ScalarAuthClient2 = _interopRequireDefault(_ScalarAuthClient);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _SdkConfig = __webpack_require__(118);
	
	var _SdkConfig2 = _interopRequireDefault(_SdkConfig);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _linkifyMatrix2.default)(linkify);
	
	module.exports = _react2.default.createClass({
	    displayName: 'TextualBody',
	
	    propTypes: {
	        /* the MatrixEvent to show */
	        mxEvent: _react2.default.PropTypes.object.isRequired,
	
	        /* a list of words to highlight */
	        highlights: _react2.default.PropTypes.array,
	
	        /* link URL for the highlights */
	        highlightLink: _react2.default.PropTypes.string,
	
	        /* should show URL previews for this event */
	        showUrlPreview: _react2.default.PropTypes.bool,
	
	        /* callback for when our widget has loaded */
	        onWidgetLoad: _react2.default.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            // the URLs (if any) to be previewed with a LinkPreviewWidget
	            // inside this TextualBody.
	            links: [],
	
	            // track whether the preview widget is hidden
	            widgetHidden: false
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        this._unmounted = false;
	
	        (0, _element2.default)(this.refs.content, _linkifyMatrix2.default.options);
	        this.calculateUrlPreview();
	
	        if (this.props.mxEvent.getContent().format === "org.matrix.custom.html") {
	            (function () {
	                var blocks = _reactDom2.default.findDOMNode(_this).getElementsByTagName("code");
	                if (blocks.length > 0) {
	                    // Do this asynchronously: parsing code takes time and we don't
	                    // need to block the DOM update on it.
	                    setTimeout(function () {
	                        if (_this._unmounted) return;
	                        for (var i = 0; i < blocks.length; i++) {
	                            _highlight2.default.highlightBlock(blocks[i]);
	                        }
	                    }, 10);
	                }
	            })();
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        this.calculateUrlPreview();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this._unmounted = true;
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        //console.log("shouldComponentUpdate: ShowUrlPreview for %s is %s", this.props.mxEvent.getId(), this.props.showUrlPreview);
	
	        // exploit that events are immutable :)
	        return nextProps.mxEvent.getId() !== this.props.mxEvent.getId() || nextProps.highlights !== this.props.highlights || nextProps.highlightLink !== this.props.highlightLink || nextProps.showUrlPreview !== this.props.showUrlPreview || nextState.links !== this.state.links || nextState.widgetHidden !== this.state.widgetHidden;
	    },
	
	    calculateUrlPreview: function calculateUrlPreview() {
	        //console.log("calculateUrlPreview: ShowUrlPreview for %s is %s", this.props.mxEvent.getId(), this.props.showUrlPreview);
	
	        if (this.props.showUrlPreview && !this.state.links.length) {
	            var links = this.findLinks(this.refs.content.children);
	            if (links.length) {
	                this.setState({ links: links.map(function (link) {
	                        return link.getAttribute("href");
	                    }) });
	
	                // lazy-load the hidden state of the preview widget from localstorage
	                if (global.localStorage) {
	                    var hidden = global.localStorage.getItem("hide_preview_" + this.props.mxEvent.getId());
	                    this.setState({ widgetHidden: hidden });
	                }
	            }
	        }
	    },
	
	    findLinks: function findLinks(nodes) {
	        var links = [];
	        for (var i = 0; i < nodes.length; i++) {
	            var node = nodes[i];
	            if (node.tagName === "A" && node.getAttribute("href")) {
	                if (this.isLinkPreviewable(node)) {
	                    links.push(node);
	                }
	            } else if (node.tagName === "PRE" || node.tagName === "CODE") {
	                continue;
	            } else if (node.children && node.children.length) {
	                links = links.concat(this.findLinks(node.children));
	            }
	        }
	        return links;
	    },
	
	    isLinkPreviewable: function isLinkPreviewable(node) {
	        // don't try to preview relative links
	        if (!node.getAttribute("href").startsWith("http://") && !node.getAttribute("href").startsWith("https://")) {
	            return false;
	        }
	
	        // as a random heuristic to avoid highlighting things like "foo.pl"
	        // we require the linked text to either include a / (either from http://
	        // or from a full foo.bar/baz style schemeless URL) - or be a markdown-style
	        // link, in which case we check the target text differs from the link value.
	        // TODO: make this configurable?
	        if (node.textContent.indexOf("/") > -1) {
	            return true;
	        } else {
	            var url = node.getAttribute("href");
	            var host = url.match(/^https?:\/\/(.*?)(\/|$)/)[1];
	
	            // never preview matrix.to links (if anything we should give a smart
	            // preview of the room/user they point to: nobody needs to be reminded
	            // what the matrix.to site looks like).
	            if (host == 'matrix.to') return false;
	
	            if (node.textContent.toLowerCase().trim().startsWith(host.toLowerCase())) {
	                // it's a "foo.pl" style link
	                return false;
	            } else {
	                // it's a [foo bar](http://foo.com) style link
	                return true;
	            }
	        }
	    },
	
	    onCancelClick: function onCancelClick(event) {
	        this.setState({ widgetHidden: true });
	        // FIXME: persist this somewhere smarter than local storage
	        if (global.localStorage) {
	            global.localStorage.setItem("hide_preview_" + this.props.mxEvent.getId(), "1");
	        }
	        this.forceUpdate();
	    },
	
	    onEmoteSenderClick: function onEmoteSenderClick(event) {
	        var mxEvent = this.props.mxEvent;
	        var name = mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender();
	        _dispatcher2.default.dispatch({
	            action: 'insert_displayname',
	            displayname: name.replace(' (IRC)', '')
	        });
	    },
	
	    getEventTileOps: function getEventTileOps() {
	        var self = this;
	        return {
	            isWidgetHidden: function isWidgetHidden() {
	                return self.state.widgetHidden;
	            },
	
	            unhideWidget: function unhideWidget() {
	                self.setState({ widgetHidden: false });
	                if (global.localStorage) {
	                    global.localStorage.removeItem("hide_preview_" + self.props.mxEvent.getId());
	                }
	            }
	        };
	    },
	
	    onStarterLinkClick: function onStarterLinkClick(starterLink, ev) {
	        ev.preventDefault();
	        // We need to add on our scalar token to the starter link, but we may not have one!
	        // In addition, we can't fetch one on click and then go to it immediately as that
	        // is then treated as a popup!
	        // We can get around this by fetching one now and showing a "confirmation dialog" (hurr hurr)
	        // which requires the user to click through and THEN we can open the link in a new tab because
	        // the window.open command occurs in the same stack frame as the onClick callback.
	
	        // Go fetch a scalar token
	        var scalarClient = new _ScalarAuthClient2.default();
	        scalarClient.connect().then(function () {
	            var completeUrl = scalarClient.getStarterLink(starterLink);
	            var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
	            var integrationsUrl = _SdkConfig2.default.get().integrations_ui_url;
	            _Modal2.default.createDialog(QuestionDialog, {
	                title: "Add an Integration",
	                description: _react2.default.createElement(
	                    'div',
	                    null,
	                    'You are about to be taken to a third-party site so you can authenticate your account for use with ',
	                    integrationsUrl,
	                    '.',
	                    _react2.default.createElement('br', null),
	                    'Do you wish to continue?'
	                ),
	                button: "Continue",
	                onFinished: function onFinished(confirmed) {
	                    if (!confirmed) {
	                        return;
	                    }
	                    var width = window.screen.width > 1024 ? 1024 : window.screen.width;
	                    var height = window.screen.height > 800 ? 800 : window.screen.height;
	                    var left = (window.screen.width - width) / 2;
	                    var top = (window.screen.height - height) / 2;
	                    window.open(completeUrl, '_blank', 'height=' + height + ', width=' + width + ', top=' + top + ', left=' + left + ',');
	                }
	            });
	        });
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var EmojiText = _index2.default.getComponent('elements.EmojiText');
	        var mxEvent = this.props.mxEvent;
	        var content = mxEvent.getContent();
	
	        var body = HtmlUtils.bodyToHtml(content, this.props.highlights, {});
	
	        if (this.props.highlightLink) {
	            body = _react2.default.createElement(
	                'a',
	                { href: this.props.highlightLink },
	                body
	            );
	        } else if (content.data && typeof content.data["org.matrix.neb.starter_link"] === "string") {
	            body = _react2.default.createElement(
	                'a',
	                { href: '#', onClick: this.onStarterLinkClick.bind(this, content.data["org.matrix.neb.starter_link"]) },
	                body
	            );
	        }
	
	        var widgets;
	        if (this.state.links.length && !this.state.widgetHidden && this.props.showUrlPreview) {
	            var LinkPreviewWidget = _index2.default.getComponent('rooms.LinkPreviewWidget');
	            widgets = this.state.links.map(function (link) {
	                return _react2.default.createElement(LinkPreviewWidget, {
	                    key: link,
	                    link: link,
	                    mxEvent: _this2.props.mxEvent,
	                    onCancelClick: _this2.onCancelClick,
	                    onWidgetLoad: _this2.props.onWidgetLoad });
	            });
	        }
	
	        switch (content.msgtype) {
	            case "m.emote":
	                var name = mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender();
	                return _react2.default.createElement(
	                    'span',
	                    { ref: 'content', className: 'mx_MEmoteBody mx_EventTile_content' },
	                    '*\xA0',
	                    _react2.default.createElement(
	                        EmojiText,
	                        {
	                            className: 'mx_MEmoteBody_sender',
	                            onClick: this.onEmoteSenderClick
	                        },
	                        name
	                    ),
	                    '\xA0',
	                    body,
	                    widgets
	                );
	            case "m.notice":
	                return _react2.default.createElement(
	                    'span',
	                    { ref: 'content', className: 'mx_MNoticeBody mx_EventTile_content' },
	                    body,
	                    widgets
	                );
	            default:
	                // including "m.text"
	                return _react2.default.createElement(
	                    'span',
	                    { ref: 'content', className: 'mx_MTextBody mx_EventTile_content' },
	                    body,
	                    widgets
	                );
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var TextForEvent = __webpack_require__(331);
	
	
	module.exports = React.createClass({
	    displayName: 'TextualEvent',
	
	    render: function render() {
	        var EmojiText = _index2.default.getComponent('elements.EmojiText');
	        var text = TextForEvent.textForEvent(this.props.mxEvent);
	        if (text == null || text.length === 0) return null;
	        return React.createElement(
	            EmojiText,
	            { element: 'div', className: 'mx_TextualEvent' },
	            text
	        );
	    }
	});


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'UnknownBody',
	
	    render: function render() {
	        var text = this.props.mxEvent.getContent().body;
	        return React.createElement(
	            'span',
	            { className: 'mx_UnknownBody', title: 'Redacted or unknown message type' },
	            text
	        );
	    }
	});


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var q = __webpack_require__(6);
	var React = __webpack_require__(1);
	var ObjectUtils = __webpack_require__(139);
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	var Modal = __webpack_require__(10);
	
	module.exports = React.createClass({
	    displayName: 'AliasSettings',
	
	    propTypes: {
	        roomId: React.PropTypes.string.isRequired,
	        canSetCanonicalAlias: React.PropTypes.bool.isRequired,
	        canSetAliases: React.PropTypes.bool.isRequired,
	        aliasEvents: React.PropTypes.array, // [MatrixEvent]
	        canonicalAliasEvent: React.PropTypes.object // MatrixEvent
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            canSetAliases: false,
	            canSetCanonicalAlias: false,
	            aliasEvents: []
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return this.recalculateState(this.props.aliasEvents, this.props.canonicalAliasEvent);
	    },
	
	    recalculateState: function recalculateState(aliasEvents, canonicalAliasEvent) {
	        aliasEvents = aliasEvents || [];
	
	        var state = {
	            domainToAliases: {}, // { domain.com => [#alias1:domain.com, #alias2:domain.com] }
	            remoteDomains: [], // [ domain.com, foobar.com ]
	            canonicalAlias: null // #canonical:domain.com
	        };
	        var localDomain = MatrixClientPeg.get().getDomain();
	
	        state.domainToAliases = this.aliasEventsToDictionary(aliasEvents);
	
	        state.remoteDomains = (0, _keys2.default)(state.domainToAliases).filter(function (alias) {
	            return alias !== localDomain;
	        });
	
	        if (canonicalAliasEvent) {
	            state.canonicalAlias = canonicalAliasEvent.getContent().alias;
	        }
	
	        return state;
	    },
	
	    saveSettings: function saveSettings() {
	        var promises = [];
	
	        // save new aliases for m.room.aliases
	        var aliasOperations = this.getAliasOperations();
	        for (var i = 0; i < aliasOperations.length; i++) {
	            var alias_operation = aliasOperations[i];
	            console.log("alias %s %s", alias_operation.place, alias_operation.val);
	            switch (alias_operation.place) {
	                case 'add':
	                    promises.push(MatrixClientPeg.get().createAlias(alias_operation.val, this.props.roomId));
	                    break;
	                case 'del':
	                    promises.push(MatrixClientPeg.get().deleteAlias(alias_operation.val));
	                    break;
	                default:
	                    console.log("Unknown alias operation, ignoring: " + alias_operation.place);
	            }
	        }
	
	        // save new canonical alias
	        var oldCanonicalAlias = null;
	        if (this.props.canonicalAliasEvent) {
	            oldCanonicalAlias = this.props.canonicalAliasEvent.getContent().alias;
	        }
	        if (oldCanonicalAlias !== this.state.canonicalAlias) {
	            console.log("AliasSettings: Updating canonical alias");
	            promises = [q.all(promises).then(MatrixClientPeg.get().sendStateEvent(this.props.roomId, "m.room.canonical_alias", {
	                alias: this.state.canonicalAlias
	            }, ""))];
	        }
	
	        return promises;
	    },
	
	    aliasEventsToDictionary: function aliasEventsToDictionary(aliasEvents) {
	        // m.room.alias events
	        var dict = {};
	        aliasEvents.forEach(function (event) {
	            dict[event.getStateKey()] = (event.getContent().aliases || []).slice() // shallow-copy
	            ;
	        });
	        return dict;
	    },
	
	    isAliasValid: function isAliasValid(alias) {
	        // XXX: FIXME SPEC-1
	        return alias.match(/^#([^\/:,]+?):(.+)$/) && encodeURI(alias) === alias;
	    },
	
	    getAliasOperations: function getAliasOperations() {
	        var oldAliases = this.aliasEventsToDictionary(this.props.aliasEvents);
	        return ObjectUtils.getKeyValueArrayDiffs(oldAliases, this.state.domainToAliases);
	    },
	
	    onAliasAdded: function onAliasAdded(alias) {
	        if (!alias || alias.length === 0) return; // ignore attempts to create blank aliases
	
	        if (this.isAliasValid(alias)) {
	            // add this alias to the domain to aliases dict
	            var domain = alias.replace(/^.*?:/, '');
	            // XXX: do we need to deep copy aliases before editing it?
	            this.state.domainToAliases[domain] = this.state.domainToAliases[domain] || [];
	            this.state.domainToAliases[domain].push(alias);
	            this.setState({
	                domainToAliases: this.state.domainToAliases
	            });
	
	            // reset the add field
	            this.refs.add_alias.setValue(''); // FIXME
	        } else {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Invalid alias format",
	                description: "'" + alias + "' is not a valid format for an alias"
	            });
	        }
	    },
	
	    onAliasChanged: function onAliasChanged(domain, index, alias) {
	        if (alias === "") return; // hit the delete button to delete please
	        var oldAlias;
	        if (this.isAliasValid(alias)) {
	            oldAlias = this.state.domainToAliases[domain][index];
	            this.state.domainToAliases[domain][index] = alias;
	        } else {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Invalid address format",
	                description: "'" + alias + "' is not a valid format for an address"
	            });
	        }
	    },
	
	    onAliasDeleted: function onAliasDeleted(domain, index) {
	        // It's a bit naughty to directly manipulate this.state, and React would
	        // normally whine at you, but it can't see us doing the splice.  Given we
	        // promptly setState anyway, it's just about acceptable.  The alternative
	        // would be to arbitrarily deepcopy to a temp variable and then setState
	        // that, but why bother when we can cut this corner.
	        var alias = this.state.domainToAliases[domain].splice(index, 1);
	        this.setState({
	            domainToAliases: this.state.domainToAliases
	        });
	    },
	
	    onCanonicalAliasChange: function onCanonicalAliasChange(event) {
	        this.setState({
	            canonicalAlias: event.target.value
	        });
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var self = this;
	        var EditableText = sdk.getComponent("elements.EditableText");
	        var localDomain = MatrixClientPeg.get().getDomain();
	
	        var canonical_alias_section;
	        if (this.props.canSetCanonicalAlias) {
	            canonical_alias_section = React.createElement(
	                "select",
	                { onChange: this.onCanonicalAliasChange, defaultValue: this.state.canonicalAlias },
	                React.createElement(
	                    "option",
	                    { value: "", key: "unset" },
	                    "not specified"
	                ),
	                (0, _keys2.default)(self.state.domainToAliases).map(function (domain, i) {
	                    return self.state.domainToAliases[domain].map(function (alias, j) {
	                        return React.createElement(
	                            "option",
	                            { value: alias, key: i + "_" + j },
	                            alias
	                        );
	                    });
	                })
	            );
	        } else {
	            canonical_alias_section = React.createElement(
	                "b",
	                null,
	                this.state.canonicalAlias || "not set"
	            );
	        }
	
	        var remote_aliases_section;
	        if (this.state.remoteDomains.length) {
	            remote_aliases_section = React.createElement(
	                "div",
	                null,
	                React.createElement(
	                    "div",
	                    { className: "mx_RoomSettings_aliasLabel" },
	                    "Remote addresses for this room:"
	                ),
	                React.createElement(
	                    "div",
	                    { className: "mx_RoomSettings_aliasesTable" },
	                    this.state.remoteDomains.map(function (domain, i) {
	                        return _this.state.domainToAliases[domain].map(function (alias, j) {
	                            return React.createElement(
	                                "div",
	                                { className: "mx_RoomSettings_aliasesTableRow", key: i + "_" + j },
	                                React.createElement(EditableText, {
	                                    className: "mx_RoomSettings_alias mx_RoomSettings_editable",
	                                    blurToCancel: false,
	                                    editable: false,
	                                    initialValue: alias })
	                            );
	                        });
	                    })
	                )
	            );
	        }
	
	        return React.createElement(
	            "div",
	            null,
	            React.createElement(
	                "h3",
	                null,
	                "Addresses"
	            ),
	            React.createElement(
	                "div",
	                { className: "mx_RoomSettings_aliasLabel" },
	                "The main address for this room is: ",
	                canonical_alias_section
	            ),
	            React.createElement(
	                "div",
	                { className: "mx_RoomSettings_aliasLabel" },
	                this.state.domainToAliases[localDomain] && this.state.domainToAliases[localDomain].length > 0 ? "Local addresses for this room:" : "This room has no local addresses"
	            ),
	            React.createElement(
	                "div",
	                { className: "mx_RoomSettings_aliasesTable" },
	                (this.state.domainToAliases[localDomain] || []).map(function (alias, i) {
	                    var deleteButton;
	                    if (_this.props.canSetAliases) {
	                        deleteButton = React.createElement("img", { src: "img/cancel-small.svg", width: "14", height: "14",
	                            alt: "Delete", onClick: self.onAliasDeleted.bind(self, localDomain, i) });
	                    }
	                    return React.createElement(
	                        "div",
	                        { className: "mx_RoomSettings_aliasesTableRow", key: i },
	                        React.createElement(EditableText, {
	                            className: "mx_RoomSettings_alias mx_RoomSettings_editable",
	                            placeholderClassName: "mx_RoomSettings_aliasPlaceholder",
	                            placeholder: "New address (e.g. #foo:" + localDomain + ")",
	                            blurToCancel: false,
	                            onValueChanged: self.onAliasChanged.bind(self, localDomain, i),
	                            editable: self.props.canSetAliases,
	                            initialValue: alias }),
	                        React.createElement(
	                            "div",
	                            { className: "mx_RoomSettings_deleteAlias mx_filterFlipColor" },
	                            deleteButton
	                        )
	                    );
	                }),
	                this.props.canSetAliases ? React.createElement(
	                    "div",
	                    { className: "mx_RoomSettings_aliasesTableRow", key: "new" },
	                    React.createElement(EditableText, {
	                        ref: "add_alias",
	                        className: "mx_RoomSettings_alias mx_RoomSettings_editable",
	                        placeholderClassName: "mx_RoomSettings_aliasPlaceholder",
	                        placeholder: "New address (e.g. #foo:" + localDomain + ")",
	                        blurToCancel: false,
	                        onValueChanged: self.onAliasAdded }),
	                    React.createElement(
	                        "div",
	                        { className: "mx_RoomSettings_addAlias mx_filterFlipColor" },
	                        React.createElement("img", { src: "img/plus.svg", width: "14", height: "14", alt: "Add",
	                            onClick: self.onAliasAdded.bind(self, undefined) })
	                    )
	                ) : ""
	            ),
	            remote_aliases_section
	        );
	    }
	});


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var q = __webpack_require__(6);
	var React = __webpack_require__(1);
	
	var sdk = __webpack_require__(2);
	var Tinter = __webpack_require__(140);
	var MatrixClientPeg = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	
	var ROOM_COLORS = [
	// magic room default values courtesy of Ribot
	["#76cfa6", "#eaf5f0"], ["#81bddb", "#eaf1f4"], ["#bd79cb", "#f3eaf5"], ["#c65d94", "#f5eaef"], ["#e55e5e", "#f5eaea"], ["#eca46f", "#f5eeea"], ["#dad658", "#f5f4ea"], ["#80c553", "#eef5ea"], ["#bb814e", "#eee8e3"], ["#595959", "#ececec"]];
	
	module.exports = React.createClass({
	    displayName: 'ColorSettings',
	
	    propTypes: {
	        room: React.PropTypes.object.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        var data = {
	            index: 0,
	            primary_color: ROOM_COLORS[0].primary_color,
	            secondary_color: ROOM_COLORS[0].secondary_color,
	            hasChanged: false
	        };
	        var event = this.props.room.getAccountData("org.matrix.room.color_scheme");
	        if (!event) {
	            return data;
	        }
	        var scheme = event.getContent();
	        data.primary_color = scheme.primary_color;
	        data.secondary_color = scheme.secondary_color;
	        data.index = this._getColorIndex(data);
	
	        if (data.index === -1) {
	            // append the unrecognised colours to our palette
	            data.index = ROOM_COLORS.length;
	            ROOM_COLORS.push([scheme.primary_color, scheme.secondary_color]);
	        }
	        return data;
	    },
	
	    saveSettings: function saveSettings() {
	        // : Promise
	        if (!this.state.hasChanged) {
	            return q(); // They didn't explicitly give a color to save.
	        }
	        var originalState = this.getInitialState();
	        if (originalState.primary_color !== this.state.primary_color || originalState.secondary_color !== this.state.secondary_color) {
	            console.log("ColorSettings: Saving new color");
	            // We would like guests to be able to set room colour but currently
	            // they can't, so we still send the request but display a sensible
	            // error if it fails.
	            return MatrixClientPeg.get().setRoomAccountData(this.props.room.roomId, "org.matrix.room.color_scheme", {
	                primary_color: this.state.primary_color,
	                secondary_color: this.state.secondary_color
	            }).catch(function (err) {
	                if (err.errcode == 'M_GUEST_ACCESS_FORBIDDEN') {
	                    var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	                    Modal.createDialog(NeedToRegisterDialog, {
	                        title: "Please Register",
	                        description: "Saving room color settings is only available to registered users"
	                    });
	                }
	            });
	        }
	        return q(); // no color diff
	    },
	
	    _getColorIndex: function _getColorIndex(scheme) {
	        if (!scheme || !scheme.primary_color || !scheme.secondary_color) {
	            return -1;
	        }
	        // XXX: we should validate these values
	        for (var i = 0; i < ROOM_COLORS.length; i++) {
	            var room_color = ROOM_COLORS[i];
	            if (room_color[0] === String(scheme.primary_color).toLowerCase() && room_color[1] === String(scheme.secondary_color).toLowerCase()) {
	                return i;
	            }
	        }
	        return -1;
	    },
	
	    _onColorSchemeChanged: function _onColorSchemeChanged(index) {
	        // preview what the user just changed the scheme to.
	        Tinter.tint(ROOM_COLORS[index][0], ROOM_COLORS[index][1]);
	        this.setState({
	            index: index,
	            primary_color: ROOM_COLORS[index][0],
	            secondary_color: ROOM_COLORS[index][1],
	            hasChanged: true
	        });
	    },
	
	    render: function render() {
	        var _this = this;
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomSettings_roomColors' },
	            ROOM_COLORS.map(function (room_color, i) {
	                var selected;
	                if (i === _this.state.index) {
	                    selected = React.createElement(
	                        'div',
	                        { className: 'mx_RoomSettings_roomColor_selected' },
	                        React.createElement('img', { src: 'img/tick.svg', width: '17', height: '14', alt: './' })
	                    );
	                }
	                var boundClick = _this._onColorSchemeChanged.bind(_this, i);
	                return React.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_roomColor',
	                        key: "room_color_" + i,
	                        style: { backgroundColor: room_color[1] },
	                        onClick: boundClick },
	                    selected,
	                    React.createElement('div', { className: 'mx_RoomSettings_roomColorPrimary', style: { backgroundColor: room_color[0] } })
	                );
	            })
	        );
	    }
	});


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(177);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var q = __webpack_require__(6);
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	var Modal = __webpack_require__(10);
	var UserSettingsStore = __webpack_require__(74);
	
	module.exports = React.createClass({
	    displayName: 'UrlPreviewSettings',
	
	    propTypes: {
	        room: React.PropTypes.object
	    },
	
	    getInitialState: function getInitialState() {
	        var cli = MatrixClientPeg.get();
	        var roomState = this.props.room.currentState;
	
	        var roomPreviewUrls = this.props.room.currentState.getStateEvents('org.matrix.room.preview_urls', '');
	        var userPreviewUrls = this.props.room.getAccountData("org.matrix.room.preview_urls");
	
	        return {
	            globalDisableUrlPreview: roomPreviewUrls && roomPreviewUrls.getContent().disable || false,
	            userDisableUrlPreview: userPreviewUrls && userPreviewUrls.getContent().disable === true || false,
	            userEnableUrlPreview: userPreviewUrls && userPreviewUrls.getContent().disable === false || false
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.originalState = (0, _assign2.default)({}, this.state);
	    },
	
	    saveSettings: function saveSettings() {
	        var promises = [];
	
	        if (this.state.globalDisableUrlPreview !== this.originalState.globalDisableUrlPreview) {
	            console.log("UrlPreviewSettings: Updating room's preview_urls state event");
	            promises.push(MatrixClientPeg.get().sendStateEvent(this.props.room.roomId, "org.matrix.room.preview_urls", {
	                disable: this.state.globalDisableUrlPreview
	            }, ""));
	        }
	
	        var content = undefined;
	        if (this.state.userDisableUrlPreview !== this.originalState.userDisableUrlPreview) {
	            console.log("UrlPreviewSettings: Disabling user's per-room preview_urls");
	            content = this.state.userDisableUrlPreview ? { disable: true } : {};
	        }
	
	        if (this.state.userEnableUrlPreview !== this.originalState.userEnableUrlPreview) {
	            console.log("UrlPreviewSettings: Enabling user's per-room preview_urls");
	            if (!content || content.disable === undefined) {
	                content = this.state.userEnableUrlPreview ? { disable: false } : {};
	            }
	        }
	
	        if (content) {
	            promises.push(MatrixClientPeg.get().setRoomAccountData(this.props.room.roomId, "org.matrix.room.preview_urls", content));
	        }
	
	        console.log("UrlPreviewSettings: saveSettings: " + (0, _stringify2.default)(promises));
	
	        return promises;
	    },
	
	    onGlobalDisableUrlPreviewChange: function onGlobalDisableUrlPreviewChange() {
	        this.setState({
	            globalDisableUrlPreview: this.refs.globalDisableUrlPreview.checked ? true : false
	        });
	    },
	
	    onUserEnableUrlPreviewChange: function onUserEnableUrlPreviewChange() {
	        this.setState({
	            userDisableUrlPreview: false,
	            userEnableUrlPreview: this.refs.userEnableUrlPreview.checked ? true : false
	        });
	    },
	
	    onUserDisableUrlPreviewChange: function onUserDisableUrlPreviewChange() {
	        this.setState({
	            userDisableUrlPreview: this.refs.userDisableUrlPreview.checked ? true : false,
	            userEnableUrlPreview: false
	        });
	    },
	
	    render: function render() {
	        var self = this;
	        var roomState = this.props.room.currentState;
	        var cli = MatrixClientPeg.get();
	
	        var maySetRoomPreviewUrls = roomState.mayClientSendStateEvent('org.matrix.room.preview_urls', cli);
	        var disableRoomPreviewUrls;
	        if (maySetRoomPreviewUrls) {
	            disableRoomPreviewUrls = React.createElement(
	                'label',
	                null,
	                React.createElement('input', { type: 'checkbox', ref: 'globalDisableUrlPreview',
	                    onChange: this.onGlobalDisableUrlPreviewChange,
	                    checked: this.state.globalDisableUrlPreview }),
	                'Disable URL previews by default for participants in this room'
	            );
	        } else {
	            disableRoomPreviewUrls = React.createElement(
	                'label',
	                null,
	                'URL previews are ',
	                this.state.globalDisableUrlPreview ? "disabled" : "enabled",
	                ' by default for participants in this room.'
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomSettings_toggles' },
	            React.createElement(
	                'h3',
	                null,
	                'URL Previews'
	            ),
	            React.createElement(
	                'label',
	                null,
	                'You have ',
	                React.createElement(
	                    'a',
	                    { href: '#/settings' },
	                    UserSettingsStore.getUrlPreviewsDisabled() ? 'disabled' : 'enabled'
	                ),
	                ' URL previews by default.'
	            ),
	            disableRoomPreviewUrls,
	            React.createElement(
	                'label',
	                null,
	                React.createElement('input', { type: 'checkbox', ref: 'userEnableUrlPreview',
	                    onChange: this.onUserEnableUrlPreviewChange,
	                    checked: this.state.userEnableUrlPreview }),
	                'Enable URL previews for this room (affects only you)'
	            ),
	            React.createElement(
	                'label',
	                null,
	                React.createElement('input', { type: 'checkbox', ref: 'userDisableUrlPreview',
	                    onChange: this.onUserDisableUrlPreviewChange,
	                    checked: this.state.userDisableUrlPreview }),
	                'Disable URL previews for this room (affects only you)'
	            )
	        );
	    }
	});


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var ObjectUtils = __webpack_require__(139);
	
	module.exports = React.createClass({
	    displayName: 'AuxPanel',
	
	    propTypes: {
	        // js-sdk room object
	        room: React.PropTypes.object.isRequired,
	
	        // Conference Handler implementation
	        conferenceHandler: React.PropTypes.object,
	
	        // set to true to show the file drop target
	        draggingFile: React.PropTypes.bool,
	
	        // set to true to show the 'active conf call' banner
	        displayConfCallNotification: React.PropTypes.bool,
	
	        // maxHeight attribute for the aux panel and the video
	        // therein
	        maxHeight: React.PropTypes.number,
	
	        // a callback which is called when the content of the aux panel changes
	        // content in a way that is likely to make it change size.
	        onResize: React.PropTypes.func
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return !ObjectUtils.shallowEqual(this.props, nextProps) || !ObjectUtils.shallowEqual(this.state, nextState);
	    },
	
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	        // most changes are likely to cause a resize
	        if (this.props.onResize) {
	            this.props.onResize();
	        }
	    },
	
	    onConferenceNotificationClick: function onConferenceNotificationClick(ev, type) {
	        dis.dispatch({
	            action: 'place_call',
	            type: type,
	            room_id: this.props.room.roomId
	        });
	        ev.stopPropagation();
	        ev.preventDefault();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var CallView = sdk.getComponent("voip.CallView");
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	
	        var fileDropTarget = null;
	        if (this.props.draggingFile) {
	            fileDropTarget = React.createElement(
	                'div',
	                { className: 'mx_RoomView_fileDropTarget' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomView_fileDropTargetLabel',
	                        title: 'Drop File Here' },
	                    React.createElement(TintableSvg, { src: 'img/upload-big.svg', width: '45', height: '59' }),
	                    React.createElement('br', null),
	                    'Drop file here to upload'
	                )
	            );
	        }
	
	        var conferenceCallNotification = null;
	        if (this.props.displayConfCallNotification) {
	            var supportedText, joinText;
	            if (!MatrixClientPeg.get().supportsVoip()) {
	                supportedText = " (unsupported)";
	            } else {
	                joinText = React.createElement(
	                    'span',
	                    null,
	                    'Join as ',
	                    React.createElement(
	                        'a',
	                        { onClick: function onClick(event) {
	                                _this.onConferenceNotificationClick(event, 'voice');
	                            },
	                            href: '#' },
	                        'voice'
	                    ),
	                    ' or ',
	                    React.createElement(
	                        'a',
	                        { onClick: function onClick(event) {
	                                _this.onConferenceNotificationClick(event, 'video');
	                            },
	                            href: '#' },
	                        'video'
	                    ),
	                    '.'
	                );
	            }
	            conferenceCallNotification = React.createElement(
	                'div',
	                { className: 'mx_RoomView_ongoingConfCallNotification' },
	                'Ongoing conference call',
	                supportedText,
	                '. ',
	                joinText
	            );
	        }
	
	        var callView = React.createElement(CallView, { ref: 'callView', room: this.props.room,
	            ConferenceHandler: this.props.conferenceHandler,
	            onResize: this.props.onResize,
	            maxVideoHeight: this.props.maxHeight
	        });
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomView_auxPanel', style: { maxHeight: this.props.maxHeight } },
	            fileDropTarget,
	            callView,
	            conferenceCallNotification,
	            this.props.children
	        );
	    }
	});


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	
	
	var PRESENCE_CLASS = {
	    "offline": "mx_EntityTile_offline",
	    "online": "mx_EntityTile_online",
	    "unavailable": "mx_EntityTile_unavailable"
	};
	
	function presenceClassForMember(presenceState, lastActiveAgo) {
	    // offline is split into two categories depending on whether we have
	    // a last_active_ago for them.
	    if (presenceState == 'offline') {
	        if (lastActiveAgo) {
	            return PRESENCE_CLASS['offline'] + '_beenactive';
	        } else {
	            return PRESENCE_CLASS['offline'] + '_neveractive';
	        }
	    } else if (presenceState) {
	        return PRESENCE_CLASS[presenceState];
	    } else {
	        return PRESENCE_CLASS['offline'] + '_neveractive';
	    }
	}
	
	module.exports = React.createClass({
	    displayName: 'EntityTile',
	
	    propTypes: {
	        name: React.PropTypes.string,
	        title: React.PropTypes.string,
	        avatarJsx: React.PropTypes.any, // <BaseAvatar />
	        className: React.PropTypes.string,
	        presenceState: React.PropTypes.string,
	        presenceLastActiveAgo: React.PropTypes.number,
	        presenceLastTs: React.PropTypes.number,
	        presenceCurrentlyActive: React.PropTypes.bool,
	        showInviteButton: React.PropTypes.bool,
	        shouldComponentUpdate: React.PropTypes.func,
	        onClick: React.PropTypes.func,
	        suppressOnHover: React.PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	                return true;
	            },
	            onClick: function onClick() {},
	            presenceState: "offline",
	            presenceLastActiveAgo: 0,
	            presenceLastTs: 0,
	            showInviteButton: false,
	            suppressOnHover: false
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            hover: false
	        };
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (this.state.hover !== nextState.hover) return true;
	        return this.props.shouldComponentUpdate(nextProps, nextState);
	    },
	
	    mouseEnter: function mouseEnter(e) {
	        this.setState({ 'hover': true });
	    },
	
	    mouseLeave: function mouseLeave(e) {
	        this.setState({ 'hover': false });
	    },
	
	    render: function render() {
	        var presenceClass = presenceClassForMember(this.props.presenceState, this.props.presenceLastActiveAgo);
	
	        var mainClassName = "mx_EntityTile ";
	        mainClassName += presenceClass + (this.props.className ? " " + this.props.className : "");
	        var nameEl;
	        var name = this.props.name;
	
	
	        var EmojiText = sdk.getComponent('elements.EmojiText');
	        if (this.state.hover && !this.props.suppressOnHover) {
	            var activeAgo = this.props.presenceLastActiveAgo ? Date.now() - (this.props.presenceLastTs - this.props.presenceLastActiveAgo) : -1;
	
	            mainClassName += " mx_EntityTile_hover";
	            var PresenceLabel = sdk.getComponent("rooms.PresenceLabel");
	            nameEl = React.createElement(
	                'div',
	                { className: 'mx_EntityTile_details' },
	                React.createElement('img', { className: 'mx_EntityTile_chevron', src: 'img/member_chevron.png', width: '8', height: '12' }),
	                React.createElement(
	                    EmojiText,
	                    { element: 'div', className: 'mx_EntityTile_name_hover' },
	                    name
	                ),
	                React.createElement(PresenceLabel, { activeAgo: activeAgo,
	                    currentlyActive: this.props.presenceCurrentlyActive,
	                    presenceState: this.props.presenceState })
	            );
	        } else {
	            nameEl = React.createElement(
	                EmojiText,
	                { element: 'div', className: 'mx_EntityTile_name' },
	                name
	            );
	        }
	
	        var inviteButton;
	        if (this.props.showInviteButton) {
	            inviteButton = React.createElement(
	                'div',
	                { className: 'mx_EntityTile_invite' },
	                React.createElement('img', { src: 'img/plus.svg', width: '16', height: '16' })
	            );
	        }
	
	        var power;
	        var powerLevel = this.props.powerLevel;
	        if (powerLevel >= 50 && powerLevel < 99) {
	            power = React.createElement('img', { src: 'img/mod.svg', className: 'mx_EntityTile_power', width: '16', height: '17', alt: 'Mod' });
	        }
	        if (powerLevel >= 99) {
	            power = React.createElement('img', { src: 'img/admin.svg', className: 'mx_EntityTile_power', width: '16', height: '17', alt: 'Admin' });
	        }
	
	        var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');
	        var BaseAvatar = sdk.getComponent('avatars.BaseAvatar');
	
	        var av = this.props.avatarJsx || React.createElement(BaseAvatar, { name: this.props.name, width: 36, height: 36 });
	
	        return React.createElement(
	            _AccessibleButton2.default,
	            { className: mainClassName, title: this.props.title,
	                onClick: this.props.onClick, onMouseEnter: this.mouseEnter,
	                onMouseLeave: this.mouseLeave },
	            React.createElement(
	                'div',
	                { className: 'mx_EntityTile_avatar' },
	                av,
	                power
	            ),
	            nameEl,
	            inviteButton
	        );
	    }
	});


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _WithMatrixClient = __webpack_require__(337);
	
	var _WithMatrixClient2 = _interopRequireDefault(_WithMatrixClient);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var classNames = __webpack_require__(27);
	var Modal = __webpack_require__(10);
	
	var sdk = __webpack_require__(2);
	var TextForEvent = __webpack_require__(331);
	
	
	var ContextualMenu = __webpack_require__(222);
	
	
	var ObjectUtils = __webpack_require__(139);
	
	var eventTileTypes = {
	    'm.room.message': 'messages.MessageEvent',
	    'm.room.member': 'messages.TextualEvent',
	    'm.call.invite': 'messages.TextualEvent',
	    'm.call.answer': 'messages.TextualEvent',
	    'm.call.hangup': 'messages.TextualEvent',
	    'm.room.name': 'messages.TextualEvent',
	    'm.room.topic': 'messages.TextualEvent',
	    'm.room.third_party_invite': 'messages.TextualEvent',
	    'm.room.history_visibility': 'messages.TextualEvent',
	    'm.room.encryption': 'messages.TextualEvent'
	};
	
	var MAX_READ_AVATARS = 5;
	
	// Our component structure for EventTiles on the timeline is:
	//
	// .-EventTile------------------------------------------------.
	// | MemberAvatar (SenderProfile)                   TimeStamp |
	// |    .-{Message,Textual}Event---------------. Read Avatars |
	// |    |   .-MFooBody-------------------.     |              |
	// |    |   |  (only if MessageEvent)    |     |              |
	// |    |   '----------------------------'     |              |
	// |    '--------------------------------------'              |
	// '----------------------------------------------------------'
	
	module.exports = (0, _WithMatrixClient2.default)(React.createClass({
	    displayName: 'EventTile',
	
	    propTypes: {
	        /* MatrixClient instance for sender verification etc */
	        matrixClient: React.PropTypes.object.isRequired,
	
	        /* the MatrixEvent to show */
	        mxEvent: React.PropTypes.object.isRequired,
	
	        /* true if mxEvent is redacted. This is a prop because using mxEvent.isRedacted()
	         * might not be enough when deciding shouldComponentUpdate - prevProps.mxEvent
	         * references the same this.props.mxEvent.
	         */
	        isRedacted: React.PropTypes.bool,
	
	        /* true if this is a continuation of the previous event (which has the
	         * effect of not showing another avatar/displayname
	         */
	        continuation: React.PropTypes.bool,
	
	        /* true if this is the last event in the timeline (which has the effect
	         * of always showing the timestamp)
	         */
	        last: React.PropTypes.bool,
	
	        /* true if this is search context (which has the effect of greying out
	         * the text
	         */
	        contextual: React.PropTypes.bool,
	
	        /* a list of words to highlight, ordered by longest first */
	        highlights: React.PropTypes.array,
	
	        /* link URL for the highlights */
	        highlightLink: React.PropTypes.string,
	
	        /* should show URL previews for this event */
	        showUrlPreview: React.PropTypes.bool,
	
	        /* is this the focused event */
	        isSelectedEvent: React.PropTypes.bool,
	
	        /* callback called when dynamic content in events are loaded */
	        onWidgetLoad: React.PropTypes.func,
	
	        /* a list of read-receipts we should show. Each object has a 'roomMember' and 'ts'. */
	        readReceipts: React.PropTypes.arrayOf(React.PropTypes.object),
	
	        /* opaque readreceipt info for each userId; used by ReadReceiptMarker
	         * to manage its animations. Should be an empty object when the room
	         * first loads
	         */
	        readReceiptMap: React.PropTypes.object,
	
	        /* A function which is used to check if the parent panel is being
	         * unmounted, to avoid unnecessary work. Should return true if we
	         * are being unmounted.
	         */
	        checkUnmounting: React.PropTypes.func,
	
	        /* the status of this event - ie, mxEvent.status. Denormalised to here so
	         * that we can tell when it changes. */
	        eventSendStatus: React.PropTypes.string,
	
	        /* the shape of the tile. by default, the layout is intended for the
	         * normal room timeline.  alternative values are: "file_list", "file_grid"
	         * and "notif".  This could be done by CSS, but it'd be horribly inefficient.
	         * It could also be done by subclassing EventTile, but that'd be quite
	         * boiilerplatey.  So just make the necessary render decisions conditional
	         * for now.
	         */
	        tileShape: React.PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return { menu: false, allReadAvatars: false, verified: null };
	    },
	
	    componentWillMount: function componentWillMount() {
	        // don't do RR animations until we are mounted
	        this._suppressReadReceiptAnimation = true;
	        this._verifyEvent(this.props.mxEvent);
	    },
	
	    componentDidMount: function componentDidMount() {
	        this._suppressReadReceiptAnimation = false;
	        this.props.matrixClient.on("deviceVerificationChanged", this.onDeviceVerificationChanged);
	        this.props.mxEvent.on("Event.decrypted", this._onDecrypted);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.mxEvent !== this.props.mxEvent) {
	            this._verifyEvent(nextProps.mxEvent);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (!ObjectUtils.shallowEqual(this.state, nextState)) {
	            return true;
	        }
	
	        if (!this._propsEqual(this.props, nextProps)) {
	            return true;
	        }
	
	        return false;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        var client = this.props.matrixClient;
	        client.removeListener("deviceVerificationChanged", this.onDeviceVerificationChanged);
	        this.props.mxEvent.removeListener("Event.decrypted", this._onDecrypted);
	    },
	
	    /** called when the event is decrypted after we show it.
	     */
	    _onDecrypted: function _onDecrypted() {
	        // we need to re-verify the sending device.
	        this._verifyEvent(this.props.mxEvent);
	        this.forceUpdate();
	    },
	
	    onDeviceVerificationChanged: function onDeviceVerificationChanged(userId, device) {
	        if (userId == this.props.mxEvent.getSender()) {
	            this._verifyEvent(this.props.mxEvent);
	        }
	    },
	
	    _verifyEvent: function _verifyEvent(mxEvent) {
	        var verified = null;
	
	        if (mxEvent.isEncrypted()) {
	            verified = this.props.matrixClient.isEventSenderVerified(mxEvent);
	        }
	
	        this.setState({
	            verified: verified
	        });
	    },
	
	    _propsEqual: function _propsEqual(objA, objB) {
	        var keysA = (0, _keys2.default)(objA);
	        var keysB = (0, _keys2.default)(objB);
	
	        if (keysA.length !== keysB.length) {
	            return false;
	        }
	
	        for (var i = 0; i < keysA.length; i++) {
	            var key = keysA[i];
	
	            if (!objB.hasOwnProperty(key)) {
	                return false;
	            }
	
	            // need to deep-compare readReceipts
	            if (key == 'readReceipts') {
	                var rA = objA[key];
	                var rB = objB[key];
	                if (rA === rB) {
	                    continue;
	                }
	
	                if (!rA || !rB) {
	                    return false;
	                }
	
	                if (rA.length !== rB.length) {
	                    return false;
	                }
	                for (var j = 0; j < rA.length; j++) {
	                    if (rA[j].roomMember.userId !== rB[j].roomMember.userId) {
	                        return false;
	                    }
	                }
	            } else {
	                if (objA[key] !== objB[key]) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    },
	
	    shouldHighlight: function shouldHighlight() {
	        var actions = this.props.matrixClient.getPushActionsForEvent(this.props.mxEvent);
	        if (!actions || !actions.tweaks) {
	            return false;
	        }
	
	        // don't show self-highlights from another of our clients
	        if (this.props.mxEvent.getSender() === this.props.matrixClient.credentials.userId) {
	            return false;
	        }
	
	        return actions.tweaks.highlight;
	    },
	
	    onEditClicked: function onEditClicked(e) {
	        var MessageContextMenu = sdk.getComponent('context_menus.MessageContextMenu');
	        var buttonRect = e.target.getBoundingClientRect();
	
	        // The window X and Y offsets are to adjust position when zoomed in to page
	        var x = buttonRect.right + window.pageXOffset;
	        var y = buttonRect.top + buttonRect.height / 2 + window.pageYOffset - 19;
	        var self = this;
	        ContextualMenu.createMenu(MessageContextMenu, {
	            chevronOffset: 10,
	            mxEvent: this.props.mxEvent,
	            left: x,
	            top: y,
	            eventTileOps: this.refs.tile && this.refs.tile.getEventTileOps ? this.refs.tile.getEventTileOps() : undefined,
	            onFinished: function onFinished() {
	                self.setState({ menu: false });
	            }
	        });
	        this.setState({ menu: true });
	    },
	
	    toggleAllReadAvatars: function toggleAllReadAvatars() {
	        this.setState({
	            allReadAvatars: !this.state.allReadAvatars
	        });
	    },
	
	    getReadAvatars: function getReadAvatars() {
	        var ReadReceiptMarker = sdk.getComponent('rooms.ReadReceiptMarker');
	        var avatars = [];
	        var receiptOffset = 15;
	        var left = 0;
	
	        // It's possible that the receipt was sent several days AFTER the event.
	        // If it is, we want to display the complete date along with the HH:MM:SS,
	        // rather than just HH:MM:SS.
	        var dayAfterEvent = new Date(this.props.mxEvent.getTs());
	        dayAfterEvent.setDate(dayAfterEvent.getDate() + 1);
	        dayAfterEvent.setHours(0);
	        dayAfterEvent.setMinutes(0);
	        dayAfterEvent.setSeconds(0);
	        var dayAfterEventTime = dayAfterEvent.getTime();
	
	        var receipts = this.props.readReceipts || [];
	        for (var i = 0; i < receipts.length; ++i) {
	            var receipt = receipts[i];
	
	            var hidden = true;
	            if (i < MAX_READ_AVATARS || this.state.allReadAvatars) {
	                hidden = false;
	            }
	            // TODO: we keep the extra read avatars in the dom to make animation simpler
	            // we could optimise this to reduce the dom size.
	
	            // If hidden, set offset equal to the offset of the final visible avatar or
	            // else set it proportional to index
	            left = (hidden ? MAX_READ_AVATARS - 1 : i) * -receiptOffset;
	
	            var userId = receipt.roomMember.userId;
	            var readReceiptInfo;
	
	            if (this.props.readReceiptMap) {
	                readReceiptInfo = this.props.readReceiptMap[userId];
	                if (!readReceiptInfo) {
	                    readReceiptInfo = {};
	                    this.props.readReceiptMap[userId] = readReceiptInfo;
	                }
	            }
	
	            // add to the start so the most recent is on the end (ie. ends up rightmost)
	            avatars.unshift(React.createElement(ReadReceiptMarker, { key: userId, member: receipt.roomMember,
	                leftOffset: left, hidden: hidden,
	                readReceiptInfo: readReceiptInfo,
	                checkUnmounting: this.props.checkUnmounting,
	                suppressAnimation: this._suppressReadReceiptAnimation,
	                onClick: this.toggleAllReadAvatars,
	                timestamp: receipt.ts,
	                showFullTimestamp: receipt.ts >= dayAfterEventTime
	            }));
	        }
	        var remText;
	        if (!this.state.allReadAvatars) {
	            var remainder = receipts.length - MAX_READ_AVATARS;
	            if (remainder > 0) {
	                remText = React.createElement(
	                    'span',
	                    { className: 'mx_EventTile_readAvatarRemainder',
	                        onClick: this.toggleAllReadAvatars,
	                        style: { right: -(left - receiptOffset) } },
	                    remainder,
	                    '+'
	                );
	            }
	        }
	
	        return React.createElement(
	            'span',
	            { className: 'mx_EventTile_readAvatars' },
	            remText,
	            avatars
	        );
	    },
	
	    onSenderProfileClick: function onSenderProfileClick(event) {
	        var mxEvent = this.props.mxEvent;
	        _dispatcher2.default.dispatch({
	            action: 'insert_displayname',
	            displayname: (mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender()).replace(' (IRC)', '')
	        });
	    },
	
	    onCryptoClicked: function onCryptoClicked(e) {
	        var event = this.props.mxEvent;
	
	        Modal.createDialogAsync(function (cb) {
	            __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1167)]; (cb.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }, {
	            event: event
	        });
	    },
	
	    onPermalinkClicked: function onPermalinkClicked(e) {
	        // This allows the permalink to be opened in a new tab/window or copied as
	        // matrix.to, but also for it to enable routing within Riot when clicked.
	        e.preventDefault();
	        _dispatcher2.default.dispatch({
	            action: 'view_room',
	            event_id: this.props.mxEvent.getId(),
	            room_id: this.props.mxEvent.getRoomId()
	        });
	    },
	
	    render: function render() {
	        var MessageTimestamp = sdk.getComponent('messages.MessageTimestamp');
	        var SenderProfile = sdk.getComponent('messages.SenderProfile');
	        var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');
	
	        //console.log("EventTile showUrlPreview for %s is %s", this.props.mxEvent.getId(), this.props.showUrlPreview);
	
	        var content = this.props.mxEvent.getContent();
	        var msgtype = content.msgtype;
	        var eventType = this.props.mxEvent.getType();
	
	        // Info messages are basically information about commands processed on a
	        // room, or emote messages
	        var isInfoMessage = eventType !== 'm.room.message';
	
	        var EventTileType = sdk.getComponent(eventTileTypes[eventType]);
	        // This shouldn't happen: the caller should check we support this type
	        // before trying to instantiate us
	        if (!EventTileType) {
	            throw new Error("Event type not supported");
	        }
	
	        var e2eEnabled = this.props.matrixClient.isRoomEncrypted(this.props.mxEvent.getRoomId());
	        var isSending = ['sending', 'queued', 'encrypting'].indexOf(this.props.eventSendStatus) !== -1;
	        var isRedacted = eventType === 'm.room.message' && this.props.isRedacted;
	
	        var classes = classNames({
	            mx_EventTile: true,
	            mx_EventTile_info: isInfoMessage,
	            mx_EventTile_encrypting: this.props.eventSendStatus == 'encrypting',
	            mx_EventTile_sending: isSending,
	            mx_EventTile_notSent: this.props.eventSendStatus == 'not_sent',
	            mx_EventTile_highlight: this.props.tileShape == 'notif' ? false : this.shouldHighlight(),
	            mx_EventTile_selected: this.props.isSelectedEvent,
	            mx_EventTile_continuation: this.props.tileShape ? '' : this.props.continuation,
	            mx_EventTile_last: this.props.last,
	            mx_EventTile_contextual: this.props.contextual,
	            menu: this.state.menu,
	            mx_EventTile_verified: this.state.verified == true,
	            mx_EventTile_unverified: this.state.verified == false,
	            mx_EventTile_bad: this.props.mxEvent.getContent().msgtype === 'm.bad.encrypted',
	            mx_EventTile_redacted: isRedacted
	        });
	
	        var permalink = "https://matrix.to/#/" + this.props.mxEvent.getRoomId() + "/" + this.props.mxEvent.getId();
	
	        var readAvatars = this.getReadAvatars();
	
	        var avatar, sender;
	        var avatarSize = void 0;
	        var needsSenderProfile = void 0;
	
	        if (this.props.tileShape === "notif") {
	            avatarSize = 24;
	            needsSenderProfile = true;
	        } else if (isInfoMessage) {
	            // a small avatar, with no sender profile, for
	            // joins/parts/etc
	            avatarSize = 14;
	            needsSenderProfile = false;
	        } else if (this.props.continuation && this.props.tileShape !== "file_grid") {
	            // no avatar or sender profile for continuation messages
	            avatarSize = 0;
	            needsSenderProfile = false;
	        } else {
	            avatarSize = 30;
	            needsSenderProfile = true;
	        }
	
	        if (this.props.mxEvent.sender && avatarSize) {
	            avatar = React.createElement(
	                'div',
	                { className: 'mx_EventTile_avatar' },
	                React.createElement(MemberAvatar, { member: this.props.mxEvent.sender,
	                    width: avatarSize, height: avatarSize,
	                    viewUserOnClick: true
	                })
	            );
	        }
	
	        if (needsSenderProfile) {
	            var aux = null;
	            if (!this.props.tileShape) {
	                if (msgtype === 'm.image') aux = "sent an image";else if (msgtype === 'm.video') aux = "sent a video";else if (msgtype === 'm.file') aux = "uploaded a file";
	                sender = React.createElement(SenderProfile, { onClick: this.onSenderProfileClick, mxEvent: this.props.mxEvent, aux: aux });
	            } else {
	                sender = React.createElement(SenderProfile, { mxEvent: this.props.mxEvent });
	            }
	        }
	
	        var editButton = React.createElement('span', { className: 'mx_EventTile_editButton', title: 'Options', onClick: this.onEditClicked });
	
	        var e2e;
	        // cosmetic padlocks:
	        if (e2eEnabled && this.props.eventSendStatus || this.props.mxEvent.getType() === 'm.room.encryption') {
	            e2e = React.createElement('img', { style: { cursor: 'initial', marginLeft: '-1px' }, className: 'mx_EventTile_e2eIcon', src: 'img/e2e-verified.svg', width: '10', height: '12' });
	        }
	        // real padlocks
	        else if (this.props.mxEvent.isEncrypted() || e2eEnabled && this.props.eventSendStatus) {
	                if (this.props.mxEvent.getContent().msgtype === 'm.bad.encrypted') {
	                    e2e = React.createElement('img', { onClick: this.onCryptoClicked, className: 'mx_EventTile_e2eIcon', src: 'img/e2e-blocked.svg', width: '12', height: '12', style: { marginLeft: "-1px" } });
	                } else if (this.state.verified == true || e2eEnabled && this.props.eventSendStatus) {
	                    e2e = React.createElement('img', { onClick: this.onCryptoClicked, className: 'mx_EventTile_e2eIcon', src: 'img/e2e-verified.svg', width: '10', height: '12' });
	                } else {
	                    e2e = React.createElement('img', { onClick: this.onCryptoClicked, className: 'mx_EventTile_e2eIcon', src: 'img/e2e-warning.svg', width: '15', height: '12', style: { marginLeft: "-2px" } });
	                }
	            } else if (e2eEnabled) {
	                e2e = React.createElement('img', { onClick: this.onCryptoClicked, className: 'mx_EventTile_e2eIcon', src: 'img/e2e-unencrypted.svg', width: '12', height: '12' });
	            }
	        var timestamp = this.props.mxEvent.getTs() ? React.createElement(MessageTimestamp, { ts: this.props.mxEvent.getTs() }) : null;
	
	        if (this.props.tileShape === "notif") {
	            var room = this.props.matrixClient.getRoom(this.props.mxEvent.getRoomId());
	
	            return React.createElement(
	                'div',
	                { className: classes },
	                React.createElement(
	                    'div',
	                    { className: 'mx_EventTile_roomName' },
	                    React.createElement(
	                        'a',
	                        { href: permalink, onClick: this.onPermalinkClicked },
	                        room ? room.name : ''
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_EventTile_senderDetails' },
	                    avatar,
	                    React.createElement(
	                        'a',
	                        { href: permalink, onClick: this.onPermalinkClicked },
	                        sender,
	                        timestamp
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_EventTile_line' },
	                    React.createElement(EventTileType, { ref: 'tile',
	                        mxEvent: this.props.mxEvent,
	                        highlights: this.props.highlights,
	                        highlightLink: this.props.highlightLink,
	                        showUrlPreview: this.props.showUrlPreview,
	                        onWidgetLoad: this.props.onWidgetLoad })
	                )
	            );
	        } else if (this.props.tileShape === "file_grid") {
	            return React.createElement(
	                'div',
	                { className: classes },
	                React.createElement(
	                    'div',
	                    { className: 'mx_EventTile_line' },
	                    React.createElement(EventTileType, { ref: 'tile',
	                        mxEvent: this.props.mxEvent,
	                        highlights: this.props.highlights,
	                        highlightLink: this.props.highlightLink,
	                        showUrlPreview: this.props.showUrlPreview,
	                        tileShape: this.props.tileShape,
	                        onWidgetLoad: this.props.onWidgetLoad })
	                ),
	                React.createElement(
	                    'a',
	                    {
	                        className: 'mx_EventTile_senderDetailsLink',
	                        href: permalink,
	                        onClick: this.onPermalinkClicked
	                    },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_EventTile_senderDetails' },
	                        sender,
	                        timestamp
	                    )
	                )
	            );
	        } else {
	            return React.createElement(
	                'div',
	                { className: classes },
	                React.createElement(
	                    'div',
	                    { className: 'mx_EventTile_msgOption' },
	                    readAvatars
	                ),
	                avatar,
	                sender,
	                React.createElement(
	                    'div',
	                    { className: 'mx_EventTile_line' },
	                    React.createElement(
	                        'a',
	                        { href: permalink, onClick: this.onPermalinkClicked },
	                        timestamp
	                    ),
	                    e2e,
	                    React.createElement(EventTileType, { ref: 'tile',
	                        mxEvent: this.props.mxEvent,
	                        highlights: this.props.highlights,
	                        highlightLink: this.props.highlightLink,
	                        showUrlPreview: this.props.showUrlPreview,
	                        onWidgetLoad: this.props.onWidgetLoad }),
	                    editButton
	                )
	            );
	        }
	    }
	}));
	
	module.exports.haveTileForEvent = function (e) {
	    // Only messages have a tile (black-rectangle) if redacted
	    if (e.isRedacted() && e.getType() !== 'm.room.message') return false;
	    if (eventTileTypes[e.getType()] == undefined) return false;
	    if (eventTileTypes[e.getType()] == 'messages.TextualEvent') {
	        return TextForEvent.textForEvent(e) !== '';
	    } else {
	        return true;
	    }
	};


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var ImageUtils = __webpack_require__(498);
	var Modal = __webpack_require__(10);
	
	var linkify = __webpack_require__(204);
	var linkifyElement = __webpack_require__(302);
	var linkifyMatrix = __webpack_require__(142);
	linkifyMatrix(linkify);
	
	module.exports = React.createClass({
	    displayName: 'LinkPreviewWidget',
	
	    propTypes: {
	        link: React.PropTypes.string.isRequired, // the URL being previewed
	        mxEvent: React.PropTypes.object.isRequired, // the Event associated with the preview
	        onCancelClick: React.PropTypes.func, // called when the preview's cancel ('hide') button is clicked
	        onWidgetLoad: React.PropTypes.func },
	
	    getInitialState: function getInitialState() {
	        return {
	            preview: null
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        this.unmounted = false;
	        MatrixClientPeg.get().getUrlPreview(this.props.link, this.props.mxEvent.getTs()).then(function (res) {
	            if (_this.unmounted) {
	                return;
	            }
	            _this.setState({ preview: res }, _this.props.onWidgetLoad);
	        }, function (error) {
	            console.error("Failed to get preview for " + _this.props.link + " " + error);
	        }).done();
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.refs.description) {
	            linkifyElement(this.refs.description, linkifyMatrix.options);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (this.refs.description) {
	            linkifyElement(this.refs.description, linkifyMatrix.options);
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this.unmounted = true;
	    },
	
	    onImageClick: function onImageClick(ev) {
	        var p = this.state.preview;
	        if (ev.button != 0 || ev.metaKey) return;
	        ev.preventDefault();
	        var ImageView = sdk.getComponent("elements.ImageView");
	
	        var src = p["og:image"];
	        if (src && src.startsWith("mxc://")) {
	            src = MatrixClientPeg.get().mxcUrlToHttp(src);
	        }
	
	        var params = {
	            src: src,
	            width: p["og:image:width"],
	            height: p["og:image:height"],
	            name: p["og:title"] || p["og:description"] || this.props.link,
	            fileSize: p["matrix:image:size"],
	            link: this.props.link
	        };
	
	        Modal.createDialog(ImageView, params, "mx_Dialog_lightbox");
	    },
	
	    render: function render() {
	        var p = this.state.preview;
	        if (!p) return React.createElement('div', null);
	
	        // FIXME: do we want to factor out all image displaying between this and MImageBody - especially for lightboxing?
	        var image = p["og:image"];
	        var imageMaxWidth = 100,
	            imageMaxHeight = 100;
	        if (image && image.startsWith("mxc://")) {
	            image = MatrixClientPeg.get().mxcUrlToHttp(image, imageMaxWidth, imageMaxHeight);
	        }
	
	        var thumbHeight = imageMaxHeight;
	        if (p["og:image:width"] && p["og:image:height"]) {
	            thumbHeight = ImageUtils.thumbHeight(p["og:image:width"], p["og:image:height"], imageMaxWidth, imageMaxHeight);
	        }
	
	        var img;
	        if (image) {
	            img = React.createElement(
	                'div',
	                { className: 'mx_LinkPreviewWidget_image', style: { height: thumbHeight } },
	                React.createElement('img', { style: { maxWidth: imageMaxWidth, maxHeight: imageMaxHeight }, src: image, onClick: this.onImageClick })
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_LinkPreviewWidget' },
	            img,
	            React.createElement(
	                'div',
	                { className: 'mx_LinkPreviewWidget_caption' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_LinkPreviewWidget_title' },
	                    React.createElement(
	                        'a',
	                        { href: this.props.link, target: '_blank', rel: 'noopener' },
	                        p["og:title"]
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_LinkPreviewWidget_siteName' },
	                    p["og:site_name"] ? " - " + p["og:site_name"] : null
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_LinkPreviewWidget_description', ref: 'description' },
	                    p["og:description"]
	                )
	            ),
	            React.createElement('img', { className: 'mx_LinkPreviewWidget_cancel', src: 'img/cancel.svg', width: '18', height: '18',
	                onClick: this.props.onCancelClick })
	        );
	    }
	});


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MemberDeviceInfo = function (_React$Component) {
	    (0, _inherits3.default)(MemberDeviceInfo, _React$Component);
	
	    function MemberDeviceInfo() {
	        (0, _classCallCheck3.default)(this, MemberDeviceInfo);
	        return (0, _possibleConstructorReturn3.default)(this, (MemberDeviceInfo.__proto__ || (0, _getPrototypeOf2.default)(MemberDeviceInfo)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MemberDeviceInfo, [{
	        key: 'render',
	        value: function render() {
	            var indicator = null;
	            var DeviceVerifyButtons = _index2.default.getComponent('elements.DeviceVerifyButtons');
	
	            if (this.props.device.isBlocked()) {
	                indicator = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MemberDeviceInfo_blacklisted' },
	                    _react2.default.createElement('img', { src: 'img/e2e-blocked.svg', width: '12', height: '12', style: { marginLeft: "-1px" }, alt: 'Blacklisted' })
	                );
	            } else if (this.props.device.isVerified()) {
	                indicator = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MemberDeviceInfo_verified' },
	                    _react2.default.createElement('img', { src: 'img/e2e-verified.svg', width: '10', height: '12', alt: 'Verified' })
	                );
	            } else {
	                indicator = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MemberDeviceInfo_unverified' },
	                    _react2.default.createElement('img', { src: 'img/e2e-warning.svg', width: '15', height: '12', style: { marginLeft: "-2px" }, alt: 'Unverified' })
	                );
	            }
	
	            var deviceName = this.props.device.ambiguous ? (this.props.device.getDisplayName() ? this.props.device.getDisplayName() : "") + " (" + this.props.device.deviceId + ")" : this.props.device.getDisplayName();
	
	            // add the deviceId as a titletext to help with debugging
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_MemberDeviceInfo',
	                    title: "device id: " + this.props.device.deviceId },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MemberDeviceInfo_deviceInfo' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_MemberDeviceInfo_deviceId' },
	                        deviceName,
	                        indicator
	                    )
	                ),
	                _react2.default.createElement(DeviceVerifyButtons, { userId: this.props.userId, device: this.props.device })
	            );
	        }
	    }]);
	    return MemberDeviceInfo;
	}(_react2.default.Component);
	
	exports.default = MemberDeviceInfo;
	
	
	MemberDeviceInfo.displayName = 'MemberDeviceInfo';
	MemberDeviceInfo.propTypes = {
	    userId: _react2.default.PropTypes.string.isRequired,
	    device: _react2.default.PropTypes.object.isRequired
	};
	module.exports = exports['default'];


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _create = __webpack_require__(178);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _createRoom = __webpack_require__(224);
	
	var _createRoom2 = _interopRequireDefault(_createRoom);
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	var _Unread = __webpack_require__(221);
	
	var _Unread2 = _interopRequireDefault(_Unread);
	
	var _Receipt = __webpack_require__(522);
	
	var _WithMatrixClient = __webpack_require__(337);
	
	var _WithMatrixClient2 = _interopRequireDefault(_WithMatrixClient);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = (0, _WithMatrixClient2.default)(_react2.default.createClass({
	    displayName: 'MemberInfo',
	
	    propTypes: {
	        matrixClient: _react2.default.PropTypes.object.isRequired,
	        member: _react2.default.PropTypes.object.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            can: {
	                kick: false,
	                ban: false,
	                mute: false,
	                modifyLevel: false
	            },
	            muted: false,
	            isTargetMod: false,
	            updating: 0,
	            devicesLoading: true,
	            devices: null
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this._cancelDeviceList = null;
	
	        // only display the devices list if our client supports E2E
	        this._enableDevices = this.props.matrixClient.isCryptoEnabled();
	
	        var cli = this.props.matrixClient;
	        cli.on("deviceVerificationChanged", this.onDeviceVerificationChanged);
	        cli.on("Room", this.onRoom);
	        cli.on("deleteRoom", this.onDeleteRoom);
	        cli.on("Room.timeline", this.onRoomTimeline);
	        cli.on("Room.name", this.onRoomName);
	        cli.on("Room.receipt", this.onRoomReceipt);
	        cli.on("RoomState.events", this.onRoomStateEvents);
	        cli.on("RoomMember.name", this.onRoomMemberName);
	        cli.on("accountData", this.onAccountData);
	    },
	
	    componentDidMount: function componentDidMount() {
	        this._updateStateForNewMember(this.props.member);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        if (this.props.member.userId != newProps.member.userId) {
	            this._updateStateForNewMember(newProps.member);
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        var client = this.props.matrixClient;
	        if (client) {
	            client.removeListener("deviceVerificationChanged", this.onDeviceVerificationChanged);
	            client.removeListener("Room", this.onRoom);
	            client.removeListener("deleteRoom", this.onDeleteRoom);
	            client.removeListener("Room.timeline", this.onRoomTimeline);
	            client.removeListener("Room.name", this.onRoomName);
	            client.removeListener("Room.receipt", this.onRoomReceipt);
	            client.removeListener("RoomState.events", this.onRoomStateEvents);
	            client.removeListener("RoomMember.name", this.onRoomMemberName);
	            client.removeListener("accountData", this.onAccountData);
	        }
	        if (this._cancelDeviceList) {
	            this._cancelDeviceList();
	        }
	    },
	
	    _disambiguateDevices: function _disambiguateDevices(devices) {
	        var names = (0, _create2.default)(null);
	        for (var i = 0; i < devices.length; i++) {
	            var name = devices[i].getDisplayName();
	            var indexList = names[name] || [];
	            indexList.push(i);
	            names[name] = indexList;
	        }
	        for (name in names) {
	            if (names[name].length > 1) {
	                names[name].forEach(function (j) {
	                    devices[j].ambiguous = true;
	                });
	            }
	        }
	    },
	
	    onDeviceVerificationChanged: function onDeviceVerificationChanged(userId, device) {
	        if (!this._enableDevices) {
	            return;
	        }
	
	        if (userId == this.props.member.userId) {
	            // no need to re-download the whole thing; just update our copy of
	            // the list.
	            var devices = this.props.matrixClient.getStoredDevicesForUser(userId);
	            this.setState({ devices: devices });
	        }
	    },
	
	    onRoom: function onRoom(room) {
	        this.forceUpdate();
	    },
	
	    onDeleteRoom: function onDeleteRoom(roomId) {
	        this.forceUpdate();
	    },
	
	    onRoomTimeline: function onRoomTimeline(ev, room, toStartOfTimeline) {
	        if (toStartOfTimeline) return;
	        this.forceUpdate();
	    },
	
	    onRoomName: function onRoomName(room) {
	        this.forceUpdate();
	    },
	
	    onRoomReceipt: function onRoomReceipt(receiptEvent, room) {
	        // because if we read a notification, it will affect notification count
	        // only bother updating if there's a receipt from us
	        if ((0, _Receipt.findReadReceiptFromUserId)(receiptEvent, this.props.matrixClient.credentials.userId)) {
	            this.forceUpdate();
	        }
	    },
	
	    onRoomStateEvents: function onRoomStateEvents(ev, state) {
	        this.forceUpdate();
	    },
	
	    onRoomMemberName: function onRoomMemberName(ev, member) {
	        this.forceUpdate();
	    },
	
	    onAccountData: function onAccountData(ev) {
	        if (ev.getType() == 'm.direct') {
	            this.forceUpdate();
	        }
	    },
	
	    _updateStateForNewMember: function _updateStateForNewMember(member) {
	        var newState = this._calculateOpsPermissions(member);
	        newState.devicesLoading = true;
	        newState.devices = null;
	        this.setState(newState);
	
	        if (this._cancelDeviceList) {
	            this._cancelDeviceList();
	            this._cancelDeviceList = null;
	        }
	
	        this._downloadDeviceList(member);
	    },
	
	    _downloadDeviceList: function _downloadDeviceList(member) {
	        if (!this._enableDevices) {
	            return;
	        }
	
	        var cancelled = false;
	        this._cancelDeviceList = function () {
	            cancelled = true;
	        };
	
	        var client = this.props.matrixClient;
	        var self = this;
	        client.downloadKeys([member.userId], true).finally(function () {
	            self._cancelDeviceList = null;
	        }).done(function () {
	            if (cancelled) {
	                // we got cancelled - presumably a different user now
	                return;
	            }
	            var devices = client.getStoredDevicesForUser(member.userId);
	            self._disambiguateDevices(devices);
	            self.setState({ devicesLoading: false, devices: devices });
	        }, function (err) {
	            console.log("Error downloading devices", err);
	            self.setState({ devicesLoading: false });
	        });
	    },
	
	    onKick: function onKick() {
	        var _this = this;
	
	        var membership = this.props.member.membership;
	        var kickLabel = membership === "invite" ? "Disinvite" : "Kick";
	        var ConfirmUserActionDialog = _index2.default.getComponent("dialogs.ConfirmUserActionDialog");
	        _Modal2.default.createDialog(ConfirmUserActionDialog, {
	            member: this.props.member,
	            action: kickLabel,
	            askReason: membership == "join",
	            danger: true,
	            onFinished: function onFinished(proceed, reason) {
	                if (!proceed) return;
	
	                _this.setState({ updating: _this.state.updating + 1 });
	                _this.props.matrixClient.kick(_this.props.member.roomId, _this.props.member.userId, reason || undefined).then(function () {
	                    // NO-OP; rely on the m.room.member event coming down else we could
	                    // get out of sync if we force setState here!
	                    console.log("Kick success");
	                }, function (err) {
	                    var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                    console.error("Kick error: " + err);
	                    _Modal2.default.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "Failed to kick user"
	                    });
	                }).finally(function () {
	                    _this.setState({ updating: _this.state.updating - 1 });
	                });
	            }
	        });
	    },
	
	    onBanOrUnban: function onBanOrUnban() {
	        var _this2 = this;
	
	        var ConfirmUserActionDialog = _index2.default.getComponent("dialogs.ConfirmUserActionDialog");
	        _Modal2.default.createDialog(ConfirmUserActionDialog, {
	            member: this.props.member,
	            action: this.props.member.membership == 'ban' ? 'Unban' : 'Ban',
	            askReason: this.props.member.membership != 'ban',
	            danger: this.props.member.membership != 'ban',
	            onFinished: function onFinished(proceed, reason) {
	                if (!proceed) return;
	
	                _this2.setState({ updating: _this2.state.updating + 1 });
	                var promise = void 0;
	                if (_this2.props.member.membership == 'ban') {
	                    promise = _this2.props.matrixClient.unban(_this2.props.member.roomId, _this2.props.member.userId);
	                } else {
	                    promise = _this2.props.matrixClient.ban(_this2.props.member.roomId, _this2.props.member.userId, reason || undefined);
	                }
	                promise.then(function () {
	                    // NO-OP; rely on the m.room.member event coming down else we could
	                    // get out of sync if we force setState here!
	                    console.log("Ban success");
	                }, function (err) {
	                    var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                    console.error("Ban error: " + err);
	                    _Modal2.default.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "Failed to ban user"
	                    });
	                }).finally(function () {
	                    _this2.setState({ updating: _this2.state.updating - 1 });
	                });
	            }
	        });
	    },
	
	    onMuteToggle: function onMuteToggle() {
	        var _this3 = this;
	
	        var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	        var roomId = this.props.member.roomId;
	        var target = this.props.member.userId;
	        var room = this.props.matrixClient.getRoom(roomId);
	        if (!room) {
	            return;
	        }
	        var powerLevelEvent = room.currentState.getStateEvents("m.room.power_levels", "");
	        if (!powerLevelEvent) {
	            return;
	        }
	        var isMuted = this.state.muted;
	        var powerLevels = powerLevelEvent.getContent();
	        var levelToSend = (powerLevels.events ? powerLevels.events["m.room.message"] : null) || powerLevels.events_default;
	        var level;
	        if (isMuted) {
	            // unmute
	            level = levelToSend;
	        } else {
	            // mute
	            level = levelToSend - 1;
	        }
	        level = parseInt(level);
	
	        if (level !== NaN) {
	            this.setState({ updating: this.state.updating + 1 });
	            this.props.matrixClient.setPowerLevel(roomId, target, level, powerLevelEvent).then(function () {
	                // NO-OP; rely on the m.room.member event coming down else we could
	                // get out of sync if we force setState here!
	                console.log("Mute toggle success");
	            }, function (err) {
	                console.error("Mute error: " + err);
	                _Modal2.default.createDialog(ErrorDialog, {
	                    title: "Error",
	                    description: "Failed to mute user"
	                });
	            }).finally(function () {
	                _this3.setState({ updating: _this3.state.updating - 1 });
	            });
	        }
	    },
	
	    onModToggle: function onModToggle() {
	        var _this4 = this;
	
	        var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	        var roomId = this.props.member.roomId;
	        var target = this.props.member.userId;
	        var room = this.props.matrixClient.getRoom(roomId);
	        if (!room) {
	            return;
	        }
	        var powerLevelEvent = room.currentState.getStateEvents("m.room.power_levels", "");
	        if (!powerLevelEvent) {
	            return;
	        }
	        var me = room.getMember(this.props.matrixClient.credentials.userId);
	        if (!me) {
	            return;
	        }
	        var defaultLevel = powerLevelEvent.getContent().users_default;
	        var modLevel = me.powerLevel - 1;
	        if (modLevel > 50 && defaultLevel < 50) modLevel = 50; // try to stick with the vector level defaults
	        // toggle the level
	        var newLevel = this.state.isTargetMod ? defaultLevel : modLevel;
	        this.setState({ updating: this.state.updating + 1 });
	        this.props.matrixClient.setPowerLevel(roomId, target, parseInt(newLevel), powerLevelEvent).then(function () {
	            // NO-OP; rely on the m.room.member event coming down else we could
	            // get out of sync if we force setState here!
	            console.log("Mod toggle success");
	        }, function (err) {
	            if (err.errcode == 'M_GUEST_ACCESS_FORBIDDEN') {
	                var NeedToRegisterDialog = _index2.default.getComponent("dialogs.NeedToRegisterDialog");
	                _Modal2.default.createDialog(NeedToRegisterDialog, {
	                    title: "Please Register",
	                    description: "This action cannot be performed by a guest user. Please register to be able to do this."
	                });
	            } else {
	                console.error("Toggle moderator error:" + err);
	                _Modal2.default.createDialog(ErrorDialog, {
	                    title: "Error",
	                    description: "Failed to toggle moderator status"
	                });
	            }
	        }).finally(function () {
	            _this4.setState({ updating: _this4.state.updating - 1 });
	        });
	    },
	
	    _applyPowerChange: function _applyPowerChange(roomId, target, powerLevel, powerLevelEvent) {
	        var _this5 = this;
	
	        this.setState({ updating: this.state.updating + 1 });
	        this.props.matrixClient.setPowerLevel(roomId, target, parseInt(powerLevel), powerLevelEvent).then(function () {
	            // NO-OP; rely on the m.room.member event coming down else we could
	            // get out of sync if we force setState here!
	            console.log("Power change success");
	        }, function (err) {
	            var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	            console.error("Failed to change power level " + err);
	            _Modal2.default.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "Failed to change power level"
	            });
	        }).finally(function () {
	            _this5.setState({ updating: _this5.state.updating - 1 });
	        }).done();
	    },
	
	    onPowerChange: function onPowerChange(powerLevel) {
	        var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	        var roomId = this.props.member.roomId;
	        var target = this.props.member.userId;
	        var room = this.props.matrixClient.getRoom(roomId);
	        var self = this;
	        if (!room) {
	            return;
	        }
	        var powerLevelEvent = room.currentState.getStateEvents("m.room.power_levels", "");
	        if (!powerLevelEvent) {
	            return;
	        }
	        if (powerLevelEvent.getContent().users) {
	            var myPower = powerLevelEvent.getContent().users[this.props.matrixClient.credentials.userId];
	            if (parseInt(myPower) === parseInt(powerLevel)) {
	                var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
	                _Modal2.default.createDialog(QuestionDialog, {
	                    title: "Warning",
	                    description: _react2.default.createElement(
	                        'div',
	                        null,
	                        'You will not be able to undo this change as you are promoting the user to have the same power level as yourself.',
	                        _react2.default.createElement('br', null),
	                        'Are you sure?'
	                    ),
	                    button: "Continue",
	                    onFinished: function onFinished(confirmed) {
	                        if (confirmed) {
	                            self._applyPowerChange(roomId, target, powerLevel, powerLevelEvent);
	                        }
	                    }
	                });
	            } else {
	                this._applyPowerChange(roomId, target, powerLevel, powerLevelEvent);
	            }
	        } else {
	            this._applyPowerChange(roomId, target, powerLevel, powerLevelEvent);
	        }
	    },
	
	    onNewDMClick: function onNewDMClick() {
	        var _this6 = this;
	
	        this.setState({ updating: this.state.updating + 1 });
	        (0, _createRoom2.default)({ dmUserId: this.props.member.userId }).finally(function () {
	            _this6.setState({ updating: _this6.state.updating - 1 });
	        }).done();
	    },
	
	    onLeaveClick: function onLeaveClick() {
	        _dispatcher2.default.dispatch({
	            action: 'leave_room',
	            room_id: this.props.member.roomId
	        });
	    },
	
	    _calculateOpsPermissions: function _calculateOpsPermissions(member) {
	        var defaultPerms = {
	            can: {},
	            muted: false,
	            modifyLevel: false
	        };
	        var room = this.props.matrixClient.getRoom(member.roomId);
	        if (!room) {
	            return defaultPerms;
	        }
	        var powerLevels = room.currentState.getStateEvents("m.room.power_levels", "");
	        if (!powerLevels) {
	            return defaultPerms;
	        }
	        var me = room.getMember(this.props.matrixClient.credentials.userId);
	        if (!me) {
	            return defaultPerms;
	        }
	        var them = member;
	        return {
	            can: this._calculateCanPermissions(me, them, powerLevels.getContent()),
	            muted: this._isMuted(them, powerLevels.getContent()),
	            isTargetMod: them.powerLevel > powerLevels.getContent().users_default
	        };
	    },
	
	    _calculateCanPermissions: function _calculateCanPermissions(me, them, powerLevels) {
	        var can = {
	            kick: false,
	            ban: false,
	            mute: false,
	            modifyLevel: false
	        };
	        var canAffectUser = them.powerLevel < me.powerLevel;
	        if (!canAffectUser) {
	            //console.log("Cannot affect user: %s >= %s", them.powerLevel, me.powerLevel);
	            return can;
	        }
	        var editPowerLevel = (powerLevels.events ? powerLevels.events["m.room.power_levels"] : null) || powerLevels.state_default;
	        var levelToSend = (powerLevels.events ? powerLevels.events["m.room.message"] : null) || powerLevels.events_default;
	
	        can.kick = me.powerLevel >= powerLevels.kick;
	        can.ban = me.powerLevel >= powerLevels.ban;
	        can.mute = me.powerLevel >= editPowerLevel;
	        can.toggleMod = me.powerLevel > them.powerLevel && them.powerLevel >= levelToSend;
	        can.modifyLevel = me.powerLevel > them.powerLevel;
	        return can;
	    },
	
	    _isMuted: function _isMuted(member, powerLevelContent) {
	        if (!powerLevelContent || !member) {
	            return false;
	        }
	        var levelToSend = (powerLevelContent.events ? powerLevelContent.events["m.room.message"] : null) || powerLevelContent.events_default;
	        return member.powerLevel < levelToSend;
	    },
	
	    onCancel: function onCancel(e) {
	        _dispatcher2.default.dispatch({
	            action: "view_user",
	            member: null
	        });
	    },
	
	    onMemberAvatarClick: function onMemberAvatarClick() {
	        var avatarUrl = this.props.member.user ? this.props.member.user.avatarUrl : this.props.member.events.member.getContent().avatar_url;
	        if (!avatarUrl) return;
	
	        var httpUrl = this.props.matrixClient.mxcUrlToHttp(avatarUrl);
	        var ImageView = _index2.default.getComponent("elements.ImageView");
	        var params = {
	            src: httpUrl,
	            name: this.props.member.name
	        };
	
	        _Modal2.default.createDialog(ImageView, params, "mx_Dialog_lightbox");
	    },
	
	    onRoomTileClick: function onRoomTileClick(roomId) {
	        _dispatcher2.default.dispatch({
	            action: 'view_room',
	            room_id: roomId
	        });
	    },
	
	
	    _renderDevices: function _renderDevices() {
	        if (!this._enableDevices) {
	            return null;
	        }
	
	        var devices = this.state.devices;
	        var MemberDeviceInfo = _index2.default.getComponent('rooms.MemberDeviceInfo');
	        var Spinner = _index2.default.getComponent("elements.Spinner");
	
	        var devComponents;
	        if (this.state.devicesLoading) {
	            // still loading
	            devComponents = _react2.default.createElement(Spinner, null);
	        } else if (devices === null) {
	            devComponents = "Unable to load device list";
	        } else if (devices.length === 0) {
	            devComponents = "No devices with registered encryption keys";
	        } else {
	            devComponents = [];
	            for (var i = 0; i < devices.length; i++) {
	                devComponents.push(_react2.default.createElement(MemberDeviceInfo, { key: i,
	                    userId: this.props.member.userId,
	                    device: devices[i] }));
	            }
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Devices'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_MemberInfo_devices' },
	                devComponents
	            )
	        );
	    },
	
	    render: function render() {
	        var startChat, kickButton, banButton, muteButton, giveModButton, spinner;
	        if (this.props.member.userId !== this.props.matrixClient.credentials.userId) {
	            var dmRoomMap = new _DMRoomMap2.default(this.props.matrixClient);
	            var dmRooms = dmRoomMap.getDMRoomsForUserId(this.props.member.userId);
	
	            var RoomTile = _index2.default.getComponent("rooms.RoomTile");
	
	            var tiles = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(dmRooms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var roomId = _step.value;
	
	                    var room = this.props.matrixClient.getRoom(roomId);
	                    if (room) {
	                        var me = room.getMember(this.props.matrixClient.credentials.userId);
	                        var highlight = room.getUnreadNotificationCount('highlight') > 0 || me.membership == "invite";
	                        tiles.push(_react2.default.createElement(RoomTile, { key: room.roomId, room: room,
	                            collapsed: false,
	                            selected: false,
	                            unread: _Unread2.default.doesRoomHaveUnreadMessages(room),
	                            highlight: highlight,
	                            isInvite: me.membership == "invite",
	                            onClick: this.onRoomTileClick
	                        }));
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var labelClasses = (0, _classnames2.default)({
	                mx_MemberInfo_createRoom_label: true,
	                mx_RoomTile_name: true
	            });
	            var startNewChat = _react2.default.createElement(
	                _AccessibleButton2.default,
	                {
	                    className: 'mx_MemberInfo_createRoom',
	                    onClick: this.onNewDMClick
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomTile_avatar' },
	                    _react2.default.createElement('img', { src: 'img/create-big.svg', width: '26', height: '26' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: labelClasses },
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        'Start new chat'
	                    )
	                )
	            );
	
	            startChat = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Direct chats'
	                ),
	                tiles,
	                startNewChat
	            );
	        }
	
	        if (this.state.updating) {
	            var Loader = _index2.default.getComponent("elements.Spinner");
	            spinner = _react2.default.createElement(Loader, { imgClassName: 'mx_ContextualMenu_spinner' });
	        }
	
	        if (this.state.can.kick) {
	            var membership = this.props.member.membership;
	            var kickLabel = membership === "invite" ? "Disinvite" : "Kick";
	            kickButton = _react2.default.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_MemberInfo_field',
	                    onClick: this.onKick },
	                kickLabel
	            );
	        }
	        if (this.state.can.ban) {
	            var label = 'Ban';
	            if (this.props.member.membership == 'ban') {
	                label = 'Unban';
	            }
	            banButton = _react2.default.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_MemberInfo_field',
	                    onClick: this.onBanOrUnban },
	                label
	            );
	        }
	        if (this.state.can.mute) {
	            var muteLabel = this.state.muted ? "Unmute" : "Mute";
	            muteButton = _react2.default.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_MemberInfo_field',
	                    onClick: this.onMuteToggle },
	                muteLabel
	            );
	        }
	        if (this.state.can.toggleMod) {
	            var giveOpLabel = this.state.isTargetMod ? "Revoke Moderator" : "Make Moderator";
	            giveModButton = _react2.default.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_MemberInfo_field', onClick: this.onModToggle },
	                giveOpLabel
	            );
	        }
	
	        // TODO: we should have an invite button if this MemberInfo is showing a user who isn't actually in the current room yet
	        // e.g. clicking on a linkified userid in a room
	
	        var adminTools;
	        if (kickButton || banButton || muteButton || giveModButton) {
	            adminTools = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Admin tools'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MemberInfo_buttons' },
	                    muteButton,
	                    kickButton,
	                    banButton,
	                    giveModButton
	                )
	            );
	        }
	
	        var memberName = this.props.member.name;
	
	        var MemberAvatar = _index2.default.getComponent('avatars.MemberAvatar');
	        var PowerSelector = _index2.default.getComponent('elements.PowerSelector');
	        var EmojiText = _index2.default.getComponent('elements.EmojiText');
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_MemberInfo' },
	            _react2.default.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_MemberInfo_cancel', onClick: this.onCancel },
	                ' ',
	                _react2.default.createElement('img', { src: 'img/cancel.svg', width: '18', height: '18' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_MemberInfo_avatar' },
	                _react2.default.createElement(MemberAvatar, { onClick: this.onMemberAvatarClick, member: this.props.member, width: 48, height: 48 })
	            ),
	            _react2.default.createElement(
	                EmojiText,
	                { element: 'h2' },
	                memberName
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_MemberInfo_profile' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MemberInfo_profileField' },
	                    this.props.member.userId
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MemberInfo_profileField' },
	                    'Level: ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        _react2.default.createElement(PowerSelector, { controlled: true, value: parseInt(this.props.member.powerLevel), disabled: !this.state.can.modifyLevel, onChange: this.onPowerChange })
	                    )
	                )
	            ),
	            adminTools,
	            startChat,
	            this._renderDevices(),
	            spinner
	        );
	    }
	})); /*
	     Copyright 2015, 2016 OpenMarket Ltd
	     Copyright 2017 Vector Creations Ltd
	     
	     Licensed under the Apache License, Version 2.0 (the "License");
	     you may not use this file except in compliance with the License.
	     You may obtain a copy of the License at
	     
	         http://www.apache.org/licenses/LICENSE-2.0
	     
	     Unless required by applicable law or agreed to in writing, software
	     distributed under the License is distributed on an "AS IS" BASIS,
	     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     See the License for the specific language governing permissions and
	     limitations under the License.
	     */
	
	/*
	 * State vars:
	 * 'can': {
	 *   kick: boolean,
	 *   ban: boolean,
	 *   mute: boolean,
	 *   modifyLevel: boolean
	 * },
	 * 'muted': boolean,
	 * 'isTargetMod': boolean
	 */


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	var classNames = __webpack_require__(27);
	var Matrix = __webpack_require__(28);
	var q = __webpack_require__(6);
	var MatrixClientPeg = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	var Entities = __webpack_require__(1156);
	var sdk = __webpack_require__(2);
	var GeminiScrollbar = __webpack_require__(121);
	var rate_limited_func = __webpack_require__(119);
	var CallHandler = __webpack_require__(73);
	var Invite = __webpack_require__(220);
	
	var INITIAL_LOAD_NUM_MEMBERS = 30;
	var SHARE_HISTORY_WARNING = React.createElement(
	    'span',
	    null,
	    'Newly invited users will see the history of this room. ',
	    React.createElement('br', null),
	    'If you\'d prefer invited users not to see messages that were sent before they joined, ',
	    React.createElement('br', null),
	    'turn off, \'Share message history with new users\' in the settings for this room.'
	);
	
	module.exports = React.createClass({
	    displayName: 'MemberList',
	
	    getInitialState: function getInitialState() {
	        var state = {
	            members: [],
	            // ideally we'd size this to the page height, but
	            // in practice I find that a little constraining
	            truncateAt: INITIAL_LOAD_NUM_MEMBERS,
	            searchQuery: ""
	        };
	        if (!this.props.roomId) return state;
	        var cli = MatrixClientPeg.get();
	        var room = cli.getRoom(this.props.roomId);
	        if (!room) return state;
	
	        this.memberDict = this.getMemberDict();
	
	        state.members = this.roomMembers();
	        return state;
	    },
	
	    componentWillMount: function componentWillMount() {
	        var cli = MatrixClientPeg.get();
	        cli.on("RoomState.members", this.onRoomStateMember);
	        cli.on("RoomMember.name", this.onRoomMemberName);
	        cli.on("RoomState.events", this.onRoomStateEvent);
	        cli.on("Room", this.onRoom); // invites
	        // We listen for changes to the lastPresenceTs which is essentially
	        // listening for all presence events (we display most of not all of
	        // the information contained in presence events).
	        cli.on("User.lastPresenceTs", this.onUserLastPresenceTs);
	        // cli.on("Room.timeline", this.onRoomTimeline);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        var cli = MatrixClientPeg.get();
	        if (cli) {
	            cli.removeListener("RoomState.members", this.onRoomStateMember);
	            cli.removeListener("RoomMember.name", this.onRoomMemberName);
	            cli.removeListener("RoomState.events", this.onRoomStateEvent);
	            cli.removeListener("Room", this.onRoom);
	            cli.removeListener("User.lastPresenceTs", this.onUserLastPresenceTs);
	            // cli.removeListener("Room.timeline", this.onRoomTimeline);
	        }
	
	        // cancel any pending calls to the rate_limited_funcs
	        this._updateList.cancelPendingCall();
	    },
	
	    /*
	        onRoomTimeline: function(ev, room, toStartOfTimeline, removed, data) {
	            // ignore anything but real-time updates at the end of the room:
	            // updates from pagination will happen when the paginate completes.
	            if (toStartOfTimeline || !data || !data.liveEvent) return;
	    
	            // treat any activity from a user as implicit presence to update the
	            // ordering of the list whenever someone says something.
	            // Except right now we're not tiebreaking "active now" users in this way
	            // so don't bother for now.
	            if (ev.getSender()) {
	                // console.log("implicit presence from " + ev.getSender());
	    
	                var tile = this.refs[ev.getSender()];
	                if (tile) {
	                    // work around a race where you might have a room member object
	                    // before the user object exists.  XXX: why does this ever happen?
	                    var all_members = room.currentState.members;
	                    var userId = ev.getSender();
	                    if (all_members[userId].user === null) {
	                        all_members[userId].user = MatrixClientPeg.get().getUser(userId);
	                    }
	                    this._updateList(); // reorder the membership list
	                }
	            }
	        },
	    */
	
	    onUserLastPresenceTs: function onUserLastPresenceTs(event, user) {
	        // Attach a SINGLE listener for global presence changes then locate the
	        // member tile and re-render it. This is more efficient than every tile
	        // evar attaching their own listener.
	        // console.log("explicit presence from " + user.userId);
	        var tile = this.refs[user.userId];
	        if (tile) {
	            this._updateList(); // reorder the membership list
	        }
	    },
	
	
	    onRoom: function onRoom(room) {
	        if (room.roomId !== this.props.roomId) {
	            return;
	        }
	        // We listen for room events because when we accept an invite
	        // we need to wait till the room is fully populated with state
	        // before refreshing the member list else we get a stale list.
	        this._updateList();
	    },
	
	    onRoomStateMember: function onRoomStateMember(ev, state, member) {
	        this._updateList();
	    },
	
	    onRoomMemberName: function onRoomMemberName(ev, member) {
	        this._updateList();
	    },
	
	    onRoomStateEvent: function onRoomStateEvent(event, state) {
	        if (event.getType() === "m.room.third_party_invite") {
	            this._updateList();
	        }
	    },
	
	    _updateList: new rate_limited_func(function () {
	        // console.log("Updating memberlist");
	        this.memberDict = this.getMemberDict();
	
	        var self = this;
	        this.setState({
	            members: self.roomMembers()
	        });
	    }, 500),
	
	    getMemberDict: function getMemberDict() {
	        if (!this.props.roomId) return {};
	        var cli = MatrixClientPeg.get();
	        var room = cli.getRoom(this.props.roomId);
	        if (!room) return {};
	
	        var all_members = room.currentState.members;
	
	        (0, _keys2.default)(all_members).map(function (userId) {
	            // work around a race where you might have a room member object
	            // before the user object exists.  This may or may not cause
	            // https://github.com/vector-im/vector-web/issues/186
	            if (all_members[userId].user === null) {
	                all_members[userId].user = MatrixClientPeg.get().getUser(userId);
	            }
	
	            // XXX: this user may have no lastPresenceTs value!
	            // the right solution here is to fix the race rather than leave it as 0
	        });
	
	        return all_members;
	    },
	
	    roomMembers: function roomMembers() {
	        var all_members = this.memberDict || {};
	        var all_user_ids = (0, _keys2.default)(all_members);
	        var ConferenceHandler = CallHandler.getConferenceHandler();
	
	        all_user_ids.sort(this.memberSort);
	
	        var to_display = [];
	        var count = 0;
	        for (var i = 0; i < all_user_ids.length; ++i) {
	            var user_id = all_user_ids[i];
	            var m = all_members[user_id];
	
	            if (m.membership == 'join' || m.membership == 'invite') {
	                if (ConferenceHandler && !ConferenceHandler.isConferenceUser(user_id) || !ConferenceHandler) {
	                    to_display.push(user_id);
	                    ++count;
	                }
	            }
	        }
	        return to_display;
	    },
	
	    _createOverflowTile: function _createOverflowTile(overflowCount, totalCount) {
	        // For now we'll pretend this is any entity. It should probably be a separate tile.
	        var EntityTile = sdk.getComponent("rooms.EntityTile");
	        var BaseAvatar = sdk.getComponent("avatars.BaseAvatar");
	        var text = "and " + overflowCount + " other" + (overflowCount > 1 ? "s" : "") + "...";
	        return React.createElement(EntityTile, { className: 'mx_EntityTile_ellipsis', avatarJsx: React.createElement(BaseAvatar, { url: 'img/ellipsis.svg', name: '...', width: 36, height: 36 }), name: text, presenceState: 'online', suppressOnHover: true,
	            onClick: this._showFullMemberList });
	    },
	
	    _showFullMemberList: function _showFullMemberList() {
	        this.setState({
	            truncateAt: -1
	        });
	    },
	
	    memberString: function memberString(member) {
	        if (!member) {
	            return "(null)";
	        } else {
	            return "(" + member.name + ", " + member.powerLevel + ", " + member.user.lastActiveAgo + ", " + member.user.currentlyActive + ")";
	        }
	    },
	
	    // returns negative if a comes before b,
	    // returns 0 if a and b are equivalent in ordering
	    // returns positive if a comes after b.
	    memberSort: function memberSort(userIdA, userIdB) {
	        // order by last active, with "active now" first.
	        // ...and then by power
	        // ...and then alphabetically.
	        // We could tiebreak instead by "last recently spoken in this room" if we wanted to.
	
	        var memberA = this.memberDict[userIdA];
	        var memberB = this.memberDict[userIdB];
	        var userA = memberA.user;
	        var userB = memberB.user;
	
	        // if (!userA || !userB) {
	        //     console.log("comparing " + memberA.name + " user=" + memberA.user + " with " + memberB.name + " user=" + memberB.user);
	        // }
	
	        if (!userA && !userB) return 0;
	        if (userA && !userB) return -1;
	        if (!userA && userB) return 1;
	
	        // console.log("comparing " + this.memberString(memberA) + " and " + this.memberString(memberB));
	
	        if (userA.currentlyActive && userB.currentlyActive) {
	            // console.log(memberA.name + " and " + memberB.name + " are both active");
	            if (memberA.powerLevel === memberB.powerLevel) {
	                // console.log(memberA + " and " + memberB + " have same power level");
	                if (memberA.name && memberB.name) {
	                    // console.log("comparing names: " + memberA.name + " and " + memberB.name);
	                    var nameA = memberA.name[0] === '@' ? memberA.name.substr(1) : memberA.name;
	                    var nameB = memberB.name[0] === '@' ? memberB.name.substr(1) : memberB.name;
	                    return nameA.localeCompare(nameB);
	                } else {
	                    return 0;
	                }
	            } else {
	                // console.log("comparing power: " + memberA.powerLevel + " and " + memberB.powerLevel);
	                return memberB.powerLevel - memberA.powerLevel;
	            }
	        }
	
	        if (userA.currentlyActive && !userB.currentlyActive) return -1;
	        if (!userA.currentlyActive && userB.currentlyActive) return 1;
	
	        // For now, let's just order things by timestamp. It's really annoying
	        // that a user disappears from sight just because they temporarily go offline
	        return userB.getLastActiveTs() - userA.getLastActiveTs();
	    },
	
	    onSearchQueryChanged: function onSearchQueryChanged(ev) {
	        this.setState({ searchQuery: ev.target.value });
	    },
	
	    makeMemberTiles: function makeMemberTiles(membership, query) {
	        var MemberTile = sdk.getComponent("rooms.MemberTile");
	        query = (query || "").toLowerCase();
	
	        var self = this;
	
	        var memberList = self.state.members.filter(function (userId) {
	            var m = self.memberDict[userId];
	
	            if (query) {
	                var matchesName = m.name.toLowerCase().indexOf(query) !== -1;
	                var matchesId = m.userId.toLowerCase().indexOf(query) !== -1;
	
	                if (!matchesName && !matchesId) {
	                    return false;
	                }
	            }
	
	            return m.membership == membership;
	        }).map(function (userId) {
	            var m = self.memberDict[userId];
	            return React.createElement(MemberTile, { key: userId, member: m, ref: userId });
	        });
	
	        // XXX: surely this is not the right home for this logic.
	        if (membership === "invite") {
	            // include 3pid invites (m.room.third_party_invite) state events.
	            // The HS may have already converted these into m.room.member invites so
	            // we shouldn't add them if the 3pid invite state key (token) is in the
	            // member invite (content.third_party_invite.signed.token)
	            var room = MatrixClientPeg.get().getRoom(this.props.roomId);
	            var EntityTile = sdk.getComponent("rooms.EntityTile");
	            if (room) {
	                room.currentState.getStateEvents("m.room.third_party_invite").forEach(function (e) {
	                    // any events without these keys are not valid 3pid invites, so we ignore them
	                    var required_keys = ['key_validity_url', 'public_key', 'display_name'];
	                    for (var i = 0; i < required_keys.length; ++i) {
	                        if (e.getContent()[required_keys[i]] === undefined) return;
	                    }
	
	                    // discard all invites which have a m.room.member event since we've
	                    // already added them.
	                    var memberEvent = room.currentState.getInviteForThreePidToken(e.getStateKey());
	                    if (memberEvent) {
	                        return;
	                    }
	                    memberList.push(React.createElement(EntityTile, { key: e.getStateKey(), name: e.getContent().display_name }));
	                });
	            }
	        }
	
	        return memberList;
	    },
	
	    render: function render() {
	        var invitedSection = null;
	        var invitedMemberTiles = this.makeMemberTiles('invite', this.state.searchQuery);
	        if (invitedMemberTiles.length > 0) {
	            invitedSection = React.createElement(
	                'div',
	                { className: 'mx_MemberList_invited' },
	                React.createElement(
	                    'h2',
	                    null,
	                    'Invited'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_MemberList_wrapper' },
	                    invitedMemberTiles
	                )
	            );
	        }
	
	        var inputBox = React.createElement(
	            'form',
	            { autoComplete: 'off' },
	            React.createElement('input', { className: 'mx_MemberList_query', id: 'mx_MemberList_query', type: 'text',
	                onChange: this.onSearchQueryChanged, value: this.state.searchQuery,
	                placeholder: 'Filter room members' })
	        );
	
	        var TruncatedList = sdk.getComponent("elements.TruncatedList");
	        return React.createElement(
	            'div',
	            { className: 'mx_MemberList' },
	            inputBox,
	            React.createElement(
	                GeminiScrollbar,
	                { autoshow: true, className: 'mx_MemberList_joined mx_MemberList_outerWrapper' },
	                React.createElement(
	                    TruncatedList,
	                    { className: 'mx_MemberList_wrapper', truncateAt: this.state.truncateAt,
	                        createOverflowElement: this._createOverflowTile },
	                    this.makeMemberTiles('join', this.state.searchQuery)
	                ),
	                invitedSection
	            )
	        );
	    }
	});


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	
	module.exports = React.createClass({
	    displayName: 'MemberTile',
	
	    propTypes: {
	        member: React.PropTypes.any.isRequired },
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (this.member_last_modified_time === undefined || this.member_last_modified_time < nextProps.member.getLastModifiedTime()) {
	            return true;
	        }
	        if (nextProps.member.user && (this.user_last_modified_time === undefined || this.user_last_modified_time < nextProps.member.user.getLastModifiedTime())) {
	            return true;
	        }
	        return false;
	    },
	
	    onClick: function onClick(e) {
	        dis.dispatch({
	            action: 'view_user',
	            member: this.props.member
	        });
	    },
	
	    _getDisplayName: function _getDisplayName() {
	        return this.props.member.name;
	    },
	
	    getPowerLabel: function getPowerLabel() {
	        return this.props.member.userId + " (power " + this.props.member.powerLevel + ")";
	    },
	
	    render: function render() {
	        var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');
	        var BaseAvatar = sdk.getComponent('avatars.BaseAvatar');
	        var EntityTile = sdk.getComponent('rooms.EntityTile');
	
	        var member = this.props.member;
	        var name = this._getDisplayName();
	        var active = -1;
	        var presenceState = member.user ? member.user.presence : null;
	
	        var av = React.createElement(MemberAvatar, { member: member, width: 36, height: 36 });
	
	        if (member.user) {
	            this.user_last_modified_time = member.user.getLastModifiedTime();
	        }
	        this.member_last_modified_time = member.getLastModifiedTime();
	
	        return React.createElement(EntityTile, (0, _extends3.default)({}, this.props, { presenceState: presenceState,
	            presenceLastActiveAgo: member.user ? member.user.lastActiveAgo : 0,
	            presenceLastTs: member.user ? member.user.lastPresenceTs : 0,
	            presenceCurrentlyActive: member.user ? member.user.currentlyActive : false,
	            avatarJsx: av, title: this.getPowerLabel(), onClick: this.onClick,
	            name: name, powerLevel: this.props.member.powerLevel }));
	    }
	});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Autocomplete = __webpack_require__(336);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UserSettingsStore = __webpack_require__(74);
	
	var _UserSettingsStore2 = _interopRequireDefault(_UserSettingsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	
	var CallHandler = __webpack_require__(73);
	var MatrixClientPeg = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	
	var MessageComposer = function (_React$Component) {
	    (0, _inherits3.default)(MessageComposer, _React$Component);
	
	    function MessageComposer(props, context) {
	        (0, _classCallCheck3.default)(this, MessageComposer);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageComposer.__proto__ || (0, _getPrototypeOf2.default)(MessageComposer)).call(this, props, context));
	
	        _this.onCallClick = _this.onCallClick.bind(_this);
	        _this.onHangupClick = _this.onHangupClick.bind(_this);
	        _this.onUploadClick = _this.onUploadClick.bind(_this);
	        _this.onUploadFileSelected = _this.onUploadFileSelected.bind(_this);
	        _this.onVoiceCallClick = _this.onVoiceCallClick.bind(_this);
	        _this.onInputContentChanged = _this.onInputContentChanged.bind(_this);
	        _this.onUpArrow = _this.onUpArrow.bind(_this);
	        _this.onDownArrow = _this.onDownArrow.bind(_this);
	        _this._tryComplete = _this._tryComplete.bind(_this);
	        _this._onAutocompleteConfirm = _this._onAutocompleteConfirm.bind(_this);
	        _this.onToggleFormattingClicked = _this.onToggleFormattingClicked.bind(_this);
	        _this.onToggleMarkdownClicked = _this.onToggleMarkdownClicked.bind(_this);
	        _this.onInputStateChanged = _this.onInputStateChanged.bind(_this);
	        _this.onEvent = _this.onEvent.bind(_this);
	
	        _this.state = {
	            autocompleteQuery: '',
	            selection: null,
	            inputState: {
	                style: [],
	                blockType: null,
	                isRichtextEnabled: _UserSettingsStore2.default.getSyncedSetting('MessageComposerInput.isRichTextEnabled', true),
	                wordCount: 0
	            },
	            showFormatting: _UserSettingsStore2.default.getSyncedSetting('MessageComposer.showFormatting', false)
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(MessageComposer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // N.B. using 'event' rather than 'RoomEvents' otherwise the crypto handler
	            // for 'event' fires *after* 'RoomEvent', and our room won't have yet been
	            // marked as encrypted.
	            // XXX: fragile as all hell - fixme somehow, perhaps with a dedicated Room.encryption event or something.
	            MatrixClientPeg.get().on("event", this.onEvent);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (MatrixClientPeg.get()) {
	                MatrixClientPeg.get().removeListener("event", this.onEvent);
	            }
	        }
	    }, {
	        key: 'onEvent',
	        value: function onEvent(event) {
	            if (event.getType() !== 'm.room.encryption') return;
	            if (event.getRoomId() !== this.props.room.roomId) return;
	            this.forceUpdate();
	        }
	    }, {
	        key: 'onUploadClick',
	        value: function onUploadClick(ev) {
	            if (MatrixClientPeg.get().isGuest()) {
	                var NeedToRegisterDialog = sdk.getComponent("dialogs.NeedToRegisterDialog");
	                Modal.createDialog(NeedToRegisterDialog, {
	                    title: "Please Register",
	                    description: "Guest users can't upload files. Please register to upload."
	                });
	                return;
	            }
	
	            this.refs.uploadInput.click();
	        }
	    }, {
	        key: 'onUploadFileSelected',
	        value: function onUploadFileSelected(files, isPasted) {
	            var _this2 = this;
	
	            if (!isPasted) files = files.target.files;
	
	            var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	            var TintableSvg = sdk.getComponent("elements.TintableSvg");
	
	            var fileList = [];
	            for (var i = 0; i < files.length; i++) {
	                fileList.push(React.createElement(
	                    'li',
	                    { key: i },
	                    React.createElement(TintableSvg, { key: i, src: 'img/files.svg', width: '16', height: '16' }),
	                    ' ',
	                    files[i].name || 'Attachment'
	                ));
	            }
	
	            Modal.createDialog(QuestionDialog, {
	                title: "Upload Files",
	                description: React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'p',
	                        null,
	                        'Are you sure you want upload the following files?'
	                    ),
	                    React.createElement(
	                        'ul',
	                        { style: { listStyle: 'none', textAlign: 'left' } },
	                        fileList
	                    )
	                ),
	                onFinished: function onFinished(shouldUpload) {
	                    if (shouldUpload) {
	                        // MessageComposer shouldn't have to rely on its parent passing in a callback to upload a file
	                        if (files) {
	                            for (var i = 0; i < files.length; i++) {
	                                _this2.props.uploadFile(files[i]);
	                            }
	                        }
	                    }
	
	                    _this2.refs.uploadInput.value = null;
	                }
	            });
	        }
	    }, {
	        key: 'onHangupClick',
	        value: function onHangupClick() {
	            var call = CallHandler.getCallForRoom(this.props.room.roomId);
	            //var call = CallHandler.getAnyActiveCall();
	            if (!call) {
	                return;
	            }
	            dis.dispatch({
	                action: 'hangup',
	                // hangup the call for this room, which may not be the room in props
	                // (e.g. conferences which will hangup the 1:1 room instead)
	                room_id: call.roomId
	            });
	        }
	    }, {
	        key: 'onCallClick',
	        value: function onCallClick(ev) {
	            dis.dispatch({
	                action: 'place_call',
	                type: ev.shiftKey ? "screensharing" : "video",
	                room_id: this.props.room.roomId
	            });
	        }
	    }, {
	        key: 'onVoiceCallClick',
	        value: function onVoiceCallClick(ev) {
	            dis.dispatch({
	                action: 'place_call',
	                type: 'voice',
	                room_id: this.props.room.roomId
	            });
	        }
	    }, {
	        key: 'onInputContentChanged',
	        value: function onInputContentChanged(content, selection) {
	            this.setState({
	                autocompleteQuery: content,
	                selection: selection
	            });
	        }
	    }, {
	        key: 'onInputStateChanged',
	        value: function onInputStateChanged(inputState) {
	            this.setState({ inputState: inputState });
	        }
	    }, {
	        key: 'onUpArrow',
	        value: function onUpArrow() {
	            return this.refs.autocomplete.onUpArrow();
	        }
	    }, {
	        key: 'onDownArrow',
	        value: function onDownArrow() {
	            return this.refs.autocomplete.onDownArrow();
	        }
	    }, {
	        key: '_tryComplete',
	        value: function _tryComplete() {
	            if (this.refs.autocomplete) {
	                return this.refs.autocomplete.onCompletionClicked();
	            }
	            return false;
	        }
	    }, {
	        key: '_onAutocompleteConfirm',
	        value: function _onAutocompleteConfirm(range, completion) {
	            if (this.messageComposerInput) {
	                this.messageComposerInput.setDisplayedCompletion(range, completion);
	            }
	        }
	    }, {
	        key: 'onFormatButtonClicked',
	        value: function onFormatButtonClicked(name, event) {
	            event.preventDefault();
	            this.messageComposerInput.onFormatButtonClicked(name, event);
	        }
	    }, {
	        key: 'onToggleFormattingClicked',
	        value: function onToggleFormattingClicked() {
	            _UserSettingsStore2.default.setSyncedSetting('MessageComposer.showFormatting', !this.state.showFormatting);
	            this.setState({ showFormatting: !this.state.showFormatting });
	        }
	    }, {
	        key: 'onToggleMarkdownClicked',
	        value: function onToggleMarkdownClicked(e) {
	            e.preventDefault(); // don't steal focus from the editor!
	            this.messageComposerInput.enableRichtext(!this.state.inputState.isRichtextEnabled);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var me = this.props.room.getMember(MatrixClientPeg.get().credentials.userId);
	            var uploadInputStyle = { display: 'none' };
	            var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');
	            var TintableSvg = sdk.getComponent("elements.TintableSvg");
	            var MessageComposerInput = sdk.getComponent("rooms.MessageComposerInput" + (_UserSettingsStore2.default.isFeatureEnabled('rich_text_editor') ? "" : "Old"));
	
	            var controls = [];
	
	            controls.push(React.createElement(
	                'div',
	                { key: 'controls_avatar', className: 'mx_MessageComposer_avatar' },
	                React.createElement(MemberAvatar, { member: me, width: 24, height: 24 })
	            ));
	
	            var e2eImg = void 0,
	                e2eTitle = void 0,
	                e2eClass = void 0;
	            var roomIsEncrypted = MatrixClientPeg.get().isRoomEncrypted(this.props.room.roomId);
	            if (roomIsEncrypted) {
	                // FIXME: show a /!\ if there are untrusted devices in the room...
	                e2eImg = 'img/e2e-verified.svg';
	                e2eTitle = 'Encrypted room';
	                e2eClass = 'mx_MessageComposer_e2eIcon';
	            } else {
	                e2eImg = 'img/e2e-unencrypted.svg';
	                e2eTitle = 'Unencrypted room';
	                e2eClass = 'mx_MessageComposer_e2eIcon mx_filterFlipColor';
	            }
	
	            controls.push(React.createElement('img', { key: 'e2eIcon', className: e2eClass, src: e2eImg, width: '12', height: '12',
	                alt: e2eTitle, title: e2eTitle
	            }));
	            var callButton, videoCallButton, hangupButton;
	            if (this.props.callState && this.props.callState !== 'ended') {
	                hangupButton = React.createElement(
	                    'div',
	                    { key: 'controls_hangup', className: 'mx_MessageComposer_hangup', onClick: this.onHangupClick },
	                    React.createElement('img', { src: 'img/hangup.svg', alt: 'Hangup', title: 'Hangup', width: '25', height: '26' })
	                );
	            } else {
	                callButton = React.createElement(
	                    'div',
	                    { key: 'controls_call', className: 'mx_MessageComposer_voicecall', onClick: this.onVoiceCallClick, title: 'Voice call' },
	                    React.createElement(TintableSvg, { src: 'img/icon-call.svg', width: '35', height: '35' })
	                );
	                videoCallButton = React.createElement(
	                    'div',
	                    { key: 'controls_videocall', className: 'mx_MessageComposer_videocall', onClick: this.onCallClick, title: 'Video call' },
	                    React.createElement(TintableSvg, { src: 'img/icons-video.svg', width: '35', height: '35' })
	                );
	            }
	
	            var canSendMessages = this.props.room.currentState.maySendMessage(MatrixClientPeg.get().credentials.userId);
	
	            if (canSendMessages) {
	                // This also currently includes the call buttons. Really we should
	                // check separately for whether we can call, but this is slightly
	                // complex because of conference calls.
	                var uploadButton = React.createElement(
	                    'div',
	                    { key: 'controls_upload', className: 'mx_MessageComposer_upload',
	                        onClick: this.onUploadClick, title: 'Upload file' },
	                    React.createElement(TintableSvg, { src: 'img/icons-upload.svg', width: '35', height: '35' }),
	                    React.createElement('input', { ref: 'uploadInput', type: 'file',
	                        style: uploadInputStyle,
	                        multiple: true,
	                        onChange: this.onUploadFileSelected })
	                );
	
	                var formattingButton = React.createElement('img', { className: 'mx_MessageComposer_formatting',
	                    title: 'Show Text Formatting Toolbar',
	                    src: 'img/button-text-formatting.svg',
	                    onClick: this.onToggleFormattingClicked,
	                    style: { visibility: this.state.showFormatting || !_UserSettingsStore2.default.isFeatureEnabled('rich_text_editor') ? 'hidden' : 'visible' },
	                    key: 'controls_formatting' });
	
	                var placeholderText = roomIsEncrypted ? "Send an encrypted message…" : "Send a message (unencrypted)…";
	
	                controls.push(React.createElement(MessageComposerInput, {
	                    ref: function ref(c) {
	                        return _this3.messageComposerInput = c;
	                    },
	                    key: 'controls_input',
	                    onResize: this.props.onResize,
	                    room: this.props.room,
	                    placeholder: placeholderText,
	                    tryComplete: this._tryComplete,
	                    onUpArrow: this.onUpArrow,
	                    onDownArrow: this.onDownArrow,
	                    onUploadFileSelected: this.onUploadFileSelected,
	                    tabComplete: this.props.tabComplete // used for old messagecomposerinput/tabcomplete
	                    , onContentChanged: this.onInputContentChanged,
	                    onInputStateChanged: this.onInputStateChanged }), formattingButton, uploadButton, hangupButton, callButton, videoCallButton);
	            } else {
	                controls.push(React.createElement(
	                    'div',
	                    { key: 'controls_error', className: 'mx_MessageComposer_noperm_error' },
	                    'You do not have permission to post to this room'
	                ));
	            }
	
	            var autoComplete = void 0;
	            if (_UserSettingsStore2.default.isFeatureEnabled('rich_text_editor')) {
	                autoComplete = React.createElement(
	                    'div',
	                    { className: 'mx_MessageComposer_autocomplete_wrapper' },
	                    React.createElement(_Autocomplete2.default, {
	                        ref: 'autocomplete',
	                        onConfirm: this._onAutocompleteConfirm,
	                        query: this.state.autocompleteQuery,
	                        selection: this.state.selection })
	                );
	            }
	
	            var _state$inputState = this.state.inputState,
	                style = _state$inputState.style,
	                blockType = _state$inputState.blockType;
	
	            var formatButtons = ["bold", "italic", "strike", "underline", "code", "quote", "bullet", "numbullet"].map(function (name) {
	                var active = style.includes(name) || blockType === name;
	                var suffix = active ? '-o-n' : '';
	                var onFormatButtonClicked = _this3.onFormatButtonClicked.bind(_this3, name);
	                var disabled = !_this3.state.inputState.isRichtextEnabled && 'underline' === name;
	                var className = (0, _classnames2.default)("mx_MessageComposer_format_button", {
	                    mx_MessageComposer_format_button_disabled: disabled,
	                    mx_filterFlipColor: true
	                });
	                return React.createElement('img', { className: className,
	                    title: name,
	                    onMouseDown: disabled ? null : onFormatButtonClicked,
	                    key: name,
	                    src: 'img/button-text-' + name + suffix + '.svg',
	                    height: '17' });
	            });
	
	            return React.createElement(
	                'div',
	                { className: 'mx_MessageComposer mx_fadable', style: { opacity: this.props.opacity } },
	                React.createElement(
	                    'div',
	                    { className: 'mx_MessageComposer_wrapper' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_MessageComposer_row' },
	                        controls
	                    )
	                ),
	                _UserSettingsStore2.default.isFeatureEnabled('rich_text_editor') ? React.createElement(
	                    'div',
	                    { className: 'mx_MessageComposer_formatbar_wrapper' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_MessageComposer_formatbar', style: this.state.showFormatting ? {} : { display: 'none' } },
	                        formatButtons,
	                        React.createElement('div', { style: { flex: 1 } }),
	                        React.createElement('img', { title: 'Turn Markdown ' + (this.state.inputState.isRichtextEnabled ? 'on' : 'off'),
	                            onMouseDown: this.onToggleMarkdownClicked,
	                            className: 'mx_MessageComposer_formatbar_markdown mx_filterFlipColor',
	                            src: 'img/button-md-' + !this.state.inputState.isRichtextEnabled + '.png' }),
	                        React.createElement('img', { title: 'Hide Text Formatting Toolbar',
	                            onClick: this.onToggleFormattingClicked,
	                            className: 'mx_MessageComposer_formatbar_cancel mx_filterFlipColor',
	                            src: 'img/icon-text-cancel.svg' })
	                    )
	                ) : null
	            );
	        }
	    }]);
	    return MessageComposer;
	}(React.Component);
	
	exports.default = MessageComposer;
	
	
	MessageComposer.propTypes = {
	    tabComplete: React.PropTypes.any,
	
	    // a callback which is called when the height of the composer is
	    // changed due to a change in content.
	    onResize: React.PropTypes.func,
	
	    // js-sdk Room object
	    room: React.PropTypes.object.isRequired,
	
	    // string representing the current voip call state
	    callState: React.PropTypes.string,
	
	    // callback when a file to upload is chosen
	    uploadFile: React.PropTypes.func.isRequired,
	
	    // opacity for dynamic UI fading effects
	    opacity: React.PropTypes.number
	};
	module.exports = exports['default'];


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(59);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(58);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _draftJs = __webpack_require__(161);
	
	var _draftJsExportMarkdown = __webpack_require__(921);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _escape = __webpack_require__(315);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _SlashCommands = __webpack_require__(329);
	
	var _SlashCommands2 = _interopRequireDefault(_SlashCommands);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _KeyCode = __webpack_require__(116);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _UserSettingsStore = __webpack_require__(74);
	
	var _UserSettingsStore2 = _interopRequireDefault(_UserSettingsStore);
	
	var _RichText = __webpack_require__(1159);
	
	var RichText = _interopRequireWildcard(_RichText);
	
	var _HtmlUtils = __webpack_require__(219);
	
	var HtmlUtils = _interopRequireWildcard(_HtmlUtils);
	
	var _Autocomplete = __webpack_require__(336);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _Autocompleter = __webpack_require__(333);
	
	var _Markdown = __webpack_require__(500);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _MessageComposerInputOld = __webpack_require__(515);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPING_USER_TIMEOUT = 10000,
	    TYPING_SERVER_TIMEOUT = 30000; /*
	                                   Copyright 2015, 2016 OpenMarket Ltd
	                                   
	                                   Licensed under the Apache License, Version 2.0 (the "License");
	                                   you may not use this file except in compliance with the License.
	                                   You may obtain a copy of the License at
	                                   
	                                       http://www.apache.org/licenses/LICENSE-2.0
	                                   
	                                   Unless required by applicable law or agreed to in writing, software
	                                   distributed under the License is distributed on an "AS IS" BASIS,
	                                   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                   See the License for the specific language governing permissions and
	                                   limitations under the License.
	                                   */
	
	
	var KEY_M = 77;
	
	var ZWS_CODE = 8203;
	var ZWS = String.fromCharCode(ZWS_CODE); // zero width space
	function stateToMarkdown(state) {
	    return (0, _draftJsExportMarkdown.stateToMarkdown)(state).replace(ZWS, // draft-js-export-markdown adds these
	    ''); // this is *not* a zero width space, trust me :)
	}
	
	/*
	 * The textInput part of the MessageComposer
	 */
	
	var MessageComposerInput = function (_React$Component) {
	    (0, _inherits3.default)(MessageComposerInput, _React$Component);
	    (0, _createClass3.default)(MessageComposerInput, null, [{
	        key: 'getKeyBinding',
	        value: function getKeyBinding(e) {
	            // C-m => Toggles between rich text and markdown modes
	            if (e.keyCode === KEY_M && _draftJs.KeyBindingUtil.isCtrlKeyCommand(e)) {
	                return 'toggle-mode';
	            }
	
	            return (0, _draftJs.getDefaultKeyBinding)(e);
	        }
	    }, {
	        key: 'getBlockStyle',
	        value: function getBlockStyle(block) {
	            if (block.getType() === 'strikethrough') {
	                return 'mx_Markdown_STRIKETHROUGH';
	            }
	
	            return null;
	        }
	    }]);
	
	    function MessageComposerInput(props, context) {
	        (0, _classCallCheck3.default)(this, MessageComposerInput);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageComposerInput.__proto__ || (0, _getPrototypeOf2.default)(MessageComposerInput)).call(this, props, context));
	
	        _this.onAction = _this.onAction.bind(_this);
	        _this.handleReturn = _this.handleReturn.bind(_this);
	        _this.handleKeyCommand = _this.handleKeyCommand.bind(_this);
	        _this.handlePastedFiles = _this.handlePastedFiles.bind(_this);
	        _this.onEditorContentChanged = _this.onEditorContentChanged.bind(_this);
	        _this.setEditorState = _this.setEditorState.bind(_this);
	        _this.onUpArrow = _this.onUpArrow.bind(_this);
	        _this.onDownArrow = _this.onDownArrow.bind(_this);
	        _this.onTab = _this.onTab.bind(_this);
	        _this.onEscape = _this.onEscape.bind(_this);
	        _this.setDisplayedCompletion = _this.setDisplayedCompletion.bind(_this);
	        _this.onMarkdownToggleClicked = _this.onMarkdownToggleClicked.bind(_this);
	
	        var isRichtextEnabled = _UserSettingsStore2.default.getSyncedSetting('MessageComposerInput.isRichTextEnabled', true);
	
	        _this.state = {
	            // whether we're in rich text or markdown mode
	            isRichtextEnabled: isRichtextEnabled,
	
	            // the currently displayed editor state (note: this is always what is modified on input)
	            editorState: null,
	
	            // the original editor state, before we started tabbing through completions
	            originalEditorState: null
	        };
	
	        // bit of a hack, but we need to do this here since createEditorState needs isRichtextEnabled
	        /* eslint react/no-direct-mutation-state:0 */
	        _this.state.editorState = _this.createEditorState();
	
	        _this.client = _MatrixClientPeg2.default.get();
	        return _this;
	    }
	
	    /*
	     * "Does the right thing" to create an EditorState, based on:
	     * - whether we've got rich text mode enabled
	     * - contentState was passed in
	     */
	
	
	    (0, _createClass3.default)(MessageComposerInput, [{
	        key: 'createEditorState',
	        value: function createEditorState(richText, contentState) {
	            var decorators = richText ? RichText.getScopedRTDecorators(this.props) : RichText.getScopedMDDecorators(this.props),
	                compositeDecorator = new _draftJs.CompositeDecorator(decorators);
	
	            var editorState = null;
	            if (contentState) {
	                editorState = _draftJs.EditorState.createWithContent(contentState, compositeDecorator);
	            } else {
	                editorState = _draftJs.EditorState.createEmpty(compositeDecorator);
	            }
	
	            return _draftJs.EditorState.moveFocusToEnd(editorState);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var component = this;
	            this.sentHistory = {
	                // The list of typed messages. Index 0 is more recent
	                data: [],
	                // The position in data currently displayed
	                position: -1,
	                // The room the history is for.
	                roomId: null,
	                // The original text before they hit UP
	                originalText: null,
	                // The textarea element to set text to.
	                element: null,
	
	                init: function init(element, roomId) {
	                    this.roomId = roomId;
	                    this.element = element;
	                    this.position = -1;
	                    var storedData = window.sessionStorage.getItem("mx_messagecomposer_history_" + roomId);
	                    if (storedData) {
	                        this.data = JSON.parse(storedData);
	                    }
	                    if (this.roomId) {
	                        this.setLastTextEntry();
	                    }
	                },
	
	                push: function push(text) {
	                    // store a message in the sent history
	                    this.data.unshift(text);
	                    window.sessionStorage.setItem("mx_messagecomposer_history_" + this.roomId, (0, _stringify2.default)(this.data));
	                    // reset history position
	                    this.position = -1;
	                    this.originalText = null;
	                },
	
	                // move in the history. Returns true if we managed to move.
	                next: function next(offset) {
	                    if (this.position === -1) {
	                        // user is going into the history, save the current line.
	                        this.originalText = this.element.value;
	                    } else {
	                        // user may have modified this line in the history; remember it.
	                        this.data[this.position] = this.element.value;
	                    }
	
	                    if (offset > 0 && this.position === this.data.length - 1) {
	                        // we've run out of history
	                        return false;
	                    }
	
	                    // retrieve the next item (bounded).
	                    var newPosition = this.position + offset;
	                    newPosition = Math.max(-1, newPosition);
	                    newPosition = Math.min(newPosition, this.data.length - 1);
	                    this.position = newPosition;
	
	                    if (this.position !== -1) {
	                        // show the message
	                        this.element.value = this.data[this.position];
	                    } else if (this.originalText !== undefined) {
	                        // restore the original text the user was typing.
	                        this.element.value = this.originalText;
	                    }
	
	                    return true;
	                },
	
	                saveLastTextEntry: function saveLastTextEntry() {
	                    // save the currently entered text in order to restore it later.
	                    // NB: This isn't 'originalText' because we want to restore
	                    // sent history items too!
	                    var contentJSON = (0, _stringify2.default)((0, _draftJs.convertToRaw)(component.state.editorState.getCurrentContent()));
	                    window.sessionStorage.setItem("mx_messagecomposer_input_" + this.roomId, contentJSON);
	                },
	
	                setLastTextEntry: function setLastTextEntry() {
	                    var contentJSON = window.sessionStorage.getItem("mx_messagecomposer_input_" + this.roomId);
	                    if (contentJSON) {
	                        var content = (0, _draftJs.convertFromRaw)(JSON.parse(contentJSON));
	                        component.setEditorState(component.createEditorState(component.state.isRichtextEnabled, content));
	                    }
	                }
	            };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.dispatcherRef = _dispatcher2.default.register(this.onAction);
	            this.sentHistory.init(this.refs.editor, this.props.room.roomId);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            _dispatcher2.default.unregister(this.dispatcherRef);
	            this.sentHistory.saveLastTextEntry();
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            // this is dirty, but moving all this state to MessageComposer is dirtier
	            if (this.props.onInputStateChanged && nextState !== this.state) {
	                var state = this.getSelectionInfo(nextState.editorState);
	                state.isRichtextEnabled = nextState.isRichtextEnabled;
	                this.props.onInputStateChanged(state);
	            }
	        }
	    }, {
	        key: 'onAction',
	        value: function onAction(payload) {
	            var editor = this.refs.editor;
	            var contentState = this.state.editorState.getCurrentContent();
	
	            switch (payload.action) {
	                case 'focus_composer':
	                    editor.focus();
	                    break;
	
	                // TODO change this so we insert a complete user alias
	
	                case 'insert_displayname':
	                    {
	                        contentState = _draftJs.Modifier.replaceText(contentState, this.state.editorState.getSelection(), payload.displayname + ': ');
	                        var editorState = _draftJs.EditorState.push(this.state.editorState, contentState, 'insert-characters');
	                        editorState = _draftJs.EditorState.forceSelection(editorState, contentState.getSelectionAfter());
	                        this.onEditorContentChanged(editorState);
	                        editor.focus();
	                    }
	                    break;
	
	                case 'quote':
	                    {
	                        var _payload$event$getCon = payload.event.getContent(),
	                            body = _payload$event$getCon.body,
	                            formatted_body = _payload$event$getCon.formatted_body;
	
	                        formatted_body = formatted_body || (0, _escape2.default)(body);
	                        if (formatted_body) {
	                            var content = RichText.HTMLtoContentState('<blockquote>' + formatted_body + '</blockquote>');
	                            if (!this.state.isRichtextEnabled) {
	                                content = _draftJs.ContentState.createFromText(stateToMarkdown(content));
	                            }
	
	                            var blockMap = content.getBlockMap();
	                            var startSelection = _draftJs.SelectionState.createEmpty(contentState.getFirstBlock().getKey());
	                            contentState = _draftJs.Modifier.splitBlock(contentState, startSelection);
	                            startSelection = _draftJs.SelectionState.createEmpty(contentState.getFirstBlock().getKey());
	                            contentState = _draftJs.Modifier.replaceWithFragment(contentState, startSelection, blockMap);
	                            startSelection = _draftJs.SelectionState.createEmpty(contentState.getFirstBlock().getKey());
	                            if (this.state.isRichtextEnabled) {
	                                contentState = _draftJs.Modifier.setBlockType(contentState, startSelection, 'blockquote');
	                            }
	                            var _editorState = _draftJs.EditorState.push(this.state.editorState, contentState, 'insert-characters');
	                            this.onEditorContentChanged(_editorState);
	                            editor.focus();
	                        }
	                    }
	                    break;
	            }
	        }
	    }, {
	        key: 'onTypingActivity',
	        value: function onTypingActivity() {
	            this.isTyping = true;
	            if (!this.userTypingTimer) {
	                this.sendTyping(true);
	            }
	            this.startUserTypingTimer();
	            this.startServerTypingTimer();
	        }
	    }, {
	        key: 'onFinishedTyping',
	        value: function onFinishedTyping() {
	            this.isTyping = false;
	            this.sendTyping(false);
	            this.stopUserTypingTimer();
	            this.stopServerTypingTimer();
	        }
	    }, {
	        key: 'startUserTypingTimer',
	        value: function startUserTypingTimer() {
	            this.stopUserTypingTimer();
	            var self = this;
	            this.userTypingTimer = setTimeout(function () {
	                self.isTyping = false;
	                self.sendTyping(self.isTyping);
	                self.userTypingTimer = null;
	            }, TYPING_USER_TIMEOUT);
	        }
	    }, {
	        key: 'stopUserTypingTimer',
	        value: function stopUserTypingTimer() {
	            if (this.userTypingTimer) {
	                clearTimeout(this.userTypingTimer);
	                this.userTypingTimer = null;
	            }
	        }
	    }, {
	        key: 'startServerTypingTimer',
	        value: function startServerTypingTimer() {
	            if (!this.serverTypingTimer) {
	                var self = this;
	                this.serverTypingTimer = setTimeout(function () {
	                    if (self.isTyping) {
	                        self.sendTyping(self.isTyping);
	                        self.startServerTypingTimer();
	                    }
	                }, TYPING_SERVER_TIMEOUT / 2);
	            }
	        }
	    }, {
	        key: 'stopServerTypingTimer',
	        value: function stopServerTypingTimer() {
	            if (this.serverTypingTimer) {
	                clearTimeout(this.servrTypingTimer);
	                this.serverTypingTimer = null;
	            }
	        }
	    }, {
	        key: 'sendTyping',
	        value: function sendTyping(isTyping) {
	            _MatrixClientPeg2.default.get().sendTyping(this.props.room.roomId, this.isTyping, TYPING_SERVER_TIMEOUT).done();
	        }
	    }, {
	        key: 'refreshTyping',
	        value: function refreshTyping() {
	            if (this.typingTimeout) {
	                clearTimeout(this.typingTimeout);
	                this.typingTimeout = null;
	            }
	        }
	
	        // Called by Draft to change editor contents, and by setEditorState
	
	    }, {
	        key: 'onEditorContentChanged',
	        value: function onEditorContentChanged(editorState) {
	            var didRespondToUserInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            editorState = RichText.attachImmutableEntitiesToEmoji(editorState);
	
	            var contentChanged = _q2.default.defer();
	            /* If a modification was made, set originalEditorState to null, since newState is now our original */
	            this.setState({
	                editorState: editorState,
	                originalEditorState: didRespondToUserInput ? null : this.state.originalEditorState
	            }, function () {
	                return contentChanged.resolve();
	            });
	
	            if (editorState.getCurrentContent().hasText()) {
	                this.onTypingActivity();
	            } else {
	                this.onFinishedTyping();
	            }
	
	            if (this.props.onContentChanged) {
	                var textContent = editorState.getCurrentContent().getPlainText();
	                var selection = RichText.selectionStateToTextOffsets(editorState.getSelection(), editorState.getCurrentContent().getBlocksAsArray());
	
	                this.props.onContentChanged(textContent, selection);
	            }
	            return contentChanged.promise;
	        }
	    }, {
	        key: 'setEditorState',
	        value: function setEditorState(editorState) {
	            return this.onEditorContentChanged(editorState, false);
	        }
	    }, {
	        key: 'enableRichtext',
	        value: function enableRichtext(enabled) {
	            var _this2 = this;
	
	            var contentState = null;
	            if (enabled) {
	                var md = new _Markdown2.default(this.state.editorState.getCurrentContent().getPlainText());
	                contentState = RichText.HTMLtoContentState(md.toHTML());
	            } else {
	                var markdown = stateToMarkdown(this.state.editorState.getCurrentContent());
	                if (markdown[markdown.length - 1] === '\n') {
	                    markdown = markdown.substring(0, markdown.length - 1); // stateToMarkdown tacks on an extra newline (?!?)
	                }
	                contentState = _draftJs.ContentState.createFromText(markdown);
	            }
	
	            this.setEditorState(this.createEditorState(enabled, contentState)).then(function () {
	                _this2.setState({
	                    isRichtextEnabled: enabled
	                });
	
	                _UserSettingsStore2.default.setSyncedSetting('MessageComposerInput.isRichTextEnabled', enabled);
	            });
	        }
	    }, {
	        key: 'handleKeyCommand',
	        value: function handleKeyCommand(command) {
	            if (command === 'toggle-mode') {
	                this.enableRichtext(!this.state.isRichtextEnabled);
	                return true;
	            }
	
	            var newState = null;
	
	            // Draft handles rich text mode commands by default but we need to do it ourselves for Markdown.
	            if (this.state.isRichtextEnabled) {
	                // These are block types, not handled by RichUtils by default.
	                var blockCommands = ['code-block', 'blockquote', 'unordered-list-item', 'ordered-list-item'];
	
	                if (blockCommands.includes(command)) {
	                    this.setEditorState(_draftJs.RichUtils.toggleBlockType(this.state.editorState, command));
	                } else if (command === 'strike') {
	                    // this is the only inline style not handled by Draft by default
	                    this.setEditorState(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, 'STRIKETHROUGH'));
	                }
	            } else {
	                var contentState = this.state.editorState.getCurrentContent(),
	                    selection = this.state.editorState.getSelection();
	
	                var modifyFn = {
	                    'bold': function bold(text) {
	                        return '**' + text + '**';
	                    },
	                    'italic': function italic(text) {
	                        return '*' + text + '*';
	                    },
	                    'underline': function underline(text) {
	                        return '_' + text + '_';
	                    }, // there's actually no valid underline in Markdown, but *shrug*
	                    'strike': function strike(text) {
	                        return '~~' + text + '~~';
	                    },
	                    'code': function code(text) {
	                        return '`' + text + '`';
	                    },
	                    'blockquote': function blockquote(text) {
	                        return text.split('\n').map(function (line) {
	                            return '> ' + line + '\n';
	                        }).join('');
	                    },
	                    'unordered-list-item': function unorderedListItem(text) {
	                        return text.split('\n').map(function (line) {
	                            return '- ' + line + '\n';
	                        }).join('');
	                    },
	                    'ordered-list-item': function orderedListItem(text) {
	                        return text.split('\n').map(function (line, i) {
	                            return i + 1 + '. ' + line + '\n';
	                        }).join('');
	                    }
	                }[command];
	
	                if (modifyFn) {
	                    newState = _draftJs.EditorState.push(this.state.editorState, RichText.modifyText(contentState, selection, modifyFn), 'insert-characters');
	                }
	            }
	
	            if (newState == null) {
	                newState = _draftJs.RichUtils.handleKeyCommand(this.state.editorState, command);
	            }
	
	            if (newState != null) {
	                this.setEditorState(newState);
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'handlePastedFiles',
	        value: function handlePastedFiles(files) {
	            this.props.onUploadFileSelected(files, true);
	        }
	    }, {
	        key: 'handleReturn',
	        value: function handleReturn(ev) {
	            var _this3 = this;
	
	            if (ev.shiftKey) {
	                this.onEditorContentChanged(_draftJs.RichUtils.insertSoftNewline(this.state.editorState));
	                return true;
	            }
	
	            var contentState = this.state.editorState.getCurrentContent();
	            if (!contentState.hasText()) {
	                return true;
	            }
	
	            var contentText = contentState.getPlainText(),
	                contentHTML = void 0;
	
	            var cmd = _SlashCommands2.default.processInput(this.props.room.roomId, contentText);
	            if (cmd) {
	                if (!cmd.error) {
	                    this.setState({
	                        editorState: this.createEditorState()
	                    });
	                }
	                if (cmd.promise) {
	                    cmd.promise.then(function () {
	                        console.log("Command success.");
	                    }, function (err) {
	                        console.error("Command failure: %s", err);
	                        var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                        _Modal2.default.createDialog(ErrorDialog, {
	                            title: "Server error",
	                            description: "Server unavailable, overloaded, or something else went wrong."
	                        });
	                    });
	                } else if (cmd.error) {
	                    console.error(cmd.error);
	                    var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                    _Modal2.default.createDialog(ErrorDialog, {
	                        title: "Command error",
	                        description: cmd.error
	                    });
	                }
	                return true;
	            }
	
	            if (this.state.isRichtextEnabled) {
	                contentHTML = HtmlUtils.stripParagraphs(RichText.contentStateToHTML(contentState));
	            } else {
	                var md = new _Markdown2.default(contentText);
	                if (md.isPlainText()) {
	                    contentText = md.toPlaintext();
	                } else {
	                    contentHTML = md.toHTML();
	                }
	            }
	
	            var sendHtmlFn = this.client.sendHtmlMessage;
	            var sendTextFn = this.client.sendTextMessage;
	
	            if (contentText.startsWith('/me')) {
	                contentText = contentText.replace('/me ', '');
	                // bit of a hack, but the alternative would be quite complicated
	                if (contentHTML) contentHTML = contentHTML.replace('/me ', '');
	                sendHtmlFn = this.client.sendHtmlEmote;
	                sendTextFn = this.client.sendEmoteMessage;
	            }
	
	            // XXX: We don't actually seem to use this history?
	            this.sentHistory.push(contentHTML || contentText);
	            var sendMessagePromise = void 0;
	            if (contentHTML) {
	                sendMessagePromise = sendHtmlFn.call(this.client, this.props.room.roomId, contentText, contentHTML);
	            } else {
	                sendMessagePromise = sendTextFn.call(this.client, this.props.room.roomId, contentText);
	            }
	
	            sendMessagePromise.done(function (res) {
	                _dispatcher2.default.dispatch({
	                    action: 'message_sent'
	                });
	            }, function (e) {
	                return (0, _MessageComposerInputOld.onSendMessageFailed)(e, _this3.props.room);
	            });
	
	            this.setState({
	                editorState: this.createEditorState()
	            });
	
	            this.autocomplete.hide();
	
	            return true;
	        }
	    }, {
	        key: 'onUpArrow',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
	                var completion;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                completion = this.autocomplete.onUpArrow();
	
	                                if (completion != null) {
	                                    e.preventDefault();
	                                }
	                                _context.next = 4;
	                                return this.setDisplayedCompletion(completion);
	
	                            case 4:
	                                return _context.abrupt('return', _context.sent);
	
	                            case 5:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function onUpArrow(_x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return onUpArrow;
	        }()
	    }, {
	        key: 'onDownArrow',
	        value: function () {
	            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
	                var completion;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                completion = this.autocomplete.onDownArrow();
	
	                                e.preventDefault();
	                                _context2.next = 4;
	                                return this.setDisplayedCompletion(completion);
	
	                            case 4:
	                                return _context2.abrupt('return', _context2.sent);
	
	                            case 5:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onDownArrow(_x3) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return onDownArrow;
	        }()
	
	        // tab and shift-tab are mapped to down and up arrow respectively
	
	    }, {
	        key: 'onTab',
	        value: function () {
	            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(e) {
	                var _this4 = this;
	
	                var didTab;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                e.preventDefault(); // we *never* want tab's default to happen, but we do want up/down sometimes
	                                _context3.next = 3;
	                                return (e.shiftKey ? this.onUpArrow : this.onDownArrow)(e);
	
	                            case 3:
	                                didTab = _context3.sent;
	
	                                if (!didTab && this.autocomplete) {
	                                    this.autocomplete.forceComplete().then(function () {
	                                        _this4.onDownArrow(e);
	                                    });
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function onTab(_x4) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return onTab;
	        }()
	    }, {
	        key: 'onEscape',
	        value: function onEscape(e) {
	            e.preventDefault();
	            if (this.autocomplete) {
	                this.autocomplete.onEscape(e);
	            }
	            this.setDisplayedCompletion(null); // restore originalEditorState
	        }
	
	        /* If passed null, restores the original editor content from state.originalEditorState.
	         * If passed a non-null displayedCompletion, modifies state.originalEditorState to compute new state.editorState.
	         */
	
	    }, {
	        key: 'setDisplayedCompletion',
	        value: function () {
	            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(displayedCompletion) {
	                var _this5 = this;
	
	                var activeEditorState, _displayedCompletion$, range, _displayedCompletion$2, completion, contentState, editorState, originalEditorState;
	
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                activeEditorState = this.state.originalEditorState || this.state.editorState;
	
	                                if (!(displayedCompletion == null)) {
	                                    _context4.next = 4;
	                                    break;
	                                }
	
	                                if (this.state.originalEditorState) {
	                                    this.setEditorState(this.state.originalEditorState);
	                                }
	                                return _context4.abrupt('return', false);
	
	                            case 4:
	                                _displayedCompletion$ = displayedCompletion.range, range = _displayedCompletion$ === undefined ? {} : _displayedCompletion$, _displayedCompletion$2 = displayedCompletion.completion, completion = _displayedCompletion$2 === undefined ? '' : _displayedCompletion$2;
	                                contentState = _draftJs.Modifier.replaceText(activeEditorState.getCurrentContent(), RichText.textOffsetsToSelectionState(range, activeEditorState.getCurrentContent().getBlocksAsArray()), completion);
	                                editorState = _draftJs.EditorState.push(activeEditorState, contentState, 'insert-characters');
	
	                                editorState = _draftJs.EditorState.forceSelection(editorState, contentState.getSelectionAfter());
	                                originalEditorState = activeEditorState;
	                                _context4.next = 11;
	                                return this.setEditorState(editorState);
	
	                            case 11:
	                                this.setState({ originalEditorState: originalEditorState });
	
	                                // for some reason, doing this right away does not update the editor :(
	                                setTimeout(function () {
	                                    return _this5.refs.editor.focus();
	                                }, 50);
	                                return _context4.abrupt('return', true);
	
	                            case 14:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function setDisplayedCompletion(_x5) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return setDisplayedCompletion;
	        }()
	    }, {
	        key: 'onFormatButtonClicked',
	        value: function onFormatButtonClicked(name, e) {
	            e.preventDefault(); // don't steal focus from the editor!
	            var command = {
	                code: 'code-block',
	                quote: 'blockquote',
	                bullet: 'unordered-list-item',
	                numbullet: 'ordered-list-item'
	            }[name] || name;
	            this.handleKeyCommand(command);
	        }
	
	        /* returns inline style and block type of current SelectionState so MessageComposer can render formatting
	        buttons. */
	
	    }, {
	        key: 'getSelectionInfo',
	        value: function getSelectionInfo(editorState) {
	            var styleName = {
	                BOLD: 'bold',
	                ITALIC: 'italic',
	                STRIKETHROUGH: 'strike',
	                UNDERLINE: 'underline'
	            };
	
	            var originalStyle = editorState.getCurrentInlineStyle().toArray();
	            var style = originalStyle.map(function (style) {
	                return styleName[style] || null;
	            }).filter(function (styleName) {
	                return !!styleName;
	            });
	
	            var blockName = {
	                'code-block': 'code',
	                'blockquote': 'quote',
	                'unordered-list-item': 'bullet',
	                'ordered-list-item': 'numbullet'
	            };
	            var originalBlockType = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();
	            var blockType = blockName[originalBlockType] || null;
	
	            return {
	                style: style,
	                blockType: blockType
	            };
	        }
	    }, {
	        key: 'onMarkdownToggleClicked',
	        value: function onMarkdownToggleClicked(e) {
	            e.preventDefault(); // don't steal focus from the editor!
	            this.handleKeyCommand('toggle-mode');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var activeEditorState = this.state.originalEditorState || this.state.editorState;
	
	            // From https://github.com/facebook/draft-js/blob/master/examples/rich/rich.html#L92
	            // If the user changes block type before entering any text, we can
	            // either style the placeholder or hide it.
	            var hidePlaceholder = false;
	            var contentState = activeEditorState.getCurrentContent();
	            if (!contentState.hasText()) {
	                if (contentState.getBlockMap().first().getType() !== 'unstyled') {
	                    hidePlaceholder = true;
	                }
	            }
	
	            var className = (0, _classnames2.default)('mx_MessageComposer_input', {
	                mx_MessageComposer_input_empty: hidePlaceholder
	            });
	
	            var content = activeEditorState.getCurrentContent();
	            var contentText = content.getPlainText();
	            var selection = RichText.selectionStateToTextOffsets(activeEditorState.getSelection(), activeEditorState.getCurrentContent().getBlocksAsArray());
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'mx_MessageComposer_input_wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_MessageComposer_autocomplete_wrapper' },
	                    _react2.default.createElement(_Autocomplete2.default, {
	                        ref: function ref(e) {
	                            return _this6.autocomplete = e;
	                        },
	                        onConfirm: this.setDisplayedCompletion,
	                        query: contentText,
	                        selection: selection })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: className },
	                    _react2.default.createElement('img', { className: 'mx_MessageComposer_input_markdownIndicator mx_filterFlipColor',
	                        onMouseDown: this.onMarkdownToggleClicked,
	                        title: 'Markdown is ' + (this.state.isRichtextEnabled ? 'disabled' : 'enabled'),
	                        src: 'img/button-md-' + !this.state.isRichtextEnabled + '.png' }),
	                    _react2.default.createElement(_draftJs.Editor, { ref: 'editor',
	                        placeholder: this.props.placeholder,
	                        editorState: this.state.editorState,
	                        onChange: this.onEditorContentChanged,
	                        blockStyleFn: MessageComposerInput.getBlockStyle,
	                        keyBindingFn: MessageComposerInput.getKeyBinding,
	                        handleKeyCommand: this.handleKeyCommand,
	                        handleReturn: this.handleReturn,
	                        handlePastedFiles: this.handlePastedFiles,
	                        stripPastedStyles: !this.state.isRichtextEnabled,
	                        onTab: this.onTab,
	                        onUpArrow: this.onUpArrow,
	                        onDownArrow: this.onDownArrow,
	                        onEscape: this.onEscape,
	                        spellCheck: true })
	                )
	            );
	        }
	    }]);
	    return MessageComposerInput;
	}(_react2.default.Component);
	
	exports.default = MessageComposerInput;
	
	
	MessageComposerInput.propTypes = {
	    tabComplete: _react2.default.PropTypes.any,
	
	    // a callback which is called when the height of the composer is
	    // changed due to a change in content.
	    onResize: _react2.default.PropTypes.func,
	
	    // js-sdk Room object
	    room: _react2.default.PropTypes.object.isRequired,
	
	    // called with current plaintext content (as a string) whenever it changes
	    onContentChanged: _react2.default.PropTypes.func,
	
	    onUpArrow: _react2.default.PropTypes.func,
	
	    onDownArrow: _react2.default.PropTypes.func,
	
	    onUploadFileSelected: _react2.default.PropTypes.func,
	
	    // attempts to confirm currently selected completion, returns whether actually confirmed
	    tryComplete: _react2.default.PropTypes.func,
	
	    onInputStateChanged: _react2.default.PropTypes.func
	};
	module.exports = exports['default'];


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'PresenceLabel',
	
	    propTypes: {
	        // number of milliseconds ago this user was last active.
	        // zero = unknown
	        activeAgo: React.PropTypes.number,
	
	        // if true, activeAgo is an approximation and "Now" should
	        // be shown instead
	        currentlyActive: React.PropTypes.bool,
	
	        // offline, online, etc
	        presenceState: React.PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            ago: -1,
	            presenceState: null
	        };
	    },
	
	    getDuration: function getDuration(time) {
	        if (!time) return;
	        var t = parseInt(time / 1000);
	        var s = t % 60;
	        var m = parseInt(t / 60) % 60;
	        var h = parseInt(t / (60 * 60)) % 24;
	        var d = parseInt(t / (60 * 60 * 24));
	        if (t < 60) {
	            if (t < 0) {
	                return "0s";
	            }
	            return s + "s";
	        }
	        if (t < 60 * 60) {
	            return m + "m";
	        }
	        if (t < 24 * 60 * 60) {
	            return h + "h";
	        }
	        return d + "d ";
	    },
	
	    getPrettyPresence: function getPrettyPresence(presence) {
	        if (presence === "online") return "Online";
	        if (presence === "unavailable") return "Idle"; // XXX: is this actually right?
	        if (presence === "offline") return "Offline";
	        return "Unknown";
	    },
	
	    render: function render() {
	        if (this.props.activeAgo >= 0) {
	            var ago = this.props.currentlyActive ? "now" : this.getDuration(this.props.activeAgo) + " ago";
	            // var ago = this.getDuration(this.props.activeAgo) + " ago";
	            // if (this.props.currentlyActive) ago += " (now?)";
	            return React.createElement(
	                'div',
	                { className: 'mx_PresenceLabel' },
	                this.getPrettyPresence(this.props.presenceState),
	                ' ',
	                ago
	            );
	        } else {
	            return React.createElement(
	                'div',
	                { className: 'mx_PresenceLabel' },
	                this.getPrettyPresence(this.props.presenceState)
	            );
	        }
	    }
	});


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	
	var sdk = __webpack_require__(2);
	
	var Velociraptor = __webpack_require__(1164);
	__webpack_require__(1165);
	
	var bounce = false;
	try {
	    if (global.localStorage) {
	        bounce = global.localStorage.getItem('avatar_bounce') == 'true';
	    }
	} catch (e) {}
	
	module.exports = React.createClass({
	    displayName: 'ReadReceiptMarker',
	
	    propTypes: {
	        // the RoomMember to show the RR for
	        member: React.PropTypes.object.isRequired,
	
	        // number of pixels to offset the avatar from the right of its parent;
	        // typically a negative value.
	        leftOffset: React.PropTypes.number,
	
	        // true to hide the avatar (it will still be animated)
	        hidden: React.PropTypes.bool,
	
	        // don't animate this RR into position
	        suppressAnimation: React.PropTypes.bool,
	
	        // an opaque object for storing information about this user's RR in
	        // this room
	        readReceiptInfo: React.PropTypes.object,
	
	        // A function which is used to check if the parent panel is being
	        // unmounted, to avoid unnecessary work. Should return true if we
	        // are being unmounted.
	        checkUnmounting: React.PropTypes.func,
	
	        // callback for clicks on this RR
	        onClick: React.PropTypes.func,
	
	        // Timestamp when the receipt was read
	        timestamp: React.PropTypes.number,
	
	        // True to show the full date/time rather than just the time
	        showFullTimestamp: React.PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            leftOffset: 0
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        // if we are going to animate the RR, we don't show it on first render,
	        // and instead just add a placeholder to the DOM; once we've been
	        // mounted, we start an animation which moves the RR from its old
	        // position.
	        return {
	            suppressDisplay: !this.props.suppressAnimation
	        };
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // before we remove the rr, store its location in the map, so that if
	        // it reappears, it can be animated from the right place.
	        var rrInfo = this.props.readReceiptInfo;
	        if (!rrInfo) {
	            return;
	        }
	
	        // checking the DOM properties can force a re-layout, which can be
	        // quite expensive; so if the parent messagepanel is being unmounted,
	        // then don't bother with this.
	        if (this.props.checkUnmounting && this.props.checkUnmounting()) {
	            return;
	        }
	
	        var avatarNode = ReactDOM.findDOMNode(this);
	        rrInfo.top = avatarNode.offsetTop;
	        rrInfo.left = avatarNode.offsetLeft;
	        rrInfo.parent = avatarNode.offsetParent;
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (!this.state.suppressDisplay) {
	            // we've already done our display - nothing more to do.
	            return;
	        }
	
	        // treat new RRs as though they were off the top of the screen
	        var oldTop = -15;
	
	        var oldInfo = this.props.readReceiptInfo;
	        if (oldInfo && oldInfo.parent) {
	            oldTop = oldInfo.top + oldInfo.parent.getBoundingClientRect().top;
	        }
	
	        var newElement = ReactDOM.findDOMNode(this);
	        var startTopOffset = oldTop - newElement.offsetParent.getBoundingClientRect().top;
	
	        var startStyles = [];
	        var enterTransitionOpts = [];
	
	        if (oldInfo && oldInfo.left) {
	            // start at the old height and in the old h pos
	
	            var leftOffset = oldInfo.left;
	            startStyles.push({ top: startTopOffset + "px",
	                left: oldInfo.left + "px" });
	
	            var reorderTransitionOpts = {
	                duration: 100,
	                easing: 'easeOut'
	            };
	
	            enterTransitionOpts.push(reorderTransitionOpts);
	        }
	
	        // then shift to the rightmost column,
	        // and then it will drop down to its resting position
	        startStyles.push({ top: startTopOffset + 'px', left: '0px' });
	        enterTransitionOpts.push({
	            duration: bounce ? Math.min(Math.log(Math.abs(startTopOffset)) * 200, 3000) : 300,
	            easing: bounce ? 'easeOutBounce' : 'easeOutCubic'
	        });
	
	        this.setState({
	            suppressDisplay: false,
	            startStyles: startStyles,
	            enterTransitionOpts: enterTransitionOpts
	        });
	    },
	
	    render: function render() {
	        var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');
	        if (this.state.suppressDisplay) {
	            return React.createElement('div', null);
	        }
	
	        var style = {
	            left: this.props.leftOffset + 'px',
	            top: '0px',
	            visibility: this.props.hidden ? 'hidden' : 'visible'
	        };
	
	        var title = void 0;
	        if (this.props.timestamp) {
	            var prefix = "Seen by " + this.props.member.userId + " at ";
	            var ts = new Date(this.props.timestamp);
	            if (this.props.showFullTimestamp) {
	                // "15/12/2016, 7:05:45 PM (@alice:matrix.org)"
	                title = prefix + ts.toLocaleString();
	            } else {
	                // "7:05:45 PM (@alice:matrix.org)"
	                title = prefix + ts.toLocaleTimeString();
	            }
	        }
	
	        return React.createElement(
	            Velociraptor,
	            {
	                startStyles: this.state.startStyles,
	                enterTransitionOpts: this.state.enterTransitionOpts },
	            React.createElement(MemberAvatar, {
	                member: this.props.member,
	                'aria-hidden': 'true',
	                width: 14, height: 14, resizeMethod: 'crop',
	                style: style,
	                title: title,
	                onClick: this.props.onClick
	            })
	        );
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	var _SimpleRoomHeader = __webpack_require__(517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	var dis = __webpack_require__(5);
	var rate_limited_func = __webpack_require__(119);
	
	var linkify = __webpack_require__(204);
	var linkifyElement = __webpack_require__(302);
	var linkifyMatrix = __webpack_require__(142);
	
	
	linkifyMatrix(linkify);
	
	module.exports = React.createClass({
	    displayName: 'RoomHeader',
	
	    propTypes: {
	        room: React.PropTypes.object,
	        oobData: React.PropTypes.object,
	        editing: React.PropTypes.bool,
	        saving: React.PropTypes.bool,
	        collapsedRhs: React.PropTypes.bool,
	        onSettingsClick: React.PropTypes.func,
	        onSaveClick: React.PropTypes.func,
	        onSearchClick: React.PropTypes.func,
	        onLeaveClick: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            editing: false,
	            onSettingsClick: function onSettingsClick() {},
	            onSaveClick: function onSaveClick() {}
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        var cli = MatrixClientPeg.get();
	        cli.on("RoomState.events", this._onRoomStateEvents);
	
	        // When a room name occurs, RoomState.events is fired *before*
	        // room.name is updated. So we have to listen to Room.name as well as
	        // RoomState.events.
	        if (this.props.room) {
	            this.props.room.on("Room.name", this._onRoomNameChange);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (this.refs.topic) {
	            linkifyElement(this.refs.topic, linkifyMatrix.options);
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (this.props.room) {
	            this.props.room.removeListener("Room.name", this._onRoomNameChange);
	        }
	        var cli = MatrixClientPeg.get();
	        if (cli) {
	            cli.removeListener("RoomState.events", this._onRoomStateEvents);
	        }
	    },
	
	    _onRoomStateEvents: function _onRoomStateEvents(event, state) {
	        if (!this.props.room || event.getRoomId() != this.props.room.roomId) {
	            return;
	        }
	
	        // redisplay the room name, topic, etc.
	        this._rateLimitedUpdate();
	    },
	
	    _rateLimitedUpdate: new rate_limited_func(function () {
	        this.forceUpdate();
	    }, 500),
	
	    _onRoomNameChange: function _onRoomNameChange(room) {
	        this.forceUpdate();
	    },
	
	    onAvatarPickerClick: function onAvatarPickerClick(ev) {
	        if (this.refs.file_label) {
	            this.refs.file_label.click();
	        }
	    },
	
	    onAvatarSelected: function onAvatarSelected(ev) {
	        var self = this;
	        var changeAvatar = this.refs.changeAvatar;
	        if (!changeAvatar) {
	            console.error("No ChangeAvatar found to upload image to!");
	            return;
	        }
	        changeAvatar.onFileSelected(ev).catch(function (err) {
	            var errMsg = typeof err === "string" ? err : err.error || "";
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            console.error("Failed to set avatar: " + errMsg);
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "Failed to set avatar."
	            });
	        }).done();
	    },
	
	    onShowRhsClick: function onShowRhsClick(ev) {
	        dis.dispatch({ action: 'show_right_panel' });
	    },
	
	    /**
	     * After editing the settings, get the new name for the room
	     *
	     * Returns undefined if we didn't let the user edit the room name
	     */
	    getEditedName: function getEditedName() {
	        var newName;
	        if (this.refs.nameEditor) {
	            newName = this.refs.nameEditor.getRoomName();
	        }
	        return newName;
	    },
	
	    /**
	     * After editing the settings, get the new topic for the room
	     *
	     * Returns undefined if we didn't let the user edit the room topic
	     */
	    getEditedTopic: function getEditedTopic() {
	        var newTopic;
	        if (this.refs.topicEditor) {
	            newTopic = this.refs.topicEditor.getTopic();
	        }
	        return newTopic;
	    },
	
	    render: function render() {
	        var RoomAvatar = sdk.getComponent("avatars.RoomAvatar");
	        var ChangeAvatar = sdk.getComponent("settings.ChangeAvatar");
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	        var EmojiText = sdk.getComponent('elements.EmojiText');
	
	        var header;
	        var name = null;
	        var searchStatus = null;
	        var topic_el = null;
	        var cancel_button = null;
	        var spinner = null;
	        var save_button = null;
	        var settings_button = null;
	        if (this.props.editing) {
	
	            // calculate permissions.  XXX: this should be done on mount or something
	            var user_id = MatrixClientPeg.get().credentials.userId;
	
	            var can_set_room_name = this.props.room.currentState.maySendStateEvent('m.room.name', user_id);
	            var can_set_room_avatar = this.props.room.currentState.maySendStateEvent('m.room.avatar', user_id);
	            var can_set_room_topic = this.props.room.currentState.maySendStateEvent('m.room.topic', user_id);
	            var can_set_room_name = this.props.room.currentState.maySendStateEvent('m.room.name', user_id);
	
	            save_button = React.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_RoomHeader_textButton', onClick: this.props.onSaveClick },
	                'Save'
	            );
	            cancel_button = React.createElement(_SimpleRoomHeader.CancelButton, { onClick: this.props.onCancelClick });
	        }
	
	        if (this.props.saving) {
	            var Spinner = sdk.getComponent("elements.Spinner");
	            spinner = React.createElement(
	                'div',
	                { className: 'mx_RoomHeader_spinner' },
	                React.createElement(Spinner, null)
	            );
	        }
	
	        if (can_set_room_name) {
	            var RoomNameEditor = sdk.getComponent("rooms.RoomNameEditor");
	            name = React.createElement(RoomNameEditor, { ref: 'nameEditor', room: this.props.room });
	        } else {
	            var searchStatus;
	            // don't display the search count until the search completes and
	            // gives us a valid (possibly zero) searchCount.
	            if (this.props.searchInfo && this.props.searchInfo.searchCount !== undefined && this.props.searchInfo.searchCount !== null) {
	                searchStatus = React.createElement(
	                    'div',
	                    { className: 'mx_RoomHeader_searchStatus' },
	                    '\xA0(~',
	                    this.props.searchInfo.searchCount,
	                    ' results)'
	                );
	            }
	
	            // XXX: this is a bit inefficient - we could just compare room.name for 'Empty room'...
	            var settingsHint = false;
	            var members = this.props.room ? this.props.room.getJoinedMembers() : undefined;
	            if (members) {
	                if (members.length === 1 && members[0].userId === MatrixClientPeg.get().credentials.userId) {
	                    var name = this.props.room.currentState.getStateEvents('m.room.name', '');
	                    if (!name || !name.getContent().name) {
	                        settingsHint = true;
	                    }
	                }
	            }
	
	            var roomName = 'Join Room';
	            if (this.props.oobData && this.props.oobData.name) {
	                roomName = this.props.oobData.name;
	            } else if (this.props.room) {
	                roomName = this.props.room.name;
	            }
	
	            name = React.createElement(
	                'div',
	                { className: 'mx_RoomHeader_name', onClick: this.props.onSettingsClick },
	                React.createElement(
	                    EmojiText,
	                    { element: 'div', className: "mx_RoomHeader_nametext " + (settingsHint ? "mx_RoomHeader_settingsHint" : ""), title: roomName },
	                    roomName
	                ),
	                searchStatus
	            );
	        }
	
	        if (can_set_room_topic) {
	            var RoomTopicEditor = sdk.getComponent("rooms.RoomTopicEditor");
	            topic_el = React.createElement(RoomTopicEditor, { ref: 'topicEditor', room: this.props.room });
	        } else {
	            var topic;
	            if (this.props.room) {
	                var ev = this.props.room.currentState.getStateEvents('m.room.topic', '');
	                if (ev) {
	                    topic = ev.getContent().topic;
	                }
	            }
	            if (topic) {
	                topic_el = React.createElement(
	                    'div',
	                    { className: 'mx_RoomHeader_topic', ref: 'topic', title: topic },
	                    topic
	                );
	            }
	        }
	
	        var roomAvatar = null;
	        if (can_set_room_avatar) {
	            roomAvatar = React.createElement(
	                'div',
	                { className: 'mx_RoomHeader_avatarPicker' },
	                React.createElement(
	                    'div',
	                    { onClick: this.onAvatarPickerClick },
	                    React.createElement(ChangeAvatar, { ref: 'changeAvatar', room: this.props.room, showUploadSection: false, width: 48, height: 48 })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomHeader_avatarPicker_edit' },
	                    React.createElement(
	                        'label',
	                        { htmlFor: 'avatarInput', ref: 'file_label' },
	                        React.createElement('img', { src: 'img/camera.svg',
	                            alt: 'Upload avatar', title: 'Upload avatar',
	                            width: '17', height: '15' })
	                    ),
	                    React.createElement('input', { id: 'avatarInput', type: 'file', onChange: this.onAvatarSelected })
	                )
	            );
	        } else if (this.props.room || this.props.oobData && this.props.oobData.name) {
	            roomAvatar = React.createElement(
	                'div',
	                { onClick: this.props.onSettingsClick },
	                React.createElement(RoomAvatar, { room: this.props.room, width: 48, height: 48, oobData: this.props.oobData })
	            );
	        }
	
	        var settings_button;
	        if (this.props.onSettingsClick) {
	            settings_button = React.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_RoomHeader_button', onClick: this.props.onSettingsClick, title: 'Settings' },
	                React.createElement(TintableSvg, { src: 'img/icons-settings-room.svg', width: '16', height: '16' })
	            );
	        }
	
	        //        var leave_button;
	        //        if (this.props.onLeaveClick) {
	        //            leave_button =
	        //                <div className="mx_RoomHeader_button" onClick={this.props.onLeaveClick} title="Leave room">
	        //                    <TintableSvg src="img/leave.svg" width="26" height="20"/>
	        //                </div>;
	        //        }
	
	        var forget_button;
	        if (this.props.onForgetClick) {
	            forget_button = React.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_RoomHeader_button', onClick: this.props.onForgetClick, title: 'Forget room' },
	                React.createElement(TintableSvg, { src: 'img/leave.svg', width: '26', height: '20' })
	            );
	        }
	
	        var rightPanel_buttons;
	        if (this.props.collapsedRhs) {
	            rightPanel_buttons = React.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_RoomHeader_button', onClick: this.onShowRhsClick, title: 'Show panel' },
	                React.createElement(TintableSvg, { src: 'img/maximise.svg', width: '10', height: '16' })
	            );
	        }
	
	        var right_row;
	        if (!this.props.editing) {
	            right_row = React.createElement(
	                'div',
	                { className: 'mx_RoomHeader_rightRow' },
	                settings_button,
	                forget_button,
	                React.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_RoomHeader_button', onClick: this.props.onSearchClick, title: 'Search' },
	                    React.createElement(TintableSvg, { src: 'img/icons-search.svg', width: '35', height: '35' })
	                ),
	                rightPanel_buttons
	            );
	        }
	
	        header = React.createElement(
	            'div',
	            { className: 'mx_RoomHeader_wrapper' },
	            React.createElement(
	                'div',
	                { className: 'mx_RoomHeader_leftRow' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomHeader_avatar' },
	                    roomAvatar
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomHeader_info' },
	                    name,
	                    topic_el
	                )
	            ),
	            spinner,
	            save_button,
	            cancel_button,
	            right_row
	        );
	
	        return React.createElement(
	            'div',
	            { className: "mx_RoomHeader " + (this.props.editing ? "mx_RoomHeader_editing" : "") },
	            header
	        );
	    }
	});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _typeof2 = __webpack_require__(123);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DMRoomMap = __webpack_require__(94);
	
	var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	var GeminiScrollbar = __webpack_require__(121);
	var MatrixClientPeg = __webpack_require__(4);
	var CallHandler = __webpack_require__(73);
	var RoomListSorter = __webpack_require__(503);
	var Unread = __webpack_require__(221);
	var dis = __webpack_require__(5);
	var sdk = __webpack_require__(2);
	var rate_limited_func = __webpack_require__(119);
	var Rooms = __webpack_require__(117);
	
	var Receipt = __webpack_require__(522);
	
	var HIDE_CONFERENCE_CHANS = true;
	
	module.exports = React.createClass({
	    displayName: 'RoomList',
	
	    propTypes: {
	        ConferenceHandler: React.PropTypes.any,
	        collapsed: React.PropTypes.bool.isRequired,
	        currentRoom: React.PropTypes.string,
	        searchFilter: React.PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isLoadingLeftRooms: false,
	            lists: {},
	            incomingCall: null
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var cli = MatrixClientPeg.get();
	        cli.on("Room", this.onRoom);
	        cli.on("deleteRoom", this.onDeleteRoom);
	        cli.on("Room.timeline", this.onRoomTimeline);
	        cli.on("Room.name", this.onRoomName);
	        cli.on("Room.tags", this.onRoomTags);
	        cli.on("Room.receipt", this.onRoomReceipt);
	        cli.on("RoomState.events", this.onRoomStateEvents);
	        cli.on("RoomMember.name", this.onRoomMemberName);
	        cli.on("accountData", this.onAccountData);
	
	        var s = this.getRoomLists();
	        this.setState(s);
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        // Initialise the stickyHeaders when the component is created
	        this._updateStickyHeaders(true);
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        // Reinitialise the stickyHeaders when the component is updated
	        this._updateStickyHeaders(true);
	        this._repositionIncomingCallBox(undefined, false);
	    },
	
	    onAction: function onAction(payload) {
	        switch (payload.action) {
	            case 'view_tooltip':
	                this.tooltip = payload.tooltip;
	                break;
	            case 'call_state':
	                var call = CallHandler.getCall(payload.room_id);
	                if (call && call.call_state === 'ringing') {
	                    this.setState({
	                        incomingCall: call
	                    });
	                    this._repositionIncomingCallBox(undefined, true);
	                } else {
	                    this.setState({
	                        incomingCall: null
	                    });
	                }
	                break;
	            case 'on_room_read':
	                // Force an update because the notif count state is too deep to cause
	                // an update. This forces the local echo of reading notifs to be
	                // reflected by the RoomTiles.
	                this.forceUpdate();
	                break;
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	        if (MatrixClientPeg.get()) {
	            MatrixClientPeg.get().removeListener("Room", this.onRoom);
	            MatrixClientPeg.get().removeListener("deleteRoom", this.onDeleteRoom);
	            MatrixClientPeg.get().removeListener("Room.timeline", this.onRoomTimeline);
	            MatrixClientPeg.get().removeListener("Room.name", this.onRoomName);
	            MatrixClientPeg.get().removeListener("Room.tags", this.onRoomTags);
	            MatrixClientPeg.get().removeListener("Room.receipt", this.onRoomReceipt);
	            MatrixClientPeg.get().removeListener("RoomState.events", this.onRoomStateEvents);
	            MatrixClientPeg.get().removeListener("RoomMember.name", this.onRoomMemberName);
	            MatrixClientPeg.get().removeListener("accountData", this.onAccountData);
	        }
	        // cancel any pending calls to the rate_limited_funcs
	        this._delayedRefreshRoomList.cancelPendingCall();
	    },
	
	    onRoom: function onRoom(room) {
	        this._delayedRefreshRoomList();
	    },
	
	    onDeleteRoom: function onDeleteRoom(roomId) {
	        this._delayedRefreshRoomList();
	    },
	
	    onArchivedHeaderClick: function onArchivedHeaderClick(isHidden, scrollToPosition) {
	        if (!isHidden) {
	            var self = this;
	            this.setState({ isLoadingLeftRooms: true });
	
	            // Try scrolling to position
	            this._updateStickyHeaders(true, scrollToPosition);
	
	            // we don't care about the response since it comes down via "Room"
	            // events.
	            MatrixClientPeg.get().syncLeftRooms().catch(function (err) {
	                console.error("Failed to sync left rooms: %s", err);
	                console.error(err);
	            }).finally(function () {
	                self.setState({ isLoadingLeftRooms: false });
	            });
	        }
	    },
	
	    onSubListHeaderClick: function onSubListHeaderClick(isHidden, scrollToPosition) {
	        // The scroll area has expanded or contracted, so re-calculate sticky headers positions
	        this._updateStickyHeaders(true, scrollToPosition);
	    },
	
	    onRoomTimeline: function onRoomTimeline(ev, room, toStartOfTimeline, removed, data) {
	        if (toStartOfTimeline) return;
	        if (!room) return;
	        if (data.timeline.getTimelineSet() !== room.getUnfilteredTimelineSet()) return;
	        this._delayedRefreshRoomList();
	    },
	
	    onRoomReceipt: function onRoomReceipt(receiptEvent, room) {
	        // because if we read a notification, it will affect notification count
	        // only bother updating if there's a receipt from us
	        if (Receipt.findReadReceiptFromUserId(receiptEvent, MatrixClientPeg.get().credentials.userId)) {
	            this._delayedRefreshRoomList();
	        }
	    },
	
	    onRoomName: function onRoomName(room) {
	        this._delayedRefreshRoomList();
	    },
	
	    onRoomTags: function onRoomTags(event, room) {
	        this._delayedRefreshRoomList();
	    },
	
	    onRoomStateEvents: function onRoomStateEvents(ev, state) {
	        this._delayedRefreshRoomList();
	    },
	
	    onRoomMemberName: function onRoomMemberName(ev, member) {
	        this._delayedRefreshRoomList();
	    },
	
	    onAccountData: function onAccountData(ev) {
	        if (ev.getType() == 'm.direct') {
	            this._delayedRefreshRoomList();
	        }
	    },
	
	    _delayedRefreshRoomList: new rate_limited_func(function () {
	        this.refreshRoomList();
	    }, 500),
	
	    refreshRoomList: function refreshRoomList() {
	        // console.log("DEBUG: Refresh room list delta=%s ms",
	        //     (!this._lastRefreshRoomListTs ? "-" : (Date.now() - this._lastRefreshRoomListTs))
	        // );
	
	        // TODO: rather than bluntly regenerating and re-sorting everything
	        // every time we see any kind of room change from the JS SDK
	        // we could do incremental updates on our copy of the state
	        // based on the room which has actually changed.  This would stop
	        // us re-rendering all the sublists every time anything changes anywhere
	        // in the state of the client.
	        this.setState(this.getRoomLists());
	        this._lastRefreshRoomListTs = Date.now();
	    },
	
	    getRoomLists: function getRoomLists() {
	        var self = this;
	        var s = { lists: {} };
	
	        s.lists["im.vector.fake.invite"] = [];
	        s.lists["m.favourite"] = [];
	        s.lists["im.vector.fake.recent"] = [];
	        s.lists["im.vector.fake.direct"] = [];
	        s.lists["m.lowpriority"] = [];
	        s.lists["im.vector.fake.archived"] = [];
	
	        var dmRoomMap = new _DMRoomMap2.default(MatrixClientPeg.get());
	
	        MatrixClientPeg.get().getRooms().forEach(function (room) {
	            var me = room.getMember(MatrixClientPeg.get().credentials.userId);
	            if (!me) return;
	
	            // console.log("room = " + room.name + ", me.membership = " + me.membership +
	            //             ", sender = " + me.events.member.getSender() +
	            //             ", target = " + me.events.member.getStateKey() +
	            //             ", prevMembership = " + me.events.member.getPrevContent().membership);
	
	            if (me.membership == "invite") {
	                s.lists["im.vector.fake.invite"].push(room);
	            } else if (HIDE_CONFERENCE_CHANS && Rooms.isConfCallRoom(room, me, self.props.ConferenceHandler)) {
	                // skip past this room & don't put it in any lists
	            } else if (me.membership == "join" || me.membership === "ban" || me.membership === "leave" && me.events.member.getSender() !== me.events.member.getStateKey()) {
	                // Used to split rooms via tags
	                var tagNames = (0, _keys2.default)(room.tags);
	
	                if (tagNames.length) {
	                    for (var i = 0; i < tagNames.length; i++) {
	                        var tagName = tagNames[i];
	                        s.lists[tagName] = s.lists[tagName] || [];
	                        s.lists[tagNames[i]].push(room);
	                    }
	                } else if (dmRoomMap.getUserIdForRoomId(room.roomId)) {
	                    // "Direct Message" rooms (that we're still in and that aren't otherwise tagged)
	                    s.lists["im.vector.fake.direct"].push(room);
	                } else {
	                    s.lists["im.vector.fake.recent"].push(room);
	                }
	            } else if (me.membership === "leave") {
	                s.lists["im.vector.fake.archived"].push(room);
	            } else {
	                console.error("unrecognised membership: " + me.membership + " - this should never happen");
	            }
	        });
	
	        if (s.lists["im.vector.fake.direct"].length == 0 && MatrixClientPeg.get().getAccountData('m.direct') === undefined && !MatrixClientPeg.get().isGuest()) {
	            // scan through the 'recents' list for any rooms which look like DM rooms
	            // and make them DM rooms
	            var oldRecents = s.lists["im.vector.fake.recent"];
	            s.lists["im.vector.fake.recent"] = [];
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(oldRecents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var room = _step.value;
	
	                    var me = room.getMember(MatrixClientPeg.get().credentials.userId);
	
	                    if (me && Rooms.looksLikeDirectMessageRoom(room, me)) {
	                        s.lists["im.vector.fake.direct"].push(room);
	                    } else {
	                        s.lists["im.vector.fake.recent"].push(room);
	                    }
	                }
	
	                // save these new guessed DM rooms into the account data
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var newMDirectEvent = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = (0, _getIterator3.default)(s.lists["im.vector.fake.direct"]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _room = _step2.value;
	
	                    var _me = _room.getMember(MatrixClientPeg.get().credentials.userId);
	                    var otherPerson = Rooms.getOnlyOtherMember(_room, _me);
	                    if (!otherPerson) continue;
	
	                    var roomList = newMDirectEvent[otherPerson.userId] || [];
	                    roomList.push(_room.roomId);
	                    newMDirectEvent[otherPerson.userId] = roomList;
	                }
	
	                // if this fails, fine, we'll just do the same thing next time we get the room lists
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            MatrixClientPeg.get().setAccountData('m.direct', newMDirectEvent).done();
	        }
	
	        //console.log("calculated new roomLists; im.vector.fake.recent = " + s.lists["im.vector.fake.recent"]);
	
	        // we actually apply the sorting to this when receiving the prop in RoomSubLists.
	
	        return s;
	    },
	
	    _getScrollNode: function _getScrollNode() {
	        var panel = ReactDOM.findDOMNode(this);
	        if (!panel) return null;
	
	        if (panel.classList.contains('gm-prevented')) {
	            return panel;
	        } else {
	            return panel.children[2]; // XXX: Fragile!
	        }
	    },
	
	    _whenScrolling: function _whenScrolling(e) {
	        this._hideTooltip(e);
	        this._repositionIncomingCallBox(e, false);
	        this._updateStickyHeaders(false);
	    },
	
	    _hideTooltip: function _hideTooltip(e) {
	        // Hide tooltip when scrolling, as we'll no longer be over the one we were on
	        if (this.tooltip && this.tooltip.style.display !== "none") {
	            this.tooltip.style.display = "none";
	        }
	    },
	
	    _repositionIncomingCallBox: function _repositionIncomingCallBox(e, firstTime) {
	        var incomingCallBox = document.getElementById("incomingCallBox");
	        if (incomingCallBox && incomingCallBox.parentElement) {
	            var scrollArea = this._getScrollNode();
	            // Use the offset of the top of the scroll area from the window
	            // as this is used to calculate the CSS fixed top position for the stickies
	            var scrollAreaOffset = scrollArea.getBoundingClientRect().top + window.pageYOffset;
	            // Use the offset of the top of the componet from the window
	            // as this is used to calculate the CSS fixed top position for the stickies
	            var scrollAreaHeight = ReactDOM.findDOMNode(this).getBoundingClientRect().height;
	
	            var top = incomingCallBox.parentElement.getBoundingClientRect().top + window.pageYOffset;
	            // Make sure we don't go too far up, if the headers aren't sticky
	            top = top < scrollAreaOffset ? scrollAreaOffset : top;
	            // make sure we don't go too far down, if the headers aren't sticky
	            var bottomMargin = scrollAreaOffset + (scrollAreaHeight - 45);
	            top = top > bottomMargin ? bottomMargin : top;
	
	            incomingCallBox.style.top = top + "px";
	            incomingCallBox.style.left = scrollArea.offsetLeft + scrollArea.offsetWidth + 12 + "px";
	        }
	    },
	
	    // Doing the sticky headers as raw DOM, for speed, as it gets very stuttery if done
	    // properly through React
	    _initAndPositionStickyHeaders: function _initAndPositionStickyHeaders(initialise, scrollToPosition) {
	        var scrollArea = this._getScrollNode();
	        // Use the offset of the top of the scroll area from the window
	        // as this is used to calculate the CSS fixed top position for the stickies
	        var scrollAreaOffset = scrollArea.getBoundingClientRect().top + window.pageYOffset;
	        // Use the offset of the top of the componet from the window
	        // as this is used to calculate the CSS fixed top position for the stickies
	        var scrollAreaHeight = ReactDOM.findDOMNode(this).getBoundingClientRect().height;
	
	        if (initialise) {
	            // Get a collection of sticky header containers references
	            this.stickies = document.getElementsByClassName("mx_RoomSubList_labelContainer");
	
	            if (!this.stickies.length) return;
	
	            // Make sure there is sufficient space to do sticky headers: 120px plus all the sticky headers
	            this.scrollAreaSufficient = 120 + this.stickies[0].getBoundingClientRect().height * this.stickies.length < scrollAreaHeight;
	
	            // Initialise the sticky headers
	            if ((0, _typeof3.default)(this.stickies) === "object" && this.stickies.length > 0) {
	                // Initialise the sticky headers
	                Array.prototype.forEach.call(this.stickies, function (sticky, i) {
	                    // Save the positions of all the stickies within scroll area.
	                    // These positions are relative to the LHS Panel top
	                    sticky.dataset.originalPosition = sticky.offsetTop - scrollArea.offsetTop;
	
	                    // Save and set the sticky heights
	                    var originalHeight = sticky.getBoundingClientRect().height;
	                    sticky.dataset.originalHeight = originalHeight;
	                    sticky.style.height = originalHeight;
	
	                    return sticky;
	                });
	            }
	        }
	
	        var self = this;
	        var scrollStuckOffset = 0;
	        // Scroll to the passed in position, i.e. a header was clicked and in a scroll to state
	        // rather than a collapsable one (see RoomSubList.isCollapsableOnClick method for details)
	        if (scrollToPosition !== undefined) {
	            scrollArea.scrollTop = scrollToPosition;
	        }
	        // Stick headers to top and bottom, or free them
	        Array.prototype.forEach.call(this.stickies, function (sticky, i, stickyWrappers) {
	            var stickyPosition = sticky.dataset.originalPosition;
	            var stickyHeight = sticky.dataset.originalHeight;
	            var stickyHeader = sticky.childNodes[0];
	            var topStuckHeight = stickyHeight * i;
	            var bottomStuckHeight = stickyHeight * (stickyWrappers.length - i);
	
	            if (self.scrollAreaSufficient && stickyPosition < scrollArea.scrollTop + topStuckHeight) {
	                // Top stickies
	                sticky.dataset.stuck = "top";
	                stickyHeader.classList.add("mx_RoomSubList_fixed");
	                stickyHeader.style.top = scrollAreaOffset + topStuckHeight + "px";
	                // If stuck at top adjust the scroll back down to take account of all the stuck headers
	                if (scrollToPosition !== undefined && stickyPosition === scrollToPosition) {
	                    scrollStuckOffset = topStuckHeight;
	                }
	            } else if (self.scrollAreaSufficient && stickyPosition > scrollArea.scrollTop + scrollAreaHeight - bottomStuckHeight) {
	                /// Bottom stickies
	                sticky.dataset.stuck = "bottom";
	                stickyHeader.classList.add("mx_RoomSubList_fixed");
	                stickyHeader.style.top = scrollAreaOffset + scrollAreaHeight - bottomStuckHeight + "px";
	            } else {
	                // Not sticky
	                sticky.dataset.stuck = "none";
	                stickyHeader.classList.remove("mx_RoomSubList_fixed");
	                stickyHeader.style.top = null;
	            }
	        });
	        // Adjust the scroll to take account of top stuck headers
	        if (scrollToPosition !== undefined) {
	            scrollArea.scrollTop -= scrollStuckOffset;
	        }
	    },
	
	    _updateStickyHeaders: function _updateStickyHeaders(initialise, scrollToPosition) {
	        var self = this;
	
	        if (initialise) {
	            // Useing setTimeout to ensure that the code is run after the painting
	            // of the newly rendered object as using requestAnimationFrame caused
	            // artefacts to appear on screen briefly
	            window.setTimeout(function () {
	                self._initAndPositionStickyHeaders(initialise, scrollToPosition);
	            });
	        } else {
	            this._initAndPositionStickyHeaders(initialise, scrollToPosition);
	        }
	    },
	
	    onShowMoreRooms: function onShowMoreRooms() {
	        // kick gemini in the balls to get it to wake up
	        // XXX: uuuuuuugh.
	        this.refs.gemscroll.forceUpdate();
	    },
	
	    render: function render() {
	        var RoomSubList = sdk.getComponent('structures.RoomSubList');
	        var self = this;
	
	        return React.createElement(
	            GeminiScrollbar,
	            { className: "mx_RoomList_scrollbar",
	                autoshow: true, onScroll: self._whenScrolling, ref: "gemscroll" },
	            React.createElement(
	                "div",
	                { className: "mx_RoomList" },
	                React.createElement(RoomSubList, { list: self.state.lists['im.vector.fake.invite'],
	                    label: "Invites",
	                    editable: false,
	                    order: "recent",
	                    selectedRoom: self.props.selectedRoom,
	                    incomingCall: self.state.incomingCall,
	                    collapsed: self.props.collapsed,
	                    searchFilter: self.props.searchFilter,
	                    onHeaderClick: self.onSubListHeaderClick,
	                    onShowMoreRooms: self.onShowMoreRooms }),
	                React.createElement(RoomSubList, { list: self.state.lists['m.favourite'],
	                    label: "Favourites",
	                    tagName: "m.favourite",
	                    verb: "favourite",
	                    editable: true,
	                    order: "manual",
	                    selectedRoom: self.props.selectedRoom,
	                    incomingCall: self.state.incomingCall,
	                    collapsed: self.props.collapsed,
	                    searchFilter: self.props.searchFilter,
	                    onHeaderClick: self.onSubListHeaderClick,
	                    onShowMoreRooms: self.onShowMoreRooms }),
	                React.createElement(RoomSubList, { list: self.state.lists['im.vector.fake.direct'],
	                    label: "People",
	                    tagName: "im.vector.fake.direct",
	                    verb: "tag direct chat",
	                    editable: true,
	                    order: "recent",
	                    selectedRoom: self.props.selectedRoom,
	                    incomingCall: self.state.incomingCall,
	                    collapsed: self.props.collapsed,
	                    alwaysShowHeader: true,
	                    searchFilter: self.props.searchFilter,
	                    onHeaderClick: self.onSubListHeaderClick,
	                    onShowMoreRooms: self.onShowMoreRooms }),
	                React.createElement(RoomSubList, { list: self.state.lists['im.vector.fake.recent'],
	                    label: "Rooms",
	                    editable: true,
	                    verb: "restore",
	                    order: "recent",
	                    selectedRoom: self.props.selectedRoom,
	                    incomingCall: self.state.incomingCall,
	                    collapsed: self.props.collapsed,
	                    searchFilter: self.props.searchFilter,
	                    onHeaderClick: self.onSubListHeaderClick,
	                    onShowMoreRooms: self.onShowMoreRooms }),
	                (0, _keys2.default)(self.state.lists).map(function (tagName) {
	                    if (!tagName.match(/^(m\.(favourite|lowpriority)|im\.vector\.fake\.(invite|recent|direct|archived))$/)) {
	                        return React.createElement(RoomSubList, { list: self.state.lists[tagName],
	                            key: tagName,
	                            label: tagName,
	                            tagName: tagName,
	                            verb: "tag as " + tagName,
	                            editable: true,
	                            order: "manual",
	                            selectedRoom: self.props.selectedRoom,
	                            incomingCall: self.state.incomingCall,
	                            collapsed: self.props.collapsed,
	                            searchFilter: self.props.searchFilter,
	                            onHeaderClick: self.onSubListHeaderClick,
	                            onShowMoreRooms: self.onShowMoreRooms });
	                    }
	                }),
	                React.createElement(RoomSubList, { list: self.state.lists['m.lowpriority'],
	                    label: "Low priority",
	                    tagName: "m.lowpriority",
	                    verb: "demote",
	                    editable: true,
	                    order: "recent",
	                    selectedRoom: self.props.selectedRoom,
	                    incomingCall: self.state.incomingCall,
	                    collapsed: self.props.collapsed,
	                    searchFilter: self.props.searchFilter,
	                    onHeaderClick: self.onSubListHeaderClick,
	                    onShowMoreRooms: self.onShowMoreRooms }),
	                React.createElement(RoomSubList, { list: self.state.lists['im.vector.fake.archived'],
	                    label: "Historical",
	                    editable: false,
	                    order: "recent",
	                    selectedRoom: self.props.selectedRoom,
	                    collapsed: self.props.collapsed,
	                    alwaysShowHeader: true,
	                    startAsHidden: true,
	                    showSpinner: self.state.isLoadingLeftRooms,
	                    onHeaderClick: self.onArchivedHeaderClick,
	                    incomingCall: self.state.incomingCall,
	                    searchFilter: self.props.searchFilter,
	                    onShowMoreRooms: self.onShowMoreRooms })
	            )
	        );
	    }
	});


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	
	module.exports = React.createClass({
	    displayName: 'RoomNameEditor',
	
	    propTypes: {
	        room: React.PropTypes.object.isRequired
	    },
	
	    componentWillMount: function componentWillMount() {
	        var room = this.props.room;
	        var name = room.currentState.getStateEvents('m.room.name', '');
	        var myId = MatrixClientPeg.get().credentials.userId;
	        var defaultName = room.getDefaultRoomName(myId);
	
	        this._initialName = name ? name.getContent().name : '';
	
	        this._placeholderName = "Unnamed Room";
	        if (defaultName && defaultName !== 'Empty room') {
	            this._placeholderName += " (" + defaultName + ")";
	        }
	    },
	
	    getRoomName: function getRoomName() {
	        return this.refs.editor.getValue();
	    },
	
	    render: function render() {
	        var EditableText = sdk.getComponent("elements.EditableText");
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomHeader_name' },
	            React.createElement(EditableText, { ref: 'editor',
	                className: 'mx_RoomHeader_nametext mx_RoomHeader_editable',
	                placeholderClassName: 'mx_RoomHeader_placeholder',
	                placeholder: this._placeholderName,
	                blurToCancel: false,
	                initialValue: this._initialName })
	        );
	    }
	});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	
	module.exports = React.createClass({
	    displayName: 'RoomPreviewBar',
	
	    propTypes: {
	        onJoinClick: React.PropTypes.func,
	        onRejectClick: React.PropTypes.func,
	        onForgetClick: React.PropTypes.func,
	
	        // if inviterName is specified, the preview bar will shown an invite to the room.
	        // You should also specify onRejectClick if specifiying inviterName
	        inviterName: React.PropTypes.string,
	
	        // If invited by 3rd party invite, the email address the invite was sent to
	        invitedEmail: React.PropTypes.string,
	
	        // A standard client/server API error object. If supplied, indicates that the
	        // caller was unable to fetch details about the room for the given reason.
	        error: React.PropTypes.object,
	
	        canPreview: React.PropTypes.bool,
	        spinner: React.PropTypes.bool,
	        room: React.PropTypes.object,
	
	        // The alias that was used to access this room, if appropriate
	        // If given, this will be how the room is referred to (eg.
	        // in error messages).
	        roomAlias: React.PropTypes.object
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onJoinClick: function onJoinClick() {},
	            canPreview: true
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            busy: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        // If this is an invite and we've been told what email
	        // address was invited, fetch the user's list of 3pids
	        // so we can check them against the one that was invited
	        if (this.props.inviterName && this.props.invitedEmail) {
	            this.setState({ busy: true });
	            MatrixClientPeg.get().lookupThreePid('email', this.props.invitedEmail).finally(function () {
	                _this.setState({ busy: false });
	            }).done(function (result) {
	                _this.setState({ invitedEmailMxid: result.mxid });
	            }, function (err) {
	                _this.setState({ threePidFetchError: err });
	            });
	        }
	    },
	
	    _roomNameElement: function _roomNameElement(fallback) {
	        fallback = fallback || 'a room';
	        var name = this.props.room ? this.props.room.name : this.props.room_alias || "";
	        return name ? React.createElement(
	            'b',
	            null,
	            name
	        ) : fallback;
	    },
	
	    render: function render() {
	        var joinBlock, previewBlock;
	
	        if (this.props.spinner || this.state.busy) {
	            var Spinner = sdk.getComponent("elements.Spinner");
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomPreviewBar' },
	                React.createElement(Spinner, null)
	            );
	        }
	
	        var myMember = this.props.room ? this.props.room.currentState.members[MatrixClientPeg.get().credentials.userId] : null;
	        var kicked = myMember && myMember.membership == 'leave' && myMember.events.member.getSender() != MatrixClientPeg.get().credentials.userId;
	        var banned = myMember && myMember.membership == 'ban';
	
	        if (this.props.inviterName) {
	            var emailMatchBlock;
	            if (this.props.invitedEmail) {
	                if (this.state.threePidFetchError) {
	                    emailMatchBlock = React.createElement(
	                        'div',
	                        { className: 'error' },
	                        'Unable to ascertain that the address this invite was sent to matches one associated with your account.'
	                    );
	                } else if (this.state.invitedEmailMxid != MatrixClientPeg.get().credentials.userId) {
	                    emailMatchBlock = React.createElement(
	                        'div',
	                        { className: 'mx_RoomPreviewBar_warning' },
	                        React.createElement(
	                            'div',
	                            { className: 'mx_RoomPreviewBar_warningIcon' },
	                            React.createElement('img', { src: 'img/warning.svg', width: '24', height: '23', title: '/!\\\\', alt: '/!\\\\' })
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'mx_RoomPreviewBar_warningText' },
	                            'This invitation was sent to ',
	                            React.createElement(
	                                'b',
	                                null,
	                                React.createElement(
	                                    'span',
	                                    { className: 'email' },
	                                    this.props.invitedEmail
	                                )
	                            ),
	                            ', which is not associated with this account.',
	                            React.createElement('br', null),
	                            'You may wish to login with a different account, or add this email to this account.'
	                        )
	                    );
	                }
	            }
	            joinBlock = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomPreviewBar_invite_text' },
	                    'You have been invited to join this room by ',
	                    React.createElement(
	                        'b',
	                        null,
	                        this.props.inviterName
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomPreviewBar_join_text' },
	                    'Would you like to ',
	                    React.createElement(
	                        'a',
	                        { onClick: this.props.onJoinClick },
	                        'accept'
	                    ),
	                    ' or ',
	                    React.createElement(
	                        'a',
	                        { onClick: this.props.onRejectClick },
	                        'decline'
	                    ),
	                    ' this invitation?'
	                ),
	                emailMatchBlock
	            );
	        } else if (kicked || banned) {
	            var verb = kicked ? 'kicked' : 'banned';
	            var roomName = this._roomNameElement('this room');
	            var kickerMember = this.props.room.currentState.getMember(myMember.events.member.getSender());
	            var kickerName = kickerMember ? kickerMember.name : myMember.events.member.getSender();
	            var reason = void 0;
	            if (myMember.events.member.getContent().reason) {
	                reason = React.createElement(
	                    'div',
	                    null,
	                    'Reason: ',
	                    myMember.events.member.getContent().reason
	                );
	            }
	            var rejoinBlock = void 0;
	            if (!banned) {
	                rejoinBlock = React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'a',
	                        { onClick: this.props.onJoinClick },
	                        React.createElement(
	                            'b',
	                            null,
	                            'Rejoin'
	                        )
	                    )
	                );
	            }
	            joinBlock = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomPreviewBar_join_text' },
	                    'You have been ',
	                    verb,
	                    ' from ',
	                    roomName,
	                    ' by ',
	                    kickerName,
	                    '.',
	                    React.createElement('br', null),
	                    reason,
	                    rejoinBlock,
	                    React.createElement(
	                        'a',
	                        { onClick: this.props.onForgetClick },
	                        React.createElement(
	                            'b',
	                            null,
	                            'Forget'
	                        )
	                    )
	                )
	            );
	        } else if (this.props.error) {
	            var name = this.props.roomAlias || "This room";
	            var error;
	            if (this.props.error.errcode == 'M_NOT_FOUND') {
	                error = name + " does not exist";
	            } else {
	                error = name + " is not accessible at this time";
	            }
	            joinBlock = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomPreviewBar_join_text' },
	                    error
	                )
	            );
	        } else {
	            var _name = this._roomNameElement();
	            joinBlock = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomPreviewBar_join_text' },
	                    'You are trying to access ',
	                    _name,
	                    '.',
	                    React.createElement('br', null),
	                    React.createElement(
	                        'a',
	                        { onClick: this.props.onJoinClick },
	                        React.createElement(
	                            'b',
	                            null,
	                            'Click here'
	                        )
	                    ),
	                    ' to join the discussion!'
	                )
	            );
	        }
	
	        if (this.props.canPreview) {
	            previewBlock = React.createElement(
	                'div',
	                { className: 'mx_RoomPreviewBar_preview_text' },
	                'This is a preview of this room. Room interactions have been disabled.'
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomPreviewBar' },
	            React.createElement(
	                'div',
	                { className: 'mx_RoomPreviewBar_wrapper' },
	                joinBlock,
	                previewBlock
	            )
	        );
	    }
	});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(12);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _SdkConfig = __webpack_require__(118);
	
	var _SdkConfig2 = _interopRequireDefault(_SdkConfig);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ObjectUtils = __webpack_require__(139);
	
	var _ObjectUtils2 = _interopRequireDefault(_ObjectUtils);
	
	var _dispatcher = __webpack_require__(5);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _ScalarAuthClient = __webpack_require__(505);
	
	var _ScalarAuthClient2 = _interopRequireDefault(_ScalarAuthClient);
	
	var _ScalarMessaging = __webpack_require__(1160);
	
	var _ScalarMessaging2 = _interopRequireDefault(_ScalarMessaging);
	
	var _UserSettingsStore = __webpack_require__(74);
	
	var _UserSettingsStore2 = _interopRequireDefault(_UserSettingsStore);
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// parse a string as an integer; if the input is undefined, or cannot be parsed
	// as an integer, return a default.
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	Copyright 2017 Vector Creations Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	function parseIntWithDefault(val, def) {
	    var res = parseInt(val);
	    return isNaN(res) ? def : res;
	}
	
	var BannedUser = _react2.default.createClass({
	    displayName: 'BannedUser',
	
	    propTypes: {
	        member: _react2.default.PropTypes.object.isRequired },
	
	    _onUnbanClick: function _onUnbanClick() {
	        var _this = this;
	
	        var ConfirmUserActionDialog = _index2.default.getComponent("dialogs.ConfirmUserActionDialog");
	        _Modal2.default.createDialog(ConfirmUserActionDialog, {
	            member: this.props.member,
	            action: 'Unban',
	            danger: false,
	            onFinished: function onFinished(proceed) {
	                if (!proceed) return;
	
	                _MatrixClientPeg2.default.get().unban(_this.props.member.roomId, _this.props.member.userId).catch(function (err) {
	                    var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	                    console.error("Failed to unban: " + err);
	                    _Modal2.default.createDialog(ErrorDialog, {
	                        title: "Error",
	                        description: "Failed to unban"
	                    });
	                }).done();
	            }
	        });
	    },
	
	    render: function render() {
	        return _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	                _AccessibleButton2.default,
	                { className: 'mx_RoomSettings_unbanButton',
	                    onClick: this._onUnbanClick
	                },
	                'Unban'
	            ),
	            this.props.member.userId
	        );
	    }
	});
	
	module.exports = _react2.default.createClass({
	    displayName: 'RoomSettings',
	
	    propTypes: {
	        room: _react2.default.PropTypes.object.isRequired,
	        onSaveClick: _react2.default.PropTypes.func,
	        onCancelClick: _react2.default.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        var tags = {};
	        (0, _keys2.default)(this.props.room.tags).forEach(function (tagName) {
	            tags[tagName] = ['yep'];
	        });
	
	        return {
	            name: this._yankValueFromEvent("m.room.name", "name"),
	            topic: this._yankValueFromEvent("m.room.topic", "topic"),
	            join_rule: this._yankValueFromEvent("m.room.join_rules", "join_rule"),
	            history_visibility: this._yankValueFromEvent("m.room.history_visibility", "history_visibility"),
	            guest_access: this._yankValueFromEvent("m.room.guest_access", "guest_access"),
	            power_levels_changed: false,
	            tags_changed: false,
	            tags: tags,
	            // isRoomPublished is loaded async in componentWillMount so when the component
	            // inits, the saved value will always be undefined, however getInitialState()
	            // is also called from the saving code so we must return the correct value here
	            // if we have it (although this could race if the user saves before we load whether
	            // the room is published or not).
	            // Default to false if it's undefined, otherwise react complains about changing
	            // components from uncontrolled to controlled
	            isRoomPublished: this._originalIsRoomPublished || false,
	            scalar_error: null,
	            showIntegrationsError: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _this2 = this;
	
	        _ScalarMessaging2.default.startListening();
	
	        _MatrixClientPeg2.default.get().on("RoomMember.membership", this._onRoomMemberMembership);
	
	        _MatrixClientPeg2.default.get().getRoomDirectoryVisibility(this.props.room.roomId).done(function (result) {
	            _this2.setState({ isRoomPublished: result.visibility === "public" });
	            _this2._originalIsRoomPublished = result.visibility === "public";
	        }, function (err) {
	            console.error("Failed to get room visibility: " + err);
	        });
	
	        this.scalarClient = new _ScalarAuthClient2.default();
	        this.scalarClient.connect().done(function () {
	            _this2.forceUpdate();
	        }, function (err) {
	            _this2.setState({
	                scalar_error: err
	            });
	        });
	
	        _dispatcher2.default.dispatch({
	            action: 'ui_opacity',
	            sideOpacity: 0.3,
	            middleOpacity: 0.3
	        });
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        _ScalarMessaging2.default.stopListening();
	
	        var cli = _MatrixClientPeg2.default.get();
	        if (cli) {
	            cli.removeListener("RoomMember.membership", this._onRoomMemberMembership);
	        }
	
	        _dispatcher2.default.dispatch({
	            action: 'ui_opacity',
	            sideOpacity: 1.0,
	            middleOpacity: 1.0
	        });
	    },
	
	    setName: function setName(name) {
	        this.setState({
	            name: name
	        });
	    },
	
	    setTopic: function setTopic(topic) {
	        this.setState({
	            topic: topic
	        });
	    },
	
	    save: function save() {
	        var _this3 = this;
	
	        var stateWasSetDefer = _q2.default.defer();
	        // the caller may have JUST called setState on stuff, so we need to re-render before saving
	        // else we won't use the latest values of things.
	        // We can be a bit cheeky here and set a loading flag, and listen for the callback on that
	        // to know when things have been set.
	        this.setState({ _loading: true }, function () {
	            stateWasSetDefer.resolve();
	            _this3.setState({ _loading: false });
	        });
	
	        return stateWasSetDefer.promise.then(function () {
	            return _q2.default.allSettled(_this3._calcSavePromises());
	        });
	    },
	
	    _calcSavePromises: function _calcSavePromises() {
	        var roomId = this.props.room.roomId;
	        var promises = this.saveAliases(); // returns Promise[]
	        var originalState = this.getInitialState();
	
	        // diff between original state and this.state to work out what has been changed
	        console.log("Original: %s", (0, _stringify2.default)(originalState));
	        console.log("New: %s", (0, _stringify2.default)(this.state));
	
	        // name and topic
	        if (this._hasDiff(this.state.name, originalState.name)) {
	            promises.push(_MatrixClientPeg2.default.get().setRoomName(roomId, this.state.name));
	        }
	        if (this._hasDiff(this.state.topic, originalState.topic)) {
	            promises.push(_MatrixClientPeg2.default.get().setRoomTopic(roomId, this.state.topic));
	        }
	
	        if (this.state.history_visibility !== originalState.history_visibility) {
	            promises.push(_MatrixClientPeg2.default.get().sendStateEvent(roomId, "m.room.history_visibility", { history_visibility: this.state.history_visibility }, ""));
	        }
	
	        if (this.state.isRoomPublished !== originalState.isRoomPublished) {
	            promises.push(_MatrixClientPeg2.default.get().setRoomDirectoryVisibility(roomId, this.state.isRoomPublished ? "public" : "private"));
	        }
	
	        if (this.state.join_rule !== originalState.join_rule) {
	            promises.push(_MatrixClientPeg2.default.get().sendStateEvent(roomId, "m.room.join_rules", { join_rule: this.state.join_rule }, ""));
	        }
	
	        if (this.state.guest_access !== originalState.guest_access) {
	            promises.push(_MatrixClientPeg2.default.get().sendStateEvent(roomId, "m.room.guest_access", { guest_access: this.state.guest_access }, ""));
	        }
	
	        // power levels
	        var powerLevels = this._getPowerLevels();
	        if (powerLevels) {
	            promises.push(_MatrixClientPeg2.default.get().sendStateEvent(roomId, "m.room.power_levels", powerLevels, ""));
	        }
	
	        // tags
	        if (this.state.tags_changed) {
	            var tagDiffs = _ObjectUtils2.default.getKeyValueArrayDiffs(originalState.tags, this.state.tags);
	            // [ {place: add, key: "m.favourite", val: ["yep"]} ]
	            tagDiffs.forEach(function (diff) {
	                switch (diff.place) {
	                    case "add":
	                        promises.push(_MatrixClientPeg2.default.get().setRoomTag(roomId, diff.key, {}));
	                        break;
	                    case "del":
	                        promises.push(_MatrixClientPeg2.default.get().deleteRoomTag(roomId, diff.key));
	                        break;
	                    default:
	                        console.error("Unknown tag operation: %s", diff.place);
	                        break;
	                }
	            });
	        }
	
	        // color scheme
	        var p;
	        p = this.saveColor();
	        if (!_q2.default.isFulfilled(p)) {
	            promises.push(p);
	        }
	
	        // url preview settings
	        var ps = this.saveUrlPreviewSettings();
	        if (ps.length > 0) {
	            promises.push(ps);
	        }
	
	        // encryption
	        p = this.saveEnableEncryption();
	        if (!_q2.default.isFulfilled(p)) {
	            promises.push(p);
	        }
	
	        this.saveBlacklistUnverifiedDevicesPerRoom();
	
	        console.log("Performing %s operations: %s", promises.length, (0, _stringify2.default)(promises));
	        return promises;
	    },
	
	    saveAliases: function saveAliases() {
	        if (!this.refs.alias_settings) {
	            return [(0, _q2.default)()];
	        }
	        return this.refs.alias_settings.saveSettings();
	    },
	
	    saveColor: function saveColor() {
	        if (!this.refs.color_settings) {
	            return (0, _q2.default)();
	        }
	        return this.refs.color_settings.saveSettings();
	    },
	
	    saveUrlPreviewSettings: function saveUrlPreviewSettings() {
	        if (!this.refs.url_preview_settings) {
	            return (0, _q2.default)();
	        }
	        return this.refs.url_preview_settings.saveSettings();
	    },
	
	    saveEnableEncryption: function saveEnableEncryption() {
	        if (!this.refs.encrypt) {
	            return (0, _q2.default)();
	        }
	
	        var encrypt = this.refs.encrypt.checked;
	        if (!encrypt) {
	            return (0, _q2.default)();
	        }
	
	        var roomId = this.props.room.roomId;
	        return _MatrixClientPeg2.default.get().sendStateEvent(roomId, "m.room.encryption", { algorithm: "m.megolm.v1.aes-sha2" });
	    },
	
	    saveBlacklistUnverifiedDevicesPerRoom: function saveBlacklistUnverifiedDevicesPerRoom() {
	        if (!this.refs.blacklistUnverified) return;
	        if (this._isRoomBlacklistUnverified() !== this.refs.blacklistUnverified.checked) {
	            this._setRoomBlacklistUnverified(this.refs.blacklistUnverified.checked);
	        }
	    },
	
	    _isRoomBlacklistUnverified: function _isRoomBlacklistUnverified() {
	        var blacklistUnverifiedDevicesPerRoom = _UserSettingsStore2.default.getLocalSettings().blacklistUnverifiedDevicesPerRoom;
	        if (blacklistUnverifiedDevicesPerRoom) {
	            return blacklistUnverifiedDevicesPerRoom[this.props.room.roomId];
	        }
	        return false;
	    },
	
	    _setRoomBlacklistUnverified: function _setRoomBlacklistUnverified(value) {
	        var blacklistUnverifiedDevicesPerRoom = _UserSettingsStore2.default.getLocalSettings().blacklistUnverifiedDevicesPerRoom || {};
	        blacklistUnverifiedDevicesPerRoom[this.props.room.roomId] = value;
	        _UserSettingsStore2.default.setLocalSetting('blacklistUnverifiedDevicesPerRoom', blacklistUnverifiedDevicesPerRoom);
	
	        this.props.room.setBlacklistUnverifiedDevices(value);
	    },
	
	    _hasDiff: function _hasDiff(strA, strB) {
	        // treat undefined as an empty string because other components may blindly
	        // call setName("") when there has been no diff made to the name!
	        strA = strA || "";
	        strB = strB || "";
	        return strA !== strB;
	    },
	
	    _getPowerLevels: function _getPowerLevels() {
	        if (!this.state.power_levels_changed) return undefined;
	
	        var powerLevels = this.props.room.currentState.getStateEvents('m.room.power_levels', '');
	        powerLevels = powerLevels ? powerLevels.getContent() : {};
	
	        var newPowerLevels = {
	            ban: parseInt(this.refs.ban.getValue()),
	            kick: parseInt(this.refs.kick.getValue()),
	            redact: parseInt(this.refs.redact.getValue()),
	            invite: parseInt(this.refs.invite.getValue()),
	            events_default: parseInt(this.refs.events_default.getValue()),
	            state_default: parseInt(this.refs.state_default.getValue()),
	            users_default: parseInt(this.refs.users_default.getValue()),
	            users: powerLevels.users,
	            events: powerLevels.events
	        };
	
	        return newPowerLevels;
	    },
	
	    onPowerLevelsChanged: function onPowerLevelsChanged() {
	        this.setState({
	            power_levels_changed: true
	        });
	    },
	
	    _yankValueFromEvent: function _yankValueFromEvent(stateEventType, keyName, defaultValue) {
	        // E.g.("m.room.name","name") would yank the "name" content key from "m.room.name"
	        var event = this.props.room.currentState.getStateEvents(stateEventType, '');
	        if (!event) {
	            return defaultValue;
	        }
	        return event.getContent()[keyName] || defaultValue;
	    },
	
	    _onHistoryRadioToggle: function _onHistoryRadioToggle(ev) {
	        var self = this;
	        var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
	
	        // cancel the click unless the user confirms it
	        ev.preventDefault();
	        var value = ev.target.value;
	
	        _Modal2.default.createDialog(QuestionDialog, {
	            title: "Privacy warning",
	            description: _react2.default.createElement(
	                'div',
	                null,
	                'Changes to who can read history will only apply to future messages in this room.',
	                _react2.default.createElement('br', null),
	                'The visibility of existing history will be unchanged.'
	            ),
	            button: "Continue",
	            onFinished: function onFinished(confirmed) {
	                if (confirmed) {
	                    self.setState({
	                        history_visibility: value
	                    });
	                }
	            }
	        });
	    },
	
	    _onRoomAccessRadioToggle: function _onRoomAccessRadioToggle(ev) {
	
	        //                         join_rule
	        //                      INVITE  |  PUBLIC
	        //        ----------------------+----------------
	        // guest  CAN_JOIN   | inv_only | pub_with_guest
	        // access ----------------------+----------------
	        //        FORBIDDEN  | inv_only | pub_no_guest
	        //        ----------------------+----------------
	
	        switch (ev.target.value) {
	            case "invite_only":
	                this.setState({
	                    join_rule: "invite",
	                    // we always set guests can_join here as it makes no sense to have
	                    // an invite-only room that guests can't join.  If you explicitly
	                    // invite them, you clearly want them to join, whether they're a
	                    // guest or not.  In practice, guest_access should probably have
	                    // been implemented as part of the join_rules enum.
	                    guest_access: "can_join"
	                });
	                break;
	            case "public_no_guests":
	                this.setState({
	                    join_rule: "public",
	                    guest_access: "forbidden"
	                });
	                break;
	            case "public_with_guests":
	                this.setState({
	                    join_rule: "public",
	                    guest_access: "can_join"
	                });
	                break;
	        }
	    },
	
	    _onToggle: function _onToggle(keyName, checkedValue, uncheckedValue, ev) {
	        console.log("Checkbox toggle: %s %s", keyName, ev.target.checked);
	        var state = {};
	        state[keyName] = ev.target.checked ? checkedValue : uncheckedValue;
	        this.setState(state);
	    },
	
	    _onTagChange: function _onTagChange(tagName, event) {
	        if (event.target.checked) {
	            if (tagName === 'm.favourite') {
	                delete this.state.tags['m.lowpriority'];
	            } else if (tagName === 'm.lowpriority') {
	                delete this.state.tags['m.favourite'];
	            }
	
	            this.state.tags[tagName] = this.state.tags[tagName] || ["yep"];
	        } else {
	            delete this.state.tags[tagName];
	        }
	
	        this.setState({
	            tags: this.state.tags,
	            tags_changed: true
	        });
	    },
	
	    mayChangeRoomAccess: function mayChangeRoomAccess() {
	        var cli = _MatrixClientPeg2.default.get();
	        var roomState = this.props.room.currentState;
	        return roomState.mayClientSendStateEvent("m.room.join_rules", cli) && roomState.mayClientSendStateEvent("m.room.guest_access", cli);
	    },
	
	    onManageIntegrations: function onManageIntegrations(ev) {
	        var _this4 = this;
	
	        ev.preventDefault();
	        var IntegrationsManager = _index2.default.getComponent("views.settings.IntegrationsManager");
	        _Modal2.default.createDialog(IntegrationsManager, {
	            src: this.scalarClient.hasCredentials() ? this.scalarClient.getScalarInterfaceUrlForRoom(this.props.room.roomId) : null,
	            onFinished: function onFinished() {
	                if (_this4._calcSavePromises().length === 0) {
	                    _this4.props.onCancelClick(ev);
	                }
	            }
	        }, "mx_IntegrationsManager");
	    },
	    onShowIntegrationsError: function onShowIntegrationsError(ev) {
	        ev.preventDefault();
	        this.setState({
	            showIntegrationsError: !this.state.showIntegrationsError
	        });
	    },
	    onLeaveClick: function onLeaveClick() {
	        _dispatcher2.default.dispatch({
	            action: 'leave_room',
	            room_id: this.props.room.roomId
	        });
	    },
	    onForgetClick: function onForgetClick() {
	        // FIXME: duplicated with RoomTagContextualMenu (and dead code in RoomView)
	        _MatrixClientPeg2.default.get().forget(this.props.room.roomId).done(function () {
	            _dispatcher2.default.dispatch({ action: 'view_next_room' });
	        }, function (err) {
	            var errCode = err.errcode || "unknown error code";
	            var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	            _Modal2.default.createDialog(ErrorDialog, {
	                title: "Error",
	                description: 'Failed to forget room (' + errCode + ')'
	            });
	        });
	    },
	    onEnableEncryptionClick: function onEnableEncryptionClick() {
	        var _this5 = this;
	
	        if (!this.refs.encrypt.checked) return;
	
	        var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
	        _Modal2.default.createDialog(QuestionDialog, {
	            title: "Warning!",
	            description: _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'End-to-end encryption is in beta and may not be reliable.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'You should ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'not'
	                    ),
	                    ' yet trust it to secure data.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Devices will ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'not'
	                    ),
	                    ' yet be able to decrypt history from before they joined the room.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Once encryption is enabled for a room it ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'cannot'
	                    ),
	                    ' be turned off again (for now).'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Encrypted messages will not be visible on clients that do not yet implement encryption.'
	                )
	            ),
	            onFinished: function onFinished(confirm) {
	                if (!confirm) {
	                    _this5.refs.encrypt.checked = false;
	                }
	            }
	        });
	    },
	
	
	    _onRoomMemberMembership: function _onRoomMemberMembership() {
	        // Update, since our banned user list may have changed
	        this.forceUpdate();
	    },
	
	    _renderEncryptionSection: function _renderEncryptionSection() {
	        var cli = _MatrixClientPeg2.default.get();
	        var roomState = this.props.room.currentState;
	        var isEncrypted = cli.isRoomEncrypted(this.props.room.roomId);
	        var isGlobalBlacklistUnverified = _UserSettingsStore2.default.getLocalSettings().blacklistUnverifiedDevices;
	        var isRoomBlacklistUnverified = this._isRoomBlacklistUnverified();
	
	        var settings = _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', ref: 'blacklistUnverified',
	                defaultChecked: isGlobalBlacklistUnverified || isRoomBlacklistUnverified,
	                disabled: isGlobalBlacklistUnverified || this.refs.encrypt && !this.refs.encrypt.checked }),
	            'Never send encrypted messages to unverified devices in this room from this device.'
	        );
	
	        if (!isEncrypted && roomState.mayClientSendStateEvent("m.room.encryption", cli)) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('input', { type: 'checkbox', ref: 'encrypt', onClick: this.onEnableEncryptionClick }),
	                    _react2.default.createElement('img', { className: 'mx_RoomSettings_e2eIcon', src: 'img/e2e-unencrypted.svg', width: '12', height: '12' }),
	                    'Enable encryption (warning: cannot be disabled again!)'
	                ),
	                settings
	            );
	        } else {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    isEncrypted ? _react2.default.createElement('img', { className: 'mx_RoomSettings_e2eIcon', src: 'img/e2e-verified.svg', width: '10', height: '12' }) : _react2.default.createElement('img', { className: 'mx_RoomSettings_e2eIcon', src: 'img/e2e-unencrypted.svg', width: '12', height: '12' }),
	                    'Encryption is ',
	                    isEncrypted ? "" : "not ",
	                    ' enabled in this room.'
	                ),
	                settings
	            );
	        }
	    },
	
	    render: function render() {
	        var _this6 = this;
	
	        // TODO: go through greying out things you don't have permission to change
	        // (or turning them into informative stuff)
	
	        var AliasSettings = _index2.default.getComponent("room_settings.AliasSettings");
	        var ColorSettings = _index2.default.getComponent("room_settings.ColorSettings");
	        var UrlPreviewSettings = _index2.default.getComponent("room_settings.UrlPreviewSettings");
	        var EditableText = _index2.default.getComponent('elements.EditableText');
	        var PowerSelector = _index2.default.getComponent('elements.PowerSelector');
	        var Loader = _index2.default.getComponent("elements.Spinner");
	
	        var cli = _MatrixClientPeg2.default.get();
	        var roomState = this.props.room.currentState;
	        var user_id = cli.credentials.userId;
	
	        var power_level_event = roomState.getStateEvents('m.room.power_levels', '');
	        var power_levels = power_level_event ? power_level_event.getContent() : {};
	        var events_levels = power_levels.events || {};
	        var user_levels = power_levels.users || {};
	
	        var ban_level = parseIntWithDefault(power_levels.ban, 50);
	        var kick_level = parseIntWithDefault(power_levels.kick, 50);
	        var redact_level = parseIntWithDefault(power_levels.redact, 50);
	        var invite_level = parseIntWithDefault(power_levels.invite, 50);
	        var send_level = parseIntWithDefault(power_levels.events_default, 0);
	        var state_level = power_level_event ? parseIntWithDefault(power_levels.state_default, 50) : 0;
	        var default_user_level = parseIntWithDefault(power_levels.users_default, 0);
	
	        var current_user_level = user_levels[user_id];
	        if (current_user_level === undefined) {
	            current_user_level = default_user_level;
	        }
	
	        var can_change_levels = roomState.mayClientSendStateEvent("m.room.power_levels", cli);
	
	        var canSetTag = !cli.isGuest();
	
	        var self = this;
	
	        var userLevelsSection;
	        if ((0, _keys2.default)(user_levels).length) {
	            userLevelsSection = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Privileged Users'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'mx_RoomSettings_userLevels' },
	                    (0, _keys2.default)(user_levels).map(function (user, i) {
	                        return _react2.default.createElement(
	                            'li',
	                            { className: 'mx_RoomSettings_userLevel', key: user },
	                            user,
	                            ' is a ',
	                            _react2.default.createElement(PowerSelector, { value: user_levels[user], disabled: true })
	                        );
	                    })
	                )
	            );
	        } else {
	            userLevelsSection = _react2.default.createElement(
	                'div',
	                null,
	                'No users have specific privileges in this room.'
	            );
	        }
	
	        var banned = this.props.room.getMembersWithMembership("ban");
	        var bannedUsersSection;
	        if (banned.length) {
	            bannedUsersSection = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Banned users'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'mx_RoomSettings_banned' },
	                    banned.map(function (member) {
	                        return _react2.default.createElement(BannedUser, { key: member.userId, member: member });
	                    })
	                )
	            );
	        }
	
	        var unfederatableSection;
	        if (this._yankValueFromEvent("m.room.create", "m.federate") === false) {
	            unfederatableSection = _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_powerLevel' },
	                'Ths room is not accessible by remote Matrix servers.'
	            );
	        }
	
	        var leaveButton = null;
	        var myMember = this.props.room.getMember(user_id);
	        if (myMember) {
	            if (myMember.membership === "join") {
	                leaveButton = _react2.default.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_RoomSettings_leaveButton', onClick: this.onLeaveClick },
	                    'Leave room'
	                );
	            } else if (myMember.membership === "leave") {
	                leaveButton = _react2.default.createElement(
	                    _AccessibleButton2.default,
	                    { className: 'mx_RoomSettings_leaveButton', onClick: this.onForgetClick },
	                    'Forget room'
	                );
	            }
	        }
	
	        // TODO: support editing custom events_levels
	        // TODO: support editing custom user_levels
	
	        var tags = [{ name: "m.favourite", label: "Favourite", ref: "tag_favourite" }, { name: "m.lowpriority", label: "Low priority", ref: "tag_lowpriority" }];
	
	        (0, _keys2.default)(this.state.tags).sort().forEach(function (tagName) {
	            if (tagName !== 'm.favourite' && tagName !== 'm.lowpriority') {
	                tags.push({ name: tagName, label: tagName });
	            }
	        });
	
	        var tagsSection = null;
	        if (canSetTag || self.state.tags) {
	            var tagsSection = _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_tags' },
	                'Tagged as: ',
	                canSetTag ? tags.map(function (tag, i) {
	                    return _react2.default.createElement(
	                        'label',
	                        { key: i },
	                        _react2.default.createElement('input', { type: 'checkbox',
	                            ref: tag.ref,
	                            checked: tag.name in self.state.tags,
	                            onChange: self._onTagChange.bind(self, tag.name) }),
	                        tag.label
	                    );
	                }) : self.state.tags && self.state.tags.join ? self.state.tags.join(", ") : ""
	            );
	        }
	
	        // If there is no history_visibility, it is assumed to be 'shared'.
	        // http://matrix.org/docs/spec/r0.0.0/client_server.html#id31
	        var historyVisibility = this.state.history_visibility || "shared";
	
	        var addressWarning;
	        var aliasEvents = this.props.room.currentState.getStateEvents('m.room.aliases') || [];
	        var aliasCount = 0;
	        aliasEvents.forEach(function (event) {
	            aliasCount += event.getContent().aliases.length;
	        });
	
	        if (this.state.join_rule === "public" && aliasCount == 0) {
	            addressWarning = _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_warning' },
	                'To link to a room it must have ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#addresses' },
	                    'an address'
	                ),
	                '.'
	            );
	        }
	
	        var inviteGuestWarning;
	        if (this.state.join_rule !== "public" && this.state.guest_access === "forbidden") {
	            inviteGuestWarning = _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_warning' },
	                'Guests cannot join this room even if explicitly invited. ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: function onClick(e) {
	                            _this6.setState({ join_rule: "invite", guest_access: "can_join" });
	                            e.preventDefault();
	                        } },
	                    'Click here to fix'
	                ),
	                '.'
	            );
	        }
	
	        var integrationsButton;
	        var integrationsError;
	        if (this.state.showIntegrationsError && this.state.scalar_error) {
	            console.error(this.state.scalar_error);
	            integrationsError = _react2.default.createElement(
	                'span',
	                { className: 'mx_RoomSettings_integrationsButton_errorPopup' },
	                'Could not connect to the integration server'
	            );
	        }
	
	        if (this.scalarClient.hasCredentials()) {
	            integrationsButton = _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_integrationsButton', onClick: this.onManageIntegrations },
	                'Manage Integrations'
	            );
	        } else if (this.state.scalar_error) {
	            integrationsButton = _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_integrationsButton_error', onClick: this.onShowIntegrationsError },
	                'Integrations Error ',
	                _react2.default.createElement('img', { src: 'img/warning.svg', width: '17' }),
	                integrationsError
	            );
	        } else {
	            integrationsButton = _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_integrationsButton', style: { opacity: 0.5 } },
	                'Manage Integrations'
	            );
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'mx_RoomSettings' },
	            leaveButton,
	            integrationsButton,
	            tagsSection,
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_toggles' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_settings' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Who can access this room?'
	                    ),
	                    inviteGuestWarning,
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'radio', name: 'roomVis', value: 'invite_only',
	                            disabled: !this.mayChangeRoomAccess(),
	                            onChange: this._onRoomAccessRadioToggle,
	                            checked: this.state.join_rule !== "public" }),
	                        'Only people who have been invited'
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'radio', name: 'roomVis', value: 'public_no_guests',
	                            disabled: !this.mayChangeRoomAccess(),
	                            onChange: this._onRoomAccessRadioToggle,
	                            checked: this.state.join_rule === "public" && this.state.guest_access !== "can_join" }),
	                        'Anyone who knows the room\'s link, apart from guests'
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'radio', name: 'roomVis', value: 'public_with_guests',
	                            disabled: !this.mayChangeRoomAccess(),
	                            onChange: this._onRoomAccessRadioToggle,
	                            checked: this.state.join_rule === "public" && this.state.guest_access === "can_join" }),
	                        'Anyone who knows the room\'s link, including guests'
	                    ),
	                    addressWarning,
	                    _react2.default.createElement('br', null),
	                    this._renderEncryptionSection(),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'checkbox', disabled: !roomState.mayClientSendStateEvent("m.room.aliases", cli),
	                            onChange: this._onToggle.bind(this, "isRoomPublished", true, false),
	                            checked: this.state.isRoomPublished }),
	                        'List this room in ',
	                        _MatrixClientPeg2.default.get().getDomain(),
	                        '\'s room directory?'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_settings' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Who can read history?'
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'radio', name: 'historyVis', value: 'world_readable',
	                            disabled: !roomState.mayClientSendStateEvent("m.room.history_visibility", cli),
	                            checked: historyVisibility === "world_readable",
	                            onChange: this._onHistoryRadioToggle }),
	                        'Anyone'
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'radio', name: 'historyVis', value: 'shared',
	                            disabled: !roomState.mayClientSendStateEvent("m.room.history_visibility", cli),
	                            checked: historyVisibility === "shared",
	                            onChange: this._onHistoryRadioToggle }),
	                        'Members only (since the point in time of selecting this option)'
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'radio', name: 'historyVis', value: 'invited',
	                            disabled: !roomState.mayClientSendStateEvent("m.room.history_visibility", cli),
	                            checked: historyVisibility === "invited",
	                            onChange: this._onHistoryRadioToggle }),
	                        'Members only (since they were invited)'
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', { type: 'radio', name: 'historyVis', value: 'joined',
	                            disabled: !roomState.mayClientSendStateEvent("m.room.history_visibility", cli),
	                            checked: historyVisibility === "joined",
	                            onChange: this._onHistoryRadioToggle }),
	                        'Members only (since they joined)'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Room Colour'
	                ),
	                _react2.default.createElement(ColorSettings, { ref: 'color_settings', room: this.props.room })
	            ),
	            _react2.default.createElement('a', { id: 'addresses' }),
	            _react2.default.createElement(AliasSettings, { ref: 'alias_settings',
	                roomId: this.props.room.roomId,
	                canSetCanonicalAlias: roomState.mayClientSendStateEvent("m.room.canonical_alias", cli),
	                canSetAliases: true
	                /* Originally, we arbitrarily restricted creating aliases to room admins: roomState.mayClientSendStateEvent("m.room.aliases", cli) */
	                ,
	                canonicalAliasEvent: this.props.room.currentState.getStateEvents('m.room.canonical_alias', ''),
	                aliasEvents: this.props.room.currentState.getStateEvents('m.room.aliases') }),
	            _react2.default.createElement(UrlPreviewSettings, { ref: 'url_preview_settings', room: this.props.room }),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Permissions'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_powerLevels mx_RoomSettings_settings' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_powerLevel' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_RoomSettings_powerLevelKey' },
	                        'The default role for new room members is '
	                    ),
	                    _react2.default.createElement(PowerSelector, { ref: 'users_default', value: default_user_level, controlled: false, disabled: !can_change_levels || current_user_level < default_user_level, onChange: this.onPowerLevelsChanged })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_powerLevel' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_RoomSettings_powerLevelKey' },
	                        'To send messages, you must be a '
	                    ),
	                    _react2.default.createElement(PowerSelector, { ref: 'events_default', value: send_level, controlled: false, disabled: !can_change_levels || current_user_level < send_level, onChange: this.onPowerLevelsChanged })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_powerLevel' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_RoomSettings_powerLevelKey' },
	                        'To invite users into the room, you must be a '
	                    ),
	                    _react2.default.createElement(PowerSelector, { ref: 'invite', value: invite_level, controlled: false, disabled: !can_change_levels || current_user_level < invite_level, onChange: this.onPowerLevelsChanged })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_powerLevel' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_RoomSettings_powerLevelKey' },
	                        'To configure the room, you must be a '
	                    ),
	                    _react2.default.createElement(PowerSelector, { ref: 'state_default', value: state_level, controlled: false, disabled: !can_change_levels || current_user_level < state_level, onChange: this.onPowerLevelsChanged })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_powerLevel' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_RoomSettings_powerLevelKey' },
	                        'To kick users, you must be a '
	                    ),
	                    _react2.default.createElement(PowerSelector, { ref: 'kick', value: kick_level, controlled: false, disabled: !can_change_levels || current_user_level < kick_level, onChange: this.onPowerLevelsChanged })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_powerLevel' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_RoomSettings_powerLevelKey' },
	                        'To ban users, you must be a '
	                    ),
	                    _react2.default.createElement(PowerSelector, { ref: 'ban', value: ban_level, controlled: false, disabled: !can_change_levels || current_user_level < ban_level, onChange: this.onPowerLevelsChanged })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_RoomSettings_powerLevel' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'mx_RoomSettings_powerLevelKey' },
	                        'To redact messages, you must be a '
	                    ),
	                    _react2.default.createElement(PowerSelector, { ref: 'redact', value: redact_level, controlled: false, disabled: !can_change_levels || current_user_level < redact_level, onChange: this.onPowerLevelsChanged })
	                ),
	                (0, _keys2.default)(events_levels).map(function (event_type, i) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'mx_RoomSettings_powerLevel', key: event_type },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'mx_RoomSettings_powerLevelKey' },
	                            'To send events of type ',
	                            _react2.default.createElement(
	                                'code',
	                                null,
	                                event_type
	                            ),
	                            ', you must be a '
	                        ),
	                        _react2.default.createElement(PowerSelector, { value: events_levels[event_type], controlled: false, disabled: true, onChange: self.onPowerLevelsChanged })
	                    );
	                }),
	                unfederatableSection
	            ),
	            userLevelsSection,
	            bannedUsersSection,
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Advanced'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_RoomSettings_settings' },
	                'This room\'s internal ID is ',
	                _react2.default.createElement(
	                    'code',
	                    null,
	                    this.props.room.roomId
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'RoomTopicEditor',
	
	    propTypes: {
	        room: React.PropTypes.object.isRequired
	    },
	
	    componentWillMount: function componentWillMount() {
	        var room = this.props.room;
	        var topic = room.currentState.getStateEvents('m.room.topic', '');
	        this._initialTopic = topic ? topic.getContent().topic : '';
	    },
	
	    getTopic: function getTopic() {
	        return this.refs.editor.getValue();
	    },
	
	    render: function render() {
	        var EditableText = sdk.getComponent("elements.EditableText");
	
	        return React.createElement(EditableText, { ref: 'editor',
	            className: 'mx_RoomHeader_topic mx_RoomHeader_editable',
	            placeholderClassName: 'mx_RoomHeader_placeholder',
	            placeholder: 'Add a topic',
	            blurToCancel: false,
	            initialValue: this._initialTopic });
	    }
	});


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'SearchResult',
	
	    propTypes: {
	        // a matrix-js-sdk SearchResult containing the details of this result
	        searchResult: React.PropTypes.object.isRequired,
	
	        // a list of strings to be highlighted in the results
	        searchHighlights: React.PropTypes.array,
	
	        // href for the highlights in this result
	        resultLink: React.PropTypes.string,
	
	        onWidgetLoad: React.PropTypes.func
	    },
	
	    render: function render() {
	        var DateSeparator = sdk.getComponent('messages.DateSeparator');
	        var EventTile = sdk.getComponent('rooms.EventTile');
	        var result = this.props.searchResult;
	        var mxEv = result.context.getEvent();
	        var eventId = mxEv.getId();
	
	        var ts1 = mxEv.getTs();
	        var ret = [React.createElement(DateSeparator, { key: ts1 + "-search", ts: ts1 })];
	
	        var timeline = result.context.getTimeline();
	        for (var j = 0; j < timeline.length; j++) {
	            var ev = timeline[j];
	            var highlights;
	            var contextual = j != result.context.getOurEventIndex();
	            if (!contextual) {
	                highlights = this.props.searchHighlights;
	            }
	            if (EventTile.haveTileForEvent(ev)) {
	                ret.push(React.createElement(EventTile, { key: eventId + "+" + j, mxEvent: ev, contextual: contextual, highlights: highlights,
	                    highlightLink: this.props.resultLink,
	                    onWidgetLoad: this.props.onWidgetLoad }));
	            }
	        }
	        return React.createElement(
	            'li',
	            { 'data-scroll-token': eventId + "+" + j },
	            ret
	        );
	    }
	});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	var GeminiScrollbar = __webpack_require__(121);
	
	// A list capable of displaying entities which conform to the SearchableEntity
	// interface which is an object containing getJsx(): Jsx and matches(query: string): boolean
	var SearchableEntityList = React.createClass({
	    displayName: 'SearchableEntityList',
	
	    propTypes: {
	        searchPlaceholderText: React.PropTypes.string,
	        emptyQueryShowsAll: React.PropTypes.bool,
	        showInputBox: React.PropTypes.bool,
	        onQueryChanged: React.PropTypes.func, // fn(inputText)
	        onSubmit: React.PropTypes.func, // fn(inputText)
	        entities: React.PropTypes.array,
	        truncateAt: React.PropTypes.number
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            showInputBox: true,
	            searchPlaceholderText: "Search",
	            entities: [],
	            emptyQueryShowsAll: false,
	            onSubmit: function onSubmit() {},
	            onQueryChanged: function onQueryChanged(input) {}
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            query: "",
	            focused: false,
	            truncateAt: this.props.truncateAt,
	            results: this.getSearchResults("", this.props.entities)
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        // recalculate the search results in case we got new entities
	        this.setState({
	            results: this.getSearchResults(this.state.query, newProps.entities)
	        });
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        // pretend the query box was blanked out else filters could still be
	        // applied to other components which rely on onQueryChanged.
	        this.props.onQueryChanged("");
	    },
	
	    /**
	     * Public-facing method to set the input query text to the given input.
	     * @param {string} input
	     */
	    setQuery: function setQuery(input) {
	        this.setState({
	            query: input,
	            results: this.getSearchResults(input, this.props.entities)
	        });
	    },
	
	    onQueryChanged: function onQueryChanged(ev) {
	        var _this = this;
	
	        var q = ev.target.value;
	        this.setState({
	            query: q,
	            // reset truncation if they back out the entire text
	            truncateAt: q.length === 0 ? this.props.truncateAt : this.state.truncateAt,
	            results: this.getSearchResults(q, this.props.entities)
	        }, function () {
	            // invoke the callback AFTER we've flushed the new state. We need to
	            // do this because onQueryChanged can result in new props being passed
	            // to this component, which will then try to recalculate the search
	            // list. If we do this without flushing, we'll recalc with the last
	            // search term and not the current one!
	            _this.props.onQueryChanged(q);
	        });
	    },
	
	    onQuerySubmit: function onQuerySubmit(ev) {
	        ev.preventDefault();
	        this.props.onSubmit(this.state.query);
	    },
	
	    getSearchResults: function getSearchResults(query, entities) {
	        if (!query || query.length === 0) {
	            return this.props.emptyQueryShowsAll ? entities : [];
	        }
	        return entities.filter(function (e) {
	            return e.matches(query);
	        });
	    },
	
	    _showAll: function _showAll() {
	        this.setState({
	            truncateAt: -1
	        });
	    },
	
	    _createOverflowEntity: function _createOverflowEntity(overflowCount, totalCount) {
	        var EntityTile = sdk.getComponent("rooms.EntityTile");
	        var BaseAvatar = sdk.getComponent("avatars.BaseAvatar");
	        var text = "and " + overflowCount + " other" + (overflowCount > 1 ? "s" : "") + "...";
	        return React.createElement(EntityTile, { className: "mx_EntityTile_ellipsis", avatarJsx: React.createElement(BaseAvatar, { url: "img/ellipsis.svg", name: "...", width: 36, height: 36 }), name: text, presenceState: "online", suppressOnHover: true,
	            onClick: this._showAll });
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var inputBox;
	
	        if (this.props.showInputBox) {
	            inputBox = React.createElement(
	                "form",
	                { onSubmit: this.onQuerySubmit, autoComplete: "off" },
	                React.createElement("input", { className: "mx_SearchableEntityList_query", id: "mx_SearchableEntityList_query", type: "text",
	                    onChange: this.onQueryChanged, value: this.state.query,
	                    onFocus: function onFocus() {
	                        _this2.setState({ focused: true });
	                    },
	                    onBlur: function onBlur() {
	                        _this2.setState({ focused: false });
	                    },
	                    placeholder: this.props.searchPlaceholderText })
	            );
	        }
	
	        var list;
	        if (this.state.results.length > 1 || this.state.focused) {
	            if (this.props.truncateAt) {
	                // caller wants list truncated
	                var TruncatedList = sdk.getComponent("elements.TruncatedList");
	                list = React.createElement(
	                    TruncatedList,
	                    { className: "mx_SearchableEntityList_list",
	                        truncateAt: this.state.truncateAt // use state truncation as it may be expanded
	                        , createOverflowElement: this._createOverflowEntity },
	                    this.state.results.map(function (entity) {
	                        return entity.getJsx();
	                    })
	                );
	            } else {
	                list = React.createElement(
	                    "div",
	                    { className: "mx_SearchableEntityList_list" },
	                    this.state.results.map(function (entity) {
	                        return entity.getJsx();
	                    })
	                );
	            }
	            list = React.createElement(
	                GeminiScrollbar,
	                { autoshow: true,
	                    className: "mx_SearchableEntityList_listWrapper" },
	                list
	            );
	        }
	
	        return React.createElement(
	            "div",
	            { className: "mx_SearchableEntityList " + (list ? "mx_SearchableEntityList_expanded" : "") },
	            inputBox,
	            list,
	            list ? React.createElement(
	                "div",
	                { className: "mx_SearchableEntityList_hrWrapper" },
	                React.createElement("hr", null)
	            ) : ''
	        );
	    }
	});
	
	module.exports = SearchableEntityList;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var CommandEntry = __webpack_require__(330).CommandEntry;
	
	module.exports = React.createClass({
	    displayName: 'TabCompleteBar',
	
	    propTypes: {
	        tabComplete: React.PropTypes.object.isRequired
	    },
	
	    render: function render() {
	        var _this = this;
	
	        return React.createElement(
	            'div',
	            { className: 'mx_TabCompleteBar' },
	            this.props.tabComplete.peek(6).map(function (entry, i) {
	                return React.createElement(
	                    'div',
	                    { key: entry.getKey() || i + "",
	                        className: "mx_TabCompleteBar_item " + (entry instanceof CommandEntry ? "mx_TabCompleteBar_command" : ""),
	                        onClick: _this.props.tabComplete.onEntryClick.bind(_this.props.tabComplete, entry) },
	                    entry.getImageJsx(),
	                    React.createElement(
	                        'span',
	                        { className: 'mx_TabCompleteBar_text' },
	                        entry.getText()
	                    )
	                );
	            })
	        );
	    }
	});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'TopUnreadMessagesBar',
	
	    propTypes: {
	        onScrollUpClick: React.PropTypes.func,
	        onCloseClick: React.PropTypes.func
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_TopUnreadMessagesBar' },
	            React.createElement(
	                'div',
	                { className: 'mx_TopUnreadMessagesBar_scrollUp',
	                    onClick: this.props.onScrollUpClick },
	                'Jump to first unread message. ',
	                React.createElement(
	                    'span',
	                    { style: { textDecoration: 'underline' }, onClick: this.props.onCloseClick },
	                    'Mark all read'
	                )
	            ),
	            React.createElement('img', { className: 'mx_TopUnreadMessagesBar_close',
	                src: 'img/cancel.svg', width: '18', height: '18',
	                alt: 'Close', title: 'Close',
	                onClick: this.props.onCloseClick })
	        );
	    }
	});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _extends2 = __webpack_require__(44);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	var Avatar = __webpack_require__(138);
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	
	module.exports = React.createClass({
	    displayName: 'UserTile',
	
	    propTypes: {
	        user: React.PropTypes.any.isRequired // User
	    },
	
	    render: function render() {
	        var EntityTile = sdk.getComponent("rooms.EntityTile");
	        var user = this.props.user;
	        var name = user.displayName || user.userId;
	        var active = -1;
	
	        // FIXME: make presence data update whenever User.presence changes...
	        active = user.lastActiveAgo ? Date.now() - (user.lastPresenceTs - user.lastActiveAgo) : -1;
	
	        var BaseAvatar = sdk.getComponent('avatars.BaseAvatar');
	        var avatarJsx = React.createElement(BaseAvatar, { width: 36, height: 36, name: name, idName: user.userId,
	            url: Avatar.avatarUrlForUser(user, 36, 36, "crop") });
	
	        return React.createElement(EntityTile, (0, _extends3.default)({}, this.props, { presenceState: user.presence, presenceActiveAgo: active,
	            presenceCurrentlyActive: user.currentlyActive,
	            name: name, title: user.userId, avatarJsx: avatarJsx }));
	    }
	});


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _AddThreepid = __webpack_require__(496);
	
	var _AddThreepid2 = _interopRequireDefault(_AddThreepid);
	
	var _WithMatrixClient = __webpack_require__(337);
	
	var _WithMatrixClient2 = _interopRequireDefault(_WithMatrixClient);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _WithMatrixClient2.default)(_react2.default.createClass({
	    displayName: 'AddPhoneNumber',
	
	    propTypes: {
	        matrixClient: _react2.default.PropTypes.object.isRequired,
	        onThreepidAdded: _react2.default.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            busy: false,
	            phoneCountry: null,
	            phoneNumber: "",
	            msisdn_add_pending: false
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this._addThreepid = null;
	        this._addMsisdnInput = null;
	        this._unmounted = false;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        this._unmounted = true;
	    },
	
	    _onPhoneCountryChange: function _onPhoneCountryChange(phoneCountry) {
	        this.setState({ phoneCountry: phoneCountry });
	    },
	
	    _onPhoneNumberChange: function _onPhoneNumberChange(ev) {
	        this.setState({ phoneNumber: ev.target.value });
	    },
	
	    _onAddMsisdnEditFinished: function _onAddMsisdnEditFinished(value, shouldSubmit) {
	        if (!shouldSubmit) return;
	        this._addMsisdn();
	    },
	
	    _onAddMsisdnSubmit: function _onAddMsisdnSubmit(ev) {
	        ev.preventDefault();
	        this._addMsisdn();
	    },
	
	    _collectAddMsisdnInput: function _collectAddMsisdnInput(e) {
	        this._addMsisdnInput = e;
	    },
	
	    _addMsisdn: function _addMsisdn() {
	        var _this = this;
	
	        var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
	
	        this._addThreepid = new _AddThreepid2.default();
	        // we always bind phone numbers when registering, so let's do the
	        // same here.
	        this._addThreepid.addMsisdn(this.state.phoneCountry, this.state.phoneNumber, true).then(function (resp) {
	            _this._promptForMsisdnVerificationCode(resp.msisdn);
	        }).catch(function (err) {
	            console.error("Unable to add phone number: " + err);
	            var msg = err.message;
	            _Modal2.default.createDialog(ErrorDialog, {
	                title: "Error",
	                description: msg
	            });
	        }).finally(function () {
	            if (_this._unmounted) return;
	            _this.setState({ msisdn_add_pending: false });
	        }).done();
	        this._addMsisdnInput.blur();
	        this.setState({ msisdn_add_pending: true });
	    },
	
	    _promptForMsisdnVerificationCode: function _promptForMsisdnVerificationCode(msisdn, err) {
	        var _this2 = this;
	
	        if (this._unmounted) return;
	        var TextInputDialog = _index2.default.getComponent("dialogs.TextInputDialog");
	        var msgElements = [_react2.default.createElement(
	            'div',
	            { key: '_static' },
	            'A text message has been sent to +',
	            msisdn,
	            '. Please enter the verification code it contains'
	        )];
	        if (err) {
	            var msg = err.error;
	            if (err.errcode == 'M_THREEPID_AUTH_FAILED') {
	                msg = "Incorrect verification code";
	            }
	            msgElements.push(_react2.default.createElement(
	                'div',
	                { key: '_error', className: 'error' },
	                msg
	            ));
	        }
	        _Modal2.default.createDialog(TextInputDialog, {
	            title: "Enter Code",
	            description: _react2.default.createElement(
	                'div',
	                null,
	                msgElements
	            ),
	            button: "Submit",
	            onFinished: function onFinished(should_verify, token) {
	                if (!should_verify) {
	                    _this2._addThreepid = null;
	                    return;
	                }
	                if (_this2._unmounted) return;
	                _this2.setState({ msisdn_add_pending: true });
	                _this2._addThreepid.haveMsisdnToken(token).then(function () {
	                    _this2._addThreepid = null;
	                    _this2.setState({ phoneNumber: '' });
	                    if (_this2.props.onThreepidAdded) _this2.props.onThreepidAdded();
	                }).catch(function (err) {
	                    _this2._promptForMsisdnVerificationCode(msisdn, err);
	                }).finally(function () {
	                    if (_this2._unmounted) return;
	                    _this2.setState({ msisdn_add_pending: false });
	                }).done();
	            }
	        });
	    },
	
	    render: function render() {
	        var Loader = _index2.default.getComponent("elements.Spinner");
	        if (this.state.msisdn_add_pending) {
	            return _react2.default.createElement(Loader, null);
	        } else if (this.props.matrixClient.isGuest()) {
	            return _react2.default.createElement('div', null);
	        }
	
	        var CountryDropdown = _index2.default.getComponent('views.login.CountryDropdown');
	        // XXX: This CSS relies on the CSS surrounding it in UserSettings as its in
	        // a tabular format to align the submit buttons
	        return _react2.default.createElement(
	            'form',
	            { className: 'mx_UserSettings_profileTableRow', onSubmit: this._onAddMsisdnSubmit },
	            _react2.default.createElement('div', { className: 'mx_UserSettings_profileLabelCell' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_UserSettings_profileInputCell' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_Login_phoneSection' },
	                    _react2.default.createElement(CountryDropdown, { onOptionChange: this._onPhoneCountryChange,
	                        className: 'mx_Login_phoneCountry',
	                        value: this.state.phoneCountry
	                    }),
	                    _react2.default.createElement('input', { type: 'text',
	                        ref: this._collectAddMsisdnInput,
	                        className: 'mx_UserSettings_phoneNumberField',
	                        placeholder: 'Add phone number',
	                        value: this.state.phoneNumber,
	                        onChange: this._onPhoneNumberChange
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mx_UserSettings_threepidButton mx_filterFlipColor' },
	                _react2.default.createElement('input', { type: 'image', value: 'Add', src: 'img/plus.svg', width: '14', height: '14' })
	            )
	        );
	    }
	})); /*
	     Copyright 2017 Vector Creations Ltd
	     
	     Licensed under the Apache License, Version 2.0 (the "License");
	     you may not use this file except in compliance with the License.
	     You may obtain a copy of the License at
	     
	         http://www.apache.org/licenses/LICENSE-2.0
	     
	     Unless required by applicable law or agreed to in writing, software
	     distributed under the License is distributed on an "AS IS" BASIS,
	     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     See the License for the specific language governing permissions and
	     limitations under the License.
	     */

	module.exports = exports['default'];


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var sdk = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'ChangeAvatar',
	    propTypes: {
	        initialAvatarUrl: React.PropTypes.string,
	        room: React.PropTypes.object,
	        // if false, you need to call changeAvatar.onFileSelected yourself.
	        showUploadSection: React.PropTypes.bool,
	        width: React.PropTypes.number,
	        height: React.PropTypes.number,
	        className: React.PropTypes.string
	    },
	
	    Phases: {
	        Display: "display",
	        Uploading: "uploading",
	        Error: "error"
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            showUploadSection: true,
	            className: "",
	            width: 80,
	            height: 80
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            avatarUrl: this.props.initialAvatarUrl,
	            phase: this.Phases.Display
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        if (this.avatarSet) {
	            // don't clobber what the user has just set
	            return;
	        }
	        this.setState({
	            avatarUrl: newProps.initialAvatarUrl
	        });
	    },
	
	    setAvatarFromFile: function setAvatarFromFile(file) {
	        var newUrl = null;
	
	        this.setState({
	            phase: this.Phases.Uploading
	        });
	        var self = this;
	        var httpPromise = MatrixClientPeg.get().uploadContent(file).then(function (url) {
	            newUrl = url;
	            if (self.props.room) {
	                return MatrixClientPeg.get().sendStateEvent(self.props.room.roomId, 'm.room.avatar', { url: url }, '');
	            } else {
	                return MatrixClientPeg.get().setAvatarUrl(url);
	            }
	        });
	
	        httpPromise.done(function () {
	            self.setState({
	                phase: self.Phases.Display,
	                avatarUrl: MatrixClientPeg.get().mxcUrlToHttp(newUrl)
	            });
	        }, function (error) {
	            self.setState({
	                phase: self.Phases.Error
	            });
	            self.onError(error);
	        });
	
	        return httpPromise;
	    },
	
	    onFileSelected: function onFileSelected(ev) {
	        this.avatarSet = true;
	        return this.setAvatarFromFile(ev.target.files[0]);
	    },
	
	    onError: function onError(error) {
	        this.setState({
	            errorText: "Failed to upload profile picture!"
	        });
	    },
	
	    render: function render() {
	        var avatarImg;
	        // Having just set an avatar we just display that since it will take a little
	        // time to propagate through to the RoomAvatar.
	        if (this.props.room && !this.avatarSet) {
	            var RoomAvatar = sdk.getComponent('avatars.RoomAvatar');
	            avatarImg = React.createElement(RoomAvatar, { room: this.props.room, width: this.props.width, height: this.props.height, resizeMethod: 'crop' });
	        } else {
	            var BaseAvatar = sdk.getComponent("avatars.BaseAvatar");
	            // XXX: FIXME: once we track in the JS what our own displayname is(!) then use it here rather than ?
	            avatarImg = React.createElement(BaseAvatar, { width: this.props.width, height: this.props.height, resizeMethod: 'crop',
	                name: '?', idName: MatrixClientPeg.get().getUserIdLocalpart(), url: this.state.avatarUrl });
	        }
	
	        var uploadSection;
	        if (this.props.showUploadSection) {
	            uploadSection = React.createElement(
	                'div',
	                { className: this.props.className },
	                'Upload new:',
	                React.createElement('input', { type: 'file', accept: 'image/*', onChange: this.onFileSelected }),
	                this.state.errorText
	            );
	        }
	
	        switch (this.state.phase) {
	            case this.Phases.Display:
	            case this.Phases.Error:
	                return React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'div',
	                        { className: this.props.className },
	                        avatarImg
	                    ),
	                    uploadSection
	                );
	            case this.Phases.Uploading:
	                var Loader = sdk.getComponent("elements.Spinner");
	                return React.createElement(Loader, null);
	        }
	    }
	});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	
	module.exports = React.createClass({
	    displayName: 'ChangeDisplayName',
	
	    _getDisplayName: function _getDisplayName() {
	        var cli = MatrixClientPeg.get();
	        return cli.getProfileInfo(cli.credentials.userId).then(function (result) {
	            var displayname = result.displayname;
	            if (!displayname) {
	                if (MatrixClientPeg.get().isGuest()) {
	                    displayname = "Guest " + MatrixClientPeg.get().getUserIdLocalpart();
	                } else {
	                    displayname = MatrixClientPeg.get().getUserIdLocalpart();
	                }
	            }
	            return displayname;
	        }, function (error) {
	            throw new Error("Failed to fetch display name");
	        });
	    },
	
	    _changeDisplayName: function _changeDisplayName(new_displayname) {
	        var cli = MatrixClientPeg.get();
	        return cli.setDisplayName(new_displayname).catch(function (e) {
	            throw new Error("Failed to set display name");
	        });
	    },
	
	    render: function render() {
	        var EditableTextContainer = sdk.getComponent('elements.EditableTextContainer');
	        return React.createElement(EditableTextContainer, {
	            getInitialValue: this._getDisplayName,
	            placeholder: 'No display name',
	            blurToSubmit: true,
	            onSubmit: this._changeDisplayName });
	    }
	});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var _AccessibleButton = __webpack_require__(30);
	
	var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	var sdk = __webpack_require__(2);
	
	
	module.exports = React.createClass({
	    displayName: 'ChangePassword',
	    propTypes: {
	        onFinished: React.PropTypes.func,
	        onError: React.PropTypes.func,
	        onCheckPassword: React.PropTypes.func,
	        rowClassName: React.PropTypes.string,
	        rowLabelClassName: React.PropTypes.string,
	        rowInputClassName: React.PropTypes.string,
	        buttonClassName: React.PropTypes.string
	    },
	
	    Phases: {
	        Edit: "edit",
	        Uploading: "uploading",
	        Error: "error"
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onFinished: function onFinished() {},
	            onError: function onError() {},
	            onCheckPassword: function onCheckPassword(oldPass, newPass, confirmPass) {
	                if (newPass !== confirmPass) {
	                    return {
	                        error: "New passwords don't match."
	                    };
	                } else if (!newPass || newPass.length === 0) {
	                    return {
	                        error: "Passwords can't be empty"
	                    };
	                }
	            }
	        };
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            phase: this.Phases.Edit
	        };
	    },
	
	    changePassword: function changePassword(old_password, new_password) {
	        var _this = this;
	
	        var cli = MatrixClientPeg.get();
	
	        var QuestionDialog = sdk.getComponent("dialogs.QuestionDialog");
	        Modal.createDialog(QuestionDialog, {
	            title: "Warning",
	            description: React.createElement(
	                'div',
	                null,
	                'Changing password will currently reset any end-to-end encryption keys on all devices, making encrypted chat history unreadable, unless you first export your room keys and re-import them afterwards. In future this ',
	                React.createElement(
	                    'a',
	                    { href: 'https://github.com/vector-im/riot-web/issues/2671' },
	                    'will be improved'
	                ),
	                '.'
	            ),
	            button: "Continue",
	            extraButtons: [React.createElement(
	                'button',
	                { className: 'mx_Dialog_primary',
	                    onClick: this._onExportE2eKeysClicked },
	                'Export E2E room keys'
	            )],
	            onFinished: function onFinished(confirmed) {
	                if (confirmed) {
	                    var authDict = {
	                        type: 'm.login.password',
	                        user: cli.credentials.userId,
	                        password: old_password
	                    };
	
	                    _this.setState({
	                        phase: _this.Phases.Uploading
	                    });
	
	                    var self = _this;
	                    cli.setPassword(authDict, new_password).then(function () {
	                        self.props.onFinished();
	                    }, function (err) {
	                        self.props.onError(err);
	                    }).finally(function () {
	                        self.setState({
	                            phase: self.Phases.Edit
	                        });
	                    }).done();
	                }
	            }
	        });
	    },
	
	    _onExportE2eKeysClicked: function _onExportE2eKeysClicked() {
	        Modal.createDialogAsync(function (cb) {
	            __webpack_require__.e/* nsure */(0, function () {
	                cb(__webpack_require__(141));
	            });
	        }, {
	            matrixClient: MatrixClientPeg.get()
	        });
	    },
	
	    onClickChange: function onClickChange() {
	        var old_password = this.refs.old_input.value;
	        var new_password = this.refs.new_input.value;
	        var confirm_password = this.refs.confirm_input.value;
	        var err = this.props.onCheckPassword(old_password, new_password, confirm_password);
	        if (err) {
	            this.props.onError(err);
	        } else {
	            this.changePassword(old_password, new_password);
	        }
	    },
	
	    render: function render() {
	        var rowClassName = this.props.rowClassName;
	        var rowLabelClassName = this.props.rowLabelClassName;
	        var rowInputClassName = this.props.rowInputClassName;
	        var buttonClassName = this.props.buttonClassName;
	
	        switch (this.state.phase) {
	            case this.Phases.Edit:
	                return React.createElement(
	                    'div',
	                    { className: this.props.className },
	                    React.createElement(
	                        'div',
	                        { className: rowClassName },
	                        React.createElement(
	                            'div',
	                            { className: rowLabelClassName },
	                            React.createElement(
	                                'label',
	                                { htmlFor: 'passwordold' },
	                                'Current password'
	                            )
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: rowInputClassName },
	                            React.createElement('input', { id: 'passwordold', type: 'password', ref: 'old_input' })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: rowClassName },
	                        React.createElement(
	                            'div',
	                            { className: rowLabelClassName },
	                            React.createElement(
	                                'label',
	                                { htmlFor: 'password1' },
	                                'New password'
	                            )
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: rowInputClassName },
	                            React.createElement('input', { id: 'password1', type: 'password', ref: 'new_input' })
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: rowClassName },
	                        React.createElement(
	                            'div',
	                            { className: rowLabelClassName },
	                            React.createElement(
	                                'label',
	                                { htmlFor: 'password2' },
	                                'Confirm password'
	                            )
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: rowInputClassName },
	                            React.createElement('input', { id: 'password2', type: 'password', ref: 'confirm_input' })
	                        )
	                    ),
	                    React.createElement(
	                        _AccessibleButton2.default,
	                        { className: buttonClassName,
	                            onClick: this.onClickChange },
	                        'Change Password'
	                    )
	                );
	            case this.Phases.Uploading:
	                var Loader = sdk.getComponent("elements.Spinner");
	                return React.createElement(
	                    'div',
	                    { className: 'mx_Dialog_content' },
	                    React.createElement(Loader, null)
	                );
	        }
	    }
	});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var DevicesPanel = function (_React$Component) {
	    (0, _inherits3.default)(DevicesPanel, _React$Component);
	
	    function DevicesPanel(props, context) {
	        (0, _classCallCheck3.default)(this, DevicesPanel);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DevicesPanel.__proto__ || (0, _getPrototypeOf2.default)(DevicesPanel)).call(this, props, context));
	
	        _this.state = {
	            devices: undefined,
	            deviceLoadError: undefined
	        };
	
	        _this._unmounted = false;
	
	        _this._renderDevice = _this._renderDevice.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(DevicesPanel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._loadDevices();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this._unmounted = true;
	        }
	    }, {
	        key: '_loadDevices',
	        value: function _loadDevices() {
	            var _this2 = this;
	
	            _MatrixClientPeg2.default.get().getDevices().done(function (resp) {
	                if (_this2._unmounted) {
	                    return;
	                }
	                _this2.setState({ devices: resp.devices || [] });
	            }, function (error) {
	                if (_this2._unmounted) {
	                    return;
	                }
	                var errtxt;
	                if (error.httpStatus == 404) {
	                    // 404 probably means the HS doesn't yet support the API.
	                    errtxt = "Your home server does not support device management.";
	                } else {
	                    console.error("Error loading devices:", error);
	                    errtxt = "Unable to load device list.";
	                }
	                _this2.setState({ deviceLoadError: errtxt });
	            });
	        }
	
	        /**
	         * compare two devices, sorting from most-recently-seen to least-recently-seen
	         * (and then, for stability, by device id)
	         */
	
	    }, {
	        key: '_deviceCompare',
	        value: function _deviceCompare(a, b) {
	            // return < 0 if a comes before b, > 0 if a comes after b.
	            var lastSeenDelta = (b.last_seen_ts || 0) - (a.last_seen_ts || 0);
	
	            if (lastSeenDelta !== 0) {
	                return lastSeenDelta;
	            }
	
	            var idA = a.device_id;
	            var idB = b.device_id;
	            return idA < idB ? -1 : idA > idB ? 1 : 0;
	        }
	    }, {
	        key: '_onDeviceDeleted',
	        value: function _onDeviceDeleted(device) {
	            if (this._unmounted) {
	                return;
	            }
	
	            // delete the removed device from our list.
	            var removed_id = device.device_id;
	            this.setState(function (state, props) {
	                var newDevices = state.devices.filter(function (d) {
	                    return d.device_id != removed_id;
	                });
	                return { devices: newDevices };
	            });
	        }
	    }, {
	        key: '_renderDevice',
	        value: function _renderDevice(device) {
	            var _this3 = this;
	
	            var DevicesPanelEntry = _index2.default.getComponent('settings.DevicesPanelEntry');
	            return _react2.default.createElement(DevicesPanelEntry, { key: device.device_id, device: device,
	                onDeleted: function onDeleted() {
	                    _this3._onDeviceDeleted(device);
	                } });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Spinner = _index2.default.getComponent("elements.Spinner");
	
	            if (this.state.deviceLoadError !== undefined) {
	                var _classes = (0, _classnames2.default)(this.props.className, "error");
	                return _react2.default.createElement(
	                    'div',
	                    { className: _classes },
	                    this.state.deviceLoadError
	                );
	            }
	
	            var devices = this.state.devices;
	            if (devices === undefined) {
	                // still loading
	                var _classes2 = this.props.className;
	                return _react2.default.createElement(Spinner, { className: _classes2 });
	            }
	
	            devices.sort(this._deviceCompare);
	
	            var classes = (0, _classnames2.default)(this.props.className, "mx_DevicesPanel");
	            return _react2.default.createElement(
	                'div',
	                { className: classes },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_DevicesPanel_header' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_DevicesPanel_deviceId' },
	                        'ID'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_DevicesPanel_deviceName' },
	                        'Name'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mx_DevicesPanel_deviceLastSeen' },
	                        'Last seen'
	                    ),
	                    _react2.default.createElement('div', { className: 'mx_DevicesPanel_deviceButtons' })
	                ),
	                devices.map(this._renderDevice)
	            );
	        }
	    }]);
	    return DevicesPanel;
	}(_react2.default.Component);
	
	exports.default = DevicesPanel;
	
	
	DevicesPanel.displayName = 'MemberDeviceInfo';
	DevicesPanel.propTypes = {
	    className: _react2.default.PropTypes.string
	};
	module.exports = exports['default'];


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(15);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(20);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(19);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(2);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MatrixClientPeg = __webpack_require__(4);
	
	var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);
	
	var _Modal = __webpack_require__(10);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _DateUtils = __webpack_require__(326);
	
	var _DateUtils2 = _interopRequireDefault(_DateUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AUTH_CACHE_AGE = 5 * 60 * 1000; // 5 minutes
	
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var DevicesPanelEntry = function (_React$Component) {
	    (0, _inherits3.default)(DevicesPanelEntry, _React$Component);
	
	    function DevicesPanelEntry(props, context) {
	        (0, _classCallCheck3.default)(this, DevicesPanelEntry);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DevicesPanelEntry.__proto__ || (0, _getPrototypeOf2.default)(DevicesPanelEntry)).call(this, props, context));
	
	        _this.state = {
	            deleting: false,
	            deleteError: undefined
	        };
	
	        _this._unmounted = false;
	        _this._onDeleteClick = _this._onDeleteClick.bind(_this);
	        _this._onDisplayNameChanged = _this._onDisplayNameChanged.bind(_this);
	        _this._makeDeleteRequest = _this._makeDeleteRequest.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(DevicesPanelEntry, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this._unmounted = true;
	        }
	    }, {
	        key: '_onDisplayNameChanged',
	        value: function _onDisplayNameChanged(value) {
	            var device = this.props.device;
	            return _MatrixClientPeg2.default.get().setDeviceDetails(device.device_id, {
	                display_name: value
	            }).catch(function (e) {
	                console.error("Error setting device display name", e);
	                throw new Error("Failed to set display name");
	            });
	        }
	    }, {
	        key: '_onDeleteClick',
	        value: function _onDeleteClick() {
	            var _this2 = this;
	
	            this.setState({ deleting: true });
	
	            if (this.context.authCache.lastUpdate < Date.now() - AUTH_CACHE_AGE) {
	                this.context.authCache.auth = null;
	            }
	
	            // try with auth cache (which is null, so no interactive auth, to start off)
	            this._makeDeleteRequest(this.context.authCache.auth).catch(function (error) {
	                if (_this2._unmounted) {
	                    return;
	                }
	                if (error.httpStatus !== 401 || !error.data || !error.data.flows) {
	                    // doesn't look like an interactive-auth failure
	                    throw error;
	                }
	
	                // pop up an interactive auth dialog
	                var InteractiveAuthDialog = _index2.default.getComponent("dialogs.InteractiveAuthDialog");
	
	                _Modal2.default.createDialog(InteractiveAuthDialog, {
	                    matrixClient: _MatrixClientPeg2.default.get(),
	                    authData: error.data,
	                    makeRequest: _this2._makeDeleteRequest
	                });
	
	                _this2.setState({
	                    deleting: false
	                });
	            }).catch(function (e) {
	                console.error("Error deleting device", e);
	                if (_this2._unmounted) {
	                    return;
	                }
	                _this2.setState({
	                    deleting: false,
	                    deleteError: "Failed to delete device"
	                });
	            }).done();
	        }
	    }, {
	        key: '_makeDeleteRequest',
	        value: function _makeDeleteRequest(auth) {
	            var _this3 = this;
	
	            this.context.authCache.auth = auth;
	            this.context.authCache.lastUpdate = Date.now();
	
	            var device = this.props.device;
	            return _MatrixClientPeg2.default.get().deleteDevice(device.device_id, auth).then(function () {
	                _this3.props.onDeleted();
	                if (_this3._unmounted) {
	                    return;
	                }
	                _this3.setState({ deleting: false });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var EditableTextContainer = _index2.default.getComponent('elements.EditableTextContainer');
	
	            var device = this.props.device;
	
	            if (this.state.deleting) {
	                var Spinner = _index2.default.getComponent("elements.Spinner");
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'mx_DevicesPanel_device' },
	                    _react2.default.createElement(Spinner, null)
	                );
	            }
	
	            var lastSeen = "";
	            if (device.last_seen_ts) {
	                var lastSeenDate = _DateUtils2.default.formatDate(new Date(device.last_seen_ts));
	                lastSeen = device.last_seen_ip + " @ " + lastSeenDate.toLocaleString();
	            }
	
	            var deleteButton = void 0;
	            if (this.state.deleteError) {
	                deleteButton = _react2.default.createElement(
	                    'div',
	                    { className: 'error' },
	                    this.state.deleteError
	                );
	            } else {
	                deleteButton = _react2.default.createElement(
	                    'div',
	                    { className: 'mx_textButton',
	                        onClick: this._onDeleteClick },
	                    'Delete'
	                );
	            }
	
	            var myDeviceClass = '';
	            if (device.device_id === _MatrixClientPeg2.default.get().getDeviceId()) {
	                myDeviceClass = " mx_DevicesPanel_myDevice";
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: "mx_DevicesPanel_device" + myDeviceClass },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_DevicesPanel_deviceId' },
	                    device.device_id
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_DevicesPanel_deviceName' },
	                    _react2.default.createElement(EditableTextContainer, { initialValue: device.display_name,
	                        onSubmit: this._onDisplayNameChanged,
	                        placeholder: device.device_id
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_DevicesPanel_lastSeen' },
	                    lastSeen
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mx_DevicesPanel_deviceButtons' },
	                    deleteButton
	                )
	            );
	        }
	    }]);
	    return DevicesPanelEntry;
	}(_react2.default.Component);
	
	exports.default = DevicesPanelEntry;
	
	
	DevicesPanelEntry.propTypes = {
	    device: _react2.default.PropTypes.object.isRequired,
	    onDeleted: _react2.default.PropTypes.func
	};
	
	DevicesPanelEntry.contextTypes = {
	    authCache: _react2.default.PropTypes.object
	};
	
	DevicesPanelEntry.defaultProps = {
	    onDeleted: function onDeleted() {}
	};
	module.exports = exports['default'];


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var Notifier = __webpack_require__(170);
	var dis = __webpack_require__(5);
	
	module.exports = React.createClass({
	    displayName: 'EnableNotificationsButton',
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	    },
	
	    onAction: function onAction(payload) {
	        if (payload.action !== "notifier_enabled") {
	            return;
	        }
	        this.forceUpdate();
	    },
	
	    enabled: function enabled() {
	        return Notifier.isEnabled();
	    },
	
	    onClick: function onClick() {
	        var self = this;
	        if (!Notifier.supportsDesktopNotifications()) {
	            return;
	        }
	        if (!Notifier.isEnabled()) {
	            Notifier.setEnabled(true, function () {
	                self.forceUpdate();
	            });
	        } else {
	            Notifier.setEnabled(false);
	        }
	        this.forceUpdate();
	    },
	
	    render: function render() {
	        if (this.enabled()) {
	            return React.createElement(
	                "button",
	                { className: "mx_EnableNotificationsButton", onClick: this.onClick },
	                "Disable Notifications"
	            );
	        } else {
	            return React.createElement(
	                "button",
	                { className: "mx_EnableNotificationsButton", onClick: this.onClick },
	                "Enable Notifications"
	            );
	        }
	    }
	});


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	var dis = __webpack_require__(5);
	var CallHandler = __webpack_require__(73);
	var sdk = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(4);
	
	module.exports = React.createClass({
	    displayName: 'CallView',
	
	    propTypes: {
	        // js-sdk room object. If set, we will only show calls for the given
	        // room; if not, we will show any active call.
	        room: React.PropTypes.object,
	
	        // A Conference Handler implementation
	        // Must have a function signature:
	        //  getConferenceCallForRoom(roomId: string): MatrixCall
	        ConferenceHandler: React.PropTypes.object,
	
	        // maxHeight style attribute for the video panel
	        maxVideoHeight: React.PropTypes.number,
	
	        // a callback which is called when the user clicks on the video div
	        onClick: React.PropTypes.func,
	
	        // a callback which is called when the content in the callview changes
	        // in a way that is likely to cause a resize.
	        onResize: React.PropTypes.func,
	
	        // render ongoing audio call details - useful when in LeftPanel
	        showVoice: React.PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            // the call this view is displaying (if any)
	            call: null
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        this.showCall();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	    },
	
	    onAction: function onAction(payload) {
	        // don't filter out payloads for room IDs other than props.room because
	        // we may be interested in the conf 1:1 room
	        if (payload.action !== 'call_state') {
	            return;
	        }
	        this.showCall();
	    },
	
	    showCall: function showCall() {
	        var call;
	
	        if (this.props.room) {
	            var roomId = this.props.room.roomId;
	            call = CallHandler.getCallForRoom(roomId) || (this.props.ConferenceHandler ? this.props.ConferenceHandler.getConferenceCallForRoom(roomId) : null);
	
	            if (this.call) {
	                this.setState({ call: call });
	            }
	        } else {
	            call = CallHandler.getAnyActiveCall();
	            this.setState({ call: call });
	        }
	
	        if (call) {
	            call.setLocalVideoElement(this.getVideoView().getLocalVideoElement());
	            call.setRemoteVideoElement(this.getVideoView().getRemoteVideoElement());
	            // always use a separate element for audio stream playback.
	            // this is to let us move CallView around the DOM without interrupting remote audio
	            // during playback, by having the audio rendered by a top-level <audio/> element.
	            // rather than being rendered by the main remoteVideo <video/> element.
	            call.setRemoteAudioElement(this.getVideoView().getRemoteAudioElement());
	        }
	        if (call && call.type === "video" && call.call_state !== "ended" && call.call_state !== "ringing") {
	            // if this call is a conf call, don't display local video as the
	            // conference will have us in it
	            this.getVideoView().getLocalVideoElement().style.display = call.confUserId ? "none" : "block";
	            this.getVideoView().getRemoteVideoElement().style.display = "block";
	        } else {
	            this.getVideoView().getLocalVideoElement().style.display = "none";
	            this.getVideoView().getRemoteVideoElement().style.display = "none";
	            dis.dispatch({ action: 'video_fullscreen', fullscreen: false });
	        }
	
	        if (this.props.onResize) {
	            this.props.onResize();
	        }
	    },
	
	    getVideoView: function getVideoView() {
	        return this.refs.video;
	    },
	
	    render: function render() {
	        var VideoView = sdk.getComponent('voip.VideoView');
	
	        var voice;
	        if (this.state.call && this.state.call.type === "voice" && this.props.showVoice) {
	            var callRoom = MatrixClientPeg.get().getRoom(this.state.call.roomId);
	            voice = React.createElement(
	                "div",
	                { className: "mx_CallView_voice", onClick: this.props.onClick },
	                "Active call (",
	                callRoom.name,
	                ")"
	            );
	        }
	
	        return React.createElement(
	            "div",
	            null,
	            React.createElement(VideoView, { ref: "video", onClick: this.props.onClick,
	                onResize: this.props.onResize,
	                maxHeight: this.props.maxVideoHeight
	            }),
	            voice
	        );
	    }
	});


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	var React = __webpack_require__(1);
	var MatrixClientPeg = __webpack_require__(4);
	var dis = __webpack_require__(5);
	var CallHandler = __webpack_require__(73);
	
	module.exports = React.createClass({
	    displayName: 'IncomingCallBox',
	
	    propTypes: {
	        incomingCall: React.PropTypes.object
	    },
	
	    onAnswerClick: function onAnswerClick() {
	        dis.dispatch({
	            action: 'answer',
	            room_id: this.props.incomingCall.roomId
	        });
	    },
	
	    onRejectClick: function onRejectClick() {
	        dis.dispatch({
	            action: 'hangup',
	            room_id: this.props.incomingCall.roomId
	        });
	    },
	
	    render: function render() {
	        var room = null;
	        if (this.props.incomingCall) {
	            room = MatrixClientPeg.get().getRoom(this.props.incomingCall.roomId);
	        }
	
	        var caller = room ? room.name : "unknown";
	
	        return React.createElement(
	            'div',
	            { className: 'mx_IncomingCallBox', id: 'incomingCallBox' },
	            React.createElement('img', { className: 'mx_IncomingCallBox_chevron', src: 'img/chevron-left.png', width: '9', height: '16' }),
	            React.createElement(
	                'div',
	                { className: 'mx_IncomingCallBox_title' },
	                'Incoming ',
	                this.props.incomingCall ? this.props.incomingCall.type : '',
	                ' call from ',
	                caller
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_IncomingCallBox_buttons' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_IncomingCallBox_buttons_cell' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_IncomingCallBox_buttons_decline', onClick: this.onRejectClick },
	                        'Decline'
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_IncomingCallBox_buttons_cell' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_IncomingCallBox_buttons_accept', onClick: this.onAnswerClick },
	                        'Accept'
	                    )
	                )
	            )
	        );
	    }
	});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = React.createClass({
	    displayName: 'VideoFeed',
	
	    propTypes: {
	        // maxHeight style attribute for the video element
	        maxHeight: React.PropTypes.number,
	
	        // a callback which is called when the video element is resized
	        // due to a change in video metadata
	        onResize: React.PropTypes.func
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.refs.vid.addEventListener('resize', this.onResize);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.refs.vid.removeEventListener('resize', this.onResize);
	    },
	
	
	    onResize: function onResize(e) {
	        if (this.props.onResize) {
	            this.props.onResize(e);
	        }
	    },
	
	    render: function render() {
	        return React.createElement('video', { ref: 'vid', style: { maxHeight: this.props.maxHeight } });
	    }
	});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(18);
	
	var sdk = __webpack_require__(2);
	var dis = __webpack_require__(5);
	
	module.exports = React.createClass({
	    displayName: 'VideoView',
	
	    propTypes: {
	        // maxHeight style attribute for the video element
	        maxHeight: React.PropTypes.number,
	
	        // a callback which is called when the user clicks on the video div
	        onClick: React.PropTypes.func,
	
	        // a callback which is called when the video element is resized due to
	        // a change in video metadata
	        onResize: React.PropTypes.func
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	    },
	
	    getRemoteVideoElement: function getRemoteVideoElement() {
	        return ReactDOM.findDOMNode(this.refs.remote);
	    },
	
	    getRemoteAudioElement: function getRemoteAudioElement() {
	        // this needs to be somewhere at the top of the DOM which
	        // always exists to avoid audio interruptions.
	        // Might as well just use DOM.
	        var remoteAudioElement = document.getElementById("remoteAudio");
	        if (!remoteAudioElement) {
	            console.error("Failed to find remoteAudio element - cannot play audio!  You need to add an <audio/> to the DOM.");
	        }
	        return remoteAudioElement;
	    },
	
	    getLocalVideoElement: function getLocalVideoElement() {
	        return ReactDOM.findDOMNode(this.refs.local);
	    },
	
	    setContainer: function setContainer(c) {
	        this.container = c;
	    },
	
	    onAction: function onAction(payload) {
	        switch (payload.action) {
	            case 'video_fullscreen':
	                if (!this.container) {
	                    return;
	                }
	                var element = this.container;
	                if (payload.fullscreen) {
	                    var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;
	                    requestMethod.call(element);
	                } else {
	                    var exitMethod = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
	                    if (exitMethod) {
	                        exitMethod.call(document);
	                    }
	                }
	                break;
	        }
	    },
	
	    render: function render() {
	        var VideoFeed = sdk.getComponent('voip.VideoFeed');
	
	        // if we're fullscreen, we don't want to set a maxHeight on the video element.
	        var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
	        var maxVideoHeight = fullscreenElement ? null : this.props.maxHeight;
	
	        return React.createElement(
	            'div',
	            { className: 'mx_VideoView', ref: this.setContainer, onClick: this.props.onClick },
	            React.createElement(
	                'div',
	                { className: 'mx_VideoView_remoteVideoFeed' },
	                React.createElement(VideoFeed, { ref: 'remote', onResize: this.props.onResize,
	                    maxHeight: maxVideoHeight })
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_VideoView_localVideoFeed' },
	                React.createElement(VideoFeed, { ref: 'local' })
	            )
	        );
	    }
	});


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	module.exports = function (dest, src) {
	    for (var i in src) {
	        if (src.hasOwnProperty(i)) {
	            dest[i] = src[i];
	        }
	    }
	    return dest;
	};


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(34);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(180);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Invite = __webpack_require__(220);
	
	var _q = __webpack_require__(6);
	
	var _q2 = _interopRequireDefault(_q);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Invites multiple addresses to a room, handling rate limiting from the server
	 */
	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	var MultiInviter = function () {
	    function MultiInviter(roomId) {
	        (0, _classCallCheck3.default)(this, MultiInviter);
	
	        this.roomId = roomId;
	
	        this.canceled = false;
	        this.addrs = [];
	        this.busy = false;
	        this.completionStates = {}; // State of each address (invited or error)
	        this.errorTexts = {}; // Textual error per address
	        this.deferred = null;
	    }
	
	    /**
	     * Invite users to this room. This may only be called once per
	     * instance of the class.
	     *
	     * The promise is given progress when each address completes, with an
	     * object argument with each completed address with value either
	     * 'invited' or 'error'.
	     *
	     * @param {array} addresses Array of addresses to invite
	     * @returns {Promise} Resolved when all invitations in the queue are complete
	     */
	
	
	    (0, _createClass3.default)(MultiInviter, [{
	        key: 'invite',
	        value: function invite(addrs) {
	            var _addrs;
	
	            if (this.addrs.length > 0) {
	                throw new Error("Already inviting/invited");
	            }
	            (_addrs = this.addrs).push.apply(_addrs, (0, _toConsumableArray3.default)(addrs));
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(this.addrs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var addr = _step.value;
	
	                    if ((0, _Invite.getAddressType)(addr) === null) {
	                        this.completionStates[addr] = 'error';
	                        this.errorTexts[addr] = 'Unrecognised address';
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.deferred = _q2.default.defer();
	            this._inviteMore(0);
	
	            return this.deferred.promise;
	        }
	
	        /**
	         * Stops inviting. Causes promises returned by invite() to be rejected.
	         */
	
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            if (!this.busy) return;
	
	            this._canceled = true;
	            this.deferred.reject(new Error('canceled'));
	        }
	    }, {
	        key: 'getCompletionState',
	        value: function getCompletionState(addr) {
	            return this.completionStates[addr];
	        }
	    }, {
	        key: 'getErrorText',
	        value: function getErrorText(addr) {
	            return this.errorTexts[addr];
	        }
	    }, {
	        key: '_inviteMore',
	        value: function _inviteMore(nextIndex) {
	            var _this = this;
	
	            if (this._canceled) {
	                return;
	            }
	
	            if (nextIndex == this.addrs.length) {
	                this.busy = false;
	                this.deferred.resolve(this.completionStates);
	                return;
	            }
	
	            var addr = this.addrs[nextIndex];
	
	            // don't try to invite it if it's an invalid address
	            // (it will already be marked as an error though,
	            // so no need to do so again)
	            if ((0, _Invite.getAddressType)(addr) === null) {
	                this._inviteMore(nextIndex + 1);
	                return;
	            }
	
	            // don't re-invite (there's no way in the UI to do this, but
	            // for sanity's sake)
	            if (this.completionStates[addr] == 'invited') {
	                this._inviteMore(nextIndex + 1);
	                return;
	            }
	
	            (0, _Invite.inviteToRoom)(this.roomId, addr).then(function () {
	                if (_this._canceled) {
	                    return;
	                }
	
	                _this.completionStates[addr] = 'invited';
	                _this.deferred.notify(_this.completionStates);
	
	                _this._inviteMore(nextIndex + 1);
	            }, function (err) {
	                if (_this._canceled) {
	                    return;
	                }
	
	                var errorText = void 0;
	                var fatal = false;
	                if (err.errcode == 'M_FORBIDDEN') {
	                    fatal = true;
	                    errorText = 'You do not have permission to invite people to this room.';
	                } else if (err.errcode == 'M_LIMIT_EXCEEDED') {
	                    // we're being throttled so wait a bit & try again
	                    setTimeout(function () {
	                        _this._inviteMore(nextIndex);
	                    }, 5000);
	                    return;
	                } else {
	                    errorText = 'Unknown server error';
	                }
	                _this.completionStates[addr] = 'error';
	                _this.errorTexts[addr] = errorText;
	                _this.busy = !fatal;
	
	                if (!fatal) {
	                    _this.deferred.notify(_this.completionStates);
	                    _this._inviteMore(nextIndex + 1);
	                }
	            });
	        }
	    }]);
	    return MultiInviter;
	}();
	
	exports.default = MultiInviter;
	module.exports = exports['default'];


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Syntax highlighting with language autodetection.
	https://highlightjs.org/
	*/
	
	(function(factory) {
	
	  // Setup highlight.js for different environments. First is Node.js or
	  // CommonJS.
	  if(true) {
	    factory(exports);
	  } else {
	    // Export hljs globally even when using AMD for cases when this script
	    // is loaded with others that may still expect a global hljs.
	    window.hljs = factory({});
	
	    // Finally register the global hljs with AMD.
	    if(typeof define === 'function' && define.amd) {
	      define('hljs', [], function() {
	        return window.hljs;
	      });
	    }
	  }
	
	}(function(hljs) {
	
	  /* Utility functions */
	
	  function escape(value) {
	    return value.replace(/&/gm, '&amp;').replace(/</gm, '&lt;').replace(/>/gm, '&gt;');
	  }
	
	  function tag(node) {
	    return node.nodeName.toLowerCase();
	  }
	
	  function testRe(re, lexeme) {
	    var match = re && re.exec(lexeme);
	    return match && match.index == 0;
	  }
	
	  function isNotHighlighted(language) {
	    return (/^(no-?highlight|plain|text)$/i).test(language);
	  }
	
	  function blockLanguage(block) {
	    var i, match, length,
	        classes = block.className + ' ';
	
	    classes += block.parentNode ? block.parentNode.className : '';
	
	    // language-* takes precedence over non-prefixed class names
	    match = (/\blang(?:uage)?-([\w-]+)\b/i).exec(classes);
	    if (match) {
	      return getLanguage(match[1]) ? match[1] : 'no-highlight';
	    }
	
	    classes = classes.split(/\s+/);
	    for (i = 0, length = classes.length; i < length; i++) {
	      if (getLanguage(classes[i]) || isNotHighlighted(classes[i])) {
	        return classes[i];
	      }
	    }
	  }
	
	  function inherit(parent, obj) {
	    var result = {}, key;
	    for (key in parent)
	      result[key] = parent[key];
	    if (obj)
	      for (key in obj)
	        result[key] = obj[key];
	    return result;
	  }
	
	  /* Stream merging */
	
	  function nodeStream(node) {
	    var result = [];
	    (function _nodeStream(node, offset) {
	      for (var child = node.firstChild; child; child = child.nextSibling) {
	        if (child.nodeType == 3)
	          offset += child.nodeValue.length;
	        else if (child.nodeType == 1) {
	          result.push({
	            event: 'start',
	            offset: offset,
	            node: child
	          });
	          offset = _nodeStream(child, offset);
	          // Prevent void elements from having an end tag that would actually
	          // double them in the output. There are more void elements in HTML
	          // but we list only those realistically expected in code display.
	          if (!tag(child).match(/br|hr|img|input/)) {
	            result.push({
	              event: 'stop',
	              offset: offset,
	              node: child
	            });
	          }
	        }
	      }
	      return offset;
	    })(node, 0);
	    return result;
	  }
	
	  function mergeStreams(original, highlighted, value) {
	    var processed = 0;
	    var result = '';
	    var nodeStack = [];
	
	    function selectStream() {
	      if (!original.length || !highlighted.length) {
	        return original.length ? original : highlighted;
	      }
	      if (original[0].offset != highlighted[0].offset) {
	        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
	      }
	
	      /*
	      To avoid starting the stream just before it should stop the order is
	      ensured that original always starts first and closes last:
	
	      if (event1 == 'start' && event2 == 'start')
	        return original;
	      if (event1 == 'start' && event2 == 'stop')
	        return highlighted;
	      if (event1 == 'stop' && event2 == 'start')
	        return original;
	      if (event1 == 'stop' && event2 == 'stop')
	        return highlighted;
	
	      ... which is collapsed to:
	      */
	      return highlighted[0].event == 'start' ? original : highlighted;
	    }
	
	    function open(node) {
	      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value) + '"';}
	      result += '<' + tag(node) + Array.prototype.map.call(node.attributes, attr_str).join('') + '>';
	    }
	
	    function close(node) {
	      result += '</' + tag(node) + '>';
	    }
	
	    function render(event) {
	      (event.event == 'start' ? open : close)(event.node);
	    }
	
	    while (original.length || highlighted.length) {
	      var stream = selectStream();
	      result += escape(value.substr(processed, stream[0].offset - processed));
	      processed = stream[0].offset;
	      if (stream == original) {
	        /*
	        On any opening or closing tag of the original markup we first close
	        the entire highlighted node stack, then render the original tag along
	        with all the following original tags at the same offset and then
	        reopen all the tags on the highlighted stack.
	        */
	        nodeStack.reverse().forEach(close);
	        do {
	          render(stream.splice(0, 1)[0]);
	          stream = selectStream();
	        } while (stream == original && stream.length && stream[0].offset == processed);
	        nodeStack.reverse().forEach(open);
	      } else {
	        if (stream[0].event == 'start') {
	          nodeStack.push(stream[0].node);
	        } else {
	          nodeStack.pop();
	        }
	        render(stream.splice(0, 1)[0]);
	      }
	    }
	    return result + escape(value.substr(processed));
	  }
	
	  /* Initialization */
	
	  function compileLanguage(language) {
	
	    function reStr(re) {
	        return (re && re.source) || re;
	    }
	
	    function langRe(value, global) {
	      return new RegExp(
	        reStr(value),
	        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
	      );
	    }
	
	    function compileMode(mode, parent) {
	      if (mode.compiled)
	        return;
	      mode.compiled = true;
	
	      mode.keywords = mode.keywords || mode.beginKeywords;
	      if (mode.keywords) {
	        var compiled_keywords = {};
	
	        var flatten = function(className, str) {
	          if (language.case_insensitive) {
	            str = str.toLowerCase();
	          }
	          str.split(' ').forEach(function(kw) {
	            var pair = kw.split('|');
	            compiled_keywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1];
	          });
	        };
	
	        if (typeof mode.keywords == 'string') { // string
	          flatten('keyword', mode.keywords);
	        } else {
	          Object.keys(mode.keywords).forEach(function (className) {
	            flatten(className, mode.keywords[className]);
	          });
	        }
	        mode.keywords = compiled_keywords;
	      }
	      mode.lexemesRe = langRe(mode.lexemes || /\b\w+\b/, true);
	
	      if (parent) {
	        if (mode.beginKeywords) {
	          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
	        }
	        if (!mode.begin)
	          mode.begin = /\B|\b/;
	        mode.beginRe = langRe(mode.begin);
	        if (!mode.end && !mode.endsWithParent)
	          mode.end = /\B|\b/;
	        if (mode.end)
	          mode.endRe = langRe(mode.end);
	        mode.terminator_end = reStr(mode.end) || '';
	        if (mode.endsWithParent && parent.terminator_end)
	          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
	      }
	      if (mode.illegal)
	        mode.illegalRe = langRe(mode.illegal);
	      if (mode.relevance === undefined)
	        mode.relevance = 1;
	      if (!mode.contains) {
	        mode.contains = [];
	      }
	      var expanded_contains = [];
	      mode.contains.forEach(function(c) {
	        if (c.variants) {
	          c.variants.forEach(function(v) {expanded_contains.push(inherit(c, v));});
	        } else {
	          expanded_contains.push(c == 'self' ? mode : c);
	        }
	      });
	      mode.contains = expanded_contains;
	      mode.contains.forEach(function(c) {compileMode(c, mode);});
	
	      if (mode.starts) {
	        compileMode(mode.starts, parent);
	      }
	
	      var terminators =
	        mode.contains.map(function(c) {
	          return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin;
	        })
	        .concat([mode.terminator_end, mode.illegal])
	        .map(reStr)
	        .filter(Boolean);
	      mode.terminators = terminators.length ? langRe(terminators.join('|'), true) : {exec: function(/*s*/) {return null;}};
	    }
	
	    compileMode(language);
	  }
	
	  /*
	  Core highlighting function. Accepts a language name, or an alias, and a
	  string with the code to highlight. Returns an object with the following
	  properties:
	
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	
	  */
	  function highlight(name, value, ignore_illegals, continuation) {
	
	    function subMode(lexeme, mode) {
	      for (var i = 0; i < mode.contains.length; i++) {
	        if (testRe(mode.contains[i].beginRe, lexeme)) {
	          return mode.contains[i];
	        }
	      }
	    }
	
	    function endOfMode(mode, lexeme) {
	      if (testRe(mode.endRe, lexeme)) {
	        while (mode.endsParent && mode.parent) {
	          mode = mode.parent;
	        }
	        return mode;
	      }
	      if (mode.endsWithParent) {
	        return endOfMode(mode.parent, lexeme);
	      }
	    }
	
	    function isIllegal(lexeme, mode) {
	      return !ignore_illegals && testRe(mode.illegalRe, lexeme);
	    }
	
	    function keywordMatch(mode, match) {
	      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
	      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
	    }
	
	    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
	      var classPrefix = noPrefix ? '' : options.classPrefix,
	          openSpan    = '<span class="' + classPrefix,
	          closeSpan   = leaveOpen ? '' : '</span>';
	
	      openSpan += classname + '">';
	
	      return openSpan + insideSpan + closeSpan;
	    }
	
	    function processKeywords() {
	      if (!top.keywords)
	        return escape(mode_buffer);
	      var result = '';
	      var last_index = 0;
	      top.lexemesRe.lastIndex = 0;
	      var match = top.lexemesRe.exec(mode_buffer);
	      while (match) {
	        result += escape(mode_buffer.substr(last_index, match.index - last_index));
	        var keyword_match = keywordMatch(top, match);
	        if (keyword_match) {
	          relevance += keyword_match[1];
	          result += buildSpan(keyword_match[0], escape(match[0]));
	        } else {
	          result += escape(match[0]);
	        }
	        last_index = top.lexemesRe.lastIndex;
	        match = top.lexemesRe.exec(mode_buffer);
	      }
	      return result + escape(mode_buffer.substr(last_index));
	    }
	
	    function processSubLanguage() {
	      var explicit = typeof top.subLanguage == 'string';
	      if (explicit && !languages[top.subLanguage]) {
	        return escape(mode_buffer);
	      }
	
	      var result = explicit ?
	                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
	                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);
	
	      // Counting embedded language score towards the host language may be disabled
	      // with zeroing the containing mode relevance. Usecase in point is Markdown that
	      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
	      // score.
	      if (top.relevance > 0) {
	        relevance += result.relevance;
	      }
	      if (explicit) {
	        continuations[top.subLanguage] = result.top;
	      }
	      return buildSpan(result.language, result.value, false, true);
	    }
	
	    function processBuffer() {
	      return top.subLanguage !== undefined ? processSubLanguage() : processKeywords();
	    }
	
	    function startNewMode(mode, lexeme) {
	      var markup = mode.className? buildSpan(mode.className, '', true): '';
	      if (mode.returnBegin) {
	        result += markup;
	        mode_buffer = '';
	      } else if (mode.excludeBegin) {
	        result += escape(lexeme) + markup;
	        mode_buffer = '';
	      } else {
	        result += markup;
	        mode_buffer = lexeme;
	      }
	      top = Object.create(mode, {parent: {value: top}});
	    }
	
	    function processLexeme(buffer, lexeme) {
	
	      mode_buffer += buffer;
	      if (lexeme === undefined) {
	        result += processBuffer();
	        return 0;
	      }
	
	      var new_mode = subMode(lexeme, top);
	      if (new_mode) {
	        result += processBuffer();
	        startNewMode(new_mode, lexeme);
	        return new_mode.returnBegin ? 0 : lexeme.length;
	      }
	
	      var end_mode = endOfMode(top, lexeme);
	      if (end_mode) {
	        var origin = top;
	        if (!(origin.returnEnd || origin.excludeEnd)) {
	          mode_buffer += lexeme;
	        }
	        result += processBuffer();
	        do {
	          if (top.className) {
	            result += '</span>';
	          }
	          relevance += top.relevance;
	          top = top.parent;
	        } while (top != end_mode.parent);
	        if (origin.excludeEnd) {
	          result += escape(lexeme);
	        }
	        mode_buffer = '';
	        if (end_mode.starts) {
	          startNewMode(end_mode.starts, '');
	        }
	        return origin.returnEnd ? 0 : lexeme.length;
	      }
	
	      if (isIllegal(lexeme, top))
	        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
	
	      /*
	      Parser should not reach this point as all types of lexemes should be caught
	      earlier, but if it does due to some bug make sure it advances at least one
	      character forward to prevent infinite looping.
	      */
	      mode_buffer += lexeme;
	      return lexeme.length || 1;
	    }
	
	    var language = getLanguage(name);
	    if (!language) {
	      throw new Error('Unknown language: "' + name + '"');
	    }
	
	    compileLanguage(language);
	    var top = continuation || language;
	    var continuations = {}; // keep continuations for sub-languages
	    var result = '', current;
	    for(current = top; current != language; current = current.parent) {
	      if (current.className) {
	        result = buildSpan(current.className, '', true) + result;
	      }
	    }
	    var mode_buffer = '';
	    var relevance = 0;
	    try {
	      var match, count, index = 0;
	      while (true) {
	        top.terminators.lastIndex = index;
	        match = top.terminators.exec(value);
	        if (!match)
	          break;
	        count = processLexeme(value.substr(index, match.index - index), match[0]);
	        index = match.index + count;
	      }
	      processLexeme(value.substr(index));
	      for(current = top; current.parent; current = current.parent) { // close dangling modes
	        if (current.className) {
	          result += '</span>';
	        }
	      }
	      return {
	        relevance: relevance,
	        value: result,
	        language: name,
	        top: top
	      };
	    } catch (e) {
	      if (e.message.indexOf('Illegal') != -1) {
	        return {
	          relevance: 0,
	          value: escape(value)
	        };
	      } else {
	        throw e;
	      }
	    }
	  }
	
	  /*
	  Highlighting with language detection. Accepts a string with the code to
	  highlight. Returns an object with the following properties:
	
	  - language (detected language)
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	  - second_best (object with the same structure for second-best heuristically
	    detected language, may be absent)
	
	  */
	  function highlightAuto(text, languageSubset) {
	    languageSubset = languageSubset || options.languages || Object.keys(languages);
	    var result = {
	      relevance: 0,
	      value: escape(text)
	    };
	    var second_best = result;
	    languageSubset.forEach(function(name) {
	      if (!getLanguage(name)) {
	        return;
	      }
	      var current = highlight(name, text, false);
	      current.language = name;
	      if (current.relevance > second_best.relevance) {
	        second_best = current;
	      }
	      if (current.relevance > result.relevance) {
	        second_best = result;
	        result = current;
	      }
	    });
	    if (second_best.language) {
	      result.second_best = second_best;
	    }
	    return result;
	  }
	
	  /*
	  Post-processing of the highlighted markup:
	
	  - replace TABs with something more useful
	  - replace real line-breaks with '<br>' for non-pre containers
	
	  */
	  function fixMarkup(value) {
	    if (options.tabReplace) {
	      value = value.replace(/^((<[^>]+>|\t)+)/gm, function(match, p1 /*..., offset, s*/) {
	        return p1.replace(/\t/g, options.tabReplace);
	      });
	    }
	    if (options.useBR) {
	      value = value.replace(/\n/g, '<br>');
	    }
	    return value;
	  }
	
	  function buildClassName(prevClassName, currentLang, resultLang) {
	    var language = currentLang ? aliases[currentLang] : resultLang,
	        result   = [prevClassName.trim()];
	
	    if (!prevClassName.match(/\bhljs\b/)) {
	      result.push('hljs');
	    }
	
	    if (prevClassName.indexOf(language) === -1) {
	      result.push(language);
	    }
	
	    return result.join(' ').trim();
	  }
	
	  /*
	  Applies highlighting to a DOM node containing code. Accepts a DOM node and
	  two optional parameters for fixMarkup.
	  */
	  function highlightBlock(block) {
	    var language = blockLanguage(block);
	    if (isNotHighlighted(language))
	        return;
	
	    var node;
	    if (options.useBR) {
	      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
	    } else {
	      node = block;
	    }
	    var text = node.textContent;
	    var result = language ? highlight(language, text, true) : highlightAuto(text);
	
	    var originalStream = nodeStream(node);
	    if (originalStream.length) {
	      var resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      resultNode.innerHTML = result.value;
	      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
	    }
	    result.value = fixMarkup(result.value);
	
	    block.innerHTML = result.value;
	    block.className = buildClassName(block.className, language, result.language);
	    block.result = {
	      language: result.language,
	      re: result.relevance
	    };
	    if (result.second_best) {
	      block.second_best = {
	        language: result.second_best.language,
	        re: result.second_best.relevance
	      };
	    }
	  }
	
	  var options = {
	    classPrefix: 'hljs-',
	    tabReplace: null,
	    useBR: false,
	    languages: undefined
	  };
	
	  /*
	  Updates highlight.js global options with values passed in the form of an object
	  */
	  function configure(user_options) {
	    options = inherit(options, user_options);
	  }
	
	  /*
	  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
	  */
	  function initHighlighting() {
	    if (initHighlighting.called)
	      return;
	    initHighlighting.called = true;
	
	    var blocks = document.querySelectorAll('pre code');
	    Array.prototype.forEach.call(blocks, highlightBlock);
	  }
	
	  /*
	  Attaches highlighting to the page load event.
	  */
	  function initHighlightingOnLoad() {
	    addEventListener('DOMContentLoaded', initHighlighting, false);
	    addEventListener('load', initHighlighting, false);
	  }
	
	  var languages = {};
	  var aliases = {};
	
	  function registerLanguage(name, language) {
	    var lang = languages[name] = language(hljs);
	    if (lang.aliases) {
	      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
	    }
	  }
	
	  function listLanguages() {
	    return Object.keys(languages);
	  }
	
	  function getLanguage(name) {
	    name = (name || '').toLowerCase();
	    return languages[name] || languages[aliases[name]];
	  }
	
	  /* Interface definition */
	
	  hljs.highlight = highlight;
	  hljs.highlightAuto = highlightAuto;
	  hljs.fixMarkup = fixMarkup;
	  hljs.highlightBlock = highlightBlock;
	  hljs.configure = configure;
	  hljs.initHighlighting = initHighlighting;
	  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
	  hljs.registerLanguage = registerLanguage;
	  hljs.listLanguages = listLanguages;
	  hljs.getLanguage = getLanguage;
	  hljs.inherit = inherit;
	
	  // Common regexps
	  hljs.IDENT_RE = '[a-zA-Z]\\w*';
	  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
	  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
	  hljs.C_NUMBER_RE = '(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
	  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
	  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
	
	  // Common modes
	  hljs.BACKSLASH_ESCAPE = {
	    begin: '\\\\[\\s\\S]', relevance: 0
	  };
	  hljs.APOS_STRING_MODE = {
	    className: 'string',
	    begin: '\'', end: '\'',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.QUOTE_STRING_MODE = {
	    className: 'string',
	    begin: '"', end: '"',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.PHRASAL_WORDS_MODE = {
	    begin: /\b(a|an|the|are|I|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|like)\b/
	  };
	  hljs.COMMENT = function (begin, end, inherits) {
	    var mode = hljs.inherit(
	      {
	        className: 'comment',
	        begin: begin, end: end,
	        contains: []
	      },
	      inherits || {}
	    );
	    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
	    mode.contains.push({
	      className: 'doctag',
	      begin: "(?:TODO|FIXME|NOTE|BUG|XXX):",
	      relevance: 0
	    });
	    return mode;
	  };
	  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
	  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
	  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
	  hljs.NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE,
	    relevance: 0
	  };
	  hljs.C_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.C_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.BINARY_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.BINARY_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.CSS_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE + '(' +
	      '%|em|ex|ch|rem'  +
	      '|vw|vh|vmin|vmax' +
	      '|cm|mm|in|pt|pc|px' +
	      '|deg|grad|rad|turn' +
	      '|s|ms' +
	      '|Hz|kHz' +
	      '|dpi|dpcm|dppx' +
	      ')?',
	    relevance: 0
	  };
	  hljs.REGEXP_MODE = {
	    className: 'regexp',
	    begin: /\//, end: /\/[gimuy]*/,
	    illegal: /\n/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      {
	        begin: /\[/, end: /\]/,
	        relevance: 0,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  hljs.TITLE_MODE = {
	    className: 'title',
	    begin: hljs.IDENT_RE,
	    relevance: 0
	  };
	  hljs.UNDERSCORE_TITLE_MODE = {
	    className: 'title',
	    begin: hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0
	  };
	
	  return hljs;
	}));


/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	module.exports = function(hljs){
	  var IDENT_RE_RU = '[a-zA-Zа-яА-Я][a-zA-Z0-9_а-яА-Я]*';
	  var OneS_KEYWORDS = 'возврат дата для если и или иначе иначеесли исключение конецесли ' +
	    'конецпопытки конецпроцедуры конецфункции конеццикла константа не перейти перем ' +
	    'перечисление по пока попытка прервать продолжить процедура строка тогда фс функция цикл ' +
	    'число экспорт';
	  var OneS_BUILT_IN = 'ansitooem oemtoansi ввестивидсубконто ввестидату ввестизначение ' +
	    'ввестиперечисление ввестипериод ввестиплансчетов ввестистроку ввестичисло вопрос ' +
	    'восстановитьзначение врег выбранныйплансчетов вызватьисключение датагод датамесяц ' +
	    'датачисло добавитьмесяц завершитьработусистемы заголовоксистемы записьжурналарегистрации ' +
	    'запуститьприложение зафиксироватьтранзакцию значениевстроку значениевстрокувнутр ' +
	    'значениевфайл значениеизстроки значениеизстрокивнутр значениеизфайла имякомпьютера ' +
	    'имяпользователя каталогвременныхфайлов каталогиб каталогпользователя каталогпрограммы ' +
	    'кодсимв командасистемы конгода конецпериодаби конецрассчитанногопериодаби ' +
	    'конецстандартногоинтервала конквартала конмесяца коннедели лев лог лог10 макс ' +
	    'максимальноеколичествосубконто мин монопольныйрежим названиеинтерфейса названиенабораправ ' +
	    'назначитьвид назначитьсчет найти найтипомеченныенаудаление найтиссылки началопериодаби ' +
	    'началостандартногоинтервала начатьтранзакцию начгода начквартала начмесяца начнедели ' +
	    'номерднягода номерднянедели номернеделигода нрег обработкаожидания окр описаниеошибки ' +
	    'основнойжурналрасчетов основнойплансчетов основнойязык открытьформу открытьформумодально ' +
	    'отменитьтранзакцию очиститьокносообщений периодстр полноеимяпользователя получитьвремята ' +
	    'получитьдатута получитьдокументта получитьзначенияотбора получитьпозициюта ' +
	    'получитьпустоезначение получитьта прав праводоступа предупреждение префиксавтонумерации ' +
	    'пустаястрока пустоезначение рабочаядаттьпустоезначение рабочаядата разделительстраниц ' +
	    'разделительстрок разм разобратьпозициюдокумента рассчитатьрегистрына ' +
	    'рассчитатьрегистрыпо сигнал симв символтабуляции создатьобъект сокрл сокрлп сокрп ' +
	    'сообщить состояние сохранитьзначение сред статусвозврата стрдлина стрзаменить ' +
	    'стрколичествострок стрполучитьстроку  стрчисловхождений сформироватьпозициюдокумента ' +
	    'счетпокоду текущаядата текущеевремя типзначения типзначениястр удалитьобъекты ' +
	    'установитьтана установитьтапо фиксшаблон формат цел шаблон';
	  var DQUOTE =  {className: 'dquote',  begin: '""'};
	  var STR_START = {
	      className: 'string',
	      begin: '"', end: '"|$',
	      contains: [DQUOTE]
	    };
	  var STR_CONT = {
	    className: 'string',
	    begin: '\\|', end: '"|$',
	    contains: [DQUOTE]
	  };
	
	  return {
	    case_insensitive: true,
	    lexemes: IDENT_RE_RU,
	    keywords: {keyword: OneS_KEYWORDS, built_in: OneS_BUILT_IN},
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.NUMBER_MODE,
	      STR_START, STR_CONT,
	      {
	        className: 'function',
	        begin: '(процедура|функция)', end: '$',
	        lexemes: IDENT_RE_RU,
	        keywords: 'процедура функция',
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE_RU}),
	          {
	            className: 'tail',
	            endsWithParent: true,
	            contains: [
	              {
	                className: 'params',
	                begin: '\\(', end: '\\)',
	                lexemes: IDENT_RE_RU,
	                keywords: 'знач',
	                contains: [STR_START, STR_CONT]
	              },
	              {
	                className: 'export',
	                begin: 'экспорт', endsWithParent: true,
	                lexemes: IDENT_RE_RU,
	                keywords: 'экспорт',
	                contains: [hljs.C_LINE_COMMENT_MODE]
	              }
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE
	        ]
	      },
	      {className: 'preprocessor', begin: '#', end: '$'},
	      {className: 'date', begin: '\'\\d{2}\\.\\d{2}\\.(\\d{2}|\\d{4})\''}
	    ]
	  };
	};

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      // IP
	      {
	        className: 'number',
	        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
	      },
	      // Other numbers
	      {
	        className: 'number',
	        begin: '\\b\\d+\\b',
	        relevance: 0
	      },
	      // Requests
	      {
	        className: 'string',
	        begin: '"(GET|POST|HEAD|PUT|DELETE|CONNECT|OPTIONS|PATCH|TRACE)', end: '"',
	        keywords: 'GET POST HEAD PUT DELETE CONNECT OPTIONS PATCH TRACE',
	        illegal: '\\n',
	        relevance: 10
	      },
	      // Dates
	      {
	        className: 'string',
	        begin: /\[/, end: /\]/,
	        illegal: '\\n'
	      },
	      // Strings
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        illegal: '\\n'
	      }
	    ]
	  };
	};

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
	  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';
	
	  var AS3_REST_ARG_MODE = {
	    className: 'rest_arg',
	    begin: '[.]{3}', end: IDENT_RE,
	    relevance: 10
	  };
	
	  return {
	    aliases: ['as'],
	    keywords: {
	      keyword: 'as break case catch class const continue default delete do dynamic each ' +
	        'else extends final finally for function get if implements import in include ' +
	        'instanceof interface internal is namespace native new override package private ' +
	        'protected public return set static super switch this throw try typeof use var void ' +
	        'while with',
	      literal: 'true false null undefined'
	    },
	    contains: [
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'package',
	        beginKeywords: 'package', end: '{',
	        contains: [hljs.TITLE_MODE]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.TITLE_MODE
	        ]
	      },
	      {
	        className: 'preprocessor',
	        beginKeywords: 'import include', end: ';'
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
	        illegal: '\\S',
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              AS3_REST_ARG_MODE
	            ]
	          },
	          {
	            className: 'type',
	            begin: ':',
	            end: IDENT_FUNC_RETURN_TYPE_RE,
	            relevance: 10
	          }
	        ]
	      }
	    ],
	    illegal: /#/
	  };
	};

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUMBER = {className: 'number', begin: '[\\$%]\\d+'};
	  return {
	    aliases: ['apacheconf'],
	    case_insensitive: true,
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {className: 'tag', begin: '</?', end: '>'},
	      {
	        className: 'keyword',
	        begin: /\w+/,
	        relevance: 0,
	        // keywords aren’t needed for highlighting per se, they only boost relevance
	        // for a very generally defined mode (starts with a word, ends with line-end
	        keywords: {
	          common:
	            'order deny allow setenv rewriterule rewriteengine rewritecond documentroot ' +
	            'sethandler errordocument loadmodule options header listen serverroot ' +
	            'servername'
	        },
	        starts: {
	          end: /$/,
	          relevance: 0,
	          keywords: {
	            literal: 'on off all'
	          },
	          contains: [
	            {
	              className: 'sqbracket',
	              begin: '\\s\\[', end: '\\]$'
	            },
	            {
	              className: 'cbracket',
	              begin: '[\\$%]\\{', end: '\\}',
	              contains: ['self', NUMBER]
	            },
	            NUMBER,
	            hljs.QUOTE_STRING_MODE
	          ]
	        }
	      }
	    ],
	    illegal: /\S/
	  };
	};

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: ''});
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)',
	    contains: ['self', hljs.C_NUMBER_MODE, STRING]
	  };
	  var COMMENT_MODE_1 = hljs.COMMENT('--', '$');
	  var COMMENT_MODE_2 = hljs.COMMENT(
	    '\\(\\*',
	    '\\*\\)',
	    {
	      contains: ['self', COMMENT_MODE_1] //allow nesting
	    }
	  );
	  var COMMENTS = [
	    COMMENT_MODE_1,
	    COMMENT_MODE_2,
	    hljs.HASH_COMMENT_MODE
	  ];
	
	  return {
	    aliases: ['osascript'],
	    keywords: {
	      keyword:
	        'about above after against and around as at back before beginning ' +
	        'behind below beneath beside between but by considering ' +
	        'contain contains continue copy div does eighth else end equal ' +
	        'equals error every exit fifth first for fourth from front ' +
	        'get given global if ignoring in into is it its last local me ' +
	        'middle mod my ninth not of on onto or over prop property put ref ' +
	        'reference repeat returning script second set seventh since ' +
	        'sixth some tell tenth that the|0 then third through thru ' +
	        'timeout times to transaction try until where while whose with ' +
	        'without',
	      constant:
	        'AppleScript false linefeed return pi quote result space tab true',
	      type:
	        'alias application boolean class constant date file integer list ' +
	        'number real record string text',
	      command:
	        'activate beep count delay launch log offset read round ' +
	        'run say summarize write',
	      property:
	        'character characters contents day frontmost id item length ' +
	        'month name paragraph paragraphs rest reverse running time version ' +
	        'weekday word words year'
	    },
	    contains: [
	      STRING,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'type',
	        begin: '\\bPOSIX file\\b'
	      },
	      {
	        className: 'command',
	        begin:
	          '\\b(clipboard info|the clipboard|info for|list (disks|folder)|' +
	          'mount volume|path to|(close|open for) access|(get|set) eof|' +
	          'current date|do shell script|get volume settings|random number|' +
	          'set volume|system attribute|system info|time to GMT|' +
	          '(load|run|store) script|scripting components|' +
	          'ASCII (character|number)|localized string|' +
	          'choose (application|color|file|file name|' +
	          'folder|from list|remote application|URL)|' +
	          'display (alert|dialog))\\b|^\\s*return\\b'
	      },
	      {
	        className: 'constant',
	        begin:
	          '\\b(text item delimiters|current application|missing value)\\b'
	      },
	      {
	        className: 'keyword',
	        begin:
	          '\\b(apart from|aside from|instead of|out of|greater than|' +
	          "isn't|(doesn't|does not) (equal|come before|come after|contain)|" +
	          '(greater|less) than( or equal)?|(starts?|ends|begins?) with|' +
	          'contained by|comes (before|after)|a (ref|reference))\\b'
	      },
	      {
	        className: 'property',
	        begin:
	          '\\b(POSIX path|(date|time) string|quoted form)\\b'
	      },
	      {
	        className: 'function_start',
	        beginKeywords: 'on',
	        illegal: '[${=;\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      }
	    ].concat(COMMENTS),
	    illegal: '//|->|=>|\\[\\['
	  };
	};

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    //local labels: %?[FB]?[AT]?\d{1,2}\w+
	  return {
	    case_insensitive: true,
	    aliases: ['arm'],
	    lexemes: '\\.?' + hljs.IDENT_RE,
	    keywords: {
	      literal:
	        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 '+ //standard registers
	        'pc lr sp ip sl sb fp '+ //typical regs plus backward compatibility
	        'a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 '+ //more regs and fp
	        'p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 '+ //coprocessor regs
	        'c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 '+ //more coproc
	        'q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 '+ //advanced SIMD NEON regs
	
	        //program status registers
	        'cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf '+
	        'spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf '+
	
	        //NEON and VFP registers
	        's0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 '+
	        's16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 '+
	        'd0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 '+
	        'd16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 ',
	    preprocessor:
	        //GNU preprocs
	        '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg '+
	        //ARM directives
	        'ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ',
	    built_in:
	        '{PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @ '
	    },
	    contains: [
	      {
	        className: 'keyword',
	        begin: '\\b('+     //mnemonics
	            'adc|'+
	            '(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|'+
	            'and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|'+
	            'bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|'+
	            'setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|'+
	            'ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|'+
	            'mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|'+
	            'mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|'+
	            'mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|'+
	            'rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|'+
	            'stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|'+
	            '[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|'+
	            'wfe|wfi|yield'+
	        ')'+
	        '(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?'+ //condition codes
	        '[sptrx]?' ,                                             //legal postfixes
	        end: '\\s'
	      },
	      hljs.COMMENT('[;@]', '$', {relevance: 0}),
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'',
	        end: '[^\\\\]\'',
	        relevance: 0
	      },
	      {
	        className: 'title',
	        begin: '\\|', end: '\\|',
	        illegal: '\\n',
	        relevance: 0
	      },
	      {
	        className: 'number',
	        variants: [
	            {begin: '[#$=]?0x[0-9a-f]+'}, //hex
	            {begin: '[#$=]?0b[01]+'},     //bin
	            {begin: '[#$=]\\d+'},        //literal
	            {begin: '\\b\\d+'}           //bare number
	        ],
	        relevance: 0
	      },
	      {
	        className: 'label',
	        variants: [
	            {begin: '^[a-z_\\.\\$][a-z0-9_\\.\\$]+'}, //ARM syntax
	            {begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'}, //GNU ARM syntax
	            {begin: '[=#]\\w+' }  //label reference
	        ],
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['adoc'],
	    contains: [
	      // block comment
	      hljs.COMMENT(
	        '^/{4,}\\n',
	        '\\n/{4,}$',
	        // can also be done as...
	        //'^/{4,}$',
	        //'^/{4,}$',
	        {
	          relevance: 10
	        }
	      ),
	      // line comment
	      hljs.COMMENT(
	        '^//',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      // title
	      {
	        className: 'title',
	        begin: '^\\.\\w.*$'
	      },
	      // example, admonition & sidebar blocks
	      {
	        begin: '^[=\\*]{4,}\\n',
	        end: '\\n^[=\\*]{4,}$',
	        relevance: 10
	      },
	      // headings
	      {
	        className: 'header',
	        begin: '^(={1,5}) .+?( \\1)?$',
	        relevance: 10
	      },
	      {
	        className: 'header',
	        begin: '^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$',
	        relevance: 10
	      },
	      // document attributes
	      {
	        className: 'attribute',
	        begin: '^:.+?:',
	        end: '\\s',
	        excludeEnd: true,
	        relevance: 10
	      },
	      // block attributes
	      {
	        className: 'attribute',
	        begin: '^\\[.+?\\]$',
	        relevance: 0
	      },
	      // quoteblocks
	      {
	        className: 'blockquote',
	        begin: '^_{4,}\\n',
	        end: '\\n_{4,}$',
	        relevance: 10
	      },
	      // listing and literal blocks
	      {
	        className: 'code',
	        begin: '^[\\-\\.]{4,}\\n',
	        end: '\\n[\\-\\.]{4,}$',
	        relevance: 10
	      },
	      // passthrough blocks
	      {
	        begin: '^\\+{4,}\\n',
	        end: '\\n\\+{4,}$',
	        contains: [
	          {
	            begin: '<', end: '>',
	            subLanguage: 'xml',
	            relevance: 0
	          }
	        ],
	        relevance: 10
	      },
	      // lists (can only capture indicators)
	      {
	        className: 'bullet',
	        begin: '^(\\*+|\\-+|\\.+|[^\\n]+?::)\\s+'
	      },
	      // admonition
	      {
	        className: 'label',
	        begin: '^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+',
	        relevance: 10
	      },
	      // inline strong
	      {
	        className: 'strong',
	        // must not follow a word character or be followed by an asterisk or space
	        begin: '\\B\\*(?![\\*\\s])',
	        end: '(\\n{2}|\\*)',
	        // allow escaped asterisk followed by word char
	        contains: [
	          {
	            begin: '\\\\*\\w',
	            relevance: 0
	          }
	        ]
	      },
	      // inline emphasis
	      {
	        className: 'emphasis',
	        // must not follow a word character or be followed by a single quote or space
	        begin: '\\B\'(?![\'\\s])',
	        end: '(\\n{2}|\')',
	        // allow escaped single quote followed by word char
	        contains: [
	          {
	            begin: '\\\\\'\\w',
	            relevance: 0
	          }
	        ],
	        relevance: 0
	      },
	      // inline emphasis (alt)
	      {
	        className: 'emphasis',
	        // must not follow a word character or be followed by an underline or space
	        begin: '_(?![_\\s])',
	        end: '(\\n{2}|_)',
	        relevance: 0
	      },
	      // inline smart quotes
	      {
	        className: 'smartquote',
	        variants: [
	          {begin: "``.+?''"},
	          {begin: "`.+?'"}
	        ]
	      },
	      // inline code snippets (TODO should get same treatment as strong and emphasis)
	      {
	        className: 'code',
	        begin: '(`.+?`|\\+.+?\\+)',
	        relevance: 0
	      },
	      // indented literal block
	      {
	        className: 'code',
	        begin: '^[ \\t]',
	        end: '$',
	        relevance: 0
	      },
	      // horizontal rules
	      {
	        className: 'horizontal_rule',
	        begin: '^\'{3,}[ \\t]*$',
	        relevance: 10
	      },
	      // images and links
	      {
	        begin: '(link:)?(http|https|ftp|file|irc|image:?):\\S+\\[.*?\\]',
	        returnBegin: true,
	        contains: [
	          {
	            //className: 'macro',
	            begin: '(link|image:?):',
	            relevance: 0
	          },
	          {
	            className: 'link_url',
	            begin: '\\w',
	            end: '[^\\[]+',
	            relevance: 0
	          },
	          {
	            className: 'link_label',
	            begin: '\\[',
	            end: '\\]',
	            excludeBegin: true,
	            excludeEnd: true,
	            relevance: 0
	          }
	        ],
	        relevance: 10
	      }
	    ]
	  };
	};

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var KEYWORDS =
	    'false synchronized int abstract float private char boolean static null if const ' +
	    'for true while long throw strictfp finally protected import native final return void ' +
	    'enum else extends implements break transient new catch instanceof byte super volatile case ' +
	    'assert short package default double public try this switch continue throws privileged ' +
	    'aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization ' +
	    'staticinitialization withincode target within execution getWithinTypeName handler ' +
	    'thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents '+
	    'warning error soft precedence thisAspectInstance';
	  var SHORTKEYS = 'get set args call';
	  return {
	    keywords : KEYWORDS,
	    illegal : /<\/|#/,
	    contains : [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [{
	            className : 'doctag',
	            begin : '@[A-Za-z]+'
	          }]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className : 'aspect',
	        beginKeywords : 'aspect',
	        end : /[{;=]/,
	        excludeEnd : true,
	        illegal : /[:;"\[\]]/,
	        contains : [
	          {
	            beginKeywords : 'extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton'
	          },
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            begin : /\([^\)]*/,
	            end : /[)]+/,
	            keywords : KEYWORDS + ' ' + SHORTKEYS,
	            excludeEnd : false
	          }
	        ]
	      },
	      {
	        className : 'class',
	        beginKeywords : 'class interface',
	        end : /[{;=]/,
	        excludeEnd : true,
	        relevance: 0,
	        keywords : 'class interface',
	        illegal : /[:"\[\]]/,
	        contains : [
	          {beginKeywords : 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        // AspectJ Constructs
	        beginKeywords : 'pointcut after before around throwing returning',
	        end : /[)]/,
	        excludeEnd : false,
	        illegal : /["\[\]]/,
	        contains : [
	          {
	            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
	            returnBegin : true,
	            contains : [hljs.UNDERSCORE_TITLE_MODE]
	          }
	        ]
	      },
	      {
	        begin : /[:]/,
	        returnBegin : true,
	        end : /[{;]/,
	        relevance: 0,
	        excludeEnd : false,
	        keywords : KEYWORDS,
	        illegal : /["\[\]]/,
	        contains : [
	          {
	            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
	            keywords : KEYWORDS + ' ' + SHORTKEYS
	          },
	          hljs.QUOTE_STRING_MODE
	        ]
	      },
	      {
	        // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
	        beginKeywords : 'new throw',
	        relevance : 0
	      },
	      {
	        // the function class is a bit different for AspectJ compared to the Java language
	        className : 'function',
	        begin : /\w+ +\w+(\.)?\w+\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
	        returnBegin : true,
	        end : /[{;=]/,
	        keywords : KEYWORDS,
	        excludeEnd : true,
	        contains : [
	          {
	            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
	            returnBegin : true,
	            relevance: 0,
	            contains : [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className : 'params',
	            begin : /\(/, end : /\)/,
	            relevance: 0,
	            keywords : KEYWORDS,
	            contains : [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      hljs.C_NUMBER_MODE,
	      {
	        // annotation is also used in this language
	        className : 'annotation',
	        begin : '@[A-Za-z]+'
	      }
	    ]
	  };
	};

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BACKTICK_ESCAPE = {
	    className: 'escape',
	    begin: '`[\\s\\S]'
	  };
	  var COMMENTS = hljs.COMMENT(
	    ';',
	    '$',
	    {
	      relevance: 0
	    }
	  );
	  var BUILT_IN = [
	    {
	      className: 'built_in',
	      begin: 'A_[a-zA-Z0-9]+'
	    },
	    {
	      className: 'built_in',
	      beginKeywords: 'ComSpec Clipboard ClipboardAll ErrorLevel'
	    }
	  ];
	
	  return {
	    case_insensitive: true,
	    keywords: {
	      keyword: 'Break Continue Else Gosub If Loop Return While',
	      literal: 'A true false NOT AND OR'
	    },
	    contains: BUILT_IN.concat([
	      BACKTICK_ESCAPE,
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [BACKTICK_ESCAPE]}),
	      COMMENTS,
	      {
	        className: 'number',
	        begin: hljs.NUMBER_RE,
	        relevance: 0
	      },
	      {
	        className: 'var_expand', // FIXME
	        begin: '%', end: '%',
	        illegal: '\\n',
	        contains: [BACKTICK_ESCAPE]
	      },
	      {
	        className: 'label',
	        contains: [BACKTICK_ESCAPE],
	        variants: [
	          {begin: '^[^\\n";]+::(?!=)'},
	          {begin: '^[^\\n";]+:(?!=)', relevance: 0} // zero relevance as it catches a lot of things
	                                                    // followed by a single ':' in many languages
	        ]
	      },
	      {
	        // consecutive commas, not for highlighting but just for relevance
	        begin: ',\\s*,',
	        relevance: 10
	      }
	    ])
	  }
	};

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    var KEYWORDS = 'ByRef Case Const ContinueCase ContinueLoop ' +
	        'Default Dim Do Else ElseIf EndFunc EndIf EndSelect ' +
	        'EndSwitch EndWith Enum Exit ExitLoop For Func ' +
	        'Global If In Local Next ReDim Return Select Static ' +
	        'Step Switch Then To Until Volatile WEnd While With',
	
	        LITERAL = 'True False And Null Not Or',
	
	        BUILT_IN = 'Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin ' +
	        'Assign ATan AutoItSetOption AutoItWinGetTitle ' +
	        'AutoItWinSetTitle Beep Binary BinaryLen BinaryMid ' +
	        'BinaryToString BitAND BitNOT BitOR BitRotate BitShift ' +
	        'BitXOR BlockInput Break Call CDTray Ceiling Chr ' +
	        'ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ' +
	        'ConsoleWriteError ControlClick ControlCommand ' +
	        'ControlDisable ControlEnable ControlFocus ControlGetFocus ' +
	        'ControlGetHandle ControlGetPos ControlGetText ControlHide ' +
	        'ControlListView ControlMove ControlSend ControlSetText ' +
	        'ControlShow ControlTreeView Cos Dec DirCopy DirCreate ' +
	        'DirGetSize DirMove DirRemove DllCall DllCallAddress ' +
	        'DllCallbackFree DllCallbackGetPtr DllCallbackRegister ' +
	        'DllClose DllOpen DllStructCreate DllStructGetData ' +
	        'DllStructGetPtr DllStructGetSize DllStructSetData ' +
	        'DriveGetDrive DriveGetFileSystem DriveGetLabel ' +
	        'DriveGetSerial DriveGetType DriveMapAdd DriveMapDel ' +
	        'DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal ' +
	        'DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp ' +
	        'FileChangeDir FileClose FileCopy FileCreateNTFSLink ' +
	        'FileCreateShortcut FileDelete FileExists FileFindFirstFile ' +
	        'FileFindNextFile FileFlush FileGetAttrib FileGetEncoding ' +
	        'FileGetLongName FileGetPos FileGetShortcut FileGetShortName ' +
	        'FileGetSize FileGetTime FileGetVersion FileInstall ' +
	        'FileMove FileOpen FileOpenDialog FileRead FileReadLine ' +
	        'FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog ' +
	        'FileSelectFolder FileSetAttrib FileSetEnd FileSetPos ' +
	        'FileSetTime FileWrite FileWriteLine Floor FtpSetProxy ' +
	        'FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton ' +
	        'GUICtrlCreateCheckbox GUICtrlCreateCombo ' +
	        'GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy ' +
	        'GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup ' +
	        'GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel ' +
	        'GUICtrlCreateList GUICtrlCreateListView ' +
	        'GUICtrlCreateListViewItem GUICtrlCreateMenu ' +
	        'GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj ' +
	        'GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio ' +
	        'GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem ' +
	        'GUICtrlCreateTreeView GUICtrlCreateTreeViewItem ' +
	        'GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle ' +
	        'GUICtrlGetState GUICtrlRead GUICtrlRecvMsg ' +
	        'GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy ' +
	        'GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor ' +
	        'GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor ' +
	        'GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage ' +
	        'GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos ' +
	        'GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle ' +
	        'GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg ' +
	        'GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor ' +
	        'GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon ' +
	        'GUISetOnEvent GUISetState GUISetStyle GUIStartGroup ' +
	        'GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent ' +
	        'HWnd InetClose InetGet InetGetInfo InetGetSize InetRead ' +
	        'IniDelete IniRead IniReadSection IniReadSectionNames ' +
	        'IniRenameSection IniWrite IniWriteSection InputBox Int ' +
	        'IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct ' +
	        'IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj ' +
	        'IsPtr IsString Log MemGetStats Mod MouseClick ' +
	        'MouseClickDrag MouseDown MouseGetCursor MouseGetPos ' +
	        'MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ' +
	        'ObjCreateInterface ObjEvent ObjGet ObjName ' +
	        'OnAutoItExitRegister OnAutoItExitUnRegister Opt Ping ' +
	        'PixelChecksum PixelGetColor PixelSearch ProcessClose ' +
	        'ProcessExists ProcessGetStats ProcessList ' +
	        'ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ' +
	        'ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey ' +
	        'RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait ' +
	        'RunWait Send SendKeepActive SetError SetExtended ' +
	        'ShellExecute ShellExecuteWait Shutdown Sin Sleep ' +
	        'SoundPlay SoundSetWaveVolume SplashImageOn SplashOff ' +
	        'SplashTextOn Sqrt SRandom StatusbarGetText StderrRead ' +
	        'StdinWrite StdioClose StdoutRead String StringAddCR ' +
	        'StringCompare StringFormat StringFromASCIIArray StringInStr ' +
	        'StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit ' +
	        'StringIsFloat StringIsInt StringIsLower StringIsSpace ' +
	        'StringIsUpper StringIsXDigit StringLeft StringLen ' +
	        'StringLower StringMid StringRegExp StringRegExpReplace ' +
	        'StringReplace StringReverse StringRight StringSplit ' +
	        'StringStripCR StringStripWS StringToASCIIArray ' +
	        'StringToBinary StringTrimLeft StringTrimRight StringUpper ' +
	        'Tan TCPAccept TCPCloseSocket TCPConnect TCPListen ' +
	        'TCPNameToIP TCPRecv TCPSend TCPShutdown TCPStartup ' +
	        'TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu ' +
	        'TrayGetMsg TrayItemDelete TrayItemGetHandle ' +
	        'TrayItemGetState TrayItemGetText TrayItemSetOnEvent ' +
	        'TrayItemSetState TrayItemSetText TraySetClick TraySetIcon ' +
	        'TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip ' +
	        'TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv ' +
	        'UDPSend UDPShutdown UDPStartup VarGetType WinActivate ' +
	        'WinActive WinClose WinExists WinFlash WinGetCaretPos ' +
	        'WinGetClassList WinGetClientSize WinGetHandle WinGetPos ' +
	        'WinGetProcess WinGetState WinGetText WinGetTitle WinKill ' +
	        'WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo ' +
	        'WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans ' +
	        'WinWait WinWaitActive WinWaitClose WinWaitNotActive ' +
	        'Array1DToHistogram ArrayAdd ArrayBinarySearch ' +
	        'ArrayColDelete ArrayColInsert ArrayCombinations ' +
	        'ArrayConcatenate ArrayDelete ArrayDisplay ArrayExtract ' +
	        'ArrayFindAll ArrayInsert ArrayMax ArrayMaxIndex ArrayMin ' +
	        'ArrayMinIndex ArrayPermute ArrayPop ArrayPush ' +
	        'ArrayReverse ArraySearch ArrayShuffle ArraySort ArraySwap ' +
	        'ArrayToClip ArrayToString ArrayTranspose ArrayTrim ' +
	        'ArrayUnique Assert ChooseColor ChooseFont ' +
	        'ClipBoard_ChangeChain ClipBoard_Close ClipBoard_CountFormats ' +
	        'ClipBoard_Empty ClipBoard_EnumFormats ClipBoard_FormatStr ' +
	        'ClipBoard_GetData ClipBoard_GetDataEx ClipBoard_GetFormatName ' +
	        'ClipBoard_GetOpenWindow ClipBoard_GetOwner ' +
	        'ClipBoard_GetPriorityFormat ClipBoard_GetSequenceNumber ' +
	        'ClipBoard_GetViewer ClipBoard_IsFormatAvailable ' +
	        'ClipBoard_Open ClipBoard_RegisterFormat ClipBoard_SetData ' +
	        'ClipBoard_SetDataEx ClipBoard_SetViewer ClipPutFile ' +
	        'ColorConvertHSLtoRGB ColorConvertRGBtoHSL ColorGetBlue ' +
	        'ColorGetCOLORREF ColorGetGreen ColorGetRed ColorGetRGB ' +
	        'ColorSetCOLORREF ColorSetRGB Crypt_DecryptData ' +
	        'Crypt_DecryptFile Crypt_DeriveKey Crypt_DestroyKey ' +
	        'Crypt_EncryptData Crypt_EncryptFile Crypt_GenRandom ' +
	        'Crypt_HashData Crypt_HashFile Crypt_Shutdown Crypt_Startup ' +
	        'DateAdd DateDayOfWeek DateDaysInMonth DateDiff ' +
	        'DateIsLeapYear DateIsValid DateTimeFormat DateTimeSplit ' +
	        'DateToDayOfWeek DateToDayOfWeekISO DateToDayValue ' +
	        'DateToMonth Date_Time_CompareFileTime ' +
	        'Date_Time_DOSDateTimeToArray Date_Time_DOSDateTimeToFileTime ' +
	        'Date_Time_DOSDateTimeToStr Date_Time_DOSDateToArray ' +
	        'Date_Time_DOSDateToStr Date_Time_DOSTimeToArray ' +
	        'Date_Time_DOSTimeToStr Date_Time_EncodeFileTime ' +
	        'Date_Time_EncodeSystemTime Date_Time_FileTimeToArray ' +
	        'Date_Time_FileTimeToDOSDateTime ' +
	        'Date_Time_FileTimeToLocalFileTime Date_Time_FileTimeToStr ' +
	        'Date_Time_FileTimeToSystemTime Date_Time_GetFileTime ' +
	        'Date_Time_GetLocalTime Date_Time_GetSystemTime ' +
	        'Date_Time_GetSystemTimeAdjustment ' +
	        'Date_Time_GetSystemTimeAsFileTime Date_Time_GetSystemTimes ' +
	        'Date_Time_GetTickCount Date_Time_GetTimeZoneInformation ' +
	        'Date_Time_LocalFileTimeToFileTime Date_Time_SetFileTime ' +
	        'Date_Time_SetLocalTime Date_Time_SetSystemTime ' +
	        'Date_Time_SetSystemTimeAdjustment ' +
	        'Date_Time_SetTimeZoneInformation Date_Time_SystemTimeToArray ' +
	        'Date_Time_SystemTimeToDateStr Date_Time_SystemTimeToDateTimeStr ' +
	        'Date_Time_SystemTimeToFileTime Date_Time_SystemTimeToTimeStr ' +
	        'Date_Time_SystemTimeToTzSpecificLocalTime ' +
	        'Date_Time_TzSpecificLocalTimeToSystemTime DayValueToDate ' +
	        'DebugBugReportEnv DebugCOMError DebugOut DebugReport ' +
	        'DebugReportEx DebugReportVar DebugSetup Degree ' +
	        'EventLog__Backup EventLog__Clear EventLog__Close ' +
	        'EventLog__Count EventLog__DeregisterSource EventLog__Full ' +
	        'EventLog__Notify EventLog__Oldest EventLog__Open ' +
	        'EventLog__OpenBackup EventLog__Read EventLog__RegisterSource ' +
	        'EventLog__Report Excel_BookAttach Excel_BookClose ' +
	        'Excel_BookList Excel_BookNew Excel_BookOpen ' +
	        'Excel_BookOpenText Excel_BookSave Excel_BookSaveAs ' +
	        'Excel_Close Excel_ColumnToLetter Excel_ColumnToNumber ' +
	        'Excel_ConvertFormula Excel_Export Excel_FilterGet ' +
	        'Excel_FilterSet Excel_Open Excel_PictureAdd Excel_Print ' +
	        'Excel_RangeCopyPaste Excel_RangeDelete Excel_RangeFind ' +
	        'Excel_RangeInsert Excel_RangeLinkAddRemove Excel_RangeRead ' +
	        'Excel_RangeReplace Excel_RangeSort Excel_RangeValidate ' +
	        'Excel_RangeWrite Excel_SheetAdd Excel_SheetCopyMove ' +
	        'Excel_SheetDelete Excel_SheetList FileCountLines FileCreate ' +
	        'FileListToArray FileListToArrayRec FilePrint ' +
	        'FileReadToArray FileWriteFromArray FileWriteLog ' +
	        'FileWriteToLine FTP_Close FTP_Command FTP_Connect ' +
	        'FTP_DecodeInternetStatus FTP_DirCreate FTP_DirDelete ' +
	        'FTP_DirGetCurrent FTP_DirPutContents FTP_DirSetCurrent ' +
	        'FTP_FileClose FTP_FileDelete FTP_FileGet FTP_FileGetSize ' +
	        'FTP_FileOpen FTP_FilePut FTP_FileRead FTP_FileRename ' +
	        'FTP_FileTimeLoHiToStr FTP_FindFileClose FTP_FindFileFirst ' +
	        'FTP_FindFileNext FTP_GetLastResponseInfo FTP_ListToArray ' +
	        'FTP_ListToArray2D FTP_ListToArrayEx FTP_Open ' +
	        'FTP_ProgressDownload FTP_ProgressUpload FTP_SetStatusCallback ' +
	        'GDIPlus_ArrowCapCreate GDIPlus_ArrowCapDispose ' +
	        'GDIPlus_ArrowCapGetFillState GDIPlus_ArrowCapGetHeight ' +
	        'GDIPlus_ArrowCapGetMiddleInset GDIPlus_ArrowCapGetWidth ' +
	        'GDIPlus_ArrowCapSetFillState GDIPlus_ArrowCapSetHeight ' +
	        'GDIPlus_ArrowCapSetMiddleInset GDIPlus_ArrowCapSetWidth ' +
	        'GDIPlus_BitmapApplyEffect GDIPlus_BitmapApplyEffectEx ' +
	        'GDIPlus_BitmapCloneArea GDIPlus_BitmapConvertFormat ' +
	        'GDIPlus_BitmapCreateApplyEffect ' +
	        'GDIPlus_BitmapCreateApplyEffectEx ' +
	        'GDIPlus_BitmapCreateDIBFromBitmap GDIPlus_BitmapCreateFromFile ' +
	        'GDIPlus_BitmapCreateFromGraphics ' +
	        'GDIPlus_BitmapCreateFromHBITMAP GDIPlus_BitmapCreateFromHICON ' +
	        'GDIPlus_BitmapCreateFromHICON32 GDIPlus_BitmapCreateFromMemory ' +
	        'GDIPlus_BitmapCreateFromResource GDIPlus_BitmapCreateFromScan0 ' +
	        'GDIPlus_BitmapCreateFromStream ' +
	        'GDIPlus_BitmapCreateHBITMAPFromBitmap GDIPlus_BitmapDispose ' +
	        'GDIPlus_BitmapGetHistogram GDIPlus_BitmapGetHistogramEx ' +
	        'GDIPlus_BitmapGetHistogramSize GDIPlus_BitmapGetPixel ' +
	        'GDIPlus_BitmapLockBits GDIPlus_BitmapSetPixel ' +
	        'GDIPlus_BitmapUnlockBits GDIPlus_BrushClone ' +
	        'GDIPlus_BrushCreateSolid GDIPlus_BrushDispose ' +
	        'GDIPlus_BrushGetSolidColor GDIPlus_BrushGetType ' +
	        'GDIPlus_BrushSetSolidColor GDIPlus_ColorMatrixCreate ' +
	        'GDIPlus_ColorMatrixCreateGrayScale ' +
	        'GDIPlus_ColorMatrixCreateNegative ' +
	        'GDIPlus_ColorMatrixCreateSaturation ' +
	        'GDIPlus_ColorMatrixCreateScale ' +
	        'GDIPlus_ColorMatrixCreateTranslate GDIPlus_CustomLineCapClone ' +
	        'GDIPlus_CustomLineCapCreate GDIPlus_CustomLineCapDispose ' +
	        'GDIPlus_CustomLineCapGetStrokeCaps ' +
	        'GDIPlus_CustomLineCapSetStrokeCaps GDIPlus_Decoders ' +
	        'GDIPlus_DecodersGetCount GDIPlus_DecodersGetSize ' +
	        'GDIPlus_DrawImageFX GDIPlus_DrawImageFXEx ' +
	        'GDIPlus_DrawImagePoints GDIPlus_EffectCreate ' +
	        'GDIPlus_EffectCreateBlur GDIPlus_EffectCreateBrightnessContrast ' +
	        'GDIPlus_EffectCreateColorBalance GDIPlus_EffectCreateColorCurve ' +
	        'GDIPlus_EffectCreateColorLUT GDIPlus_EffectCreateColorMatrix ' +
	        'GDIPlus_EffectCreateHueSaturationLightness ' +
	        'GDIPlus_EffectCreateLevels GDIPlus_EffectCreateRedEyeCorrection ' +
	        'GDIPlus_EffectCreateSharpen GDIPlus_EffectCreateTint ' +
	        'GDIPlus_EffectDispose GDIPlus_EffectGetParameters ' +
	        'GDIPlus_EffectSetParameters GDIPlus_Encoders ' +
	        'GDIPlus_EncodersGetCLSID GDIPlus_EncodersGetCount ' +
	        'GDIPlus_EncodersGetParamList GDIPlus_EncodersGetParamListSize ' +
	        'GDIPlus_EncodersGetSize GDIPlus_FontCreate ' +
	        'GDIPlus_FontDispose GDIPlus_FontFamilyCreate ' +
	        'GDIPlus_FontFamilyCreateFromCollection ' +
	        'GDIPlus_FontFamilyDispose GDIPlus_FontFamilyGetCellAscent ' +
	        'GDIPlus_FontFamilyGetCellDescent GDIPlus_FontFamilyGetEmHeight ' +
	        'GDIPlus_FontFamilyGetLineSpacing GDIPlus_FontGetHeight ' +
	        'GDIPlus_FontPrivateAddFont GDIPlus_FontPrivateAddMemoryFont ' +
	        'GDIPlus_FontPrivateCollectionDispose ' +
	        'GDIPlus_FontPrivateCreateCollection GDIPlus_GraphicsClear ' +
	        'GDIPlus_GraphicsCreateFromHDC GDIPlus_GraphicsCreateFromHWND ' +
	        'GDIPlus_GraphicsDispose GDIPlus_GraphicsDrawArc ' +
	        'GDIPlus_GraphicsDrawBezier GDIPlus_GraphicsDrawClosedCurve ' +
	        'GDIPlus_GraphicsDrawClosedCurve2 GDIPlus_GraphicsDrawCurve ' +
	        'GDIPlus_GraphicsDrawCurve2 GDIPlus_GraphicsDrawEllipse ' +
	        'GDIPlus_GraphicsDrawImage GDIPlus_GraphicsDrawImagePointsRect ' +
	        'GDIPlus_GraphicsDrawImageRect GDIPlus_GraphicsDrawImageRectRect ' +
	        'GDIPlus_GraphicsDrawLine GDIPlus_GraphicsDrawPath ' +
	        'GDIPlus_GraphicsDrawPie GDIPlus_GraphicsDrawPolygon ' +
	        'GDIPlus_GraphicsDrawRect GDIPlus_GraphicsDrawString ' +
	        'GDIPlus_GraphicsDrawStringEx GDIPlus_GraphicsFillClosedCurve ' +
	        'GDIPlus_GraphicsFillClosedCurve2 GDIPlus_GraphicsFillEllipse ' +
	        'GDIPlus_GraphicsFillPath GDIPlus_GraphicsFillPie ' +
	        'GDIPlus_GraphicsFillPolygon GDIPlus_GraphicsFillRect ' +
	        'GDIPlus_GraphicsFillRegion GDIPlus_GraphicsGetCompositingMode ' +
	        'GDIPlus_GraphicsGetCompositingQuality GDIPlus_GraphicsGetDC ' +
	        'GDIPlus_GraphicsGetInterpolationMode ' +
	        'GDIPlus_GraphicsGetSmoothingMode GDIPlus_GraphicsGetTransform ' +
	        'GDIPlus_GraphicsMeasureCharacterRanges ' +
	        'GDIPlus_GraphicsMeasureString GDIPlus_GraphicsReleaseDC ' +
	        'GDIPlus_GraphicsResetClip GDIPlus_GraphicsResetTransform ' +
	        'GDIPlus_GraphicsRestore GDIPlus_GraphicsRotateTransform ' +
	        'GDIPlus_GraphicsSave GDIPlus_GraphicsScaleTransform ' +
	        'GDIPlus_GraphicsSetClipPath GDIPlus_GraphicsSetClipRect ' +
	        'GDIPlus_GraphicsSetClipRegion ' +
	        'GDIPlus_GraphicsSetCompositingMode ' +
	        'GDIPlus_GraphicsSetCompositingQuality ' +
	        'GDIPlus_GraphicsSetInterpolationMode ' +
	        'GDIPlus_GraphicsSetPixelOffsetMode ' +
	        'GDIPlus_GraphicsSetSmoothingMode ' +
	        'GDIPlus_GraphicsSetTextRenderingHint ' +
	        'GDIPlus_GraphicsSetTransform GDIPlus_GraphicsTransformPoints ' +
	        'GDIPlus_GraphicsTranslateTransform GDIPlus_HatchBrushCreate ' +
	        'GDIPlus_HICONCreateFromBitmap GDIPlus_ImageAttributesCreate ' +
	        'GDIPlus_ImageAttributesDispose ' +
	        'GDIPlus_ImageAttributesSetColorKeys ' +
	        'GDIPlus_ImageAttributesSetColorMatrix GDIPlus_ImageDispose ' +
	        'GDIPlus_ImageGetDimension GDIPlus_ImageGetFlags ' +
	        'GDIPlus_ImageGetGraphicsContext GDIPlus_ImageGetHeight ' +
	        'GDIPlus_ImageGetHorizontalResolution ' +
	        'GDIPlus_ImageGetPixelFormat GDIPlus_ImageGetRawFormat ' +
	        'GDIPlus_ImageGetThumbnail GDIPlus_ImageGetType ' +
	        'GDIPlus_ImageGetVerticalResolution GDIPlus_ImageGetWidth ' +
	        'GDIPlus_ImageLoadFromFile GDIPlus_ImageLoadFromStream ' +
	        'GDIPlus_ImageResize GDIPlus_ImageRotateFlip ' +
	        'GDIPlus_ImageSaveToFile GDIPlus_ImageSaveToFileEx ' +
	        'GDIPlus_ImageSaveToStream GDIPlus_ImageScale ' +
	        'GDIPlus_LineBrushCreate GDIPlus_LineBrushCreateFromRect ' +
	        'GDIPlus_LineBrushCreateFromRectWithAngle ' +
	        'GDIPlus_LineBrushGetColors GDIPlus_LineBrushGetRect ' +
	        'GDIPlus_LineBrushMultiplyTransform ' +
	        'GDIPlus_LineBrushResetTransform GDIPlus_LineBrushSetBlend ' +
	        'GDIPlus_LineBrushSetColors GDIPlus_LineBrushSetGammaCorrection ' +
	        'GDIPlus_LineBrushSetLinearBlend GDIPlus_LineBrushSetPresetBlend ' +
	        'GDIPlus_LineBrushSetSigmaBlend GDIPlus_LineBrushSetTransform ' +
	        'GDIPlus_MatrixClone GDIPlus_MatrixCreate ' +
	        'GDIPlus_MatrixDispose GDIPlus_MatrixGetElements ' +
	        'GDIPlus_MatrixInvert GDIPlus_MatrixMultiply ' +
	        'GDIPlus_MatrixRotate GDIPlus_MatrixScale ' +
	        'GDIPlus_MatrixSetElements GDIPlus_MatrixShear ' +
	        'GDIPlus_MatrixTransformPoints GDIPlus_MatrixTranslate ' +
	        'GDIPlus_PaletteInitialize GDIPlus_ParamAdd GDIPlus_ParamInit ' +
	        'GDIPlus_ParamSize GDIPlus_PathAddArc GDIPlus_PathAddBezier ' +
	        'GDIPlus_PathAddClosedCurve GDIPlus_PathAddClosedCurve2 ' +
	        'GDIPlus_PathAddCurve GDIPlus_PathAddCurve2 ' +
	        'GDIPlus_PathAddCurve3 GDIPlus_PathAddEllipse ' +
	        'GDIPlus_PathAddLine GDIPlus_PathAddLine2 GDIPlus_PathAddPath ' +
	        'GDIPlus_PathAddPie GDIPlus_PathAddPolygon ' +
	        'GDIPlus_PathAddRectangle GDIPlus_PathAddString ' +
	        'GDIPlus_PathBrushCreate GDIPlus_PathBrushCreateFromPath ' +
	        'GDIPlus_PathBrushGetCenterPoint GDIPlus_PathBrushGetFocusScales ' +
	        'GDIPlus_PathBrushGetPointCount GDIPlus_PathBrushGetRect ' +
	        'GDIPlus_PathBrushGetWrapMode GDIPlus_PathBrushMultiplyTransform ' +
	        'GDIPlus_PathBrushResetTransform GDIPlus_PathBrushSetBlend ' +
	        'GDIPlus_PathBrushSetCenterColor GDIPlus_PathBrushSetCenterPoint ' +
	        'GDIPlus_PathBrushSetFocusScales ' +
	        'GDIPlus_PathBrushSetGammaCorrection ' +
	        'GDIPlus_PathBrushSetLinearBlend GDIPlus_PathBrushSetPresetBlend ' +
	        'GDIPlus_PathBrushSetSigmaBlend ' +
	        'GDIPlus_PathBrushSetSurroundColor ' +
	        'GDIPlus_PathBrushSetSurroundColorsWithCount ' +
	        'GDIPlus_PathBrushSetTransform GDIPlus_PathBrushSetWrapMode ' +
	        'GDIPlus_PathClone GDIPlus_PathCloseFigure GDIPlus_PathCreate ' +
	        'GDIPlus_PathCreate2 GDIPlus_PathDispose GDIPlus_PathFlatten ' +
	        'GDIPlus_PathGetData GDIPlus_PathGetFillMode ' +
	        'GDIPlus_PathGetLastPoint GDIPlus_PathGetPointCount ' +
	        'GDIPlus_PathGetPoints GDIPlus_PathGetWorldBounds ' +
	        'GDIPlus_PathIsOutlineVisiblePoint GDIPlus_PathIsVisiblePoint ' +
	        'GDIPlus_PathIterCreate GDIPlus_PathIterDispose ' +
	        'GDIPlus_PathIterGetSubpathCount GDIPlus_PathIterNextMarkerPath ' +
	        'GDIPlus_PathIterNextSubpathPath GDIPlus_PathIterRewind ' +
	        'GDIPlus_PathReset GDIPlus_PathReverse GDIPlus_PathSetFillMode ' +
	        'GDIPlus_PathSetMarker GDIPlus_PathStartFigure ' +
	        'GDIPlus_PathTransform GDIPlus_PathWarp GDIPlus_PathWiden ' +
	        'GDIPlus_PathWindingModeOutline GDIPlus_PenCreate ' +
	        'GDIPlus_PenCreate2 GDIPlus_PenDispose GDIPlus_PenGetAlignment ' +
	        'GDIPlus_PenGetColor GDIPlus_PenGetCustomEndCap ' +
	        'GDIPlus_PenGetDashCap GDIPlus_PenGetDashStyle ' +
	        'GDIPlus_PenGetEndCap GDIPlus_PenGetMiterLimit ' +
	        'GDIPlus_PenGetWidth GDIPlus_PenSetAlignment ' +
	        'GDIPlus_PenSetColor GDIPlus_PenSetCustomEndCap ' +
	        'GDIPlus_PenSetDashCap GDIPlus_PenSetDashStyle ' +
	        'GDIPlus_PenSetEndCap GDIPlus_PenSetLineCap ' +
	        'GDIPlus_PenSetLineJoin GDIPlus_PenSetMiterLimit ' +
	        'GDIPlus_PenSetStartCap GDIPlus_PenSetWidth ' +
	        'GDIPlus_RectFCreate GDIPlus_RegionClone ' +
	        'GDIPlus_RegionCombinePath GDIPlus_RegionCombineRect ' +
	        'GDIPlus_RegionCombineRegion GDIPlus_RegionCreate ' +
	        'GDIPlus_RegionCreateFromPath GDIPlus_RegionCreateFromRect ' +
	        'GDIPlus_RegionDispose GDIPlus_RegionGetBounds ' +
	        'GDIPlus_RegionGetHRgn GDIPlus_RegionTransform ' +
	        'GDIPlus_RegionTranslate GDIPlus_Shutdown GDIPlus_Startup ' +
	        'GDIPlus_StringFormatCreate GDIPlus_StringFormatDispose ' +
	        'GDIPlus_StringFormatGetMeasurableCharacterRangeCount ' +
	        'GDIPlus_StringFormatSetAlign GDIPlus_StringFormatSetLineAlign ' +
	        'GDIPlus_StringFormatSetMeasurableCharacterRanges ' +
	        'GDIPlus_TextureCreate GDIPlus_TextureCreate2 ' +
	        'GDIPlus_TextureCreateIA GetIP GUICtrlAVI_Close ' +
	        'GUICtrlAVI_Create GUICtrlAVI_Destroy GUICtrlAVI_IsPlaying ' +
	        'GUICtrlAVI_Open GUICtrlAVI_OpenEx GUICtrlAVI_Play ' +
	        'GUICtrlAVI_Seek GUICtrlAVI_Show GUICtrlAVI_Stop ' +
	        'GUICtrlButton_Click GUICtrlButton_Create ' +
	        'GUICtrlButton_Destroy GUICtrlButton_Enable ' +
	        'GUICtrlButton_GetCheck GUICtrlButton_GetFocus ' +
	        'GUICtrlButton_GetIdealSize GUICtrlButton_GetImage ' +
	        'GUICtrlButton_GetImageList GUICtrlButton_GetNote ' +
	        'GUICtrlButton_GetNoteLength GUICtrlButton_GetSplitInfo ' +
	        'GUICtrlButton_GetState GUICtrlButton_GetText ' +
	        'GUICtrlButton_GetTextMargin GUICtrlButton_SetCheck ' +
	        'GUICtrlButton_SetDontClick GUICtrlButton_SetFocus ' +
	        'GUICtrlButton_SetImage GUICtrlButton_SetImageList ' +
	        'GUICtrlButton_SetNote GUICtrlButton_SetShield ' +
	        'GUICtrlButton_SetSize GUICtrlButton_SetSplitInfo ' +
	        'GUICtrlButton_SetState GUICtrlButton_SetStyle ' +
	        'GUICtrlButton_SetText GUICtrlButton_SetTextMargin ' +
	        'GUICtrlButton_Show GUICtrlComboBoxEx_AddDir ' +
	        'GUICtrlComboBoxEx_AddString GUICtrlComboBoxEx_BeginUpdate ' +
	        'GUICtrlComboBoxEx_Create GUICtrlComboBoxEx_CreateSolidBitMap ' +
	        'GUICtrlComboBoxEx_DeleteString GUICtrlComboBoxEx_Destroy ' +
	        'GUICtrlComboBoxEx_EndUpdate GUICtrlComboBoxEx_FindStringExact ' +
	        'GUICtrlComboBoxEx_GetComboBoxInfo ' +
	        'GUICtrlComboBoxEx_GetComboControl GUICtrlComboBoxEx_GetCount ' +
	        'GUICtrlComboBoxEx_GetCurSel ' +
	        'GUICtrlComboBoxEx_GetDroppedControlRect ' +
	        'GUICtrlComboBoxEx_GetDroppedControlRectEx ' +
	        'GUICtrlComboBoxEx_GetDroppedState ' +
	        'GUICtrlComboBoxEx_GetDroppedWidth ' +
	        'GUICtrlComboBoxEx_GetEditControl GUICtrlComboBoxEx_GetEditSel ' +
	        'GUICtrlComboBoxEx_GetEditText ' +
	        'GUICtrlComboBoxEx_GetExtendedStyle ' +
	        'GUICtrlComboBoxEx_GetExtendedUI GUICtrlComboBoxEx_GetImageList ' +
	        'GUICtrlComboBoxEx_GetItem GUICtrlComboBoxEx_GetItemEx ' +
	        'GUICtrlComboBoxEx_GetItemHeight GUICtrlComboBoxEx_GetItemImage ' +
	        'GUICtrlComboBoxEx_GetItemIndent ' +
	        'GUICtrlComboBoxEx_GetItemOverlayImage ' +
	        'GUICtrlComboBoxEx_GetItemParam ' +
	        'GUICtrlComboBoxEx_GetItemSelectedImage ' +
	        'GUICtrlComboBoxEx_GetItemText GUICtrlComboBoxEx_GetItemTextLen ' +
	        'GUICtrlComboBoxEx_GetList GUICtrlComboBoxEx_GetListArray ' +
	        'GUICtrlComboBoxEx_GetLocale GUICtrlComboBoxEx_GetLocaleCountry ' +
	        'GUICtrlComboBoxEx_GetLocaleLang ' +
	        'GUICtrlComboBoxEx_GetLocalePrimLang ' +
	        'GUICtrlComboBoxEx_GetLocaleSubLang ' +
	        'GUICtrlComboBoxEx_GetMinVisible GUICtrlComboBoxEx_GetTopIndex ' +
	        'GUICtrlComboBoxEx_GetUnicode GUICtrlComboBoxEx_InitStorage ' +
	        'GUICtrlComboBoxEx_InsertString GUICtrlComboBoxEx_LimitText ' +
	        'GUICtrlComboBoxEx_ReplaceEditSel GUICtrlComboBoxEx_ResetContent ' +
	        'GUICtrlComboBoxEx_SetCurSel GUICtrlComboBoxEx_SetDroppedWidth ' +
	        'GUICtrlComboBoxEx_SetEditSel GUICtrlComboBoxEx_SetEditText ' +
	        'GUICtrlComboBoxEx_SetExtendedStyle ' +
	        'GUICtrlComboBoxEx_SetExtendedUI GUICtrlComboBoxEx_SetImageList ' +
	        'GUICtrlComboBoxEx_SetItem GUICtrlComboBoxEx_SetItemEx ' +
	        'GUICtrlComboBoxEx_SetItemHeight GUICtrlComboBoxEx_SetItemImage ' +
	        'GUICtrlComboBoxEx_SetItemIndent ' +
	        'GUICtrlComboBoxEx_SetItemOverlayImage ' +
	        'GUICtrlComboBoxEx_SetItemParam ' +
	        'GUICtrlComboBoxEx_SetItemSelectedImage ' +
	        'GUICtrlComboBoxEx_SetMinVisible GUICtrlComboBoxEx_SetTopIndex ' +
	        'GUICtrlComboBoxEx_SetUnicode GUICtrlComboBoxEx_ShowDropDown ' +
	        'GUICtrlComboBox_AddDir GUICtrlComboBox_AddString ' +
	        'GUICtrlComboBox_AutoComplete GUICtrlComboBox_BeginUpdate ' +
	        'GUICtrlComboBox_Create GUICtrlComboBox_DeleteString ' +
	        'GUICtrlComboBox_Destroy GUICtrlComboBox_EndUpdate ' +
	        'GUICtrlComboBox_FindString GUICtrlComboBox_FindStringExact ' +
	        'GUICtrlComboBox_GetComboBoxInfo GUICtrlComboBox_GetCount ' +
	        'GUICtrlComboBox_GetCueBanner GUICtrlComboBox_GetCurSel ' +
	        'GUICtrlComboBox_GetDroppedControlRect ' +
	        'GUICtrlComboBox_GetDroppedControlRectEx ' +
	        'GUICtrlComboBox_GetDroppedState GUICtrlComboBox_GetDroppedWidth ' +
	        'GUICtrlComboBox_GetEditSel GUICtrlComboBox_GetEditText ' +
	        'GUICtrlComboBox_GetExtendedUI ' +
	        'GUICtrlComboBox_GetHorizontalExtent ' +
	        'GUICtrlComboBox_GetItemHeight GUICtrlComboBox_GetLBText ' +
	        'GUICtrlComboBox_GetLBTextLen GUICtrlComboBox_GetList ' +
	        'GUICtrlComboBox_GetListArray GUICtrlComboBox_GetLocale ' +
	        'GUICtrlComboBox_GetLocaleCountry GUICtrlComboBox_GetLocaleLang ' +
	        'GUICtrlComboBox_GetLocalePrimLang ' +
	        'GUICtrlComboBox_GetLocaleSubLang GUICtrlComboBox_GetMinVisible ' +
	        'GUICtrlComboBox_GetTopIndex GUICtrlComboBox_InitStorage ' +
	        'GUICtrlComboBox_InsertString GUICtrlComboBox_LimitText ' +
	        'GUICtrlComboBox_ReplaceEditSel GUICtrlComboBox_ResetContent ' +
	        'GUICtrlComboBox_SelectString GUICtrlComboBox_SetCueBanner ' +
	        'GUICtrlComboBox_SetCurSel GUICtrlComboBox_SetDroppedWidth ' +
	        'GUICtrlComboBox_SetEditSel GUICtrlComboBox_SetEditText ' +
	        'GUICtrlComboBox_SetExtendedUI ' +
	        'GUICtrlComboBox_SetHorizontalExtent ' +
	        'GUICtrlComboBox_SetItemHeight GUICtrlComboBox_SetMinVisible ' +
	        'GUICtrlComboBox_SetTopIndex GUICtrlComboBox_ShowDropDown ' +
	        'GUICtrlDTP_Create GUICtrlDTP_Destroy GUICtrlDTP_GetMCColor ' +
	        'GUICtrlDTP_GetMCFont GUICtrlDTP_GetMonthCal ' +
	        'GUICtrlDTP_GetRange GUICtrlDTP_GetRangeEx ' +
	        'GUICtrlDTP_GetSystemTime GUICtrlDTP_GetSystemTimeEx ' +
	        'GUICtrlDTP_SetFormat GUICtrlDTP_SetMCColor ' +
	        'GUICtrlDTP_SetMCFont GUICtrlDTP_SetRange ' +
	        'GUICtrlDTP_SetRangeEx GUICtrlDTP_SetSystemTime ' +
	        'GUICtrlDTP_SetSystemTimeEx GUICtrlEdit_AppendText ' +
	        'GUICtrlEdit_BeginUpdate GUICtrlEdit_CanUndo ' +
	        'GUICtrlEdit_CharFromPos GUICtrlEdit_Create ' +
	        'GUICtrlEdit_Destroy GUICtrlEdit_EmptyUndoBuffer ' +
	        'GUICtrlEdit_EndUpdate GUICtrlEdit_Find GUICtrlEdit_FmtLines ' +
	        'GUICtrlEdit_GetCueBanner GUICtrlEdit_GetFirstVisibleLine ' +
	        'GUICtrlEdit_GetLimitText GUICtrlEdit_GetLine ' +
	        'GUICtrlEdit_GetLineCount GUICtrlEdit_GetMargins ' +
	        'GUICtrlEdit_GetModify GUICtrlEdit_GetPasswordChar ' +
	        'GUICtrlEdit_GetRECT GUICtrlEdit_GetRECTEx GUICtrlEdit_GetSel ' +
	        'GUICtrlEdit_GetText GUICtrlEdit_GetTextLen ' +
	        'GUICtrlEdit_HideBalloonTip GUICtrlEdit_InsertText ' +
	        'GUICtrlEdit_LineFromChar GUICtrlEdit_LineIndex ' +
	        'GUICtrlEdit_LineLength GUICtrlEdit_LineScroll ' +
	        'GUICtrlEdit_PosFromChar GUICtrlEdit_ReplaceSel ' +
	        'GUICtrlEdit_Scroll GUICtrlEdit_SetCueBanner ' +
	        'GUICtrlEdit_SetLimitText GUICtrlEdit_SetMargins ' +
	        'GUICtrlEdit_SetModify GUICtrlEdit_SetPasswordChar ' +
	        'GUICtrlEdit_SetReadOnly GUICtrlEdit_SetRECT ' +
	        'GUICtrlEdit_SetRECTEx GUICtrlEdit_SetRECTNP ' +
	        'GUICtrlEdit_SetRectNPEx GUICtrlEdit_SetSel ' +
	        'GUICtrlEdit_SetTabStops GUICtrlEdit_SetText ' +
	        'GUICtrlEdit_ShowBalloonTip GUICtrlEdit_Undo ' +
	        'GUICtrlHeader_AddItem GUICtrlHeader_ClearFilter ' +
	        'GUICtrlHeader_ClearFilterAll GUICtrlHeader_Create ' +
	        'GUICtrlHeader_CreateDragImage GUICtrlHeader_DeleteItem ' +
	        'GUICtrlHeader_Destroy GUICtrlHeader_EditFilter ' +
	        'GUICtrlHeader_GetBitmapMargin GUICtrlHeader_GetImageList ' +
	        'GUICtrlHeader_GetItem GUICtrlHeader_GetItemAlign ' +
	        'GUICtrlHeader_GetItemBitmap GUICtrlHeader_GetItemCount ' +
	        'GUICtrlHeader_GetItemDisplay GUICtrlHeader_GetItemFlags ' +
	        'GUICtrlHeader_GetItemFormat GUICtrlHeader_GetItemImage ' +
	        'GUICtrlHeader_GetItemOrder GUICtrlHeader_GetItemParam ' +
	        'GUICtrlHeader_GetItemRect GUICtrlHeader_GetItemRectEx ' +
	        'GUICtrlHeader_GetItemText GUICtrlHeader_GetItemWidth ' +
	        'GUICtrlHeader_GetOrderArray GUICtrlHeader_GetUnicodeFormat ' +
	        'GUICtrlHeader_HitTest GUICtrlHeader_InsertItem ' +
	        'GUICtrlHeader_Layout GUICtrlHeader_OrderToIndex ' +
	        'GUICtrlHeader_SetBitmapMargin ' +
	        'GUICtrlHeader_SetFilterChangeTimeout ' +
	        'GUICtrlHeader_SetHotDivider GUICtrlHeader_SetImageList ' +
	        'GUICtrlHeader_SetItem GUICtrlHeader_SetItemAlign ' +
	        'GUICtrlHeader_SetItemBitmap GUICtrlHeader_SetItemDisplay ' +
	        'GUICtrlHeader_SetItemFlags GUICtrlHeader_SetItemFormat ' +
	        'GUICtrlHeader_SetItemImage GUICtrlHeader_SetItemOrder ' +
	        'GUICtrlHeader_SetItemParam GUICtrlHeader_SetItemText ' +
	        'GUICtrlHeader_SetItemWidth GUICtrlHeader_SetOrderArray ' +
	        'GUICtrlHeader_SetUnicodeFormat GUICtrlIpAddress_ClearAddress ' +
	        'GUICtrlIpAddress_Create GUICtrlIpAddress_Destroy ' +
	        'GUICtrlIpAddress_Get GUICtrlIpAddress_GetArray ' +
	        'GUICtrlIpAddress_GetEx GUICtrlIpAddress_IsBlank ' +
	        'GUICtrlIpAddress_Set GUICtrlIpAddress_SetArray ' +
	        'GUICtrlIpAddress_SetEx GUICtrlIpAddress_SetFocus ' +
	        'GUICtrlIpAddress_SetFont GUICtrlIpAddress_SetRange ' +
	        'GUICtrlIpAddress_ShowHide GUICtrlListBox_AddFile ' +
	        'GUICtrlListBox_AddString GUICtrlListBox_BeginUpdate ' +
	        'GUICtrlListBox_ClickItem GUICtrlListBox_Create ' +
	        'GUICtrlListBox_DeleteString GUICtrlListBox_Destroy ' +
	        'GUICtrlListBox_Dir GUICtrlListBox_EndUpdate ' +
	        'GUICtrlListBox_FindInText GUICtrlListBox_FindString ' +
	        'GUICtrlListBox_GetAnchorIndex GUICtrlListBox_GetCaretIndex ' +
	        'GUICtrlListBox_GetCount GUICtrlListBox_GetCurSel ' +
	        'GUICtrlListBox_GetHorizontalExtent GUICtrlListBox_GetItemData ' +
	        'GUICtrlListBox_GetItemHeight GUICtrlListBox_GetItemRect ' +
	        'GUICtrlListBox_GetItemRectEx GUICtrlListBox_GetListBoxInfo ' +
	        'GUICtrlListBox_GetLocale GUICtrlListBox_GetLocaleCountry ' +
	        'GUICtrlListBox_GetLocaleLang GUICtrlListBox_GetLocalePrimLang ' +
	        'GUICtrlListBox_GetLocaleSubLang GUICtrlListBox_GetSel ' +
	        'GUICtrlListBox_GetSelCount GUICtrlListBox_GetSelItems ' +
	        'GUICtrlListBox_GetSelItemsText GUICtrlListBox_GetText ' +
	        'GUICtrlListBox_GetTextLen GUICtrlListBox_GetTopIndex ' +
	        'GUICtrlListBox_InitStorage GUICtrlListBox_InsertString ' +
	        'GUICtrlListBox_ItemFromPoint GUICtrlListBox_ReplaceString ' +
	        'GUICtrlListBox_ResetContent GUICtrlListBox_SelectString ' +
	        'GUICtrlListBox_SelItemRange GUICtrlListBox_SelItemRangeEx ' +
	        'GUICtrlListBox_SetAnchorIndex GUICtrlListBox_SetCaretIndex ' +
	        'GUICtrlListBox_SetColumnWidth GUICtrlListBox_SetCurSel ' +
	        'GUICtrlListBox_SetHorizontalExtent GUICtrlListBox_SetItemData ' +
	        'GUICtrlListBox_SetItemHeight GUICtrlListBox_SetLocale ' +
	        'GUICtrlListBox_SetSel GUICtrlListBox_SetTabStops ' +
	        'GUICtrlListBox_SetTopIndex GUICtrlListBox_Sort ' +
	        'GUICtrlListBox_SwapString GUICtrlListBox_UpdateHScroll ' +
	        'GUICtrlListView_AddArray GUICtrlListView_AddColumn ' +
	        'GUICtrlListView_AddItem GUICtrlListView_AddSubItem ' +
	        'GUICtrlListView_ApproximateViewHeight ' +
	        'GUICtrlListView_ApproximateViewRect ' +
	        'GUICtrlListView_ApproximateViewWidth GUICtrlListView_Arrange ' +
	        'GUICtrlListView_BeginUpdate GUICtrlListView_CancelEditLabel ' +
	        'GUICtrlListView_ClickItem GUICtrlListView_CopyItems ' +
	        'GUICtrlListView_Create GUICtrlListView_CreateDragImage ' +
	        'GUICtrlListView_CreateSolidBitMap ' +
	        'GUICtrlListView_DeleteAllItems GUICtrlListView_DeleteColumn ' +
	        'GUICtrlListView_DeleteItem GUICtrlListView_DeleteItemsSelected ' +
	        'GUICtrlListView_Destroy GUICtrlListView_DrawDragImage ' +
	        'GUICtrlListView_EditLabel GUICtrlListView_EnableGroupView ' +
	        'GUICtrlListView_EndUpdate GUICtrlListView_EnsureVisible ' +
	        'GUICtrlListView_FindInText GUICtrlListView_FindItem ' +
	        'GUICtrlListView_FindNearest GUICtrlListView_FindParam ' +
	        'GUICtrlListView_FindText GUICtrlListView_GetBkColor ' +
	        'GUICtrlListView_GetBkImage GUICtrlListView_GetCallbackMask ' +
	        'GUICtrlListView_GetColumn GUICtrlListView_GetColumnCount ' +
	        'GUICtrlListView_GetColumnOrder ' +
	        'GUICtrlListView_GetColumnOrderArray ' +
	        'GUICtrlListView_GetColumnWidth GUICtrlListView_GetCounterPage ' +
	        'GUICtrlListView_GetEditControl ' +
	        'GUICtrlListView_GetExtendedListViewStyle ' +
	        'GUICtrlListView_GetFocusedGroup GUICtrlListView_GetGroupCount ' +
	        'GUICtrlListView_GetGroupInfo ' +
	        'GUICtrlListView_GetGroupInfoByIndex ' +
	        'GUICtrlListView_GetGroupRect ' +
	        'GUICtrlListView_GetGroupViewEnabled GUICtrlListView_GetHeader ' +
	        'GUICtrlListView_GetHotCursor GUICtrlListView_GetHotItem ' +
	        'GUICtrlListView_GetHoverTime GUICtrlListView_GetImageList ' +
	        'GUICtrlListView_GetISearchString GUICtrlListView_GetItem ' +
	        'GUICtrlListView_GetItemChecked GUICtrlListView_GetItemCount ' +
	        'GUICtrlListView_GetItemCut GUICtrlListView_GetItemDropHilited ' +
	        'GUICtrlListView_GetItemEx GUICtrlListView_GetItemFocused ' +
	        'GUICtrlListView_GetItemGroupID GUICtrlListView_GetItemImage ' +
	        'GUICtrlListView_GetItemIndent GUICtrlListView_GetItemParam ' +
	        'GUICtrlListView_GetItemPosition ' +
	        'GUICtrlListView_GetItemPositionX ' +
	        'GUICtrlListView_GetItemPositionY GUICtrlListView_GetItemRect ' +
	        'GUICtrlListView_GetItemRectEx GUICtrlListView_GetItemSelected ' +
	        'GUICtrlListView_GetItemSpacing GUICtrlListView_GetItemSpacingX ' +
	        'GUICtrlListView_GetItemSpacingY GUICtrlListView_GetItemState ' +
	        'GUICtrlListView_GetItemStateImage GUICtrlListView_GetItemText ' +
	        'GUICtrlListView_GetItemTextArray ' +
	        'GUICtrlListView_GetItemTextString GUICtrlListView_GetNextItem ' +
	        'GUICtrlListView_GetNumberOfWorkAreas GUICtrlListView_GetOrigin ' +
	        'GUICtrlListView_GetOriginX GUICtrlListView_GetOriginY ' +
	        'GUICtrlListView_GetOutlineColor ' +
	        'GUICtrlListView_GetSelectedColumn ' +
	        'GUICtrlListView_GetSelectedCount ' +
	        'GUICtrlListView_GetSelectedIndices ' +
	        'GUICtrlListView_GetSelectionMark GUICtrlListView_GetStringWidth ' +
	        'GUICtrlListView_GetSubItemRect GUICtrlListView_GetTextBkColor ' +
	        'GUICtrlListView_GetTextColor GUICtrlListView_GetToolTips ' +
	        'GUICtrlListView_GetTopIndex GUICtrlListView_GetUnicodeFormat ' +
	        'GUICtrlListView_GetView GUICtrlListView_GetViewDetails ' +
	        'GUICtrlListView_GetViewLarge GUICtrlListView_GetViewList ' +
	        'GUICtrlListView_GetViewRect GUICtrlListView_GetViewSmall ' +
	        'GUICtrlListView_GetViewTile GUICtrlListView_HideColumn ' +
	        'GUICtrlListView_HitTest GUICtrlListView_InsertColumn ' +
	        'GUICtrlListView_InsertGroup GUICtrlListView_InsertItem ' +
	        'GUICtrlListView_JustifyColumn GUICtrlListView_MapIDToIndex ' +
	        'GUICtrlListView_MapIndexToID GUICtrlListView_RedrawItems ' +
	        'GUICtrlListView_RegisterSortCallBack ' +
	        'GUICtrlListView_RemoveAllGroups GUICtrlListView_RemoveGroup ' +
	        'GUICtrlListView_Scroll GUICtrlListView_SetBkColor ' +
	        'GUICtrlListView_SetBkImage GUICtrlListView_SetCallBackMask ' +
	        'GUICtrlListView_SetColumn GUICtrlListView_SetColumnOrder ' +
	        'GUICtrlListView_SetColumnOrderArray ' +
	        'GUICtrlListView_SetColumnWidth ' +
	        'GUICtrlListView_SetExtendedListViewStyle ' +
	        'GUICtrlListView_SetGroupInfo GUICtrlListView_SetHotItem ' +
	        'GUICtrlListView_SetHoverTime GUICtrlListView_SetIconSpacing ' +
	        'GUICtrlListView_SetImageList GUICtrlListView_SetItem ' +
	        'GUICtrlListView_SetItemChecked GUICtrlListView_SetItemCount ' +
	        'GUICtrlListView_SetItemCut GUICtrlListView_SetItemDropHilited ' +
	        'GUICtrlListView_SetItemEx GUICtrlListView_SetItemFocused ' +
	        'GUICtrlListView_SetItemGroupID GUICtrlListView_SetItemImage ' +
	        'GUICtrlListView_SetItemIndent GUICtrlListView_SetItemParam ' +
	        'GUICtrlListView_SetItemPosition ' +
	        'GUICtrlListView_SetItemPosition32 ' +
	        'GUICtrlListView_SetItemSelected GUICtrlListView_SetItemState ' +
	        'GUICtrlListView_SetItemStateImage GUICtrlListView_SetItemText ' +
	        'GUICtrlListView_SetOutlineColor ' +
	        'GUICtrlListView_SetSelectedColumn ' +
	        'GUICtrlListView_SetSelectionMark GUICtrlListView_SetTextBkColor ' +
	        'GUICtrlListView_SetTextColor GUICtrlListView_SetToolTips ' +
	        'GUICtrlListView_SetUnicodeFormat GUICtrlListView_SetView ' +
	        'GUICtrlListView_SetWorkAreas GUICtrlListView_SimpleSort ' +
	        'GUICtrlListView_SortItems GUICtrlListView_SubItemHitTest ' +
	        'GUICtrlListView_UnRegisterSortCallBack GUICtrlMenu_AddMenuItem ' +
	        'GUICtrlMenu_AppendMenu GUICtrlMenu_CalculatePopupWindowPosition ' +
	        'GUICtrlMenu_CheckMenuItem GUICtrlMenu_CheckRadioItem ' +
	        'GUICtrlMenu_CreateMenu GUICtrlMenu_CreatePopup ' +
	        'GUICtrlMenu_DeleteMenu GUICtrlMenu_DestroyMenu ' +
	        'GUICtrlMenu_DrawMenuBar GUICtrlMenu_EnableMenuItem ' +
	        'GUICtrlMenu_FindItem GUICtrlMenu_FindParent ' +
	        'GUICtrlMenu_GetItemBmp GUICtrlMenu_GetItemBmpChecked ' +
	        'GUICtrlMenu_GetItemBmpUnchecked GUICtrlMenu_GetItemChecked ' +
	        'GUICtrlMenu_GetItemCount GUICtrlMenu_GetItemData ' +
	        'GUICtrlMenu_GetItemDefault GUICtrlMenu_GetItemDisabled ' +
	        'GUICtrlMenu_GetItemEnabled GUICtrlMenu_GetItemGrayed ' +
	        'GUICtrlMenu_GetItemHighlighted GUICtrlMenu_GetItemID ' +
	        'GUICtrlMenu_GetItemInfo GUICtrlMenu_GetItemRect ' +
	        'GUICtrlMenu_GetItemRectEx GUICtrlMenu_GetItemState ' +
	        'GUICtrlMenu_GetItemStateEx GUICtrlMenu_GetItemSubMenu ' +
	        'GUICtrlMenu_GetItemText GUICtrlMenu_GetItemType ' +
	        'GUICtrlMenu_GetMenu GUICtrlMenu_GetMenuBackground ' +
	        'GUICtrlMenu_GetMenuBarInfo GUICtrlMenu_GetMenuContextHelpID ' +
	        'GUICtrlMenu_GetMenuData GUICtrlMenu_GetMenuDefaultItem ' +
	        'GUICtrlMenu_GetMenuHeight GUICtrlMenu_GetMenuInfo ' +
	        'GUICtrlMenu_GetMenuStyle GUICtrlMenu_GetSystemMenu ' +
	        'GUICtrlMenu_InsertMenuItem GUICtrlMenu_InsertMenuItemEx ' +
	        'GUICtrlMenu_IsMenu GUICtrlMenu_LoadMenu ' +
	        'GUICtrlMenu_MapAccelerator GUICtrlMenu_MenuItemFromPoint ' +
	        'GUICtrlMenu_RemoveMenu GUICtrlMenu_SetItemBitmaps ' +
	        'GUICtrlMenu_SetItemBmp GUICtrlMenu_SetItemBmpChecked ' +
	        'GUICtrlMenu_SetItemBmpUnchecked GUICtrlMenu_SetItemChecked ' +
	        'GUICtrlMenu_SetItemData GUICtrlMenu_SetItemDefault ' +
	        'GUICtrlMenu_SetItemDisabled GUICtrlMenu_SetItemEnabled ' +
	        'GUICtrlMenu_SetItemGrayed GUICtrlMenu_SetItemHighlighted ' +
	        'GUICtrlMenu_SetItemID GUICtrlMenu_SetItemInfo ' +
	        'GUICtrlMenu_SetItemState GUICtrlMenu_SetItemSubMenu ' +
	        'GUICtrlMenu_SetItemText GUICtrlMenu_SetItemType ' +
	        'GUICtrlMenu_SetMenu GUICtrlMenu_SetMenuBackground ' +
	        'GUICtrlMenu_SetMenuContextHelpID GUICtrlMenu_SetMenuData ' +
	        'GUICtrlMenu_SetMenuDefaultItem GUICtrlMenu_SetMenuHeight ' +
	        'GUICtrlMenu_SetMenuInfo GUICtrlMenu_SetMenuStyle ' +
	        'GUICtrlMenu_TrackPopupMenu GUICtrlMonthCal_Create ' +
	        'GUICtrlMonthCal_Destroy GUICtrlMonthCal_GetCalendarBorder ' +
	        'GUICtrlMonthCal_GetCalendarCount GUICtrlMonthCal_GetColor ' +
	        'GUICtrlMonthCal_GetColorArray GUICtrlMonthCal_GetCurSel ' +
	        'GUICtrlMonthCal_GetCurSelStr GUICtrlMonthCal_GetFirstDOW ' +
	        'GUICtrlMonthCal_GetFirstDOWStr GUICtrlMonthCal_GetMaxSelCount ' +
	        'GUICtrlMonthCal_GetMaxTodayWidth ' +
	        'GUICtrlMonthCal_GetMinReqHeight GUICtrlMonthCal_GetMinReqRect ' +
	        'GUICtrlMonthCal_GetMinReqRectArray ' +
	        'GUICtrlMonthCal_GetMinReqWidth GUICtrlMonthCal_GetMonthDelta ' +
	        'GUICtrlMonthCal_GetMonthRange GUICtrlMonthCal_GetMonthRangeMax ' +
	        'GUICtrlMonthCal_GetMonthRangeMaxStr ' +
	        'GUICtrlMonthCal_GetMonthRangeMin ' +
	        'GUICtrlMonthCal_GetMonthRangeMinStr ' +
	        'GUICtrlMonthCal_GetMonthRangeSpan GUICtrlMonthCal_GetRange ' +
	        'GUICtrlMonthCal_GetRangeMax GUICtrlMonthCal_GetRangeMaxStr ' +
	        'GUICtrlMonthCal_GetRangeMin GUICtrlMonthCal_GetRangeMinStr ' +
	        'GUICtrlMonthCal_GetSelRange GUICtrlMonthCal_GetSelRangeMax ' +
	        'GUICtrlMonthCal_GetSelRangeMaxStr ' +
	        'GUICtrlMonthCal_GetSelRangeMin ' +
	        'GUICtrlMonthCal_GetSelRangeMinStr GUICtrlMonthCal_GetToday ' +
	        'GUICtrlMonthCal_GetTodayStr GUICtrlMonthCal_GetUnicodeFormat ' +
	        'GUICtrlMonthCal_HitTest GUICtrlMonthCal_SetCalendarBorder ' +
	        'GUICtrlMonthCal_SetColor GUICtrlMonthCal_SetCurSel ' +
	        'GUICtrlMonthCal_SetDayState GUICtrlMonthCal_SetFirstDOW ' +
	        'GUICtrlMonthCal_SetMaxSelCount GUICtrlMonthCal_SetMonthDelta ' +
	        'GUICtrlMonthCal_SetRange GUICtrlMonthCal_SetSelRange ' +
	        'GUICtrlMonthCal_SetToday GUICtrlMonthCal_SetUnicodeFormat ' +
	        'GUICtrlRebar_AddBand GUICtrlRebar_AddToolBarBand ' +
	        'GUICtrlRebar_BeginDrag GUICtrlRebar_Create ' +
	        'GUICtrlRebar_DeleteBand GUICtrlRebar_Destroy ' +
	        'GUICtrlRebar_DragMove GUICtrlRebar_EndDrag ' +
	        'GUICtrlRebar_GetBandBackColor GUICtrlRebar_GetBandBorders ' +
	        'GUICtrlRebar_GetBandBordersEx GUICtrlRebar_GetBandChildHandle ' +
	        'GUICtrlRebar_GetBandChildSize GUICtrlRebar_GetBandCount ' +
	        'GUICtrlRebar_GetBandForeColor GUICtrlRebar_GetBandHeaderSize ' +
	        'GUICtrlRebar_GetBandID GUICtrlRebar_GetBandIdealSize ' +
	        'GUICtrlRebar_GetBandLength GUICtrlRebar_GetBandLParam ' +
	        'GUICtrlRebar_GetBandMargins GUICtrlRebar_GetBandMarginsEx ' +
	        'GUICtrlRebar_GetBandRect GUICtrlRebar_GetBandRectEx ' +
	        'GUICtrlRebar_GetBandStyle GUICtrlRebar_GetBandStyleBreak ' +
	        'GUICtrlRebar_GetBandStyleChildEdge ' +
	        'GUICtrlRebar_GetBandStyleFixedBMP ' +
	        'GUICtrlRebar_GetBandStyleFixedSize ' +
	        'GUICtrlRebar_GetBandStyleGripperAlways ' +
	        'GUICtrlRebar_GetBandStyleHidden ' +
	        'GUICtrlRebar_GetBandStyleHideTitle ' +
	        'GUICtrlRebar_GetBandStyleNoGripper ' +
	        'GUICtrlRebar_GetBandStyleTopAlign ' +
	        'GUICtrlRebar_GetBandStyleUseChevron ' +
	        'GUICtrlRebar_GetBandStyleVariableHeight ' +
	        'GUICtrlRebar_GetBandText GUICtrlRebar_GetBarHeight ' +
	        'GUICtrlRebar_GetBarInfo GUICtrlRebar_GetBKColor ' +
	        'GUICtrlRebar_GetColorScheme GUICtrlRebar_GetRowCount ' +
	        'GUICtrlRebar_GetRowHeight GUICtrlRebar_GetTextColor ' +
	        'GUICtrlRebar_GetToolTips GUICtrlRebar_GetUnicodeFormat ' +
	        'GUICtrlRebar_HitTest GUICtrlRebar_IDToIndex ' +
	        'GUICtrlRebar_MaximizeBand GUICtrlRebar_MinimizeBand ' +
	        'GUICtrlRebar_MoveBand GUICtrlRebar_SetBandBackColor ' +
	        'GUICtrlRebar_SetBandForeColor GUICtrlRebar_SetBandHeaderSize ' +
	        'GUICtrlRebar_SetBandID GUICtrlRebar_SetBandIdealSize ' +
	        'GUICtrlRebar_SetBandLength GUICtrlRebar_SetBandLParam ' +
	        'GUICtrlRebar_SetBandStyle GUICtrlRebar_SetBandStyleBreak ' +
	        'GUICtrlRebar_SetBandStyleChildEdge ' +
	        'GUICtrlRebar_SetBandStyleFixedBMP ' +
	        'GUICtrlRebar_SetBandStyleFixedSize ' +
	        'GUICtrlRebar_SetBandStyleGripperAlways ' +
	        'GUICtrlRebar_SetBandStyleHidden ' +
	        'GUICtrlRebar_SetBandStyleHideTitle ' +
	        'GUICtrlRebar_SetBandStyleNoGripper ' +
	        'GUICtrlRebar_SetBandStyleTopAlign ' +
	        'GUICtrlRebar_SetBandStyleUseChevron ' +
	        'GUICtrlRebar_SetBandStyleVariableHeight ' +
	        'GUICtrlRebar_SetBandText GUICtrlRebar_SetBarInfo ' +
	        'GUICtrlRebar_SetBKColor GUICtrlRebar_SetColorScheme ' +
	        'GUICtrlRebar_SetTextColor GUICtrlRebar_SetToolTips ' +
	        'GUICtrlRebar_SetUnicodeFormat GUICtrlRebar_ShowBand ' +
	        'GUICtrlRichEdit_AppendText GUICtrlRichEdit_AutoDetectURL ' +
	        'GUICtrlRichEdit_CanPaste GUICtrlRichEdit_CanPasteSpecial ' +
	        'GUICtrlRichEdit_CanRedo GUICtrlRichEdit_CanUndo ' +
	        'GUICtrlRichEdit_ChangeFontSize GUICtrlRichEdit_Copy ' +
	        'GUICtrlRichEdit_Create GUICtrlRichEdit_Cut ' +
	        'GUICtrlRichEdit_Deselect GUICtrlRichEdit_Destroy ' +
	        'GUICtrlRichEdit_EmptyUndoBuffer GUICtrlRichEdit_FindText ' +
	        'GUICtrlRichEdit_FindTextInRange GUICtrlRichEdit_GetBkColor ' +
	        'GUICtrlRichEdit_GetCharAttributes ' +
	        'GUICtrlRichEdit_GetCharBkColor GUICtrlRichEdit_GetCharColor ' +
	        'GUICtrlRichEdit_GetCharPosFromXY ' +
	        'GUICtrlRichEdit_GetCharPosOfNextWord ' +
	        'GUICtrlRichEdit_GetCharPosOfPreviousWord ' +
	        'GUICtrlRichEdit_GetCharWordBreakInfo ' +
	        'GUICtrlRichEdit_GetFirstCharPosOnLine GUICtrlRichEdit_GetFont ' +
	        'GUICtrlRichEdit_GetLineCount GUICtrlRichEdit_GetLineLength ' +
	        'GUICtrlRichEdit_GetLineNumberFromCharPos ' +
	        'GUICtrlRichEdit_GetNextRedo GUICtrlRichEdit_GetNextUndo ' +
	        'GUICtrlRichEdit_GetNumberOfFirstVisibleLine ' +
	        'GUICtrlRichEdit_GetParaAlignment ' +
	        'GUICtrlRichEdit_GetParaAttributes GUICtrlRichEdit_GetParaBorder ' +
	        'GUICtrlRichEdit_GetParaIndents GUICtrlRichEdit_GetParaNumbering ' +
	        'GUICtrlRichEdit_GetParaShading GUICtrlRichEdit_GetParaSpacing ' +
	        'GUICtrlRichEdit_GetParaTabStops GUICtrlRichEdit_GetPasswordChar ' +
	        'GUICtrlRichEdit_GetRECT GUICtrlRichEdit_GetScrollPos ' +
	        'GUICtrlRichEdit_GetSel GUICtrlRichEdit_GetSelAA ' +
	        'GUICtrlRichEdit_GetSelText GUICtrlRichEdit_GetSpaceUnit ' +
	        'GUICtrlRichEdit_GetText GUICtrlRichEdit_GetTextInLine ' +
	        'GUICtrlRichEdit_GetTextInRange GUICtrlRichEdit_GetTextLength ' +
	        'GUICtrlRichEdit_GetVersion GUICtrlRichEdit_GetXYFromCharPos ' +
	        'GUICtrlRichEdit_GetZoom GUICtrlRichEdit_GotoCharPos ' +
	        'GUICtrlRichEdit_HideSelection GUICtrlRichEdit_InsertText ' +
	        'GUICtrlRichEdit_IsModified GUICtrlRichEdit_IsTextSelected ' +
	        'GUICtrlRichEdit_Paste GUICtrlRichEdit_PasteSpecial ' +
	        'GUICtrlRichEdit_PauseRedraw GUICtrlRichEdit_Redo ' +
	        'GUICtrlRichEdit_ReplaceText GUICtrlRichEdit_ResumeRedraw ' +
	        'GUICtrlRichEdit_ScrollLineOrPage GUICtrlRichEdit_ScrollLines ' +
	        'GUICtrlRichEdit_ScrollToCaret GUICtrlRichEdit_SetBkColor ' +
	        'GUICtrlRichEdit_SetCharAttributes ' +
	        'GUICtrlRichEdit_SetCharBkColor GUICtrlRichEdit_SetCharColor ' +
	        'GUICtrlRichEdit_SetEventMask GUICtrlRichEdit_SetFont ' +
	        'GUICtrlRichEdit_SetLimitOnText GUICtrlRichEdit_SetModified ' +
	        'GUICtrlRichEdit_SetParaAlignment ' +
	        'GUICtrlRichEdit_SetParaAttributes GUICtrlRichEdit_SetParaBorder ' +
	        'GUICtrlRichEdit_SetParaIndents GUICtrlRichEdit_SetParaNumbering ' +
	        'GUICtrlRichEdit_SetParaShading GUICtrlRichEdit_SetParaSpacing ' +
	        'GUICtrlRichEdit_SetParaTabStops GUICtrlRichEdit_SetPasswordChar ' +
	        'GUICtrlRichEdit_SetReadOnly GUICtrlRichEdit_SetRECT ' +
	        'GUICtrlRichEdit_SetScrollPos GUICtrlRichEdit_SetSel ' +
	        'GUICtrlRichEdit_SetSpaceUnit GUICtrlRichEdit_SetTabStops ' +
	        'GUICtrlRichEdit_SetText GUICtrlRichEdit_SetUndoLimit ' +
	        'GUICtrlRichEdit_SetZoom GUICtrlRichEdit_StreamFromFile ' +
	        'GUICtrlRichEdit_StreamFromVar GUICtrlRichEdit_StreamToFile ' +
	        'GUICtrlRichEdit_StreamToVar GUICtrlRichEdit_Undo ' +
	        'GUICtrlSlider_ClearSel GUICtrlSlider_ClearTics ' +
	        'GUICtrlSlider_Create GUICtrlSlider_Destroy ' +
	        'GUICtrlSlider_GetBuddy GUICtrlSlider_GetChannelRect ' +
	        'GUICtrlSlider_GetChannelRectEx GUICtrlSlider_GetLineSize ' +
	        'GUICtrlSlider_GetLogicalTics GUICtrlSlider_GetNumTics ' +
	        'GUICtrlSlider_GetPageSize GUICtrlSlider_GetPos ' +
	        'GUICtrlSlider_GetRange GUICtrlSlider_GetRangeMax ' +
	        'GUICtrlSlider_GetRangeMin GUICtrlSlider_GetSel ' +
	        'GUICtrlSlider_GetSelEnd GUICtrlSlider_GetSelStart ' +
	        'GUICtrlSlider_GetThumbLength GUICtrlSlider_GetThumbRect ' +
	        'GUICtrlSlider_GetThumbRectEx GUICtrlSlider_GetTic ' +
	        'GUICtrlSlider_GetTicPos GUICtrlSlider_GetToolTips ' +
	        'GUICtrlSlider_GetUnicodeFormat GUICtrlSlider_SetBuddy ' +
	        'GUICtrlSlider_SetLineSize GUICtrlSlider_SetPageSize ' +
	        'GUICtrlSlider_SetPos GUICtrlSlider_SetRange ' +
	        'GUICtrlSlider_SetRangeMax GUICtrlSlider_SetRangeMin ' +
	        'GUICtrlSlider_SetSel GUICtrlSlider_SetSelEnd ' +
	        'GUICtrlSlider_SetSelStart GUICtrlSlider_SetThumbLength ' +
	        'GUICtrlSlider_SetTic GUICtrlSlider_SetTicFreq ' +
	        'GUICtrlSlider_SetTipSide GUICtrlSlider_SetToolTips ' +
	        'GUICtrlSlider_SetUnicodeFormat GUICtrlStatusBar_Create ' +
	        'GUICtrlStatusBar_Destroy GUICtrlStatusBar_EmbedControl ' +
	        'GUICtrlStatusBar_GetBorders GUICtrlStatusBar_GetBordersHorz ' +
	        'GUICtrlStatusBar_GetBordersRect GUICtrlStatusBar_GetBordersVert ' +
	        'GUICtrlStatusBar_GetCount GUICtrlStatusBar_GetHeight ' +
	        'GUICtrlStatusBar_GetIcon GUICtrlStatusBar_GetParts ' +
	        'GUICtrlStatusBar_GetRect GUICtrlStatusBar_GetRectEx ' +
	        'GUICtrlStatusBar_GetText GUICtrlStatusBar_GetTextFlags ' +
	        'GUICtrlStatusBar_GetTextLength GUICtrlStatusBar_GetTextLengthEx ' +
	        'GUICtrlStatusBar_GetTipText GUICtrlStatusBar_GetUnicodeFormat ' +
	        'GUICtrlStatusBar_GetWidth GUICtrlStatusBar_IsSimple ' +
	        'GUICtrlStatusBar_Resize GUICtrlStatusBar_SetBkColor ' +
	        'GUICtrlStatusBar_SetIcon GUICtrlStatusBar_SetMinHeight ' +
	        'GUICtrlStatusBar_SetParts GUICtrlStatusBar_SetSimple ' +
	        'GUICtrlStatusBar_SetText GUICtrlStatusBar_SetTipText ' +
	        'GUICtrlStatusBar_SetUnicodeFormat GUICtrlStatusBar_ShowHide ' +
	        'GUICtrlTab_ActivateTab GUICtrlTab_ClickTab GUICtrlTab_Create ' +
	        'GUICtrlTab_DeleteAllItems GUICtrlTab_DeleteItem ' +
	        'GUICtrlTab_DeselectAll GUICtrlTab_Destroy GUICtrlTab_FindTab ' +
	        'GUICtrlTab_GetCurFocus GUICtrlTab_GetCurSel ' +
	        'GUICtrlTab_GetDisplayRect GUICtrlTab_GetDisplayRectEx ' +
	        'GUICtrlTab_GetExtendedStyle GUICtrlTab_GetImageList ' +
	        'GUICtrlTab_GetItem GUICtrlTab_GetItemCount ' +
	        'GUICtrlTab_GetItemImage GUICtrlTab_GetItemParam ' +
	        'GUICtrlTab_GetItemRect GUICtrlTab_GetItemRectEx ' +
	        'GUICtrlTab_GetItemState GUICtrlTab_GetItemText ' +
	        'GUICtrlTab_GetRowCount GUICtrlTab_GetToolTips ' +
	        'GUICtrlTab_GetUnicodeFormat GUICtrlTab_HighlightItem ' +
	        'GUICtrlTab_HitTest GUICtrlTab_InsertItem ' +
	        'GUICtrlTab_RemoveImage GUICtrlTab_SetCurFocus ' +
	        'GUICtrlTab_SetCurSel GUICtrlTab_SetExtendedStyle ' +
	        'GUICtrlTab_SetImageList GUICtrlTab_SetItem ' +
	        'GUICtrlTab_SetItemImage GUICtrlTab_SetItemParam ' +
	        'GUICtrlTab_SetItemSize GUICtrlTab_SetItemState ' +
	        'GUICtrlTab_SetItemText GUICtrlTab_SetMinTabWidth ' +
	        'GUICtrlTab_SetPadding GUICtrlTab_SetToolTips ' +
	        'GUICtrlTab_SetUnicodeFormat GUICtrlToolbar_AddBitmap ' +
	        'GUICtrlToolbar_AddButton GUICtrlToolbar_AddButtonSep ' +
	        'GUICtrlToolbar_AddString GUICtrlToolbar_ButtonCount ' +
	        'GUICtrlToolbar_CheckButton GUICtrlToolbar_ClickAccel ' +
	        'GUICtrlToolbar_ClickButton GUICtrlToolbar_ClickIndex ' +
	        'GUICtrlToolbar_CommandToIndex GUICtrlToolbar_Create ' +
	        'GUICtrlToolbar_Customize GUICtrlToolbar_DeleteButton ' +
	        'GUICtrlToolbar_Destroy GUICtrlToolbar_EnableButton ' +
	        'GUICtrlToolbar_FindToolbar GUICtrlToolbar_GetAnchorHighlight ' +
	        'GUICtrlToolbar_GetBitmapFlags GUICtrlToolbar_GetButtonBitmap ' +
	        'GUICtrlToolbar_GetButtonInfo GUICtrlToolbar_GetButtonInfoEx ' +
	        'GUICtrlToolbar_GetButtonParam GUICtrlToolbar_GetButtonRect ' +
	        'GUICtrlToolbar_GetButtonRectEx GUICtrlToolbar_GetButtonSize ' +
	        'GUICtrlToolbar_GetButtonState GUICtrlToolbar_GetButtonStyle ' +
	        'GUICtrlToolbar_GetButtonText GUICtrlToolbar_GetColorScheme ' +
	        'GUICtrlToolbar_GetDisabledImageList ' +
	        'GUICtrlToolbar_GetExtendedStyle GUICtrlToolbar_GetHotImageList ' +
	        'GUICtrlToolbar_GetHotItem GUICtrlToolbar_GetImageList ' +
	        'GUICtrlToolbar_GetInsertMark GUICtrlToolbar_GetInsertMarkColor ' +
	        'GUICtrlToolbar_GetMaxSize GUICtrlToolbar_GetMetrics ' +
	        'GUICtrlToolbar_GetPadding GUICtrlToolbar_GetRows ' +
	        'GUICtrlToolbar_GetString GUICtrlToolbar_GetStyle ' +
	        'GUICtrlToolbar_GetStyleAltDrag ' +
	        'GUICtrlToolbar_GetStyleCustomErase GUICtrlToolbar_GetStyleFlat ' +
	        'GUICtrlToolbar_GetStyleList GUICtrlToolbar_GetStyleRegisterDrop ' +
	        'GUICtrlToolbar_GetStyleToolTips ' +
	        'GUICtrlToolbar_GetStyleTransparent ' +
	        'GUICtrlToolbar_GetStyleWrapable GUICtrlToolbar_GetTextRows ' +
	        'GUICtrlToolbar_GetToolTips GUICtrlToolbar_GetUnicodeFormat ' +
	        'GUICtrlToolbar_HideButton GUICtrlToolbar_HighlightButton ' +
	        'GUICtrlToolbar_HitTest GUICtrlToolbar_IndexToCommand ' +
	        'GUICtrlToolbar_InsertButton GUICtrlToolbar_InsertMarkHitTest ' +
	        'GUICtrlToolbar_IsButtonChecked GUICtrlToolbar_IsButtonEnabled ' +
	        'GUICtrlToolbar_IsButtonHidden ' +
	        'GUICtrlToolbar_IsButtonHighlighted ' +
	        'GUICtrlToolbar_IsButtonIndeterminate ' +
	        'GUICtrlToolbar_IsButtonPressed GUICtrlToolbar_LoadBitmap ' +
	        'GUICtrlToolbar_LoadImages GUICtrlToolbar_MapAccelerator ' +
	        'GUICtrlToolbar_MoveButton GUICtrlToolbar_PressButton ' +
	        'GUICtrlToolbar_SetAnchorHighlight GUICtrlToolbar_SetBitmapSize ' +
	        'GUICtrlToolbar_SetButtonBitMap GUICtrlToolbar_SetButtonInfo ' +
	        'GUICtrlToolbar_SetButtonInfoEx GUICtrlToolbar_SetButtonParam ' +
	        'GUICtrlToolbar_SetButtonSize GUICtrlToolbar_SetButtonState ' +
	        'GUICtrlToolbar_SetButtonStyle GUICtrlToolbar_SetButtonText ' +
	        'GUICtrlToolbar_SetButtonWidth GUICtrlToolbar_SetCmdID ' +
	        'GUICtrlToolbar_SetColorScheme ' +
	        'GUICtrlToolbar_SetDisabledImageList ' +
	        'GUICtrlToolbar_SetDrawTextFlags GUICtrlToolbar_SetExtendedStyle ' +
	        'GUICtrlToolbar_SetHotImageList GUICtrlToolbar_SetHotItem ' +
	        'GUICtrlToolbar_SetImageList GUICtrlToolbar_SetIndent ' +
	        'GUICtrlToolbar_SetIndeterminate GUICtrlToolbar_SetInsertMark ' +
	        'GUICtrlToolbar_SetInsertMarkColor GUICtrlToolbar_SetMaxTextRows ' +
	        'GUICtrlToolbar_SetMetrics GUICtrlToolbar_SetPadding ' +
	        'GUICtrlToolbar_SetParent GUICtrlToolbar_SetRows ' +
	        'GUICtrlToolbar_SetStyle GUICtrlToolbar_SetStyleAltDrag ' +
	        'GUICtrlToolbar_SetStyleCustomErase GUICtrlToolbar_SetStyleFlat ' +
	        'GUICtrlToolbar_SetStyleList GUICtrlToolbar_SetStyleRegisterDrop ' +
	        'GUICtrlToolbar_SetStyleToolTips ' +
	        'GUICtrlToolbar_SetStyleTransparent ' +
	        'GUICtrlToolbar_SetStyleWrapable GUICtrlToolbar_SetToolTips ' +
	        'GUICtrlToolbar_SetUnicodeFormat GUICtrlToolbar_SetWindowTheme ' +
	        'GUICtrlTreeView_Add GUICtrlTreeView_AddChild ' +
	        'GUICtrlTreeView_AddChildFirst GUICtrlTreeView_AddFirst ' +
	        'GUICtrlTreeView_BeginUpdate GUICtrlTreeView_ClickItem ' +
	        'GUICtrlTreeView_Create GUICtrlTreeView_CreateDragImage ' +
	        'GUICtrlTreeView_CreateSolidBitMap GUICtrlTreeView_Delete ' +
	        'GUICtrlTreeView_DeleteAll GUICtrlTreeView_DeleteChildren ' +
	        'GUICtrlTreeView_Destroy GUICtrlTreeView_DisplayRect ' +
	        'GUICtrlTreeView_DisplayRectEx GUICtrlTreeView_EditText ' +
	        'GUICtrlTreeView_EndEdit GUICtrlTreeView_EndUpdate ' +
	        'GUICtrlTreeView_EnsureVisible GUICtrlTreeView_Expand ' +
	        'GUICtrlTreeView_ExpandedOnce GUICtrlTreeView_FindItem ' +
	        'GUICtrlTreeView_FindItemEx GUICtrlTreeView_GetBkColor ' +
	        'GUICtrlTreeView_GetBold GUICtrlTreeView_GetChecked ' +
	        'GUICtrlTreeView_GetChildCount GUICtrlTreeView_GetChildren ' +
	        'GUICtrlTreeView_GetCount GUICtrlTreeView_GetCut ' +
	        'GUICtrlTreeView_GetDropTarget GUICtrlTreeView_GetEditControl ' +
	        'GUICtrlTreeView_GetExpanded GUICtrlTreeView_GetFirstChild ' +
	        'GUICtrlTreeView_GetFirstItem GUICtrlTreeView_GetFirstVisible ' +
	        'GUICtrlTreeView_GetFocused GUICtrlTreeView_GetHeight ' +
	        'GUICtrlTreeView_GetImageIndex ' +
	        'GUICtrlTreeView_GetImageListIconHandle ' +
	        'GUICtrlTreeView_GetIndent GUICtrlTreeView_GetInsertMarkColor ' +
	        'GUICtrlTreeView_GetISearchString GUICtrlTreeView_GetItemByIndex ' +
	        'GUICtrlTreeView_GetItemHandle GUICtrlTreeView_GetItemParam ' +
	        'GUICtrlTreeView_GetLastChild GUICtrlTreeView_GetLineColor ' +
	        'GUICtrlTreeView_GetNext GUICtrlTreeView_GetNextChild ' +
	        'GUICtrlTreeView_GetNextSibling GUICtrlTreeView_GetNextVisible ' +
	        'GUICtrlTreeView_GetNormalImageList ' +
	        'GUICtrlTreeView_GetParentHandle GUICtrlTreeView_GetParentParam ' +
	        'GUICtrlTreeView_GetPrev GUICtrlTreeView_GetPrevChild ' +
	        'GUICtrlTreeView_GetPrevSibling GUICtrlTreeView_GetPrevVisible ' +
	        'GUICtrlTreeView_GetScrollTime GUICtrlTreeView_GetSelected ' +
	        'GUICtrlTreeView_GetSelectedImageIndex ' +
	        'GUICtrlTreeView_GetSelection GUICtrlTreeView_GetSiblingCount ' +
	        'GUICtrlTreeView_GetState GUICtrlTreeView_GetStateImageIndex ' +
	        'GUICtrlTreeView_GetStateImageList GUICtrlTreeView_GetText ' +
	        'GUICtrlTreeView_GetTextColor GUICtrlTreeView_GetToolTips ' +
	        'GUICtrlTreeView_GetTree GUICtrlTreeView_GetUnicodeFormat ' +
	        'GUICtrlTreeView_GetVisible GUICtrlTreeView_GetVisibleCount ' +
	        'GUICtrlTreeView_HitTest GUICtrlTreeView_HitTestEx ' +
	        'GUICtrlTreeView_HitTestItem GUICtrlTreeView_Index ' +
	        'GUICtrlTreeView_InsertItem GUICtrlTreeView_IsFirstItem ' +
	        'GUICtrlTreeView_IsParent GUICtrlTreeView_Level ' +
	        'GUICtrlTreeView_SelectItem GUICtrlTreeView_SelectItemByIndex ' +
	        'GUICtrlTreeView_SetBkColor GUICtrlTreeView_SetBold ' +
	        'GUICtrlTreeView_SetChecked GUICtrlTreeView_SetCheckedByIndex ' +
	        'GUICtrlTreeView_SetChildren GUICtrlTreeView_SetCut ' +
	        'GUICtrlTreeView_SetDropTarget GUICtrlTreeView_SetFocused ' +
	        'GUICtrlTreeView_SetHeight GUICtrlTreeView_SetIcon ' +
	        'GUICtrlTreeView_SetImageIndex GUICtrlTreeView_SetIndent ' +
	        'GUICtrlTreeView_SetInsertMark ' +
	        'GUICtrlTreeView_SetInsertMarkColor ' +
	        'GUICtrlTreeView_SetItemHeight GUICtrlTreeView_SetItemParam ' +
	        'GUICtrlTreeView_SetLineColor GUICtrlTreeView_SetNormalImageList ' +
	        'GUICtrlTreeView_SetScrollTime GUICtrlTreeView_SetSelected ' +
	        'GUICtrlTreeView_SetSelectedImageIndex GUICtrlTreeView_SetState ' +
	        'GUICtrlTreeView_SetStateImageIndex ' +
	        'GUICtrlTreeView_SetStateImageList GUICtrlTreeView_SetText ' +
	        'GUICtrlTreeView_SetTextColor GUICtrlTreeView_SetToolTips ' +
	        'GUICtrlTreeView_SetUnicodeFormat GUICtrlTreeView_Sort ' +
	        'GUIImageList_Add GUIImageList_AddBitmap GUIImageList_AddIcon ' +
	        'GUIImageList_AddMasked GUIImageList_BeginDrag ' +
	        'GUIImageList_Copy GUIImageList_Create GUIImageList_Destroy ' +
	        'GUIImageList_DestroyIcon GUIImageList_DragEnter ' +
	        'GUIImageList_DragLeave GUIImageList_DragMove ' +
	        'GUIImageList_Draw GUIImageList_DrawEx GUIImageList_Duplicate ' +
	        'GUIImageList_EndDrag GUIImageList_GetBkColor ' +
	        'GUIImageList_GetIcon GUIImageList_GetIconHeight ' +
	        'GUIImageList_GetIconSize GUIImageList_GetIconSizeEx ' +
	        'GUIImageList_GetIconWidth GUIImageList_GetImageCount ' +
	        'GUIImageList_GetImageInfoEx GUIImageList_Remove ' +
	        'GUIImageList_ReplaceIcon GUIImageList_SetBkColor ' +
	        'GUIImageList_SetIconSize GUIImageList_SetImageCount ' +
	        'GUIImageList_Swap GUIScrollBars_EnableScrollBar ' +
	        'GUIScrollBars_GetScrollBarInfoEx GUIScrollBars_GetScrollBarRect ' +
	        'GUIScrollBars_GetScrollBarRGState ' +
	        'GUIScrollBars_GetScrollBarXYLineButton ' +
	        'GUIScrollBars_GetScrollBarXYThumbBottom ' +
	        'GUIScrollBars_GetScrollBarXYThumbTop ' +
	        'GUIScrollBars_GetScrollInfo GUIScrollBars_GetScrollInfoEx ' +
	        'GUIScrollBars_GetScrollInfoMax GUIScrollBars_GetScrollInfoMin ' +
	        'GUIScrollBars_GetScrollInfoPage GUIScrollBars_GetScrollInfoPos ' +
	        'GUIScrollBars_GetScrollInfoTrackPos GUIScrollBars_GetScrollPos ' +
	        'GUIScrollBars_GetScrollRange GUIScrollBars_Init ' +
	        'GUIScrollBars_ScrollWindow GUIScrollBars_SetScrollInfo ' +
	        'GUIScrollBars_SetScrollInfoMax GUIScrollBars_SetScrollInfoMin ' +
	        'GUIScrollBars_SetScrollInfoPage GUIScrollBars_SetScrollInfoPos ' +
	        'GUIScrollBars_SetScrollRange GUIScrollBars_ShowScrollBar ' +
	        'GUIToolTip_Activate GUIToolTip_AddTool GUIToolTip_AdjustRect ' +
	        'GUIToolTip_BitsToTTF GUIToolTip_Create GUIToolTip_Deactivate ' +
	        'GUIToolTip_DelTool GUIToolTip_Destroy GUIToolTip_EnumTools ' +
	        'GUIToolTip_GetBubbleHeight GUIToolTip_GetBubbleSize ' +
	        'GUIToolTip_GetBubbleWidth GUIToolTip_GetCurrentTool ' +
	        'GUIToolTip_GetDelayTime GUIToolTip_GetMargin ' +
	        'GUIToolTip_GetMarginEx GUIToolTip_GetMaxTipWidth ' +
	        'GUIToolTip_GetText GUIToolTip_GetTipBkColor ' +
	        'GUIToolTip_GetTipTextColor GUIToolTip_GetTitleBitMap ' +
	        'GUIToolTip_GetTitleText GUIToolTip_GetToolCount ' +
	        'GUIToolTip_GetToolInfo GUIToolTip_HitTest ' +
	        'GUIToolTip_NewToolRect GUIToolTip_Pop GUIToolTip_PopUp ' +
	        'GUIToolTip_SetDelayTime GUIToolTip_SetMargin ' +
	        'GUIToolTip_SetMaxTipWidth GUIToolTip_SetTipBkColor ' +
	        'GUIToolTip_SetTipTextColor GUIToolTip_SetTitle ' +
	        'GUIToolTip_SetToolInfo GUIToolTip_SetWindowTheme ' +
	        'GUIToolTip_ToolExists GUIToolTip_ToolToArray ' +
	        'GUIToolTip_TrackActivate GUIToolTip_TrackPosition ' +
	        'GUIToolTip_Update GUIToolTip_UpdateTipText HexToString ' +
	        'IEAction IEAttach IEBodyReadHTML IEBodyReadText ' +
	        'IEBodyWriteHTML IECreate IECreateEmbedded IEDocGetObj ' +
	        'IEDocInsertHTML IEDocInsertText IEDocReadHTML ' +
	        'IEDocWriteHTML IEErrorNotify IEFormElementCheckBoxSelect ' +
	        'IEFormElementGetCollection IEFormElementGetObjByName ' +
	        'IEFormElementGetValue IEFormElementOptionSelect ' +
	        'IEFormElementRadioSelect IEFormElementSetValue ' +
	        'IEFormGetCollection IEFormGetObjByName IEFormImageClick ' +
	        'IEFormReset IEFormSubmit IEFrameGetCollection ' +
	        'IEFrameGetObjByName IEGetObjById IEGetObjByName ' +
	        'IEHeadInsertEventScript IEImgClick IEImgGetCollection ' +
	        'IEIsFrameSet IELinkClickByIndex IELinkClickByText ' +
	        'IELinkGetCollection IELoadWait IELoadWaitTimeout IENavigate ' +
	        'IEPropertyGet IEPropertySet IEQuit IETableGetCollection ' +
	        'IETableWriteToArray IETagNameAllGetCollection ' +
	        'IETagNameGetCollection IE_Example IE_Introduction ' +
	        'IE_VersionInfo INetExplorerCapable INetGetSource INetMail ' +
	        'INetSmtpMail IsPressed MathCheckDiv Max MemGlobalAlloc ' +
	        'MemGlobalFree MemGlobalLock MemGlobalSize MemGlobalUnlock ' +
	        'MemMoveMemory MemVirtualAlloc MemVirtualAllocEx ' +
	        'MemVirtualFree MemVirtualFreeEx Min MouseTrap ' +
	        'NamedPipes_CallNamedPipe NamedPipes_ConnectNamedPipe ' +
	        'NamedPipes_CreateNamedPipe NamedPipes_CreatePipe ' +
	        'NamedPipes_DisconnectNamedPipe ' +
	        'NamedPipes_GetNamedPipeHandleState NamedPipes_GetNamedPipeInfo ' +
	        'NamedPipes_PeekNamedPipe NamedPipes_SetNamedPipeHandleState ' +
	        'NamedPipes_TransactNamedPipe NamedPipes_WaitNamedPipe ' +
	        'Net_Share_ConnectionEnum Net_Share_FileClose ' +
	        'Net_Share_FileEnum Net_Share_FileGetInfo Net_Share_PermStr ' +
	        'Net_Share_ResourceStr Net_Share_SessionDel ' +
	        'Net_Share_SessionEnum Net_Share_SessionGetInfo ' +
	        'Net_Share_ShareAdd Net_Share_ShareCheck Net_Share_ShareDel ' +
	        'Net_Share_ShareEnum Net_Share_ShareGetInfo ' +
	        'Net_Share_ShareSetInfo Net_Share_StatisticsGetSvr ' +
	        'Net_Share_StatisticsGetWrk Now NowCalc NowCalcDate ' +
	        'NowDate NowTime PathFull PathGetRelative PathMake ' +
	        'PathSplit ProcessGetName ProcessGetPriority Radian ' +
	        'ReplaceStringInFile RunDos ScreenCapture_Capture ' +
	        'ScreenCapture_CaptureWnd ScreenCapture_SaveImage ' +
	        'ScreenCapture_SetBMPFormat ScreenCapture_SetJPGQuality ' +
	        'ScreenCapture_SetTIFColorDepth ScreenCapture_SetTIFCompression ' +
	        'Security__AdjustTokenPrivileges ' +
	        'Security__CreateProcessWithToken Security__DuplicateTokenEx ' +
	        'Security__GetAccountSid Security__GetLengthSid ' +
	        'Security__GetTokenInformation Security__ImpersonateSelf ' +
	        'Security__IsValidSid Security__LookupAccountName ' +
	        'Security__LookupAccountSid Security__LookupPrivilegeValue ' +
	        'Security__OpenProcessToken Security__OpenThreadToken ' +
	        'Security__OpenThreadTokenEx Security__SetPrivilege ' +
	        'Security__SetTokenInformation Security__SidToStringSid ' +
	        'Security__SidTypeStr Security__StringSidToSid SendMessage ' +
	        'SendMessageA SetDate SetTime Singleton SoundClose ' +
	        'SoundLength SoundOpen SoundPause SoundPlay SoundPos ' +
	        'SoundResume SoundSeek SoundStatus SoundStop ' +
	        'SQLite_Changes SQLite_Close SQLite_Display2DResult ' +
	        'SQLite_Encode SQLite_ErrCode SQLite_ErrMsg SQLite_Escape ' +
	        'SQLite_Exec SQLite_FastEncode SQLite_FastEscape ' +
	        'SQLite_FetchData SQLite_FetchNames SQLite_GetTable ' +
	        'SQLite_GetTable2d SQLite_LastInsertRowID SQLite_LibVersion ' +
	        'SQLite_Open SQLite_Query SQLite_QueryFinalize ' +
	        'SQLite_QueryReset SQLite_QuerySingleRow SQLite_SafeMode ' +
	        'SQLite_SetTimeout SQLite_Shutdown SQLite_SQLiteExe ' +
	        'SQLite_Startup SQLite_TotalChanges StringBetween ' +
	        'StringExplode StringInsert StringProper StringRepeat ' +
	        'StringTitleCase StringToHex TCPIpToName TempFile ' +
	        'TicksToTime Timer_Diff Timer_GetIdleTime Timer_GetTimerID ' +
	        'Timer_Init Timer_KillAllTimers Timer_KillTimer ' +
	        'Timer_SetTimer TimeToTicks VersionCompare viClose ' +
	        'viExecCommand viFindGpib viGpibBusReset viGTL ' +
	        'viInteractiveControl viOpen viSetAttribute viSetTimeout ' +
	        'WeekNumberISO WinAPI_AbortPath WinAPI_ActivateKeyboardLayout ' +
	        'WinAPI_AddClipboardFormatListener WinAPI_AddFontMemResourceEx ' +
	        'WinAPI_AddFontResourceEx WinAPI_AddIconOverlay ' +
	        'WinAPI_AddIconTransparency WinAPI_AddMRUString ' +
	        'WinAPI_AdjustBitmap WinAPI_AdjustTokenPrivileges ' +
	        'WinAPI_AdjustWindowRectEx WinAPI_AlphaBlend WinAPI_AngleArc ' +
	        'WinAPI_AnimateWindow WinAPI_Arc WinAPI_ArcTo ' +
	        'WinAPI_ArrayToStruct WinAPI_AssignProcessToJobObject ' +
	        'WinAPI_AssocGetPerceivedType WinAPI_AssocQueryString ' +
	        'WinAPI_AttachConsole WinAPI_AttachThreadInput ' +
	        'WinAPI_BackupRead WinAPI_BackupReadAbort WinAPI_BackupSeek ' +
	        'WinAPI_BackupWrite WinAPI_BackupWriteAbort WinAPI_Beep ' +
	        'WinAPI_BeginBufferedPaint WinAPI_BeginDeferWindowPos ' +
	        'WinAPI_BeginPaint WinAPI_BeginPath WinAPI_BeginUpdateResource ' +
	        'WinAPI_BitBlt WinAPI_BringWindowToTop ' +
	        'WinAPI_BroadcastSystemMessage WinAPI_BrowseForFolderDlg ' +
	        'WinAPI_BufferedPaintClear WinAPI_BufferedPaintInit ' +
	        'WinAPI_BufferedPaintSetAlpha WinAPI_BufferedPaintUnInit ' +
	        'WinAPI_CallNextHookEx WinAPI_CallWindowProc ' +
	        'WinAPI_CallWindowProcW WinAPI_CascadeWindows ' +
	        'WinAPI_ChangeWindowMessageFilterEx WinAPI_CharToOem ' +
	        'WinAPI_ChildWindowFromPointEx WinAPI_ClientToScreen ' +
	        'WinAPI_ClipCursor WinAPI_CloseDesktop WinAPI_CloseEnhMetaFile ' +
	        'WinAPI_CloseFigure WinAPI_CloseHandle WinAPI_CloseThemeData ' +
	        'WinAPI_CloseWindow WinAPI_CloseWindowStation ' +
	        'WinAPI_CLSIDFromProgID WinAPI_CoInitialize ' +
	        'WinAPI_ColorAdjustLuma WinAPI_ColorHLSToRGB ' +
	        'WinAPI_ColorRGBToHLS WinAPI_CombineRgn ' +
	        'WinAPI_CombineTransform WinAPI_CommandLineToArgv ' +
	        'WinAPI_CommDlgExtendedError WinAPI_CommDlgExtendedErrorEx ' +
	        'WinAPI_CompareString WinAPI_CompressBitmapBits ' +
	        'WinAPI_CompressBuffer WinAPI_ComputeCrc32 ' +
	        'WinAPI_ConfirmCredentials WinAPI_CopyBitmap WinAPI_CopyCursor ' +
	        'WinAPI_CopyEnhMetaFile WinAPI_CopyFileEx WinAPI_CopyIcon ' +
	        'WinAPI_CopyImage WinAPI_CopyRect WinAPI_CopyStruct ' +
	        'WinAPI_CoTaskMemAlloc WinAPI_CoTaskMemFree ' +
	        'WinAPI_CoTaskMemRealloc WinAPI_CoUninitialize ' +
	        'WinAPI_Create32BitHBITMAP WinAPI_Create32BitHICON ' +
	        'WinAPI_CreateANDBitmap WinAPI_CreateBitmap ' +
	        'WinAPI_CreateBitmapIndirect WinAPI_CreateBrushIndirect ' +
	        'WinAPI_CreateBuffer WinAPI_CreateBufferFromStruct ' +
	        'WinAPI_CreateCaret WinAPI_CreateColorAdjustment ' +
	        'WinAPI_CreateCompatibleBitmap WinAPI_CreateCompatibleBitmapEx ' +
	        'WinAPI_CreateCompatibleDC WinAPI_CreateDesktop ' +
	        'WinAPI_CreateDIB WinAPI_CreateDIBColorTable ' +
	        'WinAPI_CreateDIBitmap WinAPI_CreateDIBSection ' +
	        'WinAPI_CreateDirectory WinAPI_CreateDirectoryEx ' +
	        'WinAPI_CreateEllipticRgn WinAPI_CreateEmptyIcon ' +
	        'WinAPI_CreateEnhMetaFile WinAPI_CreateEvent WinAPI_CreateFile ' +
	        'WinAPI_CreateFileEx WinAPI_CreateFileMapping ' +
	        'WinAPI_CreateFont WinAPI_CreateFontEx ' +
	        'WinAPI_CreateFontIndirect WinAPI_CreateGUID ' +
	        'WinAPI_CreateHardLink WinAPI_CreateIcon ' +
	        'WinAPI_CreateIconFromResourceEx WinAPI_CreateIconIndirect ' +
	        'WinAPI_CreateJobObject WinAPI_CreateMargins ' +
	        'WinAPI_CreateMRUList WinAPI_CreateMutex WinAPI_CreateNullRgn ' +
	        'WinAPI_CreateNumberFormatInfo WinAPI_CreateObjectID ' +
	        'WinAPI_CreatePen WinAPI_CreatePoint WinAPI_CreatePolygonRgn ' +
	        'WinAPI_CreateProcess WinAPI_CreateProcessWithToken ' +
	        'WinAPI_CreateRect WinAPI_CreateRectEx WinAPI_CreateRectRgn ' +
	        'WinAPI_CreateRectRgnIndirect WinAPI_CreateRoundRectRgn ' +
	        'WinAPI_CreateSemaphore WinAPI_CreateSize ' +
	        'WinAPI_CreateSolidBitmap WinAPI_CreateSolidBrush ' +
	        'WinAPI_CreateStreamOnHGlobal WinAPI_CreateString ' +
	        'WinAPI_CreateSymbolicLink WinAPI_CreateTransform ' +
	        'WinAPI_CreateWindowEx WinAPI_CreateWindowStation ' +
	        'WinAPI_DecompressBuffer WinAPI_DecryptFile ' +
	        'WinAPI_DeferWindowPos WinAPI_DefineDosDevice ' +
	        'WinAPI_DefRawInputProc WinAPI_DefSubclassProc ' +
	        'WinAPI_DefWindowProc WinAPI_DefWindowProcW WinAPI_DeleteDC ' +
	        'WinAPI_DeleteEnhMetaFile WinAPI_DeleteFile ' +
	        'WinAPI_DeleteObject WinAPI_DeleteObjectID ' +
	        'WinAPI_DeleteVolumeMountPoint WinAPI_DeregisterShellHookWindow ' +
	        'WinAPI_DestroyCaret WinAPI_DestroyCursor WinAPI_DestroyIcon ' +
	        'WinAPI_DestroyWindow WinAPI_DeviceIoControl ' +
	        'WinAPI_DisplayStruct WinAPI_DllGetVersion WinAPI_DllInstall ' +
	        'WinAPI_DllUninstall WinAPI_DPtoLP WinAPI_DragAcceptFiles ' +
	        'WinAPI_DragFinish WinAPI_DragQueryFileEx ' +
	        'WinAPI_DragQueryPoint WinAPI_DrawAnimatedRects ' +
	        'WinAPI_DrawBitmap WinAPI_DrawEdge WinAPI_DrawFocusRect ' +
	        'WinAPI_DrawFrameControl WinAPI_DrawIcon WinAPI_DrawIconEx ' +
	        'WinAPI_DrawLine WinAPI_DrawShadowText WinAPI_DrawText ' +
	        'WinAPI_DrawThemeBackground WinAPI_DrawThemeEdge ' +
	        'WinAPI_DrawThemeIcon WinAPI_DrawThemeParentBackground ' +
	        'WinAPI_DrawThemeText WinAPI_DrawThemeTextEx ' +
	        'WinAPI_DuplicateEncryptionInfoFile WinAPI_DuplicateHandle ' +
	        'WinAPI_DuplicateTokenEx WinAPI_DwmDefWindowProc ' +
	        'WinAPI_DwmEnableBlurBehindWindow WinAPI_DwmEnableComposition ' +
	        'WinAPI_DwmExtendFrameIntoClientArea ' +
	        'WinAPI_DwmGetColorizationColor ' +
	        'WinAPI_DwmGetColorizationParameters ' +
	        'WinAPI_DwmGetWindowAttribute WinAPI_DwmInvalidateIconicBitmaps ' +
	        'WinAPI_DwmIsCompositionEnabled ' +
	        'WinAPI_DwmQueryThumbnailSourceSize WinAPI_DwmRegisterThumbnail ' +
	        'WinAPI_DwmSetColorizationParameters ' +
	        'WinAPI_DwmSetIconicLivePreviewBitmap ' +
	        'WinAPI_DwmSetIconicThumbnail WinAPI_DwmSetWindowAttribute ' +
	        'WinAPI_DwmUnregisterThumbnail ' +
	        'WinAPI_DwmUpdateThumbnailProperties WinAPI_DWordToFloat ' +
	        'WinAPI_DWordToInt WinAPI_EjectMedia WinAPI_Ellipse ' +
	        'WinAPI_EmptyWorkingSet WinAPI_EnableWindow WinAPI_EncryptFile ' +
	        'WinAPI_EncryptionDisable WinAPI_EndBufferedPaint ' +
	        'WinAPI_EndDeferWindowPos WinAPI_EndPaint WinAPI_EndPath ' +
	        'WinAPI_EndUpdateResource WinAPI_EnumChildProcess ' +
	        'WinAPI_EnumChildWindows WinAPI_EnumDesktops ' +
	        'WinAPI_EnumDesktopWindows WinAPI_EnumDeviceDrivers ' +
	        'WinAPI_EnumDisplayDevices WinAPI_EnumDisplayMonitors ' +
	        'WinAPI_EnumDisplaySettings WinAPI_EnumDllProc ' +
	        'WinAPI_EnumFiles WinAPI_EnumFileStreams ' +
	        'WinAPI_EnumFontFamilies WinAPI_EnumHardLinks ' +
	        'WinAPI_EnumMRUList WinAPI_EnumPageFiles ' +
	        'WinAPI_EnumProcessHandles WinAPI_EnumProcessModules ' +
	        'WinAPI_EnumProcessThreads WinAPI_EnumProcessWindows ' +
	        'WinAPI_EnumRawInputDevices WinAPI_EnumResourceLanguages ' +
	        'WinAPI_EnumResourceNames WinAPI_EnumResourceTypes ' +
	        'WinAPI_EnumSystemGeoID WinAPI_EnumSystemLocales ' +
	        'WinAPI_EnumUILanguages WinAPI_EnumWindows ' +
	        'WinAPI_EnumWindowsPopup WinAPI_EnumWindowStations ' +
	        'WinAPI_EnumWindowsTop WinAPI_EqualMemory WinAPI_EqualRect ' +
	        'WinAPI_EqualRgn WinAPI_ExcludeClipRect ' +
	        'WinAPI_ExpandEnvironmentStrings WinAPI_ExtCreatePen ' +
	        'WinAPI_ExtCreateRegion WinAPI_ExtFloodFill WinAPI_ExtractIcon ' +
	        'WinAPI_ExtractIconEx WinAPI_ExtSelectClipRgn ' +
	        'WinAPI_FatalAppExit WinAPI_FatalExit ' +
	        'WinAPI_FileEncryptionStatus WinAPI_FileExists ' +
	        'WinAPI_FileIconInit WinAPI_FileInUse WinAPI_FillMemory ' +
	        'WinAPI_FillPath WinAPI_FillRect WinAPI_FillRgn ' +
	        'WinAPI_FindClose WinAPI_FindCloseChangeNotification ' +
	        'WinAPI_FindExecutable WinAPI_FindFirstChangeNotification ' +
	        'WinAPI_FindFirstFile WinAPI_FindFirstFileName ' +
	        'WinAPI_FindFirstStream WinAPI_FindNextChangeNotification ' +
	        'WinAPI_FindNextFile WinAPI_FindNextFileName ' +
	        'WinAPI_FindNextStream WinAPI_FindResource ' +
	        'WinAPI_FindResourceEx WinAPI_FindTextDlg WinAPI_FindWindow ' +
	        'WinAPI_FlashWindow WinAPI_FlashWindowEx WinAPI_FlattenPath ' +
	        'WinAPI_FloatToDWord WinAPI_FloatToInt WinAPI_FlushFileBuffers ' +
	        'WinAPI_FlushFRBuffer WinAPI_FlushViewOfFile ' +
	        'WinAPI_FormatDriveDlg WinAPI_FormatMessage WinAPI_FrameRect ' +
	        'WinAPI_FrameRgn WinAPI_FreeLibrary WinAPI_FreeMemory ' +
	        'WinAPI_FreeMRUList WinAPI_FreeResource WinAPI_GdiComment ' +
	        'WinAPI_GetActiveWindow WinAPI_GetAllUsersProfileDirectory ' +
	        'WinAPI_GetAncestor WinAPI_GetApplicationRestartSettings ' +
	        'WinAPI_GetArcDirection WinAPI_GetAsyncKeyState ' +
	        'WinAPI_GetBinaryType WinAPI_GetBitmapBits ' +
	        'WinAPI_GetBitmapDimension WinAPI_GetBitmapDimensionEx ' +
	        'WinAPI_GetBkColor WinAPI_GetBkMode WinAPI_GetBoundsRect ' +
	        'WinAPI_GetBrushOrg WinAPI_GetBufferedPaintBits ' +
	        'WinAPI_GetBufferedPaintDC WinAPI_GetBufferedPaintTargetDC ' +
	        'WinAPI_GetBufferedPaintTargetRect WinAPI_GetBValue ' +
	        'WinAPI_GetCaretBlinkTime WinAPI_GetCaretPos WinAPI_GetCDType ' +
	        'WinAPI_GetClassInfoEx WinAPI_GetClassLongEx ' +
	        'WinAPI_GetClassName WinAPI_GetClientHeight ' +
	        'WinAPI_GetClientRect WinAPI_GetClientWidth ' +
	        'WinAPI_GetClipboardSequenceNumber WinAPI_GetClipBox ' +
	        'WinAPI_GetClipCursor WinAPI_GetClipRgn ' +
	        'WinAPI_GetColorAdjustment WinAPI_GetCompressedFileSize ' +
	        'WinAPI_GetCompression WinAPI_GetConnectedDlg ' +
	        'WinAPI_GetCurrentDirectory WinAPI_GetCurrentHwProfile ' +
	        'WinAPI_GetCurrentObject WinAPI_GetCurrentPosition ' +
	        'WinAPI_GetCurrentProcess ' +
	        'WinAPI_GetCurrentProcessExplicitAppUserModelID ' +
	        'WinAPI_GetCurrentProcessID WinAPI_GetCurrentThemeName ' +
	        'WinAPI_GetCurrentThread WinAPI_GetCurrentThreadId ' +
	        'WinAPI_GetCursor WinAPI_GetCursorInfo WinAPI_GetDateFormat ' +
	        'WinAPI_GetDC WinAPI_GetDCEx WinAPI_GetDefaultPrinter ' +
	        'WinAPI_GetDefaultUserProfileDirectory WinAPI_GetDesktopWindow ' +
	        'WinAPI_GetDeviceCaps WinAPI_GetDeviceDriverBaseName ' +
	        'WinAPI_GetDeviceDriverFileName WinAPI_GetDeviceGammaRamp ' +
	        'WinAPI_GetDIBColorTable WinAPI_GetDIBits ' +
	        'WinAPI_GetDiskFreeSpaceEx WinAPI_GetDlgCtrlID ' +
	        'WinAPI_GetDlgItem WinAPI_GetDllDirectory ' +
	        'WinAPI_GetDriveBusType WinAPI_GetDriveGeometryEx ' +
	        'WinAPI_GetDriveNumber WinAPI_GetDriveType ' +
	        'WinAPI_GetDurationFormat WinAPI_GetEffectiveClientRect ' +
	        'WinAPI_GetEnhMetaFile WinAPI_GetEnhMetaFileBits ' +
	        'WinAPI_GetEnhMetaFileDescription WinAPI_GetEnhMetaFileDimension ' +
	        'WinAPI_GetEnhMetaFileHeader WinAPI_GetErrorMessage ' +
	        'WinAPI_GetErrorMode WinAPI_GetExitCodeProcess ' +
	        'WinAPI_GetExtended WinAPI_GetFileAttributes WinAPI_GetFileID ' +
	        'WinAPI_GetFileInformationByHandle ' +
	        'WinAPI_GetFileInformationByHandleEx WinAPI_GetFilePointerEx ' +
	        'WinAPI_GetFileSizeEx WinAPI_GetFileSizeOnDisk ' +
	        'WinAPI_GetFileTitle WinAPI_GetFileType ' +
	        'WinAPI_GetFileVersionInfo WinAPI_GetFinalPathNameByHandle ' +
	        'WinAPI_GetFinalPathNameByHandleEx WinAPI_GetFocus ' +
	        'WinAPI_GetFontMemoryResourceInfo WinAPI_GetFontName ' +
	        'WinAPI_GetFontResourceInfo WinAPI_GetForegroundWindow ' +
	        'WinAPI_GetFRBuffer WinAPI_GetFullPathName WinAPI_GetGeoInfo ' +
	        'WinAPI_GetGlyphOutline WinAPI_GetGraphicsMode ' +
	        'WinAPI_GetGuiResources WinAPI_GetGUIThreadInfo ' +
	        'WinAPI_GetGValue WinAPI_GetHandleInformation ' +
	        'WinAPI_GetHGlobalFromStream WinAPI_GetIconDimension ' +
	        'WinAPI_GetIconInfo WinAPI_GetIconInfoEx WinAPI_GetIdleTime ' +
	        'WinAPI_GetKeyboardLayout WinAPI_GetKeyboardLayoutList ' +
	        'WinAPI_GetKeyboardState WinAPI_GetKeyboardType ' +
	        'WinAPI_GetKeyNameText WinAPI_GetKeyState ' +
	        'WinAPI_GetLastActivePopup WinAPI_GetLastError ' +
	        'WinAPI_GetLastErrorMessage WinAPI_GetLayeredWindowAttributes ' +
	        'WinAPI_GetLocaleInfo WinAPI_GetLogicalDrives ' +
	        'WinAPI_GetMapMode WinAPI_GetMemorySize ' +
	        'WinAPI_GetMessageExtraInfo WinAPI_GetModuleFileNameEx ' +
	        'WinAPI_GetModuleHandle WinAPI_GetModuleHandleEx ' +
	        'WinAPI_GetModuleInformation WinAPI_GetMonitorInfo ' +
	        'WinAPI_GetMousePos WinAPI_GetMousePosX WinAPI_GetMousePosY ' +
	        'WinAPI_GetMUILanguage WinAPI_GetNumberFormat WinAPI_GetObject ' +
	        'WinAPI_GetObjectID WinAPI_GetObjectInfoByHandle ' +
	        'WinAPI_GetObjectNameByHandle WinAPI_GetObjectType ' +
	        'WinAPI_GetOpenFileName WinAPI_GetOutlineTextMetrics ' +
	        'WinAPI_GetOverlappedResult WinAPI_GetParent ' +
	        'WinAPI_GetParentProcess WinAPI_GetPerformanceInfo ' +
	        'WinAPI_GetPEType WinAPI_GetPhysicallyInstalledSystemMemory ' +
	        'WinAPI_GetPixel WinAPI_GetPolyFillMode WinAPI_GetPosFromRect ' +
	        'WinAPI_GetPriorityClass WinAPI_GetProcAddress ' +
	        'WinAPI_GetProcessAffinityMask WinAPI_GetProcessCommandLine ' +
	        'WinAPI_GetProcessFileName WinAPI_GetProcessHandleCount ' +
	        'WinAPI_GetProcessID WinAPI_GetProcessIoCounters ' +
	        'WinAPI_GetProcessMemoryInfo WinAPI_GetProcessName ' +
	        'WinAPI_GetProcessShutdownParameters WinAPI_GetProcessTimes ' +
	        'WinAPI_GetProcessUser WinAPI_GetProcessWindowStation ' +
	        'WinAPI_GetProcessWorkingDirectory WinAPI_GetProfilesDirectory ' +
	        'WinAPI_GetPwrCapabilities WinAPI_GetRawInputBuffer ' +
	        'WinAPI_GetRawInputBufferLength WinAPI_GetRawInputData ' +
	        'WinAPI_GetRawInputDeviceInfo WinAPI_GetRegionData ' +
	        'WinAPI_GetRegisteredRawInputDevices ' +
	        'WinAPI_GetRegKeyNameByHandle WinAPI_GetRgnBox WinAPI_GetROP2 ' +
	        'WinAPI_GetRValue WinAPI_GetSaveFileName WinAPI_GetShellWindow ' +
	        'WinAPI_GetStartupInfo WinAPI_GetStdHandle ' +
	        'WinAPI_GetStockObject WinAPI_GetStretchBltMode ' +
	        'WinAPI_GetString WinAPI_GetSysColor WinAPI_GetSysColorBrush ' +
	        'WinAPI_GetSystemDefaultLangID WinAPI_GetSystemDefaultLCID ' +
	        'WinAPI_GetSystemDefaultUILanguage WinAPI_GetSystemDEPPolicy ' +
	        'WinAPI_GetSystemInfo WinAPI_GetSystemMetrics ' +
	        'WinAPI_GetSystemPowerStatus WinAPI_GetSystemTimes ' +
	        'WinAPI_GetSystemWow64Directory WinAPI_GetTabbedTextExtent ' +
	        'WinAPI_GetTempFileName WinAPI_GetTextAlign ' +
	        'WinAPI_GetTextCharacterExtra WinAPI_GetTextColor ' +
	        'WinAPI_GetTextExtentPoint32 WinAPI_GetTextFace ' +
	        'WinAPI_GetTextMetrics WinAPI_GetThemeAppProperties ' +
	        'WinAPI_GetThemeBackgroundContentRect ' +
	        'WinAPI_GetThemeBackgroundExtent WinAPI_GetThemeBackgroundRegion ' +
	        'WinAPI_GetThemeBitmap WinAPI_GetThemeBool ' +
	        'WinAPI_GetThemeColor WinAPI_GetThemeDocumentationProperty ' +
	        'WinAPI_GetThemeEnumValue WinAPI_GetThemeFilename ' +
	        'WinAPI_GetThemeFont WinAPI_GetThemeInt WinAPI_GetThemeMargins ' +
	        'WinAPI_GetThemeMetric WinAPI_GetThemePartSize ' +
	        'WinAPI_GetThemePosition WinAPI_GetThemePropertyOrigin ' +
	        'WinAPI_GetThemeRect WinAPI_GetThemeString ' +
	        'WinAPI_GetThemeSysBool WinAPI_GetThemeSysColor ' +
	        'WinAPI_GetThemeSysColorBrush WinAPI_GetThemeSysFont ' +
	        'WinAPI_GetThemeSysInt WinAPI_GetThemeSysSize ' +
	        'WinAPI_GetThemeSysString WinAPI_GetThemeTextExtent ' +
	        'WinAPI_GetThemeTextMetrics WinAPI_GetThemeTransitionDuration ' +
	        'WinAPI_GetThreadDesktop WinAPI_GetThreadErrorMode ' +
	        'WinAPI_GetThreadLocale WinAPI_GetThreadUILanguage ' +
	        'WinAPI_GetTickCount WinAPI_GetTickCount64 ' +
	        'WinAPI_GetTimeFormat WinAPI_GetTopWindow ' +
	        'WinAPI_GetUDFColorMode WinAPI_GetUpdateRect ' +
	        'WinAPI_GetUpdateRgn WinAPI_GetUserDefaultLangID ' +
	        'WinAPI_GetUserDefaultLCID WinAPI_GetUserDefaultUILanguage ' +
	        'WinAPI_GetUserGeoID WinAPI_GetUserObjectInformation ' +
	        'WinAPI_GetVersion WinAPI_GetVersionEx ' +
	        'WinAPI_GetVolumeInformation WinAPI_GetVolumeInformationByHandle ' +
	        'WinAPI_GetVolumeNameForVolumeMountPoint WinAPI_GetWindow ' +
	        'WinAPI_GetWindowDC WinAPI_GetWindowDisplayAffinity ' +
	        'WinAPI_GetWindowExt WinAPI_GetWindowFileName ' +
	        'WinAPI_GetWindowHeight WinAPI_GetWindowInfo ' +
	        'WinAPI_GetWindowLong WinAPI_GetWindowOrg ' +
	        'WinAPI_GetWindowPlacement WinAPI_GetWindowRect ' +
	        'WinAPI_GetWindowRgn WinAPI_GetWindowRgnBox ' +
	        'WinAPI_GetWindowSubclass WinAPI_GetWindowText ' +
	        'WinAPI_GetWindowTheme WinAPI_GetWindowThreadProcessId ' +
	        'WinAPI_GetWindowWidth WinAPI_GetWorkArea ' +
	        'WinAPI_GetWorldTransform WinAPI_GetXYFromPoint ' +
	        'WinAPI_GlobalMemoryStatus WinAPI_GradientFill ' +
	        'WinAPI_GUIDFromString WinAPI_GUIDFromStringEx WinAPI_HashData ' +
	        'WinAPI_HashString WinAPI_HiByte WinAPI_HideCaret ' +
	        'WinAPI_HiDWord WinAPI_HiWord WinAPI_InflateRect ' +
	        'WinAPI_InitMUILanguage WinAPI_InProcess ' +
	        'WinAPI_IntersectClipRect WinAPI_IntersectRect ' +
	        'WinAPI_IntToDWord WinAPI_IntToFloat WinAPI_InvalidateRect ' +
	        'WinAPI_InvalidateRgn WinAPI_InvertANDBitmap ' +
	        'WinAPI_InvertColor WinAPI_InvertRect WinAPI_InvertRgn ' +
	        'WinAPI_IOCTL WinAPI_IsAlphaBitmap WinAPI_IsBadCodePtr ' +
	        'WinAPI_IsBadReadPtr WinAPI_IsBadStringPtr ' +
	        'WinAPI_IsBadWritePtr WinAPI_IsChild WinAPI_IsClassName ' +
	        'WinAPI_IsDoorOpen WinAPI_IsElevated WinAPI_IsHungAppWindow ' +
	        'WinAPI_IsIconic WinAPI_IsInternetConnected ' +
	        'WinAPI_IsLoadKBLayout WinAPI_IsMemory ' +
	        'WinAPI_IsNameInExpression WinAPI_IsNetworkAlive ' +
	        'WinAPI_IsPathShared WinAPI_IsProcessInJob ' +
	        'WinAPI_IsProcessorFeaturePresent WinAPI_IsRectEmpty ' +
	        'WinAPI_IsThemeActive ' +
	        'WinAPI_IsThemeBackgroundPartiallyTransparent ' +
	        'WinAPI_IsThemePartDefined WinAPI_IsValidLocale ' +
	        'WinAPI_IsWindow WinAPI_IsWindowEnabled WinAPI_IsWindowUnicode ' +
	        'WinAPI_IsWindowVisible WinAPI_IsWow64Process ' +
	        'WinAPI_IsWritable WinAPI_IsZoomed WinAPI_Keybd_Event ' +
	        'WinAPI_KillTimer WinAPI_LineDDA WinAPI_LineTo ' +
	        'WinAPI_LoadBitmap WinAPI_LoadCursor WinAPI_LoadCursorFromFile ' +
	        'WinAPI_LoadIcon WinAPI_LoadIconMetric ' +
	        'WinAPI_LoadIconWithScaleDown WinAPI_LoadImage ' +
	        'WinAPI_LoadIndirectString WinAPI_LoadKeyboardLayout ' +
	        'WinAPI_LoadLibrary WinAPI_LoadLibraryEx WinAPI_LoadMedia ' +
	        'WinAPI_LoadResource WinAPI_LoadShell32Icon WinAPI_LoadString ' +
	        'WinAPI_LoadStringEx WinAPI_LoByte WinAPI_LocalFree ' +
	        'WinAPI_LockDevice WinAPI_LockFile WinAPI_LockResource ' +
	        'WinAPI_LockWindowUpdate WinAPI_LockWorkStation WinAPI_LoDWord ' +
	        'WinAPI_LongMid WinAPI_LookupIconIdFromDirectoryEx ' +
	        'WinAPI_LoWord WinAPI_LPtoDP WinAPI_MAKELANGID ' +
	        'WinAPI_MAKELCID WinAPI_MakeLong WinAPI_MakeQWord ' +
	        'WinAPI_MakeWord WinAPI_MapViewOfFile WinAPI_MapVirtualKey ' +
	        'WinAPI_MaskBlt WinAPI_MessageBeep WinAPI_MessageBoxCheck ' +
	        'WinAPI_MessageBoxIndirect WinAPI_MirrorIcon ' +
	        'WinAPI_ModifyWorldTransform WinAPI_MonitorFromPoint ' +
	        'WinAPI_MonitorFromRect WinAPI_MonitorFromWindow ' +
	        'WinAPI_Mouse_Event WinAPI_MoveFileEx WinAPI_MoveMemory ' +
	        'WinAPI_MoveTo WinAPI_MoveToEx WinAPI_MoveWindow ' +
	        'WinAPI_MsgBox WinAPI_MulDiv WinAPI_MultiByteToWideChar ' +
	        'WinAPI_MultiByteToWideCharEx WinAPI_NtStatusToDosError ' +
	        'WinAPI_OemToChar WinAPI_OffsetClipRgn WinAPI_OffsetPoints ' +
	        'WinAPI_OffsetRect WinAPI_OffsetRgn WinAPI_OffsetWindowOrg ' +
	        'WinAPI_OpenDesktop WinAPI_OpenFileById WinAPI_OpenFileDlg ' +
	        'WinAPI_OpenFileMapping WinAPI_OpenIcon ' +
	        'WinAPI_OpenInputDesktop WinAPI_OpenJobObject WinAPI_OpenMutex ' +
	        'WinAPI_OpenProcess WinAPI_OpenProcessToken ' +
	        'WinAPI_OpenSemaphore WinAPI_OpenThemeData ' +
	        'WinAPI_OpenWindowStation WinAPI_PageSetupDlg ' +
	        'WinAPI_PaintDesktop WinAPI_PaintRgn WinAPI_ParseURL ' +
	        'WinAPI_ParseUserName WinAPI_PatBlt WinAPI_PathAddBackslash ' +
	        'WinAPI_PathAddExtension WinAPI_PathAppend ' +
	        'WinAPI_PathBuildRoot WinAPI_PathCanonicalize ' +
	        'WinAPI_PathCommonPrefix WinAPI_PathCompactPath ' +
	        'WinAPI_PathCompactPathEx WinAPI_PathCreateFromUrl ' +
	        'WinAPI_PathFindExtension WinAPI_PathFindFileName ' +
	        'WinAPI_PathFindNextComponent WinAPI_PathFindOnPath ' +
	        'WinAPI_PathGetArgs WinAPI_PathGetCharType ' +
	        'WinAPI_PathGetDriveNumber WinAPI_PathIsContentType ' +
	        'WinAPI_PathIsDirectory WinAPI_PathIsDirectoryEmpty ' +
	        'WinAPI_PathIsExe WinAPI_PathIsFileSpec ' +
	        'WinAPI_PathIsLFNFileSpec WinAPI_PathIsRelative ' +
	        'WinAPI_PathIsRoot WinAPI_PathIsSameRoot ' +
	        'WinAPI_PathIsSystemFolder WinAPI_PathIsUNC ' +
	        'WinAPI_PathIsUNCServer WinAPI_PathIsUNCServerShare ' +
	        'WinAPI_PathMakeSystemFolder WinAPI_PathMatchSpec ' +
	        'WinAPI_PathParseIconLocation WinAPI_PathRelativePathTo ' +
	        'WinAPI_PathRemoveArgs WinAPI_PathRemoveBackslash ' +
	        'WinAPI_PathRemoveExtension WinAPI_PathRemoveFileSpec ' +
	        'WinAPI_PathRenameExtension WinAPI_PathSearchAndQualify ' +
	        'WinAPI_PathSkipRoot WinAPI_PathStripPath ' +
	        'WinAPI_PathStripToRoot WinAPI_PathToRegion ' +
	        'WinAPI_PathUndecorate WinAPI_PathUnExpandEnvStrings ' +
	        'WinAPI_PathUnmakeSystemFolder WinAPI_PathUnquoteSpaces ' +
	        'WinAPI_PathYetAnotherMakeUniqueName WinAPI_PickIconDlg ' +
	        'WinAPI_PlayEnhMetaFile WinAPI_PlaySound WinAPI_PlgBlt ' +
	        'WinAPI_PointFromRect WinAPI_PolyBezier WinAPI_PolyBezierTo ' +
	        'WinAPI_PolyDraw WinAPI_Polygon WinAPI_PostMessage ' +
	        'WinAPI_PrimaryLangId WinAPI_PrintDlg WinAPI_PrintDlgEx ' +
	        'WinAPI_PrintWindow WinAPI_ProgIDFromCLSID WinAPI_PtInRect ' +
	        'WinAPI_PtInRectEx WinAPI_PtInRegion WinAPI_PtVisible ' +
	        'WinAPI_QueryDosDevice WinAPI_QueryInformationJobObject ' +
	        'WinAPI_QueryPerformanceCounter WinAPI_QueryPerformanceFrequency ' +
	        'WinAPI_RadialGradientFill WinAPI_ReadDirectoryChanges ' +
	        'WinAPI_ReadFile WinAPI_ReadProcessMemory WinAPI_Rectangle ' +
	        'WinAPI_RectInRegion WinAPI_RectIsEmpty WinAPI_RectVisible ' +
	        'WinAPI_RedrawWindow WinAPI_RegCloseKey ' +
	        'WinAPI_RegConnectRegistry WinAPI_RegCopyTree ' +
	        'WinAPI_RegCopyTreeEx WinAPI_RegCreateKey ' +
	        'WinAPI_RegDeleteEmptyKey WinAPI_RegDeleteKey ' +
	        'WinAPI_RegDeleteKeyValue WinAPI_RegDeleteTree ' +
	        'WinAPI_RegDeleteTreeEx WinAPI_RegDeleteValue ' +
	        'WinAPI_RegDisableReflectionKey WinAPI_RegDuplicateHKey ' +
	        'WinAPI_RegEnableReflectionKey WinAPI_RegEnumKey ' +
	        'WinAPI_RegEnumValue WinAPI_RegFlushKey ' +
	        'WinAPI_RegisterApplicationRestart WinAPI_RegisterClass ' +
	        'WinAPI_RegisterClassEx WinAPI_RegisterHotKey ' +
	        'WinAPI_RegisterPowerSettingNotification ' +
	        'WinAPI_RegisterRawInputDevices WinAPI_RegisterShellHookWindow ' +
	        'WinAPI_RegisterWindowMessage WinAPI_RegLoadMUIString ' +
	        'WinAPI_RegNotifyChangeKeyValue WinAPI_RegOpenKey ' +
	        'WinAPI_RegQueryInfoKey WinAPI_RegQueryLastWriteTime ' +
	        'WinAPI_RegQueryMultipleValues WinAPI_RegQueryReflectionKey ' +
	        'WinAPI_RegQueryValue WinAPI_RegRestoreKey WinAPI_RegSaveKey ' +
	        'WinAPI_RegSetValue WinAPI_ReleaseCapture WinAPI_ReleaseDC ' +
	        'WinAPI_ReleaseMutex WinAPI_ReleaseSemaphore ' +
	        'WinAPI_ReleaseStream WinAPI_RemoveClipboardFormatListener ' +
	        'WinAPI_RemoveDirectory WinAPI_RemoveFontMemResourceEx ' +
	        'WinAPI_RemoveFontResourceEx WinAPI_RemoveWindowSubclass ' +
	        'WinAPI_ReOpenFile WinAPI_ReplaceFile WinAPI_ReplaceTextDlg ' +
	        'WinAPI_ResetEvent WinAPI_RestartDlg WinAPI_RestoreDC ' +
	        'WinAPI_RGB WinAPI_RotatePoints WinAPI_RoundRect ' +
	        'WinAPI_SaveDC WinAPI_SaveFileDlg WinAPI_SaveHBITMAPToFile ' +
	        'WinAPI_SaveHICONToFile WinAPI_ScaleWindowExt ' +
	        'WinAPI_ScreenToClient WinAPI_SearchPath WinAPI_SelectClipPath ' +
	        'WinAPI_SelectClipRgn WinAPI_SelectObject ' +
	        'WinAPI_SendMessageTimeout WinAPI_SetActiveWindow ' +
	        'WinAPI_SetArcDirection WinAPI_SetBitmapBits ' +
	        'WinAPI_SetBitmapDimensionEx WinAPI_SetBkColor ' +
	        'WinAPI_SetBkMode WinAPI_SetBoundsRect WinAPI_SetBrushOrg ' +
	        'WinAPI_SetCapture WinAPI_SetCaretBlinkTime WinAPI_SetCaretPos ' +
	        'WinAPI_SetClassLongEx WinAPI_SetColorAdjustment ' +
	        'WinAPI_SetCompression WinAPI_SetCurrentDirectory ' +
	        'WinAPI_SetCurrentProcessExplicitAppUserModelID WinAPI_SetCursor ' +
	        'WinAPI_SetDCBrushColor WinAPI_SetDCPenColor ' +
	        'WinAPI_SetDefaultPrinter WinAPI_SetDeviceGammaRamp ' +
	        'WinAPI_SetDIBColorTable WinAPI_SetDIBits ' +
	        'WinAPI_SetDIBitsToDevice WinAPI_SetDllDirectory ' +
	        'WinAPI_SetEndOfFile WinAPI_SetEnhMetaFileBits ' +
	        'WinAPI_SetErrorMode WinAPI_SetEvent WinAPI_SetFileAttributes ' +
	        'WinAPI_SetFileInformationByHandleEx WinAPI_SetFilePointer ' +
	        'WinAPI_SetFilePointerEx WinAPI_SetFileShortName ' +
	        'WinAPI_SetFileValidData WinAPI_SetFocus WinAPI_SetFont ' +
	        'WinAPI_SetForegroundWindow WinAPI_SetFRBuffer ' +
	        'WinAPI_SetGraphicsMode WinAPI_SetHandleInformation ' +
	        'WinAPI_SetInformationJobObject WinAPI_SetKeyboardLayout ' +
	        'WinAPI_SetKeyboardState WinAPI_SetLastError ' +
	        'WinAPI_SetLayeredWindowAttributes WinAPI_SetLocaleInfo ' +
	        'WinAPI_SetMapMode WinAPI_SetMessageExtraInfo WinAPI_SetParent ' +
	        'WinAPI_SetPixel WinAPI_SetPolyFillMode ' +
	        'WinAPI_SetPriorityClass WinAPI_SetProcessAffinityMask ' +
	        'WinAPI_SetProcessShutdownParameters ' +
	        'WinAPI_SetProcessWindowStation WinAPI_SetRectRgn ' +
	        'WinAPI_SetROP2 WinAPI_SetSearchPathMode ' +
	        'WinAPI_SetStretchBltMode WinAPI_SetSysColors ' +
	        'WinAPI_SetSystemCursor WinAPI_SetTextAlign ' +
	        'WinAPI_SetTextCharacterExtra WinAPI_SetTextColor ' +
	        'WinAPI_SetTextJustification WinAPI_SetThemeAppProperties ' +
	        'WinAPI_SetThreadDesktop WinAPI_SetThreadErrorMode ' +
	        'WinAPI_SetThreadExecutionState WinAPI_SetThreadLocale ' +
	        'WinAPI_SetThreadUILanguage WinAPI_SetTimer ' +
	        'WinAPI_SetUDFColorMode WinAPI_SetUserGeoID ' +
	        'WinAPI_SetUserObjectInformation WinAPI_SetVolumeMountPoint ' +
	        'WinAPI_SetWindowDisplayAffinity WinAPI_SetWindowExt ' +
	        'WinAPI_SetWindowLong WinAPI_SetWindowOrg ' +
	        'WinAPI_SetWindowPlacement WinAPI_SetWindowPos ' +
	        'WinAPI_SetWindowRgn WinAPI_SetWindowsHookEx ' +
	        'WinAPI_SetWindowSubclass WinAPI_SetWindowText ' +
	        'WinAPI_SetWindowTheme WinAPI_SetWinEventHook ' +
	        'WinAPI_SetWorldTransform WinAPI_SfcIsFileProtected ' +
	        'WinAPI_SfcIsKeyProtected WinAPI_ShellAboutDlg ' +
	        'WinAPI_ShellAddToRecentDocs WinAPI_ShellChangeNotify ' +
	        'WinAPI_ShellChangeNotifyDeregister ' +
	        'WinAPI_ShellChangeNotifyRegister WinAPI_ShellCreateDirectory ' +
	        'WinAPI_ShellEmptyRecycleBin WinAPI_ShellExecute ' +
	        'WinAPI_ShellExecuteEx WinAPI_ShellExtractAssociatedIcon ' +
	        'WinAPI_ShellExtractIcon WinAPI_ShellFileOperation ' +
	        'WinAPI_ShellFlushSFCache WinAPI_ShellGetFileInfo ' +
	        'WinAPI_ShellGetIconOverlayIndex WinAPI_ShellGetImageList ' +
	        'WinAPI_ShellGetKnownFolderIDList WinAPI_ShellGetKnownFolderPath ' +
	        'WinAPI_ShellGetLocalizedName WinAPI_ShellGetPathFromIDList ' +
	        'WinAPI_ShellGetSetFolderCustomSettings WinAPI_ShellGetSettings ' +
	        'WinAPI_ShellGetSpecialFolderLocation ' +
	        'WinAPI_ShellGetSpecialFolderPath WinAPI_ShellGetStockIconInfo ' +
	        'WinAPI_ShellILCreateFromPath WinAPI_ShellNotifyIcon ' +
	        'WinAPI_ShellNotifyIconGetRect WinAPI_ShellObjectProperties ' +
	        'WinAPI_ShellOpenFolderAndSelectItems WinAPI_ShellOpenWithDlg ' +
	        'WinAPI_ShellQueryRecycleBin ' +
	        'WinAPI_ShellQueryUserNotificationState ' +
	        'WinAPI_ShellRemoveLocalizedName WinAPI_ShellRestricted ' +
	        'WinAPI_ShellSetKnownFolderPath WinAPI_ShellSetLocalizedName ' +
	        'WinAPI_ShellSetSettings WinAPI_ShellStartNetConnectionDlg ' +
	        'WinAPI_ShellUpdateImage WinAPI_ShellUserAuthenticationDlg ' +
	        'WinAPI_ShellUserAuthenticationDlgEx WinAPI_ShortToWord ' +
	        'WinAPI_ShowCaret WinAPI_ShowCursor WinAPI_ShowError ' +
	        'WinAPI_ShowLastError WinAPI_ShowMsg WinAPI_ShowOwnedPopups ' +
	        'WinAPI_ShowWindow WinAPI_ShutdownBlockReasonCreate ' +
	        'WinAPI_ShutdownBlockReasonDestroy ' +
	        'WinAPI_ShutdownBlockReasonQuery WinAPI_SizeOfResource ' +
	        'WinAPI_StretchBlt WinAPI_StretchDIBits ' +
	        'WinAPI_StrFormatByteSize WinAPI_StrFormatByteSizeEx ' +
	        'WinAPI_StrFormatKBSize WinAPI_StrFromTimeInterval ' +
	        'WinAPI_StringFromGUID WinAPI_StringLenA WinAPI_StringLenW ' +
	        'WinAPI_StrLen WinAPI_StrokeAndFillPath WinAPI_StrokePath ' +
	        'WinAPI_StructToArray WinAPI_SubLangId WinAPI_SubtractRect ' +
	        'WinAPI_SwapDWord WinAPI_SwapQWord WinAPI_SwapWord ' +
	        'WinAPI_SwitchColor WinAPI_SwitchDesktop ' +
	        'WinAPI_SwitchToThisWindow WinAPI_SystemParametersInfo ' +
	        'WinAPI_TabbedTextOut WinAPI_TerminateJobObject ' +
	        'WinAPI_TerminateProcess WinAPI_TextOut WinAPI_TileWindows ' +
	        'WinAPI_TrackMouseEvent WinAPI_TransparentBlt ' +
	        'WinAPI_TwipsPerPixelX WinAPI_TwipsPerPixelY ' +
	        'WinAPI_UnhookWindowsHookEx WinAPI_UnhookWinEvent ' +
	        'WinAPI_UnionRect WinAPI_UnionStruct WinAPI_UniqueHardwareID ' +
	        'WinAPI_UnloadKeyboardLayout WinAPI_UnlockFile ' +
	        'WinAPI_UnmapViewOfFile WinAPI_UnregisterApplicationRestart ' +
	        'WinAPI_UnregisterClass WinAPI_UnregisterHotKey ' +
	        'WinAPI_UnregisterPowerSettingNotification ' +
	        'WinAPI_UpdateLayeredWindow WinAPI_UpdateLayeredWindowEx ' +
	        'WinAPI_UpdateLayeredWindowIndirect WinAPI_UpdateResource ' +
	        'WinAPI_UpdateWindow WinAPI_UrlApplyScheme ' +
	        'WinAPI_UrlCanonicalize WinAPI_UrlCombine WinAPI_UrlCompare ' +
	        'WinAPI_UrlCreateFromPath WinAPI_UrlFixup WinAPI_UrlGetPart ' +
	        'WinAPI_UrlHash WinAPI_UrlIs WinAPI_UserHandleGrantAccess ' +
	        'WinAPI_ValidateRect WinAPI_ValidateRgn WinAPI_VerQueryRoot ' +
	        'WinAPI_VerQueryValue WinAPI_VerQueryValueEx ' +
	        'WinAPI_WaitForInputIdle WinAPI_WaitForMultipleObjects ' +
	        'WinAPI_WaitForSingleObject WinAPI_WideCharToMultiByte ' +
	        'WinAPI_WidenPath WinAPI_WindowFromDC WinAPI_WindowFromPoint ' +
	        'WinAPI_WordToShort WinAPI_Wow64EnableWow64FsRedirection ' +
	        'WinAPI_WriteConsole WinAPI_WriteFile ' +
	        'WinAPI_WriteProcessMemory WinAPI_ZeroMemory ' +
	        'WinNet_AddConnection WinNet_AddConnection2 ' +
	        'WinNet_AddConnection3 WinNet_CancelConnection ' +
	        'WinNet_CancelConnection2 WinNet_CloseEnum ' +
	        'WinNet_ConnectionDialog WinNet_ConnectionDialog1 ' +
	        'WinNet_DisconnectDialog WinNet_DisconnectDialog1 ' +
	        'WinNet_EnumResource WinNet_GetConnection ' +
	        'WinNet_GetConnectionPerformance WinNet_GetLastError ' +
	        'WinNet_GetNetworkInformation WinNet_GetProviderName ' +
	        'WinNet_GetResourceInformation WinNet_GetResourceParent ' +
	        'WinNet_GetUniversalName WinNet_GetUser WinNet_OpenEnum ' +
	        'WinNet_RestoreConnection WinNet_UseConnection Word_Create ' +
	        'Word_DocAdd Word_DocAttach Word_DocClose Word_DocExport ' +
	        'Word_DocFind Word_DocFindReplace Word_DocGet ' +
	        'Word_DocLinkAdd Word_DocLinkGet Word_DocOpen ' +
	        'Word_DocPictureAdd Word_DocPrint Word_DocRangeSet ' +
	        'Word_DocSave Word_DocSaveAs Word_DocTableRead ' +
	        'Word_DocTableWrite Word_Quit',
	
	        COMMENT = {
	            variants: [
	              hljs.COMMENT(';', '$', {relevance: 0}),
	              hljs.COMMENT('#cs', '#ce'),
	              hljs.COMMENT('#comments-start', '#comments-end')
	            ]
	        },
	
	        VARIABLE = {
	            className: 'variable',
	            begin: '\\$[A-z0-9_]+'
	        },
	
	        STRING = {
	            className: 'string',
	            variants: [{
	                begin: /"/,
	                end: /"/,
	                contains: [{
	                    begin: /""/,
	                    relevance: 0
	                }]
	            }, {
	                begin: /'/,
	                end: /'/,
	                contains: [{
	                    begin: /''/,
	                    relevance: 0
	                }]
	            }]
	        },
	
	        NUMBER = {
	            variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
	        },
	
	        PREPROCESSOR = {
	            className: 'preprocessor',
	            begin: '#',
	            end: '$',
	            keywords: 'include include-once NoTrayIcon OnAutoItStartRegister RequireAdmin pragma ' +
	                'Au3Stripper_Ignore_Funcs Au3Stripper_Ignore_Variables ' +
	                'Au3Stripper_Off Au3Stripper_On Au3Stripper_Parameters ' +
	                'AutoIt3Wrapper_Add_Constants AutoIt3Wrapper_Au3Check_Parameters ' +
	                'AutoIt3Wrapper_Au3Check_Stop_OnWarning AutoIt3Wrapper_Aut2Exe ' +
	                'AutoIt3Wrapper_AutoIt3 AutoIt3Wrapper_AutoIt3Dir ' +
	                'AutoIt3Wrapper_Change2CUI AutoIt3Wrapper_Compile_Both ' +
	                'AutoIt3Wrapper_Compression AutoIt3Wrapper_EndIf ' +
	                'AutoIt3Wrapper_Icon AutoIt3Wrapper_If_Compile ' +
	                'AutoIt3Wrapper_If_Run AutoIt3Wrapper_Jump_To_First_Error ' +
	                'AutoIt3Wrapper_OutFile AutoIt3Wrapper_OutFile_Type ' +
	                'AutoIt3Wrapper_OutFile_X64 AutoIt3Wrapper_PlugIn_Funcs ' +
	                'AutoIt3Wrapper_Res_Comment Autoit3Wrapper_Res_Compatibility ' +
	                'AutoIt3Wrapper_Res_Description AutoIt3Wrapper_Res_Field ' +
	                'AutoIt3Wrapper_Res_File_Add AutoIt3Wrapper_Res_FileVersion ' +
	                'AutoIt3Wrapper_Res_FileVersion_AutoIncrement ' +
	                'AutoIt3Wrapper_Res_Icon_Add AutoIt3Wrapper_Res_Language ' +
	                'AutoIt3Wrapper_Res_LegalCopyright ' +
	                'AutoIt3Wrapper_Res_ProductVersion ' +
	                'AutoIt3Wrapper_Res_requestedExecutionLevel ' +
	                'AutoIt3Wrapper_Res_SaveSource AutoIt3Wrapper_Run_After ' +
	                'AutoIt3Wrapper_Run_Au3Check AutoIt3Wrapper_Run_Au3Stripper ' +
	                'AutoIt3Wrapper_Run_Before AutoIt3Wrapper_Run_Debug_Mode ' +
	                'AutoIt3Wrapper_Run_SciTE_Minimized ' +
	                'AutoIt3Wrapper_Run_SciTE_OutputPane_Minimized ' +
	                'AutoIt3Wrapper_Run_Tidy AutoIt3Wrapper_ShowProgress ' +
	                'AutoIt3Wrapper_Testing AutoIt3Wrapper_Tidy_Stop_OnError ' +
	                'AutoIt3Wrapper_UPX_Parameters AutoIt3Wrapper_UseUPX ' +
	                'AutoIt3Wrapper_UseX64 AutoIt3Wrapper_Version ' +
	                'AutoIt3Wrapper_Versioning AutoIt3Wrapper_Versioning_Parameters ' +
	                'Tidy_Off Tidy_On Tidy_Parameters EndRegion Region',
	            contains: [{
	                    begin: /\\\n/,
	                    relevance: 0
	                }, {
	                    beginKeywords: 'include',
	                    end: '$',
	                    contains: [
	                        STRING, {
	                            className: 'string',
	                            variants: [{
	                                begin: '<',
	                                end: '>'
	                            }, {
	                                begin: /"/,
	                                end: /"/,
	                                contains: [{
	                                    begin: /""/,
	                                    relevance: 0
	                                }]
	                            }, {
	                                begin: /'/,
	                                end: /'/,
	                                contains: [{
	                                    begin: /''/,
	                                    relevance: 0
	                                }]
	                            }]
	                        }
	                    ]
	                },
	                STRING,
	                COMMENT
	            ]
	        },
	
	        CONSTANT = {
	            className: 'constant',
	            // begin: '@',
	            // end: '$',
	            // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
	            // relevance: 5
	            begin: '@[A-z0-9_]+'
	        },
	
	        FUNCTION = {
	            className: 'function',
	            beginKeywords: 'Func',
	            end: '$',
	            excludeEnd: true,
	            illegal: '\\$|\\[|%',
	            contains: [
	                hljs.UNDERSCORE_TITLE_MODE, {
	                    className: 'params',
	                    begin: '\\(',
	                    end: '\\)',
	                    contains: [
	                        VARIABLE,
	                        STRING,
	                        NUMBER
	                    ]
	                }
	            ]
	        };
	
	    return {
	        case_insensitive: true,
	        illegal: /\/\*/,
	        keywords: {
	            keyword: KEYWORDS,
	            built_in: BUILT_IN,
	            literal: LITERAL
	        },
	        contains: [
	            COMMENT,
	            VARIABLE,
	            STRING,
	            NUMBER,
	            PREPROCESSOR,
	            CONSTANT,
	            FUNCTION
	        ]
	    }
	};

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    lexemes: '\\.?' + hljs.IDENT_RE,
	    keywords: {
	      keyword:
	        /* mnemonic */
	        'adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs ' +
	        'brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr ' +
	        'clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor ' +
	        'fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul ' +
	        'muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs ' +
	        'sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub ' +
	        'subi swap tst wdr',
	      built_in:
	        /* general purpose registers */
	        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 ' +
	        'r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ' +
	        /* IO Registers (ATMega128) */
	        'ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h ' +
	        'tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ' +
	        'ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ' +
	        'ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk ' +
	        'tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ' +
	        'ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr ' +
	        'porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ' +
	        'ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf',
	      preprocessor:
	        '.byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list ' +
	        '.listmac .macro .nolist .org .set'
	    },
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.COMMENT(
	        ';',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      hljs.C_NUMBER_MODE, // 0x..., decimal, float
	      hljs.BINARY_NUMBER_MODE, // 0b...
	      {
	        className: 'number',
	        begin: '\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)' // $..., 0o...
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'', end: '[^\\\\]\'',
	        illegal: '[^\\\\][^\']'
	      },
	      {className: 'label',  begin: '^[A-Za-z0-9_.$]+:'},
	      {className: 'preprocessor', begin: '#', end: '$'},
	      {  // подстановка в «.macro»
	        className: 'localvars',
	        begin: '@[0-9]+'
	      }
	    ]
	  };
	};

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: 'false int abstract private char boolean static null if for true ' +
	      'while long throw finally protected final return void enum else ' +
	      'break new catch byte super case short default double public try this switch ' +
	      'continue reverse firstfast firstonly forupdate nofetch sum avg minof maxof count ' +
	      'order group by asc desc index hint like dispaly edit client server ttsbegin ' +
	      'ttscommit str real date container anytype common div mod',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'preprocessor',
	        begin: '#', end: '$'
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        illegal: ':',
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d#@][\w\d_]*/},
	      {begin: /\$\{(.*?)}/}
	    ]
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      VAR,
	      {
	        className: 'variable',
	        begin: /\$\(/, end: /\)/,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  var APOS_STRING = {
	    className: 'string',
	    begin: /'/, end: /'/
	  };
	
	  return {
	    aliases: ['sh', 'zsh'],
	    lexemes: /-?[a-z\.]+/,
	    keywords: {
	      keyword:
	        'if then else elif fi for while in do done case esac function',
	      literal:
	        'true false',
	      built_in:
	        // Shell built-ins
	        // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
	        'break cd continue eval exec exit export getopts hash pwd readonly return shift test times ' +
	        'trap umask unset ' +
	        // Bash built-ins
	        'alias bind builtin caller command declare echo enable help let local logout mapfile printf ' +
	        'read readarray source type typeset ulimit unalias ' +
	        // Shell modifiers
	        'set shopt ' +
	        // Zsh built-ins
	        'autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles ' +
	        'compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate ' +
	        'fc fg float functions getcap getln history integer jobs kill limit log noglob popd print ' +
	        'pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit ' +
	        'unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof ' +
	        'zpty zregexparse zsocket zstyle ztcp',
	      operator:
	        '-ne -eq -lt -gt -f -d -e -s -l -a' // relevance booster
	    },
	    contains: [
	      {
	        className: 'shebang',
	        begin: /^#![^\n]+sh\s*$/,
	        relevance: 10
	      },
	      {
	        className: 'function',
	        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
	        returnBegin: true,
	        contains: [hljs.inherit(hljs.TITLE_MODE, {begin: /\w[\w\d_]*/})],
	        relevance: 0
	      },
	      hljs.HASH_COMMENT_MODE,
	      hljs.NUMBER_MODE,
	      QUOTE_STRING,
	      APOS_STRING,
	      VAR
	    ]
	  };
	};

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	module.exports = function(hljs){
	  var LITERAL = {
	    className: 'literal',
	    begin: '[\\+\\-]',
	    relevance: 0
	  };
	  return {
	    aliases: ['bf'],
	    contains: [
	      hljs.COMMENT(
	        '[^\\[\\]\\.,\\+\\-<> \r\n]',
	        '[\\[\\]\\.,\\+\\-<> \r\n]',
	        {
	          returnEnd: true,
	          relevance: 0
	        }
	      ),
	      {
	        className: 'title',
	        begin: '[\\[\\]]',
	        relevance: 0
	      },
	      {
	        className: 'string',
	        begin: '[\\.,]',
	        relevance: 0
	      },
	      {
	        // this mode works as the only relevance counter
	        begin: /\+\+|\-\-/, returnBegin: true,
	        contains: [LITERAL]
	      },
	      LITERAL
	    ]
	  };
	};

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS =
	    'div mod in and or not xor asserterror begin case do downto else end exit for if of repeat then to ' +
	    'until while with var';
	  var LITERALS = 'false true';
	  var COMMENT_MODES = [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.COMMENT(
	      /\{/,
	      /\}/,
	      {
	        relevance: 0
	      }
	    ),
	    hljs.COMMENT(
	      /\(\*/,
	      /\*\)/,
	      {
	        relevance: 10
	      }
	    )
	  ];
	  var STRING = {
	    className: 'string',
	    begin: /'/, end: /'/,
	    contains: [{begin: /''/}]
	  };
	  var CHAR_STRING = {
	    className: 'string', begin: /(#\d+)+/
	  };
	  var DATE = {
	      className: 'date',
	      begin: '\\b\\d+(\\.\\d+)?(DT|D|T)',
	      relevance: 0
	  };
	  var DBL_QUOTED_VARIABLE = {
	      className: 'variable',
	      begin: '"',
	      end: '"'
	  };
	
	  var PROCEDURE = {
	    className: 'function',
	    beginKeywords: 'procedure', end: /[:;]/,
	    keywords: 'procedure|10',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        className: 'params',
	        begin: /\(/, end: /\)/,
	        keywords: KEYWORDS,
	        contains: [STRING, CHAR_STRING]
	      }
	    ].concat(COMMENT_MODES)
	  };
	
	  var OBJECT = {
	    className: 'class',
	    begin: 'OBJECT (Table|Form|Report|Dataport|Codeunit|XMLport|MenuSuite|Page|Query) (\\d+) ([^\\r\\n]+)',
	    returnBegin: true,
	    contains: [
	      hljs.TITLE_MODE,
	        PROCEDURE
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    keywords: { keyword: KEYWORDS, literal: LITERALS },
	    illegal: /\/\*/,
	    contains: [
	      STRING, CHAR_STRING,
	      DATE, DBL_QUOTED_VARIABLE,
	      hljs.NUMBER_MODE,
	      OBJECT,
	      PROCEDURE
	    ]
	  };
	};

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['capnp'],
	    keywords: {
	      keyword:
	        'struct enum interface union group import using const annotation extends in of on as with from fixed',
	      built_in:
	        'Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 ' +
	        'Text Data AnyPointer AnyStruct Capability List',
	      literal:
	        'true false'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'shebang',
	        begin: /@0x[\w\d]{16};/,
	        illegal: /\n/
	      },
	      {
	        className: 'number',
	        begin: /@\d+\b/
	      },
	      {
	        className: 'class',
	        beginKeywords: 'struct enum', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'interface', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  // 2.3. Identifiers and keywords
	  var KEYWORDS =
	    'assembly module package import alias class interface object given value ' +
	    'assign void function new of extends satisfies abstracts in out return ' +
	    'break continue throw assert dynamic if else switch case for while try ' +
	    'catch finally then let this outer super is exists nonempty';
	  // 7.4.1 Declaration Modifiers
	  var DECLARATION_MODIFIERS =
	    'shared abstract formal default actual variable late native deprecated' +
	    'final sealed annotation suppressWarnings small';
	  // 7.4.2 Documentation
	  var DOCUMENTATION =
	    'doc by license see throws tagged';
	  var LANGUAGE_ANNOTATIONS = DECLARATION_MODIFIERS + ' ' + DOCUMENTATION;
	  var SUBST = {
	    className: 'subst', excludeBegin: true, excludeEnd: true,
	    begin: /``/, end: /``/,
	    keywords: KEYWORDS,
	    relevance: 10
	  };
	  var EXPRESSIONS = [
	    {
	      // verbatim string
	      className: 'string',
	      begin: '"""',
	      end: '"""',
	      relevance: 10
	    },
	    {
	      // string literal or template
	      className: 'string',
	      begin: '"', end: '"',
	      contains: [SUBST]
	    },
	    {
	      // character literal
	      className: 'string',
	      begin: "'",
	      end: "'"
	    },
	    {
	      // numeric literal
	      className: 'number',
	      begin: '#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?',
	      relevance: 0
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  return {
	    keywords: {
	      keyword: KEYWORDS,
	      annotation: LANGUAGE_ANNOTATIONS
	    },
	    illegal: '\\$[^01]|#[^0-9a-fA-F]',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
	      {
	        // compiler annotation
	        className: 'annotation',
	        begin: '@[a-z]\\w*(?:\\:\"[^\"]*\")?'
	      }
	    ].concat(EXPRESSIONS)
	  };
	};

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      {
	        className: 'prompt',
	        begin: /^([\w.-]+|\s*#_)=>/,
	        starts: {
	          end: /$/,
	          subLanguage: 'clojure'
	        }
	      }
	    ]
	  }
	};

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var keywords = {
	    built_in:
	      // Clojure keywords
	      'def defonce cond apply if-not if-let if not not= = < > <= >= == + / * - rem '+
	      'quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? '+
	      'set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? '+
	      'class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? '+
	      'string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . '+
	      'inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last '+
	      'drop-while while intern condp case reduced cycle split-at split-with repeat replicate '+
	      'iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext '+
	      'nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends '+
	      'add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler '+
	      'set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter '+
	      'monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or '+
	      'when when-not when-let comp juxt partial sequence memoize constantly complement identity assert '+
	      'peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast '+
	      'sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import '+
	      'refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! '+
	      'assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger '+
	      'bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline '+
	      'flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking '+
	      'assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! '+
	      'reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! '+
	      'new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty '+
	      'hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list '+
	      'disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer '+
	      'chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate '+
	      'unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta '+
	      'lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize'
	   };
	
	  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
	  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
	  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';
	
	  var SYMBOL = {
	    begin: SYMBOL_RE,
	    relevance: 0
	  };
	  var NUMBER = {
	    className: 'number', begin: SIMPLE_NUMBER_RE,
	    relevance: 0
	  };
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
	  var COMMENT = hljs.COMMENT(
	    ';',
	    '$',
	    {
	      relevance: 0
	    }
	  );
	  var LITERAL = {
	    className: 'literal',
	    begin: /\b(true|false|nil)\b/
	  };
	  var COLLECTION = {
	    className: 'collection',
	    begin: '[\\[\\{]', end: '[\\]\\}]'
	  };
	  var HINT = {
	    className: 'comment',
	    begin: '\\^' + SYMBOL_RE
	  };
	  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
	  var KEY = {
	    className: 'attribute',
	    begin: '[:]' + SYMBOL_RE
	  };
	  var LIST = {
	    className: 'list',
	    begin: '\\(', end: '\\)'
	  };
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	  var NAME = {
	    keywords: keywords,
	    lexemes: SYMBOL_RE,
	    className: 'keyword', begin: SYMBOL_RE,
	    starts: BODY
	  };
	  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];
	
	  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
	  BODY.contains = DEFAULT_CONTAINS;
	  COLLECTION.contains = DEFAULT_CONTAINS;
	
	  return {
	    aliases: ['clj'],
	    illegal: /\S/,
	    contains: [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
	  }
	};

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['cmake.in'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'add_custom_command add_custom_target add_definitions add_dependencies ' +
	        'add_executable add_library add_subdirectory add_test aux_source_directory ' +
	        'break build_command cmake_minimum_required cmake_policy configure_file ' +
	        'create_test_sourcelist define_property else elseif enable_language enable_testing ' +
	        'endforeach endfunction endif endmacro endwhile execute_process export find_file ' +
	        'find_library find_package find_path find_program fltk_wrap_ui foreach function ' +
	        'get_cmake_property get_directory_property get_filename_component get_property ' +
	        'get_source_file_property get_target_property get_test_property if include ' +
	        'include_directories include_external_msproject include_regular_expression install ' +
	        'link_directories load_cache load_command macro mark_as_advanced message option ' +
	        'output_required_files project qt_wrap_cpp qt_wrap_ui remove_definitions return ' +
	        'separate_arguments set set_directory_properties set_property ' +
	        'set_source_files_properties set_target_properties set_tests_properties site_name ' +
	        'source_group string target_link_libraries try_compile try_run unset variable_watch ' +
	        'while build_name exec_program export_library_dependencies install_files ' +
	        'install_programs install_targets link_libraries make_directory remove subdir_depends ' +
	        'subdirs use_mangled_mesa utility_source variable_requires write_file ' +
	        'qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or',
	      operator:
	        'equal less greater strless strgreater strequal matches'
	    },
	    contains: [
	      {
	        className: 'envvar',
	        begin: '\\${', end: '}'
	      },
	      hljs.HASH_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      // JS keywords
	      'in if for while finally new do return else break catch instanceof throw try this ' +
	      'switch continue typeof delete debugger super ' +
	      // Coffee keywords
	      'then unless until loop of by when and or is isnt not',
	    literal:
	      // JS literals
	      'true false null undefined ' +
	      // Coffee literals
	      'yes no on off',
	    built_in:
	      'npm require console print module global window document'
	  };
	  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
	  var SUBST = {
	    className: 'subst',
	    begin: /#\{/, end: /}/,
	    keywords: KEYWORDS
	  };
	  var EXPRESSIONS = [
	    hljs.BINARY_NUMBER_MODE,
	    hljs.inherit(hljs.C_NUMBER_MODE, {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
	    {
	      className: 'string',
	      variants: [
	        {
	          begin: /'''/, end: /'''/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /'/, end: /'/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /"""/, end: /"""/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	        },
	        {
	          begin: /"/, end: /"/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	        }
	      ]
	    },
	    {
	      className: 'regexp',
	      variants: [
	        {
	          begin: '///', end: '///',
	          contains: [SUBST, hljs.HASH_COMMENT_MODE]
	        },
	        {
	          begin: '//[gim]*',
	          relevance: 0
	        },
	        {
	          // regex can't start with space to parse x / 2 / 3 as two divisions
	          // regex can't start with *, and it supports an "illegal" in the main mode
	          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
	        }
	      ]
	    },
	    {
	      className: 'property',
	      begin: '@' + JS_IDENT_RE
	    },
	    {
	      begin: '`', end: '`',
	      excludeBegin: true, excludeEnd: true,
	      subLanguage: 'javascript'
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
	  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
	  var PARAMS = {
	    className: 'params',
	    begin: '\\([^\\(]', returnBegin: true,
	    /* We need another contained nameless mode to not have every nested
	    pair of parens to be called "params" */
	    contains: [{
	      begin: /\(/, end: /\)/,
	      keywords: KEYWORDS,
	      contains: ['self'].concat(EXPRESSIONS)
	    }]
	  };
	
	  return {
	    aliases: ['coffee', 'cson', 'iced'],
	    keywords: KEYWORDS,
	    illegal: /\/\*/,
	    contains: EXPRESSIONS.concat([
	      hljs.COMMENT('###', '###'),
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'function',
	        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
	        returnBegin: true,
	        contains: [TITLE, PARAMS]
	      },
	      {
	        // anonymous function start
	        begin: /[:\(,=]\s*/,
	        relevance: 0,
	        contains: [
	          {
	            className: 'function',
	            begin: PARAMS_RE, end: '[-=]>',
	            returnBegin: true,
	            contains: [PARAMS]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class',
	        end: '$',
	        illegal: /[:="\[\]]/,
	        contains: [
	          {
	            beginKeywords: 'extends',
	            endsWithParent: true,
	            illegal: /[:="\[\]]/,
	            contains: [TITLE]
	          },
	          TITLE
	        ]
	      },
	      {
	        className: 'attribute',
	        begin: JS_IDENT_RE + ':', end: ':',
	        returnBegin: true, returnEnd: true,
	        relevance: 0
	      }
	    ])
	  };
	};

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CPP_PRIMATIVE_TYPES = {
	    className: 'keyword',
	    begin: '\\b[a-z\\d_]*_t\\b'
	  };
	
	  var STRINGS = {
	    className: 'string',
	    variants: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, { begin: '((u8?|U)|L)?"' }),
	      {
	        begin: '(u8?|U)?R"', end: '"',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '\'\\\\?.', end: '\'',
	        illegal: '.'
	      }
	    ]
	  };
	
	  var NUMBERS = {
	    className: 'number',
	    variants: [
	      { begin: '\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)' },
	      { begin: hljs.C_NUMBER_RE }
	    ]
	  };
	
	  var PREPROCESSOR =       {
	    className: 'preprocessor',
	    begin: '#', end: '$',
	    keywords: 'if else elif endif define undef warning error line ' +
	              'pragma ifdef ifndef',
	    contains: [
	      {
	        begin: /\\\n/, relevance: 0
	      },
	      {
	        beginKeywords: 'include', end: '$',
	        contains: [
	          STRINGS,
	          {
	            className: 'string',
	            begin: '<', end: '>',
	            illegal: '\\n',
	          }
	        ]
	      },
	      STRINGS,
	      NUMBERS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	
	  var FUNCTION_TITLE = hljs.IDENT_RE + '\\s*\\(';
	
	  var CPP_KEYWORDS = {
	    keyword: 'int float while private char catch export virtual operator sizeof ' +
	      'dynamic_cast|10 typedef const_cast|10 const struct for static_cast|10 union namespace ' +
	      'unsigned long volatile static protected bool template mutable if public friend ' +
	      'do goto auto void enum else break extern using class asm case typeid ' +
	      'short reinterpret_cast|10 default double register explicit signed typename try this ' +
	      'switch continue inline delete alignof constexpr decltype ' +
	      'noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary ' +
	      'atomic_bool atomic_char atomic_schar ' +
	      'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' +
	      'atomic_ullong',
	    built_in: 'std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' +
	      'auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set ' +
	      'unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos ' +
	      'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' +
	      'fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' +
	      'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' +
	      'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' +
	      'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' +
	      'vfprintf vprintf vsprintf',
	    literal: 'true false nullptr NULL'
	  };
	
	  return {
	    aliases: ['c', 'cc', 'h', 'c++', 'h++', 'hpp'],
	    keywords: CPP_KEYWORDS,
	    illegal: '</',
	    contains: [
	      CPP_PRIMATIVE_TYPES,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMBERS,
	      STRINGS,
	      PREPROCESSOR,
	      {
	        begin: '\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<', end: '>',
	        keywords: CPP_KEYWORDS,
	        contains: ['self', CPP_PRIMATIVE_TYPES]
	      },
	      {
	        begin: hljs.IDENT_RE + '::',
	        keywords: CPP_KEYWORDS
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...) or else if(...)' from
	        // being recognized as a function definition
	        beginKeywords: 'new throw return else',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + hljs.IDENT_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
	        returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: CPP_KEYWORDS,
	        illegal: /[^\w\s\*&]/,
	        contains: [
	          {
	            begin: FUNCTION_TITLE, returnBegin: true,
	            contains: [hljs.TITLE_MODE],
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: CPP_KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRINGS,
	              NUMBERS
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          PREPROCESSOR
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var RESOURCES = 'primitive rsc_template';
	
	  var COMMANDS = 'group clone ms master location colocation order fencing_topology ' +
	      'rsc_ticket acl_target acl_group user role ' +
	      'tag xml';
	
	  var PROPERTY_SETS = 'property rsc_defaults op_defaults';
	
	  var KEYWORDS = 'params meta operations op rule attributes utilization';
	
	  var OPERATORS = 'read write deny defined not_defined in_range date spec in ' +
	      'ref reference attribute type xpath version and or lt gt tag ' +
	      'lte gte eq ne \\';
	
	  var TYPES = 'number string';
	
	  var LITERALS = 'Master Started Slave Stopped start promote demote stop monitor true false';
	
	  return {
	    aliases: ['crm', 'pcmk'],
	    case_insensitive: true,
	    keywords: {
	      keyword: KEYWORDS,
	      operator: OPERATORS,
	      type: TYPES,
	      literal: LITERALS
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        beginKeywords: 'node',
	        starts: {
	          className: 'identifier',
	          end: '\\s*([\\w_-]+:)?',
	          starts: {
	            className: 'title',
	            end: '\\s*[\\$\\w_][\\w_-]*'
	          }
	        }
	      },
	      {
	        beginKeywords: RESOURCES,
	        starts: {
	          className: 'title',
	          end: '\\s*[\\$\\w_][\\w_-]*',
	          starts: {
	            className: 'pragma',
	            end: '\\s*@?[\\w_][\\w_\\.:-]*',
	          }
	        }
	      },
	      {
	        begin: '\\b(' + COMMANDS.split(' ').join('|') + ')\\s+',
	        keywords: COMMANDS,
	        starts: {
	          className: 'title',
	          end: '[\\$\\w_][\\w_-]*',
	        }
	      },
	      {
	        beginKeywords: PROPERTY_SETS,
	        starts: {
	          className: 'title',
	          end: '\\s*([\\w_-]+:)?'
	        }
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'pragma',
	        begin: '(ocf|systemd|service|lsb):[\\w_:-]+',
	        relevance: 0
	      },
	      {
	        className: 'number',
	        begin: '\\b\\d+(\\.\\d+)?(ms|s|h|m)?',
	        relevance: 0
	      },
	      {
	        className: 'number',
	        begin: '[-]?(infinity|inf)',
	        relevance: 0
	      },
	      {
	        className: 'variable',
	        begin: /([A-Za-z\$_\#][\w_-]+)=/,
	        relevance: 0
	      },
	      {
	        className: 'tag',
	        begin: '</?',
	        end: '/?>',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUM_SUFFIX = '(_[uif](8|16|32|64))?';
	  var CRYSTAL_IDENT_RE = '[a-zA-Z_]\\w*[!?=]?';
	  var RE_STARTER = '!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|' +
	    '>>|>|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
	  var CRYSTAL_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\][=?]?';
	  var CRYSTAL_KEYWORDS = {
	    keyword:
	      'abstract alias as asm begin break case class def do else elsif end ensure enum extend for fun if ifdef ' +
	      'include instance_sizeof is_a? lib macro module next of out pointerof private protected rescue responds_to? ' +
	      'return require self sizeof struct super then type typeof union unless until when while with yield ' +
	      '__DIR__ __FILE__ __LINE__',
	    literal: 'false nil true'
	  };
	  var SUBST = {
	    className: 'subst',
	    begin: '#{', end: '}',
	    keywords: CRYSTAL_KEYWORDS
	  };
	  var EXPANSION = {
	    className: 'expansion',
	    variants: [
	      {begin: '\\{\\{', end: '\\}\\}'},
	      {begin: '\\{%', end: '%\\}'}
	    ],
	    keywords: CRYSTAL_KEYWORDS,
	    relevance: 10
	  };
	
	  function recursiveParen(begin, end) {
	    var
	    contains = [{begin: begin, end: end}];
	    contains[0].contains = contains;
	    return contains;
	  }
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/},
	      {begin: /`/, end: /`/},
	      {begin: '%w?\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
	      {begin: '%w?\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
	      {begin: '%w?{', end: '}', contains: recursiveParen('{', '}')},
	      {begin: '%w?<', end: '>', contains: recursiveParen('<', '>')},
	      {begin: '%w?/', end: '/'},
	      {begin: '%w?%', end: '%'},
	      {begin: '%w?-', end: '-'},
	      {begin: '%w?\\|', end: '\\|'},
	    ],
	    relevance: 0,
	  };
	  var REGEXP = {
	    begin: '(' + RE_STARTER + ')\\s*',
	    contains: [
	      {
	        className: 'regexp',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	        variants: [
	          {begin: '/', end: '/[a-z]*'},
	          {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
	          {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
	          {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
	          {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
	          {begin: '%r/', end: '/'},
	          {begin: '%r%', end: '%'},
	          {begin: '%r-', end: '-'},
	          {begin: '%r\\|', end: '\\|'},
	        ]
	      }
	    ],
	    relevance: 0
	  };
	  var REGEXP2 = {
	    className: 'regexp',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
	      {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
	      {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
	      {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
	      {begin: '%r/', end: '/'},
	      {begin: '%r%', end: '%'},
	      {begin: '%r-', end: '-'},
	      {begin: '%r\\|', end: '\\|'},
	    ],
	    relevance: 0
	  };
	  var ATTRIBUTE = {
	    className: 'annotation',
	    begin: '@\\[', end: '\\]',
	    relevance: 5
	  };
	  var CRYSTAL_DEFAULT_CONTAINS = [
	    EXPANSION,
	    STRING,
	    REGEXP,
	    REGEXP2,
	    ATTRIBUTE,
	    hljs.HASH_COMMENT_MODE,
	    {
	      className: 'class',
	      beginKeywords: 'class module struct', end: '$|;',
	      illegal: /=/,
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
	        {
	          className: 'inheritance',
	          begin: '<\\s*',
	          contains: [{
	            className: 'parent',
	            begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE
	          }]
	        }
	      ]
	    },
	    {
	      className: 'class',
	      beginKeywords: 'lib enum union', end: '$|;',
	      illegal: /=/,
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
	      ],
	      relevance: 10
	    },
	    {
	      className: 'function',
	      beginKeywords: 'def', end: /\B\b/,
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {
	          begin: CRYSTAL_METHOD_RE,
	          endsParent: true
	        })
	      ]
	    },
	    {
	      className: 'function',
	      beginKeywords: 'fun macro', end: /\B\b/,
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {
	          begin: CRYSTAL_METHOD_RE,
	          endsParent: true
	        })
	      ],
	      relevance: 5
	    },
	    {
	      className: 'constant',
	      begin: '(::)?(\\b[A-Z]\\w*(::)?)+',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ':',
	      contains: [STRING, {begin: CRYSTAL_METHOD_RE}],
	      relevance: 0
	    },
	    {
	      className: 'number',
	      variants: [
	        { begin: '\\b0b([01_]*[01])' + NUM_SUFFIX },
	        { begin: '\\b0o([0-7_]*[0-7])' + NUM_SUFFIX },
	        { begin: '\\b0x([A-Fa-f0-9_]*[A-Fa-f0-9])' + NUM_SUFFIX },
	        { begin: '\\b(([0-9][0-9_]*[0-9]|[0-9])(\\.[0-9_]*[0-9])?([eE][+-]?[0-9_]*[0-9])?)' + NUM_SUFFIX}
	      ],
	      relevance: 0
	    },
	    {
	      className: 'variable',
	      begin: '(\\$\\W)|((\\$|\\@\\@?|%)(\\w+))'
	    }
	  ];
	  SUBST.contains = CRYSTAL_DEFAULT_CONTAINS;
	  ATTRIBUTE.contains = CRYSTAL_DEFAULT_CONTAINS;
	  EXPANSION.contains = CRYSTAL_DEFAULT_CONTAINS.slice(1); // without EXPANSION
	
	  return {
	    aliases: ['cr'],
	    lexemes: CRYSTAL_IDENT_RE,
	    keywords: CRYSTAL_KEYWORDS,
	    contains: CRYSTAL_DEFAULT_CONTAINS
	  };
	};

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS =
	    // Normal keywords.
	    'abstract as base bool break byte case catch char checked const continue decimal dynamic ' +
	    'default delegate do double else enum event explicit extern false finally fixed float ' +
	    'for foreach goto if implicit in int interface internal is lock long null when ' +
	    'object operator out override params private protected public readonly ref sbyte ' +
	    'sealed short sizeof stackalloc static string struct switch this true try typeof ' +
	    'uint ulong unchecked unsafe ushort using virtual volatile void while async ' +
	    'protected public private internal ' +
	    // Contextual keywords.
	    'ascending descending from get group into join let orderby partial select set value var ' +
	    'where yield';
	  var GENERIC_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '>)?';
	  return {
	    aliases: ['csharp'],
	    keywords: KEYWORDS,
	    illegal: /::/,
	    contains: [
	      hljs.COMMENT(
	        '///',
	        '$',
	        {
	          returnBegin: true,
	          contains: [
	            {
	              className: 'xmlDocTag',
	              variants: [
	                {
	                  begin: '///', relevance: 0
	                },
	                {
	                  begin: '<!--|-->'
	                },
	                {
	                  begin: '</?', end: '>'
	                }
	              ]
	            }
	          ]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'preprocessor',
	        begin: '#', end: '$',
	        keywords: 'if else elif endif define undef warning error line region endregion pragma checksum'
	      },
	      {
	        className: 'string',
	        begin: '@"', end: '"',
	        contains: [{begin: '""'}]
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        beginKeywords: 'class interface', end: /[{;=]/,
	        illegal: /[^\s:]/,
	        contains: [
	          hljs.TITLE_MODE,
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: /[{;=]/,
	        illegal: /[^\s:]/,
	        contains: [
	          {
	            // Customization of hljs.TITLE_MODE that allows '.'
	            className: 'title',
	            begin: '[a-zA-Z](\\.?\\w)*',
	            relevance: 0
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...)' from being
	        // recognized as a function definition
	        beginKeywords: 'new return throw await',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
	            contains: [hljs.TITLE_MODE],
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            keywords: KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
	  var FUNCTION = {
	    className: 'function',
	    begin: IDENT_RE + '\\(',
	    returnBegin: true,
	    excludeEnd: true,
	    end: '\\('
	  };
	  var RULE = {
	    className: 'rule',
	    begin: /[A-Z\_\.\-]+\s*:/, returnBegin: true, end: ';', endsWithParent: true,
	    contains: [
	      {
	        className: 'attribute',
	        begin: /\S/, end: ':', excludeEnd: true,
	        starts: {
	          className: 'value',
	          endsWithParent: true, excludeEnd: true,
	          contains: [
	            FUNCTION,
	            hljs.CSS_NUMBER_MODE,
	            hljs.QUOTE_STRING_MODE,
	            hljs.APOS_STRING_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            {
	              className: 'hexcolor', begin: '#[0-9A-Fa-f]+'
	            },
	            {
	              className: 'important', begin: '!important'
	            }
	          ]
	        }
	      }
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    illegal: /[=\/|'\$]/,
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'id', begin: /\#[A-Za-z0-9_-]+/
	      },
	      {
	        className: 'class', begin: /\.[A-Za-z0-9_-]+/
	      },
	      {
	        className: 'attr_selector',
	        begin: /\[/, end: /\]/,
	        illegal: '$'
	      },
	      {
	        className: 'pseudo',
	        begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"']+/
	      },
	      {
	        className: 'at_rule',
	        begin: '@(font-face|page)',
	        lexemes: '[a-z-]+',
	        keywords: 'font-face page'
	      },
	      {
	        className: 'at_rule',
	        begin: '@', end: '[{;]', // at_rule eating first "{" is a good thing
	                                 // because it doesn’t let it to be parsed as
	                                 // a rule set but instead drops parser into
	                                 // the default mode which is how it should be.
	        contains: [
	          {
	            className: 'keyword',
	            begin: /\S+/
	          },
	          {
	            begin: /\s/, endsWithParent: true, excludeEnd: true,
	            relevance: 0,
	            contains: [
	              FUNCTION,
	              hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE,
	              hljs.CSS_NUMBER_MODE
	            ]
	          }
	        ]
	      },
	      {
	        className: 'tag', begin: IDENT_RE,
	        relevance: 0
	      },
	      {
	        className: 'rules',
	        begin: '{', end: '}',
	        illegal: /\S/,
	        contains: [
	          hljs.C_BLOCK_COMMENT_MODE,
	          RULE,
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	module.exports = /**
	 * Known issues:
	 *
	 * - invalid hex string literals will be recognized as a double quoted strings
	 *   but 'x' at the beginning of string will not be matched
	 *
	 * - delimited string literals are not checked for matching end delimiter
	 *   (not possible to do with js regexp)
	 *
	 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
	 *   also, content of token string is not validated to contain only valid D tokens
	 *
	 * - special token sequence rule is not strictly following D grammar (anything following #line
	 *   up to the end of line is matched as special token sequence)
	 */
	
	function(hljs) {
	  /**
	   * Language keywords
	   *
	   * @type {Object}
	   */
	  var D_KEYWORDS = {
	    keyword:
	      'abstract alias align asm assert auto body break byte case cast catch class ' +
	      'const continue debug default delete deprecated do else enum export extern final ' +
	      'finally for foreach foreach_reverse|10 goto if immutable import in inout int ' +
	      'interface invariant is lazy macro mixin module new nothrow out override package ' +
	      'pragma private protected public pure ref return scope shared static struct ' +
	      'super switch synchronized template this throw try typedef typeid typeof union ' +
	      'unittest version void volatile while with __FILE__ __LINE__ __gshared|10 ' +
	      '__thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__',
	    built_in:
	      'bool cdouble cent cfloat char creal dchar delegate double dstring float function ' +
	      'idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar ' +
	      'wstring',
	    literal:
	      'false null true'
	  };
	
	  /**
	   * Number literal regexps
	   *
	   * @type {String}
	   */
	  var decimal_integer_re = '(0|[1-9][\\d_]*)',
	    decimal_integer_nosus_re = '(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)',
	    binary_integer_re = '0[bB][01_]+',
	    hexadecimal_digits_re = '([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)',
	    hexadecimal_integer_re = '0[xX]' + hexadecimal_digits_re,
	
	    decimal_exponent_re = '([eE][+-]?' + decimal_integer_nosus_re + ')',
	    decimal_float_re = '(' + decimal_integer_nosus_re + '(\\.\\d*|' + decimal_exponent_re + ')|' +
	                '\\d+\\.' + decimal_integer_nosus_re + decimal_integer_nosus_re + '|' +
	                '\\.' + decimal_integer_re + decimal_exponent_re + '?' +
	              ')',
	    hexadecimal_float_re = '(0[xX](' +
	                  hexadecimal_digits_re + '\\.' + hexadecimal_digits_re + '|'+
	                  '\\.?' + hexadecimal_digits_re +
	                 ')[pP][+-]?' + decimal_integer_nosus_re + ')',
	
	    integer_re = '(' +
	      decimal_integer_re + '|' +
	      binary_integer_re  + '|' +
	       hexadecimal_integer_re   +
	    ')',
	
	    float_re = '(' +
	      hexadecimal_float_re + '|' +
	      decimal_float_re  +
	    ')';
	
	  /**
	   * Escape sequence supported in D string and character literals
	   *
	   * @type {String}
	   */
	  var escape_sequence_re = '\\\\(' +
	              '[\'"\\?\\\\abfnrtv]|' +  // common escapes
	              'u[\\dA-Fa-f]{4}|' +     // four hex digit unicode codepoint
	              '[0-7]{1,3}|' +       // one to three octal digit ascii char code
	              'x[\\dA-Fa-f]{2}|' +    // two hex digit ascii char code
	              'U[\\dA-Fa-f]{8}' +      // eight hex digit unicode codepoint
	              ')|' +
	              '&[a-zA-Z\\d]{2,};';      // named character entity
	
	  /**
	   * D integer number literals
	   *
	   * @type {Object}
	   */
	  var D_INTEGER_MODE = {
	    className: 'number',
	      begin: '\\b' + integer_re + '(L|u|U|Lu|LU|uL|UL)?',
	      relevance: 0
	  };
	
	  /**
	   * [D_FLOAT_MODE description]
	   * @type {Object}
	   */
	  var D_FLOAT_MODE = {
	    className: 'number',
	    begin: '\\b(' +
	        float_re + '([fF]|L|i|[fF]i|Li)?|' +
	        integer_re + '(i|[fF]i|Li)' +
	      ')',
	    relevance: 0
	  };
	
	  /**
	   * D character literal
	   *
	   * @type {Object}
	   */
	  var D_CHARACTER_MODE = {
	    className: 'string',
	    begin: '\'(' + escape_sequence_re + '|.)', end: '\'',
	    illegal: '.'
	  };
	
	  /**
	   * D string escape sequence
	   *
	   * @type {Object}
	   */
	  var D_ESCAPE_SEQUENCE = {
	    begin: escape_sequence_re,
	    relevance: 0
	  };
	
	  /**
	   * D double quoted string literal
	   *
	   * @type {Object}
	   */
	  var D_STRING_MODE = {
	    className: 'string',
	    begin: '"',
	    contains: [D_ESCAPE_SEQUENCE],
	    end: '"[cwd]?'
	  };
	
	  /**
	   * D wysiwyg and delimited string literals
	   *
	   * @type {Object}
	   */
	  var D_WYSIWYG_DELIMITED_STRING_MODE = {
	    className: 'string',
	    begin: '[rq]"',
	    end: '"[cwd]?',
	    relevance: 5
	  };
	
	  /**
	   * D alternate wysiwyg string literal
	   *
	   * @type {Object}
	   */
	  var D_ALTERNATE_WYSIWYG_STRING_MODE = {
	    className: 'string',
	    begin: '`',
	    end: '`[cwd]?'
	  };
	
	  /**
	   * D hexadecimal string literal
	   *
	   * @type {Object}
	   */
	  var D_HEX_STRING_MODE = {
	    className: 'string',
	    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
	    relevance: 10
	  };
	
	  /**
	   * D delimited string literal
	   *
	   * @type {Object}
	   */
	  var D_TOKEN_STRING_MODE = {
	    className: 'string',
	    begin: 'q"\\{',
	    end: '\\}"'
	  };
	
	  /**
	   * Hashbang support
	   *
	   * @type {Object}
	   */
	  var D_HASHBANG_MODE = {
	    className: 'shebang',
	    begin: '^#!',
	    end: '$',
	    relevance: 5
	  };
	
	  /**
	   * D special token sequence
	   *
	   * @type {Object}
	   */
	  var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
	    className: 'preprocessor',
	    begin: '#(line)',
	    end: '$',
	    relevance: 5
	  };
	
	  /**
	   * D attributes
	   *
	   * @type {Object}
	   */
	  var D_ATTRIBUTE_MODE = {
	    className: 'keyword',
	    begin: '@[a-zA-Z_][a-zA-Z_\\d]*'
	  };
	
	  /**
	   * D nesting comment
	   *
	   * @type {Object}
	   */
	  var D_NESTING_COMMENT_MODE = hljs.COMMENT(
	    '\\/\\+',
	    '\\+\\/',
	    {
	      contains: ['self'],
	      relevance: 10
	    }
	  );
	
	  return {
	    lexemes: hljs.UNDERSCORE_IDENT_RE,
	    keywords: D_KEYWORDS,
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        D_NESTING_COMMENT_MODE,
	        D_HEX_STRING_MODE,
	        D_STRING_MODE,
	        D_WYSIWYG_DELIMITED_STRING_MODE,
	        D_ALTERNATE_WYSIWYG_STRING_MODE,
	        D_TOKEN_STRING_MODE,
	        D_FLOAT_MODE,
	        D_INTEGER_MODE,
	        D_CHARACTER_MODE,
	        D_HASHBANG_MODE,
	        D_SPECIAL_TOKEN_SEQUENCE_MODE,
	        D_ATTRIBUTE_MODE
	    ]
	  };
	};

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var SUBST = {
	    className: 'subst',
	    begin: '\\$\\{', end: '}',
	    keywords: 'true false null this is new super'
	  };
	
	  var STRING = {
	    className: 'string',
	    variants: [
	      {
	        begin: 'r\'\'\'', end: '\'\'\''
	      },
	      {
	        begin: 'r"""', end: '"""'
	      },
	      {
	        begin: 'r\'', end: '\'',
	        illegal: '\\n'
	      },
	      {
	        begin: 'r"', end: '"',
	        illegal: '\\n'
	      },
	      {
	        begin: '\'\'\'', end: '\'\'\'',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '"""', end: '"""',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '\'', end: '\'',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      }
	    ]
	  };
	  SUBST.contains = [
	    hljs.C_NUMBER_MODE, STRING
	  ];
	
	  var KEYWORDS = {
	    keyword: 'assert break case catch class const continue default do else enum extends false final finally for if ' +
	      'in is new null rethrow return super switch this throw true try var void while with',
	    literal: 'abstract as dynamic export external factory get implements import library operator part set static typedef',
	    built_in:
	      // dart:core
	      'print Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set ' +
	      'Stopwatch String StringBuffer StringSink Symbol Type Uri bool double int num ' +
	      // dart:html
	      'document window querySelector querySelectorAll Element ElementList'
	  };
	
	  return {
	    keywords: KEYWORDS,
	    contains: [
	      STRING,
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          subLanguage: 'markdown'
	        }
	      ),
	      hljs.COMMENT(
	        '///',
	        '$',
	        {
	          subLanguage: 'markdown'
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'annotation', begin: '@[A-Za-z]+'
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      }
	    ]
	  }
	};

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS =
	    'exports register file shl array record property for mod while set ally label uses raise not ' +
	    'stored class safecall var interface or private static exit index inherited to else stdcall ' +
	    'override shr asm far resourcestring finalization packed virtual out and protected library do ' +
	    'xorwrite goto near function end div overload object unit begin string on inline repeat until ' +
	    'destructor write message program with read initialization except default nil if case cdecl in ' +
	    'downto threadvar of try pascal const external constructor type public then implementation ' +
	    'finally published procedure';
	  var COMMENT_MODES = [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.COMMENT(
	      /\{/,
	      /\}/,
	      {
	        relevance: 0
	      }
	    ),
	    hljs.COMMENT(
	      /\(\*/,
	      /\*\)/,
	      {
	        relevance: 10
	      }
	    )
	  ];
	  var STRING = {
	    className: 'string',
	    begin: /'/, end: /'/,
	    contains: [{begin: /''/}]
	  };
	  var CHAR_STRING = {
	    className: 'string', begin: /(#\d+)+/
	  };
	  var CLASS = {
	    begin: hljs.IDENT_RE + '\\s*=\\s*class\\s*\\(', returnBegin: true,
	    contains: [
	      hljs.TITLE_MODE
	    ]
	  };
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'function constructor destructor procedure', end: /[:;]/,
	    keywords: 'function constructor|10 destructor|10 procedure|10',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        className: 'params',
	        begin: /\(/, end: /\)/,
	        keywords: KEYWORDS,
	        contains: [STRING, CHAR_STRING]
	      }
	    ].concat(COMMENT_MODES)
	  };
	  return {
	    case_insensitive: true,
	    keywords: KEYWORDS,
	    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
	    contains: [
	      STRING, CHAR_STRING,
	      hljs.NUMBER_MODE,
	      CLASS,
	      FUNCTION
	    ].concat(COMMENT_MODES)
	  };
	};

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['patch'],
	    contains: [
	      {
	        className: 'chunk',
	        relevance: 10,
	        variants: [
	          {begin: /^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},
	          {begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/},
	          {begin: /^\-\-\- +\d+,\d+ +\-\-\-\-$/}
	        ]
	      },
	      {
	        className: 'header',
	        variants: [
	          {begin: /Index: /, end: /$/},
	          {begin: /=====/, end: /=====$/},
	          {begin: /^\-\-\-/, end: /$/},
	          {begin: /^\*{3} /, end: /$/},
	          {begin: /^\+\+\+/, end: /$/},
	          {begin: /\*{5}/, end: /\*{5}$/}
	        ]
	      },
	      {
	        className: 'addition',
	        begin: '^\\+', end: '$'
	      },
	      {
	        className: 'deletion',
	        begin: '^\\-', end: '$'
	      },
	      {
	        className: 'change',
	        begin: '^\\!', end: '$'
	      }
	    ]
	  };
	};

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var FILTER = {
	    className: 'filter',
	    begin: /\|[A-Za-z]+:?/,
	    keywords:
	      'truncatewords removetags linebreaksbr yesno get_digit timesince random striptags ' +
	      'filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands ' +
	      'title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode ' +
	      'timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort ' +
	      'dictsortreversed default_if_none pluralize lower join center default ' +
	      'truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first ' +
	      'escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize ' +
	      'localtime utc timezone',
	    contains: [
	      {className: 'argument', begin: /"/, end: /"/},
	      {className: 'argument', begin: /'/, end: /'/}
	    ]
	  };
	
	  return {
	    aliases: ['jinja'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT(/\{%\s*comment\s*%}/, /\{%\s*endcomment\s*%}/),
	      hljs.COMMENT(/\{#/, /#}/),
	      {
	        className: 'template_tag',
	        begin: /\{%/, end: /%}/,
	        keywords:
	          'comment endcomment load templatetag ifchanged endifchanged if endif firstof for ' +
	          'endfor in ifnotequal endifnotequal widthratio extends include spaceless ' +
	          'endspaceless regroup by as ifequal endifequal ssi now with cycle url filter ' +
	          'endfilter debug block endblock else autoescape endautoescape csrf_token empty elif ' +
	          'endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix ' +
	          'plural get_current_language language get_available_languages ' +
	          'get_current_language_bidi get_language_info get_language_info_list localize ' +
	          'endlocalize localtime endlocaltime timezone endtimezone get_current_timezone ' +
	          'verbatim',
	        contains: [FILTER]
	      },
	      {
	        className: 'variable',
	        begin: /\{\{/, end: /}}/,
	        contains: [FILTER]
	      }
	    ]
	  };
	};

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['bind', 'zone'],
	    keywords: {
	      keyword:
	        'IN A AAAA AFSDB APL CAA CDNSKEY CDS CERT CNAME DHCID DLV DNAME DNSKEY DS HIP IPSECKEY KEY KX ' +
	        'LOC MX NAPTR NS NSEC NSEC3 NSEC3PARAM PTR RRSIG RP SIG SOA SRV SSHFP TA TKEY TLSA TSIG TXT'
	    },
	    contains: [
	      hljs.COMMENT(';', '$'),
	      {
	        className: 'operator',
	        beginKeywords: '$TTL $GENERATE $INCLUDE $ORIGIN'
	      },
	      // IPv6
	      {
	        className: 'number',
	        begin: '((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))'
	      },
	      // IPv4
	      {
	        className: 'number',
	        begin: '((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])'
	      }
	    ]
	  };
	};

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['docker'],
	    case_insensitive: true,
	    keywords: {
	      built_ins: 'from maintainer cmd expose add copy entrypoint volume user workdir onbuild run env label'
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        keywords : {
	          built_in: 'run cmd entrypoint volume add copy workdir onbuild label'
	        },
	        begin: /^ *(onbuild +)?(run|cmd|entrypoint|volume|add|copy|workdir|label) +/,
	        starts: {
	          end: /[^\\]\n/,
	          subLanguage: 'bash'
	        }
	      },
	      {
	        keywords: {
	          built_in: 'from maintainer expose env user onbuild'
	        },
	        begin: /^ *(onbuild +)?(from|maintainer|expose|env|user|onbuild) +/, end: /[^\\]\n/,
	        contains: [
	          hljs.APOS_STRING_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.NUMBER_MODE,
	          hljs.HASH_COMMENT_MODE
	        ]
	      }
	    ]
	  }
	};

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT = hljs.COMMENT(
	    /@?rem\b/, /$/,
	    {
	      relevance: 10
	    }
	  );
	  var LABEL = {
	    className: 'label',
	    begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)',
	    relevance: 0
	  };
	  return {
	    aliases: ['bat', 'cmd'],
	    case_insensitive: true,
	    illegal: /\/\*/,
	    keywords: {
	      flow: 'if else goto for in do call exit not exist errorlevel defined',
	      operator: 'equ neq lss leq gtr geq',
	      keyword: 'shift cd dir echo setlocal endlocal set pause copy',
	      stream: 'prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux',
	      winutils: 'ping net ipconfig taskkill xcopy ren del',
	      built_in: 'append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color ' +
	        'comp compact convert date dir diskcomp diskcopy doskey erase fs ' +
	        'find findstr format ftype graftabl help keyb label md mkdir mode more move path ' +
	        'pause print popd pushd promt rd recover rem rename replace restore rmdir shift' +
	        'sort start subst time title tree type ver verify vol'
	    },
	    contains: [
	      {
	        className: 'envvar', begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
	      },
	      {
	        className: 'function',
	        begin: LABEL.begin, end: 'goto:eof',
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
	          COMMENT
	        ]
	      },
	      {
	        className: 'number', begin: '\\b\\d+',
	        relevance: 0
	      },
	      COMMENT
	    ]
	  };
	};

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var EXPRESSION_KEYWORDS = 'if eq ne lt lte gt gte select default math sep';
	  return {
	    aliases: ['dst'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      {
	        className: 'expression',
	        begin: '{', end: '}',
	        relevance: 0,
	        contains: [
	          {
	            className: 'begin-block', begin: '\#[a-zA-Z\-\ \.]+',
	            keywords: EXPRESSION_KEYWORDS
	          },
	          {
	            className: 'string',
	            begin: '"', end: '"'
	          },
	          {
	            className: 'end-block', begin: '\\\/[a-zA-Z\-\ \.]+',
	            keywords: EXPRESSION_KEYWORDS
	          },
	          {
	            className: 'variable', begin: '[a-zA-Z\-\.]+',
	            keywords: EXPRESSION_KEYWORDS,
	            relevance: 0
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var ELIXIR_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9_]*(\\!|\\?)?';
	  var ELIXIR_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
	  var ELIXIR_KEYWORDS =
	    'and false then defined module in return redo retry end for true self when ' +
	    'next until do begin unless nil break not case cond alias while ensure or ' +
	    'include use alias fn quote';
	  var SUBST = {
	    className: 'subst',
	    begin: '#\\{', end: '}',
	    lexemes: ELIXIR_IDENT_RE,
	    keywords: ELIXIR_KEYWORDS
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {
	        begin: /'/, end: /'/
	      },
	      {
	        begin: /"/, end: /"/
	      }
	    ]
	  };
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'def defp defmacro', end: /\B\b/, // the mode is ended by the title
	    contains: [
	      hljs.inherit(hljs.TITLE_MODE, {
	        begin: ELIXIR_IDENT_RE,
	        endsParent: true
	      })
	    ]
	  };
	  var CLASS = hljs.inherit(FUNCTION, {
	    className: 'class',
	    beginKeywords: 'defmodule defrecord', end: /\bdo\b|$|;/
	  });
	  var ELIXIR_DEFAULT_CONTAINS = [
	    STRING,
	    hljs.HASH_COMMENT_MODE,
	    CLASS,
	    FUNCTION,
	    {
	      className: 'constant',
	      begin: '(\\b[A-Z_]\\w*(.)?)+',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ':',
	      contains: [STRING, {begin: ELIXIR_METHOD_RE}],
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ELIXIR_IDENT_RE + ':',
	      relevance: 0
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    {
	      className: 'variable',
	      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))'
	    },
	    {
	      begin: '->'
	    },
	    { // regexp container
	      begin: '(' + hljs.RE_STARTERS_RE + ')\\s*',
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        {
	          className: 'regexp',
	          illegal: '\\n',
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	          variants: [
	            {
	              begin: '/', end: '/[a-z]*'
	            },
	            {
	              begin: '%r\\[', end: '\\][a-z]*'
	            }
	          ]
	        }
	      ],
	      relevance: 0
	    }
	  ];
	  SUBST.contains = ELIXIR_DEFAULT_CONTAINS;
	
	  return {
	    lexemes: ELIXIR_IDENT_RE,
	    keywords: ELIXIR_KEYWORDS,
	    contains: ELIXIR_DEFAULT_CONTAINS
	  };
	};

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT_MODES = [
	    hljs.COMMENT('--', '$'),
	    hljs.COMMENT(
	      '{-',
	      '-}',
	      {
	        contains: ['self']
	      }
	    )
	  ];
	
	  var CONSTRUCTOR = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (build-in, infix).
	    relevance: 0
	  };
	
	  var LIST = {
	    className: 'container',
	    begin: '\\(', end: '\\)',
	    illegal: '"',
	    contains: [
	      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'}
	    ].concat(COMMENT_MODES)
	  };
	
	  var RECORD = {
	    className: 'container',
	    begin: '{', end: '}',
	    contains: LIST.contains
	  };
	
	  return {
	    keywords:
	      'let in if then else case of where module import exposing ' +
	      'type alias as infix infixl infixr port',
	    contains: [
	
	      // Top-level constructions.
	
	      {
	        className: 'module',
	        begin: '\\bmodule\\b', end: 'where',
	        keywords: 'module where',
	        contains: [LIST].concat(COMMENT_MODES),
	        illegal: '\\W\\.|;'
	      },
	      {
	        className: 'import',
	        begin: '\\bimport\\b', end: '$',
	        keywords: 'import|0 as exposing',
	        contains: [LIST].concat(COMMENT_MODES),
	        illegal: '\\W\\.|;'
	      },
	      {
	        className: 'typedef',
	        begin: '\\btype\\b', end: '$',
	        keywords: 'type alias',
	        contains: [CONSTRUCTOR, LIST, RECORD].concat(COMMENT_MODES)
	      },
	      {
	        className: 'infix',
	        beginKeywords: 'infix infixl infixr', end: '$',
	        contains: [hljs.C_NUMBER_MODE].concat(COMMENT_MODES)
	      },
	      {
	        className: 'foreign',
	        begin: '\\bport\\b', end: '$',
	        keywords: 'port',
	        contains: COMMENT_MODES
	      },
	
	      // Literals and names.
	
	      // TODO: characters.
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      CONSTRUCTOR,
	      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),
	
	      {begin: '->|<-'} // No markup, relevance booster
	    ].concat(COMMENT_MODES)
	  };
	};

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT('<%#', '%>'),
	      {
	        begin: '<%[%=-]?', end: '[%-]?%>',
	        subLanguage: 'ruby',
	        excludeBegin: true,
	        excludeEnd: true
	      }
	    ]
	  };
	};

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      special_functions:
	        'spawn spawn_link self',
	      reserved:
	        'after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if ' +
	        'let not of or orelse|10 query receive rem try when xor'
	    },
	    contains: [
	      {
	        className: 'prompt', begin: '^[0-9]+> ',
	        relevance: 10
	      },
	      hljs.COMMENT('%', '$'),
	      {
	        className: 'number',
	        begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
	        relevance: 0
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'constant', begin: '\\?(::)?([A-Z]\\w*(::)?)+'
	      },
	      {
	        className: 'arrow', begin: '->'
	      },
	      {
	        className: 'ok', begin: 'ok'
	      },
	      {
	        className: 'exclamation_mark', begin: '!'
	      },
	      {
	        className: 'function_or_atom',
	        begin: '(\\b[a-z\'][a-zA-Z0-9_\']*:[a-z\'][a-zA-Z0-9_\']*)|(\\b[a-z\'][a-zA-Z0-9_\']*)',
	        relevance: 0
	      },
	      {
	        className: 'variable',
	        begin: '[A-Z][a-zA-Z0-9_\']*',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BASIC_ATOM_RE = '[a-z\'][a-zA-Z0-9_\']*';
	  var FUNCTION_NAME_RE = '(' + BASIC_ATOM_RE + ':' + BASIC_ATOM_RE + '|' + BASIC_ATOM_RE + ')';
	  var ERLANG_RESERVED = {
	    keyword:
	      'after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if ' +
	      'let not of orelse|10 query receive rem try when xor',
	    literal:
	      'false true'
	  };
	
	  var COMMENT = hljs.COMMENT('%', '$');
	  var NUMBER = {
	    className: 'number',
	    begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
	    relevance: 0
	  };
	  var NAMED_FUN = {
	    begin: 'fun\\s+' + BASIC_ATOM_RE + '/\\d+'
	  };
	  var FUNCTION_CALL = {
	    begin: FUNCTION_NAME_RE + '\\(', end: '\\)',
	    returnBegin: true,
	    relevance: 0,
	    contains: [
	      {
	        className: 'function_name', begin: FUNCTION_NAME_RE,
	        relevance: 0
	      },
	      {
	        begin: '\\(', end: '\\)', endsWithParent: true,
	        returnEnd: true,
	        relevance: 0
	        // "contains" defined later
	      }
	    ]
	  };
	  var TUPLE = {
	    className: 'tuple',
	    begin: '{', end: '}',
	    relevance: 0
	    // "contains" defined later
	  };
	  var VAR1 = {
	    className: 'variable',
	    begin: '\\b_([A-Z][A-Za-z0-9_]*)?',
	    relevance: 0
	  };
	  var VAR2 = {
	    className: 'variable',
	    begin: '[A-Z][a-zA-Z0-9_]*',
	    relevance: 0
	  };
	  var RECORD_ACCESS = {
	    begin: '#' + hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0,
	    returnBegin: true,
	    contains: [
	      {
	        className: 'record_name',
	        begin: '#' + hljs.UNDERSCORE_IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: '{', end: '}',
	        relevance: 0
	        // "contains" defined later
	      }
	    ]
	  };
	
	  var BLOCK_STATEMENTS = {
	    beginKeywords: 'fun receive if try case', end: 'end',
	    keywords: ERLANG_RESERVED
	  };
	  BLOCK_STATEMENTS.contains = [
	    COMMENT,
	    NAMED_FUN,
	    hljs.inherit(hljs.APOS_STRING_MODE, {className: ''}),
	    BLOCK_STATEMENTS,
	    FUNCTION_CALL,
	    hljs.QUOTE_STRING_MODE,
	    NUMBER,
	    TUPLE,
	    VAR1, VAR2,
	    RECORD_ACCESS
	  ];
	
	  var BASIC_MODES = [
	    COMMENT,
	    NAMED_FUN,
	    BLOCK_STATEMENTS,
	    FUNCTION_CALL,
	    hljs.QUOTE_STRING_MODE,
	    NUMBER,
	    TUPLE,
	    VAR1, VAR2,
	    RECORD_ACCESS
	  ];
	  FUNCTION_CALL.contains[1].contains = BASIC_MODES;
	  TUPLE.contains = BASIC_MODES;
	  RECORD_ACCESS.contains[1].contains = BASIC_MODES;
	
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)',
	    contains: BASIC_MODES
	  };
	  return {
	    aliases: ['erl'],
	    keywords: ERLANG_RESERVED,
	    illegal: '(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))',
	    contains: [
	      {
	        className: 'function',
	        begin: '^' + BASIC_ATOM_RE + '\\s*\\(', end: '->',
	        returnBegin: true,
	        illegal: '\\(|#|//|/\\*|\\\\|:|;',
	        contains: [
	          PARAMS,
	          hljs.inherit(hljs.TITLE_MODE, {begin: BASIC_ATOM_RE})
	        ],
	        starts: {
	          end: ';|\\.',
	          keywords: ERLANG_RESERVED,
	          contains: BASIC_MODES
	        }
	      },
	      COMMENT,
	      {
	        className: 'pp',
	        begin: '^-', end: '\\.',
	        relevance: 0,
	        excludeEnd: true,
	        returnBegin: true,
	        lexemes: '-' + hljs.IDENT_RE,
	        keywords:
	          '-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn ' +
	          '-import -include -include_lib -compile -define -else -endif -file -behaviour ' +
	          '-behavior -spec',
	        contains: [PARAMS]
	      },
	      NUMBER,
	      hljs.QUOTE_STRING_MODE,
	      RECORD_ACCESS,
	      VAR1, VAR2,
	      TUPLE,
	      {begin: /\.$/} // relevance booster
	    ]
	  };
	};

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	    {
	      begin: /[^\u2401\u0001]+/,
	      end: /[\u2401\u0001]/,
	      excludeEnd: true,
	      returnBegin: true,
	      returnEnd: false,
	      contains: [
	      {
	        begin: /([^\u2401\u0001=]+)/,
	        end: /=([^\u2401\u0001=]+)/,
	        returnEnd: true,
	        returnBegin: false,
	        className: 'attribute'
	      },
	      {
	        begin: /=/,
	        end: /([\u2401\u0001])/,
	        excludeEnd: true,
	        excludeBegin: true,
	        className: 'string'
	      }]
	    }],
	    case_insensitive: true
	  };
	};

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)'
	  };
	
	  var F_KEYWORDS = {
	    constant: '.False. .True.',
	    type: 'integer real character complex logical dimension allocatable|10 parameter ' +
	      'external implicit|10 none double precision assign intent optional pointer ' +
	      'target in out common equivalence data',
	    keyword: 'kind do while private call intrinsic where elsewhere ' +
	      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
	      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
	      'goto save else use module select case ' +
	      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
	      'continue format pause cycle exit ' +
	      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
	      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
	      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
	      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
	      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
	      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
	      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
	      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
	      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
	      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
	      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure',
	    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
	      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
	      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
	      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
	      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
	      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
	      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
	      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
	      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
	      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
	      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
	      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
	      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
	      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
	      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
	      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
	      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
	      'num_images parity popcnt poppar shifta shiftl shiftr this_image'
	  };
	  return {
	    case_insensitive: true,
	    aliases: ['f90', 'f95'],
	    keywords: F_KEYWORDS,
	    illegal: /\/\*/,
	    contains: [
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
	      {
	        className: 'function',
	        beginKeywords: 'subroutine function program',
	        illegal: '[${=\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      },
	      hljs.COMMENT('!', '$', {relevance: 0}),
	      {
	        className: 'number',
	        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var TYPEPARAM = {
	    begin: '<', end: '>',
	    contains: [
	      hljs.inherit(hljs.TITLE_MODE, {begin: /'[a-zA-Z0-9_]+/})
	    ]
	  };
	
	  return {
	    aliases: ['fs'],
	    keywords:
	      'abstract and as assert base begin class default delegate do done ' +
	      'downcast downto elif else end exception extern false finally for ' +
	      'fun function global if in inherit inline interface internal lazy let ' +
	      'match member module mutable namespace new null of open or ' +
	      'override private public rec return sig static struct then to ' +
	      'true try type upcast use val void when while with yield',
	    illegal: /\/\*/,
	    contains: [
	      {
	        // monad builder keywords (matches before non-bang kws)
	        className: 'keyword',
	        begin: /\b(yield|return|let|do)!/
	      },
	      {
	        className: 'string',
	        begin: '@"', end: '"',
	        contains: [{begin: '""'}]
	      },
	      {
	        className: 'string',
	        begin: '"""', end: '"""'
	      },
	      hljs.COMMENT('\\(\\*', '\\*\\)'),
	      {
	        className: 'class',
	        beginKeywords: 'type', end: '\\(|=|$', excludeEnd: true,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          TYPEPARAM
	        ]
	      },
	      {
	        className: 'annotation',
	        begin: '\\[<', end: '>\\]',
	        relevance: 10
	      },
	      {
	        className: 'attribute',
	        begin: '\\B(\'[A-Za-z])\\b',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var KEYWORDS =
	    'abort acronym acronyms alias all and assign binary card diag display else1 eps eq equation equations file files ' +
	    'for1 free ge gt if inf integer le loop lt maximizing minimizing model models na ne negative no not option ' +
	    'options or ord parameter parameters positive prod putpage puttl repeat sameas scalar scalars semicont semiint ' +
	    'set1 sets smax smin solve sos1 sos2 sum system table then until using variable variables while1 xor yes';
	
	  return {
	    aliases: ['gms'],
	    case_insensitive: true,
	    keywords: KEYWORDS,
	    contains: [
	      {
	        className: 'section',
	        beginKeywords: 'sets parameters variables equations',
	        end: ';',
	        contains: [
	          {
	            begin: '/',
	            end: '/',
	            contains: [hljs.NUMBER_MODE]
	          }
	        ]
	      },
	      {
	        className: 'string',
	        begin: '\\*{3}', end: '\\*{3}'
	      },
	      hljs.NUMBER_MODE,
	      {
	        className: 'number',
	        begin: '\\$[a-zA-Z0-9]+'
	      }
	    ]
	  };
	};

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    var GCODE_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
	    var GCODE_CLOSE_RE = '\\%';
	    var GCODE_KEYWORDS = {
	        literal:
	            '',
	        built_in:
	            '',
	        keyword:
	            'IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT ' +
	            'EQ LT GT NE GE LE OR XOR'
	    };
	    var GCODE_START = {
	        className: 'preprocessor',
	        begin: '([O])([0-9]+)'
	    };
	    var GCODE_CODE = [
	        hljs.C_LINE_COMMENT_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        hljs.COMMENT(/\(/, /\)/),
	        hljs.inherit(hljs.C_NUMBER_MODE, {begin: '([-+]?([0-9]*\\.?[0-9]+\\.?))|' + hljs.C_NUMBER_RE}),
	        hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	        hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	        {
	            className: 'keyword',
	            begin: '([G])([0-9]+\\.?[0-9]?)'
	        },
	        {
	            className: 'title',
	            begin: '([M])([0-9]+\\.?[0-9]?)'
	        },
	        {
	            className: 'title',
	            begin: '(VC|VS|#)',
	            end: '(\\d+)'
	        },
	        {
	            className: 'title',
	            begin: '(VZOFX|VZOFY|VZOFZ)'
	        },
	        {
	            className: 'built_in',
	            begin: '(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)',
	            end: '([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])'
	        },
	        {
	            className: 'label',
	            variants: [
	                {
	                    begin: 'N', end: '\\d+',
	                    illegal: '\\W'
	                }
	            ]
	        }
	    ];
	
	    return {
	        aliases: ['nc'],
	        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
	        // However, most prefer all uppercase and uppercase is customary.
	        case_insensitive: true,
	        lexemes: GCODE_IDENT_RE,
	        keywords: GCODE_KEYWORDS,
	        contains: [
	            {
	                className: 'preprocessor',
	                begin: GCODE_CLOSE_RE
	            },
	            GCODE_START
	        ].concat(GCODE_CODE)
	    };
	};

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  return {
	    aliases: ['feature'],
	    keywords: 'Feature Background Ability Business\ Need Scenario Scenarios Scenario\ Outline Scenario\ Template Examples Given And Then But When',
	    contains: [
	      {
	        className: 'keyword',
	        begin: '\\*'
	      },
	      hljs.COMMENT('@[^@\r\n\t ]+', '$'),
	      {
	        begin: '\\|', end: '\\|\\w*$',
	        contains: [
	          {
	            className: 'string',
	            begin: '[^|]+'
	          }
	        ]
	      },
	      {
	        className: 'variable',
	        begin: '<', end: '>'
	      },
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'string',
	        begin: '"""', end: '"""'
	      },
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	};

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword:
	        'atomic_uint attribute bool break bvec2 bvec3 bvec4 case centroid coherent const continue default ' +
	        'discard dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 ' +
	        'dmat4x4 do double dvec2 dvec3 dvec4 else flat float for highp if iimage1D iimage1DArray ' +
	        'iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube ' +
	        'iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect ' +
	        'image3D imageBuffer imageCube imageCubeArray in inout int invariant isampler1D isampler1DArray ' +
	        'isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer ' +
	        'isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 layout lowp mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 ' +
	        'mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 mediump noperspective out patch precision readonly restrict ' +
	        'return sample sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray ' +
	        'sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow ' +
	        'sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow smooth ' +
	        'struct subroutine switch uimage1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray ' +
	        'uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint uniform usampler1D usampler1DArray ' +
	        'usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D usamplerBuffer ' +
	        'usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 varying vec2 vec3 vec4 void volatile while writeonly',
	      built_in:
	        'gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial ' +
	        'gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color ' +
	        'gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord ' +
	        'gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor ' +
	        'gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial ' +
	        'gl_FrontSecondaryColor gl_InstanceID gl_InvocationID gl_Layer gl_LightModel ' +
	        'gl_LightSource gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize ' +
	        'gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers ' +
	        'gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs ' +
	        'gl_MaxCombinedTextureImageUnits gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers ' +
	        'gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents ' +
	        'gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers ' +
	        'gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents ' +
	        'gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits ' +
	        'gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents ' +
	        'gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset ' +
	        'gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms ' +
	        'gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits ' +
	        'gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents ' +
	        'gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters ' +
	        'gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents ' +
	        'gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents ' +
	        'gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits ' +
	        'gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors ' +
	        'gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs ' +
	        'gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexTextureImageUnits ' +
	        'gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset'+
	        'gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose ' +
	        'gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse ' +
	        'gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose ' +
	        'gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 ' +
	        'gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix ' +
	        'gl_NormalScale gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn ' +
	        'gl_PerVertex gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn ' +
	        'gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose ' +
	        'gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition ' +
	        'gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor ' +
	        'gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID ' +
	        'gl_ViewportIndex gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive ' +
	        'abs acos acosh all any asin asinh atan atanh atomicCounter atomicCounterDecrement ' +
	        'atomicCounterIncrement barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ' +
	        'ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward ' +
	        'findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan ' +
	        'greaterThanEqual imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange ' +
	        'imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageStore imulExtended ' +
	        'intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt ' +
	        'isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier ' +
	        'min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 ' +
	        'packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract ' +
	        'round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj ' +
	        'shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture ' +
	        'texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj ' +
	        'texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod ' +
	        'textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod ' +
	        'textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod ' +
	        'textureProjLodOffset textureProjOffset textureQueryLod textureSize transpose trunc uaddCarry ' +
	        'uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 ' +
	        'unpackUnorm2x16 unpackUnorm4x8 usubBorrow gl_TextureMatrix gl_TextureMatrixInverse',
	      literal: 'true false'
	    },
	    illegal: '"',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'preprocessor',
	        begin: '#', end: '$'
	      }
	    ]
	  };
	};

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var GO_KEYWORDS = {
	    keyword:
	      'break default func interface select case map struct chan else goto package switch ' +
	      'const fallthrough if range type continue for import return var go defer',
	    constant:
	       'true false iota nil',
	    typename:
	      'bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 ' +
	      'uint16 uint32 uint64 int uint uintptr rune',
	    built_in:
	      'append cap close complex copy imag len make new panic print println real recover delete'
	  };
	  return {
	    aliases: ["golang"],
	    keywords: GO_KEYWORDS,
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'', end: '[^\\\\]\''
	      },
	      {
	        className: 'string',
	        begin: '`', end: '`'
	      },
	      {
	        className: 'number',
	        begin: hljs.C_NUMBER_RE + '[dflsi]?',
	        relevance: 0
	      },
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    return {
	      keywords: {
	        keyword:
	          'println readln print import module function local return let var ' +
	          'while for foreach times in case when match with break continue ' +
	          'augment augmentation each find filter reduce ' +
	          'if then else otherwise try catch finally raise throw orIfNull',
	        typename:
	          'DynamicObject|10 DynamicVariable struct Observable map set vector list array',
	        literal:
	          'true false null'
	      },
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        hljs.QUOTE_STRING_MODE,
	        hljs.C_NUMBER_MODE,
	        {
	          className: 'annotation', begin: '@[A-Za-z]+'
	        }
	      ]
	    }
	};

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'task project allprojects subprojects artifacts buildscript configurations ' +
	        'dependencies repositories sourceSets description delete from into include ' +
	        'exclude source classpath destinationDir includes options sourceCompatibility ' +
	        'targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant ' +
	        'def abstract break case catch continue default do else extends final finally ' +
	        'for if implements instanceof native new private protected public return static ' +
	        'switch synchronized throw throws transient try volatile while strictfp package ' +
	        'import false null super this true antlrtask checkstyle codenarc copy boolean ' +
	        'byte char class double float int interface long short void compile runTime ' +
	        'file fileTree abs any append asList asWritable call collect compareTo count ' +
	        'div dump each eachByte eachFile eachLine every find findAll flatten getAt ' +
	        'getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods ' +
	        'isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter ' +
	        'newReader newWriter next plus pop power previous print println push putAt read ' +
	        'readBytes readLines reverse reverseEach round size sort splitEachLine step subMap ' +
	        'times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader ' +
	        'withStream withWriter withWriterAppend write writeLine'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.REGEXP_MODE
	
	    ]
	  }
	};

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    return {
	        keywords: {
	            typename: 'byte short char int long boolean float double void',
	            literal : 'true false null',
	            keyword:
	            // groovy specific keywords
	            'def as in assert trait ' +
	            // common keywords with Java
	            'super this abstract static volatile transient public private protected synchronized final ' +
	            'class interface enum if else for while switch case break default continue ' +
	            'throw throws try catch finally implements extends new import package return instanceof'
	        },
	
	        contains: [
	            hljs.COMMENT(
	                '/\\*\\*',
	                '\\*/',
	                {
	                    relevance : 0,
	                    contains : [{
	                        className : 'doctag',
	                        begin : '@[A-Za-z]+'
	                    }]
	                }
	            ),
	            hljs.C_LINE_COMMENT_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            {
	                className: 'string',
	                begin: '"""', end: '"""'
	            },
	            {
	                className: 'string',
	                begin: "'''", end: "'''"
	            },
	            {
	                className: 'string',
	                begin: "\\$/", end: "/\\$",
	                relevance: 10
	            },
	            hljs.APOS_STRING_MODE,
	            {
	                className: 'regexp',
	                begin: /~?\/[^\/\n]+\//,
	                contains: [
	                    hljs.BACKSLASH_ESCAPE
	                ]
	            },
	            hljs.QUOTE_STRING_MODE,
	            {
	                className: 'shebang',
	                begin: "^#!/usr/bin/env", end: '$',
	                illegal: '\n'
	            },
	            hljs.BINARY_NUMBER_MODE,
	            {
	                className: 'class',
	                beginKeywords: 'class interface trait enum', end: '{',
	                illegal: ':',
	                contains: [
	                    {beginKeywords: 'extends implements'},
	                    hljs.UNDERSCORE_TITLE_MODE,
	                ]
	            },
	            hljs.C_NUMBER_MODE,
	            {
	                className: 'annotation', begin: '@[A-Za-z]+'
	            },
	            {
	                // highlight map keys and named parameters as strings
	                className: 'string', begin: /[^\?]{0}[A-Za-z0-9_$]+ *:/
	            },
	            {
	                // catch middle element of the ternary operator
	                // to avoid highlight it as a label, named parameter, or map key
	                begin: /\?/, end: /\:/
	            },
	            {
	                // highlight labeled statements
	                className: 'label', begin: '^\\s*[A-Za-z0-9_$]+:',
	                relevance: 0
	            },
	        ],
	        illegal: /#/
	    }
	};

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	module.exports = // TODO support filter tags like :javascript, support inline HTML
	function(hljs) {
	  return {
	    case_insensitive: true,
	    contains: [
	      {
	        className: 'doctype',
	        begin: '^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$',
	        relevance: 10
	      },
	      // FIXME these comments should be allowed to span indented lines
	      hljs.COMMENT(
	        '^\\s*(!=#|=#|-#|/).*$',
	        false,
	        {
	          relevance: 0
	        }
	      ),
	      {
	        begin: '^\\s*(-|=|!=)(?!#)',
	        starts: {
	          end: '\\n',
	          subLanguage: 'ruby'
	        }
	      },
	      {
	        className: 'tag',
	        begin: '^\\s*%',
	        contains: [
	          {
	            className: 'title',
	            begin: '\\w+'
	          },
	          {
	            className: 'value',
	            begin: '[#\\.][\\w-]+'
	          },
	          {
	            begin: '{\\s*',
	            end: '\\s*}',
	            excludeEnd: true,
	            contains: [
	              {
	                //className: 'attribute',
	                begin: ':\\w+\\s*=>',
	                end: ',\\s+',
	                returnBegin: true,
	                endsWithParent: true,
	                contains: [
	                  {
	                    className: 'symbol',
	                    begin: ':\\w+'
	                  },
	                  hljs.APOS_STRING_MODE,
	                  hljs.QUOTE_STRING_MODE,
	                  {
	                    begin: '\\w+',
	                    relevance: 0
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            begin: '\\(\\s*',
	            end: '\\s*\\)',
	            excludeEnd: true,
	            contains: [
	              {
	                //className: 'attribute',
	                begin: '\\w+\\s*=',
	                end: '\\s+',
	                returnBegin: true,
	                endsWithParent: true,
	                contains: [
	                  {
	                    className: 'attribute',
	                    begin: '\\w+',
	                    relevance: 0
	                  },
	                  hljs.APOS_STRING_MODE,
	                  hljs.QUOTE_STRING_MODE,
	                  {
	                    begin: '\\w+',
	                    relevance: 0
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      },
	      {
	        className: 'bullet',
	        begin: '^\\s*[=~]\\s*',
	        relevance: 0
	      },
	      {
	        begin: '#{',
	        starts: {
	          end: '}',
	          subLanguage: 'ruby'
	        }
	      }
	    ]
	  };
	};

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var EXPRESSION_KEYWORDS = 'each in with if else unless bindattr action collection debugger log outlet template unbound view yield';
	  return {
	    aliases: ['hbs', 'html.hbs', 'html.handlebars'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      {
	        className: 'expression',
	        begin: '{{', end: '}}',
	        contains: [
	          {
	            className: 'begin-block', begin: '\#[a-zA-Z\-\ \.]+',
	            keywords: EXPRESSION_KEYWORDS
	          },
	          {
	            className: 'string',
	            begin: '"', end: '"'
	          },
	          {
	            className: 'end-block', begin: '\\\/[a-zA-Z\-\ \.]+',
	            keywords: EXPRESSION_KEYWORDS
	          },
	          {
	            className: 'variable', begin: '[a-zA-Z\-\.]+',
	            keywords: EXPRESSION_KEYWORDS
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT_MODES = [
	    hljs.COMMENT('--', '$'),
	    hljs.COMMENT(
	      '{-',
	      '-}',
	      {
	        contains: ['self']
	      }
	    )
	  ];
	
	  var PRAGMA = {
	    className: 'pragma',
	    begin: '{-#', end: '#-}'
	  };
	
	  var PREPROCESSOR = {
	    className: 'preprocessor',
	    begin: '^#', end: '$'
	  };
	
	  var CONSTRUCTOR = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (build-in, infix).
	    relevance: 0
	  };
	
	  var LIST = {
	    className: 'container',
	    begin: '\\(', end: '\\)',
	    illegal: '"',
	    contains: [
	      PRAGMA,
	      PREPROCESSOR,
	      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
	      hljs.inherit(hljs.TITLE_MODE, {begin: '[_a-z][\\w\']*'})
	    ].concat(COMMENT_MODES)
	  };
	
	  var RECORD = {
	    className: 'container',
	    begin: '{', end: '}',
	    contains: LIST.contains
	  };
	
	  return {
	    aliases: ['hs'],
	    keywords:
	      'let in if then else case of where do module import hiding ' +
	      'qualified type data newtype deriving class instance as default ' +
	      'infix infixl infixr foreign export ccall stdcall cplusplus ' +
	      'jvm dotnet safe unsafe family forall mdo proc rec',
	    contains: [
	
	      // Top-level constructions.
	
	      {
	        className: 'module',
	        begin: '\\bmodule\\b', end: 'where',
	        keywords: 'module where',
	        contains: [LIST].concat(COMMENT_MODES),
	        illegal: '\\W\\.|;'
	      },
	      {
	        className: 'import',
	        begin: '\\bimport\\b', end: '$',
	        keywords: 'import|0 qualified as hiding',
	        contains: [LIST].concat(COMMENT_MODES),
	        illegal: '\\W\\.|;'
	      },
	
	      {
	        className: 'class',
	        begin: '^(\\s*)?(class|instance)\\b', end: 'where',
	        keywords: 'class family instance where',
	        contains: [CONSTRUCTOR, LIST].concat(COMMENT_MODES)
	      },
	      {
	        className: 'typedef',
	        begin: '\\b(data|(new)?type)\\b', end: '$',
	        keywords: 'data family type newtype deriving',
	        contains: [PRAGMA, CONSTRUCTOR, LIST, RECORD].concat(COMMENT_MODES)
	      },
	      {
	        className: 'default',
	        beginKeywords: 'default', end: '$',
	        contains: [CONSTRUCTOR, LIST].concat(COMMENT_MODES)
	      },
	      {
	        className: 'infix',
	        beginKeywords: 'infix infixl infixr', end: '$',
	        contains: [hljs.C_NUMBER_MODE].concat(COMMENT_MODES)
	      },
	      {
	        className: 'foreign',
	        begin: '\\bforeign\\b', end: '$',
	        keywords: 'foreign import export ccall stdcall cplusplus jvm ' +
	                  'dotnet safe unsafe',
	        contains: [CONSTRUCTOR, hljs.QUOTE_STRING_MODE].concat(COMMENT_MODES)
	      },
	      {
	        className: 'shebang',
	        begin: '#!\\/usr\\/bin\\/env\ runhaskell', end: '$'
	      },
	
	      // "Whitespaces".
	
	      PRAGMA,
	      PREPROCESSOR,
	
	      // Literals and names.
	
	      // TODO: characters.
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      CONSTRUCTOR,
	      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),
	
	      {begin: '->|<-'} // No markup, relevance booster
	    ].concat(COMMENT_MODES)
	  };
	};

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
	  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';
	
	  return {
	    aliases: ['hx'],
	    keywords: {
	      keyword: 'break callback case cast catch class continue default do dynamic else enum extends extern ' +
	    'for function here if implements import in inline interface never new override package private ' +
	    'public return static super switch this throw trace try typedef untyped using var while',
	      literal: 'true false null'
	    },
	    contains: [
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.TITLE_MODE
	        ]
	      },
	      {
	        className: 'preprocessor',
	        begin: '#', end: '$',
	        keywords: 'if else elseif end error'
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
	        illegal: '\\S',
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          {
	            className: 'type',
	            begin: ':',
	            end: IDENT_FUNC_RETURN_TYPE_RE,
	            relevance: 10
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['https'],
	    illegal: '\\S',
	    contains: [
	      {
	        className: 'status',
	        begin: '^HTTP/[0-9\\.]+', end: '$',
	        contains: [{className: 'number', begin: '\\b\\d{3}\\b'}]
	      },
	      {
	        className: 'request',
	        begin: '^[A-Z]+ (.*?) HTTP/[0-9\\.]+$', returnBegin: true, end: '$',
	        contains: [
	          {
	            className: 'string',
	            begin: ' ', end: ' ',
	            excludeBegin: true, excludeEnd: true
	          }
	        ]
	      },
	      {
	        className: 'attribute',
	        begin: '^\\w', end: ': ', excludeEnd: true,
	        illegal: '\\n|\\s|=',
	        starts: {className: 'string', end: '$'}
	      },
	      {
	        begin: '\\n\\n',
	        starts: {subLanguage: [], endsWithParent: true}
	      }
	    ]
	  };
	};

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var START_BRACKET = '\\[';
	  var END_BRACKET = '\\]';
	  return {
	    aliases: ['i7'],
	    case_insensitive: true,
	    keywords: {
	      // Some keywords more or less unique to I7, for relevance.
	      keyword:
	        // kind:
	        'thing room person man woman animal container ' +
	        'supporter backdrop door ' +
	        // characteristic:
	        'scenery open closed locked inside gender ' +
	        // verb:
	        'is are say understand ' +
	        // misc keyword:
	        'kind of rule'
	    },
	    contains: [
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        relevance: 0,
	        contains: [
	          {
	            className: 'subst',
	            begin: START_BRACKET, end: END_BRACKET
	          }
	        ]
	      },
	      {
	        className: 'title',
	        begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
	        end: '$'
	      },
	      {
	        // Rule definition
	        // This is here for relevance.
	        begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
	        end: ':',
	        contains: [
	          {
	            //Rule name
	            begin: '\\b\\(This',
	            end: '\\)'
	          }
	        ]
	      },
	      {
	        className: 'comment',
	        begin: START_BRACKET, end: END_BRACKET,
	        contains: ['self']
	      }
	    ]
	  };
	};

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STRING = {
	    className: "string",
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: "'''", end: "'''",
	        relevance: 10
	      }, {
	        begin: '"""', end: '"""',
	        relevance: 10
	      }, {
	        begin: '"', end: '"'
	      }, {
	        begin: "'", end: "'"
	      }
	    ]
	  };
	  return {
	    aliases: ['toml'],
	    case_insensitive: true,
	    illegal: /\S/,
	    contains: [
	      hljs.COMMENT(';', '$'),
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'title',
	        begin: /^\s*\[+/, end: /\]+/
	      },
	      {
	        className: 'setting',
	        begin: /^[a-z0-9\[\]_-]+\s*=\s*/, end: '$',
	        contains: [
	          {
	            className: 'value',
	            endsWithParent: true,
	            keywords: 'on off true false yes no',
	            contains: [
	              {
	                className: 'variable',
	                variants: [
	                  {begin: /\$[\w\d"][\w\d_]*/},
	                  {begin: /\$\{(.*?)}/}
	                ]
	              },
	              STRING,
	              {
	                className: 'number',
	                begin: /([\+\-]+)?[\d]+_[\d_]+/
	              },
	              hljs.NUMBER_MODE
	            ],
	            relevance: 0
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)'
	  };
	
	  var F_KEYWORDS = {
	    constant: '.False. .True.',
	    type: 'integer real character complex logical dimension allocatable|10 parameter ' +
	      'external implicit|10 none double precision assign intent optional pointer ' +
	      'target in out common equivalence data',
	    keyword: 'kind do while private call intrinsic where elsewhere ' +
	      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
	      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
	      'goto save else use module select case ' +
	      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
	      'continue format pause cycle exit ' +
	      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
	      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
	      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
	      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
	      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
	      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
	      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
	      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
	      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
	      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
	      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
	      // IRPF90 special keywords
	      'begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch ' +
	      'soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read',
	    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
	      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
	      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
	      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
	      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
	      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
	      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
	      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
	      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
	      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
	      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
	      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
	      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
	      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
	      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
	      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
	      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
	      'num_images parity popcnt poppar shifta shiftl shiftr this_image ' +
	      // IRPF90 special built_ins
	      'IRP_ALIGN irp_here'
	  };
	  return {
	    case_insensitive: true,
	    keywords: F_KEYWORDS,
	    illegal: /\/\*/,
	    contains: [
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
	      {
	        className: 'function',
	        beginKeywords: 'subroutine function program',
	        illegal: '[${=\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      },
	      hljs.COMMENT('!', '$', {relevance: 0}),
	      hljs.COMMENT('begin_doc', 'end_doc', {relevance: 10}),
	      {
	        className: 'number',
	        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var GENERIC_IDENT_RE = hljs.UNDERSCORE_IDENT_RE + '(<' + hljs.UNDERSCORE_IDENT_RE + '>)?';
	  var KEYWORDS =
	    'false synchronized int abstract float private char boolean static null if const ' +
	    'for true while long strictfp finally protected import native final void ' +
	    'enum else break transient catch instanceof byte super volatile case assert short ' +
	    'package default double public try this switch continue throws protected public private';
	
	  // https://docs.oracle.com/javase/7/docs/technotes/guides/language/underscores-literals.html
	  var JAVA_NUMBER_RE = '\\b' +
	    '(' +
	      '0[bB]([01]+[01_]+[01]+|[01]+)' + // 0b...
	      '|' +
	      '0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)' + // 0x...
	      '|' +
	      '(' +
	        '([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?' +
	        '|' +
	        '\\.([\\d]+[\\d_]+[\\d]+|[\\d]+)' +
	      ')' +
	      '([eE][-+]?\\d+)?' + // octal, decimal, float
	    ')' +
	    '[lLfF]?';
	  var JAVA_NUMBER_MODE = {
	    className: 'number',
	    begin: JAVA_NUMBER_RE,
	    relevance: 0
	  };
	
	  return {
	    aliases: ['jsp'],
	    keywords: KEYWORDS,
	    illegal: /<\/|#/,
	    contains: [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [{
	            className : 'doctag',
	            begin : '@[A-Za-z]+'
	          }]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: /[{;=]/, excludeEnd: true,
	        keywords: 'class interface',
	        illegal: /[:"\[\]]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...)' from being
	        // recognized as a function definition
	        beginKeywords: 'new throw return else',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
	            relevance: 0,
	            contains: [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      JAVA_NUMBER_MODE,
	      {
	        className: 'annotation', begin: '@[A-Za-z]+'
	      }
	    ]
	  };
	};

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['js'],
	    keywords: {
	      keyword:
	        'in of if for while finally var new function do return void else break catch ' +
	        'instanceof with throw case default try this switch continue typeof delete ' +
	        'let yield const export super debugger as async await',
	      literal:
	        'true false null undefined NaN Infinity',
	      built_in:
	        'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
	        'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
	        'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
	        'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
	        'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
	        'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
	        'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
	        'Promise'
	    },
	    contains: [
	      {
	        className: 'pi',
	        relevance: 10,
	        begin: /^\s*['"]use (strict|asm)['"]/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      { // template string
	        className: 'string',
	        begin: '`', end: '`',
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          {
	            className: 'subst',
	            begin: '\\$\\{', end: '\\}'
	          }
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b(0[bB][01]+)' },
	          { begin: '\\b(0[oO][0-7]+)' },
	          { begin: hljs.C_NUMBER_RE }
	        ],
	        relevance: 0
	      },
	      { // "value" container
	        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
	        keywords: 'return throw case',
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.REGEXP_MODE,
	          { // E4X / JSX
	            begin: /</, end: />\s*[);\]]/,
	            relevance: 0,
	            subLanguage: 'xml'
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /\{/, excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
	      },
	      {
	        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
	      },
	      // ECMAScript 6 modules import
	      {
	        beginKeywords: 'import', end: '[;$]',
	        keywords: 'import from as',
	        contains: [
	          hljs.APOS_STRING_MODE,
	          hljs.QUOTE_STRING_MODE
	        ]
	      },
	      { // ES6 class
	        className: 'class',
	        beginKeywords: 'class', end: /[{;=]/, excludeEnd: true,
	        illegal: /[:"\[\]]/,
	        contains: [
	          {beginKeywords: 'extends'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      }
	    ],
	    illegal: /#/
	  };
	};

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var LITERALS = {literal: 'true false null'};
	  var TYPES = [
	    hljs.QUOTE_STRING_MODE,
	    hljs.C_NUMBER_MODE
	  ];
	  var VALUE_CONTAINER = {
	    className: 'value',
	    end: ',', endsWithParent: true, excludeEnd: true,
	    contains: TYPES,
	    keywords: LITERALS
	  };
	  var OBJECT = {
	    begin: '{', end: '}',
	    contains: [
	      {
	        className: 'attribute',
	        begin: '\\s*"', end: '"\\s*:\\s*', excludeBegin: true, excludeEnd: true,
	        contains: [hljs.BACKSLASH_ESCAPE],
	        illegal: '\\n',
	        starts: VALUE_CONTAINER
	      }
	    ],
	    illegal: '\\S'
	  };
	  var ARRAY = {
	    begin: '\\[', end: '\\]',
	    contains: [hljs.inherit(VALUE_CONTAINER, {className: null})], // inherit is also a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
	    illegal: '\\S'
	  };
	  TYPES.splice(TYPES.length, 0, OBJECT, ARRAY);
	  return {
	    contains: TYPES,
	    keywords: LITERALS,
	    illegal: '\\S'
	  };
	};

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  // Since there are numerous special names in Julia, it is too much trouble
	  // to maintain them by hand. Hence these names (i.e. keywords, literals and
	  // built-ins) are automatically generated from Julia (v0.3.0) itself through
	  // following scripts for each.
	
	  var KEYWORDS = {
	    // # keyword generator
	    // println("\"in\",")
	    // for kw in Base.REPLCompletions.complete_keyword("")
	    //     println("\"$kw\",")
	    // end
	    keyword:
	      'in abstract baremodule begin bitstype break catch ccall const continue do else elseif end export ' +
	      'finally for function global if immutable import importall let local macro module quote return try type ' +
	      'typealias using while',
	
	    // # literal generator
	    // println("\"true\",\n\"false\"")
	    // for name in Base.REPLCompletions.completions("", 0)[1]
	    //     try
	    //         s = symbol(name)
	    //         v = eval(s)
	    //         if !isa(v, Function) &&
	    //            !isa(v, DataType) &&
	    //            !issubtype(typeof(v), Tuple) &&
	    //            !isa(v, UnionType) &&
	    //            !isa(v, Module) &&
	    //            !isa(v, TypeConstructor) &&
	    //            !isa(v, Colon)
	    //             println("\"$name\",")
	    //         end
	    //     end
	    // end
	    literal:
	      'true false ANY ARGS CPU_CORES C_NULL DL_LOAD_PATH DevNull ENDIAN_BOM ENV I|0 Inf Inf16 Inf32 ' +
	      'InsertionSort JULIA_HOME LOAD_PATH MS_ASYNC MS_INVALIDATE MS_SYNC MergeSort NaN NaN16 NaN32 OS_NAME QuickSort ' +
	      'RTLD_DEEPBIND RTLD_FIRST RTLD_GLOBAL RTLD_LAZY RTLD_LOCAL RTLD_NODELETE RTLD_NOLOAD RTLD_NOW RoundDown ' +
	      'RoundFromZero RoundNearest RoundToZero RoundUp STDERR STDIN STDOUT VERSION WORD_SIZE catalan cglobal e|0 eu|0 ' +
	      'eulergamma golden im nothing pi γ π φ',
	
	    // # built_in generator:
	    // for name in Base.REPLCompletions.completions("", 0)[1]
	    //     try
	    //         v = eval(symbol(name))
	    //         if isa(v, DataType)
	    //             println("\"$name\",")
	    //         end
	    //     end
	    // end
	    built_in:
	      'ASCIIString AbstractArray AbstractRNG AbstractSparseArray Any ArgumentError Array Associative Base64Pipe ' +
	      'Bidiagonal BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError Box CFILE Cchar Cdouble Cfloat Char ' +
	      'CharString Cint Clong Clonglong ClusterManager Cmd Coff_t Colon Complex Complex128 Complex32 Complex64 ' +
	      'Condition Cptrdiff_t Cshort Csize_t Cssize_t Cuchar Cuint Culong Culonglong Cushort Cwchar_t DArray DataType ' +
	      'DenseArray Diagonal Dict DimensionMismatch DirectIndexString Display DivideError DomainError EOFError ' +
	      'EachLine Enumerate ErrorException Exception Expr Factorization FileMonitor FileOffset Filter Float16 Float32 ' +
	      'Float64 FloatRange FloatingPoint Function GetfieldNode GotoNode Hermitian IO IOBuffer IOStream IPv4 IPv6 ' +
	      'InexactError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException IntrinsicFunction KeyError ' +
	      'LabelNode LambdaStaticData LineNumberNode LoadError LocalProcess MIME MathConst MemoryError MersenneTwister ' +
	      'Method MethodError MethodTable Module NTuple NewvarNode Nothing Number ObjectIdDict OrdinalRange ' +
	      'OverflowError ParseError PollingFileWatcher ProcessExitedException ProcessGroup Ptr QuoteNode Range Range1 ' +
	      'Ranges Rational RawFD Real Regex RegexMatch RemoteRef RepString RevString RopeString RoundingMode Set ' +
	      'SharedArray Signed SparseMatrixCSC StackOverflowError Stat StatStruct StepRange String SubArray SubString ' +
	      'SymTridiagonal Symbol SymbolNode Symmetric SystemError Task TextDisplay Timer TmStruct TopNode Triangular ' +
	      'Tridiagonal Type TypeConstructor TypeError TypeName TypeVar UTF16String UTF32String UTF8String UdpSocket ' +
	      'Uint Uint128 Uint16 Uint32 Uint64 Uint8 UndefRefError UndefVarError UniformScaling UnionType UnitRange ' +
	      'Unsigned Vararg VersionNumber WString WeakKeyDict WeakRef Woodbury Zip'
	  };
	
	  // ref: http://julia.readthedocs.org/en/latest/manual/variables/#allowed-variable-names
	  var VARIABLE_NAME_RE = "[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*";
	
	  // placeholder for recursive self-reference
	  var DEFAULT = { lexemes: VARIABLE_NAME_RE, keywords: KEYWORDS };
	
	  var TYPE_ANNOTATION = {
	    className: "type-annotation",
	    begin: /::/
	  };
	
	  var SUBTYPE = {
	    className: "subtype",
	    begin: /<:/
	  };
	
	  // ref: http://julia.readthedocs.org/en/latest/manual/integers-and-floating-point-numbers/
	  var NUMBER = {
	    className: "number",
	    // supported numeric literals:
	    //  * binary literal (e.g. 0x10)
	    //  * octal literal (e.g. 0o76543210)
	    //  * hexadecimal literal (e.g. 0xfedcba876543210)
	    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
	    //  * decimal literal (e.g. 9876543210, 100_000_000)
	    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
	    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
	    relevance: 0
	  };
	
	  var CHAR = {
	    className: "char",
	    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
	  };
	
	  var INTERPOLATION = {
	    className: 'subst',
	    begin: /\$\(/, end: /\)/,
	    keywords: KEYWORDS
	  };
	
	  var INTERPOLATED_VARIABLE = {
	    className: 'variable',
	    begin: "\\$" + VARIABLE_NAME_RE
	  };
	
	  // TODO: neatly escape normal code in string literal
	  var STRING = {
	    className: "string",
	    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
	    variants: [
	      { begin: /\w*"/, end: /"\w*/ },
	      { begin: /\w*"""/, end: /"""\w*/ }
	    ]
	  };
	
	  var COMMAND = {
	    className: "string",
	    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
	    begin: '`', end: '`'
	  };
	
	  var MACROCALL = {
	    className: "macrocall",
	    begin: "@" + VARIABLE_NAME_RE
	  };
	
	  var COMMENT = {
	    className: "comment",
	    variants: [
	      { begin: "#=", end: "=#", relevance: 10 },
	      { begin: '#', end: '$' }
	    ]
	  };
	
	  DEFAULT.contains = [
	    NUMBER,
	    CHAR,
	    TYPE_ANNOTATION,
	    SUBTYPE,
	    STRING,
	    COMMAND,
	    MACROCALL,
	    COMMENT,
	    hljs.HASH_COMMENT_MODE
	  ];
	  INTERPOLATION.contains = DEFAULT.contains;
	
	  return DEFAULT;
	};

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var KEYWORDS = 'val var get set class trait object public open private protected ' +
	    'final enum if else do while for when break continue throw try catch finally ' +
	    'import package is as in return fun override default companion reified inline volatile transient native';
	
	  return {
	    keywords: {
	      typename: 'Byte Short Char Int Long Boolean Float Double Void Unit Nothing',
	      literal: 'true false null',
	      keyword: KEYWORDS
	    },
	    contains : [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [{
	            className : 'doctag',
	            begin : '@[A-Za-z]+'
	          }]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'type',
	        begin: /</, end: />/,
	        returnBegin: true,
	        excludeEnd: false,
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'fun', end: '[(]|$',
	        returnBegin: true,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        illegal: /fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,
	        relevance: 5,
	        contains: [
	          {
	            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
	            relevance: 0,
	            contains: [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className: 'type',
	            begin: /</, end: />/, keywords: 'reified',
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: KEYWORDS,
	            relevance: 0,
	            illegal: /\([^\(,\s:]+,/,
	            contains: [
	              {
	                className: 'typename',
	                begin: /:\s*/, end: /\s*[=\)]/, excludeBegin: true, returnEnd: true,
	                relevance: 0
	              }
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class trait', end: /[:\{(]|$/,
	        excludeEnd: true,
	        illegal: 'extends implements',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'type',
	            begin: /</, end: />/, excludeBegin: true, excludeEnd: true,
	            relevance: 0
	          },
	          {
	            className: 'typename',
	            begin: /[,:]\s*/, end: /[<\(,]|$/, excludeBegin: true, returnEnd: true
	          }
	        ]
	      },
	      {
	        className: 'variable', beginKeywords: 'var val', end: /\s*[=:$]/, excludeEnd: true
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'shebang',
	        begin: "^#!/usr/bin/env", end: '$',
	        illegal: '\n'
	      },
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var LASSO_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9_.]*';
	  var LASSO_ANGLE_RE = '<\\?(lasso(script)?|=)';
	  var LASSO_CLOSE_RE = '\\]|\\?>';
	  var LASSO_KEYWORDS = {
	    literal:
	      'true false none minimal full all void ' +
	      'bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft',
	    built_in:
	      'array date decimal duration integer map pair string tag xml null ' +
	      'boolean bytes keyword list locale queue set stack staticarray ' +
	      'local var variable global data self inherited currentcapture givenblock',
	    keyword:
	      'error_code error_msg error_pop error_push error_reset cache ' +
	      'database_names database_schemanames database_tablenames define_tag ' +
	      'define_type email_batch encode_set html_comment handle handle_error ' +
	      'header if inline iterate ljax_target link link_currentaction ' +
	      'link_currentgroup link_currentrecord link_detail link_firstgroup ' +
	      'link_firstrecord link_lastgroup link_lastrecord link_nextgroup ' +
	      'link_nextrecord link_prevgroup link_prevrecord log loop ' +
	      'namespace_using output_none portal private protect records referer ' +
	      'referrer repeating resultset rows search_args search_arguments ' +
	      'select sort_args sort_arguments thread_atomic value_list while ' +
	      'abort case else if_empty if_false if_null if_true loop_abort ' +
	      'loop_continue loop_count params params_up return return_value ' +
	      'run_children soap_definetag soap_lastrequest soap_lastresponse ' +
	      'tag_name ascending average by define descending do equals ' +
	      'frozen group handle_failure import in into join let match max ' +
	      'min on order parent protected provide public require returnhome ' +
	      'skip split_thread sum take thread to trait type where with ' +
	      'yield yieldhome'
	  };
	  var HTML_COMMENT = hljs.COMMENT(
	    '<!--',
	    '-->',
	    {
	      relevance: 0
	    }
	  );
	  var LASSO_NOPROCESS = {
	    className: 'preprocessor',
	    begin: '\\[noprocess\\]',
	    starts: {
	      className: 'markup',
	      end: '\\[/noprocess\\]',
	      returnEnd: true,
	      contains: [HTML_COMMENT]
	    }
	  };
	  var LASSO_START = {
	    className: 'preprocessor',
	    begin: '\\[/noprocess|' + LASSO_ANGLE_RE
	  };
	  var LASSO_DATAMEMBER = {
	    className: 'variable',
	    begin: '\'' + LASSO_IDENT_RE + '\''
	  };
	  var LASSO_CODE = [
	    hljs.COMMENT(
	      '/\\*\\*!',
	      '\\*/'
	    ),
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.inherit(hljs.C_NUMBER_MODE, {begin: hljs.C_NUMBER_RE + '|(infinity|nan)\\b'}),
	    hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	    hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	    {
	      className: 'string',
	      begin: '`', end: '`'
	    },
	    {
	      className: 'variable',
	      variants: [
	        {
	          begin: '[#$]' + LASSO_IDENT_RE
	        },
	        {
	          begin: '#', end: '\\d+',
	          illegal: '\\W'
	        }
	      ]
	    },
	    {
	      className: 'tag',
	      begin: '::\\s*', end: LASSO_IDENT_RE,
	      illegal: '\\W'
	    },
	    {
	      className: 'attribute',
	      variants: [
	        {
	          begin: '-(?!infinity)' + hljs.UNDERSCORE_IDENT_RE,
	          relevance: 0
	        },
	        {
	          begin: '(\\.\\.\\.)'
	        }
	      ]
	    },
	    {
	      className: 'subst',
	      variants: [
	        {
	          begin: '->\\s*',
	          contains: [LASSO_DATAMEMBER]
	        },
	        {
	          begin: '->|\\\\|&&?|\\|\\||!(?!=|>)|(and|or|not)\\b',
	          relevance: 0
	        }
	      ]
	    },
	    {
	      className: 'built_in',
	      begin: '\\.\\.?\\s*',
	      relevance: 0,
	      contains: [LASSO_DATAMEMBER]
	    },
	    {
	      className: 'class',
	      beginKeywords: 'define',
	      returnEnd: true, end: '\\(|=>',
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: hljs.UNDERSCORE_IDENT_RE + '(=(?!>))?'})
	      ]
	    }
	  ];
	  return {
	    aliases: ['ls', 'lassoscript'],
	    case_insensitive: true,
	    lexemes: LASSO_IDENT_RE + '|&[lg]t;',
	    keywords: LASSO_KEYWORDS,
	    contains: [
	      {
	        className: 'preprocessor',
	        begin: LASSO_CLOSE_RE,
	        relevance: 0,
	        starts: {
	          className: 'markup',
	          end: '\\[|' + LASSO_ANGLE_RE,
	          returnEnd: true,
	          relevance: 0,
	          contains: [HTML_COMMENT]
	        }
	      },
	      LASSO_NOPROCESS,
	      LASSO_START,
	      {
	        className: 'preprocessor',
	        begin: '\\[no_square_brackets',
	        starts: {
	          end: '\\[/no_square_brackets\\]', // not implemented in the language
	          lexemes: LASSO_IDENT_RE + '|&[lg]t;',
	          keywords: LASSO_KEYWORDS,
	          contains: [
	            {
	              className: 'preprocessor',
	              begin: LASSO_CLOSE_RE,
	              relevance: 0,
	              starts: {
	                className: 'markup',
	                end: '\\[noprocess\\]|' + LASSO_ANGLE_RE,
	                returnEnd: true,
	                contains: [HTML_COMMENT]
	              }
	            },
	            LASSO_NOPROCESS,
	            LASSO_START
	          ].concat(LASSO_CODE)
	        }
	      },
	      {
	        className: 'preprocessor',
	        begin: '\\[',
	        relevance: 0
	      },
	      {
	        className: 'shebang',
	        begin: '^#!.+lasso9\\b',
	        relevance: 10
	      }
	    ].concat(LASSO_CODE)
	  };
	};

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE        = '[\\w-]+'; // yes, Less identifiers may begin with a digit
	  var INTERP_IDENT_RE = '(' + IDENT_RE + '|@{' + IDENT_RE + '})';
	
	  /* Generic Modes */
	
	  var RULES = [], VALUE = []; // forward def. for recursive modes
	
	  var STRING_MODE = function(c) { return {
	    // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
	    className: 'string', begin: '~?' + c + '.*?' + c
	  };};
	
	  var IDENT_MODE = function(name, begin, relevance) { return {
	    className: name, begin: begin, relevance: relevance
	  };};
	
	  var FUNCT_MODE = function(name, ident, obj) {
	    return hljs.inherit({
	        className: name, begin: ident + '\\(', end: '\\(',
	        returnBegin: true, excludeEnd: true, relevance: 0
	    }, obj);
	  };
	
	  var PARENS_MODE = {
	    // used only to properly balance nested parens inside mixin call, def. arg list
	    begin: '\\(', end: '\\)', contains: VALUE, relevance: 0
	  };
	
	  // generic Less highlighter (used almost everywhere except selectors):
	  VALUE.push(
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    STRING_MODE("'"),
	    STRING_MODE('"'),
	    hljs.CSS_NUMBER_MODE, // fixme: it does not include dot for numbers like .5em :(
	    IDENT_MODE('hexcolor', '#[0-9A-Fa-f]+\\b'),
	    FUNCT_MODE('function', '(url|data-uri)', {
	      starts: {className: 'string', end: '[\\)\\n]', excludeEnd: true}
	    }),
	    FUNCT_MODE('function', IDENT_RE),
	    PARENS_MODE,
	    IDENT_MODE('variable', '@@?' + IDENT_RE, 10),
	    IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),
	    IDENT_MODE('built_in', '~?`[^`]*?`'), // inline javascript (or whatever host language) *multiline* string
	    { // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
	      className: 'attribute', begin: IDENT_RE + '\\s*:', end: ':', returnBegin: true, excludeEnd: true
	    }
	  );
	
	  var VALUE_WITH_RULESETS = VALUE.concat({
	    begin: '{', end: '}', contains: RULES
	  });
	
	  var MIXIN_GUARD_MODE = {
	    beginKeywords: 'when', endsWithParent: true,
	    contains: [{beginKeywords: 'and not'}].concat(VALUE) // using this form to override VALUE’s 'function' match
	  };
	
	  /* Rule-Level Modes */
	
	  var RULE_MODE = {
	    className: 'attribute',
	    begin: INTERP_IDENT_RE, end: ':', excludeEnd: true,
	    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE],
	    illegal: /\S/,
	    starts: {end: '[;}]', returnEnd: true, contains: VALUE, illegal: '[<=$]'}
	  };
	
	  var AT_RULE_MODE = {
	    className: 'at_rule', // highlight only at-rule keyword
	    begin: '@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b',
	    starts: {end: '[;{}]', returnEnd: true, contains: VALUE, relevance: 0}
	  };
	
	  // variable definitions and calls
	  var VAR_RULE_MODE = {
	    className: 'variable',
	    variants: [
	      // using more strict pattern for higher relevance to increase chances of Less detection.
	      // this is *the only* Less specific statement used in most of the sources, so...
	      // (we’ll still often loose to the css-parser unless there's '//' comment,
	      // simply because 1 variable just can't beat 99 properties :)
	      {begin: '@' + IDENT_RE + '\\s*:', relevance: 15},
	      {begin: '@' + IDENT_RE}
	    ],
	    starts: {end: '[;}]', returnEnd: true, contains: VALUE_WITH_RULESETS}
	  };
	
	  var SELECTOR_MODE = {
	    // first parse unambiguous selectors (i.e. those not starting with tag)
	    // then fall into the scary lookahead-discriminator variant.
	    // this mode also handles mixin definitions and calls
	    variants: [{
	      begin: '[\\.#:&\\[]', end: '[;{}]'  // mixin calls end with ';'
	      }, {
	      begin: INTERP_IDENT_RE + '[^;]*{',
	      end: '{'
	    }],
	    returnBegin: true,
	    returnEnd:   true,
	    illegal: '[<=\'$"]',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      MIXIN_GUARD_MODE,
	      IDENT_MODE('keyword',  'all\\b'),
	      IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),     // otherwise it’s identified as tag
	      IDENT_MODE('tag',       INTERP_IDENT_RE + '%?', 0), // '%' for more consistent coloring of @keyframes "tags"
	      IDENT_MODE('id',       '#'   + INTERP_IDENT_RE),
	      IDENT_MODE('class',    '\\.' + INTERP_IDENT_RE, 0),
	      IDENT_MODE('keyword',  '&', 0),
	      FUNCT_MODE('pseudo',   ':not'),
	      FUNCT_MODE('keyword',  ':extend'),
	      IDENT_MODE('pseudo',   '::?' + INTERP_IDENT_RE),
	      {className: 'attr_selector', begin: '\\[', end: '\\]'},
	      {begin: '\\(', end: '\\)', contains: VALUE_WITH_RULESETS}, // argument list of parametric mixins
	      {begin: '!important'} // eat !important after mixin call or it will be colored as tag
	    ]
	  };
	
	  RULES.push(
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    AT_RULE_MODE,
	    VAR_RULE_MODE,
	    SELECTOR_MODE,
	    RULE_MODE
	  );
	
	  return {
	    case_insensitive: true,
	    illegal: '[=>\'/<($"]',
	    contains: RULES
	  };
	};

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var LISP_IDENT_RE = '[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*';
	  var MEC_RE = '\\|[^]*?\\|';
	  var LISP_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?';
	  var SHEBANG = {
	    className: 'shebang',
	    begin: '^#!', end: '$'
	  };
	  var LITERAL = {
	    className: 'literal',
	    begin: '\\b(t{1}|nil)\\b'
	  };
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      {begin: LISP_SIMPLE_NUMBER_RE, relevance: 0},
	      {begin: '#(b|B)[0-1]+(/[0-1]+)?'},
	      {begin: '#(o|O)[0-7]+(/[0-7]+)?'},
	      {begin: '#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?'},
	      {begin: '#(c|C)\\(' + LISP_SIMPLE_NUMBER_RE + ' +' + LISP_SIMPLE_NUMBER_RE, end: '\\)'}
	    ]
	  };
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
	  var COMMENT = hljs.COMMENT(
	    ';', '$',
	    {
	      relevance: 0
	    }
	  );
	  var VARIABLE = {
	    className: 'variable',
	    begin: '\\*', end: '\\*'
	  };
	  var KEYWORD = {
	    className: 'keyword',
	    begin: '[:&]' + LISP_IDENT_RE
	  };
	  var IDENT = {
	    begin: LISP_IDENT_RE,
	    relevance: 0
	  };
	  var MEC = {
	    begin: MEC_RE
	  };
	  var QUOTED_LIST = {
	    begin: '\\(', end: '\\)',
	    contains: ['self', LITERAL, STRING, NUMBER, IDENT]
	  };
	  var QUOTED = {
	    className: 'quoted',
	    contains: [NUMBER, STRING, VARIABLE, KEYWORD, QUOTED_LIST, IDENT],
	    variants: [
	      {
	        begin: '[\'`]\\(', end: '\\)'
	      },
	      {
	        begin: '\\(quote ', end: '\\)',
	        keywords: 'quote'
	      },
	      {
	        begin: '\'' + MEC_RE
	      }
	    ]
	  };
	  var QUOTED_ATOM = {
	    className: 'quoted',
	    variants: [
	      {begin: '\'' + LISP_IDENT_RE},
	      {begin: '#\'' + LISP_IDENT_RE + '(::' + LISP_IDENT_RE + ')*'}
	    ]
	  };
	  var LIST = {
	    className: 'list',
	    begin: '\\(\\s*', end: '\\)'
	  };
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	  LIST.contains = [
	    {
	      className: 'keyword',
	      variants: [
	        {begin: LISP_IDENT_RE},
	        {begin: MEC_RE}
	      ]
	    },
	    BODY
	  ];
	  BODY.contains = [QUOTED, QUOTED_ATOM, LIST, LITERAL, NUMBER, STRING, COMMENT, VARIABLE, KEYWORD, MEC, IDENT];
	
	  return {
	    illegal: /\S/,
	    contains: [
	      NUMBER,
	      SHEBANG,
	      LITERAL,
	      STRING,
	      COMMENT,
	      QUOTED,
	      QUOTED_ATOM,
	      LIST,
	      IDENT
	    ]
	  };
	};

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VARIABLE = {
	    className: 'variable', begin: '\\b[gtps][A-Z]+[A-Za-z0-9_\\-]*\\b|\\$_[A-Z]+',
	    relevance: 0
	  };
	  var COMMENT_MODES = [
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.HASH_COMMENT_MODE,
	    hljs.COMMENT('--', '$'),
	    hljs.COMMENT('[^:]//', '$')
	  ];
	  var TITLE1 = hljs.inherit(hljs.TITLE_MODE, {
	    variants: [
	      {begin: '\\b_*rig[A-Z]+[A-Za-z0-9_\\-]*'},
	      {begin: '\\b_[a-z0-9\\-]+'}
	    ]
	  });
	  var TITLE2 = hljs.inherit(hljs.TITLE_MODE, {begin: '\\b([A-Za-z0-9_\\-]+)\\b'});
	  return {
	    case_insensitive: false,
	    keywords: {
	      keyword:
	        '$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER ' +
	        'codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph ' +
	        'after byte bytes english the until http forever descending using line real8 with seventh ' +
	        'for stdout finally element word words fourth before black ninth sixth characters chars stderr ' +
	        'uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid ' +
	        'at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 ' +
	        'int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat ' +
	        'end repeat URL in try into switch to words https token binfile each tenth as ticks tick ' +
	        'system real4 by dateItems without char character ascending eighth whole dateTime numeric short ' +
	        'first ftp integer abbreviated abbr abbrev private case while if',
	      constant:
	        'SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE ' +
	        'QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO ' +
	        'six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five ' +
	        'quote empty one true return cr linefeed right backslash null seven tab three two ' +
	        'RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK ' +
	        'FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK',
	      operator:
	        'div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within ' +
	        'contains ends with begins the keys of keys',
	      built_in:
	        'put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode ' +
	        'base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum ' +
	        'cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress ' +
	        'constantNames cos date dateFormat decompress directories ' +
	        'diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global ' +
	        'globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset ' +
	        'keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders ' +
	        'libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 ' +
	        'longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge millisec ' +
	        'millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar ' +
	        'numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets ' +
	        'paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation ' +
	        'populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile ' +
	        'revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull ' +
	        'revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered ' +
	        'revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames ' +
	        'revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull ' +
	        'revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections ' +
	        'revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype ' +
	        'revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext ' +
	        'revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames ' +
	        'revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase ' +
	        'revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute ' +
	        'revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces ' +
	        'revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode ' +
	        'revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling ' +
	        'revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error ' +
	        'revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute ' +
	        'revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort ' +
	        'revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree ' +
	        'revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance ' +
	        'sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound ' +
	        'stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper ' +
	        'transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames ' +
	        'variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet ' +
	        'xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process ' +
	        'combine constant convert create new alias folder directory decrypt delete variable word line folder ' +
	        'directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile ' +
	        'libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback ' +
	        'libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime ' +
	        'libURLSetStatusCallback load multiply socket prepare process post seek rel relative read from process rename ' +
	        'replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase ' +
	        'revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees ' +
	        'revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord ' +
	        'revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase ' +
	        'revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD ' +
	        'revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost ' +
	        'revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData ' +
	        'revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel ' +
	        'revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback ' +
	        'revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop ' +
	        'subtract union unload wait write'
	    },
	    contains: [
	      VARIABLE,
	      {
	        className: 'keyword',
	        begin: '\\bend\\sif\\b'
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '$',
	        contains: [
	          VARIABLE,
	          TITLE2,
	          hljs.APOS_STRING_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.BINARY_NUMBER_MODE,
	          hljs.C_NUMBER_MODE,
	          TITLE1
	        ]
	      },
	      {
	        className: 'function',
	        begin: '\\bend\\s+', end: '$',
	        keywords: 'end',
	        contains: [
	          TITLE2,
	          TITLE1
	        ]
	      },
	      {
	        className: 'command',
	        beginKeywords: 'command on', end: '$',
	        contains: [
	          VARIABLE,
	          TITLE2,
	          hljs.APOS_STRING_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.BINARY_NUMBER_MODE,
	          hljs.C_NUMBER_MODE,
	          TITLE1
	        ]
	      },
	      {
	        className: 'preprocessor',
	        variants: [
	          {
	            begin: '<\\?(rev|lc|livecode)',
	            relevance: 10
	          },
	          { begin: '<\\?' },
	          { begin: '\\?>' }
	        ]
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.BINARY_NUMBER_MODE,
	      hljs.C_NUMBER_MODE,
	      TITLE1
	    ].concat(COMMENT_MODES),
	    illegal: ';$|^\\[|^='
	  };
	};

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      // JS keywords
	      'in if for while finally new do return else break catch instanceof throw try this ' +
	      'switch continue typeof delete debugger case default function var with ' +
	      // LiveScript keywords
	      'then unless until loop of by when and or is isnt not it that otherwise from to til fallthrough super ' +
	      'case default function var void const let enum export import native ' +
	      '__hasProp __extends __slice __bind __indexOf',
	    literal:
	      // JS literals
	      'true false null undefined ' +
	      // LiveScript literals
	      'yes no on off it that void',
	    built_in:
	      'npm require console print module global window document'
	  };
	  var JS_IDENT_RE = '[A-Za-z$_](?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*';
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
	  var SUBST = {
	    className: 'subst',
	    begin: /#\{/, end: /}/,
	    keywords: KEYWORDS
	  };
	  var SUBST_SIMPLE = {
	    className: 'subst',
	    begin: /#[A-Za-z$_]/, end: /(?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
	    keywords: KEYWORDS
	  };
	  var EXPRESSIONS = [
	    hljs.BINARY_NUMBER_MODE,
	    {
	      className: 'number',
	      begin: '(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)',
	      relevance: 0,
	      starts: {end: '(\\s*/)?', relevance: 0} // a number tries to eat the following slash to prevent treating it as a regexp
	    },
	    {
	      className: 'string',
	      variants: [
	        {
	          begin: /'''/, end: /'''/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /'/, end: /'/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /"""/, end: /"""/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
	        },
	        {
	          begin: /"/, end: /"/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
	        },
	        {
	          begin: /\\/, end: /(\s|$)/,
	          excludeEnd: true
	        }
	      ]
	    },
	    {
	      className: 'pi',
	      variants: [
	        {
	          begin: '//', end: '//[gim]*',
	          contains: [SUBST, hljs.HASH_COMMENT_MODE]
	        },
	        {
	          // regex can't start with space to parse x / 2 / 3 as two divisions
	          // regex can't start with *, and it supports an "illegal" in the main mode
	          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
	        }
	      ]
	    },
	    {
	      className: 'property',
	      begin: '@' + JS_IDENT_RE
	    },
	    {
	      begin: '``', end: '``',
	      excludeBegin: true, excludeEnd: true,
	      subLanguage: 'javascript'
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', returnBegin: true,
	    /* We need another contained nameless mode to not have every nested
	    pair of parens to be called "params" */
	    contains: [
	      {
	        begin: /\(/, end: /\)/,
	        keywords: KEYWORDS,
	        contains: ['self'].concat(EXPRESSIONS)
	      }
	    ]
	  };
	
	  return {
	    aliases: ['ls'],
	    keywords: KEYWORDS,
	    illegal: /\/\*/,
	    contains: EXPRESSIONS.concat([
	      hljs.COMMENT('\\/\\*', '\\*\\/'),
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'function',
	        contains: [TITLE, PARAMS],
	        returnBegin: true,
	        variants: [
	          {
	            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B\\->\\*?', end: '\\->\\*?'
	          },
	          {
	            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?!?(\\(.*\\))?\\s*\\B[-~]{1,2}>\\*?', end: '[-~]{1,2}>\\*?'
	          },
	          {
	            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B!?[-~]{1,2}>\\*?', end: '!?[-~]{1,2}>\\*?'
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class',
	        end: '$',
	        illegal: /[:="\[\]]/,
	        contains: [
	          {
	            beginKeywords: 'extends',
	            endsWithParent: true,
	            illegal: /[:="\[\]]/,
	            contains: [TITLE]
	          },
	          TITLE
	        ]
	      },
	      {
	        className: 'attribute',
	        begin: JS_IDENT_RE + ':', end: ':',
	        returnBegin: true, returnEnd: true,
	        relevance: 0
	      }
	    ])
	  };
	};

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var OPENING_LONG_BRACKET = '\\[=*\\[';
	  var CLOSING_LONG_BRACKET = '\\]=*\\]';
	  var LONG_BRACKETS = {
	    begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
	    contains: ['self']
	  };
	  var COMMENTS = [
	    hljs.COMMENT('--(?!' + OPENING_LONG_BRACKET + ')', '$'),
	    hljs.COMMENT(
	      '--' + OPENING_LONG_BRACKET,
	      CLOSING_LONG_BRACKET,
	      {
	        contains: [LONG_BRACKETS],
	        relevance: 10
	      }
	    )
	  ];
	  return {
	    lexemes: hljs.UNDERSCORE_IDENT_RE,
	    keywords: {
	      keyword:
	        'and break do else elseif end false for if in local nil not or repeat return then ' +
	        'true until while',
	      built_in:
	        '_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load ' +
	        'loadfile loadstring module next pairs pcall print rawequal rawget rawset require ' +
	        'select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug ' +
	        'io math os package string table'
	    },
	    contains: COMMENTS.concat([
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '\\)',
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
	          {
	            className: 'params',
	            begin: '\\(', endsWithParent: true,
	            contains: COMMENTS
	          }
	        ].concat(COMMENTS)
	      },
	      hljs.C_NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
	        contains: [LONG_BRACKETS],
	        relevance: 5
	      }
	    ])
	  };
	};

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VARIABLE = {
	    className: 'variable',
	    begin: /\$\(/, end: /\)/,
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  return {
	    aliases: ['mk', 'mak'],
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        begin: /^\w+\s*\W*=/, returnBegin: true,
	        relevance: 0,
	        starts: {
	          className: 'constant',
	          end: /\s*\W*=/, excludeEnd: true,
	          starts: {
	            end: /$/,
	            relevance: 0,
	            contains: [
	              VARIABLE
	            ]
	          }
	        }
	      },
	      {
	        className: 'title',
	        begin: /^[\w]+:\s*$/
	      },
	      {
	        className: 'phony',
	        begin: /^\.PHONY:/, end: /$/,
	        keywords: '.PHONY', lexemes: /[\.\w]+/
	      },
	      {
	        begin: /^\t+/, end: /$/,
	        relevance: 0,
	        contains: [
	          hljs.QUOTE_STRING_MODE,
	          VARIABLE
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['md', 'mkdown', 'mkd'],
	    contains: [
	      // highlight headers
	      {
	        className: 'header',
	        variants: [
	          { begin: '^#{1,6}', end: '$' },
	          { begin: '^.+?\\n[=-]{2,}$' }
	        ]
	      },
	      // inline html
	      {
	        begin: '<', end: '>',
	        subLanguage: 'xml',
	        relevance: 0
	      },
	      // lists (indicators only)
	      {
	        className: 'bullet',
	        begin: '^([*+-]|(\\d+\\.))\\s+'
	      },
	      // strong segments
	      {
	        className: 'strong',
	        begin: '[*_]{2}.+?[*_]{2}'
	      },
	      // emphasis segments
	      {
	        className: 'emphasis',
	        variants: [
	          { begin: '\\*.+?\\*' },
	          { begin: '_.+?_'
	          , relevance: 0
	          }
	        ]
	      },
	      // blockquotes
	      {
	        className: 'blockquote',
	        begin: '^>\\s+', end: '$'
	      },
	      // code snippets
	      {
	        className: 'code',
	        variants: [
	          { begin: '`.+?`' },
	          { begin: '^( {4}|\t)', end: '$'
	          , relevance: 0
	          }
	        ]
	      },
	      // horizontal rules
	      {
	        className: 'horizontal_rule',
	        begin: '^[-\\*]{3,}', end: '$'
	      },
	      // using links - title and link
	      {
	        begin: '\\[.+?\\][\\(\\[].*?[\\)\\]]',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'link_label',
	            begin: '\\[', end: '\\]',
	            excludeBegin: true,
	            returnEnd: true,
	            relevance: 0
	          },
	          {
	            className: 'link_url',
	            begin: '\\]\\(', end: '\\)',
	            excludeBegin: true, excludeEnd: true
	          },
	          {
	            className: 'link_reference',
	            begin: '\\]\\[', end: '\\]',
	            excludeBegin: true, excludeEnd: true
	          }
	        ],
	        relevance: 10
	      },
	      {
	        begin: '^\\[\.+\\]:',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'link_reference',
	            begin: '\\[', end: '\\]:',
	            excludeBegin: true, excludeEnd: true,
	            starts: {
	              className: 'link_url',
	              end: '$'
	            }
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['mma'],
	    lexemes: '(\\$|\\b)' + hljs.IDENT_RE + '\\b',
	    keywords: 'AbelianGroup Abort AbortKernels AbortProtect Above Abs Absolute AbsoluteCorrelation AbsoluteCorrelationFunction AbsoluteCurrentValue AbsoluteDashing AbsoluteFileName AbsoluteOptions AbsolutePointSize AbsoluteThickness AbsoluteTime AbsoluteTiming AccountingForm Accumulate Accuracy AccuracyGoal ActionDelay ActionMenu ActionMenuBox ActionMenuBoxOptions Active ActiveItem ActiveStyle AcyclicGraphQ AddOnHelpPath AddTo AdjacencyGraph AdjacencyList AdjacencyMatrix AdjustmentBox AdjustmentBoxOptions AdjustTimeSeriesForecast AffineTransform After AiryAi AiryAiPrime AiryAiZero AiryBi AiryBiPrime AiryBiZero AlgebraicIntegerQ AlgebraicNumber AlgebraicNumberDenominator AlgebraicNumberNorm AlgebraicNumberPolynomial AlgebraicNumberTrace AlgebraicRules AlgebraicRulesData Algebraics AlgebraicUnitQ Alignment AlignmentMarker AlignmentPoint All AllowedDimensions AllowGroupClose AllowInlineCells AllowKernelInitialization AllowReverseGroupClose AllowScriptLevelChange AlphaChannel AlternatingGroup AlternativeHypothesis Alternatives AmbientLight Analytic AnchoredSearch And AndersonDarlingTest AngerJ AngleBracket AngularGauge Animate AnimationCycleOffset AnimationCycleRepetitions AnimationDirection AnimationDisplayTime AnimationRate AnimationRepetitions AnimationRunning Animator AnimatorBox AnimatorBoxOptions AnimatorElements Annotation Annuity AnnuityDue Antialiasing Antisymmetric Apart ApartSquareFree Appearance AppearanceElements AppellF1 Append AppendTo Apply ArcCos ArcCosh ArcCot ArcCoth ArcCsc ArcCsch ArcSec ArcSech ArcSin ArcSinDistribution ArcSinh ArcTan ArcTanh Arg ArgMax ArgMin ArgumentCountQ ARIMAProcess ArithmeticGeometricMean ARMAProcess ARProcess Array ArrayComponents ArrayDepth ArrayFlatten ArrayPad ArrayPlot ArrayQ ArrayReshape ArrayRules Arrays Arrow Arrow3DBox ArrowBox Arrowheads AspectRatio AspectRatioFixed Assert Assuming Assumptions AstronomicalData Asynchronous AsynchronousTaskObject AsynchronousTasks AtomQ Attributes AugmentedSymmetricPolynomial AutoAction AutoDelete AutoEvaluateEvents AutoGeneratedPackage AutoIndent AutoIndentSpacings AutoItalicWords AutoloadPath AutoMatch Automatic AutomaticImageSize AutoMultiplicationSymbol AutoNumberFormatting AutoOpenNotebooks AutoOpenPalettes AutorunSequencing AutoScaling AutoScroll AutoSpacing AutoStyleOptions AutoStyleWords Axes AxesEdge AxesLabel AxesOrigin AxesStyle Axis ' +
	      'BabyMonsterGroupB Back Background BackgroundTasksSettings Backslash Backsubstitution Backward Band BandpassFilter BandstopFilter BarabasiAlbertGraphDistribution BarChart BarChart3D BarLegend BarlowProschanImportance BarnesG BarOrigin BarSpacing BartlettHannWindow BartlettWindow BaseForm Baseline BaselinePosition BaseStyle BatesDistribution BattleLemarieWavelet Because BeckmannDistribution Beep Before Begin BeginDialogPacket BeginFrontEndInteractionPacket BeginPackage BellB BellY Below BenfordDistribution BeniniDistribution BenktanderGibratDistribution BenktanderWeibullDistribution BernoulliB BernoulliDistribution BernoulliGraphDistribution BernoulliProcess BernsteinBasis BesselFilterModel BesselI BesselJ BesselJZero BesselK BesselY BesselYZero Beta BetaBinomialDistribution BetaDistribution BetaNegativeBinomialDistribution BetaPrimeDistribution BetaRegularized BetweennessCentrality BezierCurve BezierCurve3DBox BezierCurve3DBoxOptions BezierCurveBox BezierCurveBoxOptions BezierFunction BilateralFilter Binarize BinaryFormat BinaryImageQ BinaryRead BinaryReadList BinaryWrite BinCounts BinLists Binomial BinomialDistribution BinomialProcess BinormalDistribution BiorthogonalSplineWavelet BipartiteGraphQ BirnbaumImportance BirnbaumSaundersDistribution BitAnd BitClear BitGet BitLength BitNot BitOr BitSet BitShiftLeft BitShiftRight BitXor Black BlackmanHarrisWindow BlackmanNuttallWindow BlackmanWindow Blank BlankForm BlankNullSequence BlankSequence Blend Block BlockRandom BlomqvistBeta BlomqvistBetaTest Blue Blur BodePlot BohmanWindow Bold Bookmarks Boole BooleanConsecutiveFunction BooleanConvert BooleanCountingFunction BooleanFunction BooleanGraph BooleanMaxterms BooleanMinimize BooleanMinterms Booleans BooleanTable BooleanVariables BorderDimensions BorelTannerDistribution Bottom BottomHatTransform BoundaryStyle Bounds Box BoxBaselineShift BoxData BoxDimensions Boxed Boxes BoxForm BoxFormFormatTypes BoxFrame BoxID BoxMargins BoxMatrix BoxRatios BoxRotation BoxRotationPoint BoxStyle BoxWhiskerChart Bra BracketingBar BraKet BrayCurtisDistance BreadthFirstScan Break Brown BrownForsytheTest BrownianBridgeProcess BrowserCategory BSplineBasis BSplineCurve BSplineCurve3DBox BSplineCurveBox BSplineCurveBoxOptions BSplineFunction BSplineSurface BSplineSurface3DBox BubbleChart BubbleChart3D BubbleScale BubbleSizes BulletGauge BusinessDayQ ButterflyGraph ButterworthFilterModel Button ButtonBar ButtonBox ButtonBoxOptions ButtonCell ButtonContents ButtonData ButtonEvaluator ButtonExpandable ButtonFrame ButtonFunction ButtonMargins ButtonMinHeight ButtonNote ButtonNotebook ButtonSource ButtonStyle ButtonStyleMenuListing Byte ByteCount ByteOrdering ' +
	      'C CachedValue CacheGraphics CalendarData CalendarType CallPacket CanberraDistance Cancel CancelButton CandlestickChart Cap CapForm CapitalDifferentialD CardinalBSplineBasis CarmichaelLambda Cases Cashflow Casoratian Catalan CatalanNumber Catch CauchyDistribution CauchyWindow CayleyGraph CDF CDFDeploy CDFInformation CDFWavelet Ceiling Cell CellAutoOverwrite CellBaseline CellBoundingBox CellBracketOptions CellChangeTimes CellContents CellContext CellDingbat CellDynamicExpression CellEditDuplicate CellElementsBoundingBox CellElementSpacings CellEpilog CellEvaluationDuplicate CellEvaluationFunction CellEventActions CellFrame CellFrameColor CellFrameLabelMargins CellFrameLabels CellFrameMargins CellGroup CellGroupData CellGrouping CellGroupingRules CellHorizontalScrolling CellID CellLabel CellLabelAutoDelete CellLabelMargins CellLabelPositioning CellMargins CellObject CellOpen CellPrint CellProlog Cells CellSize CellStyle CellTags CellularAutomaton CensoredDistribution Censoring Center CenterDot CentralMoment CentralMomentGeneratingFunction CForm ChampernowneNumber ChanVeseBinarize Character CharacterEncoding CharacterEncodingsPath CharacteristicFunction CharacteristicPolynomial CharacterRange Characters ChartBaseStyle ChartElementData ChartElementDataFunction ChartElementFunction ChartElements ChartLabels ChartLayout ChartLegends ChartStyle Chebyshev1FilterModel Chebyshev2FilterModel ChebyshevDistance ChebyshevT ChebyshevU Check CheckAbort CheckAll Checkbox CheckboxBar CheckboxBox CheckboxBoxOptions ChemicalData ChessboardDistance ChiDistribution ChineseRemainder ChiSquareDistribution ChoiceButtons ChoiceDialog CholeskyDecomposition Chop Circle CircleBox CircleDot CircleMinus CirclePlus CircleTimes CirculantGraph CityData Clear ClearAll ClearAttributes ClearSystemCache ClebschGordan ClickPane Clip ClipboardNotebook ClipFill ClippingStyle ClipPlanes ClipRange Clock ClockGauge ClockwiseContourIntegral Close Closed CloseKernels ClosenessCentrality Closing ClosingAutoSave ClosingEvent ClusteringComponents CMYKColor Coarse Coefficient CoefficientArrays CoefficientDomain CoefficientList CoefficientRules CoifletWavelet Collect Colon ColonForm ColorCombine ColorConvert ColorData ColorDataFunction ColorFunction ColorFunctionScaling Colorize ColorNegate ColorOutput ColorProfileData ColorQuantize ColorReplace ColorRules ColorSelectorSettings ColorSeparate ColorSetter ColorSetterBox ColorSetterBoxOptions ColorSlider ColorSpace Column ColumnAlignments ColumnBackgrounds ColumnForm ColumnLines ColumnsEqual ColumnSpacings ColumnWidths CommonDefaultFormatTypes Commonest CommonestFilter CommonUnits CommunityBoundaryStyle CommunityGraphPlot CommunityLabels CommunityRegionStyle CompatibleUnitQ CompilationOptions CompilationTarget Compile Compiled CompiledFunction Complement CompleteGraph CompleteGraphQ CompleteKaryTree CompletionsListPacket Complex Complexes ComplexExpand ComplexInfinity ComplexityFunction ComponentMeasurements ' +
	      'ComponentwiseContextMenu Compose ComposeList ComposeSeries Composition CompoundExpression CompoundPoissonDistribution CompoundPoissonProcess CompoundRenewalProcess Compress CompressedData Condition ConditionalExpression Conditioned Cone ConeBox ConfidenceLevel ConfidenceRange ConfidenceTransform ConfigurationPath Congruent Conjugate ConjugateTranspose Conjunction Connect ConnectedComponents ConnectedGraphQ ConnesWindow ConoverTest ConsoleMessage ConsoleMessagePacket ConsolePrint Constant ConstantArray Constants ConstrainedMax ConstrainedMin ContentPadding ContentsBoundingBox ContentSelectable ContentSize Context ContextMenu Contexts ContextToFilename ContextToFileName Continuation Continue ContinuedFraction ContinuedFractionK ContinuousAction ContinuousMarkovProcess ContinuousTimeModelQ ContinuousWaveletData ContinuousWaveletTransform ContourDetect ContourGraphics ContourIntegral ContourLabels ContourLines ContourPlot ContourPlot3D Contours ContourShading ContourSmoothing ContourStyle ContraharmonicMean Control ControlActive ControlAlignment ControllabilityGramian ControllabilityMatrix ControllableDecomposition ControllableModelQ ControllerDuration ControllerInformation ControllerInformationData ControllerLinking ControllerManipulate ControllerMethod ControllerPath ControllerState ControlPlacement ControlsRendering ControlType Convergents ConversionOptions ConversionRules ConvertToBitmapPacket ConvertToPostScript ConvertToPostScriptPacket Convolve ConwayGroupCo1 ConwayGroupCo2 ConwayGroupCo3 CoordinateChartData CoordinatesToolOptions CoordinateTransform CoordinateTransformData CoprimeQ Coproduct CopulaDistribution Copyable CopyDirectory CopyFile CopyTag CopyToClipboard CornerFilter CornerNeighbors Correlation CorrelationDistance CorrelationFunction CorrelationTest Cos Cosh CoshIntegral CosineDistance CosineWindow CosIntegral Cot Coth Count CounterAssignments CounterBox CounterBoxOptions CounterClockwiseContourIntegral CounterEvaluator CounterFunction CounterIncrements CounterStyle CounterStyleMenuListing CountRoots CountryData Covariance CovarianceEstimatorFunction CovarianceFunction CoxianDistribution CoxIngersollRossProcess CoxModel CoxModelFit CramerVonMisesTest CreateArchive CreateDialog CreateDirectory CreateDocument CreateIntermediateDirectories CreatePalette CreatePalettePacket CreateScheduledTask CreateTemporary CreateWindow CriticalityFailureImportance CriticalitySuccessImportance CriticalSection Cross CrossingDetect CrossMatrix Csc Csch CubeRoot Cubics Cuboid CuboidBox Cumulant CumulantGeneratingFunction Cup CupCap Curl CurlyDoubleQuote CurlyQuote CurrentImage CurrentlySpeakingPacket CurrentValue CurvatureFlowFilter CurveClosed Cyan CycleGraph CycleIndexPolynomial Cycles CyclicGroup Cyclotomic Cylinder CylinderBox CylindricalDecomposition ' +
	      'D DagumDistribution DamerauLevenshteinDistance DampingFactor Darker Dashed Dashing DataCompression DataDistribution DataRange DataReversed Date DateDelimiters DateDifference DateFunction DateList DateListLogPlot DateListPlot DatePattern DatePlus DateRange DateString DateTicksFormat DaubechiesWavelet DavisDistribution DawsonF DayCount DayCountConvention DayMatchQ DayName DayPlus DayRange DayRound DeBruijnGraph Debug DebugTag Decimal DeclareKnownSymbols DeclarePackage Decompose Decrement DedekindEta Default DefaultAxesStyle DefaultBaseStyle DefaultBoxStyle DefaultButton DefaultColor DefaultControlPlacement DefaultDuplicateCellStyle DefaultDuration DefaultElement DefaultFaceGridsStyle DefaultFieldHintStyle DefaultFont DefaultFontProperties DefaultFormatType DefaultFormatTypeForStyle DefaultFrameStyle DefaultFrameTicksStyle DefaultGridLinesStyle DefaultInlineFormatType DefaultInputFormatType DefaultLabelStyle DefaultMenuStyle DefaultNaturalLanguage DefaultNewCellStyle DefaultNewInlineCellStyle DefaultNotebook DefaultOptions DefaultOutputFormatType DefaultStyle DefaultStyleDefinitions DefaultTextFormatType DefaultTextInlineFormatType DefaultTicksStyle DefaultTooltipStyle DefaultValues Defer DefineExternal DefineInputStreamMethod DefineOutputStreamMethod Definition Degree DegreeCentrality DegreeGraphDistribution DegreeLexicographic DegreeReverseLexicographic Deinitialization Del Deletable Delete DeleteBorderComponents DeleteCases DeleteContents DeleteDirectory DeleteDuplicates DeleteFile DeleteSmallComponents DeleteWithContents DeletionWarning Delimiter DelimiterFlashTime DelimiterMatching Delimiters Denominator DensityGraphics DensityHistogram DensityPlot DependentVariables Deploy Deployed Depth DepthFirstScan Derivative DerivativeFilter DescriptorStateSpace DesignMatrix Det DGaussianWavelet DiacriticalPositioning Diagonal DiagonalMatrix Dialog DialogIndent DialogInput DialogLevel DialogNotebook DialogProlog DialogReturn DialogSymbols Diamond DiamondMatrix DiceDissimilarity DictionaryLookup DifferenceDelta DifferenceOrder DifferenceRoot DifferenceRootReduce Differences DifferentialD DifferentialRoot DifferentialRootReduce DifferentiatorFilter DigitBlock DigitBlockMinimum DigitCharacter DigitCount DigitQ DihedralGroup Dilation Dimensions DiracComb DiracDelta DirectedEdge DirectedEdges DirectedGraph DirectedGraphQ DirectedInfinity Direction Directive Directory DirectoryName DirectoryQ DirectoryStack DirichletCharacter DirichletConvolve DirichletDistribution DirichletL DirichletTransform DirichletWindow DisableConsolePrintPacket DiscreteChirpZTransform DiscreteConvolve DiscreteDelta DiscreteHadamardTransform DiscreteIndicator DiscreteLQEstimatorGains DiscreteLQRegulatorGains DiscreteLyapunovSolve DiscreteMarkovProcess DiscretePlot DiscretePlot3D DiscreteRatio DiscreteRiccatiSolve DiscreteShift DiscreteTimeModelQ DiscreteUniformDistribution DiscreteVariables DiscreteWaveletData DiscreteWaveletPacketTransform ' +
	      'DiscreteWaveletTransform Discriminant Disjunction Disk DiskBox DiskMatrix Dispatch DispersionEstimatorFunction Display DisplayAllSteps DisplayEndPacket DisplayFlushImagePacket DisplayForm DisplayFunction DisplayPacket DisplayRules DisplaySetSizePacket DisplayString DisplayTemporary DisplayWith DisplayWithRef DisplayWithVariable DistanceFunction DistanceTransform Distribute Distributed DistributedContexts DistributeDefinitions DistributionChart DistributionDomain DistributionFitTest DistributionParameterAssumptions DistributionParameterQ Dithering Div Divergence Divide DivideBy Dividers Divisible Divisors DivisorSigma DivisorSum DMSList DMSString Do DockedCells DocumentNotebook DominantColors DOSTextFormat Dot DotDashed DotEqual Dotted DoubleBracketingBar DoubleContourIntegral DoubleDownArrow DoubleLeftArrow DoubleLeftRightArrow DoubleLeftTee DoubleLongLeftArrow DoubleLongLeftRightArrow DoubleLongRightArrow DoubleRightArrow DoubleRightTee DoubleUpArrow DoubleUpDownArrow DoubleVerticalBar DoublyInfinite Down DownArrow DownArrowBar DownArrowUpArrow DownLeftRightVector DownLeftTeeVector DownLeftVector DownLeftVectorBar DownRightTeeVector DownRightVector DownRightVectorBar Downsample DownTee DownTeeArrow DownValues DragAndDrop DrawEdges DrawFrontFaces DrawHighlighted Drop DSolve Dt DualLinearProgramming DualSystemsModel DumpGet DumpSave DuplicateFreeQ Dynamic DynamicBox DynamicBoxOptions DynamicEvaluationTimeout DynamicLocation DynamicModule DynamicModuleBox DynamicModuleBoxOptions DynamicModuleParent DynamicModuleValues DynamicName DynamicNamespace DynamicReference DynamicSetting DynamicUpdating DynamicWrapper DynamicWrapperBox DynamicWrapperBoxOptions ' +
	      'E EccentricityCentrality EdgeAdd EdgeBetweennessCentrality EdgeCapacity EdgeCapForm EdgeColor EdgeConnectivity EdgeCost EdgeCount EdgeCoverQ EdgeDashing EdgeDelete EdgeDetect EdgeForm EdgeIndex EdgeJoinForm EdgeLabeling EdgeLabels EdgeLabelStyle EdgeList EdgeOpacity EdgeQ EdgeRenderingFunction EdgeRules EdgeShapeFunction EdgeStyle EdgeThickness EdgeWeight Editable EditButtonSettings EditCellTagsSettings EditDistance EffectiveInterest Eigensystem Eigenvalues EigenvectorCentrality Eigenvectors Element ElementData Eliminate EliminationOrder EllipticE EllipticExp EllipticExpPrime EllipticF EllipticFilterModel EllipticK EllipticLog EllipticNomeQ EllipticPi EllipticReducedHalfPeriods EllipticTheta EllipticThetaPrime EmitSound EmphasizeSyntaxErrors EmpiricalDistribution Empty EmptyGraphQ EnableConsolePrintPacket Enabled Encode End EndAdd EndDialogPacket EndFrontEndInteractionPacket EndOfFile EndOfLine EndOfString EndPackage EngineeringForm Enter EnterExpressionPacket EnterTextPacket Entropy EntropyFilter Environment Epilog Equal EqualColumns EqualRows EqualTilde EquatedTo Equilibrium EquirippleFilterKernel Equivalent Erf Erfc Erfi ErlangB ErlangC ErlangDistribution Erosion ErrorBox ErrorBoxOptions ErrorNorm ErrorPacket ErrorsDialogSettings EstimatedDistribution EstimatedProcess EstimatorGains EstimatorRegulator EuclideanDistance EulerE EulerGamma EulerianGraphQ EulerPhi Evaluatable Evaluate Evaluated EvaluatePacket EvaluationCell EvaluationCompletionAction EvaluationElements EvaluationMode EvaluationMonitor EvaluationNotebook EvaluationObject EvaluationOrder Evaluator EvaluatorNames EvenQ EventData EventEvaluator EventHandler EventHandlerTag EventLabels ExactBlackmanWindow ExactNumberQ ExactRootIsolation ExampleData Except ExcludedForms ExcludePods Exclusions ExclusionsStyle Exists Exit ExitDialog Exp Expand ExpandAll ExpandDenominator ExpandFileName ExpandNumerator Expectation ExpectationE ExpectedValue ExpGammaDistribution ExpIntegralE ExpIntegralEi Exponent ExponentFunction ExponentialDistribution ExponentialFamily ExponentialGeneratingFunction ExponentialMovingAverage ExponentialPowerDistribution ExponentPosition ExponentStep Export ExportAutoReplacements ExportPacket ExportString Expression ExpressionCell ExpressionPacket ExpToTrig ExtendedGCD Extension ExtentElementFunction ExtentMarkers ExtentSize ExternalCall ExternalDataCharacterEncoding Extract ExtractArchive ExtremeValueDistribution ' +
	      'FaceForm FaceGrids FaceGridsStyle Factor FactorComplete Factorial Factorial2 FactorialMoment FactorialMomentGeneratingFunction FactorialPower FactorInteger FactorList FactorSquareFree FactorSquareFreeList FactorTerms FactorTermsList Fail FailureDistribution False FARIMAProcess FEDisableConsolePrintPacket FeedbackSector FeedbackSectorStyle FeedbackType FEEnableConsolePrintPacket Fibonacci FieldHint FieldHintStyle FieldMasked FieldSize File FileBaseName FileByteCount FileDate FileExistsQ FileExtension FileFormat FileHash FileInformation FileName FileNameDepth FileNameDialogSettings FileNameDrop FileNameJoin FileNames FileNameSetter FileNameSplit FileNameTake FilePrint FileType FilledCurve FilledCurveBox Filling FillingStyle FillingTransform FilterRules FinancialBond FinancialData FinancialDerivative FinancialIndicator Find FindArgMax FindArgMin FindClique FindClusters FindCurvePath FindDistributionParameters FindDivisions FindEdgeCover FindEdgeCut FindEulerianCycle FindFaces FindFile FindFit FindGeneratingFunction FindGeoLocation FindGeometricTransform FindGraphCommunities FindGraphIsomorphism FindGraphPartition FindHamiltonianCycle FindIndependentEdgeSet FindIndependentVertexSet FindInstance FindIntegerNullVector FindKClan FindKClique FindKClub FindKPlex FindLibrary FindLinearRecurrence FindList FindMaximum FindMaximumFlow FindMaxValue FindMinimum FindMinimumCostFlow FindMinimumCut FindMinValue FindPermutation FindPostmanTour FindProcessParameters FindRoot FindSequenceFunction FindSettings FindShortestPath FindShortestTour FindThreshold FindVertexCover FindVertexCut Fine FinishDynamic FiniteAbelianGroupCount FiniteGroupCount FiniteGroupData First FirstPassageTimeDistribution FischerGroupFi22 FischerGroupFi23 FischerGroupFi24Prime FisherHypergeometricDistribution FisherRatioTest FisherZDistribution Fit FitAll FittedModel FixedPoint FixedPointList FlashSelection Flat Flatten FlattenAt FlatTopWindow FlipView Floor FlushPrintOutputPacket Fold FoldList Font FontColor FontFamily FontForm FontName FontOpacity FontPostScriptName FontProperties FontReencoding FontSize FontSlant FontSubstitutions FontTracking FontVariations FontWeight For ForAll Format FormatRules FormatType FormatTypeAutoConvert FormatValues FormBox FormBoxOptions FortranForm Forward ForwardBackward Fourier FourierCoefficient FourierCosCoefficient FourierCosSeries FourierCosTransform FourierDCT FourierDCTFilter FourierDCTMatrix FourierDST FourierDSTMatrix FourierMatrix FourierParameters FourierSequenceTransform FourierSeries FourierSinCoefficient FourierSinSeries FourierSinTransform FourierTransform FourierTrigSeries FractionalBrownianMotionProcess FractionalPart FractionBox FractionBoxOptions FractionLine Frame FrameBox FrameBoxOptions Framed FrameInset FrameLabel Frameless FrameMargins FrameStyle FrameTicks FrameTicksStyle FRatioDistribution FrechetDistribution FreeQ FrequencySamplingFilterKernel FresnelC FresnelS Friday FrobeniusNumber FrobeniusSolve ' +
	      'FromCharacterCode FromCoefficientRules FromContinuedFraction FromDate FromDigits FromDMS Front FrontEndDynamicExpression FrontEndEventActions FrontEndExecute FrontEndObject FrontEndResource FrontEndResourceString FrontEndStackSize FrontEndToken FrontEndTokenExecute FrontEndValueCache FrontEndVersion FrontFaceColor FrontFaceOpacity Full FullAxes FullDefinition FullForm FullGraphics FullOptions FullSimplify Function FunctionExpand FunctionInterpolation FunctionSpace FussellVeselyImportance ' +
	      'GaborFilter GaborMatrix GaborWavelet GainMargins GainPhaseMargins Gamma GammaDistribution GammaRegularized GapPenalty Gather GatherBy GaugeFaceElementFunction GaugeFaceStyle GaugeFrameElementFunction GaugeFrameSize GaugeFrameStyle GaugeLabels GaugeMarkers GaugeStyle GaussianFilter GaussianIntegers GaussianMatrix GaussianWindow GCD GegenbauerC General GeneralizedLinearModelFit GenerateConditions GeneratedCell GeneratedParameters GeneratingFunction Generic GenericCylindricalDecomposition GenomeData GenomeLookup GeodesicClosing GeodesicDilation GeodesicErosion GeodesicOpening GeoDestination GeodesyData GeoDirection GeoDistance GeoGridPosition GeometricBrownianMotionProcess GeometricDistribution GeometricMean GeometricMeanFilter GeometricTransformation GeometricTransformation3DBox GeometricTransformation3DBoxOptions GeometricTransformationBox GeometricTransformationBoxOptions GeoPosition GeoPositionENU GeoPositionXYZ GeoProjectionData GestureHandler GestureHandlerTag Get GetBoundingBoxSizePacket GetContext GetEnvironment GetFileName GetFrontEndOptionsDataPacket GetLinebreakInformationPacket GetMenusPacket GetPageBreakInformationPacket Glaisher GlobalClusteringCoefficient GlobalPreferences GlobalSession Glow GoldenRatio GompertzMakehamDistribution GoodmanKruskalGamma GoodmanKruskalGammaTest Goto Grad Gradient GradientFilter GradientOrientationFilter Graph GraphAssortativity GraphCenter GraphComplement GraphData GraphDensity GraphDiameter GraphDifference GraphDisjointUnion ' +
	      'GraphDistance GraphDistanceMatrix GraphElementData GraphEmbedding GraphHighlight GraphHighlightStyle GraphHub Graphics Graphics3D Graphics3DBox Graphics3DBoxOptions GraphicsArray GraphicsBaseline GraphicsBox GraphicsBoxOptions GraphicsColor GraphicsColumn GraphicsComplex GraphicsComplex3DBox GraphicsComplex3DBoxOptions GraphicsComplexBox GraphicsComplexBoxOptions GraphicsContents GraphicsData GraphicsGrid GraphicsGridBox GraphicsGroup GraphicsGroup3DBox GraphicsGroup3DBoxOptions GraphicsGroupBox GraphicsGroupBoxOptions GraphicsGrouping GraphicsHighlightColor GraphicsRow GraphicsSpacing GraphicsStyle GraphIntersection GraphLayout GraphLinkEfficiency GraphPeriphery GraphPlot GraphPlot3D GraphPower GraphPropertyDistribution GraphQ GraphRadius GraphReciprocity GraphRoot GraphStyle GraphUnion Gray GrayLevel GreatCircleDistance Greater GreaterEqual GreaterEqualLess GreaterFullEqual GreaterGreater GreaterLess GreaterSlantEqual GreaterTilde Green Grid GridBaseline GridBox GridBoxAlignment GridBoxBackground GridBoxDividers GridBoxFrame GridBoxItemSize GridBoxItemStyle GridBoxOptions GridBoxSpacings GridCreationSettings GridDefaultElement GridElementStyleOptions GridFrame GridFrameMargins GridGraph GridLines GridLinesStyle GroebnerBasis GroupActionBase GroupCentralizer GroupElementFromWord GroupElementPosition GroupElementQ GroupElements GroupElementToWord GroupGenerators GroupMultiplicationTable GroupOrbits GroupOrder GroupPageBreakWithin GroupSetwiseStabilizer GroupStabilizer GroupStabilizerChain Gudermannian GumbelDistribution ' +
	      'HaarWavelet HadamardMatrix HalfNormalDistribution HamiltonianGraphQ HammingDistance HammingWindow HankelH1 HankelH2 HankelMatrix HannPoissonWindow HannWindow HaradaNortonGroupHN HararyGraph HarmonicMean HarmonicMeanFilter HarmonicNumber Hash HashTable Haversine HazardFunction Head HeadCompose Heads HeavisideLambda HeavisidePi HeavisideTheta HeldGroupHe HeldPart HelpBrowserLookup HelpBrowserNotebook HelpBrowserSettings HermiteDecomposition HermiteH HermitianMatrixQ HessenbergDecomposition Hessian HexadecimalCharacter Hexahedron HexahedronBox HexahedronBoxOptions HiddenSurface HighlightGraph HighlightImage HighpassFilter HigmanSimsGroupHS HilbertFilter HilbertMatrix Histogram Histogram3D HistogramDistribution HistogramList HistogramTransform HistogramTransformInterpolation HitMissTransform HITSCentrality HodgeDual HoeffdingD HoeffdingDTest Hold HoldAll HoldAllComplete HoldComplete HoldFirst HoldForm HoldPattern HoldRest HolidayCalendar HomeDirectory HomePage Horizontal HorizontalForm HorizontalGauge HorizontalScrollPosition HornerForm HotellingTSquareDistribution HoytDistribution HTMLSave Hue HumpDownHump HumpEqual HurwitzLerchPhi HurwitzZeta HyperbolicDistribution HypercubeGraph HyperexponentialDistribution Hyperfactorial Hypergeometric0F1 Hypergeometric0F1Regularized Hypergeometric1F1 Hypergeometric1F1Regularized Hypergeometric2F1 Hypergeometric2F1Regularized HypergeometricDistribution HypergeometricPFQ HypergeometricPFQRegularized HypergeometricU Hyperlink HyperlinkCreationSettings Hyphenation HyphenationOptions HypoexponentialDistribution HypothesisTestData ' +
	      'I Identity IdentityMatrix If IgnoreCase Im Image Image3D Image3DSlices ImageAccumulate ImageAdd ImageAdjust ImageAlign ImageApply ImageAspectRatio ImageAssemble ImageCache ImageCacheValid ImageCapture ImageChannels ImageClip ImageColorSpace ImageCompose ImageConvolve ImageCooccurrence ImageCorners ImageCorrelate ImageCorrespondingPoints ImageCrop ImageData ImageDataPacket ImageDeconvolve ImageDemosaic ImageDifference ImageDimensions ImageDistance ImageEffect ImageFeatureTrack ImageFileApply ImageFileFilter ImageFileScan ImageFilter ImageForestingComponents ImageForwardTransformation ImageHistogram ImageKeypoints ImageLevels ImageLines ImageMargins ImageMarkers ImageMeasurements ImageMultiply ImageOffset ImagePad ImagePadding ImagePartition ImagePeriodogram ImagePerspectiveTransformation ImageQ ImageRangeCache ImageReflect ImageRegion ImageResize ImageResolution ImageRotate ImageRotated ImageScaled ImageScan ImageSize ImageSizeAction ImageSizeCache ImageSizeMultipliers ImageSizeRaw ImageSubtract ImageTake ImageTransformation ImageTrim ImageType ImageValue ImageValuePositions Implies Import ImportAutoReplacements ImportString ImprovementImportance In IncidenceGraph IncidenceList IncidenceMatrix IncludeConstantBasis IncludeFileExtension IncludePods IncludeSingularTerm Increment Indent IndentingNewlineSpacings IndentMaxFraction IndependenceTest IndependentEdgeSetQ IndependentUnit IndependentVertexSetQ Indeterminate IndexCreationOptions Indexed IndexGraph IndexTag Inequality InexactNumberQ InexactNumbers Infinity Infix Information Inherited InheritScope Initialization InitializationCell InitializationCellEvaluation InitializationCellWarning InlineCounterAssignments InlineCounterIncrements InlineRules Inner Inpaint Input InputAliases InputAssumptions InputAutoReplacements InputField InputFieldBox InputFieldBoxOptions InputForm InputGrouping InputNamePacket InputNotebook InputPacket InputSettings InputStream InputString InputStringPacket InputToBoxFormPacket Insert InsertionPointObject InsertResults Inset Inset3DBox Inset3DBoxOptions InsetBox InsetBoxOptions Install InstallService InString Integer IntegerDigits IntegerExponent IntegerLength IntegerPart IntegerPartitions IntegerQ Integers IntegerString Integral Integrate Interactive InteractiveTradingChart Interlaced Interleaving InternallyBalancedDecomposition InterpolatingFunction InterpolatingPolynomial Interpolation InterpolationOrder InterpolationPoints InterpolationPrecision Interpretation InterpretationBox InterpretationBoxOptions InterpretationFunction ' +
	      'InterpretTemplate InterquartileRange Interrupt InterruptSettings Intersection Interval IntervalIntersection IntervalMemberQ IntervalUnion Inverse InverseBetaRegularized InverseCDF InverseChiSquareDistribution InverseContinuousWaveletTransform InverseDistanceTransform InverseEllipticNomeQ InverseErf InverseErfc InverseFourier InverseFourierCosTransform InverseFourierSequenceTransform InverseFourierSinTransform InverseFourierTransform InverseFunction InverseFunctions InverseGammaDistribution InverseGammaRegularized InverseGaussianDistribution InverseGudermannian InverseHaversine InverseJacobiCD InverseJacobiCN InverseJacobiCS InverseJacobiDC InverseJacobiDN InverseJacobiDS InverseJacobiNC InverseJacobiND InverseJacobiNS InverseJacobiSC InverseJacobiSD InverseJacobiSN InverseLaplaceTransform InversePermutation InverseRadon InverseSeries InverseSurvivalFunction InverseWaveletTransform InverseWeierstrassP InverseZTransform Invisible InvisibleApplication InvisibleTimes IrreduciblePolynomialQ IsolatingInterval IsomorphicGraphQ IsotopeData Italic Item ItemBox ItemBoxOptions ItemSize ItemStyle ItoProcess ' +
	      'JaccardDissimilarity JacobiAmplitude Jacobian JacobiCD JacobiCN JacobiCS JacobiDC JacobiDN JacobiDS JacobiNC JacobiND JacobiNS JacobiP JacobiSC JacobiSD JacobiSN JacobiSymbol JacobiZeta JankoGroupJ1 JankoGroupJ2 JankoGroupJ3 JankoGroupJ4 JarqueBeraALMTest JohnsonDistribution Join Joined JoinedCurve JoinedCurveBox JoinForm JordanDecomposition JordanModelDecomposition ' +
	      'K KagiChart KaiserBesselWindow KaiserWindow KalmanEstimator KalmanFilter KarhunenLoeveDecomposition KaryTree KatzCentrality KCoreComponents KDistribution KelvinBei KelvinBer KelvinKei KelvinKer KendallTau KendallTauTest KernelExecute KernelMixtureDistribution KernelObject Kernels Ket Khinchin KirchhoffGraph KirchhoffMatrix KleinInvariantJ KnightTourGraph KnotData KnownUnitQ KolmogorovSmirnovTest KroneckerDelta KroneckerModelDecomposition KroneckerProduct KroneckerSymbol KuiperTest KumaraswamyDistribution Kurtosis KuwaharaFilter ' +
	      'Label Labeled LabeledSlider LabelingFunction LabelStyle LaguerreL LambdaComponents LambertW LanczosWindow LandauDistribution Language LanguageCategory LaplaceDistribution LaplaceTransform Laplacian LaplacianFilter LaplacianGaussianFilter Large Larger Last Latitude LatitudeLongitude LatticeData LatticeReduce Launch LaunchKernels LayeredGraphPlot LayerSizeFunction LayoutInformation LCM LeafCount LeapYearQ LeastSquares LeastSquaresFilterKernel Left LeftArrow LeftArrowBar LeftArrowRightArrow LeftDownTeeVector LeftDownVector LeftDownVectorBar LeftRightArrow LeftRightVector LeftTee LeftTeeArrow LeftTeeVector LeftTriangle LeftTriangleBar LeftTriangleEqual LeftUpDownVector LeftUpTeeVector LeftUpVector LeftUpVectorBar LeftVector LeftVectorBar LegendAppearance Legended LegendFunction LegendLabel LegendLayout LegendMargins LegendMarkers LegendMarkerSize LegendreP LegendreQ LegendreType Length LengthWhile LerchPhi Less LessEqual LessEqualGreater LessFullEqual LessGreater LessLess LessSlantEqual LessTilde LetterCharacter LetterQ Level LeveneTest LeviCivitaTensor LevyDistribution Lexicographic LibraryFunction LibraryFunctionError LibraryFunctionInformation LibraryFunctionLoad LibraryFunctionUnload LibraryLoad LibraryUnload LicenseID LiftingFilterData LiftingWaveletTransform LightBlue LightBrown LightCyan Lighter LightGray LightGreen Lighting LightingAngle LightMagenta LightOrange LightPink LightPurple LightRed LightSources LightYellow Likelihood Limit LimitsPositioning LimitsPositioningTokens LindleyDistribution Line Line3DBox LinearFilter LinearFractionalTransform LinearModelFit LinearOffsetFunction LinearProgramming LinearRecurrence LinearSolve LinearSolveFunction LineBox LineBreak LinebreakAdjustments LineBreakChart LineBreakWithin LineColor LineForm LineGraph LineIndent LineIndentMaxFraction LineIntegralConvolutionPlot LineIntegralConvolutionScale LineLegend LineOpacity LineSpacing LineWrapParts LinkActivate LinkClose LinkConnect LinkConnectedQ LinkCreate LinkError LinkFlush LinkFunction LinkHost LinkInterrupt LinkLaunch LinkMode LinkObject LinkOpen LinkOptions LinkPatterns LinkProtocol LinkRead LinkReadHeld LinkReadyQ Links LinkWrite LinkWriteHeld LiouvilleLambda List Listable ListAnimate ListContourPlot ListContourPlot3D ListConvolve ListCorrelate ListCurvePathPlot ListDeconvolve ListDensityPlot Listen ListFourierSequenceTransform ListInterpolation ListLineIntegralConvolutionPlot ListLinePlot ListLogLinearPlot ListLogLogPlot ListLogPlot ListPicker ListPickerBox ListPickerBoxBackground ListPickerBoxOptions ListPlay ListPlot ListPlot3D ListPointPlot3D ListPolarPlot ListQ ListStreamDensityPlot ListStreamPlot ListSurfacePlot3D ListVectorDensityPlot ListVectorPlot ListVectorPlot3D ListZTransform Literal LiteralSearch LocalClusteringCoefficient LocalizeVariables LocationEquivalenceTest LocationTest Locator LocatorAutoCreate LocatorBox LocatorBoxOptions LocatorCentering LocatorPane LocatorPaneBox LocatorPaneBoxOptions ' +
	      'LocatorRegion Locked Log Log10 Log2 LogBarnesG LogGamma LogGammaDistribution LogicalExpand LogIntegral LogisticDistribution LogitModelFit LogLikelihood LogLinearPlot LogLogisticDistribution LogLogPlot LogMultinormalDistribution LogNormalDistribution LogPlot LogRankTest LogSeriesDistribution LongEqual Longest LongestAscendingSequence LongestCommonSequence LongestCommonSequencePositions LongestCommonSubsequence LongestCommonSubsequencePositions LongestMatch LongForm Longitude LongLeftArrow LongLeftRightArrow LongRightArrow Loopback LoopFreeGraphQ LowerCaseQ LowerLeftArrow LowerRightArrow LowerTriangularize LowpassFilter LQEstimatorGains LQGRegulator LQOutputRegulatorGains LQRegulatorGains LUBackSubstitution LucasL LuccioSamiComponents LUDecomposition LyapunovSolve LyonsGroupLy ' +
	      'MachineID MachineName MachineNumberQ MachinePrecision MacintoshSystemPageSetup Magenta Magnification Magnify MainSolve MaintainDynamicCaches Majority MakeBoxes MakeExpression MakeRules MangoldtLambda ManhattanDistance Manipulate Manipulator MannWhitneyTest MantissaExponent Manual Map MapAll MapAt MapIndexed MAProcess MapThread MarcumQ MardiaCombinedTest MardiaKurtosisTest MardiaSkewnessTest MarginalDistribution MarkovProcessProperties Masking MatchingDissimilarity MatchLocalNameQ MatchLocalNames MatchQ Material MathematicaNotation MathieuC MathieuCharacteristicA MathieuCharacteristicB MathieuCharacteristicExponent MathieuCPrime MathieuGroupM11 MathieuGroupM12 MathieuGroupM22 MathieuGroupM23 MathieuGroupM24 MathieuS MathieuSPrime MathMLForm MathMLText Matrices MatrixExp MatrixForm MatrixFunction MatrixLog MatrixPlot MatrixPower MatrixQ MatrixRank Max MaxBend MaxDetect MaxExtraBandwidths MaxExtraConditions MaxFeatures MaxFilter Maximize MaxIterations MaxMemoryUsed MaxMixtureKernels MaxPlotPoints MaxPoints MaxRecursion MaxStableDistribution MaxStepFraction MaxSteps MaxStepSize MaxValue MaxwellDistribution McLaughlinGroupMcL Mean MeanClusteringCoefficient MeanDegreeConnectivity MeanDeviation MeanFilter MeanGraphDistance MeanNeighborDegree MeanShift MeanShiftFilter Median MedianDeviation MedianFilter Medium MeijerG MeixnerDistribution MemberQ MemoryConstrained MemoryInUse Menu MenuAppearance MenuCommandKey MenuEvaluator MenuItem MenuPacket MenuSortingValue MenuStyle MenuView MergeDifferences Mesh MeshFunctions MeshRange MeshShading MeshStyle Message MessageDialog MessageList MessageName MessageOptions MessagePacket Messages MessagesNotebook MetaCharacters MetaInformation Method MethodOptions MexicanHatWavelet MeyerWavelet Min MinDetect MinFilter MinimalPolynomial MinimalStateSpaceModel Minimize Minors MinRecursion MinSize MinStableDistribution Minus MinusPlus MinValue Missing MissingDataMethod MittagLefflerE MixedRadix MixedRadixQuantity MixtureDistribution Mod Modal Mode Modular ModularLambda Module Modulus MoebiusMu Moment Momentary MomentConvert MomentEvaluate MomentGeneratingFunction Monday Monitor MonomialList MonomialOrder MonsterGroupM MorletWavelet MorphologicalBinarize MorphologicalBranchPoints MorphologicalComponents MorphologicalEulerNumber MorphologicalGraph MorphologicalPerimeter MorphologicalTransform Most MouseAnnotation MouseAppearance MouseAppearanceTag MouseButtons Mouseover MousePointerNote MousePosition MovingAverage MovingMedian MoyalDistribution MultiedgeStyle MultilaunchWarning MultiLetterItalics MultiLetterStyle MultilineFunction Multinomial MultinomialDistribution MultinormalDistribution MultiplicativeOrder Multiplicity Multiselection MultivariateHypergeometricDistribution MultivariatePoissonDistribution MultivariateTDistribution ' +
	      'N NakagamiDistribution NameQ Names NamespaceBox Nand NArgMax NArgMin NBernoulliB NCache NDSolve NDSolveValue Nearest NearestFunction NeedCurrentFrontEndPackagePacket NeedCurrentFrontEndSymbolsPacket NeedlemanWunschSimilarity Needs Negative NegativeBinomialDistribution NegativeMultinomialDistribution NeighborhoodGraph Nest NestedGreaterGreater NestedLessLess NestedScriptRules NestList NestWhile NestWhileList NevilleThetaC NevilleThetaD NevilleThetaN NevilleThetaS NewPrimitiveStyle NExpectation Next NextPrime NHoldAll NHoldFirst NHoldRest NicholsGridLines NicholsPlot NIntegrate NMaximize NMaxValue NMinimize NMinValue NominalVariables NonAssociative NoncentralBetaDistribution NoncentralChiSquareDistribution NoncentralFRatioDistribution NoncentralStudentTDistribution NonCommutativeMultiply NonConstants None NonlinearModelFit NonlocalMeansFilter NonNegative NonPositive Nor NorlundB Norm Normal NormalDistribution NormalGrouping Normalize NormalizedSquaredEuclideanDistance NormalsFunction NormFunction Not NotCongruent NotCupCap NotDoubleVerticalBar Notebook NotebookApply NotebookAutoSave NotebookClose NotebookConvertSettings NotebookCreate NotebookCreateReturnObject NotebookDefault NotebookDelete NotebookDirectory NotebookDynamicExpression NotebookEvaluate NotebookEventActions NotebookFileName NotebookFind NotebookFindReturnObject NotebookGet NotebookGetLayoutInformationPacket NotebookGetMisspellingsPacket NotebookInformation NotebookInterfaceObject NotebookLocate NotebookObject NotebookOpen NotebookOpenReturnObject NotebookPath NotebookPrint NotebookPut NotebookPutReturnObject NotebookRead NotebookResetGeneratedCells Notebooks NotebookSave NotebookSaveAs NotebookSelection NotebookSetupLayoutInformationPacket NotebooksMenu NotebookWrite NotElement NotEqualTilde NotExists NotGreater NotGreaterEqual NotGreaterFullEqual NotGreaterGreater NotGreaterLess NotGreaterSlantEqual NotGreaterTilde NotHumpDownHump NotHumpEqual NotLeftTriangle NotLeftTriangleBar NotLeftTriangleEqual NotLess NotLessEqual NotLessFullEqual NotLessGreater NotLessLess NotLessSlantEqual NotLessTilde NotNestedGreaterGreater NotNestedLessLess NotPrecedes NotPrecedesEqual NotPrecedesSlantEqual NotPrecedesTilde NotReverseElement NotRightTriangle NotRightTriangleBar NotRightTriangleEqual NotSquareSubset NotSquareSubsetEqual NotSquareSuperset NotSquareSupersetEqual NotSubset NotSubsetEqual NotSucceeds NotSucceedsEqual NotSucceedsSlantEqual NotSucceedsTilde NotSuperset NotSupersetEqual NotTilde NotTildeEqual NotTildeFullEqual NotTildeTilde NotVerticalBar NProbability NProduct NProductFactors NRoots NSolve NSum NSumTerms Null NullRecords NullSpace NullWords Number NumberFieldClassNumber NumberFieldDiscriminant NumberFieldFundamentalUnits NumberFieldIntegralBasis NumberFieldNormRepresentatives NumberFieldRegulator NumberFieldRootsOfUnity NumberFieldSignature NumberForm NumberFormat NumberMarks NumberMultiplier NumberPadding NumberPoint NumberQ NumberSeparator ' +
	      'NumberSigns NumberString Numerator NumericFunction NumericQ NuttallWindow NValues NyquistGridLines NyquistPlot ' +
	      'O ObservabilityGramian ObservabilityMatrix ObservableDecomposition ObservableModelQ OddQ Off Offset OLEData On ONanGroupON OneIdentity Opacity Open OpenAppend Opener OpenerBox OpenerBoxOptions OpenerView OpenFunctionInspectorPacket Opening OpenRead OpenSpecialOptions OpenTemporary OpenWrite Operate OperatingSystem OptimumFlowData Optional OptionInspectorSettings OptionQ Options OptionsPacket OptionsPattern OptionValue OptionValueBox OptionValueBoxOptions Or Orange Order OrderDistribution OrderedQ Ordering Orderless OrnsteinUhlenbeckProcess Orthogonalize Out Outer OutputAutoOverwrite OutputControllabilityMatrix OutputControllableModelQ OutputForm OutputFormData OutputGrouping OutputMathEditExpression OutputNamePacket OutputResponse OutputSizeLimit OutputStream Over OverBar OverDot Overflow OverHat Overlaps Overlay OverlayBox OverlayBoxOptions Overscript OverscriptBox OverscriptBoxOptions OverTilde OverVector OwenT OwnValues ' +
	      'PackingMethod PaddedForm Padding PadeApproximant PadLeft PadRight PageBreakAbove PageBreakBelow PageBreakWithin PageFooterLines PageFooters PageHeaderLines PageHeaders PageHeight PageRankCentrality PageWidth PairedBarChart PairedHistogram PairedSmoothHistogram PairedTTest PairedZTest PaletteNotebook PalettePath Pane PaneBox PaneBoxOptions Panel PanelBox PanelBoxOptions Paneled PaneSelector PaneSelectorBox PaneSelectorBoxOptions PaperWidth ParabolicCylinderD ParagraphIndent ParagraphSpacing ParallelArray ParallelCombine ParallelDo ParallelEvaluate Parallelization Parallelize ParallelMap ParallelNeeds ParallelProduct ParallelSubmit ParallelSum ParallelTable ParallelTry Parameter ParameterEstimator ParameterMixtureDistribution ParameterVariables ParametricFunction ParametricNDSolve ParametricNDSolveValue ParametricPlot ParametricPlot3D ParentConnect ParentDirectory ParentForm Parenthesize ParentList ParetoDistribution Part PartialCorrelationFunction PartialD ParticleData Partition PartitionsP PartitionsQ ParzenWindow PascalDistribution PassEventsDown PassEventsUp Paste PasteBoxFormInlineCells PasteButton Path PathGraph PathGraphQ Pattern PatternSequence PatternTest PauliMatrix PaulWavelet Pause PausedTime PDF PearsonChiSquareTest PearsonCorrelationTest PearsonDistribution PerformanceGoal PeriodicInterpolation Periodogram PeriodogramArray PermutationCycles PermutationCyclesQ PermutationGroup PermutationLength PermutationList PermutationListQ PermutationMax PermutationMin PermutationOrder PermutationPower PermutationProduct PermutationReplace Permutations PermutationSupport Permute PeronaMalikFilter Perpendicular PERTDistribution PetersenGraph PhaseMargins Pi Pick PIDData PIDDerivativeFilter PIDFeedforward PIDTune Piecewise PiecewiseExpand PieChart PieChart3D PillaiTrace PillaiTraceTest Pink Pivoting PixelConstrained PixelValue PixelValuePositions Placed Placeholder PlaceholderReplace Plain PlanarGraphQ Play PlayRange Plot Plot3D Plot3Matrix PlotDivision PlotJoined PlotLabel PlotLayout PlotLegends PlotMarkers PlotPoints PlotRange PlotRangeClipping PlotRangePadding PlotRegion PlotStyle Plus PlusMinus Pochhammer PodStates PodWidth Point Point3DBox PointBox PointFigureChart PointForm PointLegend PointSize PoissonConsulDistribution PoissonDistribution PoissonProcess PoissonWindow PolarAxes PolarAxesOrigin PolarGridLines PolarPlot PolarTicks PoleZeroMarkers PolyaAeppliDistribution PolyGamma Polygon Polygon3DBox Polygon3DBoxOptions PolygonBox PolygonBoxOptions PolygonHoleScale PolygonIntersections PolygonScale PolyhedronData PolyLog PolynomialExtendedGCD PolynomialForm PolynomialGCD PolynomialLCM PolynomialMod PolynomialQ PolynomialQuotient PolynomialQuotientRemainder PolynomialReduce PolynomialRemainder Polynomials PopupMenu PopupMenuBox PopupMenuBoxOptions PopupView PopupWindow Position Positive PositiveDefiniteMatrixQ PossibleZeroQ Postfix PostScript Power PowerDistribution PowerExpand PowerMod PowerModList ' +
	      'PowerSpectralDensity PowersRepresentations PowerSymmetricPolynomial Precedence PrecedenceForm Precedes PrecedesEqual PrecedesSlantEqual PrecedesTilde Precision PrecisionGoal PreDecrement PredictionRoot PreemptProtect PreferencesPath Prefix PreIncrement Prepend PrependTo PreserveImageOptions Previous PriceGraphDistribution PrimaryPlaceholder Prime PrimeNu PrimeOmega PrimePi PrimePowerQ PrimeQ Primes PrimeZetaP PrimitiveRoot PrincipalComponents PrincipalValue Print PrintAction PrintForm PrintingCopies PrintingOptions PrintingPageRange PrintingStartingPageNumber PrintingStyleEnvironment PrintPrecision PrintTemporary Prism PrismBox PrismBoxOptions PrivateCellOptions PrivateEvaluationOptions PrivateFontOptions PrivateFrontEndOptions PrivateNotebookOptions PrivatePaths Probability ProbabilityDistribution ProbabilityPlot ProbabilityPr ProbabilityScalePlot ProbitModelFit ProcessEstimator ProcessParameterAssumptions ProcessParameterQ ProcessStateDomain ProcessTimeDomain Product ProductDistribution ProductLog ProgressIndicator ProgressIndicatorBox ProgressIndicatorBoxOptions Projection Prolog PromptForm Properties Property PropertyList PropertyValue Proportion Proportional Protect Protected ProteinData Pruning PseudoInverse Purple Put PutAppend Pyramid PyramidBox PyramidBoxOptions ' +
	      'QBinomial QFactorial QGamma QHypergeometricPFQ QPochhammer QPolyGamma QRDecomposition QuadraticIrrationalQ Quantile QuantilePlot Quantity QuantityForm QuantityMagnitude QuantityQ QuantityUnit Quartics QuartileDeviation Quartiles QuartileSkewness QueueingNetworkProcess QueueingProcess QueueProperties Quiet Quit Quotient QuotientRemainder ' +
	      'RadialityCentrality RadicalBox RadicalBoxOptions RadioButton RadioButtonBar RadioButtonBox RadioButtonBoxOptions Radon RamanujanTau RamanujanTauL RamanujanTauTheta RamanujanTauZ Random RandomChoice RandomComplex RandomFunction RandomGraph RandomImage RandomInteger RandomPermutation RandomPrime RandomReal RandomSample RandomSeed RandomVariate RandomWalkProcess Range RangeFilter RangeSpecification RankedMax RankedMin Raster Raster3D Raster3DBox Raster3DBoxOptions RasterArray RasterBox RasterBoxOptions Rasterize RasterSize Rational RationalFunctions Rationalize Rationals Ratios Raw RawArray RawBoxes RawData RawMedium RayleighDistribution Re Read ReadList ReadProtected Real RealBlockDiagonalForm RealDigits RealExponent Reals Reap Record RecordLists RecordSeparators Rectangle RectangleBox RectangleBoxOptions RectangleChart RectangleChart3D RecurrenceFilter RecurrenceTable RecurringDigitsForm Red Reduce RefBox ReferenceLineStyle ReferenceMarkers ReferenceMarkerStyle Refine ReflectionMatrix ReflectionTransform Refresh RefreshRate RegionBinarize RegionFunction RegionPlot RegionPlot3D RegularExpression Regularization Reinstall Release ReleaseHold ReliabilityDistribution ReliefImage ReliefPlot Remove RemoveAlphaChannel RemoveAsynchronousTask Removed RemoveInputStreamMethod RemoveOutputStreamMethod RemoveProperty RemoveScheduledTask RenameDirectory RenameFile RenderAll RenderingOptions RenewalProcess RenkoChart Repeated RepeatedNull RepeatedString Replace ReplaceAll ReplaceHeldPart ReplaceImageValue ReplaceList ReplacePart ReplacePixelValue ReplaceRepeated Resampling Rescale RescalingTransform ResetDirectory ResetMenusPacket ResetScheduledTask Residue Resolve Rest Resultant ResumePacket Return ReturnExpressionPacket ReturnInputFormPacket ReturnPacket ReturnTextPacket Reverse ReverseBiorthogonalSplineWavelet ReverseElement ReverseEquilibrium ReverseGraph ReverseUpEquilibrium RevolutionAxis RevolutionPlot3D RGBColor RiccatiSolve RiceDistribution RidgeFilter RiemannR RiemannSiegelTheta RiemannSiegelZ Riffle Right RightArrow RightArrowBar RightArrowLeftArrow RightCosetRepresentative RightDownTeeVector RightDownVector RightDownVectorBar RightTee RightTeeArrow RightTeeVector RightTriangle RightTriangleBar RightTriangleEqual RightUpDownVector RightUpTeeVector RightUpVector RightUpVectorBar RightVector RightVectorBar RiskAchievementImportance RiskReductionImportance RogersTanimotoDissimilarity Root RootApproximant RootIntervals RootLocusPlot RootMeanSquare RootOfUnityQ RootReduce Roots RootSum Rotate RotateLabel RotateLeft RotateRight RotationAction RotationBox RotationBoxOptions RotationMatrix RotationTransform Round RoundImplies RoundingRadius Row RowAlignments RowBackgrounds RowBox RowHeights RowLines RowMinHeight RowReduce RowsEqual RowSpacings RSolve RudvalisGroupRu Rule RuleCondition RuleDelayed RuleForm RulerUnits Run RunScheduledTask RunThrough RuntimeAttributes RuntimeOptions RussellRaoDissimilarity ' +
	      'SameQ SameTest SampleDepth SampledSoundFunction SampledSoundList SampleRate SamplingPeriod SARIMAProcess SARMAProcess SatisfiabilityCount SatisfiabilityInstances SatisfiableQ Saturday Save Saveable SaveAutoDelete SaveDefinitions SawtoothWave Scale Scaled ScaleDivisions ScaledMousePosition ScaleOrigin ScalePadding ScaleRanges ScaleRangeStyle ScalingFunctions ScalingMatrix ScalingTransform Scan ScheduledTaskActiveQ ScheduledTaskData ScheduledTaskObject ScheduledTasks SchurDecomposition ScientificForm ScreenRectangle ScreenStyleEnvironment ScriptBaselineShifts ScriptLevel ScriptMinSize ScriptRules ScriptSizeMultipliers Scrollbars ScrollingOptions ScrollPosition Sec Sech SechDistribution SectionGrouping SectorChart SectorChart3D SectorOrigin SectorSpacing SeedRandom Select Selectable SelectComponents SelectedCells SelectedNotebook Selection SelectionAnimate SelectionCell SelectionCellCreateCell SelectionCellDefaultStyle SelectionCellParentStyle SelectionCreateCell SelectionDebuggerTag SelectionDuplicateCell SelectionEvaluate SelectionEvaluateCreateCell SelectionMove SelectionPlaceholder SelectionSetStyle SelectWithContents SelfLoops SelfLoopStyle SemialgebraicComponentInstances SendMail Sequence SequenceAlignment SequenceForm SequenceHold SequenceLimit Series SeriesCoefficient SeriesData SessionTime Set SetAccuracy SetAlphaChannel SetAttributes Setbacks SetBoxFormNamesPacket SetDelayed SetDirectory SetEnvironment SetEvaluationNotebook SetFileDate SetFileLoadingContext SetNotebookStatusLine SetOptions SetOptionsPacket SetPrecision SetProperty SetSelectedNotebook SetSharedFunction SetSharedVariable SetSpeechParametersPacket SetStreamPosition SetSystemOptions Setter SetterBar SetterBox SetterBoxOptions Setting SetValue Shading Shallow ShannonWavelet ShapiroWilkTest Share Sharpen ShearingMatrix ShearingTransform ShenCastanMatrix Short ShortDownArrow Shortest ShortestMatch ShortestPathFunction ShortLeftArrow ShortRightArrow ShortUpArrow Show ShowAutoStyles ShowCellBracket ShowCellLabel ShowCellTags ShowClosedCellArea ShowContents ShowControls ShowCursorTracker ShowGroupOpenCloseIcon ShowGroupOpener ShowInvisibleCharacters ShowPageBreaks ShowPredictiveInterface ShowSelection ShowShortBoxForm ShowSpecialCharacters ShowStringCharacters ShowSyntaxStyles ShrinkingDelay ShrinkWrapBoundingBox SiegelTheta SiegelTukeyTest Sign Signature SignedRankTest SignificanceLevel SignPadding SignTest SimilarityRules SimpleGraph SimpleGraphQ Simplify Sin Sinc SinghMaddalaDistribution SingleEvaluation SingleLetterItalics SingleLetterStyle SingularValueDecomposition SingularValueList SingularValuePlot SingularValues Sinh SinhIntegral SinIntegral SixJSymbol Skeleton SkeletonTransform SkellamDistribution Skewness SkewNormalDistribution Skip SliceDistribution Slider Slider2D Slider2DBox Slider2DBoxOptions SliderBox SliderBoxOptions SlideView Slot SlotSequence Small SmallCircle Smaller SmithDelayCompensator SmithWatermanSimilarity ' +
	      'SmoothDensityHistogram SmoothHistogram SmoothHistogram3D SmoothKernelDistribution SocialMediaData Socket SokalSneathDissimilarity Solve SolveAlways SolveDelayed Sort SortBy Sound SoundAndGraphics SoundNote SoundVolume Sow Space SpaceForm Spacer Spacings Span SpanAdjustments SpanCharacterRounding SpanFromAbove SpanFromBoth SpanFromLeft SpanLineThickness SpanMaxSize SpanMinSize SpanningCharacters SpanSymmetric SparseArray SpatialGraphDistribution Speak SpeakTextPacket SpearmanRankTest SpearmanRho Spectrogram SpectrogramArray Specularity SpellingCorrection SpellingDictionaries SpellingDictionariesPath SpellingOptions SpellingSuggestionsPacket Sphere SphereBox SphericalBesselJ SphericalBesselY SphericalHankelH1 SphericalHankelH2 SphericalHarmonicY SphericalPlot3D SphericalRegion SpheroidalEigenvalue SpheroidalJoiningFactor SpheroidalPS SpheroidalPSPrime SpheroidalQS SpheroidalQSPrime SpheroidalRadialFactor SpheroidalS1 SpheroidalS1Prime SpheroidalS2 SpheroidalS2Prime Splice SplicedDistribution SplineClosed SplineDegree SplineKnots SplineWeights Split SplitBy SpokenString Sqrt SqrtBox SqrtBoxOptions Square SquaredEuclideanDistance SquareFreeQ SquareIntersection SquaresR SquareSubset SquareSubsetEqual SquareSuperset SquareSupersetEqual SquareUnion SquareWave StabilityMargins StabilityMarginsStyle StableDistribution Stack StackBegin StackComplete StackInhibit StandardDeviation StandardDeviationFilter StandardForm Standardize StandbyDistribution Star StarGraph StartAsynchronousTask StartingStepSize StartOfLine StartOfString StartScheduledTask StartupSound StateDimensions StateFeedbackGains StateOutputEstimator StateResponse StateSpaceModel StateSpaceRealization StateSpaceTransform StationaryDistribution StationaryWaveletPacketTransform StationaryWaveletTransform StatusArea StatusCentrality StepMonitor StieltjesGamma StirlingS1 StirlingS2 StopAsynchronousTask StopScheduledTask StrataVariables StratonovichProcess StreamColorFunction StreamColorFunctionScaling StreamDensityPlot StreamPlot StreamPoints StreamPosition Streams StreamScale StreamStyle String StringBreak StringByteCount StringCases StringCount StringDrop StringExpression StringForm StringFormat StringFreeQ StringInsert StringJoin StringLength StringMatchQ StringPosition StringQ StringReplace StringReplaceList StringReplacePart StringReverse StringRotateLeft StringRotateRight StringSkeleton StringSplit StringTake StringToStream StringTrim StripBoxes StripOnInput StripWrapperBoxes StrokeForm StructuralImportance StructuredArray StructuredSelection StruveH StruveL Stub StudentTDistribution Style StyleBox StyleBoxAutoDelete StyleBoxOptions StyleData StyleDefinitions StyleForm StyleKeyMapping StyleMenuListing StyleNameDialogSettings StyleNames StylePrint StyleSheetPath Subfactorial Subgraph SubMinus SubPlus SubresultantPolynomialRemainders ' +
	      'SubresultantPolynomials Subresultants Subscript SubscriptBox SubscriptBoxOptions Subscripted Subset SubsetEqual Subsets SubStar Subsuperscript SubsuperscriptBox SubsuperscriptBoxOptions Subtract SubtractFrom SubValues Succeeds SucceedsEqual SucceedsSlantEqual SucceedsTilde SuchThat Sum SumConvergence Sunday SuperDagger SuperMinus SuperPlus Superscript SuperscriptBox SuperscriptBoxOptions Superset SupersetEqual SuperStar Surd SurdForm SurfaceColor SurfaceGraphics SurvivalDistribution SurvivalFunction SurvivalModel SurvivalModelFit SuspendPacket SuzukiDistribution SuzukiGroupSuz SwatchLegend Switch Symbol SymbolName SymletWavelet Symmetric SymmetricGroup SymmetricMatrixQ SymmetricPolynomial SymmetricReduction Symmetrize SymmetrizedArray SymmetrizedArrayRules SymmetrizedDependentComponents SymmetrizedIndependentComponents SymmetrizedReplacePart SynchronousInitialization SynchronousUpdating Syntax SyntaxForm SyntaxInformation SyntaxLength SyntaxPacket SyntaxQ SystemDialogInput SystemException SystemHelpPath SystemInformation SystemInformationData SystemOpen SystemOptions SystemsModelDelay SystemsModelDelayApproximate SystemsModelDelete SystemsModelDimensions SystemsModelExtract SystemsModelFeedbackConnect SystemsModelLabels SystemsModelOrder SystemsModelParallelConnect SystemsModelSeriesConnect SystemsModelStateFeedbackConnect SystemStub ' +
	      'Tab TabFilling Table TableAlignments TableDepth TableDirections TableForm TableHeadings TableSpacing TableView TableViewBox TabSpacings TabView TabViewBox TabViewBoxOptions TagBox TagBoxNote TagBoxOptions TaggingRules TagSet TagSetDelayed TagStyle TagUnset Take TakeWhile Tally Tan Tanh TargetFunctions TargetUnits TautologyQ TelegraphProcess TemplateBox TemplateBoxOptions TemplateSlotSequence TemporalData Temporary TemporaryVariable TensorContract TensorDimensions TensorExpand TensorProduct TensorQ TensorRank TensorReduce TensorSymmetry TensorTranspose TensorWedge Tetrahedron TetrahedronBox TetrahedronBoxOptions TeXForm TeXSave Text Text3DBox Text3DBoxOptions TextAlignment TextBand TextBoundingBox TextBox TextCell TextClipboardType TextData TextForm TextJustification TextLine TextPacket TextParagraph TextRecognize TextRendering TextStyle Texture TextureCoordinateFunction TextureCoordinateScaling Therefore ThermometerGauge Thick Thickness Thin Thinning ThisLink ThompsonGroupTh Thread ThreeJSymbol Threshold Through Throw Thumbnail Thursday Ticks TicksStyle Tilde TildeEqual TildeFullEqual TildeTilde TimeConstrained TimeConstraint Times TimesBy TimeSeriesForecast TimeSeriesInvertibility TimeUsed TimeValue TimeZone Timing Tiny TitleGrouping TitsGroupT ToBoxes ToCharacterCode ToColor ToContinuousTimeModel ToDate ToDiscreteTimeModel ToeplitzMatrix ToExpression ToFileName Together Toggle ToggleFalse Toggler TogglerBar TogglerBox TogglerBoxOptions ToHeldExpression ToInvertibleTimeSeries TokenWords Tolerance ToLowerCase ToNumberField TooBig Tooltip TooltipBox TooltipBoxOptions TooltipDelay TooltipStyle Top TopHatTransform TopologicalSort ToRadicals ToRules ToString Total TotalHeight TotalVariationFilter TotalWidth TouchscreenAutoZoom TouchscreenControlPlacement ToUpperCase Tr Trace TraceAbove TraceAction TraceBackward TraceDepth TraceDialog TraceForward TraceInternal TraceLevel TraceOff TraceOn TraceOriginal TracePrint TraceScan TrackedSymbols TradingChart TraditionalForm TraditionalFunctionNotation TraditionalNotation TraditionalOrder TransferFunctionCancel TransferFunctionExpand TransferFunctionFactor TransferFunctionModel TransferFunctionPoles TransferFunctionTransform TransferFunctionZeros TransformationFunction TransformationFunctions TransformationMatrix TransformedDistribution TransformedField Translate TranslationTransform TransparentColor Transpose TreeForm TreeGraph TreeGraphQ TreePlot TrendStyle TriangleWave TriangularDistribution Trig TrigExpand TrigFactor TrigFactorList Trigger TrigReduce TrigToExp TrimmedMean True TrueQ TruncatedDistribution TsallisQExponentialDistribution TsallisQGaussianDistribution TTest Tube TubeBezierCurveBox TubeBezierCurveBoxOptions TubeBox TubeBSplineCurveBox TubeBSplineCurveBoxOptions Tuesday TukeyLambdaDistribution TukeyWindow Tuples TuranGraph TuringMachine ' +
	      'Transparent ' +
	      'UnateQ Uncompress Undefined UnderBar Underflow Underlined Underoverscript UnderoverscriptBox UnderoverscriptBoxOptions Underscript UnderscriptBox UnderscriptBoxOptions UndirectedEdge UndirectedGraph UndirectedGraphQ UndocumentedTestFEParserPacket UndocumentedTestGetSelectionPacket Unequal Unevaluated UniformDistribution UniformGraphDistribution UniformSumDistribution Uninstall Union UnionPlus Unique UnitBox UnitConvert UnitDimensions Unitize UnitRootTest UnitSimplify UnitStep UnitTriangle UnitVector Unprotect UnsameQ UnsavedVariables Unset UnsetShared UntrackedVariables Up UpArrow UpArrowBar UpArrowDownArrow Update UpdateDynamicObjects UpdateDynamicObjectsSynchronous UpdateInterval UpDownArrow UpEquilibrium UpperCaseQ UpperLeftArrow UpperRightArrow UpperTriangularize Upsample UpSet UpSetDelayed UpTee UpTeeArrow UpValues URL URLFetch URLFetchAsynchronous URLSave URLSaveAsynchronous UseGraphicsRange Using UsingFrontEnd ' +
	      'V2Get ValidationLength Value ValueBox ValueBoxOptions ValueForm ValueQ ValuesData Variables Variance VarianceEquivalenceTest VarianceEstimatorFunction VarianceGammaDistribution VarianceTest VectorAngle VectorColorFunction VectorColorFunctionScaling VectorDensityPlot VectorGlyphData VectorPlot VectorPlot3D VectorPoints VectorQ Vectors VectorScale VectorStyle Vee Verbatim Verbose VerboseConvertToPostScriptPacket VerifyConvergence VerifySolutions VerifyTestAssumptions Version VersionNumber VertexAdd VertexCapacity VertexColors VertexComponent VertexConnectivity VertexCoordinateRules VertexCoordinates VertexCorrelationSimilarity VertexCosineSimilarity VertexCount VertexCoverQ VertexDataCoordinates VertexDegree VertexDelete VertexDiceSimilarity VertexEccentricity VertexInComponent VertexInDegree VertexIndex VertexJaccardSimilarity VertexLabeling VertexLabels VertexLabelStyle VertexList VertexNormals VertexOutComponent VertexOutDegree VertexQ VertexRenderingFunction VertexReplace VertexShape VertexShapeFunction VertexSize VertexStyle VertexTextureCoordinates VertexWeight Vertical VerticalBar VerticalForm VerticalGauge VerticalSeparator VerticalSlider VerticalTilde ViewAngle ViewCenter ViewMatrix ViewPoint ViewPointSelectorSettings ViewPort ViewRange ViewVector ViewVertical VirtualGroupData Visible VisibleCell VoigtDistribution VonMisesDistribution ' +
	      'WaitAll WaitAsynchronousTask WaitNext WaitUntil WakebyDistribution WalleniusHypergeometricDistribution WaringYuleDistribution WatershedComponents WatsonUSquareTest WattsStrogatzGraphDistribution WaveletBestBasis WaveletFilterCoefficients WaveletImagePlot WaveletListPlot WaveletMapIndexed WaveletMatrixPlot WaveletPhi WaveletPsi WaveletScale WaveletScalogram WaveletThreshold WeaklyConnectedComponents WeaklyConnectedGraphQ WeakStationarity WeatherData WeberE Wedge Wednesday WeibullDistribution WeierstrassHalfPeriods WeierstrassInvariants WeierstrassP WeierstrassPPrime WeierstrassSigma WeierstrassZeta WeightedAdjacencyGraph WeightedAdjacencyMatrix WeightedData WeightedGraphQ Weights WelchWindow WheelGraph WhenEvent Which While White Whitespace WhitespaceCharacter WhittakerM WhittakerW WienerFilter WienerProcess WignerD WignerSemicircleDistribution WilksW WilksWTest WindowClickSelect WindowElements WindowFloating WindowFrame WindowFrameElements WindowMargins WindowMovable WindowOpacity WindowSelected WindowSize WindowStatusArea WindowTitle WindowToolbars WindowWidth With WolframAlpha WolframAlphaDate WolframAlphaQuantity WolframAlphaResult Word WordBoundary WordCharacter WordData WordSearch WordSeparators WorkingPrecision Write WriteString Wronskian ' +
	      'XMLElement XMLObject Xnor Xor ' +
	      'Yellow YuleDissimilarity ' +
	      'ZernikeR ZeroSymmetric ZeroTest ZeroWidthTimes Zeta ZetaZero ZipfDistribution ZTest ZTransform ' +
	      '$Aborted $ActivationGroupID $ActivationKey $ActivationUserRegistered $AddOnsDirectory $AssertFunction $Assumptions $AsynchronousTask $BaseDirectory $BatchInput $BatchOutput $BoxForms $ByteOrdering $Canceled $CharacterEncoding $CharacterEncodings $CommandLine $CompilationTarget $ConditionHold $ConfiguredKernels $Context $ContextPath $ControlActiveSetting $CreationDate $CurrentLink $DateStringFormat $DefaultFont $DefaultFrontEnd $DefaultImagingDevice $DefaultPath $Display $DisplayFunction $DistributedContexts $DynamicEvaluation $Echo $Epilog $ExportFormats $Failed $FinancialDataSource $FormatType $FrontEnd $FrontEndSession $GeoLocation $HistoryLength $HomeDirectory $HTTPCookies $IgnoreEOF $ImagingDevices $ImportFormats $InitialDirectory $Input $InputFileName $InputStreamMethods $Inspector $InstallationDate $InstallationDirectory $InterfaceEnvironment $IterationLimit $KernelCount $KernelID $Language $LaunchDirectory $LibraryPath $LicenseExpirationDate $LicenseID $LicenseProcesses $LicenseServer $LicenseSubprocesses $LicenseType $Line $Linked $LinkSupported $LoadedFiles $MachineAddresses $MachineDomain $MachineDomains $MachineEpsilon $MachineID $MachineName $MachinePrecision $MachineType $MaxExtraPrecision $MaxLicenseProcesses $MaxLicenseSubprocesses $MaxMachineNumber $MaxNumber $MaxPiecewiseCases $MaxPrecision $MaxRootDegree $MessageGroups $MessageList $MessagePrePrint $Messages $MinMachineNumber $MinNumber $MinorReleaseNumber $MinPrecision $ModuleNumber $NetworkLicense $NewMessage $NewSymbol $Notebooks $NumberMarks $Off $OperatingSystem $Output $OutputForms $OutputSizeLimit $OutputStreamMethods $Packages $ParentLink $ParentProcessID $PasswordFile $PatchLevelID $Path $PathnameSeparator $PerformanceGoal $PipeSupported $Post $Pre $PreferencesDirectory $PrePrint $PreRead $PrintForms $PrintLiteral $ProcessID $ProcessorCount $ProcessorType $ProductInformation $ProgramName $RandomState $RecursionLimit $ReleaseNumber $RootDirectory $ScheduledTask $ScriptCommandLine $SessionID $SetParentLink $SharedFunctions $SharedVariables $SoundDisplay $SoundDisplayFunction $SuppressInputFormHeads $SynchronousEvaluation $SyntaxHandler $System $SystemCharacterEncoding $SystemID $SystemWordLength $TemporaryDirectory $TemporaryPrefix $TextStyle $TimedOut $TimeUnit $TimeZone $TopDirectory $TraceOff $TraceOn $TracePattern $TracePostAction $TracePreAction $Urgent $UserAddOnsDirectory $UserBaseDirectory $UserDocumentsDirectory $UserName $Version $VersionNumber',
	    contains: [
	      {
	        className: "comment",
	        begin: /\(\*/, end: /\*\)/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'list',
	        begin: /\{/, end: /\}/,
	        illegal: /:/
	      }
	    ]
	  };
	};

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMON_CONTAINS = [
	    hljs.C_NUMBER_MODE,
	    {
	      className: 'string',
	      begin: '\'', end: '\'',
	      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	    }
	  ];
	  var TRANSPOSE = {
	    relevance: 0,
	    contains: [
	      {
	        className: 'operator', begin: /'['\.]*/
	      }
	    ]
	  };
	
	  return {
	    keywords: {
	      keyword:
	        'break case catch classdef continue else elseif end enumerated events for function ' +
	        'global if methods otherwise parfor persistent properties return spmd switch try while',
	      built_in:
	        'sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan ' +
	        'atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot ' +
	        'cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog ' +
	        'realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal ' +
	        'cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli ' +
	        'besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma ' +
	        'gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms ' +
	        'nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones ' +
	        'eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ' +
	        'ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril ' +
	        'triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute ' +
	        'shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan ' +
	        'isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal ' +
	        'rosser toeplitz vander wilkinson'
	    },
	    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
	    contains: [
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '$',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	              className: 'params',
	              begin: '\\(', end: '\\)'
	          },
	          {
	              className: 'params',
	              begin: '\\[', end: '\\]'
	          }
	        ]
	      },
	      {
	        begin: /[a-zA-Z_][a-zA-Z_0-9]*'['\.]*/,
	        returnBegin: true,
	        relevance: 0,
	        contains: [
	          {begin: /[a-zA-Z_][a-zA-Z_0-9]*/, relevance: 0},
	          TRANSPOSE.contains[0]
	        ]
	      },
	      {
	        className: 'matrix',
	        begin: '\\[', end: '\\]',
	        contains: COMMON_CONTAINS,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      {
	        className: 'cell',
	        begin: '\\{', end: /}/,
	        contains: COMMON_CONTAINS,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      {
	        // transpose operators at the end of a function call
	        begin: /\)/,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      hljs.COMMENT('^\\s*\\%\\{\\s*$', '^\\s*\\%\\}\\s*$'),
	      hljs.COMMENT('\\%', '$')
	    ].concat(COMMON_CONTAINS)
	  };
	};

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords:
	      'int float string vector matrix if else switch case default while do for in break ' +
	      'continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic ' +
	      'addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey ' +
	      'affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve ' +
	      'alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor ' +
	      'animDisplay animView annotate appendStringArray applicationName applyAttrPreset ' +
	      'applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx ' +
	      'artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu ' +
	      'artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand ' +
	      'assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface ' +
	      'attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu ' +
	      'attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp ' +
	      'attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery ' +
	      'autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults ' +
	      'bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership ' +
	      'bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType ' +
	      'boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu ' +
	      'buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge ' +
	      'cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch ' +
	      'catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox ' +
	      'character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp ' +
	      'checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip ' +
	      'clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore ' +
	      'closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter ' +
	      'cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color ' +
	      'colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp ' +
	      'colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem ' +
	      'componentEditor compositingInterop computePolysetVolume condition cone confirmDialog ' +
	      'connectAttr connectControl connectDynamic connectJoint connectionInfo constrain ' +
	      'constrainValue constructionHistory container containsMultibyte contextInfo control ' +
	      'convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation ' +
	      'convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache ' +
	      'cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel ' +
	      'cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver ' +
	      'cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor ' +
	      'createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer ' +
	      'createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse ' +
	      'currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx ' +
	      'curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface ' +
	      'curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox ' +
	      'defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete ' +
	      'deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes ' +
	      'delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo ' +
	      'dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable ' +
	      'disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected ' +
	      'displayColor displayCull displayLevelOfDetail displayPref displayRGBColor ' +
	      'displaySmoothness displayStats displayString displaySurface distanceDimContext ' +
	      'distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct ' +
	      'doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator ' +
	      'duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression ' +
	      'dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor ' +
	      'dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers ' +
	      'editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor ' +
	      'editorTemplate effector emit emitter enableDevice encodeString endString endsWith env ' +
	      'equivalent equivalentTol erf error eval evalDeferred evalEcho event ' +
	      'exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp ' +
	      'expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof ' +
	      'fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo ' +
	      'filetest filletCurve filter filterCurve filterExpand filterStudioImport ' +
	      'findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster ' +
	      'finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar ' +
	      'floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo ' +
	      'fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint ' +
	      'frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss ' +
	      'geometryConstraint getApplicationVersionAsFloat getAttr getClassification ' +
	      'getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes ' +
	      'getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender ' +
	      'glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl ' +
	      'gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid ' +
	      'gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap ' +
	      'HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor ' +
	      'HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached ' +
	      'HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel ' +
	      'headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey ' +
	      'hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender ' +
	      'hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox ' +
	      'iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ' +
	      'ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ' +
	      'ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform ' +
	      'insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance ' +
	      'instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp ' +
	      'interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf ' +
	      'isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect ' +
	      'itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx ' +
	      'jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner ' +
	      'keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx ' +
	      'keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx ' +
	      'keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx ' +
	      'keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor ' +
	      'layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList ' +
	      'lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep ' +
	      'listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory ' +
	      'listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation ' +
	      'listNodeTypes listPanelCategories listRelatives listSets listTransforms ' +
	      'listUnselected listerEditor loadFluid loadNewShelf loadPlugin ' +
	      'loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log ' +
	      'longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive ' +
	      'makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext ' +
	      'manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx ' +
	      'manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout ' +
	      'menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp ' +
	      'mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move ' +
	      'moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute ' +
	      'nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast ' +
	      'nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint ' +
	      'normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect ' +
	      'nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref ' +
	      'nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType ' +
	      'objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface ' +
	      'offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit ' +
	      'orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier ' +
	      'paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration ' +
	      'panelHistory paramDimContext paramDimension paramLocator parent parentConstraint ' +
	      'particle particleExists particleInstancer particleRenderInfo partition pasteKey ' +
	      'pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture ' +
	      'pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo ' +
	      'pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult ' +
	      'pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend ' +
	      'polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal ' +
	      'polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge ' +
	      'polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge ' +
	      'polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet ' +
	      'polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet ' +
	      'polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection ' +
	      'polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge ' +
	      'polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet ' +
	      'polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix ' +
	      'polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut ' +
	      'polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet ' +
	      'polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge ' +
	      'polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex ' +
	      'polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection ' +
	      'polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection ' +
	      'polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint ' +
	      'polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate ' +
	      'polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge ' +
	      'polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing ' +
	      'polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet ' +
	      'polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace ' +
	      'popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer ' +
	      'projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx ' +
	      'propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd ' +
	      'python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection ' +
	      'radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl ' +
	      'readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference ' +
	      'referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE ' +
	      'registerPluginResource rehash reloadImage removeJoint removeMultiInstance ' +
	      'removePanelCategory rename renameAttr renameSelectionList renameUI render ' +
	      'renderGlobalsNode renderInfo renderLayerButton renderLayerParent ' +
	      'renderLayerPostProcess renderLayerUnparent renderManip renderPartition ' +
	      'renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor ' +
	      'renderWindowSelectContext renderer reorder reorderDeformers requires reroot ' +
	      'resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget ' +
	      'reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx ' +
	      'rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout ' +
	      'runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage ' +
	      'saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale ' +
	      'scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor ' +
	      'sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable ' +
	      'scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt ' +
	      'searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey ' +
	      'selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType ' +
	      'selectedNodes selectionConnection separator setAttr setAttrEnumResource ' +
	      'setAttrMapping setAttrNiceNameResource setConstraintRestPosition ' +
	      'setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr ' +
	      'setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe ' +
	      'setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag ' +
	      'setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject ' +
	      'setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets ' +
	      'shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare ' +
	      'shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField ' +
	      'shortNameOf showHelp showHidden showManipCtx showSelectionInTitle ' +
	      'showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface ' +
	      'size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep ' +
	      'snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound ' +
	      'soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort ' +
	      'spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString ' +
	      'startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp ' +
	      'stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex ' +
	      'stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex ' +
	      'stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString ' +
	      'stringToStringArray strip stripPrefixFromName stroke subdAutoProjection ' +
	      'subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV ' +
	      'subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror ' +
	      'subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease ' +
	      'subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring ' +
	      'surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton ' +
	      'symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext ' +
	      'texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext ' +
	      'texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text ' +
	      'textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList ' +
	      'textToShelf textureDisplacePlane textureHairColor texturePlacementContext ' +
	      'textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath ' +
	      'toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower ' +
	      'toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper ' +
	      'trace track trackCtx transferAttributes transformCompare transformLimits translator ' +
	      'trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence ' +
	      'twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit ' +
	      'unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink ' +
	      'uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane ' +
	      'viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex ' +
	      'waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire ' +
	      'wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform',
	    illegal: '</',
	    contains: [
	      hljs.C_NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '`', end: '`',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        className: 'variable',
	        variants: [
	          {begin: '\\$\\d'},
	          {begin: '[\\$\\%\\@](\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)'},
	          {begin: '\\*(\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)', relevance: 0}
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	};

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      'module use_module import_module include_module end_module initialise ' +
	      'mutable initialize finalize finalise interface implementation pred ' +
	      'mode func type inst solver any_pred any_func is semidet det nondet ' +
	      'multi erroneous failure cc_nondet cc_multi typeclass instance where ' +
	      'pragma promise external trace atomic or_else require_complete_switch ' +
	      'require_det require_semidet require_multi require_nondet ' +
	      'require_cc_multi require_cc_nondet require_erroneous require_failure',
	    pragma:
	      'inline no_inline type_spec source_file fact_table obsolete memo ' +
	      'loop_check minimal_model terminates does_not_terminate ' +
	      'check_termination promise_equivalent_clauses',
	    preprocessor:
	      'foreign_proc foreign_decl foreign_code foreign_type ' +
	      'foreign_import_module foreign_export_enum foreign_export ' +
	      'foreign_enum may_call_mercury will_not_call_mercury thread_safe ' +
	      'not_thread_safe maybe_thread_safe promise_pure promise_semipure ' +
	      'tabled_for_io local untrailed trailed attach_to_io_state ' +
	      'can_pass_as_mercury_type stable will_not_throw_exception ' +
	      'may_modify_trail will_not_modify_trail may_duplicate ' +
	      'may_not_duplicate affects_liveness does_not_affect_liveness ' +
	      'doesnt_affect_liveness no_sharing unknown_sharing sharing',
	    built_in:
	      'some all not if then else true fail false try catch catch_any ' +
	      'semidet_true semidet_false semidet_fail impure_true impure semipure'
	  };
	
	  var TODO = {
	    className: 'label',
	    begin: 'XXX', end: '$', endsWithParent: true,
	    relevance: 0
	  };
	  var COMMENT = hljs.inherit(hljs.C_LINE_COMMENT_MODE, {begin: '%'});
	  var CCOMMENT = hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {relevance: 0});
	  COMMENT.contains.push(TODO);
	  CCOMMENT.contains.push(TODO);
	
	  var NUMCODE = {
	    className: 'number',
	    begin: "0'.\\|0[box][0-9a-fA-F]*"
	  };
	
	  var ATOM = hljs.inherit(hljs.APOS_STRING_MODE, {relevance: 0});
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {relevance: 0});
	  var STRING_FMT = {
	    className: 'constant',
	    begin: '\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]',
	    relevance: 0
	  };
	  STRING.contains.push(STRING_FMT);
	
	  var IMPLICATION = {
	    className: 'built_in',
	    variants: [
	      {begin: '<=>'},
	      {begin: '<=', relevance: 0},
	      {begin: '=>', relevance: 0},
	      {begin: '/\\\\'},
	      {begin: '\\\\/'}
	    ]
	  };
	
	  var HEAD_BODY_CONJUNCTION = {
	    className: 'built_in',
	    variants: [
	      {begin: ':-\\|-->'},
	      {begin: '=', relevance: 0}
	    ]
	  };
	
	  return {
	    aliases: ['m', 'moo'],
	    keywords: KEYWORDS,
	    contains: [
	      IMPLICATION,
	      HEAD_BODY_CONJUNCTION,
	      COMMENT,
	      CCOMMENT,
	      NUMCODE,
	      hljs.NUMBER_MODE,
	      ATOM,
	      STRING,
	      {begin: /:-/} // relevance booster
	    ]
	  };
	};

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords:
	      'environ vocabularies notations constructors definitions ' +
	      'registrations theorems schemes requirements begin end definition ' +
	      'registration cluster existence pred func defpred deffunc theorem ' +
	      'proof let take assume then thus hence ex for st holds consider ' +
	      'reconsider such that and in provided of as from be being by means ' +
	      'equals implies iff redefine define now not or attr is mode ' +
	      'suppose per cases set thesis contradiction scheme reserve struct ' +
	      'correctness compatibility coherence symmetry assymetry ' +
	      'reflexivity irreflexivity connectedness uniqueness commutativity ' +
	      'idempotence involutiveness projectivity',
	    contains: [
	      hljs.COMMENT('::', '$')
	    ]
	  };
	};

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    subLanguage: 'xml',
	    contains: [
	      {
	        className: 'preprocessor',
	        begin: '^__(END|DATA)__$'
	      },
	    // mojolicious line
	      {
	        begin: "^\\s*%{1,2}={0,2}", end: '$',
	        subLanguage: 'perl'
	      },
	    // mojolicious block
	      {
	        begin: "<%{1,2}={0,2}",
	        end: "={0,1}%>",
	        subLanguage: 'perl',
	        excludeBegin: true,
	        excludeEnd: true
	      }
	    ]
	  };
	};

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUMBER = {
	    className: 'number', relevance: 0,
	    variants: [
	      {
	        begin: '[$][a-fA-F0-9]+'
	      },
	      hljs.NUMBER_MODE
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    keywords: {
	      keyword: 'public private property continue exit extern new try catch ' +
	        'eachin not abstract final select case default const local global field ' +
	        'end if then else elseif endif while wend repeat until forever for to step next return module inline throw',
	
	      built_in: 'DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil ' +
	        'Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI',
	
	      literal: 'true false null and or shl shr mod'
	    },
	    illegal: /\/\*/,
	    contains: [
	      hljs.COMMENT('#rem', '#end'),
	      hljs.COMMENT(
	        "'",
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'function',
	        beginKeywords: 'function method', end: '[(=:]|$',
	        illegal: /\n/,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '$',
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        className: 'variable',
	        begin: '\\b(self|super)\\b'
	      },
	      {
	        className: 'preprocessor',
	        beginKeywords: 'import',
	        end: '$'
	      },
	      {
	        className: 'preprocessor',
	        begin: '\\s*#', end: '$',
	        keywords: 'if else elseif endif end then'
	      },
	      {
	        className: 'pi',
	        begin: '^\\s*strict\\b'
	      },
	      {
	        beginKeywords: 'alias', end: '=',
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      hljs.QUOTE_STRING_MODE,
	      NUMBER
	    ]
	  }
	};

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$\d+/},
	      {begin: /\$\{/, end: /}/},
	      {begin: '[\\$\\@]' + hljs.UNDERSCORE_IDENT_RE}
	    ]
	  };
	  var DEFAULT = {
	    endsWithParent: true,
	    lexemes: '[a-z/_]+',
	    keywords: {
	      built_in:
	        'on off yes no true false none blocked debug info notice warn error crit ' +
	        'select break last permanent redirect kqueue rtsig epoll poll /dev/poll'
	    },
	    relevance: 0,
	    illegal: '=>',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'string',
	        contains: [hljs.BACKSLASH_ESCAPE, VAR],
	        variants: [
	          {begin: /"/, end: /"/},
	          {begin: /'/, end: /'/}
	        ]
	      },
	      {
	        className: 'url',
	        begin: '([a-z]+):/', end: '\\s', endsWithParent: true, excludeEnd: true,
	        contains: [VAR]
	      },
	      {
	        className: 'regexp',
	        contains: [hljs.BACKSLASH_ESCAPE, VAR],
	        variants: [
	          {begin: "\\s\\^", end: "\\s|{|;", returnEnd: true},
	          // regexp locations (~, ~*)
	          {begin: "~\\*?\\s+", end: "\\s|{|;", returnEnd: true},
	          // *.example.com
	          {begin: "\\*(\\.[a-z\\-]+)+"},
	          // sub.example.*
	          {begin: "([a-z\\-]+\\.)+\\*"}
	        ]
	      },
	      // IP
	      {
	        className: 'number',
	        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
	      },
	      // units
	      {
	        className: 'number',
	        begin: '\\b\\d+[kKmMgGdshdwy]*\\b',
	        relevance: 0
	      },
	      VAR
	    ]
	  };
	
	  return {
	    aliases: ['nginxconf'],
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        begin: hljs.UNDERSCORE_IDENT_RE + '\\s', end: ';|{', returnBegin: true,
	        contains: [
	          {
	            className: 'title',
	            begin: hljs.UNDERSCORE_IDENT_RE,
	            starts: DEFAULT
	          }
	        ],
	        relevance: 0
	      }
	    ],
	    illegal: '[^\\s\\}]'
	  };
	};

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['nim'],
	    keywords: {
	      keyword: 'addr and as asm bind block break|0 case|0 cast const|0 continue|0 converter discard distinct|10 div do elif else|0 end|0 enum|0 except export finally for from generic if|0 import|0 in include|0 interface is isnot|10 iterator|10 let|0 macro method|10 mixin mod nil not notin|10 object|0 of or out proc|10 ptr raise ref|10 return shl shr static template try|0 tuple type|0 using|0 var|0 when while|0 with without xor yield',
	      literal: 'shared guarded stdin stdout stderr result|10 true false'
	    },
	    contains: [ {
	        className: 'decorator', // Actually pragma
	        begin: /{\./,
	        end: /\.}/,
	        relevance: 10
	      }, {
	        className: 'string',
	        begin: /[a-zA-Z]\w*"/,
	        end: /"/,
	        contains: [{begin: /""/}]
	      }, {
	        className: 'string',
	        begin: /([a-zA-Z]\w*)?"""/,
	        end: /"""/
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'type',
	        begin: /\b[A-Z]\w+\b/,
	        relevance: 0
	      }, {
	        className: 'type',
	        begin: /\b(int|int8|int16|int32|int64|uint|uint8|uint16|uint32|uint64|float|float32|float64|bool|char|string|cstring|pointer|expr|stmt|void|auto|any|range|array|openarray|varargs|seq|set|clong|culong|cchar|cschar|cshort|cint|csize|clonglong|cfloat|cdouble|clongdouble|cuchar|cushort|cuint|culonglong|cstringarray|semistatic)\b/
	      }, {
	        className: 'number',
	        begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/,
	        relevance: 0
	      }, {
	        className: 'number',
	        begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/,
	        relevance: 0
	      }, {
	        className: 'number',
	        begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/,
	        relevance: 0
	      }, {
	        className: 'number',
	        begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/,
	        relevance: 0
	      },
	      hljs.HASH_COMMENT_MODE
	    ]
	  }
	};

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NIX_KEYWORDS = {
	    keyword: 'rec with let in inherit assert if else then',
	    constant: 'true false or and null',
	    built_in:
	      'import abort baseNameOf dirOf isNull builtins map removeAttrs throw toString derivation'
	  };
	  var ANTIQUOTE = {
	    className: 'subst',
	    begin: /\$\{/,
	    end: /}/,
	    keywords: NIX_KEYWORDS
	  };
	  var ATTRS = {
	    className: 'variable',
	    // TODO: we have to figure out a way how to exclude \s*=
	    begin: /[a-zA-Z0-9-_]+(\s*=)/,
	    relevance: 0
	  };
	  var SINGLE_QUOTE = {
	    className: 'string',
	    begin: "''",
	    end: "''",
	    contains: [
	      ANTIQUOTE
	    ]
	  };
	  var DOUBLE_QUOTE = {
	    className: 'string',
	    begin: '"',
	    end: '"',
	    contains: [
	      ANTIQUOTE
	    ]
	  };
	  var EXPRESSIONS = [
	    hljs.NUMBER_MODE,
	    hljs.HASH_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    SINGLE_QUOTE,
	    DOUBLE_QUOTE,
	    ATTRS
	  ];
	  ANTIQUOTE.contains = EXPRESSIONS;
	  return {
	    aliases: ["nixos"],
	    keywords: NIX_KEYWORDS,
	    contains: EXPRESSIONS
	  };
	};

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CONSTANTS = {
	    className: 'symbol',
	    begin: '\\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)'
	  };
	
	  var DEFINES = {
	    // ${defines}
	    className: 'constant',
	    begin: '\\$+{[a-zA-Z0-9_]+}'
	  };
	
	  var VARIABLES = {
	    // $variables
	    className: 'variable',
	    begin: '\\$+[a-zA-Z0-9_]+',
	    illegal: '\\(\\){}'
	  };
	
	  var LANGUAGES = {
	    // $(language_strings)
	    className: 'constant',
	    begin: '\\$+\\([a-zA-Z0-9_]+\\)'
	  };
	
	  var PARAMETERS = {
	    // command parameters
	    className: 'params',
	    begin: '(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)'
	  };
	
	  var COMPILER ={
	    // !compiler_flags
	    className: 'constant',
	    begin: '\\!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversionsystem|ifdef|ifmacrodef|ifmacrondef|ifndef|if|include|insertmacro|macroend|macro|makensis|packhdr|searchparse|searchreplace|tempfile|undef|verbose|warning)'
	  };
	
	  return {
	    case_insensitive: false,
	    keywords: {
	      keyword:
	      'Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileSeek FileWrite FileWriteByte FileWriteUTF16LE FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI FunctionEnd GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText IntCmp IntCmpU IntFmt IntOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PageExEnd Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionEnd SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionGroupEnd SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetPluginUnload SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption SubSectionEnd Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegStr WriteUninstaller XPStyle',
	      literal:
	      'admin all auto both colored current false force hide highest lastused leave listonly none normal notset off on open print show silent silentlog smooth textonly true user '
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        illegal: '\\n',
	        contains: [
	          { // $\n, $\r, $\t, $$
	            className: 'symbol',
	            begin: '\\$(\\\\(n|r|t)|\\$)'
	          },
	          CONSTANTS,
	          DEFINES,
	          VARIABLES,
	          LANGUAGES
	        ]
	      },
	      hljs.COMMENT(
	        ';',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'function',
	        beginKeywords: 'Function PageEx Section SectionGroup SubSection', end: '$'
	      },
	      COMPILER,
	      DEFINES,
	      VARIABLES,
	      LANGUAGES,
	      PARAMETERS,
	      hljs.NUMBER_MODE,
	      { // plug::ins
	        className: 'literal',
	        begin: hljs.IDENT_RE + '::' + hljs.IDENT_RE
	      }
	    ]
	  };
	};

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var API_CLASS = {
	    className: 'built_in',
	    begin: '(AV|CA|CF|CG|CI|MK|MP|NS|UI)\\w+',
	  };
	  var OBJC_KEYWORDS = {
	    keyword:
	      'int float while char export sizeof typedef const struct for union ' +
	      'unsigned long volatile static bool mutable if do return goto void ' +
	      'enum else break extern asm case short default double register explicit ' +
	      'signed typename this switch continue wchar_t inline readonly assign ' +
	      'readwrite self @synchronized id typeof ' +
	      'nonatomic super unichar IBOutlet IBAction strong weak copy ' +
	      'in out inout bycopy byref oneway __strong __weak __block __autoreleasing ' +
	      '@private @protected @public @try @property @end @throw @catch @finally ' +
	      '@autoreleasepool @synthesize @dynamic @selector @optional @required',
	    literal:
	      'false true FALSE TRUE nil YES NO NULL',
	    built_in:
	      'BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once'
	  };
	  var LEXEMES = /[a-zA-Z@][a-zA-Z0-9_]*/;
	  var CLASS_KEYWORDS = '@interface @class @protocol @implementation';
	  return {
	    aliases: ['mm', 'objc', 'obj-c'],
	    keywords: OBJC_KEYWORDS,
	    lexemes: LEXEMES,
	    illegal: '</',
	    contains: [
	      API_CLASS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        variants: [
	          {
	            begin: '@"', end: '"',
	            illegal: '\\n',
	            contains: [hljs.BACKSLASH_ESCAPE]
	          },
	          {
	            begin: '\'', end: '[^\\\\]\'',
	            illegal: '[^\\\\][^\']'
	          }
	        ]
	      },
	      {
	        className: 'preprocessor',
	        begin: '#',
	        end: '$',
	        contains: [
	          {
	            className: 'title',
	            variants: [
	              { begin: '\"', end: '\"' },
	              { begin: '<', end: '>' }
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        begin: '(' + CLASS_KEYWORDS.split(' ').join('|') + ')\\b', end: '({|$)', excludeEnd: true,
	        keywords: CLASS_KEYWORDS, lexemes: LEXEMES,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        className: 'variable',
	        begin: '\\.'+hljs.UNDERSCORE_IDENT_RE,
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  /* missing support for heredoc-like string (OCaml 4.0.2+) */
	  return {
	    aliases: ['ml'],
	    keywords: {
	      keyword:
	        'and as assert asr begin class constraint do done downto else end ' +
	        'exception external for fun function functor if in include ' +
	        'inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method ' +
	        'mod module mutable new object of open! open or private rec sig struct ' +
	        'then to try type val! val virtual when while with ' +
	        /* camlp4 */
	        'parser value',
	      built_in:
	        /* built-in types */
	        'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit ' +
	        /* (some) types in Pervasives */
	        'in_channel out_channel ref',
	      literal:
	        'true false'
	    },
	    illegal: /\/\/|>>/,
	    lexemes: '[a-z_]\\w*!?',
	    contains: [
	      {
	        className: 'literal',
	        begin: '\\[(\\|\\|)?\\]|\\(\\)',
	        relevance: 0
	      },
	      hljs.COMMENT(
	        '\\(\\*',
	        '\\*\\)',
	        {
	          contains: ['self']
	        }
	      ),
	      { /* type variable */
	        className: 'symbol',
	        begin: '\'[A-Za-z_](?!\')[\\w\']*'
	        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
	      },
	      { /* polymorphic variant */
	        className: 'tag',
	        begin: '`[A-Z][\\w\']*'
	      },
	      { /* module or constructor */
	        className: 'type',
	        begin: '\\b[A-Z][\\w\']*',
	        relevance: 0
	      },
	      { /* don't color identifiers, but safely catch all identifiers with '*/
	        begin: '[a-z_]\\w*\'[\\w\']*'
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'char', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      {
	        className: 'number',
	        begin:
	          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
	          '0[oO][0-7_]+[Lln]?|' +
	          '0[bB][01_]+[Lln]?|' +
	          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
	        relevance: 0
	      },
	      {
	        begin: /[-=]>/ // relevance booster
	      }
	    ]
	  }
	};

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
		var SPECIAL_VARS = {
			className: 'keyword',
			begin: '\\$(f[asn]|t|vp[rtd]|children)'
		},
		LITERALS = {
			className: 'literal',
			begin: 'false|true|PI|undef'
		},
		NUMBERS = {
			className: 'number',
			begin: '\\b\\d+(\\.\\d+)?(e-?\\d+)?', //adds 1e5, 1e-10
			relevance: 0
		},
		STRING = hljs.inherit(hljs.QUOTE_STRING_MODE,{illegal: null}),
		PREPRO = {
			className: 'preprocessor',
			keywords: 'include use',
			begin: 'include|use <',
			end: '>'
		},
		PARAMS = {
			className: 'params',
			begin: '\\(', end: '\\)',
			contains: ['self', NUMBERS, STRING, SPECIAL_VARS, LITERALS]
		},
		MODIFIERS = {
			className: 'built_in',
			begin: '[*!#%]',
			relevance: 0
		},
		FUNCTIONS = {
			className: 'function',
			beginKeywords: 'module function',
			end: '\\=|\\{',
			contains: [PARAMS, hljs.UNDERSCORE_TITLE_MODE]
		};
	
		return {
			aliases: ['scad'],
			keywords: {
				keyword: 'function module include use for intersection_for if else \\%',
				literal: 'false true PI undef',
				built_in: 'circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign'
			},
			contains: [
				hljs.C_LINE_COMMENT_MODE,
				hljs.C_BLOCK_COMMENT_MODE,
				NUMBERS,
				PREPRO,
				STRING,
				SPECIAL_VARS,
				MODIFIERS,
				FUNCTIONS
			]
		}
	};

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var OXYGENE_KEYWORDS = 'abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue '+
	    'create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false '+
	    'final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited '+
	    'inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of '+
	    'old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly '+
	    'record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple '+
	    'type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal '+
	    'register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained';
	  var CURLY_COMMENT =  hljs.COMMENT(
	    '{',
	    '}',
	    {
	      relevance: 0
	    }
	  );
	  var PAREN_COMMENT = hljs.COMMENT(
	    '\\(\\*',
	    '\\*\\)',
	    {
	      relevance: 10
	    }
	  );
	  var STRING = {
	    className: 'string',
	    begin: '\'', end: '\'',
	    contains: [{begin: '\'\''}]
	  };
	  var CHAR_STRING = {
	    className: 'string', begin: '(#\\d+)+'
	  };
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'function constructor destructor procedure method', end: '[:;]',
	    keywords: 'function constructor|10 destructor|10 procedure|10 method|10',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        className: 'params',
	        begin: '\\(', end: '\\)',
	        keywords: OXYGENE_KEYWORDS,
	        contains: [STRING, CHAR_STRING]
	      },
	      CURLY_COMMENT, PAREN_COMMENT
	    ]
	  };
	  return {
	    case_insensitive: true,
	    keywords: OXYGENE_KEYWORDS,
	    illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
	    contains: [
	      CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
	      STRING, CHAR_STRING,
	      hljs.NUMBER_MODE,
	      FUNCTION,
	      {
	        className: 'class',
	        begin: '=\\bclass\\b', end: 'end;',
	        keywords: OXYGENE_KEYWORDS,
	        contains: [
	          STRING, CHAR_STRING,
	          CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
	          FUNCTION
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CURLY_SUBCOMMENT = hljs.COMMENT(
	    '{',
	    '}',
	    {
	      contains: ['self']
	    }
	  );
	  return {
	    subLanguage: 'xml', relevance: 0,
	    contains: [
	      hljs.COMMENT('^#', '$'),
	      hljs.COMMENT(
	        '\\^rem{',
	        '}',
	        {
	          relevance: 10,
	          contains: [
	            CURLY_SUBCOMMENT
	          ]
	        }
	      ),
	      {
	        className: 'preprocessor',
	        begin: '^@(?:BASE|USE|CLASS|OPTIONS)$',
	        relevance: 10
	      },
	      {
	        className: 'title',
	        begin: '@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$'
	      },
	      {
	        className: 'variable',
	        begin: '\\$\\{?[\\w\\-\\.\\:]+\\}?'
	      },
	      {
	        className: 'keyword',
	        begin: '\\^[\\w\\-\\.\\:]+'
	      },
	      {
	        className: 'number',
	        begin: '\\^#[0-9a-fA-F]+'
	      },
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PERL_KEYWORDS = 'getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ' +
	    'ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime ' +
	    'readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qq' +
	    'fileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent ' +
	    'shutdown dump chomp connect getsockname die socketpair close flock exists index shmget' +
	    'sub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr ' +
	    'unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 ' +
	    'getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline ' +
	    'endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand ' +
	    'mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink ' +
	    'getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr ' +
	    'untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link ' +
	    'getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller ' +
	    'lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and ' +
	    'sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 ' +
	    'chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach ' +
	    'tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedir' +
	    'ioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe ' +
	    'atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when';
	  var SUBST = {
	    className: 'subst',
	    begin: '[$@]\\{', end: '\\}',
	    keywords: PERL_KEYWORDS
	  };
	  var METHOD = {
	    begin: '->{', end: '}'
	    // contains defined later
	  };
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$\d/},
	      {begin: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},
	      {begin: /[\$%@][^\s\w{]/, relevance: 0}
	    ]
	  };
	  var STRING_CONTAINS = [hljs.BACKSLASH_ESCAPE, SUBST, VAR];
	  var PERL_DEFAULT_CONTAINS = [
	    VAR,
	    hljs.HASH_COMMENT_MODE,
	    hljs.COMMENT(
	      '^\\=\\w',
	      '\\=cut',
	      {
	        endsWithParent: true
	      }
	    ),
	    METHOD,
	    {
	      className: 'string',
	      contains: STRING_CONTAINS,
	      variants: [
	        {
	          begin: 'q[qwxr]?\\s*\\(', end: '\\)',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\[', end: '\\]',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\{', end: '\\}',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\|', end: '\\|',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\<', end: '\\>',
	          relevance: 5
	        },
	        {
	          begin: 'qw\\s+q', end: 'q',
	          relevance: 5
	        },
	        {
	          begin: '\'', end: '\'',
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: '"', end: '"'
	        },
	        {
	          begin: '`', end: '`',
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: '{\\w+}',
	          contains: [],
	          relevance: 0
	        },
	        {
	          begin: '\-?\\w+\\s*\\=\\>',
	          contains: [],
	          relevance: 0
	        }
	      ]
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    { // regexp container
	      begin: '(\\/\\/|' + hljs.RE_STARTERS_RE + '|\\b(split|return|print|reverse|grep)\\b)\\s*',
	      keywords: 'split return print reverse grep',
	      relevance: 0,
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        {
	          className: 'regexp',
	          begin: '(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*',
	          relevance: 10
	        },
	        {
	          className: 'regexp',
	          begin: '(m|qr)?/', end: '/[a-z]*',
	          contains: [hljs.BACKSLASH_ESCAPE],
	          relevance: 0 // allows empty "//" which is a common comment delimiter in other languages
	        }
	      ]
	    },
	    {
	      className: 'sub',
	      beginKeywords: 'sub', end: '(\\s*\\(.*?\\))?[;{]',
	      relevance: 5
	    },
	    {
	      className: 'operator',
	      begin: '-\\w\\b',
	      relevance: 0
	    },
	    {
	      begin: "^__DATA__$",
	      end: "^__END__$",
	      subLanguage: 'mojolicious',
	      contains: [
	        {
	            begin: "^@@.*",
	            end: "$",
	            className: "comment"
	        }
	      ]
	    }
	  ];
	  SUBST.contains = PERL_DEFAULT_CONTAINS;
	  METHOD.contains = PERL_DEFAULT_CONTAINS;
	
	  return {
	    aliases: ['pl'],
	    keywords: PERL_KEYWORDS,
	    contains: PERL_DEFAULT_CONTAINS
	  };
	};

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var MACRO = {
	    className: 'variable',
	    begin: /\$[\w\d#@][\w\d_]*/
	  };
	  var TABLE = {
	    className: 'variable',
	    begin: /</, end: />/
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/
	  };
	
	  return {
	    aliases: ['pf.conf'],
	    lexemes: /[a-z0-9_<>-]+/,
	    keywords: {
	      built_in: /* block match pass are "actions" in pf.conf(5), the rest are
	                 * lexically similar top-level commands.
	                 */
	        'block match pass load anchor|5 antispoof|10 set table',
	      keyword:
	        'in out log quick on rdomain inet inet6 proto from port os to route' +
	        'allow-opts divert-packet divert-reply divert-to flags group icmp-type' +
	        'icmp6-type label once probability recieved-on rtable prio queue' +
	        'tos tag tagged user keep fragment for os drop' +
	        'af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin' +
	        'source-hash static-port' +
	        'dup-to reply-to route-to' +
	        'parent bandwidth default min max qlimit' +
	        'block-policy debug fingerprints hostid limit loginterface optimization' +
	        'reassemble ruleset-optimization basic none profile skip state-defaults' +
	        'state-policy timeout' +
	        'const counters persist' +
	        'no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy' +
	        'source-track global rule max-src-nodes max-src-states max-src-conn' +
	        'max-src-conn-rate overload flush' +
	        'scrub|5 max-mss min-ttl no-df|10 random-id',
	      literal:
	        'all any no-route self urpf-failed egress|5 unknown'
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.NUMBER_MODE,
	      hljs.QUOTE_STRING_MODE,
	      MACRO,
	      TABLE
	    ]
	  };
	};

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VARIABLE = {
	    className: 'variable', begin: '\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*'
	  };
	  var PREPROCESSOR = {
	    className: 'preprocessor', begin: /<\?(php)?|\?>/
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, PREPROCESSOR],
	    variants: [
	      {
	        begin: 'b"', end: '"'
	      },
	      {
	        begin: 'b\'', end: '\''
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
	    ]
	  };
	  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
	  return {
	    aliases: ['php3', 'php4', 'php5', 'php6'],
	    case_insensitive: true,
	    keywords:
	      'and include_once list abstract global private echo interface as static endswitch ' +
	      'array null if endwhile or const for endforeach self var while isset public ' +
	      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
	      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
	      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
	      'enddeclare final try switch continue endfor endif declare unset true false ' +
	      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
	      'yield finally',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.HASH_COMMENT_MODE,
	      hljs.COMMENT(
	        '/\\*',
	        '\\*/',
	        {
	          contains: [
	            {
	              className: 'doctag',
	              begin: '@[A-Za-z]+'
	            },
	            PREPROCESSOR
	          ]
	        }
	      ),
	      hljs.COMMENT(
	        '__halt_compiler.+?;',
	        false,
	        {
	          endsWithParent: true,
	          keywords: '__halt_compiler',
	          lexemes: hljs.UNDERSCORE_IDENT_RE
	        }
	      ),
	      {
	        className: 'string',
	        begin: /<<<['"]?\w+['"]?$/, end: /^\w+;?$/,
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          {
	            className: 'subst',
	            variants: [
	              {begin: /\$\w+/},
	              {begin: /\{\$/, end: /\}/}
	            ]
	          }
	        ]
	      },
	      PREPROCESSOR,
	      VARIABLE,
	      {
	        // swallow composed identifiers to avoid parsing them as keywords
	        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
	        illegal: '\\$|\\[|%',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              'self',
	              VARIABLE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRING,
	              NUMBER
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        illegal: /[:\(\$"]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: ';',
	        illegal: /[\.']/,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        beginKeywords: 'use', end: ';',
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      },
	      STRING,
	      NUMBER
	    ]
	  };
	};

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var backtickEscape = {
	    begin: '`[\\s\\S]',
	    relevance: 0
	  };
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d][\w\d_:]*/}
	    ]
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/,
	    contains: [
	      backtickEscape,
	      VAR,
	      {
	        className: 'variable',
	        begin: /\$[A-z]/, end: /[^A-z]/
	      }
	    ]
	  };
	  var APOS_STRING = {
	    className: 'string',
	    begin: /'/, end: /'/
	  };
	
	  return {
	    aliases: ['ps'],
	    lexemes: /-?[A-z\.\-]+/,
	    case_insensitive: true,
	    keywords: {
	      keyword: 'if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch',
	      literal: '$null $true $false',
	      built_in: 'Add-Content Add-History Add-Member Add-PSSnapin Clear-Content Clear-Item Clear-Item Property Clear-Variable Compare-Object ConvertFrom-SecureString Convert-Path ConvertTo-Html ConvertTo-SecureString Copy-Item Copy-ItemProperty Export-Alias Export-Clixml Export-Console Export-Csv ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-Content Get-Credential Get-Culture Get-Date Get-EventLog Get-ExecutionPolicy Get-Help Get-History Get-Host Get-Item Get-ItemProperty Get-Location Get-Member Get-PfxCertificate Get-Process Get-PSDrive Get-PSProvider Get-PSSnapin Get-Service Get-TraceSource Get-UICulture Get-Unique Get-Variable Get-WmiObject Group-Object Import-Alias Import-Clixml Import-Csv Invoke-Expression Invoke-History Invoke-Item Join-Path Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Item New-ItemProperty New-Object New-PSDrive New-Service New-TimeSpan New-Variable Out-Default Out-File Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Remove-Item Remove-ItemProperty Remove-PSDrive Remove-PSSnapin Remove-Variable Rename-Item Rename-ItemProperty Resolve-Path Restart-Service Resume-Service Select-Object Select-String Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-Location Set-PSDebug Set-Service Set-TraceSource Set-Variable Sort-Object Split-Path Start-Service Start-Sleep Start-Transcript Stop-Process Stop-Service Stop-Transcript Suspend-Service Tee-Object Test-Path Trace-Command Update-FormatData Update-TypeData Where-Object Write-Debug Write-Error Write-Host Write-Output Write-Progress Write-Verbose Write-Warning',
	      operator: '-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace'
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.NUMBER_MODE,
	      QUOTE_STRING,
	      APOS_STRING,
	      VAR
	    ]
	  };
	};

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword: 'BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color ' +
	        'double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject ' +
	        'Object StringDict StringList Table TableRow XML ' +
	        // Java keywords
	        'false synchronized int abstract float private char boolean static null if const ' +
	        'for true while long throw strictfp finally protected import native final return void ' +
	        'enum else break transient new catch instanceof byte super volatile case assert short ' +
	        'package default double public try this switch continue throws protected public private',
	      constant: 'P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI',
	      variable: 'displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key ' +
	        'keyCode pixels focused frameCount frameRate height width',
	      title: 'setup draw',
	      built_in: 'size createGraphics beginDraw createShape loadShape PShape arc ellipse line point ' +
	        'quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint ' +
	        'curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex ' +
	        'endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap ' +
	        'strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased ' +
	        'mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour ' +
	        'millis minute month second year background clear colorMode fill noFill noStroke stroke alpha ' +
	        'blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY ' +
	        'screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ' +
	        'ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle ' +
	        'pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf ' +
	        'nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset ' +
	        'box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings ' +
	        'loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput ' +
	        'createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings ' +
	        'saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale ' +
	        'shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal ' +
	        'pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap ' +
	        'blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont ' +
	        'loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil ' +
	        'constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees ' +
	        'radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'built_in',
	        begin: '{', end: '}$',
	        excludeBegin: true, excludeEnd: true,
	        contains: [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE],
	        relevance: 0
	      },
	      {
	        className: 'filename',
	        begin: '[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}', end: ':',
	        excludeEnd: true
	      },
	      {
	        className: 'header',
	        begin: '(ncalls|tottime|cumtime)', end: '$',
	        keywords: 'ncalls tottime|10 cumtime|10 filename',
	        relevance: 10
	      },
	      {
	        className: 'summary',
	        begin: 'function calls', end: '$',
	        contains: [hljs.C_NUMBER_MODE],
	        relevance: 10
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'function',
	        begin: '\\(', end: '\\)$',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ],
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var ATOM = {
	
	    className: 'atom',
	    begin: /[a-z][A-Za-z0-9_]*/,
	    relevance: 0
	  };
	
	  var VAR = {
	
	    className: 'name',
	    variants: [
	      {begin: /[A-Z][a-zA-Z0-9_]*/},
	      {begin: /_[A-Za-z0-9_]*/},
	    ],
	    relevance: 0
	  };
	
	  var PARENTED = {
	
	    begin: /\(/,
	    end: /\)/,
	    relevance: 0
	  };
	
	  var LIST = {
	
	    begin: /\[/,
	    end: /\]/
	  };
	
	  var LINE_COMMENT = {
	
	    className: 'comment',
	    begin: /%/, end: /$/,
	    contains: [hljs.PHRASAL_WORDS_MODE]
	  };
	
	  var BACKTICK_STRING = {
	
	    className: 'string',
	    begin: /`/, end: /`/,
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	
	  var CHAR_CODE = {
	
	    className: 'string', // 0'a etc.
	    begin: /0\'(\\\'|.)/
	  };
	
	  var SPACE_CODE = {
	
	    className: 'string',
	    begin: /0\'\\s/ // 0'\s
	  };
	
	  var PRED_OP = { // relevance booster
	    begin: /:-/
	  };
	
	  var inner = [
	
	    ATOM,
	    VAR,
	    PARENTED,
	    PRED_OP,
	    LIST,
	    LINE_COMMENT,
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.QUOTE_STRING_MODE,
	    hljs.APOS_STRING_MODE,
	    BACKTICK_STRING,
	    CHAR_CODE,
	    SPACE_CODE,
	    hljs.C_NUMBER_MODE
	  ];
	
	  PARENTED.contains = inner;
	  LIST.contains = inner;
	
	  return {
	    contains: inner.concat([
	      {begin: /\.$/} // relevance booster
	    ])
	  };
	};

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword: 'package import option optional required repeated group',
	      built_in: 'double float int32 int64 uint32 uint64 sint32 sint64 ' +
	        'fixed32 fixed64 sfixed32 sfixed64 bool string bytes',
	      literal: 'true false'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'message enum service', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      },
	      {
	        className: 'function',
	        beginKeywords: 'rpc',
	        end: /;/, excludeEnd: true,
	        keywords: 'rpc returns'
	      },
	      {
	        className: 'constant',
	        begin: /^\s*[A-Z_]+/,
	        end: /\s*=/, excludeEnd: true
	      }
	    ]
	  };
	};

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var PUPPET_KEYWORDS = {
	    keyword:
	    /* language keywords */
	      'and case default else elsif false if in import enherits node or true undef unless main settings $string ',
	    literal:
	    /* metaparameters */
	      'alias audit before loglevel noop require subscribe tag ' +
	    /* normal attributes */
	      'owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check ' +
	      'en_address ip_address realname command environment hour monute month monthday special target weekday '+
	      'creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore ' +
	      'links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source ' +
	      'souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid '+
	      'ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel ' +
	      'native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options ' +
	      'device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use ' +
	      'message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform ' +
	      'responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running ' +
	      'start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age ' +
	      'password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled ' +
	      'enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist ' +
	      'priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey ' +
	      'sslverify mounted',
	    built_in:
	    /* core facts */
	      'architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers ' +
	      'domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces '+
	      'ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion ' +
	      'kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease ' +
	      'lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major ' +
	      'macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease '+
	      'operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion '+
	      'rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced '+
	      'selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime '+
	      'uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version'
	  };
	
	  var COMMENT = hljs.COMMENT('#', '$');
	
	  var IDENT_RE = '([A-Za-z_]|::)(\\w|::)*';
	
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE});
	
	  var VARIABLE = {className: 'variable', begin: '\\$' + IDENT_RE};
	
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/}
	    ]
	  };
	
	  return {
	    aliases: ['pp'],
	    contains: [
	      COMMENT,
	      VARIABLE,
	      STRING,
	      {
	        beginKeywords: 'class', end: '\\{|;',
	        illegal: /=/,
	        contains: [TITLE, COMMENT]
	      },
	      {
	        beginKeywords: 'define', end: /\{/,
	        contains: [
	          {
	            className: 'title', begin: hljs.IDENT_RE, endsParent: true
	          }
	        ]
	      },
	      {
	        begin: hljs.IDENT_RE + '\\s+\\{', returnBegin: true,
	        end: /\S/,
	        contains: [
	          {
	            className: 'name',
	            begin: hljs.IDENT_RE
	          },
	          {
	            begin: /\{/, end: /\}/,
	            keywords: PUPPET_KEYWORDS,
	            relevance: 0,
	            contains: [
	              STRING,
	              COMMENT,
	              {
	                begin:'[a-zA-Z_]+\\s*=>'
	              },
	              {
	                className: 'number',
	                begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	                relevance: 0
	              },
	              VARIABLE
	            ]
	          }
	        ],
	        relevance: 0
	      }
	    ]
	  }
	};

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PROMPT = {
	    className: 'prompt',  begin: /^(>>>|\.\.\.) /
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: /(u|b)?r?'''/, end: /'''/,
	        contains: [PROMPT],
	        relevance: 10
	      },
	      {
	        begin: /(u|b)?r?"""/, end: /"""/,
	        contains: [PROMPT],
	        relevance: 10
	      },
	      {
	        begin: /(u|r|ur)'/, end: /'/,
	        relevance: 10
	      },
	      {
	        begin: /(u|r|ur)"/, end: /"/,
	        relevance: 10
	      },
	      {
	        begin: /(b|br)'/, end: /'/
	      },
	      {
	        begin: /(b|br)"/, end: /"/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	  var NUMBER = {
	    className: 'number', relevance: 0,
	    variants: [
	      {begin: hljs.BINARY_NUMBER_RE + '[lLjJ]?'},
	      {begin: '\\b(0o[0-7]+)[lLjJ]?'},
	      {begin: hljs.C_NUMBER_RE + '[lLjJ]?'}
	    ]
	  };
	  var PARAMS = {
	    className: 'params',
	    begin: /\(/, end: /\)/,
	    contains: ['self', PROMPT, NUMBER, STRING]
	  };
	  return {
	    aliases: ['py', 'gyp'],
	    keywords: {
	      keyword:
	        'and elif is global as in if from raise for except finally print import pass return ' +
	        'exec else break not with class assert yield try while continue del or def lambda ' +
	        'async await nonlocal|10 None True False',
	      built_in:
	        'Ellipsis NotImplemented'
	    },
	    illegal: /(<\/|->|\?)/,
	    contains: [
	      PROMPT,
	      NUMBER,
	      STRING,
	      hljs.HASH_COMMENT_MODE,
	      {
	        variants: [
	          {className: 'function', beginKeywords: 'def', relevance: 10},
	          {className: 'class', beginKeywords: 'class'}
	        ],
	        end: /:/,
	        illegal: /[${=;\n,]/,
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      },
	      {
	        className: 'decorator',
	        begin: /^[\t ]*@/, end: /$/
	      },
	      {
	        begin: /\b(print|exec)\(/ // don’t highlight keywords-turned-functions in Python 3
	      }
	    ]
	  };
	};

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var Q_KEYWORDS = {
	  keyword:
	    'do while select delete by update from',
	  constant:
	    '0b 1b',
	  built_in:
	    'neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum',
	  typename:
	    '`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid'
	  };
	  return {
	  aliases:['k', 'kdb'],
	  keywords: Q_KEYWORDS,
	  lexemes: /\b(`?)[A-Za-z0-9_]+\b/,
	  contains: [
	  hljs.C_LINE_COMMENT_MODE,
	    hljs.QUOTE_STRING_MODE,
	    hljs.C_NUMBER_MODE
	     ]
	  };
	};

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*';
	
	  return {
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        begin: IDENT_RE,
	        lexemes: IDENT_RE,
	        keywords: {
	          keyword:
	            'function if in break next repeat else for return switch while try tryCatch ' +
	            'stop warning require library attach detach source setMethod setGeneric ' +
	            'setGroupGeneric setClass ...',
	          literal:
	            'NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 ' +
	            'NA_complex_|10'
	        },
	        relevance: 0
	      },
	      {
	        // hex value
	        className: 'number',
	        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
	        relevance: 0
	      },
	      {
	        // explicit integer
	        className: 'number',
	        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
	        relevance: 0
	      },
	      {
	        // number with trailing decimal
	        className: 'number',
	        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
	        relevance: 0
	      },
	      {
	        // number
	        className: 'number',
	        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      },
	      {
	        // number with leading decimal
	        className: 'number',
	        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      },
	
	      {
	        // escaped identifier
	        begin: '`',
	        end: '`',
	        relevance: 0
	      },
	
	      {
	        className: 'string',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        variants: [
	          {begin: '"', end: '"'},
	          {begin: "'", end: "'"}
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords:
	      'ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis ' +
	      'Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone ' +
	      'CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail ' +
	      'DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format ' +
	      'FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry ' +
	      'Hider Hyperboloid Identity Illuminate Imager Interior LightSource ' +
	      'MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte ' +
	      'MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option ' +
	      'Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples ' +
	      'PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection ' +
	      'Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ' +
	      'ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere ' +
	      'SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd ' +
	      'TransformPoints Translate TrimCurve WorldBegin WorldEnd',
	    illegal: '</',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENTIFIER = '[a-zA-Z-_][^\n{\r\n]+\\{';
	
	  return {
	    aliases: ['graph', 'instances'],
	    case_insensitive: true,
	    keywords: 'import',
	    contains: [
	      // Facet sections
	      {
	        className: 'facet',
	        begin: '^facet ' + IDENTIFIER,
	        end: '}',
	        keywords: 'facet installer exports children extends',
	        contains: [
	          hljs.HASH_COMMENT_MODE
	        ]
	      },
	
	      // Instance sections
	      {
	        className: 'instance-of',
	        begin: '^instance of ' + IDENTIFIER,
	        end: '}',
	        keywords: 'name count channels instance-data instance-state instance of',
	        contains: [
	          // Instance overridden properties
	          {
	            className: 'keyword',
	            begin: '[a-zA-Z-_]+( |\t)*:'
	          },
	          hljs.HASH_COMMENT_MODE
	        ]
	      },
	
	      // Component sections
	      {
	        className: 'component',
	        begin: '^' + IDENTIFIER,
	        end: '}',
	        lexemes: '\\(?[a-zA-Z]+\\)?',
	        keywords: 'installer exports children extends imports facets alias (optional)',
	        contains: [
	          // Imported component variables
	          {
	            className: 'string',
	            begin: '\\.[a-zA-Z-_]+',
	            end: '\\s|,|;',
	            excludeEnd: true
	          },
	          hljs.HASH_COMMENT_MODE
	        ]
	      },
	
	      // Comments
	      hljs.HASH_COMMENT_MODE
	    ]
	  };
	};

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword:
	        'float color point normal vector matrix while for if do return else break extern continue',
	      built_in:
	        'abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise ' +
	        'clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp ' +
	        'faceforward filterstep floor format fresnel incident length lightsource log match ' +
	        'max min mod noise normalize ntransform opposite option phong pnoise pow printf ' +
	        'ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp ' +
	        'setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan ' +
	        'texture textureinfo trace transform vtransform xcomp ycomp zcomp'
	    },
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'preprocessor',
	        begin: '#', end: '$'
	      },
	      {
	        className: 'shader',
	        beginKeywords: 'surface displacement light volume imager', end: '\\('
	      },
	      {
	        className: 'shading',
	        beginKeywords: 'illuminate illuminance gather', end: '\\('
	      }
	    ]
	  };
	};

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var RUBY_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
	  var RUBY_KEYWORDS =
	    'and false then defined module in return redo if BEGIN retry end for true self when ' +
	    'next until do begin unless END rescue nil else break undef not super class case ' +
	    'require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor';
	  var YARDOCTAG = {
	    className: 'doctag',
	    begin: '@[A-Za-z]+'
	  };
	  var IRB_OBJECT = {
	    className: 'value',
	    begin: '#<', end: '>'
	  };
	  var COMMENT_MODES = [
	    hljs.COMMENT(
	      '#',
	      '$',
	      {
	        contains: [YARDOCTAG]
	      }
	    ),
	    hljs.COMMENT(
	      '^\\=begin',
	      '^\\=end',
	      {
	        contains: [YARDOCTAG],
	        relevance: 10
	      }
	    ),
	    hljs.COMMENT('^__END__', '\\n$')
	  ];
	  var SUBST = {
	    className: 'subst',
	    begin: '#\\{', end: '}',
	    keywords: RUBY_KEYWORDS
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/},
	      {begin: /`/, end: /`/},
	      {begin: '%[qQwWx]?\\(', end: '\\)'},
	      {begin: '%[qQwWx]?\\[', end: '\\]'},
	      {begin: '%[qQwWx]?{', end: '}'},
	      {begin: '%[qQwWx]?<', end: '>'},
	      {begin: '%[qQwWx]?/', end: '/'},
	      {begin: '%[qQwWx]?%', end: '%'},
	      {begin: '%[qQwWx]?-', end: '-'},
	      {begin: '%[qQwWx]?\\|', end: '\\|'},
	      {
	        // \B in the beginning suppresses recognition of ?-sequences where ?
	        // is the last character of a preceding identifier, as in: `func?4`
	        begin: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/
	      }
	    ]
	  };
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)',
	    keywords: RUBY_KEYWORDS
	  };
	
	  var RUBY_DEFAULT_CONTAINS = [
	    STRING,
	    IRB_OBJECT,
	    {
	      className: 'class',
	      beginKeywords: 'class module', end: '$|;',
	      illegal: /=/,
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
	        {
	          className: 'inheritance',
	          begin: '<\\s*',
	          contains: [{
	            className: 'parent',
	            begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE
	          }]
	        }
	      ].concat(COMMENT_MODES)
	    },
	    {
	      className: 'function',
	      beginKeywords: 'def', end: '$|;',
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: RUBY_METHOD_RE}),
	        PARAMS
	      ].concat(COMMENT_MODES)
	    },
	    {
	      className: 'constant',
	      begin: '(::)?(\\b[A-Z]\\w*(::)?)+',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ':',
	      contains: [STRING, {begin: RUBY_METHOD_RE}],
	      relevance: 0
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    {
	      className: 'variable',
	      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))'
	    },
	    { // regexp container
	      begin: '(' + hljs.RE_STARTERS_RE + ')\\s*',
	      contains: [
	        IRB_OBJECT,
	        {
	          className: 'regexp',
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	          illegal: /\n/,
	          variants: [
	            {begin: '/', end: '/[a-z]*'},
	            {begin: '%r{', end: '}[a-z]*'},
	            {begin: '%r\\(', end: '\\)[a-z]*'},
	            {begin: '%r!', end: '![a-z]*'},
	            {begin: '%r\\[', end: '\\][a-z]*'}
	          ]
	        }
	      ].concat(COMMENT_MODES),
	      relevance: 0
	    }
	  ].concat(COMMENT_MODES);
	
	  SUBST.contains = RUBY_DEFAULT_CONTAINS;
	  PARAMS.contains = RUBY_DEFAULT_CONTAINS;
	
	  var SIMPLE_PROMPT = "[>?]>";
	  var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
	  var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>";
	
	  var IRB_DEFAULT = [
	    {
	      begin: /^\s*=>/,
	      className: 'status',
	      starts: {
	        end: '$', contains: RUBY_DEFAULT_CONTAINS
	      }
	    },
	    {
	      className: 'prompt',
	      begin: '^('+SIMPLE_PROMPT+"|"+DEFAULT_PROMPT+'|'+RVM_PROMPT+')',
	      starts: {
	        end: '$', contains: RUBY_DEFAULT_CONTAINS
	      }
	    }
	  ];
	
	  return {
	    aliases: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
	    keywords: RUBY_KEYWORDS,
	    illegal: /\/\*/,
	    contains: COMMENT_MODES.concat(IRB_DEFAULT).concat(RUBY_DEFAULT_CONTAINS)
	  };
	};

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	       keyword: 'BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE ' +
	         'INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 ' +
	         'INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 ' +
	         'INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 ' +
	         'INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 ' +
	         'INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 ' +
	         'INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 ' +
	         'INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 ' +
	         'INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 ' +
	         'INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 ' +
	         'INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 ' +
	         'INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 ' +
	         'INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 ' +
	         'INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 ' +
	         'INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 ' +
	         'MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER ' +
	         'OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE ' +
	         'NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH ' +
	         'IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND ' +
	         'UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ' +
	         'ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE ' +
	         'GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE ' +
	         'SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING ' +
	         'DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF ' +
	         'MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY ' +
	         'YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE ' +
	         'COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR ' +
	         'READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ' +
	         'ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE ' +
	         'EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE ' +
	         'SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL ' +
	         'COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN ' +
	         'MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING ' +
	         'FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM ' +
	         'NUMDAYS READ_DATE STAGING',
	       built_in: 'IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML ' +
	         'DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT ' +
	         'DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE ' +
	         'DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT ' +
	         'DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'array',
	        variants: [
	          {begin: '#\\s+[a-zA-Z\\ \\.]*', relevance: 0}, // looks like #-comment
	          {begin: '#[a-zA-Z\\ \\.]+'}
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUM_SUFFIX = '([uif](8|16|32|64|size))\?';
	  var BLOCK_COMMENT = hljs.inherit(hljs.C_BLOCK_COMMENT_MODE);
	  BLOCK_COMMENT.contains.push('self');
	  return {
	    aliases: ['rs'],
	    keywords: {
	      keyword:
	        'alignof as be box break const continue crate do else enum extern ' +
	        'false fn for if impl in let loop match mod mut offsetof once priv ' +
	        'proc pub pure ref return self Self sizeof static struct super trait true ' +
	        'type typeof unsafe unsized use virtual while where yield ' +
	        'int i8 i16 i32 i64 ' +
	        'uint u8 u32 u64 ' +
	        'float f32 f64 ' +
	        'str char bool',
	      built_in:
	        // prelude
	        'Copy Send Sized Sync Drop Fn FnMut FnOnce drop Box ToOwned Clone ' +
	        'PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator ' +
	        'Extend IntoIterator DoubleEndedIterator ExactSizeIterator Option ' +
	        'Some None Result Ok Err SliceConcatExt String ToString Vec ' +
	        // macros
	        'assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! ' +
	        'debug_assert! debug_assert_eq! env! panic! file! format! format_args! ' +
	        'include_bin! include_str! line! local_data_key! module_path! ' +
	        'option_env! print! println! select! stringify! try! unimplemented! ' +
	        'unreachable! vec! write! writeln!'
	    },
	    lexemes: hljs.IDENT_RE + '!?',
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      BLOCK_COMMENT,
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      {
	        className: 'string',
	        variants: [
	           { begin: /r(#*)".*?"\1(?!#)/ },
	           { begin: /'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ },
	           { begin: /'[a-zA-Z_][a-zA-Z0-9_]*/ }
	        ]
	      },
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b0b([01_]+)' + NUM_SUFFIX },
	          { begin: '\\b0o([0-7_]+)' + NUM_SUFFIX },
	          { begin: '\\b0x([A-Fa-f0-9_]+)' + NUM_SUFFIX },
	          { begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' +
	                   NUM_SUFFIX
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'fn', end: '(\\(|<)', excludeEnd: true,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        className: 'preprocessor',
	        begin: '#\\!?\\[', end: '\\]'
	      },
	      {
	        beginKeywords: 'type', end: '(=|<)',
	        contains: [hljs.UNDERSCORE_TITLE_MODE],
	        illegal: '\\S'
	      },
	      {
	        beginKeywords: 'trait enum', end: '{',
	        contains: [
	          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
	        ],
	        illegal: '[\\w\\d]'
	      },
	      {
	        begin: hljs.IDENT_RE + '::'
	      },
	      {
	        begin: '->'
	      }
	    ]
	  };
	};

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var ANNOTATION = {
	    className: 'annotation', begin: '@[A-Za-z]+'
	  };
	
	  var STRING = {
	    className: 'string',
	    begin: 'u?r?"""', end: '"""',
	    relevance: 10
	  };
	
	  var SYMBOL = {
	    className: 'symbol',
	    begin: '\'\\w[\\w\\d_]*(?!\')'
	  };
	
	  var TYPE = {
	    className: 'type',
	    begin: '\\b[A-Z][A-Za-z0-9_]*',
	    relevance: 0
	  };
	
	  var NAME = {
	    className: 'title',
	    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
	    relevance: 0
	  };
	
	  var CLASS = {
	    className: 'class',
	    beginKeywords: 'class object trait type',
	    end: /[:={\[(\n;]/,
	    contains: [{className: 'keyword', beginKeywords: 'extends with', relevance: 10}, NAME]
	  };
	
	  var METHOD = {
	    className: 'function',
	    beginKeywords: 'def',
	    end: /[:={\[(\n;]/,
	    contains: [NAME]
	  };
	
	  return {
	    keywords: {
	      literal: 'true false null',
	      keyword: 'type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      STRING,
	      hljs.QUOTE_STRING_MODE,
	      SYMBOL,
	      TYPE,
	      METHOD,
	      CLASS,
	      hljs.C_NUMBER_MODE,
	      ANNOTATION
	    ]
	  };
	};

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var SCHEME_IDENT_RE = '[^\\(\\)\\[\\]\\{\\}",\'`;#|\\\\\\s]+';
	  var SCHEME_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+([./]\\d+)?';
	  var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + '[+\\-]' + SCHEME_SIMPLE_NUMBER_RE + 'i';
	  var BUILTINS = {
	    built_in:
	      'case-lambda call/cc class define-class exit-handler field import ' +
	      'inherit init-field interface let*-values let-values let/ec mixin ' +
	      'opt-lambda override protect provide public rename require ' +
	      'require-for-syntax syntax syntax-case syntax-error unit/sig unless ' +
	      'when with-syntax and begin call-with-current-continuation ' +
	      'call-with-input-file call-with-output-file case cond define ' +
	      'define-syntax delay do dynamic-wind else for-each if lambda let let* ' +
	      'let-syntax letrec letrec-syntax map or syntax-rules \' * + , ,@ - ... / ' +
	      '; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan ' +
	      'boolean? caar cadr call-with-input-file call-with-output-file ' +
	      'call-with-values car cdddar cddddr cdr ceiling char->integer ' +
	      'char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? ' +
	      'char-downcase char-lower-case? char-numeric? char-ready? char-upcase ' +
	      'char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? ' +
	      'char? close-input-port close-output-port complex? cons cos ' +
	      'current-input-port current-output-port denominator display eof-object? ' +
	      'eq? equal? eqv? eval even? exact->inexact exact? exp expt floor ' +
	      'force gcd imag-part inexact->exact inexact? input-port? integer->char ' +
	      'integer? interaction-environment lcm length list list->string ' +
	      'list->vector list-ref list-tail list? load log magnitude make-polar ' +
	      'make-rectangular make-string make-vector max member memq memv min ' +
	      'modulo negative? newline not null-environment null? number->string ' +
	      'number? numerator odd? open-input-file open-output-file output-port? ' +
	      'pair? peek-char port? positive? procedure? quasiquote quote quotient ' +
	      'rational? rationalize read read-char real-part real? remainder reverse ' +
	      'round scheme-report-environment set! set-car! set-cdr! sin sqrt string ' +
	      'string->list string->number string->symbol string-append string-ci<=? ' +
	      'string-ci<? string-ci=? string-ci>=? string-ci>? string-copy ' +
	      'string-fill! string-length string-ref string-set! string<=? string<? ' +
	      'string=? string>=? string>? string? substring symbol->string symbol? ' +
	      'tan transcript-off transcript-on truncate values vector ' +
	      'vector->list vector-fill! vector-length vector-ref vector-set! ' +
	      'with-input-from-file with-output-to-file write write-char zero?'
	  };
	
	  var SHEBANG = {
	    className: 'shebang',
	    begin: '^#!',
	    end: '$'
	  };
	
	  var LITERAL = {
	    className: 'literal',
	    begin: '(#t|#f|#\\\\' + SCHEME_IDENT_RE + '|#\\\\.)'
	  };
	
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      { begin: SCHEME_SIMPLE_NUMBER_RE, relevance: 0 },
	      { begin: SCHEME_COMPLEX_NUMBER_RE, relevance: 0 },
	      { begin: '#b[0-1]+(/[0-1]+)?' },
	      { begin: '#o[0-7]+(/[0-7]+)?' },
	      { begin: '#x[0-9a-f]+(/[0-9a-f]+)?' }
	    ]
	  };
	
	  var STRING = hljs.QUOTE_STRING_MODE;
	
	  var REGULAR_EXPRESSION = {
	    className: 'regexp',
	    begin: '#[pr]x"',
	    end: '[^\\\\]"'
	  };
	
	  var COMMENT_MODES = [
	    hljs.COMMENT(
	      ';',
	      '$',
	      {
	        relevance: 0
	      }
	    ),
	    hljs.COMMENT('#\\|', '\\|#')
	  ];
	
	  var IDENT = {
	    begin: SCHEME_IDENT_RE,
	    relevance: 0
	  };
	
	  var QUOTED_IDENT = {
	    className: 'variable',
	    begin: '\'' + SCHEME_IDENT_RE
	  };
	
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	
	  var LIST = {
	    className: 'list',
	    variants: [
	      { begin: '\\(', end: '\\)' },
	      { begin: '\\[', end: '\\]' }
	    ],
	    contains: [
	      {
	        className: 'keyword',
	        begin: SCHEME_IDENT_RE,
	        lexemes: SCHEME_IDENT_RE,
	        keywords: BUILTINS
	      },
	      BODY
	    ]
	  };
	
	  BODY.contains = [LITERAL, NUMBER, STRING, IDENT, QUOTED_IDENT, LIST].concat(COMMENT_MODES);
	
	  return {
	    illegal: /\S/,
	    contains: [SHEBANG, NUMBER, STRING, QUOTED_IDENT, LIST].concat(COMMENT_MODES)
	  };
	};

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var COMMON_CONTAINS = [
	    hljs.C_NUMBER_MODE,
	    {
	      className: 'string',
	      begin: '\'|\"', end: '\'|\"',
	      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	    }
	  ];
	
	  return {
	    aliases: ['sci'],
	    keywords: {
	      keyword: 'abort break case clear catch continue do elseif else endfunction end for function'+
	        'global if pause return resume select try then while'+
	        '%f %F %t %T %pi %eps %inf %nan %e %i %z %s',
	      built_in: // Scilab has more than 2000 functions. Just list the most commons
	       'abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error'+
	       'exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty'+
	       'isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log'+
	       'max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real'+
	       'round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan'+
	       'type typename warning zeros matrix'
	    },
	    illegal: '("|#|/\\*|\\s+/\\w+)',
	    contains: [
	      {
	        className: 'function',
	        beginKeywords: 'function endfunction', end: '$',
	        keywords: 'function endfunction|10',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)'
	          }
	        ]
	      },
	      {
	        className: 'transposed_variable',
	        begin: '[a-zA-Z_][a-zA-Z_0-9]*(\'+[\\.\']*|[\\.\']+)', end: '',
	        relevance: 0
	      },
	      {
	        className: 'matrix',
	        begin: '\\[', end: '\\]\'*[\\.\']*',
	        relevance: 0,
	        contains: COMMON_CONTAINS
	      },
	      hljs.COMMENT('//', '$')
	    ].concat(COMMON_CONTAINS)
	  };
	};

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
	  var VARIABLE = {
	    className: 'variable',
	    begin: '(\\$' + IDENT_RE + ')\\b'
	  };
	  var FUNCTION = {
	    className: 'function',
	    begin: IDENT_RE + '\\(',
	    returnBegin: true,
	    excludeEnd: true,
	    end: '\\('
	  };
	  var HEXCOLOR = {
	    className: 'hexcolor', begin: '#[0-9A-Fa-f]+'
	  };
	  var DEF_INTERNALS = {
	    className: 'attribute',
	    begin: '[A-Z\\_\\.\\-]+', end: ':',
	    excludeEnd: true,
	    illegal: '[^\\s]',
	    starts: {
	      className: 'value',
	      endsWithParent: true, excludeEnd: true,
	      contains: [
	        FUNCTION,
	        HEXCOLOR,
	        hljs.CSS_NUMBER_MODE,
	        hljs.QUOTE_STRING_MODE,
	        hljs.APOS_STRING_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        {
	          className: 'important', begin: '!important'
	        }
	      ]
	    }
	  };
	  return {
	    case_insensitive: true,
	    illegal: '[=/|\']',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      FUNCTION,
	      {
	        className: 'id', begin: '\\#[A-Za-z0-9_-]+',
	        relevance: 0
	      },
	      {
	        className: 'class', begin: '\\.[A-Za-z0-9_-]+',
	        relevance: 0
	      },
	      {
	        className: 'attr_selector',
	        begin: '\\[', end: '\\]',
	        illegal: '$'
	      },
	      {
	        className: 'tag', // begin: IDENT_RE, end: '[,|\\s]'
	        begin: '\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b',
	        relevance: 0
	      },
	      {
	        className: 'pseudo',
	        begin: ':(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)'
	      },
	      {
	        className: 'pseudo',
	        begin: '::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)'
	      },
	      VARIABLE,
	      {
	        className: 'attribute',
	        begin: '\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b',
	        illegal: '[^\\s]'
	      },
	      {
	        className: 'value',
	        begin: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
	      },
	      {
	        className: 'value',
	        begin: ':', end: ';',
	        contains: [
	          FUNCTION,
	          VARIABLE,
	          HEXCOLOR,
	          hljs.CSS_NUMBER_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          {
	            className: 'important', begin: '!important'
	          }
	        ]
	      },
	      {
	        className: 'at_rule',
	        begin: '@', end: '[{;]',
	        keywords: 'mixin include extend for if else each while charset import debug media page content font-face namespace warn',
	        contains: [
	          FUNCTION,
	          VARIABLE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          HEXCOLOR,
	          hljs.CSS_NUMBER_MODE,
	          {
	            className: 'preprocessor',
	            begin: '\\s[A-Za-z0-9_.-]+',
	            relevance: 0
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var smali_instr_low_prio = ['add', 'and', 'cmp', 'cmpg', 'cmpl', 'const', 'div', 'double', 'float', 'goto', 'if', 'int', 'long', 'move', 'mul', 'neg', 'new', 'nop', 'not', 'or', 'rem', 'return', 'shl', 'shr', 'sput', 'sub', 'throw', 'ushr', 'xor'];
	  var smali_instr_high_prio = ['aget', 'aput', 'array', 'check', 'execute', 'fill', 'filled', 'goto/16', 'goto/32', 'iget', 'instance', 'invoke', 'iput', 'monitor', 'packed', 'sget', 'sparse'];
	  var smali_keywords = ['transient', 'constructor', 'abstract', 'final', 'synthetic', 'public', 'private', 'protected', 'static', 'bridge', 'system'];
	  return {
	    aliases: ['smali'],
	    contains: [
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        relevance: 0
	      },
	      hljs.COMMENT(
	        '#',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'keyword',
	        begin: '\\s*\\.end\\s[a-zA-Z0-9]*',
	        relevance: 1
	      },
	      {
	        className: 'keyword',
	        begin: '^[ ]*\\.[a-zA-Z]*',
	        relevance: 0
	      },
	      {
	        className: 'keyword',
	        begin: '\\s:[a-zA-Z_0-9]*',
	        relevance: 0
	      },
	      {
	        className: 'keyword',
	        begin: '\\s('+smali_keywords.join('|')+')',
	        relevance: 1
	      },
	      {
	        className: 'keyword',
	        begin: '\\[',
	        relevance: 0
	      },
	      {
	        className: 'instruction',
	        begin: '\\s('+smali_instr_low_prio.join('|')+')\\s',
	        relevance: 1
	      },
	      {
	        className: 'instruction',
	        begin: '\\s('+smali_instr_low_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)+\\s',
	        relevance: 10
	      },
	      {
	        className: 'instruction',
	        begin: '\\s('+smali_instr_high_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)*\\s',
	        relevance: 10
	      },
	      {
	        className: 'class',
	        begin: 'L[^\(;:\n]*;',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '( |->)[^(\n ;"]*\\(',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '\\)',
	        relevance: 0
	      },
	      {
	        className: 'variable',
	        begin: '[vp][0-9]+',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VAR_IDENT_RE = '[a-z][a-zA-Z0-9_]*';
	  var CHAR = {
	    className: 'char',
	    begin: '\\$.{1}'
	  };
	  var SYMBOL = {
	    className: 'symbol',
	    begin: '#' + hljs.UNDERSCORE_IDENT_RE
	  };
	  return {
	    aliases: ['st'],
	    keywords: 'self super nil true false thisContext', // only 6
	    contains: [
	      hljs.COMMENT('"', '"'),
	      hljs.APOS_STRING_MODE,
	      {
	        className: 'class',
	        begin: '\\b[A-Z][A-Za-z0-9_]*',
	        relevance: 0
	      },
	      {
	        className: 'method',
	        begin: VAR_IDENT_RE + ':',
	        relevance: 0
	      },
	      hljs.C_NUMBER_MODE,
	      SYMBOL,
	      CHAR,
	      {
	        className: 'localvars',
	        // This looks more complicated than needed to avoid combinatorial
	        // explosion under V8. It effectively means `| var1 var2 ... |` with
	        // whitespace adjacent to `|` being optional.
	        begin: '\\|[ ]*' + VAR_IDENT_RE + '([ ]+' + VAR_IDENT_RE + ')*[ ]*\\|',
	        returnBegin: true, end: /\|/,
	        illegal: /\S/,
	        contains: [{begin: '(\\|[ ]*)?' + VAR_IDENT_RE}]
	      },
	      {
	        className: 'array',
	        begin: '\\#\\(', end: '\\)',
	        contains: [
	          hljs.APOS_STRING_MODE,
	          CHAR,
	          hljs.C_NUMBER_MODE,
	          SYMBOL
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['ml'],
	    keywords: {
	      keyword:
	        /* according to Definition of Standard ML 97  */
	        'abstype and andalso as case datatype do else end eqtype ' +
	        'exception fn fun functor handle if in include infix infixr ' +
	        'let local nonfix of op open orelse raise rec sharing sig ' +
	        'signature struct structure then type val with withtype where while',
	      built_in:
	        /* built-in types according to basis library */
	        'array bool char exn int list option order real ref string substring vector unit word',
	      literal:
	        'true false NONE SOME LESS EQUAL GREATER nil'
	    },
	    illegal: /\/\/|>>/,
	    lexemes: '[a-z_]\\w*!?',
	    contains: [
	      {
	        className: 'literal',
	        begin: '\\[(\\|\\|)?\\]|\\(\\)'
	      },
	      hljs.COMMENT(
	        '\\(\\*',
	        '\\*\\)',
	        {
	          contains: ['self']
	        }
	      ),
	      { /* type variable */
	        className: 'symbol',
	        begin: '\'[A-Za-z_](?!\')[\\w\']*'
	        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
	      },
	      { /* polymorphic variant */
	        className: 'tag',
	        begin: '`[A-Z][\\w\']*'
	      },
	      { /* module or constructor */
	        className: 'type',
	        begin: '\\b[A-Z][\\w\']*',
	        relevance: 0
	      },
	      { /* don't color identifiers, but safely catch all identifiers with '*/
	        begin: '[a-z_]\\w*\'[\\w\']*'
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'char', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      {
	        className: 'number',
	        begin:
	          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
	          '0[oO][0-7_]+[Lln]?|' +
	          '0[bB][01_]+[Lln]?|' +
	          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
	        relevance: 0
	      },
	      {
	        begin: /[-=]>/ // relevance booster
	      }
	    ]
	  };
	};

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var allCommands = ['!', '-', '+', '!=', '%', '&&', '*', '/', '=', '==', '>', '>=', '<', '<=', 'or', 'plus', '^', ':', '>>', 'abs', 'accTime', 'acos', 'action', 'actionKeys', 'actionKeysImages', 'actionKeysNames', 'actionKeysNamesArray', 'actionName', 'activateAddons', 'activatedAddons', 'activateKey', 'addAction', 'addBackpack', 'addBackpackCargo', 'addBackpackCargoGlobal', 'addBackpackGlobal', 'addCamShake', 'addCuratorAddons', 'addCuratorCameraArea', 'addCuratorEditableObjects', 'addCuratorEditingArea', 'addCuratorPoints', 'addEditorObject', 'addEventHandler', 'addGoggles', 'addGroupIcon', 'addHandgunItem', 'addHeadgear', 'addItem', 'addItemCargo', 'addItemCargoGlobal', 'addItemPool', 'addItemToBackpack', 'addItemToUniform', 'addItemToVest', 'addLiveStats', 'addMagazine', 'addMagazine array', 'addMagazineAmmoCargo', 'addMagazineCargo', 'addMagazineCargoGlobal', 'addMagazineGlobal', 'addMagazinePool', 'addMagazines', 'addMagazineTurret', 'addMenu', 'addMenuItem', 'addMissionEventHandler', 'addMPEventHandler', 'addMusicEventHandler', 'addPrimaryWeaponItem', 'addPublicVariableEventHandler', 'addRating', 'addResources', 'addScore', 'addScoreSide', 'addSecondaryWeaponItem', 'addSwitchableUnit', 'addTeamMember', 'addToRemainsCollector', 'addUniform', 'addVehicle', 'addVest', 'addWaypoint', 'addWeapon', 'addWeaponCargo', 'addWeaponCargoGlobal', 'addWeaponGlobal', 'addWeaponPool', 'addWeaponTurret', 'agent', 'agents', 'AGLToASL', 'aimedAtTarget', 'aimPos', 'airDensityRTD', 'airportSide', 'AISFinishHeal', 'alive', 'allControls', 'allCurators', 'allDead', 'allDeadMen', 'allDisplays', 'allGroups', 'allMapMarkers', 'allMines', 'allMissionObjects', 'allow3DMode', 'allowCrewInImmobile', 'allowCuratorLogicIgnoreAreas', 'allowDamage', 'allowDammage', 'allowFileOperations', 'allowFleeing', 'allowGetIn', 'allPlayers', 'allSites', 'allTurrets', 'allUnits', 'allUnitsUAV', 'allVariables', 'ammo', 'and', 'animate', 'animateDoor', 'animationPhase', 'animationState', 'append', 'armoryPoints', 'arrayIntersect', 'asin', 'ASLToAGL', 'ASLToATL', 'assert', 'assignAsCargo', 'assignAsCargoIndex', 'assignAsCommander', 'assignAsDriver', 'assignAsGunner', 'assignAsTurret', 'assignCurator', 'assignedCargo', 'assignedCommander', 'assignedDriver', 'assignedGunner', 'assignedItems', 'assignedTarget', 'assignedTeam', 'assignedVehicle', 'assignedVehicleRole', 'assignItem', 'assignTeam', 'assignToAirport', 'atan', 'atan2', 'atg', 'ATLToASL', 'attachedObject', 'attachedObjects', 'attachedTo', 'attachObject', 'attachTo', 'attackEnabled', 'backpack', 'backpackCargo', 'backpackContainer', 'backpackItems', 'backpackMagazines', 'backpackSpaceFor', 'behaviour', 'benchmark', 'binocular', 'blufor', 'boundingBox', 'boundingBoxReal', 'boundingCenter', 'breakOut', 'breakTo', 'briefingName', 'buildingExit', 'buildingPos', 'buttonAction', 'buttonSetAction', 'cadetMode', 'call', 'callExtension', 'camCommand', 'camCommit', 'camCommitPrepared', 'camCommitted', 'camConstuctionSetParams', 'camCreate', 'camDestroy', 'cameraEffect', 'cameraEffectEnableHUD', 'cameraInterest', 'cameraOn', 'cameraView', 'campaignConfigFile', 'camPreload', 'camPreloaded', 'camPrepareBank', 'camPrepareDir', 'camPrepareDive', 'camPrepareFocus', 'camPrepareFov', 'camPrepareFovRange', 'camPreparePos', 'camPrepareRelPos', 'camPrepareTarget', 'camSetBank', 'camSetDir', 'camSetDive', 'camSetFocus', 'camSetFov', 'camSetFovRange', 'camSetPos', 'camSetRelPos', 'camSetTarget', 'camTarget', 'camUseNVG', 'canAdd', 'canAddItemToBackpack', 'canAddItemToUniform', 'canAddItemToVest', 'cancelSimpleTaskDestination', 'canFire', 'canMove', 'canSlingLoad', 'canStand', 'canUnloadInCombat', 'captive', 'captiveNum', 'case', 'catch', 'cbChecked', 'cbSetChecked', 'ceil', 'cheatsEnabled', 'checkAIFeature', 'civilian', 'className', 'clearAllItemsFromBackpack', 'clearBackpackCargo', 'clearBackpackCargoGlobal', 'clearGroupIcons', 'clearItemCargo', 'clearItemCargoGlobal', 'clearItemPool', 'clearMagazineCargo', 'clearMagazineCargoGlobal', 'clearMagazinePool', 'clearOverlay', 'clearRadio', 'clearWeaponCargo', 'clearWeaponCargoGlobal', 'clearWeaponPool', 'closeDialog', 'closeDisplay', 'closeOverlay', 'collapseObjectTree', 'combatMode', 'commandArtilleryFire', 'commandChat', 'commander', 'commandFire', 'commandFollow', 'commandFSM', 'commandGetOut', 'commandingMenu', 'commandMove', 'commandRadio', 'commandStop', 'commandTarget', 'commandWatch', 'comment', 'commitOverlay', 'compile', 'compileFinal', 'completedFSM', 'composeText', 'configClasses', 'configFile', 'configHierarchy', 'configName', 'configProperties', 'configSourceMod', 'configSourceModList', 'connectTerminalToUAV', 'controlNull', 'controlsGroupCtrl', 'copyFromClipboard', 'copyToClipboard', 'copyWaypoints', 'cos', 'count', 'countEnemy', 'countFriendly', 'countSide', 'countType', 'countUnknown', 'createAgent', 'createCenter', 'createDialog', 'createDiaryLink', 'createDiaryRecord', 'createDiarySubject', 'createDisplay', 'createGearDialog', 'createGroup', 'createGuardedPoint', 'createLocation', 'createMarker', 'createMarkerLocal', 'createMenu', 'createMine', 'createMissionDisplay', 'createSimpleTask', 'createSite', 'createSoundSource', 'createTask', 'createTeam', 'createTrigger', 'createUnit', 'createUnit array', 'createVehicle', 'createVehicle array', 'createVehicleCrew', 'createVehicleLocal', 'crew', 'ctrlActivate', 'ctrlAddEventHandler', 'ctrlAutoScrollDelay', 'ctrlAutoScrollRewind', 'ctrlAutoScrollSpeed', 'ctrlChecked', 'ctrlClassName', 'ctrlCommit', 'ctrlCommitted', 'ctrlCreate', 'ctrlDelete', 'ctrlEnable', 'ctrlEnabled', 'ctrlFade', 'ctrlHTMLLoaded', 'ctrlIDC', 'ctrlIDD', 'ctrlMapAnimAdd', 'ctrlMapAnimClear', 'ctrlMapAnimCommit', 'ctrlMapAnimDone', 'ctrlMapCursor', 'ctrlMapMouseOver', 'ctrlMapScale', 'ctrlMapScreenToWorld', 'ctrlMapWorldToScreen', 'ctrlModel', 'ctrlModelDirAndUp', 'ctrlModelScale', 'ctrlParent', 'ctrlPosition', 'ctrlRemoveAllEventHandlers', 'ctrlRemoveEventHandler', 'ctrlScale', 'ctrlSetActiveColor', 'ctrlSetAutoScrollDelay', 'ctrlSetAutoScrollRewind', 'ctrlSetAutoScrollSpeed', 'ctrlSetBackgroundColor', 'ctrlSetChecked', 'ctrlSetEventHandler', 'ctrlSetFade', 'ctrlSetFocus', 'ctrlSetFont', 'ctrlSetFontH1', 'ctrlSetFontH1B', 'ctrlSetFontH2', 'ctrlSetFontH2B', 'ctrlSetFontH3', 'ctrlSetFontH3B', 'ctrlSetFontH4', 'ctrlSetFontH4B', 'ctrlSetFontH5', 'ctrlSetFontH5B', 'ctrlSetFontH6', 'ctrlSetFontH6B', 'ctrlSetFontHeight', 'ctrlSetFontHeightH1', 'ctrlSetFontHeightH2', 'ctrlSetFontHeightH3', 'ctrlSetFontHeightH4', 'ctrlSetFontHeightH5', 'ctrlSetFontHeightH6', 'ctrlSetFontP', 'ctrlSetFontPB', 'ctrlSetForegroundColor', 'ctrlSetModel', 'ctrlSetModelDirAndUp', 'ctrlSetModelScale', 'ctrlSetPosition', 'ctrlSetScale', 'ctrlSetStructuredText', 'ctrlSetText', 'ctrlSetTextColor', 'ctrlSetTooltip', 'ctrlSetTooltipColorBox', 'ctrlSetTooltipColorShade', 'ctrlSetTooltipColorText', 'ctrlShow', 'ctrlShown', 'ctrlText', 'ctrlTextHeight', 'ctrlType', 'ctrlVisible', 'curatorAddons', 'curatorCamera', 'curatorCameraArea', 'curatorCameraAreaCeiling', 'curatorCoef', 'curatorEditableObjects', 'curatorEditingArea', 'curatorEditingAreaType', 'curatorMouseOver', 'curatorPoints', 'curatorRegisteredObjects', 'curatorSelected', 'curatorWaypointCost', 'currentChannel', 'currentCommand', 'currentMagazine', 'currentMagazineDetail', 'currentMagazineDetailTurret', 'currentMagazineTurret', 'currentMuzzle', 'currentNamespace', 'currentTask', 'currentTasks', 'currentThrowable', 'currentVisionMode', 'currentWaypoint', 'currentWeapon', 'currentWeaponMode', 'currentWeaponTurret', 'currentZeroing', 'cursorTarget', 'customChat', 'customRadio', 'cutFadeOut', 'cutObj', 'cutRsc', 'cutText', 'damage', 'date', 'dateToNumber', 'daytime', 'deActivateKey', 'debriefingText', 'debugFSM', 'debugLog', 'default', 'deg', 'deleteAt', 'deleteCenter', 'deleteCollection', 'deleteEditorObject', 'deleteGroup', 'deleteIdentity', 'deleteLocation', 'deleteMarker', 'deleteMarkerLocal', 'deleteRange', 'deleteResources', 'deleteSite', 'deleteStatus', 'deleteTeam', 'deleteVehicle', 'deleteVehicleCrew', 'deleteWaypoint', 'detach', 'detectedMines', 'diag activeMissionFSMs', 'diag activeSQFScripts', 'diag activeSQSScripts', 'diag captureFrame', 'diag captureSlowFrame', 'diag fps', 'diag fpsMin', 'diag frameNo', 'diag log', 'diag logSlowFrame', 'diag tickTime', 'dialog', 'diarySubjectExists', 'didJIP', 'didJIPOwner', 'difficulty', 'difficultyEnabled', 'difficultyEnabledRTD', 'direction', 'directSay', 'disableAI', 'disableCollisionWith', 'disableConversation', 'disableDebriefingStats', 'disableSerialization', 'disableTIEquipment', 'disableUAVConnectability', 'disableUserInput', 'displayAddEventHandler', 'displayCtrl', 'displayNull', 'displayRemoveAllEventHandlers', 'displayRemoveEventHandler', 'displaySetEventHandler', 'dissolveTeam', 'distance', 'distance2D', 'distanceSqr', 'distributionRegion', 'do', 'doArtilleryFire', 'doFire', 'doFollow', 'doFSM', 'doGetOut', 'doMove', 'doorPhase', 'doStop', 'doTarget', 'doWatch', 'drawArrow', 'drawEllipse', 'drawIcon', 'drawIcon3D', 'drawLine', 'drawLine3D', 'drawLink', 'drawLocation', 'drawRectangle', 'driver', 'drop', 'east', 'echo', 'editObject', 'editorSetEventHandler', 'effectiveCommander', 'else', 'emptyPositions', 'enableAI', 'enableAIFeature', 'enableAttack', 'enableCamShake', 'enableCaustics', 'enableCollisionWith', 'enableCopilot', 'enableDebriefingStats', 'enableDiagLegend', 'enableEndDialog', 'enableEngineArtillery', 'enableEnvironment', 'enableFatigue', 'enableGunLights', 'enableIRLasers', 'enableMimics', 'enablePersonTurret', 'enableRadio', 'enableReload', 'enableRopeAttach', 'enableSatNormalOnDetail', 'enableSaving', 'enableSentences', 'enableSimulation', 'enableSimulationGlobal', 'enableTeamSwitch', 'enableUAVConnectability', 'enableUAVWaypoints', 'endLoadingScreen', 'endMission', 'engineOn', 'enginesIsOnRTD', 'enginesRpmRTD', 'enginesTorqueRTD', 'entities', 'estimatedEndServerTime', 'estimatedTimeLeft', 'evalObjectArgument', 'everyBackpack', 'everyContainer', 'exec', 'execEditorScript', 'execFSM', 'execVM', 'exit', 'exitWith', 'exp', 'expectedDestination', 'eyeDirection', 'eyePos', 'face', 'faction', 'fadeMusic', 'fadeRadio', 'fadeSound', 'fadeSpeech', 'failMission', 'false', 'fillWeaponsFromPool', 'find', 'findCover', 'findDisplay', 'findEditorObject', 'findEmptyPosition', 'findEmptyPositionReady', 'findNearestEnemy', 'finishMissionInit', 'finite', 'fire', 'fireAtTarget', 'firstBackpack', 'flag', 'flagOwner', 'fleeing', 'floor', 'flyInHeight', 'fog', 'fogForecast', 'fogParams', 'for', 'forceAddUniform', 'forceEnd', 'forceMap', 'forceRespawn', 'forceSpeed', 'forceWalk', 'forceWeaponFire', 'forceWeatherChange', 'forEach', 'forEachMember', 'forEachMemberAgent', 'forEachMemberTeam', 'format', 'formation', 'formationDirection', 'formationLeader', 'formationMembers', 'formationPosition', 'formationTask', 'formatText', 'formLeader', 'freeLook', 'from', 'fromEditor', 'fuel', 'fullCrew', 'gearSlotAmmoCount', 'gearSlotData', 'getAllHitPointsDamage', 'getAmmoCargo', 'getArray', 'getArtilleryAmmo', 'getArtilleryComputerSettings', 'getArtilleryETA', 'getAssignedCuratorLogic', 'getAssignedCuratorUnit', 'getBackpackCargo', 'getBleedingRemaining', 'getBurningValue', 'getCargoIndex', 'getCenterOfMass', 'getClientState', 'getConnectedUAV', 'getDammage', 'getDescription', 'getDir', 'getDirVisual', 'getDLCs', 'getEditorCamera', 'getEditorMode', 'getEditorObjectScope', 'getElevationOffset', 'getFatigue', 'getFriend', 'getFSMVariable', 'getFuelCargo', 'getGroupIcon', 'getGroupIconParams', 'getGroupIcons', 'getHideFrom', 'getHit', 'getHitIndex', 'getHitPointDamage', 'getItemCargo', 'getMagazineCargo', 'getMarkerColor', 'getMarkerPos', 'getMarkerSize', 'getMarkerType', 'getMass', 'getModelInfo', 'getNumber', 'getObjectArgument', 'getObjectChildren', 'getObjectDLC', 'getObjectMaterials', 'getObjectProxy', 'getObjectTextures', 'getObjectType', 'getObjectViewDistance', 'getOxygenRemaining', 'getPersonUsedDLCs', 'getPlayerChannel', 'getPlayerUID', 'getPos', 'getPosASL', 'getPosASLVisual', 'getPosASLW', 'getPosATL', 'getPosATLVisual', 'getPosVisual', 'getPosWorld', 'getRepairCargo', 'getResolution', 'getShadowDistance', 'getSlingLoad', 'getSpeed', 'getSuppression', 'getTerrainHeightASL', 'getText', 'getVariable', 'getWeaponCargo', 'getWPPos', 'glanceAt', 'globalChat', 'globalRadio', 'goggles', 'goto', 'group', 'groupChat', 'groupFromNetId', 'groupIconSelectable', 'groupIconsVisible', 'groupId', 'groupOwner', 'groupRadio', 'groupSelectedUnits', 'groupSelectUnit', 'grpNull', 'gunner', 'gusts', 'halt', 'handgunItems', 'handgunMagazine', 'handgunWeapon', 'handsHit', 'hasInterface', 'hasWeapon', 'hcAllGroups', 'hcGroupParams', 'hcLeader', 'hcRemoveAllGroups', 'hcRemoveGroup', 'hcSelected', 'hcSelectGroup', 'hcSetGroup', 'hcShowBar', 'hcShownBar', 'headgear', 'hideBody', 'hideObject', 'hideObjectGlobal', 'hint', 'hintC', 'hintCadet', 'hintSilent', 'hmd', 'hostMission', 'htmlLoad', 'HUDMovementLevels', 'humidity', 'if', 'image', 'importAllGroups', 'importance', 'in', 'incapacitatedState', 'independent', 'inflame', 'inflamed', 'inGameUISetEventHandler', 'inheritsFrom', 'initAmbientLife', 'inputAction', 'inRangeOfArtillery', 'insertEditorObject', 'intersect', 'isAbleToBreathe', 'isAgent', 'isArray', 'isAutoHoverOn', 'isAutonomous', 'isAutotest', 'isBleeding', 'isBurning', 'isClass', 'isCollisionLightOn', 'isCopilotEnabled', 'isDedicated', 'isDLCAvailable', 'isEngineOn', 'isEqualTo', 'isFlashlightOn', 'isFlatEmpty', 'isForcedWalk', 'isFormationLeader', 'isHidden', 'isInRemainsCollector', 'isInstructorFigureEnabled', 'isIRLaserOn', 'isKeyActive', 'isKindOf', 'isLightOn', 'isLocalized', 'isManualFire', 'isMarkedForCollection', 'isMultiplayer', 'isNil', 'isNull', 'isNumber', 'isObjectHidden', 'isObjectRTD', 'isOnRoad', 'isPipEnabled', 'isPlayer', 'isRealTime', 'isServer', 'isShowing3DIcons', 'isSteamMission', 'isStreamFriendlyUIEnabled', 'isText', 'isTouchingGround', 'isTurnedOut', 'isTutHintsEnabled', 'isUAVConnectable', 'isUAVConnected', 'isUniformAllowed', 'isWalking', 'isWeaponDeployed', 'isWeaponRested', 'itemCargo', 'items', 'itemsWithMagazines', 'join', 'joinAs', 'joinAsSilent', 'joinSilent', 'joinString', 'kbAddDatabase', 'kbAddDatabaseTargets', 'kbAddTopic', 'kbHasTopic', 'kbReact', 'kbRemoveTopic', 'kbTell', 'kbWasSaid', 'keyImage', 'keyName', 'knowsAbout', 'land', 'landAt', 'landResult', 'language', 'laserTarget', 'lbAdd', 'lbClear', 'lbColor', 'lbCurSel', 'lbData', 'lbDelete', 'lbIsSelected', 'lbPicture', 'lbSelection', 'lbSetColor', 'lbSetCurSel', 'lbSetData', 'lbSetPicture', 'lbSetPictureColor', 'lbSetPictureColorDisabled', 'lbSetPictureColorSelected', 'lbSetSelectColor', 'lbSetSelectColorRight', 'lbSetSelected', 'lbSetTooltip', 'lbSetValue', 'lbSize', 'lbSort', 'lbSortByValue', 'lbText', 'lbValue', 'leader', 'leaderboardDeInit', 'leaderboardGetRows', 'leaderboardInit', 'leaveVehicle', 'libraryCredits', 'libraryDisclaimers', 'lifeState', 'lightAttachObject', 'lightDetachObject', 'lightIsOn', 'lightnings', 'limitSpeed', 'linearConversion', 'lineBreak', 'lineIntersects', 'lineIntersectsObjs', 'lineIntersectsSurfaces', 'lineIntersectsWith', 'linkItem', 'list', 'listObjects', 'ln', 'lnbAddArray', 'lnbAddColumn', 'lnbAddRow', 'lnbClear', 'lnbColor', 'lnbCurSelRow', 'lnbData', 'lnbDeleteColumn', 'lnbDeleteRow', 'lnbGetColumnsPosition', 'lnbPicture', 'lnbSetColor', 'lnbSetColumnsPos', 'lnbSetCurSelRow', 'lnbSetData', 'lnbSetPicture', 'lnbSetText', 'lnbSetValue', 'lnbSize', 'lnbText', 'lnbValue', 'load', 'loadAbs', 'loadBackpack', 'loadFile', 'loadGame', 'loadIdentity', 'loadMagazine', 'loadOverlay', 'loadStatus', 'loadUniform', 'loadVest', 'local', 'localize', 'locationNull', 'locationPosition', 'lock', 'lockCameraTo', 'lockCargo', 'lockDriver', 'locked', 'lockedCargo', 'lockedDriver', 'lockedTurret', 'lockTurret', 'lockWP', 'log', 'logEntities', 'lookAt', 'lookAtPos', 'magazineCargo', 'magazines', 'magazinesAllTurrets', 'magazinesAmmo', 'magazinesAmmoCargo', 'magazinesAmmoFull', 'magazinesDetail', 'magazinesDetailBackpack', 'magazinesDetailUniform', 'magazinesDetailVest', 'magazinesTurret', 'magazineTurretAmmo', 'mapAnimAdd', 'mapAnimClear', 'mapAnimCommit', 'mapAnimDone', 'mapCenterOnCamera', 'mapGridPosition', 'markAsFinishedOnSteam', 'markerAlpha', 'markerBrush', 'markerColor', 'markerDir', 'markerPos', 'markerShape', 'markerSize', 'markerText', 'markerType', 'max', 'members', 'min', 'mineActive', 'mineDetectedBy', 'missionConfigFile', 'missionName', 'missionNamespace', 'missionStart', 'mod', 'modelToWorld', 'modelToWorldVisual', 'moonIntensity', 'morale', 'move', 'moveInAny', 'moveInCargo', 'moveInCommander', 'moveInDriver', 'moveInGunner', 'moveInTurret', 'moveObjectToEnd', 'moveOut', 'moveTime', 'moveTo', 'moveToCompleted', 'moveToFailed', 'musicVolume', 'name', 'name location', 'nameSound', 'nearEntities', 'nearestBuilding', 'nearestLocation', 'nearestLocations', 'nearestLocationWithDubbing', 'nearestObject', 'nearestObjects', 'nearObjects', 'nearObjectsReady', 'nearRoads', 'nearSupplies', 'nearTargets', 'needReload', 'netId', 'netObjNull', 'newOverlay', 'nextMenuItemIndex', 'nextWeatherChange', 'nil', 'nMenuItems', 'not', 'numberToDate', 'objectCurators', 'objectFromNetId', 'objectParent', 'objNull', 'objStatus', 'onBriefingGroup', 'onBriefingNotes', 'onBriefingPlan', 'onBriefingTeamSwitch', 'onCommandModeChanged', 'onDoubleClick', 'onEachFrame', 'onGroupIconClick', 'onGroupIconOverEnter', 'onGroupIconOverLeave', 'onHCGroupSelectionChanged', 'onMapSingleClick', 'onPlayerConnected', 'onPlayerDisconnected', 'onPreloadFinished', 'onPreloadStarted', 'onShowNewObject', 'onTeamSwitch', 'openCuratorInterface', 'openMap', 'openYoutubeVideo', 'opfor', 'or', 'orderGetIn', 'overcast', 'overcastForecast', 'owner', 'param', 'params', 'parseNumber', 'parseText', 'parsingNamespace', 'particlesQuality', 'pi', 'pickWeaponPool', 'pitch', 'playableSlotsNumber', 'playableUnits', 'playAction', 'playActionNow', 'player', 'playerRespawnTime', 'playerSide', 'playersNumber', 'playGesture', 'playMission', 'playMove', 'playMoveNow', 'playMusic', 'playScriptedMission', 'playSound', 'playSound3D', 'position', 'positionCameraToWorld', 'posScreenToWorld', 'posWorldToScreen', 'ppEffectAdjust', 'ppEffectCommit', 'ppEffectCommitted', 'ppEffectCreate', 'ppEffectDestroy', 'ppEffectEnable', 'ppEffectForceInNVG', 'precision', 'preloadCamera', 'preloadObject', 'preloadSound', 'preloadTitleObj', 'preloadTitleRsc', 'preprocessFile', 'preprocessFileLineNumbers', 'primaryWeapon', 'primaryWeaponItems', 'primaryWeaponMagazine', 'priority', 'private', 'processDiaryLink', 'productVersion', 'profileName', 'profileNamespace', 'profileNameSteam', 'progressLoadingScreen', 'progressPosition', 'progressSetPosition', 'publicVariable', 'publicVariableClient', 'publicVariableServer', 'pushBack', 'putWeaponPool', 'queryItemsPool', 'queryMagazinePool', 'queryWeaponPool', 'rad', 'radioChannelAdd', 'radioChannelCreate', 'radioChannelRemove', 'radioChannelSetCallSign', 'radioChannelSetLabel', 'radioVolume', 'rain', 'rainbow', 'random', 'rank', 'rankId', 'rating', 'rectangular', 'registeredTasks', 'registerTask', 'reload', 'reloadEnabled', 'remoteControl', 'remoteExec', 'remoteExecCall', 'removeAction', 'removeAllActions', 'removeAllAssignedItems', 'removeAllContainers', 'removeAllCuratorAddons', 'removeAllCuratorCameraAreas', 'removeAllCuratorEditingAreas', 'removeAllEventHandlers', 'removeAllHandgunItems', 'removeAllItems', 'removeAllItemsWithMagazines', 'removeAllMissionEventHandlers', 'removeAllMPEventHandlers', 'removeAllMusicEventHandlers', 'removeAllPrimaryWeaponItems', 'removeAllWeapons', 'removeBackpack', 'removeBackpackGlobal', 'removeCuratorAddons', 'removeCuratorCameraArea', 'removeCuratorEditableObjects', 'removeCuratorEditingArea', 'removeDrawIcon', 'removeDrawLinks', 'removeEventHandler', 'removeFromRemainsCollector', 'removeGoggles', 'removeGroupIcon', 'removeHandgunItem', 'removeHeadgear', 'removeItem', 'removeItemFromBackpack', 'removeItemFromUniform', 'removeItemFromVest', 'removeItems', 'removeMagazine', 'removeMagazineGlobal', 'removeMagazines', 'removeMagazinesTurret', 'removeMagazineTurret', 'removeMenuItem', 'removeMissionEventHandler', 'removeMPEventHandler', 'removeMusicEventHandler', 'removePrimaryWeaponItem', 'removeSecondaryWeaponItem', 'removeSimpleTask', 'removeSwitchableUnit', 'removeTeamMember', 'removeUniform', 'removeVest', 'removeWeapon', 'removeWeaponGlobal', 'removeWeaponTurret', 'requiredVersion', 'resetCamShake', 'resetSubgroupDirection', 'resistance', 'resize', 'resources', 'respawnVehicle', 'restartEditorCamera', 'reveal', 'revealMine', 'reverse', 'reversedMouseY', 'roadsConnectedTo', 'roleDescription', 'ropeAttachedObjects', 'ropeAttachedTo', 'ropeAttachEnabled', 'ropeAttachTo', 'ropeCreate', 'ropeCut', 'ropeEndPosition', 'ropeLength', 'ropes', 'ropeUnwind', 'ropeUnwound', 'rotorsForcesRTD', 'rotorsRpmRTD', 'round', 'runInitScript', 'safeZoneH', 'safeZoneW', 'safeZoneWAbs', 'safeZoneX', 'safeZoneXAbs', 'safeZoneY', 'saveGame', 'saveIdentity', 'saveJoysticks', 'saveOverlay', 'saveProfileNamespace', 'saveStatus', 'saveVar', 'savingEnabled', 'say', 'say2D', 'say3D', 'scopeName', 'score', 'scoreSide', 'screenToWorld', 'scriptDone', 'scriptName', 'scriptNull', 'scudState', 'secondaryWeapon', 'secondaryWeaponItems', 'secondaryWeaponMagazine', 'select', 'selectBestPlaces', 'selectDiarySubject', 'selectedEditorObjects', 'selectEditorObject', 'selectionPosition', 'selectLeader', 'selectNoPlayer', 'selectPlayer', 'selectWeapon', 'selectWeaponTurret', 'sendAUMessage', 'sendSimpleCommand', 'sendTask', 'sendTaskResult', 'sendUDPMessage', 'serverCommand', 'serverCommandAvailable', 'serverCommandExecutable', 'serverName', 'serverTime', 'set', 'setAccTime', 'setAirportSide', 'setAmmo', 'setAmmoCargo', 'setAperture', 'setApertureNew', 'setArmoryPoints', 'setAttributes', 'setAutonomous', 'setBehaviour', 'setBleedingRemaining', 'setCameraInterest', 'setCamShakeDefParams', 'setCamShakeParams', 'setCamUseTi', 'setCaptive', 'setCenterOfMass', 'setCollisionLight', 'setCombatMode', 'setCompassOscillation', 'setCuratorCameraAreaCeiling', 'setCuratorCoef', 'setCuratorEditingAreaType', 'setCuratorWaypointCost', 'setCurrentChannel', 'setCurrentTask', 'setCurrentWaypoint', 'setDamage', 'setDammage', 'setDate', 'setDebriefingText', 'setDefaultCamera', 'setDestination', 'setDetailMapBlendPars', 'setDir', 'setDirection', 'setDrawIcon', 'setDropInterval', 'setEditorMode', 'setEditorObjectScope', 'setEffectCondition', 'setFace', 'setFaceAnimation', 'setFatigue', 'setFlagOwner', 'setFlagSide', 'setFlagTexture', 'setFog', 'setFog array', 'setFormation', 'setFormationTask', 'setFormDir', 'setFriend', 'setFromEditor', 'setFSMVariable', 'setFuel', 'setFuelCargo', 'setGroupIcon', 'setGroupIconParams', 'setGroupIconsSelectable', 'setGroupIconsVisible', 'setGroupId', 'setGroupIdGlobal', 'setGroupOwner', 'setGusts', 'setHideBehind', 'setHit', 'setHitIndex', 'setHitPointDamage', 'setHorizonParallaxCoef', 'setHUDMovementLevels', 'setIdentity', 'setImportance', 'setLeader', 'setLightAmbient', 'setLightAttenuation', 'setLightBrightness', 'setLightColor', 'setLightDayLight', 'setLightFlareMaxDistance', 'setLightFlareSize', 'setLightIntensity', 'setLightnings', 'setLightUseFlare', 'setLocalWindParams', 'setMagazineTurretAmmo', 'setMarkerAlpha', 'setMarkerAlphaLocal', 'setMarkerBrush', 'setMarkerBrushLocal', 'setMarkerColor', 'setMarkerColorLocal', 'setMarkerDir', 'setMarkerDirLocal', 'setMarkerPos', 'setMarkerPosLocal', 'setMarkerShape', 'setMarkerShapeLocal', 'setMarkerSize', 'setMarkerSizeLocal', 'setMarkerText', 'setMarkerTextLocal', 'setMarkerType', 'setMarkerTypeLocal', 'setMass', 'setMimic', 'setMousePosition', 'setMusicEffect', 'setMusicEventHandler', 'setName', 'setNameSound', 'setObjectArguments', 'setObjectMaterial', 'setObjectProxy', 'setObjectTexture', 'setObjectTextureGlobal', 'setObjectViewDistance', 'setOvercast', 'setOwner', 'setOxygenRemaining', 'setParticleCircle', 'setParticleClass', 'setParticleFire', 'setParticleParams', 'setParticleRandom', 'setPilotLight', 'setPiPEffect', 'setPitch', 'setPlayable', 'setPlayerRespawnTime', 'setPos', 'setPosASL', 'setPosASL2', 'setPosASLW', 'setPosATL', 'setPosition', 'setPosWorld', 'setRadioMsg', 'setRain', 'setRainbow', 'setRandomLip', 'setRank', 'setRectangular', 'setRepairCargo', 'setShadowDistance', 'setSide', 'setSimpleTaskDescription', 'setSimpleTaskDestination', 'setSimpleTaskTarget', 'setSimulWeatherLayers', 'setSize', 'setSkill', 'setSkill array', 'setSlingLoad', 'setSoundEffect', 'setSpeaker', 'setSpeech', 'setSpeedMode', 'setStatValue', 'setSuppression', 'setSystemOfUnits', 'setTargetAge', 'setTaskResult', 'setTaskState', 'setTerrainGrid', 'setText', 'setTimeMultiplier', 'setTitleEffect', 'setTriggerActivation', 'setTriggerArea', 'setTriggerStatements', 'setTriggerText', 'setTriggerTimeout', 'setTriggerType', 'setType', 'setUnconscious', 'setUnitAbility', 'setUnitPos', 'setUnitPosWeak', 'setUnitRank', 'setUnitRecoilCoefficient', 'setUnloadInCombat', 'setUserActionText', 'setVariable', 'setVectorDir', 'setVectorDirAndUp', 'setVectorUp', 'setVehicleAmmo', 'setVehicleAmmoDef', 'setVehicleArmor', 'setVehicleId', 'setVehicleLock', 'setVehiclePosition', 'setVehicleTiPars', 'setVehicleVarName', 'setVelocity', 'setVelocityTransformation', 'setViewDistance', 'setVisibleIfTreeCollapsed', 'setWaves', 'setWaypointBehaviour', 'setWaypointCombatMode', 'setWaypointCompletionRadius', 'setWaypointDescription', 'setWaypointFormation', 'setWaypointHousePosition', 'setWaypointLoiterRadius', 'setWaypointLoiterType', 'setWaypointName', 'setWaypointPosition', 'setWaypointScript', 'setWaypointSpeed', 'setWaypointStatements', 'setWaypointTimeout', 'setWaypointType', 'setWaypointVisible', 'setWeaponReloadingTime', 'setWind', 'setWindDir', 'setWindForce', 'setWindStr', 'setWPPos', 'show3DIcons', 'showChat', 'showCinemaBorder', 'showCommandingMenu', 'showCompass', 'showCuratorCompass', 'showGPS', 'showHUD', 'showLegend', 'showMap', 'shownArtilleryComputer', 'shownChat', 'shownCompass', 'shownCuratorCompass', 'showNewEditorObject', 'shownGPS', 'shownHUD', 'shownMap', 'shownPad', 'shownRadio', 'shownUAVFeed', 'shownWarrant', 'shownWatch', 'showPad', 'showRadio', 'showSubtitles', 'showUAVFeed', 'showWarrant', 'showWatch', 'showWaypoint', 'side', 'sideChat', 'sideEnemy', 'sideFriendly', 'sideLogic', 'sideRadio', 'sideUnknown', 'simpleTasks', 'simulationEnabled', 'simulCloudDensity', 'simulCloudOcclusion', 'simulInClouds', 'simulWeatherSync', 'sin', 'size', 'sizeOf', 'skill', 'skillFinal', 'skipTime', 'sleep', 'sliderPosition', 'sliderRange', 'sliderSetPosition', 'sliderSetRange', 'sliderSetSpeed', 'sliderSpeed', 'slingLoadAssistantShown', 'soldierMagazines', 'someAmmo', 'sort', 'soundVolume', 'spawn', 'speaker', 'speed', 'speedMode', 'splitString', 'sqrt', 'squadParams', 'stance', 'startLoadingScreen', 'step', 'stop', 'stopped', 'str', 'sunOrMoon', 'supportInfo', 'suppressFor', 'surfaceIsWater', 'surfaceNormal', 'surfaceType', 'swimInDepth', 'switch', 'switchableUnits', 'switchAction', 'switchCamera', 'switchGesture', 'switchLight', 'switchMove', 'synchronizedObjects', 'synchronizedTriggers', 'synchronizedWaypoints', 'synchronizeObjectsAdd', 'synchronizeObjectsRemove', 'synchronizeTrigger', 'synchronizeWaypoint', 'synchronizeWaypoint trigger', 'systemChat', 'systemOfUnits', 'tan', 'targetKnowledge', 'targetsAggregate', 'targetsQuery', 'taskChildren', 'taskCompleted', 'taskDescription', 'taskDestination', 'taskHint', 'taskNull', 'taskParent', 'taskResult', 'taskState', 'teamMember', 'teamMemberNull', 'teamName', 'teams', 'teamSwitch', 'teamSwitchEnabled', 'teamType', 'terminate', 'terrainIntersect', 'terrainIntersectASL', 'text', 'text location', 'textLog', 'textLogFormat', 'tg', 'then', 'throw', 'time', 'timeMultiplier', 'titleCut', 'titleFadeOut', 'titleObj', 'titleRsc', 'titleText', 'to', 'toArray', 'toLower', 'toString', 'toUpper', 'triggerActivated', 'triggerActivation', 'triggerArea', 'triggerAttachedVehicle', 'triggerAttachObject', 'triggerAttachVehicle', 'triggerStatements', 'triggerText', 'triggerTimeout', 'triggerTimeoutCurrent', 'triggerType', 'true', 'try', 'turretLocal', 'turretOwner', 'turretUnit', 'tvAdd', 'tvClear', 'tvCollapse', 'tvCount', 'tvCurSel', 'tvData', 'tvDelete', 'tvExpand', 'tvPicture', 'tvSetCurSel', 'tvSetData', 'tvSetPicture', 'tvSetPictureColor', 'tvSetTooltip', 'tvSetValue', 'tvSort', 'tvSortByValue', 'tvText', 'tvValue', 'type', 'typeName', 'typeOf', 'UAVControl', 'uiNamespace', 'uiSleep', 'unassignCurator', 'unassignItem', 'unassignTeam', 'unassignVehicle', 'underwater', 'uniform', 'uniformContainer', 'uniformItems', 'uniformMagazines', 'unitAddons', 'unitBackpack', 'unitPos', 'unitReady', 'unitRecoilCoefficient', 'units', 'unitsBelowHeight', 'unlinkItem', 'unlockAchievement', 'unregisterTask', 'updateDrawIcon', 'updateMenuItem', 'updateObjectTree', 'useAudioTimeForMoves', 'vectorAdd', 'vectorCos', 'vectorCrossProduct', 'vectorDiff', 'vectorDir', 'vectorDirVisual', 'vectorDistance', 'vectorDistanceSqr', 'vectorDotProduct', 'vectorFromTo', 'vectorMagnitude', 'vectorMagnitudeSqr', 'vectorMultiply', 'vectorNormalized', 'vectorUp', 'vectorUpVisual', 'vehicle', 'vehicleChat', 'vehicleRadio', 'vehicles', 'vehicleVarName', 'velocity', 'velocityModelSpace', 'verifySignature', 'vest', 'vestContainer', 'vestItems', 'vestMagazines', 'viewDistance', 'visibleCompass', 'visibleGPS', 'visibleMap', 'visiblePosition', 'visiblePositionASL', 'visibleWatch', 'waitUntil', 'waves', 'waypointAttachedObject', 'waypointAttachedVehicle', 'waypointAttachObject', 'waypointAttachVehicle', 'waypointBehaviour', 'waypointCombatMode', 'waypointCompletionRadius', 'waypointDescription', 'waypointFormation', 'waypointHousePosition', 'waypointLoiterRadius', 'waypointLoiterType', 'waypointName', 'waypointPosition', 'waypoints', 'waypointScript', 'waypointsEnabledUAV', 'waypointShow', 'waypointSpeed', 'waypointStatements', 'waypointTimeout', 'waypointTimeoutCurrent', 'waypointType', 'waypointVisible', 'weaponAccessories', 'weaponCargo', 'weaponDirection', 'weaponLowered', 'weapons', 'weaponsItems', 'weaponsItemsCargo', 'weaponState', 'weaponsTurret', 'weightRTD', 'west', 'WFSideText', 'while', 'wind', 'windDir', 'windStr', 'wingsForcesRTD', 'with', 'worldName', 'worldSize', 'worldToModel', 'worldToModelVisual', 'worldToScreen'];
	  var control = ['case', 'catch', 'default', 'do', 'else', 'exit', 'exitWith|5', 'for', 'forEach', 'from', 'if', 'switch', 'then', 'throw', 'to', 'try', 'while', 'with'];
	  var operators = ['!', '-', '+', '!=', '%', '&&', '*', '/', '=', '==', '>', '>=', '<', '<=', '^', ':', '>>'];
	  var specials = ['_forEachIndex|10', '_this|10', '_x|10'];
	  var literals = ['true', 'false', 'nil'];
	  var builtins = allCommands.filter(function (command) {
	    return control.indexOf(command) == -1 &&
	        literals.indexOf(command) == -1 &&
	        operators.indexOf(command) == -1;
	  });
	  //Note: operators will not be treated as builtins due to the lexeme rules
	  builtins = builtins.concat(specials);
	
	  // In SQF strings, quotes matching the start are escaped by adding a consecutive.
	  // Example of single escaped quotes: " "" " and  ' '' '.
	  var STRINGS = {
	    className: 'string',
	    relevance: 0,
	    variants: [
	      {
	        begin: '"',
	        end: '"',
	        contains: [{begin: '""'}]
	      },
	      {
	        begin: '\'',
	        end: '\'',
	        contains: [{begin: '\'\''}]
	      }
	    ]
	  };
	
	  var NUMBERS = {
	    className: 'number',
	    begin: hljs.NUMBER_RE,
	    relevance: 0
	  };
	
	  // Preprocessor definitions borrowed from C++
	  var PREPROCESSOR_STRINGS = {
	    className: 'string',
	    variants: [
	      hljs.QUOTE_STRING_MODE,
	      {
	        begin: '\'\\\\?.', end: '\'',
	        illegal: '.'
	      }
	    ]
	  };
	
	  var PREPROCESSOR =       {
	    className: 'preprocessor',
	    begin: '#', end: '$',
	    keywords: 'if else elif endif define undef warning error line ' +
	              'pragma ifdef ifndef',
	    contains: [
	      {
	        begin: /\\\n/, relevance: 0
	      },
	      {
	        beginKeywords: 'include', end: '$',
	        contains: [
	          PREPROCESSOR_STRINGS,
	          {
	            className: 'string',
	            begin: '<', end: '>',
	            illegal: '\\n',
	          }
	        ]
	      },
	      PREPROCESSOR_STRINGS,
	      NUMBERS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	
	  return {
	    aliases: ['sqf'],
	    case_insensitive: true,
	    keywords: {
	      keyword: control.join(' '),
	      built_in: builtins.join(' '),
	      literal: literals.join(' ')
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMBERS,
	      STRINGS,
	      PREPROCESSOR
	    ]
	  };
	};

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT_MODE = hljs.COMMENT('--', '$');
	  return {
	    case_insensitive: true,
	    illegal: /[<>{}*]/,
	    contains: [
	      {
	        className: 'operator',
	        beginKeywords:
	          'begin end start commit rollback savepoint lock alter create drop rename call ' +
	          'delete do handler insert load replace select truncate update set show pragma grant ' +
	          'merge describe use explain help declare prepare execute deallocate release ' +
	          'unlock purge reset change stop analyze cache flush optimize repair kill ' +
	          'install uninstall checksum restore check backup revoke',
	        end: /;/, endsWithParent: true,
	        keywords: {
	          keyword:
	            'abort abs absolute acc acce accep accept access accessed accessible account acos action activate add ' +
	            'addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias ' +
	            'allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply ' +
	            'archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan ' +
	            'atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid ' +
	            'authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile ' +
	            'before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float ' +
	            'binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound ' +
	            'buffer_cache buffer_pool build bulk by byte byteordermark bytes c cache caching call calling cancel ' +
	            'capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base ' +
	            'char_length character_length characters characterset charindex charset charsetform charsetid check ' +
	            'checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close ' +
	            'cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation ' +
	            'collect colu colum column column_value columns columns_updated comment commit compact compatibility ' +
	            'compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn ' +
	            'connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection ' +
	            'consider consistent constant constraint constraints constructor container content contents context ' +
	            'contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost ' +
	            'count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation ' +
	            'critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user ' +
	            'cursor curtime customdatum cycle d data database databases datafile datafiles datalength date_add ' +
	            'date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts ' +
	            'day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate ' +
	            'declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults ' +
	            'deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank ' +
	            'depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor ' +
	            'deterministic diagnostics difference dimension direct_load directory disable disable_all ' +
	            'disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div ' +
	            'do document domain dotnet double downgrade drop dumpfile duplicate duration e each edition editionable ' +
	            'editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt ' +
	            'end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors ' +
	            'escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding ' +
	            'execu execut execute exempt exists exit exp expire explain export export_set extended extent external ' +
	            'external_1 external_2 externally extract f failed failed_login_attempts failover failure far fast ' +
	            'feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final ' +
	            'finish first first_value fixed flash_cache flashback floor flush following follows for forall force ' +
	            'form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ' +
	            'ftp full function g general generated get get_format get_lock getdate getutcdate global global_name ' +
	            'globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups ' +
	            'gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex ' +
	            'hierarchy high high_priority hosts hour http i id ident_current ident_incr ident_seed identified ' +
	            'identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment ' +
	            'index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile ' +
	            'initial initialized initially initrans inmemory inner innodb input insert install instance instantiable ' +
	            'instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat ' +
	            'is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists ' +
	            'k keep keep_duplicates key keys kill l language large last last_day last_insert_id last_value lax lcase ' +
	            'lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit ' +
	            'lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate ' +
	            'locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call ' +
	            'logoff logon logs long loop low low_priority lower lpad lrtrim ltrim m main make_set makedate maketime ' +
	            'managed management manual map mapping mask master master_pos_wait match matched materialized max ' +
	            'maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans ' +
	            'md5 measures median medium member memcompress memory merge microsecond mid migration min minextents ' +
	            'minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month ' +
	            'months mount move movement multiset mutex n name name_const names nan national native natural nav nchar ' +
	            'nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile ' +
	            'nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile ' +
	            'nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder ' +
	            'nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck ' +
	            'noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe ' +
	            'nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ' +
	            'ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old ' +
	            'on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date ' +
	            'oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary ' +
	            'out outer outfile outline output over overflow overriding p package pad parallel parallel_enable ' +
	            'parameters parent parse partial partition partitions pascal passing password password_grace_time ' +
	            'password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex ' +
	            'pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc ' +
	            'performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin ' +
	            'policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction ' +
	            'prediction_cost prediction_details prediction_probability prediction_set prepare present preserve ' +
	            'prior priority private private_sga privileges procedural procedure procedure_analyze processlist ' +
	            'profiles project prompt protection public publishingservername purge quarter query quick quiesce quota ' +
	            'quotename radians raise rand range rank raw read reads readsize rebuild record records ' +
	            'recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh ' +
	            'regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy ' +
	            'reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename ' +
	            'repair repeat replace replicate replication required reset resetlogs resize resource respect restore ' +
	            'restricted result result_cache resumable resume retention return returning returns reuse reverse revoke ' +
	            'right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows ' +
	            'rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll ' +
	            'sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select ' +
	            'self sequence sequential serializable server servererror session session_user sessions_per_user set ' +
	            'sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor ' +
	            'si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin ' +
	            'size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex ' +
	            'source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows ' +
	            'sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone ' +
	            'standby start starting startup statement static statistics stats_binomial_test stats_crosstab ' +
	            'stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep ' +
	            'stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev ' +
	            'stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate ' +
	            'subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum ' +
	            'suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate ' +
	            'sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime t table tables tablespace tan tdo ' +
	            'template temporary terminated tertiary_weights test than then thread through tier ties time time_format ' +
	            'time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr ' +
	            'timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking ' +
	            'transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate ' +
	            'try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress ' +
	            'under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot ' +
	            'unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert ' +
	            'url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date ' +
	            'utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var ' +
	            'var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray ' +
	            'verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear ' +
	            'wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped ' +
	            'xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces ' +
	            'xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',
	          literal:
	            'true false null',
	          built_in:
	            'array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number ' +
	            'numeric real record serial serial8 smallint text varchar varying void'
	        },
	        contains: [
	          {
	            className: 'string',
	            begin: '\'', end: '\'',
	            contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	          },
	          {
	            className: 'string',
	            begin: '"', end: '"',
	            contains: [hljs.BACKSLASH_ESCAPE, {begin: '""'}]
	          },
	          {
	            className: 'string',
	            begin: '`', end: '`',
	            contains: [hljs.BACKSLASH_ESCAPE]
	          },
	          hljs.C_NUMBER_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          COMMENT_MODE
	        ]
	      },
	      hljs.C_BLOCK_COMMENT_MODE,
	      COMMENT_MODE
	    ]
	  };
	};

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['do', 'ado'],
	    case_insensitive: true,
	    keywords: 'if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate g gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l la lab labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize meqparse mer merg merge mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5',
	        contains: [
	      {
	        className: 'label',
	        variants: [
	          {begin: "\\$\\{?[a-zA-Z0-9_]+\\}?"},
	          {begin: "`[a-zA-Z0-9_]+'"}
	
	        ]
	      },
	      {
	        className: 'string',
	        variants: [
	          {begin: '`"[^\r\n]*?"\''},
	          {begin: '"[^\r\n"]*"'}
	        ]
	      },
	
	      {
	        className: 'literal',
	        variants: [
	          {
	            begin: '\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\(|$)'
	          }
	        ]
	      },
	
	      hljs.COMMENT('^[ \t]*\\*.*$', false),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	};

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STEP21_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
	  var STEP21_CLOSE_RE = 'END-ISO-10303-21;';
	  var STEP21_KEYWORDS = {
	    literal: '',
	    built_in: '',
	    keyword:
	    'HEADER ENDSEC DATA'
	  };
	  var STEP21_START = {
	    className: 'preprocessor',
	    begin: 'ISO-10303-21;',
	    relevance: 10
	  };
	  var STEP21_CODE = [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.COMMENT('/\\*\\*!', '\\*/'),
	    hljs.C_NUMBER_MODE,
	    hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	    hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	    {
	      className: 'string',
	      begin: "'", end: "'"
	    },
	    {
	      className: 'label',
	      variants: [
	        {
	          begin: '#', end: '\\d+',
	          illegal: '\\W'
	        }
	      ]
	    }
	  ];
	
	  return {
	    aliases: ['p21', 'step', 'stp'],
	    case_insensitive: true, // STEP 21 is case insensitive in theory, in practice all non-comments are capitalized.
	    lexemes: STEP21_IDENT_RE,
	    keywords: STEP21_KEYWORDS,
	    contains: [
	      {
	        className: 'preprocessor',
	        begin: STEP21_CLOSE_RE,
	        relevance: 10
	      },
	      STEP21_START
	    ].concat(STEP21_CODE)
	  };
	};

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var VARIABLE = {
	    className: 'variable',
	    begin: '\\$' + hljs.IDENT_RE
	  };
	
	  var HEX_COLOR = {
	    className: 'hexcolor',
	    begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})',
	    relevance: 10
	  };
	
	  var AT_KEYWORDS = [
	    'charset',
	    'css',
	    'debug',
	    'extend',
	    'font-face',
	    'for',
	    'import',
	    'include',
	    'media',
	    'mixin',
	    'page',
	    'warn',
	    'while'
	  ];
	
	  var PSEUDO_SELECTORS = [
	    'after',
	    'before',
	    'first-letter',
	    'first-line',
	    'active',
	    'first-child',
	    'focus',
	    'hover',
	    'lang',
	    'link',
	    'visited'
	  ];
	
	  var TAGS = [
	    'a',
	    'abbr',
	    'address',
	    'article',
	    'aside',
	    'audio',
	    'b',
	    'blockquote',
	    'body',
	    'button',
	    'canvas',
	    'caption',
	    'cite',
	    'code',
	    'dd',
	    'del',
	    'details',
	    'dfn',
	    'div',
	    'dl',
	    'dt',
	    'em',
	    'fieldset',
	    'figcaption',
	    'figure',
	    'footer',
	    'form',
	    'h1',
	    'h2',
	    'h3',
	    'h4',
	    'h5',
	    'h6',
	    'header',
	    'hgroup',
	    'html',
	    'i',
	    'iframe',
	    'img',
	    'input',
	    'ins',
	    'kbd',
	    'label',
	    'legend',
	    'li',
	    'mark',
	    'menu',
	    'nav',
	    'object',
	    'ol',
	    'p',
	    'q',
	    'quote',
	    'samp',
	    'section',
	    'span',
	    'strong',
	    'summary',
	    'sup',
	    'table',
	    'tbody',
	    'td',
	    'textarea',
	    'tfoot',
	    'th',
	    'thead',
	    'time',
	    'tr',
	    'ul',
	    'var',
	    'video'
	  ];
	
	  var TAG_END = '[\\.\\s\\n\\[\\:,]';
	
	  var ATTRIBUTES = [
	    'align-content',
	    'align-items',
	    'align-self',
	    'animation',
	    'animation-delay',
	    'animation-direction',
	    'animation-duration',
	    'animation-fill-mode',
	    'animation-iteration-count',
	    'animation-name',
	    'animation-play-state',
	    'animation-timing-function',
	    'auto',
	    'backface-visibility',
	    'background',
	    'background-attachment',
	    'background-clip',
	    'background-color',
	    'background-image',
	    'background-origin',
	    'background-position',
	    'background-repeat',
	    'background-size',
	    'border',
	    'border-bottom',
	    'border-bottom-color',
	    'border-bottom-left-radius',
	    'border-bottom-right-radius',
	    'border-bottom-style',
	    'border-bottom-width',
	    'border-collapse',
	    'border-color',
	    'border-image',
	    'border-image-outset',
	    'border-image-repeat',
	    'border-image-slice',
	    'border-image-source',
	    'border-image-width',
	    'border-left',
	    'border-left-color',
	    'border-left-style',
	    'border-left-width',
	    'border-radius',
	    'border-right',
	    'border-right-color',
	    'border-right-style',
	    'border-right-width',
	    'border-spacing',
	    'border-style',
	    'border-top',
	    'border-top-color',
	    'border-top-left-radius',
	    'border-top-right-radius',
	    'border-top-style',
	    'border-top-width',
	    'border-width',
	    'bottom',
	    'box-decoration-break',
	    'box-shadow',
	    'box-sizing',
	    'break-after',
	    'break-before',
	    'break-inside',
	    'caption-side',
	    'clear',
	    'clip',
	    'clip-path',
	    'color',
	    'column-count',
	    'column-fill',
	    'column-gap',
	    'column-rule',
	    'column-rule-color',
	    'column-rule-style',
	    'column-rule-width',
	    'column-span',
	    'column-width',
	    'columns',
	    'content',
	    'counter-increment',
	    'counter-reset',
	    'cursor',
	    'direction',
	    'display',
	    'empty-cells',
	    'filter',
	    'flex',
	    'flex-basis',
	    'flex-direction',
	    'flex-flow',
	    'flex-grow',
	    'flex-shrink',
	    'flex-wrap',
	    'float',
	    'font',
	    'font-family',
	    'font-feature-settings',
	    'font-kerning',
	    'font-language-override',
	    'font-size',
	    'font-size-adjust',
	    'font-stretch',
	    'font-style',
	    'font-variant',
	    'font-variant-ligatures',
	    'font-weight',
	    'height',
	    'hyphens',
	    'icon',
	    'image-orientation',
	    'image-rendering',
	    'image-resolution',
	    'ime-mode',
	    'inherit',
	    'initial',
	    'justify-content',
	    'left',
	    'letter-spacing',
	    'line-height',
	    'list-style',
	    'list-style-image',
	    'list-style-position',
	    'list-style-type',
	    'margin',
	    'margin-bottom',
	    'margin-left',
	    'margin-right',
	    'margin-top',
	    'marks',
	    'mask',
	    'max-height',
	    'max-width',
	    'min-height',
	    'min-width',
	    'nav-down',
	    'nav-index',
	    'nav-left',
	    'nav-right',
	    'nav-up',
	    'none',
	    'normal',
	    'object-fit',
	    'object-position',
	    'opacity',
	    'order',
	    'orphans',
	    'outline',
	    'outline-color',
	    'outline-offset',
	    'outline-style',
	    'outline-width',
	    'overflow',
	    'overflow-wrap',
	    'overflow-x',
	    'overflow-y',
	    'padding',
	    'padding-bottom',
	    'padding-left',
	    'padding-right',
	    'padding-top',
	    'page-break-after',
	    'page-break-before',
	    'page-break-inside',
	    'perspective',
	    'perspective-origin',
	    'pointer-events',
	    'position',
	    'quotes',
	    'resize',
	    'right',
	    'tab-size',
	    'table-layout',
	    'text-align',
	    'text-align-last',
	    'text-decoration',
	    'text-decoration-color',
	    'text-decoration-line',
	    'text-decoration-style',
	    'text-indent',
	    'text-overflow',
	    'text-rendering',
	    'text-shadow',
	    'text-transform',
	    'text-underline-position',
	    'top',
	    'transform',
	    'transform-origin',
	    'transform-style',
	    'transition',
	    'transition-delay',
	    'transition-duration',
	    'transition-property',
	    'transition-timing-function',
	    'unicode-bidi',
	    'vertical-align',
	    'visibility',
	    'white-space',
	    'widows',
	    'width',
	    'word-break',
	    'word-spacing',
	    'word-wrap',
	    'z-index'
	  ];
	
	  // illegals
	  var ILLEGAL = [
	    '\\{',
	    '\\}',
	    '\\?',
	    '(\\bReturn\\b)', // monkey
	    '(\\bEnd\\b)', // monkey
	    '(\\bend\\b)', // vbscript
	    ';', // sql
	    '#\\s', // markdown
	    '\\*\\s', // markdown
	    '===\\s', // markdown
	    '\\|',
	    '%', // prolog
	  ];
	
	  return {
	    aliases: ['styl'],
	    case_insensitive: false,
	    illegal: '(' + ILLEGAL.join('|') + ')',
	    keywords: 'if else for in',
	    contains: [
	
	      // strings
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE,
	
	      // comments
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	
	      // hex colors
	      HEX_COLOR,
	
	      // class tag
	      {
	        begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
	        returnBegin: true,
	        contains: [
	          {className: 'class', begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*'}
	        ]
	      },
	
	      // id tag
	      {
	        begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
	        returnBegin: true,
	        contains: [
	          {className: 'id', begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*'}
	        ]
	      },
	
	      // tags
	      {
	        begin: '\\b(' + TAGS.join('|') + ')' + TAG_END,
	        returnBegin: true,
	        contains: [
	          {className: 'tag', begin: '\\b[a-zA-Z][a-zA-Z0-9_-]*'}
	        ]
	      },
	
	      // psuedo selectors
	      {
	        className: 'pseudo',
	        begin: '&?:?:\\b(' + PSEUDO_SELECTORS.join('|') + ')' + TAG_END
	      },
	
	      // @ keywords
	      {
	        className: 'at_rule',
	        begin: '\@(' + AT_KEYWORDS.join('|') + ')\\b'
	      },
	
	      // variables
	      VARIABLE,
	
	      // dimension
	      hljs.CSS_NUMBER_MODE,
	
	      // number
	      hljs.NUMBER_MODE,
	
	      // functions
	      //  - only from beginning of line + whitespace
	      {
	        className: 'function',
	        begin: '\\b[a-zA-Z][a-zA-Z0-9_\-]*\\(.*\\)',
	        illegal: '[\\n]',
	        returnBegin: true,
	        contains: [
	          {className: 'title', begin: '\\b[a-zA-Z][a-zA-Z0-9_\-]*'},
	          {
	            className: 'params',
	            begin: /\(/,
	            end: /\)/,
	            contains: [
	              HEX_COLOR,
	              VARIABLE,
	              hljs.APOS_STRING_MODE,
	              hljs.CSS_NUMBER_MODE,
	              hljs.NUMBER_MODE,
	              hljs.QUOTE_STRING_MODE
	            ]
	          }
	        ]
	      },
	
	      // attributes
	      //  - only from beginning of line + whitespace
	      //  - must have whitespace after it
	      {
	        className: 'attribute',
	        begin: '\\b(' + ATTRIBUTES.reverse().join('|') + ')\\b'
	      }
	    ]
	  };
	};

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var SWIFT_KEYWORDS = {
	      keyword: '__COLUMN__ __FILE__ __FUNCTION__ __LINE__ as as! as? associativity ' +
	        'break case catch class continue convenience default defer deinit didSet do ' +
	        'dynamic dynamicType else enum extension fallthrough false final for func ' +
	        'get guard if import in indirect infix init inout internal is lazy left let ' +
	        'mutating nil none nonmutating operator optional override postfix precedence ' +
	        'prefix private protocol Protocol public repeat required rethrows return ' +
	        'right self Self set static struct subscript super switch throw throws true ' +
	        'try try! try? Type typealias unowned var weak where while willSet',
	      literal: 'true false nil',
	      built_in: 'abs advance alignof alignofValue anyGenerator assert assertionFailure ' +
	        'bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC ' +
	        'bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros ' +
	        'debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords ' +
	        'enumerate equal fatalError filter find getBridgedObjectiveCType getVaList ' +
	        'indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC ' +
	        'isUniquelyReferenced isUniquelyReferencedNonObjC join lazy lexicographicalCompare ' +
	        'map max maxElement min minElement numericCast overlaps partition posix ' +
	        'precondition preconditionFailure print println quickSort readLine reduce reflect ' +
	        'reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split ' +
	        'startsWith stride strideof strideofValue swap toString transcode ' +
	        'underestimateCount unsafeAddressOf unsafeBitCast unsafeDowncast unsafeUnwrap ' +
	        'unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer ' +
	        'withUnsafePointerToObject withUnsafeMutablePointer withUnsafeMutablePointers ' +
	        'withUnsafePointer withUnsafePointers withVaList zip'
	    };
	
	  var TYPE = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\']*',
	    relevance: 0
	  };
	  var BLOCK_COMMENT = hljs.COMMENT(
	    '/\\*',
	    '\\*/',
	    {
	      contains: ['self']
	    }
	  );
	  var SUBST = {
	    className: 'subst',
	    begin: /\\\(/, end: '\\)',
	    keywords: SWIFT_KEYWORDS,
	    contains: [] // assigned later
	  };
	  var NUMBERS = {
	      className: 'number',
	      begin: '\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b',
	      relevance: 0
	  };
	  var QUOTE_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
	    contains: [SUBST, hljs.BACKSLASH_ESCAPE]
	  });
	  SUBST.contains = [NUMBERS];
	
	  return {
	    keywords: SWIFT_KEYWORDS,
	    contains: [
	      QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      BLOCK_COMMENT,
	      TYPE,
	      NUMBERS,
	      {
	        className: 'func',
	        beginKeywords: 'func', end: '{', excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            begin: /[A-Za-z$_][0-9A-Za-z$_]*/,
	            illegal: /\(/
	          }),
	          {
	            className: 'generics',
	            begin: /</, end: />/,
	            illegal: />/
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/, endsParent: true,
	            keywords: SWIFT_KEYWORDS,
	            contains: [
	              'self',
	              NUMBERS,
	              QUOTE_STRING_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              {begin: ':'} // relevance booster
	            ],
	            illegal: /["']/
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        className: 'class',
	        beginKeywords: 'struct protocol class extension enum',
	        keywords: SWIFT_KEYWORDS,
	        end: '\\{',
	        excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/})
	        ]
	      },
	      {
	        className: 'preprocessor', // @attributes
	        begin: '(@warn_unused_result|@exported|@lazy|@noescape|' +
	                  '@NSCopying|@NSManaged|@objc|@convention|@required|' +
	                  '@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|' +
	                  '@infix|@prefix|@postfix|@autoclosure|@testable|@available|' +
	                  '@nonobjc|@NSApplicationMain|@UIApplicationMain)'
	
	      },
	      {
	        beginKeywords: 'import', end: /$/,
	        contains: [hljs.C_LINE_COMMENT_MODE, BLOCK_COMMENT]
	      }
	    ]
	  };
	};

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['tk'],
	    keywords: 'after append apply array auto_execok auto_import auto_load auto_mkindex ' +
	      'auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock ' +
	      'close concat continue dde dict encoding eof error eval exec exit expr fblocked ' +
	      'fconfigure fcopy file fileevent filename flush for foreach format gets glob global ' +
	      'history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list ' +
	      'llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 '+
	      'mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex '+
	      'platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename '+
	      'return safe scan seek set socket source split string subst switch tcl_endOfWord '+
	      'tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter '+
	      'tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update '+
	      'uplevel upvar variable vwait while',
	    contains: [
	      hljs.COMMENT(';[ \\t]*#', '$'),
	      hljs.COMMENT('^[ \\t]*#', '$'),
	      {
	        beginKeywords: 'proc',
	        end: '[\\{]',
	        excludeEnd: true,
	        contains: [
	          {
	            className: 'symbol',
	            begin: '[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
	            end: '[ \\t\\n\\r]',
	            endsWithParent: true,
	            excludeEnd: true
	          }
	        ]
	      },
	      {
	        className: 'variable',
	        excludeEnd: true,
	        variants: [
	          {
	            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*\\(([a-zA-Z0-9_])*\\)',
	            end: '[^a-zA-Z0-9_\\}\\$]'
	          },
	          {
	            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
	            end: '(\\))?[^a-zA-Z0-9_\\}\\$]'
	          }
	        ]
	      },
	      {
	        className: 'string',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        variants: [
	          hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	          hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
	        ]
	      },
	      {
	        className: 'number',
	        variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
	      }
	    ]
	  }
	};

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMAND1 = {
	    className: 'command',
	    begin: '\\\\[a-zA-Zа-яА-я]+[\\*]?'
	  };
	  var COMMAND2 = {
	    className: 'command',
	    begin: '\\\\[^a-zA-Zа-яА-я0-9]'
	  };
	  var SPECIAL = {
	    className: 'special',
	    begin: '[{}\\[\\]\\&#~]',
	    relevance: 0
	  };
	
	  return {
	    contains: [
	      { // parameter
	        begin: '\\\\[a-zA-Zа-яА-я]+[\\*]? *= *-?\\d*\\.?\\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?',
	        returnBegin: true,
	        contains: [
	          COMMAND1, COMMAND2,
	          {
	            className: 'number',
	            begin: ' *=', end: '-?\\d*\\.?\\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?',
	            excludeBegin: true
	          }
	        ],
	        relevance: 10
	      },
	      COMMAND1, COMMAND2,
	      SPECIAL,
	      {
	        className: 'formula',
	        begin: '\\$\\$', end: '\\$\\$',
	        contains: [COMMAND1, COMMAND2, SPECIAL],
	        relevance: 0
	      },
	      {
	        className: 'formula',
	        begin: '\\$', end: '\\$',
	        contains: [COMMAND1, COMMAND2, SPECIAL],
	        relevance: 0
	      },
	      hljs.COMMENT(
	        '%',
	        '$',
	        {
	          relevance: 0
	        }
	      )
	    ]
	  };
	};

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BUILT_IN_TYPES = 'bool byte i16 i32 i64 double string binary';
	  return {
	    keywords: {
	      keyword:
	        'namespace const typedef struct enum service exception void oneway set list map required optional',
	      built_in:
	        BUILT_IN_TYPES,
	      literal:
	        'true false'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'struct enum service exception', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      },
	      {
	        begin: '\\b(set|list|map)\\s*<', end: '>',
	        keywords: BUILT_IN_TYPES,
	        contains: ['self']
	      }
	    ]
	  };
	};

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var TPID = {
	    className: 'number',
	    begin: '[1-9][0-9]*', /* no leading zeros */
	    relevance: 0
	  };
	  var TPLABEL = {
	    className: 'comment',
	    begin: ':[^\\]]+'
	  };
	  var TPDATA = {
	    className: 'built_in',
	    begin: '(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|\
	    TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[', end: '\\]',
	    contains: [
	      'self',
	      TPID,
	      TPLABEL
	    ]
	  };
	  var TPIO = {
	    className: 'built_in',
	    begin: '(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[', end: '\\]',
	    contains: [
	      'self',
	      TPID,
	      hljs.QUOTE_STRING_MODE, /* for pos section at bottom */
	      TPLABEL
	    ]
	  };
	
	  return {
	    keywords: {
	      keyword:
	        'ABORT ACC ADJUST AND AP_LD BREAK CALL CNT COL CONDITION CONFIG DA DB ' +
	        'DIV DETECT ELSE END ENDFOR ERR_NUM ERROR_PROG FINE FOR GP GUARD INC ' +
	        'IF JMP LINEAR_MAX_SPEED LOCK MOD MONITOR OFFSET Offset OR OVERRIDE ' +
	        'PAUSE PREG PTH RT_LD RUN SELECT SKIP Skip TA TB TO TOOL_OFFSET ' +
	        'Tool_Offset UF UT UFRAME_NUM UTOOL_NUM UNLOCK WAIT X Y Z W P R STRLEN ' +
	        'SUBSTR FINDSTR VOFFSET',
	      constant:
	        'ON OFF max_speed LPOS JPOS ENABLE DISABLE START STOP RESET'
	    },
	    contains: [
	      TPDATA,
	      TPIO,
	      {
	        className: 'keyword',
	        begin: '/(PROG|ATTR|MN|POS|END)\\b'
	      },
	      {
	        /* this is for cases like ,CALL */
	        className: 'keyword',
	        begin: '(CALL|RUN|POINT_LOGIC|LBL)\\b'
	      },
	      {
	        /* this is for cases like CNT100 where the default lexemes do not
	         * separate the keyword and the number */
	        className: 'keyword',
	        begin: '\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)'
	      },
	      {
	        /* to catch numbers that do not have a word boundary on the left */
	        className: 'number',
	        begin: '\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b',
	        relevance: 0
	      },
	      hljs.COMMENT('//', '[;$]'),
	      hljs.COMMENT('!', '[;$]'),
	      hljs.COMMENT('--eg:', '$'),
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'', end: '\''
	      },
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'variable',
	        begin: '\\$[A-Za-z0-9_]+'
	      }
	    ]
	  };
	};

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)'
	  };
	
	  var FUNCTION_NAMES = 'attribute block constant cycle date dump include ' +
	                  'max min parent random range source template_from_string';
	
	  var FUNCTIONS = {
	    className: 'function',
	    beginKeywords: FUNCTION_NAMES,
	    relevance: 0,
	    contains: [
	      PARAMS
	    ]
	  };
	
	  var FILTER = {
	    className: 'filter',
	    begin: /\|[A-Za-z_]+:?/,
	    keywords:
	      'abs batch capitalize convert_encoding date date_modify default ' +
	      'escape first format join json_encode keys last length lower ' +
	      'merge nl2br number_format raw replace reverse round slice sort split ' +
	      'striptags title trim upper url_encode',
	    contains: [
	      FUNCTIONS
	    ]
	  };
	
	  var TAGS = 'autoescape block do embed extends filter flush for ' +
	    'if import include macro sandbox set spaceless use verbatim';
	
	  TAGS = TAGS + ' ' + TAGS.split(' ').map(function(t){return 'end' + t}).join(' ');
	
	  return {
	    aliases: ['craftcms'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT(/\{#/, /#}/),
	      {
	        className: 'template_tag',
	        begin: /\{%/, end: /%}/,
	        keywords: TAGS,
	        contains: [FILTER, FUNCTIONS]
	      },
	      {
	        className: 'variable',
	        begin: /\{\{/, end: /}}/,
	        contains: [FILTER, FUNCTIONS]
	      }
	    ]
	  };
	};

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      'in if for while finally var new function|0 do return void else break catch ' +
	      'instanceof with throw case default try this switch continue typeof delete ' +
	      'let yield const class public private protected get set super ' +
	      'static implements enum export import declare type namespace abstract',
	    literal:
	      'true false null undefined NaN Infinity',
	    built_in:
	      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
	      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
	      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
	      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
	      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
	      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
	      'module console window document any number boolean string void'
	  };
	
	  return {
	    aliases: ['ts'],
	    keywords: KEYWORDS,
	    contains: [
	      {
	        className: 'pi',
	        begin: /^\s*['"]use strict['"]/,
	        relevance: 0
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b(0[bB][01]+)' },
	          { begin: '\\b(0[oO][0-7]+)' },
	          { begin: hljs.C_NUMBER_RE }
	        ],
	        relevance: 0
	      },
	      { // "value" container
	        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
	        keywords: 'return throw case',
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.REGEXP_MODE
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: 'function', end: /[\{;]/, excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          'self',
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            keywords: KEYWORDS,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ],
	            illegal: /["'\(]/
	          }
	        ],
	        illegal: /\[|%/,
	        relevance: 0 // () => {} is more typical in TypeScript
	      },
	      {
	        className: 'constructor',
	        beginKeywords: 'constructor', end: /\{/, excludeEnd: true,
	        relevance: 10
	      },
	      {
	        className: 'module',
	        beginKeywords: 'module', end: /\{/, excludeEnd: true
	      },
	      {
	        className: 'interface',
	        beginKeywords: 'interface', end: /\{/, excludeEnd: true,
	        keywords: 'interface extends'
	      },
	      {
	        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
	      },
	      {
	        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
	      }
	    ]
	  };
	};

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword:
	        // Value types
	        'char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 ' +
	        'uint16 uint32 uint64 float double bool struct enum string void ' +
	        // Reference types
	        'weak unowned owned ' +
	        // Modifiers
	        'async signal static abstract interface override ' +
	        // Control Structures
	        'while do for foreach else switch case break default return try catch ' +
	        // Visibility
	        'public private protected internal ' +
	        // Other
	        'using new this get set const stdout stdin stderr var',
	      built_in:
	        'DBus GLib CCode Gee Object',
	      literal:
	        'false true null'
	    },
	    contains: [
	      {
	        className: 'class',
	        beginKeywords: 'class interface delegate namespace', end: '{', excludeEnd: true,
	        illegal: '[^,:\\n\\s\\.]',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'string',
	        begin: '"""', end: '"""',
	        relevance: 5
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'preprocessor',
	        begin: '^#', end: '$',
	        relevance: 2
	      },
	      {
	        className: 'constant',
	        begin: ' [A-Z_]+ ',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['vb'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'addhandler addressof alias and andalso aggregate ansi as assembly auto binary by byref byval ' + /* a-b */
	        'call case catch class compare const continue custom declare default delegate dim distinct do ' + /* c-d */
	        'each equals else elseif end enum erase error event exit explicit finally for friend from function ' + /* e-f */
	        'get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue ' + /* g-i */
	        'join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass ' + /* j-m */
	        'namespace narrowing new next not notinheritable notoverridable ' + /* n */
	        'of off on operator option optional or order orelse overloads overridable overrides ' + /* o */
	        'paramarray partial preserve private property protected public ' + /* p */
	        'raiseevent readonly redim rem removehandler resume return ' + /* r */
	        'select set shadows shared skip static step stop structure strict sub synclock ' + /* s */
	        'take text then throw to try unicode until using when where while widening with withevents writeonly xor', /* t-x */
	      built_in:
	        'boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype ' +  /* b-c */
	        'date decimal directcast double gettype getxmlnamespace iif integer long object ' + /* d-o */
	        'sbyte short single string trycast typeof uinteger ulong ushort', /* s-u */
	      literal:
	        'true false nothing'
	    },
	    illegal: '//|{|}|endif|gosub|variant|wend', /* reserved deprecated keywords */
	    contains: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
	      hljs.COMMENT(
	        '\'',
	        '$',
	        {
	          returnBegin: true,
	          contains: [
	            {
	              className: 'xmlDocTag',
	              begin: '\'\'\'|<!--|-->',
	              contains: [hljs.PHRASAL_WORDS_MODE]
	            },
	            {
	              className: 'xmlDocTag',
	              begin: '</?', end: '>',
	              contains: [hljs.PHRASAL_WORDS_MODE]
	            }
	          ]
	        }
	      ),
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'preprocessor',
	        begin: '#', end: '$',
	        keywords: 'if else elseif end region externalsource'
	      }
	    ]
	  };
	};

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    subLanguage: 'xml',
	    contains: [
	      {
	        begin: '<%', end: '%>',
	        subLanguage: 'vbscript'
	      }
	    ]
	  };
	};

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['vbs'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'call class const dim do loop erase execute executeglobal exit for each next function ' +
	        'if then else on error option explicit new private property let get public randomize ' +
	        'redim rem select case set stop sub while wend with end to elseif is or xor and not ' +
	        'class_initialize class_terminate default preserve in me byval byref step resume goto',
	      built_in:
	        'lcase month vartype instrrev ubound setlocale getobject rgb getref string ' +
	        'weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency ' +
	        'conversions csng timevalue second year space abs clng timeserial fixs len asc ' +
	        'isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate ' +
	        'instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex ' +
	        'chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim ' +
	        'strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion ' +
	        'scriptengine split scriptengineminorversion cint sin datepart ltrim sqr ' +
	        'scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw ' +
	        'chrw regexp server response request cstr err',
	      literal:
	        'true false null nothing empty'
	    },
	    illegal: '//',
	    contains: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
	      hljs.COMMENT(
	        /'/,
	        /$/,
	        {
	          relevance: 0
	        }
	      ),
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['v'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'always and assign begin buf bufif0 bufif1 case casex casez cmos deassign ' +
	        'default defparam disable edge else end endcase endfunction endmodule ' +
	        'endprimitive endspecify endtable endtask event for force forever fork ' +
	        'function if ifnone initial inout input join macromodule module nand ' +
	        'negedge nmos nor not notif0 notif1 or output parameter pmos posedge ' +
	        'primitive pulldown pullup rcmos release repeat rnmos rpmos rtran ' +
	        'rtranif0 rtranif1 specify specparam table task timescale tran ' +
	        'tranif0 tranif1 wait while xnor xor',
	      typename:
	        'highz0 highz1 integer large medium pull0 pull1 real realtime reg ' +
	        'scalared signed small strong0 strong1 supply0 supply0 supply1 supply1 ' +
	        'time tri tri0 tri1 triand trior trireg vectored wand weak0 weak1 wire wor'
	    },
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'number',
	        begin: '\\b(\\d+\'(b|h|o|d|B|H|O|D))?[0-9xzXZ]+',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        relevance: 0
	      },
	      /* ports in instances */
	      {
	        className: 'typename',
	        begin: '\\.\\w+',
	        relevance: 0
	      },
	      /* parameters to instances */
	      {
	        className: 'value',
	        begin: '#\\((?!parameter).+\\)'
	      },
	      /* operators */
	      {
	        className: 'keyword',
	        begin: '\\+|-|\\*|/|%|<|>|=|#|`|\\!|&|\\||@|:|\\^|~|\\{|\\}',
	        relevance: 0
	      }
	    ]
	  }; // return
	};

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  // Regular expression for VHDL numeric literals.
	
	  // Decimal literal:
	  var INTEGER_RE = '\\d(_|\\d)*';
	  var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
	  var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';
	  // Based literal:
	  var BASED_INTEGER_RE = '\\w+';
	  var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';
	
	  var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';
	
	  return {
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'abs access after alias all and architecture array assert attribute begin block ' +
	        'body buffer bus case component configuration constant context cover disconnect ' +
	        'downto default else elsif end entity exit fairness file for force function generate ' +
	        'generic group guarded if impure in inertial inout is label library linkage literal ' +
	        'loop map mod nand new next nor not null of on open or others out package port ' +
	        'postponed procedure process property protected pure range record register reject ' +
	        'release rem report restrict restrict_guarantee return rol ror select sequence ' +
	        'severity shared signal sla sll sra srl strong subtype then to transport type ' +
	        'unaffected units until use variable vmode vprop vunit wait when while with xnor xor',
	      typename:
	        'boolean bit character severity_level integer time delay_length natural positive ' +
	        'string bit_vector file_open_kind file_open_status std_ulogic std_ulogic_vector ' +
	        'std_logic std_logic_vector unsigned signed boolean_vector integer_vector ' +
	        'real_vector time_vector'
	    },
	    illegal: '{',
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,        // VHDL-2008 block commenting.
	      hljs.COMMENT('--', '$'),
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'number',
	        begin: NUMBER_RE,
	        relevance: 0
	      },
	      {
	        className: 'literal',
	        begin: '\'(U|X|0|1|Z|W|L|H|-)\'',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        className: 'attribute',
	        begin: '\'[A-Za-z](_?[A-Za-z0-9])*',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	};

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    lexemes: /[!#@\w]+/,
	    keywords: {
	      keyword: //ex command
	        // express version except: ! & * < = > !! # @ @@
	        'N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope '+
	        'cp cpf cq cr cs cst cu cuna cunme cw d|0 delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu g|0 go gr grepa gu gv ha h|0 helpf helpg helpt hi hid his i|0 ia iabc if ij il im imapc '+
	        'ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs n|0 new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 '+
	        'profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf q|0 quita qa r|0 rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv s|0 sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor '+
	        'so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync t|0 tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew '+
	        'tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up v|0 ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ '+
	        // full version
	        'Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload '+
	        'bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap '+
	        'cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor '+
	        'endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap '+
	        'imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview '+
	        'lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap '+
	        'nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext '+
	        'ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding '+
	        'scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace '+
	        'startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious '+'trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew '+
	        'vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank',
	      built_in: //built in func
	        'abs acos add and append argc argidx argv asin atan atan2 browse browsedir bufexists buflisted bufloaded bufname bufnr bufwinnr byte2line byteidx call ceil changenr char2nr cindent clearmatches col complete complete_add complete_check confirm copy cos cosh count cscope_connection cursor '+
	        'deepcopy delete did_filetype diff_filler diff_hlID empty escape eval eventhandler executable exists exp expand extend feedkeys filereadable filewritable filter finddir findfile float2nr floor fmod fnameescape fnamemodify foldclosed foldclosedend foldlevel foldtext foldtextresult foreground function '+
	        'garbagecollect get getbufline getbufvar getchar getcharmod getcmdline getcmdpos getcmdtype getcwd getfontname getfperm getfsize getftime getftype getline getloclist getmatches getpid getpos getqflist getreg getregtype gettabvar gettabwinvar getwinposx getwinposy getwinvar glob globpath has has_key '+
	        'haslocaldir hasmapto histadd histdel histget histnr hlexists hlID hostname iconv indent index input inputdialog inputlist inputrestore inputsave inputsecret insert invert isdirectory islocked items join keys len libcall libcallnr line line2byte lispindent localtime log log10 luaeval map maparg mapcheck '+
	        'match matchadd matcharg matchdelete matchend matchlist matchstr max min mkdir mode mzeval nextnonblank nr2char or pathshorten pow prevnonblank printf pumvisible py3eval pyeval range readfile reltime reltimestr remote_expr remote_foreground remote_peek remote_read remote_send remove rename repeat '+
	        'resolve reverse round screenattr screenchar screencol screenrow search searchdecl searchpair searchpairpos searchpos server2client serverlist setbufvar setcmdpos setline setloclist setmatches setpos setqflist setreg settabvar settabwinvar setwinvar sha256 shellescape shiftwidth simplify sin '+
	        'sinh sort soundfold spellbadword spellsuggest split sqrt str2float str2nr strchars strdisplaywidth strftime stridx string strlen strpart strridx strtrans strwidth submatch substitute synconcealed synID synIDattr '+
	        'synIDtrans synstack system tabpagebuflist tabpagenr tabpagewinnr tagfiles taglist tan tanh tempname tolower toupper tr trunc type undofile undotree values virtcol visualmode wildmenumode winbufnr wincol winheight winline winnr winrestcmd winrestview winsaveview winwidth writefile xor'
	    },
	    illegal: /[{:]/,
	    contains: [
	      hljs.NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      {
	        className: 'string',
	        // quote with escape, comment as quote
	        begin: /"((\\")|[^"\n])*("|\n)/
	      },
	      {
	        className: 'variable',
	        begin: /[bwtglsav]:[\w\d_]*/
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function function!', end: '$',
	        relevance: 0,
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)'
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    lexemes: '\\.?' + hljs.IDENT_RE,
	    keywords: {
	      keyword:
	        'lock rep repe repz repne repnz xaquire xrelease bnd nobnd ' +
	        'aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63',
	      literal:
	        // Instruction pointer
	        'ip eip rip ' +
	        // 8-bit registers
	        'al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ' +
	        // 16-bit registers
	        'ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w ' +
	        // 32-bit registers
	        'eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d ' +
	        // 64-bit registers
	        'rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 ' +
	        // Segment registers
	        'cs ds es fs gs ss ' +
	        // Floating point stack registers
	        'st st0 st1 st2 st3 st4 st5 st6 st7 ' +
	        // MMX Registers
	        'mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 ' +
	        // SSE registers
	        'xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 ' +
	        'xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ' +
	        // AVX registers
	        'ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ' +
	        'ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 ' +
	        // AVX-512F registers
	        'zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 ' +
	        'zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 ' +
	        // AVX-512F mask registers
	        'k0 k1 k2 k3 k4 k5 k6 k7 ' +
	        // Bound (MPX) register
	        'bnd0 bnd1 bnd2 bnd3 ' +
	        // Special register
	        'cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 ' +
	        // NASM altreg package
	        'r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b ' +
	        'r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d ' +
	        'r0h r1h r2h r3h ' +
	        'r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l',
	
	      pseudo:
	        'db dw dd dq dt ddq do dy dz ' +
	        'resb resw resd resq rest resdq reso resy resz ' +
	        'incbin equ times',
	
	      preprocessor:
	        '%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif ' +
	        '%ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep ' +
	        '%endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment ' +
	        '.nolist ' +
	        'byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr ' +
	        '__FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ ' +
	        '__UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend ' +
	        'align alignb sectalign daz nodaz up down zero default option assume public ',
	
	      built_in:
	        'bits use16 use32 use64 default section segment absolute extern global common cpu float ' +
	        '__utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ ' +
	        '__float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ ' +
	        '__Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e ' +
	        'float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__'
	    },
	    contains: [
	      hljs.COMMENT(
	        ';',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'number',
	        variants: [
	          // Float number and x87 BCD
	          {
	            begin: '\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|' +
	                   '(0[Xx])?[0-9][0-9_]*\\.?[0-9_]*(?:[pP](?:[+-]?[0-9_]+)?)?)\\b',
	            relevance: 0
	          },
	
	          // Hex number in $
	          { begin: '\\$[0-9][0-9A-Fa-f]*', relevance: 0 },
	
	          // Number in H,D,T,Q,O,B,Y suffix
	          { begin: '\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b' },
	
	          // Number in X,D,T,Q,O,B,Y prefix
	          { begin: '\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b'}
	        ]
	      },
	      // Double quote string
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        variants: [
	          // Single-quoted string
	          { begin: '\'', end: '[^\\\\]\'' },
	          // Backquoted string
	          { begin: '`', end: '[^\\\\]`' },
	          // Section name
	          { begin: '\\.[A-Za-z0-9]+' }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'label',
	        variants: [
	          // Global label and local label
	          { begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)' },
	          // Macro-local label
	          { begin: '^\\s*%%[A-Za-z0-9_$#@~.?]*:' }
	        ],
	        relevance: 0
	      },
	      // Macro parameter
	      {
	        className: 'argument',
	        begin: '%[0-9]+',
	        relevance: 0
	      },
	      // Macro parameter
	      {
	        className: 'built_in',
	        begin: '%!\S+',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BUILTIN_MODULES =
	    'ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo ' +
	    'StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts';
	
	  var XL_KEYWORDS = {
	    keyword: 'if then else do while until for loop import with is as where when by data constant',
	    literal: 'true false nil',
	    type: 'integer real text name boolean symbol infix prefix postfix block tree',
	    built_in: 'in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin acos atan exp expm1 log log2 log10 log1p pi at',
	    module: BUILTIN_MODULES,
	    id:
	      'text_length text_range text_find text_replace contains page slide basic_slide title_slide title subtitle ' +
	      'fade_in fade_out fade_at clear_color color line_color line_width texture_wrap texture_transform texture ' +
	      'scale_?x scale_?y scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y rotate_?z? rectangle ' +
	      'circle ellipse sphere path line_to move_to quad_to curve_to theme background contents locally time mouse_?x ' +
	      'mouse_?y mouse_buttons'
	  };
	
	  var XL_CONSTANT = {
	    className: 'constant',
	    begin: '[A-Z][A-Z_0-9]+',
	    relevance: 0
	  };
	  var XL_VARIABLE = {
	    className: 'variable',
	    begin: '([A-Z][a-z_0-9]+)+',
	    relevance: 0
	  };
	  var XL_ID = {
	    className: 'id',
	    begin: '[a-z][a-z_0-9]+',
	    relevance: 0
	  };
	
	  var DOUBLE_QUOTE_TEXT = {
	    className: 'string',
	    begin: '"', end: '"', illegal: '\\n'
	  };
	  var SINGLE_QUOTE_TEXT = {
	    className: 'string',
	    begin: '\'', end: '\'', illegal: '\\n'
	  };
	  var LONG_TEXT = {
	    className: 'string',
	    begin: '<<', end: '>>'
	  };
	  var BASED_NUMBER = {
	    className: 'number',
	    begin: '[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?',
	    relevance: 10
	  };
	  var IMPORT = {
	    className: 'import',
	    beginKeywords: 'import', end: '$',
	    keywords: {
	      keyword: 'import',
	      module: BUILTIN_MODULES
	    },
	    relevance: 0,
	    contains: [DOUBLE_QUOTE_TEXT]
	  };
	  var FUNCTION_DEFINITION = {
	    className: 'function',
	    begin: '[a-z].*->'
	  };
	  return {
	    aliases: ['tao'],
	    lexemes: /[a-zA-Z][a-zA-Z0-9_?]*/,
	    keywords: XL_KEYWORDS,
	    contains: [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    DOUBLE_QUOTE_TEXT,
	    SINGLE_QUOTE_TEXT,
	    LONG_TEXT,
	    FUNCTION_DEFINITION,
	    IMPORT,
	    XL_CONSTANT,
	    XL_VARIABLE,
	    XL_ID,
	    BASED_NUMBER,
	    hljs.NUMBER_MODE
	    ]
	  };
	};

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var XML_IDENT_RE = '[A-Za-z0-9\\._:-]+';
	  var PHP = {
	    begin: /<\?(php)?(?!\w)/, end: /\?>/,
	    subLanguage: 'php'
	  };
	  var TAG_INTERNALS = {
	    endsWithParent: true,
	    illegal: /</,
	    relevance: 0,
	    contains: [
	      PHP,
	      {
	        className: 'attribute',
	        begin: XML_IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: '=',
	        relevance: 0,
	        contains: [
	          {
	            className: 'value',
	            contains: [PHP],
	            variants: [
	              {begin: /"/, end: /"/},
	              {begin: /'/, end: /'/},
	              {begin: /[^\s\/>]+/}
	            ]
	          }
	        ]
	      }
	    ]
	  };
	  return {
	    aliases: ['html', 'xhtml', 'rss', 'atom', 'xsl', 'plist'],
	    case_insensitive: true,
	    contains: [
	      {
	        className: 'doctype',
	        begin: '<!DOCTYPE', end: '>',
	        relevance: 10,
	        contains: [{begin: '\\[', end: '\\]'}]
	      },
	      hljs.COMMENT(
	        '<!--',
	        '-->',
	        {
	          relevance: 10
	        }
	      ),
	      {
	        className: 'cdata',
	        begin: '<\\!\\[CDATA\\[', end: '\\]\\]>',
	        relevance: 10
	      },
	      {
	        className: 'tag',
	        /*
	        The lookahead pattern (?=...) ensures that 'begin' only matches
	        '<style' as a single word, followed by a whitespace or an
	        ending braket. The '$' is needed for the lexeme to be recognized
	        by hljs.subMode() that tests lexemes outside the stream.
	        */
	        begin: '<style(?=\\s|>|$)', end: '>',
	        keywords: {title: 'style'},
	        contains: [TAG_INTERNALS],
	        starts: {
	          end: '</style>', returnEnd: true,
	          subLanguage: 'css'
	        }
	      },
	      {
	        className: 'tag',
	        // See the comment in the <style tag about the lookahead pattern
	        begin: '<script(?=\\s|>|$)', end: '>',
	        keywords: {title: 'script'},
	        contains: [TAG_INTERNALS],
	        starts: {
	          end: '\<\/script\>', returnEnd: true,
	          subLanguage: ['actionscript', 'javascript', 'handlebars']
	        }
	      },
	      PHP,
	      {
	        className: 'pi',
	        begin: /<\?\w+/, end: /\?>/,
	        relevance: 10
	      },
	      {
	        className: 'tag',
	        begin: '</?', end: '/?>',
	        contains: [
	          {
	            className: 'title', begin: /[^ \/><\n\t]+/, relevance: 0
	          },
	          TAG_INTERNALS
	        ]
	      }
	    ]
	  };
	};

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = 'for let if while then else return where group by xquery encoding version' +
	    'module namespace boundary-space preserve strip default collation base-uri ordering' +
	    'copy-namespaces order declare import schema namespace function option in allowing empty' +
	    'at tumbling window sliding window start when only end when previous next stable ascending' +
	    'descending empty greatest least some every satisfies switch case typeswitch try catch and' +
	    'or to union intersect instance of treat as castable cast map array delete insert into' +
	    'replace value rename copy modify update';
	  var LITERAL = 'false true xs:string xs:integer element item xs:date xs:datetime xs:float xs:double xs:decimal QName xs:anyURI xs:long xs:int xs:short xs:byte attribute';
	  var VAR = {
	    className: 'variable',
	    begin: /\$[a-zA-Z0-9\-]+/,
	    relevance: 5
	  };
	
	  var NUMBER = {
	    className: 'number',
	    begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	    relevance: 0
	  };
	
	  var STRING = {
	    className: 'string',
	    variants: [
	      {begin: /"/, end: /"/, contains: [{begin: /""/, relevance: 0}]},
	      {begin: /'/, end: /'/, contains: [{begin: /''/, relevance: 0}]}
	    ]
	  };
	
	  var ANNOTATION = {
	    className: 'decorator',
	    begin: '%\\w+'
	  };
	
	  var COMMENT = {
	    className: 'comment',
	    begin: '\\(:', end: ':\\)',
	    relevance: 10,
	    contains: [
	      {
	        className: 'doc', begin: '@\\w+'
	      }
	    ]
	  };
	
	  var METHOD = {
	    begin: '{', end: '}'
	  };
	
	  var CONTAINS = [
	    VAR,
	    STRING,
	    NUMBER,
	    COMMENT,
	    ANNOTATION,
	    METHOD
	  ];
	  METHOD.contains = CONTAINS;
	
	
	  return {
	    aliases: ['xpath', 'xq'],
	    case_insensitive: false,
	    lexemes: /[a-zA-Z\$][a-zA-Z0-9_:\-]*/,
	    illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
	    keywords: {
	      keyword: KEYWORDS,
	      literal: LITERAL
	    },
	    contains: CONTAINS
	  };
	};

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: 'b"', end: '"'
	      },
	      {
	        begin: 'b\'', end: '\''
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
	    ]
	  };
	  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
	  return {
	    aliases: ['zep'],
	    case_insensitive: true,
	    keywords:
	    'and include_once list abstract global private echo interface as static endswitch ' +
	    'array null if endwhile or const for endforeach self var let while isset public ' +
	    'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
	    'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
	    'catch __METHOD__ case exception default die require __FUNCTION__ ' +
	    'enddeclare final try switch continue endfor endif declare unset true false ' +
	    'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
	    'yield finally int uint long ulong char uchar double float bool boolean string' +
	    'likely unlikely',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.HASH_COMMENT_MODE,
	      hljs.COMMENT(
	        '/\\*',
	        '\\*/',
	        {
	          contains: [
	            {
	              className: 'doctag',
	              begin: '@[A-Za-z]+'
	            }
	          ]
	        }
	      ),
	      hljs.COMMENT(
	        '__halt_compiler.+?;',
	        false,
	        {
	          endsWithParent: true,
	          keywords: '__halt_compiler',
	          lexemes: hljs.UNDERSCORE_IDENT_RE
	        }
	      ),
	      {
	        className: 'string',
	        begin: '<<<[\'"]?\\w+[\'"]?$', end: '^\\w+;',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        // swallow composed identifiers to avoid parsing them as keywords
	        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
	        illegal: '\\$|\\[|%',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              'self',
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRING,
	              NUMBER
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        illegal: /[:\(\$"]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: ';',
	        illegal: /[\.']/,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        beginKeywords: 'use', end: ';',
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      },
	      STRING,
	      NUMBER
	    ]
	  };
	};

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	
	'use strict';
	
	
	/* eslint-disable no-bitwise */
	
	var decodeCache = {};
	
	function getDecodeCache(exclude) {
	  var i, ch, cache = decodeCache[exclude];
	  if (cache) { return cache; }
	
	  cache = decodeCache[exclude] = [];
	
	  for (i = 0; i < 128; i++) {
	    ch = String.fromCharCode(i);
	    cache.push(ch);
	  }
	
	  for (i = 0; i < exclude.length; i++) {
	    ch = exclude.charCodeAt(i);
	    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
	  }
	
	  return cache;
	}
	
	
	// Decode percent-encoded string.
	//
	function decode(string, exclude) {
	  var cache;
	
	  if (typeof exclude !== 'string') {
	    exclude = decode.defaultChars;
	  }
	
	  cache = getDecodeCache(exclude);
	
	  return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
	    var i, l, b1, b2, b3, b4, chr,
	        result = '';
	
	    for (i = 0, l = seq.length; i < l; i += 3) {
	      b1 = parseInt(seq.slice(i + 1, i + 3), 16);
	
	      if (b1 < 0x80) {
	        result += cache[b1];
	        continue;
	      }
	
	      if ((b1 & 0xE0) === 0xC0 && (i + 3 < l)) {
	        // 110xxxxx 10xxxxxx
	        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
	
	        if ((b2 & 0xC0) === 0x80) {
	          chr = ((b1 << 6) & 0x7C0) | (b2 & 0x3F);
	
	          if (chr < 0x80) {
	            result += '\ufffd\ufffd';
	          } else {
	            result += String.fromCharCode(chr);
	          }
	
	          i += 3;
	          continue;
	        }
	      }
	
	      if ((b1 & 0xF0) === 0xE0 && (i + 6 < l)) {
	        // 1110xxxx 10xxxxxx 10xxxxxx
	        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
	        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
	
	        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
	          chr = ((b1 << 12) & 0xF000) | ((b2 << 6) & 0xFC0) | (b3 & 0x3F);
	
	          if (chr < 0x800 || (chr >= 0xD800 && chr <= 0xDFFF)) {
	            result += '\ufffd\ufffd\ufffd';
	          } else {
	            result += String.fromCharCode(chr);
	          }
	
	          i += 6;
	          continue;
	        }
	      }
	
	      if ((b1 & 0xF8) === 0xF0 && (i + 9 < l)) {
	        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
	        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
	        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
	        b4 = parseInt(seq.slice(i + 10, i + 12), 16);
	
	        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
	          chr = ((b1 << 18) & 0x1C0000) | ((b2 << 12) & 0x3F000) | ((b3 << 6) & 0xFC0) | (b4 & 0x3F);
	
	          if (chr < 0x10000 || chr > 0x10FFFF) {
	            result += '\ufffd\ufffd\ufffd\ufffd';
	          } else {
	            chr -= 0x10000;
	            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
	          }
	
	          i += 9;
	          continue;
	        }
	      }
	
	      result += '\ufffd';
	    }
	
	    return result;
	  });
	}
	
	
	decode.defaultChars   = ';/?:@&=+$,#';
	decode.componentChars = '';
	
	
	module.exports = decode;


/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	
	'use strict';
	
	
	var encodeCache = {};
	
	
	// Create a lookup array where anything but characters in `chars` string
	// and alphanumeric chars is percent-encoded.
	//
	function getEncodeCache(exclude) {
	  var i, ch, cache = encodeCache[exclude];
	  if (cache) { return cache; }
	
	  cache = encodeCache[exclude] = [];
	
	  for (i = 0; i < 128; i++) {
	    ch = String.fromCharCode(i);
	
	    if (/^[0-9a-z]$/i.test(ch)) {
	      // always allow unencoded alphanumeric characters
	      cache.push(ch);
	    } else {
	      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
	    }
	  }
	
	  for (i = 0; i < exclude.length; i++) {
	    cache[exclude.charCodeAt(i)] = exclude[i];
	  }
	
	  return cache;
	}
	
	
	// Encode unsafe characters with percent-encoding, skipping already
	// encoded sequences.
	//
	//  - string       - string to encode
	//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
	//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
	//
	function encode(string, exclude, keepEscaped) {
	  var i, l, code, nextCode, cache,
	      result = '';
	
	  if (typeof exclude !== 'string') {
	    // encode(string, keepEscaped)
	    keepEscaped  = exclude;
	    exclude = encode.defaultChars;
	  }
	
	  if (typeof keepEscaped === 'undefined') {
	    keepEscaped = true;
	  }
	
	  cache = getEncodeCache(exclude);
	
	  for (i = 0, l = string.length; i < l; i++) {
	    code = string.charCodeAt(i);
	
	    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
	      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
	        result += string.slice(i, i + 3);
	        i += 2;
	        continue;
	      }
	    }
	
	    if (code < 128) {
	      result += cache[code];
	      continue;
	    }
	
	    if (code >= 0xD800 && code <= 0xDFFF) {
	      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
	        nextCode = string.charCodeAt(i + 1);
	        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
	          result += encodeURIComponent(string[i] + string[i + 1]);
	          i++;
	          continue;
	        }
	      }
	      result += '%EF%BF%BD';
	      continue;
	    }
	
	    result += encodeURIComponent(string[i]);
	  }
	
	  return result;
	}
	
	encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
	encode.componentChars = "-_.!~*'()";
	
	
	module.exports = encode;


/***/ }),
/* 1413 */,
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(43);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	var ReactPropTypesSecret = __webpack_require__(1416);
	var checkPropTypes = __webpack_require__(1414);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _union = __webpack_require__(1131);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _without = __webpack_require__(487);
	
	var _without2 = _interopRequireDefault(_without);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnterLeaveCounter = function () {
	  function EnterLeaveCounter() {
	    _classCallCheck(this, EnterLeaveCounter);
	
	    this.entered = [];
	  }
	
	  _createClass(EnterLeaveCounter, [{
	    key: 'enter',
	    value: function enter(enteringNode) {
	      var previousLength = this.entered.length;
	
	      var isNodeEntered = function isNodeEntered(node) {
	        return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
	      };
	
	      this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
	
	      return previousLength === 0 && this.entered.length > 0;
	    }
	  }, {
	    key: 'leave',
	    value: function leave(leavingNode) {
	      var previousLength = this.entered.length;
	
	      this.entered = (0, _without2.default)(this.entered.filter(function (node) {
	        return document.documentElement.contains(node);
	      }), leavingNode);
	
	      return previousLength > 0 && this.entered.length === 0;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.entered = [];
	    }
	  }]);
	
	  return EnterLeaveCounter;
	}();
	
	exports.default = EnterLeaveCounter;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _defaults = __webpack_require__(1120);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _shallowEqual = __webpack_require__(1426);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _EnterLeaveCounter = __webpack_require__(1419);
	
	var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
	var _BrowserDetector = __webpack_require__(527);
	
	var _OffsetUtils = __webpack_require__(1423);
	
	var _NativeDragSources = __webpack_require__(1422);
	
	var _NativeTypes = __webpack_require__(340);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTML5Backend = function () {
	  function HTML5Backend(manager) {
	    _classCallCheck(this, HTML5Backend);
	
	    this.actions = manager.getActions();
	    this.monitor = manager.getMonitor();
	    this.registry = manager.getRegistry();
	    this.context = manager.getContext();
	
	    this.sourcePreviewNodes = {};
	    this.sourcePreviewNodeOptions = {};
	    this.sourceNodes = {};
	    this.sourceNodeOptions = {};
	    this.enterLeaveCounter = new _EnterLeaveCounter2.default();
	
	    this.dragStartSourceIds = [];
	    this.dropTargetIds = [];
	    this.dragEnterTargetIds = [];
	    this.currentNativeSource = null;
	    this.currentNativeHandle = null;
	    this.currentDragSourceNode = null;
	    this.currentDragSourceNodeOffset = null;
	    this.currentDragSourceNodeOffsetChanged = false;
	    this.altKeyPressed = false;
	
	    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
	    this.handleTopDragStart = this.handleTopDragStart.bind(this);
	    this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
	    this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
	    this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
	    this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
	    this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
	    this.handleTopDragOver = this.handleTopDragOver.bind(this);
	    this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
	    this.handleTopDrop = this.handleTopDrop.bind(this);
	    this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
	    this.handleSelectStart = this.handleSelectStart.bind(this);
	    this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
	    this.endDragNativeItem = this.endDragNativeItem.bind(this);
	  }
	
	  _createClass(HTML5Backend, [{
	    key: 'setup',
	    value: function setup() {
	      if (this.window === undefined) {
	        return;
	      }
	
	      if (this.window.__isReactDndBackendSetUp) {
	        // eslint-disable-line no-underscore-dangle
	        throw new Error('Cannot have two HTML5 backends at the same time.');
	      }
	      this.window.__isReactDndBackendSetUp = true; // eslint-disable-line no-underscore-dangle
	      this.addEventListeners(this.window);
	    }
	  }, {
	    key: 'teardown',
	    value: function teardown() {
	      if (this.window === undefined) {
	        return;
	      }
	
	      this.window.__isReactDndBackendSetUp = false; // eslint-disable-line no-underscore-dangle
	      this.removeEventListeners(this.window);
	      this.clearCurrentDragSourceNode();
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners(target) {
	      target.addEventListener('dragstart', this.handleTopDragStart);
	      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
	      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
	      target.addEventListener('dragenter', this.handleTopDragEnter);
	      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
	      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	      target.addEventListener('dragover', this.handleTopDragOver);
	      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
	      target.addEventListener('drop', this.handleTopDrop);
	      target.addEventListener('drop', this.handleTopDropCapture, true);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners(target) {
	      target.removeEventListener('dragstart', this.handleTopDragStart);
	      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
	      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
	      target.removeEventListener('dragenter', this.handleTopDragEnter);
	      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
	      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	      target.removeEventListener('dragover', this.handleTopDragOver);
	      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
	      target.removeEventListener('drop', this.handleTopDrop);
	      target.removeEventListener('drop', this.handleTopDropCapture, true);
	    }
	  }, {
	    key: 'connectDragPreview',
	    value: function connectDragPreview(sourceId, node, options) {
	      var _this = this;
	
	      this.sourcePreviewNodeOptions[sourceId] = options;
	      this.sourcePreviewNodes[sourceId] = node;
	
	      return function () {
	        delete _this.sourcePreviewNodes[sourceId];
	        delete _this.sourcePreviewNodeOptions[sourceId];
	      };
	    }
	  }, {
	    key: 'connectDragSource',
	    value: function connectDragSource(sourceId, node, options) {
	      var _this2 = this;
	
	      this.sourceNodes[sourceId] = node;
	      this.sourceNodeOptions[sourceId] = options;
	
	      var handleDragStart = function handleDragStart(e) {
	        return _this2.handleDragStart(e, sourceId);
	      };
	      var handleSelectStart = function handleSelectStart(e) {
	        return _this2.handleSelectStart(e, sourceId);
	      };
	
	      node.setAttribute('draggable', true);
	      node.addEventListener('dragstart', handleDragStart);
	      node.addEventListener('selectstart', handleSelectStart);
	
	      return function () {
	        delete _this2.sourceNodes[sourceId];
	        delete _this2.sourceNodeOptions[sourceId];
	
	        node.removeEventListener('dragstart', handleDragStart);
	        node.removeEventListener('selectstart', handleSelectStart);
	        node.setAttribute('draggable', false);
	      };
	    }
	  }, {
	    key: 'connectDropTarget',
	    value: function connectDropTarget(targetId, node) {
	      var _this3 = this;
	
	      var handleDragEnter = function handleDragEnter(e) {
	        return _this3.handleDragEnter(e, targetId);
	      };
	      var handleDragOver = function handleDragOver(e) {
	        return _this3.handleDragOver(e, targetId);
	      };
	      var handleDrop = function handleDrop(e) {
	        return _this3.handleDrop(e, targetId);
	      };
	
	      node.addEventListener('dragenter', handleDragEnter);
	      node.addEventListener('dragover', handleDragOver);
	      node.addEventListener('drop', handleDrop);
	
	      return function () {
	        node.removeEventListener('dragenter', handleDragEnter);
	        node.removeEventListener('dragover', handleDragOver);
	        node.removeEventListener('drop', handleDrop);
	      };
	    }
	  }, {
	    key: 'getCurrentSourceNodeOptions',
	    value: function getCurrentSourceNodeOptions() {
	      var sourceId = this.monitor.getSourceId();
	      var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
	      return (0, _defaults2.default)(sourceNodeOptions || {}, {
	        dropEffect: this.altKeyPressed ? 'copy' : 'move'
	      });
	    }
	  }, {
	    key: 'getCurrentDropEffect',
	    value: function getCurrentDropEffect() {
	      if (this.isDraggingNativeItem()) {
	        // It makes more sense to default to 'copy' for native resources
	        return 'copy';
	      }
	
	      return this.getCurrentSourceNodeOptions().dropEffect;
	    }
	  }, {
	    key: 'getCurrentSourcePreviewNodeOptions',
	    value: function getCurrentSourcePreviewNodeOptions() {
	      var sourceId = this.monitor.getSourceId();
	      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
	      return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
	        anchorX: 0.5,
	        anchorY: 0.5,
	        captureDraggingState: false
	      });
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset(sourceId) {
	      return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
	    }
	  }, {
	    key: 'isDraggingNativeItem',
	    value: function isDraggingNativeItem() {
	      var itemType = this.monitor.getItemType();
	      return Object.keys(NativeTypes).some(function (key) {
	        return NativeTypes[key] === itemType;
	      });
	    }
	  }, {
	    key: 'beginDragNativeItem',
	    value: function beginDragNativeItem(type) {
	      this.clearCurrentDragSourceNode();
	
	      var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
	      this.currentNativeSource = new SourceType();
	      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
	      this.actions.beginDrag([this.currentNativeHandle]);
	
	      // On Firefox, if mousemove fires, the drag is over but browser failed to tell us.
	      // This is not true for other browsers.
	      if ((0, _BrowserDetector.isFirefox)()) {
	        this.window.addEventListener('mousemove', this.endDragNativeItem, true);
	      }
	    }
	  }, {
	    key: 'endDragNativeItem',
	    value: function endDragNativeItem() {
	      if (!this.isDraggingNativeItem()) {
	        return;
	      }
	
	      if ((0, _BrowserDetector.isFirefox)()) {
	        this.window.removeEventListener('mousemove', this.endDragNativeItem, true);
	      }
	
	      this.actions.endDrag();
	      this.registry.removeSource(this.currentNativeHandle);
	      this.currentNativeHandle = null;
	      this.currentNativeSource = null;
	    }
	  }, {
	    key: 'endDragIfSourceWasRemovedFromDOM',
	    value: function endDragIfSourceWasRemovedFromDOM() {
	      var node = this.currentDragSourceNode;
	      if (document.body.contains(node)) {
	        return;
	      }
	
	      if (this.clearCurrentDragSourceNode()) {
	        this.actions.endDrag();
	      }
	    }
	  }, {
	    key: 'setCurrentDragSourceNode',
	    value: function setCurrentDragSourceNode(node) {
	      this.clearCurrentDragSourceNode();
	      this.currentDragSourceNode = node;
	      this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
	      this.currentDragSourceNodeOffsetChanged = false;
	
	      // Receiving a mouse event in the middle of a dragging operation
	      // means it has ended and the drag source node disappeared from DOM,
	      // so the browser didn't dispatch the dragend event.
	      this.window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	    }
	  }, {
	    key: 'clearCurrentDragSourceNode',
	    value: function clearCurrentDragSourceNode() {
	      if (this.currentDragSourceNode) {
	        this.currentDragSourceNode = null;
	        this.currentDragSourceNodeOffset = null;
	        this.currentDragSourceNodeOffsetChanged = false;
	        this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'checkIfCurrentDragSourceRectChanged',
	    value: function checkIfCurrentDragSourceRectChanged() {
	      var node = this.currentDragSourceNode;
	      if (!node) {
	        return false;
	      }
	
	      if (this.currentDragSourceNodeOffsetChanged) {
	        return true;
	      }
	
	      this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
	
	      return this.currentDragSourceNodeOffsetChanged;
	    }
	  }, {
	    key: 'handleTopDragStartCapture',
	    value: function handleTopDragStartCapture() {
	      this.clearCurrentDragSourceNode();
	      this.dragStartSourceIds = [];
	    }
	  }, {
	    key: 'handleDragStart',
	    value: function handleDragStart(e, sourceId) {
	      this.dragStartSourceIds.unshift(sourceId);
	    }
	  }, {
	    key: 'handleTopDragStart',
	    value: function handleTopDragStart(e) {
	      var _this4 = this;
	
	      var dragStartSourceIds = this.dragStartSourceIds;
	
	      this.dragStartSourceIds = null;
	
	      var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
	
	      // Don't publish the source just yet (see why below)
	      this.actions.beginDrag(dragStartSourceIds, {
	        publishSource: false,
	        getSourceClientOffset: this.getSourceClientOffset,
	        clientOffset: clientOffset
	      });
	
	      var dataTransfer = e.dataTransfer;
	
	      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
	      if (this.monitor.isDragging()) {
	        if (typeof dataTransfer.setDragImage === 'function') {
	          // Use custom drag image if user specifies it.
	          // If child drag source refuses drag but parent agrees,
	          // use parent's node as drag image. Neither works in IE though.
	          var sourceId = this.monitor.getSourceId();
	          var sourceNode = this.sourceNodes[sourceId];
	          var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
	          var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
	              anchorX = _getCurrentSourcePrev.anchorX,
	              anchorY = _getCurrentSourcePrev.anchorY;
	
	          var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
	          var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint);
	          dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
	        }
	
	        try {
	          // Firefox won't drag without setting data
	          dataTransfer.setData('application/json', {});
	        } catch (err) {}
	        // IE doesn't support MIME types in setData
	
	
	        // Store drag source node so we can check whether
	        // it is removed from DOM and trigger endDrag manually.
	        this.setCurrentDragSourceNode(e.target);
	
	        // Now we are ready to publish the drag source.. or are we not?
	
	        var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
	            captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
	
	        if (!captureDraggingState) {
	          // Usually we want to publish it in the next tick so that browser
	          // is able to screenshot the current (not yet dragging) state.
	          //
	          // It also neatly avoids a situation where render() returns null
	          // in the same tick for the source element, and browser freaks out.
	          setTimeout(function () {
	            return _this4.actions.publishDragSource();
	          });
	        } else {
	          // In some cases the user may want to override this behavior, e.g.
	          // to work around IE not supporting custom drag previews.
	          //
	          // When using a custom drag layer, the only way to prevent
	          // the default drag preview from drawing in IE is to screenshot
	          // the dragging state in which the node itself has zero opacity
	          // and height. In this case, though, returning null from render()
	          // will abruptly end the dragging, which is not obvious.
	          //
	          // This is the reason such behavior is strictly opt-in.
	          this.actions.publishDragSource();
	        }
	      } else if (nativeType) {
	        // A native item (such as URL) dragged from inside the document
	        this.beginDragNativeItem(nativeType);
	      } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
	        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
	        // Just let it drag. It's a native type (URL or text) and will be picked up in
	        // dragenter handler.
	        return; // eslint-disable-line no-useless-return
	      } else {
	        // If by this time no drag source reacted, tell browser not to drag.
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: 'handleTopDragEndCapture',
	    value: function handleTopDragEndCapture() {
	      if (this.clearCurrentDragSourceNode()) {
	        // Firefox can dispatch this event in an infinite loop
	        // if dragend handler does something like showing an alert.
	        // Only proceed if we have not handled it already.
	        this.actions.endDrag();
	      }
	    }
	  }, {
	    key: 'handleTopDragEnterCapture',
	    value: function handleTopDragEnterCapture(e) {
	      this.dragEnterTargetIds = [];
	
	      var isFirstEnter = this.enterLeaveCounter.enter(e.target);
	      if (!isFirstEnter || this.monitor.isDragging()) {
	        return;
	      }
	
	      var dataTransfer = e.dataTransfer;
	
	      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
	      if (nativeType) {
	        // A native item (such as file or URL) dragged from outside the document
	        this.beginDragNativeItem(nativeType);
	      }
	    }
	  }, {
	    key: 'handleDragEnter',
	    value: function handleDragEnter(e, targetId) {
	      this.dragEnterTargetIds.unshift(targetId);
	    }
	  }, {
	    key: 'handleTopDragEnter',
	    value: function handleTopDragEnter(e) {
	      var _this5 = this;
	
	      var dragEnterTargetIds = this.dragEnterTargetIds;
	
	      this.dragEnterTargetIds = [];
	
	      if (!this.monitor.isDragging()) {
	        // This is probably a native item type we don't understand.
	        return;
	      }
	
	      this.altKeyPressed = e.altKey;
	
	      if (!(0, _BrowserDetector.isFirefox)()) {
	        // Don't emit hover in `dragenter` on Firefox due to an edge case.
	        // If the target changes position as the result of `dragenter`, Firefox
	        // will still happily dispatch `dragover` despite target being no longer
	        // there. The easy solution is to only fire `hover` in `dragover` on FF.
	        this.actions.hover(dragEnterTargetIds, {
	          clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	        });
	      }
	
	      var canDrop = dragEnterTargetIds.some(function (targetId) {
	        return _this5.monitor.canDropOnTarget(targetId);
	      });
	
	      if (canDrop) {
	        // IE requires this to fire dragover events
	        e.preventDefault();
	        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	      }
	    }
	  }, {
	    key: 'handleTopDragOverCapture',
	    value: function handleTopDragOverCapture() {
	      this.dragOverTargetIds = [];
	    }
	  }, {
	    key: 'handleDragOver',
	    value: function handleDragOver(e, targetId) {
	      this.dragOverTargetIds.unshift(targetId);
	    }
	  }, {
	    key: 'handleTopDragOver',
	    value: function handleTopDragOver(e) {
	      var _this6 = this;
	
	      var dragOverTargetIds = this.dragOverTargetIds;
	
	      this.dragOverTargetIds = [];
	
	      if (!this.monitor.isDragging()) {
	        // This is probably a native item type we don't understand.
	        // Prevent default "drop and blow away the whole document" action.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = 'none';
	        return;
	      }
	
	      this.altKeyPressed = e.altKey;
	
	      this.actions.hover(dragOverTargetIds, {
	        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	      });
	
	      var canDrop = dragOverTargetIds.some(function (targetId) {
	        return _this6.monitor.canDropOnTarget(targetId);
	      });
	
	      if (canDrop) {
	        // Show user-specified drop effect.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	      } else if (this.isDraggingNativeItem()) {
	        // Don't show a nice cursor but still prevent default
	        // "drop and blow away the whole document" action.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = 'none';
	      } else if (this.checkIfCurrentDragSourceRectChanged()) {
	        // Prevent animating to incorrect position.
	        // Drop effect must be other than 'none' to prevent animation.
	        e.preventDefault();
	        e.dataTransfer.dropEffect = 'move';
	      }
	    }
	  }, {
	    key: 'handleTopDragLeaveCapture',
	    value: function handleTopDragLeaveCapture(e) {
	      if (this.isDraggingNativeItem()) {
	        e.preventDefault();
	      }
	
	      var isLastLeave = this.enterLeaveCounter.leave(e.target);
	      if (!isLastLeave) {
	        return;
	      }
	
	      if (this.isDraggingNativeItem()) {
	        this.endDragNativeItem();
	      }
	    }
	  }, {
	    key: 'handleTopDropCapture',
	    value: function handleTopDropCapture(e) {
	      this.dropTargetIds = [];
	      e.preventDefault();
	
	      if (this.isDraggingNativeItem()) {
	        this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
	      }
	
	      this.enterLeaveCounter.reset();
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(e, targetId) {
	      this.dropTargetIds.unshift(targetId);
	    }
	  }, {
	    key: 'handleTopDrop',
	    value: function handleTopDrop(e) {
	      var dropTargetIds = this.dropTargetIds;
	
	      this.dropTargetIds = [];
	
	      this.actions.hover(dropTargetIds, {
	        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	      });
	      this.actions.drop({ dropEffect: this.getCurrentDropEffect() });
	
	      if (this.isDraggingNativeItem()) {
	        this.endDragNativeItem();
	      } else {
	        this.endDragIfSourceWasRemovedFromDOM();
	      }
	    }
	  }, {
	    key: 'handleSelectStart',
	    value: function handleSelectStart(e) {
	      var target = e.target;
	
	      // Only IE requires us to explicitly say
	      // we want drag drop operation to start
	
	      if (typeof target.dragDrop !== 'function') {
	        return;
	      }
	
	      // Inputs and textareas should be selectable
	      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
	        return;
	      }
	
	      // For other targets, ask IE
	      // to enable drag and drop
	      e.preventDefault();
	      target.dragDrop();
	    }
	  }, {
	    key: 'window',
	    get: function get() {
	      if (this.context && this.context.window) {
	        return this.context.window;
	      } else if (typeof window !== 'undefined') {
	        return window;
	      }
	      return undefined;
	    }
	  }]);
	
	  return HTML5Backend;
	}();
	
	exports.default = HTML5Backend;

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint
	   no-plusplus: off,
	   no-mixed-operators: off
	*/
	var MonotonicInterpolant = function () {
	  function MonotonicInterpolant(xs, ys) {
	    _classCallCheck(this, MonotonicInterpolant);
	
	    var length = xs.length;
	
	    // Rearrange xs and ys so that xs is sorted
	    var indexes = [];
	    for (var i = 0; i < length; i++) {
	      indexes.push(i);
	    }
	    indexes.sort(function (a, b) {
	      return xs[a] < xs[b] ? -1 : 1;
	    });
	
	    // Get consecutive differences and slopes
	    var dys = [];
	    var dxs = [];
	    var ms = [];
	    var dx = void 0;
	    var dy = void 0;
	    for (var _i = 0; _i < length - 1; _i++) {
	      dx = xs[_i + 1] - xs[_i];
	      dy = ys[_i + 1] - ys[_i];
	      dxs.push(dx);
	      dys.push(dy);
	      ms.push(dy / dx);
	    }
	
	    // Get degree-1 coefficients
	    var c1s = [ms[0]];
	    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
	      var _m = ms[_i2];
	      var mNext = ms[_i2 + 1];
	      if (_m * mNext <= 0) {
	        c1s.push(0);
	      } else {
	        dx = dxs[_i2];
	        var dxNext = dxs[_i2 + 1];
	        var common = dx + dxNext;
	        c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
	      }
	    }
	    c1s.push(ms[ms.length - 1]);
	
	    // Get degree-2 and degree-3 coefficients
	    var c2s = [];
	    var c3s = [];
	    var m = void 0;
	    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
	      m = ms[_i3];
	      var c1 = c1s[_i3];
	      var invDx = 1 / dxs[_i3];
	      var _common = c1 + c1s[_i3 + 1] - m - m;
	      c2s.push((m - c1 - _common) * invDx);
	      c3s.push(_common * invDx * invDx);
	    }
	
	    this.xs = xs;
	    this.ys = ys;
	    this.c1s = c1s;
	    this.c2s = c2s;
	    this.c3s = c3s;
	  }
	
	  _createClass(MonotonicInterpolant, [{
	    key: "interpolate",
	    value: function interpolate(x) {
	      var xs = this.xs,
	          ys = this.ys,
	          c1s = this.c1s,
	          c2s = this.c2s,
	          c3s = this.c3s;
	
	      // The rightmost point in the dataset should give an exact result
	
	      var i = xs.length - 1;
	      if (x === xs[i]) {
	        return ys[i];
	      }
	
	      // Search for the interval x is in, returning the corresponding y if x is one of the original xs
	      var low = 0;
	      var high = c3s.length - 1;
	      var mid = void 0;
	      while (low <= high) {
	        mid = Math.floor(0.5 * (low + high));
	        var xHere = xs[mid];
	        if (xHere < x) {
	          low = mid + 1;
	        } else if (xHere > x) {
	          high = mid - 1;
	        } else {
	          return ys[mid];
	        }
	      }
	      i = Math.max(0, high);
	
	      // Interpolate
	      var diff = x - xs[i];
	      var diffSq = diff * diff;
	      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
	    }
	  }]);
	
	  return MonotonicInterpolant;
	}();
	
	exports.default = MonotonicInterpolant;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _nativeTypesConfig;
	
	exports.createNativeDragSource = createNativeDragSource;
	exports.matchNativeItemType = matchNativeItemType;
	
	var _NativeTypes = __webpack_require__(340);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
	    return resultSoFar || dataTransfer.getData(typeToTry);
	  }, null);
	
	  return result != null ? // eslint-disable-line eqeqeq
	  result : defaultValue;
	}
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	  exposeProperty: 'files',
	  matchesTypes: ['Files'],
	  getData: function getData(dataTransfer) {
	    return Array.prototype.slice.call(dataTransfer.files);
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	  exposeProperty: 'urls',
	  matchesTypes: ['Url', 'text/uri-list'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	  exposeProperty: 'text',
	  matchesTypes: ['Text', 'text/plain'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	  }
	}), _nativeTypesConfig);
	
	function createNativeDragSource(type) {
	  var _nativeTypesConfig$ty = nativeTypesConfig[type],
	      exposeProperty = _nativeTypesConfig$ty.exposeProperty,
	      matchesTypes = _nativeTypesConfig$ty.matchesTypes,
	      getData = _nativeTypesConfig$ty.getData;
	
	
	  return function () {
	    function NativeDragSource() {
	      var _item, _mutatorMap;
	
	      _classCallCheck(this, NativeDragSource);
	
	      this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
	        console.warn( // eslint-disable-line no-console
	        'Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
	        return null;
	      }, _defineEnumerableProperties(_item, _mutatorMap), _item);
	    }
	
	    _createClass(NativeDragSource, [{
	      key: 'mutateItemByReadingDataTransfer',
	      value: function mutateItemByReadingDataTransfer(dataTransfer) {
	        delete this.item[exposeProperty];
	        this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
	      }
	    }, {
	      key: 'canDrag',
	      value: function canDrag() {
	        return true;
	      }
	    }, {
	      key: 'beginDrag',
	      value: function beginDrag() {
	        return this.item;
	      }
	    }, {
	      key: 'isDragging',
	      value: function isDragging(monitor, handle) {
	        return handle === monitor.getSourceId();
	      }
	    }, {
	      key: 'endDrag',
	      value: function endDrag() {}
	    }]);
	
	    return NativeDragSource;
	  }();
	}
	
	function matchNativeItemType(dataTransfer) {
	  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
	  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
	    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
	    return matchesTypes.some(function (t) {
	      return dataTransferTypes.indexOf(t) > -1;
	    });
	  })[0] || null;
	}

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNodeClientOffset = getNodeClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	var _BrowserDetector = __webpack_require__(527);
	
	var _MonotonicInterpolant = __webpack_require__(1421);
	
	var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint
	   no-mixed-operators: off
	*/
	var ELEMENT_NODE = 1;
	
	function getNodeClientOffset(node) {
	  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
	  if (!el) {
	    return null;
	  }
	
	  var _el$getBoundingClient = el.getBoundingClientRect(),
	      top = _el$getBoundingClient.top,
	      left = _el$getBoundingClient.left;
	
	  return { x: left, y: top };
	}
	
	function getEventClientOffset(e) {
	  return {
	    x: e.clientX,
	    y: e.clientY
	  };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint) {
	  // The browsers will use the image intrinsic size under different conditions.
	  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
	  var isImage = dragPreview.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(dragPreview));
	  var dragPreviewNode = isImage ? sourceNode : dragPreview;
	
	  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	  var offsetFromDragPreview = {
	    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
	    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	  };
	
	  var sourceWidth = sourceNode.offsetWidth,
	      sourceHeight = sourceNode.offsetHeight;
	  var anchorX = anchorPoint.anchorX,
	      anchorY = anchorPoint.anchorY;
	
	
	  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
	  // Work around @2x coordinate discrepancies in browsers
	  if ((0, _BrowserDetector.isSafari)() && isImage) {
	    dragPreviewHeight /= window.devicePixelRatio;
	    dragPreviewWidth /= window.devicePixelRatio;
	  } else if ((0, _BrowserDetector.isFirefox)() && !isImage) {
	    dragPreviewHeight *= window.devicePixelRatio;
	    dragPreviewWidth *= window.devicePixelRatio;
	  }
	
	  // Interpolate coordinates depending on anchor point
	  // If you know a simpler way to do this, let me know
	  var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
	  // Dock to the left
	  offsetFromDragPreview.x,
	  // Align at the center
	  offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
	  // Dock to the right
	  offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
	  var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
	  // Dock to the top
	  offsetFromDragPreview.y,
	  // Align at the center
	  offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
	  // Dock to the bottom
	  offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
	  var x = interpolantX.interpolate(anchorX);
	  var y = interpolantY.interpolate(anchorY);
	
	  // Work around Safari 8 positioning bug
	  if ((0, _BrowserDetector.isSafari)() && isImage) {
	    // We'll have to wait for @3x to see if this is entirely correct
	    y += (window.devicePixelRatio - 1) * dragPreviewHeight;
	  }
	
	  return { x: x, y: y };
	}

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getEmptyImage;
	var emptyImage = void 0;
	function getEmptyImage() {
	  if (!emptyImage) {
	    emptyImage = new Image();
	    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	  }
	
	  return emptyImage;
	}

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEmptyImage = exports.NativeTypes = undefined;
	exports.default = createHTML5Backend;
	
	var _HTML5Backend = __webpack_require__(1420);
	
	var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
	var _getEmptyImage = __webpack_require__(1424);
	
	var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
	var _NativeTypes = __webpack_require__(340);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NativeTypes = NativeTypes;
	exports.getEmptyImage = _getEmptyImage2.default;
	function createHTML5Backend(manager) {
	  return new _HTML5Backend2.default(manager);
	}

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i += 1) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _DragDropContext = __webpack_require__(528);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This class is a React-Component based version of the DragDropContext.
	 * This is an alternative to decorating an application component with an ES7 decorator.
	 */
	var DragDropContextProvider = (_temp = _class = function (_Component) {
	  _inherits(DragDropContextProvider, _Component);
	
	  function DragDropContextProvider(props, context) {
	    _classCallCheck(this, DragDropContextProvider);
	
	    var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
	
	    _this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
	    return _this;
	  }
	
	  _createClass(DragDropContextProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      /**
	       * This property determines which window global to use for creating the DragDropManager.
	       * If a window has been injected explicitly via props, that is used first. If it is available
	       * as a context value, then use that, otherwise use the browser global.
	       */
	      var getWindow = function getWindow() {
	        if (_this2.props && _this2.props.window) {
	          return _this2.props.window;
	        } else if (_this2.context && _this2.context.window) {
	          return _this2.context.window;
	        } else if (typeof window !== 'undefined') {
	          return window;
	        }
	        return undefined;
	      };
	
	      return (0, _DragDropContext.createChildContext)(this.backend, { window: getWindow() });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return DragDropContextProvider;
	}(_react.Component), _class.propTypes = {
	  backend: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]).isRequired,
	  children: _react.PropTypes.element.isRequired,
	  window: _react.PropTypes.object }, _class.defaultProps = {
	  window: undefined
	}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
	  window: _react.PropTypes.object
	}, _temp);
	exports.default = DragDropContextProvider;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = DragLayer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(301);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _isPlainObject = __webpack_require__(114);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _shallowEqual = __webpack_require__(342);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(532);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	var _checkDecoratorArguments = __webpack_require__(226);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function DragLayer(collect) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer ' + 'to be a function that collects props to inject into the component. ', 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
	  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
	
	  return function decorateLayer(DecoratedComponent) {
	    var _class, _temp;
	
	    var _options$arePropsEqua = options.arePropsEqual,
	        arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    var DragLayerContainer = (_temp = _class = function (_Component) {
	      _inherits(DragLayerContainer, _Component);
	
	      _createClass(DragLayerContainer, [{
	        key: 'getDecoratedComponentInstance',
	        value: function getDecoratedComponentInstance() {
	          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
	          return this.child;
	        }
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	          return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
	        }
	      }]);
	
	      function DragLayerContainer(props, context) {
	        _classCallCheck(this, DragLayerContainer);
	
	        var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	
	        _this.manager = context.dragDropManager;
	        (0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	        _this.state = _this.getCurrentState();
	        return _this;
	      }
	
	      _createClass(DragLayerContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.isCurrentlyMounted = true;
	
	          var monitor = this.manager.getMonitor();
	          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
	          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	
	          this.handleChange();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.isCurrentlyMounted = false;
	
	          this.unsubscribeFromOffsetChange();
	          this.unsubscribeFromStateChange();
	        }
	      }, {
	        key: 'handleChange',
	        value: function handleChange() {
	          if (!this.isCurrentlyMounted) {
	            return;
	          }
	
	          var nextState = this.getCurrentState();
	          if (!(0, _shallowEqual2.default)(nextState, this.state)) {
	            this.setState(nextState);
	          }
	        }
	      }, {
	        key: 'getCurrentState',
	        value: function getCurrentState() {
	          var monitor = this.manager.getMonitor();
	          return collect(monitor);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this2 = this;
	
	          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	            ref: function ref(child) {
	              return _this2.child = child;
	            }
	          }));
	        }
	      }]);
	
	      return DragLayerContainer;
	    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
	      dragDropManager: _react.PropTypes.object.isRequired
	    }, _temp);
	
	
	    return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
	  };
	}

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DragSource;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(114);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(226);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(530);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerSource = __webpack_require__(1437);
	
	var _registerSource2 = _interopRequireDefault(_registerSource);
	
	var _createSourceFactory = __webpack_require__(1432);
	
	var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
	var _createSourceMonitor = __webpack_require__(1433);
	
	var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
	var _createSourceConnector = __webpack_require__(1431);
	
	var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
	var _isValidType = __webpack_require__(531);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DragSource(type, spec, collect) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  _checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	  var getType = type;
	  if (typeof type !== 'function') {
	    (0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
	    getType = function getType() {
	      return type;
	    };
	  }
	  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
	  var createSource = (0, _createSourceFactory2.default)(spec);
	  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	
	  return function decorateSource(DecoratedComponent) {
	    return (0, _decorateHandler2.default)({
	      connectBackend: function connectBackend(backend, sourceId) {
	        return backend.connectDragSource(sourceId);
	      },
	      containerDisplayName: 'DragSource',
	      createHandler: createSource,
	      registerHandler: _registerSource2.default,
	      createMonitor: _createSourceMonitor2.default,
	      createConnector: _createSourceConnector2.default,
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DropTarget;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(114);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(226);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(530);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerTarget = __webpack_require__(1438);
	
	var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
	var _createTargetFactory = __webpack_require__(1435);
	
	var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
	var _createTargetMonitor = __webpack_require__(1436);
	
	var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
	var _createTargetConnector = __webpack_require__(1434);
	
	var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
	var _isValidType = __webpack_require__(531);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropTarget(type, spec, collect) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  _checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	  var getType = type;
	  if (typeof type !== 'function') {
	    (0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
	    getType = function getType() {
	      return type;
	    };
	  }
	  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
	  var createTarget = (0, _createTargetFactory2.default)(spec);
	  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	
	  return function decorateTarget(DecoratedComponent) {
	    return (0, _decorateHandler2.default)({
	      connectBackend: function connectBackend(backend, targetId) {
	        return backend.connectDropTarget(targetId);
	      },
	      containerDisplayName: 'DropTarget',
	      createHandler: createTarget,
	      registerHandler: _registerTarget2.default,
	      createMonitor: _createTargetMonitor2.default,
	      createConnector: _createTargetConnector2.default,
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSourceConnector;
	
	var _wrapConnectorHooks = __webpack_require__(533);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(529);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSourceConnector(backend) {
	  var currentHandlerId = void 0;
	
	  var currentDragSourceNode = void 0;
	  var currentDragSourceOptions = void 0;
	  var disconnectCurrentDragSource = void 0;
	
	  var currentDragPreviewNode = void 0;
	  var currentDragPreviewOptions = void 0;
	  var disconnectCurrentDragPreview = void 0;
	
	  function reconnectDragSource() {
	    if (disconnectCurrentDragSource) {
	      disconnectCurrentDragSource();
	      disconnectCurrentDragSource = null;
	    }
	
	    if (currentHandlerId && currentDragSourceNode) {
	      disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
	    }
	  }
	
	  function reconnectDragPreview() {
	    if (disconnectCurrentDragPreview) {
	      disconnectCurrentDragPreview();
	      disconnectCurrentDragPreview = null;
	    }
	
	    if (currentHandlerId && currentDragPreviewNode) {
	      disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
	    }
	  }
	
	  function receiveHandlerId(handlerId) {
	    if (handlerId === currentHandlerId) {
	      return;
	    }
	
	    currentHandlerId = handlerId;
	    reconnectDragSource();
	    reconnectDragPreview();
	  }
	
	  var hooks = (0, _wrapConnectorHooks2.default)({
	    dragSource: function connectDragSource(node, options) {
	      if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
	        return;
	      }
	
	      currentDragSourceNode = node;
	      currentDragSourceOptions = options;
	
	      reconnectDragSource();
	    },
	
	    dragPreview: function connectDragPreview(node, options) {
	      if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
	        return;
	      }
	
	      currentDragPreviewNode = node;
	      currentDragPreviewOptions = options;
	
	      reconnectDragPreview();
	    }
	  });
	
	  return {
	    receiveHandlerId: receiveHandlerId,
	    hooks: hooks
	  };
	}

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceFactory;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(114);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	function createSourceFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	  REQUIRED_SPEC_METHODS.forEach(function (key) {
	    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	
	  var Source = function () {
	    function Source(monitor) {
	      _classCallCheck(this, Source);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    _createClass(Source, [{
	      key: 'receiveProps',
	      value: function receiveProps(props) {
	        this.props = props;
	      }
	    }, {
	      key: 'receiveComponent',
	      value: function receiveComponent(component) {
	        this.component = component;
	      }
	    }, {
	      key: 'canDrag',
	      value: function canDrag() {
	        if (!spec.canDrag) {
	          return true;
	        }
	
	        return spec.canDrag(this.props, this.monitor);
	      }
	    }, {
	      key: 'isDragging',
	      value: function isDragging(globalMonitor, sourceId) {
	        if (!spec.isDragging) {
	          return sourceId === globalMonitor.getSourceId();
	        }
	
	        return spec.isDragging(this.props, this.monitor);
	      }
	    }, {
	      key: 'beginDrag',
	      value: function beginDrag() {
	        var item = spec.beginDrag(this.props, this.monitor, this.component);
	        if (false) {
	          (0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
	        }
	        return item;
	      }
	    }, {
	      key: 'endDrag',
	      value: function endDrag() {
	        if (!spec.endDrag) {
	          return;
	        }
	
	        spec.endDrag(this.props, this.monitor, this.component);
	      }
	    }]);
	
	    return Source;
	  }();
	
	  return function createSource(monitor) {
	    return new Source(monitor);
	  };
	}

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceMonitor;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var SourceMonitor = function () {
	  function SourceMonitor(manager) {
	    _classCallCheck(this, SourceMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  _createClass(SourceMonitor, [{
	    key: 'receiveHandlerId',
	    value: function receiveHandlerId(sourceId) {
	      this.sourceId = sourceId;
	    }
	  }, {
	    key: 'canDrag',
	    value: function canDrag() {
	      (0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
	      try {
	        isCallingCanDrag = true;
	        return this.internalMonitor.canDragSource(this.sourceId);
	      } finally {
	        isCallingCanDrag = false;
	      }
	    }
	  }, {
	    key: 'isDragging',
	    value: function isDragging() {
	      (0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
	      try {
	        isCallingIsDragging = true;
	        return this.internalMonitor.isDraggingSource(this.sourceId);
	      } finally {
	        isCallingIsDragging = false;
	      }
	    }
	  }, {
	    key: 'getItemType',
	    value: function getItemType() {
	      return this.internalMonitor.getItemType();
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      return this.internalMonitor.getItem();
	    }
	  }, {
	    key: 'getDropResult',
	    value: function getDropResult() {
	      return this.internalMonitor.getDropResult();
	    }
	  }, {
	    key: 'didDrop',
	    value: function didDrop() {
	      return this.internalMonitor.didDrop();
	    }
	  }, {
	    key: 'getInitialClientOffset',
	    value: function getInitialClientOffset() {
	      return this.internalMonitor.getInitialClientOffset();
	    }
	  }, {
	    key: 'getInitialSourceClientOffset',
	    value: function getInitialSourceClientOffset() {
	      return this.internalMonitor.getInitialSourceClientOffset();
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset() {
	      return this.internalMonitor.getSourceClientOffset();
	    }
	  }, {
	    key: 'getClientOffset',
	    value: function getClientOffset() {
	      return this.internalMonitor.getClientOffset();
	    }
	  }, {
	    key: 'getDifferenceFromInitialOffset',
	    value: function getDifferenceFromInitialOffset() {
	      return this.internalMonitor.getDifferenceFromInitialOffset();
	    }
	  }]);
	
	  return SourceMonitor;
	}();
	
	function createSourceMonitor(manager) {
	  return new SourceMonitor(manager);
	}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTargetConnector;
	
	var _wrapConnectorHooks = __webpack_require__(533);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(529);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTargetConnector(backend) {
	  var currentHandlerId = void 0;
	
	  var currentDropTargetNode = void 0;
	  var currentDropTargetOptions = void 0;
	  var disconnectCurrentDropTarget = void 0;
	
	  function reconnectDropTarget() {
	    if (disconnectCurrentDropTarget) {
	      disconnectCurrentDropTarget();
	      disconnectCurrentDropTarget = null;
	    }
	
	    if (currentHandlerId && currentDropTargetNode) {
	      disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
	    }
	  }
	
	  function receiveHandlerId(handlerId) {
	    if (handlerId === currentHandlerId) {
	      return;
	    }
	
	    currentHandlerId = handlerId;
	    reconnectDropTarget();
	  }
	
	  var hooks = (0, _wrapConnectorHooks2.default)({
	    dropTarget: function connectDropTarget(node, options) {
	      if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
	        return;
	      }
	
	      currentDropTargetNode = node;
	      currentDropTargetOptions = options;
	
	      reconnectDropTarget();
	    }
	  });
	
	  return {
	    receiveHandlerId: receiveHandlerId,
	    hooks: hooks
	  };
	}

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetFactory;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(114);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	function createTargetFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	  });
	
	  var Target = function () {
	    function Target(monitor) {
	      _classCallCheck(this, Target);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    _createClass(Target, [{
	      key: 'receiveProps',
	      value: function receiveProps(props) {
	        this.props = props;
	      }
	    }, {
	      key: 'receiveMonitor',
	      value: function receiveMonitor(monitor) {
	        this.monitor = monitor;
	      }
	    }, {
	      key: 'receiveComponent',
	      value: function receiveComponent(component) {
	        this.component = component;
	      }
	    }, {
	      key: 'canDrop',
	      value: function canDrop() {
	        if (!spec.canDrop) {
	          return true;
	        }
	
	        return spec.canDrop(this.props, this.monitor);
	      }
	    }, {
	      key: 'hover',
	      value: function hover() {
	        if (!spec.hover) {
	          return;
	        }
	
	        spec.hover(this.props, this.monitor, this.component);
	      }
	    }, {
	      key: 'drop',
	      value: function drop() {
	        if (!spec.drop) {
	          return undefined;
	        }
	
	        var dropResult = spec.drop(this.props, this.monitor, this.component);
	        if (false) {
	          (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
	        }
	        return dropResult;
	      }
	    }]);
	
	    return Target;
	  }();
	
	  return function createTarget(monitor) {
	    return new Target(monitor);
	  };
	}

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetMonitor;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrop = false;
	
	var TargetMonitor = function () {
	  function TargetMonitor(manager) {
	    _classCallCheck(this, TargetMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  _createClass(TargetMonitor, [{
	    key: 'receiveHandlerId',
	    value: function receiveHandlerId(targetId) {
	      this.targetId = targetId;
	    }
	  }, {
	    key: 'canDrop',
	    value: function canDrop() {
	      (0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
	
	      try {
	        isCallingCanDrop = true;
	        return this.internalMonitor.canDropOnTarget(this.targetId);
	      } finally {
	        isCallingCanDrop = false;
	      }
	    }
	  }, {
	    key: 'isOver',
	    value: function isOver(options) {
	      return this.internalMonitor.isOverTarget(this.targetId, options);
	    }
	  }, {
	    key: 'getItemType',
	    value: function getItemType() {
	      return this.internalMonitor.getItemType();
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      return this.internalMonitor.getItem();
	    }
	  }, {
	    key: 'getDropResult',
	    value: function getDropResult() {
	      return this.internalMonitor.getDropResult();
	    }
	  }, {
	    key: 'didDrop',
	    value: function didDrop() {
	      return this.internalMonitor.didDrop();
	    }
	  }, {
	    key: 'getInitialClientOffset',
	    value: function getInitialClientOffset() {
	      return this.internalMonitor.getInitialClientOffset();
	    }
	  }, {
	    key: 'getInitialSourceClientOffset',
	    value: function getInitialSourceClientOffset() {
	      return this.internalMonitor.getInitialSourceClientOffset();
	    }
	  }, {
	    key: 'getSourceClientOffset',
	    value: function getSourceClientOffset() {
	      return this.internalMonitor.getSourceClientOffset();
	    }
	  }, {
	    key: 'getClientOffset',
	    value: function getClientOffset() {
	      return this.internalMonitor.getClientOffset();
	    }
	  }, {
	    key: 'getDifferenceFromInitialOffset',
	    value: function getDifferenceFromInitialOffset() {
	      return this.internalMonitor.getDifferenceFromInitialOffset();
	    }
	  }]);
	
	  return TargetMonitor;
	}();
	
	function createTargetMonitor(manager) {
	  return new TargetMonitor(manager);
	}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerSource;
	function registerSource(type, source, manager) {
	  var registry = manager.getRegistry();
	  var sourceId = registry.addSource(type, source);
	
	  function unregisterSource() {
	    registry.removeSource(sourceId);
	  }
	
	  return {
	    handlerId: sourceId,
	    unregister: unregisterSource
	  };
	}

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerTarget;
	function registerTarget(type, target, manager) {
	  var registry = manager.getRegistry();
	  var targetId = registry.addTarget(type, target);
	
	  function unregisterTarget() {
	    registry.removeTarget(targetId);
	  }
	
	  return {
	    handlerId: targetId,
	    unregister: unregisterTarget
	  };
	}

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneWithRef;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneWithRef(element, newRef) {
	  var previousRef = element.ref;
	  (0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
	  if (!previousRef) {
	    // When there is no ref on the element, use the new ref directly
	    return (0, _react.cloneElement)(element, {
	      ref: newRef
	    });
	  }
	
	  return (0, _react.cloneElement)(element, {
	    ref: function ref(node) {
	      newRef(node);
	
	      if (previousRef) {
	        previousRef(node);
	      }
	    }
	  });
	}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var focusNode = __webpack_require__(452);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(174);
	var ExecutionEnvironment = __webpack_require__(42);
	var FallbackCompositionState = __webpack_require__(1448);
	var SyntheticCompositionEvent = __webpack_require__(1485);
	var SyntheticInputEvent = __webpack_require__(1488);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(343);
	var ExecutionEnvironment = __webpack_require__(42);
	var ReactInstrumentation = __webpack_require__(65);
	
	var camelizeStyleName = __webpack_require__(997);
	var dangerousStyleValue = __webpack_require__(1494);
	var hyphenateStyleName = __webpack_require__(1005);
	var memoizeStringOnly = __webpack_require__(455);
	var warning = __webpack_require__(14);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(173);
	var EventPropagators = __webpack_require__(174);
	var ExecutionEnvironment = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(75);
	var SyntheticEvent = __webpack_require__(86);
	
	var getEventTarget = __webpack_require__(356);
	var isEventSupported = __webpack_require__(357);
	var isTextInputElement = __webpack_require__(550);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMLazyTree = __webpack_require__(143);
	var ExecutionEnvironment = __webpack_require__(42);
	
	var createNodesFromMarkup = __webpack_require__(998);
	var emptyFunction = __webpack_require__(43);
	var invariant = __webpack_require__(7);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(174);
	var ReactDOMComponentTree = __webpack_require__(33);
	var SyntheticMouseEvent = __webpack_require__(228);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var PooledClass = __webpack_require__(120);
	
	var getTextContentAccessor = __webpack_require__(548);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(144);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(145);
	
	var instantiateReactComponent = __webpack_require__(549);
	var KeyEscapeUtils = __webpack_require__(348);
	var shouldUpdateReactComponent = __webpack_require__(358);
	var traverseAllChildren = __webpack_require__(552);
	var warning = __webpack_require__(14);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(553);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(344);
	var ReactDOMIDOperations = __webpack_require__(1458);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(22);
	
	var React = __webpack_require__(146);
	var ReactComponentEnvironment = __webpack_require__(350);
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactErrorUtils = __webpack_require__(351);
	var ReactInstanceMap = __webpack_require__(175);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactNodeTypes = __webpack_require__(543);
	var ReactReconciler = __webpack_require__(145);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(164);
	var invariant = __webpack_require__(7);
	var shallowEqual = __webpack_require__(299);
	var shouldUpdateReactComponent = __webpack_require__(358);
	var warning = __webpack_require__(14);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDefaultInjection = __webpack_require__(1466);
	var ReactMount = __webpack_require__(542);
	var ReactReconciler = __webpack_require__(145);
	var ReactUpdates = __webpack_require__(75);
	var ReactVersion = __webpack_require__(1479);
	
	var findDOMNode = __webpack_require__(1495);
	var getHostComponentFromComposite = __webpack_require__(547);
	var renderSubtreeIntoContainer = __webpack_require__(1502);
	var warning = __webpack_require__(14);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(22);
	
	var AutoFocusUtils = __webpack_require__(1441);
	var CSSPropertyOperations = __webpack_require__(1443);
	var DOMLazyTree = __webpack_require__(143);
	var DOMNamespaces = __webpack_require__(345);
	var DOMProperty = __webpack_require__(144);
	var DOMPropertyOperations = __webpack_require__(535);
	var EventPluginHub = __webpack_require__(173);
	var EventPluginRegistry = __webpack_require__(346);
	var ReactBrowserEventEmitter = __webpack_require__(227);
	var ReactDOMComponentFlags = __webpack_require__(536);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMInput = __webpack_require__(1459);
	var ReactDOMOption = __webpack_require__(1460);
	var ReactDOMSelect = __webpack_require__(537);
	var ReactDOMTextarea = __webpack_require__(1463);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactMultiChild = __webpack_require__(1472);
	var ReactServerRenderingTransaction = __webpack_require__(1477);
	
	var emptyFunction = __webpack_require__(43);
	var escapeTextContentForBrowser = __webpack_require__(230);
	var invariant = __webpack_require__(7);
	var isEventSupported = __webpack_require__(357);
	var shallowEqual = __webpack_require__(299);
	var validateDOMNesting = __webpack_require__(359);
	var warning = __webpack_require__(14);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(359);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var DOMLazyTree = __webpack_require__(143);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(344);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(22);
	
	var DOMPropertyOperations = __webpack_require__(535);
	var LinkedValueUtils = __webpack_require__(349);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(75);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var React = __webpack_require__(146);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMSelect = __webpack_require__(537);
	
	var warning = __webpack_require__(14);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(42);
	
	var getNodeForCharacterOffset = __webpack_require__(1499);
	var getTextContentAccessor = __webpack_require__(548);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(22);
	
	var DOMChildrenOperations = __webpack_require__(344);
	var DOMLazyTree = __webpack_require__(143);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var escapeTextContentForBrowser = __webpack_require__(230);
	var invariant = __webpack_require__(7);
	var validateDOMNesting = __webpack_require__(359);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(22);
	
	var LinkedValueUtils = __webpack_require__(349);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(75);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var ReactUpdates = __webpack_require__(75);
	var Transaction = __webpack_require__(229);
	
	var emptyFunction = __webpack_require__(43);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1440);
	var BeforeInputEventPlugin = __webpack_require__(1442);
	var ChangeEventPlugin = __webpack_require__(1444);
	var DefaultEventPluginOrder = __webpack_require__(1446);
	var EnterLeaveEventPlugin = __webpack_require__(1447);
	var HTMLDOMPropertyConfig = __webpack_require__(1449);
	var ReactComponentBrowserEnvironment = __webpack_require__(1451);
	var ReactDOMComponent = __webpack_require__(1454);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMEmptyComponent = __webpack_require__(1456);
	var ReactDOMTreeTraversal = __webpack_require__(1464);
	var ReactDOMTextComponent = __webpack_require__(1462);
	var ReactDefaultBatchingStrategy = __webpack_require__(1465);
	var ReactEventListener = __webpack_require__(1469);
	var ReactInjection = __webpack_require__(1470);
	var ReactReconcileTransaction = __webpack_require__(1475);
	var SVGDOMPropertyConfig = __webpack_require__(1480);
	var SelectEventPlugin = __webpack_require__(1481);
	var SimpleEventPlugin = __webpack_require__(1482);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(173);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var EventListener = __webpack_require__(447);
	var ExecutionEnvironment = __webpack_require__(42);
	var PooledClass = __webpack_require__(120);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(75);
	
	var getEventTarget = __webpack_require__(356);
	var getUnboundedScrollPosition = __webpack_require__(453);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(144);
	var EventPluginHub = __webpack_require__(173);
	var EventPluginUtils = __webpack_require__(347);
	var ReactComponentEnvironment = __webpack_require__(350);
	var ReactEmptyComponent = __webpack_require__(538);
	var ReactBrowserEventEmitter = __webpack_require__(227);
	var ReactHostComponent = __webpack_require__(540);
	var ReactUpdates = __webpack_require__(75);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1493);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactComponentEnvironment = __webpack_require__(350);
	var ReactInstanceMap = __webpack_require__(175);
	var ReactInstrumentation = __webpack_require__(65);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactReconciler = __webpack_require__(145);
	var ReactChildReconciler = __webpack_require__(1450);
	
	var emptyFunction = __webpack_require__(43);
	var flattenChildren = __webpack_require__(1496);
	var invariant = __webpack_require__(7);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var CallbackQueue = __webpack_require__(534);
	var PooledClass = __webpack_require__(120);
	var ReactBrowserEventEmitter = __webpack_require__(227);
	var ReactInputSelection = __webpack_require__(541);
	var ReactInstrumentation = __webpack_require__(65);
	var Transaction = __webpack_require__(229);
	var ReactUpdateQueue = __webpack_require__(352);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1473);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var PooledClass = __webpack_require__(120);
	var Transaction = __webpack_require__(229);
	var ReactInstrumentation = __webpack_require__(65);
	var ReactServerUpdateQueue = __webpack_require__(1478);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(352);
	
	var warning = __webpack_require__(14);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(174);
	var ExecutionEnvironment = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInputSelection = __webpack_require__(541);
	var SyntheticEvent = __webpack_require__(86);
	
	var getActiveElement = __webpack_require__(203);
	var isTextInputElement = __webpack_require__(550);
	var shallowEqual = __webpack_require__(299);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var EventListener = __webpack_require__(447);
	var EventPropagators = __webpack_require__(174);
	var ReactDOMComponentTree = __webpack_require__(33);
	var SyntheticAnimationEvent = __webpack_require__(1483);
	var SyntheticClipboardEvent = __webpack_require__(1484);
	var SyntheticEvent = __webpack_require__(86);
	var SyntheticFocusEvent = __webpack_require__(1487);
	var SyntheticKeyboardEvent = __webpack_require__(1489);
	var SyntheticMouseEvent = __webpack_require__(228);
	var SyntheticDragEvent = __webpack_require__(1486);
	var SyntheticTouchEvent = __webpack_require__(1490);
	var SyntheticTransitionEvent = __webpack_require__(1491);
	var SyntheticUIEvent = __webpack_require__(176);
	var SyntheticWheelEvent = __webpack_require__(1492);
	
	var emptyFunction = __webpack_require__(43);
	var getEventCharCode = __webpack_require__(354);
	var invariant = __webpack_require__(7);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(228);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(176);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(176);
	
	var getEventCharCode = __webpack_require__(354);
	var getEventKey = __webpack_require__(1497);
	var getEventModifierState = __webpack_require__(355);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(176);
	
	var getEventModifierState = __webpack_require__(355);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(86);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(228);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(343);
	var warning = __webpack_require__(14);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstanceMap = __webpack_require__(175);
	
	var getHostComponentFromComposite = __webpack_require__(547);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(348);
	var traverseAllChildren = __webpack_require__(552);
	var warning = __webpack_require__(14);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(553);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(354);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(42);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(230);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(542);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(148);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1504);
	var ReactElement = __webpack_require__(147);
	
	var emptyFunction = __webpack_require__(43);
	var traverseAllChildren = __webpack_require__(1515);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(148),
	    _assign = __webpack_require__(22);
	
	var ReactComponent = __webpack_require__(360);
	var ReactElement = __webpack_require__(147);
	var ReactPropTypeLocationNames = __webpack_require__(1508);
	var ReactNoopUpdateQueue = __webpack_require__(361);
	
	var emptyObject = __webpack_require__(164);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(14);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(147);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(147),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(525);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var ReactComponent = __webpack_require__(360);
	var ReactNoopUpdateQueue = __webpack_require__(361);
	
	var emptyObject = __webpack_require__(164);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(148);
	
	var ReactElement = __webpack_require__(147);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(148);
	
	var ReactCurrentOwner = __webpack_require__(87);
	var REACT_ELEMENT_TYPE = __webpack_require__(554);
	
	var getIteratorFn = __webpack_require__(1512);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(1503);
	var warning = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(122);


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(557);
	
	/*<replacement>*/
	var util = __webpack_require__(158);
	util.inherits = __webpack_require__(72);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(88).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(181);
	/*</replacement>*/
	
	module.exports = BufferList;
	
	function BufferList() {
	  this.head = null;
	  this.tail = null;
	  this.length = 0;
	}
	
	BufferList.prototype.push = function (v) {
	  var entry = { data: v, next: null };
	  if (this.length > 0) this.tail.next = entry;else this.head = entry;
	  this.tail = entry;
	  ++this.length;
	};
	
	BufferList.prototype.unshift = function (v) {
	  var entry = { data: v, next: this.head };
	  if (this.length === 0) this.tail = entry;
	  this.head = entry;
	  ++this.length;
	};
	
	BufferList.prototype.shift = function () {
	  if (this.length === 0) return;
	  var ret = this.head.data;
	  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	  --this.length;
	  return ret;
	};
	
	BufferList.prototype.clear = function () {
	  this.head = this.tail = null;
	  this.length = 0;
	};
	
	BufferList.prototype.join = function (s) {
	  if (this.length === 0) return '';
	  var p = this.head;
	  var ret = '' + p.data;
	  while (p = p.next) {
	    ret += s + p.data;
	  }return ret;
	};
	
	BufferList.prototype.concat = function (n) {
	  if (this.length === 0) return bufferShim.alloc(0);
	  if (this.length === 1) return this.head.data;
	  var ret = bufferShim.allocUnsafe(n >>> 0);
	  var p = this.head;
	  var i = 0;
	  while (p) {
	    p.data.copy(ret, i);
	    i += p.data.length;
	    p = p.next;
	  }
	  return ret;
	};

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(363).PassThrough


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(363).Transform


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(362);


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(114);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1527);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(559);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	module.exports = function (string) {
	  return string.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&")
	}


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(56).EventEmitter;
	var inherits = __webpack_require__(72);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(363);
	Stream.Writable = __webpack_require__(1521);
	Stream.Duplex = __webpack_require__(1516);
	Stream.Transform = __webpack_require__(1520);
	Stream.PassThrough = __webpack_require__(1519);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	/*! http://mths.be/repeat v0.2.0 by @mathias */
	if (!String.prototype.repeat) {
		(function() {
			'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
			var defineProperty = (function() {
				// IE 8 only supports `Object.defineProperty` on DOM elements
				try {
					var object = {};
					var $defineProperty = Object.defineProperty;
					var result = $defineProperty(object, object, object) && $defineProperty;
				} catch(error) {}
				return result;
			}());
			var repeat = function(count) {
				if (this == null) {
					throw TypeError();
				}
				var string = String(this);
				// `ToInteger`
				var n = count ? Number(count) : 0;
				if (n != n) { // better `isNaN`
					n = 0;
				}
				// Account for out-of-bounds indices
				if (n < 0 || n == Infinity) {
					throw RangeError();
				}
				var result = '';
				while (n) {
					if (n % 2 == 1) {
						result += string;
					}
					if (n > 1) {
						string += string;
					}
					n >>= 1;
				}
				return result;
			};
			if (defineProperty) {
				defineProperty(String.prototype, 'repeat', {
					'value': repeat,
					'configurable': true,
					'writable': true
				});
			} else {
				String.prototype.repeat = repeat;
			}
		}());
	}


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1528);


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1529);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(234)(module)))

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1530 */,
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234)(module), (function() { return this; }())))

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	/**********************
	   Velocity UI Pack
	**********************/
	
	/* VelocityJS.org UI Pack (5.0.4). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License. Portions copyright Daniel Eden, Christian Pucci. */
	
	;(function (factory) {
	    /* CommonJS module. */
	    if (true ) {
	        module.exports = factory();
	    /* AMD module. */
	    } else if (typeof define === "function" && define.amd) {
	        define([ "velocity" ], factory);
	    /* Browser globals. */
	    } else {
	        factory();
	    }
	}(function() {
	return function (global, window, document, undefined) {
	
	    /*************
	        Checks
	    *************/
	
	    if (!global.Velocity || !global.Velocity.Utilities) {
	        window.console && console.log("Velocity UI Pack: Velocity must be loaded first. Aborting.");
	        return;
	    } else {
	        var Velocity = global.Velocity,
	            $ = Velocity.Utilities;
	    }
	
	    var velocityVersion = Velocity.version,
	        requiredVersion = { major: 1, minor: 1, patch: 0 };
	
	    function greaterSemver (primary, secondary) {
	        var versionInts = [];
	
	        if (!primary || !secondary) { return false; }
	
	        $.each([ primary, secondary ], function(i, versionObject) {
	            var versionIntsComponents = [];
	
	            $.each(versionObject, function(component, value) {
	                while (value.toString().length < 5) {
	                    value = "0" + value;
	                }
	                versionIntsComponents.push(value);
	            });
	
	            versionInts.push(versionIntsComponents.join(""))
	        });
	
	        return (parseFloat(versionInts[0]) > parseFloat(versionInts[1]));
	    }
	
	    if (greaterSemver(requiredVersion, velocityVersion)){
	        var abortError = "Velocity UI Pack: You need to update Velocity (jquery.velocity.js) to a newer version. Visit http://github.com/julianshapiro/velocity.";
	        alert(abortError);
	        throw new Error(abortError);
	    }
	
	    /************************
	       Effect Registration
	    ************************/
	
	    /* Note: RegisterUI is a legacy name. */
	    Velocity.RegisterEffect = Velocity.RegisterUI = function (effectName, properties) {
	        /* Animate the expansion/contraction of the elements' parent's height for In/Out effects. */
	        function animateParentHeight (elements, direction, totalDuration, stagger) {
	            var totalHeightDelta = 0,
	                parentNode;
	
	            /* Sum the total height (including padding and margin) of all targeted elements. */
	            $.each(elements.nodeType ? [ elements ] : elements, function(i, element) {
	                if (stagger) {
	                    /* Increase the totalDuration by the successive delay amounts produced by the stagger option. */
	                    totalDuration += i * stagger;
	                }
	
	                parentNode = element.parentNode;
	
	                $.each([ "height", "paddingTop", "paddingBottom", "marginTop", "marginBottom"], function(i, property) {
	                    totalHeightDelta += parseFloat(Velocity.CSS.getPropertyValue(element, property));
	                });
	            });
	
	            /* Animate the parent element's height adjustment (with a varying duration multiplier for aesthetic benefits). */
	            Velocity.animate(
	                parentNode,
	                { height: (direction === "In" ? "+" : "-") + "=" + totalHeightDelta },
	                { queue: false, easing: "ease-in-out", duration: totalDuration * (direction === "In" ? 0.6 : 1) }
	            );
	        }
	
	        /* Register a custom redirect for each effect. */
	        Velocity.Redirects[effectName] = function (element, redirectOptions, elementsIndex, elementsSize, elements, promiseData) {
	            var finalElement = (elementsIndex === elementsSize - 1);
	
	            if (typeof properties.defaultDuration === "function") {
	                properties.defaultDuration = properties.defaultDuration.call(elements, elements);
	            } else {
	                properties.defaultDuration = parseFloat(properties.defaultDuration);
	            }
	
	            /* Iterate through each effect's call array. */
	            for (var callIndex = 0; callIndex < properties.calls.length; callIndex++) {
	                var call = properties.calls[callIndex],
	                    propertyMap = call[0],
	                    redirectDuration = (redirectOptions.duration || properties.defaultDuration || 1000),
	                    durationPercentage = call[1],
	                    callOptions = call[2] || {},
	                    opts = {};
	
	                /* Assign the whitelisted per-call options. */
	                opts.duration = redirectDuration * (durationPercentage || 1);
	                opts.queue = redirectOptions.queue || "";
	                opts.easing = callOptions.easing || "ease";
	                opts.delay = parseFloat(callOptions.delay) || 0;
	                opts._cacheValues = callOptions._cacheValues || true;
	
	                /* Special processing for the first effect call. */
	                if (callIndex === 0) {
	                    /* If a delay was passed into the redirect, combine it with the first call's delay. */
	                    opts.delay += (parseFloat(redirectOptions.delay) || 0);
	
	                    if (elementsIndex === 0) {
	                        opts.begin = function() {
	                            /* Only trigger a begin callback on the first effect call with the first element in the set. */
	                            redirectOptions.begin && redirectOptions.begin.call(elements, elements);
	
	                            var direction = effectName.match(/(In|Out)$/);
	
	                            /* Make "in" transitioning elements invisible immediately so that there's no FOUC between now
	                               and the first RAF tick. */
	                            if ((direction && direction[0] === "In") && propertyMap.opacity !== undefined) {
	                                $.each(elements.nodeType ? [ elements ] : elements, function(i, element) {
	                                    Velocity.CSS.setPropertyValue(element, "opacity", 0);
	                                });
	                            }
	
	                            /* Only trigger animateParentHeight() if we're using an In/Out transition. */
	                            if (redirectOptions.animateParentHeight && direction) {
	                                animateParentHeight(elements, direction[0], redirectDuration + opts.delay, redirectOptions.stagger);
	                            }
	                        }
	                    }
	
	                    /* If the user isn't overriding the display option, default to "auto" for "In"-suffixed transitions. */
	                    if (redirectOptions.display !== null) {
	                        if (redirectOptions.display !== undefined && redirectOptions.display !== "none") {
	                            opts.display = redirectOptions.display;
	                        } else if (/In$/.test(effectName)) {
	                            /* Inline elements cannot be subjected to transforms, so we switch them to inline-block. */
	                            var defaultDisplay = Velocity.CSS.Values.getDisplayType(element);
	                            opts.display = (defaultDisplay === "inline") ? "inline-block" : defaultDisplay;
	                        }
	                    }
	
	                    if (redirectOptions.visibility && redirectOptions.visibility !== "hidden") {
	                        opts.visibility = redirectOptions.visibility;
	                    }
	                }
	
	                /* Special processing for the last effect call. */
	                if (callIndex === properties.calls.length - 1) {
	                    /* Append promise resolving onto the user's redirect callback. */
	                    function injectFinalCallbacks () {
	                        if ((redirectOptions.display === undefined || redirectOptions.display === "none") && /Out$/.test(effectName)) {
	                            $.each(elements.nodeType ? [ elements ] : elements, function(i, element) {
	                                Velocity.CSS.setPropertyValue(element, "display", "none");
	                            });
	                        }
	
	                        redirectOptions.complete && redirectOptions.complete.call(elements, elements);
	
	                        if (promiseData) {
	                            promiseData.resolver(elements || element);
	                        }
	                    }
	
	                    opts.complete = function() {
	                        if (properties.reset) {
	                            for (var resetProperty in properties.reset) {
	                                var resetValue = properties.reset[resetProperty];
	
	                                /* Format each non-array value in the reset property map to [ value, value ] so that changes apply
	                                   immediately and DOM querying is avoided (via forcefeeding). */
	                                /* Note: Don't forcefeed hooks, otherwise their hook roots will be defaulted to their null values. */
	                                if (Velocity.CSS.Hooks.registered[resetProperty] === undefined && (typeof resetValue === "string" || typeof resetValue === "number")) {
	                                    properties.reset[resetProperty] = [ properties.reset[resetProperty], properties.reset[resetProperty] ];
	                                }
	                            }
	
	                            /* So that the reset values are applied instantly upon the next rAF tick, use a zero duration and parallel queueing. */
	                            var resetOptions = { duration: 0, queue: false };
	
	                            /* Since the reset option uses up the complete callback, we trigger the user's complete callback at the end of ours. */
	                            if (finalElement) {
	                                resetOptions.complete = injectFinalCallbacks;
	                            }
	
	                            Velocity.animate(element, properties.reset, resetOptions);
	                        /* Only trigger the user's complete callback on the last effect call with the last element in the set. */
	                        } else if (finalElement) {
	                            injectFinalCallbacks();
	                        }
	                    };
	
	                    if (redirectOptions.visibility === "hidden") {
	                        opts.visibility = redirectOptions.visibility;
	                    }
	                }
	
	                Velocity.animate(element, propertyMap, opts);
	            }
	        };
	
	        /* Return the Velocity object so that RegisterUI calls can be chained. */
	        return Velocity;
	    };
	
	    /*********************
	       Packaged Effects
	    *********************/
	
	    /* Externalize the packagedEffects data so that they can optionally be modified and re-registered. */
	    /* Support: <=IE8: Callouts will have no effect, and transitions will simply fade in/out. IE9/Android 2.3: Most effects are fully supported, the rest fade in/out. All other browsers: full support. */
	    Velocity.RegisterEffect.packagedEffects =
	        {
	            /* Animate.css */
	            "callout.bounce": {
	                defaultDuration: 550,
	                calls: [
	                    [ { translateY: -30 }, 0.25 ],
	                    [ { translateY: 0 }, 0.125 ],
	                    [ { translateY: -15 }, 0.125 ],
	                    [ { translateY: 0 }, 0.25 ]
	                ]
	            },
	            /* Animate.css */
	            "callout.shake": {
	                defaultDuration: 800,
	                calls: [
	                    [ { translateX: -11 }, 0.125 ],
	                    [ { translateX: 11 }, 0.125 ],
	                    [ { translateX: -11 }, 0.125 ],
	                    [ { translateX: 11 }, 0.125 ],
	                    [ { translateX: -11 }, 0.125 ],
	                    [ { translateX: 11 }, 0.125 ],
	                    [ { translateX: -11 }, 0.125 ],
	                    [ { translateX: 0 }, 0.125 ]
	                ]
	            },
	            /* Animate.css */
	            "callout.flash": {
	                defaultDuration: 1100,
	                calls: [
	                    [ { opacity: [ 0, "easeInOutQuad", 1 ] }, 0.25 ],
	                    [ { opacity: [ 1, "easeInOutQuad" ] }, 0.25 ],
	                    [ { opacity: [ 0, "easeInOutQuad" ] }, 0.25 ],
	                    [ { opacity: [ 1, "easeInOutQuad" ] }, 0.25 ]
	                ]
	            },
	            /* Animate.css */
	            "callout.pulse": {
	                defaultDuration: 825,
	                calls: [
	                    [ { scaleX: 1.1, scaleY: 1.1 }, 0.50, { easing: "easeInExpo" } ],
	                    [ { scaleX: 1, scaleY: 1 }, 0.50 ]
	                ]
	            },
	            /* Animate.css */
	            "callout.swing": {
	                defaultDuration: 950,
	                calls: [
	                    [ { rotateZ: 15 }, 0.20 ],
	                    [ { rotateZ: -10 }, 0.20 ],
	                    [ { rotateZ: 5 }, 0.20 ],
	                    [ { rotateZ: -5 }, 0.20 ],
	                    [ { rotateZ: 0 }, 0.20 ]
	                ]
	            },
	            /* Animate.css */
	            "callout.tada": {
	                defaultDuration: 1000,
	                calls: [
	                    [ { scaleX: 0.9, scaleY: 0.9, rotateZ: -3 }, 0.10 ],
	                    [ { scaleX: 1.1, scaleY: 1.1, rotateZ: 3 }, 0.10 ],
	                    [ { scaleX: 1.1, scaleY: 1.1, rotateZ: -3 }, 0.10 ],
	                    [ "reverse", 0.125 ],
	                    [ "reverse", 0.125 ],
	                    [ "reverse", 0.125 ],
	                    [ "reverse", 0.125 ],
	                    [ "reverse", 0.125 ],
	                    [ { scaleX: 1, scaleY: 1, rotateZ: 0 }, 0.20 ]
	                ]
	            },
	            "transition.fadeIn": {
	                defaultDuration: 500,
	                calls: [
	                    [ { opacity: [ 1, 0 ] } ]
	                ]
	            },
	            "transition.fadeOut": {
	                defaultDuration: 500,
	                calls: [
	                    [ { opacity: [ 0, 1 ] } ]
	                ]
	            },
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipXIn": {
	                defaultDuration: 700,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformPerspective: [ 800, 800 ], rotateY: [ 0, -55 ] } ]
	                ],
	                reset: { transformPerspective: 0 }
	            },
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipXOut": {
	                defaultDuration: 700,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformPerspective: [ 800, 800 ], rotateY: 55 } ]
	                ],
	                reset: { transformPerspective: 0, rotateY: 0 }
	            },
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipYIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformPerspective: [ 800, 800 ], rotateX: [ 0, -45 ] } ]
	                ],
	                reset: { transformPerspective: 0 }
	            },
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipYOut": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformPerspective: [ 800, 800 ], rotateX: 25 } ]
	                ],
	                reset: { transformPerspective: 0, rotateX: 0 }
	            },
	            /* Animate.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipBounceXIn": {
	                defaultDuration: 900,
	                calls: [
	                    [ { opacity: [ 0.725, 0 ], transformPerspective: [ 400, 400 ], rotateY: [ -10, 90 ] }, 0.50 ],
	                    [ { opacity: 0.80, rotateY: 10 }, 0.25 ],
	                    [ { opacity: 1, rotateY: 0 }, 0.25 ]
	                ],
	                reset: { transformPerspective: 0 }
	            },
	            /* Animate.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipBounceXOut": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 0.9, 1 ], transformPerspective: [ 400, 400 ], rotateY: -10 }, 0.50 ],
	                    [ { opacity: 0, rotateY: 90 }, 0.50 ]
	                ],
	                reset: { transformPerspective: 0, rotateY: 0 }
	            },
	            /* Animate.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipBounceYIn": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 0.725, 0 ], transformPerspective: [ 400, 400 ], rotateX: [ -10, 90 ] }, 0.50 ],
	                    [ { opacity: 0.80, rotateX: 10 }, 0.25 ],
	                    [ { opacity: 1, rotateX: 0 }, 0.25 ]
	                ],
	                reset: { transformPerspective: 0 }
	            },
	            /* Animate.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.flipBounceYOut": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 0.9, 1 ], transformPerspective: [ 400, 400 ], rotateX: -15 }, 0.50 ],
	                    [ { opacity: 0, rotateX: 90 }, 0.50 ]
	                ],
	                reset: { transformPerspective: 0, rotateX: 0 }
	            },
	            /* Magic.css */
	            "transition.swoopIn": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformOriginX: [ "100%", "50%" ], transformOriginY: [ "100%", "100%" ], scaleX: [ 1, 0 ], scaleY: [ 1, 0 ], translateX: [ 0, -700 ], translateZ: 0 } ]
	                ],
	                reset: { transformOriginX: "50%", transformOriginY: "50%" }
	            },
	            /* Magic.css */
	            "transition.swoopOut": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformOriginX: [ "50%", "100%" ], transformOriginY: [ "100%", "100%" ], scaleX: 0, scaleY: 0, translateX: -700, translateZ: 0 } ]
	                ],
	                reset: { transformOriginX: "50%", transformOriginY: "50%", scaleX: 1, scaleY: 1, translateX: 0 }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3. (Fades and scales only.) */
	            "transition.whirlIn": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformOriginX: [ "50%", "50%" ], transformOriginY: [ "50%", "50%" ], scaleX: [ 1, 0 ], scaleY: [ 1, 0 ], rotateY: [ 0, 160 ] }, 1, { easing: "easeInOutSine" } ]
	                ]
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3. (Fades and scales only.) */
	            "transition.whirlOut": {
	                defaultDuration: 750,
	                calls: [
	                    [ { opacity: [ 0, "easeInOutQuint", 1 ], transformOriginX: [ "50%", "50%" ], transformOriginY: [ "50%", "50%" ], scaleX: 0, scaleY: 0, rotateY: 160 }, 1, { easing: "swing" } ]
	                ],
	                reset: { scaleX: 1, scaleY: 1, rotateY: 0 }
	            },
	            "transition.shrinkIn": {
	                defaultDuration: 750,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformOriginX: [ "50%", "50%" ], transformOriginY: [ "50%", "50%" ], scaleX: [ 1, 1.5 ], scaleY: [ 1, 1.5 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.shrinkOut": {
	                defaultDuration: 600,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformOriginX: [ "50%", "50%" ], transformOriginY: [ "50%", "50%" ], scaleX: 1.3, scaleY: 1.3, translateZ: 0 } ]
	                ],
	                reset: { scaleX: 1, scaleY: 1 }
	            },
	            "transition.expandIn": {
	                defaultDuration: 700,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformOriginX: [ "50%", "50%" ], transformOriginY: [ "50%", "50%" ], scaleX: [ 1, 0.625 ], scaleY: [ 1, 0.625 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.expandOut": {
	                defaultDuration: 700,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformOriginX: [ "50%", "50%" ], transformOriginY: [ "50%", "50%" ], scaleX: 0.5, scaleY: 0.5, translateZ: 0 } ]
	                ],
	                reset: { scaleX: 1, scaleY: 1 }
	            },
	            /* Animate.css */
	            "transition.bounceIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], scaleX: [ 1.05, 0.3 ], scaleY: [ 1.05, 0.3 ] }, 0.40 ],
	                    [ { scaleX: 0.9, scaleY: 0.9, translateZ: 0 }, 0.20 ],
	                    [ { scaleX: 1, scaleY: 1 }, 0.50 ]
	                ]
	            },
	            /* Animate.css */
	            "transition.bounceOut": {
	                defaultDuration: 800,
	                calls: [
	                    [ { scaleX: 0.95, scaleY: 0.95 }, 0.35 ],
	                    [ { scaleX: 1.1, scaleY: 1.1, translateZ: 0 }, 0.35 ],
	                    [ { opacity: [ 0, 1 ], scaleX: 0.3, scaleY: 0.3 }, 0.30 ]
	                ],
	                reset: { scaleX: 1, scaleY: 1 }
	            },
	            /* Animate.css */
	            "transition.bounceUpIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateY: [ -30, 1000 ] }, 0.60, { easing: "easeOutCirc" } ],
	                    [ { translateY: 10 }, 0.20 ],
	                    [ { translateY: 0 }, 0.20 ]
	                ]
	            },
	            /* Animate.css */
	            "transition.bounceUpOut": {
	                defaultDuration: 1000,
	                calls: [
	                    [ { translateY: 20 }, 0.20 ],
	                    [ { opacity: [ 0, "easeInCirc", 1 ], translateY: -1000 }, 0.80 ]
	                ],
	                reset: { translateY: 0 }
	            },
	            /* Animate.css */
	            "transition.bounceDownIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateY: [ 30, -1000 ] }, 0.60, { easing: "easeOutCirc" } ],
	                    [ { translateY: -10 }, 0.20 ],
	                    [ { translateY: 0 }, 0.20 ]
	                ]
	            },
	            /* Animate.css */
	            "transition.bounceDownOut": {
	                defaultDuration: 1000,
	                calls: [
	                    [ { translateY: -20 }, 0.20 ],
	                    [ { opacity: [ 0, "easeInCirc", 1 ], translateY: 1000 }, 0.80 ]
	                ],
	                reset: { translateY: 0 }
	            },
	            /* Animate.css */
	            "transition.bounceLeftIn": {
	                defaultDuration: 750,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateX: [ 30, -1250 ] }, 0.60, { easing: "easeOutCirc" } ],
	                    [ { translateX: -10 }, 0.20 ],
	                    [ { translateX: 0 }, 0.20 ]
	                ]
	            },
	            /* Animate.css */
	            "transition.bounceLeftOut": {
	                defaultDuration: 750,
	                calls: [
	                    [ { translateX: 30 }, 0.20 ],
	                    [ { opacity: [ 0, "easeInCirc", 1 ], translateX: -1250 }, 0.80 ]
	                ],
	                reset: { translateX: 0 }
	            },
	            /* Animate.css */
	            "transition.bounceRightIn": {
	                defaultDuration: 750,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateX: [ -30, 1250 ] }, 0.60, { easing: "easeOutCirc" } ],
	                    [ { translateX: 10 }, 0.20 ],
	                    [ { translateX: 0 }, 0.20 ]
	                ]
	            },
	            /* Animate.css */
	            "transition.bounceRightOut": {
	                defaultDuration: 750,
	                calls: [
	                    [ { translateX: -30 }, 0.20 ],
	                    [ { opacity: [ 0, "easeInCirc", 1 ], translateX: 1250 }, 0.80 ]
	                ],
	                reset: { translateX: 0 }
	            },
	            "transition.slideUpIn": {
	                defaultDuration: 900,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateY: [ 0, 20 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideUpOut": {
	                defaultDuration: 900,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateY: -20, translateZ: 0 } ]
	                ],
	                reset: { translateY: 0 }
	            },
	            "transition.slideDownIn": {
	                defaultDuration: 900,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateY: [ 0, -20 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideDownOut": {
	                defaultDuration: 900,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateY: 20, translateZ: 0 } ]
	                ],
	                reset: { translateY: 0 }
	            },
	            "transition.slideLeftIn": {
	                defaultDuration: 1000,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateX: [ 0, -20 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideLeftOut": {
	                defaultDuration: 1050,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateX: -20, translateZ: 0 } ]
	                ],
	                reset: { translateX: 0 }
	            },
	            "transition.slideRightIn": {
	                defaultDuration: 1000,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateX: [ 0, 20 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideRightOut": {
	                defaultDuration: 1050,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateX: 20, translateZ: 0 } ]
	                ],
	                reset: { translateX: 0 }
	            },
	            "transition.slideUpBigIn": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateY: [ 0, 75 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideUpBigOut": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateY: -75, translateZ: 0 } ]
	                ],
	                reset: { translateY: 0 }
	            },
	            "transition.slideDownBigIn": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateY: [ 0, -75 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideDownBigOut": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateY: 75, translateZ: 0 } ]
	                ],
	                reset: { translateY: 0 }
	            },
	            "transition.slideLeftBigIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateX: [ 0, -75 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideLeftBigOut": {
	                defaultDuration: 750,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateX: -75, translateZ: 0 } ]
	                ],
	                reset: { translateX: 0 }
	            },
	            "transition.slideRightBigIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], translateX: [ 0, 75 ], translateZ: 0 } ]
	                ]
	            },
	            "transition.slideRightBigOut": {
	                defaultDuration: 750,
	                calls: [
	                    [ { opacity: [ 0, 1 ], translateX: 75, translateZ: 0 } ]
	                ],
	                reset: { translateX: 0 }
	            },
	            /* Magic.css */
	            "transition.perspectiveUpIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformPerspective: [ 800, 800 ], transformOriginX: [ 0, 0 ], transformOriginY: [ "100%", "100%" ], rotateX: [ 0, -180 ] } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%" }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.perspectiveUpOut": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformPerspective: [ 800, 800 ], transformOriginX: [ 0, 0 ], transformOriginY: [ "100%", "100%" ], rotateX: -180 } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateX: 0 }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.perspectiveDownIn": {
	                defaultDuration: 800,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformPerspective: [ 800, 800 ], transformOriginX: [ 0, 0 ], transformOriginY: [ 0, 0 ], rotateX: [ 0, 180 ] } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%" }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.perspectiveDownOut": {
	                defaultDuration: 850,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformPerspective: [ 800, 800 ], transformOriginX: [ 0, 0 ], transformOriginY: [ 0, 0 ], rotateX: 180 } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateX: 0 }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.perspectiveLeftIn": {
	                defaultDuration: 950,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformPerspective: [ 2000, 2000 ], transformOriginX: [ 0, 0 ], transformOriginY: [ 0, 0 ], rotateY: [ 0, -180 ] } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%" }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.perspectiveLeftOut": {
	                defaultDuration: 950,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformPerspective: [ 2000, 2000 ], transformOriginX: [ 0, 0 ], transformOriginY: [ 0, 0 ], rotateY: -180 } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateY: 0 }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.perspectiveRightIn": {
	                defaultDuration: 950,
	                calls: [
	                    [ { opacity: [ 1, 0 ], transformPerspective: [ 2000, 2000 ], transformOriginX: [ "100%", "100%" ], transformOriginY: [ 0, 0 ], rotateY: [ 0, 180 ] } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%" }
	            },
	            /* Magic.css */
	            /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
	            "transition.perspectiveRightOut": {
	                defaultDuration: 950,
	                calls: [
	                    [ { opacity: [ 0, 1 ], transformPerspective: [ 2000, 2000 ], transformOriginX: [ "100%", "100%" ], transformOriginY: [ 0, 0 ], rotateY: 180 } ]
	                ],
	                reset: { transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateY: 0 }
	            }
	        };
	
	    /* Register the packaged effects. */
	    for (var effectName in Velocity.RegisterEffect.packagedEffects) {
	        Velocity.RegisterEffect(effectName, Velocity.RegisterEffect.packagedEffects[effectName]);
	    }
	
	    /*********************
	       Sequence Running
	    **********************/
	
	    /* Note: Sequence calls must use Velocity's single-object arguments syntax. */
	    Velocity.RunSequence = function (originalSequence) {
	        var sequence = $.extend(true, [], originalSequence);
	
	        if (sequence.length > 1) {
	            $.each(sequence.reverse(), function(i, currentCall) {
	                var nextCall = sequence[i + 1];
	
	                if (nextCall) {
	                    /* Parallel sequence calls (indicated via sequenceQueue:false) are triggered
	                       in the previous call's begin callback. Otherwise, chained calls are normally triggered
	                       in the previous call's complete callback. */
	                    var currentCallOptions = currentCall.o || currentCall.options,
	                        nextCallOptions = nextCall.o || nextCall.options;
	
	                    var timing = (currentCallOptions && currentCallOptions.sequenceQueue === false) ? "begin" : "complete",
	                        callbackOriginal = nextCallOptions && nextCallOptions[timing],
	                        options = {};
	
	                    options[timing] = function() {
	                        var nextCallElements = nextCall.e || nextCall.elements;
	                        var elements = nextCallElements.nodeType ? [ nextCallElements ] : nextCallElements;
	
	                        callbackOriginal && callbackOriginal.call(elements, elements);
	                        Velocity(currentCall);
	                    }
	
	                    if (nextCall.o) {
	                        nextCall.o = $.extend({}, nextCallOptions, options);
	                    } else {
	                        nextCall.options = $.extend({}, nextCallOptions, options);
	                    }
	                }
	            });
	
	            sequence.reverse();
	        }
	
	        Velocity(sequence[0]);
	    };
	}((window.jQuery || window.Zepto || window), window, document);
	}));

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 1537 */,
/* 1538 */
/***/ (function(module, exports) {

	module.exports = Olm;

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	module.exports = require("electron");

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundles/bab0d1f71b846e270316/bundle.js